/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(399);
	module.exports = __webpack_require__(554);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(900);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(58);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(190);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(79);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(865);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(340);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(859);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(878);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(860);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(861);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(341);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(863);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(858);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(862);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(864);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(877);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(123);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(866);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(875);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(346);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(868);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(869);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(873);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(343);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v2.2.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-05-20T17:23Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//"use strict";
	var arr = [];
	
	var document = window.document;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "2.2.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			var realStringObj = obj && obj.toString();
			return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			// Not own constructor property must be Object
			if ( obj.constructor &&
					!hasOwn.call( obj, "constructor" ) &&
					!hasOwn.call( obj.constructor.prototype || {}, "isPrototypeOf" ) ) {
				return false;
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
	
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf( "use strict" ) === 1 ) {
					script = document.createElement( "script" );
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
	
					// Otherwise, avoid the DOM node creation, insertion
					// and removal by using an indirect global eval
	
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	// JSHint would error on this code due to the Symbol not being defined in ES5.
	// Defining this global in .jshintrc would create a danger of using the global
	// unguarded in another place, it seems safer to just disable JSHint for these
	// three lines.
	/* jshint ignore: start */
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	/* jshint ignore: end */
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.1
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-10-17
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, nidselect, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rescape, "\\$&" );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
						while ( i-- ) {
							groups[i] = nidselect + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( (parent = document.defaultView) && parent.top !== parent ) {
			// Support: IE 11
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( document.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( (oldCache = uniqueCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
	
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[ 0 ] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
					// Always skip document fragments
					if ( cur.nodeType < 11 && ( pos ?
						pos.index( cur ) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this === promise ? newDefer.promise() : this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add( function() {
	
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 ||
					( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.progress( updateFunc( i, progressContexts, progressValues ) )
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	} );
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
	
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	} );
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE9-10 only
			// Older IE sometimes signals "interactive" too soon
			if ( document.readyState === "complete" ||
				( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		register: function( owner, initial ) {
			var value = initial || {};
	
			// If it is a node unlikely to be stringify-ed or looped over
			// use plain assignment
			if ( owner.nodeType ) {
				owner[ this.expando ] = value;
	
			// Otherwise secure it in a non-enumerable, non-writable property
			// configurability must be true to allow the property to be
			// deleted with the delete operator
			} else {
				Object.defineProperty( owner, this.expando, {
					value: value,
					writable: true,
					configurable: true
				} );
			}
			return owner[ this.expando ];
		},
		cache: function( owner ) {
	
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( !acceptData( owner ) ) {
				return {};
			}
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
				owner[ this.expando ] && owner[ this.expando ][ key ];
		},
		access: function( owner, key, value ) {
			var stored;
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase( key ) );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key === undefined ) {
				this.register( owner );
	
			} else {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
	
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
	
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
	
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <= 35-45+
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://code.google.com/p/chromium/issues/detail?id=378607
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data, camelKey;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// with the key as-is
					data = dataUser.get( elem, key ) ||
	
						// Try to find dashed key if it exists (gh-2779)
						// This is for 2.2.x only
						dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );
	
					if ( data !== undefined ) {
						return data;
					}
	
					camelKey = jQuery.camelCase( key );
	
					// Attempt to get data from the cache
					// with the key camelized
					data = dataUser.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				camelKey = jQuery.camelCase( key );
				this.each( function() {
	
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = dataUser.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					dataUser.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
						dataUser.set( this, key, value );
					}
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" ||
				!jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() { return tween.cur(); } :
				function() { return jQuery.css( elem, prop, "" ); },
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([\w:-]+)/ );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE9-11+
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0-4.3, Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE9
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support (at least): Chrome, IE9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox<=42+
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
			"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split( " " ),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
				"screenX screenY toElement" ).split( " " ),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX +
						( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
						( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY +
						( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
						( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://code.google.com/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName( "tbody" )[ 0 ] ||
				elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android<4.1, PhantomJS<2
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
	
		// Keep domManip exposed until 3.0 (gh-2225)
		domManip: domManip,
	
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	
	var iframe,
		elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			display = jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
					.appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var documentElement = document.documentElement;
	
	
	
	( function() {
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
			div.style.cssText =
	
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
		}
	
		jQuery.extend( support, {
			pixelPosition: function() {
	
				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
	
				// Support: Android 4.0-4.3
				// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
				// since that compresses better and they're computed together anyway.
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
	
				// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return reliableMarginLeftVal;
			},
			reliableMarginRight: function() {
	
				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;box-sizing:content-box;" +
					"display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				documentElement.appendChild( container );
	
				ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );
	
				documentElement.removeChild( container );
				div.removeChild( marginDiv );
	
				return ret;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
		// Support: Opera 12.1x only
		// Fall back to style even without computed
		// computed is undefined for elems on document fragments
		if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// http://dev.w3.org/csswg/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE9-11+
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = dataPriv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
	
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = dataPriv.access(
						elem,
						"olddisplay",
						defaultDisplay( elem.nodeName )
					);
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					dataPriv.set(
						elem,
						"olddisplay",
						hidden ? display : jQuery.css( elem, "display" )
					);
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
						elem.offsetWidth === 0 ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show
					// and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done( function() {
					jQuery( elem ).hide();
				} );
			}
			anim.done( function() {
				var prop;
	
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
			opt.duration : opt.duration in jQuery.fx.speeds ?
				jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		window.clearInterval( timerId );
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
	
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// Handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ?
									!option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome, Safari
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// The jqXHR state
				state = 0,
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE8-11+
				// IE throws exception if url is malformed, e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE8-11+
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( state === 2 ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
	
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapAll( html.call( this, i ) );
				} );
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function() {
			return this.parent().each( function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			} ).end();
		}
	} );
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		return !jQuery.expr.filters.visible( elem );
	};
	jQuery.expr.filters.visible = function( elem ) {
	
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		// Use OR instead of AND as the element is not visible if either is true
		// See tickets #10406 and #13132
		return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE9
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE9
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			box = elem.getBoundingClientRect();
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari<7-8+, Chrome<37-44+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
		size: function() {
			return this.length;
		}
	} );
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	return jQuery;
	}));


/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};
	
	exports.__esModule = true;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$assign = __webpack_require__(92)["default"];
	
	exports["default"] = _Object$assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2018 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString === Object.prototype.toString) {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					} else {
						classes.push(arg.toString());
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	var _interopRequireWildcard = __webpack_require__(181)['default'];
	
	exports.__esModule = true;
	
	var _Accordion2 = __webpack_require__(719);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	exports.Accordion = _Accordion3['default'];
	
	var _Alert2 = __webpack_require__(720);
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	exports.Alert = _Alert3['default'];
	
	var _Badge2 = __webpack_require__(721);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	exports.Badge = _Badge3['default'];
	
	var _Breadcrumb2 = __webpack_require__(722);
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	exports.Breadcrumb = _Breadcrumb3['default'];
	
	var _BreadcrumbItem2 = __webpack_require__(294);
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	exports.BreadcrumbItem = _BreadcrumbItem3['default'];
	
	var _Button2 = __webpack_require__(65);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	exports.Button = _Button3['default'];
	
	var _ButtonGroup2 = __webpack_require__(295);
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	exports.ButtonGroup = _ButtonGroup3['default'];
	
	var _ButtonInput2 = __webpack_require__(723);
	
	var _ButtonInput3 = _interopRequireDefault(_ButtonInput2);
	
	exports.ButtonInput = _ButtonInput3['default'];
	
	var _ButtonToolbar2 = __webpack_require__(724);
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	exports.ButtonToolbar = _ButtonToolbar3['default'];
	
	var _Carousel2 = __webpack_require__(725);
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	exports.Carousel = _Carousel3['default'];
	
	var _CarouselItem2 = __webpack_require__(296);
	
	var _CarouselItem3 = _interopRequireDefault(_CarouselItem2);
	
	exports.CarouselItem = _CarouselItem3['default'];
	
	var _Checkbox2 = __webpack_require__(727);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	exports.Checkbox = _Checkbox3['default'];
	
	var _Clearfix2 = __webpack_require__(728);
	
	var _Clearfix3 = _interopRequireDefault(_Clearfix2);
	
	exports.Clearfix = _Clearfix3['default'];
	
	var _ControlLabel2 = __webpack_require__(729);
	
	var _ControlLabel3 = _interopRequireDefault(_ControlLabel2);
	
	exports.ControlLabel = _ControlLabel3['default'];
	
	var _Col2 = __webpack_require__(297);
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	exports.Col = _Col3['default'];
	
	var _Collapse2 = __webpack_require__(175);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	exports.Collapse = _Collapse3['default'];
	
	var _Dropdown2 = __webpack_require__(116);
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	exports.Dropdown = _Dropdown3['default'];
	
	var _DropdownButton2 = __webpack_require__(730);
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	exports.DropdownButton = _DropdownButton3['default'];
	
	var _Fade2 = __webpack_require__(117);
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	exports.Fade = _Fade3['default'];
	
	var _Form2 = __webpack_require__(732);
	
	var _Form3 = _interopRequireDefault(_Form2);
	
	exports.Form = _Form3['default'];
	
	var _FormControl2 = __webpack_require__(733);
	
	var _FormControl3 = _interopRequireDefault(_FormControl2);
	
	exports.FormControl = _FormControl3['default'];
	
	var _FormGroup2 = __webpack_require__(176);
	
	var _FormGroup3 = _interopRequireDefault(_FormGroup2);
	
	exports.FormGroup = _FormGroup3['default'];
	
	var _Glyphicon2 = __webpack_require__(118);
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	exports.Glyphicon = _Glyphicon3['default'];
	
	var _Grid2 = __webpack_require__(300);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	exports.Grid = _Grid3['default'];
	
	var _HelpBlock2 = __webpack_require__(737);
	
	var _HelpBlock3 = _interopRequireDefault(_HelpBlock2);
	
	exports.HelpBlock = _HelpBlock3['default'];
	
	var _Image2 = __webpack_require__(738);
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	exports.Image = _Image3['default'];
	
	var _Input2 = __webpack_require__(739);
	
	var _Input3 = _interopRequireDefault(_Input2);
	
	exports.Input = _Input3['default'];
	
	var _InputGroup2 = __webpack_require__(740);
	
	var _InputGroup3 = _interopRequireDefault(_InputGroup2);
	
	exports.InputGroup = _InputGroup3['default'];
	
	var _Interpolate2 = __webpack_require__(301);
	
	var _Interpolate3 = _interopRequireDefault(_Interpolate2);
	
	exports.Interpolate = _Interpolate3['default'];
	
	var _Jumbotron2 = __webpack_require__(743);
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	exports.Jumbotron = _Jumbotron3['default'];
	
	var _Label2 = __webpack_require__(744);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	exports.Label = _Label3['default'];
	
	var _ListGroup2 = __webpack_require__(745);
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	exports.ListGroup = _ListGroup3['default'];
	
	var _ListGroupItem2 = __webpack_require__(302);
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	exports.ListGroupItem = _ListGroupItem3['default'];
	
	var _Media2 = __webpack_require__(746);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	exports.Media = _Media3['default'];
	
	var _MenuItem2 = __webpack_require__(753);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	exports.MenuItem = _MenuItem3['default'];
	
	var _Modal2 = __webpack_require__(754);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	exports.Modal = _Modal3['default'];
	
	var _ModalBody2 = __webpack_require__(303);
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	exports.ModalBody = _ModalBody3['default'];
	
	var _ModalFooter2 = __webpack_require__(304);
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	exports.ModalFooter = _ModalFooter3['default'];
	
	var _ModalHeader2 = __webpack_require__(305);
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	exports.ModalHeader = _ModalHeader3['default'];
	
	var _ModalTitle2 = __webpack_require__(306);
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	exports.ModalTitle = _ModalTitle3['default'];
	
	var _Nav2 = __webpack_require__(307);
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	exports.Nav = _Nav3['default'];
	
	var _Navbar2 = __webpack_require__(757);
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	exports.Navbar = _Navbar3['default'];
	
	var _NavbarBrand2 = __webpack_require__(309);
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	exports.NavbarBrand = _NavbarBrand3['default'];
	
	var _NavDropdown2 = __webpack_require__(756);
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	exports.NavDropdown = _NavDropdown3['default'];
	
	var _NavItem2 = __webpack_require__(308);
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	exports.NavItem = _NavItem3['default'];
	
	var _Overlay2 = __webpack_require__(310);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	exports.Overlay = _Overlay3['default'];
	
	var _OverlayTrigger2 = __webpack_require__(761);
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	exports.OverlayTrigger = _OverlayTrigger3['default'];
	
	var _PageHeader2 = __webpack_require__(762);
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	exports.PageHeader = _PageHeader3['default'];
	
	var _PageItem2 = __webpack_require__(763);
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	exports.PageItem = _PageItem3['default'];
	
	var _Pager2 = __webpack_require__(764);
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	exports.Pager = _Pager3['default'];
	
	var _Pagination2 = __webpack_require__(765);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	exports.Pagination = _Pagination3['default'];
	
	var _Panel2 = __webpack_require__(767);
	
	var _Panel3 = _interopRequireDefault(_Panel2);
	
	exports.Panel = _Panel3['default'];
	
	var _PanelGroup2 = __webpack_require__(311);
	
	var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);
	
	exports.PanelGroup = _PanelGroup3['default'];
	
	var _Popover2 = __webpack_require__(768);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	exports.Popover = _Popover3['default'];
	
	var _ProgressBar2 = __webpack_require__(769);
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	exports.ProgressBar = _ProgressBar3['default'];
	
	var _Radio2 = __webpack_require__(770);
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	exports.Radio = _Radio3['default'];
	
	var _ResponsiveEmbed2 = __webpack_require__(771);
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	exports.ResponsiveEmbed = _ResponsiveEmbed3['default'];
	
	var _Row2 = __webpack_require__(772);
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	exports.Row = _Row3['default'];
	
	var _SafeAnchor2 = __webpack_require__(47);
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	exports.SafeAnchor = _SafeAnchor3['default'];
	
	var _SplitButton2 = __webpack_require__(773);
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	exports.SplitButton = _SplitButton3['default'];
	
	var _Tab2 = __webpack_require__(775);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	exports.Tab = _Tab3['default'];
	
	var _TabContainer2 = __webpack_require__(178);
	
	var _TabContainer3 = _interopRequireDefault(_TabContainer2);
	
	exports.TabContainer = _TabContainer3['default'];
	
	var _TabContent2 = __webpack_require__(179);
	
	var _TabContent3 = _interopRequireDefault(_TabContent2);
	
	exports.TabContent = _TabContent3['default'];
	
	var _Table2 = __webpack_require__(776);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	exports.Table = _Table3['default'];
	
	var _TabPane2 = __webpack_require__(312);
	
	var _TabPane3 = _interopRequireDefault(_TabPane2);
	
	exports.TabPane = _TabPane3['default'];
	
	var _Tabs2 = __webpack_require__(777);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	exports.Tabs = _Tabs3['default'];
	
	var _Thumbnail2 = __webpack_require__(778);
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	exports.Thumbnail = _Thumbnail3['default'];
	
	var _Tooltip2 = __webpack_require__(779);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	exports.Tooltip = _Tooltip3['default'];
	
	var _Well2 = __webpack_require__(780);
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	exports.Well = _Well3['default'];
	
	var _FormControls2 = __webpack_require__(299);
	
	var _FormControls = _interopRequireWildcard(_FormControls2);
	
	exports.FormControls = _FormControls;
	
	var _utils2 = __webpack_require__(784);
	
	var _utils = _interopRequireWildcard(_utils2);
	
	exports.utils = _utils;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var WebFooter = function (_Component) {
		_inherits(WebFooter, _Component);
	
		function WebFooter(props) {
			_classCallCheck(this, WebFooter);
	
			var _this = _possibleConstructorReturn(this, (WebFooter.__proto__ || Object.getPrototypeOf(WebFooter)).call(this, props));
	
			_this.state = {
				email: '',
				phone: '',
				timings: ''
			};
			_this.getCustomerCareDetails = _this.getCustomerCareDetails.bind(_this);
			return _this;
		}
	
		_createClass(WebFooter, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.getCustomerCareDetails();
			}
		}, {
			key: 'getCustomerCareDetails',
			value: function getCustomerCareDetails() {
				var data1 = { from: 'desktop_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getCustomerSupportDetails',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							email: data.email,
							timings: data.timings,
							phone: data.phone
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'footer',
					{ className: 'ad_foter' },
					_react2.default.createElement(
						'div',
						{ style: { position: 'relative', width: '100%' } },
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-3 col-sm-3' },
								' ',
								_react2.default.createElement('img', { src: baseAssets + 'images_web/customer_care_bg.png', alt: ' ', className: 'cstmr_care_bg' }),
								' '
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-2 col-sm-2 fotr_cstmr_care', style: { listStyle: 'none' } },
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										{ style: { overflow: 'hidden', paddingBottom: '8px', marginBottom: '5px' } },
										' ',
										_react2.default.createElement(
											'h4',
											{ className: 'web_blk_titles' },
											' Useful Links '
										),
										' '
									),
									_react2.default.createElement(
										'li',
										null,
										' ',
										_react2.default.createElement(
											'a',
											{ href: 'http://miledeepworks.in', target: '_blank', title: '' },
											' About Us '
										),
										' '
									),
									_react2.default.createElement(
										'li',
										null,
										' ',
										_react2.default.createElement(
											'a',
											{ href: 'http://blog.aqua.deals', target: '_blank', title: '' },
											' Our Blog '
										),
										' '
									),
									_react2.default.createElement(
										'li',
										null,
										' ',
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "web/customer_care", title: '' },
											' Contact Us '
										),
										' '
									),
									_react2.default.createElement(
										'li',
										null,
										' ',
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "web/advertise-with-us", title: '' },
											' Advertise with Us '
										),
										' '
									),
									_react2.default.createElement(
										'li',
										null,
										' ',
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "web/enquire_now/partner/support/sid/did", title: '' },
											' Sell on AquaDeals '
										),
										' '
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-3 col-sm-3 off_add fotr_cstmr_care' },
								_react2.default.createElement(
									'ul',
									{ style: { listStyle: 'none', fontSize: '16px' } },
									_react2.default.createElement(
										'li',
										{ style: { overflow: 'hidden', listStyle: "none", paddingBottom: '8px', marginBottom: '5px' } },
										' ',
										_react2.default.createElement(
											'h4',
											{ className: 'web_blk_titles' },
											'Registered Office Address : '
										),
										' '
									),
									_react2.default.createElement(
										'li',
										null,
										' ',
										_react2.default.createElement(
											'span',
											null,
											'  A unit of Mile deep works Pvt. Ltd. '
										),
										' '
									),
									_react2.default.createElement(
										'li',
										null,
										' ',
										_react2.default.createElement(
											'span',
											null,
											' Plot No.4, SKS Township, Ganganapalli, Kakinada, East Godavari, Andhra Pradesh, 533006 '
										),
										' '
									),
									_react2.default.createElement(
										'li',
										null,
										' ',
										_react2.default.createElement(
											'span',
											null,
											' 8008765779 '
										),
										' '
									),
									_react2.default.createElement(
										'li',
										null,
										' ',
										_react2.default.createElement(
											'span',
											null,
											' contactus@miledeepworks.com '
										),
										' '
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-4 col-sm-4 android_play' },
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										{ style: { overflow: 'hidden', listStyle: "none", width: '100%', paddingBottom: '8px', clear: 'both', marginBottom: '5px' } },
										' ',
										_react2.default.createElement(
											'h4',
											{ className: 'web_blk_titles' },
											'Download App'
										),
										' '
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'p',
											null,
											'Download the Android app',
											_react2.default.createElement('br', null),
											'to get a much Smoother ',
											_react2.default.createElement('br', null),
											' AquaDeals Experiance'
										),
										' ',
										_react2.default.createElement('br', null),
										_react2.default.createElement(
											'a',
											{ href: 'https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en', target: '_blank', className: 'and_play_btn' },
											_react2.default.createElement('img', { src: baseAssets + 'images_web/android_play.png', alt: '' })
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return WebFooter;
	}(_react.Component);
	
	exports.default = WebFooter;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './assets/css/style_web.css';
	
	
	// import Web_Banners from './WebBanners.js';
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var WebHeaderInner = function (_Component) {
		_inherits(WebHeaderInner, _Component);
	
		function WebHeaderInner(props) {
			_classCallCheck(this, WebHeaderInner);
	
			var _this = _possibleConstructorReturn(this, (WebHeaderInner.__proto__ || Object.getPrototypeOf(WebHeaderInner)).call(this, props));
	
			_this.state = {
				status: '',
				keyword: '',
				cart_count: 0,
				cart_count_new: _this.props.cart_updated_count,
				aquacash: '',
				bookings: '',
				noty_count: '',
				menuItems: [],
				pro_pic: baseAssets + 'images/pro_pics/profile_pic.png'
			};
			_this.getMenuItems = _this.getMenuItems.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			_this.getCartCount = _this.getCartCount.bind(_this);
			_this.getProfile = _this.getProfile.bind(_this);
			return _this;
		}
	
		_createClass(WebHeaderInner, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.getMenuItems();
				this.getCartCount();
				this.getProfile();
				if (this.props.cart_updated_count === 0 && this.state.cart_count > 0) {
					this.getCartCount();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(newProps) {
				if (newProps.image) {
					this.setState({
						pro_pic: newProps.image
					});
				}
				if (newProps.cart_updated_count === 0) {
					this.setState({
						cart_count: newProps.cart_updated_count
					});
				}
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				if (this.props.cart_updated_count === 0 && this.state.cart_count > 0) {
					this.getCartCount();
				}
			}
		}, {
			key: 'logout',
			value: function logout() {
				localStorage.clear();
				window.location.reload();
			}
		}, {
			key: 'getProfile',
			value: function getProfile() {
	
				if (!localStorage.user_id && !localStorage.token) {
					// this.setState({pro_pic:'profile_pic.png'});
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.user_id;
					} else {
						uid = 0;
					}
					var data1 = { from: 'desktop_web', uid: uid, token: localStorage.getItem('token'), device_id: localStorage.getItem('push_device_id') };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						url: baseUrl + 'myprofile',
						method: 'POST',
						data: { req: data2 },
						dataType: 'JSON',
						success: function (data) {
							if (data.msg === 'success') {
								this.setState({
									pro_pic: baseAssets + 'images/pro_pics/' + data.details[0].pro_pic
								});
							}
							if (data.status === 'error' && data.message === 'Token mismatch') {
								localStorage.removeItem('user_id');
								localStorage.removeItem('token');
								window.location.reload();
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'getCartCount',
			value: function getCartCount() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
						this.setState({
							cart_count: data.cart_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				this.setState({
					status: 'foucs',
					keyword: event.target.value
				});
			}
		}, {
			key: 'getMenuItems',
			value: function getMenuItems() {
				var data1 = { from: 'desktop_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'browse_categories',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								menuItems: data.categories
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'onChangeKey',
			value: function onChangeKey(event) {
				if (event.target.value.length > 2) {
					this.props.search_products(event.target.value);
				} else if (event.target.value.length === 0) {
					this.props.search_products('');
				}
				this.setState({
					keyword: event.target.value
				});
			}
		}, {
			key: 'onBlur',
			value: function onBlur() {
				this.setState({
					status: 'unfocus'
				});
			}
		}, {
			key: 'resetKey',
			value: function resetKey() {
				this.props.search_products('');
				this.setState({
					keyword: ''
				});
			}
		}, {
			key: 'render',
			value: function render() {
				// if(this.props.cart_updated_count===0)
				// {
				// 	this.getCartCount()
				// }
				(0, _jquery2.default)(document).on('mouseup', function (e) {
					var container = (0, _jquery2.default)('.ad_search');
					var container_sub = (0, _jquery2.default)('.res');
	
					if (!container.is(e.target) // if the target of the click isn't the container...
					&& container.has(e.target).length === 0) // ... nor a descendant of the container
						{
							container_sub.hide();
						} else {
						container_sub.show();
					}
				});
				var menuItems = this.state.menuItems.map(function (data, index) {
					return _react2.default.createElement(
						'li',
						{ id: index, onClick: function onClick() {
								location.reload();
							} },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: data.redirect_url },
							data.dtype
						)
					);
				});
				if (this.props.brands.length > 0) {
					var brands = _react2.default.createElement(
						'h5',
						{ className: 'brand_hdr' },
						'Brands'
					);
				}
				if (this.props.products.length > 0) {
					var products = _react2.default.createElement(
						'span',
						null,
						_react2.default.createElement('div', { className: 'clr' }),
						_react2.default.createElement(
							'h5',
							{ className: 'brand_hdr' },
							'Products'
						)
					);
				}
	
				if (this.props.categories) {
					if (this.props.categories.length > 0) {
						var categories = _react2.default.createElement(
							'h5',
							{ className: 'brand_hdr' },
							'Categories'
						);
					}
				}
				var that = this;
				var brands_list = this.props.brands.map(function (brand, index) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ to: "/web/pdeals/" + brand.url_dtype_name + "/" + brand.url_brand_name + "/" + brand.id + "/" + brand.type + "/" + brand.dtype, onClick: function onClick() {
								that.saveSearch(localStorage.user_id, brand.id, 3);
							} },
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 12, sm: 12, xs: 12, className: 'srh_list_item' },
							_react2.default.createElement(
								_reactBootstrap.Col,
								{ md: 2, sm: 2, xs: 2, className: '' },
								_react2.default.createElement('img', { src: brand.logo !== '' && brand.logo !== null ? baseAssets + 'images/brand_icons/' + brand.logo : baseAssets + 'icons/web_icons/noImage.png', role: 'presentation', alt: ' ', width: '30px' })
							),
							_react2.default.createElement(
								_reactBootstrap.Col,
								{ md: 10, sm: 10, xs: 10, className: '' },
								_react2.default.createElement(
									'div',
									{ className: 'srh_cnt_all' },
									brand.category_name
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Col,
								{ md: 1, sm: 1, xs: 1, className: 'srh_deal_cnt' },
								_react2.default.createElement(
									'i',
									null,
									brand.dealcount
								)
							)
						)
					);
				});
				if (this.props.categories) {
					if (this.props.categories.length > 0) {
						var categories_list = this.props.categories.map(function (category, index) {
							return _react2.default.createElement(
								'li',
								{ key: index, onClick: function onClick() {
										location.reload();
									} },
								_react2.default.createElement(
									_reactRouter.Link,
									{ style: { textDecoration: 'none' }, className: 'brand_tlt', to: "/web/pdeals/" + category.url_dtype_name + "/" + category.url_cat_name + "/" + category.id + "/" + category.type + "/" + category.dtype },
									_react2.default.createElement('img', { className: '', alt: '', src: 'https://aquadeals.in/admin/assets/images/icons/' + category.logo, width: '30px;' }),
									_react2.default.createElement(
										'span',
										null,
										category.category_name
									)
								)
							);
						});
					}
				}
				var that = this;
				var product_list = this.props.products.map(function (product, index) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ to: product.dealcount > 1 ? "/web/subdeals/" + product.url_dtype_name + "/" + product.url_brand_name + "/" + product.url_product_name + "/" + product.id + "/type/" + product.dtype : "/web/pdetails/" + product.url_dtype_name + "/" + product.url_cat_name + "/" + product.url_brand_name + "/" + product.url_product_name + "/" + product.id + "/" + product.deal_id, onClick: function onClick() {
								that.saveSearch(localStorage.user_id, product.id, 1);
							} },
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 12, sm: 12, xs: 12, className: 'srh_list_item' },
							_react2.default.createElement(
								_reactBootstrap.Col,
								{ md: 2, sm: 2, xs: 2, className: '' },
								_react2.default.createElement('img', { src: product.logo !== '' && product.logo !== null ? baseAssets + 'images/product_imgs/thumbnails/' + product.logo : baseAssets + 'icons/web_icons/noImage.png', alt: ' ', width: '30px' })
							),
							_react2.default.createElement(
								_reactBootstrap.Col,
								{ md: 10, sm: 10, xs: 10, className: '' },
								_react2.default.createElement(
									'div',
									{ className: 'srh_cnt_all' },
									product.category_name
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Col,
								{ md: 1, sm: 1, xs: 1, className: 'srh_deal_cnt' },
								_react2.default.createElement(
									'i',
									null,
									product.dealcount
								)
							)
						)
					);
				});
	
				var aut_status = '';
				if (localStorage.token) {
					aut_status = _react2.default.createElement(
						'a',
						{ className: 'cursor', onClick: this.logout.bind(this) },
						'LOGOUT'
					);
				} else {
					aut_status = _react2.default.createElement(
						_reactRouter.Link,
						{ to: '/web/login' },
						'LOGIN'
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'HomePage' },
					_react2.default.createElement(
						'header',
						null,
						_react2.default.createElement('div', { className: 'clr' }),
						_react2.default.createElement(
							'nav',
							{ className: 'navbar navbar-default' },
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'div',
									{ className: 'navbar-header' },
									_react2.default.createElement(
										'button',
										{ type: 'button', className: 'navbar-toggle collapsed', 'data-toggle': 'collapse', 'data-target': '#bs-example-navbar-collapse-1', 'aria-expanded': 'false' },
										_react2.default.createElement(
											'span',
											{ className: 'sr-only' },
											'Toggle navigation'
										),
										_react2.default.createElement('span', { className: 'icon-bar' }),
										_react2.default.createElement('span', { className: 'icon-bar' }),
										_react2.default.createElement('span', { className: 'icon-bar' })
									),
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: '/web/home', title: 'AquaDeals', className: 'navbar-brand ad_logo' },
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/logo.png', alt: 'AquaDeals' }),
										_react2.default.createElement(
											'span',
											null,
											'#HappyFarming'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'clr' },
										' \xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'collapse navbar-collapse', id: 'bs-example-navbar-collapse-1' },
									_react2.default.createElement(
										'form',
										{ className: 'navbar-form navbar-left ad_search' },
										_react2.default.createElement(
											'div',
											{ className: 'dropdown ad_cat_drop' },
											_react2.default.createElement(
												_reactBootstrap.DropdownButton,
												{ title: 'All', id: 'drp_btn' },
												menuItems,
												_react2.default.createElement(
													'li',
													{ id: '5' },
													_react2.default.createElement(
														'a',
														{ href: 'http://blog.aqua.deals', target: '_blank' },
														'Blog'
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'form-group' },
											_react2.default.createElement('input', { type: 'text', ref: 'keyword', onChange: this.onChangeKey.bind(this), onFocus: this.onFocus.bind(this), onBlur: this.onBlur.bind(this), value: this.state.keyword, className: 'form-control', placeholder: 'Search for Aquaculture products, brands and more' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'res ressrch_box', style: { maxHeight: 400 + 'px', position: 'absolute', left: 0, overflowX: 'hidden', margin: 0 + ' auto', textDecoration: 'none', top: 45 + 'px', display: 'none', zindex: 9999 } },
											_react2.default.createElement(
												'div',
												null,
												brands
											),
											_react2.default.createElement(
												'ul',
												{ style: { paddingLeft: 15 + 'px' } },
												brands_list
											),
											_react2.default.createElement(
												'div',
												null,
												products
											),
											_react2.default.createElement(
												'ul',
												{ style: { paddingLeft: 15 + 'px' } },
												product_list
											),
											_react2.default.createElement(
												'div',
												null,
												categories
											),
											_react2.default.createElement(
												'ul',
												{ style: { paddingLeft: 15 + 'px' } },
												categories_list
											)
										),
										_react2.default.createElement(
											'span',
											{ className: 'btn btn-default ad_srch_btn' },
											_react2.default.createElement('i', { className: 'glyphicon glyphicon-search' })
										)
									),
									_react2.default.createElement(
										'ul',
										{ className: 'nav navbar-nav navbar-right ad_nav_rgt' },
										_react2.default.createElement(
											'li',
											{ className: 'ad_cart' },
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: '/web/mycart', title: 'MY CART' },
												_react2.default.createElement('img', { src: baseAssets + 'images_web/cart_icon.png', alt: ' ' })
											),
											this.props.cart_updated_count >= 1 ? _react2.default.createElement(
												'i',
												null,
												this.props.cart_updated_count
											) : this.state.cart_count > 0 ? _react2.default.createElement(
												'i',
												{ id: 'cart_count' },
												this.state.cart_count
											) : ''
										),
										_react2.default.createElement(
											'li',
											{ className: 'dropdown log_blk web_nav_menu' },
											_react2.default.createElement(
												_reactBootstrap.DropdownButton,
												{ noCaret: true, id: 'drp_btn1', className: 'web_nav_menu', title: _react2.default.createElement(
														'i',
														null,
														_react2.default.createElement(
															'span',
															{ className: 'web_pro_icon' },
															_react2.default.createElement('img', { src: this.state.pro_pic, alt: ' ', className: 'webpro_img' })
														),
														_react2.default.createElement('span', { className: 'glyphicon glyphicon-option-vertical glyph_dots' })
													) },
												_react2.default.createElement(
													'li',
													null,
													_react2.default.createElement(
														_reactRouter.Link,
														{ to: '/web/myaquacash', title: 'My AquaCash' },
														'My Aquacash',
														this.state.aquacash ? _react2.default.createElement(
															'span',
															{ className: 'nav_menu_right' },
															'\u20B9',
															this.state.aquacash
														) : ''
													)
												),
												_react2.default.createElement(
													'li',
													null,
													_react2.default.createElement(
														_reactRouter.Link,
														{ to: '/web/myorders', title: 'My Orders' },
														'My Orders',
														this.state.bookings ? _react2.default.createElement(
															'span',
															{ className: '' },
															this.state.bookings
														) : ''
													)
												),
												_react2.default.createElement(
													'li',
													null,
													_react2.default.createElement(
														_reactRouter.Link,
														{ to: '/web/wishlist', title: 'Wishlist' },
														'Wishlist'
													)
												),
												_react2.default.createElement(
													'li',
													null,
													_react2.default.createElement(
														_reactRouter.Link,
														{ to: "/web/profile", title: 'My Profile' },
														'My Profile'
													)
												),
												_react2.default.createElement(
													'li',
													null,
													_react2.default.createElement(
														_reactRouter.Link,
														{ to: '/web/notifications', title: 'Notifications' },
														'Notifications ',
														this.state.noty_count > 0 ? _react2.default.createElement(
															'span',
															{ className: 'nav_menu_right' },
															this.state.noty_count
														) : ''
													)
												),
												_react2.default.createElement(
													'li',
													null,
													_react2.default.createElement(
														_reactRouter.Link,
														{ to: '/web/offerszone', title: 'Offers Zone' },
														'Offers Zone'
													)
												),
												_react2.default.createElement(
													'li',
													null,
													_react2.default.createElement(
														_reactRouter.Link,
														{ to: '/web/share_earn', title: 'Share & Earn' },
														'Share & Earn'
													)
												),
												_react2.default.createElement(
													'li',
													null,
													_react2.default.createElement(
														_reactRouter.Link,
														{ to: '/web/customer_care', title: 'Customer Care' },
														'Customer Care'
													)
												),
												_react2.default.createElement('li', { role: 'separator', className: 'divider' }),
												_react2.default.createElement(
													'li',
													null,
													aut_status
												)
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'sub_nav' },
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/web/downloads', title: 'Download App' },
											'Download app'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/web/customer_care', title: '24x7 Customer Support' },
											'24x7 Customer Support'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/web/advertise-with-us', title: 'Advertise with us' },
											'Advertise with us'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "/web/enquire_now/partner/support/sid/did", title: 'Sell on AquaDeals' },
											'Sell on AquaDeals'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/web/aboutus', title: 'About Us' },
											'About Us'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'http://blog.aqua.deals', title: 'AquaDeals Blog', target: '_blank' },
											'Blog'
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return WebHeaderInner;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			search: state.posts.search,
			brands: state.posts.brands,
			products: state.posts.products,
			trendings: state.posts.trendings,
			categories: state.posts.categories
		};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(WebHeaderInner);

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.addStyle = addStyle;
	
	var _react = __webpack_require__(1);
	
	var _styleMaps = __webpack_require__(27);
	
	var _styleMaps2 = _interopRequireDefault(_styleMaps);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	}
	
	function prefix(props, variant) {
	  if (props === undefined) props = {};
	
	  !(props.bsClass || '').trim() ?  false ? _invariant2['default'](false, 'A `bsClass` prop is required for this component') : _invariant2['default'](false) : undefined;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _react.PropTypes.string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	exports.bsClass = bsClass;
	var bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _react.PropTypes.oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = propType._values = existing;
	
	  Component.propTypes = _extends({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	exports.bsStyles = bsStyles;
	var bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _styleMaps2['default'].SIZES[size];
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _react.PropTypes.oneOf(values);
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = _extends({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	exports.bsSizes = bsSizes;
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _styleMaps2['default'].SIZES[props.bsSize] || bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = curry;
	exports._curry = _curry;

/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	exports.__esModule = true;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$create = __webpack_require__(314)["default"];
	
	var _Object$setPrototypeOf = __webpack_require__(785)["default"];
	
	exports["default"] = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = _Object$create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _Object$setPrototypeOf ? _Object$setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	exports.__esModule = true;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(845);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(846);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(42);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  warning = function (condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 17 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Object.assign
	 */
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign
	
	'use strict';
	
	function assign(target, sources) {
	  if (target == null) {
	    throw new TypeError('Object.assign target cannot be null or undefined');
	  }
	
	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }
	
	    var from = Object(nextSource);
	
	    // We don't currently support accessors nor proxies. Therefore this
	    // copy cannot throw. If we ever supported this then we must handle
	    // exceptions and side-effects. We don't support symbols so they won't
	    // be transferred.
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }
	
	  return to;
	}
	
	module.exports = assign;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shareCountGetters = exports.shareLinks = exports.ShareCounts = exports.ShareButtons = exports.generateShareIcon = undefined;
	
	var _generateIcon = __webpack_require__(881);
	
	var _shareButtons = __webpack_require__(883);
	
	var ShareButtons = _interopRequireWildcard(_shareButtons);
	
	var _shareCounts = __webpack_require__(884);
	
	var ShareCounts = _interopRequireWildcard(_shareCounts);
	
	var _socialMediaShareLinks = __webpack_require__(348);
	
	var shareLinks = _interopRequireWildcard(_socialMediaShareLinks);
	
	var _shareCountGetters = __webpack_require__(347);
	
	var shareCountGetters = _interopRequireWildcard(_shareCountGetters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.generateShareIcon = _generateIcon.generateIcon;
	exports.ShareButtons = ShareButtons;
	exports.ShareCounts = ShareCounts;
	exports.shareLinks = shareLinks;
	exports.shareCountGetters = shareCountGetters;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(31));
	
	var _swiper = _interopRequireDefault(__webpack_require__(986));
	
	var _objectAssign = _interopRequireDefault(__webpack_require__(809));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(38));
	
	var _utils = __webpack_require__(808);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ReactIdSwiper =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ReactIdSwiper, _Component);
	
	  // Default props
	  // Proptypes
	  function ReactIdSwiper(props) {
	    var _this;
	
	    _classCallCheck(this, ReactIdSwiper);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactIdSwiper).call(this, props));
	    _this.renderContent = _this.renderContent.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(ReactIdSwiper, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.buildSwiper();
	      var slideToIndex = this.getActiveSlideIndexFromProps();
	
	      if (slideToIndex !== null) {
	        this.swiper.slideTo(slideToIndex);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (typeof this.swiper !== 'undefined') {
	        var _this$props = this.props,
	            rebuildOnUpdate = _this$props.rebuildOnUpdate,
	            shouldSwiperUpdate = _this$props.shouldSwiperUpdate;
	
	        if (rebuildOnUpdate) {
	          this.rebuildSwiper();
	        } else if (shouldSwiperUpdate) {
	          this.updateSwiper();
	          var numSlides = this.swiper.slides.length;
	
	          if (numSlides <= this.swiper.activeIndex) {
	            var index = Math.max(numSlides - 1, 0);
	            this.swiper.slideTo(index);
	          }
	        }
	
	        var slideToIndex = this.getActiveSlideIndexFromProps();
	
	        if (slideToIndex !== null) {
	          this.swiper.slideTo(slideToIndex);
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (typeof this.swiper !== 'undefined') this.swiper.destroy(true, true);
	      delete this.swiper;
	    }
	  }, {
	    key: "getActiveSlideIndexFromProps",
	    value: function getActiveSlideIndexFromProps() {
	      var activeSlideKey = this.props.activeSlideKey;
	
	      if (!activeSlideKey) {
	        return null;
	      }
	
	      var activeSlideId = null;
	      var id = 0;
	
	      _react.default.Children.forEach(this.props.children, function (child) {
	        if (child) {
	          if (child.key === activeSlideKey) {
	            activeSlideId = id;
	          }
	
	          id += 1;
	        }
	      });
	
	      return activeSlideId;
	    }
	  }, {
	    key: "buildSwiper",
	    value: function buildSwiper() {
	      this.swiper = new _swiper.default(_reactDom.default.findDOMNode(this), (0, _objectAssign.default)({}, this.props));
	    }
	  }, {
	    key: "rebuildSwiper",
	    value: function rebuildSwiper() {
	      this.swiper.destroy(true, true);
	      this.buildSwiper();
	    }
	  }, {
	    key: "updateSwiper",
	    value: function updateSwiper() {
	      if (typeof this.swiper !== 'undefined') this.swiper.update();
	    }
	  }, {
	    key: "renderContent",
	    value: function renderContent(e) {
	      if (!e) return false;
	      var _this$props2 = this.props,
	          slideClass = _this$props2.slideClass,
	          noSwiping = _this$props2.noSwiping;
	      var slideClassNames = [slideClass, e.props.className];
	      if (noSwiping) slideClassNames.push('swiper-no-swiping');
	      return _react.default.cloneElement(e, _objectSpread({}, e.props, {
	        className: slideClassNames.join(' ').trim()
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props3 = this.props,
	          ContainerEl = _this$props3.ContainerEl,
	          WrapperEl = _this$props3.WrapperEl,
	          containerClass = _this$props3.containerClass,
	          wrapperClass = _this$props3.wrapperClass,
	          children = _this$props3.children,
	          rtl = _this$props3.rtl,
	          scrollbar = _this$props3.scrollbar,
	          renderScrollbar = _this$props3.renderScrollbar,
	          pagination = _this$props3.pagination,
	          renderPagination = _this$props3.renderPagination,
	          navigation = _this$props3.navigation,
	          renderPrevButton = _this$props3.renderPrevButton,
	          renderNextButton = _this$props3.renderNextButton,
	          parallax = _this$props3.parallax,
	          parallaxEl = _this$props3.parallaxEl,
	          renderParallax = _this$props3.renderParallax;
	      return _react.default.createElement(ContainerEl, {
	        className: containerClass,
	        dir: rtl && 'rtl'
	      }, parallax && parallaxEl && renderParallax(this.props), _react.default.createElement(WrapperEl, {
	        className: wrapperClass
	      }, _react.default.Children.map(children, this.renderContent)), pagination && pagination.el && renderPagination(this.props), scrollbar && scrollbar.el && renderScrollbar(this.props), navigation && navigation.nextEl && renderNextButton(this.props), navigation && navigation.prevEl && renderPrevButton(this.props));
	    }
	  }]);
	
	  return ReactIdSwiper;
	}(_react.Component);
	
	exports.default = ReactIdSwiper;
	
	_defineProperty(ReactIdSwiper, "defaultProps", {
	  containerClass: 'swiper-container',
	  wrapperClass: 'swiper-wrapper',
	  slideClass: 'swiper-slide',
	  ContainerEl: 'div',
	  WrapperEl: 'div',
	  renderScrollbar: function renderScrollbar(_ref) {
	    var scrollbar = _ref.scrollbar;
	    return _react.default.createElement("div", {
	      className: (0, _utils.cn)(scrollbar.el)
	    });
	  },
	  renderPagination: function renderPagination(_ref2) {
	    var pagination = _ref2.pagination;
	    return _react.default.createElement("div", {
	      className: (0, _utils.cn)(pagination.el)
	    });
	  },
	  renderPrevButton: function renderPrevButton(_ref3) {
	    var navigation = _ref3.navigation;
	    return _react.default.createElement("div", {
	      className: (0, _utils.cn)(navigation.prevEl)
	    });
	  },
	  renderNextButton: function renderNextButton(_ref4) {
	    var navigation = _ref4.navigation;
	    return _react.default.createElement("div", {
	      className: (0, _utils.cn)(navigation.nextEl)
	    });
	  },
	  renderParallax: function renderParallax(_ref5) {
	    var parallaxEl = _ref5.parallaxEl;
	    return _react.default.createElement("div", {
	      className: (0, _utils.cn)(parallaxEl.el),
	      "data-swiper-parallax": parallaxEl.value
	    });
	  }
	});
	
	_defineProperty(ReactIdSwiper, "propTypes", {
	  // react-id-swiper original parameters
	  ContainerEl: _propTypes.default.string,
	  WrapperEl: _propTypes.default.string,
	  containerClass: _propTypes.default.string,
	  wrapperClass: _propTypes.default.string,
	  children: _propTypes.default.any,
	  rebuildOnUpdate: _propTypes.default.bool,
	  shouldSwiperUpdate: _propTypes.default.bool,
	  activeSlideKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  renderScrollbar: _propTypes.default.func,
	  renderPagination: _propTypes.default.func,
	  renderPrevButton: _propTypes.default.func,
	  renderNextButton: _propTypes.default.func,
	  renderParallax: _propTypes.default.func,
	  // parallax
	  parallax: _propTypes.default.bool,
	  parallaxEl: _propTypes.default.shape({
	    el: _propTypes.default.string,
	    value: _propTypes.default.string
	  }),
	  // swiper parameter
	  init: _propTypes.default.bool,
	  initialSlide: _propTypes.default.number,
	  direction: _propTypes.default.string,
	  rtl: _propTypes.default.bool,
	  speed: _propTypes.default.number,
	  setWrapperSize: _propTypes.default.bool,
	  virtualTranslate: _propTypes.default.bool,
	  width: _propTypes.default.number,
	  height: _propTypes.default.number,
	  autoHeight: _propTypes.default.bool,
	  roundLengths: _propTypes.default.bool,
	  nested: _propTypes.default.bool,
	  uniqueNavElements: _propTypes.default.bool,
	  effect: _propTypes.default.string,
	  runCallbacksOnInit: _propTypes.default.bool,
	  // slides grid
	  spaceBetween: _propTypes.default.number,
	  slidesPerView: _propTypes.default.any,
	  slidesPerColumn: _propTypes.default.number,
	  slidesPerColumnFill: _propTypes.default.string,
	  slidesPerGroup: _propTypes.default.number,
	  centeredSlides: _propTypes.default.bool,
	  slidesOffsetBefore: _propTypes.default.number,
	  slidesOffsetAfter: _propTypes.default.number,
	  normalizeSlideIndex: _propTypes.default.bool,
	  // grab cursor
	  grabCursor: _propTypes.default.bool,
	  // touches
	  touchEventsTarget: _propTypes.default.string,
	  touchRatio: _propTypes.default.number,
	  touchAngle: _propTypes.default.number,
	  simulateTouch: _propTypes.default.bool,
	  shortSwipes: _propTypes.default.bool,
	  longSwipes: _propTypes.default.bool,
	  longSwipesRatio: _propTypes.default.number,
	  longSwipesMs: _propTypes.default.number,
	  followFinger: _propTypes.default.bool,
	  allowTouchMove: _propTypes.default.bool,
	  threshold: _propTypes.default.number,
	  touchMoveStopPropagation: _propTypes.default.bool,
	  iOSEdgeSwipeDetection: _propTypes.default.bool,
	  iOSEdgeSwipeThreshold: _propTypes.default.number,
	  touchReleaseOnEdges: _propTypes.default.bool,
	  passiveListeners: _propTypes.default.bool,
	  // touch resistance
	  resistance: _propTypes.default.bool,
	  resistanceRatio: _propTypes.default.number,
	  // swiping / no swiping
	  allowSlidePrev: _propTypes.default.bool,
	  allowSlideNext: _propTypes.default.bool,
	  noSwiping: _propTypes.default.bool,
	  noSwipingClass: _propTypes.default.string,
	  swipeHandler: _propTypes.default.any,
	  // clicks
	  preventClicks: _propTypes.default.bool,
	  preventClicksPropagation: _propTypes.default.bool,
	  slideToClickedSlide: _propTypes.default.bool,
	  // freemode
	  freeMode: _propTypes.default.bool,
	  freeModeMomentum: _propTypes.default.bool,
	  freeModeMomentumRatio: _propTypes.default.number,
	  freeModeMomentumVelocityRatio: _propTypes.default.number,
	  freeModeMomentumBounce: _propTypes.default.bool,
	  freeModeMomentumBounceRatio: _propTypes.default.number,
	  freeModeMinimumVelocity: _propTypes.default.number,
	  freeModeSticky: _propTypes.default.bool,
	  // progress
	  watchSlidesProgress: _propTypes.default.bool,
	  watchSlidesVisibility: _propTypes.default.bool,
	  // images
	  preloadImages: _propTypes.default.bool,
	  updateOnImagesReady: _propTypes.default.bool,
	  // loop
	  loop: _propTypes.default.bool,
	  loopAdditionalSlides: _propTypes.default.number,
	  loopedSlides: _propTypes.default.number,
	  loopFillGroupWithBlank: _propTypes.default.bool,
	  // breakpoints
	  breakpoints: _propTypes.default.object,
	  // observer
	  observer: _propTypes.default.bool,
	  observeParents: _propTypes.default.bool,
	  // namespace
	  containerModifierClass: _propTypes.default.string,
	  slideClass: _propTypes.default.string,
	  slideActiveClass: _propTypes.default.string,
	  slideDuplicatedActiveClass: _propTypes.default.string,
	  slideVisibleClass: _propTypes.default.string,
	  slideDuplicateClass: _propTypes.default.string,
	  slideNextClass: _propTypes.default.string,
	  slideDuplicatedNextClass: _propTypes.default.string,
	  slidePrevClass: _propTypes.default.string,
	  slideDuplicatedPrevClass: _propTypes.default.string,
	  // autoplay
	  autoplay: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
	    delay: _propTypes.default.number,
	    stopOnLast: _propTypes.default.bool,
	    disableOnInteraction: _propTypes.default.bool
	  })]),
	  // pagination
	  pagination: _propTypes.default.shape({
	    el: _propTypes.default.string,
	    type: _propTypes.default.string,
	    bulletElement: _propTypes.default.string,
	    dynamicBullets: _propTypes.default.bool,
	    hideOnClick: _propTypes.default.bool,
	    clickable: _propTypes.default.bool,
	    renderBullet: _propTypes.default.func,
	    renderFraction: _propTypes.default.func,
	    renderProgressbar: _propTypes.default.func,
	    renderCustom: _propTypes.default.func,
	    bulletClass: _propTypes.default.string,
	    bulletActiveClass: _propTypes.default.string,
	    modifierClass: _propTypes.default.string,
	    currentClass: _propTypes.default.string,
	    totalClass: _propTypes.default.string,
	    hiddenClass: _propTypes.default.string,
	    progressbarFillClass: _propTypes.default.string,
	    clickableClass: _propTypes.default.string
	  }),
	  // scrollbar
	  scrollbar: _propTypes.default.shape({
	    el: _propTypes.default.any,
	    hide: _propTypes.default.bool,
	    draggable: _propTypes.default.bool,
	    snapOnRelease: _propTypes.default.bool,
	    dragSize: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
	  }),
	  // navigation
	  navigation: _propTypes.default.shape({
	    nextEl: _propTypes.default.string,
	    prevEl: _propTypes.default.string,
	    hideOnClick: _propTypes.default.bool,
	    disabledClass: _propTypes.default.string,
	    hiddenClass: _propTypes.default.string
	  }),
	  // a11y
	  a11y: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
	    prevSlideMessage: _propTypes.default.string,
	    nextSlideMessage: _propTypes.default.string,
	    firstSlideMessage: _propTypes.default.string,
	    lastSlideMessage: _propTypes.default.string,
	    paginationBulletMessage: _propTypes.default.string,
	    notificationClass: _propTypes.default.string
	  })]),
	  // zoom
	  zoom: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
	    maxRatio: _propTypes.default.number,
	    minRatio: _propTypes.default.number,
	    toggle: _propTypes.default.bool,
	    containerClass: _propTypes.default.string,
	    zoomedSlideClass: _propTypes.default.string
	  })]),
	  // keyboard
	  keyboard: _propTypes.default.bool,
	  // mousewheel
	  mousewheel: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
	    forceToAxis: _propTypes.default.bool,
	    releaseOnEdges: _propTypes.default.bool,
	    invert: _propTypes.default.bool,
	    sensitivity: _propTypes.default.number,
	    eventsTarged: _propTypes.default.string
	  })]),
	  // hashNavigation
	  hashNavigation: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
	    watchState: _propTypes.default.bool,
	    replaceState: _propTypes.default.bool
	  })]),
	  // history
	  history: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
	    key: _propTypes.default.string,
	    replaceState: _propTypes.default.bool
	  })]),
	  // lazy
	  lazy: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
	    loadPrevNext: _propTypes.default.bool,
	    loadPrevNextAmount: _propTypes.default.number,
	    loadOnTransitionStart: _propTypes.default.bool,
	    elementClass: _propTypes.default.string,
	    loadingClass: _propTypes.default.string,
	    loadedClass: _propTypes.default.string,
	    preloaderClass: _propTypes.default.string
	  })]),
	  // fadeEffect
	  fadeEffect: _propTypes.default.shape({
	    crossFade: _propTypes.default.bool
	  }),
	  // coverflowEffect
	  coverflowEffect: _propTypes.default.shape({
	    slideShadows: _propTypes.default.bool,
	    rotate: _propTypes.default.number,
	    stretch: _propTypes.default.number,
	    depth: _propTypes.default.number,
	    modifier: _propTypes.default.number
	  }),
	  // flipEffect
	  flipEffect: _propTypes.default.shape({
	    slideShadows: _propTypes.default.bool,
	    limitRotation: _propTypes.default.bool
	  }),
	  // cubeEffect
	  cubeEffect: _propTypes.default.shape({
	    slideShadows: _propTypes.default.bool,
	    shadow: _propTypes.default.bool,
	    shadowOffset: _propTypes.default.number,
	    shadowScale: _propTypes.default.number
	  }),
	  // controller
	  controller: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
	    control: _propTypes.default.any,
	    inverse: _propTypes.default.bool,
	    by: _propTypes.default.string
	  })]),
	  // events
	  on: _propTypes.default.shape({
	    init: _propTypes.default.func,
	    beforeDestroy: _propTypes.default.func,
	    slideChange: _propTypes.default.func,
	    slideChangeTransitionStart: _propTypes.default.func,
	    slideChangeTransitionEnd: _propTypes.default.func,
	    slideNextTransitionStart: _propTypes.default.func,
	    slideNextTransitionEnd: _propTypes.default.func,
	    slidePrevTransitionStart: _propTypes.default.func,
	    slidePrevTransitionEnd: _propTypes.default.func,
	    transitionStart: _propTypes.default.func,
	    onTransitionEnd: _propTypes.default.func,
	    touchStart: _propTypes.default.func,
	    touchMove: _propTypes.default.func,
	    touchMoveOpposite: _propTypes.default.func,
	    sliderMove: _propTypes.default.func,
	    touchEnd: _propTypes.default.func,
	    click: _propTypes.default.func,
	    tap: _propTypes.default.func,
	    doubleTap: _propTypes.default.func,
	    imagesReady: _propTypes.default.func,
	    progress: _propTypes.default.func,
	    reachBeginning: _propTypes.default.func,
	    reachEnd: _propTypes.default.func,
	    fromEdge: _propTypes.default.func,
	    setTranslate: _propTypes.default.func,
	    setTransition: _propTypes.default.func,
	    resize: _propTypes.default.func
	  })
	});

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _common = __webpack_require__(188);
	
	/**
	 * Checks whether a prop provides a type of element.
	 *
	 * The type of element can be provided in two forms:
	 * - tag name (string)
	 * - a return value of React.createClass(...)
	 *
	 * @param props
	 * @param propName
	 * @param componentName
	 * @returns {Error|undefined}
	 */
	
	function validate(props, propName, componentName) {
	  var errBeginning = _common.errMsg(props, propName, componentName, '. Expected an Element `type`');
	
	  if (typeof props[propName] !== 'function') {
	    if (_react2['default'].isValidElement(props[propName])) {
	      return new Error(errBeginning + ', not an actual Element');
	    }
	
	    if (typeof props[propName] !== 'string') {
	      return new Error(errBeginning + ' such as a tag name or return value of React.createClass(...)');
	    }
	  }
	}
	
	exports['default'] = _common.createChainableTypeChecker(validate);
	module.exports = exports['default'];

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loginUser = loginUser;
	exports.registerUser = registerUser;
	exports.addPost = addPost;
	exports.addPosting = addPosting;
	exports.fetchImages = fetchImages;
	exports.fetchPost = fetchPost;
	exports.fetchUser = fetchUser;
	exports.fetchUploads = fetchUploads;
	exports.discover = discover;
	exports.mobileNumber = mobileNumber;
	exports.PostShow = PostShow;
	exports.EditPost = EditPost;
	exports.updatePost = updatePost;
	exports.deletePost = deletePost;
	exports.authError = authError;
	exports.login_res = login_res;
	exports.logoutUser = logoutUser;
	exports.OTPsent = OTPsent;
	exports.Otpverify = Otpverify;
	exports.Signup = Signup;
	exports.fetchads = fetchads;
	exports.ads_count = ads_count;
	exports.fetchpromo_ads = fetchpromo_ads;
	exports.getcartcount = getcartcount;
	exports.search_products = search_products;
	exports.saveseed_lead = saveseed_lead;
	exports.savefeed_lead = savefeed_lead;
	exports.savefeed_lead_website = savefeed_lead_website;
	exports.trends = trends;
	exports.track_seller_lead = track_seller_lead;
	exports.track_user_lead = track_user_lead;
	exports.clear_state = clear_state;
	exports.test = test;
	exports.tokenCheck = tokenCheck;
	exports.get_rzp_keys = get_rzp_keys;
	exports.recommendedforyou = recommendedforyou;
	exports.getProductTabs = getProductTabs;
	exports.getProductDesc = getProductDesc;
	
	var _axios = __webpack_require__(215);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(2);
	
	var _types = __webpack_require__(421);
	
	var _querystring = __webpack_require__(293);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROOT_URL = 'https://aquadeals.in/admin/web3/user/';
	function loginUser(_ref) {
	  var email = _ref.email,
	      password = _ref.password;
	
	  return function (dispatch) {
	    _axios2.default.post(ROOT_URL + 'api/login', { email: email, password: password }).then(function (response) {
	      dispatch({ type: _types.AUTH_USER,
	        payload: { token: response.data.token }
	      });
	      localStorage.setItem('token', response.data.token);
	      _reactRouter.browserHistory.push("/posts");
	      window.location.reload();
	    }).catch(function () {
	      dispatch(authError("Please provide valid details.. !"));
	    });
	  };
	}
	
	function registerUser(_ref2) {
	  var name = _ref2.name,
	      email = _ref2.email,
	      password = _ref2.password;
	
	  return function (dispatch) {
	    _axios2.default.post(ROOT_URL + 'api/register', { name: name, email: email, password: password }).then(function (response) {
	      dispatch({ type: _types.AUTH_USER });
	      localStorage.setItem('token', response.data.token);
	      _reactRouter.browserHistory.push('/posts');
	      window.location.reload();
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function addPost(_ref3) {
	  var title = _ref3.title,
	      body = _ref3.body;
	
	  return function (dispatch) {
	    _axios2.default.post(ROOT_URL + 'api/posts', { title: title, body: body }, {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.ADD_POST,
	        payload: response
	      });
	    });
	  };
	}
	
	function addPosting(img_url, post_title) {
	  return function (dispatch) {
	    _axios2.default.post(ROOT_URL + 'api/lib', { img_url: img_url, post_title: post_title }, {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.ADD_IMGS,
	        payload: response
	      });
	    });
	  };
	}
	
	function fetchImages() {
	  return function (dispatch) {
	    _axios2.default.get(ROOT_URL + 'api/lib', {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_UPLOADS,
	        payload: response
	      });
	    });
	  };
	}
	
	function fetchPost() {
	  // return function(dispatch){
	  //   axios.get(`${ROOT_URL}api/posts`,{
	  //    headers: { authorization: localStorage.getItem('token') }
	  //   })
	  //     .then(response =>{
	  //         dispatch({
	  //           type:FETCH_POST,
	  //           payload:response
	  //         });
	  //     })
	
	  // }
	}
	
	function fetchUser(id) {
	  return function (dispatch) {
	    _axios2.default.get(ROOT_URL + 'api/auth/' + id, {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_USER,
	        payload: response
	      });
	    });
	  };
	}
	
	function fetchUploads(user_id) {
	  return function (dispatch) {
	    _axios2.default.get(ROOT_URL + 'api/lib/' + user_id, {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_UPLOADS,
	        payload: response
	      });
	    });
	  };
	}
	
	function discover() {
	  return function (dispatch) {
	    _axios2.default.get(ROOT_URL + 'api/auth/', {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_PEOPLE,
	        payload: response
	      });
	    });
	  };
	}
	
	function mobileNumber(_ref4) {
	  var mobile = _ref4.mobile;
	
	  return function (dispatch) {
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ from: 'desktop_web', 'mobile': mobile, uid: localStorage.getItem('f_uid'), email: localStorage.getItem('f_email'), device_id: localStorage.getItem('push_device_id') })
	    });
	    _axios2.default.post(ROOT_URL + 'social_mobile_auth', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.AUTH_USER,
	        payload: response
	      });
	
	      if (response.data.status === 'success' && response.data.page_source === 'dashboard') {
	        localStorage.setItem('user_id', response.data.uid);
	        localStorage.setItem('token', response.data.token);
	        _reactRouter.browserHistory.push('/web/home');
	      }
	      if (response.data.page_source === 'otp_screen') {
	        _reactRouter.browserHistory.push('/web/mobile/verify_otp');
	        window.location.reload();
	      }
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function PostShow(id) {
	  return function (dispatch) {
	    _axios2.default.get(ROOT_URL + 'api/posts/' + id, {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.POST_SHOW,
	        payload: response
	      });
	    });
	  };
	}
	
	function EditPost(id) {
	  return function (dispatch) {
	    _axios2.default.get(ROOT_URL + 'api/posts/' + id + '/edit', {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.EDIT_POST,
	        payload: response
	      });
	    });
	  };
	}
	
	function updatePost(id, _ref5) {
	  var title = _ref5.title,
	      body = _ref5.body;
	
	  return function (dispatch) {
	    _axios2.default.put(ROOT_URL + 'api/posts/' + id, { title: title, body: body }, {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.UPDATE_POST,
	        payload: response
	      });
	    });
	  };
	}
	
	function deletePost(id) {
	  return function (dispatch) {
	    _axios2.default.delete(ROOT_URL + 'api/posts/' + id, {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.DELETE_POST,
	        payload: response
	      });
	    });
	  };
	}
	
	function authError(error) {
	  return {
	    type: _types.AUTH_ERROR,
	    payload: error
	  };
	}
	
	function login_res(res) {
	  return {
	    type: _types.AUTH_LOG,
	    payload: res
	  };
	}
	
	function logoutUser() {
	  localStorage.removeItem('token');
	  return { type: _types.LOGOUT_USER };
	}
	
	function OTPsent(_ref6) {
	  var mobile = _ref6.mobile;
	
	  return function (dispatch) {
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ from: 'desktop_web', 'mobile': mobile })
	    });
	    _axios2.default.post(ROOT_URL + 'sentOtp', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.AUTH_USER,
	        payload: response
	      });
	      localStorage.setItem('mobile_number', mobile);
	      if (response.data.status === 'success' && response.data.page === 'login') {
	        //browserHistory.push('/web/account');
	        //window.location.reload();
	      } else if (response.data.status === 'success' && response.data.page === 'signup') {
	        //browserHistory.push('/web/signup');	
	        //window.location.reload();	
	      }
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function Otpverify(_ref7) {
	  var mobile = _ref7.mobile,
	      otp = _ref7.otp;
	
	  return function (dispatch) {
	    var mobile = localStorage.getItem('mobile_number');
	    var pwd = localStorage.getItem('pwd');
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ 'from': 'desktop_web',
	        'mobile': mobile,
	        'otp': otp,
	        'pwd': pwd })
	    });
	    _axios2.default.post(ROOT_URL + 'verifyOtp', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.AUTH_USER,
	        payload: response
	      });
	      // console.log(response.data);
	      if (response.data.status === 'success') {
	        // localStorage.setItem('token',response.data.user[0].token);
	        // browserHistory.push('/web/home');
	        // window.location.reload();
	      }
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function Signup(_ref8) {
	  var mobile = _ref8.mobile,
	      name = _ref8.name,
	      password = _ref8.password,
	      email = _ref8.email,
	      refcode = _ref8.refcode,
	      tnc = _ref8.tnc;
	
	  return function (dispatch) {
	    var mobile = localStorage.getItem('mobile_number');
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ 'from': 'desktop_web',
	        'mobile': mobile,
	        'name': name,
	        'password': password,
	        'email': email,
	        'referral': refcode,
	        'device': '',
	        'version': '',
	        'platform': '',
	        'device_id': localStorage.getItem('push_device_id')
	
	      })
	    });
	    _axios2.default.post(ROOT_URL + 'signup', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.AUTH_USER,
	        payload: response
	      });
	      // console.log(response.data);
	      if (response.data.status === 'success') {}
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	//** Dec 8th 2016 **//
	
	
	function fetchads() {
	  return function (dispatch) {
	    var uid = '';
	    if (localStorage.user_id) {
	      uid = localStorage.user_id;
	    } else {
	      uid = localStorage.ip;
	    }
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({
	        'id': uid,
	        'width': 400,
	        'height': 200,
	        'from': 3
	      })
	    });
	    _axios2.default.post(ROOT_URL + 'getAd', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_ADS,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	function ads_count(ad_id) {
	  return function (dispatch) {
	    var uid = '';
	    if (localStorage.user_id) {
	      uid = localStorage.user_id;
	    } else {
	      uid = localStorage.ip;
	    }
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({
	        'from': 3,
	        'ad_id': ad_id,
	        'id': uid
	      })
	    });
	    _axios2.default.post(ROOT_URL + 'load_ad', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_ADS,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function fetchpromo_ads() {
	  return function (dispatch) {
	    _axios2.default.post(ROOT_URL + 'getOffers').then(function (response) {
	      dispatch({
	        type: _types.FETCH_PROMO_ADS,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	function getcartcount() {
	  return function (dispatch) {
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ 'from': 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') })
	    });
	    _axios2.default.post(ROOT_URL + 'cart_count', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.CARTCOUNT,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	function search_products(keywords) {
	  return function (dispatch) {
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ 'from': 'desktop_web', 'srh': keywords })
	    });
	    _axios2.default.post(ROOT_URL + 'searchbybrand_product', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_SEARCH,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function saveseed_lead(_ref9, seller_id, deal_id) {
	  var name = _ref9.name,
	      number = _ref9.number,
	      email = _ref9.email;
	
	  return function (dispatch) {
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ 'from': 'desktop_web',
	        'name': name,
	        'mobile': number,
	        'email': email,
	        'seller_id': seller_id,
	        'deal_id': deal_id
	
	      })
	    });
	    _axios2.default.post(ROOT_URL + 'saveseed_lead_web', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_LEADS,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function savefeed_lead(_ref10, seller_id, deal_id) {
	  var name = _ref10.name,
	      number = _ref10.number,
	      email = _ref10.email;
	
	  return function (dispatch) {
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ 'from': 'desktop_web',
	        'name': name,
	        'mobile': number,
	        'email': email,
	        'seller_id': seller_id,
	        'deal_id': deal_id
	      })
	    });
	    _axios2.default.post(ROOT_URL + 'savefeed_lead_web', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_LEADS,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function savefeed_lead_website(user_id, seller_id, deal_id) {
	  return function (dispatch) {
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ 'from': 'desktop_web',
	        'user_id': user_id,
	        'seller_id': seller_id,
	        'deal_id': deal_id
	      })
	    });
	    _axios2.default.post(ROOT_URL + 'savefeed_lead_web', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_LEADS,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function trends() {
	  return function (dispatch) {
	    _axios2.default.get(ROOT_URL + 'getTrends', {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_TRENDS,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function track_seller_lead(_ref11, user_mobile, user_name, seller_id, deal_id, stype, role, message) {
	  var name = _ref11.name,
	      number = _ref11.number,
	      email = _ref11.email,
	      company_name = _ref11.company_name;
	
	  return function (dispatch) {
	    var id = '';
	    if (localStorage.user_id) {
	      id = localStorage.user_id;
	    } else {
	      id = localStorage.ip;
	    }
	    var token = '';
	    if (localStorage.token) {
	      token = localStorage.token;
	    } else {
	      token = 0;
	    }
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ 'from': 'desktop_web',
	        'id': id,
	        'token': token,
	        'name': user_name,
	        'mobile': user_mobile,
	        'email': email,
	        'cname': company_name,
	        'stype': stype,
	        'role': role,
	        'message': message,
	        'seller_id': seller_id,
	        'deal_id': deal_id
	      })
	    });
	    _axios2.default.post(ROOT_URL + 'trackSellerLead', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_LEADS,
	        payload: response
	      });
	      _reactRouter.browserHistory.push('/web/customer_care_seller');
	      // window.location.reload();
	      // if(response.message === '1'){
	      //   browserHistory.push('/web/customer_care_seller');
	      //   // window.location.reload();
	      // }
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function track_user_lead(_ref12, dtype) {
	  var name = _ref12.name,
	      number = _ref12.number,
	      email = _ref12.email;
	
	  return function (dispatch) {
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ 'from': 'desktop_web', 'name': name,
	        'mobile': number,
	        'email': email,
	        'dtype': dtype
	      })
	    });
	    _axios2.default.post(ROOT_URL + 'trackUserLead', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_LEADS,
	        payload: response
	      });
	      // if(response.data.status === 'success'){
	      //   browserHistory.push('/web/customer_care');
	      // }
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function clear_state() {
	  return { type: _types.FETCH_LEADS_C };
	}
	
	function test(type, tid, page) {
	  return function (dispatch) {
	    var _this = this;
	
	    var data1 = { from: 'desktop_web', dtype: page, type: type, tid: tid };
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify(data1)
	    });
	    _axios2.default.post(ROOT_URL + 'getProductbycat_brand', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_LEADS,
	        payload: response
	      });
	      if (response.data) {
	        //   this.setState({
	        //     feedsList:response.data.result,
	        //     offer: response.data,
	        //     loading:true,
	        //     bread: response.data.cat_name,
	        //     title:response.data.cat_name,
	        //     desc:response.data.cat_desc,
	        // });
	        document.title = _this.state.title + " Products - Feed | AquaDeals ";
	        document.getElementsByTagName("META")[2].content = _this.state.desc;
	      }
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function tokenCheck() {
	  return function (dispatch) {
	    if (localStorage.source) {
	      var source = localStorage.getItem('source');
	    }
	    if (localStorage.campaign) {
	      var campaign = localStorage.getItem('campaign');
	    }
	    if (localStorage.url_id) {
	      var url_id = localStorage.getItem('url_id');
	    }
	
	    localStorage.clear();
	
	    if (source) {
	      localStorage.setItem('source', source);
	    }
	    if (campaign) {
	      localStorage.setItem('campaign', campaign);
	    }
	    if (url_id) {
	      localStorage.setItem('url_id', url_id);
	    }
	    window.location.reload();
	  };
	}
	
	function get_rzp_keys(source) {
	  return function (dispatch) {
	    var data = _querystring2.default.stringify({ req: JSON.stringify({ 'from': source }) });
	    _axios2.default.post(ROOT_URL + 'getRazorpayKeys', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_RZP_KEYS,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function recommendedforyou(source) {
	  return function (dispatch) {
	    var uid = localStorage.user_id;
	    var data = _querystring2.default.stringify({ req: JSON.stringify({ 'from': 'mobile_web', uid: uid }) });
	    _axios2.default.post(ROOT_URL + 'recommendedforyou', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_RECENT,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function getProductTabs(params) {
	  return function (dispatch) {
	    var uid = localStorage.user_id;
	    var data = _querystring2.default.stringify({ req: JSON.stringify({ 'from': 'mobile_web', pid: params, uid: uid }) });
	    _axios2.default.post(ROOT_URL + 'getTabs', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_PRODUCT_TABS,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function getProductDesc(pid, cid) {
	  return function (dispatch) {
	    var uid = localStorage.user_id;
	    var data = _querystring2.default.stringify({ req: JSON.stringify({ 'from': 'mobile_web', pid: pid, cid: cid, uid: uid }) });
	    _axios2.default.post(ROOT_URL + 'getTabsdesc', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_PRODUCT_DESC,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loginUser = loginUser;
	exports.registerUser = registerUser;
	exports.addPost = addPost;
	exports.addPosting = addPosting;
	exports.fetchImages = fetchImages;
	exports.fetchPost = fetchPost;
	exports.fetchUser = fetchUser;
	exports.fetchUploads = fetchUploads;
	exports.discover = discover;
	exports.PostShow = PostShow;
	exports.EditPost = EditPost;
	exports.tokenCheck = tokenCheck;
	exports.updatePost = updatePost;
	exports.deletePost = deletePost;
	exports.authError = authError;
	exports.logoutUser = logoutUser;
	exports.mobileNumber = mobileNumber;
	exports.OTPsent = OTPsent;
	exports.Otpverify = Otpverify;
	exports.Signup = Signup;
	exports.fetchads = fetchads;
	exports.ads_count = ads_count;
	exports.fetchpromo_ads = fetchpromo_ads;
	exports.search_products = search_products;
	exports.placeorder = placeorder;
	exports.saveseed_lead = saveseed_lead;
	exports.savefeed_lead = savefeed_lead;
	exports.trends = trends;
	exports.track_seller_lead = track_seller_lead;
	exports.track_user_lead = track_user_lead;
	exports.get_rzp_keys = get_rzp_keys;
	exports.recommendedforyou = recommendedforyou;
	exports.getProductTabs = getProductTabs;
	exports.getProductDesc = getProductDesc;
	exports.getUserAddress = getUserAddress;
	exports.clear_state = clear_state;
	
	var _axios = __webpack_require__(215);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouter = __webpack_require__(2);
	
	var _types = __webpack_require__(137);
	
	var _querystring = __webpack_require__(293);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROOT_URL = 'https://aquadeals.in/admin/web3/user/';
	var BASE_URL = 'https://aquadeals.in/admin/web3/user/';
	function loginUser(_ref) {
	  var email = _ref.email,
	      password = _ref.password;
	
	  return function (dispatch) {
	    _axios2.default.post(ROOT_URL + 'api/login', { email: email, password: password }).then(function (response) {
	      dispatch({ type: _types.AUTH_USER,
	        payload: { token: response.data.token }
	      });
	      localStorage.setItem('token', response.data.token);
	      _reactRouter.browserHistory.push("/posts");
	      window.location.reload();
	    }).catch(function () {
	      dispatch(authError("Please provide valid details.. !"));
	    });
	  };
	}
	
	function registerUser(_ref2) {
	  var name = _ref2.name,
	      email = _ref2.email,
	      password = _ref2.password;
	
	  return function (dispatch) {
	    _axios2.default.post(ROOT_URL + 'api/register', { name: name, email: email, password: password }).then(function (response) {
	      dispatch({ type: _types.AUTH_USER });
	      localStorage.setItem('token', response.data.token);
	      _reactRouter.browserHistory.push('/posts');
	      window.location.reload();
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function addPost(_ref3) {
	  var title = _ref3.title,
	      body = _ref3.body;
	
	  return function (dispatch) {
	    _axios2.default.post(ROOT_URL + 'api/posts', { title: title, body: body }, {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.ADD_POST,
	        payload: response
	      });
	    });
	  };
	}
	
	function addPosting(img_url, post_title) {
	  return function (dispatch) {
	    _axios2.default.post(ROOT_URL + 'api/lib', { img_url: img_url, post_title: post_title }, {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.ADD_IMGS,
	        payload: response
	      });
	    });
	  };
	}
	
	function fetchImages() {
	  return function (dispatch) {
	    _axios2.default.get(ROOT_URL + 'api/lib', {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_UPLOADS,
	        payload: response
	      });
	    });
	  };
	}
	
	function fetchPost() {
	  return function (dispatch) {
	    _axios2.default.get(ROOT_URL + 'api/posts', {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_POST,
	        payload: response
	      });
	    });
	  };
	}
	
	function fetchUser(id) {
	  return function (dispatch) {
	    _axios2.default.get(ROOT_URL + 'api/auth/' + id, {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_USER,
	        payload: response
	      });
	    });
	  };
	}
	
	function fetchUploads(user_id) {
	  return function (dispatch) {
	    _axios2.default.get(ROOT_URL + 'api/lib/' + user_id, {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_UPLOADS,
	        payload: response
	      });
	    });
	  };
	}
	
	function discover() {
	  return function (dispatch) {
	    _axios2.default.get(ROOT_URL + 'api/auth/', {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_PEOPLE,
	        payload: response
	      });
	    });
	  };
	}
	
	function PostShow(id) {
	  return function (dispatch) {
	    _axios2.default.get(ROOT_URL + 'api/posts/' + id, {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.POST_SHOW,
	        payload: response
	      });
	    });
	  };
	}
	
	function EditPost(id) {
	  return function (dispatch) {
	    _axios2.default.get(ROOT_URL + 'api/posts/' + id + '/edit', {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.EDIT_POST,
	        payload: response
	      });
	    });
	  };
	}
	
	function tokenCheck() {
	  console.log("token check function calling");
	  // localStorage.removeItem('user_id');
	  // localStorage.removeItem('token');
	  // window.location.reload();
	}
	
	function updatePost(id, _ref4) {
	  var title = _ref4.title,
	      body = _ref4.body;
	
	  return function (dispatch) {
	    _axios2.default.put(ROOT_URL + 'api/posts/' + id, { title: title, body: body }, {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.UPDATE_POST,
	        payload: response
	      });
	    });
	  };
	}
	
	function deletePost(id) {
	  return function (dispatch) {
	    _axios2.default.delete(ROOT_URL + 'api/posts/' + id, {
	      headers: { authorization: localStorage.getItem('token') }
	    }).then(function (response) {
	      dispatch({
	        type: _types.DELETE_POST,
	        payload: response
	      });
	    });
	  };
	}
	
	function authError(error) {
	  return {
	    type: _types.AUTH_ERROR,
	    payload: error
	  };
	}
	
	function logoutUser() {
	  localStorage.removeItem('token');
	  return { type: _types.LOGOUT_USER };
	}
	function mobileNumber(_ref5) {
	  var mobile = _ref5.mobile;
	
	  return function (dispatch) {
	    if (localStorage.source) {
	      var source = localStorage.getItem('source');
	    } else {
	      source = '';
	    }
	    if (localStorage.campaign) {
	      var campaign = localStorage.getItem('campaign');
	    } else {
	      campaign = '';
	    }
	    if (localStorage.url_id) {
	      var url_id = localStorage.getItem('url_id');
	    } else {
	      url_id = '';
	    }
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ from: 'mobile_web', 'mobile': mobile, uid: localStorage.getItem('f_uid'), email: localStorage.getItem('f_email'), password: '', device_id: localStorage.getItem('push_device_id'), version: '', platform: '', language: '', source: source, campaign: campaign, url_id: url_id })
	    });
	    _axios2.default.post(ROOT_URL + 'social_mobile_auth', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.AUTH_USER,
	        payload: response
	      });
	      if (response.data.status === 'success' && response.data.page_source === 'dashboard') {
	        localStorage.setItem('user_id', response.data.uid);
	        localStorage.setItem('token', response.data.token);
	        _reactRouter.browserHistory.push('/home');
	      }
	      if (response.data.page_source === 'otp_screen') {
	        _reactRouter.browserHistory.push('/mobile/verify_otp');
	        window.location.reload();
	      }
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function OTPsent(_ref6) {
	  var mobile = _ref6.mobile;
	
	
	  if (typeof window.location.pathname.split("/")[2] === "undefined") {
	    var redirect_url = '';
	  } else {
	    var redirect_url = window.location.pathname.split("/")[2];
	  }
	
	  return function (dispatch) {
	    if (localStorage.source) {
	      var source = localStorage.getItem('source');
	    } else {
	      source = '';
	    }
	    if (localStorage.campaign) {
	      var campaign = localStorage.getItem('campaign');
	    } else {
	      campaign = '';
	    }
	    if (localStorage.url_id) {
	      var url_id = localStorage.getItem('url_id');
	    } else {
	      url_id = '';
	    }
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ from: 'mobile_web', 'mobile': mobile, device_id: localStorage.getItem('push_device_id'), source: source, campaign: campaign, url_id: url_id })
	    });
	    _axios2.default.post(ROOT_URL + 'sentOtp', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.AUTH_USER,
	        payload: response
	      });
	      localStorage.setItem('mobile_number', mobile);
	      if (response.data.status === 'success' && response.data.page === 'login') {
	        _reactRouter.browserHistory.push('/account/' + redirect_url);
	        // window.location.reload();
	      } else if (response.data.status === 'success' && response.data.page === 'signup') {
	        _reactRouter.browserHistory.push('/signup');
	        // window.location.reload();
	      }
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function Otpverify(_ref7) {
	  var mobile = _ref7.mobile,
	      otp = _ref7.otp;
	
	  return function (dispatch) {
	    if (localStorage.source) {
	      var source = localStorage.getItem('source');
	    } else {
	      source = '';
	    }
	    if (localStorage.campaign) {
	      var campaign = localStorage.getItem('campaign');
	    } else {
	      campaign = '';
	    }
	    if (localStorage.url_id) {
	      var url_id = localStorage.getItem('url_id');
	    } else {
	      url_id = '';
	    }
	    var mobile = localStorage.getItem('mobile_number');
	    var pwd = localStorage.getItem('pwd');
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ 'from': 'mobile_web',
	        'mobile': mobile,
	        'otp': otp,
	        'pwd': pwd, source: source, campaign: campaign, url_id: url_id
	      })
	    });
	    _axios2.default.post(ROOT_URL + 'verifyOtp', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.AUTH_USER,
	        payload: response
	      });
	      console.log(response.data);
	      if (response.data.status === 'success') {
	        localStorage.setItem('token', response.data.user[0].token);
	        _reactRouter.browserHistory.push('/reset');
	        // window.location.reload();
	      }
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function Signup(_ref8) {
	  var mobile = _ref8.mobile,
	      name = _ref8.name,
	      password = _ref8.password,
	      email = _ref8.email,
	      refcode = _ref8.refcode,
	      tnc = _ref8.tnc;
	
	  return function (dispatch) {
	    var mobile = localStorage.getItem('mobile_number');
	    if (localStorage.source) {
	      var source = localStorage.getItem('source');
	    } else {
	      source = '';
	    }
	    if (localStorage.campaign) {
	      var campaign = localStorage.getItem('campaign');
	    } else {
	      campaign = '';
	    }
	    if (localStorage.url_id) {
	      var url_id = localStorage.getItem('url_id');
	    } else {
	      url_id = '';
	    }
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ 'from': 'mobile_web',
	        'mobile': mobile,
	        'name': name,
	        'password': password,
	        'email': email,
	        'referral': refcode,
	        'device': '',
	        'version': '',
	        'platform': '',
	        'device_id': localStorage.getItem('push_device_id'), source: source, campaign: campaign, url_id: url_id
	      })
	    });
	    _axios2.default.post(ROOT_URL + 'signup', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.AUTH_USER,
	        payload: response
	      });
	      console.log(response.data);
	      if (response.data.status === 'success') {
	        _reactRouter.browserHistory.push('/Otpverify');
	      }
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	//** Dec 8th 2016 **//
	
	
	function fetchads() {
	  return function (dispatch) {
	    var uid = '';
	    if (localStorage.user_id) {
	      uid = localStorage.user_id;
	    } else {
	      uid = localStorage.ip;
	    }
	    if (localStorage.source) {
	      var source = localStorage.getItem('source');
	    } else {
	      source = '';
	    }
	    if (localStorage.campaign) {
	      var campaign = localStorage.getItem('campaign');
	    } else {
	      campaign = '';
	    }
	    if (localStorage.url_id) {
	      var url_id = localStorage.getItem('url_id');
	    } else {
	      url_id = '';
	    }
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({
	        'id': uid,
	        'token': localStorage.getItem('token'),
	        'width': 400,
	        'height': 200,
	        'from': 4, source: source, campaign: campaign, url_id: url_id
	      })
	    });
	    _axios2.default.post(ROOT_URL + 'getAd', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_ADS,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function ads_count(ad_id) {
	  return function (dispatch) {
	    var uid = '';
	    if (localStorage.user_id) {
	      uid = localStorage.user_id;
	    } else {
	      uid = localStorage.ip;
	    }
	    if (localStorage.source) {
	      var source = localStorage.getItem('source');
	    } else {
	      source = '';
	    }
	    if (localStorage.campaign) {
	      var campaign = localStorage.getItem('campaign');
	    } else {
	      campaign = '';
	    }
	    if (localStorage.url_id) {
	      var url_id = localStorage.getItem('url_id');
	    } else {
	      url_id = '';
	    }
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ 'from': 4,
	        'ad_id': ad_id,
	        'id': uid, source: source, campaign: campaign, url_id: url_id
	      })
	    });
	    _axios2.default.post(ROOT_URL + 'load_ad', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_ADS,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function fetchpromo_ads() {
	  return function (dispatch) {
	    _axios2.default.post(ROOT_URL + 'getOffers').then(function (response) {
	      dispatch({
	        type: _types.FETCH_PROMO_ADS,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function search_products(keywords) {
	  return function (dispatch) {
	    if (localStorage.source) {
	      var source = localStorage.getItem('source');
	    } else {
	      source = '';
	    }
	    if (localStorage.campaign) {
	      var campaign = localStorage.getItem('campaign');
	    } else {
	      campaign = '';
	    }
	    if (localStorage.url_id) {
	      var url_id = localStorage.getItem('url_id');
	    } else {
	      url_id = '';
	    }
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ from: 'mobile_web', 'srh': keywords, source: source, campaign: campaign, url_id: url_id })
	    });
	    _axios2.default.post(ROOT_URL + 'searchbybrand_product', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_SEARCH,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	function placeorder(data2) {
	  return function (dispatch) {
	    var data = _querystring2.default.stringify({ req: data2 });
	    _axios2.default.post(ROOT_URL + 'cartCalculations', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.MYCART_PLACEORDER,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function saveseed_lead(_ref9, seller_id, deal_id) {
	  var name = _ref9.name,
	      number = _ref9.number,
	      email = _ref9.email;
	
	  return function (dispatch) {
	    if (localStorage.source) {
	      var source = localStorage.getItem('source');
	    } else {
	      source = '';
	    }
	    if (localStorage.campaign) {
	      var campaign = localStorage.getItem('campaign');
	    } else {
	      campaign = '';
	    }
	    if (localStorage.url_id) {
	      var url_id = localStorage.getItem('url_id');
	    } else {
	      url_id = '';
	    }
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ 'from': 'mobile_web',
	        'name': name,
	        'mobile': number,
	        'email': email,
	        'seller_id': seller_id,
	        'deal_id': deal_id, source: source, campaign: campaign, url_id: url_id
	
	      })
	    });
	    _axios2.default.post(ROOT_URL + 'saveseed_lead_web', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_LEADS,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function savefeed_lead(_ref10, seller_id, deal_id) {
	  var name = _ref10.name,
	      number = _ref10.number,
	      email = _ref10.email;
	
	  return function (dispatch) {
	    if (localStorage.source) {
	      var source = localStorage.getItem('source');
	    } else {
	      source = '';
	    }
	    if (localStorage.campaign) {
	      var campaign = localStorage.getItem('campaign');
	    } else {
	      campaign = '';
	    }
	    if (localStorage.url_id) {
	      var url_id = localStorage.getItem('url_id');
	    } else {
	      url_id = '';
	    }
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ 'from': 'mobile_web',
	        'name': name,
	        'mobile': number,
	        'email': email,
	        'seller_id': seller_id,
	        'deal_id': deal_id, source: source, campaign: campaign, url_id: url_id
	      })
	    });
	    _axios2.default.post(ROOT_URL + 'savefeed_lead_web', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_LEADS,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function trends() {
	  return function (dispatch) {
	    if (localStorage.user_id) {
	      var uid = localStorage.user_id;
	    } else {
	      uid = 0;
	    }
	    var data = _querystring2.default.stringify({ req: JSON.stringify({ 'from': 'mobile_web', uid: uid }) });
	    _axios2.default.post(ROOT_URL + 'getTrends', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_TRENDS,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function track_seller_lead(_ref11, from, user_mobile, user_name, seller_id, deal_id, stype, role, message) {
	  var name = _ref11.name,
	      number = _ref11.number,
	      email = _ref11.email,
	      company_name = _ref11.company_name;
	
	  return function (dispatch) {
	    var id = '';
	    if (localStorage.user_id) {
	      id = localStorage.user_id;
	    } else {
	      id = localStorage.ip;
	    }
	    var token = '';
	    if (localStorage.token) {
	      token = localStorage.token;
	    } else {
	      token = 0;
	    }
	    if (localStorage.source) {
	      var source = localStorage.getItem('source');
	    } else {
	      source = '';
	    }
	    if (localStorage.campaign) {
	      var campaign = localStorage.getItem('campaign');
	    } else {
	      campaign = '';
	    }
	    if (localStorage.url_id) {
	      var url_id = localStorage.getItem('url_id');
	    } else {
	      url_id = '';
	    }
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ 'from': from,
	        'id': id,
	        'token': token,
	        'name': user_name,
	        'mobile': user_mobile,
	        'email': email,
	        'cname': company_name,
	        'stype': stype,
	        'role': role,
	        'message': message,
	        'seller_id': seller_id,
	        'deal_id': deal_id, source: source, campaign: campaign, url_id: url_id
	      })
	    });
	    _axios2.default.post(ROOT_URL + 'trackSellerLead', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_LEADS,
	        payload: response
	      });
	      // browserHistory.push('/customer_care_seller');
	      // window.location.reload();
	      if (response.message === '1') {
	        _reactRouter.browserHistory.push('/customer_care_seller');
	        // window.location.reload();
	      }
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function track_user_lead(_ref12, dtype) {
	  var name = _ref12.name,
	      number = _ref12.number,
	      email = _ref12.email;
	
	  var mail = '';
	  if (email.lenght > 0) {
	    mail = email;
	  } else {
	    mail = '';
	  }
	  // alert(email);
	
	  return function (dispatch) {
	    if (localStorage.source) {
	      var source = localStorage.getItem('source');
	    } else {
	      source = '';
	    }
	    if (localStorage.campaign) {
	      var campaign = localStorage.getItem('campaign');
	    } else {
	      campaign = '';
	    }
	    if (localStorage.url_id) {
	      var url_id = localStorage.getItem('url_id');
	    } else {
	      url_id = '';
	    }
	    var data = _querystring2.default.stringify({
	      req: JSON.stringify({ 'from': 'mobile_web',
	        'name': name,
	        'mobile': number,
	        'email': mail,
	        'dtype': dtype, source: source, campaign: campaign, url_id: url_id
	      })
	    });
	    _axios2.default.post(ROOT_URL + 'trackUserLead', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_LEADS,
	        payload: response
	      });
	      if (response.data.status === 'success') {
	        _reactRouter.browserHistory.push('/customer_care');
	        // window.location.reload();
	      }
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function get_rzp_keys(source) {
	  return function (dispatch) {
	    var data = _querystring2.default.stringify({ req: JSON.stringify({ 'from': source }) });
	    _axios2.default.post(ROOT_URL + 'getRazorpayKeys', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_RZP_KEYS,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function recommendedforyou(source) {
	  return function (dispatch) {
	    var uid = localStorage.user_id;
	    var data = _querystring2.default.stringify({ req: JSON.stringify({ 'from': 'mobile_web', uid: uid }) });
	    _axios2.default.post(ROOT_URL + 'recommendedforyou', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_RECENT,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function getProductTabs(params) {
	  return function (dispatch) {
	    var uid = localStorage.user_id;
	    var data = _querystring2.default.stringify({ req: JSON.stringify({ 'from': 'mobile_web', pid: params, uid: uid }) });
	    _axios2.default.post(ROOT_URL + 'getTabs', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_PRODUCT_TABS,
	        payload: response
	      });
	    }).catch(function (response) {
	      return '';
	    });
	  };
	}
	
	function getProductDesc(pid, cid) {
	  return function (dispatch) {
	    var uid = localStorage.user_id;
	    var data = _querystring2.default.stringify({ req: JSON.stringify({ 'from': 'mobile_web', pid: pid, cid: cid, uid: uid }) });
	    _axios2.default.post(ROOT_URL + 'getTabsdesc', data, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_PRODUCT_DESC,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function getUserAddress(data) {
	  return function (dispatch) {
	    var params = _querystring2.default.stringify({ req: data });
	    _axios2.default.post(ROOT_URL + 'getuserAddress', params, {
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
	      dispatch({
	        type: _types.FETCH_USER_ADDR,
	        payload: response
	      });
	    }).catch(function (response) {
	      return dispatch(authError(response.data.error));
	    });
	  };
	}
	
	function clear_state() {
	  return { type: _types.CLEAR_STATE };
	}

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 25 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(880);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$assign = __webpack_require__(92)['default'];
	
	var _Object$create = __webpack_require__(314)['default'];
	
	var _Object$keys = __webpack_require__(56)['default'];
	
	exports.__esModule = true;
	
	var constant = function constant(obj) {
	  return _Object$assign(_Object$create({
	    values: function values() {
	      var _this = this;
	
	      return _Object$keys(this).map(function (k) {
	        return _this[k];
	      });
	    }
	  }), obj);
	};
	
	var styleMaps = {
	
	  SIZES: {
	    'large': 'lg',
	    'medium': 'md',
	    'small': 'sm',
	    'xsmall': 'xs',
	    'lg': 'lg',
	    'md': 'md',
	    'sm': 'sm',
	    'xs': 'xs'
	  },
	  GRID_COLUMNS: 12
	};
	
	var Sizes = constant({
	  LARGE: 'large',
	  MEDIUM: 'medium',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	});
	
	exports.Sizes = Sizes;
	var State = constant({
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	});
	
	exports.State = State;
	var DEFAULT = 'default';
	exports.DEFAULT = DEFAULT;
	var PRIMARY = 'primary';
	exports.PRIMARY = PRIMARY;
	var LINK = 'link';
	exports.LINK = LINK;
	var INVERSE = 'inverse';
	
	exports.INVERSE = INVERSE;
	exports['default'] = styleMaps;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	// FIXME: This should really be ValidElementChildren.
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	
	  return _react2['default'].Children.map(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function count(children) {
	  var result = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result = undefined;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	exports['default'] = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  some: some
	};
	module.exports = exports['default'];

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	module.exports=function(e){var o={};function r(a){if(o[a])return o[a].exports;var t=o[a]={i:a,l:!1,exports:{}};return e[a].call(t.exports,t,t.exports,r),t.l=!0,t.exports}return r.m=e,r.c=o,r.d=function(e,o,a){r.o(e,o)||Object.defineProperty(e,o,{configurable:!1,enumerable:!0,get:a})},r.r=function(e){Object.defineProperty(e,"__esModule",{value:!0})},r.n=function(e){var o=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(o,"a",o),o},r.o=function(e,o){return Object.prototype.hasOwnProperty.call(e,o)},r.p="",r(r.s=15)}([function(e,o){e.exports=__webpack_require__(888)},function(e){e.exports={acrobat:61696,amazon:61697,android:61698,angellist:61699,aol:61700,appnet:61701,appstore:61702,bitbucket:61703,bitcoin:61704,blogger:61705,buffer:61706,cal:61707,call:61708,cart:61709,chrome:61710,cloudapp:61711,creativecommons:61712,delicious:61713,digg:61714,disqus:61715,dribbble:61716,dropbox:61717,drupal:61718,dwolla:61720,email:61721,eventasaurus:61722,eventbrite:61723,eventful:61724,evernote:61725,facebook:61726,fivehundredpx:61727,flattr:61728,flickr:61729,forrst:61730,foursquare:61731,github:61732,gmail:61733,google:61734,googleplay:61735,googleplus:61736,gowalla:61737,grooveshark:61738,guest:61739,html5:61740,ie:61741,instagram:61742,instapaper:61743,intensedebate:61744,itunes:61745,klout:61746,lanyrd:61747,lastfm:61748,lego:61749,linkedin:61750,lkdto:61751,logmein:61752,macstore:61753,meetup:61754,myspace:61755,ninetyninedesigns:61756,openid:61757,opentable:61758,paypal:61759,persona:61796,pinboard:61760,pinterest:61761,plancast:61762,plurk:61763,pocket:61764,podcast:61765,posterous:61766,print:61767,quora:61768,reddit:61769,rss:61770,scribd:61771,skype:61772,smashing:61773,songkick:61774,soundcloud:61775,spotify:61776,stackoverflow:61777,statusnet:61778,steam:61779,stripe:61780,stumbleupon:61781,tumblr:61782,twitter:61783,viadeo:61784,vimeo:61785,vk:61786,weibo:61787,wikipedia:61788,windows:61789,wordpress:61790,xing:61791,yahoo:61792,ycombinator:61793,yelp:61794,youtube:61795}},function(e){e.exports={user:57349,people:57345,"user-female":57344,"user-follow":57346,"user-following":57347,"user-unfollow":57348,login:57446,logout:57445,emotsmile:57377,phone:58880,"call-end":57416,"call-in":57415,"call-out":57414,map:57395,"location-pin":57494,direction:57410,directions:57409,compass:57413,layers:57396,menu:58881,list:57447,"options-vertical":58882,options:58883,"arrow-down":58884,"arrow-left":58885,"arrow-right":58886,"arrow-up":58887,"arrow-up-circle":57464,"arrow-left-circle":57466,"arrow-right-circle":57465,"arrow-down-circle":57467,check:57472,clock:57473,plus:57493,minus:58901,close:57474,event:58905,exclamation:58903,organization:58902,trophy:57350,"screen-smartphone":57360,"screen-desktop":57361,plane:57362,notebook:57363,mustache:57364,mouse:57365,magnet:57366,energy:57376,disc:57378,cursor:57454,"cursor-move":57379,crop:57380,chemistry:57382,speedometer:57351,shield:57358,"screen-tablet":57359,"magic-wand":57367,hourglass:57368,graduation:57369,ghost:57370,"game-controller":57371,fire:57372,eyeglass:57373,"envelope-open":57374,"envelope-letter":57375,bell:57383,badge:57384,anchor:57385,wallet:57386,vector:57387,speech:57388,puzzle:57389,printer:57390,present:57391,playlist:57392,pin:57393,picture:57394,handbag:57397,"globe-alt":57398,globe:57399,"folder-alt":57401,folder:57481,film:57402,feed:57403,drop:57406,drawer:57407,docs:57408,doc:57477,diamond:57411,cup:57412,calculator:57417,bubbles:57418,briefcase:57419,"book-open":57420,"basket-loaded":57421,basket:57422,bag:57423,"action-undo":57424,"action-redo":57425,wrench:57426,umbrella:57427,trash:57428,tag:57429,support:57430,frame:57400,"size-fullscreen":57431,"size-actual":57432,shuffle:57433,"share-alt":57434,share:57435,rocket:57436,question:57437,"pie-chart":57438,pencil:57439,note:57440,loop:57444,home:57449,grid:57450,graph:57451,microphone:57443,"music-tone-alt":57441,"music-tone":57442,"earphones-alt":57404,earphones:57405,equalizer:57452,like:57448,dislike:57453,"control-start":57455,"control-rewind":57456,"control-play":57457,"control-pause":57458,"control-forward":57459,"control-end":57460,"volume-1":57503,"volume-2":57504,"volume-off":57505,calendar:57461,bulb:57462,chart:57463,ban:57468,bubble:57469,camrecorder:57470,camera:57471,"cloud-download":57475,"cloud-upload":57476,envelope:57478,eye:57479,flag:57480,heart:57482,info:57483,key:57484,link:57485,lock:57486,"lock-open":57487,magnifier:57488,"magnifier-add":57489,"magnifier-remove":57490,"paper-clip":57491,"paper-plane":57492,power:57495,refresh:57496,reload:57497,settings:57498,star:57499,"symbol-female":57500,"symbol-male":57501,target:57502,"credit-card":57381,paypal:58888,"social-tumblr":57354,"social-twitter":57353,"social-facebook":57355,"social-instagram":58889,"social-linkedin":58890,"social-pinterest":58891,"social-github":58892,"social-google":58893,"social-reddit":58894,"social-skype":58895,"social-dribbble":57357,"social-behance":58896,"social-foursqare":58897,"social-soundcloud":58898,"social-spotify":58899,"social-stumbleupon":58900,"social-youtube":57352,"social-dropbox":57356,"social-vkontakte":58904,"social-steam":58912}},function(e){e.exports={alert:61696,archive:61697,"arrow-down":61698,"arrow-left":61699,"arrow-right":61700,"arrow-small-down":61701,"arrow-small-left":61702,"arrow-small-right":61703,"arrow-small-up":61704,"arrow-up":61705,beaker:61706,bell:61707,bold:61708,book:61709,bookmark:61710,briefcase:61711,broadcast:61712,browser:61713,bug:61714,calendar:61715,check:61716,checklist:61717,"chevron-down":61718,"chevron-left":61719,"chevron-right":61720,"chevron-up":61721,"circle-slash":61722,"circuit-board":61723,clippy:61724,clock:61725,"cloud-download":61726,"cloud-upload":61727,code:61728,comment:61729,"comment-discussion":61730,"credit-card":61731,dash:61732,dashboard:61733,database:61734,"desktop-download":61735,"device-camera":61736,"device-camera-video":61737,"device-desktop":61738,"device-mobile":61739,diff:61740,"diff-added":61741,"diff-ignored":61742,"diff-modified":61743,"diff-removed":61744,"diff-renamed":61745,ellipsis:61746,eye:61747,file:61748,"file-binary":61749,"file-code":61750,"file-directory":61751,"file-media":61752,"file-pdf":61753,"file-submodule":61754,"file-symlink-directory":61755,"file-symlink-file":61756,"file-zip":61757,flame:61758,fold:61759,gear:61760,gift:61761,gist:61762,"gist-secret":61763,"git-branch":61764,"git-commit":61765,"git-compare":61766,"git-merge":61767,"git-pull-request":61768,globe:61769,grabber:61770,graph:61771,heart:61772,history:61773,home:61774,"horizontal-rule":61775,hubot:61776,inbox:61777,info:61778,"issue-closed":61779,"issue-opened":61780,"issue-reopened":61781,italic:61782,jersey:61783,"kebab-horizontal":61784,"kebab-vertical":61785,key:61786,keyboard:61787,law:61788,"light-bulb":61789,link:61790,"link-external":61791,"list-ordered":61792,"list-unordered":61793,location:61794,lock:61795,"logo-gist":61796,"logo-github":61797,mail:61798,"mail-read":61799,"mark-github":61800,markdown:61801,megaphone:61802,mention:61803,milestone:61804,mirror:61805,"mortar-board":61806,mute:61807,"no-newline":61808,note:61809,octoface:61810,organization:61811,package:61812,paintcan:61813,pencil:61814,person:61815,pin:61816,plug:61817,plus:61818,"plus-small":61819,"primitive-dot":61820,"primitive-square":61821,project:61822,pulse:61823,question:61824,quote:61825,"radio-tower":61826,reply:61827,repo:61828,"repo-clone":61829,"repo-force-push":61830,"repo-forked":61831,"repo-pull":61832,"repo-push":61833,report:61834,rocket:61835,rss:61836,ruby:61837,"screen-full":61838,"screen-normal":61839,search:61840,server:61841,settings:61842,shield:61843,"sign-in":61844,"sign-out":61845,smiley:61846,squirrel:61847,star:61848,stop:61849,sync:61850,tag:61851,tasklist:61852,telescope:61853,terminal:61854,"text-size":61855,"three-bars":61856,thumbsdown:61857,thumbsup:61858,tools:61859,trashcan:61860,"triangle-down":61861,"triangle-left":61862,"triangle-right":61863,"triangle-up":61864,unfold:61865,unmute:61866,unverified:61867,verified:61868,versions:61869,watch:61870,x:61871,zap:61872}},function(e){e.exports={"3d-rotation":59469,"ac-unit":60219,"access-alarm":57744,"access-alarms":57745,"access-time":57746,accessibility:59470,accessible:59668,"account-balance":59471,"account-balance-wallet":59472,"account-box":59473,"account-circle":59475,adb:58894,add:57669,"add-a-photo":58425,"add-alarm":57747,"add-alert":57347,"add-box":57670,"add-circle":57671,"add-circle-outline":57672,"add-location":58727,"add-shopping-cart":59476,"add-to-photos":58269,"add-to-queue":57436,adjust:58270,"airline-seat-flat":58928,"airline-seat-flat-angled":58929,"airline-seat-individual-suite":58930,"airline-seat-legroom-extra":58931,"airline-seat-legroom-normal":58932,"airline-seat-legroom-reduced":58933,"airline-seat-recline-extra":58934,"airline-seat-recline-normal":58935,"airplanemode-active":57749,"airplanemode-inactive":57748,airplay:57429,"airport-shuttle":60220,alarm:59477,"alarm-add":59478,"alarm-off":59479,"alarm-on":59480,album:57369,"all-inclusive":60221,"all-out":59659,android:59481,announcement:59482,apps:58819,archive:57673,"arrow-back":58820,"arrow-downward":58843,"arrow-drop-down":58821,"arrow-drop-down-circle":58822,"arrow-drop-up":58823,"arrow-forward":58824,"arrow-upward":58840,"art-track":57440,"aspect-ratio":59483,assessment:59484,assignment:59485,"assignment-ind":59486,"assignment-late":59487,"assignment-return":59488,"assignment-returned":59489,"assignment-turned-in":59490,assistant:58271,"assistant-photo":58272,"attach-file":57894,"attach-money":57895,attachment:58044,audiotrack:58273,autorenew:59491,"av-timer":57371,backspace:57674,backup:59492,"battery-alert":57756,"battery-charging-full":57763,"battery-full":57764,"battery-std":57765,"battery-unknown":57766,"beach-access":60222,beenhere:58669,block:57675,bluetooth:57767,"bluetooth-audio":58895,"bluetooth-connected":57768,"bluetooth-disabled":57769,"bluetooth-searching":57770,"blur-circular":58274,"blur-linear":58275,"blur-off":58276,"blur-on":58277,book:59493,bookmark:59494,"bookmark-border":59495,"border-all":57896,"border-bottom":57897,"border-clear":57898,"border-color":57899,"border-horizontal":57900,"border-inner":57901,"border-left":57902,"border-outer":57903,"border-right":57904,"border-style":57905,"border-top":57906,"border-vertical":57907,"branding-watermark":57451,"brightness-1":58278,"brightness-2":58279,"brightness-3":58280,"brightness-4":58281,"brightness-5":58282,"brightness-6":58283,"brightness-7":58284,"brightness-auto":57771,"brightness-high":57772,"brightness-low":57773,"brightness-medium":57774,"broken-image":58285,brush:58286,"bubble-chart":59101,"bug-report":59496,build:59497,"burst-mode":58428,business:57519,"business-center":60223,cached:59498,cake:59369,call:57520,"call-end":57521,"call-made":57522,"call-merge":57523,"call-missed":57524,"call-missed-outgoing":57572,"call-received":57525,"call-split":57526,"call-to-action":57452,camera:58287,"camera-alt":58288,"camera-enhance":59644,"camera-front":58289,"camera-rear":58290,"camera-roll":58291,cancel:58825,"card-giftcard":59638,"card-membership":59639,"card-travel":59640,casino:60224,cast:58119,"cast-connected":58120,"center-focus-strong":58292,"center-focus-weak":58293,"change-history":59499,chat:57527,"chat-bubble":57546,"chat-bubble-outline":57547,check:58826,"check-box":59444,"check-box-outline-blank":59445,"check-circle":59500,"chevron-left":58827,"chevron-right":58828,"child-care":60225,"child-friendly":60226,"chrome-reader-mode":59501,class:59502,clear:57676,"clear-all":57528,close:58829,"closed-caption":57372,cloud:58045,"cloud-circle":58046,"cloud-done":58047,"cloud-download":58048,"cloud-off":58049,"cloud-queue":58050,"cloud-upload":58051,code:59503,collections:58294,"collections-bookmark":58417,"color-lens":58295,colorize:58296,comment:57529,compare:58297,"compare-arrows":59669,computer:58122,"confirmation-number":58936,"contact-mail":57552,"contact-phone":57551,contacts:57530,"content-copy":57677,"content-cut":57678,"content-paste":57679,"control-point":58298,"control-point-duplicate":58299,copyright:59660,create:57680,"create-new-folder":58060,"credit-card":59504,crop:58302,"crop-16-9":58300,"crop-3-2":58301,"crop-5-4":58303,"crop-7-5":58304,"crop-din":58305,"crop-free":58306,"crop-landscape":58307,"crop-original":58308,"crop-portrait":58309,"crop-rotate":58423,"crop-square":58310,dashboard:59505,"data-usage":57775,"date-range":59670,dehaze:58311,delete:59506,"delete-forever":59691,"delete-sweep":57708,description:59507,"desktop-mac":58123,"desktop-windows":58124,details:58312,"developer-board":58125,"developer-mode":57776,"device-hub":58165,devices:57777,"devices-other":58167,"dialer-sip":57531,dialpad:57532,directions:58670,"directions-bike":58671,"directions-boat":58674,"directions-bus":58672,"directions-car":58673,"directions-railway":58676,"directions-run":58726,"directions-subway":58675,"directions-transit":58677,"directions-walk":58678,"disc-full":58896,dns:59509,"do-not-disturb":58898,"do-not-disturb-alt":58897,"do-not-disturb-off":58947,"do-not-disturb-on":58948,dock:58126,domain:59374,done:59510,"done-all":59511,"donut-large":59671,"donut-small":59672,drafts:57681,"drag-handle":57949,"drive-eta":58899,dvr:57778,edit:58313,"edit-location":58728,eject:59643,email:57534,"enhanced-encryption":58943,equalizer:57373,error:57344,"error-outline":57345,"euro-symbol":59686,"ev-station":58733,event:59512,"event-available":58900,"event-busy":58901,"event-note":58902,"event-seat":59651,"exit-to-app":59513,"expand-less":58830,"expand-more":58831,explicit:57374,explore:59514,exposure:58314,"exposure-neg-1":58315,"exposure-neg-2":58316,"exposure-plus-1":58317,"exposure-plus-2":58318,"exposure-zero":58319,extension:59515,face:59516,"fast-forward":57375,"fast-rewind":57376,favorite:59517,"favorite-border":59518,"featured-play-list":57453,"featured-video":57454,feedback:59519,"fiber-dvr":57437,"fiber-manual-record":57441,"fiber-new":57438,"fiber-pin":57450,"fiber-smart-record":57442,"file-download":58052,"file-upload":58054,filter:58323,"filter-1":58320,"filter-2":58321,"filter-3":58322,"filter-4":58324,"filter-5":58325,"filter-6":58326,"filter-7":58327,"filter-8":58328,"filter-9":58329,"filter-9-plus":58330,"filter-b-and-w":58331,"filter-center-focus":58332,"filter-drama":58333,"filter-frames":58334,"filter-hdr":58335,"filter-list":57682,"filter-none":58336,"filter-tilt-shift":58338,"filter-vintage":58339,"find-in-page":59520,"find-replace":59521,fingerprint:59661,"first-page":58844,"fitness-center":60227,flag:57683,flare:58340,"flash-auto":58341,"flash-off":58342,"flash-on":58343,flight:58681,"flight-land":59652,"flight-takeoff":59653,flip:58344,"flip-to-back":59522,"flip-to-front":59523,folder:58055,"folder-open":58056,"folder-shared":58057,"folder-special":58903,"font-download":57703,"format-align-center":57908,"format-align-justify":57909,"format-align-left":57910,"format-align-right":57911,"format-bold":57912,"format-clear":57913,"format-color-fill":57914,"format-color-reset":57915,"format-color-text":57916,"format-indent-decrease":57917,"format-indent-increase":57918,"format-italic":57919,"format-line-spacing":57920,"format-list-bulleted":57921,"format-list-numbered":57922,"format-paint":57923,"format-quote":57924,"format-shapes":57950,"format-size":57925,"format-strikethrough":57926,"format-textdirection-l-to-r":57927,"format-textdirection-r-to-l":57928,"format-underlined":57929,forum:57535,forward:57684,"forward-10":57430,"forward-30":57431,"forward-5":57432,"free-breakfast":60228,fullscreen:58832,"fullscreen-exit":58833,functions:57930,"g-translate":59687,gamepad:58127,games:57377,gavel:59662,gesture:57685,"get-app":59524,gif:59656,"golf-course":60229,"gps-fixed":57779,"gps-not-fixed":57780,"gps-off":57781,grade:59525,gradient:58345,grain:58346,"graphic-eq":57784,"grid-off":58347,"grid-on":58348,group:59375,"group-add":59376,"group-work":59526,hd:57426,"hdr-off":58349,"hdr-on":58350,"hdr-strong":58353,"hdr-weak":58354,headset:58128,"headset-mic":58129,healing:58355,hearing:57379,help:59527,"help-outline":59645,"high-quality":57380,highlight:57951,"highlight-off":59528,history:59529,home:59530,"hot-tub":60230,hotel:58682,"hourglass-empty":59531,"hourglass-full":59532,http:59650,https:59533,image:58356,"image-aspect-ratio":58357,"import-contacts":57568,"import-export":57539,"important-devices":59666,inbox:57686,"indeterminate-check-box":59657,info:59534,"info-outline":59535,input:59536,"insert-chart":57931,"insert-comment":57932,"insert-drive-file":57933,"insert-emoticon":57934,"insert-invitation":57935,"insert-link":57936,"insert-photo":57937,"invert-colors":59537,"invert-colors-off":57540,iso:58358,keyboard:58130,"keyboard-arrow-down":58131,"keyboard-arrow-left":58132,"keyboard-arrow-right":58133,"keyboard-arrow-up":58134,"keyboard-backspace":58135,"keyboard-capslock":58136,"keyboard-hide":58138,"keyboard-return":58139,"keyboard-tab":58140,"keyboard-voice":58141,kitchen:60231,label:59538,"label-outline":59539,landscape:58359,language:59540,laptop:58142,"laptop-chromebook":58143,"laptop-mac":58144,"laptop-windows":58145,"last-page":58845,launch:59541,layers:58683,"layers-clear":58684,"leak-add":58360,"leak-remove":58361,lens:58362,"library-add":57390,"library-books":57391,"library-music":57392,"lightbulb-outline":59663,"line-style":59673,"line-weight":59674,"linear-scale":57952,link:57687,"linked-camera":58424,list:59542,"live-help":57542,"live-tv":58937,"local-activity":58687,"local-airport":58685,"local-atm":58686,"local-bar":58688,"local-cafe":58689,"local-car-wash":58690,"local-convenience-store":58691,"local-dining":58710,"local-drink":58692,"local-florist":58693,"local-gas-station":58694,"local-grocery-store":58695,"local-hospital":58696,"local-hotel":58697,"local-laundry-service":58698,"local-library":58699,"local-mall":58700,"local-movies":58701,"local-offer":58702,"local-parking":58703,"local-pharmacy":58704,"local-phone":58705,"local-pizza":58706,"local-play":58707,"local-post-office":58708,"local-printshop":58709,"local-see":58711,"local-shipping":58712,"local-taxi":58713,"location-city":59377,"location-disabled":57782,"location-off":57543,"location-on":57544,"location-searching":57783,lock:59543,"lock-open":59544,"lock-outline":59545,looks:58364,"looks-3":58363,"looks-4":58365,"looks-5":58366,"looks-6":58367,"looks-one":58368,"looks-two":58369,loop:57384,loupe:58370,"low-priority":57709,loyalty:59546,mail:57688,"mail-outline":57569,map:58715,markunread:57689,"markunread-mailbox":59547,memory:58146,menu:58834,"merge-type":57938,message:57545,mic:57385,"mic-none":57386,"mic-off":57387,mms:58904,"mode-comment":57939,"mode-edit":57940,"monetization-on":57955,"money-off":57948,"monochrome-photos":58371,mood:59378,"mood-bad":59379,more:58905,"more-horiz":58835,"more-vert":58836,motorcycle:59675,mouse:58147,"move-to-inbox":57704,movie:57388,"movie-creation":58372,"movie-filter":58426,"multiline-chart":59103,"music-note":58373,"music-video":57443,"my-location":58716,nature:58374,"nature-people":58375,"navigate-before":58376,"navigate-next":58377,navigation:58717,"near-me":58729,"network-cell":57785,"network-check":58944,"network-locked":58906,"network-wifi":57786,"new-releases":57393,"next-week":57706,nfc:57787,"no-encryption":58945,"no-sim":57548,"not-interested":57395,note:57455,"note-add":59548,notifications:59380,"notifications-active":59383,"notifications-none":59381,"notifications-off":59382,"notifications-paused":59384,"offline-pin":59658,"ondemand-video":58938,opacity:59676,"open-in-browser":59549,"open-in-new":59550,"open-with":59551,pages:59385,pageview:59552,palette:58378,"pan-tool":59685,panorama:58379,"panorama-fish-eye":58380,"panorama-horizontal":58381,"panorama-vertical":58382,"panorama-wide-angle":58383,"party-mode":59386,pause:57396,"pause-circle-filled":57397,"pause-circle-outline":57398,payment:59553,people:59387,"people-outline":59388,"perm-camera-mic":59554,"perm-contact-calendar":59555,"perm-data-setting":59556,"perm-device-information":59557,"perm-identity":59558,"perm-media":59559,"perm-phone-msg":59560,"perm-scan-wifi":59561,person:59389,"person-add":59390,"person-outline":59391,"person-pin":58714,"person-pin-circle":58730,"personal-video":58939,pets:59677,phone:57549,"phone-android":58148,"phone-bluetooth-speaker":58907,"phone-forwarded":58908,"phone-in-talk":58909,"phone-iphone":58149,"phone-locked":58910,"phone-missed":58911,"phone-paused":58912,phonelink:58150,"phonelink-erase":57563,"phonelink-lock":57564,"phonelink-off":58151,"phonelink-ring":57565,"phonelink-setup":57566,photo:58384,"photo-album":58385,"photo-camera":58386,"photo-filter":58427,"photo-library":58387,"photo-size-select-actual":58418,"photo-size-select-large":58419,"photo-size-select-small":58420,"picture-as-pdf":58389,"picture-in-picture":59562,"picture-in-picture-alt":59665,"pie-chart":59076,"pie-chart-outlined":59077,"pin-drop":58718,place:58719,"play-arrow":57399,"play-circle-filled":57400,"play-circle-outline":57401,"play-for-work":59654,"playlist-add":57403,"playlist-add-check":57445,"playlist-play":57439,"plus-one":59392,poll:59393,polymer:59563,pool:60232,"portable-wifi-off":57550,portrait:58390,power:58940,"power-input":58166,"power-settings-new":59564,"pregnant-woman":59678,"present-to-all":57567,print:59565,"priority-high":58949,public:59403,publish:57941,"query-builder":59566,"question-answer":59567,queue:57404,"queue-music":57405,"queue-play-next":57446,radio:57406,"radio-button-checked":59447,"radio-button-unchecked":59446,"rate-review":58720,receipt:59568,"recent-actors":57407,"record-voice-over":59679,redeem:59569,redo:57690,refresh:58837,remove:57691,"remove-circle":57692,"remove-circle-outline":57693,"remove-from-queue":57447,"remove-red-eye":58391,"remove-shopping-cart":59688,reorder:59646,repeat:57408,"repeat-one":57409,replay:57410,"replay-10":57433,"replay-30":57434,"replay-5":57435,reply:57694,"reply-all":57695,report:57696,"report-problem":59570,restaurant:58732,"restaurant-menu":58721,restore:59571,"restore-page":59689,"ring-volume":57553,room:59572,"room-service":60233,"rotate-90-degrees-ccw":58392,"rotate-left":58393,"rotate-right":58394,"rounded-corner":59680,router:58152,rowing:59681,"rss-feed":57573,"rv-hookup":58946,satellite:58722,save:57697,scanner:58153,schedule:59573,school:59404,"screen-lock-landscape":57790,"screen-lock-portrait":57791,"screen-lock-rotation":57792,"screen-rotation":57793,"screen-share":57570,"sd-card":58915,"sd-storage":57794,search:59574,security:58154,"select-all":57698,send:57699,"sentiment-dissatisfied":59409,"sentiment-neutral":59410,"sentiment-satisfied":59411,"sentiment-very-dissatisfied":59412,"sentiment-very-satisfied":59413,settings:59576,"settings-applications":59577,"settings-backup-restore":59578,"settings-bluetooth":59579,"settings-brightness":59581,"settings-cell":59580,"settings-ethernet":59582,"settings-input-antenna":59583,"settings-input-component":59584,"settings-input-composite":59585,"settings-input-hdmi":59586,"settings-input-svideo":59587,"settings-overscan":59588,"settings-phone":59589,"settings-power":59590,"settings-remote":59591,"settings-system-daydream":57795,"settings-voice":59592,share:59405,shop:59593,"shop-two":59594,"shopping-basket":59595,"shopping-cart":59596,"short-text":57953,"show-chart":59105,shuffle:57411,"signal-cellular-4-bar":57800,"signal-cellular-connected-no-internet-4-bar":57805,"signal-cellular-no-sim":57806,"signal-cellular-null":57807,"signal-cellular-off":57808,"signal-wifi-4-bar":57816,"signal-wifi-4-bar-lock":57817,"signal-wifi-off":57818,"sim-card":58155,"sim-card-alert":58916,"skip-next":57412,"skip-previous":57413,slideshow:58395,"slow-motion-video":57448,smartphone:58156,"smoke-free":60234,"smoking-rooms":60235,sms:58917,"sms-failed":58918,snooze:57414,sort:57700,"sort-by-alpha":57427,spa:60236,"space-bar":57942,speaker:58157,"speaker-group":58158,"speaker-notes":59597,"speaker-notes-off":59690,"speaker-phone":57554,spellcheck:59598,star:59448,"star-border":59450,"star-half":59449,stars:59600,"stay-current-landscape":57555,"stay-current-portrait":57556,"stay-primary-landscape":57557,"stay-primary-portrait":57558,stop:57415,"stop-screen-share":57571,storage:57819,store:59601,"store-mall-directory":58723,straighten:58396,streetview:58734,"strikethrough-s":57943,style:58397,"subdirectory-arrow-left":58841,"subdirectory-arrow-right":58842,subject:59602,subscriptions:57444,subtitles:57416,subway:58735,"supervisor-account":59603,"surround-sound":57417,"swap-calls":57559,"swap-horiz":59604,"swap-vert":59605,"swap-vertical-circle":59606,"switch-camera":58398,"switch-video":58399,sync:58919,"sync-disabled":58920,"sync-problem":58921,"system-update":58922,"system-update-alt":59607,tab:59608,"tab-unselected":59609,tablet:58159,"tablet-android":58160,"tablet-mac":58161,"tag-faces":58400,"tap-and-play":58923,terrain:58724,"text-fields":57954,"text-format":57701,textsms:57560,texture:58401,theaters:59610,"thumb-down":59611,"thumb-up":59612,"thumbs-up-down":59613,"time-to-leave":58924,timelapse:58402,timeline:59682,timer:58405,"timer-10":58403,"timer-3":58404,"timer-off":58406,title:57956,toc:59614,today:59615,toll:59616,tonality:58407,"touch-app":59667,toys:58162,"track-changes":59617,traffic:58725,train:58736,tram:58737,"transfer-within-a-station":58738,transform:58408,translate:59618,"trending-down":59619,"trending-flat":59620,"trending-up":59621,tune:58409,"turned-in":59622,"turned-in-not":59623,tv:58163,unarchive:57705,undo:57702,"unfold-less":58838,"unfold-more":58839,update:59683,usb:57824,"verified-user":59624,"vertical-align-bottom":57944,"vertical-align-center":57945,"vertical-align-top":57946,vibration:58925,"video-call":57456,"video-label":57457,"video-library":57418,videocam:57419,"videocam-off":57420,"videogame-asset":58168,"view-agenda":59625,"view-array":59626,"view-carousel":59627,"view-column":59628,"view-comfy":58410,"view-compact":58411,"view-day":59629,"view-headline":59630,"view-list":59631,"view-module":59632,"view-quilt":59633,"view-stream":59634,"view-week":59635,vignette:58421,visibility:59636,"visibility-off":59637,"voice-chat":58926,voicemail:57561,"volume-down":57421,"volume-mute":57422,"volume-off":57423,"volume-up":57424,"vpn-key":57562,"vpn-lock":58927,wallpaper:57788,warning:57346,watch:58164,"watch-later":59684,"wb-auto":58412,"wb-cloudy":58413,"wb-incandescent":58414,"wb-iridescent":58422,"wb-sunny":58416,wc:58941,web:57425,"web-asset":57449,weekend:57707,whatshot:59406,widgets:57789,wifi:58942,"wifi-lock":57825,"wifi-tethering":57826,work:59641,"wrap-text":57947,"youtube-searched-for":59642,"zoom-in":59647,"zoom-out":59648,"zoom-out-map":58731}},function(e){e.exports={"access-point":61442,"access-point-network":61443,account:61444,"account-alert":61445,"account-box":61446,"account-box-multiple":63795,"account-box-outline":61447,"account-card-details":62930,"account-check":61448,"account-child":64136,"account-child-circle":64137,"account-circle":61449,"account-convert":61450,"account-details":63025,"account-edit":63163,"account-group":63560,"account-heart":63640,"account-key":61451,"account-location":61452,"account-minus":61453,"account-minus-outline":64235,"account-multiple":61454,"account-multiple-check":63684,"account-multiple-minus":62931,"account-multiple-outline":61455,"account-multiple-plus":61456,"account-multiple-plus-outline":63487,"account-network":61457,"account-off":61458,"account-outline":61459,"account-plus":61460,"account-plus-outline":63488,"account-remove":61461,"account-remove-outline":64236,"account-search":61462,"account-search-outline":63796,"account-settings":63024,"account-star":61463,"account-supervisor":64138,"account-supervisor-circle":64139,"account-switch":61465,accusoft:63561,adjust:61466,adobe:63797,"air-conditioner":61467,airballoon:61468,airplane:61469,"airplane-landing":62932,"airplane-off":61470,"airplane-takeoff":62933,airplay:61471,airport:63562,alarm:61472,"alarm-bell":63373,"alarm-check":61473,"alarm-light":63374,"alarm-multiple":61474,"alarm-off":61475,"alarm-plus":61476,"alarm-snooze":63117,album:61477,alert:61478,"alert-box":61479,"alert-circle":61480,"alert-circle-outline":62934,"alert-decagram":63164,"alert-octagon":61481,"alert-octagram":63334,"alert-outline":61482,alien:63641,"all-inclusive":63165,alpha:61483,"alpha-a":65,"alpha-a-box":64237,"alpha-b":66,"alpha-b-box":64238,"alpha-c":67,"alpha-c-box":64239,"alpha-d":68,"alpha-d-box":64240,"alpha-e":69,"alpha-e-box":64241,"alpha-f":70,"alpha-f-box":64242,"alpha-g":71,"alpha-g-box":64243,"alpha-h":72,"alpha-h-box":64244,"alpha-i":73,"alpha-i-box":64245,"alpha-j":74,"alpha-j-box":64246,"alpha-k":75,"alpha-k-box":64247,"alpha-l":76,"alpha-l-box":64248,"alpha-m":77,"alpha-m-box":64249,"alpha-n":78,"alpha-n-box":64250,"alpha-o":79,"alpha-o-box":64251,"alpha-p":80,"alpha-p-box":64252,"alpha-q":81,"alpha-q-box":64253,"alpha-r":82,"alpha-r-box":64254,"alpha-s":83,"alpha-s-box":64255,"alpha-t":84,"alpha-t-box":64256,"alpha-u":85,"alpha-u-box":64257,"alpha-v":86,"alpha-v-box":64258,"alpha-w":87,"alpha-w-box":64259,"alpha-x":88,"alpha-x-box":64260,"alpha-y":89,"alpha-y-box":64261,"alpha-z":90,"alpha-z-box":64262,alphabetical:61484,altimeter:62935,amazon:61485,"amazon-alexa":63685,"amazon-drive":61486,ambulance:61487,ampersand:64140,amplifier:61488,anchor:61489,android:61490,"android-auto":64141,"android-debug-bridge":61491,"android-head":63375,"android-studio":61492,"angle-acute":63798,"angle-obtuse":63799,"angle-right":63800,angular:63153,angularjs:63166,animation:62936,"animation-outline":64142,"animation-play":63801,"animation-play-outline":64143,anvil:63642,apple:61493,"apple-finder":61494,"apple-icloud":61496,"apple-ios":61495,"apple-keyboard-caps":63026,"apple-keyboard-command":63027,"apple-keyboard-control":63028,"apple-keyboard-option":63029,"apple-keyboard-shift":63030,"apple-safari":61497,application:62996,apps:61499,arch:63686,archive:61500,"arrange-bring-forward":61501,"arrange-bring-to-front":61502,"arrange-send-backward":61503,"arrange-send-to-back":61504,"arrow-all":61505,"arrow-bottom-left":61506,"arrow-bottom-left-bold-outline":63926,"arrow-bottom-left-thick":63927,"arrow-bottom-right":61507,"arrow-bottom-right-bold-outline":63928,"arrow-bottom-right-thick":63929,"arrow-collapse":62997,"arrow-collapse-all":61508,"arrow-collapse-down":63377,"arrow-collapse-horizontal":63563,"arrow-collapse-left":63378,"arrow-collapse-right":63379,"arrow-collapse-up":63380,"arrow-collapse-vertical":63564,"arrow-decision":63930,"arrow-decision-auto":63931,"arrow-decision-auto-outline":63932,"arrow-decision-outline":63933,"arrow-down":61509,"arrow-down-bold":63277,"arrow-down-bold-box":63278,"arrow-down-bold-box-outline":63279,"arrow-down-bold-circle":61511,"arrow-down-bold-circle-outline":61512,"arrow-down-bold-hexagon-outline":61513,"arrow-down-bold-outline":63934,"arrow-down-box":63167,"arrow-down-drop-circle":61514,"arrow-down-drop-circle-outline":61515,"arrow-down-thick":61510,"arrow-expand":62998,"arrow-expand-all":61516,"arrow-expand-down":63381,"arrow-expand-horizontal":63565,"arrow-expand-left":63382,"arrow-expand-right":63383,"arrow-expand-up":63384,"arrow-expand-vertical":63566,"arrow-left":61517,"arrow-left-bold":63280,"arrow-left-bold-box":63281,"arrow-left-bold-box-outline":63282,"arrow-left-bold-circle":61519,"arrow-left-bold-circle-outline":61520,"arrow-left-bold-hexagon-outline":61521,"arrow-left-bold-outline":63935,"arrow-left-box":63168,"arrow-left-drop-circle":61522,"arrow-left-drop-circle-outline":61523,"arrow-left-right-bold-outline":63936,"arrow-left-thick":61518,"arrow-right":61524,"arrow-right-bold":63283,"arrow-right-bold-box":63284,"arrow-right-bold-box-outline":63285,"arrow-right-bold-circle":61526,"arrow-right-bold-circle-outline":61527,"arrow-right-bold-hexagon-outline":61528,"arrow-right-bold-outline":63937,"arrow-right-box":63169,"arrow-right-drop-circle":61529,"arrow-right-drop-circle-outline":61530,"arrow-right-thick":61525,"arrow-split-horizontal":63802,"arrow-split-vertical":63803,"arrow-top-left":61531,"arrow-top-left-bold-outline":63938,"arrow-top-left-thick":63939,"arrow-top-right":61532,"arrow-top-right-bold-outline":63940,"arrow-top-right-thick":63941,"arrow-up":61533,"arrow-up-bold":63286,"arrow-up-bold-box":63287,"arrow-up-bold-box-outline":63288,"arrow-up-bold-circle":61535,"arrow-up-bold-circle-outline":61536,"arrow-up-bold-hexagon-outline":61537,"arrow-up-bold-outline":63942,"arrow-up-box":63170,"arrow-up-down-bold-outline":63943,"arrow-up-drop-circle":61538,"arrow-up-drop-circle-outline":61539,"arrow-up-thick":61534,artist:63490,"aspect-ratio":64035,assistant:61540,asterisk:63171,at:61541,atlassian:63491,atom:63335,attachment:61542,"audio-video":63804,audiobook:61543,"augmented-reality":63567,"auto-fix":61544,"auto-upload":61545,autorenew:61546,"av-timer":61547,axe:63687,azure:63492,babel:64036,baby:61548,"baby-buggy":63118,backburger:61549,backspace:61550,"backup-restore":61551,badminton:63568,balloon:64037,ballot:63944,"ballot-outline":63945,bandcamp:63092,bank:61552,"bank-transfer":64038,"bank-transfer-in":64039,"bank-transfer-out":64040,barcode:61553,"barcode-scan":61554,barley:61555,barrel:61556,baseball:63569,"baseball-bat":63570,basecamp:61557,basket:61558,"basket-fill":61559,"basket-unfill":61560,basketball:63493,battery:61561,"battery-10":61562,"battery-10-bluetooth":63805,"battery-20":61563,"battery-20-bluetooth":63806,"battery-30":61564,"battery-30-bluetooth":63807,"battery-40":61565,"battery-40-bluetooth":63808,"battery-50":61566,"battery-50-bluetooth":63809,"battery-60":61567,"battery-60-bluetooth":63810,"battery-70":61568,"battery-70-bluetooth":63811,"battery-80":61569,"battery-80-bluetooth":63812,"battery-90":61570,"battery-90-bluetooth":63813,"battery-alert":61571,"battery-alert-bluetooth":63814,"battery-bluetooth":63815,"battery-bluetooth-variant":63816,"battery-charging":61572,"battery-charging-10":63643,"battery-charging-100":61573,"battery-charging-20":61574,"battery-charging-30":61575,"battery-charging-40":61576,"battery-charging-50":63644,"battery-charging-60":61577,"battery-charging-70":63645,"battery-charging-80":61578,"battery-charging-90":61579,"battery-charging-outline":63646,"battery-charging-wireless":63494,"battery-charging-wireless-10":63495,"battery-charging-wireless-20":63496,"battery-charging-wireless-30":63497,"battery-charging-wireless-40":63498,"battery-charging-wireless-50":63499,"battery-charging-wireless-60":63500,"battery-charging-wireless-70":63501,"battery-charging-wireless-80":63502,"battery-charging-wireless-90":63503,"battery-charging-wireless-alert":63504,"battery-charging-wireless-outline":63505,"battery-minus":61580,"battery-negative":61581,"battery-outline":61582,"battery-plus":61583,"battery-positive":61584,"battery-unknown":61585,"battery-unknown-bluetooth":63817,beach:61586,beaker:63119,beats:61591,"bed-empty":63647,beer:61592,behance:61593,bell:61594,"bell-off":61595,"bell-off-outline":64144,"bell-outline":61596,"bell-plus":61597,"bell-plus-outline":64145,"bell-ring":61598,"bell-ring-outline":61599,"bell-sleep":61600,"bell-sleep-outline":64146,beta:61601,betamax:63946,bible:61602,bike:61603,bing:61604,binoculars:61605,bio:61606,biohazard:61607,bitbucket:61608,bitcoin:63506,"black-mesa":61609,blackberry:61610,blender:61611,blinds:61612,"block-helper":61613,blogger:61614,bluetooth:61615,"bluetooth-audio":61616,"bluetooth-connect":61617,"bluetooth-off":61618,"bluetooth-settings":61619,"bluetooth-transfer":61620,blur:61621,"blur-linear":61622,"blur-off":61623,"blur-radial":61624,bomb:63120,"bomb-off":63172,bone:61625,book:61626,"book-lock":63385,"book-lock-open":63386,"book-minus":62937,"book-multiple":61627,"book-multiple-minus":64147,"book-multiple-plus":64148,"book-multiple-remove":64149,"book-multiple-variant":61628,"book-open":61629,"book-open-page-variant":62938,"book-open-variant":61630,"book-plus":62939,"book-remove":64150,"book-variant":61631,bookmark:61632,"bookmark-check":61633,"bookmark-minus":63947,"bookmark-minus-outline":63948,"bookmark-music":61634,"bookmark-off":63949,"bookmark-off-outline":63950,"bookmark-outline":61635,"bookmark-plus":61637,"bookmark-plus-outline":61636,"bookmark-remove":61638,boombox:62940,bootstrap:63173,"border-all":61639,"border-all-variant":63648,"border-bottom":61640,"border-bottom-variant":63649,"border-color":61641,"border-horizontal":61642,"border-inside":61643,"border-left":61644,"border-left-variant":63650,"border-none":61645,"border-none-variant":63651,"border-outside":61646,"border-right":61647,"border-right-variant":63652,"border-style":61648,"border-top":61649,"border-top-variant":63653,"border-vertical":61650,"bottle-wine":63571,"bow-tie":63095,bowl:62999,bowling:61651,box:61652,"box-cutter":61653,"box-shadow":63031,braille:63951,brain:63952,bridge:63e3,briefcase:61654,"briefcase-check":61655,"briefcase-download":61656,"briefcase-edit":64151,"briefcase-minus":64041,"briefcase-outline":63507,"briefcase-plus":64042,"briefcase-remove":64043,"briefcase-search":64044,"briefcase-upload":61657,"brightness-1":61658,"brightness-2":61659,"brightness-3":61660,"brightness-4":61661,"brightness-5":61662,"brightness-6":61663,"brightness-7":61664,"brightness-auto":61665,broom:61666,brush:61667,buddhism:63818,buffer:63001,bug:61668,"bug-check":64045,"bug-check-outline":64046,"bug-outline":64047,bulldozer:64263,"bulletin-board":61669,bullhorn:61670,"bullhorn-outline":64264,bullseye:62941,"bullseye-arrow":63688,bus:61671,"bus-alert":64152,"bus-articulated-end":63387,"bus-articulated-front":63388,"bus-clock":63689,"bus-double-decker":63389,"bus-school":63390,"bus-side":63391,cached:61672,cake:61673,"cake-layered":61674,"cake-variant":61675,calculator:61676,"calculator-variant":64153,calendar:61677,"calendar-alert":64048,"calendar-blank":61678,"calendar-check":61679,"calendar-clock":61680,"calendar-edit":63654,"calendar-export":64265,"calendar-heart":63953,"calendar-import":64266,"calendar-multiple":61681,"calendar-multiple-check":61682,"calendar-multiselect":64049,"calendar-plus":61683,"calendar-question":63121,"calendar-range":63096,"calendar-remove":61684,"calendar-search":63819,"calendar-star":63954,"calendar-text":61685,"calendar-today":61686,"calendar-week":64050,"calendar-week-begin":64051,"call-made":61687,"call-merge":61688,"call-missed":61689,"call-received":61690,"call-split":61691,camcorder:61692,"camcorder-box":61693,"camcorder-box-off":61694,"camcorder-off":61695,camera:61696,"camera-account":63690,"camera-burst":63122,"camera-enhance":61697,"camera-front":61698,"camera-front-variant":61699,"camera-gopro":63392,"camera-image":63691,"camera-iris":61700,"camera-metering-center":63393,"camera-metering-matrix":63394,"camera-metering-partial":63395,"camera-metering-spot":63396,"camera-off":62943,"camera-party-mode":61701,"camera-rear":61702,"camera-rear-variant":61703,"camera-switch":61704,"camera-timer":61705,cancel:63289,candle:62946,candycane:61706,cannabis:63397,"caps-lock":64154,car:61707,"car-battery":61708,"car-connected":61709,"car-convertible":63398,"car-estate":63399,"car-hatchback":63400,"car-limousine":63692,"car-pickup":63401,"car-side":63402,"car-sports":63403,"car-wash":61710,caravan:63404,cards:63032,"cards-club":63693,"cards-diamond":63694,"cards-heart":63695,"cards-outline":63033,"cards-playing-outline":63034,"cards-spade":63696,"cards-variant":63174,carrot:61711,cart:61712,"cart-off":63083,"cart-outline":61713,"cart-plus":61714,"case-sensitive-alt":61715,cash:61716,"cash-100":61717,"cash-multiple":61718,"cash-refund":64155,"cash-usd":61719,cassette:63955,cast:61720,"cast-connected":61721,"cast-off":63369,castle:61722,cat:61723,cctv:63405,"ceiling-light":63336,cellphone:61724,"cellphone-android":61725,"cellphone-arrow-down":63956,"cellphone-basic":61726,"cellphone-dock":61727,"cellphone-erase":63820,"cellphone-iphone":61728,"cellphone-key":63821,"cellphone-link":61729,"cellphone-link-off":61730,"cellphone-lock":63822,"cellphone-message":63698,"cellphone-off":63823,"cellphone-screenshot":64052,"cellphone-settings":61731,"cellphone-settings-variant":63824,"cellphone-sound":63825,"cellphone-text":63697,"cellphone-wireless":63508,certificate:61732,"chair-school":61733,"chart-arc":61734,"chart-areaspline":61735,"chart-bar":61736,"chart-bar-stacked":63337,"chart-bubble":62947,"chart-donut":63406,"chart-donut-variant":63407,"chart-gantt":63084,"chart-histogram":61737,"chart-line":61738,"chart-line-stacked":63338,"chart-line-variant":63408,"chart-multiline":63699,"chart-pie":61739,"chart-scatterplot-hexbin":63085,"chart-timeline":63086,check:61740,"check-all":61741,"check-circle":62944,"check-circle-outline":62945,"check-decagram":63376,"check-outline":63572,checkbook:64156,"checkbox-blank":61742,"checkbox-blank-circle":61743,"checkbox-blank-circle-outline":61744,"checkbox-blank-outline":61745,"checkbox-intermediate":63573,"checkbox-marked":61746,"checkbox-marked-circle":61747,"checkbox-marked-circle-outline":61748,"checkbox-marked-outline":61749,"checkbox-multiple-blank":61750,"checkbox-multiple-blank-circle":63035,"checkbox-multiple-blank-circle-outline":63036,"checkbox-multiple-blank-outline":61751,"checkbox-multiple-marked":61752,"checkbox-multiple-marked-circle":63037,"checkbox-multiple-marked-circle-outline":63038,"checkbox-multiple-marked-outline":61753,checkerboard:61754,"chemical-weapon":61755,"chess-bishop":63579,"chess-king":63574,"chess-knight":63575,"chess-pawn":63576,"chess-queen":63577,"chess-rook":63578,"chevron-double-down":61756,"chevron-double-left":61757,"chevron-double-right":61758,"chevron-double-up":61759,"chevron-down":61760,"chevron-down-box":63957,"chevron-down-box-outline":63958,"chevron-down-circle":64267,"chevron-down-circle-outline":64268,"chevron-left":61761,"chevron-left-box":63959,"chevron-left-box-outline":63960,"chevron-left-circle":64269,"chevron-left-circle-outline":64270,"chevron-right":61762,"chevron-right-box":63961,"chevron-right-box-outline":63962,"chevron-right-circle":64271,"chevron-right-circle-outline":64272,"chevron-up":61763,"chevron-up-box":63963,"chevron-up-box-outline":63964,"chevron-up-circle":64273,"chevron-up-circle-outline":64274,"chili-hot":63409,"chili-medium":63410,"chili-mild":63411,chip:63002,christianity:63826,church:61764,circle:63332,"circle-edit-outline":63700,"circle-medium":63965,"circle-outline":63333,"circle-slice-1":64157,"circle-slice-2":64158,"circle-slice-3":64159,"circle-slice-4":64160,"circle-slice-5":64161,"circle-slice-6":64162,"circle-slice-7":64163,"circle-slice-8":64164,"circle-small":63966,"cisco-webex":61765,city:61766,"city-variant":64053,"city-variant-outline":64054,clipboard:61767,"clipboard-account":61768,"clipboard-alert":61769,"clipboard-arrow-down":61770,"clipboard-arrow-left":61771,"clipboard-check":61772,"clipboard-check-outline":63655,"clipboard-flow":63175,"clipboard-outline":61773,"clipboard-plus":63312,"clipboard-pulse":63580,"clipboard-pulse-outline":63581,"clipboard-text":61774,"clipboard-text-outline":64055,clippy:61775,clock:63827,"clock-alert":63828,"clock-alert-outline":62926,"clock-end":61777,"clock-fast":61778,"clock-in":61779,"clock-out":61780,"clock-outline":61776,"clock-start":61781,close:61782,"close-box":61783,"close-box-outline":61784,"close-circle":61785,"close-circle-outline":61786,"close-network":61787,"close-octagon":61788,"close-octagon-outline":61789,"close-outline":63176,"closed-caption":61790,cloud:61791,"cloud-alert":63967,"cloud-braces":63412,"cloud-check":61792,"cloud-circle":61793,"cloud-download":61794,"cloud-off-outline":61796,"cloud-outline":61795,"cloud-print":61797,"cloud-print-outline":61798,"cloud-question":64056,"cloud-search":63829,"cloud-search-outline":63830,"cloud-sync":63039,"cloud-tags":63413,"cloud-upload":61799,clover:63509,"code-array":61800,"code-braces":61801,"code-brackets":61802,"code-equal":61803,"code-greater-than":61804,"code-greater-than-or-equal":61805,"code-less-than":61806,"code-less-than-or-equal":61807,"code-not-equal":61808,"code-not-equal-variant":61809,"code-parentheses":61810,"code-string":61811,"code-tags":61812,"code-tags-check":63123,codepen:61813,coffee:61814,"coffee-outline":63177,"coffee-to-go":61815,cogs:63701,coin:61816,coins:63124,collage:63040,"collapse-all":64165,"collapse-all-outline":64166,"color-helper":61817,comment:61818,"comment-account":61819,"comment-account-outline":61820,"comment-alert":61821,"comment-alert-outline":61822,"comment-arrow-left":63968,"comment-arrow-left-outline":63969,"comment-arrow-right":63970,"comment-arrow-right-outline":63971,"comment-check":61823,"comment-check-outline":61824,"comment-eye":64057,"comment-eye-outline":64058,"comment-multiple":63582,"comment-multiple-outline":61825,"comment-outline":61826,"comment-plus":63972,"comment-plus-outline":61827,"comment-processing":61828,"comment-processing-outline":61829,"comment-question":63510,"comment-question-outline":61830,"comment-remove":62942,"comment-remove-outline":61831,"comment-search":64059,"comment-search-outline":64060,"comment-text":61832,"comment-text-multiple":63583,"comment-text-multiple-outline":63584,"comment-text-outline":61833,compare:61834,compass:61835,"compass-outline":61836,console:61837,"console-line":63414,"console-network":63656,"contact-mail":61838,contacts:63178,contain:64061,"contain-end":64062,"contain-start":64063,"content-copy":61839,"content-cut":61840,"content-duplicate":61841,"content-paste":61842,"content-save":61843,"content-save-all":61844,"content-save-outline":63511,"content-save-settings":63003,"content-save-settings-outline":64275,contrast:61845,"contrast-box":61846,"contrast-circle":61847,cookie:61848,copyright:62950,cordova:63831,corn:63415,counter:61849,cow:61850,crane:63585,creation:61897,"credit-card":61851,"credit-card-multiple":61852,"credit-card-off":62948,"credit-card-plus":63093,"credit-card-refund":64167,"credit-card-scan":61853,"credit-card-settings":63702,crop:61854,"crop-free":61855,"crop-landscape":61856,"crop-portrait":61857,"crop-rotate":63125,"crop-square":61858,crosshairs:61859,"crosshairs-gps":61860,crown:61861,cryengine:63832,"crystal-ball":64276,cube:61862,"cube-outline":61863,"cube-send":61864,"cube-unfolded":61865,cup:61866,"cup-off":62949,"cup-water":61867,cupcake:63833,curling:63586,"currency-bdt":63587,"currency-btc":61868,"currency-chf":63416,"currency-cny":63417,"currency-eth":63418,"currency-eur":61869,"currency-gbp":61870,"currency-inr":61871,"currency-jpy":63419,"currency-krw":63420,"currency-kzt":63588,"currency-ngn":61872,"currency-php":63973,"currency-rub":61873,"currency-sign":63421,"currency-try":61874,"currency-twd":63422,"currency-usd":61875,"currency-usd-off":63097,"current-ac":63834,"current-dc":63835,"cursor-default":61876,"cursor-default-outline":61877,"cursor-move":61878,"cursor-pointer":61879,"cursor-text":62951,database:61880,"database-check":64168,"database-export":63837,"database-import":63836,"database-lock":64169,"database-minus":61881,"database-plus":61882,"database-search":63589,"death-star":63703,"death-star-variant":63704,debian:63705,"debug-step-into":61883,"debug-step-out":61884,"debug-step-over":61885,decagram:63339,"decagram-outline":63340,"decimal-decrease":61886,"decimal-increase":61887,delete:61888,"delete-circle":63106,"delete-empty":63179,"delete-forever":62952,"delete-outline":63974,"delete-restore":63512,"delete-sweep":62953,"delete-variant":61889,delta:61890,"desk-lamp":63838,deskphone:61891,"desktop-classic":63423,"desktop-mac":61892,"desktop-mac-dashboard":63975,"desktop-tower":61893,"desktop-tower-monitor":64170,details:61894,"developer-board":63126,deviantart:61895,dialpad:63004,diamond:61896,"dice-1":61898,"dice-2":61899,"dice-3":61900,"dice-4":61901,"dice-5":61902,"dice-6":61903,"dice-d10":63342,"dice-d12":63590,"dice-d20":62954,"dice-d4":62955,"dice-d6":62956,"dice-d8":62957,"dice-multiple":63341,dictionary:63005,"dip-switch":63424,directions:61904,"directions-fork":63041,disc:62958,"disc-alert":61905,"disc-player":63839,discord:63087,dishwasher:64171,disqus:61906,"disqus-outline":61907,division:61908,"division-box":61909,dlna:64064,dna:63107,dns:61910,"do-not-disturb":63127,"do-not-disturb-off":63128,docker:63591,doctor:64065,dog:64066,"dog-service":64172,"dog-side":64067,dolby:63154,domain:61911,donkey:63425,door:63513,"door-closed":63514,"door-open":63515,"doorbell-video":63592,"dot-net":64173,"dots-horizontal":61912,"dots-horizontal-circle":63426,"dots-vertical":61913,"dots-vertical-circle":63427,douban:63129,download:61914,"download-multiple":63976,"download-network":63219,drag:61915,"drag-horizontal":61916,"drag-vertical":61917,drawing:61918,"drawing-box":61919,dribbble:61920,"dribbble-box":61921,drone:61922,dropbox:61923,drupal:61924,duck:61925,dumbbell:61926,"ear-hearing":63428,"ear-hearing-off":64068,earth:61927,"earth-box":63180,"earth-box-off":63181,"earth-off":61928,edge:61929,egg:64174,"egg-easter":64175,"eight-track":63977,eject:61930,elephant:63429,"elevation-decline":61931,"elevation-rise":61932,elevator:61933,email:61934,"email-alert":63182,"email-check":64176,"email-check-outline":64177,"email-lock":61937,"email-open":61935,"email-open-outline":62959,"email-outline":61936,"email-plus":63978,"email-plus-outline":63979,"email-search":63840,"email-search-outline":63841,"email-variant":62960,ember:64277,emby:63155,emoticon:61938,"emoticon-cool":61939,"emoticon-dead":63130,"emoticon-devil":61940,"emoticon-excited":63131,"emoticon-happy":61941,"emoticon-neutral":61942,"emoticon-poop":61943,"emoticon-sad":61944,"emoticon-tongue":61945,engine:61946,"engine-off":64069,"engine-off-outline":64070,"engine-outline":61947,equal:61948,"equal-box":61949,eraser:61950,"eraser-variant":63042,escalator:61951,et:64178,ethereum:63593,ethernet:61952,"ethernet-cable":61953,"ethernet-cable-off":61954,etsy:61955,"ev-station":62961,eventbrite:63430,evernote:61956,exclamation:61957,"exit-run":64071,"exit-to-app":61958,"expand-all":64179,"expand-all-outline":64180,exponent:63842,"exponent-box":63843,export:61959,eye:61960,"eye-off":61961,"eye-off-outline":63184,"eye-outline":63183,"eye-plus":63594,"eye-plus-outline":63595,"eye-settings":63596,"eye-settings-outline":63597,eyedropper:61962,"eyedropper-variant":61963,face:63043,"face-profile":63044,facebook:61964,"facebook-box":61965,"facebook-messenger":61966,"facebook-workplace":64278,factory:61967,fan:61968,"fan-off":63516,"fast-forward":61969,"fast-forward-outline":63185,fax:61970,feather:63186,"feature-search":64072,"feature-search-outline":64073,fedora:63706,ferry:61971,file:61972,"file-account":63290,"file-alert":64074,"file-alert-outline":64075,"file-cabinet":64181,"file-chart":61973,"file-check":61974,"file-cloud":61975,"file-compare":63657,"file-delimited":61976,"file-document":61977,"file-document-box":61978,"file-document-box-multiple":64182,"file-document-box-multiple-outline":64183,"file-document-box-outline":63980,"file-document-outline":63981,"file-download":63844,"file-download-outline":63845,"file-excel":61979,"file-excel-box":61980,"file-export":61981,"file-find":61982,"file-hidden":62995,"file-image":61983,"file-import":61984,"file-lock":61985,"file-move":64184,"file-multiple":61986,"file-music":61987,"file-outline":61988,"file-pdf":61989,"file-pdf-box":61990,"file-percent":63517,"file-plus":63313,"file-powerpoint":61991,"file-powerpoint-box":61992,"file-presentation-box":61993,"file-question":63598,"file-replace":64279,"file-replace-outline":64280,"file-restore":63088,"file-send":61994,"file-tree":63045,"file-undo":63707,"file-upload":64076,"file-upload-outline":64077,"file-video":61995,"file-word":61996,"file-word-box":61997,"file-xml":61998,film:61999,filmstrip:62e3,"filmstrip-off":62001,filter:62002,"filter-outline":62003,"filter-remove":62004,"filter-remove-outline":62005,"filter-variant":62006,finance:63518,"find-replace":63187,fingerprint:62007,fire:62008,"fire-truck":63658,firebase:63846,firefox:62009,fish:62010,flag:62011,"flag-checkered":62012,"flag-outline":62013,"flag-triangle":62015,"flag-variant":62016,"flag-variant-outline":62014,flash:62017,"flash-auto":62018,"flash-circle":63519,"flash-off":62019,"flash-outline":63188,"flash-red-eye":63098,flashlight:62020,"flashlight-off":62021,flask:61587,"flask-empty":61588,"flask-empty-outline":61589,"flask-outline":61590,flattr:62022,"flip-to-back":62023,"flip-to-front":62024,"floor-lamp":63708,"floor-plan":63520,floppy:62025,"floppy-variant":63982,flower:62026,"flower-outline":63983,"flower-tulip":63984,"flower-tulip-outline":63985,folder:62027,"folder-account":62028,"folder-clock":64185,"folder-clock-outline":64186,"folder-download":62029,"folder-edit":63709,"folder-google-drive":62030,"folder-image":62031,"folder-key":63659,"folder-key-network":63660,"folder-lock":62032,"folder-lock-open":62033,"folder-move":62034,"folder-multiple":62035,"folder-multiple-image":62036,"folder-multiple-outline":62037,"folder-network":63599,"folder-open":63343,"folder-outline":62038,"folder-plus":62039,"folder-remove":62040,"folder-search":63847,"folder-search-outline":63848,"folder-star":63132,"folder-upload":62041,"font-awesome":61498,food:62042,"food-apple":62043,"food-croissant":63431,"food-fork-drink":62962,"food-off":62963,"food-variant":62044,football:62045,"football-australian":62046,"football-helmet":62047,forklift:63432,"format-align-bottom":63314,"format-align-center":62048,"format-align-justify":62049,"format-align-left":62050,"format-align-middle":63315,"format-align-right":62051,"format-align-top":63316,"format-annotation-minus":64187,"format-annotation-plus":63046,"format-bold":62052,"format-clear":62053,"format-color-fill":62054,"format-color-text":63133,"format-columns":63710,"format-float-center":62055,"format-float-left":62056,"format-float-none":62057,"format-float-right":62058,"format-font":63189,"format-font-size-decrease":63986,"format-font-size-increase":63987,"format-header-1":62059,"format-header-2":62060,"format-header-3":62061,"format-header-4":62062,"format-header-5":62063,"format-header-6":62064,"format-header-decrease":62065,"format-header-equal":62066,"format-header-increase":62067,"format-header-pound":62068,"format-horizontal-align-center":63006,"format-horizontal-align-left":63007,"format-horizontal-align-right":63008,"format-indent-decrease":62069,"format-indent-increase":62070,"format-italic":62071,"format-letter-case":64281,"format-letter-case-lower":64282,"format-letter-case-upper":64283,"format-line-spacing":62072,"format-line-style":62920,"format-line-weight":62921,"format-list-bulleted":62073,"format-list-bulleted-type":62074,"format-list-checkbox":63849,"format-list-checks":63317,"format-list-numbers":62075,"format-page-break":63190,"format-paint":62076,"format-paragraph":62077,"format-pilcrow":63191,"format-quote-close":62078,"format-quote-open":63318,"format-rotate-90":63145,"format-section":63134,"format-size":62079,"format-strikethrough":62080,"format-strikethrough-variant":62081,"format-subscript":62082,"format-superscript":62083,"format-text":62084,"format-textdirection-l-to-r":62085,"format-textdirection-r-to-l":62086,"format-title":62964,"format-underline":62087,"format-vertical-align-bottom":63009,"format-vertical-align-center":63010,"format-vertical-align-top":63011,"format-wrap-inline":62088,"format-wrap-square":62089,"format-wrap-tight":62090,"format-wrap-top-bottom":62091,forum:62092,"forum-outline":63521,forward:62093,fountain:63850,foursquare:62094,freebsd:63711,fridge:62095,"fridge-filled":62096,"fridge-filled-bottom":62097,"fridge-filled-top":62098,fuel:63433,fullscreen:62099,"fullscreen-exit":62100,function:62101,"function-variant":63600,gamepad:62102,"gamepad-variant":62103,garage:63192,"garage-alert":63601,"garage-open":63193,"gas-cylinder":63047,"gas-station":62104,gate:62105,"gate-and":63712,"gate-nand":63713,"gate-nor":63714,"gate-not":63715,"gate-or":63716,"gate-xnor":63717,"gate-xor":63718,gauge:62106,"gauge-empty":63602,"gauge-full":63603,"gauge-low":63604,gavel:62107,"gender-female":62108,"gender-male":62109,"gender-male-female":62110,"gender-transgender":62111,gentoo:63719,gesture:63434,"gesture-double-tap":63291,"gesture-pinch":64188,"gesture-spread":64189,"gesture-swipe-down":63292,"gesture-swipe-horizontal":64190,"gesture-swipe-left":63293,"gesture-swipe-right":63294,"gesture-swipe-up":63295,"gesture-swipe-vertical":64191,"gesture-tap":63296,"gesture-two-double-tap":63297,"gesture-two-tap":63298,ghost:62112,"ghost-off":63988,gift:62113,git:62114,"github-box":62115,"github-circle":62116,"github-face":63194,"glass-cocktail":62294,"glass-flute":62117,"glass-mug":62118,"glass-stange":62119,"glass-tulip":62120,"glass-wine":63605,glassdoor:62121,glasses:62122,"globe-model":63720,gmail:62123,gnome:62124,golf:63522,gondola:63109,google:62125,"google-allo":63489,"google-analytics":63435,"google-assistant":63436,"google-cardboard":62126,"google-chrome":62127,"google-circles":62128,"google-circles-communities":62129,"google-circles-extended":62130,"google-circles-group":62131,"google-controller":62132,"google-controller-off":62133,"google-drive":62134,"google-earth":62135,"google-fit":63851,"google-glass":62136,"google-hangouts":62153,"google-home":63523,"google-keep":63195,"google-lens":63989,"google-maps":62965,"google-nearby":62137,"google-pages":62138,"google-photos":63196,"google-physical-web":62139,"google-play":62140,"google-plus":62141,"google-plus-box":62142,"google-spreadsheet":63990,"google-translate":62143,"google-wallet":62144,gpu:63661,gradient:63135,graphql:63606,"grease-pencil":63048,"greater-than":63852,"greater-than-or-equal":63853,grid:62145,"grid-large":63319,"grid-off":62146,group:62147,"guitar-acoustic":63344,"guitar-electric":62148,"guitar-pick":62149,"guitar-pick-outline":62150,"guy-fawkes-mask":63524,hackernews:63012,hail:64192,hamburger:63108,hammer:63721,hand:64078,"hand-okay":64079,"hand-peace":64080,"hand-peace-variant":64081,"hand-pointing-down":64082,"hand-pointing-left":64083,"hand-pointing-right":62151,"hand-pointing-up":64084,hanger:62152,"hard-hat":63854,harddisk:62154,headphones:62155,"headphones-bluetooth":63855,"headphones-box":62156,"headphones-off":63437,"headphones-settings":62157,headset:62158,"headset-dock":62159,"headset-off":62160,heart:62161,"heart-box":62162,"heart-box-outline":62163,"heart-broken":62164,"heart-circle":63856,"heart-circle-outline":63857,"heart-half":63198,"heart-half-full":63197,"heart-half-outline":63199,"heart-multiple":64085,"heart-multiple-outline":64086,"heart-off":63320,"heart-outline":62165,"heart-pulse":62966,helicopter:64193,help:62166,"help-box":63370,"help-circle":62167,"help-circle-outline":63013,"help-network":63220,hexagon:62168,"hexagon-multiple":63200,"hexagon-outline":62169,"hexagon-slice-1":64194,"hexagon-slice-2":64195,"hexagon-slice-3":64196,"hexagon-slice-4":64197,"hexagon-slice-5":64198,"hexagon-slice-6":64199,hexagram:64200,"hexagram-outline":64201,"high-definition":63438,"high-definition-box":63607,highway:62967,hinduism:63858,history:62170,"hockey-puck":63608,"hockey-sticks":63609,hololens:62171,home:62172,"home-account":63525,"home-alert":63610,"home-assistant":63439,"home-automation":63440,"home-circle":63441,"home-currency-usd":63662,"home-heart":63526,"home-lock":63722,"home-lock-open":63723,"home-map-marker":62968,"home-minus":63859,"home-modern":62173,"home-outline":63136,"home-plus":63860,"home-variant":62174,hook:63201,"hook-off":63202,hops:62175,horseshoe:64087,hospital:62176,"hospital-building":62177,"hospital-marker":62178,"hot-tub":63527,hotel:62179,houzz:62180,"houzz-box":62181,hulu:63528,human:62182,"human-child":62183,"human-female":63049,"human-female-boy":64088,"human-female-female":64089,"human-female-girl":64090,"human-greeting":63050,"human-handsdown":63051,"human-handsup":63052,"human-male":63053,"human-male-boy":64091,"human-male-female":62184,"human-male-girl":64092,"human-male-male":64093,"human-pregnant":62927,"humble-bundle":63299,"ice-cream":63529,image:62185,"image-album":62186,"image-area":62187,"image-area-close":62188,"image-broken":62189,"image-broken-variant":62190,"image-filter":62191,"image-filter-black-white":62192,"image-filter-center-focus":62193,"image-filter-center-focus-weak":62194,"image-filter-drama":62195,"image-filter-frames":62196,"image-filter-hdr":62197,"image-filter-none":62198,"image-filter-tilt-shift":62199,"image-filter-vintage":62200,"image-move":63991,"image-multiple":62201,"image-off":63530,"image-outline":63861,"image-plus":63611,"image-search":63862,"image-search-outline":63863,import:62202,inbox:63110,"inbox-arrow-down":62203,"inbox-arrow-up":62417,"inbox-multiple":63663,incognito:62969,infinity:63203,information:62204,"information-outline":62205,"information-variant":63054,instagram:62206,instapaper:62207,"internet-explorer":62208,"invert-colors":62209,ip:64094,"ip-network":64095,islam:63864,itunes:63094,jeepney:62210,jira:62211,jquery:63612,jsfiddle:62212,json:63014,judaism:63865,karate:63531,keg:62213,kettle:62970,key:62214,"key-change":62215,"key-minus":62216,"key-plus":62217,"key-remove":62218,"key-variant":62219,keyboard:62220,"keyboard-backspace":62221,"keyboard-caps":62222,"keyboard-close":62223,"keyboard-off":62224,"keyboard-outline":63866,"keyboard-return":62225,"keyboard-settings":63992,"keyboard-settings-outline":63993,"keyboard-tab":62226,"keyboard-variant":62227,kickstarter:63300,knife:63994,"knife-military":63995,kodi:62228,label:62229,"label-off":64202,"label-off-outline":64203,"label-outline":62230,"label-variant":64204,"label-variant-outline":64205,ladybug:63532,lambda:63015,lamp:63156,lan:62231,"lan-connect":62232,"lan-disconnect":62233,"lan-pending":62234,"language-c":63089,"language-cpp":63090,"language-csharp":62235,"language-css3":62236,"language-go":63442,"language-html5":62237,"language-java":64284,"language-javascript":62238,"language-lua":63664,"language-php":62239,"language-python":62240,"language-python-text":62241,"language-r":63443,"language-ruby-on-rails":64206,"language-swift":63204,"language-typescript":63205,laptop:62242,"laptop-chromebook":62243,"laptop-mac":62244,"laptop-off":63206,"laptop-windows":62245,laravel:64207,lastfm:62246,lastpass:62534,launch:62247,"lava-lamp":63444,layers:62248,"layers-off":62249,"layers-off-outline":63996,"layers-outline":63997,"lead-pencil":63055,leaf:62250,"led-off":62251,"led-on":62252,"led-outline":62253,"led-strip":63445,"led-variant-off":62254,"led-variant-on":62255,"led-variant-outline":62256,"less-than":63867,"less-than-or-equal":63868,library:62257,"library-books":62258,"library-music":62259,"library-plus":62260,lifebuoy:63613,"light-switch":63869,lightbulb:62261,"lightbulb-on":63207,"lightbulb-on-outline":63208,"lightbulb-outline":62262,lighthouse:63998,"lighthouse-on":63999,link:62263,"link-off":62264,"link-variant":62265,"link-variant-off":62266,linkedin:62267,"linkedin-box":62268,linux:62269,"linux-mint":63724,litecoin:64096,loading:63345,lock:62270,"lock-alert":63725,"lock-clock":63870,"lock-open":62271,"lock-open-outline":62272,"lock-outline":62273,"lock-pattern":63209,"lock-plus":62971,"lock-question":63726,"lock-reset":63346,"lock-smart":63665,locker:63446,"locker-multiple":63447,login:62274,"login-variant":62972,logout:62275,"logout-variant":62973,looks:62276,loop:63210,loupe:62277,lumx:62278,lyft:64285,magnet:62279,"magnet-on":62280,magnify:62281,"magnify-close":63871,"magnify-minus":62282,"magnify-minus-cursor":64097,"magnify-minus-outline":63211,"magnify-plus":62283,"magnify-plus-cursor":64098,"magnify-plus-outline":63212,"mail-ru":62284,mailbox:63213,map:62285,"map-legend":64e3,"map-marker":62286,"map-marker-circle":62287,"map-marker-distance":63727,"map-marker-minus":63056,"map-marker-multiple":62288,"map-marker-off":62289,"map-marker-outline":63448,"map-marker-plus":63057,"map-marker-radius":62290,"map-minus":63872,"map-outline":63873,"map-plus":63874,"map-search":63875,"map-search-outline":63876,margin:62291,markdown:62292,marker:63058,"marker-check":62293,mastodon:64208,"mastodon-variant":64209,"material-design":63877,"material-ui":62295,"math-compass":62296,matrix:63016,maxcdn:62297,medal:63878,"medical-bag":63214,medium:62298,meetup:64210,memory:62299,menu:62300,"menu-down":62301,"menu-down-outline":63157,"menu-left":62302,"menu-left-outline":64001,"menu-right":62303,"menu-right-outline":64002,"menu-swap":64099,"menu-swap-outline":64100,"menu-up":62304,"menu-up-outline":63158,message:62305,"message-alert":62306,"message-alert-outline":64003,"message-bulleted":63137,"message-bulleted-off":63138,"message-draw":62307,"message-image":62308,"message-outline":62309,"message-plus":63059,"message-processing":62310,"message-reply":62311,"message-reply-text":62312,"message-settings":63215,"message-settings-variant":63216,"message-text":62313,"message-text-outline":62314,"message-video":62315,meteor:63017,metronome:63449,"metronome-tick":63450,"micro-sd":63451,microphone:62316,"microphone-minus":63666,"microphone-off":62317,"microphone-outline":62318,"microphone-plus":63667,"microphone-settings":62319,"microphone-variant":62320,"microphone-variant-off":62321,microscope:63060,microsoft:62322,"microsoft-dynamics":63879,midi:63728,"midi-port":63729,minecraft:62323,"mini-sd":64004,minidisc:64005,minus:62324,"minus-box":62325,"minus-box-outline":63217,"minus-circle":62326,"minus-circle-outline":62327,"minus-network":62328,mixcloud:63018,"mixed-reality":63614,mixer:63452,monitor:62329,"monitor-cellphone":63880,"monitor-cellphone-star":63881,"monitor-dashboard":64006,"monitor-multiple":62330,more:62331,motorbike:62332,mouse:62333,"mouse-bluetooth":63882,"mouse-off":62334,"mouse-variant":62335,"mouse-variant-off":62336,"move-resize":63061,"move-resize-variant":63062,movie:62337,"movie-roll":63453,muffin:63883,multiplication:62338,"multiplication-box":62339,mushroom:63454,"mushroom-outline":63455,music:63321,"music-box":62340,"music-box-outline":62341,"music-circle":62342,"music-circle-outline":64211,"music-note":62343,"music-note-bluetooth":62974,"music-note-bluetooth-off":62975,"music-note-eighth":62344,"music-note-half":62345,"music-note-off":62346,"music-note-quarter":62347,"music-note-sixteenth":62348,"music-note-whole":62349,"music-off":63322,nas:63730,nativescript:63615,nature:62350,"nature-people":62351,navigation:62352,"near-me":62925,needle:62353,netflix:63301,network:63218,"network-strength-1":63731,"network-strength-1-alert":63732,"network-strength-2":63733,"network-strength-2-alert":63734,"network-strength-3":63735,"network-strength-3-alert":63736,"network-strength-4":63737,"network-strength-4-alert":63738,"network-strength-off":63739,"network-strength-off-outline":63740,"network-strength-outline":63741,"new-box":62356,newspaper:62357,nfc:62358,"nfc-tap":62359,"nfc-variant":62360,ninja:63347,"nintendo-switch":63456,nodejs:62361,"not-equal":63884,"not-equal-variant":63885,note:62362,"note-multiple":63159,"note-multiple-outline":63160,"note-outline":62363,"note-plus":62364,"note-plus-outline":62365,"note-text":62366,notebook:63533,"notification-clear-all":62367,npm:63222,"npm-variant":63886,"npm-variant-outline":63887,nuke:63139,null:63457,numeric:62368,"numeric-0":48,"numeric-0-box":62369,"numeric-0-box-multiple-outline":62370,"numeric-0-box-outline":62371,"numeric-1":49,"numeric-1-box":62372,"numeric-1-box-multiple-outline":62373,"numeric-1-box-outline":62374,"numeric-2":50,"numeric-2-box":62375,"numeric-2-box-multiple-outline":62376,"numeric-2-box-outline":62377,"numeric-3":51,"numeric-3-box":62378,"numeric-3-box-multiple-outline":62379,"numeric-3-box-outline":62380,"numeric-4":52,"numeric-4-box":62381,"numeric-4-box-multiple-outline":62382,"numeric-4-box-outline":62383,"numeric-5":53,"numeric-5-box":62384,"numeric-5-box-multiple-outline":62385,"numeric-5-box-outline":62386,"numeric-6":54,"numeric-6-box":62387,"numeric-6-box-multiple-outline":62388,"numeric-6-box-outline":62389,"numeric-7":55,"numeric-7-box":62390,"numeric-7-box-multiple-outline":62391,"numeric-7-box-outline":62392,"numeric-8":56,"numeric-8-box":62393,"numeric-8-box-multiple-outline":62394,"numeric-8-box-outline":62395,"numeric-9":57,"numeric-9-box":62396,"numeric-9-box-multiple-outline":62397,"numeric-9-box-outline":62398,"numeric-9-plus-box":62399,"numeric-9-plus-box-multiple-outline":62400,"numeric-9-plus-box-outline":62401,nut:63223,nutrition:62402,oar:63099,octagon:62403,"octagon-outline":62404,octagram:63224,"octagram-outline":63348,odnoklassniki:62405,office:62406,"office-building":63888,oil:62407,"oil-temperature":62408,omega:62409,onedrive:62410,onenote:63302,onepassword:63616,opacity:62924,"open-in-app":62411,"open-in-new":62412,openid:62413,opera:62414,orbit:61464,origin:64299,ornament:62415,"ornament-variant":62416,owl:62418,package:62419,"package-down":62420,"package-up":62421,"package-variant":62422,"package-variant-closed":62423,"page-first":62976,"page-last":62977,"page-layout-body":63225,"page-layout-footer":63226,"page-layout-header":63227,"page-layout-sidebar-left":63228,"page-layout-sidebar-right":63229,palette:62424,"palette-advanced":62425,"palette-swatch":63668,panda:62426,pandora:62427,panorama:62428,"panorama-fisheye":62429,"panorama-horizontal":62430,"panorama-vertical":62431,"panorama-wide-angle":62432,"paper-cut-vertical":62433,paperclip:62434,parking:62435,passport:63458,patreon:63617,pause:62436,"pause-circle":62437,"pause-circle-outline":62438,"pause-octagon":62439,"pause-octagon-outline":62440,paw:62441,"paw-off":63063,paypal:63618,peace:63619,pen:62442,pencil:62443,"pencil-box":62444,"pencil-box-outline":62445,"pencil-circle":63230,"pencil-circle-outline":63349,"pencil-lock":62446,"pencil-off":62447,pentagon:63231,"pentagon-outline":63232,percent:62448,"periodic-table":63669,"periodic-table-co2":63459,periscope:63303,pharmacy:62449,phone:62450,"phone-bluetooth":62451,"phone-classic":62978,"phone-forward":62452,"phone-hangup":62453,"phone-in-talk":62454,"phone-incoming":62455,"phone-lock":62456,"phone-log":62457,"phone-minus":63064,"phone-missed":62458,"phone-outgoing":62459,"phone-paused":62460,"phone-plus":63065,"phone-return":63534,"phone-rotate-landscape":63620,"phone-rotate-portrait":63621,"phone-settings":62461,"phone-voip":62462,pi:62463,"pi-box":62464,piano:63100,pickaxe:63670,pier:63622,"pier-crane":63623,pig:62465,pill:62466,pillar:63233,pin:62467,"pin-off":62468,"pin-off-outline":63791,"pin-outline":63792,"pine-tree":62469,"pine-tree-box":62470,pinterest:62471,"pinterest-box":62472,pinwheel:64212,"pinwheel-outline":64213,pipe:63460,"pipe-disconnected":63461,"pipe-leak":63624,pirate:64007,pistol:63234,piston:63625,pizza:62473,"plane-shield":63162,play:62474,"play-box-outline":62475,"play-circle":62476,"play-circle-outline":62477,"play-network":63626,"play-pause":62478,"play-protected-content":62479,"play-speed":63742,"playlist-check":62919,"playlist-edit":63743,"playlist-minus":62480,"playlist-play":62481,"playlist-plus":62482,"playlist-remove":62483,playstation:62484,plex:63161,plus:62485,"plus-box":62486,"plus-box-outline":63235,"plus-circle":62487,"plus-circle-multiple-outline":62488,"plus-circle-outline":62489,"plus-minus":63889,"plus-minus-box":63890,"plus-network":62490,"plus-one":62491,"plus-outline":63236,pocket:62492,podcast:63891,pokeball:62493,"pokemon-go":64008,"poker-chip":63535,polaroid:62494,poll:62495,"poll-box":62496,polymer:62497,pool:62982,popcorn:62498,pot:63066,"pot-mix":63067,pound:62499,"pound-box":62500,power:62501,"power-cycle":63744,"power-off":63745,"power-on":63746,"power-plug":63140,"power-plug-off":63141,"power-settings":62502,"power-sleep":63747,"power-socket":62503,"power-socket-au":63748,"power-socket-eu":63462,"power-socket-uk":63463,"power-socket-us":63464,"power-standby":63749,powershell:64009,prescription:63237,presentation:62504,"presentation-play":62505,printer:62506,"printer-3d":62507,"printer-alert":62508,"printer-settings":63238,"printer-wireless":64010,"priority-high":62979,"priority-low":62980,"professional-hexagon":62509,"progress-check":63892,"progress-clock":63893,"progress-download":63894,"progress-upload":63895,projector:62510,"projector-screen":62511,publish:63142,pulse:62512,puzzle:62513,"puzzle-outline":64101,qi:63896,qqchat:62981,qrcode:62514,"qrcode-edit":63671,"qrcode-scan":62515,quadcopter:62516,"quality-high":62517,"quality-low":64011,"quality-medium":64012,quicktime:62518,rabbit:63750,radar:62519,radiator:62520,"radiator-disabled":64214,"radiator-off":64215,radio:62521,"radio-handheld":62522,"radio-tower":62523,radioactive:62524,"radiobox-blank":62525,"radiobox-marked":62526,raspberrypi:62527,"ray-end":62528,"ray-end-arrow":62529,"ray-start":62530,"ray-start-arrow":62531,"ray-start-end":62532,"ray-vertex":62533,react:63239,read:62535,receipt:62537,record:62538,"record-player":63897,"record-rec":62539,recycle:62540,reddit:62541,redo:62542,"redo-variant":62543,"reflect-horizontal":64013,"reflect-vertical":64014,refresh:62544,regex:62545,"registered-trademark":64102,"relative-scale":62546,reload:62547,reminder:63627,remote:62548,"remote-desktop":63672,"rename-box":62549,"reorder-horizontal":63111,"reorder-vertical":63112,repeat:62550,"repeat-off":62551,"repeat-once":62552,replay:62553,reply:62554,"reply-all":62555,reproduction:62556,resistor:64287,"resistor-nodes":64288,resize:64103,"resize-bottom-right":62557,responsive:62558,restart:63240,restore:63898,"restore-clock":63143,rewind:62559,"rewind-outline":63241,rhombus:63242,"rhombus-medium":64015,"rhombus-outline":63243,"rhombus-split":64016,ribbon:62560,rice:63465,ring:63466,road:62561,"road-variant":62562,robot:63144,"robot-industrial":64289,"robot-vacuum":63244,"robot-vacuum-variant":63751,rocket:62563,"room-service":63628,"rotate-3d":62564,"rotate-left":62565,"rotate-left-variant":62566,"rotate-right":62567,"rotate-right-variant":62568,"rounded-corner":62983,"router-wireless":62569,"router-wireless-settings":64104,routes:62570,rowing:62984,rss:62571,"rss-box":62572,ruler:62573,run:63245,"run-fast":62574,safe:64105,sale:62575,salesforce:63629,sass:63467,satellite:62576,"satellite-uplink":63752,"satellite-variant":62577,sausage:63673,saxophone:62985,scale:62578,"scale-balance":62929,"scale-bathroom":62579,scanner:63146,"scanner-off":63753,school:62580,"scissors-cutting":64106,"screen-rotation":62581,"screen-rotation-lock":62582,screwdriver:62583,script:62584,sd:62585,seal:62586,"search-web":63246,"seat-flat":62587,"seat-flat-angled":62588,"seat-individual-suite":62589,"seat-legroom-extra":62590,"seat-legroom-normal":62591,"seat-legroom-reduced":62592,"seat-recline-extra":62593,"seat-recline-normal":62594,security:62595,"security-account":63630,"security-account-outline":64017,"security-close":63899,"security-home":63113,"security-lock":63900,"security-network":62596,"security-off":63901,select:62597,"select-all":62598,"select-compare":64216,"select-drag":64107,"select-inverse":62599,"select-off":62600,selection:62601,"selection-drag":64108,"selection-off":63350,send:62602,"send-lock":63468,"serial-port":63068,server:62603,"server-minus":62604,"server-network":62605,"server-network-off":62606,"server-off":62607,"server-plus":62608,"server-remove":62609,"server-security":62610,"set-all":63351,"set-center":63352,"set-center-right":63353,"set-left":63354,"set-left-center":63355,"set-left-right":63356,"set-none":63357,"set-right":63358,"set-top-box":63902,settings:62611,"settings-box":62612,"settings-helper":64109,"settings-outline":63674,shape:63536,"shape-circle-plus":63069,"shape-outline":63537,"shape-plus":62613,"shape-polygon-plus":63070,"shape-rectangle-plus":63071,"shape-square-plus":63072,share:62614,"share-outline":63793,"share-variant":62615,shield:62616,"shield-half-full":63359,"shield-outline":62617,"shield-plus":64217,"shield-plus-outline":64218,"shield-remove":64219,"shield-remove-outline":64220,"ship-wheel":63538,"shoe-formal":64290,"shoe-heel":64291,shopify:64221,shopping:62618,"shopping-music":62619,shovel:63247,"shovel-off":63248,shower:63903,"shower-head":63904,shredder:62620,shuffle:62621,"shuffle-disabled":62622,"shuffle-variant":62623,sigma:62624,"sigma-lower":63019,"sign-caution":62625,"sign-direction":63360,"sign-text":63361,signal:62626,"signal-2g":63249,"signal-3g":63250,"signal-4g":63251,"signal-5g":64110,"signal-cellular-1":63675,"signal-cellular-2":63676,"signal-cellular-3":63677,"signal-cellular-outline":63678,"signal-hspa":63252,"signal-hspa-plus":63253,"signal-off":63362,"signal-variant":62986,silo:64292,silverware:62627,"silverware-fork":62628,"silverware-fork-knife":64111,"silverware-spoon":62629,"silverware-variant":62630,sim:62631,"sim-alert":62632,"sim-off":62633,"sina-weibo":64222,sitemap:62634,"skip-backward":62635,"skip-forward":62636,"skip-next":62637,"skip-next-circle":63073,"skip-next-circle-outline":63074,"skip-previous":62638,"skip-previous-circle":63075,"skip-previous-circle-outline":63076,skull:63115,skype:62639,"skype-business":62640,slack:62641,slackware:63754,sleep:62642,"sleep-off":62643,smog:64112,"smoke-detector":62354,smoking:62644,"smoking-off":62645,snapchat:62646,snowflake:63254,snowman:62647,soccer:62648,"soccer-field":63539,sofa:62649,"solar-power":64113,solid:63116,sort:62650,"sort-alphabetical":62651,"sort-ascending":62652,"sort-descending":62653,"sort-numeric":62654,"sort-variant":62655,soundcloud:62656,"source-branch":63020,"source-commit":63255,"source-commit-end":63256,"source-commit-end-local":63257,"source-commit-local":63258,"source-commit-next-local":63259,"source-commit-start":63260,"source-commit-start-next-local":63261,"source-fork":62657,"source-merge":63021,"source-pull":62658,"soy-sauce":63469,speaker:62659,"speaker-bluetooth":63905,"speaker-off":62660,"speaker-wireless":63262,speedometer:62661,spellcheck:62662,spotify:62663,spotlight:62664,"spotlight-beam":62665,spray:63077,"spray-bottle":64223,square:63331,"square-edit-outline":63755,"square-inc":62666,"square-inc-cash":62667,"square-medium":64018,"square-medium-outline":64019,"square-outline":63330,"square-root":63363,"square-root-box":63906,"square-small":64020,squeegee:64224,ssh:63679,"stack-exchange":62987,"stack-overflow":62668,stadium:63263,stairs:62669,"standard-definition":63470,star:62670,"star-box":64114,"star-box-outline":64115,"star-circle":62671,"star-circle-outline":63907,"star-face":63908,"star-four-points":64225,"star-four-points-outline":64226,"star-half":62672,"star-off":62673,"star-outline":62674,"star-three-points":64227,"star-three-points-outline":64228,steam:62675,"steam-box":63756,steering:62676,"steering-off":63757,"step-backward":62677,"step-backward-2":62678,"step-forward":62679,"step-forward-2":62680,stethoscope:62681,sticker:62928,"sticker-emoji":63364,stocking:62682,stop:62683,"stop-circle":63078,"stop-circle-outline":63079,store:62684,"store-24-hour":62685,stove:62686,strava:64293,"subdirectory-arrow-left":62988,"subdirectory-arrow-right":62989,subtitles:64021,"subtitles-outline":64022,subway:63147,"subway-variant":62687,summit:63365,sunglasses:62688,"surround-sound":62917,"surround-sound-2-0":63471,"surround-sound-3-1":63472,"surround-sound-5-1":63473,"surround-sound-7-1":63474,svg:63264,"swap-horizontal":62689,"swap-horizontal-variant":63680,"swap-vertical":62690,"swap-vertical-variant":63681,swim:62691,switch:62692,sword:62693,"sword-cross":63366,symfony:64229,sync:62694,"sync-alert":62695,"sync-off":62696,tab:62697,"tab-minus":64294,"tab-plus":63323,"tab-remove":64295,"tab-unselected":62698,table:62699,"table-border":64023,"table-column":63540,"table-column-plus-after":62700,"table-column-plus-before":62701,"table-column-remove":62702,"table-column-width":62703,"table-edit":62704,"table-large":62705,"table-merge-cells":63909,"table-of-contents":63541,"table-plus":64116,"table-remove":64117,"table-row":63542,"table-row-height":62706,"table-row-plus-after":62707,"table-row-plus-before":62708,"table-row-remove":62709,"table-search":63758,"table-settings":63543,tablet:62710,"tablet-android":62711,"tablet-cellphone":63910,"tablet-ipad":62712,taco:63329,tag:62713,"tag-faces":62714,"tag-heart":63114,"tag-minus":63759,"tag-multiple":62715,"tag-outline":62716,"tag-plus":63265,"tag-remove":63266,"tag-text-outline":62717,"tape-measure":64296,target:62718,"target-variant":64118,taxi:62719,teach:63631,teamviewer:62720,telegram:62721,telescope:64297,television:62722,"television-box":63544,"television-classic":63475,"television-classic-off":63545,"television-guide":62723,"television-off":63546,"temperature-celsius":62724,"temperature-fahrenheit":62725,"temperature-kelvin":62726,tennis:62727,tent:62728,terrain:62729,"test-tube":63080,"test-tube-empty":63760,"test-tube-off":63761,text:63911,"text-shadow":63081,"text-short":63912,"text-subject":63913,"text-to-speech":62730,"text-to-speech-off":62731,textbox:62990,"textbox-password":63476,texture:62732,theater:62733,"theme-light-dark":62734,thermometer:62735,"thermometer-lines":62736,thermostat:62355,"thermostat-box":63632,"thought-bubble":63477,"thought-bubble-outline":63478,"thumb-down":62737,"thumb-down-outline":62738,"thumb-up":62739,"thumb-up-outline":62740,"thumbs-up-down":62741,ticket:62742,"ticket-account":62743,"ticket-confirmation":62744,"ticket-outline":63762,"ticket-percent":63267,tie:62745,tilde:63268,timelapse:62746,timer:62747,"timer-10":62748,"timer-3":62749,"timer-off":62750,"timer-sand":62751,"timer-sand-empty":63148,"timer-sand-full":63371,timetable:62752,"toggle-switch":62753,"toggle-switch-off":62754,"toggle-switch-off-outline":64024,"toggle-switch-outline":64025,toilet:63914,toolbox:63915,"toolbox-outline":63916,tooltip:62755,"tooltip-edit":62756,"tooltip-image":62757,"tooltip-outline":62758,"tooltip-outline-plus":62759,"tooltip-text":62760,tooth:63682,"tooth-outline":62761,tor:62762,tournament:63917,"tower-beach":63104,"tower-fire":63105,towing:63547,"track-light":63763,trackpad:63479,"trackpad-lock":63794,tractor:63633,trademark:64119,"traffic-light":62763,train:62764,"train-variant":63683,tram:62765,transcribe:62766,"transcribe-close":62767,transfer:62768,"transit-transfer":63149,transition:63764,"transition-masked":63765,translate:62922,"trash-can":64120,"trash-can-outline":64121,"treasure-chest":63269,tree:62769,trello:62770,"trending-down":62771,"trending-neutral":62772,"trending-up":62773,triangle:62774,"triangle-outline":62775,trophy:62776,"trophy-award":62777,"trophy-outline":62778,"trophy-variant":62779,"trophy-variant-outline":62780,truck:62781,"truck-delivery":62782,"truck-fast":63367,"truck-trailer":63270,"tshirt-crew":64122,"tshirt-crew-outline":62783,"tshirt-v":64123,"tshirt-v-outline":62784,"tumble-dryer":63766,tumblr:62785,"tumblr-box":63767,"tumblr-reblog":62786,tune:63022,"tune-vertical":63082,twitch:62787,twitter:62788,"twitter-box":62789,"twitter-circle":62790,"twitter-retweet":62791,"two-factor-authentication":63918,uber:63304,ubuntu:62792,"ultra-high-definition":63480,umbraco:62793,umbrella:62794,"umbrella-closed":63919,"umbrella-outline":62795,undo:62796,"undo-variant":62797,"unfold-less-horizontal":62798,"unfold-less-vertical":63327,"unfold-more-horizontal":62799,"unfold-more-vertical":63328,ungroup:62800,unity:63150,unreal:63920,untappd:62801,update:63151,upload:62802,"upload-multiple":63548,"upload-network":63221,usb:62803,"van-passenger":63481,"van-utility":63482,vanish:63483,variable:64230,"vector-arrange-above":62804,"vector-arrange-below":62805,"vector-bezier":64231,"vector-circle":62806,"vector-circle-variant":62807,"vector-combine":62808,"vector-curve":62809,"vector-difference":62810,"vector-difference-ab":62811,"vector-difference-ba":62812,"vector-ellipse":63634,"vector-intersection":62813,"vector-line":62814,"vector-point":62815,"vector-polygon":62816,"vector-polyline":62817,"vector-radius":63305,"vector-rectangle":62918,"vector-selection":62818,"vector-square":61441,"vector-triangle":62819,"vector-union":62820,venmo:62840,verified:62821,vhs:64026,vibrate:62822,video:62823,"video-3d":63484,"video-4k-box":63549,"video-account":63768,"video-image":63769,"video-input-antenna":63550,"video-input-component":63551,"video-input-hdmi":63552,"video-input-svideo":63553,"video-minus":63921,"video-off":62824,"video-plus":63922,"video-stabilization":63770,"video-switch":62825,"video-vintage":64027,"view-agenda":62826,"view-array":62827,"view-carousel":62828,"view-column":62829,"view-dashboard":62830,"view-dashboard-outline":64028,"view-dashboard-variant":63554,"view-day":62831,"view-grid":62832,"view-headline":62833,"view-list":62834,"view-module":62835,"view-parallel":63271,"view-quilt":62836,"view-sequential":63272,"view-stream":62837,"view-week":62838,vimeo:62839,violin:62991,"virtual-reality":63635,"visual-studio":62992,"visual-studio-code":64029,vk:62841,"vk-box":62842,"vk-circle":62843,vlc:62844,voice:62923,voicemail:62845,volleyball:63923,"volume-high":62846,"volume-low":62847,"volume-medium":62848,"volume-minus":63325,"volume-mute":63326,"volume-off":62849,"volume-plus":63324,vote:64030,"vote-outline":64031,vpn:62850,vuejs:63555,walk:62851,wall:63485,"wall-sconce":63771,"wall-sconce-flat":63772,"wall-sconce-variant":63773,wallet:62852,"wallet-giftcard":62853,"wallet-membership":62854,"wallet-travel":62855,wan:62856,"washing-machine":63273,watch:62857,"watch-export":62858,"watch-export-variant":63636,"watch-import":62859,"watch-import-variant":63637,"watch-variant":63638,"watch-vibrate":63152,water:62860,"water-off":62861,"water-percent":62862,"water-pump":62863,watermark:62994,waves:63372,"weather-cloudy":62864,"weather-fog":62865,"weather-hail":62866,"weather-hurricane":63639,"weather-lightning":62867,"weather-lightning-rainy":63101,"weather-night":62868,"weather-partlycloudy":62869,"weather-pouring":62870,"weather-rainy":62871,"weather-snowy":62872,"weather-snowy-rainy":63102,"weather-sunny":62873,"weather-sunset":62874,"weather-sunset-down":62875,"weather-sunset-up":62876,"weather-windy":62877,"weather-windy-variant":62878,web:62879,webcam:62880,webhook:63023,webpack:63274,wechat:62993,weight:62881,"weight-kilogram":62882,"weight-pound":63924,whatsapp:62883,"wheelchair-accessibility":62884,whistle:63925,"white-balance-auto":62885,"white-balance-incandescent":62886,"white-balance-iridescent":62887,"white-balance-sunny":62888,widgets:63275,wifi:62889,"wifi-off":62890,"wifi-strength-1":63774,"wifi-strength-1-alert":63775,"wifi-strength-1-lock":63776,"wifi-strength-2":63777,"wifi-strength-2-alert":63778,"wifi-strength-2-lock":63779,"wifi-strength-3":63780,"wifi-strength-3-alert":63781,"wifi-strength-3-lock":63782,"wifi-strength-4":63783,"wifi-strength-4-alert":63784,"wifi-strength-4-lock":63785,"wifi-strength-alert-outline":63786,"wifi-strength-lock-outline":63787,"wifi-strength-off":63788,"wifi-strength-off-outline":63789,"wifi-strength-outline":63790,wii:62891,wiiu:63276,wikipedia:62892,"window-close":62893,"window-closed":62894,"window-maximize":62895,"window-minimize":62896,"window-open":62897,"window-restore":62898,windows:62899,"windows-classic":64032,wiper:64232,wordpress:62900,worker:62901,wrap:62902,wrench:62903,wunderlist:62904,xamarin:63556,"xamarin-outline":63557,xaml:63091,xbox:62905,"xbox-controller":62906,"xbox-controller-battery-alert":63306,"xbox-controller-battery-charging":64033,"xbox-controller-battery-empty":63307,"xbox-controller-battery-full":63308,"xbox-controller-battery-low":63309,"xbox-controller-battery-medium":63310,"xbox-controller-battery-unknown":63311,"xbox-controller-off":62907,xda:62908,xing:62909,"xing-box":62910,"xing-circle":62911,xml:62912,xmpp:63486,yahoo:64298,yammer:63368,yeast:62913,yelp:62914,"yin-yang":63103,youtube:62915,"youtube-creator-studio":63558,"youtube-gaming":63559,"youtube-tv":62536,"z-wave":64233,zend:64234,"zip-box":62916,"zip-disk":64034,"zodiac-aquarius":64124,"zodiac-aries":64125,"zodiac-cancer":64126,"zodiac-capricorn":64127,"zodiac-gemini":64128,"zodiac-leo":64129,"zodiac-libra":64130,"zodiac-pisces":64131,"zodiac-sagittarius":64132,"zodiac-scorpio":64133,"zodiac-taurus":64134,"zodiac-virgo":64135,blank:63116}},function(e){e.exports={"ios-add":61698,"ios-add-circle":61697,"ios-add-circle-outline":61696,"ios-airplane":61751,"ios-alarm":62408,"ios-albums":62410,"ios-alert":61700,"ios-american-football":61702,"ios-analytics":62414,"ios-aperture":61704,"ios-apps":61706,"ios-appstore":61708,"ios-archive":61710,"ios-arrow-back":62415,"ios-arrow-down":62416,"ios-arrow-dropdown":61712,"ios-arrow-dropdown-circle":61733,"ios-arrow-dropleft":61714,"ios-arrow-dropleft-circle":61737,"ios-arrow-dropright":61716,"ios-arrow-dropright-circle":61739,"ios-arrow-dropup":61718,"ios-arrow-dropup-circle":61741,"ios-arrow-forward":62417,"ios-arrow-round-back":61719,"ios-arrow-round-down":61720,"ios-arrow-round-forward":61721,"ios-arrow-round-up":61722,"ios-arrow-up":62424,"ios-at":62426,"ios-attach":61723,"ios-backspace":61725,"ios-barcode":62428,"ios-baseball":62430,"ios-basket":61727,"ios-basketball":62432,"ios-battery-charging":61728,"ios-battery-dead":61729,"ios-battery-full":61730,"ios-beaker":61732,"ios-bed":61753,"ios-beer":61734,"ios-bicycle":61735,"ios-bluetooth":61736,"ios-boat":61738,"ios-body":62436,"ios-bonfire":61740,"ios-book":62440,"ios-bookmark":61742,"ios-bookmarks":62442,"ios-bowtie":61744,"ios-briefcase":62446,"ios-browsers":62448,"ios-brush":61746,"ios-bug":61748,"ios-build":61750,"ios-bulb":61752,"ios-bus":61754,"ios-business":61859,"ios-cafe":61756,"ios-calculator":62450,"ios-calendar":62452,"ios-call":61758,"ios-camera":62454,"ios-car":61760,"ios-card":61762,"ios-cart":62456,"ios-cash":61764,"ios-cellular":61757,"ios-chatboxes":62458,"ios-chatbubbles":61766,"ios-checkbox":61768,"ios-checkbox-outline":61767,"ios-checkmark":62463,"ios-checkmark-circle":61770,"ios-checkmark-circle-outline":61769,"ios-clipboard":61772,"ios-clock":62467,"ios-close":62470,"ios-close-circle":61774,"ios-close-circle-outline":61773,"ios-cloud":62476,"ios-cloud-circle":61778,"ios-cloud-done":61780,"ios-cloud-download":62472,"ios-cloud-outline":62473,"ios-cloud-upload":62475,"ios-cloudy":62480,"ios-cloudy-night":62478,"ios-code":61783,"ios-code-download":61781,"ios-code-working":61782,"ios-cog":62482,"ios-color-fill":61785,"ios-color-filter":62484,"ios-color-palette":61787,"ios-color-wand":62486,"ios-compass":61789,"ios-construct":61791,"ios-contact":62490,"ios-contacts":61793,"ios-contract":61794,"ios-contrast":61795,"ios-copy":62492,"ios-create":61797,"ios-crop":62494,"ios-cube":61800,"ios-cut":61802,"ios-desktop":61804,"ios-disc":61806,"ios-document":61808,"ios-done-all":61809,"ios-download":62496,"ios-easel":61811,"ios-egg":61813,"ios-exit":61815,"ios-expand":61816,"ios-eye":62501,"ios-eye-off":61818,"ios-fastforward":62503,"ios-female":61819,"ios-filing":62505,"ios-film":62507,"ios-finger-print":61820,"ios-fitness":61867,"ios-flag":62509,"ios-flame":62511,"ios-flash":61822,"ios-flash-off":61743,"ios-flashlight":61761,"ios-flask":62513,"ios-flower":62515,"ios-folder":62517,"ios-folder-open":61824,"ios-football":62519,"ios-funnel":61826,"ios-gift":61841,"ios-git-branch":61827,"ios-git-commit":61828,"ios-git-compare":61829,"ios-git-merge":61830,"ios-git-network":61831,"ios-git-pull-request":61832,"ios-glasses":62527,"ios-globe":61834,"ios-grid":61836,"ios-hammer":61838,"ios-hand":61840,"ios-happy":61842,"ios-headset":61844,"ios-heart":62531,"ios-heart-dislike":61759,"ios-heart-empty":61851,"ios-heart-half":61853,"ios-help":62534,"ios-help-buoy":61846,"ios-help-circle":61848,"ios-help-circle-outline":61847,"ios-home":62536,"ios-hourglass":61699,"ios-ice-cream":61850,"ios-image":61852,"ios-images":61854,"ios-infinite":62538,"ios-information":62541,"ios-information-circle":61856,"ios-information-circle-outline":61855,"ios-jet":61861,"ios-journal":61833,"ios-key":61863,"ios-keypad":62544,"ios-laptop":61864,"ios-leaf":61866,"ios-link":61994,"ios-list":62548,"ios-list-box":61763,"ios-locate":61870,"ios-lock":61872,"ios-log-in":61873,"ios-log-out":61874,"ios-magnet":61876,"ios-mail":61880,"ios-mail-open":61878,"ios-mail-unread":61765,"ios-male":61881,"ios-man":61883,"ios-map":61885,"ios-medal":61887,"ios-medical":62556,"ios-medkit":62558,"ios-megaphone":61889,"ios-menu":61891,"ios-mic":62561,"ios-mic-off":62559,"ios-microphone":61894,"ios-moon":62568,"ios-more":61896,"ios-move":61899,"ios-musical-note":62571,"ios-musical-notes":62572,"ios-navigate":62574,"ios-notifications":61907,"ios-notifications-off":61905,"ios-notifications-outline":61747,"ios-nuclear":61909,"ios-nutrition":62576,"ios-open":61911,"ios-options":61913,"ios-outlet":61915,"ios-paper":62578,"ios-paper-plane":61917,"ios-partly-sunny":61919,"ios-pause":62584,"ios-paw":62586,"ios-people":62588,"ios-person":62590,"ios-person-add":61921,"ios-phone-landscape":61922,"ios-phone-portrait":61923,"ios-photos":62594,"ios-pie":62596,"ios-pin":61925,"ios-pint":62598,"ios-pizza":61927,"ios-planet":61931,"ios-play":62600,"ios-play-circle":61715,"ios-podium":61933,"ios-power":61935,"ios-pricetag":62605,"ios-pricetags":62607,"ios-print":61937,"ios-pulse":62611,"ios-qr-scanner":61939,"ios-quote":61941,"ios-radio":61945,"ios-radio-button-off":61942,"ios-radio-button-on":61943,"ios-rainy":62613,"ios-recording":62615,"ios-redo":62617,"ios-refresh":62620,"ios-refresh-circle":61749,"ios-remove":61948,"ios-remove-circle":61947,"ios-remove-circle-outline":61946,"ios-reorder":61949,"ios-repeat":61950,"ios-resize":61951,"ios-restaurant":61953,"ios-return-left":61954,"ios-return-right":61955,"ios-reverse-camera":62623,"ios-rewind":62625,"ios-ribbon":61957,"ios-rocket":61771,"ios-rose":62627,"ios-sad":61959,"ios-save":61862,"ios-school":61961,"ios-search":62629,"ios-send":61964,"ios-settings":62631,"ios-share":61969,"ios-share-alt":61967,"ios-shirt":61971,"ios-shuffle":62633,"ios-skip-backward":61973,"ios-skip-forward":61975,"ios-snow":61976,"ios-speedometer":62640,"ios-square":61978,"ios-square-outline":61788,"ios-star":62643,"ios-star-half":62641,"ios-star-outline":62642,"ios-stats":61980,"ios-stopwatch":62645,"ios-subway":61982,"ios-sunny":62647,"ios-swap":61983,"ios-switch":61985,"ios-sync":61986,"ios-tablet-landscape":61987,"ios-tablet-portrait":62030,"ios-tennisball":62651,"ios-text":62032,"ios-thermometer":62034,"ios-thumbs-down":62036,"ios-thumbs-up":62038,"ios-thunderstorm":62653,"ios-time":62655,"ios-timer":62657,"ios-today":61775,"ios-train":62040,"ios-transgender":62041,"ios-trash":62661,"ios-trending-down":62042,"ios-trending-up":62043,"ios-trophy":62045,"ios-tv":61717,"ios-umbrella":62047,"ios-undo":62663,"ios-unlock":62049,"ios-videocam":62669,"ios-volume-high":61724,"ios-volume-low":61726,"ios-volume-mute":62051,"ios-volume-off":62052,"ios-walk":62054,"ios-wallet":61835,"ios-warning":62056,"ios-watch":62057,"ios-water":62059,"ios-wifi":62061,"ios-wine":62063,"ios-woman":62065,"logo-android":61989,"logo-angular":61991,"logo-apple":61993,"logo-bitbucket":61843,"logo-bitcoin":61995,"logo-buffer":61997,"logo-chrome":61999,"logo-closed-captioning":61701,"logo-codepen":62e3,"logo-css3":62001,"logo-designernews":62002,"logo-dribbble":62003,"logo-dropbox":62004,"logo-euro":62005,"logo-facebook":62006,"logo-flickr":61703,"logo-foursquare":62007,"logo-freebsd-devil":62008,"logo-game-controller-a":61755,"logo-game-controller-b":61825,"logo-github":62009,"logo-google":62010,"logo-googleplus":62011,"logo-hackernews":62012,"logo-html5":62013,"logo-instagram":62014,"logo-ionic":61776,"logo-ionitron":61777,"logo-javascript":62015,"logo-linkedin":62016,"logo-markdown":62017,"logo-model-s":61779,"logo-no-smoking":61705,"logo-nodejs":62018,"logo-npm":61845,"logo-octocat":62019,"logo-pinterest":62020,"logo-playstation":62021,"logo-polymer":61790,"logo-python":62022,"logo-reddit":62023,"logo-rss":62024,"logo-sass":62025,"logo-skype":62026,"logo-slack":61707,"logo-snapchat":62027,"logo-steam":62028,"logo-tumblr":62029,"logo-tux":62126,"logo-twitch":62127,"logo-twitter":62128,"logo-usd":62129,"logo-vimeo":62148,"logo-vk":61709,"logo-whatsapp":62149,"logo-windows":62255,"logo-wordpress":62256,"logo-xbox":62284,"logo-xing":61711,"logo-yahoo":62285,"logo-yen":62286,"logo-youtube":62287,"md-add":62067,"md-add-circle":62066,"md-add-circle-outline":61784,"md-airplane":61786,"md-alarm":62068,"md-albums":62069,"md-alert":62070,"md-american-football":62071,"md-analytics":62072,"md-aperture":62073,"md-apps":62074,"md-appstore":62075,"md-archive":62076,"md-arrow-back":62077,"md-arrow-down":62078,"md-arrow-dropdown":62080,"md-arrow-dropdown-circle":62079,"md-arrow-dropleft":62082,"md-arrow-dropleft-circle":62081,"md-arrow-dropright":62084,"md-arrow-dropright-circle":62083,"md-arrow-dropup":62086,"md-arrow-dropup-circle":62085,"md-arrow-forward":62087,"md-arrow-round-back":62088,"md-arrow-round-down":62089,"md-arrow-round-forward":62090,"md-arrow-round-up":62091,"md-arrow-up":62092,"md-at":62093,"md-attach":62094,"md-backspace":62095,"md-barcode":62096,"md-baseball":62097,"md-basket":62098,"md-basketball":62099,"md-battery-charging":62100,"md-battery-dead":62101,"md-battery-full":62102,"md-beaker":62103,"md-bed":61792,"md-beer":62104,"md-bicycle":62105,"md-bluetooth":62106,"md-boat":62107,"md-body":62108,"md-bonfire":62109,"md-book":62110,"md-bookmark":62111,"md-bookmarks":62112,"md-bowtie":62113,"md-briefcase":62114,"md-browsers":62115,"md-brush":62116,"md-bug":62117,"md-build":62118,"md-bulb":62119,"md-bus":62120,"md-business":61860,"md-cafe":62121,"md-calculator":62122,"md-calendar":62123,"md-call":62124,"md-camera":62125,"md-car":62130,"md-card":62131,"md-cart":62132,"md-cash":62133,"md-cellular":61796,"md-chatboxes":62134,"md-chatbubbles":62135,"md-checkbox":62137,"md-checkbox-outline":62136,"md-checkmark":62140,"md-checkmark-circle":62139,"md-checkmark-circle-outline":62138,"md-clipboard":62141,"md-clock":62142,"md-close":62144,"md-close-circle":62143,"md-close-circle-outline":61798,"md-cloud":62153,"md-cloud-circle":62146,"md-cloud-done":62147,"md-cloud-download":62150,"md-cloud-outline":62151,"md-cloud-upload":62152,"md-cloudy":62155,"md-cloudy-night":62154,"md-code":62158,"md-code-download":62156,"md-code-working":62157,"md-cog":62159,"md-color-fill":62160,"md-color-filter":62161,"md-color-palette":62162,"md-color-wand":62163,"md-compass":62164,"md-construct":62165,"md-contact":62166,"md-contacts":62167,"md-contract":62168,"md-contrast":62169,"md-copy":62170,"md-create":62171,"md-crop":62172,"md-cube":62173,"md-cut":62174,"md-desktop":62175,"md-disc":62176,"md-document":62177,"md-done-all":62178,"md-download":62179,"md-easel":62180,"md-egg":62181,"md-exit":62182,"md-expand":62183,"md-eye":62185,"md-eye-off":62184,"md-fastforward":62186,"md-female":62187,"md-filing":62188,"md-film":62189,"md-finger-print":62190,"md-fitness":61868,"md-flag":62191,"md-flame":62192,"md-flash":62193,"md-flash-off":61801,"md-flashlight":61803,"md-flask":62194,"md-flower":62195,"md-folder":62197,"md-folder-open":62196,"md-football":62198,"md-funnel":62199,"md-gift":61849,"md-git-branch":62202,"md-git-commit":62203,"md-git-compare":62204,"md-git-merge":62205,"md-git-network":62206,"md-git-pull-request":62207,"md-glasses":62208,"md-globe":62209,"md-grid":62210,"md-hammer":62211,"md-hand":62212,"md-happy":62213,"md-headset":62214,"md-heart":62216,"md-heart-dislike":61799,"md-heart-empty":61857,"md-heart-half":61858,"md-help":62219,"md-help-buoy":62217,"md-help-circle":62218,"md-help-circle-outline":61805,"md-home":62220,"md-hourglass":61713,"md-ice-cream":62221,"md-image":62222,"md-images":62223,"md-infinite":62224,"md-information":62226,"md-information-circle":62225,"md-information-circle-outline":61807,"md-jet":62229,"md-journal":61837,"md-key":62230,"md-keypad":62231,"md-laptop":62232,"md-leaf":62233,"md-link":61998,"md-list":62235,"md-list-box":62234,"md-locate":62236,"md-lock":62237,"md-log-in":62238,"md-log-out":62239,"md-magnet":62240,"md-mail":62242,"md-mail-open":62241,"md-mail-unread":61810,"md-male":62243,"md-man":62244,"md-map":62245,"md-medal":62246,"md-medical":62247,"md-medkit":62248,"md-megaphone":62249,"md-menu":62250,"md-mic":62252,"md-mic-off":62251,"md-microphone":62253,"md-moon":62254,"md-more":61897,"md-move":62257,"md-musical-note":62258,"md-musical-notes":62259,"md-navigate":62260,"md-notifications":62264,"md-notifications-off":62262,"md-notifications-outline":62263,"md-nuclear":62265,"md-nutrition":62266,"md-open":62267,"md-options":62268,"md-outlet":62269,"md-paper":62271,"md-paper-plane":62270,"md-partly-sunny":62272,"md-pause":62273,"md-paw":62274,"md-people":62275,"md-person":62277,"md-person-add":62276,"md-phone-landscape":62278,"md-phone-portrait":62279,"md-photos":62280,"md-pie":62281,"md-pin":62282,"md-pint":62283,"md-pizza":62292,"md-planet":62294,"md-play":62295,"md-play-circle":61812,"md-podium":62296,"md-power":62297,"md-pricetag":62298,"md-pricetags":62299,"md-print":62300,"md-pulse":62301,"md-qr-scanner":62302,"md-quote":62303,"md-radio":62306,"md-radio-button-off":62304,"md-radio-button-on":62305,"md-rainy":62307,"md-recording":62308,"md-redo":62309,"md-refresh":62310,"md-refresh-circle":61992,"md-remove":62312,"md-remove-circle":62311,"md-remove-circle-outline":61814,"md-reorder":62313,"md-repeat":62314,"md-resize":62315,"md-restaurant":62316,"md-return-left":62317,"md-return-right":62318,"md-reverse-camera":62319,"md-rewind":62320,"md-ribbon":62321,"md-rocket":61817,"md-rose":62322,"md-sad":62323,"md-save":61865,"md-school":62324,"md-search":62325,"md-send":62326,"md-settings":62327,"md-share":62329,"md-share-alt":62328,"md-shirt":62330,"md-shuffle":62331,"md-skip-backward":62332,"md-skip-forward":62333,"md-snow":62334,"md-speedometer":62335,"md-square":62337,"md-square-outline":62336,"md-star":62340,"md-star-half":62338,"md-star-outline":62339,"md-stats":62341,"md-stopwatch":62342,"md-subway":62343,"md-sunny":62344,"md-swap":62345,"md-switch":62346,"md-sync":62347,"md-tablet-landscape":62348,"md-tablet-portrait":62349,"md-tennisball":62350,"md-text":62351,"md-thermometer":62352,"md-thumbs-down":62353,"md-thumbs-up":62354,"md-thunderstorm":62355,"md-time":62356,"md-timer":62357,"md-today":61821,"md-train":62358,"md-transgender":62359,"md-trash":62360,"md-trending-down":62361,"md-trending-up":62362,"md-trophy":62363,"md-tv":61823,"md-umbrella":62364,"md-undo":62365,"md-unlock":62366,"md-videocam":62367,"md-volume-high":61731,"md-volume-low":61745,"md-volume-mute":62369,"md-volume-off":62370,"md-walk":62372,"md-wallet":61839,"md-warning":62373,"md-watch":62374,"md-water":62375,"md-wifi":62376,"md-wine":62377,"md-woman":62378}},function(e){e.exports={"address-book":61696,alert:61697,"align-center":61698,"align-justify":61699,"align-left":61700,"align-right":61701,anchor:61702,annotate:61703,archive:61704,"arrow-down":61705,"arrow-left":61706,"arrow-right":61707,"arrow-up":61708,"arrows-compress":61709,"arrows-expand":61710,"arrows-in":61711,"arrows-out":61712,asl:61713,asterisk:61714,"at-sign":61715,"background-color":61716,"battery-empty":61717,"battery-full":61718,"battery-half":61719,"bitcoin-circle":61720,bitcoin:61721,blind:61722,bluetooth:61723,bold:61724,"book-bookmark":61725,book:61726,bookmark:61727,braille:61728,"burst-new":61729,"burst-sale":61730,burst:61731,calendar:61732,camera:61733,check:61734,checkbox:61735,"clipboard-notes":61736,"clipboard-pencil":61737,clipboard:61738,clock:61739,"closed-caption":61740,cloud:61741,"comment-minus":61742,"comment-quotes":61743,"comment-video":61744,comment:61745,comments:61746,compass:61747,contrast:61748,"credit-card":61749,crop:61750,crown:61751,css3:61752,database:61753,"die-five":61754,"die-four":61755,"die-one":61756,"die-six":61757,"die-three":61758,"die-two":61759,dislike:61760,"dollar-bill":61761,dollar:61762,download:61763,eject:61764,elevator:61765,euro:61766,eye:61767,"fast-forward":61768,"female-symbol":61769,female:61770,filter:61771,"first-aid":61772,flag:61773,"folder-add":61774,"folder-lock":61775,folder:61776,foot:61777,foundation:61778,"graph-bar":61779,"graph-horizontal":61780,"graph-pie":61781,"graph-trend":61782,"guide-dog":61783,"hearing-aid":61784,heart:61785,home:61786,html5:61787,"indent-less":61788,"indent-more":61789,info:61790,italic:61791,key:61792,laptop:61793,layout:61794,lightbulb:61795,like:61796,link:61797,"list-bullet":61798,"list-number":61799,"list-thumbnails":61800,list:61801,lock:61802,loop:61803,"magnifying-glass":61804,mail:61805,"male-female":61806,"male-symbol":61807,male:61808,map:61809,marker:61810,megaphone:61811,microphone:61812,"minus-circle":61813,minus:61814,"mobile-signal":61815,mobile:61816,monitor:61817,mountains:61818,music:61819,next:61820,"no-dogs":61821,"no-smoking":61822,"page-add":61823,"page-copy":61824,"page-csv":61825,"page-delete":61826,"page-doc":61827,"page-edit":61828,"page-export-csv":61829,"page-export-doc":61830,"page-export-pdf":61831,"page-export":61832,"page-filled":61833,"page-multiple":61834,"page-pdf":61835,"page-remove":61836,"page-search":61837,page:61838,"paint-bucket":61839,paperclip:61840,pause:61841,paw:61842,paypal:61843,pencil:61844,photo:61845,"play-circle":61846,"play-video":61847,play:61848,plus:61849,pound:61850,power:61851,previous:61852,"price-tag":61853,"pricetag-multiple":61854,print:61855,prohibited:61856,"projection-screen":61857,puzzle:61858,quote:61859,record:61860,refresh:61861,"results-demographics":61862,results:61863,"rewind-ten":61864,rewind:61865,rss:61866,"safety-cone":61867,save:61868,share:61869,"sheriff-badge":61870,shield:61871,"shopping-bag":61872,"shopping-cart":61873,shuffle:61874,skull:61875,"social-500px":61876,"social-adobe":61877,"social-amazon":61878,"social-android":61879,"social-apple":61880,"social-behance":61881,"social-bing":61882,"social-blogger":61883,"social-delicious":61884,"social-designer-news":61885,"social-deviant-art":61886,"social-digg":61887,"social-dribbble":61888,"social-drive":61889,"social-dropbox":61890,"social-evernote":61891,"social-facebook":61892,"social-flickr":61893,"social-forrst":61894,"social-foursquare":61895,"social-game-center":61896,"social-github":61897,"social-google-plus":61898,"social-hacker-news":61899,"social-hi5":61900,"social-instagram":61901,"social-joomla":61902,"social-lastfm":61903,"social-linkedin":61904,"social-medium":61905,"social-myspace":61906,"social-orkut":61907,"social-path":61908,"social-picasa":61909,"social-pinterest":61910,"social-rdio":61911,"social-reddit":61912,"social-skillshare":61913,"social-skype":61914,"social-smashing-mag":61915,"social-snapchat":61916,"social-spotify":61917,"social-squidoo":61918,"social-stack-overflow":61919,"social-steam":61920,"social-stumbleupon":61921,"social-treehouse":61922,"social-tumblr":61923,"social-twitter":61924,"social-vimeo":61925,"social-windows":61926,"social-xbox":61927,"social-yahoo":61928,"social-yelp":61929,"social-youtube":61930,"social-zerply":61931,"social-zurb":61932,sound:61933,star:61934,stop:61935,strikethrough:61936,subscript:61937,superscript:61938,"tablet-landscape":61939,"tablet-portrait":61940,"target-two":61941,target:61942,"telephone-accessible":61943,telephone:61944,"text-color":61945,thumbnails:61946,ticket:61947,"torso-business":61948,"torso-female":61949,torso:61950,"torsos-all-female":61951,"torsos-all":61952,"torsos-female-male":61953,"torsos-male-female":61954,torsos:61955,trash:61956,trees:61957,trophy:61958,underline:61959,"universal-access":61960,unlink:61961,unlock:61962,"upload-cloud":61963,upload:61964,usb:61965,video:61966,"volume-none":61967,"volume-strike":61968,volume:61969,web:61970,wheelchair:61971,widget:61972,wrench:61973,"x-circle":61974,x:61975,yen:61976,"zoom-in":61977,"zoom-out":61978}},function(e){e.exports={"500px":62062,"accessible-icon":62312,accusoft:62313,ad:63041,"address-book":62137,"address-card":62139,adjust:61506,adn:61808,adversal:62314,affiliatetheme:62315,"air-freshener":62928,algolia:62316,"align-center":61495,"align-justify":61497,"align-left":61494,"align-right":61496,alipay:63042,allergies:62561,amazon:62064,"amazon-pay":62508,ambulance:61689,"american-sign-language-interpreting":62115,amilia:62317,anchor:61757,android:61819,angellist:61961,"angle-double-down":61699,"angle-double-left":61696,"angle-double-right":61697,"angle-double-up":61698,"angle-down":61703,"angle-left":61700,"angle-right":61701,"angle-up":61702,angry:62806,angrycreative:62318,angular:62496,ankh:63044,"app-store":62319,"app-store-ios":62320,apper:62321,apple:61817,"apple-alt":62929,"apple-pay":62485,archive:61831,archway:62807,"arrow-alt-circle-down":62296,"arrow-alt-circle-left":62297,"arrow-alt-circle-right":62298,"arrow-alt-circle-up":62299,"arrow-circle-down":61611,"arrow-circle-left":61608,"arrow-circle-right":61609,"arrow-circle-up":61610,"arrow-down":61539,"arrow-left":61536,"arrow-right":61537,"arrow-up":61538,"arrows-alt":61618,"arrows-alt-h":62263,"arrows-alt-v":62264,"assistive-listening-systems":62114,asterisk:61545,asymmetrik:62322,at:61946,atlas:62808,atom:62930,audible:62323,"audio-description":62110,autoprefixer:62492,avianex:62324,aviato:62497,award:62809,aws:62325,backspace:62810,backward:61514,"balance-scale":62030,ban:61534,"band-aid":62562,bandcamp:62165,barcode:61482,bars:61641,"baseball-ball":62515,"basketball-ball":62516,bath:62157,"battery-empty":62020,"battery-full":62016,"battery-half":62018,"battery-quarter":62019,"battery-three-quarters":62017,bed:62006,beer:61692,behance:61876,"behance-square":61877,bell:61683,"bell-slash":61942,"bezier-curve":62811,bible:63047,bicycle:61958,bimobject:62328,binoculars:61925,"birthday-cake":61949,bitbucket:61809,bitcoin:62329,bity:62330,"black-tie":62078,blackberry:62331,blender:62743,blind:62109,blogger:62332,"blogger-b":62333,bluetooth:62099,"bluetooth-b":62100,bold:61490,bolt:61671,bomb:61922,bone:62935,bong:62812,book:61485,"book-open":62744,"book-reader":62938,bookmark:61486,"bowling-ball":62518,box:62566,"box-open":62622,boxes:62568,braille:62113,brain:62940,briefcase:61617,"briefcase-medical":62569,"broadcast-tower":62745,broom:62746,brush:62813,btc:61786,bug:61832,building:61869,bullhorn:61601,bullseye:61760,burn:62570,buromobelexperte:62335,bus:61959,"bus-alt":62814,"business-time":63050,buysellads:61965,calculator:61932,calendar:61747,"calendar-alt":61555,"calendar-check":62068,"calendar-minus":62066,"calendar-plus":62065,"calendar-times":62067,camera:61488,"camera-retro":61571,cannabis:62815,capsules:62571,car:61881,"car-alt":62942,"car-battery":62943,"car-crash":62945,"car-side":62948,"caret-down":61655,"caret-left":61657,"caret-right":61658,"caret-square-down":61776,"caret-square-left":61841,"caret-square-right":61778,"caret-square-up":61777,"caret-up":61656,"cart-arrow-down":61976,"cart-plus":61975,"cc-amazon-pay":62509,"cc-amex":61939,"cc-apple-pay":62486,"cc-diners-club":62028,"cc-discover":61938,"cc-jcb":62027,"cc-mastercard":61937,"cc-paypal":61940,"cc-stripe":61941,"cc-visa":61936,centercode:62336,certificate:61603,chalkboard:62747,"chalkboard-teacher":62748,"charging-station":62951,"chart-area":61950,"chart-bar":61568,"chart-line":61953,"chart-pie":61952,check:61452,"check-circle":61528,"check-double":62816,"check-square":61770,chess:62521,"chess-bishop":62522,"chess-board":62524,"chess-king":62527,"chess-knight":62529,"chess-pawn":62531,"chess-queen":62533,"chess-rook":62535,"chevron-circle-down":61754,"chevron-circle-left":61751,"chevron-circle-right":61752,"chevron-circle-up":61753,"chevron-down":61560,"chevron-left":61523,"chevron-right":61524,"chevron-up":61559,child:61870,chrome:62056,church:62749,circle:61713,"circle-notch":61902,city:63055,clipboard:62248,"clipboard-check":62572,"clipboard-list":62573,clock:61463,clone:62029,"closed-captioning":61962,cloud:61634,"cloud-download-alt":62337,"cloud-upload-alt":62338,cloudscale:62339,cloudsmith:62340,cloudversify:62341,cocktail:62817,code:61729,"code-branch":61734,codepen:61899,codiepie:62084,coffee:61684,cog:61459,cogs:61573,coins:62750,columns:61659,comment:61557,"comment-alt":62074,"comment-dollar":63057,"comment-dots":62637,"comment-slash":62643,comments:61574,"comments-dollar":63059,"compact-disc":62751,compass:61774,compress:61542,"concierge-bell":62818,connectdevelop:61966,contao:62061,cookie:62819,"cookie-bite":62820,copy:61637,copyright:61945,couch:62648,cpanel:62344,"creative-commons":62046,"creative-commons-by":62695,"creative-commons-nc":62696,"creative-commons-nc-eu":62697,"creative-commons-nc-jp":62698,"creative-commons-nd":62699,"creative-commons-pd":62700,"creative-commons-pd-alt":62701,"creative-commons-remix":62702,"creative-commons-sa":62703,"creative-commons-sampling":62704,"creative-commons-sampling-plus":62705,"creative-commons-share":62706,"credit-card":61597,crop:61733,"crop-alt":62821,cross:63060,crosshairs:61531,crow:62752,crown:62753,css3:61756,"css3-alt":62347,cube:61874,cubes:61875,cut:61636,cuttlefish:62348,"d-and-d":62349,dashcube:61968,database:61888,deaf:62116,delicious:61861,deploydog:62350,deskpro:62351,desktop:61704,deviantart:61885,dharmachakra:63061,diagnoses:62576,dice:62754,"dice-five":62755,"dice-four":62756,"dice-one":62757,"dice-six":62758,"dice-three":62759,"dice-two":62760,digg:61862,"digital-ocean":62353,"digital-tachograph":62822,directions:62955,discord:62354,discourse:62355,divide:62761,dizzy:62823,dna:62577,dochub:62356,docker:62357,"dollar-sign":61781,dolly:62578,"dolly-flatbed":62580,donate:62649,"door-closed":62762,"door-open":62763,"dot-circle":61842,dove:62650,download:61465,draft2digital:62358,"drafting-compass":62824,"draw-polygon":62958,dribbble:61821,"dribbble-square":62359,dropbox:61803,drum:62825,"drum-steelpan":62826,drupal:61865,dumbbell:62539,dyalog:62361,earlybirds:62362,ebay:62708,edge:62082,edit:61508,eject:61522,elementor:62512,"ellipsis-h":61761,"ellipsis-v":61762,ello:62961,ember:62499,empire:61905,envelope:61664,"envelope-open":62134,"envelope-open-text":63064,"envelope-square":61849,envira:62105,equals:62764,eraser:61741,erlang:62365,ethereum:62510,etsy:62167,"euro-sign":61779,"exchange-alt":62306,exclamation:61738,"exclamation-circle":61546,"exclamation-triangle":61553,expand:61541,"expand-arrows-alt":62238,expeditedssl:62014,"external-link-alt":62301,"external-link-square-alt":62304,eye:61550,"eye-dropper":61947,"eye-slash":61552,facebook:61594,"facebook-f":62366,"facebook-messenger":62367,"facebook-square":61570,"fast-backward":61513,"fast-forward":61520,fax:61868,feather:62765,"feather-alt":62827,female:61826,"fighter-jet":61691,file:61787,"file-alt":61788,"file-archive":61894,"file-audio":61895,"file-code":61897,"file-contract":62828,"file-download":62829,"file-excel":61891,"file-export":62830,"file-image":61893,"file-import":62831,"file-invoice":62832,"file-invoice-dollar":62833,"file-medical":62583,"file-medical-alt":62584,"file-pdf":61889,"file-powerpoint":61892,"file-prescription":62834,"file-signature":62835,"file-upload":62836,"file-video":61896,"file-word":61890,fill:62837,"fill-drip":62838,film:61448,filter:61616,fingerprint:62839,fire:61549,"fire-extinguisher":61748,firefox:62057,"first-aid":62585,"first-order":62128,"first-order-alt":62730,firstdraft:62369,fish:62840,flag:61476,"flag-checkered":61726,flask:61635,flickr:61806,flipboard:62541,flushed:62841,fly:62487,folder:61563,"folder-minus":63069,"folder-open":61564,"folder-plus":63070,font:61489,"font-awesome":62132,"font-awesome-alt":62300,"font-awesome-flag":62501,"font-awesome-logo-full":62694,fonticons:62080,"fonticons-fi":62370,"football-ball":62542,"fort-awesome":62086,"fort-awesome-alt":62371,forumbee:61969,forward:61518,foursquare:61824,"free-code-camp":62149,freebsd:62372,frog:62766,frown:61721,"frown-open":62842,fulcrum:62731,"funnel-dollar":63074,futbol:61923,"galactic-republic":62732,"galactic-senate":62733,gamepad:61723,"gas-pump":62767,gavel:61667,gem:62373,genderless:61997,"get-pocket":62053,gg:62048,"gg-circle":62049,gift:61547,git:61907,"git-square":61906,github:61595,"github-alt":61715,"github-square":61586,gitkraken:62374,gitlab:62102,gitter:62502,"glass-martini":61440,"glass-martini-alt":62843,glasses:62768,glide:62117,"glide-g":62118,globe:61612,"globe-africa":62844,"globe-americas":62845,"globe-asia":62846,gofore:62375,"golf-ball":62544,goodreads:62376,"goodreads-g":62377,google:61856,"google-drive":62378,"google-play":62379,"google-plus":62131,"google-plus-g":61653,"google-plus-square":61652,"google-wallet":61934,gopuram:63076,"graduation-cap":61853,gratipay:61828,grav:62166,"greater-than":62769,"greater-than-equal":62770,grimace:62847,grin:62848,"grin-alt":62849,"grin-beam":62850,"grin-beam-sweat":62851,"grin-hearts":62852,"grin-squint":62853,"grin-squint-tears":62854,"grin-stars":62855,"grin-tears":62856,"grin-tongue":62857,"grin-tongue-squint":62858,"grin-tongue-wink":62859,"grin-wink":62860,"grip-horizontal":62861,"grip-vertical":62862,gripfire:62380,grunt:62381,gulp:62382,"h-square":61693,"hacker-news":61908,"hacker-news-square":62383,hackerrank:62967,hamsa:63077,"hand-holding":62653,"hand-holding-heart":62654,"hand-holding-usd":62656,"hand-lizard":62040,"hand-paper":62038,"hand-peace":62043,"hand-point-down":61607,"hand-point-left":61605,"hand-point-right":61604,"hand-point-up":61606,"hand-pointer":62042,"hand-rock":62037,"hand-scissors":62039,"hand-spock":62041,hands:62658,"hands-helping":62660,handshake:62133,hashtag:62098,haykal:63078,hdd:61600,heading:61916,headphones:61477,"headphones-alt":62863,headset:62864,heart:61444,heartbeat:61982,helicopter:62771,highlighter:62865,hips:62546,"hire-a-helper":62384,history:61914,"hockey-puck":62547,home:61461,hooli:62503,hornbill:62866,hospital:61688,"hospital-alt":62589,"hospital-symbol":62590,"hot-tub":62867,hotel:62868,hotjar:62385,hourglass:62036,"hourglass-end":62035,"hourglass-half":62034,"hourglass-start":62033,houzz:62076,html5:61755,hubspot:62386,"i-cursor":62022,"id-badge":62145,"id-card":62146,"id-card-alt":62591,image:61502,images:62210,imdb:62168,inbox:61468,indent:61500,industry:62069,infinity:62772,info:61737,"info-circle":61530,instagram:61805,"internet-explorer":62059,ioxhost:61960,italic:61491,itunes:62388,"itunes-note":62389,java:62692,jedi:63081,"jedi-order":62734,jenkins:62390,joget:62391,joint:62869,joomla:61866,"journal-whills":63082,js:62392,"js-square":62393,jsfiddle:61900,kaaba:63083,kaggle:62970,key:61572,keybase:62709,keyboard:61724,keycdn:62394,khanda:63085,kickstarter:62395,"kickstarter-k":62396,kiss:62870,"kiss-beam":62871,"kiss-wink-heart":62872,"kiwi-bird":62773,korvue:62511,landmark:63087,language:61867,laptop:61705,"laptop-code":62972,laravel:62397,lastfm:61954,"lastfm-square":61955,laugh:62873,"laugh-beam":62874,"laugh-squint":62875,"laugh-wink":62876,"layer-group":62973,leaf:61548,leanpub:61970,lemon:61588,less:62493,"less-than":62774,"less-than-equal":62775,"level-down-alt":62398,"level-up-alt":62399,"life-ring":61901,lightbulb:61675,line:62400,link:61633,linkedin:61580,"linkedin-in":61665,linode:62136,linux:61820,"lira-sign":61845,list:61498,"list-alt":61474,"list-ol":61643,"list-ul":61642,"location-arrow":61732,lock:61475,"lock-open":62401,"long-arrow-alt-down":62217,"long-arrow-alt-left":62218,"long-arrow-alt-right":62219,"long-arrow-alt-up":62220,"low-vision":62120,"luggage-cart":62877,lyft:62403,magento:62404,magic:61648,magnet:61558,"mail-bulk":63092,mailchimp:62878,male:61827,mandalorian:62735,map:62073,"map-marked":62879,"map-marked-alt":62880,"map-marker":61505,"map-marker-alt":62405,"map-pin":62070,"map-signs":62071,markdown:62991,marker:62881,mars:61986,"mars-double":61991,"mars-stroke":61993,"mars-stroke-h":61995,"mars-stroke-v":61994,mastodon:62710,maxcdn:61750,medal:62882,medapps:62406,medium:62010,"medium-m":62407,medkit:61690,medrt:62408,meetup:62176,megaport:62883,meh:61722,"meh-blank":62884,"meh-rolling-eyes":62885,memory:62776,menorah:63094,mercury:61987,microchip:62171,microphone:61744,"microphone-alt":62409,"microphone-alt-slash":62777,"microphone-slash":61745,microscope:62992,microsoft:62410,minus:61544,"minus-circle":61526,"minus-square":61766,mix:62411,mixcloud:62089,mizuni:62412,mobile:61707,"mobile-alt":62413,modx:62085,monero:62416,"money-bill":61654,"money-bill-alt":62417,"money-bill-wave":62778,"money-bill-wave-alt":62779,"money-check":62780,"money-check-alt":62781,monument:62886,moon:61830,"mortar-pestle":62887,mosque:63096,motorcycle:61980,"mouse-pointer":62021,music:61441,napster:62418,neos:62994,neuter:61996,newspaper:61930,nimblr:62888,"nintendo-switch":62488,node:62489,"node-js":62419,"not-equal":62782,"notes-medical":62593,npm:62420,ns8:62421,nutritionix:62422,"object-group":62023,"object-ungroup":62024,odnoklassniki:62051,"odnoklassniki-square":62052,"oil-can":62995,"old-republic":62736,om:63097,opencart:62013,openid:61851,opera:62058,"optin-monster":62012,osi:62490,outdent:61499,page4:62423,pagelines:61836,"paint-brush":61948,"paint-roller":62890,palette:62783,palfed:62424,pallet:62594,"paper-plane":61912,paperclip:61638,"parachute-box":62669,paragraph:61917,parking:62784,passport:62891,pastafarianism:63099,paste:61674,patreon:62425,pause:61516,"pause-circle":62091,paw:61872,paypal:61933,peace:63100,pen:62212,"pen-alt":62213,"pen-fancy":62892,"pen-nib":62893,"pen-square":61771,"pencil-alt":62211,"pencil-ruler":62894,"people-carry":62670,percent:62101,percentage:62785,periscope:62426,phabricator:62427,"phoenix-framework":62428,"phoenix-squadron":62737,phone:61589,"phone-slash":62429,"phone-square":61592,"phone-volume":62112,php:62551,"pied-piper":62126,"pied-piper-alt":61864,"pied-piper-hat":62693,"pied-piper-pp":61863,"piggy-bank":62675,pills:62596,pinterest:61650,"pinterest-p":62001,"pinterest-square":61651,"place-of-worship":63103,plane:61554,"plane-arrival":62895,"plane-departure":62896,play:61515,"play-circle":61764,playstation:62431,plug:61926,plus:61543,"plus-circle":61525,"plus-square":61694,podcast:62158,poll:63105,"poll-h":63106,poo:62206,poop:63001,portrait:62432,"pound-sign":61780,"power-off":61457,pray:63107,"praying-hands":63108,prescription:62897,"prescription-bottle":62597,"prescription-bottle-alt":62598,print:61487,procedures:62599,"product-hunt":62088,"project-diagram":62786,pushed:62433,"puzzle-piece":61742,python:62434,qq:61910,qrcode:61481,question:61736,"question-circle":61529,quidditch:62552,quinscape:62553,quora:62148,"quote-left":61709,"quote-right":61710,quran:63111,"r-project":62711,random:61556,ravelry:62169,react:62491,readme:62677,rebel:61904,receipt:62787,recycle:61880,"red-river":62435,reddit:61857,"reddit-alien":62081,"reddit-square":61858,redo:61470,"redo-alt":62201,registered:62045,rendact:62436,renren:61835,reply:62437,"reply-all":61730,replyd:62438,researchgate:62712,resolving:62439,retweet:61561,rev:62898,ribbon:62678,road:61464,robot:62788,rocket:61749,rocketchat:62440,rockrms:62441,route:62679,rss:61598,"rss-square":61763,"ruble-sign":61784,ruler:62789,"ruler-combined":62790,"ruler-horizontal":62791,"ruler-vertical":62792,"rupee-sign":61782,"sad-cry":62899,"sad-tear":62900,safari:62055,sass:62494,save:61639,schlix:62442,school:62793,screwdriver:62794,scribd:62090,search:61442,"search-dollar":63112,"search-location":63113,"search-minus":61456,"search-plus":61454,searchengin:62443,seedling:62680,sellcast:62170,sellsy:61971,server:62003,servicestack:62444,shapes:63007,share:61540,"share-alt":61920,"share-alt-square":61921,"share-square":61773,"shekel-sign":61963,"shield-alt":62445,ship:61978,"shipping-fast":62603,shirtsinbulk:61972,"shoe-prints":62795,"shopping-bag":62096,"shopping-basket":62097,"shopping-cart":61562,shopware:62901,shower:62156,"shuttle-van":62902,sign:62681,"sign-in-alt":62198,"sign-language":62119,"sign-out-alt":62197,signal:61458,signature:62903,simplybuilt:61973,sistrix:62446,sitemap:61672,sith:62738,skull:62796,skyatlas:61974,skype:61822,slack:61848,"slack-hash":62447,"sliders-h":61918,slideshare:61927,smile:61720,"smile-beam":62904,"smile-wink":62682,smoking:62605,"smoking-ban":62797,snapchat:62123,"snapchat-ghost":62124,"snapchat-square":62125,snowflake:62172,socks:63126,"solar-panel":62906,sort:61660,"sort-alpha-down":61789,"sort-alpha-up":61790,"sort-amount-down":61792,"sort-amount-up":61793,"sort-down":61661,"sort-numeric-down":61794,"sort-numeric-up":61795,"sort-up":61662,soundcloud:61886,spa:62907,"space-shuttle":61847,speakap:62451,spinner:61712,splotch:62908,spotify:61884,"spray-can":62909,square:61640,"square-full":62556,"square-root-alt":63128,squarespace:62910,"stack-exchange":61837,"stack-overflow":61804,stamp:62911,star:61445,"star-and-crescent":63129,"star-half":61577,"star-half-alt":62912,"star-of-david":63130,"star-of-life":63009,staylinked:62453,steam:61878,"steam-square":61879,"steam-symbol":62454,"step-backward":61512,"step-forward":61521,stethoscope:61681,"sticker-mule":62455,"sticky-note":62025,stop:61517,"stop-circle":62093,stopwatch:62194,store:62798,"store-alt":62799,strava:62504,stream:62800,"street-view":61981,strikethrough:61644,stripe:62505,"stripe-s":62506,stroopwafel:62801,studiovinari:62456,stumbleupon:61860,"stumbleupon-circle":61859,subscript:61740,subway:62009,suitcase:61682,"suitcase-rolling":62913,sun:61829,superpowers:62173,superscript:61739,supple:62457,surprise:62914,swatchbook:62915,swimmer:62916,"swimming-pool":62917,synagogue:63131,sync:61473,"sync-alt":62193,syringe:62606,table:61646,"table-tennis":62557,tablet:61706,"tablet-alt":62458,tablets:62608,"tachometer-alt":62461,tag:61483,tags:61484,tape:62683,tasks:61614,taxi:61882,teamspeak:62713,teeth:63022,"teeth-open":63023,telegram:62150,"telegram-plane":62462,"tencent-weibo":61909,terminal:61728,"text-height":61492,"text-width":61493,th:61450,"th-large":61449,"th-list":61451,"the-red-yeti":63133,"theater-masks":63024,themeco:62918,themeisle:62130,thermometer:62609,"thermometer-empty":62155,"thermometer-full":62151,"thermometer-half":62153,"thermometer-quarter":62154,"thermometer-three-quarters":62152,"thumbs-down":61797,"thumbs-up":61796,thumbtack:61581,"ticket-alt":62463,times:61453,"times-circle":61527,tint:61507,"tint-slash":62919,tired:62920,"toggle-off":61956,"toggle-on":61957,toolbox:62802,tooth:62921,torah:63136,"torii-gate":63137,"trade-federation":62739,trademark:62044,"traffic-light":63031,train:62008,transgender:61988,"transgender-alt":61989,trash:61944,"trash-alt":62189,tree:61883,trello:61825,tripadvisor:62050,trophy:61585,truck:61649,"truck-loading":62686,"truck-monster":63035,"truck-moving":62687,"truck-pickup":63036,tshirt:62803,tty:61924,tumblr:61811,"tumblr-square":61812,tv:62060,twitch:61928,twitter:61593,"twitter-square":61569,typo3:62507,uber:62466,uikit:62467,umbrella:61673,"umbrella-beach":62922,underline:61645,undo:61666,"undo-alt":62186,uniregistry:62468,"universal-access":62106,university:61852,unlink:61735,unlock:61596,"unlock-alt":61758,untappd:62469,upload:61587,usb:62087,user:61447,"user-alt":62470,"user-alt-slash":62714,"user-astronaut":62715,"user-check":62716,"user-circle":62141,"user-clock":62717,"user-cog":62718,"user-edit":62719,"user-friends":62720,"user-graduate":62721,"user-lock":62722,"user-md":61680,"user-minus":62723,"user-ninja":62724,"user-plus":62004,"user-secret":61979,"user-shield":62725,"user-slash":62726,"user-tag":62727,"user-tie":62728,"user-times":62005,users:61632,"users-cog":62729,ussunnah:62471,"utensil-spoon":62181,utensils:62183,vaadin:62472,"vector-square":62923,venus:61985,"venus-double":61990,"venus-mars":61992,viacoin:62007,viadeo:62121,"viadeo-square":62122,vial:62610,vials:62611,viber:62473,video:61501,"video-slash":62690,vihara:63143,vimeo:62474,"vimeo-square":61844,"vimeo-v":62077,vine:61898,vk:61833,vnv:62475,"volleyball-ball":62559,"volume-down":61479,"volume-off":61478,"volume-up":61480,vuejs:62495,walking:62804,wallet:62805,warehouse:62612,weebly:62924,weibo:61834,weight:62614,"weight-hanging":62925,weixin:61911,whatsapp:62002,"whatsapp-square":62476,wheelchair:61843,whmcs:62477,wifi:61931,"wikipedia-w":62054,"window-close":62480,"window-maximize":62160,"window-minimize":62161,"window-restore":62162,windows:61818,"wine-glass":62691,"wine-glass-alt":62926,wix:62927,"wolf-pack-battalion":62740,"won-sign":61785,wordpress:61850,"wordpress-simple":62481,wpbeginner:62103,wpexplorer:62174,wpforms:62104,wrench:61613,"x-ray":62615,xbox:62482,xing:61800,"xing-square":61801,"y-combinator":62011,yahoo:61854,yandex:62483,"yandex-international":62484,yelp:61929,"yen-sign":61783,"yin-yang":63149,yoast:62129,youtube:61799,"youtube-square":62513,zhihu:63039}},function(e){e.exports={glass:61440,music:61441,search:61442,"envelope-o":61443,heart:61444,star:61445,"star-o":61446,user:61447,film:61448,"th-large":61449,th:61450,"th-list":61451,check:61452,remove:61453,close:61453,times:61453,"search-plus":61454,"search-minus":61456,"power-off":61457,signal:61458,gear:61459,cog:61459,"trash-o":61460,home:61461,"file-o":61462,"clock-o":61463,road:61464,download:61465,"arrow-circle-o-down":61466,"arrow-circle-o-up":61467,inbox:61468,"play-circle-o":61469,"rotate-right":61470,repeat:61470,refresh:61473,"list-alt":61474,lock:61475,flag:61476,headphones:61477,"volume-off":61478,"volume-down":61479,"volume-up":61480,qrcode:61481,barcode:61482,tag:61483,tags:61484,book:61485,bookmark:61486,print:61487,camera:61488,font:61489,bold:61490,italic:61491,"text-height":61492,"text-width":61493,"align-left":61494,"align-center":61495,"align-right":61496,"align-justify":61497,list:61498,dedent:61499,outdent:61499,indent:61500,"video-camera":61501,photo:61502,image:61502,"picture-o":61502,pencil:61504,"map-marker":61505,adjust:61506,tint:61507,edit:61508,"pencil-square-o":61508,"share-square-o":61509,"check-square-o":61510,arrows:61511,"step-backward":61512,"fast-backward":61513,backward:61514,play:61515,pause:61516,stop:61517,forward:61518,"fast-forward":61520,"step-forward":61521,eject:61522,"chevron-left":61523,"chevron-right":61524,"plus-circle":61525,"minus-circle":61526,"times-circle":61527,"check-circle":61528,"question-circle":61529,"info-circle":61530,crosshairs:61531,"times-circle-o":61532,"check-circle-o":61533,ban:61534,"arrow-left":61536,"arrow-right":61537,"arrow-up":61538,"arrow-down":61539,"mail-forward":61540,share:61540,expand:61541,compress:61542,plus:61543,minus:61544,asterisk:61545,"exclamation-circle":61546,gift:61547,leaf:61548,fire:61549,eye:61550,"eye-slash":61552,warning:61553,"exclamation-triangle":61553,plane:61554,calendar:61555,random:61556,comment:61557,magnet:61558,"chevron-up":61559,"chevron-down":61560,retweet:61561,"shopping-cart":61562,folder:61563,"folder-open":61564,"arrows-v":61565,"arrows-h":61566,"bar-chart-o":61568,"bar-chart":61568,"twitter-square":61569,"facebook-square":61570,"camera-retro":61571,key:61572,gears:61573,cogs:61573,comments:61574,"thumbs-o-up":61575,"thumbs-o-down":61576,"star-half":61577,"heart-o":61578,"sign-out":61579,"linkedin-square":61580,"thumb-tack":61581,"external-link":61582,"sign-in":61584,trophy:61585,"github-square":61586,upload:61587,"lemon-o":61588,phone:61589,"square-o":61590,"bookmark-o":61591,"phone-square":61592,twitter:61593,"facebook-f":61594,facebook:61594,github:61595,unlock:61596,"credit-card":61597,feed:61598,rss:61598,"hdd-o":61600,bullhorn:61601,bell:61683,certificate:61603,"hand-o-right":61604,"hand-o-left":61605,"hand-o-up":61606,"hand-o-down":61607,"arrow-circle-left":61608,"arrow-circle-right":61609,"arrow-circle-up":61610,"arrow-circle-down":61611,globe:61612,wrench:61613,tasks:61614,filter:61616,briefcase:61617,"arrows-alt":61618,group:61632,users:61632,chain:61633,link:61633,cloud:61634,flask:61635,cut:61636,scissors:61636,copy:61637,"files-o":61637,paperclip:61638,save:61639,"floppy-o":61639,square:61640,navicon:61641,reorder:61641,bars:61641,"list-ul":61642,"list-ol":61643,strikethrough:61644,underline:61645,table:61646,magic:61648,truck:61649,pinterest:61650,"pinterest-square":61651,"google-plus-square":61652,"google-plus":61653,money:61654,"caret-down":61655,"caret-up":61656,"caret-left":61657,"caret-right":61658,columns:61659,unsorted:61660,sort:61660,"sort-down":61661,"sort-desc":61661,"sort-up":61662,"sort-asc":61662,envelope:61664,linkedin:61665,"rotate-left":61666,undo:61666,legal:61667,gavel:61667,dashboard:61668,tachometer:61668,"comment-o":61669,"comments-o":61670,flash:61671,bolt:61671,sitemap:61672,umbrella:61673,paste:61674,clipboard:61674,"lightbulb-o":61675,exchange:61676,"cloud-download":61677,"cloud-upload":61678,"user-md":61680,stethoscope:61681,suitcase:61682,"bell-o":61602,coffee:61684,cutlery:61685,"file-text-o":61686,"building-o":61687,"hospital-o":61688,ambulance:61689,medkit:61690,"fighter-jet":61691,beer:61692,"h-square":61693,"plus-square":61694,"angle-double-left":61696,"angle-double-right":61697,"angle-double-up":61698,"angle-double-down":61699,"angle-left":61700,"angle-right":61701,"angle-up":61702,"angle-down":61703,desktop:61704,laptop:61705,tablet:61706,"mobile-phone":61707,mobile:61707,"circle-o":61708,"quote-left":61709,"quote-right":61710,spinner:61712,circle:61713,"mail-reply":61714,reply:61714,"github-alt":61715,"folder-o":61716,"folder-open-o":61717,"smile-o":61720,"frown-o":61721,"meh-o":61722,gamepad:61723,"keyboard-o":61724,"flag-o":61725,"flag-checkered":61726,terminal:61728,code:61729,"mail-reply-all":61730,"reply-all":61730,"star-half-empty":61731,"star-half-full":61731,"star-half-o":61731,"location-arrow":61732,crop:61733,"code-fork":61734,unlink:61735,"chain-broken":61735,question:61736,info:61737,exclamation:61738,superscript:61739,subscript:61740,eraser:61741,"puzzle-piece":61742,microphone:61744,"microphone-slash":61745,shield:61746,"calendar-o":61747,"fire-extinguisher":61748,rocket:61749,maxcdn:61750,"chevron-circle-left":61751,"chevron-circle-right":61752,"chevron-circle-up":61753,"chevron-circle-down":61754,html5:61755,css3:61756,anchor:61757,"unlock-alt":61758,bullseye:61760,"ellipsis-h":61761,"ellipsis-v":61762,"rss-square":61763,"play-circle":61764,ticket:61765,"minus-square":61766,"minus-square-o":61767,"level-up":61768,"level-down":61769,"check-square":61770,"pencil-square":61771,"external-link-square":61772,"share-square":61773,compass:61774,"toggle-down":61776,"caret-square-o-down":61776,"toggle-up":61777,"caret-square-o-up":61777,"toggle-right":61778,"caret-square-o-right":61778,euro:61779,eur:61779,gbp:61780,dollar:61781,usd:61781,rupee:61782,inr:61782,cny:61783,rmb:61783,yen:61783,jpy:61783,ruble:61784,rouble:61784,rub:61784,won:61785,krw:61785,bitcoin:61786,btc:61786,file:61787,"file-text":61788,"sort-alpha-asc":61789,"sort-alpha-desc":61790,"sort-amount-asc":61792,"sort-amount-desc":61793,"sort-numeric-asc":61794,"sort-numeric-desc":61795,"thumbs-up":61796,"thumbs-down":61797,"youtube-square":61798,youtube:61799,xing:61800,"xing-square":61801,"youtube-play":61802,dropbox:61803,"stack-overflow":61804,instagram:61805,flickr:61806,adn:61808,bitbucket:61809,"bitbucket-square":61810,tumblr:61811,"tumblr-square":61812,"long-arrow-down":61813,"long-arrow-up":61814,"long-arrow-left":61815,"long-arrow-right":61816,apple:61817,windows:61818,android:61819,linux:61820,dribbble:61821,skype:61822,foursquare:61824,trello:61825,female:61826,male:61827,gittip:61828,gratipay:61828,"sun-o":61829,"moon-o":61830,archive:61831,bug:61832,vk:61833,weibo:61834,renren:61835,pagelines:61836,"stack-exchange":61837,"arrow-circle-o-right":61838,"arrow-circle-o-left":61840,"toggle-left":61841,"caret-square-o-left":61841,"dot-circle-o":61842,wheelchair:61843,"vimeo-square":61844,"turkish-lira":61845,try:61845,"plus-square-o":61846,"space-shuttle":61847,slack:61848,"envelope-square":61849,wordpress:61850,openid:61851,institution:61852,bank:61852,university:61852,"mortar-board":61853,"graduation-cap":61853,yahoo:61854,google:61856,reddit:61857,"reddit-square":61858,"stumbleupon-circle":61859,stumbleupon:61860,delicious:61861,digg:61862,"pied-piper-pp":61863,"pied-piper-alt":61864,drupal:61865,joomla:61866,language:61867,fax:61868,building:61869,child:61870,paw:61872,spoon:61873,cube:61874,cubes:61875,behance:61876,"behance-square":61877,steam:61878,"steam-square":61879,recycle:61880,automobile:61881,car:61881,cab:61882,taxi:61882,tree:61883,spotify:61884,deviantart:61885,soundcloud:61886,database:61888,"file-pdf-o":61889,"file-word-o":61890,"file-excel-o":61891,"file-powerpoint-o":61892,"file-photo-o":61893,"file-picture-o":61893,"file-image-o":61893,"file-zip-o":61894,"file-archive-o":61894,"file-sound-o":61895,"file-audio-o":61895,"file-movie-o":61896,"file-video-o":61896,"file-code-o":61897,vine:61898,codepen:61899,jsfiddle:61900,"life-bouy":61901,"life-buoy":61901,"life-saver":61901,support:61901,"life-ring":61901,"circle-o-notch":61902,ra:61904,resistance:61904,rebel:61904,ge:61905,empire:61905,"git-square":61906,git:61907,"y-combinator-square":61908,"yc-square":61908,"hacker-news":61908,"tencent-weibo":61909,qq:61910,wechat:61911,weixin:61911,send:61912,"paper-plane":61912,"send-o":61913,"paper-plane-o":61913,history:61914,"circle-thin":61915,header:61916,paragraph:61917,sliders:61918,"share-alt":61920,"share-alt-square":61921,bomb:61922,"soccer-ball-o":61923,"futbol-o":61923,tty:61924,binoculars:61925,plug:61926,slideshare:61927,twitch:61928,yelp:61929,"newspaper-o":61930,wifi:61931,calculator:61932,paypal:61933,"google-wallet":61934,"cc-visa":61936,"cc-mastercard":61937,"cc-discover":61938,"cc-amex":61939,"cc-paypal":61940,"cc-stripe":61941,"bell-slash":61942,"bell-slash-o":61943,trash:61944,copyright:61945,at:61946,eyedropper:61947,"paint-brush":61948,"birthday-cake":61949,"area-chart":61950,"pie-chart":61952,"line-chart":61953,lastfm:61954,"lastfm-square":61955,"toggle-off":61956,"toggle-on":61957,bicycle:61958,bus:61959,ioxhost:61960,angellist:61961,cc:61962,shekel:61963,sheqel:61963,ils:61963,meanpath:61964,buysellads:61965,connectdevelop:61966,dashcube:61968,forumbee:61969,leanpub:61970,sellsy:61971,shirtsinbulk:61972,simplybuilt:61973,skyatlas:61974,"cart-plus":61975,"cart-arrow-down":61976,diamond:61977,ship:61978,"user-secret":61979,motorcycle:61980,"street-view":61981,heartbeat:61982,venus:61985,mars:61986,mercury:61987,intersex:61988,transgender:61988,"transgender-alt":61989,"venus-double":61990,"mars-double":61991,"venus-mars":61992,"mars-stroke":61993,"mars-stroke-v":61994,"mars-stroke-h":61995,neuter:61996,genderless:61997,"facebook-official":62e3,"pinterest-p":62001,whatsapp:62002,server:62003,"user-plus":62004,"user-times":62005,hotel:62006,bed:62006,viacoin:62007,train:62008,subway:62009,medium:62010,yc:62011,"y-combinator":62011,"optin-monster":62012,opencart:62013,expeditedssl:62014,"battery-4":62016,battery:62016,"battery-full":62016,"battery-3":62017,"battery-three-quarters":62017,"battery-2":62018,"battery-half":62018,"battery-1":62019,"battery-quarter":62019,"battery-0":62020,"battery-empty":62020,"mouse-pointer":62021,"i-cursor":62022,"object-group":62023,"object-ungroup":62024,"sticky-note":62025,"sticky-note-o":62026,"cc-jcb":62027,"cc-diners-club":62028,clone:62029,"balance-scale":62030,"hourglass-o":62032,"hourglass-1":62033,"hourglass-start":62033,"hourglass-2":62034,"hourglass-half":62034,"hourglass-3":62035,"hourglass-end":62035,hourglass:62036,"hand-grab-o":62037,"hand-rock-o":62037,"hand-stop-o":62038,"hand-paper-o":62038,"hand-scissors-o":62039,"hand-lizard-o":62040,"hand-spock-o":62041,"hand-pointer-o":62042,"hand-peace-o":62043,trademark:62044,registered:62045,"creative-commons":62046,gg:62048,"gg-circle":62049,tripadvisor:62050,odnoklassniki:62051,"odnoklassniki-square":62052,"get-pocket":62053,"wikipedia-w":62054,safari:62055,chrome:62056,firefox:62057,opera:62058,"internet-explorer":62059,tv:62060,television:62060,contao:62061,"500px":62062,amazon:62064,"calendar-plus-o":62065,"calendar-minus-o":62066,"calendar-times-o":62067,"calendar-check-o":62068,industry:62069,"map-pin":62070,"map-signs":62071,"map-o":62072,map:62073,commenting:62074,"commenting-o":62075,houzz:62076,vimeo:62077,"black-tie":62078,fonticons:62080,"reddit-alien":62081,edge:62082,"credit-card-alt":62083,codiepie:62084,modx:62085,"fort-awesome":62086,usb:62087,"product-hunt":62088,mixcloud:62089,scribd:62090,"pause-circle":62091,"pause-circle-o":62092,"stop-circle":62093,"stop-circle-o":62094,"shopping-bag":62096,"shopping-basket":62097,hashtag:62098,bluetooth:62099,"bluetooth-b":62100,percent:62101,gitlab:62102,wpbeginner:62103,wpforms:62104,envira:62105,"universal-access":62106,"wheelchair-alt":62107,"question-circle-o":62108,blind:62109,"audio-description":62110,"volume-control-phone":62112,braille:62113,"assistive-listening-systems":62114,"asl-interpreting":62115,"american-sign-language-interpreting":62115,deafness:62116,"hard-of-hearing":62116,deaf:62116,glide:62117,"glide-g":62118,signing:62119,"sign-language":62119,"low-vision":62120,viadeo:62121,"viadeo-square":62122,snapchat:62123,"snapchat-ghost":62124,"snapchat-square":62125,"pied-piper":62126,"first-order":62128,yoast:62129,themeisle:62130,"google-plus-circle":62131,"google-plus-official":62131,fa:62132,"font-awesome":62132,"handshake-o":62133,"envelope-open":62134,"envelope-open-o":62135,linode:62136,"address-book":62137,"address-book-o":62138,vcard:62139,"address-card":62139,"vcard-o":62140,"address-card-o":62140,"user-circle":62141,"user-circle-o":62142,"user-o":62144,"id-badge":62145,"drivers-license":62146,"id-card":62146,"drivers-license-o":62147,"id-card-o":62147,quora:62148,"free-code-camp":62149,telegram:62150,"thermometer-4":62151,thermometer:62151,"thermometer-full":62151,"thermometer-3":62152,"thermometer-three-quarters":62152,"thermometer-2":62153,"thermometer-half":62153,"thermometer-1":62154,"thermometer-quarter":62154,"thermometer-0":62155,"thermometer-empty":62155,shower:62156,bathtub:62157,s15:62157,bath:62157,podcast:62158,"window-maximize":62160,"window-minimize":62161,"window-restore":62162,"times-rectangle":62163,"window-close":62163,"times-rectangle-o":62164,"window-close-o":62164,bandcamp:62165,grav:62166,etsy:62167,imdb:62168,ravelry:62169,eercast:62170,microchip:62171,"snowflake-o":62172,superpowers:62173,wpexplorer:62174,meetup:62176}},function(e){e.exports={activity:59648,airplay:59649,"alert-circle":59650,"alert-octagon":59651,"alert-triangle":59652,"align-center":59653,"align-justify":59654,"align-left":59655,"align-right":59656,anchor:59657,aperture:59658,archive:59659,"arrow-down":59660,"arrow-down-circle":59661,"arrow-down-left":59662,"arrow-down-right":59663,"arrow-left":59664,"arrow-left-circle":59665,"arrow-right":59666,"arrow-right-circle":59667,"arrow-up":59668,"arrow-up-circle":59669,"arrow-up-left":59670,"arrow-up-right":59671,"at-sign":59672,award:59673,"bar-chart":59674,"bar-chart-2":59675,battery:59676,"battery-charging":59677,bell:59678,"bell-off":59679,bluetooth:59680,bold:59681,book:59682,"book-open":59683,bookmark:59684,box:59685,briefcase:59686,calendar:59687,camera:59688,"camera-off":59689,cast:59690,check:59691,"check-circle":59692,"check-square":59693,"chevron-down":59694,"chevron-left":59695,"chevron-right":59696,"chevron-up":59697,"chevrons-down":59698,"chevrons-left":59699,"chevrons-right":59700,"chevrons-up":59701,chrome:59702,circle:59703,clipboard:59704,clock:59705,cloud:59706,"cloud-drizzle":59707,"cloud-lightning":59708,"cloud-off":59709,"cloud-rain":59710,"cloud-snow":59711,code:59712,codepen:59713,command:59714,compass:59715,copy:59716,"corner-down-left":59717,"corner-down-right":59718,"corner-left-down":59719,"corner-left-up":59720,"corner-right-down":59721,"corner-right-up":59722,"corner-up-left":59723,"corner-up-right":59724,cpu:59725,"credit-card":59726,crop:59727,crosshair:59728,database:59729,delete:59730,disc:59731,"dollar-sign":59732,download:59733,"download-cloud":59734,droplet:59735,edit:59736,"edit-2":59737,"edit-3":59738,"external-link":59739,eye:59740,"eye-off":59741,facebook:59742,"fast-forward":59743,feather:59744,file:59745,"file-minus":59746,"file-plus":59747,"file-text":59748,film:59749,filter:59750,flag:59751,folder:59752,"folder-minus":59753,"folder-plus":59754,gift:59755,"git-branch":59756,"git-commit":59757,"git-merge":59758,"git-pull-request":59759,github:59760,gitlab:59761,globe:59762,grid:59763,"hard-drive":59764,hash:59765,headphones:59766,heart:59767,"help-circle":59768,home:59769,image:59770,inbox:59771,info:59772,instagram:59773,italic:59774,layers:59775,layout:59776,"life-buoy":59777,link:59778,"link-2":59779,linkedin:59780,list:59781,loader:59782,lock:59783,"log-in":59784,"log-out":59785,mail:59786,map:59787,"map-pin":59788,maximize:59789,"maximize-2":59790,menu:59791,"message-circle":59792,"message-square":59793,mic:59794,"mic-off":59795,minimize:59796,"minimize-2":59797,minus:59798,"minus-circle":59799,"minus-square":59800,monitor:59801,moon:59802,"more-horizontal":59803,"more-vertical":59804,move:59805,music:59806,navigation:59807,"navigation-2":59808,octagon:59809,package:59810,paperclip:59811,pause:59812,"pause-circle":59813,percent:59814,phone:59815,"phone-call":59816,"phone-forwarded":59817,"phone-incoming":59818,"phone-missed":59819,"phone-off":59820,"phone-outgoing":59821,"pie-chart":59822,play:59823,"play-circle":59824,plus:59825,"plus-circle":59826,"plus-square":59827,pocket:59828,power:59829,printer:59830,radio:59831,"refresh-ccw":59832,"refresh-cw":59833,repeat:59834,rewind:59835,"rotate-ccw":59836,"rotate-cw":59837,rss:59838,save:59839,scissors:59840,search:59841,send:59842,server:59843,settings:59844,share:59845,"share-2":59846,shield:59847,"shield-off":59848,"shopping-bag":59849,"shopping-cart":59850,shuffle:59851,sidebar:59852,"skip-back":59853,"skip-forward":59854,slack:59855,slash:59856,sliders:59857,smartphone:59858,speaker:59859,square:59860,star:59861,"stop-circle":59862,sun:59863,sunrise:59864,sunset:59865,tablet:59866,tag:59867,target:59868,terminal:59869,thermometer:59870,"thumbs-down":59871,"thumbs-up":59872,"toggle-left":59873,"toggle-right":59874,trash:59875,"trash-2":59876,"trending-down":59877,"trending-up":59878,triangle:59879,truck:59880,tv:59881,twitter:59882,type:59883,umbrella:59884,underline:59885,unlock:59886,upload:59887,"upload-cloud":59888,user:59889,"user-check":59890,"user-minus":59891,"user-plus":59892,"user-x":59893,users:59894,video:59895,"video-off":59896,voicemail:59897,volume:59898,"volume-1":59899,"volume-2":59900,"volume-x":59901,watch:59902,wifi:59903,"wifi-off":59904,wind:59905,x:59906,"x-circle":59907,"x-square":59908,youtube:59909,zap:59910,"zap-off":59911,"zoom-in":59912,"zoom-out":59913}},function(e){e.exports={archive:61696,"arrow-down":61697,"arrow-left":61698,"arrow-right":61699,"arrow-up":61700,bell:61701,calendar:61702,camera:61703,cart:61704,chart:61705,check:61706,"chevron-down":61707,"chevron-left":61708,"chevron-right":61709,"chevron-up":61710,clock:61711,close:61712,"close-o":61713,comment:61714,"credit-card":61715,envelope:61716,exclamation:61717,"external-link":61718,eye:61719,gear:61720,heart:61721,image:61722,like:61723,link:61724,location:61725,lock:61726,minus:61727,navicon:61728,paperclip:61729,pencil:61730,play:61731,plus:61732,pointer:61733,question:61734,redo:61735,refresh:61736,retweet:61737,"sc-facebook":61738,"sc-github":61739,"sc-google-plus":61740,"sc-instagram":61741,"sc-linkedin":61742,"sc-odnoklassniki":61743,"sc-pinterest":61744,"sc-skype":61745,"sc-soundcloud":61746,"sc-telegram":61747,"sc-tumblr":61748,"sc-twitter":61749,"sc-vimeo":61750,"sc-vk":61751,"sc-youtube":61752,search:61753,"share-apple":61754,"share-google":61755,spinner:61756,"spinner-2":61757,"spinner-3":61758,star:61759,tag:61760,trash:61761,trophy:61762,undo:61763,unlock:61764,user:61765}},function(e){e.exports={"500px":61696,"500px-with-circle":61697,"add-to-list":61698,"add-user":61699,address:61700,adjust:61701,air:61702,aircraft:61703,"aircraft-landing":61704,"aircraft-take-off":61705,"align-bottom":61706,"align-horizontal-middle":61707,"align-left":61708,"align-right":61709,"align-top":61710,"align-vertical-middle":61711,"app-store":61712,archive:61713,"area-graph":61714,"arrow-bold-down":61715,"arrow-bold-left":61716,"arrow-bold-right":61717,"arrow-bold-up":61718,"arrow-down":61719,"arrow-left":61720,"arrow-long-down":61721,"arrow-long-left":61722,"arrow-long-right":61723,"arrow-long-up":61724,"arrow-right":61725,"arrow-up":61726,"arrow-with-circle-down":61727,"arrow-with-circle-left":61728,"arrow-with-circle-right":61729,"arrow-with-circle-up":61730,attachment:61731,"awareness-ribbon":61732,back:61733,"back-in-time":61734,baidu:61735,"bar-graph":61736,basecamp:61737,battery:61738,"beamed-note":61739,behance:61740,bell:61741,blackboard:61742,block:61743,book:61744,bookmark:61745,bookmarks:61746,bowl:61747,box:61748,briefcase:61749,browser:61750,brush:61751,bucket:61752,bug:61753,cake:61754,calculator:61755,calendar:61756,camera:61757,ccw:61758,chat:61759,check:61760,"chevron-down":61761,"chevron-left":61762,"chevron-right":61763,"chevron-small-down":61764,"chevron-small-left":61765,"chevron-small-right":61766,"chevron-small-up":61767,"chevron-thin-down":61768,"chevron-thin-left":61769,"chevron-thin-right":61770,"chevron-thin-up":61771,"chevron-up":61772,"chevron-with-circle-down":61773,"chevron-with-circle-left":61774,"chevron-with-circle-right":61775,"chevron-with-circle-up":61776,circle:61777,"circle-with-cross":61778,"circle-with-minus":61779,"circle-with-plus":61780,"circular-graph":61781,clapperboard:61782,"classic-computer":61783,clipboard:61784,clock:61785,cloud:61786,code:61787,cog:61788,colours:61789,compass:61790,"controller-fast-backward":61791,"controller-fast-forward":61792,"controller-jump-to-start":61793,"controller-next":61794,"controller-paus":61795,"controller-play":61796,"controller-record":61797,"controller-stop":61798,"controller-volume":61799,copy:61800,"creative-cloud":61801,"creative-commons":61802,"creative-commons-attribution":61803,"creative-commons-noderivs":61804,"creative-commons-noncommercial-eu":61805,"creative-commons-noncommercial-us":61806,"creative-commons-public-domain":61807,"creative-commons-remix":61808,"creative-commons-share":61809,"creative-commons-sharealike":61810,credit:61811,"credit-card":61812,crop:61813,cross:61814,cup:61815,cw:61816,cycle:61817,database:61818,"dial-pad":61819,direction:61820,document:61821,"document-landscape":61822,documents:61823,"dot-single":61824,"dots-three-horizontal":61825,"dots-three-vertical":61826,"dots-two-horizontal":61827,"dots-two-vertical":61828,download:61829,dribbble:61830,"dribbble-with-circle":61831,drink:61832,drive:61833,drop:61834,dropbox:61835,edit:61836,email:61837,"emoji-flirt":61838,"emoji-happy":61839,"emoji-neutral":61840,"emoji-sad":61841,erase:61842,eraser:61843,evernote:61844,export:61845,eye:61846,"eye-with-line":61847,facebook:61848,"facebook-with-circle":61849,feather:61850,fingerprint:61851,flag:61852,flash:61853,flashlight:61854,"flat-brush":61855,flattr:61856,flickr:61857,"flickr-with-circle":61858,"flow-branch":61859,"flow-cascade":61860,"flow-line":61861,"flow-parallel":61862,"flow-tree":61863,flower:61864,folder:61865,"folder-images":61866,"folder-music":61867,"folder-video":61868,forward:61869,foursquare:61870,funnel:61871,"game-controller":61872,gauge:61873,github:61874,"github-with-circle":61875,globe:61876,"google-":61877,"google--with-circle":61878,"google-drive":61879,"google-hangouts":61880,"google-play":61881,"graduation-cap":61882,grid:61883,grooveshark:61884,"hair-cross":61885,hand:61886,heart:61887,"heart-outlined":61888,help:61889,"help-with-circle":61890,home:61891,"hour-glass":61892,houzz:61893,icloud:61894,image:61895,"image-inverted":61896,images:61897,inbox:61898,infinity:61899,info:61900,"info-with-circle":61901,instagram:61902,"instagram-with-circle":61903,install:61904,key:61905,keyboard:61906,"lab-flask":61907,landline:61908,language:61909,laptop:61910,lastfm:61911,"lastfm-with-circle":61912,layers:61913,leaf:61914,"level-down":61915,"level-up":61916,lifebuoy:61917,"light-bulb":61918,"light-down":61919,"light-up":61920,"line-graph":61921,link:61922,linkedin:61923,"linkedin-with-circle":61924,list:61925,location:61926,"location-pin":61927,lock:61928,"lock-open":61929,"log-out":61930,login:61931,loop:61932,magnet:61933,"magnifying-glass":61934,mail:61935,"mail-with-circle":61936,man:61937,map:61938,mask:61939,medal:61940,medium:61941,"medium-with-circle":61942,megaphone:61943,menu:61944,merge:61945,message:61946,mic:61947,minus:61948,mixi:61949,mobile:61950,"modern-mic":61951,moon:61952,mouse:61953,"mouse-pointer":61954,music:61955,network:61956,new:61957,"new-message":61958,news:61959,newsletter:61960,note:61961,notification:61962,"notifications-off":61963,"old-mobile":61964,"old-phone":61965,onedrive:61966,"open-book":61967,palette:61968,"paper-plane":61969,paypal:61970,pencil:61971,phone:61972,picasa:61973,"pie-chart":61974,pin:61975,pinterest:61976,"pinterest-with-circle":61977,plus:61978,popup:61979,"power-plug":61980,"price-ribbon":61981,"price-tag":61982,print:61983,"progress-empty":61984,"progress-full":61985,"progress-one":61986,"progress-two":61987,publish:61988,qq:61989,"qq-with-circle":61990,quote:61991,radio:61992,raft:61993,"raft-with-circle":61994,rainbow:61995,rdio:61996,"rdio-with-circle":61997,"remove-user":61998,renren:61999,reply:62e3,"reply-all":62001,"resize-100-":62002,"resize-full-screen":62003,retweet:62004,rocket:62005,"round-brush":62006,rss:62007,ruler:62008,save:62009,scissors:62010,scribd:62011,"select-arrows":62012,share:62013,"share-alternative":62014,shareable:62015,shield:62016,shop:62017,"shopping-bag":62018,"shopping-basket":62019,"shopping-cart":62020,shuffle:62021,signal:62022,"sina-weibo":62023,skype:62024,"skype-with-circle":62025,slideshare:62026,smashing:62027,sound:62028,"sound-mix":62029,"sound-mute":62030,soundcloud:62031,"sports-club":62032,spotify:62033,"spotify-with-circle":62034,spreadsheet:62035,"squared-cross":62036,"squared-minus":62037,"squared-plus":62038,star:62039,"star-outlined":62040,stopwatch:62041,stumbleupon:62042,"stumbleupon-with-circle":62043,suitcase:62044,swap:62045,swarm:62046,sweden:62047,switch:62048,tablet:62049,"tablet-mobile-combo":62050,tag:62051,text:62052,"text-document":62053,"text-document-inverted":62054,thermometer:62055,"thumbs-down":62056,"thumbs-up":62057,"thunder-cloud":62058,ticket:62059,"time-slot":62060,tools:62061,"traffic-cone":62062,trash:62063,tree:62064,"triangle-down":62065,"triangle-left":62066,"triangle-right":62067,"triangle-up":62068,tripadvisor:62069,trophy:62070,tumblr:62071,"tumblr-with-circle":62072,tv:62073,twitter:62074,"twitter-with-circle":62075,typing:62076,uninstall:62077,unread:62078,untag:62079,upload:62080,"upload-to-cloud":62081,user:62082,users:62083,"v-card":62084,video:62085,"video-camera":62086,vimeo:62087,"vimeo-with-circle":62088,vine:62089,"vine-with-circle":62090,vinyl:62091,vk:62092,"vk-alternitive":62093,"vk-with-circle":62094,voicemail:62095,wallet:62096,warning:62097,water:62098,"windows-store":62099,xing:62100,"xing-with-circle":62101,yelp:62102,youko:62103,"youko-with-circle":62104,youtube:62105,"youtube-with-circle":62106}},function(e){e.exports={stepforward:58880,stepbackward:58881,forward:58882,banckward:58883,caretright:58884,caretleft:58885,caretdown:58886,caretup:58887,rightcircle:58888,leftcircle:58889,upcircle:58890,downcircle:58891,rightcircleo:58892,leftcircleo:58893,upcircleo:58894,downcircleo:58895,verticleleft:58896,verticleright:58897,back:58898,retweet:58899,shrink:58900,arrowsalt:58901,doubleright:58903,doubleleft:58904,arrowdown:58905,arrowup:58906,arrowright:58907,arrowleft:58908,down:58909,up:58910,right:58911,left:58912,minussquareo:58913,minuscircle:58914,minuscircleo:58915,minus:58916,pluscircleo:58917,pluscircle:58918,plus:58919,infocirlce:58920,infocirlceo:58921,info:58922,exclamation:58923,exclamationcircle:58924,exclamationcircleo:58925,closecircle:58926,closecircleo:58927,checkcircle:58928,checkcircleo:58929,check:58930,close:58931,customerservice:58932,creditcard:58933,codesquareo:58934,book:58935,barschart:58936,bars:58937,question:58938,questioncircle:58939,questioncircleo:58940,pause:58941,pausecircle:58942,pausecircleo:58943,clockcircle:58944,clockcircleo:58945,swap:58946,swapleft:58947,swapright:58948,plussquareo:58949,frown:58950,menufold:58968,mail:58969,link:58971,areachart:58972,linechart:58973,home:58974,laptop:58975,star:58976,staro:58977,filter:58979,meho:58982,meh:58983,shoppingcart:58984,save:58985,user:58986,videocamera:58987,totop:58988,team:58989,sharealt:58993,setting:58994,picture:58996,phone:58997,paperclip:58998,notification:58999,menuunfold:59001,inbox:59002,lock:59003,qrcode:59004,tags:59005,tagso:59006,cloudo:59007,cloud:59008,cloudupload:59009,clouddownload:59010,clouddownloado:59011,clouduploado:59012,enviroment:59013,enviromento:59014,eye:59015,eyeo:59016,camera:59017,camerao:59018,windows:59019,export2:59024,export:59025,circledowno:59027,circledown:59028,hdd:59034,ie:59035,delete:59039,enter:59040,pushpino:59041,pushpin:59042,heart:59043,hearto:59044,"smile-circle":59047,smileo:59048,frowno:59049,calculator:59050,chrome:59052,github:59053,iconfontdesktop:59060,caretcircleoup:59061,upload:59062,download:59063,piechart:59064,lock1:59065,unlock:59066,windowso:59068,dotchart:59069,barchart:59070,codesquare:59071,plussquare:59072,minussquare:59073,closesquare:59074,closesquareo:59075,checksquare:59076,checksquareo:59077,fastbackward:59078,fastforward:59079,upsquare:59080,downsquare:59081,leftsquare:59082,rightsquare:59083,rightsquareo:59084,leftsquareo:59085,"down-square-o":59086,"up-square-o":59087,play:59088,playcircleo:59089,tag:59090,tago:59091,addfile:59664,folder1:58978,file1:58980,switcher:59667,addfolder:59668,folderopen:59033,search1:58992,ellipsis1:58951,calendar:59067,filetext1:59032,copy1:58952,jpgfile1:59036,pdffile1:59059,exclefile1:59056,pptfile1:59057,unknowfile1:59055,wordfile1:59058,dingding:59683,"dingding-o":59685,mobile1:59e3,tablet1:58990,bells:58958,disconnect:58959,database:58960,barcode:58962,hourglass:58963,key:58964,flag:58965,layout:58966,printer:58995,USB:59095,skin:59096,tool:59097,car:59100,addusergroup:59101,carryout:59103,deleteuser:59104,deleteusergroup:59105,man:59106,isv:59107,gift:59108,idcard:59109,medicinebox:59110,redenvelopes:59111,rest:59112,Safety:59114,wallet:59115,woman:59116,adduser:59117,bank:59118,Trophy:59119,loading1:59054,loading2:58957,like2:59037,dislike2:59038,like1:58956,dislike1:58955,bulb1:58953,rocket1:59663,select1:58954,apple1:59020,"apple-o":59092,android1:59704,android:59021,"aliwangwang-o1":59023,aliwangwang:59022,"pay-circle1":59045,"pay-circle-o1":59046,poweroff:59093,trademark:58961,find:59099,copyright:59102,sound:59113,earth:59121,wifi:59094,sync:59098,login:58967,logout:58970,reload1:58902,message1:59051,shake:59727,API:59729,"appstore-o":59029,appstore1:59030,scan1:59031,exception1:58981,contacts:59120,solution1:58991,fork:59122,edit:59026,form:59798,warning:59799,table:59800,profile:59801,dashboard:59802,"indent-left":59814,"indent-right":59815,"menu-unfold":59820,"menu-fold":59821,antdesign:59826,"alipay-square":59827,"codepen-circle":59828,google:59829,amazon:59830,codepen:59831,"facebook-square":59832,dropbox:59833,googleplus:59834,"linkedin-square":59835,"medium-monogram":59836,gitlab:59837,"medium-wordmark":59838,QQ:59839,skype:59840,"taobao-square":59841,"alipay-circle":59842,youtube:59843,wechat:59844,twitter:59845,weibo:59846,HTML:59847,"taobao-circle":59123,"weibo-circle":59124,"weibo-square":59125,CodeSandbox:59860,aliyun:59892,zhihu:59139,behance:59143,dribbble:59145,"dribbble-square":59146,"behance-square":59144,"file-markdown":59140,instagram:59147,yuque:59148,slack:59141,"slack-square":59142}},function(e,o,r){"use strict";Object.defineProperty(o,"__esModule",{value:!0});var a=function(){function e(e,o){for(var r=0;r<o.length;r++){var a=o[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(o,r,a){return r&&e(o.prototype,r),a&&e(o,a),o}}();o.default=function(e,o){return function(r){function t(){return function(e,o){if(!(e instanceof o))throw new TypeError("Cannot call a class as a function")}(this,t),function(e,o){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!o||"object"!=typeof o&&"function"!=typeof o?e:o}(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return function(e,o){if("function"!=typeof o&&null!==o)throw new TypeError("Super expression must either be null or a function, not "+typeof o);e.prototype=Object.create(o&&o.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),o&&(Object.setPrototypeOf?Object.setPrototypeOf(e,o):e.__proto__=o)}(t,r),a(t,[{key:"render",value:function(){var r=this.props,a=r.name?e[r.name]||"?":"";"number"==typeof a&&(a=String.fromCharCode(a));var t=n([t={fontSize:r.size?r.size:30,color:r.color?r.color:"grey"},r.style,{fontFamily:o,fontWeight:"normal",fontStyle:"normal"}]);return l.default.createElement("i",{style:t},a)}}]),t}(i.Component)};var t,i=r(0),l=(t=i)&&t.__esModule?t:{default:t};var n=function(e){if(!e)return{};if(e.length){var o={};return e.map(function(e){return Object.assign(o,e)}),o}return e}},function(e,o,r){"use strict";Object.defineProperty(o,"__esModule",{value:!0}),o.Zocial=o.SimpleLineIcons=o.Octicons=o.MaterialIcons=o.MaterialCommunityIcons=o.Ionicons=o.Foundation=o.FontAwesome5=o.FontAwesome=o.Feather=o.EvilIcons=o.Entypo=o.AntDesign=void 0;var a=function(){function e(e,o){for(var r=0;r<o.length;r++){var a=o[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(o,r,a){return r&&e(o.prototype,r),a&&e(o,a),o}}(),t=n(r(14)),i=r(0),l=n(i);function n(e){return e&&e.__esModule?e:{default:e}}var s=o.AntDesign=(0,t.default)(r(13),"AntDesign"),c=o.Entypo=(0,t.default)(r(12),"Entypo"),d=o.EvilIcons=(0,t.default)(r(11),"EvilIcons"),u=o.Feather=(0,t.default)(r(10),"Feather"),p=o.FontAwesome=(0,t.default)(r(9),"FontAwesome"),m=(o.FontAwesome5=(0,t.default)(r(8),"FontAwesome5"),o.Foundation=(0,t.default)(r(7),"Foundation")),h=o.Ionicons=(0,t.default)(r(6),"Ionicons"),g=o.MaterialCommunityIcons=(0,t.default)(r(5),"MaterialCommunityIcons"),b=o.MaterialIcons=(0,t.default)(r(4),"MaterialIcons"),f=o.Octicons=(0,t.default)(r(3),"Octicons"),w=o.SimpleLineIcons=(0,t.default)(r(2),"SimpleLineIcons"),k=o.Zocial=(0,t.default)(r(1),"Zocial"),y=function(e){function o(){return function(e,o){if(!(e instanceof o))throw new TypeError("Cannot call a class as a function")}(this,o),function(e,o){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!o||"object"!=typeof o&&"function"!=typeof o?e:o}(this,(o.__proto__||Object.getPrototypeOf(o)).apply(this,arguments))}return function(e,o){if("function"!=typeof o&&null!==o)throw new TypeError("Super expression must either be null or a function, not "+typeof o);e.prototype=Object.create(o&&o.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),o&&(Object.setPrototypeOf?Object.setPrototypeOf(e,o):e.__proto__=o)}(o,i.Component),a(o,[{key:"render",value:function(){var e=null;switch(this.props.font){case"AntDesign":e=s;break;case"Entypo":e=c;break;case"EvilIcons":e=d;break;case"Feather":e=u;break;case"FontAwesome":e=p;break;case"Foundation":e=m;break;case"Ionicons":e=h;break;case"MaterialIcons":e=b;break;case"MaterialCommunityIcons":e=g;break;case"Octicons":e=f;break;case"Zocial":e=k;break;case"SimpleLineIcons":e=w;break;default:e=h}return l.default.createElement(e,{name:this.props.name,color:this.props.color?this.props.color:"grey",size:this.props.size?this.props.size:30,style:this.props.style})}}]),o}();o.default=y}]);

/***/ },
/* 30 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(355);


/***/ },
/* 32 */
/***/ function(module, exports) {

	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	'use strict';
	
	exports.__esModule = true;
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports['default'] = createChainedFunction;
	module.exports = exports['default'];

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(38);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var parentStyles = {
	  overflow: 'hidden',
	  position: 'relative'
	};
	
	var defaultStyles = {
	  position: 'relative',
	  overflow: 'hidden',
	  cursor: 'pointer',
	  display: 'block',
	  float: 'left'
	};
	
	var getHalfStarStyles = function getHalfStarStyles(color, uniqueness) {
	  return '\n    .react-stars-' + uniqueness + ':before {\n      position: absolute;\n      overflow: hidden;\n      display: block;\n      z-index: 1;\n      top: 0; left: 0;\n      width: 50%;\n      content: attr(data-forhalf);\n      color: ' + color + ';\n  }';
	};
	
	var ReactStars = function (_Component) {
	  _inherits(ReactStars, _Component);
	
	  function ReactStars(props) {
	    _classCallCheck(this, ReactStars);
	
	    // set defaults
	
	    var _this = _possibleConstructorReturn(this, (ReactStars.__proto__ || Object.getPrototypeOf(ReactStars)).call(this, props));
	
	    props = _extends({}, props);
	
	    _this.state = {
	      uniqueness: (Math.random() + '').replace('.', ''),
	      value: props.value || 0,
	      stars: [],
	      halfStar: {
	        at: Math.floor(props.value),
	        hidden: props.half && props.value % 1 < 0.5
	      }
	    };
	
	    _this.state.config = {
	      count: props.count,
	      size: props.size,
	      char: props.char,
	      // default color of inactive star
	      color1: props.color1,
	      // color of an active star
	      color2: props.color2,
	      half: props.half,
	      edit: props.edit
	    };
	
	    return _this;
	  }
	
	  _createClass(ReactStars, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        stars: this.getStars(this.state.value)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this.setState({
	        stars: this.getStars(props.value),
	        value: props.value,
	        halfStar: {
	          at: Math.floor(props.value),
	          hidden: this.state.config.half && props.value % 1 < 0.5
	        }
	      });
	    }
	  }, {
	    key: 'isDecimal',
	    value: function isDecimal(value) {
	      return value % 1 !== 0;
	    }
	  }, {
	    key: 'getRate',
	    value: function getRate() {
	      var stars = void 0;
	      if (this.state.config.half) {
	        stars = Math.floor(this.state.value);
	      } else {
	        stars = Math.round(this.state.value);
	      }
	      return stars;
	    }
	  }, {
	    key: 'getStars',
	    value: function getStars(activeCount) {
	      if (typeof activeCount === 'undefined') {
	        activeCount = this.getRate();
	      }
	      var stars = [];
	      for (var i = 0; i < this.state.config.count; i++) {
	        stars.push({
	          active: i <= activeCount - 1
	        });
	      }
	      return stars;
	    }
	  }, {
	    key: 'mouseOver',
	    value: function mouseOver(event) {
	      var _state = this.state,
	          config = _state.config,
	          halfStar = _state.halfStar;
	
	      if (!config.edit) return;
	      var index = Number(event.target.getAttribute('data-index'));
	      if (config.half) {
	        var isAtHalf = this.moreThanHalf(event, config.size);
	        halfStar.hidden = isAtHalf;
	        if (isAtHalf) index = index + 1;
	        halfStar.at = index;
	      } else {
	        index = index + 1;
	      }
	      this.setState({
	        stars: this.getStars(index)
	      });
	    }
	  }, {
	    key: 'moreThanHalf',
	    value: function moreThanHalf(event, size) {
	      var target = event.target;
	
	      var mouseAt = event.clientX - target.getBoundingClientRect().left;
	      mouseAt = Math.round(Math.abs(mouseAt));
	      return mouseAt > size / 2;
	    }
	  }, {
	    key: 'mouseLeave',
	    value: function mouseLeave() {
	      var _state2 = this.state,
	          value = _state2.value,
	          halfStar = _state2.halfStar,
	          config = _state2.config;
	
	      if (!config.edit) return;
	      if (config.half) {
	        halfStar.hidden = !this.isDecimal(value);
	        halfStar.at = Math.floor(this.state.value);
	      }
	      this.setState({
	        stars: this.getStars()
	      });
	    }
	  }, {
	    key: 'clicked',
	    value: function clicked(event) {
	      var _state3 = this.state,
	          config = _state3.config,
	          halfStar = _state3.halfStar;
	
	      if (!config.edit) return;
	      var index = Number(event.target.getAttribute('data-index'));
	      var value = void 0;
	      if (config.half) {
	        var isAtHalf = this.moreThanHalf(event, config.size);
	        halfStar.hidden = isAtHalf;
	        if (isAtHalf) index = index + 1;
	        value = isAtHalf ? index : index + .5;
	        halfStar.at = index;
	      } else {
	        value = index = index + 1;
	      }
	      this.setState({
	        value: value,
	        stars: this.getStars(index)
	      });
	      this.props.onChange(value);
	    }
	  }, {
	    key: 'renderHalfStarStyleElement',
	    value: function renderHalfStarStyleElement() {
	      var _state4 = this.state,
	          config = _state4.config,
	          uniqueness = _state4.uniqueness;
	
	      return _react2.default.createElement('style', { dangerouslySetInnerHTML: {
	          __html: getHalfStarStyles(config.color2, uniqueness)
	        } });
	    }
	  }, {
	    key: 'renderStars',
	    value: function renderStars() {
	      var _this2 = this;
	
	      var _state5 = this.state,
	          halfStar = _state5.halfStar,
	          stars = _state5.stars,
	          uniqueness = _state5.uniqueness,
	          config = _state5.config;
	      var color1 = config.color1,
	          color2 = config.color2,
	          size = config.size,
	          char = config.char,
	          half = config.half,
	          edit = config.edit;
	
	      return stars.map(function (star, i) {
	        var starClass = '';
	        if (half && !halfStar.hidden && halfStar.at === i) {
	          starClass = 'react-stars-' + uniqueness;
	        }
	        var style = _extends({}, defaultStyles, {
	          color: star.active ? color2 : color1,
	          cursor: edit ? 'pointer' : 'default',
	          fontSize: size + 'px'
	        });
	        return _react2.default.createElement(
	          'span',
	          {
	            className: starClass,
	            style: style,
	            key: i,
	            'data-index': i,
	            'data-forhalf': char,
	            onMouseOver: _this2.mouseOver.bind(_this2),
	            onMouseMove: _this2.mouseOver.bind(_this2),
	            onMouseLeave: _this2.mouseLeave.bind(_this2),
	            onClick: _this2.clicked.bind(_this2) },
	          char
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: parentStyles },
	        this.state.config.half ? this.renderHalfStarStyleElement() : '',
	        this.renderStars()
	      );
	    }
	  }]);
	
	  return ReactStars;
	}(_react.Component);
	
	ReactStars.propTypes = {
	  className: _propTypes2.default.string,
	  edit: _propTypes2.default.bool,
	  half: _propTypes2.default.bool,
	  value: _propTypes2.default.number,
	  count: _propTypes2.default.number,
	  char: _propTypes2.default.string,
	  size: _propTypes2.default.number,
	  color1: _propTypes2.default.string,
	  color2: _propTypes2.default.string
	};
	
	ReactStars.defaultProps = {
	  edit: true,
	  half: true,
	  value: 0,
	  count: 5,
	  char: '★',
	  size: 15,
	  color1: 'gray',
	  color2: '#ffd700',
	
	  onChange: function onChange() {}
	};
	
	exports.default = ReactStars;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(80);
	var ReactBrowserEventEmitter = __webpack_require__(126);
	var ReactCurrentOwner = __webpack_require__(49);
	var ReactDOMFeatureFlags = __webpack_require__(356);
	var ReactElement = __webpack_require__(35);
	var ReactEmptyComponentRegistry = __webpack_require__(363);
	var ReactInstanceHandles = __webpack_require__(81);
	var ReactInstanceMap = __webpack_require__(98);
	var ReactMarkupChecksum = __webpack_require__(366);
	var ReactPerf = __webpack_require__(40);
	var ReactReconciler = __webpack_require__(67);
	var ReactUpdateQueue = __webpack_require__(199);
	var ReactUpdates = __webpack_require__(41);
	
	var assign = __webpack_require__(17);
	var emptyObject = __webpack_require__(90);
	var containsNode = __webpack_require__(246);
	var instantiateReactComponent = __webpack_require__(206);
	var invariant = __webpack_require__(14);
	var setInnerHTML = __webpack_require__(133);
	var shouldUpdateReactComponent = __webpack_require__(209);
	var validateDOMNesting = __webpack_require__(211);
	var warning = __webpack_require__(16);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var nodeCache = {};
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var ownerDocumentContextKey = '__ReactMount_ownerDocument$' + Math.random().toString(36).slice(2);
	
	/** Mapping from reactRootID to React component instance. */
	var instancesByReactRootID = {};
	
	/** Mapping from reactRootID to `container` nodes. */
	var containersByReactRootID = {};
	
	if (false) {
	  /** __DEV__-only mapping from reactRootID to root elements. */
	  var rootElementsByReactRootID = {};
	}
	
	// Used to store breadth-first search state in findComponentRoot.
	var findComponentRootReusableArray = [];
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	/**
	 * @param {DOMElement} container DOM element that may contain a React component.
	 * @return {?string} A "reactRoot" ID, if a React component is rendered.
	 */
	function getReactRootID(container) {
	  var rootElement = getReactRootElementInContainer(container);
	  return rootElement && ReactMount.getID(rootElement);
	}
	
	/**
	 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
	 * element can return its control whose name or ID equals ATTR_NAME. All
	 * DOM nodes support `getAttributeNode` but this can also get called on
	 * other objects so just return '' if we're given something other than a
	 * DOM node (such as window).
	 *
	 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
	 * @return {string} ID of the supplied `domNode`.
	 */
	function getID(node) {
	  var id = internalGetID(node);
	  if (id) {
	    if (nodeCache.hasOwnProperty(id)) {
	      var cached = nodeCache[id];
	      if (cached !== node) {
	        !!isValid(cached, id) ?  false ? invariant(false, 'ReactMount: Two valid but unequal nodes with the same `%s`: %s', ATTR_NAME, id) : invariant(false) : undefined;
	
	        nodeCache[id] = node;
	      }
	    } else {
	      nodeCache[id] = node;
	    }
	  }
	
	  return id;
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Sets the React-specific ID of the given node.
	 *
	 * @param {DOMElement} node The DOM node whose ID will be set.
	 * @param {string} id The value of the ID attribute.
	 */
	function setID(node, id) {
	  var oldID = internalGetID(node);
	  if (oldID !== id) {
	    delete nodeCache[oldID];
	  }
	  node.setAttribute(ATTR_NAME, id);
	  nodeCache[id] = node;
	}
	
	/**
	 * Finds the node with the supplied React-generated DOM ID.
	 *
	 * @param {string} id A React-generated DOM ID.
	 * @return {DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNode(id) {
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * Finds the node with the supplied public React instance.
	 *
	 * @param {*} instance A public React instance.
	 * @return {?DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNodeFromInstance(instance) {
	  var id = ReactInstanceMap.get(instance)._rootNodeID;
	  if (ReactEmptyComponentRegistry.isNullComponentID(id)) {
	    return null;
	  }
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * A node is "valid" if it is contained by a currently mounted container.
	 *
	 * This means that the node does not have to be contained by a document in
	 * order to be considered valid.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @param {string} id The expected ID of the node.
	 * @return {boolean} Whether the node is contained by a mounted container.
	 */
	function isValid(node, id) {
	  if (node) {
	    !(internalGetID(node) === id) ?  false ? invariant(false, 'ReactMount: Unexpected modification of `%s`', ATTR_NAME) : invariant(false) : undefined;
	
	    var container = ReactMount.findReactContainerForID(id);
	    if (container && containsNode(container, node)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Causes the cache to forget about one React-specific ID.
	 *
	 * @param {string} id The ID to forget.
	 */
	function purgeID(id) {
	  delete nodeCache[id];
	}
	
	var deepestNodeSoFar = null;
	function findDeepestCachedAncestorImpl(ancestorID) {
	  var ancestor = nodeCache[ancestorID];
	  if (ancestor && isValid(ancestor, ancestorID)) {
	    deepestNodeSoFar = ancestor;
	  } else {
	    // This node isn't populated in the cache, so presumably none of its
	    // descendants are. Break out of the loop.
	    return false;
	  }
	}
	
	/**
	 * Return the deepest cached node whose ID is a prefix of `targetID`.
	 */
	function findDeepestCachedAncestor(targetID) {
	  deepestNodeSoFar = null;
	  ReactInstanceHandles.traverseAncestors(targetID, findDeepestCachedAncestorImpl);
	
	  var foundNode = deepestNodeSoFar;
	  deepestNodeSoFar = null;
	  return foundNode;
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(componentInstance, rootID, container, transaction, shouldReuseMarkup, context) {
	  if (ReactDOMFeatureFlags.useCreateElement) {
	    context = assign({}, context);
	    if (container.nodeType === DOC_NODE_TYPE) {
	      context[ownerDocumentContextKey] = container;
	    } else {
	      context[ownerDocumentContextKey] = container.ownerDocument;
	    }
	  }
	  if (false) {
	    if (context === emptyObject) {
	      context = {};
	    }
	    var tag = container.nodeName.toLowerCase();
	    context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(null, tag, null);
	  }
	  var markup = ReactReconciler.mountComponent(componentInstance, rootID, transaction, context);
	  componentInstance._renderedComponent._topLevelWrapper = componentInstance;
	  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, rootID, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* forceHTML */shouldReuseMarkup);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, rootID, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container) {
	  ReactReconciler.unmountComponent(instance);
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(node) {
	  var reactRootID = getReactRootID(node);
	  return reactRootID ? reactRootID !== ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID) : false;
	}
	
	/**
	 * Returns the first (deepest) ancestor of a node which is rendered by this copy
	 * of React.
	 */
	function findFirstReactDOMImpl(node) {
	  // This node might be from another React instance, so we make sure not to
	  // examine the node cache here
	  for (; node && node.parentNode !== node; node = node.parentNode) {
	    if (node.nodeType !== 1) {
	      // Not a DOMElement, therefore not a React component
	      continue;
	    }
	    var nodeID = internalGetID(node);
	    if (!nodeID) {
	      continue;
	    }
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	
	    // If containersByReactRootID contains the container we find by crawling up
	    // the tree, we know that this instance of React rendered the node.
	    // nb. isValid's strategy (with containsNode) does not work because render
	    // trees may be nested and we don't want a false positive in that case.
	    var current = node;
	    var lastID;
	    do {
	      lastID = internalGetID(current);
	      current = current.parentNode;
	      if (current == null) {
	        // The passed-in node has been detached from the container it was
	        // originally rendered into.
	        return null;
	      }
	    } while (lastID !== reactRootID);
	
	    if (current === containersByReactRootID[reactRootID]) {
	      return node;
	    }
	  }
	  return null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var TopLevelWrapper = function () {};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /** Exposed for debugging purposes **/
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[getReactRootID(container)] = getReactRootElementInContainer(container);
	    }
	
	    return prevComponent;
	  },
	
	  /**
	   * Register a component into the instance map and starts scroll value
	   * monitoring
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @return {string} reactRoot ID prefix
	   */
	  _registerComponent: function (nextComponent, container) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	
	    var reactRootID = ReactMount.registerContainer(container);
	    instancesByReactRootID[reactRootID] = nextComponent;
	    return reactRootID;
	  },
	
	  /**
	   * Render a new component into the DOM.
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    var componentInstance = instantiateReactComponent(nextElement, null);
	    var reactRootID = ReactMount._registerComponent(componentInstance, container);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, reactRootID, container, shouldReuseMarkup, context);
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[reactRootID] = getReactRootElementInContainer(container);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && parentComponent._reactInternalInstance != null) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : undefined;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing an element string, make sure to instantiate ' + 'it by passing it to React.createElement.' : typeof nextElement === 'function' ? ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : undefined;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : undefined;
	
	    var nextWrappedElement = new ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var prevComponent = instancesByReactRootID[getReactRootID(container)];
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : undefined;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : undefined;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Registers a container node into which React components will be rendered.
	   * This also creates the "reactRoot" ID that will be assigned to the element
	   * rendered within.
	   *
	   * @param {DOMElement} container DOM element to register as a container.
	   * @return {string} The "reactRoot" ID of elements rendered within.
	   */
	  registerContainer: function (container) {
	    var reactRootID = getReactRootID(container);
	    if (reactRootID) {
	      // If one exists, make sure it is a valid "reactRoot" ID.
	      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
	    }
	    if (!reactRootID) {
	      // No valid "reactRoot" ID found, create one.
	      reactRootID = ReactInstanceHandles.createReactRootID();
	    }
	    containersByReactRootID[reactRootID] = container;
	    return reactRootID;
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    var reactRootID = getReactRootID(container);
	    var component = instancesByReactRootID[reactRootID];
	    if (!component) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var containerID = internalGetID(container);
	      var isContainerReactRoot = containerID && containerID === ReactInstanceHandles.getReactRootIDFromNodeID(containerID);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : undefined;
	      }
	
	      return false;
	    }
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, component, container);
	    delete instancesByReactRootID[reactRootID];
	    delete containersByReactRootID[reactRootID];
	    if (false) {
	      delete rootElementsByReactRootID[reactRootID];
	    }
	    return true;
	  },
	
	  /**
	   * Finds the container DOM element that contains React component to which the
	   * supplied DOM `id` belongs.
	   *
	   * @param {string} id The ID of an element rendered by a React component.
	   * @return {?DOMElement} DOM element that contains the `id`.
	   */
	  findReactContainerForID: function (id) {
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
	    var container = containersByReactRootID[reactRootID];
	
	    if (false) {
	      var rootElement = rootElementsByReactRootID[reactRootID];
	      if (rootElement && rootElement.parentNode !== container) {
	        process.env.NODE_ENV !== 'production' ? warning(
	        // Call internalGetID here because getID calls isValid which calls
	        // findReactContainerForID (this function).
	        internalGetID(rootElement) === reactRootID, 'ReactMount: Root element ID differed from reactRootID.') : undefined;
	        var containerChild = container.firstChild;
	        if (containerChild && reactRootID === internalGetID(containerChild)) {
	          // If the container has a new child with the same ID as the old
	          // root element, then rootElementsByReactRootID[reactRootID] is
	          // just stale and needs to be updated. The case that deserves a
	          // warning is when the container is empty.
	          rootElementsByReactRootID[reactRootID] = containerChild;
	        } else {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'ReactMount: Root element has been removed from its original ' + 'container. New container: %s', rootElement.parentNode) : undefined;
	        }
	      }
	    }
	
	    return container;
	  },
	
	  /**
	   * Finds an element rendered by React with the supplied ID.
	   *
	   * @param {string} id ID of a DOM node in the React component.
	   * @return {DOMElement} Root DOM node of the React component.
	   */
	  findReactNodeByID: function (id) {
	    var reactRoot = ReactMount.findReactContainerForID(id);
	    return ReactMount.findComponentRoot(reactRoot, id);
	  },
	
	  /**
	   * Traverses up the ancestors of the supplied node to find a node that is a
	   * DOM representation of a React component rendered by this copy of React.
	   *
	   * @param {*} node
	   * @return {?DOMEventTarget}
	   * @internal
	   */
	  getFirstReactDOM: function (node) {
	    return findFirstReactDOMImpl(node);
	  },
	
	  /**
	   * Finds a node with the supplied `targetID` inside of the supplied
	   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
	   * quickly.
	   *
	   * @param {DOMEventTarget} ancestorNode Search from this root.
	   * @pararm {string} targetID ID of the DOM representation of the component.
	   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
	   * @internal
	   */
	  findComponentRoot: function (ancestorNode, targetID) {
	    var firstChildren = findComponentRootReusableArray;
	    var childIndex = 0;
	
	    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;
	
	    if (false) {
	      // This will throw on the next line; give an early warning
	      process.env.NODE_ENV !== 'production' ? warning(deepestAncestor != null, 'React can\'t find the root component node for data-reactid value ' + '`%s`. If you\'re seeing this message, it probably means that ' + 'you\'ve loaded two copies of React on the page. At this time, only ' + 'a single copy of React can be loaded at a time.', targetID) : undefined;
	    }
	
	    firstChildren[0] = deepestAncestor.firstChild;
	    firstChildren.length = 1;
	
	    while (childIndex < firstChildren.length) {
	      var child = firstChildren[childIndex++];
	      var targetChild;
	
	      while (child) {
	        var childID = ReactMount.getID(child);
	        if (childID) {
	          // Even if we find the node we're looking for, we finish looping
	          // through its siblings to ensure they're cached so that we don't have
	          // to revisit this node again. Otherwise, we make n^2 calls to getID
	          // when visiting the many children of a single node in order.
	
	          if (targetID === childID) {
	            targetChild = child;
	          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
	            // If we find a child whose ID is an ancestor of the given ID,
	            // then we can be sure that we only want to search the subtree
	            // rooted at this child, so we can throw out the rest of the
	            // search state.
	            firstChildren.length = childIndex = 0;
	            firstChildren.push(child.firstChild);
	          }
	        } else {
	          // If this child had no ID, then there's a chance that it was
	          // injected automatically by the browser, as when a `<table>`
	          // element sprouts an extra `<tbody>` child as a side effect of
	          // `.innerHTML` parsing. Optimistically continue down this
	          // branch, but not before examining the other siblings.
	          firstChildren.push(child.firstChild);
	        }
	
	        child = child.nextSibling;
	      }
	
	      if (targetChild) {
	        // Emptying firstChildren/findComponentRootReusableArray is
	        // not necessary for correctness, but it helps the GC reclaim
	        // any nodes that were left at the end of the search.
	        firstChildren.length = 0;
	
	        return targetChild;
	      }
	    }
	
	    firstChildren.length = 0;
	
	     true ?  false ? invariant(false, 'findComponentRoot(..., %s): Unable to find element. This probably ' + 'means the DOM was unexpectedly mutated (e.g., by the browser), ' + 'usually due to forgetting a <tbody> when using tables, nesting tags ' + 'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' + 'parent. ' + 'Try inspecting the child nodes of the element with React ID `%s`.', targetID, ReactMount.getID(ancestorNode)) : invariant(false) : undefined;
	  },
	
	  _mountImageIntoNode: function (markup, container, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : undefined;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : undefined;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : undefined;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      container.appendChild(markup);
	    } else {
	      setInnerHTML(container, markup);
	    }
	  },
	
	  ownerDocumentContextKey: ownerDocumentContextKey,
	
	  /**
	   * React ID utilities.
	   */
	
	  getReactRootID: getReactRootID,
	
	  getID: getID,
	
	  setID: setID,
	
	  getNode: getNode,
	
	  getNodeFromInstance: getNodeFromInstance,
	
	  isValid: isValid,
	
	  purgeID: purgeID
	};
	
	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});
	
	module.exports = ReactMount;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(49);
	
	var assign = __webpack_require__(17);
	var canDefineProperty = __webpack_require__(131);
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	/**
	 * Base constructor for all React elements. This is only used to make this
	 * work with a dynamic instanceof check. Nothing should live on this prototype.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    Object.freeze(element.props);
	    Object.freeze(element);
	  }
	
	  return element;
	};
	
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    ref = config.ref === undefined ? null : config.ref;
	    key = config.key === undefined ? null : '' + config.key;
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (typeof props[propName] === 'undefined') {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	ReactElement.cloneAndReplaceProps = function (oldElement, newProps) {
	  var newElement = ReactElement(oldElement.type, oldElement.key, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, newProps);
	
	  if (false) {
	    // If the key on the original is valid, then the clone is valid
	    newElement._store.validated = oldElement._store.validated;
	  }
	
	  return newElement;
	};
	
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.untouchWithKey = exports.untouch = exports.touchWithKey = exports.touch = exports.swapArrayValues = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.propTypes = exports.initializeWithKey = exports.initialize = exports.getValues = exports.removeArrayValue = exports.reduxForm = exports.reducer = exports.focus = exports.destroy = exports.changeWithKey = exports.change = exports.blur = exports.autofillWithKey = exports.autofill = exports.addArrayValue = exports.actionTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(15);
	
	var _createAll2 = __webpack_require__(945);
	
	var _createAll3 = _interopRequireDefault(_createAll2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	
	var _createAll = (0, _createAll3.default)(isNative, _react2.default, _reactRedux.connect);
	
	var actionTypes = _createAll.actionTypes,
	    addArrayValue = _createAll.addArrayValue,
	    autofill = _createAll.autofill,
	    autofillWithKey = _createAll.autofillWithKey,
	    blur = _createAll.blur,
	    change = _createAll.change,
	    changeWithKey = _createAll.changeWithKey,
	    destroy = _createAll.destroy,
	    focus = _createAll.focus,
	    reducer = _createAll.reducer,
	    reduxForm = _createAll.reduxForm,
	    removeArrayValue = _createAll.removeArrayValue,
	    getValues = _createAll.getValues,
	    initialize = _createAll.initialize,
	    initializeWithKey = _createAll.initializeWithKey,
	    propTypes = _createAll.propTypes,
	    reset = _createAll.reset,
	    startAsyncValidation = _createAll.startAsyncValidation,
	    startSubmit = _createAll.startSubmit,
	    stopAsyncValidation = _createAll.stopAsyncValidation,
	    stopSubmit = _createAll.stopSubmit,
	    swapArrayValues = _createAll.swapArrayValues,
	    touch = _createAll.touch,
	    touchWithKey = _createAll.touchWithKey,
	    untouch = _createAll.untouch,
	    untouchWithKey = _createAll.untouchWithKey;
	exports.actionTypes = actionTypes;
	exports.addArrayValue = addArrayValue;
	exports.autofill = autofill;
	exports.autofillWithKey = autofillWithKey;
	exports.blur = blur;
	exports.change = change;
	exports.changeWithKey = changeWithKey;
	exports.destroy = destroy;
	exports.focus = focus;
	exports.reducer = reducer;
	exports.reduxForm = reduxForm;
	exports.removeArrayValue = removeArrayValue;
	exports.getValues = getValues;
	exports.initialize = initialize;
	exports.initializeWithKey = initializeWithKey;
	exports.propTypes = propTypes;
	exports.reset = reset;
	exports.startAsyncValidation = startAsyncValidation;
	exports.startSubmit = startSubmit;
	exports.stopAsyncValidation = stopAsyncValidation;
	exports.stopSubmit = stopSubmit;
	exports.swapArrayValues = swapArrayValues;
	exports.touch = touch;
	exports.touchWithKey = touchWithKey;
	exports.untouch = untouch;
	exports.untouchWithKey = untouchWithKey;

/***/ },
/* 37 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(714)();
	}


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var domToReact = __webpack_require__(662);
	var htmlToDOM = __webpack_require__(660);
	
	// decode HTML entities by default for `htmlparser2`
	var domParserOptions = { decodeEntities: true, lowerCaseAttributeNames: false };
	
	/**
	 * Converts HTML string to React elements.
	 *
	 * @param  {String}   html              - The HTML string to parse to React.
	 * @param  {Object}   [options]         - The parser options.
	 * @param  {Function} [options.replace] - The replace method.
	 * @return {ReactElement|Array|String}  - When parsed with HTML string, returns React elements; otherwise, returns string or empty array.
	 */
	function HTMLReactParser(html, options) {
	  if (typeof html !== 'string') {
	    throw new TypeError('First argument must be a string');
	  }
	  return domToReact(htmlToDOM(html, domParserOptions), options);
	}
	
	HTMLReactParser.domToReact = domToReact;
	HTMLReactParser.htmlToDOM = htmlToDOM;
	
	module.exports = HTMLReactParser;


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,
	
	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,
	
	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function (object, objectName, methodNames) {
	    if (false) {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(objectName, methodNames[key], object[key]);
	      }
	    }
	  },
	
	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function (objName, fnName, func) {
	    if (false) {
	      var measuredFunc = null;
	      var wrapper = function () {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },
	
	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function (measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};
	
	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}
	
	module.exports = ReactPerf;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(193);
	var PooledClass = __webpack_require__(59);
	var ReactPerf = __webpack_require__(40);
	var ReactReconciler = __webpack_require__(67);
	var Transaction = __webpack_require__(130);
	
	var assign = __webpack_require__(17);
	var invariant = __webpack_require__(14);
	
	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : undefined;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled( /* forceHTML */false);
	}
	
	assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : undefined;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction);
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure('ReactUpdates', 'flushBatchedUpdates', flushBatchedUpdates);
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : undefined;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : undefined;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : undefined;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 42 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyFunction
	 */
	
	"use strict";
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	function emptyFunction() {}
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(55),
	    isString = __webpack_require__(168),
	    support = __webpack_require__(172);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  if (support.unindexedChars && isString(value)) {
	    var index = -1,
	        length = value.length,
	        result = Object(value);
	
	    while (++index < length) {
	      result[index] = value.charAt(index);
	    }
	    return result;
	  }
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ },
/* 44 */
/***/ function(module, exports) {

	'use strict';
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return toString.call(val) === '[object FormData]';
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  trim: trim
	};


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/minus_orange_fade.6d7e4b16.png";

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/plus.72ec7de0.png";

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or bootstrap css where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = (function (_React$Component) {
	  _inherits(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props) {
	    _classCallCheck(this, SafeAnchor);
	
	    _React$Component.call(this, props);
	    this.handleClick = this.handleClick.bind(this);
	  }
	
	  SafeAnchor.prototype.render = function render() {
	    var _props = this.props;
	    var href = _props.href;
	    var role = _props.role;
	    var tabIndex = _props.tabIndex;
	    var disabled = _props.disabled;
	    var style = _props.style;
	
	    var props = _objectWithoutProperties(_props, ['href', 'role', 'tabIndex', 'disabled', 'style']);
	
	    var Component = this.props.componentClass || 'a';
	
	    if (isTrivialHref(href)) {
	      role = role || 'button';
	      // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	      href = href || '';
	    }
	
	    if (disabled) {
	      tabIndex = -1;
	      style = _extends({ pointerEvents: 'none' }, style);
	    }
	
	    return _react2['default'].createElement(Component, _extends({}, props, {
	      role: role,
	      href: href,
	      style: style,
	      tabIndex: tabIndex,
	      onClick: this.handleClick
	    }));
	  };
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    var _props2 = this.props;
	    var disabled = _props2.disabled;
	    var href = _props2.href;
	    var onClick = _props2.onClick;
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  return SafeAnchor;
	})(_react2['default'].Component);
	
	exports['default'] = SafeAnchor;
	
	SafeAnchor.propTypes = {
	  href: _react2['default'].PropTypes.string,
	  onClick: _react2['default'].PropTypes.func,
	  disabled: _react2['default'].PropTypes.bool,
	  role: _react2['default'].PropTypes.string,
	  tabIndex: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _reactPropTypesLibElementType2['default']
	};
	module.exports = exports['default'];

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(105);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 49 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import {Link} from 'react-router';
	
	
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer(props) {
	    _classCallCheck(this, Footer);
	
	    var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));
	
	    _this.state = {
	      showOpenApp: ""
	    };
	    return _this;
	  }
	
	  _createClass(Footer, [{
	    key: 'show_footer',
	    value: function show_footer() {
	      this.setState({ showOpenApp: "close" });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var footer = '';
	      if (this.state.showOpenApp === "") {
	        footer = _react2.default.createElement(
	          'div',
	          { className: 'mob_deals' },
	          _react2.default.createElement(
	            'section',
	            { className: 'close_footer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'fxd_fotr col-md-12 col-xs-12 col-sm-12' },
	              _react2.default.createElement(
	                'a',
	                { onClick: this.show_footer.bind(this), className: 'cls_btn' },
	                _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/close_button.png', alt: '' })
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Download the app to get a much Smoother',
	                _react2.default.createElement('br', null),
	                'AquaDeals Experience'
	              ),
	              _react2.default.createElement(
	                'a',
	                { className: 'open_btn', href: 'https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en', target: '_blank' },
	                'Open app'
	              )
	            )
	          )
	        );
	      } else {
	        footer = '';
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        footer
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(70)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 52 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 53 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	"use strict";
	
	var keyOf = function (oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(114),
	    isLength = __webpack_require__(77),
	    isObjectLike = __webpack_require__(64);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.exports = isArray;


/***/ },
/* 55 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 56 */
[995, 788],
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else if(typeof exports === 'object')
			exports["InfiniteScroll"] = factory(require("react"));
		else
			root["InfiniteScroll"] = factory(root["React"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_7__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
		var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var _react = __webpack_require__(7);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(5);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		var _utilsThrottle = __webpack_require__(1);
	
		var _utilsThrottle2 = _interopRequireDefault(_utilsThrottle);
	
		var InfiniteScroll = (function (_Component) {
		  _inherits(InfiniteScroll, _Component);
	
		  function InfiniteScroll(props) {
		    _classCallCheck(this, InfiniteScroll);
	
		    _get(Object.getPrototypeOf(InfiniteScroll.prototype), 'constructor', this).call(this);
		    this.state = {
		      showLoader: false,
		      lastScrollTop: 0,
		      actionTriggered: false,
		      pullToRefreshThresholdBreached: false
		    };
		    // variables to keep track of pull down behaviour
		    this.startY = 0;
		    this.currentY = 0;
		    this.dragging = false;
		    // will be populated in componentDidMount
		    // based on the height of the pull down element
		    this.maxPullDownDistance = 0;
	
		    this.onScrollListener = this.onScrollListener.bind(this);
		    this.throttledOnScrollListener = (0, _utilsThrottle2['default'])(this.onScrollListener, 150).bind(this);
		    this.onStart = this.onStart.bind(this);
		    this.onMove = this.onMove.bind(this);
		    this.onEnd = this.onEnd.bind(this);
		  }
	
		  _createClass(InfiniteScroll, [{
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      this.el = this.props.height ? this._infScroll : this.props.scrollableTarget || window;
		      this.el.addEventListener('scroll', this.throttledOnScrollListener);
	
		      if (typeof this.props.initialScrollY === 'number' && this.el.scrollHeight > this.props.initialScrollY) {
		        this.el.scrollTo(0, this.props.initialScrollY);
		      }
	
		      if (this.props.pullDownToRefresh) {
		        this.el.addEventListener('touchstart', this.onStart);
		        this.el.addEventListener('touchmove', this.onMove);
		        this.el.addEventListener('touchend', this.onEnd);
	
		        this.el.addEventListener('mousedown', this.onStart);
		        this.el.addEventListener('mousemove', this.onMove);
		        this.el.addEventListener('mouseup', this.onEnd);
	
		        // get BCR of pullDown element to position it above
		        this.maxPullDownDistance = this._pullDown.firstChild.getBoundingClientRect().height;
		        this.forceUpdate();
	
		        if (typeof this.props.refreshFunction !== 'function') {
		          throw new Error('Mandatory prop "refreshFunction" missing.\n          Pull Down To Refresh functionality will not work\n          as expected. Check README.md for usage\'');
		        }
		      }
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      this.el.removeEventListener('scroll', this.throttledOnScrollListener);
	
		      if (this.props.pullDownToRefresh) {
		        this.el.removeEventListener('touchstart', this.onStart);
		        this.el.removeEventListener('touchmove', this.onMove);
		        this.el.removeEventListener('touchend', this.onEnd);
	
		        this.el.removeEventListener('mousedown', this.onStart);
		        this.el.removeEventListener('mousemove', this.onMove);
		        this.el.removeEventListener('mouseup', this.onEnd);
		      }
		    }
		  }, {
		    key: 'componentWillReceiveProps',
		    value: function componentWillReceiveProps(props) {
		      // new data was sent in
		      this.setState({
		        showLoader: false,
		        actionTriggered: false,
		        pullToRefreshThresholdBreached: false
		      });
		    }
		  }, {
		    key: 'onStart',
		    value: function onStart(evt) {
		      if (this.state.lastScrollTop) return;
	
		      this.dragging = true;
		      this.startY = evt.pageY || evt.touches[0].pageY;
		      this.currentY = this.startY;
	
		      this._infScroll.style.willChange = 'transform';
		      this._infScroll.style.transition = 'transform 0.2s cubic-bezier(0,0,0.31,1)';
		    }
		  }, {
		    key: 'onMove',
		    value: function onMove(evt) {
		      if (!this.dragging) return;
		      this.currentY = evt.pageY || evt.touches[0].pageY;
	
		      // user is scrolling down to up
		      if (this.currentY < this.startY) return;
	
		      if (this.currentY - this.startY >= this.props.pullDownToRefreshThreshold) {
		        this.setState({
		          pullToRefreshThresholdBreached: true
		        });
		      }
	
		      // so you can drag upto 1.5 times of the maxPullDownDistance
		      if (this.currentY - this.startY > this.maxPullDownDistance * 1.5) return;
	
		      this._infScroll.style.overflow = 'visible';
		      this._infScroll.style.transform = 'translate3d(0px, ' + (this.currentY - this.startY) + 'px, 0px)';
		    }
		  }, {
		    key: 'onEnd',
		    value: function onEnd(evt) {
		      var _this = this;
	
		      this.startY = 0;
		      this.currentY = 0;
	
		      this.dragging = false;
	
		      if (this.state.pullToRefreshThresholdBreached) {
		        this.props.refreshFunction && this.props.refreshFunction();
		      }
	
		      requestAnimationFrame(function () {
		        _this._infScroll.style.overflow = 'auto';
		        _this._infScroll.style.transform = 'none';
		        _this._infScroll.style.willChange = 'none';
		      });
		    }
		  }, {
		    key: 'isElementAtBottom',
		    value: function isElementAtBottom(target) {
		      var scrollThreshold = arguments.length <= 1 || arguments[1] === undefined ? 0.8 : arguments[1];
	
		      var clientHeight = target === document.body || target === document.documentElement ? window.screen.availHeight : target.clientHeight;
	
		      var scrolled = scrollThreshold * (target.scrollHeight - target.scrollTop);
		      return scrolled <= clientHeight;
		    }
		  }, {
		    key: 'onScrollListener',
		    value: function onScrollListener(event) {
		      var _this2 = this;
	
		      if (typeof this.props.onScroll === 'function') {
		        // Execute this callback in next tick so that it does not affect the
		        // functionality of the library.
		        setTimeout(function () {
		          return _this2.props.onScroll(event);
		        }, 0);
		      }
	
		      var target = this.props.height || this.props.scrollableTarget ? event.target : document.documentElement.scrollTop ? document.documentElement : document.body;
	
		      // if user scrolls up, remove action trigger lock
		      if (target.scrollTop < this.state.lastScrollTop) {
		        this.setState({
		          actionTriggered: false,
		          lastScrollTop: target.scrollTop
		        });
		        return; // user's going up, we don't care
		      }
	
		      // return immediately if the action has already been triggered,
		      // prevents multiple triggers.
		      if (this.state.actionTriggered) return;
	
		      var atBottom = this.isElementAtBottom(target, this.props.scrollThreshold);
	
		      // call the `next` function in the props to trigger the next data fetch
		      if (atBottom && this.props.hasMore) {
		        this.props.next();
		        this.setState({ actionTriggered: true, showLoader: true });
		      }
		      this.setState({ lastScrollTop: target.scrollTop });
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _this3 = this;
	
		      var style = _extends({
		        height: this.props.height || 'auto',
		        overflow: 'auto',
		        WebkitOverflowScrolling: 'touch'
		      }, this.props.style);
		      var hasChildren = this.props.hasChildren || !!(this.props.children && this.props.children.length);
	
		      // because heighted infiniteScroll visualy breaks
		      // on drag down as overflow becomes visible
		      var outerDivStyle = this.props.pullDownToRefresh && this.props.height ? { overflow: 'auto' } : {};
		      return _react2['default'].createElement(
		        'div',
		        { style: outerDivStyle },
		        _react2['default'].createElement(
		          'div',
		          {
		            className: 'infinite-scroll-component',
		            ref: function (infScroll) {
		              return _this3._infScroll = infScroll;
		            },
		            style: style
		          },
		          this.props.pullDownToRefresh && _react2['default'].createElement(
		            'div',
		            {
		              style: { position: 'relative' },
		              ref: function (pullDown) {
		                return _this3._pullDown = pullDown;
		              }
		            },
		            _react2['default'].createElement(
		              'div',
		              { style: {
		                  position: 'absolute',
		                  left: 0,
		                  right: 0,
		                  top: -1 * this.maxPullDownDistance
		                } },
		              !this.state.pullToRefreshThresholdBreached && this.props.pullDownToRefreshContent,
		              this.state.pullToRefreshThresholdBreached && this.props.releaseToRefreshContent
		            )
		          ),
		          this.props.children,
		          !this.state.showLoader && !hasChildren && this.props.hasMore && this.props.loader,
		          this.state.showLoader && this.props.loader,
		          !this.props.hasMore && this.props.endMessage
		        )
		      );
		    }
		  }]);
	
		  return InfiniteScroll;
		})(_react.Component);
	
		exports['default'] = InfiniteScroll;
	
		InfiniteScroll.defaultProps = {
		  pullDownToRefreshContent: _react2['default'].createElement(
		    'h3',
		    null,
		    'Pull down to refresh'
		  ),
		  releaseToRefreshContent: _react2['default'].createElement(
		    'h3',
		    null,
		    'Release to refresh'
		  ),
		  pullDownToRefreshThreshold: 100,
		  disableBrowserPullToRefresh: true
		};
	
		InfiniteScroll.propTypes = {
		  next: _propTypes2['default'].func,
		  hasMore: _propTypes2['default'].bool,
		  children: _propTypes2['default'].node,
		  loader: _propTypes2['default'].node.isRequired,
		  scrollThreshold: _propTypes2['default'].number,
		  endMessage: _propTypes2['default'].node,
		  style: _propTypes2['default'].object,
		  height: _propTypes2['default'].number,
		  scrollableTarget: _propTypes2['default'].node,
		  hasChildren: _propTypes2['default'].bool,
		  pullDownToRefresh: _propTypes2['default'].bool,
		  pullDownToRefreshContent: _propTypes2['default'].node,
		  releaseToRefreshContent: _propTypes2['default'].node,
		  pullDownToRefreshThreshold: _propTypes2['default'].number,
		  refreshFunction: _propTypes2['default'].func,
		  onScroll: _propTypes2['default'].func
		};
		module.exports = exports['default'];
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		// https://remysharp.com/2010/07/21/throttling-function-calls
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = throttle;
	
		function throttle(fn, threshhold, scope) {
		  threshhold || (threshhold = 250);
		  var last, deferTimer;
		  return function () {
		    var context = scope || this;
	
		    var now = +new Date(),
		        args = arguments;
		    if (last && now < last + threshhold) {
		      // hold on to it
		      clearTimeout(deferTimer);
		      deferTimer = setTimeout(function () {
		        last = now;
		        fn.apply(context, args);
		      }, threshhold);
		    } else {
		      last = now;
		      fn.apply(context, args);
		    }
		  };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		function makeEmptyFunction(arg) {
		  return function () {
		    return arg;
		  };
		}
	
		/**
		 * This function accepts and discards inputs; it has no side effects. This is
		 * primarily useful idiomatically for overridable function endpoints which
		 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
		 */
		var emptyFunction = function emptyFunction() {};
	
		emptyFunction.thatReturns = makeEmptyFunction;
		emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
		emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
		emptyFunction.thatReturnsNull = makeEmptyFunction(null);
		emptyFunction.thatReturnsThis = function () {
		  return this;
		};
		emptyFunction.thatReturnsArgument = function (arg) {
		  return arg;
		};
	
		module.exports = emptyFunction;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		var validateFormat = function validateFormat(format) {};
	
		if (false) {
		  validateFormat = function validateFormat(format) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  };
		}
	
		function invariant(condition, format, a, b, c, d, e, f) {
		  validateFormat(format);
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
	
		module.exports = invariant;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(2);
		var invariant = __webpack_require__(3);
		var ReactPropTypesSecret = __webpack_require__(6);
	
		module.exports = function() {
		  function shim(props, propName, componentName, location, propFullName, secret) {
		    if (secret === ReactPropTypesSecret) {
		      // It is still safe when called from React.
		      return;
		    }
		    invariant(
		      false,
		      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		      'Use PropTypes.checkPropTypes() to call them. ' +
		      'Read more at http://fb.me/use-check-prop-types'
		    );
		  };
		  shim.isRequired = shim;
		  function getShim() {
		    return shim;
		  };
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
		  var ReactPropTypes = {
		    array: shim,
		    bool: shim,
		    func: shim,
		    number: shim,
		    object: shim,
		    string: shim,
		    symbol: shim,
	
		    any: shim,
		    arrayOf: getShim,
		    element: shim,
		    instanceOf: getShim,
		    node: shim,
		    objectOf: getShim,
		    oneOf: getShim,
		    oneOfType: getShim,
		    shape: getShim
		  };
	
		  ReactPropTypes.checkPropTypes = emptyFunction;
		  ReactPropTypes.PropTypes = ReactPropTypes;
	
		  return ReactPropTypes;
		};
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		if (false) {
		  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
		    Symbol.for &&
		    Symbol.for('react.element')) ||
		    0xeac7;
	
		  var isValidElement = function(object) {
		    return typeof object === 'object' &&
		      object !== null &&
		      object.$$typeof === REACT_ELEMENT_TYPE;
		  };
	
		  // By explicitly using `prop-types` you are opting into new development behavior.
		  // http://fb.me/prop-types-in-prod
		  var throwOnDirectAccess = true;
		  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
		} else {
		  // By explicitly using `prop-types` you are opting into new production behavior.
		  // http://fb.me/prop-types-in-prod
		  module.exports = __webpack_require__(4)();
		}
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
		module.exports = ReactPropTypesSecret;
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_7__;
	
	/***/ })
	/******/ ])
	});
	;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : undefined;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(52);
	var core = __webpack_require__(37);
	var ctx = __webpack_require__(229);
	var hide = __webpack_require__(71);
	var has = __webpack_require__(61);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 61 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(85);
	var IE8_DOM_DEFINE = __webpack_require__(231);
	var toPrimitive = __webpack_require__(152);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(51) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ },
/* 64 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _styleMaps = __webpack_require__(27);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _SafeAnchor = __webpack_require__(47);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var ButtonStyles = _styleMaps.State.values().concat(_styleMaps.DEFAULT, _styleMaps.PRIMARY, _styleMaps.LINK);
	
	var types = ['button', 'reset', 'submit'];
	
	var Button = (function (_React$Component) {
	  _inherits(Button, _React$Component);
	
	  function Button(props, context) {
	    _classCallCheck(this, Button);
	
	    _React$Component.call(this, props, context);
	  }
	
	  Button.prototype.render = function render() {
	    var _extends2;
	
	    var classes = this.props.navDropdown ? {} : _utilsBootstrapUtils.getClassSet(this.props);
	    var renderFuncName = undefined;
	
	    var blockClass = _utilsBootstrapUtils.prefix(this.props, 'block');
	
	    classes = _extends((_extends2 = {
	      active: this.props.active
	    }, _extends2[blockClass] = this.props.block, _extends2), classes);
	
	    if (this.props.navItem) {
	      return this.renderNavItem(classes);
	    }
	
	    renderFuncName = this.props.href || this.props.target || this.props.navDropdown ? 'renderAnchor' : 'renderButton';
	
	    return this[renderFuncName](classes);
	  };
	
	  Button.prototype.renderAnchor = function renderAnchor(classes) {
	    var _props = this.props;
	    var disabled = _props.disabled;
	    var href = _props.href;
	
	    classes.disabled = disabled;
	
	    return _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      _extends({}, this.props, {
	        href: href || '#',
	        className: _classnames2['default'](this.props.className, classes)
	      }),
	      this.props.children
	    );
	  };
	
	  Button.prototype.renderButton = function renderButton(classes) {
	    var Component = this.props.componentClass || 'button';
	
	    return _react2['default'].createElement(
	      Component,
	      _extends({}, this.props, {
	        type: this.props.type || 'button',
	        className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	  };
	
	  Button.prototype.renderNavItem = function renderNavItem(classes) {
	    var liClasses = {
	      active: this.props.active
	    };
	
	    return _react2['default'].createElement(
	      'li',
	      { className: _classnames2['default'](liClasses) },
	      this.renderAnchor(classes)
	    );
	  };
	
	  return Button;
	})(_react2['default'].Component);
	
	Button.propTypes = {
	  active: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  block: _react2['default'].PropTypes.bool,
	  navItem: _react2['default'].PropTypes.bool,
	  navDropdown: _react2['default'].PropTypes.bool,
	  onClick: _react2['default'].PropTypes.func,
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _reactPropTypesLibElementType2['default'],
	  href: _react2['default'].PropTypes.string,
	  target: _react2['default'].PropTypes.string,
	  /**
	   * Defines HTML button type Attribute
	   * @type {("button"|"reset"|"submit")}
	   * @defaultValue 'button'
	   */
	  type: _react2['default'].PropTypes.oneOf(types)
	};
	
	Button.defaultProps = {
	  active: false,
	  block: false,
	  disabled: false,
	  navItem: false,
	  navDropdown: false
	};
	
	Button.types = types;
	
	exports['default'] = _utilsBootstrapUtils.bsStyles(ButtonStyles, _styleMaps.DEFAULT, _utilsBootstrapUtils.bsSizes([_styleMaps.Sizes.LARGE, _styleMaps.Sizes.SMALL, _styleMaps.Sizes.XSMALL], _utilsBootstrapUtils.bsClass('btn', Button)));
	module.exports = exports['default'];

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(919);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, rootID, transaction, context) {
	    var markup = internalInstance.mountComponent(rootID, transaction, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent();
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction) {
	    internalInstance.performUpdateIfNecessary(transaction);
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(59);
	
	var assign = __webpack_require__(17);
	var emptyFunction = __webpack_require__(42);
	var warning = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 */
	function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  this.dispatchConfig = dispatchConfig;
	  this.dispatchMarker = dispatchMarker;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	}
	
	assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `preventDefault` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `stopPropagation` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      this[propName] = null;
	    }
	    this.dispatchConfig = null;
	    this.dispatchMarker = null;
	    this.nativeEvent = null;
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var prototype = Object.create(Super.prototype);
	  assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	exports.ccAvenue = ccAvenue;
	exports.razorpayForm = razorpayForm;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(524);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	function ccAvenue(params) {
			var basePayUrl = 'https://aqua.deals/paymentGateWay/paymentRequestHandler.php';
	
			var data1 = { access_code: 'AVIJ67DJ41BD20JIDB', merchant_id: '103328', order_id: params.order_id, merchant_param1: params.pre_payment_id, merchant_param2: params.deal_type, merchant_param3: params.cart_add_id, merchant_param4: 'desktop_web', amount: params.paid_amt, currency: 'INR', cancel_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', redirect_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', billing_name: params.username, billing_address: params.address, billing_city: params.city, billing_state: params.state, billing_zip: params.pincode, billing_tel: params.mobile, billing_country: 'India', billing_email: params.email };
			// var data1={access_code:'AVJZ66DG16BM17ZJMB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:add_id,merchant_param4:'desktop_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',redirect_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
	
			_jquery2.default.ajax({
					method: 'POST',
					data: data1,
					url: basePayUrl,
					success: function success(response) {
							(0, _jquery2.default)('' + self.state.pageId + '').html(response);
							if (response.status === 'error' && response.message === 'Token mismatch') {
									//data.props.tokenCheck();
							}
					},
					error: function error(err) {}
			});
	}
	
	function razorpayForm(params) {
			var orders_data = {
					receipt: params.order_id,
					//amount: 1*100, // 2000 rupees in paise
					amount: params.paid_amt * 100, // 2000 rupees in paise
					currency: 'INR',
					payment_capture: 0
			};
	
			var data1 = { from: params.from, orders_data: orders_data };
			var data2 = JSON.stringify(data1);
			_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'paymentHandlerWeb',
					data: { req: data2 },
					success: function success(response) {
							var rzp_order_id = response.razorpay_order_id;
							razorpay(rzp_order_id, params);
					},
					error: function error(err) {}
			});
	}
	
	function razorpay(rzp_order_id, params) {
			console.log(params);
			var options = {
					key: params.rzp_key,
					amount: params.paid_amt * 100,
					name: params.username,
					description: params.order_id,
					order_id: rzp_order_id,
					//billing_email:this.state.user_details.email,
					handler: function handler(response) {
							var paymentId = response.razorpay_payment_id;
							var orderId = response.razorpay_order_id;
							var signature = response.razorpay_signature;
	
							var data1 = { from: params.from, orders_data: options, razorpay_order_id: orderId, razorpay_payment_id: paymentId, razorpay_signature: signature };
							var data2 = JSON.stringify(data1);
							_jquery2.default.ajax({
									method: 'POST',
									url: baseUrl + 'rzpVerifySignature',
									data: { req: data2 },
									success: function success(response) {
											(0, _jquery2.default)('' + params.pageId + '').html(response);
									},
									error: function error(err) {}
							});
	
							// const url = process.env.URL+'/api/v1/rzp_capture/'+paymentId+'/'+payment_amount;
							// Using my server endpoints to capture the payment
					},
					"modal": {
							ondismiss: function ondismiss(response) {
									var data1 = { from: params.from, razorpay_order_id: rzp_order_id, razorpay_payment_id: '' };
									var data2 = JSON.stringify(data1);
									_jquery2.default.ajax({
											method: 'POST',
											url: baseUrl + 'rzpVerifySignature',
											data: { req: data2 },
											success: function (response) {
													if (response != 1) {
															(0, _jquery2.default)('' + params.pageId + '').html(response);
													}
													//$('.web_checkout_page').html(data);
											}.bind(response),
											error: function error(err) {}
									});
							}
					},
	
					prefill: {
							name: params.username,
							email: params.email ? params.email : '',
							contact: params.mobile
					},
					notes: {
							order_id: params.order_id,
							merchant_param1: params.pre_payment_id,
							merchant_param2: params.deal_type,
							merchant_param3: params.cart_add_id,
							merchant_param4: params.from,
							amount: params.paid_amt,
							billing_name: params.username,
							billing_address: params.address,
							billing_city: params.city,
							billing_state: params.state,
							billing_zip: params.pincode,
							billing_tel: params.mobile,
							billing_country: 'India',
							billing_email: params.email
					}, external: {
							wallets: ['paytm', 'amazonpay'],
							handler: function handler(data) {
									'data';
	
									if (data.wallet == 'paytm') {
											paytmGatewayHandler(params);
									}
									if (data.wallet == 'amazonpay') {
											//console.log(this, data);
									}
							}
					}
			};
	
			var rzp1 = new window.Razorpay(options);
			rzp1.open();
	}
	
	function paytmGatewayHandler(params) {
			var email = params.email ? params.email : '';
			var data1 = { from: params.from, ORDER_ID: params.order_id, INDUSTRY_TYPE_ID: 'Retail', CHANNEL_ID: 'WEB', TXN_AMOUNT: params.paid_amt, MOBILE: params.mobile, EMAIL: email, CUST_ID: params.uid, merchant_param1: params.pre_payment_id, merchant_param2: params.deal_type, merchant_param3: params.cart_add_id, merchant_param4: params.from };
			var data2 = JSON.stringify(data1);
			_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'paytmPaymentRequestHandler',
					data: { req: data2 },
					success: function success(data) {
							//console.log(data);
							(0, _jquery2.default)('html').html(data);
					},
					error: function error(err) {}
			});
	}

/***/ },
/* 70 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(62);
	var createDesc = __webpack_require__(103);
	module.exports = __webpack_require__(51) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 72 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(232);
	var defined = __webpack_require__(143);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(150)('wks');
	var uid = __webpack_require__(104);
	var Symbol = __webpack_require__(52).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/minus_orange.b73e9285.png";

/***/ },
/* 76 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 77 */
/***/ function(module, exports) {

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 78 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_ATTRIBUTE: 0x1,
	  MUST_USE_PROPERTY: 0x2,
	  HAS_SIDE_EFFECTS: 0x4,
	  HAS_BOOLEAN_VALUE: 0x8,
	  HAS_NUMERIC_VALUE: 0x10,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : undefined;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseAttribute: checkMask(propConfig, Injection.MUST_USE_ATTRIBUTE),
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	
	      !(!propertyInfo.mustUseAttribute || !propertyInfo.mustUseProperty) ?  false ? invariant(false, 'DOMProperty: Cannot require using both attribute and property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ?  false ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : undefined;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	var defaultValueCache = {};
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseAttribute:
	   *   Whether the property must be accessed and mutated using `*Attribute()`.
	   *   (This includes anything that fails `<propName> in <element>`.)
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasSideEffects:
	   *   Whether or not setting a value causes side effects such as triggering
	   *   resources to be loaded or text selection changes. If true, we read from
	   *   the DOM before updating to ensure that the value is only set if it has
	   *   changed.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Returns the default property value for a DOM property (i.e., not an
	   * attribute). Most default values are '' or false, but not all. Worse yet,
	   * some (in particular, `type`) vary depending on the type of element.
	   *
	   * TODO: Is it better to grab all the possible properties when creating an
	   * element to avoid having to create the same element twice?
	   */
	  getDefaultValueForProperty: function (nodeName, prop) {
	    var nodeDefaults = defaultValueCache[nodeName];
	    var testElement;
	    if (!nodeDefaults) {
	      defaultValueCache[nodeName] = nodeDefaults = {};
	    }
	    if (!(prop in nodeDefaults)) {
	      testElement = document.createElement(nodeName);
	      nodeDefaults[prop] = testElement[prop];
	    }
	    return nodeDefaults[prop];
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceHandles
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactRootIndex = __webpack_require__(371);
	
	var invariant = __webpack_require__(14);
	
	var SEPARATOR = '.';
	var SEPARATOR_LENGTH = SEPARATOR.length;
	
	/**
	 * Maximum depth of traversals before we consider the possibility of a bad ID.
	 */
	var MAX_TREE_DEPTH = 10000;
	
	/**
	 * Creates a DOM ID prefix to use when mounting React components.
	 *
	 * @param {number} index A unique integer
	 * @return {string} React root ID.
	 * @internal
	 */
	function getReactRootIDString(index) {
	  return SEPARATOR + index.toString(36);
	}
	
	/**
	 * Checks if a character in the supplied ID is a separator or the end.
	 *
	 * @param {string} id A React DOM ID.
	 * @param {number} index Index of the character to check.
	 * @return {boolean} True if the character is a separator or end of the ID.
	 * @private
	 */
	function isBoundary(id, index) {
	  return id.charAt(index) === SEPARATOR || index === id.length;
	}
	
	/**
	 * Checks if the supplied string is a valid React DOM ID.
	 *
	 * @param {string} id A React DOM ID, maybe.
	 * @return {boolean} True if the string is a valid React DOM ID.
	 * @private
	 */
	function isValidID(id) {
	  return id === '' || id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR;
	}
	
	/**
	 * Checks if the first ID is an ancestor of or equal to the second ID.
	 *
	 * @param {string} ancestorID
	 * @param {string} descendantID
	 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
	 * @internal
	 */
	function isAncestorIDOf(ancestorID, descendantID) {
	  return descendantID.indexOf(ancestorID) === 0 && isBoundary(descendantID, ancestorID.length);
	}
	
	/**
	 * Gets the parent ID of the supplied React DOM ID, `id`.
	 *
	 * @param {string} id ID of a component.
	 * @return {string} ID of the parent, or an empty string.
	 * @private
	 */
	function getParentID(id) {
	  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
	}
	
	/**
	 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
	 * supplied `destinationID`. If they are equal, the ID is returned.
	 *
	 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
	 * @param {string} destinationID ID of the destination node.
	 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
	 * @private
	 */
	function getNextDescendantID(ancestorID, destinationID) {
	  !(isValidID(ancestorID) && isValidID(destinationID)) ?  false ? invariant(false, 'getNextDescendantID(%s, %s): Received an invalid React DOM ID.', ancestorID, destinationID) : invariant(false) : undefined;
	  !isAncestorIDOf(ancestorID, destinationID) ?  false ? invariant(false, 'getNextDescendantID(...): React has made an invalid assumption about ' + 'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.', ancestorID, destinationID) : invariant(false) : undefined;
	  if (ancestorID === destinationID) {
	    return ancestorID;
	  }
	  // Skip over the ancestor and the immediate separator. Traverse until we hit
	  // another separator or we reach the end of `destinationID`.
	  var start = ancestorID.length + SEPARATOR_LENGTH;
	  var i;
	  for (i = start; i < destinationID.length; i++) {
	    if (isBoundary(destinationID, i)) {
	      break;
	    }
	  }
	  return destinationID.substr(0, i);
	}
	
	/**
	 * Gets the nearest common ancestor ID of two IDs.
	 *
	 * Using this ID scheme, the nearest common ancestor ID is the longest common
	 * prefix of the two IDs that immediately preceded a "marker" in both strings.
	 *
	 * @param {string} oneID
	 * @param {string} twoID
	 * @return {string} Nearest common ancestor ID, or the empty string if none.
	 * @private
	 */
	function getFirstCommonAncestorID(oneID, twoID) {
	  var minLength = Math.min(oneID.length, twoID.length);
	  if (minLength === 0) {
	    return '';
	  }
	  var lastCommonMarkerIndex = 0;
	  // Use `<=` to traverse until the "EOL" of the shorter string.
	  for (var i = 0; i <= minLength; i++) {
	    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
	      lastCommonMarkerIndex = i;
	    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
	      break;
	    }
	  }
	  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
	  !isValidID(longestCommonID) ?  false ? invariant(false, 'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s', oneID, twoID, longestCommonID) : invariant(false) : undefined;
	  return longestCommonID;
	}
	
	/**
	 * Traverses the parent path between two IDs (either up or down). The IDs must
	 * not be the same, and there must exist a parent path between them. If the
	 * callback returns `false`, traversal is stopped.
	 *
	 * @param {?string} start ID at which to start traversal.
	 * @param {?string} stop ID at which to end traversal.
	 * @param {function} cb Callback to invoke each ID with.
	 * @param {*} arg Argument to invoke the callback with.
	 * @param {?boolean} skipFirst Whether or not to skip the first node.
	 * @param {?boolean} skipLast Whether or not to skip the last node.
	 * @private
	 */
	function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
	  start = start || '';
	  stop = stop || '';
	  !(start !== stop) ?  false ? invariant(false, 'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.', start) : invariant(false) : undefined;
	  var traverseUp = isAncestorIDOf(stop, start);
	  !(traverseUp || isAncestorIDOf(start, stop)) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' + 'not have a parent path.', start, stop) : invariant(false) : undefined;
	  // Traverse from `start` to `stop` one depth at a time.
	  var depth = 0;
	  var traverse = traverseUp ? getParentID : getNextDescendantID;
	  for (var id = start;; /* until break */id = traverse(id, stop)) {
	    var ret;
	    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
	      ret = cb(id, traverseUp, arg);
	    }
	    if (ret === false || id === stop) {
	      // Only break //after// visiting `stop`.
	      break;
	    }
	    !(depth++ < MAX_TREE_DEPTH) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' + 'traversing the React DOM ID tree. This may be due to malformed IDs: %s', start, stop, id) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Manages the IDs assigned to DOM representations of React components. This
	 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
	 * order to simulate events).
	 *
	 * @internal
	 */
	var ReactInstanceHandles = {
	
	  /**
	   * Constructs a React root ID
	   * @return {string} A React root ID.
	   */
	  createReactRootID: function () {
	    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
	  },
	
	  /**
	   * Constructs a React ID by joining a root ID with a name.
	   *
	   * @param {string} rootID Root ID of a parent component.
	   * @param {string} name A component's name (as flattened children).
	   * @return {string} A React ID.
	   * @internal
	   */
	  createReactID: function (rootID, name) {
	    return rootID + name;
	  },
	
	  /**
	   * Gets the DOM ID of the React component that is the root of the tree that
	   * contains the React component with the supplied DOM ID.
	   *
	   * @param {string} id DOM ID of a React component.
	   * @return {?string} DOM ID of the React component that is the root.
	   * @internal
	   */
	  getReactRootIDFromNodeID: function (id) {
	    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
	      var index = id.indexOf(SEPARATOR, 1);
	      return index > -1 ? id.substr(0, index) : id;
	    }
	    return null;
	  },
	
	  /**
	   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	   * should would receive a `mouseEnter` or `mouseLeave` event.
	   *
	   * NOTE: Does not invoke the callback on the nearest common ancestor because
	   * nothing "entered" or "left" that element.
	   *
	   * @param {string} leaveID ID being left.
	   * @param {string} enterID ID being entered.
	   * @param {function} cb Callback to invoke on each entered/left ID.
	   * @param {*} upArg Argument to invoke the callback with on left IDs.
	   * @param {*} downArg Argument to invoke the callback with on entered IDs.
	   * @internal
	   */
	  traverseEnterLeave: function (leaveID, enterID, cb, upArg, downArg) {
	    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
	    if (ancestorID !== leaveID) {
	      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
	    }
	    if (ancestorID !== enterID) {
	      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
	    }
	  },
	
	  /**
	   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseTwoPhase: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, false);
	      traverseParentPath(targetID, '', cb, arg, false, true);
	    }
	  },
	
	  /**
	   * Same as `traverseTwoPhase` but skips the `targetID`.
	   */
	  traverseTwoPhaseSkipTarget: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, true);
	      traverseParentPath(targetID, '', cb, arg, true, true);
	    }
	  },
	
	  /**
	   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
	   * example, passing `.0.$row-0.1` would result in `cb` getting called
	   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseAncestors: function (targetID, cb, arg) {
	    traverseParentPath('', targetID, cb, arg, true, false);
	  },
	
	  getFirstCommonAncestorID: getFirstCommonAncestorID,
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getNextDescendantID: getNextDescendantID,
	
	  isAncestorIDOf: isAncestorIDOf,
	
	  SEPARATOR: SEPARATOR
	
	};
	
	module.exports = ReactInstanceHandles;

/***/ },
/* 82 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.makeFieldValue = makeFieldValue;
	exports.isFieldValue = isFieldValue;
	var flag = '_isFieldValue';
	var isObject = function isObject(object) {
	  return typeof object === 'object';
	};
	
	function makeFieldValue(object) {
	  if (object && isObject(object)) {
	    // This flag has to be enumerable, because otherwise it is not possible
	    // to serialize object with this field.
	    // The consequence is you lose information that particular field is
	    // field or nested group of fields, so you're not able to fetch
	    // field value from state when it has been affected in some way
	    // by serializing/using immutable and so on.
	    // @fixme marking field as leaf should be made in other way
	    Object.defineProperty(object, flag, { value: true, enumerable: true });
	  }
	  return object;
	}
	
	function isFieldValue(object) {
	  return !!(object && isObject(object) && object[flag]);
	}

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ccAvenue = ccAvenue;
	exports.razorpayForm = razorpayForm;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(463);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	function ccAvenue(params) {
		var basePayUrl = 'https://aqua.deals/paymentGateWay/paymentRequestHandler.php';
		// var basePayUrl='http://203.193.173.125/paymentGateWay/paymentRequestHandler.php';
		var data1 = { access_code: 'AVIJ67DJ41BD20JIDB', merchant_id: '103328', order_id: params.order_id, merchant_param1: params.pre_payment_id, merchant_param2: params.deal_type, merchant_param3: params.cart_add_id, merchant_param4: 'desktop_web', amount: params.paid_amt, currency: 'INR', cancel_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', redirect_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', billing_name: params.username, billing_address: params.address, billing_city: params.city, billing_state: params.state, billing_zip: params.pincode, billing_tel: params.mobile, billing_country: 'India', billing_email: params.email };
		// var data1={access_code:'AVJZ66DG16BM17ZJMB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:add_id,merchant_param4:'desktop_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',redirect_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
	
		_jquery2.default.ajax({
			method: 'POST',
			data: data1,
			url: basePayUrl,
			success: function success(response) {
				(0, _jquery2.default)('' + self.state.pageId + '').html(response);
				if (response.status === 'error' && response.message === 'Token mismatch') {
					//data.props.tokenCheck();
				}
			},
			error: function error(err) {}
		});
	}
	
	function razorpayForm(params) {
		var orders_data = {
			receipt: params.order_id,
			//amount: 1*100, // 2000 rupees in paise
			amount: params.paid_amt * 100, // 2000 rupees in paise
			currency: 'INR',
			payment_capture: 0
		};
	
		var data1 = { from: params.from, orders_data: orders_data };
		var data2 = JSON.stringify(data1);
		_jquery2.default.ajax({
			method: 'POST',
			dataType: 'json',
			url: baseUrl + 'paymentHandlerWeb',
			data: { req: data2 },
			success: function success(response) {
				var rzp_order_id = response.razorpay_order_id;
				razorpay(rzp_order_id, params);
			},
			error: function error(err) {}
		});
	}
	
	function razorpay(rzp_order_id, params) {
		console.log(params);
		var options = {
			key: params.rzp_key,
			amount: params.paid_amt * 100,
			name: params.username,
			description: params.order_id,
			order_id: rzp_order_id,
			//billing_email:this.state.user_details.email,
			handler: function handler(response) {
				var paymentId = response.razorpay_payment_id;
				var orderId = response.razorpay_order_id;
				var signature = response.razorpay_signature;
	
				var data1 = { from: params.from, orders_data: options, razorpay_order_id: orderId, razorpay_payment_id: paymentId, razorpay_signature: signature };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'rzpVerifySignature',
					data: { req: data2 },
					success: function success(response) {
						(0, _jquery2.default)('' + params.pageId + '').html(response);
					},
					error: function error(err) {}
				});
	
				// const url = process.env.URL+'/api/v1/rzp_capture/'+paymentId+'/'+payment_amount;
				// Using my server endpoints to capture the payment
			},
			"modal": {
				ondismiss: function ondismiss(response) {
					var data1 = { from: params.from, razorpay_order_id: rzp_order_id, razorpay_payment_id: '' };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						url: baseUrl + 'rzpVerifySignature',
						data: { req: data2 },
						success: function (response) {
							if (response != 1) {
								(0, _jquery2.default)('' + params.pageId + '').html(response);
							}
							//$('.web_checkout_page').html(data);
						}.bind(response),
						error: function error(err) {}
					});
				}
			},
	
			prefill: {
				name: params.username,
				email: params.email ? params.email : '',
				contact: params.mobile
			},
			notes: {
				order_id: params.order_id,
				merchant_param1: params.pre_payment_id,
				merchant_param2: params.deal_type,
				merchant_param3: params.cart_add_id,
				merchant_param4: params.from,
				amount: params.paid_amt,
				billing_name: params.username,
				billing_address: params.address,
				billing_city: params.city,
				billing_state: params.state,
				billing_zip: params.pincode,
				billing_tel: params.mobile,
				billing_country: 'India',
				billing_email: params.email
			}, external: {
				wallets: ['paytm', 'amazonpay'],
				handler: function handler(data) {
					'data';
	
					if (data.wallet == 'paytm') {
						paytmGatewayHandler(params);
					}
					if (data.wallet == 'amazonpay') {
						//console.log(this, data);
					}
				}
			}
		};
	
		var rzp1 = new window.Razorpay(options);
		rzp1.open();
	}
	
	function paytmGatewayHandler(params) {
		var email = params.email ? params.email : '';
		var data1 = { from: params.from, ORDER_ID: params.order_id, INDUSTRY_TYPE_ID: 'Retail', CHANNEL_ID: 'WEB', TXN_AMOUNT: params.paid_amt, MOBILE: params.mobile, EMAIL: email, CUST_ID: params.uid, merchant_param1: params.pre_payment_id, merchant_param2: params.deal_type, merchant_param3: params.cart_add_id, merchant_param4: params.from };
		var data2 = JSON.stringify(data1);
		_jquery2.default.ajax({
			method: 'POST',
			url: baseUrl + 'paytmPaymentRequestHandler',
			data: { req: data2 },
			success: function success(data) {
				//console.log(data);
				(0, _jquery2.default)('html').html(data);
			},
			error: function error(err) {}
		});
	}

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(139);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _reactRouter = __webpack_require__(2);
	
	var _Footer = __webpack_require__(138);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import SubHeaderMain from './SubHeaderMain.js';
	
	
	var NotFound = function (_Component) {
		_inherits(NotFound, _Component);
	
		function NotFound() {
			_classCallCheck(this, NotFound);
	
			return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
		}
	
		_createClass(NotFound, [{
			key: 'render',
			value: function render() {
				var home_url = '/';
				var footer = _react2.default.createElement(_Footer2.default, null);
				if (screen.width >= 800) {
					home_url = '/web/home';
					footer = _react2.default.createElement(_WebFooter2.default, null);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'lgt_gry mob_deals' },
					_react2.default.createElement(_Header2.default, null),
					_react2.default.createElement(
						'section',
						{ className: 'container error_cntnt' },
						_react2.default.createElement(
							'div',
							{ className: 'col-md-6 col-md-offset-3 eror_cntnt_blk' },
							_react2.default.createElement(
								'h1',
								null,
								'404 Error',
								_react2.default.createElement('br', null),
								_react2.default.createElement(
									'span',
									null,
									'Oops! Page not found'
								),
								' '
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ href: home_url, className: 'back_hm_btn' },
								'Back to Home'
							)
						)
					),
					footer
				);
			}
		}]);
	
		return NotFound;
	}(_react.Component);
	
	exports.default = NotFound;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(72);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(237);
	var enumBugKeys = __webpack_require__(144);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(143);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(290);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var origDefineProperty = Object.defineProperty;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			origDefineProperty(obj, 'x', { enumerable: false, value: obj });
			// eslint-disable-next-line no-unused-vars, no-restricted-syntax
			for (var _ in obj) { // jscs:ignore disallowUnusedVariables
				return false;
			}
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			origDefineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 89 */
/***/ function(module, exports) {

	'use strict';
	module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyObject
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message = undefined;
	
	  if (typeof oldname === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + ' is deprecated. Use ' + newname + ' instead.';
	
	    if (link) {
	      message += '\nYou can read more about it at ' + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? _warning2['default'](false, message) : undefined;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return (function (_Component) {
	    _inherits(DeprecatedComponent, _Component);
	
	    function DeprecatedComponent() {
	      _classCallCheck(this, DeprecatedComponent);
	
	      _Component.apply(this, arguments);
	    }
	
	    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
	      deprecationWarning.apply(undefined, args);
	
	      if (_Component.prototype.componentWillMount) {
	        var _Component$prototype$componentWillMount;
	
	        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          methodArgs[_key2] = arguments[_key2];
	        }
	
	        (_Component$prototype$componentWillMount = _Component.prototype.componentWillMount).call.apply(_Component$prototype$componentWillMount, [this].concat(methodArgs));
	      }
	    };
	
	    return DeprecatedComponent;
	  })(Component);
	};
	
	exports['default'] = deprecationWarning;
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 92 */
[993, 786],
/* 93 */
/***/ function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(95);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 95 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(351);
	var EventPluginUtils = __webpack_require__(897);
	var ReactErrorUtils = __webpack_require__(364);
	
	var accumulateInto = __webpack_require__(373);
	var forEachAccumulated = __webpack_require__(374);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(16);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	/**
	 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
	 *   hierarchy given ids of the logical DOM elements involved.
	 */
	var InstanceHandle = null;
	
	function validateInstanceHandle() {
	  var valid = InstanceHandle && InstanceHandle.traverseTwoPhase && InstanceHandle.traverseEnterLeave;
	   false ? warning(valid, 'InstanceHandle not injected before use!') : undefined;
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {object} InjectedMount
	     * @public
	     */
	    injectMount: EventPluginUtils.injection.injectMount,
	
	    /**
	     * @param {object} InjectedInstanceHandle
	     * @public
	     */
	    injectInstanceHandle: function (InjectedInstanceHandle) {
	      InstanceHandle = InjectedInstanceHandle;
	      if (false) {
	        validateInstanceHandle();
	      }
	    },
	
	    getInstanceHandle: function () {
	      if (false) {
	        validateInstanceHandle();
	      }
	      return InstanceHandle;
	    },
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginRegistry.registrationNameModules,
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {?function} listener The callback to store.
	   */
	  putListener: function (id, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : undefined;
	
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[id] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(id, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[id];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (id, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(id, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[id];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {string} id ID of the DOM element.
	   */
	  deleteAllListeners: function (id) {
	    for (var registrationName in listenerBank) {
	      if (!listenerBank[registrationName][id]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(id, registrationName);
	      }
	
	      delete listenerBank[registrationName][id];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : undefined;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(48);
	var EventPluginHub = __webpack_require__(96);
	
	var warning = __webpack_require__(16);
	
	var accumulateInto = __webpack_require__(373);
	var forEachAccumulated = __webpack_require__(374);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(id, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(id, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(domID, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(domID, 'Dispatching id must not be null') : undefined;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(domID, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhaseSkipTarget(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(id, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(id, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event.dispatchMarker, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
	  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(fromID, toID, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 98 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(68);
	
	var getEventTarget = __webpack_require__(204);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(393);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(972);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(971);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(970);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(392);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(394);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 101 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 102 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 103 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 104 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyMirror
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function (obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ad_assest_pop_icon.2a4bcc68.png";

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon_cust_sup.ea02989d.png";

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mail_icn.30e46c94.png";

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/phone_icn.dafab0e2.png";

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/plus_fade.2122d67a.png";

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/timer_icn.f60de171.png";

/***/ },
/* 112 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(716);
	
	var _runTransitionHook = __webpack_require__(162);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(63);
	
	var _deprecate = __webpack_require__(161);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(702);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(273),
	    bindCallback = __webpack_require__(165),
	    pickByArray = __webpack_require__(283),
	    pickByCallback = __webpack_require__(284),
	    restParam = __webpack_require__(272);
	
	/**
	 * Creates an object composed of the picked `object` properties. Property
	 * names may be specified as individual arguments or as arrays of property
	 * names. If `predicate` is provided it's invoked for each property of `object`
	 * picking the properties `predicate` returns truthy for. The predicate is
	 * bound to `thisArg` and invoked with three arguments: (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|...(string|string[])} [predicate] The function invoked per
	 *  iteration or property names to pick, specified as individual property
	 *  names or arrays of property names.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'user': 'fred', 'age': 40 };
	 *
	 * _.pick(object, 'user');
	 * // => { 'user': 'fred' }
	 *
	 * _.pick(object, _.isString);
	 * // => { 'user': 'fred' }
	 */
	var pick = restParam(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  return typeof props[0] == 'function'
	    ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	    : pickByArray(object, baseFlatten(props));
	});
	
	module.exports = pick;


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _domHelpersActiveElement = __webpack_require__(605);
	
	var _domHelpersActiveElement2 = _interopRequireDefault(_domHelpersActiveElement);
	
	var _domHelpersQueryContains = __webpack_require__(156);
	
	var _domHelpersQueryContains2 = _interopRequireDefault(_domHelpersQueryContains);
	
	var _keycode = __webpack_require__(164);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _lodashCompatCollectionFind = __webpack_require__(669);
	
	var _lodashCompatCollectionFind2 = _interopRequireDefault(_lodashCompatCollectionFind);
	
	var _lodashCompatObjectOmit = __webpack_require__(171);
	
	var _lodashCompatObjectOmit2 = _interopRequireDefault(_lodashCompatObjectOmit);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactPropTypesLibAll = __webpack_require__(120);
	
	var _reactPropTypesLibAll2 = _interopRequireDefault(_reactPropTypesLibAll);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _reactPropTypesLibIsRequiredForA11y = __webpack_require__(122);
	
	var _reactPropTypesLibIsRequiredForA11y2 = _interopRequireDefault(_reactPropTypesLibIsRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(135);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _utilsCreateChainedFunction = __webpack_require__(32);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var _utilsCustomPropTypes = __webpack_require__(781);
	
	var _utilsCustomPropTypes2 = _interopRequireDefault(_utilsCustomPropTypes);
	
	var _utilsValidComponentChildren = __webpack_require__(28);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _ButtonGroup = __webpack_require__(295);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__(731);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__(298);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var TOGGLE_ROLE = _DropdownToggle2['default'].defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2['default'].defaultProps.bsRole;
	
	var Dropdown = (function (_React$Component) {
	  _inherits(Dropdown, _React$Component);
	
	  function Dropdown(props) {
	    _classCallCheck(this, Dropdown);
	
	    _React$Component.call(this, props);
	
	    this.Toggle = _DropdownToggle2['default'];
	
	    this.toggleOpen = this.toggleOpen.bind(this);
	    this.handleClick = this.handleClick.bind(this);
	    this.handleKeyDown = this.handleKeyDown.bind(this);
	    this.handleClose = this.handleClose.bind(this);
	    this.extractChildren = this.extractChildren.bind(this);
	
	    this.refineMenu = this.refineMenu.bind(this);
	    this.refineToggle = this.refineToggle.bind(this);
	
	    this.childExtractors = [{
	      key: 'toggle',
	      matches: function matches(child) {
	        return child.props.bsRole === TOGGLE_ROLE;
	      },
	      refine: this.refineToggle
	    }, {
	      key: 'menu',
	      exclusive: true,
	      matches: function matches(child) {
	        return child.props.bsRole === MENU_ROLE;
	      },
	      refine: this.refineMenu
	    }];
	
	    this.state = {};
	
	    this.lastOpenEventType = null;
	  }
	
	  Dropdown.prototype.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = _domHelpersQueryContains2['default'](_reactDom2['default'].findDOMNode(this.menu), _domHelpersActiveElement2['default'](document));
	    }
	  };
	
	  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.open && !prevProps.open) {
	      this.focusNextOnOpen();
	    }
	
	    if (!this.props.open && prevProps.open) {
	      // if focus hasn't already moved from the menu lets return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _rootClasses;
	
	    var children = this.extractChildren();
	    var Component = this.props.componentClass;
	
	    var props = _lodashCompatObjectOmit2['default'](this.props, ['id', 'bsClass', 'role', 'onSelect']);
	    var className = _utilsBootstrapUtils.prefix(this.props);
	
	    var rootClasses = (_rootClasses = {
	      open: this.props.open,
	      disabled: this.props.disabled
	    }, _rootClasses[className] = !this.props.dropup, _rootClasses.dropup = this.props.dropup, _rootClasses);
	
	    return _react2['default'].createElement(
	      Component,
	      _extends({}, props, {
	        className: _classnames2['default'](this.props.className, rootClasses)
	      }),
	      children
	    );
	  };
	
	  Dropdown.prototype.toggleOpen = function toggleOpen() {
	    var eventType = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventType;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open);
	    }
	  };
	
	  Dropdown.prototype.handleClick = function handleClick() {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen('click');
	  };
	
	  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        if (!this.props.open) {
	          this.toggleOpen('keydown');
	        } else if (this.menu.focusNext) {
	          this.menu.focusNext();
	        }
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.handleClose(event);
	        break;
	      default:
	    }
	  };
	
	  Dropdown.prototype.handleClose = function handleClose() {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen();
	  };
	
	  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.menu;
	
	    if (!menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  Dropdown.prototype.focus = function focus() {
	    var toggle = _reactDom2['default'].findDOMNode(this.toggle);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  Dropdown.prototype.extractChildren = function extractChildren() {
	    var _this = this;
	
	    var open = !!this.props.open;
	    var seen = {};
	
	    return _utilsValidComponentChildren2['default'].map(this.props.children, function (child) {
	      var extractor = _lodashCompatCollectionFind2['default'](_this.childExtractors, function (x) {
	        return x.matches(child);
	      });
	
	      if (extractor) {
	        if (seen[extractor.key]) {
	          return false;
	        }
	
	        seen[extractor.key] = extractor.exclusive;
	        child = extractor.refine(child, open);
	      }
	
	      return child;
	    });
	  };
	
	  Dropdown.prototype.refineMenu = function refineMenu(menu, open) {
	    var _this2 = this;
	
	    var ref = function ref(r) {
	      return _this2.menu = r;
	    };
	
	    if (typeof menu.ref === 'string') {
	       false ? _warning2['default'](false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature: \n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : undefined;
	    } else {
	      ref = _utilsCreateChainedFunction2['default'](menu.ref, ref);
	    }
	
	    var menuProps = {
	      ref: ref,
	      open: open,
	      labelledBy: this.props.id,
	      pullRight: this.props.pullRight,
	      bsClass: this.props.bsClass
	    };
	
	    menuProps.onClose = _utilsCreateChainedFunction2['default'](menu.props.onClose, this.props.onClose, this.handleClose);
	
	    menuProps.onSelect = _utilsCreateChainedFunction2['default'](menu.props.onSelect, this.props.onSelect, this.handleClose);
	
	    return _react.cloneElement(menu, menuProps, menu.props.children);
	  };
	
	  Dropdown.prototype.refineToggle = function refineToggle(toggle, open) {
	    var _this3 = this;
	
	    var ref = function ref(r) {
	      return _this3.toggle = r;
	    };
	
	    if (typeof toggle.ref === 'string') {
	       false ? _warning2['default'](false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature: \n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : undefined;
	    } else {
	      ref = _utilsCreateChainedFunction2['default'](toggle.ref, ref);
	    }
	
	    var toggleProps = {
	      ref: ref,
	      open: open,
	      id: this.props.id,
	      role: this.props.role
	    };
	
	    toggleProps.onClick = _utilsCreateChainedFunction2['default'](toggle.props.onClick, this.handleClick);
	
	    toggleProps.onKeyDown = _utilsCreateChainedFunction2['default'](toggle.props.onKeyDown, this.handleKeyDown);
	
	    return _react.cloneElement(toggle, toggleProps, toggle.props.children);
	  };
	
	  return Dropdown;
	})(_react2['default'].Component);
	
	Dropdown.Toggle = _DropdownToggle2['default'];
	
	Dropdown.TOGGLE_ROLE = TOGGLE_ROLE;
	Dropdown.MENU_ROLE = MENU_ROLE;
	
	Dropdown.defaultProps = {
	  componentClass: _ButtonGroup2['default'],
	  bsClass: 'dropdown'
	};
	
	Dropdown.propTypes = {
	
	  bsClass: _react2['default'].PropTypes.string,
	
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _react2['default'].PropTypes.bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: _reactPropTypesLibIsRequiredForA11y2['default'](_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	  componentClass: _reactPropTypesLibElementType2['default'],
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle/>` or a `<Dropdown.Menu/>`.
	   * @type {node}
	   */
	  children: _reactPropTypesLibAll2['default'](_utilsCustomPropTypes2['default'].requiredRoles(TOGGLE_ROLE, MENU_ROLE), _utilsCustomPropTypes2['default'].exclusiveRoles(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _react2['default'].PropTypes.bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _react2['default'].PropTypes.bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _react2['default'].PropTypes.bool,
	
	  /**
	   * A callback fired when the Dropdown closes.
	   */
	  onClose: _react2['default'].PropTypes.func,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value.
	   *
	   * ```js
	   * function(Boolean isOpen) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _react2['default'].PropTypes.func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _react2['default'].PropTypes.string
	};
	
	Dropdown = _uncontrollable2['default'](Dropdown, { open: 'onToggle' });
	
	Dropdown.Toggle = _DropdownToggle2['default'];
	Dropdown.Menu = _DropdownMenu2['default'];
	
	exports['default'] = Dropdown;
	module.exports = exports['default'];

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactOverlaysLibTransition = __webpack_require__(326);
	
	var _reactOverlaysLibTransition2 = _interopRequireDefault(_reactOverlaysLibTransition);
	
	var Fade = (function (_React$Component) {
	  _inherits(Fade, _React$Component);
	
	  function Fade() {
	    _classCallCheck(this, Fade);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  // Explicitly copied from Transition for doc generation.
	  // TODO: Remove duplication once #977 is resolved.
	
	  Fade.prototype.render = function render() {
	    var timeout = this.props.timeout;
	
	    return _react2['default'].createElement(
	      _reactOverlaysLibTransition2['default'],
	      _extends({}, this.props, {
	        timeout: timeout,
	        className: _classnames2['default'](this.props.className, 'fade'),
	        enteredClassName: 'in',
	        enteringClassName: 'in'
	      }),
	      this.props.children
	    );
	  };
	
	  return Fade;
	})(_react2['default'].Component);
	
	Fade.propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  'in': _react2['default'].PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _react2['default'].PropTypes.bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2['default'].PropTypes.bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _react2['default'].PropTypes.number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _react2['default'].PropTypes.func
	};
	
	Fade.defaultProps = {
	  'in': false,
	  timeout: 300,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	exports['default'] = Fade;
	module.exports = exports['default'];

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibDeprecated = __webpack_require__(121);
	
	var _reactPropTypesLibDeprecated2 = _interopRequireDefault(_reactPropTypesLibDeprecated);
	
	var Glyphicon = _react2['default'].createClass({
	  displayName: 'Glyphicon',
	
	  propTypes: {
	    /**
	     * bootstrap className
	     * @private
	     */
	    bsClass: _react2['default'].PropTypes.string,
	    /**
	     * An icon name. See e.g. http://getbootstrap.com/components/#glyphicons
	     */
	    glyph: _react2['default'].PropTypes.string.isRequired,
	    /**
	     * Adds 'form-control-feedback' class
	     * @private
	     */
	    formControlFeedback: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.bool, 'Use `<FormControl.Feedback>`.')
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'glyphicon'
	    };
	  },
	
	  render: function render() {
	    var _classNames;
	
	    var className = _classnames2['default'](this.props.className, (_classNames = {}, _classNames[this.props.bsClass] = true, _classNames['glyphicon-' + this.props.glyph] = true, _classNames['form-control-feedback'] = this.props.formControlFeedback, _classNames));
	
	    return _react2['default'].createElement(
	      'span',
	      _extends({}, this.props, { className: className }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Glyphicon;
	module.exports = exports['default'];

/***/ },
/* 119 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = all;
	
	var _common = __webpack_require__(188);
	
	function all() {
	  for (var _len = arguments.length, propTypes = Array(_len), _key = 0; _key < _len; _key++) {
	    propTypes[_key] = arguments[_key];
	  }
	
	  if (propTypes === undefined) {
	    throw new Error('No validations provided');
	  }
	
	  if (propTypes.some(function (propType) {
	    return typeof propType !== 'function';
	  })) {
	    throw new Error('Invalid arguments, must be functions');
	  }
	
	  if (propTypes.length === 0) {
	    throw new Error('No validations provided');
	  }
	
	  function validate(props, propName, componentName) {
	    for (var i = 0; i < propTypes.length; i++) {
	      var result = propTypes[i](props, propName, componentName);
	
	      if (result !== undefined && result !== null) {
	        return result;
	      }
	    }
	  }
	
	  return _common.createChainableTypeChecker(validate);
	}
	
	module.exports = exports['default'];

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = deprecated;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var warned = {};
	
	function deprecated(propType, explanation) {
	  return function validate(props, propName, componentName) {
	    if (props[propName] != null) {
	      var message = '"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation;
	      if (!warned[message]) {
	        _warning2['default'](false, message);
	        warned[message] = true;
	      }
	    }
	
	    return propType(props, propName, componentName);
	  };
	}
	
	function _resetWarned() {
	  warned = {};
	}
	
	deprecated._resetWarned = _resetWarned;
	module.exports = exports['default'];

/***/ },
/* 122 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = isRequiredForA11y;
	
	function isRequiredForA11y(propType) {
	  return function validate(props, propName, componentName) {
	    if (props[propName] == null) {
	      return new Error("The prop '" + propName + "' is required to make '" + componentName + "' accessible" + " for users using assistive technologies such as screen readers");
	    }
	
	    return propType(props, propName, componentName);
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(124);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(872);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(58);
	
	var _routerWarning = __webpack_require__(26);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(26);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(38);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _swipeJsIso = __webpack_require__(985);
	
	var _swipeJsIso2 = _interopRequireDefault(_swipeJsIso);
	
	var _objectAssign = __webpack_require__(885);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactSwipe = function (_Component) {
	  _inherits(ReactSwipe, _Component);
	
	  function ReactSwipe() {
	    _classCallCheck(this, ReactSwipe);
	
	    return _possibleConstructorReturn(this, (ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).apply(this, arguments));
	  }
	
	  _createClass(ReactSwipe, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var swipeOptions = this.props.swipeOptions;
	
	
	      this.swipe = (0, _swipeJsIso2.default)(this.container, swipeOptions);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props,
	          childCount = _props.childCount,
	          swipeOptions = _props.swipeOptions;
	
	
	      if (prevProps.childCount !== childCount) {
	        this.swipe.kill();
	        this.swipe = (0, _swipeJsIso2.default)(this.container, swipeOptions);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.swipe.kill();
	      this.swipe = void 0;
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      this.swipe.next();
	    }
	  }, {
	    key: 'prev',
	    value: function prev() {
	      this.swipe.prev();
	    }
	  }, {
	    key: 'slide',
	    value: function slide() {
	      var _swipe;
	
	      (_swipe = this.swipe).slide.apply(_swipe, arguments);
	    }
	  }, {
	    key: 'getPos',
	    value: function getPos() {
	      return this.swipe.getPos();
	    }
	  }, {
	    key: 'getNumSlides',
	    value: function getNumSlides() {
	      return this.swipe.getNumSlides();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          style = _props2.style,
	          children = _props2.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(container) {
	            return _this2.container = container;
	          }, id: id, className: 'react-swipe-container ' + className, style: style.container },
	        _react2.default.createElement(
	          'div',
	          { style: style.wrapper },
	          _react2.default.Children.map(children, function (child) {
	            if (!child) {
	              return null;
	            }
	
	            var childStyle = child.props.style ? (0, _objectAssign2.default)({}, style.child, child.props.style) : style.child;
	
	            return _react2.default.cloneElement(child, { style: childStyle });
	          })
	        )
	      );
	    }
	  }]);
	
	  return ReactSwipe;
	}(_react.Component);
	
	ReactSwipe.propTypes = {
	  swipeOptions: _propTypes2.default.shape({
	    startSlide: _propTypes2.default.number,
	    speed: _propTypes2.default.number,
	    auto: _propTypes2.default.number,
	    continuous: _propTypes2.default.bool,
	    disableScroll: _propTypes2.default.bool,
	    stopPropagation: _propTypes2.default.bool,
	    swiping: _propTypes2.default.func,
	    callback: _propTypes2.default.func,
	    transitionEnd: _propTypes2.default.func
	  }),
	  style: _propTypes2.default.shape({
	    container: _propTypes2.default.object,
	    wrapper: _propTypes2.default.object,
	    child: _propTypes2.default.object
	  }),
	  id: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  childCount: _propTypes2.default.number
	};
	ReactSwipe.defaultProps = {
	  swipeOptions: {},
	  style: {
	    container: {
	      overflow: 'hidden',
	      visibility: 'hidden',
	      position: 'relative'
	    },
	
	    wrapper: {
	      overflow: 'hidden',
	      position: 'relative'
	    },
	
	    child: {
	      float: 'left',
	      width: '100%',
	      position: 'relative',
	      transitionProperty: 'transform'
	    }
	  },
	  className: '',
	  childCount: 0
	};
	exports.default = ReactSwipe;
	module.exports = exports['default'];


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(48);
	var EventPluginHub = __webpack_require__(96);
	var EventPluginRegistry = __webpack_require__(351);
	var ReactEventEmitterMixin = __webpack_require__(912);
	var ReactPerf = __webpack_require__(40);
	var ViewportMetrics = __webpack_require__(372);
	
	var assign = __webpack_require__(17);
	var isEventSupported = __webpack_require__(207);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (!isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  },
	
	  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginHub.registrationNameModules,
	
	  putListener: EventPluginHub.putListener,
	
	  getListener: EventPluginHub.getListener,
	
	  deleteListener: EventPluginHub.deleteListener,
	
	  deleteAllListeners: EventPluginHub.deleteAllListeners
	
	});
	
	ReactPerf.measureMethods(ReactBrowserEventEmitter, 'ReactBrowserEventEmitter', {
	  putListener: 'putListener',
	  deleteListener: 'deleteListener'
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(105);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(99);
	var ViewportMetrics = __webpack_require__(372);
	
	var getEventModifierState = __webpack_require__(203);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : undefined;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : undefined;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 132 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = function (node, html) {
	  node.innerHTML = html;
	};
	
	// Win8 apps: Allow all html to be inserted
	if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	  setInnerHTML = function (node, html) {
	    MSApp.execUnsafeLocalFunction(function () {
	      node.innerHTML = html;
	    });
	  };
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 134 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isValid;
	function isValid(error) {
	  if (Array.isArray(error)) {
	    return error.reduce(function (valid, errorValue) {
	      return valid && isValid(errorValue);
	    }, true);
	  }
	  if (error && typeof error === 'object') {
	    return Object.keys(error).reduce(function (valid, key) {
	      return valid && isValid(error[key]);
	    }, true);
	  }
	  return !error;
	}

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(989);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (component.isMounted()) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)([mixin], set);
	module.exports = exports['default'];

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import SubHeaderMain from './SubHeaderMain.js';
	
	
	var Web_NotFound = function (_Component) {
		_inherits(Web_NotFound, _Component);
	
		function Web_NotFound() {
			_classCallCheck(this, Web_NotFound);
	
			return _possibleConstructorReturn(this, (Web_NotFound.__proto__ || Object.getPrototypeOf(Web_NotFound)).apply(this, arguments));
		}
	
		_createClass(Web_NotFound, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'lgt_gry web_deals' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'container error_cntnt' },
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-md-6 col-md-offset-3 eror_cntnt_blk' },
							_react2.default.createElement(
								'h1',
								null,
								'404 Error',
								_react2.default.createElement('br', null),
								_react2.default.createElement(
									'span',
									null,
									'Oops! Page not found'
								),
								' '
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: "/web/home", className: 'back_hm_btn' },
								'Back to Home'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_NotFound;
	}(_react.Component);
	
	exports.default = Web_NotFound;

/***/ },
/* 137 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var AUTH_USER = exports.AUTH_USER = "AUTH_USER";
	var LOGOUT_USER = exports.LOGOUT_USER = "LOGOUT_USER";
	var AUTH_ERROR = exports.AUTH_ERROR = "AUTH_ERROR";
	var FETCH_POST = exports.FETCH_POST = "FETCH_POST";
	var ADD_POST = exports.ADD_POST = "ADD_POST";
	var POST_SHOW = exports.POST_SHOW = "POST_SHOW";
	var DELETE_POST = exports.DELETE_POST = "DELETE_POST";
	var EDIT_POST = exports.EDIT_POST = "EDIT_POST";
	var UPDATE_POST = exports.UPDATE_POST = "UPDATE_POST";
	var FETCH_USER = exports.FETCH_USER = "FETCH_USER";
	var FETCH_PEOPLE = exports.FETCH_PEOPLE = "FETCH_PEOPLE";
	var FETCH_UPLOADS = exports.FETCH_UPLOADS = "FETCH_UPLOADS";
	var ADD_IMGS = exports.ADD_IMGS = "ADD_IMGS";
	var FETCH_IMGS = exports.FETCH_IMGS = "FETCH_IMGS";
	var FETCH_ADS = exports.FETCH_ADS = "FETCH_ADS";
	var FETCH_PROMO_ADS = exports.FETCH_PROMO_ADS = "FETCH_PROMO_ADS";
	var FETCH_SEARCH = exports.FETCH_SEARCH = "FETCH_SEARCH";
	var FETCH_TRENDS = exports.FETCH_TRENDS = "FETCH_TRENDS";
	var FETCH_LEADS = exports.FETCH_LEADS = "FETCH_LEADS";
	var CLEAR_STATE = exports.CLEAR_STATE = "CLEAR_STATE";
	var MYCART_PLACEORDER = exports.MYCART_PLACEORDER = "MYCART_PLACEORDER";
	var FETCH_RZP_KEYS = exports.FETCH_RZP_KEYS = "FETCH_RZP_KEYS";
	var FETCH_RECENT = exports.FETCH_RECENT = "FETCH_RZP_RECENT";
	var FETCH_PRODUCT_TABS = exports.FETCH_PRODUCT_TABS = "FETCH_PRODUCT_TABS";
	var FETCH_PRODUCT_DESC = exports.FETCH_PRODUCT_DESC = "FETCH_PRODUCT_DESC";
	var FETCH_USER_ADDR = exports.FETCH_USER_ADDR = "FETCH_USER_ADDR";

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Footer = function (_Component) {
		_inherits(Footer, _Component);
	
		function Footer(props) {
			_classCallCheck(this, Footer);
	
			var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));
	
			_this.state = {
				foo_brands: [],
				tot_data: []
			};
			_this.getCategories = _this.getCategories.bind(_this);
			return _this;
		}
	
		_createClass(Footer, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.getCategories();
				var data1 = { from: 'mobile_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'GetBrands',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
	
						// // console.log(data);
	
						this.setState({
							foo_brands: data.brands
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'getCategories',
			value: function getCategories() {
				var data1 = { from: 'mobile_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'Getcategories',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							tot_data: data.deal_categories
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var foo_brands = this.state.foo_brands.map(function (brand, index) {
					return _react2.default.createElement(
						'li',
						{ key: brand.tid },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: "/pdeals/" + brand.url_dtype_name + "/" + brand.url_name + "/" + brand.tid + "/" + brand.type + "/" + brand.page },
							brand.name
						)
					);
				});
				var categories = this.state.tot_data.map(function (category, index) {
					return _react2.default.createElement(Category, { key: index, data: category });
				});
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'section',
						{ className: 'dwnld_blk' },
						_react2.default.createElement(
							'h2',
							null,
							'Download Aquadeals App'
						),
						_react2.default.createElement(
							'p',
							null,
							'Download our Android app today to have a complete access of Aqua products'
						),
						_react2.default.createElement(
							'a',
							{ href: 'https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en', target: '_blank', title: '' },
							_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/google_play_store_icon.png', alt: 'download' })
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'site_map' },
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ className: 'row ctgors_site_map' },
								categories
							),
							_react2.default.createElement(
								'div',
								{ className: 'row brand_site_map' },
								_react2.default.createElement(
									'h3',
									null,
									'Brands'
								),
								_react2.default.createElement(
									'ul',
									null,
									foo_brands,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'http://blog.aqua.deals', target: '_blank' },
											'AquaDeals Blog'
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Footer;
	}(_react.Component);
	
	exports.default = Footer;
	
	var Category = function (_Component2) {
		_inherits(Category, _Component2);
	
		function Category() {
			_classCallCheck(this, Category);
	
			var _this2 = _possibleConstructorReturn(this, (Category.__proto__ || Object.getPrototypeOf(Category)).call(this));
	
			_this2.state = {};
	
			return _this2;
		}
	
		_createClass(Category, [{
			key: 'render',
			value: function render() {
				var cat_list = this.props.data;
				return _react2.default.createElement(
					'div',
					{ className: "col-md-3 col-sm-3 col-xs-6" },
					_react2.default.createElement(
						'h3',
						null,
						cat_list.dtype
					),
					cat_list.categories.map(function (cat) {
						return _react2.default.createElement(
							'ul',
							null,
							_react2.default.createElement(
								'li',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: cat.dtype === '1' || cat.dtype === '8' ? '/' + cat.url_dtype_name + '/' + cat.url_name + '/' + cat.id : '/' + cat.url + '/' + cat.url_dtype_name + '/' + cat.url_name + '/' + cat.id + '/' + cat.category + '/' + cat.dtype },
									cat.title
								)
							)
						);
					})
				);
			}
		}]);
	
		return Category;
	}(_react.Component);

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Header = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Header = exports.Header = function (_Component) {
	    _inherits(Header, _Component);
	
	    function Header(props) {
	        _classCallCheck(this, Header);
	
	        var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	        _this.state = {
	            status: '',
	            keyword: ''
	        };
	        return _this;
	    }
	
	    _createClass(Header, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            (0, _jquery2.default)('.srh_res').remove();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            (0, _jquery2.default)(document).on('mouseup', function (e) {
	                var container = (0, _jquery2.default)('.search');
	                var container_sub = (0, _jquery2.default)('.res');
	                if (!container.is(e.target) && container.has(e.target).length === 0) {
	                    container_sub.hide();
	                } else {
	                    container_sub.hide();
	                }
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'mob_deals mob_header' },
	                _react2.default.createElement(
	                    'section',
	                    { className: 'indx_hdr hm_hdr' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'inx_nav' },
	                        _react2.default.createElement(
	                            'nav',
	                            { className: 'navbar navbar-default' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'container' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-2 col-sm-3 col-xs-6' },
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { className: 'navbar-brand indx_logo', to: "/" },
	                                            _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/abt_logo.png', title: 'AquaDeals', alt: 'AquaDeals' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-3 col-sm-4 col-xs-6 pull-right' },
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: 'nav navbar-nav navbar-right' },
	                                            _react2.default.createElement(
	                                                'li',
	                                                { style: { textAlign: 'right' } },
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    { href: 'https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en', target: '_blank', title: 'Download AquaDeals Mobile App', className: 'play_img' },
	                                                    _react2.default.createElement('img', { src: baseAssets + '/images/web_imgs/google_play_store_icon.png', alt: 'Download' })
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement('div', { className: 'col-md-6 col-md-offset-1 col-sm-12 col-xs-12' })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Header;
	}(_react.Component);
	
	function mapStateToProps(state) {
	    return {
	        search: state.posts.search,
	        brands: state.posts.brands,
	        products: state.posts.products,
	        trendings: state.posts.trendings
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Header);

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(559);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(564);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(563);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(158);
	var GetIntrinsic = __webpack_require__(263);
	
	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
	
	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
	var $max = GetIntrinsic('%Math.max%');
	
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = null;
		}
	}
	
	module.exports = function callBind(originalFunction) {
		var func = $reflectApply(bind, $call, arguments);
		if ($gOPD && $defineProperty) {
			var desc = $gOPD(func, 'length');
			if (desc.configurable) {
				// original length, plus the receiver, minus any additional arguments (after the receiver)
				$defineProperty(
					func,
					'length',
					{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
				);
			}
		}
		return func;
	};
	
	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ },
/* 143 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 144 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 145 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(85);
	var dPs = __webpack_require__(584);
	var enumBugKeys = __webpack_require__(144);
	var IE_PROTO = __webpack_require__(149)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(230)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(578).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 147 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(62).f;
	var has = __webpack_require__(61);
	var TAG = __webpack_require__(74)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(150)('keys');
	var uid = __webpack_require__(104);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(37);
	var global = __webpack_require__(52);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(101) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 151 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(72);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(52);
	var core = __webpack_require__(37);
	var LIBRARY = __webpack_require__(101);
	var wksExt = __webpack_require__(154);
	var defineProperty = __webpack_require__(62).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(74);


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var objectKeys = __webpack_require__(290);
	var isArguments = __webpack_require__(664);
	var is = __webpack_require__(709);
	var isRegex = __webpack_require__(666);
	var flags = __webpack_require__(981);
	var isDate = __webpack_require__(665);
	
	var getTime = Date.prototype.getTime;
	
	function deepEqual(actual, expected, options) {
	  var opts = options || {};
	
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (opts.strict ? is(actual, expected) : actual === expected) {
	    return true;
	  }
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
	  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
	    return opts.strict ? is(actual, expected) : actual == expected;
	  }
	
	  /*
	   * 7.4. For all other Object pairs, including Array objects, equivalence is
	   * determined by having the same number of owned properties (as verified
	   * with Object.prototype.hasOwnProperty.call), the same set of keys
	   * (although not necessarily the same order), equivalent values for every
	   * corresponding key, and an identical 'prototype' property. Note: this
	   * accounts for both named and indexed properties on Arrays.
	   */
	  // eslint-disable-next-line no-use-before-define
	  return objEquiv(actual, expected, opts);
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
	    return false;
	  }
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') {
	    return false;
	  }
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  /* eslint max-statements: [2, 50] */
	  var i, key;
	  if (typeof a !== typeof b) { return false; }
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }
	
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) { return false; }
	
	  if (isArguments(a) !== isArguments(b)) { return false; }
	
	  var aIsRegex = isRegex(a);
	  var bIsRegex = isRegex(b);
	  if (aIsRegex !== bIsRegex) { return false; }
	  if (aIsRegex || bIsRegex) {
	    return a.source === b.source && flags(a) === flags(b);
	  }
	
	  if (isDate(a) && isDate(b)) {
	    return getTime.call(a) === getTime.call(b);
	  }
	
	  var aIsBuffer = isBuffer(a);
	  var bIsBuffer = isBuffer(b);
	  if (aIsBuffer !== bIsBuffer) { return false; }
	  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
	    if (a.length !== b.length) { return false; }
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) { return false; }
	    }
	    return true;
	  }
	
	  if (typeof a !== typeof b) { return false; }
	
	  try {
	    var ka = objectKeys(a);
	    var kb = objectKeys(b);
	  } catch (e) { // happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates hasOwnProperty)
	  if (ka.length !== kb.length) { return false; }
	
	  // the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  // ~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) { return false; }
	  }
	  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) { return false; }
	  }
	
	  return true;
	}
	
	module.exports = deepEqual;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(89);
	
	var contains = (function () {
	  var root = canUseDOM && document.documentElement;
	
	  return root && root.contains ? function (context, node) {
	    return context.contains(node);
	  } : root && root.compareDocumentPosition ? function (context, node) {
	    return context === node || !!(context.compareDocumentPosition(node) & 16);
	  } : function (context, node) {
	    if (node) do {
	      if (node === context) return true;
	    } while (node = node.parentNode);
	
	    return false;
	  };
	})();
	
	module.exports = contains;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/wa_app.618a27a7.png";

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(650);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = __webpack_require__(264);
	
	module.exports = function hasToStringTagShams() {
		return hasSymbols() && !!Symbol.toStringTag;
	};


/***/ },
/* 160 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 163 */
/***/ function(module, exports) {

	module.exports = isPromise;
	module.exports.default = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ },
/* 164 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(287);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(278),
	    isLength = __webpack_require__(77);
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(166),
	    isObjectLike = __webpack_require__(64);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.exports = isArguments;


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(64);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(114),
	    isArrayLike = __webpack_require__(166),
	    isObject = __webpack_require__(55),
	    shimKeys = __webpack_require__(701),
	    support = __webpack_require__(172);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object == 'function' ? support.enumPrototypes : isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	module.exports = keys;


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(671),
	    isArguments = __webpack_require__(167),
	    isArray = __webpack_require__(54),
	    isFunction = __webpack_require__(286),
	    isIndex = __webpack_require__(280),
	    isLength = __webpack_require__(77),
	    isObject = __webpack_require__(55),
	    isString = __webpack_require__(168),
	    support = __webpack_require__(172);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/** Used to fix the JScript `[[DontEnum]]` bug. */
	var shadowProps = [
	  'constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable',
	  'toLocaleString', 'toString', 'valueOf'
	];
	
	/** Used for native method references. */
	var errorProto = Error.prototype,
	    objectProto = Object.prototype,
	    stringProto = String.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to avoid iterating over non-enumerable properties in IE < 9. */
	var nonEnumProps = {};
	nonEnumProps[arrayTag] = nonEnumProps[dateTag] = nonEnumProps[numberTag] = { 'constructor': true, 'toLocaleString': true, 'toString': true, 'valueOf': true };
	nonEnumProps[boolTag] = nonEnumProps[stringTag] = { 'constructor': true, 'toString': true, 'valueOf': true };
	nonEnumProps[errorTag] = nonEnumProps[funcTag] = nonEnumProps[regexpTag] = { 'constructor': true, 'toString': true };
	nonEnumProps[objectTag] = { 'constructor': true };
	
	arrayEach(shadowProps, function(key) {
	  for (var tag in nonEnumProps) {
	    if (hasOwnProperty.call(nonEnumProps, tag)) {
	      var props = nonEnumProps[tag];
	      props[key] = hasOwnProperty.call(props, key);
	    }
	  }
	});
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object) || isString(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      proto = (isFunction(Ctor) && Ctor.prototype) || objectProto,
	      isProto = proto === object,
	      result = Array(length),
	      skipIndexes = length > 0,
	      skipErrorProps = support.enumErrorProps && (object === errorProto || object instanceof Error),
	      skipProto = support.enumPrototypes && isFunction(object);
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  // lodash skips the `constructor` property when it infers it's iterating
	  // over a `prototype` object because IE < 9 can't set the `[[Enumerable]]`
	  // attribute of an existing property and the `constructor` property of a
	  // prototype defaults to non-enumerable.
	  for (var key in object) {
	    if (!(skipProto && key == 'prototype') &&
	        !(skipErrorProps && (key == 'message' || key == 'name')) &&
	        !(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  if (support.nonEnumShadows && object !== objectProto) {
	    var tag = object === stringProto ? stringTag : (object === errorProto ? errorTag : objToString.call(object)),
	        nonEnums = nonEnumProps[tag] || nonEnumProps[objectTag];
	
	    if (tag == objectTag) {
	      proto = objectProto;
	    }
	    length = shadowProps.length;
	    while (length--) {
	      key = shadowProps[length];
	      var nonEnum = nonEnums[key];
	      if (!(isProto && nonEnum) &&
	          (nonEnum ? hasOwnProperty.call(object, key) : object[key] !== proto[key])) {
	        result.push(key);
	      }
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(672),
	    baseDifference = __webpack_require__(676),
	    baseFlatten = __webpack_require__(273),
	    bindCallback = __webpack_require__(165),
	    keysIn = __webpack_require__(170),
	    pickByArray = __webpack_require__(283),
	    pickByCallback = __webpack_require__(284),
	    restParam = __webpack_require__(272);
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable properties of `object` that are not omitted.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|...(string|string[])} [predicate] The function invoked per
	 *  iteration or property names to omit, specified as individual property
	 *  names or arrays of property names.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'user': 'fred', 'age': 40 };
	 *
	 * _.omit(object, 'age');
	 * // => { 'user': 'fred' }
	 *
	 * _.omit(object, _.isNumber);
	 * // => { 'user': 'fred' }
	 */
	var omit = restParam(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  if (typeof props[0] != 'function') {
	    var props = arrayMap(baseFlatten(props), String);
	    return pickByArray(object, baseDifference(keysIn(object), props));
	  }
	  var predicate = bindCallback(props[0], props[1], 3);
	  return pickByCallback(object, function(value, key, object) {
	    return !predicate(value, key, object);
	  });
	});
	
	module.exports = omit;


/***/ },
/* 172 */
/***/ function(module, exports) {

	/** Used for native method references. */
	var arrayProto = Array.prototype,
	    errorProto = Error.prototype,
	    objectProto = Object.prototype;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/**
	 * An object environment feature flags.
	 *
	 * @static
	 * @memberOf _
	 * @type Object
	 */
	var support = {};
	
	(function(x) {
	  var Ctor = function() { this.x = x; },
	      object = { '0': x, 'length': x },
	      props = [];
	
	  Ctor.prototype = { 'valueOf': x, 'y': x };
	  for (var key in new Ctor) { props.push(key); }
	
	  /**
	   * Detect if `name` or `message` properties of `Error.prototype` are
	   * enumerable by default (IE < 9, Safari < 5.1).
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.enumErrorProps = propertyIsEnumerable.call(errorProto, 'message') ||
	    propertyIsEnumerable.call(errorProto, 'name');
	
	  /**
	   * Detect if `prototype` properties are enumerable by default.
	   *
	   * Firefox < 3.6, Opera > 9.50 - Opera < 11.60, and Safari < 5.1
	   * (if the prototype or a property on the prototype has been set)
	   * incorrectly set the `[[Enumerable]]` value of a function's `prototype`
	   * property to `true`.
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.enumPrototypes = propertyIsEnumerable.call(Ctor, 'prototype');
	
	  /**
	   * Detect if properties shadowing those on `Object.prototype` are non-enumerable.
	   *
	   * In IE < 9 an object's own properties, shadowing non-enumerable ones,
	   * are made non-enumerable as well (a.k.a the JScript `[[DontEnum]]` bug).
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.nonEnumShadows = !/valueOf/.test(props);
	
	  /**
	   * Detect if own properties are iterated after inherited properties (IE < 9).
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.ownLast = props[0] != 'x';
	
	  /**
	   * Detect if `Array#shift` and `Array#splice` augment array-like objects
	   * correctly.
	   *
	   * Firefox < 10, compatibility modes of IE 8, and IE < 9 have buggy Array
	   * `shift()` and `splice()` functions that fail to remove the last element,
	   * `value[0]`, of array-like objects even though the "length" property is
	   * set to `0`. The `shift()` method is buggy in compatibility modes of IE 8,
	   * while `splice()` is buggy regardless of mode in IE < 9.
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.spliceObjects = (splice.call(object, 0, 1), !object[0]);
	
	  /**
	   * Detect lack of support for accessing string characters by index.
	   *
	   * IE < 8 can't access characters by index. IE 8 can only access characters
	   * by index on string literals, not string objects.
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.unindexedChars = ('x'[0] + Object('x')[0]) != 'xx';
	}(1, 0));
	
	module.exports = support;


/***/ },
/* 173 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 174 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule shallowCompare
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return (
	    !shallowEqual(instance.props, nextProps) ||
	    !shallowEqual(instance.state, nextState)
	  );
	}
	
	module.exports = shallowCompare;


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _domHelpersStyle = __webpack_require__(614);
	
	var _domHelpersStyle2 = _interopRequireDefault(_domHelpersStyle);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactOverlaysLibTransition = __webpack_require__(326);
	
	var _reactOverlaysLibTransition2 = _interopRequireDefault(_reactOverlaysLibTransition);
	
	var _utilsCreateChainedFunction = __webpack_require__(32);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var capitalize = function capitalize(str) {
	  return str[0].toUpperCase() + str.substr(1);
	};
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	var triggerBrowserReflow = function triggerBrowserReflow(node) {
	  return node.offsetHeight;
	};
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	function getDimensionValue(dimension, elem) {
	  var value = elem['offset' + capitalize(dimension)];
	  var margins = MARGINS[dimension];
	
	  return value + parseInt(_domHelpersStyle2['default'](elem, margins[0]), 10) + parseInt(_domHelpersStyle2['default'](elem, margins[1]), 10);
	}
	
	var Collapse = (function (_React$Component) {
	  _inherits(Collapse, _React$Component);
	
	  function Collapse(props, context) {
	    _classCallCheck(this, Collapse);
	
	    _React$Component.call(this, props, context);
	
	    this.onEnterListener = this.handleEnter.bind(this);
	    this.onEnteringListener = this.handleEntering.bind(this);
	    this.onEnteredListener = this.handleEntered.bind(this);
	    this.onExitListener = this.handleExit.bind(this);
	    this.onExitingListener = this.handleExiting.bind(this);
	  }
	
	  // Explicitly copied from Transition for doc generation.
	  // TODO: Remove duplication once #977 is resolved.
	
	  Collapse.prototype.render = function render() {
	    var enter = _utilsCreateChainedFunction2['default'](this.onEnterListener, this.props.onEnter);
	    var entering = _utilsCreateChainedFunction2['default'](this.onEnteringListener, this.props.onEntering);
	    var entered = _utilsCreateChainedFunction2['default'](this.onEnteredListener, this.props.onEntered);
	    var exit = _utilsCreateChainedFunction2['default'](this.onExitListener, this.props.onExit);
	    var exiting = _utilsCreateChainedFunction2['default'](this.onExitingListener, this.props.onExiting);
	
	    return _react2['default'].createElement(
	      _reactOverlaysLibTransition2['default'],
	      _extends({
	        ref: 'transition'
	      }, this.props, {
	        'aria-expanded': this.props.role ? this.props['in'] : null,
	        className: _classnames2['default'](this.props.className, { width: this._dimension() === 'width' }),
	        exitedClassName: 'collapse',
	        exitingClassName: 'collapsing',
	        enteredClassName: 'collapse in',
	        enteringClassName: 'collapsing',
	        onEnter: enter,
	        onEntering: entering,
	        onEntered: entered,
	        onExit: exit,
	        onExiting: exiting,
	        onExited: this.props.onExited
	      }),
	      this.props.children
	    );
	  };
	
	  /* -- Expanding -- */
	
	  Collapse.prototype.handleEnter = function handleEnter(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.handleEntering = function handleEntering(elem) {
	    var dimension = this._dimension();
	
	    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
	  };
	
	  Collapse.prototype.handleEntered = function handleEntered(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = null;
	  };
	
	  /* -- Collapsing -- */
	
	  Collapse.prototype.handleExit = function handleExit(elem) {
	    var dimension = this._dimension();
	
	    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
	  };
	
	  Collapse.prototype.handleExiting = function handleExiting(elem) {
	    var dimension = this._dimension();
	
	    triggerBrowserReflow(elem);
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype._dimension = function _dimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  };
	
	  // for testing
	
	  Collapse.prototype._getTransitionInstance = function _getTransitionInstance() {
	    return this.refs.transition;
	  };
	
	  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem['scroll' + capitalize(dimension)] + 'px';
	  };
	
	  return Collapse;
	})(_react2['default'].Component);
	
	Collapse.propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  'in': _react2['default'].PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _react2['default'].PropTypes.bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2['default'].PropTypes.bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _react2['default'].PropTypes.number,
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _react2['default'].PropTypes.func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.oneOf(['height', 'width']), _react2['default'].PropTypes.func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _react2['default'].PropTypes.func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _react2['default'].PropTypes.string
	};
	
	Collapse.defaultProps = {
	  'in': false,
	  timeout: 300,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	exports['default'] = Collapse;
	module.exports = exports['default'];

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibDeprecated = __webpack_require__(121);
	
	var _reactPropTypesLibDeprecated2 = _interopRequireDefault(_reactPropTypesLibDeprecated);
	
	var _styleMaps = __webpack_require__(27);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _utilsValidComponentChildren = __webpack_require__(28);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _react2['default'].PropTypes.string,
	  /**
	   * @private
	   */
	  standalone: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.bool, 'Use a `<FormControl>` or `<InputGroup>` directly.'),
	  validationState: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error']),
	  /**
	   * @private
	   */
	  bsStyle: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.oneOf(['success', 'warning', 'error']), 'Use `validationState`'),
	  /**
	   * @private
	   */
	  hasFeedback: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.bool, 'Use a `<FormControl.Feedback>` element.'),
	  /**
	   * @private
	   */
	  groupClassName: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.string, 'Use `className`.')
	};
	
	var childContextTypes = {
	  $bs_formGroup: _react2['default'].PropTypes.object.isRequired
	};
	
	var FormGroup = (function (_React$Component) {
	  _inherits(FormGroup, _React$Component);
	
	  function FormGroup() {
	    _classCallCheck(this, FormGroup);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  FormGroup.prototype.getChildContext = function getChildContext() {
	    var _props = this.props;
	    var controlId = _props.controlId;
	    var bsStyle = _props.bsStyle;
	    var _props$validationState = _props.validationState;
	    var validationState = _props$validationState === undefined ? bsStyle : _props$validationState;
	
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
	    var _this = this;
	
	    return _utilsValidComponentChildren2['default'].some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this.hasFeedback(child.props.children);
	    });
	  };
	
	  FormGroup.prototype.render = function render() {
	    var _props2 = this.props;
	    var standalone = _props2.standalone;
	    var bsStyle = _props2.bsStyle;
	    var _props2$validationState = _props2.validationState;
	    var validationState = _props2$validationState === undefined ? bsStyle : _props2$validationState;
	    var groupClassName = _props2.groupClassName;
	    var _props2$className = _props2.className;
	    var className = _props2$className === undefined ? groupClassName : _props2$className;
	    var children = _props2.children;
	    var _props2$hasFeedback = _props2.hasFeedback;
	    var hasFeedback = _props2$hasFeedback === undefined ? this.hasFeedback(children) : _props2$hasFeedback;
	
	    var props = _objectWithoutProperties(_props2, ['standalone', 'bsStyle', 'validationState', 'groupClassName', 'className', 'children', 'hasFeedback']);
	
	    delete props.bsClass;
	    delete props.bsSize;
	    delete props.controlId;
	
	    var classes = _extends({}, !standalone && _utilsBootstrapUtils.getClassSet(this.props), {
	      'has-feedback': hasFeedback
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, props, { className: _classnames2['default'](className, classes) }),
	      children
	    );
	  };
	
	  return FormGroup;
	})(_react2['default'].Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	exports['default'] = _utilsBootstrapUtils.bsClass('form-group', _utilsBootstrapUtils.bsSizes([_styleMaps.Sizes.LARGE, _styleMaps.Sizes.SMALL], FormGroup));
	module.exports = exports['default'];

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormGroup = __webpack_require__(176);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _Glyphicon = __webpack_require__(118);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var InputBase = (function (_React$Component) {
	  _inherits(InputBase, _React$Component);
	
	  function InputBase() {
	    _classCallCheck(this, InputBase);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  InputBase.prototype.getInputDOMNode = function getInputDOMNode() {
	    return this.refs.input;
	  };
	
	  InputBase.prototype.getValue = function getValue() {
	    if (this.props.type === 'static') {
	      return this.props.value;
	    } else if (this.props.type) {
	      if (this.props.type === 'select' && this.props.multiple) {
	        return this.getSelectedOptions();
	      }
	      return this.getInputDOMNode().value;
	    }
	    throw new Error('Cannot use getValue without specifying input type.');
	  };
	
	  InputBase.prototype.getChecked = function getChecked() {
	    return this.getInputDOMNode().checked;
	  };
	
	  InputBase.prototype.getSelectedOptions = function getSelectedOptions() {
	    var values = [];
	
	    Array.prototype.forEach.call(this.getInputDOMNode().getElementsByTagName('option'), function (option) {
	      if (option.selected) {
	        var value = option.getAttribute('value') || option.innerHtml;
	        values.push(value);
	      }
	    });
	
	    return values;
	  };
	
	  InputBase.prototype.isCheckboxOrRadio = function isCheckboxOrRadio() {
	    return this.props.type === 'checkbox' || this.props.type === 'radio';
	  };
	
	  InputBase.prototype.isFile = function isFile() {
	    return this.props.type === 'file';
	  };
	
	  InputBase.prototype.renderInputGroup = function renderInputGroup(children) {
	    var addonBefore = this.props.addonBefore ? _react2['default'].createElement(
	      'span',
	      { className: 'input-group-addon', key: 'addonBefore' },
	      this.props.addonBefore
	    ) : null;
	
	    var addonAfter = this.props.addonAfter ? _react2['default'].createElement(
	      'span',
	      { className: 'input-group-addon', key: 'addonAfter' },
	      this.props.addonAfter
	    ) : null;
	
	    var buttonBefore = this.props.buttonBefore ? _react2['default'].createElement(
	      'span',
	      { className: 'input-group-btn' },
	      this.props.buttonBefore
	    ) : null;
	
	    var buttonAfter = this.props.buttonAfter ? _react2['default'].createElement(
	      'span',
	      { className: 'input-group-btn' },
	      this.props.buttonAfter
	    ) : null;
	
	    var inputGroupClassName = undefined;
	    switch (this.props.bsSize) {
	      case 'small':
	        inputGroupClassName = 'input-group-sm';break;
	      case 'large':
	        inputGroupClassName = 'input-group-lg';break;
	      default:
	    }
	
	    return addonBefore || addonAfter || buttonBefore || buttonAfter ? _react2['default'].createElement(
	      'div',
	      { className: _classnames2['default'](inputGroupClassName, 'input-group'), key: 'input-group' },
	      addonBefore,
	      buttonBefore,
	      children,
	      addonAfter,
	      buttonAfter
	    ) : children;
	  };
	
	  InputBase.prototype.renderIcon = function renderIcon() {
	    if (this.props.hasFeedback) {
	      if (this.props.feedbackIcon) {
	        return _react2['default'].cloneElement(this.props.feedbackIcon, { formControlFeedback: true });
	      }
	
	      switch (this.props.bsStyle) {
	        case 'success':
	          return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'ok', key: 'icon' });
	        case 'warning':
	          return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'warning-sign', key: 'icon' });
	        case 'error':
	          return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'remove', key: 'icon' });
	        default:
	          return _react2['default'].createElement('span', { className: 'form-control-feedback', key: 'icon' });
	      }
	    } else {
	      return null;
	    }
	  };
	
	  InputBase.prototype.renderHelp = function renderHelp() {
	    return this.props.help ? _react2['default'].createElement(
	      'span',
	      { className: 'help-block', key: 'help' },
	      this.props.help
	    ) : null;
	  };
	
	  InputBase.prototype.renderCheckboxAndRadioWrapper = function renderCheckboxAndRadioWrapper(children) {
	    var classes = {
	      'checkbox': this.props.type === 'checkbox',
	      'radio': this.props.type === 'radio'
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      { className: _classnames2['default'](classes), key: 'checkboxRadioWrapper' },
	      children
	    );
	  };
	
	  InputBase.prototype.renderWrapper = function renderWrapper(children) {
	    return this.props.wrapperClassName ? _react2['default'].createElement(
	      'div',
	      { className: this.props.wrapperClassName, key: 'wrapper' },
	      children
	    ) : children;
	  };
	
	  InputBase.prototype.renderLabel = function renderLabel(children) {
	    var classes = {
	      'control-label': !this.isCheckboxOrRadio()
	    };
	    classes[this.props.labelClassName] = this.props.labelClassName;
	
	    return this.props.label ? _react2['default'].createElement(
	      'label',
	      { htmlFor: this.props.id, className: _classnames2['default'](classes), key: 'label' },
	      children,
	      this.props.label
	    ) : children;
	  };
	
	  InputBase.prototype.renderInput = function renderInput() {
	    if (!this.props.type) {
	      return this.props.children;
	    }
	
	    switch (this.props.type) {
	      case 'select':
	        return _react2['default'].createElement(
	          'select',
	          _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'form-control'), ref: 'input', key: 'input' }),
	          this.props.children
	        );
	      case 'textarea':
	        return _react2['default'].createElement('textarea', _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'form-control'), ref: 'input', key: 'input' }));
	      case 'static':
	        return _react2['default'].createElement(
	          'p',
	          _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'form-control-static'), ref: 'input', key: 'input' }),
	          this.props.value
	        );
	      default:
	        var className = this.isCheckboxOrRadio() || this.isFile() ? '' : 'form-control';
	        return _react2['default'].createElement('input', _extends({}, this.props, { className: _classnames2['default'](this.props.className, className), ref: 'input', key: 'input' }));
	    }
	  };
	
	  InputBase.prototype.renderFormGroup = function renderFormGroup(children) {
	    return _react2['default'].createElement(
	      _FormGroup2['default'],
	      this.props,
	      children
	    );
	  };
	
	  InputBase.prototype.renderChildren = function renderChildren() {
	    return !this.isCheckboxOrRadio() ? [this.renderLabel(), this.renderWrapper([this.renderInputGroup(this.renderInput()), this.renderIcon(), this.renderHelp()])] : this.renderWrapper([this.renderCheckboxAndRadioWrapper(this.renderLabel(this.renderInput())), this.renderHelp()]);
	  };
	
	  InputBase.prototype.render = function render() {
	    var children = this.renderChildren();
	    return this.renderFormGroup(children);
	  };
	
	  return InputBase;
	})(_react2['default'].Component);
	
	InputBase.propTypes = {
	  type: _react2['default'].PropTypes.string,
	  label: _react2['default'].PropTypes.node,
	  help: _react2['default'].PropTypes.node,
	  addonBefore: _react2['default'].PropTypes.node,
	  addonAfter: _react2['default'].PropTypes.node,
	  buttonBefore: _react2['default'].PropTypes.node,
	  buttonAfter: _react2['default'].PropTypes.node,
	  bsSize: _react2['default'].PropTypes.oneOf(['small', 'medium', 'large']),
	  bsStyle: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error']),
	  hasFeedback: _react2['default'].PropTypes.bool,
	  feedbackIcon: _react2['default'].PropTypes.node,
	  id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	  groupClassName: _react2['default'].PropTypes.string,
	  wrapperClassName: _react2['default'].PropTypes.string,
	  labelClassName: _react2['default'].PropTypes.string,
	  multiple: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  value: _react2['default'].PropTypes.any
	};
	
	InputBase.defaultProps = {
	  disabled: false,
	  hasFeedback: false,
	  multiple: false
	};
	
	exports['default'] = InputBase;
	module.exports = exports['default'];

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uncontrollable = __webpack_require__(135);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var idPropType = _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]);
	
	var TabContainer = _react2['default'].createClass({
	  displayName: 'TabContainer',
	
	  propTypes: {
	    /**
	     * HTML id attribute, required if no `generateChildId` prop
	     * is specified.
	     */
	    id: function id(props) {
	      var error = null;
	
	      if (!props.generateChildId) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        error = idPropType.apply(undefined, [props].concat(args));
	
	        if (!error && !props.id) {
	          error = new Error('In order to properly initialize Tabs in a way that is accessible to assistive technologies ' + '(such as screen readers) an `id` or a `generateChildId` prop to TabContainer is required');
	        }
	      }
	      return error;
	    },
	
	    /**
	     * A function that takes an eventKey and type and returns a
	     * unique id for child tab NavItems and TabPanes. The function _must_ be a pure function,
	     * meaning it should always return the _same_ id for the same set of inputs. The default
	     * value requires that an `id` to be set for the TabContainer.
	     *
	     * The `type` argument will either be `"tab"` or `"pane"`.
	     *
	     * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	     */
	    generateChildId: _react.PropTypes.func,
	
	    /**
	     * A callback fired when a tab is selected.
	     *
	     * @controllable activeKey
	     */
	    onSelect: _react.PropTypes.func,
	
	    /**
	     * The `eventKey` of the currently active tab.
	     *
	     * @controllable onSelect
	     */
	    activeKey: _react.PropTypes.any
	  },
	
	  childContextTypes: {
	    $bs_tabcontainer: _react2['default'].PropTypes.shape({
	      activeKey: _react.PropTypes.any,
	      onSelect: _react.PropTypes.func,
	      getId: _react.PropTypes.func
	    })
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var activeKey = _props.activeKey;
	    var generateChildId = _props.generateChildId;
	    var id = _props.id;
	
	    return {
	      $bs_tabcontainer: {
	        activeKey: activeKey,
	        onSelect: this.handleSelect,
	        getId: generateChildId || function (key, type) {
	          return id ? id + '-' + type + '-' + key : null;
	        }
	      }
	    };
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    // isMounted() isn't `true` at this point;
	    this.unmounting = true;
	  },
	
	  handleSelect: function handleSelect(key) {
	    if (!this.unmounting) {
	      this.props.onSelect(key);
	    }
	  },
	
	  render: function render() {
	    var _props2 = this.props;
	    var children = _props2.children;
	
	    var props = _objectWithoutProperties(_props2, ['children']);
	
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	
	    return _react2['default'].cloneElement(_react2['default'].Children.only(children), props);
	  }
	});
	
	exports['default'] = _uncontrollable2['default'](TabContainer, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var animationPropType = _react.PropTypes.oneOfType([_react.PropTypes.bool, _reactPropTypesLibElementType2['default']]);
	
	var TabContent = _react2['default'].createClass({
	  displayName: 'TabContent',
	
	  propTypes: {
	
	    /**
	     * the Component used to render the TabContent
	     */
	    componentClass: _reactPropTypesLibElementType2['default'],
	
	    /**
	     * Sets a default animation strategy for all children TabPanes.
	     * Use `false` to disable, `true` to enable the default "Fade"
	     * animation or any `<Transition>` component.
	     */
	    animation: _react.PropTypes.oneOfType([_react.PropTypes.bool, _reactPropTypesLibElementType2['default']]),
	
	    /**
	     * Unmount the tab (remove it from the DOM) when it is no longer visible
	     */
	    unmountOnExit: _react.PropTypes.bool
	  },
	
	  contextTypes: {
	    $bs_tabcontainer: _react2['default'].PropTypes.shape({
	      activeKey: _react2['default'].PropTypes.any,
	      onSelect: _react.PropTypes.func
	    })
	  },
	
	  childContextTypes: {
	    $bs_tabcontent: _react.PropTypes.shape({
	      bsClass: _react.PropTypes.string,
	      animation: animationPropType,
	      activeKey: _react.PropTypes.any,
	      onExited: _react.PropTypes.func,
	      register: _react.PropTypes.func,
	      unmountOnExit: _react.PropTypes.bool
	    })
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div',
	      animation: true,
	      unmountOnExit: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      exitingPane: null
	    };
	  },
	
	  getChildContext: function getChildContext() {
	    var exitingPane = this._exitingPane;
	
	    return {
	      $bs_tabcontent: {
	        bsClass: this.props.bsClass,
	        animation: this.props.animation,
	        activeKey: exitingPane ? undefined : this.getActiveKey(),
	        onExited: this.handlePaneExited,
	        register: this.registerPane,
	        unmountOnExit: this.props.unmountOnExit
	      }
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.panes = [];
	  },
	
	  /**
	   * This belongs in `componentWillReceiveProps()` but
	   * 0.14.x contains a bug where cwrp isn't called when only context changes.
	   * fixed in master, not sure it will make it into any 0.14 release
	   */
	  componentWillUpdate: function componentWillUpdate(nextProps, _, nextContext) {
	    var currentActiveKey = this.getActiveKey();
	    var nextActiveKey = this.getActiveKey(nextContext);
	    var currentKeyIsStillValid = this.panes.indexOf(currentActiveKey) !== -1;
	
	    if (this.panes.indexOf(this._exitingPane) === -1) {
	      this._exitingPane = null;
	    }
	
	    if (nextActiveKey !== currentActiveKey && currentKeyIsStillValid) {
	      this._exitingPane = currentActiveKey;
	    }
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var children = _props.children;
	
	    var Component = this.props.componentClass;
	
	    var contentClass = _utilsBootstrapUtils.prefix(this.props, 'content');
	
	    return _react2['default'].createElement(
	      Component,
	      { className: _classnames2['default'](contentClass, className) },
	      children
	    );
	  },
	
	  handlePaneExited: function handlePaneExited() {
	    this._exitingPane = null;
	    this.forceUpdate();
	  },
	
	  /**
	   * This is unfortunately neccessary because the TabContent needs to know if
	   * a TabPane is ever going to exit, since it may unmount and just leave the
	   * TabContent to wait longingly forever for the handlePaneExited to be called.
	   */
	  registerPane: function registerPane(eventKey) {
	    var _this = this;
	
	    var panes = this.panes;
	
	    !(panes.indexOf(eventKey) === -1) ?  false ? _invariant2['default'](false, 'You cannot have multiple TabPanes of with the same `eventKey` in the same ' + 'TabContent component. Duplicate eventKey: ' + eventKey) : _invariant2['default'](false) : undefined;
	
	    panes.push(eventKey);
	
	    return function () {
	      panes.splice(panes.indexOf(eventKey), 1);
	
	      // #1892
	      // new active state can propagate down _before_
	      // the tab actually unmounts, so it will map be exiting.
	      // since an exiting tab won't complete, clear the bad state
	      if (eventKey === _this._exitingPane) {
	        _this.handlePaneExited();
	      }
	
	      // If the tab was active, we need to tell the container
	      // that it no longer exists and as such is not active.
	      if (eventKey === _this.getActiveKey()) {
	        _this.getContext('$bs_tabcontainer').onSelect();
	      }
	    };
	  },
	
	  getActiveKey: function getActiveKey() {
	    var context = arguments.length <= 0 || arguments[0] === undefined ? this.context : arguments[0];
	
	    return this.getContext('$bs_tabcontainer', context).activeKey;
	  },
	
	  getContext: function getContext(key) {
	    var context = arguments.length <= 1 || arguments[1] === undefined ? this.context : arguments[1];
	
	    return context[key] || {};
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsClass('tab', TabContent);
	module.exports = exports['default'];

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	exports['default'] = valueValidation;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibSinglePropFrom = __webpack_require__(840);
	
	var _reactPropTypesLibSinglePropFrom2 = _interopRequireDefault(_reactPropTypesLibSinglePropFrom);
	
	function valueValidation(props, propName, componentName) {
	  var error = _reactPropTypesLibSinglePropFrom2['default']('children', 'value')(props, propName, componentName);
	
	  if (!error) {
	    error = _react2['default'].PropTypes.node(props, propName, componentName);
	  }
	
	  return error;
	}
	
	module.exports = exports['default'];

/***/ },
/* 181 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }
	
	    newObj["default"] = obj;
	    return newObj;
	  }
	};
	
	exports.__esModule = true;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(794)
	  , core      = __webpack_require__(93)
	  , ctx       = __webpack_require__(315)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ },
/* 183 */
/***/ function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(78));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(334));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(837));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(832));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__(833));
	
	var _properties = __webpack_require__(333);
	
	var _isTransform = _interopRequireDefault(__webpack_require__(834));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(336);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ },
/* 188 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.errMsg = errMsg;
	exports.createChainableTypeChecker = createChainableTypeChecker;
	
	function errMsg(props, propName, componentName, msgContinuation) {
	  return 'Invalid prop \'' + propName + '\' of value \'' + props[propName] + '\'' + (' supplied to \'' + componentName + '\'' + msgContinuation);
	}
	
	/**
	 * Create chain-able isRequired validator
	 *
	 * Largely copied directly from:
	 *  https://github.com/facebook/react/blob/0.11-stable/src/core/ReactPropTypes.js#L94
	 */
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName) {
	    componentName = componentName || '<<anonymous>>';
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required prop \'' + propName + '\' was not specified in \'' + componentName + '\'.');
	      }
	    } else {
	      return validate(props, propName, componentName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ },
/* 189 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _deprecateObjectProperties = __webpack_require__(124);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(66);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(26);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(26);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(870);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(867);
	
	var _isActive2 = __webpack_require__(874);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(871);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(876);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isPromise = undefined;
	
	var _typeof2 = __webpack_require__(141);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(222);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.isInternetExplorerBefore = isInternetExplorerBefore;
	exports.objectToGetParams = objectToGetParams;
	exports.windowOpen = windowOpen;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This detection method identifies Internet Explorers up until version 11.
	 *
	 * Reference: https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
	 */
	function isInternetExplorerBefore(version) {
	  var iematch = /MSIE ([0-9]+)/g.exec(window.navigator.userAgent);
	
	  return iematch ? +iematch[1] < version : false;
	}
	
	/* eslint-disable prefer-template */
	function objectToGetParams(object) {
	  return '?' + (0, _keys2.default)(object).filter(function (key) {
	    return !!object[key];
	  }).map(function (key) {
	    return key + '=' + encodeURIComponent(object[key]);
	  }).join('&');
	}
	/* eslint-enable prefer-template */
	
	function windowOpen(url, _ref, onShareWindowClose) {
	  var name = _ref.name,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 400 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 550 : _ref$width;
	
	  var left = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2;
	  var top = window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2;
	
	  var config = {
	    height: height,
	    width: width,
	    left: left,
	    top: top,
	    location: 'no',
	    toolbar: 'no',
	    status: 'no',
	    directories: 'no',
	    menubar: 'no',
	    scrollbars: 'yes',
	    resizable: 'no',
	    centerscreen: 'yes',
	    chrome: 'yes'
	  };
	
	  var shareDialog = window.open(url, isInternetExplorerBefore(10) ? '' : name, (0, _keys2.default)(config).map(function (key) {
	    return key + '=' + config[key];
	  }).join(', '));
	
	  if (onShareWindowClose) {
	    var interval = window.setInterval(function () {
	      try {
	        if (shareDialog === null || shareDialog.closed) {
	          window.clearInterval(interval);
	          onShareWindowClose(shareDialog);
	        }
	      } catch (e) {
	        /* eslint-disable no-console */
	        console.error(e);
	        /* eslint-enable no-console */
	      }
	    }, 1000);
	  }
	
	  return shareDialog;
	}
	
	var isPromise = exports.isPromise = function isPromise(obj) {
	  return !!obj && ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	};

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(59);
	
	var assign = __webpack_require__(17);
	var invariant = __webpack_require__(14);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : undefined;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(80);
	var ReactPerf = __webpack_require__(40);
	
	var quoteAttributeValueForBrowser = __webpack_require__(942);
	var warning = __webpack_require__(16);
	
	// Simplified subset
	var VALID_ATTRIBUTE_NAME_REGEX = /^[a-zA-Z_][\w\.\-]*$/;
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : undefined;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	if (false) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function (name) {
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    process.env.NODE_ENV !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : undefined;
	  };
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (propertyInfo.mustUseAttribute) {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      } else {
	        var propName = propertyInfo.propertyName;
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseAttribute) {
	        node.removeAttribute(propertyInfo.attributeName);
	      } else {
	        var propName = propertyInfo.propertyName;
	        var defaultValue = DOMProperty.getDefaultValueForProperty(node.nodeName, propName);
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== defaultValue) {
	          node[propName] = defaultValue;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMPropertyOperations, 'DOMPropertyOperations', {
	  setValueForProperty: 'setValueForProperty',
	  setValueForAttribute: 'setValueForAttribute',
	  deleteValueForProperty: 'deleteValueForProperty'
	});
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(370);
	var ReactPropTypeLocations = __webpack_require__(128);
	
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(16);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : undefined;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : undefined;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : undefined;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(198);
	var ReactMount = __webpack_require__(34);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkupByID: ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {
	    ReactMount.purgeID(rootNodeID);
	  }
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkupByID: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : undefined;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkupByID = environment.replaceNodeWithMarkupByID;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(350);
	var DOMPropertyOperations = __webpack_require__(194);
	var ReactMount = __webpack_require__(34);
	var ReactPerf = __webpack_require__(40);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Errors for properties that should not be updated with `updatePropertyByID()`.
	 *
	 * @type {object}
	 * @private
	 */
	var INVALID_PROPERTY_ERRORS = {
	  dangerouslySetInnerHTML: '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
	  style: '`style` must be set using `updateStylesByID()`.'
	};
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a DOM node with new property values. This should only be used to
	   * update DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A valid property name, see `DOMProperty`.
	   * @param {*} value New value of the property.
	   * @internal
	   */
	  updatePropertyByID: function (id, name, value) {
	    var node = ReactMount.getNode(id);
	    !!INVALID_PROPERTY_ERRORS.hasOwnProperty(name) ?  false ? invariant(false, 'updatePropertyByID(...): %s', INVALID_PROPERTY_ERRORS[name]) : invariant(false) : undefined;
	
	    // If we're updating to null or undefined, we should remove the property
	    // from the DOM node instead of inadvertantly setting to a string. This
	    // brings us in line with the same behavior we have on initial render.
	    if (value != null) {
	      DOMPropertyOperations.setValueForProperty(node, name, value);
	    } else {
	      DOMPropertyOperations.deleteValueForProperty(node, name);
	    }
	  },
	
	  /**
	   * Replaces a DOM node that exists in the document with markup.
	   *
	   * @param {string} id ID of child to be replaced.
	   * @param {string} markup Dangerous markup to inject in place of child.
	   * @internal
	   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
	   */
	  dangerouslyReplaceNodeWithMarkupByID: function (id, markup) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
	  },
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markup List of markup strings.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (updates, markup) {
	    for (var i = 0; i < updates.length; i++) {
	      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
	    }
	    DOMChildrenOperations.processUpdates(updates, markup);
	  }
	};
	
	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(49);
	var ReactElement = __webpack_require__(35);
	var ReactInstanceMap = __webpack_require__(98);
	var ReactUpdates = __webpack_require__(41);
	
	var assign = __webpack_require__(17);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(16);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : undefined;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition ' + '(such as within `render`). Render methods should be a pure function ' + 'of props and state.', callerName) : undefined;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueSetPropsInternal(internalInstance, partialProps);
	  },
	
	  enqueueSetPropsInternal: function (internalInstance, partialProps) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'setProps(...): You called `setProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    var props = assign({}, element.props, partialProps);
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueReplacePropsInternal(internalInstance, props);
	  },
	
	  enqueueReplacePropsInternal: function (internalInstance, props) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'replaceProps(...): You called `replaceProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  enqueueElementInternal: function (internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 200 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '0.14.10';


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(49);
	var ReactInstanceMap = __webpack_require__(98);
	var ReactMount = __webpack_require__(34);
	
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(16);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing getDOMNode or findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	  if (ReactInstanceMap.has(componentOrElement)) {
	    return ReactMount.getNodeFromInstance(componentOrElement);
	  }
	  !(componentOrElement.render == null || typeof componentOrElement.render !== 'function') ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : undefined;
	   true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : undefined;
	}
	
	module.exports = findDOMNode;

/***/ },
/* 202 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 203 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 204 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 205 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/* global Symbol */
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCompositeComponent = __webpack_require__(903);
	var ReactEmptyComponent = __webpack_require__(362);
	var ReactNativeComponent = __webpack_require__(368);
	
	var assign = __webpack_require__(17);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(16);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function () {};
	assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = new ReactEmptyComponent(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : undefined;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactNativeComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper();
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : undefined;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.construct === 'function' && typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : undefined;
	  }
	
	  // Sets up the instance. This can probably just move into the constructor now.
	  instance.construct(node);
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = (eventName in document);
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	var escapeTextContentForBrowser = __webpack_require__(132);
	var setInnerHTML = __webpack_require__(133);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 209 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	  return false;
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(49);
	var ReactElement = __webpack_require__(35);
	var ReactInstanceHandles = __webpack_require__(81);
	
	var getIteratorFn = __webpack_require__(205);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(16);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  '.': '=1',
	  ':': '=2'
	};
	
	var userProvidedKeyEscapeRegex = /[=.:]/g;
	
	var didWarnAboutMaps = false;
	
	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  if (component && component.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} text Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, userProvidedKeyEscaper);
	}
	
	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : undefined;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + wrapUserProvidedKey(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : undefined;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var assign = __webpack_require__(17);
	var emptyFunction = __webpack_require__(42);
	var warning = __webpack_require__(16);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    parentTag: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.parentTag = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    /*eslint-disable space-after-keywords */
	    do {
	      /*eslint-enable space-after-keywords */
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a child of <%s>. ' + 'See %s.%s', childTag, ancestorTag, ownerInfo, info) : undefined;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a descendant of ' + '<%s>. See %s.', childTag, ancestorTag, ownerInfo) : undefined;
	      }
	    }
	  };
	
	  validateDOMNesting.ancestorInfoContextKey = '__validateDOMNesting_ancestorInfo$' + Math.random().toString(36).slice(2);
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 212 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var ADD_ARRAY_VALUE = exports.ADD_ARRAY_VALUE = 'redux-form/ADD_ARRAY_VALUE';
	var AUTOFILL = exports.AUTOFILL = 'redux-form/AUTOFILL';
	var BLUR = exports.BLUR = 'redux-form/BLUR';
	var CHANGE = exports.CHANGE = 'redux-form/CHANGE';
	var DESTROY = exports.DESTROY = 'redux-form/DESTROY';
	var FOCUS = exports.FOCUS = 'redux-form/FOCUS';
	var INITIALIZE = exports.INITIALIZE = 'redux-form/INITIALIZE';
	var REMOVE_ARRAY_VALUE = exports.REMOVE_ARRAY_VALUE = 'redux-form/REMOVE_ARRAY_VALUE';
	var RESET = exports.RESET = 'redux-form/RESET';
	var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = 'redux-form/START_ASYNC_VALIDATION';
	var START_SUBMIT = exports.START_SUBMIT = 'redux-form/START_SUBMIT';
	var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = 'redux-form/STOP_ASYNC_VALIDATION';
	var STOP_SUBMIT = exports.STOP_SUBMIT = 'redux-form/STOP_SUBMIT';
	var SUBMIT_FAILED = exports.SUBMIT_FAILED = 'redux-form/SUBMIT_FAILED';
	var SWAP_ARRAY_VALUES = exports.SWAP_ARRAY_VALUES = 'redux-form/SWAP_ARRAY_VALUES';
	var TOUCH = exports.TOUCH = 'redux-form/TOUCH';
	var UNTOUCH = exports.UNTOUCH = 'redux-form/UNTOUCH';

/***/ },
/* 213 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = mapValues;
	/**
	 * Maps all the values in the given object through the given function and saves them, by key, to a result object
	 */
	function mapValues(obj, fn) {
	  return obj ? Object.keys(obj).reduce(function (accumulator, key) {
	    var _extends2;
	
	    return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = fn(obj[key], key), _extends2));
	  }, {}) : obj;
	}

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.initialState = exports.globalErrorKey = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _initialState, _behaviors;
	
	var _actionTypes = __webpack_require__(212);
	
	var _mapValues = __webpack_require__(213);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _read = __webpack_require__(390);
	
	var _read2 = _interopRequireDefault(_read);
	
	var _write = __webpack_require__(391);
	
	var _write2 = _interopRequireDefault(_write);
	
	var _getValuesFromState = __webpack_require__(386);
	
	var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);
	
	var _initializeState = __webpack_require__(388);
	
	var _initializeState2 = _interopRequireDefault(_initializeState);
	
	var _resetState = __webpack_require__(962);
	
	var _resetState2 = _interopRequireDefault(_resetState);
	
	var _setErrors = __webpack_require__(963);
	
	var _setErrors2 = _interopRequireDefault(_setErrors);
	
	var _fieldValue = __webpack_require__(82);
	
	var _normalizeFields = __webpack_require__(958);
	
	var _normalizeFields2 = _interopRequireDefault(_normalizeFields);
	
	var _createInitialState = __webpack_require__(379);
	
	var _createInitialState2 = _interopRequireDefault(_createInitialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var globalErrorKey = exports.globalErrorKey = '_error';
	
	var initialState = exports.initialState = (_initialState = {
	  _active: undefined,
	  _asyncValidating: false
	}, _initialState[globalErrorKey] = undefined, _initialState._initialized = false, _initialState._submitting = false, _initialState._submitFailed = false, _initialState);
	
	var behaviors = (_behaviors = {}, _behaviors[_actionTypes.ADD_ARRAY_VALUE] = function (state, _ref) {
	  var path = _ref.path,
	      index = _ref.index,
	      value = _ref.value,
	      fields = _ref.fields;
	
	  var array = (0, _read2.default)(path, state);
	  var stateCopy = _extends({}, state);
	  var arrayCopy = array ? [].concat(array) : [];
	  var newValue = value !== null && typeof value === 'object' ? (0, _initializeState2.default)(value, fields || Object.keys(value)) : (0, _fieldValue.makeFieldValue)({ value: value });
	  if (index === undefined) {
	    arrayCopy.push(newValue);
	  } else {
	    arrayCopy.splice(index, 0, newValue);
	  }
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.AUTOFILL] = function (state, _ref2) {
	  var field = _ref2.field,
	      value = _ref2.value;
	
	  return (0, _write2.default)(field, function (previous) {
	    var _previous$value$autof = _extends({}, previous, { value: value, autofilled: true }),
	        asyncError = _previous$value$autof.asyncError,
	        submitError = _previous$value$autof.submitError,
	        result = _objectWithoutProperties(_previous$value$autof, ['asyncError', 'submitError']);
	
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, state);
	}, _behaviors[_actionTypes.BLUR] = function (state, _ref3) {
	  var field = _ref3.field,
	      value = _ref3.value,
	      touch = _ref3.touch;
	
	  var _active = state._active,
	      stateCopy = _objectWithoutProperties(state, ['_active']);
	
	  if (_active && _active !== field) {
	    // remove _active from state
	    stateCopy._active = _active;
	  }
	  return (0, _write2.default)(field, function (previous) {
	    var result = _extends({}, previous);
	    if (value !== undefined) {
	      result.value = value;
	    }
	    if (touch) {
	      result.touched = true;
	    }
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, stateCopy);
	}, _behaviors[_actionTypes.CHANGE] = function (state, _ref4) {
	  var field = _ref4.field,
	      value = _ref4.value,
	      touch = _ref4.touch;
	
	  return (0, _write2.default)(field, function (previous) {
	    var _previous$value = _extends({}, previous, { value: value }),
	        asyncError = _previous$value.asyncError,
	        submitError = _previous$value.submitError,
	        autofilled = _previous$value.autofilled,
	        result = _objectWithoutProperties(_previous$value, ['asyncError', 'submitError', 'autofilled']);
	
	    if (touch) {
	      result.touched = true;
	    }
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, state);
	}, _behaviors[_actionTypes.DESTROY] = function () {
	  return undefined;
	}, _behaviors[_actionTypes.FOCUS] = function (state, _ref5) {
	  var field = _ref5.field;
	
	  var stateCopy = (0, _write2.default)(field, function (previous) {
	    return (0, _fieldValue.makeFieldValue)(_extends({}, previous, { visited: true }));
	  }, state);
	  stateCopy._active = field;
	  return stateCopy;
	}, _behaviors[_actionTypes.INITIALIZE] = function (state, _ref6) {
	  var data = _ref6.data,
	      fields = _ref6.fields,
	      overwriteValues = _ref6.overwriteValues;
	
	  return (0, _createInitialState2.default)(data, fields, state, overwriteValues);
	}, _behaviors[_actionTypes.REMOVE_ARRAY_VALUE] = function (state, _ref7) {
	  var path = _ref7.path,
	      indexOfValue = _ref7.index,
	      predicate = _ref7.predicate;
	
	  var array = (0, _read2.default)(path, state);
	  var stateCopy = _extends({}, state);
	  var arrayCopy = array ? [].concat(array) : [];
	  var index = void 0;
	
	  if (predicate) {
	    index = arrayCopy.findIndex(predicate);
	  } else {
	    index = indexOfValue;
	  }
	
	  if (index === undefined) {
	    arrayCopy.pop();
	  } else if (isNaN(index)) {
	    delete arrayCopy[index];
	  } else {
	    arrayCopy.splice(index, 1);
	  }
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.RESET] = function (state) {
	  var _extends2;
	
	  return _extends({}, (0, _resetState2.default)(state), (_extends2 = {
	    _active: undefined,
	    _asyncValidating: false
	  }, _extends2[globalErrorKey] = undefined, _extends2._initialized = state._initialized, _extends2._submitting = false, _extends2._submitFailed = false, _extends2));
	}, _behaviors[_actionTypes.START_ASYNC_VALIDATION] = function (state, _ref8) {
	  var field = _ref8.field;
	
	  return _extends({}, state, {
	    _asyncValidating: field || true
	  });
	}, _behaviors[_actionTypes.START_SUBMIT] = function (state) {
	  return _extends({}, state, {
	    _submitting: true
	  });
	}, _behaviors[_actionTypes.STOP_ASYNC_VALIDATION] = function (state, _ref9) {
	  var _extends3;
	
	  var errors = _ref9.errors;
	
	  return _extends({}, (0, _setErrors2.default)(state, errors, 'asyncError'), (_extends3 = {
	    _asyncValidating: false
	  }, _extends3[globalErrorKey] = errors && errors[globalErrorKey], _extends3));
	}, _behaviors[_actionTypes.STOP_SUBMIT] = function (state, _ref10) {
	  var _extends4;
	
	  var errors = _ref10.errors;
	
	  return _extends({}, (0, _setErrors2.default)(state, errors, 'submitError'), (_extends4 = {}, _extends4[globalErrorKey] = errors && errors[globalErrorKey], _extends4._submitting = false, _extends4._submitFailed = !!(errors && Object.keys(errors).length), _extends4));
	}, _behaviors[_actionTypes.SUBMIT_FAILED] = function (state) {
	  return _extends({}, state, {
	    _submitFailed: true
	  });
	}, _behaviors[_actionTypes.SWAP_ARRAY_VALUES] = function (state, _ref11) {
	  var path = _ref11.path,
	      indexA = _ref11.indexA,
	      indexB = _ref11.indexB;
	
	  var array = (0, _read2.default)(path, state);
	  var arrayLength = array.length;
	  if (indexA === indexB || isNaN(indexA) || isNaN(indexB) || indexA >= arrayLength || indexB >= arrayLength) {
	    return state; // do nothing
	  }
	  var stateCopy = _extends({}, state);
	  var arrayCopy = [].concat(array);
	  arrayCopy[indexA] = array[indexB];
	  arrayCopy[indexB] = array[indexA];
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.TOUCH] = function (state, _ref12) {
	  var fields = _ref12.fields;
	
	  return _extends({}, state, fields.reduce(function (accumulator, field) {
	    return (0, _write2.default)(field, function (value) {
	      return (0, _fieldValue.makeFieldValue)(_extends({}, value, { touched: true }));
	    }, accumulator);
	  }, state));
	}, _behaviors[_actionTypes.UNTOUCH] = function (state, _ref13) {
	  var fields = _ref13.fields;
	
	  return _extends({}, state, fields.reduce(function (accumulator, field) {
	    return (0, _write2.default)(field, function (value) {
	      if (value) {
	        var touched = value.touched,
	            rest = _objectWithoutProperties(value, ['touched']);
	
	        return (0, _fieldValue.makeFieldValue)(rest);
	      }
	      return (0, _fieldValue.makeFieldValue)(value);
	    }, accumulator);
	  }, state));
	}, _behaviors);
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var behavior = behaviors[action.type];
	  return behavior ? behavior(state, action) : state;
	};
	
	function formReducer() {
	  var _extends10;
	
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var form = action.form,
	      key = action.key,
	      rest = _objectWithoutProperties(action, ['form', 'key']); // eslint-disable-line no-redeclare
	
	
	  if (!form) {
	    return state;
	  }
	  if (key) {
	    var _extends7, _extends8;
	
	    if (action.type === _actionTypes.DESTROY) {
	      var _extends6;
	
	      return _extends({}, state, (_extends6 = {}, _extends6[form] = state[form] && Object.keys(state[form]).reduce(function (accumulator, stateKey) {
	        var _extends5;
	
	        return stateKey === key ? accumulator : _extends({}, accumulator, (_extends5 = {}, _extends5[stateKey] = state[form][stateKey], _extends5));
	      }, {}), _extends6));
	    }
	    return _extends({}, state, (_extends8 = {}, _extends8[form] = _extends({}, state[form], (_extends7 = {}, _extends7[key] = reducer((state[form] || {})[key], rest), _extends7)), _extends8));
	  }
	  if (action.type === _actionTypes.DESTROY) {
	    return Object.keys(state).reduce(function (accumulator, formName) {
	      var _extends9;
	
	      return formName === form ? accumulator : _extends({}, accumulator, (_extends9 = {}, _extends9[formName] = state[formName], _extends9));
	    }, {});
	  }
	  return _extends({}, state, (_extends10 = {}, _extends10[form] = reducer(state[form], rest), _extends10));
	}
	
	/**
	 * Adds additional functionality to the reducer
	 */
	function decorate(target) {
	  target.plugin = function plugin(reducers) {
	    var _this = this;
	
	    // use 'function' keyword to enable 'this'
	    return decorate(function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var result = _this(state, action);
	      return _extends({}, result, (0, _mapValues2.default)(reducers, function (pluginReducer, key) {
	        return pluginReducer(result[key] || initialState, action);
	      }));
	    });
	  };
	
	  target.normalize = function normalize(normalizers) {
	    var _this2 = this;
	
	    // use 'function' keyword to enable 'this'
	    return decorate(function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var result = _this2(state, action);
	      return _extends({}, result, (0, _mapValues2.default)(normalizers, function (formNormalizers, form) {
	        var runNormalize = function runNormalize(previous, currentResult) {
	          var previousValues = (0, _getValuesFromState2.default)(_extends({}, initialState, previous));
	          var formResult = _extends({}, initialState, currentResult);
	          var values = (0, _getValuesFromState2.default)(formResult);
	          return (0, _normalizeFields2.default)(formNormalizers, formResult, previous, values, previousValues);
	        };
	        if (action.key) {
	          var _extends11;
	
	          return _extends({}, result[form], (_extends11 = {}, _extends11[action.key] = runNormalize(state[form][action.key], result[form][action.key]), _extends11));
	        }
	        return runNormalize(state[form], result[form]);
	      }));
	    });
	  };
	
	  return target;
	}
	
	exports.default = decorate(formReducer);

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(407);

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	var buildURL = __webpack_require__(413);
	var parseHeaders = __webpack_require__(418);
	var transformData = __webpack_require__(217);
	var isURLSameOrigin = __webpack_require__(417);
	var btoa = window.btoa || __webpack_require__(412);
	
	module.exports = function xhrAdapter(resolve, reject, config) {
	  var requestData = config.data;
	  var requestHeaders = config.headers;
	
	  if (utils.isFormData(requestData)) {
	    delete requestHeaders['Content-Type']; // Let the browser set it
	  }
	
	  var request = new XMLHttpRequest();
	
	  // For IE 8/9 CORS support
	  // Only supports POST and GET calls and doesn't returns the response headers.
	  if (window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
	    request = new window.XDomainRequest();
	  }
	
	  // HTTP basic authentication
	  if (config.auth) {
	    var username = config.auth.username || '';
	    var password = config.auth.password || '';
	    requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	  }
	
	  request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	  // Set the request timeout in MS
	  request.timeout = config.timeout;
	
	  // Listen for ready state
	  request.onload = function handleLoad() {
	    if (!request) {
	      return;
	    }
	    // Prepare the response
	    var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	    var responseData = ['text', ''].indexOf(config.responseType || '') !== -1 ? request.responseText : request.response;
	    var response = {
	      data: transformData(
	        responseData,
	        responseHeaders,
	        config.transformResponse
	      ),
	      // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	      status: request.status === 1223 ? 204 : request.status,
	      statusText: request.status === 1223 ? 'No Content' : request.statusText,
	      headers: responseHeaders,
	      config: config
	    };
	
	    // Resolve or reject the Promise based on the status
	    ((response.status >= 200 && response.status < 300) ||
	     (!('status' in request) && response.responseText) ?
	      resolve :
	      reject)(response);
	
	    // Clean up request
	    request = null;
	  };
	
	  // Handle low level network errors
	  request.onerror = function handleError() {
	    // Real errors are hidden from us by the browser
	    // onerror should only fire if it's a network error
	    reject(new Error('Network Error'));
	
	    // Clean up request
	    request = null;
	  };
	
	  // Add xsrf header
	  // This is only done if running in a standard browser environment.
	  // Specifically not if we're in a web worker, or react-native.
	  if (utils.isStandardBrowserEnv()) {
	    var cookies = __webpack_require__(415);
	
	    // Add xsrf header
	    var xsrfValue = config.withCredentials || isURLSameOrigin(config.url) ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	    if (xsrfValue) {
	      requestHeaders[config.xsrfHeaderName] = xsrfValue;
	    }
	  }
	
	  // Add headers to the request
	  if ('setRequestHeader' in request) {
	    utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	      if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	        // Remove Content-Type if data is undefined
	        delete requestHeaders[key];
	      } else {
	        // Otherwise add header to the request
	        request.setRequestHeader(key, val);
	      }
	    });
	  }
	
	  // Add withCredentials to request if needed
	  if (config.withCredentials) {
	    request.withCredentials = true;
	  }
	
	  // Add responseType to request if needed
	  if (config.responseType) {
	    try {
	      request.responseType = config.responseType;
	    } catch (e) {
	      if (request.responseType !== 'json') {
	        throw e;
	      }
	    }
	  }
	
	  if (utils.isArrayBuffer(requestData)) {
	    requestData = new DataView(requestData);
	  }
	
	  // Send the request
	  request.send(requestData);
	};


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AboutHeader = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutHeader = exports.AboutHeader = function (_Component) {
	  _inherits(AboutHeader, _Component);
	
	  function AboutHeader(props) {
	    _classCallCheck(this, AboutHeader);
	
	    var _this = _possibleConstructorReturn(this, (AboutHeader.__proto__ || Object.getPrototypeOf(AboutHeader)).call(this, props));
	
	    _this.state = {
	      status: '',
	      keyword: ''
	    };
	    _this.test = _this.test.bind(_this);
	    return _this;
	  }
	
	  _createClass(AboutHeader, [{
	    key: 'test',
	    value: function test(type) {
	      // console.log(type);
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(event) {
	      this.setState({
	        status: 'foucs',
	        keyword: event.target.value
	      });
	    }
	  }, {
	    key: 'onChangeKey',
	    value: function onChangeKey(event) {
	      this.props.search_products(event.target.value);
	      this.setState({
	        keyword: event.target.value
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      this.setState({
	        status: 'unfocus'
	      });
	    }
	  }, {
	    key: 'resetKey',
	    value: function resetKey() {
	      this.props.search_products('');
	      this.setState({
	        keyword: ''
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.clear_state();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      (0, _jquery2.default)(document).on('mouseup', function (e) {
	        var container = (0, _jquery2.default)('.search');
	        var container_sub = (0, _jquery2.default)('.res');
	
	        if (!container.is(e.target) // if the target of the click isn't the container...
	        && container.has(e.target).length === 0) // ... nor a descendant of the container
	          {
	            container_sub.hide();
	          } else {
	          container_sub.show();
	        }
	      });
	      if (this.props.brands.length > 0) {
	        var brands = _react2.default.createElement(
	          'h5',
	          { className: 'brand_hdr' },
	          'Brands'
	        );
	      }
	      if (this.props.products.length > 0) {
	        var products = _react2.default.createElement(
	          'h5',
	          { className: 'brand_hdr' },
	          'Products'
	        );
	      }
	      var brands_list = this.props.brands.map(function (brand, index) {
	        // var link = this.props.params.Type;
	        return _react2.default.createElement(
	          'li',
	          { key: index },
	          _react2.default.createElement(
	            'a',
	            { style: { textDecoration: 'none' }, className: 'brand_tlt', href: "/pdeals/" + brand.id + "/" + brand.type + "/" + brand.dtype },
	            brand.category_name
	          )
	        );
	      });
	      var product_list = this.props.products.map(function (product, index) {
	        var _this2 = this;
	
	        // var link = this.props.params.Type;
	        return _react2.default.createElement(
	          'li',
	          { key: index },
	          _react2.default.createElement(
	            'a',
	            { className: 'brand_tlt', href: "/subdeals/" + product.id + "/" + product.dtype, onClick: function onClick() {
	                _this2.test("/subdeals/" + product.id + "/" + product.dtype);
	              } },
	            product.category_name
	          )
	        );
	      }.bind(this));
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'web_deals' },
	        _react2.default.createElement(
	          'section',
	          { className: 'indx_hdr hm_hdr' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inx_nav' },
	            _react2.default.createElement(
	              'nav',
	              { className: 'navbar navbar-default' },
	              _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-2 col-sm-3 col-xs-6' },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { className: 'navbar-brand ad_logo about_adlogo', to: "/web/home" },
	                      ' ',
	                      _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images_web/logo.png', title: 'AquaDeals', alt: 'AquaDeals' }),
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        '#HappyFarming'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-3 col-sm-4 col-xs-6 pull-right' },
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'nav navbar-nav navbar-right' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          { href: 'https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en', target: '_blank', title: '', className: 'play_img' },
	                          _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/google_play_store_icon.png', alt: 'download', title: 'Download AquaDeals Mobile App' })
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement('div', { className: 'col-md-6 col-md-offset-1 col-sm-12 col-xs-12' })
	                )
	              ),
	              ' '
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'res', style: { maxWidth: '550px', maxHeight: '400px', position: 'absolute', left: 0, overflowX: 'hidden', overflowY: 'scroll', margin: '0 auto', textDecoration: 'none', right: 0, top: '57px', display: 'none' } },
	              _react2.default.createElement(
	                'div',
	                null,
	                brands
	              ),
	              _react2.default.createElement(
	                'ul',
	                { style: { paddingLeft: 15 + 'px' } },
	                brands_list
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                products
	              ),
	              _react2.default.createElement(
	                'ul',
	                { style: { paddingLeft: 15 + 'px' } },
	                product_list
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          )
	        )
	      );
	    }
	  }]);
	
	  return AboutHeader;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    search: state.posts.search,
	    brands: state.posts.brands,
	    products: state.posts.products,
	    trendings: state.posts.trendings
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(AboutHeader);

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactStars = __webpack_require__(33);
	
	var _reactStars2 = _interopRequireDefault(_reactStars);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactShare = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var PDeal = function (_Component) {
	  _inherits(PDeal, _Component);
	
	  function PDeal() {
	    _classCallCheck(this, PDeal);
	
	    var _this = _possibleConstructorReturn(this, (PDeal.__proto__ || Object.getPrototypeOf(PDeal)).call(this));
	
	    _this.state = {
	      open: false,
	      shareUrl: '',
	      msg: '',
	      showModal: false,
	      showModalLogin: false
	    };
	    _this.ShareFunc = _this.ShareFunc.bind(_this);
	    return _this;
	  }
	
	  _createClass(PDeal, [{
	    key: 'ShareFunc',
	    value: function ShareFunc(evnt) {
	      var _this2 = this;
	
	      var data1 = { from: 'desktop_web', type: 1, did: evnt };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'createTinyurl',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            msg: data.msg,
	            shareUrl: data.tinyurl
	          });
	        }.bind(this),
	        error: function error(err) {
	          // console.log("Error"+err);
	        }
	      });
	      this.setState({
	        open: !this.state.open
	      });
	      setTimeout(function () {
	        _this2.setState({ open: false });
	      }, 5000);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var product = this.props.data;
	      var shareUrl = this.state.shareUrl;
	      var title = "Hey! Click here " + shareUrl + " to check " + product.title + " deal from AquaDeals.";
	      var description = shareUrl;
	      return (
	        // var star_rate = product.over_rate >=1 ? product.over_rate :'' ;  
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-3 col-sm-6' },
	          product.pid ? _react2.default.createElement(
	            'div',
	            { className: 'prdt_blk' },
	            product.dealcount <= 1 ? _react2.default.createElement(
	              _reactRouter.Link,
	              { className: 'lst_share_btn', onClick: function onClick() {
	                  _this3.ShareFunc(product.deal_id);
	                } },
	              _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/share.png', alt: 'Share' })
	            ) : _react2.default.createElement(
	              'span',
	              { className: 'lst_share_btn' },
	              '\xA0'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { className: 'share_panel ', collapsible: true, expanded: this.state.open },
	              _react2.default.createElement(
	                FacebookShareButton,
	                { url: shareUrl, quote: title, className: 'test_share' },
	                _react2.default.createElement(FacebookIcon, { size: 32, round: true })
	              ),
	              _react2.default.createElement(
	                TwitterShareButton,
	                { url: shareUrl, quote: title, className: 'test_share' },
	                _react2.default.createElement(TwitterIcon, { size: 32, round: true })
	              ),
	              _react2.default.createElement(
	                GooglePlusShareButton,
	                { url: shareUrl, quote: title, description: description, className: 'test_share' },
	                _react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
	              )
	            ),
	            product.dealcount >= 2 ? _react2.default.createElement(
	              'div',
	              null,
	              product.ad_guarantee_flag === '1' ? _react2.default.createElement(
	                'span',
	                { className: 'web_ad_guarantee' },
	                _react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: 'presentation' })
	              ) : '',
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: "/web/subdeals/" + product.url_dtype_name + "/" + product.url_cat_name + "/" + product.dtype + "/" + product.url_brand_name + "/" + product.pid },
	                product.promo_ribbion ? _react2.default.createElement(
	                  'i',
	                  { className: 'ribbon_img' },
	                  _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + product.promo_ribbion, alt: 'ribbon' })
	                ) : '',
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('img', { alt: ' ', src: product.image !== null && product.image !== '' ? baseAssets + 'images/product_imgs/thumbnails/' + product.image : baseAssets + 'icons/web_icons/noImage.png' })
	                ),
	                product.title ? _react2.default.createElement(
	                  'h3',
	                  null,
	                  product.title,
	                  ' ',
	                  product.quantity
	                ) : _react2.default.createElement(
	                  'h3',
	                  null,
	                  '\xA0'
	                ),
	                product.brand_name ? _react2.default.createElement(
	                  'h4',
	                  null,
	                  product.brand_name
	                ) : _react2.default.createElement(
	                  'h4',
	                  null,
	                  '\xA0'
	                ),
	                product.dealcount >= 2 ? _react2.default.createElement(
	                  'h4',
	                  null,
	                  product.dealcount,
	                  ' deals available'
	                ) : _react2.default.createElement(
	                  'h4',
	                  null,
	                  '\xA0'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row stars_view_blk' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-7 col-xs-7', style: { paddingRight: '0' } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'prdt_str_rt' },
	                    _react2.default.createElement(_reactStars2.default, {
	                      count: 5,
	                      className: 'webRate_blk_item',
	                      size: 17,
	                      value: product.over_rate >= 1 ? product.over_rate : 0,
	                      edit: false,
	                      color1: '#ccc',
	                      color2: '#ffc50a' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-5 col-xs-5', style: { paddingLeft: 0 } },
	                  product.count > 0 && product.dealcount <= 1 ? _react2.default.createElement(
	                    'span',
	                    { className: 'prdt_views' },
	                    _react2.default.createElement(
	                      'i',
	                      null,
	                      _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
	                    ),
	                    ' ',
	                    product.count
	                  ) : _react2.default.createElement(
	                    'span',
	                    { className: 'prdt_views hide_views' },
	                    _react2.default.createElement(
	                      'i',
	                      null,
	                      _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
	                    ),
	                    ' 0'
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: 'clr' })
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              product.ad_guarantee_flag === 1 ? _react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: 'presentation' }) : '',
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { key: product.pid, className: 'cursor', to: "/web/pdetails/" + product.url_dtype_name + "/" + product.url_cat_name + "/" + product.url_brand_name + "/" + product.url_product_name + "/" + product.pid + "/" + product.deal_id },
	                product.promo_ribbion ? _react2.default.createElement(
	                  'i',
	                  { className: 'ribbon_img' },
	                  _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/' + product.promo_ribbion, alt: '' })
	                ) : '',
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('img', { alt: ' ', src: product.image !== null && product.image !== '' ? 'https://aquadeals.in/admin/assets/images/product_imgs/thumbnails/' + product.image : 'https://aquadeals.in/admin/assets/icons/web_icons/noImage.png' })
	                ),
	                product.title ? _react2.default.createElement(
	                  'h3',
	                  null,
	                  product.title,
	                  ' ',
	                  product.quantity
	                ) : _react2.default.createElement(
	                  'h3',
	                  null,
	                  '\xA0'
	                ),
	                product.brand_name ? _react2.default.createElement(
	                  'h4',
	                  null,
	                  product.brand_name
	                ) : _react2.default.createElement(
	                  'h4',
	                  null,
	                  '\xA0'
	                ),
	                product.pricediff ? _react2.default.createElement(
	                  'h4',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'AquaCash Discount'
	                  ),
	                  '\xA0',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u20B9',
	                    product.pricediff
	                  )
	                ) : '',
	                product.pricediff === "" || product.pricediff === 0 ? _react2.default.createElement(
	                  'h4',
	                  null,
	                  'MRP \u20B9 ',
	                  product.mrp
	                ) : ''
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row stars_view_blk' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-7 col-md-7 col-xs-7', style: { paddingRight: '0' } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'prdt_str_rt' },
	                    _react2.default.createElement(_reactStars2.default, {
	                      count: 5,
	                      className: 'webRate_blk_item',
	                      size: 17,
	                      value: product.over_rate >= 1 ? product.over_rate : 0,
	                      edit: false,
	                      color1: '#ccc',
	                      color2: '#ffc50a' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-5 col-md-5 col-xs-5', style: { paddingLeft: 0 } },
	                  product.count > 0 && product.dealcount <= 1 ? _react2.default.createElement(
	                    'span',
	                    { className: 'prdt_views' },
	                    _react2.default.createElement(
	                      'i',
	                      null,
	                      _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
	                    ),
	                    ' ',
	                    product.count
	                  ) : _react2.default.createElement(
	                    'span',
	                    { className: 'prdt_views hide_views' },
	                    _react2.default.createElement(
	                      'i',
	                      null,
	                      _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
	                    ),
	                    ' 0'
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: 'clr' })
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'prdt_blk' },
	            product.ad_guarantee_flag === 1 ? _react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: 'presentation' }) : '',
	            product.dealcount <= 1 ? _react2.default.createElement(
	              _reactRouter.Link,
	              { className: 'lst_share_btn', onClick: function onClick() {
	                  _this3.ShareFunc(product.id);
	                } },
	              _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/share.png', alt: 'Share' })
	            ) : _react2.default.createElement(
	              'span',
	              { className: 'lst_share_btn' },
	              '\xA0'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { className: 'share_panel', collapsible: true, expanded: this.state.open },
	              _react2.default.createElement(
	                FacebookShareButton,
	                { url: shareUrl, quote: title, className: 'test_share' },
	                _react2.default.createElement(FacebookIcon, { size: 32, round: true })
	              ),
	              _react2.default.createElement(
	                TwitterShareButton,
	                { url: shareUrl, quote: title, className: 'test_share' },
	                _react2.default.createElement(TwitterIcon, { size: 32, round: true })
	              ),
	              _react2.default.createElement(
	                GooglePlusShareButton,
	                { url: shareUrl, quote: title, className: 'test_share' },
	                _react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { key: product.pid, to: "/web/pdetails/" + product.url_dtype_name + "/" + product.url_cat_name + "/" + product.url_brand_name + "/" + product.url_product_name + "/" + product.pro_id + "/" + product.id },
	              product.promo_ribbion ? _react2.default.createElement(
	                'i',
	                { className: 'ribbon_img' },
	                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/' + product.promo_ribbion, alt: '' })
	              ) : '',
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('img', { alt: ' ', src: product.image !== null && product.image !== '' ? 'https://aquadeals.in/admin/assets/images/product_imgs/thumbnails/' + product.image : 'https://aquadeals.in/admin/assets/icons/web_icons/noImage.png' })
	              ),
	              product.title ? _react2.default.createElement(
	                'h3',
	                null,
	                product.title,
	                ' ',
	                product.quantity
	              ) : _react2.default.createElement(
	                'h3',
	                null,
	                '\xA0'
	              ),
	              product.brand_name ? _react2.default.createElement(
	                'h4',
	                null,
	                product.brand_name
	              ) : _react2.default.createElement(
	                'h4',
	                null,
	                '\xA0'
	              ),
	              product.pricediff ? _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'AquaCash Discount'
	                ),
	                '\xA0',
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  '\u20B9',
	                  product.pricediff
	                )
	              ) : '',
	              product.pricediff === "" || product.pricediff === 0 ? _react2.default.createElement(
	                'h4',
	                null,
	                'MRP \u20B9 ',
	                product.mrp
	              ) : ''
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row stars_view_blk' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-lg-7 col-md-7 col-sm-7 col-xs-7', style: { paddingRight: '0' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'prdt_str_rt' },
	                  _react2.default.createElement(_reactStars2.default, {
	                    count: 5,
	                    className: 'webRate_blk_item',
	                    size: 17,
	                    value: product.over_rate >= 1 ? product.over_rate : 0,
	                    edit: false,
	                    color1: '#ccc',
	                    color2: '#ffc50a' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-lg-5 col-md-5 col-sm-5 col-xs-5', style: { paddingLeft: 0 } },
	                product.count > 0 ? _react2.default.createElement(
	                  'span',
	                  { className: 'prdt_views' },
	                  _react2.default.createElement(
	                    'i',
	                    null,
	                    _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
	                  ),
	                  ' ',
	                  product.count
	                ) : _react2.default.createElement(
	                  'span',
	                  { className: 'prdt_views hide_views' },
	                  _react2.default.createElement(
	                    'i',
	                    null,
	                    _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
	                  ),
	                  ' 0'
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'clr' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return PDeal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    errorMessage: state.auth.error,
	    authenticated: state.auth.authenticated,
	    formdata: state.auth.formdata,
	    formdata_log: state.auth.formdata_log
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(PDeal);

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var WebPromotions = function (_Component) {
		_inherits(WebPromotions, _Component);
	
		function WebPromotions(props) {
			_classCallCheck(this, WebPromotions);
	
			var _this = _possibleConstructorReturn(this, (WebPromotions.__proto__ || Object.getPrototypeOf(WebPromotions)).call(this, props));
	
			_this.state = {
				tot_data: [],
				product_offers: [],
				seed_offers: [],
				offers: [],
				status: ''
			};
			_this.getOffers = _this.getOffers.bind(_this);
			_this.goPrev = _this.goPrev.bind(_this);
			_this.goNext = _this.goNext.bind(_this);
			_this.swiper = null;
			return _this;
		}
	
		_createClass(WebPromotions, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.getOffers();
			}
		}, {
			key: 'getOffers',
			value: function getOffers() {
				var data1 = { from: 'desktop_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getOffers',
					success: function (data) {
						if (data.status === 'available') {
							this.setState({
								tot_data: data,
								product_offers: data.product_offers,
								seed_offers: data.seed_offers,
								offers: data.offers,
								status: 'available'
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'goNext',
			value: function goNext() {
				if (this.swiper) this.swiper.slideNext();
			}
		}, {
			key: 'goPrev',
			value: function goPrev() {
				if (this.swiper) this.swiper.slidePrev();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var params = {
					paginationClickable: true,
					spaceBetween: 10,
					slidesPerView: 2.8,
					// autoplay:3000,
					autoplayDisableOnInteraction: false,
					// loop:true,
					// pagination: '.swiper-pagination'
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				};
	
				var product_offers = this.state.product_offers.map(function (product, index) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ className: 'web_promo_ofr_item', to: "/web/pdetails/" + product.url_dtype_name + "/" + product.url_cat_name + "/" + product.url_brand_name + "/" + product.url_product_name + "/" + product.product_id + "/" + product.deal_id },
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_product_ofer_icon' },
							_react2.default.createElement('img', { style: { paddingTop: '5px' }, src: product.img, alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_product_cntnt' },
							product.title ? _react2.default.createElement(
								'h5',
								{ className: 'web_promo_product_title' },
								product.title
							) : _react2.default.createElement(
								'h5',
								null,
								'\xA0'
							),
							product.desc ? _react2.default.createElement(
								'h6',
								{ className: 'web_promo_product_desc' },
								product.desc
							) : _react2.default.createElement(
								'h6',
								null,
								'\xA0'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_ofer_arrow' },
							_react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
						)
					);
				});
				var seed_offers = this.state.seed_offers.map(function (seed, index) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ className: 'web_promo_ofr_item', to: "/web/sdetails/" + seed.url_title + "/" + seed.deal_id },
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_seed_ofer_icon' },
							_react2.default.createElement('img', { style: { paddingTop: '5px' }, src: seed.img, alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_seed_ofer_cntnt' },
							seed.title ? _react2.default.createElement(
								'h5',
								{ className: 'web_promo_seed_title' },
								seed.title
							) : _react2.default.createElement(
								'h5',
								{ className: 'web_promo_seed_title' },
								'\xA0'
							),
							seed.desc ? _react2.default.createElement(
								'h6',
								{ className: 'web_promo_seed_desc' },
								seed.desc
							) : _react2.default.createElement(
								'h6',
								{ className: 'web_promo_seed_desc' },
								'\xA0'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_ofer_arrow' },
							_react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
						)
					);
				});
				var offers = this.state.offers.map(function (offer, index) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ className: 'web_promo_ofr_item', to: '/web/offer/' + offer.id + "/details" },
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_gen_ofer_icon' },
							_react2.default.createElement('img', { src: offer.img === '' ? baseAssets + 'icons/web_icons/offer-icon.png' : offer.img, alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_gen_ofer_cntnt' },
							offer.title ? _react2.default.createElement(
								'h5',
								{ className: 'web_gen_title' },
								offer.title
							) : _react2.default.createElement(
								'h5',
								{ className: 'web_gen_title' },
								'\xA0'
							),
							offer.desc ? _react2.default.createElement(
								'h6',
								{ className: 'web_gen_desc' },
								offer.desc
							) : _react2.default.createElement(
								'h6',
								{ className: 'web_gen_desc' },
								'\xA0'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_gen_ofer_arrow' },
							_react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
						)
					);
				});
	
				return _react2.default.createElement(
					'section',
					{ className: 'container web_promo_blks' },
					this.state.status === 'available' ? _react2.default.createElement(
						'div',
						{ className: '' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-lg-6 col-md-6 col-sm-6 text-left' },
								_react2.default.createElement(
									'h4',
									{ className: 'web_blk_titles' },
									this.state.offers.length > 0 ? 'AD Offers' : 'Promotions'
								),
								_react2.default.createElement(
									'a',
									{ className: 'web_promo_view_all', href: this.state.offers.length > 0 ? "/web/offerszone" : "/web/promotional_offers" },
									'View All'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-6 col-md-6 col-lg-6 pull-right' },
								_react2.default.createElement(
									'div',
									{ className: 'pro_sld_ctrls' },
									_react2.default.createElement(
										'a',
										{ className: 'left carousel-control pro_sld_lft', onClick: this.goPrev },
										_react2.default.createElement(
											'span',
											{ className: 'pro_sld_arow', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: baseAssets + 'images_web/left_arrow.png', alt: '' })
										),
										_react2.default.createElement(
											'span',
											{ className: 'sr-only' },
											'Previous'
										)
									),
									_react2.default.createElement(
										'a',
										{ className: 'right carousel-control pro_sld_rgt', onClick: this.goNext },
										_react2.default.createElement(
											'span',
											{ className: 'pro_sld_arow', 'aria-hidden': 'true' },
											_react2.default.createElement('img', { src: baseAssets + 'images_web/right_arrow.png', alt: '' })
										),
										_react2.default.createElement(
											'span',
											{ className: 'sr-only' },
											'Next'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'webpromotions_page1 web_promo_blk_items' },
							_react2.default.createElement(
								'div',
								{ style: { marginTop: '15px', marginBottom: '15px' } },
								_react2.default.createElement(
									_reactIdSwiper2.default,
									_extends({}, params, { key: product_offers.length + seed_offers.length + offers.length, ref: function ref(node) {
											return node ? _this2.swiper = node.swiper : '';
										} }),
									product_offers,
									seed_offers,
									offers
								)
							)
						)
					) : ''
				);
			}
		}]);
	
		return WebPromotions;
	}(_react.Component);
	
	exports.default = WebPromotions;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(569), __esModule: true };

/***/ },
/* 222 */
[995, 570],
/* 223 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(561);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(562);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(560);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(141);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(141);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(263);
	
	var callBind = __webpack_require__(142);
	
	var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
	
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		var intrinsic = GetIntrinsic(name, !!allowMissing);
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBind(intrinsic);
		}
		return intrinsic;
	};


/***/ },
/* 228 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(574);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(72);
	var document = __webpack_require__(52).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(51) && !__webpack_require__(70)(function () {
	  return Object.defineProperty(__webpack_require__(230)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(228);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(101);
	var $export = __webpack_require__(60);
	var redefine = __webpack_require__(239);
	var hide = __webpack_require__(71);
	var Iterators = __webpack_require__(145);
	var $iterCreate = __webpack_require__(580);
	var setToStringTag = __webpack_require__(148);
	var getPrototypeOf = __webpack_require__(236);
	var ITERATOR = __webpack_require__(74)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(102);
	var createDesc = __webpack_require__(103);
	var toIObject = __webpack_require__(73);
	var toPrimitive = __webpack_require__(152);
	var has = __webpack_require__(61);
	var IE8_DOM_DEFINE = __webpack_require__(231);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(51) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(237);
	var hiddenKeys = __webpack_require__(144).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(61);
	var toObject = __webpack_require__(87);
	var IE_PROTO = __webpack_require__(149)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(61);
	var toIObject = __webpack_require__(73);
	var arrayIndexOf = __webpack_require__(576)(false);
	var IE_PROTO = __webpack_require__(149)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(60);
	var core = __webpack_require__(37);
	var fails = __webpack_require__(70);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(71);


/***/ },
/* 240 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === "object") {
	    factory(exports);
	  } else {
	    factory(root.babelHelpers = {});
	  }
	})(this, function (global) {
	  var babelHelpers = global;
	
	  babelHelpers.interopRequireDefault = function (obj) {
	    return obj && obj.__esModule ? obj : {
	      "default": obj
	    };
	  };
	
	  babelHelpers._extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	})

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	
	'use strict';
	var camelize = __webpack_require__(616);
	var msPattern = /^-ms-/;
	
	module.exports = function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	};

/***/ },
/* 243 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 244 */
243,
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventListener
	 * @typechecks
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(42);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function () {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function () {}
	};
	
	module.exports = EventListener;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule containsNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isTextNode = __webpack_require__(641);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 *
	 * @param {?DOMNode} outerNode Outer DOM node.
	 * @param {?DOMNode} innerNode Inner DOM node.
	 * @return {boolean} True if `outerNode` contains or is `innerNode`.
	 */
	function containsNode(_x, _x2) {
	  var _again = true;
	
	  _function: while (_again) {
	    var outerNode = _x,
	        innerNode = _x2;
	    _again = false;
	
	    if (!outerNode || !innerNode) {
	      return false;
	    } else if (outerNode === innerNode) {
	      return true;
	    } else if (isTextNode(outerNode)) {
	      return false;
	    } else if (isTextNode(innerNode)) {
	      _x = outerNode;
	      _x2 = innerNode.parentNode;
	      _again = true;
	      continue _function;
	    } else if (outerNode.contains) {
	      return outerNode.contains(innerNode);
	    } else if (outerNode.compareDocumentPosition) {
	      return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	    } else {
	      return false;
	    }
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 247 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule focusNode
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 248 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getActiveElement
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	'use strict';
	
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getMarkupWrap
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : undefined;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 250 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bp_icn_pro.dae4db5a.png";

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/check_out_truck.221a433f.png";

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/checkmark.41c5ee1d.png";

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/coupon.bc1ed53f.png";

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cust_bg.c65cce8f.png";

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/quick_buy.407bc0e3.png";

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/rateus_icn.81a9a058.png";

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ref_earn_icn.0e4fe2f5.png";

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/view_similar1.aa3c021b.png";

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/view_similar2.55431ab4.png";

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/view_similar3_1.6c877f6f.png";

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/visible.056e71fb.png";

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var undefined;
	
	var $SyntaxError = SyntaxError;
	var $Function = Function;
	var $TypeError = TypeError;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(651)();
	
	var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': Object,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': RangeError,
		'%ReferenceError%': ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
	};
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(158);
	var hasOwn = __webpack_require__(652);
	var $concat = bind.call(Function.call, Array.prototype.concat);
	var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
	var $replace = bind.call(Function.call, String.prototype.replace);
	var $strSlice = bind.call(Function.call, String.prototype.slice);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ },
/* 264 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(112);
	
	var _DOMUtils = __webpack_require__(160);
	
	var _createHistory = __webpack_require__(268);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(76);
	
	var _PathUtils = __webpack_require__(63);
	
	var _ExecutionEnvironment = __webpack_require__(112);
	
	var _DOMUtils = __webpack_require__(160);
	
	var _DOMStateStorage = __webpack_require__(265);
	
	var _createDOMHistory = __webpack_require__(266);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(155);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(63);
	
	var _AsyncUtils = __webpack_require__(653);
	
	var _Actions = __webpack_require__(76);
	
	var _createLocation2 = __webpack_require__(655);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(162);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(161);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(112);
	
	var _PathUtils = __webpack_require__(63);
	
	var _runTransitionHook = __webpack_require__(162);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(161);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	var CASE_SENSITIVE_TAG_NAMES = __webpack_require__(658).CASE_SENSITIVE_TAG_NAMES;
	
	var caseSensitiveTagNamesMap = {};
	var tagName;
	for (var i = 0, len = CASE_SENSITIVE_TAG_NAMES.length; i < len; i++) {
	  tagName = CASE_SENSITIVE_TAG_NAMES[i];
	  caseSensitiveTagNamesMap[tagName.toLowerCase()] = tagName;
	}
	
	/**
	 * Gets case-sensitive tag name.
	 *
	 * @param  {String}           tagName - The lowercase tag name.
	 * @return {String|undefined}
	 */
	function getCaseSensitiveTagName(tagName) {
	  return caseSensitiveTagNamesMap[tagName];
	}
	
	/**
	 * Formats DOM attributes to a hash map.
	 *
	 * @param  {NamedNodeMap} attributes - The list of attributes.
	 * @return {Object}                  - A map of attribute name to value.
	 */
	function formatAttributes(attributes) {
	  var result = {};
	  var attribute;
	  // `NamedNodeMap` is array-like
	  for (var i = 0, len = attributes.length; i < len; i++) {
	    attribute = attributes[i];
	    result[attribute.name] = attribute.value;
	  }
	  return result;
	}
	
	/**
	 * Corrects the tag name if it is case-sensitive (SVG).
	 * Otherwise, returns the lowercase tag name (HTML).
	 *
	 * @param  {String} tagName - The lowercase tag name.
	 * @return {String}         - The formatted tag name.
	 */
	function formatTagName(tagName) {
	  tagName = tagName.toLowerCase();
	  var caseSensitiveTagName = getCaseSensitiveTagName(tagName);
	  if (caseSensitiveTagName) {
	    return caseSensitiveTagName;
	  }
	  return tagName;
	}
	
	/**
	 * Formats the browser DOM nodes to mimic the output of `htmlparser2.parseDOM()`.
	 *
	 * @param  {NodeList} nodes        - The DOM nodes.
	 * @param  {Object}   [parentObj]  - The formatted parent node.
	 * @param  {String}   [directive]  - The directive.
	 * @return {Object[]}              - The formatted DOM object.
	 */
	function formatDOM(nodes, parentObj, directive) {
	  parentObj = parentObj || null;
	
	  var result = [];
	  var node;
	  var prevNode;
	  var nodeObj;
	
	  // `NodeList` is array-like
	  for (var i = 0, len = nodes.length; i < len; i++) {
	    node = nodes[i];
	    // reset
	    nodeObj = {
	      next: null,
	      prev: result[i - 1] || null,
	      parent: parentObj
	    };
	
	    // set the next node for the previous node (if applicable)
	    prevNode = result[i - 1];
	    if (prevNode) {
	      prevNode.next = nodeObj;
	    }
	
	    // set the node name if it's not "#text" or "#comment"
	    // e.g., "div"
	    if (node.nodeName[0] !== '#') {
	      nodeObj.name = formatTagName(node.nodeName);
	      // also, nodes of type "tag" have "attribs"
	      nodeObj.attribs = {}; // default
	      if (node.attributes && node.attributes.length) {
	        nodeObj.attribs = formatAttributes(node.attributes);
	      }
	    }
	
	    // set the node type
	    // e.g., "tag"
	    switch (node.nodeType) {
	      // 1 = element
	      case 1:
	        if (nodeObj.name === 'script' || nodeObj.name === 'style') {
	          nodeObj.type = nodeObj.name;
	        } else {
	          nodeObj.type = 'tag';
	        }
	        // recursively format the children
	        nodeObj.children = formatDOM(node.childNodes, nodeObj);
	        break;
	      // 2 = attribute
	      // 3 = text
	      case 3:
	        nodeObj.type = 'text';
	        nodeObj.data = node.nodeValue;
	        break;
	      // 8 = comment
	      case 8:
	        nodeObj.type = 'comment';
	        nodeObj.data = node.nodeValue;
	        break;
	    }
	
	    result.push(nodeObj);
	  }
	
	  if (directive) {
	    result.unshift({
	      name: directive.substring(0, directive.indexOf(' ')).toLowerCase(),
	      data: directive,
	      type: 'directive',
	      next: result[0] ? result[0] : null,
	      prev: null,
	      parent: parentObj
	    });
	
	    if (result[1]) {
	      result[1].prev = result[0];
	    }
	  }
	
	  return result;
	}
	
	/**
	 * Detects IE with or without version.
	 *
	 * @param  {Number}  [version] - The IE version to detect.
	 * @return {Boolean}           - Whether IE or the version has been detected.
	 */
	function isIE(version) {
	  if (version) {
	    return document.documentMode === version;
	  }
	  return /(MSIE |Trident\/|Edge\/)/.test(navigator.userAgent);
	}
	
	module.exports = {
	  formatAttributes: formatAttributes,
	  formatDOM: formatDOM,
	  isIE: isIE
	};


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var hyphenPatternRegex = /-([a-z])/g;
	var CUSTOM_PROPERTY_OR_NO_HYPHEN_REGEX = /^--[a-zA-Z0-9-]+$|^[^-]+$/;
	
	/**
	 * Converts a string to camelCase.
	 *
	 * @param  {String} string - The string.
	 * @return {String}
	 */
	function camelCase(string) {
	  if (typeof string !== 'string') {
	    throw new TypeError('First argument must be a string');
	  }
	
	  // custom property or no hyphen found
	  if (CUSTOM_PROPERTY_OR_NO_HYPHEN_REGEX.test(string)) {
	    return string;
	  }
	
	  // convert to camelCase
	  return string
	    .toLowerCase()
	    .replace(hyphenPatternRegex, function(_, character) {
	      return character.toUpperCase();
	    });
	}
	
	/**
	 * Swap key with value in an object.
	 *
	 * @param  {Object}   obj        - The object.
	 * @param  {Function} [override] - The override method.
	 * @return {Object}              - The inverted object.
	 */
	function invertObject(obj, override) {
	  if (!obj || typeof obj !== 'object') {
	    throw new TypeError('First argument must be an object');
	  }
	
	  var key;
	  var value;
	  var isOverridePresent = typeof override === 'function';
	  var overrides = {};
	  var result = {};
	
	  for (key in obj) {
	    value = obj[key];
	
	    if (isOverridePresent) {
	      overrides = override(key, value);
	      if (overrides && overrides.length === 2) {
	        result[overrides[0]] = overrides[1];
	        continue;
	      }
	    }
	
	    if (typeof value === 'string') {
	      result[value] = key;
	    }
	  }
	
	  return result;
	}
	
	/**
	 * Check if a given tag is a custom component.
	 *
	 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
	 *
	 * @param {string} tagName - The name of the html tag.
	 * @param {Object} props   - The props being passed to the element.
	 * @return {boolean}
	 */
	function isCustomComponent(tagName, props) {
	  if (tagName.indexOf('-') === -1) {
	    return props && typeof props.is === 'string';
	  }
	
	  switch (tagName) {
	    // These are reserved SVG and MathML elements.
	    // We don't mind this whitelist too much because we expect it to never grow.
	    // The alternative is to track the namespace in a few places which is convoluted.
	    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
	    case 'annotation-xml':
	    case 'color-profile':
	    case 'font-face':
	    case 'font-face-src':
	    case 'font-face-uri':
	    case 'font-face-format':
	    case 'font-face-name':
	    case 'missing-glyph':
	      return false;
	    default:
	      return true;
	  }
	}
	
	/**
	 * @constant {Boolean}
	 * @see {@link https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html}
	 */
	var PRESERVE_CUSTOM_ATTRIBUTES = React.version.split('.')[0] >= 16;
	
	module.exports = {
	  PRESERVE_CUSTOM_ATTRIBUTES: PRESERVE_CUSTOM_ATTRIBUTES,
	  camelCase: camelCase,
	  invertObject: invertObject,
	  isCustomComponent: isCustomComponent
	};


/***/ },
/* 272 */
/***/ function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(673),
	    isArguments = __webpack_require__(167),
	    isArray = __webpack_require__(54),
	    isArrayLike = __webpack_require__(166),
	    isObjectLike = __webpack_require__(64);
	
	/**
	 * The base implementation of `_.flatten` with added support for restricting
	 * flattening and specifying the start index.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {boolean} [isDeep] Specify a deep flatten.
	 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, isDeep, isStrict, result) {
	  result || (result = []);
	
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    if (isObjectLike(value) && isArrayLike(value) &&
	        (isStrict || isArray(value) || isArguments(value))) {
	      if (isDeep) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, isDeep, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(693);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(43);
	
	/**
	 * The base implementation of `get` without support for string paths
	 * and default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path of the property to get.
	 * @param {string} [pathKey] The key representation of path.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path, pathKey) {
	  if (object == null) {
	    return;
	  }
	  object = toObject(object);
	  if (pathKey !== undefined && pathKey in object) {
	    path = [pathKey];
	  }
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = toObject(object)[path[index++]];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(683),
	    isObject = __webpack_require__(55),
	    isObjectLike = __webpack_require__(64);
	
	/**
	 * The base implementation of `_.isEqual` without support for `this` binding
	 * `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(43);
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : toObject(object)[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(277);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 279 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	var isHostObject = (function() {
	  try {
	    Object({ 'toString': 0 } + '');
	  } catch(e) {
	    return function() { return false; };
	  }
	  return function(value) {
	    // IE < 9 presents many host objects as `Object` objects that can coerce
	    // to strings despite having improperly defined `toString` methods.
	    return typeof value.toString != 'function' && typeof (value + '') == 'string';
	  };
	}());
	
	module.exports = isHostObject;


/***/ },
/* 280 */
/***/ function(module, exports) {

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(54),
	    toObject = __webpack_require__(43);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  var type = typeof value;
	  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	    return true;
	  }
	  if (isArray(value)) {
	    return false;
	  }
	  var result = !reIsDeepProp.test(value);
	  return result || (object != null && value in toObject(object));
	}
	
	module.exports = isKey;


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(55);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(43);
	
	/**
	 * A specialized version of `_.pick` which picks `object` properties specified
	 * by `props`.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property names to pick.
	 * @returns {Object} Returns the new object.
	 */
	function pickByArray(object, props) {
	  object = toObject(object);
	
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index];
	    if (key in object) {
	      result[key] = object[key];
	    }
	  }
	  return result;
	}
	
	module.exports = pickByArray;


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var baseForIn = __webpack_require__(680);
	
	/**
	 * A specialized version of `_.pick` which picks `object` properties `predicate`
	 * returns truthy for.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Object} Returns the new object.
	 */
	function pickByCallback(object, predicate) {
	  var result = {};
	  baseForIn(object, function(value, key, object) {
	    if (predicate(value, key, object)) {
	      result[key] = value;
	    }
	  });
	  return result;
	}
	
	module.exports = pickByCallback;


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(689),
	    isArray = __webpack_require__(54);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `value` to property path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Array} Returns the property path array.
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return value;
	  }
	  var result = [];
	  baseToString(value).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	}
	
	module.exports = toPath;


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(55);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 which returns 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 287 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 288 */
/***/ function(module, exports) {

	'use strict';
	
	var numberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		}
		if (a === b) {
			return true;
		}
		if (numberIsNaN(a) && numberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(288);
	
	module.exports = function getPolyfill() {
		return typeof Object.is === 'function' ? Object.is : implementation;
	};


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(291);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(711);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 291 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(401);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(717);
	exports.encode = exports.stringify = __webpack_require__(718);


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SafeAnchor = __webpack_require__(47);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var BreadcrumbItem = _react2['default'].createClass({
	  displayName: 'BreadcrumbItem',
	
	  propTypes: {
	    /**
	     * If set to true, renders `span` instead of `a`
	     */
	    active: _react2['default'].PropTypes.bool,
	    /**
	     * HTML id for the wrapper `li` element
	     */
	    id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	    /**
	     * HTML id for the inner `a` element
	     */
	    linkId: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	    /**
	     * `href` attribute for the inner `a` element
	     */
	    href: _react2['default'].PropTypes.string,
	    /**
	     * `title` attribute for the inner `a` element
	     */
	    title: _react2['default'].PropTypes.node,
	    /**
	     * `target` attribute for the inner `a` element
	     */
	    target: _react2['default'].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      active: false
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var active = _props.active;
	    var className = _props.className;
	    var id = _props.id;
	    var linkId = _props.linkId;
	    var children = _props.children;
	    var href = _props.href;
	    var title = _props.title;
	    var target = _props.target;
	
	    var props = _objectWithoutProperties(_props, ['active', 'className', 'id', 'linkId', 'children', 'href', 'title', 'target']);
	
	    var linkProps = {
	      href: href,
	      title: title,
	      target: target,
	      id: linkId
	    };
	
	    return _react2['default'].createElement(
	      'li',
	      { id: id, className: _classnames2['default'](className, { active: active }) },
	      active ? _react2['default'].createElement(
	        'span',
	        props,
	        children
	      ) : _react2['default'].createElement(
	        _SafeAnchor2['default'],
	        _extends({}, props, linkProps),
	        children
	      )
	    );
	  }
	});
	
	exports['default'] = BreadcrumbItem;
	module.exports = exports['default'];

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibAll = __webpack_require__(120);
	
	var _reactPropTypesLibAll2 = _interopRequireDefault(_reactPropTypesLibAll);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _Button = __webpack_require__(65);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var ButtonGroup = _react2['default'].createClass({
	  displayName: 'ButtonGroup',
	
	  propTypes: {
	    vertical: _react2['default'].PropTypes.bool,
	    justified: _react2['default'].PropTypes.bool,
	    /**
	     * Display block buttons, only useful when used with the "vertical" prop.
	     * @type {bool}
	     */
	    block: _reactPropTypesLibAll2['default'](_react2['default'].PropTypes.bool, function (props) {
	      if (props.block && !props.vertical) {
	        return new Error('The block property requires the vertical property to be set to have any effect');
	      }
	    })
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      block: false,
	      justified: false,
	      vertical: false
	    };
	  },
	
	  render: function render() {
	    var classes = _utilsBootstrapUtils.getClassSet(this.props);
	
	    classes[_utilsBootstrapUtils.prefix(this.props)] = !this.props.vertical;
	    classes[_utilsBootstrapUtils.prefix(this.props, 'vertical')] = this.props.vertical;
	    classes[_utilsBootstrapUtils.prefix(this.props, 'justified')] = this.props.justified;
	
	    // this is annoying, since the class is `btn-block` not `btn-group-block`
	    classes[_utilsBootstrapUtils.prefix(_Button2['default'].defaultProps, 'block')] = this.props.block;
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, classes)
	      }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsClass('btn-group', ButtonGroup);
	module.exports = exports['default'];

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _utilsTransitionEvents = __webpack_require__(782);
	
	var _utilsTransitionEvents2 = _interopRequireDefault(_utilsTransitionEvents);
	
	var CarouselItem = _react2['default'].createClass({
	  displayName: 'CarouselItem',
	
	  propTypes: {
	    direction: _react2['default'].PropTypes.oneOf(['prev', 'next']),
	    onAnimateOutEnd: _react2['default'].PropTypes.func,
	    active: _react2['default'].PropTypes.bool,
	    animateIn: _react2['default'].PropTypes.bool,
	    animateOut: _react2['default'].PropTypes.bool,
	    caption: _react2['default'].PropTypes.node,
	    index: _react2['default'].PropTypes.number
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      direction: null
	    };
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsStyle: 'carousel',
	      active: false,
	      animateIn: false,
	      animateOut: false
	    };
	  },
	
	  handleAnimateOutEnd: function handleAnimateOutEnd() {
	    if (this.props.onAnimateOutEnd && this.isMounted()) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({
	        direction: null
	      });
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (!this.props.active && prevProps.active) {
	      _utilsTransitionEvents2['default'].addEndEventListener(_reactDom2['default'].findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (this.props.active !== prevProps.active) {
	      setTimeout(this.startAnimation, 20);
	    }
	  },
	
	  startAnimation: function startAnimation() {
	    if (!this.isMounted()) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  },
	
	  render: function render() {
	    var classes = {
	      item: true,
	      active: this.props.active && !this.props.animateIn || this.props.animateOut,
	      next: this.props.active && this.props.animateIn && this.props.direction === 'next',
	      prev: this.props.active && this.props.animateIn && this.props.direction === 'prev'
	    };
	
	    if (this.state.direction && (this.props.animateIn || this.props.animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children,
	      this.props.caption ? this.renderCaption() : null
	    );
	  },
	
	  renderCaption: function renderCaption() {
	    var classes = _utilsBootstrapUtils.prefix(this.props, 'caption');
	
	    return _react2['default'].createElement(
	      'div',
	      { className: classes },
	      this.props.caption
	    );
	  }
	});
	
	exports['default'] = CarouselItem;
	module.exports = exports['default'];

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _Object$keys = __webpack_require__(56)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styleMaps = __webpack_require__(27);
	
	var _styleMaps2 = _interopRequireDefault(_styleMaps);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var Col = _react2['default'].createClass({
	  displayName: 'Col',
	
	  propTypes: {
	    /**
	     * The number of columns you wish to span
	     *
	     * for Extra small devices Phones (<768px)
	     *
	     * class-prefix `col-xs-`
	     */
	    xs: _react2['default'].PropTypes.number,
	    /**
	     * The number of columns you wish to span
	     *
	     * for Small devices Tablets (≥768px)
	     *
	     * class-prefix `col-sm-`
	     */
	    sm: _react2['default'].PropTypes.number,
	    /**
	     * The number of columns you wish to span
	     *
	     * for Medium devices Desktops (≥992px)
	     *
	     * class-prefix `col-md-`
	     */
	    md: _react2['default'].PropTypes.number,
	    /**
	     * The number of columns you wish to span
	     *
	     * for Large devices Desktops (≥1200px)
	     *
	     * class-prefix `col-lg-`
	     */
	    lg: _react2['default'].PropTypes.number,
	    /**
	     * Hide column
	     *
	     * on Extra small devices Phones
	     *
	     * adds class `hidden-xs`
	     */
	    xsHidden: _react2['default'].PropTypes.bool,
	    /**
	     * Hide column
	     *
	     * on Small devices Tablets
	     *
	     * adds class `hidden-sm`
	     */
	    smHidden: _react2['default'].PropTypes.bool,
	    /**
	     * Hide column
	     *
	     * on Medium devices Desktops
	     *
	     * adds class `hidden-md`
	     */
	    mdHidden: _react2['default'].PropTypes.bool,
	    /**
	     * Hide column
	     *
	     * on Large devices Desktops
	     *
	     * adds class `hidden-lg`
	     */
	    lgHidden: _react2['default'].PropTypes.bool,
	    /**
	     * Move columns to the right
	     *
	     * for Extra small devices Phones
	     *
	     * class-prefix `col-xs-offset-`
	     */
	    xsOffset: _react2['default'].PropTypes.number,
	    /**
	     * Move columns to the right
	     *
	     * for Small devices Tablets
	     *
	     * class-prefix `col-sm-offset-`
	     */
	    smOffset: _react2['default'].PropTypes.number,
	    /**
	     * Move columns to the right
	     *
	     * for Medium devices Desktops
	     *
	     * class-prefix `col-md-offset-`
	     */
	    mdOffset: _react2['default'].PropTypes.number,
	    /**
	     * Move columns to the right
	     *
	     * for Large devices Desktops
	     *
	     * class-prefix `col-lg-offset-`
	     */
	    lgOffset: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the right
	     *
	     * for Extra small devices Phones
	     *
	     * class-prefix `col-xs-push-`
	     */
	    xsPush: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the right
	     *
	     * for Small devices Tablets
	     *
	     * class-prefix `col-sm-push-`
	     */
	    smPush: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the right
	     *
	     * for Medium devices Desktops
	     *
	     * class-prefix `col-md-push-`
	     */
	    mdPush: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the right
	     *
	     * for Large devices Desktops
	     *
	     * class-prefix `col-lg-push-`
	     */
	    lgPush: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the left
	     *
	     * for Extra small devices Phones
	     *
	     * class-prefix `col-xs-pull-`
	     */
	    xsPull: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the left
	     *
	     * for Small devices Tablets
	     *
	     * class-prefix `col-sm-pull-`
	     */
	    smPull: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the left
	     *
	     * for Medium devices Desktops
	     *
	     * class-prefix `col-md-pull-`
	     */
	    mdPull: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the left
	     *
	     * for Large devices Desktops
	     *
	     * class-prefix `col-lg-pull-`
	     */
	    lgPull: _react2['default'].PropTypes.number,
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div'
	    };
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var ComponentClass = this.props.componentClass;
	    var classes = {};
	
	    _Object$keys(_styleMaps2['default'].SIZES).forEach(function (key) {
	      var size = _styleMaps2['default'].SIZES[key];
	      var prop = size;
	      var classPart = size + '-';
	
	      if (_this.props[prop]) {
	        classes['col-' + classPart + _this.props[prop]] = true;
	      }
	
	      classes['hidden-' + size] = _this.props[size + 'Hidden'];
	
	      prop = size + 'Offset';
	      classPart = size + '-offset-';
	      if (_this.props[prop] >= 0) {
	        classes['col-' + classPart + _this.props[prop]] = true;
	      }
	
	      prop = size + 'Push';
	      classPart = size + '-push-';
	      if (_this.props[prop] >= 0) {
	        classes['col-' + classPart + _this.props[prop]] = true;
	      }
	
	      prop = size + 'Pull';
	      classPart = size + '-pull-';
	      if (_this.props[prop] >= 0) {
	        classes['col-' + classPart + _this.props[prop]] = true;
	      }
	    }, this);
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Col;
	module.exports = exports['default'];

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(65);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__(47);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var CARET = _react2['default'].createElement(
	  'span',
	  null,
	  ' ',
	  _react2['default'].createElement('span', { className: 'caret' })
	);
	
	var DropdownToggle = (function (_React$Component) {
	  _inherits(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    _classCallCheck(this, DropdownToggle);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  DropdownToggle.prototype.render = function render() {
	    var caret = this.props.noCaret ? null : CARET;
	
	    var classes = {
	      'dropdown-toggle': true
	    };
	
	    var Component = this.props.useAnchor ? _SafeAnchor2['default'] : _Button2['default'];
	
	    return _react2['default'].createElement(
	      Component,
	      _extends({}, this.props, {
	        className: _classnames2['default'](classes, this.props.className),
	        role: 'button',
	        'aria-haspopup': true,
	        'aria-expanded': this.props.open }),
	      this.props.children || this.props.title,
	      caret
	    );
	  };
	
	  return DropdownToggle;
	})(_react2['default'].Component);
	
	exports['default'] = DropdownToggle;
	
	DropdownToggle.defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	DropdownToggle.propTypes = {
	  bsRole: _react2['default'].PropTypes.string,
	  noCaret: _react2['default'].PropTypes.bool,
	  open: _react2['default'].PropTypes.bool,
	  title: _react2['default'].PropTypes.string,
	  useAnchor: _react2['default'].PropTypes.bool
	};
	
	DropdownToggle.isToggle = true;
	DropdownToggle.titleProp = 'title';
	DropdownToggle.onClickProp = 'onClick';
	module.exports = exports['default'];

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _Static2 = __webpack_require__(736);
	
	var _Static3 = _interopRequireDefault(_Static2);
	
	exports.Static = _Static3['default'];

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var Grid = _react2['default'].createClass({
	  displayName: 'Grid',
	
	  propTypes: {
	    /**
	     * Turn any fixed-width grid layout into a full-width layout by this property.
	     *
	     * Adds `container-fluid` class.
	     */
	    fluid: _react2['default'].PropTypes.bool,
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div',
	      fluid: false
	    };
	  },
	
	  render: function render() {
	    var ComponentClass = this.props.componentClass;
	    var className = this.props.fluid ? 'container-fluid' : 'container';
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, className) }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Grid;
	module.exports = exports['default'];

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	// https://www.npmjs.org/package/react-interpolate-component
	// TODO: Drop this in favor of es6 string interpolation
	
	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _Object$assign = __webpack_require__(92)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsValidComponentChildren = __webpack_require__(28);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var REGEXP = /\%\((.+?)\)s/;
	
	var Interpolate = _react2['default'].createClass({
	  displayName: 'Interpolate',
	
	  propTypes: {
	    component: _react2['default'].PropTypes.node,
	    format: _react2['default'].PropTypes.string,
	    unsafe: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      component: 'span',
	      unsafe: false
	    };
	  },
	
	  render: function render() {
	    var format = _utilsValidComponentChildren2['default'].count(this.props.children) > 0 || typeof this.props.children === 'string' ? this.props.children : this.props.format;
	    var parent = this.props.component;
	    var unsafe = this.props.unsafe === true;
	    var props = _extends({}, this.props);
	
	    delete props.children;
	    delete props.format;
	    delete props.component;
	    delete props.unsafe;
	
	    if (unsafe) {
	      var content = format.split(REGEXP).reduce(function (memo, match, index) {
	        var html = undefined;
	
	        if (index % 2 === 0) {
	          html = match;
	        } else {
	          html = props[match];
	          delete props[match];
	        }
	
	        if (_react2['default'].isValidElement(html)) {
	          throw new Error('cannot interpolate a React component into unsafe text');
	        }
	
	        memo += html;
	
	        return memo;
	      }, '');
	
	      props.dangerouslySetInnerHTML = { __html: content };
	
	      return _react2['default'].createElement(parent, props);
	    }
	    var kids = format.split(REGEXP).reduce(function (memo, match, index) {
	      var child = undefined;
	
	      if (index % 2 === 0) {
	        if (match.length === 0) {
	          return memo;
	        }
	
	        child = match;
	      } else {
	        child = props[match];
	        delete props[match];
	      }
	
	      memo.push(child);
	
	      return memo;
	    }, []);
	
	    return _react2['default'].createElement(parent, props, kids);
	  }
	});
	
	_Object$assign(Interpolate, { REGEXP: REGEXP });
	
	exports['default'] = Interpolate;
	module.exports = exports['default'];

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styleMaps = __webpack_require__(27);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var ListGroupItem = (function (_React$Component) {
	  _inherits(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    _classCallCheck(this, ListGroupItem);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ListGroupItem.prototype.render = function render() {
	    var classes = _utilsBootstrapUtils.getClassSet(this.props);
	
	    classes.active = this.props.active;
	    classes.disabled = this.props.disabled;
	
	    if (this.props.href) {
	      return this.renderAnchor(classes);
	    } else if (this.props.onClick) {
	      return this.renderButton(classes);
	    } else if (this.props.listItem) {
	      return this.renderLi(classes);
	    }
	
	    return this.renderSpan(classes);
	  };
	
	  ListGroupItem.prototype.renderLi = function renderLi(classes) {
	    return _react2['default'].createElement(
	      'li',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.header ? this.renderStructuredContent() : this.props.children
	    );
	  };
	
	  ListGroupItem.prototype.renderAnchor = function renderAnchor(classes) {
	    return _react2['default'].createElement(
	      'a',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, classes)
	      }),
	      this.props.header ? this.renderStructuredContent() : this.props.children
	    );
	  };
	
	  ListGroupItem.prototype.renderButton = function renderButton(classes) {
	    return _react2['default'].createElement(
	      'button',
	      _extends({
	        type: 'button'
	      }, this.props, {
	        className: _classnames2['default'](this.props.className, classes) }),
	      this.props.header ? this.renderStructuredContent() : this.props.children
	    );
	  };
	
	  ListGroupItem.prototype.renderSpan = function renderSpan(classes) {
	    return _react2['default'].createElement(
	      'span',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.header ? this.renderStructuredContent() : this.props.children
	    );
	  };
	
	  ListGroupItem.prototype.renderStructuredContent = function renderStructuredContent() {
	    var header = undefined;
	    var headingClass = _utilsBootstrapUtils.prefix(this.props, 'heading');
	
	    if (_react2['default'].isValidElement(this.props.header)) {
	      header = _react.cloneElement(this.props.header, {
	        key: 'header',
	        className: _classnames2['default'](this.props.header.props.className, headingClass)
	      });
	    } else {
	      header = _react2['default'].createElement(
	        'h4',
	        { key: 'header', className: headingClass },
	        this.props.header
	      );
	    }
	
	    var content = _react2['default'].createElement(
	      'p',
	      { key: 'content', className: _utilsBootstrapUtils.prefix(this.props, 'text') },
	      this.props.children
	    );
	
	    return [header, content];
	  };
	
	  return ListGroupItem;
	})(_react2['default'].Component);
	
	ListGroupItem.propTypes = {
	  className: _react2['default'].PropTypes.string,
	  active: _react2['default'].PropTypes.any,
	  disabled: _react2['default'].PropTypes.any,
	  header: _react2['default'].PropTypes.node,
	  listItem: _react2['default'].PropTypes.bool,
	  onClick: _react2['default'].PropTypes.func,
	  eventKey: _react2['default'].PropTypes.any,
	  href: _react2['default'].PropTypes.string,
	  target: _react2['default'].PropTypes.string
	};
	
	ListGroupItem.defaultTypes = {
	  listItem: false
	};
	
	exports['default'] = _utilsBootstrapUtils.bsStyles(_styleMaps.State.values(), _utilsBootstrapUtils.bsClass('list-group-item', ListGroupItem));
	module.exports = exports['default'];

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var ModalBody = (function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody() {
	    _classCallCheck(this, ModalBody);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ModalBody.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils.prefix(this.props, 'body'))
	      }),
	      this.props.children
	    );
	  };
	
	  return ModalBody;
	})(_react2['default'].Component);
	
	exports['default'] = _utilsBootstrapUtils.bsClass('modal', ModalBody);
	module.exports = exports['default'];

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var ModalFooter = (function (_React$Component) {
	  _inherits(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    _classCallCheck(this, ModalFooter);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ModalFooter.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils.prefix(this.props, 'footer'))
	      }),
	      this.props.children
	    );
	  };
	
	  return ModalFooter;
	})(_react2['default'].Component);
	
	ModalFooter.propTypes = {
	  /**
	   * A css class applied to the Component
	   */
	  bsClass: _react2['default'].PropTypes.string
	};
	
	ModalFooter.defaultProps = {
	  bsClass: 'modal'
	};
	
	exports['default'] = _utilsBootstrapUtils.bsClass('modal', ModalFooter);
	module.exports = exports['default'];

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _utilsCreateChainedFunction = __webpack_require__(32);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var ModalHeader = (function (_React$Component) {
	  _inherits(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    _classCallCheck(this, ModalHeader);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props;
	    var label = _props['aria-label'];
	
	    var props = _objectWithoutProperties(_props, ['aria-label']);
	
	    var onHide = _utilsCreateChainedFunction2['default'](this.context.$bs_onModalHide, this.props.onHide);
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils.prefix(this.props, 'header'))
	      }),
	      this.props.closeButton && _react2['default'].createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'close',
	          'aria-label': label,
	          onClick: onHide },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          '×'
	        )
	      ),
	      this.props.children
	    );
	  };
	
	  return ModalHeader;
	})(_react2['default'].Component);
	
	ModalHeader.propTypes = {
	  /**
	   * The 'aria-label' attribute provides an accessible label for the close button.
	   * It is used for Assistive Technology when the label text is not readable.
	   */
	  'aria-label': _react2['default'].PropTypes.string,
	
	  bsClass: _react2['default'].PropTypes.string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _react2['default'].PropTypes.bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside a Modal component, the onHide will automatically
	   * be propagated up to the parent Modal `onHide`.
	   */
	  onHide: _react2['default'].PropTypes.func
	};
	
	ModalHeader.contextTypes = {
	  '$bs_onModalHide': _react2['default'].PropTypes.func
	};
	
	ModalHeader.defaultProps = {
	  'aria-label': 'Close',
	  closeButton: false
	};
	
	exports['default'] = _utilsBootstrapUtils.bsClass('modal', ModalHeader);
	module.exports = exports['default'];

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var ModalTitle = (function (_React$Component) {
	  _inherits(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    _classCallCheck(this, ModalTitle);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ModalTitle.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'h4',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils.prefix(this.props, 'title'))
	      }),
	      this.props.children
	    );
	  };
	
	  return ModalTitle;
	})(_react2['default'].Component);
	
	exports['default'] = _utilsBootstrapUtils.bsClass('modal', ModalTitle);
	module.exports = exports['default'];

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(164);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactPropTypesLibAll = __webpack_require__(120);
	
	var _reactPropTypesLibAll2 = _interopRequireDefault(_reactPropTypesLibAll);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _utilsCreateChainedFunction = __webpack_require__(32);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var _utilsTabUtils = __webpack_require__(313);
	
	var _utilsValidComponentChildren = __webpack_require__(28);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var Nav = (function (_React$Component) {
	  _inherits(Nav, _React$Component);
	
	  function Nav() {
	    _classCallCheck(this, Nav);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this._needsRefocus) {
	      var ul = this.refs.ul && _reactDom2['default'].findDOMNode(this.refs.ul);
	      var tabs = ul ? ul.children || [] : [];
	      var tabIdx = this.eventKeys().indexOf(this.getActiveKey());
	
	      this._needsRefocus = false;
	
	      if (tabIdx !== -1) {
	        var tabNode = tabs[tabIdx];
	
	        if (tabNode && tabNode.firstChild) {
	          tabNode.firstChild.focus();
	        }
	      }
	    }
	  };
	
	  Nav.prototype.render = function render() {
	    var className = this.props.className;
	
	    var isNavbar = this.props.navbar != null ? this.props.navbar : this.context.$bs_navbar;
	
	    var classes = _utilsBootstrapUtils.getClassSet(this.props);
	
	    classes[_utilsBootstrapUtils.prefix(this.props, 'stacked')] = this.props.stacked;
	    classes[_utilsBootstrapUtils.prefix(this.props, 'justified')] = this.props.justified;
	
	    if (isNavbar) {
	      var bsClass = this.context.$bs_navbar_bsClass || 'navbar';
	
	      classes[_utilsBootstrapUtils.prefix({ bsClass: bsClass }, 'nav')] = true;
	      classes[_utilsBootstrapUtils.prefix({ bsClass: bsClass }, 'right')] = this.props.pullRight;
	      classes[_utilsBootstrapUtils.prefix({ bsClass: bsClass }, 'left')] = this.props.pullLeft;
	    } else {
	      classes['pull-right'] = this.props.pullRight;
	      classes['pull-left'] = this.props.pullLeft;
	    }
	
	    var list = _react2['default'].createElement(
	      'ul',
	      _extends({ ref: 'ul'
	      }, this.props, {
	        role: this.getNavRole(),
	        className: _classnames2['default'](className, classes)
	      }),
	      _utilsValidComponentChildren2['default'].map(this.props.children, this.renderNavItem, this)
	    );
	
	    return list;
	  };
	
	  Nav.prototype.renderNavItem = function renderNavItem(child, index) {
	    var onSelect = _utilsCreateChainedFunction2['default'](child.props.onSelect, this.props.onSelect);
	    var active = this.isChildActive(child);
	    var tabProps = this.getTabProps(child, active, onSelect);
	
	    return _react.cloneElement(child, _extends({
	      active: active,
	      activeKey: this.props.activeKey,
	      activeHref: this.props.activeHref,
	      onSelect: onSelect,
	      key: child.key || index,
	      navItem: true
	    }, tabProps));
	  };
	
	  Nav.prototype.getActiveKey = function getActiveKey() {
	    var context = this.context.$bs_tabcontainer;
	    if (!context) {
	      return this.props.activeKey;
	    }
	
	     false ? _warning2['default'](!(this.props.activeKey != null || this.props.activeHref), 'Specifing a Nav `activeKey` or `activeHref` prop in the context of a `TabContainer` is not supported. ' + 'Instead use `<TabContainer activeKey={' + this.props.activeKey + '} />`') : undefined;
	
	    return context.activeKey;
	  };
	
	  Nav.prototype.isChildActive = function isChildActive(child) {
	    var activeKey = this.getActiveKey();
	
	    if (this.context.$bs_tabcontainer) {
	       false ? _warning2['default'](!child.props.active, 'Specifying a NavItem `active` prop in the context of a `TabContainer` is not supported. Instead ' + 'use `<TabContainer activeKey={' + child.props.eventKey + '} />`') : undefined;
	
	      return child.props.eventKey === activeKey;
	    }
	
	    if (child.props.active) {
	      return true;
	    }
	    if (this.props.activeKey != null) {
	      if (child.props.eventKey === this.props.activeKey) {
	        return true;
	      }
	    }
	    if (this.props.activeHref != null) {
	      if (child.props.href === this.props.activeHref) {
	        return true;
	      }
	    }
	
	    return child.props.active;
	  };
	
	  Nav.prototype.getTabProps = function getTabProps(child, isActive, onSelect) {
	    var navRole = this.getNavRole();
	    var context = this.context.$bs_tabcontainer;
	
	    if (!context && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props;
	    var id = _child$props.id;
	    var controls = _child$props['aria-controls'];
	    var eventKey = _child$props.eventKey;
	    var role = _child$props.role;
	    var onKeyDown = _child$props.onKeyDown;
	    var _child$props$tabIndex = _child$props.tabIndex;
	    var tabIndex = _child$props$tabIndex === undefined ? 0 : _child$props$tabIndex;
	
	    if (context && context.getId) {
	       false ? _warning2['default'](!(id || controls), 'In the context of a TabContainer, NavItems are given generated `id` and `aria-controls` ' + 'attributes for the sake of proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` prop to the parent TabContainer.') : undefined;
	
	      id = context.getId(eventKey, _utilsTabUtils.TAB) || null;
	      controls = context.getId(eventKey, _utilsTabUtils.PANE) || null;
	      onSelect = _utilsCreateChainedFunction2['default'](onSelect, context.onSelect);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = _utilsCreateChainedFunction2['default'](this.handleTabKeyDown.bind(this, onSelect || function () {}), onKeyDown);
	      tabIndex = isActive ? tabIndex : -1;
	    }
	
	    return {
	      onSelect: onSelect,
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var keys = this.eventKeys();
	    var currentKey = this.getActiveKey() || keys[0];
	    var next = undefined;
	
	    switch (event.keyCode) {
	
	      case _keycode2['default'].codes.left:
	      case _keycode2['default'].codes.up:
	        next = _utilsTabUtils.nextEnabled(this.props.children, currentKey, keys, false);
	
	        if (next && next !== currentKey) {
	          event.preventDefault();
	          onSelect(next);
	          this._needsRefocus = true;
	        }
	        break;
	      case _keycode2['default'].codes.right:
	      case _keycode2['default'].codes.down:
	        next = _utilsTabUtils.nextEnabled(this.props.children, currentKey, keys, true);
	
	        if (next && next !== currentKey) {
	          event.preventDefault();
	          onSelect(next);
	          this._needsRefocus = true;
	        }
	        break;
	      default:
	    }
	  };
	
	  Nav.prototype.eventKeys = function eventKeys() {
	    var keys = [];
	    _utilsValidComponentChildren2['default'].forEach(this.props.children, function (_ref) {
	      var eventKey = _ref.props.eventKey;
	      return keys.push(eventKey);
	    });
	    return keys;
	  };
	
	  Nav.prototype.getNavRole = function getNavRole() {
	    return this.props.role || (this.context.$bs_tabcontainer ? 'tablist' : null);
	  };
	
	  return Nav;
	})(_react2['default'].Component);
	
	Nav.propTypes = {
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _react2['default'].PropTypes.string,
	
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _react2['default'].PropTypes.any,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _react2['default'].PropTypes.bool,
	
	  justified: _reactPropTypesLibAll2['default'](_react2['default'].PropTypes.bool, function (_ref2) {
	    var justified = _ref2.justified;
	    var navbar = _ref2.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * CSS classes for the wrapper `nav` element
	   */
	  className: _react2['default'].PropTypes.string,
	  /**
	   * HTML id for the wrapper `nav` element
	   */
	  id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will be set
	   * to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to the
	   * ARIA authoring practices for tabs: https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _react2['default'].PropTypes.string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _react2['default'].PropTypes.bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _react2['default'].PropTypes.bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _react2['default'].PropTypes.bool
	};
	
	Nav.contextTypes = {
	  $bs_navbar: _react2['default'].PropTypes.bool,
	  $bs_navbar_bsClass: _react2['default'].PropTypes.string,
	
	  $bs_tabcontainer: _react2['default'].PropTypes.shape({
	    activeKey: _react2['default'].PropTypes.any,
	    onSelect: _react2['default'].PropTypes.func,
	    getId: _react2['default'].PropTypes.func
	  })
	};
	
	Nav.defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	exports['default'] = _utilsBootstrapUtils.bsClass('nav', _utilsBootstrapUtils.bsStyles(['tabs', 'pills'], Nav));
	module.exports = exports['default'];

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SafeAnchor = __webpack_require__(47);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _utilsCreateChainedFunction = __webpack_require__(32);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var NavItem = _react2['default'].createClass({
	  displayName: 'NavItem',
	
	  propTypes: {
	    active: _react2['default'].PropTypes.bool,
	    disabled: _react2['default'].PropTypes.bool,
	    role: _react2['default'].PropTypes.string,
	    href: _react2['default'].PropTypes.string,
	    onClick: _react2['default'].PropTypes.func,
	    onSelect: _react2['default'].PropTypes.func,
	    eventKey: _react2['default'].PropTypes.any
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      active: false,
	      disabled: false
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var active = _props.active;
	    var disabled = _props.disabled;
	    var role = _props.role;
	    var href = _props.href;
	    var onClick = _props.onClick;
	    var className = _props.className;
	    var style = _props.style;
	
	    var props = _objectWithoutProperties(_props, ['active', 'disabled', 'role', 'href', 'onClick', 'className', 'style']);
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    if (!role) {
	      if (href === '#') {
	        role = 'button';
	      }
	    } else if (role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: _classnames2['default'](className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], _extends({}, props, {
	        disabled: disabled,
	        role: role,
	        href: href,
	        onClick: _utilsCreateChainedFunction2['default'](onClick, this.handleClick)
	      }))
	    );
	  },
	
	  handleClick: function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, e);
	      }
	    }
	  }
	});
	
	exports['default'] = NavItem;
	module.exports = exports['default'];

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var NavbarBrand = (function (_React$Component) {
	  _inherits(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    _classCallCheck(this, NavbarBrand);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  NavbarBrand.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['className', 'children']);
	
	    var _context$$bs_navbar_bsClass = this.context.$bs_navbar_bsClass;
	    var bsClass = _context$$bs_navbar_bsClass === undefined ? 'navbar' : _context$$bs_navbar_bsClass;
	
	    var brandClasses = _utilsBootstrapUtils.prefix({ bsClass: bsClass }, 'brand');
	
	    if (_react2['default'].isValidElement(children)) {
	      return _react2['default'].cloneElement(children, {
	        className: _classnames2['default'](children.props.className, className, brandClasses)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'span',
	      _extends({}, props, { className: _classnames2['default'](className, brandClasses) }),
	      children
	    );
	  };
	
	  return NavbarBrand;
	})(_react2['default'].Component);
	
	NavbarBrand.contextTypes = {
	  $bs_navbar_bsClass: _react2['default'].PropTypes.string
	};
	
	exports['default'] = NavbarBrand;
	module.exports = exports['default'];

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint react/prop-types: [2, {ignore: ["container", "containerPadding", "target", "placement", "children"] }] */
	/* These properties are validated in 'Portal' and 'Position' components */
	
	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactOverlaysLibOverlay = __webpack_require__(819);
	
	var _reactOverlaysLibOverlay2 = _interopRequireDefault(_reactOverlaysLibOverlay);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _Fade = __webpack_require__(117);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Overlay = (function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay() {
	    _classCallCheck(this, Overlay);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props;
	    var child = _props.children;
	    var transition = _props.animation;
	
	    var props = _objectWithoutProperties(_props, ['children', 'animation']);
	
	    if (transition === true) {
	      transition = _Fade2['default'];
	    }
	
	    if (transition === false) {
	      transition = null;
	    }
	
	    if (!transition) {
	      child = _react.cloneElement(child, {
	        className: _classnames2['default']('in', child.props.className)
	      });
	    }
	
	    return _react2['default'].createElement(
	      _reactOverlaysLibOverlay2['default'],
	      _extends({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	})(_react2['default'].Component);
	
	Overlay.propTypes = _extends({}, _reactOverlaysLibOverlay2['default'].propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2['default'].PropTypes.bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _react2['default'].PropTypes.bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _react2['default'].PropTypes.func,
	
	  /**
	   * Use animation
	   */
	  animation: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _reactPropTypesLibElementType2['default']]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2['default'].PropTypes.func
	});
	
	Overlay.defaultProps = {
	  animation: _Fade2['default'],
	  rootClose: false,
	  show: false
	};
	
	exports['default'] = Overlay;
	module.exports = exports['default'];

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _utilsValidComponentChildren = __webpack_require__(28);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var PanelGroup = _react2['default'].createClass({
	  displayName: 'PanelGroup',
	
	  propTypes: {
	    accordion: _react2['default'].PropTypes.bool,
	    activeKey: _react2['default'].PropTypes.any,
	    className: _react2['default'].PropTypes.string,
	    children: _react2['default'].PropTypes.node,
	    defaultActiveKey: _react2['default'].PropTypes.any,
	    onSelect: _react2['default'].PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      accordion: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var defaultActiveKey = this.props.defaultActiveKey;
	
	    return {
	      activeKey: defaultActiveKey
	    };
	  },
	
	  render: function render() {
	    var classes = _utilsBootstrapUtils.getClassSet(this.props);
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    if (this.props.accordion) {
	      props.role = 'tablist';
	    }
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, props, { className: _classnames2['default'](className, classes), onSelect: null }),
	      _utilsValidComponentChildren2['default'].map(props.children, this.renderPanel)
	    );
	  },
	
	  renderPanel: function renderPanel(child, index) {
	    var activeKey = this.props.activeKey != null ? this.props.activeKey : this.state.activeKey;
	
	    var props = {
	      bsStyle: child.props.bsStyle || this.props.bsStyle,
	      key: child.key ? child.key : index,
	      ref: child.ref
	    };
	
	    if (this.props.accordion) {
	      props.headerRole = 'tab';
	      props.panelRole = 'tabpanel';
	      props.collapsible = true;
	      props.expanded = child.props.eventKey === activeKey;
	      props.onSelect = this.handleSelect;
	    }
	
	    return _react.cloneElement(child, props);
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    // Defer any updates to this component during the `onSelect` handler.
	    return !this._isChanging;
	  },
	
	  handleSelect: function handleSelect(key, e) {
	    e.preventDefault();
	
	    if (this.props.onSelect) {
	      this._isChanging = true;
	      this.props.onSelect(key, e);
	      this._isChanging = false;
	    }
	
	    if (this.state.activeKey === key) {
	      key = null;
	    }
	
	    this.setState({
	      activeKey: key
	    });
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsClass('panel-group', PanelGroup);
	module.exports = exports['default'];

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _domHelpersClassAddClass = __webpack_require__(606);
	
	var _domHelpersClassAddClass2 = _interopRequireDefault(_domHelpersClassAddClass);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _utilsCreateChainedFunction = __webpack_require__(32);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var _utilsTabUtils = __webpack_require__(313);
	
	var _Fade = __webpack_require__(117);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var TabPane = _react2['default'].createClass({
	  displayName: 'TabPane',
	
	  propTypes: {
	
	    /**
	     * Uniquely identify the TabPane amoung its siblings.
	     */
	    eventKey: _react.PropTypes.any,
	
	    /**
	     * Use animation when showing or hiding TabPanes. Use `false` to disable,
	     * `true` to enable the default "Fade" animation or any Transition component.
	     *
	     */
	    animation: _react.PropTypes.oneOfType([_react.PropTypes.bool, _reactPropTypesLibElementType2['default']]),
	
	    /** @private **/
	    id: _react.PropTypes.string,
	
	    /** @private **/
	    'aria-labelledby': _react.PropTypes.string,
	
	    /**
	     * Transition onEnter callback when animation is not `false`
	     */
	    onEnter: _react.PropTypes.func,
	
	    /**
	     * Transition onEntering callback when animation is not `false`
	     */
	    onEntering: _react.PropTypes.func,
	
	    /**
	     * Transition onEntered callback when animation is not `false`
	     */
	    onEntered: _react.PropTypes.func,
	
	    /**
	     * Transition onExit callback when animation is not `false`
	     */
	    onExit: _react.PropTypes.func,
	
	    /**
	     * Transition onExiting callback when animation is not `false`
	     */
	    onExiting: _react.PropTypes.func,
	
	    /**
	     * Transition onExited callback when animation is not `false`
	     */
	    onExited: _react.PropTypes.func,
	
	    /**
	     * Unmount the tab (remove it from the DOM) when it is no longer visible
	     */
	    unmountOnExit: _react.PropTypes.bool
	  },
	
	  contextTypes: {
	    $bs_tabcontainer: _react.PropTypes.shape({
	      getId: _react.PropTypes.func,
	      unmountOnExit: _react.PropTypes.bool
	    }),
	    $bs_tabcontent: _react.PropTypes.shape({
	      bsClass: _react.PropTypes.string,
	      animation: _react.PropTypes.oneOfType([_react.PropTypes.bool, _reactPropTypesLibElementType2['default']]),
	      activeKey: _react.PropTypes.any,
	      onExited: _react.PropTypes.func,
	      register: _react.PropTypes.func,
	      unmountOnExit: _react.PropTypes.bool
	    })
	  },
	
	  /**
	   * We override the TabContainer context so Navs in TabPanes
	   * don't conflict with the top level one.
	   */
	  childContextTypes: {
	    $bs_tabcontainer: _react.PropTypes.oneOf([null])
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.exited = !this.isActive();
	    this.registerWithParent();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    if (nextProps.eventKey !== this.props.eventKey) {
	      this.unregisterWithParent();
	      this.registerWithParent(nextProps, nextContext);
	    }
	  },
	
	  componentWillUpdate: function componentWillUpdate(nextProps, _, nextContext) {
	    if (this.isActive(nextProps, nextContext)) {
	      this.exited = false;
	    } else if (!this.exited && !this.getTransition(nextProps, nextContext)) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.exited = true;
	      this._fireExitedCallback = true;
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    if (this._fireExitedCallback) {
	      this._fireExitedCallback = false;
	      this.onExited();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.unregisterWithParent();
	  },
	
	  getChildContext: function getChildContext() {
	    return { $bs_tabcontainer: null };
	  },
	
	  getTransition: function getTransition() {
	    var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	    var context = arguments.length <= 1 || arguments[1] === undefined ? this.context : arguments[1];
	
	    context = this.getContext('$bs_tabcontent', context);
	    return props.animation != null ? props.animation : context.animation;
	  },
	
	  getUnmountOnExit: function getUnmountOnExit() {
	    var context = this.getContext('$bs_tabcontent', this.context);
	    return this.props.unmountOnExit != null ? this.props.unmountOnExit : context.unmountOnExit;
	  },
	
	  isActive: function isActive() {
	    var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	    var context = arguments.length <= 1 || arguments[1] === undefined ? this.context : arguments[1];
	
	    return this.getContext('$bs_tabcontent', context).activeKey === props.eventKey;
	  },
	
	  render: function render() {
	    var _classes;
	
	    var active = this.isActive();
	    var visible = active || !this.exited;
	    var getId = this.getContext('$bs_tabcontainer').getId;
	    var bsClass = this.props.bsClass || this.getContext('$bs_tabcontent').bsClass;
	
	    var Transition = this.getTransition();
	
	    if (!visible && !Transition && this.getUnmountOnExit()) {
	      return null;
	    }
	
	    var classes = (_classes = {
	      active: visible
	    }, _classes[_utilsBootstrapUtils.prefix({ bsClass: bsClass }, 'pane')] = true, _classes);
	
	    var _props = this.props;
	    var eventKey = _props.eventKey;
	    var id = _props.id;
	    var labelledBy = _props['aria-labelledby'];
	    var onExit = _props.onExit;
	    var onExiting = _props.onExiting;
	    var onExited = _props.onExited;
	    var onEnter = _props.onEnter;
	    var onEntering = _props.onEntering;
	    var onEntered = _props.onEntered;
	
	    if (typeof Transition === 'boolean') {
	      Transition = Transition ? _Fade2['default'] : null;
	    }
	
	    if (getId) {
	       false ? _warning2['default'](!(id || labelledBy), 'In the context of a TabContainer, TabPanes are given generated `id` and `aria-labelledby` ' + 'attributes for the sake of proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` prop to the parent TabContainer.') : undefined;
	      id = getId(eventKey, _utilsTabUtils.PANE) || null;
	      labelledBy = getId(eventKey, _utilsTabUtils.TAB) || null;
	    }
	
	    var tabPane = _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        id: id,
	        role: 'tabpanel',
	        'aria-hidden': !visible,
	        'aria-labelledby': labelledBy,
	        className: _classnames2['default'](this.props.className, classes, { 'in': !Transition })
	      }),
	      this.props.children
	    );
	
	    if (Transition) {
	      tabPane = _react2['default'].createElement(
	        Transition,
	        {
	          'in': active,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: _utilsCreateChainedFunction2['default'](this.handleExited, onExited),
	          onEnter: _utilsCreateChainedFunction2['default'](this.handleEnter, onEnter),
	          onEntering: onEntering,
	          onEntered: onEntered,
	          unmountOnExit: this.getUnmountOnExit()
	        },
	        tabPane
	      );
	    }
	
	    return tabPane;
	  },
	
	  onExited: function onExited() {
	    var context = this.getContext('$bs_tabcontent');
	    if (context.onExited) {
	      context.onExited(this.props.eventKey);
	    }
	  },
	
	  handleEnter: function handleEnter(node) {
	    // ref: https://github.com/react-bootstrap/react-overlays/issues/40
	    if (this.isActive()) {
	      _domHelpersClassAddClass2['default'](node, 'active');
	      node.offsetWidth; // eslint-disable-line no-unused-expressions
	    }
	  },
	
	  handleExited: function handleExited() {
	    this.exited = true;
	    this.onExited();
	    this.forceUpdate();
	  },
	
	  registerWithParent: function registerWithParent() {
	    var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	    var context = arguments.length <= 1 || arguments[1] === undefined ? this.context : arguments[1];
	
	    var register = this.getContext('$bs_tabcontent', context).register;
	
	    if (register) {
	      this.unregister = register(props.eventKey);
	    }
	  },
	
	  unregisterWithParent: function unregisterWithParent() {
	    if (this.unregister) {
	      this.unregister();
	    }
	  },
	
	  getContext: function getContext(key) {
	    var context = arguments.length <= 1 || arguments[1] === undefined ? this.context : arguments[1];
	
	    return context[key] || {};
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsClass('tab', TabPane);
	module.exports = exports['default'];

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	exports.nextEnabled = nextEnabled;
	
	var _ValidComponentChildren = __webpack_require__(28);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	var findChild = _ValidComponentChildren2['default'].find;
	
	var TAB = 'tab';
	exports.TAB = TAB;
	var PANE = 'pane';
	
	exports.PANE = PANE;
	
	function nextEnabled(children, currentKey, keys, moveNext) {
	  var lastIdx = keys.length - 1;
	  var stopAt = keys[moveNext ? Math.max(lastIdx, 0) : 0];
	  var nextKey = currentKey;
	
	  function getNext() {
	    var idx = keys.indexOf(nextKey);
	    nextKey = moveNext ? keys[Math.min(lastIdx, idx + 1)] : keys[Math.max(0, idx - 1)];
	
	    return findChild(children, function (_child) {
	      return _child.props.eventKey === nextKey;
	    });
	  }
	
	  var next = getNext();
	
	  while (next.props.eventKey !== stopAt && next.props.disabled) {
	    next = getNext();
	  }
	
	  return next.props.disabled ? currentKey : next.props.eventKey;
	}

/***/ },
/* 314 */
[994, 787],
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(790);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 316 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 317 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(793);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.FacebookLogin=t(require("react")):e.FacebookLogin=t(e.react)}(this,function(e){return function(e){function t(n){if(o[n])return o[n].exports;var r=o[n]={exports:{},id:n,loaded:!1};return e[n].call(r.exports,r,r.exports,t),r.loaded=!0,r.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t,o){e.exports=o(2)},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var n in o)Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n])}return e},c=function(){function e(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,o,n){return o&&e(t.prototype,o),n&&e(t,n),t}}(),u=o(11),l=n(u),f=o(9),d=n(f),p=o(4),h=n(p),b=o(3),y=n(b),g=function(){var e=!1;try{e=!!(window.navigator&&window.navigator.standalone||navigator.userAgent.match("CriOS")||navigator.userAgent.match(/mobile/i))}catch(t){}return e},m=function(e){return["button","input","select","textarea","optgroup","option","fieldset"].indexOf((e+"").toLowerCase())>=0},k=function(e){function t(){var e,o,n,a;r(this,t);for(var c=arguments.length,u=Array(c),l=0;l<c;l++)u[l]=arguments[l];return o=n=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(u))),n.state={isSdkLoaded:!1,isProcessing:!1},n.responseApi=function(e){window.FB.api("/me",{locale:n.props.language,fields:n.props.fields},function(t){s(t,e),n.props.callback(t)})},n.checkLoginState=function(e){n.setStateIfMounted({isProcessing:!1}),e.authResponse?n.responseApi(e.authResponse):n.props.onFailure?n.props.onFailure({status:e.status}):n.props.callback({status:e.status})},n.checkLoginAfterRefresh=function(e){"connected"===e.status?n.checkLoginState(e):window.FB.login(function(e){return n.checkLoginState(e)},!0)},n.click=function(e){if(n.state.isSdkLoaded&&!n.state.isProcessing&&!n.props.isDisabled){n.setState({isProcessing:!0});var t=n.props,o=t.scope,r=t.appId,i=t.onClick,a=t.reAuthenticate,s=t.returnScopes,c=t.redirectUri,u=t.disableMobileRedirect;if("function"!=typeof i||(i(e),!e.defaultPrevented)){var l={client_id:r,redirect_uri:c,state:"facebookdirect",return_scopes:s,scope:o};a&&(l.auth_type="reauthenticate"),n.props.isMobile&&!u?window.location.href="//www.facebook.com/dialog/oauth"+(0,y["default"])(l):window.FB.login(n.checkLoginState,{scope:o,return_scopes:s,auth_type:l.auth_type})}}},a=o,i(n,a)}return a(t,e),c(t,[{key:"componentDidMount",value:function(){if(this._isMounted=!0,document.getElementById("facebook-jssdk"))return void this.sdkLoaded();this.setFbAsyncInit(),this.loadSdkAsynchronously();var e=document.getElementById("fb-root");e||(e=document.createElement("div"),e.id="fb-root",document.body.appendChild(e))}},{key:"componentWillReceiveProps",value:function(e){this.state.isSdkLoaded&&e.autoLoad&&!this.props.autoLoad&&window.FB.getLoginStatus(this.checkLoginAfterRefresh)}},{key:"componentWillUnmount",value:function(){this._isMounted=!1}},{key:"setStateIfMounted",value:function(e){this._isMounted&&this.setState(e)}},{key:"setFbAsyncInit",value:function(){var e=this,t=this.props,o=t.appId,n=t.xfbml,r=t.cookie,i=t.version,a=t.autoLoad;window.fbAsyncInit=function(){window.FB.init({version:"v"+i,appId:o,xfbml:n,cookie:r}),e.setStateIfMounted({isSdkLoaded:!0}),(a||window.location.search.includes("facebookdirect"))&&window.FB.getLoginStatus(e.checkLoginAfterRefresh)}}},{key:"sdkLoaded",value:function(){this.setState({isSdkLoaded:!0})}},{key:"loadSdkAsynchronously",value:function(){var e=this.props.language;!function(t,o,n){var r=t.getElementsByTagName(o)[0],i=r,a=r;t.getElementById(n)||(a=t.createElement(o),a.id=n,a.src="https://connect.facebook.net/"+e+"/sdk.js",i.parentNode.insertBefore(a,i))}(document,"script","facebook-jssdk")}},{key:"style",value:function(){var e=this.constructor.defaultProps.cssClass;return this.props.cssClass===e&&l["default"].createElement("style",{dangerouslySetInnerHTML:{__html:h["default"]}})}},{key:"containerStyle",value:function(){var e={transition:"opacity 0.5s"};return(this.state.isProcessing||!this.state.isSdkLoaded||this.props.isDisabled)&&(e.opacity=.6),s(e,this.props.containerStyle)}},{key:"renderOwnButton",value:function(){var e=this.props,t=e.cssClass,o=e.size,n=e.icon,r=e.textButton,i=e.typeButton,a=e.buttonStyle,c="string"==typeof n,u={};return this.props.isDisabled&&m(this.props.tag)&&(u.disabled=!0),l["default"].createElement("span",{style:this.containerStyle()},c&&l["default"].createElement("link",{rel:"stylesheet",href:"//maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css"}),l["default"].createElement(this.props.tag,s({type:i,className:t+" "+o,style:a,onClick:this.click},u),n&&c&&l["default"].createElement("i",{className:"fa "+n}),n&&!c&&n,r),this.style())}},{key:"render",value:function(){var e=this.props.children;return e?l["default"].createElement("span",{onClick:this.click},e):this.renderOwnButton()}}]),t}(l["default"].Component);k.propTypes={isDisabled:d["default"].bool,callback:d["default"].func.isRequired,appId:d["default"].string.isRequired,xfbml:d["default"].bool,cookie:d["default"].bool,reAuthenticate:d["default"].bool,scope:d["default"].string,returnScopes:d["default"].bool,redirectUri:d["default"].string,textButton:d["default"].string,typeButton:d["default"].string,autoLoad:d["default"].bool,disableMobileRedirect:d["default"].bool,isMobile:d["default"].bool,size:d["default"].string,fields:d["default"].string,cssClass:d["default"].string,version:d["default"].string,icon:d["default"].any,language:d["default"].string,onClick:d["default"].func,containerStyle:d["default"].object,buttonStyle:d["default"].object,children:d["default"].node,tag:d["default"].oneOfType([d["default"].node,d["default"].func]),onFailure:d["default"].func},k.defaultProps={textButton:"Login with Facebook",typeButton:"button",redirectUri:"undefined"!=typeof window?window.location.href:"/",scope:"public_profile,email",returnScopes:!1,xfbml:!1,cookie:!1,reAuthenticate:!1,size:"metro",fields:"name",cssClass:"kep-login-facebook",version:"2.3",language:"en_US",disableMobileRedirect:!1,isMobile:g(),tag:"button",onFailure:null},t["default"]=k},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=void 0;var r=o(1),i=n(r);t["default"]=i["default"]},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){return"?"+Object.keys(e).map(function(t){return t+"="+encodeURIComponent(e[t])}).join("&")}},function(e,t,o){t=e.exports=o(5)(),t.push([e.id,".kep-login-facebook{font-family:Helvetica,sans-serif;font-weight:700;-webkit-font-smoothing:antialiased;color:#fff;cursor:pointer;display:inline-block;font-size:calc(.27548vw + 12.71074px);text-decoration:none;text-transform:uppercase;transition:background-color .3s,border-color .3s;background-color:#4c69ba;border:calc(.06887vw + .67769px) solid #4c69ba;padding:calc(.34435vw + 13.38843px) calc(.34435vw + 18.38843px)}.kep-login-facebook.small{padding:calc(.34435vw + 3.38843px) calc(.34435vw + 8.38843px)}.kep-login-facebook.medium{padding:calc(.34435vw + 8.38843px) calc(.34435vw + 13.38843px)}.kep-login-facebook.metro{border-radius:0}.kep-login-facebook .fa{margin-right:calc(.34435vw + 3.38843px)}",""]),t.locals={"kep-login-facebook":"kep-login-facebook",small:"small",medium:"medium",metro:"metro",fa:"fa"}},function(e,t){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],t=0;t<this.length;t++){var o=this[t];o[2]?e.push("@media "+o[2]+"{"+o[1]+"}"):e.push(o[1])}return e.join("")},e.i=function(t,o){"string"==typeof t&&(t=[[null,t,""]]);for(var n={},r=0;r<this.length;r++){var i=this[r][0];"number"==typeof i&&(n[i]=!0)}for(r=0;r<t.length;r++){var a=t[r];"number"==typeof a[0]&&n[a[0]]||(o&&!a[2]?a[2]=o:o&&(a[2]="("+a[2]+") and ("+o+")"),e.push(a))}},e}},function(e,t){"use strict";function o(e){return function(){return e}}var n=function(){};n.thatReturns=o,n.thatReturnsFalse=o(!1),n.thatReturnsTrue=o(!0),n.thatReturnsNull=o(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n},function(e,t,o){"use strict";function n(e,t,o,n,i,a,s,c){if(r(t),!e){var u;if(void 0===t)u=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[o,n,i,a,s,c],f=0;u=new Error(t.replace(/%s/g,function(){return l[f++]})),u.name="Invariant Violation"}throw u.framesToPop=1,u}}var r=function(e){};e.exports=n},function(e,t,o){"use strict";var n=o(6),r=o(7),i=o(10);e.exports=function(){function e(e,t,o,n,a,s){s!==i&&r(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var o={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return o.checkPropTypes=n,o.PropTypes=o,o}},function(e,t,o){e.exports=o(8)()},function(e,t){"use strict";var o="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=o},function(t,o){t.exports=e}])});

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(706);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _defaults = __webpack_require__(803);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	var _propTypes = __webpack_require__(805);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _filterInputAttributes = __webpack_require__(321);
	
	var _filterInputAttributes2 = _interopRequireDefault(_filterInputAttributes);
	
	var _input = __webpack_require__(804);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _suggestList = __webpack_require__(807);
	
	var _suggestList2 = _interopRequireDefault(_suggestList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */
	
	// Escapes special characters in user input for regex
	function escapeRegExp(str) {
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	}
	
	/**
	 * Entry point for the Geosuggest component
	 */
	
	var Geosuggest = function (_React$Component) {
	  _inherits(Geosuggest, _React$Component);
	
	  /**
	   * The constructor. Sets the initial state.
	   * @param  {Object} props The properties object.
	   */
	  function Geosuggest(props) {
	    _classCallCheck(this, Geosuggest);
	
	    var _this = _possibleConstructorReturn(this, (Geosuggest.__proto__ || Object.getPrototypeOf(Geosuggest)).call(this, props));
	
	    _this.onInputChange = function (userInput) {
	      _this.setState({ userInput: userInput }, _this.onAfterInputChange);
	    };
	
	    _this.onAfterInputChange = function () {
	      _this.showSuggests();
	      _this.props.onChange(_this.state.userInput);
	    };
	
	    _this.onInputFocus = function () {
	      _this.props.onFocus();
	      _this.showSuggests();
	    };
	
	    _this.onInputBlur = function () {
	      if (!_this.state.ignoreBlur) {
	        _this.hideSuggests();
	      }
	    };
	
	    _this.onNext = function () {
	      return _this.activateSuggest('next');
	    };
	
	    _this.onPrev = function () {
	      return _this.activateSuggest('prev');
	    };
	
	    _this.onSelect = function () {
	      return _this.selectSuggest(_this.state.activeSuggest);
	    };
	
	    _this.onSuggestMouseDown = function () {
	      return _this.setState({ ignoreBlur: true });
	    };
	
	    _this.onSuggestMouseOut = function () {
	      return _this.setState({ ignoreBlur: false });
	    };
	
	    _this.onSuggestNoResults = function () {
	      _this.props.onSuggestNoResults(_this.state.userInput);
	    };
	
	    _this.hideSuggests = function () {
	      _this.props.onBlur(_this.state.userInput);
	      var timer = setTimeout(function () {
	        _this.setState({
	          isSuggestsHidden: true,
	          activeSuggest: null
	        });
	      }, 100);
	
	      _this.setState({ timer: timer });
	    };
	
	    _this.selectSuggest = function (suggest) {
	      if (!suggest) {
	        suggest = {
	          label: _this.state.userInput
	        };
	      }
	
	      _this.setState({
	        isSuggestsHidden: true,
	        userInput: suggest.label
	      });
	
	      if (suggest.location) {
	        _this.setState({ ignoreBlur: false });
	        _this.props.onSuggestSelect(suggest);
	        return;
	      }
	
	      _this.geocodeSuggest(suggest);
	    };
	
	    _this.state = {
	      isSuggestsHidden: true,
	      isLoading: false,
	      userInput: props.initialValue,
	      activeSuggest: null,
	      suggests: [],
	      timer: null
	    };
	
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onAfterInputChange = _this.onAfterInputChange.bind(_this);
	
	    if (props.queryDelay) {
	      _this.onAfterInputChange = (0, _lodash2.default)(_this.onAfterInputChange, props.queryDelay);
	    }
	    return _this;
	  }
	
	  /**
	   * Change inputValue if prop changes
	   * @param {Object} props The new props
	   */
	
	
	  _createClass(Geosuggest, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      if (this.props.initialValue !== props.initialValue) {
	        this.setState({ userInput: props.initialValue });
	      }
	    }
	
	    /**
	     * Called on the client side after component is mounted.
	     * Google api sdk object will be obtained and cached as a instance property.
	     * Necessary objects of google api will also be determined and saved.
	     */
	
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (typeof window === 'undefined') {
	        return;
	      }
	
	      var googleMaps = this.props.googleMaps || window.google && // eslint-disable-line no-extra-parens
	      window.google.maps || this.googleMaps;
	
	      /* istanbul ignore next */
	      if (!googleMaps) {
	        console.error( // eslint-disable-line no-console
	        'Google map api was not found in the page.');
	        return;
	      }
	      this.googleMaps = googleMaps;
	
	      this.autocompleteService = new googleMaps.places.AutocompleteService();
	      this.geocoder = new googleMaps.Geocoder();
	    }
	
	    /**
	     * When the component will unmount
	     */
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.state.timer);
	    }
	
	    /**
	     * When the input changed
	     * @param {String} userInput The input value of the user
	     */
	
	
	    /**
	     * On After the input got changed
	     */
	
	
	    /**
	     * When the input gets focused
	     */
	
	
	    /**
	     * When the input gets blurred
	     */
	
	  }, {
	    key: 'focus',
	
	
	    /**
	     * Focus the input
	     */
	    value: function focus() {
	      this.refs.input.focus();
	    }
	
	    /**
	     * Update the value of the user input
	     * @param {String} userInput the new value of the user input
	     */
	
	  }, {
	    key: 'update',
	    value: function update(userInput) {
	      this.setState({ userInput: userInput });
	      this.props.onChange(userInput);
	    }
	
	    /*
	     * Clear the input and close the suggestion pane
	     */
	
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.setState({ userInput: '' }, this.hideSuggests);
	    }
	
	    /**
	     * Search for new suggests
	     */
	
	  }, {
	    key: 'searchSuggests',
	    value: function searchSuggests() {
	      var _this2 = this;
	
	      if (!this.state.userInput) {
	        this.updateSuggests();
	        return;
	      }
	
	      var options = {
	        input: this.state.userInput
	      };
	
	      ['location', 'radius', 'bounds', 'types'].forEach(function (option) {
	        if (_this2.props[option]) {
	          options[option] = _this2.props[option];
	        }
	      });
	
	      if (this.props.country) {
	        options.componentRestrictions = {
	          country: this.props.country
	        };
	      }
	
	      this.setState({ isLoading: true }, function () {
	        _this2.autocompleteService.getPlacePredictions(options, function (suggestsGoogle) {
	          _this2.setState({ isLoading: false });
	          _this2.updateSuggests(suggestsGoogle || [], // can be null
	          function () {
	            if (_this2.props.autoActivateFirstSuggest && !_this2.state.activeSuggest) {
	              _this2.activateSuggest('next');
	            }
	          });
	        });
	      });
	    }
	
	    /**
	     * Update the suggests
	     * @param {Array} suggestsGoogle The new google suggests
	     * @param {Function} callback Called once the state has been updated
	     */
	
	  }, {
	    key: 'updateSuggests',
	    value: function updateSuggests() {
	      var _this3 = this;
	
	      var suggestsGoogle = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	      var callback = arguments[1];
	
	      var suggests = [],
	          regex = new RegExp(escapeRegExp(this.state.userInput), 'gim'),
	          skipSuggest = this.props.skipSuggest,
	          maxFixtures = 10,
	          fixturesSearched = 0,
	          activeSuggest = null;
	
	      this.props.fixtures.forEach(function (suggest) {
	        if (fixturesSearched >= maxFixtures) {
	          return;
	        }
	
	        if (!skipSuggest(suggest) && suggest.label.match(regex)) {
	          fixturesSearched++;
	
	          suggest.placeId = suggest.label;
	          suggest.isFixture = true;
	          suggests.push(suggest);
	        }
	      });
	
	      suggestsGoogle.forEach(function (suggest) {
	        if (!skipSuggest(suggest)) {
	          suggests.push({
	            label: _this3.props.getSuggestLabel(suggest),
	            placeId: suggest.place_id,
	            isFixture: false
	          });
	        }
	      });
	
	      activeSuggest = this.updateActiveSuggest(suggests);
	      this.setState({ suggests: suggests, activeSuggest: activeSuggest }, callback);
	    }
	
	    /**
	     * Return the new activeSuggest object after suggests have been updated
	     * @param {Array} suggests The new list of suggests
	     * @return {Object} The new activeSuggest
	     **/
	
	  }, {
	    key: 'updateActiveSuggest',
	    value: function updateActiveSuggest() {
	      var suggests = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	      var activeSuggest = this.state.activeSuggest;
	
	      if (activeSuggest) {
	        var newSuggest = suggests.find(function (listedSuggest) {
	          return activeSuggest.placeId === listedSuggest.placeId && activeSuggest.isFixture === listedSuggest.isFixture;
	        });
	
	        activeSuggest = newSuggest || null;
	      }
	
	      return activeSuggest;
	    }
	
	    /**
	     * Show the suggestions
	     */
	
	  }, {
	    key: 'showSuggests',
	    value: function showSuggests() {
	      this.searchSuggests();
	      this.setState({ isSuggestsHidden: false });
	    }
	
	    /**
	     * Hide the suggestions
	     */
	
	  }, {
	    key: 'activateSuggest',
	
	
	    /**
	     * Activate a new suggest
	     * @param {String} direction The direction in which to activate new suggest
	     */
	    value: function activateSuggest(direction) {
	      // eslint-disable-line complexity
	      if (this.state.isSuggestsHidden) {
	        this.showSuggests();
	        return;
	      }
	
	      var suggestsCount = this.state.suggests.length - 1,
	          next = direction === 'next';
	      var newActiveSuggest = null,
	          newIndex = 0,
	          i = 0;
	
	      for (i; i <= suggestsCount; i++) {
	        if (this.state.suggests[i] === this.state.activeSuggest) {
	          newIndex = next ? i + 1 : i - 1;
	        }
	      }
	
	      if (!this.state.activeSuggest) {
	        newIndex = next ? 0 : suggestsCount;
	      }
	
	      if (newIndex >= 0 && newIndex <= suggestsCount) {
	        newActiveSuggest = this.state.suggests[newIndex];
	      }
	
	      this.props.onActivateSuggest(newActiveSuggest);
	
	      this.setState({ activeSuggest: newActiveSuggest });
	    }
	
	    /**
	     * When an item got selected
	     * @param {GeosuggestItem} suggest The selected suggest item
	     */
	
	  }, {
	    key: 'geocodeSuggest',
	
	
	    /**
	     * Geocode a suggest
	     * @param  {Object} suggest The suggest
	     */
	    value: function geocodeSuggest(suggest) {
	      var _this4 = this;
	
	      this.geocoder.geocode(suggest.placeId && !suggest.isFixture ? { placeId: suggest.placeId } : { address: suggest.label }, function (results, status) {
	        if (status !== _this4.googleMaps.GeocoderStatus.OK) {
	          return;
	        }
	
	        var gmaps = results[0],
	            location = gmaps.geometry.location;
	
	        suggest.gmaps = gmaps;
	        suggest.location = {
	          lat: location.lat(),
	          lng: location.lng()
	        };
	
	        _this4.props.onSuggestSelect(suggest);
	      });
	    }
	
	    /**
	     * Render the view
	     * @return {Function} The React element to render
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var attributes = (0, _filterInputAttributes2.default)(this.props),
	          classes = (0, _classnames2.default)('geosuggest', this.props.className, { 'geosuggest--loading': this.state.isLoading }),
	          input = _react2.default.createElement(_input2.default, _extends({ className: this.props.inputClassName,
	        ref: 'input',
	        value: this.state.userInput,
	        ignoreEnter: !this.state.isSuggestsHidden,
	        ignoreTab: this.props.ignoreTab,
	        style: this.props.style.input,
	        onChange: this.onInputChange,
	        onFocus: this.onInputFocus,
	        onBlur: this.onInputBlur,
	        onNext: this.onNext,
	        onPrev: this.onPrev,
	        onSelect: this.onSelect,
	        onEscape: this.hideSuggests }, attributes)),
	          suggestionsList = _react2.default.createElement(_suggestList2.default, { isHidden: this.state.isSuggestsHidden,
	        style: this.props.style.suggests,
	        suggestItemStyle: this.props.style.suggestItem,
	        suggests: this.state.suggests,
	        activeSuggest: this.state.activeSuggest,
	        onSuggestNoResults: this.onSuggestNoResults,
	        onSuggestMouseDown: this.onSuggestMouseDown,
	        onSuggestMouseOut: this.onSuggestMouseOut,
	        onSuggestSelect: this.selectSuggest });
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _react2.default.createElement(
	          'div',
	          { className: 'geosuggest__input-wrapper' },
	          input
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'geosuggest__suggests-wrapper' },
	          suggestionsList
	        )
	      );
	    }
	  }]);
	
	  return Geosuggest;
	}(_react2.default.Component);
	
	/**
	 * Types for the properties
	 * @type {Object}
	 */
	
	
	Geosuggest.propTypes = _propTypes2.default;
	
	/**
	 * Default values for the properties
	 * @type {Object}
	 */
	Geosuggest.defaultProps = _defaults2.default;
	
	exports.default = Geosuggest;

/***/ },
/* 321 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (props) {
	  var attributes = {};
	
	  allowedAttributes.forEach(function (allowedAttribute) {
	    if (props[allowedAttribute]) {
	      attributes[allowedAttribute] = props[allowedAttribute];
	    }
	  });
	
	  return attributes;
	};
	
	/**
	 * Attributes allowed on input elements
	 */
	var allowedAttributes = ['autoFocus', 'disabled', 'form', 'formAction', 'formEncType', 'formMethod', 'formNoValidate', 'formTarget', 'height', 'id', 'inputMode', 'maxLength', 'name', 'onClick', 'onContextMenu', 'onCopy', 'onCut', 'onDoubleClick', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onPaste', 'pattern', 'placeholder', 'readOnly', 'required', 'size', 'spellCheck', 'tabIndex'];
	
	/**
	 * Filter the properties for only allowed input properties
	 * @param  {Object} props The properties to filter
	 * @return {Object} The filtered, allowed properties
	 */

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.GoogleLogin=t(require("react")):e.GoogleLogin=t(e.react)}(this,function(e){return function(e){function t(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,o){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:o})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,n){e.exports=n(1)},function(e,t,n){"use strict";function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=n(2),a=n.n(s),c=n(3),u=(n.n(c),function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}()),l=function(e){function t(e){o(this,t);var n=r(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.signIn=n.signIn.bind(n),n.state={disabled:!0},n}return i(t,e),u(t,[{key:"componentDidMount",value:function(){var e=this,t=this.props,n=t.clientId,o=t.cookiePolicy,r=t.loginHint,i=t.hostedDomain,s=t.autoLoad,a=t.isSignedIn,c=t.fetchBasicProfile,u=t.redirectUri,l=t.discoveryDocs,f=t.onFailure,p=t.uxMode,d=t.scope;!function(e,t,n,o){var r=e.getElementsByTagName(t)[0],i=r,s=r;s=e.createElement(t),s.id="google-login",s.src="//apis.google.com/js/client:platform.js",i.parentNode.insertBefore(s,i),s.onload=o}(document,"script",0,function(){var t={client_id:n,cookie_policy:o,login_hint:r,hosted_domain:i,fetch_basic_profile:c,discoveryDocs:l,ux_mode:p,redirect_uri:u,scope:d};window.gapi.load("auth2",function(){e.setState({disabled:!1}),window.gapi.auth2.getAuthInstance()||window.gapi.auth2.init(t).then(function(t){a&&t.isSignedIn.get()&&e._handleSigninSuccess(t.currentUser.get())},function(e){return f(e)}),s&&e.signIn()})})}},{key:"signIn",value:function(e){var t=this;if(e&&e.preventDefault(),!this.state.disabled){var n=window.gapi.auth2.getAuthInstance(),o=this.props,r=o.onSuccess,i=o.onRequest,s=o.onFailure,a=o.prompt,c=o.responseType,u={prompt:a};i(),"code"===c?n.grantOfflineAccess(u).then(function(e){return r(e)},function(e){return s(e)}):n.signIn(u).then(function(e){return t._handleSigninSuccess(e)},function(e){return s(e)})}}},{key:"_handleSigninSuccess",value:function(e){var t=e.getBasicProfile(),n=e.getAuthResponse();e.googleId=t.getId(),e.tokenObj=n,e.tokenId=n.id_token,e.accessToken=n.access_token,e.profileObj={googleId:t.getId(),imageUrl:t.getImageUrl(),email:t.getEmail(),name:t.getName(),givenName:t.getGivenName(),familyName:t.getFamilyName()},this.props.onSuccess(e)}},{key:"render",value:function(){var e=this.props,t=e.tag,n=e.type,o=e.style,r=e.className,i=e.disabledStyle,s=e.buttonText,c=e.children,u=this.state.disabled||this.props.disabled,l={display:"inline-block",background:"#d14836",color:"#fff",width:190,paddingTop:10,paddingBottom:10,borderRadius:2,border:"1px solid transparent",fontSize:16,fontWeight:"bold",fontFamily:"Roboto"},f=function(){return o||(r&&!o?{}:l)}(),p=function(){return u?Object.assign({},f,i):f}();return a.a.createElement(t,{onClick:this.signIn,style:p,type:n,disabled:u,className:r},c||s)}}]),t}(s.Component);l.defaultProps={type:"button",tag:"button",buttonText:"Login with Google",scope:"profile email",prompt:"",cookiePolicy:"single_host_origin",fetchBasicProfile:!0,isSignedIn:!1,uxMode:"popup",disabledStyle:{opacity:.6},onRequest:function(){}},t.default=l},function(t,n){t.exports=e},function(e,t,n){"function"==typeof Symbol&&Symbol.iterator,e.exports=n(4)()},function(e,t,n){"use strict";var o=n(5),r=n(6),i=n(7);e.exports=function(){function e(e,t,n,o,s,a){a!==i&&r(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return n.checkPropTypes=o,n.PropTypes=n,n}},function(e,t,n){"use strict";function o(e){return function(){return e}}var r=function(){};r.thatReturns=o,r.thatReturnsFalse=o(!1),r.thatReturnsTrue=o(!0),r.thatReturnsNull=o(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){"use strict";function o(e,t,n,o,i,s,a,c){if(r(t),!e){var u;if(void 0===t)u=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[n,o,i,s,a,c],f=0;u=new Error(t.replace(/%s/g,function(){return l[f++]})),u.name="Invariant Violation"}throw u.framesToPop=1,u}}var r=function(e){};e.exports=o},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"}])});

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OffCanvasMenu = exports.OffCanvasBody = exports.OffCanvas = undefined;
	
	var _OffCanvas2 = __webpack_require__(814);
	
	var _OffCanvas3 = _interopRequireDefault(_OffCanvas2);
	
	var _OffCanvasBody2 = __webpack_require__(815);
	
	var _OffCanvasBody3 = _interopRequireDefault(_OffCanvasBody2);
	
	var _OffCanvasMenu2 = __webpack_require__(816);
	
	var _OffCanvasMenu3 = _interopRequireDefault(_OffCanvasMenu2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.OffCanvas = _OffCanvas3.default;
	exports.OffCanvasBody = _OffCanvasBody3.default;
	exports.OffCanvasMenu = _OffCanvasMenu3.default;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(187);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _ownerDocument = __webpack_require__(94);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _getContainer = __webpack_require__(184);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = _react2.default.createClass({
	
	  displayName: 'Portal',
	
	  propTypes: {
	    /**
	     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	     * appended to it.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func])
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._renderOverlay();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._renderOverlay();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  },
	  _mountOverlayTarget: function _mountOverlayTarget() {
	    if (!this._overlayTarget) {
	      this._overlayTarget = document.createElement('div');
	      this._portalContainerNode = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  _unmountOverlayTarget: function _unmountOverlayTarget() {
	    if (this._overlayTarget) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._overlayTarget = null;
	    }
	    this._portalContainerNode = null;
	  },
	  _renderOverlay: function _renderOverlay() {
	
	    var overlay = !this.props.children ? null : _react2.default.Children.only(this.props.children);
	
	    // Save reference for future access.
	    if (overlay !== null) {
	      this._mountOverlayTarget();
	      this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	    } else {
	      // Unrender if the component is null for transitions to null
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  },
	  _unrenderOverlay: function _unrenderOverlay() {
	    if (this._overlayTarget) {
	      _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
	      this._overlayInstance = null;
	    }
	  },
	  render: function render() {
	    return null;
	  },
	  getMountNode: function getMountNode() {
	    return this._overlayTarget;
	  },
	  getOverlayDOMNode: function getOverlayDOMNode() {
	    if (!this.isMounted()) {
	      throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	    }
	
	    if (this._overlayInstance) {
	      return _reactDom2.default.findDOMNode(this._overlayInstance);
	    }
	
	    return null;
	  }
	});
	
	exports.default = Portal;
	module.exports = exports['default'];

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _contains = __webpack_require__(185);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(327);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(94);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, (RootCloseWrapper.__proto__ || Object.getPrototypeOf(RootCloseWrapper)).call(this, props, context));
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  _createClass(RootCloseWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.disabled) {
	        this.addEventListeners();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!this.props.disabled && prevProps.disabled) {
	        this.addEventListeners();
	      } else if (this.props.disabled && !prevProps.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.props.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'addEventListeners',
	    value: function addEventListeners() {
	      var event = this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, this.handleMouseCapture, true);
	
	      this.documentMouseListener = (0, _addEventListener2.default)(doc, event, this.handleMouse);
	
	      this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'removeEventListeners',
	    value: function removeEventListeners() {
	      if (this.documentMouseCaptureListener) {
	        this.documentMouseCaptureListener.remove();
	      }
	
	      if (this.documentMouseListener) {
	        this.documentMouseListener.remove();
	      }
	
	      if (this.documentKeyupListener) {
	        this.documentKeyupListener.remove();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _react2.default.PropTypes.func,
	  /**
	   * Children to render.
	   */
	  children: _react2.default.PropTypes.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _react2.default.PropTypes.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _react2.default.PropTypes.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__(330);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__(333);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this, props, context));
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  _createClass(Transition, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var status = this.state.status;
	
	
	      if (nextProps.in) {
	        if (status === UNMOUNTED) {
	          this.setState({ status: EXITED });
	        }
	        if (status !== ENTERING && status !== ENTERED) {
	          this.nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          this.nextStatus = EXITING;
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.cancelNextCallback();
	    }
	  }, {
	    key: 'updateStatus',
	    value: function updateStatus() {
	      var _this2 = this;
	
	      if (this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(this);
	
	        if (this.nextStatus === ENTERING) {
	          this.props.onEnter(node);
	
	          this.safeSetState({ status: ENTERING }, function () {
	            _this2.props.onEntering(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: ENTERED }, function () {
	                _this2.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          this.props.onExit(node);
	
	          this.safeSetState({ status: EXITING }, function () {
	            _this2.props.onExiting(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: EXITED }, function () {
	                _this2.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        this.nextStatus = null;
	      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	        this.setState({ status: UNMOUNTED });
	      }
	    }
	  }, {
	    key: 'cancelNextCallback',
	    value: function cancelNextCallback() {
	      if (this.nextCallback !== null) {
	        this.nextCallback.cancel();
	        this.nextCallback = null;
	      }
	    }
	  }, {
	    key: 'safeSetState',
	    value: function safeSetState(nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      this.setState(nextState, this.setNextCallback(callback));
	    }
	  }, {
	    key: 'setNextCallback',
	    value: function setNextCallback(callback) {
	      var _this3 = this;
	
	      var active = true;
	
	      this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this3.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return this.nextCallback;
	    }
	  }, {
	    key: 'onTransitionEnd',
	    value: function onTransitionEnd(node, handler) {
	      this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, this.nextCallback);
	        setTimeout(this.nextCallback, this.props.timeout);
	      } else {
	        setTimeout(this.nextCallback, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var status = this.state.status;
	      if (status === UNMOUNTED) {
	        return null;
	      }
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	      Object.keys(Transition.propTypes).forEach(function (key) {
	        return delete childProps[key];
	      });
	
	      var transitionClassName = void 0;
	      if (status === EXITED) {
	        transitionClassName = this.props.exitedClassName;
	      } else if (status === ENTERING) {
	        transitionClassName = this.props.enteringClassName;
	      } else if (status === ENTERED) {
	        transitionClassName = this.props.enteredClassName;
	      } else if (status === EXITING) {
	        transitionClassName = this.props.exitingClassName;
	      }
	
	      var child = _react2.default.Children.only(children);
	      return _react2.default.cloneElement(child, _extends({}, childProps, {
	        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	      }));
	    }
	  }]);
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _react2.default.PropTypes.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _react2.default.PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _react2.default.PropTypes.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2.default.PropTypes.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _react2.default.PropTypes.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _react2.default.PropTypes.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _react2.default.PropTypes.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _react2.default.PropTypes.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(330);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(828);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(119);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(95);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ },
/* 329 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(78));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = offset;
	
	var _contains = _interopRequireDefault(__webpack_require__(185));
	
	var _isWindow = _interopRequireDefault(__webpack_require__(119));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(95));
	
	function offset(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      win = (0, _isWindow.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = {
	    top: 0,
	    left: 0,
	    height: 0,
	    width: 0
	  };
	  if (!doc) return; // Make sure it's not a disconnected DOM node
	
	  if (!(0, _contains.default)(docElem, node)) return box;
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height
	
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	  return box;
	}
	
	module.exports = exports["default"];

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(119));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(78));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__(835));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(336);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ },
/* 336 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(38);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ },
/* 338 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 339 */
[997, 855],
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(26);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(58);
	
	var _PatternUtils = __webpack_require__(79);
	
	var _InternalPropTypes = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(124);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(113);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(269);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(656);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(346);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(124);
	
	var _routerWarning = __webpack_require__(26);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(113);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(269);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVKShareCount = undefined;
	
	var _stringify = __webpack_require__(558);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.getFacebookShareCount = getFacebookShareCount;
	exports.getGooglePlusShareCount = getGooglePlusShareCount;
	exports.getLinkedinShareCount = getLinkedinShareCount;
	exports.getPinterestShareCount = getPinterestShareCount;
	exports.getOKShareCount = getOKShareCount;
	exports.getRedditShareCount = getRedditShareCount;
	exports.getTumblrShareCount = getTumblrShareCount;
	
	var _jsonp = __webpack_require__(667);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _utils = __webpack_require__(192);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getFacebookShareCount(shareUrl, callback) {
	  var endpoint = 'https://graph.facebook.com/?id=' + shareUrl;
	
	  (0, _jsonp2.default)(endpoint, function (err, data) {
	    callback(!err && data && data.share && data.share.share_count ? data.share.share_count : undefined);
	  });
	}
	
	function getGooglePlusShareCount(shareUrl, callback) {
	  if ((0, _utils.isInternetExplorerBefore)(11)) {
	    /* eslint-disable no-console */
	    console.error('Google plus share count is not supported in <=IE10!');
	    /* eslint-enable no-console */
	    return;
	  }
	
	  var xhr = new XMLHttpRequest();
	
	  xhr.open('POST', 'https://clients6.google.com/rpc');
	  xhr.setRequestHeader('Accept', 'application/json');
	  xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8');
	
	  xhr.send((0, _stringify2.default)({
	    method: 'pos.plusones.get',
	    id: 'p',
	    params: {
	      nolog: true,
	      id: shareUrl,
	      source: 'widget',
	      userId: '@viewer',
	      groupId: '@self'
	    },
	    jsonrpc: '2.0',
	    key: 'p',
	    apiVersion: 'v1'
	  }));
	
	  xhr.onload = function onSuccessdata() {
	    var data = JSON.parse(this.responseText);
	    callback(!!data ? data.result.metadata.globalCounts.count : undefined);
	  };
	
	  xhr.onerror = function onErrordata() {};
	}
	
	function getLinkedinShareCount(shareUrl, callback) {
	  var url = 'https://www.linkedin.com/countserv/count/share';
	
	  return (0, _jsonp2.default)(url + (0, _utils.objectToGetParams)({
	    url: shareUrl,
	    format: 'jsonp'
	  }), function (err, data) {
	    callback(!!data ? data.count : undefined);
	  });
	}
	
	function getPinterestShareCount(shareUrl, callback) {
	  var url = 'https://api.pinterest.com/v1/urls/count.json';
	
	  return (0, _jsonp2.default)(url + (0, _utils.objectToGetParams)({
	    url: shareUrl
	  }), function (err, data) {
	    callback(!!data ? data.count : undefined);
	  });
	}
	
	function getVKShareCount(shareUrl, callback) {
	  if (!window.VK) {
	    window.VK = {
	      Share: {
	        count: function count(index, _count2) {
	          return window.VK.callbacks[index](_count2);
	        }
	      },
	      callbacks: []
	    };
	  }
	
	  var url = 'https://vk.com/share.php';
	  var index = window.VK.callbacks.length;
	
	  window.VK.callbacks.push(callback);
	
	  return (0, _jsonp2.default)(url + (0, _utils.objectToGetParams)({
	    act: 'count',
	    index: index,
	    url: shareUrl
	  }));
	}
	
	exports.getVKShareCount = getVKShareCount;
	function getOKShareCount(shareUrl, callback) {
	  if (!window.OK) {
	    window.OK = {
	      Share: {
	        count: function count(index, _count) {
	          return window.OK.callbacks[index](_count);
	        }
	      },
	      callbacks: []
	    };
	  }
	
	  var url = 'https://connect.ok.ru/dk';
	  var index = window.OK.callbacks.length;
	
	  window.ODKL = {
	    updateCount: function updateCount(a, b) {
	      window.OK.callbacks[index](b);
	    }
	  };
	  window.OK.callbacks.push(callback);
	
	  return (0, _jsonp2.default)(url + (0, _utils.objectToGetParams)({
	    'st.cmd': 'extLike',
	    uid: 'odklcnt0',
	    ref: shareUrl
	  }));
	}
	
	function getRedditShareCount(shareUrl, callback) {
	  var endpoint = 'https://www.reddit.com/api/info.json?limit=1&url=' + shareUrl;
	
	  (0, _jsonp2.default)(endpoint, { param: 'jsonp' }, function (err, response) {
	    callback(!err && response && response.data && response.data.children.length > 0 && response.data.children[0].data.score ? response.data.children[0].data.score : undefined);
	  });
	}
	
	function getTumblrShareCount(shareUrl, callback) {
	  var endpoint = 'http://api.tumblr.com/v2/share/stats';
	
	  return (0, _jsonp2.default)(endpoint + (0, _utils.objectToGetParams)({
	    url: shareUrl
	  }), function (err, data) {
	    callback(!!data ? data.note_count : undefined);
	  });
	}

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.email = email;
	exports.twitter = twitter;
	exports.telegram = telegram;
	exports.whatsapp = whatsapp;
	exports.facebook = facebook;
	exports.googlePlus = googlePlus;
	exports.linkedin = linkedin;
	exports.pinterest = pinterest;
	exports.vk = vk;
	exports.ok = ok;
	exports.reddit = reddit;
	exports.tumblr = tumblr;
	exports.livejournal = livejournal;
	exports.mailru = mailru;
	
	var _assert = __webpack_require__(402);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _utils = __webpack_require__(192);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable prefer-template */
	function email(url, _ref) {
	  var subject = _ref.subject,
	      body = _ref.body;
	
	  return 'mailto:' + (0, _utils.objectToGetParams)({ subject: subject, body: body || subject });
	}
	
	function twitter(url, _ref2) {
	  var title = _ref2.title,
	      via = _ref2.via,
	      _ref2$hashtags = _ref2.hashtags,
	      hashtags = _ref2$hashtags === undefined ? [] : _ref2$hashtags;
	
	  (0, _assert2.default)(url, 'twitter.url');
	  (0, _assert2.default)(Array.isArray(hashtags), 'twitter.hashtags is not an array');
	
	  return 'https://twitter.com/share' + (0, _utils.objectToGetParams)({
	    url: url,
	    text: title,
	    via: via,
	    hashtags: hashtags.join(',')
	  });
	}
	
	function telegram(url, _ref3) {
	  var title = _ref3.title;
	
	  (0, _assert2.default)(url, 'telegram.url');
	  return 'https://telegram.me/share/' + (0, _utils.objectToGetParams)({
	    url: url,
	    text: title
	  });
	}
	
	function whatsapp(url, _ref4) {
	  var title = _ref4.title,
	      separator = _ref4.separator;
	
	  (0, _assert2.default)(url, 'whatsapp.url');
	  return 'https://api.whatsapp.com/send' + (0, _utils.objectToGetParams)({
	    text: title ? title + separator + url : url
	  });
	}
	
	function facebook(url, _ref5) {
	  var quote = _ref5.quote,
	      hashtag = _ref5.hashtag;
	
	  (0, _assert2.default)(url, 'facebook.url');
	
	  return 'https://www.facebook.com/sharer/sharer.php' + (0, _utils.objectToGetParams)({
	    u: url,
	    quote: quote,
	    hashtag: hashtag
	  });
	}
	
	function googlePlus(url) {
	  (0, _assert2.default)(url, 'googlePlus.url');
	
	  return 'https://plus.google.com/share' + (0, _utils.objectToGetParams)({ url: url });
	}
	
	function linkedin(url, _ref6) {
	  var title = _ref6.title,
	      description = _ref6.description;
	
	  (0, _assert2.default)(url, 'linkedin.url');
	
	  return 'https://linkedin.com/shareArticle' + (0, _utils.objectToGetParams)({
	    url: url,
	    title: title,
	    summary: description
	  });
	}
	
	function pinterest(url, _ref7) {
	  var media = _ref7.media,
	      description = _ref7.description;
	
	  (0, _assert2.default)(url, 'pinterest.url');
	  (0, _assert2.default)(media, 'pinterest.media');
	
	  return 'https://pinterest.com/pin/create/button/' + (0, _utils.objectToGetParams)({
	    url: url,
	    media: media,
	    description: description
	  });
	}
	
	function vk(url, _ref8) {
	  var title = _ref8.title,
	      description = _ref8.description,
	      image = _ref8.image;
	
	  (0, _assert2.default)(url, 'vk.url');
	
	  return 'https://vk.com/share.php' + (0, _utils.objectToGetParams)({
	    url: url,
	    title: title,
	    description: description,
	    image: image
	  });
	}
	
	function ok(url, _ref9) {
	  var title = _ref9.title,
	      description = _ref9.description,
	      image = _ref9.image;
	
	  (0, _assert2.default)(url, 'ok.url');
	
	  return 'https://connect.ok.ru/offer' + (0, _utils.objectToGetParams)({
	    url: url,
	    title: title,
	    description: description,
	    imageUrl: image
	  });
	}
	
	function reddit(url, _ref10) {
	  var title = _ref10.title;
	
	  (0, _assert2.default)(url, 'reddit.url');
	
	  return 'https://www.reddit.com/submit' + (0, _utils.objectToGetParams)({
	    url: url,
	    title: title
	  });
	}
	
	function tumblr(url, _ref11) {
	  var title = _ref11.title,
	      caption = _ref11.caption,
	      tags = _ref11.tags,
	      posttype = _ref11.posttype;
	
	  (0, _assert2.default)(url, 'tumblr.url');
	
	  return 'https://www.tumblr.com/widgets/share/tool' + (0, _utils.objectToGetParams)({
	    canonicalUrl: url,
	    title: title,
	    caption: caption,
	    tags: tags,
	    posttype: posttype
	  });
	}
	
	function livejournal(url, _ref12) {
	  var title = _ref12.title,
	      description = _ref12.description;
	
	  (0, _assert2.default)(url, 'livejournal.url');
	
	  return 'https://www.livejournal.com/update.bml' + (0, _utils.objectToGetParams)({
	    subject: title,
	    event: description
	  });
	}
	
	function mailru(url, _ref13) {
	  var title = _ref13.title,
	      description = _ref13.description,
	      image = _ref13.image;
	
	  (0, _assert2.default)(url, 'mailru.url');
	
	  return 'https://connect.mail.ru/share' + (0, _utils.objectToGetParams)({
	    url: url,
	    title: title,
	    description: description,
	    imageurl: image
	  });
	}

/***/ },
/* 349 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var Danger = __webpack_require__(894);
	var ReactMultiChildUpdateTypes = __webpack_require__(367);
	var ReactPerf = __webpack_require__(40);
	
	var setInnerHTML = __webpack_require__(133);
	var setTextContent = __webpack_require__(208);
	var invariant = __webpack_require__(14);
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	function insertChildAt(parentNode, childNode, index) {
	  // By exploiting arrays returning `undefined` for an undefined index, we can
	  // rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. However, using `undefined` is not allowed by all
	  // browsers so we must replace it with `null`.
	
	  // fix render order error in safari
	  // IE8 will throw error when index out of list size.
	  var beforeChild = index >= parentNode.childNodes.length ? null : parentNode.childNodes.item(index);
	
	  parentNode.insertBefore(childNode, beforeChild);
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,
	
	  updateTextContent: setTextContent,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markupList List of markup strings.
	   * @internal
	   */
	  processUpdates: function (updates, markupList) {
	    var update;
	    // Mapping from parent IDs to initial child orderings.
	    var initialChildren = null;
	    // List of children that will be moved or removed.
	    var updatedChildren = null;
	
	    for (var i = 0; i < updates.length; i++) {
	      update = updates[i];
	      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING || update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
	        var updatedIndex = update.fromIndex;
	        var updatedChild = update.parentNode.childNodes[updatedIndex];
	        var parentID = update.parentID;
	
	        !updatedChild ?  false ? invariant(false, 'processUpdates(): Unable to find child %s of element. This ' + 'probably means the DOM was unexpectedly mutated (e.g., by the ' + 'browser), usually due to forgetting a <tbody> when using tables, ' + 'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' + 'in an <svg> parent. Try inspecting the child nodes of the element ' + 'with React ID `%s`.', updatedIndex, parentID) : invariant(false) : undefined;
	
	        initialChildren = initialChildren || {};
	        initialChildren[parentID] = initialChildren[parentID] || [];
	        initialChildren[parentID][updatedIndex] = updatedChild;
	
	        updatedChildren = updatedChildren || [];
	        updatedChildren.push(updatedChild);
	      }
	    }
	
	    var renderedMarkup;
	    // markupList is either a list of markup or just a list of elements
	    if (markupList.length && typeof markupList[0] === 'string') {
	      renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
	    } else {
	      renderedMarkup = markupList;
	    }
	
	    // Remove updated children first so that `toIndex` is consistent.
	    if (updatedChildren) {
	      for (var j = 0; j < updatedChildren.length; j++) {
	        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
	      }
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertChildAt(update.parentNode, renderedMarkup[update.markupIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          insertChildAt(update.parentNode, initialChildren[update.parentID][update.fromIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          // Already removed by the for-loop above.
	          break;
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMChildrenOperations, 'DOMChildrenOperations', {
	  updateTextContent: 'updateTextContent'
	});
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : undefined;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : undefined;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : undefined;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : undefined;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : undefined;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : undefined;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : undefined;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(59);
	var ReactElement = __webpack_require__(35);
	
	var emptyFunction = __webpack_require__(42);
	var traverseAllChildren = __webpack_require__(210);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/(?!\/)/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '//');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild !== child ? escapeUserProvidedKey(mappedChild.key || '') + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var ReactComponent = __webpack_require__(354);
	var ReactElement = __webpack_require__(35);
	var ReactPropTypeLocations = __webpack_require__(128);
	var ReactPropTypeLocationNames = __webpack_require__(127);
	var ReactNoopUpdateQueue = __webpack_require__(369);
	
	var assign = __webpack_require__(17);
	var emptyObject = __webpack_require__(90);
	var invariant = __webpack_require__(14);
	var keyMirror = __webpack_require__(105);
	var keyOf = __webpack_require__(53);
	var warning = __webpack_require__(16);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	var warnedSetProps = false;
	function warnSetProps() {
	  if (!warnedSetProps) {
	    warnedSetProps = true;
	     false ? warning(false, 'setProps(...) and replaceProps(...) are deprecated. ' + 'Instead, call render again at the top level.') : undefined;
	  }
	}
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but not in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : undefined;
	    }
	  }
	}
	
	function validateMethodOverride(proto, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : undefined;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (proto.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classses.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	
	  var proto = Constructor.prototype;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    validateMethodOverride(proto, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        if (!proto.__reactAutoBindMap) {
	          proto.__reactAutoBindMap = {};
	        }
	        proto.__reactAutoBindMap[name] = property;
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : undefined;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = (name in RESERVED_SPEC_KEYS);
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : undefined;
	
	    var isInherited = (name in Constructor);
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : undefined;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : undefined;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : undefined;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    /* eslint-disable block-scoped-var, no-undef */
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : undefined;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : undefined;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	      /* eslint-enable */
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      var method = component.__reactAutoBindMap[autoBindKey];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  setProps: function (partialProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueSetProps(this, partialProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Replace all the props.
	   *
	   * @param {object} newProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  replaceProps: function (newProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueReplaceProps(this, newProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  }
	};
	
	var ReactClassComponent = function () {};
	assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor is overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : undefined;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindMap) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (typeof initialState === 'undefined' && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : undefined;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : undefined;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactNoopUpdateQueue = __webpack_require__(369);
	
	var canDefineProperty = __webpack_require__(131);
	var emptyObject = __webpack_require__(90);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(16);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : undefined;
	  }
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    getDOMNode: ['getDOMNode', 'Use ReactDOM.findDOMNode(component) instead.'],
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceProps: ['replaceProps', 'Instead, call render again at the top level.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).'],
	    setProps: ['setProps', 'Instead, call render again at the top level.']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : undefined;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(49);
	var ReactDOMTextComponent = __webpack_require__(358);
	var ReactDefaultInjection = __webpack_require__(360);
	var ReactInstanceHandles = __webpack_require__(81);
	var ReactMount = __webpack_require__(34);
	var ReactPerf = __webpack_require__(40);
	var ReactReconciler = __webpack_require__(67);
	var ReactUpdates = __webpack_require__(41);
	var ReactVersion = __webpack_require__(200);
	
	var findDOMNode = __webpack_require__(201);
	var renderSubtreeIntoContainer = __webpack_require__(943);
	var warning = __webpack_require__(16);
	
	ReactDefaultInjection.inject();
	
	var render = ReactPerf.measure('React', 'render', ReactMount.render);
	
	var React = {
	  findDOMNode: findDOMNode,
	  render: render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    CurrentOwner: ReactCurrentOwner,
	    InstanceHandles: ReactInstanceHandles,
	    Mount: ReactMount,
	    Reconciler: ReactReconciler,
	    TextComponent: ReactDOMTextComponent
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        console.debug('Download the React DevTools for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : undefined;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim,
	
	    // shams
	    Object.create, Object.freeze];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        console.error('One or more ES5 shim/shams expected by React are not available: ' + 'https://fb.me/react-warning-polyfills');
	        break;
	      }
	    }
	  }
	}
	
	module.exports = React;

/***/ },
/* 356 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(195);
	var ReactMount = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(41);
	
	var assign = __webpack_require__(17);
	var warning = __webpack_require__(16);
	
	var valueContextKey = '__ReactDOMSelect_value$' + Math.random().toString(36).slice(2);
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactMount.getNode(inst._rootNodeID).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  valueContextKey: valueContextKey,
	
	  getNativeProps: function (inst, props, context) {
	    return assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	  },
	
	  processChildContext: function (inst, props, context) {
	    // Pass down initial value so initial generated markup has correct
	    // `selected` attributes
	    var childContext = assign({}, context);
	    childContext[valueContextKey] = inst._wrapperState.initialValue;
	    return childContext;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // the context value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  this._wrapperState.pendingUpdate = true;
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(350);
	var DOMPropertyOperations = __webpack_require__(194);
	var ReactComponentBrowserEnvironment = __webpack_require__(196);
	var ReactMount = __webpack_require__(34);
	
	var assign = __webpack_require__(17);
	var escapeTextContentForBrowser = __webpack_require__(132);
	var setTextContent = __webpack_require__(208);
	var validateDOMNesting = __webpack_require__(211);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings in elements so that they can undergo
	 * the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (props) {
	  // This constructor and its argument is currently used by mocks.
	};
	
	assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * @param {ReactText} text
	   * @internal
	   */
	  construct: function (text) {
	    // TODO: This is really a ReactText (ReactNode), not a ReactElement
	    this._currentElement = text;
	    this._stringText = '' + text;
	
	    // Properties
	    this._rootNodeID = null;
	    this._mountIndex = 0;
	  },
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting('span', null, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    this._rootNodeID = rootID;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement('span');
	      DOMPropertyOperations.setAttributeForID(el, rootID);
	      // Populate node cache
	      ReactMount.getID(el);
	      setTextContent(el, this._stringText);
	      return el;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this in a `span` for the reasons stated above, but
	        // since this is a situation where React won't take over (static pages),
	        // we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' + escapedText + '</span>';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var node = ReactMount.getNode(this._rootNodeID);
	        DOMChildrenOperations.updateTextContent(node, nextStringText);
	      }
	    }
	  },
	
	  unmountComponent: function () {
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var ReactUpdates = __webpack_require__(41);
	var Transaction = __webpack_require__(130);
	
	var assign = __webpack_require__(17);
	var emptyFunction = __webpack_require__(42);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(890);
	var ChangeEventPlugin = __webpack_require__(892);
	var ClientReactRootIndex = __webpack_require__(893);
	var DefaultEventPluginOrder = __webpack_require__(895);
	var EnterLeaveEventPlugin = __webpack_require__(896);
	var ExecutionEnvironment = __webpack_require__(30);
	var HTMLDOMPropertyConfig = __webpack_require__(899);
	var ReactBrowserComponentMixin = __webpack_require__(901);
	var ReactComponentBrowserEnvironment = __webpack_require__(196);
	var ReactDefaultBatchingStrategy = __webpack_require__(359);
	var ReactDOMComponent = __webpack_require__(905);
	var ReactDOMTextComponent = __webpack_require__(358);
	var ReactEventListener = __webpack_require__(913);
	var ReactInjection = __webpack_require__(914);
	var ReactInstanceHandles = __webpack_require__(81);
	var ReactMount = __webpack_require__(34);
	var ReactReconcileTransaction = __webpack_require__(918);
	var SelectEventPlugin = __webpack_require__(924);
	var ServerReactRootIndex = __webpack_require__(925);
	var SimpleEventPlugin = __webpack_require__(926);
	var SVGDOMPropertyConfig = __webpack_require__(923);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
	  ReactInjection.EventPluginHub.injectMount(ReactMount);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.RootIndex.injectCreateReactRootIndex(ExecutionEnvironment.canUseDOM ? ClientReactRootIndex.createReactRootIndex : ServerReactRootIndex.createReactRootIndex);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	
	  if (false) {
	    var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
	    if (/[?&]react_perf\b/.test(url)) {
	      var ReactDefaultPerf = require('./ReactDefaultPerf');
	      ReactDefaultPerf.start();
	    }
	  }
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(35);
	var ReactPropTypeLocations = __webpack_require__(128);
	var ReactPropTypeLocationNames = __webpack_require__(127);
	var ReactCurrentOwner = __webpack_require__(49);
	
	var canDefineProperty = __webpack_require__(131);
	var getIteratorFn = __webpack_require__(205);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(16);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
	  if (addenda === null) {
	    // we already showed the warning
	    return;
	  }
	   false ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : undefined;
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} messageType A key used for de-duping warnings.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 * @returns {?object} A set of addenda to use in the warning message, or null
	 * if the warning has already been shown before (and shouldn't be shown again).
	 */
	function getAddendaForKeyUse(messageType, element, parentType) {
	  var addendum = getDeclarationErrorAddendum();
	  if (!addendum) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      addendum = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	
	  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
	  if (memoizer[addendum]) {
	    return null;
	  }
	  memoizer[addendum] = true;
	
	  var addenda = {
	    parentOrOwner: addendum,
	    url: ' See https://fb.me/react-warning-keys for more information.',
	    childOwner: null
	  };
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	  return addenda;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	        error = propTypes[propName](props, propName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : undefined;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum();
	         false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	     false ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : undefined;
	  }
	}
	
	var ReactElementValidator = {
	
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	     false ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : undefined;
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (false) {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : undefined;
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.exports = ReactElementValidator;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(35);
	var ReactEmptyComponentRegistry = __webpack_require__(363);
	var ReactReconciler = __webpack_require__(67);
	
	var assign = __webpack_require__(17);
	
	var placeholderElement;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponent: function (component) {
	    placeholderElement = ReactElement.createElement(component);
	  }
	};
	
	function registerNullComponentID() {
	  ReactEmptyComponentRegistry.registerNullComponentID(this._rootNodeID);
	}
	
	var ReactEmptyComponent = function (instantiate) {
	  this._currentElement = null;
	  this._rootNodeID = null;
	  this._renderedComponent = instantiate(placeholderElement);
	};
	assign(ReactEmptyComponent.prototype, {
	  construct: function (element) {},
	  mountComponent: function (rootID, transaction, context) {
	    transaction.getReactMountReady().enqueue(registerNullComponentID, this);
	    this._rootNodeID = rootID;
	    return ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, context);
	  },
	  receiveComponent: function () {},
	  unmountComponent: function (rootID, transaction, context) {
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    ReactEmptyComponentRegistry.deregisterNullComponentID(this._rootNodeID);
	    this._rootNodeID = null;
	    this._renderedComponent = null;
	  }
	});
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 363 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponentRegistry
	 */
	
	'use strict';
	
	// This registry keeps track of the React IDs of the components that rendered to
	// `null` (in reality a placeholder such as `noscript`)
	var nullComponentIDsRegistry = {};
	
	/**
	 * @param {string} id Component's `_rootNodeID`.
	 * @return {boolean} True if the component is rendered to null.
	 */
	function isNullComponentID(id) {
	  return !!nullComponentIDsRegistry[id];
	}
	
	/**
	 * Mark the component as having rendered to null.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function registerNullComponentID(id) {
	  nullComponentIDsRegistry[id] = true;
	}
	
	/**
	 * Unmark the component as having rendered to null: it renders to something now.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function deregisterNullComponentID(id) {
	  delete nullComponentIDsRegistry[id];
	}
	
	var ReactEmptyComponentRegistry = {
	  isNullComponentID: isNullComponentID,
	  registerNullComponentID: registerNullComponentID,
	  deregisterNullComponentID: deregisterNullComponentID
	};
	
	module.exports = ReactEmptyComponentRegistry;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 * @typechecks
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(909);
	
	var containsNode = __webpack_require__(246);
	var focusNode = __webpack_require__(247);
	var getActiveElement = __webpack_require__(248);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (typeof end === 'undefined') {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(935);
	
	var TAG_END = /\/?>/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags and self-closing tags)
	    return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(105);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var assign = __webpack_require__(17);
	var invariant = __webpack_require__(14);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : undefined;
	  return new genericComponentClass(element.type, element.props);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.exports = ReactNativeComponent;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(16);
	
	function warnTDZ(publicInstance, callerName) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : undefined;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnTDZ(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnTDZ(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnTDZ(publicInstance, 'setState');
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    warnTDZ(publicInstance, 'setProps');
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    warnTDZ(publicInstance, 'replaceProps');
	  }
	
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(35);
	var ReactPropTypeLocationNames = __webpack_require__(127);
	
	var emptyFunction = __webpack_require__(42);
	var getIteratorFn = __webpack_require__(205);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (propValue === expectedValues[i]) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED') == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return '<<anonymous>>';
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 371 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactRootIndexInjection = {
	  /**
	   * @param {function} _createReactRootIndex
	   */
	  injectCreateReactRootIndex: function (_createReactRootIndex) {
	    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
	  }
	};
	
	var ReactRootIndex = {
	  createReactRootIndex: null,
	  injection: ReactRootIndexInjection
	};
	
	module.exports = ReactRootIndex;

/***/ },
/* 372 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : undefined;
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 374 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	var forEachAccumulated = function (arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.exports = forEachAccumulated;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 376 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.untouch = exports.touch = exports.swapArrayValues = exports.submitFailed = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.removeArrayValue = exports.initialize = exports.focus = exports.destroy = exports.change = exports.blur = exports.autofill = exports.addArrayValue = undefined;
	
	var _actionTypes = __webpack_require__(212);
	
	var _isFunction = __webpack_require__(956);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addArrayValue = exports.addArrayValue = function addArrayValue(path, value, index, fields) {
	  return { type: _actionTypes.ADD_ARRAY_VALUE, path: path, value: value, index: index, fields: fields };
	};
	
	var autofill = exports.autofill = function autofill(field, value) {
	  return { type: _actionTypes.AUTOFILL, field: field, value: value };
	};
	
	var blur = exports.blur = function blur(field, value) {
	  return { type: _actionTypes.BLUR, field: field, value: value };
	};
	
	var change = exports.change = function change(field, value) {
	  return { type: _actionTypes.CHANGE, field: field, value: value };
	};
	
	var destroy = exports.destroy = function destroy() {
	  return { type: _actionTypes.DESTROY };
	};
	
	var focus = exports.focus = function focus(field) {
	  return { type: _actionTypes.FOCUS, field: field };
	};
	
	var initialize = exports.initialize = function initialize(data, fields) {
	  var overwriteValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!Array.isArray(fields)) {
	    throw new Error('must provide fields array to initialize() action creator');
	  }
	  return { type: _actionTypes.INITIALIZE, data: data, fields: fields, overwriteValues: overwriteValues };
	};
	
	var removeArrayValue = exports.removeArrayValue = function removeArrayValue(path, indexOrPredicate) {
	  var index = void 0;
	  var predicate = void 0;
	
	  if ((0, _isFunction2.default)(indexOrPredicate)) {
	    predicate = indexOrPredicate;
	  } else {
	    index = indexOrPredicate;
	  }
	
	  return { type: _actionTypes.REMOVE_ARRAY_VALUE, path: path, index: index, predicate: predicate };
	};
	
	var reset = exports.reset = function reset() {
	  return { type: _actionTypes.RESET };
	};
	
	var startAsyncValidation = exports.startAsyncValidation = function startAsyncValidation(field) {
	  return { type: _actionTypes.START_ASYNC_VALIDATION, field: field };
	};
	
	var startSubmit = exports.startSubmit = function startSubmit() {
	  return { type: _actionTypes.START_SUBMIT };
	};
	
	var stopAsyncValidation = exports.stopAsyncValidation = function stopAsyncValidation(errors) {
	  return { type: _actionTypes.STOP_ASYNC_VALIDATION, errors: errors };
	};
	
	var stopSubmit = exports.stopSubmit = function stopSubmit(errors) {
	  return { type: _actionTypes.STOP_SUBMIT, errors: errors };
	};
	
	var submitFailed = exports.submitFailed = function submitFailed() {
	  return { type: _actionTypes.SUBMIT_FAILED };
	};
	
	var swapArrayValues = exports.swapArrayValues = function swapArrayValues(path, indexA, indexB) {
	  return { type: _actionTypes.SWAP_ARRAY_VALUES, path: path, indexA: indexA, indexB: indexB };
	};
	
	var touch = exports.touch = function touch() {
	  for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
	    fields[_key] = arguments[_key];
	  }
	
	  return { type: _actionTypes.TOUCH, fields: fields };
	};
	
	var untouch = exports.untouch = function untouch() {
	  for (var _len2 = arguments.length, fields = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    fields[_key2] = arguments[_key2];
	  }
	
	  return { type: _actionTypes.UNTOUCH, fields: fields };
	};

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = bindActionData;
	
	var _mapValues = __webpack_require__(213);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adds additional properties to the results of the function or map of functions passed
	 */
	function bindActionData(action, data) {
	  if (typeof action === 'function') {
	    return function () {
	      return _extends({}, action.apply(undefined, arguments), data);
	    };
	  }
	  if (typeof action === 'object') {
	    return (0, _mapValues2.default)(action, function (value) {
	      return bindActionData(value, data);
	    });
	  }
	  return action;
	}

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reducer = __webpack_require__(214);
	
	var _initializeState = __webpack_require__(388);
	
	var _initializeState2 = _interopRequireDefault(_initializeState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createInitialState = function createInitialState(data, fields, state) {
	  var _extends2;
	
	  var overwriteValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	  var markInitialized = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	
	  return _extends({}, (0, _initializeState2.default)(data, fields, state, overwriteValues), (_extends2 = {
	    _initData: data,
	    _asyncValidating: false,
	    _active: undefined
	  }, _extends2[_reducer.globalErrorKey] = undefined, _extends2._initialized = markInitialized, _extends2._submitting = false, _extends2._submitFailed = false, _extends2));
	};
	
	exports.default = createInitialState;

/***/ },
/* 380 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var dataKey = exports.dataKey = 'value';
	var createOnDragStart = function createOnDragStart(name, getValue) {
	  return function (event) {
	    event.dataTransfer.setData(dataKey, getValue());
	  };
	};
	
	exports.default = createOnDragStart;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isEvent = __webpack_require__(382);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	  return result;
	};
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent2.default)(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	    var _event$target = event.target,
	        type = _event$target.type,
	        value = _event$target.value,
	        checked = _event$target.checked,
	        files = _event$target.files,
	        dataTransfer = event.dataTransfer;
	
	    if (type === 'checkbox') {
	      return checked;
	    }
	    if (type === 'radio') {
	      return checked ? value : '';
	    }
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	    if (value !== '' && (type === 'number' || type === 'range')) {
	      return parseFloat(value);
	    }
	    return value;
	  }
	  // not an event, so must be either our value or an object containing our value in the 'value' key
	  return event && typeof event === 'object' && Object.keys(event).length === 1 && event.value !== undefined ? event.value : // extract value from { value: value } structure. https://github.com/nikgraf/belle/issues/58
	  event;
	};
	
	exports.default = getValue;

/***/ },
/* 382 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	exports.default = isEvent;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isEvent = __webpack_require__(382);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent2.default)(event);
	  if (is) {
	    event.preventDefault();
	  }
	  return is;
	};
	
	exports.default = silenceEvent;

/***/ },
/* 384 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getDisplayName;
	function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	}

/***/ },
/* 385 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Given a state[field], get the value.
	 *  Fallback to .initialValue when .value is undefined to prevent double render/initialize cycle.
	 *  See {@link https://github.com/erikras/redux-form/issues/621}.
	 */
	var itemToValue = function itemToValue(_ref) {
	  var value = _ref.value,
	      initialValue = _ref.initialValue;
	  return typeof value !== 'undefined' ? value : initialValue;
	};
	
	var getValue = function getValue(field, state, dest) {
	  var dotIndex = field.indexOf('.');
	  var openIndex = field.indexOf('[');
	  var closeIndex = field.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    // array field
	    var key = field.substring(0, openIndex);
	    var rest = field.substring(closeIndex + 1);
	    if (rest[0] === '.') {
	      rest = rest.substring(1);
	    }
	    var array = state && state[key] || [];
	    if (rest) {
	      if (!dest[key]) {
	        dest[key] = [];
	      }
	      array.forEach(function (item, index) {
	        if (!dest[key][index]) {
	          dest[key][index] = {};
	        }
	        getValue(rest, item, dest[key][index]);
	      });
	    } else {
	      dest[key] = array.map(itemToValue);
	    }
	  } else if (dotIndex > 0) {
	    // subobject field
	    var _key = field.substring(0, dotIndex);
	    var _rest = field.substring(dotIndex + 1);
	    if (!dest[_key]) {
	      dest[_key] = {};
	    }
	    getValue(_rest, state && state[_key] || {}, dest[_key]);
	  } else {
	    dest[field] = state[field] && itemToValue(state[field]);
	  }
	};
	
	var getValues = function getValues(fields, state) {
	  return fields.reduce(function (accumulator, field) {
	    getValue(field, state, accumulator);
	    return accumulator;
	  }, {});
	};
	
	exports.default = getValues;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _fieldValue = __webpack_require__(82);
	
	/**
	 * A different version of getValues() that does not need the fields array
	 */
	var getValuesFromState = function getValuesFromState(state) {
	  if (!state) {
	    return state;
	  }
	  var keys = Object.keys(state);
	  if (!keys.length) {
	    return undefined;
	  }
	  return keys.reduce(function (accumulator, key) {
	    var field = state[key];
	    if (field) {
	      if ((0, _fieldValue.isFieldValue)(field)) {
	        if (field.value !== undefined) {
	          accumulator[key] = field.value;
	        }
	      } else if (Array.isArray(field)) {
	        accumulator[key] = field.map(function (arrayField) {
	          return (0, _fieldValue.isFieldValue)(arrayField) ? arrayField.value : getValuesFromState(arrayField);
	        });
	      } else if (typeof field === 'object') {
	        var result = getValuesFromState(field);
	
	        if (result && Object.keys(result).length > 0) {
	          accumulator[key] = result;
	        }
	      }
	    }
	    return accumulator;
	  }, {});
	};
	
	exports.default = getValuesFromState;

/***/ },
/* 387 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fieldValue = __webpack_require__(82);
	
	var makeEntry = function makeEntry(value, previousValue, overwriteValues) {
	  if (value === undefined && previousValue === undefined) return (0, _fieldValue.makeFieldValue)({});
	  return (0, _fieldValue.makeFieldValue)({
	    initial: value,
	    value: overwriteValues ? value : previousValue
	  });
	};
	
	/**
	 * Sets the initial values into the state and returns a new copy of the state
	 */
	var initializeState = function initializeState(values, fields) {
	  var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var overwriteValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  if (!fields) {
	    throw new Error('fields must be passed when initializing state');
	  }
	  if (!values || !fields.length) {
	    return state;
	  }
	  var initializeField = function initializeField(path, src, dest) {
	    var dotIndex = path.indexOf('.');
	    if (dotIndex === 0) {
	      return initializeField(path.substring(1), src, dest);
	    }
	    var openIndex = path.indexOf('[');
	    var closeIndex = path.indexOf(']');
	    var result = _extends({}, dest) || {};
	    if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	      // is dot notation
	      var key = path.substring(0, dotIndex);
	      result[key] = src[key] && initializeField(path.substring(dotIndex + 1), src[key], result[key] || {});
	    } else if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	      // is array notation
	      if (closeIndex < 0) {
	        throw new Error('found \'[\' but no \']\': \'' + path + '\'');
	      }
	      var _key = path.substring(0, openIndex);
	      var srcArray = src[_key];
	      var destArray = result[_key];
	      var rest = path.substring(closeIndex + 1);
	      if (Array.isArray(srcArray)) {
	        if (rest.length) {
	          // need to keep recursing
	          result[_key] = srcArray.map(function (srcValue, srcIndex) {
	            return initializeField(rest, srcValue, destArray && destArray[srcIndex]);
	          });
	        } else {
	          result[_key] = srcArray.map(function (srcValue, srcIndex) {
	            return makeEntry(srcValue, destArray && destArray[srcIndex] && destArray[srcIndex].value, overwriteValues);
	          });
	        }
	      } else {
	        result[_key] = [];
	      }
	    } else {
	      result[path] = makeEntry(src && src[path], dest && dest[path] && dest[path].value, overwriteValues);
	    }
	    return result;
	  };
	  return fields.reduce(function (accumulator, field) {
	    return initializeField(field, values, accumulator);
	  }, _extends({}, state));
	};
	
	exports.default = initializeState;

/***/ },
/* 389 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isChecked = function isChecked(value) {
	  if (typeof value === 'boolean') {
	    return value;
	  }
	  if (typeof value === 'string') {
	    var lower = value.toLowerCase();
	    if (lower === 'true') {
	      return true;
	    }
	    if (lower === 'false') {
	      return false;
	    }
	  }
	  return undefined;
	};
	
	exports.default = isChecked;

/***/ },
/* 390 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Reads any potentially deep value from an object using dot and array syntax
	 */
	var read = function read(path, object) {
	  if (!path || !object) {
	    return object;
	  }
	  var dotIndex = path.indexOf('.');
	  if (dotIndex === 0) {
	    return read(path.substring(1), object);
	  }
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	    // iterate down object tree
	    return read(path.substring(dotIndex + 1), object[path.substring(0, dotIndex)]);
	  }
	  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    if (closeIndex < 0) {
	      throw new Error('found [ but no ]');
	    }
	    var key = path.substring(0, openIndex);
	    var index = path.substring(openIndex + 1, closeIndex);
	    if (!index.length) {
	      return object[key];
	    }
	    if (openIndex === 0) {
	      return read(path.substring(closeIndex + 1), object[index]);
	    }
	    if (!object[key]) {
	      return undefined;
	    }
	    return read(path.substring(closeIndex + 1), object[key][index]);
	  }
	  return object[path];
	};
	
	exports.default = read;

/***/ },
/* 391 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Writes any potentially deep value from an object using dot and array syntax,
	 * and returns a new copy of the object.
	 */
	var write = function write(path, value, object) {
	  var _extends7;
	
	  var dotIndex = path.indexOf('.');
	  if (dotIndex === 0) {
	    return write(path.substring(1), value, object);
	  }
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	    var _extends2;
	
	    // is dot notation
	    var key = path.substring(0, dotIndex);
	    return _extends({}, object, (_extends2 = {}, _extends2[key] = write(path.substring(dotIndex + 1), value, object[key] || {}), _extends2));
	  }
	  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    var _extends6;
	
	    // is array notation
	    if (closeIndex < 0) {
	      throw new Error('found [ but no ]');
	    }
	    var _key = path.substring(0, openIndex);
	    var index = path.substring(openIndex + 1, closeIndex);
	    var array = object[_key] || [];
	    var rest = path.substring(closeIndex + 1);
	    if (index) {
	      var _extends4;
	
	      // indexed array
	      if (rest.length) {
	        var _extends3;
	
	        // need to keep recursing
	        var dest = array[index] || {};
	        var arrayCopy = [].concat(array);
	        arrayCopy[index] = write(rest, value, dest);
	        return _extends({}, object || {}, (_extends3 = {}, _extends3[_key] = arrayCopy, _extends3));
	      }
	      var copy = [].concat(array);
	      copy[index] = typeof value === 'function' ? value(copy[index]) : value;
	      return _extends({}, object || {}, (_extends4 = {}, _extends4[_key] = copy, _extends4));
	    }
	    // indexless array
	    if (rest.length) {
	      var _extends5;
	
	      // need to keep recursing
	      if ((!array || !array.length) && typeof value === 'function') {
	        return object; // don't even set a value under [key]
	      }
	      var _arrayCopy = array.map(function (dest) {
	        return write(rest, value, dest);
	      });
	      return _extends({}, object || {}, (_extends5 = {}, _extends5[_key] = _arrayCopy, _extends5));
	    }
	    var result = void 0;
	    if (Array.isArray(value)) {
	      result = value;
	    } else if (object[_key]) {
	      result = array.map(function (dest) {
	        return typeof value === 'function' ? value(dest) : value;
	      });
	    } else if (typeof value === 'function') {
	      return object; // don't even set a value under [key]
	    } else {
	      result = value;
	    }
	    return _extends({}, object || {}, (_extends6 = {}, _extends6[_key] = result, _extends6));
	  }
	  return _extends({}, object, (_extends7 = {}, _extends7[path] = typeof value === 'function' ? value(object[path]) : value, _extends7));
	};
	
	exports.default = write;

/***/ },
/* 392 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(396);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(987);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 394 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 395 */
[997, 979],
/* 396 */
[1002, 973, 975, 980],
/* 397 */
/***/ function(module, exports) {

	'use strict';
	
	var $Object = Object;
	var $TypeError = TypeError;
	
	module.exports = function flags() {
		if (this != null && this !== $Object(this)) {
			throw new $TypeError('RegExp.prototype.flags getter called on non-object');
		}
		var result = '';
		if (this.global) {
			result += 'g';
		}
		if (this.ignoreCase) {
			result += 'i';
		}
		if (this.multiline) {
			result += 'm';
		}
		if (this.dotAll) {
			result += 's';
		}
		if (this.unicode) {
			result += 'u';
		}
		if (this.sticky) {
			result += 'y';
		}
		return result;
	};


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(397);
	
	var supportsDescriptors = __webpack_require__(88).supportsDescriptors;
	var $gOPD = Object.getOwnPropertyDescriptor;
	var $TypeError = TypeError;
	
	module.exports = function getPolyfill() {
		if (!supportsDescriptors) {
			throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		if ((/a/mig).flags === 'gim') {
			var descriptor = $gOPD(RegExp.prototype, 'flags');
			if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
				return descriptor.get;
			}
		}
		return implementation;
	};


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(713).enable();
	  window.Promise = __webpack_require__(712);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(992);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(708);


/***/ },
/* 400 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 401 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var objectAssign = __webpack_require__(404);
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	// NB: The URL to the CommonJS spec is kept just for tradition.
	//     node-assert has evolved a lot since then, both in API and behavior.
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(406);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	// Expose a strict only variant of assert
	function strict(value, message) {
	  if (!value) fail(value, true, message, '==', strict);
	}
	assert.strict = objectAssign(strict, assert, {
	  equal: assert.strictEqual,
	  deepEqual: assert.deepStrictEqual,
	  notEqual: assert.notStrictEqual,
	  notDeepEqual: assert.notDeepStrictEqual
	});
	assert.strict.strict = assert.strict;
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 403 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 404 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 405 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(405);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(403);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(173)))

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(410);
	var utils = __webpack_require__(44);
	var dispatchRequest = __webpack_require__(409);
	var InterceptorManager = __webpack_require__(408);
	var isAbsoluteURL = __webpack_require__(416);
	var combineURLs = __webpack_require__(414);
	var bind = __webpack_require__(411);
	var transformData = __webpack_require__(217);
	
	function Axios(defaultConfig) {
	  this.defaults = utils.merge({}, defaultConfig);
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Don't allow overriding defaults.withCredentials
	  config.withCredentials = config.withCredentials || this.defaults.withCredentials;
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	var defaultInstance = new Axios(defaults);
	var axios = module.exports = bind(Axios.prototype.request, defaultInstance);
	
	axios.create = function create(defaultConfig) {
	  return new Axios(defaultConfig);
	};
	
	// Expose defaults
	axios.defaults = defaultInstance.defaults;
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(419);
	
	// Expose interceptors
	axios.interceptors = defaultInstance.interceptors;
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	  axios[method] = bind(Axios.prototype[method], defaultInstance);
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	  axios[method] = bind(Axios.prototype[method], defaultInstance);
	});


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	/**
	 * Dispatch a request to the server using whichever adapter
	 * is supported by the current environment.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  return new Promise(function executor(resolve, reject) {
	    try {
	      var adapter;
	
	      if (typeof config.adapter === 'function') {
	        // For custom adapter support
	        adapter = config.adapter;
	      } else if (typeof XMLHttpRequest !== 'undefined') {
	        // For browsers use XHR adapter
	        adapter = __webpack_require__(216);
	      } else if (typeof process !== 'undefined') {
	        // For node use HTTP adapter
	        adapter = __webpack_require__(216);
	      }
	
	      if (typeof adapter === 'function') {
	        adapter(resolve, reject, config);
	      }
	    } catch (e) {
	      reject(e);
	    }
	  });
	};
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(173)))

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	module.exports = {
	  transformRequest: [function transformResponseJSON(data, headers) {
	    if (utils.isFormData(data)) {
	      return data;
	    }
	    if (utils.isArrayBuffer(data)) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isObject(data) && !utils.isFile(data) && !utils.isBlob(data)) {
	      // Set application/json if no Content-Type has been specified
	      if (!utils.isUndefined(headers)) {
	        utils.forEach(headers, function processContentTypeHeader(val, key) {
	          if (key.toLowerCase() === 'content-type') {
	            headers['Content-Type'] = val;
	          }
	        });
	
	        if (utils.isUndefined(headers['Content-Type'])) {
	          headers['Content-Type'] = 'application/json;charset=utf-8';
	        }
	      }
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponseJSON(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    },
	    patch: utils.merge(DEFAULT_CONTENT_TYPE),
	    post: utils.merge(DEFAULT_CONTENT_TYPE),
	    put: utils.merge(DEFAULT_CONTENT_TYPE)
	  },
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN'
	};


/***/ },
/* 411 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 412 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function InvalidCharacterError(message) {
	  this.message = message;
	}
	InvalidCharacterError.prototype = new Error;
	InvalidCharacterError.prototype.code = 5;
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new InvalidCharacterError('INVALID_CHARACTER_ERR: DOM Exception 5');
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};
	


/***/ },
/* 414 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 416 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(44);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 419 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WebHeaderHome = __webpack_require__(449);
	
	var _WebHeaderHome2 = _interopRequireDefault(_WebHeaderHome);
	
	var _WebTrendings = __webpack_require__(487);
	
	var _WebTrendings2 = _interopRequireDefault(_WebTrendings);
	
	var _WebStoreBlocks = __webpack_require__(484);
	
	var _WebStoreBlocks2 = _interopRequireDefault(_WebStoreBlocks);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _WebCategories = __webpack_require__(448);
	
	var _WebCategories2 = _interopRequireDefault(_WebCategories);
	
	var _WebBrandStoreBlocks = __webpack_require__(483);
	
	var _WebBrandStoreBlocks2 = _interopRequireDefault(_WebBrandStoreBlocks);
	
	var _WebPromotions = __webpack_require__(220);
	
	var _WebPromotions2 = _interopRequireDefault(_WebPromotions);
	
	var _WebRecommended = __webpack_require__(475);
	
	var _WebRecommended2 = _interopRequireDefault(_WebRecommended);
	
	var _WebAdAssist = __webpack_require__(446);
	
	var _WebAdAssist2 = _interopRequireDefault(_WebAdAssist);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Web_App = function (_Component) {
		_inherits(Web_App, _Component);
	
		function Web_App(props) {
			_classCallCheck(this, Web_App);
	
			var _this = _possibleConstructorReturn(this, (Web_App.__proto__ || Object.getPrototypeOf(Web_App)).call(this, props));
	
			_this.dashBoard = _this.dashBoard.bind(_this);
			return _this;
		}
	
		_createClass(Web_App, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width < 800) {
					window.location.href = "/home";
				}
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
				localStorage.removeItem('checkout');
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
				localStorage.removeItem('web_quickcart');
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
				localStorage.removeItem('web_brand_details');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
	
				localStorage.removeItem('brand');
				localStorage.removeItem('d_type');
				localStorage.removeItem('Tid');
				localStorage.removeItem('type');
	
				if (localStorage.user_id && localStorage.token) {
					this.dashBoard();
				}
			}
		}, {
			key: 'dashBoard',
			value: function dashBoard() {
				var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'dashboard',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = "Online AquaCulture MarketPlace, Find best deals on Seed, Feed, Health Care, Machinery & Farm Equipments, Products, Ropes & Nets Paddle Wheels and More | AquaDeals";
				document.getElementsByTagName("META")[2].content = "It is a place for deals related to Aqua culture";
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_WebHeaderHome2.default, null),
					_react2.default.createElement(_WebTrendings2.default, null),
					_react2.default.createElement(_WebStoreBlocks2.default, null),
					_react2.default.createElement(_WebBrandStoreBlocks2.default, null),
					_react2.default.createElement(_WebCategories2.default, null),
					_react2.default.createElement(_WebAdAssist2.default, null),
					_react2.default.createElement(_WebRecommended2.default, null),
					_react2.default.createElement(_WebPromotions2.default, null),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_App;
	}(_react.Component);
	
	exports.default = Web_App;

/***/ },
/* 421 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var AUTH_USER = exports.AUTH_USER = "AUTH_USER";
	var LOGOUT_USER = exports.LOGOUT_USER = "LOGOUT_USER";
	var AUTH_ERROR = exports.AUTH_ERROR = "AUTH_ERROR";
	var FETCH_POST = exports.FETCH_POST = "FETCH_POST";
	var ADD_POST = exports.ADD_POST = "ADD_POST";
	var POST_SHOW = exports.POST_SHOW = "POST_SHOW";
	var DELETE_POST = exports.DELETE_POST = "DELETE_POST";
	var EDIT_POST = exports.EDIT_POST = "EDIT_POST";
	var UPDATE_POST = exports.UPDATE_POST = "UPDATE_POST";
	var FETCH_USER = exports.FETCH_USER = "FETCH_USER";
	var FETCH_PEOPLE = exports.FETCH_PEOPLE = "FETCH_PEOPLE";
	var FETCH_UPLOADS = exports.FETCH_UPLOADS = "FETCH_UPLOADS";
	var ADD_IMGS = exports.ADD_IMGS = "ADD_IMGS";
	var FETCH_IMGS = exports.FETCH_IMGS = "FETCH_IMGS";
	var FETCH_ADS = exports.FETCH_ADS = "FETCH_ADS";
	var FETCH_PROMO_ADS = exports.FETCH_PROMO_ADS = "FETCH_PROMO_ADS";
	var FETCH_SEARCH = exports.FETCH_SEARCH = "FETCH_SEARCH";
	var FETCH_TRENDS = exports.FETCH_TRENDS = "FETCH_TRENDS";
	var FETCH_LEADS = exports.FETCH_LEADS = "FETCH_LEADS";
	var FETCH_LEADS_C = exports.FETCH_LEADS_C = "FETCH_LEADS_C";
	var AUTH_LOG = exports.AUTH_LOG = "AUTH_LOG";
	var CARTCOUNT = exports.CARTCOUNT = "CARTCOUNT";
	var FETCH_RZP_KEYS = exports.FETCH_RZP_KEYS = "FETCH_RZP_KEYS";
	var FETCH_RECENT = exports.FETCH_RECENT = "FETCH_RECENT";
	var FETCH_PRODUCT_TABS = exports.FETCH_PRODUCT_TABS = "FETCH_PRODUCT_TABS";
	var FETCH_PRODUCT_DESC = exports.FETCH_PRODUCT_DESC = "FETCH_PRODUCT_DESC";

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactStars = __webpack_require__(33);
	
	var _reactStars2 = _interopRequireDefault(_reactStars);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Web_GiveRatings = function (_Component) {
		_inherits(Web_GiveRatings, _Component);
	
		function Web_GiveRatings(props) {
			_classCallCheck(this, Web_GiveRatings);
	
			var _this = _possibleConstructorReturn(this, (Web_GiveRatings.__proto__ || Object.getPrototypeOf(Web_GiveRatings)).call(this, props));
	
			_this.state = {
				seed_rate: 0,
				over_rate: 0,
				serv_rate: 0,
				pack_rate: 0,
				recomend: true,
				seller: localStorage.getItem('seller'),
				book_date: localStorage.getItem('book_date'),
				nodata_status: false,
				successRating: false
				// this.getSeedDetails=this.getSeedDetails.bind(this);
				// this.getProductDetails=this.getProductDetails.bind(this);
			};_this.over_rateChanged = _this.over_rateChanged.bind(_this);
			_this.seed_rateChanged = _this.seed_rateChanged.bind(_this);
			_this.serv_rateChanged = _this.serv_rateChanged.bind(_this);
			_this.pack_rateChanged = _this.pack_rateChanged.bind(_this);
			_this.handleChange = _this.handleChange.bind(_this);
			_this.getRatingDetails = _this.getRatingDetails.bind(_this);
			_this.close = _this.close.bind(_this);
			return _this;
		}
	
		_createClass(Web_GiveRatings, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (!localStorage.token && !localStorage.user_id) {
					if (this.props.params.Product === 'product') {
						localStorage.setItem('give_rating', '/web/giverating/' + this.props.params.Product + '/' + this.props.params.Bid);
						_reactRouter.browserHistory.push('/web/login');
					} else {
						localStorage.setItem('give_rating', '/web/giverating/' + this.props.params.Bid);
						_reactRouter.browserHistory.push('/web/login');
					}
				} else {
					this.getRatingDetails();
				}
				if (screen.width < 800) {
					if (this.props.params.Product === 'product') {
						window.location.href = "/giverating/" + this.props.params.Product + '/' + this.props.params.Bid;
					} else {
						window.location.href = "/giverating/" + this.props.params.Bid;
					}
				}
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					successRating: false
				});
			}
		}, {
			key: 'getRatingDetails',
			value: function getRatingDetails() {
				if (this.props.params.Product === 'product') {
					var type = 1;
				} else {
					type = 0;
				}
				var data1 = { from: 'desktop_web', uid: localStorage.user_id, token: localStorage.token, type: type, bid: this.props.params.Bid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'pre_rate_info',
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								seller: data.seller_name,
								book_date: data.created_on
							});
						} else {
							this.setState({
								nodata_status: true
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'over_rateChanged',
			value: function over_rateChanged(newRating) {
				// console.log(newRating);
				this.setState({
					over_rate: newRating
				});
			}
		}, {
			key: 'seed_rateChanged',
			value: function seed_rateChanged(newRating) {
				// console.log(newRating);
				this.setState({
					seed_rate: newRating
				});
			}
		}, {
			key: 'serv_rateChanged',
			value: function serv_rateChanged(newRating) {
				// console.log(newRating);
				this.setState({
					serv_rate: newRating
				});
			}
		}, {
			key: 'pack_rateChanged',
			value: function pack_rateChanged(newRating) {
				// console.log(newRating);
				this.setState({
					pack_rate: newRating
				});
			}
		}, {
			key: 'handleChange',
			value: function handleChange() {
				this.setState({
					recomend: !this.state.recomend
				});
			}
		}, {
			key: 'submitRatings',
			value: function submitRatings() {
				// saveRatings(id,token,vid,deal_id,ser_qlty,seed_qlty,pack_qlty,book_id,overall,recomend)
	
				if (localStorage.vid) {
					var vid = localStorage.getItem('vid');
				} else {
					vid = '';
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
	
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				if (this.props.params.Product === 'product') {
					var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, book_id: this.props.params.Bid, product_id: localStorage.product_id, ser_qlty: this.state.serv_rate, product_qlt: this.state.seed_rate, pack_qlty: this.state.pack_rate, overall: this.state.over_rate, recomend: this.state.recomend, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'savepro_ratings',
						success: function (data) {
							if (data.status === 'ok') {
								this.setState({
									successRating: true
								});
								// alert("Thanks for Rating");
								_reactRouter.browserHistory.push('/web/myorders');
							}
						}.bind(this),
						error: function error(err) {
							// console.log(err);
						}
					});
				} else {
					data1 = { from: 'desktop_web', id: uid, token: localStorage.token, vid: vid, deal_id: '', ser_qlty: this.state.serv_rate, seed_qlty: this.state.seed_rate, pack_qlty: this.state.pack_rate, book_id: this.props.params.Bid, overall: this.state.over_rate, recomend: this.state.recomend, source: source, campaign: campaign, url_id: url_id };
					data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'saveRatings',
						success: function (data) {
							if (data.status === 'ok') {
								this.setState({
									successRating: true
								});
								// alert("Thanks for Rating");
								_reactRouter.browserHistory.push('/web/myorders');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				document.title = this.props.params.Product === 'product' ? 'Give Product Ratings | AquaDeals' : 'Give Hatchery Ratings | AquaDeals';
				(0, _jquery2.default)('body').css('background', '#f1f1f2');
				// $(window).scrollTop(0);
				var over_rate = _react2.default.createElement(_reactStars2.default, {
					className: 'rate_dtls_item',
					count: 5,
					onChange: this.over_rateChanged,
					size: 20,
					value: this.state.over_rate
					// color1={'#F3F3F3'}
					, color2: '#ffc50a' });
				var serv_rate = _react2.default.createElement(_reactStars2.default, {
					className: 'rate_dtls_item',
					count: 5,
					onChange: this.serv_rateChanged,
					size: 20,
					value: this.state.serv_rate
					// color1={'#F3F3F3'}
					, color2: '#ffc50a' });
				var seed_rate = _react2.default.createElement(_reactStars2.default, {
					className: 'rate_dtls_item',
					count: 5,
					onChange: this.seed_rateChanged,
					size: 20,
					value: this.state.seed_rate
					// color1={'#F3F3F3'}
					, color2: '#ffc50a' });
				var pack_rate = _react2.default.createElement(_reactStars2.default, {
					className: 'rate_dtls_item',
					count: 5,
					onChange: this.pack_rateChanged,
					size: 20,
					value: this.state.pack_rate
					// color1={'#F3F3F3'}
					, color2: '#ffc50a' });
	
				var switch_btn = _react2.default.createElement(
					'div',
					{ className: 'webswitch-container custom_switch_blk' },
					_react2.default.createElement(
						'label',
						null,
						_react2.default.createElement('input', { ref: 'switch', checked: this.state.recomend, onChange: this.handleChange, className: this.state.recomend ? "webswitch active" : "webswitch", type: 'checkbox' }),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'span',
								null,
								_react2.default.createElement('g', { className: 'icon icon-toolbar grid-view' })
							),
							_react2.default.createElement(
								'span',
								null,
								_react2.default.createElement('g', { className: 'icon icon-toolbar ticket-view' })
							),
							_react2.default.createElement('div', null)
						)
					)
				);
				return _react2.default.createElement(
					'div',
					{ className: 'web_Deals web_giverating_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'container web_givRat_container' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12 webDels_cntnt' },
								this.state.nodata_status ? _react2.default.createElement(
									'section',
									null,
									_react2.default.createElement(
										'div',
										{ className: 'web_unauth_blk' },
										_react2.default.createElement(
											'h4',
											null,
											'You are not authorized !'
										),
										_react2.default.createElement(
											'a',
											{ href: '/web/login', className: 'web_link_btn' },
											'Sign in Here'
										)
									)
								) : _react2.default.createElement(
									'section',
									{ className: 'web_give_rate_blk' },
									_react2.default.createElement(
										'div',
										{ className: 'container-fluid row' },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-4 col-lg-4 col-sm-4 col-xs-4' },
											_react2.default.createElement('img', { src: baseAssets + 'images/promo_offers/20170310100146779139.png', alt: '' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-8 col-sm-8 col-md-8 col-lg-8' },
											_react2.default.createElement(
												'h4',
												{ className: 'web_giverate_title' },
												this.props.params.Product === 'product' ? 'Give Product Ratings' : 'Give Hatchery Ratings'
											),
											_react2.default.createElement(
												'div',
												{ className: 'from_dtls_blk' },
												_react2.default.createElement(
													'p',
													{ className: 'giverate_frm' },
													'FROM'
												),
												this.state.seller ? _react2.default.createElement(
													'p',
													null,
													this.state.seller
												) : _react2.default.createElement(
													'p',
													null,
													'\xA0'
												),
												_react2.default.createElement(
													'p',
													null,
													'ORDER DATE'
												),
												this.state.book_date ? _react2.default.createElement(
													'p',
													null,
													this.state.book_date
												) : _react2.default.createElement(
													'p',
													null,
													'\xA0'
												)
											),
											_react2.default.createElement(
												'div',
												{ style: { marginTop: '10px', fontSize: '12px' } },
												_react2.default.createElement(
													'div',
													{ className: 'rating_list_blk' },
													_react2.default.createElement(
														'div',
														{ className: 'rating_list_item' },
														_react2.default.createElement(
															'span',
															{ style: { float: 'left' } },
															'Overall Rating'
														),
														over_rate
													),
													_react2.default.createElement(
														'div',
														{ className: 'rating_list_item' },
														_react2.default.createElement(
															'span',
															{ style: { float: 'left' } },
															'Service Quality'
														),
														serv_rate
													),
													_react2.default.createElement(
														'div',
														{ className: 'rating_list_item' },
														_react2.default.createElement(
															'span',
															{ style: { float: 'left' } },
															this.props.params.Product === 'product' ? 'Product Quality' : 'Seed Quality'
														),
														seed_rate
													),
													_react2.default.createElement(
														'div',
														{ className: 'rating_list_item' },
														_react2.default.createElement(
															'span',
															{ style: { float: 'left' } },
															'Packing Quality'
														),
														pack_rate
													)
												)
											),
											_react2.default.createElement(
												'section',
												{ style: { marginTop: '10px' } },
												this.state.recomend === true ? _react2.default.createElement(
													'div',
													{ className: 'rate_rec_blk' },
													_react2.default.createElement(
														'span',
														{ style: { width: '75%', display: 'block' } },
														this.props.params.Product === 'product' ? 'I recommended this product to other customers' : 'I recommended this hatchery to other customers'
													),
													_react2.default.createElement(
														'span',
														null,
														switch_btn
													)
												) : _react2.default.createElement(
													'div',
													{ className: 'rate_rec_blk' },
													_react2.default.createElement(
														'span',
														{ style: { width: '75%', display: 'block' } },
														this.props.params.Product === 'product' ? 'I recommended this product to other customers' : 'I recommended this hatchery to other customers'
													),
													_react2.default.createElement(
														'span',
														null,
														switch_btn
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'text-right' },
												_react2.default.createElement(
													'button',
													{ className: 'save_rating_btn', onClick: function onClick() {
															_this2.submitRatings();
														} },
													'SUBMIT'
												)
											)
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: 'showModal', show: this.state.successRating, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'h4',
											{ style: { fontSize: '14px', color: '#666', textAlign: 'center' } },
											'Thanks for Rating'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_GiveRatings;
	}(_react.Component);
	
	exports.default = Web_GiveRatings;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Web_MyAquaCash = function (_Component) {
		_inherits(Web_MyAquaCash, _Component);
	
		function Web_MyAquaCash(props) {
			_classCallCheck(this, Web_MyAquaCash);
	
			var _this = _possibleConstructorReturn(this, (Web_MyAquaCash.__proto__ || Object.getPrototypeOf(Web_MyAquaCash)).call(this, props));
	
			_this.state = {
				loading: false,
				balance: '',
				transactions: [],
	
				title: '',
				subtitle: '',
				type: '',
				date: '',
				amount: '',
				sign: '',
				modal_status: false,
				deleteModal_status: false,
				deleteAll_modal_status: false
			};
			_this.transactionDetails = _this.transactionDetails.bind(_this);
			_this.aquacash_Modal = _this.aquacash_Modal.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.deleteSingle_AquaCash = _this.deleteSingle_AquaCash.bind(_this);
			_this.deleteSingleAc = _this.deleteSingleAc.bind(_this);
			_this.deleteallAC = _this.deleteallAC.bind(_this);
			_this.deleteAll = _this.deleteAll.bind(_this);
			return _this;
		}
	
		_createClass(Web_MyAquaCash, [{
			key: 'transactionDetails',
			value: function transactionDetails() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token'), device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'aquaCash',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							loading: true,
							balance: data.balance,
							transactions: data.transactions
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'aquacash_Modal',
			value: function aquacash_Modal(title, subtitle, amount, sign, type, date) {
				this.setState({
					modal_status: true,
					title: title,
					subtitle: subtitle,
					type: type,
					date: date,
					amount: amount,
					sign: sign
				});
			}
		}, {
			key: 'deleteallAC',
			value: function deleteallAC() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', uid: uid, token: localStorage.token };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					url: baseUrl + 'deleteAquacash_user',
					method: 'POST',
					dataType: 'JSON',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({ deleteAll_modal_status: false });
							this.transactionDetails();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'deleteSingle_AquaCash',
			value: function deleteSingle_AquaCash(id) {
				this.setState({
					aquaCash_id: id,
					deleteModal_status: true
				});
			}
		}, {
			key: 'deleteAll',
			value: function deleteAll() {
				this.setState({
					deleteAll_modal_status: true
				});
			}
		}, {
			key: 'deleteSingleAc',
			value: function deleteSingleAc(acid) {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', uid: uid, token: localStorage.token, aquacash_id: acid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					url: baseUrl + 'deleteAquacash',
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({ deleteModal_status: false });
							this.transactionDetails();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
	
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
	
				localStorage.removeItem('web_share_earn');
				localStorage.removeItem('checkout');
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
				localStorage.removeItem('web_quickcart');
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_brand_details');
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
				localStorage.removeItem('web_smartcart');
	
				if (screen.width < 800) {
					window.location.href = "/myaquacash";
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('myaquacash', '/web/myaquacash');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					this.transactionDetails();
				}
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					modal_status: false,
					deleteModal_status: false,
					deleteAll_modal_status: false
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				document.title = "My AquaCash | AquaDeals";
				var transactions = this.state.transactions.map(function (data, index) {
					var _this2 = this;
	
					return _react2.default.createElement(
						'li',
						{ className: 'web_Myaquacash_Li', key: index },
						_react2.default.createElement(
							'div',
							{ className: 'row web_Myaquacash_Row no-gutters' },
							_react2.default.createElement(
								'div',
								{ onClick: function onClick() {
										_this2.aquacash_Modal(data.title, data.subtitle, data.amount, data.sign, data.type, data.date);
									} },
								_react2.default.createElement(
									'h5',
									{ className: 'col-md-5 col-sm-5' },
									data.title ? _react2.default.createElement(
										'span',
										{ className: 'web_Aquacash_Title' },
										data.title,
										'\xA0',
										data.subtitle ? _react2.default.createElement(
											'span',
											null,
											'(',
											data.subtitle,
											')'
										) : _react2.default.createElement(
											'span',
											null,
											'\xA0'
										)
									) : _react2.default.createElement(
										'span',
										null,
										'\xA0'
									)
								),
								_react2.default.createElement(
									'h5',
									{ className: 'webaquacash_date col-md-2 col-sm-2' },
									data.date
								),
								_react2.default.createElement(
									'h5',
									{ className: 'col-md-2 col-sm-2', style: { paddingLeft: '2px' } },
									data.type ? _react2.default.createElement(
										'span',
										{ className: data.type === 'Used' ? "web_Aquacash_Type red" : "web_Aquacash_Type green" },
										data.type
									) : _react2.default.createElement(
										'span',
										null,
										'\xA0'
									)
								),
								_react2.default.createElement(
									'h5',
									{ className: 'col-md-2 col-sm-2', style: { paddingLeft: 0 } },
									data.amount ? _react2.default.createElement(
										'span',
										{ className: 'pull-left' },
										data.sign === '+' ? _react2.default.createElement(
											'span',
											{ className: 'green' },
											'(Cr)'
										) : _react2.default.createElement(
											'span',
											{ className: 'red' },
											'(Dr)'
										),
										' \u20B9 ',
										data.amount
									) : _react2.default.createElement(
										'span',
										{ className: 'pull-left' },
										'\xA0'
									)
								)
							),
							_react2.default.createElement(
								'i',
								{ style: { marginRight: '15px' }, onClick: function onClick() {
										_this2.deleteSingle_AquaCash(data.id);
									} },
								_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/close_icon1.png', width: '13px', alt: '' })
							)
						)
					);
				}.bind(this));
	
				return _react2.default.createElement(
					'div',
					{ className: 'web_Deals web_aquacash_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'section',
						{ className: 'container cash_img_blk', style: { marginTop: '125px' } },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/web/share_earn' },
								_react2.default.createElement('img', { src: baseAssets + 'images/promo_offers/my_aquacash.png', alt: ' ' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							_reactBootstrap.Breadcrumb,
							{ className: 'aquacash_breadcrmb' },
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb.Item,
								{ href: '/web/home' },
								'Home'
							),
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb.Item,
								{ active: true },
								'My Aquacash'
							)
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12 col-lg-12 Dels_cntnt web_aquacash_cnt', style: { paddingBottom: '150px' } },
								_react2.default.createElement(
									'div',
									{ className: 'container-fluid', style: { marginTop: '25px' } },
									this.state.transactions.length > 0 ? _react2.default.createElement(
										'a',
										{ className: 'webMyaquacashAmount cursor', onClick: this.deleteAll },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/del_bin3.png', width: '16px', alt: '' })
										),
										' Delete all'
									) : ''
								),
								_react2.default.createElement('hr', { className: this.state.transactions.length > 0 ? 'show' : 'hide' }),
								transactions.length > 0 ? _react2.default.createElement(
									'section',
									null,
									_react2.default.createElement(
										'ul',
										{ className: 'web_myaquacash_ul' },
										_react2.default.createElement(
											'li',
											{ className: 'row' },
											_react2.default.createElement(
												'h5',
												{ className: 'col-md-5 col-sm-5', style: { paddingLeft: '30px' } },
												'Description'
											),
											_react2.default.createElement(
												'h5',
												{ className: 'col-md-2 col-sm-2', style: { paddingLeft: '30px' } },
												'Date'
											),
											_react2.default.createElement(
												'h5',
												{ className: 'col-md-2 col-sm-2' },
												'Status'
											),
											_react2.default.createElement(
												'h5',
												{ className: 'col-md-2 col-sm-2' },
												'Amount'
											),
											_react2.default.createElement(
												'h5',
												{ className: 'col-md-1 col-sm-1' },
												'\xA0'
											)
										),
										transactions
									)
								) : _react2.default.createElement(
									'div',
									{ className: 'web_no_Transactions_Blk' },
									'No transactions were made'
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: 'Aquacash_Modal', show: this.state.modal_status, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'div',
											null,
											this.state.title ? _react2.default.createElement(
												'h4',
												null,
												this.state.title
											) : '',
											_react2.default.createElement(
												'div',
												null,
												_react2.default.createElement(
													'p',
													{ style: { marginTop: '20px' } },
													this.state.amount ? _react2.default.createElement(
														'span',
														null,
														'\u20B9',
														this.state.amount
													) : '',
													' ',
													this.state.type ? this.state.type : '',
													' ',
													this.state.subtitle ? 'for ' + this.state.subtitle : '',
													' on ',
													this.state.date,
													' '
												),
												_react2.default.createElement(
													'a',
													{ style: { color: '#ff742a', textDecoration: 'none', outline: 'none', textAlign: 'right', display: 'block' }, onClick: this.close },
													'CLOSE'
												)
											)
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: 'Aquacash_deleteModal', show: this.state.deleteModal_status, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										{ style: { padding: '35px' } },
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(
												'div',
												{ className: 'aquaCash_delete' },
												_react2.default.createElement(
													'p',
													null,
													'Are you sure you want to delete this item'
												),
												_react2.default.createElement(
													'ul',
													{ className: 'pull-right' },
													_react2.default.createElement(
														'li',
														{ className: 'cursor' },
														_react2.default.createElement(
															'a',
															{ onClick: this.close },
															'No'
														)
													),
													_react2.default.createElement(
														'li',
														{ className: 'cursor' },
														_react2.default.createElement(
															'a',
															{ onClick: function onClick() {
																	_this3.deleteSingleAc(_this3.state.aquaCash_id);
																} },
															'Yes'
														)
													)
												)
											)
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: 'Aquacash_deleteModal', show: this.state.deleteAll_modal_status, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										{ style: { padding: '35px' } },
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(
												'div',
												{ className: 'aquaCash_delete' },
												_react2.default.createElement(
													'p',
													null,
													'Are you sure you want to delete all items'
												),
												_react2.default.createElement(
													'ul',
													{ className: 'pull-right' },
													_react2.default.createElement(
														'li',
														{ className: 'cursor' },
														_react2.default.createElement(
															'a',
															{ onClick: this.close },
															'No'
														)
													),
													_react2.default.createElement(
														'li',
														{ className: 'cursor' },
														_react2.default.createElement(
															'a',
															{ onClick: function onClick() {
																	_this3.deleteallAC();
																} },
															'Yes'
														)
													)
												)
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_MyAquaCash;
	}(_react.Component);
	
	exports.default = Web_MyAquaCash;

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var WebNotifications = function (_Component) {
		_inherits(WebNotifications, _Component);
	
		function WebNotifications(props) {
			_classCallCheck(this, WebNotifications);
	
			var _this = _possibleConstructorReturn(this, (WebNotifications.__proto__ || Object.getPrototypeOf(WebNotifications)).call(this, props));
	
			_this.state = {
				notifications: [],
				empty_status: false,
				deleteAll_modal: false
			};
			_this.deleteAll = _this.deleteAll.bind(_this);
			_this.clearNotif = _this.clearNotif.bind(_this);
			// this.deleteModal=this.deleteModal.bind(this);
			_this.getpnotifications = _this.getpnotifications.bind(_this);
			_this.close = _this.close.bind(_this);
			return _this;
		}
	
		_createClass(WebNotifications, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
				localStorage.removeItem('checkout');
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('web_quickcart');
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
				localStorage.removeItem('web_brand_details');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
				if (screen.width < 800) {
					window.location.href = "/notifications";
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('notifications', '/web/notifications');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					this.getpnotifications();
				}
			}
		}, {
			key: 'getpnotifications',
			value: function getpnotifications() {
				var data1 = { id: localStorage.user_id, token: localStorage.token, from: 'desktop_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'getpnotifications',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							if (data.notifications.length > 0) {
								this.setState({
									notifications: data.notifications
								});
							} else {
								this.setState({
									empty_status: true
								});
							}
						} else if (data.status === 'error' && data.message === 'Token mismatch') {
							localStorage.clear();
							localStorage.setItem('notifications', '/web/notifications');
							_reactRouter.browserHistory.push('/web/login');
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					deleteAll_modal: false
				});
			}
			// deleteModal()
			// {
	
			// 	this.setState({
			// 		deleteAll_modal:true,
			// 	});
			// }
	
		}, {
			key: 'deleteAll',
			value: function deleteAll() {
				var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'deleteAllNotifications',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								empty_status: true,
								deleteAll_modal: false
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			// clearNotif(id,token,push_id,from)
	
		}, {
			key: 'clearNotif',
			value: function clearNotif(push_id) {
				var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, push_id: push_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'clearNotif',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.getpnotifications();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				document.title = "Notifications | AquaDeals";
				var notifications = this.state.notifications.map(function (data, index) {
					var _this2 = this;
	
					return _react2.default.createElement(
						'div',
						{ className: 'webNotificationItem' },
						data.link === 'internal' ? _react2.default.createElement(
							'div',
							{ className: 'panel panel-default' },
							_react2.default.createElement(
								'div',
								{ className: 'panel-body' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ onClick: function onClick() {
												return _this2.clearNotif(data.id);
											}, to: data.url ? data.url : '/web/home', style: { cursor: 'pointer' } },
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-6 col-md-6 col-sm-6' },
											data.title ? _react2.default.createElement(
												'h5',
												{ className: 'web_noty_title' },
												data.title
											) : _react2.default.createElement(
												'h5',
												{ className: 'web_noty_title' },
												'\xA0'
											),
											data.content ? _react2.default.createElement(
												'h5',
												{ className: 'web_noty_content' },
												data.content
											) : _react2.default.createElement(
												'h5',
												{ className: 'web_noty_content' },
												'\xA0'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-5 col-md-5 col-sm-5 text-right' },
											data.date ? _react2.default.createElement(
												'span',
												{ className: 'web_noty_date' },
												data.date
											) : _react2.default.createElement(
												'span',
												{ className: 'web_noty_date' },
												'\xA0'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-1 col-md-1 col-sm-1 text-right' },
										_react2.default.createElement(
											'i',
											{ onClick: function onClick() {
													return _this2.clearNotif(data.id);
												} },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png', alt: 'remove', width: '16px' })
										)
									)
								)
							)
						) : _react2.default.createElement(
							'div',
							{ className: 'panel panel-default' },
							_react2.default.createElement(
								'div',
								{ className: 'panel-body' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'a',
										{ onClick: function onClick() {
												return _this2.clearNotif(data.id);
											}, href: data.url ? data.url : '/web/home', target: '_blank', style: { cursor: 'pointer' } },
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-6 col-md-6 col-sm-6' },
											data.title ? _react2.default.createElement(
												'h5',
												{ className: 'web_noty_title' },
												data.title
											) : _react2.default.createElement(
												'h5',
												{ className: 'web_noty_title' },
												'\xA0'
											),
											data.content ? _react2.default.createElement(
												'h5',
												{ className: 'web_noty_content' },
												data.content
											) : _react2.default.createElement(
												'h5',
												{ className: 'web_noty_content' },
												'\xA0'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-5 col-md-5 col-sm-5 text-right' },
											data.date ? _react2.default.createElement(
												'span',
												{ className: 'web_noty_date' },
												data.date
											) : _react2.default.createElement(
												'span',
												{ className: 'web_noty_date ' },
												'\xA0'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-1 col-md-1 col-sm-1 text-right' },
										_react2.default.createElement(
											'i',
											{ onClick: function onClick() {
													return _this2.clearNotif(data.id);
												} },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png', alt: 'remove', width: '16px' })
										)
									)
								)
							)
						)
					);
				}.bind(this));
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_notifications_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							_reactBootstrap.Breadcrumb,
							null,
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb.Item,
								{ href: '/web/home' },
								'Home'
							),
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb.Item,
								{ active: true },
								'Notifications'
							)
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-lg-12 col-md-12 col-sm-12  webDels_cntnt' },
								_react2.default.createElement(
									'div',
									{ className: 'container-fluid', style: { marginTop: '25px' } },
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-8 col-md-8 col-sm-8' },
											'\xA0'
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-4 col-md-4 col-sm-4' },
											!this.state.empty_status ? _react2.default.createElement(
												'a',
												{ className: 'webNoty_emptybtn', onClick: function onClick() {
														_this3.setState({ deleteAll_modal: true });
													} },
												_react2.default.createElement(
													'i',
													null,
													_react2.default.createElement('img', { alt: '', src: baseAssets + 'icons/web_icons/del_bin3.png', width: '20px' })
												),
												_react2.default.createElement(
													'span',
													null,
													'Delete all'
												)
											) : ''
										)
									)
								),
								_react2.default.createElement('hr', null),
								_react2.default.createElement(
									'section',
									{ className: 'container-fluid webNoty_blk_cnt' },
									this.state.empty_status ? _react2.default.createElement(
										'div',
										{ className: 'webNoty_empty' },
										'No Notifications Available'
									) : notifications
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ show: this.state.deleteAll_modal, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Header,
										{ closeButton: true },
										_react2.default.createElement(
											_reactBootstrap.Modal.Title,
											null,
											'Alert'
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'h4',
											null,
											'Do you want to remove all notifications? '
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Footer,
										{ className: 'webCart_confirm' },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ onClick: this.close },
											'NO'
										),
										_react2.default.createElement(
											'a',
											null,
											_react2.default.createElement(
												_reactBootstrap.Button,
												{ onClick: function onClick() {
														_this3.deleteAll();
													} },
												'YES'
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return WebNotifications;
	}(_react.Component);
	
	exports.default = WebNotifications;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactGeosuggest = __webpack_require__(320);
	
	var _reactGeosuggest2 = _interopRequireDefault(_reactGeosuggest);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Web_Profile = function (_Component) {
	  _inherits(Web_Profile, _Component);
	
	  function Web_Profile(props) {
	    _classCallCheck(this, Web_Profile);
	
	    var _this = _possibleConstructorReturn(this, (Web_Profile.__proto__ || Object.getPrototypeOf(Web_Profile)).call(this, props));
	
	    _this.state = {
	      pro_pic: baseAssets + 'images/pro_pics/web_default_img.png',
	      full_details: [],
	      name: '',
	      mobile: '',
	      email: '',
	      door_no: '',
	      city: '',
	      file: '',
	      imageUrl: '',
	      otp_flag: '',
	      email_flag: '',
	      editName_status: false,
	      editEmail_status: false,
	      editDoorNo_status: false,
	      err_name: '',
	      err_name_status: false,
	      err_email_status: false,
	      err_email: '',
	      err_door_no_status: false,
	      err_door_no: '',
	      editCityAddress_status: false,
	      err_cityAddress_status: false,
	      err_cityAddress: '',
	
	      pincode: '',
	      err_pincode_status: false,
	      err_pincode_msg: 'Invalid pincode',
	      page_loading: false,
	
	      delimg_status: false
	    };
	    _this.getPhoto = _this.getPhoto.bind(_this);
	    _this.uploadFile = _this.uploadFile.bind(_this);
	    _this.editName = _this.editName.bind(_this);
	    _this.NameChange = _this.NameChange.bind(_this);
	    _this.EmailChange = _this.EmailChange.bind(_this);
	    _this.editEmail = _this.editEmail.bind(_this);
	    _this.editDoorNo = _this.editDoorNo.bind(_this);
	    _this.DoorNoChange = _this.DoorNoChange.bind(_this);
	    _this.saveChanges = _this.saveChanges.bind(_this);
	    _this.submitProfileData = _this.submitProfileData.bind(_this);
	    _this.editCityAddress = _this.editCityAddress.bind(_this);
	    _this.onSuggestSelect = _this.onSuggestSelect.bind(_this);
	    _this.pincodeChange = _this.pincodeChange.bind(_this);
	
	    _this.getProfileDetails = _this.getProfileDetails.bind(_this);
	    _this.removeProfilePic = _this.removeProfilePic.bind(_this);
	    _this.close = _this.close.bind(_this);
	    return _this;
	  }
	
	  _createClass(Web_Profile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (screen.width < 800) {
	        window.location.href = "/profile";
	      }
	      localStorage.removeItem('w_r_s_dt');
	      localStorage.removeItem('w_r_e_coupon_dt');
	      localStorage.removeItem('w_r_e_s_dt');
	      localStorage.removeItem('web_mycart');
	      localStorage.removeItem('w_r_enq_seller_page');
	      localStorage.removeItem('w_r_p_dt');
	      localStorage.removeItem('w_r_e_p_dt');
	      localStorage.removeItem('web_ofr_page');
	      localStorage.removeItem('myaquacash');
	      localStorage.removeItem('web_share_earn');
	      localStorage.removeItem('checkout');
	      localStorage.removeItem('order_details');
	      localStorage.removeItem('myorders');
	      localStorage.removeItem('w_r_p_deals');
	      localStorage.removeItem('seed');
	      localStorage.removeItem('nauplii');
	      localStorage.removeItem('subdeals');
	      localStorage.removeItem('shipping');
	      localStorage.removeItem('notifications');
	      localStorage.removeItem('web_quickcart');
	      localStorage.removeItem('view_rating');
	      localStorage.removeItem('w_modal_seed');
	      localStorage.removeItem('w_r_seed_deals');
	      localStorage.removeItem('w_r_e_p_dt');
	      localStorage.removeItem('w_modal_details');
	      localStorage.removeItem('offers');
	      localStorage.removeItem('give_rating');
	      localStorage.removeItem('pprice');
	      localStorage.removeItem('sprice');
	      localStorage.removeItem('seed_id');
	      localStorage.removeItem('h_type');
	      localStorage.removeItem('web_pro_ofr_dtls');
	      localStorage.removeItem('web_wishlist');
	      localStorage.removeItem('web_brand_details');
	
	      localStorage.removeItem('m_r_s_dt');
	      localStorage.removeItem('m_r_e_coupon_dt');
	      localStorage.removeItem('m_r_e_s_dt');
	      localStorage.removeItem('mob_mycart');
	      localStorage.removeItem('m_r_enq_seller_page');
	      localStorage.removeItem('m_r_p_dt');
	      localStorage.removeItem('m_r_e_p_dt');
	      localStorage.removeItem('ofr_page');
	      localStorage.removeItem('pro_ofr_dtls');
	
	      localStorage.removeItem('share_earn');
	      localStorage.removeItem('my_orders');
	      localStorage.removeItem('m_r_p_deals');
	      localStorage.removeItem('mob_quickcart');
	      localStorage.removeItem('partner_deals');
	
	      if (!localStorage.token && !localStorage.user_id) {
	        localStorage.setItem('profile', '/web/profile');
	        _reactRouter.browserHistory.push('/web/login');
	      } else {
	        this.getProfileDetails();
	      }
	    }
	  }, {
	    key: 'getProfileDetails',
	    value: function getProfileDetails() {
	      var data1 = { from: 'desktop_web', uid: localStorage.getItem('user_id'), token: localStorage.getItem('token'), device_id: localStorage.getItem('push_device_id') };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'myprofile',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          if (data.msg === 'success') {
	            this.setState({
	              full_details: data.details,
	              pro_pic: baseAssets + 'images/pro_pics/' + data.details[0].pro_pic,
	              name: data.details[0].name,
	              mobile: data.details[0].mobile,
	              email: data.details[0].email,
	              door_no: data.details[0].address1,
	              city: data.details[0].city,
	              otp_flag: data.details[0].otp_flag,
	              email_flag: data.details[0].email_flag,
	              pincode: data.details[0].zip
	            });
	            localStorage.setItem('mobile_number', data.details[0].mobile);
	          }
	          if (data.status === 'error' && data.message === 'Token mismatch') {
	            localStorage.removeItem('token');
	            localStorage.removeItem('user_id');
	            localStorage.setItem('profile', '/web/profile');
	            _reactRouter.browserHistory.push('/web/login');
	          }
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'removeProfilePic',
	    value: function removeProfilePic() {
	      if (localStorage.user_id) {
	        var uid = localStorage.user_id;
	      } else {
	        uid = 0;
	      }
	      var data1 = { from: 'desktop_web', id: uid, token: localStorage.token };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        url: baseUrl + 'removePropic',
	        method: 'POST',
	        dataType: 'JSON',
	        data: { req: data2 },
	        success: function (data) {
	          if (data.status === 'success') {
	            this.setState({
	              delimg_status: false
	              // page_loading:false,
	            });
	            // window.location.reload();
	            this.getProfileDetails();
	          }
	          if (data.status === 'error' && data.message === 'Token mismatch') {
	            this.setState({
	              // page_loading:false,
	            });
	            this.tokenCheck();
	          }
	        }.bind(this),
	        error: function error(err) {}
	
	      });
	    }
	  }, {
	    key: 'pincodeChange',
	    value: function pincodeChange() {
	      // alert(this.refs.pincode.value);
	      var invalidChars = /[^0-9]/gi;
	      if (invalidChars.test(this.refs.pincode.value)) {
	        var x = this.refs.pincode.value.replace(invalidChars, "");
	      } else {
	        this.setState({
	          err_pincode_status: true
	        });
	      }
	      this.setState({
	        pincode: x,
	        err_pincode_status: false
	      });
	      // this.setState({
	      //     pincode:this.refs.pincode.value,
	      //     err_pincode:false,
	      // });
	
	
	      // var invalidChars = /[^0-9]/gi;
	      // if(invalidChars.test(this.refs.pincode.value)) 
	      // {
	      //     var x = this.refs.pincode.value.replace(invalidChars,"");
	      // }
	      // else
	      // {
	      //     this.setState({
	      //       err_pincode: true,
	      //     });
	      // }
	      //   this.setState({
	      //     pincode:x,
	      //     err_pincode:false,
	      //   });
	    }
	  }, {
	    key: 'getPhoto',
	    value: function getPhoto(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      var reader = new FileReader();
	      var file = e.target.files[0];
	      reader.onloadend = function () {
	        _this2.setState({
	          file: file,
	          imageUrl: reader.result
	        });
	      };
	      reader.readAsDataURL(file);
	      this.setState({
	        page_loading: true
	      });
	      setTimeout(function () {
	        _this2.uploadFile();
	      }, 5000);
	    }
	  }, {
	    key: 'uploadFile',
	    value: function uploadFile(reader) {
	      var data1 = { from: 'desktop_web', uid: localStorage.getItem('user_id'), image: this.state.imageUrl };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'uploadImage',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          if (data.msg === 'success') {
	            this.getProfileDetails();
	            this.setState({
	              page_loading: false
	            });
	            // window.location.reload();
	          }
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'editName',
	    value: function editName(e) {
	      this.setState({
	        editName_status: true,
	        err_name_status: false
	      });
	    }
	  }, {
	    key: 'NameChange',
	    value: function NameChange(e) {
	      this.setState({
	        name: this.refs.e_name.value
	      });
	    }
	  }, {
	    key: 'editEmail',
	    value: function editEmail(e) {
	      this.setState({
	        editEmail_status: true,
	        err_email_status: false
	      });
	    }
	  }, {
	    key: 'EmailChange',
	    value: function EmailChange(e) {
	      this.setState({
	        email: this.refs.e_email.value
	      });
	    }
	  }, {
	    key: 'editDoorNo',
	    value: function editDoorNo(e) {
	      this.setState({
	        editDoorNo_status: true,
	        err_door_no_status: false
	      });
	    }
	  }, {
	    key: 'DoorNoChange',
	    value: function DoorNoChange(e) {
	      this.setState({
	        door_no: this.refs.e_door_no.value
	      });
	    }
	  }, {
	    key: 'editCityAddress',
	    value: function editCityAddress(e) {
	      this.setState({
	        editCityAddress_status: true,
	        err_cityAddress_status: false
	      });
	    }
	  }, {
	    key: 'onSuggestSelect',
	    value: function onSuggestSelect(e) {
	      this.setState({
	        city: e.label
	      });
	    }
	  }, {
	    key: 'saveChanges',
	    value: function saveChanges(e) {
	      var _this3 = this;
	
	      this.setState({
	        page_loading: true
	      });
	      if (this.state.name.length < 3) {
	        this.setState({
	          err_name_status: true,
	          err_name: 'Minimum 3 Characters'
	        });
	      } else {
	        this.setState({
	          err_name_status: false,
	          err_name: ''
	        });
	        var s_name = this.state.name;
	      }
	      // if(this.state.pincode.length < 6)
	      // {
	      //     this.setState({
	      //       err_pincode_status: true,
	      //       err_pincode_msg:'Invalid pincode',
	      //     });
	      // }
	      if (this.state.email.length > 0) {
	        var emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
	        if (!emailPattern.test(this.state.email)) {
	          var s_email = '';
	          this.setState({
	            err_email_status: true,
	            err_email: 'Invalid Email Address'
	          });
	        } else {
	          this.setState({
	            err_email_status: false,
	            err_email: ''
	          });
	          s_email = this.state.email;
	        }
	      } else {
	        s_email = '';
	      }
	      // if(this.state.door_no.length < 1)
	      // {
	      //   // alert("Enter Door No");
	      //   this.setState({
	      //       err_door_no_status: true,
	      //       err_door_no: 'Enter Door No',
	      //   });
	      // }
	      // else
	      // {
	      //   // alert("Door No good");
	      //   this.setState({
	      //       err_door_no_status: false,
	      //       err_door_no: '',
	      //   });
	      //   var s_door_no=this.state.door_no;
	      // }
	      if (s_name && !this.state.err_email_status) {
	        // this.submitProfileData(s_name,s_email,s_door_no,)
	        setTimeout(function () {
	          _this3.submitProfileData(s_name, s_email);
	        }, 3000);
	      } else {
	        alert('Please fill the details');
	      }
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.setState({ delimg_status: false });
	    }
	  }, {
	    key: 'submitProfileData',
	    value: function submitProfileData(s_name, s_email, s_door_no) {
	      var data1 = { from: 'desktop_web', uid: localStorage.getItem('user_id'), name: s_name, email: s_email, add1: '', city: this.state.city, dist: '', state: '', zip: this.refs.pincode.value };
	      var data2 = JSON.stringify(data1);
	      if (!this.state.err_email_status) {
	        _jquery2.default.ajax({
	          method: 'POST',
	          url: baseUrl + 'myprofile_save',
	          dataType: 'json',
	          data: { req: data2 },
	          success: function (data) {
	            if (data.status === "success") {
	              _reactRouter.browserHistory.push('/web/home');
	            } else {
	              this.setState({
	                page_loading: false
	              });
	            }
	          }.bind(this),
	          error: function error(err) {
	            // console.log(err);
	          }
	        });
	      } else {
	        console.log('Please fill the details');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      (0, _jquery2.default)('#profile_email').unbind("keyup").keyup(function () {
	        (0, _jquery2.default)('.email_verify').hide();
	      });
	      document.title = "My Profile | AquaDeals";
	      var fixtures = [{ label: 'Kakinada, Andhra Pradesh, India', location: { lat: 16.9890648, lng: 82.24746479999999 } }, { label: 'Bhimavaram, Andhra Pradesh, India', location: { lat: 16.544893, lng: 81.52124100000003 } }, { label: 'Samalkota, Andhra Pradesh, India', location: { lat: 17.0504374, lng: 82.16592430000003 } }, { label: 'Amalapuram, Andhra Pradesh, India', location: { lat: 16.5720904, lng: 82.00085480000007 } }];
	      return _react2.default.createElement(
	        'div',
	        { className: 'web_Deals web_profile_page' },
	        _react2.default.createElement(_WebHeaderInner2.default, { image: this.state.pro_pic }),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            _reactBootstrap.Breadcrumb,
	            { className: 'webmyprofile_breadcrmb' },
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { href: '/web/home' },
	              'Home'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Breadcrumb.Item,
	              { active: true },
	              'My Profile'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-12 col-md-12 col-sm-12 webDels_cntnt', style: { paddingLeft: '0', paddingRight: '0' } },
	              _react2.default.createElement(
	                'section',
	                { className: 'web_pro_img_blk' },
	                _react2.default.createElement(
	                  'form',
	                  { action: '', encType: 'multipart/form-data' },
	                  this.state.pro_pic === baseAssets + 'images/pro_pics/web_default_img.png' ? _react2.default.createElement(
	                    'label',
	                    { 'for': 'image_edit', className: 'web_Edit_pro_Img' },
	                    _react2.default.createElement('input', { type: 'file', name: 'image_edit', id: 'image_edit', style: { display: 'none' }, onChange: this.getPhoto }),
	                    _react2.default.createElement(_reactBootstrap.Image, { src: 'https://aquadeals.in/admin/assets/images/web_imgs/came_icon.png', alt: '', className: 'web_Edit_Pro', style: { marginTop: '5px' } })
	                  ) : _react2.default.createElement(
	                    'label',
	                    { 'for': 'del_img', className: 'web_delimg', onClick: function onClick() {
	                        _this4.setState({ delimg_status: true });
	                      } },
	                    _react2.default.createElement(_reactBootstrap.Image, { src: 'https://aquadeals.in/admin/assets/mob-assets/cam_remove_pic.png', alt: '', className: 'web_Edit_Pro', style: { marginTop: '5px' } })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'web_pro_img_blk web_Side_Bar_Prfil' },
	                  _react2.default.createElement(
	                    'form',
	                    { action: '', encType: 'multipart/form-data' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'web_Pro_Img web_Side_Bar_Prfil_Pic' },
	                      _react2.default.createElement(
	                        'label',
	                        { 'for': 'image' },
	                        _react2.default.createElement('input', { type: 'file', name: 'image', id: 'image', style: { display: 'none' }, onChange: this.getPhoto }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'web_pro_inner_icon' },
	                          _react2.default.createElement(_reactBootstrap.Image, { src: this.state.pro_pic, alt: '', circle: true })
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clr' },
	                '\xA0'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-sm-6 col-lg-6 col-md-6 col-md-offset-6 pro_btns' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-lg-12 col-sm-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-6 col-lg-6 ' },
	                      _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: "/web/change_number", className: 'btn btn-default btn-lg mobile_change' },
	                        _react2.default.createElement(
	                          'i',
	                          { style: { paddingRight: '5px' } },
	                          _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/mobile_number.png', alt: ' ', width: '20px' })
	                        ),
	                        'CHANGE MOBILE NUMBER'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-6 col-lg-6' },
	                      _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/web/reset', className: 'btn btn-lg btn-default reset_pass' },
	                        _react2.default.createElement(
	                          'i',
	                          { style: { paddingRight: '7px' } },
	                          _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/password.png', width: '20px', alt: '' })
	                        ),
	                        'RESET PASSWORD '
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clr' },
	                '\xA0'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clr' },
	                '\xA0'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clr' },
	                '\xA0'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-4 col-lg-4 col-sm-4' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'webPro_Dtls_Blk' },
	                    _react2.default.createElement(
	                      'h4',
	                      { className: 'web_per_Info_Title' },
	                      'Personal Information ',
	                      _react2.default.createElement('i', { onClick: this.editName, className: 'glyphicon glyphicon-pencil profile_edit_sym' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'web_psl_Info_Blk' },
	                      _react2.default.createElement(
	                        'h5',
	                        { onClick: this.editName },
	                        this.state.name && !this.state.editName_status ? _react2.default.createElement(
	                          'p',
	                          { className: 'input_name' },
	                          this.state.name
	                        ) : _react2.default.createElement('input', { type: 'text', ref: 'e_name', placeholder: 'Name', value: this.state.name, onChange: this.NameChange, style: { border: 'none', textDecoration: 'underline', width: '100%', outline: 'none' } }),
	                        _react2.default.createElement(
	                          'span',
	                          { style: { color: 'red', fontSize: '12px' } },
	                          ' ',
	                          this.state.err_name_status ? this.state.err_name : ''
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'h5',
	                        { className: 'col-md-12 col-lg-12 col-sm-12' },
	                        this.state.mobile ? _react2.default.createElement(
	                          'p',
	                          { className: 'col-md-6 col-sm-6 col-lg-6 input_mobile' },
	                          this.state.mobile
	                        ) : 'Mobile',
	                        this.state.otp_flag === '1' ? _react2.default.createElement(
	                          'p',
	                          { className: 'col-md-6 col-sm-6 col-lg-6 pro_num_Status_Img text-right' },
	                          _react2.default.createElement('img', { src: baseAssets + 'mob-assets/ok.png', alt: '' })
	                        ) : _react2.default.createElement(
	                          'p',
	                          { className: 'col-md-6 pro_num_status' },
	                          '\xA0'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'h5',
	                        { className: 'col-md-12 col-lg-12 col-sm-12', onClick: this.editEmail },
	                        this.state.email && !this.state.editEmail_status ? _react2.default.createElement(
	                          'p',
	                          { className: 'input_email col-sm-6 col-md-6' },
	                          this.state.email
	                        ) : _react2.default.createElement(
	                          'p',
	                          { className: 'input_email col-sm-6 col-md-6' },
	                          _react2.default.createElement('input', { type: 'mail', ref: 'e_email', placeholder: 'Email(Optional)', value: this.state.email, onChange: this.EmailChange, id: 'profile_email' })
	                        ),
	                        this.state.email_flag === '1' && this.state.email != '' ? _react2.default.createElement(
	                          'p',
	                          { className: 'col-sm-6 col-md-6 pro_num_Status_Img text-right' },
	                          _react2.default.createElement('img', { src: baseAssets + 'mob-assets/ok.png', alt: '' })
	                        ) : _react2.default.createElement(
	                          'p',
	                          { className: 'pro_num_status col-sm-6 col-md-6' },
	                          '\xA0'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { style: { color: 'red', fontSize: '12px' } },
	                          this.state.err_email_status ? this.state.err_email : ''
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'web_email_verify' },
	                          this.state.email_flag == 0 && this.state.email != '' ? 'Not verified' : ''
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-8  col-md-8 col-sm-8' },
	                  this.state.page_loading ? _react2.default.createElement(
	                    'i',
	                    { className: 'web_Pro_Load_Img text-left' },
	                    _react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
	                  ) : ''
	                )
	              ),
	              _react2.default.createElement('hr', { className: 'webprofile_hr' }),
	              _react2.default.createElement(
	                'div',
	                { className: '' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-4 col-sm-4 col-lg-4' },
	                  _react2.default.createElement(
	                    'h4',
	                    { className: 'web_Cnt_Info_Title' },
	                    'Contact Information'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'web_Cnt_Info' },
	                    _react2.default.createElement(
	                      'h5',
	                      { onClick: this.editCityAddress, style: { fontSize: '12px' } },
	                      this.state.city && !this.state.editCityAddress_status ? this.state.city : _react2.default.createElement(_reactGeosuggest2.default, { fixtures: fixtures, placeholder: 'Select Address', onSuggestSelect: this.onSuggestSelect, ignoreTab: true })
	                    ),
	                    _react2.default.createElement(
	                      'h5',
	                      null,
	                      _react2.default.createElement('input', { type: 'text', ref: 'pincode', placeholder: 'Pincode', value: this.state.pincode === '0' ? '' : this.state.pincode, onChange: this.pincodeChange, style: { border: 'none', width: '100%', outline: 'none' }, maxLength: 6 }),
	                      this.state.err_pincode_status ? _react2.default.createElement(
	                        'p',
	                        null,
	                        this.state.err_pincode_msg
	                      ) : ''
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-8 col-lg-8 col-sm-8' },
	                  '\xA0'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clr' },
	                '\xA0'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'web_profile_Save_Btn text-center', onClick: this.saveChanges },
	                'Save'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clr' },
	                '\xA0'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Modal,
	            { show: this.state.delimg_status, onHide: this.close },
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Body,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Want to remove profile photo?'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Footer,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'webdelimg_btns' },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'Nobtn', onClick: this.close },
	                  'NO'
	                ),
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick() {
	                      _this4.removeProfilePic();
	                    } },
	                  'YES'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_WebFooter2.default, null)
	      );
	    }
	  }]);
	
	  return Web_Profile;
	}(_react.Component);
	
	exports.default = Web_Profile;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactStars = __webpack_require__(33);
	
	var _reactStars2 = _interopRequireDefault(_reactStars);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import Switch from './switch.js';
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Web_View_Rating = function (_Component) {
		_inherits(Web_View_Rating, _Component);
	
		function Web_View_Rating(props) {
			_classCallCheck(this, Web_View_Rating);
	
			var _this = _possibleConstructorReturn(this, (Web_View_Rating.__proto__ || Object.getPrototypeOf(Web_View_Rating)).call(this, props));
	
			_this.state = {
				over_rate: '',
				pack_rate: '',
				recomend: '',
				seller: '',
				book_date: '',
				nodata_status: false
			};
			_this.getSeedDetails = _this.getSeedDetails.bind(_this);
			_this.getProductDetails = _this.getProductDetails.bind(_this);
			_this.handleChange = _this.handleChange.bind(_this);
	
			_this.over_rateChanged = _this.over_rateChanged.bind(_this);
			_this.seed_rateChanged = _this.seed_rateChanged.bind(_this);
			_this.serv_rateChanged = _this.serv_rateChanged.bind(_this);
			_this.pack_rateChanged = _this.pack_rateChanged.bind(_this);
			return _this;
		}
	
		_createClass(Web_View_Rating, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
				localStorage.removeItem('checkout');
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
				localStorage.removeItem('web_quickcart');
	
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
				localStorage.removeItem('web_brand_details');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
	
				if (screen.width < 800) {
					if (this.props.params.Product === 'product') {
						window.location.href = '/viewrating/' + this.props.params.Product + '/' + this.props.params.Bid;
					} else {
						window.location.href = "/viewrating/" + this.props.params.Bid;
					}
				}
				if (this.props.params.Product === 'product') {
					this.getProductDetails();
				} else {
					this.getSeedDetails();
				}
				if (!localStorage.token && !localStorage.user_id) {
					if (this.props.params.Product === 'product') {
						localStorage.setItem('view_rating', '/web/viewrating/' + this.props.params.Product + '/' + this.props.params.Bid);
						_reactRouter.browserHistory.push('/web/login');
					} else {
						localStorage.setItem('view_rating', '/web/viewrating/' + this.props.params.Bid);
						_reactRouter.browserHistory.push('/web/login');
					}
				}
			}
		}, {
			key: 'getSeedDetails',
			value: function getSeedDetails() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
	
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, bid: this.props.params.Bid, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'getrating',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							seed_rate: data.seed_rate,
							serv_rate: data.serv_rate,
							pack_rate: data.pack_rate,
							over_rate: data.over_rate,
							recomend: data.recomend,
							seller: data.seller,
							book_date: data.book_date
						});
						if (data.status === 'fails') {
							this.setState({
								nodata_status: true
							});
						}
					}.bind(this),
					error: function error(err) {
						// console.log(err);
					}
				});
			}
		}, {
			key: 'getProductDetails',
			value: function getProductDetails() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, bid: this.props.params.Bid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'getpro_book_rating',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							seed_rate: data.product_rate,
							serv_rate: data.serv_rate,
							pack_rate: data.pack_rate,
							over_rate: data.over_rate,
							recomend: data.recomend,
							seller: data.seller,
							book_date: data.book_date
						});
						if (data.status === 'fails') {
							this.setState({
								nodata_status: true
							});
						}
					}.bind(this),
					error: function error(err) {
						// console.log(err);
					}
				});
			}
		}, {
			key: 'ratingChanged',
			value: function ratingChanged(newRating) {
				//console.log(newRating)
			}
		}, {
			key: 'handleChange',
			value: function handleChange() {
				this.setState({
					recomend: !this.state.recomend
				});
			}
		}, {
			key: 'over_rateChanged',
			value: function over_rateChanged(newRating) {
				// console.log(newRating);
				this.setState({
					over_rate: newRating
				});
			}
		}, {
			key: 'seed_rateChanged',
			value: function seed_rateChanged(newRating) {
				console.log(newRating);
				this.setState({
					seed_rate: newRating
				});
			}
		}, {
			key: 'serv_rateChanged',
			value: function serv_rateChanged(newRating) {
				console.log(newRating);
				this.setState({
					serv_rate: newRating
				});
			}
		}, {
			key: 'pack_rateChanged',
			value: function pack_rateChanged(newRating) {
				console.log(newRating);
				this.setState({
					pack_rate: newRating
				});
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = this.props.params.Product === 'product' ? 'View Product Ratings | AquaDeals' : 'View Hatchery Ratings | AquaDeals';
				// $(window).scrollTop(0);
				(0, _jquery2.default)('body').css('background', '#f1f1f2');
	
				var switch_btn = this.state.recomend ? _react2.default.createElement(
					'div',
					{ className: 'switch-container custom_switch_blk' },
					_react2.default.createElement(
						'label',
						null,
						_react2.default.createElement('input', { ref: 'switch', checked: this.state.recomend === "true" ? true : false, disabled: true, onChange: this.handleChange, className: 'switch', type: 'checkbox' }),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'span',
								null,
								_react2.default.createElement('g', { className: 'icon icon-toolbar grid-view' })
							),
							_react2.default.createElement(
								'span',
								null,
								_react2.default.createElement('g', { className: 'icon icon-toolbar ticket-view' })
							),
							_react2.default.createElement('div', null)
						)
					)
				) : '';
	
				var pack_rate = _react2.default.createElement(_reactStars2.default, {
					className: 'rate_dtls_item',
					count: 5,
					onChange: this.pack_rateChanged,
					size: 20,
					edit: false,
					value: this.state.pack_rate,
					color1: '#F3F3F3',
					color2: '#FABB9A' });
	
				var seed_rate = _react2.default.createElement(_reactStars2.default, {
					className: 'rate_dtls_item',
					count: 5,
					onChange: this.seed_rateChanged,
					size: 20,
					edit: false,
					value: this.state.seed_rate,
					color1: '#F3F3F3',
					color2: '#FABB9A' });
	
				var serv_rate = _react2.default.createElement(_reactStars2.default, {
					className: 'rate_dtls_item',
					count: 5,
					onChange: this.serv_rateChanged,
					size: 20,
					edit: false,
					value: this.state.serv_rate,
					color1: '#F3F3F3',
					color2: '#FABB9A' });
				var over_rate = _react2.default.createElement(_reactStars2.default, {
					className: 'rate_dtls_item',
					count: 5,
					onChange: this.over_rateChanged,
					size: 20,
					edit: false,
					value: this.state.over_rate,
					color1: '#F3F3F3',
					color2: '#FABB9A' });
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_view_rating_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: '' },
						_react2.default.createElement(
							'section',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-12 Dels_cntnt' },
									this.state.nodata_status ? _react2.default.createElement(
										'section',
										null,
										_react2.default.createElement(
											'div',
											{ style: { textAlign: 'center', marginTop: '150px', marginBottom: '150px' } },
											'Rating Not Available'
										)
									) : _react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'div',
											{ className: 'container-fluid', style: { marginTop: '25px' } },
											_react2.default.createElement(
												'h5',
												null,
												_react2.default.createElement(
													_reactRouter.Link,
													{ onClick: function onClick() {
															_reactRouter.browserHistory.goBack();
														}, style: { cursor: 'pointer' } },
													_react2.default.createElement(
														'i',
														{ style: { marginRight: '15px' } },
														_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/close_icon1.png', width: '16px', alt: ' ' })
													)
												),
												' ',
												this.props.params.Product === 'product' ? 'View Product Ratings' : 'View Hatchery Details'
											),
											_react2.default.createElement(
												'a',
												{ href: '/web/home', title: 'Home', className: 'web_home_icon' },
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/home2.png', alt: 'Home' })
											)
										),
										_react2.default.createElement(
											'div',
											{ style: { marginBottom: '30px' } },
											_react2.default.createElement(
												'section',
												{ className: '' },
												_react2.default.createElement(
													'div',
													{ className: 'from_dtls_blk' },
													_react2.default.createElement(
														'p',
														null,
														'FROM'
													),
													this.state.seller ? _react2.default.createElement(
														'p',
														null,
														this.state.seller
													) : _react2.default.createElement(
														'p',
														null,
														'\xA0'
													),
													_react2.default.createElement(
														'p',
														null,
														'ORDER DATE'
													),
													this.state.book_date ? _react2.default.createElement(
														'p',
														null,
														this.state.book_date
													) : _react2.default.createElement(
														'p',
														null,
														'\xA0'
													)
												)
											),
											_react2.default.createElement(
												'section',
												{ style: { marginTop: '10px', fontSize: '12px' } },
												_react2.default.createElement(
													'div',
													{ className: 'rating_list_blk' },
													_react2.default.createElement(
														'div',
														{ className: 'rating_list_item' },
														_react2.default.createElement(
															'span',
															{ style: { float: 'left' } },
															'Overall Rating'
														),
														over_rate
													),
													_react2.default.createElement(
														'div',
														{ className: 'rating_list_item' },
														_react2.default.createElement(
															'span',
															{ style: { float: 'left' } },
															'Service Quality'
														),
														serv_rate
													),
													_react2.default.createElement(
														'div',
														{ className: 'rating_list_item' },
														_react2.default.createElement(
															'span',
															{ style: { float: 'left' } },
															this.props.params.Product === 'product' ? 'Product Quality' : 'Seed Quality'
														),
														seed_rate
													),
													_react2.default.createElement(
														'div',
														{ className: 'rating_list_item' },
														_react2.default.createElement(
															'span',
															{ style: { float: 'left' } },
															'Packing Quality'
														),
														pack_rate
													)
												)
											),
											_react2.default.createElement(
												'section',
												{ style: { marginTop: '10px' } },
												this.state.recomend === true ? _react2.default.createElement(
													'div',
													{ className: 'rate_rec_blk' },
													_react2.default.createElement(
														'span',
														{ style: { width: '75%', display: 'block' } },
														this.props.params.Product === 'product' ? 'I recommended this product to other customers' : 'I recommended this hatchery to other customers'
													),
													_react2.default.createElement(
														'span',
														null,
														this.state.recomend ? switch_btn : ''
													)
												) : _react2.default.createElement(
													'div',
													{ className: 'rate_rec_blk' },
													_react2.default.createElement(
														'span',
														{ style: { width: '75%', display: 'block' } },
														this.props.params.Product === 'product' ? 'I recommended this product to other customers' : 'I recommended this hatchery to other customers'
													),
													_react2.default.createElement(
														'span',
														null,
														this.state.recomend ? switch_btn : ''
													)
												)
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_View_Rating;
	}(_react.Component);
	
	exports.default = Web_View_Rating;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Web_ChangeVerifyOtp = function (_Component) {
		_inherits(Web_ChangeVerifyOtp, _Component);
	
		function Web_ChangeVerifyOtp(props, context) {
			_classCallCheck(this, Web_ChangeVerifyOtp);
	
			var _this = _possibleConstructorReturn(this, (Web_ChangeVerifyOtp.__proto__ || Object.getPrototypeOf(Web_ChangeVerifyOtp)).call(this, props));
	
			_this.state = {
				mobile: localStorage.getItem('mobile_number'),
				invalid_otp: ''
			};
			_this.handleSubmit = _this.handleSubmit.bind(_this);
			_this.gotoLogin = _this.gotoLogin.bind(_this);
			_this.resendOtp = _this.resendOtp.bind(_this);
			return _this;
		}
	
		_createClass(Web_ChangeVerifyOtp, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.refs.otp.focus();
			}
		}, {
			key: 'resendOtp',
			value: function resendOtp() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', mobile: this.state.mobile };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'resendOtp',
					data: { req: data2 },
					dataType: 'json',
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'handleSubmit',
			value: function handleSubmit(event) {
				event.preventDefault();
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', uid: localStorage.getItem('user_id'), token: localStorage.getItem('token'), mobile: localStorage.getItem('mobile_number'), otp: this.refs.otp.value };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'verifyChangeMobileOtp',
					data: { req: data2 },
					dataType: 'json',
					success: function (data) {
						if (data.status === "success") {
							_reactRouter.browserHistory.push('/web/profile');
						}
						if (data.status === 'fail') {
							this.setState({
								err: true,
								invalid_otp: 'Invalid Otp'
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'gotoLogin',
			value: function gotoLogin(event) {
				event.preventDefault();
				_reactRouter.browserHistory.push('/web/login');
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = "Verify OTP | AquaDeals";
				(0, _jquery2.default)(window).scrollTop(0);
				return _react2.default.createElement(
					'div',
					{ className: 'lgt_gry web_deals web_changenumber_otp_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'container dels_cntnt' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12 del_rgt' },
								_react2.default.createElement(
									'div',
									{ className: 'del_rgt_blk' },
									_react2.default.createElement(
										'div',
										{ className: 'del_dtl' },
										_react2.default.createElement(
											'div',
											{ className: '' },
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-md-offset-3' },
												_react2.default.createElement(
													'div',
													{ className: 'thumbnail' },
													_react2.default.createElement(
														'div',
														{ className: '' },
														_react2.default.createElement(
															'div',
															{ className: 'enquire_form signup_blk proced_blk', style: { marginLeft: '20px', marginRight: '20px' } },
															_react2.default.createElement(
																'div',
																{ className: 'newlogin_logo' },
																_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png', alt: ' ' })
															),
															_react2.default.createElement(
																'form',
																{ className: 'mtrl_elmnts web_chng_otp_form', onSubmit: this.handleSubmit },
																_react2.default.createElement(
																	'div',
																	{ className: 'col-md-12', style: { marginLeft: '20px', marginRight: '20px' } },
																	_react2.default.createElement(
																		'div',
																		{ className: 'col-md-12' },
																		_react2.default.createElement(
																			'div',
																			{ className: 'group' },
																			_react2.default.createElement('input', { type: 'text', ref: 'otp', maxLength: 6, required: true }),
																			_react2.default.createElement('span', { className: 'highlight' }),
																			_react2.default.createElement('span', { className: 'bar' }),
																			this.state.err ? this.state.invalid_otp : '',
																			_react2.default.createElement(
																				'label',
																				null,
																				'Enter OTP'
																			)
																		)
																	),
																	_react2.default.createElement(
																		'button',
																		{ onSubmit: this.handleSubmit.bind(this), action: 'submit', className: 'btn mob_social_verifybtn' },
																		'Verify ',
																		_react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
																	)
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'clr' },
																	'\xA0'
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'web_forgot_pasword web_verify_blk' },
																	_react2.default.createElement(
																		'h5',
																		null,
																		'Didn\'t receive the OTP?'
																	),
																	_react2.default.createElement(
																		'div',
																		{ className: 'tap' },
																		_react2.default.createElement(
																			'a',
																			{ style: { cursor: 'pointer' }, onClick: this.resendOtp },
																			'Tap here to resend'
																		)
																	)
																)
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'clr' },
															'\xA0'
														)
													)
												)
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_ChangeVerifyOtp;
	}(_react.Component);
	
	exports.default = Web_ChangeVerifyOtp;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Web_Change_Number = function (_Component) {
		_inherits(Web_Change_Number, _Component);
	
		function Web_Change_Number(props) {
			_classCallCheck(this, Web_Change_Number);
	
			var _this = _possibleConstructorReturn(this, (Web_Change_Number.__proto__ || Object.getPrototypeOf(Web_Change_Number)).call(this, props));
	
			_this.state = {
				mobile: '',
				err_mobile: '',
				err_mobile_status: false
			};
			_this.handleSubmit = _this.handleSubmit.bind(_this);
			_this.mobileChange = _this.mobileChange.bind(_this);
			return _this;
		}
	
		_createClass(Web_Change_Number, [{
			key: 'handleSubmit',
			value: function handleSubmit(e) {
				e.preventDefault();
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', uid: localStorage.user_id, token: localStorage.token, mobile: this.refs.mobile.value };
				var data2 = JSON.stringify(data1);
				localStorage.setItem('mobile_number', this.refs.mobile.value);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'changeMobile',
					data: { req: data2 },
					dataType: 'json',
					success: function (data) {
						if (data.status === "error") {
							this.setState({
								err_mobile_status: true,
								err_mobile: data.msg
							});
						} else {
							this.setState({
								err_mobile_status: false,
								err_mobile: ''
							});
						}
						if (data.status === "success") {
							_reactRouter.browserHistory.push('/web/verify_otp');
						}
					}.bind(this),
					error: function error(err) {
						// console.log(err);
					}
				});
			}
		}, {
			key: 'mobileChange',
			value: function mobileChange(e) {
				this.setState({
					err_mobile_status: false
				});
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = "Change Number | AquaDeals";
				(0, _jquery2.default)(window).scrollTop(0);
				return _react2.default.createElement(
					'div',
					{ className: 'lgt_gry web_deals web_numberchng_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'container dels_cntnt' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12 del_rgt' },
								_react2.default.createElement(
									'div',
									{ className: 'del_rgt_blk' },
									_react2.default.createElement(
										'div',
										{ className: 'del_dtl' },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-6 col-md-offset-3' },
											_react2.default.createElement(
												'div',
												{ className: 'thumbnail' },
												_react2.default.createElement(
													'div',
													{ className: 'enquire_form signup_blk proced_blk' },
													_react2.default.createElement(
														'div',
														{ className: 'newlogin_logo' },
														_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png', alt: ' ' })
													),
													_react2.default.createElement(
														'form',
														{ className: 'mtrl_elmnts web_chng_form', onSubmit: this.handleSubmit.bind(this) },
														_react2.default.createElement(
															'div',
															{ className: '', style: { marginLeft: '40px', marginRight: '40px', marginBottom: '100px' } },
															_react2.default.createElement(
																'div',
																{ className: 'group' },
																_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cell_dl.png', alt: '', style: { position: 'absolute', top: '11px', left: '0px' } }),
																_react2.default.createElement('input', { type: 'text', placeholder: 'Enter Mobile', ref: 'mobile', required: true, maxLength: 10, onChange: this.mobileChange }),
																_react2.default.createElement('span', { className: 'highlight' }),
																_react2.default.createElement('span', { className: 'bar' }),
																_react2.default.createElement(
																	'span',
																	{ style: { fontSize: '12px', color: 'red' } },
																	this.state.err_mobile_status ? this.state.err_mobile : ''
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'clr' },
																'\xA0'
															),
															_react2.default.createElement(
																'div',
																null,
																_react2.default.createElement(
																	'button',
																	{ action: 'submit', className: 'btn mob_changenumber_btn' },
																	'Verify ',
																	_react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
																)
															)
														)
													),
													_react2.default.createElement('div', { className: 'clr' })
												)
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_Change_Number;
	}(_react.Component);
	
	exports.default = Web_Change_Number;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(36);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Web_Otpverify = function (_Component) {
	  _inherits(Web_Otpverify, _Component);
	
	  function Web_Otpverify(props) {
	    _classCallCheck(this, Web_Otpverify);
	
	    var _this = _possibleConstructorReturn(this, (Web_Otpverify.__proto__ || Object.getPrototypeOf(Web_Otpverify)).call(this, props));
	
	    _this.state = {
	      mobile: localStorage.mobile_number
	    };
	    _this.resendOtp = _this.resendOtp.bind(_this);
	    return _this;
	  }
	
	  _createClass(Web_Otpverify, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      localStorage.removeItem('h_type');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refs.otp.focus();
	    }
	  }, {
	    key: 'resendOtp',
	    value: function resendOtp() {
	      var mobile = '';
	      if (localStorage.mobile_number) {
	        mobile = localStorage.getItem('mobile_number');
	      } else if (localStorage.mobile) {
	        mobile = localStorage.getItem('mobile');
	      }
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      var data1 = { from: 'desktop_web', mobile: mobile, device_id: localStorage.getItem('push_device_id') };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'resendOtp',
	        data: { req: data2 },
	        dataType: 'json',
	        success: function success(data) {
	          // console.log(data);
	        },
	        error: function error(err) {
	          // console.log("Resend Otp Error"+err);
	        }
	      });
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      //this.props.Otpverify(formProps);
	      var mobile = '';
	      if (localStorage.mobile_number) {
	        mobile = localStorage.getItem('mobile_number');
	      } else if (localStorage.mobile) {
	        mobile = localStorage.getItem('mobile');
	      }
	      // var mobile = localStorage.getItem('mobile_number');
	
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      var pwd = localStorage.getItem('pwd');
	      var data1 = { from: 'desktop_web', mobile: mobile, otp: formProps.otp, pwd: pwd };
	      var data2 = JSON.stringify(data1);
	      if (formProps.otp) {
	        var button = (0, _jquery2.default)('.otp_v');
	        button.html("loading...");
	        button.prop("disabled", true);
	
	        _jquery2.default.ajax({
	          method: 'POST',
	          url: baseUrl + 'verifyOtp',
	          dataType: 'json',
	          data: { req: data2 },
	          success: function success(data) {
	            button.html("verify");
	            button.prop("disabled", false);
	            if (data.status === 'fail') {
	              (0, _jquery2.default)('#otp_err').text('Invalid verification code');
	            } else if (data.status === 'success') {
	              localStorage.setItem('pwd', data.pwd);
	              localStorage.setItem('token', data.user[0].token);
	              localStorage.setItem('user_id', data.user[0].id);
	              if (localStorage.token && localStorage.w_r_s_dt) {
	                _reactRouter.browserHistory.push(localStorage.w_r_s_dt);
	                localStorage.setItem('sprice', '1');
	                localStorage.removeItem('pprice');
	                window.location.reload();
	              }
	              if (localStorage.token && localStorage.w_r_p_dt) {
	                _reactRouter.browserHistory.push(localStorage.w_r_p_dt);
	                localStorage.setItem('pprice', '1');
	                localStorage.removeItem('sprice');
	                window.location.reload();
	              }
	              if (localStorage.token && localStorage.w_r_seed_deals) {
	                _reactRouter.browserHistory.push(localStorage.w_r_seed_deals);
	                window.location.reload();
	              }
	              if (localStorage.token && localStorage.w_r_p_deals) {
	                _reactRouter.browserHistory.push(localStorage.w_r_p_deals);
	                window.location.reload();
	              }
	              if (localStorage.token && localStorage.w_r_e_s_dt) {
	                _reactRouter.browserHistory.push(localStorage.w_r_e_s_dt);
	                window.location.reload();
	              }
	              if (localStorage.token && localStorage.w_r_e_p_dt) {
	                _reactRouter.browserHistory.push(localStorage.w_r_e_p_dt);
	                window.location.reload();
	              } else if (localStorage.token && localStorage.w_r_e_p_dt) {
	                _reactRouter.browserHistory.push(localStorage.w_r_e_p_dt);
	                window.location.reload();
	              } else if (localStorage.token && data.status === "success" && !localStorage.w_r_s_dt && !localStorage.w_r_p_dt && !localStorage.w_r_e_s_dt && !localStorage.w_r_e_p_dt && !localStorage.w_r_seed_deals && !localStorage.w_r_p_deals) {
	                _reactRouter.browserHistory.push('/web/home');
	                window.location.reload();
	              }
	            }
	            // button.prop("disabled",false);
	            // button.html("create account");
	            // if(data.status === 'referror'){
	            // $("#ref_err").text(data.message); 
	            // }
	            // if(data.status === 'error'){
	            // $("#email_err").text(data.message);
	            // }
	          },
	          error: function error(err) {
	            button.prop("disabled", false);
	            button.html("create account");
	            // console.log("Error"+err);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {}
	  }, {
	    key: 'render',
	    value: function render() {
	      (0, _jquery2.default)('#otp_input').keyup(function () {
	        (0, _jquery2.default)('#otp_err').text('');
	      });
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          otp = _props.fields.otp;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'lgt_gry web_deals web_otpverify_page' },
	        _react2.default.createElement(_WebHeaderInner2.default, null),
	        _react2.default.createElement(
	          'section',
	          { className: 'container dels_cntnt' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 del_rgt' },
	              _react2.default.createElement(
	                'div',
	                { className: 'del_rgt_blk' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'del_dtl' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'clr' },
	                    '\xA0'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: '' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-6 col-md-offset-3' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'thumbnail' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'newlogin_logo' },
	                          _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png', alt: ' ' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'form',
	                            { className: 'mtrl_elmnts', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-md-12' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 col-xs-12 col-sm-12' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'group' },
	                                  _react2.default.createElement('input', _extends({}, otp, { type: 'text', required: true, id: 'otp_input', ref: 'otp' })),
	                                  _react2.default.createElement('span', { className: 'highlight' }),
	                                  _react2.default.createElement('span', { className: 'bar' }),
	                                  _react2.default.createElement('span', { style: { color: 'red' }, id: 'otp_err' }),
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'Enter OTP'
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'button',
	                                { action: 'submit', className: 'btn web_otpverify_btn otp_v' },
	                                'Verify ',
	                                _react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'clr' },
	                              '\xA0'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'clr' },
	                              '\xA0'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'forgot_pasword' },
	                              _react2.default.createElement(
	                                'h5',
	                                null,
	                                'Didn\'t recieve the OTP?'
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'tap' },
	                                _react2.default.createElement(
	                                  'a',
	                                  { onClick: this.resendOtp },
	                                  'Tap here to resend'
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'clr' },
	                          '\xA0'
	                        )
	                      ),
	                      '                  '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'clr' },
	                    '\xA0'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'clr' },
	                    '\xA0'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          )
	        ),
	        _react2.default.createElement(_WebFooter2.default, null)
	      );
	    }
	  }]);
	
	  return Web_Otpverify;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    errorMessage: state.auth.error,
	    authenticated: state.auth.authenticated,
	    formdata: state.auth.formdata
	  };
	}
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'Otpverify',
	  fields: ['otp']
	}, mapStateToProps, actions)(Web_Otpverify);

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(36);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _reactGoogleLogin = __webpack_require__(322);
	
	var _reactGoogleLogin2 = _interopRequireDefault(_reactGoogleLogin);
	
	var _reactFacebookLogin = __webpack_require__(319);
	
	var _reactFacebookLogin2 = _interopRequireDefault(_reactFacebookLogin);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var responseGoogle = function responseGoogle(response) {
	  console.log(response);
	};
	// const responseFacebook = (response) => {
	//   console.log(response);
	// }
	
	var Web_Registration = function (_Component) {
	  _inherits(Web_Registration, _Component);
	
	  function Web_Registration(props) {
	    _classCallCheck(this, Web_Registration);
	
	    var _this = _possibleConstructorReturn(this, (Web_Registration.__proto__ || Object.getPrototypeOf(Web_Registration)).call(this, props));
	
	    _this.state = {
	      status: '',
	      msg: ''
	    };
	    _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
	    _this.getFbData = _this.getFbData.bind(_this);
	    _this.getGoogleData = _this.getGoogleData.bind(_this);
	    return _this;
	  }
	
	  _createClass(Web_Registration, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.formdata.status === 'success' && newProps.formdata.page === "otp") {
	        localStorage.setItem('pwd', newProps.formdata.pwd);
	        localStorage.setItem('mobile_number', newProps.formdata.mobile);
	        _reactRouter.browserHistory.push('/web/Otpverify');
	        window.location.reload();
	      }
	      if (newProps.formdata.status === 'success' && newProps.formdata.page === "login") {
	        _reactRouter.browserHistory.push('/web/account');
	        window.location.reload();
	      }
	      if (newProps.formdata.status === 'success' && newProps.formdata.page === "signup") {
	        _reactRouter.browserHistory.push('/web/signup');
	        window.location.reload();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _jquery2.default)(window).scrollTop(10);
	      if (screen.width > 800 && localStorage.token && localStorage.user_id) {
	        window.location.href = "/web/home";
	      }
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      //this.props.OTPsent(formProps);
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      var data1 = { from: 'desktop_web', mobile: formProps.mobile, device_id: localStorage.getItem('push_device_id') };
	      var data2 = JSON.stringify(data1);
	      var flag = 0;
	      var mobile_Pattern = /^([0-9]){10}$/;
	      if (!mobile_Pattern.test(formProps.mobile)) {
	        (0, _jquery2.default)('#num_err').text('Enter valid mobile number');
	        flag = 1;
	      }
	      if (flag === 0) {
	        var button = (0, _jquery2.default)('#reg_btn');
	        button.html("loading...");
	        button.prop("disabled", true);
	        _jquery2.default.ajax({
	          method: 'POST',
	          url: baseUrl + 'sentOtp',
	          dataType: 'json',
	          data: { req: data2 },
	          success: function success(data) {
	            button.html("proceed");
	            button.prop("disabled", false);
	            localStorage.setItem('mobile_number', data.mobile);
	            if (data.status === 'success' && data.page === "login") {
	              _reactRouter.browserHistory.push('/web/account');
	            } else if (data.status === 'success' && data.page === "signup") {
	              _reactRouter.browserHistory.push('/web/signup');
	            } else if (data.status === 'success' && data.page === "otp") {
	              localStorage.setItem('pwd', data.pwd);
	              localStorage.setItem('mobile_number', data.mobile);
	              _reactRouter.browserHistory.push('/web/Otpverify');
	              window.location.reload();
	            }
	          },
	          error: function error(err) {
	            // console.log("Error"+err);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'getFbData',
	    value: function getFbData(res) {
	      console.log(res);
	
	      this.setState({
	        name: res.name,
	        email: res.email,
	        id: res.id,
	        userId: res.user_id,
	        expiresIn: res.expiresIn,
	        picture: res.picture.data.url
	      });
	
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      var data1 = { from: 'desktop_web', name: res.name, social_type: '1', email: res.email, device_id: localStorage.getItem('push_device_id'), version: '', platform: '', language: '' };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'post',
	        data: { req: data2 },
	        url: baseUrl + 'social_login',
	        success: function success(data) {
	          data = JSON.parse(data);
	          if (data.status === 'success' && data.page_source === 'dashboard') {
	            localStorage.setItem('token', data.token);
	            localStorage.setItem('f_uid', data.uid);
	            localStorage.setItem('user_id', data.uid);
	            _reactRouter.browserHistory.push('/web/home');
	          } else if (data.status === 'success' && data.page_source === 'mobile_number') {
	            localStorage.setItem('f_uid', data.uid);
	            localStorage.setItem('user_id', data.uid);
	            localStorage.setItem('f_email', data.email);
	            _reactRouter.browserHistory.push('/web/mobile');
	          } else if (data.status === 'success' && data.page_source === "otp_screen") {
	            localStorage.setItem('mobile_number', data.mobile);
	            _reactRouter.browserHistory.push('/web/mobile/verify_otp');
	            window.location.reload();
	          }
	        },
	        error: function error(err) {
	          // console.log(err);
	        }
	      });
	    }
	  }, {
	    key: 'getGoogleData',
	    value: function getGoogleData(res) {
	      console.log(res);
	      console.log(JSON.stringify(res));
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      var data1 = { from: 'desktop_web', name: res.profileObj.name, social_type: '2', email: res.profileObj.email, device_id: localStorage.getItem('push_device_id') };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'post',
	        dataType: 'json',
	        data: { req: data2 },
	        url: baseUrl + 'social_login',
	        success: function success(data) {
	          // data= JSON.parse(data);
	          if (data.status === 'success' && data.page_source === 'dashboard') {
	            localStorage.setItem('token', data.token);
	            localStorage.setItem('f_uid', data.uid);
	            localStorage.setItem('user_id', data.uid);
	            _reactRouter.browserHistory.push('/web/home');
	            window.location.reload();
	          } else if (data.status === 'success' && data.page_source === 'mobile_number') {
	            localStorage.setItem('f_uid', data.uid);
	            localStorage.setItem('user_id', data.uid);
	            localStorage.setItem('f_email', data.email);
	            _reactRouter.browserHistory.push('/web/mobile');
	            window.location.reload();
	          } else if (data.status === 'success' && data.page_source === "otp_screen") {
	            localStorage.setItem('mobile_number', data.mobile);
	            _reactRouter.browserHistory.push('/web/mobile/verify_otp');
	            window.location.reload();
	          }
	        },
	        error: function error(err) {
	          // console.log(err);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      (0, _jquery2.default)('#num_input').keyup(function () {
	        (0, _jquery2.default)('#num_err').text('');
	      });
	      localStorage.removeItem('h_type');
	      (0, _jquery2.default)(window).scrollTop(10);
	      document.title = "AquaDeals Registration - You find,buy best deals by register with us";
	      document.getElementsByTagName("META")[2].content = "You find,buy best deals by register with us";
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          mobile = _props.fields.mobile;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'lgt_gry web_deals web_reg_page' },
	        _react2.default.createElement(_WebHeaderInner2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'container dels_cntnt' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 del_rgt' },
	              _react2.default.createElement(
	                'div',
	                { className: 'del_rgt_blk' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'del_dtl' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: '' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-6 col-md-offset-3' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: '' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'newlogin_logo' },
	                          _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png', alt: ' ' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'enquire_form signup_blk proced_blk', style: { marginLeft: '40px', marginRight: '40px' } },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                          ),
	                          _react2.default.createElement(
	                            'form',
	                            { className: 'mtrl_elmnts login_blk', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-md-12' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-10 col-md-offset-1' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'group' },
	                                  _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cell_dl.png', alt: '', style: { position: 'absolute', top: '9px', left: '0px' } }),
	                                  _react2.default.createElement('input', _extends({ type: 'text' }, mobile, { id: 'num_input', placeholder: 'Enter Mobile', required: true, maxLength: 10 })),
	                                  _react2.default.createElement('span', { className: 'highlight' }),
	                                  _react2.default.createElement('span', { className: 'bar' }),
	                                  _react2.default.createElement('span', { style: { color: 'red' }, id: 'num_err' })
	                                ),
	                                _react2.default.createElement(
	                                  'button',
	                                  { action: 'submit', className: 'btn web_reg_btn', id: 'reg_btn' },
	                                  'PROCEED ',
	                                  _react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_WebFooter2.default, null)
	      );
	    }
	  }]);
	
	  return Web_Registration;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    errorMessage: state.auth.error,
	    authenticated: state.auth.authenticated,
	    formdata: state.auth.formdata
	  };
	}
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'register',
	  fields: ['mobile']
	}, mapStateToProps, actions)(Web_Registration);
	
	var FbLogo = function (_Component2) {
	  _inherits(FbLogo, _Component2);
	
	  function FbLogo() {
	    _classCallCheck(this, FbLogo);
	
	    return _possibleConstructorReturn(this, (FbLogo.__proto__ || Object.getPrototypeOf(FbLogo)).apply(this, arguments));
	  }
	
	  _createClass(FbLogo, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('img', { src: "https://aquadeals.in/admin/assets/icons/web_icons/fb-lgn.png", width: '50px', alt: ' ' });
	    }
	  }]);
	
	  return FbLogo;
	}(_react.Component);

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(36);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import {connect} from 'react-redux';
	
	
	// import Signup_module from './modules/signup_module.js';
	
	
	var Web_Signup = function (_Component) {
	  _inherits(Web_Signup, _Component);
	
	  function Web_Signup(props) {
	    _classCallCheck(this, Web_Signup);
	
	    var _this = _possibleConstructorReturn(this, (Web_Signup.__proto__ || Object.getPrototypeOf(Web_Signup)).call(this, props));
	
	    _this.state = {
	      mobile: localStorage.mobile_number,
	      err_email: '',
	      err_tnc: '',
	      input_opt: false,
	      ref_status: false
	    };
	
	    return _this;
	  }
	
	  _createClass(Web_Signup, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // Load reCAPTCHA script
	      var script = document.createElement('script');
	      script.src = 'https://www.google.com/recaptcha/api.js';
	      script.async = true;
	      script.defer = true;
	      script.onload = function () {
	        return _this2.setState({ recaptchaLoaded: true });
	      };
	      document.body.appendChild(script);
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.clear_state();
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      var mobile = localStorage.getItem('mobile_number');
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      var data1 = { from: 'desktop_web', mobile: mobile, name: formProps.name, password: formProps.password, email: formProps.email, referral: formProps.refcode, device: '', version: '', platform: '', device_id: localStorage.getItem('push_device_id') };
	      var data2 = JSON.stringify(data1);
	
	      var flag = 0;
	      var emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
	      var namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
	      if (formProps.name && !namePattern.test(formProps.name)) {
	        (0, _jquery2.default)('#name_err').text('Enter minimum 3 characters');
	        flag = 1;
	      }
	      if (formProps.password.length < 4) {
	        (0, _jquery2.default)('#pwd_err').text('Minmum 4 characters');
	        flag = 1;
	      }
	      if (formProps.email && !emailPattern.test(formProps.email)) {
	        (0, _jquery2.default)('#email_err').text('Enter a valid email');
	        flag = 1;
	      }
	      if (!formProps.tnc) {
	        (0, _jquery2.default)('#tnc_err').text('Please accept Terms and conditions');
	        flag = 1;
	      }
	
	      var recaptchaResponse = document.getElementById('g-recaptcha-response').value;;
	
	      if (!recaptchaResponse) {
	        (0, _jquery2.default)('#captcha_err').text('Please complete the reCAPTCHA');
	        flag = 1;
	      }
	
	      if (flag === 0) {
	        var button = (0, _jquery2.default)('.signup_btn');
	        button.html("loading...");
	        button.prop("disabled", true);
	        _jquery2.default.ajax({
	          method: 'POST',
	          url: baseUrl + 'signup',
	          dataType: 'json',
	          data: { req: data2 },
	          success: function success(data) {
	            button.prop("disabled", false);
	            button.html("create account");
	            if (data.status === 'referror') {
	              (0, _jquery2.default)("#ref_err").text(data.message);
	            }
	            if (data.status === 'error') {
	              (0, _jquery2.default)("#email_err").text(data.message);
	            }
	            if (data.status === 'success') {
	              localStorage.setItem('pwd', data.pwd);
	              _reactRouter.browserHistory.push('/web/Otpverify');
	              window.location.reload();
	            }
	          },
	          error: function error(err) {
	            button.prop("disabled", false);
	            button.html("create account");
	          }
	        });
	        this.setState = {
	          mobile: localStorage.mobile_number
	        };
	      }
	    }
	  }, {
	    key: 'onBlur_email',
	    value: function onBlur_email(event) {
	      if (event.target.value.length > 0) {
	        this.setState({
	          isFocused_email: true
	        });
	      }
	    }
	  }, {
	    key: 'onBlur_refer',
	    value: function onBlur_refer(event) {
	      if (event.target.value.length > 0) {
	        this.setState({
	          isFocused_refer: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.formdata.status === 'referror') {}
	
	      if (newProps.formdata.status === 'error') {
	        this.setState({
	          err_email: newProps.formdata.message
	        });
	      }
	      if (newProps.formdata.status === 'success') {
	        localStorage.setItem('pwd', newProps.formdata.pwd);
	        //localStorage.setItem('token',newProps.formdata.user[0].token);
	        _reactRouter.browserHistory.push('/web/Otpverify');
	        //window.location.reload();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      (0, _jquery2.default)('#ref_input').keyup(function () {
	        (0, _jquery2.default)('#ref_err').text('');
	      });
	      (0, _jquery2.default)('#email_input').keyup(function () {
	        (0, _jquery2.default)('#email_err').text('');
	      });
	      (0, _jquery2.default)('#name_input').keyup(function () {
	        (0, _jquery2.default)('#name_err').text('');
	      });
	      (0, _jquery2.default)('#pwd_input').keyup(function () {
	        (0, _jquery2.default)('#pwd_err').text('');
	      });
	      (0, _jquery2.default)('#web_tnc_input').click(function () {
	        (0, _jquery2.default)('#tnc_err').text('');
	      });
	      (0, _jquery2.default)(document).on('click', '#recaptcha-anchor', function () {
	        (0, _jquery2.default)('#captcha_err').text('');
	      });
	      var classes = [];
	      if (this.state.isFocused_email) {
	        classes.push('testblur');
	      }
	      if (this.state.isFocused_refer) {
	        classes.push('testblur');
	      }
	      document.title = "AquaDeals Registration - You find,buy best deals by register with us";
	      document.getElementsByTagName("META")[2].content = "You find,buy best deals by register with us";
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          _props$fields = _props.fields,
	          name = _props$fields.name,
	          password = _props$fields.password,
	          email = _props$fields.email,
	          refcode = _props$fields.refcode,
	          tnc = _props$fields.tnc;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'lgt_gry web_deals web_signup_page' },
	        _react2.default.createElement(_WebHeaderInner2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'container dels_cntnt' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 del_rgt' },
	              _react2.default.createElement(
	                'div',
	                { className: 'del_rgt_blk' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'del_dtl' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'clr' },
	                    '\xA0'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: '' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-6 col-md-offset-3' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'thumbnail', style: { overflow: 'hidden' } },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'newlogin_logo' },
	                          _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png', alt: ' ' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'enquire_form signup_blk proced_blk' },
	                          _react2.default.createElement(
	                            'form',
	                            { className: 'mtrl_elmnts login_blk ', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)), name: 'login' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'group form_fields' },
	                              _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cell_dl.png', alt: '', style: { position: 'absolute', top: '11px', left: '0px' } }),
	                              _react2.default.createElement('input', { type: 'text', placeholder: 'Mobile Number', ref: 'mobile', value: this.state.mobile, disabled: true }),
	                              _react2.default.createElement('span', { className: 'highlight' }),
	                              _react2.default.createElement('span', { className: 'bar' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'group form_fields' },
	                              _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/user.png', alt: '', style: { position: 'absolute', top: '11px', left: '0px' } }),
	                              _react2.default.createElement('input', _extends({ type: 'text', placeholder: 'Name', id: 'name_input', required: true }, name, { ref: 'name' })),
	                              _react2.default.createElement('span', { className: 'highlight' }),
	                              _react2.default.createElement('span', { className: 'bar' }),
	                              _react2.default.createElement('span', { id: 'name_err' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'group form_fields' },
	                              _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/lock.png', alt: '', style: { position: 'absolute', top: '11px', left: '0px' } }),
	                              _react2.default.createElement('input', _extends({ type: 'password', placeholder: 'Password', required: true }, password, { id: 'pwd_input', ref: 'pwd' })),
	                              _react2.default.createElement('span', { className: 'highlight' }),
	                              _react2.default.createElement('span', { className: 'bar' }),
	                              _react2.default.createElement('span', { id: 'pwd_err' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'group form_fields' },
	                              _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/lock.png', alt: '', style: { position: 'absolute', top: '11px', left: '0px' } }),
	                              _react2.default.createElement('input', _extends({ type: 'text', placeholder: 'Email (Optional)' }, email, { id: 'email_input', ref: 'email' })),
	                              _react2.default.createElement('span', { className: 'highlight' }),
	                              _react2.default.createElement('span', { className: 'bar' }),
	                              _react2.default.createElement('span', { id: 'email_err' })
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'group form_fields ref_code' },
	                              _react2.default.createElement(
	                                'a',
	                                { onClick: function onClick() {
	                                    _this3.setState({ ref_status: true });
	                                  } },
	                                'Have a referral code?'
	                              )
	                            ),
	                            this.state.ref_status ? _react2.default.createElement(
	                              'div',
	                              { className: 'group form_fields mtrl_inpt_optn ' },
	                              _react2.default.createElement('input', _extends({ type: 'text', placeholder: 'Referral Code(Optional)', id: 'ref_input' }, refcode, { ref: 'refer', onBlur: this.onBlur_refer.bind(this), onSubmit: this.onBlur_refer.bind(this), className: classes.join(' ') })),
	                              _react2.default.createElement('span', { className: 'highlight' }),
	                              _react2.default.createElement('span', { className: 'bar' }),
	                              _react2.default.createElement('span', { id: 'ref_err' })
	                            ) : '',
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'web_check' },
	                              _react2.default.createElement('input', _extends({ type: 'checkbox', value: 'checked' }, tnc, { id: 'web_tnc_input' })),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'web_signup_note' },
	                                'I accept & agree ',
	                                _react2.default.createElement(
	                                  'a',
	                                  { href: 'https://aqua.deals/terms.html', target: '_blank' },
	                                  'Terms of Services'
	                                )
	                              ),
	                              _react2.default.createElement('div', { id: 'tnc_err' })
	                            ),
	                            _react2.default.createElement('div', { className: 'g-recaptcha', 'data-sitekey': '6LeoplwUAAAAAIoBTSeogNosrRo_uRpFmJh-e3fr' }),
	                            _react2.default.createElement('div', { id: 'captcha_err' }),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'clr' },
	                              '\xA0'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'text-center' },
	                              _react2.default.createElement(
	                                'button',
	                                { action: 'submit', className: 'btn web_signup_btn', style: { width: '50%' } },
	                                'Sign Up ',
	                                _react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'clr' },
	                              '\xA0'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'clr' },
	                              '\xA0'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'clr' },
	                    '\xA0'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'clr' },
	                    '\xA0'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          )
	        ),
	        _react2.default.createElement(_WebFooter2.default, null)
	      );
	    }
	  }]);
	
	  return Web_Signup;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    errorMessage: state.auth.error,
	    authenticated: state.auth.authenticated,
	    formdata: state.auth.formdata
	  };
	}
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'Otpverify',
	  fields: ['name', 'password', 'email', 'refcode', 'tnc']
	}, mapStateToProps, actions)(Web_Signup);

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Web_Ab_Login = function (_Component) {
	  _inherits(Web_Ab_Login, _Component);
	
	  function Web_Ab_Login(props, context) {
	    _classCallCheck(this, Web_Ab_Login);
	
	    var _this = _possibleConstructorReturn(this, (Web_Ab_Login.__proto__ || Object.getPrototypeOf(Web_Ab_Login)).call(this, props));
	
	    _this.router = context.router;
	    _this.state = {
	      err: false,
	      err_mob: false,
	      err_pass: false,
	      invalid_pass: '',
	      invalid_num: '',
	      ab_modal: false
	    };
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.onMobileChange = _this.onMobileChange.bind(_this);
	    _this.close = _this.close.bind(_this);
	    _this.redLogin = _this.redLogin.bind(_this);
	    return _this;
	  }
	
	  _createClass(Web_Ab_Login, [{
	    key: 'close',
	    value: function close() {
	      this.setState({
	        ab_modal: true
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(event) {
	      event.preventDefault();
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      localStorage.setItem('mobile_number', this.refs.mobile.value);
	      var data1 = {
	        from: 'desktop_web',
	        mobile: this.refs.mobile.value,
	        password: this.refs.pass.value,
	        version: '',
	        device_id: localStorage.getItem('push_device_id'),
	        platform: ''
	
	      };
	      var data2 = JSON.stringify(data1);
	
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'signupAB',
	        data: { req: data2 },
	        dataType: 'json',
	        success: function (data) {
	          if (data.status === 'error' && data.message === "Mobile number already registered with AquaDeals") {
	            this.setState({
	              ab_modal: true
	            });
	          }
	          if (data.status === 'success') {
	            localStorage.setItem('token', data.result[0].token);
	            localStorage.setItem('user_id', data.result[0].id);
	            _reactRouter.browserHistory.push('/web/home');
	          }
	          if (data.status === 'error') {
	            this.setState({
	              err: true,
	              invalid_num: data.message
	            });
	          }
	        }.bind(this),
	        error: function error(err) {
	          // console.log("AB Login Fail"+err);
	        }
	      });
	    }
	  }, {
	    key: 'redLogin',
	    value: function redLogin() {
	      _reactRouter.browserHistory.push('/web/account');
	      window.location.reload();
	    }
	  }, {
	    key: 'onMobileChange',
	    value: function onMobileChange(event) {
	      var invalidChars = /[^0-9]/gi;
	      if (invalidChars.test(event.target.value)) {
	        event.target.value = event.target.value.replace(invalidChars, "");
	      } else {
	        this.setState({
	          err: true
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      localStorage.removeItem('h_type');
	      return _react2.default.createElement(
	        'div',
	        { className: 'lgt_gry web_deals web_ab_login_page' },
	        _react2.default.createElement(_WebHeaderInner2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'container dels_cntnt' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 del_rgt' },
	              _react2.default.createElement(
	                'div',
	                { className: 'del_rgt_blk' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'del_dtl' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: '' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-6 col-md-offset-3' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'thumbnail' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'enquire_form signup_blk' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'login_logo', style: { textAlign: 'center', marginBottom: 20 + 'px' } },
	                            _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/ab-logo.png', title: '', alt: 'Aquadeals' })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'login_form' },
	                            _react2.default.createElement(
	                              'form',
	                              { onSubmit: this.handleSubmit, className: 'mtrl_elmnts' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'group' },
	                                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/ab_cell_dl.png', alt: '', style: { position: 'absolute', top: '11px', left: '0px' } }),
	                                _react2.default.createElement('input', { type: 'text', required: true, ref: 'mobile', placeholder: 'Mobile Number', maxLength: 10, onChange: this.onMobileChange }),
	                                _react2.default.createElement('span', { className: 'highlight' }),
	                                _react2.default.createElement('span', { className: 'bar' }),
	                                this.state.err ? this.state.invalid_num : ''
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'group' },
	                                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/ab_pass.png', alt: '', style: { position: 'absolute', top: '11px', left: '0px' } }),
	                                _react2.default.createElement('input', { type: 'password', placeholder: 'Password', ref: 'pass', required: true }),
	                                _react2.default.createElement('span', { className: 'highlight' }),
	                                _react2.default.createElement('span', { className: 'bar' }),
	                                this.state.err_pass ? this.state.invalid_pass : ''
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'button',
	                                  { type: 'submit', className: 'btn web_ab_login_btn', onSubmit: this.handleSubmit },
	                                  'Enter ',
	                                  _react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'clr' },
	                          '\xA0'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'clr' },
	              '\xA0'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'clr' },
	              '\xA0'
	            )
	          )
	        ),
	        _react2.default.createElement(_WebFooter2.default, null),
	        _react2.default.createElement(
	          _reactBootstrap.Modal,
	          { className: 'web_ab_login_modal', show: this.state.ab_modal, onHide: this.close },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	              'h4',
	              { style: { fontSize: 14 + 'px', color: '#222' } },
	              'You are already registered with AquaDeals.'
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { style: { border: 'none', background: '#fff none repeat scroll 0 0', color: 'green', float: 'right' }, onClick: this.redLogin },
	              'OK'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Web_Ab_Login;
	}(_react.Component);
	
	exports.default = Web_Ab_Login;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './../../assets/index.css';
	
	
	var Web_Forgot = function (_Component) {
	  _inherits(Web_Forgot, _Component);
	
	  function Web_Forgot(props, context) {
	    _classCallCheck(this, Web_Forgot);
	
	    var _this = _possibleConstructorReturn(this, (Web_Forgot.__proto__ || Object.getPrototypeOf(Web_Forgot)).call(this, props));
	
	    _this.router = context.router;
	    _this.state = {
	      token: localStorage.token,
	      err: false,
	      invalid_num: ''
	    };
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.onMobileChange = _this.onMobileChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(Web_Forgot, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(event) {
	      event.preventDefault();
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      // var mobile= this.refs.mobile.value;
	      var data1 = {
	        from: 'desktop_web',
	        mobile: this.refs.mobile.value,
	        device_id: localStorage.getItem('push_device_id')
	      };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'forgotOtp',
	        data: { req: data2 },
	        dataType: 'json',
	        success: function (data) {
	          // console.log(data);
	          if (data.status === "success") {
	            localStorage.setItem('mobile', data.mobile);
	            this.setState({
	              err: false
	            });
	            _reactRouter.browserHistory.push('/web/verify');
	            window.location.reload();
	          } else if (data.status === 'fail') {
	            this.setState({
	              err: true,
	              invalid_num: data.msg
	            });
	          } else if (data.status === 'Mobile number is not registerd with us') {
	            this.setState({
	              err: true,
	              invalid_num: data.status
	            });
	          }
	        }.bind(this),
	        error: function error(err) {
	          // console.log("Forgot Password" + err);
	        }
	
	      });
	    }
	  }, {
	    key: 'onMobileChange',
	    value: function onMobileChange(event) {
	      var invalidChars = /[^0-9]/gi;
	      if (invalidChars.test(event.target.value)) {
	        event.target.value = event.target.value.replace(invalidChars, "");
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      localStorage.removeItem('h_type');
	      return _react2.default.createElement(
	        'div',
	        { className: 'lgt_gry' },
	        _react2.default.createElement(_WebHeaderInner2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'container dels_cntnt' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 del_rgt' },
	              _react2.default.createElement(
	                'div',
	                { className: 'del_rgt_blk' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'del_dtl' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: '' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-6 col-md-offset-3' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'thumbnail' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'enquire_form signup_blk proced_blk' },
	                          _react2.default.createElement(
	                            'h5',
	                            { className: 'mob_nmbr_title' },
	                            'Submit your Mobile Number to Reset Password'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                          ),
	                          _react2.default.createElement(
	                            'form',
	                            { className: 'mtrl_elmnts', onSubmit: this.handleSubmit },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-md-12 col-xs-12 col-sm-12' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 col-xs-12 col-sm-12' },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'group' },
	                                  _react2.default.createElement('input', { type: 'text', maxLength: 10, required: true, ref: 'mobile', onChange: this.onMobileChange }),
	                                  _react2.default.createElement('span', { className: 'highlight' }),
	                                  _react2.default.createElement('span', { className: 'bar' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    this.state.err ? this.state.invalid_num : ''
	                                  ),
	                                  _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'Mobile'
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'clr' },
	                              '\xA0'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { style: { border: 'none', overflow: 'hidden' } },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 col-xs-12 col-sm-12 proced_btn' },
	                                _react2.default.createElement(
	                                  'button',
	                                  { action: 'submit', className: 'btn signup_btn', onSubmit: this.handleSubmit },
	                                  'Submit'
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'clr' },
	                    '\xA0'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'clr' },
	                    '\xA0'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          )
	        ),
	        _react2.default.createElement(_WebFooter2.default, null)
	      );
	    }
	  }]);
	
	  return Web_Forgot;
	}(_react.Component);
	
	exports.default = Web_Forgot;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Web_Login = function (_Component) {
	  _inherits(Web_Login, _Component);
	
	  function Web_Login(props, context) {
	    _classCallCheck(this, Web_Login);
	
	    // this.router = context.router;
	    var _this = _possibleConstructorReturn(this, (Web_Login.__proto__ || Object.getPrototypeOf(Web_Login)).call(this, props));
	
	    _this.state = {
	      error: false,
	      err: false,
	      err_pass: false,
	      not_reg: '',
	      invalid_pass: '',
	      myNumber: '',
	      mobile: localStorage.mobile_number
	    };
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.onMobileChange = _this.onMobileChange.bind(_this);
	    _this.passwordChange = _this.passwordChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(Web_Login, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (localStorage.token && localStorage.user_id) {
	        _reactRouter.browserHistory.push('/web/home');
	      }
	      this.refs.pass.focus();
	    }
	  }, {
	    key: 'passwordChange',
	    value: function passwordChange() {
	      this.setState({
	        invalid_pass: ''
	      });
	    }
	  }, {
	    key: 'verify_otp',
	    value: function verify_otp() {
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      var data1 = { from: 'desktop_web', mobile: this.state.mobile, device_id: localStorage.getItem('push_device_id') };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'forgotOtp',
	        data: { req: data2 },
	        dataType: 'json',
	        success: function (data) {
	          if (data.status === "success") {
	            localStorage.setItem('mobile', data.mobile);
	            this.setState({
	              err: false
	            });
	            _reactRouter.browserHistory.push('/web/verify');
	            window.location.reload();
	          } else if (data.status === 'fail') {
	            this.setState({
	              err: true,
	              invalid_num: data.msg
	            });
	          } else if (data.status === 'Mobile number is not registerd with us') {
	            this.setState({
	              err: true,
	              invalid_num: data.status
	            });
	          }
	        }.bind(this),
	        error: function error(err) {
	          // console.log("Forgot Password" + err);
	        }
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(event) {
	      event.preventDefault();
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      var data1 = { from: 'desktop_web', mobile: this.refs.mobile.value, password: this.refs.pass.value, version: '', device_id: localStorage.getItem('push_device_id'), platform: '' };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'login',
	        data: { req: data2 },
	        dataType: 'json',
	        success: function (data) {
	          if (data.status === "success") {
	            localStorage.setItem('token', data.result[0].token);
	            localStorage.setItem('user_id', data.result[0].id);
	            localStorage.setItem('user_name', data.result[0].name);
	            localStorage.setItem('user_mobile', data.result[0].mobile);
	            localStorage.setItem('user_email', data.result[0].email);
	          } else if (data.status === "Invalid password") {
	            this.setState({
	              err_pass: 'true',
	              invalid_pass: data.status,
	              not_reg: ''
	            });
	          } else if (data.status === "Mobile number is not registerd with us") {
	            this.setState({
	              err: 'true',
	              not_reg: data.status,
	              invalid_pass: ''
	            }).bind(this);
	          } else if (data.status === "fail") {
	            this.setState({
	              err: 'true',
	              invalid_pass: '',
	              not_reg: data.message
	            }).bind(this);
	          } else {
	            this.setState({
	              err: 'true',
	              err_pass: 'true'
	            });
	          }
	          if (localStorage.token && localStorage.w_r_s_dt) {
	            _reactRouter.browserHistory.push(localStorage.w_r_s_dt);
	          }
	          if (localStorage.token && localStorage.w_r_e_coupon_dt) {
	            _reactRouter.browserHistory.push(localStorage.w_r_e_coupon_dt);
	          }
	          if (localStorage.token && localStorage.w_r_e_s_dt) {
	            _reactRouter.browserHistory.push(localStorage.w_r_e_s_dt);
	            // window.location.reload();
	          }
	          if (localStorage.token && localStorage.web_mycart) {
	            _reactRouter.browserHistory.push(localStorage.web_mycart);
	            // window.location.reload();
	          }
	          if (localStorage.token && localStorage.w_r_enq_seller_page) {
	            _reactRouter.browserHistory.push(localStorage.w_r_enq_seller_page);
	          }
	          if (localStorage.token && localStorage.w_r_p_dt) {
	            _reactRouter.browserHistory.push(localStorage.w_r_p_dt);
	            // window.location.reload();
	          }
	          if (localStorage.token && localStorage.w_r_e_p_dt) {
	            _reactRouter.browserHistory.push(localStorage.w_r_e_p_dt);
	            // window.location.reload();
	          }
	          if (localStorage.token && localStorage.web_ofr_page) {
	            _reactRouter.browserHistory.push(localStorage.web_ofr_page);
	          }
	          if (localStorage.token && localStorage.profile) {
	            _reactRouter.browserHistory.push(localStorage.profile);
	            // window.location.reload();
	          }
	          if (localStorage.token && localStorage.myaquacash) {
	            _reactRouter.browserHistory.push(localStorage.myaquacash);
	            // window.location.reload();
	          }
	          if (localStorage.token && localStorage.web_share_earn) {
	            _reactRouter.browserHistory.push(localStorage.web_share_earn);
	            // window.location.reload();
	          }
	          if (localStorage.token && localStorage.checkout) {
	            _reactRouter.browserHistory.push(localStorage.checkout);
	            // window.location.reload();
	          }
	          if (localStorage.token && localStorage.order_details) {
	            _reactRouter.browserHistory.push(localStorage.order_details);
	          }
	          if (localStorage.token && localStorage.myorders) {
	            _reactRouter.browserHistory.push(localStorage.myorders);
	          }
	          if (localStorage.token && localStorage.w_r_p_deals) {
	            _reactRouter.browserHistory.push(localStorage.w_r_p_deals);
	          }
	          if (localStorage.token && localStorage.seed) {
	            _reactRouter.browserHistory.push(localStorage.seed);
	          }
	          if (localStorage.token && localStorage.nauplii) {
	            _reactRouter.browserHistory.push(localStorage.nauplii);
	          }
	          if (localStorage.token && localStorage.subdeals) {
	            _reactRouter.browserHistory.push(localStorage.subdeals);
	          }
	          if (localStorage.token && localStorage.offers) {
	            _reactRouter.browserHistory.push(localStorage.offers);
	          }
	          if (localStorage.token && localStorage.shipping) {
	            _reactRouter.browserHistory.push(localStorage.shipping);
	          }
	          if (localStorage.token && localStorage.notifications) {
	            _reactRouter.browserHistory.push(localStorage.notifications);
	          }
	          if (localStorage.token && localStorage.web_quickcart) {
	            _reactRouter.browserHistory.push(localStorage.web_quickcart);
	          }
	          if (localStorage.token && localStorage.view_rating) {
	            _reactRouter.browserHistory.push(localStorage.view_rating);
	          }
	          if (localStorage.token && localStorage.give_rating) {
	            _reactRouter.browserHistory.push(localStorage.give_rating);
	          }
	          if (localStorage.token && localStorage.w_modal_seed) {
	            _reactRouter.browserHistory.push(localStorage.w_modal_seed);
	          }
	          if (localStorage.token && localStorage.w_r_seed_deals) {
	            _reactRouter.browserHistory.push(localStorage.w_r_seed_deals);
	          }
	          if (localStorage.token && localStorage.w_r_e_p_dt) {
	            _reactRouter.browserHistory.push(localStorage.w_r_e_p_dt);
	          }
	          if (localStorage.token && localStorage.w_modal_details) {
	            _reactRouter.browserHistory.push(localStorage.w_modal_details);
	          }
	          if (localStorage.token && localStorage.web_pro_ofr_dtls) {
	            _reactRouter.browserHistory.push(localStorage.web_pro_ofr_dtls);
	          }
	          if (localStorage.token && localStorage.web_smartcart) {
	            _reactRouter.browserHistory.push(localStorage.web_smartcart);
	          }
	          if (localStorage.token && localStorage.web_wishlist) {
	            _reactRouter.browserHistory.push(localStorage.web_wishlist);
	          }
	          if (localStorage.token && localStorage.web_brand_details) {
	            _reactRouter.browserHistory.push(localStorage.web_brand_details);
	          } else if (localStorage.token && data.status === "success" && !localStorage.w_r_s_dt && !localStorage.w_r_p_dt && !localStorage.w_r_e_s_dt && !localStorage.w_r_e_p_dt && !localStorage.w_r_seed_deals && !localStorage.w_r_p_deals && !localStorage.w_r_e_coupon_dt && !localStorage.w_modal_details && !localStorage.w_r_enq_seller_page && !localStorage.web_mycart && !localStorage.shipping && !localStorage.order_details && !localStorage.view_rating && !localStorage.give_rating && !localStorage.myorders && !localStorage.web_quickcart && !localStorage.checkout && !localStorage.profile && !localStorage.web_share_earn && !localStorage.myaquacash && !localStorage.notifications && !localStorage.web_ofr_page && !localStorage.seed && !localStorage.nauplii && !localStorage.subdeals && !localStorage.offers && !localStorage.web_pro_ofr_dtls && !localStorage.web_smartcart && !localStorage.web_wishlist && !localStorage.web_brand_details) {
	            _reactRouter.browserHistory.push('/web/home');
	          }
	          if (localStorage.token && localStorage.getItem('redirect_url')) {
	            _reactRouter.browserHistory.push(localStorage.getItem('redirect_url'));
	          }
	        }.bind(this),
	        error: function error(err) {
	          // console.log("Login error" + err);
	        }
	      });
	    }
	  }, {
	    key: 'onMobileChange',
	    value: function onMobileChange(event) {
	      var invalidChars = /[^0-9]/gi;
	      if (invalidChars.test(event.target.value)) {
	        event.target.value = event.target.value.replace(invalidChars, "");
	      } else {
	        this.setState({
	          err: true
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      (0, _jquery2.default)(window).scrollTop(0);
	      localStorage.removeItem('h_type');
	      return _react2.default.createElement(
	        'div',
	        { className: 'lgt_gry web_deals web_login_page' },
	        _react2.default.createElement(_WebHeaderInner2.default, null),
	        '// ',
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        '// ',
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'container dels_cntnt log_web_blk' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 del_rgt' },
	              _react2.default.createElement(
	                'div',
	                { className: 'del_rgt_blk' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'del_dtl' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: '' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-6 col-md-offset-3' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'thumbnail' },
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'newlogin_logo' },
	                            _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png', alt: ' ' })
	                          ),
	                          _react2.default.createElement(
	                            'form',
	                            { className: 'mtrl_elmnts', onSubmit: this.handleSubmit },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-md-12' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'group' },
	                                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cell_dl.png', alt: '', style: { position: 'absolute', top: '9px', left: '0px' } }),
	                                _react2.default.createElement('input', { type: 'text', value: this.state.mobile, placeholder: 'Mobile Number', ref: 'mobile', maxLength: 10, onChange: this.onMobileChange, required: true }),
	                                _react2.default.createElement('span', { className: 'highlight' }),
	                                _react2.default.createElement('span', { className: 'bar' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { style: { color: 'red' } },
	                                  this.state.err ? this.state.not_reg : ''
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'group' },
	                                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/lock.png', alt: '', style: { position: 'absolute', top: '11px', left: '0px' } }),
	                                _react2.default.createElement('input', { type: 'password', placeholder: 'Password', ref: 'pass', required: true, onChange: this.passwordChange }),
	                                _react2.default.createElement('span', { className: 'highlight' }),
	                                _react2.default.createElement('span', { className: 'bar' }),
	                                _react2.default.createElement(
	                                  'span',
	                                  { style: { color: 'red' } },
	                                  this.state.err_pass ? this.state.invalid_pass : ''
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'button',
	                                  { onSubmit: this.handleSubmit.bind(this), action: 'submit', className: 'btn web_lgn_btn' },
	                                  'Enter ',
	                                  _react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'clr' },
	                                '\xA0'
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'forgot_pasword' },
	                                _react2.default.createElement(
	                                  'h5',
	                                  null,
	                                  'Forgot your password?'
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'tap' },
	                                  _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { onClick: this.verify_otp.bind(this), style: { cursor: 'pointer' } },
	                                    'Tap here to reset password'
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'clr' },
	                          '\xA0'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'clr' },
	                    '\xA0'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'clr' },
	                    '\xA0'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          )
	        ),
	        _react2.default.createElement(_WebFooter2.default, null)
	      );
	    }
	  }]);
	
	  return Web_Login;
	}(_react.Component);
	
	exports.default = Web_Login;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(36);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import $ from 'jquery';
	
	var Web_MobileNumber = function (_Component) {
	  _inherits(Web_MobileNumber, _Component);
	
	  function Web_MobileNumber(props) {
	    _classCallCheck(this, Web_MobileNumber);
	
	    var _this = _possibleConstructorReturn(this, (Web_MobileNumber.__proto__ || Object.getPrototypeOf(Web_MobileNumber)).call(this, props));
	
	    _this.state = {
	      status: '',
	      msg: ''
	    };
	    _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(Web_MobileNumber, [{
	    key: 'renderAlert',
	    value: function renderAlert() {
	      if (this.props.errorMessage) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'error' },
	          _react2.default.createElement('strong', null),
	          this.props.errorMessage
	        );
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.formdata.status === 'success' && newProps.formdata.page === "otp") {
	        localStorage.setItem('pwd', newProps.formdata.pwd);
	        localStorage.setItem('mobile_number', newProps.formdata.mobile);
	        // browserHistory.push('/verify');
	        // window.location.reload();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (localStorage.token && localStorage.user_id) {
	        _reactRouter.browserHistory.push('/web/home');
	      }
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      localStorage.setItem('mobile_number', this.refs.mobile_num.value);
	      this.props.mobileNumber(formProps);
	      this.setState({
	        status: this.props.formdata.status
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          mobile = _props.fields.mobile;
	
	      document.title = "AquaDeals Registration - You find,buy best deals by register with us";
	      document.getElementsByTagName("META")[2].content = "You find,buy best deals by register with us";
	      return _react2.default.createElement(
	        'div',
	        { className: 'lgt_gry web_deals web_scl_regpage' },
	        _react2.default.createElement(_WebHeaderInner2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'container dels_cntnt' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 del_rgt' },
	              _react2.default.createElement(
	                'div',
	                { className: 'del_rgt_blk' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'clr' },
	                  '\xA0'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'del_dtl' },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { marginLeft: '20px', marginRight: '20px' } },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-6 col-md-offset-3' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'thumbnail' },
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'newlogin_logo' },
	                            _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png', alt: ' ' })
	                          ),
	                          _react2.default.createElement(
	                            'form',
	                            { className: 'mtrl_elmnts login_blk', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-md-12' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-10', style: { marginLeft: '30px' } },
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'group' },
	                                  _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cell_dl.png', alt: '', style: { position: 'absolute', top: '11px', left: '0px' } }),
	                                  _react2.default.createElement('input', _extends({ placeholder: 'Enter Mobile' }, mobile, { type: 'text', required: true, maxLength: 10, ref: 'mobile_num' })),
	                                  _react2.default.createElement('span', { className: 'highlight' }),
	                                  _react2.default.createElement('span', { className: 'bar' }),
	                                  _react2.default.createElement(
	                                    'span',
	                                    { style: { color: 'red', fontSize: '12px' }, id: 'num_err' },
	                                    mobile.touched && mobile.error ? mobile.error : ''
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'button',
	                                  { action: 'submit', className: 'btn web_scl_reg_btn', id: 'reg_btn' },
	                                  'PROCEED ',
	                                  _react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'clr' },
	                              '\xA0'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'clr' },
	                              '\xA0'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'clr' },
	                    '\xA0'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'clr' },
	                    '\xA0'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          )
	        ),
	        _react2.default.createElement(_WebFooter2.default, null)
	      )
	      //ending 
	
	      ;
	    }
	  }]);
	
	  return Web_MobileNumber;
	}(_react.Component);
	
	function validate(formProps) {
	  var errors = {};
	
	  var mobile_Pattern = /^([0-9]){10}$/;
	  if (formProps.mobile && !mobile_Pattern.test(formProps.mobile)) {
	    errors.mobile = 'Enter valid mobile number';
	  }
	
	  return errors;
	}
	
	function mapStateToProps(state) {
	  return {
	    errorMessage: state.auth.error,
	    authenticated: state.auth.authenticated,
	    formdata: state.auth.formdata
	  };
	}
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'register',
	  fields: ['mobile'],
	  validate: validate
	
	}, mapStateToProps, actions)(Web_MobileNumber);

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Web_MobVerifyOtp = function (_Component) {
		_inherits(Web_MobVerifyOtp, _Component);
	
		function Web_MobVerifyOtp(props, context) {
			_classCallCheck(this, Web_MobVerifyOtp);
	
			var _this = _possibleConstructorReturn(this, (Web_MobVerifyOtp.__proto__ || Object.getPrototypeOf(Web_MobVerifyOtp)).call(this, props));
	
			_this.state = {
				mobile: localStorage.getItem('mobile_number'),
				invalid_otp: ''
			};
			_this.handleSubmit = _this.handleSubmit.bind(_this);
			_this.gotoLogin = _this.gotoLogin.bind(_this);
			_this.resendOtp = _this.resendOtp.bind(_this);
			return _this;
		}
	
		_createClass(Web_MobVerifyOtp, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.refs.otp.focus();
			}
		}, {
			key: 'resendOtp',
			value: function resendOtp() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', mobile: this.state.mobile };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'social_rsend_otp',
					data: { req: data2 },
					dataType: 'json',
					success: function success(data) {
						// console.log(data);
					},
					error: function error(err) {
						// console.log(err);
					}
				});
			}
		}, {
			key: 'handleSubmit',
			value: function handleSubmit(event) {
				event.preventDefault();
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', mobile: localStorage.getItem('mobile_number'), otp: this.refs.otp.value, device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'social_otp_auth',
					data: { req: data2 },
					dataType: 'json',
					success: function (data) {
						if (data.status === 'success' && data.page_source === "dashboard") {
							localStorage.setItem('token', data.token);
							localStorage.setItem('user_id', data.uid);
							_reactRouter.browserHistory.push('/web/home');
						}
						if (data.status === 'error') {
							this.setState({
								err: true,
								invalid_otp: 'OTP mis match'
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'gotoLogin',
			value: function gotoLogin(event) {
				event.preventDefault();
				_reactRouter.browserHistory.push('/web/login');
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'lgt_gry web_deals web_scl_verifyotp_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'container dels_cntnt' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12 del_rgt' },
								_react2.default.createElement(
									'div',
									{ className: 'del_rgt_blk' },
									_react2.default.createElement(
										'div',
										{ className: 'del_dtl' },
										_react2.default.createElement(
											'div',
											{ className: '' },
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-md-offset-3' },
												_react2.default.createElement(
													'div',
													{ className: 'clr' },
													'\xA0'
												),
												_react2.default.createElement(
													'div',
													{ className: 'clr' },
													'\xA0'
												),
												_react2.default.createElement(
													'div',
													{ className: 'thumbnail' },
													_react2.default.createElement(
														'div',
														{ className: 'newlogin_logo' },
														_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png', alt: ' ' })
													),
													_react2.default.createElement(
														'div',
														{ className: '' },
														_react2.default.createElement(
															'div',
															{ className: 'clr' },
															'\xA0'
														),
														_react2.default.createElement(
															'form',
															{ className: 'mtrl_elmnts', onSubmit: this.handleSubmit },
															_react2.default.createElement(
																'div',
																{ className: 'col-md-12' },
																_react2.default.createElement(
																	'div',
																	{ className: 'col-md-12' },
																	_react2.default.createElement(
																		'div',
																		{ className: 'group' },
																		_react2.default.createElement('input', { type: 'text', ref: 'otp', maxLength: 6, required: true, onChange: this.otpChange }),
																		_react2.default.createElement('span', { className: 'highlight' }),
																		_react2.default.createElement('span', { className: 'bar' }),
																		_react2.default.createElement(
																			'span',
																			{ style: { fontSize: '11px', color: 'red' } },
																			this.state.err ? this.state.invalid_otp : ''
																		),
																		_react2.default.createElement(
																			'label',
																			null,
																			'Enter OTP'
																		)
																	)
																),
																_react2.default.createElement(
																	'button',
																	{ onSubmit: this.handleSubmit.bind(this), action: 'submit', className: 'btn web_scl_verify_btn' },
																	'VERIFY ',
																	_react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'clr' },
																'\xA0'
															),
															_react2.default.createElement(
																'div',
																{ className: 'clr' },
																'\xA0'
															),
															_react2.default.createElement(
																'div',
																{ className: 'forgot_pasword' },
																_react2.default.createElement(
																	'h5',
																	null,
																	'Didn\'t recieve the OTP?'
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'tap' },
																	_react2.default.createElement(
																		'a',
																		{ onClick: this.resendOtp },
																		'Tap Here to Resend'
																	)
																)
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'clr' },
														'\xA0'
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										),
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_MobVerifyOtp;
	}(_react.Component);
	
	exports.default = Web_MobVerifyOtp;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Web_Reset = function (_Component) {
		_inherits(Web_Reset, _Component);
	
		function Web_Reset(props) {
			_classCallCheck(this, Web_Reset);
	
			var _this = _possibleConstructorReturn(this, (Web_Reset.__proto__ || Object.getPrototypeOf(Web_Reset)).call(this, props));
	
			_this.state = {
				mobile: localStorage.mobile,
				mobile_number: localStorage.mobile_number,
				password: '',
				confirm_password: '',
				err: false,
				err_pass: '',
				err_c_pass: '',
				mismatch: '',
	
				err_msg: ''
			};
			_this.handleSubmit = _this.handleSubmit.bind(_this);
			_this.passwordChange = _this.passwordChange.bind(_this);
			// this.confirmPassChange=this.confirmPassChange.bind(this);
			// this.validate=this.validate.bind(this);
			// this.onPassChange=this.onPassChange.bind(this);
			return _this;
		}
		// onPassChange(event){
		// 	// alert(event.target.value);
		// 	this.validation(event.target.value);
		// }
		// // validation(value){
		// 	console.log(value);
		// 	var valid_pass = this.validPass();
		// 	// var valid_c_pass = this.validCPass();
		// 	return ( valid_pass );
	
		// 	// if(value.length < 4 ){
		// 	// 	alert("Password must be more than 4 characters");
		// 	// }
		// 	// if(value=== '') {
		// 	// 	return "Required";
		// 	// }
	
		// }
	
		// handlePasswordInput(value){
		// 	this.setState({
		// 		password: value
		// 	});
		// 	var self= this;
		// 	window.setTimout(function(){
		// 		if(self.state.confirmPassword && self.state.confirmPassword.length) {
		// 			            this.validate(self.state.confirmPassword);
		// 		}
		// 	})
	
		// }
		//  handleConfirmPasswordInput(value) {
		//        this.setState({
		//            confirmPassword: value
		//        })
		//    }
		//    isConfirmedPassword(value) {
		//       console.log(value,this.state.password,value===this.state.password);
		//        return (value === this.state.password)
	
		//    }
	
	
		_createClass(Web_Reset, [{
			key: 'handleSubmit',
			value: function handleSubmit(event) {
	
				event.preventDefault();
				var x = this.refs.confirmPassword.value;
				var flag = 1;
	
				if (x.length <= 3) {
					flag = 0;
					this.setState({
						err: true,
						err_msg: '* password is minimum 4 characters'
					});
				} else if (x === '') {
					flag = 0;
					this.setState({
						err: true,
						err_msg: '* enter password'
					});
				} else {
					flag = 1;
				}
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', password: this.refs.confirmPassword.value, mobile: this.state.mobile };
				var data2 = JSON.stringify(data1);
				if (flag === 1) {
					_jquery2.default.ajax({
						method: 'POST',
						url: baseUrl + 'resetpass',
						data: { req: data2 },
						dataType: 'json',
						success: function success(data) {
							if (data.status === "success") {
								localStorage.setItem('token', data.result[0].token);
								localStorage.setItem('user_id', data.result[0].id);
								_reactRouter.browserHistory.push('/web/home');
								window.location.reload();
							}
						}
					});
				} else {
					this.setState({
						err: true
					});
				}
			}
		}, {
			key: 'passwordChange',
			value: function passwordChange(event) {
				this.setState({
					password: event.target.value,
					err: false
				});
			}
			// confirmPassChange(event){
	
			// 	this.setState({
			// 		confirm_password: event.target.value,
			// 	},function(){
			// 		if(this.state.password !== this.state.confirm_password){
			// 				this.setState({
			// 					err: true,
			// 					mismatch: "Password Mismatch",
			// 				})				
			// 		}
			// 		else{
			// 			this.setState({
			// 				err: false,
			// 			})
			// 		}
			// 	});
			// 	// this.validate(event);
			// }
	
		}, {
			key: 'render',
			value: function render() {
				localStorage.removeItem('h_type');
				document.title = "AquaDeals Reset Password ";
				document.getElementsByTagName("META")[2].content = "AquaDeals Reset Password";
				return _react2.default.createElement(
					'div',
					{ className: 'lgt_gry web_deals web_reset_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'section',
						{ className: 'container dels_cntnt ' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12 del_rgt' },
								_react2.default.createElement(
									'div',
									{ className: 'del_rgt_blk' },
									_react2.default.createElement(
										'div',
										{ className: 'del_dtl' },
										_react2.default.createElement(
											'div',
											{ className: '' },
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-md-offset-3' },
												_react2.default.createElement(
													'div',
													{ className: 'clr' },
													'\xA0'
												),
												_react2.default.createElement(
													'div',
													{ className: 'clr' },
													'\xA0'
												),
												_react2.default.createElement(
													'div',
													{ className: 'thumbnail', style: { overflow: 'hidden' } },
													_react2.default.createElement(
														'div',
														{ className: 'enquire_form signup_blk proced_blk' },
														_react2.default.createElement(
															'div',
															{ className: 'newlogin_logo' },
															_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png', alt: ' ' })
														),
														_react2.default.createElement(
															'form',
															{ className: 'mtrl_elmnts', onSubmit: this.handleSubmit },
															_react2.default.createElement(
																'div',
																{ className: 'col-md-12' },
																_react2.default.createElement(
																	'div',
																	{ className: 'group' },
																	_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cell_dl.png', alt: '', style: { position: 'absolute', top: '11px', left: '0px' } }),
																	_react2.default.createElement('input', { type: 'text', value: this.state.mobile_number, disabled: true }),
																	_react2.default.createElement('span', { className: 'highlight' }),
																	_react2.default.createElement('span', { className: 'bar' })
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'group' },
																	_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/lock.png', alt: '', style: { position: 'absolute', top: '11px', left: '0px' } }),
																	_react2.default.createElement('input', { type: 'password', placeholder: 'New Password', ref: 'confirmPassword', onChange: this.passwordChange, required: true }),
																	_react2.default.createElement('span', { className: 'highlight' }),
																	_react2.default.createElement('span', { className: 'bar' }),
																	this.state.err ? _react2.default.createElement(
																		'span',
																		{ style: { color: 'red', fontSize: '12px' } },
																		this.state.err_msg
																	) : ''
																),
																_react2.default.createElement(
																	'div',
																	null,
																	_react2.default.createElement(
																		'button',
																		{ onSubmit: this.handleSubmit, action: 'submit', className: 'btn web_reset_btn' },
																		'Reset ',
																		_react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
																	)
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'clr' },
																'\xA0'
															),
															_react2.default.createElement(
																'div',
																{ className: 'clr' },
																'\xA0'
															),
															_react2.default.createElement(
																'div',
																{ className: 'clr' },
																'\xA0'
															),
															_react2.default.createElement(
																'div',
																{ className: 'clr' },
																'\xA0'
															)
														)
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_Reset;
	}(_react.Component);
	
	exports.default = Web_Reset;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Web_verifyOtp = function (_Component) {
		_inherits(Web_verifyOtp, _Component);
	
		function Web_verifyOtp(props, context) {
			_classCallCheck(this, Web_verifyOtp);
	
			// this.router = context.router;
			var _this = _possibleConstructorReturn(this, (Web_verifyOtp.__proto__ || Object.getPrototypeOf(Web_verifyOtp)).call(this, props));
	
			_this.state = {
				mobile: localStorage.mobile,
				invalid_otp: ''
			};
			_this.handleSubmit = _this.handleSubmit.bind(_this);
			_this.gotoLogin = _this.gotoLogin.bind(_this);
			_this.resendOtp = _this.resendOtp.bind(_this);
			return _this;
		}
	
		_createClass(Web_verifyOtp, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.refs.otp.focus();
			}
		}, {
			key: 'resendOtp',
			value: function resendOtp() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', mobile: this.state.mobile };
				var data2 = JSON.stringify(data1);
	
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'resendOtp',
					data: { req: data2 },
					dataType: 'json',
					success: function success(data) {
						// console.log(data);
	
					},
					error: function error(err) {
						// console.log("Resend Otp Error"+err);
					}
				});
			}
		}, {
			key: 'handleSubmit',
			value: function handleSubmit(event) {
				event.preventDefault();
				// var otp = this.refs.otp.value;
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', mobile: this.state.mobile,
					otp: this.refs.otp.value, device_id: localStorage.getItem('push_device_id')
				};
	
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'verifyforgotOtp',
					data: { req: data2 },
					dataType: 'json',
					success: function (data) {
						// console.log(data);
						if (data.status === "success") {
							_reactRouter.browserHistory.push('/web/reset');
							window.location.reload();
						}
						if (data.status === 'fail') {
							this.setState({
								err: true,
								invalid_otp: 'Invalid Otp'
							});
						}
					}.bind(this),
					error: function error(err) {
						// console.log("Verify Otp error"+ err);
					}
	
				});
			}
		}, {
			key: 'gotoLogin',
			value: function gotoLogin(event) {
				event.preventDefault();
				_reactRouter.browserHistory.push('/web/login');
				window.location.reload();
			}
		}, {
			key: 'otpChange',
			value: function otpChange(event) {}
		}, {
			key: 'render',
			value: function render() {
				// var props = this.props;
				// var d= this.context;
				// console.log(d);
	
				localStorage.removeItem('h_type');
				document.title = "AquaDeals Verify OTP ";
				document.getElementsByTagName("META")[2].content = "AquaDeals Verify OTP";
				return _react2.default.createElement(
					'div',
					{ className: 'lgt_gry web_deals web_verifyotp_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'container dels_cntnt' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12 del_rgt' },
								_react2.default.createElement(
									'div',
									{ className: 'del_rgt_blk' },
									_react2.default.createElement(
										'div',
										{ className: 'del_dtl' },
										_react2.default.createElement(
											'div',
											{ className: '' },
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-md-offset-3' },
												_react2.default.createElement(
													'div',
													{ className: 'clr' },
													'\xA0'
												),
												_react2.default.createElement(
													'div',
													{ className: 'clr' },
													'\xA0'
												),
												_react2.default.createElement(
													'div',
													{ className: 'thumbnail' },
													_react2.default.createElement(
														'div',
														{ className: 'enquire_form signup_blk proced_blk' },
														_react2.default.createElement(
															'div',
															{ className: 'newlogin_logo' },
															_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png', alt: ' ' })
														),
														_react2.default.createElement(
															'form',
															{ className: 'mtrl_elmnts', onSubmit: this.handleSubmit },
															_react2.default.createElement(
																'div',
																{ className: 'col-md-12' },
																_react2.default.createElement(
																	'div',
																	{ className: 'col-md-12' },
																	_react2.default.createElement(
																		'div',
																		{ className: 'group' },
																		_react2.default.createElement('input', { type: 'text', ref: 'otp', maxLength: 6, required: true, onChange: this.otpChange }),
																		_react2.default.createElement('span', { className: 'highlight' }),
																		_react2.default.createElement('span', { className: 'bar' }),
																		this.state.err ? this.state.invalid_otp : '',
																		_react2.default.createElement(
																			'label',
																			null,
																			'Enter OTP'
																		)
																	),
																	_react2.default.createElement(
																		'button',
																		{ onSubmit: this.handleSubmit.bind(this), action: 'submit', className: 'btn web_otp_btn' },
																		'Verify ',
																		_react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
																	)
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'clr' },
																'\xA0'
															),
															_react2.default.createElement(
																'div',
																{ className: 'clr' },
																'\xA0'
															),
															_react2.default.createElement(
																'div',
																{ className: 'forgot_pasword' },
																_react2.default.createElement(
																	'h5',
																	null,
																	'Didn\'t recieve the OTP?'
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'tap' },
																	_react2.default.createElement(
																		'a',
																		{ onClick: this.resendOtp },
																		'Tap Here to Resend'
																	)
																)
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'clr' },
														'\xA0'
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										),
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_verifyOtp;
	}(_react.Component);
	
	exports.default = Web_verifyOtp;

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactShare = __webpack_require__(18);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Swiper from 'react-id-swiper';
	
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	// path="/web/:Bname/brand-details/:DType/:Bid"
	
	var Web_About_Brand = function (_Component) {
		_inherits(Web_About_Brand, _Component);
	
		function Web_About_Brand(props) {
			_classCallCheck(this, Web_About_Brand);
	
			var _this = _possibleConstructorReturn(this, (Web_About_Brand.__proto__ || Object.getPrototypeOf(Web_About_Brand)).call(this, props));
	
			_this.state = {
				tot_data: [],
				products: [],
				cat: [],
				product_count: '',
				brand_details: '',
				load_more: '',
				brand_id: '',
				brand_name: '',
				type: '',
				dtype: '',
				share_msg: '',
				brand_location: '',
				logo: '',
				brand_bg: '',
				description: '',
				views_count: '',
				follow_count: '',
				brand_likes_count: '',
				deal_count: '',
				follow_status: '',
				like_status: '',
				page_loading: false,
	
				follow_status_flag: '',
				like_status_flag: '',
				open: false,
				brand_like_users: [],
				brand_like_rem_count: '',
	
				cat_active: '',
				like_load: false
			};
			_this.getBrandDetails = _this.getBrandDetails.bind(_this);
			_this.tokenCheck = _this.tokenCheck.bind(_this);
			_this.likeBrand = _this.likeBrand.bind(_this);
			_this.FollowBrand = _this.FollowBrand.bind(_this);
			_this.ShareFunc = _this.ShareFunc.bind(_this);
			_this.likeBrand_onLoad = _this.likeBrand_onLoad.bind(_this);
			_this.getProducts = _this.getProducts.bind(_this);
			return _this;
		}
	
		_createClass(Web_About_Brand, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
				localStorage.removeItem('checkout');
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
				localStorage.removeItem('web_quickcart');
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
	
				if (screen.width < 800) {
					// window.location.href="/"+this.props.params.BrandName/*this.props.params.Bname+"/brand-details/"+this.props.params.DType+'/'+this.props.params.Bid;
					window.location.href = "/" + this.props.params.Bname + "/brand-details/" + this.props.params.Bid;
				}
				// if(!localStorage.token && !localStorage.user_id)
				// {
				// 	localStorage.setItem('web_brand_details','/web/'+this.props.params.Bname+'/brand-details/'+this.props.params.DType+'/'+this.props.params.Bid);
				// 	browserHistory.push('/web/login');
				// }
				// else
				// {
				this.getBrandDetails();
	
				// }
				if (localStorage.user_id && localStorage.token && localStorage.web_likebrand) {
					this.likeBrand_onLoad();
				}
			}
		}, {
			key: 'getProducts',
			value: function getProducts(catid) {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, brand_id: this.props.params.Bid, cat_id: catid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					url: baseUrl + 'get_brandProductsByCat',
					method: 'POST',
					dataType: 'JSON',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({ products: data.products, cat_active: catid });
						}
					}.bind(this),
					error: function error(err) {}
	
				});
			}
		}, {
			key: 'ShareFunc',
			value: function ShareFunc() {
				var _this2 = this;
	
				this.setState({
					open: !this.state.open
				});
				setTimeout(function () {
					_this2.setState({ open: false });
				}, 5000);
			}
		}, {
			key: 'FollowBrand',
			value: function FollowBrand(status) {
				var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, brand_id: this.state.brand_id, status: status };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'follow_brand',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								follow_count: data.brand_follow_count,
								follow_status: data.follow_status
							});
							if (data.follow_status === 0) {
								this.setState({
									follow_status_flag: true
								});
							} else {
								this.setState({
									follow_status_flag: false
								});
							}
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'likeBrand',
			value: function likeBrand(status) {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('web_brand_details', '/web/' + this.props.params.Bname + '/brand-details/' + this.props.params.Bid);
					localStorage.setItem('web_likebrand', '0');
					localStorage.setItem('status', status);
					_reactRouter.browserHistory.push('/web/login');
				} else {
					this.setState({ like_load: true });
					var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, brand_id: this.props.params.Bid, status: status };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'like_brand',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									like_status: data.like_status,
									brand_likes_count: data.brand_likes_count,
									brand_like_users: data.brand_like_users,
									like_load: false
								});
							}
							if (data.like_status === 1) {
								this.setState({
									like_status_flag: true,
									like_load: false
								});
							} else {
								this.setState({
									like_status_flag: false,
									like_load: false
								});
							}
							localStorage.removeItem('status');
							localStorage.removeItem('web_likebrand');
							// this.getBrandDetails();
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'likeBrand_onLoad',
			value: function likeBrand_onLoad() {
				this.setState({ like_load: true });
				if (localStorage.status) {
					var status = localStorage.status;
				} else {
					status = 1;
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('status', status);
					localStorage.setItem('web_likebrand', '1');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.user_id;
					} else {
						uid = 0;
					}
					var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, brand_id: this.props.params.Bid, status: status };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'like_brand',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									like_status: data.like_status,
									brand_likes_count: data.brand_likes_count,
									brand_like_users: data.brand_like_users,
									like_load: false
								});
							}
							if (data.like_status === 1) {
								this.setState({
									like_status_flag: true
								});
							} else {
								this.setState({
									like_status_flag: false
								});
							}
							localStorage.removeItem('status');
							localStorage.removeItem('web_likebrand');
							// localStorage.removeItem('status');
							this.getBrandDetails();
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'tokenCheck',
			value: function tokenCheck() {
				localStorage.removeItem('user_id');
				localStorage.removeItem('token');
				window.location.reload();
			}
		}, {
			key: 'getBrandDetails',
			value: function getBrandDetails() {
				this.setState({
					page_loading: true
				});
				var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, brand_id: this.props.params.Bid, page: '1' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'get_brand_details',
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								tot_data: data,
								products: data.products,
								cat: data.cat,
								product_count: data.product_count,
								brand_details: data.brand_details,
								load_more: data.load_more,
								// brand_details start 
								brand_id: data.brand_details[0].brand_id,
								brand_name: data.brand_details[0].brand_name,
								type: data.brand_details[0].type,
								dtype: data.brand_details[0].dtype,
								share_msg: data.brand_details[0].share_msg,
								brand_location: data.brand_details[0].brand_location,
								logo: data.brand_details[0].logo,
								brand_bg: data.brand_details[0].brand_bg,
								description: data.brand_details[0].description,
								views_count: data.brand_details[0].views_count,
								follow_count: data.brand_details[0].follow_count,
								brand_likes_count: data.brand_details[0].likes_count,
								deal_count: data.brand_details[0].deal_count,
								follow_status: data.brand_details[0].follow_status,
								like_status: data.brand_details[0].like_status,
								brand_like_users: data.brand_like_users,
								brand_like_rem_count: data.brand_like_rem_count,
								// brand details end
								page_loading: false
							});
							if (data.brand_details[0].follow_status === '1') {
								this.setState({
									follow_status_flag: false
								});
							} else {
								this.setState({
									follow_status_flag: true
								});
							}
							if (data.brand_details[0].like_status === '1') {
								this.setState({
									like_status_flag: true
								});
							} else {
								this.setState({
									like_status_flag: false
								});
							}
						}
						this.setState({ cat_active: '' });
						if (data.status === 'error' && data.message === "Token mismatch") {
							this.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				// const params = {
				//      paginationClickable: true,
				//      spaceBetween: 10,
				//      slidesPerView: 3.3
				//    }
				document.title = this.state.brand_details ? 'Buy ' + this.state.brand_name + " Aqua Products Online | AquaDeals " : 'About the Brand | AquaDeals';
				var cat = this.state.cat.map(function (data, index) {
					var _this3 = this;
	
					return _react2.default.createElement(
						'li',
						{ key: data.id, className: this.state.cat_active === data.id ? 'active' : '', onClick: function onClick() {
								_this3.getProducts(data.id);
							} },
						_react2.default.createElement(
							_reactRouter.Link,
							null,
							_react2.default.createElement('img', { src: baseAssets + 'images/icons2/' + data.logo, width: '30px', alt: ' ' }),
							_react2.default.createElement(
								'span',
								null,
								data.name,
								':',
								data.count
							),
							_react2.default.createElement('span', null)
						)
					);
				}.bind(this));
				var people_liked = _react2.default.createElement(
					'div',
					{ className: 'web_brnd_liked_blk' },
					_react2.default.createElement(
						'h5',
						{ className: 'web_abt_brnd_h5' },
						'People who liked'
					),
					_react2.default.createElement(
						'div',
						{ className: 'web_brnd_liked_left' },
						_react2.default.createElement(
							'p',
							null,
							'Liked by ',
							this.state.brand_likes_count === '1' ? this.state.brand_likes_count + ' user' : this.state.brand_likes_count + ' users'
						),
						_react2.default.createElement(
							'div',
							{ className: 'web_pro_liked_profile_blk' },
							this.state.brand_like_users.map(function (data, index) {
								return _react2.default.createElement(
									'i',
									{ key: index, className: 'web_pro_liked_profile_icon' },
									_react2.default.createElement('img', { src: baseAssets + 'images/pro_pics/' + data.pro_pic, alt: ' ', width: '50px' })
								);
							}),
							this.state.brand_like_rem_count > 0 ? _react2.default.createElement(
								'span',
								{ className: 'pro_liked_rem_count' },
								_react2.default.createElement(
									'span',
									null,
									'+',
									this.state.brand_like_rem_count
								)
							) : ''
						)
					)
				);
				var products = this.state.products.map(function (data, index) {
					return _react2.default.createElement(
						'div',
						{ className: 'col-lg-3 col-md-3 col-sm-6  col-xs-3' },
						_react2.default.createElement(
							'div',
							{ className: 'prdt_blk' },
							data.dealcount >= 2 ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: "/web/subdeals/" + data.url_dtype_name + "/" + data.url_cat_name + "/" + data.url_dtype + "/" + data.url_brand_name + "/" + data.pid },
									data.promo_ribbion ? _react2.default.createElement(
										'i',
										{ className: 'ribbon_img' },
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + data.promo_ribbion, alt: '' })
									) : '',
									_react2.default.createElement(
										'div',
										null,
										_react2.default.createElement('img', { alt: ' ', src: data.image !== null && data.image !== '' ? data.image : baseAssets + 'icons/web_icons/noImage.png' })
									),
									data.title ? _react2.default.createElement(
										'h3',
										null,
										data.title
									) : _react2.default.createElement(
										'h3',
										null,
										'\xA0'
									),
									data.mrp ? _react2.default.createElement(
										'h4',
										null,
										'MRP \u20B9 ',
										data.mrp
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									),
									parseInt(data.count, 10) > 0 ? _react2.default.createElement(
										'h4',
										{ className: 'webbrnd_view' },
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/views.png', width: '17px', alt: '' }),
										'\xA0',
										data.count,
										' ',
										data.count > 1 ? 'Views' : 'View'
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									)
								)
							) : _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ key: data.id, className: 'cursor', to: "/web/pdetails/" + data.url_dtype_name + "/" + data.url_cat_name + "/" + data.url_brand_name + "/" + data.url_product_name + "/" + data.pid + "/" + data.id },
									data.promo_ribbion ? _react2.default.createElement(
										'i',
										{ className: 'ribbon_img' },
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + data.promo_ribbion, alt: '' })
									) : '',
									_react2.default.createElement(
										'div',
										null,
										_react2.default.createElement('img', { alt: ' ', src: data.image !== null && data.image !== '' ? data.image : baseAssets + 'icons/web_icons/noImage.png' })
									),
									data.title ? _react2.default.createElement(
										'h3',
										null,
										data.title
									) : _react2.default.createElement(
										'h3',
										null,
										'\xA0'
									),
									data.mrp ? _react2.default.createElement(
										'h4',
										null,
										'MRP \u20B9 ',
										data.mrp
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									),
									parseInt(data.count, 10) > 0 ? _react2.default.createElement(
										'h4',
										{ className: 'webbrnd_view' },
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/views.png', width: '17px', alt: '' }),
										'\xA0',
										data.count,
										' ',
										data.count > 1 ? 'Views' : 'View'
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									)
								)
							)
						)
					);
				});
				// var following_btn=this.state.follow_status_flag ? <span className="web_pro_abt_follow_header_btn" onClick={()=>{this.FollowBrand(1)}}>Follow</span> : <span className="web_pro_abt_follow_header_btn_active" onClick={()=>this.FollowBrand(0)}>Following</span>;
				var likes_btn = this.state.like_status_flag ? _react2.default.createElement(
					'span',
					{ className: 'brand_dtls_likes', onClick: function onClick() {
							_this4.likeBrand(0);
						} },
					_react2.default.createElement('i', { className: "glyph_heart_active glyphicon glyphicon-heart" }),
					this.state.brand_likes_count === '1' ? this.state.brand_likes_count + ' Like' : this.state.brand_likes_count + ' Likes'
				) : _react2.default.createElement(
					'span',
					{ className: 'brand_dtls_likes', onClick: function onClick() {
							_this4.likeBrand(1);
						} },
					_react2.default.createElement('i', { className: "glyph_heart glyphicon glyphicon-heart" }),
					this.state.brand_likes_count === '1' ? this.state.brand_likes_count + ' Like' : this.state.brand_likes_count + ' Likes'
				);
				var description_blk = this.state.description ? _react2.default.createElement(
					'div',
					{ className: 'about_brand_dtls_blk', style: { marginBottom: '30px' } },
					_react2.default.createElement(
						'h5',
						{ className: 'web_abt_brnd_h5' },
						_react2.default.createElement(
							'span',
							null,
							'About the brand'
						),
						_react2.default.createElement(
							'span',
							{ style: { float: 'right', marginRight: '5px', cursor: 'pointer' }, onClick: function onClick() {
									_this4.ShareFunc();
								} },
							_react2.default.createElement(
								'i',
								null,
								_react2.default.createElement('img', { src: baseAssets + 'mob-assets/share.png', alt: 'share', width: '19px' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_reactBootstrap.Panel,
							{ className: 'abt_brnd_panel', collapsible: true, expanded: this.state.open },
							_react2.default.createElement(
								FacebookShareButton,
								{ url: 'https://goo.gl/5dhJSM', title: this.state.brand_name, description: this.state.share_msg, className: 'test_share1' },
								_react2.default.createElement(FacebookIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								TwitterShareButton,
								{ url: 'https://goo.gl/5dhJSM', title: this.state.brand_name, description: this.state.share_msg, className: 'test_share1' },
								_react2.default.createElement(TwitterIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								GooglePlusShareButton,
								{ url: 'https://goo.gl/5dhJSM', title: this.state.brand_name, description: this.state.share_msg, className: 'test_share1' },
								_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'abt_brnd_desc' },
						_react2.default.createElement(
							'p',
							null,
							this.state.description
						)
					)
				) : '';
	
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_brand_details_page' },
					this.state.page_loading ? _react2.default.createElement(
						'div',
						{ className: 'loading_sym' },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/ajax-loader1.gif', alt: 'Loading' })
					) : _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_WebHeaderInner2.default, null),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'section',
							{ className: 'container Dels_cntnt' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-3' },
									_react2.default.createElement(
										'div',
										{ className: 'row del_lft' },
										_react2.default.createElement(
											'h5',
											{ className: this.state.cat_active ? "fltr_title" : 'fltr_title active', onClick: function onClick() {
													_this4.getBrandDetails();
												} },
											this.state.brand_name ? this.state.brand_name : 'About the Brand'
										),
										_react2.default.createElement(
											'ul',
											null,
											cat
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-9 del_rgt' },
									_react2.default.createElement(
										'div',
										{ className: 'del_rgt_blk' },
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-12 col-md-12', style: { padding: '0px' } },
											_react2.default.createElement(
												'div',
												{ className: 'brand_dtls_blk', style: { textAlign: 'center', backgroundImage: "url(https://aquadeals.in/admin/assets/images/" + this.state.brand_bg + ")" } },
												_react2.default.createElement(
													'i',
													{ className: 'bg_img' },
													_react2.default.createElement('img', { src: baseAssets + 'images/brand_icons/' + this.state.logo, alt: ' ', width: '60px' })
												),
												_react2.default.createElement(
													'h5',
													{ className: 'web_brand_dtls_title' },
													this.state.brand_name ? this.state.brand_name : 'Brand Name:'
												),
												_react2.default.createElement(
													'div',
													null,
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-4 col-md-4 web_brand_views_blk' },
														_react2.default.createElement(
															'span',
															{ className: 'web_views_item' },
															_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/views.png', width: '17px', alt: ' ' }),
															'\xA0',
															this.state.views_count === 1 ? this.state.views_count + ' View' : this.state.views_count + ' Views'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-4 col-md-4', style: { padding: '0px', textAlign: 'center' } },
														_react2.default.createElement(
															'a',
															{ className: 'brand_dtls_shop_btn', href: '/web/pdeals/brands/' + this.state.tot_data.url_brand_name + '/' + this.props.params.Bid },
															'SHOP BRAND'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-4 col-md-4' },
														likes_btn
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										),
										_react2.default.createElement(
											'div',
											{ className: 'itm_lst' },
											_react2.default.createElement(
												'div',
												null,
												description_blk
											),
											people_liked && this.state.brand_likes_count > 0 ? people_liked : '',
											products.length > 0 ? products : ''
										)
									),
									this.state.like_load ? _react2.default.createElement(
										'div',
										{ className: 'web_loading' },
										_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', role: 'presentation', width: '40px' })
									) : ''
								)
							)
						),
						_react2.default.createElement('div', { className: 'clr' }),
						_react2.default.createElement(_WebFooter2.default, null)
					)
				);
			}
		}]);
	
		return Web_About_Brand;
	}(_react.Component);
	
	exports.default = Web_About_Brand;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _reactWebVectorIcons = __webpack_require__(29);
	
	var _reactWebVectorIcons2 = _interopRequireDefault(_reactWebVectorIcons);
	
	var _custom_functions = __webpack_require__(83);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	__webpack_require__(489);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var parseHtml = __webpack_require__(39);
	// import Footer from './../Common/footer';
	
	// Webpack CSS import
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Web_Checkout = function (_Component) {
		_inherits(Web_Checkout, _Component);
	
		function Web_Checkout(props) {
			_classCallCheck(this, Web_Checkout);
	
			var _this = _possibleConstructorReturn(this, (Web_Checkout.__proto__ || Object.getPrototypeOf(Web_Checkout)).call(this, props));
	
			_this.state = {}, _this.state = {
				page_loading: false,
				lod: false,
				user_address: [],
				edit_add_id: '',
				address_flag: 0,
				add_address_form_status: false,
				add_available: false,
				add_address: false,
				edit_address: false,
				click_here_status: false,
				tot_data: _this.props.total_cart_data,
				add_id: '',
				edit_data: [],
				// edit form elements 
				edit_name: '',
				edit_mobile: '',
				edit_state: '',
				edit_city: '',
				edit_doorno: '',
				edit_pincode: '',
	
				// add form elements
				add_name: localStorage.user_name,
				add_mobile: localStorage.user_mobile,
				add_state: '',
				add_city: '',
				add_doorno: '',
				add_pincode: '',
	
				//cart response 
				cart_count: 0,
				grand_total: 0,
				cart_add_id: '',
				coupon_code: 0,
				aqua_cash: '',
				coupons_amt: '',
				ac_discount: '',
	
				//cart calculations response
				mode: '',
				pay_advance: '',
				complete_amount: '',
				pay_at_outlet: '',
				final_amt: '',
				totals: '',
				other_amount_field_status: false,
				ptype: '',
				min_val: '',
				max_val: '',
				err_qty_status: false,
				err_qty_msg: '',
	
				paymentMethodStatus: '',
				offline_payment: '',
				prebook_payment: '',
				fullamount_payment: '',
				otheramount_payment: '',
	
				// cart calculations respnose before pay now
				deal_id: 0,
				product_id: 0,
				quantity: '',
				act_price: '',
				deal_price: '',
				total: '',
				total_discount: '',
				discount: '',
				pre_booking_amount: '',
				bank_fee: '',
				total_thx_fee: '',
				save_price: '',
				remaining_amount: '',
				payable_ad: '',
				payable_hatchery: '',
				ac_offer_title: '',
				aqua_cash_value: '',
				aqua_cash_code: '',
				ac_cal_info: '',
				pur_ern_ofr_code: '',
				pur_ern_ofr_title: '',
				pur_ern_ofr_desc: '',
				pur_ern_retrn_amt: '',
				full_aquacash_back_amount: '',
				full_aquacash_back_title: '',
				full_aquacash_back_code: '',
				full_aquacash_back_description: '',
				deal_type: '',
				promo_code: '',
				promo_amt: '',
				promo_title: '',
				promo_help: '',
				free_shipment: '',
				free_shipment_msg: '',
				user_details: [],
				coupon_amt: '',
				cart_ids: '',
				promodiscount: '',
				applied_promos: '',
				promos: [],
				ac_enough: '',
				ac_enough_msg: '',
				applied_coupons: '',
	
				//variable for storing the payment radio buttons 
				total_online_payment: '',
				default_ptype: '',
				mode_loading: false,
				amount_loading: false,
				evnt_key: 2,
	
				// offline payment success displaying it in modal
				success_msg: '',
				thank_msg: '',
	
				offline_confirm_data: [],
				offline_pay_success_status: false,
	
				paying_process: false,
	
				// online payment response variables start
				pre_payment_id: '',
				order_id: '',
				//deal_type:'',
				//cart_ids:'',
				paid_amt: '',
				response: '',
				offline_success: false,
				// online payment response variables ends here
	
				cart_items: [],
	
				qty: '',
				min_qty: '',
				max_qty: '',
				cart_id: '',
				updateModal: false,
	
				cart_total: '',
				pageId: '.web_checkout_page',
				order_error_modal: false,
				order_error_message: '',
				coupons: []
			};
			_this.testclose = _this.testclose.bind(_this);
	
			_this.getUserAddress = _this.getUserAddress.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.handleSubmit_add = _this.handleSubmit_add.bind(_this);
			_this.editAddress = _this.editAddress.bind(_this);
			_this.deleteAddress = _this.deleteAddress.bind(_this);
			_this.handleSubmit_edit = _this.handleSubmit_edit.bind(_this);
			_this.getAddressDetails = _this.getAddressDetails.bind(_this);
	
			// functions for edit address form
			_this.edit_nameChange = _this.edit_nameChange.bind(_this);
			_this.edit_mobileChange = _this.edit_mobileChange.bind(_this);
			_this.edit_stateChange = _this.edit_stateChange.bind(_this);
			_this.edit_cityChange = _this.edit_cityChange.bind(_this);
			_this.edit_doornoChange = _this.edit_doornoChange.bind(_this);
			_this.edit_pincodeChange = _this.edit_pincodeChange.bind(_this);
	
			// functions for add address form
			_this.add_nameChange = _this.add_nameChange.bind(_this);
			_this.add_mobileChange = _this.add_mobileChange.bind(_this);
			_this.add_stateChange = _this.add_stateChange.bind(_this);
			_this.add_cityChange = _this.add_cityChange.bind(_this);
			_this.add_doornoChange = _this.add_doornoChange.bind(_this);
			_this.add_pincodeChange = _this.add_pincodeChange.bind(_this);
			//this.setDefaultAddress=this.setDefaultAddress.bind(this);
	
			_this.getCart = _this.getCart.bind(_this);
			_this.getCartCalculations = _this.getCartCalculations.bind(_this);
			_this.validateOtherAmount = _this.validateOtherAmount.bind(_this);
	
			_this.modeChange_cartCalculations = _this.modeChange_cartCalculations.bind(_this);
			_this.handleTabsSelect = _this.handleTabsSelect.bind(_this);
			_this.payNow = _this.payNow.bind(_this);
			_this.ccAvenue = _this.ccAvenue.bind(_this);
	
			_this.other_amount_cartCalculations = _this.other_amount_cartCalculations.bind(_this);
	
			_this.updateMinQuantity = _this.updateMinQuantity.bind(_this);
			_this.updateQuantity = _this.updateQuantity.bind(_this);
			_this.updateMinQtyModal = _this.updateMinQtyModal.bind(_this);
			_this.goNext = _this.goNext.bind(_this);
			_this.goPrev = _this.goPrev.bind(_this);
			return _this;
		}
	
		_createClass(Web_Checkout, [{
			key: 'goNext',
			value: function goNext() {
				if (this.swiper) this.swiper.slideNext();
			}
		}, {
			key: 'goPrev',
			value: function goPrev() {
				if (this.swiper) this.swiper.slidePrev();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				// const loc = window.location;
				// var str = location.pathname;
				// var domain=location.hostname;
				// localStorage.setItem('domain',domain);
				// if(domain !=='aqua.deals')
				// {
				// 	window.location.href='https://aqua.deals/'
				// }
				this.props.get_rzp_keys("desktop_web");
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
	
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
				localStorage.removeItem('web_quickcart');
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
				localStorage.removeItem('web_brand_details');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
	
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('checkout', '/web/checkout');
					_reactRouter.browserHistory.push('/web/login');
				}
				this.getUserAddress();
				// this.getCart();
			}
			//function updateQuantitiy is used to update the qunatity of the product in modal box and updating the cart values by calling the "applyCoupon_getCart" 
	
		}, {
			key: 'updateQuantity',
			value: function updateQuantity() {
				var x = '';
				if (parseInt(this.state.qty, 10) < parseInt(this.state.min_qty, 10)) {
					// alert('Minimum Quantity is '+this.state.min_qty);
					x = 'Minimum Quantity is ' + this.state.min_qty;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Minimum Quantity is ' + this.state.min_qty
					});
				}
				if (this.state.qty === '') {
					// alert('Minimum Quantity is '+this.state.min_qty);
					x = 'Minimum Quantity is ' + this.state.min_qty;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Minimum Quantity is ' + this.state.min_qty
					});
				}
				if (parseInt(this.state.qty, 10) > parseInt(this.state.max_qty, 10)) {
					// alert('Maximum Quantity is '+this.state.max_qty);
					x = 'Maximum Quantity is ' + this.state.max_qty;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Maximum Quantity is ' + this.state.max_qty
					});
				}
				var check = /[^0-9]/gi;
				if (check.test(this.refs.web_edit_qty.value)) {
					x = '* Invalid Quantity';
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Invalid Quantity'
					});
				}
				if (x === '') {
					this.setState({
						err_qty_status: false,
						err_qty_msg: ''
					});
					var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), cart_id: this.state.cart_id, quantity: this.state.qty };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'update_cart_qty',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.close();
								this.getCart();
								this.applyCoupon_getCart();
							}
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'updateMinQuantity',
			value: function updateMinQuantity(qty, min_qty, max_qty, id) {
				this.setState({
					updateModal: true,
					qty: qty,
					min_qty: min_qty,
					max_qty: max_qty,
					cart_id: id
				});
			}
		}, {
			key: 'updateMinQtyModal',
			value: function updateMinQtyModal() {
				this.setState({
					qty: this.refs.web_edit_qty.value,
					err_qty_status: false
				});
			}
		}, {
			key: 'testclose',
			value: function testclose() {
				this.setState({
					offline_pay_success_status: false
				});
			}
		}, {
			key: 'ccAvenue',
			value: function ccAvenue() {
	
				//var basePayUrl='https://aqua.deals/paymentGateWay/paymentRequestHandler.php';
				var basePayUrl = 'http://203.193.173.78/paymentGateWay/paymentRequestHandler.php';
				var username = this.state.user_details.username;
				var email = this.state.user_details.email;
				var mobile = this.state.user_details.mobile;
				var address = this.state.user_details.address;
				var city = this.state.user_details.city;
				var pincode = this.state.user_details.pincode;
				var state = this.state.user_details.state;
				// var behalf_of=this.state.user_details.behalf_of;
				var deal_type = this.state.deal_type;
				var add_id = this.state.cart_add_id;
	
				var data1 = { access_code: 'AVIJ67DJ41BD20JIDB', merchant_id: '103328', order_id: this.state.order_id, merchant_param1: this.state.pre_payment_id, merchant_param2: deal_type, merchant_param3: add_id, merchant_param4: 'desktop_web', amount: this.state.paid_amt, currency: 'INR', cancel_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', redirect_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', billing_name: username, billing_address: address, billing_city: city, billing_state: state, billing_zip: pincode, billing_tel: mobile, billing_country: 'India', billing_email: email };
				// var data1={access_code:'AVJZ66DG16BM17ZJMB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:add_id,merchant_param4:'desktop_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',redirect_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
				_jquery2.default.ajax({
					method: 'POST',
					data: data1,
					url: basePayUrl,
					success: function (data) {
						(0, _jquery2.default)('.web_checkout_page').html(data);
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
	
			//payNow function is used to submit the values to 
	
		}, {
			key: 'payNow',
			value: function payNow() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (this.state.add_address_form_status) {
					this.setState({
						add_address: true
					});
				} else {
					this.setState({
						paying_process: true
					});
	
					// here this.state.ptype = mode of the payment 
					// 1:offline, 2:pay advance, 3:online pay total , 4: online pay other amount
					if (this.state.ptype === 1) {
						var data1 = { from: 'desktop_web', uid: localStorage.user_id, token: localStorage.token, product_id: this.state.product_id, quantity: this.state.quantity, act_price: this.state.act_price, deal_price: this.state.deal_price, total: this.state.total, total_discount: this.state.total_discount, discount: this.state.discount, total_online_payment: this.state.total_online_payment, pre_booking_amount: this.state.pre_booking_amount, bank_fee: this.state.bank_fee, total_thx_fee: this.state.total_thx_fee, save_price: this.state.save_price, remaining_amount: this.state.remaining_amount, payable_ad: this.state.payable_ad, payable_hatchery: this.state.payable_hatchery, mode: this.state.ptype, coupons_amt: this.state.coupons_amt, aqua_cash: this.state.aqua_cash, ac_offer_title: this.state.ac_offer_title, aqua_cash_value: this.state.aqua_cash_value, aqua_cash_code: this.state.aqua_cash_code, ac_cal_info: this.state.ac_cal_info, pur_ern_ofr_code: this.state.pur_ern_ofr_code, pur_ern_ofr_title: this.state.pur_ern_ofr_title, pur_ern_ofr_desc: this.state.pur_ern_ofr_desc, pur_ern_retrn_amt: this.state.pur_ern_retrn_amt, full_aquacash_back_amount: this.state.full_aquacash_back_amount, full_aquacash_back_title: this.state.full_aquacash_back_title, full_aquacash_back_code: this.state.full_aquacash_back_code, full_aquacash_back_description: this.state.full_aquacash_back_description, deal_type: this.state.deal_type, promo_code: this.state.promo_code, promo_amt: this.state.promo_amt, promo_title: this.state.promo_title, promo_help: this.state.promo_help, free_shipment: this.state.free_shipment, free_shipment_msg: this.state.free_shipment_msg, paymentMethodStatus: this.state.paymentMethodStatus, add_id: this.state.cart_add_id, complete_amount: this.state.complete_amount, pay_advance: this.state.pay_advance, pay_at_outlet: this.state.pay_at_outlet, final_amt: this.state.final_amt, totals: this.state.totals, coupon_code: this.state.coupon_code, coupon_amt: this.state.coupon_amt, cart_ids: this.state.cart_ids, applied_coupons: this.state.applied_coupons, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, source: source, campaign: campaign, url_id: url_id };
						var data2 = JSON.stringify(data1);
						_jquery2.default.ajax({
							method: 'POST',
							dataType: 'json',
							data: { req: data2 },
							url: baseUrl + 'bookCart',
							success: function (data) {
								if (data.status === "success") {
									this.setState({
										offline_confirm_data: data,
										offline_pay_success_status: true,
										paying_process: false,
										offline_success: true
									});
									(0, _jquery2.default)('#off_modal_status').parent().addClass('offline_modal');
									localStorage.setItem('source_status', 'repeated');
									localStorage.removeItem('source');
									localStorage.removeItem('campaign');
									localStorage.removeItem('url_id');
								}
								if (data.status === 'error' && data.message === 'Token mismatch') {
									this.props.tokenCheck();
								}
							}.bind(this),
							error: function error(err) {}
						});
					} else if (this.state.ptype === 3 || this.state.ptype === 2) {
						data1 = { from: 'desktop_web', uid: localStorage.user_id, token: localStorage.token, product_id: this.state.product_id, quantity: this.state.quantity, act_price: this.state.act_price, deal_price: this.state.deal_price, total: this.state.total, total_discount: this.state.total_discount, discount: this.state.discount, total_online_payment: this.state.total_online_payment, pre_booking_amount: this.state.pre_booking_amount, bank_fee: this.state.bank_fee, total_thx_fee: this.state.total_thx_fee, save_price: this.state.save_price, remaining_amount: this.state.remaining_amount, payable_ad: this.state.payable_ad, payable_hatchery: this.state.payable_hatchery, mode: this.state.ptype, aqua_cash: this.state.aqua_cash, ac_offer_title: this.state.ac_offer_title, aqua_cash_value: this.state.aqua_cash_value, aqua_cash_code: this.state.aqua_cash_code, ac_cal_info: this.state.ac_cal_info, pur_ern_ofr_code: this.state.pur_ern_ofr_code, pur_ern_ofr_title: this.state.pur_ern_ofr_title, pur_ern_ofr_desc: this.state.pur_ern_ofr_desc, pur_ern_retrn_amt: this.state.pur_ern_retrn_amt, full_aquacash_back_title: this.state.full_aquacash_back_title, full_aquacash_back_code: this.state.full_aquacash_back_code, full_aquacash_back_description: this.state.full_aquacash_back_description, full_aquacash_back_amount: this.state.full_aquacash_back_amount, deal_type: this.state.deal_type, promo_code: this.state.promo_code, promo_amt: this.state.promo_amt, promo_title: this.state.promo_title, promo_help: this.state.promo_help, free_shipment: this.state.free_shipment, free_shipment_msg: this.state.free_shipment_msg, paymentMethodStatus: this.state.paymentMethodStatus, add_id: this.state.cart_add_id, complete_amount: this.state.complete_amount, pay_advance: this.state.pay_advance, pay_at_outlet: this.state.pay_at_outlet, final_amt: this.state.final_amt, totals: this.state.totals, coupon_code: this.state.coupon_code, coupon_amt: this.state.coupon_amt, cart_ids: this.state.cart_ids, applied_coupons: this.state.applied_coupons, coupons_amt: this.state.coupons_amt, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos };
						data2 = JSON.stringify(data1);
						_jquery2.default.ajax({
							method: 'POST',
							dataType: 'json',
							data: { req: data2 },
							url: baseUrl + 'onlineCartProcessing',
							success: function (data) {
								if (data.status === "success") {
									this.setState({
										pre_payment_id: data.pre_payment_id,
										order_id: data.order_id,
										deal_type: data.deal_type,
										cart_ids: data.cart_ids,
										paid_amt: data.paid_amt
									});
									//this.ccAvenue();
									var payment_params = { from: 'desktop_web',
										uid: localStorage.getItem('user_id'),
										pre_payment_id: data.pre_payment_id,
										order_id: data.order_id,
										deal_type: data.deal_type,
										cart_ids: data.cart_ids,
										paid_amt: data.paid_amt,
										username: this.state.user_details.username,
										address: this.state.user_details.address,
										city: this.state.user_details.city,
										state: this.state.user_details.state,
										pincode: this.state.user_details.pincode,
										mobile: this.state.user_details.mobile,
										country: 'India',
										email: this.state.user_details.email,
										cart_add_id: this.state.cart_add_id,
										pageId: this.state.pageId,
										rzp_key: this.props.rzp_keys.key_id };
									if (this.state.gateway_mode == 2) {
										(0, _custom_functions.razorpayForm)(payment_params);
										this.setState({ paying_process: false });
									} else {
										(0, _custom_functions.ccAvenue)(payment_params);
									}
								}
								if (data.status === 'error' && data.message === 'Token mismatch') {
									this.props.tokenCheck();
								}
								if (data.status === "invalid") {
									this.setState({
										order_error_modal: true,
										order_error_message: data.message
									});
									setTimeout(function () {
										_reactRouter.browserHistory.push('/web/home');
									}, 3000);
								}
							}.bind(this),
							error: function error(err) {}
						});
					} else if (this.state.ptype === 4) {
						var x = '';
						if (this.refs.ref_other_amt.value === "") {
							x = '* Enter Amount';
							this.setState({
								err_qty_msg: '* Enter Amount',
								err_qty_status: true
							});
						}
						if (parseInt(this.refs.ref_other_amt.value, 10) < parseInt(this.state.min_val, 10)) {
							x = 'Minimum Quantity is ' + this.state.min_val;
							this.setState({
								err_qty_status: true,
								err_qty_msg: '* Minimum amount is ' + this.state.min_val
							});
						}
						if (this.refs.ref_other_amt === '') {
							x = 'Minimum Quantity is ' + this.state.min_val;
							this.setState({
								err_qty_status: true,
								err_qty_msg: '* Minimum amount is ' + this.state.min_val
							});
						}
						if (parseInt(this.refs.ref_other_amt.value, 10) > parseInt(this.state.max_val, 10)) {
							x = 'Maximum Quantity is ' + this.state.max_val;
							this.setState({
								err_qty_status: true,
								err_qty_msg: '* Maximum amount is ' + this.state.max_val
							});
						}
						var check = /[^0-9]/gi;
						if (check.test(this.refs.ref_other_amt.value)) {
							x = '* Invalid Amount';
							this.setState({
								err_qty_status: true,
								err_qty_msg: '* Invalid Amount'
							});
						}
						if (x === '') {
							data1 = { from: 'desktop_web', uid: localStorage.user_id, token: localStorage.token, product_id: this.state.product_id, quantity: this.state.quantity, act_price: this.state.act_price, deal_price: this.state.deal_price, total: this.state.total, total_discount: this.state.total_discount, discount: this.state.discount, total_online_payment: this.state.total_online_payment, pre_booking_amount: this.state.pre_booking_amount, bank_fee: this.state.bank_fee, total_thx_fee: this.state.total_thx_fee, save_price: this.state.save_price, remaining_amount: this.state.remaining_amount, payable_ad: this.state.payable_ad, payable_hatchery: this.state.payable_hatchery, mode: this.state.ptype, aqua_cash: this.state.aqua_cash, ac_offer_title: this.state.ac_offer_title, aqua_cash_value: this.state.aqua_cash_value, aqua_cash_code: this.state.aqua_cash_code, ac_cal_info: this.state.ac_cal_info, pur_ern_ofr_code: this.state.pur_ern_ofr_code, pur_ern_ofr_title: this.state.pur_ern_ofr_title, pur_ern_ofr_desc: this.state.pur_ern_ofr_desc, pur_ern_retrn_amt: this.state.pur_ern_retrn_amt, full_aquacash_back_title: this.state.full_aquacash_back_title, full_aquacash_back_code: this.state.full_aquacash_back_code, full_aquacash_back_description: this.state.full_aquacash_back_description, full_aquacash_back_amount: this.state.full_aquacash_back_amount, deal_type: this.state.deal_type, promo_code: this.state.promo_code, promo_amt: this.state.promo_amt, promo_title: this.state.promo_title, promo_help: this.state.promo_help, free_shipment: this.state.free_shipment, free_shipment_msg: this.state.free_shipment_msg, paymentMethodStatus: this.state.paymentMethodStatus, add_id: this.state.cart_add_id, complete_amount: this.state.complete_amount, pay_advance: this.state.pay_advance, pay_at_outlet: this.state.pay_at_outlet, final_amt: this.state.final_amt, totals: this.state.totals, coupon_code: this.state.coupon_code, coupon_amt: this.state.coupon_amt, cart_ids: this.state.cart_ids, applied_coupons: this.state.applied_coupons, coupons_amt: this.state.coupons_amt, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos };
							data2 = JSON.stringify(data1);
							_jquery2.default.ajax({
								method: 'POST',
								dataType: 'json',
								data: { req: data2 },
								url: baseUrl + 'onlineCartProcessing',
								success: function (data) {
									if (data.status === "success") {
										this.setState({
											pre_payment_id: data.pre_payment_id,
											order_id: data.order_id,
											deal_type: data.deal_type,
											cart_ids: data.cart_ids,
											paid_amt: data.paid_amt
										});
										//this.ccAvenue();
										var payment_params = { from: 'desktop_web',
											uid: localStorage.getItem('user_id'),
											pre_payment_id: data.pre_payment_id,
											order_id: data.order_id,
											deal_type: data.deal_type,
											cart_ids: data.cart_ids,
											paid_amt: data.paid_amt,
											username: this.state.user_details.username,
											address: this.state.user_details.address,
											city: this.state.user_details.city,
											state: this.state.user_details.state,
											pincode: this.state.user_details.pincode,
											mobile: this.state.user_details.mobile,
											country: 'India',
											email: this.state.user_details.email,
											cart_add_id: this.state.cart_add_id,
											pageId: this.state.pageId,
											rzp_key: this.props.rzp_keys.key_id };
										if (this.state.gateway_mode == 2) {
											(0, _custom_functions.razorpayForm)(payment_params);
										} else {
											(0, _custom_functions.ccAvenue)(payment_params);
										}
									}
									if (data.status === 'error' && data.message === 'Token mismatch') {
										this.props.tokenCheck();
									}
									if (data.status === "invalid") {
										this.setState({
											order_error_modal: true,
											order_error_message: data.message
										});
										setTimeout(function () {
											_reactRouter.browserHistory.push('/web/home');
										}, 3000);
									}
								}.bind(this),
								error: function error(err) {}
							});
						} else {}
						this.setState({
							paying_process: false
						});
					}
				}
			}
			// getUserAddress function is used to get the address of the user when page loads. 
	
		}, {
			key: 'getUserAddress',
			value: function getUserAddress() {
				var _this2 = this;
	
				var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getuserAddress',
					success: function (data) {
						if (data.status === "success" && data.address.length > 0) {
							this.setState({
								user_address: data.address,
								address_flag: data.address_flag,
								add_available: true,
								click_here_status: false,
								add_address_form_status: false
							});
						} else if (data.status === "success" && data.address.length === 0) {
							this.setState({
								user_address: data.address,
								click_here_status: true,
								address_flag: data.address_flag,
								add_address_form_status: true
							});
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
				this.getCart();
				setTimeout(function () {
					_this2.setState({ lod: true });
				}, 8000);
			}
			//getCart function is used to get the cart values from the cart page to get the cart values to the checkout page
	
		}, {
			key: 'getCart',
			value: function getCart() {
				var apply_coupon = localStorage.getItem('apply_coupon');
				var apply_coupon_code = localStorage.getItem('apply_coupon_code');
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token'), apply_ac: 1, apply_coupon: apply_coupon, apply_coupon_code: apply_coupon_code, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cart',
					success: function (data) {
						this.setState({
							total: data.total,
							cart_count: data.cart_count,
							//add_id:data.add_id,
							ac_discount: data.ac_discount,
							grand_total: data.grand_total,
							aqua_cash: data.aqua_cash,
							ac_enough: data.ac_enough,
							ac_enough_msg: data.ac_enough_msg,
							apply_ac: data.apply_ac,
							used_cash: data.used_cash,
							used_cash1: data.used_cash1,
							coupons: data.coupons,
							applied_coupons: data.applied_coupons,
							applied_coupons1: data.applied_coupons1,
							coupons_amt: data.coupons_amt,
							coupons_amt1: data.coupons_amt1,
							proceedCheck: data.proceedCheck,
							proceedMsg: data.proceedMsg,
							promodiscount: data.promodiscount,
							promos: data.promos,
							applied_promos: data.applied_promos,
							loc_msg: data.loc_msg,
							address_change: data.address_change,
							address: data.address,
							location: data.location,
							zip: data.zip,
							state: data.state,
							city: data.city,
							cart_add_id: data.add_id,
	
							cart_items: data.items,
							qty: data.items.qty,
							min_qty: data.items.min_qty,
							max_qty: data.items.max_qty,
							cart_id: data.items.id,
	
							cart_total: data.total
	
						});
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
						this.getCartCalculations();
					}.bind(this),
					error: function error(err) {}
				});
			}
			//getCartCalculations function is used to get the results of the cart and payment types resutls.
	
		}, {
			key: 'getCartCalculations',
			value: function getCartCalculations() {
				this.setState({
					mode_loading: true,
					amount_loading: true
	
				});
	
				var uid = 0;
				var token = 0;
				var coupon_code = 0;
				var coupon_amount = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.token) {
					token = localStorage.getItem('token');
				} else {
					token = 0;
				}
				if (localStorage.apply_coupon_code) {
					coupon_code = localStorage.getItem('apply_coupon_code');
				} else {
					coupon_code = 0;
				}
				if (localStorage.apply_coupon) {
					coupon_amount = localStorage.getItem('apply_coupon');
				} else {
					coupon_amount = 0;
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = _defineProperty({ from: 'desktop_web', uid: uid, token: token, mode: 2, add_id: this.state.cart_add_id, code: coupon_code, coupon_amount: coupon_amount, other_amount: '', aqua_cash: this.state.used_cash1, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, source: source, campaign: campaign, url_id: url_id }, 'aqua_cash', this.state.aqua_cash);
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cartCalculations',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								mode_loading: false,
								page_loading: true,
								amount_loading: false,
								mode: data.mode,
								ptype: data.mode,
								default_ptype: data.mode,
								final_amt: data.final_amt,
								pay_at_outlet: data.pay_at_outlet,
								pay_advance: data.pay_advance,
								complete_amount: data.complete_amount,
								min_val: data.min_val,
								max_val: data.max_val,
	
								paymentMethodStatus: data.paymentMethodStatus,
								offline_payment: data.offline_payment,
								prebook_payment: data.prebook_payment,
								fullamount_payment: data.fullamount_payment,
								otheramount_payment: data.otheramount_payment,
	
								total_online_payment: data.total_online_payment,
	
								product_id: data.product_id,
								quantity: data.quantity,
								act_price: data.act_price,
								deal_price: data.deal_price,
								total: data.total,
								total_discount: data.total_discount,
								discount: data.discount,
								pre_booking_amount: data.pre_booking_amount,
								bank_fee: data.bank_fee,
								total_thx_fee: data.total_thx_fee,
								save_price: data.save_price,
								remaining_amount: data.remaining_amount,
								payable_ad: data.payable_ad,
								payable_hatchery: data.payable_hatchery,
								aqua_cash: data.aqua_cash,
								ac_offer_title: data.ac_offer_title,
								aqua_cash_value: data.aqua_cash_value,
								aqua_cash_code: data.aqua_cash_code,
								ac_cal_info: data.ac_cal_info,
								pur_ern_ofr_code: data.pur_ern_ofr_code,
								pur_ern_ofr_title: data.pur_ern_ofr_title,
								pur_ern_ofr_desc: data.pur_ern_ofr_desc,
								pur_ern_retrn_amt: data.pur_ern_retrn_amt,
								full_aquacash_back_title: data.full_aquacash_back_title,
								full_aquacash_back_code: data.full_aquacash_back_code,
								full_aquacash_back_description: data.full_aquacash_back_description,
								full_aquacash_back_amount: data.full_aquacash_back_amount,
								deal_type: data.deal_type,
								promo_code: data.promo_code,
								promo_amt: data.promo_amt,
								promo_title: data.promo_title,
								promo_help: data.promo_help,
								free_shipment: data.free_shipment,
								free_shipment_msg: data.free_shipment_msg,
								coupon_code: data.coupon_code,
								coupon_amt: data.coupon_amt,
								cart_ids: data.cart_ids,
								coupons_amt: data.coupons_amt,
								promodiscount: data.promodiscount,
								applied_promos: data.applied_promos,
	
								user_details: data.user_details,
								cart_add_id: data.add_id,
								gateway_mode: data.gateway_mode,
								deliver_date_text: data.deliver_date_text,
								payment_options: data.payment_options
							});
	
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
							if (data.mode !== 1) {
								this.setState({
									evnt_key: 2
								});
							}
						}
					}.bind(this),
					error: function (err) {
						this.setState({
							page_loading: false,
							lod: true
						});
					}.bind(this)
				});
			}
		}, {
			key: 'other_amount_cartCalculations',
			value: function other_amount_cartCalculations(mode, other_amount) {
				this.setState({
					amount_loading: true
				});
				var uid = 0;
				var token = 0;
				var coupon_code = 0;
				var coupon_amount = 0;
	
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.token) {
					token = localStorage.getItem('token');
				} else {
					token = 0;
				}
				if (localStorage.apply_coupon_code) {
					coupon_code = localStorage.getItem('apply_coupon_code');
				} else {
					coupon_code = 0;
				}
				if (localStorage.apply_coupon) {
					coupon_amount = localStorage.getItem('apply_coupon');
				} else {
					coupon_amount = 0;
				}
	
				var data1 = { from: 'desktop_web', uid: uid, token: token, mode: 4, add_id: this.state.cart_add_id, code: coupon_code, coupon_amount: coupon_amount, other_amount: other_amount, aqua_cash: this.state.used_cash1, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cartCalculations',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								// mode_loading:false,
								amount_loading: false,
								mode: data.mode,
								ptype: data.mode,
								final_amt: data.final_amt,
								pay_at_outlet: data.pay_at_outlet,
								pay_advance: data.pay_advance,
								complete_amount: data.complete_amount,
								min_val: data.min_val,
								max_val: data.max_val,
	
								paymentMethodStatus: data.paymentMethodStatus,
								offline_payment: data.offline_payment,
								prebook_payment: data.prebook_payment,
								fullamount_payment: data.fullamount_payment,
								otheramount_payment: data.otheramount_payment,
								total_online_payment: data.total_online_payment,
								product_id: data.product_id,
								quantity: data.quantity,
								act_price: data.act_price,
								deal_price: data.deal_price,
								total: data.total,
								total_discount: data.total_discount,
								discount: data.discount,
								pre_booking_amount: data.pre_booking_amount,
								bank_fee: data.bank_fee,
								total_thx_fee: data.total_thx_fee,
								save_price: data.save_price,
								remaining_amount: data.remaining_amount,
								payable_ad: data.payable_ad,
								payable_hatchery: data.payable_hatchery,
								aqua_cash: data.aqua_cash,
								ac_offer_title: data.ac_offer_title,
								aqua_cash_value: data.aqua_cash_value,
								aqua_cash_code: data.aqua_cash_code,
								ac_cal_info: data.ac_cal_info,
								pur_ern_ofr_code: data.pur_ern_ofr_code,
								pur_ern_ofr_title: data.pur_ern_ofr_title,
								pur_ern_ofr_desc: data.pur_ern_ofr_desc,
								pur_ern_retrn_amt: data.pur_ern_retrn_amt,
								full_aquacash_back_title: data.full_aquacash_back_title,
								full_aquacash_back_code: data.full_aquacash_back_code,
								full_aquacash_back_description: data.full_aquacash_back_description,
								full_aquacash_back_amount: data.full_aquacash_back_amount,
								deal_type: data.deal_type,
								promo_code: data.promo_code,
								promo_amt: data.promo_amt,
								promo_title: data.promo_title,
								promo_help: data.promo_help,
								free_shipment: data.free_shipment,
								free_shipment_msg: data.free_shipment_msg,
								coupon_code: data.coupon_code,
								coupon_amt: data.coupon_amt,
								cart_ids: data.cart_ids,
								coupons_amt: data.coupons_amt,
								promodiscount: data.promodiscount,
								applied_promos: data.applied_promos,
	
								user_details: data.user_details,
								cart_add_id: data.add_id,
								gateway_mode: data.gateway_mode,
								deliver_date_text: data.deliver_date_text,
								payment_options: data.payment_options
							});
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'modeChange_cartCalculations',
			value: function modeChange_cartCalculations(mode) {
				this.setState({
					mode_loading: true,
					amount_loading: true
				});
				var uid = 0;
				var token = 0;
				var coupon_code = 0;
				var coupon_amount = 0;
	
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.token) {
					token = localStorage.getItem('token');
				} else {
					token = 0;
				}
				if (localStorage.apply_coupon_code) {
					coupon_code = localStorage.getItem('apply_coupon_code');
				} else {
					coupon_code = 0;
				}
				if (localStorage.apply_coupon) {
					coupon_amount = localStorage.getItem('apply_coupon');
				} else {
					coupon_amount = 0;
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
	
				var data1 = { from: 'desktop_web', uid: uid, token: token, mode: mode, add_id: this.state.cart_add_id, code: coupon_code, coupon_amount: coupon_amount, other_amount: '', aqua_cash: this.state.used_cash1, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cartCalculations',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								mode_loading: false,
								amount_loading: false,
								mode: data.mode,
								ptype: data.mode,
								final_amt: data.final_amt,
								pay_at_outlet: data.pay_at_outlet,
								pay_advance: data.pay_advance,
								complete_amount: data.complete_amount,
								min_val: data.min_val,
								max_val: data.max_val,
	
								paymentMethodStatus: data.paymentMethodStatus,
								offline_payment: data.offline_payment,
								prebook_payment: data.prebook_payment,
								fullamount_payment: data.fullamount_payment,
								otheramount_payment: data.otheramount_payment,
								total_online_payment: data.total_online_payment,
								product_id: data.product_id,
								quantity: data.quantity,
								act_price: data.act_price,
								deal_price: data.deal_price,
								total: data.total,
								total_discount: data.total_discount,
								discount: data.discount,
								pre_booking_amount: data.pre_booking_amount,
								bank_fee: data.bank_fee,
								total_thx_fee: data.total_thx_fee,
								save_price: data.save_price,
								remaining_amount: data.remaining_amount,
								payable_ad: data.payable_ad,
								payable_hatchery: data.payable_hatchery,
								aqua_cash: data.aqua_cash,
								ac_offer_title: data.ac_offer_title,
								aqua_cash_value: data.aqua_cash_value,
								aqua_cash_code: data.aqua_cash_code,
								ac_cal_info: data.ac_cal_info,
								pur_ern_ofr_code: data.pur_ern_ofr_code,
								pur_ern_ofr_title: data.pur_ern_ofr_title,
								pur_ern_ofr_desc: data.pur_ern_ofr_desc,
								pur_ern_retrn_amt: data.pur_ern_retrn_amt,
								full_aquacash_back_title: data.full_aquacash_back_title,
								full_aquacash_back_code: data.full_aquacash_back_code,
								full_aquacash_back_description: data.full_aquacash_back_description,
								full_aquacash_back_amount: data.full_aquacash_back_amount,
								deal_type: data.deal_type,
								promo_code: data.promo_code,
								promo_amt: data.promo_amt,
								promo_title: data.promo_title,
								promo_help: data.promo_help,
								free_shipment: data.free_shipment,
								free_shipment_msg: data.free_shipment_msg,
								coupon_code: data.coupon_code,
								coupon_amt: data.coupon_amt,
								cart_ids: data.cart_ids,
								coupons_amt: data.coupons_amt,
								promodiscount: data.promodiscount,
								applied_promos: data.applied_promos,
	
								user_details: data.user_details,
								cart_add_id: data.add_id
							});
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			// close function is used to close both edit address modal & add address modal boxes.
	
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					add_address: false,
					edit_address: false,
					updateModal: false,
					order_error_modal: false
				});
			}
			// handleSubmit_add function for submitting the new address when click on add new address 
	
		}, {
			key: 'handleSubmit_add',
			value: function handleSubmit_add(event) {
				event.preventDefault();
				var name = this.refs.add_name.value;
				var mobile = this.refs.add_mobile.value;
				var state = this.refs.add_state.value;
				var city = this.refs.add_city.value;
				var doorno = this.refs.add_doorno.value;
				var pincode = this.refs.add_pincode.value;
	
				var flag = 0;
				var namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
				if (name && !namePattern.test(name)) {
					(0, _jquery2.default)('#add_name_err').text('*name is minimum 3 characters');
					flag = 1;
				}
				if (mobile.length < 10) {
					(0, _jquery2.default)('#add_mobile_err').text('*enter valid number');
					flag = 1;
				}
				if (state && !namePattern.test(state) && state.length < 2) {
					(0, _jquery2.default)('#add_state_err').text('*enter state');
					flag = 1;
				}
				if (city && !namePattern.test(city)) {
					(0, _jquery2.default)('#add_city_err').text('*enter city');
					flag = 1;
				}
				if (doorno && doorno.length <= 1) {
					(0, _jquery2.default)('#add_doorno_err').text('*enter address');
					flag = 1;
				}
				if (pincode && pincode.length < 6) {
					(0, _jquery2.default)('#add_pincode_err').text('*enter valid pincode');
					flag = 1;
				}
				if (flag === 0) {
					var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, name: name, mobile: mobile, state: state, city: city, address: doorno, zip: pincode };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'saveAdd',
						success: function (data) {
							if (data.status === "success") {
								this.close();
								this.getUserAddress();
								this.setState({
									add_state: '',
									add_city: '',
									add_doorno: '',
									add_pincode: ''
								});
							}
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
			//handleSubmit_edit function for updating the address when click on edit icon in the swipe list.
	
		}, {
			key: 'handleSubmit_edit',
			value: function handleSubmit_edit(event) {
				event.preventDefault();
				var add_id = this.state.edit_add_id;
	
				var name = this.refs.edit_name.value;
				var mobile = this.refs.edit_mobile.value;
				var state = this.refs.edit_state.value;
				var city = this.refs.edit_city.value;
				var doorno = this.refs.edit_doorno.value;
				var pincode = this.refs.edit_pincode.value;
	
				var flag = 0;
				// const emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
				var namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
				if (name && !namePattern.test(name)) {
					(0, _jquery2.default)('#edit_name_err').text('*name is minimum 3 characters');
					flag = 1;
				}
				if (mobile.length < 10) {
					(0, _jquery2.default)('#edit_mobile_err').text('*enter valid number');
					flag = 1;
				}
				if (state && !namePattern.test(state) && state.length < 2) {
					(0, _jquery2.default)('#edit_state_err').text('*enter state');
					flag = 1;
				}
				if (city && !namePattern.test(city)) {
					(0, _jquery2.default)('#edit_city_err').text('*enter city');
					flag = 1;
				}
				if (doorno && doorno.length <= 1) {
					(0, _jquery2.default)('#edit_doorno_err').text('*enter address');
					flag = 1;
				}
				if (pincode && pincode.length < 6) {
					(0, _jquery2.default)('#edit_pincode_err').text('*enter valid pincode');
					flag = 1;
				}
				if (flag === 0) {
					var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, add_id: add_id, name: name, mobile: mobile, state: state, city: city, address: doorno, zip: pincode };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'updateAdd',
						success: function (data) {
							if (data.status === "success") {
								this.close();
								this.getUserAddress();
							}
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
			//editAddress function for when click on edit icon that enables the status of the Edit form modal
	
		}, {
			key: 'editAddress',
			value: function editAddress(add_id) {
				this.setState({
					edit_add_id: add_id,
					edit_address: true
				});
			}
			// deleteAddress function is used when click on deleted icon in swipe address list
	
		}, {
			key: 'deleteAddress',
			value: function deleteAddress(add_id) {
				var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, add_id: add_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'deleteAdd',
					success: function (data) {
						if (data.status === "success") {
							this.getUserAddress();
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			// getAddressDetails function is used to get the address details from server when click the edit icon and edit modal form is opened. 
	
		}, {
			key: 'getAddressDetails',
			value: function getAddressDetails() {
				var add_id = this.state.edit_add_id;
				var data1 = { from: 'desktop_web', uid: localStorage.user_id, token: localStorage.token, id: add_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'get_add_details',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								edit_data: data.data,
								edit_name: data.data[0]['name'],
								edit_mobile: data.data[0]['phone'],
								edit_state: data.data[0]['state'],
								edit_city: data.data[0]['city'],
								edit_doorno: data.data[0]['address'],
								edit_pincode: data.data[0]['zip']
							});
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			//******************
			/* functions for EDIT form validations and upations start here  */
	
			// edit_nameChange function is used to set the edit_name value edit modal form.
	
		}, {
			key: 'edit_nameChange',
			value: function edit_nameChange(event) {
				// this.setState({
				// 	edit_name:event.target.value,
				// });
				var x = event.target.value;
				var invalidChars = /[^a-zA-Z ]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						edit_name: x
					});
				}
			}
		}, {
			key: 'edit_mobileChange',
			value: function edit_mobileChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						edit_mobile: x
					});
				}
			}
		}, {
			key: 'edit_stateChange',
			value: function edit_stateChange(event) {
				// this.setState({
				// 	edit_state:event.target.value,
				// });
				var x = event.target.value;
				var invalidChars = /[^a-zA-Z]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						edit_state: x
	
					});
				}
			}
		}, {
			key: 'edit_cityChange',
			value: function edit_cityChange(event) {
				// this.setState({
				// 	edit_city:event.target.value,
				// });
				var x = event.target.value;
				var invalidChars = /[^a-zA-Z]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						edit_city: x
					});
				}
			}
		}, {
			key: 'edit_doornoChange',
			value: function edit_doornoChange(event) {
				this.setState({
					edit_doorno: event.target.value
				});
			}
		}, {
			key: 'edit_pincodeChange',
			value: function edit_pincodeChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						edit_pincode: x
					});
				}
				// this.setState({
				// 	edit_pincode:event.target.value,
				// });
			}
			// **********************************
			// functions for "EDIT" form validations and upations "ENDS" here
	
			// functions for "ADD" form validations and updations START here 
			// ***************************************
	
		}, {
			key: 'add_nameChange',
			value: function add_nameChange(event) {
				// this.setState({
				// 	add_name:event.target.value,
				// });
				var x = event.target.value;
				var invalidChars = /[^a-zA-Z ]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						add_name: x
					});
				}
			}
		}, {
			key: 'add_mobileChange',
			value: function add_mobileChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						add_mobile: x
					});
				}
			}
		}, {
			key: 'add_stateChange',
			value: function add_stateChange(event) {
				// this.setState({
				// 	add_state:event.target.value,
				// });
				var x = event.target.value;
				var invalidChars = /[^a-zA-Z]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						add_state: x
	
					});
				}
			}
		}, {
			key: 'add_cityChange',
			value: function add_cityChange(event) {
				// this.setState({
				// 	add_city:event.target.value,
				// });
				var x = event.target.value;
				var invalidChars = /[^a-zA-Z]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						add_city: x
					});
				}
			}
		}, {
			key: 'add_doornoChange',
			value: function add_doornoChange(event) {
				this.setState({
					add_doorno: event.target.value
				});
			}
		}, {
			key: 'add_pincodeChange',
			value: function add_pincodeChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						add_pincode: x
					});
				}
			}
			// ***********************************
	
			// setDefaultAddress function is used to set the default address when click on circle image in address block 
			// setDefaultAddress(add_id)
			// {
			// 	var data1={from:'desktop_web',id:localStorage.user_id,token:localStorage.token,add_id:add_id};
			// 	var data2=JSON.stringify(data1);
			// 	$.ajax({
			// 		method:'POST',
			// 		dataType:'json',
			// 		data:{req:data2},
			// 		url:baseUrl+'setdefault_address',
			// 		success:function(data)
			// 		{
			// 			if(data.status==="success")
			// 			{
			// 				this.getUserAddress();
			// 			}
			// 			if(data.status==='error' && data.message==='Token mismatch')
			// 			{
			// 				this.props.tokenCheck();
			// 			}
			// 		}.bind(this),
			// 		error:function(err)
			// 		{
			// 		}
			// 	});
			// }
	
			//setPaymentMode is used to set the mode of the payment like 2 for - advance,3 for total,4 for other and calling the modeChange_cartCalculations
			//hiding the other amount input field and calling
	
		}, {
			key: 'setPaymentMode',
			value: function setPaymentMode(id) {
				this.setState({
					ptype: id,
					mode: id
				});
				if (id === 4) {
					this.setState({
						other_amount_field_status: true
	
					});
				} else {
					this.setState({
						other_amount_field_status: false
					});
					this.modeChange_cartCalculations(id);
				}
			}
		}, {
			key: 'validateOtherAmount',
			value: function validateOtherAmount() {
				var x = '';
				if (parseInt(this.refs.ref_other_amt.value, 10) < parseInt(this.state.min_val, 10)) {
					x = 'Minimum Quantity is ' + this.state.min_val;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Minimum amount is ' + this.state.min_val
					});
				}
				if (parseInt(this.refs.ref_other_amt.value, 10) > parseInt(this.state.max_val, 10)) {
					x = 'Maximum Quantity is ' + this.state.max_val;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Maximum amount is ' + this.state.max_val
					});
				}
				var check = /[^0-9]/gi;
				if (check.test(this.refs.ref_other_amt.value)) {
					x = '* Invalid Amount';
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Invalid Amount'
					});
				}
	
				if (x === '') {
					this.other_amount_cartCalculations(4, this.refs.ref_other_amt.value);
				}
	
				/*	if(x==='')
	   	{
	   		this.other_amount_cartCalculations(4,this.refs.ref_other_amt.value);	
	   	}
	   */
			}
		}, {
			key: 'handleTabsSelect',
			value: function handleTabsSelect(key) {
				this.setState({
					evnt_key: key
				});
				this.modeChange_cartCalculations(key);
			}
			// functions for "ADD" form validations and updations END here 
	
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var coupon_map = this.state.coupons.map(function (coupon, index) {
					return _react2.default.createElement(
						'span',
						{ key: index, style: { display: 'block' } },
						coupon.coupon_code,
						' (\u20B9',
						coupon.value,
						' )'
					);
				});
				var couponsList = _react2.default.createElement(
					_reactBootstrap.Popover,
					{ id: 'popover-positioned-top1' },
					coupon_map
				);
				var coupon_info = _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{ trigger: 'focus', placement: 'top', overlay: couponsList },
					_react2.default.createElement(
						_reactBootstrap.Button,
						{ className: 'cartCoupon_info_img' },
						_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_info.png', alt: ' ' })
					)
				);
	
				var promos_map = this.state.promos.map(function (promo, index) {
					return _react2.default.createElement(
						'span',
						{ key: index, style: { display: 'block' } },
						promo.promo_code,
						' ( \u20B9 ',
						promo.promo_value,
						' )'
					);
				});
				var promosList = _react2.default.createElement(
					_reactBootstrap.Popover,
					{ id: 'popover-positioned-top2' },
					promos_map
				);
	
				var promo_info = '';
				promo_info = _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{ trigger: 'focus', placement: 'top', overlay: promosList },
					_react2.default.createElement(
						_reactBootstrap.Button,
						{ className: 'cartCoupon_info_img' },
						_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_info.png', alt: ' ' })
					)
				);
				document.title = "Checkout | AquaDeals";
				var tabs_data = '';
				// $('#off_modal_status').parent().addClass('offline_modal');
				var that = this;
				(0, _jquery2.default)(document).ready(function () {
	
					(0, _jquery2.default)('#web_add_address').validate({
						rules: {
							add_name: {
								required: true,
								minlength: 3
							},
							add_mobile: {
								required: true,
								minlength: 10,
								digits: true
							},
							add_state: {
								required: true,
								minlength: 2
							},
							add_city: {
								required: true,
								minlength: 3
							},
							add_doorno: {
								required: true,
								minlength: 2
							},
							add_pincode: {
								required: true,
								minlength: 6,
								maxlength: 6,
								digits: true
							}
						},
						messages: {
							add_name: {
								required: 'Enter name',
								minlength: 'Enter minimum 3 characters'
							},
							add_mobile: {
								required: 'Enter mobile number',
								minlength: 'Enter valid mobile number',
								digits: 'Enter valid mobile number'
							},
							add_state: {
								required: 'Enter state',
								minlength: 'Enter valid state'
							},
							add_city: {
								required: 'Enter city',
								minlength: 'Enter minimum 3 characters'
							},
							add_doorno: {
								required: 'Enter door number',
								minlength: 'Enter valid door number'
							},
							add_pincode: {
								required: 'Enter pincode',
								minlength: 'Enter valid pincode',
								maxlength: 'Enter valid pincode',
								digits: 'Enter valid pincode'
							}
						},
						submitHandler: function submitHandler(form) {
							// var data = $('#web_add_address').serializeArray();
							var add_mobile = (0, _jquery2.default)('#add_mobile').val();
							var add_name = (0, _jquery2.default)('#add_name').val();
							var add_state = (0, _jquery2.default)('#add_state').val();
							var add_city = (0, _jquery2.default)('#add_city').val();
							var add_pincode = (0, _jquery2.default)('#add_pincode').val();
							var add_doorno = (0, _jquery2.default)('#add_doorno').val();
							var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, name: add_name, mobile: add_mobile, state: add_state, city: add_city, address: add_doorno, zip: add_pincode };
							var data2 = JSON.stringify(data1);
							_jquery2.default.ajax({
								method: 'POST',
								dataType: 'json',
								data: { req: data2 },
								url: baseUrl + 'saveAdd',
								success: function (data) {
									if (data.status === "success") {
										that.getUserAddress();
										(0, _jquery2.default)('#web_add_address')[0].reset();
									}
									if (data.status === 'error' && data.message === 'Token mismatch') {
										this.props.tokenCheck();
									}
								}.bind(this),
								error: function error(err) {}
							});
						}
	
					});
				});
	
				(0, _jquery2.default)('.mob_check').unbind("click").click(function () {
					(0, _jquery2.default)(".mob_check img").attr("src", "https://aquadeals.in/admin/assets/images/icons/circle_gray.png");
					var sel_addr_id = (0, _jquery2.default)(this).attr("id");
					var add_id = sel_addr_id.replace('swipe-addr-id_', '');
					(0, _jquery2.default)("#" + sel_addr_id + " .mob_check img").attr("src", "https://aquadeals.in/admin/assets/images/icons/ok.png");
					//$(".swipe_addr_blk .mob_check img").attr('src',"https://aquadeals.in/admin/assets/images/icons/circle_gray.png");
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, add_id: add_id, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'setdefault_address',
						success: function (data) {
							if (data.status === "success") {
								//this.getUserAddress();
							}
						}.bind(this),
						error: function error(err) {
							console.log(err);
						}
					});
				});
	
				if (this.state.paymentMethodStatus === 'Both') {
					tabs_data = _react2.default.createElement(
						_reactBootstrap.Tabs,
						{ activeKey: this.state.evnt_key, className: 'web_pay_both', id: 'controlled-tab-ex', onSelect: this.handleTabsSelect },
						_react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: 2, title: 'ONLINE' },
							_react2.default.createElement(
								'div',
								null,
								this.state.prebook_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group web_group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 2 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_adv', checked: this.state.ptype === 2 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(2);
											}, required: true }),
										'Pay Advance \u20B9 ',
										this.state.pay_advance
									)
								) : '',
								this.state.otheramount_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group web_group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 4 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_other', checked: this.state.ptype === 4 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(4);
											}, required: true }),
										'Pay Other Advance ',
										this.state.other_amount_field_status ? _react2.default.createElement(
											'span',
											{ style: { marginLeft: '10px', position: 'absolute' } },
											_react2.default.createElement('input', { onBlur: function onBlur() {
													return _this3.validateOtherAmount();
												}, onChange: function onChange() {
													return _this3.validateOtherAmount();
												}, ref: 'ref_other_amt', id: 'ref_other_amt', type: 'text', placeholder: 'Enter Amount' }),
											this.state.err_qty_status ? _react2.default.createElement(
												'span',
												{ className: 'error_other_amt' },
												this.state.err_qty_msg
											) : ''
										) : ''
									)
								) : '',
								this.state.fullamount_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group web_group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 3 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_total', checked: this.state.ptype === 3 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(3);
											}, required: true }),
										'Pay Total \u20B9 ',
										this.state.final_amt
									)
								) : '',
								this.state.free_shipment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'web_ship_van' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
									),
									' ',
									this.state.free_shipment_msg
								) : '',
								this.state.full_aquacash_back_title ? _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/newcashback.png', alt: '', width: '20px' }),
										' '
									),
									' ',
									this.state.full_aquacash_back_title
								) : ''
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: 1, title: 'OFFLINE' },
							_react2.default.createElement(
								'div',
								null,
								this.state.offline_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group web_group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 1 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_outlet', checked: this.state.ptype === 1 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(1);
											}, required: true }),
										'Pay at Outlet \u20B9 ',
										this.state.final_amt
									),
									this.state.free_shipment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'web_ship_van' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
										),
										' ',
										this.state.free_shipment_msg
									) : '',
									this.state.full_aquacash_back_title ? _react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/newcashback.png', alt: '', width: '20px' }),
											' '
										),
										' ',
										this.state.full_aquacash_back_title
									) : ''
								) : ''
							)
						)
					);
				} else if (this.state.paymentMethodStatus === 'Online') {
					tabs_data = _react2.default.createElement(
						_reactBootstrap.Tabs,
						{ activeKey: this.state.evnt_key, className: 'pay_online', id: 'controlled-tab-ex', onSelect: this.handleTabsSelect },
						_react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: 2, title: 'ONLINE' },
							_react2.default.createElement(
								'div',
								null,
								this.state.prebook_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 2 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_adv', checked: this.state.ptype === 2 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(2);
											}, required: true }),
										'Pay Advance \u20B9 ',
										this.state.pay_advance
									)
								) : '',
								this.state.otheramount_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 4 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_other', checked: this.state.ptype === 4 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(4);
											}, required: true }),
										'Pay Other Advance ',
										this.state.other_amount_field_status ? _react2.default.createElement(
											'span',
											{ style: { marginLeft: '10px', position: 'absolute' } },
											_react2.default.createElement('input', { onChange: function onChange() {
													return _this3.validateOtherAmount();
												}, onBlur: function onBlur() {
													return _this3.validateOtherAmount();
												}, ref: 'ref_other_amt', id: 'ref_other_amt', type: 'text', placeholder: 'Enter Amount' }),
											this.state.err_qty_status ? _react2.default.createElement(
												'span',
												{ className: 'error_other_amt' },
												this.state.err_qty_msg
											) : ''
										) : ''
									)
								) : '',
								this.state.fullamount_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 3 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_total', checked: this.state.ptype === 3 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(3);
											}, required: true }),
										'Pay Total \u20B9 ',
										this.state.final_amt
									)
								) : '',
								this.state.free_shipment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'web_ship_van' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
									),
									' ',
									this.state.free_shipment_msg
								) : '',
								this.state.full_aquacash_back_title ? _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/newcashback.png', alt: '', width: '20px' }),
										' '
									),
									' ',
									this.state.full_aquacash_back_title
								) : ''
							)
						),
						this.state.offline_payment === 1 ? _react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: 1, title: 'OFFLINE' },
							_react2.default.createElement(
								'div',
								null,
								this.state.offline_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 1 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_outlet', checked: this.state.ptype === 1 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(1);
											}, required: true }),
										'Pay at Outlet \u20B9 ',
										this.state.final_amt
									),
									this.state.free_shipment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'web_ship_van' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
										),
										' ',
										this.state.free_shipment_msg
									) : '',
									this.state.full_aquacash_back_title ? _react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/newcashback.png', alt: '', width: '20px' }),
											' '
										),
										' ',
										this.state.full_aquacash_back_title
									) : ''
								) : ''
							)
						) : ''
					);
				} else if (this.state.paymentMethodStatus === 'Offline') {
					tabs_data = _react2.default.createElement(
						_reactBootstrap.Tabs,
						{ activeKey: 1, className: 'pay_offline', id: 'controlled-tab-ex' },
						this.state.offline_payment === 1 ? _react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: 1, title: 'OFFLINE' },
							_react2.default.createElement(
								'div',
								null,
								this.state.offline_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 1 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_outlet', checked: this.state.ptype === 1 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(1);
											}, required: true }),
										'Pay at Outlet \u20B9 ',
										this.state.final_amt
									),
									this.state.free_shipment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'web_ship_van' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
										),
										' ',
										this.state.free_shipment_msg
									) : '',
									this.state.full_aquacash_back_title ? _react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/newcashback.png', alt: '', width: '20px' }),
											' '
										),
										' ',
										this.state.full_aquacash_back_title
									) : ''
								) : ''
							)
						) : ''
					);
				} else if (this.state.paymentMethodStatus === 'None') {
					tabs_data = _react2.default.createElement(
						_reactBootstrap.Tabs,
						{ activeKey: this.state.evnt_key, id: 'controlled-tab-ex', onSelect: this.handleTabsSelect, className: 'pay_partner' },
						_react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: 2, title: 'ONLINE' },
							_react2.default.createElement(
								'div',
								null,
								this.state.prebook_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 2 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_adv', checked: this.state.ptype === 2 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(2);
											}, required: true }),
										'Pay Advance \u20B9 ',
										this.state.pay_advance
									)
								) : '',
								this.state.otheramount_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 4 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_other', checked: this.state.ptype === 4 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(4);
											}, required: true }),
										'Pay Other Advance ',
										this.state.other_amount_field_status ? _react2.default.createElement(
											'span',
											{ style: { marginLeft: '10px', position: 'absolute' } },
											_react2.default.createElement('input', { onBlur: function onBlur() {
													return _this3.validateOtherAmount();
												}, onChange: function onChange() {
													return _this3.validateOtherAmount();
												}, ref: 'ref_other_amt', id: 'ref_other_amt', type: 'text', placeholder: 'Enter Amount' }),
											this.state.err_qty_status ? _react2.default.createElement(
												'span',
												{ className: 'error_other_amt' },
												this.state.err_qty_msg
											) : ''
										) : ''
									)
								) : '',
								this.state.fullamount_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 3 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_total', checked: this.state.ptype === 3 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(3);
											}, required: true }),
										'Pay Total \u20B9 ',
										this.state.final_amt
									)
								) : '',
								this.state.free_shipment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'web_ship_van' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
									),
									' ',
									this.state.free_shipment_msg
								) : '',
								this.state.full_aquacash_back_title ? _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/newcashback.png', alt: '', width: '20px' }),
										' '
									),
									' ',
									this.state.full_aquacash_back_title
								) : ''
							)
						),
						this.state.offline_payment === 1 ? _react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: 1, title: 'OFFLINE' },
							_react2.default.createElement(
								'div',
								null,
								this.state.offline_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 1 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_outlet', checked: this.state.ptype === 1 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(1);
											}, required: true }),
										'Pay at Outlet \u20B9 ',
										this.state.final_amt
									),
									this.state.free_shipment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'web_ship_van' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', alt: '', width: '25px' })
										),
										' ',
										this.state.free_shipment_msg
									) : '',
									this.state.full_aquacash_back_title ? _react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/newcashback.png', alt: '', width: '20px' }),
											' '
										),
										' ',
										this.state.full_aquacash_back_title
									) : ''
								) : ''
							)
						) : ''
					);
				}
	
				// edit form empty errors when click on the text input fields starts here
				(0, _jquery2.default)('#edit_name').keyup(function () {
					(0, _jquery2.default)('#edit_name_err').text('');
				});
				(0, _jquery2.default)('#edit_mobile').keyup(function () {
					(0, _jquery2.default)('#edit_mobile_err').text('');
				});
				(0, _jquery2.default)('#edit_state').keyup(function () {
					(0, _jquery2.default)('#edit_state_err').text('');
				});
				(0, _jquery2.default)('#edit_city').keyup(function () {
					(0, _jquery2.default)('#edit_city_err').text('');
				});
				(0, _jquery2.default)('#edit_doorno').keyup(function () {
					(0, _jquery2.default)('#edit_doorno_err').text('');
				});
				(0, _jquery2.default)('#edit_pincode').keyup(function () {
					(0, _jquery2.default)('#edit_pincode_err').text('');
				});
				// edit form validations ends here
	
				// add form removing error msg's when click on input fields start here
				(0, _jquery2.default)('#add_name').keyup(function () {
					(0, _jquery2.default)('#add_name_err').text('');
				});
				(0, _jquery2.default)('#add_mobile').keyup(function () {
					(0, _jquery2.default)('#add_mobile_err').text('');
				});
				(0, _jquery2.default)('#add_state').keyup(function () {
					(0, _jquery2.default)('#add_state_err').text('');
				});
				(0, _jquery2.default)('#add_city').keyup(function () {
					(0, _jquery2.default)('#add_city_err').text('');
				});
				(0, _jquery2.default)('#add_doorno').keyup(function () {
					(0, _jquery2.default)('#add_doorno_err').text('');
				});
				(0, _jquery2.default)('#add_pincode').keyup(function () {
					(0, _jquery2.default)('#add_pincode_err').text('');
				});
	
				//      if(this.state.user_address.length==1){
				// $(".web_checkout_page .swiper-slide:nth-of-type(1)").unbind("css").css({margin:'0 auto'});        	        	
				//      }	
	
				var params = {
					paginationClickable: true,
					spaceBetween: 30,
					slidesPerView: 2.2
				};
	
				var delivery_address = this.state.user_address.map(function (data, index) {
					var _this4 = this;
	
					return localStorage.address_change_flag === '0' ? _react2.default.createElement(
						_reactBootstrap.Col,
						{ md: 12, xs: 12, className: 'swipe_addr_blk', id: "swipe-addr-id_" + data.add_id },
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 3, sm: 3, xs: 3, className: 'mob_check', id: "swipe-addr-id_" + data.add_id },
							_react2.default.createElement('img', { src: data.default === '1' ? baseAssets + 'images/icons/ok.png' : baseAssets + 'images/icons/circle_gray.png', alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ style: { margin: '0 20px' } },
							_react2.default.createElement(
								_reactBootstrap.Col,
								{ md: 10, sm: 10, xs: 10, className: 's_data_blk' },
								_react2.default.createElement(
									'p',
									null,
									data.name,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.mobile,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.state,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.city,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.address,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.zip,
									'\xA0'
								)
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 12, sm: 12, xs: 12, style: { paddingLeft: '0px', paddingRight: '0px' } },
							_react2.default.createElement(
								'ul',
								{ className: 'addr_btns' },
								'// ',
								_react2.default.createElement(
									'li',
									{ onClick: function onClick() {
											_this4.editAddress(data.add_id);
										} },
									'EDIT'
								),
								'// ',
								_react2.default.createElement(
									'li',
									{ onClick: function onClick() {
											return _this4.deleteAddress(data.add_id);
										} },
									'DELETE'
								),
								_react2.default.createElement(
									'div',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									null,
									'\xA0'
								)
							)
						)
					) : _react2.default.createElement(
						_reactBootstrap.Col,
						{ md: 10, xs: 10, className: 'swipe_addr_blk', id: "swipe-addr-id_" + data.add_id },
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 2, sm: 2, xs: 2, className: 'mob_check', id: "swipe-addr-id_" + data.add_id },
							_react2.default.createElement('img', { src: data.default === '1' ? baseAssets + 'images/icons/ok.png' : baseAssets + 'images/icons/circle_gray.png', alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ style: { margin: '0 20px' } },
							_react2.default.createElement(
								_reactBootstrap.Col,
								{ md: 10, sm: 10, xs: 10, className: 's_data_blk' },
								_react2.default.createElement(
									'p',
									null,
									data.name,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.mobile,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.state,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.city,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.address,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.zip,
									'\xA0'
								)
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 12, sm: 12, xs: 12, style: { paddingLeft: '0px', paddingRight: '0px' } },
							_react2.default.createElement(
								'ul',
								{ className: 'addr_btns' },
								_react2.default.createElement(
									'li',
									{ onClick: function onClick() {
											_this4.editAddress(data.add_id);
										} },
									'EDIT'
								),
								_react2.default.createElement(
									'li',
									{ onClick: function onClick() {
											return _this4.deleteAddress(data.add_id);
										} },
									'DELETE'
								)
							)
						)
					);
				}.bind(this));
	
				var offline_success = _react2.default.createElement(
					'section',
					{ className: 'offline_success_data' },
					_react2.default.createElement(
						_reactBootstrap.Modal.Header,
						{ className: 'offline_header_section' },
						_react2.default.createElement(
							'div',
							{ className: '' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: "/web/home" },
									_react2.default.createElement(
										'i',
										{ style: { marginRight: '15px' } },
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/close_icon1.png', width: '16px', alt: '' })
									)
								),
								'Confirmation'
							),
							_react2.default.createElement(
								'a',
								{ href: '/web/home', className: 'web_home_icon' },
								_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/home2.png', alt: 'Home' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ style: { textAlign: 'center', paddingBottom: '10px' } },
						_react2.default.createElement(
							'i',
							null,
							_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cc_footer_icon.png', alt: 'AquaDeals', width: '100px' })
						),
						_react2.default.createElement(
							'h5',
							{ style: { color: 'green' } },
							this.state.offline_confirm_data.success_msg
						),
						_react2.default.createElement(
							'h6',
							{ style: { color: '#ff742a' } },
							this.state.offline_confirm_data.thank_msg
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal_ordr_dtls_blk' },
						_react2.default.createElement(
							'div',
							{ className: 'web_modal_ordr_dtls' },
							_react2.default.createElement(
								'h5',
								null,
								'Order Details'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: '', style: { padding: '10px' } },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									'span',
									null,
									'SELLER NAME : '
								),
								_react2.default.createElement(
									'span',
									null,
									this.state.offline_confirm_data.address ? this.state.offline_confirm_data.address.seller_name : ''
								)
							),
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									'span',
									null,
									'ORDER NO'
								),
								_react2.default.createElement(
									'span',
									{ style: { float: 'right' } },
									'ORDER DATE'
								)
							),
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									'span',
									null,
									this.state.offline_confirm_data.book_id
								),
								_react2.default.createElement(
									'span',
									{ style: { float: 'right' } },
									this.state.offline_confirm_data.booking_date ? this.state.offline_confirm_data.booking_date : ''
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal_pro_details_blk' },
						_react2.default.createElement(
							'div',
							{ className: 'web_modal_pro_title' },
							_react2.default.createElement(
								'h5',
								null,
								'Product Details '
							)
						),
						_react2.default.createElement(
							'div',
							{ style: { padding: '10px' } },
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									null,
									'Item : ',
									this.state.offline_confirm_data.qty ? this.state.offline_confirm_data.qty : ''
								),
								_react2.default.createElement(
									'span',
									{ style: { float: 'right' } },
									'Total : ',
									this.state.offline_confirm_data.remaining_amount ? this.state.offline_confirm_data.remaining_amount : ''
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: '', style: { backgroundColor: '#fff', overflow: 'hidden', paddingBottom: '10px', marginTop: '10px' } },
						this.state.offline_confirm_data.order_items ? this.state.offline_confirm_data.order_items.map(function (data, index) {
							return _react2.default.createElement(
								'div',
								{ className: 'col-xs-12 col-md-12 col-sm-12 col-lg-12', style: { padding: '0px', paddingTop: '15px', paddingBottom: '15px', borderTop: '1px solid #eee' } },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-3 col-md-3 col-sm-3' },
									_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/thumbnails/20170323130243537436.jpg', alt: ' ' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-6 col-md-6 col-sm-6', style: { padding: '0px' } },
									_react2.default.createElement(
										'p',
										null,
										data.pro_name,
										' ',
										data.unit
									),
									_react2.default.createElement(
										'p',
										null,
										'QTY : ',
										data.quantity
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-3 col-md-3 col-sm-3', style: { padding: '0px' } },
									_react2.default.createElement(
										'p',
										{ style: { marginTop: '17px' } },
										'\u20B9 ',
										data.deal_amt
									)
								)
							);
						}) : ''
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ style: { backgroundColor: '#f1f1f2', padding: '5px 0px 5px 10px' } },
							_react2.default.createElement(
								'h5',
								null,
								'PAYMENT DETAILS'
							)
						),
						_react2.default.createElement(
							'div',
							{ style: { backgroundColor: '#fff', padding: '10px' } },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									'span',
									null,
									this.state.offline_confirm_data.payment_details ? this.state.offline_confirm_data.payment_details[0].title : ''
								),
								_react2.default.createElement(
									'span',
									{ style: { float: 'right' } },
									'\u20B9 ',
									this.state.offline_confirm_data.payment_details ? this.state.offline_confirm_data.payment_details[0].value : ''
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: '', style: { backgroundColor: '#f1f1f2', padding: '5px 0px 5px 10px' } },
							_react2.default.createElement(
								'h5',
								null,
								'SHIPPING ADDRESS'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: '', style: { backgroundColor: '#fff', padding: '10px' } },
							_react2.default.createElement(
								'p',
								null,
								this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].name : ''
							),
							_react2.default.createElement(
								'p',
								null,
								this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].address : '',
								' , ',
								this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].city : '',
								' '
							),
							_react2.default.createElement(
								'p',
								null,
								this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].state : ''
							),
							_react2.default.createElement(
								'p',
								null,
								this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].phone : ''
							),
							_react2.default.createElement(
								'p',
								null,
								this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].zip : ''
							)
						)
					)
				);
	
				var Items = this.state.cart_items.map(function (item, index) {
					return _react2.default.createElement(
						'div',
						{ className: 'row cart_ItemsList' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: '' },
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-2 col-md-2 col-lg-2 webcart_centerimg' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: item.type === 0 ? '/web/sdetails/' + item.url_name + '/' + item.deal_id : '/web/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
										item.type === 0 ? _react2.default.createElement('img', { src: baseAssets + 'icons/' + item.img, alt: ' ' }) : _react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/thumbnails/' + item.img, alt: ' ' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'cartdesc_Blk' },
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-2 col-md-2 col-sm-2 col-xs-2 cart_title_blk' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: item.type === 0 ? '/web/sdetails/' + item.url_name + '/' + item.deal_id : '/web/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
											item.pro_name !== "" ? _react2.default.createElement(
												'h3',
												{ className: 'cartitem_Title' },
												item.pro_name
											) : _react2.default.createElement(
												'h3',
												{ className: 'cartitem_Title' },
												'\xA0'
											),
											item.brand ? _react2.default.createElement(
												'h4',
												{ className: 'cartitem_Brand' },
												item.brand
											) : _react2.default.createElement(
												'h4',
												null,
												'\xA0'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-md-2 col-lg-2 col-sm-2 text-right' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: item.type === 0 ? '/web/sdetails/' + item.url_name + '/' + item.deal_id : '/web/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
											item.mrp !== '' ? _react2.default.createElement(
												'h3',
												{ className: 'webcart_mrp' },
												'\u20B9',
												item.mrp
											) : _react2.default.createElement(
												'h3',
												null,
												'\xA0'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-3 col-sm-3 col-md-3 col-lg-3 text-center' },
										item.min_qty !== "" ? _react2.default.createElement(
											'p',
											{ className: 'webQty_Edit cart_edit ' },
											item.qty
										) : _react2.default.createElement(
											'p',
											null,
											'\xA0'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-2 col-sm-2 col-md-2 col-lg-2', style: { paddingLeft: '0px', paddingRight: '0px' } },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: item.type === 0 ? '/web/sdetails/' + item.url_name + '/' + item.deal_id : '/web/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
											item.amount !== "" ? _react2.default.createElement(
												'p',
												{ className: 'cartitem_amount cart_amt' },
												_react2.default.createElement(
													'span',
													null,
													'\u20B9 '
												),
												_react2.default.createElement(
													'span',
													null,
													item.amount
												)
											) : _react2.default.createElement(
												'p',
												null,
												'\xA0'
											)
										)
									),
									_react2.default.createElement('div', { className: 'col-lg-1 col-md-1 col-sm-1 col-xs-1' })
								)
							)
						)
					);
				});
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_checkout_page' },
					this.state.page_loading ? _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_WebHeaderInner2.default, null),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb,
								{ className: 'webcheckout_breadcrumb' },
								_react2.default.createElement(
									_reactBootstrap.Breadcrumb.Item,
									{ href: '/web/home' },
									'Home'
								),
								_react2.default.createElement(
									_reactBootstrap.Breadcrumb.Item,
									{ active: true },
									'Checkout'
								)
							)
						),
						parseInt(this.state.cart_count, 10) > 0 ? _react2.default.createElement(
							'div',
							{ className: 'body_content' },
							this.state.paying_process ? _react2.default.createElement(
								'div',
								{ className: 'checkout_loading' },
								_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
							) : _react2.default.createElement(
								'section',
								{ className: 'container' },
								_react2.default.createElement(
									'div',
									{ className: 'row webDels_cntnt' },
									this.state.offline_success ? _react2.default.createElement(
										'div',
										{ className: 'col-md-6 col-md-offset-3 web_dels_cntnt' },
										offline_success
									) : _react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											'div',
											{ className: 'container' },
											_react2.default.createElement(
												'section',
												{ id: 'cart-process' },
												_react2.default.createElement(
													'div',
													{ className: 'progressbar-wrapper', style: { background: 'unset!important' } },
													_react2.default.createElement(
														'ul',
														{ className: 'progressbar' },
														_react2.default.createElement(
															'li',
															{ className: 'active' },
															_react2.default.createElement(
																'div',
																null,
																'Cart'
															),
															_react2.default.createElement(
																'div',
																null,
																_react2.default.createElement(_reactWebVectorIcons2.default, {
																	name: 'check',
																	font: 'Entypo',
																	color: '#fff',
																	size: 14
																	// style={{}}
																})
															)
														),
														_react2.default.createElement(
															'li',
															null,
															_react2.default.createElement(
																'div',
																null,
																'Checkout'
															),
															_react2.default.createElement(
																'div',
																null,
																_react2.default.createElement(_reactWebVectorIcons2.default, {
																	name: 'check',
																	font: 'Entypo',
																	color: '#fff',
																	size: 14
																	// style={{}}
																})
															)
														),
														_react2.default.createElement(
															'li',
															null,
															'Payment'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-3 col-lg-3 col-sm-3' },
												_react2.default.createElement(
													'div',
													{ className: 'web_chk_dlry_title_blk' },
													_react2.default.createElement(
														'h4',
														null,
														'ADD SHIPPING ADDRESS'
													)
												),
												_react2.default.createElement(
													'form',
													{ className: 'web_add_address_form', id: 'web_add_address', name: 'web_add_address', method: 'post' },
													_react2.default.createElement(
														'div',
														{ className: 'web_add_form_blk' },
														_react2.default.createElement('input', { placeholder: 'Name', name: 'add_name', ref: 'add_name', value: this.state.add_name, id: 'add_name', onChange: function onChange(e) {
																return _this3.setState({ add_name: e.target.value });
															} }),
														_react2.default.createElement('input', { placeholder: 'Mobile', name: 'add_mobile', ref: 'add_mobile', value: this.state.add_mobile, id: 'add_mobile', onChange: function onChange(e) {
																return _this3.setState({ add_mobile: e.target.value });
															} }),
														_react2.default.createElement('input', { placeholder: 'Enter State', ref: 'add_state', id: 'add_state', name: 'add_state' }),
														_react2.default.createElement('input', { placeholder: 'Enter City/Town', ref: 'add_city', id: 'add_city', name: 'add_city' }),
														_react2.default.createElement('input', { placeholder: 'Door No/Landmark', ref: 'add_doorno', id: 'add_doorno', name: 'add_doorno' }),
														_react2.default.createElement('input', { placeholder: 'Pincode', ref: 'add_pincode', id: 'add_pincode', maxLength: 6, name: 'add_pincode' }),
														_react2.default.createElement(
															'div',
															{ className: 'clr' },
															'\xA0'
														),
														_react2.default.createElement(
															'div',
															{ className: 'text-right' },
															_react2.default.createElement(
																'button',
																{ type: 'submit', className: 'web_save_add_btn', value: 'ADD' },
																'ADD'
															)
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-8  col-sm-8 col-lg-8' },
												_react2.default.createElement(
													'section',
													{ className: 'web_chk_dlry_title_blk' },
													_react2.default.createElement(
														'div',
														{ id: 'pay_response' },
														this.state.response
													),
													_react2.default.createElement(
														'h4',
														null,
														_react2.default.createElement(
															'span',
															null,
															'DELIVERY ADDRESS'
														),
														_react2.default.createElement(
															'div',
															{ className: 'pro_sld_ctrls' },
															_react2.default.createElement(
																'a',
																{ className: 'left carousel-control pro_sld_lft', onClick: this.goPrev },
																_react2.default.createElement(
																	'span',
																	{ className: 'pro_sld_arow' },
																	_react2.default.createElement('img', { src: baseAssets + 'images_web/left_arrow.png', alt: '' })
																),
																_react2.default.createElement('span', { className: 'sr-only' })
															),
															_react2.default.createElement(
																'a',
																{ className: 'right carousel-control pro_sld_rgt', onClick: this.goNext },
																_react2.default.createElement(
																	'span',
																	{ className: 'pro_sld_arow' },
																	_react2.default.createElement('img', { src: baseAssets + 'images_web/right_arrow.png', alt: '' })
																),
																_react2.default.createElement('span', { className: 'sr-only' })
															)
														)
													)
												),
												_react2.default.createElement(
													'section',
													{ className: 'web_chk_dlry_data_blk col-sm-12 col-md-12 col-lg-12' },
													this.state.click_here_status ? _react2.default.createElement(
														'div',
														{ className: 'empty_add_blk' },
														_react2.default.createElement(
															'a',
															null,
															'Add your shipping address'
														)
													) : _react2.default.createElement(
														_reactIdSwiper2.default,
														_extends({}, params, { key: delivery_address.length, ref: function ref(node) {
																return node ? _this3.swiper = node.swiper : '';
															} }),
														delivery_address
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										),
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										),
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										),
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'container' },
												_react2.default.createElement(
													'div',
													{ className: this.state.payment_options == 0 ? "col-md-12 col-sm-12 col-lg-12" : "col-md-8 col-sm-8 col-lg-8" },
													this.state.cart_items.length > 0 ? _react2.default.createElement(
														'section',
														{ className: 'webChk_summary_Blk' },
														_react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																'div',
																{ className: 'col-md-4 col-lg-4 col-sm-4' },
																_react2.default.createElement(
																	'h4',
																	{ className: 'add_Item' },
																	'Added Item'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-md-2 col-lg-2 col-sm-2 text-right' },
																_react2.default.createElement(
																	'h4',
																	null,
																	'MRP'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-md-3 col-lg-3 col-sm-3 text-center' },
																_react2.default.createElement(
																	'h4',
																	null,
																	'Quantity'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-md-3 col-lg-3 col-sm-2' },
																_react2.default.createElement(
																	'h4',
																	null,
																	'Price'
																)
															)
														)
													) : '',
													_react2.default.createElement(
														'section',
														{ className: 'webChk_Summary_Dtls_Blk' },
														this.state.cart_count > 0 ? _react2.default.createElement(
															'div',
															{ className: this.state.cart_count > 3 ? 'scroll' : '' },
															Items
														) : '',
														this.state.cart_count > 0 ? _react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																'div',
																{ className: this.state.payment_options == 0 ? "col-md-offset-5 col-md-7 col-lg-7 col-sm-7 col-sm-offset-7" : "col-md-offset-5 col-md-7 col-lg-7 col-sm-7 col-sm-offset-5", style: { paddingLeft: 0 } },
																_react2.default.createElement(
																	'table',
																	{ className: 'table-responsive table webcheckout_table' },
																	_react2.default.createElement(
																		'tr',
																		null,
																		_react2.default.createElement(
																			'td',
																			{ className: 'text-right' },
																			'Total'
																		),
																		_react2.default.createElement(
																			'td',
																			null,
																			'\u20B9 ',
																			this.state.cart_total
																		)
																	),
																	this.state.used_cash ? _react2.default.createElement(
																		'tr',
																		null,
																		_react2.default.createElement(
																			'td',
																			{ className: 'text-right' },
																			'Aquacash Discount'
																		),
																		_react2.default.createElement(
																			'td',
																			null,
																			'(-) \u20B9 ',
																			this.state.used_cash
																		)
																	) : '',
																	this.state.coupons_amt1 ? _react2.default.createElement(
																		'tr',
																		null,
																		this.state.coupons.length === 1 ? _react2.default.createElement(
																			'td',
																			{ className: 'text-right' },
																			'Applied Coupon ',
																			_react2.default.createElement(
																				'span',
																				{ className: 'appliedCoupon_Msg' },
																				': ',
																				this.state.coupons.length === 1 ? this.state.coupons[0]['coupon_code'] : ''
																			)
																		) : _react2.default.createElement(
																			'td',
																			{ className: 'text-right' },
																			'Coupons applied on your purchase ',
																			coupon_info
																		),
																		_react2.default.createElement(
																			'td',
																			{ className: 'web_coupon_amt_tot' },
																			'(-) \u20B9 ',
																			this.state.coupons_amt
																		)
																	) : '',
																	this.state.coupon_amt != 0 ? _react2.default.createElement(
																		'tr',
																		null,
																		this.state.coupon_code != "" ? _react2.default.createElement(
																			'td',
																			{ className: 'text-right' },
																			'Applied Coupon ',
																			_react2.default.createElement(
																				'span',
																				{ className: 'appliedCoupon_Msg' },
																				': ',
																				this.state.coupon_code
																			)
																		) : '',
																		_react2.default.createElement(
																			'td',
																			{ className: 'web_coupon_amt_tot' },
																			'(-) \u20B9 ',
																			this.state.coupon_amt
																		)
																	) : '',
																	_react2.default.createElement(
																		'tr',
																		{ style: { borderTop: '1px solid #eee' } },
																		_react2.default.createElement(
																			'td',
																			{ className: 'text-right' },
																			'Grand Total'
																		),
																		_react2.default.createElement(
																			'td',
																			null,
																			'\u20B9 ',
																			this.state.grand_total
																		)
																	),
																	_react2.default.createElement(
																		'tr',
																		null,
																		_react2.default.createElement(
																			'td',
																			{ colSpan: 2, style: { 'fontSize': '12px' } },
																			parseHtml(this.state.deliver_date_text)
																		)
																	)
																)
															)
														) : ''
													)
												),
												this.state.payment_options == 1 ? _react2.default.createElement(
													'div',
													{ className: 'col-md-4 col-lg-4 col-sm-4' },
													_react2.default.createElement(
														'section',
														{ className: 'web_chk_pay_opts_blk' },
														_react2.default.createElement(
															'h4',
															null,
															'PAYMENT OPTIONS'
														)
													),
													this.state.mode_loading ? _react2.default.createElement(
														'div',
														{ className: 'webcheck_mode_loading' },
														_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
													) : tabs_data
												) : ''
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										),
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										),
										_react2.default.createElement(
											'div',
											{ className: 'container' },
											_react2.default.createElement(
												'div',
												{ className: 'col-md-12 col-lg-12 col-sm-12 check_btm_btns' },
												_react2.default.createElement(
													'div',
													{ className: 'col-md-4 col-lg-4 col-sm-4' },
													_react2.default.createElement(
														_reactRouter.Link,
														{ to: '/web/customer_care', className: 'enquire btn btn-default' },
														'ENQUIRE NOW'
													)
												),
												_react2.default.createElement('div', { className: 'col-md-4 col-lg-4 col-sm-4' }),
												_react2.default.createElement(
													'div',
													{ className: 'col-md-4 col-sm-4 col-lg-4' },
													this.state.amount_loading ? _react2.default.createElement(
														_reactRouter.Link,
														{ className: 'disabled btn btn-default pull-right pay' },
														'Loading'
													) : _react2.default.createElement(
														_reactRouter.Link,
														{ className: 'btn btn-default pull-right pay', onClick: function onClick() {
																_this3.payNow();
															} },
														'PAY NOW'
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											),
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											),
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											)
										),
										_react2.default.createElement(
											_reactBootstrap.Modal,
											{ onEntered: function onEntered() {
													_this3.getAddressDetails();
												}, className: '', show: this.state.edit_address, onHide: this.close },
											_react2.default.createElement(
												_reactBootstrap.Modal.Header,
												{ closeButton: true },
												_react2.default.createElement(
													_reactBootstrap.Modal.Title,
													{ className: 'm_title' },
													'Edit Shipping Address'
												)
											),
											_react2.default.createElement(
												_reactBootstrap.Modal.Body,
												null,
												_react2.default.createElement(
													'div',
													null,
													_react2.default.createElement(
														'form',
														{ className: 'web_edit_address_form', onSubmit: this.handleSubmit_edit },
														_react2.default.createElement(
															'div',
															{ className: 'web_edit_form_blk' },
															_react2.default.createElement('input', { type: 'text', id: 'edit_name', placeholder: 'Name', value: this.state.edit_name, onChange: this.edit_nameChange, ref: 'edit_name', required: true }),
															_react2.default.createElement('p', { id: 'edit_name_err' }),
															_react2.default.createElement('input', { type: 'text', placeholder: 'Mobile', maxLength: 10, value: this.state.edit_mobile, onChange: this.edit_mobileChange, ref: 'edit_mobile', id: 'edit_mobile', required: true }),
															_react2.default.createElement('p', { id: 'edit_mobile_err' }),
															_react2.default.createElement('input', { type: 'text', placeholder: 'Enter State', value: this.state.edit_state, onChange: this.edit_stateChange, ref: 'edit_state', id: 'edit_state', required: true }),
															_react2.default.createElement('p', { id: 'edit_state_err' }),
															_react2.default.createElement('input', { type: 'text', placeholder: 'Enter City/Town', value: this.state.edit_city, onChange: this.edit_cityChange, ref: 'edit_city', id: 'edit_city', required: true }),
															_react2.default.createElement('p', { id: 'edit_city_err' }),
															_react2.default.createElement('input', { type: 'text', placeholder: 'Door No/Landmark', value: this.state.edit_doorno, onChange: this.edit_doornoChange, ref: 'edit_doorno', id: 'edit_doorno', required: true }),
															_react2.default.createElement('p', { id: 'edit_doorno_err' }),
															_react2.default.createElement('input', { type: 'text', placeholder: 'Pincode', maxLength: 6, value: this.state.edit_pincode, onChange: this.edit_pincodeChange, ref: 'edit_pincode', id: 'edit_pincode', required: true }),
															_react2.default.createElement('p', { id: 'edit_pincode_err' }),
															_react2.default.createElement(
																'div',
																{ className: 'm_submit_blk' },
																_react2.default.createElement(
																	'button',
																	{ type: 'submit', className: 'web_adrs_update_btn', value: 'UPDATE' },
																	'UPDATE'
																)
															)
														)
													)
												)
											)
										),
										_react2.default.createElement(
											_reactBootstrap.Modal,
											{ className: 'webEdit_Qty_Modal', show: this.state.updateModal, onHide: this.close },
											_react2.default.createElement(
												_reactBootstrap.Modal.Body,
												null,
												_react2.default.createElement(
													'h4',
													null,
													_react2.default.createElement('input', { ref: 'web_edit_qty', type: 'text', value: this.state.qty, placeholder: 'Enter Quantity', onChange: function onChange() {
															_this3.updateMinQtyModal();
														} })
												),
												this.state.err_qty_status ? _react2.default.createElement(
													'p',
													{ className: 'webErr_Qty' },
													this.state.err_qty_msg
												) : ''
											),
											_react2.default.createElement(
												_reactBootstrap.Modal.Footer,
												{ className: 'web_EditQty_Footer' },
												_react2.default.createElement(
													_reactBootstrap.Button,
													{ className: 'web_Edit_Qty_cls_Btn', onClick: this.close },
													'CANCEL'
												),
												_react2.default.createElement(
													'a',
													null,
													_react2.default.createElement(
														_reactBootstrap.Button,
														{ className: 'web_edit_qty_Update_Btn', onClick: function onClick() {
																_this3.updateQuantity();
															} },
														'UPDATE'
													)
												)
											)
										)
									),
									' '
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal,
								{ className: 'invalid_order', show: this.state.order_error_modal, onHide: this.close },
								_react2.default.createElement(
									_reactBootstrap.Modal.Body,
									null,
									this.state.order_error_message,
									_react2.default.createElement(
										'a',
										{ onClick: this.close, className: 'req_conf_ok_btn' },
										'OK'
									)
								)
							),
							_react2.default.createElement(_WebFooter2.default, null)
						) : _react2.default.createElement(
							'div',
							{ className: '' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-6 col-md-offset-3 web_dels_cntnt' },
								_react2.default.createElement(
									'div',
									{ className: 'web_cart_emtpy', style: { marginTop: '30px' } },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/empty_cartbg.png', alt: '...' })
									),
									_react2.default.createElement(
										'h4',
										null,
										'Your Cart is Empty'
									),
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: "/web/home", className: 'cart_shopbtn' },
										'SHOP NOW'
									)
								)
							),
							_react2.default.createElement(_WebFooter2.default, null)
						)
					) : _react2.default.createElement(
						'div',
						{ className: 'checkout_loading' },
						this.state.lod ? _react2.default.createElement(
							'div',
							{ className: 'checkout_error_blk' },
							_react2.default.createElement(
								'h4',
								null,
								'Something went wrong'
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/web/home', className: 'try_again_btn' },
								'Please try again!'
							)
						) : _react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
					)
				);
			}
		}]);
	
		return Web_Checkout;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			save_order_status: state.posts.mycart_order_status,
			total_cart_data: state.posts.total_cart_data,
			rzp_keys: state.posts.rzp_keys
		};
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Web_Checkout);

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactWebVectorIcons = __webpack_require__(29);
	
	var _reactWebVectorIcons2 = _interopRequireDefault(_reactWebVectorIcons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var parseHtml = __webpack_require__(39);
	
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Web_MyCart = function (_Component) {
		_inherits(Web_MyCart, _Component);
	
		function Web_MyCart(props) {
			_classCallCheck(this, Web_MyCart);
	
			var _this = _possibleConstructorReturn(this, (Web_MyCart.__proto__ || Object.getPrototypeOf(Web_MyCart)).call(this, props));
	
			_this.state = {};
			_this.state = {
				total: '',
				cartcount: '',
				grandtotal: '',
				items: [],
				aqua_cash: '',
				used_cash: '',
				used_cash1: '',
				ac_discount: '',
				coupons_amt: '',
				coupons_amt1: '',
				grand_total: '',
				openModal: false,
				applied_coupons: '',
				applied_coupons1: '',
				coupon_ref: '',
				coupon_err_msg: '',
				coupon_err_status: false,
				updateModal: false,
				coupon_success_status: false,
				coupon_success_msg: '',
				coupon_success_value: '',
				delete_status: false,
				delete_status_id: '',
	
				qty: '',
				min_qty: '',
				max_qty: '',
				cart_id: '',
				err_qty_status: false,
				err_qty_msg: '',
				emptyCartConfirm: false,
				coupons: [],
				billing_status: false,
	
				proceedCheck: 0,
				proceedMsg: '',
				ac_enough_msg: '',
				loc_msg: '',
				add_id: 0,
	
				coupon_code: 0,
				coupon_price: 0,
	
				state: '',
				zip: '',
				city: '',
				address: '',
				save_local_address_msg_status: false,
				ac_enough_msg_status: false,
				proceedMsg_status: false,
	
				promodiscount: '',
				promos: [],
				applied_promos: '',
	
				checkout_page_loading: false,
				pay_clicked: false,
	
				page_loading: false
			};
			_this.close = _this.close.bind(_this);
			_this.submitCoupon = _this.submitCoupon.bind(_this);
			_this.changeCoupon = _this.changeCoupon.bind(_this);
			_this.getCart = _this.getCart.bind(_this);
			_this.updateMinQty = _this.updateMinQty.bind(_this);
			_this.updateMinQtyModal = _this.updateMinQtyModal.bind(_this);
			_this.deleteSingleItem = _this.deleteSingleItem.bind(_this);
			_this.emptyCart = _this.emptyCart.bind(_this);
			_this.emptyCartConfirm = _this.emptyCartConfirm.bind(_this);
			_this.delete = _this.delete.bind(_this);
	
			_this.updateQuantity = _this.updateQuantity.bind(_this);
			_this.enableBillingDetails = _this.enableBillingDetails.bind(_this);
			_this.placeOrder = _this.placeOrder.bind(_this);
			_this.applyCoupon_getCart = _this.applyCoupon_getCart.bind(_this);
			_this.removeCoupon = _this.removeCoupon.bind(_this);
			_this.saveDefaultAddress = _this.saveDefaultAddress.bind(_this);
			_this.saveAddress_placeOrder = _this.saveAddress_placeOrder.bind(_this);
			_this.getCartCount = _this.getCartCount.bind(_this);
			return _this;
		}
	
		//saveDefaultAddress function is used to save the new address in checkout page
	
	
		_createClass(Web_MyCart, [{
			key: 'saveDefaultAddress',
			value: function saveDefaultAddress() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token'), name: localStorage.user_name, mobile: localStorage.user_mobile, state: this.state.state, city: this.state.city, address: this.state.address, zip: this.state.zip };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'saveAdd',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							add_id: data.add_id
						});
						localStorage.setItem('address_change_flag', data.address_change);
						this.saveAddress_placeOrder();
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getCartCount',
			value: function getCartCount() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							cartcount: data.cart_count
						});
						// if(data.cart_count===0)
						//          {
						//            	$('#cart_count').hide();
						//          }
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'emptyCartConfirm',
			value: function emptyCartConfirm() {
				this.setState({
					emptyCartConfirm: true
				});
			}
			//function updateQuantitiy is used to update the qunatity of the product in modal box and updating the cart values by calling the "applyCoupon_getCart" 
	
		}, {
			key: 'updateQuantity',
			value: function updateQuantity() {
				var x = '';
				if (parseInt(this.state.qty, 10) < parseInt(this.state.min_qty, 10)) {
					// alert('Minimum Quantity is '+this.state.min_qty);
					x = 'Minimum Quantity is ' + this.state.min_qty;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Minimum Quantity is ' + this.state.min_qty
					});
				}
				if (this.state.qty === '') {
					// alert('Minimum Quantity is '+this.state.min_qty);
					x = 'Minimum Quantity is ' + this.state.min_qty;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Minimum Quantity is ' + this.state.min_qty
					});
				}
				if (parseInt(this.state.qty, 10) > parseInt(this.state.max_qty, 10)) {
					// alert('Maximum Quantity is '+this.state.max_qty);
					x = 'Maximum Quantity is ' + this.state.max_qty;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Maximum Quantity is ' + this.state.max_qty
					});
				}
				var check = /[^0-9]/gi;
				if (check.test(this.refs.web_edit_qty.value)) {
					x = '* Invalid Quantity';
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Invalid Quantity'
					});
				}
				if (x === '') {
					this.setState({
						err_qty_status: false,
						err_qty_msg: ''
					});
					var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), cart_id: this.state.cart_id, quantity: this.state.qty };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'update_cart_qty',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.close();
								// this.getCart();
								this.applyCoupon_getCart();
							}
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
			//function close is used to close all of the modal boxes
	
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					openModal: false,
					updateModal: false,
					emptyCartConfirm: false,
					save_local_address_msg_status: false,
					ac_enough_msg_status: false,
					proceedMsg_status: false
				});
			}
			// function emptyCart is used to empty the cart items and updating the cart and close functions
	
		}, {
			key: 'emptyCart',
			value: function emptyCart() {
				var data1 = { from: 'desktop_web', uid: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'Cart_delete',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success") {
							this.getCart();
							this.close();
							this.getCartCount();
						} else {
							this.close();
							this.getCartCount();
						}
						location.reload();
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			//function delete(id) gets the id from the deleteSingleItem(id) and removes the item from the cart.
	
		}, {
			key: 'delete',
			value: function _delete(id) {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
	
				var data1 = { from: 'desktop_web', id: id, uid: uid, token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'singleCart_delete',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success" && data.message === "Item deleted successfully.") {
							this.getCart();
							this.getCartCount();
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			// function deleteSingleItem(id) changes the status of the item block per 5 seconds to delete, can undo the deletions withing 5 sec or it calls the delete(id) function.
	
		}, {
			key: 'deleteSingleItem',
			value: function deleteSingleItem(id) {
				var _this2 = this;
	
				this.setState({
					delete_status: true,
					delete_status_id: id
				});
	
				//setTimeout(() => {this.setState({delete_status:false});}, 9000);
				setTimeout(function () {
					_this2.state.delete_status === true ? _this2.delete(id) : '';
				}, 2000);
			}
	
			//applyCoupon_getCart(value,code) function is used to call the cart function with updated state values of coupon price and coupon value. 
	
		}, {
			key: 'applyCoupon_getCart',
			value: function applyCoupon_getCart(value, code) {
				this.setState({ page_loading: true });
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token'), apply_ac: 1, apply_coupon: this.state.coupon_price, apply_coupon_code: this.state.coupon_code, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
	
				localStorage.setItem('apply_coupon', this.state.coupon_price);
				localStorage.setItem('apply_coupon_code', this.state.coupon_code);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'cart',
					data: { req: data2 },
					success: function (data) {
						console.log(data);
						localStorage.setItem('apply_coupon', this.state.coupon_price);
						localStorage.setItem('apply_coupon_code', this.state.coupon_code);
						this.setState({
							total: data.total,
							cartcount: data.cart_count,
							grandtotal: data.grand_total,
							items: data.items,
							ac_discount: data.ac_discount,
							aqua_cash: data.aqua_cash,
							used_cash: data.used_cash,
							used_cash1: data.used_cash1,
							coupons_amt: data.coupons_amt,
							coupons_amt1: data.coupons_amt1,
							grand_total: data.grand_total,
							applied_coupons: data.applied_coupons,
							applied_coupons1: data.applied_coupons1,
							coupons: data.coupons,
	
							proceedCheck: data.proceedCheck,
							proceedMsg: data.proceedMsg,
							ac_enough_msg: data.ac_enough_msg,
							loc_msg: data.loc_msg,
							add_id: data.add_id,
	
							state: data.state,
							zip: data.zip,
							city: data.city,
							address: data.address,
	
							promodiscount: data.promodiscount,
							promos: data.promos,
							applied_promos: data.applied_promos,
	
							page_loading: false,
							shipping_note: data.shipping_note
						});
						localStorage.setItem('address_change_flag', data.address_change);
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			//function getCart is used to get the cart values when page loads with empty params of coupons codes and values.
	
		}, {
			key: 'getCart',
			value: function getCart() {
				this.setState({ page_loading: true });
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token'), apply_ac: 1, apply_coupon: 0, apply_coupon_code: '', source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
	
				localStorage.setItem('apply_coupon', this.state.coupon_price);
				localStorage.setItem('apply_coupon_code', this.state.coupon_code);
	
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'cart',
					data: { req: data2 },
					success: function (data) {
						console.log(data);
						this.setState({
							total: data.total,
							cartcount: data.cart_count,
							grandtotal: data.grand_total,
							items: data.items,
							ac_discount: data.ac_discount,
							aqua_cash: data.aqua_cash,
							used_cash: data.used_cash,
							used_cash1: data.used_cash1,
							coupons_amt: data.coupons_amt,
							coupons_amt1: data.coupons_amt1,
							grand_total: data.grand_total,
							applied_coupons: data.applied_coupons,
							applied_coupons1: data.applied_coupons1,
							coupons: data.coupons,
	
							proceedCheck: data.proceedCheck,
							proceedMsg: data.proceedMsg,
							ac_enough_msg: data.ac_enough_msg,
							loc_msg: data.loc_msg,
							add_id: data.add_id,
	
							promodiscount: data.promodiscount,
							promos: data.promos,
							applied_promos: data.applied_promos,
							page_loading: false,
							shipping_note: data.shipping_note
						});
	
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
						localStorage.setItem('address_change_flag', data.address_change);
					}.bind(this),
					error: function error(err) {}
				});
			}
	
			//componentDidMount function is loaded first when page loaded by checking the session and calls the getCart function.
	
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
	
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
				localStorage.removeItem('checkout');
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
				localStorage.removeItem('web_quickcart');
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
				localStorage.removeItem('web_brand_details');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
				if (!localStorage.token && !localStorage.user_id) {
					localStorage.setItem('web_mycart', '/web/mycart');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					this.getCart();
				}
				// localStorage.removeItem('address_change_flag');
				if (screen.width < 800) {
					window.location.href = '/mycart';
				}
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var that = this;
				setTimeout(function () {
					that.enableBillingDetails();
				}, 3000);
			}
		}, {
			key: 'enableBillingDetails',
			value: function enableBillingDetails() {
				// this.getCart();
				this.setState({
					billing_status: true
				});
			}
		}, {
			key: 'changeCoupon',
			value: function changeCoupon() {
				this.setState({
					coupon_ref: this.refs.apply_coupon.value,
					coupon_err_status: false
				});
			}
		}, {
			key: 'submitCoupon',
			value: function submitCoupon() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token'), coupon: this.refs.apply_coupon.value, public_amt: this.state.coupons_amt1, apply_ac: 1, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'applyCoupon',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "error") {
							this.setState({
								coupon_err_status: true,
								coupon_err_msg: data.message
							});
						}
						if (data.status === "success") {
							this.setState({
								coupon_code: data.code,
								coupon_price: data.value,
								coupon_success_msg: data.message,
								coupon_success_status: true,
								coupon_success_value: data.value
							});
							this.applyCoupon_getCart(data.value, data.code);
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'updateMinQty',
			value: function updateMinQty(qty, min_qty, max_qty, cart_id) {
				this.setState({
					updateModal: true,
					qty: qty,
					min_qty: min_qty,
					max_qty: max_qty,
					cart_id: cart_id
				});
			}
		}, {
			key: 'updateMinQtyModal',
			value: function updateMinQtyModal() {
				// alert(this.refs.min_qty.value);
				this.setState({
					qty: this.refs.web_edit_qty.value,
					err_qty_status: false
				});
			}
			//saveAddress_placeOrder() function is called when the coupon is applied and shown location_msg and saving the address,if the address is saved then redirect to checkout page.
	
		}, {
			key: 'saveAddress_placeOrder',
			value: function saveAddress_placeOrder() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
	
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = _defineProperty({ from: 'desktop_web', uid: uid, token: localStorage.token, mode: 2, add_id: this.state.add_id, code: this.state.coupon_code, coupon_amount: this.state.coupon_price, other_amount: '', aqua_cash: this.state.aqua_cash, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, source: source, campaign: campaign, url_id: url_id }, 'aqua_cash', this.state.aqua_cash);
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cartCalculations',
					success: function (data) {
						this.applyCoupon_getCart();
						if (data.status === "success") {
							_reactRouter.browserHistory.push('/checkout');
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'placeOrder',
			value: function placeOrder() {
				this.setState({
					pay_clicked: true
				});
				if (this.state.proceedCheck === 0 && this.state.proceedMsg !== "") {
					this.setState({
						proceedMsg_status: true,
						pay_clicked: false
					});
				} else if (this.state.proceedCheck === 0 && this.state.ac_enough_msg !== "") {
					this.setState({
						ac_enough_msg_status: true,
						pay_clicked: false
					});
				} else if (this.state.proceedCheck === 0 && this.state.loc_msg !== "") {
					this.setState({
						save_local_address_msg_status: true,
						pay_clicked: false
					});
				} else {
					this.setState({
						checkout_page_loading: true
					});
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
	
					if (localStorage.user_id) {
						var uid = localStorage.user_id;
					} else {
						uid = 0;
					}
					var data1 = _defineProperty({ from: 'desktop_web', uid: uid, token: localStorage.token, mode: 2, add_id: this.state.add_id, code: this.state.coupon_code, coupon_amount: this.state.coupon_price, other_amount: '', aqua_cash: this.state.used_cash1, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, source: source, campaign: campaign, url_id: url_id }, 'aqua_cash', this.state.aqua_cash);
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'cartCalculations',
						success: function (data) {
							this.applyCoupon_getCart();
							if (data.status === "success") {
								_reactRouter.browserHistory.push('/web/checkout');
							}
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'removeCoupon',
			value: function removeCoupon() {
				this.setState({
					coupon_success_status: false,
					coupon_code: 0,
					coupon_price: 0
				});
				localStorage.setItem('apply_coupon', 0);
				localStorage.setItem('apply_coupon_code', 0);
				this.getCart();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				document.title = "My Cart | AquaDeals";
				var cart_items = this.state.items.map(function (item, index) {
					var _this3 = this;
	
					return _react2.default.createElement(
						'div',
						null,
						this.state.delete_status && this.state.delete_status_id === item.id ? _react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12', style: { padding: '10px', color: '#666' } },
								_react2.default.createElement(
									'span',
									null,
									'Deleted'
								),
								_react2.default.createElement(
									'span',
									{ style: { float: 'right', cursor: 'pointer' }, onClick: function onClick() {
											_this3.setState({ delete_status: false });
										} },
									'UNDO'
								)
							)
						) : _react2.default.createElement(
							'div',
							{ className: 'row cart_ItemsList' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'container' },
									_react2.default.createElement(
										'div',
										{ className: 'col-sm-2 col-md-2 col-lg-2 webcart_centerimg' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: item.type === 0 ? '/web/sdetails/' + item.url_name + '/' + item.deal_id : '/web/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
											item.type === 0 ? _react2.default.createElement('img', { src: baseAssets + 'icons/' + item.img, alt: ' ' }) : _react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/thumbnails/' + item.img, alt: ' ' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'cartdesc_Blk' },
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-2 col-md-2 col-sm-2 col-xs-2 cart_title_blk' },
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: item.type === 0 ? '/web/sdetails/' + item.url_name + '/' + item.deal_id : '/web/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
												item.pro_name !== "" ? _react2.default.createElement(
													'h3',
													{ className: 'cartitem_Title' },
													item.pro_name
												) : _react2.default.createElement(
													'h3',
													{ className: 'cartitem_Title' },
													'\xA0'
												),
												item.brand ? _react2.default.createElement(
													'h4',
													{ className: 'cartitem_Brand' },
													item.brand
												) : _react2.default.createElement(
													'h4',
													null,
													'\xA0'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-2 col-md-2 col-sm-2' },
											item.mrp ? _react2.default.createElement(
												'h4',
												{ className: 'cartitem_Mrp' },
												'\u20B9 ',
												item.mrp
											) : _react2.default.createElement(
												'h4',
												null,
												'\xA0'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-3 col-sm-3 col-md-3  col-lg-3 text-center' },
											item.min_qty !== "" ? _react2.default.createElement(
												'p',
												{ onClick: function onClick() {
														_this3.updateMinQty(item.qty, item.min_qty, item.max_qty, item.id);
													}, className: 'webQty_Edit' },
												_react2.default.createElement(
													'span',
													null,
													item.qty
												)
											) : _react2.default.createElement(
												'p',
												null,
												'\xA0'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-2 col-sm-2 col-md-2 col-lg-2 text-center', style: { paddingLeft: '0px', paddingRight: '0px' } },
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: item.type === 0 ? '/web/sdetails/' + item.url_name + '/' + item.deal_id : '/web/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
												item.amount !== "" ? _react2.default.createElement(
													'p',
													{ className: 'cartitem_amount' },
													_react2.default.createElement(
														'span',
														null,
														'\u20B9 '
													),
													_react2.default.createElement(
														'span',
														null,
														item.amount
													)
												) : _react2.default.createElement(
													'p',
													null,
													'\xA0'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-1 col-md-1 col-sm-1 col-xs-1' },
											_react2.default.createElement(
												'button',
												{ onClick: function onClick() {
														item.type === 1 ? _this3.deleteSingleItem(item.id) : _this3.deleteSingleItem(item.id);
													}, ariaLabel: 'Close', className: 'close cartitem_removebtn', type: 'button' },
												_react2.default.createElement(
													'p',
													{ ariaHidden: 'true' },
													'\xD7'
												)
											)
										)
									)
								)
							)
						)
					);
				}.bind(this));
				var cart_coupons = '';
				cart_coupons = _react2.default.createElement(
					'div',
					{ className: 'row', style: { paddingTop: '20px', paddingBottom: '20px' } },
					_react2.default.createElement('div', { className: 'col-xs-1 col-sm-1 col-md-1 col-lg-1' }),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-4 col-xs-4 col-md-4 col-lg-4 cart_coupon_blk' },
						_react2.default.createElement(
							'i',
							{ className: 'cart_left_img' },
							_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_left.png', alt: ' ' })
						),
						_react2.default.createElement('input', { type: 'text', ref: 'apply_coupon', maxLength: 15, placeholder: 'Enter coupon code', onChange: function onChange() {
								_this4.changeCoupon();
							} })
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-2 col-xs-2 col-lg-2' },
						_react2.default.createElement(
							'div',
							{ className: 'cart_submit' },
							_react2.default.createElement(
								'button',
								{ className: 'cart_submitbtn', onClick: function onClick() {
										_this4.submitCoupon();
									} },
								'Apply'
							)
						)
					),
					_react2.default.createElement('div', { className: 'col-sm-12 col-xs-12 col-lg-12' }),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-4 col-sm-offset-1 col-xs-4 col-xs-offset-1 err_coupon' },
						_react2.default.createElement(
							'span',
							null,
							this.state.coupon_err_status ? this.state.coupon_err_msg : ''
						)
					)
				);
	
				var coupon_map = this.state.coupons.map(function (coupon, index) {
					return _react2.default.createElement(
						'span',
						{ key: index, style: { display: 'block' } },
						coupon.coupon_code,
						' (\u20B9',
						coupon.value,
						' )'
					);
				});
				var couponsList = _react2.default.createElement(
					_reactBootstrap.Popover,
					{ id: 'popover-positioned-top1' },
					coupon_map
				);
				var coupon_info = _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{ trigger: 'focus', placement: 'top', overlay: couponsList },
					_react2.default.createElement(
						_reactBootstrap.Button,
						{ className: 'cartCoupon_info_img' },
						_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_info.png', alt: ' ' })
					)
				);
	
				var promos_map = this.state.promos.map(function (promo, index) {
					return _react2.default.createElement(
						'span',
						{ key: index, style: { display: 'block' } },
						promo.promo_code,
						' ( \u20B9 ',
						promo.promo_value,
						' )'
					);
				});
				var promosList = _react2.default.createElement(
					_reactBootstrap.Popover,
					{ id: 'popover-positioned-top2' },
					promos_map
				);
	
				var promo_info = '';
				promo_info = _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{ trigger: 'focus', placement: 'top', overlay: promosList },
					_react2.default.createElement(
						_reactBootstrap.Button,
						{ className: 'cartCoupon_info_img' },
						_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_info.png', alt: ' ' })
					)
				);
				var coupon_success = '';
	
				if (this.state.coupon_success_status) {
					coupon_success = _react2.default.createElement(
						'div',
						{ className: 'cartCoupon_Success cart_cpn_success' },
						_react2.default.createElement(
							'button',
							{ onClick: function onClick() {
									_this4.removeCoupon();
								}, ariaLabel: 'Close', className: 'coupon_close', type: 'button' },
							_react2.default.createElement(
								'i',
								null,
								_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cancel_coupon.png', alt: '', width: '20px' })
							)
						),
						_react2.default.createElement(
							'h5',
							null,
							'Coupon discount:(-) \u20B9 ',
							this.state.coupon_success_value
						),
						_react2.default.createElement(
							'p',
							null,
							this.state.coupon_success_msg
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'web_Deals Web_CartPage ' },
					_react2.default.createElement(_WebHeaderInner2.default, { cart_updated_count: this.state.cartcount }),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							_reactBootstrap.Breadcrumb,
							{ className: 'webcart_breadcrumb' },
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb.Item,
								{ href: '/web/home' },
								'Home'
							),
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb.Item,
								{ active: true },
								'My Cart'
							)
						)
					),
					this.state.page_loading ? _react2.default.createElement(
						'div',
						{ className: 'col-lg-12 col-md-12 col-sm-12 Dels_cntnt' },
						_react2.default.createElement(
							'div',
							{ className: 'web_cart_loading' },
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/loading_more.gif', alt: 'Loading' })
						)
					) : _react2.default.createElement(
						'div',
						null,
						this.state.cartcount !== 0 ? _react2.default.createElement(
							'section',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-12 col-md-12 col-sm-12 Dels_cntnt' },
									_react2.default.createElement(
										'section',
										{ className: 'container-fluid' },
										this.state.checkout_page_loading ? '' : _react2.default.createElement(
											'section',
											{ id: 'cart-process' },
											_react2.default.createElement(
												'div',
												{ className: 'progressbar-wrapper', style: { background: 'unset!important' } },
												_react2.default.createElement(
													'ul',
													{ className: 'progressbar' },
													_react2.default.createElement(
														'li',
														{ className: 'active' },
														_react2.default.createElement(
															'div',
															null,
															'Cart'
														),
														_react2.default.createElement(
															'div',
															null,
															_react2.default.createElement(_reactWebVectorIcons2.default, {
																name: 'check',
																font: 'Entypo',
																color: '#fff',
																size: 14
																// style={{}}
															})
														)
													),
													_react2.default.createElement(
														'li',
														null,
														'Checkout'
													),
													_react2.default.createElement(
														'li',
														null,
														'Payment'
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'row Mycart_Block', style: { marginTop: '15px' } },
											_react2.default.createElement(
												'div',
												{ className: 'container-fluid' },
												_react2.default.createElement(
													'a',
													{ className: 'pull-right delete_item', onClick: function onClick() {
															_this4.emptyCartConfirm();
														} },
													_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/del_bin3.png', width: '16px', alt: 'Home' }),
													'Delete all'
												)
											),
											_react2.default.createElement('hr', null)
										),
										_react2.default.createElement(
											'div',
											{ className: 'row cart_head_blk' },
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-5 col-md-5 col-sm-5 col-xs-5', style: { paddingRight: '0' } },
												_react2.default.createElement(
													'span',
													{ className: 'add_head' },
													'Added Item'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-2 col-md-2 col-sm-2' },
												_react2.default.createElement(
													'span',
													{ className: 'add_mrp' },
													'MRP'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-4 col-md-4 col-sm-4 col-xs-4', style: { paddingLeft: '0' } },
												_react2.default.createElement(
													'div',
													{ className: 'col-lg-6 col-md-6 col-sm-6' },
													_react2.default.createElement(
														'span',
														{ className: 'qun_head' },
														'Quantity'
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'col-lg-6 col-md-6 col-sm-6 text-center' },
													_react2.default.createElement(
														'span',
														{ className: 'price_head' },
														'Price'
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'cart_itemsblk' },
											cart_items
										)
									),
									_react2.default.createElement(
										'section',
										{ className: 'container-fluid', style: { marginTop: '20px' } },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-lg-6 col-sm-6' },
												this.state.coupon_success_status ? coupon_success : cart_coupons,
												_react2.default.createElement(
													'div',
													{ className: 'col-md-6 col-lg-6' },
													'\xA0'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-lg-6 col-sm-6', style: { paddingLeft: '0' } },
												this.state.billing_status ? _react2.default.createElement(
													'table',
													{ className: 'table cartTable' },
													_react2.default.createElement(
														'tr',
														{ className: 'cartTr_Total' },
														_react2.default.createElement(
															'td',
															null,
															'Total Price'
														),
														_react2.default.createElement(
															'td',
															null,
															'\u20B9 ',
															this.state.total
														)
													),
													this.state.used_cash ? _react2.default.createElement(
														'tr',
														{ className: 'cartTr' },
														_react2.default.createElement(
															'td',
															null,
															'Aquacash Discount'
														),
														_react2.default.createElement(
															'td',
															null,
															'(-) \u20B9 ',
															this.state.used_cash
														)
													) : '',
													this.state.coupons_amt1 ? _react2.default.createElement(
														'tr',
														{ className: 'cartTr cartTrEnd' },
														this.state.coupons.length === 1 ? _react2.default.createElement(
															'td',
															null,
															'Applied Coupon ',
															_react2.default.createElement(
																'span',
																{ className: 'appliedCoupon_Msg' },
																': ',
																this.state.coupons.length === 1 ? this.state.coupons[0]['coupon_code'] : ''
															)
														) : _react2.default.createElement(
															'td',
															null,
															'Coupons applied on your purchase ',
															coupon_info
														),
														_react2.default.createElement(
															'td',
															null,
															'(-) \u20B9 ',
															this.state.coupons_amt
														)
													) : '',
													parseInt(this.state.promodiscount, 10) > 0 ? _react2.default.createElement(
														'tr',
														null,
														_react2.default.createElement(
															'td',
															null,
															'Promos Discount ',
															this.state.promos.length === 1 ? _react2.default.createElement(
																'span',
																{ className: 'appliedCoupon_Msg' },
																': ',
																this.state.promos[0].promo_code
															) : promo_info,
															' '
														),
														_react2.default.createElement(
															'td',
															null,
															'(-) \u20B9 ',
															this.state.promodiscount
														)
													) : '',
													_react2.default.createElement(
														'tr',
														{ className: 'cartTr_Grandtotal' },
														_react2.default.createElement(
															'td',
															null,
															'Grand Total'
														),
														_react2.default.createElement(
															'td',
															null,
															'\u20B9 ',
															this.state.grand_total
														)
													),
													_react2.default.createElement(
														'tr',
														null,
														_react2.default.createElement(
															'td',
															{ colSpan: 2 },
															parseHtml(this.state.shipping_note)
														)
													)
												) : _react2.default.createElement(
													'div',
													{ className: 'webPrice_Loading' },
													_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
												)
											)
										)
									),
									_react2.default.createElement(
										'section',
										{ className: 'container-fluid' },
										_react2.default.createElement(
											'div',
											{ className: 'webBotm_Btns row', style: { marginTop: '4%' } },
											_react2.default.createElement(
												'ul',
												null,
												_react2.default.createElement(
													'li',
													{ className: 'col-lg-4 col-md-4 col-xs-4 col-sm-5', style: { cursor: 'pointer' } },
													_react2.default.createElement(
														_reactRouter.Link,
														{ to: '/web/home', title: '' },
														'CONTINUE SHOPPING'
													)
												),
												_react2.default.createElement(
													'li',
													{ className: 'col-lg-4 col-md-4 col-xs-4 col-sm-2' },
													'\xA0'
												),
												_react2.default.createElement(
													'li',
													{ className: 'col-lg-4 col-md-4 col-xs-4 col-sm-5 text-right', style: { cursor: 'pointer' } },
													this.state.pay_clicked ? _react2.default.createElement(
														_reactRouter.Link,
														{ className: 'disabled' },
														'Processing...'
													) : _react2.default.createElement(
														'a',
														{ onClick: function onClick() {
																_this4.placeOrder();
															} },
														'PROCEED TO CHECKOUT'
													)
												)
											)
										)
									)
								)
							)
						) : _react2.default.createElement(
							'section',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-12 col-md-12 EmptyDels_cntnt' },
									_react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'div',
											{ className: 'webCart_Empty' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/empty_cartbg.png', alt: '...' })
											),
											_react2.default.createElement(
												'h3',
												null,
												'Your Cart is Empty'
											),
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "/web/home", className: 'cart_ShopBtn' },
												'SHOP NOW'
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: '', show: this.state.openModal, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'AquaDeals'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#666' } },
								'You need to install Android mobile app to place this order.'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'Modal_Footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: '#fff none repeat scroll 0 0', color: '#ff742a' }, onClick: this.close },
								'Close'
							),
							_react2.default.createElement(
								'a',
								{ href: 'https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en', target: '_blank', title: '' },
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: '#ff742a none repeat scroll 0 0', color: '#fff' } },
									'OK'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'webEdit_Qty_Modal', show: this.state.updateModal, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								null,
								_react2.default.createElement('input', { ref: 'web_edit_qty', type: 'text', value: this.state.qty, placeholder: 'Enter Quantity', onChange: function onChange() {
										_this4.updateMinQtyModal();
									} })
							),
							this.state.err_qty_status ? _react2.default.createElement(
								'p',
								{ className: 'webErr_Qty' },
								this.state.err_qty_msg
							) : ''
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'web_EditQty_Footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ className: 'web_Edit_Qty_cls_Btn', onClick: this.close },
								'CANCEL'
							),
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ className: 'web_edit_qty_Update_Btn', onClick: function onClick() {
											_this4.updateQuantity();
										} },
									'UPDATE'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: '', show: this.state.emptyCartConfirm, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								null,
								'Do you want to remove all items? '
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'mob_Cart_Confirm' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ className: '', onClick: this.close },
								'NO'
							),
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ className: '', onClick: function onClick() {
											_this4.emptyCart();
										} },
									'YES'
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_MyCart;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Web_MyCart);

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// const baseUrl='https://aquadeals.in/admin/web3/user/';
	// const baseAssets='https://aquadeals.in/admin/assets/';
	
	var Order_aborted = function (_Component) {
		_inherits(Order_aborted, _Component);
	
		function Order_aborted(props) {
			_classCallCheck(this, Order_aborted);
	
			var _this = _possibleConstructorReturn(this, (Order_aborted.__proto__ || Object.getPrototypeOf(Order_aborted)).call(this, props));
	
			_this.state = {
				status_title: 'Transaction Aborted'
			};
			return _this;
		}
	
		_createClass(Order_aborted, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				if (screen.width < 800) {
					window.location.href = "/status/" + this.props.params.Type;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var status_title = '';
				if (this.props.params.Type === 'aborted') {
					status_title = 'Transaction Aborted';
				} else if (this.props.params.Type === 'failure') {
					status_title = 'Transaction Failed';
				} else if (this.props.params.Type === 'invalid') {
					status_title = 'Invalid Transaction';
				} else if (this.props.params.Type === 'serverDown') {
					status_title = 'Server Down';
				} else {
					status_title = 'Something went wrong!';
				}
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_order_aborted_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-6 col-md-offset-3 web_dels_cntnt' },
								_react2.default.createElement(
									'div',
									{ className: 'web_abort_content' },
									_react2.default.createElement(
										'h4',
										null,
										status_title
									),
									_react2.default.createElement(
										'a',
										{ href: '/web/mycart', className: 'web_try_again_btn' },
										'Try again'
									)
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Order_aborted;
	}(_react.Component);
	
	exports.default = Order_aborted;

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Web_NotFound = __webpack_require__(136);
	
	var _Web_NotFound2 = _interopRequireDefault(_Web_NotFound);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// path is /status/:book_id/:type
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Order_response = function (_Component) {
		_inherits(Order_response, _Component);
	
		function Order_response(props) {
			_classCallCheck(this, Order_response);
	
			var _this = _possibleConstructorReturn(this, (Order_response.__proto__ || Object.getPrototypeOf(Order_response)).call(this, props));
	
			_this.state = {
				response_data: [],
				page_error_status: false,
				payment_details: [],
				visibility: false
			};
			_this.getOrderDetails = _this.getOrderDetails.bind(_this);
			return _this;
		}
	
		_createClass(Order_response, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				if (screen.width < 800) {
					window.location.href = "/status/" + this.props.params.book_id + '/' + this.props.params.type + '/' + this.props.params.Uid;
				}
				this.getOrderDetails();
			}
		}, {
			key: 'getOrderDetails',
			value: function getOrderDetails() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', user_id: uid, token: localStorage.token, type: this.props.params.type, book_id: this.props.params.book_id, uid: this.props.params.Uid, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'get_order_responce',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								response_data: data,
								payment_details: data.payment_details,
								disclaimer_flag: data.disclaimer_flag
							});
							localStorage.removeItem('source');
							localStorage.removeItem('campaign');
							localStorage.removeItem('url_id');
						} else {
							this.setState({
								page_error_status: true
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'toggleDisclaimer',
			value: function toggleDisclaimer() {
				this.setState({ visibility: !this.state.visibility });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_order_success_page' },
					this.state.page_error_status ? _react2.default.createElement(_Web_NotFound2.default, null) : _react2.default.createElement(
						'div',
						{ className: 'web_order_success_page' },
						_react2.default.createElement(_WebHeaderInner2.default, null),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'section',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-md-offset-3' },
									_react2.default.createElement(
										'div',
										{ className: 'response_content' },
										_react2.default.createElement(
											'div',
											{ style: { textAlign: 'center', padding: '45px 0px 30px 0' } },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { style: { paddingBottom: '35px;' }, src: __webpack_require__(253), width: '60', alt: '...' })
											),
											_react2.default.createElement(
												'h5',
												{ style: { fontWeight: 800 } },
												this.state.response_data.success_msg
											),
											_react2.default.createElement(
												'h6',
												null,
												this.state.response_data.thank_msg
											)
										),
										_react2.default.createElement(
											'section',
											{ className: 'order_deatails_blk' },
											_react2.default.createElement('div', null),
											_react2.default.createElement(
												'div',
												{ className: 'order_deatails_card' },
												_react2.default.createElement(
													'h5',
													null,
													'ORDER DETAILS'
												),
												_react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														'Order No'
													),
													_react2.default.createElement(
														'span',
														{ style: { float: 'right' } },
														'Order Date'
													)
												),
												_react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														this.state.response_data.book_id
													),
													_react2.default.createElement(
														'span',
														{ style: { float: 'right' } },
														this.state.response_data.booking_date ? this.state.response_data.booking_date : ''
													)
												),
												_react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														'Amount Paid (Online)'
													),
													_react2.default.createElement(
														'span',
														{ style: { float: 'right', fontWeight: 800 } },
														'\u20B9 ',
														this.state.response_data.total_online_payment
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'rate_us_block' },
												_react2.default.createElement(
													'ul',
													null,
													_react2.default.createElement(
														'li',
														null,
														_react2.default.createElement(
															'div',
															{ className: 'rate_img_block' },
															_react2.default.createElement('img', { className: 'img-responsive', src: __webpack_require__(257), alt: '...' })
														),
														_react2.default.createElement(
															'div',
															{ className: 'rate_content' },
															_react2.default.createElement(
																'h4',
																null,
																'Love the App?'
															),
															_react2.default.createElement(
																'h6',
																null,
																'Please take a moment to rate us,Your feedback is very important...'
															)
														),
														_react2.default.createElement(
															'a',
															{ href: 'https://goo.gl/gvP4pb' },
															_react2.default.createElement(
																'button',
																null,
																'Rate Now'
															)
														)
													),
													_react2.default.createElement(
														'li',
														null,
														_react2.default.createElement(
															'div',
															{ className: 'rate_img_block' },
															_react2.default.createElement('img', { className: 'img-responsive', src: __webpack_require__(258), alt: '...' })
														),
														_react2.default.createElement(
															'div',
															{ className: 'rate_content' },
															_react2.default.createElement(
																'h4',
																null,
																'Share & Earn'
															),
															_react2.default.createElement(
																'h6',
																null,
																'Invite your friends to AquaDeals and you both earn rewards. \xA0\xA0\xA0\xA0\xA0\xA0\xA0'
															)
														),
														_react2.default.createElement(
															'a',
															{ href: '/share_earn' },
															_react2.default.createElement(
																'button',
																null,
																'Share Now'
															)
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'conffirm_page_buttom_btns' },
												_react2.default.createElement(
													'ul',
													null,
													_react2.default.createElement(
														'li',
														null,
														_react2.default.createElement(
															'a',
															{ href: '/' },
															_react2.default.createElement(
																'button',
																null,
																'CONTINUE SHOPPING'
															)
														)
													),
													_react2.default.createElement(
														'li',
														null,
														_react2.default.createElement(
															'a',
															{ href: '/order_details/' + this.state.response_data.type + '/' + this.state.response_data.bid },
															_react2.default.createElement(
																'button',
																null,
																'REVIEW ORDER'
															)
														)
													)
												)
											),
											this.state.disclaimer_flag ? _react2.default.createElement(
												'div',
												{ className: 'view_disclaimer_details' },
												_react2.default.createElement(
													'span',
													{ id: 'disclaimer_toggle_txt' },
													_react2.default.createElement(
														'a',
														{ onClick: function onClick() {
																_this2.toggleDisclaimer();
															} },
														this.state.visibility ? "Hide Disclaimer" : "View Disclaimer"
													)
												),
												this.state.visibility ? _react2.default.createElement('span', { id: 'mob_disclaimer_txt', dangerouslySetInnerHTML: { __html: this.state.response_data.disclaimer_txt } }) : ''
											) : ''
										)
									)
								)
							)
						),
						_react2.default.createElement(_WebFooter2.default, null)
					)
				);
			}
		}]);
	
		return Order_response;
	}(_react.Component);
	
	exports.default = Order_response;

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRedux = __webpack_require__(15);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
		_inherits(Footer, _Component);
	
		function Footer(props) {
			_classCallCheck(this, Footer);
	
			var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));
	
			_this.state = {
				foo_brands: [],
				tot_data: [],
				email: '',
				mobiles: '',
				timings: ''
			};
			_this.getCategories = _this.getCategories.bind(_this);
			_this.getCustomerCareDetails = _this.getCustomerCareDetails.bind(_this);
			return _this;
		}
	
		_createClass(Footer, [{
			key: 'getCustomerCareDetails',
			value: function getCustomerCareDetails() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getCustomerSupportDetails',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							email: data.email,
							timings: data.timings,
							mobiles: data.phone
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getCategories',
			value: function getCategories() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'Getcategories',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						// console.log(data)
						this.setState({
							tot_data: data.deal_categories
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				// console.log(this.props.formdata);
				// this.props.test();
				this.getCategories();
				this.getCustomerCareDetails();
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'GetBrands',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							foo_brands: data.brands
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var foo_brands = this.state.foo_brands.map(function (brand, index) {
					return _react2.default.createElement(
						'li',
						{ key: brand.tid, onClick: function onClick() {
								location.reload();(0, _jquery2.default)(window).scrollTop(0);
							} },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: "/web/pdeals/" + brand.url_dtype_name + "/" + brand.url_name + "/" + brand.tid + "/" + brand.type + "/" + brand.page },
							brand.name
						)
					);
				});
				var categories = this.state.tot_data.map(function (category, index) {
					return _react2.default.createElement(Category, { key: index, data: category });
				});
	
				return _react2.default.createElement(
					'div',
					{ style: { clear: 'both' } },
					_react2.default.createElement(
						'section',
						{ className: 'dwnld_blk' },
						_react2.default.createElement(
							'h2',
							null,
							'Download AquaDeals App'
						),
						_react2.default.createElement(
							'p',
							null,
							'Download our Android app today to have a complete access of Aqua products'
						),
						_react2.default.createElement(
							'a',
							{ href: 'https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en', target: '_blank', title: '' },
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/google_play_store_icon.png', alt: 'Download' })
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'site_map' },
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ className: 'row ctgors_site_map' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-9' },
									categories
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-3' },
									_react2.default.createElement(
										'h4',
										null,
										'Contact Customer Care'
									),
									_react2.default.createElement(
										'div',
										{ className: 'home_care_blk' },
										_react2.default.createElement(
											'div',
											{ className: 'home_care_img' },
											_react2.default.createElement('img', { src: "https://aquadeals.in/admin/assets/icons/web_icons/cc_head_icon.png", alt: ' ' })
										),
										_react2.default.createElement(
											'ul',
											null,
											this.state.email ? _react2.default.createElement(
												'li',
												null,
												_react2.default.createElement(
													'i',
													null,
													_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/email_icon_md.png', alt: 'Email' })
												),
												_react2.default.createElement(
													'a',
													null,
													this.state.email
												)
											) : '',
											this.state.mobiles ? _react2.default.createElement(
												'li',
												null,
												_react2.default.createElement(
													'i',
													null,
													_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/call_icon_md.png', alt: 'Call' })
												),
												_react2.default.createElement(
													'a',
													null,
													this.state.mobiles
												)
											) : '',
											this.state.timings ? _react2.default.createElement(
												'li',
												null,
												_react2.default.createElement(
													'i',
													null,
													_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/timing_md.png', alt: 'Timings' })
												),
												_react2.default.createElement(
													'a',
													null,
													this.state.timings
												)
											) : ''
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row brand_site_map' },
								_react2.default.createElement(
									'h3',
									null,
									'Brands'
								),
								_react2.default.createElement(
									'ul',
									null,
									foo_brands,
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: 'http://blog.aqua.deals', target: '_blank' },
											'AquaDeals Blog'
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Footer;
	}(_react.Component);
	
	var Category = function (_Component2) {
		_inherits(Category, _Component2);
	
		function Category() {
			_classCallCheck(this, Category);
	
			var _this2 = _possibleConstructorReturn(this, (Category.__proto__ || Object.getPrototypeOf(Category)).call(this));
	
			_this2.state = {};
	
			return _this2;
		}
	
		_createClass(Category, [{
			key: 'render',
			value: function render() {
				var cat_list = this.props.data;
				return _react2.default.createElement(
					'div',
					{ className: "col-md-3 col-sm-3 col-xs-6" },
					_react2.default.createElement(
						'h3',
						null,
						cat_list.dtype
					),
					cat_list.categories.map(function (cat) {
						return _react2.default.createElement(
							'ul',
							null,
							_react2.default.createElement(
								'li',
								{ onClick: function onClick() {
										location.reload();(0, _jquery2.default)(window).scrollTop(0);
									} },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: cat.dtype === '1' || cat.dtype === '8' ? '/web/' + cat.url_dtype_name + '/' + cat.url_name + '/' + cat.id : '/web/' + cat.url + '/' + cat.url_dtype_name + '/' + cat.url_name + '/' + cat.id + '/' + cat.category + '/' + cat.dtype },
									cat.title
								)
							)
						);
					})
				);
			}
		}]);
	
		return Category;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			errorMessage: state.auth.error,
			authenticated: state.auth.authenticated,
			leads: state.auth.leads
		};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Footer);

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Header = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactOffcanvas = __webpack_require__(323);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = exports.Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	    _this.state = {
	      status: '',
	      keyword: '',
	      cart_count: _this.props.cart_updated_count,
	      cart_count_update: 0,
	      isMenuOpened: false,
	      aquacash: '',
	      bookings: '',
	      noty_count: '',
	      menuItems: []
	    };
	
	    _this.getCartCount = _this.getCartCount.bind(_this);
	    _this.menuClick = _this.menuClick.bind(_this);
	    _this.dashboard = _this.dashboard.bind(_this);
	    _this.getMenuItems = _this.getMenuItems.bind(_this);
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (localStorage.token && localStorage.user_id) {
	        this.getCartCount();
	        this.dashboard();
	      }
	      this.getMenuItems();
	      document.addEventListener('click', this.handleClickOutside.bind(this), true);
	      //this.props.getcartcount();
	    }
	  }, {
	    key: 'getMenuItems',
	    value: function getMenuItems() {
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      var data1 = { from: 'desktop_web' };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        dataType: 'json',
	        url: baseUrl + 'browse_categories',
	        data: { req: data2 },
	        success: function (data) {
	          if (data.status === 'success') {
	            this.setState({
	              menuItems: data.categories
	            });
	          }
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.clear_state();
	      // document.removeEventListener('click', this.handleClickOutside.bind(this), true);
	    }
	  }, {
	    key: 'dashboard',
	    value: function dashboard() {
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        dataType: 'json',
	        data: { req: data2 },
	        url: baseUrl + 'dashboard',
	        success: function (data) {
	          if (data.status === 'success') {
	            this.setState({
	              aquacash: data.aquacash,
	              bookings: data.bookings,
	              noty_count: data.notifications
	            });
	          }
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'menuClick',
	    value: function menuClick() {
	      this.setState({
	        isMenuOpened: !this.state.isMenuOpened
	      });
	    }
	  }, {
	    key: 'getCartCount',
	    value: function getCartCount() {
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'cart_count',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            cart_count: data.cart_count
	          });
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(event) {
	      this.props.getcartcount();
	      this.setState({
	        status: 'focus',
	        keyword: event.target.value
	      });
	    }
	  }, {
	    key: 'onChangeKey',
	    value: function onChangeKey(event) {
	      if (event.target.value.length > 2) {
	        this.props.search_products(event.target.value);
	      } else if (event.target.value.length === 0) {
	        this.props.search_products('');
	      }
	
	      this.setState({
	        keyword: event.target.value
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      this.setState({
	        status: 'unfocus'
	      });
	    }
	  }, {
	    key: 'resetKey',
	    value: function resetKey() {
	      this.props.search_products('');
	      this.setState({
	        keyword: ''
	      });
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      localStorage.clear();
	      window.location.reload();
	    }
	  }, {
	    key: 'handleClickOutside',
	    value: function handleClickOutside(event) {
	      // alert("testing "+ event.target);
	      var domNode = _reactDom2.default.findDOMNode(this);
	      // alert("testing" + domNode)
	      if (!domNode || !domNode.contains(event.target)) {
	        this.setState({
	          isMenuOpened: false
	        });
	      }
	      // if(this.state.isMenuOpened)
	      // {
	      //   this.setState({
	      //     isMenuOpened:!this.state.isMenuOpened,
	      //   })
	      // }
	      // else
	      // {
	      //   this.setState({
	      //     isMenuOpened:false,
	      //   })  
	      // }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // if(!this.props.cart_updated_count)
	      // {
	      //   this.getCartCount();
	      // }
	      (0, _jquery2.default)(document).on('mouseup', function (e) {
	        var container = (0, _jquery2.default)('.search');
	        var container_sub = (0, _jquery2.default)('.res');
	        if (!container.is(e.target) // if the target of the click isn't the container...
	        && container.has(e.target).length === 0) // ... nor a descendant of the container
	          {
	            container_sub.hide();
	          } else {
	          container_sub.show();
	        }
	      });
	      if (this.props.brands.length > 0) {
	        var brands = _react2.default.createElement(
	          'h5',
	          { className: 'brand_hdr' },
	          'Brands'
	        );
	      }
	      if (this.props.products.length > 0) {
	        var products = _react2.default.createElement(
	          'h5',
	          { className: 'brand_hdr' },
	          'Products'
	        );
	      }
	      if (this.props.categories) {
	        if (this.props.categories.length > 0) {
	          var categories = _react2.default.createElement(
	            'h5',
	            { className: 'brand_hdr' },
	            'Categories'
	          );
	        }
	      }
	      var brands_list = this.props.brands.map(function (brand, index) {
	        return _react2.default.createElement(
	          'li',
	          { key: index, onClick: function onClick() {
	              location.reload();
	            } },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { style: { textDecoration: 'none' }, className: 'brand_tlt', to: "/web/pdeals/" + brand.url_dtype_name + "/" + brand.url_brand_name + "/" + brand.id + "/" + brand.type + "/" + brand.dtype },
	            _react2.default.createElement('img', { className: '', alt: '', src: 'https://aquadeals.in/admin/assets/images/brand_icons/' + brand.logo, width: '30px;' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              brand.category_name
	            )
	          )
	        );
	      });
	      if (this.props.categories) {
	        if (this.props.categories.length > 0) {
	          var categories_list = this.props.categories.map(function (category, index) {
	            return _react2.default.createElement(
	              'li',
	              { key: index, onClick: function onClick() {
	                  location.reload();
	                } },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { style: { textDecoration: 'none' }, className: 'brand_tlt', to: "/web/pdeals/" + category.url_dtype_name + "/" + category.url_cat_name + "/" + category.id + "/" + category.type + "/" + category.dtype },
	                _react2.default.createElement('img', { className: '', alt: '', src: 'https://aquadeals.in/admin/assets/images/icons/' + category.logo, width: '30px;' }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  category.category_name
	                )
	              )
	            );
	          });
	        }
	      }
	
	      var product_list = this.props.products.map(function (product, index) {
	        return _react2.default.createElement(
	          'li',
	          { key: index, onClick: function onClick() {
	              location.reload();
	            } },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { style: { textDecoration: 'none' }, className: 'brand_tlt', to: "/web/pdetails/" + product.url_dtype_name + "/" + product.url_brand_name + "/" + product.url_product_name + "/" + product.id + "/" + product.deal_id },
	            _react2.default.createElement('img', { className: '', alt: '', src: 'https://aquadeals.in/admin/assets/images/product_imgs/thumbnails/' + product.logo, width: '30px;' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              product.category_name
	            )
	          )
	        );
	      });
	
	      var aut_status = '';
	      if (localStorage.token) {
	        aut_status = _react2.default.createElement(
	          'a',
	          { id: 'cursor', onClick: this.logout.bind(this) },
	          'LOGOUT'
	        );
	      } else {
	        aut_status = _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/web/login' },
	          'LOGIN'
	        );
	      }
	      var menuItems = this.state.menuItems.map(function (data, index) {
	        return _react2.default.createElement(
	          'li',
	          { id: index, onClick: function onClick() {
	              location.reload();
	            } },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: data.redirect_url },
	            data.dtype
	          )
	        );
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'web_deals web_header_page' },
	        _react2.default.createElement(
	          'section',
	          { className: 'indx_hdr hm_hdr' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inx_nav' },
	            _react2.default.createElement(
	              'nav',
	              { className: 'navbar navbar-default' },
	              _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4 col-lg-4 col-sm-4 col-xs-6' },
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'ul-style-none' },
	                      _react2.default.createElement(
	                        'li',
	                        { style: { float: 'left', width: '15%', marginTop: '20px' } },
	                        _react2.default.createElement(
	                          'a',
	                          { className: 'hm_menu_btn', style: { color: '#666' }, onClick: function onClick() {
	                              _this2.menuClick();
	                            } },
	                          _react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-hamburger' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { className: 'navbar-brand indx_logo', to: "/web/home" },
	                          _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/abt_logo.png', title: 'AquaDeals', alt: 'AquaDeals' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.DropdownButton,
	                          { title: 'Browse Categories', className: 'cat-drop', id: 'drp_btn' },
	                          menuItems,
	                          _react2.default.createElement(
	                            'li',
	                            { id: '5' },
	                            _react2.default.createElement(
	                              'a',
	                              { href: 'http://blog.aqua.deals', target: '_blank' },
	                              'Blog'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4 col-lg-4 col-sm-4 col-xs-6 pull-right' },
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'nav navbar-nav navbar-right' },
	                      _react2.default.createElement(
	                        'li',
	                        { className: 'abt_cls' },
	                        _react2.default.createElement(
	                          'a',
	                          { className: 'web_cart_btn', title: 'My Cart', href: '/web/mycart' },
	                          _react2.default.createElement('img', { alt: ' ', src: 'https://aquadeals.in/admin/assets/icons/web_icons/cart_icon.png' }),
	                          this.props.cart_updated_count === '0' && this.state.cart_count > 0 ? _react2.default.createElement(
	                            'span',
	                            { className: this.state.cart_count > 9 ? "web_cart_count1" : "web_cart_count" },
	                            this.state.cart_count
	                          ) : '',
	                          this.props.cart_updated_count ? _react2.default.createElement(
	                            'span',
	                            { className: this.props.cart_updated_count > 9 ? "web_cart_count1" : "web_cart_count" },
	                            this.props.cart_updated_count
	                          ) : ''
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { className: 'abt_cls' },
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { title: 'ABOUT US', to: "/web/aboutus" },
	                          'ABOUT US'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { className: 'abt_cls' },
	                        aut_status
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { to: '/web/downloads', title: 'Download AquaDeals Mobile App', className: 'dwnld_app' },
	                          'Download App'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactOffcanvas.OffCanvas,
	                    { width: 250, transitionDuration: 300, isMenuOpened: this.state.isMenuOpened, position: "left" },
	                    _react2.default.createElement(
	                      _reactOffcanvas.OffCanvasMenu,
	                      { className: 'web_side_menu' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'web_side_bar_menu' },
	                        _react2.default.createElement(
	                          'ul',
	                          null,
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              _reactRouter.Link,
	                              { to: '/web/myaquacash', title: 'My AquaCash' },
	                              _react2.default.createElement(
	                                'i',
	                                null,
	                                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/mob-assets/nav_aquacash.png', alt: '' })
	                              ),
	                              'My Aquacash',
	                              this.state.aquacash ? _react2.default.createElement(
	                                'span',
	                                { className: 'nav_menu_right' },
	                                '\u20B9',
	                                this.state.aquacash
	                              ) : ''
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              _reactRouter.Link,
	                              { to: '/web/myorders', title: 'My Orders' },
	                              _react2.default.createElement(
	                                'i',
	                                null,
	                                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/mob-assets/nav_my_bookings.png', alt: '' })
	                              ),
	                              'My Orders',
	                              this.state.bookings ? _react2.default.createElement(
	                                'span',
	                                { className: 'nav_menu_right' },
	                                this.state.bookings
	                              ) : ''
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              _reactRouter.Link,
	                              { to: '/web/mycart', title: 'My Cart' },
	                              _react2.default.createElement(
	                                'i',
	                                null,
	                                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/mob-assets/cart_icon.png', alt: '' })
	                              ),
	                              'My Cart ',
	                              this.state.cart_count > 0 ? _react2.default.createElement(
	                                'span',
	                                { className: 'nav_menu_right' },
	                                this.state.cart_count
	                              ) : ''
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              _reactRouter.Link,
	                              { to: "/web/profile", title: 'My Profile' },
	                              _react2.default.createElement(
	                                'i',
	                                null,
	                                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/mob-assets/home_my_profile.png', alt: '' })
	                              ),
	                              'My Profile'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              _reactRouter.Link,
	                              { to: '/web/notifications', title: 'Notifications' },
	                              _react2.default.createElement(
	                                'i',
	                                null,
	                                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/mob-assets/home_notification_hdr.png', alt: '' })
	                              ),
	                              'Notifications ',
	                              this.state.noty_count > 0 ? _react2.default.createElement(
	                                'span',
	                                { className: 'nav_menu_right' },
	                                this.state.noty_count
	                              ) : ''
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              _reactRouter.Link,
	                              { to: '/web/offerszone', title: 'Offers Zone' },
	                              _react2.default.createElement(
	                                'i',
	                                null,
	                                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/mob-assets/nav_offers.png', alt: '' })
	                              ),
	                              'Offers Zone'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              _reactRouter.Link,
	                              { to: '/web/share_earn', title: 'Share & Earn' },
	                              _react2.default.createElement(
	                                'i',
	                                null,
	                                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/mob-assets/nav_refer_earn.png', alt: '' })
	                              ),
	                              'Share & Earn'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              _reactRouter.Link,
	                              { to: '/web/customer_care', title: 'Customer Care' },
	                              _react2.default.createElement(
	                                'i',
	                                null,
	                                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/mob-assets/nav_customer_care.png', alt: '' })
	                              ),
	                              'Customer Support'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              _reactRouter.Link,
	                              { to: '/web/aboutus', title: 'About Us' },
	                              _react2.default.createElement(
	                                'i',
	                                null,
	                                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/nav_aboutus.png', alt: '' })
	                              ),
	                              'About Us'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                              'a',
	                              { href: 'http://blog.aqua.deals', title: 'AquaDeals Blog', target: '_blank' },
	                              _react2.default.createElement(
	                                'i',
	                                null,
	                                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/mob-assets/blogger-logo.png', alt: '' })
	                              ),
	                              'Blog'
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4 col-lg-4 col-sm-12 col-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'srch_br search' },
	                      _react2.default.createElement(
	                        'form',
	                        { className: 'navbar-form navbar-left indx_srch' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-group' },
	                          _react2.default.createElement('input', { type: 'text', ref: 'keyword', onChange: this.onChangeKey.bind(this), onFocus: this.onFocus.bind(this), onBlur: this.onBlur.bind(this), value: this.state.keyword, className: 'form-control', placeholder: 'Search for Aquaculture products, brands and more' })
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          { type: 'submit', className: 'btn btn-default' },
	                          _react2.default.createElement('i', { className: 'glyphicon glyphicon-search' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'res ressrch_box', style: { maxHeight: 400 + 'px', position: 'absolute', left: 0, overflowX: 'hidden', margin: 0 + ' auto', textDecoration: 'none', top: 45 + 'px', display: 'none', zindex: 9999 } },
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          brands
	                        ),
	                        _react2.default.createElement(
	                          'ul',
	                          { style: { paddingLeft: 15 + 'px' } },
	                          brands_list
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          products
	                        ),
	                        _react2.default.createElement(
	                          'ul',
	                          { style: { paddingLeft: 15 + 'px' } },
	                          product_list
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          categories
	                        ),
	                        _react2.default.createElement(
	                          'ul',
	                          { style: { paddingLeft: 15 + 'px' } },
	                          categories_list
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    search: state.posts.search,
	    brands: state.posts.brands,
	    products: state.posts.products,
	    trendings: state.posts.trendings,
	    categories: state.posts.categories,
	    cart_count: state.posts.cart_count,
	    cart_status: state.posts.cart_status
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Header);

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactWebVectorIcons = __webpack_require__(29);
	
	var _reactWebVectorIcons2 = _interopRequireDefault(_reactWebVectorIcons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var WebAdAssist = function (_Component) {
		_inherits(WebAdAssist, _Component);
	
		function WebAdAssist(props) {
			_classCallCheck(this, WebAdAssist);
	
			var _this = _possibleConstructorReturn(this, (WebAdAssist.__proto__ || Object.getPrototypeOf(WebAdAssist)).call(this, props));
	
			_this.state = {
				ad_assist_modal: false,
				ad_asst_confirm_modal: false,
				queries: [],
				ad_assist_flag: false,
				ad_assist_banner: ''
			};
			_this.getAdAssistModal = _this.getAdAssistModal.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.submitAdAssistData = _this.submitAdAssistData.bind(_this);
			return _this;
		}
	
		_createClass(WebAdAssist, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.getbanner();
			}
		}, {
			key: 'getAdAssistModal',
			value: function getAdAssistModal() {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('adassist_status', '1');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', id: uid, pid: '', token: localStorage.getItem('token'), source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'checkaskExpert',
						success: function (data) {
							if (data.status === 'success' && data.proceed === 1) {
								this.setState({
									ad_assist_modal: !this.state.ad_assist_modal,
									assist_data: data,
									queries: data.queries
								});
								localStorage.removeItem('adassist_status');
							}
							if (data.status === 'success' && data.proceed === 0) {
								this.setState({
									ad_asst_confirm_modal: true,
									ad_asst_confirm_message: data.msg
								});
								localStorage.removeItem('adassist_status');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'submitAdAssistData',
			value: function submitAdAssistData(event) {
				event.preventDefault();
				var error_flag = false;
				var q_id = (0, _jquery2.default)('#ad-sel-question').val();
				if (q_id == 1) {
					(0, _jquery2.default)('#ad-sel-question').css("color", "red");
					(0, _jquery2.default)('#ad-sel-question option').css("color", "#666");
					error_flag = true;
				} else {
					(0, _jquery2.default)('#ad-sel-question').css("color", "#666");
					(0, _jquery2.default)('#ad-sel-question option').css("color", "#666");
					error_flag = false;
				}
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var ad_time = this.state.ad_asst_time ? this.state.ad_asst_time : '0';
				if (ad_time == '0') {
					console.log("dv;slfjlkfr");
					error_flag = true;
					this.setState({
						time_err_status: true,
						time_err_msg: '* Required'
					});
				}
				console.log(error_flag);
				if (!error_flag) {
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.token, pid: '', time: ad_time, desc: '', source: source, campaign: campaign, url_id: url_id, selectedQue: q_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'askExpert',
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									ad_assist_modal: false,
									ad_asst_confirm_message: data.message,
									ad_asst_confirm_modal: true
								});
							} else {
								this.setState({
									ad_assist_modal: false
									// ad_asst_confirm_message:data.message,
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					ad_assist_modal: false,
					ad_asst_confirm_modal: false
				});
			}
		}, {
			key: 'setAdTime',
			value: function setAdTime(val) {
				this.setState({
					ad_asst_time: val,
					time_err_status: false,
					time_err_msg: ''
				});
			}
		}, {
			key: 'getbanner',
			value: function getbanner() {
				var data1 = { from: 'desktop_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'adassistbanner',
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								ad_assist_banner: data.ad_assist_banner,
								ad_assist_flag: data.ad_assist_flag
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					null,
					this.state.ad_assist_flag ? _react2.default.createElement(
						'section',
						{ className: 'container', style: { padding: '0px' } },
						_react2.default.createElement(
							'div',
							{ className: 'web_ad_assist', onClick: function onClick() {
									return _this2.getAdAssistModal();
								} },
							_react2.default.createElement('img', { src: baseAssets + "icons/" + this.state.ad_assist_banner, alt: '..' })
						)
					) : '',
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'ad_asst_modalbox', show: this.state.ad_assist_modal, onHide: this.close, id: 'ad_assist_web' },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'section',
								{ id: 'assets_cnt_block' },
								_react2.default.createElement(
									'span',
									{ onClick: this.close },
									_react2.default.createElement(_reactWebVectorIcons2.default, {
										name: 'close',
										font: 'SimpleLineIcons',
										color: '#fff',
										size: 16,
										style: { position: 'absolute', right: '10px', top: '8px' }
									})
								),
								_react2.default.createElement('img', { src: __webpack_require__(106), alt: '' }),
								_react2.default.createElement(
									'p',
									null,
									'Please submit the details, one of our experts will respond shortly.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'aqua-txt-block' },
									_react2.default.createElement(
										'select',
										{ id: 'ad-sel-question' },
										this.state.queries.map(function (option) {
											return _react2.default.createElement(
												'option',
												{ key: option.id, value: option.id },
												option.question
											);
										})
									),
									_react2.default.createElement(
										'h6',
										null,
										'Best time to contact:  ',
										this.state.time_err_status ? _react2.default.createElement(
											'span',
											{ style: { color: 'red', fontSize: '10px' } },
											this.state.time_err_msg
										) : ''
									),
									_react2.default.createElement(
										'form',
										{ onSubmit: this.submitAdAssistData },
										_react2.default.createElement(
											'div',
											{ className: 'ad_asst_time_blk' },
											_react2.default.createElement(
												'span',
												{ className: this.state.ad_asst_time === 1 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time", onClick: function onClick() {
														_this2.setAdTime(1);
													} },
												'9am - 12pm'
											),
											_react2.default.createElement(
												'span',
												{ className: this.state.ad_asst_time === 2 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time", onClick: function onClick() {
														_this2.setAdTime(2);
													} },
												'12pm - 3pm'
											),
											_react2.default.createElement(
												'span',
												{ className: this.state.ad_asst_time === 3 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time", onClick: function onClick() {
														_this2.setAdTime(3);
													} },
												'3pm - 5pm'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'ad_asst_submit_blk' },
											_react2.default.createElement(
												'button',
												{ type: 'submit' },
												'SCHEDULE CALL'
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'mob_reqbestprice_confm', show: this.state.ad_asst_confirm_modal, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							this.state.ad_asst_confirm_message,
							_react2.default.createElement(
								'a',
								{ onClick: this.close, className: 'req_conf_ok_btn' },
								'OK'
							)
						)
					)
				);
			}
		}]);
	
		return WebAdAssist;
	}(_react.Component);
	
	exports.default = WebAdAssist;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var WebBanners = function (_Component) {
		_inherits(WebBanners, _Component);
	
		function WebBanners(props) {
			_classCallCheck(this, WebBanners);
	
			var _this = _possibleConstructorReturn(this, (WebBanners.__proto__ || Object.getPrototypeOf(WebBanners)).call(this, props));
	
			_this.state = {
				totcount: '',
				ads: []
			};
			_this.fetchads = _this.fetchads.bind(_this);
			_this.ads_count = _this.ads_count.bind(_this);
			return _this;
		}
	
		_createClass(WebBanners, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.fetchads();
			}
		}, {
			key: 'ads_count',
			value: function ads_count(ad_id) {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var data1 = { 'from': 3, 'ad_id': ad_id, 'id': uid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'load_ad',
					success: function success(data) {},
					error: function error(data) {}
				});
			}
		}, {
			key: 'fetchads',
			value: function fetchads() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { 'id': uid, 'width': 400, 'height': 200, 'from': 3 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getAd',
					success: function (data) {
						this.setState({
							ads: data.imgs
						});
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					this.state.ads.length > 0 ? _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'container_fluid ad_slideshow' },
							_react2.default.createElement(
								_reactBootstrap.Carousel,
								{ className: '', id: 'carousel-main-slide', pauseOnHover: false, indicators: true },
								this.state.ads.map(function (ad, index) {
									var _this2 = this;
	
									var ad_deal = '';
									var link = '';
									if (ad.link === "") {
										link = '';
									} else if (ad.link !== '') {
										link = ad.link;
									}
	
									if (ad.type === "Product") {
										ad_deal = "/web/subdeals/" + ad.url_dtype + "/" + ad.url_cat_name + "/" + ad.url_brand_name + "/" + ad.pid;
									} else if (ad.type === "All Seed Deals" && ad.id === '0') {
										ad_deal = "/web/seed";
									} else if (ad.type === "All Seed Deals" && ad.id > 0) {
										ad_deal = "/web/seed/" + ad.url_dtype + "/" + ad.id;
									} else if (ad.type === "p_sub_category") {
										var deal_ids = '';
										if (typeof ad.deal_id != "undefined" && ad.deal_id != '') {
											deal_ids = ad.deal_id;
										} else {
											deal_ids = '';
										}
										ad_deal = "/web/pdeals/" + ad.url_dtype + "/" + ad.url_cat_name + "/" + ad.tid + "/Pcategory/" + ad.dtype + "/" + deal_ids;
									} else if (ad.type === "Pcategory") {
										ad_deal = "/web/pdeals/" + ad.url_name + "/all/" + ad.id;
									}
									// else if(ad.type === 'ad-guarantee')
									// {
									// ad_deal = '/web/pdeals/';
									// /pdeals/health-care/synergy-biotech/198/brand/4
									// }
									else if (ad.type === "SeedDeals") {
											ad_deal = "/web/sdetails/" + ad.url_dtype + "/" + ad.id;
										} else if (ad.type === "brand") {
											ad_deal = "/web/pdeals/" + ad.url_dtype + "/" + ad.url_ad_title + "/" + ad.tid + "/" + ad.type + "/" + ad.dtype;
										} else if (ad.type === "FeedDeals") {
											// ad_deal="/pdetails/health-care/gybro-chemicals/geolite/788/403"
											ad_deal = "/web/pdetails/" + ad.url_dtype + "/" + ad.url_cat_name + "/" + ad.url_ad_title + "/" + ad.pid + "/" + ad.deal_id;
										} else if (ad.type === "Deal Offer Types") {
											ad_deal = "/web/pdeals/" + ad.url_dtype + "/" + ad.url_ad_title + "/" + ad.url_ad_type + "/offers/" + ad.id;
										} else if (ad.type === "All Product Deals") {
											//ad_deal = 'home';
											ad_deal = "/web/offers/deals/" + ad.dis_val + "/" + ad.dis_opr + "/" + ad.dis_type;
										} else if (ad.type === "PromoOffer") {
											ad_deal = "/web/offerszone";
										} else if (ad.type === "brand_details") {
											ad_deal = "/web/" + ad.bname + "/brand-details/" + ad.dtype + "/" + ad.bid;
										} else if (ad.type === 'partner') {
											ad_deal = "/web/pdeals/partner/" + ad.tid;
										} else if (ad.type === 'caa-approved' || ad.type === 'ad-guarantee' || ad.type === 'ad-assist') {
											if (ad.tid === '0') {
												ad_deal = '/web/ad-banners/' + ad.type;
											} else {
												ad_deal = "/web/stores/" + ad.type + '/' + ad.tid;
											}
										} else {
											ad_deal = "/web/home";
										}
	
									return _react2.default.createElement(
										_reactBootstrap.Carousel.Item,
										{ key: index },
										_react2.default.createElement(
											_reactBootstrap.Carousel.Caption,
											{ className: 'webCarousel_count ' },
											ad.sno,
											'/',
											this.state.ads.length
										),
										link === '' ? _react2.default.createElement(
											_reactRouter.Link,
											{ onClick: function onClick() {
													return _this2.ads_count(ad.ad_id);
												}, to: ad_deal, className: 'item' },
											_react2.default.createElement('img', { className: 'webbanner_img', src: baseAssets + 'images/ad_imgs/ad_imgs_web/' + ad.img, alt: '...' })
										) : _react2.default.createElement(
											'a',
											{ onClick: function onClick() {
													return _this2.ads_count(ad.ad_id);
												}, href: link, target: '_blank', className: 'item' },
											_react2.default.createElement('img', { className: 'webbanner_img', src: baseAssets + 'images/ad_imgs/ad_imgs_web/' + ad.img, alt: '...' })
										)
									);
								}.bind(this))
							)
						)
					) : ''
				);
			}
		}]);
	
		return WebBanners;
	}(_react.Component);
	
	exports.default = WebBanners;

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var WebCategories = function (_Component) {
		_inherits(WebCategories, _Component);
	
		function WebCategories(props) {
			_classCallCheck(this, WebCategories);
	
			var _this = _possibleConstructorReturn(this, (WebCategories.__proto__ || Object.getPrototypeOf(WebCategories)).call(this, props));
	
			_this.state = {
				key: 1,
				cat_names: [],
				cat_items: []
			};
			_this.handleSelect = _this.handleSelect.bind(_this);
			_this.getcategories = _this.getcategories.bind(_this);
			return _this;
		}
	
		_createClass(WebCategories, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.getcategories();
			}
		}, {
			key: 'handleSelect',
			value: function handleSelect(key) {
				this.setState({
					key: key
				});
				var data1 = key;
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'getCatByDtype',
					data: { req: data1 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								cat_items: data.data
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getcategories',
			value: function getcategories() {
				var data1 = { from: 'desktop_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'getNewDtypes',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								cat_names: data.data,
								key: data.data[0].id
	
							});
							this.handleSelect('{"from":"desktop_web","dtype_id":"' + data.data[0].id + '","type":"' + data.data[0].type + '"}');
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var cat_names = '';
				if (this.state.cat_names.length > 0) {
					cat_names = this.state.cat_names.map(function (data, index) {
						return _react2.default.createElement(_reactBootstrap.Tab, { eventKey: '{"from":"desktop_web","dtype_id":"' + data.id + '","type":"' + data.type + '"}', title: data.name });
					});
				}
				var cat_items = '';
				if (this.state.cat_items.length > 0) {
					cat_items = this.state.cat_items.map(function (data, index) {
						return _react2.default.createElement(
							'div',
							{ className: ' col-md-2 col-sm-4 cart_item' },
							_react2.default.createElement(
								'a',
								{ href: data.dtype === '1' || data.dtype === 8 ? '/web/' + data.url_dtype_name + '/' + data.url_name + '/' + data.id : '/web/' + data.url + '/' + data.url_dtype_name + '/' + data.url_name + '/' + data.id + '/' + data.category + '/' + data.dtype, className: 'cat_blk' },
								_react2.default.createElement(
									'span',
									null,
									_react2.default.createElement('img', { src: data.icon ? baseAssets + 'images/icons/' + data.icon : baseAssets + '/icons/web_icons/noImage.png', alt: '' })
								),
								data.title ? _react2.default.createElement(
									'h5',
									null,
									data.title
								) : _react2.default.createElement(
									'h5',
									null,
									'\xA0'
								),
								data.count ? _react2.default.createElement(
									'h6',
									null,
									data.count + ' items'
								) : _react2.default.createElement(
									'h6',
									null,
									'\xA0'
								)
							)
						);
					});
				}
				return _react2.default.createElement(
					'section',
					{ className: 'web_categories_blk' },
					_react2.default.createElement(
						'div',
						{ className: 'container', style: { padding: '0px' } },
						_react2.default.createElement(
							'h4',
							null,
							'Trending Categories'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'container home_category_blk' },
						_react2.default.createElement(
							_reactBootstrap.Tabs,
							{ onSelect: this.handleSelect },
							cat_names
						),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'Block' },
								cat_items.length > 0 ? cat_items : ""
							)
						)
					)
				);
			}
		}]);
	
		return WebCategories;
	}(_react.Component);
	
	exports.default = WebCategories;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _WebBanners = __webpack_require__(447);
	
	var _WebBanners2 = _interopRequireDefault(_WebBanners);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import './assets/css/style_web.css';
	
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var WebHeaderHome = function (_Component) {
			_inherits(WebHeaderHome, _Component);
	
			function WebHeaderHome(props) {
					_classCallCheck(this, WebHeaderHome);
	
					var _this = _possibleConstructorReturn(this, (WebHeaderHome.__proto__ || Object.getPrototypeOf(WebHeaderHome)).call(this, props));
	
					_this.state = {
							status: '',
							keyword: '',
							cart_count: 0,
							aquacash: '',
							bookings: '',
							noty_count: '',
							menuItems: [],
	
							pro_pic: baseAssets + 'images/pro_pics/profile_pic.png'
					};
					_this.getMenuItems = _this.getMenuItems.bind(_this);
					_this.onFocus = _this.onFocus.bind(_this);
					_this.getCartCount = _this.getCartCount.bind(_this);
					_this.getProfile = _this.getProfile.bind(_this);
					return _this;
			}
	
			_createClass(WebHeaderHome, [{
					key: 'componentDidMount',
					value: function componentDidMount() {
							this.getMenuItems();
							this.getCartCount();
							this.getProfile();
					}
			}, {
					key: 'getProfile',
					value: function getProfile() {
	
							if (!localStorage.user_id && !localStorage.token) {
									// this.setState({pro_pic:'profile_pic.png'});
							} else {
									if (localStorage.user_id) {
											var uid = localStorage.user_id;
									} else {
											uid = 0;
									}
									var data1 = { from: 'desktop_web', uid: uid, token: localStorage.getItem('token'), device_id: localStorage.getItem('push_device_id') };
									var data2 = JSON.stringify(data1);
									_jquery2.default.ajax({
											url: baseUrl + 'myprofile',
											method: 'POST',
											data: { req: data2 },
											dataType: 'JSON',
											success: function (data) {
													if (data.msg === 'success') {
															this.setState({ pro_pic: baseAssets + 'images/pro_pics/' + data.details[0].pro_pic });
													}
													if (data.status === 'error' && data.message === 'Token mismatch') {
															localStorage.removeItem('user_id');
															localStorage.removeItem('token');
															window.location.reload();
													}
											}.bind(this),
											error: function error(err) {}
									});
							}
					}
			}, {
					key: 'logout',
					value: function logout() {
							localStorage.clear();
							window.location.reload();
					}
			}, {
					key: 'getCartCount',
					value: function getCartCount() {
							if (localStorage.user_id) {
									var uid = localStorage.user_id;
							} else {
									uid = 0;
							}
							var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token') };
							var data2 = JSON.stringify(data1);
							_jquery2.default.ajax({
									method: 'POST',
									url: baseUrl + 'cart_count',
									dataType: 'json',
									data: { req: data2 },
									success: function (data) {
											if (data.status === 'error' && data.message === 'Token mismatch') {
													this.props.tokenCheck();
											}
											this.setState({
													cart_count: data.cart_count
											});
									}.bind(this),
									error: function error(err) {}
							});
					}
			}, {
					key: 'onFocus',
					value: function onFocus(event) {
							this.setState({
									status: 'foucs',
									keyword: event.target.value
							});
					}
			}, {
					key: 'getMenuItems',
					value: function getMenuItems() {
							var data1 = { from: 'desktop_web' };
							var data2 = JSON.stringify(data1);
							_jquery2.default.ajax({
									method: 'POST',
									dataType: 'json',
									url: baseUrl + 'browse_categories',
									data: { req: data2 },
									success: function (data) {
											if (data.status === 'success') {
													this.setState({
															menuItems: data.categories
													});
											}
									}.bind(this),
									error: function error(err) {}
							});
					}
			}, {
					key: 'onChangeKey',
					value: function onChangeKey(event) {
							if (event.target.value.length > 2) {
									this.props.search_products(event.target.value);
							} else if (event.target.value.length === 0) {
									this.props.search_products('');
							}
							this.setState({
									keyword: event.target.value
							});
					}
			}, {
					key: 'onBlur',
					value: function onBlur() {
							this.setState({
									status: 'unfocus'
							});
					}
			}, {
					key: 'resetKey',
					value: function resetKey() {
							this.props.search_products('');
							this.setState({
									keyword: ''
							});
					}
			}, {
					key: 'render',
					value: function render() {
							var params = {
									paginationClickable: true,
									spaceBetween: 10,
									slidesPerView: 4.5
							};
							(0, _jquery2.default)(document).on('mouseup', function (e) {
									var container = (0, _jquery2.default)('.ad_search');
									var container_sub = (0, _jquery2.default)('.res');
	
									if (!container.is(e.target) // if the target of the click isn't the container...
									&& container.has(e.target).length === 0) // ... nor a descendant of the container
											{
													container_sub.hide();
											} else {
											container_sub.show();
									}
							});
							var menuItems = this.state.menuItems.map(function (data, index) {
									return _react2.default.createElement(
											'li',
											{ id: index, onClick: function onClick() {
															location.reload();
													} },
											_react2.default.createElement(
													_reactRouter.Link,
													{ to: data.redirect_url },
													data.dtype
											)
									);
							});
							if (this.props.brands.length > 0) {
									var brands = _react2.default.createElement(
											'h5',
											{ className: 'brand_hdr' },
											'Brands'
									);
							}
							if (this.props.products.length > 0) {
									var products = _react2.default.createElement(
											'span',
											null,
											_react2.default.createElement('div', { className: 'clr' }),
											_react2.default.createElement(
													'h5',
													{ className: 'brand_hdr' },
													'Products'
											)
									);
							}
	
							if (this.props.categories) {
									if (this.props.categories.length > 0) {
											var categories = _react2.default.createElement(
													'h5',
													{ className: 'brand_hdr' },
													'Categories'
											);
									}
							}
							var that = this;
							var brands_list = this.props.brands.map(function (brand, index) {
									return _react2.default.createElement(
											_reactRouter.Link,
											{ to: "/web/pdeals/" + brand.url_dtype_name + "/" + brand.url_brand_name + "/" + brand.id + "/" + brand.type + "/" + brand.dtype, onClick: function onClick() {
															that.saveSearch(localStorage.user_id, brand.id, 3);
													} },
											_react2.default.createElement(
													_reactBootstrap.Col,
													{ md: 12, sm: 12, xs: 12, className: 'srh_list_item' },
													_react2.default.createElement(
															_reactBootstrap.Col,
															{ md: 2, sm: 2, xs: 2, className: '' },
															_react2.default.createElement('img', { src: brand.logo !== '' && brand.logo !== null ? baseAssets + 'images/brand_icons/' + brand.logo : baseAssets + 'icons/web_icons/noImage.png', role: 'presentation', alt: ' ', width: '30px' })
													),
													_react2.default.createElement(
															_reactBootstrap.Col,
															{ md: 10, sm: 10, xs: 10, className: '' },
															_react2.default.createElement(
																	'div',
																	{ className: 'srh_cnt_all' },
																	brand.category_name
															)
													),
													_react2.default.createElement(
															_reactBootstrap.Col,
															{ md: 1, sm: 1, xs: 1, className: 'srh_deal_cnt' },
															_react2.default.createElement(
																	'i',
																	null,
																	brand.dealcount
															)
													)
											)
									);
							});
							if (this.props.categories) {
									if (this.props.categories.length > 0) {
											var categories_list = this.props.categories.map(function (category, index) {
													return _react2.default.createElement(
															'li',
															{ key: index, onClick: function onClick() {
																			location.reload();
																	} },
															_react2.default.createElement(
																	_reactRouter.Link,
																	{ style: { textDecoration: 'none' }, className: 'brand_tlt', to: "/web/pdeals/" + category.url_dtype_name + "/" + category.url_cat_name + "/" + category.id + "/" + category.type + "/" + category.dtype },
																	_react2.default.createElement('img', { className: '', alt: '', src: 'https://aquadeals.in/admin/assets/images/icons/' + category.logo, width: '30px;' }),
																	_react2.default.createElement(
																			'span',
																			null,
																			category.category_name
																	)
															)
													);
											});
									}
							}
							var that = this;
							var product_list = this.props.products.map(function (product, index) {
									return _react2.default.createElement(
											_reactRouter.Link,
											{ to: product.dealcount > 1 ? "/web/subdeals/" + product.url_dtype_name + "/" + product.url_brand_name + "/" + product.url_product_name + "/" + product.id + "/type/" + product.dtype : "/pdetails/" + product.url_dtype_name + "/" + product.url_brand_name + "/" + product.url_product_name + "/" + product.id + "/" + product.deal_id, onClick: function onClick() {
															that.saveSearch(localStorage.user_id, product.id, 1);
													} },
											_react2.default.createElement(
													_reactBootstrap.Col,
													{ md: 12, sm: 12, xs: 12, className: 'srh_list_item' },
													_react2.default.createElement(
															_reactBootstrap.Col,
															{ md: 2, sm: 2, xs: 2, className: '' },
															_react2.default.createElement('img', { src: product.logo !== '' && product.logo !== null ? baseAssets + 'images/product_imgs/thumbnails/' + product.logo : baseAssets + 'icons/web_icons/noImage.png', alt: ' ', width: '30px' })
													),
													_react2.default.createElement(
															_reactBootstrap.Col,
															{ md: 10, sm: 10, xs: 10, className: '' },
															_react2.default.createElement(
																	'div',
																	{ className: 'srh_cnt_all' },
																	product.category_name
															)
													),
													_react2.default.createElement(
															_reactBootstrap.Col,
															{ md: 1, sm: 1, xs: 1, className: 'srh_deal_cnt' },
															_react2.default.createElement(
																	'i',
																	null,
																	product.dealcount
															)
													)
											)
									);
							});
	
							var aut_status = '';
							if (localStorage.token) {
									aut_status = _react2.default.createElement(
											'a',
											{ className: 'cursor', onClick: this.logout.bind(this) },
											'LOGOUT'
									);
							} else {
									aut_status = _react2.default.createElement(
											_reactRouter.Link,
											{ to: '/web/login' },
											'LOGIN'
									);
							}
	
							if (this.props.recent_search.length > 3) {
									var recent_search = this.props.recent_search.map(function (item, index) {
											var _this2 = this;
	
											var data = _react2.default.createElement(
													'div',
													{ className: 'recent_search_list' },
													item.type === "product" ? _react2.default.createElement(
															'div',
															null,
															_react2.default.createElement(
																	'div',
																	{ className: 'recent_close_icon' },
																	_react2.default.createElement(
																			'span',
																			{ onClick: function onClick() {
																							_this2.deleteSearchItem(item.del_id);
																					} },
																			_react2.default.createElement(Icon, {
																					name: 'close-circle',
																					font: 'MaterialCommunityIcons',
																					color: '#9999',
																					size: 16
																			})
																	)
															),
															_react2.default.createElement(
																	_reactRouter.Link,
																	{ to: item.type === "product" && item.dealcount > 1 ? "/web/subdeals/" + item.url_dtype_name + "/" + item.url_cat_name + "/" + item.url_name + "/" + item.id : "/pdetails/" + item.url_dtype_name + "/" + item.url_cat_name + "/" + item.url_name + "/" + item.id + "/" + item.deal_id },
																	_react2.default.createElement(
																			'div',
																			{ className: 'recent_search_thumbnail' },
																			_react2.default.createElement('img', { src: item.logo !== null && item.logo !== '' ? baseAssets + 'images/product_imgs/' + item.logo : baseAssets + 'icons/web_icons/noImage.png', alt: '', width: '40px' })
																	),
																	_react2.default.createElement(
																			'h4',
																			null,
																			item.category_name
																	)
															)
													) : '',
													item.type === 'brand' ? _react2.default.createElement(
															'div',
															null,
															_react2.default.createElement(
																	'div',
																	{ className: 'recent_close_icon' },
																	_react2.default.createElement(
																			'span',
																			{ onClick: function onClick() {
																							_this2.deleteSearchItem(item.del_id);
																					} },
																			_react2.default.createElement(Icon, {
																					name: 'close-circle',
																					font: 'MaterialCommunityIcons',
																					color: '#9999',
																					size: 16
																			})
																	)
															),
															_react2.default.createElement(
																	_reactRouter.Link,
																	{ to: "/web/pdeals/" + item.url_dtype_name + "/" + item.url_name + "/" + item.id + "/" + item.type + "/" + item.dtype },
																	_react2.default.createElement(
																			'div',
																			{ className: 'recent_search_thumbnail' },
																			_react2.default.createElement('img', { src: item.logo !== '' && item.logo !== null ? baseAssets + 'images/brand_icons/' + item.logo : baseAssets + 'icons/web_icons/noImage.png', alt: '', width: '40px' })
																	),
																	_react2.default.createElement(
																			'h4',
																			null,
																			item.category_name
																	)
															)
													) : '',
													item.type === 'Pcategory' ? _react2.default.createElement(
															'div',
															null,
															_react2.default.createElement(
																	'div',
																	{ className: 'recent_close_icon' },
																	_react2.default.createElement(
																			'span',
																			{ onClick: function onClick() {
																							_this2.deleteSearchItem(item.del_id);
																					} },
																			_react2.default.createElement(Icon, {
																					name: 'close-circle',
																					font: 'MaterialCommunityIcons',
																					color: '#9999',
																					size: 16
																			})
																	)
															),
															_react2.default.createElement(
																	_reactRouter.Link,
																	{ to: '/pdeals/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.id + '/Pcategory/' + item.dtype },
																	_react2.default.createElement(
																			'div',
																			{ className: 'recent_search_thumbnail' },
																			_react2.default.createElement('img', { src: item.logo !== '' && item.logo !== null ? baseAssets + 'images/icons/' + item.logo : baseAssets + 'icons/web_icons/noImage.png', alt: '', width: '40px' })
																	),
																	_react2.default.createElement(
																			'h4',
																			null,
																			item.category_name
																	)
															)
													) : ''
											);
											return data;
									}.bind(this));
							} else if (this.props.recent_search.length < 4 && this.props.recent_search.length != 0) {
									var recent_search = this.props.recent_search.map(function (item, index) {
											var _this3 = this;
	
											var data = _react2.default.createElement(
													'li',
													{ className: 'recent_search_list' },
													item.type === "product" ? _react2.default.createElement(
															'div',
															null,
															_react2.default.createElement(
																	'div',
																	{ className: 'recent_close_icon' },
																	_react2.default.createElement(
																			'span',
																			{ onClick: function onClick() {
																							_this3.deleteSearchItem(item.del_id);
																					} },
																			_react2.default.createElement(Icon, {
																					name: 'close-circle',
																					font: 'MaterialCommunityIcons',
																					color: '#9999',
																					size: 16
																			})
																	)
															),
															_react2.default.createElement(
																	_reactRouter.Link,
																	{ to: item.type === "product" && item.dealcount > 1 ? "/web/subdeals/" + item.url_dtype_name + "/" + item.url_cat_name + "/" + item.url_name + "/" + item.id : "/pdetails/" + item.url_dtype_name + "/" + item.url_cat_name + "/" + item.url_name + "/" + item.id + "/" + item.deal_id },
																	_react2.default.createElement(
																			'div',
																			{ className: 'recent_search_thumbnail' },
																			_react2.default.createElement('img', { src: item.logo !== null && item.logo !== '' ? baseAssets + 'images/product_imgs/' + item.logo : baseAssets + 'icons/web_icons/noImage.png', alt: '', width: '40px' })
																	),
																	_react2.default.createElement(
																			'h4',
																			null,
																			item.category_name
																	)
															)
													) : ''
											);
	
											{
													item.type === 'brand' ? _react2.default.createElement(
															'div',
															null,
															_react2.default.createElement(
																	'div',
																	{ className: 'recent_close_icon' },
																	_react2.default.createElement(
																			'span',
																			{ onClick: function onClick() {
																							_this3.deleteSearchItem(item.del_id);
																					} },
																			_react2.default.createElement(Icon, {
																					name: 'close-circle',
																					font: 'MaterialCommunityIcons',
																					color: '#9999',
																					size: 16
																			})
																	)
															),
															_react2.default.createElement(
																	_reactRouter.Link,
																	{ to: "/web/pdeals/" + item.url_dtype_name + "/" + item.url_name + "/" + item.id + "/" + item.type + "/" + item.dtype },
																	_react2.default.createElement(
																			'div',
																			{ className: 'recent_search_thumbnail' },
																			_react2.default.createElement('img', { src: item.logo !== '' && item.logo !== null ? baseAssets + 'images/brand_icons/' + item.logo : baseAssets + 'icons/web_icons/noImage.png', alt: '', width: '40px' })
																	),
																	_react2.default.createElement(
																			'h4',
																			null,
																			item.category_name
																	)
															)
													) : '';
											}
	
											{
													item.type === 'Pcategory' ? _react2.default.createElement(
															'div',
															null,
															_react2.default.createElement(
																	'div',
																	{ className: 'recent_close_icon' },
																	_react2.default.createElement(
																			'span',
																			{ onClick: function onClick() {
																							_this3.deleteSearchItem(item.del_id);
																					} },
																			_react2.default.createElement(Icon, {
																					name: 'close-circle',
																					font: 'MaterialCommunityIcons',
																					color: '#9999',
																					size: 16
																			})
																	)
															),
															_react2.default.createElement(
																	_reactRouter.Link,
																	{ to: '/pdeals/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.id + '/Pcategory/' + item.dtype },
																	_react2.default.createElement(
																			'div',
																			{ className: 'recent_search_thumbnail' },
																			_react2.default.createElement('img', { src: item.logo !== '' && item.logo !== null ? baseAssets + 'images/icons/' + item.logo : baseAssets + 'icons/web_icons/noImage.png', alt: '', width: '40px' })
																	),
																	_react2.default.createElement(
																			'h4',
																			null,
																			item.category_name
																	)
															)
													) : '';
											}
											return data;
									}.bind(this));
							} else {
									recent_search = '';
							}
	
							return _react2.default.createElement(
									'div',
									{ className: 'HomePage' },
									_react2.default.createElement(
											'header',
											null,
											_react2.default.createElement('div', { className: 'clr' }),
											_react2.default.createElement(
													'nav',
													{ className: 'navbar navbar-default' },
													_react2.default.createElement(
															'div',
															{ className: 'container-fluid' },
															_react2.default.createElement(
																	'div',
																	{ className: 'navbar-header' },
																	_react2.default.createElement(
																			'button',
																			{ type: 'button', className: 'navbar-toggle collapsed', 'data-toggle': 'collapse', 'data-target': '#bs-example-navbar-collapse-1', 'aria-expanded': 'false' },
																			_react2.default.createElement(
																					'span',
																					{ className: 'sr-only' },
																					'Toggle navigation'
																			),
																			_react2.default.createElement('span', { className: 'icon-bar' }),
																			_react2.default.createElement('span', { className: 'icon-bar' }),
																			_react2.default.createElement('span', { className: 'icon-bar' })
																	),
																	_react2.default.createElement(
																			'a',
																			{ className: 'navbar-brand ad_logo' },
																			_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/logo.png', alt: 'AquaDeals' }),
																			_react2.default.createElement(
																					'span',
																					null,
																					'#HappyFarming'
																			)
																	),
																	_react2.default.createElement(
																			'div',
																			{ className: 'clr' },
																			' \xA0'
																	)
															),
															_react2.default.createElement(
																	'div',
																	{ className: 'collapse navbar-collapse', id: 'bs-example-navbar-collapse-1' },
																	_react2.default.createElement(
																			'form',
																			{ className: 'navbar-form navbar-left ad_search' },
																			_react2.default.createElement(
																					'div',
																					{ className: 'dropdown ad_cat_drop' },
																					_react2.default.createElement(
																							_reactBootstrap.DropdownButton,
																							{ title: 'All', id: 'drp_btn' },
																							menuItems,
																							_react2.default.createElement(
																									'li',
																									{ id: '5' },
																									_react2.default.createElement(
																											'a',
																											{ href: 'http://blog.aqua.deals', target: '_blank' },
																											'Blog'
																									)
																							)
																					)
																			),
																			_react2.default.createElement(
																					'div',
																					{ className: 'form-group' },
																					_react2.default.createElement('input', { type: 'text', ref: 'keyword', onChange: this.onChangeKey.bind(this), onFocus: this.onFocus.bind(this), onBlur: this.onBlur.bind(this), value: this.state.keyword, className: 'form-control', placeholder: 'Search for Aquaculture products, brands and more' })
																			),
																			_react2.default.createElement(
																					'div',
																					{ className: 'res ressrch_box', style: { maxHeight: 400 + 'px', position: 'absolute', left: 0, overflowX: 'hidden', margin: 0 + ' auto', textDecoration: 'none', top: 45 + 'px', display: 'none', zindex: 9999 } },
																					_react2.default.createElement(
																							'div',
																							null,
																							brands
																					),
																					_react2.default.createElement(
																							'ul',
																							{ style: { paddingLeft: 15 + 'px' } },
																							brands_list
																					),
																					_react2.default.createElement(
																							'div',
																							null,
																							products
																					),
																					_react2.default.createElement(
																							'ul',
																							{ style: { paddingLeft: 15 + 'px' } },
																							product_list
																					),
																					_react2.default.createElement(
																							'div',
																							null,
																							categories
																					),
																					_react2.default.createElement(
																							'ul',
																							{ style: { paddingLeft: 15 + 'px' } },
																							categories_list
																					),
																					recent_search,
																					this.props.recent_search.length > 0 ? _react2.default.createElement(
																							'div',
																							{ className: 'recent_search_blk' },
																							_react2.default.createElement(
																									'div',
																									null,
																									_react2.default.createElement(
																											'h2',
																											null,
																											'Recent Searches'
																									)
																							),
																							this.props.recent_search.length > 3 ? _react2.default.createElement(
																									Swiper,
																									_extends({}, params, { key: recent_search.length }),
																									recent_search
																							) : _react2.default.createElement(
																									'div',
																									null,
																									_react2.default.createElement(
																											'ul',
																											{ className: 'recent_search_ul' },
																											recent_search
																									)
																							)
																					) : ''
																			),
																			_react2.default.createElement(
																					'span',
																					{ className: 'btn btn-default ad_srch_btn' },
																					_react2.default.createElement('i', { className: 'glyphicon glyphicon-search' })
																			)
																	),
																	_react2.default.createElement(
																			'ul',
																			{ className: 'nav navbar-nav navbar-right ad_nav_rgt' },
																			_react2.default.createElement(
																					'li',
																					{ className: 'ad_cart' },
																					_react2.default.createElement(
																							'a',
																							{ href: '/web/mycart' },
																							_react2.default.createElement('img', { src: baseAssets + 'images_web/cart_icon.png', alt: ' ' })
																					),
																					this.state.cart_count > 0 ? _react2.default.createElement(
																							'i',
																							null,
																							this.state.cart_count
																					) : ''
																			),
																			_react2.default.createElement(
																					'li',
																					{ className: 'dropdown log_blk web_nav_menu' },
																					_react2.default.createElement(
																							_reactBootstrap.DropdownButton,
																							{ className: '', noCaret: true, id: 'drp_btn1', title: _react2.default.createElement(
																											'i',
																											null,
																											_react2.default.createElement(
																													'span',
																													{ className: 'web_pro_icon' },
																													_react2.default.createElement('img', { src: this.state.pro_pic, alt: ' ', className: 'webpro_img' })
																											),
																											_react2.default.createElement('span', { className: 'glyphicon glyphicon-option-vertical glyph_dots' })
																									) },
																							_react2.default.createElement(
																									'li',
																									null,
																									_react2.default.createElement(
																											_reactRouter.Link,
																											{ to: '/web/myaquacash', title: 'My AquaCash' },
																											'My Aquacash',
																											this.state.aquacash ? _react2.default.createElement(
																													'span',
																													{ className: 'nav_menu_right' },
																													'\u20B9',
																													this.state.aquacash
																											) : ''
																									)
																							),
																							_react2.default.createElement(
																									'li',
																									null,
																									_react2.default.createElement(
																											_reactRouter.Link,
																											{ to: '/web/myorders', title: 'My Orders' },
																											'My Orders',
																											this.state.bookings ? _react2.default.createElement(
																													'span',
																													{ className: '' },
																													this.state.bookings
																											) : ''
																									)
																							),
																							_react2.default.createElement(
																									'li',
																									null,
																									_react2.default.createElement(
																											_reactRouter.Link,
																											{ to: '/web/wishlist', title: 'Wishlist' },
																											'Wishlist'
																									)
																							),
																							_react2.default.createElement(
																									'li',
																									null,
																									_react2.default.createElement(
																											_reactRouter.Link,
																											{ to: "/web/profile", title: 'My Profile' },
																											'My Profile'
																									)
																							),
																							_react2.default.createElement(
																									'li',
																									null,
																									_react2.default.createElement(
																											_reactRouter.Link,
																											{ to: '/web/notifications', title: 'Notifications' },
																											'Notifications ',
																											this.state.noty_count > 0 ? _react2.default.createElement(
																													'span',
																													{ className: 'nav_menu_right' },
																													this.state.noty_count
																											) : ''
																									)
																							),
																							_react2.default.createElement(
																									'li',
																									null,
																									_react2.default.createElement(
																											_reactRouter.Link,
																											{ to: '/web/offerszone', title: 'Offers Zone' },
																											'Offers Zone'
																									)
																							),
																							_react2.default.createElement(
																									'li',
																									null,
																									_react2.default.createElement(
																											_reactRouter.Link,
																											{ to: '/web/share_earn', title: 'Share & Earn' },
																											'Share & Earn'
																									)
																							),
																							_react2.default.createElement(
																									'li',
																									null,
																									_react2.default.createElement(
																											_reactRouter.Link,
																											{ to: '/web/customer_care', title: 'Customer Care' },
																											'Customer Support'
																									)
																							),
																							_react2.default.createElement('li', { role: 'separator', className: 'divider' }),
																							_react2.default.createElement(
																									'li',
																									null,
																									aut_status
																							)
																					)
																			)
																	)
															)
													)
											),
											_react2.default.createElement(
													'div',
													{ className: 'sub_nav' },
													_react2.default.createElement(
															'div',
															{ className: 'container-fluid' },
															_react2.default.createElement(
																	'ul',
																	null,
																	_react2.default.createElement(
																			'li',
																			null,
																			_react2.default.createElement(
																					_reactRouter.Link,
																					{ to: '/web/downloads', title: 'Download App' },
																					'Download app'
																			)
																	),
																	_react2.default.createElement(
																			'li',
																			null,
																			_react2.default.createElement(
																					_reactRouter.Link,
																					{ to: '/web/customer_care', title: '24x7 Customer Support' },
																					'24x7 Customer Support'
																			)
																	),
																	_react2.default.createElement(
																			'li',
																			null,
																			_react2.default.createElement(
																					_reactRouter.Link,
																					{ to: '/web/advertise-with-us', title: 'Advertise with us' },
																					'Advertise with us'
																			)
																	),
																	_react2.default.createElement(
																			'li',
																			null,
																			_react2.default.createElement(
																					_reactRouter.Link,
																					{ to: '/web/enquire_now/partner/support/sid/did', title: 'Sell on AquaDeals' },
																					'Sell on AquaDeals'
																			)
																	),
																	_react2.default.createElement(
																			'li',
																			null,
																			_react2.default.createElement(
																					_reactRouter.Link,
																					{ to: '/web/aboutus', title: 'About Us' },
																					'About Us'
																			)
																	),
																	_react2.default.createElement(
																			'li',
																			null,
																			_react2.default.createElement(
																					'a',
																					{ href: 'http://blog.aqua.deals', title: 'AquaDeals Blog', target: '_blank' },
																					'Blog'
																			)
																	)
															)
													)
											)
									),
									_react2.default.createElement(
											'div',
											{ className: 'fetrs_slid' },
											_react2.default.createElement(
													'div',
													{ className: 'ad_featurs' },
													_react2.default.createElement(
															'ul',
															null,
															_react2.default.createElement(
																	'li',
																	{ className: 'col-md-4 col-sm-4' },
																	_react2.default.createElement(
																			'i',
																			null,
																			_react2.default.createElement('img', { src: baseAssets + 'images_web/languages_icon.png', alt: ' ' })
																	),
																	_react2.default.createElement(
																			'span',
																			null,
																			'9 Languages support'
																	)
															),
															_react2.default.createElement(
																	'li',
																	{ className: 'col-md-4 col-sm-4' },
																	_react2.default.createElement(
																			'i',
																			null,
																			_react2.default.createElement('img', { src: baseAssets + 'images_web/buyer_protection.png', alt: ' ' })
																	),
																	_react2.default.createElement(
																			'span',
																			null,
																			'100% Buyer protection'
																	)
															),
															_react2.default.createElement(
																	'li',
																	{ className: 'col-md-4 col-sm-4' },
																	_react2.default.createElement(
																			'i',
																			null,
																			_react2.default.createElement('img', { src: baseAssets + 'images_web/customer_care.png', alt: ' ' })
																	),
																	_react2.default.createElement(
																			'span',
																			null,
																			'24/7 Customer service'
																	)
															)
													)
											),
											_react2.default.createElement(
													'h1',
													{ className: 'about_title' },
													'Shop the best deals on all Aquaculture products & brands online'
											),
											_react2.default.createElement(_WebBanners2.default, null)
									)
							);
					}
			}]);
	
			return WebHeaderHome;
	}(_react.Component);
	
	function mapStateToProps(state) {
			return {
					search: state.posts.search,
					brands: state.posts.brands,
					products: state.posts.products,
					trendings: state.posts.trendings,
					categories: state.posts.categories,
					isLoading: state.posts.isLoading,
					recent_search: state.posts.recent_search
			};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(WebHeaderHome);

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	// const baseAssets='https://aquadeals.in/admin/assets/';
	
	var Web_Advertise = function (_Component) {
	  _inherits(Web_Advertise, _Component);
	
	  function Web_Advertise(props) {
	    _classCallCheck(this, Web_Advertise);
	
	    var _this = _possibleConstructorReturn(this, (Web_Advertise.__proto__ || Object.getPrototypeOf(Web_Advertise)).call(this, props));
	
	    _this.state = {
	      contact_err: '',
	      name_err: '',
	      email_err: '',
	      phone_err: '',
	
	      utype: 1,
	      message: '',
	      response: false,
	
	      email: '',
	      mobile: '',
	      name: ''
	
	    };
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.nameChange = _this.nameChange.bind(_this);
	    _this.mobileChange = _this.mobileChange.bind(_this);
	    _this.close = _this.close.bind(_this);
	    return _this;
	  }
	
	  _createClass(Web_Advertise, [{
	    key: 'close',
	    value: function close() {
	      this.setState({ response: false });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(event) {
	      // var contact = this.refs.contact.value;
	      var name = this.refs.name.value;
	      var email = this.refs.email.value;
	      var mobile = this.refs.phone.value;
	      var company = this.refs.company.value;
	      var invalidChars = /[^a-zA-Z ]/gi;
	      var invalidNumber = /[^0-9]/gi;
	      var emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
	      // var contact ="User";
	      var flag = 0;
	
	      if (name === '') {
	        this.setState({ name_err: 'Please enter name' });
	        flag = 1;
	      } else if (invalidChars.test(name)) {
	        this.setState({ name_err: 'Please enter valid name' });
	        flag = 1;
	      } else if (name.length < 3) {
	        this.setState({ name_err: 'Minimum length should be 3 characters' });
	        flag = 1;
	      } else {
	        this.setState({ name_err: '' });
	      }
	      if (email === '') {
	        this.setState({ email_err: 'Please enter Email' });
	        flag = 1;
	      } else if (!emailPattern.test(email)) {
	        this.setState({ email_err: 'Please enter valid Email' });
	        flag = 1;
	      } else {
	        this.setState({ email_err: '' });
	        flag = 0;
	      }
	
	      if (mobile === '') {
	        this.setState({ phone_err: 'Please enter Phone Number' });
	        flag = 1;
	      } else if (invalidNumber.test(mobile)) {
	        this.setState({ phone_err: 'Please enter valid Phone Number' });
	        flag = 1;
	      } else if (mobile.length < 10) {
	        this.setState({ phone_err: 'Please enter valid Phone Number' });
	        flag = 1;
	      } else {
	        this.setState({ phone_err: '' });
	      }
	
	      if (localStorage.user_id) {
	        var uid = localStorage.user_id;
	      } else {
	        uid = 0;
	      }
	      var url = window.location.href;
	
	      if (localStorage.source) {
	        var source = localStorage.getItem('source');
	      } else {
	        source = '';
	      }
	      if (localStorage.campaign) {
	        var campaign = localStorage.getItem('campaign');
	      } else {
	        campaign = '';
	      }
	      if (localStorage.url_id) {
	        var url_id = localStorage.getItem('url_id');
	      } else {
	        url_id = '';
	      }
	
	      // advertiseWithUs(id,name,email,mobile,company,utype,from)
	      var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, utype: this.state.utype, name: name, email: email, mobile: mobile, company: company, source: source, campaign: campaign, url_id: url_id, url: url };
	      var data2 = JSON.stringify(data1);
	      if (flag === 0) {
	        _jquery2.default.ajax({
	          url: baseUrl + 'advertiseWithUs',
	          method: 'POST',
	          dataType: 'JSON',
	          data: { req: data2 },
	          success: function (data) {
	            if (data.status === 'success') {
	              this.setState({
	                message: data.msg,
	                response: true,
	                mobile: '',
	                name: ''
	              });
	            }
	            if (data.status === 'error') {
	              this.setState({
	                message: data.msg,
	                response: true,
	                mobile: '',
	                name: ''
	              });
	            }
	            this.refs.name.value = "";
	            this.refs.email.value = "";
	            this.refs.phone.value = "";
	            this.refs.company.value = "";
	          }.bind(this),
	          error: function error(err) {}
	
	        });
	      }
	
	      event.preventDefault();
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      this.setState({ utype: event.target.value });
	    }
	  }, {
	    key: 'nameChange',
	    value: function nameChange(event) {
	
	      var x = event.target.value;
	      var invalidChars = /[^a-zA-Z ]/gi;
	      if (invalidChars.test(event.target.value)) {
	        x = event.target.value.replace(invalidChars, "");
	      } else {
	        this.setState({
	          name: x
	        });
	      }
	    }
	  }, {
	    key: 'mobileChange',
	    value: function mobileChange(event) {
	      var x = event.target.value;
	      var invalidChars = /[^0-9]/gi;
	      if (invalidChars.test(event.target.value)) {
	        x = event.target.value.replace(invalidChars, "");
	      } else {
	        this.setState({
	          mobile: x
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      document.title = "Advertise With Us | AquaDeals";
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_WebHeaderInner2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container web_advertise_page', style: { marginTop: '30px', marginBottom: '20px' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'clr' },
	              '\xA0'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'clr' },
	              '\xA0'
	            ),
	            _react2.default.createElement(
	              'h3',
	              { className: 'contact_hdr' },
	              'Advertise With Us'
	            ),
	            _react2.default.createElement(
	              'form',
	              { onSubmit: this.handleSubmit },
	              _react2.default.createElement(
	                'div',
	                { className: 'container advertise_form' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'contact_filed' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'I am a'
	                  ),
	                  _react2.default.createElement(
	                    'select',
	                    { className: 'selectbox', value: this.state.value, onChange: this.handleChange },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '1' },
	                      'User'
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { value: '2' },
	                      'Dealer'
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { value: '3' },
	                      'Manufacturer'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'error' },
	                    this.state.contact_err ? this.state.contact_err : ''
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'clr' },
	                  '\xA0'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'clr' },
	                  '\xA0'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row form_fileds' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'advertise_group col-xs-3 col-lg-3 col-md-3' },
	                    _react2.default.createElement('input', { type: 'text', ref: 'name', placeholder: 'Name', value: this.state.name, onChange: this.nameChange }),
	                    _react2.default.createElement('span', { className: 'bar' }),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'error' },
	                      this.state.name_err ? this.state.name_err : ''
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'advertise_group col-xs-3 col-lg-3 col-md-3' },
	                    _react2.default.createElement('input', { type: 'text', ref: 'email', placeholder: 'Email' }),
	                    _react2.default.createElement('span', { className: 'bar' }),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'error' },
	                      this.state.email_err ? this.state.email_err : ''
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'advertise_group col-xs-3 col-lg-3 col-md-3' },
	                    _react2.default.createElement('input', { type: 'text', ref: 'phone', placeholder: 'Phone Number', maxLength: '10', value: this.state.mobile, onChange: this.mobileChange }),
	                    _react2.default.createElement('span', { className: 'bar' }),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'error' },
	                      this.state.phone_err ? this.state.phone_err : ''
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'advertise_group col-xs-3 col-lg-3 col-md-3' },
	                    _react2.default.createElement('input', { type: 'text', ref: 'company', placeholder: 'Company' }),
	                    _react2.default.createElement('span', { className: 'bar' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clr' },
	                '\xA0'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clr' },
	                '\xA0'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement('input', { type: 'submit', className: 'btn  advertise_submit', value: 'SUBMIT' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Modal,
	            { show: this.state.response, onHide: this.close },
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Body,
	              { style: { padding: '35px' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'advertise_msg' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  this.state.message
	                ),
	                _react2.default.createElement(
	                  'a',
	                  { onClick: this.close },
	                  'OK'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_WebFooter2.default, null)
	      );
	    }
	  }]);
	
	  return Web_Advertise;
	}(_react.Component);
	
	exports.default = Web_Advertise;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Deal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import ReactCountdownClock from 'react-countdown-clock';
	
	var Web_AllPromoOffers = function (_Component) {
		_inherits(Web_AllPromoOffers, _Component);
	
		function Web_AllPromoOffers(props) {
			_classCallCheck(this, Web_AllPromoOffers);
	
			var _this = _possibleConstructorReturn(this, (Web_AllPromoOffers.__proto__ || Object.getPrototypeOf(Web_AllPromoOffers)).call(this, props));
	
			_this.state = {
				loading: false,
				nodata: false,
				offers: [],
				seed_offers: [],
				product_offers: [],
				deals: []
			};
			_this.getOffers = _this.getOffers.bind(_this);
			return _this;
		}
	
		_createClass(Web_AllPromoOffers, [{
			key: 'getOffers',
			value: function getOffers() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', lat: '', long: '', device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'viewPromotedDeals',
					data: { req: data2 },
					dataType: 'json',
					success: function (data) {
						if (data.deals.length === 0) {
							this.setState({
								nodata: true,
								loading: true
							});
						} else {
							this.setState({
								nodata: false,
								loading: true,
								deals: data.deals
							});
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width < 800) {
					window.location.href = "/promotional_offers";
				}
				this.getOffers();
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = "Promotional Deals | AquaDeals";
				var deals = this.state.deals.map(function (deal, index) {
					return _react2.default.createElement(Deal, { key: index, data: deal });
				});
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'web_deals web_promo_deals_page' },
						this.state.loading ? _react2.default.createElement(
							'div',
							{ className: 'lgt_gry' },
							_react2.default.createElement(_WebHeaderInner2.default, null),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'pag_cntnt' },
								'\xA0'
							),
							_react2.default.createElement(
								'section',
								{ className: 'container dels_cntnt' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-3 col-lg-3' },
										_react2.default.createElement(
											'div',
											{ className: 'row del_lft' },
											_react2.default.createElement(
												'h5',
												{ className: 'fltr_title' },
												'Promotional Offers'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-md-9 del_rgt' },
										_react2.default.createElement(
											'div',
											{ className: 'del_rgt_blk' },
											_react2.default.createElement('div', { className: 'col-md-12' }),
											_react2.default.createElement('div', { className: 'clr' }),
											_react2.default.createElement(
												'div',
												{ className: 'row itm_lst' },
												this.state.nodata ? _react2.default.createElement(
													'div',
													{ className: 'webno_data' },
													_react2.default.createElement(
														'h3',
														null,
														'No Deals Available'
													),
													_react2.default.createElement(
														'p',
														null,
														'Need something here? ',
														_react2.default.createElement(
															_reactRouter.Link,
															{ to: "/web/customer_care" },
															'CONTACT US'
														),
														' now !'
													)
												) : deals.length > 0 ? _react2.default.createElement(
													'div',
													{ className: '' },
													deals
												) : _react2.default.createElement(
													'div',
													{ className: 'no_data' },
													_react2.default.createElement(
														'h3',
														null,
														'No Deals Available'
													),
													_react2.default.createElement(
														'p',
														null,
														'Need something here? ',
														_react2.default.createElement(
															_reactRouter.Link,
															{ to: '/web/customer_care' },
															'CONTACT US'
														),
														' now !'
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'clr' },
										'\xA0'
									)
								)
							),
							_react2.default.createElement('div', { className: 'clr' })
						) : _react2.default.createElement(
							'div',
							{ className: 'loading_sym' },
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/loading.gif', alt: 'Loading', role: 'presentation' }),
							' '
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_AllPromoOffers;
	}(_react.Component);
	
	exports.default = Web_AllPromoOffers;
	
	var Deal = exports.Deal = function (_Component2) {
		_inherits(Deal, _Component2);
	
		function Deal(props) {
			_classCallCheck(this, Deal);
	
			var _this2 = _possibleConstructorReturn(this, (Deal.__proto__ || Object.getPrototypeOf(Deal)).call(this, props));
	
			_this2.state = {
				data1: _this2.props.data,
				time: _this2.props.data.micro_time,
				seconds: Math.floor(_this2.props.data.micro_time / 1000 % 60),
				minutes: Math.floor(_this2.props.data.micro_time / 1000 / 60 % 60),
				hours: Math.floor(_this2.props.data.micro_time / (1000 * 60 * 60) % 24),
				days: Math.floor(_this2.props.data.micro_time / (1000 * 60 * 60 * 24))
			};
			_this2.tick_seconds = _this2.tick_seconds.bind(_this2);
			return _this2;
		}
	
		_createClass(Deal, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this3 = this;
	
				this.timerID_sec = setInterval(function () {
					return _this3.tick_seconds();
				}, 1000);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				clearInterval(this.timerID_sec);
			}
		}, {
			key: 'tick_seconds',
			value: function tick_seconds() {
				this.setState({
					time: this.state.time - 1,
					seconds: this.state.seconds - 1
				});
	
				if (this.state.seconds === 0) {
					this.setState({
						minutes: this.state.minutes - 1,
						seconds: 60
					});
					if (this.state.minutes < 0) {
						this.setState({
							minutes: 59,
							hours: this.state.hours - 1
						});
					}
					if (this.state.hours < 0) {
						if (this.state.days > 0) {
							this.setState({
								days: this.state.days - 1
							});
						}
					}
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var data = this.props.data;
				return _react2.default.createElement(
					'div',
					{ className: 'col-md-3 col-sm-6 ' },
					_react2.default.createElement(
						'div',
						{ className: 'prdt_blk' },
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ className: 'cursor', to: data.type === "seed" ? "/web/sdetails/" + data.sname + "/" + data.id : "/web/pdetails/" + data.url_dtype_name + "/" + data.url_cat_name + "/" + data.url_brand_name + "/" + data.url_product_name + "/" + data.pid + "/" + data.id },
								_react2.default.createElement(
									'div',
									null,
									data.type === "seed" ? _react2.default.createElement('img', { className: 'itm_img', src: data.img !== null && data.img !== '' ? data.img : 'https://aquadeals.in/admin/assets/icons/web_icons/noImage.png', alt: '', height: '112px' }) : _react2.default.createElement('img', { className: 'itm_img', src: data.img !== null && data.img !== '' ? data.img : 'https://aquadeals.in/admin/assets/icons/web_icons/noImage.png', alt: '', height: '112px' })
								),
								data.title ? _react2.default.createElement(
									'p',
									{ className: 'web_pro_item_title' },
									data.title
								) : _react2.default.createElement(
									'p',
									null,
									'\xA0'
								),
								data.brand !== null && data.brand !== "" ? _react2.default.createElement(
									'p',
									{ className: 'web_pro_item_brnd' },
									data.brand
								) : _react2.default.createElement(
									'p',
									null,
									'\xA0'
								),
								data.price ? _react2.default.createElement(
									'h4',
									{ className: 'pro_mrp' },
									'MRP \u20B9 ',
									data.price
								) : _react2.default.createElement(
									'h4',
									{ className: 'pro_mrp' },
									'\xA0'
								),
								data.deal_price ? _react2.default.createElement(
									'p',
									{ className: 'web_pro_item_offer' },
									'Promotional Offer :  \u20B9 ',
									data.deal_price,
									' '
								) : _react2.default.createElement(
									'p',
									{ className: 'web_pro_item_offer' },
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									{ className: 'web_promo_clock' },
									this.state.days > 0 ? _react2.default.createElement(
										'p',
										null,
										_react2.default.createElement(
											'span',
											{ className: 'promo_clk_num' },
											this.state.days
										),
										' ',
										_react2.default.createElement(
											'span',
											{ className: 'promo_clk_txt1' },
											this.state.days === 0 ? 'Days' : this.state.days > 1 ? 'Days' : 'Day'
										)
									) : _react2.default.createElement(
										'p',
										null,
										'\xA0'
									),
									_react2.default.createElement(
										'p',
										null,
										_react2.default.createElement(
											'span',
											{ className: 'promo_clk_num promo_hrs' },
											this.state.hours <= 9 ? 0 : '',
											this.state.hours
										),
										_react2.default.createElement(
											'span',
											{ className: 'promo_clk_txt' },
											' hrs'
										),
										_react2.default.createElement(
											'span',
											{ className: 'promo_clk_num' },
											' ',
											this.state.minutes <= 9 ? 0 : '',
											this.state.minutes
										),
										_react2.default.createElement(
											'span',
											{ className: 'promo_clk_txt' },
											' min'
										),
										_react2.default.createElement(
											'span',
											{ className: 'promo_clk_num' },
											' ',
											this.state.seconds
										),
										_react2.default.createElement(
											'span',
											{ className: 'promo_clk_txt' },
											' sec'
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Deal;
	}(_react.Component);

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WebdealBlocks = function (_Component) {
	  _inherits(WebdealBlocks, _Component);
	
	  function WebdealBlocks(props) {
	    _classCallCheck(this, WebdealBlocks);
	
	    var _this = _possibleConstructorReturn(this, (WebdealBlocks.__proto__ || Object.getPrototypeOf(WebdealBlocks)).call(this, props));
	
	    _this.state = {
	      deal_offers: [],
	      deal_details: [],
	      arrowImage: '',
	      dealoffer_name: '',
	      bgImage: '',
	      deal_bg_img: ''
	    };
	    _this.getStoreBlocks = _this.getStoreBlocks.bind(_this);
	    _this.getblockDetails = _this.getblockDetails.bind(_this);
	    _this.goNext = _this.goNext.bind(_this);
	    _this.goPrev = _this.goPrev.bind(_this);
	    return _this;
	  }
	
	  _createClass(WebdealBlocks, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getStoreBlocks();
	    }
	  }, {
	    key: 'getStoreBlocks',
	    value: function getStoreBlocks() {
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      var data1 = { from: 'desktop_web' };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'post',
	        url: baseUrl + 'getdealOffers',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            deal_offers: data.deal_offers
	          });
	          this.getblockDetails(data.deal_offers[0].id);
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'getblockDetails',
	    value: function getblockDetails(block_id) {
	      this.setState({
	        arrowImage: block_id
	      });
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      var data1 = { from: 'desktop_web', id: block_id };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getOfferDeals',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            deal_details: data.deal_blocks,
	            deal_bg_img: 'https://aquadeals.in/admin/assets/images/' + data.blck_img,
	            dealoffer_name: data.arrayname
	          });
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'goNext',
	    value: function goNext() {
	      if (this.swiper) this.swiper.slideNext();
	    }
	  }, {
	    key: 'goPrev',
	    value: function goPrev() {
	      if (this.swiper) this.swiper.slidePrev();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var params = {
	        paginationClickable: true,
	        spaceBetween: 30,
	        slidesPerView: 5.5
	      };
	      var mob_swipe_blocks = this.state.deal_offers.map(function (block, index) {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'swipe_blocks_list', onClick: function onClick() {
	              _this2.getblockDetails(block.id);
	            } },
	          block.img === '' ? '' : _react2.default.createElement('img', { className: 'web_sw_pic', src: 'https://aquadeals.in/admin/assets/images/' + block.img, alt: ' ' }),
	          _react2.default.createElement(
	            'p',
	            { className: 'block_name' },
	            block.type
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'block_arrow' },
	            this.state.arrowImage === block.id ? _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/' + block.arrow_img, alt: ' ' }) : ''
	          )
	        );
	      }.bind(this));
	      var swipe_all = '';
	      if (this.state.deal_details.length > 0) {
	        swipe_all = this.state.deal_details.map(function (block, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: block.pro_title === "View More" ? "swipe_dtls_content1" : "web_swipe_dtls_content" },
	            this.state.dealoffer_name === "Imported" ? _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/web/pdeals/' + block.url_dtype + '/' + block.url_name + '/' + block.id + '/' + block.type + '/' + block.pro_id },
	              block.image === '' ? '' : _react2.default.createElement(
	                'i',
	                { className: 'web_store_img' },
	                _react2.default.createElement('img', { className: 'web_sw_dtls_img', src: 'https://aquadeals.in/admin/assets/images/' + block.image, alt: ' ' })
	              ),
	              block.pro_title ? _react2.default.createElement(
	                'h5',
	                { className: 'web_dtls_name' },
	                block.pro_title
	              ) : _react2.default.createElement(
	                'h5',
	                { className: 'web_dtls_name' },
	                '\xA0'
	              ),
	              block.brand_name ? _react2.default.createElement(
	                'h6',
	                { className: 'web_sw_brand_name' },
	                block.brand_name
	              ) : _react2.default.createElement(
	                'h6',
	                { className: 'web_sw_brand_name' },
	                '\xA0'
	              ),
	              block.mrp ? _react2.default.createElement(
	                'p',
	                { className: 'web_sw_dtls_price' },
	                'MRP \u20B9 ',
	                block.mrp
	              ) : _react2.default.createElement(
	                'p',
	                { className: 'web_sw_brand_price' },
	                '\xA0'
	              )
	            ) : _react2.default.createElement(
	              'div',
	              null,
	              block.pro_title === "View More" ? _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/stores/' + block.url_name + '/' + block.id },
	                block.image === '' ? '' : _react2.default.createElement('img', { className: 'sw_dtls_img', src: 'https://aquadeals.in/admin/assets/images/' + block.image, alt: ' ' }),
	                _react2.default.createElement(
	                  'h5',
	                  { className: 'm_dtls_name organic_dtls_name' },
	                  block.pro_title
	                )
	              ) : _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/web/pdetails/' + block.url_dtype_name + '/' + block.url_cat_name + '/' + block.url_brand_name + '/' + block.url_product_name + '/' + block.pro_id + '/' + block.id },
	                block.image === '' ? '' : _react2.default.createElement(
	                  'i',
	                  { className: 'web_store_img' },
	                  _react2.default.createElement('img', { className: 'web_sw_dtls_img', src: 'https://aquadeals.in/admin/assets/images/' + block.image, alt: ' ' })
	                ),
	                block.pro_title ? _react2.default.createElement(
	                  'h5',
	                  { className: 'web_dtls_name' },
	                  block.pro_title
	                ) : _react2.default.createElement(
	                  'h5',
	                  { className: 'web_dtls_name' },
	                  '\xA0'
	                ),
	                block.brand_name ? _react2.default.createElement(
	                  'h6',
	                  { className: 'web_sw_brand_name' },
	                  block.brand_name
	                ) : _react2.default.createElement(
	                  'h6',
	                  { className: 'web_sw_brand_name' },
	                  '\xA0'
	                ),
	                block.mrp ? _react2.default.createElement(
	                  'p',
	                  { className: 'web_sw_dtls_price' },
	                  'MRP \u20B9 ',
	                  block.mrp
	                ) : _react2.default.createElement(
	                  'p',
	                  { className: 'web_sw_dtls_price' },
	                  '\xA0'
	                )
	              )
	            )
	          );
	        }.bind(this));
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'container', style: { marginTop: '10px', marginBottom: '10px', paddingTop: '10px', paddingBottom: '10px' } },
	        _react2.default.createElement(
	          'h2',
	          { className: 'cat_store_title' },
	          'Stores'
	        ),
	        _react2.default.createElement(
	          _reactIdSwiper2.default,
	          _extends({}, params, { key: mob_swipe_blocks.length }),
	          mob_swipe_blocks
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'web_swipe_imp_bg', style: { background: 'url(' + this.state.deal_bg_img + ')' } },
	          swipe_all.length > 0 ? _react2.default.createElement(
	            _reactIdSwiper2.default,
	            _extends({}, params, { key: swipe_all.length }),
	            swipe_all
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return WebdealBlocks;
	}(_react.Component);
	
	exports.default = WebdealBlocks;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(36);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import {connect} from 'react-redux';
	
	
	// import $ from 'jquery';
	var Web_EnquireNow_Partner = function (_Component) {
		_inherits(Web_EnquireNow_Partner, _Component);
	
		function Web_EnquireNow_Partner(props) {
			_classCallCheck(this, Web_EnquireNow_Partner);
	
			var _this = _possibleConstructorReturn(this, (Web_EnquireNow_Partner.__proto__ || Object.getPrototypeOf(Web_EnquireNow_Partner)).call(this, props));
	
			_this.state = {
				ltype: _this.props.params.Ltype,
				sid: _this.props.params.Sid,
				did: _this.props.params.Did,
				showModal: false,
				stype: 0,
				rtype: 0,
				textarea_msg: '',
				comp_name: '',
				email_fld: '',
				stype_status: false,
				stype1: false,
				rtype1: false,
				rtype_status: false,
				user_mob_num: '',
				user_name: '',
				message: ''
			};
			_this.modalOpen = _this.modalOpen.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.closeModal = _this.closeModal.bind(_this);
			_this.getCat = _this.getCat.bind(_this);
			_this.txtAreaChange = _this.txtAreaChange.bind(_this);
			_this.getCompName = _this.getCompName.bind(_this);
			_this.getEmail = _this.getEmail.bind(_this);
			_this.validateData = _this.validateData.bind(_this);
			_this.getDeviceId = _this.getDeviceId.bind(_this);
			_this.getRole = _this.getRole.bind(_this);
			_this.getUserDetails = _this.getUserDetails.bind(_this);
			_this.saveLead = _this.saveLead.bind(_this);
			return _this;
		}
	
		_createClass(Web_EnquireNow_Partner, [{
			key: 'getEmail',
			value: function getEmail(event) {
				event.preventDefault();
				this.setState({
					email_fld: this.refs.email_ref_fld.value
				});
			}
		}, {
			key: 'getCat',
			value: function getCat(x) {
				var _this2 = this;
	
				this.setState({
					stype: x,
					stype_status: true
					// stype1:false,
				}, function () {
					console.log(_this2.state.stype);
				});
			}
		}, {
			key: 'validateData',
			value: function validateData(event) {
				event.preventDefault();
				// this.setState({
				// 	stype1 : true,
				// 	rtype1: true,
				// });
				if (this.state.stype1 === false) {
					this.setState({
						stype1: true
					});
				}
				if (this.state.rtype1 === false) {
					this.setState({
						rtype1: true
					});
				}
			}
		}, {
			key: 'txtAreaChange',
			value: function txtAreaChange(event) {
				event.preventDefault();
				this.setState({
					textarea_msg: this.refs.txtAreaMsg.value
				});
			}
		}, {
			key: 'modalOpen',
			value: function modalOpen() {
				this.setState({
					showModal: true
				});
			}
		}, {
			key: 'closeModal',
			value: function closeModal() {
				this.setState({
					showModal: false
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					showModal: false
				});
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(newProps) {
				// if (newProps.leads === 1 || newProps.leads.status === 'success') 
				// {
				//   this.setState({showModal: true});
				// }
	
				// this.setState({showModal: false});
	
			}
		}, {
			key: 'getRole',
			value: function getRole(x) {
				var _this3 = this;
	
				// alert(x);
				this.setState({
					rtype: x,
					rtype_status: true
					// rtype1: false,
				}, function () {
					console.log(_this3.state.rtype);
				});
				// console.log(this.state.cat);
			}
		}, {
			key: 'handleFormSubmit',
			value: function handleFormSubmit(formProps) {
				// console.log(this.state.ltype);
				if (this.state.stype === 0) {
					this.setState({
						stype_status: true
					});
				} else {
					this.setState({
						stype_status: false
					});
				}
				if (this.state.rtype === 0) {
					this.setState({
						rtype_status: true
					});
				} else {
					this.setState({
						rtype_status: false
					});
				}
				if (this.state.ltype === "seed") {
					this.props.saveseed_lead(formProps, this.state.sid, this.state.did);
				}
				if (this.state.ltype === "feed") {
					this.props.savefeed_lead(formProps, this.state.sid, this.state.did);
				}
				if (this.state.ltype === "seller") {
					this.props.track_seller_lead(formProps, this.state.user_mob_num, this.state.user_name, this.state.sid, this.state.did, this.state.stype, this.state.rtype, this.state.textarea_msg);
					//this.props.track_seller_lead(formProps,this.state.sid,this.state.did);	
				}
				if (this.state.ltype === "nodata") {
					this.props.track_user_lead(formProps, this.state.sid, this.state.did);
				} else {
					// var frm='desktop_web';
					// this.props.track_seller_lead(formProps,frm,this.state.user_mob_num,this.state.user_name,this.state.sid,this.state.did,this.state.stype,this.state.rtype,this.state.textarea_msg);
					this.saveLead(this.state.user_mob_num, this.state.user_name, this.state.sid, this.state.did, this.state.stype, this.state.rtype, this.state.textarea_msg, this.state.email_fld, this.state.comp_name);
				}
			}
		}, {
			key: 'saveLead',
			value: function saveLead(user_mobile, user_name, seller_id, deal_id, stype, role, message, email, company_name) {
				var id = '';
				if (localStorage.user_id) {
					id = localStorage.user_id;
				} else {
					id = localStorage.ip;
				}
				var token = '';
				if (localStorage.token) {
					token = localStorage.token;
				} else {
					token = 0;
				}
	
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'desktop_web', 'id': id, 'token': token, 'name': user_name, 'mobile': user_mobile, 'email': email, 'cname': company_name, 'stype': stype, 'role': role, 'message': message, 'seller_id': seller_id, 'deal_id': deal_id, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'trackSellerLead',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								showModal: true,
								message: data.message
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getDeviceId',
			value: function getDeviceId() {
				if (localStorage.user_id) {
					var user_id = localStorage.user_id;
				} else {
					user_id = 0;
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'desktop_web', id: user_id, device_id: localStorage.getItem('push_device_id'), source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getDeviceId',
					dataType: 'json',
					data: { req: data2 },
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				if (screen.width < 800) {
					window.location.href = "/enquire_now/partner/support/sid/did";
				}
				this.refs.comp_ref_name.focus();
				this.getDeviceId();
	
				if (!localStorage.token && !localStorage.user_id) {
					localStorage.setItem('w_r_enq_seller_page', '/web/enquire_now/partner/support/sid/did');
					localStorage.removeItem('w_r_s_dt');
					localStorage.removeItem('w_r_e_coupon_dt');
					localStorage.removeItem('w_r_e_s_dt');
					localStorage.removeItem('web_mycart');
	
					localStorage.removeItem('w_r_p_dt');
					localStorage.removeItem('w_r_e_p_dt');
					localStorage.removeItem('web_ofr_page');
					localStorage.removeItem('profile');
					localStorage.removeItem('myaquacash');
					localStorage.removeItem('web_share_earn');
					localStorage.removeItem('checkout');
					localStorage.removeItem('order_details');
					localStorage.removeItem('myorders');
					localStorage.removeItem('w_r_p_deals');
					localStorage.removeItem('seed');
					localStorage.removeItem('nauplii');
					localStorage.removeItem('subdeals');
					localStorage.removeItem('shipping');
					localStorage.removeItem('notifications');
					localStorage.removeItem('web_quickcart');
					localStorage.removeItem('view_rating');
					localStorage.removeItem('w_modal_seed');
					localStorage.removeItem('w_r_seed_deals');
					localStorage.removeItem('w_r_e_p_dt');
					localStorage.removeItem('w_modal_details');
					localStorage.removeItem('offers');
					localStorage.removeItem('give_rating');
					localStorage.removeItem('pprice');
					localStorage.removeItem('sprice');
					localStorage.removeItem('seed_id');
					localStorage.removeItem('h_type');
					localStorage.removeItem('web_pro_ofr_dtls');
					localStorage.removeItem('web_wishlist');
					localStorage.removeItem('web_brand_details');
	
					localStorage.removeItem('m_r_s_dt');
					localStorage.removeItem('m_r_e_coupon_dt');
					localStorage.removeItem('m_r_e_s_dt');
					localStorage.removeItem('mob_mycart');
					localStorage.removeItem('m_r_enq_seller_page');
					localStorage.removeItem('m_r_p_dt');
					localStorage.removeItem('m_r_e_p_dt');
					localStorage.removeItem('ofr_page');
					localStorage.removeItem('pro_ofr_dtls');
	
					localStorage.removeItem('share_earn');
					localStorage.removeItem('my_orders');
					localStorage.removeItem('m_r_p_deals');
					localStorage.removeItem('mob_quickcart');
					localStorage.removeItem('partner_deals');
	
					_reactRouter.browserHistory.push('/web/login');
				} else {
					this.getUserDetails();
				}
			}
		}, {
			key: 'getUserDetails',
			value: function getUserDetails() {
				if (localStorage.user_id) {
					var user_id = localStorage.getItem('user_id');
				} else {
					user_id = 0;
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'desktop_web', uid: user_id, token: localStorage.getItem('token'), device_id: localStorage.getItem('push_device_id'), source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'myprofile',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							user_mob_num: data.details[0].mobile,
							user_name: data.details[0].name
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getCompName',
			value: function getCompName(event) {
				event.preventDefault();
				this.setState({
					comp_name: this.refs.comp_ref_name.value
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				document.title = "Register as Partner with AquaDeals";
				// var redirect = '/web/customer_care_seller';
	
				var _props = this.props,
				    handleSubmit = _props.handleSubmit,
				    _props$fields = _props.fields,
				    name = _props$fields.name,
				    number = _props$fields.number,
				    email = _props$fields.email,
				    company_name = _props$fields.company_name,
				    comment = _props$fields.comment;
	
				return _react2.default.createElement(
					'div',
					{ className: 'lgt_gry web_deals web_enquire_page web_req_ptr_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12 del_rgt' },
								_react2.default.createElement(
									'div',
									{ className: 'del_rgt_blk' },
									_react2.default.createElement('div', { className: 'col-md-12' }),
									_react2.default.createElement('div', { className: 'clr' }),
									_react2.default.createElement(
										'div',
										{ className: 'customer_care' },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-6 col-md-offset-3' },
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											),
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											),
											_react2.default.createElement(
												'div',
												{ className: 'thumbnail' },
												_react2.default.createElement(
													'div',
													{ className: 'enquire_form' },
													_react2.default.createElement(
														'div',
														{ className: 'parnter_logo_img' },
														_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/partner_support.png', alt: ' ' })
													),
													_react2.default.createElement(
														'div',
														{ style: { paddingTop: '8px' } },
														_react2.default.createElement(
															'h5',
															null,
															'Personal Details'
														)
													),
													_react2.default.createElement(
														'form',
														{ className: 'mtrl_elmnts2 req_ptr_form', onSubmit: this.state.stype === 0 || this.state.rtype === 0 ? this.validateData : handleSubmit(this.handleFormSubmit.bind(this)), style: { marginTop: '15px' } },
														_react2.default.createElement(
															'div',
															{ className: 'group' },
															_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cell_dl_blue.png', alt: '', className: 'req_ptr_lft_icon' }),
															_react2.default.createElement('input', _extends({}, number, { value: this.state.user_mob_num, placeholder: 'Mobile Number', type: 'text', maxLength: 10, required: true })),
															_react2.default.createElement('span', { className: 'highlight' }),
															_react2.default.createElement('span', { className: 'bar' })
														),
														_react2.default.createElement(
															'div',
															{ className: 'group' },
															_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/user_blue.png', alt: '', className: 'req_ptr_lft_icon' }),
															_react2.default.createElement('input', _extends({}, name, { value: this.state.user_name, placeholder: 'Name', type: 'text', required: true })),
															_react2.default.createElement('span', { className: 'highlight' }),
															_react2.default.createElement('span', { className: 'bar' })
														),
														_react2.default.createElement(
															'div',
															{ className: 'group' },
															_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/building_blue.png', alt: '', className: 'req_ptr_lft_icon' }),
															_react2.default.createElement('input', _extends({}, company_name, { placeholder: 'Company/Firm Name', type: 'text', required: true, value: this.state.comp_name, onChange: this.getCompName, ref: 'comp_ref_name' })),
															_react2.default.createElement('span', { className: 'highlight' }),
															_react2.default.createElement('span', { className: 'bar' }),
															_react2.default.createElement(
																'span',
																{ style: { color: 'red', fontSize: '11px' } },
																company_name.touched && company_name.error && _react2.default.createElement(
																	'div',
																	{ className: 'text-danger' },
																	company_name.error
																)
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'group' },
															_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/email_dl_blue.png', alt: '', className: 'req_ptr_lft_icon' }),
															_react2.default.createElement('input', _extends({}, email, { required: true, placeholder: 'Email', type: 'text', ref: 'email_ref_fld', value: this.state.email_fld, onChange: this.getEmail })),
															_react2.default.createElement('span', { className: 'highlight' }),
															_react2.default.createElement('span', { className: 'bar' }),
															_react2.default.createElement(
																'span',
																null,
																_react2.default.createElement(
																	'div',
																	{ className: 'req_ptr_err' },
																	email.error ? email.error : ''
																)
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'new_role_blk' },
															_react2.default.createElement(
																'h5',
																null,
																'My Role'
															),
															_react2.default.createElement(
																_reactBootstrap.FormGroup,
																null,
																_react2.default.createElement(
																	_reactBootstrap.Radio,
																	{ name: 'radioGroup', className: this.state.rtype === 1 ? 'role_active' : 'role_inactive', required: true, inline: true, onChange: function onChange() {
																			_this4.getRole(1);
																		} },
																	'Hatchery owner'
																),
																_react2.default.createElement(
																	_reactBootstrap.Radio,
																	{ name: 'radioGroup', className: this.state.rtype === 2 ? 'role_active' : 'role_inactive', required: true, inline: true, onChange: function onChange() {
																			_this4.getRole(2);
																		} },
																	'Manufacturer/Importer'
																),
																_react2.default.createElement(
																	_reactBootstrap.Radio,
																	{ name: 'radioGroup', className: this.state.rtype === 3 ? 'role_active' : 'role_inactive', required: true, inline: true, onChange: function onChange() {
																			_this4.getRole(3);
																		} },
																	'Dealer'
																)
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'new_role_blk' },
															_react2.default.createElement(
																'h5',
																null,
																'Categories'
															),
															_react2.default.createElement(
																_reactBootstrap.FormGroup,
																null,
																_react2.default.createElement(
																	_reactBootstrap.Radio,
																	{ name: 'radioGroup1', className: this.state.stype === 1 ? 'role_active' : 'role_inactive', required: true, inline: true, onChange: function onChange() {
																			_this4.getCat(1);
																		} },
																	'Seed/Nauplii'
																),
																_react2.default.createElement(
																	_reactBootstrap.Radio,
																	{ name: 'radioGroup1', className: this.state.stype === 2 ? 'role_active' : 'role_inactive', required: true, inline: true, onChange: function onChange() {
																			_this4.getCat(2);
																		} },
																	'Feed/Health care'
																),
																_react2.default.createElement(
																	_reactBootstrap.Radio,
																	{ name: 'radioGroup1', className: this.state.stype === 3 ? 'role_active' : 'role_inactive', required: true, inline: true, onChange: function onChange() {
																			_this4.getCat(3);
																		} },
																	'Aerators/Machinery'
																)
															)
														),
														_react2.default.createElement(
															'div',
															{ className: '' },
															_react2.default.createElement(
																'h5',
																{ style: { paddingTop: '12px', paddingBottom: '10px' } },
																'Message ',
																_react2.default.createElement(
																	'span',
																	null,
																	comment.touched && comment.error && _react2.default.createElement(
																		'span',
																		{ className: 'text-msg_danger' },
																		'* ',
																		comment.error
																	)
																)
															),
															_react2.default.createElement('textarea', _extends({}, comment, { required: true, placeholder: "I am interested to sell my products in Aqua deals partnership program,. I would like to know some more details. Looking forward for your reply.", rows: 5, style: { width: '100%', fontSize: '13px' }, value: this.state.textarea_msg, onChange: this.txtAreaChange, ref: 'txtAreaMsg' }))
														),
														_react2.default.createElement(
															'div',
															{ style: { textAlign: 'center', background: '#fff', margin: '10px 0 5px 0' } },
															_react2.default.createElement(
																'button',
																{ action: 'submit', className: 'partner_req_sub_btn' },
																'REQUEST CALL BACK'
															)
														),
														_react2.default.createElement(
															'div',
															{ className: 'parner_bot_img' },
															_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/ad_partner_logo.png', alt: '' })
														)
													)
												)
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ backdrop: 'static', className: 'showModal modal fade', show: this.state.showModal, style: { zIndex: '1111' }, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ style: { borderBottom: 'none' } },
							_react2.default.createElement(_reactBootstrap.Modal.Title, { style: { fontSize: '16px', color: '#333' } })
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { textAlign: 'center', fontSize: '14px', color: '#666' } },
								this.state.message
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer', style: { borderTop: 'none', textAlign: 'center' } },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: "/web/customer_care_seller" },
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: '#ff742a none repeat scroll 0 0', color: '#fff' } },
									'OK'
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_EnquireNow_Partner;
	}(_react.Component);
	
	function validate(formProps) {
		var errors = {};
		var namePattern = /^[a-zA-Z0-9\x20]{3,25}/;
	
		// if(!formProps.name){
		//   errors.name = "Enter your name";
		// }
		// else if(formProps.name && !namePattern.test(formProps.name)){
		// 		errors.name = 'Enter minimum 3 characters';
		// }
	
		/* if(!formProps.company_name){
	 	errors.company_name="Please enter your company Name";
	 }
	 */
	
		if (formProps.company_name && !namePattern.test(formProps.company_name)) {
			errors.company_name = 'Enter minimum 3 characters';
		}
		if (formProps.comment && !namePattern.test(formProps.comment)) {
			errors.comment = 'Enter minimum 3 characters';
		}
	
		// const invalidChars = /[^0-9]/gi;
		// if(formProps.number && invalidChars.test(formProps.number)){
		// 	errors.number="invalid mobile number";
		// }
	
		// const number_check = /^[0-9]{10}$/;  
		// if(formProps.number && !number_check.test(formProps.number)){
		// 	errors.number="Mobile number must contains 10 numbers only";
		// }
	
		// if(!formProps.number){
		// 	errors.number="Enter Mobile Number";
		// }
	
	
		var emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
		if (formProps.email && !emailPattern.test(formProps.email)) {
			errors.email = 'Enter a valid email';
		}
		// if(!formProps.email)
		// {
		//   errors.email = "Enter your email";
		// }
	
	
		// const emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
		//   if (!emailPattern.test(formProps.email)) {
		//     errors.email = 'Enter a valid email';
		//   }
	
		return errors;
	}
	
	function mapStateToProps(state) {
		return {
			leads: state.posts.leads
		};
	}
	
	exports.default = (0, _reduxForm.reduxForm)({
		form: 'Enquiry',
		fields: ['name', 'number', 'email', 'company_name', 'comment'],
		validate: validate
	
	}, mapStateToProps, actions)(Web_EnquireNow_Partner);

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Link, browserHistory } from 'react-router';
	
	
	var Web_PromoOfr_Details = function (_Component) {
		_inherits(Web_PromoOfr_Details, _Component);
	
		function Web_PromoOfr_Details(props) {
			_classCallCheck(this, Web_PromoOfr_Details);
	
			var _this = _possibleConstructorReturn(this, (Web_PromoOfr_Details.__proto__ || Object.getPrototypeOf(Web_PromoOfr_Details)).call(this, props));
	
			_this.state = {
				title: '',
				description: '',
				terms: '',
				enddate: '',
				discount_type: '',
				image: '',
				details: [],
				share_title: '',
				share_desc: '',
				share_panel_open: false,
				page_error: false
			};
			return _this;
		}
	
		_createClass(Web_PromoOfr_Details, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
	
				if (screen.width < 800) {
					window.location.href = '/offer/' + this.props.params.Oid + '/details';
				}
				// if(!localStorage.token && !localStorage.user_id)
				// {
				// 	localStorage.setItem('web_pro_ofr_dtls','/web/offer/'+this.props.params.Oid+"/details");
				// 	browserHistory.push('/web/login');
				// }
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), ofr_id: this.props.params.Oid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + "get_promo_ofr",
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						var details = _jquery2.default.makeArray(data.data);
						this.setState({
							details: details,
							title: details[0].title,
							image: details[0].image,
							description: details[0].description,
							terms: details[0].terms,
							enddate: details[0].endDate,
							discount_type: details[0].discount_type,
							share_panel_open: false
						});
						if (data.status === 'error') {
							this.setState({
								page_error: true
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				(0, _jquery2.default)(window).scrollTop(10);
				document.title = this.state.title ? this.state.title + ' | AquaDeals' : 'Offer Details | AquaDeals';
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_ofr_full_details_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12  web_dels_cntnt' },
								this.state.page_error === false ? _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement('div', { className: 'container-fluid', style: { marginTop: '25px' } }),
									_react2.default.createElement(
										'section',
										{ className: 'container-fluid row' },
										_react2.default.createElement(
											'div',
											{ className: 'lst_img1 col-md-4 col-lg-4 col-sm-4 col-xs-4' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/promo_offers/' + this.state.image, alt: '' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-8 col-lg-8 col-sm-8 col-xs-8' },
											_react2.default.createElement(
												'div',
												{ className: '' },
												_react2.default.createElement(
													'h4',
													{ className: 'web_ofr_title' },
													this.state.title
												),
												_react2.default.createElement(
													'table',
													{ className: 'table web_ofr_dtls_table' },
													_react2.default.createElement(
														'tr',
														null,
														_react2.default.createElement(
															'th',
															null,
															'Applicable On'
														),
														_react2.default.createElement(
															'th',
															null,
															'Offer valid till'
														)
													),
													_react2.default.createElement(
														'tr',
														null,
														_react2.default.createElement(
															'td',
															null,
															this.state.discount_type
														),
														_react2.default.createElement(
															'td',
															null,
															this.state.enddate !== '' ? this.state.enddate : 'Limited period offer'
														)
													)
												)
											),
											_react2.default.createElement(
												'section',
												{ className: 'container-fluid' },
												_react2.default.createElement(
													'h5',
													{ className: 'web_ofr_hd' },
													'Description'
												),
												_react2.default.createElement(
													'p',
													{ className: 'web_ofr_desc' },
													this.state.description
												)
											),
											_react2.default.createElement(
												'section',
												{ className: 'container-fluid webofr_blk' },
												_react2.default.createElement(
													'h5',
													{ className: 'web_ofr_hd' },
													'Terms & Conditions'
												),
												_react2.default.createElement('div', { className: 'web_modal_ofr_terms', dangerouslySetInnerHTML: { __html: this.state.terms } })
											)
										)
									)
								) : _react2.default.createElement(
									'div',
									{ className: 'web_no_data' },
									'No Offer Details Available'
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_PromoOfr_Details;
	}(_react.Component);
	
	exports.default = Web_PromoOfr_Details;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactShare = __webpack_require__(18);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import Footer from './Footer.js';
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	
	var Web_ShareEarn = function (_Component) {
		_inherits(Web_ShareEarn, _Component);
	
		function Web_ShareEarn(props) {
			_classCallCheck(this, Web_ShareEarn);
	
			var _this = _possibleConstructorReturn(this, (Web_ShareEarn.__proto__ || Object.getPrototypeOf(Web_ShareEarn)).call(this, props));
	
			_this.state = {
				balance: 0,
				code: '',
				refferal_cash: 0,
				frnd_cash: 0,
				tot_amt: 0,
				image: '',
				status: '',
	
				open: true,
				open2: true,
				shareUrl: '',
				msg: '',
				url: ''
			};
			_this.getShareDetails = _this.getShareDetails.bind(_this);
			_this.shareEarn = _this.shareEarn.bind(_this);
			return _this;
		}
	
		_createClass(Web_ShareEarn, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
	
				localStorage.removeItem('checkout');
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
				localStorage.removeItem('web_quickcart');
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
				localStorage.removeItem('web_brand_details');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
	
				if (screen.width < 800) {
					window.location.href = "/share_earn";
				}
				// localStorage.setItem('web_share_earn','/web/share_earn');
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('web_share_earn', '/web/share_earn');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					this.getShareDetails();
					this.shareEarn();
				}
			}
		}, {
			key: 'shareEarn',
			value: function shareEarn() {
				this.setState({
					open: !this.state.open
				});
	
				var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + 'shareAppurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							msg: data.share_data,
							url: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getShareDetails',
			value: function getShareDetails() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + 'referAndEarn',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							balance: data.balance,
							code: data.code,
							refferal_cash: data.refferal_cash,
							frnd_cash: data.frnd_cash,
							tot_amt: data.tot_amt,
							image: data.image,
							status: data.status
						});
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = "Share & Earn | AquaDeals";
				var msg = this.state.msg;
				var url = this.state.url;
				// var sh_url=this.state.msg;
				var description = this.state.msg;
				if (this.state.msg !== '') {
					var title = this.state.msg;
				} else {
					// title="Hey! Use my code "+code+ "to signup and get Rs2000 AquaCash. Click https:\/\/goo.gl\/gvP4pb to download the AquaDeals Android app";
					title = msg;
				}
				return _react2.default.createElement(
					'div',
					{ className: 'web_Deals web_share_earnpage' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'row container', style: { marginLeft: 0 } },
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb,
								{ className: 'webshareEarn_breadcrumb' },
								_react2.default.createElement(
									_reactBootstrap.Breadcrumb.Item,
									{ href: '/web/home' },
									'Home'
								),
								_react2.default.createElement(
									_reactBootstrap.Breadcrumb.Item,
									{ active: true },
									'Share & Earn'
								)
							),
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/promo_offers/share_earn_bg.png', alt: 'Share and Earn', width: "100%" })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row ref_earn_code_blk' },
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-4 col-md-4 col-sm-4 col-sm-offset-1 col-md-offset-1 text-center' },
									_react2.default.createElement(
										'h2',
										{ className: 'referral_earning' },
										' \u20B9',
										this.state.tot_amt
									),
									_react2.default.createElement(
										'h4',
										null,
										'Total referral earnings'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-4 col-md-4 col-sm-4 col-sm-offset-2 col-md-offset-2 text-center' },
									_react2.default.createElement(
										'h2',
										{ className: 'referral_code' },
										this.state.code
									),
									_react2.default.createElement(
										'h4',
										null,
										'Your referral code'
									)
								),
								_react2.default.createElement('div', { className: 'col-lg-3 col-md-3 col-sm-3 col-sm-offset-2 col-md-offset-3' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'row share_invite_blk' },
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-3 col-md-3 col-sm-3' },
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-6 col-md-6 col-sm-6' },
									_react2.default.createElement(
										'div',
										{ style: { clear: 'both' } },
										_react2.default.createElement(
											'h4',
											{ className: 'web_share_invite_msg' },
											'Share and invite your friends'
										),
										_react2.default.createElement(
											_reactBootstrap.Panel,
											{ className: 'web_share_earn_panel text-center', id: 'web_share_earn_panel', collapsible: true, expanded: this.state.open2 },
											_react2.default.createElement(
												FacebookShareButton,
												{ url: url, title: title, className: 'web_test_earn_share outline' },
												_react2.default.createElement(FacebookIcon, { size: 50, round: true })
											),
											_react2.default.createElement(
												TwitterShareButton,
												{ url: url, title: title, description: description, className: 'web_test_earn_share outline' },
												_react2.default.createElement(TwitterIcon, { size: 50, round: true })
											),
											_react2.default.createElement(
												GooglePlusShareButton,
												{ url: url, title: title, descirption: description, className: 'web_test_earn_share outline' },
												_react2.default.createElement(GooglePlusIcon, { size: 50, round: true })
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-3 col-md-3 col-sm-3' },
									'\xA0'
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_ShareEarn;
	}(_react.Component);
	
	exports.default = Web_ShareEarn;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {Modal} from 'react-bootstrap';
	
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	// const baseAssets='https://aquadeals.in/admin/assets/';
	
	var Web_Site_Map = function (_Component) {
			_inherits(Web_Site_Map, _Component);
	
			function Web_Site_Map(props) {
					_classCallCheck(this, Web_Site_Map);
	
					var _this = _possibleConstructorReturn(this, (Web_Site_Map.__proto__ || Object.getPrototypeOf(Web_Site_Map)).call(this, props));
	
					_this.state = {};
					return _this;
			}
	
			_createClass(Web_Site_Map, [{
					key: 'render',
					value: function render() {
	
							document.title = "AquaDeals - Online AquaCulture MarketPlace, Find best deals on Seed, Feed, Health Care, Machinery & Farm Equipments, Products, Ropes & Nets Paddle Wheels and More | AquaDeals";
							document.getElementsByTagName("META")[2].content = "It is a place for deals related to Aqua culture";
							return _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(_WebHeaderInner2.default, null),
									_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
									),
									_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
									),
									_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
									),
									_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
									),
									_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
									),
									_react2.default.createElement(
											'div',
											{ className: 'full_wt_clr_bg' },
											_react2.default.createElement(
													'div',
													{ className: 'container web_advertise_page' },
													_react2.default.createElement(
															'div',
															{ className: 'row' },
															_react2.default.createElement(
																	'div',
																	{ className: 'clr' },
																	'\xA0'
															),
															_react2.default.createElement(
																	'div',
																	{ className: 'clr' },
																	'\xA0'
															),
															_react2.default.createElement(
																	'div',
																	{ style: { textAlign: 'center' } },
																	_react2.default.createElement(
																			'h1',
																			null,
																			'Checkout Flow'
																	),
																	_react2.default.createElement('br', null),
																	_react2.default.createElement(
																			'div',
																			null,
																			_react2.default.createElement('img', { src: __webpack_require__(645) })
																	)
															)
													)
											)
									),
									_react2.default.createElement(_WebFooter2.default, null)
							);
					}
			}]);
	
			return Web_Site_Map;
	}(_react.Component);
	
	exports.default = Web_Site_Map;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	__webpack_require__(625);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import {Modal} from 'react-bootstrap';
	
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	// const baseAssets='https://aquadeals.in/admin/assets/';
	
	var Web_Site_Map = function (_Component) {
	  _inherits(Web_Site_Map, _Component);
	
	  function Web_Site_Map(props) {
	    _classCallCheck(this, Web_Site_Map);
	
	    var _this = _possibleConstructorReturn(this, (Web_Site_Map.__proto__ || Object.getPrototypeOf(Web_Site_Map)).call(this, props));
	
	    _this.state = {
	      todos: [],
	      isLoaded: false
	    };
	    return _this;
	  }
	
	  _createClass(Web_Site_Map, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _jquery2.default.ajax({
	        url: baseUrl + "web_site_map",
	        dataType: "json",
	        success: function (data) {
	          this.setState({
	            todos: data
	          });
	        }.bind(this)
	
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var categories = _jquery2.default.makeArray(this.state.todos.products);
	
	      var categories_list = categories.map(function (list, index) {
	        return _react2.default.createElement(
	          'li',
	          { key: index },
	          _react2.default.createElement(
	            'h1',
	            { className: 'list_hdg' },
	            list.cname
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'list_blk' },
	            list.scat.map(function (sclist, index1) {
	              return _react2.default.createElement(
	                'li',
	                { key: index1 },
	                _react2.default.createElement(
	                  'a',
	                  { href: sclist.sclink },
	                  sclist.scname
	                )
	              );
	            })
	          )
	        );
	      });
	      document.title = "AquaDeals - Online AquaCulture MarketPlace, Find best deals on Seed, Feed, Health Care, Machinery & Farm Equipments, Products, Ropes & Nets Paddle Wheels and More | AquaDeals";
	      document.getElementsByTagName("META")[2].content = "It is a place for deals related to Aqua culture";
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_WebHeaderInner2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container web_advertise_page' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { align: 'center' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'st_mp_hdg' },
	                'Catalogue'
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'myclass' },
	                categories_list
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_WebFooter2.default, null)
	      );
	    }
	  }]);
	
	  return Web_Site_Map;
	}(_react.Component);
	
	exports.default = Web_Site_Map;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Web_CustomerCare = function (_Component) {
	  _inherits(Web_CustomerCare, _Component);
	
	  function Web_CustomerCare(props) {
	    _classCallCheck(this, Web_CustomerCare);
	
	    var _this = _possibleConstructorReturn(this, (Web_CustomerCare.__proto__ || Object.getPrototypeOf(Web_CustomerCare)).call(this, props));
	
	    _this.state = {
	      email: '',
	      mobiles: '',
	      timings: '',
	      advertiser_email: '',
	      advertiser_mobile: ''
	    };
	    return _this;
	  }
	
	  _createClass(Web_CustomerCare, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	      localStorage.removeItem('w_r_s_dt');
	      localStorage.removeItem('w_r_e_coupon_dt');
	      localStorage.removeItem('w_r_e_s_dt');
	      localStorage.removeItem('web_mycart');
	      localStorage.removeItem('w_r_enq_seller_page');
	      localStorage.removeItem('w_r_p_dt');
	      localStorage.removeItem('w_r_e_p_dt');
	      localStorage.removeItem('web_ofr_page');
	      localStorage.removeItem('profile');
	      localStorage.removeItem('myaquacash');
	      localStorage.removeItem('web_share_earn');
	      localStorage.removeItem('checkout');
	      localStorage.removeItem('order_details');
	
	      localStorage.removeItem('w_r_p_deals');
	      localStorage.removeItem('seed');
	      localStorage.removeItem('nauplii');
	      localStorage.removeItem('subdeals');
	      localStorage.removeItem('shipping');
	      localStorage.removeItem('notifications');
	      localStorage.removeItem('web_quickcart');
	      localStorage.removeItem('view_rating');
	      localStorage.removeItem('w_modal_seed');
	      localStorage.removeItem('w_r_seed_deals');
	      localStorage.removeItem('w_r_e_p_dt');
	      localStorage.removeItem('w_modal_details');
	      localStorage.removeItem('offers');
	      localStorage.removeItem('give_rating');
	      localStorage.removeItem('pprice');
	      localStorage.removeItem('sprice');
	      localStorage.removeItem('seed_id');
	      localStorage.removeItem('h_type');
	      localStorage.removeItem('web_pro_ofr_dtls');
	      localStorage.removeItem('web_wishlist');
	      localStorage.removeItem('web_brand_details');
	
	      localStorage.removeItem('m_r_s_dt');
	      localStorage.removeItem('m_r_e_coupon_dt');
	      localStorage.removeItem('m_r_e_s_dt');
	      localStorage.removeItem('mob_mycart');
	      localStorage.removeItem('m_r_enq_seller_page');
	      localStorage.removeItem('m_r_p_dt');
	      localStorage.removeItem('m_r_e_p_dt');
	      localStorage.removeItem('ofr_page');
	      localStorage.removeItem('pro_ofr_dtls');
	
	      localStorage.removeItem('share_earn');
	      localStorage.removeItem('my_orders');
	      localStorage.removeItem('m_r_p_deals');
	      localStorage.removeItem('mob_quickcart');
	      localStorage.removeItem('partner_deals');
	
	      localStorage.removeItem('type');
	      localStorage.removeItem('web_cat_sort');
	      localStorage.removeItem('d_type');
	      localStorage.removeItem('Tid');
	
	      if (screen.width < 800) {
	        window.location.href = "/customer_care";
	      }
	      if (localStorage.user_id) {
	        var uid = localStorage.getItem('user_id');
	      } else {
	        uid = 0;
	      }
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      var data1 = { from: 'desktop_web', user_id: uid, ref: 'web/customer_care' };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getCustomerSupportDetails',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            email: data.email,
	            timings: data.timings,
	            mobiles: data.mobiles,
	            advertiser_email: data.advertiser_email,
	            advertiser_mobile: data.advertiser_mobile,
	            username: data.user_name,
	            wb_url: data.wb_url
	          });
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'chatnow',
	    value: function chatnow() {
	      if (localStorage.user_id) {
	        var uid = localStorage.getItem('user_id');
	      } else {
	        uid = 0;
	      }
	
	      if (!localStorage.user_id && !localStorage.token) {
	        // if(this.props.params.Bname)
	        // {
	        //   localStorage.setItem('m_r_p_dt','/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Bname+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.DealId)   
	        // }
	        // else
	        // {
	        //   localStorage.setItem('m_r_p_dt','/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.DealId)
	        // }
	        // localStorage.setItem('mob_addtocart','1');
	        // localStorage.setItem('mob_addtocart_qty',this.state.min_qty);
	        _reactRouter.browserHistory.push('/login/' + this.state.wb_url);
	      } else {
	        location.href = this.state.wb_url;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      document.title = "AquaDeals Customer Care";
	      document.getElementsByTagName("META")[2].content = "AquaDeals Customer Care";
	      return _react2.default.createElement(
	        'div',
	        { className: 'lgt_gry web_deals web_customer_care_page' },
	        _react2.default.createElement(_WebHeaderInner2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6 col-md-offset-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dels_cntnt web_customer_care' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'del_rgt_blk' },
	                  _react2.default.createElement('div', { className: 'clr' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'del_dtl' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'pag_cntnt customer_care' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mod_cc_bg' },
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mob_cc_image' },
	                        _react2.default.createElement('img', { src: __webpack_require__(107), alt: '...' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'container-fluid' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12' },
	                          _react2.default.createElement(
	                            'section',
	                            { id: 'cc_content_block' },
	                            _react2.default.createElement(
	                              'h3',
	                              null,
	                              'Dear ',
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                this.state.username
	                              ),
	                              ' ,'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { id: 'cc_cnt' },
	                              'If you have any questions or concerns about our products or services, feel free to contact our Customer Support team.'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'section',
	                            { id: 'cc_contact_list' },
	                            _react2.default.createElement(
	                              'a',
	                              { href: "mailto:" + this.state.email },
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                  'span',
	                                  null,
	                                  _react2.default.createElement('img', { src: __webpack_require__(108) })
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  null,
	                                  this.state.email
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement('img', { src: __webpack_require__(109) })
	                              ),
	                              this.state.mobiles
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement('img', { src: __webpack_require__(111) })
	                              ),
	                              this.state.timings
	                            )
	                          ),
	                          _react2.default.createElement('section', { id: 'cc_wb_div' })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'clr' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cust_car_ftr' },
	          _react2.default.createElement(_WebFooter2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return Web_CustomerCare;
	}(_react.Component);
	
	exports.default = Web_CustomerCare;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Web_CustomerCare_Seller = function (_Component) {
	  _inherits(Web_CustomerCare_Seller, _Component);
	
	  function Web_CustomerCare_Seller(props) {
	    _classCallCheck(this, Web_CustomerCare_Seller);
	
	    var _this = _possibleConstructorReturn(this, (Web_CustomerCare_Seller.__proto__ || Object.getPrototypeOf(Web_CustomerCare_Seller)).call(this, props));
	
	    _this.state = {
	      email: '',
	      mobiles: '',
	      timings: ''
	    };
	    _this.getDeviceId = _this.getDeviceId.bind(_this);
	    return _this;
	  }
	
	  _createClass(Web_CustomerCare_Seller, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (screen.width < 800) {
	        window.location.href = "/customer_care_seller";
	      }
	      this.getDeviceId();
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      var data1 = { from: 'desktop_web', user_id: localStorage.user_id };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getSellerSupportDetails',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            email: data.email,
	            timings: data.timings,
	            mobiles: data.phone,
	            username: data.username
	          });
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'getDeviceId',
	    value: function getDeviceId() {
	      if (localStorage.user_id) {
	        var user_id = localStorage.user_id;
	      } else {
	        user_id = 0;
	      }
	      var data1 = { from: 'desktop_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
	      var data2 = JSON.stringify(data1);
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getDeviceId',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function success(data) {},
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      document.title = "AquaDeals Customer Care";
	      document.getElementsByTagName("META")[2].content = "AquaDeals Customer Care";
	      return _react2.default.createElement(
	        'div',
	        { className: 'lgt_gry web_deals web_customer_care_page' },
	        _react2.default.createElement(_WebHeaderInner2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6 col-md-offset-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dels_cntnt web_customer_care' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'del_rgt_blk' },
	                  _react2.default.createElement('div', { className: 'clr' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'del_dtl' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'pag_cntnt customer_care' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mod_cc_bg' },
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'mob_cc_image' },
	                        _react2.default.createElement('img', { src: __webpack_require__(107), alt: '...' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'container-fluid' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'col-md-12' },
	                          _react2.default.createElement(
	                            'section',
	                            { id: 'cc_content_block' },
	                            _react2.default.createElement(
	                              'h3',
	                              null,
	                              'Dear ',
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                this.state.username
	                              ),
	                              ' ,'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              { id: 'cc_cnt' },
	                              'If you have any questions or concerns about our products or services, feel free to contact our Customer Support team.'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'section',
	                            { id: 'cc_contact_list' },
	                            _react2.default.createElement(
	                              'a',
	                              { href: "mailto:" + this.state.email },
	                              _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                  'span',
	                                  null,
	                                  _react2.default.createElement('img', { src: __webpack_require__(108) })
	                                ),
	                                _react2.default.createElement(
	                                  'span',
	                                  null,
	                                  this.state.email
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement('img', { src: __webpack_require__(109) })
	                              ),
	                              this.state.mobiles
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement('img', { src: __webpack_require__(111) })
	                              ),
	                              this.state.timings
	                            )
	                          ),
	                          _react2.default.createElement('section', { id: 'cc_wb_div' })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'clr' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cust_car_ftr' },
	          _react2.default.createElement(_WebFooter2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return Web_CustomerCare_Seller;
	}(_react.Component);
	
	exports.default = Web_CustomerCare_Seller;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AboutHeader = __webpack_require__(218);
	
	var _AboutHeader2 = _interopRequireDefault(_AboutHeader);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import {Link, browserHistory } from 'react-router';
	// import $ from 'jquery';
	
	
	var Web_downloads = function (_Component) {
		_inherits(Web_downloads, _Component);
	
		function Web_downloads() {
			_classCallCheck(this, Web_downloads);
	
			return _possibleConstructorReturn(this, (Web_downloads.__proto__ || Object.getPrototypeOf(Web_downloads)).apply(this, arguments));
		}
	
		_createClass(Web_downloads, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width < 800) {
					window.location.href = "/downloads";
				}
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = "AquaDeals Downloads";
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_downloads_page' },
					_react2.default.createElement(_AboutHeader2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'featr_blk' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-3' },
									_react2.default.createElement('img', { className: 'mob_splsh_img', src: 'https://aquadeals.in/admin/assets/images/splash_mob.png', alt: '' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-9' },
									_react2.default.createElement(
										'h3',
										null,
										'Features'
									),
									_react2.default.createElement(
										'p',
										null,
										'For fast and safe orders of Seed, Feed, Health Care, Machinery & Farm Equipment experience the AquaDeals app on your Android phone and order on the GO! We are sure you will find the best deals every time. Invite your Contacts and get AquaCash. Refer your friends to download the AquaDeals app, sign up using your referral code and earn Rs.2000 AquaCash. Your friend gets Rs.2000 AquaCash. And there\u2019s more.'
									),
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-4 col-sm-4 featrs' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/deals.png', alt: '' }),
											_react2.default.createElement(
												'h4',
												null,
												'Deals'
											),
											_react2.default.createElement(
												'p',
												null,
												'Search several deals on Seed, Feed, Machinery etc right from your mobile deals on Seed.'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-4 col-sm-4 featrs' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/sp_offers.png', alt: '' }),
											_react2.default.createElement(
												'h4',
												null,
												'Special Offers'
											),
											_react2.default.createElement(
												'p',
												null,
												'Celebrate the best of offers that you can ever get for your aqua business. Profit, Share, WalletUp!'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-4 col-sm-4 featrs' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/refer_earn.png', alt: '' }),
											_react2.default.createElement(
												'h4',
												null,
												'Refer & Earn'
											),
											_react2.default.createElement(
												'p',
												null,
												'Fill your wallet with the magical AquaCash by just sharing with your friends across.'
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'container qr_codes' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-4 col-sm-4 qr_blk' },
								_react2.default.createElement('img', { className: 'qr_img', src: 'https://aquadeals.in/admin/assets/images/google_play_qr.png', alt: '' }),
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										'a',
										{ href: 'https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en', target: '_blank' },
										'Google Play'
									)
								),
								_react2.default.createElement('img', { className: 'qr_icon', src: 'https://aquadeals.in/admin/assets/images/google_play.png', alt: '' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-4 col-sm-4 qr_blk' },
								_react2.default.createElement('img', { className: 'qr_img', src: 'https://aquadeals.in/admin/assets/images/mobile_web_qr.png', alt: '' }),
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										'a',
										{ href: 'http://aquadeals.in', target: '_blank' },
										'aquadeals.in'
									)
								),
								_react2.default.createElement('img', { className: 'qr_icon qr_mob_icon', src: 'https://aquadeals.in/admin/assets/images/mobile_web.png', alt: '' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-4 col-sm-4 qr_blk' },
								_react2.default.createElement('img', { className: 'qr_img', src: 'https://aquadeals.in/admin/assets/images/desktop_web_qr.png', alt: '' }),
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										'a',
										{ href: 'http://aquadeals.in/web', target: '_blank' },
										'aquadeals.in/web'
									)
								),
								_react2.default.createElement('img', { className: 'qr_icon', src: 'https://aquadeals.in/admin/assets/images/desktop_web.png', alt: '' })
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_downloads;
	}(_react.Component);
	
	exports.default = Web_downloads;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(36);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _Footer = __webpack_require__(444);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Header = __webpack_require__(445);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import $ from 'jquery';
	
	
	var Web_EnquireNow = function (_Component) {
		_inherits(Web_EnquireNow, _Component);
	
		function Web_EnquireNow(props) {
			_classCallCheck(this, Web_EnquireNow);
	
			var _this = _possibleConstructorReturn(this, (Web_EnquireNow.__proto__ || Object.getPrototypeOf(Web_EnquireNow)).call(this, props));
	
			_this.state = {
				ltype: _this.props.params.Ltype,
				sid: _this.props.params.Sid,
				did: _this.props.params.Did,
				showModal: false
			};
			_this.modalOpen = _this.modalOpen.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.closeModal = _this.closeModal.bind(_this);
			return _this;
		}
	
		_createClass(Web_EnquireNow, [{
			key: 'modalOpen',
			value: function modalOpen() {
				this.setState({
					showModal: true
				});
			}
		}, {
			key: 'closeModal',
			value: function closeModal() {
				this.setState({
					showModal: false
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					showModal: false
				});
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(newProps) {
				if (newProps.leads === 1 || newProps.leads.status === 'success') {
					this.setState({ showModal: true });
				} else {
					this.setState({ showModal: false });
				}
			}
		}, {
			key: 'getDeviceId',
			value: function getDeviceId() {
				if (localStorage.user_id) {
					var user_id = localStorage.user_id;
				} else {
					user_id = 0;
				}
				var data1 = { from: 'desktop_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getDeviceId',
					dataType: 'json',
					data: { req: data2 },
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.props.clear_state();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.getDeviceId();
			}
		}, {
			key: 'handleFormSubmit',
			value: function handleFormSubmit(formProps) {
				// console.log(this.state.ltype);
				if (this.state.ltype === "seed") {
					this.props.saveseed_lead(formProps, this.state.sid, this.state.did);
				}
				if (this.state.ltype === "feed") {
					this.props.savefeed_lead(formProps, this.state.sid, this.state.did);
				}
				if (this.state.ltype === "seller") {
					this.props.savefeed_lead(formProps, this.state.sid, this.state.did);
					//this.props.track_seller_lead(formProps,this.state.sid,this.state.did);	
				}
				if (this.state.ltype === "nodata") {
					this.props.track_user_lead(formProps, this.state.sid, this.state.did);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				// console.log(this.props.leads);
				document.title = "AquaDeals Enquire Now ";
				document.getElementsByTagName("META")[2].content = "AquaDeals Enquire Now";
				var redirect = '';
				if (this.state.ltype === 'seller') {
					redirect = '/customer_care_seller';
				} else {
					redirect = '/customer_care';
				}
				var _props = this.props,
				    handleSubmit = _props.handleSubmit,
				    _props$fields = _props.fields,
				    name = _props$fields.name,
				    number = _props$fields.number,
				    email = _props$fields.email;
	
				return _react2.default.createElement(
					'div',
					{ className: 'lgt_gry web_deals web_enquire_page' },
					_react2.default.createElement(_Header2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'container dels_cntnt' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12 del_rgt' },
								_react2.default.createElement(
									'div',
									{ className: 'del_rgt_blk' },
									_react2.default.createElement('div', { className: 'col-md-12' }),
									_react2.default.createElement('div', { className: 'clr' }),
									_react2.default.createElement(
										'div',
										{ className: 'customer_care' },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-6 col-md-offset-3' },
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											),
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											),
											_react2.default.createElement(
												'div',
												{ className: 'thumbnail' },
												_react2.default.createElement(
													'div',
													{ className: 'enquire_form' },
													_react2.default.createElement(
														'div',
														{ className: 'login_form' },
														_react2.default.createElement(
															'form',
															{ className: 'mtrl_elmnts', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
															_react2.default.createElement(
																'div',
																{ className: 'group' },
																_react2.default.createElement('input', _extends({}, name, { type: 'text' })),
																_react2.default.createElement('span', { className: 'highlight' }),
																_react2.default.createElement('span', { className: 'bar' }),
																_react2.default.createElement(
																	'span',
																	null,
																	name.touched && name.error && _react2.default.createElement(
																		'div',
																		{ className: 'text-danger' },
																		name.error
																	)
																),
																_react2.default.createElement(
																	'label',
																	null,
																	'Name'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'group' },
																_react2.default.createElement('input', _extends({}, number, { type: 'text', maxLength: 10 })),
																_react2.default.createElement('span', { className: 'highlight' }),
																_react2.default.createElement('span', { className: 'bar' }),
																_react2.default.createElement(
																	'span',
																	null,
																	number.touched && number.error && _react2.default.createElement(
																		'div',
																		{ className: 'text-danger' },
																		number.error
																	)
																),
																_react2.default.createElement(
																	'label',
																	null,
																	'Mobile'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'group' },
																_react2.default.createElement('input', _extends({}, email, { type: 'text' })),
																_react2.default.createElement('span', { className: 'highlight' }),
																_react2.default.createElement('span', { className: 'bar' }),
																_react2.default.createElement(
																	'span',
																	null,
																	_react2.default.createElement(
																		'div',
																		{ className: 'text-danger' },
																		email.error ? email.error : ''
																	)
																),
																_react2.default.createElement(
																	'label',
																	null,
																	'Email(Optional)'
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'row' },
																_react2.default.createElement('div', { className: 'col-md-6 col-xs-6 col-sm-6' }),
																_react2.default.createElement(
																	'div',
																	{ className: 'col-md-6 col-xs-6 col-sm-6' },
																	_react2.default.createElement(
																		'button',
																		{ style: { border: 'none' }, action: 'submit', className: 'btn enquire_btn' },
																		'Enquire'
																	)
																)
															)
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'customer_care_bg' },
												'\xA0'
											),
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'clr' },
										'\xA0'
									),
									_react2.default.createElement(
										'div',
										{ className: 'clr' },
										'\xA0'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'showModal modal fade', show: this.state.showModal, style: { zIndex: '1111' }, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ style: { borderBottom: 'none' } },
							_react2.default.createElement(_reactBootstrap.Modal.Title, { style: { fontSize: 16 + 'px', color: '#333' } })
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'div',
								{ style: { textAlign: 'center' } },
								_react2.default.createElement('img', { width: 70, src: 'https://aquadeals.in/admin/assets/images/web_imgs/conformed.png', alt: '...' })
							),
							_react2.default.createElement(
								'h4',
								{ style: { textAlign: 'center', fontSize: 14 + 'px', color: '#666' } },
								'Your details has been submitted successfully'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer', style: { borderTop: 'none', textAlign: 'center' } },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: redirect },
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: '#ff742a none repeat scroll 0 0', color: '#fff' } },
									'OK'
								)
							)
						)
					),
					_react2.default.createElement(_Footer2.default, null)
				);
			}
		}]);
	
		return Web_EnquireNow;
	}(_react.Component);
	
	function validate(formProps) {
		var errors = {};
		var namePattern = /^[a-zA-Z0-9\x20]{3,25}/;
	
		if (!formProps.name) {
			errors.name = "Enter your name";
		} else if (formProps.name && !namePattern.test(formProps.name)) {
			errors.name = 'Enter minimum 3 characters';
		}
	
		var invalidChars = /[^0-9]/gi;
		if (formProps.number && invalidChars.test(formProps.number)) {
			errors.number = "invalid mobile number";
		}
	
		var number_check = /^[0-9]{10}$/;
		if (formProps.number && !number_check.test(formProps.number)) {
			errors.number = "Mobile number must contains 10 numbers only";
		}
	
		if (!formProps.number) {
			errors.number = "Enter Mobile Number";
		}
	
		var emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
		if (formProps.email && !emailPattern.test(formProps.email)) {
			errors.email = 'Enter a valid email';
		}
	
		// const emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
		//   if (!emailPattern.test(formProps.email)) {
		//     errors.email = 'Enter a valid email';
		//   }
	
		return errors;
	}
	
	function mapStateToProps(state) {
		return {
			leads: state.posts.leads
		};
	}
	
	exports.default = (0, _reduxForm.reduxForm)({
		form: 'Enquiry',
		fields: ['name', 'number', 'email'],
		validate: validate
	}, mapStateToProps, actions)(Web_EnquireNow);

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactShare = __webpack_require__(18);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var Web_PromoOffersZones = function (_Component) {
		_inherits(Web_PromoOffersZones, _Component);
	
		function Web_PromoOffersZones() {
			_classCallCheck(this, Web_PromoOffersZones);
	
			var _this = _possibleConstructorReturn(this, (Web_PromoOffersZones.__proto__ || Object.getPrototypeOf(Web_PromoOffersZones)).call(this));
	
			_this.state = {
				key: 1,
				gen_offers: [],
				seed_offers: [],
				product_offers: [],
				gen_offers_status: true,
				seed_offers_status: true,
				product_offers_status: true,
				modal_gen: false,
				modal_seed: false,
				modal_feed: false
			};
			_this.handleSelect = _this.handleSelect.bind(_this);
			return _this;
		}
	
		_createClass(Web_PromoOffersZones, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
	
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
				localStorage.removeItem('checkout');
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
				localStorage.removeItem('web_quickcart');
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
				localStorage.removeItem('web_brand_details');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
	
				if (screen.width < 800) {
					window.location.href = "/offerszone";
				}
				// if(!localStorage.token && !localStorage.user_id){
				localStorage.setItem('web_ofr_page', '/web/offerszone');
				// 	browserHistory.push('/web/login');
				// }
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', uid: localStorage.getItem('user_id'), token: localStorage.getItem('token'), tab: 'general' };
				var data2 = JSON.stringify(data1);
				var data3 = { from: 'desktop_web', uid: localStorage.getItem('user_id'), token: localStorage.getItem('token'), tab: 'seed' };
				var data4 = JSON.stringify(data3);
				var data5 = { from: 'desktop_web', uid: localStorage.getItem('user_id'), token: localStorage.getItem('token'), tab: 'product' };
				var data6 = JSON.stringify(data5);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getPromoOffers',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						console.log(data);
						if (data.status === 'available') {
							this.setState({
								gen_offers: data.offers
							});
						} else {
							this.setState({
								gen_offers_status: false
							});
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getPromoOffers',
					dataType: 'json',
					data: { req: data4 },
					success: function (data) {
						if (data.status === 'available') {
							this.setState({
								seed_offers: data.offers
							});
						} else {
							this.setState({
								seed_offers_status: false
							});
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getPromoOffers',
					dataType: 'json',
					data: { req: data6 },
					success: function (data) {
						if (data.status === 'available') {
							this.setState({
								product_offers: data.offers
							});
						} else {
							this.setState({
								product_offers_status: false
							});
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'handleSelect',
			value: function handleSelect(key) {
				this.setState({
					key: key
				});
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = "Offers Zone | AquaDeals";
				document.getElementsByTagName("META")[2].content = "AquaDeals Offers Zone";
				var gen_offers = '';
				var seed_offers = '';
				var product_offers = '';
	
				if (this.state.gen_offers_status) {
					gen_offers = this.state.gen_offers.map(function (offer, index) {
						return _react2.default.createElement(GenOffers, { key: offer.id, data: offer });
					});
				} else {
					gen_offers = _react2.default.createElement(
						'div',
						{ className: 'web_no_offers' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: "/web/customer_care" },
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/cc_orange_offers.png', width: '33px', alt: ' ' }),
							_react2.default.createElement(
								'p',
								{ className: 'web_ofr_care' },
								'Call customer care for best offers.'
							)
						)
					);
				}
	
				if (this.state.seed_offers_status) {
					seed_offers = this.state.seed_offers.map(function (offer, index) {
						return _react2.default.createElement(SeedOffers, { key: offer.id, data: offer });
					});
				} else {
					seed_offers = _react2.default.createElement(
						'div',
						{ className: 'web_no_offers' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: "/web/customer_care" },
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/cc_orange_offers.png', width: '33px', alt: ' ' }),
							_react2.default.createElement(
								'p',
								{ className: 'web_ofr_care' },
								'Call customer care for best offers.'
							)
						)
					);
				}
				if (this.state.product_offers_status) {
					product_offers = this.state.product_offers.map(function (offer, index) {
						return _react2.default.createElement(ProductOffers, { key: offer.id, data: offer });
					});
				} else {
					product_offers = _react2.default.createElement(
						'div',
						{ className: 'web_no_offers' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: "/web/customer_care" },
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/cc_orange_offers.png', width: '33px', alt: ' ' }),
							_react2.default.createElement(
								'p',
								{ className: 'web_ofr_care' },
								'Call customer care for best offers.'
							)
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'Web_Deals web_Offer_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							_reactBootstrap.Breadcrumb,
							{ className: 'ofrzone_breadcrmb' },
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb.Item,
								{ href: '/web/home' },
								'Home'
							),
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb.Item,
								{ active: true },
								'Offers Zone'
							)
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'container offer_content' },
						_react2.default.createElement(
							_reactBootstrap.Tabs,
							{ activeKey: this.state.key, onSelect: this.handleSelect, id: 'controlled-tab-example', className: 'justified offertab' },
							_react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 1, title: 'AD OFFERS' },
								gen_offers
							),
							_react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 2, title: 'SEED' },
								seed_offers
							),
							_react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 3, title: 'PRODUCTS' },
								product_offers
							)
						)
					),
					_react2.default.createElement('div', { className: 'clr' }),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_PromoOffersZones;
	}(_react.Component);
	
	exports.default = Web_PromoOffersZones;
	
	var GenOffers = function (_Component2) {
		_inherits(GenOffers, _Component2);
	
		function GenOffers(props) {
			_classCallCheck(this, GenOffers);
	
			var _this2 = _possibleConstructorReturn(this, (GenOffers.__proto__ || Object.getPrototypeOf(GenOffers)).call(this, props));
	
			_this2.state = {
				modal_gen: false,
				offers: _this2.props.data,
				title: '',
				description: '',
				terms: '',
				discount_type: '',
				details: [],
				share_title: '',
				share_desc: '',
				share_panel_open: false
			};
			_this2.close = _this2.close.bind(_this2);
			_this2.getPromoDetails = _this2.getPromoDetails.bind(_this2);
			_this2.getInvite = _this2.getInvite.bind(_this2);
			return _this2;
		}
	
		_createClass(GenOffers, [{
			key: 'getPromoDetails',
			value: function getPromoDetails(offer_id) {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), ofr_id: offer_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + "get_promo_ofr",
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						var details = _jquery2.default.makeArray(data.data);
	
						window.test = details;
						this.setState({
							details: details,
							title: details[0].title,
							description: details[0].description,
							terms: details[0].terms,
							discount_type: details[0].discount_type,
							share_panel_open: false
						});
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({ modal_gen: false });
			}
		}, {
			key: 'getInvite',
			value: function getInvite() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + 'shareAppurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
	
						this.setState({
							share_title: data.share_data,
							share_desc: data.share_data,
							share_panel_open: !this.state.share_panel_open
						});
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var offers = this.props.data;
				var shareUrl = 'http://tinyurl.com/aquadotdeals';
	
				return _react2.default.createElement(
					'div',
					{ className: 'web_ofrs_blk col-md-6' },
					_react2.default.createElement(
						_reactRouter.Link,
						null,
						_react2.default.createElement(
							'div',
							{ className: 'web_offer_info', onClick: function onClick() {
									_this3.setState({ modal_gen: true });
								} },
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/info.png', width: '20px', alt: '' })
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement('img', { onClick: function onClick() {
									_this3.setState({ modal_gen: true });
								}, src: 'https://aquadeals.in/admin/assets/images/promo_offers/' + offers.image, alt: ' ' })
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ onEntered: function onEntered() {
								_this3.getPromoDetails(offers.id);
							}, className: '', show: this.state.modal_gen, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ className: 'modal_offer_header', closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: 18 + 'px', color: '#fff' } },
								'Offer Details'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							{ className: 'modal_details_block' },
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_title' },
								this.state.title
							),
							_react2.default.createElement(
								'h6',
								{ className: 'modal_ofr_applicable' },
								'Applicable On: ',
								this.state.discount_type
							),
							_react2.default.createElement(
								'p',
								{ className: 'modal_ofr_period' },
								'Limited period offer'
							),
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_desc_title' },
								'Description'
							),
							_react2.default.createElement(
								'p',
								{ className: 'modal_ofr_desc' },
								this.state.description
							),
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_terms_title' },
								'Terms and Conditions'
							),
							_react2.default.createElement('div', { className: 'modal_ofr_terms', dangerouslySetInnerHTML: { __html: this.state.terms } }),
							this.state.title === 'Refer & Earn' ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'ofr_invite_btn' },
									_react2.default.createElement(
										'a',
										{ onClick: function onClick() {
												_this3.getInvite();
											} },
										'INVITE NOW'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'ofr_share_panel' },
									_react2.default.createElement(
										_reactBootstrap.Panel,
										{ className: '', style: { marginLeft: '30%' }, collapsible: true, expanded: this.state.share_panel_open },
										_react2.default.createElement(
											FacebookShareButton,
											{ url: shareUrl, title: this.state.share_title, className: 'test_share2' },
											_react2.default.createElement(FacebookIcon, { size: 32, round: true })
										),
										_react2.default.createElement(
											TwitterShareButton,
											{ url: shareUrl, title: this.state.share_title, description: shareUrl, className: 'test_share2' },
											_react2.default.createElement(TwitterIcon, { size: 32, round: true })
										),
										_react2.default.createElement(
											GooglePlusShareButton,
											{ url: shareUrl, title: this.state.share_title, description: shareUrl, className: 'test_share2' },
											_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
										)
									)
								)
							) : ''
						)
					)
				);
			}
		}]);
	
		return GenOffers;
	}(_react.Component);
	
	var SeedOffers = function (_Component3) {
		_inherits(SeedOffers, _Component3);
	
		function SeedOffers(props) {
			_classCallCheck(this, SeedOffers);
	
			var _this4 = _possibleConstructorReturn(this, (SeedOffers.__proto__ || Object.getPrototypeOf(SeedOffers)).call(this, props));
	
			_this4.state = {
				modal_gen: false,
				offers: _this4.props.data,
				title: '',
				description: '',
				terms: '',
				discount_type: '',
				details: [],
				share_title: '',
				share_desc: '',
				share_panel_open: false
			};
			_this4.close = _this4.close.bind(_this4);
			_this4.getPromoDetails = _this4.getPromoDetails.bind(_this4);
			_this4.getInvite = _this4.getInvite.bind(_this4);
			return _this4;
		}
	
		_createClass(SeedOffers, [{
			key: 'getPromoDetails',
			value: function getPromoDetails(offer_id) {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), ofr_id: offer_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + "get_promo_ofr",
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						var details = _jquery2.default.makeArray(data.data);
						// console.log(data);
						console.log(details);
						window.test = details;
						this.setState({
							details: details,
							title: details[0].title,
							description: details[0].description,
							terms: details[0].terms,
							discount_type: details[0].discount_type,
							share_panel_open: false
						});
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({ modal_gen: false });
			}
		}, {
			key: 'getInvite',
			value: function getInvite() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + 'shareAppurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
	
						this.setState({
							share_title: data.share_data,
							share_desc: data.share_data,
							share_panel_open: !this.state.share_panel_open
						});
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var offers = this.props.data;
				var shareUrl = 'http://tinyurl.com/aquadotdeals';
				return _react2.default.createElement(
					'div',
					{ className: 'web_ofrs_blk col-md-6' },
					_react2.default.createElement(
						_reactRouter.Link,
						null,
						_react2.default.createElement(
							'div',
							{ className: 'web_offer_info', onClick: function onClick() {
									_this5.setState({ modal_gen: true });
								} },
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/info.png', width: '20px', alt: '' })
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement('img', { onClick: function onClick() {
									_this5.setState({ modal_gen: true });
								}, src: 'https://aquadeals.in/admin/assets/images/promo_offers/' + offers.image, alt: '' })
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ onEntered: function onEntered() {
								_this5.getPromoDetails(offers.id);
							}, className: '', show: this.state.modal_gen, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ className: 'modal_offer_header', closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: 18 + 'px', color: '#fff' } },
								'Offer Details'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							{ className: 'modal_details_block' },
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_title' },
								this.state.title
							),
							_react2.default.createElement(
								'h6',
								{ className: 'modal_ofr_applicable' },
								'Applicable On: ',
								this.state.discount_type
							),
							_react2.default.createElement(
								'p',
								{ className: 'modal_ofr_period' },
								'Limited period offer'
							),
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_desc_title' },
								'Description'
							),
							_react2.default.createElement(
								'p',
								{ className: 'modal_ofr_desc' },
								this.state.description
							),
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_terms_title' },
								'Terms and Conditions'
							),
							_react2.default.createElement('div', { className: 'modal_ofr_terms', dangerouslySetInnerHTML: { __html: this.state.terms } }),
							this.state.title === 'Refer & Earn' ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'ofr_invite_btn' },
									_react2.default.createElement(
										'a',
										{ onClick: function onClick() {
												_this5.getInvite();
											} },
										'INVITE NOW'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'ofr_share_panel' },
									_react2.default.createElement(
										_reactBootstrap.Panel,
										{ className: '', style: { marginLeft: '30%' }, collapsible: true, expanded: this.state.share_panel_open },
										_react2.default.createElement(
											FacebookShareButton,
											{ url: shareUrl, title: this.state.share_title, className: 'test_share2' },
											_react2.default.createElement(FacebookIcon, { size: 32, round: true })
										),
										_react2.default.createElement(
											TwitterShareButton,
											{ url: shareUrl, title: this.state.share_title, description: shareUrl, className: 'test_share2' },
											_react2.default.createElement(TwitterIcon, { size: 32, round: true })
										),
										_react2.default.createElement(
											GooglePlusShareButton,
											{ url: shareUrl, title: this.state.share_title, description: shareUrl, className: 'test_share2' },
											_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
										)
									)
								)
							) : ''
						)
					)
				);
			}
		}]);
	
		return SeedOffers;
	}(_react.Component);
	
	var ProductOffers = function (_Component4) {
		_inherits(ProductOffers, _Component4);
	
		function ProductOffers(props) {
			_classCallCheck(this, ProductOffers);
	
			var _this6 = _possibleConstructorReturn(this, (ProductOffers.__proto__ || Object.getPrototypeOf(ProductOffers)).call(this, props));
	
			_this6.state = {
				modal_gen: false,
				offers: _this6.props.data,
				title: '',
				description: '',
				terms: '',
				discount_type: '',
				details: [],
				share_title: '',
				share_desc: '',
				share_panel_open: false
			};
			_this6.close = _this6.close.bind(_this6);
			_this6.getPromoDetails = _this6.getPromoDetails.bind(_this6);
			_this6.getInvite = _this6.getInvite.bind(_this6);
			return _this6;
		}
	
		_createClass(ProductOffers, [{
			key: 'getPromoDetails',
			value: function getPromoDetails(offer_id) {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), ofr_id: offer_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + "get_promo_ofr",
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						var details = _jquery2.default.makeArray(data.data);
						window.test = details;
						this.setState({
							details: details,
							title: details[0].title,
							description: details[0].description,
							terms: details[0].terms,
							discount_type: details[0].discount_type,
							share_panel_open: false
						});
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({ modal_gen: false });
			}
		}, {
			key: 'getInvite',
			value: function getInvite() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + 'shareAppurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							share_title: data.share_data,
							share_desc: data.share_data,
							share_panel_open: !this.state.share_panel_open
						});
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				var offers = this.props.data;
				var shareUrl = 'http://tinyurl.com/aquadotdeals';
				return _react2.default.createElement(
					'div',
					{ className: 'web_ofrs_blk col-md-6' },
					_react2.default.createElement(
						_reactRouter.Link,
						null,
						_react2.default.createElement(
							'div',
							{ className: 'web_offer_info', onClick: function onClick() {
									_this7.setState({ modal_gen: true });
								} },
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/info.png', width: '20px', alt: '' })
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement('img', { onClick: function onClick() {
									_this7.setState({ modal_gen: true });
								}, src: 'https://aquadeals.in/admin/assets/images/promo_offers/' + offers.image, alt: '' })
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ onEntered: function onEntered() {
								_this7.getPromoDetails(offers.id);
							}, className: '', show: this.state.modal_gen, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ className: 'modal_offer_header', closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: 18 + 'px', color: '#fff' } },
								'Offer Details'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							{ className: 'modal_details_block' },
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_title' },
								this.state.title
							),
							_react2.default.createElement(
								'h6',
								{ className: 'modal_ofr_applicable' },
								'Applicable On: ',
								this.state.discount_type
							),
							_react2.default.createElement(
								'p',
								{ className: 'modal_ofr_period' },
								'Limited period offer'
							),
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_desc_title' },
								'Description'
							),
							_react2.default.createElement(
								'p',
								{ className: 'modal_ofr_desc' },
								this.state.description
							),
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_terms_title' },
								'Terms and Conditions'
							),
							_react2.default.createElement('div', { className: 'modal_ofr_terms', dangerouslySetInnerHTML: { __html: this.state.terms } }),
							this.state.title === 'Refer & Earn' ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'ofr_invite_btn' },
									_react2.default.createElement(
										'a',
										{ onClick: function onClick() {
												_this7.getInvite();
											} },
										'INVITE NOW'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'ofr_share_panel' },
									_react2.default.createElement(
										_reactBootstrap.Panel,
										{ className: '', style: { marginLeft: '30%' }, collapsible: true, expanded: this.state.share_panel_open },
										_react2.default.createElement(
											FacebookShareButton,
											{ url: shareUrl, title: this.state.share_title, className: 'test_share2' },
											_react2.default.createElement(FacebookIcon, { size: 32, round: true })
										),
										_react2.default.createElement(
											TwitterShareButton,
											{ url: shareUrl, title: this.state.share_title, description: shareUrl, className: 'test_share2' },
											_react2.default.createElement(TwitterIcon, { size: 32, round: true })
										),
										_react2.default.createElement(
											GooglePlusShareButton,
											{ url: shareUrl, title: this.state.share_title, description: shareUrl, className: 'test_share2' },
											_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
										)
									)
								)
							) : ''
						)
					)
				);
			}
		}]);
	
		return ProductOffers;
	}(_react.Component);

/***/ },
/* 463 */
/***/ function(module, exports) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!function () {
	  "use strict";
	  !function () {
	    var l = window,
	        c = l.document,
	        t = l.Array,
	        s = l.Object,
	        r = l.String,
	        m = l.Number,
	        e = l.Date,
	        u = l.Math,
	        a = l.setTimeout,
	        n = l.setInterval,
	        i = l.clearTimeout,
	        d = l.parseInt,
	        f = l.encodeURIComponent,
	        h = l.btoa,
	        v = l.unescape,
	        o = l.TypeError,
	        p = l.navigator,
	        _ = l.location,
	        y = l.XMLHttpRequest;function b(i) {
	      return function (e, n) {
	        return arguments.length < 2 ? function (n) {
	          return i.call(null, n, e);
	        } : i.call(null, e, n);
	      };
	    }function g(t) {
	      return function (e, i, n) {
	        return arguments.length < 3 ? function (n) {
	          return t.call(null, n, e, i);
	        } : t.call(null, e, i, n);
	      };
	    }function D() {
	      for (var n = arguments.length, e = new t(n), i = 0; i < n; i++) {
	        e[i] = arguments[i];
	      }return function (n) {
	        return function () {
	          var i = arguments;return e.every(function (n, e) {
	            return n(i[e]) || function () {
	              console.error.apply(console, arguments);
	            }("wrong " + e + "th argtype", i[e]);
	          }) ? n.apply(null, i) : i[0];
	        };
	      };
	    }function R(n) {
	      return w(n) && 1 === n.nodeType;
	    }var S = b(function (n, e) {
	      return (typeof n === "undefined" ? "undefined" : _typeof(n)) === e;
	    }),
	        M = S("boolean"),
	        k = S("number"),
	        P = S("string"),
	        K = S("function"),
	        L = S("object"),
	        N = t.isArray,
	        w = function w(n) {
	      return null !== n && L(n);
	    },
	        B = function B(n) {
	      return !T(s.keys(n));
	    },
	        A = b(function (n, e) {
	      return n && n[e];
	    }),
	        T = A("length"),
	        C = A("prototype"),
	        $ = b(function (n, e) {
	      return n instanceof e;
	    }),
	        G = e.now,
	        E = u.random,
	        x = u.floor;function z(n, e) {
	      return { error: function (n, e) {
	          var i = { description: r(n) };return e && (i.field = e), i;
	        }(n, e) };
	    }function F(n) {
	      throw new Error(n);
	    }var H = function H(n) {
	      return (/data:image\/[^;]+;base64/.test(n)
	      );
	    };function O(n) {
	      var e = function a(o, r) {
	        var m = {};if (!w(o)) return m;var u = null == r;return s.keys(o).forEach(function (n) {
	          var e = o[n],
	              i = u ? n : r + "[" + n + "]";if ("object" == (typeof e === "undefined" ? "undefined" : _typeof(e))) {
	            var t = a(e, i);s.keys(t).forEach(function (n) {
	              m[n] = t[n];
	            });
	          } else m[i] = e;
	        }), m;
	      }(n);return s.keys(e).map(function (n) {
	        return f(n) + "=" + f(e[n]);
	      }).join("&");
	    }function U(n, e) {
	      return w(e) && (e = O(e)), e && (n += 0 < n.indexOf("?") ? "&" : "?", n += e), n;
	    }function Z(n) {
	      return s.keys(n || {});
	    }function I(n) {
	      try {
	        return JSON.parse(n);
	      } catch (n) {}
	    }function Y(e, t, a, o) {
	      return $(e, Nn) ? console.error("use el |> _El.on(e, cb)") : function (i) {
	        var n = t;return P(a) ? n = function n(_n2) {
	          for (var e = _n2.target; !Vn(e, a) && e !== i;) {
	            e = Bn(e);
	          }e !== i && (_n2.delegateTarget = e, t(_n2));
	        } : o = a, o = !!o, i.addEventListener(e, n, o), function () {
	          return i.removeEventListener(e, n, o);
	        };
	      };
	    }function j(n) {
	      return P(n) ? oe(n) : n;
	    }var W,
	        q,
	        J,
	        V,
	        Q,
	        X,
	        nn,
	        en,
	        tn,
	        an,
	        on,
	        rn,
	        mn,
	        un = C(t),
	        cn = un.slice,
	        ln = b(function (n, e) {
	      return n && un.forEach.call(n, e), n;
	    }),
	        sn = (W = "indexOf", b(function (n, e) {
	      return un[W].call(n, e);
	    })),
	        dn = b(function (n, e) {
	      return 0 <= sn(n, e);
	    }),
	        fn = b(function (n, e) {
	      return cn.call(n, e);
	    }),
	        hn = g(function (n, e, i) {
	      return un.reduce.call(n, e, i);
	    }),
	        vn = function vn(n) {
	      return n;
	    },
	        pn = (C(Function), J = function J(n, e) {
	      return n.bind(e);
	    }, q = function q(n) {
	      if (K(n)) return J.apply(null, arguments);throw new o("not a function");
	    }, b(function (n, e) {
	      var i = arguments;return P(n) && ((i = fn(i, 0))[0] = e[n]), q.apply(null, i);
	    })),
	        _n = C(r).slice,
	        yn = g(function (n, e, i) {
	      return _n.call(n, e, i);
	    }),
	        bn = b(function (n, e) {
	      return _n.call(n, e);
	    }),
	        gn = b(function (n, e) {
	      return e in n;
	    }),
	        Dn = b(function (n, e) {
	      return n && n.hasOwnProperty(e);
	    }),
	        Rn = g(function (n, e, i) {
	      return n[e] = i, n;
	    }),
	        Sn = g(function (n, e, i) {
	      return i && (n[e] = i), n;
	    }),
	        Mn = b(function (n, e) {
	      return delete n[e], n;
	    }),
	        kn = b(function (e, i) {
	      return ln(Z(e), function (n) {
	        return i(e[n], n, e);
	      }), e;
	    }),
	        Pn = JSON.stringify,
	        Kn = b(function (i, n) {
	      return kn(n, function (n, e) {
	        return i[e] = n;
	      }), i;
	    }),
	        Ln = function Ln(n, t) {
	      void 0 === t && (t = "");var a = {};return kn(n, function (n, e) {
	        var i = t ? t + "." + e : e;w(n) ? Kn(a, Ln(n, i)) : a[i] = n;
	      }), a;
	    },
	        Nn = l.Element,
	        wn = function wn(n) {
	      return c.createElement(n || "div");
	    },
	        Bn = function Bn(n) {
	      return n.parentNode;
	    },
	        An = D(R),
	        Tn = D(R, R),
	        Cn = D(R, P),
	        $n = D(R, P, function () {
	      return !0;
	    }),
	        Gn = D(R, w),
	        En = (V = Tn(function (n, e) {
	      return e.appendChild(n);
	    }), b(V)),
	        xn = (Q = Tn(function (n, e) {
	      var i;return i = e, En(n)(i), n;
	    }), b(Q)),
	        zn = An(function (n) {
	      var e = Bn(n);return e && e.removeChild(n), n;
	    }),
	        Fn = (An(A("selectionStart")), An(A("selectionEnd")), nn = function nn(n, e) {
	      return n.selectionStart = n.selectionEnd = e, n;
	    }, X = D(R, k)(nn), b(X), An(function (n) {
	      return n.submit(), n;
	    })),
	        Hn = g($n(function (n, e, i) {
	      return n.setAttribute(e, i), n;
	    })),
	        On = g($n(function (n, e, i) {
	      return n.style[e] = i, n;
	    })),
	        Un = (en = Gn(function (t, n) {
	      var e;return e = n, kn(function (n, e) {
	        var i;return i = t, Hn(e, n)(i);
	      })(e), t;
	    }), b(en)),
	        Zn = (tn = Gn(function (t, n) {
	      var e;return e = n, kn(function (n, e) {
	        var i;return i = t, On(e, n)(i);
	      })(e), t;
	    }), b(tn)),
	        In = (an = Cn(function (n, e) {
	      return n.innerHTML = e, n;
	    }), b(an)),
	        Yn = (on = Cn(function (n, e) {
	      var i;return i = n, On("display", e)(i);
	    }), b(on)),
	        jn = (Yn("none"), Yn("block"), Yn("inline-block"), A("offsetWidth")),
	        Wn = A("offsetHeight"),
	        qn = C(Nn),
	        Jn = qn.matches || qn.matchesSelector || qn.webkitMatchesSelector || qn.mozMatchesSelector || qn.msMatchesSelector || qn.oMatchesSelector,
	        Vn = (rn = Cn(function (n, e) {
	      return Jn.call(n, e);
	    }), b(rn)),
	        Qn = c.documentElement,
	        Xn = c.body,
	        ne = l.innerHeight,
	        ee = l.pageYOffset,
	        ie = l.scrollBy,
	        te = l.scrollTo,
	        ae = l.requestAnimationFrame,
	        oe = pn("querySelector", c),
	        re = pn("querySelectorAll", c);function me(n, e, i, t) {
	      if (i && "get" === i.toLowerCase()) n = U(n, e), t ? l.open(n, t) : l.location = n;else {
	        var a,
	            o,
	            r,
	            m,
	            u,
	            c = { action: n, method: i };t && (c.target = t), u = wn("form"), m = Un(c)(u), r = In(ue(e))(m), o = En(Qn)(r), a = Fn(o), zn(a);
	      }
	    }function ue(n, i) {
	      if (w(n)) {
	        var t = "";return kn(n, function (n, e) {
	          i && (e = i + "[" + e + "]"), t += ue(n, e);
	        }), t;
	      }var e = wn("input");return e.type = "hidden", e.value = n, e.name = i, e.outerHTML;
	    }function ce(n) {
	      !function (m) {
	        if (!l.requestAnimationFrame) return ie(0, m);mn && i(mn), mn = a(function () {
	          var t = ee,
	              a = u.min(t + m, Wn(Xn) - ne);m = a - t;var o = 0,
	              r = l.performance.now();ae(function n(e) {
	            if (1 <= (o += (e - r) / 300)) return te(0, a);var i = u.sin(fe * o / 2);te(0, t + u.round(m * i)), r = e, ae(n);
	          });
	        }, 100);
	      }(n - ee);
	    }pn("getElementById", c), pn("getComputedStyle", l);var le,
	        se,
	        de,
	        fe = u.PI,
	        he = y,
	        ve = z("Network error"),
	        pe = 0;function _e(n) {
	      if (!$(this, _e)) return new _e(n);this.options = function (n) {
	        P(n) && (n = { url: n });var e = n,
	            i = e.method,
	            t = e.headers,
	            a = e.callback,
	            o = e.data;return t || (n.headers = {}), i || (n.method = "get"), a || (n.callback = vn), w(o) && (o = O(o)), n.data = o, n;
	      }(n), this.defer();
	    }((se = { setReq: function setReq(n, e) {
	        return this.abort(), this.type = n, this.req = e, this;
	      }, till: function till(e) {
	        var i = this;return this.setReq("timeout", a(function () {
	          i.call(function (n) {
	            e(n) ? i.till(e) : i.options.callback(n);
	          });
	        }, 3e3));
	      }, abort: function abort() {
	        var n = this.req,
	            e = this.type;n && ("ajax" === e ? this.req.abort() : "jsonp" === e ? l.Razorpay[this.req] = vn : i(this.req), this.req = null);
	      }, defer: function defer() {
	        var n = this;this.req = a(function () {
	          return n.call();
	        });
	      }, call: function call(e) {
	        var n, i;void 0 === e && (e = this.options.callback);var t = this.options,
	            a = t.url,
	            o = t.method,
	            r = t.data,
	            m = t.headers,
	            u = new he();this.setReq("ajax", u), u.open(o, a, !0), u.onreadystatechange = function () {
	          if (4 === u.readyState && u.status) {
	            var n = I(u.responseText);n || ((n = z("Parsing error")).xhr = { status: u.status, text: u.responseText }), e(n);
	          }
	        }, u.onerror = function () {
	          var n = ve;n.xhr = { status: 0 }, e(n);
	        }, i = m, n = Sn("X-Razorpay-SessionId", le)(i), kn(function (n, e) {
	          return u.setRequestHeader(e, n);
	        })(n), u.send(r);
	      } }).constructor = _e).prototype = se, _e.post = function (n) {
	      return n.method = "post", n.headers || (n.headers = {}), n.headers["Content-type"] || (n.headers["Content-type"] = "application/x-www-form-urlencoded"), _e(n);
	    }, _e.setSessionId = function (n) {
	      le = n;
	    }, _e.jsonp = function (r) {
	      r.data || (r.data = {});var m = "jsonp" + pe++;r.data.callback = "Razorpay." + m;var n = new _e(r);return r = n.options, n.call = function (e) {
	        var n, i;function t() {
	          a || this.readyState && "loaded" !== this.readyState && "complete" !== this.readyState || (a = !0, this.onload = this.onreadystatechange = null, zn(this));
	        }void 0 === e && (e = r.callback);var a = !1,
	            o = l.Razorpay[m] = function (n) {
	          Mn(n, "http_status_code"), e(n), Mn(l.Razorpay, m);
	        };this.setReq("jsonp", o), i = wn("script"), n = Kn({ src: U(r.url, r.data), async: !0, onerror: function onerror(n) {
	            return r.callback(ve);
	          }, onload: t, onreadystatechange: t })(i), En(Qn)(n);
	      }, n;
	    };var ye = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
	        be = (de = ye, hn(function (n, e, i) {
	      return Rn(n, e, i);
	    }, {})(de));function ge(n) {
	      for (var e = ""; n;) {
	        e = ye[n % 62] + e, n = x(n / 62);
	      }return e;
	    }function De() {
	      var n,
	          i,
	          t = ge(r(G() - 13885344e5) + bn("000000" + x(1e6 * E()), -6)) + ge(x(238328 * E())) + "0",
	          a = 0;return n = t, ln(function (n, e) {
	        i = be[t[t.length - 1 - e]], (t.length - e) % 2 && (i *= 2), 62 <= i && (i = i % 62 + 1), a += i;
	      })(n), i = (i = a % 62) && ye[62 - i], yn(t, 0, 13) + i;
	    }var Re = De(),
	        Se = { library: "checkoutjs", platform: "browser", referer: _.href };function Me(n) {
	      var e,
	          i = { checkout_id: n ? n.id : Re };return e = ["integration", "referer", "library", "platform", "platform_version", "os", "os_version", "device"], ln(function (n) {
	        var e;return e = i, Sn(n, Se[n])(e);
	      })(e), i;
	    }var ke,
	        Pe = [],
	        Ke = [],
	        Le = function Le(n) {
	      return Pe.push(n);
	    },
	        Ne = function Ne(n) {
	      ke = n;
	    },
	        we = function we() {
	      var n, e, i, t, a;if (Pe.length) {
	        var o = gn(p, "sendBeacon"),
	            r = { url: "https://lumberjack.razorpay.com/v1/track", data: { key: "ZmY5N2M0YzVkN2JiYzkyMWM1ZmVmYWJk", data: (a = { context: ke, addons: [{ name: "ua_parser", input_key: "user_agent", output_key: "user_agent_parsed" }], events: Pe.splice(0, Pe.length) }, t = Pn(a), i = f(t), e = v(i), n = h(e), f(n)) } };try {
	          o ? p.sendBeacon(r.url, Pn(r.data)) : _e.post(r);
	        } catch (n) {}
	      }
	    };function Be(m, u, c, l) {
	      m ? m.isLiveMode() && a(function () {
	        var n;c instanceof Error && (c = { message: c.message, stack: c.stack });var e = Me(m);e.user_agent = null, e.mode = "live";var i = m.get("order_id");i && (e.order_id = i);var a = {},
	            t = { options: a, es6: !0 };c && (t.data = c);var o = ["key", "amount", "prefill", "theme", "image", "description", "name", "method", "display_currency", "display_amount", "redirect", "readonly", "contact_id"];kn(m.get(), function (n, e) {
	          var i = e.split("."),
	              t = i[0];-1 !== o.indexOf(t) && (1 < i.length ? (a.hasOwnProperty(t) || (a[t] = {}), a[t][i[1]] = n) : a[e] = n);
	        }), gn(a, "prefill") && ln(["card[number]", "card[cvv]", "card[expiry]"], function (n) {
	          gn(a.prefill, n) && (a.prefill[n] = !0);
	        }), a.image && H(a.image) && (a.image = "base64");var r = m.get("external.wallets") || [];a.external_wallets = (n = r, hn(function (n, e) {
	          var i;return i = n, Rn(e, !0)(i);
	        }, {})(n)), function (n, e) {
	          var i,
	              t,
	              a,
	              o = n._payment;o && (o.payment_id && (e.payment_id = o.payment_id), i = o, Dn("magicPossible")(i) && (e.magic_possible = o.magicPossible), t = o, Dn("isMagicPayment")(t) && (e.magic_attempted = o.isMagicPayment), a = o, Dn("magicCoproto")(a) && (e.magic_coproto = o.magicCoproto));
	        }(m, t), Re && (t.local_order_id = Re), Le({ event: u, properties: t, timestamp: G() }), Ne(e), l && we();
	      }) : Ke.push([u, c, l]);
	    }n(function () {
	      we();
	    }, 1e3), Be.dispatchPendingEvents = function (n) {
	      if (n) {
	        var e = Be.bind(Be, n);Ke.splice(0, Ke.length).forEach(function (n) {
	          e.apply(Be, n);
	        });
	      }
	    }, Be.parseAnalyticsData = function (n) {
	      var e;w(n) && (e = n, kn(function (n, e) {
	        Se[n] = e;
	      })(e));
	    }, Be.makeUid = De, Be.common = Me, Be.props = Se, Be.id = Re, Be.updateUid = function (n) {
	      Be.id = Re = n;
	    }, Be.flush = we;var Ae,
	        Te = {},
	        Ce = { setR: function setR(n) {
	        Be.dispatchPendingEvents(Ae = n);
	      }, track: function track(n, e) {
	        var i = void 0 === e ? {} : e,
	            t = i.type,
	            a = i.data,
	            o = void 0 === a ? {} : a,
	            r = i.r,
	            m = void 0 === r ? Ae : r,
	            u = i.immediately,
	            c = void 0 !== u && u,
	            l = function (n) {
	          var i = Ln(n);return kn(i, function (n, e) {
	            K(n) && (i[e] = n.call());
	          }), i;
	        }(Te);(o = w(o) ? function (n) {
	          return I(Pn(n));
	        }(o) : { data: o }).meta && w(o.meta) && (l = Kn(l, o.meta)), o.meta = l, t && (n = t + ":" + n), Be(m, n, o, c);
	      }, setMeta: function setMeta(n, e) {
	        Rn(Te, n, e);
	      }, removeMeta: function removeMeta(n) {
	        Mn(Te, n);
	      }, getMeta: function getMeta() {
	        return function (n) {
	          var e = {};return kn(n, function (i, n) {
	            var t = (n = n.replace(/\[([^[\]]+)\]/g, ".$1")).split("."),
	                a = e;ln(t, function (n, e) {
	              e < t.length - 1 ? (a[n] || (a[n] = {}), a = a[n]) : a[n] = i;
	            });
	          }), e;
	        }(Te);
	      } };function $e() {
	      return this._evts = {}, this._defs = {}, this;
	    }$e.prototype = { onNew: vn, def: function def(n, e) {
	        this._defs[n] = e;
	      }, on: function on(n, e) {
	        if (P(n) && K(e)) {
	          var i = this._evts;i[n] || (i[n] = []), !1 !== this.onNew(n, e) && i[n].push(e);
	        }return this;
	      }, once: function once(n, e) {
	        var i = e,
	            t = this,
	            a = function a() {
	          i.apply(t, arguments), t.off(n, a);
	        };return e = a, this.on(n, e);
	      }, off: function off(i, n) {
	        var e = arguments.length;if (!e) return $e.call(this);var t = this._evts;if (2 === e) {
	          var a = t[i];if (!K(n) || !N(a)) return;if (a.splice(sn(a, n), 1), a.length) return;
	        }return t[i] ? delete t[i] : (i += ".", kn(t, function (n, e) {
	          e.indexOf(i) || delete t[e];
	        })), this;
	      }, emit: function emit(n, e) {
	        var i = this;return ln(this._evts[n], function (n) {
	          try {
	            n.call(i, e);
	          } catch (n) {
	            console.error;
	          }
	        }), this;
	      }, emitter: function emitter() {
	        var n = this,
	            e = arguments;return function () {
	          n.emit.apply(n, e);
	        };
	      } };var Ge = p.userAgent,
	        Ee = p.vendor;function xe(n) {
	      return n.test(Ge);
	    }xe(/MSIE |Trident\//);var ze = xe(/iPhone/),
	        Fe = ze || xe(/iPad/),
	        He = (xe(/Android/), xe(/Safari/), xe(/firefox/), xe(/Chrome/) && /Google Inc/.test(Ee), xe(/; wv\) |Gecko\) Version\/[^ ]+ Chrome|Windows Phone|Opera Mini|UCBrowser|FBAN|CriOS/) || Fe || xe(/Android 4/)),
	        Oe = (xe(/iPhone/), Ge.match(/Chrome\/(\d+)/));Oe = Oe && d(Oe[1], 10);var Ue = { key: "", account_id: "", image: "", amount: 100, currency: "INR", order_id: "", invoice_id: "", subscription_id: "", payment_link_id: "", notes: null, callback_url: "", redirect: !1, description: "", customer_id: "", recurring: null, payout: null, contact_id: "", signature: "", retry: !0, target: "", subscription_card_change: null, display_currency: "", display_amount: "", recurring_token: { max_amount: 0, expire_by: 0 } };function Ze(n, e, i, t) {
	      var a = e[i = i.toLowerCase()],
	          o = typeof a === "undefined" ? "undefined" : _typeof(a);"object" == o && null === a ? P(t) && ("true" === t || "1" === t ? t = !0 : "false" !== t && "0" !== t || (t = !1)) : "string" == o && (k(t) || M(t)) ? t = r(t) : "number" == o ? t = m(t) : "boolean" == o && (P(t) ? "true" === t || "1" === t ? t = !0 : "false" !== t && "0" !== t || (t = !1) : k(t) && (t = !!t)), null !== a && o != (typeof t === "undefined" ? "undefined" : _typeof(t)) || (n[i] = t);
	    }function Ie(n, t) {
	      var a = {};return kn(n, function (n, i) {
	        i in Ye ? kn(n, function (n, e) {
	          Ze(a, t, i + "." + e, n);
	        }) : Ze(a, t, i, n);
	      }), a;
	    }var Ye = {};function je(i) {
	      kn(Ue, function (n, i) {
	        w(n) && !B(n) && (Ye[i] = !0, kn(n, function (n, e) {
	          Ue[i + "." + e] = n;
	        }), delete Ue[i]);
	      }), (i = Ie(i, Ue)).callback_url && He && (i.redirect = !0), this.get = function (n) {
	        return arguments.length ? n in i ? i[n] : Ue[n] : i;
	      }, this.set = function (n, e) {
	        i[n] = e;
	      }, this.unset = function (n) {
	        delete i[n];
	      };
	    }function We(t, a) {
	      return void 0 === a && (a = "."), function (n) {
	        for (var e = a, i = 0; i < t; i++) {
	          e += "0";
	        }return n.replace(e, "");
	      };
	    }function qe(n, e) {
	      return void 0 === e && (e = ","), n.replace(/\./, e);
	    }var Je = { AED: { code: "784", denomination: 100, min_value: 10, min_auth_value: 100, symbol: "د.إ", name: "Emirati Dirham" }, ALL: { code: "008", denomination: 100, min_value: 221, min_auth_value: 100, symbol: "Lek", name: "Albanian Lek" }, AMD: { code: "051", denomination: 100, min_value: 975, min_auth_value: 100, symbol: "֏", name: "Armenian Dram" }, ARS: { code: "032", denomination: 100, min_value: 80, min_auth_value: 100, symbol: "$", name: "Argentine Peso" }, AUD: { code: "036", denomination: 100, min_value: 50, min_auth_value: 100, symbol: "$", name: "Australian Dollar" }, AWG: { code: "533", denomination: 100, min_value: 10, min_auth_value: 100, symbol: "ƒ", name: "Aruban or Dutch Guilder" }, BBD: { code: "052", denomination: 100, min_value: 10, min_auth_value: 100, symbol: "$", name: "Barbadian or Bajan Dollar" }, BDT: { code: "050", denomination: 100, min_value: 168, min_auth_value: 100, symbol: "৳", name: "Bangladeshi Taka" }, BMD: { code: "060", denomination: 100, min_value: 10, min_auth_value: 100, symbol: "$", name: "Bermudian Dollar" }, BND: { code: "096", denomination: 100, min_value: 10, min_auth_value: 100, symbol: "B$", name: "Bruneian Dollar" }, BOB: { code: "068", denomination: 100, min_value: 14, min_auth_value: 100, symbol: "Bs", name: "Bolivian Bolíviano" }, BSD: { code: "044", denomination: 100, min_value: 10, min_auth_value: 100, symbol: "B$", name: "Bahamian Dollar" }, BWP: { code: "072", denomination: 100, min_value: 22, min_auth_value: 100, symbol: "P", name: "Botswana Pula" }, BZD: { code: "084", denomination: 100, min_value: 10, min_auth_value: 100, symbol: "BZ$", name: "Belizean Dollar" }, CAD: { code: "124", denomination: 100, min_value: 50, min_auth_value: 100, symbol: "C$", name: "Canadian Dollar" }, CHF: { code: "756", denomination: 100, min_value: 50, min_auth_value: 100, symbol: "₣", name: "Swiss Franc" }, CNY: { code: "156", denomination: 100, min_value: 14, min_auth_value: 100, symbol: "¥", name: "Chinese Yuan Renminbi" }, COP: { code: "170", denomination: 100, min_value: 1e3, min_auth_value: 100, symbol: "$", name: "Colombian Peso" }, CRC: { code: "188", denomination: 100, min_value: 1e3, min_auth_value: 100, symbol: "₡", name: "Costa Rican Colon" }, CUP: { code: "192", denomination: 100, min_value: 53, min_auth_value: 100, symbol: "$", name: "Cuban Peso" }, CZK: { code: "203", denomination: 100, min_value: 46, min_auth_value: 100, symbol: "Kč", name: "Czech Koruna" }, DKK: { code: "208", denomination: 100, min_value: 250, min_auth_value: 100, symbol: "kr", name: "Danish Krone" }, DOP: { code: "214", denomination: 100, min_value: 102, min_auth_value: 100, symbol: "$", name: "Dominican Peso" }, DZD: { code: "012", denomination: 100, min_value: 239, min_auth_value: 100, symbol: "د.ج", name: "Algerian Dinar" }, EGP: { code: "818", denomination: 100, min_value: 35, min_auth_value: 100, symbol: "£", name: "Egyptian Pound" }, ETB: { code: "230", denomination: 100, min_value: 57, min_auth_value: 100, symbol: "ብር", name: "Ethiopian Birr" }, EUR: { code: "978", denomination: 100, min_value: 50, min_auth_value: 100, symbol: "€", name: "Euro" }, FJD: { code: "242", denomination: 100, min_value: 10, min_auth_value: 100, symbol: "FJ$", name: "Fijian Dollar" }, GBP: { code: "826", denomination: 100, min_value: 30, min_auth_value: 100, symbol: "£", name: "British Pound" }, GIP: { code: "292", denomination: 100, min_value: 10, min_auth_value: 100, symbol: "£", name: "Gibraltar Pound" }, GMD: { code: "270", denomination: 100, min_value: 100, min_auth_value: 100, symbol: "D", name: "Gambian Dalasi" }, GTQ: { code: "320", denomination: 100, min_value: 16, min_auth_value: 100, symbol: "Q", name: "Guatemalan Quetzal" }, GYD: { code: "328", denomination: 100, min_value: 418, min_auth_value: 100, symbol: "G$", name: "Guyanese Dollar" }, HKD: { code: "344", denomination: 100, min_value: 400, min_auth_value: 100, symbol: "HK$", name: "Hong Kong Dollar" }, HNL: { code: "340", denomination: 100, min_value: 49, min_auth_value: 100, symbol: "L", name: "Honduran Lempira" }, HRK: { code: "191", denomination: 100, min_value: 14, min_auth_value: 100, symbol: "kn", name: "Croatian Kuna" }, HTG: { code: "332", denomination: 100, min_value: 167, min_auth_value: 100, symbol: "G", name: "Haitian Gourde" }, HUF: { code: "348", denomination: 100, min_value: 555, min_auth_value: 100, symbol: "Ft", name: "Hungarian Forint" }, IDR: { code: "360", denomination: 100, min_value: 1e3, min_auth_value: 100, symbol: "Rp", name: "Indonesian Rupiah" }, ILS: { code: "376", denomination: 100, min_value: 10, min_auth_value: 100, symbol: "₪", name: "Israeli Shekel" }, INR: { code: "356", denomination: 100, min_value: 100, min_auth_value: 100, symbol: "₹", name: "Indian Rupee" }, JMD: { code: "388", denomination: 100, min_value: 250, min_auth_value: 100, symbol: "$", name: "Jamaican Dollar" }, KES: { code: "404", denomination: 100, min_value: 201, min_auth_value: 100, symbol: "Ksh", name: "Kenyan Shilling" }, KGS: { code: "417", denomination: 100, min_value: 140, min_auth_value: 100, symbol: "Лв", name: "Kyrgyzstani Som" }, KHR: { code: "116", denomination: 100, min_value: 1e3, min_auth_value: 100, symbol: "៛", name: "Cambodian Riel" }, KYD: { code: "136", denomination: 100, min_value: 10, min_auth_value: 100, symbol: "$", name: "Caymanian Dollar" }, KZT: { code: "398", denomination: 100, min_value: 759, min_auth_value: 100, symbol: "₸", name: "Kazakhstani Tenge" }, LAK: { code: "418", denomination: 100, min_value: 1e3, min_auth_value: 100, symbol: "₭", name: "Lao Kip" }, LBP: { code: "422", denomination: 100, min_value: 1e3, min_auth_value: 100, symbol: "&#1604;.&#1604;.", name: "Lebanese Pound" }, LKR: { code: "144", denomination: 100, min_value: 358, min_auth_value: 100, symbol: "රු", name: "Sri Lankan Rupee" }, LRD: { code: "430", denomination: 100, min_value: 325, min_auth_value: 100, symbol: "L$", name: "Liberian Dollar" }, LSL: { code: "426", denomination: 100, min_value: 29, min_auth_value: 100, symbol: "L", name: "Basotho Loti" }, MAD: { code: "504", denomination: 100, min_value: 20, min_auth_value: 100, symbol: "د.م.", name: "Moroccan Dirham" }, MDL: { code: "498", denomination: 100, min_value: 35, min_auth_value: 100, symbol: "L", name: "Moldovan Leu" }, MKD: { code: "807", denomination: 100, min_value: 109, min_auth_value: 100, symbol: "ден", name: "Macedonian Denar" }, MMK: { code: "104", denomination: 100, min_value: 1e3, min_auth_value: 100, symbol: "K", name: "Burmese Kyat" }, MNT: { code: "496", denomination: 100, min_value: 1e3, min_auth_value: 100, symbol: "₮", name: "Mongolian Tughrik" }, MOP: { code: "446", denomination: 100, min_value: 17, min_auth_value: 100, symbol: "P", name: "Macau Pataca" }, MUR: { code: "480", denomination: 100, min_value: 70, min_auth_value: 100, symbol: "Rs", name: "Mauritian Rupee" }, MVR: { code: "462", denomination: 100, min_value: 31, min_auth_value: 100, symbol: "Rf", name: "Maldivian Rufiyaa" }, MWK: { code: "454", denomination: 100, min_value: 1e3, min_auth_value: 100, symbol: "MK", name: "Malawian Kwacha" }, MXN: { code: "484", denomination: 100, min_value: 39, min_auth_value: 100, symbol: "Mex$", name: "Mexican Peso" }, MYR: { code: "458", denomination: 100, min_value: 10, min_auth_value: 100, symbol: "RM", name: "Malaysian Ringgit" }, NAD: { code: "516", denomination: 100, min_value: 29, min_auth_value: 100, symbol: "N$", name: "Namibian Dollar" }, NGN: { code: "566", denomination: 100, min_value: 723, min_auth_value: 100, symbol: "₦", name: "Nigerian Naira" }, NIO: { code: "558", denomination: 100, min_value: 66, min_auth_value: 100, symbol: "C$", name: "Nicaraguan Cordoba" }, NOK: { code: "578", denomination: 100, min_value: 300, min_auth_value: 100, symbol: "kr", name: "Norwegian Krone" }, NPR: { code: "524", denomination: 100, min_value: 221, min_auth_value: 100, symbol: "रू", name: "Nepalese Rupee" }, NZD: { code: "554", denomination: 100, min_value: 50, min_auth_value: 100, symbol: "$", name: "New Zealand Dollar" }, PEN: { code: "604", denomination: 100, min_value: 10, min_auth_value: 100, symbol: "S/", name: "Peruvian Sol" }, PGK: { code: "598", denomination: 100, min_value: 10, min_auth_value: 100, symbol: "K", name: "Papua New Guinean Kina" }, PHP: { code: "608", denomination: 100, min_value: 106, min_auth_value: 100, symbol: "₱", name: "Philippine Peso" }, PKR: { code: "586", denomination: 100, min_value: 227, min_auth_value: 100, symbol: "Rs", name: "Pakistani Rupee" }, QAR: { code: "634", denomination: 100, min_value: 10, min_auth_value: 100, symbol: "QR", name: "Qatari Riyal" }, RUB: { code: "643", denomination: 100, min_value: 130, min_auth_value: 100, symbol: "₽", name: "Russian Ruble" }, SAR: { code: "682", denomination: 100, min_value: 10, min_auth_value: 100, symbol: "SR", name: "Saudi Arabian Riyal" }, SCR: { code: "690", denomination: 100, min_value: 28, min_auth_value: 100, symbol: "SRe", name: "Seychellois Rupee" }, SEK: { code: "752", denomination: 100, min_value: 300, min_auth_value: 100, symbol: "kr", name: "Swedish Krona" }, SGD: { code: "702", denomination: 100, min_value: 50, min_auth_value: 100, symbol: "S$", name: "Singapore Dollar" }, SLL: { code: "694", denomination: 100, min_value: 1e3, min_auth_value: 100, symbol: "Le", name: "Sierra Leonean Leone" }, SOS: { code: "706", denomination: 100, min_value: 1e3, min_auth_value: 100, symbol: "Sh.so.", name: "Somali Shilling" }, SSP: { code: "728", denomination: 100, min_value: 100, min_auth_value: 100, symbol: "£", name: "South Sudanese Pound" }, SVC: { code: "222", denomination: 100, min_value: 18, min_auth_value: 100, symbol: "$", name: "Salvadoran Colon" }, SZL: { code: "748", denomination: 100, min_value: 29, min_auth_value: 100, symbol: "L", name: "Swazi Lilangeni" }, THB: { code: "764", denomination: 100, min_value: 64, min_auth_value: 100, symbol: "฿", name: "Thai Baht" }, TTD: { code: "780", denomination: 100, min_value: 14, min_auth_value: 100, symbol: "$", name: "Trinidadian Dollar" }, TZS: { code: "834", denomination: 100, min_value: 1e3, min_auth_value: 100, symbol: "Sh", name: "Tanzanian Shilling" }, USD: { code: "840", denomination: 100, min_value: 50, min_auth_value: 100, symbol: "$", name: "US Dollar" }, UYU: { code: "858", denomination: 100, min_value: 67, min_auth_value: 100, symbol: "$", name: "Uruguayan Peso" }, UZS: { code: "860", denomination: 100, min_value: 1e3, min_auth_value: 100, symbol: "so'm", name: "Uzbekistani Som" }, YER: { code: "886", denomination: 100, min_value: 501, min_auth_value: 100, symbol: "﷼", name: "Yemeni Rial" }, ZAR: { code: "710", denomination: 100, min_value: 29, min_auth_value: 100, symbol: "R", name: "South African Rand" } },
	        Ve = { three: function three(n, e) {
	        var i;return i = r(n).replace(new RegExp("(.{1,3})(?=(...)+(\\..{" + e + "})$)", "g"), "$1,"), We(e)(i);
	      }, threecommadecimal: function threecommadecimal(n, e) {
	        var i;return i = qe(r(n)).replace(new RegExp("(.{1,3})(?=(...)+(\\,.{" + e + "})$)", "g"), "$1."), We(e, ",")(i);
	      }, threespaceseparator: function threespaceseparator(n, e) {
	        var i;return i = r(n).replace(new RegExp("(.{1,3})(?=(...)+(\\..{" + e + "})$)", "g"), "$1 "), We(e)(i);
	      }, threespacecommadecimal: function threespacecommadecimal(n, e) {
	        var i;return i = qe(r(n)).replace(new RegExp("(.{1,3})(?=(...)+(\\,.{" + e + "})$)", "g"), "$1 "), We(e, ",")(i);
	      }, szl: function szl(n, e) {
	        var i;return i = r(n).replace(new RegExp("(.{1,3})(?=(...)+(\\..{" + e + "})$)", "g"), "$1, "), We(e)(i);
	      }, chf: function chf(n, e) {
	        var i;return i = r(n).replace(new RegExp("(.{1,3})(?=(...)+(\\..{" + e + "})$)", "g"), "$1'"), We(e)(i);
	      }, inr: function inr(n, e) {
	        var i;return i = r(n).replace(new RegExp("(.{1,2})(?=.(..)+(\\..{" + e + "})$)", "g"), "$1,"), We(e)(i);
	      }, none: function none(n) {
	        return r(n);
	      } },
	        Qe = { default: { decimals: 2, format: Ve.three, minimum: 100 }, AED: { minor: "fil", minimum: 10 }, AFN: { minor: "pul" }, ALL: { minor: "qindarka", minimum: 221 }, AMD: { minor: "luma", minimum: 975 }, ANG: { minor: "cent" }, AOA: { minor: "lwei" }, ARS: { format: Ve.threecommadecimal, minor: "centavo", minimum: 80 }, AUD: { format: Ve.threespaceseparator, minimum: 50, minor: "cent" }, AWG: { minor: "cent", minimum: 10 }, AZN: { minor: "qäpik" }, BAM: { minor: "fenning" }, BBD: { minor: "cent", minimum: 10 }, BDT: { minor: "paisa", minimum: 168 }, BGN: { minor: "stotinki" }, BHD: { decimals: 3, minor: "fils" }, BIF: { decimals: 0, major: "franc", minor: "centime" }, BMD: { minor: "cent", minimum: 10 }, BND: { minor: "sen", minimum: 10 }, BOB: { minor: "centavo", minimum: 14 }, BRL: { format: Ve.threecommadecimal, minimum: 50, minor: "centavo" }, BSD: { minor: "cent", minimum: 10 }, BTN: { minor: "chetrum" }, BWP: { minor: "thebe", minimum: 22 }, BYR: { decimals: 0, major: "ruble" }, BZD: { minor: "cent", minimum: 10 }, CAD: { minimum: 50, minor: "cent" }, CDF: { minor: "centime" }, CHF: { format: Ve.chf, minimum: 50, minor: "rappen" }, CLP: { decimals: 0, format: Ve.none, major: "peso", minor: "centavo" }, CNY: { minor: "jiao", minimum: 14 }, COP: { format: Ve.threecommadecimal, minor: "centavo", minimum: 1e3 }, CRC: { format: Ve.threecommadecimal, minor: "centimo", minimum: 1e3 }, CUC: { minor: "centavo" }, CUP: { minor: "centavo", minimum: 53 }, CVE: { minor: "centavo" }, CZK: { format: Ve.threecommadecimal, minor: "haler", minimum: 46 }, DJF: { decimals: 0, major: "franc", minor: "centime" }, DKK: { minimum: 250, minor: "øre" }, DOP: { minor: "centavo", minimum: 102 }, DZD: { minor: "centime", minimum: 239 }, EGP: { minor: "piaster", minimum: 35 }, ERN: { minor: "cent" }, ETB: { minor: "cent", minimum: 57 }, EUR: { minimum: 50, minor: "cent" }, FJD: { minor: "cent", minimum: 10 }, FKP: { minor: "pence" }, GBP: { minimum: 30, minor: "pence" }, GEL: { minor: "tetri" }, GIP: { minor: "pence", minimum: 10 }, GMD: { minor: "butut" }, GTQ: { minor: "centavo", minimum: 16 }, GYD: { minor: "cent", minimum: 418 }, HKD: { minimum: 400, minor: "cent" }, HNL: { minor: "centavo", minimum: 49 }, HRK: { format: Ve.threecommadecimal, minor: "lipa", minimum: 14 }, HTG: { minor: "centime", minimum: 167 }, HUF: { decimals: 0, format: Ve.none, major: "forint", minimum: 555 }, IDR: { format: Ve.threecommadecimal, minor: "sen", minimum: 1e3 }, ILS: { minor: "agorot", minimum: 10 }, INR: { format: Ve.inr, minor: "paise" }, IQD: { decimals: 3, minor: "fil" }, IRR: { minor: "rials" }, ISK: { decimals: 0, format: Ve.none, major: "króna", minor: "aurar" }, JMD: { minor: "cent", minimum: 250 }, JOD: { decimals: 3, minor: "fil" }, JPY: { decimals: 0, minimum: 50, minor: "sen" }, KES: { minor: "cent", minimum: 201 }, KGS: { minor: "tyyn", minimum: 140 }, KHR: { minor: "sen", minimum: 1e3 }, KMF: { decimals: 0, major: "franc", minor: "centime" }, KPW: { minor: "chon" }, KRW: { decimals: 0, major: "won", minor: "chon" }, KWD: { decimals: 3, minor: "fil" }, KYD: { minor: "cent", minimum: 10 }, KZT: { minor: "tiyn", minimum: 759 }, LAK: { minor: "at", minimum: 1e3 }, LBP: { format: Ve.threespaceseparator, minor: "piastre", minimum: 1e3 }, LKR: { minor: "cent", minimum: 358 }, LRD: { minor: "cent", minimum: 325 }, LSL: { minor: "lisente", minimum: 29 }, LTL: { format: Ve.threespacecommadecimal, minor: "centu" }, LVL: { minor: "santim" }, LYD: { decimals: 3, minor: "dirham" }, MAD: { minor: "centime", minimum: 20 }, MDL: { minor: "ban", minimum: 35 }, MGA: { decimals: 0, major: "ariary" }, MKD: { minor: "deni" }, MMK: { minor: "pya", minimum: 1e3 }, MNT: { minor: "mongo", minimum: 1e3 }, MOP: { minor: "avo", minimum: 17 }, MRO: { minor: "khoum" }, MUR: { minor: "cent", minimum: 70 }, MVR: { minor: "lari", minimum: 31 }, MWK: { minor: "tambala", minimum: 1e3 }, MXN: { minor: "centavo", minimum: 39 }, MYR: { minor: "sen", minimum: 10 }, MZN: { decimals: 0, major: "metical" }, NAD: { minor: "cent", minimum: 29 }, NGN: { minor: "kobo", minimum: 723 }, NIO: { minor: "centavo", minimum: 66 }, NOK: { format: Ve.threecommadecimal, minimum: 300, minor: "øre" }, NPR: { minor: "paise", minimum: 221 }, NZD: { minimum: 50, minor: "cent" }, OMR: { minor: "baiza", decimals: 3 }, PAB: { minor: "centesimo" }, PEN: { minor: "centimo", minimum: 10 }, PGK: { minor: "toea", minimum: 10 }, PHP: { minor: "centavo", minimum: 106 }, PKR: { minor: "paisa", minimum: 227 }, PLN: { format: Ve.threespacecommadecimal, minor: "grosz" }, PYG: { decimals: 0, major: "guarani", minor: "centimo" }, QAR: { minor: "dirham", minimum: 10 }, RON: { format: Ve.threecommadecimal, minor: "bani" }, RUB: { format: Ve.threecommadecimal, minor: "kopeck", minimum: 130 }, RWF: { decimals: 0, major: "franc", minor: "centime" }, SAR: { minor: "halalat", minimum: 10 }, SBD: { minor: "cent" }, SCR: { minor: "cent", minimum: 28 }, SEK: { format: Ve.threespacecommadecimal, minimum: 300, minor: "öre" }, SGD: { minimum: 50, minor: "cent" }, SHP: { minor: "new pence" }, SLL: { minor: "cent", minimum: 1e3 }, SOS: { minor: "centesimi", minimum: 1e3 }, SRD: { minor: "cent" }, STD: { minor: "centimo" }, SSP: { minor: "piaster" }, SVC: { minor: "centavo", minimum: 18 }, SYP: { minor: "piaster" }, SZL: { format: Ve.szl, minor: "cent", minimum: 29 }, THB: { minor: "satang", minimum: 64 }, TJS: { minor: "diram" }, TMT: { minor: "tenga" }, TND: { decimals: 3, minor: "millime" }, TOP: { minor: "seniti" }, TRY: { minor: "kurus" }, TTD: { minor: "cent", minimum: 14 }, TWD: { minor: "cent" }, TZS: { minor: "cent", minimum: 1e3 }, UAH: { format: Ve.threespacecommadecimal, minor: "kopiyka" }, UGX: { minor: "cent" }, USD: { minimum: 50, minor: "cent" }, UYU: { format: Ve.threecommadecimal, minor: "centé", minimum: 67 }, UZS: { minor: "tiyin", minimum: 1e3 }, VND: { format: Ve.none, minor: "hao,xu" }, VUV: { decimals: 0, major: "vatu", minor: "centime" }, WST: { minor: "sene" }, XAF: { decimals: 0, major: "franc", minor: "centime" }, XCD: { minor: "cent" }, XPF: { decimals: 0, major: "franc", minor: "centime" }, YER: { minor: "fil", minimum: 501 }, ZAR: { format: Ve.threespaceseparator, minor: "cent", minimum: 29 }, ZMK: { minor: "ngwee" } },
	        Xe = function Xe(n) {
	      return Qe[n] ? Qe[n] : Qe.default;
	    },
	        ni = ["AED", "ALL", "AMD", "ARS", "AUD", "AWG", "BBD", "BDT", "BMD", "BND", "BOB", "BSD", "BWP", "BZD", "CAD", "CHF", "CNY", "COP", "CRC", "CUP", "CZK", "DKK", "DOP", "DZD", "EGP", "ETB", "EUR", "FJD", "GBP", "GIP", "GMD", "GTQ", "GYD", "HKD", "HNL", "HRK", "HTG", "HUF", "IDR", "ILS", "INR", "JMD", "KES", "KGS", "KHR", "KYD", "KZT", "LAK", "LBP", "LKR", "LRD", "LSL", "MAD", "MDL", "MKD", "MMK", "MNT", "MOP", "MUR", "MVR", "MWK", "MXN", "MYR", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "PEN", "PGK", "PHP", "PKR", "QAR", "RUB", "SAR", "SCR", "SEK", "SGD", "SLL", "SOS", "SSP", "SVC", "SZL", "THB", "TTD", "TZS", "USD", "UYU", "UZS", "YER", "ZAR"],
	        ei = { AED: "د.إ", AFN: "&#x60b;", ALL: "Lek", AMD: "֏", ANG: "ƒ", AOA: "Kz", ARS: "$", AUD: "$", AWG: "ƒ", AZN: "ман", BAM: "KM", BBD: "$", BDT: "৳", BGN: "лв", BHD: "د.ب", BIF: "FBu", BMD: "$", BND: "B$", BOB: "Bs.", BRL: "R$", BSD: "B$", BTN: "Nu.", BWP: "P", BYR: "Br", BZD: "BZ$", CAD: "C$", CDF: "FC", CHF: "F", CLP: "$", CNY: "¥", COP: "$", CRC: "₡", CUC: "&#x20b1;", CUP: "$", CVE: "Esc", CZK: "Kč", DJF: "Fdj", DKK: "kr", DOP: "$", DZD: "د.ج", EGP: "£", ERN: "Nfa", ETB: "ብር", EUR: "€", FJD: "FJ$", FKP: "FK&#163;", GBP: "£", GEL: "ლ", GHS: "&#x20b5;", GIP: "£", GMD: "D", GNF: "FG", GTQ: "Q", GYD: "G$", HKD: "HK$", HNL: "L", HRK: "kn", HTG: "G", HUF: "Ft", IDR: "Rp", ILS: "₪", INR: "₹", IQD: "ع.د", IRR: "&#xfdfc;", ISK: "Kr", JMD: "$", JOD: "د.ا", JPY: "&#165;", KES: "Ksh", KGS: "Лв", KHR: "៛", KMF: "CF", KPW: "₩", KRW: "₩", KWD: "د.ك", KYD: "$", KZT: "₸", LAK: "₭", LBP: "&#1604;.&#1604;.", LD: "ل.د", LKR: "රු", LRD: "L$", LSL: "L", LTL: "Lt", LVL: "Ls", LYD: "ل.د", MAD: "د.م.", MDL: "L", MGA: "Ar", MKD: "ден", MMK: "K", MNT: "₮", MOP: "P", MRO: "UM", MUR: "Ɍs", MVR: "Rf", MWK: "MK", MXN: "Mex$", MYR: "RM", MZN: "MT", NAD: "N$", NGN: "₦", NIO: "C$", NOK: "kr", NPR: "रू", NZD: "$", OMR: "ر.ع.", PAB: "B/.", PEN: "S/", PGK: "K", PHP: "₱", PKR: "Ɍs", PLN: "Zł", PYG: "&#x20b2;", QAR: "QR", RON: "L", RSD: "Дин.", RUB: "₽", RWF: "RF", SAR: "SR", SBD: "SI$", SCR: "SRe", SDG: "&#163;Sd", SEK: "kr", SFR: "Fr", SGD: "S$", SHP: "&#163;", SLL: "Le", SOS: "Sh.so.", SRD: "$", SSP: "£", STD: "Db", SVC: "$", SYP: "S&#163;", SZL: "L", THB: "฿", TJS: "SM", TMT: "M", TND: "د.ت", TOP: "T$", TRY: "TL", TTD: "$", TWD: "NT$", TZS: "Sh", UAH: "&#x20b4;", UGX: "USh", USD: "$", UYU: "$", UZS: "so'm", VEF: "Bs", VND: "&#x20ab;", VUV: "VT", WST: "T", XAF: "CFA", XCD: "EC$", XOF: "CFA", XPF: "F", YER: "﷼", ZAR: "R", ZMK: "ZK", ZWL: "Z$" };function ii(n, e) {
	      return ei[e] + " " + function (n, e) {
	        var i = Xe(e),
	            t = n / u.pow(10, i.decimals);return i.format(t.toFixed(i.decimals), i.decimals);
	      }(n, e);
	    }kn(Je, function (n, e) {
	      Qe[e] && (Qe[e].minimum = Je[e].min_value);
	    }), kn(Je, function (n, e) {
	      ei[e] && (ei[e] = Je[e].symbol);
	    }), kn(ei, function (n, e) {
	      var i, t;Qe[e] = (t = {}, i = Kn(Qe.default)(t), Kn(Qe[e] || {})(i)), Qe[e].code = e, ei[e] && (Qe[e].symbol = ei[e]);
	    }), hn(ni, function (n, e) {
	      return n[e] = ei[e], n;
	    }, {});var ti = { api: "https://api.razorpay.com/", version: "v1/", frameApi: "/", cdn: "https://cdn.razorpay.com/" };try {
	      Kn(ti, l.Razorpay.config);
	    } catch (n) {}function ai(n) {
	      return void 0 === n && (n = ""), ti.api + ti.version + n;
	    }var oi = ["key", "order_id", "invoice_id", "subscription_id", "payment_link_id", "contact_id"];function ri(e) {
	      if (!$(this, ri)) return new ri(e);var i;$e.call(this), this.id = Be.makeUid(), Ce.setR(this);try {
	        i = function (n) {
	          n && "object" == (typeof n === "undefined" ? "undefined" : _typeof(n)) || F("Invalid options");var e = new je(n);return function (t, a) {
	            void 0 === a && (a = []);t = t.get(), kn(li, function (n, e) {
	              if (!dn(a, e) && e in t) {
	                var i = n(t[e], t);i && (!1, F("Invalid " + e + " (" + i + ")"));
	              }
	            });
	          }(e, ["amount"]), function (n) {
	            var i = n.get("notes");kn(i, function (n, e) {
	              P(n) ? 254 < n.length && (i[e] = n.slice(0, 254)) : k(n) || M(n) || delete i[e];
	            });
	          }(e), e;
	        }(e), this.get = i.get, this.set = i.set;
	      } catch (n) {
	        var t = n.message;this.get && this.isLiveMode() || w(e) && !e.parent && l.alert(t), F(t);
	      }oi.every(function (n) {
	        return !i.get(n);
	      }) && F("No key passed"), this.postInit();
	    }var mi = ri.prototype = new $e();function ui(n, e) {
	      return _e.jsonp({ url: ai("preferences"), data: n, callback: e });
	    }function ci(n) {
	      if (n) {
	        var i = n.get,
	            t = {},
	            e = i("key");e && (t.key_id = e);var a = [i("currency")],
	            o = i("display_currency"),
	            r = i("display_amount");return o && ("" + r).length && a.push(o), t.currency = a, ln(["order_id", "customer_id", "invoice_id", "payment_link_id", "subscription_id", "recurring", "subscription_card_change", "account_id", "contact_id"], function (n) {
	          var e = i(n);e && (t[n] = e);
	        }), t;
	      }
	    }mi.postInit = vn, mi.onNew = function (n, e) {
	      var i = this;"ready" === n && (this.prefs ? e(n, this.prefs) : ui(ci(this), function (n) {
	        n.methods && (i.prefs = n, i.methods = n.methods), e(i.prefs, n);
	      }));
	    }, mi.emi_calculator = function (n, e) {
	      return ri.emi.calculator(this.get("amount") / 100, n, e);
	    }, ri.emi = { calculator: function calculator(n, e, i) {
	        if (!i) return u.ceil(n / e);i /= 1200;var t = u.pow(1 + i, e);return d(n * i * t / (t - 1), 10);
	      } }, ri.payment = { getMethods: function getMethods(e) {
	        return ui({ key_id: ri.defaults.key }, function (n) {
	          e(n.methods || n);
	        });
	      }, getPrefs: function getPrefs(e, i) {
	        return _e({ url: U(ai("preferences"), e), callback: function callback(n) {
	            if (n.xhr && 0 === n.xhr.status) return ui(e, i);i(n);
	          } });
	      } }, mi.isLiveMode = function () {
	      var n = this.preferences;return !n && /^rzp_l/.test(this.get("key")) || n && "live" === n.mode;
	    };var li = { notes: function notes(n) {
	        if (w(n) && 15 < T(Z(n))) return "At most 15 notes are allowed";
	      }, amount: function amount(n, e) {
	        var i = e.display_currency || e.currency || "INR",
	            t = Xe(i),
	            a = t.minimum,
	            o = "";if (t.decimals && t.minor ? o = " " + t.minor : t.major && (o = " " + t.major), !function (n, e) {
	          return void 0 === e && (e = 100), !/[^0-9]/.test(n) && e <= (n = d(n, 10));
	        }(n, a) && !e.recurring) return "should be passed in integer" + o + ". Minimum value is " + a + o + ", i.e. " + ii(a, i);
	      }, currency: function currency(n) {
	        if (!dn(ni, n)) return "The provided currency is not currently supported";
	      }, display_currency: function display_currency(n) {
	        if (!(n in ei) && n !== ri.defaults.display_currency) return "This display currency is not supported";
	      }, display_amount: function display_amount(n) {
	        if (!(n = r(n).replace(/([^0-9.])/g, "")) && n !== ri.defaults.display_amount) return "";
	      }, payout: function payout(n, e) {
	        if (n) {
	          if (!e.key) return "key is required for a Payout";if (!e.contact_id) return "contact_id is required for a Payout";
	        }
	      } };ri.configure = function (n) {
	      kn(Ie(n, Ue), function (n, e) {
	        _typeof(Ue[e]) == (typeof n === "undefined" ? "undefined" : _typeof(n)) && (Ue[e] = n);
	      });
	    }, ri.defaults = Ue, l.Razorpay = ri, Ue.timeout = 0, Ue.name = "", Ue.partnership_logo = "", Ue.ecod = !1, Ue.nativeotp = !0, Ue.remember_customer = !1, Ue.personalization = !1, Ue.paused = !1, Ue.min_amount_label = "", Ue.method = { netbanking: null, card: !0, cardless_emi: null, wallet: null, emi: !0, upi: !0, upi_intent: null, qr: !0, bank_transfer: !0 }, Ue.prefill = { amount: "", wallet: "", provider: "", method: "", name: "", contact: "", email: "", vpa: "", "card[number]": "", "card[expiry]": "", "card[cvv]": "", bank: "", "bank_account[name]": "", "bank_account[account_number]": "", "bank_account[account_type]": "", "bank_account[ifsc]": "", auth_type: "" }, Ue.features = { cardsaving: !0 }, Ue.readonly = { contact: !1, email: !1, name: !1 }, Ue.hidden = { contact: !1, email: !1 }, Ue.modal = { confirm_close: !1, ondismiss: vn, onhidden: vn, escape: !0, animation: !0, backdropclose: !1, handleback: !0 }, Ue.external = { wallets: [], handler: vn }, Ue.theme = { upi_only: !1, color: "", backdrop_color: "rgba(0,0,0,0.6)", image_padding: !0, image_frame: !0, close_button: !0, close_method_back: !1, hide_topbar: !1, branding: "", debit_card: !1 }, Ue._ = { integration: null, integration_version: null, integration_parent_version: null };var si,
	        di,
	        fi,
	        hi,
	        vi = l,
	        pi = vi.screen,
	        _i = vi.scrollTo,
	        yi = ze,
	        bi = { overflow: "", metas: null, orientationchange: function orientationchange() {
	        bi.resize.call(this), bi.scroll.call(this);
	      }, resize: function resize() {
	        var n = l.innerHeight || pi.height;Ri.container.style.position = n < 450 ? "absolute" : "fixed", this.el.style.height = u.max(n, 460) + "px";
	      }, scroll: function scroll() {
	        if ("number" == typeof l.pageYOffset) if (l.innerHeight < 460) {
	          var n = 460 - l.innerHeight;l.pageYOffset > 120 + n && ce(n);
	        } else this.isFocused || ce(0);
	      } };function gi() {
	      return bi.metas || (bi.metas = re('head meta[name=viewport],head meta[name="theme-color"]')), bi.metas;
	    }function Di(n) {
	      try {
	        Ri.backdrop.style.background = n;
	      } catch (n) {}
	    }function Ri(n) {
	      if (si = c.body, di = c.head, fi = si.style, n) return this.getEl(n), this.openRzp(n);this.getEl(), this.time = G();
	    }Ri.prototype = { getEl: function getEl(n) {
	        if (!this.el) {
	          var e,
	              i = { style: "opacity: 1; height: 100%; position: relative; background: none; display: block; border: 0 none transparent; margin: 0px; padding: 0px; z-index: 2;", allowtransparency: !0, frameborder: 0, width: "100%", height: "100%", allowpaymentrequest: !0, src: function (n) {
	              var e = ti.frame;if (!e) {
	                e = ai("checkout");var i = ci(n);i ? e = U(e, i) : e += "/public";
	              }return e;
	            }(n), class: "razorpay-checkout-frame" };this.el = (e = wn("iframe"), Un(i)(e));
	        }return this.el;
	      }, openRzp: function openRzp(n) {
	        var e,
	            i,
	            t,
	            a,
	            o,
	            r = (e = this.el, Zn({ width: "100%", height: "100%" })(e)),
	            m = n.get("parent"),
	            u = (m = m && j(m)) || Ri.container;(function (n, e) {
	          if (!hi) try {
	            var i;(hi = c.createElement("div")).className = "razorpay-loader";var t = "margin:-25px 0 0 -25px;height:50px;width:50px;animation:rzp-rot 1s infinite linear;-webkit-animation:rzp-rot 1s infinite linear;border: 1px solid rgba(255, 255, 255, 0.2);border-top-color: rgba(255, 255, 255, 0.7);border-radius: 50%;";t += e ? "margin: 100px auto -150px;border: 1px solid rgba(0, 0, 0, 0.2);border-top-color: rgba(0, 0, 0, 0.7);" : "position:absolute;left:50%;top:50%;", hi.setAttribute("style", t), i = hi, En(n)(i);
	          } catch (n) {}
	        })(u, m), n !== this.rzp && (Bn(r) !== u && (o = u, xn(r)(o)), this.rzp = n);m ? (i = r, On("minHeight", "530px")(i), this.embedded = !0) : (a = u, t = On("display", "block")(a), jn(t), Di(n.get("theme.backdrop_color")), /^rzp_t/.test(n.get("key")) && Ri.ribbon && (Ri.ribbon.style.opacity = 1), this.setMetaAndOverflow()), this.bind(), this.onload();
	      }, makeMessage: function makeMessage() {
	        var n = this.rzp,
	            i = n.get(),
	            e = { integration: Be.props.integration, referer: _.href, options: i, id: n.id };return n.metadata && (e.metadata = n.metadata), kn(n.modal.options, function (n, e) {
	          i["modal." + e] = n;
	        }), this.embedded && (delete i.parent, e.embedded = !0), function (n) {
	          var e = n.image;if (e && P(e)) {
	            if (H(e)) return;if (e.indexOf("http")) {
	              var i = _.protocol + "//" + _.hostname + (_.port ? ":" + _.port : ""),
	                  t = "";"/" !== e[0] && "/" !== (t += _.pathname.replace(/[^/]*$/g, ""))[0] && (t = "/" + t), n.image = i + t + e;
	            }
	          }
	        }(i), e;
	      }, close: function close() {
	        Di(""), Ri.ribbon && (Ri.ribbon.style.opacity = 0), function (n) {
	          n && ln(n, zn);var e = gi();e && ln(e, En(di));
	        }(this.$metas), fi.overflow = bi.overflow, this.unbind(), yi && _i(0, bi.oldY), Be.flush();
	      }, bind: function bind() {
	        var t = this;if (!this.listeners) {
	          this.listeners = [];var n = {};yi && (n.orientationchange = bi.orientationchange, this.rzp.get("parent") || (n.resize = bi.resize)), kn(n, function (n, e) {
	            var i;t.listeners.push((i = window, Y(e, pn(n, t))(i)));
	          });
	        }
	      }, unbind: function unbind() {
	        (function (n) {
	          ln(n, function (n) {
	            return n();
	          });
	        })(this.listeners), this.listeners = null;
	      }, setMetaAndOverflow: function setMetaAndOverflow() {
	        var n, e;di && (ln(gi(), function (n) {
	          return zn(n);
	        }), this.$metas = [(n = wn("meta"), Un({ name: "viewport", content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" })(n)), (e = wn("meta"), Un({ name: "theme-color", content: this.rzp.get("theme.color") })(e))], ln(this.$metas, En(di)), bi.overflow = fi.overflow, fi.overflow = "hidden", yi && (bi.oldY = l.pageYOffset, l.scrollTo(0, 0), bi.orientationchange.call(this)));
	      }, postMessage: function postMessage(n) {
	        n.id = this.rzp.id, n = Pn(n), this.el.contentWindow.postMessage(n, "*");
	      }, onmessage: function onmessage(n) {
	        var e = I(n.data);if (e) {
	          var i = e.event,
	              t = this.rzp;n.origin && "frame" === e.source && n.source === this.el.contentWindow && (e = e.data, this["on" + i](e), "dismiss" !== i && "fault" !== i || Ce.track(i, { data: e, r: t, immediately: !0 }));
	        }
	      }, onload: function onload() {
	        this.rzp && this.postMessage(this.makeMessage());
	      }, onfocus: function onfocus() {
	        this.isFocused = !0;
	      }, onblur: function onblur() {
	        this.isFocused = !1, bi.orientationchange.call(this);
	      }, onrender: function onrender() {
	        hi && (zn(hi), hi = null), this.rzp.emit("render");
	      }, onevent: function onevent(n) {
	        this.rzp.emit(n.event, n.data);
	      }, onredirect: function onredirect(n) {
	        Be.flush(), function (n) {
	          if (!n.target && l !== l.parent) return l.Razorpay.sendMessage({ event: "redirect", data: n });me(n.url, n.content, n.method, n.target);
	        }(n);
	      }, onsubmit: function onsubmit(e) {
	        Be.flush();var i = this.rzp;"wallet" === e.method && ln(i.get("external.wallets"), function (n) {
	          if (n === e.wallet) try {
	            i.get("external.handler").call(i, e);
	          } catch (n) {}
	        }), i.emit("payment.submit", { method: e.method });
	      }, ondismiss: function ondismiss(n) {
	        this.close();var e = this.rzp.get("modal.ondismiss");K(e) && a(function () {
	          return e(n);
	        });
	      }, onhidden: function onhidden() {
	        Be.flush(), this.afterClose();var n = this.rzp.get("modal.onhidden");K(n) && n();
	      }, oncomplete: function oncomplete(n) {
	        this.close();var e = this.rzp,
	            i = e.get("handler");Ce.track("checkout_success", { r: e, data: n, immediately: !0 }), K(i) && a(function () {
	          i.call(e, n);
	        }, 200);
	      }, onpaymenterror: function onpaymenterror(n) {
	        Be.flush();try {
	          this.rzp.emit("payment.error", n), this.rzp.emit("payment.failed", n);
	        } catch (n) {}
	      }, onfailure: function onfailure(n) {
	        this.ondismiss(), l.alert("Payment Failed.\n" + n.error.description), this.onhidden();
	      }, onfault: function onfault(n) {
	        var e = "Something went wrong.";P(n) ? e = n : L(n) && (n.message || n.description) && (e = n.message || n.description), Be.flush(), this.rzp.close();var i = this.rzp.get("callback_url");(this.rzp.get("redirect") || He) && i ? me(i, { error: n }, "post") : l.alert("Oops! Something went wrong.\n" + e), this.afterClose();
	      }, afterClose: function afterClose() {
	        Ri.container.style.display = "none";
	      }, onflush: function onflush(n) {
	        Be.flush();
	      } };var Si,
	        Mi = C(ri);function ki(e) {
	      return function n() {
	        return Si ? e.call(this) : (a(pn(n, this), 99), this);
	      };
	    }!function n() {
	      (Si = c.body || c.getElementsByTagName("body")[0]) || a(n, 99);
	    }();var Pi,
	        Ki,
	        Li,
	        Ni = c.currentScript || (Pi = re("script"))[Pi.length - 1];function wi(n) {
	      var e, i, t, a;t = Bn(Ni), i = xn((a = wn(), In(ue(n))(a)))(t), e = Rn("onsubmit", vn)(i), Fn(e);
	    }function Bi(m) {
	      var n, e, i;e = Bn(Ni), n = xn((i = wn("input"), Kn({ type: "submit", value: m.get("buttontext"), className: "razorpay-payment-button" })(i)))(e), Rn("onsubmit", function (n) {
	        n.preventDefault();var e = this.action,
	            i = this.method,
	            t = this.target,
	            a = m.get();if (P(e) && e && !a.callback_url) {
	          var o = { url: e, content: function (n) {
	              return hn(n.querySelectorAll("[name]"), function (n, e) {
	                return n[e.name] = e.value, n;
	              }, {});
	            }(this), method: P(i) ? i : "get", target: P(t) && t };try {
	            var r = h(Pn({ request: o, options: Pn(a), back: _.href }));a.callback_url = ai("checkout/onyx") + "?data=" + r;
	          } catch (n) {}
	        }return m.open(), !1;
	      })(n);
	    }function Ai() {
	      if (!Ki) {
	        var n, e, i, t;t = wn(), i = Rn("className", "razorpay-container")(t), e = Rn("innerHTML", "<style>@keyframes rzp-rot{to{transform: rotate(360deg);}}@-webkit-keyframes rzp-rot{to{-webkit-transform: rotate(360deg);}}</style>")(i), n = Zn({ zIndex: 1e9, position: "fixed", top: 0, display: "none", left: 0, height: "100%", width: "100%", "-webkit-overflow-scrolling": "touch", "-webkit-backface-visibility": "hidden", "overflow-y": "visible" })(e), Ki = En(Si)(n);var a = function (n) {
	          var e, i, t;return t = wn(), i = Rn("className", "razorpay-backdrop")(t), e = Zn({ "min-height": "100%", transition: "0.3s ease-out", position: "fixed", top: 0, left: 0, width: "100%", height: "100%" })(i), En(n)(e);
	        }(Ri.container = Ki),
	            o = function (n) {
	          var e,
	              i,
	              t,
	              a = "rotate(45deg)",
	              o = "opacity 0.3s ease-in";return t = wn("span"), i = Rn("innerHTML", "Test Mode")(t), e = Zn({ "text-decoration": "none", background: "#D64444", border: "1px dashed white", padding: "3px", opacity: "0", "-webkit-transform": a, "-moz-transform": a, "-ms-transform": a, "-o-transform": a, transform: a, "-webkit-transition": o, "-moz-transition": o, transition: o, "font-family": "lato,ubuntu,helvetica,sans-serif", color: "white", position: "absolute", width: "200px", "text-align": "center", right: "-50px", top: "50px" })(i), En(n)(e);
	        }(Ri.backdrop = a);Ri.ribbon = o;
	      }return Ki;
	    }function Ti(n) {
	      var e, i;return Li ? Li.openRzp(n) : (Li = new Ri(n), e = l, Y("message", pn("onmessage", Li))(e), i = Ki, xn(Li.el)(i)), Li;
	    }ri.open = function (n) {
	      return ri(n).open();
	    }, Mi.postInit = function () {
	      this.modal = { options: {} }, this.get("parent") && this.open();
	    };var Ci = Mi.onNew;Mi.onNew = function (n, e) {
	      "payment.error" === n && Be(this, "event_paymenterror", _.href), K(Ci) && Ci.call(this, n, e);
	    }, Mi.open = ki(function () {
	      this.metadata || (this.metadata = {}), this.metadata.openedAt = e.now();var n = this.checkoutFrame = Ti(this);return Be(this, "open"), n.el.contentWindow || (n.close(), n.afterClose(), l.alert("This browser is not supported.\nPlease try payment in another browser.")), "-new.js" === Ni.src.slice(-7) && Be(this, "oldscript", _.href), this;
	    }), Mi.resume = function (n) {
	      var e = this.checkoutFrame;e && e.postMessage({ event: "resume", data: n });
	    }, Mi.close = function () {
	      var n = this.checkoutFrame;n && n.postMessage({ event: "close" });
	    };var $i = ki(function () {
	      Ai(), Li = Ti();try {
	        !function () {
	          var a = {};kn(Ni.attributes, function (n) {
	            var e = n.name.toLowerCase();if (/^data-/.test(e)) {
	              var i = a;e = e.replace(/^data-/, "");var t = n.value;"true" === t ? t = !0 : "false" === t && (t = !1), /^notes\./.test(e) && (a.notes || (a.notes = {}), i = a.notes, e = e.replace(/^notes\./, "")), i[e] = t;
	            }
	          });var n = a.key;if (n && 0 < n.length) {
	            a.handler = wi;var e = ri(a);a.parent || Bi(e);
	          }
	        }();
	      } catch (n) {}
	    });Be.props.library = "checkoutjs", Ue.handler = function (n) {
	      if ($(this, ri)) {
	        var e = this.get("callback_url");e && me(e, n, "post");
	      }
	    }, Ue.buttontext = "Pay Now", Ue.parent = null, li.parent = function (n) {
	      if (!j(n)) return "parent provided for embedded mode doesn't exist";
	    }, $i();
	  }();
	}();

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactWebVectorIcons = __webpack_require__(29);
	
	var _reactWebVectorIcons2 = _interopRequireDefault(_reactWebVectorIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Coupon_Details = function (_Component) {
	  _inherits(Coupon_Details, _Component);
	
	  function Coupon_Details(props) {
	    _classCallCheck(this, Coupon_Details);
	
	    var _this = _possibleConstructorReturn(this, (Coupon_Details.__proto__ || Object.getPrototypeOf(Coupon_Details)).call(this, props));
	
	    _this.state = {
	      coupon_details: [],
	      coupon_status: false
	    };
	    return _this;
	  }
	
	  _createClass(Coupon_Details, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      if (screen.width <= 800) {
	        window.location.href = "/coupon/details/" + this.props.params.Cid;
	      }
	
	      var data1 = { from: 'mobile_web', cid: this.props.params.Cid };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getCouponDetails',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	
	          //  var coupon = $.makeArray(data.coupon_details);
	          //this.setState({
	          //	coupon_details:coupon[0],
	          //}); */}
	          if (data.status === "success") {
	            var coupon = _jquery2.default.makeArray(data.coupon_details);
	            this.setState({
	              coupon_details: coupon[0]
	            });
	          } else if (data.status === "error") {
	            this.setState({
	              coupon_status: true
	            });
	          }
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'chatnow',
	    value: function chatnow() {
	      if (localStorage.user_id) {
	        var uid = localStorage.getItem('user_id');
	      } else {
	        uid = 0;
	      }
	
	      if (!localStorage.user_id && !localStorage.token) {
	        // if(this.props.params.Bname)
	        // {
	        //   localStorage.setItem('m_r_p_dt','/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Bname+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.DealId)   
	        // }
	        // else
	        // {
	        //   localStorage.setItem('m_r_p_dt','/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.DealId)
	        // }
	        // localStorage.setItem('mob_addtocart','1');
	        // localStorage.setItem('mob_addtocart_qty',this.state.min_qty);
	        _reactRouter.browserHistory.push('/login/' + this.state.wb_url);
	      } else {
	        location.href = this.state.wb_url;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      //document.title ="AquaDeals Customer Care";
	      //document.getElementsByTagName("META")[2].content="AquaDeals Customer Care";
	      return _react2.default.createElement(
	        'div',
	        { className: 'lgt_gry web_deals web_coupon_details_page' },
	        _react2.default.createElement(_WebHeaderInner2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6 col-md-offset-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dels_cntnt web_coupon_details_page' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'del_rgt_blk' },
	                  _react2.default.createElement('div', { className: 'clr' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'del_dtl' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: '' },
	                      !this.state.coupon_status ? _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'section',
	                          { className: 'container-fluid coupon_details_main' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row coupon_img' },
	                            _react2.default.createElement('img', { src: baseAssets + "images/" + this.state.coupon_details.img, role: 'presentation', alt: '' })
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'row coupon_details' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'col-md-12 coupon_specs' },
	                              this.state.coupon_details.code ? _react2.default.createElement(
	                                'ul',
	                                { id: 'coupon_label' },
	                                _react2.default.createElement(
	                                  'span',
	                                  null,
	                                  _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement('img', { src: __webpack_require__(254), alt: '...' })
	                                  ),
	                                  _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    this.state.coupon_details.code
	                                  )
	                                )
	                              ) : '',
	                              this.state.coupon_details.coupon_title ? _react2.default.createElement(
	                                'h4',
	                                null,
	                                this.state.coupon_details.coupon_title,
	                                this.state.coupon_details.status == 1 ? _react2.default.createElement(
	                                  'span',
	                                  { className: 'coupon_status_active' },
	                                  'ACTIVE'
	                                ) : _react2.default.createElement(
	                                  'span',
	                                  { className: 'coupon_status_expired' },
	                                  'EXPIRED'
	                                )
	                              ) : '',
	                              this.state.coupon_details.date_time_msg ? _react2.default.createElement(
	                                'h3',
	                                null,
	                                this.state.coupon_details.date_time_msg
	                              ) : ''
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'coupon_specs_sub_bg' },
	                          _react2.default.createElement(
	                            'section',
	                            { className: 'coupon_specs_sub' },
	                            this.state.coupon_details.applied_on_name !== 0 ? _react2.default.createElement(
	                              'h5',
	                              null,
	                              this.state.coupon_details.applied_on_name,
	                              this.state.coupon_details.value !== 0 ? '' : ''
	                            ) : '',
	                            this.state.coupon_details.quantity_msg !== 0 ? _react2.default.createElement(
	                              'h5',
	                              null,
	                              _react2.default.createElement(_reactWebVectorIcons2.default, {
	                                name: 'circle',
	                                font: 'MaterialCommunityIcons',
	                                color: '#ccc',
	                                size: 14,
	                                style: { paddingRight: '3px', top: '1', position: 'relative' }
	                              }),
	                              this.state.coupon_details.quantity_msg,
	                              ' '
	                            ) : '',
	                            this.state.coupon_details.applied_on_catname !== 0 ? _react2.default.createElement(
	                              'h5',
	                              null,
	                              _react2.default.createElement(_reactWebVectorIcons2.default, {
	                                name: 'circle',
	                                font: 'MaterialCommunityIcons',
	                                color: '#ccc',
	                                size: 14,
	                                style: { paddingRight: '3px', top: '1', position: 'relative' }
	                              }),
	                              this.state.coupon_details.applied_on_catname
	                            ) : ''
	                          ),
	                          _react2.default.createElement('div', { className: 'coupon_dots_blocks' }),
	                          _react2.default.createElement(
	                            'section',
	                            { className: 'container-fluid' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'row coupon_description_blk' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 col-xs-12 col-sm-12 coupon_description_head' },
	                                this.state.coupon_details.desc ? _react2.default.createElement(
	                                  'h4',
	                                  null,
	                                  this.state.coupon_details.desc
	                                ) : ''
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'clr' },
	                          '\xA0'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'clr' },
	                          '\xA0'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'clr' },
	                          '\xA0'
	                        )
	                      ) : _react2.default.createElement(
	                        'div',
	                        { className: 'row', style: { textAlign: 'center', color: '#555', margin: '30% auto' } },
	                        'No Coupons Available'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'clr' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cust_car_ftr' },
	          _react2.default.createElement(_WebFooter2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return Coupon_Details;
	}(_react.Component);
	
	exports.default = Coupon_Details;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _pdeals_list = __webpack_require__(219);
	
	var _pdeals_list2 = _interopRequireDefault(_pdeals_list);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import  SubHeaderMain  from './../Common/SubHeaderMain.js';
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Web_OffersDetails = function (_Component) {
	    _inherits(Web_OffersDetails, _Component);
	
	    function Web_OffersDetails(props) {
	        _classCallCheck(this, Web_OffersDetails);
	
	        var _this = _possibleConstructorReturn(this, (Web_OffersDetails.__proto__ || Object.getPrototypeOf(Web_OffersDetails)).call(this, props));
	
	        _this.state = {
	            feedsList: [],
	            fulldata: [],
	            feedbrands: [],
	            feed_sub_cat: [],
	            feedcat: [],
	            todata: '',
	            types: [],
	            tid: _this.props.params.Tid,
	            lod: false,
	            type: _this.props.params.Type,
	            dtype: _this.props.params.DType,
	            data_type: _this.props.params.DType,
	            ofr_type: _this.props.params.Offer,
	            bread: '',
	            activeMenu: '',
	            selected: '',
	            loading: false,
	            loadmore_number: 2,
	            loadmore_status: 0,
	            set_type: '',
	            next_page: '',
	            loading_gif: false,
	            h1_desc: ''
	        };
	        localStorage.setItem('d_type', _this.props.params.Dtype);
	        _this.loadMoreDeals = _this.loadMoreDeals.bind(_this);
	        _this.getDeviceId = _this.getDeviceId.bind(_this);
	        _this.getBrands_Categories = _this.getBrands_Categories.bind(_this);
	        return _this;
	    }
	
	    _createClass(Web_OffersDetails, [{
	        key: 'getBrands_Categories',
	        value: function getBrands_Categories() {
	            var data1 = { from: 'desktop_web', type: 4 };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'getbrands_categoires',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	                    this.setState({
	                        feedbrands: data.brands,
	                        feedcat: data.categories
	                    });
	                }.bind(this),
	                error: function error(err) {}
	            });
	        }
	    }, {
	        key: 'getTypes',
	        value: function getTypes() {
	            var data1 = { from: 'desktop_web' };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'getTypes',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	                    this.setState({
	                        types: data.types
	                    });
	                }.bind(this),
	                error: function error(err) {
	                    // console.log("Error"+err);
	                }
	            });
	        }
	    }, {
	        key: 'getDeviceId',
	        value: function getDeviceId() {
	            if (localStorage.user_id) {
	                var user_id = localStorage.user_id;
	            } else {
	                user_id = 0;
	            }
	            var data1 = { from: 'desktop_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'getDeviceId',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function success(data) {},
	                error: function error(err) {}
	            });
	        }
	    }, {
	        key: 'loadMoreDeals',
	        value: function loadMoreDeals(num, type, tid, dtype) {
	            this.setState({
	                loading_gif: true
	            });
	            var getfunc = "";
	            var data1 = "";
	            var data2 = "";
	            var uid = 0;
	            if (localStorage.user_id) {
	                uid = localStorage.getItem('user_id');
	            } else {
	                uid = 0;
	            }
	            if (type === ">=") {
	                data1 = { from: 'desktop_web', uid: uid, page: num, type: dtype, limit: 20 };
	                data2 = JSON.stringify(data1);
	                getfunc = "getNewsearch";
	            }
	
	            var products = "";
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + getfunc,
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	                    this.setState({
	                        offer: data,
	                        todata: data,
	                        loading: true,
	                        title: data.cat_name,
	                        desc: data.cat_desc,
	                        selected: data.cat_name,
	                        loadmore_status: data.load_more,
	                        set_type: data.set_type,
	                        next_page: data.next_page,
	                        loading_gif: false
	                    });
	                    this.setState({
	                        feedsList: this.state.feedsList.concat(data.result)
	                    });
	                }.bind(this),
	                error: function error(err) {
	                    // console.log(err);
	                    this.setState({
	                        loading_gif: false
	                    });
	                }
	            });
	            return products;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            localStorage.removeItem('w_r_s_dt');
	            localStorage.removeItem('w_r_e_coupon_dt');
	            localStorage.removeItem('w_r_e_s_dt');
	            localStorage.removeItem('web_mycart');
	            localStorage.removeItem('w_r_enq_seller_page');
	            localStorage.removeItem('w_r_p_dt');
	            localStorage.removeItem('w_r_e_p_dt');
	            localStorage.removeItem('web_ofr_page');
	            localStorage.removeItem('profile');
	            localStorage.removeItem('myaquacash');
	            localStorage.removeItem('web_share_earn');
	            localStorage.removeItem('checkout');
	            localStorage.removeItem('order_details');
	            localStorage.removeItem('myorders');
	            localStorage.removeItem('w_r_p_deals');
	            localStorage.removeItem('seed');
	            localStorage.removeItem('nauplii');
	            localStorage.removeItem('subdeals');
	            localStorage.removeItem('shipping');
	            localStorage.removeItem('notifications');
	            localStorage.removeItem('web_quickcart');
	            localStorage.removeItem('view_rating');
	            localStorage.removeItem('w_modal_seed');
	            localStorage.removeItem('w_r_seed_deals');
	            localStorage.removeItem('w_r_e_p_dt');
	            localStorage.removeItem('w_modal_details');
	
	            localStorage.removeItem('give_rating');
	            localStorage.removeItem('pprice');
	            localStorage.removeItem('sprice');
	            localStorage.removeItem('seed_id');
	            localStorage.removeItem('h_type');
	            localStorage.removeItem('web_pro_ofr_dtls');
	            localStorage.removeItem('web_wishlist');
	            localStorage.removeItem('web_brand_details');
	
	            localStorage.removeItem('m_r_s_dt');
	            localStorage.removeItem('m_r_e_coupon_dt');
	            localStorage.removeItem('m_r_e_s_dt');
	            localStorage.removeItem('mob_mycart');
	            localStorage.removeItem('m_r_enq_seller_page');
	            localStorage.removeItem('m_r_p_dt');
	            localStorage.removeItem('m_r_e_p_dt');
	            localStorage.removeItem('ofr_page');
	            localStorage.removeItem('pro_ofr_dtls');
	
	            localStorage.removeItem('share_earn');
	            localStorage.removeItem('my_orders');
	            localStorage.removeItem('m_r_p_deals');
	            localStorage.removeItem('mob_quickcart');
	            localStorage.removeItem('partner_deals');
	            if (screen.width < 800) {
	                window.location.href = "/offers/deals/" + this.props.params.Tid + "/" + this.props.params.Type + "/" + this.props.params.DType;
	            }
	            if (!localStorage.token && !localStorage.user_id) {
	                localStorage.setItem('offers', '/web/offers/deals/' + this.props.params.Tid + '/' + this.props.params.Type + '/' + this.props.params.DType);
	            }
	
	            this.getBrands_Categories();
	            this.getDeviceId();
	            var uid = 0;
	            if (localStorage.user_id) {
	                uid = localStorage.getItem('user_id');
	            } else {
	                uid = 0;
	            }
	            (0, _jquery2.default)(window).scrollTop(0);
	            var self = this;
	            setTimeout(function () {
	                self.setState({ lod: true });
	            }, 15000);
	            localStorage.setItem('d_type', this.props.params.Dtype);
	            this.getTypes();
	            var data1 = { from: 'desktop_web', uid: uid, discount: this.props.params.Tid, discount_type: this.props.params.DType, discount_opr: this.props.params.Type };
	            var data2 = JSON.stringify(data1);
	            var get_function = 'getNewsearch';
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + get_function,
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data1) {
	                    if (data1.products) {
	                        this.setState({
	                            feedsList: data1.products,
	                            offer: data1,
	                            todata: data1,
	                            loading: true,
	                            h1_desc: data1.product_name
	                        });
	                    } else {
	                        this.setState({
	                            feedsList: data1.result,
	                            offer: data1,
	                            todata: data1,
	                            loading: true
	                        });
	                    }
	                }.bind(this),
	                error: function error(err) {
	                    // console.log("Error"+err);
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            // console.log(this.state.feedsList);
	            //     var products=this.state.feedsList.map(function(product,index){ 
	
	            //       return(
	
	            //             <div className="col-md-3 col-sm-3 col-xs-3 eq_cls">
	            //             {product.pid ?
	            //                 <div className="itm_lst_grd">
	            //                  {product.dealcount >= 2 ? 
	            //                 <Link key={product.index} to={"/web/subdeals/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.dtype+"/"+product.url_brand_name+"/"+product.pid)}>
	            //                         <div className="itm_img">
	            //                                 <img className="itm_img" alt="Deals" src={baseAssets+'images/product_imgs/thumbnails/'+product.image}/>
	            //                         </div>
	            //                         <h2>{product.title}</h2>
	            //                         <h5>{product.brand_name}</h5>
	            //                         {product.dealcount >=2 ? <h3>{product.dealcount} deals available</h3> : ''}
	            //                         <div className="clr">&nbsp;</div>
	            //                         {product.over_rate >=1 ? <h6  className="w_star_rate"><i><img src={baseAssets+'images/web_imgs/star_filled.png'} width="17px" role="presentation"/></i>{product.over_rate}</h6>: <h6 className="w_nostar_rate"><i><img src={baseAssets+'images/web_imgs/star_gray.png'} width="17px" role="presentation"/></i></h6>}
	            //                         {product.count >0 ? <h6 className="views_eye"><i><img src={baseAssets+'images/web_imgs/eye.png'} width="17px" role="presentation"/></i> {product.count} {product.count >1 ? 'Views' : 'View'}</h6> : ''}
	            //                         <div className="clr"></div>
	            //                 </Link> :    
	            //         <Link key={product.index} to={"/web/pdetails/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.pid+"/"+product.deal_id}>
	            //                     <div className="itm_img">
	            //                         <img className="itm_img" alt="Deals" src={baseAssets+'images/product_imgs/thumbnails/'+product.image}/>
	            //                     </div>
	            //                     <h2>{product.title}</h2>
	            //                     <h5>{product.brand_name}</h5>
	            //                    {product.pricediff ?  <h3><span>AquaCash Discount</span>&nbsp;<span>&#8377;{product.pricediff}</span></h3> : ''}
	            //               {product.pricediff ==="" ? <h3>MRP &#8377; {product.mrp}</h3> : ''}
	            //               <div className="clr">&nbsp;</div>
	            //               {product.over_rate >=1 ? <h6  className="w_star_rate"><i><img src={baseAssets+'images/web_imgs/star_filled.png'} width="17px" role="presentation"/></i>{product.over_rate}</h6>: <h6  className="w_nostar_rate" ><i><img src={baseAssets+'images/web_imgs/star_gray.png'} width="17px" role="presentation"/></i></h6>}
	            //               {product.count >0 ? <h6 className="views_eye" ><i><img src={baseAssets+'images/web_imgs/eye.png'} width="17px" role="presentation"/></i> {product.count} {product.count >1 ? 'Views' : 'View'}</h6> : ''}
	
	            //               <div className="clr"></div>
	            //         </Link>
	            //          <Link className="share_btn" onClick={()=>{this.ShareFunc(product.deal_id)}}>
	            //               <img src={baseAssets+'images/web_imgs/share.png'} alt="Share" />
	            //             </Link>
	            //             <Panel className="share_panel" collapsible expanded={this.state.open}>
	            //               <FacebookShareButton url={shareUrl} quote={title} className="test_share">
	            //                 <FacebookIcon size={32} round />
	            //               </FacebookShareButton>
	            //               <TwitterShareButton url={shareUrl} quote={title} className="test_share">
	            //                 <TwitterIcon size={32} round />
	            //               </TwitterShareButton>
	            //               <GooglePlusShareButton url={shareUrl} quote={title} description={description} className="test_share">
	            //                 <GooglePlusIcon  size={32} round />
	            //               </GooglePlusShareButton>
	            //             </Panel>
	            //     } 
	            //     </div>
	            //   );
	            // })
	            var brands = this.state.feedbrands.map(function (brand, index) {
	                return _react2.default.createElement(
	                    'li',
	                    { key: brand.id, id: "brand_" + brand.id },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: "/web/pdeals/" + brand.url_dtype_name + "/" + brand.url_name + "/" + brand.id + "/" + brand.type + "/" + brand.dtype },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            brand.category_name
	                        )
	                    )
	                );
	            });
	            var cate = this.state.feedcat.map(function (cat, index) {
	                if (cat.sub.length > 0) {
	                    var subs_cat = cat.sub.map(function (sub_cat, index) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: sub_cat.id, id: "sub_cat_" + sub_cat.id },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: "/web/pdeals/" + sub_cat.url_dtype_name + "/" + sub_cat.url_name + "/" + sub_cat.id + "/" + sub_cat.type + "/" + sub_cat.dtype },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    sub_cat.category_name
	                                )
	                            )
	                        );
	                    });
	                    return _react2.default.createElement(
	                        'li',
	                        { key: cat.id, id: "cat_" + cat.id },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                cat.category_name
	                            )
	                        ),
	                        subs_cat
	                    );
	                } else {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: cat.id, id: "cat_" + cat.id },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: "/web/pdeals/" + cat.url_dtype_name + "/" + cat.url_name + "/" + cat.id + "/" + cat.type + "/" + cat.dtype },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                cat.category_name
	                            )
	                        )
	                    );
	                }
	            }.bind(this));
	            var products = '';
	            if (this.state.feedsList.length > 0) {
	                products = this.state.feedsList.map(function (product, index) {
	                    return _react2.default.createElement(_pdeals_list2.default, { key: product.id, data: product });
	                });
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'web_deals web_pdeals_page' },
	                this.state.loading ? _react2.default.createElement(
	                    'div',
	                    { className: 'lgt_gry' },
	                    _react2.default.createElement(_WebHeaderInner2.default, null),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'section',
	                        { className: 'container Dels_cntnt', style: { paddingLeft: 0 } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'tot_pro' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row', style: { marginRight: '0 !important' } },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3 col-sm-3' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'filtrs_blk' },
	                                        _react2.default.createElement(
	                                            'h3',
	                                            null,
	                                            'Categories'
	                                        ),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            null,
	                                            cate
	                                        ),
	                                        _react2.default.createElement(
	                                            'h3',
	                                            null,
	                                            'Brands'
	                                        ),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: brands.length > 10 ? 'flt_scrl' : 'no_scrl' },
	                                            brands
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'pro_sec col-md-9 col-sm-9' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'pro_sec_hdr' },
	                                        _react2.default.createElement(
	                                            'h3',
	                                            null,
	                                            this.state.h1_desc,
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                '(',
	                                                this.state.feedsList.length,
	                                                ' Items)'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement('div', { className: 'clr' }),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row itm_lst' },
	                                        this.state.loading_gif ? _react2.default.createElement(
	                                            'i',
	                                            { className: 'web_loading_gif' },
	                                            _react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
	                                        ) : '',
	                                        products ? products : _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            this.state.lod ? _react2.default.createElement(
	                                                'div',
	                                                { className: 'seed_no_data' },
	                                                'No Deals Available'
	                                            ) : _react2.default.createElement(
	                                                'div',
	                                                { className: 'loading_sym', style: { width: 100 + '%', textAlign: 'center', marginTop: 15 + '%' } },
	                                                _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/ajax-loader.gif', alt: 'AquaDeals', role: 'presentation' })
	                                            )
	                                        )
	                                    ),
	                                    this.state.loadmore_status === 1 ? _react2.default.createElement(
	                                        'div',
	                                        { className: 'web_loadmore_button', onClick: function onClick() {
	                                                _this2.setState({ loadmore_number: _this2.state.loadmore_number + 1 });_this2.loadMoreDeals(_this2.state.next_page, _this2.state.set_type, _this2.props.params.Tid, _this2.props.params.DType);
	                                            } },
	                                        _react2.default.createElement('i', { className: 'glyphicon glyphicon-circle-arrow-down' }),
	                                        'Load More Deals'
	                                    ) : ''
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: 'clr' }),
	                    _react2.default.createElement(_WebFooter2.default, null)
	                ) : _react2.default.createElement(
	                    'div',
	                    { className: 'loading_sym', style: { width: 100 + '%', textAlign: 'center', marginTop: 20 + '%' } },
	                    _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/ajax-loader1.gif', alt: 'Loading Deals', role: 'presentation' }),
	                    ' '
	                )
	            );
	        }
	    }]);
	
	    return Web_OffersDetails;
	}(_react.Component);
	
	exports.default = Web_OffersDetails;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _pdeals_list = __webpack_require__(219);
	
	var _pdeals_list2 = _interopRequireDefault(_pdeals_list);
	
	var _reactInfiniteScrollComponent = __webpack_require__(57);
	
	var _reactInfiniteScrollComponent2 = _interopRequireDefault(_reactInfiniteScrollComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	// "/web/pdeals/:BrandName/:CatName/:Tid/:Type/:DType";
	// "/web/pdeals/:BrandName/:Type/:DType";
	// "/web/pdeals/brands/:BrandName/:Bid";
	
	
	var Web_ProductDetails = function (_Component) {
	    _inherits(Web_ProductDetails, _Component);
	
	    function Web_ProductDetails(props) {
	        _classCallCheck(this, Web_ProductDetails);
	
	        var _this = _possibleConstructorReturn(this, (Web_ProductDetails.__proto__ || Object.getPrototypeOf(Web_ProductDetails)).call(this, props));
	
	        _this.state = {
	            feedsList: [],
	            fulldata: [],
	            feedbrands: [],
	            feed_sub_cat: [],
	            feedcat: [],
	            todata: '',
	            nodata: false,
	            open: false,
	            types: [],
	            title: '',
	            desc: '',
	            tid: _this.props.params.Tid,
	            type: _this.props.params.Type,
	            dtype: _this.props.params.DType,
	            htype: _this.props.params.DType,
	            data_type: _this.props.params.DType,
	            bread: '',
	            activeMenu: '',
	            selected: '',
	            loading: false,
	            lod: false,
	            loadmore_number: 2,
	            loadmore_status: 0,
	            set_type: '',
	            next_page: '',
	            seo_desc: '',
	            loading_gif: false,
	            h1_desc: '',
	            nodata_status: false,
	            cart_count: 0,
	
	            bid: _this.props.params.Bid,
	            brandname: _this.props.params.BrandName,
	            location: _this.props.location.pathname,
	            route: '/web/pdeals/brands/' + _this.props.params.BrandName + '/' + _this.props.params.Bid,
	
	            brands_status: false,
	            cat_status: false,
	            sortList: [],
	            total_deals: '',
	
	            categories: [],
	            catloading_gif: false
	
	        };
	        localStorage.setItem('d_type', _this.props.params.DType);
	        // localStorage.setItem('Tid',this.props.params.Tid);
	        localStorage.setItem('h_type', _this.props.params.DType);
	        localStorage.setItem('type', _this.props.params.Type);
	        _this.test = _this.test.bind(_this);
	        _this.test1 = _this.test1.bind(_this);
	        _this.getTypes = _this.getTypes.bind(_this);
	        // this.loadMoreDeals=this.loadMoreDeals.bind(this);
	        _this.getDeviceId = _this.getDeviceId.bind(_this);
	        _this.fetchData = _this.fetchData.bind(_this);
	        _this.refresh = _this.refresh.bind(_this);
	        _this.getCartCount = _this.getCartCount.bind(_this);
	
	        _this.getBrandCat = _this.getBrandCat.bind(_this);
	        _this.getSelectedCatSort = _this.getSelectedCatSort.bind(_this);
	        _this.getBrand_Categories = _this.getBrand_Categories.bind(_this);
	        _this.get_product_list = _this.get_product_list.bind(_this);
	        return _this;
	    }
	
	    _createClass(Web_ProductDetails, [{
	        key: 'getBrandCat',
	        value: function getBrandCat() {
	            if (this.props.params.Type) {
	                var type = this.props.params.Type;
	            } else {
	                type = 'brand';
	            }
	            if (this.props.params.Bid) {
	                var tid = this.props.params.Bid;
	            } else {
	                tid = this.state.tid;
	            }
	            if (this.props.params.DType) {
	                var dtype = this.props.params.DType;
	            } else {
	                dtype = 0;
	            }
	            var data1 = { from: 'desktop_web', type: type, tid: tid, dtype: dtype };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                url: baseUrl + 'filterBrandCat',
	                method: 'POST',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	                    if (data.status === 'success') {
	                        this.setState({
	                            brands: data.brands_lst,
	                            categories: data.cat_lst,
	                            sortList: data.sort });
	                    }
	                }.bind(this),
	                error: function error(err) {}
	            });
	        }
	    }, {
	        key: 'getBrand_Categories',
	        value: function getBrand_Categories() {
	            if (this.props.params.Bid) {
	                var type = 0;
	                var bid = this.props.params.Bid;
	            } else {
	                type = this.props.params.DType;
	                bid = '';
	            }
	            this.setState({ catloading_gif: true });
	            var data1 = { from: 'desktop_web', type: type, bid: bid };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'getbrands_categoires',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	                    this.setState({
	                        fulldata: data,
	                        feedbrands: data.brands,
	                        feedcat: data.categories,
	                        dtype: this.props.params.DType,
	                        bread: data.cat_name,
	                        loading: true,
	                        // total_deals:data.tot_deals,
	                        // selected:data.cat_name,
	                        catloading_gif: false
	                    });
	                }.bind(this),
	                error: function error(err) {
	                    // console.log("Error"+err);
	
	                }
	            });
	        }
	    }, {
	        key: 'getSelectedCatSort',
	        value: function getSelectedCatSort(event) {
	
	            var index = event.target.selectedIndex;
	            var optionElement = event.target.childNodes[index];
	            var id = optionElement.getAttribute('id');
	            // var num=this.state.next_page;
	            // var name = event.target.value;
	            this.setState({
	                loading_gif: true
	                // sortid:id,
	            });
	            localStorage.setItem('web_cat_sort', id);
	
	            if (localStorage.user_id) {
	                var uid = localStorage.getItem('user_id');
	            } else {
	                uid = 0;
	            }
	            if (this.props.params.DType) {
	                var dtype = this.props.params.DType;
	            } else {
	                dtype = 0;
	            }
	
	            // if(this.state.type === 'offers')
	            // {
	            //   var data1={from:'desktop_web',"tid":"","type":"","uid":uid,"deal_offer_type":"3","bid":localStorage.getItem('brand'),"lat1":"","long1":"","sort":id}
	            //   var getfunc ='getProductbycat_brand';
	            // }
	            // else if(this.props.params.Bid)
	            // {
	            //    data1={from:'desktop_web',uid:uid,type:'brand',dtype:dtype,tid:this.props.params.Bid,sort:id};
	            //     getfunc ='getProductbycat_brand';
	            // }
	            // else if(this.state.type === 'all')
	            // {
	            //     data1={from:'desktop_web',uid:uid,type:this.state.dtype,sort:id,limit:20};
	            //      getfunc ='getPoductDeals';
	            // }
	            // else {
	            //    data1={from: 'desktop_web',uid:uid,type:this.state.type, tid: this.state.tid, dtype:this.state.dtype,sort:id};
	            //    getfunc ='getProductbycat_brand';
	            // }
	            var type = this.state.set_type;
	            // var dtype=this.props.params.DType;
	            var tid = this.props.params.Tid;
	            // if(this.state.sortid)
	            // {
	            //   var sortid=this.state.sortid;
	            // } 
	            // else
	            // {
	            //   sortid=1;
	            // }
	            var getfunc = "";
	            var data1 = "";
	            var data2 = "";
	
	            type = this.props.params.Type;
	            if (type === "all") {
	                data1 = { from: 'desktop_web', uid: uid, type: dtype, limit: 20, sort: id };
	                data2 = JSON.stringify(data1);
	                getfunc = "getPoductDeals";
	            } else if (type === "Pcategory") {
	                data1 = { from: 'desktop_web', uid: uid, dtype: dtype, type: type, tid: tid, limit: 20, sort: id };
	                data2 = JSON.stringify(data1);
	                getfunc = "getProductbycat_brand";
	            } else if (type === "brand") {
	                data1 = { from: 'desktop_web', uid: uid, dtype: dtype, type: type, tid: tid, limit: 20, sort: id };
	                data2 = JSON.stringify(data1);
	                getfunc = "getProductbycat_brand";
	            } else if (type === "partner") {
	                data1 = { from: 'desktop_web', uid: uid, dtype: 0, type: type, tid: tid, limit: 20, sort: id };
	                data2 = JSON.stringify(data1);
	                getfunc = "getProductbycat_brand";
	            } else if (this.props.params.Bid) {
	                data1 = { from: 'desktop_web', uid: uid, dtype: 0, type: 'brand', tid: this.props.params.Bid, limit: 20, sort: id };
	                data2 = JSON.stringify(data1);
	                getfunc = "getProductbycat_brand";
	            }
	            // var data2 =JSON.stringify(data1);
	            _jquery2.default.ajax({
	                url: baseUrl + getfunc,
	                method: 'POST',
	                dataType: 'JSON',
	                data: { req: data2 },
	                success: function (data) {
	                    if (data.status === 'success') {
	                        if (data.result.length === 0) {
	                            this.setState({ loading_gif: false });
	                        }
	
	                        this.setState({
	                            feedsList: data.result,
	                            offer: data,
	                            todata: data,
	                            loading: true,
	                            title: data.product_name,
	                            desc: 'The best offers of AquaDeals',
	                            selected: data.cat_name,
	                            loadmore_status: data.load_more,
	                            set_type: data.set_type,
	                            next_page: data.next_page,
	                            loading_gif: false,
	                            total_deals: data.tot_deals
	
	                        });
	                    }
	                }.bind(this),
	                error: function error(err) {}
	            });
	        }
	    }, {
	        key: 'getCartCount',
	        value: function getCartCount() {
	            if (localStorage.user_id) {
	                var uid = localStorage.getItem('user_id');
	            } else {
	                uid = 0;
	            }
	            var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token') };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'cart_count',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	                    this.setState({
	                        cart_count: data.cart_count
	                    });
	                }.bind(this),
	                error: function error(err) {}
	            });
	        }
	    }, {
	        key: 'fetchData',
	        value: function fetchData() {
	            // this.state.next_page, this.state.set_type,this.props.params.Tid,this.props.params.DType
	            var num = this.state.next_page;
	            var type = this.state.set_type;
	            var dtype = this.props.params.DType;
	            var tid = this.props.params.Tid;
	            // if(this.state.sortid)
	            // {
	            //   var sortid=this.state.sortid;
	            // } 
	            // else
	            // {
	            //   sortid=1;
	            // }
	
	            if (localStorage.user_id) {
	                var uid = localStorage.getItem('user_id');
	            } else {
	                uid = 0;
	            }
	            if (this.props.params.DType) {
	                dtype = this.props.params.DType;
	            } else {
	                dtype = 0;
	            }
	
	            var getfunc = "";
	            var data1 = "";
	            var data2 = "";
	            type = this.props.params.Type;
	            if (type === "all") {
	                data1 = { from: 'desktop_web', uid: uid, page: num, type: dtype, limit: 20 };
	                data2 = JSON.stringify(data1);
	                getfunc = "getPoductDeals";
	            } else if (type === "Pcategory") {
	                data1 = { from: 'desktop_web', uid: uid, page: num, dtype: dtype, type: type, tid: tid, limit: 20 };
	                data2 = JSON.stringify(data1);
	                getfunc = "getProductbycat_brand";
	            } else if (type === "brand") {
	                data1 = { from: 'desktop_web', uid: uid, page: num, dtype: dtype, type: type, tid: tid, limit: 20 };
	                data2 = JSON.stringify(data1);
	                getfunc = "getProductbycat_brand";
	            } else if (type === "partner") {
	                data1 = { from: 'desktop_web', uid: uid, page: num, dtype: 0, type: type, tid: tid, limit: 20 };
	                data2 = JSON.stringify(data1);
	                getfunc = "getProductbycat_brand";
	            } else if (this.props.params.Bid) {
	                data1 = { from: 'desktop_web', uid: uid, page: num, dtype: 0, type: 'brand', tid: this.props.params.Bid, limit: 20 };
	                data2 = JSON.stringify(data1);
	                getfunc = "getProductbycat_brand";
	            }
	            if (this.state.loadmore_status === 1) {
	                this.setState({
	                    loading_gif: true
	                });
	                _jquery2.default.ajax({
	                    method: 'POST',
	                    dataType: 'json',
	                    data: { req: data2 },
	                    url: baseUrl + getfunc,
	                    success: function (data) {
	                        if (data.products) {
	                            if (data.load_more === 1) {
	                                this.setState({
	                                    feedsList: this.state.feedsList.concat(data.products),
	                                    offer: data,
	                                    todata: data,
	                                    loadmore_status: data.load_more,
	                                    set_type: data.set_type,
	                                    next_page: data.next_page,
	                                    loading_gif: false,
	                                    selected: data.cat_name
	                                });
	                            } else {
	                                this.setState({
	                                    feedsList: this.state.feedsList.concat(data.products),
	                                    set_type: data.set_type,
	                                    next_page: data.next_page,
	                                    loadmore_status: data.load_more,
	                                    loading_gif: false,
	                                    selected: data.cat_name
	                                });
	                            }
	                        } else {
	                            if (data.load_more === 1) {
	                                this.setState({
	                                    feedsList: this.state.feedsList.concat(data.result),
	                                    set_type: data.set_type,
	                                    next_page: data.next_page,
	                                    loadmore_status: data.load_more,
	                                    loading_gif: false,
	                                    selected: data.cat_name
	                                });
	                            } else {
	                                this.setState({
	                                    feedsList: this.state.feedsList.concat(data.result),
	                                    set_type: data.set_type,
	                                    next_page: data.next_page,
	                                    loadmore_status: data.load_more,
	                                    loading_gif: false,
	                                    selected: data.cat_name
	                                });
	                            }
	                        }
	                    }.bind(this),
	                    error: function (err) {
	                        this.setState({
	                            loading_gif: false
	                        });
	                    }.bind(this)
	                });
	            }
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            console.log("");
	        }
	    }, {
	        key: 'getDeviceId',
	        value: function getDeviceId() {
	            if (localStorage.user_id) {
	                var user_id = localStorage.user_id;
	            } else {
	                user_id = 0;
	            }
	            var data1 = { from: 'desktop_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'getDeviceId',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function success(data) {},
	                error: function error(err) {}
	            });
	        }
	    }, {
	        key: 'getTypes',
	        value: function getTypes() {
	            var data1 = { from: 'desktop_web' };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'getTypes',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	                    this.setState({
	                        types: data.types
	                    });
	                }.bind(this),
	                error: function error(err) {
	                    // console.log("Error"+err);
	                }
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.scrollTo(0, 0);
	            var uid = 0;
	            if (localStorage.user_id) {
	                uid = localStorage.getItem('user_id');
	            } else {
	                uid = 0;
	            }
	
	            // this.setFilter(this.state.bid); 
	
	            this.getCartCount();
	
	            localStorage.removeItem('w_r_s_dt');
	            localStorage.removeItem('w_r_e_coupon_dt');
	            localStorage.removeItem('w_r_e_s_dt');
	            localStorage.removeItem('web_mycart');
	            localStorage.removeItem('w_r_enq_seller_page');
	            localStorage.removeItem('w_r_p_dt');
	            localStorage.removeItem('w_r_e_p_dt');
	            localStorage.removeItem('web_ofr_page');
	            localStorage.removeItem('profile');
	            localStorage.removeItem('myaquacash');
	            localStorage.removeItem('web_share_earn');
	            localStorage.removeItem('checkout');
	            localStorage.removeItem('order_details');
	            localStorage.removeItem('myorders');
	
	            localStorage.removeItem('seed');
	            localStorage.removeItem('nauplii');
	            localStorage.removeItem('subdeals');
	            localStorage.removeItem('shipping');
	            localStorage.removeItem('notifications');
	            localStorage.removeItem('web_quickcart');
	            localStorage.removeItem('view_rating');
	            localStorage.removeItem('w_modal_seed');
	            localStorage.removeItem('w_r_seed_deals');
	            localStorage.removeItem('w_r_e_p_dt');
	            localStorage.removeItem('w_modal_details');
	            localStorage.removeItem('offers');
	            localStorage.removeItem('give_rating');
	            localStorage.removeItem('pprice');
	            localStorage.removeItem('sprice');
	            localStorage.removeItem('seed_id');
	            localStorage.removeItem('h_type');
	            localStorage.removeItem('web_pro_ofr_dtls');
	            localStorage.removeItem('web_wishlist');
	            localStorage.removeItem('web_brand_details');
	
	            localStorage.removeItem('m_r_s_dt');
	            localStorage.removeItem('m_r_e_coupon_dt');
	            localStorage.removeItem('m_r_e_s_dt');
	            localStorage.removeItem('mob_mycart');
	            localStorage.removeItem('m_r_enq_seller_page');
	            localStorage.removeItem('m_r_p_dt');
	            localStorage.removeItem('m_r_e_p_dt');
	            localStorage.removeItem('ofr_page');
	            localStorage.removeItem('pro_ofr_dtls');
	
	            localStorage.removeItem('share_earn');
	            localStorage.removeItem('my_orders');
	            localStorage.removeItem('m_r_p_deals');
	            localStorage.removeItem('mob_quickcart');
	            localStorage.removeItem('partner_deals');
	
	            this.getDeviceId();
	            this.getBrandCat();
	
	            if (this.props.params.Type === "all" && screen.width < 800) {
	                window.location.href = "/pdeals/" + this.props.params.BrandName + "/all/" + this.props.params.DType;
	            }
	            if (this.props.params.CatName && this.props.params.Tid) {
	                localStorage.setItem('w_r_p_deals', "/web/pdeals/" + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Tid + "/" + this.props.params.Type + "/" + this.props.params.DType);
	            }
	            if (screen.width <= 800 && window.location.hash === "/pdeals/feed/offers/35/>=/4") {
	                window.location.href = "/offers_details/35/>=/4";
	            } else if (screen.width <= 800 && this.props.params.CatName && this.props.params.Tid) {
	                localStorage.setItem('w_r_p_deals', "/web/pdeals/" + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Tid + "/" + this.props.params.Type + "/" + this.props.params.DType);
	                window.location.href = "/pdeals/" + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Tid + "/" + this.props.params.Type + "/" + this.props.params.DType;
	            }
	
	            if (!this.props.params.CatName && this.props.params.Type) {
	                localStorage.setItem('w_r_p_deals', "web/pdeals/" + this.props.params.BrandName + "/" + this.props.params.Type + "/" + this.props.params.DType);
	            }
	
	            if (this.props.params.BrandName && this.props.params.Bid && screen.width < 800) {
	                window.location.href = "/pdeals/brand/" + this.props.params.BrandName + "/" + this.props.params.Bid;
	            }
	
	            (0, _jquery2.default)(window).scrollTop(0);
	            var self = this;
	            setTimeout(function () {
	                self.setState({ lod: true });
	            }, 15000);
	
	            localStorage.setItem('h_type', this.props.params.DType);
	            localStorage.setItem('d_type', this.props.params.DType);
	            this.getTypes();
	
	            // if(this.props.params.DType)
	            // {
	            //  var dtype =this.props.params.DType;
	            // }
	            // else
	            // {
	            //    dtype = 0;
	            // }
	
	            // if(this.props.params.DType)
	            // {
	            //   var dtype =this.props.params.DType;
	            // }
	            // else if(this.props.params.Type)
	            // {
	            //     dtype = this.props.params.Type;
	            // }
	            // else
	            // {
	            //    dtype ='brand';
	            // }
	            // if(!this.props.params.Tid && !this.props.params.DType && !this.props.params.Type)
	            // {
	            //    dtype = 'brand';
	            // }
	
	            // if(this.props.params.Bid)
	            // {
	            //   var tid = this.props.params.Bid;
	            // }
	            // else
	            // {
	            //    var tid = this.state.tid;
	            // }
	
	            this.getBrand_Categories();
	            var data1 = "";
	            var data2 = "";
	            var get_function = "";
	            if (this.state.type === '>=') {
	                data1 = { from: 'desktop_web', uid: uid, discount: this.state.tid, discount_type: this.state.dtype, discount_opr: this.state.type, limit: 20 };
	                data2 = JSON.stringify(data1);
	                get_function = 'getNewsearch';
	                this.get_product_list(data2, baseUrl, get_function);
	            } else if (this.state.type === 'sub') {
	                data1 = { from: 'desktop_web', uid: uid, pid: this.state.tid, limit: 20 };
	                data2 = JSON.stringify(data1);
	                get_function = 'getNewsearch';
	                this.get_product_list(data2, baseUrl, get_function);
	            } else if (this.state.type === 'all') {
	                data1 = { from: 'desktop_web', type: this.state.dtype, limit: 20 };
	                data2 = JSON.stringify(data1);
	                get_function = 'getPoductDeals';
	                this.get_product_list(data2, baseUrl, get_function);
	            } else if (this.state.type === 'offers') {
	                data1 = { from: 'desktop_web', uid: uid, deal_offer_type: this.state.dtype, type: '', limit: 20 };
	                data2 = JSON.stringify(data1);
	                get_function = 'getProductbycat_brand';
	                this.get_product_list(data2, baseUrl, get_function);
	            } else if (this.state.type === 'Pcategory') {
	                data1 = { from: 'desktop_web', uid: uid, type: this.state.type, tid: this.state.tid, dtype: this.state.dtype, deal_ids: this.props.params.Dids };
	                data2 = JSON.stringify(data1);
	                get_function = 'getProductbycat_brand';
	                this.get_product_list(data2, baseUrl, get_function);
	            } else if (this.state.type === 'brand') {
	                data1 = { from: 'desktop_web', uid: uid, type: this.state.type, tid: this.state.tid, dtype: this.state.dtype };
	                data2 = JSON.stringify(data1);
	                get_function = 'getProductbycat_brand';
	                this.get_product_list(data2, baseUrl, get_function);
	            } else if (this.props.params.Bid) {
	                data1 = { from: 'desktop_web', uid: uid, type: 'brand', tid: this.props.params.Bid };
	                data2 = JSON.stringify(data1);
	                get_function = 'getProductbycat_brand';
	                this.get_product_list(data2, baseUrl, get_function);
	            }
	            // else
	            // { 
	            //     data3={from: 'desktop_web',uid:uid,type:this.state.type,tid: this.state.tid,dtype:dtypethis.state.dtype,limit:20};
	            //     data4=JSON.stringify(data3);
	            //     get_function = 'getProductbycat_brand';          
	            // }
	        }
	    }, {
	        key: 'get_product_list',
	        value: function get_product_list(data2, baseUrl, get_function) {
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + get_function,
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	                    if (data.products) {
	                        this.setState({
	                            feedsList: data.products,
	                            offer: data,
	                            todata: data,
	                            loading: true,
	                            title: data.product_name,
	                            desc: 'The best offers of AquaDeals',
	                            selected: data.cat_name,
	                            loadmore_status: data.load_more,
	                            set_type: data.set_type,
	                            next_page: data.next_page,
	                            loading_gif: false,
	                            total_deals: data.tot_deals
	                        });
	                        // document.getElementById('cat_4').addClass("active");
	                    } else {
	                        this.setState({
	                            feedsList: data.result,
	                            offer: data,
	                            todata: data,
	                            loading: true,
	                            title: data.cat_name,
	                            desc: 'Browse best deals,Aquaculture products from ' + data.cat_name + ' in AquaDeals.Contact customer care for any queries.',
	                            selected: data.cat_name,
	                            loadmore_status: data.load_more,
	                            set_type: data.set_type,
	                            next_page: data.next_page,
	                            seo_desc: '',
	                            loading_gif: false,
	                            total_deals: data.tot_deals
	                        });
	                    }
	                    if (data.status === 'error') {
	                        this.setState({
	                            loading_gif: false,
	                            nodata_status: true
	                        });
	                        if (this.props.params.DType === "2" && this.props.params.Type !== 'all') {
	                            var nodata_red_url = '/web/pdeals/feed/all/2';
	                        } else if (this.props.params.DType === "4" && this.props.params.Type !== 'all') {
	                            nodata_red_url = '/web/pdeals/health-care/all/4';
	                        } else if (this.props.params.DType === "3" && this.props.params.Type !== 'all') {
	                            nodata_red_url = '/web/pdeals/machine-equip/all/3';
	                        } else if (this.props.params.DType === "5" && this.props.params.Type !== 'all') {
	                            nodata_red_url = '/web/pdeals/hatchery-machinery/all/5';
	                        } else if (this.props.params.DType === "7" && this.props.params.Type !== 'all') {
	                            nodata_red_url = '/web/pdeals/hatchery-health-care/all/7';
	                        } else {
	                            nodata_red_url = '/web/home';
	                        }
	                    }
	                    if (this.props.params.Type === "Pcategory") {
	                        this.setState({
	                            h1_desc: 'Shop best deals on ' + data.cat_name + ' products'
	                        });
	                    } else if (this.props.params.Type === 'brand') {
	                        this.setState({
	                            h1_desc: 'Shop best deals on ' + data.cat_name + ' products'
	                        });
	                    } else if (this.props.params.Type === "all") {
	                        this.setState({
	                            h1_desc: 'Shop best deals on ' + data.cat_name + ' products'
	                        });
	                    } else if (this.props.params.Bid) {
	                        this.setState({
	                            h1_desc: 'Shop best deals on ' + data.cat_name + ' products'
	                        });
	                    }
	
	                    if (this.props.params.Type === "all") {
	                        if (this.props.params.DType === "2") {
	                            document.title = "Buy Aqua Feed Products Online | AquaDeals";
	                            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Feed deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	                        } else if (this.props.params.DType === "4") {
	                            document.title = "Buy Aqua Healthcare Products Online | AquaDeals";
	                            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Healthcare Products & Supplements deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	                        } else if (this.props.params.DType === "3") {
	                            document.title = "Buy Aqua Machinery & Equipment Products Online | AquaDeals";
	                            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Machinery & Equipment deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	                        } else if (this.props.params.DType === "5") {
	                            document.title = "Buy Aqua Hatchery Machinery Products Online | AquaDeals";
	                            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Hatchery Machinery Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	                        } else if (this.props.params.DType === "7") {
	                            document.title = "Buy Aqua Hatchery Health Care Product deals Online | AquaDeals";
	                            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Hatchery Healthcare Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	                        } else {
	                            document.title = "Buy Aquaculture deals Online | AquaDeals";
	                            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	                        }
	                    }
	                    if (this.props.params.Type === "Pcategory") {
	                        // document.title =this.state.title + " - Products | AquaDeals ";
	                        // document.getElementsByTagName("META")[2].content="Browse bestÂ deals,Aquaculture products from various brandsÂ in "+data.cat_name+".Contact customer care for any queries on these Aqua products and order online";
	                        if (this.props.params.BrandName === "feed") {
	                            document.title = 'Buy Aqua ' + data.cat_name + ' Products Online | AquaDeals';
	                            document.getElementsByTagName("META")[2].content = 'Browse quality Aquaculture ' + data.cat_name + ' feed deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
	                        } else if (this.props.params.BrandName === "health-care") {
	                            document.title = 'Buy Aqua ' + data.cat_name + ' Products Online | AquaDeals';
	                            document.getElementsByTagName("META")[2].content = 'Browse quality Aquaculture ' + data.cat_name + ' Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
	                        } else if (this.props.params.BrandName === "aerators") {
	                            document.title = 'Buy Aqua ' + data.cat_name + ' Products Online | AquaDeals';
	                            document.getElementsByTagName("META")[2].content = 'Browse quality Aquaculture ' + data.cat_name + ' products from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
	                        } else {
	                            document.title = 'Buy Aqua ' + data.cat_name + ' Products Online | AquaDeals';
	                            document.getElementsByTagName("META")[2].content = 'Browse quality Aquaculture ' + data.cat_name + ' deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
	                        }
	                    } else if (this.props.params.Type === 'brand') {
	                        // document.title =this.state.title + " - Products | AquaDeals ";
	                        // document.getElementsByTagName("META")[2].content="Browse best deals, AquacultureÂ products from "+data.cat_name+".Contact customer care for any queries on these Aqua products and order online";
	                        if (this.props.params.BrandName === "feed") {
	                            document.title = 'Buy ' + data.cat_name + ' Aqua Products Online | AquaDeals';
	                            document.getElementsByTagName("META")[2].content = "Search " + data.cat_name + " branded quality Aquaculture " + data.dtype_name + " deals, choose the best deal price from our nearest partner and avail free shipment";
	                        } else if (this.props.params.BrandName === "health-care") {
	                            document.title = 'Buy ' + data.cat_name + ' Aqua Products Online | AquaDeals';
	                            document.getElementsByTagName("META")[2].content = "Search " + data.cat_name + " branded quality Aquaculture " + data.dtype_name + " deals, choose the best deal price from our nearest partner and avail free shipment";
	                        } else if (this.props.params.BrandName === "aerators") {
	                            document.title = 'Buy ' + data.cat_name + ' Aqua Products Online | AquaDeals';
	                            document.getElementsByTagName("META")[2].content = "Search " + data.cat_name + " branded quality Aquaculture " + data.dtype_name + " deals, choose the best deal price from our nearest partner and avail free shipment";
	                        } else {
	                            document.title = 'Buy ' + data.cat_name + ' Aqua Products Online | AquaDeals';
	                            document.getElementsByTagName("META")[2].content = "Search " + data.cat_name + " branded quality Aquaculture Fish / Vannamei Shrimp " + data.dtype_name + " deals, choose the best deal price from our nearest partner and avail free shipment";
	                        }
	                    } else if (this.props.params.Bid) {
	                        document.title = 'Buy ' + data.cat_name + ' Aqua Products Online | AquaDeals';
	                        document.getElementsByTagName("META")[2].content = "Search " + data.cat_name + " branded quality Aquaculture deals, choose the best deal price from our nearest partner and avail free shipment";
	                    }
	                }.bind(this),
	                error: function error(err) {}
	            });
	        }
	        // test(type,tid,page)
	
	    }, {
	        key: 'test',
	        value: function test(type, tid, dtype) {
	            this.setState({
	                loading_gif: true
	            });
	            var uid = 0;
	            if (localStorage.user_id) {
	                uid = localStorage.getItem('user_id');
	            } else {
	                uid = 0;
	            }
	            // if(this.props.params.DType)
	            // {
	            //   var dtype =this.props.params.DType;
	            // }
	
	            // else
	            // {
	            //    dtype =0;
	            // }
	            // console.log(typeof('type'));
	            if (type !== undefined) {
	                var type = type;
	            } else {
	                type = 'brand';
	            }
	
	            if (tid) {
	                var tid = tid;
	            } else {
	                tid = this.state.bid;
	            }
	
	            localStorage.setItem('w_r_p_deals', "/web/pdeals/" + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Tid + "/" + this.props.params.Type + "/" + this.props.params.DType);
	            (0, _jquery2.default)(window).scrollTop(0);
	            // var data1={from: 'desktop_web',uid:uid,dtype:dtype/*this.state.data_type*/,type:type,tid:tid,limit:20};
	            var data1 = { from: 'desktop_web', uid: uid, dtype: dtype, type: type, tid: tid, limit: 20 };
	            localStorage.setItem('Tid', tid);
	            localStorage.setItem('type', type);
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'getProductbycat_brand',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	                    this.setState({
	                        feedsList: data.result,
	                        offer: data,
	                        loading: true,
	                        bread: data.cat_name,
	                        title: data.cat_name,
	                        desc: data.cat_desc,
	                        loadmore_status: data.load_more,
	                        set_type: data.set_type,
	                        next_page: data.next_page,
	                        seo_desc: 'Browse best deals,Aquaculture products from various brands in ' + data.cat_name + '. Contact customer care for any queries.',
	                        loading_gif: false,
	                        nodata_status: false,
	                        selected: data.cat_name,
	                        total_deals: data.tot_deals
	                    });
	                    if (data.status === 'error') {
	                        this.setState({
	                            nodata_status: true
	                        });
	                    }
	                    if (this.props.params.Type === "Pcategory") {
	                        this.setState({
	                            h1_desc: 'Shop best deals on ' + data.cat_name + ' products'
	                        });
	                    } else if (this.props.params.Type === 'brand') {
	                        this.setState({
	                            h1_desc: 'Shop best deals on ' + data.cat_name + ' products'
	                        });
	                    } else if (this.props.params.Bid) {
	                        this.setState({
	                            h1_desc: 'Shop best deals on ' + data.cat_name + ' products'
	                        });
	                    }
	                    if (this.props.params.Type === "all") {
	                        if (this.props.params.DType === "2") {
	                            document.title = "Buy Aqua Feed Products Online | AquaDeals";
	                            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Feed deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	                        } else if (this.props.params.DType === "4") {
	                            document.title = "Buy Aqua Healthcare Products Online | AquaDeals";
	                            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Healthcare Products & Supplements deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	                        } else if (this.props.params.DType === "3") {
	                            document.title = "Buy Aqua Machinery & Equipment Products Online | AquaDeals";
	                            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Machinery & Equipment deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	                        } else if (this.props.params.DType === "5") {
	                            document.title = "Buy Aqua Hatchery Machinery Products Online | AquaDeals";
	                            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Hatchery Machinery Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	                        } else if (this.props.params.DType === "7") {
	                            document.title = "Buy Aqua Hatchery Health Care Product deals Online | AquaDeals";
	                            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Hatchery Healthcare Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	                        } else {
	                            document.title = "Buy Aquaculture deals Online | AquaDeals";
	                            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	                        }
	                        // if(this.props.params.BrandName==="feed")
	                        // {
	                        //   document.title="Buy Aqua "+data.cat_name+" Products Online | AquaDeals";
	                        //   document.getElementsByTagName("META")[2].content="Browse quality Aquaculture "+ data.cat_name +" deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";    
	                        // }
	                        // else if(this.props.params.BrandName==="health-care")
	                        // {
	                        //  document.title="Buy Aqua Healthcare Products Online | AquaDeals"; 
	                        //  document.getElementsByTagName("META")[2].content="Browse quality Aquaculture Healthcare Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	                        // }
	                        // else if(this.props.params.BrandName==="machine-equip")
	                        // {
	                        //   document.title="Buy Aqua Machine & Equipment Products Online | AquaDeals";
	                        //   document.getElementsByTagName("META")[2].content="Browse quality Aquaculture "+data.cat_name+" deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	                        // }
	                        // else if(this.props.params.BrandName==="hatchery-machinery")
	                        // {
	                        //   document.title="Buy Aqua Hatchery Machiney Products Online | AquaDeals";
	                        //   document.getElementsByTagName("META")[2].content="Browse quality Aquaculture "+data.cat_name+" deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	                        // }
	                        // else
	                        // {
	                        //     document.title ='Buy Aqua '+data.cat_name+' Products Online | AquaDeals';
	                        //     document.getElementsByTagName("META")[2].content='Browse quality Aquaculture '+data.cat_name+' deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
	                        // }
	                    }
	                    if (this.props.params.Type === "Pcategory") {
	                        // document.title =this.state.title + " - Products | AquaDeals ";
	                        // document.getElementsByTagName("META")[2].content="Browse bestÂ deals,Aquaculture products from various brandsÂ in "+data.cat_name+".Contact customer care for any queries on these Aqua products and order online";
	                        if (this.props.params.BrandName === "feed") {
	                            document.title = 'Buy Aqua ' + data.cat_name + ' Products Online | AquaDeals';
	                            document.getElementsByTagName("META")[2].content = 'Browse quality Aquaculture ' + data.cat_name + ' feed deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
	                        } else if (this.props.params.BrandName === "health-care") {
	                            document.title = 'Buy Aqua ' + data.cat_name + ' Products Online | AquaDeals';
	                            document.getElementsByTagName("META")[2].content = 'Browse quality Aquaculture ' + data.cat_name + ' Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
	                        } else if (this.props.params.BrandName === "aerators") {
	                            document.title = 'Buy Aqua ' + data.cat_name + ' Products Online | AquaDeals';
	                            document.getElementsByTagName("META")[2].content = 'Browse quality Aquaculture ' + data.cat_name + ' products from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
	                        } else {
	                            document.title = 'Buy Aqua ' + data.cat_name + ' Products Online | AquaDeals';
	                            document.getElementsByTagName("META")[2].content = 'Browse quality Aquaculture ' + data.cat_name + ' deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
	                        }
	                    } else if (this.props.params.Type === 'brand') {
	                        // document.title =this.state.title + " - Products | AquaDeals ";
	                        // document.getElementsByTagName("META")[2].content="Browse best deals, AquacultureÂ products from "+data.cat_name+".Contact customer care for any queries on these Aqua products and order online";
	                        if (this.props.params.BrandName === "feed") {
	                            document.title = 'Buy ' + data.cat_name + ' Aqua Products Online | AquaDeals';
	                            document.getElementsByTagName("META")[2].content = "Search " + data.cat_name + " branded quality Aquaculture " + data.dtype_name + " deals, choose the best deal price from our nearest partner and avail free shipment";
	                        } else if (this.props.params.BrandName === "health-care") {
	                            document.title = 'Buy ' + data.cat_name + ' Aqua Products Online | AquaDeals';
	                            document.getElementsByTagName("META")[2].content = "Search " + data.cat_name + " branded quality Aquaculture " + data.dtype_name + " deals, choose the best deal price from our nearest partner and avail free shipment";
	                        } else if (this.props.params.BrandName === "aerators") {
	                            document.title = 'Buy ' + data.cat_name + ' Aqua Products Online | AquaDeals';
	                            document.getElementsByTagName("META")[2].content = "Search " + data.cat_name + " branded quality Aquaculture " + data.dtype_name + " deals, choose the best deal price from our nearest partner and avail free shipment";
	                        } else {
	                            document.title = 'Buy ' + data.cat_name + ' Aqua Products Online | AquaDeals';
	                            document.getElementsByTagName("META")[2].content = "Search " + data.cat_name + " branded quality Aquaculture Fish / Vannamei Shrimp " + data.dtype_name + " deals, choose the best deal price from our nearest partner and avail free shipment";
	                        }
	                    } else if (this.props.params.Bid) {
	                        document.title = 'Buy ' + data.cat_name + ' Aqua Products Online | AquaDeals';
	                        document.getElementsByTagName("META")[2].content = "Search " + data.cat_name + " branded quality Aquaculture deals, choose the best deal price from our nearest partner and avail free shipment";
	                    }
	                }.bind(this),
	                error: function error(err) {
	                    // console.log("Error"+err);
	                }
	            });
	        }
	    }, {
	        key: 'test1',
	        value: function test1(id) {
	            this.setState({
	                loading_gif: true
	            });
	            (0, _jquery2.default)(window).scrollTop(0);
	            localStorage.setItem('d_type', this.props.params.DType);
	            localStorage.setItem('w_r_p_deals', "/web/pdeals/" + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Tid + "/" + this.props.params.Type + "/" + this.props.params.DType);
	            this.getTypes();
	            var data1 = { from: 'desktop_web', type: id };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'getbrands_categoires',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	                    this.setState({
	                        fulldata: data,
	                        feedbrands: data.brands,
	                        feedcat: data.categories,
	                        feed_sub_cat: data.categories[1].sub,
	                        dtype: this.props.params.Dtype,
	                        loading_gif: false
	                    });
	                }.bind(this),
	                error: function error(err) {}
	            });
	            var data3 = { from: 'desktop_web', type: id, limit: 20 };
	            var data4 = JSON.stringify(data3);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'getPoductDeals',
	                dataType: 'json',
	                data: { req: data4 },
	                success: function (data1) {
	                    this.setState({
	                        feedsList: data1.result,
	                        offer: data1,
	                        loading: true,
	                        title: data1.cat_name,
	                        selected: data1.cat_name,
	                        desc: data1.cat_desc,
	                        seo_desc: 'Browse best deals,Aquaculture products from ' + data1.cat_name + ' in AquaDeals.Contact customer care for any queries.',
	                        loading_gif: false,
	
	                        total_deals: data1.tot_deals
	                    });
	                    document.title = this.state.title + " - Products  | AquaDeals";
	                    document.getElementsByTagName("META")[2].content = this.state.seo_desc;
	                }.bind(this),
	                error: function error(err) {
	                    this.setState({
	                        loading_gif: false
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'setFilter',
	        value: function setFilter(filter, id, type) {
	            this.setState({ selected: filter, tid: id, type: type });
	        }
	    }, {
	        key: 'isActive',
	        value: function isActive(value) {
	            if (value) {
	                return 'li ' + (value === this.state.selected ? 'active' : '');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var brands = this.state.feedbrands.map(function (brand, index) {
	                var _this2 = this;
	
	                return _react2.default.createElement(
	                    'li',
	                    { key: brand.id, id: "brand_" + brand.id, className: this.isActive(brand.category_name), onClick: this.setFilter.bind(this, brand.category_name, brand.id, brand.type) },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { onClick: function onClick() {
	                                _this2.test(brand.type, brand.id, brand.dtype);
	                            }, to: this.props.params.Bid ? "/web/pdeals/brands/" + brand.url_name + "/" + brand.id : "/web/pdeals/" + brand.url_dtype_name + "/" + brand.url_name + "/" + brand.id + "/" + brand.type + "/" + brand.dtype },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            brand.category_name
	                        )
	                    )
	                );
	            }.bind(this));
	
	            var cat_filter = this.state.sortList.map(function (item, index) {
	                return _react2.default.createElement(
	                    'option',
	                    { key: item.id, id: item.id, value: item.name },
	                    item.name
	                );
	            });
	
	            // var categories = this.state.categories.map(function(brandcat,index){
	            //    return(
	            //       <li key={index}>
	            //          <Link to={"/web/pdeals/brands/"+brandcat.url_name+"/"+brandcat.id} /*onClick={() =>{this.test('Pcategory',brandcat.id,0)}}*/>
	            //              <span>{brandcat.name}</span>
	            //          </Link>
	            //       </li> 
	            //     );
	            // });
	
	            // '/web/pdeals/brands/'+this.props.params.BrandName+'/'+this.props.params.Bid
	            // if(!this.props.params.Bid this.props.location.pathname !== this.state.route)
	            // {          
	            var cate = this.state.feedcat.map(function (cat, index) {
	                var _this4 = this;
	
	                if (cat.sub.length > 0) {
	                    var subs_cat = cat.sub.map(function (sub_cat, index) {
	                        var _this3 = this;
	
	                        return _react2.default.createElement(
	                            'li',
	                            { key: sub_cat.id, id: "sub_cat_" + sub_cat.id, className: "sub_cat_li " + this.isActive(sub_cat.category_name), onClick: this.setFilter.bind(this, sub_cat.category_name, sub_cat.id, sub_cat.type) },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { onClick: function onClick() {
	                                        _this3.test(sub_cat.type, sub_cat.id, sub_cat.dtype);
	                                    }, to: "/web/pdeals/" + sub_cat.url_dtype_name + "/" + sub_cat.url_name + "/" + sub_cat.id + "/" + sub_cat.type + "/" + sub_cat.dtype },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    sub_cat.category_name
	                                )
	                            )
	                        );
	                    }.bind(this));
	                    return _react2.default.createElement(
	                        'li',
	                        { key: cat.id, id: "cat_" + cat.id },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                cat.category_name
	                            )
	                        ),
	                        subs_cat
	                    );
	                } else {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: cat.id, id: "cat_" + cat.id, className: this.isActive(cat.category_name), onClick: this.setFilter.bind(this, cat.category_name, cat.id, cat.type) },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { onClick: function onClick() {
	                                    _this4.test(cat.type, cat.id, cat.dtype);
	                                }, to: "/web/pdeals/" + cat.url_dtype_name + "/" + cat.url_name + "/" + cat.id + "/" + cat.type + "/" + cat.dtype },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                cat.category_name
	                            )
	                        )
	                    );
	                }
	            }.bind(this));
	            // }
	            // else{
	            //   cate ='';
	            // } 
	            var products = '';
	            if (this.state.feedsList.length > 0) {
	                products = this.state.feedsList.map(function (product, index) {
	                    return _react2.default.createElement(_pdeals_list2.default, { key: product.id, data: product });
	                });
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'web_Deals web_pdeals_page' },
	                this.state.loading ? _react2.default.createElement(
	                    'div',
	                    { className: 'lgt_gry' },
	                    _react2.default.createElement(_WebHeaderInner2.default, { cart_updated_count: this.state.cart_count }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'section',
	                        { className: 'container pro_lst_cntnt' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'clr' },
	                            '\xA0'
	                        ),
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'page_title' },
	                            this.state.h1_desc
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'container' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Breadcrumb,
	                                { className: 'webpdeals_breadcrmb' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Breadcrumb.Item,
	                                    { href: '/web/home' },
	                                    'Home'
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Breadcrumb.Item,
	                                    { active: true },
	                                    this.state.selected
	                                )
	                            )
	                        ),
	                        _react2.default.createElement('div', { className: 'clr' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'tot_pro' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row', style: { marginRight: '0 !important' } },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3 col-sm-3' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'filtrs_blk' },
	                                        _react2.default.createElement(
	                                            'h3',
	                                            null,
	                                            'Categories'
	                                        ),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            null,
	                                            this.state.catloading_gif ? _react2.default.createElement(
	                                                'i',
	                                                { className: 'web_catloading_gif' },
	                                                _react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
	                                            ) : _react2.default.createElement('i', { className: 'web_catloading_gif' }),
	                                            cate
	                                        ),
	                                        brands.length > 0 ? _react2.default.createElement(
	                                            'h3',
	                                            null,
	                                            'Brands'
	                                        ) : '',
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: brands.length > 10 ? 'flt_scrl' : 'no_scrl' },
	                                            brands
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'pro_sec col-md-9 col-sm-9' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'pro_sec_hdr' },
	                                        _react2.default.createElement(
	                                            'h3',
	                                            null,
	                                            this.state.selected,
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                '(',
	                                                this.state.total_deals,
	                                                ' Items)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'pro_slt_fltr' },
	                                            _react2.default.createElement(
	                                                'select',
	                                                { onChange: this.getSelectedCatSort },
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    null,
	                                                    'Select'
	                                                ),
	                                                cat_filter
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row itm_lst' },
	                                        this.state.loading_gif ? _react2.default.createElement(
	                                            'i',
	                                            { className: 'web_loading_gif' },
	                                            _react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
	                                        ) : _react2.default.createElement('i', { className: 'web_loading_gif' }),
	                                        _react2.default.createElement(
	                                            _reactInfiniteScrollComponent2.default,
	                                            {
	                                                pullDownToRefresh: true,
	                                                pullDownToRefreshContent: _react2.default.createElement(
	                                                    'h3',
	                                                    { style: { textAlign: 'center' } },
	                                                    '\u2193'
	                                                ),
	                                                releaseToRefreshContent: _react2.default.createElement(
	                                                    'h3',
	                                                    { style: { textAlign: 'center' } },
	                                                    '\u2191'
	                                                ),
	                                                refreshFunction: this.refresh,
	                                                next: this.fetchData,
	                                                hasMore: true,
	                                                scrollThreshold: 0.5,
	                                                loader: _react2.default.createElement('h4', null),
	                                                endMessage: _react2.default.createElement(
	                                                    'p',
	                                                    { style: { textAlign: 'center' } },
	                                                    _react2.default.createElement('b', null)
	                                                ) },
	                                            products
	                                        ),
	                                        this.state.nodata_status ? _react2.default.createElement(
	                                            'div',
	                                            { className: 'seed_no_data' },
	                                            'No Deals Available'
	                                        ) : ''
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_WebFooter2.default, null)
	                ) : _react2.default.createElement(
	                    'div',
	                    { className: 'loading_sym', style: { width: '100%', textAlign: 'center', marginTop: '20%' } },
	                    _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/ajax-loader1.gif', alt: 'Loading Deals', role: 'presentation' })
	                )
	            );
	        }
	    }]);
	
	    return Web_ProductDetails;
	}(_react.Component);
	
	exports.default = Web_ProductDetails;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(15);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactStars = __webpack_require__(33);
	
	var _reactStars2 = _interopRequireDefault(_reactStars);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _Web_NotFound = __webpack_require__(136);
	
	var _Web_NotFound2 = _interopRequireDefault(_Web_NotFound);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactShare = __webpack_require__(18);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _reactWebVectorIcons = __webpack_require__(29);
	
	var _reactWebVectorIcons2 = _interopRequireDefault(_reactWebVectorIcons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var parseHtml = __webpack_require__(39);
	
	
	// Routing Parameters ::
	// /web/pdetails/:BrandName/:CatName/:Title/:Pid/:Did
	// /web/pdetails/:BrandName/:CatName/:Bname/:Title/:Pid/:Did
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets//';
	
	var Web_ProductFullDetails = function (_Component) {
		_inherits(Web_ProductFullDetails, _Component);
	
		function Web_ProductFullDetails(props) {
			_classCallCheck(this, Web_ProductFullDetails);
	
			var _this = _possibleConstructorReturn(this, (Web_ProductFullDetails.__proto__ || Object.getPrototypeOf(Web_ProductFullDetails)).call(this, props));
	
			_this.state = {};
			_this.state = {
				feedbrands: [],
				feed_sub_cat: [],
				feedcat: [],
				feedsList: [],
				pid: _this.props.params.Pid,
				dealid: _this.props.params.Did,
				brand_name: _this.props.params.BrandName,
				cat_name: _this.props.params.CatName,
				p_title: _this.props.params.Title,
				pdeals: [],
				offer: '',
				pro_details: [],
				pro_deal_details: [],
				offer_details: [],
				product_attributes: [],
				coupon_first: [],
				imgs: [],
				prevPath: '',
				seller_id: '',
				tags_status: false,
				attr_status: false,
				loading: false,
				tags: [],
				split_tags: [],
				open: false,
				desc_open: true,
				desc_flag: false,
				showModal: false,
				is_char: false,
				shareUrl: '',
				dtype: _this.props.params.DType,
				session: localStorage.getItem('token'),
				title: '',
				desc: '',
				bestprice_desc: '',
				bestprice_status: false,
				coupons: [],
				page_error_status: false,
				web_title: '',
				web_desc: '',
				seo_desc: '',
				reqbestPrice: false,
				cpns_list: '',
				swipe_description_status: 1,
				swipe_product_attributes: [],
				desc_update_soon_status: false,
	
				unit_name: '',
				min_qty: 0,
				max_qty: 0,
				min_qty1: 0,
				max_qty1: 0,
				tons: 0,
				qty: '',
				qty_err_status: false,
				qty_err_msg: '',
				is_cart: 0,
				clearcart_status: false,
				cart_added_status: false,
				addtocart_status: false,
				updatecart_status: false,
				addtocart_msg: '',
				type: '',
	
				free_ship_msg: '',
				user_zipcode: '',
				free_shipment: 0,
	
				err_pincode: false,
				err_pincode_msg: '',
	
				cart_count: 0,
				swipe_attributes_titles: [],
				swipe_attr_status: '',
				cid: '',
				no_details_attr: 0,
				req_quantity: '',
				req_state: '',
				req_city: '',
				req_doorno: '',
				req_pincode: '',
	
				req_confirm_modal: false,
				req_confirm_message: '',
				// prev_path: window.previousLocation.pathname,
				page_loading: false,
				wishLst_flag: '',
				cat_sim_flag: '',
				brand_sim_flag: '',
				stage_sim_flag: '',
				similar_brand_deals: [],
				similar_category_deals: [],
				similar_stage_deals: [],
				similar_brand_deals_status: false,
				similar_category_deals_status: false,
				similar_stage_deals_status: false,
				bid: '',
				// Follow section
				brand_like_status: '',
				// brand_like_users:[],
				brand_likes_count: '',
				// brand_like_rem_count:'',
				brand_follow_count: '',
				// b_follow_status:false,
				show_about_brand: '',
				show_about_brand_flag: false,
	
				like_status_flag: '',
				isToggle: true,
				check_swipe_id: '',
	
				ad_assist_modal: false,
				ad_guarantee: '',
				ad_guarantee_icon: '',
				ad_asst_time: '',
				ad_asst_confirm_message: '',
				ad_asst_confirm_modal: false,
				ad_grnt_str: '',
	
				rotateClass: false,
				cart_qty: 0,
				d_type_bread: '',
	
				recommended: '',
				rating: '',
				// dealid:'',
	
				deal_did: '',
	
				brand_desc: '',
				order_msg: '',
				show_order_count_flag: '',
				queries: [],
				product_tabs_avail: false,
				best_price_txt: '',
				disclaimer_flag: false,
				disclaimer_txt: '',
				visibility: false
				// rotate:false,
			};
			_this.ShareFunc = _this.ShareFunc.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.getDeviceId = _this.getDeviceId.bind(_this);
			_this.getswipeDescription = _this.getswipeDescription.bind(_this);
	
			_this.decrementMinQty = _this.decrementMinQty.bind(_this);
			_this.updateMinQty = _this.updateMinQty.bind(_this);
			_this.incrementMinQty = _this.incrementMinQty.bind(_this);
			_this.placeOrderModal = _this.placeOrderModal.bind(_this);
			_this.removeCartItems = _this.removeCartItems.bind(_this);
	
			_this.pincodeChange = _this.pincodeChange.bind(_this);
			_this.checkPincode = _this.checkPincode.bind(_this);
	
			_this.getCartCount = _this.getCartCount.bind(_this);
			//this.getAttributesTitle=this.getAttributesTitle.bind(this);
			//this.getswipeDescription_Initial=this.getswipeDescription_Initial.bind(this);
	
			_this.checkBestPrice = _this.checkBestPrice.bind(_this);
			_this.reqBestPriceSubmit = _this.reqBestPriceSubmit.bind(_this);
	
			_this.req_quantityChange = _this.req_quantityChange.bind(_this);
			_this.req_stateChange = _this.req_stateChange.bind(_this);
			_this.req_cityChange = _this.req_cityChange.bind(_this);
			_this.req_doornoChange = _this.req_doornoChange.bind(_this);
			_this.req_pincodeChange = _this.req_pincodeChange.bind(_this);
	
			_this.addToWishlist = _this.addToWishlist.bind(_this);
			_this.tokenCheck = _this.tokenCheck.bind(_this);
	
			_this.getSimilarBrandDeals = _this.getSimilarBrandDeals.bind(_this);
			_this.getSimilarCatDeals = _this.getSimilarCatDeals.bind(_this);
			_this.getSimilarStageDeals = _this.getSimilarStageDeals.bind(_this);
			// this.FollowBrand=this.FollowBrand.bind(this);
			_this.submitAdAssistData = _this.submitAdAssistData.bind(_this);
			_this.getAdAssistModal = _this.getAdAssistModal.bind(_this);
			_this.setAdTime = _this.setAdTime.bind(_this);
			_this.addToCartOnload = _this.addToCartOnload.bind(_this);
			_this.checkBestPriceOnload = _this.checkBestPriceOnload.bind(_this);
			_this.addtowishlistOnload = _this.addtowishlistOnload.bind(_this);
			_this.likeBrandOnload = _this.likeBrandOnload.bind(_this);
	
			_this.goNext = _this.goNext.bind(_this);
			_this.goPrev = _this.goPrev.bind(_this);
	
			_this.addQCart = _this.addQCart.bind(_this);
			_this.addQCart_Onload = _this.addQCart_Onload.bind(_this);
			return _this;
		}
	
		_createClass(Web_ProductFullDetails, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
	
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
				localStorage.removeItem('checkout');
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
	
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
				localStorage.removeItem('web_brand_details');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
	
				if (screen.width < 800) {
					if (this.props.params.Bname) {
						window.location.href = '/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Bname + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.Did;
					} else {
						window.location.href = '/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.Did;
					}
				}
				// if(!localStorage.token && !localStorage.user_id)
				// {
				// 	localStorage.setItem('w_r_p_dt','/web/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Bname+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.Did);
				// 	browserHistory.push('/web/login');
				// 	window.location.reload();
				// }
	
				this.getDeviceId();
				//this.getAttributesTitle();
				this.getCartCount();
				// this.getswipeDescription(1);
				if (this.props.params.Bname) {
					localStorage.setItem('w_r_p_dt', '/web/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Bname + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.Did);
				} else {
					localStorage.setItem('w_r_p_dt', '/web/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.Did);
				}
	
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var url = window.location.href;
	
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'desktop_web', uid: uid, token: localStorage.getItem('token'), id: this.state.pid, deal_id: this.props.params.Did, lati: localStorage.getItem('lati'), longi: localStorage.getItem('longi'), url: url, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductDetails',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "error") {
							this.setState({
								page_error_status: true
							});
							window.location.href = data.redirect;
						}
						if (data.message === "Token mismatch") {
							localStorage.removeItem('token');
							localStorage.removeItem('user_id');
							// browserHistory.push('/web/login');
							window.location.reload();
						}
						this.setState({
							is_char: data.is_char
						});
						var t = _jquery2.default.makeArray(data.tags);
						// if(data.product_attributes.length > 0)
						// {
						//  	this.setState({
						//  		product_attributes: data.product_attributes[0].chars,
						//  	})
						// }
						var s = _jquery2.default.makeArray(data.pro_details);
						var o = _jquery2.default.makeArray(data.offer_details);
						localStorage.setItem('d_type', s[0].dtype);
						this.setState({
							loading: true,
							page_id: localStorage.getItem('cat_page'),
							offer: data,
							pdeals: data.pro_deal_details,
							pro_details: s[0],
							dtype: s[0].dtype,
							pro_deal_details: data.pro_deal_details[0],
							offer_details: o[0],
							// product_attributes: data.product_attributes[0].chars,
							imgs: data.pro_imgs,
							coupon_first: data.coupons[0],
							seller_id: data['pro_deal_details'][0]['seller_id'],
							tags: t[0]['tag'],
							title: s[0].title + " " + s[0].unit_pack + " " + s[0].brand_name,
							bread_tid: s[0].category_id,
							desc: s[0].description,
							coupons: data.coupons,
							cpns_list: data.cpns_list,
							web_title: s[0].title + " " + s[0].unit_pack + " - " + s[0].brand_name,
							web_desc: s[0].description,
							seo_title: s[0].title + " " + s[0].unit_pack + " - " + s[0].brand_name + " | AquaDeals",
							seo_desc: "Choose the Best deal on " + s[0].brand_name + " " + s[0].title + " product from our partners and avail free shipment on online purchase",
	
							cart_qty: data.cart_qty,
							min_qty: data.min_qty,
							max_qty: data.max_qty,
							min_qty1: data.min_qty,
							max_qty1: data.max_qty,
							qty: data.qty,
							unit_name: data.unit_name,
							type: data.type,
							is_cart: data.is_cart,
	
							free_ship_msg: data.free_ship_msg,
							user_zipcode: data.user_zipcode,
							free_shipment: data.free_ship_flag,
							d_type_bread: s[0].dtype,
							wishLst_flag: data.wishLst_flag,
							cat_sim_flag: data.cat_sim_flag,
							brand_sim_flag: data.brand_sim_flag,
							stage_sim_flag: data.stage_sim_flag,
							bid: data.bid,
							brand_like_status: s[0].brand_like_status,
							// brand_like_users:data.brand_like_users,
							brand_likes_count: data.brand_likes_count,
							// brand_like_rem_count:data.brand_like_rem_count,
							brand_follow_count: data.brand_follow_count,
	
							ad_guarantee: data.ad_guarantee,
							ad_guarantee_icon: data.ad_guarantee_icon,
							ad_grnt_str: data.ad_grnt_str,
	
							recommended: data.recommended,
							rating: data.pro_details.over_rating,
							dealid: data.pro_deal_details[0].deal_id,
							//the below id is deal_id of product,this is using for share url,replacecart,cart function calls 
							deal_did: data.pro_deal_details[0].id,
							brand_desc: data.pro_details.brand_desc,
							order_msg: data.order_count,
							show_order_count_flag: data.show_order_count,
							previous_order: data.previous_order,
							best_price_txt: data.best_price_txt,
							disclaimer_flag: data.disclaimer_flag,
							disclaimer_txt: data.disclaimer_txt
						});
	
						if (data.brand_sim_flag && data.cat_sim_flag && data.stage_sim_flag) {
	
							this.setState({
								similar_brand_deals_status: true
							});
							this.getSimilarBrandDeals();
						} else if (!data.brand_sim_flag && data.cat_sim_flag) {
							this.setState({
								similar_category_deals_status: true
							});
							this.getSimilarCatDeals();
						} else if (!data.brand_sim_flag && !data.cat_sim_flag && data.stage_sim_flag) {
							this.setState({
								similar_stage_deals_status: true
							});
							this.getSimilarStageDeals();
						}
	
						if (data.cart_qty > 0) {
							this.setState({
								min_qty: data.cart_qty
							});
						}
						if (data.show_about_brand === 1) {
							this.setState({
								show_about_brand_flag: true
							});
						} else {
							this.setState({
								show_about_brand_flag: false
							});
						}
						if (this.state.unit_name === "kg") {
							this.setState({
								tons: parseFloat(data.pro_deal_details[0]['min_qty'] * s[0]['qty'] / 1000).toFixed(1)
							});
						}
						if (this.state.unit_name === "gm") {
							this.setState({
								tons: parseFloat(data.pro_deal_details[0]['min_qty'] * s[0]['qty'] / 1000 / 1000).toFixed(1)
							});
						}
						if (data.is_cart === 1) {
							this.setState({
								addtocart_msg: 'Go to Cart',
								addtocart_status: true
							});
						} else {
							this.setState({
								addtocart_msg: 'Add to Cart'
							});
						}
						if (this.state.unit_name === "kg") {
							this.setState({
								min_qty: parseInt(this.state.min_qty1, 10),
								tons: this.state.min_qty * this.state.qty / 1000
							});
						} else if (this.state.is_cart === 0 && this.state.unit_name === "gm") {
							this.setState({
								min_qty: parseInt(this.state.min_qty1, 10),
								tons: parseFloat(this.state.min_qty * this.state.qty / 1000 / 1000).toFixed(7)
							});
						} else if (this.state.is_cart === 1 && this.state.unit_name !== "nos") {
							this.setState({
								min_qty: parseInt(this.state.min_qty1, 10),
								tons: this.state.min_qty * this.state.qty / 1000
								// addtocart_status:false,
							});
						}
						// if(s[0].brand_follow_status==='1')
						// {
						// 	this.setState({
						// 		b_follow_status:true,
						// 	});
						// }
						document.title = this.state.seo_title;
						document.getElementsByTagName("META")[2].content = this.state.seo_desc;
	
						// this.getSimilarBrandDeals();
					}.bind(this),
					error: function error(err) {}
				});
	
				if (localStorage.user_id && localStorage.token && localStorage.addtocart) {
					// setTimeout(() => {this.addToCartOnload()}, 10000);
					this.addToCartOnload();
				}
				if (localStorage.user_id && localStorage.token && localStorage.checkbestprice) {
					this.checkBestPriceOnload();
				}
				if (localStorage.user_id && localStorage.token && localStorage.web_addtowishlist) {
					this.addtowishlistOnload();
				}
				if (localStorage.user_id && localStorage.token && localStorage.adAssist) {
					this.getAdAssistModal();
				}
	
				if (localStorage.user_id && localStorage.token && localStorage.web_likebrand) {
					this.likeBrandOnload();
				}
				if (localStorage.user_id && localStorage.token && localStorage.quickbuy_onload) {
					this.addQCart_Onload();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.location.pathname !== this.props.location.pathname) {
					window.location.reload();
				}
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var getProductTabs = this.props.getProductTabs;
	
				getProductTabs(this.state.pid);
				//this.props.getProductDesc(this.state.pid,nextProps.product_tabs.result[0].cid);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps) {
				// compare prevProps to current props and update
				if (this.props.product_tabs !== prevProps.product_tabs) {
	
					this.props.getProductDesc(this.state.pid, this.props.product_tabs.result[0].cid);
					this.setState({
						swipe_attributes_titles: this.props.product_tabs.result,
						cid: this.props.product_tabs.result[0].cid,
						swipe_attr_status: this.props.product_tabs.result[0].cid,
						product_tabs_avail: true
					});
				}
	
				if (this.props.product_desc !== prevProps.product_desc) {
					this.setState({
						swipe_desc_info: this.props.product_desc.desc
						// swipe_product_attributes:[],
						// swipe_attr_status:this.props.product_tabs.result[0].cid,
						// check_swipe_id:this.props.product_tabs.result[0].cid,
					});
				}
			}
		}, {
			key: 'addQCart',
			value: function addQCart(dealid) {
				if (!localStorage.user_id && !localStorage.token) {
					var quantity = '';
					if (this.refs.input_minqty.value < parseInt(this.state.min_qty1, 10) || this.refs.input_minqty.value === "NaN") {
						this.setState({
							qty_err_status: true,
							qty_err_msg: "* Minimum Quantity is " + this.state.min_qty1
						});
						quantity = this.state.min_qty1;
					} else if (this.refs.input_minqty.value > parseInt(this.state.max_qty1, 10)) {
						this.setState({
							qty_err_status: true,
							qty_err_msg: "* Maximum Quantity is " + this.state.max_qty1
						});
						quantity = this.state.max_qty1;
					} else {
						if (this.props.params.Bname) {
							localStorage.setItem('w_r_p_dt', '/web/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Bname + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.Did);
						} else {
							localStorage.setItem('w_r_p_dt', '/web/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.Did);
						}
						// localStorage.setItem('w_r_p_dt','/web/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Bname+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.Did);
						localStorage.setItem('quickbuy_onload', '1');
						localStorage.setItem('quickbuy_deal_id', dealid);
						localStorage.setItem('quickbuy_qty', this.refs.input_minqty.value);
						_reactRouter.browserHistory.push('/web/login');
					}
				}
				// if(!localStorage.user_id && !localStorage.token)
				// {
				// 	localStorage.setItem('web_quickcart','/web/quickcart');
				// 	localStorage.setItem('quickbuy_onload','1');
				// 	localStorage.setItem('quickbuy_deal_id',dealid);
				//  browserHistory.push('/web/login');
				// }
				else {
						if (localStorage.user_id) {
							var uid = localStorage.user_id;
						} else {
							uid = 0;
						}
						if (localStorage.quickbuy_qty) {
							var quantity = localStorage.quickbuy_qty;
						} else {
							quantity = '';
						}
						var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, deal_id: dealid, quantity: quantity, deal_type: 1 };
						var data2 = JSON.stringify(data1);
						_jquery2.default.ajax({
							url: baseUrl + 'addToQCart',
							method: 'POST',
							data: { req: data2 },
							dataType: 'JSON',
							success: function (data) {
								if (data.status === 'success') {
									_reactRouter.browserHistory.push('/web/quickcart');
									localStorage.removeItem('quickbuy_onload');
									localStorage.removeItem('quickbuy_deal_id');
									localStorage.removeItem('quickbuy_qty');
								} else if (data.status === 'error' && data.cart_flag === 0) {
									this.setState({ clearcart_status: true });
									localStorage.removeItem('quickbuy_onload');
									localStorage.removeItem('quickbuy_deal_id');
									localStorage.removeItem('quickbuy_qty');
								} else if (data.status === 'error' && data.message === 'Token mismatch') {
									this.tokenCheck();
									localStorage.removeItem('quickbuy_onload');
									localStorage.removeItem('quickbuy_deal_id');
									localStorage.removeItem('quickbuy_qty');
								} else if (data.status === "error" && data.message === "Product already added to the cart") {
									this.setState({
										already_added_status: true
									});
									localStorage.removeItem('quickbuy_onload');
									localStorage.removeItem('quickbuy_deal_id');
									localStorage.removeItem('quickbuy_qty');
								}
							}.bind(this),
							error: function error(err) {}
						});
					}
			}
		}, {
			key: 'addQCart_Onload',
			value: function addQCart_Onload() {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('web_quickcart', '/web/quickcart');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.user_id;
					} else {
						uid = 0;
					}
					if (localStorage.quickbuy_deal_id) {
						var dealid = localStorage.quickbuy_deal_id;
					} else {
						dealid = 0;
					}
					if (localStorage.quickbuy_qty) {
						var quantity = localStorage.quickbuy_qty;
					} else {
						quantity = '';
					}
					var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, quantity: quantity, deal_id: dealid, deal_type: 1 };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						url: baseUrl + 'addToQCart',
						method: 'POST',
						data: { req: data2 },
						dataType: 'JSON',
						success: function (data) {
							if (data.status === 'success') {
								_reactRouter.browserHistory.push('/web/quickcart');
								window.location.reload();
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
								localStorage.removeItem('quickbuy_qty');
							} else if (data.status === 'error' && data.cart_flag === 0) {
								this.setState({ clearcart_status: true });
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
								localStorage.removeItem('quickbuy_qty');
							} else if (data.status === 'error' && data.message === 'Token mismatch') {
								this.tokenCheck();
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
								localStorage.removeItem('quickbuy_qty');
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
								localStorage.removeItem('quickbuy_qty');
							}
							localStorage.removeItem('quickbuy_onload');
							localStorage.removeItem('quickbuy_deal_id');
							localStorage.removeItem('quickbuy_qty');
						}.bind(this),
						error: function error(err) {}
	
					});
				}
			}
		}, {
			key: 'getCartCount',
			value: function getCartCount() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							cart_count: data.cart_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'goNext',
			value: function goNext() {
				if (this.swiper) this.swiper.slideNext();
			}
		}, {
			key: 'goPrev',
			value: function goPrev() {
				if (this.swiper) this.swiper.slidePrev();
			}
		}, {
			key: 'tokenCheck',
			value: function tokenCheck() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				}
				// localStorage.removeItem('user_id');
				// localStorage.removeItem('token');
				localStorage.clear();
				if (source) {
					localStorage.setItem('source', source);
				}
				if (campaign) {
					localStorage.setItem('campaign', campaign);
				}
				if (url_id) {
					localStorage.setItem('url_id', url_id);
				}
				window.location.reload();
			}
		}, {
			key: 'getDeviceId',
			value: function getDeviceId() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getDeviceId',
					dataType: 'json',
					data: { req: data2 },
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					showModal: false,
					clearcart_status: false,
					reqbestPrice: false,
					req_confirm_modal: false,
					cart_added_status: false,
					ad_assist_modal: false,
					ad_asst_confirm_modal: false
				});
			}
		}, {
			key: 'pincodeChange',
			value: function pincodeChange() {
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(this.refs.pincode.value)) {
					var x = this.refs.pincode.value.replace(invalidChars, "");
				} else {
					this.setState({
						err_pincode: true
					});
				}
				this.setState({
					user_zipcode: x,
					err_pincode: false
				});
			}
		}, {
			key: 'checkPincode',
			value: function checkPincode() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				if (this.refs.pincode.value.length === 6) {
					var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token'), type: 1, did: this.props.params.Did, zip: this.refs.pincode.value, device_id: localStorage.getItem('push_device_id') };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						url: baseUrl + 'checkFreeshipment',
						dataType: 'json',
						data: { req: data2 },
						success: function (data) {
							this.setState({
								free_ship_msg: data.msg
							});
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
						}.bind(this),
						error: function error(err) {}
					});
				} else {
					this.setState({
						err_pincode: true,
						err_pincode_msg: '* Invalid pincode'
					});
				}
			}
		}, {
			key: 'removeCartItems',
			value: function removeCartItems() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token'), deal_id: this.state.deal_did, deal_type: 1, quantity: this.refs.input_minqty.value, pl_size: 0, salinity: 0, pickup_date: 0, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'replaceCart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success" && data.cart_flag === 1) {
							this.setState({
								addtocart_msg: 'Go to Cart',
								clearcart_status: false,
								addtocart_status: true
							});
							this.getCartCount();
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'reqBestPriceSubmit',
			value: function reqBestPriceSubmit(event) {
				event.preventDefault();
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var quantity = this.refs.req_quantity.value;
				var state = this.refs.req_state.value;
				{/*var city = this.refs.req_city.value;
	    var doorno = this.refs.req_doorno.value;*/}
				var pincode = this.refs.req_pincode.value;
				var flag = 0;
				var namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
				if (quantity === '' && quantity.length < 1) {
					(0, _jquery2.default)('#req_quantity_err').text('* Enter quantity');
					flag = 1;
				}
	
				if (quantity !== '' && parseInt(quantity) < parseInt(this.state.pro_deal_details.best_price_min_qty)) {
					(0, _jquery2.default)('#req_quantity_err').text('* Minimum Quantity is ' + this.state.pro_deal_details.best_price_min_qty + '');
					flag = 1;
				}
				if (state === '' && !namePattern.test(state) && state.length < 2) {
					(0, _jquery2.default)('#req_state_err').text('* Enter state');
					flag = 1;
				}
				if (state !== '' && state.length < 2 && !namePattern.test(state)) {
					(0, _jquery2.default)('#req_state_err').text('* Enter valid state');
					flag = 1;
				}
				{/*if(city==='' && !namePattern.test(city))
	    {
	     	$('#req_city_err').text('* enter city');
	     	flag= 1;
	    }
	    if(city !=='' && city.length < 3)
	    {
	    $('#req_city_err').text('* enter city');
	    flag = 1;
	    }
	    if(doorno==='' && doorno.length <= 1)
	    {
	    $('#req_doorno_err').text('* enter address');
	     	flag= 1;
	    }
	    if(doorno!=='' && doorno.length <= 1)
	    {
	    $('#req_doorno_err').text('* enter address');
	     	flag= 1;
	    }*/}
				if (pincode === '' && pincode.length < 6) {
					(0, _jquery2.default)('#req_pincode_err').text('* Enter valid pincode');
					flag = 1;
				}
				if (pincode !== '' && pincode.length < 6) {
					(0, _jquery2.default)('#req_pincode_err').text('* Enter valid pincode');
					flag = 1;
				}
				// if(quantity !=='' && quantity < parseInt(this.state.min_qty1,10))
				// {
				// 	$('#req_quantity_err').text('* Minimum quantity is '+this.state.min_qty1);
				// 	flag =1;
				// }
				// if(quantity > parseInt(this.state.max_qty1,10))
				// {
				// 	$('#req_quantity_err').text('* Maximum quantity is '+this.state.max_qty1);
				// 	flag =1;
				// }
				if (flag === 0) {
					this.setState({
						reqbestPrice: false
						// disable_button:false,
					});
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, did: this.props.params.Did, dtype: '1', req_qty: this.state.req_quantity, state: this.state.req_state, city: this.state.req_city, address: this.state.req_doorno, pincode: this.state.req_pincode, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'saveBestpriceLead',
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									reqbestPrice: false,
									req_confirm_modal: true,
									req_confirm_message: data.message
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'req_quantityChange',
			value: function req_quantityChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						req_quantity: x
					});
				}
			}
		}, {
			key: 'req_stateChange',
			value: function req_stateChange(event) {
				var x = event.target.value;
				var namePattern = /^[a-z A-Z]+$/;
				if (!namePattern.test(event.target.value) && x !== '') {
					x = event.target.value.replace(namePattern, "");
				} else {
					this.setState({
						req_state: event.target.value
					});
				}
			}
		}, {
			key: 'req_cityChange',
			value: function req_cityChange(event) {
				var x = event.target.value;
				var namePattern = /^[a-z A-Z]+$/;
				if (!namePattern.test(event.target.value) && x !== '') {
					x = event.target.value.replace(namePattern, "");
				} else {
					this.setState({
						req_city: event.target.value
					});
				}
			}
		}, {
			key: 'req_doornoChange',
			value: function req_doornoChange(event) {
				this.setState({
					req_doorno: event.target.value
				});
			}
		}, {
			key: 'checkBestPriceOnload',
			value: function checkBestPriceOnload() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('checkbestprice', '1');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'desktop_web', did: this.props.params.Did, id: uid, dtype: 1, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'checkBestPriceLead',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success' && data.proceed === 1) {
								this.setState({
									reqbestPrice: true
								});
								localStorage.removeItem('checkbestprice');
							} else if (data.status === 'success' && data.proceed === 0) {
								this.setState({
									req_confirm_modal: true,
									req_confirm_message: data.msg
								});
								localStorage.removeItem('checkbestprice');
							}
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'checkBestPrice',
			value: function checkBestPrice() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('checkbestprice', '1');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'desktop_web', did: this.props.params.Did, id: uid, dtype: 1, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'checkBestPriceLead',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success' && data.proceed === 1) {
								this.setState({
									reqbestPrice: true
								});
								localStorage.removeItem('checkbestprice');
							} else if (data.status === 'success' && data.proceed === 0) {
								this.setState({
									req_confirm_modal: true,
									req_confirm_message: data.msg
								});
								localStorage.removeItem('checkbestprice');
							}
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'req_pincodeChange',
			value: function req_pincodeChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						req_pincode: x
					});
				}
			}
		}, {
			key: 'getswipeDescription',
			value: function getswipeDescription(pid, cid) {
				this.props.getProductDesc(pid, cid);
				this.setState({
					swipe_attr_status: cid
				});
				// this.setState({
				// 	swipe_description_status:pid,
				// });
				// var func='';
			}
		}, {
			key: 'ShareFunc',
			value: function ShareFunc(evnt) {
				var _this2 = this;
	
				var data1 = { from: 'desktop_web', type: 1, did: evnt };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'createTinyurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							shareUrl: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {}
				});
				this.setState({ open: !this.state.open });
				setTimeout(function () {
					_this2.setState({ open: false });
				}, 10000);
			}
		}, {
			key: 'decrementMinQty',
			value: function decrementMinQty() {
				var minquantity = '';
				var removedquantity = '';
				var total = '';
				setTimeout(function () {
					(0, _jquery2.default)('.plus_btn img').attr('src', __webpack_require__(46));
					if (parseInt(this.refs.input_minqty.value) - 1 <= parseInt(this.state.min_qty1)) {
						(0, _jquery2.default)('.minus_btn img').attr('src', __webpack_require__(45));
					}
				}.bind(this), 100);
				if (this.state.unit_name === "") {
					minquantity = parseInt(this.state.min_qty, 10);
				} else if (parseInt(this.state.min_qty, 10) <= parseInt(this.state.min_qty1, 10)) {
					minquantity = parseInt(this.state.min_qty1, 10);
					removedquantity = parseInt(500 / minquantity, 10);
					total = parseInt(minquantity, 10);
				} else if (this.state.unit_name === "kg" && this.state.type === "Feed") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(500 / this.state.qty, 10);
					// total = parseInt(minquantity - removedquantity,10)
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(500 / this.state.qty, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(500 / this.state.qty, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "kg" && this.state.type === "Health Care") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(1,10);
					// total=parseInt(minquantity - removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "kg" && this.state.type === "Hatchery Health Care") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(1,10);
					// total=parseInt(minquantity - removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "gm" && this.state.type === "Feed") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(500 * 1000 / this.state.qty,10);
					// total=parseInt(minquantity - removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(500 * 1000 / this.state.qty, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(500 * 1000 / this.state.qty, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "gm" && this.state.type === "Health Care") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(1,10);
					// total=parseInt(minquantity - removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "gm" && this.state.type === "Hatchery Health Care") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(1,10);
					// total=parseInt(minquantity - removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "ltr" && this.state.type === "Feed") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(500 / this.state.qty,10);
					// total=parseInt(minquantity - removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(500 / this.state.qty, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(500 / this.state.qty, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "ltr" && this.state.type === "Health Care") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(1,10);
					// total=parseInt(minquantity - removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "ltr" && this.state.type === "Hatchery Health Care") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(1,10);
					// total=parseInt(minquantity-removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "nos") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(1,10);
					// total=parseInt(minquantity-removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(1,10);
					// total=parseInt(minquantity-removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				}
	
				if (this.state.is_cart === 1 && this.state.unit_name !== "nos") {
					this.setState({
						min_qty: parseInt(total, 10),
						tons: total * this.state.qty / 1000,
						addtocart_msg: 'Update Cart'
						// addtocart_status:false,
					});
				} else if (this.state.is_cart === 0 && this.state.unit_name === "nos") {
					this.setState({
						min_qty: parseInt(total, 10),
						// tons: total * this.state.qty / 1000,
						addtocart_msg: 'Add to Cart'
					});
				} else if (this.state.is_cart === 0 && this.state.unit_name === "kg") {
					this.setState({
						min_qty: parseInt(total, 10),
						tons: total * this.state.qty / 1000,
						addtocart_msg: 'Add to Cart'
						// addtocart_status:false,
					});
				} else if (this.state.is_cart === 0 && this.state.unit_name === "gm") {
					this.setState({
						min_qty: parseInt(total, 10),
						tons: total * this.state.qty / 1000 / 1000,
						addtocart_msg: 'Add to Cart'
						// addtocart_status:false,
					});
				} else if (this.state.is_cart === 1 && this.state.unit_name === "nos") {
					this.setState({
						min_qty: parseInt(total, 10),
						addtocart_msg: 'Update Cart'
						// addtocart_status:false,
					});
				} else {
					if (this.state.is_cart === 0) {
						this.setState({
							min_qty: parseInt(total, 10),
							// tons: total * this.state.qty / 1000,
							addtocart_msg: 'Add to Cart'
						});
					}
					if (this.state.is_cart === 1) {
						this.setState({
							min_qty: parseInt(total, 10),
							addtocart_msg: 'Update Cart'
						});
					}
				}
			}
		}, {
			key: 'updateMinQty',
			value: function updateMinQty(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						min_qty: x,
						tons: x * this.state.qty / 1000
					});
				}
				if (x > parseInt(this.state.max_qty1, 10)) {
					this.setState({
						min_qty: this.state.max_qty1,
						tons: this.state.max_qty1 * this.state.qty / 1000
					});
				}
			}
		}, {
			key: 'incrementMinQty',
			value: function incrementMinQty() {
				setTimeout(function () {
					(0, _jquery2.default)('.minus_btn img').attr('src', __webpack_require__(75));
					if (parseInt(this.refs.input_minqty.value) >= parseInt(this.state.max_qty1)) {
						(0, _jquery2.default)('.plus_btn img').attr('src', __webpack_require__(110));
					}
				}.bind(this), 100);
	
				this.setState({
					qty_err_status: false
				});
				if (this.state.unit_name === "kg") {
					var add = '';
					var tons = '';
					if (this.state.type === "Feed" && this.refs.input_minqty.value !== '') {
						add = parseInt(this.state.min_qty, 10) + parseInt(500 / this.state.qty, 10);
						tons = add * this.state.qty / 1000;
					} else if (this.state.type === "Feed" && this.refs.input_minqty.value === '') {
						add = parseInt(this.state.min_qty1, 10) + parseInt(500 / this.state.qty, 10);
						tons = add * this.state.qty / 1000;
					}
					if ((this.state.type === "Health Care" || this.state.type === "Hatchery Health Care") && this.refs.input_minqty.value !== '') {
						add = parseInt(this.state.min_qty, 10) + 1;
						tons = add * this.state.qty / 1000;
					} else if ((this.state.type === "Health Care" || this.state.type === "Hatchery Health Care") && this.refs.input_minqty.value === '') {
						add = parseInt(this.state.min_qty1, 10) + parseInt(500 / this.state.qty, 10);
						tons = add * this.state.qty / 1000;
					}
	
					if (add > this.state.max_qty1) {
						// alert("Maximum limit is "+this.state.max_qty1)
						this.setState({
							min_qty: this.state.max_qty1,
							tons: this.state.max_qty1 * this.state.qty / 1000,
							qty_err_status: true,
							qty_err_msg: "* Maximum Quantity is " + this.state.max_qty1
						});
					} else {
						if (this.state.is_cart === 1) {
							this.setState({
								min_qty: add,
								tons: tons,
								addtocart_msg: 'Update Cart'
							});
						} else {
							this.setState({
								min_qty: add,
								tons: tons,
								addtocart_msg: 'Add to Cart'
							});
						}
					}
				}
	
				//  GRAMS INCREMENT 
				else if (this.state.unit_name === "gm") {
	
						if (this.state.type === "Feed" && this.refs.input_minqty.value !== '') {
							add = parseInt(this.state.min_qty, 10) + parseInt(500 * 1000 / this.state.qty, 10);
							tons = add * this.state.qty / 1000 / 1000;
						} else if (this.state.type === "Feed" && this.refs.input_minqty.value === '') {
							add = parseInt(this.state.min_qty1, 10) + parseInt(500 * 1000 / this.state.qty, 10);
							tons = add * this.state.qty / 1000 / 1000;
						}
	
						if ((this.state.type === "Health Care" || this.state.type === "Hatchery Health Care") && this.refs.input_minqty.value !== '') {
							add = parseInt(this.state.min_qty, 10) + parseInt(1, 10);
							tons = add * this.state.qty / 1000 / 1000;
						} else if ((this.state.type === "Health Care" || this.state.type === "Hatchery Health Care") && this.refs.input_minqty.value === '') {
							add = parseInt(this.state.min_qty1, 10) + parseInt(1, 10);
							tons = add * this.state.qty / 1000 / 1000;
						}
	
						//  adding if not greater thn limit.
						if (add > this.state.max_qty1) {
							// alert("Maximum limit is "+this.state.max_qty1)
	
							this.setState({
								min_qty: this.state.max_qty1,
								qty_err_status: true,
								qty_err_msg: "* Maximum Quantity is " + this.state.max_qty1
							});
						} else {
							if (this.state.is_cart === 1) {
								this.setState({
									min_qty: add,
									tons: tons,
									addtocart_msg: 'Update Cart'
								});
							} else {
								this.setState({
									min_qty: add,
									tons: tons,
									addtocart_msg: 'Add to Cart'
								});
							}
						}
					}
					// LTR's
					else if (this.state.unit_name === "ltr") {
	
							if (this.state.type === "Feed" && this.refs.input_minqty.value !== '') {
								add = parseInt(this.state.min_qty, 10) + parseInt(500 / this.state.qty, 10);
							} else if (this.state.type === "Feed" && this.refs.input_minqty.value === '') {
								add = parseInt(this.state.min_qty1, 10) + parseInt(500 / this.state.qty, 10);
							}
	
							if ((this.state.type === "Health Care" || this.state.type === "Hatchery Health Care") && this.refs.input_minqty.value !== '') {
								add = parseInt(this.state.min_qty, 10) + parseInt(1, 10);
							} else if ((this.state.type === "Health Care" || this.state.type === "Hatchery Health Care") && this.refs.input_minqty.value === '') {
								add = parseInt(this.state.min_qty1, 10) + parseInt(1, 10);
							}
	
							if (add > this.state.max_qty1) {
								// alert("Maximum limit is "+this.state.max_qty1)
								this.setState({
									min_qty: this.state.max_qty1,
									qty_err_status: true,
									qty_err_msg: "* Maximum Quantity is " + this.state.max_qty1
								});
							} else {
								if (this.state.is_cart === 1) {
									this.setState({
										min_qty: add,
										addtocart_msg: 'Update Cart'
									});
								} else {
									this.setState({
										min_qty: add,
										addtocart_msg: 'Add to Cart'
									});
								}
							}
						} else if (this.state.unit_name === "nos") {
							if (this.refs.input_minqty.value !== '') {
								add = parseInt(this.state.min_qty, 10) + 1;
							} else {
								add = parseInt(this.state.min_qty1, 10);
							}
	
							if (add > this.state.max_qty1) {
	
								this.setState({
									min_qty: this.state.max_qty1,
									qty_err_status: true,
									qty_err_msg: "* Maximum Quantity is " + this.state.max_qty1
								});
							} else {
								if (this.state.is_cart === 1) {
									this.setState({
										min_qty: add,
										addtocart_msg: 'Update Cart'
									});
								} else {
									this.setState({
										min_qty: add,
										addtocart_msg: 'Add to Cart'
									});
								}
							}
						} else {
							if (this.refs.input_minqty.value !== '') {
								add = parseInt(this.state.min_qty, 10) + 1;
							} else {
								add = parseInt(this.state.min_qty1, 10);
							}
	
							if (add > this.state.max_qty1) {
	
								this.setState({
									min_qty: this.state.max_qty1,
									qty_err_status: true,
									qty_err_msg: "* Maximum Quantity is " + this.state.max_qty1
								});
							} else {
								if (this.state.is_cart === 1) {
									this.setState({
										min_qty: add,
										addtocart_msg: 'Update Cart'
									});
								} else {
									this.setState({
										min_qty: add,
										addtocart_msg: 'Add to Cart'
									});
								}
							}
						}
			}
		}, {
			key: 'addToCartOnload',
			value: function addToCartOnload() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (this.state.addtocart_msg === "Go to Cart") {
					_reactRouter.browserHistory.push('/web/mycart');
				}
				if (!localStorage.user_id && !localStorage.token) {
					if (this.props.params.Bname) {
						localStorage.setItem('w_r_p_dt', '/web/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Bname + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.Did);
					} else {
						localStorage.setItem('w_r_p_dt', '/web/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.Did);
					}
					localStorage.setItem('addtocart', '1');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					this.setState({
						rotateClass: true
					});
					var quantity = '';
					if (localStorage.addtocart_qty) {
						quantity = localStorage.getItem('addtocart_qty');
					}
					if (parseInt(quantity, 10) < parseInt(this.state.min_qty1, 10) || quantity === "NaN") {
						this.setState({
							qty_err_status: true,
							qty_err_msg: "* Minimum Quantity is " + this.state.min_qty1
						});
						// quantity=this.state.min_qty1;
					} else {
						// quantity=this.refs.input_minqty.value;
						if (localStorage.addtocart_qty) {
							quantity = localStorage.getItem('addtocart_qty');
						} else {
							quantity = this.state.min_qty;
						}
						var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token'), deal_id: this.state.dealid, deal_type: 1, quantity: quantity, pl_size: 0, salinity: 0, pickup_date: 0 };
						var data2 = JSON.stringify(data1);
						_jquery2.default.ajax({
							method: 'post',
							dataType: 'json',
							url: baseUrl + 'addToCart',
							data: { req: data2 },
							success: function (data) {
								if (data.status === "success" && data.message === "Added to cart") {
									this.setState({
										addtocart_msg: 'Go to Cart',
										is_cart: data.cart_flag
									});
									// this.getCartCount();
									localStorage.removeItem('addtocart');
									localStorage.removeItem('addtocart_qty');
								}
								if (data.status === "success" && data.message === "Cart Updated") {
									this.setState({
										addtocart_msg: 'Go to Cart',
										is_cart: data.cart_flag
									});
									localStorage.removeItem('addtocart');
									localStorage.removeItem('addtocart_qty');
								}
								if (data.status === "error" && data.cart_flag === 0) {
									this.setState({
										clearcart_status: true
									});
									localStorage.removeItem('addtocart');
									localStorage.removeItem('addtocart_qty');
								}
								if (data.status === "error" && data.message === "Product already added to the cart" && data.cart_flag === 1) {
									this.setState({
										cart_added_status: true,
										addtocart_msg: 'Go to Cart',
										// addtocart_status:true,
										is_cart: data.cart_flag
									});
									localStorage.removeItem('addtocart');
									localStorage.removeItem('addtocart_qty');
								}
								this.getCartCount();
								if (data.status === 'error' && data.message === 'Token mismatch') {
									this.props.tokenCheck();
								}
							}.bind(this),
							error: function error(err) {}
						});
					}
				}
			}
		}, {
			key: 'placeOrderModal',
			value: function placeOrderModal() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (this.state.addtocart_msg === "Go to Cart") {
					_reactRouter.browserHistory.push('/web/mycart');
				}
				if (!localStorage.user_id && !localStorage.token) {
					var quantity = '';
					if (this.refs.input_minqty.value < parseInt(this.state.min_qty1, 10) || this.refs.input_minqty.value === "NaN") {
						this.setState({
							qty_err_status: true,
							qty_err_msg: "* Minimum Quantity is " + this.state.min_qty1
						});
						quantity = this.state.min_qty1;
					} else if (this.refs.input_minqty.value > parseInt(this.state.max_qty1, 10)) {
						this.setState({
							qty_err_status: true,
							qty_err_msg: "* Maximum Quantity is " + this.state.max_qty1
						});
						quantity = this.state.max_qty1;
					} else {
						if (this.props.params.Bname) {
							localStorage.setItem('w_r_p_dt', '/web/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Bname + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.Did);
						} else {
							localStorage.setItem('w_r_p_dt', '/web/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.Did);
						}
						localStorage.setItem('w_r_p_dt', '/web/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Bname + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.Did);
						localStorage.setItem('addtocart', '1');
						localStorage.setItem('addtocart_qty', this.state.min_qty);
						_reactRouter.browserHistory.push('/web/login');
					}
				} else {
					if (this.state.addtocart_msg === "Add to Cart" || this.state.addtocart_msg === "Update Cart") {
						this.setState({
							rotateClass: true
						});
						quantity = '';
						if (this.refs.input_minqty.value < parseInt(this.state.min_qty1, 10) || this.refs.input_minqty.value === "NaN") {
							this.setState({
								qty_err_status: true,
								qty_err_msg: "* Minimum Quantity is " + this.state.min_qty1
							});
							quantity = this.state.min_qty1;
						} else {
							quantity = this.refs.input_minqty.value;
							if (localStorage.source) {
								var source = localStorage.getItem('source');
							} else {
								source = '';
							}
							if (localStorage.campaign) {
								var campaign = localStorage.getItem('campaign');
							} else {
								campaign = '';
							}
							if (localStorage.url_id) {
								var url_id = localStorage.getItem('url_id');
							} else {
								url_id = '';
							}
							var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token'), deal_id: this.state.deal_did, deal_type: 1, quantity: quantity, pl_size: 0, salinity: 0, pickup_date: 0, source: source, campaign: campaign, url_id: url_id };
							var data2 = JSON.stringify(data1);
							_jquery2.default.ajax({
								method: 'post',
								dataType: 'json',
								url: baseUrl + 'addToCart',
								data: { req: data2 },
								success: function (data) {
									if (data.status === "success" && data.message === "Added to cart") {
										this.setState({
											addtocart_msg: 'Go to Cart',
											is_cart: data.cart_flag,
											qty_err_status: false
										});
										// this.getCartCount();
										localStorage.removeItem('addtocart');
										localStorage.removeItem('addtocart_qty');
									}
									if (data.status === "success" && data.message === "Cart Updated") {
										this.setState({
											addtocart_msg: 'Go to Cart',
											is_cart: data.cart_flag,
											qty_err_status: false
										});
										localStorage.removeItem('addtocart');
										localStorage.removeItem('addtocart_qty');
									}
									if (data.status === "error" && data.cart_flag === 0) {
										this.setState({
											clearcart_status: true
										});
										localStorage.removeItem('addtocart');
										localStorage.removeItem('addtocart_qty');
									}
									if (data.status === "error" && data.message === "Product already added to the cart" && data.cart_flag === 1) {
										this.setState({
											cart_added_status: true,
											addtocart_msg: 'Go to Cart',
											qty_err_status: false,
											// addtocart_status:true,
											is_cart: data.cart_flag
										});
										localStorage.removeItem('addtocart');
										localStorage.removeItem('addtocart_qty');
									}
									this.getCartCount();
								}.bind(this),
								error: function error(err) {}
							});
						}
					}
				}
			}
			// **********************
	
		}, {
			key: 'getAdAssistModal',
			value: function getAdAssistModal() {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('adassist_status', '1');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'desktop_web', id: uid, pid: this.props.params.Pid, token: localStorage.getItem('token'), source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'checkaskExpert',
						success: function (data) {
							if (data.status === 'success' && data.proceed === 1) {
								this.setState({
									ad_assist_modal: !this.state.ad_assist_modal,
									assist_data: data,
									queries: data.queries
								});
								localStorage.removeItem('adassist_status');
							}
							if (data.status === 'success' && data.proceed === 0) {
								this.setState({
									ad_asst_confirm_modal: true,
									ad_asst_confirm_message: data.msg
								});
								localStorage.removeItem('adassist_status');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'submitAdAssistData',
			value: function submitAdAssistData(event) {
				event.preventDefault();
				var error_flag = false;
				var q_id = (0, _jquery2.default)('#ad-sel-question').val();
				if (q_id == 1) {
					(0, _jquery2.default)('#ad-sel-question').css("color", "red");
					(0, _jquery2.default)('#ad-sel-question option').css("color", "#666");
					error_flag = true;
				} else {
					(0, _jquery2.default)('#ad-sel-question').css("color", "#666");
					(0, _jquery2.default)('#ad-sel-question option').css("color", "#666");
					error_flag = false;
				}
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var ad_time = this.state.ad_asst_time ? this.state.ad_asst_time : '0';
				if (ad_time == '0') {
					error_flag = true;
					this.setState({
						time_err_status: true,
						time_err_msg: '* Required'
					});
				}
				if (!error_flag) {
					var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, pid: this.props.params.Pid, time: ad_time, desc: '', source: source, campaign: campaign, url_id: url_id, selectedQue: q_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'askExpert',
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									ad_assist_modal: false,
									ad_asst_confirm_message: data.message,
									ad_asst_confirm_modal: true
								});
							} else {
								this.setState({
									ad_assist_modal: false
									// ad_asst_confirm_message:data.message,
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'setAdTime',
			value: function setAdTime(val) {
				this.setState({
					ad_asst_time: val
				});
			}
		}, {
			key: 'likeBrandOnload',
			value: function likeBrandOnload() {
				if (localStorage.web_likebrand_status) {
					var status = localStorage.getItem('web_likebrand_status');
				} else {
					status = '';
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('web_likebrand', '1');
					localStorage.setItem('web_likebrand_qty', status);
					_reactRouter.browserHistory.push('/web/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, brand_id: localStorage.getItem('web_likebrand_bid'), status: status };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'like_brand',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									brand_like_status: data.like_status,
									brand_likes_count: data.brand_likes_count
								});
								localStorage.removeItem('web_likebrand');
								localStorage.removeItem('web_likebrand_status');
								localStorage.removeItem('web_likebrand_bid');
							}
							if (data.like_status === 1) {
								this.setState({
									brand_like_status: '1'
								});
								localStorage.removeItem('web_likebrand');
								localStorage.removeItem('web_likebrand_status');
								localStorage.removeItem('web_likebrand_bid');
							} else {
								this.setState({
									brand_like_status: '0'
								});
								localStorage.removeItem('web_likebrand');
								localStorage.removeItem('web_likebrand_status');
								localStorage.removeItem('web_likebrand_bid');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'likeBrand',
			value: function likeBrand(status) {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('web_likebrand', '0');
					localStorage.setItem('web_likebrand_status', status);
					localStorage.setItem('web_likebrand_bid', this.state.bid);
					_reactRouter.browserHistory.push('/web/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, brand_id: this.state.offer.bid, status: status };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'like_brand',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									brand_like_status: data.like_status,
									brand_likes_count: data.brand_likes_count
								});
								localStorage.removeItem('web_likebrand');
								localStorage.removeItem('web_likebrand_status');
								localStorage.removeItem('web_likebrand_bid');
							}
							if (data.like_status === 1) {
								this.setState({
									brand_like_status: '1'
								});
								localStorage.removeItem('web_likebrand');
								localStorage.removeItem('web_likebrand_status');
								localStorage.removeItem('web_likebrand_bid');
							} else {
								this.setState({
									brand_like_status: '0'
								});
								localStorage.removeItem('web_likebrand');
								localStorage.removeItem('web_likebrand_status');
								localStorage.removeItem('web_likebrand_bid');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'getSimilarBrandDeals',
			value: function getSimilarBrandDeals() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				this.setState({
					similar_brand_deals_status: true,
					similar_category_deals_status: false,
					similar_stage_deals_status: false
				});
				if (this.state.similar_brand_deals_status) {
					var data1 = { from: 'desktop_web', tid: this.state.bid, type: 'brand', dtype: this.state.pro_details.dtype, uid: uid, page: 1, bid: '', sort: '', pDetails_viewmore: 1, deal_id: this.props.params.Did };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'getProductbycat_brand',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									similar_brand_deals: data.result
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'getSimilarCatDeals',
			value: function getSimilarCatDeals() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				this.setState({
					similar_category_deals_status: true,
					similar_brand_deals_status: false,
					similar_stage_deals_status: false
				});
				// if(!this.state.similar_category_deals_status)
				// {
				var data1 = { from: 'desktop_web', tid: this.state.pro_details.category_id, type: 'Pcategory', dtype: this.state.pro_details.dtype, uid: uid, page: 1, bid: '', sort: '', pDetails_viewmore: 1, deal_id: this.props.params.Did };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'getProductbycat_brand',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								similar_category_deals: data.result
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
				// }
			}
		}, {
			key: 'getSimilarStageDeals',
			value: function getSimilarStageDeals() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				this.setState({
					similar_stage_deals_status: true,
					similar_category_deals_status: false,
					similar_brand_deals_status: false
				});
				// if(!this.state.similar_stage_deals_status)
				// {
				var data1 = { from: 'desktop_web', tid: this.state.pro_details.stage, type: 'stage', dtype: this.state.pro_details.dtype, uid: uid, page: 1, bid: '', sort: '', 'pDetails_viewmore': 1, deal_id: this.props.params.Did };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'getProductbycat_brand',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								similar_stage_deals: data.result
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
				// }
			}
		}, {
			key: 'addtowishlistOnload',
			value: function addtowishlistOnload() {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('web_addtowishlist', '1');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					// this.setState({
					// 		page_loading:true,
					// });
					var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, type: 1, did: this.props.params.Did };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'addToWishlist',
						success: function (data) {
							if (data.status === 'success' && data.message === 'Added to wish list') {
								this.setState({
									wishLst_flag: 1,
									page_loading: false
								});
							} else if (data.status === 'error' && data.message === 'Token mismatch') {
								this.tokenCheck();
							}
							localStorage.removeItem('web_addtowishlist');
						}.bind(this),
						error: function error(err) {
							this.setState({
								page_loading: false
							});
						}
					});
				}
			}
		}, {
			key: 'addToWishlist',
			value: function addToWishlist() {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('web_addtowishlist', '1');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					this.setState({
						page_loading: true
					});
					var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, type: 1, did: this.state.pro_deal_details.id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'addToWishlist',
						success: function (data) {
							if (data.status === 'success' && data.message === 'Added to wish list') {
								this.setState({
									wishLst_flag: 1,
									page_loading: false
								});
							} else if (data.status === 'error' && data.message === 'Token mismatch') {
								this.tokenCheck();
							}
							localStorage.removeItem('web_addtowishlist');
						}.bind(this),
						error: function error(err) {
							this.setState({
								page_loading: false
							});
						}
					});
				}
			}
		}, {
			key: 'videoplayer',
			value: function videoplayer(url, id) {
				var url = url.split("=").pop();
				window.open("http://www.youtube.com/embed/" + url);
			}
		}, {
			key: 'toggleDisclaimer',
			value: function toggleDisclaimer() {
				this.setState({ visibility: !this.state.visibility });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var that = this;
				var carousel_params = '';
	
				var img_array = _jquery2.default.makeArray(this.state.imgs);
				if (img_array.length > 1) {
					carousel_params = {
						pagination: {
							el: '.swiper-pagination',
							clickable: true,
							dynamicBullets: false
						}
					};
				} else {
					carousel_params = {
						paginationClickable: true,
						slidesPerView: 1,
						spaceBetween: 0
					};
				}
				var self = this;
				var product_imgs = img_array.map(function (image, index) {
					if (image.url) {
						return _react2.default.createElement(
							'div',
							{ style: { 'maxWidth': '100%' }, className: 'slide-id-' + index },
							_react2.default.createElement(
								'div',
								{ onClick: function onClick() {
										self.videoplayer(image.url, index);
									}, style: { height: '355px' } },
								_react2.default.createElement(
									'i',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'table',
									{ id: 'wrapper' },
									_react2.default.createElement(
										'tr',
										null,
										_react2.default.createElement(
											'td',
											null,
											_react2.default.createElement('img', { itemProp: 'image', src: baseAssets + 'images/product_imgs/' + image.img }),
											_react2.default.createElement(
												'div',
												{ className: 'web_play_icon' },
												_react2.default.createElement(
													'span',
													null,
													_react2.default.createElement('img', { src: baseAssets + 'images/play_icon.png', alt: ' ' })
												)
											)
										)
									)
								)
							)
						);
					} else {
						return _react2.default.createElement(
							'div',
							{ style: { 'maxWidth': '100%' } },
							_react2.default.createElement('img', { itemProp: 'image', src: baseAssets + 'images/product_imgs/' + image.img, alt: ' ', height: '355px', className: 'img-item-' + (index % 2 ? 'even' : 'odd') })
						);
						{/*return (<div className="iframe-container"><div style={{height:'355px'}}><iframe src="https://www.youtube.com/embed/QH2-TGUlwu4" width="560" height="315" frameborder="0"></iframe></div></div>);*/}
					}
				});
	
				(0, _jquery2.default)('.min_qty_btn input').unbind("keyup").keyup(function (e) {
	
					if (parseInt((0, _jquery2.default)('.min_qty_btn input').val()) < parseInt(that.state.min_qty1)) {
						(0, _jquery2.default)('.plus_btn img').attr('src', __webpack_require__(46));
						(0, _jquery2.default)('.minus_btn img').attr('src', __webpack_require__(75));
					}
					if (parseInt((0, _jquery2.default)('.min_qty_btn input').val()) < parseInt(that.state.min_qty1) || isNaN(parseInt((0, _jquery2.default)('.min_qty_btn input').val()))) {
						(0, _jquery2.default)('.minus_btn img').attr('src', __webpack_require__(45));
					}
					if (e.keyCode == 8) {
						if (parseInt((0, _jquery2.default)('.min_qty_btn input').val()) < parseInt(that.state.min_qty1)) {
							console.log("Key background");
							(0, _jquery2.default)('.plus_btn img').attr('src', __webpack_require__(46));
						}
					}
	
					if (parseInt((0, _jquery2.default)('.min_qty_btn input').val()) > parseInt(that.state.min_qty1)) {
						(0, _jquery2.default)('.minus_btn img').attr('src', __webpack_require__(75));
					}
	
					if (parseInt((0, _jquery2.default)('.min_qty_btn input').val()) >= parseInt(that.state.max_qty1)) {
						(0, _jquery2.default)('.plus_btn img').attr('src', __webpack_require__(110));
					}
				});
				(0, _jquery2.default)('.min_qty_btn input').keyup(function (e) {
					if (e.keyCode == 8) {
						(0, _jquery2.default)('.plus_btn img').attr('src', __webpack_require__(46));
					}
				});
	
				var shareUrl = this.state.shareUrl;
				var title = "Hey! Click here " + shareUrl + " to check " + this.state.pro_details.title + " deal from AquaDeals.";
				var description = shareUrl;
				var swipe_product_attributes = this.state.swipe_product_attributes.map(function (product, index) {
					return _react2.default.createElement(Details, { key: product.c_id, data: product });
				});
				var views_cnt = this.state.offer.dealviews_count >= 1 ? _react2.default.createElement(
					'span',
					null,
					_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/pro_views_icon.png', role: 'presentation', width: '20px' }),
					' ',
					this.state.offer.dealviews_count
				) : '';
				var rec_cnt = this.state.offer.recommended >= 1 ? _react2.default.createElement(
					'span',
					{ className: 'recommended_img' },
					_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/like_icon.png', width: '17px', role: 'presentation' }),
					' ',
					this.state.offer.recommended
				) : '';
	
				var rating = _react2.default.createElement(_reactStars2.default, {
					count: 5,
					className: 'webRate_blk_item',
					size: 17,
					value: this.state.rating >= 0 ? this.state.rating : 0,
					edit: false,
					color1: '#ccc',
					color2: '#ffc50a' });
	
				var getcoupons = '';
				if (this.state.coupons.length > 0) {
					getcoupons = "coupons";
					var descriptionTop = _react2.default.createElement(
						_reactBootstrap.Popover,
						{ id: 'popover-positioned-top' },
						this.state.coupon_first.description
					);
					var couponsList = _react2.default.createElement(
						_reactBootstrap.Popover,
						{ id: 'popover-positioned-top1' },
						this.state.cpns_list.replace(/,\s*$/, "")
					);
					if (this.state.coupons.length === 1) {
						getcoupons = _react2.default.createElement(
							'div',
							{ className: 'row', style: { paddingTop: '10px', paddingBottom: '10px' } },
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'mob_new_coupon_blk' },
									_react2.default.createElement(
										'i',
										{ className: 'coupon_left_img' },
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_left.png', role: 'presentation' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'coupon_text' },
										this.state.coupon_first.coupon_code
									),
									_react2.default.createElement(
										_reactBootstrap.OverlayTrigger,
										{ trigger: 'focus', placement: 'top', overlay: descriptionTop },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ className: 'coupon_info_img' },
											_react2.default.createElement('img', { role: 'presentation', src: baseAssets + 'icons/web_icons/coupon_info.png' })
										)
									)
								)
							)
						);
					} else {
						getcoupons = _react2.default.createElement(
							'div',
							{ className: 'row', style: { paddingTop: '10px', paddingBottom: '10px' } },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-6 col-xs-6 col-sm-6 col-md-offset' },
								_react2.default.createElement(
									'div',
									{ className: 'mob_new_coupon_blk' },
									_react2.default.createElement(
										'i',
										{ className: 'coupon_left_img' },
										_react2.default.createElement('img', { alt: ' ', src: baseAssets + 'icons/web_icons/coupon_left.png' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'coupon_text' },
										this.state.coupon_first.coupon_code
									),
									_react2.default.createElement(
										_reactBootstrap.OverlayTrigger,
										{ trigger: 'focus', placement: 'top', overlay: descriptionTop },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ className: 'coupon_info_img' },
											_react2.default.createElement('img', { alt: ' ', src: baseAssets + 'icons/web_icons/coupon_info.png' })
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-6 col-xs-6 col-sm-6' },
								_react2.default.createElement(
									_reactBootstrap.OverlayTrigger,
									{ trigger: 'focus', placement: 'top', overlay: couponsList },
									_react2.default.createElement(
										_reactBootstrap.Button,
										{ className: 'applied_coupons' },
										'Applied coupons'
									)
								)
							)
						);
					}
				} else {
					getcoupons = '';
				}
				var params = {
					paginationClickable: true,
					spaceBetween: 10,
					slidesPerView: 5
				};
				var deals_params = {
					paginationClickable: true,
					spaceBetween: 10,
					slidesPerView: 5,
					// autoplay:3000,
					autoplayDisableOnInteraction: false,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				};
				var z = this.state.swipe_attributes_titles.map(function (name, index) {
					var _this3 = this;
	
					return _react2.default.createElement(
						'div',
						{ className: this.state.swipe_attr_status === name.cid ? "swipe_attr_title_blk web_swipe_title_active" : "swipe_attr_title_blk" },
						_react2.default.createElement(
							'div',
							{ className: this.state.swipe_attr_status === name.cid ? "web_detail_head_active" : "web_detail_head" },
							_react2.default.createElement(
								'a',
								{ className: 'product_att_titles', onClick: function onClick() {
										return _this3.getswipeDescription(_this3.props.params.Pid, name.cid);
									} },
								name.title
							)
						)
					);
				}.bind(this));
				(0, _jquery2.default)('#req_quantity').keyup(function () {
					(0, _jquery2.default)('#req_quantity_err').text('');
				});
				(0, _jquery2.default)('#req_state').keyup(function () {
					(0, _jquery2.default)('#req_state_err').text('');
				});
				(0, _jquery2.default)('#req_city').keyup(function () {
					(0, _jquery2.default)('#req_city_err').text('');
				});
				(0, _jquery2.default)('#req_doorno').keyup(function () {
					(0, _jquery2.default)('#req_doorno_err').text('');
				});
				(0, _jquery2.default)('#req_pincode').keyup(function () {
					(0, _jquery2.default)('#req_pincode_err').text('');
				});
	
				var wishLst_flag = '';
				if (this.state.wishLst_flag === 1) {
					wishLst_flag = _react2.default.createElement(
						'div',
						{ className: 'web_goto_wish_blk' },
						_react2.default.createElement(
							'div',
							{ className: '' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/web/wishlist' },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/wish_list_filled.png', alt: '', width: '26px', style: { "marginRight": '-3px' }, title: 'GO TO WISHLIST' })
								)
							)
						)
					);
				} else {
					wishLst_flag = _react2.default.createElement(
						'div',
						{ className: 'web_addto_wish_blk' },
						_react2.default.createElement(
							'div',
							{ className: '' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ onClick: function onClick() {
										_this4.addToWishlist();
									} },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/wish_list_unfilled.png', alt: '', width: '20px', title: 'ADD TO WISHLIST' })
								)
							)
						)
					);
				}
				// var people_liked=<div>
				// 					<h4 className="dis_offers_h4">People who liked</h4>
				// 					<div>
				// 						<p>Liked by {this.state.brand_likes_count === 1 ? this.state.brand_likes_count +' user' : this.state.brand_likes_count+' users'}</p>
				// 						<div className="web_pro_liked_profile_blk">
				// 							{this.state.brand_like_users.map(function(data,index){
				// 								return(
				// 									<i className="web_pro_liked_profile_icon"><img src={baseAssets+'images/pro_pics/'+data.pro_pic} alt=" " width="50px" /></i>
				// 								)
				// 							}.bind(this))}
				// 							{this.state.brand_like_rem_count > 0 ? <span className="pro_liked_rem_count"><span>+{this.state.brand_like_rem_count}</span></span>: ''}
				// 						</div>
				// 					</div>
				// 				</div>;
	
				var likes_btn = this.state.brand_like_status === '1' ? _react2.default.createElement(
					'div',
					{ onClick: function onClick() {
							_this4.likeBrand(0);
						} },
					_react2.default.createElement(
						'span',
						null,
						_react2.default.createElement('i', { className: "glyph_heart_active glyphicon glyphicon-heart" })
					),
					parseInt(this.state.brand_likes_count, 10) === 1 ? _react2.default.createElement(
						'h6',
						null,
						this.state.brand_likes_count + ' Like'
					) : _react2.default.createElement(
						'h6',
						null,
						this.state.brand_likes_count + ' Likes'
					)
				) : _react2.default.createElement(
					'div',
					{ onClick: function onClick() {
							_this4.likeBrand(1);
						} },
					_react2.default.createElement(
						'span',
						null,
						_react2.default.createElement('i', { className: "glyph_heart glyphicon glyphicon-heart" })
					),
					parseInt(this.state.brand_likes_count, 10) === 1 ? _react2.default.createElement(
						'h6',
						null,
						this.state.brand_likes_count + ' Like'
					) : _react2.default.createElement(
						'h6',
						null,
						this.state.brand_likes_count + ' Likes'
					)
				);
				var ad_assist_data = _react2.default.createElement(
					_reactBootstrap.Popover,
					{ className: 'in', id: 'popover-positioned-top2' },
					_react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: this.state.ad_grnt_str } })
				);
	
				var ad_assist_icon = this.state.ad_guarantee === 1 && this.state.ad_guarantee_icon ? _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{ trigger: 'focus', placement: 'top', overlay: ad_assist_data },
					_react2.default.createElement(
						_reactBootstrap.Button,
						{ className: 'web_ad_guarantee_icon' },
						_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/' + this.state.ad_guarantee_icon, alt: ' ' })
					)
				) : '';
	
				var similar_brand_deals = this.state.similar_brand_deals.map(function (data, index) {
					return _react2.default.createElement(
						'div',
						{ className: 'col-md-3 col-sm-6' },
						_react2.default.createElement(
							'div',
							{ className: data.title === "View More" ? "web_sw_view_more1" : "" },
							_react2.default.createElement(
								'div',
								{ className: 'prdt_blk' },
								data.title === "View More" ? _react2.default.createElement(
									'a',
									{ href: "/web/pdeals/" + data.url_dtype_name + '/' + data.url_cat_name + '/' + this.state.pro_details.category_id + '/Pcategory/' + data.dtype },
									data.promo_ribbion ? _react2.default.createElement(
										'i',
										{ className: 'ribbon_img' },
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + data.promo_ribbion, alt: '' })
									) : '',
									_react2.default.createElement(
										'div',
										null,
										data.image === '' ? '' : _react2.default.createElement(
											'i',
											{ className: 'sim_deal_img' },
											_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/' + data.image, alt: ' ' })
										)
									),
									data.title ? _react2.default.createElement(
										'h3',
										null,
										data.title
									) : _react2.default.createElement(
										'h3',
										null,
										'\xA0'
									),
									data.brand_name ? _react2.default.createElement(
										'h4',
										null,
										data.brand_name
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									),
									data.mrp ? _react2.default.createElement(
										'h4',
										null,
										'MRP \u20B9 ',
										data.mrp
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									)
								) : _react2.default.createElement(
									'a',
									{ href: '/web/pdetails/' + data.url_dtype_name + '/' + data.url_cat_name + '/' + data.url_brand_name + '/' + data.url_product_name + '/' + data.pid + '/' + data.deal_id },
									_react2.default.createElement(
										'div',
										null,
										data.image === '' ? '' : _react2.default.createElement(
											'i',
											{ className: 'sim_deal_img' },
											_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/' + data.image, alt: ' ' })
										)
									),
									data.title ? _react2.default.createElement(
										'h3',
										null,
										data.title
									) : _react2.default.createElement(
										'h3',
										null,
										'\xA0'
									),
									data.brand_name ? _react2.default.createElement(
										'h4',
										null,
										data.brand_name
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									),
									data.mrp ? _react2.default.createElement(
										'h4',
										null,
										'MRP \u20B9 ',
										data.mrp
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									)
								)
							)
						)
					);
				}.bind(this));
	
				var similar_category_deals = this.state.similar_category_deals.map(function (data, index) {
					return _react2.default.createElement(
						'div',
						{ className: 'col-md-3 col-sm-6' },
						_react2.default.createElement(
							'div',
							{ className: data.title === "View More" ? "web_sw_view_more1" : "" },
							_react2.default.createElement(
								'div',
								{ className: 'prdt_blk' },
								data.title === "View More" ? _react2.default.createElement(
									'a',
									{ href: "/web/pdeals/" + data.url_dtype_name + '/' + data.url_cat_name + '/' + this.state.pro_details.category_id + '/Pcategory/' + data.dtype },
									data.promo_ribbion ? _react2.default.createElement(
										'i',
										{ className: 'ribbon_img' },
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + data.promo_ribbion, alt: '' })
									) : '',
									_react2.default.createElement(
										'div',
										null,
										data.image === '' ? '' : _react2.default.createElement(
											'i',
											{ className: 'sim_deal_img' },
											_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/' + data.image, alt: ' ' })
										)
									),
									data.title ? _react2.default.createElement(
										'h3',
										null,
										data.title
									) : _react2.default.createElement(
										'h3',
										null,
										'\xA0'
									),
									data.brand_name ? _react2.default.createElement(
										'h4',
										null,
										data.brand_name
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									),
									data.mrp ? _react2.default.createElement(
										'h4',
										null,
										'MRP \u20B9 ',
										data.mrp
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									)
								) : _react2.default.createElement(
									'a',
									{ href: '/web/pdetails/' + data.url_dtype_name + '/' + data.url_cat_name + '/' + data.url_brand_name + '/' + data.url_product_name + '/' + data.pid + '/' + data.deal_id },
									_react2.default.createElement(
										'div',
										null,
										data.image === '' ? '' : _react2.default.createElement(
											'i',
											{ className: 'sim_deal_img' },
											_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/' + data.image, alt: ' ' })
										)
									),
									data.title ? _react2.default.createElement(
										'h3',
										null,
										data.title
									) : _react2.default.createElement(
										'h3',
										null,
										'\xA0'
									),
									data.brand_name ? _react2.default.createElement(
										'h4',
										null,
										data.brand_name
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									),
									data.mrp ? _react2.default.createElement(
										'h4',
										null,
										'MRP \u20B9 ',
										data.mrp
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									)
								)
							)
						)
					);
				}.bind(this));
	
				var similar_stage_deals = this.state.similar_stage_deals.map(function (data, index) {
					return _react2.default.createElement(
						'div',
						{ className: 'col-md-3 col-sm-6' },
						_react2.default.createElement(
							'div',
							{ className: data.title === "View More" ? "web_sw_view_more1" : "" },
							_react2.default.createElement(
								'div',
								{ className: 'prdt_blk' },
								data.title === "View More" ? _react2.default.createElement(
									'a',
									{ href: "/web/pdeals/" + data.url_dtype_name + '/' + data.url_cat_name + '/' + this.state.pro_details.category_id + '/Pcategory/' + data.dtype },
									data.promo_ribbion ? _react2.default.createElement(
										'i',
										{ className: 'ribbon_img' },
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + data.promo_ribbion, alt: '' })
									) : '',
									_react2.default.createElement(
										'div',
										null,
										data.image === '' ? '' : _react2.default.createElement(
											'i',
											{ className: 'sim_deal_img' },
											_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/' + data.image, alt: ' ' })
										)
									),
									data.title ? _react2.default.createElement(
										'h3',
										null,
										data.title
									) : _react2.default.createElement(
										'h3',
										null,
										'\xA0'
									),
									data.brand_name ? _react2.default.createElement(
										'h4',
										null,
										data.brand_name
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									),
									data.mrp ? _react2.default.createElement(
										'h4',
										null,
										'MRP \u20B9 ',
										data.mrp
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									)
								) : _react2.default.createElement(
									'a',
									{ href: '/web/pdetails/' + data.url_dtype_name + '/' + data.url_cat_name + '/' + data.url_brand_name + '/' + data.url_product_name + '/' + data.pid + '/' + data.deal_id },
									_react2.default.createElement(
										'div',
										null,
										data.image === '' ? '' : _react2.default.createElement(
											'i',
											{ className: 'sim_deal_img' },
											_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/' + data.image, alt: ' ' })
										)
									),
									data.title ? _react2.default.createElement(
										'h3',
										null,
										data.title
									) : _react2.default.createElement(
										'h3',
										null,
										'\xA0'
									),
									data.brand_name ? _react2.default.createElement(
										'h4',
										null,
										data.brand_name
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									),
									data.mrp ? _react2.default.createElement(
										'h4',
										null,
										'MRP \u20B9 ',
										data.mrp
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									)
								)
							)
						)
					);
				}.bind(this));
	
				return _react2.default.createElement(
					'div',
					{ className: 'web_Deals web_pro_full_details_page', itemScope: 'itemScope', itemType: 'http://schema.org/Product' },
					' ',
					this.state.loading && !this.state.page_error_status ? _react2.default.createElement(
						'div',
						{ className: 'lgt_gry' },
						_react2.default.createElement(_WebHeaderInner2.default, { cart_updated_count: this.state.cart_count }),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'section',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ className: '' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										_reactBootstrap.Breadcrumb,
										{ className: 'pro_ful_dtls_breadcrumb' },
										_react2.default.createElement(
											_reactBootstrap.Breadcrumb.Item,
											{ href: '/web/home' },
											'Home'
										),
										_react2.default.createElement(
											_reactBootstrap.Breadcrumb.Item,
											{ href: '/web/pdeals/' + this.state.brand_name + '/all/' + this.state.dtype },
											this.state.brand_name
										),
										_react2.default.createElement(
											_reactBootstrap.Breadcrumb.Item,
											{ href: '/web/pdeals/' + this.state.brand_name + '/' + this.state.cat_name + '/' + this.state.bread_tid + '/Pcategory/' + this.state.d_type_bread },
											this.state.cat_name
										),
										_react2.default.createElement(
											_reactBootstrap.Breadcrumb.Item,
											{ active: true },
											this.state.pro_details.title,
											' ',
											this.state.pro_details.unit_pack
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row pro_dtls' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-4' },
									wishLst_flag,
									_react2.default.createElement(
										_reactIdSwiper2.default,
										carousel_params,
										product_imgs
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-8' },
									_react2.default.createElement(
										'div',
										{ className: 'pro_info' },
										this.state.pro_details.title ? _react2.default.createElement(
											'h3',
											{ itemProp: 'name' },
											this.state.pro_details.title,
											' ',
											this.state.pro_details.unit_pack
										) : '',
										_react2.default.createElement(
											_reactRouter.Link,
											{ className: 'share_btn', onClick: function onClick() {
													_this4.ShareFunc(_this4.state.deal_did);
												} },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/share_icon.png', alt: 'share', width: '19px' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'web_full_share_panel' },
											_react2.default.createElement(
												_reactBootstrap.Panel,
												{ collapsible: true, expanded: this.state.open },
												_react2.default.createElement(
													FacebookShareButton,
													{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
													_react2.default.createElement(FacebookIcon, { size: 32, round: true })
												),
												_react2.default.createElement(
													TwitterShareButton,
													{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
													_react2.default.createElement(TwitterIcon, { size: 32, round: true })
												),
												_react2.default.createElement(
													GooglePlusShareButton,
													{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
													_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										),
										this.state.pro_details.brand_name ? _react2.default.createElement(
											'h4',
											null,
											_react2.default.createElement(
												'span',
												{ itemProp: 'brand' },
												this.state.pro_details.brand_name
											)
										) : '',
										_react2.default.createElement(
											'div',
											{ className: 'star_view_like' },
											_react2.default.createElement(
												'ul',
												null,
												_react2.default.createElement(
													'li',
													null,
													_react2.default.createElement(
														'span',
														null,
														rating
													),
													'\xA0',
													_react2.default.createElement(
														'span',
														null,
														this.state.rating ? this.state.rating : ''
													)
												),
												views_cnt ? _react2.default.createElement(
													'li',
													null,
													_react2.default.createElement(
														'span',
														null,
														views_cnt
													)
												) : '',
												rec_cnt ? _react2.default.createElement(
													'li',
													null,
													_react2.default.createElement(
														'span',
														null,
														rec_cnt
													)
												) : '',
												_react2.default.createElement(
													'li',
													null,
													_react2.default.createElement(
														'span',
														{ className: 'brand_flag_img' },
														_react2.default.createElement('img', { src: "https://aquadeals.in/admin/assets/icons/" + this.state.pro_details.brand_flag, role: 'presentation' })
													),
													'\xA0'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'ad_gurnted' },
												ad_assist_icon
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'ordr_cnt' },
											this.state.show_order_count_flag === 1 ? _react2.default.createElement(
												'p',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/hot_sale.png', alt: '', width: '16px' }),
												' ',
												this.state.order_msg
											) : _react2.default.createElement(
												'p',
												null,
												'\xA0'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'pric_ofers' },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-6' },
											_react2.default.createElement(
												'div',
												{ className: 'pro_pric_blk' },
												this.state.pro_deal_details.mrp ? _react2.default.createElement(
													'h5',
													{ itemProp: 'offers', itemScope: true, itemType: 'http://schema.org/Offer' },
													_react2.default.createElement('meta', { itemProp: 'priceCurrency', content: 'INR' }),
													'Rs. ',
													_react2.default.createElement('span', null),
													' ',
													_react2.default.createElement(
														'span',
														{ itemProp: 'price' },
														this.state.pro_deal_details.mrp
													)
												) : ''
											),
											_react2.default.createElement(
												'div',
												{ className: 'cupn_blk' },
												this.state.coupons.length > 0 ? _react2.default.createElement(
													'div',
													null,
													_react2.default.createElement(
														'h4',
														{ className: 'web_coupon_h4' },
														'Coupons '
													),
													_react2.default.createElement(
														'div',
														{ className: 'coupons_list' },
														getcoupons
													)
												) : ''
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-6 dscnt_ofrs' },
											_react2.default.createElement(
												'h4',
												null,
												'Discount & Offers'
											),
											_react2.default.createElement(
												'div',
												{ className: 'dscnt_ofrs_blk' },
												_react2.default.createElement(
													'div',
													{ className: 'row web_dis_ofr_blk' },
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-1 web_dis_ofr_lft' },
														this.state.offer_details.aqua_cash_title ? _react2.default.createElement(
															'i',
															{ className: 'bookcsh2' },
															_react2.default.createElement('img', { className: 'newaquacash_icon2', src: baseAssets + 'icons/web_icons/nav_aquacash.png', alt: ' ' })
														) : ''
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-11 web_dis_ofr_rgt' },
														this.state.offer_details.aqua_cash_title ? this.state.offer_details.aqua_cash_title : ''
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-1 web_dis_ofr_lft' },
														this.state.offer_details.full_aquacash_back_title ? _react2.default.createElement(
															'i',
															null,
															_react2.default.createElement('img', { className: 'full_aquacash_back_title2', src: baseAssets + 'icons/web_icons/newcashback.png', alt: ' ' })
														) : ''
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-11 web_dis_ofr_rgt' },
														this.state.offer_details.full_aquacash_back_title ? this.state.offer_details.full_aquacash_back_title : ''
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-1 web_dis_ofr_lft' },
														this.state.offer_details.pur_ern_ofr_desc ? _react2.default.createElement(
															'i',
															null,
															_react2.default.createElement('img', { className: 'newaquacash_icon2', src: baseAssets + 'icons/web_icons/nav_aquacash.png', alt: ' ' })
														) : ''
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-11 web_dis_ofr_rgt' },
														this.state.offer_details.pur_ern_ofr_desc ? this.state.offer_details.pur_ern_ofr_desc : ''
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-1 web_dis_ofr_lft' },
														parseInt(this.state.offer_details.emi_opt_sts) === 1 ? _react2.default.createElement(
															'i',
															null,
															_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/emi.png', alt: ' ', width: '20px' })
														) : ''
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-11 web_dis_ofr_rgt' },
														parseInt(this.state.offer_details.emi_opt_sts) === 1 ? this.state.offer_details.emi_opt_desc : ''
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'qty_delvr row' },
										_react2.default.createElement(
											'div',
											{ className: this.state.free_shipment === 1 ? "col-md-6 col-sm-6" : 'col-md-12' },
											_react2.default.createElement(
												'div',
												{ className: 'qty_blk col-md-12', style: { padding: '0px' } },
												_react2.default.createElement(
													'div',
													null,
													_react2.default.createElement(
														'div',
														{ className: 'col-md-12', style: { padding: '0px' } },
														_react2.default.createElement(
															'ul',
															{ style: { display: 'flex', justifyContent: 'center' } },
															this.state.free_shipment === 1 ? _react2.default.createElement(
																'h5',
																null,
																'Quantity'
															) : _react2.default.createElement(
																'h4',
																null,
																'Quantity'
															),
															this.state.unit_name === "kg" || this.state.unit_name === "gm" ? _react2.default.createElement(
																'ul',
																null,
																_react2.default.createElement(
																	'li',
																	null,
																	_react2.default.createElement(
																		'button',
																		{ className: 'minus_btn', onClick: function onClick() {
																				_this4.decrementMinQty();
																			} },
																		_react2.default.createElement('img', { src: __webpack_require__(45), alt: ' ' })
																	)
																),
																_react2.default.createElement(
																	'li',
																	{ className: 'min_qty_btn' },
																	_react2.default.createElement('input', { type: 'text', placeholder: this.state.min_qty1, value: this.state.min_qty, ref: 'input_minqty', onChange: this.updateMinQty })
																),
																_react2.default.createElement(
																	'li',
																	null,
																	_react2.default.createElement(
																		'button',
																		{ className: 'plus_btn', onClick: function onClick() {
																				_this4.incrementMinQty();
																			} },
																		_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/plus.png', alt: ' ' })
																	)
																),
																_react2.default.createElement(
																	'li',
																	null,
																	_react2.default.createElement(
																		'span',
																		{ className: 'equl_to' },
																		'='
																	)
																),
																_react2.default.createElement(
																	'li',
																	{ className: 'cunt_van' },
																	_react2.default.createElement(
																		'p',
																		null,
																		_react2.default.createElement(
																			'span',
																			{ className: 'web_qty_mainvalue' },
																			this.state.tons
																		),
																		_react2.default.createElement(
																			'span',
																			{ className: 'qty_unitname' },
																			'Tons'
																		)
																	),
																	_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/truck.png', role: 'presentation' })
																)
															) : _react2.default.createElement(
																'ul',
																null,
																_react2.default.createElement(
																	'li',
																	null,
																	_react2.default.createElement(
																		'button',
																		{ className: 'minus_btn', onClick: function onClick() {
																				_this4.decrementMinQty();
																			} },
																		_react2.default.createElement('img', { src: __webpack_require__(45), alt: ' ' })
																	)
																),
																_react2.default.createElement(
																	'li',
																	{ className: 'min_qty_btn' },
																	_react2.default.createElement('input', { type: 'text', placeholder: this.state.min_qty1, value: this.state.min_qty, ref: 'input_minqty', onChange: this.updateMinQty })
																),
																_react2.default.createElement(
																	'li',
																	null,
																	_react2.default.createElement(
																		'button',
																		{ className: 'plus_btn', onClick: function onClick() {
																				_this4.incrementMinQty();
																			} },
																		_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/plus.png', alt: ' ' })
																	)
																)
															)
														)
													)
												)
											),
											this.state.qty_err_status ? _react2.default.createElement(
												'p',
												{ className: 'web_err_quantity' },
												this.state.qty_err_msg
											) : '',
											_react2.default.createElement(
												'div',
												{ className: 'web_prev_order_text' },
												this.state.previous_order === '' ? '' : this.state.previous_order
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-6 col-sm-6' },
											this.state.free_shipment === 1 ? _react2.default.createElement(
												'div',
												null,
												_react2.default.createElement(
													'div',
													{ className: 'delvry_blk' },
													_react2.default.createElement(
														'h4',
														null,
														'Delivery'
													),
													this.state.free_shipment === 1 ? _react2.default.createElement(
														'div',
														{ className: 'pin_blk' },
														_react2.default.createElement('input', { type: 'text', name: 'pin code', placeholder: 'Enter pincode', value: this.state.user_zipcode === '0' ? '' : this.state.user_zipcode, maxLength: 6, ref: 'pincode', onChange: function onChange() {
																_this4.pincodeChange();
															} }),
														_react2.default.createElement(
															'button',
															{ onClick: function onClick() {
																	_this4.checkPincode();
																} },
															'CHECK'
														)
													) : ''
												),
												this.state.err_pincode ? _react2.default.createElement(
													'p',
													{ className: 'error' },
													this.state.err_pincode_msg
												) : '',
												this.state.free_ship_msg ? _react2.default.createElement(
													'p',
													{ className: this.state.err_pincode ? 'hide' : "free_ship_msg" },
													this.state.free_ship_msg
												) : ''
											) : ''
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-md-10 col-md-offset-1 price_cart_btns' },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-6 col-sm-6' },
											_react2.default.createElement(
												'button',
												{ className: 'best_price_btn', onClick: function onClick() {
														_this4.addQCart(_this4.state.deal_did);
													} },
												_react2.default.createElement(
													'i',
													null,
													_react2.default.createElement('img', { src: baseAssets + "images/web_imgs/quick_buy.png", role: 'presentation' })
												),
												_react2.default.createElement(
													'span',
													null,
													'Quick Buy'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: this.state.rotateClass ? "col-md-6 col-sm-6 web_rotate_true" : "col-md-6 col-sm-6 web_rotate_false" },
											_react2.default.createElement(
												'button',
												{ className: 'add_cart_btn', onClick: function onClick() {
														_this4.placeOrderModal();
													} },
												_react2.default.createElement(
													'span',
													null,
													this.state.addtocart_msg
												)
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									{ className: 'abt_brnd' },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-6 col-sm-6 rgt_brdr' },
										_react2.default.createElement(
											'div',
											{ className: 'brnd_dtls' },
											_react2.default.createElement(
												'div',
												{ className: 'brnd_dtls_lft' },
												_react2.default.createElement(
													_reactRouter.Link,
													{ className: 'web_pro_abt_link', to: this.state.pro_details ? '/web/' + this.state.pro_details.url_brand_name + '/brand-details/' + this.state.offer.bid : '#' },
													_react2.default.createElement('img', { className: 'media-object', src: this.state.pro_details ? baseAssets + 'images/brand_icons/' + this.state.pro_details.brand_logo : '', alt: ' ', width: "100px" })
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'brnd_dtls_rgt' },
												_react2.default.createElement(
													_reactRouter.Link,
													{ className: 'web_pro_abt_link', to: '/web/' + this.state.pro_details.url_brand_name + '/brand-details/' + this.state.offer.bid },
													this.state.pro_details.brand_name ? _react2.default.createElement(
														'h4',
														null,
														this.state.pro_details.brand_name
													) : _react2.default.createElement(
														'h4',
														null,
														'\xA0'
													),
													this.state.brand_desc ? _react2.default.createElement(
														'h5',
														{ className: 'brand_desc' },
														this.state.brand_desc
													) : _react2.default.createElement(
														'h5',
														null,
														'\xA0'
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'brnd_like' },
												likes_btn
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-md-6 col-sm-6' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-sm-6 rgt_brdr' },
												_react2.default.createElement(
													'div',
													{ className: 'ad_icons', onClick: function onClick() {
															return _this4.getAdAssistModal();
														} },
													_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/ad_assist_icon_5.png', role: 'presentation' }),
													_react2.default.createElement(
														'h6',
														null,
														'AD Assist'
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-sm-6' },
												_react2.default.createElement(
													'div',
													{ className: 'ad_icons', onClick: function onClick() {
															_this4.checkBestPrice();
														} },
													_react2.default.createElement('img', { src: baseAssets + "images_web/get_best_price.png", role: 'presentation' }),
													_react2.default.createElement(
														'h6',
														null,
														'Get Best Price'
													)
												)
											)
										)
									)
								),
								this.state.product_tabs_avail ? _react2.default.createElement(
									'div',
									{ className: 'pro_des' },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-12' },
										_react2.default.createElement(
											'h2',
											null,
											'Details'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'pro_des_tb_cnt' },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-12 col-sm-12 col-xs-12', style: { marginTop: '5px' } },
											_react2.default.createElement(
												'div',
												{ className: 'desc_swipeblock' },
												_react2.default.createElement(
													_reactIdSwiper2.default,
													params,
													z
												),
												_react2.default.createElement(
													'div',
													{ className: 'tab-content' },
													this.state.swipe_desc_info ? _react2.default.createElement(
														'div',
														null,
														_react2.default.createElement(
															'div',
															{ className: 'row web_description_blk' },
															this.state.swipe_desc_info ? _react2.default.createElement(
																'section',
																{ className: 'mob_pro_desc' },
																_react2.default.createElement('div', { dangerouslySetInnerHTML: {
																		__html: this.state.swipe_desc_info
																	} })
															) : ''
														)
													) : '',
													swipe_product_attributes.length > 0 ? _react2.default.createElement(
														'div',
														{ className: 'row' },
														_react2.default.createElement(
															'div',
															{ className: 'col-md-12 col-xs-12 col-sm-12 web_description_cntnt' },
															this.state.pro_details.description ? _react2.default.createElement('p', { itemProp: 'description', style: { fontSize: '11px' }, dangerouslySetInnerHTML: { __html: this.state.pro_details.description } }) : '',
															_react2.default.createElement(
																'table',
																null,
																swipe_product_attributes
															)
														)
													) : ''
												)
											)
										)
									)
								) : "",
								_react2.default.createElement(
									'div',
									{ className: 'pro_des similar_tabs' },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-12 ' },
										_react2.default.createElement(
											'h2',
											null,
											'Similar Deals'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'pro_des_tb_cnt' },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-12 websimilar_blk' },
											this.state.brand_sim_flag === 1 ? _react2.default.createElement(
												'div',
												{ className: 'col-md-4 col-sm-4', onClick: function onClick() {
														_this4.getSimilarBrandDeals();
													} },
												_react2.default.createElement(
													'div',
													{ className: this.state.similar_brand_deals_status ? "similar_tab_item  border_active" : "similar_tab_item" },
													_react2.default.createElement(
														'i',
														null,
														_react2.default.createElement('img', { src: __webpack_require__(259), alt: '...', width: '40' })
													),
													' More deals from ',
													this.state.pro_details.brand_name
												)
											) : '',
											this.state.cat_sim_flag === 1 ? _react2.default.createElement(
												'div',
												{ className: 'col-md-4 col-sm-4', onClick: function onClick() {
														_this4.getSimilarCatDeals();
													} },
												_react2.default.createElement(
													'div',
													{ className: this.state.similar_category_deals_status ? "similar_tab_item border_active" : "similar_tab_item" },
													_react2.default.createElement(
														'i',
														null,
														_react2.default.createElement('img', { src: __webpack_require__(260), alt: '...', width: '40' })
													),
													' More deals in ',
													this.state.pro_details.category
												)
											) : '',
											this.state.stage_sim_flag === 1 ? _react2.default.createElement(
												'div',
												{ className: 'col-md-4 col-sm-4', onClick: function onClick() {
														_this4.getSimilarStageDeals();
													} },
												_react2.default.createElement(
													'div',
													{ className: this.state.similar_stage_deals_status ? "similar_tab_item  border_active" : "similar_tab_item" },
													_react2.default.createElement(
														'i',
														null,
														_react2.default.createElement('img', { src: __webpack_require__(261), alt: '...', width: '40' })
													),
													'View Similar Stage'
												)
											) : ''
										),
										_react2.default.createElement(
											'div',
											{ className: 'pro_sld_ctrls lr_chiv' },
											_react2.default.createElement(
												'a',
												{ className: 'left carousel-control pro_sld_lft', onClick: this.goPrev },
												_react2.default.createElement(
													'span',
													{ className: 'pro_sld_arow' },
													_react2.default.createElement('img', { src: baseAssets + 'images_web/left_arrow.png', alt: '' })
												),
												_react2.default.createElement('span', { className: 'sr-only' })
											),
											_react2.default.createElement(
												'a',
												{ className: 'right carousel-control pro_sld_rgt', onClick: this.goNext },
												_react2.default.createElement(
													'span',
													{ className: 'pro_sld_arow' },
													_react2.default.createElement('img', { src: baseAssets + 'images_web/right_arrow.png', alt: '' })
												),
												_react2.default.createElement('span', { className: 'sr-only' })
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'total_similars' },
										_react2.default.createElement(
											'div',
											{ className: 'container' },
											_react2.default.createElement(
												'div',
												{ className: 'row' },
												this.state.similar_brand_deals_status ? _react2.default.createElement(
													'div',
													{ className: 'Similar_Deals_Blk' },
													_react2.default.createElement(
														_reactIdSwiper2.default,
														_extends({}, deals_params, { key: similar_brand_deals.length, ref: function ref(node) {
																return node ? _this4.swiper = node.swiper : '';
															} }),
														similar_brand_deals
													)
												) : '',
												this.state.similar_category_deals_status ? _react2.default.createElement(
													'div',
													{ className: 'Similar_Deals_Blk' },
													_react2.default.createElement(
														_reactIdSwiper2.default,
														_extends({}, deals_params, { key: similar_category_deals.length, ref: function ref(node) {
																return node ? _this4.swiper = node.swiper : '';
															} }),
														similar_category_deals
													)
												) : '',
												this.state.similar_stage_deals_status ? _react2.default.createElement(
													'div',
													{ className: 'Similar_Deals_Blk' },
													_react2.default.createElement(
														_reactIdSwiper2.default,
														_extends({}, deals_params, { key: similar_stage_deals.length, ref: function ref(node) {
																return node ? _this4.swiper = node.swiper : '';
															} }),
														similar_stage_deals
													)
												) : ''
											)
										)
									)
								),
								this.state.disclaimer_flag ? _react2.default.createElement(
									'section',
									null,
									_react2.default.createElement(
										'span',
										{ id: 'disclaimer_toggle_txt' },
										_react2.default.createElement(
											'a',
											{ onClick: function onClick() {
													_this4.toggleDisclaimer();
												} },
											this.state.visibility ? "Hide Disclaimer" : "View Disclaimer"
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'view_disclaimer_details' },
										this.state.visibility ? _react2.default.createElement(
											'div',
											{ className: 'disclaimer_txt_container' },
											_react2.default.createElement('span', { id: 'mob_disclaimer_txt', dangerouslySetInnerHTML: { __html: this.state.disclaimer_txt } })
										) : ''
									)
								) : '',
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: 'showModal', show: this.state.showModal, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Header,
										{ closeButton: true },
										_react2.default.createElement(
											_reactBootstrap.Modal.Title,
											{ style: { fontSize: 16 + 'px', color: '#333' } },
											'AquaDeals'
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'h4',
											{ style: { fontSize: 14 + 'px', color: '#666' } },
											'You need to install Android mobile app to place order.'
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Footer,
										{ className: 'modal_footer' },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ style: { background: '#fff none repeat scroll 0 0', color: '#ff742a', marginRight: '5px' }, onClick: this.close },
											'Close'
										),
										_react2.default.createElement(
											'a',
											{ href: 'https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en', target: '_blank', title: '' },
											_react2.default.createElement(
												_reactBootstrap.Button,
												{ style: { background: '#ff742a none repeat scroll 0 0', color: '#fff' } },
												'OK'
											)
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: 'm_pro_full_dtls_modal', show: this.state.clearcart_status, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Header,
										{ closeButton: true },
										_react2.default.createElement(
											_reactBootstrap.Modal.Title,
											{ style: { fontSize: '16px', color: '#333' } },
											'Alert'
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'h4',
											{ style: { fontSize: '14px', color: '#666' } },
											'You can\'t have multiple seller items in the cart.Empty existing cart & add this item ',
											this.state.pro_details.title,
											'?'
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Footer,
										{ className: 'modal_footer' },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
											'NO'
										),
										_react2.default.createElement(
											'a',
											null,
											_react2.default.createElement(
												_reactBootstrap.Button,
												{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: function onClick() {
														_this4.removeCartItems();
													} },
												'YES'
											)
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: 'mob_reqbestprice', show: this.state.reqbestPrice, onHide: this.close, id: 'ad_best_price_web' },
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'section',
											{ className: 'bst_header_block', style: { textAlign: 'center' } },
											_react2.default.createElement(
												'h4',
												{ className: 'req_title' },
												'REQUEST FOR BEST PRICE'
											),
											_react2.default.createElement(
												'span',
												{ onClick: this.close },
												_react2.default.createElement(_reactWebVectorIcons2.default, {
													name: 'close',
													font: 'SimpleLineIcons',
													color: '#333',
													size: 16,
													style: { position: 'absolute', right: '10px', top: '8px', cursor: 'pointer' }
												})
											),
											_react2.default.createElement('img', { src: __webpack_require__(251), width: '100', alt: '' }),
											_react2.default.createElement(
												'p',
												{ className: 'req_desc' },
												_react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.state.best_price_txt } })
											)
										),
										_react2.default.createElement(
											'form',
											{ className: 'req_best_price_form', onSubmit: this.reqBestPriceSubmit },
											_react2.default.createElement('input', { type: 'text', maxLength: 10, id: 'req_quantity', ref: 'req_quantity', value: this.state.req_quantity, onChange: this.req_quantityChange, placeholder: 'Enter Quantity' }),
											_react2.default.createElement('span', { className: 'req_err', id: 'req_quantity_err' }),
											_react2.default.createElement('input', { type: 'text', ref: 'req_state', id: 'req_state', value: this.state.req_state, onChange: this.req_stateChange, placeholder: 'Enter State' }),
											_react2.default.createElement('span', { className: 'req_err', id: 'req_state_err' }),
											_react2.default.createElement('input', { type: 'text', maxLength: 6, ref: 'req_pincode', id: 'req_pincode', value: this.state.req_pincode, onChange: this.req_pincodeChange, placeholder: 'Pincode' }),
											_react2.default.createElement('span', { className: 'req_err', id: 'req_pincode_err' }),
											_react2.default.createElement(
												'div',
												{ className: 'req_footer' },
												_react2.default.createElement(
													'button',
													{ type: 'submit' },
													'SUBMIT'
												)
											)
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: 'mob_reqbestprice_confm', show: this.state.req_confirm_modal, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										this.state.req_confirm_message,
										_react2.default.createElement(
											'a',
											{ onClick: this.close, className: 'req_conf_ok_btn' },
											'OK'
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: 'ad_asst_modalbox', show: this.state.ad_assist_modal, onHide: this.close, id: 'ad_assist_web' },
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'section',
											{ id: 'assets_cnt_block' },
											_react2.default.createElement(
												'span',
												{ onClick: this.close },
												_react2.default.createElement(_reactWebVectorIcons2.default, {
													name: 'close',
													font: 'SimpleLineIcons',
													color: '#fff',
													size: 16,
													style: { position: 'absolute', right: '10px', top: '8px', cursor: 'pointer' }
												})
											),
											_react2.default.createElement('img', { src: __webpack_require__(106), alt: '' }),
											_react2.default.createElement(
												'p',
												null,
												'Please submit the details, one of our experts will respond shortly.'
											),
											_react2.default.createElement(
												'section',
												{ className: 'ad_prd_blocks' },
												_react2.default.createElement(
													'p',
													null,
													_react2.default.createElement(
														'span',
														{ className: 'orng_clr' },
														'Brand: '
													),
													this.state.pro_details.brand_name ? this.state.pro_details.brand_name : ''
												),
												_react2.default.createElement(
													'p',
													null,
													_react2.default.createElement(
														'span',
														{ className: 'orng_clr' },
														'Product: '
													),
													' ',
													this.state.pro_details.title ? this.state.pro_details.title : ''
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'aqua-txt-block' },
												_react2.default.createElement(
													'select',
													{ id: 'ad-sel-question' },
													this.state.queries.map(function (option) {
														return _react2.default.createElement(
															'option',
															{ key: option.id, value: option.id },
															option.question
														);
													})
												),
												_react2.default.createElement(
													'h6',
													null,
													'Best time to contact:  ',
													this.state.time_err_status ? _react2.default.createElement(
														'span',
														{ style: { color: 'red', fontSize: '10px' } },
														this.state.time_err_msg
													) : ''
												),
												_react2.default.createElement(
													'form',
													{ onSubmit: this.submitAdAssistData },
													_react2.default.createElement(
														'div',
														{ className: 'ad_asst_time_blk' },
														_react2.default.createElement(
															'span',
															{ className: this.state.ad_asst_time === 1 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time", onClick: function onClick() {
																	_this4.setAdTime(1);
																} },
															'9am - 12pm'
														),
														_react2.default.createElement(
															'span',
															{ className: this.state.ad_asst_time === 2 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time", onClick: function onClick() {
																	_this4.setAdTime(2);
																} },
															'12pm - 3pm'
														),
														_react2.default.createElement(
															'span',
															{ className: this.state.ad_asst_time === 3 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time", onClick: function onClick() {
																	_this4.setAdTime(3);
																} },
															'3pm - 5pm'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'ad_asst_submit_blk' },
														_react2.default.createElement(
															'button',
															{ type: 'submit' },
															'SCHEDULE CALL'
														)
													)
												)
											)
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: 'mob_reqbestprice_confm', show: this.state.ad_asst_confirm_modal, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										this.state.ad_asst_confirm_message,
										_react2.default.createElement(
											'a',
											{ onClick: this.close, className: 'req_conf_ok_btn' },
											'OK'
										)
									)
								)
							)
						),
						_react2.default.createElement(_WebFooter2.default, null)
					) : _react2.default.createElement(
						'div',
						null,
						this.state.page_error_status ? _react2.default.createElement(_Web_NotFound2.default, null) : _react2.default.createElement(
							'div',
							{ className: 'loading_sym', style: { width: 100 + '%', textAlign: 'center', marginTop: 20 + '%' } },
							_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/ajax-loader1.gif', alt: 'Loading Deals', role: 'presentation' }),
							' '
						)
					)
				);
			}
		}]);
	
		return Web_ProductFullDetails;
	}(_react.Component);
	
	var Details = function (_Component2) {
		_inherits(Details, _Component2);
	
		function Details() {
			_classCallCheck(this, Details);
	
			return _possibleConstructorReturn(this, (Details.__proto__ || Object.getPrototypeOf(Details)).apply(this, arguments));
		}
	
		_createClass(Details, [{
			key: 'render',
			value: function render() {
				var mydata = this.props.data;
				return _react2.default.createElement(
					'tr',
					null,
					mydata.value !== '--' ? _react2.default.createElement(
						'td',
						null,
						mydata.name
					) : '',
					mydata.value !== '--' ? _react2.default.createElement(
						'td',
						{ className: 'desc_right' },
						mydata.value
					) : ''
				);
			}
		}]);
	
		return Details;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			leads: state.posts.leads,
			formdata: state.auth.formdata,
			formdata_log: state.auth.formdata_log,
			product_tabs: state.posts.product_tabs,
			product_desc: state.posts.product_desc
		};
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Web_ProductFullDetails);

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PDeal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactStars = __webpack_require__(33);
	
	var _reactStars2 = _interopRequireDefault(_reactStars);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _reactInfiniteScrollComponent = __webpack_require__(57);
	
	var _reactInfiniteScrollComponent2 = _interopRequireDefault(_reactInfiniteScrollComponent);
	
	var _reactShare = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	// "/subdeals/:BrandName/:CatName/:ProName/:Pid"
	// "/subdeals/:Pid" 
	// "/subdeals/:BrandName/:CatName/:DType/:ProName/:Pid"
	
	var WebSubDeals = function (_Component) {
	    _inherits(WebSubDeals, _Component);
	
	    function WebSubDeals(props) {
	        _classCallCheck(this, WebSubDeals);
	
	        var _this = _possibleConstructorReturn(this, (WebSubDeals.__proto__ || Object.getPrototypeOf(WebSubDeals)).call(this, props));
	
	        _this.state = {
	            feedsList: [],
	            fulldata: [],
	            feedbrands: [],
	            feed_sub_cat: [],
	            feedcat: [],
	            totdata: '',
	            types: [],
	            tid: _this.props.params.Tid,
	            type: _this.props.params.Type,
	            // dtype: this.props.params.DType,
	            pid: _this.props.params.Pid,
	            data_type: _this.props.params.DType,
	            lod: false,
	            loading: false,
	            loadmore_number: 2,
	            loadmore_status: 0,
	            set_type: '',
	            next_page: '',
	            loading_gif: false,
	            h1_desc: '',
	            sortList: [],
	
	            selected: '',
	            count: ''
	        };
	        // localStorage.setItem('d_type',this.props.params.Dtype);
	        _this.test = _this.test.bind(_this);
	        _this.loadMoreDeals = _this.loadMoreDeals.bind(_this);
	        _this.getDeviceId = _this.getDeviceId.bind(_this);
	        // this.getTypes=this.getTypes.bind(this);
	        // this.getPoductDeals=this.getPoductDeals.bind(this);
	
	        _this.getSelectedCatSort = _this.getSelectedCatSort.bind(_this);
	        _this.fetchData = _this.fetchData.bind(_this);
	        _this.refresh = _this.refresh.bind(_this);
	        return _this;
	    }
	
	    _createClass(WebSubDeals, [{
	        key: 'fetchData',
	        value: function fetchData() {
	            // this.state.next_page, this.state.set_type,this.props.params.Tid,this.props.params.DType
	            var num = this.state.next_page;
	            var sortid = this.state.sortid;
	            if (localStorage.user_id) {
	                var uid = localStorage.getItem('user_id');
	            } else {
	                uid = 0;
	            }
	            var getfunc = "";
	            var data1 = "";
	            var data2 = "";
	            data1 = { from: 'desktop_web', uid: uid, page: num, limit: 20, sort: sortid, pid: this.state.pid };
	            data2 = JSON.stringify(data1);
	            getfunc = "getNewsearch";
	
	            if (this.state.loadmore_status === 1) {
	                this.setState({
	                    loading_gif: true
	                });
	                _jquery2.default.ajax({
	                    method: 'POST',
	                    dataType: 'json',
	                    data: { req: data2 },
	                    url: baseUrl + getfunc,
	                    success: function (data) {
	                        if (data.products) {
	                            if (data.load_more === 1) {
	                                this.setState({
	                                    feedsList: this.state.feedsList.concat(data.products),
	                                    offer: data,
	                                    todata: data,
	                                    loadmore_status: data.load_more,
	                                    set_type: data.set_type,
	                                    next_page: data.next_page,
	                                    loading_gif: false,
	                                    h1_desc: 'Shop best deals on ' + data1.product_name,
	                                    selected: data.product_name,
	                                    count: data.count
	                                });
	                            } else {
	                                this.setState({
	                                    set_type: data.set_type,
	                                    next_page: data.next_page,
	                                    loadmore_status: data.load_more,
	                                    loading_gif: false
	                                });
	                            }
	                        } else {
	                            if (data.load_more === 1) {
	                                this.setState({
	                                    feedsList: this.state.feedsList.concat(data.products),
	                                    set_type: data.set_type,
	                                    next_page: data.next_page,
	                                    loadmore_status: data.load_more,
	                                    loading_gif: false
	                                });
	                            } else {
	                                this.setState({
	                                    set_type: data.set_type,
	                                    next_page: data.next_page,
	                                    loadmore_status: data.load_more,
	                                    loading_gif: false
	                                });
	                            }
	                        }
	                    }.bind(this),
	                    error: function (err) {
	                        this.setState({
	                            loading_gif: false
	                        });
	                    }.bind(this)
	                });
	            }
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            console.log("");
	        }
	    }, {
	        key: 'getDeviceId',
	        value: function getDeviceId() {
	            if (localStorage.user_id) {
	                var user_id = localStorage.user_id;
	            } else {
	                user_id = 0;
	            }
	            var data1 = { from: 'desktop_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'getDeviceId',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function success(data) {},
	                error: function error(err) {}
	            });
	        }
	        // getTypes()
	        // {
	
	        //         var data1={from: 'desktop_web'};
	        //         var data2=JSON.stringify(data1);
	        //         $.ajax({
	        //         method: 'POST',
	        //         url: baseUrl+'getTypes',
	        //         dataType:'json',
	        //         data: {req:data2},
	        //         success: function(data){
	        //         this.setState({
	        //             types:data.types,
	        //         });
	        //         }.bind(this),
	        //         error: function(err){
	        //         console.log("Error"+err);
	        //         }
	        //         })
	        // }
	
	
	    }, {
	        key: 'getSelectedCatSort',
	        value: function getSelectedCatSort(event) {
	
	            var index = event.target.selectedIndex;
	            var optionElement = event.target.childNodes[index];
	            var id = optionElement.getAttribute('id');
	            // var name = event.target.value;
	            this.setState({
	                loading_gif: true,
	                sortid: id
	            });
	            localStorage.setItem('web_cat_sort', id);
	
	            if (localStorage.user_id) {
	                var uid = localStorage.getItem('user_id');
	            } else {
	                uid = 0;
	            }
	
	            var data1 = { from: 'desktop_web', uid: uid, sort: id, pid: this.state.pid };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                url: baseUrl + 'getNewsearch',
	                method: 'POST',
	                dataType: 'JSON',
	                data: { req: data2 },
	                success: function (data) {
	                    if (data.status === 'success') {
	                        if (data.products.length === 0) {
	                            this.setState({ loading_gif: false });
	                        }
	                        this.setState({
	                            feedsList: data.products,
	                            offer: data,
	                            todata: data,
	                            loading: true,
	                            title: data.product_name,
	                            desc: 'The best offers of AquaDeals',
	                            selected: data.product_name,
	                            loadmore_status: data.load_more,
	                            set_type: data.set_type,
	                            next_page: data.next_page,
	                            loading_gif: false,
	                            count: data.count
	                        });
	                    }
	                }.bind(this),
	                error: function error(err) {}
	            });
	        }
	    }, {
	        key: 'test',
	        value: function test(type, tid, page) {
	            this.setState({
	                loading_gif: true
	            });
	            var uid = 0;
	            if (localStorage.user_id) {
	                uid = localStorage.getItem('user_id');
	            } else {
	                uid = 0;
	            }
	            var data1 = { from: 'desktop_web', uid: uid, dtype: this.state.data_type, type: type, tid: tid };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'getProductbycat_brand',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	                    this.setState({
	                        feedsList: data.result,
	                        offer: data,
	                        loading: true,
	                        bread: data.cat_name,
	                        loadmore_status: data.load_more,
	                        set_type: data.set_type,
	                        next_page: data.next_page,
	                        loading_gif: false
	                    });
	                }.bind(this),
	                error: function error(err) {
	                    this.setState({
	                        loading_gif: false
	                    });
	                }
	            });
	        }
	
	        // getPoductDeals(type,tid,dtype){
	
	        //     var data3={from: 'desktop_web',type:type, tid: tid, dtype:dtype};
	        //     var data4=JSON.stringify(data3);
	        //     var get_function = 'getProductbycat_brand'; 
	
	        //     $.ajax({
	        //         method: 'POST',
	        //         url: baseUrl+get_function,
	        //         dataType:'json',
	        //         data: {req:data4},
	        //         success: function(data1){
	        //         if(data1.products){
	        //                 this.setState({
	        //                 feedsList:data1.products,
	        //                 offer: data1,
	        //                 totdata: data1,
	        //                 loading:true,
	        //                 bread:data1.cat_name,
	        //             });
	        //         }else{
	        //             this.setState({
	        //                 feedsList:data1.result,
	        //                 offer: data1,
	        //                 totdata: data1,
	        //                 loading:true,
	        //             });
	        //         }
	
	        //         }.bind(this),
	        //         error: function(err){
	        //         console.log("Error"+err);
	        //         }
	        //     });
	        // }
	
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            localStorage.removeItem('w_r_s_dt');
	            localStorage.removeItem('w_r_e_coupon_dt');
	            localStorage.removeItem('w_r_e_s_dt');
	            localStorage.removeItem('web_mycart');
	            localStorage.removeItem('w_r_enq_seller_page');
	            localStorage.removeItem('w_r_p_dt');
	            localStorage.removeItem('w_r_e_p_dt');
	            localStorage.removeItem('web_ofr_page');
	            localStorage.removeItem('profile');
	            localStorage.removeItem('myaquacash');
	            localStorage.removeItem('web_share_earn');
	            localStorage.removeItem('checkout');
	            localStorage.removeItem('order_details');
	            localStorage.removeItem('myorders');
	            localStorage.removeItem('w_r_p_deals');
	            localStorage.removeItem('seed');
	            localStorage.removeItem('nauplii');
	
	            localStorage.removeItem('shipping');
	            localStorage.removeItem('notifications');
	            localStorage.removeItem('web_quickcart');
	            localStorage.removeItem('view_rating');
	            localStorage.removeItem('w_modal_seed');
	            localStorage.removeItem('w_r_seed_deals');
	            localStorage.removeItem('w_r_e_p_dt');
	            localStorage.removeItem('w_modal_details');
	            localStorage.removeItem('offers');
	            localStorage.removeItem('give_rating');
	            localStorage.removeItem('pprice');
	            localStorage.removeItem('sprice');
	            localStorage.removeItem('seed_id');
	            localStorage.removeItem('h_type');
	            localStorage.removeItem('web_pro_ofr_dtls');
	            localStorage.removeItem('web_wishlist');
	            localStorage.removeItem('web_brand_details');
	
	            localStorage.removeItem('m_r_s_dt');
	            localStorage.removeItem('m_r_e_coupon_dt');
	            localStorage.removeItem('m_r_e_s_dt');
	            localStorage.removeItem('mob_mycart');
	            localStorage.removeItem('m_r_enq_seller_page');
	            localStorage.removeItem('m_r_p_dt');
	            localStorage.removeItem('m_r_e_p_dt');
	            localStorage.removeItem('ofr_page');
	            localStorage.removeItem('pro_ofr_dtls');
	
	            localStorage.removeItem('share_earn');
	            localStorage.removeItem('my_orders');
	            localStorage.removeItem('m_r_p_deals');
	            localStorage.removeItem('mob_quickcart');
	            localStorage.removeItem('partner_deals');
	
	            if (!localStorage.user_id && !localStorage.token) {
	                if (this.props.params.BrandName && this.props.params.CatName && this.props.params.ProName && this.props.params.Pid && !this.props.params.DType) {
	                    localStorage.setItem('subdeals', '/web/subdeals/' + this.props.params.BrandName + '/' + this.props.params.CatName + '/' + this.props.params.ProName + '/' + this.props.params.Pid);
	                } else if (this.props.params.BrandName && this.props.params.CatName && this.props.params.DType && this.props.params.ProName && this.props.params.Pid) {
	                    localStorage.setItem('subdeals', '/web/subdeals/' + this.props.params.BrandName + '/' + this.props.params.CatName + '/' + this.props.params.DType + '/' + this.props.params.ProName + '/' + this.props.params.Pid);
	                }
	            }
	
	            var uid = 0;
	            if (localStorage.user_id) {
	                uid = localStorage.getItem('user_id');
	            } else {
	                uid = 0;
	            }
	            if (screen.width < 800 && this.props.params.BrandName && this.props.params.CatName && this.props.params.DType && this.props.params.ProName && this.props.params.Pid) {
	                window.location.href = "/subdeals/" + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.DType + "/" + this.props.params.ProName + "/" + this.props.params.Pid;
	            }
	            this.getDeviceId();
	            localStorage.removeItem('w_r_p_deals');
	            (0, _jquery2.default)(window).scrollTop(0);
	            // localStorage.setItem('d_type',this.props.params.Dtype);
	
	            var self = this;
	            setTimeout(function () {
	                self.setState({ lod: true });
	            }, 15000);
	            var data1 = { from: 'desktop_web', uid: uid, type: this.state.data_type };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'getbrands_categoires',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	                    this.setState({
	                        fulldata: data,
	                        feedbrands: data.brands,
	                        feedcat: data.categories,
	                        feed_sub_cat: data.categories[0].sub,
	                        dtype: this.props.params.Dtype,
	                        bread: ''
	                    });
	                }.bind(this),
	                error: function error(err) {
	                    // console.log("Error"+err);
	                }
	            });
	            var data3 = { from: 'desktop_web', uid: uid, pid: this.state.pid, limit: 20 };
	            var data4 = JSON.stringify(data3);
	
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'getNewsearch',
	                dataType: 'json',
	                data: { req: data4 },
	                success: function (data1) {
	                    this.setState({
	                        feedsList: data1.products,
	                        offer: data1,
	                        totdata: data1,
	                        loading: true,
	                        loadmore_status: data1.load_more,
	                        set_type: data1.set_type,
	                        next_page: data1.next_page,
	                        h1_desc: 'Shop best deals on ' + data1.product_name,
	
	                        selected: data1.product_name,
	                        count: data1.count
	                    });
	                }.bind(this),
	                error: function error(err) {
	                    // console.log("Error"+err);
	                }
	            });
	        }
	    }, {
	        key: 'loadMoreDeals',
	        value: function loadMoreDeals(num, type, tid, dtype) {
	            this.setState({
	                loading_gif: true
	            });
	            var uid = 0;
	            if (localStorage.user_id) {
	                uid = localStorage.getItem('user_id');
	            } else {
	                uid = 0;
	            }
	            var data1 = { from: 'desktop_web', uid: uid, pid: tid, limit: 20, page: num };
	            var data2 = JSON.stringify(data1);
	            // if(type==="all"){
	            //   // alert(type);
	            //   data1={from :'desktop_web',page:num,type:dtype,limit:20};
	            //   data2=JSON.stringify(data1);
	            //   getfunc="getPoductDeals";
	            // }
	            // if(type==="Pcategory"){
	            //   // alert(type);
	            //   data1={from: 'desktop_web', page:num, dtype:dtype, type:type, tid:tid,limit:20};
	            //   data2=JSON.stringify(data1);
	            //   getfunc="getProductbycat_brand";
	            // }
	            // if(type==="brand"){
	            //   // alert(type);
	            //   data1={from:'desktop_web', page:num,dtype:dtype,type:type,tid:tid,limit:20};
	            //   data2=JSON.stringify(data1);
	            //   getfunc="getProductbycat_brand";
	            // }
	
	            var products = "";
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'getNewsearch',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	
	                    this.setState({
	                        offer: data,
	                        totdata: data,
	                        loading: true,
	                        title: data.product_name,
	                        desc: data.cat_desc,
	                        selected: data.product_name,
	                        loadmore_status: data.load_more,
	                        set_type: data.set_type,
	                        next_page: data.next_page,
	
	                        loading_gif: false,
	                        count: data.count
	                    });
	                    this.setState({
	                        feedsList: this.state.feedsList.concat(data.products)
	                    });
	                }.bind(this),
	                error: function error(err) {
	                    this.setState({
	                        loading_gif: false
	                    });
	                    // console.log(err);
	                }
	            });
	            return products;
	        }
	    }, {
	        key: 'test1',
	        value: function test1(id) {
	            this.setState({
	                loading_gif: true
	            });
	            var data1 = { from: 'desktop_web', type: id };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'getbrands_categoires',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	                    this.setState({
	                        fulldata: data,
	                        feedbrands: data.brands,
	                        feedcat: data.categories,
	                        feed_sub_cat: data.categories[0].sub,
	                        dtype: this.props.params.Dtype,
	                        loading_gif: false
	                    });
	                }.bind(this),
	                error: function error(err) {
	                    // console.log("Error"+err);
	                    this.setState({
	                        loading_gif: false
	                    });
	                }
	            });
	
	            var data3 = { from: 'desktop_web', type: id };
	            var data4 = JSON.stringify(data3);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'getPoductDeals',
	                dataType: 'json',
	                data: { req: data4 },
	                success: function (data1) {
	                    this.setState({
	                        feedsList: data1.result,
	                        offer: data1,
	                        loading: true,
	                        loading_gif: false
	                    });
	                }.bind(this),
	                error: function error(err) {
	                    // console.log("Error"+err);
	                }
	            });
	        }
	    }, {
	        key: 'setFilter',
	        value: function setFilter(filter) {
	            this.setState({ selected: filter });
	        }
	    }, {
	        key: 'isActive',
	        value: function isActive(value) {
	            return 'li ' + (value === this.state.selected ? 'active' : '');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            // document.title =this.state.totdata.product_name + " - Products | AquaDeals | "+"Browse best deals,Aquaculture products from "+this.state.totdata.product_name+" in AquaDeals. Contact customer care for any queries.";
	            document.title = this.state.totdata.product_name ? this.state.totdata.product_name + " - Products | AquaDeals" : 'AquaDeals';
	            document.getElementsByTagName("META")[2].content = "Browse best deals,Aquaculture products from " + this.state.totdata.product_name + " in AquaDeals. Contact customer care for any queries.";
	
	            var sub_cat = '';
	            var brands = this.state.feedbrands.map(function (brand, index) {
	                return _react2.default.createElement(
	                    'li',
	                    { key: brand.id, id: "brand_" + brand.id },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: "/web/pdeals/" + brand.url_dtype_name + "/" + brand.url_name + "/" + brand.id + "/" + brand.type + "/" + brand.dtype },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            brand.category_name
	                        )
	                    )
	                );
	            });
	
	            if (this.state.feed_sub_cat.length > 0) {
	                var cat = this.state.feedcat.map(function (cat, index) {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: cat.id, id: "cat_" + cat.id, className: this.isActive(cat.category_name), onClick: this.setFilter.bind(this, cat.category_name) },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                cat.category_name
	                            )
	                        )
	                    );
	                }.bind(this));
	            } else {
	                cat = this.state.feedcat.map(function (cat, index) {
	                    return _react2.default.createElement(
	                        'li',
	                        { key: cat.id, id: "cat_" + cat.id, className: this.isActive(cat.category_name), onClick: this.setFilter.bind(this, cat.category_name) },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: "/web/pdeals/" + cat.url_dtype_name + "/" + cat.url_name + "/" + cat.id + "/" + cat.type + "/" + cat.dtype },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                cat.category_name
	                            )
	                        )
	                    );
	                }.bind(this));
	            }
	            sub_cat = this.state.feed_sub_cat.map(function (sub_cat, index) {
	                return _react2.default.createElement(
	                    'li',
	                    { key: sub_cat.id, id: "sub_cat_" + sub_cat.id, className: this.isActive(sub_cat.category_name), onClick: this.setFilter.bind(this, sub_cat.category_name) },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { className: 'sub_cat_li', to: "/web/pdeals/" + sub_cat.url_dtype_name + "/" + sub_cat.url_name + "/" + sub_cat.id + "/" + sub_cat.type + "/" + sub_cat.dtype },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            sub_cat.category_name
	                        )
	                    )
	                );
	            }.bind(this));
	
	            // var types= this.state.types.map(function(type,index){
	            //             return(<li key={type.id} className="cat-0-list__item"><Link onClick={()=>{this.test1(type.id)}} to={"/"+type.url+"/"+type.id} className="cat-0-list__item--name">{type.type}</Link></li>);
	            //           }.bind(this))
	
	            var products = '';
	            if (this.state.feedsList.length > 0) {
	                products = this.state.feedsList.map(function (product, index) {
	                    return _react2.default.createElement(PDeal, { key: product.id, data: product });
	                });
	            }
	            //     var products=this.state.feedsList.map(function(product,index){ 
	
	            //       return(
	
	            //             <div>
	            //             {product.pid ?
	            //                 <Link key={product.index} className="col-md-3 col-sm-3 col-xs-3 itm_lst_grd" to={"/web/pdetails/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.pid+"/"+product.deal_id}>
	            //                         <div className="itm_img">
	            //                                 <img className="itm_img" alt="Deals" src={baseAssets+'images/product_imgs/thumbnails/'+product.image}/>
	            //                         </div>
	            //                         <h2>{product.title}</h2>
	            //                         <h5>{product.brand_name}</h5>
	            //                         <h6>{product.quantity}</h6>
	            //                         {product.deal_price > 0 ? <p><span>&#8377;{product.mrp}</span><span>&#8377;{product.deal_price}</span></p> : <p><span>&#8377;{product.mrp}</span></p>}
	            //                         <span className="share_btn"> <img src={baseAssets+'images/web_imgs/share.png'} alt="share" /> </span>
	
	            //                 </Link> :    
	            //         <Link key={product.index} className="col-md-3 col-sm-3 col-xs-3 itm_lst_grd" to={"/web/pdetails/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.pro_id+"/"+product.id}>
	            //                     <div className="itm_img">
	            //                         <img className="itm_img" alt="Deals" src={baseAssets+'images/product_imgs/thumbnails/'+product.image}/>
	            //                     </div>
	            //                     <h2>{product.title}</h2>
	            //                     <h5>{product.brand_name}</h5>
	            //                     <p><span>&#8377;{product.discount_amount}</span></p>
	            //                     <h6><span>{product.quantity}</span></h6>
	            //                     {product.deal_price > 0 ? <p><span>&#8377;{product.mrp}</span><span>&#8377;{product.deal_price}</span></p>: <p><span>&#8377;{product.mrp}</span></p>}
	
	            //         </Link>
	            //     } 
	            //     </div>
	            //   );
	            // })
	            return _react2.default.createElement(
	                'div',
	                { className: 'web_Deals web_subdeals_page' },
	                this.state.loading ? _react2.default.createElement(
	                    'div',
	                    { className: 'lgt_gry' },
	                    _react2.default.createElement(_WebHeaderInner2.default, null),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'h1',
	                        { className: 'page_title' },
	                        this.state.h1_desc ? this.state.h1_desc : ''
	                    ),
	                    _react2.default.createElement(
	                        'section',
	                        { className: 'container pro_lst_cntnt' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'container' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Breadcrumb,
	                                { className: 'webpdeals_breadcrmb' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Breadcrumb.Item,
	                                    { href: '/web/home' },
	                                    'Home'
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Breadcrumb.Item,
	                                    { active: true },
	                                    this.state.selected
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'tot_pro' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row', style: { marginRight: '0 !important' } },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3 col-sm-3' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'filtrs_blk' },
	                                        _react2.default.createElement(
	                                            'h3',
	                                            null,
	                                            'Categories'
	                                        ),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            null,
	                                            cat,
	                                            sub_cat
	                                        ),
	                                        _react2.default.createElement(
	                                            'h3',
	                                            null,
	                                            'Brands'
	                                        ),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: brands.length > 10 ? 'flt_scrl' : 'no_scrl' },
	                                            brands
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'pro_sec col-md-9 col-sm-9' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'pro_sec_hdr' },
	                                        _react2.default.createElement(
	                                            'h3',
	                                            null,
	                                            this.state.selected ? this.state.selected : '',
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                '(',
	                                                this.state.count,
	                                                ' Items)'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'pro_slt_fltr' },
	                                            _react2.default.createElement(
	                                                'select',
	                                                { onChange: this.getSelectedCatSort },
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    null,
	                                                    'Select'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { id: '1' },
	                                                    'Price:High-Low'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { id: '2' },
	                                                    'Price:Low-High'
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row itm_lst' },
	                                        this.state.loading_gif ? _react2.default.createElement(
	                                            'i',
	                                            { className: 'web_loading_gif' },
	                                            _react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
	                                        ) : '',
	                                        _react2.default.createElement(
	                                            _reactInfiniteScrollComponent2.default,
	                                            {
	                                                pullDownToRefresh: true,
	                                                pullDownToRefreshContent: _react2.default.createElement(
	                                                    'h3',
	                                                    { style: { textAlign: 'center' } },
	                                                    '\u2193'
	                                                ),
	                                                releaseToRefreshContent: _react2.default.createElement(
	                                                    'h3',
	                                                    { style: { textAlign: 'center' } },
	                                                    '\u2191'
	                                                ),
	                                                refreshFunction: this.refresh,
	                                                next: this.fetchData,
	                                                hasMore: true,
	                                                scrollThreshold: 0.9,
	                                                loader: _react2.default.createElement('h4', null),
	                                                endMessage: _react2.default.createElement(
	                                                    'p',
	                                                    { style: { textAlign: 'center' } },
	                                                    _react2.default.createElement('b', null)
	                                                ) },
	                                            products
	                                        ),
	                                        products ? '' : _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            this.state.lod ? _react2.default.createElement(
	                                                'div',
	                                                { className: 'seed_no_data' },
	                                                'No Deals Available'
	                                            ) : _react2.default.createElement(
	                                                'div',
	                                                { className: 'loading_sym', style: { width: '100%', textAlign: 'center', marginTop: '10%' } },
	                                                _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/ajax-loader.gif', alt: 'Loading', role: 'presentation' })
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'clr' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(_WebFooter2.default, null)
	                ) : _react2.default.createElement(
	                    'div',
	                    { className: 'loading_sym', style: { width: 100 + '%', textAlign: 'center', marginTop: 20 + '%' } },
	                    _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/ajax-loader1.gif', alt: 'Loading Deals', role: 'presentation' }),
	                    ' '
	                )
	            );
	        }
	    }]);
	
	    return WebSubDeals;
	}(_react.Component);
	
	exports.default = WebSubDeals;
	
	var PDeal = exports.PDeal = function (_Component2) {
	    _inherits(PDeal, _Component2);
	
	    function PDeal() {
	        _classCallCheck(this, PDeal);
	
	        var _this2 = _possibleConstructorReturn(this, (PDeal.__proto__ || Object.getPrototypeOf(PDeal)).call(this));
	
	        _this2.state = {
	            open: false,
	            shareUrl: '',
	            msg: '',
	            showModal: false,
	            showModalLogin: false
	
	        };
	
	        _this2.ShareFunc = _this2.ShareFunc.bind(_this2);
	        _this2.modalOpen = _this2.modalOpen.bind(_this2);
	        _this2.close = _this2.close.bind(_this2);
	        _this2.closeModal = _this2.closeModal.bind(_this2);
	        _this2.openLoginModal = _this2.openLoginModal.bind(_this2);
	        return _this2;
	    }
	
	    _createClass(PDeal, [{
	        key: 'modalOpen',
	        value: function modalOpen() {
	            this.setState({
	                showModal: !this.state.showModal
	            });
	        }
	    }, {
	        key: 'closeModal',
	        value: function closeModal() {
	            this.setState({
	                showModal: !this.state.showModal
	            });
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            this.setState({
	                showModal: false
	            });
	        }
	    }, {
	        key: 'openLoginModal',
	        value: function openLoginModal() {
	            this.setState({
	                showModal: false,
	                showModalLogin: true
	            });
	        }
	    }, {
	        key: 'closeLoginModal',
	        value: function closeLoginModal() {
	            this.setState({
	                showModal: false,
	                showModalLogin: false
	            });
	        }
	    }, {
	        key: 'ShareFunc',
	        value: function ShareFunc(evnt) {
	            var _this3 = this;
	
	            var self = this;
	            setTimeout(function () {
	                self.setState({ open: false });
	            }, 3000);
	            var data1 = { from: 'desktop_web', type: 1, did: evnt };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'createTinyurl',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	                    // console.log(data);
	                    this.setState({
	                        msg: data.msg,
	                        shareUrl: data.tinyurl
	                    });
	                }.bind(this),
	                error: function error(err) {
	                    console.log("Error" + err);
	                }
	            });
	            this.setState({
	                open: !this.state.open
	            });
	            setTimeout(function () {
	                _this3.setState({ open: false });
	            }, 5000);
	        }
	        // <div className="col-md-3 col-sm-3 col-xs-3" style={{height: 300+'px'}}> 
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var product = this.props.data;
	            var shareUrl = this.state.shareUrl;
	            var title = "Hey! Click here " + shareUrl + " to check " + product.title + " deal from AquaDeals.";
	            var description = shareUrl;
	            return _react2.default.createElement(
	                'div',
	                { className: 'col-md-3 col-sm-6' },
	                product.pid ? _react2.default.createElement(
	                    'div',
	                    { className: 'prdt_blk' },
	                    parseInt(product.ad_guarantee_flag, 10) === 1 ? _react2.default.createElement(
	                        'span',
	                        { className: 'web_ad_guarantee' },
	                        _react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: 'presentation' })
	                    ) : '',
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { className: 'lst_share_btn', onClick: function onClick() {
	                                _this4.ShareFunc(product.deal_id);
	                            } },
	                        _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/share.png', alt: 'Share' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { className: 'share_panel', collapsible: true, expanded: this.state.open },
	                        _react2.default.createElement(
	                            FacebookShareButton,
	                            { url: shareUrl, quote: title, className: 'test_share' },
	                            _react2.default.createElement(FacebookIcon, { size: 32, round: true })
	                        ),
	                        _react2.default.createElement(
	                            TwitterShareButton,
	                            { url: shareUrl, quote: title, className: 'test_share' },
	                            _react2.default.createElement(TwitterIcon, { size: 32, round: true })
	                        ),
	                        _react2.default.createElement(
	                            GooglePlusShareButton,
	                            { url: shareUrl, quote: title, description: description, className: 'test_share' },
	                            _react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
	                        )
	                    ),
	                    product.dealcount >= 2 ? _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: "/web/subdeals/" + product.url_dtype_name + "/" + product.url_cat_name + "/" + product.url_brand_name + "/" + product.pid },
	                            product.promo_ribbion ? _react2.default.createElement(
	                                'i',
	                                { className: 'ribbon_img' },
	                                _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + product.promo_ribbion, alt: '' })
	                            ) : '',
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement('img', { alt: ' ', src: baseAssets + 'images/product_imgs/thumbnails/' + product.image })
	                            ),
	                            product.title ? _react2.default.createElement(
	                                'h3',
	                                null,
	                                product.title,
	                                ' ',
	                                product.quantity
	                            ) : _react2.default.createElement(
	                                'h3',
	                                null,
	                                '\xA0'
	                            ),
	                            product.brand_name ? _react2.default.createElement(
	                                'h4',
	                                null,
	                                product.brand_name
	                            ) : _react2.default.createElement(
	                                'h4',
	                                null,
	                                '\xA0'
	                            ),
	                            product.pricediff ? _react2.default.createElement(
	                                'h4',
	                                null,
	                                'AquaCash Discount \u20B9 ',
	                                product.pricediff
	                            ) : ''
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row star_views_blk' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-7 col-xs-7', style: { paddingRight: '0' } },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'prdt_str_rt' },
	                                    _react2.default.createElement(_reactStars2.default, {
	                                        count: 5,
	                                        className: 'webRate_blk_item',
	                                        size: 17,
	                                        value: product.over_rate >= 1 ? product.over_rate : 0,
	                                        edit: false,
	                                        color1: '#ccc',
	                                        color2: '#ffc50a' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-5 col-xs-5', style: { paddingLeft: 0 } },
	                                product.deal_views > 0 ? _react2.default.createElement(
	                                    'span',
	                                    { className: 'prdt_views' },
	                                    _react2.default.createElement(
	                                        'i',
	                                        null,
	                                        _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
	                                    ),
	                                    '\xA0',
	                                    product.deal_views
	                                ) : _react2.default.createElement(
	                                    'span',
	                                    { className: 'prdt_views hide_views' },
	                                    _react2.default.createElement(
	                                        'i',
	                                        null,
	                                        _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
	                                    ),
	                                    ' 0'
	                                )
	                            )
	                        )
	                    ) : _react2.default.createElement(
	                        'div',
	                        null,
	                        parseInt(product.ad_guarantee_flag, 10) === 1 ? _react2.default.createElement(
	                            'span',
	                            { className: 'web_ad_guarantee' },
	                            _react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: 'presentation' })
	                        ) : '',
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { key: product.pid, to: "/web/pdetails/" + product.url_dtype_name + "/" + product.url_cat_name + "/" + product.url_brand_name + "/" + product.url_product_name + "/" + product.pid + "/" + product.deal_id },
	                            product.promo_ribbion ? _react2.default.createElement(
	                                'i',
	                                { className: 'ribbon_img' },
	                                _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + product.promo_ribbion, alt: '' })
	                            ) : '',
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement('img', { alt: ' ', src: baseAssets + 'images/product_imgs/thumbnails/' + product.image })
	                            ),
	                            product.title ? _react2.default.createElement(
	                                'h3',
	                                null,
	                                product.title,
	                                ' ',
	                                product.quantity
	                            ) : _react2.default.createElement(
	                                'h3',
	                                null,
	                                '\xA0'
	                            ),
	                            product.brand_name ? _react2.default.createElement(
	                                'h4',
	                                null,
	                                product.brand_name
	                            ) : _react2.default.createElement(
	                                'h4',
	                                null,
	                                '\xA0'
	                            ),
	                            product.pricediff ? _react2.default.createElement(
	                                'h4',
	                                null,
	                                'AquaCash Discount \u20B9 ',
	                                product.pricediff
	                            ) : ''
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row star_views_blk' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-7 col-xs-7', style: { paddingRight: '0' } },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'prdt_str_rt' },
	                                    _react2.default.createElement(_reactStars2.default, {
	                                        count: 5,
	                                        className: 'webRate_blk_item',
	                                        size: 17,
	                                        value: product.over_rate >= 1 ? product.over_rate : 0,
	                                        edit: false,
	                                        color1: '#ccc',
	                                        color2: '#ffc50a' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-5 col-xs-5', style: { paddingLeft: 0 } },
	                                product.deal_views > 0 ? _react2.default.createElement(
	                                    'span',
	                                    { className: 'prdt_views' },
	                                    _react2.default.createElement(
	                                        'i',
	                                        null,
	                                        _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
	                                    ),
	                                    '\xA0',
	                                    product.deal_views
	                                ) : _react2.default.createElement(
	                                    'span',
	                                    { className: 'prdt_views hide_views' },
	                                    _react2.default.createElement(
	                                        'i',
	                                        null,
	                                        _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
	                                    ),
	                                    ' 0'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement('div', { className: 'clr' })
	                    )
	                ) : _react2.default.createElement(
	                    'div',
	                    { className: 'prdt_blk' },
	                    parseInt(product.ad_guarantee_flag, 10) === 1 ? _react2.default.createElement(
	                        'span',
	                        { className: 'web_ad_guarantee' },
	                        _react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: 'presentation' })
	                    ) : '',
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { className: 'lst_share_btn', onClick: function onClick() {
	                                _this4.ShareFunc(product.id);
	                            } },
	                        _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/share.png', alt: 'Share' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { className: 'share_panel', collapsible: true, expanded: this.state.open },
	                        _react2.default.createElement(
	                            FacebookShareButton,
	                            { url: shareUrl, quote: title, className: 'test_share' },
	                            _react2.default.createElement(FacebookIcon, { size: 32, round: true })
	                        ),
	                        _react2.default.createElement(
	                            TwitterShareButton,
	                            { url: shareUrl, quote: title, className: 'test_share' },
	                            _react2.default.createElement(TwitterIcon, { size: 32, round: true })
	                        ),
	                        _react2.default.createElement(
	                            GooglePlusShareButton,
	                            { url: shareUrl, quote: title, className: 'test_share' },
	                            _react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { key: product.id, to: "/web/pdetails/" + product.url_dtype_name + "/" + product.url_cat_name + "/" + product.url_brand_name + "/" + product.url_product_name + "/" + product.pro_id + "/" + product.id },
	                        product.promo_ribbion ? _react2.default.createElement(
	                            'i',
	                            { className: 'ribbon_img' },
	                            _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + product.promo_ribbion, alt: '' })
	                        ) : '',
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement('img', { alt: ' ', src: baseAssets + 'images/product_imgs/thumbnails/' + product.image })
	                        ),
	                        product.title ? _react2.default.createElement(
	                            'h3',
	                            null,
	                            product.title,
	                            ' ',
	                            product.quantity
	                        ) : _react2.default.createElement(
	                            'h3',
	                            null,
	                            '\xA0'
	                        ),
	                        product.brand_name ? _react2.default.createElement(
	                            'h4',
	                            null,
	                            product.brand_name
	                        ) : _react2.default.createElement(
	                            'h4',
	                            null,
	                            '\xA0'
	                        ),
	                        product.pricediff ? _react2.default.createElement(
	                            'h4',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'AquaCash Discount'
	                            ),
	                            '\xA0',
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '\u20B9',
	                                product.pricediff
	                            )
	                        ) : '',
	                        product.pricediff === "" || product.pricediff === 0 ? _react2.default.createElement(
	                            'h4',
	                            null,
	                            'MRP \u20B9 ',
	                            product.mrp
	                        ) : ''
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row star_views_blk' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-7 col-xs-7', style: { paddingRight: '0' } },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'prdt_str_rt' },
	                                _react2.default.createElement(_reactStars2.default, {
	                                    count: 5,
	                                    className: 'webRate_blk_item',
	                                    size: 17,
	                                    value: product.over_rate >= 1 ? product.over_rate : 0,
	                                    edit: false,
	                                    color1: '#ccc',
	                                    color2: '#ffc50a' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-5 col-xs-5', style: { paddingLeft: 0 } },
	                            product.deal_views > 0 ? _react2.default.createElement(
	                                'span',
	                                { className: 'prdt_views' },
	                                _react2.default.createElement(
	                                    'i',
	                                    null,
	                                    _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
	                                ),
	                                '\xA0',
	                                product.deal_views
	                            ) : _react2.default.createElement(
	                                'span',
	                                { className: 'prdt_views hide_views' },
	                                _react2.default.createElement(
	                                    'i',
	                                    null,
	                                    _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' }),
	                                    ' 0'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PDeal;
	}(_react.Component);

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _AboutHeader = __webpack_require__(218);
	
	var _AboutHeader2 = _interopRequireDefault(_AboutHeader);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Web_IndexHome = function (_Component) {
		_inherits(Web_IndexHome, _Component);
	
		function Web_IndexHome(props) {
			_classCallCheck(this, Web_IndexHome);
	
			var _this = _possibleConstructorReturn(this, (Web_IndexHome.__proto__ || Object.getPrototypeOf(Web_IndexHome)).call(this, props));
	
			_this.getDeviceId = _this.getDeviceId.bind(_this);
	
			return _this;
		}
	
		_createClass(Web_IndexHome, [{
			key: 'getDeviceId',
			value: function getDeviceId() {
				if (localStorage.user_id) {
					var user_id = localStorage.user_id;
				} else {
					user_id = 0;
				}
	
				var data1 = { from: 'desktop_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getDeviceId',
					dataType: 'json',
					data: { req: data2 },
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width < 800) {
					window.location.href = "/aboutus";
				}
				this.getDeviceId();
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = "AquaDeals - Online AquaCulture MarketPlace, Find best deals on Seed, Feed, Health Care, Machinery & Farm Equipments, Products, Ropes & Nets Paddle Wheels and More | AquaDeals";
				document.getElementsByTagName("META")[2].content = "It is a place for deals related to Aqua culture";
				var red_url = '';
				if (screen.width < 800) {
					window.location.href = "/aboutus";
				}
				red_url = "/web/home";
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_aboutus_page' },
					_react2.default.createElement(_AboutHeader2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'indx_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container tp_block' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-5 col-md-offset-1 col-sm-6' },
									_react2.default.createElement(
										'h2',
										null,
										'Welcome to Aquadeals'
									),
									_react2.default.createElement(
										'p',
										null,
										'For fast and safe orders of Seed, Feed, Health Care, Machinery & Farm Equipment experience the AquaDeals app on your Android phone and order on the GO! We are sure you will find the best deals every time. Invite your Contacts and get AquaCash. Refer your friends to download the AquaDeals app, sign up using your referral code and earn Rs. 2000 AquaCash. Your friend gets Rs. 2000 AquaCash. And there\u2019s more.'
									),
									_react2.default.createElement(
										'ul',
										{ className: 'top_btns_blk' },
										_react2.default.createElement(
											'li',
											null,
											_react2.default.createElement(
												'a',
												{ href: red_url, className: 'top_btns' },
												'Explore AquaDeals'
											)
										),
										_react2.default.createElement(
											'li',
											null,
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "/web/enquire_now/partner/support/sid/did", className: 'top_btns' },
												'Join as Partner'
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-sm-6' },
									_react2.default.createElement(
										'div',
										{ className: 'top_rgt_mble' },
										_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/mobile.png', alt: 'Aqua' })
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'features_blk' },
						_react2.default.createElement('div', { className: 'topright' }),
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ className: 'features_cntnt' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-8' },
										_react2.default.createElement(
											'div',
											{ className: 'row features_blk_cntnt' },
											_react2.default.createElement(
												'div',
												{ className: 'col-md-5' },
												_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/deals.png', alt: '' }),
												_react2.default.createElement(
													'h4',
													null,
													'D',
													_react2.default.createElement(
														'span',
														null,
														'eal'
													),
													's'
												),
												_react2.default.createElement(
													'p',
													null,
													'Search several deals on Seed, Feed, Machinery etc right from your mobile.'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-5' },
												_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/bookings.png', alt: '' }),
												_react2.default.createElement(
													'h4',
													null,
													'Bo',
													_react2.default.createElement(
														'span',
														null,
														'okin'
													),
													'gs'
												),
												_react2.default.createElement(
													'p',
													null,
													'Save finding, meeting and negotiating time. Now, find & book your deal in 3 simple steps wherever you are'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'row features_blk_cntnt' },
											_react2.default.createElement(
												'div',
												{ className: 'col-md-5' },
												_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/offers.png', alt: '' }),
												_react2.default.createElement(
													'h4',
													null,
													'Spec',
													_react2.default.createElement(
														'span',
														null,
														'ial Off'
													),
													'ers'
												),
												_react2.default.createElement(
													'p',
													null,
													'Celebrate the best of offers that you can ever get for your aqua business. Profit, Share, WalletUp!'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-5' },
												_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/refer.png', alt: '' }),
												_react2.default.createElement(
													'h4',
													null,
													'Ref',
													_react2.default.createElement(
														'span',
														null,
														'er & Ea'
													),
													'rn'
												),
												_react2.default.createElement(
													'p',
													null,
													'Fill your wallet with the magical AquaCash by just sharing with your friends across the world on how you got better business with AD. Bestow Smiles!'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-md-4' },
										_react2.default.createElement(
											'h2',
											null,
											'Feat',
											_react2.default.createElement(
												'span',
												null,
												'ures'
											)
										),
										_react2.default.createElement(
											'h6',
											null,
											'For fast and safe orders of Seed, Feed, Health Care, Machinery & Farm Equipment experience the AquaDeals app on your Android phone and order on the GO! We are sure you will find the best deals every time. Invite your Contacts and get AquaCash.'
										)
									)
								)
							)
						),
						_react2.default.createElement('div', { className: 'bottomleft' })
					),
					_react2.default.createElement(
						'section',
						{ className: 'aquacash_blk' },
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-7' },
									_react2.default.createElement(
										'div',
										{ className: 'aquacash_mble' },
										_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/aquacash.png', alt: '' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-4' },
									_react2.default.createElement(
										'h4',
										null,
										'AquaCash'
									),
									_react2.default.createElement(
										'p',
										null,
										'We respect your time and so reveal you from the fuss of banking everytime. Virtual money makes your life easy!'
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						' ',
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						' ',
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'status_blk' },
						_react2.default.createElement('div', { className: 'topright' }),
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								'ul',
								{ className: 'status_div' },
								_react2.default.createElement(
									'li',
									{ className: 'col-md-4 col-sm-4 col-xs-4' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/users.png', alt: '' }),
									_react2.default.createElement(
										'h4',
										null,
										'20,000+'
									),
									_react2.default.createElement(
										'p',
										null,
										'Users'
									)
								),
								_react2.default.createElement(
									'li',
									{ className: 'col-md-4 col-sm-4 col-xs-4' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/partners.png', alt: '' }),
									_react2.default.createElement(
										'h4',
										null,
										'210'
									),
									_react2.default.createElement(
										'p',
										null,
										'Partners'
									)
								),
								_react2.default.createElement(
									'li',
									{ className: 'col-md-4 col-sm-4 col-xs-4' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/hatchery.png', alt: '' }),
									_react2.default.createElement(
										'h4',
										null,
										'463'
									),
									_react2.default.createElement(
										'p',
										null,
										'Hatcheries'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'brands_blk thumbnail' },
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ id: 'carousel-example-generic', className: 'carousel slide', 'data-ride': 'carousel' },
								_react2.default.createElement(
									'div',
									{ className: 'carousel-inner', role: 'listbox' },
									_react2.default.createElement(
										'div',
										{ className: 'item active' },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_1.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_2.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_3.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_4.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3 hidden-sm hidden-xs' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_5.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3 hidden-sm hidden-xs' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_6.jpg', alt: '...' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'item' },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_7.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_8.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_9.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_10.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3 hidden-sm hidden-xs' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_1.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3 hidden-sm hidden-xs' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_2.jpg', alt: '...' })
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_IndexHome;
	}(_react.Component);
	
	exports.default = Web_IndexHome;

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import {Link} from 'react-router';
	
	
	var Web_My_Order_aborted = function (_Component) {
		_inherits(Web_My_Order_aborted, _Component);
	
		function Web_My_Order_aborted(props) {
			_classCallCheck(this, Web_My_Order_aborted);
	
			var _this = _possibleConstructorReturn(this, (Web_My_Order_aborted.__proto__ || Object.getPrototypeOf(Web_My_Order_aborted)).call(this, props));
	
			_this.state = {
				status_title: 'Something went wrong'
			};
			return _this;
		}
	
		_createClass(Web_My_Order_aborted, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width < 800) {
					window.location.href = "/order_status/" + this.props.params.Type;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var status_title = 'Something went wrong';
				if (localStorage.pay_page) {
					var pay_page = localStorage.getItem('pay_page');
				} else {
					pay_page = '/web/home';
				}
				if (this.props.params.Type === 'aborted') {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Transaction Aborted'
						),
						_react2.default.createElement(
							'a',
							{ href: pay_page },
							'Try Again'
						)
					);
				} else if (this.props.params.Type === 'failure') {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Transaction Failed'
						),
						_react2.default.createElement(
							'a',
							{ href: pay_page },
							'Try Again'
						)
					);
				} else if (this.props.params.Type === 'invalid') {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Invalid Transaction'
						),
						_react2.default.createElement(
							'a',
							{ href: pay_page },
							'Try Again'
						)
					);
				} else if (this.props.params.Type === 'serverDown') {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Server Down'
						),
						_react2.default.createElement(
							'a',
							{ href: pay_page },
							'Try Again'
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_order_aborted_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-6 col-md-offset-3 web_dels_cntnt' },
								_react2.default.createElement(
									'div',
									{ className: 'web_abort_content' },
									status_title ? status_title : _react2.default.createElement(
										'h4',
										null,
										'Something went wrong'
									)
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_My_Order_aborted;
	}(_react.Component);
	
	exports.default = Web_My_Order_aborted;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactStars = __webpack_require__(33);
	
	var _reactStars2 = _interopRequireDefault(_reactStars);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _custom_functions = __webpack_require__(83);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import StarRating from 'react-bootstrap-star-rating';
	
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets//';
	
	var Web_My_Orders = function (_Component) {
		_inherits(Web_My_Orders, _Component);
	
		function Web_My_Orders(props) {
			_classCallCheck(this, Web_My_Orders);
	
			var _this = _possibleConstructorReturn(this, (Web_My_Orders.__proto__ || Object.getPrototypeOf(Web_My_Orders)).call(this, props));
	
			_this.state = {
				cart_count: 0,
				activeTab: 1,
				bookings: [],
				cancel_bookings: [],
				bookings_count: '',
				cancel_count: 0,
				orders_list_status: false,
				book_type: '',
				// payment variables starts here
				pre_payment_id: '',
				order_id: '',
				paid_amt: '',
				username: '',
				address: '',
				city: '',
				state: '',
				pincode: '',
				mobile: '',
				email: '',
				cancel_modal_status: false,
				cancel_reasons: [],
				edit_input_status: false,
				edit_input: '',
				bid: '',
				booking_type: '',
				selected_reason: '',
	
				cancel_success_status: false,
				cancel_success_msg: '',
				pageId: '.web_myorders_page'
			};
			_this.getCartCount = _this.getCartCount.bind(_this);
			_this.handleTabsSelect = _this.handleTabsSelect.bind(_this);
			_this.getOrdersList = _this.getOrdersList.bind(_this);
			_this.repeatOrder = _this.repeatOrder.bind(_this);
			_this.getBookingsFilterbyType = _this.getBookingsFilterbyType.bind(_this);
			_this.getBookingsFilterbyStatus = _this.getBookingsFilterbyStatus.bind(_this);
			_this.payNow = _this.payNow.bind(_this);
			_this.ccAvenue = _this.ccAvenue.bind(_this);
			_this.getCancelDetails = _this.getCancelDetails.bind(_this);
			_this.handleCancel_Submit = _this.handleCancel_Submit.bind(_this);
			_this.openCancelModal = _this.openCancelModal.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.selectedReason = _this.selectedReason.bind(_this);
			_this.update_other_reason = _this.update_other_reason.bind(_this);
	
			_this.ratingChanged = _this.ratingChanged.bind(_this);
			_this.openRatingsPage = _this.openRatingsPage.bind(_this);
	
			_this.getCancelBookingsFilter = _this.getCancelBookingsFilter.bind(_this);
			return _this;
		}
	
		_createClass(Web_My_Orders, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.props.get_rzp_keys("desktop_web");
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
				localStorage.removeItem('checkout');
				localStorage.removeItem('order_details');
	
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
				localStorage.removeItem('web_quickcart');
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
				localStorage.removeItem('web_brand_details');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
	
				localStorage.removeItem('type');
				localStorage.removeItem('web_cat_sort');
				localStorage.removeItem('d_type');
				localStorage.removeItem('Tid');
				if (screen.width < 800) {
					window.location.href = '/myorders';
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('myorders', '/web/myorders');
					_reactRouter.browserHistory.push('/web/login');
				}
				if (localStorage.user_id && localStorage.token) {
					this.getCartCount();
					this.getOrdersList();
					localStorage.setItem('pay_page', '/web/myorders');
				}
				localStorage.removeItem('book_date');
				localStorage.removeItem('seller');
				localStorage.removeItem('vid');
				localStorage.removeItem('order_details');
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					cancel_modal_status: false,
					cancel_success_status: false
				});
			}
		}, {
			key: 'openRatingsPage',
			value: function openRatingsPage(bid, booking_type, give_rate, seller, book_date, vid, product_id) {
				// Seed -> booking_type = 0;
				// Product -> booking_type = 1;
				localStorage.setItem('book_date', book_date);
				localStorage.setItem('seller', seller);
				localStorage.setItem('vid', vid);
				localStorage.setItem('product_id', product_id);
	
				if (booking_type === 1 && give_rate === 'no') {
					_reactRouter.browserHistory.push('/web/viewrating/product/' + bid);
				} else if (booking_type === 0 && give_rate === 'no') {
					_reactRouter.browserHistory.push('/web/viewrating/' + bid);
				} else if (booking_type === 1 && give_rate === 'yes') {
					_reactRouter.browserHistory.push('/web/giverating/product/' + bid);
				} else if (booking_type === 0 && give_rate === 'yes') {
					_reactRouter.browserHistory.push('/web/giverating/' + bid);
				}
			}
		}, {
			key: 'getBookingsFilterbyStatus',
			value: function getBookingsFilterbyStatus(status) {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', uid: uid, token: localStorage.token, status: status, type: '' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getBookings',
					success: function (data) {
						this.setState({
							bookings: data.bookings,
							cancel_bookings: data.cancel_bookings,
							bookings_count: data.bookings_count,
							cancel_count: data.cancel_count,
							gateway_mode: data.gateway_mode
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getBookingsFilterbyType',
			value: function getBookingsFilterbyType(type) {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var type = type.toString();
				var data1 = { from: 'desktop_web', uid: uid, token: localStorage.token, status: '', type: type };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getBookings',
					success: function (data) {
						this.setState({
							bookings: data.bookings,
							cancel_bookings: data.cancel_bookings,
							bookings_count: data.bookings_count,
							cancel_count: data.cancel_count,
							gateway_mode: data.gateway_mode
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getCancelBookingsFilter',
			value: function getCancelBookingsFilter(type) {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var type = type.toString();
				var data1 = { from: 'desktop_web', uid: uid, token: localStorage.token, status: '', type: type };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getBookings',
					success: function (data) {
						this.setState({
							bookings: data.bookings,
							cancel_bookings: data.cancel_bookings,
							bookings_count: data.bookings_count,
							cancel_count: data.cancel_count,
							gateway_mode: data.gateway_mode
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'repeatOrder',
			value: function repeatOrder(booking_id) {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, booking_id: booking_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'recap_cart',
					success: function success(data) {
						if (data.status === "success") {
							_reactRouter.browserHistory.push('/web/mycart');
							// this.getOrdersList();
						}
					},
					error: function error(err) {}
				});
			}
		}, {
			key: 'update_other_reason',
			value: function update_other_reason(event) {
				this.setState({
					edit_input: event.target.value
				});
			}
		}, {
			key: 'getCartCount',
			value: function getCartCount() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							cart_count: data.cart_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'handleTabsSelect',
			value: function handleTabsSelect(key) {
				this.setState({
					activeTab: key
				});
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var that = this;
				setTimeout(function () {
					that.enableOrdersList();
				}, 3000);
			}
		}, {
			key: 'enableOrdersList',
			value: function enableOrdersList() {
				this.setState({
					orders_list_status: true
				});
			}
		}, {
			key: 'getOrdersList',
			value: function getOrdersList() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', uid: uid, token: localStorage.token, status: '', type: '' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getBookings',
					success: function (data) {
						this.setState({
							bookings: data.bookings,
							cancel_bookings: data.cancel_bookings,
							bookings_count: data.bookings_count,
							cancel_count: data.cancel_count,
							gateway_mode: data.gateway_mode
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'ccAvenue',
			value: function ccAvenue() {
				var basePayUrl = 'https://aqua.deals/paymentGateWay/paymentRequestHandler.php';
				// var basePayUrl='http://203.193.173.125/paymentGateWay/paymentRequestHandler.php';
	
				var username = this.state.username;
				var address = this.state.address;
				var city = this.state.city;
				var state = this.state.state;
				var pincode = this.state.pincode;
				var mobile = this.state.mobile;
				var email = this.state.email;
				var rem_amt = 'rem_amt';
				var deal_type = this.state.book_type;
	
				var data1 = { access_code: 'AVIJ67DJ41BD20JIDB', merchant_id: '103328', order_id: this.state.order_id, merchant_param1: this.state.pre_payment_id, merchant_param2: deal_type, merchant_param3: rem_amt, merchant_param4: 'desktop_web', amount: this.state.paid_amt, currency: 'INR', cancel_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', redirect_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', billing_name: username, billing_address: address, billing_city: city, billing_state: state, billing_zip: pincode, billing_tel: mobile, billing_country: 'India', billing_email: email };
				// var data1={access_code:'AVJZ66DG16BM17ZJMB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:rem_amt,merchant_param4:'desktop_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',redirect_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
	
				_jquery2.default.ajax({
					method: 'POST',
					data: data1,
					url: basePayUrl,
					success: function success(data) {
						(0, _jquery2.default)('.web_myorders_page').html(data);
					},
					error: function error(err) {}
				});
			}
		}, {
			key: 'payNow',
			value: function payNow(book_id, paid_amt, pay_type, book_type, u_name, u_address, u_phone, u_zip, u_city, u_state, u_email) {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, book_id: book_id, paid_amt: paid_amt, pay_type: pay_type, book_type: book_type };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'rem_amt_temp_process',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								pre_payment_id: data.pre_payment_id,
								order_id: data.order_id,
								paid_amt: data.paid_amt,
								book_type: book_type,
	
								username: u_name,
								address: u_address,
								city: u_city,
								state: u_state,
								pincode: u_zip,
								mobile: u_phone,
								email: u_email
							});
						}
						//this.ccAvenue();
						var payment_params = { from: 'desktop_web',
							uid: localStorage.getItem('user_id'),
							pre_payment_id: data.pre_payment_id,
							order_id: data.order_id,
							deal_type: this.state.book_type,
							cart_ids: '',
							paid_amt: data.paid_amt,
							username: this.state.username,
							address: this.state.address,
							city: this.state.city,
							state: this.state.state,
							pincode: this.state.pincode,
							mobile: this.state.mobile,
							country: 'India',
							email: this.state.email,
							cart_add_id: 'rem_amt',
							pageId: this.state.pageId,
							rzp_key: this.props.rzp_keys.key_id };
						if (this.state.gateway_mode == 2) {
							(0, _custom_functions.razorpayForm)(payment_params);
						} else {
							(0, _custom_functions.ccAvenue)(payment_params);
						}
					}.bind(this),
					error: function error(err) {
						// console.log(err);
					}
	
				});
			}
		}, {
			key: 'getCancelDetails',
			value: function getCancelDetails() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.token };
				var data2 = JSON.stringify(data1);
	
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'cancel_reasons',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								cancel_reasons: data.reasons
							});
						}
					}.bind(this),
					error: function error(err) {
						// console.log(err);
					}
				});
			}
		}, {
			key: 'handleCancel_Submit',
			value: function handleCancel_Submit(event) {
				event.preventDefault();
				var bid = this.state.bid;
				var booking_type = this.state.booking_type;
				var selected_reason = this.state.selected_reason;
				if (this.state.selected_reason === 9) {
					selected_reason = this.state.edit_input;
				}
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				if (booking_type === 1) {
					var action_url = 'product_booking_cancel';
					var data1 = { from: 'desktop_web', uid: uid, token: localStorage.token, reason: selected_reason, book_id: bid };
					var data2 = JSON.stringify(data1);
				} else {
					action_url = 'booking_cancel';
					data1 = { from: 'desktop_web', uid: uid, token: localStorage.token, book_id: bid, reason: selected_reason };
					data2 = JSON.stringify(data1);
				}
	
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + action_url,
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								cancel_modal_status: false,
								cancel_success_status: true,
								cancel_success_msg: data.message
							});
							// alert(data.message);
							this.getOrdersList();
							// window.location.reload();
						} else {
							this.setState({
								cancel_modal_status: false,
								cancel_success_status: true,
								cancel_success_msg: data.message
							});
							this.getOrdersList();
							// alert(data.message);
							// window.location.reload();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'openCancelModal',
			value: function openCancelModal(bid, booking_type) {
				this.setState({
					cancel_modal_status: true,
					bid: bid,
					booking_type: booking_type
				});
			}
		}, {
			key: 'selectedReason',
			value: function selectedReason(id, flag) {
				if (flag === '1') {
					this.setState({
						edit_input_status: true,
						selected_reason: id
					});
				} else {
					this.setState({
						edit_input_status: false,
						selected_reason: id
					});
				}
			}
		}, {
			key: 'ratingChanged',
			value: function ratingChanged(newRating) {
				console.log(newRating);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				document.title = "My Orders | AquaDeals";
				(0, _jquery2.default)('body').css('background', '#f1f1f2');
				(0, _jquery2.default)(window).scrollTop(0);
				var orders_tabs = '';
				if (this.state.bookings_count === 0) {
					var bookings = _react2.default.createElement(
						'div',
						{ className: 'web_NoOrdrs_Blk' },
						_react2.default.createElement(
							'p',
							null,
							'No orders were made'
						),
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: '/web/home' },
							'EXPLORE BEST DEALS'
						)
					);
				} else {
					bookings = this.state.bookings.map(function (order, index) {
						var _this2 = this;
	
						var status = '';
						var rating = '';
						var repeat = '';
						// paynow and cacel blk start here
						var paynow_cancel = '';
						if (order.rem_amt_flag === '1' || order.rem_amt_flag === '2') {
							paynow_cancel = '';
						} else if (order.rem_amt_flag === '0' && order.cancel_flag === 1) {
							var pay_type = 1;
	
							var u_name = order.shipping_details ? order.shipping_details.name : '';
							var u_address = order.shipping_details ? order.shipping_details.address : '';
							var u_phone = order.shipping_details ? order.shipping_details.phone : '';
							var u_zip = order.shipping_details ? order.shipping_details.zip : '';
							var u_city = order.shipping_details ? order.shipping_details.city : '';
							var u_state = order.shipping_details ? order.shipping_details.state : '';
							//var u_default_flag = order.shipping_details ? order.shipping_details.default_flag : '';
							//var u_behalf_of = order.shipping_details ? order.shipping_details.behalf_of : '';
							//var u_status = order.shipping_details ? order.shipping_details.status : '';
							var u_email = order.shipping_details ? order.shipping_details.email : '';
	
							paynow_cancel = _react2.default.createElement(
								'div',
								{ className: 'payCancel_Blk' },
								_react2.default.createElement(
									'p',
									{ onClick: function onClick() {
											_this2.payNow(order.booking_id, order.order_amount, pay_type, order.booking_type, u_name, u_address, u_phone, u_zip, u_city, u_state, u_email);
										} },
									_react2.default.createElement(
										'button',
										{ className: 'btn btn-default pay_btn' },
										'Pay Now '
									)
								),
								_react2.default.createElement(
									'p',
									{ onClick: function onClick() {
											_this2.openCancelModal(order.bid, order.booking_type);
										} },
									_react2.default.createElement(
										'button',
										{ className: 'btn btn-default pay_btn' },
										'Cancel'
									)
								)
							);
						} else if (order.rem_amt_flag === '0' && order.cancel_flag === 0) {
							pay_type = 1;
	
							u_name = order.shipping_details ? order.shipping_details.name : '';
							u_address = order.shipping_details ? order.shipping_details.address : '';
							u_phone = order.shipping_details ? order.shipping_details.phone : '';
							u_zip = order.shipping_details ? order.shipping_details.zip : '';
							u_city = order.shipping_details ? order.shipping_details.city : '';
							u_state = order.shipping_details ? order.shipping_details.state : '';
							//u_default_flag = order.shipping_details ? order.shipping_details.default_flag : '';
							//u_behalf_of = order.shipping_details ? order.shipping_details.behalf_of : '';
							//u_status = order.shipping_details ? order.shipping_details.status : '';
							u_email = order.shipping_details ? order.shipping_details.email : '';
							paynow_cancel = _react2.default.createElement(
								'div',
								{ className: 'payBlk text-right' },
								_react2.default.createElement(
									'p',
									{ onClick: function onClick() {
											_this2.payNow(order.booking_id, order.order_amount, order.status, order.booking_type, u_name, u_address, u_phone, u_zip, u_city, u_state, u_email);
										} },
									_react2.default.createElement(
										'button',
										{ className: 'btn btn-default pay_btn' },
										'Pay Now'
									)
								)
							);
						}
	
						// paynow and cacel blk ENDS here
	
						// cancel blk starts here
						var cancel = '';
	
						if (order.rem_amt_flag === '1' && order.cancel_flag === 1) {
							cancel = _react2.default.createElement(
								'div',
								{ className: 'cancel_Blk', onClick: function onClick() {
										_this2.openCancelModal(order.bid, order.booking_type);
									} },
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'button',
										{ className: 'btn btn-default pay_btn' },
										'Cancel'
									)
								)
							);
						}
						// cancel blk ends here
						// rating status with rating and repeat status
						if (order.status === '2' && order.rate === 1) {
							var give_rate = 'no';
							rating = _react2.default.createElement(
								'div',
								{ className: 'order_Rate_Blk pull-right' },
								_react2.default.createElement(
									'p',
									{ className: 'text-right' },
									'View Rating'
								),
								_react2.default.createElement(
									'div',
									{ className: 'RateBlk pull-right', onClick: function onClick() {
											_this2.openRatingsPage(order.bid, order.booking_type, give_rate, order.seller, order.book_date, order.vid, order.product_id);
										} },
									_react2.default.createElement(_reactStars2.default, {
										count: 5,
										onChange: this.ratingChanged,
										className: 'webRate_blk_item',
										size: 20,
										value: order.rating,
										edit: false,
										color1: '#ccc',
										color2: '#FABB9A' })
								)
							);
						} else {
							rating = '';
						}
						if (order.status === '6' && order.rate === 1) {
							give_rate = 'yes';
							rating = _react2.default.createElement(
								'div',
								{ className: 'order_Rate_Blk pull-right' },
								_react2.default.createElement(
									'p',
									{ className: 'rate_desc text-right' },
									'Rate the order based on your experience'
								),
								_react2.default.createElement(
									'div',
									{ className: 'RateBlk pull-right', onClick: function onClick() {
											_this2.openRatingsPage(order.bid, order.booking_type, give_rate, order.seller, order.book_date, order.vid, order.product_id);
										} },
									_react2.default.createElement(_reactStars2.default, {
										count: 5,
										onChange: this.ratingChanged,
										className: 'webRate_blk_item',
										size: 30,
										value: order.rating,
										edit: false,
										color1: '#ccc',
										color2: '#FABB9A' })
								)
							);
							repeat = _react2.default.createElement(
								'div',
								{ onClick: function onClick() {
										_this2.repeatOrder(order.booking_id);
									} },
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'button',
										{ className: 'btn btn-default pay_btn' },
										'Repeat'
									)
								)
							);
						}
						if (order.status === '2' && order.rate === 2) {
							repeat = _react2.default.createElement(
								'div',
								{ onClick: function onClick() {
										_this2.repeatOrder(order.booking_id);
									} },
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'button',
										{ className: 'btn btn-default pay_btn' },
										'Repeat'
									)
								)
							);
							give_rate = 'no';
							rating = _react2.default.createElement(
								'div',
								{ className: 'order_Rate_Blk pull-right' },
								_react2.default.createElement(
									'p',
									null,
									'View Rating'
								),
								_react2.default.createElement(
									'div',
									{ className: 'RateBlk pull-right', onClick: function onClick() {
											_this2.openRatingsPage(order.bid, order.booking_type, give_rate, order.seller, order.book_date, order.vid, order.product_id);
										} },
									_react2.default.createElement(_reactStars2.default, {
										count: 5,
										onChange: this.ratingChanged,
										className: 'webRate_blk_item',
										size: 30,
										edit: false,
										color1: '#ccc',
										value: order.rating,
										color2: '#FABB9A' })
								)
							);
							// set rating
						}
						if (order.status === '6' && order.rate === 2) {
							give_rate = 'no';
							rating = _react2.default.createElement(
								'div',
								{ className: 'order_Rate_Blk pull-right' },
								_react2.default.createElement(
									'p',
									null,
									'View Rating'
								),
								_react2.default.createElement(
									'div',
									{ className: 'RateBlk pull-right', onClick: function onClick() {
											_this2.openRatingsPage(order.bid, order.booking_type, give_rate, order.seller, order.book_date, order.vid, order.product_id);
										} },
									_react2.default.createElement(_reactStars2.default, {
										className: 'webRate_blk_item',
										count: 5,
										onChange: this.ratingChanged,
										size: 30,
										edit: false,
										color1: '#ccc',
										value: order.rating,
										color2: '#FABB9A' })
								)
							);
							//set Rating;
							repeat = _react2.default.createElement(
								'div',
								{ onClick: function onClick() {
										_this2.repeatOrder(order.booking_id);
									} },
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'button',
										{ className: 'btn btn-default pay_btn' },
										'Repeat'
									)
								)
							);
						}
						// order status like placed,shipping,delivered starts here
						if (order.status === '0' || order.status === '4' || order.status === '7') {
							status = 'Placed';
						} else if (order.status === '1') {
							status = 'Processing';
						} else if (order.status === '3') {
							status = 'Cancelled';
						} else if (order.status === '5') {
							status = 'Shipping';
						} else if (order.status === '6') {
							status = 'Delivered';
						}
						// order status like placed,shipping,delivered ends here
	
						return _react2.default.createElement(
							'div',
							{ className: 'orderItem' },
							_react2.default.createElement(
								'div',
								{ className: 'panel panel-default', style: { marginLeft: '40px', marginRight: '40px', marginTop: '10px' } },
								_react2.default.createElement(
									'div',
									{ className: 'panel-heading' },
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-3 col-md-3 col-sm-3' },
											_react2.default.createElement(
												'p',
												{ className: 'order_head' },
												'Order Placed'
											),
											_react2.default.createElement(
												'p',
												{ className: 'orderBody' },
												order.book_date
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-3 col-md-3 col-sm-3' },
											_react2.default.createElement(
												'p',
												null,
												_react2.default.createElement(
													'span',
													{ className: 'order_head' },
													'Total:'
												)
											),
											_react2.default.createElement(
												'p',
												{ className: 'orderBody' },
												_react2.default.createElement(
													'span',
													null,
													'Rs.',
													order.order_amount_online
												)
											),
											_react2.default.createElement(
												'p',
												{ className: 'green order_head' },
												'(',
												status,
												')'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-6 col-md-6 col-sm-6 text-right' },
											_react2.default.createElement(
												'p',
												{ className: 'order_head' },
												'ORDER NO:'
											),
											_react2.default.createElement(
												'p',
												{ className: 'orderBody' },
												order.booking_id
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'panel-body' },
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-6 col-md-6 col-sm-6' },
											order.items.length > 0 ? order.items.map(function (item, index) {
												return _react2.default.createElement(
													_reactRouter.Link,
													{ to: '/web/order_details/' + order.booking_type + '/' + order.bid, className: 'My_Order_Link row' },
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-2 col-md-2 col-sm-3 text-center' },
														_react2.default.createElement(
															'i',
															{ className: 'orderIcon' },
															_react2.default.createElement('img', { src: baseAssets + 'images/' + item.image, alt: '' })
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-10 col-md-10 col-sm-9' },
														item.title ? _react2.default.createElement(
															'p',
															{ className: 'order_Title' },
															item.title
														) : _react2.default.createElement(
															'p',
															{ className: 'order_Title' },
															'\xA0'
														),
														item.quantity ? _react2.default.createElement(
															'p',
															null,
															'Quantity ',
															item.quantity
														) : _react2.default.createElement(
															'p',
															null,
															'\xA0'
														)
													)
												);
											}) : ''
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-6 col-md-6 col-sm-6 text-right' },
											paynow_cancel,
											cancel,
											repeat
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-12 col-md-12 col-sm-12' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/web/order_details/' + order.booking_type + '/' + order.bid, className: 'My_Order_Link' },
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-5 col-md-5 col-sm-5' },
												_react2.default.createElement(
													'i',
													null,
													_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/' + order.progress_bar, alt: '' })
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-7 col-md-7 col-sm-7' },
											_react2.default.createElement(
												'div',
												{ className: 'order_Rating_Blk' },
												rating
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								)
							)
						);
					}.bind(this));
				}
				if (this.state.cancel_count === 0) {
					var cancel_bookings = _react2.default.createElement(
						'div',
						{ className: 'no_ordrs_blk' },
						_react2.default.createElement(
							'p',
							null,
							'No Orders were made'
						),
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: '/web/home' },
							'EXPLORE BEST DEALS'
						)
					);
				} else {
					cancel_bookings = this.state.cancel_bookings.map(function (order, index) {
						var status = '';
						if (order.status === '3') {
							status = 'Cancelled';
						}
						return _react2.default.createElement(
							'div',
							{ className: 'orderItem' },
							_react2.default.createElement(
								'div',
								{ className: 'panel panel-default', style: { marginLeft: '40px', marginRight: '40px', marginTop: '10px' } },
								_react2.default.createElement(
									'div',
									{ className: 'panel-heading' },
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-3 col-md-3 col-sm-3' },
											_react2.default.createElement(
												'p',
												{ className: 'order_head' },
												'Order Placed'
											),
											_react2.default.createElement(
												'p',
												{ className: 'orderBody' },
												order.book_date
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-3 col-md-3 col-sm-3' },
											_react2.default.createElement(
												'p',
												null,
												_react2.default.createElement(
													'span',
													{ className: 'order_head' },
													'Total:'
												)
											),
											_react2.default.createElement(
												'p',
												{ className: 'orderBody' },
												_react2.default.createElement(
													'span',
													null,
													'Rs.',
													order.order_amount
												)
											),
											_react2.default.createElement(
												'p',
												{ className: 'red order_head' },
												'(',
												status,
												')'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-6 col-md-6 col-sm-6 text-right' },
											_react2.default.createElement(
												'p',
												{ className: 'order_head' },
												'ORDER NO:'
											),
											_react2.default.createElement(
												'p',
												{ className: 'orderBody' },
												order.booking_id
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'panel-body' },
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										),
										order.items.length > 0 ? order.items.map(function (item, index) {
											return _react2.default.createElement(
												_reactRouter.Link,
												{ to: '/web/order_details/' + order.booking_type + '/' + order.bid, className: 'My_Order_Link' },
												_react2.default.createElement(
													'div',
													{ className: 'col-lg-6 col-md-6 col-sm-6' },
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-2 col-md-2 col-sm-3 text-center' },
														_react2.default.createElement(
															'i',
															{ className: 'orderIcon' },
															_react2.default.createElement('img', { src: baseAssets + 'images/' + item.image, alt: '' })
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-10 col-md-10 col-sm-9' },
														item.title ? _react2.default.createElement(
															'p',
															{ className: 'order_Title' },
															item.title
														) : _react2.default.createElement(
															'p',
															{ className: 'order_Title' },
															'\xA0'
														),
														item.quantity ? _react2.default.createElement(
															'p',
															null,
															'Quantity ',
															item.quantity
														) : _react2.default.createElement(
															'p',
															null,
															'\xA0'
														)
													)
												)
											);
										}) : ''
									),
									_react2.default.createElement(
										'div',
										{ className: 'clr' },
										'\xA0'
									),
									_react2.default.createElement(
										'div',
										{ className: 'clr' },
										'\xA0'
									)
								)
							)
						);
					});
				}
	
				orders_tabs = _react2.default.createElement(
					_reactBootstrap.Tabs,
					{ activeKey: this.state.activeTab, tabWidth: 2, className: 'my_ordr_tabs', id: 'web_my_orders_tabs', onSelect: this.handleTabsSelect },
					_react2.default.createElement(
						_reactBootstrap.Tab,
						{ eventKey: 1, tabClassName: 'web_Myorders_Tab', title: "MY ORDERS : " + this.state.bookings_count },
						_react2.default.createElement(
							'div',
							null,
							bookings
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Tab,
						{ eventKey: 2, tabClassName: 'web_Myorders_Tab', title: "CANCELLED : " + this.state.cancel_count },
						_react2.default.createElement(
							'div',
							null,
							cancel_bookings
						)
					)
				);
	
				var cancel_reasons = this.state.cancel_reasons.map(function (data, index) {
					var _this3 = this;
	
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement('input', { type: 'radio', id: data.id, name: 'reason', className: 'Cancel_Radio', onClick: function onClick() {
								_this3.selectedReason(data.id, data.flag);
							} }),
						_react2.default.createElement(
							'span',
							null,
							data.reason
						),
						data.flag === '1' ? _react2.default.createElement(
							'div',
							{ className: 'Other_Reason_Blk' },
							this.state.edit_input_status ? _react2.default.createElement('input', { type: 'text', name: 'other_reason', ref: 'other_reason', id: 'other_reason', placeholder: 'Enter any reason', value: this.state.edit_input, onChange: this.update_other_reason }) : ''
						) : ''
					);
				}.bind(this));
				return _react2.default.createElement(
					'div',
					{ className: 'web_Deals web_myorders_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							_reactBootstrap.Breadcrumb,
							{ className: 'webmyorder_breadcrumb' },
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb.Item,
								{ href: '/web/home' },
								'Home'
							),
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb.Item,
								{ active: true },
								'My Orders'
							)
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12 Dels_cntnt' },
								this.state.activeTab === 1 ? _react2.default.createElement(
									'div',
									{ className: 'sort_btns' },
									_react2.default.createElement(
										'ul',
										null,
										_react2.default.createElement(
											'li',
											null,
											_react2.default.createElement(
												_reactBootstrap.ButtonToolbar,
												{ className: 'drops' },
												_react2.default.createElement(
													_reactBootstrap.DropdownButton,
													{ className: 'webOrder_filter_1', noCaret: true, title: 'By Order Status', dropdown: true },
													_react2.default.createElement(
														_reactBootstrap.MenuItem,
														{ header: true, className: 'drop_head' },
														'By Order Status'
													),
													_react2.default.createElement(
														_reactBootstrap.MenuItem,
														{ className: 'seed_list1', onClick: function onClick() {
																return _this4.getBookingsFilterbyStatus('');
															} },
														'All'
													),
													_react2.default.createElement(
														_reactBootstrap.MenuItem,
														{ className: 'seed_list1', eventKey: 0, onClick: function onClick() {
																return _this4.getBookingsFilterbyStatus(0);
															} },
														'PLACED'
													),
													_react2.default.createElement(
														_reactBootstrap.MenuItem,
														{ className: 'seed_list1', eventKey: 5, onClick: function onClick() {
																return _this4.getBookingsFilterbyStatus(5);
															} },
														'Shipping'
													),
													_react2.default.createElement(
														_reactBootstrap.MenuItem,
														{ className: 'seed_list1', eventKey: 6, onClick: function onClick() {
																return _this4.getBookingsFilterbyStatus(6);
															} },
														'Delivered'
													)
												)
											)
										),
										_react2.default.createElement(
											'li',
											null,
											_react2.default.createElement(
												_reactBootstrap.ButtonToolbar,
												{ className: 'drops ordr_filtr_2' },
												_react2.default.createElement(
													_reactBootstrap.DropdownButton,
													{ className: 'webOrder_filter_2', noCaret: true, onClick: this.getBrands, title: 'By Type', dropdown: true },
													_react2.default.createElement(
														_reactBootstrap.MenuItem,
														{ header: true, className: 'drop_head' },
														'By Type '
													),
													_react2.default.createElement(
														_reactBootstrap.MenuItem,
														{ className: 'seed_list1', eventKey: '', onClick: function onClick() {
																return _this4.getBookingsFilterbyType('');
															} },
														'ALL'
													),
													_react2.default.createElement(
														_reactBootstrap.MenuItem,
														{ className: 'seed_list1', eventKey: 0, onClick: function onClick() {
																return _this4.getBookingsFilterbyType(0);
															} },
														'Seed'
													),
													_react2.default.createElement(
														_reactBootstrap.MenuItem,
														{ className: 'seed_list1', eventKey: 1, onClick: function onClick() {
																return _this4.getBookingsFilterbyType(1);
															} },
														'Product'
													)
												)
											)
										)
									)
								) : _react2.default.createElement(
									'div',
									{ className: 'sort_btns' },
									_react2.default.createElement(
										'ul',
										null,
										_react2.default.createElement(
											'li',
											null,
											_react2.default.createElement(
												_reactBootstrap.ButtonToolbar,
												{ className: 'pull-right drops ordr_filtr_2', id: 'web_Type_Sort' },
												_react2.default.createElement(
													_reactBootstrap.DropdownButton,
													{ className: 'webOrder_filter_2', noCaret: true, onClick: this.getBrands, title: 'By Type', dropdown: true },
													_react2.default.createElement(
														_reactBootstrap.MenuItem,
														{ header: true, className: 'drop_head' },
														'By Type '
													),
													_react2.default.createElement(
														_reactBootstrap.MenuItem,
														{ className: 'seed_list1', eventKey: '', onClick: function onClick() {
																return _this4.getCancelBookingsFilter('');
															} },
														'ALL'
													),
													_react2.default.createElement(
														_reactBootstrap.MenuItem,
														{ className: 'seed_list1', eventKey: 0, onClick: function onClick() {
																return _this4.getCancelBookingsFilter(0);
															} },
														'Seed'
													),
													_react2.default.createElement(
														_reactBootstrap.MenuItem,
														{ className: 'seed_list1', eventKey: 1, onClick: function onClick() {
																return _this4.getCancelBookingsFilter(1);
															} },
														'Product'
													)
												)
											)
										)
									)
								),
								_react2.default.createElement(
									'section',
									{ className: 'webOrders_content', style: { marginLeft: '-15px', marginRight: '-15px', marginBottom: '120px' } },
									orders_tabs
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ onEntered: function onEntered() {
											_this4.getCancelDetails();
										}, className: '', show: this.state.cancel_modal_status, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Header,
										{ className: 'Modal_Offer_Header', closeButton: true },
										_react2.default.createElement(
											_reactBootstrap.Modal.Title,
											{ className: 'M_Title', style: { textAlign: 'center', color: '#fff' } },
											'Order Cancellation'
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(
												'p',
												null,
												'Do you want to cancel this Order?'
											),
											_react2.default.createElement(
												'form',
												{ className: 'cancel_reasons_form', onSubmit: this.handleCancel_Submit },
												_react2.default.createElement(
													'div',
													{ className: '' },
													cancel_reasons
												),
												_react2.default.createElement(
													'div',
													null,
													_react2.default.createElement(
														'div',
														{ className: 'Modal_Footer' },
														_react2.default.createElement(
															'a',
															{ className: 'Cancel_No_Btn', onClick: this.close },
															'No'
														),
														_react2.default.createElement(
															'button',
															{ type: 'submit', className: 'Cancel_Yes_Btn' },
															'Yes'
														)
													)
												)
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'showModal', show: this.state.cancel_success_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#666', textAlign: 'center' } },
								this.state.cancel_success_msg
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_My_Orders;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			rzp_keys: state.posts.rzp_keys
		};
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Web_My_Orders);

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Web_NotFound = __webpack_require__(136);
	
	var _Web_NotFound2 = _interopRequireDefault(_Web_NotFound);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _custom_functions = __webpack_require__(83);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Web_Order_Details = function (_Component) {
		_inherits(Web_Order_Details, _Component);
	
		function Web_Order_Details(props) {
			_classCallCheck(this, Web_Order_Details);
	
			var _this = _possibleConstructorReturn(this, (Web_Order_Details.__proto__ || Object.getPrototypeOf(Web_Order_Details)).call(this, props));
	
			_this.state = {};
			_this.state = {
				total_data: [],
				details: [],
				shipping_address: [],
	
				items: [],
				aqua_cash: '',
				aqua_cash1: '',
				coupons_amt: '',
				coupons_amt1: '',
				seller_discount: '',
				seller_discount1: '',
				promo_manf_value: '',
				promo_manf_value1: '',
				promo_hatch_value: '',
				promo_hatch_value1: '',
				applied_coupons: [],
				applied_coupons1: '',
				payment_details: [],
				payment_log: [],
				shipment_log: [],
				ship_dlvr_blck: [],
				details_status: false,
				page_error_status: false,
				page_loading: false,
	
				pay_now_btn: '',
				other_amount_btn: '',
				famount_pay_manufacturer: '',
	
				other_amount_btn_status: false,
				err_qty_status: false,
				err_qty_msg: '',
				min_val: '',
				max_val: '',
				book_id: '',
				applied_cpns_amt: '',
				confirm_modal: false,
				famount_pay_hatchery: '',
	
				edit_input_status: false,
				edit_input: '',
				cancel_modal_status: false,
				cancel_reasons: [],
				selected_reason: '',
	
				rate_flag: '',
				shipping_details: '',
				confirm_btn_show: '',
				transport_mode: '',
	
				cancel_time: '',
				cancel_reason: '',
				cancel_by: '',
				cancel_success_status: false,
				cancel_success_msg: '',
				// shipping payment start 
				ship_cc_pay: '',
				ship_pre_payment_id: '',
				ship_order_id: '',
				ship_paid_amt: '',
				ship_book_type: '',
	
				ship_username: '',
				ship_address: '',
				ship_city: '',
				ship_state: '',
				ship_pincode: '',
				ship_mobile: '',
				ship_email: '',
				pageId: '.web_order_details_page'
				// shipping payment ends 
			};
			_this.getOrderDetails = _this.getOrderDetails.bind(_this);
			_this.enableOtherAmount = _this.enableOtherAmount.bind(_this);
			_this.validateOtherAmount = _this.validateOtherAmount.bind(_this);
			_this.payNow = _this.payNow.bind(_this);
			_this.ccAvenue = _this.ccAvenue.bind(_this);
			_this.payOtherAmount = _this.payOtherAmount.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.openCancelModal = _this.openCancelModal.bind(_this);
			_this.getCancelDetails = _this.getCancelDetails.bind(_this);
			_this.handleCancel_Submit = _this.handleCancel_Submit.bind(_this);
			_this.selectedReason = _this.selectedReason.bind(_this);
			_this.update_other_reason = _this.update_other_reason.bind(_this);
	
			_this.shippingPayNow = _this.shippingPayNow.bind(_this);
			_this.shipping_ccAvenue = _this.shipping_ccAvenue.bind(_this);
			return _this;
		}
	
		_createClass(Web_Order_Details, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.props.get_rzp_keys("desktop_web");
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
				localStorage.removeItem('checkout');
	
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
				localStorage.removeItem('web_quickcart');
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
				localStorage.removeItem('web_brand_details');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
				if (screen.width < 800) {
					window.location.href = "/order_details/" + this.props.params.OrderType + '/' + this.props.params.Oid;
				}
				if (!localStorage.user_id /*&& !localStorage.token*/) {
						localStorage.setItem('order_details', '/web/order_details/' + this.props.params.OrderType + '/' + this.props.params.Oid);
						_reactRouter.browserHistory.push('/web/login');
					} else {
					this.getOrderDetails();
					localStorage.setItem('pay_page', '/web/order_details/' + this.props.params.OrderType + '/' + this.props.params.Oid);
				}
			}
		}, {
			key: 'shippingPayNow',
			value: function shippingPayNow() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, bid: this.props.params.Oid, type: this.props.params.OrderType, details_flag: 1 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'ship_payment_temp_process',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								ship_pre_payment_id: data.pre_payment_id,
								ship_order_id: data.order_id,
								ship_paid_amt: data.paid_amt,
								ship_book_type: data.book_type,
	
								ship_username: data.shipaddress[0].name,
								ship_address: data.shipaddress[0].address,
								ship_city: data.shipaddress[0].city,
								ship_state: data.shipaddress[0].state,
								ship_pincode: data.shipaddress[0].zip,
								ship_mobile: data.shipaddress[0].phone,
								ship_email: data.shipaddress[0].email
							});
							//this.shipping_ccAvenue();
							var payment_params = { from: 'desktop_web',
								uid: localStorage.getItem('user_id'),
								pre_payment_id: data.pre_payment_id,
								order_id: data.order_id,
								deal_type: this.state.ship_book_type,
								cart_ids: data.cart_ids,
								paid_amt: data.paid_amt,
								username: this.state.ship_username,
								address: this.state.ship_address,
								city: this.state.ship_city,
								state: this.state.ship_state,
								pincode: this.state.ship_pincode,
								mobile: this.state.ship_mobile,
								country: 'India',
								email: this.state.ship_email,
								cart_add_id: 'shipping_amt',
								pageId: this.state.pageId,
								rzp_key: this.props.rzp_keys.key_id };
							if (this.state.gateway_mode == 2) {
								(0, _custom_functions.razorpayForm)(payment_params);
							} else {
								(0, _custom_functions.ccAvenue)(payment_params);
							}
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
	
				});
			}
		}, {
			key: 'shipping_ccAvenue',
			value: function shipping_ccAvenue() {
				var username = this.state.ship_username;
				var address = this.state.ship_address;
				var city = this.state.ship_city;
				var state = this.state.ship_state;
				var pincode = this.state.ship_pincode;
				var mobile = this.state.ship_mobile;
				var email = this.state.ship_email;
				var shipping_amt = 'shipping_amt';
				var deal_type = this.state.ship_book_type;
	
				var basePayUrl = 'https://aqua.deals/paymentGateWay/paymentRequestHandler.php';
				// var basePayUrl='http://203.193.173.125/paymentGateWay/paymentRequestHandler.php';
	
				var data1 = { access_code: 'AVIJ67DJ41BD20JIDB', merchant_id: '103328', order_id: this.state.order_id, merchant_param1: this.state.pre_payment_id, merchant_param2: deal_type, merchant_param3: shipping_amt, merchant_param4: 'mobile_web', amount: this.state.paid_amt, currency: 'INR', cancel_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', redirect_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', billing_name: username, billing_address: address, billing_city: city, billing_state: state, billing_zip: pincode, billing_tel: mobile, billing_country: 'India', billing_email: email };
				// var data1={access_code:'AVJZ66DG16BM17ZJMB',merchant_id:'103328',order_id:this.state.ship_order_id,merchant_param1:this.state.ship_pre_payment_id,merchant_param2:deal_type,merchant_param3:shipping_amt,merchant_param4:'desktop_web',amount:this.state.ship_paid_amt,currency:'INR',cancel_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',redirect_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
	
				_jquery2.default.ajax({
					method: 'POST',
					data: data1,
					url: basePayUrl,
					success: function success(data) {
						(0, _jquery2.default)('.web_order_details_page').html(data);
					},
					error: function error(err) {
						console.log(err);
						alert(err);
					}
				});
			}
		}, {
			key: 'openCancelModal',
			value: function openCancelModal(bid, booking_type) {
				this.setState({
					cancel_modal_status: true
				});
			}
		}, {
			key: 'getCancelDetails',
			value: function getCancelDetails() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token };
				var data2 = JSON.stringify(data1);
	
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'cancel_reasons',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								cancel_reasons: data.reasons
							});
						}
					}.bind(this),
					error: function error(err) {
						// console.log(err);
					}
				});
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var that = this;
				setTimeout(function () {
					that.enableDetails();
				}, 3000);
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					confirm_modal: false,
					cancel_modal_status: false,
					cancel_success_status: false
				});
			}
		}, {
			key: 'enableDetails',
			value: function enableDetails() {
				this.setState({
					details_status: true
				});
			}
		}, {
			key: 'getOrderDetails',
			value: function getOrderDetails() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, bid: this.props.params.Oid, order_type: this.props.params.OrderType };
				var data2 = JSON.stringify(data1);
				var order_type = this.props.params.OrderType;
	
				this.setState({
					page_loading: true
				});
	
				if (order_type === '0') {
					var call_fn = 'Booking_details';
				} else if (order_type === '1') {
					call_fn = 'pro_booking_details';
				} else {
					call_fn = 'pro_booking_details';
				}
	
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + call_fn,
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								page_loading: false,
								total_data: data,
								details: data.details,
								shipping_address: data.shipping_address,
								items: data.items,
								applied_coupons: data.applied_coupons,
								payment_details: data.payment_details,
								ship_dlvr_blck: data.ship_dlvr_blck,
								aqua_cash: data.aqua_cash,
								aqua_cash1: data.aqua_cash1,
								seller_discount: data.seller_discount,
								seller_discount1: data.seller_discount1,
								promo_hatch_value: data.promo_hatch_value,
								promo_hatch_value1: data.promo_hatch_value1,
								promo_manf_value: data.promo_manf_value,
								promo_manf_value1: data.promo_manf_value1,
								coupons_amt: data.coupons_amt,
								coupons_amt1: data.coupons_amt1,
								payment_log: data.payment_log,
								shipment_log: data.shipment_log,
								applied_cpns_amt: data.details.applied_cpns_amt,
								pay_now_btn: data.pay_now_btn,
								other_amount_btn: data.other_amount_btn,
								famount_pay_manufacturer: data.famount_pay_manufacturer,
								famount_pay_hatchery: data.famount_pay_hatchery,
								min_val: data.min_val,
								max_val: data.max_val,
								book_id: data.details.booking_id,
	
								pre_payment_id: '',
								order_id: '',
								paid_amt: '',
								rate_flag: data.rate_flag,
								shipping_details: data.shipping_details,
								confirm_btn_show: data.confirm_btn_show,
								transport_mode: data.transport_mode,
	
								cancel_time: data.cancel_time,
								cancel_reason: data.cancel_reason,
								cancel_by: data.cancel_by,
								ship_cc_pay: data.ship_cc_pay,
								gateway_mode: data.gateway_mode
							});
						} else {
							this.setState({
								page_error_status: true
							});
						}
					}.bind(this),
					error: function error(err) {
						// console.log(err);
					}
				});
			}
		}, {
			key: 'enableOtherAmount',
			value: function enableOtherAmount() {
				this.setState({
					other_amount_btn_status: true
				});
			}
		}, {
			key: 'validateOtherAmount',
			value: function validateOtherAmount() {
				this.setState({
					err_qty_status: false,
					err_qty_msg: ''
				});
				//var x='';
				if (parseInt(this.refs.ref_other_amt.value, 10) < parseInt(this.state.min_val, 10)) {
					//x='Minimum Quantity is '+this.state.min_val;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Minimum amount is ' + this.state.min_val
					});
				}
				if (parseInt(this.refs.ref_other_amt.value, 10) > parseInt(this.state.max_val, 10)) {
					//x='Maximum Quantity is '+this.state.max_val;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Maximum amount is ' + this.state.max_val
					});
				}
				var check = /[^0-9]/gi;
				if (check.test(this.refs.ref_other_amt.value)) {
					//x='* Invalid Amount';	
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Invalid Amount'
					});
				}
	
				//if(x==='')
				//{
				//this.other_amount_cartCalculations(4,this.refs.ref_other_amt.value);	
				//}
			}
		}, {
			key: 'payNow',
			value: function payNow() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				if (this.props.params.OrderType === '1') {
					var paid_amt = this.state.famount_pay_manufacturer;
				} else if (this.props.params.OrderType === '0') {
					paid_amt = this.state.famount_pay_hatchery;
				}
	
				var pay_type = '1';
				var book_id = this.state.book_id;
				var book_type = this.props.params.OrderType;
				var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, book_id: book_id, paid_amt: paid_amt, pay_type: pay_type, book_type: book_type };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'rem_amt_temp_process',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								pre_payment_id: data.pre_payment_id,
								order_id: data.order_id,
								paid_amt: data.paid_amt
							});
						}
						//this.ccAvenue();
						var payment_params = { from: 'desktop_web',
							uid: localStorage.getItem('user_id'),
							pre_payment_id: data.pre_payment_id,
							order_id: data.order_id,
							deal_type: this.props.params.OrderType,
							cart_ids: '',
							paid_amt: data.paid_amt,
							username: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].name : '',
							address: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].address : '',
							city: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].city : '',
							state: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].state : '',
							pincode: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].zip : '',
							mobile: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].mobile : '',
							country: 'India',
							email: '',
							cart_add_id: 'rem_amt',
							pageId: this.state.pageId,
							rzp_key: this.props.rzp_keys.key_id };
	
						if (this.state.gateway_mode == 2) {
							(0, _custom_functions.razorpayForm)(payment_params);
						} else {
							(0, _custom_functions.ccAvenue)(payment_params);
						}
					}.bind(this),
					error: function error(err) {
						// console.log(err);
					}
				});
			}
		}, {
			key: 'payOtherAmount',
			value: function payOtherAmount() {
				var x = '';
	
				if (this.refs.ref_other_amt.value === '') {
					x = '* Enter Amount';
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Enter Amount'
					});
				}
				if (parseInt(this.refs.ref_other_amt.value, 10) === parseInt(this.state.max_val, 10)) {
					this.setState({
						confirm_modal: true
					});
				} else {
					if (parseInt(this.refs.ref_other_amt.value, 10) < parseInt(this.state.min_val, 10)) {
						x = 'Minimum Quantity is ' + this.state.min_val;
						this.setState({
							err_qty_status: true,
							err_qty_msg: '* Minimum amount is ' + this.state.min_val
						});
					}
					if (parseInt(this.refs.ref_other_amt.value, 10) > parseInt(this.state.max_val, 10)) {
						// alert('Maximum Quantity is '+this.state.max_qty);
						x = 'Maximum Quantity is ' + this.state.max_val;
						this.setState({
							err_qty_status: true,
							err_qty_msg: '* Maximum amount is ' + this.state.max_val
						});
					}
					var check = /[^0-9]/gi;
					if (check.test(this.refs.ref_other_amt.value)) {
						x = '* Invalid Amount';
						this.setState({
							err_qty_status: true,
							err_qty_msg: '* Invalid Amount'
						});
					}
	
					if (x === '') {
						var baseUrl = 'https://aquadeals.in/admin/web3/user/';
						var paid_amt = this.refs.ref_other_amt.value;
						var pay_type = '2';
						var book_id = this.state.book_id;
						var book_type = this.props.params.OrderType;
						var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, book_id: book_id, paid_amt: paid_amt, pay_type: pay_type, book_type: book_type };
						var data2 = JSON.stringify(data1);
						_jquery2.default.ajax({
							method: 'POST',
							dataType: 'json',
							url: baseUrl + 'rem_amt_temp_process',
							data: { req: data2 },
							success: function (data) {
								if (data.status === 'success') {
									this.setState({
										pre_payment_id: data.pre_payment_id,
										order_id: data.order_id,
										paid_amt: data.paid_amt
									});
								}
								//this.ccAvenue();
								var payment_params = { from: 'desktop_web',
									uid: localStorage.getItem('user_id'),
									pre_payment_id: data.pre_payment_id,
									order_id: data.order_id,
									deal_type: this.props.params.OrderType,
									cart_ids: data.cart_ids,
									paid_amt: data.paid_amt,
									username: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].name : '',
									address: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].address : '',
									city: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].city : '',
									state: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].state : '',
									pincode: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].zip : '',
									mobile: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].mobile : '',
									country: 'India',
									email: '',
									cart_add_id: 'rem_amt',
									pageId: this.state.pageId,
									rzp_key: this.props.rzp_keys.key_id };
	
								if (this.state.gateway_mode == 2) {
									(0, _custom_functions.razorpayForm)(payment_params);
								} else {
									(0, _custom_functions.ccAvenue)(payment_params);
								}
							}.bind(this),
							error: function error(err) {
								// console.log(err);
							}
						});
					}
				}
			}
		}, {
			key: 'ccAvenue',
			value: function ccAvenue() {
				var username = this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].name : '';
				var address = this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].address : '';
				var city = this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].city : '';
				var state = this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].state : '';
				var pincode = this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].zip : '';
				var mobile = this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].mobile : '';
				var email = '';
				var rem_amt = 'rem_amt';
				var deal_type = this.props.params.OrderType;
	
				var basePayUrl = 'https://aqua.deals/paymentGateWay/paymentRequestHandler.php';
				// var basePayUrl='http://203.193.173.125/paymentGateWay/paymentRequestHandler.php';
				var data1 = { access_code: 'AVIJ67DJ41BD20JIDB', merchant_id: '103328', order_id: this.state.order_id, merchant_param1: this.state.pre_payment_id, merchant_param2: deal_type, merchant_param3: rem_amt, merchant_param4: 'desktop_web', amount: this.state.paid_amt, currency: 'INR', cancel_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', redirect_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', billing_name: username, billing_address: address, billing_city: city, billing_state: state, billing_zip: pincode, billing_tel: mobile, billing_country: 'India', billing_email: email };
				// var data1={access_code:'AVJZ66DG16BM17ZJMB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:rem_amt,merchant_param4:'desktop_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',redirect_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
				_jquery2.default.ajax({
					method: 'POST',
					data: data1,
					url: basePayUrl,
					success: function success(data) {
						(0, _jquery2.default)('.web_order_details_page').html(data);
					},
					error: function error(err) {
						// console.log(err);
					}
				});
			}
		}, {
			key: 'selectedReason',
			value: function selectedReason(id, flag) {
				// var flag=flag;
				if (flag === '1') {
					this.setState({
						edit_input_status: true,
						selected_reason: id
					});
				} else {
					this.setState({
						edit_input_status: false,
						selected_reason: id
					});
				}
			}
		}, {
			key: 'update_other_reason',
			value: function update_other_reason(event) {
				this.setState({
					edit_input: event.target.value
				});
			}
		}, {
			key: 'handleCancel_Submit',
			value: function handleCancel_Submit(event) {
				event.preventDefault();
				var bid = this.props.params.Oid;
				var booking_type = this.props.params.OrderType;
				var selected_reason = this.state.selected_reason;
				if (this.state.selected_reason === 9) {
					selected_reason = this.state.edit_input;
				}
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				if (booking_type === '1') {
					var action_url = 'product_booking_cancel';
					var data1 = { from: 'desktop_web', uid: localStorage.user_id, token: localStorage.token, reason: selected_reason, book_id: bid };
					var data2 = JSON.stringify(data1);
				} else {
					action_url = 'booking_cancel';
					data1 = { from: 'desktop_web', uid: localStorage.user_id, token: localStorage.token, book_id: bid, reason: selected_reason };
					data2 = JSON.stringify(data1);
				}
	
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + action_url,
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								cancel_modal_status: false,
								cancel_success_status: true,
								cancel_success_msg: data.message
							});
							this.getOrderDetails();
							// alert(data.message);
							// window.location.reload();
						} else {
							this.setState({
								cancel_modal_status: false,
								cancel_success_status: true,
								cancel_success_msg: data.message
							});
							this.getOrderDetails();
							// alert(data.message);
							// window.location.reload();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				document.title = this.state.details.booking_id ? "Order " + this.state.details.booking_id + " Details | AquaDeals" : "Order Details | AquaDeals";
				(0, _jquery2.default)('body').css('background-color', '#fff');
				var status = '';
				if (this.state.details.status === '0' || this.state.details.status === '4' || this.state.details.status === '7') {
					status = 'Order Placed';
				} else if (this.state.details.status === '1') {
					status = 'Processing';
				} else if (this.state.details.status === '3') {
					status = 'Cancelled';
				} else if (this.state.details.status === '5') {
					status = 'Shipping';
				} else if (this.state.details.status === '6') {
					status = 'Delivered';
				}
				var order_items = '';
				if (this.state.items.length > 0) {
					if (this.props.params.OrderType === '1') {
						order_items = this.state.items.map(function (order, index) {
							return _react2.default.createElement(
								'div',
								{ className: '' },
								_react2.default.createElement(
									'div',
									{ className: 'order_list_items' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-12 col-md-12 order_subitems' },
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-3 col-md-3', style: { padding: '0px' } },
											_react2.default.createElement(
												'i',
												{ className: 'Weborder_icon' },
												_react2.default.createElement('img', { src: order.image, alt: '' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-9 col-md-9', style: { padding: '0px' } },
											order.title ? _react2.default.createElement(
												'p',
												null,
												order.title
											) : _react2.default.createElement(
												'p',
												null,
												'\xA0'
											),
											order.brand ? _react2.default.createElement(
												'p',
												null,
												_react2.default.createElement(
													'span',
													{ style: { fontSize: '10px', color: '#999' } },
													order.brand
												),
												_react2.default.createElement(
													'span',
													{ style: { float: 'right' } },
													'\u20B9 ',
													order.total_amount
												)
											) : _react2.default.createElement(
												'p',
												null,
												'\xA0'
											),
											order.mrp || order.quantity ? _react2.default.createElement(
												'p',
												null,
												'Price \u20B9 ',
												order.mrp,
												' ',
												_react2.default.createElement(
													'span',
													null,
													'Quantity ',
													order.quantity,
													' '
												),
												' '
											) : _react2.default.createElement(
												'p',
												null,
												'\xA0'
											)
										)
									)
								)
							);
						});
					} else {
						order_items = this.state.items.map(function (order, index) {
							return _react2.default.createElement(
								'div',
								{ className: '' },
								_react2.default.createElement(
									'div',
									{ className: 'order_list_items' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-12 col-md-12 order_subitems' },
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-2 col-md-2', style: { padding: '0px' } },
											_react2.default.createElement(
												'i',
												{ className: 'seed_order_icon' },
												_react2.default.createElement('img', { src: order.image, alt: '' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-10 col-md-10', style: { padding: '0px' } },
											order.specie ? _react2.default.createElement(
												'p',
												{ style: { color: '#333' } },
												order.specie
											) : _react2.default.createElement(
												'p',
												null,
												'\xA0'
											),
											order.total_amount ? _react2.default.createElement(
												'p',
												null,
												_react2.default.createElement(
													'span',
													{ style: { float: 'right' } },
													'\u20B9 ',
													order.total_amount
												)
											) : _react2.default.createElement(
												'p',
												null,
												'\xA0'
											),
											_react2.default.createElement(
												'p',
												{ style: { color: '#999' } },
												_react2.default.createElement(
													'span',
													null,
													'Plsize'
												),
												'\xA0',
												_react2.default.createElement(
													'span',
													null,
													order.plsize
												),
												'\xA0',
												_react2.default.createElement(
													'span',
													null,
													'Salinity'
												),
												'\xA0',
												_react2.default.createElement(
													'span',
													null,
													order.salinity
												)
											),
											order.mrp || order.quantity ? _react2.default.createElement(
												'p',
												null,
												'Price \u20B9 ',
												order.mrp,
												' ',
												_react2.default.createElement(
													'span',
													null,
													'Quantity ',
													order.quantity
												)
											) : _react2.default.createElement(
												'p',
												null,
												'\xA0'
											)
										)
									)
								)
							);
						});
					}
				}
	
				var payment_log = this.state.payment_log.map(function (data, index) {
					return _react2.default.createElement(
						'div',
						{ className: 'ordr_dtls_5' },
						_react2.default.createElement(
							'p',
							null,
							data.msg
						)
					);
				});
				var shipment_log = this.state.shipment_log.map(function (data, index) {
					return _react2.default.createElement(
						'div',
						{ className: 'ordr_dtls_5' },
						_react2.default.createElement(
							'p',
							null,
							data.msg
						)
					);
				});
				var pay_remaining_amount = '';
				if (this.state.pay_now_btn === 'yes') {
					pay_remaining_amount = _react2.default.createElement(
						'div',
						{ className: 'pay_now_btn', onClick: function onClick() {
								_this2.payNow();
							} },
						_react2.default.createElement(
							'a',
							null,
							'Pay \u20B9 ',
							this.state.famount_pay_manufacturer,
							' ',
							this.state.famount_pay_hatchery,
							' Online ',
							_react2.default.createElement(
								'i',
								{ className: 'fwd_img' },
								_react2.default.createElement('img', { alt: '', src: 'https://aquadeals.in/admin/assets/images/fwd_org.png', width: '15px' })
							)
						)
					);
				} else {
					pay_remaining_amount = '';
				}
	
				var other_amount_btn = '';
				if (this.state.other_amount_btn === 'yes') {
					other_amount_btn = _react2.default.createElement(
						'div',
						{ className: 'other_amount_btn' },
						_react2.default.createElement(
							'a',
							{ onClick: function onClick() {
									_this2.enableOtherAmount();
								} },
							'Pay Other Amount ',
							_react2.default.createElement(
								'i',
								{ className: 'fwd_img', style: { marginLeft: '11px' } },
								_react2.default.createElement('img', { alt: '', src: 'https://aquadeals.in/admin/assets/images/fwd_org.png', width: '15px' })
							)
						),
						this.state.other_amount_btn_status ? _react2.default.createElement(
							'span',
							{ className: 'ordr_dtls_6' },
							_react2.default.createElement('input', { onChange: function onChange() {
									return _this2.validateOtherAmount();
								}, ref: 'ref_other_amt', id: 'ref_other_amt', type: 'text', placeholder: 'Enter Amount' }),
							this.state.err_qty_status ? _react2.default.createElement(
								'span',
								{ className: 'error_other_amt' },
								this.state.err_qty_msg
							) : ''
						) : '',
						this.state.other_amount_btn_status ? _react2.default.createElement(
							'a',
							{ className: 'pay_other_btn', onClick: function onClick() {
									_this2.payOtherAmount();
								} },
							'PAY'
						) : ''
					);
				} else {
					other_amount_btn = '';
				}
				var cancel_reasons = this.state.cancel_reasons.map(function (data, index) {
					var _this3 = this;
	
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement('input', { type: 'radio', id: data.id, name: 'reason', className: 'cancel_radio', onClick: function onClick() {
								_this3.selectedReason(data.id, data.flag);
							} }),
						_react2.default.createElement(
							'span',
							null,
							data.reason
						),
						data.flag === '1' ? _react2.default.createElement(
							'div',
							{ className: 'other_reason_blk' },
							this.state.edit_input_status ? _react2.default.createElement('input', { type: 'text', name: 'other_reason', ref: 'other_reason', id: 'other_reason', placeholder: 'Enter any reason', value: this.state.edit_input, onChange: this.update_other_reason }) : ''
						) : ''
					);
				}.bind(this));
	
				var cancel_btn_status = this.state.details.status ? this.state.details.status : '';
				var cancel_btn = '';
				if (cancel_btn_status) {
					if (cancel_btn_status === "0" || cancel_btn_status === "4" || cancel_btn_status === "7") {
						cancel_btn = _react2.default.createElement(
							'div',
							{ className: 'web_ordr_ftr_blk', onClick: function onClick() {
									_this2.openCancelModal();
								} },
							_react2.default.createElement(
								'a',
								{ className: 'web_ordr_cncl_btn' },
								'CANCEL ORDER'
							)
						);
					} else {
						cancel_btn = '';
					}
				}
	
				var transport_info = '';
				if (this.state.details.driver_name !== '' && this.state.details.mobile !== '') {
	
					transport_info = _react2.default.createElement(
						'div',
						{ className: 'transport_info_blk' },
						_react2.default.createElement(
							'h5',
							null,
							'Transport Info'
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									null,
									this.state.transport_mode === '0' ? 'Driver Name' : 'Transport Area',
									' : '
								),
								' ',
								this.state.details ? this.state.details.driver_name : ''
							),
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									null,
									this.state.transport_mode === '0' ? 'Vehicle No' : 'Transport Name',
									' : '
								),
								this.state.details ? this.state.details.vehicle_no : ''
							),
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'a',
									{ href: this.state.details ? 'tel:+' + this.state.details.driver_mobile : '' },
									this.state.details ? this.state.details.driver_mobile : ''
								)
							),
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'a',
									{ href: this.state.details ? 'tel+' + this.state.details.alternate_number_driver : '' },
									this.state.details ? this.state.details.alternate_number_driver : ''
								)
							)
						)
					);
					// }
					// else
					// {
					// 	transport_info =<div><div className="clr">&nbsp;</div><div className="clr">&nbsp;</div><div className="clr">&nbsp;</div></div>;
					// }
				} else {
					// transport_info = <div><div className="clr">&nbsp;</div><div className="clr">&nbsp;</div><div className="clr">&nbsp;</div></div>;
					transport_info = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						)
					);
				}
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'web_deals web_order_details_page' },
						_react2.default.createElement(_WebHeaderInner2.default, null),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'section',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-12  webDels_cntnt' },
									_react2.default.createElement(
										'div',
										{ className: '' },
										this.state.page_error_status ? _react2.default.createElement(_Web_NotFound2.default, null) : _react2.default.createElement(
											'div',
											null,
											!this.state.page_loading ? _react2.default.createElement(
												'div',
												{ className: 'ordr_details_content' },
												_react2.default.createElement(
													'div',
													{ className: 'container-fluid', style: { marginTop: '25px' } },
													_react2.default.createElement(
														'h5',
														null,
														_react2.default.createElement(
															_reactRouter.Link,
															{ to: '/web/myorders' },
															_react2.default.createElement(
																'i',
																{ style: { marginRight: '15px' } },
																_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png', width: '16px', alt: '' })
															)
														),
														'Order ',
														this.state.details.booking_id,
														' Details '
													),
													_react2.default.createElement(
														'a',
														{ href: '/web/home', title: 'Home', className: 'web_home_icon1' },
														_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/home2.png', alt: 'Home' })
													)
												),
												_react2.default.createElement(
													'section',
													{ className: 'ordr_dtls_1' },
													_react2.default.createElement(
														'div',
														null,
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'span',
																null,
																this.state.details.booking_id
															),
															_react2.default.createElement(
																'span',
																{ className: 'right_side' },
																'\u20B9 ',
																this.state.details.total_discount
															)
														),
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'span',
																{ style: { fontSize: '10px' } },
																this.state.details.book_date
															),
															_react2.default.createElement(
																'span',
																{ className: 'order_details_status' },
																status
															)
														)
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'ordr_dtls_2' },
													this.state.items.length > 1 ? _react2.default.createElement(
														'p',
														null,
														'You have ',
														this.state.items.length,
														' items in your order'
													) : _react2.default.createElement(
														'p',
														null,
														'You have ',
														this.state.items.length,
														' item in your order'
													),
													order_items,
													this.state.total_data.progress_bar != "" ? _react2.default.createElement(
														'div',
														{ className: 'col-md-12 col-sm-12 col-xs-12 Web_order_progress-bar' },
														_react2.default.createElement(
															'i',
															null,
															_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/product_imgs/' + this.state.total_data.progress_bar, alt: '' })
														)
													) : ''
												),
												_react2.default.createElement(
													'div',
													{ className: '', style: { marginTop: '10px' } },
													_react2.default.createElement(
														'h5',
														{ className: 'ordr_header' },
														'ORDER SUMMARY'
													),
													_react2.default.createElement(
														'div',
														{ className: 'ordr_dtls_3' },
														_react2.default.createElement(
															'table',
															{ className: 'table cart_table' },
															_react2.default.createElement(
																'tr',
																{ className: 'cart_tr_total' },
																_react2.default.createElement(
																	'td',
																	null,
																	'Order Total'
																),
																_react2.default.createElement(
																	'td',
																	null,
																	'\u20B9 ',
																	this.state.details.total_amount
																)
															),
															this.state.aqua_cash1 && parseInt(this.state.aqua_cash1, 10) > 0 ? _react2.default.createElement(
																'tr',
																{ className: 'cart_tr' },
																_react2.default.createElement(
																	'td',
																	null,
																	'Aquacash Discount'
																),
																_react2.default.createElement(
																	'td',
																	null,
																	'(-) \u20B9 ',
																	this.state.aqua_cash
																)
															) : '',
															this.state.coupons_amt1 && parseInt(this.state.coupons_amt1, 10) > 0 ? _react2.default.createElement(
																'tr',
																{ className: 'cart_tr' },
																_react2.default.createElement(
																	'td',
																	null,
																	'Applicable Coupons'
																),
																_react2.default.createElement(
																	'td',
																	null,
																	'(-) \u20B9 ',
																	this.state.coupons_amt
																)
															) : '',
															this.state.seller_discount1 && parseInt(this.state.seller_discount1, 10) > 0 ? _react2.default.createElement(
																'tr',
																{ className: 'cart_tr' },
																_react2.default.createElement(
																	'td',
																	null,
																	'Seller Discount'
																),
																_react2.default.createElement(
																	'td',
																	null,
																	'(-) \u20B9 ',
																	this.state.seller_discount
																)
															) : '',
															this.state.promo_manf_value1 && parseInt(this.state.promo_manf_value1, 10) > 0 ? _react2.default.createElement(
																'tr',
																{ className: 'cart_tr' },
																_react2.default.createElement(
																	'td',
																	null,
																	'Promo Discount'
																),
																_react2.default.createElement(
																	'td',
																	null,
																	'(-) \u20B9 ',
																	this.state.promo_manf_value
																)
															) : '',
															this.state.promo_hatch_value1 && parseInt(this.state.promo_hatch_value1, 10) > 0 ? _react2.default.createElement(
																'tr',
																{ className: 'cart_tr' },
																_react2.default.createElement(
																	'td',
																	null,
																	'Promo Discount'
																),
																_react2.default.createElement(
																	'td',
																	null,
																	'(-) \u20B9 ',
																	this.state.promo_hatch_value
																)
															) : '',
															_react2.default.createElement(
																'tr',
																{ className: 'cart_tr_grandtotal' },
																_react2.default.createElement(
																	'td',
																	null,
																	'\xA0'
																),
																_react2.default.createElement(
																	'td',
																	null,
																	'Total \xA0 \xA0 \u20B9 ',
																	this.state.details.total_discount
																)
															)
														)
													)
												),
												this.state.payment_details.length > 0 ? _react2.default.createElement(
													'div',
													{ style: { marginTop: '10px' } },
													_react2.default.createElement(
														'h5',
														{ className: 'ordr_header' },
														'PAYMENT DETAILS'
													),
													this.state.payment_details.map(function (item, index) {
														return _react2.default.createElement(
															'h5',
															{ className: 'ordr_dtls_4' },
															_react2.default.createElement(
																'span',
																null,
																item.title
															),
															_react2.default.createElement(
																'span',
																{ style: { float: 'right' } },
																'\u20B9 ',
																item.value
															)
														);
													})
												) : '',
												payment_log.length > 0 ? _react2.default.createElement(
													'div',
													null,
													_react2.default.createElement(
														'h5',
														{ className: 'ordr_header' },
														'PAYMENT HISTORY'
													),
													payment_log
												) : '',
												pay_remaining_amount ? _react2.default.createElement(
													'div',
													{ className: 'payment_options' },
													pay_remaining_amount
												) : '',
												other_amount_btn ? other_amount_btn : '',
												_react2.default.createElement(
													'div',
													null,
													_react2.default.createElement(
														'h5',
														{ className: 'ordr_header' },
														'SHIPPING AND DELIVERY'
													),
													_react2.default.createElement(
														'div',
														null,
														this.state.ship_dlvr_blck.map(function (data, index) {
															var _this4 = this;
	
															return _react2.default.createElement(
																'div',
																{ className: 'ship_del_blk' },
																_react2.default.createElement(
																	'h5',
																	null,
																	_react2.default.createElement(
																		'span',
																		null,
																		data.shipment_charge ? 'Shipping Charge' : ''
																	),
																	this.state.ship_cc_pay === 1 ? _react2.default.createElement(
																		'span',
																		{ className: 'ship_pay_now_btn', onClick: function onClick() {
																				_this4.shippingPayNow();
																			} },
																		data.shipment_charge ? data.shipment_charge : ''
																	) : _react2.default.createElement(
																		'span',
																		{ className: 'right_side' },
																		data.shipment_charge ? data.shipment_charge : ''
																	)
																),
																_react2.default.createElement(
																	'h5',
																	null,
																	_react2.default.createElement(
																		'span',
																		null,
																		data.deliver_date ? 'Delivery Date' : ''
																	),
																	_react2.default.createElement(
																		'span',
																		{ className: 'right_side' },
																		data.deliver_date ? data.deliver_date : ''
																	)
																)
															);
														}.bind(this))
													)
												),
												shipment_log.length > 0 ? _react2.default.createElement(
													'div',
													null,
													_react2.default.createElement(
														'h5',
														{ className: 'ordr_header' },
														'SHIPPING PAYMENT HISTORY'
													),
													shipment_log
												) : '',
												_react2.default.createElement(
													'div',
													{ className: 'ship_adrs_blk' },
													_react2.default.createElement(
														'h5',
														{ className: 'ordr_header' },
														'SHIPPING ADDRESS'
													),
													_react2.default.createElement(
														'div',
														null,
														_react2.default.createElement(
															'p',
															null,
															this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].name : ''
														),
														_react2.default.createElement(
															'p',
															null,
															this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].address : ''
														),
														_react2.default.createElement(
															'p',
															null,
															this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].city : '',
															' , ',
															this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].state : ''
														),
														_react2.default.createElement(
															'p',
															null,
															this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].zip : ''
														),
														_react2.default.createElement(
															'p',
															{ style: { color: '#ff742a' } },
															_react2.default.createElement(
																'a',
																{ href: this.state.total_data.shipping_address ? 'tel:+' + this.state.total_data.shipping_address[0].mobile : '' },
																this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].mobile : ''
															)
														)
													)
												),
												transport_info,
												this.state.cancel_by !== '' ? _react2.default.createElement(
													'div',
													null,
													_react2.default.createElement(
														'h5',
														{ className: 'ordr_header' },
														'CANCELLATION DETAILS'
													),
													_react2.default.createElement(
														'div',
														{ style: { padding: '10px' } },
														this.state.cancel_by ? _react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'span',
																null,
																'Cancelled by '
															),
															_react2.default.createElement(
																'span',
																{ style: { float: 'right' } },
																this.state.cancel_by
															)
														) : '',
														this.state.cancel_time ? _react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'span',
																null,
																'Date & Time '
															),
															_react2.default.createElement(
																'span',
																{ style: { float: 'right' } },
																this.state.cancel_time
															)
														) : '',
														this.state.cancel_reason ? _react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'span',
																null,
																'Reason'
															),
															_react2.default.createElement(
																'span',
																{ style: { float: 'right' } },
																this.state.cancel_reason
															)
														) : ''
													)
												) : '',
												_react2.default.createElement(
													_reactBootstrap.Modal,
													{ className: 'order_confirm_modal', show: this.state.confirm_modal, onHide: this.close },
													_react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
													_react2.default.createElement(
														_reactBootstrap.Modal.Body,
														null,
														_react2.default.createElement(
															'h4',
															{ className: 'order_confirm_title' },
															'Are You Sure?'
														),
														_react2.default.createElement(
															'p',
															null,
															'You are paying full amount !'
														)
													),
													_react2.default.createElement(
														_reactBootstrap.Modal.Footer,
														{ className: 'modal_footer' },
														_react2.default.createElement(
															'a',
															{ onClick: function onClick() {
																	_this2.payNow();
																} },
															_react2.default.createElement(
																_reactBootstrap.Button,
																{ style: { background: '#ff742a none repeat scroll 0 0', color: '#fff' } },
																'Yes, I will pay'
															)
														)
													)
												),
												this.state.details.status === '2' || this.state.details.status === '6' ? _react2.default.createElement(
													'div',
													{ className: 'web_ordr_ftr_blk' },
													this.state.rate_flag === 2 ? _react2.default.createElement(
														_reactRouter.Link,
														{ className: 'ordr_view_rate_btn', to: this.props.params.OrderType === '1' ? '/web/viewrating/product/' + this.props.params.Oid : '/web/viewrating/' + this.props.params.Oid },
														'View Rating'
													) : '',
													this.state.rate_flag === 1 ? _react2.default.createElement(
														_reactRouter.Link,
														{ className: 'ordr_give_rate_btn', to: this.props.params.OrderType === '1' ? '/web/giverating/product/' + this.props.params.Oid : '/web/giverating/' + this.props.params.Oid },
														'Give Rating'
													) : ''
												) : '',
												cancel_btn,
												_react2.default.createElement(
													_reactBootstrap.Modal,
													{ onEntered: function onEntered() {
															_this2.getCancelDetails();
														}, className: '', show: this.state.cancel_modal_status, onHide: this.close },
													_react2.default.createElement(
														_reactBootstrap.Modal.Header,
														{ className: 'modal_offer_header', closeButton: true },
														_react2.default.createElement(
															_reactBootstrap.Modal.Title,
															{ className: 'm_title', style: { textAlign: 'center', color: '#fff' } },
															'Order Cancellation'
														)
													),
													_react2.default.createElement(
														_reactBootstrap.Modal.Body,
														null,
														_react2.default.createElement(
															'div',
															null,
															_react2.default.createElement(
																'p',
																null,
																'Do you want to cancel this Order?'
															),
															_react2.default.createElement(
																'form',
																{ className: 'cancel_reasons_form', onSubmit: this.handleCancel_Submit },
																_react2.default.createElement(
																	'div',
																	{ className: '' },
																	cancel_reasons
																),
																_react2.default.createElement(
																	'div',
																	null,
																	_react2.default.createElement(
																		'div',
																		{ className: 'modal-footer' },
																		_react2.default.createElement(
																			'a',
																			{ className: 'cancel_no_btn', onClick: this.close },
																			'No'
																		),
																		_react2.default.createElement(
																			'button',
																			{ type: 'submit', className: 'cancel_yes_btn' },
																			'Yes'
																		)
																	)
																)
															)
														)
													)
												),
												_react2.default.createElement(
													_reactBootstrap.Modal,
													{ className: 'showModal', show: this.state.cancel_success_status, onHide: this.close },
													_react2.default.createElement(
														_reactBootstrap.Modal.Body,
														null,
														_react2.default.createElement(
															'h4',
															{ style: { fontSize: '14px', color: '#666', textAlign: 'center' } },
															this.state.cancel_success_msg
														)
													)
												)
											) : _react2.default.createElement(
												'div',
												{ className: 'page_loading' },
												_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/loading_more.gif', alt: 'Loading' })
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_Order_Details;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			rzp_keys: state.posts.rzp_keys
		};
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Web_Order_Details);

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _custom_functions = __webpack_require__(83);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// /shipping_payment/:Type/:Book_Id/:Uid
	
	var Web_Shipping_Payment = function (_Component) {
		_inherits(Web_Shipping_Payment, _Component);
	
		function Web_Shipping_Payment(props) {
			_classCallCheck(this, Web_Shipping_Payment);
	
			var _this = _possibleConstructorReturn(this, (Web_Shipping_Payment.__proto__ || Object.getPrototypeOf(Web_Shipping_Payment)).call(this, props));
	
			_this.state = {
				pre_payment_id: '',
				order_id: '',
				paid_amt: '',
				book_type: '',
	
				shipaddress: [],
				username: '',
				address: '',
				city: '',
				state: '',
				pincode: '',
				mobile: '',
				email: '',
	
				payment_details: '',
				pros: [],
				shipment_details: '',
				deal_type: '',
				booking_data: [],
				tot_data: [],
				billing_status: false,
				page_error_status: false,
				pageId: '.web_shipping_payment_page'
			};
			_this.getShippingDetails = _this.getShippingDetails.bind(_this);
			_this.enableBillingDetails = _this.enableBillingDetails.bind(_this);
			return _this;
		}
	
		_createClass(Web_Shipping_Payment, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
				localStorage.removeItem('checkout');
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
	
				localStorage.removeItem('notifications');
				localStorage.removeItem('web_quickcart');
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
				localStorage.removeItem('web_brand_details');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
				if (screen.width < 800) {
					//window.location.href='/shipping_payment/'+this.props.params.Type+'/'+this.props.params.Book_Id+'/'+this.props.params.Uid;
					window.location.href = '/shipping_payment/' + this.props.params.Type + '/' + this.props.params.Book_Id + '/' + this.props.params.Uid;
				}
				if (!localStorage.token && !localStorage.user_id) {
					localStorage.setItem('shipping', '/web/shipping_payment/' + this.props.params.Type + '/' + this.props.params.Book_Id + '/' + this.props.params.Uid);
					_reactRouter.browserHistory.push('/web/login');
				} else {
					this.getShippingDetails();
				}
			}
		}, {
			key: 'enableBillingDetails',
			value: function enableBillingDetails() {
				this.setState({
					billing_status: true
				});
			}
		}, {
			key: 'getShippingDetails',
			value: function getShippingDetails() {
				var id = '';
				if (localStorage.user_id) {
					id = localStorage.user_id;
				} else {
					id = 0;
				}
	
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, bid: this.props.params.Book_Id, type: this.props.params.Type, pid: this.props.params.Uid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'get_shipment_stat',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								payment_details: data.payment_details,
								pros: data.pros,
								shipment_details: data.shipment_details,
								deal_type: data.deal_type,
								booking_data: data.booking_data,
								tot_data: data
							});
						} else if (data.status === 'error' && data.message === 'You are not authorized') {
							this.setState({
								page_error_status: true
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var that = this;
				setTimeout(function () {
					that.enableBillingDetails();
				}, 3000);
			}
			// payNow(book_id,paid_amt,pay_type,book_type,u_name,u_address,u_phone,u_zip,u_city,u_state,u_email)
	
		}, {
			key: 'payNow',
			value: function payNow() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, bid: this.props.params.Book_Id, type: this.props.params.Type, pid: this.props.params.Uid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'ship_payment_temp_process',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							pre_payment_id: data.pre_payment_id,
							order_id: data.order_id,
							paid_amt: data.paid_amt,
							book_type: data.book_type,
	
							username: data.shipaddress[0].name,
							address: data.shipaddress[0].address,
							city: data.shipaddress[0].city,
							state: data.shipaddress[0].state,
							pincode: data.shipaddress[0].zip,
							mobile: data.shipaddress[0].phone,
							email: data.shipaddress[0].email,
							gateway_mode: data.gateway_mode
	
						});
						var payment_params = { from: 'desktop_web',
							uid: localStorage.getItem('user_id'),
							pre_payment_id: this.state.pre_payment_id,
							order_id: this.state.order_id,
							deal_type: this.state.book_type,
							cart_ids: '',
							paid_amt: this.state.paid_amt,
							username: this.state.username,
							address: this.state.address,
							city: this.state.city,
							state: this.state.state,
							pincode: this.state.pincode,
							mobile: this.state.mobile,
							country: 'India',
							email: this.state.email,
							cart_add_id: 'shipping_amt',
							pageId: this.state.pageId,
							rzp_key: this.props.rzp_keys.key_id };
						if (this.state.gateway_mode == 2) {
							(0, _custom_functions.razorpayForm)(payment_params);
							this.setState({
								page_loading: false
							});
						} else {
							(0, _custom_functions.ccAvenue)(payment_params);
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
	
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				document.title = "Shipping Payment | AquaDeals";
				var pay_details = '';
				if (this.state.pros.length > 0) {
					if (this.state.deal_type === '1') {
						var products = this.state.pros.map(function (order, index) {
							return _react2.default.createElement(
								'div',
								{ className: '' },
								_react2.default.createElement(
									'div',
									{ className: 'order_list_items' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-12 col-md-12 order_subitems' },
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-3 col-md-3', style: { padding: '0px', textAlign: 'center' } },
											_react2.default.createElement(
												'i',
												{ className: 'order_icon' },
												_react2.default.createElement('img', { src: order.image, alt: '' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-9 col-md-9', style: { padding: '0px' } },
											_react2.default.createElement(
												'p',
												null,
												order.title
											),
											_react2.default.createElement(
												'p',
												null,
												_react2.default.createElement(
													'span',
													{ style: { fontSize: '10px', color: '#999' } },
													order.brand
												),
												_react2.default.createElement(
													'span',
													{ style: { float: 'right' } },
													'\u20B9 ',
													order.total_amount
												)
											),
											_react2.default.createElement(
												'p',
												null,
												'Price \u20B9 ',
												order.mrp,
												' ',
												_react2.default.createElement(
													'span',
													null,
													'Quantity ',
													order.quantity,
													' '
												),
												' '
											)
										)
									)
								)
							);
						});
					} else {
						products = this.state.pros.map(function (order, index) {
							return _react2.default.createElement(
								'div',
								{ className: '' },
								_react2.default.createElement(
									'div',
									{ className: 'order_list_items' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-12 col-md-12 order_subitems' },
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-2 col-md-2', style: { padding: '0px' } },
											_react2.default.createElement(
												'i',
												{ className: 'seed_order_icon' },
												_react2.default.createElement('img', { src: order.image, alt: '' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-10 col-md-10', style: { padding: '0px' } },
											_react2.default.createElement(
												'p',
												{ style: { color: '#333' } },
												order.specie
											),
											_react2.default.createElement(
												'p',
												null,
												_react2.default.createElement(
													'span',
													{ style: { float: 'right' } },
													'\u20B9 ',
													order.total_amount
												)
											),
											_react2.default.createElement(
												'p',
												{ style: { color: '#999' } },
												_react2.default.createElement(
													'span',
													null,
													'Plsize'
												),
												'\xA0',
												_react2.default.createElement(
													'span',
													null,
													order.plsize
												),
												'\xA0',
												_react2.default.createElement(
													'span',
													null,
													'Salinity'
												),
												'\xA0',
												_react2.default.createElement(
													'span',
													null,
													order.salinity
												)
											),
											_react2.default.createElement(
												'p',
												null,
												'Price \u20B9 ',
												order.mrp,
												' ',
												_react2.default.createElement(
													'span',
													null,
													'Quantity ',
													order.quantity
												)
											)
										)
									)
								)
							);
						});
					}
				}
	
				if (this.state.shipment_details.length > 0) {
					var shipment_details = _react2.default.createElement(
						'div',
						{ style: { marginTop: '10px' } },
						_react2.default.createElement(
							'h5',
							{ className: 'ordr_header' },
							'SHIPPING DETAILS'
						),
						this.state.shipment_details.map(function (item, index) {
							return _react2.default.createElement(
								'h5',
								{ className: 'ordr_dtls_4' },
								_react2.default.createElement(
									'span',
									null,
									item.title
								),
								_react2.default.createElement(
									'span',
									{ style: { float: 'right' } },
									'\u20B9 ',
									item.value
								)
							);
						})
					);
				} else {
					shipment_details = '';
				}
	
				var status = '';
				if (this.state.tot_data) {
					if (this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].status === '0' || this.state.tot_data.booking_data[0] === '4' || this.state.tot_data.booking_data[0].status === '7' : '') {
						status = 'Order Placed';
					} else if (this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].status === '1' : '') {
						status = 'Processing';
					} else if (this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].status === '3' : '') {
						status = 'Cancelled';
					} else if (this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].status === '5' : '') {
						status = 'Shipping';
					} else if (this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].status === '6' : '') {
						status = 'Delivered';
					}
				}
	
				var b_id = this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].booking_id : '';
				var total_discount = this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].total_discount : '';
				var book_date = this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].created_on : '';
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_shipping_payment_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'web_ship_dtls_cnt_blk' },
						_react2.default.createElement(
							'section',
							{ className: 'container' },
							this.state.page_error_status ? _react2.default.createElement(
								'div',
								{ className: 'ship_error_block' },
								_react2.default.createElement(
									'h4',
									null,
									'You are not authorized'
								),
								_react2.default.createElement(
									'a',
									{ href: '/web/home' },
									'Explore Deals'
								)
							) : _react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-md-offset-3 dels_cntnt' },
									_react2.default.createElement(
										'div',
										{ className: 'container-fluid' },
										_react2.default.createElement(
											'h5',
											null,
											_react2.default.createElement(
												_reactRouter.Link,
												{ onClick: function onClick() {
														_reactRouter.browserHistory.goBack();
													}, style: { cursor: 'pointer' } },
												_react2.default.createElement(
													'i',
													null,
													_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png', width: '16px', alt: ' ' })
												)
											),
											' \xA0 Shipping Payment'
										),
										_react2.default.createElement(
											'a',
											{ href: '/web/home', title: 'Home', className: 'web_home_icon' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/home2.png', alt: 'Home' })
										)
									),
									_react2.default.createElement(
										'section',
										{ className: 'ordr_dtls_1' },
										this.state.booking_data ? _react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(
												'p',
												null,
												_react2.default.createElement(
													'span',
													null,
													b_id
												),
												_react2.default.createElement(
													'span',
													{ className: 'right_side' },
													'\u20B9 ',
													total_discount
												)
											),
											_react2.default.createElement(
												'p',
												null,
												_react2.default.createElement(
													'span',
													{ style: { fontSize: '10px' } },
													book_date
												),
												_react2.default.createElement(
													'span',
													{ className: 'order_details_status' },
													status
												)
											)
										) : ''
									),
									_react2.default.createElement(
										'div',
										{ className: 'web_ship_dtls_pro_blk' },
										this.state.pros.length > 1 ? _react2.default.createElement(
											'p',
											{ style: { paddingLeft: '10px', marginTop: '5px' } },
											'You have ',
											this.state.pros.length,
											' items in your order'
										) : _react2.default.createElement(
											'p',
											{ style: { paddingLeft: '10px', marginTop: '5px' } },
											'You have ',
											this.state.pros.length,
											' item in your order'
										),
										products,
										this.state.tot_data.progress_bar ? _react2.default.createElement(
											'div',
											{ className: 'col-md-12 col-sm-12 col-xs-12' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/product_imgs/' + this.state.tot_data.progress_bar, alt: '' })
											)
										) : ''
									),
									_react2.default.createElement(
										'div',
										{ className: '', style: { marginTop: '10px' } },
										_react2.default.createElement(
											'h5',
											{ className: 'ordr_header' },
											'ORDER SUMMARY'
										),
										this.state.billing_status ? _react2.default.createElement(
											'div',
											{ className: 'ordr_dtls_3' },
											_react2.default.createElement(
												'table',
												{ className: 'table cart_table' },
												_react2.default.createElement(
													'tr',
													{ className: 'cart_tr_total' },
													_react2.default.createElement(
														'td',
														null,
														'Order Total'
													),
													_react2.default.createElement(
														'td',
														null,
														'\u20B9 ',
														this.state.tot_data.total_amount
													)
												),
												this.state.tot_data.aqua_cash1 && parseInt(this.state.tot_data.aqua_cash1, 10) > 0 ? _react2.default.createElement(
													'tr',
													{ className: 'cart_tr' },
													_react2.default.createElement(
														'td',
														null,
														'Aquacash Discount'
													),
													_react2.default.createElement(
														'td',
														null,
														'(-) \u20B9 ',
														this.state.tot_data.aqua_cash
													)
												) : '',
												this.state.tot_data.coupons_amt1 && parseInt(this.state.tot_data.coupons_amt1, 10) > 0 ? _react2.default.createElement(
													'tr',
													{ className: 'cart_tr' },
													_react2.default.createElement(
														'td',
														null,
														'Applicable Coupons'
													),
													_react2.default.createElement(
														'td',
														null,
														'(-) \u20B9 ',
														this.state.tot_data.coupons_amt
													)
												) : '',
												this.state.tot_data.seller_discount1 && parseInt(this.state.tot_data.seller_discount1, 10) > 0 ? _react2.default.createElement(
													'tr',
													{ className: 'cart_tr' },
													_react2.default.createElement(
														'td',
														null,
														'Seller Discount'
													),
													_react2.default.createElement(
														'td',
														null,
														'(-) \u20B9 ',
														this.state.tot_data.seller_discount
													)
												) : '',
												this.state.tot_data.promo_manf_value1 && parseInt(this.state.tot_data.promo_manf_value1, 10) > 0 ? _react2.default.createElement(
													'tr',
													{ className: 'cart_tr' },
													_react2.default.createElement(
														'td',
														null,
														'Promo Discount'
													),
													_react2.default.createElement(
														'td',
														null,
														'(-) \u20B9 ',
														this.state.tot_data.promo_manf_value
													)
												) : '',
												this.state.tot_data.promo_hatch_value1 && parseInt(this.state.tot_data.promo_hatch_value1, 10) > 0 ? _react2.default.createElement(
													'tr',
													{ className: 'cart_tr' },
													_react2.default.createElement(
														'td',
														null,
														'Promo Discount'
													),
													_react2.default.createElement(
														'td',
														null,
														'(-) \u20B9 ',
														this.state.tot_data.promo_hatch_value
													)
												) : '',
												_react2.default.createElement(
													'tr',
													{ className: 'cart_tr_grandtotal' },
													_react2.default.createElement(
														'td',
														null,
														'\xA0'
													),
													_react2.default.createElement(
														'td',
														null,
														'Total \xA0 \xA0 \u20B9 ',
														this.state.tot_data.total_discount
													)
												),
												this.state.tot_data.ship_value1 && parseInt(this.state.tot_data.ship_value1, 10) > 0 ? _react2.default.createElement(
													'tr',
													{ className: 'web_ship_grandtotal' },
													_react2.default.createElement(
														'td',
														null,
														'You need to pay shipping charges'
													),
													_react2.default.createElement(
														'td',
														null,
														'(+) \u20B9 ',
														this.state.tot_data.ship_value
													)
												) : ''
											)
										) : _react2.default.createElement(
											'div',
											{ className: 'price_loading' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/loading_more.gif', alt: 'Loading' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'web_ship_pay_blk' },
										_react2.default.createElement(
											'a',
											{ className: 'web_ship_pay_btn', onClick: function onClick() {
													_this2.payNow();
												} },
											'PAY NOW'
										)
									)
								)
							)
						),
						_react2.default.createElement(_WebFooter2.default, null)
					)
				);
			}
		}]);
	
		return Web_Shipping_Payment;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			rzp_keys: state.posts.rzp_keys
		};
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Web_Shipping_Payment);

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import {Link} from 'react-router';
	
	
	var Web_Shipping_Status = function (_Component) {
		_inherits(Web_Shipping_Status, _Component);
	
		function Web_Shipping_Status() {
			_classCallCheck(this, Web_Shipping_Status);
	
			return _possibleConstructorReturn(this, (Web_Shipping_Status.__proto__ || Object.getPrototypeOf(Web_Shipping_Status)).apply(this, arguments));
		}
	
		_createClass(Web_Shipping_Status, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width < 800) {
					window.location.href = "/payment_status/" + this.props.params.Status;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = "Payment Status | AquaDeals";
				var status_title = _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'h4',
						null,
						'Something went wrong'
					),
					_react2.default.createElement(
						'a',
						{ href: '/web/home', className: 'web_expl_btn' },
						'Explore Deals'
					)
				);
				if (this.props.params.Status === 'aborted') {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Transaction Aborted'
						),
						_react2.default.createElement(
							'a',
							{ href: '/web/home', className: 'web_expl_btn' },
							'Explore Deals'
						)
					);
				} else if (this.props.params.Status === 'success') {
					if (this.props.params.OrderType && this.props.params.Oid) {
						status_title = _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'i',
								null,
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/conformed.png', width: '70px', alt: '' })
							),
							_react2.default.createElement(
								'h5',
								{ style: { marginTop: '10px', marginBottom: '30px' } },
								'Shipping Payment Completed Successfully'
							),
							_react2.default.createElement(
								'a',
								{ href: '/web/order_details/' + this.props.params.OrderType + '/' + this.props.params.Oid },
								'View Order Details'
							)
						);
					} else {
						status_title = _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'i',
								null,
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/conformed.png', width: '70px', alt: '' })
							),
							_react2.default.createElement(
								'h5',
								{ style: { marginTop: '10px', marginBottom: '30px' } },
								'Shipping Payment Completed Successfully'
							),
							_react2.default.createElement(
								'a',
								{ href: '/web/home' },
								'Explore Deals'
							)
						);
					}
				} else if (this.props.params.Status === 'failure') {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Transaction Failed'
						),
						_react2.default.createElement(
							'a',
							{ href: '/web/home', className: 'web_expl_btn' },
							'Explore Deals'
						)
					);
				} else if (this.props.params.Status === 'invalid') {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Invalid Transaction'
						),
						_react2.default.createElement(
							'a',
							{ href: '/web/home', className: 'web_expl_btn' },
							'Explore Deals'
						)
					);
				} else if (this.props.params.Status === 'serverDown') {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Server Down'
						),
						_react2.default.createElement(
							'a',
							{ href: '/web/home', className: 'web_expl_btn' },
							'Explore Deals'
						)
					);
				} else {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Something went wrong !'
						),
						_react2.default.createElement(
							'a',
							{ href: '/web/home', className: 'web_expl_btn' },
							'Explore Deals'
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_shipping_status_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-6 col-md-offset-3 web_dels_cntnt' },
								_react2.default.createElement(
									'div',
									{ className: 'web_abort_content' },
									status_title ? status_title : _react2.default.createElement(
										'h4',
										null,
										'Something went wrong'
									)
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_Shipping_Status;
	}(_react.Component);
	
	exports.default = Web_Shipping_Status;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var WebRecommended = function (_Component) {
		_inherits(WebRecommended, _Component);
	
		function WebRecommended(props) {
			_classCallCheck(this, WebRecommended);
	
			var _this = _possibleConstructorReturn(this, (WebRecommended.__proto__ || Object.getPrototypeOf(WebRecommended)).call(this, props));
	
			_this.state = {
				tot_data: [],
				product_offers: [],
				seed_offers: [],
				offers: [],
				status: '',
				suggetions: [],
				pro_recommended: []
			};
			_this.getOffers = _this.getOffers.bind(_this);
			_this.goPrev = _this.goPrev.bind(_this);
			_this.goNext = _this.goNext.bind(_this);
			_this.swiper = null;
			return _this;
		}
	
		_createClass(WebRecommended, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.getOffers();
				this.props.recommendedforyou();
			}
			//   componentWillMount(){
			// this.props.recommendedforyou();
			// if(this.props.recommended.suggetions)
			// {
			// 			this.setState({
			// 				suggetions: this.props.recommended.suggetions,
			// 			})			
			// }		
			//   }	
	
		}, {
			key: 'getOffers',
			value: function getOffers() {
				var data1 = { from: 'desktop_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getOffers',
					success: function (data) {
						if (data.status === 'available') {
							this.setState({
								tot_data: data,
								product_offers: data.product_offers,
								seed_offers: data.seed_offers,
								offers: data.offers,
								status: 'available'
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'goNext',
			value: function goNext() {
				if (this.swiper) this.swiper.slideNext();
			}
		}, {
			key: 'goPrev',
			value: function goPrev() {
				if (this.swiper) this.swiper.slidePrev();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var params = {
					paginationClickable: true,
					spaceBetween: 10,
					slidesPerView: 2.8,
					// autoplay:3000,
					autoplayDisableOnInteraction: false,
					// loop:true,
					// pagination: '.swiper-pagination'
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					observer: true,
					rebuildOnUpdate: true
				};
				var recommended = this.props.recommended.suggetions;
	
				if (this.props.recommended.suggetions) {
	
					var pro_recommended = recommended.map(function (product, index) {
						return _react2.default.createElement(
							_reactRouter.Link,
							{ className: 'web_promo_ofr_item', to: "web/" + product.redirect_url },
							_react2.default.createElement(
								'div',
								{ className: 'web_promo_product_ofer_icon' },
								_react2.default.createElement('img', { style: { paddingTop: '5px' }, src: product.logo, alt: '' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'web_rec_product_cntnt' },
								product.product ? _react2.default.createElement(
									'h5',
									{ className: 'web_promo_product_title' },
									product.product
								) : _react2.default.createElement(
									'h5',
									null,
									'\xA0'
								),
								product.mrp ? _react2.default.createElement(
									'h6',
									{ className: 'web_promo_product_desc web_rec_product_desc' },
									'MRP \u20B9',
									product.mrp
								) : _react2.default.createElement(
									'h6',
									null,
									'\xA0'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'web_promo_ofer_arrow' },
								_react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
							)
						);
					});
				}
	
				var product_offers = this.state.product_offers.map(function (product, index) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ className: 'web_promo_ofr_item', to: "/web/pdetails/" + product.url_dtype_name + "/" + product.url_cat_name + "/" + product.url_brand_name + "/" + product.url_product_name + "/" + product.product_id + "/" + product.deal_id },
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_product_ofer_icon' },
							_react2.default.createElement('img', { style: { paddingTop: '5px' }, src: product.img, alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_product_cntnt' },
							product.title ? _react2.default.createElement(
								'h5',
								{ className: 'web_promo_product_title' },
								product.title
							) : _react2.default.createElement(
								'h5',
								null,
								'\xA0'
							),
							product.desc ? _react2.default.createElement(
								'h6',
								{ className: 'web_promo_product_desc' },
								product.desc
							) : _react2.default.createElement(
								'h6',
								null,
								'\xA0'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_ofer_arrow' },
							_react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
						)
					);
				});
				var seed_offers = this.state.seed_offers.map(function (seed, index) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ className: 'web_promo_ofr_item', to: "/web/sdetails/" + seed.url_title + "/" + seed.deal_id },
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_seed_ofer_icon' },
							_react2.default.createElement('img', { style: { paddingTop: '5px' }, src: seed.img, alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_seed_ofer_cntnt' },
							seed.title ? _react2.default.createElement(
								'h5',
								{ className: 'web_promo_seed_title' },
								seed.title
							) : _react2.default.createElement(
								'h5',
								{ className: 'web_promo_seed_title' },
								'\xA0'
							),
							seed.desc ? _react2.default.createElement(
								'h6',
								{ className: 'web_promo_seed_desc' },
								seed.desc
							) : _react2.default.createElement(
								'h6',
								{ className: 'web_promo_seed_desc' },
								'\xA0'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_ofer_arrow' },
							_react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
						)
					);
				});
				var offers = this.state.offers.map(function (offer, index) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ className: 'web_promo_ofr_item', to: '/web/offer/' + offer.id + "/details" },
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_gen_ofer_icon' },
							_react2.default.createElement('img', { src: offer.img === '' ? baseAssets + 'icons/web_icons/offer-icon.png' : offer.img, alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_gen_ofer_cntnt' },
							offer.title ? _react2.default.createElement(
								'h5',
								{ className: 'web_gen_title' },
								offer.title
							) : _react2.default.createElement(
								'h5',
								{ className: 'web_gen_title' },
								'\xA0'
							),
							offer.desc ? _react2.default.createElement(
								'h6',
								{ className: 'web_gen_desc' },
								offer.desc
							) : _react2.default.createElement(
								'h6',
								{ className: 'web_gen_desc' },
								'\xA0'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'web_promo_gen_ofer_arrow' },
							_react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
						)
					);
				});
				return _react2.default.createElement(
					'section',
					{ className: 'container web_promo_blks' },
					_react2.default.createElement(
						'div',
						null,
						this.props.recommended.suggetions != '' ? _react2.default.createElement(
							'div',
							{ className: '' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-6 col-md-6 col-sm-6 text-left' },
									_react2.default.createElement(
										'h4',
										{ className: 'web_blk_titles' },
										this.props.recommended.suggetions != '' ? 'RECOMMENDED FOR YOU' : ''
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-sm-6 col-md-6 col-lg-6 pull-right' },
									_react2.default.createElement(
										'div',
										{ className: 'pro_sld_ctrls' },
										_react2.default.createElement(
											'a',
											{ className: 'left carousel-control pro_sld_lft', onClick: this.goPrev },
											_react2.default.createElement(
												'span',
												{ className: 'pro_sld_arow', 'aria-hidden': 'true' },
												_react2.default.createElement('img', { src: baseAssets + 'images_web/left_arrow.png', alt: '' })
											),
											_react2.default.createElement(
												'span',
												{ className: 'sr-only' },
												'Previous'
											)
										),
										_react2.default.createElement(
											'a',
											{ className: 'right carousel-control pro_sld_rgt', onClick: this.goNext },
											_react2.default.createElement(
												'span',
												{ className: 'pro_sld_arow', 'aria-hidden': 'true' },
												_react2.default.createElement('img', { src: baseAssets + 'images_web/right_arrow.png', alt: '' })
											),
											_react2.default.createElement(
												'span',
												{ className: 'sr-only' },
												'Next'
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'webpromotions_page1 web_promo_blk_items' },
								_react2.default.createElement(
									'div',
									{ style: { marginTop: '15px', marginBottom: '15px' } },
									_react2.default.createElement(
										_reactIdSwiper2.default,
										_extends({}, params, { key: this.state.suggetions, ref: function ref(node) {
												return node ? _this2.swiper = node.swiper : '';
											} }),
										pro_recommended
									)
								)
							)
						) : ''
					)
				);
			}
		}]);
	
		return WebRecommended;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			recommended: state.posts.recommended
		};
	}
	
	function mapDispatchToProps(dispatch) {
		return (0, _reactRedux.bindActionCreators)({ actions: actions }, dispatch);
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(WebRecommended);

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _reactWebVectorIcons = __webpack_require__(29);
	
	var _reactWebVectorIcons2 = _interopRequireDefault(_reactWebVectorIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var parseHtml = __webpack_require__(39);
	
	
	// import Footer from './../Common/footer';
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Web_QuickCart = function (_Component) {
		_inherits(Web_QuickCart, _Component);
	
		function Web_QuickCart(props) {
			_classCallCheck(this, Web_QuickCart);
	
			var _this = _possibleConstructorReturn(this, (Web_QuickCart.__proto__ || Object.getPrototypeOf(Web_QuickCart)).call(this, props));
	
			_this.state = {};
			_this.state = {
				total: '',
				cartcount: '',
				grandtotal: '',
				items: [],
				aqua_cash: '',
				used_cash: '',
				used_cash1: '',
				ac_discount: '',
				coupons_amt: '',
				coupons_amt1: '',
				grand_total: '',
				openModal: false,
				applied_coupons: '',
				applied_coupons1: '',
				coupon_ref: '',
				coupon_err_msg: '',
				coupon_err_status: false,
				updateModal: false,
				coupon_success_status: false,
				coupon_success_msg: '',
				coupon_success_value: '',
				delete_status: false,
				delete_status_id: '',
	
				qty: '',
				min_qty: '',
				max_qty: '',
				cart_id: '',
				err_qty_status: false,
				err_qty_msg: '',
				coupons: [],
				billing_status: false,
	
				proceedCheck: 0,
				proceedMsg: '',
				ac_enough_msg: '',
				loc_msg: '',
				add_id: 0,
	
				coupon_code: 0,
				coupon_price: 0,
	
				state: '',
				zip: '',
				city: '',
				address: '',
				save_local_address_msg_status: false,
				ac_enough_msg_status: false,
				proceedMsg_status: false,
	
				promodiscount: '',
				promos: [],
				applied_promos: '',
	
				checkout_page_loading: false,
	
				page_loading: false,
				show: false,
				page_error: false
			};
			_this.close = _this.close.bind(_this);
			_this.submitCoupon = _this.submitCoupon.bind(_this);
			_this.changeCoupon = _this.changeCoupon.bind(_this);
			_this.getCart = _this.getCart.bind(_this);
			_this.updateMinQty = _this.updateMinQty.bind(_this);
			_this.updateMinQtyModal = _this.updateMinQtyModal.bind(_this);
			_this.updateQuantity = _this.updateQuantity.bind(_this);
			_this.enableBillingDetails = _this.enableBillingDetails.bind(_this);
			_this.placeOrder = _this.placeOrder.bind(_this);
			_this.applyCoupon_getCart = _this.applyCoupon_getCart.bind(_this);
			_this.removeCoupon = _this.removeCoupon.bind(_this);
			_this.saveDefaultAddress = _this.saveDefaultAddress.bind(_this);
			_this.saveAddress_placeOrder = _this.saveAddress_placeOrder.bind(_this);
	
			_this.deleteSingleItem = _this.deleteSingleItem.bind(_this);
			_this.delete = _this.delete.bind(_this);
			return _this;
		}
	
		//saveDefaultAddress function is used to save the new address in checkout page
	
	
		_createClass(Web_QuickCart, [{
			key: 'saveDefaultAddress',
			value: function saveDefaultAddress() {
				var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), name: localStorage.user_name, mobile: localStorage.user_mobile, state: this.state.state, city: this.state.city, address: this.state.address, zip: this.state.zip, quick_buy: 1 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'saveAdd',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							add_id: data.add_id
						});
						localStorage.setItem('address_change_flag', data.address_change);
						this.saveAddress_placeOrder();
					}.bind(this),
					error: function error(err) {
						// console.log(err);
					}
				});
			}
		}, {
			key: 'deleteSingleItem',
			value: function deleteSingleItem(id) {
				var _this2 = this;
	
				this.setState({
					delete_status: true,
					delete_status_id: id
				});
				setTimeout(function () {
					_this2.state.delete_status === true ? _this2.delete(id) : '';
				}, 2000);
			}
		}, {
			key: 'delete',
			value: function _delete(id) {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: id, uid: uid, token: localStorage.token, quick_buy: 1 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					url: baseUrl + 'singleCart_delete',
					method: 'POST',
					dataType: 'JSON',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success' && data.message === 'Item deleted successfully') {
							this.getCart();
							this.getCartCount();
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
						location.reload();
					}.bind(this),
					error: function error(err) {}
				});
			}
			//function updateQuantitiy is used to update the qunatity of the product in modal box and updating the cart values by calling the "applyCoupon_getCart" 
	
		}, {
			key: 'updateQuantity',
			value: function updateQuantity() {
				var x = '';
				if (parseInt(this.state.qty, 10) < parseInt(this.state.min_qty, 10)) {
					// alert('Minimum Quantity is '+this.state.min_qty);
					x = 'Minimum Quantity is ' + this.state.min_qty;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Minimum Quantity is ' + this.state.min_qty
					});
				}
				if (this.state.qty === '') {
					// alert('Minimum Quantity is '+this.state.min_qty);
					x = 'Minimum Quantity is ' + this.state.min_qty;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Minimum Quantity is ' + this.state.min_qty
					});
				}
				if (parseInt(this.state.qty, 10) > parseInt(this.state.max_qty, 10)) {
					// alert('Maximum Quantity is '+this.state.max_qty);
					x = 'Maximum Quantity is ' + this.state.max_qty;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Maximum Quantity is ' + this.state.max_qty
					});
				}
				var check = /[^0-9]/gi;
				if (check.test(this.refs.mob_edit_qty.value)) {
					x = '* Invalid Quantity';
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Invalid Quantity'
					});
				}
				if (x === '') {
					this.setState({
						err_qty_status: false,
						err_qty_msg: ''
					});
					var baseUrl = 'https://aquadeals.in/admin/web3/user/';
					var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), cart_id: this.state.cart_id, quantity: this.state.qty, quick_buy: 1 };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'update_qcart_qty',
						data: { req: data2 },
						success: function (data) {
							console.log(data);
							if (data.status === "success") {
								this.close();
								// this.getCart();
								this.applyCoupon_getCart();
							}
						}.bind(this),
						error: function error(err) {
							// console.log(err);
						}
					});
				}
			}
			//function close is used to close all of the modal boxes
	
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					openModal: false,
					updateModal: false,
					save_local_address_msg_status: false,
					ac_enough_msg_status: false,
					proceedMsg_status: false
				});
			}
			//applyCoupon_getCart(value,code) function is used to call the cart function with updated state values of coupon price and coupon value. 
	
		}, {
			key: 'applyCoupon_getCart',
			value: function applyCoupon_getCart(value, code) {
				this.setState({ page_loading: true });
				var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), apply_ac: 1, apply_coupon: this.state.coupon_price, apply_coupon_code: this.state.coupon_code, quick_buy: 1 };
				var data2 = JSON.stringify(data1);
	
				localStorage.setItem('apply_coupon', this.state.coupon_price);
				localStorage.setItem('apply_coupon_code', this.state.coupon_code);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'cart',
					data: { req: data2 },
					success: function (data) {
						// console.log(data);
						localStorage.setItem('apply_coupon', this.state.coupon_price);
						localStorage.setItem('apply_coupon_code', this.state.coupon_code);
						this.setState({
							total: data.total,
							cartcount: data.cart_count,
							grandtotal: data.grand_total,
							items: data.items,
							ac_discount: data.ac_discount,
							aqua_cash: data.aqua_cash,
							used_cash: data.used_cash,
							used_cash1: data.used_cash1,
							coupons_amt: data.coupons_amt,
							coupons_amt1: data.coupons_amt1,
							grand_total: data.grand_total,
							applied_coupons: data.applied_coupons,
							applied_coupons1: data.applied_coupons1,
							coupons: data.coupons,
	
							proceedCheck: data.proceedCheck,
							proceedMsg: data.proceedMsg,
							ac_enough_msg: data.ac_enough_msg,
							loc_msg: data.loc_msg,
							add_id: data.add_id,
	
							state: data.state,
							zip: data.zip,
							city: data.city,
							address: data.address,
	
							promodiscount: data.promodiscount,
							promos: data.promos,
							applied_promos: data.applied_promos,
	
							page_loading: false,
							shipping_note: data.shipping_note
						});
						localStorage.setItem('address_change_flag', data.address_change);
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
			//function getCart is used to get the cart values when page loads with empty params of coupons codes and values.
	
		}, {
			key: 'getCart',
			value: function getCart() {
				this.setState({ page_loading: true });
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token'), apply_ac: 1, apply_coupon: 0, apply_coupon_code: '', quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				localStorage.setItem('apply_coupon', this.state.coupon_price);
				localStorage.setItem('apply_coupon_code', this.state.coupon_code);
	
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'cart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'error' && data.message === 'Token mismatch') {
							localStorage.clear();
							window.location.reload();
						}
						if (data.status === 'success') {
							this.setState({
								total: data.total,
								cartcount: data.cart_count,
								grandtotal: data.grand_total,
								items: data.items,
								ac_discount: data.ac_discount,
								aqua_cash: data.aqua_cash,
								used_cash: data.used_cash,
								used_cash1: data.used_cash1,
								coupons_amt: data.coupons_amt,
								coupons_amt1: data.coupons_amt1,
								grand_total: data.grand_total,
								applied_coupons: data.applied_coupons,
								applied_coupons1: data.applied_coupons1,
								coupons: data.coupons,
	
								proceedCheck: data.proceedCheck,
								proceedMsg: data.proceedMsg,
								ac_enough_msg: data.ac_enough_msg,
								loc_msg: data.loc_msg,
								add_id: data.add_id,
	
								promodiscount: data.promodiscount,
								promos: data.promos,
								applied_promos: data.applied_promos,
	
								page_loading: false,
								shipping_note: data.shipping_note
							});
						}
						if (data.status === 'error') {
							this.setState({
								page_error: true
							});
						}
						localStorage.setItem('address_change_flag', data.address_change);
					}.bind(this),
					error: function error(err) {}
				});
			}
			//componentDidMount function is loaded first when page loaded by checking the session and calls the getCart function.
	
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this3 = this;
	
				window.scrollTo(0, 0);
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
				localStorage.removeItem('checkout');
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
	
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
				localStorage.removeItem('web_brand_details');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
				if (!localStorage.token && !localStorage.user_id) {
					localStorage.setItem('web_quickcart', '/web/quickcart');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					this.getCart();
				}
				if (screen.width < 800) {
					window.location.href = '/quickcart';
				}
				setTimeout(function () {
					_this3.setState({ show: true });
				}, 5000);
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var that = this;
				setTimeout(function () {
					that.enableBillingDetails();
				}, 3000);
			}
		}, {
			key: 'enableBillingDetails',
			value: function enableBillingDetails() {
				// this.getCart();
				this.setState({
					billing_status: true
				});
			}
		}, {
			key: 'changeCoupon',
			value: function changeCoupon() {
				this.setState({
					coupon_ref: this.refs.apply_coupon.value,
					coupon_err_status: false
				});
			}
		}, {
			key: 'submitCoupon',
			value: function submitCoupon() {
				var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), coupon: this.refs.apply_coupon.value, public_amt: this.state.coupons_amt1, apply_ac: 1, quick_buy: 1 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'applyCoupon',
					data: { req: data2 },
					success: function (data) {
	
						// console.log(data);
						if (data.status === "error") {
							this.setState({
								coupon_err_status: true,
								coupon_err_msg: data.message
							});
						}
						if (data.status === "success") {
							this.setState({
								coupon_code: data.code,
								coupon_price: data.value,
								coupon_success_msg: data.message,
								coupon_success_status: true,
								coupon_success_value: data.value
							});
							this.applyCoupon_getCart(data.value, data.code);
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'updateMinQty',
			value: function updateMinQty(qty, min_qty, max_qty, cart_id) {
				this.setState({
					updateModal: true,
					qty: qty,
					min_qty: min_qty,
					max_qty: max_qty,
					cart_id: cart_id
				});
			}
		}, {
			key: 'updateMinQtyModal',
			value: function updateMinQtyModal() {
				// alert(this.refs.min_qty.value);
				this.setState({
					qty: this.refs.mob_edit_qty.value,
					err_qty_status: false
				});
			}
			//saveAddress_placeOrder() function is called when the coupon is applied and shown location_msg and saving the address,if the address is saved then redirect to checkout page.
	
		}, {
			key: 'saveAddress_placeOrder',
			value: function saveAddress_placeOrder() {
				var data1 = { from: 'desktop_web', uid: localStorage.user_id, token: localStorage.token, mode: 2, add_id: this.state.add_id, code: this.state.coupon_code, coupon_amount: this.state.coupon_price, other_amount: '', aqua_cash: this.state.aqua_cash, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, quick_buy: 1 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cartCalculations',
					success: function (data) {
						this.applyCoupon_getCart();
						if (data.status === "success") {
							_reactRouter.browserHistory.push('/web/quick_checkout');
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'placeOrder',
			value: function placeOrder() {
				if (this.state.proceedCheck === 0 && this.state.proceedMsg !== "") {
					this.setState({
						proceedMsg_status: true
					});
				} else if (this.state.proceedCheck === 0 && this.state.ac_enough_msg !== "") {
					this.setState({
						ac_enough_msg_status: true
					});
				} else if (this.state.proceedCheck === 0 && this.state.loc_msg !== "") {
					this.setState({
						save_local_address_msg_status: true
					});
				} else {
					this.setState({
						checkout_page_loading: true
					});
					var data1 = { from: 'desktop_web', uid: localStorage.user_id, token: localStorage.token, mode: 2, add_id: this.state.add_id, code: this.state.coupon_code, coupon_amount: this.state.coupon_price, other_amount: '', aqua_cash: this.state.used_cash1, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, quick_buy: 1 };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'cartCalculations',
						success: function (data) {
							this.applyCoupon_getCart();
							if (data.status === "success") {
								_reactRouter.browserHistory.push('/web/quick_checkout');
							}
						}.bind(this),
						error: function error(err) {
							console.log(err);
						}
					});
				}
			}
		}, {
			key: 'removeCoupon',
			value: function removeCoupon() {
				this.setState({
					coupon_success_status: false,
					coupon_code: 0,
					coupon_price: 0
				});
				localStorage.setItem('apply_coupon', 0);
				localStorage.setItem('apply_coupon_code', 0);
				this.getCart();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				document.title = "Quick Cart | AquaDeals";
				// $(window).scrollTop(0);
				// $('body').css('background','#fff');
				var cart_items = this.state.items.map(function (item, index) {
					var _this4 = this;
	
					return _react2.default.createElement(
						'div',
						null,
						this.state.delete_status && this.state.delete_status_id === item.id ? _react2.default.createElement(
							'div',
							{ className: 'row cart_ItemsList' },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12', style: { padding: '10px', color: '#666' } },
								_react2.default.createElement(
									'span',
									null,
									'Deleted'
								),
								_react2.default.createElement(
									'span',
									{ style: { float: 'right', cursor: 'pointer' }, onClick: function onClick() {
											_this4.setState({ delete_status: false });
										} },
									'UNDO'
								)
							)
						) : _react2.default.createElement(
							'div',
							{ className: 'row cart_ItemsList' },
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'container' },
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-2 col-md-2 col-sm-2 webcart_centerimg' },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: item.type === 0 ? '/web/sdetails/' + item.url_name + '/' + item.deal_id : '/web/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
											item.type === 0 ? _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/' + item.img, width: '50px', alt: ' ' }) : _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/product_imgs/thumbnails/' + item.img, alt: ' ' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'cartdesc_Blk' },
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-2 col-md-2 col-sm-2 col-xs-2 cart_title_blk' },
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: item.type === 0 ? '/web/sdetails/' + item.url_name + '/' + item.deal_id : '/web/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
												item.pro_name !== "" ? _react2.default.createElement(
													'h3',
													{ className: 'cartitem_Title' },
													item.pro_name
												) : _react2.default.createElement(
													'h3',
													null,
													'\xA0'
												),
												item.brand ? _react2.default.createElement(
													'h4',
													{ className: 'cartitem_Brand' },
													item.brand
												) : _react2.default.createElement(
													'h4',
													null,
													'\xA0'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-2 col-md-2 col-sm-2' },
											item.mrp ? _react2.default.createElement(
												'h4',
												{ className: 'cartitem_Mrp' },
												'\u20B9 ',
												item.mrp
											) : _react2.default.createElement(
												'h4',
												null,
												'\xA0'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-3 col-sm-3 col-md-3 col-lg-3 text-center' },
											item.min_qty !== "" ? _react2.default.createElement(
												'p',
												{ className: 'webQty_Edit', onClick: function onClick() {
														_this4.updateMinQty(item.qty, item.min_qty, item.max_qty, item.id);
													} },
												_react2.default.createElement(
													'span',
													null,
													item.qty
												)
											) : ''
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-2 col-sm-2 col-md-2 col-lg-2 text-center', style: { paddingLeft: '0px', paddingRight: '0px' } },
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: item.type === 0 ? '/web/sdetails/' + item.url_name + '/' + item.deal_id : '/web/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
												item.amount !== "" ? _react2.default.createElement(
													'p',
													{ className: 'cartitem_amount' },
													_react2.default.createElement(
														'span',
														null,
														'\u20B9 '
													),
													_react2.default.createElement(
														'span',
														null,
														item.amount
													)
												) : ''
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-1 col-md-1 col-sm-1 col-xs-1' },
											_react2.default.createElement(
												'button',
												{ onClick: function onClick() {
														item.type === 1 ? _this4.deleteSingleItem(item.id) : _this4.deleteSingleItem(item.id);
													}, ariaLabel: 'Close', className: 'close cartitem_removebtn', type: 'button' },
												_react2.default.createElement(
													'p',
													{ ariaHidden: 'true' },
													'\xD7'
												)
											)
										)
									)
								)
							)
						)
					);
				}.bind(this));
	
				{/*var cart_coupons='';
	    cart_coupons=  <div className="col-md-6 col-lg-6 col-sm-10">
	    				<div className="coupon_input_blk">
	    		  	       <input type="text" ref="apply_coupon" maxLength={15} placeholder="Enter coupon code" onChange={()=>{this.changeCoupon()}} />	
	                                <i className='glyphicon glyphicon-chevron-right' onClick={()=>{this.submitCoupon()}}></i>
	                             </div>
	                           <span className="error">{this.state.coupon_err_status ? this.state.coupon_err_msg : ''}</span>
	                        </div>;*/}
				var cart_coupons = '';
				cart_coupons = _react2.default.createElement(
					'div',
					{ className: 'row', style: { paddingTop: '20px', paddingBottom: '20px' } },
					_react2.default.createElement('div', { className: 'col-xs-1 col-sm-1 col-md-1 col-lg-1' }),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-4 col-xs-4 col-md-4 col-lg-4 cart_coupon_blk' },
						_react2.default.createElement(
							'i',
							{ className: 'cart_left_img' },
							_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_left.png', alt: ' ' })
						),
						_react2.default.createElement('input', { type: 'text', ref: 'apply_coupon', maxLength: 15, placeholder: 'Enter coupon code', onChange: function onChange() {
								_this5.changeCoupon();
							} })
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-2 col-xs-2 col-lg-2' },
						_react2.default.createElement(
							'div',
							{ className: 'cart_submit' },
							_react2.default.createElement(
								'button',
								{ className: 'cart_submitbtn', onClick: function onClick() {
										_this5.submitCoupon();
									} },
								'Apply'
							)
						)
					),
					_react2.default.createElement('div', { className: 'col-sm-12 col-xs-12 col-lg-12' }),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-4 col-sm-offset-1 col-xs-4 col-xs-offset-1 err_coupon' },
						_react2.default.createElement(
							'span',
							null,
							this.state.coupon_err_status ? this.state.coupon_err_msg : ''
						)
					)
				);
				var coupon_map = this.state.coupons.map(function (coupon, index) {
					return _react2.default.createElement(
						'span',
						{ key: index, style: { display: 'block' } },
						coupon.coupon_code,
						' (\u20B9',
						coupon.value,
						' )'
					);
				});
				var couponsList = _react2.default.createElement(
					_reactBootstrap.Popover,
					{ id: 'popover-positioned-top1' },
					coupon_map
				);
				var coupon_info = _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{ trigger: 'focus', placement: 'top', overlay: couponsList },
					_react2.default.createElement(
						_reactBootstrap.Button,
						{ className: 'cart_coupon_info_img' },
						_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/coupon_info.png', alt: ' ' })
					)
				);
				var promos_map = this.state.promos.map(function (promo, index) {
					return _react2.default.createElement(
						'span',
						{ key: index, style: { display: 'block' } },
						promo.promo_code,
						' ( \u20B9 ',
						promo.promo_value,
						' )'
					);
				});
				var promosList = _react2.default.createElement(
					_reactBootstrap.Popover,
					{ id: 'popover-positioned-top2' },
					promos_map
				);
				var promo_info = '';
				promo_info = _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{ trigger: 'focus', placement: 'top', overlay: promosList },
					_react2.default.createElement(
						_reactBootstrap.Button,
						{ className: 'cart_coupon_info_img' },
						_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/coupon_info.png', alt: ' ' })
					)
				);
				var coupon_success = '';
				if (this.state.coupon_success_status) {
					coupon_success = _react2.default.createElement(
						'div',
						{ className: 'cart_cpn_success' },
						_react2.default.createElement(
							'button',
							{ onClick: function onClick() {
									_this5.removeCoupon();
								}, ariaLabel: 'Close', className: 'coupon_close', type: 'button' },
							_react2.default.createElement(
								'i',
								null,
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cancel_coupon.png', alt: '', width: '20px' })
							)
						),
						_react2.default.createElement(
							'h5',
							null,
							'Coupon discount:(-) \u20B9 ',
							this.state.coupon_success_value
						),
						_react2.default.createElement(
							'p',
							null,
							this.state.coupon_success_msg
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'web_Deals webQuick_cartpage' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb,
								{ className: 'webcart_breadcrumb' },
								_react2.default.createElement(
									_reactBootstrap.Breadcrumb.Item,
									{ href: '/web/home' },
									'Home'
								),
								_react2.default.createElement(
									_reactBootstrap.Breadcrumb.Item,
									{ active: true },
									'Quick Cart'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12  webDels_cntnt' },
								this.state.cartcount !== 0 && !this.state.page_error ? _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'section',
										{ className: 'container-fluid' },
										this.state.checkout_page_loading ? '' : _react2.default.createElement(
											'section',
											{ id: 'cart-process' },
											_react2.default.createElement(
												'div',
												{ className: 'progressbar-wrapper', style: { background: 'unset!important' } },
												_react2.default.createElement(
													'ul',
													{ className: 'progressbar' },
													_react2.default.createElement(
														'li',
														{ className: 'active' },
														_react2.default.createElement(
															'div',
															null,
															'Cart'
														),
														_react2.default.createElement(
															'div',
															null,
															_react2.default.createElement(_reactWebVectorIcons2.default, {
																name: 'check',
																font: 'Entypo',
																color: '#fff',
																size: 14
																// style={{}}
															})
														)
													),
													_react2.default.createElement(
														'li',
														null,
														'Checkout'
													),
													_react2.default.createElement(
														'li',
														null,
														'Payment'
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'row Mycart_Block', style: { marginTop: '15px' } },
											_react2.default.createElement('div', { className: 'container-fluid' }),
											_react2.default.createElement('hr', null)
										),
										_react2.default.createElement(
											'div',
											{ className: 'row cart_head_blk' },
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-5 col-md-5 col-sm-5 col-xs-5', style: { paddingRight: '0' } },
												_react2.default.createElement(
													'span',
													{ className: 'add_head' },
													'Added Item'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-2 col-md-2 col-sm-2' },
												_react2.default.createElement(
													'span',
													{ className: 'add_mrp' },
													'MRP'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-4 col-md-4 col-sm-4 col-xs-4', style: { paddingLeft: '0' } },
												_react2.default.createElement(
													'div',
													{ className: 'col-lg-6 col-md-6 col-sm-6' },
													_react2.default.createElement(
														'span',
														{ className: 'qun_head' },
														'Quantity'
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'col-lg-6 col-md-6 col-sm-6 text-center' },
													_react2.default.createElement(
														'span',
														{ className: 'price_head' },
														'Price'
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'web_cart_itemsblk' },
											cart_items
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'clr' },
										'\xA0'
									),
									_react2.default.createElement(
										'section',
										{ className: 'container-fluid' },
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-lg-6 col-sm-6' },
												this.state.coupon_success_status ? coupon_success : cart_coupons,
												_react2.default.createElement(
													'div',
													{ className: 'col-md-6 col-lg-6' },
													'\xA0'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-lg-6 col-md-6 col-sm-6' },
												this.state.billing_status ? _react2.default.createElement(
													'table',
													{ className: 'table cartTable' },
													_react2.default.createElement(
														'tr',
														{ className: 'cartTr_Total' },
														_react2.default.createElement(
															'td',
															null,
															'Total'
														),
														_react2.default.createElement(
															'td',
															null,
															'\u20B9 ',
															this.state.total
														)
													),
													parseInt(this.state.used_cash) > 0 ? _react2.default.createElement(
														'tr',
														{ className: 'cart_tr' },
														_react2.default.createElement(
															'td',
															null,
															'Aquacash Discount'
														),
														_react2.default.createElement(
															'td',
															null,
															'(-) \u20B9 ',
															this.state.used_cash
														)
													) : '',
													_react2.default.createElement(
														'tr',
														{ className: 'cartTr', style: { display: this.state.coupons.length === 1 ? "table-row" : "none" } },
														_react2.default.createElement(
															'td',
															null,
															'Applied Coupon ',
															_react2.default.createElement(
																'span',
																{ className: 'applied_coupon_msg' },
																': ',
																this.state.coupons.length === 1 ? this.state.coupons[0]['coupon_code'] : ''
															)
														),
														_react2.default.createElement(
															'td',
															null,
															'(-) \u20B9 ',
															this.state.coupons_amt
														)
													),
													_react2.default.createElement(
														'tr',
														{ className: 'cartTr', style: { display: this.state.coupons.length > 1 ? "table-row" : "none" } },
														_react2.default.createElement(
															'td',
															null,
															'Coupons applied on your purchase ',
															coupon_info
														),
														_react2.default.createElement(
															'td',
															null,
															'(-) \u20B9 ',
															this.state.coupons_amt
														)
													),
													parseInt(this.state.promodiscount, 10) > 0 ? _react2.default.createElement(
														'tr',
														null,
														_react2.default.createElement(
															'td',
															null,
															'Promos Discount ',
															this.state.promos.length === 1 ? _react2.default.createElement(
																'span',
																{ className: 'applied_coupon_msg' },
																': ',
																this.state.promos[0].promo_code
															) : promo_info,
															' '
														),
														_react2.default.createElement(
															'td',
															null,
															'(-) \u20B9 ',
															this.state.promodiscount
														)
													) : '',
													_react2.default.createElement(
														'tr',
														{ className: 'cartTr_Grandtotal' },
														_react2.default.createElement(
															'td',
															null,
															'GRAND TOTAL '
														),
														_react2.default.createElement(
															'td',
															null,
															'\u20B9 ',
															this.state.grand_total
														)
													),
													_react2.default.createElement(
														'tr',
														null,
														_react2.default.createElement(
															'td',
															null,
															parseHtml(this.state.shipping_note)
														)
													)
												) : _react2.default.createElement(
													'div',
													{ className: 'webPrice_Loading' },
													_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
												)
											)
										)
									),
									_react2.default.createElement(
										'section',
										{ className: 'container-fluid' },
										_react2.default.createElement(
											'div',
											{ className: 'webBotm_Btns row', style: { marginTop: '4%' } },
											_react2.default.createElement(
												'ul',
												null,
												_react2.default.createElement(
													'li',
													{ className: 'col-lg-4 col-md-4 col-xs-4 col-sm-5', style: { cursor: 'pointer' } },
													_react2.default.createElement(
														_reactRouter.Link,
														{ to: '/web/home', title: '' },
														'CONTINUE SHOPPING'
													)
												),
												_react2.default.createElement(
													'li',
													{ className: 'col-lg-4 col-md-4 col-xs-4 col-sm-2' },
													'\xA0'
												),
												_react2.default.createElement(
													'li',
													{ className: 'col-lg-4 col-md-4 col-xs-4 col-sm-5 text-right', style: { cursor: 'pointer' } },
													_react2.default.createElement(
														'a',
														{ onClick: function onClick() {
																_this5.placeOrder();
															} },
														'PROCEED TO CHECKOUT'
													)
												)
											)
										)
									)
								) : '',
								this.state.page_error ? _react2.default.createElement(
									'section',
									{ className: 'container' },
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-12 col-md-12 EmptyDels_cntnt' },
											_react2.default.createElement(
												'div',
												null,
												_react2.default.createElement(
													'div',
													{ className: 'webCart_Empty' },
													_react2.default.createElement(
														'i',
														null,
														_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/empty_cartbg.png', alt: '...' })
													),
													_react2.default.createElement(
														'h3',
														{ className: 'web_quick_empty' },
														'Your Quick Cart is Empty'
													),
													_react2.default.createElement(
														_reactRouter.Link,
														{ to: "/web/home", className: 'cart_ShopBtn' },
														'SHOP NOW'
													)
												)
											)
										)
									)
								) : '',
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: '', show: this.state.openModal, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Header,
										{ closeButton: true },
										_react2.default.createElement(
											_reactBootstrap.Modal.Title,
											{ style: { fontSize: '16px', color: '#333' } },
											'AquaDeals'
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'h4',
											{ style: { fontSize: '14px', color: '#666' } },
											'You need to install Android mobile app to place this order.'
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Footer,
										{ className: 'modal_footer' },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ style: { background: '#fff none repeat scroll 0 0', color: '#ff742a' }, onClick: this.close },
											'Close'
										),
										_react2.default.createElement(
											'a',
											{ href: 'https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en', target: '_blank', title: '' },
											_react2.default.createElement(
												_reactBootstrap.Button,
												{ style: { background: '#ff742a none repeat scroll 0 0', color: '#fff' } },
												'OK'
											)
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: 'mob_edit_qty_modal', show: this.state.updateModal, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'h4',
											null,
											_react2.default.createElement('input', { ref: 'mob_edit_qty', type: 'text', value: this.state.qty, placeholder: 'Enter Quantity', onChange: function onChange() {
													_this5.updateMinQtyModal();
												} })
										),
										this.state.err_qty_status ? _react2.default.createElement(
											'p',
											{ className: 'mob_err_qty' },
											this.state.err_qty_msg
										) : ''
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Footer,
										{ className: 'mob_edit_qty_footer' },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ className: 'mob_edit_qty_cls_btn', onClick: this.close },
											'CANCEL'
										),
										_react2.default.createElement(
											'a',
											null,
											_react2.default.createElement(
												_reactBootstrap.Button,
												{ className: 'mob_edit_qty_update_btn', onClick: function onClick() {
														_this5.updateQuantity();
													} },
												'UPDATE'
											)
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: '', show: this.state.save_local_address_msg_status, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'h4',
											{ style: { fontSize: '14px', color: '#666' } },
											this.state.loc_msg
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Footer,
										{ className: 'mob_cart_confirm' },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ className: '', onClick: this.close },
											'NO'
										),
										_react2.default.createElement(
											'a',
											null,
											_react2.default.createElement(
												_reactBootstrap.Button,
												{ className: '', onClick: function onClick() {
														_this5.saveDefaultAddress();
													} },
												'YES'
											)
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: '', show: this.state.ac_enough_msg_status, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'h4',
											{ style: { fontSize: '14px', color: '#666' } },
											this.state.ac_enough_msg
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Footer,
										{ className: 'mob_cart_confirm' },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ className: '', onClick: this.close },
											'CLOSE'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/web/customer_care' },
											_react2.default.createElement(
												_reactBootstrap.Button,
												null,
												'CUSTOMERCARE'
											)
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: '', show: this.state.proceedMsg_status, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'h4',
											{ style: { fontSize: '14px', color: '#666' } },
											this.state.proceedMsg
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Footer,
										{ className: 'mob_cart_confirm' },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ className: '', onClick: this.close },
											'CANCEL'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_QuickCart;
	}(_react.Component);
	
	exports.default = Web_QuickCart;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _reactWebVectorIcons = __webpack_require__(29);
	
	var _reactWebVectorIcons2 = _interopRequireDefault(_reactWebVectorIcons);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _custom_functions = __webpack_require__(83);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var parseHtml = __webpack_require__(39);
	
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets//';
	
	var Web_Quick_Checkout = function (_Component) {
		_inherits(Web_Quick_Checkout, _Component);
	
		function Web_Quick_Checkout(props) {
			_classCallCheck(this, Web_Quick_Checkout);
	
			var _this = _possibleConstructorReturn(this, (Web_Quick_Checkout.__proto__ || Object.getPrototypeOf(Web_Quick_Checkout)).call(this, props));
	
			_this.state = {};
			_this.state = {
				page_loading: false,
				lod: false,
				user_address: [],
				edit_add_id: '',
				address_flag: 0,
				add_address_form_status: false,
				add_available: false,
				add_address: false,
				edit_address: false,
				click_here_status: false,
				tot_data: _this.props.total_cart_data,
				add_id: '',
				edit_data: [],
				// edit form elements 
				edit_name: '',
				edit_mobile: '',
				edit_state: '',
				edit_city: '',
				edit_doorno: '',
				edit_pincode: '',
	
				// add form elements
				add_name: localStorage.user_name,
				add_mobile: localStorage.user_mobile,
				add_state: '',
				add_city: '',
				add_doorno: '',
				add_pincode: '',
	
				//cart response 
				cart_count: 0,
				grand_total: 0,
				cart_add_id: '',
				coupon_code: 0,
				aqua_cash: '',
				coupons_amt: '',
				ac_discount: '',
	
				//cart calculations response
				mode: '',
				pay_advance: '',
				complete_amount: '',
				pay_at_outlet: '',
				final_amt: '',
				totals: '',
				other_amount_field_status: false,
				ptype: '',
				min_val: '',
				max_val: '',
				err_qty_status: false,
				err_qty_msg: '',
	
				paymentMethodStatus: '',
				offline_payment: '',
				prebook_payment: '',
				fullamount_payment: '',
				otheramount_payment: '',
	
				// cart calculations respnose before pay now
				deal_id: 0,
				product_id: 0,
				quantity: '',
				act_price: '',
				deal_price: '',
				total: '',
				total_discount: '',
				discount: '',
				pre_booking_amount: '',
				bank_fee: '',
				total_thx_fee: '',
				save_price: '',
				remaining_amount: '',
				payable_ad: '',
				payable_hatchery: '',
				ac_offer_title: '',
				aqua_cash_value: '',
				aqua_cash_code: '',
				ac_cal_info: '',
				pur_ern_ofr_code: '',
				pur_ern_ofr_title: '',
				pur_ern_ofr_desc: '',
				pur_ern_retrn_amt: '',
				full_aquacash_back_amount: '',
				full_aquacash_back_title: '',
				full_aquacash_back_code: '',
				full_aquacash_back_description: '',
				deal_type: '',
				promo_code: '',
				promo_amt: '',
				promo_title: '',
				promo_help: '',
				free_shipment: '',
				free_shipment_msg: '',
				user_details: [],
				coupon_amt: '',
				cart_ids: '',
				promodiscount: '',
				applied_promos: '',
				promos: [],
				ac_enough: '',
				ac_enough_msg: '',
				applied_coupons: '',
	
				//variable for storing the payment radio buttons 
				total_online_payment: '',
				default_ptype: '',
				mode_loading: false,
				amount_loading: false,
				evnt_key: 2,
	
				// offline payment success displaying it in modal
				success_msg: '',
				thank_msg: '',
	
				offline_confirm_data: [],
				offline_pay_success_status: false,
	
				paying_process: false,
	
				// online payment response variables start
				pre_payment_id: '',
				order_id: '',
				//deal_type:'',
				//cart_ids:'',
				paid_amt: '',
				response: '',
				offline_success: false,
				// online payment response variables ends here
	
				cart_items: [],
				cart_total: '',
				gateway_mode: '',
				pageId: '.web_quick_checkout_page',
				order_error_modal: false,
				order_error_message: '',
				coupons: []
			};
			_this.testclose = _this.testclose.bind(_this);
	
			_this.getUserAddress = _this.getUserAddress.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.handleSubmit_add = _this.handleSubmit_add.bind(_this);
			_this.editAddress = _this.editAddress.bind(_this);
			_this.deleteAddress = _this.deleteAddress.bind(_this);
			_this.handleSubmit_edit = _this.handleSubmit_edit.bind(_this);
			_this.getAddressDetails = _this.getAddressDetails.bind(_this);
	
			// functions for edit address form
			_this.edit_nameChange = _this.edit_nameChange.bind(_this);
			_this.edit_mobileChange = _this.edit_mobileChange.bind(_this);
			_this.edit_stateChange = _this.edit_stateChange.bind(_this);
			_this.edit_cityChange = _this.edit_cityChange.bind(_this);
			_this.edit_doornoChange = _this.edit_doornoChange.bind(_this);
			_this.edit_pincodeChange = _this.edit_pincodeChange.bind(_this);
	
			// functions for add address form
			_this.add_nameChange = _this.add_nameChange.bind(_this);
			_this.add_mobileChange = _this.add_mobileChange.bind(_this);
			_this.add_stateChange = _this.add_stateChange.bind(_this);
			_this.add_cityChange = _this.add_cityChange.bind(_this);
			_this.add_doornoChange = _this.add_doornoChange.bind(_this);
			_this.add_pincodeChange = _this.add_pincodeChange.bind(_this);
			//this.setDefaultAddress=this.setDefaultAddress.bind(this);
	
			_this.getCart = _this.getCart.bind(_this);
			_this.getCartCalculations = _this.getCartCalculations.bind(_this);
			_this.validateOtherAmount = _this.validateOtherAmount.bind(_this);
	
			_this.modeChange_cartCalculations = _this.modeChange_cartCalculations.bind(_this);
			_this.handleTabsSelect = _this.handleTabsSelect.bind(_this);
			_this.payNow = _this.payNow.bind(_this);
			_this.ccAvenue = _this.ccAvenue.bind(_this);
	
			_this.other_amount_cartCalculations = _this.other_amount_cartCalculations.bind(_this);
			_this.goNext = _this.goNext.bind(_this);
			_this.goPrev = _this.goPrev.bind(_this);
			return _this;
		}
	
		_createClass(Web_Quick_Checkout, [{
			key: 'goNext',
			value: function goNext() {
				if (this.swiper) this.swiper.slideNext();
			}
		}, {
			key: 'goPrev',
			value: function goPrev() {
				if (this.swiper) this.swiper.slidePrev();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				this.props.get_rzp_keys("desktop_web");
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
	
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
				localStorage.removeItem('web_quickcart');
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
				localStorage.removeItem('web_brand_details');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
				if (screen.width < 800) {
					window.location.href = "/quick_checkout";
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('checkout', '/web/quick_checkout');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					this.getUserAddress();
				}
				// this.getCart();
			}
		}, {
			key: 'testclose',
			value: function testclose() {
				this.setState({
					offline_pay_success_status: false
				});
			}
		}, {
			key: 'ccAvenue',
			value: function ccAvenue() {
				var username = this.state.user_details.username;
				var email = this.state.user_details.email;
				var mobile = this.state.user_details.mobile;
				var address = this.state.user_details.address;
				var city = this.state.user_details.city;
				var pincode = this.state.user_details.pincode;
				var state = this.state.user_details.state;
				// var behalf_of=this.state.user_details.behalf_of;
				var deal_type = this.state.deal_type;
				var add_id = this.state.cart_add_id;
	
				var basePayUrl = 'https://aqua.deals/paymentGateWay/paymentRequestHandler.php';
				// var basePayUrl='http://203.193.173.125/paymentGateWay/paymentRequestHandler.php';
	
				var data1 = { access_code: 'AVIJ67DJ41BD20JIDB', merchant_id: '103328', order_id: this.state.order_id, merchant_param1: this.state.pre_payment_id, merchant_param2: deal_type, merchant_param3: add_id, merchant_param4: 'desktop_web', amount: this.state.paid_amt, currency: 'INR', cancel_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', redirect_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', billing_name: username, billing_address: address, billing_city: city, billing_state: state, billing_zip: pincode, billing_tel: mobile, billing_country: 'India', billing_email: email };
				// var data1={access_code:'AVJZ66DG16BM17ZJMB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:add_id,merchant_param4:'desktop_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',redirect_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
				_jquery2.default.ajax({
					method: 'POST',
					data: data1,
					url: basePayUrl,
					success: function success(data) {
						(0, _jquery2.default)('.web_quick_checkout_page').html(data);
					},
					error: function error(err) {
						console.log(err);
					}
	
				});
			}
			//payNow function is used to submit the values to 
	
		}, {
			key: 'payNow',
			value: function payNow() {
				if (this.state.add_address_form_status) {
					this.setState({
						add_address: true
					});
				} else {
					this.setState({
						paying_process: true
					});
	
					// here this.state.ptype = mode of the payment 
					// 1:offline, 2:pay advance, 3:online pay total , 4: online pay other amount
					if (this.state.ptype === 1) {
						var baseUrl = 'https://aquadeals.in/admin/web3/user/';
						var data1 = { from: 'desktop_web', uid: localStorage.user_id, token: localStorage.token, product_id: this.state.product_id, quantity: this.state.quantity, act_price: this.state.act_price, deal_price: this.state.deal_price, total: this.state.total, total_discount: this.state.total_discount, discount: this.state.discount, total_online_payment: this.state.total_online_payment, pre_booking_amount: this.state.pre_booking_amount, bank_fee: this.state.bank_fee, total_thx_fee: this.state.total_thx_fee, save_price: this.state.save_price, remaining_amount: this.state.remaining_amount, payable_ad: this.state.payable_ad, payable_hatchery: this.state.payable_hatchery, mode: this.state.ptype, coupons_amt: this.state.coupons_amt, aqua_cash: this.state.aqua_cash, ac_offer_title: this.state.ac_offer_title, aqua_cash_value: this.state.aqua_cash_value, aqua_cash_code: this.state.aqua_cash_code, ac_cal_info: this.state.ac_cal_info, pur_ern_ofr_code: this.state.pur_ern_ofr_code, pur_ern_ofr_title: this.state.pur_ern_ofr_title, pur_ern_ofr_desc: this.state.pur_ern_ofr_desc, pur_ern_retrn_amt: this.state.pur_ern_retrn_amt, full_aquacash_back_amount: this.state.full_aquacash_back_amount, full_aquacash_back_title: this.state.full_aquacash_back_title, full_aquacash_back_code: this.state.full_aquacash_back_code, full_aquacash_back_description: this.state.full_aquacash_back_description, deal_type: this.state.deal_type, promo_code: this.state.promo_code, promo_amt: this.state.promo_amt, promo_title: this.state.promo_title, promo_help: this.state.promo_help, free_shipment: this.state.free_shipment, free_shipment_msg: this.state.free_shipment_msg, paymentMethodStatus: this.state.paymentMethodStatus, add_id: this.state.cart_add_id, complete_amount: this.state.complete_amount, pay_advance: this.state.pay_advance, pay_at_outlet: this.state.pay_at_outlet, final_amt: this.state.final_amt, totals: this.state.totals, coupon_code: this.state.coupon_code, coupon_amt: this.state.coupon_amt, cart_ids: this.state.cart_ids, applied_coupons: this.state.applied_coupons, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, quick_buy: 1 };
						var data2 = JSON.stringify(data1);
						_jquery2.default.ajax({
							method: 'POST',
							dataType: 'json',
							data: { req: data2 },
							url: baseUrl + 'bookCart',
							success: function (data) {
								if (data.status === "success") {
									this.setState({
										offline_confirm_data: data,
										offline_pay_success_status: true,
										paying_process: false,
										offline_success: true
									});
									(0, _jquery2.default)('#off_modal_status').parent().addClass('offline_modal');
								}
							}.bind(this),
							error: function error(err) {}
						});
					} else if (this.state.ptype === 3 || this.state.ptype === 2) {
						baseUrl = 'https://aquadeals.in/admin/web3/user/';
						data1 = { from: 'desktop_web', uid: localStorage.user_id, token: localStorage.token, product_id: this.state.product_id, quantity: this.state.quantity, act_price: this.state.act_price, deal_price: this.state.deal_price, total: this.state.total, total_discount: this.state.total_discount, discount: this.state.discount, total_online_payment: this.state.total_online_payment, pre_booking_amount: this.state.pre_booking_amount, bank_fee: this.state.bank_fee, total_thx_fee: this.state.total_thx_fee, save_price: this.state.save_price, remaining_amount: this.state.remaining_amount, payable_ad: this.state.payable_ad, payable_hatchery: this.state.payable_hatchery, mode: this.state.ptype, aqua_cash: this.state.aqua_cash, ac_offer_title: this.state.ac_offer_title, aqua_cash_value: this.state.aqua_cash_value, aqua_cash_code: this.state.aqua_cash_code, ac_cal_info: this.state.ac_cal_info, pur_ern_ofr_code: this.state.pur_ern_ofr_code, pur_ern_ofr_title: this.state.pur_ern_ofr_title, pur_ern_ofr_desc: this.state.pur_ern_ofr_desc, pur_ern_retrn_amt: this.state.pur_ern_retrn_amt, full_aquacash_back_title: this.state.full_aquacash_back_title, full_aquacash_back_code: this.state.full_aquacash_back_code, full_aquacash_back_description: this.state.full_aquacash_back_description, full_aquacash_back_amount: this.state.full_aquacash_back_amount, deal_type: this.state.deal_type, promo_code: this.state.promo_code, promo_amt: this.state.promo_amt, promo_title: this.state.promo_title, promo_help: this.state.promo_help, free_shipment: this.state.free_shipment, free_shipment_msg: this.state.free_shipment_msg, paymentMethodStatus: this.state.paymentMethodStatus, add_id: this.state.cart_add_id, complete_amount: this.state.complete_amount, pay_advance: this.state.pay_advance, pay_at_outlet: this.state.pay_at_outlet, final_amt: this.state.final_amt, totals: this.state.totals, coupon_code: this.state.coupon_code, coupon_amt: this.state.coupon_amt, cart_ids: this.state.cart_ids, applied_coupons: this.state.applied_coupons, coupons_amt: this.state.coupons_amt, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, quick_buy: 1 };
						data2 = JSON.stringify(data1);
						_jquery2.default.ajax({
							method: 'POST',
							dataType: 'json',
							data: { req: data2 },
							url: baseUrl + 'onlineCartProcessing',
							success: function (data) {
								if (data.status === "success") {
									this.setState({
										pre_payment_id: data.pre_payment_id,
										order_id: data.order_id,
										deal_type: data.deal_type,
										cart_ids: data.cart_ids,
										paid_amt: data.paid_amt
									});
									//this.ccAvenue();
									//this.ccAvenue();
									var payment_params = { from: 'desktop_web',
										uid: localStorage.getItem('user_id'),
										pre_payment_id: data.pre_payment_id,
										order_id: data.order_id,
										deal_type: data.deal_type,
										cart_ids: data.cart_ids,
										paid_amt: data.paid_amt,
										username: this.state.user_details.username,
										address: this.state.user_details.address,
										city: this.state.user_details.city,
										state: this.state.user_details.state,
										pincode: this.state.user_details.pincode,
										mobile: this.state.user_details.mobile,
										country: 'India',
										email: this.state.user_details.email,
										cart_add_id: this.state.cart_add_id,
										pageId: this.state.pageId,
										rzp_key: this.props.rzp_keys.key_id };
									if (this.state.gateway_mode == 2) {
										this.props.get_rzp_keys("desktop_web");
										(0, _custom_functions.razorpayForm)(payment_params);
										this.setState({
											paying_process: false
										});
									} else {
										(0, _custom_functions.ccAvenue)(payment_params);
									}
								}
								if (data.status === "invalid") {
									this.setState({
										order_error_modal: true,
										order_error_message: data.message
									});
									setTimeout(function () {
										_reactRouter.browserHistory.push('/web/home');
									}, 3000);
								}
							}.bind(this),
							error: function error(err) {
								console.log(err);
							}
						});
					} else if (this.state.ptype === 4) {
						var x = '';
						if (this.refs.ref_other_amt.value === "") {
							x = '* Enter Amount';
							this.setState({
								err_qty_msg: '* Enter Amount',
								err_qty_status: true
							});
						}
						if (parseInt(this.refs.ref_other_amt.value, 10) < parseInt(this.state.min_val, 10)) {
							x = 'Minimum Quantity is ' + this.state.min_val;
							this.setState({
								err_qty_status: true,
								err_qty_msg: '* Minimum amount is ' + this.state.min_val
							});
						}
						if (this.refs.ref_other_amt === '') {
							x = 'Minimum Quantity is ' + this.state.min_val;
							this.setState({
								err_qty_status: true,
								err_qty_msg: '* Minimum amount is ' + this.state.min_val
							});
						}
						if (parseInt(this.refs.ref_other_amt.value, 10) > parseInt(this.state.max_val, 10)) {
							// alert('Maximum Quantity is '+this.state.max_qty);
							x = 'Maximum Quantity is ' + this.state.max_val;
							this.setState({
								err_qty_status: true,
								err_qty_msg: '* Maximum amount is ' + this.state.max_val
							});
						}
						var check = /[^0-9]/gi;
						if (check.test(this.refs.ref_other_amt.value)) {
							x = '* Invalid Amount';
							this.setState({
								err_qty_status: true,
								err_qty_msg: '* Invalid Amount'
							});
						}
	
						if (x === '') {
							baseUrl = 'https://aquadeals.in/admin/web3/user/';
							data1 = { from: 'desktop_web', uid: localStorage.user_id, token: localStorage.token, product_id: this.state.product_id, quantity: this.state.quantity, act_price: this.state.act_price, deal_price: this.state.deal_price, total: this.state.total, total_discount: this.state.total_discount, discount: this.state.discount, total_online_payment: this.state.total_online_payment, pre_booking_amount: this.state.pre_booking_amount, bank_fee: this.state.bank_fee, total_thx_fee: this.state.total_thx_fee, save_price: this.state.save_price, remaining_amount: this.state.remaining_amount, payable_ad: this.state.payable_ad, payable_hatchery: this.state.payable_hatchery, mode: this.state.ptype, aqua_cash: this.state.aqua_cash, ac_offer_title: this.state.ac_offer_title, aqua_cash_value: this.state.aqua_cash_value, aqua_cash_code: this.state.aqua_cash_code, ac_cal_info: this.state.ac_cal_info, pur_ern_ofr_code: this.state.pur_ern_ofr_code, pur_ern_ofr_title: this.state.pur_ern_ofr_title, pur_ern_ofr_desc: this.state.pur_ern_ofr_desc, pur_ern_retrn_amt: this.state.pur_ern_retrn_amt, full_aquacash_back_title: this.state.full_aquacash_back_title, full_aquacash_back_code: this.state.full_aquacash_back_code, full_aquacash_back_description: this.state.full_aquacash_back_description, full_aquacash_back_amount: this.state.full_aquacash_back_amount, deal_type: this.state.deal_type, promo_code: this.state.promo_code, promo_amt: this.state.promo_amt, promo_title: this.state.promo_title, promo_help: this.state.promo_help, free_shipment: this.state.free_shipment, free_shipment_msg: this.state.free_shipment_msg, paymentMethodStatus: this.state.paymentMethodStatus, add_id: this.state.cart_add_id, complete_amount: this.state.complete_amount, pay_advance: this.state.pay_advance, pay_at_outlet: this.state.pay_at_outlet, final_amt: this.state.final_amt, totals: this.state.totals, coupon_code: this.state.coupon_code, coupon_amt: this.state.coupon_amt, cart_ids: this.state.cart_ids, applied_coupons: this.state.applied_coupons, coupons_amt: this.state.coupons_amt, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, quick_buy: 1 };
							data2 = JSON.stringify(data1);
							_jquery2.default.ajax({
								method: 'POST',
								dataType: 'json',
								data: { req: data2 },
								url: baseUrl + 'onlineCartProcessing',
								success: function (data) {
									if (data.status === "success") {
										this.setState({
											pre_payment_id: data.pre_payment_id,
											order_id: data.order_id,
											deal_type: data.deal_type,
											cart_ids: data.cart_ids,
											paid_amt: data.paid_amt
										});
										//this.ccAvenue();
										var payment_params = { from: 'desktop_web',
											uid: localStorage.getItem('user_id'),
											pre_payment_id: data.pre_payment_id,
											order_id: data.order_id,
											deal_type: data.deal_type,
											cart_ids: data.cart_ids,
											paid_amt: data.paid_amt,
											username: this.state.user_details.username,
											address: this.state.user_details.address,
											city: this.state.user_details.city,
											state: this.state.user_details.state,
											pincode: this.state.user_details.pincode,
											mobile: this.state.user_details.mobile,
											country: 'India',
											email: this.state.user_details.email,
											cart_add_id: this.state.cart_add_id,
											pageId: this.state.pageId,
											rzp_key: this.props.rzp_keys.key_id };
										if (this.state.gateway_mode == 2) {
											(0, _custom_functions.razorpayForm)(payment_params);
											this.setState({ paying_process: false });
										} else {
											(0, _custom_functions.ccAvenue)(payment_params);
										}
										if (data.status === 'error' && data.message === 'Token mismatch') {
											this.props.tokenCheck();
										}
										if (data.status === "invalid") {
											this.setState({
												order_error_modal: true,
												order_error_message: data.message
											});
											setTimeout(function () {
												_reactRouter.browserHistory.push('/web/home');
											}, 3000);
										}
									}
								}.bind(this),
								error: function error(err) {
									console.log(err);
								}
							});
						} else {
							// alert('error');
						}
						this.setState({
							paying_process: false
						});
					}
				}
			}
			// getUserAddress function is used to get the address of the user when page loads. 
	
		}, {
			key: 'getUserAddress',
			value: function getUserAddress() {
				var _this2 = this;
	
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, quick_buy: 1 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getuserAddress',
					success: function (data) {
						if (data.status === "success" && data.address.length > 0) {
							this.setState({
								user_address: data.address,
								address_flag: data.address_flag,
								add_available: true,
								click_here_status: false,
								add_address_form_status: false
							});
						} else if (data.status === "success" && data.address.length === 0) {
							this.setState({
								user_address: data.address,
								click_here_status: true,
								address_flag: data.address_flag,
								add_address_form_status: true
							});
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
				this.getCart();
				setTimeout(function () {
					_this2.setState({ lod: true });
				}, 8000);
			}
			//getCart function is used to get the cart values from the cart page to get the cart values to the checkout page
	
		}, {
			key: 'getCart',
			value: function getCart() {
				var apply_coupon = localStorage.getItem('apply_coupon');
				var apply_coupon_code = localStorage.getItem('apply_coupon_code');
	
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), apply_ac: 1, apply_coupon: apply_coupon, apply_coupon_code: apply_coupon_code, quick_buy: 1 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cart',
					success: function (data) {
						this.setState({
							total: data.total,
							cart_count: data.cart_count,
							//add_id:data.add_id,
							ac_discount: data.ac_discount,
							grand_total: data.grand_total,
							aqua_cash: data.aqua_cash,
							ac_enough: data.ac_enough,
							ac_enough_msg: data.ac_enough_msg,
							apply_ac: data.apply_ac,
							used_cash: data.used_cash,
							used_cash1: data.used_cash1,
							coupons: data.coupons,
							applied_coupons: data.applied_coupons,
							applied_coupons1: data.applied_coupons1,
							coupons_amt: data.coupons_amt,
							coupons_amt1: data.coupons_amt1,
							proceedCheck: data.proceedCheck,
							proceedMsg: data.proceedMsg,
							promodiscount: data.promodiscount,
							promos: data.promos,
							applied_promos: data.applied_promos,
							loc_msg: data.loc_msg,
							address_change: data.address_change,
							address: data.address,
							location: data.location,
							zip: data.zip,
							state: data.state,
							city: data.city,
							cart_add_id: data.add_id,
	
							cart_items: data.items,
							cart_total: data.total
						});
						this.getCartCalculations();
					}.bind(this),
					error: function error(err) {}
				});
			}
			//getCartCalculations function is used to get the results of the cart and payment types resutls.
	
		}, {
			key: 'getCartCalculations',
			value: function getCartCalculations() {
				this.setState({
					mode_loading: true,
					amount_loading: true
				});
				var uid = 0;
				var token = 0;
				var coupon_code = 0;
				var coupon_amount = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.token) {
					token = localStorage.getItem('token');
				} else {
					token = 0;
				}
				if (localStorage.apply_coupon_code) {
					coupon_code = localStorage.getItem('apply_coupon_code');
				} else {
					coupon_code = 0;
				}
				if (localStorage.apply_coupon) {
					coupon_amount = localStorage.getItem('apply_coupon');
				} else {
					coupon_amount = 0;
				}
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', uid: uid, token: token, mode: 2, add_id: this.state.cart_add_id, code: coupon_code, coupon_amount: coupon_amount, other_amount: '', aqua_cash: this.state.used_cash1, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, quick_buy: 1 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cartCalculations',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								mode_loading: false,
								page_loading: true,
								amount_loading: false,
								mode: data.mode,
								ptype: data.mode,
								default_ptype: data.mode,
								final_amt: data.final_amt,
								pay_at_outlet: data.pay_at_outlet,
								pay_advance: data.pay_advance,
								complete_amount: data.complete_amount,
								min_val: data.min_val,
								max_val: data.max_val,
	
								paymentMethodStatus: data.paymentMethodStatus,
								offline_payment: data.offline_payment,
								prebook_payment: data.prebook_payment,
								fullamount_payment: data.fullamount_payment,
								otheramount_payment: data.otheramount_payment,
	
								total_online_payment: data.total_online_payment,
	
								product_id: data.product_id,
								quantity: data.quantity,
								act_price: data.act_price,
								deal_price: data.deal_price,
								total: data.total,
								total_discount: data.total_discount,
								discount: data.discount,
								pre_booking_amount: data.pre_booking_amount,
								bank_fee: data.bank_fee,
								total_thx_fee: data.total_thx_fee,
								save_price: data.save_price,
								remaining_amount: data.remaining_amount,
								payable_ad: data.payable_ad,
								payable_hatchery: data.payable_hatchery,
								aqua_cash: data.aqua_cash,
								ac_offer_title: data.ac_offer_title,
								aqua_cash_value: data.aqua_cash_value,
								aqua_cash_code: data.aqua_cash_code,
								ac_cal_info: data.ac_cal_info,
								pur_ern_ofr_code: data.pur_ern_ofr_code,
								pur_ern_ofr_title: data.pur_ern_ofr_title,
								pur_ern_ofr_desc: data.pur_ern_ofr_desc,
								pur_ern_retrn_amt: data.pur_ern_retrn_amt,
								full_aquacash_back_title: data.full_aquacash_back_title,
								full_aquacash_back_code: data.full_aquacash_back_code,
								full_aquacash_back_description: data.full_aquacash_back_description,
								full_aquacash_back_amount: data.full_aquacash_back_amount,
								deal_type: data.deal_type,
								promo_code: data.promo_code,
								promo_amt: data.promo_amt,
								promo_title: data.promo_title,
								promo_help: data.promo_help,
								free_shipment: data.free_shipment,
								free_shipment_msg: data.free_shipment_msg,
								coupon_code: data.coupon_code,
								coupon_amt: data.coupon_amt,
								cart_ids: data.cart_ids,
								coupons_amt: data.coupons_amt,
								promodiscount: data.promodiscount,
								applied_promos: data.applied_promos,
	
								user_details: data.user_details,
								cart_add_id: data.add_id,
								gateway_mode: data.gateway_mode,
								deliver_date_text: data.deliver_date_text,
								payment_options: data.payment_options
							});
							if (data.mode !== 1) {
								this.setState({
									evnt_key: 2
								});
							}
						}
					}.bind(this),
					error: function (err) {
						this.setState({
							page_loading: false,
							lod: true
						});
					}.bind(this)
				});
			}
		}, {
			key: 'other_amount_cartCalculations',
			value: function other_amount_cartCalculations(mode, other_amount) {
				this.setState({
					amount_loading: true
				});
				var uid = 0;
				var token = 0;
				var coupon_code = 0;
				var coupon_amount = 0;
	
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.token) {
					token = localStorage.getItem('token');
				} else {
					token = 0;
				}
				if (localStorage.apply_coupon_code) {
					coupon_code = localStorage.getItem('apply_coupon_code');
				} else {
					coupon_code = 0;
				}
				if (localStorage.apply_coupon) {
					coupon_amount = localStorage.getItem('apply_coupon');
				} else {
					coupon_amount = 0;
				}
	
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', uid: uid, token: token, mode: 4, add_id: this.state.cart_add_id, code: coupon_code, coupon_amount: coupon_amount, other_amount: other_amount, aqua_cash: this.state.used_cash1, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, quick_buy: 1 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cartCalculations',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								// mode_loading:false,
								amount_loading: false,
								mode: data.mode,
								ptype: data.mode,
								final_amt: data.final_amt,
								pay_at_outlet: data.pay_at_outlet,
								pay_advance: data.pay_advance,
								complete_amount: data.complete_amount,
								min_val: data.min_val,
								max_val: data.max_val,
	
								paymentMethodStatus: data.paymentMethodStatus,
								offline_payment: data.offline_payment,
								prebook_payment: data.prebook_payment,
								fullamount_payment: data.fullamount_payment,
								otheramount_payment: data.otheramount_payment,
								total_online_payment: data.total_online_payment,
								product_id: data.product_id,
								quantity: data.quantity,
								act_price: data.act_price,
								deal_price: data.deal_price,
								total: data.total,
								total_discount: data.total_discount,
								discount: data.discount,
								pre_booking_amount: data.pre_booking_amount,
								bank_fee: data.bank_fee,
								total_thx_fee: data.total_thx_fee,
								save_price: data.save_price,
								remaining_amount: data.remaining_amount,
								payable_ad: data.payable_ad,
								payable_hatchery: data.payable_hatchery,
								aqua_cash: data.aqua_cash,
								ac_offer_title: data.ac_offer_title,
								aqua_cash_value: data.aqua_cash_value,
								aqua_cash_code: data.aqua_cash_code,
								ac_cal_info: data.ac_cal_info,
								pur_ern_ofr_code: data.pur_ern_ofr_code,
								pur_ern_ofr_title: data.pur_ern_ofr_title,
								pur_ern_ofr_desc: data.pur_ern_ofr_desc,
								pur_ern_retrn_amt: data.pur_ern_retrn_amt,
								full_aquacash_back_title: data.full_aquacash_back_title,
								full_aquacash_back_code: data.full_aquacash_back_code,
								full_aquacash_back_description: data.full_aquacash_back_description,
								full_aquacash_back_amount: data.full_aquacash_back_amount,
								deal_type: data.deal_type,
								promo_code: data.promo_code,
								promo_amt: data.promo_amt,
								promo_title: data.promo_title,
								promo_help: data.promo_help,
								free_shipment: data.free_shipment,
								free_shipment_msg: data.free_shipment_msg,
								coupon_code: data.coupon_code,
								coupon_amt: data.coupon_amt,
								cart_ids: data.cart_ids,
								coupons_amt: data.coupons_amt,
								promodiscount: data.promodiscount,
								applied_promos: data.applied_promos,
	
								user_details: data.user_details,
								cart_add_id: data.add_id,
								gateway_mode: data.gateway_mode,
								deliver_date_text: data.deliver_date_text,
								payment_options: data.payment_options
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'modeChange_cartCalculations',
			value: function modeChange_cartCalculations(mode) {
				this.setState({
					mode_loading: true,
					amount_loading: true
				});
				var uid = 0;
				var token = 0;
				var coupon_code = 0;
				var coupon_amount = 0;
	
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.token) {
					token = localStorage.getItem('token');
				} else {
					token = 0;
				}
				if (localStorage.apply_coupon_code) {
					coupon_code = localStorage.getItem('apply_coupon_code');
				} else {
					coupon_code = 0;
				}
				if (localStorage.apply_coupon) {
					coupon_amount = localStorage.getItem('apply_coupon');
				} else {
					coupon_amount = 0;
				}
	
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', uid: uid, token: token, mode: mode, add_id: this.state.cart_add_id, code: coupon_code, coupon_amount: coupon_amount, other_amount: '', aqua_cash: this.state.used_cash1, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, quick_buy: 1 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cartCalculations',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								mode_loading: false,
								amount_loading: false,
								mode: data.mode,
								ptype: data.mode,
								final_amt: data.final_amt,
								pay_at_outlet: data.pay_at_outlet,
								pay_advance: data.pay_advance,
								complete_amount: data.complete_amount,
								min_val: data.min_val,
								max_val: data.max_val,
	
								paymentMethodStatus: data.paymentMethodStatus,
								offline_payment: data.offline_payment,
								prebook_payment: data.prebook_payment,
								fullamount_payment: data.fullamount_payment,
								otheramount_payment: data.otheramount_payment,
								total_online_payment: data.total_online_payment,
								product_id: data.product_id,
								quantity: data.quantity,
								act_price: data.act_price,
								deal_price: data.deal_price,
								total: data.total,
								total_discount: data.total_discount,
								discount: data.discount,
								pre_booking_amount: data.pre_booking_amount,
								bank_fee: data.bank_fee,
								total_thx_fee: data.total_thx_fee,
								save_price: data.save_price,
								remaining_amount: data.remaining_amount,
								payable_ad: data.payable_ad,
								payable_hatchery: data.payable_hatchery,
								aqua_cash: data.aqua_cash,
								ac_offer_title: data.ac_offer_title,
								aqua_cash_value: data.aqua_cash_value,
								aqua_cash_code: data.aqua_cash_code,
								ac_cal_info: data.ac_cal_info,
								pur_ern_ofr_code: data.pur_ern_ofr_code,
								pur_ern_ofr_title: data.pur_ern_ofr_title,
								pur_ern_ofr_desc: data.pur_ern_ofr_desc,
								pur_ern_retrn_amt: data.pur_ern_retrn_amt,
								full_aquacash_back_title: data.full_aquacash_back_title,
								full_aquacash_back_code: data.full_aquacash_back_code,
								full_aquacash_back_description: data.full_aquacash_back_description,
								full_aquacash_back_amount: data.full_aquacash_back_amount,
								deal_type: data.deal_type,
								promo_code: data.promo_code,
								promo_amt: data.promo_amt,
								promo_title: data.promo_title,
								promo_help: data.promo_help,
								free_shipment: data.free_shipment,
								free_shipment_msg: data.free_shipment_msg,
								coupon_code: data.coupon_code,
								coupon_amt: data.coupon_amt,
								cart_ids: data.cart_ids,
								coupons_amt: data.coupons_amt,
								promodiscount: data.promodiscount,
								applied_promos: data.applied_promos,
	
								user_details: data.user_details,
								cart_add_id: data.add_id
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			// close function is used to close both edit address modal & add address modal boxes.
	
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					add_address: false,
					edit_address: false
				});
			}
			// handleSubmit_add function for submitting the new address when click on add new address 
	
		}, {
			key: 'handleSubmit_add',
			value: function handleSubmit_add(event) {
				event.preventDefault();
				var name = this.refs.add_name.value;
				var mobile = this.refs.add_mobile.value;
				var state = this.refs.add_state.value;
				var city = this.refs.add_city.value;
				var doorno = this.refs.add_doorno.value;
				var pincode = this.refs.add_pincode.value;
	
				var flag = 0;
				var namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
				if (name && !namePattern.test(name)) {
					(0, _jquery2.default)('#add_name_err').text('*name is minimum 3 characters');
					flag = 1;
				}
				if (mobile.length < 10) {
					(0, _jquery2.default)('#add_mobile_err').text('*enter valid number');
					flag = 1;
				}
				if (state && !namePattern.test(state) && state.length < 2) {
					(0, _jquery2.default)('#add_state_err').text('*enter state');
					flag = 1;
				}
				if (city && !namePattern.test(city)) {
					(0, _jquery2.default)('#add_city_err').text('*enter city');
					flag = 1;
				}
				if (doorno && doorno.length <= 1) {
					(0, _jquery2.default)('#add_doorno_err').text('*enter address');
					flag = 1;
				}
				if (pincode && pincode.length < 6) {
					(0, _jquery2.default)('#add_pincode_err').text('*enter valid pincode');
					flag = 1;
				}
				if (flag === 0) {
					var baseUrl = 'https://aquadeals.in/admin/web3/user/';
					var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, name: name, mobile: mobile, state: state, city: city, address: doorno, zip: pincode, quick_buy: 1 };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'saveAdd',
						success: function (data) {
							if (data.status === "success") {
								this.close();
								this.getUserAddress();
								this.setState({
									add_state: '',
									add_city: '',
									add_doorno: '',
									add_pincode: ''
								});
							}
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
			//handleSubmit_edit function for updating the address when click on edit icon in the swipe list.
	
		}, {
			key: 'handleSubmit_edit',
			value: function handleSubmit_edit(event) {
				event.preventDefault();
				var add_id = this.state.edit_add_id;
	
				var name = this.refs.edit_name.value;
				var mobile = this.refs.edit_mobile.value;
				var state = this.refs.edit_state.value;
				var city = this.refs.edit_city.value;
				var doorno = this.refs.edit_doorno.value;
				var pincode = this.refs.edit_pincode.value;
	
				var flag = 0;
				// const emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
				var namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
				if (name && !namePattern.test(name)) {
					(0, _jquery2.default)('#edit_name_err').text('*name is minimum 3 characters');
					flag = 1;
				}
				if (mobile.length < 10) {
					(0, _jquery2.default)('#edit_mobile_err').text('*enter valid number');
					flag = 1;
				}
				if (state && !namePattern.test(state) && state.length < 2) {
					(0, _jquery2.default)('#edit_state_err').text('*enter state');
					flag = 1;
				}
				if (city && !namePattern.test(city)) {
					(0, _jquery2.default)('#edit_city_err').text('*enter city');
					flag = 1;
				}
				if (doorno && doorno.length <= 1) {
					(0, _jquery2.default)('#edit_doorno_err').text('*enter address');
					flag = 1;
				}
				if (pincode && pincode.length < 6) {
					(0, _jquery2.default)('#edit_pincode_err').text('*enter valid pincode');
					flag = 1;
				}
				if (flag === 0) {
					var baseUrl = 'https://aquadeals.in/admin/web3/user/';
					var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, add_id: add_id, name: name, mobile: mobile, state: state, city: city, address: doorno, zip: pincode, quick_buy: 1 };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'updateAdd',
						success: function (data) {
							if (data.status === "success") {
								this.close();
								this.getUserAddress();
							}
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
			//editAddress function for when click on edit icon that enables the status of the Edit form modal
	
		}, {
			key: 'editAddress',
			value: function editAddress(add_id) {
				this.setState({
					edit_add_id: add_id,
					edit_address: true
				});
			}
			// deleteAddress function is used when click on deleted icon in swipe address list
	
		}, {
			key: 'deleteAddress',
			value: function deleteAddress(add_id) {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: localStorage.user_id, token: localStorage.token, add_id: add_id, quick_buy: 1 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'deleteAdd',
					success: function (data) {
						if (data.status === "success") {
							this.getUserAddress();
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			// getAddressDetails function is used to get the address details from server when click the edit icon and edit modal form is opened. 
	
		}, {
			key: 'getAddressDetails',
			value: function getAddressDetails() {
				var add_id = this.state.edit_add_id;
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', uid: localStorage.user_id, token: localStorage.token, id: add_id, quick_buy: 1 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'get_add_details',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								edit_data: data.data,
								edit_name: data.data[0]['name'],
								edit_mobile: data.data[0]['phone'],
								edit_state: data.data[0]['state'],
								edit_city: data.data[0]['city'],
								edit_doorno: data.data[0]['address'],
								edit_pincode: data.data[0]['zip']
							});
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			//******************
			/* functions for EDIT form validations and upations start here  */
			// edit_nameChange function is used to set the edit_name value edit modal form.
	
		}, {
			key: 'edit_nameChange',
			value: function edit_nameChange(event) {
				// this.setState({
				// 	edit_name:event.target.value,
				// });
				var x = event.target.value;
				var invalidChars = /[^a-zA-Z ]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						edit_name: x
					});
				}
			}
		}, {
			key: 'edit_mobileChange',
			value: function edit_mobileChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						edit_mobile: x
					});
				}
			}
		}, {
			key: 'edit_stateChange',
			value: function edit_stateChange(event) {
				// this.setState({
				// 	edit_state:event.target.value,
				// });
				var x = event.target.value;
				var invalidChars = /[^a-zA-Z ]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						edit_state: x
	
					});
				}
			}
		}, {
			key: 'edit_cityChange',
			value: function edit_cityChange(event) {
				// this.setState({
				// 	edit_city:event.target.value,
				// });
				var x = event.target.value;
				var invalidChars = /[^a-zA-Z]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						edit_city: x
					});
				}
			}
		}, {
			key: 'edit_doornoChange',
			value: function edit_doornoChange(event) {
				this.setState({
					edit_doorno: event.target.value
				});
			}
		}, {
			key: 'edit_pincodeChange',
			value: function edit_pincodeChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						edit_pincode: x
					});
				}
				// this.setState({
				// 	edit_pincode:event.target.value,
				// });
			}
			// **********************************
			// functions for "EDIT" form validations and upations "ENDS" here
	
			// functions for "ADD" form validations and updations START here 
			// ***************************************
	
		}, {
			key: 'add_nameChange',
			value: function add_nameChange(event) {
				// this.setState({
				// 	add_name:event.target.value,
				// });
				var x = event.target.value;
				var invalidChars = /[^a-zA-Z ]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						add_name: x
					});
				}
			}
		}, {
			key: 'add_mobileChange',
			value: function add_mobileChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						add_mobile: x
					});
				}
			}
		}, {
			key: 'add_stateChange',
			value: function add_stateChange(event) {
				// this.setState({
				// 	add_state:event.target.value,
				// });
				var x = event.target.value;
				var invalidChars = /[^a-zA-Z]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						add_state: x
	
					});
				}
			}
		}, {
			key: 'add_cityChange',
			value: function add_cityChange(event) {
				// this.setState({
				// 	add_city:event.target.value,
				// });
				var x = event.target.value;
				var invalidChars = /[^a-zA-Z]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						add_city: x
					});
				}
			}
		}, {
			key: 'add_doornoChange',
			value: function add_doornoChange(event) {
				this.setState({
					add_doorno: event.target.value
				});
			}
		}, {
			key: 'add_pincodeChange',
			value: function add_pincodeChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						add_pincode: x
					});
				}
			}
			// ***********************************
			// setDefaultAddress function is used to set the default address when click on circle image in address block 
			// setDefaultAddress(add_id)
			// {
			// 	var baseUrl='https://aquadeals.in/admin/web3/user/';
			// 	var data1={from:'desktop_web',id:localStorage.user_id,token:localStorage.token,add_id:add_id,quick_buy:1};
			// 	var data2=JSON.stringify(data1);
			// 	$.ajax({
			// 		method:'POST',
			// 		dataType:'json',
			// 		data:{req:data2},
			// 		url:baseUrl+'setdefault_address',
			// 		success:function(data)
			// 		{
			// 			if(data.status==="success")
			// 			{
			// 				this.getUserAddress();
			// 			}
			// 		}.bind(this),
			// 		error:function(err)
			// 		{
			// 			console.log(err);
			// 		}
			// 	});
			// }
			//setPaymentMode is used to set the mode of the payment like 2 for - advance,3 for total,4 for other and calling the modeChange_cartCalculations
			//hiding the other amount input field and calling
	
		}, {
			key: 'setPaymentMode',
			value: function setPaymentMode(id) {
				this.setState({
					ptype: id,
					mode: id
				});
				if (id === 4) {
					this.setState({
						other_amount_field_status: true
					});
				} else {
					this.setState({
						other_amount_field_status: false
					});
					this.modeChange_cartCalculations(id);
				}
			}
		}, {
			key: 'validateOtherAmount',
			value: function validateOtherAmount() {
				this.setState({
					err_qty_status: false,
					err_qty_msg: ''
				});
				var x = '';
				if (parseInt(this.refs.ref_other_amt.value, 10) < parseInt(this.state.min_val, 10)) {
					x = 'Minimum Quantity is ' + this.state.min_val;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Minimum amount is ' + this.state.min_val
					});
				}
				if (parseInt(this.refs.ref_other_amt.value, 10) > parseInt(this.state.max_val, 10)) {
					// alert('Maximum Quantity is '+this.state.max_qty);
					x = 'Maximum Quantity is ' + this.state.max_val;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Maximum amount is ' + this.state.max_val
					});
				}
				var check = /[^0-9]/gi;
				if (check.test(this.refs.ref_other_amt.value)) {
					x = '* Invalid Amount';
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Invalid Amount'
					});
				}
	
				// this.other_amount_cartCalculations(4,this.refs.ref_other_amt.value);
	
				if (x === '') {
					this.other_amount_cartCalculations(4, this.refs.ref_other_amt.value);
				}
			}
		}, {
			key: 'handleTabsSelect',
			value: function handleTabsSelect(key) {
				this.setState({
					evnt_key: key
				});
				this.modeChange_cartCalculations(key);
			}
			// functions for "ADD" form validations and updations END here 
	
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				document.title = "Quick Buy Checkout | AquaDeals";
				var coupon_map = this.state.coupons.map(function (coupon, index) {
					return _react2.default.createElement(
						'span',
						{ key: index, style: { display: 'block' } },
						coupon.coupon_code,
						' (\u20B9',
						coupon.value,
						' )'
					);
				});
				var couponsList = _react2.default.createElement(
					_reactBootstrap.Popover,
					{ id: 'popover-positioned-top1' },
					coupon_map
				);
				var coupon_info = _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{ trigger: 'focus', placement: 'top', overlay: couponsList },
					_react2.default.createElement(
						_reactBootstrap.Button,
						{ className: 'cartCoupon_info_img' },
						_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_info.png', alt: ' ' })
					)
				);
	
				var promos_map = this.state.promos.map(function (promo, index) {
					return _react2.default.createElement(
						'span',
						{ key: index, style: { display: 'block' } },
						promo.promo_code,
						' ( \u20B9 ',
						promo.promo_value,
						' )'
					);
				});
				var promosList = _react2.default.createElement(
					_reactBootstrap.Popover,
					{ id: 'popover-positioned-top2' },
					promos_map
				);
	
				var promo_info = '';
				promo_info = _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{ trigger: 'focus', placement: 'top', overlay: promosList },
					_react2.default.createElement(
						_reactBootstrap.Button,
						{ className: 'cartCoupon_info_img' },
						_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_info.png', alt: ' ' })
					)
				);
				var Items = this.state.cart_items.map(function (item, index) {
					return _react2.default.createElement(
						'div',
						{ className: 'row cart_ItemsList' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-sm-2 col-md-2 col-lg-2 webcart_centerimg' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: item.type === 0 ? '/web/sdetails/' + item.url_name + '/' + item.deal_id : '/web/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
									item.type === 0 ? _react2.default.createElement('img', { src: baseAssets + 'icons/' + item.img, alt: ' ' }) : _react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/thumbnails/' + item.img, alt: ' ' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'cartdesc_Blk' },
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-2 col-md-2 col-sm-2 col-xs-2 cart_title_blk' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: item.type === 0 ? '/web/sdetails/' + item.url_name + '/' + item.deal_id : '/web/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
										item.pro_name !== "" ? _react2.default.createElement(
											'h3',
											{ className: 'cartitem_Title' },
											item.pro_name
										) : _react2.default.createElement(
											'h3',
											{ className: 'cartitem_Title' },
											'\xA0'
										),
										item.brand ? _react2.default.createElement(
											'h4',
											{ className: 'cartitem_Brand' },
											item.brand
										) : _react2.default.createElement(
											'h4',
											null,
											'\xA0'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-2 col-lg-2 col-sm-2 text-right' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: item.type === 0 ? '/web/sdetails/' + item.url_name + '/' + item.deal_id : '/web/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
										item.mrp !== '' ? _react2.default.createElement(
											'h3',
											{ className: 'webcart_mrp' },
											'\u20B9',
											item.mrp
										) : _react2.default.createElement(
											'h3',
											null,
											'\xA0'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-3 col-sm-3 col-md-3 col-lg-3 text-center' },
									item.min_qty !== "" ? _react2.default.createElement(
										'p',
										{ className: 'webQty_Edit cart_edit ' },
										item.qty
									) : _react2.default.createElement(
										'p',
										null,
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-2 col-sm-2 col-md-2 col-lg-2', style: { paddingLeft: '0px', paddingRight: '0px' } },
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: item.type === 0 ? '/web/sdetails/' + item.url_name + '/' + item.deal_id : '/web/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
										item.amount !== "" ? _react2.default.createElement(
											'p',
											{ className: 'cartitem_amount cart_amt' },
											_react2.default.createElement(
												'span',
												null,
												'\u20B9 '
											),
											_react2.default.createElement(
												'span',
												null,
												item.amount
											)
										) : _react2.default.createElement(
											'p',
											null,
											'\xA0'
										)
									)
								),
								_react2.default.createElement('div', { className: 'col-lg-1 col-md-1 col-sm-1 col-xs-1' })
							)
						)
					);
				});
				(0, _jquery2.default)('.mob_check').unbind("click").click(function () {
					(0, _jquery2.default)(".mob_check img").attr("src", "https://aquadeals.in/admin/assets/images/icons/circle_gray.png");
					var sel_addr_id = (0, _jquery2.default)(this).attr("id");
					var add_id = sel_addr_id.replace('swipe-addr-id_', '');
					(0, _jquery2.default)("#" + sel_addr_id + " .mob_check img").attr("src", "https://aquadeals.in/admin/assets/images/icons/ok.png");
					//$(".swipe_addr_blk .mob_check img").attr('src',"https://aquadeals.in/admin/assets/images/icons/circle_gray.png");
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, add_id: add_id, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'setdefault_address',
						success: function (data) {
							if (data.status === "success") {
								//this.getUserAddress();
							}
						}.bind(this),
						error: function error(err) {
							console.log(err);
						}
					});
				});
	
				var tabs_data = '';
				// $('#off_modal_status').parent().addClass('offline_modal');
				if (this.state.paymentMethodStatus === 'Both') {
					tabs_data = _react2.default.createElement(
						_reactBootstrap.Tabs,
						{ activeKey: this.state.evnt_key, className: 'web_pay_both', id: 'controlled-tab-ex', onSelect: this.handleTabsSelect },
						_react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: 2, title: 'ONLINE' },
							_react2.default.createElement(
								'div',
								null,
								this.state.prebook_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group web_group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 2 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_adv', checked: this.state.ptype === 2 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(2);
											}, required: true }),
										'Pay Advance \u20B9 ',
										this.state.pay_advance
									)
								) : '',
								this.state.otheramount_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group web_group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 4 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_other', checked: this.state.ptype === 4 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(4);
											}, required: true }),
										'Pay Other Advance ',
										this.state.other_amount_field_status ? _react2.default.createElement(
											'span',
											{ style: { marginLeft: '10px', position: 'absolute' } },
											_react2.default.createElement('input', { onBlur: function onBlur() {
													return _this3.validateOtherAmount();
												}, onChange: function onChange() {
													return _this3.validateOtherAmount();
												}, ref: 'ref_other_amt', id: 'ref_other_amt', type: 'text', placeholder: 'Enter Amount' }),
											this.state.err_qty_status ? _react2.default.createElement(
												'span',
												{ className: 'error_other_amt' },
												this.state.err_qty_msg
											) : ''
										) : ''
									)
								) : '',
								this.state.fullamount_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group web_group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 3 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_total', checked: this.state.ptype === 3 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(3);
											}, required: true }),
										'Pay Total \u20B9 ',
										this.state.final_amt
									)
								) : '',
								this.state.free_shipment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'web_ship_van' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
									),
									' ',
									this.state.free_shipment_msg
								) : '',
								this.state.full_aquacash_back_title ? _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/newcashback.png', alt: '', width: '20px' }),
										' '
									),
									' ',
									this.state.full_aquacash_back_title
								) : ''
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: 1, title: 'OFFLINE' },
							_react2.default.createElement(
								'div',
								null,
								this.state.offline_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group web_group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 1 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_outlet', checked: this.state.ptype === 1 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(1);
											}, required: true }),
										'Pay at Outlet \u20B9 ',
										this.state.final_amt
									),
									this.state.free_shipment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'web_ship_van' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
										),
										' ',
										this.state.free_shipment_msg
									) : '',
									this.state.full_aquacash_back_title ? _react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/newcashback.png', alt: '', width: '20px' }),
											' '
										),
										' ',
										this.state.full_aquacash_back_title
									) : ''
								) : ''
							)
						)
					);
				} else if (this.state.paymentMethodStatus === 'Online') {
					tabs_data = _react2.default.createElement(
						_reactBootstrap.Tabs,
						{ activeKey: this.state.evnt_key, className: 'pay_online', id: 'controlled-tab-ex', onSelect: this.handleTabsSelect },
						_react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: 2, title: 'ONLINE' },
							_react2.default.createElement(
								'div',
								null,
								this.state.prebook_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 2 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_adv', checked: this.state.ptype === 2 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(2);
											}, required: true }),
										'Pay Advance \u20B9 ',
										this.state.pay_advance
									)
								) : '',
								this.state.otheramount_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 4 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_other', checked: this.state.ptype === 4 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(4);
											}, required: true }),
										'Pay Other Advance ',
										this.state.other_amount_field_status ? _react2.default.createElement(
											'span',
											{ style: { marginLeft: '10px', position: 'absolute' } },
											_react2.default.createElement('input', { onChange: function onChange() {
													return _this3.validateOtherAmount();
												}, onBlur: function onBlur() {
													return _this3.validateOtherAmount();
												}, ref: 'ref_other_amt', id: 'ref_other_amt', type: 'text', placeholder: 'Enter Amount' }),
											this.state.err_qty_status ? _react2.default.createElement(
												'span',
												{ className: 'error_other_amt' },
												this.state.err_qty_msg
											) : ''
										) : ''
									)
								) : '',
								this.state.fullamount_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 3 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_total', checked: this.state.ptype === 3 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(3);
											}, required: true }),
										'Pay Total \u20B9 ',
										this.state.final_amt
									)
								) : '',
								this.state.free_shipment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'web_ship_van' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
									),
									' ',
									this.state.free_shipment_msg
								) : '',
								this.state.full_aquacash_back_title ? _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/newcashback.png', alt: '', width: '20px' }),
										' '
									),
									' ',
									this.state.full_aquacash_back_title
								) : ''
							)
						),
						this.state.offline_payment === 1 ? _react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: 1, title: 'OFFLINE' },
							_react2.default.createElement(
								'div',
								null,
								this.state.offline_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 1 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_outlet', checked: this.state.ptype === 1 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(1);
											}, required: true }),
										'Pay at Outlet \u20B9 ',
										this.state.final_amt
									),
									this.state.free_shipment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'web_ship_van' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
										),
										' ',
										this.state.free_shipment_msg
									) : '',
									this.state.full_aquacash_back_title ? _react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/newcashback.png', alt: '', width: '20px' }),
											' '
										),
										' ',
										this.state.full_aquacash_back_title
									) : ''
								) : ''
							)
						) : ''
					);
				} else if (this.state.paymentMethodStatus === 'Offline') {
					tabs_data = _react2.default.createElement(
						_reactBootstrap.Tabs,
						{ activeKey: 1, className: 'pay_offline', id: 'controlled-tab-ex' },
						this.state.offline_payment === 1 ? _react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: 1, title: 'OFFLINE' },
							_react2.default.createElement(
								'div',
								null,
								this.state.offline_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 1 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_outlet', checked: this.state.ptype === 1 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(1);
											}, required: true }),
										'Pay at Outlet \u20B9 ',
										this.state.final_amt
									),
									this.state.free_shipment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'web_ship_van' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
										),
										' ',
										this.state.free_shipment_msg
									) : '',
									this.state.full_aquacash_back_title ? _react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/newcashback.png', alt: '', width: '20px' }),
											' '
										),
										' ',
										this.state.full_aquacash_back_title
									) : ''
								) : ''
							)
						) : ''
					);
				} else if (this.state.paymentMethodStatus === 'None') {
					tabs_data = _react2.default.createElement(
						_reactBootstrap.Tabs,
						{ activeKey: this.state.evnt_key, id: 'controlled-tab-ex', onSelect: this.handleTabsSelect, className: 'pay_partner' },
						_react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: 2, title: 'ONLINE' },
							_react2.default.createElement(
								'div',
								null,
								this.state.prebook_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 2 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_adv', checked: this.state.ptype === 2 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(2);
											}, required: true }),
										'Pay Advance \u20B9 ',
										this.state.pay_advance
									)
								) : '',
								this.state.otheramount_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 4 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_other', checked: this.state.ptype === 4 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(4);
											}, required: true }),
										'Pay Other Advance ',
										this.state.other_amount_field_status ? _react2.default.createElement(
											'span',
											{ style: { marginLeft: '10px', position: 'absolute' } },
											_react2.default.createElement('input', { onBlur: function onBlur() {
													return _this3.validateOtherAmount();
												}, onChange: function onChange() {
													return _this3.validateOtherAmount();
												}, ref: 'ref_other_amt', id: 'ref_other_amt', type: 'text', placeholder: 'Enter Amount' }),
											this.state.err_qty_status ? _react2.default.createElement(
												'span',
												{ className: 'error_other_amt' },
												this.state.err_qty_msg
											) : ''
										) : ''
									)
								) : '',
								this.state.fullamount_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 3 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_total', checked: this.state.ptype === 3 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(3);
											}, required: true }),
										'Pay Total \u20B9 ',
										this.state.final_amt
									)
								) : '',
								this.state.free_shipment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'web_ship_van' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
									),
									' ',
									this.state.free_shipment_msg
								) : '',
								this.state.full_aquacash_back_title ? _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/newcashback.png', alt: '', width: '20px' }),
										' '
									),
									' ',
									this.state.full_aquacash_back_title
								) : ''
							)
						),
						this.state.offline_payment === 1 ? _react2.default.createElement(
							_reactBootstrap.Tab,
							{ eventKey: 1, title: 'OFFLINE' },
							_react2.default.createElement(
								'div',
								null,
								this.state.offline_payment === 1 ? _react2.default.createElement(
									'div',
									{ className: 'group' },
									_react2.default.createElement(
										'label',
										{ className: this.state.ptype === 1 ? 'pay_active' : 'pay_inactive' },
										_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_outlet', checked: this.state.ptype === 1 ? true : false, onChange: function onChange() {
												_this3.setPaymentMode(1);
											}, required: true }),
										'Pay at Outlet \u20B9 ',
										this.state.final_amt
									),
									this.state.free_shipment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'web_ship_van' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', alt: '', width: '25px' })
										),
										' ',
										this.state.free_shipment_msg
									) : '',
									this.state.full_aquacash_back_title ? _react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/newcashback.png', alt: '', width: '20px' }),
											' '
										),
										' ',
										this.state.full_aquacash_back_title
									) : ''
								) : ''
							)
						) : ''
					);
				}
	
				// edit form empty errors when click on the text input fields starts here
				(0, _jquery2.default)('#edit_name').keyup(function () {
					(0, _jquery2.default)('#edit_name_err').text('');
				});
				(0, _jquery2.default)('#edit_mobile').keyup(function () {
					(0, _jquery2.default)('#edit_mobile_err').text('');
				});
				(0, _jquery2.default)('#edit_state').keyup(function () {
					(0, _jquery2.default)('#edit_state_err').text('');
				});
				(0, _jquery2.default)('#edit_city').keyup(function () {
					(0, _jquery2.default)('#edit_city_err').text('');
				});
				(0, _jquery2.default)('#edit_doorno').keyup(function () {
					(0, _jquery2.default)('#edit_doorno_err').text('');
				});
				(0, _jquery2.default)('#edit_pincode').keyup(function () {
					(0, _jquery2.default)('#edit_pincode_err').text('');
				});
				// edit form validations ends here
	
				// add form removing error msg's when click on input fields start here
				(0, _jquery2.default)('#add_name').keyup(function () {
					(0, _jquery2.default)('#add_name_err').text('');
				});
				(0, _jquery2.default)('#add_mobile').keyup(function () {
					(0, _jquery2.default)('#add_mobile_err').text('');
				});
				(0, _jquery2.default)('#add_state').keyup(function () {
					(0, _jquery2.default)('#add_state_err').text('');
				});
				(0, _jquery2.default)('#add_city').keyup(function () {
					(0, _jquery2.default)('#add_city_err').text('');
				});
				(0, _jquery2.default)('#add_doorno').keyup(function () {
					(0, _jquery2.default)('#add_doorno_err').text('');
				});
				(0, _jquery2.default)('#add_pincode').keyup(function () {
					(0, _jquery2.default)('#add_pincode_err').text('');
				});
				var params = {
					paginationClickable: true,
					spaceBetween: 30,
					slidesPerView: 2.2,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
	
				};
	
				var delivery_address = this.state.user_address.map(function (data, index) {
					var _this4 = this;
	
					return localStorage.address_change_flag === '0' ? _react2.default.createElement(
						_reactBootstrap.Col,
						{ md: 8, xs: 8, className: 'swipe_addr_blk', id: "swipe-addr-id_" + data.add_id },
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 2, sm: 2, xs: 2, className: 'mob_check', id: "swipe-addr-id_" + data.add_id },
							_react2.default.createElement('img', { src: data.default === '1' ? baseAssets + 'images/icons/ok.png' : baseAssets + 'images/icons/circle_gray.png', alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ style: { margin: '0 20px' } },
							_react2.default.createElement(
								_reactBootstrap.Col,
								{ md: 8, sm: 8, xs: 8, className: 's_data_blk' },
								_react2.default.createElement(
									'p',
									null,
									data.name,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.mobile,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.state,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.city,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.address,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.zip,
									'\xA0'
								)
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 12, sm: 12, xs: 12, style: { paddingLeft: '0px', paddingRight: '0px' } },
							_react2.default.createElement(
								'ul',
								{ className: 'addr_btns' },
								'// ',
								_react2.default.createElement(
									'li',
									{ onClick: function onClick() {
											_this4.editAddress(data.add_id);
										} },
									'EDIT'
								),
								'// ',
								_react2.default.createElement(
									'li',
									{ onClick: function onClick() {
											return _this4.deleteAddress(data.add_id);
										} },
									'DELETE'
								),
								_react2.default.createElement(
									'div',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									null,
									'\xA0'
								)
							)
						)
					) : _react2.default.createElement(
						_reactBootstrap.Col,
						{ md: 8, xs: 8, className: 'swipe_addr_blk', id: "swipe-addr-id_" + data.add_id },
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 2, sm: 2, xs: 2, className: 'mob_check', id: "swipe-addr-id_" + data.add_id },
							_react2.default.createElement('img', { src: data.default === '1' ? baseAssets + 'images/icons/ok.png' : baseAssets + 'images/icons/circle_gray.png', alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ style: { margin: '0 20px' } },
							_react2.default.createElement(
								_reactBootstrap.Col,
								{ md: 8, sm: 8, xs: 8, className: 's_data_blk' },
								_react2.default.createElement(
									'p',
									null,
									data.name,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.mobile,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.state,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.city,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.address,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.zip,
									'\xA0'
								)
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 12, sm: 12, xs: 12, style: { paddingLeft: '0px', paddingRight: '0px' } },
							_react2.default.createElement(
								'ul',
								{ className: 'addr_btns' },
								_react2.default.createElement(
									'li',
									{ onClick: function onClick() {
											_this4.editAddress(data.add_id);
										} },
									'EDIT'
								),
								_react2.default.createElement(
									'li',
									{ onClick: function onClick() {
											return _this4.deleteAddress(data.add_id);
										} },
									'DELETE'
								)
							)
						)
					);
				}.bind(this));
	
				var offline_success = _react2.default.createElement(
					'section',
					{ className: 'offline_success_data' },
					_react2.default.createElement(
						_reactBootstrap.Modal.Header,
						{ className: 'offline_header_section' },
						_react2.default.createElement(
							'div',
							{ className: '' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: "/web/home" },
									_react2.default.createElement(
										'i',
										{ style: { marginRight: '15px' } },
										_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png', width: '16px', alt: '' })
									)
								),
								'Confirmation'
							),
							_react2.default.createElement(
								'a',
								{ href: '/web/home', className: 'web_home_icon' },
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/home2.png', alt: 'Home' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ style: { textAlign: 'center', paddingBottom: '10px' } },
						_react2.default.createElement(
							'i',
							null,
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png', alt: 'AquaDeals', width: '100px' })
						),
						_react2.default.createElement(
							'h5',
							{ style: { color: 'green' } },
							this.state.offline_confirm_data.success_msg
						),
						_react2.default.createElement(
							'h6',
							{ style: { color: '#ff742a' } },
							this.state.offline_confirm_data.thank_msg
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal_ordr_dtls_blk' },
						_react2.default.createElement(
							'div',
							{ className: 'web_modal_ordr_dtls' },
							_react2.default.createElement(
								'h5',
								null,
								'Order Details'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: '', style: { padding: '10px' } },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									'span',
									null,
									'SELLER NAME : '
								),
								_react2.default.createElement(
									'span',
									null,
									this.state.offline_confirm_data.address ? this.state.offline_confirm_data.address.seller_name : ''
								)
							),
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									'span',
									null,
									'ORDER NO'
								),
								_react2.default.createElement(
									'span',
									{ style: { float: 'right' } },
									'ORDER DATE'
								)
							),
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									'span',
									null,
									this.state.offline_confirm_data.book_id
								),
								_react2.default.createElement(
									'span',
									{ style: { float: 'right' } },
									this.state.offline_confirm_data.booking_date ? this.state.offline_confirm_data.booking_date : ''
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'modal_pro_details_blk' },
						_react2.default.createElement(
							'div',
							{ className: 'web_modal_pro_title' },
							_react2.default.createElement(
								'h5',
								null,
								'Product Details '
							)
						),
						_react2.default.createElement(
							'div',
							{ style: { padding: '10px' } },
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									null,
									'Item : ',
									this.state.offline_confirm_data.qty ? this.state.offline_confirm_data.qty : ''
								),
								_react2.default.createElement(
									'span',
									{ style: { float: 'right' } },
									'Total : ',
									this.state.offline_confirm_data.remaining_amount ? this.state.offline_confirm_data.remaining_amount : ''
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: '', style: { backgroundColor: '#fff', overflow: 'hidden', paddingBottom: '10px', marginTop: '10px' } },
						this.state.offline_confirm_data.order_items ? this.state.offline_confirm_data.order_items.map(function (data, index) {
							return _react2.default.createElement(
								'div',
								{ className: 'col-xs-12 col-md-12', style: { padding: '0px', paddingTop: '15px', paddingBottom: '15px', borderTop: '1px solid #eee' } },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-3 col-md-3' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/product_imgs/thumbnails/20170323130243537436.jpg', alt: ' ' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-6 col-md-6', style: { padding: '0px' } },
									_react2.default.createElement(
										'p',
										null,
										data.pro_name,
										' ',
										data.unit
									),
									_react2.default.createElement(
										'p',
										null,
										'QTY : ',
										data.quantity
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-3 col-md-3', style: { padding: '0px' } },
									_react2.default.createElement(
										'p',
										{ style: { marginTop: '17px' } },
										'\u20B9 ',
										data.deal_amt
									)
								)
							);
						}) : ''
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ style: { backgroundColor: '#f1f1f2', padding: '5px 0px 5px 10px' } },
							_react2.default.createElement(
								'h5',
								null,
								'PAYMENT DETAILS'
							)
						),
						_react2.default.createElement(
							'div',
							{ style: { backgroundColor: '#fff', padding: '10px' } },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									'span',
									null,
									this.state.offline_confirm_data.payment_details ? this.state.offline_confirm_data.payment_details[0].title : ''
								),
								_react2.default.createElement(
									'span',
									{ style: { float: 'right' } },
									'\u20B9 ',
									this.state.offline_confirm_data.payment_details ? this.state.offline_confirm_data.payment_details[0].value : ''
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: '', style: { backgroundColor: '#f1f1f2', padding: '5px 0px 5px 10px' } },
							_react2.default.createElement(
								'h5',
								null,
								'SHIPPING ADDRESS'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: '', style: { backgroundColor: '#fff', padding: '10px' } },
							_react2.default.createElement(
								'p',
								null,
								this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].name : ''
							),
							_react2.default.createElement(
								'p',
								null,
								this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].address : '',
								' , ',
								this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].city : '',
								' '
							),
							_react2.default.createElement(
								'p',
								null,
								this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].state : ''
							),
							_react2.default.createElement(
								'p',
								null,
								this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].phone : ''
							),
							_react2.default.createElement(
								'p',
								null,
								this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].zip : ''
							)
						)
					)
				);
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_quick_checkout_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							_reactBootstrap.Breadcrumb,
							{ className: 'webcheckout_breadcrumb' },
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb.Item,
								{ href: '/web/home' },
								'Home'
							),
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb.Item,
								{ active: true },
								'Quick Checkout'
							)
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'container' },
						this.state.offline_success ? _react2.default.createElement(
							'div',
							{ className: 'col-md-12 web_dels_cntnt' },
							offline_success
						) : _react2.default.createElement(
							'div',
							{ className: 'col-md-12 col-lg-12 col-sm-12 web_dels_cntnt' },
							this.state.page_loading ? _react2.default.createElement(
								'div',
								null,
								parseInt(this.state.cart_count, 10) > 0 ? _react2.default.createElement(
									'div',
									{ className: 'body_content' },
									this.state.paying_process ? _react2.default.createElement(
										'div',
										{ className: 'web_checkout_loading' },
										_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/loading_more.gif', alt: 'Loading' })
									) : _react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'container' },
												_react2.default.createElement(
													'section',
													{ id: 'cart-process' },
													_react2.default.createElement(
														'div',
														{ className: 'progressbar-wrapper', style: { background: 'unset!important' } },
														_react2.default.createElement(
															'ul',
															{ className: 'progressbar' },
															_react2.default.createElement(
																'li',
																{ className: 'active' },
																_react2.default.createElement(
																	'div',
																	null,
																	'Cart'
																),
																_react2.default.createElement(
																	'div',
																	null,
																	_react2.default.createElement(_reactWebVectorIcons2.default, {
																		name: 'check',
																		font: 'Entypo',
																		color: '#fff',
																		size: 14
																		// style={{}}
																	})
																)
															),
															_react2.default.createElement(
																'li',
																null,
																_react2.default.createElement(
																	'div',
																	null,
																	'Checkout'
																),
																_react2.default.createElement(
																	'div',
																	null,
																	_react2.default.createElement(_reactWebVectorIcons2.default, {
																		name: 'check',
																		font: 'Entypo',
																		color: '#fff',
																		size: 14
																		// style={{}}
																	})
																)
															),
															_react2.default.createElement(
																'li',
																null,
																'Payment'
															)
														)
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'col-lg-3 col-md-3 col-sm-3' },
													_react2.default.createElement(
														'div',
														{ className: 'web_chk_dlry_title_blk' },
														_react2.default.createElement(
															'h4',
															null,
															'ADD SHIPPING ADDRESS'
														)
													),
													_react2.default.createElement(
														'form',
														{ className: 'web_add_address_form', onSubmit: this.handleSubmit_add },
														_react2.default.createElement(
															'div',
															{ className: 'web_add_form_blk' },
															_react2.default.createElement('input', { type: 'text', placeholder: 'Name', ref: 'add_name', id: 'add_name', value: this.state.add_name, onChange: this.add_nameChange, required: true }),
															_react2.default.createElement('p', { id: 'add_name_err' }),
															_react2.default.createElement('input', { type: 'text', maxLength: 10, placeholder: 'Mobile', ref: 'add_mobile', id: 'add_mobile', value: this.state.add_mobile, onChange: this.add_mobileChange, required: true }),
															_react2.default.createElement('p', { id: 'add_mobile_err' }),
															_react2.default.createElement('input', { type: 'text', placeholder: 'Enter State', ref: 'add_state', id: 'add_state', value: this.state.add_state, onChange: this.add_stateChange, required: true }),
															_react2.default.createElement('p', { id: 'add_state_err' }),
															_react2.default.createElement('input', { type: 'text', placeholder: 'Enter City/Town', ref: 'add_city', id: 'add_city', value: this.state.add_city, onChange: this.add_cityChange, required: true }),
															_react2.default.createElement('p', { id: 'add_city_err' }),
															_react2.default.createElement('input', { type: 'text', placeholder: 'Door No/Landmark', ref: 'add_doorno', id: 'add_doorno', value: this.state.add_doorno, onChange: this.add_doornoChange, required: true }),
															_react2.default.createElement('p', { id: 'add_doorno_err' }),
															_react2.default.createElement('input', { type: 'text', maxLength: 6, placeholder: 'Pincode', ref: 'add_pincode', id: 'add_pincode', value: this.state.add_pincode, onChange: this.add_pincodeChange, required: true }),
															_react2.default.createElement('p', { id: 'add_pincode_err' }),
															_react2.default.createElement(
																'div',
																{ className: 'clr' },
																'\xA0'
															),
															_react2.default.createElement(
																'div',
																{ className: 'text-right' },
																_react2.default.createElement(
																	'button',
																	{ type: 'submit', className: 'web_save_add_btn', value: 'ADD' },
																	'ADD'
																)
															)
														)
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'col-md-8 col-lg-8 col-sm-8' },
													_react2.default.createElement(
														'section',
														{ className: 'web_chk_dlry_title_blk' },
														_react2.default.createElement(
															'div',
															{ id: 'pay_response' },
															this.state.response
														),
														_react2.default.createElement(
															'h4',
															null,
															'DELIVERY ADDRESS',
															delivery_address.length > 0 ? _react2.default.createElement(
																'div',
																{ className: 'pro_sld_ctrls' },
																_react2.default.createElement(
																	'a',
																	{ className: 'left carousel-control pro_sld_lft', onClick: this.goPrev },
																	_react2.default.createElement(
																		'span',
																		{ className: 'pro_sld_arow' },
																		_react2.default.createElement('img', { src: baseAssets + 'images_web/left_arrow.png', alt: '' })
																	),
																	_react2.default.createElement('span', { className: 'sr-only' })
																),
																_react2.default.createElement(
																	'a',
																	{ className: 'right carousel-control pro_sld_rgt', onClick: this.goNext },
																	_react2.default.createElement(
																		'span',
																		{ className: 'pro_sld_arow' },
																		_react2.default.createElement('img', { src: baseAssets + 'images_web/right_arrow.png', alt: '' })
																	),
																	_react2.default.createElement('span', { className: 'sr-only' })
																)
															) : ''
														),
														_react2.default.createElement('h5', null)
													),
													_react2.default.createElement(
														'section',
														{ className: 'web_chk_dlry_data_blk col-sm-12 col-md-12 col-lg-12' },
														this.state.click_here_status ? _react2.default.createElement(
															'div',
															{ className: 'empty_add_blk' },
															_react2.default.createElement(
																'a',
																null,
																'Add Your shipping address'
															)
														) : _react2.default.createElement(
															_reactIdSwiper2.default,
															_extends({}, params, { key: delivery_address.length, ref: function ref(node) {
																	return node ? _this3.swiper = node.swiper : '';
																} }),
															delivery_address
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											),
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											),
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											),
											_react2.default.createElement(
												'div',
												{ className: 'row' },
												_react2.default.createElement(
													'div',
													{ className: 'container' },
													_react2.default.createElement(
														'div',
														{ className: this.state.payment_options == 0 ? "col-md-12 col-sm-12 col-lg-12" : "col-md-8 col-sm-8 col-lg-8" },
														this.state.cart_items.length > 0 ? _react2.default.createElement(
															'section',
															{ className: 'webChk_summary_Blk' },
															_react2.default.createElement(
																'div',
																{ className: 'row' },
																_react2.default.createElement(
																	'div',
																	{ className: 'col-md-4 col-lg-4 col-sm-4' },
																	_react2.default.createElement(
																		'h4',
																		{ className: 'add_Item' },
																		'Added Item'
																	)
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'col-md-2 col-lg-2 col-sm-2 text-right' },
																	_react2.default.createElement(
																		'h4',
																		null,
																		'MRP'
																	)
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'col-md-3 col-lg-3 col-sm-3 text-center' },
																	_react2.default.createElement(
																		'h4',
																		null,
																		'Quantity'
																	)
																),
																_react2.default.createElement(
																	'div',
																	{ className: 'col-md-3 col-lg-3 col-sm-2' },
																	_react2.default.createElement(
																		'h4',
																		null,
																		'Price'
																	)
																)
															)
														) : '',
														_react2.default.createElement(
															'section',
															{ className: 'webChk_Summary_Dtls_Blk' },
															this.state.cart_count > 0 ? _react2.default.createElement(
																'div',
																{ className: this.state.cart_count > 3 ? 'scroll' : '' },
																Items
															) : '',
															this.state.cart_count > 0 ? _react2.default.createElement(
																'div',
																{ className: 'row' },
																_react2.default.createElement(
																	'div',
																	{ className: 'col-md-offset-5 col-md-7 col-lg-7 col-sm-7 col-sm-offset-5', style: { paddingLeft: 0 } },
																	_react2.default.createElement(
																		'table',
																		{ className: 'table-responsive table webcheckout_table' },
																		_react2.default.createElement(
																			'tr',
																			null,
																			_react2.default.createElement(
																				'td',
																				{ className: 'text-right' },
																				'Total'
																			),
																			_react2.default.createElement(
																				'td',
																				null,
																				'\u20B9 ',
																				this.state.cart_total
																			)
																		),
																		this.state.used_cash ? _react2.default.createElement(
																			'tr',
																			null,
																			_react2.default.createElement(
																				'td',
																				{ className: 'text-right' },
																				'Aquacash Discount'
																			),
																			_react2.default.createElement(
																				'td',
																				null,
																				'(-) \u20B9 ',
																				this.state.used_cash
																			)
																		) : '',
																		this.state.coupons_amt1 ? _react2.default.createElement(
																			'tr',
																			null,
																			this.state.coupons.length === 1 ? _react2.default.createElement(
																				'td',
																				{ className: 'text-right' },
																				'Applied Coupon ',
																				_react2.default.createElement(
																					'span',
																					{ className: 'appliedCoupon_Msg' },
																					': ',
																					this.state.coupons.length === 1 ? this.state.coupons[0]['coupon_code'] : ''
																				)
																			) : _react2.default.createElement(
																				'td',
																				{ className: 'text-right' },
																				'Coupons applied on your purchase ',
																				coupon_info
																			),
																			_react2.default.createElement(
																				'td',
																				{ className: 'web_coupon_amt_tot' },
																				'(-) \u20B9 ',
																				this.state.coupons_amt
																			)
																		) : '',
																		this.state.coupon_amt != 0 ? _react2.default.createElement(
																			'tr',
																			null,
																			this.state.coupon_code != "" ? _react2.default.createElement(
																				'td',
																				{ className: 'text-right' },
																				'Applied Coupon ',
																				_react2.default.createElement(
																					'span',
																					{ className: 'appliedCoupon_Msg' },
																					': ',
																					this.state.coupon_code
																				)
																			) : '',
																			_react2.default.createElement(
																				'td',
																				{ className: 'web_coupon_amt_tot' },
																				'(-) \u20B9 ',
																				this.state.coupon_amt
																			)
																		) : '',
																		_react2.default.createElement(
																			'tr',
																			{ style: { 'borderTop': '1px solid #eee' } },
																			_react2.default.createElement(
																				'td',
																				{ className: 'text-right' },
																				'Grand Total'
																			),
																			_react2.default.createElement(
																				'td',
																				null,
																				'\u20B9 ',
																				this.state.grand_total
																			)
																		),
																		_react2.default.createElement(
																			'tr',
																			null,
																			_react2.default.createElement(
																				'td',
																				{ colSpan: 2, style: { 'fontSize': '12px' } },
																				parseHtml(this.state.deliver_date_text)
																			)
																		)
																	)
																)
															) : ''
														)
													),
													this.state.payment_options == 1 ? _react2.default.createElement(
														'div',
														{ className: 'col-md-4 col-lg-4 col-sm-4' },
														_react2.default.createElement(
															'section',
															{ className: 'web_chk_pay_opts_blk' },
															_react2.default.createElement(
																'h4',
																null,
																'PAYMENT OPTIONS'
															)
														),
														this.state.mode_loading ? _react2.default.createElement(
															'div',
															{ className: 'web_mode_loading' },
															_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/loading_more.gif', alt: 'Loading' })
														) : tabs_data
													) : ''
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											),
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											),
											_react2.default.createElement(
												'div',
												{ className: 'container' },
												_react2.default.createElement(
													'div',
													{ className: 'col-lg-12 col-md-12 col-sm-12 check_btm_btns' },
													_react2.default.createElement(
														'div',
														{ className: 'col-md-4 col-lg-4 col-sm-6' },
														_react2.default.createElement(
															_reactRouter.Link,
															{ to: '/web/customer_care', className: 'enquire btn btn-default chck_enq_btn' },
															'ENQUIRE NOW'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-4 col-md-4' },
														'\xA0'
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-4 col-md-4 col-sm-6' },
														this.state.amount_loading ? _react2.default.createElement(
															_reactRouter.Link,
															{ className: 'pull-right btn btn-default pay' },
															'Loading..'
														) : _react2.default.createElement(
															_reactRouter.Link,
															{ className: 'btn btn-default pull-right pay', onClick: function onClick() {
																	_this3.payNow();
																} },
															'PAY NOW'
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											),
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											)
										),
										_react2.default.createElement(
											_reactBootstrap.Modal,
											{ onEntered: function onEntered() {
													_this3.getAddressDetails();
												}, className: '', show: this.state.edit_address, onHide: this.close },
											_react2.default.createElement(
												_reactBootstrap.Modal.Header,
												{ closeButton: true },
												_react2.default.createElement(
													_reactBootstrap.Modal.Title,
													{ className: 'm_title' },
													'Edit Shipping Address'
												)
											),
											_react2.default.createElement(
												_reactBootstrap.Modal.Body,
												null,
												_react2.default.createElement(
													'div',
													null,
													_react2.default.createElement(
														'form',
														{ className: 'web_edit_address_form', onSubmit: this.handleSubmit_edit },
														_react2.default.createElement(
															'div',
															{ className: 'web_edit_form_blk' },
															_react2.default.createElement('input', { type: 'text', id: 'edit_name', placeholder: 'Name', value: this.state.edit_name, onChange: this.edit_nameChange, ref: 'edit_name', required: true }),
															_react2.default.createElement('p', { id: 'edit_name_err' }),
															_react2.default.createElement('input', { type: 'text', placeholder: 'Mobile', maxLength: 10, value: this.state.edit_mobile, onChange: this.edit_mobileChange, ref: 'edit_mobile', id: 'edit_mobile', required: true }),
															_react2.default.createElement('p', { id: 'edit_mobile_err' }),
															_react2.default.createElement('input', { type: 'text', placeholder: 'Enter State', value: this.state.edit_state, onChange: this.edit_stateChange, ref: 'edit_state', id: 'edit_state', required: true }),
															_react2.default.createElement('p', { id: 'edit_state_err' }),
															_react2.default.createElement('input', { type: 'text', placeholder: 'Enter City/Town', value: this.state.edit_city, onChange: this.edit_cityChange, ref: 'edit_city', id: 'edit_city', required: true }),
															_react2.default.createElement('p', { id: 'edit_city_err' }),
															_react2.default.createElement('input', { type: 'text', placeholder: 'Door No/Landmark', value: this.state.edit_doorno, onChange: this.edit_doornoChange, ref: 'edit_doorno', id: 'edit_doorno', required: true }),
															_react2.default.createElement('p', { id: 'edit_doorno_err' }),
															_react2.default.createElement('input', { type: 'text', placeholder: 'Pincode', maxLength: 6, value: this.state.edit_pincode, onChange: this.edit_pincodeChange, ref: 'edit_pincode', id: 'edit_pincode', required: true }),
															_react2.default.createElement('p', { id: 'edit_pincode_err' }),
															_react2.default.createElement(
																'div',
																{ className: 'm_submit_blk' },
																_react2.default.createElement(
																	'button',
																	{ type: 'submit', className: 'adrs_update_btn', value: 'UPDATE' },
																	'UPDATE'
																)
															)
														)
													)
												)
											)
										),
										_react2.default.createElement(
											_reactBootstrap.Modal,
											{ id: 'off_modal_status', className: 'off_modal_status', backdrop: 'static', show: this.state.offline_pay_success_status, onHide: this.testclose },
											_react2.default.createElement(
												_reactBootstrap.Modal.Header,
												null,
												_react2.default.createElement(
													'div',
													{ className: '' },
													_react2.default.createElement(
														'h5',
														null,
														_react2.default.createElement(
															_reactRouter.Link,
															{ to: "/web/home" },
															_react2.default.createElement(
																'i',
																null,
																_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/mob-assets/arrow_back.png', width: '30px', alt: '' })
															)
														),
														'Confirmation'
													),
													_react2.default.createElement(
														'a',
														{ href: '/web/home', className: 'home_cartlogo' },
														_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/home1.png', alt: '' })
													)
												)
											),
											_react2.default.createElement(
												_reactBootstrap.Modal.Body,
												null,
												_react2.default.createElement(
													'div',
													{ style: { textAlign: 'center', paddingBottom: '10px' } },
													_react2.default.createElement(
														'i',
														null,
														_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png', alt: 'AquaDeals', width: '100px' })
													),
													_react2.default.createElement(
														'h5',
														{ style: { color: 'green' } },
														this.state.offline_confirm_data.success_msg
													),
													_react2.default.createElement(
														'h6',
														{ style: { color: '#ff742a' } },
														this.state.offline_confirm_data.thank_msg
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'modal_ordr_dtls_blk' },
													_react2.default.createElement(
														'div',
														{ className: 'modal_ordr_dtls' },
														_react2.default.createElement(
															'h5',
															null,
															'Order Details'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: '', style: { padding: '10px' } },
														_react2.default.createElement(
															'h5',
															null,
															_react2.default.createElement(
																'span',
																null,
																'SELLER NAME : '
															),
															_react2.default.createElement(
																'span',
																null,
																this.state.offline_confirm_data.address ? this.state.offline_confirm_data.address.seller_name : ''
															)
														),
														_react2.default.createElement(
															'h5',
															{ style: { fontSize: '11px', marginTop: '4px', marginBottom: '4px' } },
															_react2.default.createElement(
																'span',
																null,
																'ORDER NO'
															),
															_react2.default.createElement(
																'span',
																{ style: { float: 'right' } },
																'ORDER DATE'
															)
														),
														_react2.default.createElement(
															'h5',
															null,
															_react2.default.createElement(
																'span',
																null,
																this.state.offline_confirm_data.book_id
															),
															_react2.default.createElement(
																'span',
																{ style: { float: 'right' } },
																this.state.offline_confirm_data.booking_date ? this.state.offline_confirm_data.booking_date : ''
															)
														)
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'modal_pro_details_blk' },
													_react2.default.createElement(
														'div',
														{ className: 'modal_pro_title' },
														_react2.default.createElement(
															'h5',
															null,
															'Product Details '
														)
													),
													_react2.default.createElement(
														'div',
														{ style: { padding: '10px' } },
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'span',
																null,
																'Item : ',
																this.state.offline_confirm_data.qty ? this.state.offline_confirm_data.qty : ''
															),
															_react2.default.createElement(
																'span',
																{ style: { float: 'right' } },
																'Total : ',
																this.state.offline_confirm_data.remaining_amount ? this.state.offline_confirm_data.remaining_amount : ''
															)
														)
													)
												),
												_react2.default.createElement(
													'div',
													{ className: '', style: { backgroundColor: '#fff', overflow: 'hidden', paddingBottom: '10px', marginTop: '10px' } },
													this.state.offline_confirm_data.order_items ? this.state.offline_confirm_data.order_items.map(function (data, index) {
														return _react2.default.createElement(
															'div',
															{ className: 'col-xs-12 col-md-12', style: { padding: '0px', paddingTop: '15px', paddingBottom: '15px', borderTop: '1px solid #eee' } },
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-3 col-md-3' },
																_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/product_imgs/thumbnails/20170323130243537436.jpg', alt: ' ' })
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-6 col-md-6', style: { padding: '0px' } },
																_react2.default.createElement(
																	'p',
																	null,
																	data.pro_name,
																	' ',
																	data.unit
																),
																_react2.default.createElement(
																	'p',
																	null,
																	'QTY : ',
																	data.quantity
																)
															),
															_react2.default.createElement(
																'div',
																{ className: 'col-xs-3 col-md-3', style: { padding: '0px' } },
																_react2.default.createElement(
																	'p',
																	{ style: { marginTop: '17px' } },
																	'\u20B9 ',
																	data.deal_amt
																)
															)
														);
													}) : ''
												),
												_react2.default.createElement(
													'div',
													null,
													_react2.default.createElement(
														'div',
														{ style: { backgroundColor: '#f1f1f2', padding: '5px 0px 5px 10px' } },
														_react2.default.createElement(
															'h5',
															null,
															'PAYMENT DETAILS'
														)
													),
													_react2.default.createElement(
														'div',
														{ style: { backgroundColor: '#fff', padding: '10px' } },
														_react2.default.createElement(
															'h5',
															null,
															_react2.default.createElement(
																'span',
																null,
																this.state.offline_confirm_data.payment_details ? this.state.offline_confirm_data.payment_details[0].title : ''
															),
															_react2.default.createElement(
																'span',
																{ style: { float: 'right' } },
																'\u20B9 ',
																this.state.offline_confirm_data.payment_details ? this.state.offline_confirm_data.payment_details[0].value : ''
															)
														)
													)
												),
												_react2.default.createElement(
													'div',
													null,
													_react2.default.createElement(
														'div',
														{ className: '', style: { backgroundColor: '#f1f1f2', padding: '5px 0px 5px 10px' } },
														_react2.default.createElement(
															'h5',
															null,
															'SHIPPING ADDRESS'
														)
													),
													_react2.default.createElement(
														'div',
														{ className: '', style: { backgroundColor: '#fff', padding: '10px' } },
														_react2.default.createElement(
															'p',
															null,
															this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].name : ''
														),
														_react2.default.createElement(
															'p',
															null,
															this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].address : '',
															' , ',
															this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].city : '',
															' '
														),
														_react2.default.createElement(
															'p',
															null,
															this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].state : ''
														),
														_react2.default.createElement(
															'p',
															null,
															this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].phone : ''
														),
														_react2.default.createElement(
															'p',
															null,
															this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].zip : ''
														)
													)
												),
												_react2.default.createElement(
													'div',
													{ style: { textAlign: 'center', marginTop: '100px' }, className: 'modal_share_blk' },
													_react2.default.createElement(
														'div',
														null,
														_react2.default.createElement(
															_reactRouter.Link,
															{ style: { color: '#ff742a' }, to: '/share_earn' },
															_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/icons/nav_refer_earn.png', width: '40px', alt: '' }),
															'Share & Earn'
														)
													)
												)
											)
										)
									)
								) : _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'div',
										{ className: 'web_cart_emtpy' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/empty_cartbg.png', alt: '...' })
										),
										_react2.default.createElement(
											'h4',
											null,
											'Your Quick Cart is Empty'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "/web/home", className: 'cart_shopbtn' },
											'SHOP NOW'
										)
									)
								)
							) : _react2.default.createElement(
								'div',
								{ className: 'web_checkout_loading' },
								this.state.lod ? _react2.default.createElement(
									'div',
									{ className: 'checkout_error_blk' },
									_react2.default.createElement(
										'h4',
										null,
										'Something went wrong'
									),
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: '/web/home', className: 'try_again_btn' },
										'Please try again!'
									)
								) : _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/loading_more.gif', alt: 'Loading' })
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'invalid_order', show: this.state.order_error_modal, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							this.state.order_error_message,
							_react2.default.createElement(
								'a',
								{ onClick: this.close, className: 'req_conf_ok_btn' },
								'OK'
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_Quick_Checkout;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			rzp_keys: state.posts.rzp_keys
		};
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Web_Quick_Checkout);

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Product = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _reactStars = __webpack_require__(33);
	
	var _reactStars2 = _interopRequireDefault(_reactStars);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactShare = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	
	var Web_NaupliiDeals = function (_Component) {
		_inherits(Web_NaupliiDeals, _Component);
	
		function Web_NaupliiDeals(props) {
			_classCallCheck(this, Web_NaupliiDeals);
	
			var _this = _possibleConstructorReturn(this, (Web_NaupliiDeals.__proto__ || Object.getPrototypeOf(Web_NaupliiDeals)).call(this, props));
	
			_this.state = {
				seedsList: [],
				offer: {},
				sort_status: true,
				sort: '1',
				img_price: 'price.png',
				coasts: [],
				coast: '0',
				nodata: false,
				img_data: 'Price',
				open: false,
				latitude: '',
				longitude: '',
				seed_type: _this.props.params.Stype,
				shareUrl: '',
				loading: false,
				web_title: '',
				web_desc: '',
				seo_title: '',
				seo_desc: '',
				cart_count: 0,
				loading_gif: false,
	
				sortlist: [],
				total_deals: ''
			};
			_this.getDeviceId = _this.getDeviceId.bind(_this);
			_this.getCartCount = _this.getCartCount.bind(_this);
	
			_this.getNearBy = _this.getNearBy.bind(_this);
			_this.getSort = _this.getSort.bind(_this);
			_this.getCoasts = _this.getCoasts.bind(_this);
			_this.getSelectedCoast = _this.getSelectedCoast.bind(_this);
	
			_this.getSeedFilter = _this.getSeedFilter.bind(_this);
			_this.getSelectedItem = _this.getSelectedItem.bind(_this);
			return _this;
		}
	
		_createClass(Web_NaupliiDeals, [{
			key: 'getSeedFilter',
			value: function getSeedFilter() {
				var data1 = { from: 'desktop_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					url: baseUrl + 'seedFilters',
					method: 'POST',
					dataType: 'JSON',
					data: { req: data2 },
					success: function (data) {
						if (data) {
							this.setState({
								sortlist: data.sort
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSelectedItem',
			value: function getSelectedItem(event) {
				// var value = event.target.value;
				var index = event.target.selectedIndex;
				var optionElement = event.target.childNodes[index];
				var id = optionElement.getAttribute('id');
				var data1 = { from: 'desktop_web', sort: id, coast: 0, species: 0, deal_type: 8 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					url: baseUrl + 'getdeals',
					method: 'POST',
					dataType: 'JSON',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							loading: true,
							seedsList: data.data,
							offer: data
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getNearBy',
			value: function getNearBy() {
				this.setState({
					loading_gif: true
				});
	
				var data1 = { from: 'desktop_web', lat: this.state.latitude, long: this.state.longitude, sort: this.state.sort, species: '0', deal_type: '8' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdeals',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.data.length === 0) {
							this.setState({
								nodata: true
							});
						} else {
							this.setState({
								nodata: false,
								seedsList: data.data,
								offer: data,
								web_title: data.title,
								web_desc: data.desc,
								loading_gif: false
							});
	
							// document.title =this.state.web_title +  " - Deals | AquaDeals ";
							//        		document.title ="Nauplii - Deals | AquaDeals ";
							// document.getElementsByTagName("META")[2].content=this.state.seo_desc;
						}
					}.bind(this),
					error: function (err) {
						this.setState({
							loading_gif: false
						});
					}.bind(this)
				});
			}
		}, {
			key: 'getCoasts',
			value: function getCoasts() {
	
				var data1 = { from: 'desktop_web', species: '0', deal_type: '8' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'coasts',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							coasts: data.coasts
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'getCartCount',
			value: function getCartCount() {
	
				var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						console.log(data);
						this.setState({
							cart_count: data.cart_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getDeviceId',
			value: function getDeviceId() {
				if (localStorage.user_id) {
					var user_id = localStorage.user_id;
				} else {
					user_id = 0;
				}
				var data1 = { from: 'desktop_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
	
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getDeviceId',
					dataType: 'json',
					data: { req: data2 },
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width < 800) {
					window.location.href = "/nauplii";
				}
				this.setState({
					loading_gif: true
				});
	
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
				localStorage.removeItem('checkout');
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
	
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
				localStorage.removeItem('web_quickcart');
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
				localStorage.removeItem('web_brand_details');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
	
				this.getDeviceId();
				if (localStorage.user_id && localStorage.token) {
					this.getCartCount();
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('nauplii', '/web/nauplii/nauplii/8');
				}
				this.getCoasts();
	
				var data1 = { from: 'desktop_web', coast: '0', species: '0', deal_type: '8' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdeals',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							seedsList: data.data,
							offer: data,
							web_title: data.title,
							web_desc: data.desc,
							loading: true,
							seo_title: 'Nauplii deals from Hatcheries',
							seo_desc: 'Browse quality Nauplii deals from CAA approved Hatcheries, shop online and avail free shipment.',
							loading_gif: false,
							total_deals: data.total_records
						});
						// document.title =this.state.web_title+  " - Deals | AquaDeals | "+this.state.seo_desc;
						document.title = this.state.seo_title;
						document.getElementsByTagName("META")[2].content = this.state.seo_desc;
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
						this.setState({
							loading_gif: false
						});
					}
				});
				this.getSeedFilter();
			}
		}, {
			key: 'getSort',
			value: function getSort() {
				localStorage.setItem('sort', this.state.sort);
	
				var data1 = { from: 'desktop_web', sort: this.state.sort, coast: this.state.coast, species: '0', deal_type: '8' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdeals',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (this.state.sort === 1) {
							var ss = 2;
							var img_price = 'down.png';
							var img_data = 'High - Low';
						} else {
							ss = 1;
							img_price = 'up.png';
							img_data = 'Low - High';
						}
						this.setState({
							sort: ss,
							img_price: img_price,
							img_data: img_data,
							seedsList: data.data,
							offer: data
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'getSelectedCoast',
			value: function getSelectedCoast(c) {
				if (this.state.sort === 1) {
					this.setState({
						sort: '2'
					});
				} else {
					this.setState({
						sort: '1'
					});
				}
				this.setState({
					coast: c
				});
	
				var data1 = { from: 'desktop_web', coast: c, sort: localStorage.sort, species: '0', deal_type: '8' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdeals',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.data.length === 0) {
							this.setState({
								nodata: true
							});
						} else {
							this.setState({
								nodata: false
							});
						}
						this.setState({
							seedsList: data.data,
							offer: data
	
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var seedFilters = this.state.sortlist.map(function (item, index) {
					return _react2.default.createElement(
						'option',
						{ key: item.id, value: item.type, id: item.id },
						item.type
					);
				});
	
				var products = this.state.seedsList.map(function (product, index) {
					return _react2.default.createElement(Product, { key: product.deals_data.id, data: product });
				});
				// return(
				// 	<div className="mob_deals">
				// 		<div className="seed_list_page">
				// 			<div className="page_hdr">
				// 				<div className="container-fluid">
				// 					<h5><Link to={"/home"}><i><img src={'https://aquadeals.in/admin/assets/images/web_imgs/arrow_back.png'} width="30px" alt=""/></i></Link>Nauplii</h5>
				// 					<a href="/home" className="home_logo1"><img src={'https://aquadeals.in/admin/assets/images/web_imgs/home1.png'} alt="Home" /></a>
				// 					<a className="mob_cart_btn" href="/mycart">
				// 						<img alt="" src={'https://aquadeals.in/admin/assets/icons/web_icons/cart_icon.png'} />
				// 						{this.state.cart_count > 0 ? <span className={this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count"}>{this.state.cart_count}</span> : ''}
				// 					</a>
				// 				</div>
				// 			</div>
				// 			<div className="pag_cntnt">&nbsp;</div>
				// 			<section>
				// 					<div className="no_data">
				// 						<h3>No Deals Available</h3>
				// 						<p>Need some thing here? <Link to={"/web/customer_care"}>CONTACT US</Link> now !</p>
				// 					</div>
				// 			</section>
				// 		</div>
				// 	</div>
				// );
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_seedslist_page' },
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					this.state.loading ? _react2.default.createElement(
						'div',
						{ className: 'lgt_gry' },
						_react2.default.createElement(_WebHeaderInner2.default, null),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'section',
							{ className: 'container pro_lst_cntnt' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									_reactBootstrap.Breadcrumb,
									{ className: 'webpdeals_breadcrmb' },
									_react2.default.createElement(
										_reactBootstrap.Breadcrumb.Item,
										{ href: '/web/home' },
										'Home'
									),
									_react2.default.createElement(
										_reactBootstrap.Breadcrumb.Item,
										{ active: true },
										this.state.web_title
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'tot_pro' },
								_react2.default.createElement(
									'div',
									{ className: 'row', style: { marginRight: '0 !important' } },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-3 col-sm-3' },
										_react2.default.createElement(
											'div',
											{ className: 'filtrs_blk' },
											_react2.default.createElement(
												'h3',
												null,
												'Categories'
											),
											_react2.default.createElement(
												'ul',
												null,
												_react2.default.createElement(
													'li',
													{ className: 'fltr_title' },
													'Nauplii'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'pro_sec col-md-9 col-sm-9' },
										_react2.default.createElement(
											'div',
											{ className: 'pro_sec_hdr' },
											_react2.default.createElement(
												'h3',
												null,
												this.state.web_title,
												_react2.default.createElement(
													'span',
													null,
													'\xA0(',
													this.state.total_deals,
													' Items)'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'pro_slt_fltr' },
												_react2.default.createElement(
													'select',
													{ onChange: this.getSelectedItem },
													_react2.default.createElement(
														'option',
														null,
														'Select'
													),
													seedFilters
												)
											)
										),
										this.state.loading ? _react2.default.createElement(
											'div',
											{ className: 'row itm_lst' },
											products.length > 0 ? products : _react2.default.createElement(
												'div',
												{ className: 'seed_no_data' },
												'No Deals Available'
											)
										) : _react2.default.createElement(
											'div',
											{ className: 'loading_sym' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/ajax-loader.gif', alt: 'AquaDeals', role: 'presentation' })
										)
									)
								)
							)
						),
						_react2.default.createElement(_WebFooter2.default, null)
					) : _react2.default.createElement(
						'div',
						{ className: 'loading_sym', style: { width: 100 + '%', textAlign: 'center', marginTop: 20 + '%' } },
						_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/ajax-loader1.gif', alt: 'Loading Deals', role: 'presentation' }),
						' '
					)
				);
			}
		}]);
	
		return Web_NaupliiDeals;
	}(_react.Component);
	
	exports.default = Web_NaupliiDeals;
	
	var Product = exports.Product = function (_Component2) {
		_inherits(Product, _Component2);
	
		function Product() {
			_classCallCheck(this, Product);
	
			var _this2 = _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).call(this));
	
			_this2.state = {
				open: false,
				shareUrl: '',
				msg: ''
			};
			_this2.ShareFunc = _this2.ShareFunc.bind(_this2);
			return _this2;
		}
	
		_createClass(Product, [{
			key: 'ShareFunc',
			value: function ShareFunc(evnt) {
				var _this3 = this;
	
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', type: 0, did: evnt };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'createTinyurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							msg: data.msg,
							shareUrl: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
				this.setState({
					open: !this.state.open
				});
				setTimeout(function () {
					_this3.setState({ open: false });
				}, 5000);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var mydata = this.props.data;
				// var shareUrl = 'http://203.193.173.125:3003/seed_details/'+mydata.deals_data.id;
				var shareUrl = this.state.shareUrl;
				var title = "Hey Click here " + shareUrl + " to check " + mydata.deals_data.sname + " from AquaDeals.";
				var description = shareUrl;
				// var title = this.state.msg;
				var no_data = '';
				if (mydata.length === 0) {
					no_data = _react2.default.createElement(
						'div',
						{ className: 'no_data' },
						_react2.default.createElement(
							'h3',
							null,
							'No Deals Available'
						),
						_react2.default.createElement(
							'p',
							null,
							'Need some thing here? ',
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: "/web/customer_care" },
								'CONTACT US'
							),
							' now !'
						)
					);
				} else {
					no_data = "";
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'col-md-3 col-sm-6' },
					no_data,
					_react2.default.createElement(
						'div',
						{ className: 'prdt_blk' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ className: 'lst_share_btn', onClick: function onClick() {
									_this4.ShareFunc(mydata.deals_data.id);
								} },
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/share.png', alt: 'Share' })
						),
						_react2.default.createElement(
							_reactBootstrap.Panel,
							{ className: 'share_panel', collapsible: true, expanded: this.state.open },
							_react2.default.createElement(
								FacebookShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share' },
								_react2.default.createElement(FacebookIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								TwitterShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share' },
								_react2.default.createElement(TwitterIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								GooglePlusShareButton,
								{ url: shareUrl, quote: title, descirption: description, className: 'test_share' },
								_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
							)
						),
						_react2.default.createElement(
							_reactRouter.Link,
							{ className: 'cursor', to: "/web/sdetails/" + mydata.deals_data.sname + "/" + mydata.deals_data.id },
							_react2.default.createElement(
								'div',
								{ className: 'itm_img' },
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/seller_imgs/thumbnails/' + mydata.deals_data.image, alt: 'AquaDeals', role: 'presentation' })
							),
							mydata.deals_data.sname ? _react2.default.createElement(
								'h3',
								null,
								mydata.deals_data.sname
							) : _react2.default.createElement(
								'h3',
								null,
								'\xA0'
							),
							mydata.deals_data.discount_price > 0 ? _react2.default.createElement(
								'h4',
								null,
								_react2.default.createElement('span', null),
								_react2.default.createElement(
									'span',
									null,
									'\u20B9 ',
									mydata.offer
								),
								' off on 1M'
							) : _react2.default.createElement(
								'h4',
								null,
								'\xA0'
							),
							mydata.deals_data.price ? _react2.default.createElement(
								'h4',
								null,
								_react2.default.createElement('span', null),
								_react2.default.createElement(
									'span',
									{ style: { color: '#333' } },
									'\u20B9'
								),
								_react2.default.createElement(
									'span',
									{ style: { color: '#333' } },
									' ',
									mydata.deals_data.price
								)
							) : _react2.default.createElement(
								'h4',
								null,
								'\xA0'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row stars_view_blk' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-7 col-xs-7', style: { paddingRight: '0' } },
								_react2.default.createElement(
									'div',
									{ className: 'prdt_str_rt' },
									_react2.default.createElement(_reactStars2.default, {
										count: 5,
										className: 'webRate_blk_item',
										size: 17,
										value: mydata.deals_data.rate >= 1 ? mydata.deals_data.rate : 0,
										edit: false,
										color1: '#ccc',
										color2: '#ffc50a'
									})
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-5 col-xs-5', style: { paddingLeft: 0 } },
								mydata.view_status > 0 ? _react2.default.createElement(
									'span',
									{ className: 'prdt_views' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/eye.png', width: '16px', role: 'presentation' })
									),
									'\xA0',
									mydata.view_status
								) : ''
							),
							_react2.default.createElement('div', { className: 'clr' })
						)
					)
				);
			}
		}]);
	
		return Product;
	}(_react.Component);
	
	// export default connect(mapStateToProps,actions)(Web_NaupliiDeals);

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SDetails = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(15);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _reactShare = __webpack_require__(18);
	
	__webpack_require__(244);
	
	__webpack_require__(243);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { ButtonToolbar,SplitButton, MenuItem, Panel, Button,Modal } from 'react-bootstrap';
	
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Web_Seed_Details = function (_Component) {
		_inherits(Web_Seed_Details, _Component);
	
		function Web_Seed_Details(props) {
			_classCallCheck(this, Web_Seed_Details);
	
			var _this = _possibleConstructorReturn(this, (Web_Seed_Details.__proto__ || Object.getPrototypeOf(Web_Seed_Details)).call(this, props));
	
			_this.state = {
				id: _this.props.params.Sid,
				seedDetails: [],
				deal_options: [],
				details: '',
				offers_details: '',
				d_options: [],
				test: [],
				s: [],
				hatchary_details: [],
				rate: '',
				res_img: '',
				seller_id: '',
				deal_id: '',
				open: false,
				showModal: false,
				loading: false,
				sp_name: '',
				shareUrl: '',
				seedid: '',
				session: localStorage.getItem('token'),
				title: '',
				desc: '',
				web_title: '',
				web_desc: '',
				deal_price: '',
				original_price: '',
				data_status: false,
				SName: _this.props.params.BrandName,
				bestprice_status: false,
				bestprice_desc: '',
				coupons: [],
				reset: '',
				showBestPrice: false,
				showBestPriceDesc: 'Thank you.We will get back to you shortly with best price',
				reqbestPrice: false,
				recomends: '',
				coupon_first: [],
				cpns_list: '',
	
				min_allowed_qty: '',
				min_allowed_qty1: '',
				available_qty: '',
				plsize: 0,
				plsizes: [],
				salinities: [],
				millions: '',
				min_allowed_qty_status: false,
				salinity: 0,
				seeddates: '',
				start_date: '',
				end_date: '',
				addtocart_msg: '',
				is_cart: 0,
				clearcart_status: false,
				addtocart_status: false,
				updatecart_status: false,
				active_date: '',
				date_status: false,
				err_date: '',
				err_date_status: false,
	
				free_ship_msg: '',
				user_zipcode: '',
				free_shipment: '',
				err_pincode: false,
				err_pincode_msg: '',
	
				product_existed: false,
				seo_title: '',
				seo_desc: '',
	
				emi_opt_desc: '',
				emi_opt_sts: 0,
				err_qty_status_1: false,
				err_qty_msg: '',
	
				req_confirm_modal: false,
				req_confirm_message: '',
				req_pincode: '',
				req_quantity: '',
				req_state: '',
				req_city: '',
				req_doorno: '',
				wishLst_flag: '',
				page_loading: '',
	
				rotateClass: false,
				cart_count: 0,
				cart_date: '',
				cart_date_active: '',
				cart_salinity: 0,
				cart_pl_size: 0,
				date_flag: false,
				cart_qty: '',
	
				seed_type_id: ''
			};
			localStorage.setItem('seed_id', _this.props.params.Sid);
			localStorage.setItem('h_type', '1');
			_this.ShareFunc = _this.ShareFunc.bind(_this);
	
			_this.close = _this.close.bind(_this);
			_this.getDeviceId = _this.getDeviceId.bind(_this);
	
			_this.decrementMinQty = _this.decrementMinQty.bind(_this);
			_this.updateMinQty = _this.updateMinQty.bind(_this);
			_this.incrementMinQty = _this.incrementMinQty.bind(_this);
			_this.plsizeChange = _this.plsizeChange.bind(_this);
			_this.salinityChange = _this.salinityChange.bind(_this);
			_this.DealPlSalinity = _this.DealPlSalinity.bind(_this);
			_this.getDates = _this.getDates.bind(_this);
			_this.placeOrderModal = _this.placeOrderModal.bind(_this);
			_this.removeCartItems = _this.removeCartItems.bind(_this);
			_this.changeDate = _this.changeDate.bind(_this);
			_this.checkPincode = _this.checkPincode.bind(_this);
			_this.pincodeChange = _this.pincodeChange.bind(_this);
	
			_this.checkBestPrice = _this.checkBestPrice.bind(_this);
			_this.req_pincodeChange = _this.req_pincodeChange.bind(_this);
			_this.req_quantityChange = _this.req_quantityChange.bind(_this);
			_this.req_stateChange = _this.req_stateChange.bind(_this);
			_this.req_cityChange = _this.req_cityChange.bind(_this);
			_this.req_doornoChange = _this.req_doornoChange.bind(_this);
			_this.reqBestPriceSubmit = _this.reqBestPriceSubmit.bind(_this);
			_this.addToWishlist = _this.addToWishlist.bind(_this);
			_this.getCartCount = _this.getCartCount.bind(_this);
	
			_this.addtocartOnload = _this.addtocartOnload.bind(_this);
			_this.checkBestPriceOnload = _this.checkBestPriceOnload.bind(_this);
	
			_this.goPrev = _this.goPrev.bind(_this);
			_this.goNext = _this.goNext.bind(_this);
			_this.addQCart_Onload = _this.addQCart_Onload.bind(_this);
			return _this;
		}
	
		_createClass(Web_Seed_Details, [{
			key: 'goNext',
			value: function goNext() {
				if (this.swiper) this.swiper.slideNext();
			}
		}, {
			key: 'goPrev',
			value: function goPrev() {
				if (this.swiper) this.swiper.slidePrev();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width <= 800) {
					window.location.href = '/sdetails/' + this.props.params.BrandName + "/" + this.props.params.Sid;
				}
				// if(!localStorage.token && !localStorage.user_id)
				// {
				// localStorage.setItem('w_r_s_dt','/web/sdetails/'+this.props.params.BrandName+"/"+this.props.params.Sid);
				// browserHistory.push('/web/login');
				// window.location.reload();
				// }
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				this.getDeviceId();
	
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
				localStorage.removeItem('checkout');
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
				localStorage.removeItem('web_quickcart');
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
				localStorage.removeItem('web_brand_details');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
	
				localStorage.setItem('w_r_s_dt', '/web/sdetails/' + this.props.params.BrandName + "/" + this.props.params.Sid);
				localStorage.setItem('seed_id', this.props.params.Sid);
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'desktop_web', id: this.props.params.Sid, uid: uid, token: localStorage.getItem('token'), source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdealsdetails',
					dataType: 'json',
					data: { req: data2 },
					success: function (response) {
						if (response.status === "error") {
							this.setState({
								data_status: true
							});
							window.location.href = response.redirect;
						}
						if (response.message === "Token mismatch") {
							localStorage.removeItem('token');
							localStorage.removeItem('user_id');
							// browserHistory.push('/web/login');
						}
						var s = _jquery2.default.makeArray(response.offers_details);
						var h = _jquery2.default.makeArray(response.hatchary_details);
						var d_opt = _jquery2.default.makeArray(response.deal_options);
						// var deal_options=$.makeArray(response.deal_options);
						d_opt = _jquery2.default.makeArray(response.deal_options);
						this.setState({
							loading: true,
							seller_id: response.data[0]['deals_data']['seller_id'],
							deal_id: response.data[0]['deals_data']['id'],
							seedDetails: response.data,
							details: response,
							test: s[0],
							t: response.data[0],
							// d_options: deal_options[0],
							hatchary_details: h[0],
							rate: response.data[0]['deals_data']['rate'],
							res_img: response.imgs[0]['img'],
							sp_name: response.data[0]['deals_data']['sname'],
							seedid: response.data[0]['deals_data']['sid'],
							deal_price: response.data[0]['deals_data']['discount_price'],
							original_price: response.data[0]['deals_data']['price'],
							coupons: response.coupons,
							coupon_first: response.coupons[0],
							recomends: response.recomends,
							cpns_list: response.cpns_list,
	
							emi_opt_desc: response.emi_opt_desc,
							emi_opt_sts: response.emi_opt_sts,
	
							min_allowed_qty: response.data[0]['deals_data']['min_allowed_qty'],
							min_allowed_qty1: response.data[0]['deals_data']['min_allowed_qty'],
							available_qty: response.data[0]['deals_data']['available_qty'],
							millions: parseFloat(response.data[0]['deals_data']['min_allowed_qty']) / 1000000,
							start_date: response.start_date,
							end_date: response.end_date,
							is_cart: response.is_cart,
	
							free_ship_msg: response.free_ship_msg,
							user_zipcode: response.user_zipcode,
							free_shipment: response.free_shipment,
							seo_title: h[0]['org_name'] + ' Seed Deals',
							seo_desc: 'Buy quality ' + response.data[0]['deals_data']['sname'] + ' seed from CAA approved ' + h[0]['org_name'] + ' and avail free shipment',
							cart_date: response.cart_date,
							// the below state for recently added because addto cart function
	
							seed_id: response.data[0]['deals_data']['id'],
							wishLst_flag: response.wishLst_flag,
							seed_type_id: response.seed_type_id
						});
						if (response.cart_qty !== 0) {
							this.setState({
								min_allowed_qty: response.cart_qty
							});
						}
						if (response.cart_date !== '') {
							this.setState({
								date_flag: true
								// active_date:response.cart_date,
							});
						}
						if (response.cart_pl_size !== 0) {
							this.setState({
								plsize: response.cart_pl_size
							});
						}
						if (response.cart_salinity !== 0) {
							this.setState({
								salinity: response.cart_salinity
							});
						}
						if (response.data[0]['deals_data']['sname'] === null) {
							this.setState({
								seo_desc: 'Buy quality ' + response.data[0]['deals_data']['oname'] + ' seed from CAA approved ' + h[0]['org_name'] + ' and avail free shipment'
							});
						}
						if (d_opt.length > 0) {
							this.setState({
								deal_options: d_opt[0]
							});
						}
						if (response.is_cart === 1) {
							this.setState({
								addtocart_msg: 'Go to Cart',
								is_cart: response.is_cart
							});
						} else {
							this.setState({
								addtocart_msg: 'Add to Cart',
								is_cart: response.is_cart
							});
						}
						document.title = this.state.seo_title;
						document.getElementsByTagName("META")[2].content = this.state.seo_desc;
						this.getDates();
						this.DealPlSalinity();
						if (localStorage.user_id && localStorage.token && localStorage.web_seed_addtocart) {
							this.addtocartOnload();
						}
						if (localStorage.user_id && localStorage.token && localStorage.web_seed_checkbestprice) {
							this.checkBestPriceOnload();
						}
						if (response.status === 'error' && response.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
						if (localStorage.user_id && localStorage.token) {
							this.getCartCount();
						}
						if (localStorage.user_id && localStorage.token && localStorage.web_addtowishlist) {
							this.addToWishlist();
						}
						if (localStorage.user_id && localStorage.token && localStorage.quickbuy_onload) {
							this.addQCart_Onload();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getDeviceId',
			value: function getDeviceId() {
				if (localStorage.user_id) {
					var user_id = localStorage.user_id;
				} else {
					user_id = 0;
				}
				var data1 = { from: 'desktop_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getDeviceId',
					dataType: 'json',
					data: { req: data2 },
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'getCartCount',
			value: function getCartCount() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							cart_count: data.cart_count
						});
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					showModal: false,
					reqbestPrice: false,
					clearcart_status: false,
					product_existed: false,
					req_confirm_modal: false
				});
			}
		}, {
			key: 'checkPincode',
			value: function checkPincode() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				if (this.refs.pincode.value.length === 6) {
					var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token'), type: 0, did: this.props.params.Sid, zip: this.refs.pincode.value, device_id: localStorage.getItem('push_device_id') };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						url: baseUrl + 'checkFreeshipment',
						dataType: 'json',
						data: { req: data2 },
						success: function (data) {
							this.setState({
								free_ship_msg: data.msg
							});
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
						}.bind(this),
						error: function error(err) {}
					});
				} else {
					this.setState({
						err_pincode: true,
						err_pincode_msg: '* Invalid pincode'
					});
				}
			}
		}, {
			key: 'pincodeChange',
			value: function pincodeChange() {
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(this.refs.pincode.value)) {
					var x = this.refs.pincode.value.replace(invalidChars, "");
				} else {
					this.setState({
						err_pincode: true
					});
				}
				this.setState({
					user_zipcode: x,
					err_pincode: false
				});
			}
		}, {
			key: 'addToWishlist',
			value: function addToWishlist() {
				this.setState({
					page_loading: true
				});
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('web_addtowishlist', '1');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, type: 0, did: this.props.params.Sid };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'addToWishlist',
						success: function (data) {
							if (data.status === 'success' && data.message === 'Added to wish list') {
								this.setState({
									wishLst_flag: 1,
									page_loading: false
								});
							}
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
							localStorage.removeItem('web_addtowishlist');
						}.bind(this),
						error: function error(err) {
							this.setState({
								page_loading: false
							});
						}
					});
				}
			}
		}, {
			key: 'checkBestPriceOnload',
			value: function checkBestPriceOnload() {
				if (!localStorage.user_id && !localStorage.token) {
					_reactRouter.browserHistory.push('/web/login');
				} else {
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					var data1 = { from: 'desktop_web', did: this.props.params.Sid, id: uid, dtype: 0, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'checkBestPriceLead',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success' && data.proceed === 1) {
								this.setState({
									reqbestPrice: true
								});
								localStorage.removeItem('web_seed_checkbestprice');
							} else if (data.status === 'success' && data.proceed === 0) {
								this.setState({
									req_confirm_modal: true,
									req_confirm_message: data.msg
								});
								localStorage.removeItem('web_seed_checkbestprice');
							}
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
						}.bind(this),
						error: function error(err) {
							localStorage.removeItem('web_seed_checkbestprice');
						}
					});
				}
			}
		}, {
			key: 'checkBestPrice',
			value: function checkBestPrice() {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('web_seed_checkbestprice', '1');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					var data1 = { from: 'desktop_web', did: this.props.params.Sid, id: uid, dtype: 0, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'checkBestPriceLead',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success' && data.proceed === 1) {
								this.setState({
									reqbestPrice: true
								});
								localStorage.removeItem('web_seed_checkbestprice');
							} else if (data.status === 'success' && data.proceed === 0) {
								this.setState({
									req_confirm_modal: true,
									req_confirm_message: data.msg
								});
								localStorage.removeItem('web_seed_checkbestprice');
							}
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
						}.bind(this),
						error: function error(err) {
							localStorage.removeItem('web_seed_checkbestprice');
						}
					});
				}
			}
		}, {
			key: 'ShareFunc',
			value: function ShareFunc(evnt) {
				var _this2 = this;
	
				var data1 = { from: 'desktop_web', type: 0, did: this.props.params.Sid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'createTinyurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							shareUrl: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {}
				});
				this.setState({
					open: !this.state.open
				});
				setTimeout(function () {
					_this2.setState({ open: false });
				}, 10000);
			}
			// below function is related to quick buy 
	
		}, {
			key: 'addQCart',
			value: function addQCart(dealid) {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('web_quickcart', '/web/quickcart');
					localStorage.setItem('quickbuy_onload', '1');
					localStorage.setItem('quickbuy_deal_id', dealid);
	
					localStorage.setItem('web_quickbuy_qty', this.state.min_allowed_qty);
					localStorage.setItem('web_quickbuy_pick_date', this.state.active_date);
					localStorage.setItem('web_quickbuy_salinity', this.state.salinity);
					localStorage.setItem('web_quickbuy_plsize', this.state.plsize);
					_reactRouter.browserHistory.push('/web/login');
				} else {
	
					if (this.state.plsize === 0) {
						var seed_plsize = 'PLSIZE';
					} else {
						seed_plsize = this.state.plsize;
					}
					if (this.state.salinity === 0) {
						var seed_salinity = 'SALINITY';
					} else {
						seed_salinity = this.state.salinity;
					}
					if (this.state.active_date === '') {
						var pickup_date = this.state.cart_date_active;
					} else {
						pickup_date = this.state.active_date;
					}
	
					if (this.state.min_allowed_qty) {
						var quantity = this.state.min_allowed_qty;
					} else {
						quantity = '';
					}
	
					var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, deal_id: dealid, deal_type: 0, quantity: quantity, pl_size: seed_plsize, salinity: seed_salinity, pickup_date: pickup_date };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						url: baseUrl + 'addToQCart',
						method: 'POST',
						data: { req: data2 },
						dataType: 'JSON',
						success: function (data) {
							if (data.status === 'success') {
								_reactRouter.browserHistory.push('/web/quickcart');
							} else if (data.status === 'error' && data.cart_flag === 0) {
								this.setState({ clearcart_status: true });
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
							}
						}.bind(this),
						error: function error(err) {}
	
					});
				}
			}
		}, {
			key: 'addQCart_Onload',
			value: function addQCart_Onload() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				if (localStorage.quickbuy_deal_id) {
					var dealid = localStorage.quickbuy_deal_id;
				} else {
					dealid = 0;
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('web_quickcart', '/web/quickcart');
					localStorage.setItem('quickbuy_onload', '1');
					// localStorage.setItem('quickbuy_deal_id',dealid);
					_reactRouter.browserHistory.push('/web/login');
				} else {
	
					if (localStorage.web_quickbuy_qty) {
						var quantity = localStorage.web_quickbuy_qty;
					} else {
						quantity = '';
					}
	
					if (localStorage.web_quickbuy_pick_date) {
						var pickup_date = localStorage.web_quickbuy_pick_date;
					} else {
						pickup_date = '';
					}
	
					if (localStorage.web_quickbuy_salinity) {
						var seed_salinity = localStorage.web_quickbuy_salinity;
					} else {
						seed_salinity = 'SALINITY';
					}
	
					if (localStorage.web_quickbuy_plsize) {
						var seed_plsize = localStorage.web_quickbuy_plsize;
					} else {
						seed_plsize = 'PLSIZE';
					}
	
					var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, deal_id: dealid, deal_type: 0, quantity: quantity, pl_size: seed_plsize, salinity: seed_salinity, pickup_date: pickup_date };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						url: baseUrl + 'addToQCart',
						method: 'POST',
						data: { req: data2 },
						dataType: 'JSON',
						success: function (data) {
							if (data.status === 'success') {
								_reactRouter.browserHistory.push('/web/quickcart');
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							} else if (data.status === 'error' && data.cart_flag === 0) {
								this.setState({ clearcart_status: true });
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							}
							localStorage.removeItem('quickbuy_onload');
							localStorage.removeItem('quickbuy_deal_id');
						}.bind(this),
						error: function error(err) {}
	
					});
				}
			}
		}, {
			key: 'addtocartOnload',
			value: function addtocartOnload() {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('web_seed_addtocart', '1');
					localStorage.setItem('web_seed_addtocart_qty', this.state.min_allowed_qty);
					_reactRouter.browserHistory.push('/web/login');
				} else {
					if (localStorage.web_seed_addtocart_pick_date) {
						this.setState({
							rotateClass: true
						});
						var quantity = '';
						if (localStorage.web_seed_addtocart_qty) {
							quantity = localStorage.getItem('web_seed_addtocart_qty');
						} else {
							quantity = '';
						}
						if (quantity < parseInt(this.state.min_allowed_qty1, 10) || quantity === "NaN") {
							this.setState({
								err_qty_status_1: true,
								err_qty_msg: "* Minimum Quantity is " + this.state.min_allowed_qty1,
								min_allowed_qty: this.state.min_allowed_qty1,
								millions: parseInt(this.state.min_allowed_qty1, 10) / 1000000
							});
							quantity = this.state.min_allowed_qty1;
						} else if (quantity === '') {
							this.setState({
								min_allowed_qty: this.state.available_qty,
								millions: parseInt(this.state.available_qty, 10) / 1000000,
								err_qty_status_1: true,
								err_qty_msg: "* Minimum Quantity is " + this.state.min_allowed_qty1
							});
						} else if (quantity > parseInt(this.state.available_qty, 10)) {
							this.setState({
								min_allowed_qty: this.state.available_qty,
								millions: parseInt(this.state.available_qty, 10) / 1000000,
								err_qty_status_1: true,
								err_qty_msg: '* Maximum quantity is ' + this.state.available_qty
							});
						} else {
							this.setState({
								err_qty_status_1: false,
								err_qty_msg: ''
							});
							quantity = localStorage.getItem('web_seed_addtocart_qty');
						}
						if (quantity >= this.state.min_allowed_qty1 && quantity !== "NaN") {
							if (localStorage.web_seed_addtocart_plsize && localStorage.web_seed_addtocart_plsize !== '0') {
								var seed_plsize = localStorage.getItem('web_seed_addtocart_plsize');
							} else {
								seed_plsize = 'PLSIZE';
							}
							if (localStorage.web_seed_addtocart_salinity && localStorage.web_seed_addtocart_salinity !== '0') {
								var seed_salinity = localStorage.getItem('web_seed_addtocart_salinity');
							} else {
								seed_salinity = 'SALINITY';
							}
							if (localStorage.web_seed_addtocart_pick_date) {
								var pickup_date = localStorage.getItem('web_seed_addtocart_pick_date');
							} else {
								pickup_date = this.state.active_date;
							}
	
							// Google campaign source params starts here
							if (localStorage.source) {
								var source = localStorage.getItem('source');
							} else {
								source = '';
							}
							if (localStorage.campaign) {
								var campaign = localStorage.getItem('campaign');
							} else {
								campaign = '';
							}
							if (localStorage.url_id) {
								var url_id = localStorage.getItem('url_id');
							} else {
								url_id = '';
							}
							if (localStorage.user_id) {
								var uid = localStorage.getItem('user_id');
							} else {
								uid = 0;
							}
							var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token'), deal_id: this.props.params.Sid, deal_type: 0, quantity: quantity, pl_size: seed_plsize, salinity: seed_salinity, pickup_date: pickup_date, source: source, campaign: campaign, url_id: url_id };
							var data2 = JSON.stringify(data1);
							_jquery2.default.ajax({
								method: 'post',
								dataType: 'json',
								url: baseUrl + 'addToCart',
								data: { req: data2 },
								success: function (data) {
									if (data.status === "success" && data.message === "Added to cart") {
										this.setState({
											addtocart_msg: 'Go to Cart',
											addtocart_status: true,
											is_cart: 1
										});
										localStorage.removeItem('web_seed_addtocart');
										localStorage.removeItem('web_seed_addtocart_qty');
										localStorage.removeItem('web_seed_addtocart_pick_date');
										localStorage.removeItem('web_seed_addtocart_salinity');
										localStorage.removeItem('web_seed_addtocart_plsize');
									}
									if (data.status === "success" && data.message === "Cart Updated") {
										this.setState({
											updatecart_status: true,
											addtocart_msg: 'Go to Cart',
											is_cart: 1
										});
										localStorage.removeItem('web_seed_addtocart');
										localStorage.removeItem('web_seed_addtocart_qty');
										localStorage.removeItem('web_seed_addtocart_pick_date');
										localStorage.removeItem('web_seed_addtocart_salinity');
										localStorage.removeItem('web_seed_addtocart_plsize');
									}
									if (data.status === "error" && data.cart_flag === 0) {
										this.setState({
											clearcart_status: true
										});
										localStorage.removeItem('web_seed_addtocart');
										localStorage.removeItem('web_seed_addtocart_qty');
										localStorage.removeItem('web_seed_addtocart_pick_date');
										localStorage.removeItem('web_seed_addtocart_salinity');
										localStorage.removeItem('web_seed_addtocart_plsize');
									}
									if (data.status === "error" && data.message === "Product already added to the cart" && data.cart_flag === 1) {
										this.setState({
											cart_added_status: true,
											addtocart_msg: 'Go to Cart',
											addtocart_status: true,
											is_cart: 1,
											product_existed: true
										});
										localStorage.removeItem('web_seed_addtocart');
										localStorage.removeItem('web_seed_addtocart_qty');
										localStorage.removeItem('web_seed_addtocart_pick_date');
										localStorage.removeItem('web_seed_addtocart_salinity');
										localStorage.removeItem('web_seed_addtocart_plsize');
									}
									this.getCartCount();
									if (data.status === 'error' && data.message === 'Token mismatch') {
										this.tokenCheck();
									}
								}.bind(this),
								error: function error(err) {}
							});
						}
					}
				}
			}
		}, {
			key: 'placeOrderModal',
			value: function placeOrderModal() {
				if (this.state.addtocart_msg === "Go to Cart") {
					_reactRouter.browserHistory.push('/web/mycart');
				}
				if (!localStorage.user_id && !localStorage.token) {
					if (this.state.date_flag === true) {
						this.setState({
							err_date: '',
							err_date_status: false
						});
						localStorage.setItem('web_seed_addtocart', '1');
						localStorage.setItem('web_seed_addtocart_qty', this.state.min_allowed_qty);
						localStorage.setItem('web_seed_addtocart_pick_date', this.state.active_date);
						localStorage.setItem('web_seed_addtocart_salinity', this.state.salinity);
						localStorage.setItem('web_seed_addtocart_plsize', this.state.plsize);
						_reactRouter.browserHistory.push('/web/login');
					} else {
						this.setState({
							err_date: '* Please Select Pickup Date',
							err_date_status: true
						});
						alert('* Please Select Pickup Date');
					}
				} else {
					if (this.state.date_flag === true) {
						this.setState({
							err_date: '',
							err_date_status: false
						});
					} else {
						this.setState({
							err_date: '* Please Select Pickup Date',
							err_date_status: true
						});
						alert('* Please Select Pickup Date');
					}
					if (this.state.date_flag === true) {
						if (this.state.addtocart_msg === "Add to Cart" || this.state.addtocart_msg === "Update Cart") {
							this.setState({
								rotateClass: true
							});
							var quantity = '';
							if (this.refs.input_minqty.value < parseInt(this.state.min_allowed_qty1, 10) || this.refs.input_minqty.value === "NaN") {
								this.setState({
									err_qty_status_1: true,
									err_qty_msg: "* Minimum Quantity is " + this.state.min_allowed_qty1,
									min_allowed_qty: this.state.min_allowed_qty1,
									millions: parseInt(this.state.min_allowed_qty1, 10) / 1000000
								});
								quantity = this.state.min_allowed_qty1;
							} else if (this.refs.input_minqty.value === '') {
								this.setState({
									min_allowed_qty: this.state.available_qty,
									millions: parseInt(this.state.available_qty, 10) / 1000000,
									err_qty_status_1: true,
									err_qty_msg: "* Minimum Quantity is " + this.state.min_allowed_qty1
								});
							} else if (this.refs.input_minqty.value > parseInt(this.state.available_qty, 10)) {
								this.setState({
									min_allowed_qty: this.state.available_qty,
									millions: parseInt(this.state.available_qty, 10) / 1000000,
									err_qty_status_1: true,
									err_qty_msg: '* Maximum quantity is ' + this.state.available_qty
								});
							} else {
								this.setState({
									err_qty_status_1: false,
									err_qty_msg: ''
								});
								quantity = this.refs.input_minqty.value;
							}
							if (this.refs.input_minqty.value >= this.state.min_allowed_qty1 && this.refs.input_minqty.value !== "NaN") {
								if (this.state.plsize === 0) {
									var seed_plsize = 'PLSIZE';
								} else {
									seed_plsize = this.state.plsize;
								}
								if (this.state.salinity === 0) {
									var seed_salinity = 'SALINITY';
								} else {
									seed_salinity = this.state.salinity;
								}
								if (localStorage.source) {
									var source = localStorage.getItem('source');
								} else {
									source = '';
								}
								if (localStorage.campaign) {
									var campaign = localStorage.getItem('campaign');
								} else {
									campaign = '';
								}
								if (localStorage.url_id) {
									var url_id = localStorage.getItem('url_id');
								} else {
									url_id = '';
								}
								if (this.state.active_date === '') {
									var pickup_date = this.state.cart_date_active;
								} else {
									pickup_date = this.state.active_date;
								}
								var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: this.props.params.Sid, deal_type: 0, quantity: quantity, pl_size: seed_plsize, salinity: seed_salinity, pickup_date: pickup_date, source: source, campaign: campaign, url_id: url_id };
								var data2 = JSON.stringify(data1);
								_jquery2.default.ajax({
									method: 'post',
									dataType: 'json',
									url: baseUrl + 'addToCart',
									data: { req: data2 },
									success: function (data) {
										if (data.status === "success" && data.message === "Added to cart") {
											this.setState({
												addtocart_msg: 'Go to Cart',
												addtocart_status: true,
												is_cart: 1
											});
											localStorage.removeItem('web_seed_addtocart');
											localStorage.removeItem('web_seed_addtocart_qty');
											localStorage.removeItem('web_seed_addtocart_pick_date');
											localStorage.removeItem('web_seed_addtocart_salinity');
											localStorage.removeItem('web_seed_addtocart_plsize');
										}
										if (data.status === "success" && data.message === "Cart Updated") {
											this.setState({
												updatecart_status: true,
												addtocart_msg: 'Go to Cart',
												is_cart: 1
											});
											localStorage.removeItem('web_seed_addtocart');
											localStorage.removeItem('web_seed_addtocart_qty');
											localStorage.removeItem('web_seed_addtocart_pick_date');
											localStorage.removeItem('web_seed_addtocart_salinity');
											localStorage.removeItem('web_seed_addtocart_plsize');
										}
										if (data.status === "error" && data.cart_flag === 0) {
											this.setState({
												clearcart_status: true
											});
											localStorage.removeItem('web_seed_addtocart');
											localStorage.removeItem('web_seed_addtocart_qty');
											localStorage.removeItem('web_seed_addtocart_pick_date');
											localStorage.removeItem('web_seed_addtocart_salinity');
											localStorage.removeItem('web_seed_addtocart_plsize');
										}
										if (data.status === "error" && data.message === "Product already added to the cart" && data.cart_flag === 1) {
											this.setState({
												cart_added_status: true,
												addtocart_msg: 'Go to Cart',
												addtocart_status: true,
												is_cart: 1,
												product_existed: true
											});
											localStorage.removeItem('web_seed_addtocart');
											localStorage.removeItem('web_seed_addtocart_qty');
											localStorage.removeItem('web_seed_addtocart_pick_date');
											localStorage.removeItem('web_seed_addtocart_salinity');
											localStorage.removeItem('web_seed_addtocart_plsize');
										}
										this.getCartCount();
										if (data.status === 'error' && data.message === 'Token mismatch') {
											this.props.tokenCheck();
										}
									}.bind(this),
									error: function error(err) {
										localStorage.removeItem('web_seed_addtocart');
										localStorage.removeItem('web_seed_addtocart_qty');
										localStorage.removeItem('web_seed_addtocart_pick_date');
										localStorage.removeItem('web_seed_addtocart_salinity');
										localStorage.removeItem('web_seed_addtocart_plsize');
									}
								});
							}
						}
					}
				}
			}
		}, {
			key: 'removeCartItems',
			value: function removeCartItems() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token'), deal_id: this.props.params.Sid, deal_type: 0, quantity: this.refs.input_minqty.value, pl_size: this.state.plsize, salinity: this.state.salinity, pickup_date: this.state.active_date, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'replaceCart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success" && data.cart_flag === 1) {
							this.setState({
								addtocart_msg: 'Go to Cart',
								clearcart_status: false,
								addtocart_status: true
							});
							this.getCartCount();
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'DealPlSalinity',
			value: function DealPlSalinity() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', deal_id: this.props.params.Sid, id: uid, token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'DealPlSalinity',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "ok") {
							this.setState({
								plsizes: data.plsizes,
								salinities: data.salinities
							});
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.props.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'salinityChange',
			value: function salinityChange() {
				this.setState({
					salinity: this.refs.select_salinity.value
				});
				if (this.state.is_cart === 1) {
					this.setState({
						addtocart_msg: 'Update Cart'
					});
				}
			}
		}, {
			key: 'plsizeChange',
			value: function plsizeChange() {
				this.setState({
					plsize: this.refs.select_plsize.value
				});
				if (this.state.is_cart === 1) {
					this.setState({
						addtocart_msg: 'Update Cart'
					});
				}
			}
		}, {
			key: 'decrementMinQty',
			value: function decrementMinQty() {
				if (this.state.min_allowed_qty !== this.state.min_allowed_qty1 && this.state.min_allowed_qty > this.state.min_allowed_qty1) {
					var cal = parseInt(this.state.min_allowed_qty, 10) - 100000;
					this.setState({
						min_allowed_qty: parseInt(this.state.min_allowed_qty, 10) - 100000,
						min_allowed_qty_status: false,
						millions: cal / 1000000
					});
				} else {
					this.setState({
						min_allowed_qty: parseInt(this.state.min_allowed_qty1, 10),
						millions: parseInt(this.state.min_allowed_qty1, 10) / 1000000
					});
				}
				if (this.state.is_cart === 1) {
					this.setState({
						addtocart_msg: 'Update Cart'
					});
				}
			}
		}, {
			key: 'updateMinQty',
			value: function updateMinQty(event) {
				this.setState({
					err_qty_status_1: false,
					err_qty_msg: ''
				});
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						min_allowed_qty: x,
						millions: parseInt(x, 10) / 1000000
					});
				}
				if (this.refs.input_minqty.value > parseInt(this.state.available_qty, 10)) {
					// alert(this.state.max_qty1);
					this.setState({
						min_allowed_qty: this.state.available_qty,
						millions: parseInt(this.state.available_qty, 10) / 1000000,
						err_qty_status_1: true,
						err_qty_msg: '* Maximum quantity is ' + this.state.available_qty
					});
				} else if (this.refs.input_minqty.value === "") {
					this.setState({
						min_allowed_qty: '',
						err_qty_status_1: true,
						err_qty_msg: '* Minimum quantity is ' + this.state.min_allowed_qty1,
						millions: 0
					});
				}
				// else
				// {
				// 	this.setState({
				// 		min_allowed_qty : this.refs.input_minqty.value,
				// 		millions:parseInt(this.refs.input_minqty.value,10) / 1000000,
				// 	});
				// }
			}
		}, {
			key: 'incrementMinQty',
			value: function incrementMinQty() {
				var cal = parseInt(this.state.min_allowed_qty, 10) + 100000;
				if (cal <= this.state.available_qty) {
					this.setState({
						min_allowed_qty: parseInt(this.state.min_allowed_qty, 10) + 100000,
						millions: cal / 1000000,
						err_qty_status_1: false,
						err_qty_msg: ''
					});
				} else if (this.refs.input_minqty.value === '') {
					this.setState({
						min_allowed_qty: this.state.min_allowed_qty1,
						millions: parseInt(this.state.min_allowed_qty1, 10) / 1000000,
						err_qty_status_1: true,
						err_qty_msg: '* Minimum quantity is ' + this.state.min_allowed_qty1
					});
				} else {
					this.setState({
						min_allowed_qty: parseInt(this.state.available_qty, 10),
						millions: parseInt(this.state.available_qty, 10) / 1000000,
						min_allowed_qty_status: true,
						err_qty_status_1: true,
						err_qty_msg: '* Maximum quantity is ' + this.state.available_qty
					});
				}
				if (this.state.is_cart === 1) {
					this.setState({
						addtocart_msg: 'Update Cart'
					});
				}
			}
		}, {
			key: 'changeDate',
			value: function changeDate(dt) {
				this.setState({
					active_date: dt,
					date_flag: true,
					err_date_status: false,
					cart_date_active: dt
				});
				if (this.state.is_cart === 1) {
					this.setState({
						addtocart_msg: 'Update Cart'
					});
				}
			}
		}, {
			key: 'getDates',
			value: function getDates() {
				var day = 1000 * 60 * 60 * 24;
				var d1 = Date.parse(this.state.start_date);
				var d2 = Date.parse(this.state.end_date);
				var d3 = Date.parse(this.state.cart_date);
				var date1 = new Date(d1);
				var date2 = new Date(d2);
				var date3 = new Date(d3);
				var diff = (date2.getTime() - date1.getTime()) / day;
				var dates = [];
				var months = new Array(12);
				months[0] = "Jan";
				months[1] = "Feb";
				months[2] = "Mar";
				months[3] = "Apr";
				months[4] = "May";
				months[5] = "Jun";
				months[6] = "Jul";
				months[7] = "Aug";
				months[8] = "Sep";
				months[9] = "Oct";
				months[10] = "Nov";
				months[11] = "Dec";
				for (var i = 0; i <= diff; i++) {
					var xx = date1.getTime() + day * i;
					var yy = new Date(xx);
					var monthName = months[yy.getMonth()];
					var tt = yy.getDate() + " " + monthName + " " + yy.getFullYear();
					dates[i + 1] = tt;
				}
	
				if (this.state.cart_date !== '') {
					var a = date3.getTime();
					var b = new Date(a);
					monthName = months[b.getMonth()];
					var c = b.getDate() + " " + monthName + " " + b.getFullYear();
					this.setState({
						cart_date_active: c
					});
				}
				this.setState({
					seeddates: dates
				});
			}
		}, {
			key: 'req_pincodeChange',
			value: function req_pincodeChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						req_pincode: x
					});
				}
			}
		}, {
			key: 'req_quantityChange',
			value: function req_quantityChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						req_quantity: x
					});
				}
			}
		}, {
			key: 'req_stateChange',
			value: function req_stateChange(event) {
				var x = event.target.value;
				var namePattern = /^[a-z A-Z]+$/;
				if (!namePattern.test(event.target.value) && x !== '') {
					x = event.target.value.replace(namePattern, "");
				} else {
					this.setState({
						req_state: event.target.value
					});
				}
			}
		}, {
			key: 'req_cityChange',
			value: function req_cityChange(event) {
				// this.setState({
				// 	req_city:event.target.value,
				// });
				var x = event.target.value;
				var namePattern = /^[a-z A-Z]+$/;
				if (!namePattern.test(event.target.value) && x !== '') {
					x = event.target.value.replace(namePattern, "");
				} else {
					this.setState({
						req_city: event.target.value
					});
				}
			}
		}, {
			key: 'req_doornoChange',
			value: function req_doornoChange(event) {
				this.setState({
					req_doorno: event.target.value
				});
			}
		}, {
			key: 'reqBestPriceSubmit',
			value: function reqBestPriceSubmit(event) {
				event.preventDefault();
				var quantity = this.refs.req_quantity.value;
				var state = this.refs.req_state.value;
				var city = this.refs.req_city.value;
				var doorno = this.refs.req_doorno.value;
				var pincode = this.refs.req_pincode.value;
	
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var flag = 0;
				var namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
	
				if (quantity === '' && quantity.length < 1) {
					(0, _jquery2.default)('#req_quantity_err').text('* enter quantity');
					flag = 1;
				}
				if (state === '' && !namePattern.test(state) && state.length < 2) {
					(0, _jquery2.default)('#req_state_err').text('* enter state');
					flag = 1;
				}
				if (state !== '' && state.length < 2 && !namePattern.test(state)) {
					(0, _jquery2.default)('#req_state_err').text('* enter valid state');
					flag = 1;
				}
				if (city === '' && !namePattern.test(city)) {
					(0, _jquery2.default)('#req_city_err').text('* enter city');
					flag = 1;
				}
				if (city !== '' && city.length < 3) {
					(0, _jquery2.default)('#req_city_err').text('* enter city');
					flag = 1;
				}
				if (doorno === '' && doorno.length <= 1) {
					(0, _jquery2.default)('#req_doorno_err').text('* enter address');
					flag = 1;
				}
				if (doorno !== '' && doorno.length <= 1) {
					(0, _jquery2.default)('#req_doorno_err').text('* enter address');
					flag = 1;
				}
				if (pincode === '' && pincode.length < 6) {
					(0, _jquery2.default)('#req_pincode_err').text('* enter valid pincode');
					flag = 1;
				}
				if (pincode !== '' && pincode.length < 6) {
					(0, _jquery2.default)('#req_pincode_err').text('* enter valid pincode');
					flag = 1;
				}
				if (quantity !== '' && quantity < parseInt(this.state.min_allowed_qty1, 10)) {
					(0, _jquery2.default)('#req_quantity_err').text('* minimum quantity is ' + this.state.min_allowed_qty1);
					flag = 1;
				}
				if (quantity > parseInt(this.state.available_qty, 10)) {
					(0, _jquery2.default)('#req_quantity_err').text('* maximum quantity is ' + this.state.available_qty);
					flag = 1;
				}
	
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				if (flag === 0) {
					var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, did: this.props.params.Sid, dtype: '0', req_qty: this.state.req_quantity, state: this.state.req_state, city: this.state.req_city, address: this.state.req_doorno, req_loc: this.state.req_pincode, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'saveBestpriceLead',
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									reqbestPrice: false,
									req_confirm_modal: true,
									req_confirm_message: data.message
								});
							}
							if (data.status === 'error' && data.message === 'Token mismatch') {
								this.props.tokenCheck();
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var params = {
					// paginationClickable: true,
					// spaceBetween: 10,
					// slidesPerView: 10,
					// sliderPerGroup:5,
	
					//  navigation: {
					//    nextEl: '.swiper-button-next',
					//    prevEl: '.swiper-button-prev'
					//   },
					//   pagination: '.swiper-pagination', 
					paginationClickable: true,
					spaceBetween: 10,
					slidesPerView: 8,
					// autoplay:3000,
					autoplayDisableOnInteraction: false,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				};
				var shareUrl = this.state.shareUrl;
				var title = "Hey Click here " + shareUrl + " to check " + this.state.sp_name + " deal from AquaDeals.";
				var description = shareUrl;
				var x = _jquery2.default.makeArray(this.state.seeddates);
				var seeddates = x.map(function (dt, index) {
					var _this3 = this;
	
					return _react2.default.createElement(
						'div',
						{ className: this.state.active_date === dt || this.state.cart_date_active === dt ? "web_seed_dateblk web_seed_dateblk_active" : "web_seed_dateblk", key: dt, onClick: function onClick() {
								_this3.changeDate(dt);
							} },
						_react2.default.createElement(
							'div',
							{ className: 'web_seed_date' },
							dt
						)
					);
				}.bind(this));
	
				// var shipment= this.state.details.free_shipment === '0' ? '' : <p><i className="det_icons"><img className="ship_icon1" src={baseAssets+'icons/web_icons/shipping_van.png'} alt="aqua" /></i>{this.state.details.shipping_desc}</p>;
				// var credit = this.state.details.credit_facility === '0' ? '' : <h5><i><img className="credit_title" src={baseAssets+'images/web_imgs/credit_ava.png'} alt="aqua" /></i>{this.state.details.credit_title}</h5>;
				var views_cnt = this.state.details.views_count >= 1 ? _react2.default.createElement(
					'span',
					null,
					_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/pro_views_icon.png', 'class': 'pro_vies', width: '20px', alt: ' ' }),
					' ',
					this.state.details.views_count
				) : '';
	
				// var rec_cnt=this.state.details.recomends >=1 ? <span className="recommended_img"><img src={baseAssets+'icons/web_icons/recommended1.png'} width="17px" alt=" " /> {this.state.details.recomends}</span> : '';
				var recommendation = this.state.recomends >= 1 ? _react2.default.createElement(
					'span',
					null,
					_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/like_icon.png', alt: ' ' }),
					' ',
					this.state.recomends
				) : '';
				var getcoupons = '';
				if (this.state.coupons.length > 0) {
					getcoupons = "coupons";
					// const descriptionTop = (
					// 	  <Popover id="popover-positioned-top">
					// 		    {this.state.coupon_first.description}
					// 	  </Popover>
					// );
					var couponsList = _react2.default.createElement(
						_reactBootstrap.Popover,
						{ id: 'popover-positioned-top1' },
						this.state.cpns_list.replace(/,\s*$/, "")
					);
					if (this.state.coupons.length === 1) {
						getcoupons = _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'cupn_inpt' },
								_react2.default.createElement(
									'i',
									{ className: 'cupn_icon' },
									_react2.default.createElement('img', { alt: ' ', src: baseAssets + 'icons/web_icons/coupon_left.png' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'coupon_text' },
									this.state.coupon_first.coupon_code
								)
							)
						);
					} else {
						getcoupons = _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'cupn_inpt' },
								_react2.default.createElement(
									'i',
									{ className: 'cupn_icon' },
									_react2.default.createElement('img', { alt: ' ', src: baseAssets + 'icons/web_icons/coupon_left.png' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'coupon_text' },
									this.state.coupon_first.coupon_code
								)
							),
							_react2.default.createElement(
								'div',
								{ className: '' },
								_react2.default.createElement(
									_reactBootstrap.OverlayTrigger,
									{ trigger: 'focus', placement: 'top', overlay: couponsList },
									_react2.default.createElement(
										_reactBootstrap.Button,
										{ className: 'btn btn-default apld_cupns' },
										'Applied coupons'
									)
								)
							)
						);
					}
				} else {
					getcoupons = '';
				}
	
				var plsizes = this.state.plsizes.map(function (pl, index) {
					return _react2.default.createElement(
						'option',
						{ key: pl, value: pl },
						pl
					);
				});
				var salinities = this.state.salinities.map(function (sal, index) {
					return _react2.default.createElement(
						'option',
						{ key: sal, value: sal },
						sal
					);
				});
	
				// errors of the req form 
				(0, _jquery2.default)('#req_quantity').keyup(function () {
					(0, _jquery2.default)('#req_quantity_err').text('');
				});
				(0, _jquery2.default)('#req_state').keyup(function () {
					(0, _jquery2.default)('#req_state_err').text('');
				});
				(0, _jquery2.default)('#req_city').keyup(function () {
					(0, _jquery2.default)('#req_city_err').text('');
				});
				(0, _jquery2.default)('#req_doorno').keyup(function () {
					(0, _jquery2.default)('#req_doorno_err').text('');
				});
				(0, _jquery2.default)('#req_pincode').keyup(function () {
					(0, _jquery2.default)('#req_pincode_err').text('');
				});
	
				var wishLst_flag = '';
				if (this.state.wishLst_flag === 1) {
					wishLst_flag = _react2.default.createElement(
						'div',
						{ className: 'web_goto_wish_blk' },
						_react2.default.createElement(
							'div',
							{ className: '' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/web/wishlist' },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/wish_list_filled.png', alt: '', width: '29px', title: 'GO TO WISHLIST' })
								),
								' '
							)
						)
					);
				} else {
					wishLst_flag = _react2.default.createElement(
						'div',
						{ className: 'web_addto_wish_blk' },
						_react2.default.createElement(
							'div',
							{ className: '' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ onClick: function onClick() {
										_this4.addToWishlist();
									} },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/wish_list_unfilled.png', alt: '', width: '20px', title: 'ADD TO WISHLIST' })
								)
							)
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_seed_details_page' },
					this.state.loading ? _react2.default.createElement(
						'div',
						{ className: 'lgt_gry' },
						_react2.default.createElement(_WebHeaderInner2.default, { cart_updated_count: this.state.cart_count }),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'section',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									_reactBootstrap.Breadcrumb,
									{ className: 'webseed_breadcrumb' },
									_react2.default.createElement(
										_reactBootstrap.Breadcrumb.Item,
										{ href: '/web/home' },
										'Home'
									),
									_react2.default.createElement(
										_reactBootstrap.Breadcrumb.Item,
										{ href: '/web/seed' },
										'Seed'
									),
									_react2.default.createElement(
										_reactBootstrap.Breadcrumb.Item,
										{ href: '/web/seed/' + this.state.SName + "/" + this.state.seed_type_id },
										this.state.SName
									),
									_react2.default.createElement(
										_reactBootstrap.Breadcrumb.Item,
										{ active: true },
										this.state.sp_name,
										' Details'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row pro_dtls' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-4' },
									wishLst_flag,
									_react2.default.createElement('img', { itemProp: 'image', src: baseAssets + 'images/seller_imgs/' + this.state.res_img, alt: ' ' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-8' },
									_react2.default.createElement(
										'div',
										{ className: 'pro_info' },
										this.state.sp_name ? _react2.default.createElement(
											'h3',
											null,
											this.state.sp_name
										) : '',
										_react2.default.createElement(
											_reactRouter.Link,
											{ className: 'share_btn', onClick: function onClick() {
													_this4.ShareFunc(_this4.state.seedid);
												} },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/share_icon.png', alt: 'share', width: '19px' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'web_full_share_panel' },
											_react2.default.createElement(
												_reactBootstrap.Panel,
												{ className: 'seed_full_panel1', collapsible: true, expanded: this.state.open },
												_react2.default.createElement(
													FacebookShareButton,
													{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
													_react2.default.createElement(FacebookIcon, { size: 32, round: true })
												),
												_react2.default.createElement(
													TwitterShareButton,
													{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
													_react2.default.createElement(TwitterIcon, { size: 32, round: true })
												),
												_react2.default.createElement(
													GooglePlusShareButton,
													{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
													_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										),
										this.state.hatchary_details.org_name ? _react2.default.createElement(
											'h4',
											null,
											this.state.hatchary_details.org_name
										) : '',
										_react2.default.createElement(
											'div',
											{ className: 'star_view_like' },
											_react2.default.createElement(
												'ul',
												null,
												views_cnt ? _react2.default.createElement(
													'li',
													null,
													_react2.default.createElement(
														'span',
														null,
														views_cnt
													)
												) : '',
												recommendation ? _react2.default.createElement(
													'li',
													null,
													_react2.default.createElement(
														'span',
														null,
														recommendation
													)
												) : ''
											),
											_react2.default.createElement('div', { className: 'ad_gurnted' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'pric_ofers' },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-6' },
											_react2.default.createElement(
												'div',
												{ className: 'pro_pric_blk' },
												this.state.original_price ? _react2.default.createElement(
													'h5',
													null,
													'Rs.',
													this.state.original_price
												) : ''
											),
											_react2.default.createElement(
												'div',
												{ className: 'cupn_blk' },
												this.state.coupons.length > 0 ? _react2.default.createElement(
													'div',
													{ className: 'coupons_list' },
													getcoupons
												) : ''
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-6 dscnt_ofrs' },
											_react2.default.createElement(
												'h4',
												null,
												'Discount & Offers'
											),
											_react2.default.createElement(
												'div',
												{ className: 'dscnt_ofrs_blk' },
												_react2.default.createElement(
													'div',
													{ className: 'row web_dis_ofr_blk' },
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-1 web_dis_ofr_lft' },
														this.state.test.aqua_cash_title ? _react2.default.createElement(
															'i',
															{ className: 'bookcsh2' },
															_react2.default.createElement('img', { className: 'newaquacash_icon2', src: baseAssets + 'icons/web_icons/nav_aquacash.png', alt: ' ' })
														) : ''
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-11 web_dis_ofr_rgt' },
														this.state.test.aqua_cash_title ? this.state.test.aqua_cash_title : ''
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-1 web_dis_ofr_lft' },
														this.state.test.full_aquacash_back_title ? _react2.default.createElement(
															'i',
															null,
															_react2.default.createElement('img', { className: 'full_aquacash_back_title2', src: baseAssets + 'icons/web_icons/newcashback.png', alt: '' })
														) : ''
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-11 web_dis_ofr_rgt' },
														this.state.test.full_aquacash_back_title ? this.state.test.full_aquacash_back_title : ''
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-1 web_dis_ofr_lft' },
														this.state.test.purchase_earn_disc ? _react2.default.createElement(
															'i',
															null,
															_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/nav_aquacash.png', alt: ' ' })
														) : ''
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-11 web_dis_ofr_rgt' },
														this.state.test.purchase_earn_disc ? this.state.test.purchase_earn_disc : ''
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-1 web_dis_ofr_lft' },
														this.state.emi_opt_sts === 1 ? _react2.default.createElement(
															'i',
															null,
															_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/emi.png', alt: ' ', width: '21px' })
														) : ''
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-lg-11 web_dis_ofr_rgt' },
														this.state.emi_opt_sts === 1 ? this.state.emi_opt_desc : ''
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'qty_delvr row' },
										_react2.default.createElement(
											'div',
											{ className: this.state.free_shipment === '1' ? "col-md-6 col-sm-6" : 'col-md-12' },
											_react2.default.createElement(
												'div',
												{ className: 'web_seedqty_blk col-md-12' },
												_react2.default.createElement(
													'h4',
													null,
													'Quantity'
												),
												_react2.default.createElement(
													'ul',
													null,
													_react2.default.createElement(
														'li',
														null,
														_react2.default.createElement(
															'a',
															{ className: 'incrs_val', onClick: function onClick() {
																	_this4.decrementMinQty();
																} },
															'-'
														)
													),
													_react2.default.createElement(
														'li',
														null,
														_react2.default.createElement('input', { type: 'text', placeholder: this.state.min_allowed_qty1, value: this.state.min_allowed_qty, ref: 'input_minqty', onChange: this.updateMinQty })
													),
													_react2.default.createElement(
														'li',
														null,
														_react2.default.createElement(
															'a',
															{ className: 'incrs_val', onClick: function onClick() {
																	_this4.incrementMinQty();
																} },
															'+'
														)
													),
													_react2.default.createElement(
														'li',
														null,
														_react2.default.createElement(
															'span',
															{ className: 'equl_to' },
															'='
														)
													),
													_react2.default.createElement(
														'li',
														{ className: 'cunt_van' },
														_react2.default.createElement(
															'p',
															null,
															_react2.default.createElement(
																'span',
																{ className: 'web_seedqty_mainvalue' },
																this.state.millions
															),
															'Millions'
														),
														_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/truck.png', role: 'presentation' })
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-6 col-sm-6' },
											this.state.free_shipment === '1' ? _react2.default.createElement(
												'div',
												{ className: 'delvry_blk' },
												_react2.default.createElement(
													'h4',
													null,
													'Delivery'
												),
												this.state.free_shipment === '1' ? _react2.default.createElement(
													'div',
													null,
													_react2.default.createElement(
														'div',
														{ className: 'pin_blk' },
														_react2.default.createElement('input', { type: 'text', placeholder: 'Pincode', value: this.state.user_zipcode === '0' ? '' : this.state.user_zipcode, maxLength: 6, ref: 'pincode', onChange: function onChange() {
																_this4.pincodeChange();
															} }),
														_react2.default.createElement(
															'button',
															{ onClick: function onClick() {
																	_this4.checkPincode();
																} },
															'CHECK'
														)
													),
													this.state.err_pincode ? _react2.default.createElement(
														'p',
														{ className: 'error' },
														this.state.err_pincode_msg
													) : '',
													this.state.free_ship_msg ? _react2.default.createElement(
														'p',
														{ className: this.state.err_pincode ? 'hide' : "seed_free_ship_msg" },
														this.state.free_ship_msg
													) : ''
												) : ''
											) : ''
										)
									),
									this.state.err_qty_status_1 ? _react2.default.createElement(
										'p',
										{ className: 'web_err_seedlimit' },
										this.state.err_qty_msg
									) : '',
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-9 col-sm-9 col-lg-9' },
											_react2.default.createElement(
												'h4',
												{ className: 'seed_h4' },
												'Select PL Size & Salinity'
											),
											_react2.default.createElement(
												'div',
												{ className: 'websalinity_blk' },
												_react2.default.createElement(
													'select',
													{ value: this.state.plsize, onChange: function onChange() {
															_this4.plsizeChange();
														}, className: 'form-control select_plsize', ref: 'select_plsize' },
													_react2.default.createElement(
														'option',
														{ key: '0', value: '0', selected: true },
														'PL Size'
													),
													plsizes
												),
												_react2.default.createElement(
													'select',
													{ value: this.state.salinity, onChange: function onChange() {
															_this4.salinityChange();
														}, ref: 'select_salinity', className: 'form-control select_salinity' },
													_react2.default.createElement(
														'option',
														{ key: '0', value: '0', selected: true },
														'Salinity'
													),
													salinities
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-3 col-md-3 col-sm-3 ad_price_blk' },
											_react2.default.createElement(
												'div',
												{ className: 'ad_icons', onClick: function onClick() {
														_this4.checkBestPrice();
													} },
												_react2.default.createElement('img', { src: baseAssets + "images_web/get_best_price.png", role: 'presentation' }),
												_react2.default.createElement(
													'h6',
													null,
													'Get Best Price'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										null,
										this.state.deal_options.length <= 0 && this.state.hatchary_details.caa === "Yes" ? _react2.default.createElement(
											'div',
											{ className: 'row del_dscrptn' },
											_react2.default.createElement(
												'div',
												{ className: 'col-md-12' },
												_react2.default.createElement(
													'h4',
													{ className: 'seed_h4' },
													'Key Features'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.hatchary_details.caa === "Yes" ? _react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														'CAA Approved'
													)
												) : ''
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.hatchary_details.caa === "Yes" ? _react2.default.createElement(
													'h5',
													{ style: { color: '#333' } },
													'Yes, Vallid till ',
													this.state.hatchary_details.caa_date
												) : ''
											)
										) : '',
										this.state.deal_options.length > 0 ? _react2.default.createElement(
											'div',
											{ className: 'row del_dscrptn' },
											_react2.default.createElement(
												'div',
												{ className: 'col-md-12' },
												_react2.default.createElement(
													'h4',
													{ className: 'seed_h4' },
													'Key Features'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.hatchary_details.caa === "Yes" ? _react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														'CAA Approved'
													)
												) : ''
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.hatchary_details.caa === "Yes" ? _react2.default.createElement(
													'h5',
													null,
													'Yes, Vallid till ',
													this.state.hatchary_details.caa_date
												) : ''
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.deal_options.brod_name !== "0" ? _react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														'Brood Stock Source'
													)
												) : ''
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.deal_options.brod_name !== "0" ? _react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														this.state.deal_options.brod_name
													)
												) : ''
											),
											_react2.default.createElement('div', { className: 'clr' }),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.deal_options.nauplii !== "0" ? _react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														'Nauplii'
													)
												) : ''
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.deal_options.nauplii !== "0" ? _react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														this.state.deal_options.nauplii
													)
												) : ''
											),
											_react2.default.createElement('div', { className: 'clr' }),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.deal_options.feed_sub !== "0" ? _react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														'Feed'
													)
												) : ''
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.deal_options.feed_sub !== "0" ? _react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														this.state.deal_options.feed_sub
													)
												) : ''
											),
											_react2.default.createElement('div', { className: 'clr' }),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.deal_options.cultrDays_days !== "0" ? _react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														'Cultured Days'
													)
												) : ''
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.deal_options.cultrDays_days !== "0" ? _react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														this.state.deal_options.cultrDays_days
													)
												) : ''
											),
											_react2.default.createElement('div', { className: 'clr' }),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.deal_options.pkg_size !== "0" ? _react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														'Minimum Packing Size'
													)
												) : ''
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.deal_options.pkg_size !== "0" ? _react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														this.state.deal_options.pkg_size
													)
												) : ''
											),
											_react2.default.createElement('div', { className: 'clr' }),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.deal_options.daign_name !== "0" ? _react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														'Diagnosis'
													)
												) : ''
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.deal_options.daign_name !== "0" ? _react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														this.state.deal_options.daign_name
													)
												) : ''
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.deal_options.pcr_tests !== "0" ? _react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														'PCR Tests'
													)
												) : ''
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-6 col-xs-6 col-sm-6' },
												this.state.deal_options.pcr_tests !== "0" ? _react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														this.state.deal_options.pcr_tests
													)
												) : ''
											)
										) : ''
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									{ className: 'row webdate_blk' },
									_react2.default.createElement(
										'div',
										{ className: 'container' },
										_react2.default.createElement(
											'h4',
											null,
											'Select Date',
											_react2.default.createElement(
												'div',
												{ className: 'pro_sld_ctrls' },
												_react2.default.createElement(
													'a',
													{ className: 'left carousel-control pro_sld_lft', onClick: this.goPrev },
													_react2.default.createElement(
														'span',
														{ className: 'pro_sld_arow' },
														_react2.default.createElement('img', { src: baseAssets + 'images_web/left_arrow.png', alt: '' })
													),
													_react2.default.createElement('span', { className: 'sr-only' })
												),
												_react2.default.createElement(
													'a',
													{ className: 'right carousel-control pro_sld_rgt', onClick: this.goNext },
													_react2.default.createElement(
														'span',
														{ className: 'pro_sld_arow' },
														_react2.default.createElement('img', { src: baseAssets + 'images_web/right_arrow.png', alt: '' })
													),
													_react2.default.createElement('span', { className: 'sr-only' })
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										),
										_react2.default.createElement(
											'div',
											{ style: { paddingTop: '4px', paddingBottom: '9px' } },
											_react2.default.createElement(
												_reactIdSwiper2.default,
												_extends({}, params, { key: seeddates.length, ref: function ref(node) {
														return node ? _this4.swiper = node.swiper : '';
													} }),
												seeddates
											),
											this.state.err_date_status ? _react2.default.createElement(
												'p',
												{ className: 'err_dateselect' },
												this.state.err_date
											) : ''
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-6 col-md-offset-6' },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-6 col-sm-6' },
											_react2.default.createElement(
												'button',
												{ className: 'best_price_btn', onClick: function onClick() {
														_this4.addQCart(_this4.state.seed_id);
													} },
												_react2.default.createElement(
													'i',
													null,
													_react2.default.createElement('img', { src: baseAssets + "images/web_imgs/quick_buy.png", role: 'presentation' })
												),
												_react2.default.createElement(
													'span',
													null,
													'Quick Buy'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: this.state.rotateClass ? "col-md-6 col-sm-6 web_rotate_true" : "col-md-6 col-sm-6 web_rotate_false" },
											_react2.default.createElement(
												'button',
												{ className: 'add_cart_btn', onClick: function onClick() {
														_this4.placeOrderModal();
													} },
												_react2.default.createElement(
													'span',
													null,
													this.state.addtocart_msg
												)
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'section',
							{ className: 'more_about_slr' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									'h4',
									null,
									'More about the seller'
								),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									{ className: 'row mor_abt_slr_blk' },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-10' },
										this.state.hatchary_details.org_name ? _react2.default.createElement(
											'h4',
											null,
											_react2.default.createElement(
												'i',
												{ className: 'det_icons' },
												_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home.png', alt: 'aqua', className: 'ship_icon' }),
												' '
											),
											this.state.hatchary_details.org_name
										) : "",
										this.state.hatchary_details.coast ? _react2.default.createElement(
											'h4',
											null,
											_react2.default.createElement(
												'i',
												{ className: 'det_icons oln_payment_available' },
												_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/hat_loc.png', alt: 'aqua', className: 'online_payment_icon' }),
												' '
											),
											this.state.hatchary_details.coast
										) : ''
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-md-2' },
										this.state.rate >= 1 ? _react2.default.createElement(
											'div',
											{ className: 'web_seler_rating pull-right' },
											_react2.default.createElement('i', { className: 'glyphicon glyphicon-star' }),
											this.state.rate
										) : ''
									)
								)
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal,
							{ className: '', show: this.state.showModal, onHide: this.close },
							_react2.default.createElement(
								_reactBootstrap.Modal.Header,
								{ closeButton: true },
								_react2.default.createElement(
									_reactBootstrap.Modal.Title,
									{ style: { fontSize: 16 + 'px', color: '#333' } },
									'AquaDeals'
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal.Body,
								null,
								_react2.default.createElement(
									'h4',
									{ style: { fontSize: '14px', color: '#666' } },
									'You need to install Android mobile app to place this order.'
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal.Footer,
								{ className: 'modal_footer' },
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: '#fff none repeat scroll 0 0', color: '#ff742a', marginRight: '5px' }, onClick: this.close },
									'Close'
								),
								_react2.default.createElement(
									'a',
									{ href: 'https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en', target: '_blank', title: '' },
									_react2.default.createElement(
										_reactBootstrap.Button,
										{ style: { background: '#ff742a none repeat scroll 0 0', color: '#fff' } },
										'OK'
									)
								)
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal,
							{ className: 'm_pro_full_dtls_modal', show: this.state.clearcart_status, onHide: this.close },
							_react2.default.createElement(
								_reactBootstrap.Modal.Header,
								{ closeButton: true },
								_react2.default.createElement(
									_reactBootstrap.Modal.Title,
									{ style: { fontSize: '16px', color: '#333' } },
									'Alert'
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal.Body,
								null,
								_react2.default.createElement(
									'h4',
									{ style: { fontSize: '14px', color: '#333' } },
									'You can\'t have multiple seller items in the cart. Empty existing cart & add this item ',
									this.state.sp_name,
									'?'
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal.Footer,
								{ className: 'modal_footer' },
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
									'NO'
								),
								_react2.default.createElement(
									'a',
									null,
									_react2.default.createElement(
										_reactBootstrap.Button,
										{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: function onClick() {
												_this4.removeCartItems();
											} },
										'YES'
									)
								)
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal,
							{ className: 'm_pro_full_dtls_modal', show: this.state.product_existed, onHide: this.close },
							_react2.default.createElement(
								_reactBootstrap.Modal.Header,
								{ closeButton: true },
								_react2.default.createElement(
									_reactBootstrap.Modal.Title,
									{ style: { fontSize: '16px', color: '#333' } },
									'AquaDeals'
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal.Body,
								null,
								_react2.default.createElement(
									'h4',
									{ style: { fontSize: '14px', color: '#666' } },
									'Product already added to the cart'
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal.Footer,
								{ className: 'modal_footer' },
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
									'Close'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							_reactBootstrap.Modal,
							{ className: 'web_reqbestprice', show: this.state.reqbestPrice, onHide: this.close },
							_react2.default.createElement(
								_reactBootstrap.Modal.Body,
								null,
								_react2.default.createElement(
									'h4',
									{ className: 'req_title' },
									'REQUEST FOR BEST PRICE'
								),
								_react2.default.createElement(
									'p',
									{ className: 'webreq_desc' },
									'For bulk order requirements please fill up the form we will get back with in 48hrs time.'
								),
								_react2.default.createElement(
									'form',
									{ className: 'req_best_price_form', onSubmit: this.reqBestPriceSubmit },
									_react2.default.createElement('input', { type: 'text', maxLength: 10, id: 'req_quantity', ref: 'req_quantity', value: this.state.req_quantity, onChange: this.req_quantityChange, placeholder: 'Enter Quantity' }),
									_react2.default.createElement('span', { className: 'req_err', id: 'req_quantity_err' }),
									_react2.default.createElement('input', { type: 'text', ref: 'req_state', id: 'req_state', value: this.state.req_state, onChange: this.req_stateChange, placeholder: 'Enter State' }),
									_react2.default.createElement('span', { className: 'req_err', id: 'req_state_err' }),
									_react2.default.createElement('input', { type: 'text', ref: 'req_city', id: 'req_city', value: this.state.req_city, onChange: this.req_cityChange, placeholder: 'Enter City / Town' }),
									_react2.default.createElement('span', { className: 'req_err', id: 'req_city_err' }),
									_react2.default.createElement('input', { type: 'text', ref: 'req_doorno', id: 'req_doorno', value: this.state.req_doorno, onChange: this.req_doornoChange, placeholder: 'Door No / Landmark' }),
									_react2.default.createElement('span', { className: 'req_err', id: 'req_doorno_err' }),
									_react2.default.createElement('input', { type: 'text', maxLength: 6, ref: 'req_pincode', id: 'req_pincode', value: this.state.req_pincode, onChange: this.req_pincodeChange, placeholder: 'Pincode' }),
									_react2.default.createElement('span', { className: 'req_err', id: 'req_pincode_err' }),
									_react2.default.createElement(
										'div',
										{ className: 'req_footer' },
										_react2.default.createElement(
											'a',
											{ onClick: this.close },
											'CANCEL'
										),
										_react2.default.createElement(
											'button',
											{ type: 'submit' },
											'SEND'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal,
							{ className: 'web_reqbestprice', show: this.state.req_confirm_modal, onHide: this.close },
							_react2.default.createElement(
								_reactBootstrap.Modal.Body,
								null,
								this.state.req_confirm_message,
								_react2.default.createElement(
									'a',
									{ onClick: this.close, className: 'req_conf_ok_btn' },
									'OK'
								)
							)
						),
						_react2.default.createElement(_WebFooter2.default, null)
					) : _react2.default.createElement(
						'div',
						{ className: 'loading_sym', style: { width: 100 + '%', textAlign: 'center', marginTop: 20 + '%' } },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/ajax-loader1.gif', alt: 'Loading Deals', role: 'presentation' }),
						' '
					)
				);
			}
		}]);
	
		return Web_Seed_Details;
	}(_react.Component);
	
	var SDetails = exports.SDetails = function (_Component2) {
		_inherits(SDetails, _Component2);
	
		function SDetails() {
			_classCallCheck(this, SDetails);
	
			var _this5 = _possibleConstructorReturn(this, (SDetails.__proto__ || Object.getPrototypeOf(SDetails)).call(this));
	
			_this5.state = {
				open: false,
				seedid: localStorage.getItem('seed_id'),
				shareUrl: ''
			};
			_this5.ShareFunc = _this5.ShareFunc.bind(_this5);
			return _this5;
		}
	
		_createClass(SDetails, [{
			key: 'ShareFunc',
			value: function ShareFunc(evnt) {
				var _this6 = this;
	
				var data1 = { from: 'desktop_web', type: 0, did: evnt };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'createTinyurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							msg: data.msg,
							shareUrl: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {}
				});
				this.setState({
					open: !this.state.open
				});
				setTimeout(function () {
					_this6.setState({ open: false });
				}, 5000);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				var mydetails = this.props.data;
				var shareUrl = this.state.shareUrl;
				var title = "Hey! Click here " + mydetails.deals_data.sname + " deal from AquaDeals. Click to view the deal";
				var description = shareUrl;
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'h4',
						null,
						mydetails.deals_data.oname
					),
					_react2.default.createElement(
						'h5',
						null,
						mydetails.deals_data.sname
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ className: 'share_list', onClick: function onClick() {
								_this7.ShareFunc(_this7.state.seedid);
							} },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/share.png', alt: 'share' })
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_reactBootstrap.Panel,
							{ collapsible: true, expanded: this.state.open },
							_react2.default.createElement(
								FacebookShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
								_react2.default.createElement(FacebookIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								TwitterShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
								_react2.default.createElement(TwitterIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								GooglePlusShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
								_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
							)
						)
					)
				);
			}
		}]);
	
		return SDetails;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			leads: state.posts.leads,
			formdata: state.auth.formdata,
			formdata_log: state.auth.formdata_log
		};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Web_Seed_Details);

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _reactInfiniteScrollComponent = __webpack_require__(57);
	
	var _reactInfiniteScrollComponent2 = _interopRequireDefault(_reactInfiniteScrollComponent);
	
	var _Sead_deal_list = __webpack_require__(481);
	
	var _Sead_deal_list2 = _interopRequireDefault(_Sead_deal_list);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Button} from 'react-bootstrap';
	
	
	// Path : /web/seed/:Name/:Dtype
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	
	var Web_SeedsList = function (_Component) {
	  _inherits(Web_SeedsList, _Component);
	
	  function Web_SeedsList() {
	    _classCallCheck(this, Web_SeedsList);
	
	    var _this = _possibleConstructorReturn(this, (Web_SeedsList.__proto__ || Object.getPrototypeOf(Web_SeedsList)).call(this));
	
	    _this.state = {
	      seedsList: [],
	      bread: '',
	      web_title: '',
	      web_desc: '',
	      selected: '',
	      loading: false,
	      loadmore_status: 0,
	      next_page: 0,
	      seo_desc: 'Browse best deals from various Hatcheries located in nearest Coasts.',
	      deal_categories_list: [],
	      cat_vannamei: '',
	      cat_tiger: '',
	      loading_gif: false,
	      h1_desc: '',
	      nodata_status: false,
	
	      cats: [],
	      sortlist: [],
	      sortid: '',
	      speciesid: '',
	      total_deals: ''
	    };
	    _this.getDeals = _this.getDeals.bind(_this);
	    _this.loadMoreDeals = _this.loadMoreDeals.bind(_this);
	    localStorage.setItem('h_type', '1');
	    _this.getDeviceId = _this.getDeviceId.bind(_this);
	    _this.getCategories = _this.getCategories.bind(_this);
	    _this.refresh = _this.refresh.bind(_this);
	    _this.fetchData = _this.fetchData.bind(_this);
	
	    _this.getSeedFilter = _this.getSeedFilter.bind(_this);
	    _this.getSelectedItem = _this.getSelectedItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(Web_SeedsList, [{
	    key: 'getCategories',
	    value: function getCategories() {
	
	      var data1 = { from: 'desktop_web' };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'Getcategories',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            deal_categories_list: data.deal_categories,
	            cat_vannamei: data.deal_categories[0]['categories'][0]['title'],
	
	            cats: data.deal_categories
	          });
	
	          if (data.deal_categories[0]['categories'].length >= 2) {
	            this.setState({
	              cat_tiger: data.deal_categories[0]['categories'][1]['title']
	            });
	          } else {
	            this.setState({
	              cat_tiger: ''
	            });
	          }
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'getSeedFilter',
	    value: function getSeedFilter() {
	      var data1 = { from: 'desktop_web' };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        url: baseUrl + 'seedFilters',
	        method: 'POST',
	        dataType: 'JSON',
	        data: { req: data2 },
	        success: function (data) {
	          if (data) {
	            this.setState({
	              sortlist: data.sort
	            });
	          }
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'getSelectedItem',
	    value: function getSelectedItem(event) {
	      // var value = event.target.value;
	      var index = event.target.selectedIndex;
	      var optionElement = event.target.childNodes[index];
	      var id = optionElement.getAttribute('id');
	      this.setState({ sortid: id });
	
	      var data1 = { from: 'desktop_web', sort: id, species: this.props.params.Dtype };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        url: baseUrl + 'getdeals',
	        method: 'POST',
	        dataType: 'JSON',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            loading: true,
	            seedsList: data.data,
	            offer: data
	          });
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'getDeviceId',
	    value: function getDeviceId() {
	      if (localStorage.user_id) {
	        var user_id = localStorage.user_id;
	      } else {
	        user_id = 0;
	      }
	      var data1 = { from: 'desktop_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getDeviceId',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function success(data) {},
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'getDeals',
	    value: function getDeals(type, name) {
	      this.setState({
	        loading_gif: true
	      });
	      localStorage.setItem('w_r_seed_deals', '/web/seed/' + name + "/" + type);
	      (0, _jquery2.default)(window).scrollTop(0);
	      if (this.state.sortid) {
	        var sortid = this.state.sortid;
	      } else {
	        sortid = 0;
	      }
	
	      var data1 = { from: 'desktop_web', species: type, sort: sortid };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getdeals',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            seedsList: data.data,
	            offer: data,
	            loading: true,
	            web_title: data.title,
	            web_desc: data.desc,
	            loadmore_status: data.load_more,
	            next_page: data.next_page,
	            seo_title: data.title + ' Aqua seed deals from Hatcheries',
	            seo_desc: 'Browse quality ' + data.title + ' Aquaculture seed deals from CAA approved Hatcheries, shop online and avail free shipment.',
	            loading_gif: false,
	            total_deals: data.total_records
	          });
	          if (data.data.length <= 0) {
	            this.setState({
	              nodata_status: true
	            });
	            window.location.href = "/web/home";
	          } else {
	            this.setState({
	              nodata_status: false
	            });
	          }
	          this.setState({
	            h1_desc: 'Shop ' + data.title + ' Aqua seed deals from Hatcheries'
	          });
	          // document.title =this.state.web_title +  " - Deals | AquaDeals ";
	          document.title = this.state.seo_title;
	          document.getElementsByTagName("META")[2].content = this.state.seo_desc;
	          if (data.status === 'error' && data.message === 'Token mismatch') {
	            this.props.tokenCheck();
	          }
	        }.bind(this),
	        error: function error(err) {
	          // console.log("Error"+err);
	          this.setState({
	            loading_gif: false
	          });
	        }
	      });
	    }
	  }, {
	    key: 'fetchData',
	    value: function fetchData() {
	      this.setState({
	        loading_gif: true
	      });
	      // this.props.params.Dtype,this.state.next_page,this.state.load_more_status
	      var species = this.props.params.Dtype ? this.props.params.Dtype : '';
	      var page = this.state.next_page;
	
	      if (this.state.loadmore_status === 1) {
	        var data1 = { from: 'desktop_web', species: species, page: page };
	        var data2 = JSON.stringify(data1);
	        _jquery2.default.ajax({
	          method: 'POST',
	          url: baseUrl + 'getdeals',
	          dataType: 'json',
	          data: { req: data2 },
	          success: function (data) {
	            this.setState({
	              loading: true,
	              offer: data,
	              web_title: data.title,
	              web_desc: data.desc,
	              bread: data.title,
	              selected: data.title,
	              loadmore_status: data.load_more,
	              next_page: data.next_page,
	              loading_gif: false,
	
	              total_deals: data.total_records
	            });
	            this.setState({
	              seedsList: this.state.seedsList.concat(data.data)
	            });
	            if (data.status === 'error' && data.message === 'Token mismatch') {
	              this.props.tokenCheck();
	            }
	          }.bind(this),
	          error: function error(err) {
	            this.setState({
	              loading_gif: false
	            });
	            // console.log(err);
	          }
	        });
	      } else {
	        this.setState({
	          loading_gif: false
	        });
	      }
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      console.log("");
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      localStorage.removeItem('w_r_s_dt');
	      localStorage.removeItem('w_r_e_coupon_dt');
	      localStorage.removeItem('w_r_e_s_dt');
	      localStorage.removeItem('web_mycart');
	      localStorage.removeItem('w_r_enq_seller_page');
	      localStorage.removeItem('w_r_p_dt');
	      localStorage.removeItem('w_r_e_p_dt');
	      localStorage.removeItem('web_ofr_page');
	      localStorage.removeItem('profile');
	      localStorage.removeItem('myaquacash');
	      localStorage.removeItem('web_share_earn');
	      localStorage.removeItem('checkout');
	      localStorage.removeItem('order_details');
	      localStorage.removeItem('myorders');
	      localStorage.removeItem('w_r_p_deals');
	
	      localStorage.removeItem('nauplii');
	      localStorage.removeItem('subdeals');
	      localStorage.removeItem('shipping');
	      localStorage.removeItem('notifications');
	      localStorage.removeItem('web_quickcart');
	      localStorage.removeItem('view_rating');
	      localStorage.removeItem('w_modal_seed');
	
	      localStorage.removeItem('w_r_e_p_dt');
	      localStorage.removeItem('w_modal_details');
	      localStorage.removeItem('offers');
	      localStorage.removeItem('give_rating');
	      localStorage.removeItem('pprice');
	      localStorage.removeItem('sprice');
	      localStorage.removeItem('seed_id');
	      localStorage.removeItem('h_type');
	      localStorage.removeItem('web_pro_ofr_dtls');
	      localStorage.removeItem('web_wishlist');
	      localStorage.removeItem('web_brand_details');
	
	      localStorage.removeItem('m_r_s_dt');
	      localStorage.removeItem('m_r_e_coupon_dt');
	      localStorage.removeItem('m_r_e_s_dt');
	      localStorage.removeItem('mob_mycart');
	      localStorage.removeItem('m_r_enq_seller_page');
	      localStorage.removeItem('m_r_p_dt');
	      localStorage.removeItem('m_r_e_p_dt');
	      localStorage.removeItem('ofr_page');
	      localStorage.removeItem('pro_ofr_dtls');
	
	      localStorage.removeItem('share_earn');
	      localStorage.removeItem('my_orders');
	      localStorage.removeItem('m_r_p_deals');
	      localStorage.removeItem('mob_quickcart');
	      localStorage.removeItem('partner_deals');
	      if (this.props.params.Name && this.props.params.Dtype && screen.width <= 800) {
	        window.location.href = "/seed/" + this.props.params.Name + "/" + this.props.params.Dtype;
	      } else if (!this.props.params.Name && !this.props.params.Dtype && screen.width <= 800) {
	        window.location.href = "/seed";
	      }
	
	      if (!localStorage.token && !localStorage.user_id && !this.props.params.Name && !this.props.params.Dtype) {
	        localStorage.setItem('seed', '/web/seed');
	        localStorage.removeItem('w_r_seed_deals');
	      } else if (!localStorage.token && !localStorage.user_id && this.props.params.Name && this.props.params.Dtype) {
	        localStorage.setItem('w_r_seed_deals', '/web/seed/' + this.props.params.Name + "/" + this.props.params.Dtype);
	        localStorage.removeItem('seed');
	      }
	
	      this.getCategories();
	      this.getDeviceId();
	      // localStorage.setItem('w_r_seed_deals','/web/seed/'+this.props.params.Name+"/"+this.props.params.Dtype);
	      localStorage.removeItem('w_modal_seed');
	      localStorage.removeItem('sprice');
	      localStorage.removeItem('pprice');
	      localStorage.removeItem('w_r_s_dt');
	      localStorage.removeItem('w_r_p_dt');
	      localStorage.removeItem('m_r_s_dt');
	      localStorage.removeItem('m_r_p_dt');
	      localStorage.removeItem('w_r_e_p_dt');
	      localStorage.removeItem('w_r_e_s_dt');
	      localStorage.removeItem('w_r_p_deals');
	
	      (0, _jquery2.default)(window).scrollTop(0);
	      localStorage.setItem('h_type', '1');
	      var data1 = '';
	      if (this.props.params.Name && this.props.params.Dtype) {
	
	        data1 = { from: 'desktop_web', species: this.props.params.Dtype };
	      } else {
	        data1 = { from: 'desktop_web' };
	      }
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getdeals',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            loading: true,
	            seedsList: data.data,
	            offer: data,
	            web_title: data.title,
	            web_desc: data.desc,
	            bread: data.title,
	            selected: data.title,
	            loadmore_status: data.load_more,
	            next_page: data.next_page,
	            seo_title: "Vannamei,Tiger seed deals from Hatcheries",
	            seo_desc: 'Browse quality Vannamei,Tiger seed deals from CAA approved Hatcheries, shop online and avail free shipment.',
	
	            total_deals: data.total_records
	          });
	          if (data.data.length <= 0) {
	            this.setState({
	              nodata_status: true
	            });
	            window.location.href = "/web/home";
	          } else {
	            this.setState({
	              nodata_status: false
	            });
	          }
	          if (!this.props.params.Name && !this.props.params.Dtype) {
	            this.setState({
	              h1_desc: 'Shop Vannamei,Tiger seed deals from Hatcheries'
	            });
	            document.title = this.state.seo_title;
	            document.getElementsByTagName("META")[2].content = this.state.seo_desc;
	          } else {
	            this.setState({
	              h1_desc: 'Shop ' + data.title + ' Aqua seed deals from Hatcheries'
	            });
	            document.title = data.title + " Aqua Seed deals from Hatcheries";
	            document.getElementsByTagName("META")[2].content = 'Browse quality ' + data.title + ' seed deals from CAA approved Hatcheries, shop online and avail free shipment.';
	          }
	          if (data.status === 'error' && data.message === 'Token mismatch') {
	            this.props.tokenCheck();
	          }
	        }.bind(this),
	        error: function error(err) {}
	      });
	      this.getSeedFilter();
	    }
	  }, {
	    key: 'loadMoreDeals',
	    value: function loadMoreDeals(species, page, loadmore) {
	      this.setState({
	        loading_gif: true
	      });
	      var data1 = { from: 'desktop_web', species: species, page: page };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getdeals',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            loading: true,
	            offer: data,
	            web_title: data.title,
	            web_desc: data.desc,
	            bread: data.title,
	            selected: data.title,
	            loadmore_status: data.load_more,
	            next_page: data.next_page,
	            loading_gif: false,
	
	            total_deals: data.total_records
	          });
	          this.setState({
	            seedsList: this.state.seedsList.concat(data.data)
	          });
	          if (data.status === 'error' && data.message === 'Token mismatch') {
	            this.props.tokenCheck();
	          }
	        }.bind(this),
	        error: function error(err) {
	          // console.log(err);
	        }
	      });
	    }
	  }, {
	    key: 'setFilter',
	    value: function setFilter(filter, id) {
	      this.setState({ selected: filter, speciesid: id });
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive(value) {
	      return 'li ' + (value === this.state.selected ? 'active' : '');
	    }
	
	    /******** *********/
	    /******** ********/
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var cate = this.state.cats.map(function (data, index) {
	        if (data.id === '1') {
	          return data.categories.map(function (data1, index) {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	              'li',
	              { key: index, className: this.isActive(data1.title), onClick: this.setFilter.bind(this, data1.title, data1.id) },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/web/' + data1.url_dtype_name + '/' + data1.url_name + '/' + data1.id, onClick: function onClick() {
	                    _this2.setState({ selected: data1.title });_this2.getDeals(data1.id, data1.title);
	                  } },
	                data1.title ? data1.title : ''
	              )
	            );
	          }.bind(this));
	        }
	      }.bind(this));
	
	      var seedFilters = this.state.sortlist.map(function (item, index) {
	        return _react2.default.createElement(
	          'option',
	          { key: item.id, value: item.type, id: item.id },
	          item.type
	        );
	      });
	
	      var deals = this.state.seedsList.map(function (deal, index) {
	        return _react2.default.createElement(_Sead_deal_list2.default, { key: deal.deals_data.id, data: deal });
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'web_deals web_seedslist_page' },
	        this.state.loading ? _react2.default.createElement(
	          'div',
	          { className: 'lgt_gry' },
	          _react2.default.createElement(_WebHeaderInner2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: 'container pro_lst_cntnt' },
	            _react2.default.createElement(
	              'div',
	              { className: 'clr' },
	              '\xA0'
	            ),
	            _react2.default.createElement(
	              'h1',
	              { className: 'page_title' },
	              this.state.h1_desc
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'container' },
	              _react2.default.createElement(
	                _reactBootstrap.Breadcrumb,
	                { className: 'webpdeals_breadcrmb' },
	                _react2.default.createElement(
	                  _reactBootstrap.Breadcrumb.Item,
	                  { href: '/web/home' },
	                  'Home'
	                ),
	                _react2.default.createElement(
	                  _reactBootstrap.Breadcrumb.Item,
	                  { active: true },
	                  this.state.web_title
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'tot_pro' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row', style: { marginRight: '0 !important' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-3 col-sm-3' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'filtrs_blk' },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      'Categories'
	                    ),
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      cate
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'pro_sec col-md-9 col-sm-9' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'pro_sec_hdr' },
	                    _react2.default.createElement(
	                      'h3',
	                      null,
	                      this.state.web_title,
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        '\xA0(',
	                        this.state.total_deals,
	                        ' Items)'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'pro_slt_fltr' },
	                      _react2.default.createElement(
	                        'select',
	                        { onChange: this.getSelectedItem },
	                        _react2.default.createElement(
	                          'option',
	                          null,
	                          'Select'
	                        ),
	                        seedFilters
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row itm_lst' },
	                    this.state.loading_gif ? _react2.default.createElement(
	                      'i',
	                      { className: 'web_loading_gif' },
	                      _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/loading_more.gif', alt: 'Loading' })
	                    ) : '',
	                    _react2.default.createElement(
	                      _reactInfiniteScrollComponent2.default,
	                      {
	                        pullDownToRefresh: true,
	                        pullDownToRefreshContent: _react2.default.createElement(
	                          'h3',
	                          { style: { textAlign: 'center' } },
	                          '\u2193'
	                        ),
	                        releaseToRefreshContent: _react2.default.createElement(
	                          'h3',
	                          { style: { textAlign: 'center' } },
	                          '\u2191'
	                        ),
	                        refreshFunction: this.refresh,
	                        next: this.fetchData,
	                        hasMore: true,
	                        scrollThreshold: 0.3,
	                        loader: _react2.default.createElement('h4', null),
	                        endMessage: _react2.default.createElement(
	                          'p',
	                          { style: { textAlign: 'center' } },
	                          _react2.default.createElement('b', null)
	                        ) },
	                      deals
	                    ),
	                    this.state.nodata_status ? _react2.default.createElement(
	                      'div',
	                      { className: 'seed_no_data' },
	                      'No Deals Available'
	                    ) : ''
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { classNames: 'clr' },
	            '\xA0'
	          ),
	          _react2.default.createElement(_WebFooter2.default, null)
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'loading_sym', style: { width: 100 + '%', textAlign: 'center', marginTop: 20 + '%' } },
	          _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/ajax-loader1.gif', alt: 'Loading Deals', role: 'presentation' }),
	          ' '
	        )
	      );
	    }
	  }]);
	
	  return Web_SeedsList;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    errorMessage: state.auth.error,
	    authenticated: state.auth.authenticated,
	    formdata: state.auth.formdata,
	    formdata_log: state.auth.formdata_log
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Web_SeedsList);

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(15);
	
	var _reactStars = __webpack_require__(33);
	
	var _reactStars2 = _interopRequireDefault(_reactStars);
	
	var _actions = __webpack_require__(21);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactShare = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var Deal = function (_Component) {
	  _inherits(Deal, _Component);
	
	  function Deal() {
	    _classCallCheck(this, Deal);
	
	    var _this = _possibleConstructorReturn(this, (Deal.__proto__ || Object.getPrototypeOf(Deal)).call(this));
	
	    _this.state = {
	      open: false,
	      shareUrl: '',
	      msg: '',
	      regModalStatus: false,
	      err_reg: '',
	      reg_err_status: false,
	      loginModalStatus: false,
	      signupModalStatus: false
	    };
	    _this.ShareFunc = _this.ShareFunc.bind(_this);
	    // this.regRedirect=this.regRedirect.bind(this);
	    _this.onMobileChange = _this.onMobileChange.bind(_this);
	    _this.getDeviceId = _this.getDeviceId.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(Deal, [{
	    key: 'getDeviceId',
	    value: function getDeviceId() {
	      if (localStorage.user_id) {
	        var user_id = localStorage.user_id;
	      } else {
	        user_id = 0;
	      }
	      var data1 = { from: 'desktop_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
	      var data2 = JSON.stringify(data1);
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getDeviceId',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function success(data) {},
	        error: function error(err) {}
	      });
	    }
	    // componentWillReceiveProps(newProps)
	    // {
	    //    if(newProps.formdata.status === 'success')
	    //    {
	    //         this.setState({showAddModal_Login: false})
	    //         this.setState({showAddModal_signup: false})
	    //         this.setState({showAddModal_otp_signup: false})
	    //    }
	    // }          
	
	  }, {
	    key: 'ShareFunc',
	    value: function ShareFunc(evnt) {
	      var _this2 = this;
	
	      var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	      var data1 = { from: 'desktop_web', type: 0, did: evnt };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'createTinyurl',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            msg: data.msg,
	            shareUrl: data.tinyurl
	          });
	        }.bind(this),
	        error: function error(err) {
	          // console.log("Error"+err);
	        }
	      });
	      this.setState({
	        open: !this.state.open
	      });
	      setTimeout(function () {
	        _this2.setState({ open: false });
	      }, 5000);
	    }
	    // regRedirect(sdetails,name,id)
	    // {
	    //     localStorage.removeItem('w_r_seed_deals');
	    //     localStorage.setItem('w_modal_seed','/web/sdetails/'+name+"/"+id);
	    //     if(localStorage.token && localStorage.user_id)
	    //     {
	    //         browserHistory.push(localStorage.w_modal_seed);
	    //         window.location.reload();
	    //     }
	    //     else
	    //     {
	    //         // this.setState({ showAddModal_Login: true})
	    //         browserHistory.push('/web/login');
	    //     }
	    // }
	
	
	  }, {
	    key: 'onMobileChange',
	    value: function onMobileChange(event) {
	      var invalidChars = /[^0-9]/gi;
	      if (invalidChars.test(event.target.value)) {
	        event.target.value = event.target.value.replace(invalidChars, "");
	      } else {
	        this.setState({
	          reg_err_status: true
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var myDeals = this.props.data;
	      var shareUrl = this.state.shareUrl;
	      var title = "Hey! Click here " + shareUrl + " to check " + myDeals.deals_data.sname + " from AquaDeals.";
	      var description = shareUrl;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-3 col-sm-6' },
	          _react2.default.createElement(
	            'div',
	            { className: '' },
	            myDeals.promo_ribbion ? _react2.default.createElement(
	              'i',
	              { className: 'webribbon_img' },
	              _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/' + myDeals.promo_ribbion, alt: 'ribbon' })
	            ) : ''
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'prdt_blk' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { className: 'lst_share_btn', onClick: function onClick() {
	                  _this3.ShareFunc(myDeals.deals_data.id);
	                } },
	              _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/share-icon.png', alt: 'Share' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Panel,
	              { className: 'share_panel', collapsible: true, expanded: this.state.open },
	              _react2.default.createElement(
	                FacebookShareButton,
	                { url: shareUrl, quote: title, description: description, className: 'test_share' },
	                _react2.default.createElement(FacebookIcon, { size: 32, round: true })
	              ),
	              _react2.default.createElement(
	                TwitterShareButton,
	                { url: shareUrl, quote: title, description: description, className: 'test_share' },
	                _react2.default.createElement(TwitterIcon, { size: 32, round: true })
	              ),
	              _react2.default.createElement(
	                GooglePlusShareButton,
	                { url: shareUrl, quote: title, descirption: description, className: 'test_share' },
	                _react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: "/web/sdetails/" + myDeals.deals_data.sname + "/" + myDeals.deals_data.id },
	              _react2.default.createElement(
	                'div',
	                { className: 'seed_image' },
	                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/seller_imgs/thumbnails/' + myDeals.deals_data.image, alt: 'Seed' })
	              ),
	              myDeals.deals_data.sname ? _react2.default.createElement(
	                'h3',
	                null,
	                myDeals.deals_data.sname
	              ) : _react2.default.createElement(
	                'h3',
	                null,
	                '\xA0'
	              ),
	              myDeals.deals_data.oname ? _react2.default.createElement(
	                'h4',
	                null,
	                myDeals.deals_data.oname
	              ) : _react2.default.createElement(
	                'h4',
	                null,
	                '\xA0'
	              ),
	              myDeals.offer > 0 ? _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement('span', null),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  '\u20B9 ',
	                  myDeals.offer
	                ),
	                ' off on 1M'
	              ) : '',
	              myDeals.deals_data.price ? _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement('span', null),
	                _react2.default.createElement(
	                  'span',
	                  { style: { color: '#333' } },
	                  '\u20B9'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { style: { color: '#333' } },
	                  ' ',
	                  myDeals.deals_data.price
	                )
	              ) : ''
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row stars_view_blk' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-7 col-xs-7', style: { paddingRight: '0' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'prdt_str_rt' },
	                  _react2.default.createElement(_reactStars2.default, {
	                    count: 5,
	                    className: 'webRate_blk_item',
	                    size: 17,
	                    value: myDeals.deals_data.rate >= 1 ? myDeals.deals_data.rate : 0,
	                    edit: false,
	                    color1: '#ccc',
	                    color2: '#ffc50a'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-5 col-xs-5', style: { paddingLeft: 0 } },
	                myDeals.view_status > 0 ? _react2.default.createElement(
	                  'span',
	                  { className: 'prdt_views' },
	                  _react2.default.createElement(
	                    'i',
	                    null,
	                    _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/eye.png', width: '16px', role: 'presentation' })
	                  ),
	                  '\xA0',
	                  myDeals.view_status
	                ) : _react2.default.createElement(
	                  'span',
	                  null,
	                  '\xA0'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Deal;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    errorMessage: state.auth.error,
	    authenticated: state.auth.authenticated,
	    formdata: state.auth.formdata,
	    formdata_log: state.auth.formdata_log
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Deal);

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var WebSmartCart = function (_Component) {
		_inherits(WebSmartCart, _Component);
	
		function WebSmartCart(props) {
			_classCallCheck(this, WebSmartCart);
	
			var _this = _possibleConstructorReturn(this, (WebSmartCart.__proto__ || Object.getPrototypeOf(WebSmartCart)).call(this, props));
	
			_this.state = {
				cart_count: '',
				page_loading: false,
				smart_filters: [],
				smart_deals: [],
				active_filter: 0,
				//  add to cart values
				replace_did: '',
				replace_deal_type: '',
				replace_qty: '',
				replace_pl_size: '',
				replace_salinity: '',
				replace_pickup_date: '',
				replace_id: '',
				replace_product_name: '',
	
				cart_status: false,
				cart_status_msg: '',
				clearcart_status: false,
				cart_added_status: false
				// cart values ends here
			};
			_this.getSmartFilters = _this.getSmartFilters.bind(_this);
			_this.getSmartDeals = _this.getSmartDeals.bind(_this);
			_this.getSmartDealsByType = _this.getSmartDealsByType.bind(_this);
			_this.addToCart = _this.addToCart.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.replaceCartItems = _this.replaceCartItems.bind(_this);
			_this.getCartCount = _this.getCartCount.bind(_this);
			_this.tokenCheck = _this.tokenCheck.bind(_this);
			return _this;
		}
	
		_createClass(WebSmartCart, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
				localStorage.removeItem('checkout');
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
				localStorage.removeItem('web_quickcart');
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
				localStorage.removeItem('web_brand_details');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
				if (!localStorage.token && !localStorage.user_id) {
					localStorage.setItem('web_smartcart', '/web/smartcart');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					this.getCartCount();
					this.getSmartFilters();
					this.getSmartDeals();
				}
			}
		}, {
			key: 'tokenCheck',
			value: function tokenCheck() {
				localStorage.removeItem('user_id');
				localStorage.removeItem('token');
				window.location.reload();
			}
		}, {
			key: 'getSmartFilters',
			value: function getSmartFilters() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.token };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'smart_list_filters',
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								smart_filters: data.filters
							});
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSmartDeals',
			value: function getSmartDeals() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, dtype: 0 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'smart_list',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								smart_deals: data.data
							});
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSmartDealsByType',
			value: function getSmartDealsByType(dtype) {
				this.setState({
					active_filter: dtype
				});
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, dtype: dtype };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'smart_list',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								smart_deals: data.data
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'addToCart',
			value: function addToCart(did, deal_type, qty, pl, salinity, pickup_date, id, product_name) {
				this.setState({
					replace_did: did,
					replace_deal_type: deal_type,
					replace_qty: qty,
					replace_pl_size: pl,
					replace_salinity: salinity,
					replace_pickup_date: pickup_date,
					replace_id: id,
					replace_product_name: product_name
				});
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, deal_id: did, deal_type: deal_type, quantity: qty, pl_size: pl, salinity: salinity, pickup_date: pickup_date };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'addToCart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success" && data.message === "Added to cart") {
							// this.setState({
							// 	cart_status:true,
							// 	cart_status_msg:data.message,
							// });
							_reactRouter.browserHistory.push('/web/mycart');
						}
						if (data.status === "success" && data.message === "Cart Updated") {
							this.setState({
								cart_status: true,
								cart_status_msg: data.message
							});
						}
						if (data.status === "error" && data.cart_flag === 0) {
							this.setState({
								clearcart_status: true
							});
						}
						if (data.status === "error" && data.message === "Product already added to the cart" && data.cart_flag === 1) {
							this.setState({
								cart_added_status: true
							});
						}
						this.getCartCount();
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'replaceCartItems',
			value: function replaceCartItems() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token'), deal_id: this.state.replace_did, deal_type: this.state.replace_deal_type, quantity: this.state.replace_qty, pl_size: this.state.replace_pl, salinity: this.state.replace_salinity, pickup_date: this.state.replace_pickup_date };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'replaceCart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success" && data.cart_flag === 1) {
							// this.setState({
							// 	clearcart_status:false,
							// 	cart_status:true,
							// 	cart_status_msg:data.message,
							// });
							_reactRouter.browserHistory.push('/web/mycart');
						} else {
							this.getCartCount();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					cart_status: false,
					clearcart_status: false,
					cart_added_status: false
				});
			}
		}, {
			key: 'getCartCount',
			value: function getCartCount() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								cart_count: data.cart_count
							});
						} else if (data.status === 'error' && data.message === 'Token mismatch') {
							localStorage.clear();
							window.location.reload();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				document.title = "Smart Cart | AquaDeals";
				var smart_deals = this.state.smart_deals.map(function (data, index) {
					var _this2 = this;
	
					console.log(data.cart_flag);
					return _react2.default.createElement(
						'div',
						{ className: 'smartcartitems' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-6 col-md-6 col-sm-6' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ key: index, to: data.type === 0 ? "/web/sdetails/" + data.sname + "/" + data.did : "/web/pdetails/" + data.url_dtype_name + "/" + data.url_cat_name + "/" + data.url_brand_name + "/" + data.url_product_name + "/" + data.pid + "/" + data.id },
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-4 col-md-4 col-sm-4' },
											_react2.default.createElement(
												'div',
												{ className: 'item_img' },
												data.type === 0 ? _react2.default.createElement('img', { className: 'item_img', src: data.img !== null && data.img !== '' ? data.img : baseAssets + 'icons/web_icons/noImage.png', alt: '' }) : _react2.default.createElement('img', { className: 'item_img', src: data.img !== null && data.img !== '' ? data.img : baseAssets + 'icons/web_icons/noImage.png', alt: '' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-6 col-md-6 col-sm-6' },
											data.product_name ? _react2.default.createElement(
												'h2',
												{ className: 'websmt_cartTitle' },
												data.product_name
											) : _react2.default.createElement(
												'h2',
												null,
												'\xA0'
											),
											data.brand_name !== null && data.brand_name !== "" ? _react2.default.createElement(
												'h5',
												{ className: 'websmt_cartBrand' },
												data.brand_name
											) : _react2.default.createElement(
												'h5',
												null,
												'\xA0'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-2 col-md-2 col-sm-2' },
											'\xA0'
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-6 col-md-6 col-sm-6' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ key: index, to: data.type === 0 ? "/web/sdetails/" + data.sname + "/" + data.did : "/web/pdetails/" + data.url_dtype_name + "/" + data.url_cat_name + "/" + data.url_brand_name + "/" + data.url_product_name + "/" + data.pid + "/" + data.id },
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-4 col-md-4 col-sm-4' },
											data.mrp ? _react2.default.createElement(
												'h3',
												{ className: 'Websmt_cartMrp' },
												'\u20B9 ',
												data.mrp,
												' '
											) : _react2.default.createElement(
												'h3',
												null,
												'\xA0'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-4 col-md-4 col-sm-4' },
										data.cart_flag === 1 ? _react2.default.createElement(
											'div',
											{ className: 'websmt_cartblk' },
											_react2.default.createElement(
												'a',
												{ className: 'websmt_cartbtn', href: '/web/mycart' },
												'GO TO CART'
											)
										) : _react2.default.createElement(
											'div',
											{ className: 'websmt_cartblk' },
											_react2.default.createElement(
												'a',
												{ className: 'websmt_cartbtn', onClick: function onClick() {
														_this2.addToCart(data.deal_id, data.type, data.qty, data.pl_size, data.salinity, data.pickup_date, data.id, data.pro_name);
													} },
												'ADD TO CART'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-4 col-md-4 col-sm-4' },
										_react2.default.createElement(
											'button',
											{ onClick: function onClick() {
													_this2.deleteSingleItem(data.id);
												}, ariaLabel: 'Close', className: 'close websmtcart_close outline', type: 'button' },
											_react2.default.createElement(
												'span',
												{ ariaHidden: 'true' },
												'\xD7'
											)
										)
									)
								)
							),
							_react2.default.createElement('hr', null)
						)
					);
				}.bind(this));
				return _react2.default.createElement(
					'div',
					{ className: 'web_Deals web_smartcart' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'container', style: { marginTop: '10%' } },
						_react2.default.createElement(
							_reactBootstrap.Breadcrumb,
							{ className: 'smtcrt_breadcrmb' },
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb.Item,
								{ href: '/web/home' },
								'Home'
							),
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb.Item,
								{ active: true },
								'Smart Cart'
							)
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'container Dels_cntnt' },
						_react2.default.createElement(
							'div',
							{ className: 'row smartcart_block' },
							smart_deals.length > 0 ? _react2.default.createElement(
								'div',
								{ className: 'row', style: { marginBottom: '30px' } },
								_react2.default.createElement(
									'div',
									{ className: 'container' },
									_react2.default.createElement(
										'h2',
										{ className: 'col-lg-6 col-md-6 col-sm-6', style: { paddingLeft: '66px' } },
										'Add Item'
									),
									_react2.default.createElement(
										'h2',
										{ className: 'col-lg-6 col-md-6 col-sm-6', style: { paddingLeft: '30px' } },
										'Price'
									)
								)
							) : '',
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12 del_Rgt' },
								_react2.default.createElement(
									'div',
									{ className: 'del_Rgt_Blk' },
									_react2.default.createElement('div', { className: 'col-md-12' }),
									_react2.default.createElement('div', { className: 'clr' }),
									_react2.default.createElement(
										'div',
										{ className: 'row itm_lst' },
										smart_deals.length > 0 ? smart_deals : _react2.default.createElement(
											'div',
											{ className: 'web_Nodata' },
											'No Previous Orders Found'
										)
									)
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal,
								{ className: 'M_pro_full_dtls_modal', show: this.state.cart_status, onHide: this.close },
								_react2.default.createElement(
									_reactBootstrap.Modal.Header,
									{ closeButton: true },
									_react2.default.createElement(
										_reactBootstrap.Modal.Title,
										{ style: { fontSize: '16px', color: '#333' } },
										'Alert'
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal.Body,
									null,
									_react2.default.createElement(
										'h4',
										{ style: { fontSize: '14px', color: '#666' } },
										this.state.cart_status_msg
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal.Footer,
									{ className: 'modal_footer' },
									_react2.default.createElement(
										_reactBootstrap.Button,
										{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
										'Close'
									)
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal,
								{ className: 'M_pro_full_dtls_modal', show: this.state.clearcart_status, onHide: this.close },
								_react2.default.createElement(
									_reactBootstrap.Modal.Header,
									{ closeButton: true },
									_react2.default.createElement(
										_reactBootstrap.Modal.Title,
										{ style: { fontSize: '16px', color: '#333' } },
										'Alert'
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal.Body,
									null,
									_react2.default.createElement(
										'h4',
										{ style: { fontSize: '14px', color: '#333' } },
										'You can\'t have multiple seller items in the cart. Empty existing cart & add this item ',
										this.state.replace_pro_title,
										'?'
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal.Footer,
									{ className: 'modal_footer' },
									_react2.default.createElement(
										_reactBootstrap.Button,
										{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
										'NO'
									),
									_react2.default.createElement(
										'a',
										null,
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: function onClick() {
													_this3.replaceCartItems();
												} },
											'YES'
										)
									)
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal,
								{ className: 'M_pro_full_dtls_modal', show: this.state.cart_added_status, onHide: this.close },
								_react2.default.createElement(
									_reactBootstrap.Modal.Header,
									{ closeButton: true },
									_react2.default.createElement(
										_reactBootstrap.Modal.Title,
										{ style: { fontSize: '16px', color: '#333' } },
										'Alert'
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal.Body,
									null,
									_react2.default.createElement(
										'h4',
										{ style: { fontSize: '14px', color: '#666' } },
										'Product already added to the cart!'
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal.Footer,
									{ className: 'modal_footer' },
									_react2.default.createElement(
										_reactBootstrap.Button,
										{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
										'Close'
									)
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return WebSmartCart;
	}(_react.Component);
	
	exports.default = WebSmartCart;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var WebBrandStoreBlocks = function (_Component) {
	  _inherits(WebBrandStoreBlocks, _Component);
	
	  function WebBrandStoreBlocks(props) {
	    _classCallCheck(this, WebBrandStoreBlocks);
	
	    var _this = _possibleConstructorReturn(this, (WebBrandStoreBlocks.__proto__ || Object.getPrototypeOf(WebBrandStoreBlocks)).call(this, props));
	
	    _this.state = {
	      deal_offers: []
	    };
	    _this.getBrandStores = _this.getBrandStores.bind(_this);
	    _this.storeClicks = _this.storeClicks.bind(_this);
	    _this.goNext = _this.goNext.bind(_this);
	    _this.goPrev = _this.goPrev.bind(_this);
	    return _this;
	  }
	
	  _createClass(WebBrandStoreBlocks, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getBrandStores();
	    }
	  }, {
	    key: 'getBrandStores',
	    value: function getBrandStores() {
	      var data1 = { from: 'desktop_web' };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        url: baseUrl + 'brand_store',
	        method: 'POST',
	        data: { req: data2 },
	        dataType: 'JSON',
	        success: function (data) {
	          if (data.status === 'success') {
	            this.setState({ deal_offers: data.deal_offers });
	          }
	        }.bind(this),
	        error: function error(err) {}
	
	      });
	    }
	  }, {
	    key: 'storeClicks',
	    value: function storeClicks(id) {
	      if (localStorage.user_id) {
	        var uid = localStorage.user_id;
	      } else {
	        uid = 0;
	      }
	      var data1 = { from: 'desktop_web', uid: uid, id: id };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        url: baseUrl + 'storeClicks',
	        method: 'POST',
	        data: { req: data2 },
	        dataType: 'JSON',
	        success: function success(data) {},
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'goNext',
	    value: function goNext() {
	      if (this.swiper) this.swiper.slideNext();
	    }
	  }, {
	    key: 'goPrev',
	    value: function goPrev() {
	      if (this.swiper) this.swiper.slidePrev();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var params = {
	        paginationClickable: true,
	        slidesPerView: 3,
	        spaceBetween: 10,
	        parallax: true,
	        parallaxEl: {
	          el: '.parallax-bg',
	          value: '-23%'
	        },
	
	        navigation: {
	          nextEl: '.swiper-button-next',
	          prevEl: '.swiper-button-prev'
	        }
	      };
	      var brands = this.state.deal_offers.map(function (brand, index) {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          { to: brand.redirect_url ? '/web' + brand.redirect_url : '#', onClick: function onClick() {
	              _this2.storeClicks(brand.row_id);
	            } },
	          brand.img ? _react2.default.createElement('img', { src: baseAssets + 'images/' + brand.img, alt: '' }) : ''
	        );
	      }.bind(this));
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'web_brnds_blk' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Webbrand_stores_blk' },
	          brands.length > 0 ? _react2.default.createElement(
	            'div',
	            { className: 'container', style: { padding: '0px' } },
	            _react2.default.createElement(
	              'h4',
	              { className: 'web_blk_titles' },
	              'Brand Stores'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'pro_sld_ctrls pull-right' },
	              _react2.default.createElement(
	                'a',
	                { className: 'left carousel-control pro_sld_lft', onClick: this.goPrev },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'pro_sld_arow', 'aria-hidden': 'true' },
	                  _react2.default.createElement('img', { src: baseAssets + 'images_web/left_arrow.png', alt: '' })
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'sr-only' },
	                  'Previous'
	                )
	              ),
	              _react2.default.createElement(
	                'a',
	                { className: 'right carousel-control pro_sld_rgt', onClick: this.goNext },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'pro_sld_arow', 'aria-hidden': 'true' },
	                  _react2.default.createElement('img', { src: baseAssets + 'images_web/right_arrow.png', alt: '' })
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'sr-only' },
	                  'Next'
	                )
	              )
	            )
	          ) : '',
	          _react2.default.createElement(
	            'div',
	            { className: 'container', style: { backgroundColor: '#fff', padding: '0px 0px 10px 0px', marginTop: '15px' } },
	            _react2.default.createElement(
	              _reactIdSwiper2.default,
	              _extends({}, params, { key: brands.length, ref: function ref(node) {
	                  return node ? _this3.swiper = node.swiper : '';
	                } }),
	              brands
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return WebBrandStoreBlocks;
	}(_react.Component);
	
	exports.default = WebBrandStoreBlocks;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var WebStoreBlocks = function (_Component) {
		_inherits(WebStoreBlocks, _Component);
	
		function WebStoreBlocks(props) {
			_classCallCheck(this, WebStoreBlocks);
	
			var _this = _possibleConstructorReturn(this, (WebStoreBlocks.__proto__ || Object.getPrototypeOf(WebStoreBlocks)).call(this, props));
	
			_this.state = {
				deal_offers: [],
				deal_details: [],
				arrowImage: '',
				dealoffer_name: '',
				bgImage: '',
				deal_bg_img: '',
				isToggle: ''
			};
			_this.getStoreBlocks = _this.getStoreBlocks.bind(_this);
			_this.getblockDetails = _this.getblockDetails.bind(_this);
			_this.goNext = _this.goNext.bind(_this);
			_this.goPrev = _this.goPrev.bind(_this);
			_this.goNextInner = _this.goNextInner.bind(_this);
			_this.goPrevInner = _this.goPrevInner.bind(_this);
			_this.swiper = null;
			_this.swiper1 = null;
			return _this;
		}
	
		_createClass(WebStoreBlocks, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.getStoreBlocks();
			}
		}, {
			key: 'getStoreBlocks',
			value: function getStoreBlocks() {
				var data1 = { from: 'desktop_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + 'getdealOffers',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							deal_offers: data.deal_offers
						});
						this.getblockDetails(data.deal_offers[0].id);
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getblockDetails',
			value: function getblockDetails(block_id) {
				this.setState({
					arrowImage: block_id
				});
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: block_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getOfferDeals',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							if (this.state.storeid !== block_id) {
								this.setState({ isToggle: true });
							} else {
								this.setState({ isToggle: !this.state.isToggle });
							}
	
							this.setState({
								deal_details: data.deal_blocks,
								deal_bg_img: baseAssets + 'images/' + data.blck_img,
								dealoffer_name: data.arrayname,
								storeid: block_id
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'goNext',
			value: function goNext() {
				if (this.swiper) this.swiper.slideNext();
			}
		}, {
			key: 'goPrev',
			value: function goPrev() {
				if (this.swiper) this.swiper.slidePrev();
			}
		}, {
			key: 'goNextInner',
			value: function goNextInner() {
				if (this.swiper1) this.swiper1.slideNext();
			}
		}, {
			key: 'goPrevInner',
			value: function goPrevInner() {
				if (this.swiper1) this.swiper1.slidePrev();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var params = {
					paginationClickable: true,
					spaceBetween: 10,
					slidesPerView: 4,
					slidesPerGroup: 4,
					// autoplay:3000,
					// autoplayDisableOnInteraction:false,
					//  pagination: {
					//     el: '.swiper-pagination',
					//     type: 'bullets',
					//     clickable: true
					// },
					// pagination: '.swiper-pagination',
					navigation: {
						nextEl: '.swiper-button-next1',
						prevEl: '.swiper-button-prev1'
					}
				};
				var brandparams = {
					paginationClickable: true,
					spaceBetween: 20,
					slidesPerView: 6,
					slidesPerGroup: 6,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				};
				var mob_swipe_blocks = this.state.deal_offers.map(function (block, index) {
					var _this2 = this;
	
					return _react2.default.createElement(
						'div',
						{ className: 'item', onClick: function onClick() {
								_this2.getblockDetails(block.id);
							} },
						_react2.default.createElement(
							'div',
							{ className: 'web_store_img_blk  text-center' },
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement('img', { src: baseAssets + 'images/' + block.img, alt: '' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'text-center' },
								_react2.default.createElement(
									'h6',
									null,
									block.type
								),
								this.state.isToggle ? _react2.default.createElement(
									'i',
									null,
									this.state.storeid === block.id ? _react2.default.createElement('img', { src: baseAssets + 'images/' + block.arrow_img, alt: '' }) : ''
								) : ''
							)
						)
					);
				}.bind(this));
	
				var swipe_all = '';
				if (this.state.deal_details.length > 0) {
					swipe_all = this.state.deal_details.map(function (block, index) {
						return _react2.default.createElement(
							'div',
							{ className: block.pro_title === "View More" ? "web_swipe_dtls_content1" : "web_swipe_dtls_content" },
							this.state.dealoffer_name === "Imported" ? _react2.default.createElement(
								_reactRouter.Link,
								{ to: '/web/pdeals/' + block.url_dtype + '/' + block.url_name + '/' + block.id + '/' + block.type + '/' + block.pro_id },
								block.image === '' ? '' : _react2.default.createElement(
									'i',
									{ className: 'web_store_img' },
									_react2.default.createElement('img', { className: 'web_sw_dtls_img', src: 'https://aquadeals.in/admin/assets/images/' + block.image, alt: ' ' })
								),
								block.brand_name ? _react2.default.createElement(
									'h5',
									{ className: 'web_sw_brand_name' },
									block.brand_name
								) : _react2.default.createElement(
									'h5',
									{ className: 'web_sw_brand_name' },
									'\xA0'
								),
								block.pro_title ? _react2.default.createElement(
									'h6',
									{ className: 'web_dtls_name' },
									block.pro_title
								) : _react2.default.createElement(
									'h6',
									{ className: 'web_dtls_name' },
									'\xA0'
								),
								block.mrp ? _react2.default.createElement(
									'p',
									{ className: 'web_sw_dtls_price' },
									'MRP \u20B9 ',
									block.mrp
								) : _react2.default.createElement(
									'p',
									{ className: 'web_sw_brand_price' },
									'\xA0'
								)
							) : _react2.default.createElement(
								'div',
								null,
								block.pro_title === "View More" ? _react2.default.createElement(
									_reactRouter.Link,
									{ to: '/web/stores/' + block.url_name + '/' + block.id },
									block.image === '' ? '' : _react2.default.createElement('img', { className: 'sw_dtls_img', src: 'https://aquadeals.in/admin/assets/images/' + block.image, alt: ' ' }),
									_react2.default.createElement(
										'h5',
										{ className: 'm_dtls_name organic_dtls_name' },
										block.pro_title
									)
								) : _react2.default.createElement(
									_reactRouter.Link,
									{ to: '/web/pdetails/' + block.url_dtype_name + '/' + block.url_cat_name + '/' + block.url_brand_name + '/' + block.url_product_name + '/' + block.pro_id + '/' + block.id },
									block.image === '' ? '' : _react2.default.createElement(
										'i',
										{ className: 'web_store_img' },
										_react2.default.createElement('img', { className: 'web_sw_dtls_img', src: 'https://aquadeals.in/admin/assets/images/' + block.image, alt: ' ' })
									),
									block.brand_name ? _react2.default.createElement(
										'h5',
										{ className: 'web_sw_brand_name' },
										block.pro_title
									) : _react2.default.createElement(
										'h5',
										{ className: 'web_sw_brand_name' },
										'\xA0'
									),
									block.pro_title ? _react2.default.createElement(
										'h6',
										{ className: 'web_dtls_name' },
										block.brand_name
									) : _react2.default.createElement(
										'h6',
										{ className: 'web_dtls_name' },
										'\xA0'
									),
									block.mrp ? _react2.default.createElement(
										'p',
										{ className: 'web_sw_dtls_price' },
										'MRP \u20B9 ',
										block.mrp
									) : _react2.default.createElement(
										'p',
										{ className: 'web_sw_dtls_price' },
										'\xA0'
									)
								)
							)
						);
					}.bind(this));
				}
				return _react2.default.createElement(
					'section',
					{ className: 'container our_stores' },
					_react2.default.createElement(
						'div',
						{ className: 'row' },
						_react2.default.createElement(
							'h4',
							{ className: 'web_blk_titles' },
							'AD Stores'
						),
						_react2.default.createElement(
							'div',
							{ className: 'pro_sld_ctrls' },
							_react2.default.createElement(
								'a',
								{ className: 'left carousel-control pro_sld_lft', onClick: this.goPrev },
								_react2.default.createElement(
									'span',
									{ className: 'pro_sld_arow', 'aria-hidden': 'true' },
									_react2.default.createElement('img', { src: baseAssets + 'images_web/left_arrow.png', alt: '' })
								),
								_react2.default.createElement(
									'span',
									{ className: 'sr-only' },
									'Previous'
								)
							),
							_react2.default.createElement(
								'a',
								{ className: 'right carousel-control pro_sld_rgt', onClick: this.goNext },
								_react2.default.createElement(
									'span',
									{ className: 'pro_sld_arow', 'aria-hidden': 'true' },
									_react2.default.createElement('img', { src: baseAssets + 'images_web/right_arrow.png', alt: '' })
								),
								_react2.default.createElement(
									'span',
									{ className: 'sr-only' },
									'Next'
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'row' },
						_react2.default.createElement(
							'div',
							{ id: 'carousel-our-stores', className: 'carousel slide carousel-our-stores', 'data-ride': 'carousel', 'data-type': 'multi', 'data-interval': 'false' },
							_react2.default.createElement(
								_reactIdSwiper2.default,
								_extends({}, params, { key: mob_swipe_blocks.length, ref: function ref(node) {
										return node ? _this3.swiper = node.swiper : '';
									} }),
								mob_swipe_blocks
							),
							this.state.isToggle ? _react2.default.createElement(
								'div',
								{ className: 'web_swipe_imp_bg', style: { background: 'url(' + this.state.deal_bg_img + ')' } },
								swipe_all.length > 0 ? _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'div',
										{ className: 'pro_sld_ctrls pro_sld_ctrls_innerstores' },
										_react2.default.createElement(
											'a',
											{ className: 'left carousel-control pro_sld_lft', onClick: this.goPrevInner },
											_react2.default.createElement(
												'span',
												{ className: 'pro_sld_arow', 'aria-hidden': 'true' },
												_react2.default.createElement('img', { src: baseAssets + 'images_web/left_arrow.png', alt: '' })
											),
											_react2.default.createElement(
												'span',
												{ className: 'sr-only' },
												'Previous'
											)
										),
										_react2.default.createElement(
											'a',
											{ className: 'right carousel-control pro_sld_rgt', onClick: this.goNextInner },
											_react2.default.createElement(
												'span',
												{ className: 'pro_sld_arow', 'aria-hidden': 'true' },
												_react2.default.createElement('img', { src: baseAssets + 'images_web/right_arrow.png', alt: '' })
											),
											_react2.default.createElement(
												'span',
												{ className: 'sr-only' },
												'Next'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ id: 'carousel-our-stores1' },
										_react2.default.createElement(
											_reactIdSwiper2.default,
											_extends({}, brandparams, { key: swipe_all.length, ref: function ref(node) {
													return node ? _this3.swiper1 = node.swiper : '';
												} }),
											swipe_all
										)
									)
								) : ''
							) : ''
						)
					)
				);
			}
		}]);
	
		return WebStoreBlocks;
	}(_react.Component);
	
	exports.default = WebStoreBlocks;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactStars = __webpack_require__(33);
	
	var _reactStars2 = _interopRequireDefault(_reactStars);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactShare = __webpack_require__(18);
	
	var _reactInfiniteScrollComponent = __webpack_require__(57);
	
	var _reactInfiniteScrollComponent2 = _interopRequireDefault(_reactInfiniteScrollComponent);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	// path: /pdeals/:Type/:Tid
	
	var Web_Partner_Deals = function (_Component) {
		_inherits(Web_Partner_Deals, _Component);
	
		function Web_Partner_Deals(props) {
			_classCallCheck(this, Web_Partner_Deals);
	
			var _this = _possibleConstructorReturn(this, (Web_Partner_Deals.__proto__ || Object.getPrototypeOf(Web_Partner_Deals)).call(this, props));
	
			_this.state = {
				tid: _this.props.params.Tid,
				type: _this.props.params.Type,
				dtype: _this.props.params.DType,
				pdeals: [],
				totdata: '',
				prevPath: '',
				brands: [],
				categories: [],
				brands_status: false,
				cat_status: false,
				cat_sort_status: false,
				nodata: false,
				open: false,
				web_title: '',
				web_desc: '',
				loadmore_number: 2,
				loadmore_status: 0,
				set_type: '',
				next_page: '',
				sort_list: [],
	
				cart_count: 0,
				sort_title: 'Sort By',
				seo_title: '',
				seo_desc: '',
				loading_gif: false,
				loading_more_status: false,
				deal_type_status: false,
				deal_types: [],
	
				sortid: '',
				selected: '',
				total_deals: '',
				bname: '',
	
				page_name: ''
			};
			_this.getBrands = _this.getBrands.bind(_this);
			// this.getSelectedBrand=this.getSelectedBrand.bind(this);
			_this.getDeviceId = _this.getDeviceId.bind(_this);
			// this.getSelectedCategorySort=this.getSelectedCategorySort.bind(this);
			_this.getCartCount = _this.getCartCount.bind(_this);
			_this.fetchData = _this.fetchData.bind(_this);
			_this.refresh = _this.refresh.bind(_this);
			// this.getSelectedDType=this.getSelectedDType.bind(this);
	
			_this.getPartnerDeals = _this.getPartnerDeals.bind(_this);
			_this.getSort = _this.getSort.bind(_this);
			// this.getCategories=this.getCategories.bind(this);
			_this.getBrandfilter = _this.getBrandfilter.bind(_this);
	
			_this.setFilter = _this.setFilter.bind(_this);
			_this.isActive = _this.isActive.bind(_this);
			return _this;
		}
	
		_createClass(Web_Partner_Deals, [{
			key: 'refresh',
			value: function refresh() {
				console.log("");
			}
		}, {
			key: 'getSort',
			value: function getSort(event) {
				var index = event.target.selectedIndex;
				var optionElement = event.target.childNodes[index];
				var id = optionElement.getAttribute('id');
				this.setState({ sortid: id });
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
	
				var data1 = { from: 'desktop_web', uid: uid, type: this.state.type, bid: this.state.bid, tid: this.state.tid, sort: id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					url: baseUrl + 'getProductbycat_brand',
					method: 'POST',
					dataType: 'JSON',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
	
							this.setState({
								pdeals: data.result,
								totdata: data,
								loadmore_status: data.load_more,
								set_type: data.set_type,
								next_page: data.next_page,
								seo_desc: '',
								selected: data.cat_name
								// selected:data.result[0].brand_name,
							});
						}
						if (data.result.length === 0) {
							this.setState({
								nodata: true
							});
						} else {
							this.setState({
								nodata: false
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'fetchData',
			value: function fetchData() {
	
				// this.state.next_page, this.state.set_type,this.props.params.Tid,this.props.params.DType
				var num = this.state.next_page;
				var type = this.state.set_type;
				if (this.props.params.Dtype) {
					var dtype = this.props.params.DType;
				} else {
					dtype = 0;
				}
				// var dtype=this.props.params.DType;
				var tid = this.props.params.Tid;
	
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				this.setState({
					// loading_gif:true,
					loading_more_status: true
				});
				if (this.state.sortid) {
					var sortid = this.state.sortid;
				}
				var getfunc = "";
				var data1 = "";
				var data2 = "";
				type = this.props.params.Type;
				if (type === "all") {
					data1 = { from: 'desktop_web', uid: uid, page: num, type: dtype, limit: 20, sort: sortid };
					data2 = JSON.stringify(data1);
					getfunc = "getPoductDeals";
				} else if (type === "Pcategory") {
					data1 = { from: 'desktop_web', uid: uid, page: num, dtype: dtype, type: type, tid: tid, limit: 20, sort: sortid };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				} else if (type === "brand") {
					data1 = { from: 'desktop_web', uid: uid, page: num, dtype: dtype, type: type, tid: tid, limit: 20, sort: sortid };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				} else if (type === "partner") {
					data1 = { from: 'desktop_web', uid: uid, page: num, dtype: 0, type: type, tid: tid, limit: 20, sort: sortid };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				}
				if (this.state.loadmore_status === 1) {
					this.setState({
						// loading_gif:true,
						loadmore_status: true
					});
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + getfunc,
						success: function (data) {
							if (data.products) {
								if (data.load_more === 1) {
									this.setState({
										pdeals: this.state.pdeals.concat(data.products),
										offer: data,
										todata: data,
										loadmore_status: data.load_more,
										set_type: data.set_type,
										next_page: data.next_page,
										loading_gif: false,
										loading_more_status: false,
										selected: data.cat_name
										// selected:data.result[0].brand_name,
									});
								} else {
									this.setState({
										set_type: data.set_type,
										next_page: data.next_page,
										loadmore_status: data.load_more,
										loading_gif: false,
										loading_more_status: false
									});
								}
							} else {
								if (data.load_more === 1) {
									this.setState({
										pdeals: this.state.pdeals.concat(data.result),
										// feedsList: this.state.feedsList.concat(data.result),
										set_type: data.set_type,
										next_page: data.next_page,
										loadmore_status: data.load_more,
										loading_gif: false,
										loading_more_status: false
									});
								} else {
									this.setState({
										set_type: data.set_type,
										next_page: data.next_page,
										loadmore_status: data.load_more,
										loading_gif: false,
										loading_more_status: false
									});
								}
							}
						}.bind(this),
						error: function error(err) {
							this.setState({
								loading_gif: false,
								loading_more_status: false
							});
						}
					});
				} else {
					this.setState({
						loading_more_status: false
					});
				}
			}
		}, {
			key: 'getCartCount',
			value: function getCartCount() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							cart_count: data.cart_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getDeviceId',
			value: function getDeviceId() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getDeviceId',
					dataType: 'json',
					data: { req: data2 },
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'getBrands',
			value: function getBrands() {
				if (this.props.params.DType) {
					var dtype = this.props.params.DType;
				} else {
					dtype = 0;
				}
				var data1 = { from: 'desktop_web', type: this.state.type, tid: this.state.tid, dtype: dtype };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'filterBrandCat',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.brands_lst.length > 0) {
							this.setState({
								brands_status: true
							});
						}
						if (data.cat_lst.length > 0) {
							this.setState({
								cat_status: true
							});
						}
						if (data.deal_types.length > 0) {
							this.setState({
								deal_type_status: true
							});
						}
						this.setState({
							brands: data.brands_lst,
							categories: data.cat_lst,
							sort_list: data.sort,
							deal_types: data.deal_types
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
			// getSelectedBrand(b)
			// {
			//    this.setState({
			//    	loading_gif:true,
			//    });
			//    localStorage.setItem('brand',b);
			// var uid =0;
			// if(localStorage.user_id)
			// {
			//    uid=localStorage.getItem('user_id')
			// }
			// else
			// {
			//    uid=0;
			// }
			//    if(this.state.type==="offers")
			//    {
			//  		var data1={from:"desktop_web","tid":"","type":"combo","cat_id":"cat_id","uid":uid,"deal_offer_type":"3","bid":b,"lat1":"","long1":"","sort":localStorage.getItem('cat_sort')}  	
			//    }
			//    else
			//    {
			//    	data1={from: 'desktop_web',uid:uid,type:this.state.type, tid: this.state.tid,dtype:this.state.dtype,bid: b};
			//    }
			//    var data2=JSON.stringify(data1);
			//    $.ajax({
			//          method: 'POST',
			//          url: baseUrl+'getProductbycat_brand',
			//          dataType:'json',
			//          data: {req:data2},
			//          success: function(data)
			//          {
			//             if(data.result.length === 0)
			//             {
			//               this.setState({
			//                 nodata: true,
			//                 loading_gif:false,
			//               });
			//             }
			//             else
			//             {
			//               this.setState({
			//                 nodata: false,
			//                 loading_gif:false,
			//               });
			//             }
			//             this.setState({
			//               pdeals:data.result,
			//               totdata: data,
			//               loadmore_status:data.load_more,
			//               set_type:data.set_type,
			//               next_page:data.next_page,
			//             });
			// 		if(data.status==='error')
			// 		{
			// 			localStorage.removeItem('cat_id');
			// 		}
			//          }.bind(this),
			//          error: function(err)
			//          {
			//          }
			//    });
			// }
			// getSelectedCategory(c)
			// {
			//   	this.setState({
			//   		loading_gif:true,
			//   	});
			//    localStorage.setItem('cat_id',c);
			//    localStorage.removeItem('brand');
			//    var uid =0;
			//     	if(localStorage.user_id)
			//     	{
			//        uid=localStorage.getItem('user_id')
			//    }
			//     	else
			//     	{
			//       	uid=0;
			//     	}
			//    var data1={from: 'desktop_web',uid:uid,type:this.state.type,tid:this.state.tid, dtype:this.state.dtype,cat_id: c};
			//    var data2=JSON.stringify(data1);
			// $.ajax({
			//          method: 'POST',
			//          url: baseUrl+'getProductbycat_brand',
			//          dataType:'json',
			//          data: {req:data2},
			//          success: function(data)
			//          {
			//             if(data.result.length === 0)
			//             {
			//               this.setState({
			//                 nodata: true,
			//                 loading_gif:false,
			//               })
			//             }
			//             else
			//             {
			//               this.setState({
			//                 nodata: false,
			//                 loading_gif:false,
			//               })
			//             }
			//             this.setState({
			//                 pdeals:data.result,
			//                 totdata: data,
			//                 loadmore_status:data.load_more,
			//                 set_type:data.set_type,
			//                 next_page:data.next_page,
			//            });
			//          }.bind(this),
			//          error: function(err)
			//          {
			//          }
			//    });
			// }
			// getSelectedCategorySort(c,name)
			// {
			// 		this.setState({
			// 			loading_gif:true,
			// 		});
			//    // localStorage.removeItem('brand');
			//    var catId=0;
			//    localStorage.setItem('cat_sort',c);
	
			//    if(localStorage.cat_id)
			//    {
			//      catId=localStorage.getItem('cat_id');
			//    }
			//    else
			//    {
			//      catId=0;
			//    }
			//    this.setState({
			//    	sort_title: name,
			//    });
			//    var uid =0;
			//    if(localStorage.user_id)
			//    {
			//      uid=localStorage.getItem('user_id')
			//    }
			//    else
			//    {
			//       uid=0;
			//    }
			//    if(this.state.type === 'offers')
			//    {
			//    	var data1={from:"desktop_web","tid":"","type":"","uid":uid,"deal_offer_type":"3","bid":localStorage.getItem('brand'),"lat1":"","long1":"","sort":c}
			//    }
			//    else {
			//    	 data1={from: 'desktop_web',uid:uid,type:this.state.type, tid: this.state.tid, dtype:this.state.dtype,cat_id:catId,sort:c};
			//    }
			//    var data2=JSON.stringify(data1);
			// $.ajax({
			//          method: 'POST',
			//          url: baseUrl+'getProductbycat_brand',
			//          dataType:'json',
			//          data: {req:data2},
			//          success: function(data)
			//          {
			//             if(data.result.length === 0)
			//             {
			//               this.setState({
			//                 nodata: true,
			//                 loading_gif:false,
			//               })
			//             }
			//             else
			//             {
			//               this.setState({
			//                 nodata: false,
			//                 loading_gif:false,
			//               })
			//             }
			//             this.setState({
			//                 pdeals:data.result,
			//                 totdata: data,
			//                 loadmore_status:data.load_more,
			//                 set_type:data.set_type,
			//                 next_page:data.next_page,
			//            });
			//            localStorage.removeItem('cat_sort');
			//            localStorage.removeItem('cat_id');
			//          }.bind(this),
			//          error: function(err)
			//          {
			//          }
			//    });
			// }
	
			// getSelectedBrandSort(b,name)
			// {
			//   	this.setState({
			//   		loading_gif:true,
			//   	});
			//    // localStorage.removeItem('brand');
			//    var bid=0;
			//    localStorage.setItem('bid_sort',b);
			//    if(localStorage.brand)
			//    {
			//      bid=localStorage.getItem('brand');
			//    }
			//    else
			//    {
			//      bid=0;
			//    }
			//    this.setState({
			//    	sort_title: name,
			//    });
			//    var uid =0;
			//    if(localStorage.user_id)
			//    {
			//       uid=localStorage.getItem('user_id')
			//    }
			//    else
			//    {
			//      uid=0;
			//    }
			//    if(this.state.type === 'offers')
			//    {
			//    	var data1={from:"desktop_web","tid":"","type":"","uid":uid,"deal_offer_type":"3","bid":localStorage.getItem('brand'),"lat1":"","long1":"","sort":b}
			//    }
			//    else {
			//    	 data1={from: 'desktop_web',uid:uid,type:this.state.type, tid: this.state.tid, dtype:this.state.dtype,bid:bid,sort:b};
			//    }
			//    var data2=JSON.stringify(data1);
			// $.ajax({
			//          method: 'POST',
			//          url: baseUrl+'getProductbycat_brand',
			//          dataType:'json',
			//          data: {req:data2},
			//          success: function(data)
			//          {
			//             if(data.result.length === 0)
			//             {
			//               this.setState({
			//                 nodata: true,
			//                 loading_gif:false,
			//               })
			//             }
			//             else
			//             {
			//               this.setState({
			//                 nodata: false,
			//                 loading_gif:false,
			//               })
			//             }
			//             this.setState({
			//                 pdeals:data.result,
			//                 totdata: data,
			//                 loadmore_status:data.load_more,
			//                 set_type:data.set_type,
			//                 next_page:data.next_page,
			//            });
			//          }.bind(this),
			//          error: function(err)
			//          {
			//          }
			//    });
			// }
			// getSelectedDType(dtype)
			// {
			// 		this.setState({
			// 			loading_gif:true,
			// 		});
			//    // localStorage.removeItem('brand');
			//    // var catId=0;
	
			//    if(localStorage.user_id)
			//    {
			//     	var uid=localStorage.getItem('user_id')
			//    }
			//    else
			//    {
			//        uid=0;
			//    }
			//    if(this.state.type === 'offers')
			//    {
			//    	var data1={from:"desktop_web","tid":"","type":"","uid":uid,"deal_offer_type":"3","bid":localStorage.getItem('brand'),"lat1":"","long1":"","sort":''}
			//    }
			//    else
			//    {
			//    	 data1={from: 'desktop_web',uid:uid,type:this.state.type,tid: this.state.tid,dtype:dtype,sort:''};
			//    }
			//    var data2=JSON.stringify(data1);
			// $.ajax({
			//          method: 'POST',
			//          url: baseUrl+'getProductbycat_brand',
			//          dataType:'json',
			//          data: {req:data2},
			//          success: function(data)
			//          {
			//             if(data.result.length === 0)
			//             {
			//               this.setState({
			//                 nodata: true,
			//                 loading_gif:false,
			//               })
			//             }
			//             else
			//             {
			//               this.setState({
			//                 nodata: false,
			//                 loading_gif:false,
			//               })
			//             }
			//             this.setState({
			//                 pdeals:data.result,
			//                 totdata: data,
			//                 loadmore_status:data.load_more,
			//                 set_type:data.set_type,
			//                 next_page:data.next_page,
			//            });
			//          }.bind(this),
			//          error: function(err)
			//          {
			//          }
			//    });
			// }
	
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
				localStorage.removeItem('checkout');
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
				localStorage.removeItem('web_quickcart');
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_wishlist');
				localStorage.removeItem('web_brand_details');
	
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
	
				if (screen.width < 800) {
					window.location.href = '/pdeals/' + this.props.params.Type + '/' + this.props.params.Tid;
				}
	
				localStorage.setItem('partner_deals', '/pdeals/' + this.props.params.Type + '/' + this.props.params.Tid);
				// if(screen.width >= 800)
				// {
				//   window.location.href="/web/pdeals/"+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Tid+"/"+this.props.params.Type+"/"+this.props.params.DType;
				// }
				// if(this.props.params.BrandName && this.props.params.CatName && this.props.params.Tid && this.props.params.Type && this.props.params.DType)
				// {
				//   	localStorage.setItem('m_r_p_deals',"/pdeals/"+this.props.params.BrandName+"/"+this.props.params.CatName +"/"+this.props.params.Tid+"/"+this.props.params.Type+"/"+this.props.params.DType)	
				// }
				// else
				// {
				// 		localStorage.removeItem('m_r_p_deals');	
				// }
				if (localStorage.user_id && localStorage.token) {
					this.getCartCount();
				}
	
				this.getDeviceId();
	
				localStorage.removeItem('w_r_s_deals');
				localStorage.removeItem('m_r_s_deals');
	
				//localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('bid');
				localStorage.removeItem('cat_sort');
				localStorage.removeItem('url');
				this.getBrands();
	
				this.getPartnerDeals();
			}
		}, {
			key: 'getPartnerDeals',
			value: function getPartnerDeals() {
				if (this.props.params.Type) {
					var type = this.props.params.Type;
				} else {
					type = 'type';
				}
				if (this.props.params.Tid) {
					var tid = this.props.params.Tid;
				} else {
					tid = 0;
				}
				var data1 = { from: 'desktop_web', type: type, tid: tid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true
							});
						} else {
							this.setState({
								nodata: false
							});
						}
						this.setState({
							pdeals: data.result,
							totdata: data,
							loadmore_status: data.load_more,
							set_type: data.set_type,
							next_page: data.next_page,
							seo_desc: '',
							selected: data.cat_name,
							// selected:data.result[0].brand_name,
							total_deals: data.tot_deals,
							page_name: data.cat_name
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getBrandfilter',
			value: function getBrandfilter(id, type) {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
	
				var data1 = { from: 'desktop_web', uid: uid, type: type, bid: id, tid: this.state.tid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					url: baseUrl + 'getProductbycat_brand',
					method: 'POST',
					dataType: 'JSON',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								pdeals: data.result,
								totdata: data,
								loadmore_status: data.load_more,
								set_type: data.set_type,
								next_page: data.next_page,
								seo_desc: '',
								total_deals: data.tot_deals,
	
								selected: data.cat_name
							});
							//   	  if(this.state.selected === 'all')
							//   	  {
							//   	  	 this.setState({selected:data.cat_name});
							//   	  }
							//   	  else
							//   	  {
							//   	  	this.setState({selected:data.result[0].brand_name,});
							// }
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'setFilter',
			value: function setFilter(filter, id, type) {
				this.setState({ selected: filter, bid: id, type: type });
			}
		}, {
			key: 'isActive',
			value: function isActive(value) {
				return 'li ' + (value === this.state.selected ? 'active' : '');
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				// $('body').css('background','#fff');
	
				var brands = this.state.brands.map(function (brand, index) {
					return _react2.default.createElement(
						'span',
						null,
						brand.name !== "All" ? _react2.default.createElement(
							'li',
							{ key: index, id: "brand_" + brand.id /*className={this.isActive(brand.name)} onClick={this.setFilter.bind(this, brand.name,brand.id,brand.type)}*/ },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/web/pdeals/brands/' + brand.url_name + '/' + brand.id /*onClick={() => {this.getBrandfilter(brand.id,brand.type)}}*/ },
								_react2.default.createElement(
									'span',
									null,
									brand.name
								)
							)
						) : ''
					);
				});
				var cate = this.state.categories.map(function (cat, index) {
					if (cat.sub.length > 0) {
						var subs_cat = cat.sub.map(function (sub_cat, index) {
							return _react2.default.createElement(
								'li',
								{ key: sub_cat.id, id: "sub_cat_" + sub_cat.id, className: "sub_cat_li " + this.isActive(sub_cat.category_name), onClick: this.setFilter.bind(this, sub_cat.category_name, sub_cat.id, sub_cat.type) },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: "/web/pdeals/" + sub_cat.url_dtype_name + "/" + sub_cat.url_name + "/" + sub_cat.id + "/" + sub_cat.type + "/" + sub_cat.dtype },
									_react2.default.createElement(
										'span',
										null,
										sub_cat.category_name
									)
								)
							);
						}.bind(this));
						return _react2.default.createElement(
							'li',
							{ key: cat.id, id: "cat_" + cat.id },
							_react2.default.createElement(
								_reactRouter.Link,
								null,
								_react2.default.createElement(
									'span',
									null,
									cat.category_name
								)
							),
							subs_cat
						);
					} else {
						return _react2.default.createElement(
							'li',
							{ key: cat.id, id: "cat_" + cat.id },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: "/web/pdeals/" + cat.url_dtype_name + "/" + cat.url_name + "/" + cat.id + "/" + cat.type + "/" + cat.dtype },
								_react2.default.createElement(
									'span',
									null,
									cat.category_name
								)
							)
						);
					}
				}.bind(this));
	
				var sortlist = this.state.sort_list.map(function (item, index) {
					return _react2.default.createElement(
						'option',
						{ key: item.id, id: item.id },
						item.name
					);
				});
	
				var products = this.state.pdeals.map(function (product, index) {
					return _react2.default.createElement(ProductsList, { key: product.pid, data: product, onUpdate: function onUpdate() {
							return _this2.getCartCount();
						} });
				});
	
				document.title = this.state.page_name ? 'Shop the best deals from ' + this.state.page_name + ' | AquaDeals ' : 'Shop the best deals from AquaDeals';
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_pdeals_page' },
					_react2.default.createElement(_WebHeaderInner2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					this.state.loading_gif ? _react2.default.createElement(
						'i',
						{ className: 'web_loading_gif' },
						_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
					) : '',
					_react2.default.createElement(
						'section',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'tot_pro partner_dls' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-3 col-sm-3' },
									_react2.default.createElement(
										'div',
										{ className: 'filtrs_blk cat_blks' },
										this.state.categories.length > 0 ? _react2.default.createElement(
											'h3',
											null,
											'Categories'
										) : '',
										_react2.default.createElement(
											'ul',
											null,
											cate
										),
										_react2.default.createElement(
											'h3',
											null,
											'Brands'
										),
										_react2.default.createElement(
											'ul',
											null,
											brands
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'pro_sec col-sm-9 col-md-9' },
									_react2.default.createElement(
										'div',
										{ className: 'pro_sec_hdr' },
										_react2.default.createElement(
											'h3',
											null,
											this.state.selected,
											' (',
											this.state.total_deals,
											' Items)'
										),
										_react2.default.createElement(
											'div',
											{ className: 'pro_slt_fltr' },
											_react2.default.createElement(
												'select',
												{ onChange: this.getSort },
												_react2.default.createElement(
													'option',
													null,
													'Select'
												),
												sortlist
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'row lst_itm' },
										this.state.nodata ? _react2.default.createElement(
											'div',
											{ className: 'no_data' },
											_react2.default.createElement(
												'h3',
												null,
												'No Deals Available'
											),
											_react2.default.createElement(
												'p',
												null,
												'Need something here? ',
												_react2.default.createElement(
													_reactRouter.Link,
													{ to: "/customer_care" },
													'CONTACT US'
												),
												' now !'
											)
										) : '',
										_react2.default.createElement(
											_reactInfiniteScrollComponent2.default,
											{
												pullDownToRefresh: true,
												pullDownToRefreshContent: _react2.default.createElement(
													'h3',
													{ style: { textAlign: 'center' } },
													'\u2193'
												),
												releaseToRefreshContent: _react2.default.createElement(
													'h3',
													{ style: { textAlign: 'center' } },
													'\u2191'
												),
												refreshFunction: this.refresh,
												next: this.fetchData,
												hasMore: true,
												scrollThreshold: 0.3,
												loader: _react2.default.createElement('h4', null),
												endMessage: _react2.default.createElement(
													'p',
													{ style: { textAlign: 'center' } },
													_react2.default.createElement('b', null)
												) },
											products
										),
										this.state.loading_more_status ? _react2.default.createElement(
											'div',
											{ className: 'webloading_more_sym' },
											_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
										) : ''
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return Web_Partner_Deals;
	}(_react.Component);
	
	exports.default = Web_Partner_Deals;
	
	var ProductsList = function (_Component2) {
		_inherits(ProductsList, _Component2);
	
		function ProductsList(props) {
			_classCallCheck(this, ProductsList);
	
			var _this3 = _possibleConstructorReturn(this, (ProductsList.__proto__ || Object.getPrototypeOf(ProductsList)).call(this, props));
	
			_this3.state = {
				open: false,
				msg: '',
				shareUrl: '',
				cart_count: '',
				clearcart_status: false,
				already_added_status: false
			};
			_this3.ShareFunc = _this3.ShareFunc.bind(_this3);
			_this3.addToCart = _this3.addToCart.bind(_this3);
			_this3.updateCartCount = _this3.updateCartCount.bind(_this3);
			_this3.close = _this3.close.bind(_this3);
			_this3.replaceCartItems = _this3.replaceCartItems.bind(_this3);
			_this3.addToQuickCart = _this3.addToQuickCart.bind(_this3);
			return _this3;
		}
	
		_createClass(ProductsList, [{
			key: 'replaceCartItems',
			value: function replaceCartItems(deal_id, quantity) {
				var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1, quantity: quantity, pl_size: 0, salinity: 0, pickup_date: 0 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'replaceCart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								clearcart_status: false
							});
							_reactRouter.browserHistory.push('/mycart');
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					clearcart_status: false,
					already_added_status: false
				});
			}
		}, {
			key: 'updateCartCount',
			value: function updateCartCount() {
				this.props.onUpdate();
			}
		}, {
			key: 'ShareFunc',
			value: function ShareFunc(evnt) {
				var _this4 = this;
	
				var data1 = { from: 'desktop_web', type: 1, did: evnt };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'createTinyurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							msg: data.msg,
							shareUrl: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {}
				});
				this.setState({
					open: !this.state.open
				});
				setTimeout(function () {
					_this4.setState({ open: false });
				}, 5000);
			}
		}, {
			key: 'addToQuickCart',
			value: function addToQuickCart(deal_id) {
				if (!localStorage.user_id && !localStorage.token) {
					_reactRouter.browserHistory.push('/login');
				} else {
					var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1 };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'post',
						dataType: 'json',
						url: baseUrl + 'addToQCart',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.updateCartCount();
								_reactRouter.browserHistory.push('/quickcart');
							} else if (data.status === "error" && data.cart_flag === 0) {
								this.setState({
									clearcart_status: true
								});
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'addToCart',
			value: function addToCart(deal_id) {
				if (!localStorage.user_id && !localStorage.token) {
					_reactRouter.browserHistory.push('/login');
				} else {
					var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1 };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'post',
						dataType: 'json',
						url: baseUrl + 'quickBuy',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.updateCartCount();
								_reactRouter.browserHistory.push('/mycart');
							} else if (data.status === "error" && data.cart_flag === 0) {
								this.setState({
									clearcart_status: true
								});
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
							} else if (data.status === "error" && data.message === "Token mismatch") {
								localStorage.removeItem('token');
								localStorage.removeItem('user_id');
								_reactRouter.browserHistory.push('/login');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var mydata = this.props.data;
				var shareUrl = this.state.shareUrl;
				var title = "Hey Click here " + shareUrl + " to check " + mydata.title + " from AquaDeals.";
				var description = shareUrl;
				return _react2.default.createElement(
					'div',
					{ className: 'col-md-3 col-sm-6' },
					_react2.default.createElement(
						'div',
						{ className: 'prdt_blk' },
						mydata.dealcount <= 1 ? _react2.default.createElement(
							'div',
							null,
							mydata.ad_guarantee_flag === '1' ? _react2.default.createElement(
								'span',
								{ className: 'web_ad_guarantee' },
								_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: 'presentation' })
							) : '',
							_react2.default.createElement(
								_reactRouter.Link,
								{ className: 'lst_share_btn', onClick: function onClick() {
										_this5.ShareFunc(mydata.deal_id);
									} },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/share.png', alt: 'share' })
							),
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									_reactBootstrap.Panel,
									{ className: 'share_panel', collapsible: true, expanded: this.state.open },
									_react2.default.createElement(
										FacebookShareButton,
										{ url: shareUrl, quote: title, description: description, className: 'test_share' },
										_react2.default.createElement(FacebookIcon, { size: 32, round: true })
									),
									_react2.default.createElement(
										TwitterShareButton,
										{ url: shareUrl, quote: title, description: description, className: 'test_share' },
										_react2.default.createElement(TwitterIcon, { size: 32, round: true })
									),
									_react2.default.createElement(
										GooglePlusShareButton,
										{ url: shareUrl, quote: title, description: description, className: 'test_share' },
										_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
									)
								)
							)
						) : '',
						_react2.default.createElement(
							'div',
							null,
							mydata.promo_ribbion ? _react2.default.createElement(
								'i',
								{ className: 'ribbon_img' },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + mydata.promo_ribbion, alt: '' })
							) : '',
							mydata.dealcount >= 2 ? _react2.default.createElement(
								'div',
								null,
								mydata.ad_guarantee_flag === '1' ? _react2.default.createElement(
									'span',
									{ className: 'web_ad_guarantee' },
									_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: 'presentation' })
								) : '',
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: "/web/subdeals/" + mydata.url_dtype_name + "/" + mydata.url_cat_name + "/" + mydata.dtype + "/" + mydata.url_brand_name + "/" + mydata.pid },
									mydata.promo_ribbion ? _react2.default.createElement(
										'i',
										{ className: 'ribbon_img' },
										_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/' + mydata.promo_ribbion, alt: 'ribbon' })
									) : '',
									_react2.default.createElement(
										'div',
										null,
										_react2.default.createElement('img', { src: mydata.image === null ? baseAssets + 'images/product_imgs/noimage1.jpg' : baseAssets + 'images/product_imgs/' + mydata.image, alt: '' })
									),
									mydata.title ? _react2.default.createElement(
										'h3',
										null,
										mydata.title,
										' ',
										mydata.quantity
									) : _react2.default.createElement(
										'h3',
										null,
										'\xA0'
									),
									mydata.brand_name ? _react2.default.createElement(
										'h4',
										null,
										mydata.brand_name
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									),
									mydata.dealcount >= 2 ? _react2.default.createElement(
										'h4',
										null,
										mydata.dealcount,
										' deals available'
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row stars_view_blk' },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-7 col-xs-7', style: { paddingRight: '0' } },
										_react2.default.createElement(
											'div',
											{ className: 'prdt_str_rt' },
											_react2.default.createElement(_reactStars2.default, {
												count: 5,
												className: 'webRate_blk_item',
												size: 17,
												value: mydata.over_rate >= 1 ? mydata.over_rate : 0,
												edit: false,
												color1: '#ccc',
												color2: '#ffc50a' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-md-5 col-xs-5', style: { paddingLeft: 0 } },
										'\xA0'
									)
								)
							) : _react2.default.createElement(
								'div',
								null,
								mydata.ad_guarantee_flag === '1' ? _react2.default.createElement(
									'span',
									{ className: 'web_ad_guarantee' },
									_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: 'presentation' })
								) : '',
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: "/web/pdetails/" + mydata.url_dtype_name + "/" + mydata.url_cat_name + "/" + mydata.url_brand_name + "/" + mydata.url_product_name + "/" + mydata.pid + "/" + mydata.deal_id },
									mydata.promo_ribbion ? _react2.default.createElement(
										'i',
										{ className: 'ribbon_img' },
										_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/' + mydata.promo_ribbion, alt: '' })
									) : '',
									_react2.default.createElement(
										'div',
										null,
										_react2.default.createElement('img', { src: mydata.image === null ? baseAssets + 'images/product_imgs/noimage1.jpg' : baseAssets + 'images/product_imgs/' + mydata.image, alt: ' ' })
									),
									mydata.title ? _react2.default.createElement(
										'h3',
										null,
										mydata.title,
										' ',
										mydata.quantity
									) : _react2.default.createElement(
										'h3',
										null,
										'\xA0'
									),
									mydata.brand_name ? _react2.default.createElement(
										'h4',
										null,
										mydata.brand_name
									) : _react2.default.createElement(
										'h4',
										null,
										'\xA0'
									),
									mydata.pricediff === "" ? _react2.default.createElement(
										'h4',
										null,
										'MRP \u20B9 ',
										mydata.mrp
									) : '',
									mydata.dealcount >= 2 ? _react2.default.createElement(
										'h4',
										null,
										mydata.dealcount,
										' deals available'
									) : '',
									mydata.pricediff ? _react2.default.createElement(
										'h4',
										null,
										'Aquacash discount \u20B9 ',
										mydata.pricediff
									) : ''
								),
								_react2.default.createElement(
									'div',
									{ className: 'row stars_view_blk' },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-7 col-xs-7', style: { paddingRight: '0' } },
										_react2.default.createElement(
											'div',
											{ className: 'prdt_str_rt' },
											_react2.default.createElement(_reactStars2.default, {
												count: 5,
												className: 'webRate_blk_item',
												size: 17,
												value: mydata.over_rate >= 1 ? mydata.over_rate : 0,
												edit: false,
												color1: '#ccc',
												color2: '#ffc50a' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-md-5 col-xs-5', style: { paddingLeft: 0 } },
										mydata.count > 0 && mydata.dealcount <= 1 ? _react2.default.createElement(
											'span',
											{ className: 'prdt_views' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
											),
											' ',
											mydata.count
										) : ''
									)
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.clearcart_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#333' } },
								'You can\'t have multiple seller items in the cart. Empty existing cart & add this item ',
								mydata.title,
								'?'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'NO'
							),
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: function onClick() {
											_this5.replaceCartItems(mydata.deal_id, mydata.min_qty);
										} },
									'YES'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.already_added_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#333' } },
								'Product already added to the cart'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'OK'
							)
						)
					)
				);
			}
		}]);
	
		return ProductsList;
	}(_react.Component);

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Product = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactStars = __webpack_require__(33);
	
	var _reactStars2 = _interopRequireDefault(_reactStars);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	var _reactShare = __webpack_require__(18);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactInfiniteScrollComponent = __webpack_require__(57);
	
	var _reactInfiniteScrollComponent2 = _interopRequireDefault(_reactInfiniteScrollComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	// /web/stores/:StoreType/:ID
	
	var Web_Store_Deals = function (_Component) {
		_inherits(Web_Store_Deals, _Component);
	
		function Web_Store_Deals(props) {
			_classCallCheck(this, Web_Store_Deals);
	
			var _this = _possibleConstructorReturn(this, (Web_Store_Deals.__proto__ || Object.getPrototypeOf(Web_Store_Deals)).call(this, props));
	
			_this.state = {
				store_deals: [],
				loading_more_status: false,
	
				brands: [],
				sort_list: [],
				feedcat: [],
				nodata: false,
				open: false,
				types: [],
				title: '',
				desc: '',
				tid: _this.props.params.Tid,
				type: _this.props.params.Type,
				dtype: _this.props.params.DType,
				htype: _this.props.params.DType,
				data_type: _this.props.params.DType,
				bread: '',
				activeMenu: '',
				selected: '',
				loading: false,
				lod: false,
				loadmore_number: 2,
				loadmore_status: 0,
				set_type: '',
				next_page: '',
				seo_desc: '',
				loading_gif: false,
				h1_desc: '',
				nav_deal_offers: [],
	
				id: '',
				Typ: ''
	
			};
			_this.getCartCount = _this.getCartCount.bind(_this);
			_this.getSelectedStore = _this.getSelectedStore.bind(_this);
			_this.refresh = _this.refresh.bind(_this);
			_this.fetchData = _this.fetchData.bind(_this);
			return _this;
		}
	
		_createClass(Web_Store_Deals, [{
			key: 'getSelectedStore',
			value: function getSelectedStore(type, id) {
				this.setState({
					loading_gif: true
				});
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (type === 'Ad guarantee') {
					var type1 = 'ad-guarantee';
					var id1 = '';
				} else {
					type1 = 'store';
					id1 = id;
				}
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', uid: uid, tid: id1, type: type1, dtype: '', bid: '', limit: 20 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true
							});
						} else {
							this.setState({
								nodata: false
							});
						}
						if (data.status === "success") {
							this.setState({
								store_deals: data.result,
	
								page_name: data.cat_name,
								loading: true,
								title: data.product_name,
								desc: 'The best offers of AquaDeals',
								selected: data.cat_name,
								loadmore_status: data.load_more,
								set_type: data.set_type,
								next_page: data.next_page,
								// h1_desc:data.cat_name ? 'Shop the best deals from '+data.cat_name +' Store' : 'Shop the best deals from AquaDeals Store',
								loading_gif: false
							});
							if (data.cat_name === 'CP Store') {
								this.setState({
									h1_desc: data.cat_name ? 'Shop the best deals from ' + data.cat_name : 'Shop the best deals from AquaDeals Store'
								});
							} else {
								this.setState({
									h1_desc: data.cat_name ? 'Shop the best deals from ' + data.cat_name + ' Store' : 'Shop the best deals from AquaDeals Store'
								});
							}
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				if (screen.width < 800) {
					if (this.props.params.ID) {
						window.location.href = "/stores/" + this.props.params.StoreType + '/' + this.props.params.ID;
					} else {
						window.location.href = "/stores/" + this.props.params.StoreType;
					}
				}
				if (localStorage.token && localStorage.user_id) {
					this.getCartCount();
				}
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var type = 'store';
				if (this.props.params.StoreType === 'caa-approved') {
					type = this.props.params.StoreType;
				} else if (this.props.params.StoreType === 'ad-guarantee') {
					type = this.props.params.StoreType;
				} else if (this.props.params.StoreType === 'ad-assist') {
					type = this.props.params.StoreType;
				}
				this.setFilter(this.props.params.StoreType);
				this.navStoreTypes();
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', uid: uid, tid: this.props.params.ID, type: type, dtype: '', bid: '', sort: '', limit: 20 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true
							});
						} else {
							this.setState({
								nodata: false
							});
						}
						if (data.status === "success") {
							this.setState({
								store_deals: data.result,
	
								page_name: data.cat_name,
								loading: true,
								title: data.product_name,
								desc: 'The best offers of AquaDeals',
								selected: data.cat_name,
								loadmore_status: data.load_more,
								set_type: data.set_type,
								next_page: data.next_page
								// h1_desc:data.cat_name ? 'Shop the best deals from '+data.cat_name +' Store' : 'Shop the best deals from AquaDeals Store',
							});
						}
						if (data.cat_name === 'CP Store') {
							this.setState({
								h1_desc: data.cat_name ? 'Shop the best deals from ' + data.cat_name : 'Shop the best deals from AquaDeals Store'
							});
						} else {
							this.setState({
								h1_desc: data.cat_name ? 'Shop the best deals from ' + data.cat_name + ' Store' : 'Shop the best deals from AquaDeals Store'
							});
						}
	
						// document.title =this.state.web_title+  " - Deals | AquaDeals ";
						// document.getElementsByTagName("META")[2].content=this.state.seo_desc;
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'getCartCount',
			value: function getCartCount() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							cart_count: data.cart_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'fetchData',
			value: function fetchData() {
				this.setState({
					loading_gif: true,
					loading_more_status: true
				});
				var getfunc = "";
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = "";
				var data2 = "";
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				// this.state.next_page, this.state.set_type,this.props.params.Tid,this.props.params.DType
				var num = this.state.next_page;
				var dtype = this.props.params.DType;
				// var type=this.state.set_type;
				var tid = this.props.params.Tid;
				var type = 'store';
				if (this.props.params.StoreType === 'caa-approved') {
					type = this.props.params.StoreType;
				} else if (this.props.params.StoreType === 'ad-guarantee') {
					type = this.props.params.StoreType;
				} else if (this.props.params.StoreType === 'ad-assist') {
					type = this.props.params.StoreType;
				}
	
				if (type === "all") {
					data1 = { from: 'desktop_web', page: num, type: dtype, limit: 20 };
					data2 = JSON.stringify(data1);
					getfunc = "getPoductDeals";
				}
				if (type === "Pcategory") {
					data1 = { from: 'desktop_web', uid: uid, page: num, dtype: dtype, type: type, tid: tid, limit: 20 };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				}
				if (type === "brand") {
					data1 = { from: 'desktop_web', uid: uid, page: num, dtype: dtype, type: type, tid: tid, limit: 20 };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				} else {
					data1 = { from: 'desktop_web', uid: uid, page: num, dtype: dtype, type: type, tid: this.props.params.ID, limit: 20 };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				}
	
				var products = "";
				if (this.state.loadmore_status === 1) {
					_jquery2.default.ajax({
						method: 'POST',
						url: baseUrl + getfunc,
						dataType: 'json',
						data: { req: data2 },
						success: function (data) {
							this.setState({
								// store_deals:data.result,
								loading: true,
								loading_more_status: false,
								title: data.cat_name,
								desc: data.cat_desc,
								selected: data.cat_name,
								loadmore_status: data.load_more,
								set_type: data.set_type,
								next_page: data.next_page,
								loading_gif: false
							});
							this.setState({
								store_deals: this.state.store_deals.concat(data.result)
							});
						}.bind(this),
						error: function error(err) {
							// console.log(err);
							this.setState({
								loading_gif: false,
								loading_more_status: false
							});
						}
					});
				} else {
					this.setState({
						loading_gif: false
					});
				}
			}
		}, {
			key: 'refresh',
			value: function refresh() {
				console.log("");
			}
		}, {
			key: 'navStoreTypes',
			value: function navStoreTypes() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + 'getdealOffers_sidebar',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							nav_deal_offers: data.deal_offers
						});
					}.bind(this),
					error: function error(err) {
						// console.log(err);
					}
				});
			}
		}, {
			key: 'setFilter',
			value: function setFilter(filter) {
				this.setState({ Typ: filter });
			}
		}, {
			key: 'isActive',
			value: function isActive(value) {
				// var val = value.toUpperCase();
				// console.log(val);	
				return 'li ' + (value === this.state.Typ ? 'active' : '');
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var nav_stores = this.state.nav_deal_offers.map(function (data, index) {
					var _this2 = this;
	
					return (
						// <li key={data.id} id={"brand_"+data.id}  /*className={this.isActive(data.type)} onClick={this.setFilter.bind(this,data.type)}*/ className={this.isActive(data.id)} onClick={this.setFilter.bind(this,data.id)}>
						_react2.default.createElement(
							'li',
							{ key: data.id, id: "brand_" + data.id, className: this.isActive(data.url_storetype), onClick: this.setFilter.bind(this, data.url_storetype) },
							_react2.default.createElement(
								_reactRouter.Link,
								{ onClick: function onClick() {
										_this2.getSelectedStore(data.type, data.id);
									}, to: parseInt(data.id, 10) === 17 ? "/web/ad-banners/ad-guarantee" : "/web/stores/" + data.url_storetype + "/" + data.id },
								_react2.default.createElement(
									'span',
									null,
									data.type
								)
							)
						)
					);
				}.bind(this));
	
				document.title = this.state.page_name ? 'Shop the best deals from ' + this.state.page_name + ' Store' : 'Shop the best deals from AquaDeals Stores';
				var storedeals = this.state.store_deals.map(function (deal, index) {
					return _react2.default.createElement(Product, { key: index, data: deal, onUpdate: function onUpdate() {
							return _this3.getCartCount();
						} });
				});
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_pdeals_page' },
					this.state.loading ? _react2.default.createElement(
						'div',
						{ className: 'lgt_gry' },
						_react2.default.createElement(_WebHeaderInner2.default, null),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'h1',
							{ className: 'page_title' },
							this.state.h1_desc
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'section',
							{ className: 'container Dels_cntnt', style: { paddingLeft: 0 } },
							_react2.default.createElement(
								'div',
								{ className: 'tot_pro' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-3 col-sm-3' },
										_react2.default.createElement(
											'div',
											{ className: 'filtrs_blk' },
											_react2.default.createElement(
												'h3',
												null,
												'Stores'
											),
											_react2.default.createElement(
												'ul',
												null,
												nav_stores
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-md-9 col-sm-9 pro_sec' },
										_react2.default.createElement('div', { className: 'clr' }),
										_react2.default.createElement(
											'div',
											{ className: 'row itm_lst' },
											this.state.loading_gif ? _react2.default.createElement(
												'i',
												{ className: 'web_loading_gif' },
												_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/loading_more.gif', alt: 'Loading' })
											) : '',
											_react2.default.createElement(
												_reactInfiniteScrollComponent2.default,
												{
													pullDownToRefresh: true,
													pullDownToRefreshContent: _react2.default.createElement(
														'h3',
														{ style: { textAlign: 'center' } },
														'\u2193'
													),
													releaseToRefreshContent: _react2.default.createElement(
														'h3',
														{ style: { textAlign: 'center' } },
														'\u2191'
													),
													refreshFunction: this.refresh,
													next: this.fetchData,
													hasMore: true,
													scrollThreshold: 0.3,
													loader: _react2.default.createElement('h4', null),
													endMessage: _react2.default.createElement(
														'p',
														{ style: { textAlign: 'center' } },
														_react2.default.createElement('b', null)
													) },
												storedeals
											)
										)
									)
								)
							)
						),
						_react2.default.createElement('div', { className: 'clr' }),
						_react2.default.createElement(_WebFooter2.default, null)
					) : _react2.default.createElement(
						'div',
						{ className: 'loading_sym', style: { width: '100%', textAlign: 'center', marginTop: '20%' } },
						_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/ajax-loader1.gif', alt: 'Loading Deals', role: 'presentation' })
					)
				);
			}
		}]);
	
		return Web_Store_Deals;
	}(_react.Component);
	
	exports.default = Web_Store_Deals;
	
	var Product = exports.Product = function (_Component2) {
		_inherits(Product, _Component2);
	
		function Product() {
			_classCallCheck(this, Product);
	
			var _this4 = _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).call(this));
	
			_this4.state = {
				open: false,
				msg: '',
				shareUrl: '',
				cart_count: '',
				clearcart_status: false,
				already_added_status: false
			};
			_this4.ShareFunc = _this4.ShareFunc.bind(_this4);
			// this.addToCart=this.addToCart.bind(this);
			_this4.updateCartCount = _this4.updateCartCount.bind(_this4);
			_this4.close = _this4.close.bind(_this4);
			_this4.replaceCartItems = _this4.replaceCartItems.bind(_this4);
			// this.addToQuickCart=this.addToQuickCart.bind(this);
			return _this4;
		}
	
		_createClass(Product, [{
			key: 'ShareFunc',
			value: function ShareFunc(evnt) {
				var _this5 = this;
	
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', type: 1, did: evnt };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'createTinyurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							msg: data.msg,
							shareUrl: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {}
				});
				this.setState({
					open: !this.state.open
				});
				setTimeout(function () {
					_this5.setState({ open: false });
				}, 5000);
			}
		}, {
			key: 'replaceCartItems',
			value: function replaceCartItems(deal_id, quantity) {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'desktop_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1, quantity: quantity, pl_size: 0, salinity: 0, pickup_date: 0 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'replaceCart',
					data: { req: data2 },
					success: function (data) {
						console.log(data);
						if (data.status === "success") {
							this.setState({
								clearcart_status: false
							});
							_reactRouter.browserHistory.push('/web/mycart');
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					clearcart_status: false,
					already_added_status: false
				});
			}
			// addToCart(deal_id)
			//  	{
			//   	if(!localStorage.user_id && !localStorage.token)
			//   	{
			//   		browserHistory.push('/web/login');
			// 	}
			// 	else
			// 	{
			// 		var baseUrl='https://aquadeals.in/admin/web3/user/';
			// 	  	var data1={from: 'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),deal_id:deal_id,deal_type:1}
			// 		var data2=JSON.stringify(data1);
			// 		$.ajax({
			// 			method:'post',
			// 			dataType:'json',
			// 			url: baseUrl+'quickBuy',
			// 			data:{req:data2},
			// 			success:function(data)
			// 			{
			// 				if(data.status==="success")
			// 				{
			// 					this.updateCartCount();
			// 					browserHistory.push('/web/mycart');
			// 				}
			// 				else if(data.status==="error" && data.cart_flag===0)
			// 				{
			// 					this.setState({
			// 						clearcart_status: true,
			// 					});
			// 				}
			// 				else if(data.status==="error" && data.message==="Product already added to the cart")
			// 				{
			// 					this.setState({
			// 						already_added_status: true,
			// 					});
			// 				}
			// 			}.bind(this),
			// 			error:function(err)
			// 			{
	
			// 			}
			// 		});
			// 	}
			//  	}
			//  	addToQuickCart(deal_id)
			//  	{
			//   	if(!localStorage.user_id && !localStorage.token)
			//   	{
			//   		browserHistory.push('/web/login');
			// 	}
			// 	else
			// 	{
			// 		var baseUrl='https://aquadeals.in/admin/web3/user/';
			// 	  	var data1={from: 'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),deal_id:deal_id,deal_type:1}
			// 		var data2=JSON.stringify(data1);
			// 		$.ajax({
			// 			method:'post',
			// 			dataType:'json',
			// 			url: baseUrl+'addToQCart',
			// 			data:{req:data2},
			// 			success:function(data)
			// 			{
			// 				if(data.status==="success")
			// 				{
			// 					this.updateCartCount();
			// 					browserHistory.push('/web/quickcart');
			// 				}
			// 				else if(data.status==="error" && data.cart_flag===0)
			// 				{
			// 					this.setState({
			// 						clearcart_status: true,
			// 					});
			// 				}
			// 				else if(data.status==="error" && data.message==="Product already added to the cart")
			// 				{
			// 					this.setState({
			// 						already_added_status: true,
			// 					});
			// 				}
			// 			}.bind(this),
			// 			error:function(err)
			// 			{
	
			// 			}
			// 		});
			// 	}
			// }
	
		}, {
			key: 'updateCartCount',
			value: function updateCartCount() {
				this.props.onUpdate();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this6 = this;
	
				var product = this.props.data;
				var shareUrl = this.state.shareUrl;
				var title = "Hey Click here " + shareUrl + " to check " + product.title + " from AquaDeals.";
				var description = shareUrl;
				return _react2.default.createElement(
					'div',
					{ className: 'col-md-3 col-sm-6' },
					_react2.default.createElement(
						'div',
						{ className: 'prdt_blk' },
						product.dealcount >= 2 ? _react2.default.createElement(
							'div',
							null,
							product.ad_guarantee_flag === '1' ? _react2.default.createElement(
								'span',
								{ className: 'web_ad_guarantee' },
								_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: 'presentation' })
							) : '',
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: "/web/subdeals/" + product.url_dtype_name + "/" + product.url_cat_name + "/" + product.dtype + "/" + product.url_brand_name + "/" + product.pid },
								product.promo_ribbion ? _react2.default.createElement(
									'i',
									{ className: 'ribbon_img' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/' + product.promo_ribbion, alt: '' })
								) : '',
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement('img', { alt: ' ', src: product.image !== null && product.image !== '' ? 'https://aquadeals.in/admin/assets/images/product_imgs/thumbnails/' + product.image : 'https://aquadeals.in/admin/assets/icons/web_icons/noImage.png' })
								),
								product.title ? _react2.default.createElement(
									'h3',
									null,
									product.title,
									' ',
									product.quantity
								) : _react2.default.createElement(
									'h3',
									null,
									'\xA0'
								),
								product.brand_name ? _react2.default.createElement(
									'h4',
									null,
									product.brand_name
								) : _react2.default.createElement(
									'h4',
									null,
									'\xA0'
								),
								product.dealcount >= 2 ? _react2.default.createElement(
									'h4',
									null,
									product.dealcount,
									' deals available'
								) : _react2.default.createElement(
									'h4',
									null,
									'\xA0'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row stars_view_blk' },
								_react2.default.createElement('div', { className: 'clr' }),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-7 col-xs-7', style: { paddingRight: '0' } },
									_react2.default.createElement(
										'div',
										{ className: 'prdt_str_rt' },
										_react2.default.createElement(_reactStars2.default, {
											count: 5,
											className: 'webRate_blk_item',
											size: 17,
											value: product.over_rate >= 1 ? product.over_rate : 0,
											edit: false,
											color1: '#ccc',
											color2: '#ffc50a' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-5 col-xs-5', style: { paddingLeft: 0 } },
									product.count > 0 ? _react2.default.createElement(
										'span',
										{ className: 'prdt_views' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
										),
										' ',
										product.count
									) : _react2.default.createElement(
										'span',
										{ className: 'prdt_views hide_views' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
										),
										' 0'
									)
								)
							),
							_react2.default.createElement('div', { className: 'clr' })
						) : _react2.default.createElement(
							'div',
							null,
							product.ad_guarantee_flag === '1' ? _react2.default.createElement(
								'span',
								{ className: 'web_ad_guarantee' },
								_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: 'presentation' })
							) : '',
							_react2.default.createElement(
								_reactRouter.Link,
								{ className: 'lst_share_btn', onClick: function onClick() {
										_this6.ShareFunc(product.deal_id);
									} },
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/share.png', alt: 'Share' })
							),
							_react2.default.createElement(
								_reactBootstrap.Panel,
								{ className: 'share_panel', collapsible: true, expanded: this.state.open },
								_react2.default.createElement(
									FacebookShareButton,
									{ url: shareUrl, quote: title, className: 'test_share' },
									_react2.default.createElement(FacebookIcon, { size: 32, round: true })
								),
								_react2.default.createElement(
									TwitterShareButton,
									{ url: shareUrl, quote: title, className: 'test_share' },
									_react2.default.createElement(TwitterIcon, { size: 32, round: true })
								),
								_react2.default.createElement(
									GooglePlusShareButton,
									{ url: shareUrl, quote: title, description: description, className: 'test_share' },
									_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
								)
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ key: product.pid, className: 'cursor', to: "/web/pdetails/" + product.url_dtype_name + "/" + product.url_cat_name + "/" + product.url_brand_name + "/" + product.url_product_name + "/" + product.pid + "/" + product.deal_id },
								product.promo_ribbion ? _react2.default.createElement(
									'i',
									{ className: 'ribbon_img' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/' + product.promo_ribbion, alt: '' })
								) : '',
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement('img', { alt: ' ', src: product.image !== null && product.image !== '' ? 'https://aquadeals.in/admin/assets/images/product_imgs/thumbnails/' + product.image : 'https://aquadeals.in/admin/assets/icons/web_icons/noImage.png' })
								),
								product.title ? _react2.default.createElement(
									'h3',
									null,
									product.title,
									' ',
									product.quantity
								) : _react2.default.createElement(
									'h3',
									null,
									'\xA0'
								),
								product.brand_name ? _react2.default.createElement(
									'h4',
									null,
									product.brand_name
								) : _react2.default.createElement(
									'h4',
									null,
									'\xA0'
								),
								product.pricediff ? _react2.default.createElement(
									'h4',
									null,
									_react2.default.createElement(
										'span',
										null,
										'AquaCash Discount'
									),
									'\xA0',
									_react2.default.createElement(
										'span',
										null,
										'\u20B9',
										product.pricediff
									)
								) : '',
								product.pricediff === "" ? _react2.default.createElement(
									'h4',
									null,
									'MRP \u20B9 ',
									product.mrp
								) : ''
							),
							_react2.default.createElement(
								'div',
								{ className: 'row stars_view_blk' },
								_react2.default.createElement('div', { className: 'clr' }),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-7 col-xs-7', style: { paddingRight: '0' } },
									_react2.default.createElement(
										'div',
										{ className: 'prdt_str_rt' },
										_react2.default.createElement(_reactStars2.default, {
											count: 5,
											className: 'webRate_blk_item',
											size: 17,
											value: product.over_rate >= 1 ? product.over_rate : 0,
											edit: false,
											color1: '#ccc',
											color2: '#ffc50a' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-5 col-xs-5', style: { paddingLeft: 0 } },
									product.count > 0 ? _react2.default.createElement(
										'span',
										{ className: 'prdt_views' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
										),
										' ',
										product.count
									) : _react2.default.createElement(
										'span',
										{ className: 'prdt_views hide_views' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
										),
										' 0'
									)
								)
							),
							_react2.default.createElement('div', { className: 'clr' })
						)
					)
				);
			}
		}]);
	
		return Product;
	}(_react.Component);

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _reactStars = __webpack_require__(33);
	
	var _reactStars2 = _interopRequireDefault(_reactStars);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactShare = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var WebTrendings = function (_Component) {
		_inherits(WebTrendings, _Component);
	
		function WebTrendings(props) {
			_classCallCheck(this, WebTrendings);
	
			var _this = _possibleConstructorReturn(this, (WebTrendings.__proto__ || Object.getPrototypeOf(WebTrendings)).call(this, props));
	
			_this.state = {
				trends: [],
				event: '',
				dealid: ''
			};
			_this.getTrendings = _this.getTrendings.bind(_this);
			_this.goNext = _this.goNext.bind(_this);
			_this.goPrev = _this.goPrev.bind(_this);
			// this.isActive =this.isActive.bind(this);
			_this.ShareFunc = _this.ShareFunc.bind(_this);
			_this.swiper = null;
			return _this;
		}
	
		_createClass(WebTrendings, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.getTrendings();
			}
		}, {
			key: 'getTrendings',
			value: function getTrendings() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', uid: uid, token: localStorage.token };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getTrendingProducts',
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								trends: data.data
							});
							// this.state.trends.map(function(id,index){
							//this.setState({dealid:id.deal_id});
							// });
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'goNext',
			value: function goNext() {
				if (this.swiper) this.swiper.slideNext();
			}
		}, {
			key: 'goPrev',
			value: function goPrev() {
				if (this.swiper) this.swiper.slidePrev();
			}
		}, {
			key: 'ShareFunc',
			value: function ShareFunc(evnt) {
				var _this2 = this;
	
				this.setState({ event: evnt });
				var data1 = { from: 'desktop_web', type: 1, did: evnt };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'createTinyurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							msg: data.msg,
							shareUrl: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
				setTimeout(function () {
					_this2.setState({ event: false });
				}, 2000);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var trendings = this.state.trends.map(function (product, index) {
					var _this3 = this;
	
					var shareUrl = this.state.shareUrl;
					var title = "Hey! Click here " + shareUrl + " to check " + product.title + " deal from AquaDeals.";
					var description = shareUrl;
					return _react2.default.createElement(
						'div',
						{ className: 'col-md-3 col-sm-6' },
						product.deal_count >= 2 ? _react2.default.createElement(
							'div',
							{ className: 'prdt_blk' },
							product.ad_guarantee_flag === '1' ? _react2.default.createElement(
								'span',
								{ className: 'web_ad_guarantee' },
								_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: 'presentation' })
							) : '',
							_react2.default.createElement(
								_reactRouter.Link,
								{ className: 'lst_share_btn', onClick: function onClick() {
										_this3.ShareFunc(product.deal_id);
									} },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/share.png', alt: 'Share' })
							),
							_react2.default.createElement(
								_reactBootstrap.Panel,
								{ className: 'share_panel', collapsible: true, expanded: product.deal_id === this.state.event ? true : false },
								_react2.default.createElement(
									FacebookShareButton,
									{ url: shareUrl, quote: title, className: 'test_share' },
									_react2.default.createElement(FacebookIcon, { size: 32, round: true })
								),
								_react2.default.createElement(
									TwitterShareButton,
									{ url: shareUrl, quote: title, className: 'test_share' },
									_react2.default.createElement(TwitterIcon, { size: 32, round: true })
								),
								_react2.default.createElement(
									GooglePlusShareButton,
									{ url: shareUrl, quote: title, description: description, className: 'test_share' },
									_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
								)
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ className: '', to: "/web/subdeals/" + product.url_dtype_name + "/" + product.url_cat_name + "/" + product.dtype + "/" + product.url_brand_name + "/" + product.id },
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/thumbnails/' + product.logo, alt: '' })
								),
								product.title ? _react2.default.createElement(
									'h3',
									null,
									product.title
								) : _react2.default.createElement(
									'h3',
									null,
									'\xA0'
								),
								product.brand_name ? _react2.default.createElement(
									'h4',
									null,
									product.brand_name
								) : _react2.default.createElement(
									'h4',
									null,
									'\xA0'
								),
								product.dealcount >= 2 ? _react2.default.createElement(
									'h4',
									null,
									product.dealcount,
									' deals available'
								) : _react2.default.createElement(
									'h4',
									null,
									'\xA0'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row stars_view_blk' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-7 col-xs-7', style: { paddingRight: '0' } },
									_react2.default.createElement(
										'div',
										{ className: 'prdt_str_rt' },
										_react2.default.createElement(_reactStars2.default, {
											count: 5,
											className: 'webRate_blk_item',
											size: 17,
											value: product.rate >= 1 ? product.rate : 0,
											edit: false,
											color1: '#ccc',
											color2: '#ffc50a' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-5 col-xs-5', style: { paddingLeft: 0 } },
									product.count > 0 ? _react2.default.createElement(
										'span',
										{ className: 'pro_views' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
										),
										product.count
									) : ''
								)
							)
						) : _react2.default.createElement(
							'div',
							{ className: 'prdt_blk' },
							product.ad_guarantee_flag === '1' ? _react2.default.createElement(
								'span',
								{ className: 'web_ad_guarantee' },
								_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: 'presentation' })
							) : '',
							_react2.default.createElement(
								_reactRouter.Link,
								{ className: 'lst_share_btn', onClick: function onClick() {
										_this3.ShareFunc(product.deal_id);
									} },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/share.png', alt: 'Share' })
							),
							_react2.default.createElement(
								_reactBootstrap.Panel,
								{ className: 'share_panel ', collapsible: true, expanded: product.deal_id === this.state.event ? true : false },
								_react2.default.createElement(
									FacebookShareButton,
									{ url: shareUrl, quote: title, className: 'test_share' },
									_react2.default.createElement(FacebookIcon, { size: 32, round: true })
								),
								_react2.default.createElement(
									TwitterShareButton,
									{ url: shareUrl, quote: title, className: 'test_share' },
									_react2.default.createElement(TwitterIcon, { size: 32, round: true })
								),
								_react2.default.createElement(
									GooglePlusShareButton,
									{ url: shareUrl, quote: title, description: description, className: 'test_share' },
									_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
								)
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ key: index, className: 'pro_blk', to: "/web/pdetails/" + product.url_dtype_name + "/" + product.url_cat_name + "/" + product.url_brand_name + "/" + product.url_product_name + "/" + product.id + "/" + product.deal_id },
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/thumbnails/' + product.logo, alt: '' })
								),
								product.title ? _react2.default.createElement(
									'h3',
									null,
									product.title
								) : _react2.default.createElement(
									'h3',
									null,
									'\xA0'
								),
								product.brand_name ? _react2.default.createElement(
									'h4',
									null,
									product.brand_name
								) : _react2.default.createElement(
									'h4',
									null,
									'\xA0'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-7 col-xs-7', style: { paddingRight: 0 } },
									_react2.default.createElement(
										'div',
										{ className: 'prdt_str_rt' },
										_react2.default.createElement(_reactStars2.default, {
											count: 5,
											className: 'webRate_blk_item',
											size: 17,
											value: product.rate >= 1 ? product.rate : 0,
											edit: false,
											color1: '#ccc',
											color2: '#ffc50a' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-5 col-xs-5', style: { paddingLeft: 0 } },
									product.count > 0 ? _react2.default.createElement(
										'span',
										{ className: 'pro_views' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', alt: '' })
										),
										product.count
									) : ''
								)
							)
						)
					);
				}.bind(this));
	
				var params = {
					paginationClickable: true,
					spaceBetween: 10,
					slidesPerView: 5,
					slidesPerGroup: 5,
					// autoplay:3000,
					// autoplayDisableOnInteraction:false,
					//  pagination: {
					//     el: '.swiper-pagination',
					//     type: 'bullets',
					//     clickable: true
					// },
					// pagination: '.swiper-pagination',
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				};
	
				return _react2.default.createElement(
					'section',
					{ className: 'container trndg_prdts' },
					this.state.trends.length > 0 ? _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'h4',
								{ className: 'web_trnd_title' },
								'Trending Products'
							),
							_react2.default.createElement(
								'div',
								{ className: 'pro_sld_ctrls' },
								_react2.default.createElement(
									'a',
									{ className: 'left carousel-control pro_sld_lft', onClick: this.goPrev },
									_react2.default.createElement(
										'span',
										{ className: 'pro_sld_arow' },
										_react2.default.createElement('img', { src: baseAssets + 'images_web/left_arrow.png', alt: '' })
									),
									_react2.default.createElement('span', { className: 'sr-only' })
								),
								_react2.default.createElement(
									'a',
									{ className: 'right carousel-control pro_sld_rgt', onClick: this.goNext },
									_react2.default.createElement(
										'span',
										{ className: 'pro_sld_arow' },
										_react2.default.createElement('img', { src: baseAssets + 'images_web/right_arrow.png', alt: '' })
									),
									_react2.default.createElement('span', { className: 'sr-only' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row trndg_prdts_blk' },
							_react2.default.createElement(
								'div',
								{ className: 'trndg_prdts_sldshow' },
								_react2.default.createElement(
									_reactIdSwiper2.default,
									_extends({}, params, { key: this.state.trends.length, ref: function ref(node) {
											return node ? _this4.swiper = node.swiper : '';
										} }),
									trendings
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						)
					) : ''
				);
			}
		}]);
	
		return WebTrendings;
	}(_react.Component);
	
	exports.default = WebTrendings;

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _WebHeaderInner = __webpack_require__(9);
	
	var _WebHeaderInner2 = _interopRequireDefault(_WebHeaderInner);
	
	var _WebFooter = __webpack_require__(8);
	
	var _WebFooter2 = _interopRequireDefault(_WebFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var WebWishList = function (_Component) {
		_inherits(WebWishList, _Component);
	
		function WebWishList(props) {
			_classCallCheck(this, WebWishList);
	
			var _this = _possibleConstructorReturn(this, (WebWishList.__proto__ || Object.getPrototypeOf(WebWishList)).call(this, props));
	
			_this.state = {
				cartcount: '',
				page_loading: false,
				wish_deals: [],
				cart_status: false,
				cart_status_msg: '',
				cart_added_status: false,
				clearcart_status: false,
	
				replace_deal_id: '',
				replace_deal_type: '',
				replace_qty: '',
				replace_pl_size: '',
				replace_salinity: '',
				replace_pickup_date: '',
				replace_id: '',
				replace_pro_title: '',
				emptyCartConfirm: false,
				cart_flag: '',
				cart_count: 0
			};
			_this.getDeals = _this.getDeals.bind(_this);
			_this.addToCart = _this.addToCart.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.replaceCartItems = _this.replaceCartItems.bind(_this);
			_this.emptyCartConfirm = _this.emptyCartConfirm.bind(_this);
			_this.emptyWishList = _this.emptyWishList.bind(_this);
			_this.deleteSingleItem = _this.deleteSingleItem.bind(_this);
			_this.tokenCheck = _this.tokenCheck.bind(_this);
			_this.getCartCount = _this.getCartCount.bind(_this);
			return _this;
		}
	
		_createClass(WebWishList, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_e_coupon_dt');
				localStorage.removeItem('w_r_e_s_dt');
				localStorage.removeItem('web_mycart');
				localStorage.removeItem('w_r_enq_seller_page');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('web_ofr_page');
				localStorage.removeItem('profile');
				localStorage.removeItem('myaquacash');
				localStorage.removeItem('web_share_earn');
				localStorage.removeItem('checkout');
				localStorage.removeItem('order_details');
				localStorage.removeItem('myorders');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('seed');
				localStorage.removeItem('nauplii');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('shipping');
				localStorage.removeItem('notifications');
				localStorage.removeItem('web_quickcart');
				localStorage.removeItem('view_rating');
				localStorage.removeItem('w_modal_seed');
				localStorage.removeItem('w_r_seed_deals');
				localStorage.removeItem('w_r_e_p_dt');
				localStorage.removeItem('w_modal_details');
				localStorage.removeItem('offers');
				localStorage.removeItem('give_rating');
				localStorage.removeItem('pprice');
				localStorage.removeItem('sprice');
				localStorage.removeItem('seed_id');
				localStorage.removeItem('h_type');
				localStorage.removeItem('web_pro_ofr_dtls');
				localStorage.removeItem('web_brand_details');
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('mob_mycart');
				localStorage.removeItem('m_r_enq_seller_page');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('ofr_page');
				localStorage.removeItem('pro_ofr_dtls');
				localStorage.removeItem('myaquacash');
	
				localStorage.removeItem('share_earn');
				localStorage.removeItem('my_orders');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('mob_quickcart');
				localStorage.removeItem('partner_deals');
				if (!localStorage.token && !localStorage.user_id) {
					localStorage.setItem('web_wishlist', '/web/wishlist');
					_reactRouter.browserHistory.push('/web/login');
				} else {
					this.getDeals();
				}
			}
		}, {
			key: 'deleteSingleItem',
			value: function deleteSingleItem(id) {
				this.setState({
					page_loading: true
				});
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: id, token: localStorage.token, uid: uid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'rmvFrmWshlst',
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								page_loading: false
							});
							this.getDeals();
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.tokenCheck();
						}
						// else
						// {
						// 	this.setState({
						// 		page_loading:false,
						// 	});
						// }
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'tokenCheck',
			value: function tokenCheck() {
				localStorage.removeItem('user_id');
				localStorage.removeItem('token');
				window.location.reload();
			}
		}, {
			key: 'getDeals',
			value: function getDeals() {
				this.setState({
					page_loading: true
				});
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.token };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'Wishlist',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								page_loading: false,
								wish_deals: data.lst_items,
								cartcount: data.count
							});
						} else if (data.status === 'error' && data.message === "Token mismatch") {
							this.tokenCheck();
						} else {
							this.setState({
								page_loading: false
							});
						}
					}.bind(this),
					error: function error(err) {
						this.setState({
							page_loading: false
						});
					}
				});
			}
		}, {
			key: 'getCartCount',
			value: function getCartCount() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						console.log(data);
						this.setState({
							cart_count: data.cart_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'addToCart',
			value: function addToCart(deal_id, deal_type, qty, pl_size, salinity, pickup_date, id, pro_title) {
				this.setState({
					replace_deal_id: deal_id,
					replace_deal_type: deal_type,
					replace_qty: qty,
					replace_pl_size: pl_size,
					replace_salinity: salinity,
					replace_pickup_date: pickup_date,
					replace_id: id,
					replace_pro_title: pro_title
				});
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
	
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, deal_id: deal_id, deal_type: deal_type, quantity: qty, pl_size: pl_size, salinity: salinity, pickup_date: pickup_date, wishLst_id: id, wishLst_flag: 1 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'addToCart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success" && data.message === "Added to cart") {
							this.setState({
								cart_status: true,
								cart_status_msg: data.message
							});
							this.getDeals();
							this.getCartCount();
						}
						if (data.status === "success" && data.message === "Cart Updated") {
							this.setState({
								cart_status: true,
								cart_status_msg: data.message
							});
						}
						if (data.status === "error" && data.cart_flag === 0) {
							this.setState({
								clearcart_status: true
							});
						}
						if (data.status === "error" && data.message === "Product already added to the cart" && data.cart_flag === 1) {
							this.setState({
								cart_added_status: true
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					cart_status: false,
					clearcart_status: false,
					cart_added_status: false,
					emptyCartConfirm: false
				});
			}
		}, {
			key: 'replaceCartItems',
			value: function replaceCartItems() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
	
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.getItem('token'), deal_id: this.state.replace_deal_id, deal_type: this.state.replace_deal_type, quantity: this.state.replace_qty, pl_size: this.state.replace_pl_size, salinity: this.state.replace_salinity, pickup_date: this.state.replace_pickup_date, wishLst_flag: '1', wishLst_id: this.state.replace_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'replaceCart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success" && data.cart_flag === 1) {
							this.setState({
								clearcart_status: false,
								cart_status: true,
								cart_status_msg: data.message
							});
						}
						this.getDeals();
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'emptyCartConfirm',
			value: function emptyCartConfirm() {
				this.setState({
					emptyCartConfirm: true
				});
			}
		}, {
			key: 'emptyWishList',
			value: function emptyWishList() {
				this.setState({
					emptyCartConfirm: false
				});
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'desktop_web', id: uid, token: localStorage.token };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'clearWishlist',
					success: function (data) {
						if (data.status === 'success') {
							this.getDeals();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				document.title = "WishList | AquaDeals";
				var wishdeals_list = this.state.wish_deals.map(function (data, index) {
					var _this2 = this;
	
					return _react2.default.createElement(
						'div',
						{ className: 'wishitems' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: data.type === 0 ? "/web/sdetails/" + data.sname + "/" + data.deal_id : "/web/pdetails/" + data.url_dtype_name + "/" + data.url_cat_name + "/" + data.url_brand_name + "/" + data.url_product_name + "/" + data.pid + "/" + data.deal_id },
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-1 col-md-1 col-sm-2' },
											_react2.default.createElement(
												'div',
												{ className: 'item_img' },
												data.type === 0 ? _react2.default.createElement('img', { className: 'item_img', src: data.img !== null && data.img !== '' ? data.img : baseAssets + 'icons/web_icons/noImage.png', alt: '' }) : _react2.default.createElement('img', { className: 'item_img', src: data.img !== null && data.img !== '' ? data.img : baseAssets + 'icons/web_icons/noImage.png', alt: '' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-3 col-md-3 col-sm-2' },
											data.pro_name ? _react2.default.createElement(
												'h2',
												{ className: 'WebWishTitle' },
												data.pro_name
											) : _react2.default.createElement(
												'h2',
												{ className: 'WebWishTitle' },
												'\xA0'
											),
											data.brand !== null && data.brand !== "" ? _react2.default.createElement(
												'h5',
												{ className: 'WebWishBrand' },
												data.brand
											) : _react2.default.createElement(
												'h5',
												{ className: 'WebWishBrand' },
												'\xA0'
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: '' },
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: data.type === 0 ? "/web/sdetails/" + data.sname + "/" + data.deal_id : "/web/pdetails/" + data.url_dtype_name + "/" + data.url_cat_name + "/" + data.url_brand_name + "/" + data.url_product_name + "/" + data.pid + "/" + data.deal_id },
										_react2.default.createElement(
											'div',
											{ className: 'col-lg-1 col-md-1 col-sm-2  col-md-offset-4 col-sm-offset-3 ' },
											data.mrp ? _react2.default.createElement(
												'h3',
												{ className: 'WebWishMrp' },
												'\u20B9 ',
												data.mrp,
												' '
											) : _react2.default.createElement(
												'h3',
												{ className: 'WebWishMrp' },
												'\xA0'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-2 col-md-2 col-sm-2' },
										data.cart_flag === 1 ? _react2.default.createElement(
											'div',
											{ className: 'WebWish_AddBlk' },
											_react2.default.createElement(
												'a',
												{ className: 'webwish_addcart_btn', href: '/web/mycart' },
												'GO TO CART'
											)
										) : _react2.default.createElement(
											'div',
											{ className: 'WebWish_AddBlk' },
											_react2.default.createElement(
												'a',
												{ className: 'webwish_addcart_btn', onClick: function onClick() {
														_this2.addToCart(data.deal_id, data.type, data.qty, data.pl_size, data.salinity, data.pickup_date, data.id, data.pro_name);
													} },
												'ADD TO CART'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-lg-1 col-md-1 col-sm-1' },
										_react2.default.createElement(
											'button',
											{ onClick: function onClick() {
													_this2.deleteSingleItem(data.id);
												}, ariaLabel: 'Close', className: 'close webwish_close outline', type: 'button' },
											_react2.default.createElement(
												'span',
												{ ariaHidden: 'true' },
												'\xD7'
											)
										)
									)
								)
							),
							_react2.default.createElement('hr', null)
						)
					);
				}.bind(this));
				return _react2.default.createElement(
					'div',
					{ className: 'web_Deals web_wishlist' },
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_WebHeaderInner2.default, null),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								_reactBootstrap.Breadcrumb,
								{ className: 'wishlst_breadcrmb' },
								_react2.default.createElement(
									_reactBootstrap.Breadcrumb.Item,
									{ href: '/web/home' },
									'Home'
								),
								_react2.default.createElement(
									_reactBootstrap.Breadcrumb.Item,
									{ active: true },
									'Wishlist'
								)
							)
						),
						_react2.default.createElement(
							'section',
							{ className: 'container Dels_cntnt' },
							this.state.page_loading ? _react2.default.createElement(
								'div',
								{ className: 'WebWish_loading', style: { paddingBottom: '50px' } },
								_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
							) : _react2.default.createElement(
								'div',
								{ className: 'row wishlist_Block' },
								_react2.default.createElement(
									'div',
									{ className: 'container-fluid' },
									this.state.cartcount !== 0 ? _react2.default.createElement(
										'a',
										{ className: 'pull-right delete_item ', onClick: function onClick() {
												_this3.emptyCartConfirm();
											} },
										_react2.default.createElement('img', { alt: '', src: baseAssets + 'icons/web_icons/del_bin3.png', width: '16px' }),
										'Delete all'
									) : ''
								),
								_react2.default.createElement('hr', null),
								this.state.cartcount !== 0 ? _react2.default.createElement(
									'div',
									{ className: 'container', style: { marginBottom: '30px' } },
									_react2.default.createElement(
										'div',
										{ className: 'wish_hdrs' },
										_react2.default.createElement(
											'h3',
											{ className: 'col-lg-6 col-md-6 col-sm-6' },
											'Add Item'
										),
										_react2.default.createElement(
											'h3',
											{ className: 'col-lg-4 col-md-4 col-sm-3 col-md-offset-2 col-sm-offset-1' },
											'Price'
										)
									)
								) : '',
								_react2.default.createElement(
									'div',
									null,
									this.state.cartcount !== 0 ? wishdeals_list : _react2.default.createElement(
										'div',
										{ className: 'wishlist_emtpy' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/empty_cartbg.png', alt: '...' })
										),
										_react2.default.createElement(
											'h4',
											{ style: { marginBottom: '15px' } },
											'Your Wishlist is Empty'
										),
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: "/web/home", className: 'webwish_shopbtn' },
											'SHOP NOW'
										)
									)
								),
								this.state.page_loading ? _react2.default.createElement(
									'i',
									{ className: 'proLoadImg' },
									_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
								) : '',
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: 'wish_modals', show: this.state.cart_status, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Header,
										{ closeButton: true },
										_react2.default.createElement(
											_reactBootstrap.Modal.Title,
											{ className: 'wishModal_title' },
											'Alert'
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'h4',
											{ className: 'wishModal_h4' },
											this.state.cart_status_msg
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Footer,
										{ className: 'modal_footer' },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ onClick: this.close },
											'Close'
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: 'wish_modals', show: this.state.clearcart_status, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Header,
										{ closeButton: true },
										_react2.default.createElement(
											_reactBootstrap.Modal.Title,
											{ className: 'wishModal_title' },
											'Alert'
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'h4',
											{ className: 'wishModal_h4' },
											'You can\'t have multiple seller items in the cart. Empty existing cart & add this item ',
											this.state.replace_pro_title,
											'?'
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Footer,
										{ className: 'modal_footer' },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ onClick: this.close },
											'NO'
										),
										_react2.default.createElement(
											'a',
											null,
											_react2.default.createElement(
												_reactBootstrap.Button,
												{ onClick: function onClick() {
														_this3.replaceCartItems();
													} },
												'YES'
											)
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: 'wish_modals', show: this.state.cart_added_status, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Header,
										{ closeButton: true },
										_react2.default.createElement(
											_reactBootstrap.Modal.Title,
											{ className: 'wishModal_title' },
											'Alert'
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'h4',
											{ className: 'wishModal_h4' },
											'Product already added to the cart!'
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Footer,
										{ className: 'modal_footer' },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ onClick: this.close },
											'Close'
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: 'wish_modals', show: this.state.emptyCartConfirm, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'h5',
											null,
											'Do you want to remove all items? '
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Footer,
										{ className: 'web_cart_confirm' },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ className: '', onClick: this.close },
											'NO'
										),
										_react2.default.createElement(
											'a',
											null,
											_react2.default.createElement(
												_reactBootstrap.Button,
												{ onClick: function onClick() {
														_this3.emptyWishList();
													} },
												'YES'
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_WebFooter2.default, null)
				);
			}
		}]);
	
		return WebWishList;
	}(_react.Component);
	
	exports.default = WebWishList;

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* eslint-disable */
	/*!
	 * jQuery Validation Plugin v1.17.0
	 *
	 * https://jqueryvalidation.org/
	 *
	 * Copyright (c) 2017 Jörn Zaefferer
	 * Released under the MIT license
	 */
	(function (factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
			module.exports = factory(require("jquery"));
		} else {
			factory(jQuery);
		}
	})(function ($) {
	
		$.extend($.fn, {
	
			// https://jqueryvalidation.org/validate/
			validate: function validate(options) {
	
				// If nothing is selected, return nothing; can't chain anyway
				if (!this.length) {
					if (options && options.debug && window.console) {
						console.warn("Nothing selected, can't validate, returning nothing.");
					}
					return;
				}
	
				// Check if a validator for this form was already created
				var validator = $.data(this[0], "validator");
				if (validator) {
					return validator;
				}
	
				// Add novalidate tag if HTML5.
				this.attr("novalidate", "novalidate");
	
				validator = new $.validator(options, this[0]);
				$.data(this[0], "validator", validator);
	
				if (validator.settings.onsubmit) {
	
					this.on("click.validate", ":submit", function (event) {
	
						// Track the used submit button to properly handle scripted
						// submits later.
						validator.submitButton = event.currentTarget;
	
						// Allow suppressing validation by adding a cancel class to the submit button
						if ($(this).hasClass("cancel")) {
							validator.cancelSubmit = true;
						}
	
						// Allow suppressing validation by adding the html5 formnovalidate attribute to the submit button
						if ($(this).attr("formnovalidate") !== undefined) {
							validator.cancelSubmit = true;
						}
					});
	
					// Validate the form on submit
					this.on("submit.validate", function (event) {
						if (validator.settings.debug) {
	
							// Prevent form submit to be able to see console output
							event.preventDefault();
						}
						function handle() {
							var hidden, result;
	
							// Insert a hidden input as a replacement for the missing submit button
							// The hidden input is inserted in two cases:
							//   - A user defined a `submitHandler`
							//   - There was a pending request due to `remote` method and `stopRequest()`
							//     was called to submit the form in case it's valid
							if (validator.submitButton && (validator.settings.submitHandler || validator.formSubmitted)) {
								hidden = $("<input type='hidden'/>").attr("name", validator.submitButton.name).val($(validator.submitButton).val()).appendTo(validator.currentForm);
							}
	
							if (validator.settings.submitHandler) {
								result = validator.settings.submitHandler.call(validator, validator.currentForm, event);
								if (hidden) {
	
									// And clean up afterwards; thanks to no-block-scope, hidden can be referenced
									hidden.remove();
								}
								if (result !== undefined) {
									return result;
								}
								return false;
							}
							return true;
						}
	
						// Prevent submit for invalid forms or custom submit handlers
						if (validator.cancelSubmit) {
							validator.cancelSubmit = false;
							return handle();
						}
						if (validator.form()) {
							if (validator.pendingRequest) {
								validator.formSubmitted = true;
								return false;
							}
							return handle();
						} else {
							validator.focusInvalid();
							return false;
						}
					});
				}
	
				return validator;
			},
	
			// https://jqueryvalidation.org/valid/
			valid: function valid() {
				var valid, validator, errorList;
	
				if ($(this[0]).is("form")) {
					valid = this.validate().form();
				} else {
					errorList = [];
					valid = true;
					validator = $(this[0].form).validate();
					this.each(function () {
						valid = validator.element(this) && valid;
						if (!valid) {
							errorList = errorList.concat(validator.errorList);
						}
					});
					validator.errorList = errorList;
				}
				return valid;
			},
	
			// https://jqueryvalidation.org/rules/
			rules: function rules(command, argument) {
				var element = this[0],
				    settings,
				    staticRules,
				    existingRules,
				    data,
				    param,
				    filtered;
	
				// If nothing is selected, return empty object; can't chain anyway
				if (element == null) {
					return;
				}
	
				if (!element.form && element.hasAttribute("contenteditable")) {
					element.form = this.closest("form")[0];
					element.name = this.attr("name");
				}
	
				if (element.form == null) {
					return;
				}
	
				if (command) {
					settings = $.data(element.form, "validator").settings;
					staticRules = settings.rules;
					existingRules = $.validator.staticRules(element);
					switch (command) {
						case "add":
							$.extend(existingRules, $.validator.normalizeRule(argument));
	
							// Remove messages from rules, but allow them to be set separately
							delete existingRules.messages;
							staticRules[element.name] = existingRules;
							if (argument.messages) {
								settings.messages[element.name] = $.extend(settings.messages[element.name], argument.messages);
							}
							break;
						case "remove":
							if (!argument) {
								delete staticRules[element.name];
								return existingRules;
							}
							filtered = {};
							$.each(argument.split(/\s/), function (index, method) {
								filtered[method] = existingRules[method];
								delete existingRules[method];
							});
							return filtered;
					}
				}
	
				data = $.validator.normalizeRules($.extend({}, $.validator.classRules(element), $.validator.attributeRules(element), $.validator.dataRules(element), $.validator.staticRules(element)), element);
	
				// Make sure required is at front
				if (data.required) {
					param = data.required;
					delete data.required;
					data = $.extend({ required: param }, data);
				}
	
				// Make sure remote is at back
				if (data.remote) {
					param = data.remote;
					delete data.remote;
					data = $.extend(data, { remote: param });
				}
	
				return data;
			}
		});
	
		// Custom selectors
		$.extend($.expr.pseudos || $.expr[":"], { // '|| $.expr[ ":" ]' here enables backwards compatibility to jQuery 1.7. Can be removed when dropping jQ 1.7.x support
	
			// https://jqueryvalidation.org/blank-selector/
			blank: function blank(a) {
				return !$.trim("" + $(a).val());
			},
	
			// https://jqueryvalidation.org/filled-selector/
			filled: function filled(a) {
				var val = $(a).val();
				return val !== null && !!$.trim("" + val);
			},
	
			// https://jqueryvalidation.org/unchecked-selector/
			unchecked: function unchecked(a) {
				return !$(a).prop("checked");
			}
		});
	
		// Constructor for validator
		$.validator = function (options, form) {
			this.settings = $.extend(true, {}, $.validator.defaults, options);
			this.currentForm = form;
			this.init();
		};
	
		// https://jqueryvalidation.org/jQuery.validator.format/
		$.validator.format = function (source, params) {
			if (arguments.length === 1) {
				return function () {
					var args = $.makeArray(arguments);
					args.unshift(source);
					return $.validator.format.apply(this, args);
				};
			}
			if (params === undefined) {
				return source;
			}
			if (arguments.length > 2 && params.constructor !== Array) {
				params = $.makeArray(arguments).slice(1);
			}
			if (params.constructor !== Array) {
				params = [params];
			}
			$.each(params, function (i, n) {
				source = source.replace(new RegExp("\\{" + i + "\\}", "g"), function () {
					return n;
				});
			});
			return source;
		};
	
		$.extend($.validator, {
	
			defaults: {
				messages: {},
				groups: {},
				rules: {},
				errorClass: "error",
				pendingClass: "pending",
				validClass: "valid",
				errorElement: "label",
				focusCleanup: false,
				focusInvalid: true,
				errorContainer: $([]),
				errorLabelContainer: $([]),
				onsubmit: true,
				ignore: ":hidden",
				ignoreTitle: false,
				onfocusin: function onfocusin(element) {
					this.lastActive = element;
	
					// Hide error label and remove error class on focus if enabled
					if (this.settings.focusCleanup) {
						if (this.settings.unhighlight) {
							this.settings.unhighlight.call(this, element, this.settings.errorClass, this.settings.validClass);
						}
						this.hideThese(this.errorsFor(element));
					}
				},
				onfocusout: function onfocusout(element) {
					if (!this.checkable(element) && (element.name in this.submitted || !this.optional(element))) {
						this.element(element);
					}
				},
				onkeyup: function onkeyup(element, event) {
	
					// Avoid revalidate the field when pressing one of the following keys
					// Shift       => 16
					// Ctrl        => 17
					// Alt         => 18
					// Caps lock   => 20
					// End         => 35
					// Home        => 36
					// Left arrow  => 37
					// Up arrow    => 38
					// Right arrow => 39
					// Down arrow  => 40
					// Insert      => 45
					// Num lock    => 144
					// AltGr key   => 225
					var excludedKeys = [16, 17, 18, 20, 35, 36, 37, 38, 39, 40, 45, 144, 225];
	
					if (event.which === 9 && this.elementValue(element) === "" || $.inArray(event.keyCode, excludedKeys) !== -1) {
						return;
					} else if (element.name in this.submitted || element.name in this.invalid) {
						this.element(element);
					}
				},
				onclick: function onclick(element) {
	
					// Click on selects, radiobuttons and checkboxes
					if (element.name in this.submitted) {
						this.element(element);
	
						// Or option elements, check parent select in that case
					} else if (element.parentNode.name in this.submitted) {
						this.element(element.parentNode);
					}
				},
				highlight: function highlight(element, errorClass, validClass) {
					if (element.type === "radio") {
						this.findByName(element.name).addClass(errorClass).removeClass(validClass);
					} else {
						$(element).addClass(errorClass).removeClass(validClass);
					}
				},
				unhighlight: function unhighlight(element, errorClass, validClass) {
					if (element.type === "radio") {
						this.findByName(element.name).removeClass(errorClass).addClass(validClass);
					} else {
						$(element).removeClass(errorClass).addClass(validClass);
					}
				}
			},
	
			// https://jqueryvalidation.org/jQuery.validator.setDefaults/
			setDefaults: function setDefaults(settings) {
				$.extend($.validator.defaults, settings);
			},
	
			messages: {
				required: "This field is required.",
				remote: "Please fix this field.",
				email: "Please enter a valid email address.",
				url: "Please enter a valid URL.",
				date: "Please enter a valid date.",
				dateISO: "Please enter a valid date (ISO).",
				number: "Please enter a valid number.",
				digits: "Please enter only digits.",
				equalTo: "Please enter the same value again.",
				maxlength: $.validator.format("Please enter no more than {0} characters."),
				minlength: $.validator.format("Please enter at least {0} characters."),
				rangelength: $.validator.format("Please enter a value between {0} and {1} characters long."),
				range: $.validator.format("Please enter a value between {0} and {1}."),
				max: $.validator.format("Please enter a value less than or equal to {0}."),
				min: $.validator.format("Please enter a value greater than or equal to {0}."),
				step: $.validator.format("Please enter a multiple of {0}.")
			},
	
			autoCreateRanges: false,
	
			prototype: {
	
				init: function init() {
					this.labelContainer = $(this.settings.errorLabelContainer);
					this.errorContext = this.labelContainer.length && this.labelContainer || $(this.currentForm);
					this.containers = $(this.settings.errorContainer).add(this.settings.errorLabelContainer);
					this.submitted = {};
					this.valueCache = {};
					this.pendingRequest = 0;
					this.pending = {};
					this.invalid = {};
					this.reset();
	
					var groups = this.groups = {},
					    rules;
					$.each(this.settings.groups, function (key, value) {
						if (typeof value === "string") {
							value = value.split(/\s/);
						}
						$.each(value, function (index, name) {
							groups[name] = key;
						});
					});
					rules = this.settings.rules;
					$.each(rules, function (key, value) {
						rules[key] = $.validator.normalizeRule(value);
					});
	
					function delegate(event) {
	
						// Set form expando on contenteditable
						if (!this.form && this.hasAttribute("contenteditable")) {
							this.form = $(this).closest("form")[0];
							this.name = $(this).attr("name");
						}
	
						var validator = $.data(this.form, "validator"),
						    eventType = "on" + event.type.replace(/^validate/, ""),
						    settings = validator.settings;
						if (settings[eventType] && !$(this).is(settings.ignore)) {
							settings[eventType].call(validator, this, event);
						}
					}
	
					$(this.currentForm).on("focusin.validate focusout.validate keyup.validate", ":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], " + "[type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], " + "[type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], " + "[type='radio'], [type='checkbox'], [contenteditable], [type='button']", delegate)
	
					// Support: Chrome, oldIE
					// "select" is provided as event.target when clicking a option
					.on("click.validate", "select, option, [type='radio'], [type='checkbox']", delegate);
	
					if (this.settings.invalidHandler) {
						$(this.currentForm).on("invalid-form.validate", this.settings.invalidHandler);
					}
				},
	
				// https://jqueryvalidation.org/Validator.form/
				form: function form() {
					this.checkForm();
					$.extend(this.submitted, this.errorMap);
					this.invalid = $.extend({}, this.errorMap);
					if (!this.valid()) {
						$(this.currentForm).triggerHandler("invalid-form", [this]);
					}
					this.showErrors();
					return this.valid();
				},
	
				checkForm: function checkForm() {
					this.prepareForm();
					for (var i = 0, elements = this.currentElements = this.elements(); elements[i]; i++) {
						this.check(elements[i]);
					}
					return this.valid();
				},
	
				// https://jqueryvalidation.org/Validator.element/
				element: function element(_element) {
					var cleanElement = this.clean(_element),
					    checkElement = this.validationTargetFor(cleanElement),
					    v = this,
					    result = true,
					    rs,
					    group;
	
					if (checkElement === undefined) {
						delete this.invalid[cleanElement.name];
					} else {
						this.prepareElement(checkElement);
						this.currentElements = $(checkElement);
	
						// If this element is grouped, then validate all group elements already
						// containing a value
						group = this.groups[checkElement.name];
						if (group) {
							$.each(this.groups, function (name, testgroup) {
								if (testgroup === group && name !== checkElement.name) {
									cleanElement = v.validationTargetFor(v.clean(v.findByName(name)));
									if (cleanElement && cleanElement.name in v.invalid) {
										v.currentElements.push(cleanElement);
										result = v.check(cleanElement) && result;
									}
								}
							});
						}
	
						rs = this.check(checkElement) !== false;
						result = result && rs;
						if (rs) {
							this.invalid[checkElement.name] = false;
						} else {
							this.invalid[checkElement.name] = true;
						}
	
						if (!this.numberOfInvalids()) {
	
							// Hide error containers on last error
							this.toHide = this.toHide.add(this.containers);
						}
						this.showErrors();
	
						// Add aria-invalid status for screen readers
						$(_element).attr("aria-invalid", !rs);
					}
	
					return result;
				},
	
				// https://jqueryvalidation.org/Validator.showErrors/
				showErrors: function showErrors(errors) {
					if (errors) {
						var validator = this;
	
						// Add items to error list and map
						$.extend(this.errorMap, errors);
						this.errorList = $.map(this.errorMap, function (message, name) {
							return {
								message: message,
								element: validator.findByName(name)[0]
							};
						});
	
						// Remove items from success list
						this.successList = $.grep(this.successList, function (element) {
							return !(element.name in errors);
						});
					}
					if (this.settings.showErrors) {
						this.settings.showErrors.call(this, this.errorMap, this.errorList);
					} else {
						this.defaultShowErrors();
					}
				},
	
				// https://jqueryvalidation.org/Validator.resetForm/
				resetForm: function resetForm() {
					if ($.fn.resetForm) {
						$(this.currentForm).resetForm();
					}
					this.invalid = {};
					this.submitted = {};
					this.prepareForm();
					this.hideErrors();
					var elements = this.elements().removeData("previousValue").removeAttr("aria-invalid");
	
					this.resetElements(elements);
				},
	
				resetElements: function resetElements(elements) {
					var i;
	
					if (this.settings.unhighlight) {
						for (i = 0; elements[i]; i++) {
							this.settings.unhighlight.call(this, elements[i], this.settings.errorClass, "");
							this.findByName(elements[i].name).removeClass(this.settings.validClass);
						}
					} else {
						elements.removeClass(this.settings.errorClass).removeClass(this.settings.validClass);
					}
				},
	
				numberOfInvalids: function numberOfInvalids() {
					return this.objectLength(this.invalid);
				},
	
				objectLength: function objectLength(obj) {
					/* jshint unused: false */
					var count = 0,
					    i;
					for (i in obj) {
	
						// This check allows counting elements with empty error
						// message as invalid elements
						if (obj[i] !== undefined && obj[i] !== null && obj[i] !== false) {
							count++;
						}
					}
					return count;
				},
	
				hideErrors: function hideErrors() {
					this.hideThese(this.toHide);
				},
	
				hideThese: function hideThese(errors) {
					errors.not(this.containers).text("");
					this.addWrapper(errors).hide();
				},
	
				valid: function valid() {
					return this.size() === 0;
				},
	
				size: function size() {
					return this.errorList.length;
				},
	
				focusInvalid: function focusInvalid() {
					if (this.settings.focusInvalid) {
						try {
							$(this.findLastActive() || this.errorList.length && this.errorList[0].element || []).filter(":visible").focus()
	
							// Manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
							.trigger("focusin");
						} catch (e) {
	
							// Ignore IE throwing errors when focusing hidden elements
						}
					}
				},
	
				findLastActive: function findLastActive() {
					var lastActive = this.lastActive;
					return lastActive && $.grep(this.errorList, function (n) {
						return n.element.name === lastActive.name;
					}).length === 1 && lastActive;
				},
	
				elements: function elements() {
					var validator = this,
					    rulesCache = {};
	
					// Select all valid inputs inside the form (no submit or reset buttons)
					return $(this.currentForm).find("input, select, textarea, [contenteditable]").not(":submit, :reset, :image, :disabled").not(this.settings.ignore).filter(function () {
						var name = this.name || $(this).attr("name"); // For contenteditable
						if (!name && validator.settings.debug && window.console) {
							console.error("%o has no name assigned", this);
						}
	
						// Set form expando on contenteditable
						if (this.hasAttribute("contenteditable")) {
							this.form = $(this).closest("form")[0];
							this.name = name;
						}
	
						// Select only the first element for each name, and only those with rules specified
						if (name in rulesCache || !validator.objectLength($(this).rules())) {
							return false;
						}
	
						rulesCache[name] = true;
						return true;
					});
				},
	
				clean: function clean(selector) {
					return $(selector)[0];
				},
	
				errors: function errors() {
					var errorClass = this.settings.errorClass.split(" ").join(".");
					return $(this.settings.errorElement + "." + errorClass, this.errorContext);
				},
	
				resetInternals: function resetInternals() {
					this.successList = [];
					this.errorList = [];
					this.errorMap = {};
					this.toShow = $([]);
					this.toHide = $([]);
				},
	
				reset: function reset() {
					this.resetInternals();
					this.currentElements = $([]);
				},
	
				prepareForm: function prepareForm() {
					this.reset();
					this.toHide = this.errors().add(this.containers);
				},
	
				prepareElement: function prepareElement(element) {
					this.reset();
					this.toHide = this.errorsFor(element);
				},
	
				elementValue: function elementValue(element) {
					var $element = $(element),
					    type = element.type,
					    val,
					    idx;
	
					if (type === "radio" || type === "checkbox") {
						return this.findByName(element.name).filter(":checked").val();
					} else if (type === "number" && typeof element.validity !== "undefined") {
						return element.validity.badInput ? "NaN" : $element.val();
					}
	
					if (element.hasAttribute("contenteditable")) {
						val = $element.text();
					} else {
						val = $element.val();
					}
	
					if (type === "file") {
	
						// Modern browser (chrome & safari)
						if (val.substr(0, 12) === "C:\\fakepath\\") {
							return val.substr(12);
						}
	
						// Legacy browsers
						// Unix-based path
						idx = val.lastIndexOf("/");
						if (idx >= 0) {
							return val.substr(idx + 1);
						}
	
						// Windows-based path
						idx = val.lastIndexOf("\\");
						if (idx >= 0) {
							return val.substr(idx + 1);
						}
	
						// Just the file name
						return val;
					}
	
					if (typeof val === "string") {
						return val.replace(/\r/g, "");
					}
					return val;
				},
	
				check: function check(element) {
					element = this.validationTargetFor(this.clean(element));
	
					var rules = $(element).rules(),
					    rulesCount = $.map(rules, function (n, i) {
						return i;
					}).length,
					    dependencyMismatch = false,
					    val = this.elementValue(element),
					    result,
					    method,
					    rule,
					    normalizer;
	
					// Prioritize the local normalizer defined for this element over the global one
					// if the former exists, otherwise user the global one in case it exists.
					if (typeof rules.normalizer === "function") {
						normalizer = rules.normalizer;
					} else if (typeof this.settings.normalizer === "function") {
						normalizer = this.settings.normalizer;
					}
	
					// If normalizer is defined, then call it to retreive the changed value instead
					// of using the real one.
					// Note that `this` in the normalizer is `element`.
					if (normalizer) {
						val = normalizer.call(element, val);
	
						if (typeof val !== "string") {
							throw new TypeError("The normalizer should return a string value.");
						}
	
						// Delete the normalizer from rules to avoid treating it as a pre-defined method.
						delete rules.normalizer;
					}
	
					for (method in rules) {
						rule = { method: method, parameters: rules[method] };
						try {
							result = $.validator.methods[method].call(this, val, element, rule.parameters);
	
							// If a method indicates that the field is optional and therefore valid,
							// don't mark it as valid when there are no other rules
							if (result === "dependency-mismatch" && rulesCount === 1) {
								dependencyMismatch = true;
								continue;
							}
							dependencyMismatch = false;
	
							if (result === "pending") {
								this.toHide = this.toHide.not(this.errorsFor(element));
								return;
							}
	
							if (!result) {
								this.formatAndAdd(element, rule);
								return false;
							}
						} catch (e) {
							if (this.settings.debug && window.console) {
								console.log("Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.", e);
							}
							if (e instanceof TypeError) {
								e.message += ".  Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.";
							}
	
							throw e;
						}
					}
					if (dependencyMismatch) {
						return;
					}
					if (this.objectLength(rules)) {
						this.successList.push(element);
					}
					return true;
				},
	
				// Return the custom message for the given element and validation method
				// specified in the element's HTML5 data attribute
				// return the generic message if present and no method specific message is present
				customDataMessage: function customDataMessage(element, method) {
					return $(element).data("msg" + method.charAt(0).toUpperCase() + method.substring(1).toLowerCase()) || $(element).data("msg");
				},
	
				// Return the custom message for the given element name and validation method
				customMessage: function customMessage(name, method) {
					var m = this.settings.messages[name];
					return m && (m.constructor === String ? m : m[method]);
				},
	
				// Return the first defined argument, allowing empty strings
				findDefined: function findDefined() {
					for (var i = 0; i < arguments.length; i++) {
						if (arguments[i] !== undefined) {
							return arguments[i];
						}
					}
					return undefined;
				},
	
				// The second parameter 'rule' used to be a string, and extended to an object literal
				// of the following form:
				// rule = {
				//     method: "method name",
				//     parameters: "the given method parameters"
				// }
				//
				// The old behavior still supported, kept to maintain backward compatibility with
				// old code, and will be removed in the next major release.
				defaultMessage: function defaultMessage(element, rule) {
					if (typeof rule === "string") {
						rule = { method: rule };
					}
	
					var message = this.findDefined(this.customMessage(element.name, rule.method), this.customDataMessage(element, rule.method),
	
					// 'title' is never undefined, so handle empty string as undefined
					!this.settings.ignoreTitle && element.title || undefined, $.validator.messages[rule.method], "<strong>Warning: No message defined for " + element.name + "</strong>"),
					    theregex = /\$?\{(\d+)\}/g;
					if (typeof message === "function") {
						message = message.call(this, rule.parameters, element);
					} else if (theregex.test(message)) {
						message = $.validator.format(message.replace(theregex, "{$1}"), rule.parameters);
					}
	
					return message;
				},
	
				formatAndAdd: function formatAndAdd(element, rule) {
					var message = this.defaultMessage(element, rule);
	
					this.errorList.push({
						message: message,
						element: element,
						method: rule.method
					});
	
					this.errorMap[element.name] = message;
					this.submitted[element.name] = message;
				},
	
				addWrapper: function addWrapper(toToggle) {
					if (this.settings.wrapper) {
						toToggle = toToggle.add(toToggle.parent(this.settings.wrapper));
					}
					return toToggle;
				},
	
				defaultShowErrors: function defaultShowErrors() {
					var i, elements, error;
					for (i = 0; this.errorList[i]; i++) {
						error = this.errorList[i];
						if (this.settings.highlight) {
							this.settings.highlight.call(this, error.element, this.settings.errorClass, this.settings.validClass);
						}
						this.showLabel(error.element, error.message);
					}
					if (this.errorList.length) {
						this.toShow = this.toShow.add(this.containers);
					}
					if (this.settings.success) {
						for (i = 0; this.successList[i]; i++) {
							this.showLabel(this.successList[i]);
						}
					}
					if (this.settings.unhighlight) {
						for (i = 0, elements = this.validElements(); elements[i]; i++) {
							this.settings.unhighlight.call(this, elements[i], this.settings.errorClass, this.settings.validClass);
						}
					}
					this.toHide = this.toHide.not(this.toShow);
					this.hideErrors();
					this.addWrapper(this.toShow).show();
				},
	
				validElements: function validElements() {
					return this.currentElements.not(this.invalidElements());
				},
	
				invalidElements: function invalidElements() {
					return $(this.errorList).map(function () {
						return this.element;
					});
				},
	
				showLabel: function showLabel(element, message) {
					var place,
					    group,
					    errorID,
					    v,
					    error = this.errorsFor(element),
					    elementID = this.idOrName(element),
					    describedBy = $(element).attr("aria-describedby");
	
					if (error.length) {
	
						// Refresh error/success class
						error.removeClass(this.settings.validClass).addClass(this.settings.errorClass);
	
						// Replace message on existing label
						error.html(message);
					} else {
	
						// Create error element
						error = $("<" + this.settings.errorElement + ">").attr("id", elementID + "-error").addClass(this.settings.errorClass).html(message || "");
	
						// Maintain reference to the element to be placed into the DOM
						place = error;
						if (this.settings.wrapper) {
	
							// Make sure the element is visible, even in IE
							// actually showing the wrapped element is handled elsewhere
							place = error.hide().show().wrap("<" + this.settings.wrapper + "/>").parent();
						}
						if (this.labelContainer.length) {
							this.labelContainer.append(place);
						} else if (this.settings.errorPlacement) {
							this.settings.errorPlacement.call(this, place, $(element));
						} else {
							place.insertAfter(element);
						}
	
						// Link error back to the element
						if (error.is("label")) {
	
							// If the error is a label, then associate using 'for'
							error.attr("for", elementID);
	
							// If the element is not a child of an associated label, then it's necessary
							// to explicitly apply aria-describedby
						} else if (error.parents("label[for='" + this.escapeCssMeta(elementID) + "']").length === 0) {
							errorID = error.attr("id");
	
							// Respect existing non-error aria-describedby
							if (!describedBy) {
								describedBy = errorID;
							} else if (!describedBy.match(new RegExp("\\b" + this.escapeCssMeta(errorID) + "\\b"))) {
	
								// Add to end of list if not already present
								describedBy += " " + errorID;
							}
							$(element).attr("aria-describedby", describedBy);
	
							// If this element is grouped, then assign to all elements in the same group
							group = this.groups[element.name];
							if (group) {
								v = this;
								$.each(v.groups, function (name, testgroup) {
									if (testgroup === group) {
										$("[name='" + v.escapeCssMeta(name) + "']", v.currentForm).attr("aria-describedby", error.attr("id"));
									}
								});
							}
						}
					}
					if (!message && this.settings.success) {
						error.text("");
						if (typeof this.settings.success === "string") {
							error.addClass(this.settings.success);
						} else {
							this.settings.success(error, element);
						}
					}
					this.toShow = this.toShow.add(error);
				},
	
				errorsFor: function errorsFor(element) {
					var name = this.escapeCssMeta(this.idOrName(element)),
					    describer = $(element).attr("aria-describedby"),
					    selector = "label[for='" + name + "'], label[for='" + name + "'] *";
	
					// 'aria-describedby' should directly reference the error element
					if (describer) {
						selector = selector + ", #" + this.escapeCssMeta(describer).replace(/\s+/g, ", #");
					}
	
					return this.errors().filter(selector);
				},
	
				// See https://api.jquery.com/category/selectors/, for CSS
				// meta-characters that should be escaped in order to be used with JQuery
				// as a literal part of a name/id or any selector.
				escapeCssMeta: function escapeCssMeta(string) {
					return string.replace(/([\\!"#$%&'()*+,./:;<=>?@\[\]^`{|}~])/g, "\\$1");
				},
	
				idOrName: function idOrName(element) {
					return this.groups[element.name] || (this.checkable(element) ? element.name : element.id || element.name);
				},
	
				validationTargetFor: function validationTargetFor(element) {
	
					// If radio/checkbox, validate first element in group instead
					if (this.checkable(element)) {
						element = this.findByName(element.name);
					}
	
					// Always apply ignore filter
					return $(element).not(this.settings.ignore)[0];
				},
	
				checkable: function checkable(element) {
					return (/radio|checkbox/i.test(element.type)
					);
				},
	
				findByName: function findByName(name) {
					return $(this.currentForm).find("[name='" + this.escapeCssMeta(name) + "']");
				},
	
				getLength: function getLength(value, element) {
					switch (element.nodeName.toLowerCase()) {
						case "select":
							return $("option:selected", element).length;
						case "input":
							if (this.checkable(element)) {
								return this.findByName(element.name).filter(":checked").length;
							}
					}
					return value.length;
				},
	
				depend: function depend(param, element) {
					return this.dependTypes[typeof param === "undefined" ? "undefined" : _typeof(param)] ? this.dependTypes[typeof param === "undefined" ? "undefined" : _typeof(param)](param, element) : true;
				},
	
				dependTypes: {
					"boolean": function boolean(param) {
						return param;
					},
					"string": function string(param, element) {
						return !!$(param, element.form).length;
					},
					"function": function _function(param, element) {
						return param(element);
					}
				},
	
				optional: function optional(element) {
					var val = this.elementValue(element);
					return !$.validator.methods.required.call(this, val, element) && "dependency-mismatch";
				},
	
				startRequest: function startRequest(element) {
					if (!this.pending[element.name]) {
						this.pendingRequest++;
						$(element).addClass(this.settings.pendingClass);
						this.pending[element.name] = true;
					}
				},
	
				stopRequest: function stopRequest(element, valid) {
					this.pendingRequest--;
	
					// Sometimes synchronization fails, make sure pendingRequest is never < 0
					if (this.pendingRequest < 0) {
						this.pendingRequest = 0;
					}
					delete this.pending[element.name];
					$(element).removeClass(this.settings.pendingClass);
					if (valid && this.pendingRequest === 0 && this.formSubmitted && this.form()) {
						$(this.currentForm).submit();
	
						// Remove the hidden input that was used as a replacement for the
						// missing submit button. The hidden input is added by `handle()`
						// to ensure that the value of the used submit button is passed on
						// for scripted submits triggered by this method
						if (this.submitButton) {
							$("input:hidden[name='" + this.submitButton.name + "']", this.currentForm).remove();
						}
	
						this.formSubmitted = false;
					} else if (!valid && this.pendingRequest === 0 && this.formSubmitted) {
						$(this.currentForm).triggerHandler("invalid-form", [this]);
						this.formSubmitted = false;
					}
				},
	
				previousValue: function previousValue(element, method) {
					method = typeof method === "string" && method || "remote";
	
					return $.data(element, "previousValue") || $.data(element, "previousValue", {
						old: null,
						valid: true,
						message: this.defaultMessage(element, { method: method })
					});
				},
	
				// Cleans up all forms and elements, removes validator-specific events
				destroy: function destroy() {
					this.resetForm();
	
					$(this.currentForm).off(".validate").removeData("validator").find(".validate-equalTo-blur").off(".validate-equalTo").removeClass("validate-equalTo-blur");
				}
	
			},
	
			classRuleSettings: {
				required: { required: true },
				email: { email: true },
				url: { url: true },
				date: { date: true },
				dateISO: { dateISO: true },
				number: { number: true },
				digits: { digits: true },
				creditcard: { creditcard: true }
			},
	
			addClassRules: function addClassRules(className, rules) {
				if (className.constructor === String) {
					this.classRuleSettings[className] = rules;
				} else {
					$.extend(this.classRuleSettings, className);
				}
			},
	
			classRules: function classRules(element) {
				var rules = {},
				    classes = $(element).attr("class");
	
				if (classes) {
					$.each(classes.split(" "), function () {
						if (this in $.validator.classRuleSettings) {
							$.extend(rules, $.validator.classRuleSettings[this]);
						}
					});
				}
				return rules;
			},
	
			normalizeAttributeRule: function normalizeAttributeRule(rules, type, method, value) {
	
				// Convert the value to a number for number inputs, and for text for backwards compability
				// allows type="date" and others to be compared as strings
				if (/min|max|step/.test(method) && (type === null || /number|range|text/.test(type))) {
					value = Number(value);
	
					// Support Opera Mini, which returns NaN for undefined minlength
					if (isNaN(value)) {
						value = undefined;
					}
				}
	
				if (value || value === 0) {
					rules[method] = value;
				} else if (type === method && type !== "range") {
	
					// Exception: the jquery validate 'range' method
					// does not test for the html5 'range' type
					rules[method] = true;
				}
			},
	
			attributeRules: function attributeRules(element) {
				var rules = {},
				    $element = $(element),
				    type = element.getAttribute("type"),
				    method,
				    value;
	
				for (method in $.validator.methods) {
	
					// Support for <input required> in both html5 and older browsers
					if (method === "required") {
						value = element.getAttribute(method);
	
						// Some browsers return an empty string for the required attribute
						// and non-HTML5 browsers might have required="" markup
						if (value === "") {
							value = true;
						}
	
						// Force non-HTML5 browsers to return bool
						value = !!value;
					} else {
						value = $element.attr(method);
					}
	
					this.normalizeAttributeRule(rules, type, method, value);
				}
	
				// 'maxlength' may be returned as -1, 2147483647 ( IE ) and 524288 ( safari ) for text inputs
				if (rules.maxlength && /-1|2147483647|524288/.test(rules.maxlength)) {
					delete rules.maxlength;
				}
	
				return rules;
			},
	
			dataRules: function dataRules(element) {
				var rules = {},
				    $element = $(element),
				    type = element.getAttribute("type"),
				    method,
				    value;
	
				for (method in $.validator.methods) {
					value = $element.data("rule" + method.charAt(0).toUpperCase() + method.substring(1).toLowerCase());
					this.normalizeAttributeRule(rules, type, method, value);
				}
				return rules;
			},
	
			staticRules: function staticRules(element) {
				var rules = {},
				    validator = $.data(element.form, "validator");
	
				if (validator.settings.rules) {
					rules = $.validator.normalizeRule(validator.settings.rules[element.name]) || {};
				}
				return rules;
			},
	
			normalizeRules: function normalizeRules(rules, element) {
	
				// Handle dependency check
				$.each(rules, function (prop, val) {
	
					// Ignore rule when param is explicitly false, eg. required:false
					if (val === false) {
						delete rules[prop];
						return;
					}
					if (val.param || val.depends) {
						var keepRule = true;
						switch (_typeof(val.depends)) {
							case "string":
								keepRule = !!$(val.depends, element.form).length;
								break;
							case "function":
								keepRule = val.depends.call(element, element);
								break;
						}
						if (keepRule) {
							rules[prop] = val.param !== undefined ? val.param : true;
						} else {
							$.data(element.form, "validator").resetElements($(element));
							delete rules[prop];
						}
					}
				});
	
				// Evaluate parameters
				$.each(rules, function (rule, parameter) {
					rules[rule] = $.isFunction(parameter) && rule !== "normalizer" ? parameter(element) : parameter;
				});
	
				// Clean number parameters
				$.each(["minlength", "maxlength"], function () {
					if (rules[this]) {
						rules[this] = Number(rules[this]);
					}
				});
				$.each(["rangelength", "range"], function () {
					var parts;
					if (rules[this]) {
						if ($.isArray(rules[this])) {
							rules[this] = [Number(rules[this][0]), Number(rules[this][1])];
						} else if (typeof rules[this] === "string") {
							parts = rules[this].replace(/[\[\]]/g, "").split(/[\s,]+/);
							rules[this] = [Number(parts[0]), Number(parts[1])];
						}
					}
				});
	
				if ($.validator.autoCreateRanges) {
	
					// Auto-create ranges
					if (rules.min != null && rules.max != null) {
						rules.range = [rules.min, rules.max];
						delete rules.min;
						delete rules.max;
					}
					if (rules.minlength != null && rules.maxlength != null) {
						rules.rangelength = [rules.minlength, rules.maxlength];
						delete rules.minlength;
						delete rules.maxlength;
					}
				}
	
				return rules;
			},
	
			// Converts a simple string to a {string: true} rule, e.g., "required" to {required:true}
			normalizeRule: function normalizeRule(data) {
				if (typeof data === "string") {
					var transformed = {};
					$.each(data.split(/\s/), function () {
						transformed[this] = true;
					});
					data = transformed;
				}
				return data;
			},
	
			// https://jqueryvalidation.org/jQuery.validator.addMethod/
			addMethod: function addMethod(name, method, message) {
				$.validator.methods[name] = method;
				$.validator.messages[name] = message !== undefined ? message : $.validator.messages[name];
				if (method.length < 3) {
					$.validator.addClassRules(name, $.validator.normalizeRule(name));
				}
			},
	
			// https://jqueryvalidation.org/jQuery.validator.methods/
			methods: {
	
				// https://jqueryvalidation.org/required-method/
				required: function required(value, element, param) {
	
					// Check if dependency is met
					if (!this.depend(param, element)) {
						return "dependency-mismatch";
					}
					if (element.nodeName.toLowerCase() === "select") {
	
						// Could be an array for select-multiple or a string, both are fine this way
						var val = $(element).val();
						return val && val.length > 0;
					}
					if (this.checkable(element)) {
						return this.getLength(value, element) > 0;
					}
					return value.length > 0;
				},
	
				// https://jqueryvalidation.org/email-method/
				email: function email(value, element) {
	
					// From https://html.spec.whatwg.org/multipage/forms.html#valid-e-mail-address
					// Retrieved 2014-01-14
					// If you have a problem with this implementation, report a bug against the above spec
					// Or use custom methods to implement your own email validation
					return this.optional(element) || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(value);
				},
	
				// https://jqueryvalidation.org/url-method/
				url: function url(value, element) {
	
					// Copyright (c) 2010-2013 Diego Perini, MIT licensed
					// https://gist.github.com/dperini/729294
					// see also https://mathiasbynens.be/demo/url-regex
					// modified to allow protocol-relative URLs
					return this.optional(element) || /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
				},
	
				// https://jqueryvalidation.org/date-method/
				date: function date(value, element) {
					return this.optional(element) || !/Invalid|NaN/.test(new Date(value).toString());
				},
	
				// https://jqueryvalidation.org/dateISO-method/
				dateISO: function dateISO(value, element) {
					return this.optional(element) || /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(value);
				},
	
				// https://jqueryvalidation.org/number-method/
				number: function number(value, element) {
					return this.optional(element) || /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value);
				},
	
				// https://jqueryvalidation.org/digits-method/
				digits: function digits(value, element) {
					return this.optional(element) || /^\d+$/.test(value);
				},
	
				// https://jqueryvalidation.org/minlength-method/
				minlength: function minlength(value, element, param) {
					var length = $.isArray(value) ? value.length : this.getLength(value, element);
					return this.optional(element) || length >= param;
				},
	
				// https://jqueryvalidation.org/maxlength-method/
				maxlength: function maxlength(value, element, param) {
					var length = $.isArray(value) ? value.length : this.getLength(value, element);
					return this.optional(element) || length <= param;
				},
	
				// https://jqueryvalidation.org/rangelength-method/
				rangelength: function rangelength(value, element, param) {
					var length = $.isArray(value) ? value.length : this.getLength(value, element);
					return this.optional(element) || length >= param[0] && length <= param[1];
				},
	
				// https://jqueryvalidation.org/min-method/
				min: function min(value, element, param) {
					return this.optional(element) || value >= param;
				},
	
				// https://jqueryvalidation.org/max-method/
				max: function max(value, element, param) {
					return this.optional(element) || value <= param;
				},
	
				// https://jqueryvalidation.org/range-method/
				range: function range(value, element, param) {
					return this.optional(element) || value >= param[0] && value <= param[1];
				},
	
				// https://jqueryvalidation.org/step-method/
				step: function step(value, element, param) {
					var type = $(element).attr("type"),
					    errorMessage = "Step attribute on input type " + type + " is not supported.",
					    supportedTypes = ["text", "number", "range"],
					    re = new RegExp("\\b" + type + "\\b"),
					    notSupported = type && !re.test(supportedTypes.join()),
					    decimalPlaces = function decimalPlaces(num) {
						var match = ("" + num).match(/(?:\.(\d+))?$/);
						if (!match) {
							return 0;
						}
	
						// Number of digits right of decimal point.
						return match[1] ? match[1].length : 0;
					},
					    toInt = function toInt(num) {
						return Math.round(num * Math.pow(10, decimals));
					},
					    valid = true,
					    decimals;
	
					// Works only for text, number and range input types
					// TODO find a way to support input types date, datetime, datetime-local, month, time and week
					if (notSupported) {
						throw new Error(errorMessage);
					}
	
					decimals = decimalPlaces(param);
	
					// Value can't have too many decimals
					if (decimalPlaces(value) > decimals || toInt(value) % toInt(param) !== 0) {
						valid = false;
					}
	
					return this.optional(element) || valid;
				},
	
				// https://jqueryvalidation.org/equalTo-method/
				equalTo: function equalTo(value, element, param) {
	
					// Bind to the blur event of the target in order to revalidate whenever the target field is updated
					var target = $(param);
					if (this.settings.onfocusout && target.not(".validate-equalTo-blur").length) {
						target.addClass("validate-equalTo-blur").on("blur.validate-equalTo", function () {
							$(element).valid();
						});
					}
					return value === target.val();
				},
	
				// https://jqueryvalidation.org/remote-method/
				remote: function remote(value, element, param, method) {
					if (this.optional(element)) {
						return "dependency-mismatch";
					}
	
					method = typeof method === "string" && method || "remote";
	
					var previous = this.previousValue(element, method),
					    validator,
					    data,
					    optionDataString;
	
					if (!this.settings.messages[element.name]) {
						this.settings.messages[element.name] = {};
					}
					previous.originalMessage = previous.originalMessage || this.settings.messages[element.name][method];
					this.settings.messages[element.name][method] = previous.message;
	
					param = typeof param === "string" && { url: param } || param;
					optionDataString = $.param($.extend({ data: value }, param.data));
					if (previous.old === optionDataString) {
						return previous.valid;
					}
	
					previous.old = optionDataString;
					validator = this;
					this.startRequest(element);
					data = {};
					data[element.name] = value;
					$.ajax($.extend(true, {
						mode: "abort",
						port: "validate" + element.name,
						dataType: "json",
						data: data,
						context: validator.currentForm,
						success: function success(response) {
							var valid = response === true || response === "true",
							    errors,
							    message,
							    submitted;
	
							validator.settings.messages[element.name][method] = previous.originalMessage;
							if (valid) {
								submitted = validator.formSubmitted;
								validator.resetInternals();
								validator.toHide = validator.errorsFor(element);
								validator.formSubmitted = submitted;
								validator.successList.push(element);
								validator.invalid[element.name] = false;
								validator.showErrors();
							} else {
								errors = {};
								message = response || validator.defaultMessage(element, { method: method, parameters: value });
								errors[element.name] = previous.message = message;
								validator.invalid[element.name] = true;
								validator.showErrors(errors);
							}
							previous.valid = valid;
							validator.stopRequest(element, valid);
						}
					}, param));
					return "pending";
				}
			}
	
		});
	
		// Ajax mode: abort
		// usage: $.ajax({ mode: "abort"[, port: "uniqueport"]});
		// if mode:"abort" is used, the previous request on that port (port can be undefined) is aborted via XMLHttpRequest.abort()
	
		var pendingRequests = {},
		    ajax;
	
		// Use a prefilter if available (1.5+)
		if ($.ajaxPrefilter) {
			$.ajaxPrefilter(function (settings, _, xhr) {
				var port = settings.port;
				if (settings.mode === "abort") {
					if (pendingRequests[port]) {
						pendingRequests[port].abort();
					}
					pendingRequests[port] = xhr;
				}
			});
		} else {
	
			// Proxy ajax
			ajax = $.ajax;
			$.ajax = function (settings) {
				var mode = ("mode" in settings ? settings : $.ajaxSettings).mode,
				    port = ("port" in settings ? settings : $.ajaxSettings).port;
				if (mode === "abort") {
					if (pendingRequests[port]) {
						pendingRequests[port].abort();
					}
					pendingRequests[port] = ajax.apply(this, arguments);
					return pendingRequests[port];
				}
				return ajax.apply(this, arguments);
			};
		}
		return $;
	});

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _footer = __webpack_require__(50);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _close_ad = __webpack_require__(525);
	
	var _close_ad2 = _interopRequireDefault(_close_ad);
	
	var _reactShare = __webpack_require__(18);
	
	var _reactOffcanvas = __webpack_require__(323);
	
	var _ADStores = __webpack_require__(548);
	
	var _ADStores2 = _interopRequireDefault(_ADStores);
	
	var _BannerAds = __webpack_require__(516);
	
	var _BannerAds2 = _interopRequireDefault(_BannerAds);
	
	var _PromotionsNew = __webpack_require__(541);
	
	var _PromotionsNew2 = _interopRequireDefault(_PromotionsNew);
	
	var _BrandStores = __webpack_require__(549);
	
	var _BrandStores2 = _interopRequireDefault(_BrandStores);
	
	var _Recommended = __webpack_require__(542);
	
	var _Recommended2 = _interopRequireDefault(_Recommended);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import HomeAds from './Categories/Common/HomeAds.js';
	
	// import Promotions from './Categories/Promotions/Promotions.js';
	
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var App = function (_Component) {
	    _inherits(App, _Component);
	
	    function App(props) {
	        _classCallCheck(this, App);
	
	        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	        _this.state = {
	            showModal: false,
	            shareModal: false,
	            open: false,
	            isMenuOpened: false,
	            pro_pic: 'default_img.png',
	            name: '',
	            mobile: '',
	            email: '',
	            deal_types: [],
	            cart_count: '',
	            noty_count: '',
	            aquacash: '',
	            bookings: '',
	            smart_cart_flag: '',
	            wishlist_count: '',
	            reg_as_partner: false,
	            is_loaded_dtypes: false
	            // page_loading:true,
	        };
	        _this.modalOpen = _this.modalOpen.bind(_this);
	        _this.close = _this.close.bind(_this);
	        _this.closeModal = _this.closeModal.bind(_this);
	        _this.modalOpen1 = _this.modalOpen1.bind(_this);
	        _this.close1 = _this.close1.bind(_this);
	        _this.closeModal1 = _this.closeModal1.bind(_this);
	        _this.getDeviceId = _this.getDeviceId.bind(_this);
	        _this.getDashboardIcons = _this.getDashboardIcons.bind(_this);
	
	        _this.getCartCount = _this.getCartCount.bind(_this);
	        _this.dashBoard = _this.dashBoard.bind(_this);
	        _this.reg_as_partner_show = _this.reg_as_partner_show.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(App, [{
	        key: 'reg_as_partner_show',
	        value: function reg_as_partner_show() {
	            if (localStorage.user_id) {
	                var uid = localStorage.user_id;
	            } else {
	                uid = 0;
	            }
	            var data1 = { from: 'mobile_web', uid: uid, token: localStorage.token };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                dataType: 'json',
	                url: baseUrl + 'reg_as_partner_show',
	                data: { req: data2 },
	                success: function (data) {
	                    if (data.status === 'success' && data.flag === '1') {
	                        this.setState({
	                            reg_as_partner: true
	                        });
	                    }
	                }.bind(this),
	                error: function error(err) {}
	            });
	        }
	    }, {
	        key: 'dashBoard',
	        value: function dashBoard() {
	            var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'dashboard',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	                    this.setState({
	                        aquacash: data.aquacash,
	                        bookings: data.bookings,
	                        noty_count: data.notifications,
	                        wishlist_count: data.wish_list
	                    });
	                }.bind(this),
	                error: function error(err) {}
	            });
	        }
	    }, {
	        key: 'getCartCount',
	        value: function getCartCount() {
	            var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'cart_count',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	                    if (data.status === 'success') {
	                        this.setState({
	                            cart_count: data.cart_count
	                        });
	                    } else if (data.status === 'error' && data.message === 'Token mismatch') {
	                        localStorage.clear();
	                        window.location.reload();
	                    }
	                }.bind(this),
	                error: function error(err) {}
	            });
	        }
	    }, {
	        key: 'getDashboardIcons',
	        value: function getDashboardIcons() {
	            var data1 = { from: 'mobile_web' };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'post',
	                url: baseUrl + 'dashboard_icons',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function (data) {
	                    this.setState({
	                        deal_types: data.deal_types,
	                        aboutusUrl: data.aboutusUrl,
	                        is_loaded_dtypes: true
	                    });
	                }.bind(this),
	                error: function error(err) {
	                    // this.setState({
	                    //  page_loading:false,
	                    // });
	                }
	            });
	        }
	    }, {
	        key: 'getDeviceId',
	        value: function getDeviceId() {
	            if (localStorage.user_id) {
	                var user_id = localStorage.user_id;
	            } else {
	                user_id = 0;
	            }
	            var data1 = { from: 'mobile_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
	            var data2 = JSON.stringify(data1);
	            _jquery2.default.ajax({
	                method: 'POST',
	                url: baseUrl + 'getDeviceId',
	                dataType: 'json',
	                data: { req: data2 },
	                success: function success(data) {},
	                error: function error(err) {}
	            });
	        }
	    }, {
	        key: 'handleClick',
	        value: function handleClick() {
	            this.setState({ isMenuOpened: !this.state.isMenuOpened });
	        }
	    }, {
	        key: 'modalOpen',
	        value: function modalOpen() {
	            this.setState({ showModal: true });
	        }
	    }, {
	        key: 'closeModal',
	        value: function closeModal() {
	            this.setState({ showModal: false });
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            this.setState({ showModal: false });
	        }
	    }, {
	        key: 'modalOpen1',
	        value: function modalOpen1() {
	            this.setState({ shareModal: true });
	        }
	    }, {
	        key: 'closeModal1',
	        value: function closeModal1() {
	            this.setState({ shareModal: false });
	        }
	    }, {
	        key: 'close1',
	        value: function close1() {
	            this.setState({ shareModal: false });
	        }
	    }, {
	        key: 'logout',
	        value: function logout() {
	            localStorage.clear();
	            window.location.reload();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (screen.width >= 800) {
	                window.location.href = "/web/home";
	            }
	            _jquery2.default.getJSON('https://api.ipify.org?format=json', function (data) {
	                localStorage.setItem('ip', data.ip);
	            });
	            if (localStorage.user_id && localStorage.token) {
	                this.getCartCount();
	                this.dashBoard();
	            }
	            this.reg_as_partner_show();
	
	            localStorage.removeItem('brand_details');
	            localStorage.removeItem('m_r_s_dt');
	            localStorage.removeItem('m_r_e_coupon_dt');
	            localStorage.removeItem('m_r_e_s_dt');
	            localStorage.removeItem('mob_mycart');
	            localStorage.removeItem('m_r_enq_seller_page');
	            localStorage.removeItem('m_r_p_dt');
	            localStorage.removeItem('m_r_e_p_dt');
	            localStorage.removeItem('ofr_page');
	            localStorage.removeItem('profile');
	            localStorage.removeItem('pro_ofr_dtls');
	            localStorage.removeItem('myaquacash');
	            localStorage.removeItem('share_earn');
	            localStorage.removeItem('checkout');
	            localStorage.removeItem('order_details');
	            localStorage.removeItem('my_orders');
	            localStorage.removeItem('m_r_p_deals');
	            localStorage.removeItem('m_r_p_deals');
	            localStorage.removeItem('seed');
	            localStorage.removeItem('nauplii');
	            localStorage.removeItem('subdeals');
	            localStorage.removeItem('myorders');
	            localStorage.removeItem('offers');
	            localStorage.removeItem('shipping');
	            localStorage.removeItem('notifications');
	            localStorage.removeItem('mob_quickcart');
	            localStorage.removeItem('view_rating');
	            localStorage.removeItem('give_rating');
	            localStorage.removeItem('cat_page');
	            localStorage.removeItem('w_r_s_dt');
	            localStorage.removeItem('wishlist');
	            localStorage.removeItem('smartcart');
	            localStorage.removeItem('about_brand');
	
	            localStorage.removeItem('currPath');
	            localStorage.removeItem('w_r_p_dt');
	            localStorage.removeItem('pprice');
	            localStorage.removeItem('sprice');
	            localStorage.removeItem('seed_id');
	            localStorage.removeItem('h_type');
	            localStorage.removeItem('w_r_e_p_dt');
	            localStorage.removeItem('w_r_e_p_dt');
	            localStorage.removeItem('w_r_p_deals');
	            localStorage.removeItem('w_r_seed_deals');
	            localStorage.removeItem('w_modal_details');
	            localStorage.removeItem('m_r_enq_seller_page');
	            localStorage.removeItem('cat_id');
	            localStorage.removeItem('cat');
	            localStorage.removeItem('cat_sort');
	            localStorage.removeItem('url');
	            localStorage.removeItem('mob_mycart');
	            localStorage.removeItem('brand');
	            localStorage.removeItem('sort');
	            localStorage.removeItem('Tid');
	            localStorage.removeItem('type');
	            localStorage.removeItem('d_type');
	            localStorage.removeItem('apply_coupon_code');
	            localStorage.removeItem('apply_coupon');
	            localStorage.removeItem('address_change_flag');
	            localStorage.removeItem('book_date');
	            localStorage.removeItem('seller');
	            localStorage.removeItem('vid');
	
	            this.getDeviceId();
	            this.getDashboardIcons();
	            //this.getDashboardBlocks();
	            if (localStorage.token && localStorage.user_id) {
	                var data1 = { from: 'mobile_web', uid: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
	                var data2 = JSON.stringify(data1);
	                _jquery2.default.ajax({
	                    method: 'post',
	                    url: baseUrl + 'myprofile',
	                    dataType: 'json',
	                    data: { req: data2 },
	                    success: function (data) {
	                        if (data.msg === 'success') {
	                            this.setState({
	                                pro_pic: data.details[0].pro_pic,
	                                name: data.details[0].name,
	                                mobile: data.details[0].mobile,
	                                email: data.details[0].email,
	                                smart_cart_flag: data.smart_cart_flag
	                            });
	                        }
	                        if (data.status === 'error' && data.message === 'Token mismatch') {
	                            localStorage.clear();
	                            window.location.reload();
	                        }
	                    }.bind(this),
	                    error: function error(err) {}
	                });
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            _reactRouter.browserHistory.push('/search');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            document.title = "Online AquaCulture MarketPlace - Find best deals on Seed, Feed, Health Care, Machinery & Farm Equipments, Products, Ropes & Nets Paddle Wheels and More | AquaDeals";
	            document.getElementsByTagName("META")[2].content = "It is a place for deals related to Aqua culture";
	            var shareUrl = "http://tinyurl.com/aquadotdeals";
	            var title = "Download AquaDeals Android app at";
	            var description = "http://tinyurl.com/aquadotdeals";
	            var menu_log = '';
	            if (localStorage.token) {
	                menu_log = _react2.default.createElement(
	                    'li',
	                    { onClick: this.logout.bind(this) },
	                    _react2.default.createElement(
	                        'a',
	                        null,
	                        _react2.default.createElement(
	                            'i',
	                            null,
	                            _react2.default.createElement('img', { src: baseAssets + 'icons/signout.png', alt: '' })
	                        ),
	                        'Logout'
	                    )
	                );
	            } else {
	                menu_log = _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/login' },
	                        _react2.default.createElement(
	                            'i',
	                            null,
	                            _react2.default.createElement('img', { src: baseAssets + 'icons/signin.png', alt: '' })
	                        ),
	                        'Login/Sign Up'
	                    )
	                );
	            }
	            var dboard_icons = this.state.deal_types.map(function (item, index) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: '', style: { paddingTop: '7px', paddingBottom: '7px', overflow: 'hidden' } },
	                    item.dtypes.map(function (x) {
	                        if (x.url_name === 'seed') {
	                            var route = x.url_name;
	                        } else if (x.deal_type === '1') {
	                            route = x.url_name;
	                        } else if (x.url_name === 'Categories') {
	                            route = x.url_name;
	                        } else if (x.deal_type === '8') {
	                            route = '/nauplii';
	                        } else {
	                            route = '/pdeals/' + x.url_name + '/all/' + x.id;
	                        }
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-3 col-md-3' },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: route, className: 'blk_item' },
	                                _react2.default.createElement('img', { src: baseAssets + 'icons/' + x.icon, alt: '' }),
	                                _react2.default.createElement(
	                                    'h6',
	                                    null,
	                                    x.type
	                                )
	                            )
	                        );
	                    })
	                );
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'mob_deals mob_homepage' },
	                _react2.default.createElement(_close_ad2.default, null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page_hdr page_hdr_hme' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container-fluid' },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { onClick: this.handleClick.bind(this), className: 'hm_menu_btn', style: { float: 'left' } },
	                                _react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-hamburger' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'hdr_srch' },
	                            _react2.default.createElement(
	                                'form',
	                                { className: 'navbar-form navbar-left' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-group' },
	                                    _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Search for brands and products', onClick: this.search }),
	                                    _react2.default.createElement('img', { onClick: function onClick() {
	                                            _reactRouter.browserHistory.push('/search');
	                                        }, src: baseAssets + 'images/web_imgs/search.png', width: '15px', className: 'mob_cart_cnt_img', alt: '' })
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { className: 'mob_home_cart_btn', href: '/mycart' },
	                                    _react2.default.createElement('img', { alt: '', src: baseAssets + 'icons/web_icons/cart_icon.png' }),
	                                    this.state.cart_count > 0 ? _react2.default.createElement(
	                                        'span',
	                                        { className: "mob_cart_count1" },
	                                        this.state.cart_count > 9 ? '' : _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            '\xA0'
	                                        ),
	                                        this.state.cart_count
	                                    ) : ''
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { className: 'mob_home_noty_btn', href: '/notifications' },
	                                    _react2.default.createElement('img', { src: baseAssets + 'mob-assets/home_notification_hdr.png', alt: '' }),
	                                    this.state.noty_count > 0 ? _react2.default.createElement(
	                                        'span',
	                                        { className: "mob_noty_count1" },
	                                        this.state.noty_count > 9 ? '' : _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            '\xA0'
	                                        ),
	                                        this.state.noty_count
	                                    ) : ''
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactOffcanvas.OffCanvas,
	                    { width: 250, transitionDuration: 300, isMenuOpened: this.state.isMenuOpened, position: "left" },
	                    _react2.default.createElement(
	                        _reactOffcanvas.OffCanvasMenu,
	                        { className: 'side_menu' },
	                        _react2.default.createElement('span', { className: 'pull-right glyphicon glyphicon-remove-circle', onClick: function onClick() {
	                                _this2.setState({ isMenuOpened: false });
	                            } }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'side_bar_prfil' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'side_bar_prfil_pic' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: "/profile" },
	                                    _react2.default.createElement(_reactBootstrap.Image, { src: baseAssets + 'images/pro_pics/' + this.state.pro_pic, alt: '', circle: true, width: '100%', height: '100%', style: { marginLeft: '0px', marginTop: '0px' } })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                this.state.name ? this.state.name : 'Welcome'
	                            ),
	                            this.state.email ? _react2.default.createElement(
	                                'h6',
	                                null,
	                                this.state.email
	                            ) : ''
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'side_bar_menu' },
	                            _react2.default.createElement(
	                                'ul',
	                                null,
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/myaquacash', title: 'My AquaCash' },
	                                        _react2.default.createElement(
	                                            'i',
	                                            null,
	                                            _react2.default.createElement('img', { src: baseAssets + 'mob-assets/nav_aquacash.png', alt: '' })
	                                        ),
	                                        'My Aquacash',
	                                        this.state.aquacash ? _react2.default.createElement(
	                                            'span',
	                                            { className: 'nav_menu_right' },
	                                            '\u20B9',
	                                            this.state.aquacash
	                                        ) : ''
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/myorders', title: 'My Orders' },
	                                        _react2.default.createElement(
	                                            'i',
	                                            null,
	                                            _react2.default.createElement('img', { src: baseAssets + 'mob-assets/nav_my_bookings.png', alt: '' })
	                                        ),
	                                        'My Orders',
	                                        this.state.bookings ? _react2.default.createElement(
	                                            'span',
	                                            { className: 'nav_menu_right' },
	                                            this.state.bookings
	                                        ) : ''
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/mycart', title: 'My Cart' },
	                                        _react2.default.createElement(
	                                            'i',
	                                            null,
	                                            _react2.default.createElement('img', { src: baseAssets + 'mob-assets/cart_icon.png', alt: '' })
	                                        ),
	                                        'My Cart ',
	                                        this.state.cart_count > 0 ? _react2.default.createElement(
	                                            'span',
	                                            { className: 'nav_menu_right' },
	                                            this.state.cart_count
	                                        ) : ''
	                                    )
	                                ),
	                                this.state.smart_cart_flag === 1 ? _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/smartcart', title: 'Smart Cart' },
	                                        _react2.default.createElement(
	                                            'i',
	                                            null,
	                                            _react2.default.createElement('img', { src: baseAssets + 'mob-assets/cart_icon.png', alt: '' })
	                                        ),
	                                        'Smart Cart'
	                                    )
	                                ) : '',
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/wishlist', title: 'Wish List' },
	                                        _react2.default.createElement(
	                                            'i',
	                                            null,
	                                            _react2.default.createElement('img', { src: baseAssets + 'mob-assets/wishlist_nav.png', alt: '' })
	                                        ),
	                                        'Wishlist ',
	                                        this.state.wishlist_count > 0 ? _react2.default.createElement(
	                                            'span',
	                                            { className: 'nav_menu_right' },
	                                            this.state.wishlist_count
	                                        ) : ''
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: "/profile", title: 'My Profile' },
	                                        _react2.default.createElement(
	                                            'i',
	                                            null,
	                                            _react2.default.createElement('img', { src: baseAssets + 'mob-assets/home_my_profile.png', alt: '' })
	                                        ),
	                                        'My Profile'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/notifications', title: 'Notifications' },
	                                        _react2.default.createElement(
	                                            'i',
	                                            null,
	                                            _react2.default.createElement('img', { src: baseAssets + 'mob-assets/home_notification_hdr.png', alt: '' })
	                                        ),
	                                        'Notifications ',
	                                        this.state.noty_count > 0 ? _react2.default.createElement(
	                                            'span',
	                                            { className: 'nav_menu_right' },
	                                            this.state.noty_count
	                                        ) : ''
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/offerszone', title: 'Offers Zone' },
	                                        _react2.default.createElement(
	                                            'i',
	                                            null,
	                                            _react2.default.createElement('img', { src: baseAssets + 'mob-assets/nav_offers.png', alt: '' })
	                                        ),
	                                        'Offers Zone'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/share_earn', title: 'Share & Earn' },
	                                        _react2.default.createElement(
	                                            'i',
	                                            null,
	                                            _react2.default.createElement('img', { src: baseAssets + 'mob-assets/nav_refer_earn.png', alt: '' })
	                                        ),
	                                        'Share & Earn'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/customer_care', title: 'Customer Care' },
	                                        _react2.default.createElement(
	                                            'i',
	                                            null,
	                                            _react2.default.createElement('img', { src: baseAssets + 'mob-assets/nav_customer_care.png', alt: '' })
	                                        ),
	                                        'Customer Support'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'http://blog.aqua.deals', title: 'AquaDeals Blog', target: '_blank' },
	                                        _react2.default.createElement(
	                                            'i',
	                                            null,
	                                            _react2.default.createElement('img', { src: baseAssets + 'mob-assets/blogger-logo.png', alt: '' })
	                                        ),
	                                        'Blog'
	                                    )
	                                ),
	                                this.state.aboutusUrl !== "" ? _react2.default.createElement(
	                                    'li',
	                                    { onClick: function onClick() {
	                                            _this2.setState({ isMenuOpened: false });
	                                        } },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: this.state.aboutusUrl, title: 'About Us', target: '_blank' },
	                                        _react2.default.createElement(
	                                            'i',
	                                            null,
	                                            _react2.default.createElement('img', { src: __webpack_require__(649), alt: '...' })
	                                        ),
	                                        'About Us'
	                                    )
	                                ) : '',
	                                menu_log,
	                                _react2.default.createElement(
	                                    'p',
	                                    { style: { color: '#666', paddingLeft: '23px', paddingTop: '10px', borderTop: '1px solid #ccc' } },
	                                    'Our Other Apps'
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'https://play.google.com/store/apps/details?id=com.aqua.build', target: '_blank', title: 'AquaBrahma' },
	                                        _react2.default.createElement(
	                                            'i',
	                                            null,
	                                            _react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/ab-lgn.png', alt: '' })
	                                        ),
	                                        'AquaBrahma'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_BannerAds2.default, null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'test_close', onClick: function onClick() {
	                            _this2.setState({ isMenuOpened: false });
	                        } },
	                    this.state.is_loaded_dtypes ? _react2.default.createElement(
	                        'div',
	                        { className: 'hm_main_icons' },
	                        dboard_icons
	                    ) : '',
	                    _react2.default.createElement(
	                        'section',
	                        null,
	                        _react2.default.createElement(_ADStores2.default, null)
	                    ),
	                    _react2.default.createElement(
	                        'section',
	                        null,
	                        _react2.default.createElement(_BrandStores2.default, null)
	                    ),
	                    _react2.default.createElement(_Recommended2.default, null),
	                    _react2.default.createElement(
	                        'section',
	                        { style: { backgroundColor: '#fff', marginTop: '10px' } },
	                        _react2.default.createElement(_PromotionsNew2.default, null)
	                    ),
	                    this.state.reg_as_partner ? _react2.default.createElement(
	                        'section',
	                        { className: 'want_to_sell' },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: "/enquire_now/partner/support/sid/did" },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-2 col-sm-2 col-xs-2', style: { padding: '0px', textAlign: 'center' } },
	                                _react2.default.createElement('img', { src: baseAssets + 'icons/partner.png', alt: '' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-8 col-sm-8 col-xs-8', style: { color: '#666', padding: '0px', position: 'relative', top: '4px' } },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    'REGISTER AS PARTNER'
	                                ),
	                                _react2.default.createElement(
	                                    'h6',
	                                    null,
	                                    'start selling with AquaDeals'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-2 col-sm-2 col-xs-2 pull-right' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'promo_right_arrow_img' },
	                                    _react2.default.createElement('img', { src: baseAssets + 'icons/right_arrow_gray.png', alt: '' })
	                                )
	                            )
	                        )
	                    ) : '',
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal,
	                        { className: 'showModal', show: this.state.showModal, style: { zIndex: '1111' }, onHide: this.close },
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Header,
	                            { closeButton: true },
	                            _react2.default.createElement(
	                                _reactBootstrap.Modal.Title,
	                                { style: { fontSize: '16px', color: '#333' } },
	                                'AquaDeals'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Body,
	                            null,
	                            _react2.default.createElement(
	                                'h4',
	                                { style: { fontSize: '14px', color: '#666' } },
	                                'You need to install Android mobile app to proceed further'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Footer,
	                            { className: 'modal_footer' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { style: { background: '#fff none repeat scroll 0 0', color: '#ff742a' }, onClick: this.closeModal },
	                                'Close'
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en', target: '_blank', title: '' },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    { style: { background: '#ff742a none repeat scroll 0 0', color: '#fff' } },
	                                    'OK'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal,
	                        { className: 'showModal', show: this.state.shareModal, style: { zIndex: '1111' }, onHide: this.close1 },
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Header,
	                            { closeButton: true },
	                            _react2.default.createElement(
	                                _reactBootstrap.Modal.Title,
	                                { style: { fontSize: '16px', color: '#333' } },
	                                'Share AquaDeals App'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Body,
	                            null,
	                            _react2.default.createElement('h4', { style: { fontSize: '14px', color: '#666' } }),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Panel,
	                                    { className: '', style: { marginLeft: '30%' }, collapsible: true, expanded: !this.state.open },
	                                    _react2.default.createElement(
	                                        FacebookShareButton,
	                                        { url: shareUrl, title: title, description: description, className: 'test_share2' },
	                                        _react2.default.createElement(FacebookIcon, { size: 32, round: true })
	                                    ),
	                                    _react2.default.createElement(
	                                        TwitterShareButton,
	                                        { url: shareUrl, title: title, description: description, className: 'test_share2' },
	                                        _react2.default.createElement(TwitterIcon, { size: 32, round: true })
	                                    ),
	                                    _react2.default.createElement(
	                                        GooglePlusShareButton,
	                                        { url: shareUrl, title: title, description: description, className: 'test_share2' },
	                                        _react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Footer,
	                            { className: 'modal_footer' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { style: { background: '#fff none repeat scroll 0 0', color: '#ff742a' }, onClick: this.closeModal1 },
	                                'Close'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var ChangeVerifyOtp = function (_Component) {
		_inherits(ChangeVerifyOtp, _Component);
	
		function ChangeVerifyOtp(props, context) {
			_classCallCheck(this, ChangeVerifyOtp);
	
			var _this = _possibleConstructorReturn(this, (ChangeVerifyOtp.__proto__ || Object.getPrototypeOf(ChangeVerifyOtp)).call(this, props));
	
			_this.state = {
				mobile: localStorage.getItem('mobile_number'),
				invalid_otp: ''
			};
			_this.handleSubmit = _this.handleSubmit.bind(_this);
			_this.gotoLogin = _this.gotoLogin.bind(_this);
			_this.resendOtp = _this.resendOtp.bind(_this);
			return _this;
		}
	
		_createClass(ChangeVerifyOtp, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.refs.otp.focus();
			}
		}, {
			key: 'resendOtp',
			value: function resendOtp() {
	
				var data1 = { from: 'mobile_web', mobile: this.state.mobile };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'resendOtp',
					data: { req: data2 },
					dataType: 'json',
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'handleSubmit',
			value: function handleSubmit(event) {
				event.preventDefault();
				var data1 = { from: 'mobile_web', uid: localStorage.getItem('user_id'), token: localStorage.getItem('token'), mobile: localStorage.getItem('mobile_number'), otp: this.refs.otp.value };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'verifyChangeMobileOtp',
					data: { req: data2 },
					dataType: 'json',
					success: function (data) {
						if (data.status === "success") {
							_reactRouter.browserHistory.push('/profile');
						}
						if (data.status === 'fail') {
							this.setState({
								err: true,
								invalid_otp: 'Invalid Otp'
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'gotoLogin',
			value: function gotoLogin(event) {
				event.preventDefault();
				_reactRouter.browserHistory.push('/login');
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = "Verify OTP | AquaDeals";
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals mob_changenumber_otp_page' },
					_react2.default.createElement(
						'section',
						{ className: 'tot_pag' },
						_react2.default.createElement(
							'div',
							{ className: 'page_hdr' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ onClick: function onClick() {
												_reactRouter.browserHistory.goBack();
											} },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
										)
									),
									'Verify OTP'
								),
								_react2.default.createElement(
									'a',
									{ href: '/', className: 'home_newicon' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
								)
							)
						),
						_react2.default.createElement(
							'section',
							{ className: 'pag_cntnt' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									'div',
									{ className: 'signup_form' },
									_react2.default.createElement(
										'div',
										{ className: '' },
										_react2.default.createElement(
											'div',
											{ className: 'enquire_form signup_blk proced_blk', style: { marginLeft: '20px', marginRight: '20px' } },
											_react2.default.createElement(
												'div',
												{ className: 'newlogin_logo' },
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cc_footer_icon.png', alt: ' ' })
											),
											_react2.default.createElement(
												'form',
												{ className: 'mtrl_elmnts', onSubmit: this.handleSubmit },
												_react2.default.createElement(
													'div',
													{ className: 'col-md-12', style: { marginLeft: '20px', marginRight: '20px' } },
													_react2.default.createElement(
														'div',
														{ className: 'col-md-12' },
														_react2.default.createElement(
															'div',
															{ className: 'group' },
															_react2.default.createElement('input', { type: 'text', ref: 'otp', maxLength: 6, required: true }),
															_react2.default.createElement('span', { className: 'highlight' }),
															_react2.default.createElement('span', { className: 'bar' }),
															this.state.err ? this.state.invalid_otp : '',
															_react2.default.createElement(
																'label',
																null,
																'Enter OTP'
															)
														)
													),
													_react2.default.createElement(
														'button',
														{ onSubmit: this.handleSubmit.bind(this), action: 'submit', className: 'btn mob_social_verifybtn' },
														'Verify ',
														_react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'forgot_pasword verify_blk' },
													_react2.default.createElement(
														'h5',
														null,
														'Didn\'t receive the OTP?'
													),
													_react2.default.createElement(
														'div',
														{ className: 'tap' },
														_react2.default.createElement(
															'a',
															{ style: { cursor: 'pointer' }, onClick: this.resendOtp },
															'Tap here to resend'
														)
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						)
					)
				);
			}
		}]);
	
		return ChangeVerifyOtp;
	}(_react.Component);
	
	exports.default = ChangeVerifyOtp;

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(36);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Otpverify = function (_Component) {
	  _inherits(Otpverify, _Component);
	
	  function Otpverify(props) {
	    _classCallCheck(this, Otpverify);
	
	    var _this = _possibleConstructorReturn(this, (Otpverify.__proto__ || Object.getPrototypeOf(Otpverify)).call(this, props));
	
	    _this.state = {
	      mobile: localStorage.mobile_number
	    };
	    _this.resendOtp = _this.resendOtp.bind(_this);
	    return _this;
	  }
	
	  // componentWillMount(){
	  //   this.props.clear_state();
	  // }
	
	
	  _createClass(Otpverify, [{
	    key: 'resendOtp',
	    value: function resendOtp() {
	      var data1 = { from: 'mobile_web', mobile: this.state.mobile };
	      var data2 = JSON.stringify(data1);
	
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'resendOtp',
	        data: { req: data2 },
	        dataType: 'json',
	        success: function success(data) {},
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refs.otp_input.focus();
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      //this.props.Otpverify(formProps);    
	
	      var mobile = '';
	      if (localStorage.mobile_number) {
	        mobile = localStorage.getItem('mobile_number');
	      } else if (localStorage.mobile) {
	        mobile = localStorage.getItem('mobile');
	      }
	      var pwd = localStorage.getItem('pwd');
	      var data1 = { from: 'mobile_web', mobile: mobile, otp: formProps.otp, pwd: pwd };
	      var data2 = JSON.stringify(data1);
	      if (formProps.otp) {
	        var button = (0, _jquery2.default)('.otp_v');
	        button.html("loading...");
	        button.prop("disabled", true);
	        _jquery2.default.ajax({
	          method: 'POST',
	          url: baseUrl + 'verifyOtp',
	          dataType: 'json',
	          data: { req: data2 },
	          success: function success(data) {
	            button.html("verify");
	            button.prop("disabled", false);
	            if (data.status === 'fail') {
	              (0, _jquery2.default)('#otp_err').text('Invalid verification code');
	            } else if (data.status === 'success') {
	              localStorage.removeItem('pwd');
	              localStorage.setItem('token', data.user[0].token);
	              localStorage.setItem('user_id', data.user[0].id);
	              _reactRouter.browserHistory.push('/');
	              window.location.reload();
	            }
	          },
	          error: function error(err) {
	            button.prop("disabled", false);
	            button.html("verify");
	            console.log("Error" + err);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      (0, _jquery2.default)('#otp_input').keyup(function () {
	        (0, _jquery2.default)('#otp_err').text('');
	      });
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          otp = _props.fields.otp;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'user_form' },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/account', className: 'back_icon' },
	          _react2.default.createElement(
	            'i',
	            null,
	            _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: ' ' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container ot_p pag_cntnt' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row', style: { marginLeft: '0', marginRight: '0' } },
	            _react2.default.createElement(
	              'h5',
	              { className: 'sign_in_title' },
	              'Verify Your Mobile Number'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'otp_number' },
	              'OTP sent to +91 ',
	              this.state.mobile
	            ),
	            _react2.default.createElement(
	              'form',
	              { className: 'text-center otp_form', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	              _react2.default.createElement(
	                'div',
	                { className: 'reg_group' },
	                _react2.default.createElement('input', _extends({}, otp, { type: 'text', id: 'otp_input', required: true, ref: 'otp_input', placeholder: 'Enter OTP' })),
	                _react2.default.createElement('span', { className: 'highlight' }),
	                _react2.default.createElement('span', { className: 'bar' }),
	                _react2.default.createElement('span', { style: { color: 'red', fontSize: '11px' }, id: 'otp_err' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clr' },
	                '\xA0'
	              ),
	              _react2.default.createElement(
	                'button',
	                { action: 'submit', className: 'btn mob_regbtn' },
	                'VERIFY'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clr' },
	                '\xA0'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'tap' },
	                _react2.default.createElement(
	                  'a',
	                  { style: { cursor: 'pointer' }, onClick: this.resendOtp },
	                  'RESEND OTP'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Otpverify;
	}(_react.Component);
	
	function validate(formProps) {
	  var errors = {};
	
	  return errors;
	}
	
	function mapStateToProps(state) {
	  return {
	    errorMessage: state.auth.error,
	    authenticated: state.auth.authenticated,
	    formdata: state.auth.formdata
	  };
	}
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'Otpverify',
	  fields: ['otp'],
	  validate: validate
	
	}, mapStateToProps, actions)(Otpverify);

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(36);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactGoogleLogin = __webpack_require__(322);
	
	var _reactGoogleLogin2 = _interopRequireDefault(_reactGoogleLogin);
	
	var _reactFacebookLogin = __webpack_require__(319);
	
	var _reactFacebookLogin2 = _interopRequireDefault(_reactFacebookLogin);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var responseGoogle = function responseGoogle(response) {
	  console.log(response);
	};
	
	// const responseFacebook = (response) => {
	// console.log(response);
	// }
	
	var Registration = function (_Component) {
	  _inherits(Registration, _Component);
	
	  function Registration(props) {
	    _classCallCheck(this, Registration);
	
	    var _this = _possibleConstructorReturn(this, (Registration.__proto__ || Object.getPrototypeOf(Registration)).call(this, props));
	
	    _this.state = {
	      status: '',
	      msg: '',
	      name: '',
	      email: '',
	      picture: '',
	      id: '',
	      accessToken: '',
	      signedRequest: '',
	      userID: '',
	      expiresIn: '',
	      err_mobile: '',
	
	      g_id: '',
	      g_name: '',
	      g_fname: '',
	      g_picture: '',
	      g_email: '',
	      mobile: '',
	      animate_status: false,
	      animate_social_status: false,
	      social_text: true,
	      sign_text: 'SIGN IN OR REGISTER',
	      placeholder_text: 'Enter your mobile number'
	    };
	    _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
	    _this.getFbData = _this.getFbData.bind(_this);
	    _this.getGoogleData = _this.getGoogleData.bind(_this);
	    _this.mobileChange = _this.mobileChange.bind(_this);
	
	    _this.animateTop = _this.animateTop.bind(_this);
	    _this.animateBottom = _this.animateBottom.bind(_this);
	    _this.animateTop_Social = _this.animateTop_Social.bind(_this);
	    _this.animateBottom_Socail = _this.animateBottom_Social.bind(_this);
	    return _this;
	  }
	
	  _createClass(Registration, [{
	    key: 'animateTop',
	    value: function animateTop() {
	      this.setState({
	        animate_status: true,
	        animate_social_status: false,
	        social_text: false,
	        sign_text: 'Enter your mobile number',
	        placeholder_text: 'Mobile Number'
	      });
	    }
	  }, {
	    key: 'animateBottom',
	    value: function animateBottom() {
	      this.setState({
	        animate_status: false,
	        social_text: true,
	        sign_text: 'SIGN IN OR REGISTER',
	        placeholder_text: 'Enter your mobile number'
	      });
	    }
	  }, {
	    key: 'animateTop_Social',
	    value: function animateTop_Social() {
	      this.setState({
	        // animate_status:true,
	        animate_social_status: true,
	        social_text: true
	      });
	    }
	  }, {
	    key: 'animateBottom_Social',
	    value: function animateBottom_Social() {
	      this.setState({
	        animate_social_status: false
	      });
	    }
	  }, {
	    key: 'mobileChange',
	    value: function mobileChange(e) {
	      var invalidChars = /[^0-9]/gi;
	      if (invalidChars.test(this.refs.mobile.value)) {
	        var valid_number = this.refs.mobile.value.replace(invalidChars, "");
	      }
	      this.setState({
	        mobile: valid_number
	      });
	    }
	  }, {
	    key: 'getFbData',
	    value: function getFbData(res) {
	      this.setState({
	        name: res.name,
	        email: res.email,
	        id: res.id,
	        userId: res.user_id,
	        expiresIn: res.expiresIn,
	        picture: res.picture.data.url
	      });
	      var data1 = { from: 'mobile_web', name: res.name, social_type: '1', email: res.email, device_id: localStorage.getItem('push_device_id'), version: '', platform: '', language: '' };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'post',
	        data: { req: data2 },
	        url: baseUrl + 'social_login',
	        success: function success(data) {
	          data = JSON.parse(data);
	          if (data.status === 'success' && data.page_source === 'dashboard') {
	            localStorage.setItem('token', data.token);
	            localStorage.setItem('user_id', data.uid);
	            localStorage.setItem('f_uid', data.uid);
	            _reactRouter.browserHistory.push('/');
	          } else if (data.status === 'success' && data.page_source === 'mobile_number') {
	            localStorage.setItem('f_uid', data.uid);
	            localStorage.setItem('f_email', data.email);
	            localStorage.setItem('user_id', data.uid);
	            _reactRouter.browserHistory.push('/mobile');
	          } else if (data.status === 'success' && data.page_source === "otp_screen") {
	            localStorage.setItem('mobile_number', data.mobile);
	            _reactRouter.browserHistory.push('/mobile/verify_otp');
	            window.location.reload();
	          }
	        },
	        error: function error(err) {
	          console.log(err);
	        }
	      });
	    }
	  }, {
	    key: 'getGoogleData',
	    value: function getGoogleData(res) {
	      this.setState({
	        g_name: res.profileObj.name,
	        g_email: res.profileObj.email,
	        g_aname: res.profileObj.givenName,
	        id: res.id,
	        g_id: res.El,
	        g_picture: res.profileObj.imageUrl
	      });
	      var data1 = { from: 'mobile_web', name: res.profileObj.name, social_type: '2', email: res.profileObj.email, device_id: localStorage.getItem('push_device_id'), version: '', platform: '', language: '' };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'post',
	        data: { req: data2 },
	        url: baseUrl + 'social_login',
	        success: function success(data) {
	          data = JSON.parse(data);
	          if (data.status === 'success' && data.page_source === 'dashboard') {
	            localStorage.setItem('token', data.token);
	            localStorage.setItem('f_uid', data.uid);
	            localStorage.setItem('user_id', data.uid);
	            _reactRouter.browserHistory.push('/');
	          } else if (data.status === 'success' && data.page_source === 'mobile_number') {
	            localStorage.setItem('f_uid', data.uid);
	            localStorage.setItem('f_email', data.email);
	            localStorage.setItem('user_id', data.uid);
	            _reactRouter.browserHistory.push('/mobile');
	          } else if (data.status === 'success' && data.page_source === "otp_screen") {
	            localStorage.setItem('mobile_number', data.mobile);
	            _reactRouter.browserHistory.push('/mobile/verify_otp');
	            window.location.reload();
	          }
	        },
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'renderAlert',
	    value: function renderAlert() {
	      if (this.props.errorMessage) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'error' },
	          _react2.default.createElement('strong', null),
	          this.props.errorMessage
	        );
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.formdata.status === 'success' && newProps.formdata.page === "otp") {
	        localStorage.setItem('pwd', newProps.formdata.pwd);
	        localStorage.setItem('mobile_number', newProps.formdata.mobile);
	        _reactRouter.browserHistory.push('/Otpverify');
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refs.mobile.focus();
	      if (localStorage.token && localStorage.user_id) {
	        _reactRouter.browserHistory.push('/');
	      }
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      this.props.OTPsent(formProps);
	      this.setState({
	        status: this.props.formdata.status
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // $(window).scrollTop(0);
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          mobile = _props.fields.mobile;
	
	      document.title = "AquaDeals Registration - You find,buy best deals by register with us";
	      document.getElementsByTagName("META")[2].content = "You find,buy best deals by register with us";
	      (0, _jquery2.default)('document').ready(function () {
	        // $('.back_icon').css('opacity',0);
	        // $('.social_back_icon').css('opacity',0);
	        // $('.social_login_items_blk').css('opacity',0);
	        // $('.social_login_items_blk').hide();
	
	        // $('.log_reg').on('click', function(){
	        //     $('.log_reg').addClass('log_top');
	        //     $(this).css('top','80px');
	        //     $('.login_bg').css('background-image','none');
	        //     $('.txt').attr("placeholder", "Mobile Number");
	        //     $('.sign_in_title').text('Enter your mobile number');
	        //     $('.mob_regbtn').show();
	        //     $('.back_icon').css('opacity',1);
	        //     // $('.mob_regbtn').css('opacity',1)
	        //     // $('.social_login_header_blk').css('opacity',0);
	        //     $('.social_login_header_blk').hide();
	        // });
	        // $('.log_reg').on('focusout',function(){
	        //     $('.mob_regbtn').show();
	        //     $('.back_icon').css('opacity',1);
	        // })
	        // $("#new_mob").on('keypress',function() {
	        //     $('#submit').show();
	        //     $('.back_icon').css('opacity',1);
	        // });
	        // $("#new_mob").on('change',function() {
	        //     $('#submit').show();
	        //     $('.back_icon').css('opacity',1);
	        // });
	
	        // $('.mob_regbtn').on('click',function(){
	        //     $('.back_icon').css('opacity',1);
	        // });
	
	        // $(document.body).on('click', '.back_icon' ,function()
	        // {
	        //     $('.log_reg').removeClass('log_top');
	        //     $('.login_bg').css('background-image','url(https://aquadeals.in/admin/assets/images/web_imgs/login_bg.png)');
	        //     $('.mob_regbtn').hide();
	        //     $('.back_icon').css('opacity',0);
	        //     $('.sign_in_title').text('SIGN IN OR REGISTER');
	        //     $('.txt').attr("placeholder", "Enter your mobile number");
	        //     // $('.social_login_header_blk').css('opacity',1);
	        //     $('.social_login_header_blk').show();
	        // });
	
	        // $('.social_login_header').on('click',function(){
	        //       // $('.log_reg').addClass('log_top');
	        //       // $('.social_login_items_blk').css('opacity',1);
	        //       $('.social_login_items_blk').show();
	        //       $('.login_bg').hide();
	        //       $('.login_bg').css('background-image','none');
	        //       $('.log_reg').hide();
	        //       $('.social_back_icon').css('opacity',1);
	        //       $('.social_login_header_blk').css('top','0px','position','relative',);
	        // });
	        // $('.social_back_icon').on('click',function()
	        // {
	        //     $('.login_bg').show();
	        //     $('.log_reg').show();
	        //     $('.log_reg').removeClass('log_top');
	        //     $('.social_back_icon').css('opacity',0);
	        //     // $('.social_login_items_blk').css('opacity',0);
	        //     $('.social_login_items_blk').hide();
	        //     $('.social_login_header_blk').css('top','75px');
	        //     $('.login_bg').css('background-image','url(https://aquadeals.in/admin/assets/images/web_imgs/login_bg.png)');
	        //     $('.mob_regbtn').hide();
	        //     $('.social_login_header_blk').css('opacity',1);
	        // })
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'mob_deals mob_login_page mob_new_login_page' },
	        this.state.animate_social_status ? '' : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: this.state.animate_status ? 'login_bg bgnone' : 'login_bg' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/home', className: 'signin_homeicon' },
	              _react2.default.createElement(
	                'i',
	                null,
	                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/home1.png', alt: '' })
	              )
	            ),
	            this.state.animate_status ? _react2.default.createElement(
	              'span',
	              { className: 'back_icon', onClick: function onClick() {
	                  return _this2.animateBottom();
	                } },
	              _react2.default.createElement(
	                'i',
	                null,
	                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/back_arrow.png', width: '18px', alt: '' })
	              )
	            ) : '',
	            _react2.default.createElement(
	              'div',
	              { className: this.state.animate_status ? 'log_reg log_top' : 'log_reg' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'sign_in_title' },
	                this.state.sign_text
	              ),
	              _react2.default.createElement(
	                'form',
	                { onSubmit: handleSubmit(this.handleFormSubmit.bind(this)), className: 'reg_page_new login_form' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(
	                      'i',
	                      { className: 'ind_flg' },
	                      _react2.default.createElement('img', { className: 'ind_flg_img', src: "https://aquadeals.in/admin/assets/icons/india.png", alt: '' })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { style: { fontFamily: 'robotoregular', fontWeight: 'normal' } },
	                      '+91'
	                    )
	                  ),
	                  _react2.default.createElement('input', _extends({}, mobile, { type: 'text', className: 'txt', placeholder: this.state.placeholder_text, required: true, maxLength: 10, ref: 'mobile', id: 'new_mob', onClick: function onClick() {
	                      return _this2.animateTop();
	                    } })),
	                  _react2.default.createElement('span', { className: 'highlight' }),
	                  _react2.default.createElement('span', { className: 'bar' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'error_mobile' },
	                    mobile.touched && mobile.error ? mobile.error : ''
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'clr' },
	                  '\xA0'
	                ),
	                this.state.animate_status ? _react2.default.createElement(
	                  'div',
	                  { style: { textAlign: 'center' } },
	                  _react2.default.createElement(
	                    'button',
	                    { action: 'submit', id: 'submit', className: 'mob_regbtn' },
	                    'SUBMIT'
	                  )
	                ) : ''
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        !this.state.animate_status && !this.state.animate_social_status ? _react2.default.createElement(
	          'div',
	          { style: { width: '100%', borderBottom: '1px solid #ccc', marginBottom: '10px' } },
	          '\xA0'
	        ) : '',
	        _react2.default.createElement(
	          'section',
	          { className: 'social_login_header_blk container' },
	          _react2.default.createElement(
	            'div',
	            { style: { paddingTop: '5px' } },
	            this.state.animate_social_status ? _react2.default.createElement(
	              'span',
	              { className: 'social_back_icon', onClick: function onClick() {
	                  return _this2.animateBottom_Social();
	                } },
	              _react2.default.createElement(
	                'i',
	                null,
	                _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/back_arrow.png', width: '18px', alt: '' })
	              )
	            ) : '',
	            this.state.animate_social_status ? _react2.default.createElement(
	              'div',
	              { className: 'social_login_items_blk' },
	              _react2.default.createElement(
	                'div',
	                { className: 'social_login_item' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/ab_login' },
	                  _react2.default.createElement(
	                    'button',
	                    { type: 'button', className: 'ab-lgn-btn' },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/ab-lgn.png', alt: '', width: '30px' })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'social_login_text' },
	                      'AquaBrahma'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'social_login_item' },
	                _react2.default.createElement(_reactFacebookLogin2.default, {
	                  appId: '1677330529233582',
	                  textButton: _react2.default.createElement(FbLogo, null),
	                  autoLoad: false,
	                  fields: 'name,email,picture',
	                  callback: this.getFbData,
	                  cssClass: 'fb-lgn-btn'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'social_login_item' },
	                _react2.default.createElement(
	                  _reactGoogleLogin2.default,
	                  { className: 'google-lgn-btn',
	                    clientId: '252840862313-6chaofdjgcq8b9e08gbmevj9pjo9atqe.apps.googleusercontent.com',
	                    onSuccess: this.getGoogleData,
	                    onFailure: responseGoogle,
	                    autoLoad: false
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', { src: baseAssets + "icons/web_icons/g-lgn.png", alt: ' ', width: '30px' })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'social_login_text' },
	                    'Google'
	                  )
	                )
	              )
	            ) : ''
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Registration;
	}(_react.Component);
	
	function validate(formProps) {
	  var errors = {};
	
	  var mobile_Pattern = /^([0-9]){10}$/;
	  if (formProps.mobile && !mobile_Pattern.test(formProps.mobile)) {
	    errors.mobile = 'Enter valid mobile number';
	  }
	  return errors;
	}
	
	function mapStateToProps(state) {
	  return {
	    errorMessage: state.auth.error,
	    authenticated: state.auth.authenticated,
	    formdata: state.auth.formdata
	  };
	}
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'register',
	  fields: ['mobile'],
	  validate: validate
	}, mapStateToProps, actions)(Registration);
	
	var FbLogo = function (_Component2) {
	  _inherits(FbLogo, _Component2);
	
	  function FbLogo() {
	    _classCallCheck(this, FbLogo);
	
	    return _possibleConstructorReturn(this, (FbLogo.__proto__ || Object.getPrototypeOf(FbLogo)).apply(this, arguments));
	  }
	
	  _createClass(FbLogo, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('img', { src: baseAssets + "icons/web_icons/fb-lgn.png", width: '30px', alt: ' ' })
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'social_login_text' },
	          'Facebook'
	        )
	      );
	    }
	  }]);
	
	  return FbLogo;
	}(_react.Component);

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(36);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Signup = function (_Component) {
	  _inherits(Signup, _Component);
	
	  function Signup(props) {
	    _classCallCheck(this, Signup);
	
	    var _this = _possibleConstructorReturn(this, (Signup.__proto__ || Object.getPrototypeOf(Signup)).call(this, props));
	
	    _this.state = {
	      mobile: localStorage.mobile_number,
	      err_email: '',
	      err_tnc: '',
	      ref_status: false
	    };
	    return _this;
	  }
	
	  _createClass(Signup, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.clear_state();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // Load reCAPTCHA script
	      var script = document.createElement('script');
	      script.src = 'https://www.google.com/recaptcha/api.js';
	      script.async = true;
	      script.defer = true;
	      script.onload = function () {
	        return _this2.setState({ recaptchaLoaded: true });
	      };
	      document.body.appendChild(script);
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      var mobile = localStorage.getItem('mobile_number');
	      var data1 = { from: 'mobile_web', mobile: mobile, name: formProps.name, password: formProps.password, email: formProps.email, referral: formProps.refcode, device: '', version: '', platform: '', device_id: localStorage.getItem('push_device_id') };
	      var data2 = JSON.stringify(data1);
	      //this.props.Signup(formProps);
	      var flag = 0;
	      var emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
	      var namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
	      if (formProps.name && !namePattern.test(formProps.name)) {
	        (0, _jquery2.default)('#name_err').text('Enter minimum 3 characters');
	        flag = 1;
	      }
	      if (formProps.password.length < 4) {
	        (0, _jquery2.default)('#pwd_err').text('Minmum 4 characters');
	        flag = 1;
	      }
	      if (formProps.email && !emailPattern.test(formProps.email)) {
	        (0, _jquery2.default)('#email_err').text('Enter a valid email');
	        flag = 1;
	      }
	      if (!formProps.tnc) {
	        (0, _jquery2.default)('#tnc_err').text('Please accept Terms and conditions');
	        flag = 1;
	      }
	      var recaptchaResponse = document.getElementById('g-recaptcha-response').value;;
	
	      if (!recaptchaResponse) {
	        (0, _jquery2.default)('#captcha_err').text('Please complete the reCAPTCHA');
	        flag = 1;
	      }
	      if (flag === 0) {
	        var button = (0, _jquery2.default)('.mob_signup_btn');
	        button.html("loading...");
	        button.prop("disabled", true);
	        _jquery2.default.ajax({
	          method: 'POST',
	          url: baseUrl + 'signup',
	          dataType: 'json',
	          data: { req: data2 },
	          success: function success(data) {
	            button.prop("disabled", false);
	            button.html("creating account");
	            if (data.status === 'referror') {
	              (0, _jquery2.default)("#ref_err").text(data.message);
	            }
	            if (data.status === 'error') {
	              (0, _jquery2.default)("#email_err").text(data.message);
	            }
	            if (data.status === 'success') {
	              localStorage.setItem('pwd', data.pwd);
	              _reactRouter.browserHistory.push('/Otpverify');
	              //window.location.reload();
	            }
	          },
	          error: function error(err) {
	            button.prop("disabled", false);
	            button.html("create account");
	            // console.log("Error"+err);
	          }
	        });
	      }
	      // this.state={
	      //     mobile: localStorage.mobile_number,
	      // }
	    }
	
	    // componentWillReceiveProps(newProps) {
	    //     if (newProps.formdata.status === 'referror') {
	    //         this.setState({
	    //             err_ref: newProps.formdata.message,
	    //         }); 
	    //     }
	    //     if(newProps.formdata.status === 'error'){
	    //         this.setState({
	    //           err_email: newProps.formdata.message,
	    //         });
	    //     }
	    //     if (newProps.formdata.status === 'success') {
	    //         localStorage.setItem('pwd',newProps.formdata.pwd);
	    //         // browserHistory.push('/verify');
	    //     }
	    // }
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      (0, _jquery2.default)('#ref_input').keyup(function () {
	        (0, _jquery2.default)('#ref_err').text('');
	      });
	      (0, _jquery2.default)('#email_input').keyup(function () {
	        (0, _jquery2.default)('#email_err').text('');
	      });
	      (0, _jquery2.default)('#name_input').keyup(function () {
	        (0, _jquery2.default)('#name_err').text('');
	      });
	      (0, _jquery2.default)('#pwd_input').keyup(function () {
	        (0, _jquery2.default)('#pwd_err').text('');
	      });
	      (0, _jquery2.default)('#tnc_input').click(function () {
	        (0, _jquery2.default)('#tnc_err').text('');
	      });
	      (0, _jquery2.default)(document).on('click', '#recaptcha-anchor', function () {
	        (0, _jquery2.default)('#captcha_err').text('');
	      });
	      document.title = "AquaDeals SignUp - You find,buy best deals by sign up with us";
	      document.getElementsByTagName("META")[2].content = "You find,buy best deals by sign up with us";
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          _props$fields = _props.fields,
	          name = _props$fields.name,
	          password = _props$fields.password,
	          email = _props$fields.email,
	          refcode = _props$fields.refcode,
	          tnc = _props$fields.tnc;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'user_form' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/login', className: 'back_icon' },
	            _react2.default.createElement(
	              'i',
	              null,
	              _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'container pag_cntnt' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row', style: { marginLeft: '0', marginRight: '0' } },
	              _react2.default.createElement(
	                'h5',
	                { className: 'sign_in_title' },
	                'Sign Up'
	              ),
	              _react2.default.createElement(
	                'form',
	                { className: 'text-center Regist_form', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)), name: 'login' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'reg_group' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      '+91'
	                    )
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: 'mobile', value: this.state.mobile, required: true }),
	                  _react2.default.createElement('span', { className: 'highlight' }),
	                  _react2.default.createElement('span', { className: 'bar' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'clr' },
	                  '\xA0'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'reg_group' },
	                  _react2.default.createElement('input', _extends({ type: 'text', placeholder: 'Name', id: 'name_input', required: true }, name, { ref: 'name' })),
	                  _react2.default.createElement('span', { className: 'highlight' }),
	                  _react2.default.createElement('span', { className: 'bar' }),
	                  _react2.default.createElement('span', { id: 'name_err' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'clr' },
	                  '\xA0'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'reg_group' },
	                  _react2.default.createElement('input', _extends({ type: 'password', placeholder: 'Password', required: true }, password, { id: 'pwd_input', ref: 'pwd' })),
	                  _react2.default.createElement('span', { className: 'highlight' }),
	                  _react2.default.createElement('span', { className: 'bar' }),
	                  _react2.default.createElement('span', { id: 'pwd_err' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'clr' },
	                  '\xA0'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'reg_group' },
	                  _react2.default.createElement('input', _extends({ placeholder: 'Email (optional)', type: 'text' }, email, { ref: 'email', id: 'email_input' })),
	                  _react2.default.createElement('span', { className: 'highlight' }),
	                  _react2.default.createElement('span', { id: 'email_err' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'clr' },
	                  '\xA0'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ref_code' },
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: function onClick() {
	                        _this3.setState({ ref_status: true });
	                      } },
	                    'Have a referral code?'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'clr' },
	                  '\xA0'
	                ),
	                this.state.ref_status ? _react2.default.createElement(
	                  'div',
	                  { className: 'group form_fields signup_ref_field' },
	                  _react2.default.createElement('input', _extends({ type: 'text', placeholder: 'Referral Code(Optional)', id: 'ref_input' }, refcode, { ref: 'refer' })),
	                  _react2.default.createElement('span', { className: 'highlight' }),
	                  _react2.default.createElement('span', { className: 'bar' }),
	                  _react2.default.createElement('span', { id: 'ref_err' })
	                ) : '',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'terms_check' },
	                    _react2.default.createElement('input', _extends({ type: 'checkbox', value: 'checked' }, tnc, { ref: 'tnc', id: 'tnc_input' })),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'terms_signup_note' },
	                      'I accept & agree '
	                    ),
	                    _react2.default.createElement(
	                      'a',
	                      { target: '_blank', href: 'https://aqua.deals/terms.html' },
	                      'Terms of Services'
	                    ),
	                    _react2.default.createElement('div', { id: 'tnc_err' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'verify_desc' },
	                  'Your mobile number will be verified using an OTP'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'recaptcha-mobile' },
	                  _react2.default.createElement('div', { className: 'g-recaptcha', 'data-sitekey': '6LeoplwUAAAAAIoBTSeogNosrRo_uRpFmJh-e3fr', 'data-size': 'compact' }),
	                  _react2.default.createElement('div', { id: 'captcha_err' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { marginTop: '15px' } },
	                  _react2.default.createElement(
	                    'button',
	                    { action: 'submit', className: 'btn mob_regbtn' },
	                    'SIGN UP'
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Signup;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    errorMessage: state.auth.error,
	    authenticated: state.auth.authenticated,
	    formdata: state.auth.formdata
	  };
	}
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'Otpverify',
	  fields: ['name', 'password', 'email', 'refcode', 'tnc']
	}, mapStateToProps, actions)(Signup);

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Ab_Login = function (_Component) {
		_inherits(Ab_Login, _Component);
	
		function Ab_Login(props, context) {
			_classCallCheck(this, Ab_Login);
	
			var _this = _possibleConstructorReturn(this, (Ab_Login.__proto__ || Object.getPrototypeOf(Ab_Login)).call(this, props));
	
			_this.router = context.router;
			_this.state = {
				err: false,
				err_mob: false,
				err_pass: false,
				invalid_pass: '',
				invalid_num: '',
				ab_modal: false
			};
			_this.handleSubmit = _this.handleSubmit.bind(_this);
			_this.onMobileChange = _this.onMobileChange.bind(_this);
			_this.redLogin = _this.redLogin.bind(_this);
			_this.close = _this.close.bind(_this);
			return _this;
		}
	
		_createClass(Ab_Login, [{
			key: 'close',
			value: function close() {
				this.setState({
					ab_modal: true
				});
			}
		}, {
			key: 'handleSubmit',
			value: function handleSubmit(event) {
				event.preventDefault();
				localStorage.setItem('mobile_number', this.refs.mobile.value);
				var data1 = {
					from: 'mobile_web',
					mobile: this.refs.mobile.value,
					password: this.refs.pass.value,
					device_id: localStorage.getItem('push_device_id'),
					version: '',
					platform: ''
				};
				var data2 = JSON.stringify(data1);
	
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'signupAB',
					data: { req: data2 },
					dataType: 'json',
					success: function (data) {
						if (data.status === 'error' && data.message === "Mobile number already registered with AquaDeals") {
							this.setState({
								ab_modal: true
							});
						}
						if (data.status === 'success') {
							localStorage.setItem('token', data.result[0].token);
							localStorage.setItem('user_id', data.result[0].id);
							_reactRouter.browserHistory.push('/');
						}
						if (data.status === 'error') {
							this.setState({
								err: true,
								invalid_num: data.message
							});
						}
					}.bind(this),
					error: function error(err) {
						// console.log("AB Login Fail"+err);
					}
				});
			}
		}, {
			key: 'redLogin',
			value: function redLogin() {
				_reactRouter.browserHistory.push('/account');
				// window.location.reload();
			}
		}, {
			key: 'onMobileChange',
			value: function onMobileChange(event) {
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					event.target.value = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						err: true
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'user_form' },
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: '/login', className: 'back_icon' },
						_react2.default.createElement(
							'i',
							null,
							_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'container pag_cntnt' },
						_react2.default.createElement(
							'div',
							{ className: 'row', style: { marginLeft: '0', marginRight: '0' } },
							_react2.default.createElement(
								'h5',
								{ className: 'sign_in_title' },
								'AquaBrahma Login'
							),
							_react2.default.createElement(
								'form',
								{ onSubmit: this.handleSubmit, className: 'text-center login_form' },
								_react2.default.createElement(
									'div',
									{ className: 'reg_group' },
									_react2.default.createElement(
										'label',
										null,
										_react2.default.createElement(
											'span',
											null,
											'+91'
										)
									),
									_react2.default.createElement('input', { type: 'text', required: true, placeholder: 'Enter Mobile', ref: 'mobile', maxLength: 10, onChange: this.onMobileChange }),
									_react2.default.createElement('span', { className: 'highlight' }),
									_react2.default.createElement('span', { className: 'bar' }),
									this.state.err ? this.state.invalid_num : ''
								),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									{ className: 'reg_group' },
									_react2.default.createElement('input', { type: 'password', placeholder: 'Password', ref: 'pass', required: true }),
									_react2.default.createElement('span', { className: 'highlight' }),
									_react2.default.createElement('span', { className: 'bar' }),
									this.state.err_pass ? this.state.invalid_pass : ''
								),
								_react2.default.createElement('div', { className: 'clr' }),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								),
								_react2.default.createElement(
									'button',
									{ type: 'submit', className: 'btn mob_regbtn_ablogin', onSubmit: this.handleSubmit },
									'ENTER'
								)
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal,
							{ className: 'ab_login_modal', show: this.state.ab_modal, onHide: this.close },
							_react2.default.createElement(
								_reactBootstrap.Modal.Body,
								null,
								_react2.default.createElement(
									'h4',
									{ style: { fontSize: 14 + 'px', color: '#222' } },
									'You are already registered with AquaDeals.'
								),
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { border: 'none', background: '#fff none repeat scroll 0 0', color: 'green', float: 'right' }, onClick: this.redLogin },
									'OK'
								)
							)
						)
					)
				);
			}
		}]);
	
		return Ab_Login;
	}(_react.Component);
	
	exports.default = Ab_Login;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var ChangeNumber = function (_Component) {
		_inherits(ChangeNumber, _Component);
	
		function ChangeNumber(props) {
			_classCallCheck(this, ChangeNumber);
	
			var _this = _possibleConstructorReturn(this, (ChangeNumber.__proto__ || Object.getPrototypeOf(ChangeNumber)).call(this, props));
	
			_this.state = {
				mobile: '',
				err_mobile: '',
				err_mobile_status: false
			};
			_this.handleSubmit = _this.handleSubmit.bind(_this);
			_this.mobileChange = _this.mobileChange.bind(_this);
			return _this;
		}
	
		_createClass(ChangeNumber, [{
			key: 'handleSubmit',
			value: function handleSubmit(e) {
	
				e.preventDefault();
				var data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, mobile: this.refs.mobile.value };
				var data2 = JSON.stringify(data1);
				localStorage.setItem('mobile_number', this.refs.mobile.value);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'changeMobile',
					data: { req: data2 },
					dataType: 'json',
					success: function (data) {
						// console.log(data);
						if (data.status === "error") {
							this.setState({
								err_mobile_status: true,
								err_mobile: data.msg
							});
						} else {
							this.setState({
								err_mobile_status: false,
								err_mobile: ''
							});
						}
						if (data.status === "success") {
							_reactRouter.browserHistory.push('/verify_otp');
						}
					}.bind(this),
					error: function error(err) {
						// console.log(err);
					}
				});
			}
		}, {
			key: 'mobileChange',
			value: function mobileChange(e) {
				this.setState({
					err_mobile_status: false
				});
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = "Change Number | AquaDeals";
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals mob_numberchng_page' },
					_react2.default.createElement(
						'section',
						{ className: 'tot_pag' },
						_react2.default.createElement(
							'div',
							{ className: 'page_hdr' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: "/profile" },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
										)
									),
									'Change Mobile Number'
								),
								_react2.default.createElement(
									'a',
									{ href: '/', className: 'home_newicon' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'pag_cntnt' },
						_react2.default.createElement(
							'div',
							{ className: 'col-md-6 col-md-offset-3' },
							_react2.default.createElement(
								'div',
								{ className: '' },
								_react2.default.createElement(
									'div',
									{ className: 'enquire_form signup_blk proced_blk' },
									_react2.default.createElement(
										'div',
										{ className: 'clr' },
										'\xA0'
									),
									_react2.default.createElement(
										'div',
										{ className: 'clr' },
										'\xA0'
									),
									_react2.default.createElement(
										'div',
										{ className: 'newlogin_logo' },
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cc_footer_icon.png', alt: ' ' })
									),
									_react2.default.createElement(
										'form',
										{ className: 'mtrl_elmnts', onSubmit: this.handleSubmit.bind(this) },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-12', style: { marginLeft: '40px', marginRight: '40px' } },
											_react2.default.createElement(
												'div',
												{ className: 'group' },
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cell_dl.png', alt: '', style: { position: 'absolute', top: '11px', left: '0px' } }),
												_react2.default.createElement('input', { type: 'text', placeholder: 'Enter Mobile', ref: 'mobile', required: true, maxLength: 10, onChange: this.mobileChange }),
												_react2.default.createElement('span', { className: 'highlight' }),
												_react2.default.createElement('span', { className: 'bar' }),
												_react2.default.createElement(
													'span',
													{ style: { fontSize: '12px', color: 'red' } },
													this.state.err_mobile_status ? this.state.err_mobile : ''
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											),
											_react2.default.createElement(
												'div',
												null,
												_react2.default.createElement(
													'button',
													{ action: 'submit', className: 'btn mob_changenumber_btn' },
													'Verify ',
													_react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
												)
											)
										)
									),
									_react2.default.createElement('div', { className: 'clr' })
								)
							)
						)
					)
				);
			}
		}]);
	
		return ChangeNumber;
	}(_react.Component);
	
	exports.default = ChangeNumber;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Login = function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login(props, context) {
	    _classCallCheck(this, Login);
	
	    // this.router = context.router;
	    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));
	
	    _this.state = {
	      error: false,
	      err: false,
	      err_pass: false,
	      not_reg: '',
	      invalid_pass: '',
	      myNumber: '',
	      pending: '',
	      mobile: localStorage.mobile_number
	    };
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.onMobileChange = _this.onMobileChange.bind(_this);
	    _this.passwordChange = _this.passwordChange.bind(_this);
	    return _this;
	  }
	
	  /* 
	  -> INFORMATION OF LOCAL STORAGE ELEMENTS 
	  m_r_seed_deals => mob_redirection_seed_deals ->Route is /seed/vannamei or tiger / 1 or 10
	  m_r_p_deals => mob_redirection_product_deals ->Route is like /pdeals/feed/br/sdf/sd m_r_e_coupon_dt
	  m_r_s_dt => mob_redirection_seed_full_details page -> Route is like /sdetails/vannamei/10 
	  m_r_p_dt => mob_redirection_product_full_details page -> Route is like pdetails/feed/fish/king-fish-285-2mm/85/577
	  m_r_e_p_dt=>mob_redirection_enquiry_product_fulldetails page -> when click on Enquire Now Button to route to Customer Care Page.
	  m_r_e_s_dt=>mob_redirection_enquire_seed_fulldetails page when click on Enquire Now button in seed details page
	  m_r_e_coupon_dt => mob_redirection_enquire_coupon full details page -> when click on Enquire Now button in Coupon Full Details Page; ->route is like /coupon/details/165
	  */
	
	
	  _createClass(Login, [{
	    key: 'passwordChange',
	    value: function passwordChange() {
	      this.setState({
	        invalid_pass: ''
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (localStorage.token && localStorage.user_id) {
	        _reactRouter.browserHistory.push('/home');
	        // window.location.reload();
	      }
	      this.refs.pass.focus();
	    }
	  }, {
	    key: 'verify_otp',
	    value: function verify_otp() {
	      var data1 = { from: 'mobile_web', mobile: this.state.mobile };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'forgotOtp',
	        data: { req: data2 },
	        dataType: 'json',
	        success: function (data) {
	          if (data.status === "success") {
	            localStorage.setItem('mobile', data.mobile);
	            this.setState({
	              err: false
	            });
	            _reactRouter.browserHistory.push('/verify');
	          } else if (data.status === 'fail') {
	            this.setState({
	              err: true,
	              invalid_num: data.msg
	            });
	          } else if (data.status === 'Mobile number is not registerd with us') {
	            this.setState({
	              err: true,
	              invalid_num: data.status
	            });
	          }
	        }.bind(this),
	        error: function error(err) {
	          // console.log("Forgot Password" + err);
	        }
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(event) {
	      event.preventDefault();
	      if (typeof window.location.pathname.split("/")[2] === "undefined") {
	        var redirect_url = '';
	      } else {
	        var redirect_url = window.location.pathname.split("/")[2];
	      }
	      var data1 = { from: 'mobile_web', mobile: this.refs.mobile.value, password: this.refs.pass.value, device_id: localStorage.getItem('push_device_id'), version: '', platform: '', redirect_url: redirect_url };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'login',
	        data: { req: data2 },
	        dataType: 'json',
	        success: function (data) {
	          if (data.status === "success") {
	            localStorage.setItem('token', data.result[0].token);
	            localStorage.setItem('user_id', data.result[0].id);
	            localStorage.setItem('user_name', data.result[0].name);
	            localStorage.setItem('user_mobile', data.result[0].mobile);
	            localStorage.setItem('user_email', data.result[0].email);
	          }
	          if (data.status === "success" && data.result[0].complete_status === "profile incomplet") {
	            // browserHistory.push('/');
	            // window.location.reload();
	          } else if (data.status === "Verify your mobile") {
	            _reactRouter.browserHistory.push('/Otpverify');
	          } else if (data.status === "Invalid password") {
	            this.setState({
	              err_pass: 'true',
	              invalid_pass: data.status,
	              not_reg: ''
	            });
	          } else if (data.status === "You are not active user. Contact admin.") {
	            this.setState({
	              err_pass: 'true',
	              invalid_pass: data.status,
	              not_reg: ''
	            });
	          } else if (data.status === "Mobile number is not registerd with us") {
	            this.setState({
	              err: 'true',
	              not_reg: data.status,
	              invalid_pass: ''
	            }).bind(this);
	          } else if (data.status === "fail") {
	            this.setState({
	              err: 'true',
	              invalid_pass: '',
	              not_reg: data.message
	            }).bind(this);
	          } else {
	            this.setState({
	              err: 'true',
	              err_pass: 'true'
	
	            });
	          }
	          if (localStorage.token && localStorage.m_r_s_dt) {
	            _reactRouter.browserHistory.push(localStorage.m_r_s_dt);
	          } else if (localStorage.token && localStorage.m_r_e_coupon_dt) {
	            _reactRouter.browserHistory.push(localStorage.m_r_e_coupon_dt);
	          } else if (localStorage.token && localStorage.m_r_e_s_dt) {
	            _reactRouter.browserHistory.push(localStorage.m_r_e_s_dt);
	          } else if (localStorage.token && localStorage.mob_mycart) {
	            _reactRouter.browserHistory.push(localStorage.mob_mycart);
	          } else if (localStorage.token && localStorage.m_r_enq_seller_page) {
	            _reactRouter.browserHistory.push(localStorage.m_r_enq_seller_page);
	          } else if (localStorage.token && localStorage.m_r_p_dt) {
	            _reactRouter.browserHistory.push(localStorage.m_r_p_dt);
	          } else if (localStorage.token && localStorage.m_r_e_p_dt) {
	            _reactRouter.browserHistory.push(localStorage.m_r_e_p_dt);
	          } else if (localStorage.token && localStorage.ofr_page) {
	            _reactRouter.browserHistory.push(localStorage.ofr_page);
	          } else if (localStorage.token && localStorage.profile) {
	            _reactRouter.browserHistory.push(localStorage.profile);
	          } else if (localStorage.token && localStorage.pro_ofr_dtls) {
	            _reactRouter.browserHistory.push(localStorage.pro_ofr_dtls);
	          } else if (localStorage.token && localStorage.myaquacash) {
	            _reactRouter.browserHistory.push(localStorage.myaquacash);
	          } else if (localStorage.token && localStorage.share_earn) {
	            _reactRouter.browserHistory.push(localStorage.share_earn);
	          } else if (localStorage.token && localStorage.checkout) {
	            _reactRouter.browserHistory.push(localStorage.checkout);
	          } else if (localStorage.token && localStorage.order_details) {
	            _reactRouter.browserHistory.push(localStorage.order_details);
	          } else if (localStorage.token && localStorage.my_orders) {
	            _reactRouter.browserHistory.push(localStorage.my_orders);
	          } else if (localStorage.token && localStorage.m_r_p_deals) {
	            _reactRouter.browserHistory.push(localStorage.m_r_p_deals);
	          } else if (localStorage.token && localStorage.seed) {
	            _reactRouter.browserHistory.push(localStorage.seed);
	          } else if (localStorage.token && localStorage.nauplii) {
	            _reactRouter.browserHistory.push(localStorage.nauplii);
	          } else if (localStorage.token && localStorage.subdeals) {
	            _reactRouter.browserHistory.push(localStorage.subdeals);
	          } else if (localStorage.token && localStorage.myorders) {
	            _reactRouter.browserHistory.push(localStorage.myorders);
	          } else if (localStorage.token && localStorage.offers) {
	            _reactRouter.browserHistory.push(localStorage.offers);
	          } else if (localStorage.token && localStorage.shipping) {
	            _reactRouter.browserHistory.push(localStorage.shipping);
	          } else if (localStorage.token && localStorage.notifications) {
	            _reactRouter.browserHistory.push(localStorage.notifications);
	          } else if (localStorage.token && localStorage.mob_quickcart) {
	            _reactRouter.browserHistory.push(localStorage.mob_quickcart);
	          } else if (localStorage.token && localStorage.view_rating) {
	            _reactRouter.browserHistory.push(localStorage.view_rating);
	          } else if (localStorage.token && localStorage.give_rating) {
	            _reactRouter.browserHistory.push(localStorage.give_rating);
	          } else if (localStorage.token && localStorage.wishlist) {
	            _reactRouter.browserHistory.push(localStorage.wishlist);
	          } else if (localStorage.token && localStorage.brand_details) {
	            _reactRouter.browserHistory.push(localStorage.brand_details);
	          } else if (localStorage.token && localStorage.smartcart) {
	            _reactRouter.browserHistory.push(localStorage.smartcart);
	          } else if (localStorage.token && data.status === "success" && !localStorage.m_r_s_dt && !localStorage.m_r_p_dt && !localStorage.m_r_e_s_dt && !localStorage.m_r_e_p_dt && !localStorage.m_r_e_coupon_dt && !localStorage.ofr_page && !localStorage.profile && !localStorage.pro_ofr_dtls && !localStorage.mob_mycart && !localStorage.share_earn && !localStorage.myaquacash && !localStorage.checkout && !localStorage.my_orders && !localStorage.order_details && !localStorage.m_r_p_deals && !localStorage.seed && !localStorage.nauplii && !localStorage.subdeals && !localStorage.offers && !localStorage.myorders && !localStorage.notifications && !localStorage.shipping && !localStorage.mob_quickcart && !localStorage.view_rating && !localStorage.give_rating && !localStorage.wishlist && !localStorage.smartcart && !localStorage.brand_details) {
	            if (data.result[0]['redirect_url'] != "") {
	              _reactRouter.browserHistory.push(data.result[0]['redirect_url']);
	            } else {
	              _reactRouter.browserHistory.push('/home');
	            }
	          }
	          // else
	          // {
	          //   browserHistory.push('/');
	          // }
	        }.bind(this),
	        error: function error(err) {
	          // console.log("Login error" + err);
	        }
	      });
	    }
	  }, {
	    key: 'onMobileChange',
	    value: function onMobileChange(event) {
	      var invalidChars = /[^0-9]/gi;
	      if (invalidChars.test(event.target.value)) {
	        event.target.value = event.target.value.replace(invalidChars, "");
	      } else {
	        this.setState({
	          err: true
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      (0, _jquery2.default)(window).scrollTop(0);
	      document.title = "AquaDeals Login - You find,buy best deals by sign in with us";
	      document.getElementsByTagName("META")[2].content = "You find,buy best deals by sign in with us";
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'user_form' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: 'login', className: 'back_icon' },
	            _react2.default.createElement(
	              'i',
	              null,
	              _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: ' ' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'container pag_cntnt' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row', style: { marginLeft: '0', marginRight: '0' } },
	              _react2.default.createElement(
	                'h5',
	                { className: 'sign_in_title' },
	                'Sign In'
	              ),
	              _react2.default.createElement(
	                'form',
	                { className: 'text-center login_form', onSubmit: this.handleSubmit },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'reg_group' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      '+91'
	                    )
	                  ),
	                  _react2.default.createElement('input', { type: 'text', className: 'txt', placeholder: 'Enter your mobile number', ref: 'mobile', value: this.state.mobile, maxLength: 10, onChange: this.onMobileChange, required: true })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'clr' },
	                  '\xA0'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'reg_group' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement('span', null)
	                  ),
	                  _react2.default.createElement('input', { placeholder: 'Password', type: 'password', ref: 'pass', required: true, onChange: this.passwordChange }),
	                  _react2.default.createElement('span', { className: 'highlight' }),
	                  _react2.default.createElement('span', { className: 'bar' }),
	                  _react2.default.createElement(
	                    'span',
	                    { style: { fontSize: '12px', color: 'red' } },
	                    this.state.err_pass ? this.state.invalid_pass : ''
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'clr' },
	                  '\xA0'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'clr' },
	                  '\xA0'
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'submit', className: 'btn mob_regbtn' },
	                  'ENTER'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'Clr' },
	                  '\xA0'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'forgot_pasword' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tap' },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { style: { cursor: 'pointer' }, onClick: this.verify_otp.bind(this) },
	                      'RESET PASSWORD'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Login;
	}(_react.Component);
	
	exports.default = Login;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(36);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var MobileNumber = function (_Component) {
	  _inherits(MobileNumber, _Component);
	
	  function MobileNumber(props) {
	    _classCallCheck(this, MobileNumber);
	
	    var _this = _possibleConstructorReturn(this, (MobileNumber.__proto__ || Object.getPrototypeOf(MobileNumber)).call(this, props));
	
	    _this.state = {
	      status: '',
	      msg: ''
	    };
	    _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(MobileNumber, [{
	    key: 'renderAlert',
	    value: function renderAlert() {
	      if (this.props.errorMessage) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'error' },
	          _react2.default.createElement('strong', null),
	          this.props.errorMessage
	        );
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.formdata.status === 'success' && newProps.formdata.page === "otp") {
	        localStorage.setItem('pwd', newProps.formdata.pwd);
	        localStorage.setItem('mobile_number', newProps.formdata.mobile);
	        // browserHistory.push('/verify');
	        // window.location.reload();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (localStorage.token && localStorage.user_id) {
	        _reactRouter.browserHistory.push('/');
	      }
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(formProps) {
	      localStorage.setItem('mobile_number', this.refs.mobile_num.value);
	      this.props.mobileNumber(formProps);
	      this.setState({
	        status: this.props.formdata.status
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          mobile = _props.fields.mobile;
	
	      document.title = "AquaDeals Registration - You find,buy best deals by register with us";
	      document.getElementsByTagName("META")[2].content = "You find,buy best deals by register with us";
	      return _react2.default.createElement(
	        'div',
	        { className: 'mob_deals mob_login_page mob_social_loginpage' },
	        _react2.default.createElement(
	          'section',
	          { className: 'tot_pag' },
	          _react2.default.createElement(
	            'div',
	            { className: 'page_hdr' },
	            _react2.default.createElement(
	              'div',
	              { className: 'container' },
	              _react2.default.createElement(
	                'h5',
	                null,
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { onClick: function onClick() {
	                      _reactRouter.browserHistory.goBack();
	                    } },
	                  _react2.default.createElement(
	                    'i',
	                    null,
	                    _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
	                  )
	                ),
	                'Sign In or Register'
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: '/', className: 'home_newicon' },
	                _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: 'pag_cntnt signup_cntnt' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6 col-md-offset-3' },
	              _react2.default.createElement(
	                'div',
	                { className: '' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'enquire_form signup_blk proced_blk', style: { marginLeft: '20px', marginRight: '20px' } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'clr' },
	                    '\xA0'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'newlogin_logo' },
	                    _react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cc_footer_icon.png', alt: ' ' })
	                  ),
	                  _react2.default.createElement(
	                    'form',
	                    { className: 'mtrl_elmnts', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-12' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12 col-sm-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'group' },
	                          _react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cell_dl.png', alt: '', style: { position: 'absolute', top: '11px', left: '0px' } }),
	                          _react2.default.createElement('input', _extends({}, mobile, { type: 'text', placeholder: 'Enter Mobile', required: true, maxLength: 10, ref: 'mobile_num' })),
	                          _react2.default.createElement('span', { className: 'highlight' }),
	                          _react2.default.createElement('span', { className: 'bar' }),
	                          _react2.default.createElement(
	                            'span',
	                            { style: { color: 'red', fontSize: '12px' } },
	                            mobile.touched && mobile.error ? mobile.error : ''
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'clr' },
	                          '\xA0'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'button',
	                            { action: 'submit', className: 'btn mob_social_btn' },
	                            'PROCEED ',
	                            _react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement('div', { className: 'clr' })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MobileNumber;
	}(_react.Component);
	
	function validate(formProps) {
	  var errors = {};
	
	  var mobile_Pattern = /^([0-9]){10}$/;
	  if (formProps.mobile && !mobile_Pattern.test(formProps.mobile)) {
	    errors.mobile = 'Enter valid mobile number';
	  }
	
	  return errors;
	}
	
	function mapStateToProps(state) {
	  return {
	    errorMessage: state.auth.error,
	    authenticated: state.auth.authenticated,
	    formdata: state.auth.formdata
	  };
	}
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'register',
	  fields: ['mobile'],
	  validate: validate
	
	}, mapStateToProps, actions)(MobileNumber);

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var MobVerifyOtp = function (_Component) {
		_inherits(MobVerifyOtp, _Component);
	
		function MobVerifyOtp(props, context) {
			_classCallCheck(this, MobVerifyOtp);
	
			var _this = _possibleConstructorReturn(this, (MobVerifyOtp.__proto__ || Object.getPrototypeOf(MobVerifyOtp)).call(this, props));
	
			_this.state = {
				mobile: localStorage.getItem('mobile_number'),
				invalid_otp: ''
			};
			_this.handleSubmit = _this.handleSubmit.bind(_this);
			_this.gotoLogin = _this.gotoLogin.bind(_this);
			_this.resendOtp = _this.resendOtp.bind(_this);
			return _this;
		}
	
		_createClass(MobVerifyOtp, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.refs.otp.focus();
			}
		}, {
			key: 'resendOtp',
			value: function resendOtp() {
				var data1 = { from: 'mobile_web', mobile: this.state.mobile };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'social_rsend_otp',
					data: { req: data2 },
					dataType: 'json',
					success: function success(data) {
						// console.log(data);
					},
					error: function error(err) {
						// console.log(err);
					}
				});
			}
		}, {
			key: 'handleSubmit',
			value: function handleSubmit(event) {
				event.preventDefault();
				var data1 = { from: 'mobile_web', mobile: localStorage.getItem('mobile_number'), otp: this.refs.otp.value, password: '', device_id: localStorage.getItem('push_device_id'), version: '', platform: '', language: '' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'social_otp_auth',
					data: { req: data2 },
					dataType: 'json',
					success: function (data) {
						if (data.status === 'success' && data.page_source === "dashboard") {
							localStorage.setItem('token', data.token);
							localStorage.setItem('user_id', data.uid);
							_reactRouter.browserHistory.push('/');
						}
						if (data.status === 'error') {
							this.setState({
								err: true,
								invalid_otp: 'OTP mis match'
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'gotoLogin',
			value: function gotoLogin(event) {
				event.preventDefault();
				_reactRouter.browserHistory.push('/login');
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals mob_verify_otp_page' },
					_react2.default.createElement(
						'section',
						{ className: 'tot_pag' },
						_react2.default.createElement(
							'div',
							{ className: 'page_hdr' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ onClick: function onClick() {
												_reactRouter.browserHistory.goBack();
											} },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
										)
									),
									'Verify OTP'
								),
								_react2.default.createElement(
									'a',
									{ href: '/', className: 'home_newicon' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
								)
							)
						),
						_react2.default.createElement(
							'section',
							{ className: 'pag_cntnt' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									'div',
									{ className: 'signup_form' },
									_react2.default.createElement(
										'div',
										{ className: '' },
										_react2.default.createElement(
											'div',
											{ className: 'enquire_form signup_blk proced_blk', style: { marginLeft: '20px', marginRight: '20px' } },
											_react2.default.createElement(
												'div',
												{ className: 'newlogin_logo' },
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cc_footer_icon.png', alt: ' ' })
											),
											_react2.default.createElement(
												'form',
												{ className: 'mtrl_elmnts', onSubmit: this.handleSubmit },
												_react2.default.createElement(
													'div',
													{ className: 'col-md-12', style: { marginLeft: '20px', marginRight: '20px' } },
													_react2.default.createElement(
														'div',
														{ className: 'col-md-12' },
														_react2.default.createElement(
															'div',
															{ className: 'group' },
															_react2.default.createElement('input', { type: 'text', ref: 'otp', maxLength: 6, required: true }),
															_react2.default.createElement('span', { className: 'highlight' }),
															_react2.default.createElement('span', { className: 'bar' }),
															_react2.default.createElement(
																'span',
																{ style: { fontSize: '11px', color: 'red' } },
																this.state.err ? this.state.invalid_otp : ''
															),
															_react2.default.createElement(
																'label',
																null,
																'Enter OTP'
															)
														)
													),
													_react2.default.createElement(
														'button',
														{ onSubmit: this.handleSubmit.bind(this), action: 'submit', className: 'btn mob_social_verifybtn' },
														'Verify ',
														_react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
													)
												),
												_react2.default.createElement(
													'div',
													{ className: 'forgot_pasword verify_blk' },
													_react2.default.createElement(
														'h5',
														null,
														'Didn\'t receive the OTP?'
													),
													_react2.default.createElement(
														'div',
														{ className: 'tap' },
														_react2.default.createElement(
															'a',
															{ style: { cursor: 'pointer' }, onClick: this.resendOtp },
															'Tap here to resend'
														)
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'clr' },
											'\xA0'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						)
					)
				);
			}
		}]);
	
		return MobVerifyOtp;
	}(_react.Component);
	
	exports.default = MobVerifyOtp;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactGeosuggest = __webpack_require__(320);
	
	var _reactGeosuggest2 = _interopRequireDefault(_reactGeosuggest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Profile = function (_Component) {
	  _inherits(Profile, _Component);
	
	  function Profile(props) {
	    _classCallCheck(this, Profile);
	
	    var _this = _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).call(this, props));
	
	    _this.state = {
	      pro_pic: 'default_img.png',
	      full_details: [],
	      name: '',
	      mobile: '',
	      email: '',
	      door_no: '',
	      city: '',
	      file: '',
	      imageUrl: '',
	      otp_flag: '',
	      email_flag: '',
	      editName_status: false,
	      editEmail_status: false,
	      editDoorNo_status: false,
	      err_name: '',
	      err_name_status: false,
	      err_email_status: false,
	      err_email: '',
	      err_door_no_status: false,
	      err_door_no: '',
	      editCityAddress_status: false,
	      err_cityAddress_status: false,
	      err_cityAddress: '',
	
	      pincode: '',
	      err_pincode_status: false,
	      err_pincode_msg: 'Invalid pincode',
	      page_loading: false,
	      delete_img_status: false,
	
	      mob_loading: false
	    };
	    _this.getPhoto = _this.getPhoto.bind(_this);
	    _this.uploadFile = _this.uploadFile.bind(_this);
	    _this.editName = _this.editName.bind(_this);
	    _this.NameChange = _this.NameChange.bind(_this);
	    _this.EmailChange = _this.EmailChange.bind(_this);
	    _this.editEmail = _this.editEmail.bind(_this);
	    _this.editDoorNo = _this.editDoorNo.bind(_this);
	    _this.DoorNoChange = _this.DoorNoChange.bind(_this);
	    _this.saveChanges = _this.saveChanges.bind(_this);
	    _this.submitProfileData = _this.submitProfileData.bind(_this);
	    _this.editCityAddress = _this.editCityAddress.bind(_this);
	    _this.onSuggestSelect = _this.onSuggestSelect.bind(_this);
	    _this.onSelect = _this.onSelect.bind(_this);
	    _this.pincodeChange = _this.pincodeChange.bind(_this);
	
	    _this.getProfileDetails = _this.getProfileDetails.bind(_this);
	    _this.close = _this.close.bind(_this);
	    _this.removeProfilePic = _this.removeProfilePic.bind(_this);
	    _this.tokenCheck = _this.tokenCheck.bind(_this);
	    return _this;
	  }
	
	  _createClass(Profile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (screen.width >= 800) {
	        window.location.href = "/web/profile";
	      }
	      localStorage.removeItem('m_r_s_dt');
	      localStorage.removeItem('m_r_p_dt');
	      localStorage.removeItem('currPath');
	      localStorage.removeItem('seed_id');
	      localStorage.removeItem('cat_page');
	
	      if (!localStorage.token && !localStorage.user_id) {
	        localStorage.setItem('profile', '/profile');
	        _reactRouter.browserHistory.push('/login');
	      } else {
	        this.getProfileDetails();
	      }
	    }
	  }, {
	    key: 'tokenCheck',
	    value: function tokenCheck() {
	      localStorage.removeItem('user_id');
	      localStorage.removeItem('token');
	      _reactRouter.browserHistory.push('/login');
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.setState({
	        delete_img_status: false
	      });
	    }
	  }, {
	    key: 'getProfileDetails',
	    value: function getProfileDetails() {
	      this.setState({
	        mob_loading: true
	      });
	      var data1 = { from: 'mobile_web', uid: localStorage.getItem('user_id'), token: localStorage.getItem('token'), device_id: localStorage.getItem('push_device_id') };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'post',
	        url: baseUrl + 'myprofile',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          if (data.msg === 'success') {
	            this.setState({
	              full_details: data.details,
	              pro_pic: data.details[0].pro_pic,
	              name: data.details[0].name,
	              mobile: data.details[0].mobile,
	              email: data.details[0].email,
	              door_no: data.details[0].address1,
	              city: data.details[0].city,
	              otp_flag: data.details[0].otp_flag,
	              email_flag: data.details[0].email_flag,
	              pincode: data.details[0].zip,
	              mob_loading: false
	            });
	            localStorage.setItem('mobile_number', data.details[0].mobile);
	          }
	          if (data.status === 'error' && data.message === 'Token mismatch') {
	            localStorage.removeItem('token');
	            localStorage.removeItem('user_id');
	            localStorage.setItem('profile', '/profile');
	            _reactRouter.browserHistory.push('/login');
	          }
	          this.setState({
	            mob_loading: false
	          });
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'removeProfilePic',
	    value: function removeProfilePic() {
	      if (localStorage.user_id) {
	        var uid = localStorage.user_id;
	      } else {
	        uid = 0;
	      }
	      this.setState({
	        // page_loading:true,
	        mob_loading: true
	      });
	      var data1 = { from: 'mobile_web', id: uid, token: localStorage.token };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        dataType: 'json',
	        url: baseUrl + 'removePropic',
	        data: { req: data2 },
	        success: function (data) {
	          if (data.status === 'success') {
	            this.setState({
	              delete_img_status: false,
	              // page_loading:false,
	              mob_loading: false
	            });
	            this.getProfileDetails();
	          }
	          if (data.status === 'error' && data.message === 'Token mismatch') {
	            this.setState({
	              // page_loading:false,
	              mob_loading: false
	            });
	            this.tokenCheck();
	          }
	        }.bind(this)
	      });
	    }
	  }, {
	    key: 'pincodeChange',
	    value: function pincodeChange() {
	      // alert(this.refs.pincode.value);
	      var invalidChars = /[^0-9]/gi;
	      if (invalidChars.test(this.refs.pincode.value)) {
	        var x = this.refs.pincode.value.replace(invalidChars, "");
	      } else {
	        this.setState({
	          err_pincode_status: true
	        });
	      }
	      this.setState({
	        pincode: x,
	        err_pincode_status: false
	      });
	      // this.setState({
	      //     pincode:this.refs.pincode.value,
	      //     err_pincode:false,
	      // });
	
	
	      // var invalidChars = /[^0-9]/gi;
	      // if(invalidChars.test(this.refs.pincode.value)) 
	      // {
	      //     var x = this.refs.pincode.value.replace(invalidChars,"");
	      // }
	      // else
	      // {
	      //     this.setState({
	      //       err_pincode: true,
	      //     });
	      // }
	      //   this.setState({
	      //     pincode:x,
	      //     err_pincode:false,
	      //   });
	    }
	  }, {
	    key: 'getPhoto',
	    value: function getPhoto(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      var reader = new FileReader();
	      var file = e.target.files[0];
	      reader.onloadend = function () {
	        _this2.setState({
	          file: file,
	          imageUrl: reader.result
	        }).bind(_this2);
	      };
	      reader.readAsDataURL(file);
	      this.setState({
	        // page_loading:true,
	        mob_loading: true
	      });
	      setTimeout(function () {
	        _this2.uploadFile();
	      }, 5000);
	    }
	  }, {
	    key: 'uploadFile',
	    value: function uploadFile(reader) {
	      this.setState({
	        // page_loading:true,
	        mob_loading: true
	      });
	      var data1 = { from: 'mobile_web', uid: localStorage.getItem('user_id'), image: this.state.imageUrl };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'uploadImage',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          if (data.msg === 'success') {
	            this.getProfileDetails();
	            this.setState({
	              page_loading: false,
	              mob_loading: false
	            });
	          }
	          this.setState({
	            // page_loading:false,
	            mob_loading: false
	          });
	        }.bind(this),
	        error: function error(err) {
	          // console.log(err)
	        }
	      });
	    }
	  }, {
	    key: 'editName',
	    value: function editName(e) {
	      this.setState({
	        editName_status: true,
	        err_name_status: false
	      });
	    }
	  }, {
	    key: 'NameChange',
	    value: function NameChange(e) {
	      this.setState({
	        name: this.refs.e_name.value
	      });
	    }
	  }, {
	    key: 'editEmail',
	    value: function editEmail(e) {
	      this.setState({
	        editEmail_status: true,
	        err_email_status: false
	      });
	    }
	  }, {
	    key: 'EmailChange',
	    value: function EmailChange(e) {
	      this.setState({
	        email: this.refs.e_email.value
	      });
	    }
	  }, {
	    key: 'editDoorNo',
	    value: function editDoorNo(e) {
	      this.setState({
	        editDoorNo_status: true,
	        err_door_no_status: false
	      });
	    }
	  }, {
	    key: 'DoorNoChange',
	    value: function DoorNoChange(e) {
	      this.setState({
	        door_no: this.refs.e_door_no.value
	      });
	    }
	  }, {
	    key: 'editCityAddress',
	    value: function editCityAddress(e) {
	      this.setState({
	        editCityAddress_status: true,
	        err_cityAddress_status: false
	      });
	    }
	  }, {
	    key: 'onSuggestSelect',
	    value: function onSuggestSelect(e) {
	      // console.log(e.label);
	      this.setState({
	        city: e.label
	      });
	    }
	  }, {
	    key: 'onSelect',
	    value: function onSelect(e) {
	      alert(e.label);
	    }
	  }, {
	    key: 'saveChanges',
	    value: function saveChanges(e) {
	      var _this3 = this;
	
	      this.setState({
	        // page_loading:true,
	        mob_loading: true
	      });
	      if (this.state.name.length < 3) {
	        // alert('Minimum 3 Characters');
	        this.setState({
	          err_name_status: true,
	          err_name: 'Minimum 3 Characters'
	        });
	      } else {
	        this.setState({
	          err_name_status: false,
	          err_name: ''
	        });
	        var s_name = this.state.name;
	      }
	      // if(this.state.pincode.length < 6)
	      // {
	      //     this.setState({
	      //       err_pincode_status: true,
	      //       err_pincode_msg:'Invalid pincode',
	      //     });
	      // }
	      if (this.state.email.length > 0) {
	        var emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
	        if (!emailPattern.test(this.state.email)) {
	          // alert('Invalid Email Address');
	          var s_email = '';
	          this.setState({
	            err_email_status: true,
	            err_email: 'Invalid Email Address'
	          });
	        } else {
	          this.setState({
	            err_email_status: false,
	            err_email: ''
	          });
	          s_email = this.state.email;
	        }
	      } else {
	        s_email = '';
	      }
	      // if(this.state.door_no.length < 1)
	      // {
	      //   // alert("Enter Door No");
	      //   this.setState({
	      //       err_door_no_status: true,
	      //       err_door_no: 'Enter Door No',
	      //   });
	      // }
	      // else
	      // {
	      //   // alert("Door No good");
	      //   this.setState({
	      //       err_door_no_status: false,
	      //       err_door_no: '',
	      //   });
	      //   var s_door_no=this.state.door_no;
	      // }
	      if (s_name && !this.state.err_email_status) {
	        // this.submitProfileData(s_name,s_email,s_door_no,)
	        setTimeout(function () {
	          _this3.submitProfileData(s_name, s_email);
	        }, 3000);
	      } else {
	        alert('Please fill the details');
	      }
	    }
	  }, {
	    key: 'submitProfileData',
	    value: function submitProfileData(s_name, s_email, s_door_no) {
	      this.setState({
	        mob_loading: true
	      });
	      var data1 = { from: 'mobile_web', uid: localStorage.getItem('user_id'), name: s_name, email: s_email, add1: '', city: this.state.city, dist: '', state: '', zip: this.refs.pincode.value };
	      var data2 = JSON.stringify(data1);
	      if (!this.state.err_email_status) {
	        _jquery2.default.ajax({
	          method: 'POST',
	          url: baseUrl + 'myprofile_save',
	          dataType: 'json',
	          data: { req: data2 },
	          success: function (data) {
	            // console.log(data);
	            if (data.status === "success") {
	              this.setState({
	                mob_loading: false
	              });
	              _reactRouter.browserHistory.push('/');
	            } else {
	              this.setState({
	                page_loading: false,
	                mob_loading: false
	              });
	            }
	          }.bind(this),
	          error: function error(err) {}
	        });
	      } else {
	        console.log('Please fill the details');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      (0, _jquery2.default)('#profile_email').unbind("keyup").keyup(function () {
	        (0, _jquery2.default)('.email_verify').hide();
	      });
	      document.title = "My Profile | AquaDeals";
	      var fixtures = [{ label: 'Kakinada, Andhra Pradesh, India', location: { lat: 16.9890648, lng: 82.24746479999999 } }, { label: 'Bhimavaram, Andhra Pradesh, India', location: { lat: 16.544893, lng: 81.52124100000003 } }, { label: 'Samalkota, Andhra Pradesh, India', location: { lat: 17.0504374, lng: 82.16592430000003 } }, { label: 'Amalapuram, Andhra Pradesh, India', location: { lat: 16.5720904, lng: 82.00085480000007 } }];
	      return _react2.default.createElement(
	        'div',
	        { className: 'mob_deals mob_profile_page' },
	        _react2.default.createElement(
	          'section',
	          { className: 'tot_pag' },
	          _react2.default.createElement(
	            'div',
	            { className: 'page_hdr' },
	            _react2.default.createElement(
	              'div',
	              { className: 'container' },
	              _react2.default.createElement(
	                'h5',
	                null,
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: "/" },
	                  _react2.default.createElement(
	                    'i',
	                    null,
	                    _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', className: 'cross_icon', width: '18px', alt: '' })
	                  )
	                ),
	                'My Profile'
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: '/', className: 'home_logo1' },
	                _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
	              )
	            )
	          )
	        ),
	        this.state.mob_loading ? _react2.default.createElement(
	          'div',
	          { className: 'mob_loading' },
	          _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/mob_loading.gif', alt: 'Loading' })
	        ) : '',
	        _react2.default.createElement(
	          'section',
	          { className: 'container-fluid pro_img_blk' },
	          _react2.default.createElement(
	            'form',
	            { action: '', encType: 'multipart/form-data' },
	            this.state.pro_pic === 'default_img.png' ? _react2.default.createElement(
	              'label',
	              { 'for': 'image_edit', className: 'edit_pro_img' },
	              _react2.default.createElement('input', { type: 'file', name: 'image_edit', id: 'image_edit', style: { display: 'none' }, onChange: this.getPhoto }),
	              _react2.default.createElement(_reactBootstrap.Image, { src: baseAssets + 'mob-assets/cam_profile.png', alt: '', className: 'mob_edit_pro', style: { marginRight: '10px', marginTop: '25px' } })
	            ) : _react2.default.createElement(
	              'label',
	              { 'for': 'image_edit', className: 'delete_pro_img', onClick: function onClick() {
	                  _this4.setState({ delete_img_status: true });
	                } },
	              _react2.default.createElement(_reactBootstrap.Image, { src: baseAssets + 'mob-assets/cam_remove_pic.png', alt: '', className: 'mob_edit_pro', style: { marginRight: '10px', marginTop: '15px' } })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row mob_pro_img_blk side_bar_prfil' },
	            _react2.default.createElement(
	              'form',
	              { action: '', encType: 'multipart/form-data' },
	              _react2.default.createElement(
	                'div',
	                { className: 'mob_pro_img side_bar_prfil_pic' },
	                _react2.default.createElement(
	                  'label',
	                  { 'for': 'image' },
	                  _react2.default.createElement('input', { type: 'file', name: 'image', id: 'image', style: { display: 'none' }, onChange: this.getPhoto }),
	                  _react2.default.createElement(_reactBootstrap.Image, { src: baseAssets + 'images/pro_pics/' + this.state.pro_pic, alt: '', circle: true, width: '110%', height: '106%', style: { marginLeft: '-4px', marginTop: '-3px' } })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 mob_pro_dtls_blk' },
	            _react2.default.createElement(
	              'h4',
	              { className: 'per_info_title' },
	              'Personal Information'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mob_psl_info_blk row' },
	              _react2.default.createElement(
	                'h5',
	                { onClick: this.editName, style: { paddingLeft: '15px' } },
	                this.state.name && !this.state.editName_status ? this.state.name : _react2.default.createElement('input', { type: 'text', ref: 'e_name', placeholder: 'Name', value: this.state.name, onChange: this.NameChange, style: { border: 'none', textDecoration: 'underline', width: '100%' } }),
	                _react2.default.createElement(
	                  'span',
	                  { style: { color: 'red', fontSize: '12px' } },
	                  ' ',
	                  this.state.err_name_status ? this.state.err_name : ''
	                )
	              ),
	              _react2.default.createElement(
	                'h5',
	                { style: { paddingLeft: '15px' } },
	                this.state.mobile ? this.state.mobile : 'Mobile',
	                ' ',
	                this.state.otp_flag === '1' ? _react2.default.createElement(
	                  'span',
	                  { className: 'pro_num_status_img' },
	                  _react2.default.createElement('img', { src: baseAssets + 'mob-assets/ok.png', alt: '' })
	                ) : _react2.default.createElement('span', { className: 'pro_num_status' })
	              ),
	              _react2.default.createElement(
	                'h5',
	                { style: { paddingLeft: '15px' }, onClick: this.editEmail },
	                this.state.email && !this.state.editEmail_status ? this.state.email : _react2.default.createElement('input', { type: 'mail', ref: 'e_email', placeholder: 'Email(Optional)', value: this.state.email, onChange: this.EmailChange, style: { border: 'none', textDecoration: 'none', width: '70%' }, id: 'profile_email' }),
	                ' ',
	                this.state.email_flag === '1' && this.state.email != '' ? _react2.default.createElement(
	                  'span',
	                  { className: 'pro_num_status_img' },
	                  _react2.default.createElement('img', { src: baseAssets + 'mob-assets/ok.png', alt: '' })
	                ) : _react2.default.createElement('span', { className: 'pro_num_status' }),
	                _react2.default.createElement(
	                  'span',
	                  { style: { color: 'red', fontSize: '12px' } },
	                  this.state.err_email_status ? this.state.err_email : ''
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'email_verify' },
	                  this.state.email_flag == 0 && this.state.email != '' ? 'Not verified' : ''
	                )
	              )
	            ),
	            this.state.page_loading ? _react2.default.createElement(
	              'i',
	              { className: 'pro_load_img' },
	              _react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
	            ) : '',
	            _react2.default.createElement(
	              'h4',
	              { className: 'cnt_info_title' },
	              'Contact Information'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mob_cnt_info row' },
	              _react2.default.createElement(
	                'h5',
	                { onClick: this.editCityAddress, style: { paddingLeft: '15px', fontSize: '12px' } },
	                this.state.city && !this.state.editCityAddress_status ? this.state.city : _react2.default.createElement(_reactGeosuggest2.default, { fixtures: fixtures, placeholder: 'Select Address', onSuggestSelect: this.onSuggestSelect, ignoreTab: true, onSelect: this.onSelect })
	              ),
	              _react2.default.createElement(
	                'h5',
	                { style: { paddingLeft: '15px' } },
	                _react2.default.createElement('input', { type: 'text', ref: 'pincode', placeholder: 'Pincode', value: this.state.pincode === '0' ? '' : this.state.pincode, onChange: this.pincodeChange, style: { border: 'none', width: '100%' }, maxLength: 6 }),
	                this.state.err_pincode_status ? _react2.default.createElement(
	                  'p',
	                  null,
	                  this.state.err_pincode_msg
	                ) : ''
	              )
	            ),
	            _react2.default.createElement(
	              'h4',
	              { className: 'act_info_title' },
	              'Account Options'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mob_act_opt_blk row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 col-sm-6 col-xs-6' },
	                _react2.default.createElement(
	                  'h5',
	                  { className: 'pro_chng_num' },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: "/change_number" },
	                    'Change Mobile Number'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 col-sm-6 col-xs-6', style: { borderLeft: '1px solid #ccc' } },
	                _react2.default.createElement(
	                  'h5',
	                  { className: 'pro_reset_btn', style: { paddingLeft: '15px' } },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/reset' },
	                    'Reset Password'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'clr' },
	              '\xA0'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'profile_save_btn', onClick: this.saveChanges },
	              'SAVE'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'clr' },
	              '\xA0'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Modal,
	            { className: 'm_profile_modal', show: this.state.delete_img_status, onHide: this.close },
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Body,
	              null,
	              _react2.default.createElement(
	                'h4',
	                { style: { fontSize: '14px', color: '#333' } },
	                'Want to remove profile photo?'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Footer,
	              { className: 'modal_footer modal_profile_footer' },
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
	                'NO'
	              ),
	              _react2.default.createElement(
	                'a',
	                null,
	                _react2.default.createElement(
	                  _reactBootstrap.Button,
	                  { style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: function onClick() {
	                      _this4.removeProfilePic();
	                    } },
	                  'YES'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Profile;
	}(_react.Component);
	
	exports.default = Profile;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Reset = function (_Component) {
		_inherits(Reset, _Component);
	
		function Reset(props) {
			_classCallCheck(this, Reset);
	
			var _this = _possibleConstructorReturn(this, (Reset.__proto__ || Object.getPrototypeOf(Reset)).call(this, props));
	
			_this.state = {
				mobile: localStorage.mobile_number,
				mobile_number: localStorage.mobile_number,
				password: '',
				confirm_password: '',
				err: false,
				err_pass: '',
				err_c_pass: '',
				mismatch: '',
				err_msg: ''
			};
			_this.handleSubmit = _this.handleSubmit.bind(_this);
			_this.passwordChange = _this.passwordChange.bind(_this);
			// this.confirmPassChange=this.confirmPassChange.bind(this);
			// this.validate=this.validate.bind(this);
			// this.onPassChange=this.onPassChange.bind(this);
			return _this;
		}
		// onPassChange(event){
		// 	// alert(event.target.value);
		// 	this.validation(event.target.value);
		// }
		// // validation(value){
		// 	// console.log(value);
		// 	var valid_pass = this.validPass();
		// 	// var valid_c_pass = this.validCPass();
		// 	return ( valid_pass );
	
		// 	// if(value.length < 4 ){
		// 	// 	alert("Password must be more than 4 characters");
		// 	// }
		// 	// if(value=== '') {
		// 	// 	return "Required";
		// 	// }
	
		// }
	
		// handlePasswordInput(value){
		// 	this.setState({
		// 		password: value
		// 	});
		// 	var self= this;
		// 	window.setTimout(function(){
		// 		if(self.state.confirmPassword && self.state.confirmPassword.length) {
		// 			            this.validate(self.state.confirmPassword);
		// 		}
		// 	})
	
		// }
		//  handleConfirmPasswordInput(value) {
		//        this.setState({
		//            confirmPassword: value
		//        })
		//    }
		//    isConfirmedPassword(value) {
		//       // console.log(value,this.state.password,value===this.state.password);
		//        return (value === this.state.password)
	
		//    }
	
	
		_createClass(Reset, [{
			key: 'handleSubmit',
			value: function handleSubmit(event) {
				event.preventDefault();
				var x = this.refs.confirmPassword.value;
				var flag = 1;
				if (x.length <= 3) {
					flag = 0;
					this.setState({
						err: true,
						err_msg: '* password is minimum 4 characters'
					});
				} else if (x === '') {
					flag = 0;
					this.setState({
						err: true,
						err_msg: '* enter password'
					});
				} else {
					flag = 1;
				}
				var mobile = '';
				if (localStorage.mobile_number) {
					mobile = localStorage.mobile_number;
				} else if (localStorage.mobile) {
					mobile = localStorage.mobile;
				}
				var data1 = { from: 'mobile_web', password: this.refs.confirmPassword.value, mobile: mobile, device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
				if (flag === 1) {
					_jquery2.default.ajax({
						method: 'POST',
						url: baseUrl + 'resetpass',
						data: { req: data2 },
						dataType: 'json',
						success: function success(data) {
							// console.log(data);
							if (data.status === "success") {
								localStorage.setItem('token', data.result[0].token);
								localStorage.setItem('user_id', data.result[0].id);
								_reactRouter.browserHistory.push('/');
								// window.location.reload();					
							}
						}
					});
				} else {
					this.setState({
						err: true
					});
				}
			}
		}, {
			key: 'passwordChange',
			value: function passwordChange(event) {
				this.setState({
					password: event.target.value,
					err: false
				});
			}
			// confirmPassChange(event){
	
			// 	this.setState({
			// 		confirm_password: event.target.value,
			// 	},function(){
			// 		if(this.state.password !== this.state.confirm_password){
			// 				this.setState({
			// 					err: true,
			// 					mismatch: "Password Mismatch",
			// 				})				
			// 		}
			// 		else{
			// 			this.setState({
			// 				err: false,
			// 			})
			// 		}
			// 	});
			// 	// this.validate(event);
			// }
	
		}, {
			key: 'render',
			value: function render() {
				document.title = "AquaDeals Reset - You find,buy best deals by register with us";
				document.getElementsByTagName("META")[2].content = "You find,buy best deals by register with us";
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals mob_reset_page' },
					_react2.default.createElement(
						'section',
						{ className: 'tot_pag' },
						_react2.default.createElement(
							'div',
							{ className: 'page_hdr' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ onClick: function onClick() {
												_reactRouter.browserHistory.goBack();
											} },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
										)
									),
									'Reset Password'
								),
								_react2.default.createElement(
									'a',
									{ href: '/', className: 'home_newicon' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'section',
							{ className: 'pag_cntnt' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									'div',
									{ className: '', style: { overflow: 'hidden' } },
									_react2.default.createElement(
										'div',
										{ className: 'enquire_form signup_blk proced_blk' },
										_react2.default.createElement(
											'div',
											{ className: 'newlogin_logo' },
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cc_footer_icon.png', alt: '' })
										),
										_react2.default.createElement(
											'form',
											{ className: 'mtrl_elmnts', onSubmit: this.handleSubmit },
											_react2.default.createElement(
												'div',
												{ className: 'col-md-12', style: { marginLeft: '30px', marginRight: '30px' } },
												_react2.default.createElement(
													'div',
													{ className: 'group' },
													_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cell_dl.png', alt: '', style: { position: 'absolute', top: '11px', left: '0px' } }),
													_react2.default.createElement('input', { type: 'text', value: this.state.mobile_number, required: true, placeholder: 'Mobile Number' }),
													_react2.default.createElement('span', { className: 'highlight' }),
													_react2.default.createElement('span', { className: 'bar' })
												),
												_react2.default.createElement(
													'div',
													{ className: 'group' },
													_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/lock.png', alt: '', style: { position: 'absolute', top: '11px', left: '0px' } }),
													_react2.default.createElement('input', { type: 'password', placeholder: 'New Password', ref: 'confirmPassword', onChange: this.passwordChange, required: true }),
													_react2.default.createElement('span', { className: 'highlight' }),
													_react2.default.createElement('span', { className: 'bar' }),
													this.state.err ? _react2.default.createElement(
														'span',
														{ style: { color: 'red', fontSize: '12px' } },
														this.state.err_msg
													) : ''
												),
												_react2.default.createElement(
													'div',
													{ className: 'clr' },
													'\xA0'
												),
												_react2.default.createElement(
													'div',
													{ className: '' },
													_react2.default.createElement(
														'button',
														{ onSubmit: this.handleSubmit, action: 'submit', className: 'btn mob_reset_btn' },
														'RESET ',
														_react2.default.createElement('i', { className: 'glyphicon glyphicon-menu-right' })
													)
												)
											)
										)
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return Reset;
	}(_react.Component);
	
	exports.default = Reset;

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var verifyOtp = function (_Component) {
		_inherits(verifyOtp, _Component);
	
		function verifyOtp(props, context) {
			_classCallCheck(this, verifyOtp);
	
			var _this = _possibleConstructorReturn(this, (verifyOtp.__proto__ || Object.getPrototypeOf(verifyOtp)).call(this, props));
	
			_this.state = {
				mobile: localStorage.getItem('mobile_number'),
				invalid_otp: ''
			};
			_this.handleSubmit = _this.handleSubmit.bind(_this);
			_this.gotoLogin = _this.gotoLogin.bind(_this);
			_this.resendOtp = _this.resendOtp.bind(_this);
			return _this;
		}
	
		_createClass(verifyOtp, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.refs.otp.focus();
			}
		}, {
			key: 'resendOtp',
			value: function resendOtp() {
	
				var data1 = { from: 'mobile_web', mobile: this.state.mobile };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'resendOtp',
					data: { req: data2 },
					dataType: 'json',
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'handleSubmit',
			value: function handleSubmit(event) {
				event.preventDefault();
				var data1 = { from: 'mobile_web', mobile: localStorage.getItem('mobile_number'), otp: this.refs.otp.value };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'verifyforgotOtp',
					data: { req: data2 },
					dataType: 'json',
					success: function (data) {
						if (data.status === "success") {
							_reactRouter.browserHistory.push('/reset');
						}
						if (data.status === 'fail') {
							this.setState({
								err: true,
								invalid_otp: 'Invalid Otp'
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'gotoLogin',
			value: function gotoLogin(event) {
				event.preventDefault();
				_reactRouter.browserHistory.push('/login');
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'user_form' },
					_react2.default.createElement(
						_reactRouter.Link,
						{ onClick: function onClick() {
								_reactRouter.browserHistory.goBack();
							}, className: 'back_icon' },
						_react2.default.createElement(
							'i',
							null,
							_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: ' ' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'container pag_cntnt' },
						_react2.default.createElement(
							'div',
							{ className: 'row', style: { marginLeft: '0', marginRight: '0' } },
							_react2.default.createElement(
								'h5',
								{ className: 'sign_in_title' },
								'Verify Your Mobile Number'
							),
							_react2.default.createElement(
								'span',
								{ className: 'otp_number' },
								'OTP sent to ',
								'+91 ' + this.state.mobile
							),
							_react2.default.createElement(
								'form',
								{ className: 'text-center otp_form', onSubmit: this.handleSubmit },
								_react2.default.createElement(
									'div',
									{ className: 'reg_group' },
									_react2.default.createElement('input', { type: 'text', ref: 'otp', maxLength: 6, required: true, placeholder: 'Enter OTP' }),
									_react2.default.createElement('span', { className: 'highlight' }),
									_react2.default.createElement('span', { className: 'bar' }),
									this.state.err ? this.state.invalid_otp : ''
								),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								),
								_react2.default.createElement(
									'button',
									{ action: 'submit', className: 'btn mob_regbtn' },
									'ENTER'
								),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									{ className: 'tap' },
									_react2.default.createElement(
										'a',
										{ style: { cursor: 'pointer' }, onClick: this.resendOtp },
										'RESEND OTP'
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return verifyOtp;
	}(_react.Component);
	
	exports.default = verifyOtp;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactStars = __webpack_require__(33);
	
	var _reactStars2 = _interopRequireDefault(_reactStars);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var GiveRatings = function (_Component) {
		_inherits(GiveRatings, _Component);
	
		function GiveRatings(props) {
			_classCallCheck(this, GiveRatings);
	
			var _this = _possibleConstructorReturn(this, (GiveRatings.__proto__ || Object.getPrototypeOf(GiveRatings)).call(this, props));
	
			_this.state = {
				seed_rate: 0,
				over_rate: 0,
				serv_rate: 0,
				pack_rate: 0,
				recomend: true,
				seller: localStorage.getItem('seller'),
				book_date: localStorage.getItem('book_date'),
				nodata_status: false,
				successRating: false
				// this.getSeedDetails=this.getSeedDetails.bind(this);
				// this.getProductDetails=this.getProductDetails.bind(this);
			};_this.over_rateChanged = _this.over_rateChanged.bind(_this);
			_this.seed_rateChanged = _this.seed_rateChanged.bind(_this);
			_this.serv_rateChanged = _this.serv_rateChanged.bind(_this);
			_this.pack_rateChanged = _this.pack_rateChanged.bind(_this);
			_this.handleChange = _this.handleChange.bind(_this);
			_this.getRatingDetails = _this.getRatingDetails.bind(_this);
			_this.close = _this.close.bind(_this);
			return _this;
		}
	
		_createClass(GiveRatings, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (!localStorage.token && !localStorage.user_id) {
					if (this.props.params.Product === 'product') {
						localStorage.setItem('give_rating', '/giverating/' + this.props.params.Product + '/' + this.props.params.Bid);
						_reactRouter.browserHistory.push('/login');
					} else {
						localStorage.setItem('give_rating', '/giverating/' + this.props.params.Bid);
						_reactRouter.browserHistory.push('/login');
					}
				} else {
					this.getRatingDetails();
				}
				if (screen.width >= 800) {
					if (this.props.params.Product === 'product') {
						window.location.href = "/web/giverating/" + this.props.params.Product + '/' + this.props.params.Bid;
					} else {
						window.location.href = "/web/giverating/" + this.props.params.Bid;
					}
				}
			}
		}, {
			key: 'getRatingDetails',
			value: function getRatingDetails() {
				if (this.props.params.Product === 'product') {
					var type = 1;
				} else {
					type = 0;
				}
	
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, type: type, bid: this.props.params.Bid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'pre_rate_info',
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								seller: data.seller_name,
								book_date: data.created_on
							});
						} else {
							this.setState({
								nodata_status: true
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'over_rateChanged',
			value: function over_rateChanged(newRating) {
				console.log(newRating);
				this.setState({
					over_rate: newRating
				});
			}
		}, {
			key: 'seed_rateChanged',
			value: function seed_rateChanged(newRating) {
				console.log(newRating);
				this.setState({
					seed_rate: newRating
				});
			}
		}, {
			key: 'serv_rateChanged',
			value: function serv_rateChanged(newRating) {
				console.log(newRating);
				this.setState({
					serv_rate: newRating
				});
			}
		}, {
			key: 'pack_rateChanged',
			value: function pack_rateChanged(newRating) {
				console.log(newRating);
				this.setState({
					pack_rate: newRating
				});
			}
		}, {
			key: 'handleChange',
			value: function handleChange() {
				this.setState({
					recomend: !this.state.recomend
				});
			}
		}, {
			key: 'submitRatings',
			value: function submitRatings() {
				// saveRatings(id,token,vid,deal_id,ser_qlty,seed_qlty,pack_qlty,book_id,overall,recomend)
				if (localStorage.vid) {
					var vid = localStorage.getItem('vid');
				} else {
					vid = '';
				}
				if (this.props.params.Product === 'product') {
					// savepro_ratings(id,token,book_id,product_id,ser_qlty,product_qlt,pack_qlty,overall,recomend)
					var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, book_id: this.props.params.Bid, product_id: localStorage.product_id, ser_qlty: this.state.serv_rate, product_qlt: this.state.seed_rate, pack_qlty: this.state.pack_rate, overall: this.state.over_rate, recomend: this.state.recomend };
					var data2 = JSON.stringify(data1);
	
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'savepro_ratings',
						success: function success(data) {
							if (data.status === 'ok') {
								this.setState({
									successRating: true
								});
								// alert("Thanks for Rating");
								_reactRouter.browserHistory.push('/myorders');
							}
						},
						error: function error(err) {
							console.log(err);
						}
					});
				} else {
					data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, vid: vid, deal_id: '', ser_qlty: this.state.serv_rate, seed_qlty: this.state.seed_rate, pack_qlty: this.state.pack_rate, book_id: this.props.params.Bid, overall: this.state.over_rate, recomend: this.state.recomend };
					data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'saveRatings',
						success: function (data) {
							if (data.status === 'ok') {
								this.setState({
									successRating: true
								});
								// alert("Thanks for Rating");
								_reactRouter.browserHistory.push('/myorders');
							}
						}.bind(this),
						error: function error(err) {
							console.log(err);
						}
					});
				}
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					successRating: false
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				document.title = this.props.params.Product === 'product' ? 'Give Product Ratings | AquaDeals' : 'Give Hatchery Ratings | AquaDeals';
				(0, _jquery2.default)('body').css('background', '#f1f1f2');
				var over_rate = _react2.default.createElement(_reactStars2.default, {
					className: 'rate_dtls_item',
					count: 5,
					onChange: this.over_rateChanged,
					size: 20,
					value: this.state.over_rate
					// color1={'#F3F3F3'}
					, color2: '#FABB9A' });
				var serv_rate = _react2.default.createElement(_reactStars2.default, {
					className: 'rate_dtls_item',
					count: 5,
					onChange: this.serv_rateChanged,
					size: 20,
					value: this.state.serv_rate
					// color1={'#F3F3F3'}
					, color2: '#FABB9A' });
				var seed_rate = _react2.default.createElement(_reactStars2.default, {
					className: 'rate_dtls_item',
					count: 5,
					onChange: this.seed_rateChanged,
					size: 20,
					value: this.state.seed_rate
					// color1={'#F3F3F3'}
					, color2: '#FABB9A' });
				var pack_rate = _react2.default.createElement(_reactStars2.default, {
					className: 'rate_dtls_item',
					count: 5,
					onChange: this.pack_rateChanged,
					size: 20,
					value: this.state.pack_rate
					// color1={'#F3F3F3'}
					, color2: '#FABB9A' });
	
				var switch_btn = _react2.default.createElement(
					'div',
					{ className: 'switch-container custom_switch_blk' },
					_react2.default.createElement(
						'label',
						null,
						_react2.default.createElement('input', { ref: 'switch', checked: this.state.recomend, onChange: this.handleChange, className: 'switch', type: 'checkbox' }),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'span',
								null,
								_react2.default.createElement('g', { className: 'icon icon-toolbar grid-view' })
							),
							_react2.default.createElement(
								'span',
								null,
								_react2.default.createElement('g', { className: 'icon icon-toolbar ticket-view' })
							),
							_react2.default.createElement('div', null)
						)
					)
				);
	
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals giverating_page' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ onClick: function onClick() {
											_reactRouter.browserHistory.goBack();
										} },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
									)
								),
								this.props.params.Product === 'product' ? 'Product Ratings' : 'Hatchery Ratings'
							),
							_react2.default.createElement(
								'a',
								{ href: '/', title: 'Home', className: 'home_logo1' },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'pag_cntnt' },
						'\xA0'
					),
					this.state.nodata_status ? _react2.default.createElement(
						'section',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'mob_unauth_blk' },
							_react2.default.createElement(
								'h4',
								null,
								'You are not Authorized'
							),
							_react2.default.createElement(
								'a',
								{ href: '/login', className: 'mob_link_btn' },
								'Sign in Here'
							)
						)
					) : _react2.default.createElement(
						'section',
						{ className: '' },
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement('img', { src: baseAssets + 'images/promo_offers/20170310100146779139.png', alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ className: '' },
							_react2.default.createElement(
								'div',
								{ className: 'from_dtls_blk' },
								_react2.default.createElement(
									'p',
									null,
									'FROM'
								),
								this.state.seller ? _react2.default.createElement(
									'p',
									null,
									this.state.seller
								) : _react2.default.createElement(
									'p',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									'ORDER DATE'
								),
								this.state.book_date ? _react2.default.createElement(
									'p',
									null,
									this.state.book_date
								) : _react2.default.createElement(
									'p',
									null,
									'\xA0'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ style: { marginTop: '10px', fontSize: '12px' } },
							_react2.default.createElement(
								'div',
								{ className: 'rating_list_blk' },
								_react2.default.createElement(
									'div',
									{ className: 'rating_list_item' },
									_react2.default.createElement(
										'span',
										{ style: { float: 'left' } },
										'Overall Rating'
									),
									over_rate
								),
								_react2.default.createElement(
									'div',
									{ className: 'rating_list_item' },
									_react2.default.createElement(
										'span',
										{ style: { float: 'left' } },
										'Service Quality'
									),
									serv_rate
								),
								_react2.default.createElement(
									'div',
									{ className: 'rating_list_item' },
									_react2.default.createElement(
										'span',
										{ style: { float: 'left' } },
										this.props.params.Product === 'product' ? 'Product Quality' : 'Seed Quality'
									),
									seed_rate
								),
								_react2.default.createElement(
									'div',
									{ className: 'rating_list_item' },
									_react2.default.createElement(
										'span',
										{ style: { float: 'left' } },
										'Packing Quality'
									),
									pack_rate
								)
							)
						),
						_react2.default.createElement(
							'section',
							{ style: { marginTop: '10px' } },
							this.state.recomend === true ? _react2.default.createElement(
								'div',
								{ className: 'rate_rec_blk' },
								_react2.default.createElement(
									'span',
									{ style: { width: '75%', display: 'block' } },
									this.props.params.Product === 'product' ? 'I recommended this product to other customers' : 'I recommended this hatchery to other customers'
								),
								_react2.default.createElement(
									'span',
									null,
									switch_btn
								)
							) : _react2.default.createElement(
								'div',
								{ className: 'rate_rec_blk' },
								_react2.default.createElement(
									'span',
									{ style: { width: '75%', display: 'block' } },
									this.props.params.Product === 'product' ? 'I recommended this product to other customers' : 'I recommended this hatchery to other customers'
								),
								_react2.default.createElement(
									'span',
									null,
									switch_btn
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ style: { textAlign: 'center' } },
							_react2.default.createElement(
								'button',
								{ className: 'save_rating_btn', onClick: function onClick() {
										_this2.submitRatings();
									} },
								'SUBMIT'
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'showModal', show: this.state.successRating, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#666', textAlign: 'center' } },
								'Thanks for Rating'
							)
						)
					)
				);
			}
		}]);
	
		return GiveRatings;
	}(_react.Component);
	
	exports.default = GiveRatings;

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var MyAquaCash = function (_Component) {
		_inherits(MyAquaCash, _Component);
	
		function MyAquaCash(props) {
			_classCallCheck(this, MyAquaCash);
	
			var _this = _possibleConstructorReturn(this, (MyAquaCash.__proto__ || Object.getPrototypeOf(MyAquaCash)).call(this, props));
	
			_this.state = {
				loading: false,
				balance: '',
				transactions: [],
	
				title: '',
				subtitle: '',
				type: '',
				date: '',
				amount: '',
				sign: '',
				modal_status: false
			};
			_this.transactionDetails = _this.transactionDetails.bind(_this);
			_this.aquacash_Modal = _this.aquacash_Modal.bind(_this);
			_this.close = _this.close.bind(_this);
			return _this;
		}
	
		_createClass(MyAquaCash, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					window.location.href = "/web/myaquacash";
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('myaquacash', '/myaquacash');
					_reactRouter.browserHistory.push('/login');
				}
				this.transactionDetails();
			}
		}, {
			key: 'transactionDetails',
			value: function transactionDetails() {
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
	
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'aquaCash',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
	
						this.setState({
							loading: true,
							balance: data.balance,
							transactions: data.transactions
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'aquacash_Modal',
			value: function aquacash_Modal(title, subtitle, amount, sign, type, date) {
				this.setState({
					modal_status: true,
					title: title,
					subtitle: subtitle,
					type: type,
					date: date,
					amount: amount,
					sign: sign
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					modal_status: false
				});
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = "My AquaCash | AquaDeals";
				var transactions = this.state.transactions.map(function (data, index) {
					var _this2 = this;
	
					return _react2.default.createElement(
						'li',
						{ className: 'myaquacash_li', key: index, onClick: function onClick() {
								_this2.aquacash_Modal(data.title, data.subtitle, data.amount, data.sign, data.type, data.date);
							} },
						_react2.default.createElement(
							'h5',
							null,
							data.title ? _react2.default.createElement(
								'span',
								{ className: 'aquacash_title' },
								data.title
							) : _react2.default.createElement(
								'span',
								null,
								'\xA0'
							),
							' ',
							data.amount ? _react2.default.createElement(
								'span',
								{ className: 'aquacash_amount' },
								'(',
								data.sign,
								') \u20B9 ',
								data.amount
							) : _react2.default.createElement(
								'span',
								{ className: 'aquacash_amount' },
								'\xA0'
							)
						),
						_react2.default.createElement(
							'h6',
							{ style: { paddingTop: '5px' } },
							' ',
							data.subtitle ? _react2.default.createElement(
								'span',
								{ className: 'aquacash_subtitle' },
								data.subtitle
							) : _react2.default.createElement(
								'span',
								null,
								'\xA0'
							),
							' ',
							data.type ? _react2.default.createElement(
								'span',
								{ className: data.type === "Used" ? 'pull-right red cash_type' : 'pull-right green cash_type' },
								data.type
							) : _react2.default.createElement(
								'span',
								null,
								'\xA0'
							)
						),
						_react2.default.createElement(
							'h6',
							{ className: 'aquacash_date' },
							'Date ',
							data.date
						)
					);
				}.bind(this));
	
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals mob_aquacash_page' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ onClick: function onClick() {
											_reactRouter.browserHistory.goBack();
										} },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/close_icon1.png', width: '14px', className: 'cross_icon', alt: '' })
									)
								),
								_react2.default.createElement(
									'span',
									{ className: 'header_text' },
									'MY AQUACASH'
								)
							),
							_react2.default.createElement(
								'a',
								{ href: '/', className: 'myaquacash_amount' },
								'\u20B9 ',
								this.state.balance
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'pag_cntnt' },
						'\xA0'
					),
					transactions.length > 0 ? _react2.default.createElement(
						'section',
						null,
						_react2.default.createElement(
							'ul',
							{ className: 'myaquacash_ul' },
							transactions
						)
					) : _react2.default.createElement(
						'div',
						{ className: 'no_transactions_blk' },
						'No transactions were made'
					),
					_react2.default.createElement(
						'section',
						{ className: 'botm_btns' },
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ style: { color: '#ff742a' }, to: '/share_earn' },
								_react2.default.createElement('img', { src: baseAssets + "images/icons/nav_refer_earn.png", width: '30px', alt: '' }),
								'SHARE & EARN '
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'aquacash_modal', show: this.state.modal_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'div',
								null,
								this.state.title ? _react2.default.createElement(
									'h4',
									null,
									this.state.title
								) : '',
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'p',
										{ style: { marginTop: '20px' } },
										this.state.amount ? _react2.default.createElement(
											'span',
											null,
											'\u20B9',
											this.state.amount
										) : '',
										' ',
										this.state.type ? this.state.type : '',
										' ',
										this.state.subtitle ? 'for ' + this.state.subtitle : '',
										' on ',
										this.state.date,
										' '
									),
									_react2.default.createElement(
										'a',
										{ style: { color: '#ff742a', textDecoration: 'none', outline: 'none', textAlign: 'right', display: 'block' }, onClick: this.close },
										'CLOSE'
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return MyAquaCash;
	}(_react.Component);
	
	exports.default = MyAquaCash;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Notifications = function (_Component) {
		_inherits(Notifications, _Component);
	
		function Notifications(props) {
			_classCallCheck(this, Notifications);
	
			var _this = _possibleConstructorReturn(this, (Notifications.__proto__ || Object.getPrototypeOf(Notifications)).call(this, props));
	
			_this.state = {
				notifications: [],
				empty_status: false,
				deleteAll_modal: false
			};
			_this.deleteAll = _this.deleteAll.bind(_this);
			_this.clearNotif = _this.clearNotif.bind(_this);
			_this.deleteModal = _this.deleteModal.bind(_this);
			_this.close = _this.close.bind(_this);
			return _this;
		}
	
		_createClass(Notifications, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					window.location.href = "/web/notifications";
				}
				if (!localStorage.token && !localStorage.user_id) {
					localStorage.setItem('notifications', '/notifications');
					_reactRouter.browserHistory.push('/login');
				} else {
					var data1 = { id: localStorage.user_id, token: localStorage.token, from: 'mobile_web' };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'getpnotifications',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success') {
								if (data.notifications.length > 0) {
									this.setState({
										notifications: data.notifications
									});
								} else {
									this.setState({
										empty_status: true
									});
								}
							} else if (data.status === 'error' && data.message === 'Token mismatch') {
								localStorage.clear();
								localStorage.setItem('notifications', '/notifications');
								_reactRouter.browserHistory.push('/login');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					deleteAll_modal: false
				});
			}
		}, {
			key: 'deleteModal',
			value: function deleteModal() {
				this.setState({
					deleteAll_modal: true
				});
			}
		}, {
			key: 'deleteAll',
			value: function deleteAll() {
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'deleteAllNotifications',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								empty_status: true,
								deleteAll_modal: false
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			// clearNotif(id,token,push_id,from)
	
		}, {
			key: 'clearNotif',
			value: function clearNotif(push_id) {
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, push_id: push_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'clearNotif',
					data: { req: data2 },
					success: function success(data) {},
					error: function error(err) {}
				});
			}
			// 
	
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				document.title = "Notifications | AquaDeals";
				var notifications = this.state.notifications.map(function (data, index) {
					var _this2 = this;
	
					return _react2.default.createElement(
						'div',
						{ className: 'notification_item' },
						data.link === 'internal' ? _react2.default.createElement(
							_reactRouter.Link,
							{ onClick: function onClick() {
									return _this2.clearNotif(data.id);
								}, to: data.url ? data.url : '/', style: { cursor: 'pointer' } },
							data.title ? _react2.default.createElement(
								'h5',
								{ className: 'noty_title' },
								data.title
							) : _react2.default.createElement(
								'h5',
								{ className: 'noty_title' },
								'\xA0'
							),
							data.content ? _react2.default.createElement(
								'h5',
								{ className: 'noty_content' },
								data.content
							) : _react2.default.createElement(
								'h5',
								{ className: 'noty_content' },
								'\xA0'
							),
							data.date ? _react2.default.createElement(
								'p',
								{ className: 'noty_date' },
								data.date
							) : _react2.default.createElement(
								'p',
								{ className: 'noty_date' },
								'\xA0'
							)
						) : _react2.default.createElement(
							'a',
							{ onClick: function onClick() {
									_this2.clearNotif(data.id);
								}, href: data.url ? data.url : '/', target: '_blank', style: { cursor: 'pointer' } },
							data.title ? _react2.default.createElement(
								'h5',
								{ className: 'noty_title' },
								data.title
							) : _react2.default.createElement(
								'h5',
								{ className: 'noty_title' },
								'\xA0'
							),
							data.content ? _react2.default.createElement(
								'h5',
								{ className: 'noty_content' },
								data.content
							) : _react2.default.createElement(
								'h5',
								{ className: 'noty_content' },
								'\xA0'
							),
							data.date ? _react2.default.createElement(
								'p',
								{ className: 'noty_date' },
								data.date
							) : _react2.default.createElement(
								'p',
								{ className: 'noty_date' },
								'\xA0'
							)
						)
					);
				}.bind(this));
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals mob_notifications_page' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: '', style: { paddingRight: '15px', paddingLeft: '15px', marginRight: 'auto', marginLeft: 'auto' } },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ onClick: function onClick() {
											_reactRouter.browserHistory.goBack();
										} },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: ' ' })
									)
								),
								' Notifications'
							),
							_react2.default.createElement(
								'a',
								{ href: '/', className: 'home_logo1' },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
							),
							!this.state.empty_status ? _react2.default.createElement(
								'a',
								{ className: 'noty_emptybtn', onClick: function onClick() {
										_this3.deleteModal();
									} },
								_react2.default.createElement('img', { alt: '', src: baseAssets + 'icons/web_icons/del_bin3.png' })
							) : ''
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'pag_cntnt' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'container-fluid' },
						this.state.empty_status ? _react2.default.createElement(
							'div',
							{ className: 'noty_empty' },
							'No Notifications Available'
						) : notifications
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ show: this.state.deleteAll_modal, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								null,
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								null,
								'Do you want to remove all notifications? '
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'mob_cart_confirm' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ className: '', onClick: this.close },
								'NO'
							),
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ className: '', onClick: function onClick() {
											_this3.deleteAll();
										} },
									'YES'
								)
							)
						)
					)
				);
			}
		}]);
	
		return Notifications;
	}(_react.Component);
	
	exports.default = Notifications;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactStars = __webpack_require__(33);
	
	var _reactStars2 = _interopRequireDefault(_reactStars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import Switch from './switch.js';
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var View_Rating = function (_Component) {
		_inherits(View_Rating, _Component);
	
		function View_Rating(props) {
			_classCallCheck(this, View_Rating);
	
			var _this = _possibleConstructorReturn(this, (View_Rating.__proto__ || Object.getPrototypeOf(View_Rating)).call(this, props));
	
			_this.state = {
				over_rate: '',
				pack_rate: '',
				recomend: '',
				seller: '',
				book_date: '',
				nodata_status: false
			};
			_this.getSeedDetails = _this.getSeedDetails.bind(_this);
			_this.getProductDetails = _this.getProductDetails.bind(_this);
			_this.handleChange = _this.handleChange.bind(_this);
	
			_this.over_rateChanged = _this.over_rateChanged.bind(_this);
			_this.seed_rateChanged = _this.seed_rateChanged.bind(_this);
			_this.serv_rateChanged = _this.serv_rateChanged.bind(_this);
			_this.pack_rateChanged = _this.pack_rateChanged.bind(_this);
			return _this;
		}
	
		_createClass(View_Rating, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					if (this.props.params.Product === 'product') {
						window.location.href = '/web/viewrating/' + this.props.params.Product + '/' + this.props.params.Bid;
					} else {
						window.location.href = "/web/viewrating/" + this.props.params.Bid;
					}
				}
				if (this.props.params.Product === 'product') {
					this.getProductDetails();
				} else {
					this.getSeedDetails();
				}
				if (!localStorage.token && !localStorage.user_id) {
					if (this.props.params.Product === 'product') {
						localStorage.setItem('view_rating', '/viewrating/' + this.props.params.Product + '/' + this.props.params.Bid);
						_reactRouter.browserHistory.push('/login');
					} else {
						localStorage.setItem('view_rating', '/viewrating/' + this.props.params.Bid);
						_reactRouter.browserHistory.push('/login');
					}
				}
			}
		}, {
			key: 'getSeedDetails',
			value: function getSeedDetails() {
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, bid: this.props.params.Bid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'getrating',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							seed_rate: data.seed_rate,
							serv_rate: data.serv_rate,
							pack_rate: data.pack_rate,
							over_rate: data.over_rate,
							recomend: data.recomend,
							seller: data.seller,
							book_date: data.book_date
						});
						if (data.status === 'fails') {
							this.setState({
								nodata_status: true
							});
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'getProductDetails',
			value: function getProductDetails() {
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, bid: this.props.params.Bid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'getpro_book_rating',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							seed_rate: data.product_rate,
							serv_rate: data.serv_rate,
							pack_rate: data.pack_rate,
							over_rate: data.over_rate,
							recomend: data.recomend,
							seller: data.seller,
							book_date: data.book_date
						});
						if (data.status === 'fails') {
							this.setState({
								nodata_status: true
							});
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'ratingChanged',
			value: function ratingChanged(newRating) {
				//console.log(newRating)
			}
		}, {
			key: 'handleChange',
			value: function handleChange() {
				this.setState({
					recomend: !this.state.recomend
				});
			}
		}, {
			key: 'over_rateChanged',
			value: function over_rateChanged(newRating) {
				console.log(newRating);
				this.setState({
					over_rate: newRating
				});
			}
		}, {
			key: 'seed_rateChanged',
			value: function seed_rateChanged(newRating) {
				console.log(newRating);
				this.setState({
					seed_rate: newRating
				});
			}
		}, {
			key: 'serv_rateChanged',
			value: function serv_rateChanged(newRating) {
				console.log(newRating);
				this.setState({
					serv_rate: newRating
				});
			}
		}, {
			key: 'pack_rateChanged',
			value: function pack_rateChanged(newRating) {
				console.log(newRating);
				this.setState({
					pack_rate: newRating
				});
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = this.props.params.Product === 'product' ? 'View Product Ratings | AquaDeals' : 'View Hatchery Ratings | AquaDeals';
				(0, _jquery2.default)('body').css('background', '#f1f1f2');
	
				var switch_btn = this.state.recomend ? _react2.default.createElement(
					'div',
					{ className: 'switch-container custom_switch_blk' },
					_react2.default.createElement(
						'label',
						null,
						_react2.default.createElement('input', { ref: 'switch', checked: this.state.recomend === "true" ? true : false, disabled: true, onChange: this.handleChange, className: 'switch', type: 'checkbox' }),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'span',
								null,
								_react2.default.createElement('g', { className: 'icon icon-toolbar grid-view' })
							),
							_react2.default.createElement(
								'span',
								null,
								_react2.default.createElement('g', { className: 'icon icon-toolbar ticket-view' })
							),
							_react2.default.createElement('div', null)
						)
					)
				) : '';
	
				var pack_rate = _react2.default.createElement(_reactStars2.default, {
					className: 'rate_dtls_item',
					count: 5,
					onChange: this.pack_rateChanged,
					size: 20,
					edit: false,
					value: this.state.pack_rate,
					color1: '#F3F3F3',
					color2: '#FABB9A' });
	
				var seed_rate = _react2.default.createElement(_reactStars2.default, {
					className: 'rate_dtls_item',
					count: 5,
					onChange: this.seed_rateChanged,
					size: 20,
					edit: false,
					value: this.state.seed_rate,
					color1: '#F3F3F3',
					color2: '#FABB9A' });
	
				var serv_rate = _react2.default.createElement(_reactStars2.default, {
					className: 'rate_dtls_item',
					count: 5,
					onChange: this.serv_rateChanged,
					size: 20,
					edit: false,
					value: this.state.serv_rate,
					color1: '#F3F3F3',
					color2: '#FABB9A' });
				var over_rate = _react2.default.createElement(_reactStars2.default, {
					className: 'rate_dtls_item',
					count: 5,
					onChange: this.over_rateChanged,
					size: 20,
					edit: false,
					value: this.state.over_rate,
					color1: '#F3F3F3',
					color2: '#FABB9A' });
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals rate_details_page' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ onClick: function onClick() {
											_reactRouter.browserHistory.goBack();
										} },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
									)
								),
								this.props.params.Product === 'product' ? 'View Product Ratings' : 'View Hatchery Ratings'
							),
							_react2.default.createElement(
								'a',
								{ href: '/', title: 'Home', className: 'home_logo1' },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'pag_cntnt' },
						'\xA0'
					),
					this.state.nodata_status ? _react2.default.createElement(
						'section',
						null,
						_react2.default.createElement(
							'div',
							{ style: { textAlign: 'center', marginTop: '150px' } },
							'Rating Not Available'
						)
					) : _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'section',
							{ className: '' },
							_react2.default.createElement(
								'div',
								{ className: 'from_dtls_blk' },
								_react2.default.createElement(
									'p',
									null,
									'FROM'
								),
								this.state.seller ? _react2.default.createElement(
									'p',
									null,
									this.state.seller
								) : _react2.default.createElement(
									'p',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									'ORDER DATE'
								),
								this.state.book_date ? _react2.default.createElement(
									'p',
									null,
									this.state.book_date
								) : _react2.default.createElement(
									'p',
									null,
									'\xA0'
								)
							)
						),
						_react2.default.createElement(
							'section',
							{ style: { marginTop: '10px', fontSize: '12px' } },
							_react2.default.createElement(
								'div',
								{ className: 'rating_list_blk' },
								_react2.default.createElement(
									'div',
									{ className: 'rating_list_item' },
									_react2.default.createElement(
										'span',
										{ style: { float: 'left' } },
										'Overall Rating'
									),
									over_rate
								),
								_react2.default.createElement(
									'div',
									{ className: 'rating_list_item' },
									_react2.default.createElement(
										'span',
										{ style: { float: 'left' } },
										'Service Quality'
									),
									serv_rate
								),
								_react2.default.createElement(
									'div',
									{ className: 'rating_list_item' },
									_react2.default.createElement(
										'span',
										{ style: { float: 'left' } },
										this.props.params.Product === 'product' ? 'Product Quality' : 'Seed Quality'
									),
									seed_rate
								),
								_react2.default.createElement(
									'div',
									{ className: 'rating_list_item' },
									_react2.default.createElement(
										'span',
										{ style: { float: 'left' } },
										'Packing Quality'
									),
									pack_rate
								)
							)
						),
						_react2.default.createElement(
							'section',
							{ style: { marginTop: '10px' } },
							this.state.recomend === true ? _react2.default.createElement(
								'div',
								{ className: 'rate_rec_blk' },
								_react2.default.createElement(
									'span',
									{ style: { width: '75%', display: 'block' } },
									this.props.params.Product === 'product' ? 'I recommended this product to other customers' : 'I recommended this hatchery to other customers'
								),
								_react2.default.createElement(
									'span',
									null,
									this.state.recomend ? switch_btn : ''
								)
							) : _react2.default.createElement(
								'div',
								{ className: 'rate_rec_blk' },
								_react2.default.createElement(
									'span',
									{ style: { width: '75%', display: 'block' } },
									this.props.params.Product === 'product' ? 'I recommended this product to other customers' : 'I recommended this hatchery to other customers'
								),
								_react2.default.createElement(
									'span',
									null,
									this.state.recomend ? switch_btn : ''
								)
							)
						)
					)
				);
			}
		}]);
	
		return View_Rating;
	}(_react.Component);
	
	exports.default = View_Rating;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactShare = __webpack_require__(18);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	// path="/:Bname/brand-details/:DType/:Bid"
	
	var About_Brand = function (_Component) {
		_inherits(About_Brand, _Component);
	
		function About_Brand(props) {
			_classCallCheck(this, About_Brand);
	
			var _this = _possibleConstructorReturn(this, (About_Brand.__proto__ || Object.getPrototypeOf(About_Brand)).call(this, props));
	
			_this.state = {
				tot_data: [],
				products: [],
				cat: [],
				product_count: '',
				brand_details: '',
				load_more: '',
				brand_id: '',
				brand_name: '',
				type: '',
				dtype: '',
				share_msg: '',
				brand_location: '',
				logo: '',
				brand_bg: '',
				description: '',
				views_count: '',
				follow_count: '',
				brand_likes_count: '',
				deal_count: '',
				follow_status: '',
				like_status: '',
				page_loading: false,
	
				follow_status_flag: '',
				like_status_flag: '',
				open: false,
	
				brand_like_users: []
			};
			_this.getBrandDetails = _this.getBrandDetails.bind(_this);
			_this.tokenCheck = _this.tokenCheck.bind(_this);
			_this.likeBrand = _this.likeBrand.bind(_this);
			_this.FollowBrand = _this.FollowBrand.bind(_this);
			_this.ShareFunc = _this.ShareFunc.bind(_this);
			_this.likeBrand_onload = _this.likeBrand_onload.bind(_this);
			return _this;
		}
	
		_createClass(About_Brand, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				if (screen.width >= 800) {
					window.location.href = "/web/" + this.props.params.Bname + "/brand-details/" + this.props.params.Bid;
				}
				localStorage.removeItem('m_r_p_dt');
				// if(!localStorage.token && !localStorage.user_id)
				// {
				// localStorage.setItem('brand_details',"/"+this.props.params.Bname+'/brand-details/'+this.props.params.DType+'/'+this.props.params.Bid);
				// 	localStorage.setItem('brand_details',"/"+this.props.params.Bname+'/brand-details/'+this.props.params.Bid);
				// 	browserHistory.push('/login');
				// }
				// else
				// {
				// 
	
	
				// }
				this.getBrandDetails();
				if (localStorage.status) {
					var status = localStorage.status;
					this.likeBrand_onload(status);
				}
			}
		}, {
			key: 'ShareFunc',
			value: function ShareFunc() {
				var _this2 = this;
	
				this.setState({
					open: !this.state.open
				});
				setTimeout(function () {
					_this2.setState({ open: false });
				}, 5000);
			}
		}, {
			key: 'FollowBrand',
			value: function FollowBrand(status) {
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, brand_id: this.state.brand_id, status: status };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'follow_brand',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								follow_count: data.brand_follow_count,
								follow_status: data.follow_status
							});
							if (data.follow_status === 0) {
								this.setState({
									follow_status_flag: true
								});
							} else {
								this.setState({
									follow_status_flag: false
								});
							}
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'likeBrand',
			value: function likeBrand(status) {
				if (!localStorage.token && !localStorage.user_id) {
					// localStorage.setItem('brand_details',"/"+this.props.params.Bname+'/brand-details/'+this.props.params.DType+'/'+this.props.params.Bid);
					localStorage.setItem('brand_details', "/" + this.props.params.Bname + '/brand-details/' + this.props.params.Bid);
					localStorage.setItem('status', status);
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.status) {
						var status = localStorage.status;
					}
					this.likeBrand_onload(status);
				}
			}
		}, {
			key: 'likeBrand_onload',
			value: function likeBrand_onload(status) {
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, brand_id: this.props.params.Bid, status: status };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'like_brand',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								like_status: data.like_status,
								brand_likes_count: data.brand_likes_count,
								brand_like_users: data.brand_like_users
							});
						}
						if (data.like_status === 1) {
							this.setState({
								like_status_flag: true
							});
						} else {
							this.setState({
								like_status_flag: false
							});
						}
						this.getBrandDetails();
						localStorage.removeItem('status');
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'tokenCheck',
			value: function tokenCheck() {
				localStorage.removeItem('user_id');
				localStorage.removeItem('token');
				window.location.reload();
			}
		}, {
			key: 'getBrandDetails',
			value: function getBrandDetails() {
				this.setState({
					page_loading: true
				});
	
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'mobile_web', id: uid, token: localStorage.token, brand_id: this.props.params.Bid, page: '1' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'get_brand_details',
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								tot_data: data,
								products: data.products,
								cat: data.cat,
								product_count: data.product_count,
								brand_details: data.brand_details,
								load_more: data.load_more,
								// brand_details start 
								brand_id: data.brand_details[0].brand_id,
								brand_name: data.brand_details[0].brand_name,
								type: data.brand_details[0].type,
								dtype: data.brand_details[0].dtype,
								share_msg: data.brand_details[0].share_msg,
								brand_location: data.brand_details[0].brand_location,
								logo: data.brand_details[0].logo,
								brand_bg: data.brand_details[0].brand_bg,
								description: data.brand_details[0].description,
								views_count: data.brand_details[0].views_count,
								follow_count: data.brand_details[0].follow_count,
								brand_likes_count: data.brand_details[0].likes_count,
								deal_count: data.brand_details[0].deal_count,
								follow_status: data.brand_details[0].follow_status,
								like_status: data.brand_details[0].like_status,
								brand_like_users: data.brand_like_users,
								// brand details end
								page_loading: false
							});
							if (data.brand_details[0].follow_status === '1') {
								this.setState({
									follow_status_flag: false
								});
							} else {
								this.setState({
									follow_status_flag: true
								});
							}
							if (data.brand_details[0].like_status === '1') {
								this.setState({
									like_status_flag: true
								});
							} else {
								this.setState({
									like_status_flag: false
								});
							}
						}
						if (data.status === 'error' && data.message === "Token mismatch") {
							this.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var params = {
					paginationClickable: true,
					spaceBetween: 10,
					slidesPerView: 3
					// document.title=this.state.brand_details ? 'Buy '+this.state.brand_details[0].brand_name +" Aqua Products Online | AquaDeals " : 'About the Brand | AquaDeals';
					// document.getElementsByTagName("META")[2].content ='Browse quality Aquaculture '+this.state.brand_details[0].brand_name +' feed deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
	
	
					// document.getElementsByTagName("META")[2].content="Search "+this.state.brand_name+" branded quality Aquaculture " +/*data.url_dtype_name*/+" deals, choose the best deal price from our nearest partner and avail free shipment";
				};document.title = 'Buy ' + this.state.brand_name + ' Aqua Products Online | AquaDeals';
				document.getElementsByTagName("META")[2].content = "Search " + this.state.brand_name + " branded quality Aquaculture deals, choose the best deal price from our nearest partner and avail free shipment";
				var cat = this.state.cat.map(function (data, index) {
					var cat_count = this.state.cat.length;
					return _react2.default.createElement(
						'li',
						{ className: cat_count === 1 ? "abt_brnd_cat_item abt_less_items" : "abt_brnd_cat_item" },
						_react2.default.createElement(
							'span',
							{ className: 'abt_bran_cat_name' },
							data.name
						),
						_react2.default.createElement(
							'span',
							null,
							': ',
							data.count
						),
						' ',
						_react2.default.createElement(
							'i',
							null,
							_react2.default.createElement('img', { src: baseAssets + 'images/icons2/' + data.logo, width: '15px', alt: ' ' })
						)
					);
				}.bind(this));
				var products = this.state.products.map(function (data, index) {
					return _react2.default.createElement(
						'div',
						{ className: 'col-lg-6 col-md-6 col-sm-6 col-xs-6 abt_brnd_item' },
						data.dealcount >= 2 ? _react2.default.createElement(
							_reactRouter.Link,
							{ to: "/subdeals/" + data.url_dtype_name + "/" + data.url_cat_name + "/" + data.url_dtype + "/" + data.url_brand_name + "/" + data.pid },
							data.promo_ribbion ? _react2.default.createElement(
								'i',
								{ className: 'ribbon_img' },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + data.promo_ribbion, alt: '' })
							) : '',
							_react2.default.createElement(
								'div',
								{ className: 'abt_brnd_img_blk' },
								_react2.default.createElement('img', { src: data.image === null ? baseAssets + 'images/product_imgs/noimage1.jpg' : data.image, alt: '' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'abt_brnd_data_blk' },
								data.title ? _react2.default.createElement(
									'h5',
									{ className: 'abt_brnd_pro_name' },
									data.title
								) : _react2.default.createElement(
									'h5',
									{ className: 'abt_brnd_pro_name' },
									'\xA0'
								),
								data.mrp ? _react2.default.createElement(
									'p',
									{ className: 'abt_brnd_pro_price' },
									'MRP \u20B9 ',
									data.mrp
								) : '',
								data.count > 0 ? _react2.default.createElement(
									'span',
									{ className: 'abt_brnd_views' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/views.png', width: '17px', role: 'presentation' }),
									' ',
									data.count,
									' ',
									data.count > 1 ? ' Views' : 'View'
								) : ''
							)
						) : _react2.default.createElement(
							_reactRouter.Link,
							{ to: "/pdetails/" + data.url_dtype_name + "/" + data.url_cat_name + "/" + data.url_brand_name + "/" + data.url_product_name + "/" + data.pid + "/" + data.id },
							data.promo_ribbion ? _react2.default.createElement(
								'i',
								{ className: 'ribbon_img' },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + data.promo_ribbion, alt: '' })
							) : '',
							_react2.default.createElement(
								'div',
								{ className: 'abt_brnd_img_blk' },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: data.image, alt: '' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'abt_brnd_data_blk' },
								data.title ? _react2.default.createElement(
									'h5',
									{ className: 'abt_brnd_pro_name' },
									data.title
								) : _react2.default.createElement(
									'h5',
									{ className: 'abt_brnd_pro_name' },
									'\xA0'
								),
								data.mrp ? _react2.default.createElement(
									'p',
									{ className: 'abt_brnd_pro_price' },
									'MRP \u20B9 ',
									data.mrp
								) : '',
								data.count > 0 ? _react2.default.createElement(
									'span',
									{ className: 'abt_brnd_views' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/views.png', width: '17px', role: 'presentation' }),
									' ',
									data.count,
									' ',
									data.count > 1 ? 'Views' : 'View'
								) : ''
							)
						)
					);
				});
				// var following_btn=this.state.follow_status_flag ? <span className="pro_abt_follow_header_btn" onClick={()=>{this.FollowBrand(1)}}>Follow</span> : <span className="pro_abt_follow_header_btn_active" onClick={()=>this.FollowBrand(0)}>Following</span>;
				var likes_btn = this.state.like_status_flag ? _react2.default.createElement(
					'span',
					{ className: 'brand_dtls_likes', onClick: function onClick() {
							_this3.likeBrand(0);
						} },
					_react2.default.createElement('i', { className: "glyph_heart_active glyphicon glyphicon-heart" }),
					this.state.brand_likes_count === '1' ? this.state.brand_likes_count + ' Like' : this.state.brand_likes_count + ' Likes'
				) : _react2.default.createElement(
					'span',
					{ className: 'brand_dtls_likes', onClick: function onClick() {
							_this3.likeBrand(1);
						} },
					_react2.default.createElement('i', { className: "glyph_heart glyphicon glyphicon-heart" }),
					this.state.brand_likes_count === '1' ? this.state.brand_likes_count + ' Like' : this.state.brand_likes_count + ' Likes'
				);
				var description_blk = this.state.description ? _react2.default.createElement(
					'div',
					{ className: 'about_brand_dtls_blk' },
					_react2.default.createElement(
						'h5',
						{ className: 'abt_brnd_h5' },
						_react2.default.createElement(
							'span',
							null,
							'About the brand'
						),
						_react2.default.createElement(
							'span',
							{ style: { float: 'right', marginRight: '5px', cursor: 'pointer' }, onClick: function onClick() {
									_this3.ShareFunc();
								} },
							_react2.default.createElement(
								'i',
								null,
								_react2.default.createElement('img', { src: baseAssets + 'mob-assets/share.png', alt: 'share', width: '19px' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_reactBootstrap.Panel,
							{ className: 'abt_brnd_panel', collapsible: true, expanded: this.state.open },
							_react2.default.createElement(
								FacebookShareButton,
								{ url: 'https://goo.gl/5dhJSM', title: this.state.brand_name, description: this.state.share_msg, className: 'test_share1' },
								_react2.default.createElement(FacebookIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								TwitterShareButton,
								{ url: 'https://goo.gl/5dhJSM', title: this.state.brand_name, description: this.state.share_msg, className: 'test_share1' },
								_react2.default.createElement(TwitterIcon, { size: 32, round: true })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'abt_brnd_desc' },
						_react2.default.createElement(
							'p',
							null,
							this.state.description
						)
					)
				) : '';
				var people_liked = _react2.default.createElement(
					'div',
					{ className: 'brnd_liked_blk' },
					_react2.default.createElement(
						'h5',
						{ className: 'abt_brnd_h5' },
						'People who liked'
					),
					_react2.default.createElement(
						'div',
						{ style: { paddingLeft: '10px', fontSize: '12px', paddingTop: '8px' } },
						_react2.default.createElement(
							'p',
							null,
							'Liked by ',
							parseInt(this.state.brand_likes_count, 10) === 1 ? this.state.brand_likes_count + ' user' : this.state.brand_likes_count + ' users'
						),
						_react2.default.createElement(
							'div',
							{ className: 'pro_liked_profile_blk' },
							this.state.brand_like_users ? this.state.brand_like_users.map(function (data, index) {
								return _react2.default.createElement(
									'i',
									{ className: 'brnd_liked_profile_icon' },
									_react2.default.createElement('img', { src: baseAssets + 'images/pro_pics/' + data.pro_pic, alt: ' ', width: '30px' })
								);
							}) : '',
							parseInt(this.state.brand_like_rem_count, 10 > 0) ? _react2.default.createElement(
								'span',
								{ className: 'pro_liked_rem_count' },
								_react2.default.createElement(
									'span',
									null,
									'+',
									this.state.brand_like_rem_count
								)
							) : ''
						)
					)
				);
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals brand_dtls_page' },
					this.state.page_loading ? _react2.default.createElement(
						'div',
						{ className: 'mob_loading' },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/mob_loading.gif', alt: 'Loading' })
					) : _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'page_hdr' },
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ onClick: function onClick() {
												_reactRouter.browserHistory.goBack();
											} },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: ' ' })
										)
									),
									_react2.default.createElement(
										'span',
										{ className: 'brand_page_title' },
										this.state.brand_name ? this.state.brand_name : 'Brand Details'
									)
								),
								_react2.default.createElement(
									'a',
									{ href: '/', className: 'home_logo1' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'brand_dtls_blk', style: { textAlign: 'center', backgroundImage: "url('https://aquadeals.in/admin/assets/images" + this.state.brand_bg + "')" } },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { className: 'brand_logo_center', src: baseAssets + 'images/brand_icons/' + this.state.logo, alt: ' ' })
								),
								_react2.default.createElement(
									'h5',
									{ className: 'brand_dtls_title' },
									this.state.brand_name ? this.state.brand_name : 'Brand Name:'
								),
								_react2.default.createElement(
									'div',
									{ style: { marginTop: '15px' } },
									_react2.default.createElement(
										'div',
										{ className: 'col-sm-4 col-xs-4' },
										_react2.default.createElement(
											'p',
											{ style: { backgroundColor: '#fff', color: '#333', borderRadius: '20px', padding: '3px', fontSize: '11px', width: '80px' } },
											_react2.default.createElement(
												'i',
												{ style: { marginRight: '5px' } },
												_react2.default.createElement('img', { alt: ' ', width: '17px', src: baseAssets + 'images/web_imgs/views.png' })
											),
											this.state.views_count
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-sm-4 col-xs-4', style: { padding: '0px', textAlign: 'center', marginTop: '3px', fontSize: '12px' } },
										_react2.default.createElement(
											'a',
											{ className: 'brand_dtls_shop_btn', href: '/pdeals/brand/' + this.state.tot_data.url_brand_name + '/' + this.props.params.Bid },
											'SHOP BRAND'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-sm-4 col-xs-4', style: { paddingLeft: 0 } },
										likes_btn
									)
								)
							),
							this.state.brand_likes_count > 0 ? _react2.default.createElement(
								'div',
								{ style: { marginTop: '-12px' } },
								people_liked
							) : '',
							_react2.default.createElement(
								'div',
								{ style: { backgroundColor: '#f1f1f1', paddingTop: '7px' } },
								_react2.default.createElement(
									'p',
									{ className: 'abt_brand_p' },
									'Product Count : ',
									this.state.product_count
								),
								_react2.default.createElement(
									'div',
									{ className: 'abt_brnd_cat_blk' },
									_react2.default.createElement(
										'ul',
										{ className: 'brand_cats_tabs' },
										cat
									)
								)
							),
							_react2.default.createElement(
								'div',
								null,
								description_blk
							),
							_react2.default.createElement(
								'h5',
								{ className: 'abt_brnd_h5' },
								'Products'
							),
							_react2.default.createElement(
								'div',
								{ className: 'abt_brnd_deals_blk' },
								products.length > 0 ? products : ''
							)
						)
					)
				);
			}
		}]);
	
		return About_Brand;
	}(_react.Component);
	
	exports.default = About_Brand;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _custom_functions = __webpack_require__(69);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactWebVectorIcons = __webpack_require__(29);
	
	var _reactWebVectorIcons2 = _interopRequireDefault(_reactWebVectorIcons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Footer from './../Common/footer';
	
	
	var parseHtml = __webpack_require__(39);
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Checkout = function (_Component) {
		_inherits(Checkout, _Component);
	
		function Checkout(props) {
			_classCallCheck(this, Checkout);
	
			var _this = _possibleConstructorReturn(this, (Checkout.__proto__ || Object.getPrototypeOf(Checkout)).call(this, props));
	
			_this.state = {};
			_this.state = {
				page_loading: false,
				lod: false,
				user_address: [],
				edit_add_id: '',
				address_flag: 0,
				add_address_form_status: false,
				add_available: false,
				add_address: false,
				edit_address: false,
				click_here_status: false,
				tot_data: _this.props.total_cart_data,
				add_id: '',
				edit_data: [],
				// edit form elements 
				edit_name: '',
				edit_mobile: '',
				edit_state: '',
				edit_city: '',
				edit_doorno: '',
				edit_pincode: '',
	
				// add form elements
				add_name: localStorage.user_name,
				add_mobile: localStorage.user_mobile,
				add_state: '',
				add_city: '',
				add_doorno: '',
				add_pincode: '',
	
				//cart response 
				cart_count: 0,
				grand_total: 0,
				total_grand_total: 0,
				cart_add_id: '',
				coupon_code: 0,
				aqua_cash: '',
				coupons_amt: '',
				ac_discount: '',
	
				//cart calculations response
				mode: '',
				pay_advance: '',
				complete_amount: '',
				pay_at_outlet: '',
				final_amt: '',
				totals: '',
				other_amount_field_status: false,
				ptype: '',
				min_val: '',
				max_val: '',
				err_qty_status: false,
				err_qty_msg: '',
	
				paymentMethodStatus: '',
				offline_payment: '',
				prebook_payment: '',
				fullamount_payment: '',
				otheramount_payment: '',
	
				// cart calculations respnose before pay now
				deal_id: 0,
				product_id: 0,
				quantity: '',
				act_price: '',
				deal_price: '',
				total: '',
				total_discount: '',
				discount: '',
				pre_booking_amount: '',
				bank_fee: '',
				total_thx_fee: '',
				save_price: '',
				remaining_amount: '',
				payable_ad: '',
				payable_hatchery: '',
				ac_offer_title: '',
				aqua_cash_value: '',
				aqua_cash_code: '',
				ac_cal_info: '',
				pur_ern_ofr_code: '',
				pur_ern_ofr_title: '',
				pur_ern_ofr_desc: '',
				pur_ern_retrn_amt: '',
				full_aquacash_back_amount: '',
				full_aquacash_back_title: '',
				full_aquacash_back_code: '',
				full_aquacash_back_description: '',
				deal_type: '',
				promo_code: '',
				promo_amt: '',
				promo_title: '',
				promo_help: '',
				free_shipment: '',
				free_shipment_msg: '',
				user_details: [],
				user_details_sel: [],
				coupon_amt: '',
				cart_ids: '',
				promodiscount: '',
				applied_promos: '',
				promos: [],
				ac_enough: '',
				ac_enough_msg: '',
				applied_coupons: '',
	
				//variable for storing the payment radio buttons 
				total_online_payment: '',
				default_ptype: '',
				mode_loading: false,
				amount_loading: false,
				evnt_key: 2,
	
				// offline payment success displaying it in modal
				success_msg: '',
				thank_msg: '',
	
				offline_confirm_data: [],
				offline_pay_success_status: false,
	
				paying_process: false,
	
				// online payment response variables start
				pre_payment_id: '',
				order_id: '',
				//deal_type:'',
				//cart_ids:'',
				paid_amt: '',
				response: '',
				// online payment response variables ends here
	
				test_number: 0,
	
				time_interval: 0,
				pageId: '.checkout_page'
			};
			_this.testclose = _this.testclose.bind(_this);
	
			_this.getUserAddress = _this.getUserAddress.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.handleSubmit_add = _this.handleSubmit_add.bind(_this);
			_this.editAddress = _this.editAddress.bind(_this);
			_this.deleteAddress = _this.deleteAddress.bind(_this);
			_this.handleSubmit_edit = _this.handleSubmit_edit.bind(_this);
			_this.getAddressDetails = _this.getAddressDetails.bind(_this);
	
			// functions for edit address form
			_this.edit_nameChange = _this.edit_nameChange.bind(_this);
			_this.edit_mobileChange = _this.edit_mobileChange.bind(_this);
			_this.edit_stateChange = _this.edit_stateChange.bind(_this);
			_this.edit_cityChange = _this.edit_cityChange.bind(_this);
			_this.edit_doornoChange = _this.edit_doornoChange.bind(_this);
			_this.edit_pincodeChange = _this.edit_pincodeChange.bind(_this);
	
			// functions for add address form
			_this.add_nameChange = _this.add_nameChange.bind(_this);
			_this.add_mobileChange = _this.add_mobileChange.bind(_this);
			_this.add_stateChange = _this.add_stateChange.bind(_this);
			_this.add_cityChange = _this.add_cityChange.bind(_this);
			_this.add_doornoChange = _this.add_doornoChange.bind(_this);
			_this.add_pincodeChange = _this.add_pincodeChange.bind(_this);
	
			_this.getCart = _this.getCart.bind(_this);
			_this.getCartCalculations = _this.getCartCalculations.bind(_this);
			_this.validateOtherAmount = _this.validateOtherAmount.bind(_this);
	
			_this.modeChange_cartCalculations = _this.modeChange_cartCalculations.bind(_this);
			_this.handleTabsSelect = _this.handleTabsSelect.bind(_this);
			_this.payNow = _this.payNow.bind(_this);
			_this.ccAvenue = _this.ccAvenue.bind(_this);
	
			_this.other_amount_cartCalculations = _this.other_amount_cartCalculations.bind(_this);
			return _this;
		}
	
		_createClass(Checkout, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				this.props.get_rzp_keys("desktop_web");
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('checkout', '/checkout');
					_reactRouter.browserHistory.push('/login');
				}
				this.getUserAddress();
				// this.getCart();
			}
		}, {
			key: 'testclose',
			value: function testclose() {
				this.setState({
					offline_pay_success_status: false
				});
			}
		}, {
			key: 'ccAvenue',
			value: function ccAvenue() {
				var username = this.state.user_details.username;
				var email = this.state.user_details.email;
				var mobile = this.state.user_details.mobile;
				var address = this.state.user_details.address;
				var city = this.state.user_details.city;
				var pincode = this.state.user_details.pincode;
				var state = this.state.user_details.state;
				// var behalf_of=this.state.user_details.behalf_of;
				var deal_type = this.state.deal_type;
				var add_id = this.state.cart_add_id;
	
				var basePayUrl = 'https://aqua.deals/paymentGateWay/paymentRequestHandler.php';
				// var basePayUrl='http://203.193.173.125/paymentGateWay/paymentRequestHandler.php';
	
				var data1 = { access_code: 'AVIJ67DJ41BD20JIDB', merchant_id: '103328', order_id: this.state.order_id, merchant_param1: this.state.pre_payment_id, merchant_param2: deal_type, merchant_param3: add_id, merchant_param4: 'mobile_web', amount: this.state.paid_amt, currency: 'INR', cancel_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', redirect_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', billing_name: username, billing_address: address, billing_city: city, billing_state: state, billing_zip: pincode, billing_tel: mobile, billing_country: 'India', billing_email: email };
				// var data1={access_code:'AVJZ66DG16BM17ZJMB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:add_id,merchant_param4:'mobile_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',redirect_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
				_jquery2.default.ajax({
					method: 'POST',
					data: data1,
					url: basePayUrl,
					success: function (data) {
						(0, _jquery2.default)('.checkout_page').html(data);
					}.bind(this),
					error: function error(err) {}
				});
			}
			//payNow function is used to submit the values to 
	
		}, {
			key: 'payNow',
			value: function payNow() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (this.state.add_address_form_status) {
					this.setState({
						add_address: true
					});
				} else {
					this.setState({
						paying_process: true
					});
	
					// here this.state.ptype = mode of the payment 
					// 1:offline, 2:pay advance, 3:online pay total , 4: online pay other amount
					if (this.state.ptype === 1) {
						var data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, product_id: this.state.product_id, quantity: this.state.quantity, act_price: this.state.act_price, deal_price: this.state.deal_price, total: this.state.total, total_discount: this.state.total_discount, discount: this.state.discount, total_online_payment: this.state.total_online_payment, pre_booking_amount: this.state.pre_booking_amount, bank_fee: this.state.bank_fee, total_thx_fee: this.state.total_thx_fee, save_price: this.state.save_price, remaining_amount: this.state.remaining_amount, payable_ad: this.state.payable_ad, payable_hatchery: this.state.payable_hatchery, mode: this.state.ptype, coupons_amt: this.state.coupons_amt, aqua_cash: this.state.aqua_cash, ac_offer_title: this.state.ac_offer_title, aqua_cash_value: this.state.aqua_cash_value, aqua_cash_code: this.state.aqua_cash_code, ac_cal_info: this.state.ac_cal_info, pur_ern_ofr_code: this.state.pur_ern_ofr_code, pur_ern_ofr_title: this.state.pur_ern_ofr_title, pur_ern_ofr_desc: this.state.pur_ern_ofr_desc, pur_ern_retrn_amt: this.state.pur_ern_retrn_amt, full_aquacash_back_amount: this.state.full_aquacash_back_amount, full_aquacash_back_title: this.state.full_aquacash_back_title, full_aquacash_back_code: this.state.full_aquacash_back_code, full_aquacash_back_description: this.state.full_aquacash_back_description, deal_type: this.state.deal_type, promo_code: this.state.promo_code, promo_amt: this.state.promo_amt, promo_title: this.state.promo_title, promo_help: this.state.promo_help, free_shipment: this.state.free_shipment, free_shipment_msg: this.state.free_shipment_msg, paymentMethodStatus: this.state.paymentMethodStatus, add_id: this.state.cart_add_id, complete_amount: this.state.complete_amount, pay_advance: this.state.pay_advance, pay_at_outlet: this.state.pay_at_outlet, final_amt: this.state.final_amt, totals: this.state.totals, coupon_code: this.state.coupon_code, coupon_amt: this.state.coupon_amt, cart_ids: this.state.cart_ids, applied_coupons: this.state.applied_coupons, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, source: source, campaign: campaign, url_id: url_id };
						var data2 = JSON.stringify(data1);
						_jquery2.default.ajax({
							method: 'POST',
							dataType: 'json',
							data: { req: data2 },
							url: baseUrl + 'bookCart',
							success: function (data) {
								if (data.status === "success") {
									this.setState({
										offline_confirm_data: data,
										offline_pay_success_status: true,
										paying_process: false
									});
									(0, _jquery2.default)('#off_modal_status').parent().addClass('offline_modal');
								}
							}.bind(this),
							error: function error(err) {}
						});
					} else if (this.state.ptype === 3 || this.state.ptype === 2) {
						data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, product_id: this.state.product_id, quantity: this.state.quantity, act_price: this.state.act_price, deal_price: this.state.deal_price, total: this.state.total, total_discount: this.state.total_discount, discount: this.state.discount, total_online_payment: this.state.total_online_payment, pre_booking_amount: this.state.pre_booking_amount, bank_fee: this.state.bank_fee, total_thx_fee: this.state.total_thx_fee, save_price: this.state.save_price, remaining_amount: this.state.remaining_amount, payable_ad: this.state.payable_ad, payable_hatchery: this.state.payable_hatchery, mode: this.state.ptype, aqua_cash: this.state.aqua_cash, ac_offer_title: this.state.ac_offer_title, aqua_cash_value: this.state.aqua_cash_value, aqua_cash_code: this.state.aqua_cash_code, ac_cal_info: this.state.ac_cal_info, pur_ern_ofr_code: this.state.pur_ern_ofr_code, pur_ern_ofr_title: this.state.pur_ern_ofr_title, pur_ern_ofr_desc: this.state.pur_ern_ofr_desc, pur_ern_retrn_amt: this.state.pur_ern_retrn_amt, full_aquacash_back_title: this.state.full_aquacash_back_title, full_aquacash_back_code: this.state.full_aquacash_back_code, full_aquacash_back_description: this.state.full_aquacash_back_description, full_aquacash_back_amount: this.state.full_aquacash_back_amount, deal_type: this.state.deal_type, promo_code: this.state.promo_code, promo_amt: this.state.promo_amt, promo_title: this.state.promo_title, promo_help: this.state.promo_help, free_shipment: this.state.free_shipment, free_shipment_msg: this.state.free_shipment_msg, paymentMethodStatus: this.state.paymentMethodStatus, add_id: this.state.cart_add_id, complete_amount: this.state.complete_amount, pay_advance: this.state.pay_advance, pay_at_outlet: this.state.pay_at_outlet, final_amt: this.state.final_amt, totals: this.state.totals, coupon_code: this.state.coupon_code, coupon_amt: this.state.coupon_amt, cart_ids: this.state.cart_ids, applied_coupons: this.state.applied_coupons, coupons_amt: this.state.coupons_amt, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, source: source, campaign: campaign, url_id: url_id };
						data2 = JSON.stringify(data1);
						_jquery2.default.ajax({
							method: 'POST',
							dataType: 'json',
							data: { req: data2 },
							url: baseUrl + 'onlineCartProcessing',
							success: function (data) {
								if (data.status === "success") {
									this.setState({
										pre_payment_id: data.pre_payment_id,
										order_id: data.order_id,
										deal_type: data.deal_type,
										cart_ids: data.cart_ids,
										paid_amt: data.paid_amt
									});
									//this.ccAvenue();
									var payment_params = { from: 'mobile_web',
										uid: localStorage.getItem('user_id'),
										pre_payment_id: data.pre_payment_id,
										order_id: data.order_id,
										deal_type: data.deal_type,
										cart_ids: data.cart_ids,
										paid_amt: data.paid_amt,
										username: this.state.user_details.username,
										address: this.state.user_details.address,
										city: this.state.user_details.city,
										state: this.state.user_details.state,
										pincode: this.state.user_details.pincode,
										mobile: this.state.user_details.mobile,
										country: 'India',
										email: this.state.user_details.email,
										cart_add_id: this.state.cart_add_id,
										pageId: this.state.pageId,
										rzp_key: this.props.rzp_keys.key_id };
									if (this.state.gateway_mode == 2) {
										(0, _custom_functions.razorpayForm)(payment_params);
										this.setState({
											paying_process: false
										});
									} else {
										(0, _custom_functions.ccAvenue)(payment_params);
									}
								}
								if (data.status === "invalid") {
									this.toastMessage(data.message);
								}
							}.bind(this),
							error: function error(err) {
								console.log(err);
							}
						});
					} else if (this.state.ptype === 4) {
						var x = '';
						if (this.refs.ref_other_amt.value === "") {
							x = '* Enter Amount';
							this.setState({
								err_qty_msg: '* Enter Amount',
								err_qty_status: true
							});
						}
						if (parseInt(this.refs.ref_other_amt.value, 10) < parseInt(this.state.min_val, 10)) {
							x = 'Minimum Quantity is ' + this.state.min_val;
							this.setState({
								err_qty_status: true,
								err_qty_msg: '* Minimum amount is ' + this.state.min_val
							});
						}
						if (this.refs.ref_other_amt === '') {
							x = 'Minimum Quantity is ' + this.state.min_val;
							this.setState({
								err_qty_status: true,
								err_qty_msg: '* Minimum amount is ' + this.state.min_val
							});
						}
						if (parseInt(this.refs.ref_other_amt.value, 10) > parseInt(this.state.max_val, 10)) {
							// alert('Maximum Quantity is '+this.state.max_qty);
							x = 'Maximum Quantity is ' + this.state.max_val;
							this.setState({
								err_qty_status: true,
								err_qty_msg: '* Maximum amount is ' + this.state.max_val
							});
						}
						var check = /[^0-9]/gi;
						if (check.test(this.refs.ref_other_amt.value)) {
							x = '* Invalid Amount';
							this.setState({
								err_qty_status: true,
								err_qty_msg: '* Invalid Amount'
							});
						}
	
						if (x === '') {
	
							data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, product_id: this.state.product_id, quantity: this.state.quantity, act_price: this.state.act_price, deal_price: this.state.deal_price, total: this.state.total, total_discount: this.state.total_discount, discount: this.state.discount, total_online_payment: this.state.total_online_payment, pre_booking_amount: this.state.pre_booking_amount, bank_fee: this.state.bank_fee, total_thx_fee: this.state.total_thx_fee, save_price: this.state.save_price, remaining_amount: this.state.remaining_amount, payable_ad: this.state.payable_ad, payable_hatchery: this.state.payable_hatchery, mode: this.state.ptype, aqua_cash: this.state.aqua_cash, ac_offer_title: this.state.ac_offer_title, aqua_cash_value: this.state.aqua_cash_value, aqua_cash_code: this.state.aqua_cash_code, ac_cal_info: this.state.ac_cal_info, pur_ern_ofr_code: this.state.pur_ern_ofr_code, pur_ern_ofr_title: this.state.pur_ern_ofr_title, pur_ern_ofr_desc: this.state.pur_ern_ofr_desc, pur_ern_retrn_amt: this.state.pur_ern_retrn_amt, full_aquacash_back_title: this.state.full_aquacash_back_title, full_aquacash_back_code: this.state.full_aquacash_back_code, full_aquacash_back_description: this.state.full_aquacash_back_description, full_aquacash_back_amount: this.state.full_aquacash_back_amount, deal_type: this.state.deal_type, promo_code: this.state.promo_code, promo_amt: this.state.promo_amt, promo_title: this.state.promo_title, promo_help: this.state.promo_help, free_shipment: this.state.free_shipment, free_shipment_msg: this.state.free_shipment_msg, paymentMethodStatus: this.state.paymentMethodStatus, add_id: this.state.cart_add_id, complete_amount: this.state.complete_amount, pay_advance: this.state.pay_advance, pay_at_outlet: this.state.pay_at_outlet, final_amt: this.state.final_amt, totals: this.state.totals, coupon_code: this.state.coupon_code, coupon_amt: this.state.coupon_amt, cart_ids: this.state.cart_ids, applied_coupons: this.state.applied_coupons, coupons_amt: this.state.coupons_amt, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, source: source, campaign: campaign, url_id: url_id };
							data2 = JSON.stringify(data1);
							_jquery2.default.ajax({
								method: 'POST',
								dataType: 'json',
								data: { req: data2 },
								url: baseUrl + 'onlineCartProcessing',
								success: function (data) {
									if (data.status === "success") {
										this.setState({
											pre_payment_id: data.pre_payment_id,
											order_id: data.order_id,
											deal_type: data.deal_type,
											cart_ids: data.cart_ids,
											paid_amt: data.paid_amt
										});
										//this.ccAvenue();
										var payment_params = { from: 'mobile_web',
											uid: localStorage.getItem('user_id'),
											pre_payment_id: data.pre_payment_id,
											order_id: data.order_id,
											deal_type: data.deal_type,
											cart_ids: data.cart_ids,
											paid_amt: data.paid_amt,
											username: this.state.user_details.username,
											address: this.state.user_details.address,
											city: this.state.user_details.city,
											state: this.state.user_details.state,
											pincode: this.state.user_details.pincode,
											mobile: this.state.user_details.mobile,
											country: 'India',
											email: this.state.user_details.email,
											cart_add_id: this.state.cart_add_id,
											pageId: this.state.pageId,
											rzp_key: this.props.rzp_keys.key_id };
										if (this.state.gateway_mode == 2) {
											(0, _custom_functions.razorpayForm)(payment_params);
											this.setState({
												paying_process: false
											});
										} else {
											(0, _custom_functions.ccAvenue)(payment_params);
										}
									}
	
									if (data.status === "invalid") {
										this.toastMessage(data.message);
									}
								}.bind(this),
								error: function error(err) {}
							});
						} else {
							// alert('error');
						}
						this.setState({
							paying_process: false
						});
					}
				}
			}
			// getUserAddress function is used to get the address of the user when page loads. 
	
		}, {
			key: 'getUserAddress',
			value: function getUserAddress() {
				var _this2 = this;
	
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getuserAddress',
					success: function (data) {
						if (data.status === "success" && data.address.length > 0) {
							this.setState({
								user_address: data.address,
								address_flag: data.address_flag,
								add_available: true,
								click_here_status: false,
								add_address_form_status: false
							});
						} else if (data.status === "success" && data.address.length === 0) {
							this.setState({
								user_address: data.address,
								click_here_status: true,
								address_flag: data.address_flag,
								add_address_form_status: true
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
				this.getCart();
				setTimeout(function () {
					_this2.setState({ lod: true });
				}, 8000);
			}
			//getCart function is used to get the cart values from the cart page to get the cart values to the checkout page
	
		}, {
			key: 'getCart',
			value: function getCart() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var apply_coupon = localStorage.getItem('apply_coupon');
				var apply_coupon_code = localStorage.getItem('apply_coupon_code');
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), apply_ac: 1, apply_coupon: apply_coupon, apply_coupon_code: apply_coupon_code, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cart',
					success: function (data) {
						this.setState({
							total: data.total,
							cart_count: data.cart_count,
							//add_id:data.add_id,
							ac_discount: data.ac_discount,
							grand_total: data.grand_total,
							aqua_cash: data.aqua_cash,
							ac_enough: data.ac_enough,
							ac_enough_msg: data.ac_enough_msg,
							apply_ac: data.apply_ac,
							used_cash: data.used_cash,
							used_cash1: data.used_cash1,
							coupons: data.coupons,
							applied_coupons: data.applied_coupons,
							applied_coupons1: data.applied_coupons1,
							coupons_amt: data.coupons_amt,
							coupons_amt1: data.coupons_amt1,
							proceedCheck: data.proceedCheck,
							proceedMsg: data.proceedMsg,
							promodiscount: data.promodiscount,
							promos: data.promos,
							applied_promos: data.applied_promos,
							loc_msg: data.loc_msg,
							address_change: data.address_change,
							address: data.address,
							location: data.location,
							zip: data.zip,
							state: data.state,
							city: data.city,
							cart_add_id: data.add_id
						});
						this.getCartCalculations();
					}.bind(this),
					error: function error(err) {}
				});
			}
			//getCartCalculations function is used to get the results of the cart and payment types resutls.
	
		}, {
			key: 'getCartCalculations',
			value: function getCartCalculations() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				this.setState({
					mode_loading: true,
					amount_loading: true
				});
				var uid = 0;
				var token = 0;
				var coupon_code = 0;
				var coupon_amount = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.token) {
					token = localStorage.getItem('token');
				} else {
					token = 0;
				}
				if (localStorage.apply_coupon_code) {
					coupon_code = localStorage.getItem('apply_coupon_code');
				} else {
					coupon_code = 0;
				}
				if (localStorage.apply_coupon) {
					coupon_amount = localStorage.getItem('apply_coupon');
				} else {
					coupon_amount = 0;
				}
				var data1 = { from: 'mobile_web', uid: uid, token: token, mode: 2, add_id: this.state.cart_add_id, code: coupon_code, coupon_amount: coupon_amount, other_amount: '', aqua_cash: this.state.used_cash1, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cartCalculations',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								mode_loading: false,
								page_loading: true,
								amount_loading: false,
								mode: data.mode,
								ptype: data.mode,
								default_ptype: data.mode,
								final_amt: data.final_amt,
								pay_at_outlet: data.pay_at_outlet,
								pay_advance: data.pay_advance,
								complete_amount: data.complete_amount,
								min_val: data.min_val,
								max_val: data.max_val,
	
								paymentMethodStatus: data.paymentMethodStatus,
								offline_payment: data.offline_payment,
								prebook_payment: data.prebook_payment,
								fullamount_payment: data.fullamount_payment,
								otheramount_payment: data.otheramount_payment,
	
								total_online_payment: data.total_online_payment,
	
								product_id: data.product_id,
								quantity: data.quantity,
								act_price: data.act_price,
								deal_price: data.deal_price,
								total: data.total,
								total_discount: data.total_discount,
								discount: data.discount,
								pre_booking_amount: data.pre_booking_amount,
								bank_fee: data.bank_fee,
								total_thx_fee: data.total_thx_fee,
								save_price: data.save_price,
								remaining_amount: data.remaining_amount,
								payable_ad: data.payable_ad,
								payable_hatchery: data.payable_hatchery,
								aqua_cash: data.aqua_cash,
								ac_offer_title: data.ac_offer_title,
								aqua_cash_value: data.aqua_cash_value,
								aqua_cash_code: data.aqua_cash_code,
								ac_cal_info: data.ac_cal_info,
								pur_ern_ofr_code: data.pur_ern_ofr_code,
								pur_ern_ofr_title: data.pur_ern_ofr_title,
								pur_ern_ofr_desc: data.pur_ern_ofr_desc,
								pur_ern_retrn_amt: data.pur_ern_retrn_amt,
								full_aquacash_back_title: data.full_aquacash_back_title,
								full_aquacash_back_code: data.full_aquacash_back_code,
								full_aquacash_back_description: data.full_aquacash_back_description,
								full_aquacash_back_amount: data.full_aquacash_back_amount,
								deal_type: data.deal_type,
								promo_code: data.promo_code,
								promo_amt: data.promo_amt,
								promo_title: data.promo_title,
								promo_help: data.promo_help,
								free_shipment: data.free_shipment,
								free_shipment_msg: data.free_shipment_msg,
								coupon_code: data.coupon_code,
								coupon_amt: data.coupon_amt,
								cart_ids: data.cart_ids,
								coupons_amt: data.coupons_amt,
								promodiscount: data.promodiscount,
								applied_promos: data.applied_promos,
	
								user_details: data.user_details,
								cart_add_id: data.add_id,
								gateway_mode: data.gateway_mode,
								deliver_date_text: data.deliver_date_text,
								payment_options: data.payment_options
							});
	
							if (data.mode !== 1) {
								this.setState({
									evnt_key: 2
								});
							}
						}
					}.bind(this),
					error: function (err) {
						this.setState({
							page_loading: false,
							lod: true
						});
					}.bind(this)
				});
			}
		}, {
			key: 'other_amount_cartCalculations',
			value: function other_amount_cartCalculations(mode, other_amount) {
				this.setState({
					amount_loading: true
				});
	
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var uid = 0;
				var token = 0;
				var coupon_code = 0;
				var coupon_amount = 0;
	
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.token) {
					token = localStorage.getItem('token');
				} else {
					token = 0;
				}
				if (localStorage.apply_coupon_code) {
					coupon_code = localStorage.getItem('apply_coupon_code');
				} else {
					coupon_code = 0;
				}
				if (localStorage.apply_coupon) {
					coupon_amount = localStorage.getItem('apply_coupon');
				} else {
					coupon_amount = 0;
				}
				var data1 = { from: 'mobile_web', uid: uid, token: token, mode: 4, add_id: this.state.cart_add_id, code: coupon_code, coupon_amount: coupon_amount, other_amount: other_amount, aqua_cash: this.state.used_cash1, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cartCalculations',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								// mode_loading:false,
								amount_loading: false,
								mode: data.mode,
								ptype: data.mode,
								final_amt: data.final_amt,
								pay_at_outlet: data.pay_at_outlet,
								pay_advance: data.pay_advance,
								complete_amount: data.complete_amount,
								min_val: data.min_val,
								max_val: data.max_val,
	
								paymentMethodStatus: data.paymentMethodStatus,
								offline_payment: data.offline_payment,
								prebook_payment: data.prebook_payment,
								fullamount_payment: data.fullamount_payment,
								otheramount_payment: data.otheramount_payment,
								total_online_payment: data.total_online_payment,
								product_id: data.product_id,
								quantity: data.quantity,
								act_price: data.act_price,
								deal_price: data.deal_price,
								total: data.total,
								total_discount: data.total_discount,
								discount: data.discount,
								pre_booking_amount: data.pre_booking_amount,
								bank_fee: data.bank_fee,
								total_thx_fee: data.total_thx_fee,
								save_price: data.save_price,
								remaining_amount: data.remaining_amount,
								payable_ad: data.payable_ad,
								payable_hatchery: data.payable_hatchery,
								aqua_cash: data.aqua_cash,
								ac_offer_title: data.ac_offer_title,
								aqua_cash_value: data.aqua_cash_value,
								aqua_cash_code: data.aqua_cash_code,
								ac_cal_info: data.ac_cal_info,
								pur_ern_ofr_code: data.pur_ern_ofr_code,
								pur_ern_ofr_title: data.pur_ern_ofr_title,
								pur_ern_ofr_desc: data.pur_ern_ofr_desc,
								pur_ern_retrn_amt: data.pur_ern_retrn_amt,
								full_aquacash_back_title: data.full_aquacash_back_title,
								full_aquacash_back_code: data.full_aquacash_back_code,
								full_aquacash_back_description: data.full_aquacash_back_description,
								full_aquacash_back_amount: data.full_aquacash_back_amount,
								deal_type: data.deal_type,
								promo_code: data.promo_code,
								promo_amt: data.promo_amt,
								promo_title: data.promo_title,
								promo_help: data.promo_help,
								free_shipment: data.free_shipment,
								free_shipment_msg: data.free_shipment_msg,
								coupon_code: data.coupon_code,
								coupon_amt: data.coupon_amt,
								cart_ids: data.cart_ids,
								coupons_amt: data.coupons_amt,
								promodiscount: data.promodiscount,
								applied_promos: data.applied_promos,
	
								user_details: data.user_details,
								cart_add_id: data.add_id,
								gateway_mode: data.gateway_mode,
								payment_options: data.payment_options
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'modeChange_cartCalculations',
			value: function modeChange_cartCalculations(mode) {
				this.setState({
					mode_loading: true,
					amount_loading: true
				});
				var uid = 0;
				var token = 0;
				var coupon_code = 0;
				var coupon_amount = 0;
	
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
	
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.token) {
					token = localStorage.getItem('token');
				} else {
					token = 0;
				}
				if (localStorage.apply_coupon_code) {
					coupon_code = localStorage.getItem('apply_coupon_code');
				} else {
					coupon_code = 0;
				}
				if (localStorage.apply_coupon) {
					coupon_amount = localStorage.getItem('apply_coupon');
				} else {
					coupon_amount = 0;
				}
				var data1 = { from: 'mobile_web', uid: uid, token: token, mode: mode, add_id: this.state.cart_add_id, code: coupon_code, coupon_amount: coupon_amount, other_amount: '', aqua_cash: this.state.used_cash1, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cartCalculations',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								mode_loading: false,
								amount_loading: false,
								mode: data.mode,
								ptype: data.mode,
								final_amt: data.final_amt,
								pay_at_outlet: data.pay_at_outlet,
								pay_advance: data.pay_advance,
								complete_amount: data.complete_amount,
								min_val: data.min_val,
								max_val: data.max_val,
	
								paymentMethodStatus: data.paymentMethodStatus,
								offline_payment: data.offline_payment,
								prebook_payment: data.prebook_payment,
								fullamount_payment: data.fullamount_payment,
								otheramount_payment: data.otheramount_payment,
								total_online_payment: data.total_online_payment,
								product_id: data.product_id,
								quantity: data.quantity,
								act_price: data.act_price,
								deal_price: data.deal_price,
								total: data.total,
								total_discount: data.total_discount,
								discount: data.discount,
								pre_booking_amount: data.pre_booking_amount,
								bank_fee: data.bank_fee,
								total_thx_fee: data.total_thx_fee,
								save_price: data.save_price,
								remaining_amount: data.remaining_amount,
								payable_ad: data.payable_ad,
								payable_hatchery: data.payable_hatchery,
								aqua_cash: data.aqua_cash,
								ac_offer_title: data.ac_offer_title,
								aqua_cash_value: data.aqua_cash_value,
								aqua_cash_code: data.aqua_cash_code,
								ac_cal_info: data.ac_cal_info,
								pur_ern_ofr_code: data.pur_ern_ofr_code,
								pur_ern_ofr_title: data.pur_ern_ofr_title,
								pur_ern_ofr_desc: data.pur_ern_ofr_desc,
								pur_ern_retrn_amt: data.pur_ern_retrn_amt,
								full_aquacash_back_title: data.full_aquacash_back_title,
								full_aquacash_back_code: data.full_aquacash_back_code,
								full_aquacash_back_description: data.full_aquacash_back_description,
								full_aquacash_back_amount: data.full_aquacash_back_amount,
								deal_type: data.deal_type,
								promo_code: data.promo_code,
								promo_amt: data.promo_amt,
								promo_title: data.promo_title,
								promo_help: data.promo_help,
								free_shipment: data.free_shipment,
								free_shipment_msg: data.free_shipment_msg,
								coupon_code: data.coupon_code,
								coupon_amt: data.coupon_amt,
								cart_ids: data.cart_ids,
								coupons_amt: data.coupons_amt,
								promodiscount: data.promodiscount,
								applied_promos: data.applied_promos,
	
								user_details: data.user_details,
								cart_add_id: data.add_id,
								gateway_mode: data.gateway_mode,
								payment_options: data.payment_options
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			// close function is used to close both edit address modal & add address modal boxes.
	
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					add_address: false,
					edit_address: false
				});
			}
			// handleSubmit_add function for submitting the new address when click on add new address 
	
		}, {
			key: 'handleSubmit_add',
			value: function handleSubmit_add(event) {
				event.preventDefault();
				var name = this.refs.add_name.value;
				var mobile = this.refs.add_mobile.value;
				var state = this.refs.add_state.value;
				var city = this.refs.add_city.value;
				var doorno = this.refs.add_doorno.value;
				var pincode = this.refs.add_pincode.value;
	
				var flag = 0;
				var namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
				if (name && !namePattern.test(name)) {
					(0, _jquery2.default)('#add_name_err').text('*name is minimum 3 characters');
					flag = 1;
				}
				if (mobile.length < 10) {
					(0, _jquery2.default)('#add_mobile_err').text('*enter valid number');
					flag = 1;
				}
				if (state && !namePattern.test(state) && state.length < 2) {
					(0, _jquery2.default)('#add_state_err').text('*enter state');
					flag = 1;
				}
				if (city && !namePattern.test(city)) {
					(0, _jquery2.default)('#add_city_err').text('*enter city');
					flag = 1;
				}
				if (doorno && doorno.length <= 1) {
					(0, _jquery2.default)('#add_doorno_err').text('*enter address');
					flag = 1;
				}
				if (pincode && pincode.length < 6) {
					(0, _jquery2.default)('#add_pincode_err').text('*enter valid pincode');
					flag = 1;
				}
				if (flag === 0) {
	
					var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, name: name, mobile: mobile, state: state, city: city, address: doorno, zip: pincode };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'saveAdd',
						success: function (data) {
							if (data.status === "success") {
								this.close();
								this.getUserAddress();
								this.setState({
									add_state: '',
									add_city: '',
									add_doorno: '',
									add_pincode: ''
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
			//handleSubmit_edit function for updating the address when click on edit icon in the swipe list.
	
		}, {
			key: 'handleSubmit_edit',
			value: function handleSubmit_edit(event) {
				event.preventDefault();
				var add_id = this.state.edit_add_id;
	
				var name = this.refs.edit_name.value;
				var mobile = this.refs.edit_mobile.value;
				var state = this.refs.edit_state.value;
				var city = this.refs.edit_city.value;
				var doorno = this.refs.edit_doorno.value;
				var pincode = this.refs.edit_pincode.value;
	
				var flag = 0;
				// const emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
				var namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
				if (name && !namePattern.test(name)) {
					(0, _jquery2.default)('#edit_name_err').text('*name is minimum 3 characters');
					flag = 1;
				}
				if (mobile.length < 10) {
					(0, _jquery2.default)('#edit_mobile_err').text('*enter valid number');
					flag = 1;
				}
				if (state && !namePattern.test(state) && state.length < 2) {
					(0, _jquery2.default)('#edit_state_err').text('*enter state');
					flag = 1;
				}
				if (city && !namePattern.test(city)) {
					(0, _jquery2.default)('#edit_city_err').text('*enter city');
					flag = 1;
				}
				if (doorno && doorno.length <= 1) {
					(0, _jquery2.default)('#edit_doorno_err').text('*enter address');
					flag = 1;
				}
				if (pincode && pincode.length < 6) {
					(0, _jquery2.default)('#edit_pincode_err').text('*enter valid pincode');
					flag = 1;
				}
	
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (flag === 0) {
					var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, add_id: add_id, name: name, mobile: mobile, state: state, city: city, address: doorno, zip: pincode, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'updateAdd',
						success: function (data) {
							if (data.status === "success") {
								this.close();
								this.getUserAddress();
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
			//editAddress function for when click on edit icon that enables the status of the Edit form modal
	
		}, {
			key: 'editAddress',
			value: function editAddress(add_id) {
				this.setState({
					edit_add_id: add_id,
					edit_address: true
				});
			}
			// deleteAddress function is used when click on deleted icon in swipe address list
	
		}, {
			key: 'deleteAddress',
			value: function deleteAddress(add_id) {
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, add_id: add_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'deleteAdd',
					success: function (data) {
						if (data.status === "success") {
							this.getUserAddress();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			// getAddressDetails function is used to get the address details from server when click the edit icon and edit modal form is opened. 
	
		}, {
			key: 'getAddressDetails',
			value: function getAddressDetails() {
	
				var add_id = this.state.edit_add_id;
				var data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, id: add_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'get_add_details',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								edit_data: data.data,
								edit_name: data.data[0]['name'],
								edit_mobile: data.data[0]['phone'],
								edit_state: data.data[0]['state'],
								edit_city: data.data[0]['city'],
								edit_doorno: data.data[0]['address'],
								edit_pincode: data.data[0]['zip']
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			//******************
			/* functions for EDIT form validations and upations start here  */
	
			// edit_nameChange function is used to set the edit_name value edit modal form.
	
		}, {
			key: 'edit_nameChange',
			value: function edit_nameChange(event) {
				this.setState({
					edit_name: event.target.value
				});
			}
		}, {
			key: 'edit_mobileChange',
			value: function edit_mobileChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						edit_mobile: x
					});
				}
			}
		}, {
			key: 'edit_stateChange',
			value: function edit_stateChange(event) {
				this.setState({
					edit_state: event.target.value
				});
			}
		}, {
			key: 'edit_cityChange',
			value: function edit_cityChange(event) {
				this.setState({
					edit_city: event.target.value
				});
			}
		}, {
			key: 'edit_doornoChange',
			value: function edit_doornoChange(event) {
				this.setState({
					edit_doorno: event.target.value
				});
			}
		}, {
			key: 'edit_pincodeChange',
			value: function edit_pincodeChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						edit_pincode: x
					});
				}
				// this.setState({
				// 	edit_pincode:event.target.value,
				// });
			}
			// **********************************
			// functions for "EDIT" form validations and upations "ENDS" here
	
			// functions for "ADD" form validations and updations START here 
			// ***************************************
	
		}, {
			key: 'add_nameChange',
			value: function add_nameChange(event) {
				this.setState({
					add_name: event.target.value
				});
			}
		}, {
			key: 'add_mobileChange',
			value: function add_mobileChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						add_mobile: x
					});
				}
			}
		}, {
			key: 'add_stateChange',
			value: function add_stateChange(event) {
				this.setState({
					add_state: event.target.value
				});
			}
		}, {
			key: 'add_cityChange',
			value: function add_cityChange(event) {
				this.setState({
					add_city: event.target.value
				});
			}
		}, {
			key: 'add_doornoChange',
			value: function add_doornoChange(event) {
				this.setState({
					add_doorno: event.target.value
				});
			}
		}, {
			key: 'add_pincodeChange',
			value: function add_pincodeChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						add_pincode: x
					});
				}
			}
			// ***********************************
	
			// setDefaultAddress function is used to set the default address when click on circle image in address block 
	
	
			//setPaymentMode is used to set the mode of the payment like 2 for - advance,3 for total,4 for other and calling the modeChange_cartCalculations
			//hiding the other amount input field and calling
	
		}, {
			key: 'setPaymentMode',
			value: function setPaymentMode(id) {
				this.setState({
					ptype: id,
					mode: id
				});
				if (id === 4) {
					this.setState({
						other_amount_field_status: true
					});
				} else {
					this.setState({
						other_amount_field_status: false
					});
					this.modeChange_cartCalculations(id);
				}
			}
		}, {
			key: 'validateOtherAmount',
			value: function validateOtherAmount() {
	
				this.setState({
					err_qty_status: false,
					err_qty_msg: ''
				});
				var x = '';
				if (parseInt(this.refs.ref_other_amt.value, 10) < parseInt(this.state.min_val, 10)) {
					x = 'Minimum Quantity is ' + this.state.min_val;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Minimum amount is ' + this.state.min_val
					});
				}
				if (parseInt(this.refs.ref_other_amt.value, 10) > parseInt(this.state.max_val, 10)) {
					// alert('Maximum Quantity is '+this.state.max_qty);
					x = 'Maximum Quantity is ' + this.state.max_val;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Maximum amount is ' + this.state.max_val
					});
				}
				var check = /[^0-9]/gi;
				if (check.test(this.refs.ref_other_amt.value)) {
					x = '* Invalid Amount';
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Invalid Amount'
					});
				}
	
				// this.other_amount_cartCalculations(4,this.refs.ref_other_amt.value);
	
				if (x === '') {
					this.other_amount_cartCalculations(4, this.refs.ref_other_amt.value);
				}
			}
		}, {
			key: 'handleTabsSelect',
			value: function handleTabsSelect(key) {
				this.setState({
					evnt_key: key
				});
				this.modeChange_cartCalculations(key);
			}
		}, {
			key: 'toastMessage',
			value: function toastMessage(text) {
				var x = document.getElementById("snackbar");
				x.innerHTML = text;
				x.className = "show";
				setTimeout(function () {
					x.className = x.className.replace("show", "");_reactRouter.browserHistory.push('/home');
				}, 5000);
			}
	
			// functions for "ADD" form validations and updations END here 
	
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				document.title = "Checkout | AquaDeals";
				var tabs_data = '';
				var i = 0;
	
				(0, _jquery2.default)('.mob_check').unbind("click").click(function () {
					(0, _jquery2.default)(".mob_check img").attr("src", "https://aquadeals.in/admin/assets/images/icons/circle_gray.png");
					var sel_addr_id = (0, _jquery2.default)(this).attr("id");
					var add_id = sel_addr_id.replace('swipe-addr-id_', '');
					(0, _jquery2.default)("#" + sel_addr_id + " .mob_check img").attr("src", "https://aquadeals.in/admin/assets/images/icons/ok.png");
					//$(".swipe_addr_blk .mob_check img").attr('src',"https://aquadeals.in/admin/assets/images/icons/circle_gray.png");
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, add_id: add_id, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'setdefault_address',
						success: function (data) {
							if (data.status === "success") {
								//this.getUserAddress();
							}
						}.bind(this),
						error: function error(err) {
							console.log(err);
						}
					});
				});
	
				//      if(this.state.user_address.length==1){
				// $(".checkout_page .swiper-slide:nth-of-type(1)").unbind("css").css({margin:'0 auto'});        	        	
				//      }	
	
	
				// $('#off_modal_status').parent().addClass('offline_modal');
				if (this.state.payment_options == 0) {
					tabs_data = '';
				} else if (this.state.paymentMethodStatus === 'Both') {
					tabs_data = _react2.default.createElement(
						'section',
						{ className: 'payment_layout' },
						_react2.default.createElement(
							'section',
							{ className: 'chk_pay_opts_blk' },
							_react2.default.createElement(
								'h5',
								null,
								'PAYMENT OPTIONS'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Tabs,
							{ activeKey: this.state.evnt_key, className: 'pay_both', id: 'controlled-tab-example', onSelect: this.handleTabsSelect },
							_react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 2, title: 'ONLINE' },
								_react2.default.createElement(
									'div',
									null,
									this.state.prebook_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 2 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_adv', checked: this.state.ptype === 2 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(2);
												}, required: true }),
											'Pay Advance \u20B9 ',
											this.state.pay_advance
										)
									) : '',
									this.state.otheramount_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 4 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_other', checked: this.state.ptype === 4 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(4);
												}, required: true }),
											'Pay Other Advance ',
											this.state.other_amount_field_status ? _react2.default.createElement(
												'span',
												{ style: { marginLeft: '10px', position: 'absolute' } },
												_react2.default.createElement('input', { onChange: function onChange() {
														return _this3.validateOtherAmount();
													}, ref: 'ref_other_amt', id: 'ref_other_amt', type: 'text', placeholder: 'Enter Amount' }),
												this.state.err_qty_status ? _react2.default.createElement(
													'span',
													{ className: 'error_other_amt' },
													this.state.err_qty_msg
												) : ''
											) : ''
										)
									) : '',
									this.state.fullamount_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 3 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_total', checked: this.state.ptype === 3 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(3);
												}, required: true }),
											'Pay Total \u20B9 ',
											this.state.final_amt
										)
									) : '',
									this.state.free_shipment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'mob_ship_van' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
										),
										' ',
										this.state.free_shipment_msg
									) : ''
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 1, title: 'OFFLINE' },
								_react2.default.createElement(
									'div',
									null,
									this.state.offline_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 1 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_outlet', checked: this.state.ptype === 1 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(1);
												}, required: true }),
											'Pay at Outlet \u20B9 ',
											this.state.final_amt
										),
										this.state.free_shipment === 1 ? _react2.default.createElement(
											'div',
											{ className: 'mob_ship_van' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
											),
											' ',
											this.state.free_shipment_msg
										) : ''
									) : ''
								)
							)
						)
					);
				} else if (this.state.paymentMethodStatus === 'Online') {
					tabs_data = _react2.default.createElement(
						'section',
						{ className: 'payment_layout' },
						_react2.default.createElement(
							'section',
							{ className: 'chk_pay_opts_blk' },
							_react2.default.createElement(
								'h5',
								null,
								'PAYMENT OPTIONS'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Tabs,
							{ activeKey: this.state.evnt_key, className: 'pay_online tab_single_active', id: 'controlled-tab-example', onSelect: this.handleTabsSelect },
							_react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 2, title: 'ONLINE', style: { borderRight: 'none' } },
								_react2.default.createElement(
									'div',
									null,
									this.state.prebook_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 2 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_adv', checked: this.state.ptype === 2 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(2);
												}, required: true }),
											'Pay Advance \u20B9 ',
											this.state.pay_advance
										)
									) : '',
									this.state.otheramount_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 4 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_other', checked: this.state.ptype === 4 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(4);
												}, required: true }),
											'Pay Other Advance ',
											this.state.other_amount_field_status ? _react2.default.createElement(
												'span',
												{ style: { marginLeft: '10px', position: 'absolute' } },
												_react2.default.createElement('input', { onChange: function onChange() {
														return _this3.validateOtherAmount();
													}, ref: 'ref_other_amt', id: 'ref_other_amt', type: 'text', placeholder: 'Enter Amount' }),
												this.state.err_qty_status ? _react2.default.createElement(
													'span',
													{ className: 'error_other_amt' },
													this.state.err_qty_msg
												) : ''
											) : ''
										)
									) : '',
									this.state.fullamount_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 3 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_total', checked: this.state.ptype === 3 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(3);
												}, required: true }),
											'Pay Total \u20B9 ',
											this.state.final_amt
										)
									) : '',
									this.state.free_shipment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'mob_ship_van' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
										),
										' ',
										this.state.free_shipment_msg
									) : ''
								)
							),
							this.state.offline_payment === 1 ? _react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 1, title: 'OFFLINE' },
								_react2.default.createElement(
									'div',
									null,
									this.state.offline_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 1 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_outlet', checked: this.state.ptype === 1 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(1);
												}, required: true }),
											'Pay at Outlet \u20B9 ',
											this.state.final_amt
										),
										this.state.free_shipment === 1 ? _react2.default.createElement(
											'div',
											{ className: 'mob_ship_van' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
											),
											' ',
											this.state.free_shipment_msg
										) : ''
									) : ''
								)
							) : ''
						)
					);
				} else if (this.state.paymentMethodStatus === 'Offline') {
					tabs_data = _react2.default.createElement(
						'section',
						{ className: 'payment_layout' },
						_react2.default.createElement(
							'section',
							{ className: 'chk_pay_opts_blk' },
							_react2.default.createElement(
								'h5',
								null,
								'PAYMENT OPTIONS'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Tabs,
							{ activeKey: 1, className: 'pay_offline tab_single_active', id: 'controlled-tab-example' },
							this.state.offline_payment === 1 ? _react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 1, title: 'OFFLINE' },
								_react2.default.createElement(
									'div',
									null,
									this.state.offline_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 1 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_outlet', checked: this.state.ptype === 1 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(1);
												}, required: true }),
											'Pay at Outlet \u20B9 ',
											this.state.final_amt
										),
										this.state.free_shipment === 1 ? _react2.default.createElement(
											'div',
											{ className: 'mob_ship_van' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
											),
											' ',
											this.state.free_shipment_msg
										) : ''
									) : ''
								)
							) : ''
						)
					);
				} else if (this.state.paymentMethodStatus === 'None') {
					tabs_data = _react2.default.createElement(
						'section',
						{ className: 'payment_layout' },
						_react2.default.createElement(
							'section',
							{ className: 'chk_pay_opts_blk' },
							_react2.default.createElement(
								'h5',
								null,
								'PAYMENT OPTIONS'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Tabs,
							{ activeKey: this.state.evnt_key, id: 'controlled-tab-example', onSelect: this.handleTabsSelect, className: 'pay_partner' },
							_react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 2, title: 'ONLINE' },
								_react2.default.createElement(
									'div',
									null,
									this.state.prebook_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 2 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_adv', checked: this.state.ptype === 2 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(2);
												}, required: true }),
											'Pay Advance \u20B9 ',
											this.state.pay_advance
										)
									) : '',
									this.state.otheramount_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 4 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_other', checked: this.state.ptype === 4 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(4);
												}, required: true }),
											'Pay Other Advance ',
											this.state.other_amount_field_status ? _react2.default.createElement(
												'span',
												{ style: { marginLeft: '10px', position: 'absolute' } },
												_react2.default.createElement('input', { onChange: function onChange() {
														return _this3.validateOtherAmount();
													}, ref: 'ref_other_amt', id: 'ref_other_amt', type: 'text', placeholder: 'Enter Amount' }),
												this.state.err_qty_status ? _react2.default.createElement(
													'span',
													{ className: 'error_other_amt' },
													this.state.err_qty_msg
												) : ''
											) : ''
										)
									) : '',
									this.state.fullamount_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 3 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_total', checked: this.state.ptype === 3 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(3);
												}, required: true }),
											'Pay Total \u20B9 ',
											this.state.final_amt
										)
									) : '',
									this.state.free_shipment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'mob_ship_van' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
										),
										' ',
										this.state.free_shipment_msg
									) : ''
								)
							),
							this.state.offline_payment === 1 ? _react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 1, title: 'OFFLINE' },
								_react2.default.createElement(
									'div',
									null,
									this.state.offline_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 1 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_outlet', checked: this.state.ptype === 1 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(1);
												}, required: true }),
											'Pay at Outlet \u20B9 ',
											this.state.final_amt
										),
										this.state.free_shipment === 1 ? _react2.default.createElement(
											'div',
											{ className: 'mob_ship_van' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', alt: '', width: '25px' })
											),
											' ',
											this.state.free_shipment_msg
										) : '',
										this.state.full_aquacash_back_title ? _react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/newcashback.png', alt: '', width: '20px', className: 'rp_coin' }),
												' '
											),
											' ',
											this.state.full_aquacash_back_title
										) : ''
									) : ''
								)
							) : ''
						)
					);
				}
	
				// edit form empty errors when click on the text input fields starts here
				(0, _jquery2.default)('#edit_name').keyup(function () {
					(0, _jquery2.default)('#edit_name_err').text('');
				});
				(0, _jquery2.default)('#edit_mobile').keyup(function () {
					(0, _jquery2.default)('#edit_mobile_err').text('');
				});
				(0, _jquery2.default)('#edit_state').keyup(function () {
					(0, _jquery2.default)('#edit_state_err').text('');
				});
				(0, _jquery2.default)('#edit_city').keyup(function () {
					(0, _jquery2.default)('#edit_city_err').text('');
				});
				(0, _jquery2.default)('#edit_doorno').keyup(function () {
					(0, _jquery2.default)('#edit_doorno_err').text('');
				});
				(0, _jquery2.default)('#edit_pincode').keyup(function () {
					(0, _jquery2.default)('#edit_pincode_err').text('');
				});
				// edit form validations ends here
	
				// add form removing error msg's when click on input fields start here
				(0, _jquery2.default)('#add_name').keyup(function () {
					(0, _jquery2.default)('#add_name_err').text('');
				});
				(0, _jquery2.default)('#add_mobile').keyup(function () {
					(0, _jquery2.default)('#add_mobile_err').text('');
				});
				(0, _jquery2.default)('#add_state').keyup(function () {
					(0, _jquery2.default)('#add_state_err').text('');
				});
				(0, _jquery2.default)('#add_city').keyup(function () {
					(0, _jquery2.default)('#add_city_err').text('');
				});
				(0, _jquery2.default)('#add_doorno').keyup(function () {
					(0, _jquery2.default)('#add_doorno_err').text('');
				});
				(0, _jquery2.default)('#add_pincode').keyup(function () {
					(0, _jquery2.default)('#add_pincode_err').text('');
				});
				var params = {
					paginationClickable: true,
					spaceBetween: 0,
					slidesPerView: 1.4
				};
	
				var delivery_address = this.state.user_address.map(function (data, index) {
					var _this4 = this;
	
					return localStorage.address_change_flag === '0' ? _react2.default.createElement(
						_reactBootstrap.Col,
						{ md: 12, xs: 12, className: 'swipe_addr_blk', id: "swipe-addr-id_" + data.add_id },
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 3, sm: 3, xs: 2, className: 'mob_check', id: "swipe-addr-id_" + data.add_id },
							_react2.default.createElement('img', { src: data.default === '1' ? baseAssets + 'images/icons/ok.png' : baseAssets + 'images/icons/circle_gray.png', alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ style: { margin: '0 20px' } },
							_react2.default.createElement(
								_reactBootstrap.Col,
								{ md: 10, sm: 10, xs: 10, className: 's_data_blk' },
								_react2.default.createElement(
									'p',
									null,
									data.name,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.mobile,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.state,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.city,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.address,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.zip,
									'\xA0'
								)
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 12, sm: 12, xs: 12, style: { paddingLeft: '0px', paddingRight: '0px' } },
							_react2.default.createElement(
								'ul',
								{ className: 'addr_btns' },
								'// ',
								_react2.default.createElement(
									'li',
									{ onClick: function onClick() {
											_this4.editAddress(data.add_id);
										} },
									'EDIT'
								),
								'// ',
								_react2.default.createElement(
									'li',
									{ onClick: function onClick() {
											return _this4.deleteAddress(data.add_id);
										} },
									'DELETE'
								),
								_react2.default.createElement(
									'div',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									null,
									'\xA0'
								)
							)
						)
					) : _react2.default.createElement(
						_reactBootstrap.Col,
						{ md: 12, xs: 12, className: this.state.user_address.length == 1 ? "swipe_addr_blk swipe_addr_single" : 'swipe_addr_blk', id: "swipe-addr-id_" + data.add_id },
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 3, sm: 3, xs: 2, className: 'mob_check', id: "swipe-addr-id_" + data.add_id },
							_react2.default.createElement('img', { src: data.default === '1' ? baseAssets + 'images/icons/ok.png' : baseAssets + 'images/icons/circle_gray.png', alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ style: { margin: '0 20px' } },
							_react2.default.createElement(
								_reactBootstrap.Col,
								{ md: 10, sm: 10, xs: 10, className: 's_data_blk' },
								_react2.default.createElement(
									'p',
									null,
									data.name,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.mobile,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.state,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.city,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.address,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.zip,
									'\xA0'
								)
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 12, sm: 12, xs: 12, style: { paddingLeft: '0px', paddingRight: '0px' } },
							_react2.default.createElement(
								'ul',
								{ className: 'addr_btns' },
								_react2.default.createElement(
									'li',
									{ onClick: function onClick() {
											_this4.editAddress(data.add_id);
										} },
									'EDIT'
								),
								_react2.default.createElement(
									'li',
									{ onClick: function onClick() {
											return _this4.deleteAddress(data.add_id);
										} },
									'DELETE'
								)
							)
						)
					);
				}.bind(this));
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals checkout_page' },
					this.state.page_loading ? _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ id: 'header_main' },
							_react2.default.createElement(
								'div',
								{ className: 'page_hdr' },
								_react2.default.createElement(
									'div',
									{ className: 'container-fluid' },
									_react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/mycart' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
											)
										),
										'Checkout'
									),
									_react2.default.createElement(
										'a',
										{ href: '/', title: 'Home', className: 'home_logo1' },
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'section',
							{ id: 'cart-process' },
							_react2.default.createElement(
								'div',
								{ className: 'progressbar-wrapper' },
								_react2.default.createElement(
									'ul',
									{ className: 'progressbar' },
									_react2.default.createElement(
										'li',
										{ className: 'active' },
										_react2.default.createElement(
											'div',
											null,
											'Cart'
										),
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(_reactWebVectorIcons2.default, {
												name: 'check',
												font: 'Entypo',
												color: '#fff',
												size: 14
												// style={{}}
											})
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'div',
											null,
											'Checkout'
										),
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(_reactWebVectorIcons2.default, {
												name: 'check',
												font: 'Entypo',
												color: '#fff',
												size: 14
												// style={{}}
											})
										)
									),
									_react2.default.createElement(
										'li',
										null,
										'Payment'
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ style: { marginTop: '-5px' } },
							'\xA0'
						),
						parseInt(this.state.cart_count, 10) > 0 ? _react2.default.createElement(
							'div',
							{ className: 'body_content  m_checout' },
							this.state.paying_process ? _react2.default.createElement(
								'div',
								{ className: 'checkout_loading' },
								_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
							) : _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'section',
									{ className: 'chk_dlry_title_blk', style: { width: '90%', margin: '0 auto', padding: '5px 2px;' } },
									_react2.default.createElement(
										'div',
										{ id: 'pay_response' },
										this.state.response
									),
									_react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											'span',
											null,
											'DELIVERY ADDRESS'
										),
										_react2.default.createElement(
											'span',
											{ style: { float: 'right', color: '#ff742a' }, onClick: function onClick() {
													_this3.setState({ add_address: true });
												} },
											'ADD NEW'
										)
									)
								),
								_react2.default.createElement(
									'section',
									{ className: 'chk_dlry_data_blk' },
									this.state.click_here_status ? _react2.default.createElement(
										'div',
										{ className: 'empty_add_blk' },
										_react2.default.createElement(
											'a',
											{ onClick: function onClick() {
													_this3.setState({ add_address: true });
												} },
											'Click here to  add shipping address'
										)
									) : _react2.default.createElement(
										_reactIdSwiper2.default,
										_extends({}, params, { key: delivery_address.length }),
										delivery_address
									)
								),
								this.state.mode_loading ? _react2.default.createElement(
									'div',
									{ className: 'mode_loading' },
									_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
								) : tabs_data,
								_react2.default.createElement(
									'section',
									{ className: 'botm_btns row', style: { paddingBottom: '5px' } },
									_react2.default.createElement(
										'ul',
										{ className: 'mycart_ul' },
										_react2.default.createElement(
											'li',
											{ className: 'col-md-6 col-xs-6 col-sm-6', style: { cursor: 'pointer' } },
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: '/customer_care' },
												_react2.default.createElement(
													'i',
													null,
													_react2.default.createElement('img', { src: baseAssets + 'images/icons/enquiry_now.png', alt: ' ' })
												),
												'CONTACT US'
											)
										),
										_react2.default.createElement(
											'li',
											{ className: 'col-md-6 col-xs-6 col-sm-6', style: { cursor: 'pointer' } },
											this.state.amount_loading ? _react2.default.createElement(
												_reactRouter.Link,
												{ className: 'disabled' },
												'Loading'
											) : _react2.default.createElement(
												_reactRouter.Link,
												{ onClick: function onClick() {
														_this3.payNow();
													} },
												'PAY NOW',
												_react2.default.createElement(
													'span',
													null,
													_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/continue.png', width: '14px', alt: '' })
												)
											)
										)
									)
								),
								_react2.default.createElement(
									'section',
									{ style: { 'fontSize': '10px', 'paddingLeft': '20px' } },
									parseHtml(this.state.deliver_date_text)
								),
								_react2.default.createElement(
									'div',
									{ className: 'm_check_out_truck' },
									_react2.default.createElement(
										'div',
										{ style: { margin: '0 auto' } },
										_react2.default.createElement('img', { src: __webpack_require__(252), alt: '...' }),
										_react2.default.createElement(
											'h5',
											null,
											'You Pay : \u20B9 ',
											this.state.grand_total
										),
										_react2.default.createElement(
											'h6',
											null,
											this.state.cart_count > 1 ? 'Items : ' + this.state.cart_count : 'Item : ' + this.state.cart_count
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: 'm_pro_full_dtls_modal', show: this.state.add_address, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Header,
										{ closeButton: true },
										_react2.default.createElement(
											_reactBootstrap.Modal.Title,
											{ className: 'm_title' },
											'Add Shipping Address'
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(
												'form',
												{ className: 'add_address_form', onSubmit: this.handleSubmit_add },
												_react2.default.createElement(
													'div',
													{ className: 'add_form_blk' },
													_react2.default.createElement('input', { type: 'text', placeholder: 'Name', ref: 'add_name', id: 'add_name', value: this.state.add_name, onChange: this.add_nameChange, required: true }),
													_react2.default.createElement('p', { id: 'add_name_err' }),
													_react2.default.createElement('input', { type: 'text', maxLength: 10, placeholder: 'Mobile', ref: 'add_mobile', id: 'add_mobile', value: this.state.add_mobile, onChange: this.add_mobileChange, required: true }),
													_react2.default.createElement('p', { id: 'add_mobile_err' }),
													_react2.default.createElement('input', { type: 'text', placeholder: 'Enter State', ref: 'add_state', id: 'add_state', value: this.state.add_state, onChange: this.add_stateChange, required: true }),
													_react2.default.createElement('p', { id: 'add_state_err' }),
													_react2.default.createElement('input', { type: 'text', placeholder: 'Enter City/Town', ref: 'add_city', id: 'add_city', value: this.state.add_city, onChange: this.add_cityChange, required: true }),
													_react2.default.createElement('p', { id: 'add_city_err' }),
													_react2.default.createElement('input', { type: 'text', placeholder: 'Door No/Landmark', ref: 'add_doorno', id: 'add_doorno', value: this.state.add_doorno, onChange: this.add_doornoChange, required: true }),
													_react2.default.createElement('p', { id: 'add_doorno_err' }),
													_react2.default.createElement('input', { type: 'text', maxLength: 6, placeholder: 'Pincode', ref: 'add_pincode', id: 'add_pincode', value: this.state.add_pincode, onChange: this.add_pincodeChange, required: true }),
													_react2.default.createElement('p', { id: 'add_pincode_err' }),
													_react2.default.createElement(
														'div',
														{ className: 'm_submit_blk' },
														_react2.default.createElement(
															'button',
															{ type: 'submit', className: 'save_add_btn', value: 'ADD' },
															'ADD'
														)
													)
												)
											)
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ onEntered: function onEntered() {
											_this3.getAddressDetails();
										}, className: '', show: this.state.edit_address, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Header,
										{ closeButton: true },
										_react2.default.createElement(
											_reactBootstrap.Modal.Title,
											{ className: 'm_title' },
											'Edit Shipping Address'
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(
												'form',
												{ className: 'edit_address_form', onSubmit: this.handleSubmit_edit },
												_react2.default.createElement(
													'div',
													{ className: 'edit_form_blk' },
													_react2.default.createElement('input', { type: 'text', id: 'edit_name', placeholder: 'Name', value: this.state.edit_name, onChange: this.edit_nameChange, ref: 'edit_name', required: true }),
													_react2.default.createElement('p', { id: 'edit_name_err' }),
													_react2.default.createElement('input', { type: 'text', placeholder: 'Mobile', maxLength: 10, value: this.state.edit_mobile, onChange: this.edit_mobileChange, ref: 'edit_mobile', id: 'edit_mobile', required: true }),
													_react2.default.createElement('p', { id: 'edit_mobile_err' }),
													_react2.default.createElement('input', { type: 'text', placeholder: 'Enter State', value: this.state.edit_state, onChange: this.edit_stateChange, ref: 'edit_state', id: 'edit_state', required: true }),
													_react2.default.createElement('p', { id: 'edit_state_err' }),
													_react2.default.createElement('input', { type: 'text', placeholder: 'Enter City/Town', value: this.state.edit_city, onChange: this.edit_cityChange, ref: 'edit_city', id: 'edit_city', required: true }),
													_react2.default.createElement('p', { id: 'edit_city_err' }),
													_react2.default.createElement('input', { type: 'text', placeholder: 'Door No/Landmark', value: this.state.edit_doorno, onChange: this.edit_doornoChange, ref: 'edit_doorno', id: 'edit_doorno', required: true }),
													_react2.default.createElement('p', { id: 'edit_doorno_err' }),
													_react2.default.createElement('input', { type: 'text', placeholder: 'Pincode', maxLength: 6, value: this.state.edit_pincode, onChange: this.edit_pincodeChange, ref: 'edit_pincode', id: 'edit_pincode', required: true }),
													_react2.default.createElement('p', { id: 'edit_pincode_err' }),
													_react2.default.createElement(
														'div',
														{ className: 'm_submit_blk' },
														_react2.default.createElement(
															'button',
															{ type: 'submit', className: 'adrs_update_btn', value: 'UPDATE' },
															'UPDATE'
														)
													)
												)
											)
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ id: 'off_modal_status', className: 'off_modal_status', backdrop: 'static', show: this.state.offline_pay_success_status, onHide: this.testclose },
									_react2.default.createElement(
										_reactBootstrap.Modal.Header,
										null,
										_react2.default.createElement(
											'div',
											{ className: 'chekout_modal_header' },
											_react2.default.createElement(
												'h5',
												null,
												_react2.default.createElement(
													_reactRouter.Link,
													{ to: "/" },
													_react2.default.createElement(
														'i',
														null,
														_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
													)
												),
												_react2.default.createElement(
													'span',
													{ className: 'header_text textTransform' },
													'Confirmation'
												)
											),
											_react2.default.createElement(
												'a',
												{ href: '/', className: 'home_cartlogo' },
												_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
											)
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'div',
											{ style: { textAlign: 'center', paddingBottom: '10px', paddingTop: '15px' } },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cc_footer_icon.png', alt: 'AquaDeals', width: '100px' })
											),
											_react2.default.createElement(
												'h5',
												{ className: 'green textTransform', style: { paddingTop: '10px' } },
												this.state.offline_confirm_data.success_msg
											),
											_react2.default.createElement(
												'h6',
												{ style: { color: '#ff742a', paddingTop: '4px' } },
												this.state.offline_confirm_data.thank_msg
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'modal_ordr_dtls_blk' },
											_react2.default.createElement(
												'div',
												{ className: 'modal_ordr_dtls' },
												_react2.default.createElement(
													'h5',
													null,
													'Order Details'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: '', style: { padding: '10px' } },
												_react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														'Seller Name : '
													),
													_react2.default.createElement(
														'span',
														null,
														this.state.offline_confirm_data.address ? this.state.offline_confirm_data.address.seller_name : ''
													)
												),
												_react2.default.createElement(
													'h5',
													{ style: { fontSize: '11px', marginTop: '4px', marginBottom: '4px' } },
													_react2.default.createElement(
														'span',
														null,
														'Order N0'
													),
													_react2.default.createElement(
														'span',
														{ style: { float: 'right' } },
														'Order Date'
													)
												),
												_react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														this.state.offline_confirm_data.book_id
													),
													_react2.default.createElement(
														'span',
														{ style: { float: 'right' } },
														this.state.offline_confirm_data.booking_date ? this.state.offline_confirm_data.booking_date : ''
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'modal_pro_details_blk' },
											_react2.default.createElement(
												'div',
												{ className: 'modal_pro_title' },
												_react2.default.createElement(
													'h5',
													null,
													'Product Details '
												)
											),
											_react2.default.createElement(
												'div',
												{ style: { padding: '10px' } },
												_react2.default.createElement(
													'p',
													null,
													_react2.default.createElement(
														'span',
														null,
														'Item : ',
														this.state.offline_confirm_data.qty ? this.state.offline_confirm_data.qty : ''
													),
													_react2.default.createElement(
														'span',
														{ style: { float: 'right' } },
														'Total : ',
														this.state.offline_confirm_data.remaining_amount ? this.state.offline_confirm_data.remaining_amount : ''
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: '', style: { backgroundColor: '#fff', overflow: 'hidden', paddingBottom: '10px', marginTop: '10px' } },
											this.state.offline_confirm_data.order_items ? this.state.offline_confirm_data.order_items.map(function (data, index) {
												return _react2.default.createElement(
													'div',
													{ className: 'col-xs-12 col-md-12', style: { padding: '0px', paddingTop: '15px', paddingBottom: '15px', borderTop: '1px solid #eee' } },
													_react2.default.createElement(
														'div',
														{ className: 'col-xs-3 col-md-3' },
														_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/thumbnails/20170323130243537436.jpg', alt: ' ' })
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-xs-6 col-md-6', style: { padding: '0px' } },
														_react2.default.createElement(
															'p',
															null,
															data.pro_name,
															' ',
															data.unit
														),
														_react2.default.createElement(
															'p',
															null,
															'QTY : ',
															data.quantity
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-xs-3 col-md-3', style: { padding: '0px' } },
														_react2.default.createElement(
															'p',
															{ style: { marginTop: '17px' } },
															'\u20B9 ',
															data.deal_amt
														)
													)
												);
											}) : ''
										),
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(
												'div',
												{ style: { backgroundColor: '#f1f1f2', padding: '5px 0px 5px 10px' } },
												_react2.default.createElement(
													'h5',
													null,
													'Payment Details'
												)
											),
											_react2.default.createElement(
												'div',
												{ style: { backgroundColor: '#fff', padding: '10px' } },
												_react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														this.state.offline_confirm_data.payment_details ? this.state.offline_confirm_data.payment_details[0].title : ''
													),
													_react2.default.createElement(
														'span',
														{ style: { float: 'right' } },
														'\u20B9 ',
														this.state.offline_confirm_data.payment_details ? this.state.offline_confirm_data.payment_details[0].value : ''
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(
												'div',
												{ className: '', style: { backgroundColor: '#f1f1f2', padding: '5px 0px 5px 10px' } },
												_react2.default.createElement(
													'h5',
													null,
													'Shipping Address'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: '', style: { backgroundColor: '#fff', padding: '10px' } },
												_react2.default.createElement(
													'p',
													null,
													this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].name : ''
												),
												_react2.default.createElement(
													'p',
													null,
													this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].address : '',
													' , ',
													this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].city : '',
													' '
												),
												_react2.default.createElement(
													'p',
													null,
													this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].state : ''
												),
												_react2.default.createElement(
													'p',
													null,
													this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].phone : ''
												),
												_react2.default.createElement(
													'p',
													null,
													this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].zip : ''
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ style: { textAlign: 'center', marginTop: '100px' }, className: 'modal_share_blk' },
											_react2.default.createElement(
												'div',
												null,
												_react2.default.createElement(
													_reactRouter.Link,
													{ style: { color: '#ff742a' }, to: '/share_earn' },
													_react2.default.createElement('img', { src: baseAssets + 'images/icons/nav_refer_earn.png', width: '40px', alt: '' }),
													'Share & Earn'
												)
											)
										)
									)
								)
							)
						) : _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'cart_emtpy' },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/empty_cartbg.png', alt: '...' })
								),
								_react2.default.createElement(
									'h4',
									null,
									'Your Cart is Empty'
								),
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: "/", className: 'Shop_btn' },
									'SHOP NOW'
								)
							),
							_react2.default.createElement(
								'section',
								{ className: 'botm_btns row', style: { paddingBottom: '5px' } },
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										{ className: 'col-md-6 col-xs-6 col-sm-6', style: { cursor: 'pointer' } },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/customer_care' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'images/icons/enquiry_now.png', alt: ' ' })
											),
											'Enquire Now'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'col-md-6 col-xs-6 col-sm-6', style: { cursor: 'pointer' } },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/' },
											'Explore Deals'
										)
									)
								)
							)
						)
					) : _react2.default.createElement(
						'div',
						{ className: 'checkout_loading' },
						this.state.lod ? _react2.default.createElement(
							'div',
							{ className: 'checkout_error_blk' },
							_react2.default.createElement(
								'h4',
								null,
								'Something went wrong'
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/', className: 'try_again_btn' },
								'Please try again!'
							)
						) : _react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
					),
					_react2.default.createElement(
						'div',
						{ style: { width: '100%', position: 'absolute', bottom: '30px' } },
						_react2.default.createElement('div', { id: 'snackbar' })
					)
				);
			}
		}]);
	
		return Checkout;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			save_order_status: state.posts.mycart_order_status,
			total_cart_data: state.posts.total_cart_data,
			rzp_keys: state.posts.rzp_keys
		};
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Checkout);

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactWebVectorIcons = __webpack_require__(29);
	
	var _reactWebVectorIcons2 = _interopRequireDefault(_reactWebVectorIcons);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var parseHtml = __webpack_require__(39);
	// import Footer from './../Common/footer';
	
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var MyCart = function (_Component) {
		_inherits(MyCart, _Component);
	
		function MyCart(props) {
			_classCallCheck(this, MyCart);
	
			var _this = _possibleConstructorReturn(this, (MyCart.__proto__ || Object.getPrototypeOf(MyCart)).call(this, props));
	
			_this.state = {};
			_this.state = {
				total: '',
				cartcount: '',
				grandtotal: '',
				items: [],
				aqua_cash: '',
				used_cash: '',
				used_cash1: '',
				ac_discount: '',
				coupons_amt: '',
				coupons_amt1: '',
				grand_total: '',
				openModal: false,
				applied_coupons: '',
				applied_coupons1: '',
				coupon_ref: '',
				coupon_err_msg: '',
				coupon_err_status: false,
				updateModal: false,
				coupon_success_status: false,
				coupon_success_msg: '',
				coupon_success_value: '',
				delete_status: false,
				delete_status_id: '',
	
				qty: '',
				min_qty: '',
				max_qty: '',
				cart_id: '',
				err_qty_status: false,
				err_qty_msg: '',
				emptyCartConfirm: false,
				coupons: [],
				billing_status: false,
	
				proceedCheck: 0,
				proceedMsg: '',
				ac_enough_msg: '',
				loc_msg: '',
				add_id: 0,
	
				coupon_code: 0,
				coupon_price: 0,
	
				state: '',
				zip: '',
				city: '',
				address: '',
				save_local_address_msg_status: false,
				ac_enough_msg_status: false,
				proceedMsg_status: false,
	
				promodiscount: '',
				promos: [],
				applied_promos: '',
	
				checkout_page_loading: false
			};
			_this.close = _this.close.bind(_this);
			_this.submitCoupon = _this.submitCoupon.bind(_this);
			_this.changeCoupon = _this.changeCoupon.bind(_this);
			_this.getCart = _this.getCart.bind(_this);
			_this.updateMinQty = _this.updateMinQty.bind(_this);
			_this.updateMinQtyModal = _this.updateMinQtyModal.bind(_this);
			_this.deleteSingleItem = _this.deleteSingleItem.bind(_this);
			_this.emptyCart = _this.emptyCart.bind(_this);
			_this.emptyCartConfirm = _this.emptyCartConfirm.bind(_this);
			_this.delete = _this.delete.bind(_this);
	
			_this.updateQuantity = _this.updateQuantity.bind(_this);
			_this.enableBillingDetails = _this.enableBillingDetails.bind(_this);
			_this.placeOrder = _this.placeOrder.bind(_this);
			_this.applyCoupon_getCart = _this.applyCoupon_getCart.bind(_this);
			_this.removeCoupon = _this.removeCoupon.bind(_this);
			_this.saveDefaultAddress = _this.saveDefaultAddress.bind(_this);
			_this.saveAddress_placeOrder = _this.saveAddress_placeOrder.bind(_this);
	
			return _this;
		}
	
		//saveDefaultAddress function is used to save the new address in checkout page
	
	
		_createClass(MyCart, [{
			key: 'saveDefaultAddress',
			value: function saveDefaultAddress() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), name: localStorage.user_name, mobile: localStorage.user_mobile, state: this.state.state, city: this.state.city, address: this.state.address, zip: this.state.zip, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'saveAdd',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							add_id: data.add_id
						});
						localStorage.setItem('address_change_flag', data.address_change);
						this.saveAddress_placeOrder();
					}.bind(this),
					error: function error(err) {
						// console.log(err);
					}
				});
			}
		}, {
			key: 'emptyCartConfirm',
			value: function emptyCartConfirm() {
				this.setState({
					emptyCartConfirm: true
				});
			}
			//function updateQuantitiy is used to update the qunatity of the product in modal box and updating the cart values by calling the "applyCoupon_getCart" 
	
		}, {
			key: 'updateQuantity',
			value: function updateQuantity() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var x = '';
				if (parseInt(this.state.qty, 10) < parseInt(this.state.min_qty, 10)) {
					// alert('Minimum Quantity is '+this.state.min_qty);
					x = 'Minimum Quantity is ' + this.state.min_qty;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Minimum Quantity is ' + this.state.min_qty
					});
				}
				if (this.state.qty === '') {
					// alert('Minimum Quantity is '+this.state.min_qty);
					x = 'Minimum Quantity is ' + this.state.min_qty;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Minimum Quantity is ' + this.state.min_qty
					});
				}
				if (parseInt(this.state.qty, 10) > parseInt(this.state.max_qty, 10)) {
					// alert('Maximum Quantity is '+this.state.max_qty);
					x = 'Maximum Quantity is ' + this.state.max_qty;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Maximum Quantity is ' + this.state.max_qty
					});
				}
				var check = /[^0-9]/gi;
				if (check.test(this.refs.mob_edit_qty.value)) {
					x = '* Invalid Quantity';
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Invalid Quantity'
					});
				}
				if (x === '') {
					this.setState({
						err_qty_status: false,
						err_qty_msg: ''
					});
					var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), cart_id: this.state.cart_id, quantity: this.state.qty, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'update_cart_qty',
						data: { req: data2 },
						success: function (data) {
							console.log(data);
							if (data.status === "success") {
								this.close();
								// this.getCart();
								this.applyCoupon_getCart();
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
			//function close is used to close all of the modal boxes
	
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					openModal: false,
					updateModal: false,
					emptyCartConfirm: false,
					save_local_address_msg_status: false,
					ac_enough_msg_status: false,
					proceedMsg_status: false
				});
			}
			// function emptyCart is used to empty the cart items and updating the cart and close functions
	
		}, {
			key: 'emptyCart',
			value: function emptyCart() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', uid: localStorage.getItem('user_id'), token: localStorage.getItem('token'), source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'Cart_delete',
					data: { req: data2 },
					success: function (data) {
	
						if (data.status === "success") {
							this.getCart();
							this.close();
						} else {
							this.close();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			//function delete(id) gets the id from the deleteSingleItem(id) and removes the item from the cart.
	
		}, {
			key: 'delete',
			value: function _delete(id) {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: id, uid: localStorage.getItem('user_id'), token: localStorage.getItem('token'), source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'singleCart_delete',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success" && data.message === "Item deleted successfully.") {
							this.getCart();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			// function deleteSingleItem(id) changes the status of the item block per 5 seconds to delete, can undo the deletions withing 5 sec or it calls the delete(id) function.
	
		}, {
			key: 'deleteSingleItem',
			value: function deleteSingleItem(id) {
				var _this2 = this;
	
				this.setState({
					delete_status: true,
					delete_status_id: id
				});
	
				//setTimeout(() => {this.setState({delete_status:false});}, 9000);
				setTimeout(function () {
					_this2.state.delete_status === true ? _this2.delete(id) : '';
				}, 5000);
			}
			//applyCoupon_getCart(value,code) function is used to call the cart function with updated state values of coupon price and coupon value. 
	
		}, {
			key: 'applyCoupon_getCart',
			value: function applyCoupon_getCart(value, code) {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), apply_ac: 1, apply_coupon: this.state.coupon_price, apply_coupon_code: this.state.coupon_code, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
	
				localStorage.setItem('apply_coupon', this.state.coupon_price);
				localStorage.setItem('apply_coupon_code', this.state.coupon_code);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'cart',
					data: { req: data2 },
					success: function (data) {
	
						localStorage.setItem('apply_coupon', this.state.coupon_price);
						localStorage.setItem('apply_coupon_code', this.state.coupon_code);
						this.setState({
							total: data.total,
							cartcount: data.cart_count,
							grandtotal: data.grand_total,
							items: data.items,
							ac_discount: data.ac_discount,
							aqua_cash: data.aqua_cash,
							used_cash: data.used_cash,
							used_cash1: data.used_cash1,
							coupons_amt: data.coupons_amt,
							coupons_amt1: data.coupons_amt1,
							grand_total: data.grand_total,
							applied_coupons: data.applied_coupons,
							applied_coupons1: data.applied_coupons1,
							coupons: data.coupons,
	
							proceedCheck: data.proceedCheck,
							proceedMsg: data.proceedMsg,
							ac_enough_msg: data.ac_enough_msg,
							loc_msg: data.loc_msg,
							add_id: data.add_id,
	
							state: data.state,
							zip: data.zip,
							city: data.city,
							address: data.address,
	
							promodiscount: data.promodiscount,
							promos: data.promos,
							applied_promos: data.applied_promos
						});
						localStorage.setItem('address_change_flag', data.address_change);
					}.bind(this),
					error: function error(err) {}
				});
			}
			//function getCart is used to get the cart values when page loads with empty params of coupons codes and values.
	
		}, {
			key: 'getCart',
			value: function getCart() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), apply_ac: 1, apply_coupon: 0, apply_coupon_code: '', source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
	
				localStorage.setItem('apply_coupon', this.state.coupon_price);
				localStorage.setItem('apply_coupon_code', this.state.coupon_code);
	
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'cart',
					data: { req: data2 },
					success: function (data) {
	
						if (data.status === 'error' && data.message === 'Token mismatch') {
							localStorage.clear();
							window.location.reload();
						}
						this.setState({
							total: data.total,
							cartcount: data.cart_count,
							grandtotal: data.grand_total,
							items: data.items,
							ac_discount: data.ac_discount,
							aqua_cash: data.aqua_cash,
							used_cash: data.used_cash,
							used_cash1: data.used_cash1,
							coupons_amt: data.coupons_amt,
							coupons_amt1: data.coupons_amt1,
							grand_total: data.grand_total,
							applied_coupons: data.applied_coupons,
							applied_coupons1: data.applied_coupons1,
							coupons: data.coupons,
	
							proceedCheck: data.proceedCheck,
							proceedMsg: data.proceedMsg,
							ac_enough_msg: data.ac_enough_msg,
							loc_msg: data.loc_msg,
							add_id: data.add_id,
	
							promodiscount: data.promodiscount,
							promos: data.promos,
							applied_promos: data.applied_promos,
							shipping_note: data.shipping_note
	
						});
						localStorage.setItem('address_change_flag', data.address_change);
					}.bind(this),
					error: function error(err) {}
				});
			}
	
			//componentDidMount function is loaded first when page loaded by checking the session and calls the getCart function.
	
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('myorders');
	
				if ( /*!localStorage.token && */!localStorage.user_id) {
					localStorage.setItem('mob_mycart', '/mycart');
					_reactRouter.browserHistory.push('/login');
				} else {
					this.getCart();
				}
	
				// localStorage.removeItem('address_change_flag');
	
				if (screen.width >= 800) {
					window.location.href = '/web/mycart';
				}
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var that = this;
				setTimeout(function () {
					that.enableBillingDetails();
				}, 3000);
			}
		}, {
			key: 'enableBillingDetails',
			value: function enableBillingDetails() {
				// this.getCart();
				this.setState({
					billing_status: true
				});
			}
		}, {
			key: 'changeCoupon',
			value: function changeCoupon() {
				this.setState({
					coupon_ref: this.refs.apply_coupon.value,
					coupon_err_status: false
				});
			}
		}, {
			key: 'submitCoupon',
			value: function submitCoupon() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), coupon: this.refs.apply_coupon.value, public_amt: this.state.coupons_amt1, apply_ac: 1, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'applyCoupon',
					data: { req: data2 },
					success: function (data) {
	
						if (data.status === "error") {
							this.setState({
								coupon_err_status: true,
								coupon_err_msg: data.message
							});
						}
						if (data.status === "success") {
							this.setState({
								coupon_code: data.code,
								coupon_price: data.value,
								coupon_success_msg: data.message,
								coupon_success_status: true,
								coupon_success_value: data.value
							});
							this.applyCoupon_getCart(data.value, data.code);
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'updateMinQty',
			value: function updateMinQty(qty, min_qty, max_qty, cart_id) {
				console.log(qty);
				this.setState({
					updateModal: true,
					qty: qty,
					min_qty: min_qty,
					max_qty: max_qty,
					cart_id: cart_id
				});
			}
		}, {
			key: 'updateMinQtyModal',
			value: function updateMinQtyModal() {
				this.setState({
					qty: this.refs.mob_edit_qty.value,
					err_qty_status: false
				});
			}
			//saveAddress_placeOrder() function is called when the coupon is applied and shown location_msg and saving the address,if the address is saved then redirect to checkout page.
	
		}, {
			key: 'saveAddress_placeOrder',
			value: function saveAddress_placeOrder() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = _defineProperty({ from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, mode: 2, add_id: this.state.add_id, code: this.state.coupon_code, coupon_amount: this.state.coupon_price, other_amount: '', aqua_cash: this.state.aqua_cash, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, source: source, campaign: campaign, url_id: url_id }, 'aqua_cash', this.state.aqua_cash);
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cartCalculations',
					success: function (data) {
						this.applyCoupon_getCart();
						if (data.status === "success") {
							_reactRouter.browserHistory.push('/checkout');
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'placeOrder',
			value: function placeOrder() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (this.state.proceedCheck === 0 && this.state.proceedMsg !== "") {
					this.setState({
						proceedMsg_status: true
					});
				} else if (this.state.proceedCheck === 0 && this.state.ac_enough_msg !== "") {
					this.setState({
						ac_enough_msg_status: true
					});
				} else if (this.state.proceedCheck === 0 && this.state.loc_msg !== "") {
					this.setState({
						save_local_address_msg_status: true
					});
				} else {
					this.setState({
						checkout_page_loading: true
					});
					var data1 = _defineProperty({ from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, mode: 2, add_id: this.state.add_id, code: this.state.coupon_code, coupon_amount: this.state.coupon_price, other_amount: '', aqua_cash: this.state.used_cash1, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, source: source, campaign: campaign, url_id: url_id }, 'aqua_cash', this.state.aqua_cash);
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'cartCalculations',
						success: function (data) {
							this.applyCoupon_getCart();
							if (data.status === "success") {
								_reactRouter.browserHistory.push('/checkout');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'removeCoupon',
			value: function removeCoupon() {
				this.setState({
					coupon_success_status: false,
					coupon_code: 0,
					coupon_price: 0
				});
				localStorage.setItem('apply_coupon', 0);
				localStorage.setItem('apply_coupon_code', 0);
				this.getCart();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				document.title = "My Cart | AquaDeals";
				(0, _jquery2.default)('body').css('background', '#fff');
				var cart_items = this.state.items.map(function (item, index) {
					var _this3 = this;
	
					return _react2.default.createElement(
						'div',
						null,
						this.state.delete_status && this.state.delete_status_id === item.id ? _react2.default.createElement(
							'div',
							{ className: 'row cart_itemslist' },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-12 col-sm-12 col-md-12', style: { padding: '10px', color: '#666' } },
								_react2.default.createElement(
									'span',
									null,
									'Deleted'
								),
								_react2.default.createElement(
									'span',
									{ style: { float: 'right', cursor: 'pointer' }, onClick: function onClick() {
											_this3.setState({ delete_status: false });
										} },
									'UNDO'
								)
							)
						) : _react2.default.createElement(
							'div',
							{ className: 'row cart_itemslist' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12 col-sm-12 col-xs-12' },
								_react2.default.createElement(
									'button',
									{ onClick: function onClick() {
											item.type === 1 ? _this3.deleteSingleItem(item.id) : _this3.deleteSingleItem(item.id);
										}, ariaLabel: 'Close', className: 'close', type: 'button' },
									_react2.default.createElement(
										'span',
										{ ariaHidden: 'true' },
										'\xD7'
									)
								)
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: item.type === 0 ? '/sdetails/' + item.url_name + '/' + item.deal_id : '/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-3 col-sm-3 col-md-3 col-lg-3 cart_center_img' },
									item.type === 0 ? _react2.default.createElement('img', { src: baseAssets + 'icons/' + item.img, width: '50px', alt: ' ' }) : _react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/thumbnails/' + item.img, alt: ' ' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-9 col-sm-9 col-md-9 col-lg-3 cartdesc_blk' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: item.type === 0 ? '/sdetails/' + item.url_name + '/' + item.deal_id : '/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
									item.pro_name !== "" ? _react2.default.createElement(
										'p',
										{ className: 'cartitem_title' },
										item.pro_name
									) : _react2.default.createElement(
										'p',
										null,
										'\xA0'
									)
								),
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: item.type === 0 ? '/sdetails/' + item.url_name + '/' + item.deal_id : '/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-4 col-sm-4', style: { padding: '0px' } },
										item.mrp ? _react2.default.createElement(
											'span',
											null,
											'\u20B9 ',
											item.mrp
										) : ''
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-4 col-sm-4' },
									item.min_qty !== "" ? _react2.default.createElement(
										'p',
										{ className: 'mob_edit_qty', onClick: function onClick() {
												_this3.updateMinQty(item.qty, item.min_qty, item.max_qty, item.id);
											} },
										item.qty
									) : ''
								),
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: item.type === 0 ? '/sdetails/' + item.url_name + '/' + item.deal_id : '/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-4 col-sm-4', style: { paddingLeft: '0px', paddingRight: '0px' } },
										item.amount !== "" ? _react2.default.createElement(
											'p',
											null,
											_react2.default.createElement(
												'span',
												null,
												'\u20B9 '
											),
											_react2.default.createElement(
												'span',
												null,
												item.amount
											)
										) : ''
									)
								)
							)
						)
					);
				}.bind(this));
	
				var cart_coupons = '';
				cart_coupons = _react2.default.createElement(
					'div',
					{ className: 'row', style: { paddingTop: '10px', paddingBottom: '10px' } },
					_react2.default.createElement('div', { className: 'col-sm-2 col-xs-2' }),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-6 col-xs-6' },
						_react2.default.createElement(
							'div',
							{ className: 'cart_coupon_blk' },
							_react2.default.createElement(
								'i',
								{ className: 'cart_left_img' },
								_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_left.png', alt: ' ' })
							),
							_react2.default.createElement('input', { type: 'text', ref: 'apply_coupon', maxLength: 15, placeholder: 'Enter coupon code', onChange: function onChange() {
									_this4.changeCoupon();
								} })
						),
						_react2.default.createElement(
							'div',
							{ className: 'err_coupon' },
							_react2.default.createElement(
								'span',
								null,
								this.state.coupon_err_status ? this.state.coupon_err_msg : ''
							),
							' '
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-2 col-xs-2' },
						_react2.default.createElement(
							'div',
							{ className: 'cart_submit' },
							_react2.default.createElement(
								'button',
								{ className: 'cart_submitbtn', onClick: function onClick() {
										_this4.submitCoupon();
									} },
								'Apply'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-1 col-xs-1' },
						'\xA0'
					),
					_react2.default.createElement('div', { className: 'col-sm-6 col-xs-6 ' })
				);
				var coupon_map = this.state.coupons.map(function (coupon, index) {
					return _react2.default.createElement(
						'span',
						{ key: index, style: { display: 'block' } },
						coupon.coupon_code,
						' (\u20B9',
						coupon.value,
						' )'
					);
				});
				var couponsList = _react2.default.createElement(
					_reactBootstrap.Popover,
					{ id: 'popover-positioned-top1' },
					coupon_map
				);
				var coupon_info = _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{ trigger: 'focus', placement: 'top', overlay: couponsList },
					_react2.default.createElement(
						_reactBootstrap.Button,
						{ className: 'cart_coupon_info_img' },
						_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_info.png', alt: ' ' })
					)
				);
				var promos_map = this.state.promos.map(function (promo, index) {
					return _react2.default.createElement(
						'span',
						{ key: index, style: { display: 'block' } },
						promo.promo_code,
						' ( \u20B9 ',
						promo.promo_value,
						' )'
					);
				});
				var promosList = _react2.default.createElement(
					_reactBootstrap.Popover,
					{ id: 'popover-positioned-top2' },
					promos_map
				);
	
				var promo_info = '';
				promo_info = _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{ trigger: 'focus', placement: 'top', overlay: promosList },
					_react2.default.createElement(
						_reactBootstrap.Button,
						{ className: 'cart_coupon_info_img' },
						_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_info.png', alt: ' ' })
					)
				);
				var coupon_success = '';
				if (this.state.coupon_success_status) {
					coupon_success = _react2.default.createElement(
						'div',
						{ className: 'cart_cpn_success' },
						_react2.default.createElement(
							'button',
							{ onClick: function onClick() {
									_this4.removeCoupon();
								}, ariaLabel: 'Close', className: 'coupon_close', type: 'button' },
							_react2.default.createElement(
								'i',
								null,
								_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cancel_coupon.png', alt: '', width: '20px' })
							)
						),
						_react2.default.createElement(
							'h5',
							null,
							'Coupon discount:(-) \u20B9 ',
							this.state.coupon_success_value
						),
						_react2.default.createElement(
							'p',
							null,
							this.state.coupon_success_msg
						)
					);
				}
				var coupons_amt_block = '';
	
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals mob_cartpage' },
					_react2.default.createElement(
						'div',
						{ id: 'header_main' },
						_react2.default.createElement(
							'div',
							{ className: 'page_hdr' },
							this.state.cartcount !== 0 ? _react2.default.createElement(
								'div',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: '/' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { className: 'cross_icon', src: baseAssets + 'icons/web_icons/close_icon1.png', width: '14px', alt: '' })
										)
									),
									_react2.default.createElement(
										'span',
										{ className: 'header_text' },
										'MY CART'
									)
								),
								_react2.default.createElement(
									'a',
									{ href: '/', className: 'home_newicon' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
								),
								_react2.default.createElement(
									'a',
									{ className: 'cart_emptybtn', onClick: function onClick() {
											_this4.emptyCartConfirm();
										} },
									_react2.default.createElement('img', { alt: '', src: baseAssets + 'icons/web_icons/del_bin3.png' })
								)
							) : _react2.default.createElement(
								'div',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: '/' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/close_icon1.png', width: '14px', className: 'cross_icon', alt: '' })
										)
									),
									_react2.default.createElement(
										'span',
										{ className: 'header_text' },
										'MY CART'
									)
								),
								_react2.default.createElement(
									'a',
									{ href: '/', className: 'home_newicon' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
								)
							)
						),
						this.state.cartcount == 0 ? '' : _react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							this.state.checkout_page_loading ? '' : _react2.default.createElement(
								'section',
								{ id: 'cart-process' },
								_react2.default.createElement(
									'div',
									{ className: 'progressbar-wrapper' },
									_react2.default.createElement(
										'ul',
										{ className: 'progressbar' },
										_react2.default.createElement(
											'li',
											{ className: 'active' },
											_react2.default.createElement(
												'div',
												null,
												'Cart'
											),
											_react2.default.createElement(
												'div',
												null,
												_react2.default.createElement(_reactWebVectorIcons2.default, {
													name: 'check',
													font: 'Entypo',
													color: '#fff',
													size: 14
													// style={{}}
												})
											)
										),
										_react2.default.createElement(
											'li',
											null,
											'Checkout'
										),
										_react2.default.createElement(
											'li',
											null,
											'Payment'
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row', style: { backgroundColor: '#f2f2f2', paddingTop: '10px', paddingBottom: '10px' } },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-sm-6 col-xs-6' },
									_react2.default.createElement(
										'span',
										{ className: 'cart_header_count' },
										this.state.cartcount > 1 ? 'Items : ' + this.state.cartcount : 'Item : ' + this.state.cartcount
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-sm-6 col-xs-6', style: { textAlign: 'right' } },
									_react2.default.createElement(
										'span',
										{ className: 'cart_header_total' },
										'Total: ',
										this.state.grandtotal
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					this.state.cartcount !== 0 ? _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						this.state.checkout_page_loading ? _react2.default.createElement(
							'div',
							{ className: 'checkout_loading' },
							_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
						) : _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'section',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'div',
									{ className: 'cart_itemsblk' },
									cart_items
								),
								_react2.default.createElement(
									'div',
									{ className: 'cart_couponblk' },
									_react2.default.createElement(
										'h4',
										null,
										'Coupon Details'
									),
									_react2.default.createElement(
										'div',
										null,
										this.state.coupon_success_status ? coupon_success : cart_coupons
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'cart_billingblk' },
									_react2.default.createElement(
										'h4',
										null,
										'Billing Details'
									),
									this.state.billing_status ? _react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'table',
											{ className: 'table cart_table' },
											_react2.default.createElement(
												'tr',
												{ className: 'cart_tr_total' },
												_react2.default.createElement(
													'td',
													null,
													'Total'
												),
												_react2.default.createElement(
													'td',
													null,
													'\u20B9 ',
													this.state.total
												)
											),
											parseInt(this.state.used_cash) > 0 ? _react2.default.createElement(
												'tr',
												{ className: 'cart_tr' },
												_react2.default.createElement(
													'td',
													null,
													'Aquacash Discount'
												),
												_react2.default.createElement(
													'td',
													null,
													'(-) \u20B9 ',
													this.state.used_cash
												)
											) : '',
											_react2.default.createElement(
												'tr',
												{ className: 'cart_tr', style: { display: this.state.coupons.length === 1 ? "table-row" : "none" } },
												_react2.default.createElement(
													'td',
													null,
													'Applied Coupon ',
													_react2.default.createElement(
														'span',
														{ className: 'applied_coupon_msg' },
														': ',
														this.state.coupons.length === 1 ? this.state.coupons[0]['coupon_code'] : ''
													)
												),
												_react2.default.createElement(
													'td',
													null,
													'(-) \u20B9 ',
													this.state.coupons_amt
												)
											),
											_react2.default.createElement(
												'tr',
												{ className: 'cart_tr', style: { display: this.state.coupons.length > 1 ? "table-row" : "none" } },
												_react2.default.createElement(
													'td',
													null,
													'Coupons applied on your purchase ',
													coupon_info
												),
												_react2.default.createElement(
													'td',
													null,
													'(-) \u20B9 ',
													this.state.coupons_amt
												)
											),
											parseInt(this.state.promodiscount, 10) > 0 ? _react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'Promos Discount ',
													this.state.promos.length === 1 ? _react2.default.createElement(
														'span',
														{ className: 'applied_coupon_msg' },
														': ',
														this.state.promos[0].promo_code
													) : promo_info,
													' '
												),
												_react2.default.createElement(
													'td',
													null,
													'(-) \u20B9 ',
													this.state.promodiscount
												)
											) : '',
											_react2.default.createElement(
												'tr',
												{ className: 'cart_tr_grandtotal' },
												_react2.default.createElement(
													'td',
													null,
													'GRAND TOTAL '
												),
												_react2.default.createElement(
													'td',
													null,
													'\u20B9 ',
													this.state.grand_total
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													parseHtml(this.state.shipping_note)
												),
												'}'
											)
										)
									) : _react2.default.createElement(
										'div',
										{ className: 'price_loading' },
										_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
									)
								)
							),
							_react2.default.createElement(
								'section',
								{ className: 'botm_btns row' },
								_react2.default.createElement(
									'ul',
									{ className: 'mycart_ul' },
									_react2.default.createElement(
										'li',
										{ className: 'col-md-6 col-xs-6 col-sm-6', style: { cursor: 'pointer' } },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/', title: '' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cart_icon_orange.png', alt: ' ' })
											),
											'CONTINUE SHOPPING'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'col-md-6 col-xs-6 col-sm-6', style: { cursor: 'pointer' } },
										_react2.default.createElement(
											'a',
											{ onClick: function onClick() {
													_this4.placeOrder();
												} },
											'PLACE ORDER ',
											_react2.default.createElement(
												'span',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/continue.png', width: '12px', alt: ' ' })
											)
										)
									)
								)
							)
						)
					) : _react2.default.createElement(
						'div',
						{ className: 'cart_emtpy' },
						_react2.default.createElement(
							'i',
							null,
							_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/empty_cartbg.png', alt: '...' })
						),
						_react2.default.createElement(
							'h4',
							null,
							'Your Cart is Empty'
						),
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: "/", className: 'Shop_btn' },
							'SHOP NOW'
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: '', show: this.state.openModal, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'AquaDeals'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#666' } },
								'You need to install Android mobile app to place this order.'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: '#fff none repeat scroll 0 0', color: '#ff742a' }, onClick: this.close },
								'Close'
							),
							_react2.default.createElement(
								'a',
								{ href: 'https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en', target: '_blank', title: '' },
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: '#ff742a none repeat scroll 0 0', color: '#fff' } },
									'OK'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'mob_edit_qty_modal', show: this.state.updateModal, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								null,
								_react2.default.createElement('input', { ref: 'mob_edit_qty', type: 'text', value: this.state.qty, placeholder: 'Enter Quantity', onChange: function onChange() {
										_this4.updateMinQtyModal();
									} })
							),
							this.state.err_qty_status ? _react2.default.createElement(
								'p',
								{ className: 'mob_err_qty' },
								this.state.err_qty_msg
							) : ''
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'mob_edit_qty_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ className: 'mob_edit_qty_cls_btn', onClick: this.close },
								'CANCEL'
							),
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ className: 'mob_edit_qty_update_btn', onClick: function onClick() {
											_this4.updateQuantity();
										} },
									'UPDATE'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'mob_cart_confirm_modal', show: this.state.emptyCartConfirm, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								null,
								'Do you want to remove all items? '
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'mob_cart_confirm' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ className: '', onClick: this.close },
								'NO'
							),
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ className: '', onClick: function onClick() {
											_this4.emptyCart();
										} },
									'YES'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: '', show: this.state.save_local_address_msg_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#666' } },
								this.state.loc_msg
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'mob_cart_confirm' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ className: '', onClick: this.close },
								'NO'
							),
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ className: '', onClick: function onClick() {
											_this4.saveDefaultAddress();
										} },
									'YES'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: '', show: this.state.ac_enough_msg_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#666' } },
								this.state.ac_enough_msg
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'mob_cart_confirm' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ className: '', onClick: this.close },
								'CLOSE'
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/customer_care' },
								_react2.default.createElement(
									_reactBootstrap.Button,
									null,
									'CUSTOMER SUPPORT'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: '', show: this.state.proceedMsg_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#666' } },
								this.state.proceedMsg
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'mob_cart_confirm' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ className: '', onClick: this.close },
								'CANCEL'
							)
						)
					)
				);
			}
		}]);
	
		return MyCart;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			save_order_status: state.posts.mycart_order_status,
			total_cart_data: state.posts.total_cart_data
		};
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(MyCart);

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Order_aborted = function (_Component) {
		_inherits(Order_aborted, _Component);
	
		function Order_aborted(props) {
			_classCallCheck(this, Order_aborted);
	
			var _this = _possibleConstructorReturn(this, (Order_aborted.__proto__ || Object.getPrototypeOf(Order_aborted)).call(this, props));
	
			_this.state = {
				status_title: 'Something went wrong'
			};
			return _this;
		}
	
		_createClass(Order_aborted, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					window.location.href = "/web/status/" + this.props.params.Type;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var status_title = 'Something went wrong';
				if (this.props.params.Type === 'aborted') {
					status_title = 'Transaction Aborted';
				} else if (this.props.params.Type === 'failure') {
					status_title = 'Transaction Failed';
				} else if (this.props.params.Type === 'invalid') {
					status_title = 'Invalid Transaction';
				} else if (this.props.params.Type === 'serverDown') {
					status_title = 'Server Down';
				}
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals order_aborted_page' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									'a',
									{ href: '/mycart' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
									)
								),
								'Confirmation'
							),
							_react2.default.createElement(
								'a',
								{ href: '/', title: 'Home', className: 'home_logo1' },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'pag_cntnt' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'abort_content' },
						status_title ? _react2.default.createElement(
							'h4',
							null,
							status_title
						) : _react2.default.createElement(
							'h4',
							null,
							'Something went wrong'
						),
						_react2.default.createElement(
							'a',
							{ href: '/mycart', className: 'try_again_btn' },
							'Try again'
						)
					)
				);
			}
		}]);
	
		return Order_aborted;
	}(_react.Component);
	
	exports.default = Order_aborted;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _NotFound = __webpack_require__(84);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// path is "/status/:book_id/:type/:Uid"
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Order_response = function (_Component) {
		_inherits(Order_response, _Component);
	
		function Order_response(props) {
			_classCallCheck(this, Order_response);
	
			var _this = _possibleConstructorReturn(this, (Order_response.__proto__ || Object.getPrototypeOf(Order_response)).call(this, props));
	
			_this.state = {
				response_data: [],
				page_error_status: false,
				payment_details: [],
				visibility: false,
				disclaimer_flag: false
			};
			_this.getOrderDetails = _this.getOrderDetails.bind(_this);
			return _this;
		}
	
		_createClass(Order_response, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				if (screen.width >= 800) {
					window.location.href = "/web/status/" + this.props.params.book_id + '/' + this.props.params.type + '/' + this.props.params.Uid;
				}
				this.getOrderDetails();
			}
		}, {
			key: 'getOrderDetails',
			value: function getOrderDetails() {
				var data1 = { from: 'mobile_web', user_id: localStorage.user_id, token: localStorage.token, type: this.props.params.type, book_id: this.props.params.book_id, uid: this.props.params.Uid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'get_order_responce',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								response_data: data,
								payment_details: data.payment_details,
								disclaimer_flag: data.disclaimer_flag
							});
						} else {
							this.setState({
								page_error_status: true
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'toggleDisclaimer',
			value: function toggleDisclaimer() {
				this.setState({ visibility: !this.state.visibility });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals order_success_page' },
					this.state.page_error_status ? _react2.default.createElement(_NotFound2.default, null) : _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'page_hdr' },
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										'a',
										{ href: '/' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
										)
									),
									'Confirmation'
								),
								_react2.default.createElement(
									'a',
									{ href: '/', title: 'Home', className: 'home_logo1' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'pag_cntnt' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'response_content' },
							_react2.default.createElement(
								'div',
								{ style: { textAlign: 'center', padding: '45px 0px 30px 0' } },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { style: { paddingBottom: '35px;' }, src: __webpack_require__(253), width: '60', alt: '...' })
								),
								_react2.default.createElement(
									'h5',
									{ style: { fontWeight: 800 } },
									this.state.response_data.success_msg
								),
								_react2.default.createElement(
									'h6',
									null,
									this.state.response_data.thank_msg
								)
							),
							_react2.default.createElement(
								'section',
								{ className: 'order_deatails_blk' },
								_react2.default.createElement(
									'div',
									{ className: 'order_deatails_card' },
									_react2.default.createElement(
										'h5',
										null,
										'ORDER DETAILS'
									),
									_react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											'span',
											null,
											'Order No'
										),
										_react2.default.createElement(
											'span',
											{ style: { float: 'right' } },
											'Order Date'
										)
									),
									_react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											'span',
											null,
											this.state.response_data.book_id
										),
										_react2.default.createElement(
											'span',
											{ style: { float: 'right' } },
											this.state.response_data.booking_date ? this.state.response_data.booking_date : ''
										)
									),
									_react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											'span',
											null,
											'Amount Paid (Online)'
										),
										_react2.default.createElement(
											'span',
											{ style: { float: 'right', fontWeight: 800 } },
											'\u20B9 ',
											this.state.response_data.total_online_payment
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'rate_us_block' },
									_react2.default.createElement(
										'ul',
										null,
										_react2.default.createElement(
											'li',
											null,
											_react2.default.createElement(
												'div',
												{ className: 'rate_img_block' },
												_react2.default.createElement('img', { className: 'img-responsive', src: __webpack_require__(257), alt: '...' })
											),
											_react2.default.createElement(
												'div',
												{ className: 'rate_content' },
												_react2.default.createElement(
													'h4',
													null,
													'Love the App?'
												),
												_react2.default.createElement(
													'h6',
													null,
													'Please take a moment to rate us,Your feedback is very important...'
												)
											),
											_react2.default.createElement(
												'a',
												{ href: 'https://goo.gl/gvP4pb' },
												_react2.default.createElement(
													'button',
													null,
													'Rate Now'
												)
											)
										),
										_react2.default.createElement(
											'li',
											null,
											_react2.default.createElement(
												'div',
												{ className: 'rate_img_block' },
												_react2.default.createElement('img', { className: 'img-responsive', src: __webpack_require__(258), alt: '...' })
											),
											_react2.default.createElement(
												'div',
												{ className: 'rate_content' },
												_react2.default.createElement(
													'h4',
													null,
													'Share & Earn'
												),
												_react2.default.createElement(
													'h6',
													null,
													'Invite your friends to AquaDeals and you both earn rewards.'
												)
											),
											_react2.default.createElement(
												'a',
												{ href: '/share_earn' },
												_react2.default.createElement(
													'button',
													null,
													'Share Now'
												)
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'conffirm_page_buttom_btns' },
									_react2.default.createElement(
										'ul',
										null,
										_react2.default.createElement(
											'li',
											null,
											_react2.default.createElement(
												'a',
												{ href: '/' },
												_react2.default.createElement(
													'button',
													null,
													'CONTINUE SHOPPING'
												)
											)
										),
										_react2.default.createElement(
											'li',
											null,
											_react2.default.createElement(
												'a',
												{ href: '/order_details/' + this.state.response_data.type + '/' + this.state.response_data.bid },
												_react2.default.createElement(
													'button',
													null,
													'REVIEW ORDER'
												)
											)
										)
									)
								),
								this.state.disclaimer_flag ? _react2.default.createElement(
									'div',
									{ className: 'view_disclaimer_details' },
									_react2.default.createElement(
										'span',
										{ id: 'disclaimer_toggle_txt' },
										_react2.default.createElement(
											'a',
											{ onClick: function onClick() {
													_this2.toggleDisclaimer();
												} },
											this.state.visibility ? "Hide Disclaimer" : "View Disclaimer"
										)
									),
									this.state.visibility ? _react2.default.createElement('span', { id: 'mob_disclaimer_txt', dangerouslySetInnerHTML: { __html: this.state.response_data.disclaimer_txt } }) : ''
								) : ''
							)
						),
						' '
					)
				);
			}
		}]);
	
		return Order_response;
	}(_react.Component);
	
	exports.default = Order_response;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactRedux = __webpack_require__(15);
	
	var _reactWebVectorIcons = __webpack_require__(29);
	
	var _reactWebVectorIcons2 = _interopRequireDefault(_reactWebVectorIcons);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Footer from './../Common/footer';
	
	
	var parseHtml = __webpack_require__(39);
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var QuickCart = function (_Component) {
		_inherits(QuickCart, _Component);
	
		function QuickCart(props) {
			_classCallCheck(this, QuickCart);
	
			var _this = _possibleConstructorReturn(this, (QuickCart.__proto__ || Object.getPrototypeOf(QuickCart)).call(this, props));
	
			_this.state = {};
			_this.state = {
				total: '',
				cartcount: '',
				grandtotal: '',
				items: [],
				aqua_cash: '',
				used_cash: '',
				used_cash1: '',
				ac_discount: '',
				coupons_amt: '',
				coupons_amt1: '',
				grand_total: '',
				openModal: false,
				applied_coupons: '',
				applied_coupons1: '',
				coupon_ref: '',
				coupon_err_msg: '',
				coupon_err_status: false,
				updateModal: false,
				coupon_success_status: false,
				coupon_success_msg: '',
				coupon_success_value: '',
				delete_status: false,
				delete_status_id: '',
	
				qty: '',
				min_qty: '',
				max_qty: '',
				cart_id: '',
				err_qty_status: false,
				err_qty_msg: '',
				coupons: [],
				billing_status: false,
	
				proceedCheck: 0,
				proceedMsg: '',
				ac_enough_msg: '',
				loc_msg: '',
				add_id: 0,
	
				coupon_code: 0,
				coupon_price: 0,
	
				state: '',
				zip: '',
				city: '',
				address: '',
				save_local_address_msg_status: false,
				ac_enough_msg_status: false,
				proceedMsg_status: false,
	
				promodiscount: '',
				promos: [],
				applied_promos: '',
	
				checkout_page_loading: false
			};
			_this.close = _this.close.bind(_this);
			_this.submitCoupon = _this.submitCoupon.bind(_this);
			_this.changeCoupon = _this.changeCoupon.bind(_this);
			_this.getCart = _this.getCart.bind(_this);
			_this.updateMinQty = _this.updateMinQty.bind(_this);
			_this.updateMinQtyModal = _this.updateMinQtyModal.bind(_this);
			_this.updateQuantity = _this.updateQuantity.bind(_this);
			_this.enableBillingDetails = _this.enableBillingDetails.bind(_this);
			_this.placeOrder = _this.placeOrder.bind(_this);
			_this.applyCoupon_getCart = _this.applyCoupon_getCart.bind(_this);
			_this.removeCoupon = _this.removeCoupon.bind(_this);
			_this.saveDefaultAddress = _this.saveDefaultAddress.bind(_this);
			_this.saveAddress_placeOrder = _this.saveAddress_placeOrder.bind(_this);
			_this.deleteSingleItem = _this.deleteSingleItem.bind(_this);
			_this.delete = _this.delete.bind(_this);
	
			return _this;
		}
	
		//saveDefaultAddress function is used to save the new address in checkout page
	
	
		_createClass(QuickCart, [{
			key: 'saveDefaultAddress',
			value: function saveDefaultAddress() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), name: localStorage.user_name, mobile: localStorage.user_mobile, state: this.state.state, city: this.state.city, address: this.state.address, zip: this.state.zip, quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'saveAdd',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							add_id: data.add_id
						});
						localStorage.setItem('address_change_flag', data.address_change);
						this.saveAddress_placeOrder();
					}.bind(this),
					error: function error(err) {}
				});
			}
			//function delete(id) gets the id from the deleteSingleItem(id) and removes the item from the cart.
	
		}, {
			key: 'delete',
			value: function _delete(id) {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'mobile_web', id: id, uid: uid, token: localStorage.getItem('token'), quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'singleCart_delete',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success" && data.message === "Item deleted successfully.") {
							this.getCart();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			// function deleteSingleItem(id) changes the status of the item block per 5 seconds to delete, can undo the deletions withing 5 sec or it calls the delete(id) function.
	
		}, {
			key: 'deleteSingleItem',
			value: function deleteSingleItem(id) {
				var _this2 = this;
	
				this.setState({
					delete_status: true,
					delete_status_id: id
				});
	
				//setTimeout(() => {this.setState({delete_status:false});}, 9000);
				setTimeout(function () {
					_this2.state.delete_status === true ? _this2.delete(id) : '';
				}, 5000);
			}
			//function updateQuantitiy is used to update the qunatity of the product in modal box and updating the cart values by calling the "applyCoupon_getCart" 
	
		}, {
			key: 'updateQuantity',
			value: function updateQuantity() {
				var x = '';
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (parseInt(this.state.qty, 10) < parseInt(this.state.min_qty, 10)) {
					// alert('Minimum Quantity is '+this.state.min_qty);
					x = 'Minimum Quantity is ' + this.state.min_qty;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Minimum Quantity is ' + this.state.min_qty
					});
				}
				if (this.state.qty === '') {
					// alert('Minimum Quantity is '+this.state.min_qty);
					x = 'Minimum Quantity is ' + this.state.min_qty;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Minimum Quantity is ' + this.state.min_qty
					});
				}
				if (parseInt(this.state.qty, 10) > parseInt(this.state.max_qty, 10)) {
					// alert('Maximum Quantity is '+this.state.max_qty);
					x = 'Maximum Quantity is ' + this.state.max_qty;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Maximum Quantity is ' + this.state.max_qty
					});
				}
				var check = /[^0-9]/gi;
				if (check.test(this.refs.mob_edit_qty.value)) {
					x = '* Invalid Quantity';
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Invalid Quantity'
					});
				}
				if (x === '') {
					this.setState({
						err_qty_status: false,
						err_qty_msg: ''
					});
					var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), cart_id: this.state.cart_id, quantity: this.state.qty, quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'update_qcart_qty',
						data: { req: data2 },
						success: function (data) {
							console.log(data);
							if (data.status === "success") {
								this.close();
								// this.getCart();
								this.applyCoupon_getCart();
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
			//function close is used to close all of the modal boxes
	
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					openModal: false,
					updateModal: false,
					save_local_address_msg_status: false,
					ac_enough_msg_status: false,
					proceedMsg_status: false
				});
			}
	
			//applyCoupon_getCart(value,code) function is used to call the cart function with updated state values of coupon price and coupon value. 
	
		}, {
			key: 'applyCoupon_getCart',
			value: function applyCoupon_getCart(value, code) {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), apply_ac: 1, apply_coupon: this.state.coupon_price, apply_coupon_code: this.state.coupon_code, quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
	
				localStorage.setItem('apply_coupon', this.state.coupon_price);
				localStorage.setItem('apply_coupon_code', this.state.coupon_code);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'cart',
					data: { req: data2 },
					success: function (data) {
						// console.log(data);
						localStorage.setItem('apply_coupon', this.state.coupon_price);
						localStorage.setItem('apply_coupon_code', this.state.coupon_code);
						this.setState({
							total: data.total,
							cartcount: data.cart_count,
							grandtotal: data.grand_total,
							items: data.items,
							ac_discount: data.ac_discount,
							aqua_cash: data.aqua_cash,
							used_cash: data.used_cash,
							used_cash1: data.used_cash1,
							coupons_amt: data.coupons_amt,
							coupons_amt1: data.coupons_amt1,
							grand_total: data.grand_total,
							applied_coupons: data.applied_coupons,
							applied_coupons1: data.applied_coupons1,
							coupons: data.coupons,
	
							proceedCheck: data.proceedCheck,
							proceedMsg: data.proceedMsg,
							ac_enough_msg: data.ac_enough_msg,
							loc_msg: data.loc_msg,
							add_id: data.add_id,
	
							state: data.state,
							zip: data.zip,
							city: data.city,
							address: data.address,
	
							promodiscount: data.promodiscount,
							promos: data.promos,
							applied_promos: data.applied_promos,
							shipping_note: data.shipping_note
						});
						localStorage.setItem('address_change_flag', data.address_change);
					}.bind(this),
					error: function error(err) {}
				});
			}
			//function getCart is used to get the cart values when page loads with empty params of coupons codes and values.
	
		}, {
			key: 'getCart',
			value: function getCart() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), apply_ac: 1, apply_coupon: 0, apply_coupon_code: '', quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				localStorage.setItem('apply_coupon', this.state.coupon_price);
				localStorage.setItem('apply_coupon_code', this.state.coupon_code);
	
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'cart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'error' && data.message === 'Token mismatch') {
							localStorage.clear();
							window.location.reload();
						}
						this.setState({
							total: data.total,
							cartcount: data.cart_count,
							grandtotal: data.grand_total,
							items: data.items,
							ac_discount: data.ac_discount,
							aqua_cash: data.aqua_cash,
							used_cash: data.used_cash,
							used_cash1: data.used_cash1,
							coupons_amt: data.coupons_amt,
							coupons_amt1: data.coupons_amt1,
							grand_total: data.grand_total,
							applied_coupons: data.applied_coupons,
							applied_coupons1: data.applied_coupons1,
							coupons: data.coupons,
	
							proceedCheck: data.proceedCheck,
							proceedMsg: data.proceedMsg,
							ac_enough_msg: data.ac_enough_msg,
							loc_msg: data.loc_msg,
							add_id: data.add_id,
	
							promodiscount: data.promodiscount,
							promos: data.promos,
							applied_promos: data.applied_promos,
							shipping_note: data.shipping_note
						});
						localStorage.setItem('address_change_flag', data.address_change);
					}.bind(this),
					error: function error(err) {}
				});
			}
	
			//componentDidMount function is loaded first when page loaded by checking the session and calls the getCart function.
	
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				if (!localStorage.token && !localStorage.user_id) {
					localStorage.setItem('mob_quickcart', '/quickcart');
					_reactRouter.browserHistory.push('/login');
				} else {
					this.getCart();
				}
				if (screen.width >= 800) {
					window.location.href = '/web/quickcart';
				}
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var that = this;
				setTimeout(function () {
					that.enableBillingDetails();
				}, 3000);
			}
		}, {
			key: 'enableBillingDetails',
			value: function enableBillingDetails() {
				// this.getCart();
				this.setState({
					billing_status: true
				});
			}
		}, {
			key: 'changeCoupon',
			value: function changeCoupon() {
				this.setState({
					coupon_ref: this.refs.apply_coupon.value,
					coupon_err_status: false
				});
			}
		}, {
			key: 'submitCoupon',
			value: function submitCoupon() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), coupon: this.refs.apply_coupon.value, public_amt: this.state.coupons_amt1, apply_ac: 1, quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'applyCoupon',
					data: { req: data2 },
					success: function (data) {
	
						if (data.status === "error") {
							this.setState({
								coupon_err_status: true,
								coupon_err_msg: data.message
							});
						}
						if (data.status === "success") {
							this.setState({
								coupon_code: data.code,
								coupon_price: data.value,
								coupon_success_msg: data.message,
								coupon_success_status: true,
								coupon_success_value: data.value
							});
							this.applyCoupon_getCart(data.value, data.code);
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'updateMinQty',
			value: function updateMinQty(qty, min_qty, max_qty, cart_id) {
				this.setState({
					updateModal: true,
					qty: qty,
					min_qty: min_qty,
					max_qty: max_qty,
					cart_id: cart_id
				});
			}
		}, {
			key: 'updateMinQtyModal',
			value: function updateMinQtyModal() {
				// alert(this.refs.min_qty.value);
				this.setState({
					qty: this.refs.mob_edit_qty.value,
					err_qty_status: false
				});
			}
			//saveAddress_placeOrder() function is called when the coupon is applied and shown location_msg and saving the address,if the address is saved then redirect to checkout page.
	
		}, {
			key: 'saveAddress_placeOrder',
			value: function saveAddress_placeOrder() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, mode: 2, add_id: this.state.add_id, code: this.state.coupon_code, coupon_amount: this.state.coupon_price, other_amount: '', aqua_cash: this.state.aqua_cash, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cartCalculations',
					success: function (data) {
						this.applyCoupon_getCart();
						if (data.status === "success") {
							_reactRouter.browserHistory.push('/quick_checkout');
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'placeOrder',
			value: function placeOrder() {
				if (this.state.proceedCheck === 0 && this.state.proceedMsg !== "") {
					this.setState({
						proceedMsg_status: true
					});
				} else if (this.state.proceedCheck === 0 && this.state.ac_enough_msg !== "") {
					this.setState({
						ac_enough_msg_status: true
					});
				} else if (this.state.proceedCheck === 0 && this.state.loc_msg !== "") {
					this.setState({
						save_local_address_msg_status: true
					});
				} else {
					this.setState({
						checkout_page_loading: true
					});
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, mode: 2, add_id: this.state.add_id, code: this.state.coupon_code, coupon_amount: this.state.coupon_price, other_amount: '', aqua_cash: this.state.used_cash1, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'cartCalculations',
						success: function (data) {
							this.applyCoupon_getCart();
							if (data.status === "success") {
								_reactRouter.browserHistory.push('/quick_checkout');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'removeCoupon',
			value: function removeCoupon() {
				this.setState({
					coupon_success_status: false,
					coupon_code: 0,
					coupon_price: 0
				});
				localStorage.setItem('apply_coupon', 0);
				localStorage.setItem('apply_coupon_code', 0);
				this.getCart();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				document.title = "Quick Buy Cart | AquaDeals";
				(0, _jquery2.default)('body').css('background', '#fff');
				var cart_items = this.state.items.map(function (item, index) {
					var _this3 = this;
	
					return _react2.default.createElement(
						'div',
						null,
						this.state.delete_status && this.state.delete_status_id === item.id ? _react2.default.createElement(
							'div',
							{ className: 'row cart_itemslist' },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-12 col-sm-12 col-md-12', style: { padding: '10px', color: '#666' } },
								_react2.default.createElement(
									'span',
									null,
									'Deleted'
								),
								_react2.default.createElement(
									'span',
									{ style: { float: 'right', cursor: 'pointer' }, onClick: function onClick() {
											_this3.setState({ delete_status: false });
										} },
									'UNDO'
								)
							)
						) : _react2.default.createElement(
							'div',
							{ className: 'row cart_itemslist' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12 col-sm-12 col-xs-12' },
								_react2.default.createElement(
									'button',
									{ onClick: function onClick() {
											item.type === 1 ? _this3.deleteSingleItem(item.id) : _this3.deleteSingleItem(item.id);
										}, ariaLabel: 'Close', className: 'close', type: 'button' },
									_react2.default.createElement(
										'span',
										{ ariaHidden: 'true' },
										'\xD7'
									)
								)
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: item.type === 0 ? '/sdetails/' + item.url_name + '/' + item.deal_id : '/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-3 col-sm-3 col-md-3 col-lg-3 cart_center_img' },
									item.type === 0 ? _react2.default.createElement('img', { src: baseAssets + 'icons/' + item.img, width: '50px', alt: ' ' }) : _react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/thumbnails/' + item.img, alt: ' ' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-9 col-sm-9 col-md-9 col-lg-9 cartdesc_blk' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: item.type === 0 ? '/sdetails/' + item.url_name + '/' + item.deal_id : '/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
									item.pro_name !== "" ? _react2.default.createElement(
										'p',
										{ className: 'cartitem_title' },
										item.pro_name
									) : _react2.default.createElement(
										'p',
										null,
										'\xA0'
									)
								),
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: item.type === 0 ? '/sdetails/' + item.url_name + '/' + item.deal_id : '/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-4 col-sm-4', style: { padding: '0px' } },
										item.mrp ? _react2.default.createElement(
											'span',
											null,
											'\u20B9 ',
											item.mrp
										) : ''
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-4 col-sm-4' },
									item.min_qty !== "" ? _react2.default.createElement(
										'p',
										{ className: 'mob_edit_qty', onClick: function onClick() {
												_this3.updateMinQty(item.qty, item.min_qty, item.max_qty, item.id);
											} },
										item.qty
									) : ''
								),
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: item.type === 0 ? '/sdetails/' + item.url_name + '/' + item.deal_id : '/pdetails/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.url_brand_name + '/' + item.url_product_name + '/' + item.pid + '/' + item.deal_id, style: { clear: 'both' } },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-4 col-sm-4', style: { paddingLeft: '0px', paddingRight: '0px' } },
										item.amount !== "" ? _react2.default.createElement(
											'p',
											null,
											_react2.default.createElement(
												'span',
												null,
												'\u20B9 '
											),
											_react2.default.createElement(
												'span',
												null,
												item.amount
											)
										) : ''
									)
								)
							)
						)
					);
				}.bind(this));
	
				var cart_coupons = '';
				cart_coupons = _react2.default.createElement(
					'div',
					{ className: 'row', style: { paddingTop: '10px', paddingBottom: '10px' } },
					_react2.default.createElement('div', { className: 'col-xs-2' }),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-6 col-xs-6 cart_coupon_blk' },
						_react2.default.createElement(
							'i',
							{ className: 'cart_left_img' },
							_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_left.png', alt: ' ' })
						),
						_react2.default.createElement('input', { type: 'text', ref: 'apply_coupon', maxLength: 15, placeholder: 'Enter coupon code', onChange: function onChange() {
								_this4.changeCoupon();
							} })
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-2 col-xs-2' },
						_react2.default.createElement(
							'div',
							{ className: 'cart_submit' },
							_react2.default.createElement(
								'button',
								{ className: 'cart_submitbtn', onClick: function onClick() {
										_this4.submitCoupon();
									} },
								'Apply'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-1 col-xs-1' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-6 col-xs-6 err_coupon' },
						_react2.default.createElement(
							'span',
							null,
							this.state.coupon_err_status ? this.state.coupon_err_msg : ''
						)
					)
				);
				var coupon_map = this.state.coupons.map(function (coupon, index) {
					return _react2.default.createElement(
						'span',
						{ key: index, style: { display: 'block' } },
						coupon.coupon_code,
						' (\u20B9',
						coupon.value,
						' )'
					);
				});
				var couponsList = _react2.default.createElement(
					_reactBootstrap.Popover,
					{ id: 'popover-positioned-top1' },
					coupon_map
				);
				var coupon_info = _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{ trigger: 'focus', placement: 'top', overlay: couponsList },
					_react2.default.createElement(
						_reactBootstrap.Button,
						{ className: 'cart_coupon_info_img' },
						_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_info.png', alt: ' ' })
					)
				);
				var promos_map = this.state.promos.map(function (promo, index) {
					return _react2.default.createElement(
						'span',
						{ key: index, style: { display: 'block' } },
						promo.promo_code,
						' ( \u20B9 ',
						promo.promo_value,
						' )'
					);
				});
				var promosList = _react2.default.createElement(
					_reactBootstrap.Popover,
					{ id: 'popover-positioned-top2' },
					promos_map
				);
				var promo_info = '';
				promo_info = _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{ trigger: 'focus', placement: 'top', overlay: promosList },
					_react2.default.createElement(
						_reactBootstrap.Button,
						{ className: 'cart_coupon_info_img' },
						_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_info.png', alt: ' ' })
					)
				);
				var coupon_success = '';
				if (this.state.coupon_success_status) {
					coupon_success = _react2.default.createElement(
						'div',
						{ className: 'cart_cpn_success' },
						_react2.default.createElement(
							'button',
							{ onClick: function onClick() {
									_this4.removeCoupon();
								}, ariaLabel: 'Close', className: 'coupon_close', type: 'button' },
							_react2.default.createElement(
								'i',
								null,
								_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cancel_coupon.png', alt: '', width: '20px' })
							)
						),
						_react2.default.createElement(
							'h5',
							null,
							'Coupon discount:(-) \u20B9 ',
							this.state.coupon_success_value
						),
						_react2.default.createElement(
							'p',
							null,
							this.state.coupon_success_msg
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals mob_cartpage' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						this.state.cartcount !== 0 ? _react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: '/' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { className: 'cross_icon', src: baseAssets + 'icons/web_icons/close_icon1.png', width: '14px', alt: '' })
									)
								),
								_react2.default.createElement(
									'span',
									{ className: 'header_text' },
									'QUICK BUY'
								)
							),
							_react2.default.createElement(
								'a',
								{ href: '/', className: 'home_newicon' },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
							)
						) : _react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ onClick: function onClick() {
											_reactRouter.browserHistory.goBack();
										} },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { className: 'cross_icon', src: baseAssets + 'icons/web_icons/close_icon1.png', width: '14px', alt: '' })
									)
								),
								_react2.default.createElement(
									'span',
									{ className: 'header_text' },
									'QUICK BUY'
								)
							),
							_react2.default.createElement(
								'a',
								{ href: '/', className: 'home_newicon' },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
							)
						)
					),
					this.state.cartcount !== 0 ? _react2.default.createElement(
						'div',
						null,
						this.state.checkout_page_loading ? _react2.default.createElement(
							'div',
							{ className: 'checkout_loading' },
							_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
						) : _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'section',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'section',
									{ id: 'cart-process' },
									_react2.default.createElement(
										'div',
										{ className: 'progressbar-wrapper' },
										_react2.default.createElement(
											'ul',
											{ className: 'progressbar' },
											_react2.default.createElement(
												'li',
												{ className: 'active' },
												_react2.default.createElement(
													'div',
													null,
													'Cart'
												),
												_react2.default.createElement(
													'div',
													null,
													_react2.default.createElement(_reactWebVectorIcons2.default, {
														name: 'check',
														font: 'Entypo',
														color: '#fff',
														size: 14
														// style={{}}
													})
												)
											),
											_react2.default.createElement(
												'li',
												null,
												'Checkout'
											),
											_react2.default.createElement(
												'li',
												null,
												'Payment'
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'row', style: { backgroundColor: '#f2f2f2', paddingTop: '10px', paddingBottom: '10px' } },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-6 col-sm-6 col-xs-6' },
										_react2.default.createElement(
											'span',
											{ className: 'cart_header_count' },
											this.state.cartcount > 1 ? 'Items : ' + this.state.cartcount : 'Item : ' + this.state.cartcount
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-md-6 col-sm-6 col-xs-6', style: { textAlign: 'right' } },
										_react2.default.createElement(
											'span',
											{ className: 'cart_header_total' },
											'Total: ',
											this.state.grandtotal
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'cart_itemsblk' },
									cart_items
								),
								_react2.default.createElement(
									'div',
									{ className: 'cart_couponblk' },
									_react2.default.createElement(
										'h4',
										{ className: 'quickcart_h4' },
										'Coupon Details'
									),
									_react2.default.createElement(
										'div',
										null,
										this.state.coupon_success_status ? coupon_success : cart_coupons
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'cart_billingblk' },
									_react2.default.createElement(
										'h4',
										{ className: 'quickcart_h4' },
										'Billing Details'
									),
									this.state.billing_status ? _react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'table',
											{ className: 'table cart_table' },
											_react2.default.createElement(
												'tr',
												{ className: 'cart_tr_total' },
												_react2.default.createElement(
													'td',
													null,
													'Total'
												),
												_react2.default.createElement(
													'td',
													null,
													'\u20B9 ',
													this.state.total
												)
											),
											this.state.used_cash ? _react2.default.createElement(
												'tr',
												{ className: 'cart_tr' },
												_react2.default.createElement(
													'td',
													null,
													'Aquacash Discount'
												),
												_react2.default.createElement(
													'td',
													null,
													'(-) \u20B9 ',
													this.state.used_cash
												)
											) : '',
											_react2.default.createElement(
												'tr',
												{ className: 'cart_tr', style: { display: this.state.coupons.length === 1 ? "table-row" : "none" } },
												_react2.default.createElement(
													'td',
													null,
													'Applied Coupon ',
													_react2.default.createElement(
														'span',
														{ className: 'applied_coupon_msg' },
														': ',
														this.state.coupons.length === 1 ? this.state.coupons[0]['coupon_code'] : ''
													)
												),
												_react2.default.createElement(
													'td',
													null,
													'(-) \u20B9 ',
													this.state.coupons_amt
												)
											),
											_react2.default.createElement(
												'tr',
												{ className: 'cart_tr', style: { display: this.state.coupons.length > 1 ? "table-row" : "none" } },
												_react2.default.createElement(
													'td',
													null,
													'Coupons applied on your purchase ',
													coupon_info
												),
												_react2.default.createElement(
													'td',
													null,
													'(-) \u20B9 ',
													this.state.coupons_amt
												)
											),
											parseInt(this.state.promodiscount, 10) > 0 ? _react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													'Promos Discount ',
													this.state.promos.length === 1 ? _react2.default.createElement(
														'span',
														{ className: 'applied_coupon_msg' },
														': ',
														this.state.promos[0].promo_code
													) : promo_info,
													' '
												),
												_react2.default.createElement(
													'td',
													null,
													'(-) \u20B9 ',
													this.state.promodiscount
												)
											) : '',
											_react2.default.createElement(
												'tr',
												{ className: 'cart_tr_grandtotal' },
												_react2.default.createElement(
													'td',
													null,
													'GRAND TOTAL '
												),
												_react2.default.createElement(
													'td',
													null,
													'\u20B9 ',
													this.state.grand_total
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'td',
													null,
													parseHtml(this.state.shipping_note)
												),
												'}'
											)
										)
									) : _react2.default.createElement(
										'div',
										{ className: 'price_loading' },
										_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
									)
								)
							),
							_react2.default.createElement(
								'section',
								{ className: 'botm_btns row' },
								_react2.default.createElement(
									'ul',
									{ className: 'mycart_ul' },
									_react2.default.createElement(
										'li',
										{ className: 'col-md-6 col-xs-6 col-sm-6', style: { cursor: 'pointer' } },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/', title: '' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cart_icon_orange.png', alt: ' ' })
											),
											'CONTINUE SHOPPING'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'col-md-6 col-xs-6 col-sm-6', style: { cursor: 'pointer' } },
										_react2.default.createElement(
											'a',
											{ onClick: function onClick() {
													_this4.placeOrder();
												} },
											'PLACE ORDER ',
											_react2.default.createElement(
												'span',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/continue.png', width: '12px', alt: ' ' })
											)
										)
									)
								)
							)
						)
					) : _react2.default.createElement(
						'div',
						{ className: 'cart_emtpy' },
						_react2.default.createElement(
							'i',
							null,
							_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/empty_cartbg.png', alt: '...' })
						),
						_react2.default.createElement(
							'h4',
							null,
							'Your Cart is Empty'
						),
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: "/", className: 'cart_shopbtn' },
							'SHOP NOW'
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: '', show: this.state.openModal, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'AquaDeals'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#666' } },
								'You need to install Android mobile app to place this order.'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: '#fff none repeat scroll 0 0', color: '#ff742a' }, onClick: this.close },
								'Close'
							),
							_react2.default.createElement(
								'a',
								{ href: 'https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en', target: '_blank', title: '' },
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: '#ff742a none repeat scroll 0 0', color: '#fff' } },
									'OK'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'mob_edit_qty_modal', show: this.state.updateModal, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								null,
								_react2.default.createElement('input', { ref: 'mob_edit_qty', type: 'text', value: this.state.qty, placeholder: 'Enter Quantity', onChange: function onChange() {
										_this4.updateMinQtyModal();
									} })
							),
							this.state.err_qty_status ? _react2.default.createElement(
								'p',
								{ className: 'mob_err_qty' },
								this.state.err_qty_msg
							) : ''
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'mob_edit_qty_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ className: 'mob_edit_qty_cls_btn', onClick: this.close },
								'CANCEL'
							),
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ className: 'mob_edit_qty_update_btn', onClick: function onClick() {
											_this4.updateQuantity();
										} },
									'UPDATE'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: '', show: this.state.save_local_address_msg_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#666' } },
								this.state.loc_msg
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'mob_cart_confirm' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ className: '', onClick: this.close },
								'NO'
							),
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ className: '', onClick: function onClick() {
											_this4.saveDefaultAddress();
										} },
									'YES'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: '', show: this.state.ac_enough_msg_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#666' } },
								this.state.ac_enough_msg
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'mob_cart_confirm' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ className: '', onClick: this.close },
								'CLOSE'
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/customer_care' },
								_react2.default.createElement(
									_reactBootstrap.Button,
									null,
									'CUSTOMER SUPPORT'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: '', show: this.state.proceedMsg_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#666' } },
								this.state.proceedMsg
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'mob_cart_confirm' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ className: '', onClick: this.close },
								'CANCEL'
							)
						)
					)
				);
			}
		}]);
	
		return QuickCart;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			save_order_status: state.posts.mycart_order_status,
			total_cart_data: state.posts.total_cart_data
		};
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(QuickCart);

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _custom_functions = __webpack_require__(69);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactWebVectorIcons = __webpack_require__(29);
	
	var _reactWebVectorIcons2 = _interopRequireDefault(_reactWebVectorIcons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Footer from './../Common/footer';
	
	
	var parseHtml = __webpack_require__(39);
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Quick_Checkout = function (_Component) {
		_inherits(Quick_Checkout, _Component);
	
		function Quick_Checkout(props) {
			_classCallCheck(this, Quick_Checkout);
	
			var _this = _possibleConstructorReturn(this, (Quick_Checkout.__proto__ || Object.getPrototypeOf(Quick_Checkout)).call(this, props));
	
			_this.state = {};
			_this.state = {
				page_loading: false,
				lod: false,
				user_address: [],
				edit_add_id: '',
				address_flag: 0,
				add_address_form_status: false,
				add_available: false,
				add_address: false,
				edit_address: false,
				click_here_status: false,
				tot_data: _this.props.total_cart_data,
				add_id: '',
				edit_data: [],
				// edit form elements 
				edit_name: '',
				edit_mobile: '',
				edit_state: '',
				edit_city: '',
				edit_doorno: '',
				edit_pincode: '',
	
				// add form elements
				add_name: localStorage.user_name,
				add_mobile: localStorage.user_mobile,
				add_state: '',
				add_city: '',
				add_doorno: '',
				add_pincode: '',
	
				//cart response 
				cart_count: 0,
				grand_total: 0,
				cart_add_id: '',
				coupon_code: 0,
				aqua_cash: '',
				coupons_amt: '',
				ac_discount: '',
	
				//cart calculations response
				mode: '',
				pay_advance: '',
				complete_amount: '',
				pay_at_outlet: '',
				final_amt: '',
				totals: '',
				other_amount_field_status: false,
				ptype: '',
				min_val: '',
				max_val: '',
				err_qty_status: false,
				err_qty_msg: '',
	
				paymentMethodStatus: '',
				offline_payment: '',
				prebook_payment: '',
				fullamount_payment: '',
				otheramount_payment: '',
	
				// cart calculations respnose before pay now
				deal_id: 0,
				product_id: 0,
				quantity: '',
				act_price: '',
				deal_price: '',
				total: '',
				total_discount: '',
				discount: '',
				pre_booking_amount: '',
				bank_fee: '',
				total_thx_fee: '',
				save_price: '',
				remaining_amount: '',
				payable_ad: '',
				payable_hatchery: '',
				ac_offer_title: '',
				aqua_cash_value: '',
				aqua_cash_code: '',
				ac_cal_info: '',
				pur_ern_ofr_code: '',
				pur_ern_ofr_title: '',
				pur_ern_ofr_desc: '',
				pur_ern_retrn_amt: '',
				full_aquacash_back_amount: '',
				full_aquacash_back_title: '',
				full_aquacash_back_code: '',
				full_aquacash_back_description: '',
				deal_type: '',
				promo_code: '',
				promo_amt: '',
				promo_title: '',
				promo_help: '',
				free_shipment: '',
				free_shipment_msg: '',
				user_details: [],
				coupon_amt: '',
				cart_ids: '',
				promodiscount: '',
				applied_promos: '',
				promos: [],
				ac_enough: '',
				ac_enough_msg: '',
				applied_coupons: '',
	
				//variable for storing the payment radio buttons 
				total_online_payment: '',
				default_ptype: '',
				mode_loading: false,
				amount_loading: false,
				evnt_key: 2,
	
				// offline payment success displaying it in modal
				success_msg: '',
				thank_msg: '',
	
				offline_confirm_data: [],
				offline_pay_success_status: false,
	
				paying_process: false,
	
				// online payment response variables start
				pre_payment_id: '',
				order_id: '',
				//deal_type:'',
				//cart_ids:'',
				paid_amt: '',
				response: '',
				gateway_mode: '',
				pageId: '.quick_checkout_page'
				// online payment response variables ends here
			};
			_this.testclose = _this.testclose.bind(_this);
	
			_this.getUserAddress = _this.getUserAddress.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.handleSubmit_add = _this.handleSubmit_add.bind(_this);
			_this.editAddress = _this.editAddress.bind(_this);
			_this.deleteAddress = _this.deleteAddress.bind(_this);
			_this.handleSubmit_edit = _this.handleSubmit_edit.bind(_this);
			_this.getAddressDetails = _this.getAddressDetails.bind(_this);
	
			// functions for edit address form
			_this.edit_nameChange = _this.edit_nameChange.bind(_this);
			_this.edit_mobileChange = _this.edit_mobileChange.bind(_this);
			_this.edit_stateChange = _this.edit_stateChange.bind(_this);
			_this.edit_cityChange = _this.edit_cityChange.bind(_this);
			_this.edit_doornoChange = _this.edit_doornoChange.bind(_this);
			_this.edit_pincodeChange = _this.edit_pincodeChange.bind(_this);
	
			// functions for add address form
			_this.add_nameChange = _this.add_nameChange.bind(_this);
			_this.add_mobileChange = _this.add_mobileChange.bind(_this);
			_this.add_stateChange = _this.add_stateChange.bind(_this);
			_this.add_cityChange = _this.add_cityChange.bind(_this);
			_this.add_doornoChange = _this.add_doornoChange.bind(_this);
			_this.add_pincodeChange = _this.add_pincodeChange.bind(_this);
	
			_this.getCart = _this.getCart.bind(_this);
			_this.getCartCalculations = _this.getCartCalculations.bind(_this);
			_this.validateOtherAmount = _this.validateOtherAmount.bind(_this);
	
			_this.modeChange_cartCalculations = _this.modeChange_cartCalculations.bind(_this);
			_this.handleTabsSelect = _this.handleTabsSelect.bind(_this);
			_this.payNow = _this.payNow.bind(_this);
			_this.ccAvenue = _this.ccAvenue.bind(_this);
	
			_this.other_amount_cartCalculations = _this.other_amount_cartCalculations.bind(_this);
			return _this;
		}
	
		_createClass(Quick_Checkout, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				this.props.get_rzp_keys("desktop_web");
				if (screen.width >= 800) {
					window.location.href = "/web/quick_checkout";
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('checkout', '/quick_checkout');
					_reactRouter.browserHistory.push('/login');
				} else {
					this.getUserAddress();
				}
				// this.getCart();
			}
		}, {
			key: 'testclose',
			value: function testclose() {
				this.setState({
					offline_pay_success_status: false
				});
			}
		}, {
			key: 'ccAvenue',
			value: function ccAvenue() {
				var username = this.state.user_details.username;
				var email = this.state.user_details.email;
				var mobile = this.state.user_details.mobile;
				var address = this.state.user_details.address;
				var city = this.state.user_details.city;
				var pincode = this.state.user_details.pincode;
				var state = this.state.user_details.state;
				// var behalf_of=this.state.user_details.behalf_of;
				var deal_type = this.state.deal_type;
				var add_id = this.state.cart_add_id;
	
				var basePayUrl = 'https://aqua.deals/paymentGateWay/paymentRequestHandler.php';
				// var basePayUrl='http://203.193.173.125/paymentGateWay/paymentRequestHandler.php';
	
				var data1 = { access_code: 'AVIJ67DJ41BD20JIDB', merchant_id: '103328', order_id: this.state.order_id, merchant_param1: this.state.pre_payment_id, merchant_param2: deal_type, merchant_param3: add_id, merchant_param4: 'mobile_web', amount: this.state.paid_amt, currency: 'INR', cancel_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', redirect_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', billing_name: username, billing_address: address, billing_city: city, billing_state: state, billing_zip: pincode, billing_tel: mobile, billing_country: 'India', billing_email: email };
				// var data1={access_code:'AVJZ66DG16BM17ZJMB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:add_id,merchant_param4:'mobile_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',redirect_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
				_jquery2.default.ajax({
					method: 'POST',
					data: data1,
					url: basePayUrl,
					success: function success(data) {
						(0, _jquery2.default)('.quick_checkout_page').html(data);
					},
					error: function error(err) {}
				});
			}
			//payNow function is used to submit the values to 
	
		}, {
			key: 'payNow',
			value: function payNow() {
				if (this.state.add_address_form_status) {
					this.setState({
						add_address: true
					});
				} else {
					this.setState({
						paying_process: true
					});
	
					// here this.state.ptype = mode of the payment 
					// 1:offline, 2:pay advance, 3:online pay total , 4: online pay other amount
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					if (this.state.ptype === 1) {
						var data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, product_id: this.state.product_id, quantity: this.state.quantity, act_price: this.state.act_price, deal_price: this.state.deal_price, total: this.state.total, total_discount: this.state.total_discount, discount: this.state.discount, total_online_payment: this.state.total_online_payment, pre_booking_amount: this.state.pre_booking_amount, bank_fee: this.state.bank_fee, total_thx_fee: this.state.total_thx_fee, save_price: this.state.save_price, remaining_amount: this.state.remaining_amount, payable_ad: this.state.payable_ad, payable_hatchery: this.state.payable_hatchery, mode: this.state.ptype, coupons_amt: this.state.coupons_amt, aqua_cash: this.state.aqua_cash, ac_offer_title: this.state.ac_offer_title, aqua_cash_value: this.state.aqua_cash_value, aqua_cash_code: this.state.aqua_cash_code, ac_cal_info: this.state.ac_cal_info, pur_ern_ofr_code: this.state.pur_ern_ofr_code, pur_ern_ofr_title: this.state.pur_ern_ofr_title, pur_ern_ofr_desc: this.state.pur_ern_ofr_desc, pur_ern_retrn_amt: this.state.pur_ern_retrn_amt, full_aquacash_back_amount: this.state.full_aquacash_back_amount, full_aquacash_back_title: this.state.full_aquacash_back_title, full_aquacash_back_code: this.state.full_aquacash_back_code, full_aquacash_back_description: this.state.full_aquacash_back_description, deal_type: this.state.deal_type, promo_code: this.state.promo_code, promo_amt: this.state.promo_amt, promo_title: this.state.promo_title, promo_help: this.state.promo_help, free_shipment: this.state.free_shipment, free_shipment_msg: this.state.free_shipment_msg, paymentMethodStatus: this.state.paymentMethodStatus, add_id: this.state.cart_add_id, complete_amount: this.state.complete_amount, pay_advance: this.state.pay_advance, pay_at_outlet: this.state.pay_at_outlet, final_amt: this.state.final_amt, totals: this.state.totals, coupon_code: this.state.coupon_code, coupon_amt: this.state.coupon_amt, cart_ids: this.state.cart_ids, applied_coupons: this.state.applied_coupons, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
						var data2 = JSON.stringify(data1);
						_jquery2.default.ajax({
							method: 'POST',
							dataType: 'json',
							data: { req: data2 },
							url: baseUrl + 'bookCart',
							success: function (data) {
								if (data.status === "success") {
									this.setState({
										offline_confirm_data: data,
										offline_pay_success_status: true,
										paying_process: false
									});
									(0, _jquery2.default)('#off_modal_status').parent().addClass('offline_modal');
								}
							}.bind(this),
							error: function error(err) {}
						});
					} else if (this.state.ptype === 3 || this.state.ptype === 2) {
						data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, product_id: this.state.product_id, quantity: this.state.quantity, act_price: this.state.act_price, deal_price: this.state.deal_price, total: this.state.total, total_discount: this.state.total_discount, discount: this.state.discount, total_online_payment: this.state.total_online_payment, pre_booking_amount: this.state.pre_booking_amount, bank_fee: this.state.bank_fee, total_thx_fee: this.state.total_thx_fee, save_price: this.state.save_price, remaining_amount: this.state.remaining_amount, payable_ad: this.state.payable_ad, payable_hatchery: this.state.payable_hatchery, mode: this.state.ptype, aqua_cash: this.state.aqua_cash, ac_offer_title: this.state.ac_offer_title, aqua_cash_value: this.state.aqua_cash_value, aqua_cash_code: this.state.aqua_cash_code, ac_cal_info: this.state.ac_cal_info, pur_ern_ofr_code: this.state.pur_ern_ofr_code, pur_ern_ofr_title: this.state.pur_ern_ofr_title, pur_ern_ofr_desc: this.state.pur_ern_ofr_desc, pur_ern_retrn_amt: this.state.pur_ern_retrn_amt, full_aquacash_back_title: this.state.full_aquacash_back_title, full_aquacash_back_code: this.state.full_aquacash_back_code, full_aquacash_back_description: this.state.full_aquacash_back_description, full_aquacash_back_amount: this.state.full_aquacash_back_amount, deal_type: this.state.deal_type, promo_code: this.state.promo_code, promo_amt: this.state.promo_amt, promo_title: this.state.promo_title, promo_help: this.state.promo_help, free_shipment: this.state.free_shipment, free_shipment_msg: this.state.free_shipment_msg, paymentMethodStatus: this.state.paymentMethodStatus, add_id: this.state.cart_add_id, complete_amount: this.state.complete_amount, pay_advance: this.state.pay_advance, pay_at_outlet: this.state.pay_at_outlet, final_amt: this.state.final_amt, totals: this.state.totals, coupon_code: this.state.coupon_code, coupon_amt: this.state.coupon_amt, cart_ids: this.state.cart_ids, applied_coupons: this.state.applied_coupons, coupons_amt: this.state.coupons_amt, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
						data2 = JSON.stringify(data1);
						_jquery2.default.ajax({
							method: 'POST',
							dataType: 'json',
							data: { req: data2 },
							url: baseUrl + 'onlineCartProcessing',
							success: function (data) {
								if (data.status === "success") {
									this.setState({
										pre_payment_id: data.pre_payment_id,
										order_id: data.order_id,
										deal_type: data.deal_type,
										cart_ids: data.cart_ids,
										paid_amt: data.paid_amt
									});
									var payment_params = { from: 'mobile_web',
										uid: localStorage.getItem('user_id'),
										pre_payment_id: data.pre_payment_id,
										order_id: data.order_id,
										deal_type: data.deal_type,
										cart_ids: data.cart_ids,
										paid_amt: data.paid_amt,
										username: this.state.user_details.username,
										address: this.state.user_details.address,
										city: this.state.user_details.city,
										state: this.state.user_details.state,
										pincode: this.state.user_details.pincode,
										mobile: this.state.user_details.mobile,
										country: 'India',
										email: this.state.user_details.email,
										cart_add_id: this.state.cart_add_id,
										pageId: this.state.pageId,
										rzp_key: this.props.rzp_keys.key_id };
									if (this.state.gateway_mode == 2) {
										(0, _custom_functions.razorpayForm)(payment_params);
										this.setState({
											paying_process: false
										});
									} else {
										(0, _custom_functions.ccAvenue)(payment_params);
									}
									//this.ccAvenue();
								}
							}.bind(this),
							error: function error(err) {
								console.log(err);
							}
						});
					} else if (this.state.ptype === 4) {
						var x = '';
						if (this.refs.ref_other_amt.value === "") {
							x = '* Enter Amount';
							this.setState({
								err_qty_msg: '* Enter Amount',
								err_qty_status: true
							});
						}
						if (parseInt(this.refs.ref_other_amt.value, 10) < parseInt(this.state.min_val, 10)) {
							x = 'Minimum Quantity is ' + this.state.min_val;
							this.setState({
								err_qty_status: true,
								err_qty_msg: '* Minimum amount is ' + this.state.min_val
							});
						}
						if (this.refs.ref_other_amt === '') {
							x = 'Minimum Quantity is ' + this.state.min_val;
							this.setState({
								err_qty_status: true,
								err_qty_msg: '* Minimum amount is ' + this.state.min_val
							});
						}
						if (parseInt(this.refs.ref_other_amt.value, 10) > parseInt(this.state.max_val, 10)) {
							// alert('Maximum Quantity is '+this.state.max_qty);
							x = 'Maximum Quantity is ' + this.state.max_val;
							this.setState({
								err_qty_status: true,
								err_qty_msg: '* Maximum amount is ' + this.state.max_val
							});
						}
						var check = /[^0-9]/gi;
						if (check.test(this.refs.ref_other_amt.value)) {
							x = '* Invalid Amount';
							this.setState({
								err_qty_status: true,
								err_qty_msg: '* Invalid Amount'
							});
						}
	
						if (x === '') {
							data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, product_id: this.state.product_id, quantity: this.state.quantity, act_price: this.state.act_price, deal_price: this.state.deal_price, total: this.state.total, total_discount: this.state.total_discount, discount: this.state.discount, total_online_payment: this.state.total_online_payment, pre_booking_amount: this.state.pre_booking_amount, bank_fee: this.state.bank_fee, total_thx_fee: this.state.total_thx_fee, save_price: this.state.save_price, remaining_amount: this.state.remaining_amount, payable_ad: this.state.payable_ad, payable_hatchery: this.state.payable_hatchery, mode: this.state.ptype, aqua_cash: this.state.aqua_cash, ac_offer_title: this.state.ac_offer_title, aqua_cash_value: this.state.aqua_cash_value, aqua_cash_code: this.state.aqua_cash_code, ac_cal_info: this.state.ac_cal_info, pur_ern_ofr_code: this.state.pur_ern_ofr_code, pur_ern_ofr_title: this.state.pur_ern_ofr_title, pur_ern_ofr_desc: this.state.pur_ern_ofr_desc, pur_ern_retrn_amt: this.state.pur_ern_retrn_amt, full_aquacash_back_title: this.state.full_aquacash_back_title, full_aquacash_back_code: this.state.full_aquacash_back_code, full_aquacash_back_description: this.state.full_aquacash_back_description, full_aquacash_back_amount: this.state.full_aquacash_back_amount, deal_type: this.state.deal_type, promo_code: this.state.promo_code, promo_amt: this.state.promo_amt, promo_title: this.state.promo_title, promo_help: this.state.promo_help, free_shipment: this.state.free_shipment, free_shipment_msg: this.state.free_shipment_msg, paymentMethodStatus: this.state.paymentMethodStatus, add_id: this.state.cart_add_id, complete_amount: this.state.complete_amount, pay_advance: this.state.pay_advance, pay_at_outlet: this.state.pay_at_outlet, final_amt: this.state.final_amt, totals: this.state.totals, coupon_code: this.state.coupon_code, coupon_amt: this.state.coupon_amt, cart_ids: this.state.cart_ids, applied_coupons: this.state.applied_coupons, coupons_amt: this.state.coupons_amt, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
							data2 = JSON.stringify(data1);
							_jquery2.default.ajax({
								method: 'POST',
								dataType: 'json',
								data: { req: data2 },
								url: baseUrl + 'onlineCartProcessing',
								success: function (data) {
									if (data.status === "success") {
										this.setState({
											pre_payment_id: data.pre_payment_id,
											order_id: data.order_id,
											deal_type: data.deal_type,
											cart_ids: data.cart_ids,
											paid_amt: data.paid_amt
										});
										var payment_params = { from: 'mobile_web',
											uid: localStorage.getItem('user_id'),
											pre_payment_id: data.pre_payment_id,
											order_id: data.order_id,
											deal_type: data.deal_type,
											cart_ids: data.cart_ids,
											paid_amt: data.paid_amt,
											username: this.state.user_details.username,
											address: this.state.user_details.address,
											city: this.state.user_details.city,
											state: this.state.user_details.state,
											pincode: this.state.user_details.pincode,
											mobile: this.state.user_details.mobile,
											country: 'India',
											email: this.state.user_details.email,
											cart_add_id: this.state.cart_add_id,
											pageId: this.state.pageId,
											rzp_key: this.props.rzp_keys.key_id };
										if (this.state.gateway_mode == 2) {
											(0, _custom_functions.razorpayForm)(payment_params);
											this.setState({
												paying_process: false
											});
										} else {
											(0, _custom_functions.ccAvenue)(payment_params);
										}
										//this.ccAvenue();
									}
								}.bind(this),
								error: function error(err) {
									console.log(err);
								}
							});
						} else {
							// alert('error');
						}
						this.setState({
							paying_process: false
						});
					}
				}
			}
			// getUserAddress function is used to get the address of the user when page loads. 
	
		}, {
			key: 'getUserAddress',
			value: function getUserAddress() {
				var _this2 = this;
	
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getuserAddress',
					success: function (data) {
						if (data.status === "success" && data.address.length > 0) {
							this.setState({
								user_address: data.address,
								address_flag: data.address_flag,
								add_available: true,
								click_here_status: false,
								add_address_form_status: false
							});
						} else if (data.status === "success" && data.address.length === 0) {
							this.setState({
								user_address: data.address,
								click_here_status: true,
								address_flag: data.address_flag,
								add_address_form_status: true
							});
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
				this.getCart();
				setTimeout(function () {
					_this2.setState({ lod: true });
				}, 8000);
			}
			//getCart function is used to get the cart values from the cart page to get the cart values to the checkout page
	
		}, {
			key: 'getCart',
			value: function getCart() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var apply_coupon = localStorage.getItem('apply_coupon');
				var apply_coupon_code = localStorage.getItem('apply_coupon_code');
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), apply_ac: 1, apply_coupon: apply_coupon, apply_coupon_code: apply_coupon_code, quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cart',
					success: function (data) {
						this.setState({
							total: data.total,
							cart_count: data.cart_count,
							//add_id:data.add_id,
							ac_discount: data.ac_discount,
							grand_total: data.grand_total,
							aqua_cash: data.aqua_cash,
							ac_enough: data.ac_enough,
							ac_enough_msg: data.ac_enough_msg,
							apply_ac: data.apply_ac,
							used_cash: data.used_cash,
							used_cash1: data.used_cash1,
							coupons: data.coupons,
							applied_coupons: data.applied_coupons,
							applied_coupons1: data.applied_coupons1,
							coupons_amt: data.coupons_amt,
							coupons_amt1: data.coupons_amt1,
							proceedCheck: data.proceedCheck,
							proceedMsg: data.proceedMsg,
							promodiscount: data.promodiscount,
							promos: data.promos,
							applied_promos: data.applied_promos,
							loc_msg: data.loc_msg,
							address_change: data.address_change,
							address: data.address,
							location: data.location,
							zip: data.zip,
							state: data.state,
							city: data.city,
							cart_add_id: data.add_id
						});
						this.getCartCalculations();
					}.bind(this),
					error: function error(err) {}
				});
			}
			//getCartCalculations function is used to get the results of the cart and payment types resutls.
	
		}, {
			key: 'getCartCalculations',
			value: function getCartCalculations() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				this.setState({
					mode_loading: true,
					amount_loading: true
				});
				var uid = 0;
				var token = 0;
				var coupon_code = 0;
				var coupon_amount = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.token) {
					token = localStorage.getItem('token');
				} else {
					token = 0;
				}
				if (localStorage.apply_coupon_code) {
					coupon_code = localStorage.getItem('apply_coupon_code');
				} else {
					coupon_code = 0;
				}
				if (localStorage.apply_coupon) {
					coupon_amount = localStorage.getItem('apply_coupon');
				} else {
					coupon_amount = 0;
				}
				var data1 = { from: 'mobile_web', uid: uid, token: token, mode: 2, add_id: this.state.cart_add_id, code: coupon_code, coupon_amount: coupon_amount, other_amount: '', aqua_cash: this.state.used_cash1, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cartCalculations',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								mode_loading: false,
								page_loading: true,
								amount_loading: false,
								mode: data.mode,
								ptype: data.mode,
								default_ptype: data.mode,
								final_amt: data.final_amt,
								pay_at_outlet: data.pay_at_outlet,
								pay_advance: data.pay_advance,
								complete_amount: data.complete_amount,
								min_val: data.min_val,
								max_val: data.max_val,
	
								paymentMethodStatus: data.paymentMethodStatus,
								offline_payment: data.offline_payment,
								prebook_payment: data.prebook_payment,
								fullamount_payment: data.fullamount_payment,
								otheramount_payment: data.otheramount_payment,
	
								total_online_payment: data.total_online_payment,
	
								product_id: data.product_id,
								quantity: data.quantity,
								act_price: data.act_price,
								deal_price: data.deal_price,
								total: data.total,
								total_discount: data.total_discount,
								discount: data.discount,
								pre_booking_amount: data.pre_booking_amount,
								bank_fee: data.bank_fee,
								total_thx_fee: data.total_thx_fee,
								save_price: data.save_price,
								remaining_amount: data.remaining_amount,
								payable_ad: data.payable_ad,
								payable_hatchery: data.payable_hatchery,
								aqua_cash: data.aqua_cash,
								ac_offer_title: data.ac_offer_title,
								aqua_cash_value: data.aqua_cash_value,
								aqua_cash_code: data.aqua_cash_code,
								ac_cal_info: data.ac_cal_info,
								pur_ern_ofr_code: data.pur_ern_ofr_code,
								pur_ern_ofr_title: data.pur_ern_ofr_title,
								pur_ern_ofr_desc: data.pur_ern_ofr_desc,
								pur_ern_retrn_amt: data.pur_ern_retrn_amt,
								full_aquacash_back_title: data.full_aquacash_back_title,
								full_aquacash_back_code: data.full_aquacash_back_code,
								full_aquacash_back_description: data.full_aquacash_back_description,
								full_aquacash_back_amount: data.full_aquacash_back_amount,
								deal_type: data.deal_type,
								promo_code: data.promo_code,
								promo_amt: data.promo_amt,
								promo_title: data.promo_title,
								promo_help: data.promo_help,
								free_shipment: data.free_shipment,
								free_shipment_msg: data.free_shipment_msg,
								coupon_code: data.coupon_code,
								coupon_amt: data.coupon_amt,
								cart_ids: data.cart_ids,
								coupons_amt: data.coupons_amt,
								promodiscount: data.promodiscount,
								applied_promos: data.applied_promos,
	
								user_details: data.user_details,
								cart_add_id: data.add_id,
								gateway_mode: data.gateway_mode,
								deliver_date_text: data.deliver_date_text,
								payment_options: data.payment_options
							});
	
							if (data.mode !== 1) {
								this.setState({
									evnt_key: 2
								});
							}
						}
					}.bind(this),
					error: function (err) {
						this.setState({
							page_loading: false,
							lod: true
						});
					}.bind(this)
				});
			}
		}, {
			key: 'other_amount_cartCalculations',
			value: function other_amount_cartCalculations(mode, other_amount) {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				this.setState({
					amount_loading: true
				});
				var uid = 0;
				var token = 0;
				var coupon_code = 0;
				var coupon_amount = 0;
	
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.token) {
					token = localStorage.getItem('token');
				} else {
					token = 0;
				}
				if (localStorage.apply_coupon_code) {
					coupon_code = localStorage.getItem('apply_coupon_code');
				} else {
					coupon_code = 0;
				}
				if (localStorage.apply_coupon) {
					coupon_amount = localStorage.getItem('apply_coupon');
				} else {
					coupon_amount = 0;
				}
				var data1 = { from: 'mobile_web', uid: uid, token: token, mode: 4, add_id: this.state.cart_add_id, code: coupon_code, coupon_amount: coupon_amount, other_amount: other_amount, aqua_cash: this.state.used_cash1, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cartCalculations',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								// mode_loading:false,
								amount_loading: false,
								mode: data.mode,
								ptype: data.mode,
								final_amt: data.final_amt,
								pay_at_outlet: data.pay_at_outlet,
								pay_advance: data.pay_advance,
								complete_amount: data.complete_amount,
								min_val: data.min_val,
								max_val: data.max_val,
	
								paymentMethodStatus: data.paymentMethodStatus,
								offline_payment: data.offline_payment,
								prebook_payment: data.prebook_payment,
								fullamount_payment: data.fullamount_payment,
								otheramount_payment: data.otheramount_payment,
								total_online_payment: data.total_online_payment,
								product_id: data.product_id,
								quantity: data.quantity,
								act_price: data.act_price,
								deal_price: data.deal_price,
								total: data.total,
								total_discount: data.total_discount,
								discount: data.discount,
								pre_booking_amount: data.pre_booking_amount,
								bank_fee: data.bank_fee,
								total_thx_fee: data.total_thx_fee,
								save_price: data.save_price,
								remaining_amount: data.remaining_amount,
								payable_ad: data.payable_ad,
								payable_hatchery: data.payable_hatchery,
								aqua_cash: data.aqua_cash,
								ac_offer_title: data.ac_offer_title,
								aqua_cash_value: data.aqua_cash_value,
								aqua_cash_code: data.aqua_cash_code,
								ac_cal_info: data.ac_cal_info,
								pur_ern_ofr_code: data.pur_ern_ofr_code,
								pur_ern_ofr_title: data.pur_ern_ofr_title,
								pur_ern_ofr_desc: data.pur_ern_ofr_desc,
								pur_ern_retrn_amt: data.pur_ern_retrn_amt,
								full_aquacash_back_title: data.full_aquacash_back_title,
								full_aquacash_back_code: data.full_aquacash_back_code,
								full_aquacash_back_description: data.full_aquacash_back_description,
								full_aquacash_back_amount: data.full_aquacash_back_amount,
								deal_type: data.deal_type,
								promo_code: data.promo_code,
								promo_amt: data.promo_amt,
								promo_title: data.promo_title,
								promo_help: data.promo_help,
								free_shipment: data.free_shipment,
								free_shipment_msg: data.free_shipment_msg,
								coupon_code: data.coupon_code,
								coupon_amt: data.coupon_amt,
								cart_ids: data.cart_ids,
								coupons_amt: data.coupons_amt,
								promodiscount: data.promodiscount,
								applied_promos: data.applied_promos,
	
								user_details: data.user_details,
								cart_add_id: data.add_id,
								gateway_mode: data.gateway_mode,
								payment_options: data.payment_options
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'modeChange_cartCalculations',
			value: function modeChange_cartCalculations(mode) {
				this.setState({
					mode_loading: true,
					amount_loading: true
				});
				var uid = 0;
				var token = 0;
				var coupon_code = 0;
				var coupon_amount = 0;
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
	
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.token) {
					token = localStorage.getItem('token');
				} else {
					token = 0;
				}
				if (localStorage.apply_coupon_code) {
					coupon_code = localStorage.getItem('apply_coupon_code');
				} else {
					coupon_code = 0;
				}
				if (localStorage.apply_coupon) {
					coupon_amount = localStorage.getItem('apply_coupon');
				} else {
					coupon_amount = 0;
				}
	
				var data1 = { from: 'mobile_web', uid: uid, token: token, mode: mode, add_id: this.state.cart_add_id, code: coupon_code, coupon_amount: coupon_amount, other_amount: '', aqua_cash: this.state.used_cash1, coupons_amt: this.state.coupons_amt, ac_discount: this.state.ac_discount, promodiscount: this.state.promodiscount, applied_promos: this.state.applied_promos, quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'cartCalculations',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								mode_loading: false,
								amount_loading: false,
								mode: data.mode,
								ptype: data.mode,
								final_amt: data.final_amt,
								pay_at_outlet: data.pay_at_outlet,
								pay_advance: data.pay_advance,
								complete_amount: data.complete_amount,
								min_val: data.min_val,
								max_val: data.max_val,
	
								paymentMethodStatus: data.paymentMethodStatus,
								offline_payment: data.offline_payment,
								prebook_payment: data.prebook_payment,
								fullamount_payment: data.fullamount_payment,
								otheramount_payment: data.otheramount_payment,
								total_online_payment: data.total_online_payment,
								product_id: data.product_id,
								quantity: data.quantity,
								act_price: data.act_price,
								deal_price: data.deal_price,
								total: data.total,
								total_discount: data.total_discount,
								discount: data.discount,
								pre_booking_amount: data.pre_booking_amount,
								bank_fee: data.bank_fee,
								total_thx_fee: data.total_thx_fee,
								save_price: data.save_price,
								remaining_amount: data.remaining_amount,
								payable_ad: data.payable_ad,
								payable_hatchery: data.payable_hatchery,
								aqua_cash: data.aqua_cash,
								ac_offer_title: data.ac_offer_title,
								aqua_cash_value: data.aqua_cash_value,
								aqua_cash_code: data.aqua_cash_code,
								ac_cal_info: data.ac_cal_info,
								pur_ern_ofr_code: data.pur_ern_ofr_code,
								pur_ern_ofr_title: data.pur_ern_ofr_title,
								pur_ern_ofr_desc: data.pur_ern_ofr_desc,
								pur_ern_retrn_amt: data.pur_ern_retrn_amt,
								full_aquacash_back_title: data.full_aquacash_back_title,
								full_aquacash_back_code: data.full_aquacash_back_code,
								full_aquacash_back_description: data.full_aquacash_back_description,
								full_aquacash_back_amount: data.full_aquacash_back_amount,
								deal_type: data.deal_type,
								promo_code: data.promo_code,
								promo_amt: data.promo_amt,
								promo_title: data.promo_title,
								promo_help: data.promo_help,
								free_shipment: data.free_shipment,
								free_shipment_msg: data.free_shipment_msg,
								coupon_code: data.coupon_code,
								coupon_amt: data.coupon_amt,
								cart_ids: data.cart_ids,
								coupons_amt: data.coupons_amt,
								promodiscount: data.promodiscount,
								applied_promos: data.applied_promos,
	
								user_details: data.user_details,
								cart_add_id: data.add_id,
								gateway_mode: data.gateway_mode,
								payment_options: data.payment_options
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			// close function is used to close both edit address modal & add address modal boxes.
	
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					add_address: false,
					edit_address: false
				});
			}
			// handleSubmit_add function for submitting the new address when click on add new address 
	
		}, {
			key: 'handleSubmit_add',
			value: function handleSubmit_add(event) {
				event.preventDefault();
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
	
				var name = this.refs.add_name.value;
				var mobile = this.refs.add_mobile.value;
				var state = this.refs.add_state.value;
				var city = this.refs.add_city.value;
				var doorno = this.refs.add_doorno.value;
				var pincode = this.refs.add_pincode.value;
	
				var flag = 0;
				var namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
				if (name && !namePattern.test(name)) {
					(0, _jquery2.default)('#add_name_err').text('*name is minimum 3 characters');
					flag = 1;
				}
				if (mobile.length < 10) {
					(0, _jquery2.default)('#add_mobile_err').text('*enter valid number');
					flag = 1;
				}
				if (state && !namePattern.test(state) && state.length < 2) {
					(0, _jquery2.default)('#add_state_err').text('*enter state');
					flag = 1;
				}
				if (city && !namePattern.test(city)) {
					(0, _jquery2.default)('#add_city_err').text('*enter city');
					flag = 1;
				}
				if (doorno && doorno.length <= 1) {
					(0, _jquery2.default)('#add_doorno_err').text('*enter address');
					flag = 1;
				}
				if (pincode && pincode.length < 6) {
					(0, _jquery2.default)('#add_pincode_err').text('*enter valid pincode');
					flag = 1;
				}
				if (flag === 0) {
					var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, name: name, mobile: mobile, state: state, city: city, address: doorno, zip: pincode, quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'saveAdd',
						success: function (data) {
							if (data.status === "success") {
								this.close();
								this.getUserAddress();
								this.setState({
									add_state: '',
									add_city: '',
									add_doorno: '',
									add_pincode: ''
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
			//handleSubmit_edit function for updating the address when click on edit icon in the swipe list.
	
		}, {
			key: 'handleSubmit_edit',
			value: function handleSubmit_edit(event) {
				event.preventDefault();
				var add_id = this.state.edit_add_id;
	
				var name = this.refs.edit_name.value;
				var mobile = this.refs.edit_mobile.value;
				var state = this.refs.edit_state.value;
				var city = this.refs.edit_city.value;
				var doorno = this.refs.edit_doorno.value;
				var pincode = this.refs.edit_pincode.value;
	
				var flag = 0;
				// const emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
				var namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
				if (name && !namePattern.test(name)) {
					(0, _jquery2.default)('#edit_name_err').text('*name is minimum 3 characters');
					flag = 1;
				}
				if (mobile.length < 10) {
					(0, _jquery2.default)('#edit_mobile_err').text('*enter valid number');
					flag = 1;
				}
				if (state && !namePattern.test(state) && state.length < 2) {
					(0, _jquery2.default)('#edit_state_err').text('*enter state');
					flag = 1;
				}
				if (city && !namePattern.test(city)) {
					(0, _jquery2.default)('#edit_city_err').text('*enter city');
					flag = 1;
				}
				if (doorno && doorno.length <= 1) {
					(0, _jquery2.default)('#edit_doorno_err').text('*enter address');
					flag = 1;
				}
				if (pincode && pincode.length < 6) {
					(0, _jquery2.default)('#edit_pincode_err').text('*enter valid pincode');
					flag = 1;
				}
	
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (flag === 0) {
					var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, add_id: add_id, name: name, mobile: mobile, state: state, city: city, address: doorno, zip: pincode, quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'updateAdd',
						success: function (data) {
							if (data.status === "success") {
								this.close();
								this.getUserAddress();
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
			//editAddress function for when click on edit icon that enables the status of the Edit form modal
	
		}, {
			key: 'editAddress',
			value: function editAddress(add_id) {
				this.setState({
					edit_add_id: add_id,
					edit_address: true
				});
			}
			// deleteAddress function is used when click on deleted icon in swipe address list
	
		}, {
			key: 'deleteAddress',
			value: function deleteAddress(add_id) {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
	
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, add_id: add_id, quick_buy: 1, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'deleteAdd',
					success: function (data) {
						if (data.status === "success") {
							this.getUserAddress();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			// getAddressDetails function is used to get the address details from server when click the edit icon and edit modal form is opened. 
	
		}, {
			key: 'getAddressDetails',
			value: function getAddressDetails() {
				var add_id = this.state.edit_add_id;
				var data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, id: add_id, quick_buy: 1 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'get_add_details',
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								edit_data: data.data,
								edit_name: data.data[0]['name'],
								edit_mobile: data.data[0]['phone'],
								edit_state: data.data[0]['state'],
								edit_city: data.data[0]['city'],
								edit_doorno: data.data[0]['address'],
								edit_pincode: data.data[0]['zip']
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			//******************
			/* functions for EDIT form validations and upations start here  */
	
			// edit_nameChange function is used to set the edit_name value edit modal form.
	
		}, {
			key: 'edit_nameChange',
			value: function edit_nameChange(event) {
				this.setState({
					edit_name: event.target.value
				});
			}
		}, {
			key: 'edit_mobileChange',
			value: function edit_mobileChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						edit_mobile: x
					});
				}
			}
		}, {
			key: 'edit_stateChange',
			value: function edit_stateChange(event) {
				this.setState({
					edit_state: event.target.value
				});
			}
		}, {
			key: 'edit_cityChange',
			value: function edit_cityChange(event) {
				this.setState({
					edit_city: event.target.value
				});
			}
		}, {
			key: 'edit_doornoChange',
			value: function edit_doornoChange(event) {
				this.setState({
					edit_doorno: event.target.value
				});
			}
		}, {
			key: 'edit_pincodeChange',
			value: function edit_pincodeChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						edit_pincode: x
					});
				}
				// this.setState({
				// 	edit_pincode:event.target.value,
				// });
			}
			// **********************************
			// functions for "EDIT" form validations and upations "ENDS" here
	
			// functions for "ADD" form validations and updations START here 
			// ***************************************
	
		}, {
			key: 'add_nameChange',
			value: function add_nameChange(event) {
				this.setState({
					add_name: event.target.value
				});
			}
		}, {
			key: 'add_mobileChange',
			value: function add_mobileChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						add_mobile: x
					});
				}
			}
		}, {
			key: 'add_stateChange',
			value: function add_stateChange(event) {
				this.setState({
					add_state: event.target.value
				});
			}
		}, {
			key: 'add_cityChange',
			value: function add_cityChange(event) {
				this.setState({
					add_city: event.target.value
				});
			}
		}, {
			key: 'add_doornoChange',
			value: function add_doornoChange(event) {
				this.setState({
					add_doorno: event.target.value
				});
			}
		}, {
			key: 'add_pincodeChange',
			value: function add_pincodeChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						add_pincode: x
					});
				}
			}
			// ***********************************
	
			// setDefaultAddress function is used to set the default address when click on circle image in address block 
	
	
			//setPaymentMode is used to set the mode of the payment like 2 for - advance,3 for total,4 for other and calling the modeChange_cartCalculations
			//hiding the other amount input field and calling
	
		}, {
			key: 'setPaymentMode',
			value: function setPaymentMode(id) {
				this.setState({
					ptype: id,
					mode: id
				});
				if (id === 4) {
					this.setState({
						other_amount_field_status: true
					});
				} else {
					this.setState({
						other_amount_field_status: false
					});
					this.modeChange_cartCalculations(id);
				}
			}
		}, {
			key: 'validateOtherAmount',
			value: function validateOtherAmount() {
	
				this.setState({
					err_qty_status: false,
					err_qty_msg: ''
				});
				var x = '';
				if (parseInt(this.refs.ref_other_amt.value, 10) < parseInt(this.state.min_val, 10)) {
					x = 'Minimum Quantity is ' + this.state.min_val;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Minimum amount is ' + this.state.min_val
					});
				}
				if (parseInt(this.refs.ref_other_amt.value, 10) > parseInt(this.state.max_val, 10)) {
					// alert('Maximum Quantity is '+this.state.max_qty);
					x = 'Maximum Quantity is ' + this.state.max_val;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Maximum amount is ' + this.state.max_val
					});
				}
				var check = /[^0-9]/gi;
				if (check.test(this.refs.ref_other_amt.value)) {
					x = '* Invalid Amount';
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Invalid Amount'
					});
				}
	
				// this.other_amount_cartCalculations(4,this.refs.ref_other_amt.value);
	
				if (x === '') {
					this.other_amount_cartCalculations(4, this.refs.ref_other_amt.value);
				}
			}
		}, {
			key: 'handleTabsSelect',
			value: function handleTabsSelect(key) {
				this.setState({
					evnt_key: key
				});
				this.modeChange_cartCalculations(key);
			}
	
			// functions for "ADD" form validations and updations END here 
	
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				document.title = "Quick Buy Checkout | AquaDeals";
				var tabs_data = '';
				var i = 0;
	
				(0, _jquery2.default)('.mob_check').unbind("click").click(function () {
					(0, _jquery2.default)(".mob_check img").attr("src", "https://aquadeals.in/admin/assets/images/icons/circle_gray.png");
					var sel_addr_id = (0, _jquery2.default)(this).attr("id");
					var add_id = sel_addr_id.replace('swipe-addr-id_', '');
					(0, _jquery2.default)("#" + sel_addr_id + " .mob_check img").attr("src", "https://aquadeals.in/admin/assets/images/icons/ok.png");
					//$(".swipe_addr_blk .mob_check img").attr('src',"https://aquadeals.in/admin/assets/images/icons/circle_gray.png");
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, add_id: add_id, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'setdefault_address',
						success: function (data) {
							if (data.status === "success") {
								//this.getUserAddress();
							}
						}.bind(this),
						error: function error(err) {
							console.log(err);
						}
					});
				});
				// $('#off_modal_status').parent().addClass('offline_modal');
				if (this.state.payment_options == 0) {
					tabs_data = '';
				} else if (this.state.paymentMethodStatus === 'Both') {
					tabs_data = _react2.default.createElement(
						'section',
						{ className: 'payment_layout' },
						_react2.default.createElement(
							'section',
							{ className: 'chk_pay_opts_blk' },
							_react2.default.createElement(
								'h5',
								null,
								'PAYMENT OPTIONS'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Tabs,
							{ activeKey: this.state.evnt_key, className: 'pay_both', id: 'controlled-tab-example', onSelect: this.handleTabsSelect },
							_react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 2, title: 'ONLINE' },
								_react2.default.createElement(
									'div',
									null,
									this.state.prebook_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 2 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_adv', checked: this.state.ptype === 2 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(2);
												}, required: true }),
											'Pay Advance \u20B9 ',
											this.state.pay_advance
										)
									) : '',
									this.state.otheramount_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 4 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_other', checked: this.state.ptype === 4 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(4);
												}, required: true }),
											'Pay Other Advance ',
											this.state.other_amount_field_status ? _react2.default.createElement(
												'span',
												{ style: { marginLeft: '10px', position: 'absolute' } },
												_react2.default.createElement('input', { onChange: function onChange() {
														return _this3.validateOtherAmount();
													}, ref: 'ref_other_amt', id: 'ref_other_amt', type: 'text', placeholder: 'Enter Amount' }),
												this.state.err_qty_status ? _react2.default.createElement(
													'span',
													{ className: 'error_other_amt' },
													this.state.err_qty_msg
												) : ''
											) : ''
										)
									) : '',
									this.state.fullamount_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 3 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_total', checked: this.state.ptype === 3 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(3);
												}, required: true }),
											'Pay Total \u20B9 ',
											this.state.final_amt
										)
									) : '',
									this.state.free_shipment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'mob_ship_van' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
										),
										' ',
										this.state.free_shipment_msg
									) : ''
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 1, title: 'OFFLINE' },
								_react2.default.createElement(
									'div',
									null,
									this.state.offline_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 1 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_outlet', checked: this.state.ptype === 1 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(1);
												}, required: true }),
											'Pay at Outlet \u20B9 ',
											this.state.final_amt
										),
										this.state.free_shipment === 1 ? _react2.default.createElement(
											'div',
											{ className: 'mob_ship_van' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
											),
											' ',
											this.state.free_shipment_msg
										) : ''
									) : ''
								)
							)
						)
					);
				} else if (this.state.paymentMethodStatus === 'Online') {
					tabs_data = _react2.default.createElement(
						'section',
						{ className: 'payment_layout' },
						_react2.default.createElement(
							'section',
							{ className: 'chk_pay_opts_blk' },
							_react2.default.createElement(
								'h5',
								null,
								'PAYMENT OPTIONS'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Tabs,
							{ activeKey: this.state.evnt_key, className: 'pay_online tab_single_active', id: 'controlled-tab-example', onSelect: this.handleTabsSelect },
							_react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 2, title: 'ONLINE', style: { borderRight: 'none' } },
								_react2.default.createElement(
									'div',
									null,
									this.state.prebook_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 2 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_adv', checked: this.state.ptype === 2 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(2);
												}, required: true }),
											'Pay Advance \u20B9 ',
											this.state.pay_advance
										)
									) : '',
									this.state.otheramount_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 4 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_other', checked: this.state.ptype === 4 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(4);
												}, required: true }),
											'Pay Other Advance ',
											this.state.other_amount_field_status ? _react2.default.createElement(
												'span',
												{ style: { marginLeft: '10px', position: 'absolute' } },
												_react2.default.createElement('input', { onChange: function onChange() {
														return _this3.validateOtherAmount();
													}, ref: 'ref_other_amt', id: 'ref_other_amt', type: 'text', placeholder: 'Enter Amount' }),
												this.state.err_qty_status ? _react2.default.createElement(
													'span',
													{ className: 'error_other_amt' },
													this.state.err_qty_msg
												) : ''
											) : ''
										)
									) : '',
									this.state.fullamount_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 3 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_total', checked: this.state.ptype === 3 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(3);
												}, required: true }),
											'Pay Total \u20B9 ',
											this.state.final_amt
										)
									) : '',
									this.state.free_shipment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'mob_ship_van' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
										),
										' ',
										this.state.free_shipment_msg
									) : ''
								)
							),
							this.state.offline_payment === 1 ? _react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 1, title: 'OFFLINE' },
								_react2.default.createElement(
									'div',
									null,
									this.state.offline_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 1 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_outlet', checked: this.state.ptype === 1 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(1);
												}, required: true }),
											'Pay at Outlet \u20B9 ',
											this.state.final_amt
										),
										this.state.free_shipment === 1 ? _react2.default.createElement(
											'div',
											{ className: 'mob_ship_van' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
											),
											' ',
											this.state.free_shipment_msg
										) : ''
									) : ''
								)
							) : ''
						)
					);
				} else if (this.state.paymentMethodStatus === 'Offline') {
					tabs_data = _react2.default.createElement(
						'section',
						{ className: 'payment_layout' },
						_react2.default.createElement(
							'section',
							{ className: 'chk_pay_opts_blk' },
							_react2.default.createElement(
								'h5',
								null,
								'PAYMENT OPTIONS'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Tabs,
							{ activeKey: 1, className: 'pay_offline tab_single_active', id: 'controlled-tab-example' },
							this.state.offline_payment === 1 ? _react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 1, title: 'OFFLINE' },
								_react2.default.createElement(
									'div',
									null,
									this.state.offline_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 1 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_outlet', checked: this.state.ptype === 1 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(1);
												}, required: true }),
											'Pay at Outlet \u20B9 ',
											this.state.final_amt
										),
										this.state.free_shipment === 1 ? _react2.default.createElement(
											'div',
											{ className: 'mob_ship_van' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
											),
											' ',
											this.state.free_shipment_msg
										) : ''
									) : ''
								)
							) : ''
						)
					);
				} else if (this.state.paymentMethodStatus === 'None') {
					tabs_data = _react2.default.createElement(
						'section',
						{ className: 'payment_layout' },
						_react2.default.createElement(
							'section',
							{ className: 'chk_pay_opts_blk' },
							_react2.default.createElement(
								'h5',
								null,
								'PAYMENT OPTIONS'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Tabs,
							{ activeKey: this.state.evnt_key, id: 'controlled-tab-example', onSelect: this.handleTabsSelect, className: 'pay_partner' },
							_react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 2, title: 'ONLINE' },
								_react2.default.createElement(
									'div',
									null,
									this.state.prebook_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 2 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_adv', checked: this.state.ptype === 2 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(2);
												}, required: true }),
											'Pay Advance \u20B9 ',
											this.state.pay_advance
										)
									) : '',
									this.state.otheramount_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 4 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_other', checked: this.state.ptype === 4 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(4);
												}, required: true }),
											'Pay Other Advance ',
											this.state.other_amount_field_status ? _react2.default.createElement(
												'span',
												{ style: { marginLeft: '10px', position: 'absolute' } },
												_react2.default.createElement('input', { onChange: function onChange() {
														return _this3.validateOtherAmount();
													}, ref: 'ref_other_amt', id: 'ref_other_amt', type: 'text', placeholder: 'Enter Amount' }),
												this.state.err_qty_status ? _react2.default.createElement(
													'span',
													{ className: 'error_other_amt' },
													this.state.err_qty_msg
												) : ''
											) : ''
										)
									) : '',
									this.state.fullamount_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 3 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_total', checked: this.state.ptype === 3 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(3);
												}, required: true }),
											'Pay Total \u20B9 ',
											this.state.final_amt
										)
									) : '',
									this.state.free_shipment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'mob_ship_van' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', width: '25px', alt: ' ' })
										),
										' ',
										this.state.free_shipment_msg
									) : ''
								)
							),
							this.state.offline_payment === 1 ? _react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 1, title: 'OFFLINE' },
								_react2.default.createElement(
									'div',
									null,
									this.state.offline_payment === 1 ? _react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement(
											'label',
											{ className: this.state.ptype === 1 ? 'pay_active' : 'pay_inactive' },
											_react2.default.createElement('input', { type: 'radio', name: 'pay_value', ref: 'pay_outlet', checked: this.state.ptype === 1 ? true : false, onChange: function onChange() {
													_this3.setPaymentMode(1);
												}, required: true }),
											'Pay at Outlet \u20B9 ',
											this.state.final_amt
										),
										this.state.free_shipment === 1 ? _react2.default.createElement(
											'div',
											{ className: 'mob_ship_van' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', alt: '', width: '25px' })
											),
											' ',
											this.state.free_shipment_msg
										) : '',
										this.state.full_aquacash_back_title ? _react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/newcashback.png', alt: '', width: '20px', className: 'rp_coin' }),
												' '
											),
											' ',
											this.state.full_aquacash_back_title
										) : ''
									) : ''
								)
							) : ''
						)
					);
				}
	
				// edit form empty errors when click on the text input fields starts here
				(0, _jquery2.default)('#edit_name').keyup(function () {
					(0, _jquery2.default)('#edit_name_err').text('');
				});
				(0, _jquery2.default)('#edit_mobile').keyup(function () {
					(0, _jquery2.default)('#edit_mobile_err').text('');
				});
				(0, _jquery2.default)('#edit_state').keyup(function () {
					(0, _jquery2.default)('#edit_state_err').text('');
				});
				(0, _jquery2.default)('#edit_city').keyup(function () {
					(0, _jquery2.default)('#edit_city_err').text('');
				});
				(0, _jquery2.default)('#edit_doorno').keyup(function () {
					(0, _jquery2.default)('#edit_doorno_err').text('');
				});
				(0, _jquery2.default)('#edit_pincode').keyup(function () {
					(0, _jquery2.default)('#edit_pincode_err').text('');
				});
				// edit form validations ends here
	
				// add form removing error msg's when click on input fields start here
				(0, _jquery2.default)('#add_name').keyup(function () {
					(0, _jquery2.default)('#add_name_err').text('');
				});
				(0, _jquery2.default)('#add_mobile').keyup(function () {
					(0, _jquery2.default)('#add_mobile_err').text('');
				});
				(0, _jquery2.default)('#add_state').keyup(function () {
					(0, _jquery2.default)('#add_state_err').text('');
				});
				(0, _jquery2.default)('#add_city').keyup(function () {
					(0, _jquery2.default)('#add_city_err').text('');
				});
				(0, _jquery2.default)('#add_doorno').keyup(function () {
					(0, _jquery2.default)('#add_doorno_err').text('');
				});
				(0, _jquery2.default)('#add_pincode').keyup(function () {
					(0, _jquery2.default)('#add_pincode_err').text('');
				});
				var params = {
					paginationClickable: true,
					spaceBetween: 0,
					slidesPerView: 1.4
				};
	
				var delivery_address = this.state.user_address.map(function (data, index) {
					var _this4 = this;
	
					return localStorage.address_change_flag === '0' ? _react2.default.createElement(
						_reactBootstrap.Col,
						{ md: 8, xs: 8, className: 'swipe_addr_blk', id: "swipe-addr-id_" + data.add_id },
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 3, sm: 3, xs: 2, className: 'mob_check', id: "swipe-addr-id_" + data.add_id },
							_react2.default.createElement('img', { src: data.default === '1' ? baseAssets + 'images/icons/ok.png' : baseAssets + 'images/icons/circle_gray.png', alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ style: { margin: '0 20px' } },
							_react2.default.createElement(
								_reactBootstrap.Col,
								{ md: 8, sm: 8, xs: 8, className: 's_data_blk' },
								_react2.default.createElement(
									'p',
									null,
									data.name
								),
								_react2.default.createElement(
									'p',
									null,
									data.mobile
								),
								_react2.default.createElement(
									'p',
									null,
									data.state
								),
								_react2.default.createElement(
									'p',
									null,
									data.city
								),
								_react2.default.createElement(
									'p',
									null,
									data.address
								),
								_react2.default.createElement(
									'p',
									null,
									data.zip
								)
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 12, sm: 12, xs: 12, style: { paddingLeft: '0px', paddingRight: '0px' } },
							_react2.default.createElement(
								'ul',
								{ className: 'addr_btns' },
								'// ',
								_react2.default.createElement(
									'li',
									{ onClick: function onClick() {
											_this4.editAddress(data.add_id);
										} },
									'EDIT'
								),
								'// ',
								_react2.default.createElement(
									'li',
									{ onClick: function onClick() {
											return _this4.deleteAddress(data.add_id);
										} },
									'DELETE'
								),
								_react2.default.createElement(
									'div',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									null,
									'\xA0'
								)
							)
						)
					) : _react2.default.createElement(
						_reactBootstrap.Col,
						{ md: 8, xs: 8, className: this.state.user_address.length == 1 ? "swipe_addr_blk swipe_addr_single" : 'swipe_addr_blk', id: "swipe-addr-id_" + data.add_id },
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 3, sm: 3, xs: 2, className: 'mob_check', id: "swipe-addr-id_" + data.add_id },
							_react2.default.createElement('img', { src: data.default === '1' ? baseAssets + 'images/icons/ok.png' : baseAssets + 'images/icons/circle_gray.png', alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ style: { margin: '0 20px' } },
							_react2.default.createElement(
								_reactBootstrap.Col,
								{ md: 8, sm: 8, xs: 8, className: 's_data_blk' },
								_react2.default.createElement(
									'p',
									null,
									data.name,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.mobile,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.state,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.city,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.address,
									'\xA0'
								),
								_react2.default.createElement(
									'p',
									null,
									data.zip,
									'\xA0'
								)
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ md: 12, sm: 12, xs: 12, style: { paddingLeft: '0px', paddingRight: '0px' } },
							_react2.default.createElement(
								'ul',
								{ className: 'addr_btns' },
								_react2.default.createElement(
									'li',
									{ onClick: function onClick() {
											_this4.editAddress(data.add_id);
										} },
									'EDIT'
								),
								_react2.default.createElement(
									'li',
									{ onClick: function onClick() {
											return _this4.deleteAddress(data.add_id);
										} },
									'DELETE'
								)
							)
						)
					);
				}.bind(this));
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals checkout_page' },
					this.state.page_loading ? _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ id: 'header_main' },
							_react2.default.createElement(
								'div',
								{ className: 'page_hdr' },
								_react2.default.createElement(
									'div',
									{ className: 'container-fluid' },
									_react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/mycart' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
											)
										),
										'Checkout'
									),
									_react2.default.createElement(
										'a',
										{ href: '/', title: 'Home', className: 'home_logo1' },
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'section',
							{ id: 'cart-process' },
							_react2.default.createElement(
								'div',
								{ className: 'progressbar-wrapper' },
								_react2.default.createElement(
									'ul',
									{ className: 'progressbar' },
									_react2.default.createElement(
										'li',
										{ className: 'active' },
										_react2.default.createElement(
											'div',
											null,
											'Cart'
										),
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(_reactWebVectorIcons2.default, {
												name: 'check',
												font: 'Entypo',
												color: '#fff',
												size: 14
												// style={{}}
											})
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'div',
											null,
											'Checkout'
										),
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(_reactWebVectorIcons2.default, {
												name: 'check',
												font: 'Entypo',
												color: '#fff',
												size: 14
												// style={{}}
											})
										)
									),
									_react2.default.createElement(
										'li',
										null,
										'Payment'
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ style: { marginTop: '-5px' } },
							'\xA0'
						),
						parseInt(this.state.cart_count, 10) > 0 ? _react2.default.createElement(
							'div',
							{ className: 'body_content  m_checout' },
							this.state.paying_process ? _react2.default.createElement(
								'div',
								{ className: 'checkout_loading' },
								_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
							) : _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'section',
									{ className: 'chk_dlry_title_blk', style: { width: '90%', margin: '0 auto', padding: '5px 2px;' } },
									_react2.default.createElement(
										'div',
										{ id: 'pay_response' },
										this.state.response
									),
									_react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											'span',
											null,
											'DELIVERY ADDRESS'
										),
										_react2.default.createElement(
											'span',
											{ style: { float: 'right', color: '#ff742a' }, onClick: function onClick() {
													_this3.setState({ add_address: true });
												} },
											'ADD NEW'
										)
									)
								),
								_react2.default.createElement(
									'section',
									{ className: 'chk_dlry_data_blk' },
									this.state.click_here_status ? _react2.default.createElement(
										'div',
										{ className: 'empty_add_blk' },
										_react2.default.createElement(
											'a',
											{ onClick: function onClick() {
													_this3.setState({ add_address: true });
												} },
											'Click here to  add shipping address'
										)
									) : _react2.default.createElement(
										_reactIdSwiper2.default,
										_extends({}, params, { key: delivery_address.length }),
										delivery_address
									)
								),
								this.state.mode_loading ? _react2.default.createElement(
									'div',
									{ className: 'mode_loading' },
									_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
								) : tabs_data,
								_react2.default.createElement(
									'section',
									{ className: 'botm_btns row', style: { paddingBottom: '5px' } },
									_react2.default.createElement(
										'ul',
										{ className: 'mycart_ul' },
										_react2.default.createElement(
											'li',
											{ className: 'col-md-6 col-xs-6 col-sm-6', style: { cursor: 'pointer' } },
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: '/customer_care' },
												_react2.default.createElement(
													'i',
													null,
													_react2.default.createElement('img', { src: baseAssets + 'images/icons/enquiry_now.png', alt: ' ' })
												),
												'CONTACT US'
											)
										),
										_react2.default.createElement(
											'li',
											{ className: 'col-md-6 col-xs-6 col-sm-6', style: { cursor: 'pointer' } },
											this.state.amount_loading ? _react2.default.createElement(
												_reactRouter.Link,
												{ className: 'disabled' },
												'Loading'
											) : _react2.default.createElement(
												_reactRouter.Link,
												{ onClick: function onClick() {
														_this3.payNow();
													} },
												'PAY NOW',
												_react2.default.createElement(
													'span',
													null,
													_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/continue.png', width: '14px', alt: '' })
												)
											)
										)
									)
								),
								_react2.default.createElement(
									'section',
									{ style: { 'fontSize': '10px', 'paddingLeft': '20px' } },
									parseHtml(this.state.deliver_date_text)
								),
								_react2.default.createElement(
									'div',
									{ className: 'm_check_out_truck' },
									_react2.default.createElement(
										'div',
										{ style: { margin: '0 auto' } },
										_react2.default.createElement('img', { src: __webpack_require__(252), alt: '...' }),
										_react2.default.createElement(
											'h5',
											null,
											'You Pay : \u20B9 ',
											this.state.grand_total
										),
										_react2.default.createElement(
											'h6',
											null,
											this.state.cart_count > 1 ? 'Items : ' + this.state.cart_count : 'Item : ' + this.state.cart_count
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								),
								_react2.default.createElement(
									'div',
									{ className: 'clr' },
									'\xA0'
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ className: 'm_pro_full_dtls_modal', show: this.state.add_address, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Header,
										{ closeButton: true },
										_react2.default.createElement(
											_reactBootstrap.Modal.Title,
											{ className: 'm_title' },
											'Add Shipping Address'
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(
												'form',
												{ className: 'add_address_form', onSubmit: this.handleSubmit_add },
												_react2.default.createElement(
													'div',
													{ className: 'add_form_blk' },
													_react2.default.createElement('input', { type: 'text', placeholder: 'Name', ref: 'add_name', id: 'add_name', value: this.state.add_name, onChange: this.add_nameChange, required: true }),
													_react2.default.createElement('p', { id: 'add_name_err' }),
													_react2.default.createElement('input', { type: 'text', maxLength: 10, placeholder: 'Mobile', ref: 'add_mobile', id: 'add_mobile', value: this.state.add_mobile, onChange: this.add_mobileChange, required: true }),
													_react2.default.createElement('p', { id: 'add_mobile_err' }),
													_react2.default.createElement('input', { type: 'text', placeholder: 'Enter State', ref: 'add_state', id: 'add_state', value: this.state.add_state, onChange: this.add_stateChange, required: true }),
													_react2.default.createElement('p', { id: 'add_state_err' }),
													_react2.default.createElement('input', { type: 'text', placeholder: 'Enter City/Town', ref: 'add_city', id: 'add_city', value: this.state.add_city, onChange: this.add_cityChange, required: true }),
													_react2.default.createElement('p', { id: 'add_city_err' }),
													_react2.default.createElement('input', { type: 'text', placeholder: 'Door No/Landmark', ref: 'add_doorno', id: 'add_doorno', value: this.state.add_doorno, onChange: this.add_doornoChange, required: true }),
													_react2.default.createElement('p', { id: 'add_doorno_err' }),
													_react2.default.createElement('input', { type: 'text', maxLength: 6, placeholder: 'Pincode', ref: 'add_pincode', id: 'add_pincode', value: this.state.add_pincode, onChange: this.add_pincodeChange, required: true }),
													_react2.default.createElement('p', { id: 'add_pincode_err' }),
													_react2.default.createElement(
														'div',
														{ className: 'm_submit_blk' },
														_react2.default.createElement(
															'button',
															{ type: 'submit', className: 'save_add_btn', value: 'ADD' },
															'ADD'
														)
													)
												)
											)
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ onEntered: function onEntered() {
											_this3.getAddressDetails();
										}, className: '', show: this.state.edit_address, onHide: this.close },
									_react2.default.createElement(
										_reactBootstrap.Modal.Header,
										{ closeButton: true },
										_react2.default.createElement(
											_reactBootstrap.Modal.Title,
											{ className: 'm_title' },
											'Edit Shipping Address'
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(
												'form',
												{ className: 'edit_address_form', onSubmit: this.handleSubmit_edit },
												_react2.default.createElement(
													'div',
													{ className: 'edit_form_blk' },
													_react2.default.createElement('input', { type: 'text', id: 'edit_name', placeholder: 'Name', value: this.state.edit_name, onChange: this.edit_nameChange, ref: 'edit_name', required: true }),
													_react2.default.createElement('p', { id: 'edit_name_err' }),
													_react2.default.createElement('input', { type: 'text', placeholder: 'Mobile', maxLength: 10, value: this.state.edit_mobile, onChange: this.edit_mobileChange, ref: 'edit_mobile', id: 'edit_mobile', required: true }),
													_react2.default.createElement('p', { id: 'edit_mobile_err' }),
													_react2.default.createElement('input', { type: 'text', placeholder: 'Enter State', value: this.state.edit_state, onChange: this.edit_stateChange, ref: 'edit_state', id: 'edit_state', required: true }),
													_react2.default.createElement('p', { id: 'edit_state_err' }),
													_react2.default.createElement('input', { type: 'text', placeholder: 'Enter City/Town', value: this.state.edit_city, onChange: this.edit_cityChange, ref: 'edit_city', id: 'edit_city', required: true }),
													_react2.default.createElement('p', { id: 'edit_city_err' }),
													_react2.default.createElement('input', { type: 'text', placeholder: 'Door No/Landmark', value: this.state.edit_doorno, onChange: this.edit_doornoChange, ref: 'edit_doorno', id: 'edit_doorno', required: true }),
													_react2.default.createElement('p', { id: 'edit_doorno_err' }),
													_react2.default.createElement('input', { type: 'text', placeholder: 'Pincode', maxLength: 6, value: this.state.edit_pincode, onChange: this.edit_pincodeChange, ref: 'edit_pincode', id: 'edit_pincode', required: true }),
													_react2.default.createElement('p', { id: 'edit_pincode_err' }),
													_react2.default.createElement(
														'div',
														{ className: 'm_submit_blk' },
														_react2.default.createElement(
															'button',
															{ type: 'submit', className: 'adrs_update_btn', value: 'UPDATE' },
															'UPDATE'
														)
													)
												)
											)
										)
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal,
									{ id: 'off_modal_status', className: 'off_modal_status', backdrop: 'static', show: this.state.offline_pay_success_status, onHide: this.testclose },
									_react2.default.createElement(
										_reactBootstrap.Modal.Header,
										null,
										_react2.default.createElement(
											'div',
											{ className: 'chekout_modal_header' },
											_react2.default.createElement(
												'h5',
												null,
												_react2.default.createElement(
													_reactRouter.Link,
													{ to: "/" },
													_react2.default.createElement(
														'i',
														null,
														_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
													)
												),
												_react2.default.createElement(
													'span',
													{ className: 'header_text textTransform' },
													'Confirmation'
												)
											),
											_react2.default.createElement(
												'a',
												{ href: '/', className: 'home_cartlogo' },
												_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
											)
										)
									),
									_react2.default.createElement(
										_reactBootstrap.Modal.Body,
										null,
										_react2.default.createElement(
											'div',
											{ style: { textAlign: 'center', paddingBottom: '10px', paddingTop: '15px' } },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cc_footer_icon.png', alt: 'AquaDeals', width: '100px' })
											),
											_react2.default.createElement(
												'h5',
												{ className: 'green textTransform', style: { paddingTop: '10px' } },
												this.state.offline_confirm_data.success_msg
											),
											_react2.default.createElement(
												'h6',
												{ style: { color: '#ff742a', paddingTop: '4px' } },
												this.state.offline_confirm_data.thank_msg
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'modal_ordr_dtls_blk' },
											_react2.default.createElement(
												'div',
												{ className: 'modal_ordr_dtls' },
												_react2.default.createElement(
													'h5',
													null,
													'Order Details'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: '', style: { padding: '10px' } },
												_react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														'Seller Name : '
													),
													_react2.default.createElement(
														'span',
														null,
														this.state.offline_confirm_data.address ? this.state.offline_confirm_data.address.seller_name : ''
													)
												),
												_react2.default.createElement(
													'h5',
													{ style: { fontSize: '11px', marginTop: '4px', marginBottom: '4px' } },
													_react2.default.createElement(
														'span',
														null,
														'Order N0'
													),
													_react2.default.createElement(
														'span',
														{ style: { float: 'right' } },
														'Order Date'
													)
												),
												_react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														this.state.offline_confirm_data.book_id
													),
													_react2.default.createElement(
														'span',
														{ style: { float: 'right' } },
														this.state.offline_confirm_data.booking_date ? this.state.offline_confirm_data.booking_date : ''
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'modal_pro_details_blk' },
											_react2.default.createElement(
												'div',
												{ className: 'modal_pro_title' },
												_react2.default.createElement(
													'h5',
													null,
													'Product Details '
												)
											),
											_react2.default.createElement(
												'div',
												{ style: { padding: '10px' } },
												_react2.default.createElement(
													'p',
													null,
													_react2.default.createElement(
														'span',
														null,
														'Item : ',
														this.state.offline_confirm_data.qty ? this.state.offline_confirm_data.qty : ''
													),
													_react2.default.createElement(
														'span',
														{ style: { float: 'right' } },
														'Total : ',
														this.state.offline_confirm_data.remaining_amount ? this.state.offline_confirm_data.remaining_amount : ''
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: '', style: { backgroundColor: '#fff', overflow: 'hidden', paddingBottom: '10px', marginTop: '10px' } },
											this.state.offline_confirm_data.order_items ? this.state.offline_confirm_data.order_items.map(function (data, index) {
												return _react2.default.createElement(
													'div',
													{ className: 'col-xs-12 col-md-12', style: { padding: '0px', paddingTop: '15px', paddingBottom: '15px', borderTop: '1px solid #eee' } },
													_react2.default.createElement(
														'div',
														{ className: 'col-xs-3 col-md-3' },
														_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/thumbnails/20170323130243537436.jpg', alt: ' ' })
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-xs-6 col-md-6', style: { padding: '0px' } },
														_react2.default.createElement(
															'p',
															null,
															data.pro_name,
															' ',
															data.unit
														),
														_react2.default.createElement(
															'p',
															null,
															'QTY : ',
															data.quantity
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'col-xs-3 col-md-3', style: { padding: '0px' } },
														_react2.default.createElement(
															'p',
															{ style: { marginTop: '17px' } },
															'\u20B9 ',
															data.deal_amt
														)
													)
												);
											}) : ''
										),
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(
												'div',
												{ style: { backgroundColor: '#f1f1f2', padding: '5px 0px 5px 10px' } },
												_react2.default.createElement(
													'h5',
													null,
													'Payment Details'
												)
											),
											_react2.default.createElement(
												'div',
												{ style: { backgroundColor: '#fff', padding: '10px' } },
												_react2.default.createElement(
													'h5',
													null,
													_react2.default.createElement(
														'span',
														null,
														this.state.offline_confirm_data.payment_details ? this.state.offline_confirm_data.payment_details[0].title : ''
													),
													_react2.default.createElement(
														'span',
														{ style: { float: 'right' } },
														'\u20B9 ',
														this.state.offline_confirm_data.payment_details ? this.state.offline_confirm_data.payment_details[0].value : ''
													)
												)
											)
										),
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(
												'div',
												{ className: '', style: { backgroundColor: '#f1f1f2', padding: '5px 0px 5px 10px' } },
												_react2.default.createElement(
													'h5',
													null,
													'Shipping Address'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: '', style: { backgroundColor: '#fff', padding: '10px' } },
												_react2.default.createElement(
													'p',
													null,
													this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].name : ''
												),
												_react2.default.createElement(
													'p',
													null,
													this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].address : '',
													' , ',
													this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].city : '',
													' '
												),
												_react2.default.createElement(
													'p',
													null,
													this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].state : ''
												),
												_react2.default.createElement(
													'p',
													null,
													this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].phone : ''
												),
												_react2.default.createElement(
													'p',
													null,
													this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].zip : ''
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ style: { textAlign: 'center', marginTop: '100px' }, className: 'modal_share_blk' },
											_react2.default.createElement(
												'div',
												null,
												_react2.default.createElement(
													_reactRouter.Link,
													{ style: { color: '#ff742a' }, to: '/share_earn' },
													_react2.default.createElement('img', { src: baseAssets + 'images/icons/nav_refer_earn.png', width: '40px', alt: '' }),
													'Share & Earn'
												)
											)
										)
									)
								)
							)
						) : _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'cart_emtpy' },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/empty_cartbg.png', alt: '...' })
								),
								_react2.default.createElement(
									'h4',
									null,
									'Your Quick Cart is Empty'
								),
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: "/", className: 'cart_shopbtn' },
									'SHOP NOW'
								)
							),
							_react2.default.createElement(
								'section',
								{ className: 'botm_btns row', style: { paddingBottom: '5px' } },
								_react2.default.createElement(
									'ul',
									null,
									_react2.default.createElement(
										'li',
										{ className: 'col-md-6 col-xs-6 col-sm-6', style: { cursor: 'pointer' } },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/customer_care' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'images/icons/enquiry_now.png', alt: ' ' })
											),
											'Enquire Now'
										)
									),
									_react2.default.createElement(
										'li',
										{ className: 'col-md-6 col-xs-6 col-sm-6', style: { cursor: 'pointer' } },
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: '/' },
											'Explore Deals'
										)
									)
								)
							)
						)
					) : _react2.default.createElement(
						'div',
						{ className: 'checkout_loading' },
						this.state.lod ? _react2.default.createElement(
							'div',
							{ className: 'checkout_error_blk' },
							_react2.default.createElement(
								'h4',
								null,
								'Something went wrong'
							),
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/', className: 'try_again_btn' },
								'Please try again!'
							)
						) : _react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
					)
				);
			}
		}]);
	
		return Quick_Checkout;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			save_order_status: state.posts.mycart_order_status,
			total_cart_data: state.posts.total_cart_data,
			rzp_keys: state.posts.rzp_keys
		};
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Quick_Checkout);

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Advertise = function (_Component) {
	  _inherits(Advertise, _Component);
	
	  function Advertise(props) {
	    _classCallCheck(this, Advertise);
	
	    var _this = _possibleConstructorReturn(this, (Advertise.__proto__ || Object.getPrototypeOf(Advertise)).call(this, props));
	
	    _this.state = {
	      contact_err: '',
	      name_err: '',
	      email_err: '',
	      phone_err: '',
	
	      utype: 1,
	      message: '',
	      response: false,
	
	      email: '',
	      mobile: '',
	      name: ''
	
	    };
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.nameChange = _this.nameChange.bind(_this);
	    _this.mobileChange = _this.mobileChange.bind(_this);
	    _this.close = _this.close.bind(_this);
	    return _this;
	  }
	
	  _createClass(Advertise, [{
	    key: 'close',
	    value: function close() {
	      this.setState({ response: false });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(event) {
	      // var contact = this.refs.contact.value;
	      var name = this.refs.name.value;
	      var email = this.refs.email.value;
	      var mobile = this.refs.phone.value;
	      var company = this.refs.company.value;
	      var invalidChars = /[^a-zA-Z ]/gi;
	      var invalidNumber = /[^0-9]/gi;
	      var emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
	      // var contact ="User";
	      var flag = 0;
	
	      if (name === '') {
	        this.setState({ name_err: '* please enter name' });
	        flag = 1;
	      } else if (invalidChars.test(name)) {
	        this.setState({ name_err: '* please enter valid name' });
	        flag = 1;
	      } else if (name.length < 3) {
	        this.setState({ name_err: '* minimum length should be 3 characters' });
	        flag = 1;
	      } else {
	        this.setState({ name_err: '' });
	      }
	      if (email === '') {
	        this.setState({ email_err: '* please enter Email' });
	        flag = 1;
	      } else if (!emailPattern.test(email)) {
	        this.setState({ email_err: '* please enter valid Email' });
	        flag = 1;
	      } else {
	        this.setState({ email_err: '' });
	        flag = 0;
	      }
	
	      if (mobile === '') {
	        this.setState({ phone_err: '* please enter mobile number' });
	        flag = 1;
	      } else if (invalidNumber.test(mobile)) {
	        this.setState({ phone_err: '* please enter valid mobile number' });
	        flag = 1;
	      } else if (mobile.length < 10) {
	        this.setState({ phone_err: '* please enter valid mobile number' });
	        flag = 1;
	      } else {
	        this.setState({ phone_err: '' });
	      }
	      if (localStorage.user_id) {
	        var uid = localStorage.user_id;
	      } else {
	        uid = 0;
	      }
	      var url = window.location.href;
	
	      if (localStorage.source) {
	        var source = localStorage.getItem('source');
	      } else {
	        source = '';
	      }
	      if (localStorage.campaign) {
	        var campaign = localStorage.getItem('campaign');
	      } else {
	        campaign = '';
	      }
	      if (localStorage.url_id) {
	        var url_id = localStorage.getItem('url_id');
	      } else {
	        url_id = '';
	      }
	
	      // advertiseWithUs(id,name,email,mobile,company,utype,from)
	      var data1 = { from: 'desktop_web', id: uid, token: localStorage.token, utype: this.state.utype, name: name, email: email, mobile: mobile, company: company, source: source, campaign: campaign, url_id: url_id, url: url };
	      var data2 = JSON.stringify(data1);
	      if (flag === 0) {
	        _jquery2.default.ajax({
	          url: baseUrl + 'advertiseWithUs',
	          method: 'POST',
	          dataType: 'JSON',
	          data: { req: data2 },
	          success: function (data) {
	            if (data.status === 'success') {
	              this.setState({
	                message: data.msg,
	                response: true,
	                mobile: '',
	                name: ''
	              });
	            }
	            if (data.status === 'error') {
	              this.setState({
	                message: data.msg,
	                response: true,
	                mobile: '',
	                name: ''
	              });
	            }
	            this.refs.name.value = "";
	            this.refs.email.value = "";
	            this.refs.phone.value = "";
	            this.refs.company.value = "";
	          }.bind(this),
	          error: function error(err) {}
	        });
	      }
	      event.preventDefault();
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      this.setState({ utype: event.target.value });
	    }
	  }, {
	    key: 'nameChange',
	    value: function nameChange(event) {
	      var x = event.target.value;
	      var invalidChars = /[^a-zA-Z ]/gi;
	      if (invalidChars.test(event.target.value)) {
	        x = event.target.value.replace(invalidChars, "");
	      } else {
	        this.setState({
	          name: x,
	          name_err: ''
	        });
	      }
	    }
	  }, {
	    key: 'mobileChange',
	    value: function mobileChange(event) {
	      var x = event.target.value;
	      var invalidChars = /[^0-9]/gi;
	      if (invalidChars.test(event.target.value)) {
	        x = event.target.value.replace(invalidChars, "");
	      } else {
	        this.setState({
	          mobile: x,
	          phone_err: ''
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      document.title = "Advertise With Us | AquaDeals";
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'mob_deals mob_advertise_page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page_hdr' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { onClick: function onClick() {
	                    _reactRouter.browserHistory.goBack();
	                  } },
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
	                )
	              ),
	              'Advertise With Us'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '/home', className: 'home_logo1' },
	              _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pag_cntnt' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid mob_advertise_blk' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'form',
	              { onSubmit: this.handleSubmit },
	              _react2.default.createElement(
	                'div',
	                { className: 'advertise_form1' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'contact_filed' },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'I am a'
	                  ),
	                  _react2.default.createElement(
	                    'select',
	                    { className: 'mob_selectbox', value: this.state.value, onChange: this.handleChange },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '1' },
	                      'User'
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { value: '2' },
	                      'Dealer'
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { value: '3' },
	                      'Manufacturer'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'error' },
	                    this.state.contact_err ? this.state.contact_err : ''
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'clr' },
	                  '\xA0'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'clr' },
	                  '\xA0'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form_fileds1' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mob_advertise_group' },
	                    _react2.default.createElement('input', { type: 'text', ref: 'name', placeholder: 'Name', value: this.state.name, onChange: this.nameChange }),
	                    _react2.default.createElement('span', { className: 'bar' }),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'error' },
	                      this.state.name_err ? this.state.name_err : ''
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mob_advertise_group' },
	                    _react2.default.createElement('input', { type: 'text', ref: 'email', placeholder: 'Email' }),
	                    _react2.default.createElement('span', { className: 'bar' }),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'error' },
	                      this.state.email_err ? this.state.email_err : ''
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mob_advertise_group' },
	                    _react2.default.createElement('input', { type: 'text', ref: 'phone', placeholder: 'Mobile Number', maxLength: '10', value: this.state.mobile, onChange: this.mobileChange }),
	                    _react2.default.createElement('span', { className: 'bar' }),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'error' },
	                      this.state.phone_err ? this.state.phone_err : ''
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mob_advertise_group' },
	                    _react2.default.createElement('input', { type: 'text', ref: 'company', placeholder: 'Company' }),
	                    _react2.default.createElement('span', { className: 'bar' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clr' },
	                '\xA0'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clr' },
	                '\xA0'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react2.default.createElement('input', { type: 'submit', className: 'btn  mob_advertise_submit', value: 'SUBMIT' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Modal,
	            { show: this.state.response, onHide: this.close },
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Body,
	              { style: { padding: '35px' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'advertise_msg' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  this.state.message
	                ),
	                _react2.default.createElement(
	                  'a',
	                  { onClick: this.close },
	                  'OK'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Advertise;
	}(_react.Component);
	
	exports.default = Advertise;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Deal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import ReactCountdownClock from 'react-countdown-clock';
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var AllPromoOffers = function (_Component) {
		_inherits(AllPromoOffers, _Component);
	
		function AllPromoOffers(props) {
			_classCallCheck(this, AllPromoOffers);
	
			var _this = _possibleConstructorReturn(this, (AllPromoOffers.__proto__ || Object.getPrototypeOf(AllPromoOffers)).call(this, props));
	
			_this.state = {
				loading: false,
				nodata: false,
				offers: [],
				seed_offers: [],
				product_offers: [],
				deals: []
			};
			_this.getOffers = _this.getOffers.bind(_this);
			return _this;
		}
	
		_createClass(AllPromoOffers, [{
			key: 'getOffers',
			value: function getOffers() {
				var data1 = { from: 'mobile_web', lat: '', long: '', device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'viewPromotedDeals',
					data: { req: data2 },
					dataType: 'json',
					success: function (data) {
						if (data.deals.length === 0) {
							this.setState({
								nodata: true,
								loading: true
							});
						} else {
							this.setState({
								nodata: false,
								loading: true,
								deals: data.deals
							});
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					window.location.href = "/web/promotional_offers";
				}
				this.getOffers();
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = "Promotional Deals | AquaDeals";
				var deals = this.state.deals.map(function (deal, index) {
					return _react2.default.createElement(Deal, { key: index, data: deal });
				});
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals mob_promo_deals_page' },
					this.state.loading ? _react2.default.createElement(
						'div',
						{ className: '' },
						_react2.default.createElement(
							'div',
							{ className: 'page_hdr' },
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: "/" },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
										)
									),
									'Promotional Deals'
								),
								_react2.default.createElement(
									'a',
									{ href: '/', className: 'home_newicon' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'pag_cntnt' },
							'\xA0'
						),
						_react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							this.state.nodata ? _react2.default.createElement(
								'div',
								{ className: 'no_data' },
								_react2.default.createElement(
									'h3',
									null,
									'No Deals Available'
								),
								_react2.default.createElement(
									'p',
									null,
									'Need something here? ',
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: "/customer_care" },
										'CONTACT US'
									),
									' now !'
								)
							) : deals.length > 0 ? _react2.default.createElement(
								'div',
								{ className: 'row' },
								deals
							) : _react2.default.createElement(
								'div',
								{ className: 'no_data' },
								_react2.default.createElement(
									'h3',
									null,
									'No Deals Available'
								),
								_react2.default.createElement(
									'p',
									null,
									'Need something here? ',
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: '/customer_care' },
										'CONTACT US'
									),
									' now !'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							)
						)
					) : _react2.default.createElement(
						'div',
						{ className: 'loading_sym' },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/loading.gif', alt: 'Loading', role: 'presentation' }),
						' '
					)
				);
			}
		}]);
	
		return AllPromoOffers;
	}(_react.Component);
	
	exports.default = AllPromoOffers;
	
	var Deal = exports.Deal = function (_Component2) {
		_inherits(Deal, _Component2);
	
		function Deal(props) {
			_classCallCheck(this, Deal);
	
			var _this2 = _possibleConstructorReturn(this, (Deal.__proto__ || Object.getPrototypeOf(Deal)).call(this, props));
	
			_this2.state = {
				data1: _this2.props.data,
				time: _this2.props.data.micro_time,
				seconds: Math.floor(_this2.props.data.micro_time / 1000 % 60),
				minutes: Math.floor(_this2.props.data.micro_time / 1000 / 60 % 60),
				hours: Math.floor(_this2.props.data.micro_time / (1000 * 60 * 60) % 24),
				days: Math.floor(_this2.props.data.micro_time / (1000 * 60 * 60 * 24))
			};
			_this2.tick_seconds = _this2.tick_seconds.bind(_this2);
			return _this2;
		}
	
		_createClass(Deal, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this3 = this;
	
				this.timerID_sec = setInterval(function () {
					return _this3.tick_seconds();
				}, 1000);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				clearInterval(this.timerID_sec);
			}
		}, {
			key: 'tick_seconds',
			value: function tick_seconds() {
				this.setState({
					time: this.state.time - 1,
					seconds: this.state.seconds - 1
				});
	
				if (this.state.seconds === 0) {
					this.setState({
						minutes: this.state.minutes - 1,
						seconds: 60
					});
					if (this.state.minutes < 0) {
						this.setState({
							minutes: 59,
							hours: this.state.hours - 1
						});
					}
					if (this.state.hours < 0) {
						if (this.state.days > 0) {
							this.setState({
								days: this.state.days - 1
							});
						}
					}
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var data = this.props.data;
				return _react2.default.createElement(
					'div',
					{ className: 'col-md-6 col-sm-6 col-xs-5 mob_ofr_deal_blks' },
					_react2.default.createElement(
						_reactRouter.Link,
						{ style: { textDecoration: 'none', color: '#333' }, to: data.type === "seed" ? "/sdetails/" + data.sname + "/" + data.id : "/pdetails/" + data.url_dtype_name + "/" + data.url_cat_name + "/" + data.url_brand_name + "/" + data.url_product_name + "/" + data.pid + "/" + data.id },
						_react2.default.createElement(
							'div',
							{ className: 'p_img_blk' },
							data.type === "seed" ? _react2.default.createElement('img', { src: data.img !== null && data.img !== '' ? data.img : baseAssets + 'icons/web_icons/noImage.png', alt: '', height: '101px' }) : _react2.default.createElement('img', { src: data.img !== null && data.img !== '' ? data.img : baseAssets + 'icons/web_icons/noImage.png', alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'p_data_blk' },
							_react2.default.createElement(
								'h5',
								{ style: { marginTop: '10px', marginBottom: '10px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' } },
								data.title
							),
							data.brand !== null && data.brand !== "" ? _react2.default.createElement(
								'h6',
								{ className: 'mob_pro_brand' },
								data.brand
							) : _react2.default.createElement(
								'h6',
								{ style: { marginTop: '5px', marginBottom: '10px', color: '#666', fontSize: '10px' } },
								'\xA0'
							),
							data.price ? _react2.default.createElement(
								'h6',
								{ className: 'mob_pro_mrp' },
								'MRP : \u20B9 ',
								data.price,
								' '
							) : _react2.default.createElement(
								'h6',
								{ className: 'mob_pro_mrp' },
								'\xA0'
							),
							data.aqua_cash_title ? _react2.default.createElement(
								'h6',
								{ className: 'mob_pro_ofr' },
								'Promotional Offer : \u20B9 ',
								data.deal_price
							) : _react2.default.createElement(
								'h6',
								{ className: 'mob_pro_ofr' },
								'\xA0'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'mob_promo_clock' },
							this.state.days > 0 ? _react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									{ className: 'mob_promo_clk_num' },
									this.state.days
								),
								' ',
								_react2.default.createElement(
									'span',
									{ className: 'mob_promo_clk_txt1' },
									this.state.days === 0 ? 'Days' : this.state.days > 1 ? 'Days' : 'Day'
								)
							) : _react2.default.createElement(
								'p',
								null,
								'\xA0'
							),
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									{ className: 'mob_promo_clk_num' },
									this.state.hours <= 9 ? 0 : '',
									this.state.hours
								),
								_react2.default.createElement(
									'span',
									{ className: 'mob_promo_clk_txt' },
									' hrs'
								),
								_react2.default.createElement(
									'span',
									{ className: 'mob_promo_clk_num' },
									' ',
									this.state.minutes <= 9 ? 0 : '',
									this.state.minutes
								),
								_react2.default.createElement(
									'span',
									{ className: 'mob_promo_clk_txt' },
									' min'
								),
								_react2.default.createElement(
									'span',
									{ className: 'mob_promo_clk_num' },
									' ',
									this.state.seconds
								),
								_react2.default.createElement(
									'span',
									{ className: 'mob_promo_clk_txt' },
									' sec'
								)
							)
						)
					)
				);
			}
		}]);
	
		return Deal;
	}(_react.Component);

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _reactSwipe = __webpack_require__(125);
	
	var _reactSwipe2 = _interopRequireDefault(_reactSwipe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var BannerAds = function (_Component) {
	  _inherits(BannerAds, _Component);
	
	  function BannerAds(props) {
	    _classCallCheck(this, BannerAds);
	
	    var _this = _possibleConstructorReturn(this, (BannerAds.__proto__ || Object.getPrototypeOf(BannerAds)).call(this, props));
	
	    _this.state = {
	      ads: []
	    };
	    _this.ads_count = _this.ads_count.bind(_this);
	    return _this;
	  }
	
	  _createClass(BannerAds, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (localStorage.user_id) {
	        var uid = localStorage.getItem('user_id');
	      } else {
	        uid = 0;
	      }
	      var data1 = { 'id': uid, 'token': localStorage.getItem('token'), 'width': 400, 'height': 200, 'from': 4 };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        dataType: 'json',
	        url: baseUrl + 'getAd',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            ads: data.imgs
	          });
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'ads_count',
	    value: function ads_count(ad_id) {
	      var uid = '';
	      if (localStorage.user_id) {
	        uid = localStorage.user_id;
	      } else {
	        uid = localStorage.ip;
	      }
	      var data1 = { 'from': 4, 'ad_id': ad_id, 'id': uid };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        dataType: 'json',
	        data: { req: data2 },
	        url: baseUrl + 'load_ad',
	        success: function success(data) {},
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var autoplay = "";
	      if (this.state.ads.length > 0) {
	        autoplay = {
	          delay: 5000,
	          disableOnInteraction: false
	        };
	      } else {
	        autoplay = false;
	      }
	
	      var params = {
	        spaceBetween: 0,
	        slidesPerView: 1,
	        autoplay: autoplay,
	        // pagination: '.swiper-pagination',
	        paginationClickable: true,
	        autoplayDisableOnInteraction: false,
	        // speed:1500,
	        //effect: 'coverflow',
	        // grabCursor: true,
	        // centeredSlides: true,
	        // coverflow: {
	        //   rotate: 50,
	        //   stretch: 0,
	        //   depth: 100,
	        //   modifier: 1,
	        //   slideShadows : true
	        // },
	        // effect:'cube',
	        // cube: {
	        //     shadow: true,
	        //     slideShadows: true,
	        //     shadowOffset: 20,
	        //     // shadowScale: 0.94
	        //     shadowScale: 0
	        //   },
	        loop: true
	      };
	
	      var banners = this.state.ads.map(function (ad, index) {
	        var _this2 = this;
	
	        var ad_deal = '';
	        var link = '';
	        if (ad.link === "") {
	          link = '';
	        } else if (ad.link !== '') {
	          link = ad.link;
	        }
	        if (ad.type === "Product") {
	          ad_deal = "/subdeals/" + ad.url_dtype + "/" + ad.url_cat_name + "/" + ad.url_brand_name + "/" + ad.pid;
	        } else if (ad.type === "All Seed Deals" && ad.id === '0') {
	          ad_deal = "/seed";
	        } else if (ad.type === "All Seed Deals" && ad.id > 0) {
	          ad_deal = "/seed/" + ad.url_dtype + "/" + ad.id;
	        } else if (ad.type === "p_sub_category") {
	          var deal_ids = '';
	          if (typeof ad.deal_id != "undefined" && ad.deal_id != '') {
	            deal_ids = ad.deal_id;
	          } else {
	            deal_ids = '';
	          }
	          ad_deal = "/pdeals/" + ad.url_dtype + "/" + ad.url_cat_name + "/" + ad.tid + "/Pcategory/" + ad.dtype + "/" + deal_ids;
	        } else if (ad.type === "Pcategory") {
	          ad_deal = "/pdeals/" + ad.url_name + "/all/" + ad.id;
	        } else if (ad.type === "SeedDeals") {
	          ad_deal = "/sdetails/" + ad.url_dtype + "/" + ad.id;
	        } else if (ad.type === "brand") {
	          ad_deal = "/pdeals/" + ad.url_dtype + "/" + ad.url_ad_title + "/" + ad.tid + "/" + ad.type + "/" + ad.dtype;
	        } else if (ad.type === "FeedDeals") {
	          ad_deal = "/pdetails/" + ad.url_dtype + "/" + ad.url_cat_name + "/" + ad.url_ad_title + "/" + ad.pid + "/" + ad.deal_id;
	        } else if (ad.type === "Deal Offer Types") {
	          ad_deal = "/pdeals/" + ad.url_dtype + "/" + ad.url_ad_title + "/" + ad.url_ad_type + "/offers/" + ad.id;
	        } else if (ad.type === "All Product Deals") {
	          ad_deal = "/offers/deals/" + ad.dis_val + "/" + ad.dis_opr + "/" + ad.dis_type;
	        } else if (ad.type === "brand_details") {
	          // ad_deal="/"+ad.bname+"/brand-details/"+ad.dtype+"/"+ad.bid;
	          ad_deal = "/" + ad.bname + "/brand-details/" + ad.bid;
	        } else if (ad.type === "PromoOffer") {
	          ad_deal = "/offerszone";
	        } else if (ad.type === 'partner') {
	          ad_deal = "/pdeals/partner/" + ad.tid;
	        } else if (ad.type === 'caa-approved' || ad.type === 'ad-guarantee' || ad.type === 'ad-assist') {
	          if (ad.tid === '0') {
	            ad_deal = '/ad-banners/' + ad.type;
	          } else {
	            ad_deal = "/stores/" + ad.type + '/' + ad.tid;
	          }
	        } else {
	          ad_deal = '/';
	        }
	        return _react2.default.createElement(
	          'div',
	          { key: index },
	          _react2.default.createElement(
	            'span',
	            { className: 'mob_carousel_count swipe_caption' },
	            ad.sno,
	            '/',
	            this.state.ads.length
	          ),
	          link === '' ? _react2.default.createElement(
	            _reactRouter.Link,
	            { onClick: function onClick() {
	                return _this2.ads_count(ad.ad_id);
	              }, to: ad_deal },
	            _react2.default.createElement('img', { src: ad.img ? baseAssets + "images/ad_imgs/XXHDPI/" + ad.img : baseAssets + 'images/ad_imgs/placeholder_bg.png', style: { margin: '0 auto' }, alt: '...' })
	          ) : _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this2.ads_count(ad.ad_id);
	              }, href: link, target: '_blank' },
	            _react2.default.createElement('img', { src: ad.img ? baseAssets + "images/ad_imgs/XXHDPI/" + ad.img : baseAssets + 'images/ad_imgs/placeholder_bg.png', style: { margin: '0 auto' }, alt: '...' })
	          )
	        );
	      }.bind(this));
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.state.ads.length > 0 ? _react2.default.createElement(
	          'section',
	          { className: 'pag_cntnt hm_pg_sld' },
	          _react2.default.createElement(
	            _reactIdSwiper2.default,
	            _extends({}, params, { key: this.state.ads.length }),
	            banners
	          )
	        ) : ''
	      );
	    }
	  }]);
	
	  return BannerAds;
	}(_react.Component);
	
	exports.default = BannerAds;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var CheckoutFlow = function (_Component) {
	  _inherits(CheckoutFlow, _Component);
	
	  function CheckoutFlow(props) {
	    _classCallCheck(this, CheckoutFlow);
	
	    var _this = _possibleConstructorReturn(this, (CheckoutFlow.__proto__ || Object.getPrototypeOf(CheckoutFlow)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CheckoutFlow, [{
	    key: 'render',
	    value: function render() {
	
	      document.title = "AquaDeals - Online AquaCulture MarketPlace, Find best deals on Seed, Feed, Health Care, Machinery & Farm Equipments, Products, Ropes & Nets Paddle Wheels and More | AquaDeals";
	      document.getElementsByTagName("META")[2].content = "It is a place for deals related to Aqua culture";
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'mob_deals mob_advertise_page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page_hdr' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { onClick: function onClick() {
	                    _reactRouter.browserHistory.goBack();
	                  } },
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
	                )
	              ),
	              'Advertise With Us'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '/home', className: 'home_logo1' },
	              _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pag_cntnt' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid mob_advertise_blk' },
	          _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'center' } },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Checkout Flow'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('img', { src: __webpack_require__(647) })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CheckoutFlow;
	}(_react.Component);
	
	exports.default = CheckoutFlow;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _footer = __webpack_require__(50);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var CustomerCare = function (_Component) {
	  _inherits(CustomerCare, _Component);
	
	  function CustomerCare(props) {
	    _classCallCheck(this, CustomerCare);
	
	    var _this = _possibleConstructorReturn(this, (CustomerCare.__proto__ || Object.getPrototypeOf(CustomerCare)).call(this, props));
	
	    _this.state = {};
	    _this.state = {
	      email: '',
	      mobiles: '',
	      timings: '',
	      advertiser_email: '',
	      advertiser_mobile: '',
	      zendesk_flag: false
	    };
	    return _this;
	  }
	
	  _createClass(CustomerCare, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (screen.width >= 800) {
	        window.location.href = "/customer_care";
	      }
	      if (localStorage.user_id) {
	        var uid = localStorage.getItem('user_id');
	      } else {
	        uid = 0;
	      }
	      var data1 = { from: 'mobile_web', user_id: uid, ref: 'customer_care' };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getCustomerSupportDetails',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            email: data.email,
	            timings: data.timings,
	            mobiles: data.mobiles,
	            advertiser_email: data.advertiser_email,
	            advertiser_mobile: data.advertiser_mobile,
	            username: data.user_name,
	            wb_url: data.wb_url,
	            zendesk_flag: data.zendesk_flag
	          });
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'chatnow',
	    value: function chatnow() {
	      if (localStorage.user_id) {
	        var uid = localStorage.getItem('user_id');
	      } else {
	        uid = 0;
	      }
	
	      if (!localStorage.user_id && !localStorage.token) {
	        // if(this.props.params.Bname)
	        // {
	        //   localStorage.setItem('m_r_p_dt','/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Bname+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.DealId)   
	        // }
	        // else
	        // {
	        //   localStorage.setItem('m_r_p_dt','/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.DealId)
	        // }
	        // localStorage.setItem('mob_addtocart','1');
	        // localStorage.setItem('mob_addtocart_qty',this.state.min_qty);
	        _reactRouter.browserHistory.push('/login/' + this.state.wb_url);
	      } else {
	        location.href = this.state.wb_url;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      document.title = "Customer Care | AquaDeals";
	      document.getElementsByTagName("META")[2].content = "AquaDeals Customer Care";
	      return _react2.default.createElement(
	        'div',
	        { className: 'mob_deals customer_care_page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page_hdr' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { onClick: function onClick() {
	                    _reactRouter.browserHistory.goBack();
	                  } },
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
	                )
	              ),
	              'Customer Support'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '/', className: 'home_logo1' },
	              _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pag_cntnt customer_care' },
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'mod_cc_bg' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('img', { src: __webpack_require__(255), height: '160', alt: '...' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mob_cc_image' },
	              _react2.default.createElement('img', { src: __webpack_require__(107), alt: '...' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'section',
	                { id: 'cc_content_block' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Dear ',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    this.state.username
	                  ),
	                  ' ,'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { id: 'cc_cnt' },
	                  'If you have any questions or concerns about our products or services, feel free to contact our Customer Support team.'
	                )
	              ),
	              _react2.default.createElement(
	                'section',
	                { id: 'cc_contact_list' },
	                _react2.default.createElement(
	                  'a',
	                  { href: "mailto:" + this.state.email },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', { src: __webpack_require__(108) })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      this.state.email
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', { src: __webpack_require__(109) })
	                  ),
	                  _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.state.mobiles } })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', { src: __webpack_require__(111) })
	                  ),
	                  this.state.timings
	                )
	              ),
	              this.state.zendesk_flag == 1 ? _react2.default.createElement(
	                'section',
	                { id: 'cc_wb_div' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'cc_wb_btn', onClick: function onClick() {
	                      _this2.chatnow();
	                    } },
	                  _react2.default.createElement(
	                    'span',
	                    { id: 'cnt_wb_icon' },
	                    _react2.default.createElement('img', { src: __webpack_require__(157), width: '20' })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'CHAT NOW'
	                  )
	                )
	              ) : ''
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CustomerCare;
	}(_react.Component);
	
	exports.default = CustomerCare;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(36);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _footer = __webpack_require__(50);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import {connect} from 'react-redux';
	
	
	// import $ from 'jquery';
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var EnquireNow_Partner = function (_Component) {
		_inherits(EnquireNow_Partner, _Component);
	
		function EnquireNow_Partner(props) {
			_classCallCheck(this, EnquireNow_Partner);
	
			var _this = _possibleConstructorReturn(this, (EnquireNow_Partner.__proto__ || Object.getPrototypeOf(EnquireNow_Partner)).call(this, props));
	
			_this.state = {
				ltype: _this.props.params.Ltype,
				sid: _this.props.params.Sid,
				did: _this.props.params.Did,
				showModal: false,
				stype: 0,
				rtype: 0,
				textarea_msg: '',
				comp_name: '',
				email_fld: '',
				stype_status: false,
				stype1: false,
				rtype1: false,
				rtype_status: false,
				user_mob_num: '',
				user_name: ''
			};
			_this.modalOpen = _this.modalOpen.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.closeModal = _this.closeModal.bind(_this);
			_this.getCat = _this.getCat.bind(_this);
			_this.getRole = _this.getRole.bind(_this);
			_this.txtAreaChange = _this.txtAreaChange.bind(_this);
			_this.getCompName = _this.getCompName.bind(_this);
			_this.getEmail = _this.getEmail.bind(_this);
			_this.validateData = _this.validateData.bind(_this);
			_this.getUserDetails = _this.getUserDetails.bind(_this);
			_this.saveLead = _this.saveLead.bind(_this);
			return _this;
		}
	
		_createClass(EnquireNow_Partner, [{
			key: 'getEmail',
			value: function getEmail(event) {
				event.preventDefault();
				this.setState({
					email_fld: this.refs.email_ref_fld.value
				});
			}
		}, {
			key: 'validateData',
			value: function validateData(event) {
				event.preventDefault();
				this.setState({
					stype1: true,
					rtype1: true
				});
			}
		}, {
			key: 'txtAreaChange',
			value: function txtAreaChange(event) {
				event.preventDefault();
				this.setState({
					textarea_msg: this.refs.txtAreaMsg.value
				});
			}
		}, {
			key: 'getCat',
			value: function getCat(x) {
				var _this2 = this;
	
				this.setState({
					stype: x,
					stype_status: true,
					stype1: false
				}, function () {
					console.log(_this2.state.stype);
				});
			}
		}, {
			key: 'getRole',
			value: function getRole(x) {
				var _this3 = this;
	
				// alert(x);
				this.setState({
					rtype: x,
					rtype_status: true,
					rtype1: false
				}, function () {
					console.log(_this3.state.rtype);
				});
				// console.log(this.state.cat);
			}
		}, {
			key: 'modalOpen',
			value: function modalOpen() {
				this.setState({
					showModal: true
				});
			}
		}, {
			key: 'closeModal',
			value: function closeModal() {
				this.setState({
					showModal: false
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					showModal: false
				});
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(newProps) {
				if (newProps.leads === 1 || newProps.leads.status === 'success') {
					this.setState({ showModal: true });
				} else {
					this.setState({ showModal: false });
				}
			}
		}, {
			key: 'handleFormSubmit',
			value: function handleFormSubmit(formProps) {
				if (this.state.stype === 0) {
					this.setState({
						stype_status: true
					});
				} else {
					this.setState({
						stype_status: false
					});
				}
				if (this.state.rtype === 0) {
					this.setState({
						rtype_status: true
					});
				} else {
					this.setState({
						rtype_status: false
					});
				}
	
				if (this.state.ltype === "seed") {
					this.props.saveseed_lead(formProps, this.state.sid, this.state.did);
				}
				if (this.state.ltype === "feed") {
					this.props.savefeed_lead(formProps, this.state.sid, this.state.did);
				}
				if (this.state.ltype === "seller") {
					this.props.track_seller_lead(formProps, this.state.sid, this.state.did, this.state.stype, this.state.rtype, this.state.textarea_msg);
					//this.props.track_seller_lead(formProps,this.state.sid,this.state.did);	
				}
				if (this.state.ltype === "nodata") {
					this.props.track_user_lead(formProps, this.state.sid, this.state.did);
				} else {
					// var frm='mobile_web';
					// this.props.track_seller_lead(formProps,frm,this.state.user_mob_num,this.state.user_name,this.state.sid,this.state.did,this.state.stype,this.state.rtype,this.state.textarea_msg);	
					this.saveLead(this.state.user_mob_num, this.state.user_name, this.state.sid, this.state.did, this.state.stype, this.state.rtype, this.state.textarea_msg, this.state.email_fld, this.state.comp_name);
				}
			}
		}, {
			key: 'saveLead',
			value: function saveLead(user_mobile, user_name, seller_id, deal_id, stype, role, message, email, company_name) {
				var id = '';
				if (localStorage.user_id) {
					id = localStorage.user_id;
				} else {
					id = localStorage.ip;
				}
				var token = '';
				if (localStorage.token) {
					token = localStorage.token;
				} else {
					token = 0;
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
	
				var data1 = { from: 'mobile_web', 'id': id, 'token': token, 'name': user_name, 'mobile': user_mobile, 'email': email, 'cname': company_name, 'stype': stype, 'role': role, 'message': message, 'seller_id': seller_id, 'deal_id': deal_id, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'trackSellerLead',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								showModal: true,
								message: data.message
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				if (screen.width >= 800) {
					window.location.href = "/web/enquire_now/partner/support/sid/did";
				}
				this.refs.comp_ref_name.focus();
				if (!localStorage.token && !localStorage.user_id) {
					localStorage.setItem('m_r_enq_seller_page', '/enquire_now/partner/support/sid/did');
					localStorage.removeItem('w_r_s_dt');
					localStorage.removeItem('m_r_e_coupon_dt');
					localStorage.removeItem('web_mycart');
					localStorage.removeItem('w_r_p_dt');
					localStorage.removeItem('w_modal_seed');
					localStorage.removeItem('w_r_seed_deals');
					localStorage.removeItem('w_r_p_deals');
					localStorage.removeItem('w_r_e_s_dt');
					localStorage.removeItem('w_r_e_p_dt');
					localStorage.removeItem('w_modal_details');
					localStorage.removeItem('m_r_s_dt');
					localStorage.removeItem('m_r_e_s_dt');
					localStorage.removeItem('m_r_e_s_dt');
					localStorage.removeItem('mob_mycart');
					localStorage.removeItem('m_r_e_coupon_dt');
					localStorage.removeItem('m_r_p_dt');
					localStorage.removeItem('m_r_e_p_dt');
					localStorage.removeItem('ofr_page');
					localStorage.removeItem('profile');
					localStorage.removeItem('share_earn');
					localStorage.removeItem('pro_ofr_dtls');
					_reactRouter.browserHistory.push('/login');
				} else {
					this.getUserDetails();
				}
			}
		}, {
			key: 'getUserDetails',
			value: function getUserDetails() {
				if (localStorage.user_id) {
					var user_id = localStorage.getItem('user_id');
				} else {
					user_id = 0;
				}
				var data1 = { from: 'mobile_web', uid: user_id, token: localStorage.getItem('token'), device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
	
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'myprofile',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							user_mob_num: data.details[0].mobile,
							user_name: data.details[0].name
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getCompName',
			value: function getCompName(event) {
				event.preventDefault();
				this.setState({
					comp_name: this.refs.comp_ref_name.value
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				// $(document).ready(function(){
				// 	$('.partner_text_area').on('click',function(){
				// 		$('.partner_text_area').attr('placeholder','');
				// 	})
				// });
				document.title = "Register as Partner with AquaDeals";
	
				// const {handleSubmit,fields:{name,number,email,company_name,comment}} = this.props;
				var _props = this.props,
				    handleSubmit = _props.handleSubmit,
				    _props$fields = _props.fields,
				    number = _props$fields.number,
				    email = _props$fields.email,
				    company_name = _props$fields.company_name,
				    comment = _props$fields.comment;
	
				return _react2.default.createElement(
					'section',
					{ className: 'mob_deals tot_pag mob_ptnr_spt_page', style: { backgroundColor: '#f2f2f2' } },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ onClick: function onClick() {
											_reactRouter.browserHistory.goBack();
										} },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/close_icon1.png', className: 'cross_icon', width: '14px', alt: '' })
									)
								),
								'Partner Support'
							),
							_react2.default.createElement(
								'a',
								{ href: '/', className: 'home_newicon' },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
							)
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'pag_cntnt' },
						_react2.default.createElement(
							'div',
							{ className: 'container', style: { marginTop: '50px' } },
							_react2.default.createElement(
								'div',
								{ className: 'parnter_logo_img' },
								_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/partner_support.png', alt: ' ' })
							),
							_react2.default.createElement(
								'div',
								{ className: '' },
								_react2.default.createElement(
									'h5',
									{ className: 'reg_ptr_h5' },
									'Personal Details'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-6 col-md-offset-3', style: { padding: '0px' } },
								_react2.default.createElement(
									'div',
									{ className: 'login_form' },
									_react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'form',
											{ className: 'mtrl_elmnts2 req_ptr_form', onSubmit: this.state.stype === 0 || this.state.rtype === 0 ? this.validateData : handleSubmit(this.handleFormSubmit.bind(this)), style: { marginTop: '15px' } },
											_react2.default.createElement(
												'section',
												{ className: 'form_ptnr_fields' },
												_react2.default.createElement(
													'div',
													{ className: 'form_cnt_blk' },
													_react2.default.createElement(
														'div',
														{ className: 'group' },
														_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cell_dl_blue.png', alt: '', className: 'mob_ptr_lft_img' }),
														_react2.default.createElement('input', _extends({}, number, { value: this.state.user_mob_num, placeholder: 'Mobile Number', type: 'text', maxLength: 10, required: true })),
														_react2.default.createElement('span', { className: 'highlight' }),
														_react2.default.createElement('span', { className: 'bar' })
													),
													_react2.default.createElement(
														'div',
														{ className: 'group' },
														_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/user_blue.png', alt: '', className: 'mob_ptr_lft_img' }),
														_react2.default.createElement('input', { value: this.state.user_name, type: 'text', placeholder: 'Name', required: true }),
														_react2.default.createElement('span', { className: 'highlight' }),
														_react2.default.createElement('span', { className: 'bar' })
													),
													_react2.default.createElement(
														'div',
														{ className: 'group' },
														_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/building_blue.png', alt: '', className: 'mob_ptr_lft_img' }),
														_react2.default.createElement('input', _extends({}, company_name, { required: true, placeholder: 'Company/Firm Name', type: 'text', value: this.state.comp_name, onChange: this.getCompName, ref: 'comp_ref_name' })),
														_react2.default.createElement('span', { className: 'highlight' }),
														_react2.default.createElement('span', { className: 'bar' }),
														_react2.default.createElement(
															'span',
															{ style: { color: 'red', fontSize: '11px' } },
															company_name.touched && company_name.error && _react2.default.createElement(
																'div',
																{ className: 'text-danger' },
																company_name.error
															)
														)
													),
													_react2.default.createElement(
														'div',
														{ className: 'group' },
														_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/email_dl_blue.png', alt: '', className: 'mob_ptr_lft_img' }),
														_react2.default.createElement('input', _extends({}, email, { placeholder: 'Enter Email', required: true, type: 'text', ref: 'email_ref_fld', value: this.state.email_fld, onChange: this.getEmail })),
														_react2.default.createElement('span', { className: 'highlight' }),
														_react2.default.createElement('span', { className: 'bar' }),
														_react2.default.createElement(
															'span',
															null,
															_react2.default.createElement(
																'div',
																{ className: 'text-danger' },
																email.error ? email.error : ''
															)
														)
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'mob_new_role_blk radiobtns' },
												_react2.default.createElement(
													'h5',
													{ style: {} },
													'My role'
												),
												_react2.default.createElement(
													_reactBootstrap.FormGroup,
													{ className: 'partner_role_blk' },
													_react2.default.createElement(
														_reactBootstrap.Radio,
														{ name: 'radioGroup', className: this.state.rtype === 1 ? 'role_active' : 'role_inactive', required: true, inline: true, onChange: function onChange() {
																_this4.getRole(1);
															} },
														'Hatchery owner'
													),
													_react2.default.createElement(
														_reactBootstrap.Radio,
														{ name: 'radioGroup', className: this.state.rtype === 2 ? 'role_active' : 'role_inactive', required: true, inline: true, onChange: function onChange() {
																_this4.getRole(2);
															} },
														'Manufacturer/Importer'
													),
													_react2.default.createElement(
														_reactBootstrap.Radio,
														{ name: 'radioGroup', className: this.state.rtype === 3 ? 'role_active' : 'role_inactive', required: true, inline: true, onChange: function onChange() {
																_this4.getRole(3);
															} },
														'Dealer'
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'mob_new_cat_blk radiobtns' },
												_react2.default.createElement(
													'h5',
													null,
													'Categories'
												),
												_react2.default.createElement(
													_reactBootstrap.FormGroup,
													{ className: 'partner_role_blk' },
													_react2.default.createElement(
														_reactBootstrap.Radio,
														{ name: 'radioGroup1', className: this.state.stype === 1 ? 'role_active' : 'role_inactive', required: true, inline: true, onChange: function onChange() {
																_this4.getCat(1);
															} },
														'Seed/Nauplii'
													),
													_react2.default.createElement(
														_reactBootstrap.Radio,
														{ name: 'radioGroup1', className: this.state.stype === 2 ? 'role_active' : 'role_inactive', required: true, inline: true, onChange: function onChange() {
																_this4.getCat(2);
															} },
														'Feed/Health care'
													),
													_react2.default.createElement(
														_reactBootstrap.Radio,
														{ name: 'radioGroup1', className: this.state.stype === 3 ? 'role_active' : 'role_inactive', required: true, inline: true, onChange: function onChange() {
																_this4.getCat(3);
															} },
														'Aerators/Machinery'
													)
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'mob_new_msg_blk' },
												_react2.default.createElement(
													'h5',
													null,
													'Message ',
													_react2.default.createElement(
														'span',
														null,
														comment.touched && comment.error && _react2.default.createElement(
															'span',
															{ className: 'text-msg_danger' },
															'* ',
															comment.error
														)
													)
												),
												_react2.default.createElement(
													'section',
													{ className: 'mob_pntr_textarea' },
													_react2.default.createElement('textarea', _extends({}, comment, { className: 'partner_text_area', required: true, placeholder: "I am interested to sell my products in Aqua deals partnership program. I would like to know some more details. Looking forward for your reply.", rows: 5, style: { width: '100%', fontSize: '13px' }, value: this.state.textarea_msg, onChange: this.txtAreaChange, ref: 'txtAreaMsg' }))
												)
											),
											_react2.default.createElement(
												'div',
												{ style: { textAlign: 'center', background: '#fff', margin: '0 -10px' } },
												_react2.default.createElement(
													'button',
													{ action: 'submit', className: 'partner_req_sub_btn' },
													'REQUEST CALL BACK'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'parner_bot_img' },
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											),
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/ad_partner_logo.png', alt: '' }),
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											),
											_react2.default.createElement(
												'div',
												{ className: 'clr' },
												'\xA0'
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ backdrop: 'static', className: 'showModal modal fade', show: this.state.showModal, style: { zIndex: '1111' }, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ style: { borderBottom: 'none' } },
							_react2.default.createElement(_reactBootstrap.Modal.Title, { style: { fontSize: 16 + 'px', color: '#333' } })
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { textAlign: 'center', fontSize: '14px', color: '#666' } },
								this.state.message
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer', style: { borderTop: 'none', textAlign: 'center' } },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/customer_care_seller', style: { color: '#ff742a', textAlign: 'right', float: 'right', marginRight: '20px', marginTop: '-20px', textDecoration: 'none' } },
								'OK'
							)
						)
					)
				);
			}
		}]);
	
		return EnquireNow_Partner;
	}(_react.Component);
	
	function validate(formProps) {
		var errors = {};
		var namePattern = /^[a-zA-Z0-9\x20]{3,25}/;
	
		// if(!formProps.name){
		//   errors.name = "Enter your name";
		// }
		// else if(formProps.name && !namePattern.test(formProps.name)){
		// 		errors.name = 'Enter minimum 3 characters';
		// }
	
		/* if(!formProps.company_name){
	 	errors.company_name="Please enter your company Name";
	 }
	 */
		if (formProps.company_name && !namePattern.test(formProps.company_name)) {
			errors.company_name = 'Enter minimum 3 characters';
		}
	
		// const invalidChars = /[^0-9]/gi;
		//  if(formProps.number && invalidChars.test(formProps.number)){
		//  	errors.number="invalid mobile number";
		//  }
	
		// const number_check = /^[0-9]{10}$/;  
		//  if(formProps.number && !number_check.test(formProps.number)){
		//  	errors.number="Mobile number must contains 10 numbers only";
		//  }
	
		// if(!formProps.number){
		// 	errors.number="Enter Mobile Number";
		// }
	
	
		var emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
		if (formProps.email && !emailPattern.test(formProps.email)) {
			errors.email = 'Enter a valid email';
		}
		if (formProps.comment && !namePattern.test(formProps.comment)) {
			errors.comment = 'Enter minimum 3 characters';
		}
	
		// const emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
		//   if (!emailPattern.test(formProps.email)) {
		//     errors.email = 'Enter a valid email';
		//   }
	
		return errors;
	}
	
	function mapStateToProps(state) {
		return {
			leads: state.posts.leads,
			lead_status: state.posts.lead_status
		};
	}
	
	exports.default = (0, _reduxForm.reduxForm)({
		form: 'Enquiry',
		fields: ['name', 'number', 'email', 'company_name', 'comment'],
		validate: validate
	
	}, mapStateToProps, actions)(EnquireNow_Partner);

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(36);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _footer = __webpack_require__(50);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import {connect} from 'react-redux';
	
	
	// import $ from 'jquery';
	
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var EnquireNow = function (_Component) {
		_inherits(EnquireNow, _Component);
	
		function EnquireNow(props) {
			_classCallCheck(this, EnquireNow);
	
			var _this = _possibleConstructorReturn(this, (EnquireNow.__proto__ || Object.getPrototypeOf(EnquireNow)).call(this, props));
	
			_this.state = {
				ltype: _this.props.params.Ltype,
				sid: _this.props.params.Sid,
				did: _this.props.params.Did,
				showModal: false
			};
			_this.modalOpen = _this.modalOpen.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.closeModal = _this.closeModal.bind(_this);
			return _this;
		}
	
		_createClass(EnquireNow, [{
			key: 'modalOpen',
			value: function modalOpen() {
				this.setState({
					showModal: true
				});
			}
		}, {
			key: 'closeModal',
			value: function closeModal() {
				this.setState({
					showModal: false
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					showModal: false
				});
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(newProps) {
				if (newProps.leads === 1 || newProps.leads.status === 'success') {
					this.setState({ showModal: true });
				} else {
					this.setState({ showModal: false });
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount(newProps) {}
		}, {
			key: 'handleFormSubmit',
			value: function handleFormSubmit(formProps) {
				// console.log(this.state.ltype);
				if (this.state.ltype === "seed") {
					this.props.saveseed_lead(formProps, this.state.sid, this.state.did);
				}
				if (this.state.ltype === "feed") {
					this.props.savefeed_lead(formProps, this.state.sid, this.state.did);
				}
				if (this.state.ltype === "seller") {
					this.props.savefeed_lead(formProps, this.state.sid, this.state.did);
					//this.props.track_seller_lead(formProps,this.state.sid,this.state.did);	
				}
				if (this.state.ltype === "nodata") {
					this.props.track_user_lead(formProps, this.state.sid, this.state.did);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					window.location.href = "/web/enquire/type/sid/did";
				}
			}
		}, {
			key: 'render',
			value: function render() {
				// console.log(this.props.leads);
				var redirect = '';
				if (this.state.ltype === 'seller') {
					redirect = '/customer_care_seller';
				} else {
					redirect = '/customer_care';
				}
				var _props = this.props,
				    handleSubmit = _props.handleSubmit,
				    _props$fields = _props.fields,
				    name = _props$fields.name,
				    number = _props$fields.number,
				    email = _props$fields.email;
	
				return _react2.default.createElement(
					'section',
					{ className: 'mob_deals tot_pag mob_enquire_page' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ onClick: function onClick() {
											_reactRouter.browserHistory.goBack();
										} },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
									)
								),
								'Enquire Now'
							),
							_react2.default.createElement(
								'a',
								{ href: '/home', className: 'home_newicon' },
								_react2.default.createElement('img', { src: baseAssets + 'mob-assets/home1.png', alt: 'Home' })
							)
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'pag_cntnt' },
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ className: 'login_logo' },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/logo.png', title: '', alt: 'Aquadeals' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'login_form' },
								_react2.default.createElement(
									'form',
									{ className: 'mtrl_elmnts', onSubmit: handleSubmit(this.handleFormSubmit.bind(this)) },
									_react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/user.png', alt: '', style: { position: 'absolute', top: '6px', left: '0px' } }),
										_react2.default.createElement('input', _extends({}, name, { type: 'text', placeholder: 'Name' })),
										_react2.default.createElement('span', { className: 'highlight' }),
										_react2.default.createElement('span', { className: 'bar' }),
										_react2.default.createElement(
											'span',
											null,
											name.touched && name.error && _react2.default.createElement(
												'div',
												{ className: 'text-danger' },
												name.error
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/cell_dl.png', alt: '', style: { position: 'absolute', top: '6px', left: '0px' } }),
										_react2.default.createElement('input', _extends({}, number, { type: 'text', maxLength: 10, placeholder: 'Mobile' })),
										_react2.default.createElement('span', { className: 'highlight' }),
										_react2.default.createElement('span', { className: 'bar' }),
										_react2.default.createElement(
											'span',
											null,
											number.touched && number.error && _react2.default.createElement(
												'div',
												{ className: 'text-danger' },
												number.error
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'group' },
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/email_dl.png', alt: '', style: { position: 'absolute', top: '6px', left: '0px' } }),
										_react2.default.createElement('input', _extends({}, email, { type: 'text', placeholder: 'Email(Optional)' })),
										_react2.default.createElement('span', { className: 'highlight' }),
										_react2.default.createElement('span', { className: 'bar' }),
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement(
												'div',
												{ className: 'text-danger' },
												email.error ? email.error : ''
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement('div', { className: 'col-md-6 col-xs-6 col-sm-6' }),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-6 col-xs-6 col-sm-6' },
											_react2.default.createElement(
												'button',
												{ action: 'submit', className: 'btn mob_enq_btn' },
												'Enquire'
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ backdrop: 'static', className: 'showModal modal fade', show: this.state.showModal, style: { zIndex: '1111' }, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ style: { borderBottom: 'none' } },
							_react2.default.createElement(_reactBootstrap.Modal.Title, { style: { fontSize: 16 + 'px', color: '#333' } })
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'div',
								{ style: { textAlign: 'center' } },
								_react2.default.createElement('img', { width: 70, src: baseAssets + 'images/web_imgs/conformed.png', alt: '...' })
							),
							_react2.default.createElement(
								'h4',
								{ style: { textAlign: 'center', fontSize: 14 + 'px', color: '#666' } },
								'Your details has been submitted successfully'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer', style: { borderTop: 'none', textAlign: 'center' } },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: redirect },
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: '#ff742a none repeat scroll 0 0', color: '#fff' } },
									'OK'
								)
							)
						)
					)
				);
			}
		}]);
	
		return EnquireNow;
	}(_react.Component);
	
	function validate(formProps) {
		var errors = {};
		var namePattern = /^[a-zA-Z0-9\x20]{3,25}/;
	
		if (!formProps.name) {
			errors.name = "Enter your name";
		} else if (formProps.name && !namePattern.test(formProps.name)) {
			errors.name = 'Enter minimum 3 characters';
		}
	
		var invalidChars = /[^0-9]/gi;
		if (formProps.number && invalidChars.test(formProps.number)) {
			errors.number = "invalid mobile number";
		}
	
		var number_check = /^[0-9]{10}$/;
		if (formProps.number && !number_check.test(formProps.number)) {
			errors.number = "Mobile number must contains 10 numbers only";
		}
	
		if (!formProps.number) {
			errors.number = "Enter Mobile Number";
		}
	
		var emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
		if (formProps.email && !emailPattern.test(formProps.email)) {
			errors.email = 'Enter a valid email';
		}
		if (!formProps.email) {
			formProps.email = '';
		}
	
		// const emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
		//   if (!emailPattern.test(formProps.email)) {
		//     errors.email = 'Enter a valid email';
		//   }
	
		return errors;
	}
	
	function mapStateToProps(state) {
		return {
			leads: state.posts.leads
		};
	}
	
	exports.default = (0, _reduxForm.reduxForm)({
		form: 'Enquiry',
		fields: ['name', 'number', 'email'],
		validate: validate
	
	}, mapStateToProps, actions)(EnquireNow);

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouter = __webpack_require__(2);
	
	var _footer = __webpack_require__(50);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _reactWebVectorIcons = __webpack_require__(29);
	
	var _reactWebVectorIcons2 = _interopRequireDefault(_reactWebVectorIcons);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Search = function (_Component) {
	  _inherits(Search, _Component);
	
	  function Search(props) {
	    _classCallCheck(this, Search);
	
	    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));
	
	    _this.handleClick = function (event) {
	      console.log(event);
	    };
	
	    _this.state = {
	      status: 'unfocus',
	      keyword: '',
	      viewmore_status: false,
	      isLoading: false,
	      isSearched: false
	    };
	    _this.deleteSearchItem = _this.deleteSearchItem.bind(_this);
	    _this.viewmore = _this.viewmore.bind(_this);
	    _this.saveSearch = _this.saveSearch.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: 'deleteSearchItem',
	    value: function deleteSearchItem(del_id) {
	      console.log(del_id);
	      if (localStorage.user_id) {
	        var uid = localStorage.user_id;
	      } else {
	        uid = 0;
	      }
	      var data1 = { from: 'mobile_web', uid: uid, token: localStorage.token, id: del_id };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        dataType: 'json',
	        url: baseUrl + 'deleteSearch',
	        data: { req: data2 },
	        success: function (data) {
	          if (data.status === 'success') {
	            this.props.trends();
	          }
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'viewmore',
	    value: function viewmore() {
	      this.setState({
	        viewmore_status: !this.state.viewmore_status
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refs.keyword.focus();
	      //this.props.clear_state();
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(event) {
	      this.setState({
	        // status: 'focus',
	        keyword: event.target.value
	      });
	    }
	  }, {
	    key: 'onChangeKey',
	    value: function onChangeKey(event) {
	      // this.props.clear_state();
	      // if(event.target.value ==""){
	      //   this.props.trends();
	      // }else{
	      //   this.props.search_products(event.target.value);     
	      // }
	      this.setState({
	        keyword: event.target.value,
	        status: 'focus'
	      });
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      // this.setState({
	      //   status: 'unfocus'
	      // });
	    }
	  }, {
	    key: 'resetKey',
	    value: function resetKey() {
	      this.props.trends();
	      this.setState({
	        keyword: '',
	        status: 'unfocus',
	        isSearched: false
	      });
	      // this.state.keyword = ''
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.trends();
	    }
	  }, {
	    key: 'saveSearch',
	    value: function saveSearch(uid, search_id, type) {
	      if (uid != 0) {
	        var data1 = { from: 'mobile_web', id: uid, token: localStorage.token, search_id: search_id, type: type };
	        var data2 = JSON.stringify(data1);
	        _jquery2.default.ajax({
	          method: 'POST',
	          dataType: 'json',
	          url: baseUrl + 'saveSearch',
	          data: { req: data2 },
	          success: function (data) {
	            if (data.status === 'success') {}
	          }.bind(this),
	          error: function error(err) {}
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var recent_search = "";
	      var that = this;
	      (0, _jquery2.default)(document).off('keyup', '#srh_input_box');
	      (0, _jquery2.default)(document).on('keyup', '#srh_input_box', function () {
	        var string = (0, _jquery2.default)(this).val();
	        console.log(string);
	        that.props.clear_state();
	        if (string == "") {
	          that.setState({ isSearched: false });
	          that.setState({ isLoading: false });
	          that.props.trends();
	        } else {
	          that.setState({ isSearched: true });
	          that.props.search_products(string);
	        }
	      });
	      // $('body').css('background','#E0E1E3');
	      // $(window).load(function() {
	      //   $('body').css('background','#E0E1E3');
	      // });
	      var params = {
	        paginationClickable: true,
	        spaceBetween: 10,
	        slidesPerView: 4.5
	      };
	
	      if (this.state.status === "focus") {
	        var input_keys = _react2.default.createElement(
	          'button',
	          { onClick: this.resetKey.bind(this), type: 'button', className: 'btn btn-default srch_btn' },
	          _react2.default.createElement('img', { className: 'img_srh', src: baseAssets + 'images/web_imgs/close_button.png', alt: '' })
	        );
	      } else {
	        input_keys = '';
	      }
	
	      if (this.props.brands.length > 0) {
	        var brands = _react2.default.createElement(
	          'h2',
	          null,
	          'Brands'
	        );
	      }
	      if (this.props.products.length > 0) {
	        var products = _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('div', { className: 'clr' }),
	          _react2.default.createElement(
	            'h2',
	            { style: { paddingTop: '10px' } },
	            'Products'
	          )
	        );
	      }
	      if (this.props.categories) {
	        if (this.props.categories.length > 0) {
	          var categories = _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('div', { className: 'clr' }),
	            _react2.default.createElement(
	              'h2',
	              { style: { paddingTop: '10px' } },
	              'Categories'
	            )
	          );
	        }
	      }
	      var trends = '';
	      if (this.props.trendings.length > 0 && !this.state.isSearched) {
	        trends = _react2.default.createElement(
	          'h2',
	          null,
	          'Trending Searches'
	        );
	      } else {
	        trends = '';
	      }
	      if (this.props.popular_brands.length > 0) {
	        var pop_brnds = _react2.default.createElement(
	          'h2',
	          null,
	          'Popular Brand Searches '
	        );
	      } else {
	        pop_brnds = '';
	      }
	      var that = this;
	      var brands_list = this.props.brands.map(function (brand, index) {
	        pop_brnds = '';
	        //trends='';
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          { to: "/pdeals/" + brand.url_dtype_name + "/" + brand.url_brand_name + "/" + brand.id + "/" + brand.type + "/" + brand.dtype, onClick: function onClick() {
	              that.saveSearch(localStorage.user_id, brand.id, 3);
	            } },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { md: 12, sm: 12, xs: 12, className: 'srh_list_item' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { md: 2, sm: 2, xs: 2, className: '' },
	              _react2.default.createElement('img', { src: brand.logo !== '' && brand.logo !== null ? baseAssets + 'images/brand_icons/' + brand.logo : baseAssets + 'icons/web_icons/noImage.png', role: 'presentation', alt: ' ', width: '20px' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { md: 10, sm: 10, xs: 10, className: '' },
	              _react2.default.createElement(
	                'div',
	                { className: 'srh_cnt_all' },
	                brand.category_name
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { md: 1, sm: 1, xs: 1, className: 'srh_deal_cnt' },
	              _react2.default.createElement(
	                'i',
	                null,
	                brand.dealcount
	              )
	            )
	          )
	        );
	      });
	      var product_list = this.props.products.map(function (product, index) {
	        // var link = this.props.params.Type;
	        //trends= '';
	        pop_brnds = '';
	        trendings_list = '';
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          { to: product.dealcount > 1 ? "/subdeals/" + product.url_dtype_name + "/" + product.url_brand_name + "/" + product.url_product_name + "/" + product.id : "/pdetails/" + product.url_dtype_name + "/" + product.url_brand_name + "/" + product.url_product_name + "/" + product.id + "/" + product.deal_id, onClick: function onClick() {
	              that.saveSearch(localStorage.user_id, product.id, 1);
	            } },
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { md: 12, sm: 12, xs: 12, className: 'srh_list_item' },
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { md: 2, sm: 2, xs: 2, className: '' },
	              _react2.default.createElement('img', { src: product.logo !== '' && product.logo !== null ? baseAssets + 'images/product_imgs/thumbnails/' + product.logo : baseAssets + 'icons/web_icons/noImage.png', alt: ' ', width: '20px' })
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { md: 10, sm: 10, xs: 10, className: '' },
	              _react2.default.createElement(
	                'div',
	                { className: 'srh_cnt_all' },
	                product.category_name
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Col,
	              { md: 1, sm: 1, xs: 1, className: 'srh_deal_cnt' },
	              _react2.default.createElement(
	                'i',
	                null,
	                product.dealcount
	              )
	            )
	          )
	        );
	      });
	
	      if (this.props.categories) {
	        if (this.props.categories.length > 0) {
	          var categories_list = this.props.categories.map(function (category, index) {
	            // var link = this.props.params.Type;
	            //trends='';
	            pop_brnds = '';
	            return _react2.default.createElement(
	              'li',
	              { className: 'cat_list_hide' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: "/pdeals/" + category.url_dtype_name + "/" + category.url_cat_name + "/" + category.id + "/" + category.type + "/" + category.dtype, onClick: function onClick() {
	                    that.saveSearch(localStorage.user_id, category.id, 2);
	                  } },
	                _react2.default.createElement('img', { src: category.logo !== '' && category.logo !== null ? baseAssets + 'images/icons/' + category.logo : baseAssets + 'icons/web_icons/noImage.png', alt: ' ', width: '20px' }),
	                category.category_name,
	                ' ',
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  category.dealcount
	                )
	              )
	            );
	          });
	        }
	      }
	
	      if (!this.state.keyword.length > 0) {
	        var trendings_list = this.props.trendings.map(function (trend, index) {
	          return _react2.default.createElement(
	            'li',
	            { className: 'trend_list_hide' },
	            trend.type === "product" ? _react2.default.createElement(
	              _reactRouter.Link,
	              { to: trend.type === "product" && trend.dealcount > 1 ? "/subdeals/" + trend.url_dtype_name + "/" + trend.url_cat_name + "/" + trend.url_product_name + "/" + trend.id : "/pdetails/" + trend.url_dtype_name + "/" + trend.url_cat_name + "/" + trend.url_product_name + "/" + trend.id + "/" + trend.deal_id },
	              _react2.default.createElement('img', { src: trend.logo !== null && trend.logo !== '' ? baseAssets + 'images/product_imgs/' + trend.logo : baseAssets + 'icons/web_icons/noImage.png', alt: '', width: '20px' }),
	              _react2.default.createElement(
	                'span',
	                { style: { position: 'relative', top: '2' } },
	                trend.category_name
	              )
	            ) : '',
	            trend.type === 'brand' ? _react2.default.createElement(
	              _reactRouter.Link,
	              { to: "/pdeals/" + trend.url_dtype_name + "/" + trend.url_name + "/" + trend.id + "/" + trend.type + "/" + trend.dtype },
	              _react2.default.createElement('img', { src: trend.logo !== '' && trend.logo !== null ? baseAssets + 'images/brand_icons/' + trend.logo : baseAssets + 'icons/web_icons/noImage.png', alt: '', width: '20px', style: { paddingLeft: '5px' } }),
	              trend.category_name
	            ) : ''
	          );
	        });
	
	        var popular_brands_list = this.props.popular_brands.map(function (brand, index) {
	          return _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: "/pdeals/" + brand.url_dtype_name + "/" + brand.url_name + "/" + brand.id + "/" + brand.type + "/" + brand.dtype_id },
	              _react2.default.createElement(
	                'p',
	                { className: 'pop_brnd_img' },
	                _react2.default.createElement('img', { src: brand.logo !== '' && brand.logo !== null ? baseAssets + 'images/brand_icons/' + brand.logo : baseAssets + 'icons/web_icons/noImage.png', alt: ' ' })
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'pop_brnd_name' },
	                brand.category_name
	              )
	            )
	          );
	        });
	
	        if (this.props.recent_search.length > 0 && this.props.recent_search.length > 3) {
	          var recent_search = this.props.recent_search.map(function (item, index) {
	            var _this2 = this;
	
	            var data = _react2.default.createElement(
	              'div',
	              { className: 'recent_search_list' },
	              item.type === "product" ? _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'span',
	                    { onClick: function onClick() {
	                        _this2.deleteSearchItem(item.del_id);
	                      } },
	                    _react2.default.createElement(_reactWebVectorIcons2.default, {
	                      name: 'close-circle',
	                      font: 'MaterialCommunityIcons',
	                      color: '#9999',
	                      size: 16,
	                      style: { position: 'absolute', right: 0, top: -3, cursor: 'pointer' }
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: item.type === "product" && item.dealcount > 1 ? "/subdeals/" + item.url_dtype_name + "/" + item.url_cat_name + "/" + item.url_name + "/" + item.id : "/pdetails/" + item.url_dtype_name + "/" + item.url_cat_name + "/" + item.url_brand_name + "/" + item.url_product_name + "/" + item.id + "/" + item.deal_id },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'recent_search_thumbnail' },
	                    _react2.default.createElement('img', { src: item.logo !== null && item.logo !== '' ? baseAssets + 'images/product_imgs/' + item.logo : baseAssets + 'icons/web_icons/noImage.png', alt: '', width: '40px' })
	                  ),
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    item.category_name
	                  )
	                )
	              ) : '',
	              item.type === 'brand' ? _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'span',
	                    { onClick: function onClick() {
	                        _this2.deleteSearchItem(item.del_id);
	                      } },
	                    _react2.default.createElement(_reactWebVectorIcons2.default, {
	                      name: 'close-circle',
	                      font: 'MaterialCommunityIcons',
	                      color: '#9999',
	                      size: 16,
	                      style: { position: 'absolute', right: 0, top: -3, cursor: 'pointer' }
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: item.url },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'recent_search_thumbnail' },
	                    _react2.default.createElement('img', { src: item.logo !== '' && item.logo !== null ? baseAssets + 'images/brand_icons/' + item.logo : baseAssets + 'icons/web_icons/noImage.png', alt: '', width: '40px' })
	                  ),
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    item.category_name
	                  )
	                )
	              ) : '',
	              item.type === 'Pcategory' ? _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'span',
	                    { onClick: function onClick() {
	                        _this2.deleteSearchItem(item.del_id);
	                      } },
	                    _react2.default.createElement(_reactWebVectorIcons2.default, {
	                      name: 'close-circle',
	                      font: 'MaterialCommunityIcons',
	                      color: '#9999',
	                      size: 16,
	                      style: { position: 'absolute', right: 0, top: -3, cursor: 'pointer' }
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/pdeals/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.id + '/Pcategory/' + item.dtype },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'recent_search_thumbnail' },
	                    _react2.default.createElement('img', { src: item.logo !== '' && item.logo !== null ? baseAssets + 'images/icons/' + item.logo : baseAssets + 'icons/web_icons/noImage.png', alt: '', width: '40px' })
	                  ),
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    item.category_name
	                  )
	                )
	              ) : ''
	            );
	            return data;
	          }.bind(this));
	        } else if (this.props.recent_search.length < 4) {
	          var recent_search = this.props.recent_search.map(function (item, index) {
	            var _this3 = this;
	
	            var data = '';
	            if (item.type === "product") {
	              data = _react2.default.createElement(
	                'li',
	                { className: 'recent_search_list' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'recent_close_icon' },
	                    _react2.default.createElement(
	                      'span',
	                      { onClick: function onClick() {
	                          _this3.deleteSearchItem(item.del_id);
	                        } },
	                      _react2.default.createElement(_reactWebVectorIcons2.default, {
	                        name: 'close-circle',
	                        font: 'MaterialCommunityIcons',
	                        color: '#9999',
	                        size: 16
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: item.type === "product" && item.dealcount > 1 ? "/subdeals/" + item.url_dtype_name + "/" + item.url_cat_name + "/" + item.url_name + "/" + item.id : "/pdetails/" + item.url_dtype_name + "/" + item.url_cat_name + "/" + item.url_name + "/" + item.id + "/" + item.deal_id },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'recent_search_thumbnail' },
	                      _react2.default.createElement('img', { src: item.logo !== null && item.logo !== '' ? baseAssets + 'images/product_imgs/' + item.logo : baseAssets + 'icons/web_icons/noImage.png', alt: '', width: '40px' })
	                    ),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      item.category_name
	                    )
	                  )
	                )
	              );
	            }
	            if (item.type === "brand") {
	              alert(item.type);
	              data = _react2.default.createElement(
	                'li',
	                { className: 'recent_search_list' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'recent_close_icon' },
	                    _react2.default.createElement(
	                      'span',
	                      { onClick: function onClick() {
	                          _this3.deleteSearchItem(item.del_id);
	                        } },
	                      _react2.default.createElement(_reactWebVectorIcons2.default, {
	                        name: 'close-circle',
	                        font: 'MaterialCommunityIcons',
	                        color: '#9999',
	                        size: 16
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: "/pdeals/" + item.url_dtype_name + "/" + item.url_name + "/" + item.id + "/" + item.type + "/" + item.dtype },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'recent_search_thumbnail' },
	                      _react2.default.createElement('img', { src: item.logo !== '' && item.logo !== null ? baseAssets + 'images/brand_icons/' + item.logo : baseAssets + 'icons/web_icons/noImage.png', alt: '', width: '40px' })
	                    ),
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      item.category_name
	                    )
	                  )
	                )
	              );
	            }
	            if (item.type === "Pcategory") {
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'recent_close_icon' },
	                  _react2.default.createElement(
	                    'span',
	                    { onClick: function onClick() {
	                        _this3.deleteSearchItem(item.del_id);
	                      } },
	                    _react2.default.createElement(_reactWebVectorIcons2.default, {
	                      name: 'close-circle',
	                      font: 'MaterialCommunityIcons',
	                      color: '#9999',
	                      size: 16
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/pdeals/' + item.url_dtype_name + '/' + item.url_cat_name + '/' + item.id + '/Pcategory/' + item.dtype },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'recent_search_thumbnail' },
	                    _react2.default.createElement('img', { src: item.logo !== '' && item.logo !== null ? baseAssets + 'images/icons/' + item.logo : baseAssets + 'icons/web_icons/noImage.png', alt: '', width: '40px' })
	                  ),
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    item.category_name
	                  )
	                )
	              );
	            }
	            return data;
	          }.bind(this));
	        } else {
	          recent_search = '';
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'mob_deals mob_search_page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page_hdr' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'page_hdr' },
	              _react2.default.createElement(
	                'div',
	                { className: 'container-fluid' },
	                _react2.default.createElement(
	                  'h5',
	                  { style: { float: 'left', paddingTop: '10px' } },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: "/" },
	                    _react2.default.createElement(
	                      'i',
	                      null,
	                      _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'hdr_srch' },
	                  _react2.default.createElement(
	                    'form',
	                    { className: 'navbar-form navbar-left' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-group' },
	                      _react2.default.createElement('input', { id: 'srh_input_box', ref: 'keyword', onChange: this.onChangeKey.bind(this), onFocus: this.onFocus.bind(this), onBlur: this.onBlur.bind(this), value: this.state.keyword, className: 'form-control', placeholder: 'Search brands, products and categories' })
	                    ),
	                    input_keys
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          '\xA0'
	        ),
	        this.props.isLoading ? _react2.default.createElement(
	          'div',
	          { className: 'pag_cntnt srch_page pag_cntnt2 ', style: { backgroundColor: '#e0e1e3', marginTop: '10px' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid' },
	            (this.props.brands.length > 0 || this.props.products.length > 0 || this.props.categories.length > 0) && this.state.isSearched ? _react2.default.createElement(
	              'div',
	              { className: '', style: { backgroundColor: '#fff', padding: '8px' }, id: 'srh_all_list' },
	              brands ? _react2.default.createElement(
	                'div',
	                null,
	                brands
	              ) : '',
	              this.props.brands.length > 0 ? _react2.default.createElement(
	                'ul',
	                { style: { paddingBottom: '1px' } },
	                brands_list
	              ) : '',
	              products ? _react2.default.createElement(
	                'div',
	                null,
	                products
	              ) : '',
	              this.props.products.length > 0 ? _react2.default.createElement(
	                'ul',
	                { style: { paddingBottom: '5px' } },
	                product_list
	              ) : '',
	              categories ? _react2.default.createElement(
	                'div',
	                null,
	                categories
	              ) : '',
	              categories_list ? _react2.default.createElement(
	                'ul',
	                { style: { marginBottom: '10px', overflow: 'hidden' } },
	                categories_list
	              ) : ''
	            ) : '',
	            this.props.recent_search.length > 0 ? _react2.default.createElement(
	              'div',
	              { className: 'recent_search_blk' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'Recent Searches'
	                )
	              ),
	              this.props.recent_search.length > 3 ? _react2.default.createElement(
	                _reactIdSwiper2.default,
	                _extends({}, params, { key: recent_search.length }),
	                recent_search
	              ) : _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'recent_search_ul' },
	                  recent_search
	                )
	              )
	            ) : '',
	            this.props.trendings.length > 0 && !this.state.isSearched ? _react2.default.createElement(
	              'div',
	              { className: 'trnd_blk', style: { backgroundColor: '#fff', padding: '10px' } },
	              trends ? _react2.default.createElement(
	                'div',
	                null,
	                trends
	              ) : '',
	              trendings_list ? _react2.default.createElement(
	                'ul',
	                { style: { paddingLeft: '8px' } },
	                trendings_list
	              ) : ''
	            ) : '',
	            this.props.popular_brands.length > 0 ? _react2.default.createElement(
	              'div',
	              { className: 'pop_brnds_blk', style: { backgroundColor: '#fff', marginTop: '10px' } },
	              popular_brands_list ? _react2.default.createElement(
	                'div',
	                null,
	                pop_brnds
	              ) : '',
	              popular_brands_list ? _react2.default.createElement(
	                'ul',
	                { className: 'popular_brnds_lst' },
	                popular_brands_list
	              ) : ''
	            ) : ''
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'mob_loading' },
	          _react2.default.createElement('img', { src: __webpack_require__(648), alt: 'Loading', role: 'presentation' })
	        ),
	        this.props.brands.length == 0 && this.props.products.length == 0 && this.props.categories.length == 0 && this.state.isSearched && this.props.isLoading ? _react2.default.createElement(
	          'div',
	          { className: 'mob_loading no_deals_search' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'No Deals Available'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/home' },
	            _react2.default.createElement(
	              'button',
	              null,
	              'Browse Other Deals'
	            )
	          )
	        ) : ''
	      );
	    }
	  }]);
	
	  return Search;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    search: state.posts.search,
	    brands: state.posts.brands,
	    products: state.posts.products,
	    categories: state.posts.categories,
	    trendings: state.posts.trendings,
	    popular_brands: state.posts.popular_brands,
	    recent_search: state.posts.recent_search,
	    isLoading: state.posts.isLoading
	  };
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Search);

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactShare = __webpack_require__(18);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _footer = __webpack_require__(50);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Share_Earn = function (_Component) {
		_inherits(Share_Earn, _Component);
	
		function Share_Earn(props) {
			_classCallCheck(this, Share_Earn);
	
			var _this = _possibleConstructorReturn(this, (Share_Earn.__proto__ || Object.getPrototypeOf(Share_Earn)).call(this, props));
	
			_this.state = {
				balance: 0,
				code: '',
				refferal_cash: 0,
				frnd_cash: 0,
				tot_amt: 0,
				image: '',
				status: '',
	
				open: true,
				open2: true,
				shareUrl: '',
				msg: '',
				url: ''
			};
			_this.getShareDetails = _this.getShareDetails.bind(_this);
			_this.shareEarn = _this.shareEarn.bind(_this);
			return _this;
		}
	
		_createClass(Share_Earn, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				// localStorage.setItem('share_earn','/share_earn');
				if (screen.width >= 800) {
					window.location.href = "/web/share_earn";
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('share_earn', '/share_earn');
					_reactRouter.browserHistory.push('/login');
				} else {
					this.getShareDetails();
					this.shareEarn();
				}
			}
		}, {
			key: 'shareEarn',
			value: function shareEarn() {
				// this.setState({
				// 	open: !this.state.open,
				// });
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + 'shareAppurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							msg: data.share_data,
							url: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getShareDetails',
			value: function getShareDetails() {
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + 'referAndEarn',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							balance: data.balance,
							code: data.code,
							refferal_cash: data.refferal_cash,
							frnd_cash: data.frnd_cash,
							tot_amt: data.tot_amt,
							image: data.image,
							status: data.status
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'chatnow',
			value: function chatnow() {
				this.shareEarn();
				location.href = "https://wa.me?text=" + this.state.msg;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				document.title = "Share & Earn | AquaDeals";
				var msg = this.state.msg;
				var url = this.state.url;
				// var sh_url=this.state.msg;
				var description = this.state.msg;
				if (this.state.msg !== '') {
					var title = this.state.msg;
				} else {
					// title="Hey! Use my code "+code+ "to signup and get Rs2000 AquaCash. Click https:\/\/goo.gl\/gvP4pb to download the AquaDeals Android app";
					title = msg;
				}
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals mob_share_earnpage' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: "/" },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/close_icon1.png', className: 'cross_icon', width: '14px', alt: ' ' })
									),
									' ',
									_react2.default.createElement(
										'span',
										{ className: 'header_text' },
										'Share & Earn'
									)
								)
							),
							_react2.default.createElement(
								'a',
								{ href: '/', className: 'home_logo1' },
								_react2.default.createElement('img', { src: baseAssets + 'mob-assets/home1.png', alt: 'Home' })
							)
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'container-fluid' },
						_react2.default.createElement(
							'div',
							{ className: 'row lst_img' },
							_react2.default.createElement('img', { src: baseAssets + 'images/promo_offers/20170116202638300621.png', alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'h4',
								{ className: 'share_invite_header' },
								'Total referral earnings: \u20B9',
								this.state.tot_amt
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12 col-sm-12 col-xs-12 share_earn_blk' },
								_react2.default.createElement(
									'div',
									{ className: '' },
									_react2.default.createElement(
										'h5',
										null,
										'Your referral code'
									),
									_react2.default.createElement(
										'button',
										{ className: 'sh_ern_code' },
										this.state.code
									),
									_react2.default.createElement(
										'button',
										{ onClick: function onClick() {
												_this2.chatnow();
											} },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/refer_share.png', alt: 'share', width: '30px' })
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ style: { clear: 'both' } },
								_react2.default.createElement(
									'p',
									{ className: 'share_invite_msg' },
									'Invite your friends'
								),
								_react2.default.createElement(
									_reactBootstrap.Panel,
									{ className: 'share_earn_panel', collapsible: true, expanded: this.state.open2 },
									_react2.default.createElement(
										FacebookShareButton,
										{ url: url, title: title, className: 'test_earn_share' },
										_react2.default.createElement(FacebookIcon, { size: 50, round: true })
									),
									_react2.default.createElement(
										TwitterShareButton,
										{ url: url, title: title, description: description, className: 'test_earn_share' },
										_react2.default.createElement(TwitterIcon, { size: 50, round: true })
									),
									_react2.default.createElement(
										'section',
										{ className: 'test_earn_share', id: 'wb_circle', onClick: function onClick() {
												_this2.chatnow();
											} },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: __webpack_require__(157), width: '30', alt: '' })
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							)
						)
					)
				);
			}
		}]);
	
		return Share_Earn;
	}(_react.Component);
	
	exports.default = Share_Earn;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(632);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var SiteMap = function (_Component) {
	  _inherits(SiteMap, _Component);
	
	  function SiteMap(props) {
	    _classCallCheck(this, SiteMap);
	
	    var _this = _possibleConstructorReturn(this, (SiteMap.__proto__ || Object.getPrototypeOf(SiteMap)).call(this, props));
	
	    _this.state = {
	      todos: [],
	      isLoaded: false
	    };
	    return _this;
	  }
	
	  _createClass(SiteMap, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _jquery2.default.ajax({
	        url: baseUrl + "web_site_map",
	        dataType: "json",
	        success: function (data) {
	          this.setState({
	            todos: data
	          });
	        }.bind(this)
	
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var categories = _jquery2.default.makeArray(this.state.todos.products);
	
	      var categories_list = categories.map(function (list, index) {
	        return _react2.default.createElement(
	          'li',
	          { key: index },
	          _react2.default.createElement(
	            'h1',
	            { className: 'list_hdg' },
	            list.cname
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'list_blk' },
	            list.scat.map(function (sclist, index1) {
	              return _react2.default.createElement(
	                'li',
	                { key: index1 },
	                _react2.default.createElement(
	                  'a',
	                  { href: sclist.sclink },
	                  sclist.scname
	                )
	              );
	            })
	          )
	        );
	      });
	
	      document.title = "AquaDeals - Online AquaCulture MarketPlace, Find best deals on Seed, Feed, Health Care, Machinery & Farm Equipments, Products, Ropes & Nets Paddle Wheels and More | AquaDeals";
	      document.getElementsByTagName("META")[2].content = "It is a place for deals related to Aqua culture";
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'mob_deals mob_advertise_page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page_hdr' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { onClick: function onClick() {
	                    _reactRouter.browserHistory.goBack();
	                  } },
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
	                )
	              ),
	              'Advertise With Us'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '/home', className: 'home_logo1' },
	              _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pag_cntnt' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid mob_advertise_blk' },
	          _react2.default.createElement(
	            'div',
	            { align: 'center' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'st_mp_hdg' },
	              'Catalogue'
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'myclass' },
	              categories_list
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SiteMap;
	}(_react.Component);
	
	exports.default = SiteMap;

/***/ },
/* 524 */
463,
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import {Link} from 'react-router';
	
	
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Close_ad = function (_Component) {
	  _inherits(Close_ad, _Component);
	
	  function Close_ad(props) {
	    _classCallCheck(this, Close_ad);
	
	    var _this = _possibleConstructorReturn(this, (Close_ad.__proto__ || Object.getPrototypeOf(Close_ad)).call(this, props));
	
	    _this.state = {
	      showOpenApp: "",
	      showCloseApp: 1
	    };
	    return _this;
	  }
	
	  _createClass(Close_ad, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var checkCloseAd = this.getCookie('closeAd');
	      if (typeof checkCloseAd === "undefined") {
	        this.state.showCloseApp = 0;
	      }
	    }
	  }, {
	    key: 'show_footer',
	    value: function show_footer() {
	      this.setState({ showOpenApp: "close" });
	      this.createCookie('closeAd', 1, 1);
	      var closeAd = this.getCookie('closeAd');
	      //console.log(closeAd);
	      this.setState({ showCloseApp: closeAd });
	    }
	  }, {
	    key: 'createCookie',
	    value: function createCookie(name, value, days) {
	      var date, expires;
	      if (days) {
	        date = new Date();
	        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	        expires = "; expires=" + date.toGMTString();
	      } else {
	        expires = "";
	      }
	      document.cookie = name + "=" + value + expires + "; path=/";
	    }
	  }, {
	    key: 'getCookie',
	    value: function getCookie(name) {
	      var value = "; " + document.cookie;
	      var parts = value.split("; " + name + "=");
	      if (parts.length === 2) return parts.pop().split(";").shift();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var footer = '';
	      if (this.state.showCloseApp === 0) {
	
	        footer = _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-8 col-xs-8 col-sm-8 desc-div' },
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-container-smart-banner' },
	              _react2.default.createElement('img', { onClick: this.show_footer.bind(this), className: 'smart-close-btn-android', src: 'https://www.bigbasket.com/content/images/svg/android-close.svg' }),
	              _react2.default.createElement('img', { className: 'smart-logo logo-android', src: 'https://aquadeals.in/admin/assets/images/web_imgs/ad_icon.png' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-column-container-smart-banner' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'smart-desc' },
	                  'Experience AquaDeals Mobile App'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-4 col-xs-4 col-sm-4 flex-container-smart-banner' },
	            _react2.default.createElement(
	              'div',
	              { className: 'android-use-btn' },
	              _react2.default.createElement(
	                'a',
	                { href: 'https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en' },
	                _react2.default.createElement('img', { className: 'smart-logo logo-android', src: 'https://aquadeals.in/admin/assets/images/web_imgs/get_app_icon.png' })
	              )
	            )
	          )
	        );
	      } else {
	        footer = '';
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        footer
	      );
	    }
	  }]);
	
	  return Close_ad;
	}(_react.Component);
	
	exports.default = Close_ad;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _footer = __webpack_require__(50);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var CustomerCare_Seller = function (_Component) {
	  _inherits(CustomerCare_Seller, _Component);
	
	  function CustomerCare_Seller(props) {
	    _classCallCheck(this, CustomerCare_Seller);
	
	    var _this = _possibleConstructorReturn(this, (CustomerCare_Seller.__proto__ || Object.getPrototypeOf(CustomerCare_Seller)).call(this, props));
	
	    _this.state = {
	      email: '',
	      mobiles: '',
	      timings: ''
	    };
	    return _this;
	  }
	
	  _createClass(CustomerCare_Seller, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (screen.width >= 800) {
	        window.location.href = "/web/customer_care_seller";
	      }
	      var data1 = { from: 'mobile_web', user_id: localStorage.user_id };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getSellerSupportDetails',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            email: data.email,
	            timings: data.timings,
	            mobiles: data.phone,
	            username: data.username
	          });
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      document.title = "Customer Care Partner | AquaDeals";
	      return _react2.default.createElement(
	        'div',
	        { className: 'mob_deals customer_care_page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page_hdr' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { onClick: function onClick() {
	                    _reactRouter.browserHistory.goBack();
	                  } },
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
	                )
	              ),
	              'Customer Care Partner'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '/', className: 'home_logo1' },
	              _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pag_cntnt customer_care' },
	          _react2.default.createElement(
	            'div',
	            { className: 'clr' },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'mod_cc_bg' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('img', { src: __webpack_require__(255), height: '160', alt: '...' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mob_cc_image' },
	              _react2.default.createElement('img', { src: __webpack_require__(107), alt: '...' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'section',
	                { id: 'cc_content_block' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Dear ',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    this.state.username
	                  ),
	                  ' ,'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { id: 'cc_cnt' },
	                  'If you have any questions or concerns about our products or services, feel free to contact our Customer Support team.'
	                )
	              ),
	              _react2.default.createElement(
	                'section',
	                { id: 'cc_contact_list' },
	                _react2.default.createElement(
	                  'a',
	                  { href: "mailto:" + this.state.email },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement('img', { src: __webpack_require__(108) })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      this.state.email
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', { src: __webpack_require__(109) })
	                  ),
	                  _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.state.mobiles } })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', { src: __webpack_require__(111) })
	                  ),
	                  this.state.timings
	                )
	              ),
	              this.state.zendesk_flag == 1 ? _react2.default.createElement(
	                'section',
	                { id: 'cc_wb_div' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'cc_wb_btn', onClick: function onClick() {
	                      _this2.chatnow();
	                    } },
	                  _react2.default.createElement(
	                    'span',
	                    { id: 'cnt_wb_icon' },
	                    _react2.default.createElement('img', { src: __webpack_require__(157), width: '20' })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'CHAT NOW'
	                  )
	                )
	              ) : ''
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CustomerCare_Seller;
	}(_react.Component);
	
	exports.default = CustomerCare_Seller;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(139);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(138);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import {Link, browserHistory } from 'react-router';
	// import $ from 'jquery';
	
	
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var downloads = function (_Component) {
		_inherits(downloads, _Component);
	
		function downloads() {
			_classCallCheck(this, downloads);
	
			return _possibleConstructorReturn(this, (downloads.__proto__ || Object.getPrototypeOf(downloads)).apply(this, arguments));
		}
	
		_createClass(downloads, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					window.location.href = "/web/downloads";
				}
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = "AquaDeals Downloads";
				return _react2.default.createElement(
					'div',
					{ className: 'web_deals web_downloads_page' },
					_react2.default.createElement(_Header2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'featr_blk' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-3' },
									_react2.default.createElement('img', { className: 'mob_splsh_img', src: baseAssets + "images/splash_mob.png", alt: '' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-9' },
									_react2.default.createElement(
										'h3',
										null,
										'Features'
									),
									_react2.default.createElement(
										'p',
										null,
										'For fast and safe orders of Seed, Feed, Health Care, Machinery & Farm Equipment experience the AquaDeals app on your Android phone and order on the GO! We are sure you will find the best deals every time. Invite your Contacts and get AquaCash. Refer your friends to download the AquaDeals app, sign up using your referral code and earn Rs.2000 AquaCash. Your friend gets Rs.2000 AquaCash. And there\u2019s more.'
									),
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-4 col-sm-4 featrs' },
											_react2.default.createElement('img', { src: baseAssets + "images/deals.png", alt: '' }),
											_react2.default.createElement(
												'h4',
												null,
												'Deals'
											),
											_react2.default.createElement(
												'p',
												null,
												'Search several deals on Seed, Feed, Machinery etc right from your mobile deals on Seed.'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-4 col-sm-4 featrs' },
											_react2.default.createElement('img', { src: baseAssets + "images/sp_offers.png", alt: '' }),
											_react2.default.createElement(
												'h4',
												null,
												'Special Offers'
											),
											_react2.default.createElement(
												'p',
												null,
												'Celebrate the best of offers that you can ever get for your aqua business. Profit, Share, WalletUp!'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-4 col-sm-4 featrs' },
											_react2.default.createElement('img', { src: baseAssets + "images/refer_earn.png", alt: '' }),
											_react2.default.createElement(
												'h4',
												null,
												'Refer & Earn'
											),
											_react2.default.createElement(
												'p',
												null,
												'Fill your wallet with the magical AquaCash by just sharing with your friends across.'
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'container qr_codes' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-4 col-sm-4 qr_blk' },
								_react2.default.createElement('img', { className: 'qr_img', src: baseAssets + "images/google_play_qr.png", alt: '' }),
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										'a',
										{ href: 'https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en', target: '_blank' },
										'Google Play'
									)
								),
								_react2.default.createElement('img', { className: 'qr_icon', src: baseAssets + "images/google_play.png", alt: '' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-4 col-sm-4 qr_blk' },
								_react2.default.createElement('img', { className: 'qr_img', src: baseAssets + "images/mobile_web_qr.png", alt: '' }),
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										'a',
										{ href: 'http://aquadeals.in', target: '_blank' },
										'aquadeals.in'
									)
								),
								_react2.default.createElement('img', { className: 'qr_icon qr_mob_icon', src: baseAssets + "images/mobile_web.png", alt: '' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-4 col-sm-4 qr_blk' },
								_react2.default.createElement('img', { className: 'qr_img', src: baseAssets + "images/desktop_web_qr.png", alt: '' }),
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										'a',
										{ href: 'http://aquadeals.in/web', target: '_blank' },
										'aquadeals.in/web'
									)
								),
								_react2.default.createElement('img', { className: 'qr_icon', src: baseAssets + "images/desktop_web.png", alt: '' })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'sam_scner' },
							_react2.default.createElement(
								'div',
								{ className: 'container' },
								_react2.default.createElement(
									'div',
									{ className: 'media' },
									_react2.default.createElement(
										'div',
										{ className: 'media-left' },
										_react2.default.createElement(
											'a',
											{ href: 'https://play.google.com/store/apps/details?id=com.nyros.scanner&hl=en', target: '_blank', className: 'sam_scan_blk' },
											_react2.default.createElement('img', { className: 'media-object', src: baseAssets + "images/qr_app_icon.png", alt: '' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'media-body' },
										_react2.default.createElement(
											'h4',
											{ className: 'media-heading' },
											'Simple QR Bar Code Scanner'
										),
										_react2.default.createElement(
											'p',
											null,
											'Simple scanner allows you scan bar codes, QR codets easily. This app is without any Ad which allows you to browse every feature seamlessly. You can create QR codes and share it instantly with your friends. '
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_Footer2.default, null)
				);
			}
		}]);
	
		return downloads;
	}(_react.Component);
	
	exports.default = downloads;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var PromoOfr_Details = function (_Component) {
		_inherits(PromoOfr_Details, _Component);
	
		function PromoOfr_Details(props) {
			_classCallCheck(this, PromoOfr_Details);
	
			var _this = _possibleConstructorReturn(this, (PromoOfr_Details.__proto__ || Object.getPrototypeOf(PromoOfr_Details)).call(this, props));
	
			_this.state = {
				title: '',
				description: '',
				terms: '',
				enddate: '',
				discount_type: '',
				image: '',
				details: [],
				share_title: '',
				share_desc: '',
				share_panel_open: false
			};
			return _this;
		}
	
		_createClass(PromoOfr_Details, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					window.location.href = '/web/offer/' + this.props.params.Oid + '/details';
				}
				if (!localStorage.token && !localStorage.user_id) {
					localStorage.setItem('pro_ofr_dtls', '/offer/' + this.props.params.Oid + "/details");
				}
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), ofr_id: this.props.params.Oid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + "get_promo_ofr",
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						var details = _jquery2.default.makeArray(data.data);
	
						this.setState({
							details: details,
							title: details[0].title,
							image: details[0].image,
							description: details[0].description,
							terms: details[0].terms,
							enddate: details[0].endDate,
							discount_type: details[0].discount_type,
							share_panel_open: false
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = this.state.title ? this.state.title + ' | AquaDeals' : 'Offer Details | AquaDeals';
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals ofr_full_details_page' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: "/" },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
									)
								),
								this.state.title ? this.state.title : 'Offer Details'
							),
							_react2.default.createElement(
								'a',
								{ href: '/', className: 'home_newicon' },
								_react2.default.createElement('img', { src: baseAssets + 'mob-assets/home1.png', alt: 'Home' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'container', style: { marginTop: '10px' } },
						_react2.default.createElement(
							'div',
							{ className: 'row lst_img' },
							_react2.default.createElement('img', { src: baseAssets + 'images/promo_offers/' + this.state.image, alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12 col-sm-12 col-xs-12' },
								_react2.default.createElement(
									'h4',
									{ className: 'ofr_title' },
									this.state.title
								),
								_react2.default.createElement(
									'table',
									{ className: 'table' },
									_react2.default.createElement(
										'tr',
										null,
										_react2.default.createElement(
											'th',
											null,
											'Applicable On'
										),
										_react2.default.createElement(
											'th',
											null,
											'Offer valid till'
										)
									),
									_react2.default.createElement(
										'tr',
										null,
										_react2.default.createElement(
											'td',
											null,
											this.state.discount_type
										),
										_react2.default.createElement(
											'td',
											null,
											this.state.enddate !== '' ? this.state.enddate : 'Limited period offer'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'container', style: { marginTop: '8px' } },
						_react2.default.createElement(
							'h4',
							null,
							'Description'
						),
						_react2.default.createElement(
							'p',
							{ className: 'ofr_desc' },
							this.state.description
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'container-fluid', style: { marginTop: '8px' } },
						_react2.default.createElement(
							'h4',
							null,
							'Terms & Conditions'
						),
						_react2.default.createElement('div', { className: 'modal_ofr_terms', dangerouslySetInnerHTML: { __html: this.state.terms } })
					)
				);
			}
		}]);
	
		return PromoOfr_Details;
	}(_react.Component);
	
	exports.default = PromoOfr_Details;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactShare = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var PromoOffersZone = function (_Component) {
		_inherits(PromoOffersZone, _Component);
	
		function PromoOffersZone() {
			_classCallCheck(this, PromoOffersZone);
	
			var _this = _possibleConstructorReturn(this, (PromoOffersZone.__proto__ || Object.getPrototypeOf(PromoOffersZone)).call(this));
	
			_this.state = {
				key: 1,
				gen_offers: [],
				seed_offers: [],
				product_offers: [],
				gen_offers_status: true,
				seed_offers_status: true,
				product_offers_status: true,
				modal_gen: false,
				modal_seed: false,
				modal_feed: false
			};
			_this.handleSelect = _this.handleSelect.bind(_this);
			return _this;
		}
	
		_createClass(PromoOffersZone, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					window.location.href = "/web/offerszone";
				}
				if (!localStorage.token && !localStorage.user_id) {
	
					localStorage.setItem('ofr_page', '/offerszone');
					// browserHistory.push('/login');
				}
	
				var data1 = { from: 'mobile_web', uid: localStorage.getItem('user_id'), token: localStorage.getItem('token'), tab: 'general' };
				var data2 = JSON.stringify(data1);
				var data3 = { from: 'mobile_web', uid: localStorage.getItem('user_id'), token: localStorage.getItem('token'), tab: 'seed' };
				var data4 = JSON.stringify(data3);
				var data5 = { from: 'mobile_web', uid: localStorage.getItem('user_id'), token: localStorage.getItem('token'), tab: 'product' };
				var data6 = JSON.stringify(data5);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getPromoOffers',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
	
						if (data.status === 'available') {
							this.setState({
								gen_offers: data.offers
							});
						} else {
							this.setState({
								gen_offers_status: false
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getPromoOffers',
					dataType: 'json',
					data: { req: data4 },
					success: function (data) {
						if (data.status === 'available') {
							this.setState({
								seed_offers: data.offers
							});
						} else {
							this.setState({
								seed_offers_status: false
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getPromoOffers',
					dataType: 'json',
					data: { req: data6 },
					success: function (data) {
						if (data.status === 'available') {
							this.setState({
								product_offers: data.offers
							});
						} else {
							this.setState({
								product_offers_status: false
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'handleSelect',
			value: function handleSelect(key) {
				this.setState({
					key: key
				});
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = "Offers Zone | AquaDeals";
				document.getElementsByTagName("META")[2].content = "AquaDeals Offers Zone";
				var gen_offers = '';
				var seed_offers = '';
				var product_offers = '';
	
				if (this.state.gen_offers_status) {
					gen_offers = this.state.gen_offers.map(function (offer, index) {
						return _react2.default.createElement(GenOffers, { key: offer.id, data: offer });
					});
				} else {
					gen_offers = _react2.default.createElement(
						'div',
						{ className: 'no_offers' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: "/customer_care" },
							_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/cc_orange_offers.png', width: '33px', alt: ' ' }),
							_react2.default.createElement(
								'p',
								{ className: 'ofr_care' },
								'Call customer care for best offers.'
							)
						)
					);
				}
	
				if (this.state.seed_offers_status) {
					seed_offers = this.state.seed_offers.map(function (offer, index) {
						return _react2.default.createElement(SeedOffers, { key: offer.id, data: offer });
					});
				} else {
					seed_offers = _react2.default.createElement(
						'div',
						{ className: 'no_offers' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: "/customer_care" },
							_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/cc_orange_offers.png', width: '33px', alt: ' ' }),
							_react2.default.createElement(
								'p',
								{ className: 'ofr_care' },
								'Call customer care for best offers.'
							)
						)
					);
				}
				if (this.state.product_offers_status) {
					product_offers = this.state.product_offers.map(function (offer, index) {
						return _react2.default.createElement(ProductOffers, { key: offer.id, data: offer });
					});
				} else {
					product_offers = _react2.default.createElement(
						'div',
						{ className: 'no_offers' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: "/customer_care" },
							_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/cc_orange_offers.png', width: '33px', alt: ' ' }),
							_react2.default.createElement(
								'p',
								{ className: 'ofr_care' },
								'Call customer care for best offers.'
							)
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals mob_offerszone' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: "/" },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
									)
								),
								'Offers Zone'
							),
							_react2.default.createElement(
								'a',
								{ href: '/', className: 'home_newicon' },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'pag_cntnt' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'container-fluid' },
						_react2.default.createElement(
							_reactBootstrap.Tabs,
							{ activeKey: this.state.key, onSelect: this.handleSelect, id: 'controlled-tab-example' },
							_react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 1, title: 'AD OFFERS' },
								gen_offers
							),
							_react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 2, title: 'SEED' },
								seed_offers
							),
							_react2.default.createElement(
								_reactBootstrap.Tab,
								{ eventKey: 3, title: 'PRODUCTS' },
								product_offers
							)
						)
					)
				);
			}
		}]);
	
		return PromoOffersZone;
	}(_react.Component);
	
	exports.default = PromoOffersZone;
	
	var GenOffers = function (_Component2) {
		_inherits(GenOffers, _Component2);
	
		function GenOffers(props) {
			_classCallCheck(this, GenOffers);
	
			var _this2 = _possibleConstructorReturn(this, (GenOffers.__proto__ || Object.getPrototypeOf(GenOffers)).call(this, props));
	
			_this2.state = {
				modal_gen: false,
				offers: _this2.props.data,
				title: '',
				description: '',
				terms: '',
				discount_type: '',
				details: [],
				share_title: '',
				share_desc: '',
				share_panel_open: false,
				enddate: ''
			};
			_this2.close = _this2.close.bind(_this2);
			_this2.getPromoDetails = _this2.getPromoDetails.bind(_this2);
			_this2.getInvite = _this2.getInvite.bind(_this2);
			return _this2;
		}
	
		_createClass(GenOffers, [{
			key: 'getPromoDetails',
			value: function getPromoDetails(offer_id) {
	
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), ofr_id: offer_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + "get_promo_ofr",
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						var details = _jquery2.default.makeArray(data.data);
	
						window.test = details;
						this.setState({
							details: details,
							title: details[0].title,
							description: details[0].description,
							terms: details[0].terms,
							discount_type: details[0].discount_type,
							share_panel_open: false,
							enddate: details[0].endDate
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({ modal_gen: false });
			}
		}, {
			key: 'getInvite',
			value: function getInvite() {
	
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + 'shareAppurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
	
						this.setState({
							share_title: data.share_data,
							share_desc: data.share_data,
							share_panel_open: !this.state.share_panel_open
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var offers = this.props.data;
				var shareUrl = 'http://tinyurl.com/aquadotdeals';
	
				return _react2.default.createElement(
					'div',
					{ className: 'offers_block' },
					_react2.default.createElement(
						_reactRouter.Link,
						null,
						_react2.default.createElement(
							'div',
							{ className: 'offer_info', onClick: function onClick() {
									_this3.setState({ modal_gen: true });
								} },
							_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/info.png', width: '20px', alt: '' })
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement('img', { onClick: function onClick() {
									_this3.setState({ modal_gen: true });
								}, src: !offers.image ? baseAssets + "images/ad_imgs/placeholder_bg.png" : baseAssets + "images/promo_offers/" + offers.image, alt: '' })
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ onEntered: function onEntered() {
								_this3.getPromoDetails(offers.id);
							}, className: 'Offer_modal', show: this.state.modal_gen, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ className: 'modal_offer_header', closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#fff' } },
								'Offer Details'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							{ className: 'modal_details_block' },
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_title' },
								this.state.title
							),
							_react2.default.createElement(
								'h6',
								{ className: 'modal_ofr_applicable' },
								'Applicable On: ',
								this.state.discount_type
							),
							_react2.default.createElement(
								'p',
								{ className: 'modal_ofr_period' },
								this.state.enddate !== '' ? this.state.enddate : 'Limited period offer'
							),
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_desc_title' },
								'Description'
							),
							_react2.default.createElement(
								'p',
								{ className: 'modal_ofr_desc' },
								this.state.description
							),
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_terms_title' },
								'Terms and Conditions'
							),
							_react2.default.createElement('div', { className: 'modal_ofr_terms', dangerouslySetInnerHTML: { __html: this.state.terms } }),
							offers.id === '2' ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'ofr_invite_btn' },
									_react2.default.createElement(
										'a',
										{ onClick: function onClick() {
												_this3.getInvite();
											} },
										'INVITE NOW'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'ofr_share_panel' },
									_react2.default.createElement(
										_reactBootstrap.Panel,
										{ className: '', style: { marginLeft: '30%' }, collapsible: true, expanded: this.state.share_panel_open },
										_react2.default.createElement(
											FacebookShareButton,
											{ url: shareUrl, title: this.state.share_title, className: 'test_share2' },
											_react2.default.createElement(FacebookIcon, { size: 32, round: true })
										),
										_react2.default.createElement(
											TwitterShareButton,
											{ url: shareUrl, title: this.state.share_title, description: shareUrl, className: 'test_share2' },
											_react2.default.createElement(TwitterIcon, { size: 32, round: true })
										),
										_react2.default.createElement(
											GooglePlusShareButton,
											{ url: shareUrl, title: this.state.share_title, description: shareUrl, className: 'test_share2' },
											_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
										)
									)
								)
							) : '',
							offers.id === '15' ? _react2.default.createElement(
								'div',
								{ className: 'gen_ofr_rate_btn' },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: '/myorders' },
									'RATE NOW'
								)
							) : ''
						)
					)
				);
			}
		}]);
	
		return GenOffers;
	}(_react.Component);
	
	var SeedOffers = function (_Component3) {
		_inherits(SeedOffers, _Component3);
	
		function SeedOffers(props) {
			_classCallCheck(this, SeedOffers);
	
			var _this4 = _possibleConstructorReturn(this, (SeedOffers.__proto__ || Object.getPrototypeOf(SeedOffers)).call(this, props));
	
			_this4.state = {
				modal_gen: false,
				offers: _this4.props.data,
				title: '',
				description: '',
				terms: '',
				discount_type: '',
				details: [],
				share_title: '',
				share_desc: '',
				share_panel_open: false
			};
			_this4.close = _this4.close.bind(_this4);
			_this4.getPromoDetails = _this4.getPromoDetails.bind(_this4);
			_this4.getInvite = _this4.getInvite.bind(_this4);
			return _this4;
		}
	
		_createClass(SeedOffers, [{
			key: 'getPromoDetails',
			value: function getPromoDetails(offer_id) {
	
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), ofr_id: offer_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + "get_promo_ofr",
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						var details = _jquery2.default.makeArray(data.data);
						window.test = details;
						this.setState({
							details: details,
							title: details[0].title,
							description: details[0].description,
							terms: details[0].terms,
							discount_type: details[0].discount_type,
							share_panel_open: false
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({ modal_gen: false });
			}
		}, {
			key: 'getInvite',
			value: function getInvite() {
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + 'shareAppurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
	
						this.setState({
							share_title: data.share_data,
							share_desc: data.share_data,
							share_panel_open: !this.state.share_panel_open
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var offers = this.props.data;
				var shareUrl = 'http://tinyurl.com/aquadotdeals';
				return _react2.default.createElement(
					'div',
					{ className: 'offers_block' },
					_react2.default.createElement(
						_reactRouter.Link,
						null,
						_react2.default.createElement(
							'div',
							{ className: 'offer_info', onClick: function onClick() {
									_this5.setState({ modal_gen: true });
								} },
							_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/info.png', width: '20px', alt: '' })
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement('img', { onClick: function onClick() {
									_this5.setState({ modal_gen: true });
								}, src: baseAssets + 'images/promo_offers/' + offers.image, alt: '' })
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ onEntered: function onEntered() {
								_this5.getPromoDetails(offers.id);
							}, className: 'Offer_modal', show: this.state.modal_gen, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ className: 'modal_offer_header', closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: 16 + 'px', color: '#fff' } },
								'Offer Details'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							{ className: 'modal_details_block' },
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_title' },
								this.state.title
							),
							_react2.default.createElement(
								'h6',
								{ className: 'modal_ofr_applicable' },
								'Applicable On: ',
								this.state.discount_type
							),
							_react2.default.createElement(
								'p',
								{ className: 'modal_ofr_period' },
								'Limited period offer'
							),
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_desc_title' },
								'Description'
							),
							_react2.default.createElement(
								'p',
								{ className: 'modal_ofr_desc' },
								this.state.description
							),
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_terms_title' },
								'Terms and Conditions'
							),
							_react2.default.createElement('div', { className: 'modal_ofr_terms', dangerouslySetInnerHTML: { __html: this.state.terms } }),
							this.state.title === 'Refer & Earn' ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'ofr_invite_btn' },
									_react2.default.createElement(
										'a',
										{ onClick: function onClick() {
												_this5.getInvite();
											} },
										'INVITE NOW'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'ofr_share_panel' },
									_react2.default.createElement(
										_reactBootstrap.Panel,
										{ className: '', style: { marginLeft: '30%' }, collapsible: true, expanded: this.state.share_panel_open },
										_react2.default.createElement(
											FacebookShareButton,
											{ url: shareUrl, title: this.state.share_title, className: 'test_share2' },
											_react2.default.createElement(FacebookIcon, { size: 32, round: true })
										),
										_react2.default.createElement(
											TwitterShareButton,
											{ url: shareUrl, title: this.state.share_title, description: shareUrl, className: 'test_share2' },
											_react2.default.createElement(TwitterIcon, { size: 32, round: true })
										),
										_react2.default.createElement(
											GooglePlusShareButton,
											{ url: shareUrl, title: this.state.share_title, description: shareUrl, className: 'test_share2' },
											_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
										)
									)
								)
							) : ''
						)
					)
				);
			}
		}]);
	
		return SeedOffers;
	}(_react.Component);
	
	var ProductOffers = function (_Component4) {
		_inherits(ProductOffers, _Component4);
	
		function ProductOffers(props) {
			_classCallCheck(this, ProductOffers);
	
			var _this6 = _possibleConstructorReturn(this, (ProductOffers.__proto__ || Object.getPrototypeOf(ProductOffers)).call(this, props));
	
			_this6.state = {
				modal_gen: false,
				offers: _this6.props.data,
				title: '',
				description: '',
				terms: '',
				discount_type: '',
				details: [],
				share_title: '',
				share_desc: '',
				share_panel_open: false
			};
			_this6.close = _this6.close.bind(_this6);
			_this6.getPromoDetails = _this6.getPromoDetails.bind(_this6);
			_this6.getInvite = _this6.getInvite.bind(_this6);
			return _this6;
		}
	
		_createClass(ProductOffers, [{
			key: 'getPromoDetails',
			value: function getPromoDetails(offer_id) {
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), ofr_id: offer_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + "get_promo_ofr",
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						var details = _jquery2.default.makeArray(data.data);
	
						window.test = details;
						this.setState({
							details: details,
							title: details[0].title,
							description: details[0].description,
							terms: details[0].terms,
							discount_type: details[0].discount_type,
							share_panel_open: false
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({ modal_gen: false });
			}
		}, {
			key: 'getInvite',
			value: function getInvite() {
	
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + 'shareAppurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						console.log(data);
						this.setState({
							share_title: data.share_data,
							share_desc: data.share_data,
							share_panel_open: !this.state.share_panel_open
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this7 = this;
	
				var offers = this.props.data;
				var shareUrl = 'http://tinyurl.com/aquadotdeals';
				return _react2.default.createElement(
					'div',
					{ className: 'offers_block' },
					_react2.default.createElement(
						_reactRouter.Link,
						null,
						_react2.default.createElement(
							'div',
							{ className: 'offer_info', onClick: function onClick() {
									_this7.setState({ modal_gen: true });
								} },
							_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/info.png', width: '20px', alt: '' })
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement('img', { onClick: function onClick() {
									_this7.setState({ modal_gen: true });
								}, src: baseAssets + 'images/promo_offers/' + offers.image, alt: '' })
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ onEntered: function onEntered() {
								_this7.getPromoDetails(offers.id);
							}, className: 'Offer_modal', show: this.state.modal_gen, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ className: 'modal_offer_header', closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: 16 + 'px', color: '#fff' } },
								'Offer Details'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							{ className: 'modal_details_block' },
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_title' },
								this.state.title
							),
							_react2.default.createElement(
								'h6',
								{ className: 'modal_ofr_applicable' },
								'Applicable On: ',
								this.state.discount_type
							),
							_react2.default.createElement(
								'p',
								{ className: 'modal_ofr_period' },
								'Limited period offer'
							),
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_desc_title' },
								'Description'
							),
							_react2.default.createElement(
								'p',
								{ className: 'modal_ofr_desc' },
								this.state.description
							),
							_react2.default.createElement(
								'h4',
								{ className: 'modal_ofr_terms_title' },
								'Terms and Conditions'
							),
							_react2.default.createElement('div', { className: 'modal_ofr_terms', dangerouslySetInnerHTML: { __html: this.state.terms } }),
							this.state.title === 'Refer & Earn' ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'ofr_invite_btn' },
									_react2.default.createElement(
										'a',
										{ onClick: function onClick() {
												_this7.getInvite();
											} },
										'INVITE NOW'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'ofr_share_panel' },
									_react2.default.createElement(
										_reactBootstrap.Panel,
										{ className: '', style: { marginLeft: '30%' }, collapsible: true, expanded: this.state.share_panel_open },
										_react2.default.createElement(
											FacebookShareButton,
											{ url: shareUrl, title: this.state.share_title, className: 'test_share2' },
											_react2.default.createElement(FacebookIcon, { size: 32, round: true })
										),
										_react2.default.createElement(
											TwitterShareButton,
											{ url: shareUrl, title: this.state.share_title, description: shareUrl, className: 'test_share2' },
											_react2.default.createElement(TwitterIcon, { size: 32, round: true })
										),
										_react2.default.createElement(
											GooglePlusShareButton,
											{ url: shareUrl, title: this.state.share_title, description: shareUrl, className: 'test_share2' },
											_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
										)
									)
								)
							) : ''
						)
					)
				);
			}
		}]);
	
		return ProductOffers;
	}(_react.Component);

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _custom_functions = __webpack_require__(69);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactWebVectorIcons = __webpack_require__(29);
	
	var _reactWebVectorIcons2 = _interopRequireDefault(_reactWebVectorIcons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Footer from './../Common/footer';
	
	
	var parseHtml = __webpack_require__(39);
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Coupon_Details = function (_Component) {
		_inherits(Coupon_Details, _Component);
	
		function Coupon_Details(props) {
			_classCallCheck(this, Coupon_Details);
	
			var _this = _possibleConstructorReturn(this, (Coupon_Details.__proto__ || Object.getPrototypeOf(Coupon_Details)).call(this, props));
	
			_this.state = {
				coupon_details: [],
				coupon_status: false
			};
			_this.enq_redirect = _this.enq_redirect.bind(_this);
			return _this;
		}
	
		_createClass(Coupon_Details, [{
			key: 'enq_redirect',
			value: function enq_redirect() {
				if (localStorage.token && localStorage.user_id) {
					localStorage.removeItem('w_r_p_dt');
					localStorage.removeItem('w_r_s_dt');
					localStorage.removeItem('m_r_p_dt');
					localStorage.removeItem('m_r_s_dt');
					localStorage.removeItem('m_r_e_s_dt');
					localStorage.removeItem('m_r_e_p_dt');
					localStorage.removeItem('m_r_coupon_dt');
	
					var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, cid: this.props.params.Cid };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						url: baseUrl + 'saveCouponLead',
						dataType: 'json',
						data: { req: data2 },
						success: function success(data) {
	
							if (data.status === 'success') {
								_reactRouter.browserHistory.push('/customer_care');
								// window.location.reload();
							}
						},
						error: function error(err) {}
					});
					// browserHistory.push('/web/customer_care');
					// window.location.reload();
				} else {
					localStorage.removeItem('w_r_s_dt');
					localStorage.removeItem('w_r_p_dt');
					localStorage.removeItem('m_r_s_dt');
					localStorage.removeItem('m_r_p_dt');
					localStorage.removeItem('m_r_e_p_dt');
					localStorage.removeItem('m_r_e_s_dt');
	
					// localStorage.setItem('m_r_coupon_dt','/coupon/details'+this.props.params.Cid); 			
					localStorage.setItem('m_r_e_coupon_dt', '/customer_care');
					_reactRouter.browserHistory.push('/login');
					// window.location.reload();
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
	
				if (screen.width >= 800) {
					window.location.href = "/web/coupon/details/" + this.props.params.Cid;
				}
	
				var data1 = { from: 'mobile_web', cid: this.props.params.Cid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getCouponDetails',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
	
						//  var coupon = $.makeArray(data.coupon_details);
						//this.setState({
						//	coupon_details:coupon[0],
						//}); */}
						if (data.status === "success") {
							var coupon = _jquery2.default.makeArray(data.coupon_details);
							this.setState({
								coupon_details: coupon[0]
							});
						} else if (data.status === "error") {
							this.setState({
								coupon_status: true
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
	
			// functions for "ADD" form validations and updations END here 
	
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals coupon_details_page' },
					_react2.default.createElement(
						'div',
						{ id: 'header_main' },
						_react2.default.createElement(
							'div',
							{ className: 'page_hdr' },
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: '/mycart' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
										)
									),
									'Coupon Details'
								),
								_react2.default.createElement(
									'a',
									{ href: '/', title: 'Home', className: 'home_logo1' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					!this.state.coupon_status ? _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'section',
							{ className: 'container-fluid coupon_details_main' },
							_react2.default.createElement(
								'div',
								{ className: 'row lst_img coupon_img' },
								_react2.default.createElement('img', { src: baseAssets + "images/" + this.state.coupon_details.img, role: 'presentation', alt: '' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'row coupon_details' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-12 coupon_specs' },
									this.state.coupon_details.code ? _react2.default.createElement(
										'ul',
										{ id: 'coupon_label' },
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement(
												'li',
												null,
												_react2.default.createElement('img', { src: __webpack_require__(254), alt: '...' })
											),
											_react2.default.createElement(
												'li',
												null,
												this.state.coupon_details.code
											)
										)
									) : '',
									this.state.coupon_details.coupon_title ? _react2.default.createElement(
										'h4',
										null,
										this.state.coupon_details.coupon_title,
										this.state.coupon_details.status == 1 ? _react2.default.createElement(
											'span',
											{ className: 'coupon_status_active' },
											'ACTIVE'
										) : _react2.default.createElement(
											'span',
											{ className: 'coupon_status_expired' },
											'EXPIRED'
										)
									) : '',
									this.state.coupon_details.date_time_msg ? _react2.default.createElement(
										'h3',
										null,
										this.state.coupon_details.date_time_msg
									) : ''
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'coupon_specs_sub_bg' },
							_react2.default.createElement(
								'section',
								{ className: 'coupon_specs_sub' },
								this.state.coupon_details.applied_on_name !== 0 ? _react2.default.createElement(
									'h5',
									null,
									this.state.coupon_details.applied_on_name,
									this.state.coupon_details.value !== 0 ? '' : ''
								) : '',
								this.state.coupon_details.quantity_msg !== 0 ? _react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(_reactWebVectorIcons2.default, {
										name: 'circle',
										font: 'MaterialCommunityIcons',
										color: '#ccc',
										size: 14,
										style: { paddingRight: '3px', top: '1', position: 'relative' }
									}),
									this.state.coupon_details.quantity_msg,
									' '
								) : '',
								this.state.coupon_details.applied_on_catname !== 0 ? _react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(_reactWebVectorIcons2.default, {
										name: 'circle',
										font: 'MaterialCommunityIcons',
										color: '#ccc',
										size: 14,
										style: { paddingRight: '3px', top: '1', position: 'relative' }
									}),
									this.state.coupon_details.applied_on_catname
								) : ''
							),
							_react2.default.createElement('div', { className: 'coupon_dots_blocks' }),
							_react2.default.createElement(
								'section',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'div',
									{ className: 'row coupon_description_blk' },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-12 col-xs-12 col-sm-12 coupon_description_head' },
										this.state.coupon_details.desc ? _react2.default.createElement(
											'h4',
											null,
											this.state.coupon_details.desc
										) : ''
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						)
					) : _react2.default.createElement(
						'div',
						{ className: 'row', style: { textAlign: 'center', color: '#555', margin: '30% auto' } },
						'No Coupons Available'
					),
					_react2.default.createElement(
						'section',
						{ className: 'botm_btns row', style: { paddingBottom: '5px' } },
						_react2.default.createElement(
							'ul',
							null,
							_react2.default.createElement(
								'li',
								{ className: 'col-md-6 col-xs-6 col-sm-6', style: { cursor: 'pointer' } },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: '/customer_care' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'images/icons/enquiry_now.png', alt: ' ' })
									),
									'Enquire Now'
								)
							),
							_react2.default.createElement(
								'li',
								{ className: 'col-md-6 col-xs-6 col-sm-6', style: { cursor: 'pointer' } },
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: '/' },
									'Explore Deals'
								)
							)
						)
					)
				);
			}
		}]);
	
		return Coupon_Details;
	}(_react.Component);
	
	exports.default = Coupon_Details;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _footer = __webpack_require__(50);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var BrowseFeedDeals = function (_Component) {
	  _inherits(BrowseFeedDeals, _Component);
	
	  function BrowseFeedDeals(props) {
	    _classCallCheck(this, BrowseFeedDeals);
	
	    var _this = _possibleConstructorReturn(this, (BrowseFeedDeals.__proto__ || Object.getPrototypeOf(BrowseFeedDeals)).call(this, props));
	
	    _this.state = {
	      feed_cat: [],
	      feed_sub_cat: [],
	      feed_brands: [],
	      details: '',
	      offer: '',
	      type: _this.props.params.Type,
	      prevPath: '',
	      loading: false,
	      seo_title: '',
	      seo_desc: '',
	      deal_count: '',
	      brand_count: '',
	      category_status: 0,
	      cart_count: 0,
	
	      total_feed_brands: [],
	      isToggle: true,
	      brand_id: '',
	      sort_deal_count: ''
	    };
	    _this.getDeviceId = _this.getDeviceId.bind(_this);
	    _this.getswipe_Brands = _this.getswipe_Brands.bind(_this);
	    _this.getCartCount = _this.getCartCount.bind(_this);
	    return _this;
	  }
	
	  _createClass(BrowseFeedDeals, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.location !== this.props.location) {
	        this.setState({
	          prevPath: this.props.location
	        });
	      }
	    }
	  }, {
	    key: 'getCartCount',
	    value: function getCartCount() {
	      if (localStorage.user_id) {
	        var uid = localStorage.user_id;
	      } else {
	        uid = 0;
	      }
	      var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token') };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'cart_count',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            cart_count: data.cart_count
	          });
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      if (screen.width >= 800) {
	        window.location.href = "/web/pdeals/" + this.props.params.BrandName + "/all/" + this.props.params.Type;
	      }
	      if (localStorage.user_id && localStorage.token) {
	        this.getCartCount();
	      }
	      this.getDeviceId();
	      // localStorage.setItem('cat_id',0);
	      localStorage.removeItem('cat_id');
	      localStorage.removeItem('cat');
	      localStorage.removeItem('url');
	      localStorage.removeItem('cat_sort');
	      localStorage.removeItem('m_r_p_deals');
	      localStorage.setItem('cat_page', this.props.params.Type);
	      // localStorage.setItem('currPath',this.props.location.pathname);
	      var uid = 0;
	      if (localStorage.user_id) {
	        uid = localStorage.getItem('user_id');
	      } else {
	        uid = 0;
	      }
	
	      var data1 = { from: 'mobile_web', uid: uid, type: this.state.type };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getbrands_categoires',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            loading: true,
	            feed_cat: data.categories,
	            // feed_brands:data.brands,
	            total_feed_brands: data.brands,
	            offer: data,
	            type: this.props.params.Type,
	            deal_count: data.deal_count
	          });
	          if (this.props.params.Type === "2") {
	            document.title = "Buy Aqua Feed Products Online | AquaDeals";
	            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Feed deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	          } else if (this.props.params.Type === "4") {
	            document.title = "Buy Aqua Healthcare Products Online | AquaDeals";
	            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Healthcare Products & Supplements deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	          } else if (this.props.params.Type === "3") {
	            document.title = "Buy Aqua Machinery & Equipment Products Online | AquaDeals";
	            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Machinery & Equipment deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	          } else if (this.props.params.Type === "5") {
	            document.title = "Buy Aqua Hatchery Machinery Products Online | AquaDeals";
	            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Hatchery Machinery Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	          } else if (this.props.params.Type === "7") {
	            document.title = "Buy Aqua Hatchery Health Care Product deals Online | AquaDeals";
	            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Hatchery Healthcare Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	          } else {
	            document.title = "Buy Aquaculture deals Online | AquaDeals";
	            document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	          }
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'getDeviceId',
	    value: function getDeviceId() {
	      if (localStorage.user_id) {
	        var user_id = localStorage.user_id;
	      } else {
	        user_id = 0;
	      }
	      var data1 = { from: 'mobile_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
	      var data2 = JSON.stringify(data1);
	
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getDeviceId',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function success(data) {},
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      if (this.state.type === '2') {
	        return "Feed";
	      } else if (this.state.type === '3') {
	        return "Machinery & Farm Equipments";
	      } else if (this.state.type === '4') {
	        return "Health Care";
	      } else if (this.state.type === '5') {
	        return "Hatchery Machinery";
	      } else if (this.state.type === '7') {
	        return "Hatchery Health Care";
	      }
	    }
	  }, {
	    key: 'getswipe_Brands',
	    value: function getswipe_Brands(x, url_dtype_name, url_name, type, dtype) {
	      localStorage.setItem('cat_id', x);
	      localStorage.setItem('url', '/pdeals/' + url_dtype_name + '/' + url_name + '/' + x + '/' + type + '/' + dtype);
	      this.setState({
	        category_status: x
	      });
	      if (localStorage.user_id) {
	        var user_id = localStorage.user_id;
	      } else {
	        user_id = 0;
	      }
	      var data1 = { from: 'mobile_web', id: user_id, cat_id: x, type: this.state.type };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getbrandsBycat',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          if (data.status === 'success') {
	            if (this.state.brand_id !== x) {
	              this.setState({ isToggle: false });
	            } else {
	              this.setState({ isToggle: !this.state.isToggle });
	              if (this.state.isToggle) {
	                localStorage.removeItem('url');
	              }
	            }
	            this.setState({
	              feed_brands: data.brands,
	              // deal_count:data.deal_count,
	              sort_deal_count: data.deal_count,
	              brand_count: data.brand_count,
	              brand_id: x
	            });
	          }
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var params = {
	        paginationClickable: true,
	        spaceBetween: 30,
	        slidesPerView: 3
	      };
	
	      var title = this.getTitle();
	      // document.title =title + " - Deals | AquaDeals ";
	      // document.getElementsByTagName("META")[2].content="Browse best deals,Aquaculture products from various brands and categories in "+title+".Contact customer care for any queries on these Aqua products and order online";
	      if (this.props.params.Type === "2") {
	        document.title = "Buy Aqua Feed Products Online | AquaDeals";
	        document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Feed deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	      } else if (this.props.params.Type === "4") {
	        document.title = "Buy Aqua Healthcare Products Online | AquaDeals";
	        document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Healthcare Products & Supplements deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	      } else if (this.props.params.Type === "3") {
	        document.title = "Buy Aqua Machinery & Equipment Products Online | AquaDeals";
	        document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Machinery & Equipment Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	      } else if (this.props.params.Type === "5") {
	        document.title = "Buy Aqua Hatchery Machinery Products Online | AquaDeals";
	        document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Hatchery Machinery Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	      } else if (this.props.params.Type === "7") {
	        document.title = "Buy Aqua Hatchery Healthcare Product deals Online | AquaDeals";
	        document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture Hatchery Healthcare Product deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	      } else {
	        document.title = "Buy deals Online | AquaDeals";
	        document.getElementsByTagName("META")[2].content = "Browse quality Aquaculture deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment";
	      }
	
	      if (this.state.isToggle) {
	        var feed_brands = this.state.total_feed_brands;
	      } else {
	        feed_brands = this.state.feed_brands;
	      }
	      var brands = feed_brands.map(function (brand, index) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4 col-xs-4 col-md-4 col-lg-4 brand_section' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/pdeals/" + brand.url_dtype_name + "/" + brand.url_name + "/" + brand.id + "/" + brand.type + "/" + localStorage.getItem('cat_page') },
	            _react2.default.createElement('img', { src: brand.logo === "noimage.jpg" || brand.logo === "" ? baseAssets + 'images/seller_imgs/thumbnails/noImage.png' : baseAssets + 'images/brand_icons/' + brand.logo, role: 'presentation', width: '50px', alt: ' ' }),
	            _react2.default.createElement(
	              'p',
	              { className: 'sw_brnd_name' },
	              brand.category_name
	            )
	          )
	        );
	      });
	
	      var swipe_categoies = this.state.feed_cat.map(function (cat, index) {
	        var _this3 = this;
	
	        if (cat.sub.length > 0) {
	          var sw_subs_cat = cat.sub.map(function (sub_cat, index) {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { className: 'swipe_cat_lst_grd swiper-slide', onClick: function onClick() {
	                    _this2.getswipe_Brands(sub_cat.id, sub_cat.url_dtype_name, sub_cat.url_name, sub_cat.type, sub_cat.dtype);
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { style: { textAlign: 'center' } },
	                  _react2.default.createElement('img', { src: baseAssets + 'images/icons2/' + sub_cat.logo, role: 'presentation', width: '40px', height: '40px', alt: ' ' }),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'h6',
	                      { className: this.state.category_status === sub_cat.id && !this.state.isToggle ? "sw_cat_name sw_cat_name_active" : "sw_cat_name" },
	                      sub_cat.category_name
	                    ),
	                    this.state.category_status === sub_cat.id && !this.state.isToggle ? _react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/triangle_up.png', alt: ' ', style: { width: '20px', height: '18px' } }) : _react2.default.createElement(
	                      'div',
	                      { className: 'clr' },
	                      '\xA0'
	                    )
	                  )
	                )
	              )
	            );
	          }.bind(this));
	        }
	        return _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { className: sw_subs_cat ? "swipe_cat_lst_grd swipe_cat_lst_grd_empty" : "swipe_cat_lst_grd", onClick: sw_subs_cat ? '' : function () {
	                _this3.getswipe_Brands(cat.id, cat.url_dtype_name, cat.url_name, cat.type, cat.dtype);
	              } },
	            sw_subs_cat ? '' : _react2.default.createElement(
	              'div',
	              { style: { textAlign: 'center' } },
	              _react2.default.createElement('img', { src: baseAssets + 'images/icons2/' + cat.logo, alt: ' ', role: 'presentation', width: '40px', height: '40px' }),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h6',
	                  { className: this.state.category_status === cat.id && !this.state.isToggle ? "sw_cat_name sw_cat_name_active" : "sw_cat_name" },
	                  cat.category_name
	                ),
	                this.state.category_status === cat.id && !this.state.isToggle ? _react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/triangle_up.png', alt: ' ', style: { width: '20px', height: '18px' } }) : _react2.default.createElement(
	                  'div',
	                  { className: 'clr' },
	                  '\xA0'
	                )
	              )
	            ),
	            sw_subs_cat
	          )
	        );
	      }.bind(this));
	      return _react2.default.createElement(
	        'div',
	        { className: 'mob_deals browse_deals_page' },
	        this.state.loading ? _react2.default.createElement(
	          'div',
	          { className: 'mob_deals mob_browse_deals_page' },
	          _react2.default.createElement(
	            'div',
	            { className: 'page_hdr' },
	            _react2.default.createElement(
	              'div',
	              { className: 'container-fluid' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'm_nav_back' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: "/" },
	                  _react2.default.createElement(
	                    'i',
	                    null,
	                    _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'header_text' },
	                  title
	                )
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: '/', className: 'home_logo1' },
	                _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
	              ),
	              _react2.default.createElement(
	                'a',
	                { className: 'mob_cart_btn', href: '/mycart' },
	                _react2.default.createElement('img', { alt: ' ', src: baseAssets + 'icons/web_icons/cart_icon.png' }),
	                this.state.cart_count > 0 ? _react2.default.createElement(
	                  'span',
	                  { className: this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count" },
	                  this.state.cart_count
	                ) : ''
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pag_cntnt browse_feed1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'container-fluid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'sw_cat_blk' },
	                swipe_categoies.length > 0 ? _react2.default.createElement(
	                  'h2',
	                  { className: 'mob_swip_hdg', style: { color: '#333' } },
	                  'CATEGORIES'
	                ) : _react2.default.createElement(
	                  'div',
	                  { className: 'no_data' },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'No Products Available'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { to: "/customer_care" },
	                      'CONTACT US'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'mob_browse_cat_container' },
	                    swipe_categoies
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: 'clr' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'sw_brands_blk' },
	                localStorage.url ? _react2.default.createElement(
	                  'div',
	                  { className: 'browse_cat_brands' },
	                  brands.length > 0 ? _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4 col-xs-4 col-sm-4', style: { padding: '0px' } },
	                    'BRANDS : ',
	                    brands.length
	                  ) : '',
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4 col-xs-4 col-sm-4 txt_cnt' },
	                    this.state.isToggle ? "Items : " + this.state.deal_count : "ITEMS : " + this.state.sort_deal_count
	                  ),
	                  !this.state.isToggle ? _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4 col-xs-4 col-sm-4', style: { padding: '0px', textAlign: 'right' } },
	                    localStorage.url ? _react2.default.createElement(
	                      _reactRouter.Link,
	                      { className: 'mob_view_all_deals', to: localStorage.getItem('url') },
	                      'VIEW ALL DEALS'
	                    ) : ''
	                  ) : ''
	                ) : _react2.default.createElement(
	                  'div',
	                  null,
	                  brands.length > 0 ? _react2.default.createElement(
	                    'div',
	                    { className: 'browse_cat_brands2' },
	                    brands.length > 0 ? _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-6 col-xs-6 col-sm-6', style: { padding: '0px' } },
	                      'BRANDS : ',
	                      brands.length
	                    ) : '',
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-6 col-xs-6 col-sm-6', style: { padding: '0px', textAlign: 'right' } },
	                      this.state.isToggle ? "ITEMS : " + this.state.deal_count : "ITEMS : " + this.state.sort_deal_count
	                    )
	                  ) : ''
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row brands_container' },
	                  brands
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'clr' },
	                '\xA0'
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'mob_loading' },
	          _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/mob_loading.gif', alt: 'Loading', role: 'presentation' })
	        )
	      );
	    }
	  }]);
	
	  return BrowseFeedDeals;
	}(_react.Component);
	
	exports.default = BrowseFeedDeals;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactShare = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var OffersDetails = function (_Component) {
	  _inherits(OffersDetails, _Component);
	
	  function OffersDetails(props) {
	    _classCallCheck(this, OffersDetails);
	
	    var _this = _possibleConstructorReturn(this, (OffersDetails.__proto__ || Object.getPrototypeOf(OffersDetails)).call(this, props));
	
	    _this.state = {
	      tid: _this.props.params.Tid,
	      type: _this.props.params.Type,
	      dtype: _this.props.params.DType,
	      pdeals: [],
	      totdata: '',
	      prevPath: '',
	      brands: [],
	      categories: [],
	      brands_status: false,
	      cat_status: false,
	      nodata: false,
	      open: false,
	      img_price: 'price.png',
	      img_data: 'Price',
	      sort_status: 1,
	      sort: '1',
	      latitude: '',
	      longitude: '',
	      cart_count: 0
	    };
	    _this.getBrands = _this.getBrands.bind(_this);
	    _this.getSelectedBrand = _this.getSelectedBrand.bind(_this);
	    _this.getSort = _this.getSort.bind(_this);
	    _this.getNearBy = _this.getNearBy.bind(_this);
	    _this.getDeviceId = _this.getDeviceId.bind(_this);
	    _this.getCartCount = _this.getCartCount.bind(_this);
	    return _this;
	  }
	
	  _createClass(OffersDetails, [{
	    key: 'getCartCount',
	    value: function getCartCount() {
	      if (localStorage.user_id) {
	        var uid = localStorage.user_id;
	      } else {
	        uid = 0;
	      }
	      var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token') };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'cart_count',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	
	          this.setState({
	            cart_count: data.cart_count
	          });
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	    // showPosition(position) {
	    //     localStorage.setItem('lat',position.coords.latitude);
	    //     localStorage.setItem('long',position.coords.longitude);
	    //     this.setState({
	    //       latitude: position.coords.latitude,
	    //       longitude: position.coords.longitude,
	    //     });
	    // }
	
	  }, {
	    key: 'getDeviceId',
	    value: function getDeviceId() {
	      if (localStorage.user_id) {
	        var user_id = localStorage.user_id;
	      } else {
	        user_id = 0;
	      }
	      var data1 = { from: 'mobile_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getDeviceId',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function success(data) {},
	        error: function error(err) {}
	      });
	    }
	
	    // showError(error)
	    // {
	    //   switch(error.code) {
	    //       case error.PERMISSION_DENIED:
	    //           // console.log("User denied the request for Geolocation.");
	    //           break;
	    //       case error.POSITION_UNAVAILABLE:
	    //           // console.log("Location information is unavailable.");
	    //           break;
	    //       case error.TIMEOUT:
	    //           // console.log("The request to get user location timed out.");
	    //           break;
	    //       case error.UNKNOWN_ERROR:
	    //           // console.log("An unknown error occurred.");
	    //           break;
	    //       default: 
	    //           console.log('');
	    //       break;
	    //   }
	    // }
	
	  }, {
	    key: 'getBrands',
	    value: function getBrands() {
	
	      var data1 = { from: 'mobile_web', type: this.state.type, tid: this.state.tid, dtype: this.state.dtype };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'filterBrandCat',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          if (data.brands_lst.length > 0) {
	            this.setState({
	              brands_status: true
	            });
	          }
	          if (data.cat_lst.length > 0) {
	            this.setState({
	              cat_status: true
	            });
	          }
	          this.setState({
	            brands: data.brands_lst,
	            categories: data.cat_lst
	          });
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'getCategories',
	    value: function getCategories() {
	
	      var data1 = { from: 'mobile_web', type: this.state.type, tid: this.state.tid, dtype: this.state.dtype };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'filterBrandCat',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function success(data) {},
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'getSelectedBrand',
	    value: function getSelectedBrand(b) {
	      var uid = 0;
	      if (localStorage.user_id) {
	        uid = localStorage.getItem('user_id');
	      } else {
	        uid = 0;
	      }
	
	      var data1 = { from: 'mobile_web', uid: uid, type: this.state.type, tid: this.state.tid, dtype: this.state.dtype, bid: b };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getProductbycat_brand',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          if (data.result.length === 0) {
	            this.setState({
	              nodata: true
	            });
	          } else {
	            this.setState({
	              nodata: false
	            });
	          }
	          this.setState({
	            pdeals: data.result,
	            totdata: data
	          });
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'getSelectedCategory',
	    value: function getSelectedCategory(c) {
	      var uid = 0;
	      if (localStorage.user_id) {
	        uid = localStorage.getItem('user_id');
	      } else {
	        uid = 0;
	      }
	      var data1 = { from: 'mobile_web', uid: uid, type: this.state.type, tid: this.state.tid, dtype: this.state.dtype, cat_id: c };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getProductbycat_brand',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          if (data.result.length === 0) {
	            this.setState({
	              nodata: true
	            });
	          } else {
	            this.setState({
	              nodata: false
	            });
	          }
	          this.setState({
	            pdeals: data.result,
	            totdata: data
	          });
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (screen.width >= 800) {
	        window.location.href = "/web/offers/deals/" + this.props.params.Tid + "/" + this.props.params.Type + "/1";
	      }
	      localStorage.setItem('offers', '/offers/deals/' + this.props.params.Tid + '/' + this.props.params.Type + '/' + this.props.params.DType);
	
	      // if(navigator.geolocation){
	      //     	navigator.geolocation.getCurrentPosition(this.showPosition,this.showError);
	      //   }
	      //   else{
	      //     // alert("GeoLocation is not supported by the browser");
	      //   }
	      this.getBrands();
	      this.getDeviceId();
	      if (localStorage.user_id && localStorage.token) {
	        this.getCartCount();
	      }
	
	      var data1 = '';
	      var data2 = '';
	      var get_function = '';
	      var uid = 0;
	      if (localStorage.user_id) {
	        uid = localStorage.getItem('user_id');
	      } else {
	        uid = 0;
	      }
	      if (this.state.type === 'offers') {
	        data1 = { from: 'mobile_web', uid: uid, deal_offer_type: this.state.dtype, type: '' };
	        data2 = JSON.stringify(data1);
	        get_function = 'getProductbycat_brand';
	        this.get_product_list(data2, baseUrl, get_function);
	      }
	      if (this.state.type === 'brand') {
	        data1 = { from: 'mobile_web', uid: uid, type: this.state.type, tid: this.state.tid, dtype: this.state.dtype };
	        data2 = JSON.stringify(data1);
	        get_function = 'getProductbycat_brand';
	        this.get_product_list(data2, baseUrl, get_function);
	      } else {
	        data1 = { from: 'mobile_web', uid: uid, discount: this.state.tid, discount_type: this.state.dtype, discount_opr: this.state.type };
	        data2 = JSON.stringify(data1);get_function = 'getNewsearch';
	        this.get_product_list(data2, baseUrl, get_function);
	      }
	    }
	  }, {
	    key: 'get_product_list',
	    value: function get_product_list(data2, baseUrl, get_function) {
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + get_function,
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          if (data.products.length === 0) {
	            this.setState({
	              nodata: true
	            });
	          } else if (this.state.tid === '49') {
	            this.setState({
	              nodata: true
	            });
	          } else {
	            this.setState({
	              nodata: false
	            });
	          }
	          this.setState({
	            pdeals: data.products,
	            totdata: data
	          });
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'getSort',
	    value: function getSort() {
	      var uid = 0;
	      if (localStorage.user_id) {
	        uid = localStorage.getItem('user_id');
	      } else {
	        uid = 0;
	      }
	      var data1 = { from: 'mobile_web', uid: uid, sort: this.state.sort, discount: this.state.tid, discount_type: this.state.dtype, discount_opr: this.state.type };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getNewsearch',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          if (this.state.sort === 1) {
	            var ss = 2;
	            var img_price = 'down.png';
	            var img_data = 'High - Low';
	          } else {
	            ss = 1;
	            img_price = 'up.png';
	            img_data = 'Low - High';
	          }
	          this.setState({
	            sort: ss,
	            img_price: img_price,
	            img_data: img_data
	          });
	          this.setState({
	            pdeals: data.products,
	            totdata: data
	          });
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'getNearBy',
	    value: function getNearBy() {
	      var uid = 0;
	      if (localStorage.user_id) {
	        uid = localStorage.getItem('user_id');
	      } else {
	        uid = 0;
	      }
	
	      var data1 = { from: 'mobile_web', uid: uid, lat: this.state.latitude, long: this.state.longitude, discount: this.state.tid, discount_type: this.state.dtype, discount_opr: this.state.type };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'getNewsearch',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          if (data.products.length === 0) {
	            this.setState({
	              nodata: true
	            });
	          } else {
	            this.setState({
	              nodata: false,
	              pdeals: data.products,
	              totdata: data
	            });
	          }
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var products = this.state.pdeals.map(function (product, index) {
	        return _react2.default.createElement(ProductsList, { key: product.pid, data: product });
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'mob_deals m_offer_details_page ' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page_hdr' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container-fluid' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { onClick: function onClick() {
	                    _reactRouter.browserHistory.goBack();
	                  } },
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
	                )
	              ),
	              ' Flat ',
	              this.state.tid,
	              '% off'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '/', className: 'home_logo1' },
	              _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
	            ),
	            _react2.default.createElement(
	              'a',
	              { className: 'mob_cart_btn', href: '/mycart' },
	              _react2.default.createElement('img', { alt: '', src: baseAssets + 'icons/web_icons/cart_icon.png' }),
	              this.state.cart_count > 0 ? _react2.default.createElement(
	                'span',
	                { className: this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count" },
	                this.state.cart_count
	              ) : ''
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pag_cntnt' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'container-fluid' },
	          this.state.nodata ? _react2.default.createElement(
	            'div',
	            { className: 'no_data' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'No Deals Available'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Need something here? ',
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: "/customer_care" },
	                'CONTACT US'
	              ),
	              ' now !'
	            )
	          ) : products
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clr' },
	          '\xA0'
	        )
	      );
	    }
	  }]);
	
	  return OffersDetails;
	}(_react.Component);
	
	exports.default = OffersDetails;
	
	var ProductsList = function (_Component2) {
	  _inherits(ProductsList, _Component2);
	
	  function ProductsList() {
	    _classCallCheck(this, ProductsList);
	
	    var _this2 = _possibleConstructorReturn(this, (ProductsList.__proto__ || Object.getPrototypeOf(ProductsList)).call(this));
	
	    _this2.state = {
	      open: false,
	      msg: '',
	      shareUrl: ''
	    };
	    _this2.ShareFunc = _this2.ShareFunc.bind(_this2);
	    _this2.addToCart = _this2.addToCart.bind(_this2);
	    // this.updateCartCount=this.updateCartCount.bind(this);
	    _this2.close = _this2.close.bind(_this2);
	    _this2.replaceCartItems = _this2.replaceCartItems.bind(_this2);
	    _this2.addToQuickCart = _this2.addToQuickCart.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ProductsList, [{
	    key: 'replaceCartItems',
	    value: function replaceCartItems(deal_id, quantity) {
	      if (localStorage.user_id) {
	        var uid = localStorage.user_id;
	      } else {
	        uid = 0;
	      }
	      if (localStorage.source) {
	        var source = localStorage.getItem('source');
	      } else {
	        source = '';
	      }
	      if (localStorage.campaign) {
	        var campaign = localStorage.getItem('campaign');
	      } else {
	        campaign = '';
	      }
	      if (localStorage.url_id) {
	        var url_id = localStorage.getItem('url_id');
	      } else {
	        url_id = '';
	      }
	      var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1, quantity: quantity, pl_size: 0, salinity: 0, pickup_date: 0, source: source, campaign: campaign, url_id: url_id };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'post',
	        dataType: 'json',
	        url: baseUrl + 'replaceCart',
	        data: { req: data2 },
	        success: function (data) {
	          if (data.status === "success") {
	            this.setState({
	              clearcart_status: false
	            });
	            _reactRouter.browserHistory.push('/mycart');
	          }
	        }.bind(this),
	        error: function error(err) {}
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.setState({
	        clearcart_status: false,
	        already_added_status: false
	      });
	    }
	  }, {
	    key: 'addToQuickCart',
	    value: function addToQuickCart(deal_id) {
	      if (localStorage.source) {
	        var source = localStorage.getItem('source');
	      } else {
	        source = '';
	      }
	      if (localStorage.campaign) {
	        var campaign = localStorage.getItem('campaign');
	      } else {
	        campaign = '';
	      }
	      if (localStorage.url_id) {
	        var url_id = localStorage.getItem('url_id');
	      } else {
	        url_id = '';
	      }
	      if (!localStorage.user_id && !localStorage.token) {
	        _reactRouter.browserHistory.push('/login');
	      } else {
	        if (localStorage.user_id) {
	          var uid = localStorage.user_id;
	        } else {
	          uid = 0;
	        }
	        var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1, source: source, campaign: campaign, url_id: url_id };
	        var data2 = JSON.stringify(data1);
	        _jquery2.default.ajax({
	          method: 'post',
	          dataType: 'json',
	          url: baseUrl + 'addToQCart',
	          data: { req: data2 },
	          success: function (data) {
	            if (data.status === "success") {
	              this.updateCartCount();
	              _reactRouter.browserHistory.push('/quickcart');
	            } else if (data.status === "error" && data.cart_flag === 0) {
	              this.setState({
	                clearcart_status: true
	              });
	            } else if (data.status === "error" && data.message === "Product already added to the cart") {
	              this.setState({
	                already_added_status: true
	              });
	            }
	          }.bind(this),
	          error: function error(err) {}
	        });
	      }
	    }
	  }, {
	    key: 'addToCart',
	    value: function addToCart(deal_id) {
	      if (localStorage.source) {
	        var source = localStorage.getItem('source');
	      } else {
	        source = '';
	      }
	      if (localStorage.campaign) {
	        var campaign = localStorage.getItem('campaign');
	      } else {
	        campaign = '';
	      }
	      if (localStorage.url_id) {
	        var url_id = localStorage.getItem('url_id');
	      } else {
	        url_id = '';
	      }
	      if (!localStorage.token && !localStorage.user_id) {
	        _reactRouter.browserHistory.push('/login');
	      } else {
	        if (localStorage.user_id) {
	          var uid = localStorage.user_id;
	        } else {
	          uid = 0;
	        }
	        var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1, source: source, campaign: campaign, url_id: url_id };
	        var data2 = JSON.stringify(data1);
	        _jquery2.default.ajax({
	          method: 'post',
	          dataType: 'json',
	          url: baseUrl + 'quickBuy',
	          data: { req: data2 },
	          success: function (data) {
	            if (data.status === "success") {
	              // this.updateCartCount();
	              _reactRouter.browserHistory.push('/mycart');
	            } else if (data.status === "error" && data.cart_flag === 0) {
	              this.setState({
	                clearcart_status: true
	              });
	            } else if (data.status === "error" && data.message === "Product already added to the cart") {
	              this.setState({
	                already_added_status: true
	              });
	            } else if (data.status === "error" && data.message === "Token mismatch") {
	              localStorage.removeItem('token');
	              localStorage.removeItem('user_id');
	              _reactRouter.browserHistory.push('/login');
	            }
	          }.bind(this),
	          error: function error(err) {}
	        });
	      }
	    }
	  }, {
	    key: 'ShareFunc',
	    value: function ShareFunc(evnt) {
	      var _this3 = this;
	
	      var data1 = { from: 'mobile_web', type: 1, did: evnt };
	      var data2 = JSON.stringify(data1);
	      _jquery2.default.ajax({
	        method: 'POST',
	        url: baseUrl + 'createTinyurl',
	        dataType: 'json',
	        data: { req: data2 },
	        success: function (data) {
	          this.setState({
	            msg: data.msg,
	            shareUrl: data.tinyurl
	          });
	        }.bind(this),
	        error: function error(err) {}
	      });
	      this.setState({ open: !this.state.open });
	      setTimeout(function () {
	        _this3.setState({ open: false });
	      }, 5000);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var mydata = this.props.data;
	      var shareUrl = this.state.shareUrl;
	      var title = "Hey! Click here " + shareUrl + " to check " + mydata.brand_name + " " + mydata.quantity + " from AquaDeals.";
	      return _react2.default.createElement(
	        'div',
	        { className: 'list_card' },
	        mydata.promo_ribbion ? _react2.default.createElement(
	          'i',
	          { className: 'ribbon_img' },
	          _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + mydata.promo_ribbion, alt: '' })
	        ) : '',
	        mydata.dealcount > 1 ? _react2.default.createElement(
	          _reactRouter.Link,
	          { to: "/subdeals/" + mydata.pro_id },
	          _react2.default.createElement(
	            'div',
	            { className: 'list_img' },
	            _react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/' + mydata.image, alt: 'Deal', role: 'presentation' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'list_txt' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              mydata.brand_name,
	              ' ',
	              mydata.quantity
	            ),
	            _react2.default.createElement(
	              'h5',
	              null,
	              mydata.brand_name
	            ),
	            mydata.dealcount >= 2 ? _react2.default.createElement(
	              'h3',
	              null,
	              mydata.dealcount,
	              ' deals available'
	            ) : '',
	            mydata.over_rate >= 1 ? _react2.default.createElement(
	              'h6',
	              null,
	              _react2.default.createElement('i', { className: 'glyphicon glyphicon-star' }),
	              mydata.over_rate
	            ) : _react2.default.createElement(
	              'h6',
	              null,
	              _react2.default.createElement('i', { className: 'glyphicon glyphicon-star no_star' })
	            )
	          )
	        ) : _react2.default.createElement(
	          _reactRouter.Link,
	          { to: "/pdetails/" + mydata.url_dtype_name + "/" + mydata.url_cat_name + "/" + mydata.url_brand_name + "/" + mydata.url_product_name + "/" + mydata.pro_id + "/" + mydata.id },
	          _react2.default.createElement(
	            'div',
	            { className: 'list_img' },
	            _react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/' + mydata.image, alt: 'Deal', role: 'presentation' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'list_txt' },
	            mydata.brand_name ? _react2.default.createElement(
	              'h4',
	              null,
	              mydata.brand_name,
	              ' ',
	              mydata.quantity
	            ) : '',
	            _react2.default.createElement(
	              'h5',
	              null,
	              mydata.brand_name
	            ),
	            mydata.dealcount >= 2 ? _react2.default.createElement(
	              'h3',
	              null,
	              mydata.dealcount,
	              ' deals available'
	            ) : '',
	            mydata.pricediff ? _react2.default.createElement(
	              'h3',
	              null,
	              'aquacash discount \u20B9',
	              mydata.pricediff
	            ) : '',
	            mydata.over_rate >= 1 ? _react2.default.createElement(
	              'h6',
	              null,
	              _react2.default.createElement('i', { className: 'glyphicon glyphicon-star' }),
	              mydata.over_rate
	            ) : _react2.default.createElement(
	              'h6',
	              null,
	              _react2.default.createElement('i', { className: 'glyphicon glyphicon-star no_star' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { className: 'share_list', onClick: function onClick() {
	              _this4.ShareFunc(mydata.id);
	            } },
	          _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/share1.png', alt: '' })
	        ),
	        mydata.deal_views > 0 ? _react2.default.createElement(
	          'h6',
	          { className: 'views_eye' },
	          _react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', width: '17px', role: 'presentation' }),
	          ' ',
	          mydata.deal_views,
	          ' ',
	          mydata.deal_views > 1 ? 'Views' : 'View',
	          ' '
	        ) : '',
	        mydata.dealcount >= 2 ? '' : _react2.default.createElement(
	          'a',
	          { className: 'quick_buy_img', onClick: function onClick() {
	              return _this4.addToQuickCart(mydata.id);
	            } },
	          _react2.default.createElement('img', { src: baseAssets + "images/icons/quick_buy.png", alt: ' ', width: '50px' })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { className: 'share_panel', collapsible: true, expanded: this.state.open },
	            _react2.default.createElement(
	              FacebookShareButton,
	              { url: shareUrl, quote: title, className: 'test_share' },
	              _react2.default.createElement(FacebookIcon, { size: 32, round: true })
	            ),
	            _react2.default.createElement(
	              TwitterShareButton,
	              { url: shareUrl, quote: title, className: 'test_share' },
	              _react2.default.createElement(TwitterIcon, { size: 32, round: true })
	            ),
	            _react2.default.createElement(
	              GooglePlusShareButton,
	              { url: shareUrl, className: 'test_share' },
	              _react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal,
	          { className: 'm_pro_full_dtls_modal', show: this.state.clearcart_status, onHide: this.close },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Title,
	              { style: { fontSize: '16px', color: '#333' } },
	              'Alert'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	              'h4',
	              { style: { fontSize: '14px', color: '#333' } },
	              'You can\'t have multiple seller items in the cart. Empty existing cart & add this item ',
	              mydata.title,
	              '?'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Footer,
	            { className: 'modal_footer' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
	              'NO'
	            ),
	            _react2.default.createElement(
	              'a',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.Button,
	                { style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: function onClick() {
	                    _this4.replaceCartItems(mydata.deal_id, mydata.min_qty);
	                  } },
	                'YES'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal,
	          { className: 'm_pro_full_dtls_modal', show: this.state.already_added_status, onHide: this.close },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Title,
	              { style: { fontSize: '16px', color: '#333' } },
	              'Alert'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	              'h4',
	              { style: { fontSize: '14px', color: '#333' } },
	              'Product already added to the cart'
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Footer,
	            { className: 'modal_footer' },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              { style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
	              'OK'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProductsList;
	}(_react.Component);

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactShare = __webpack_require__(18);
	
	var _reactInfiniteScrollComponent = __webpack_require__(57);
	
	var _reactInfiniteScrollComponent2 = _interopRequireDefault(_reactInfiniteScrollComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	// /pdeals/:BrandName/:CatName/:Tid/:Type/:DType
	// /pdeals/:Type/:CatName/:Tid
	
	var ProductDetails = function (_Component) {
		_inherits(ProductDetails, _Component);
	
		function ProductDetails(props) {
			_classCallCheck(this, ProductDetails);
	
			var _this = _possibleConstructorReturn(this, (ProductDetails.__proto__ || Object.getPrototypeOf(ProductDetails)).call(this, props));
	
			_this.state = {
				tid: _this.props.params.Tid,
				type: _this.props.params.Type,
				dtype: _this.props.params.DType,
				pdeals: [],
				totdata: '',
				prevPath: '',
				brands: [],
				categories: [],
				brands_status: false,
				cat_status: false,
				cat_sort_status: false,
				nodata: false,
				open: false,
				web_title: '',
				web_desc: '',
				loadmore_number: 2,
				loadmore_status: 0,
				set_type: '',
				next_page: '',
				sort_list: [],
	
				cart_count: 0,
				sort_title: 'Sort By',
				seo_title: '',
				seo_desc: '',
				loading_gif: false,
				loading_more_status: false,
	
				deal_type_status: false,
				deal_types: [],
				ad_guarantee_flag: 0,
				mob_loading: false
			};
			_this.getBrands = _this.getBrands.bind(_this);
			_this.getSelectedBrand = _this.getSelectedBrand.bind(_this);
			_this.loadMoreDeals = _this.loadMoreDeals.bind(_this);
			_this.getDeviceId = _this.getDeviceId.bind(_this);
			_this.getSelectedCategorySort = _this.getSelectedCategorySort.bind(_this);
			_this.getCartCount = _this.getCartCount.bind(_this);
			_this.fetchData = _this.fetchData.bind(_this);
			_this.refresh = _this.refresh.bind(_this);
			_this.getSelectedDType = _this.getSelectedDType.bind(_this);
			// this.getCategories=this.getCategories.bind(this);
			return _this;
		}
	
		_createClass(ProductDetails, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				// /pdeals/:BrandName/:CatName/:Tid/:Type/:DType
				// /pdeals/:Type/:CatName/:Tid
				if (screen.width >= 800) {
					if (this.props.params.DTpe) {
						window.location.href = "/web/pdeals/" + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Tid + "/" + this.props.params.Type + "/" + this.props.params.DType;
					}
				}
				if (this.props.params.BrandName && this.props.params.CatName && this.props.params.Tid && this.props.params.Type && this.props.params.DType) {
					localStorage.setItem('m_r_p_deals', "/pdeals/" + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Tid + "/" + this.props.params.Type + "/" + this.props.params.DType);
				}
				if (!this.props.params.BrandName && !this.props.params.DType && this.props.params.Tid) {
					localStorage.setItem('m_r_p_deals', '/pdeals/' + this.props.params.Type + '/' + this.props.params.CatName + '/' + this.props.params.Tid);
				}
				// else
				// {
				// 	localStorage.removeItem('m_r_p_deals');	
				// }
				if (localStorage.user_id && localStorage.token) {
					this.getCartCount();
				}
	
				this.getDeviceId();
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('w_r_s_deals');
				localStorage.removeItem('m_r_s_deals');
				localStorage.removeItem('subdeals');
				//localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('bid');
				localStorage.removeItem('cat_sort');
				localStorage.removeItem('url');
	
				this.getBrands();
	
				var data1 = '';
				var data2 = '';
				var get_function = '';
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (this.state.type === 'tag') {
					data1 = { from: 'mobile_web', uid: uid, type: 'tag', dtype: 2, tid: this.props.params.Tid };
					data2 = JSON.stringify(data1);
					get_function = 'getProductbycat_brand';
					this.get_product_list(data2, baseUrl, get_function);
				}
				if (this.state.type === 'offers') {
					data1 = { from: 'mobile_web', uid: uid, deal_offer_type: this.state.dtype, type: '' };
					data2 = JSON.stringify(data1);
					get_function = 'getProductbycat_brand';
					this.get_product_list(data2, baseUrl, get_function);
				}
				var get_cat_id = 0;
				if (localStorage.cat_id) {
					get_cat_id = localStorage.getItem('cat_id');
				} else {
					get_cat_id = 0;
				}
				if (this.state.type === 'Pcategory') {
					data1 = { from: 'mobile_web', uid: uid, type: this.state.type, tid: this.state.tid, dtype: this.state.dtype, cat_id: get_cat_id, deal_ids: this.props.params.Dids };
					data2 = JSON.stringify(data1);
					get_function = 'getProductbycat_brand';
					this.get_product_list(data2, baseUrl, get_function);
				}
				if (this.state.type === 'brand') {
					data1 = { from: 'mobile_web', uid: uid, type: this.state.type, tid: this.state.tid, dtype: this.state.dtype, cat_id: get_cat_id };
					data2 = JSON.stringify(data1);
					get_function = 'getProductbycat_brand';
					this.get_product_list(data2, baseUrl, get_function);
				}
				// else
				// {
				//     data1= {discount: this.state.tid, discount_type: this.state.dtype, discount_opr: this.state.type};
				//     data2= JSON.stringify(data1);get_function='getNewsearch';
				//     this.get_product_list(data2,baseUrl,get_function);
				// }
			}
		}, {
			key: 'refresh',
			value: function refresh() {
				console.log("");
			}
		}, {
			key: 'fetchData',
			value: function fetchData() {
				// this.state.next_page, this.state.set_type,this.props.params.Tid,this.props.params.DType
				var num = this.state.next_page;
				var type = this.state.set_type;
				if (this.props.params.DType) {
					var dtype = this.props.params.DType;
				} else {
					dtype = 0;
				}
				// var dtype=this.props.params.DType;
				var tid = this.props.params.Tid;
	
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				this.setState({
					// loading_gif:true,
					loading_more_status: true,
					mob_loading: true
				});
	
				var getfunc = "";
				var data1 = "";
				var data2 = "";
				type = this.props.params.Type;
				if (type === "all") {
					data1 = { from: 'mobile_web', uid: uid, page: num, type: dtype, limit: 20 };
					data2 = JSON.stringify(data1);
					getfunc = "getPoductDeals";
				}
				if (type === "Pcategory") {
					data1 = { from: 'mobile_web', uid: uid, page: num, dtype: dtype, type: type, tid: tid, limit: 20 };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				}
				if (type === "brand") {
					data1 = { from: 'mobile_web', uid: uid, page: num, dtype: dtype, type: type, tid: tid, limit: 20 };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				}
				if (type === "partner") {
					data1 = { from: 'mobile_web', uid: uid, page: num, dtype: 0, type: type, tid: tid, limit: 20 };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				} else {
					data1 = { from: 'mobile_web', uid: uid, page: num, dtype: dtype, type: type, tid: tid, limit: 20 };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				}
				if (this.state.loadmore_status === 1) {
					this.setState({
						// loading_gif:true,
						loadmore_status: true,
						mob_loading: true
					});
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + getfunc,
						success: function (data) {
							if (data.products) {
								if (data.load_more === 1 || data.products.length > 0) {
									this.setState({
										pdeals: this.state.pdeals.concat(data.products),
										offer: data,
										todata: data,
										loadmore_status: data.load_more,
										set_type: data.set_type,
										next_page: data.next_page,
										loading_gif: false,
										loading_more_status: false,
										mob_loading: false
									});
								} else {
									this.setState({
										set_type: data.set_type,
										next_page: data.next_page,
										loadmore_status: data.load_more,
										loading_gif: false,
										loading_more_status: false,
										mob_loading: false
									});
								}
							} else {
								if (data.load_more === 1 || data.result.length > 0) {
									this.setState({
										pdeals: this.state.pdeals.concat(data.result),
										// feedsList: this.state.feedsList.concat(data.result),
										set_type: data.set_type,
										next_page: data.next_page,
										loadmore_status: data.load_more,
										loading_gif: false,
										loading_more_status: false,
										mob_loading: false
									});
								} else {
									this.setState({
										set_type: data.set_type,
										next_page: data.next_page,
										loadmore_status: data.load_more,
										loading_gif: false,
										loading_more_status: false,
										mob_loading: false
									});
								}
							}
						}.bind(this),
						error: function error(err) {
							this.setState({
								loading_gif: false,
								loading_more_status: false,
								mob_loading: false
							});
						}
					});
				} else {
					this.setState({
						loading_more_status: false,
						mob_loading: false
					});
				}
			}
		}, {
			key: 'getCartCount',
			value: function getCartCount() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							cart_count: data.cart_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getDeviceId',
			value: function getDeviceId() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'mobile_web', id: uid, device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getDeviceId',
					dataType: 'json',
					data: { req: data2 },
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'loadMoreDeals',
			value: function loadMoreDeals(num, type, tid, dtype) {
				var getfunc = "";
				var data1 = "";
				var data2 = "";
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (type === "all") {
					// alert(type);
					data1 = { from: 'mobile_web', uid: uid, page: num, type: dtype };
					data2 = JSON.stringify(data1);
					getfunc = "getPoductDeals";
				}
				if (type === "Pcategory") {
					data1 = { from: 'mobile_web', uid: uid, page: num, dtype: dtype, type: type, tid: tid, bid: localStorage.brand };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				}
				if (type === "brand") {
					data1 = { from: 'mobile_web', uid: uid, page: num, dtype: dtype, type: type, tid: tid, cat_id: localStorage.cat_id };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				}
	
				var products = "";
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + getfunc,
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							totdata: data,
							loadmore_status: data.load_more,
							set_type: data.set_type,
							next_page: data.next_page
						});
						this.setState({
							pdeals: this.state.pdeals.concat(data.result)
						});
					}.bind(this),
					error: function error(err) {
						// console.log(err);
					}
				});
				return products;
			}
		}, {
			key: 'getBrands',
			value: function getBrands() {
				if (this.props.params.DType) {
					var dtype = this.props.params.DType;
				} else {
					dtype = 0;
				}
				var data1 = { from: 'mobile_web', type: this.state.type, tid: this.state.tid, dtype: dtype };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'filterBrandCat',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.brands_lst.length > 1) {
							this.setState({
								brands_status: true
							});
						}
						if (data.cat_lst.length > 1) {
							this.setState({
								cat_status: true
							});
						}
						if (data.deal_types.length > 1) {
							this.setState({
								deal_type_status: true
							});
						}
						this.setState({
							brands: data.brands_lst,
							categories: data.cat_lst,
							sort_list: data.sort,
							deal_types: data.deal_types
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSelectedBrand',
			value: function getSelectedBrand(b) {
				this.setState({
					loading_gif: true
				});
				localStorage.setItem('brand', b);
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (this.state.type === "offers") {
					var data1 = { from: "mobile_web", "tid": "", "type": "combo", "cat_id": "cat_id", "uid": uid, "deal_offer_type": "3", "bid": b, "lat1": "", "long1": "", "sort": localStorage.getItem('cat_sort') };
				} else {
					data1 = { from: 'mobile_web', uid: uid, type: this.state.type, tid: this.state.tid, dtype: this.state.dtype, bid: b };
				}
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true,
								loading_gif: false
							});
						} else {
							this.setState({
								nodata: false,
								loading_gif: false
							});
						}
						this.setState({
							pdeals: data.result,
							totdata: data,
							loadmore_status: data.load_more,
							set_type: data.set_type,
							next_page: data.next_page
						});
						if (data.status === 'error') {
							localStorage.removeItem('cat_id');
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSelectedCategory',
			value: function getSelectedCategory(c) {
				this.setState({
					loading_gif: true
				});
				localStorage.setItem('cat_id', c);
				localStorage.removeItem('brand');
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var data1 = { from: 'mobile_web', uid: uid, type: this.state.type, tid: this.state.tid, dtype: this.state.dtype, cat_id: c };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true,
								loading_gif: false
							});
						} else {
							this.setState({
								nodata: false,
								loading_gif: false
							});
						}
						this.setState({
							pdeals: data.result,
							totdata: data,
							loadmore_status: data.load_more,
							set_type: data.set_type,
							next_page: data.next_page
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSelectedCategorySort',
			value: function getSelectedCategorySort(c, name) {
				this.setState({
					loading_gif: true
				});
				// localStorage.removeItem('brand');
				var catId = 0;
				localStorage.setItem('cat_sort', c);
	
				if (localStorage.cat_id) {
					catId = localStorage.getItem('cat_id');
				} else {
					catId = 0;
				}
				this.setState({
					sort_title: name
				});
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (this.state.type === 'offers') {
					var data1 = { from: "mobile_web", "tid": "", "type": "", "uid": uid, "deal_offer_type": "3", "bid": localStorage.getItem('brand'), "lat1": "", "long1": "", "sort": c };
				} else {
					data1 = { from: 'mobile_web', uid: uid, type: this.state.type, tid: this.state.tid, dtype: this.state.dtype, cat_id: catId, sort: c };
				}
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true,
								loading_gif: false
							});
						} else {
							this.setState({
								nodata: false,
								loading_gif: false
							});
						}
						this.setState({
							pdeals: data.result,
							totdata: data,
							loadmore_status: data.load_more,
							set_type: data.set_type,
							next_page: data.next_page
						});
						localStorage.removeItem('cat_sort');
						localStorage.removeItem('cat_id');
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSelectedBrandSort',
			value: function getSelectedBrandSort(b, name) {
				this.setState({
					loading_gif: true
				});
				// localStorage.removeItem('brand');
				var bid = 0;
				localStorage.setItem('bid_sort', b);
				if (localStorage.brand) {
					bid = localStorage.getItem('brand');
				} else {
					bid = 0;
				}
				this.setState({
					sort_title: name
				});
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (this.state.type === 'offers') {
					var data1 = { from: "mobile_web", "tid": "", "type": "", "uid": uid, "deal_offer_type": "3", "bid": localStorage.getItem('brand'), "lat1": "", "long1": "", "sort": b };
				} else {
					data1 = { from: 'mobile_web', uid: uid, type: this.state.type, tid: this.state.tid, dtype: this.state.dtype, bid: bid, sort: b };
				}
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true,
								loading_gif: false
							});
						} else {
							this.setState({
								nodata: false,
								loading_gif: false
							});
						}
						this.setState({
							pdeals: data.result,
							totdata: data,
							loadmore_status: data.load_more,
							set_type: data.set_type,
							next_page: data.next_page
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSelectedDType',
			value: function getSelectedDType(dtype) {
				this.setState({
					loading_gif: true
				});
				// localStorage.removeItem('brand');
				// var catId=0;
	
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (this.state.type === 'offers') {
					var data1 = { from: "mobile_web", "tid": "", "type": "", "uid": uid, "deal_offer_type": "3", "bid": localStorage.getItem('brand'), "lat1": "", "long1": "", "sort": '' };
				} else {
					data1 = { from: 'mobile_web', uid: uid, type: this.state.type, tid: this.state.tid, dtype: dtype, sort: '' };
				}
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true,
								loading_gif: false
							});
						} else {
							this.setState({
								nodata: false,
								loading_gif: false
							});
						}
						this.setState({
							pdeals: data.result,
							totdata: data,
							loadmore_status: data.load_more,
							set_type: data.set_type,
							next_page: data.next_page
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'get_product_list',
			value: function get_product_list(data2, baseUrl, get_function) {
				this.setState({
					mob_loading: true
				});
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + get_function,
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true,
								mob_loading: false
							});
						} else {
							this.setState({
								nodata: false,
								mob_loading: false
							});
						}
						this.setState({
							pdeals: data.result,
							totdata: data,
							loadmore_status: data.load_more,
							set_type: data.set_type,
							next_page: data.next_page,
							seo_desc: '',
							mob_loading: false
						});
						if (this.props.params.Type === "Pcategory") {
							if (this.props.params.BrandName === "feed") {
								document.title = 'Buy Aqua ' + data.cat_name + ' Feed Products Online | AquaDeals';
								document.getElementsByTagName("META")[2].content = 'Browse quality Aquaculture ' + data.cat_name + ' feed deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
							} else if (this.props.params.BrandName === "health-care") {
								document.title = 'Buy Aqua ' + data.cat_name + ' Products Online | AquaDeals';
								document.getElementsByTagName("META")[2].content = 'Browse quality Aquaculture ' + data.cat_name + ' Products & Supplements deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
							} else if (this.props.params.BrandName === "aerators") {
								document.title = 'Buy Aqua ' + data.cat_name + ' Products Online | AquaDeals';
								document.getElementsByTagName("META")[2].content = 'Browse quality Aquaculture ' + data.cat_name + ' deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
							} else {
								document.title = 'Buy Aqua ' + data.cat_name + ' Products Online | AquaDeals';
								document.getElementsByTagName("META")[2].content = 'Browse quality Aquaculture ' + data.cat_name + ' deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
							}
						} else if (this.props.params.Type === 'brand') {
							if (this.props.params.BrandName === "feed") {
								document.title = 'Buy ' + data.cat_name + ' Aqua Products Online | AquaDeals';
								document.getElementsByTagName("META")[2].content = "Search " + data.cat_name + " branded quality Aquaculture Fish / Vannamei Shrimp " + data.dtype_name + " deals, choose the best deal price from our nearest partner and avail free shipment";
							} else if (this.props.params.BrandName === "health-care") {
								document.title = 'Buy ' + data.cat_name + ' Aqua Products Online | AquaDeals';
								document.getElementsByTagName("META")[2].content = "Search " + data.cat_name + " branded quality Aquaculture Fish / Vannamei Shrimp " + data.dtype_name + " deals, choose the best deal price from our nearest partner and avail free shipment";
							} else if (this.props.params.BrandName === "aerators") {
								document.title = 'Buy ' + data.cat_name + ' Aqua Products Online | AquaDeals';
								document.getElementsByTagName("META")[2].content = "Search " + data.cat_name + " branded quality Aquaculture " + data.dtype_name + " deals, choose the best deal price from our nearest partner and avail free shipment";
							} else {
								document.title = 'Buy ' + data.cat_name + ' Aqua Products Online | AquaDeals';
								document.getElementsByTagName("META")[2].content = "Search " + data.cat_name + " branded quality Aquaculture Fish / Vannamei Shrimp " + data.dtype_name + " deals, choose the best deal price from our nearest partner and avail free shipment";
							}
						}
						if (data.status === 'error') {
							if (this.props.params.DType === "2" && this.props.params.Type !== 'all') {
								var nodata_red_url = '/pdeals/feed/all/2';
							} else if (this.props.params.DType === "4" && this.props.params.Type !== 'all') {
								nodata_red_url = '/pdeals/health-care/all/4';
							} else if (this.props.params.DType === "3" && this.props.params.Type !== 'all') {
								nodata_red_url = '/pdeals/machine-equip/all/3';
							} else if (this.props.params.DType === "5" && this.props.params.Type !== 'all') {
								nodata_red_url = '/pdeals/hatchery-machinery/all/5';
							} else if (this.props.params.DType === "7" && this.props.params.Type !== 'all') {
								nodata_red_url = '/pdeals/hatchery-health-care/all/7';
							} else {
								nodata_red_url = '/home';
							}
							_reactRouter.browserHistory.push(nodata_red_url);
							location.reload();
						}
						this.setState({
							mob_loading: false
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				(0, _jquery2.default)('body').css('background', '#fff');
				var products = this.state.pdeals.map(function (product, index) {
					return _react2.default.createElement(ProductsList, { key: product.pid, data: product, onUpdate: function onUpdate() {
							return _this2.getCartCount();
						} });
				});
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals pdeals_page mob_pdeals_page' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ onClick: function onClick() {
											_reactRouter.browserHistory.goBack();
										} },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
									)
								),
								this.state.totdata.cat_name ? this.state.totdata.cat_name : '',
								' '
							),
							_react2.default.createElement(
								'a',
								{ href: '/', title: 'Home', className: 'home_logo1' },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
							),
							_react2.default.createElement(
								'a',
								{ className: 'mob_cart_btn', href: '/mycart' },
								_react2.default.createElement('img', { alt: '', src: baseAssets + 'icons/web_icons/cart_icon.png' }),
								this.state.cart_count > 0 ? _react2.default.createElement(
									'span',
									{ className: this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count" },
									this.state.cart_count
								) : ''
							)
						)
					),
					this.state.mob_loading ? _react2.default.createElement(
						'div',
						{ className: 'mob_loading' },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/mob_loading.gif', alt: 'Loading' })
					) : '',
					_react2.default.createElement(
						'div',
						{ className: 'pag_cntnt' },
						'\xA0'
					),
					this.state.loading_gif ? _react2.default.createElement(
						'i',
						{ className: 'mob_loading' },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/mob_loading.gif', alt: 'Loading' })
					) : '',
					_react2.default.createElement(
						'section',
						{ className: '' },
						this.state.nodata ? _react2.default.createElement(
							'div',
							{ className: 'no_data' },
							_react2.default.createElement(
								'h3',
								null,
								'No Deals Available'
							),
							_react2.default.createElement(
								'p',
								null,
								'Need something here ? ',
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: "/customer_care" },
									'CONTACT US'
								),
								' now !'
							)
						) : '',
						_react2.default.createElement(
							_reactInfiniteScrollComponent2.default,
							{
								pullDownToRefresh: true,
								pullDownToRefreshContent: _react2.default.createElement(
									'h3',
									{ style: { textAlign: 'center' } },
									'\u2193'
								),
								releaseToRefreshContent: _react2.default.createElement(
									'h3',
									{ style: { textAlign: 'center' } },
									'\u2191'
								),
								refreshFunction: this.refresh,
								next: this.fetchData,
								hasMore: true,
								scrollThreshold: 0.8,
								loader: _react2.default.createElement('h4', null),
								endMessage: _react2.default.createElement(
									'p',
									{ style: { textAlign: 'center' } },
									_react2.default.createElement('b', null)
								) },
							products
						),
						this.state.loading_more_status ? _react2.default.createElement(
							'div',
							{ className: 'loading_more_sym' },
							_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/mob_loading.gif', alt: 'Loading' })
						) : ''
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'seed_sort dsl_srt' },
						_react2.default.createElement(
							'ul',
							null,
							this.state.cat_status ? _react2.default.createElement(
								'li',
								{ className: 'col-md-6 col-xs-6 col-sm-6 ' },
								_react2.default.createElement(
									_reactBootstrap.ButtonToolbar,
									null,
									_react2.default.createElement(
										_reactBootstrap.DropdownButton,
										{ className: 'test_filter_4', noCaret: true, onClick: this.getSorts, title: this.state.sort_title, dropup: true },
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ header: true },
											'Sort By'
										),
										this.state.sort_list.map(function (cat, index) {
											return _react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ className: 'seed_list1', eventKey: cat.id, onClick: function onClick() {
														return _this2.getSelectedCategorySort(cat.id, cat.name);
													} },
												cat.name
											);
										})
									)
								)
							) : _react2.default.createElement(
								'li',
								{ className: 'col-md-6 col-xs-6 col-sm-6 ' },
								_react2.default.createElement(
									_reactBootstrap.ButtonToolbar,
									null,
									_react2.default.createElement(
										_reactBootstrap.DropdownButton,
										{ className: 'test_filter_4', noCaret: true, onClick: this.getSorts, title: this.state.sort_title, dropup: true },
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ header: true },
											'Sort By'
										),
										this.state.sort_list.map(function (cat, index) {
											return _react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ className: 'seed_list1', eventKey: cat.id, onClick: function onClick() {
														return _this2.getSelectedBrandSort(cat.id, cat.name);
													} },
												cat.name
											);
										})
									)
								)
							),
							this.state.brands_status ? _react2.default.createElement(
								'li',
								{ className: 'col-md-6 col-xs-6 col-sm-6 coast_list1' },
								_react2.default.createElement(
									_reactBootstrap.ButtonToolbar,
									null,
									_react2.default.createElement(
										_reactBootstrap.DropdownButton,
										{ className: 'test_filter_1', noCaret: true, onClick: this.getBrands, title: 'By Brand', dropup: true },
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ header: true },
											'By Brand (',
											this.state.brands.length,
											')'
										),
										this.state.brands.map(function (brand, index) {
											return _react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ eventKey: brand.id, className: 'seed_list1', onClick: function onClick() {
														return _this2.getSelectedBrand(brand.id);
													} },
												brand.name
											);
										})
									)
								)
							) : '',
							this.state.cat_status ? _react2.default.createElement(
								'li',
								{ className: 'col-md-6 col-xs-6 col-sm-6 coast_list2' },
								_react2.default.createElement(
									_reactBootstrap.ButtonToolbar,
									null,
									_react2.default.createElement(
										_reactBootstrap.DropdownButton,
										{ className: 'test_filter_2', noCaret: true, onClick: this.getCoasts, title: 'By Category', dropup: true },
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ header: true },
											'By Category '
										),
										this.state.categories.map(function (cat, index) {
											return _react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ className: 'seed_list1', eventKey: cat.id, onClick: function onClick() {
														return _this2.getSelectedCategory(cat.id);
													} },
												cat.name
											);
										})
									)
								)
							) : '',
							this.state.deal_type_status ? _react2.default.createElement(
								'li',
								{ className: 'col-md-6 col-xs-6 col-sm-6 coast_list2' },
								_react2.default.createElement(
									_reactBootstrap.ButtonToolbar,
									null,
									_react2.default.createElement(
										_reactBootstrap.DropdownButton,
										{ className: 'test_filter_2', noCaret: true, onClick: this.getCoasts, title: 'By Type', dropup: true },
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ header: true },
											'By Type '
										),
										this.state.deal_types.map(function (cat, index) {
											return _react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ className: 'seed_list1', eventKey: cat.id, onClick: function onClick() {
														return _this2.getSelectedDType(cat.id);
													} },
												cat.name
											);
										})
									)
								)
							) : ''
						)
					)
				);
			}
		}]);
	
		return ProductDetails;
	}(_react.Component);
	
	exports.default = ProductDetails;
	
	var ProductsList = function (_Component2) {
		_inherits(ProductsList, _Component2);
	
		function ProductsList(props) {
			_classCallCheck(this, ProductsList);
	
			var _this3 = _possibleConstructorReturn(this, (ProductsList.__proto__ || Object.getPrototypeOf(ProductsList)).call(this, props));
	
			_this3.state = {
				open: false,
				msg: '',
				shareUrl: '',
				cart_count: '',
				clearcart_status: false,
				already_added_status: false
			};
			_this3.ShareFunc = _this3.ShareFunc.bind(_this3);
			_this3.addToCart = _this3.addToCart.bind(_this3);
			_this3.updateCartCount = _this3.updateCartCount.bind(_this3);
			_this3.close = _this3.close.bind(_this3);
			_this3.replaceCartItems = _this3.replaceCartItems.bind(_this3);
			_this3.addToQuickCart = _this3.addToQuickCart.bind(_this3);
			_this3.addToQuickCart_Onload = _this3.addToQuickCart_Onload.bind(_this3);
			return _this3;
		}
	
		_createClass(ProductsList, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (localStorage.user_id && localStorage.token && localStorage.quickbuy_onload) {
					this.addToQuickCart_Onload();
					localStorage.removeItem('quickbuy_onload');
					localStorage.removeItem('quickbuy_deal_id');
				}
			}
		}, {
			key: 'addToQuickCart_Onload',
			value: function addToQuickCart_Onload() {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('quickbuy_onload', '1');
					// localStorage.setItem('quickbuy_deal_id',deal_id);
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.user_id;
					} else {
						uid = 0;
					}
					if (localStorage.quickbuy_deal_id) {
						var deal_id = localStorage.quickbuy_deal_id;
					} else {
						deal_id = 0;
					}
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
	
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'post',
						dataType: 'json',
						url: baseUrl + 'addToQCart',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.updateCartCount();
								_reactRouter.browserHistory.push('/quickcart');
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							} else if (data.status === "error" && data.cart_flag === 0) {
								this.setState({
									clearcart_status: true
								});
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							}
							localStorage.removeItem('quickbuy_onload');
							localStorage.removeItem('quickbuy_deal_id');
						}.bind(this),
						error: function error(err) {}
					});
				}
				localStorage.removeItem('quickbuy_onload');
				localStorage.removeItem('quickbuy_deal_id');
			}
		}, {
			key: 'replaceCartItems',
			value: function replaceCartItems(deal_id, quantity) {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1, quantity: quantity, pl_size: 0, salinity: 0, pickup_date: 0, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'replaceCart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								clearcart_status: false
							});
							_reactRouter.browserHistory.push('/mycart');
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					clearcart_status: false,
					already_added_status: false
				});
			}
		}, {
			key: 'updateCartCount',
			value: function updateCartCount() {
				this.props.onUpdate();
			}
		}, {
			key: 'ShareFunc',
			value: function ShareFunc(evnt) {
				var _this4 = this;
	
				var data1 = { from: 'mobile_web', type: 1, did: evnt };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'createTinyurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							msg: data.msg,
							shareUrl: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {}
				});
				this.setState({
					open: !this.state.open
				});
				setTimeout(function () {
					_this4.setState({ open: false });
				}, 5000);
			}
		}, {
			key: 'addToQuickCart',
			value: function addToQuickCart(deal_id) {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('quickbuy_onload', '1');
					localStorage.setItem('quickbuy_deal_id', deal_id);
					_reactRouter.browserHistory.push('/login');
				} else {
					var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'post',
						dataType: 'json',
						url: baseUrl + 'addToQCart',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.updateCartCount();
								_reactRouter.browserHistory.push('/quickcart');
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							} else if (data.status === "error" && data.cart_flag === 0) {
								this.setState({
									clearcart_status: true
								});
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							}
							localStorage.removeItem('quickbuy_onload');
							localStorage.removeItem('quickbuy_deal_id');
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'addToCart',
			value: function addToCart(deal_id) {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (!localStorage.user_id && !localStorage.token) {
					_reactRouter.browserHistory.push('/login');
				} else {
					var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'post',
						dataType: 'json',
						url: baseUrl + 'quickBuy',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.updateCartCount();
								_reactRouter.browserHistory.push('/mycart');
							} else if (data.status === "error" && data.cart_flag === 0) {
								this.setState({
									clearcart_status: true
								});
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
							} else if (data.status === "error" && data.message === "Token mismatch") {
								localStorage.removeItem('token');
								localStorage.removeItem('user_id');
								_reactRouter.browserHistory.push('/login');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var mydata = this.props.data;
				var shareUrl = this.state.shareUrl;
				var title = "Hey Click here " + shareUrl + " to check " + mydata.title + " from AquaDeals.";
				var description = shareUrl;
				return _react2.default.createElement(
					'div',
					{ className: "list_card" },
					mydata.promo_ribbion ? _react2.default.createElement(
						'i',
						{ className: 'ribbon_img' },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + mydata.promo_ribbion, alt: '' })
					) : '',
					mydata.dealcount >= 2 ? _react2.default.createElement(
						_reactRouter.Link,
						{ to: "/subdeals/" + mydata.url_dtype_name + "/" + mydata.url_cat_name + "/" + mydata.dtype + "/" + mydata.url_brand_name + "/" + mydata.pid },
						_react2.default.createElement(
							'div',
							{ className: 'list_img' },
							_react2.default.createElement('img', { src: mydata.image === null ? baseAssets + 'images/product_imgs/noimage1.jpg' : baseAssets + 'images/product_imgs/' + mydata.image, alt: '' })
						),
						mydata.ad_guarantee_flag === '1' ? _react2.default.createElement(
							'span',
							{ className: 'pdeals_adguarantee' },
							_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: ' ' })
						) : '',
						_react2.default.createElement(
							'div',
							{ className: 'list_txt' },
							_react2.default.createElement(
								'h4',
								null,
								mydata.title + ' ' + mydata.quantity
							),
							mydata.brand_name ? _react2.default.createElement(
								'h5',
								null,
								mydata.brand_name
							) : '',
							mydata.dealcount >= 2 ? _react2.default.createElement(
								'h3',
								null,
								mydata.dealcount,
								' deals available'
							) : '',
							mydata.over_rate >= 1 ? _react2.default.createElement(
								'h6',
								null,
								_react2.default.createElement(
									'i',
									{ className: 'm_star_rate' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/star_filled.png', width: '16px', role: 'presentation' })
								),
								mydata.over_rate
							) : _react2.default.createElement(
								'h6',
								null,
								_react2.default.createElement(
									'i',
									{ className: 'm_nostar_rate' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/star_gray.png', width: '17px', role: 'presentation' })
								)
							)
						)
					) : _react2.default.createElement(
						_reactRouter.Link,
						{ to: "/pdetails/" + mydata.url_dtype_name + "/" + mydata.url_cat_name + "/" + mydata.url_brand_name + "/" + mydata.url_product_name + "/" + mydata.pid + "/" + mydata.deal_id },
						_react2.default.createElement(
							'div',
							{ className: 'list_img' },
							_react2.default.createElement('img', { src: mydata.image === null ? baseAssets + 'images/product_imgs/noimage1.jpg' : baseAssets + 'images/product_imgs/' + mydata.image, alt: ' ' })
						),
						mydata.ad_guarantee_flag === '1' ? _react2.default.createElement(
							'span',
							{ className: 'pdeals_adguarantee' },
							_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: ' ' })
						) : '',
						_react2.default.createElement(
							'div',
							{ className: 'list_txt' },
							_react2.default.createElement(
								'h4',
								null,
								mydata.title,
								' ',
								mydata.quantity
							),
							mydata.brand_name ? _react2.default.createElement(
								'h5',
								null,
								mydata.brand_name
							) : '',
							mydata.pricediff === "" ? _react2.default.createElement(
								'h3',
								null,
								'MRP \u20B9 ',
								mydata.mrp
							) : '',
							mydata.dealcount >= 2 ? _react2.default.createElement(
								'h3',
								null,
								mydata.dealcount,
								' deals available'
							) : '',
							mydata.pricediff ? _react2.default.createElement(
								'h3',
								null,
								'aquacash discount \u20B9 ',
								mydata.pricediff
							) : '',
							mydata.over_rate >= 1 ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'str_blk' },
									_react2.default.createElement(
										'i',
										{ className: 'm_star_rate' },
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/star_filled.png', width: '16px', role: 'presentation' })
									),
									mydata.over_rate,
									' '
								),
								mydata.count > 0 && mydata.dealcount <= 1 ? _react2.default.createElement(
									'div',
									{ className: 'views_eye' },
									_react2.default.createElement('img', { src: __webpack_require__(262), alt: ' ', width: '17' }),
									' ',
									mydata.count,
									' ',
									mydata.count > 1 ? 'Views' : 'View'
								) : ''
							) : _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'str_blk' },
									_react2.default.createElement(
										'i',
										{ className: 'm_nostar_rate' },
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/star_gray.png', width: '17px', role: 'presentation' })
									),
									' '
								),
								mydata.count > 0 && mydata.dealcount <= 1 ? _react2.default.createElement(
									'div',
									{ className: 'views_eye' },
									_react2.default.createElement('img', { src: __webpack_require__(262), alt: ' ', width: '17' }),
									' ',
									mydata.count,
									' ',
									mydata.count > 1 ? 'Views' : 'View'
								) : ''
							)
						)
					),
					mydata.dealcount <= 1 ? _react2.default.createElement(
						_reactRouter.Link,
						{ className: 'share_list', onClick: function onClick() {
								_this5.ShareFunc(mydata.deal_id);
							} },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/share1.png', alt: 'share' })
					) : '',
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_reactBootstrap.Panel,
							{ className: 'share_panel', collapsible: true, expanded: this.state.open },
							_react2.default.createElement(
								FacebookShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share' },
								_react2.default.createElement(FacebookIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								TwitterShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share' },
								_react2.default.createElement(TwitterIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								GooglePlusShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share' },
								_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
							)
						)
					),
					mydata.dealcount >= 2 ? '' : _react2.default.createElement(
						'a',
						{ className: 'quick_buy_img', onClick: function onClick() {
								return _this5.addToQuickCart(mydata.deal_id);
							} },
						_react2.default.createElement('img', { src: __webpack_require__(256), alt: ' ', width: '40' })
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.clearcart_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#333' } },
								'You can\'t have multiple seller items in the cart. Empty existing cart & add this item ',
								mydata.title,
								'?'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'NO'
							),
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: function onClick() {
											_this5.replaceCartItems(mydata.deal_id, mydata.min_qty);
										} },
									'YES'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.already_added_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#333' } },
								'Product already added to the cart'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'OK'
							)
						)
					)
				);
			}
		}]);
	
		return ProductsList;
	}(_react.Component);

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactSwipe = __webpack_require__(125);
	
	var _reactSwipe2 = _interopRequireDefault(_reactSwipe);
	
	var _NotFound = __webpack_require__(84);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactShare = __webpack_require__(18);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _reactWebVectorIcons = __webpack_require__(29);
	
	var _reactWebVectorIcons2 = _interopRequireDefault(_reactWebVectorIcons);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var parseHtml = __webpack_require__(39);
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets//';
	// Routing Parameters :: /pdetails/:BrandName/:CatName/:Title/:Pid/:DealId
	// Routing Parameters :: /pdetails/:BrandName/:CatName/:Bname/:Title/:Pid/:DealId
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var ProductFullDetails = function (_Component) {
		_inherits(ProductFullDetails, _Component);
	
		function ProductFullDetails(props) {
			_classCallCheck(this, ProductFullDetails);
	
			var _this = _possibleConstructorReturn(this, (ProductFullDetails.__proto__ || Object.getPrototypeOf(ProductFullDetails)).call(this, props));
	
			_this.state = {};
			_this.state = {
				pid: _this.props.params.Pid,
				dealid: _this.props.params.DealId,
				pdeals: [],
				offer: '',
				pro_details: [],
				pro_deal_details: [],
				offer_details: [],
				product_attributes: [],
				swipe_product_attributes: [],
				imgs: [],
				prevPath: '',
				seller_id: '',
				tags_status: false,
				attr_status: false,
				tags: [],
				split_tags: [],
				open: false,
				desc_open: true,
				desc_flag: false,
				showModal: false,
				is_char: false,
				shareUrl: '',
				web_title: '',
				web_desc: '',
				session: localStorage.getItem('token'),
				bestprice_desc: '',
				bestprice_status: false,
				page_error_status: false,
				loading: false,
				coupons: [],
	
				new_attr_status: false,
				swipe_description_status: 1,
				desc_update_soon_status: false,
				swipe_desc_info: '',
				reqbestPrice: false,
				city: '',
				editCityAddress_status: false,
				err_cityAddress_status: false,
				err_cityAddress: '',
				recommended: '',
				coupon_first: [],
				cpns_list: '',
				min_qty: 0,
				max_qty: 0,
				min_qty1: 0,
				max_qty1: 0,
				tons: 0,
				qty: '',
				addtocart_status: false,
				addtocart_msg: '',
				clearcart_status: false,
				cart_added_status: false,
				unit_name: '',
				type: '',
				is_cart: 0,
				qty_err_status: false,
				qty_err_msg: '',
	
				free_ship_msg: '',
				user_zipcode: '',
				free_shipment: 0,
	
				err_pincode: false,
				err_pincode_msg: '',
				seo_title: '',
				seo_desc: '',
				emi_msg: '',
				emi_status: 0,
				swipe_attributes_titles: [],
				swipe_attr_status: '',
	
				cid: '',
				no_details_attr: 0,
				similar_tabs: [],
				similar_deals: [],
	
				tab_status: 0,
	
				req_pincode: '',
				req_quantity: '',
				req_state: '',
				req_city: '',
				req_doorno: '',
	
				req_confirm_modal: false,
				req_confirm_message: '',
	
				category_id: '',
				view_similar_single_deals: [],
				viewmore_cat: '',
				bid: '',
	
				wishLst_flag: '',
				page_loading: false,
				cat_sim_flag: '',
				brand_sim_flag: '',
				stage_sim_flag: '',
				similar_brand_deals_status: false,
				similar_category_deals_status: false,
				similar_stage_deals_status: false,
				similar_brand_deals: [],
				similar_category_deals: [],
				similar_stage_deals: [],
	
				// Follow section
	
				brand_follow_count: '',
				brand_likes_count: '',
				brand_like_rem_count: '',
				brand_like_status: '',
				// b_follow_status:false,
				show_about_brand: '',
				show_about_brand_flag: false,
	
				isToggle: true,
				check_swipe_id: '',
	
				ad_assist_modal: false,
				ad_guarantee: '',
				ad_guarantee_icon: '',
				ad_asst_time: 0,
				ad_asst_confirm_message: '',
				ad_asst_confirm_modal: false,
				ad_grnt_str: '',
				cart_qty: 0,
				caa_approved_flag: 0,
				caa_icon: '',
	
				time_err_status: false,
				time_err_msg: '',
				show_order_count: 0,
				order_count: '',
				free_ship_flag: 0,
	
				rotateClass: false,
				disable_button: true,
				queries: [],
				product_tabs_avail: false,
				disclaimer_flag: false,
				disclaimer_txt: '',
				visibility: false,
				currentPathname: null,
				currentSearch: null
	
				// this.scroll=this.scroll.bind(this);
			};_this.close = _this.close.bind(_this);
			_this.ShareFunc = _this.ShareFunc.bind(_this);
			// this.getTagsData=this.getTagsData.bind(this);
			_this.getDeviceId = _this.getDeviceId.bind(_this);
			_this.getswipeDescription = _this.getswipeDescription.bind(_this);
	
			_this.placeOrderModal = _this.placeOrderModal.bind(_this);
			_this.updateMinQty = _this.updateMinQty.bind(_this);
			_this.removeCartItems = _this.removeCartItems.bind(_this);
			_this.incrementMinQty = _this.incrementMinQty.bind(_this);
			_this.decrementMinQty = _this.decrementMinQty.bind(_this);
	
			_this.pincodeChange = _this.pincodeChange.bind(_this);
			_this.checkPincode = _this.checkPincode.bind(_this);
	
			_this.getAttributesTitle = _this.getAttributesTitle.bind(_this);
			//this.getswipeDescription_Initial=this.getswipeDescription_Initial.bind(this);
	
			_this.req_pincodeChange = _this.req_pincodeChange.bind(_this);
			_this.req_quantityChange = _this.req_quantityChange.bind(_this);
			_this.req_stateChange = _this.req_stateChange.bind(_this);
			_this.req_cityChange = _this.req_cityChange.bind(_this);
			_this.req_doornoChange = _this.req_doornoChange.bind(_this);
			_this.reqBestPriceSubmit = _this.reqBestPriceSubmit.bind(_this);
			_this.checkBestPrice = _this.checkBestPrice.bind(_this);
			_this.addToWishlist = _this.addToWishlist.bind(_this);
	
			_this.getSimilarBrandDeals = _this.getSimilarBrandDeals.bind(_this);
			_this.getSimilarCatDeals = _this.getSimilarCatDeals.bind(_this);
			_this.getSimilarStageDeals = _this.getSimilarStageDeals.bind(_this);
	
			// this.FollowBrand=this.FollowBrand.bind(this);
			_this.tokenCheck = _this.tokenCheck.bind(_this);
	
			_this.getAdAssistModal = _this.getAdAssistModal.bind(_this);
			_this.setAdTime = _this.setAdTime.bind(_this);
			_this.submitAdAssistData = _this.submitAdAssistData.bind(_this);
			_this.likeBrand = _this.likeBrand.bind(_this);
	
			_this.addToCartOnload = _this.addToCartOnload.bind(_this);
			_this.checkBestPriceOnload = _this.checkBestPriceOnload.bind(_this);
			_this.getAdAssistModalOnload = _this.getAdAssistModalOnload.bind(_this);
			_this.addToWishlistOnload = _this.addToWishlistOnload.bind(_this);
			_this.likeBrandOnload = _this.likeBrandOnload.bind(_this);
			return _this;
		}
	
		_createClass(ProductFullDetails, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var getProductTabs = this.props.getProductTabs;
	
				getProductTabs(this.state.pid);
				//this.props.getProductDesc(this.state.pid,nextProps.product_tabs.result[0].cid);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps) {
	
				// compare prevProps to current props and update
				if (this.props.product_tabs !== prevProps.product_tabs) {
	
					if (this.state.pid, this.props.product_tabs.result.length != 0) {
						this.props.getProductDesc(this.state.pid, this.props.product_tabs.result[0].cid);
						this.setState({
							swipe_attributes_titles: this.props.product_tabs.result,
							cid: this.props.product_tabs.result[0].cid,
							swipe_attr_status: this.props.product_tabs.result[0].cid,
							product_tabs_avail: true
						});
					}
				}
	
				if (this.props.product_desc !== prevProps.product_desc) {
					this.setState({
						swipe_desc_info: this.props.product_desc.desc
						// swipe_product_attributes:[],
						// swipe_attr_status:this.props.product_tabs.result[0].cid,
						// check_swipe_id:this.props.product_tabs.result[0].cid,
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				if (screen.width >= 800) {
					if (this.props.params.Bname) {
						window.location.href = '/web/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Bname + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.DealId;
					} else {
						window.location.href = '/web/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.DealId;
					}
				}
				this.getDeviceId();
				this.getAttributesTitle();
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('w_r_s_dt');
				localStorage.removeItem('w_r_p_dt');
				localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('subdeals');
				localStorage.removeItem('about_brand');
				localStorage.setItem('m_r_p_dt', '/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Bname + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.DealId);
				// if(!localStorage.token && !localStorage.user_id)
				// {
				//  		localStorage.setItem('m_r_p_dt','/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Bname+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.DealId)
				//  		browserHistory.push('/login');
				// }
				// this.scroll();
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: this.state.pid, deal_id: this.state.dealid, uid: uid, token: localStorage.getItem('token'), source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductDetails',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "error") {
							this.setState({
								page_error_status: true
							});
							window.location.href = data.redirect;
						}
						if (data.message === "Token mismatch") {
							this.tokenCheck();
						}
						var t = _jquery2.default.makeArray(data.tags);
						if (t[0]['tag'].length >= 1) {
							this.setState({
								tags_status: true
							});
						} else {
							this.setState({
								tags_status: false
							});
						}
						//       if(data.product_attributes.length > 0)
						//       {
						//        	this.setState({
						//        		is_char: true,
						//        		desc_flag:true,
						//        		product_attributes: data.product_attributes[0].chars,
						//        	});
						//        	if(data.product_attributes[0].chars.length > 0 )
						// 	{
						//        		this.setState({
						//        			new_attr_status: true,
						//        		});
						//        	}
						//        	else
						//        	{
						//        		this.setState({
						//        			new_attr_status:false,
						//        		});
						//        	}
						// }
						// else
						// {
						//        	this.setState({
						//        		is_char:false,
						//        		desc_flag:false,
						//        	});
						//       }
						var s = _jquery2.default.makeArray(data.pro_details);
						var o = _jquery2.default.makeArray(data.offer_details);
						this.setState({
							page_id: localStorage.getItem('cat_page'),
							offer: data,
							pdeals: data.pro_deal_details,
							pro_details: s[0],
							pro_deal_details: data.pro_deal_details[0],
							offer_details: o[0],
							imgs: data.pro_imgs,
							seller_id: data['pro_deal_details'][0]['seller_id'],
							tags: t[0]['tag'],
							web_title: s[0].title + " " + s[0].unit_pack + " - " + s[0].brand_name,
							web_desc: s[0].description,
							loading: true,
							coupons: data.coupons,
							coupon_first: data.coupons[0],
							recommended: data.recommended,
							cpns_list: data.cpns_list,
	
							min_qty: data.min_qty,
							max_qty: data.max_qty,
							min_qty1: data.min_qty,
							max_qty1: data.max_qty,
							qty: data.qty,
							unit_name: data.unit_name,
							type: data.type,
							is_cart: data.is_cart,
							similar_tabs: data.similar_tabs,
	
							free_ship_msg: data.free_ship_msg,
							user_zipcode: data.user_zipcode,
							free_shipment: data.free_shipment,
							emi_status: o[0]['emi_opt_sts'],
							emi_msg: o[0]['emi_opt_desc'],
							seo_title: s[0].title + " " + s[0].unit_pack + " - " + s[0].brand_name + " | AquaDeals",
							seo_desc: "Choose the Best deal on " + s[0].brand_name + " " + s[0].title + " product from our partners and avail free shipment on online purchase",
	
							category_id: s[0].category_id,
							viewmore_cat: data.viewmore_cat,
							bid: data.bid,
							wishLst_flag: data.wishLst_flag,
							cat_sim_flag: data.cat_sim_flag,
							brand_sim_flag: data.brand_sim_flag,
							stage_sim_flag: data.stage_sim_flag,
							brand_like_status: s[0].brand_like_status,
							// brand_like_users:data.brand_like_users,
							brand_likes_count: data.brand_likes_count,
							brand_like_rem_count: data.brand_like_rem_count,
							brand_follow_count: data.brand_follow_count,
	
							ad_guarantee: data.ad_guarantee,
							ad_guarantee_icon: data.ad_guarantee_icon,
							ad_grnt_str: data.ad_grnt_str,
							caa_approved_flag: data.caa_approved,
							caa_icon: baseAssets + 'images/product_imgs/' + data.caa_icon,
	
							show_order_count: data.show_order_count,
							order_count: data.order_count,
							free_ship_flag: data.free_ship_flag,
							previous_order: data.previous_order,
							zendesk_flag: data.zendesk_flag,
							wb_url: data.wb_url,
							best_price_txt: data.best_price_txt,
							disclaimer_flag: data.disclaimer_flag,
							disclaimer_txt: data.disclaimer_txt
						});
						if (data.cart_qty > 0) {
							this.setState({
								min_qty: data.cart_qty
							});
						}
						if (data.show_about_brand === 1) {
							this.setState({
								show_about_brand_flag: true
							});
						} else {
							this.setState({
								show_about_brand_flag: false
							});
						}
						if (this.state.unit_name === "kg") {
							this.setState({
								tons: data.pro_deal_details[0]['min_qty'] * s[0]['qty'] / 1000
							});
						}
						if (this.state.unit_name === "gm") {
							this.setState({
								tons: data.pro_deal_details[0]['min_qty'] * s[0]['qty'] / 1000 / 1000
							});
						}
						if (data.is_cart === 1) {
							this.setState({
								addtocart_msg: 'GO TO CART',
								addtocart_status: true
							});
						} else {
							this.setState({
								addtocart_msg: 'ADD TO CART'
							});
						}
						// if(s[0].brand_follow_status==='1')
						// {
						// 	this.setState({
						// 		b_follow_status:true,
						// 	});
						// }
						document.title = this.state.seo_title;
						document.getElementsByTagName("META")[2].content = this.state.seo_desc;
					}.bind(this),
					error: function error(err) {}
				});
				if (localStorage.user_id && localStorage.token && localStorage.mob_addtocart) {
					this.addToCartOnload();
				}
				// if(localStorage.user_id && localStorage.token && localStorage.mob_checkbestprice)
				// {
				// 	this.checkBestPriceOnload();
				// }
				// if(localStorage.user_id && localStorage.token && localStorage.adassist_status)
				// {
				// 	this.getAdAssistModalOnload()
				// }
				// if(localStorage.user_id && localStorage.token && localStorage.addtowishlist_onload)
				// {
				// 	this.addToWishlistOnload();
				// }
				if (localStorage.user_id && localStorage.token && localStorage.likebrand_onload) {
					this.likeBrandOnload();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.location.pathname !== this.props.location.pathname) {
					window.location.reload();
				}
			}
		}, {
			key: 'addToCartOnload',
			value: function addToCartOnload() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (this.state.addtocart_msg === "GO TO CART") {
					_reactRouter.browserHistory.push('/mycart');
				}
				if (!localStorage.user_id && !localStorage.token) {
					if (this.props.params.Bname) {
						localStorage.setItem('m_r_p_dt', '/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Bname + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.DealId);
					} else {
						localStorage.setItem('m_r_p_dt', '/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.DealId);
					}
					localStorage.setItem('mob_addtocart', '1');
					_reactRouter.browserHistory.push('/login');
				} else {
					this.setState({
						rotateClass: true
					});
					var quantity = '';
					if (localStorage.mob_addtocart_qty) {
						quantity = localStorage.getItem('mob_addtocart_qty');
					}
					if (parseInt(quantity, 10) < parseInt(this.state.min_qty1, 10) || quantity === "NaN") {
						this.setState({
							qty_err_status: true,
							qty_err_msg: "* Minimum Quantity is " + this.state.min_qty1
						});
						// quantity=this.state.min_qty1;
					} else {
						// quantity=this.refs.input_minqty.value;
						if (localStorage.mob_addtocart_qty) {
							quantity = localStorage.getItem('mob_addtocart_qty');
						} else {
							quantity = this.state.min_qty;
						}
						if (localStorage.source) {
							var source = localStorage.getItem('source');
						} else {
							source = '';
						}
						if (localStorage.campaign) {
							var campaign = localStorage.getItem('campaign');
						} else {
							campaign = '';
						}
						if (localStorage.url_id) {
							var url_id = localStorage.getItem('url_id');
						} else {
							url_id = '';
						}
						var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token'), deal_id: this.state.dealid, deal_type: 1, quantity: quantity, pl_size: 0, salinity: 0, pickup_date: 0, source: source, campaign: campaign, url_id: url_id };
						var data2 = JSON.stringify(data1);
						_jquery2.default.ajax({
							method: 'post',
							dataType: 'json',
							url: baseUrl + 'addToCart',
							data: { req: data2 },
							success: function (data) {
								if (data.status === "success" && data.message === "Added to cart") {
									this.setState({
										addtocart_msg: 'GO TO CART',
										is_cart: data.cart_flag
									});
									// this.getCartCount();
									localStorage.removeItem('mob_addtocart');
									localStorage.removeItem('mob_addtocart_qty');
								}
								if (data.status === "success" && data.message === "Cart Updated") {
									this.setState({
										addtocart_msg: 'GO TO CART',
										is_cart: data.cart_flag
									});
									localStorage.removeItem('mob_addtocart');
									localStorage.removeItem('mob_addtocart_qty');
								}
								if (data.status === "error" && data.cart_flag === 0) {
									this.setState({
										clearcart_status: true
									});
									localStorage.removeItem('mob_addtocart');
									localStorage.removeItem('mob_addtocart_qty');
								}
								if (data.status === "error" && data.message === "Product already added to the cart" && data.cart_flag === 1) {
									this.setState({
										cart_added_status: true,
										addtocart_msg: 'GO TO CART',
										// addtocart_status:true,
										is_cart: data.cart_flag
									});
									localStorage.removeItem('mob_addtocart');
									localStorage.removeItem('mob_addtocart_qty');
								}
								// this.getCartCount();
							}.bind(this),
							error: function error(err) {}
						});
					}
				}
			}
		}, {
			key: 'submitAdAssistData',
			value: function submitAdAssistData(event) {
				event.preventDefault();
				var error_flag = false;
				var q_id = (0, _jquery2.default)('#ad-sel-question').val();
				if (q_id == 1) {
					(0, _jquery2.default)('#ad-sel-question').css("color", "red");
					(0, _jquery2.default)('#ad-sel-question option').css("color", "#666");
					error_flag = true;
				} else {
					(0, _jquery2.default)('#ad-sel-question').css("color", "#666");
					(0, _jquery2.default)('#ad-sel-question option').css("color", "#666");
					error_flag = false;
				}
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var ad_time = this.state.ad_asst_time ? this.state.ad_asst_time : '0';
				if (ad_time == '0') {
					error_flag = true;
					this.setState({
						time_err_status: true,
						time_err_msg: '* Required'
					});
				}
				if (!error_flag) {
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.token, pid: this.props.params.Pid, time: ad_time, desc: '', source: source, campaign: campaign, url_id: url_id, selectedQue: q_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'askExpert',
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									ad_assist_modal: false,
									ad_asst_confirm_message: data.message,
									ad_asst_confirm_modal: true
								});
							} else {
								this.setState({
									ad_assist_modal: false
									// ad_asst_confirm_message:data.message,
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'getAdAssistModal',
			value: function getAdAssistModal() {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('adassist_status', '1');
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', id: uid, pid: this.props.params.Pid, token: localStorage.getItem('token'), source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'checkaskExpert',
						success: function (data) {
							if (data.status === 'success' && data.proceed === 1) {
								this.setState({
									ad_assist_modal: !this.state.ad_assist_modal,
									assist_data: data,
									queries: data.queries
								});
								localStorage.removeItem('adassist_status');
							}
							if (data.status === 'success' && data.proceed === 0) {
								this.setState({
									ad_asst_confirm_modal: true,
									ad_asst_confirm_message: data.msg
								});
								localStorage.removeItem('adassist_status');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'getAdAssistModalOnload',
			value: function getAdAssistModalOnload() {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('adassist_status', '1');
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', id: uid, pid: this.props.params.Pid, token: localStorage.getItem('token'), source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'checkaskExpert',
						success: function (data) {
							if (data.status === 'success' && data.proceed === 1) {
								this.setState({
									ad_assist_modal: !this.state.ad_assist_modal
								});
								localStorage.removeItem('adassist_status');
							}
							if (data.status === 'success' && data.proceed === 0) {
								this.setState({
									ad_asst_confirm_modal: true,
									ad_asst_confirm_message: data.msg
								});
								localStorage.removeItem('adassist_status');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'setAdTime',
			value: function setAdTime(val) {
				this.setState({
					ad_asst_time: val,
					time_err_status: false,
					time_err_msg: ''
				});
			}
		}, {
			key: 'likeBrandOnload',
			value: function likeBrandOnload(status) {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('likebrand_onload', '1');
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					status = 1;
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.token, brand_id: localStorage.likebrand_bid, status: status, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'like_brand',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									brand_like_status: data.like_status,
									brand_likes_count: data.brand_likes_count
								});
								localStorage.removeItem('likebrand_onload');
							}
							if (data.like_status === 1) {
								this.setState({
									brand_like_status: '1'
								});
								localStorage.removeItem('likebrand_onload');
							} else {
								this.setState({
									brand_like_status: '0'
								});
								localStorage.removeItem('likebrand_onload');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'likeBrand',
			value: function likeBrand(status) {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('likebrand_onload', '1');
					localStorage.setItem('likebrand_bid', this.state.offer.bid);
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.token, brand_id: this.state.offer.bid, status: status, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'like_brand',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									brand_like_status: data.like_status,
									brand_likes_count: data.brand_likes_count
								});
								localStorage.removeItem('likebrand_onload');
								localStorage.removeItem('likebrand_bid');
							}
							if (data.like_status === 1) {
								this.setState({
									brand_like_status: '1'
								});
								localStorage.removeItem('likebrand_onload');
								localStorage.removeItem('likebrand_bid');
							} else {
								this.setState({
									brand_like_status: '0'
								});
								localStorage.removeItem('likebrand_onload');
								localStorage.removeItem('likebrand_bid');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'tokenCheck',
			value: function tokenCheck() {
				localStorage.removeItem('user_id');
				localStorage.removeItem('token');
				window.location.reload();
			}
			// FollowBrand(status)
			// {
			// 	if(localStorage.user_id)
			// 	{
			// 		var uid=localStorage.getItem('user_id');
			// 	}
			// 	else
			// 	{
			// 		uid=0;
			// 	}
	
			// 	var data1={from:'mobile_web',id:uid,token:localStorage.token,brand_id:this.state.offer.bid,status:status}
			// 	var data2=JSON.stringify(data1);
			// 	$.ajax({
			// 		method:'POST',
			// 		dataType:'json',
			// 		url:baseUrl+'follow_brand',
			// 		data:{req:data2},
			// 		success:function(data)
			// 		{
			// 			if(data.status==='success')
			// 			{
			// 				this.setState({
			// 					brand_follow_count:data.brand_follow_count,
			// 					b_follow_status:!this.state.b_follow_status,
			// 					// brand_likes_count:data.brand_likes_count,
			// 				});
			// 			}
			// 			if(data.status==='error' && data.message==="Token mismatch")
			// 			{
			// 				this.tokenCheck();
			// 			}
			// 		}.bind(this),
			// 		error:function(err)
			// 		{
			// 		}
			// 	});
			// }
	
		}, {
			key: 'getSimilarBrandDeals',
			value: function getSimilarBrandDeals() {
				this.setState({
					similar_brand_deals_status: !this.state.similar_brand_deals_status
				});
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (!this.state.similar_brand_deals_status) {
					var data1 = { from: 'mobile_web', tid: this.state.bid, type: 'brand', dtype: this.state.pro_details.dtype, uid: uid, page: 1, bid: '', sort: '', pDetails_viewmore: 1, deal_id: this.props.params.DealId };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'getProductbycat_brand',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									similar_brand_deals: data.result
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'getSimilarCatDeals',
			value: function getSimilarCatDeals() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				this.setState({
					similar_category_deals_status: !this.state.similar_category_deals_status
				});
				if (!this.state.similar_category_deals_status) {
					var data1 = { from: 'mobile_web', tid: this.state.pro_details.category_id, type: 'Pcategory', dtype: this.state.pro_details.dtype, uid: uid, page: 1, bid: '', sort: '', pDetails_viewmore: 1, deal_id: this.props.params.DealId };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'getProductbycat_brand',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									similar_category_deals: data.result
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'getSimilarStageDeals',
			value: function getSimilarStageDeals() {
				this.setState({
					similar_stage_deals_status: !this.state.similar_stage_deals_status
				});
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (!this.state.similar_stage_deals_status) {
					var data1 = { from: 'mobile_web', tid: this.state.pro_details.stage, type: 'stage', dtype: this.state.pro_details.dtype, uid: uid, page: 1, bid: '', sort: '', 'pDetails_viewmore': 1, deal_id: this.props.params.DealId };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'getProductbycat_brand',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									similar_stage_deals: data.result
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'checkBestPriceOnload',
			value: function checkBestPriceOnload() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('mob_checkbestprice', '1');
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', did: this.props.params.DealId, id: uid, dtype: 1, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'checkBestPriceLead',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success' && data.proceed === 1) {
								this.setState({
									reqbestPrice: true
								});
								localStorage.removeItem('mob_checkbestprice');
							} else if (data.status === 'success' && data.proceed === 0) {
								this.setState({
									req_confirm_modal: true,
									req_confirm_message: data.msg
								});
								localStorage.removeItem('mob_checkbestprice');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'checkBestPrice',
			value: function checkBestPrice() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('mob_checkbestprice', '1');
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', did: this.props.params.DealId, id: uid, dtype: 1, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'checkBestPriceLead',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success' && data.proceed === 1) {
								this.setState({
									reqbestPrice: true
								});
								localStorage.removeItem('mob_checkbestprice');
							} else if (data.status === 'success' && data.proceed === 0) {
								this.setState({
									req_confirm_modal: true,
									req_confirm_message: data.msg
								});
								localStorage.removeItem('mob_checkbestprice');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'reqBestPriceSubmit',
			value: function reqBestPriceSubmit(event) {
				event.preventDefault();
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var quantity = this.refs.req_quantity.value;
				var state = this.refs.req_state.value;
				{/*var city = this.refs.req_city.value;
	    var doorno = this.refs.req_doorno.value;*/}
				var pincode = this.refs.req_pincode.value;
				var flag = 0;
				var namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
				if (quantity === '' && quantity.length < 1) {
					(0, _jquery2.default)('#req_quantity_err').text('* Enter quantity');
					flag = 1;
				}
	
				if (quantity !== '' && quantity < this.state.pro_deal_details.best_price_min_qty) {
					(0, _jquery2.default)('#req_quantity_err').text('* Minimum Quantity is ' + this.state.pro_deal_details.best_price_min_qty + '');
					flag = 1;
				}
				if (state === '' && !namePattern.test(state) && state.length < 2) {
					(0, _jquery2.default)('#req_state_err').text('* Enter state');
					flag = 1;
				}
				if (state !== '' && state.length < 2 && !namePattern.test(state)) {
					(0, _jquery2.default)('#req_state_err').text('* Enter valid state');
					flag = 1;
				}
				{/*if(city==='' && !namePattern.test(city))
	    {
	     	$('#req_city_err').text('* enter city');
	     	flag= 1;
	    }
	    if(city !=='' && city.length < 3)
	    {
	    $('#req_city_err').text('* enter city');
	    flag = 1;
	    }
	    if(doorno==='' && doorno.length <= 1)
	    {
	    $('#req_doorno_err').text('* enter address');
	     	flag= 1;
	    }
	    if(doorno!=='' && doorno.length <= 1)
	    {
	    $('#req_doorno_err').text('* enter address');
	     	flag= 1;
	    }*/}
				if (pincode === '' && pincode.length < 6) {
					(0, _jquery2.default)('#req_pincode_err').text('* Enter valid pincode');
					flag = 1;
				}
				if (pincode !== '' && pincode.length < 6) {
					(0, _jquery2.default)('#req_pincode_err').text('* Enter valid pincode');
					flag = 1;
				}
				// if(quantity !=='' && quantity < parseInt(this.state.min_qty1,10))
				// {
				// 	$('#req_quantity_err').text('* Minimum quantity is '+this.state.min_qty1);
				// 	flag =1;
				// }
				// if(quantity > parseInt(this.state.max_qty1,10))
				// {
				// 	$('#req_quantity_err').text('* Maximum quantity is '+this.state.max_qty1);
				// 	flag =1;
				// }
				if (flag === 0) {
					this.setState({
						reqbestPrice: false
						// disable_button:false,
					});
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.token, did: this.props.params.DealId, dtype: '1', req_qty: this.state.req_quantity, state: this.state.req_state, city: this.state.req_city, address: this.state.req_doorno, pincode: this.state.req_pincode, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'saveBestpriceLead',
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									reqbestPrice: false,
									req_confirm_modal: true,
									req_confirm_message: data.message
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'req_stateChange',
			value: function req_stateChange(event) {
				var x = event.target.value;
				var namePattern = /^[a-z A-Z]+$/;
				if (!namePattern.test(event.target.value) && x !== '') {
					x = event.target.value.replace(namePattern, "");
				} else {
					this.setState({
						req_state: event.target.value
					});
				}
			}
		}, {
			key: 'req_cityChange',
			value: function req_cityChange(event) {
				var x = event.target.value;
				var namePattern = /^[a-z A-Z]+$/;
				if (!namePattern.test(event.target.value) && x !== '') {
					x = event.target.value.replace(namePattern, "");
				} else {
					this.setState({
						req_city: event.target.value
					});
				}
			}
		}, {
			key: 'req_doornoChange',
			value: function req_doornoChange(event) {
				this.setState({
					req_doorno: event.target.value
				});
			}
		}, {
			key: 'req_quantityChange',
			value: function req_quantityChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						req_quantity: x
					});
				}
			}
		}, {
			key: 'req_pincodeChange',
			value: function req_pincodeChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						req_pincode: x
					});
				}
			}
		}, {
			key: 'getAttributesTitle',
			value: function getAttributesTitle() {
				var data1 = { from: 'mobile_web', pid: this.props.params.Pid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'get_pro_specs',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length > 0) {
							// this.setState({
							// 	swipe_attributes_titles:data.result,
							// 	cid:data.result[0]['cid'],
							// 	swipe_attr_status:data.result[0]['cid']
							// });
							// this.getswipeDescription_Initial(this.props.params.Pid,data.result[0]['cid']);
							// // this.getswipeDescription(this.props.params.Pid,data.result[0]['cid']);
						} else {
							this.setState({
								no_details_attr: 1
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'checkPincode',
			value: function checkPincode() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (this.refs.pincode.value.length === 6) {
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token'), type: 1, did: this.props.params.DealId, zip: this.refs.pincode.value, device_id: localStorage.getItem('push_device_id') };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						url: baseUrl + 'checkFreeshipment',
						dataType: 'json',
						data: { req: data2 },
						success: function (data) {
							this.setState({
								free_ship_msg: data.msg
							});
						}.bind(this),
						error: function error(err) {}
					});
				} else {
					this.setState({
						err_pincode: true,
						// err_pincode_msg:'* Invalid pincode',
						free_ship_msg: 'Invalid Pincode'
					});
				}
			}
		}, {
			key: 'pincodeChange',
			value: function pincodeChange() {
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(this.refs.pincode.value)) {
					var x = this.refs.pincode.value.replace(invalidChars, "");
				} else {
					this.setState({
						err_pincode: true
					});
				}
				this.setState({
					user_zipcode: x,
					err_pincode: false
				});
			}
		}, {
			key: 'incrementMinQty',
			value: function incrementMinQty() {
				setTimeout(function () {
					(0, _jquery2.default)('.minus_btn img').attr('src', __webpack_require__(75));
					if (parseInt(this.refs.input_minqty.value) + 1 >= parseInt(this.state.max_qty1)) {
						(0, _jquery2.default)('.plus_btn img').attr('src', __webpack_require__(110));
					}
				}.bind(this), 100);
				if (this.state.unit_name === "kg") {
					var add = '';
					var tons = '';
					if (this.state.type === "Feed" && this.refs.input_minqty.value !== '') {
						add = parseInt(this.state.min_qty, 10) + parseInt(500 / this.state.qty, 10);
						tons = add * this.state.qty / 1000;
					} else if (this.state.type === "Feed" && this.refs.input_minqty.value === '') {
						add = parseInt(this.state.min_qty1, 10) + parseInt(500 / this.state.qty, 10);
						tons = add * this.state.qty / 1000;
					}
					if ((this.state.type === "Health Care" || this.state.type === "Hatchery Health Care") && this.refs.input_minqty.value !== '') {
						add = parseInt(this.state.min_qty, 10) + 1;
						tons = add * this.state.qty / 1000;
					} else if ((this.state.type === "Health Care" || this.state.type === "Hatchery Health Care") && this.refs.input_minqty.value === '') {
						add = parseInt(this.state.min_qty1, 10) + parseInt(500 / this.state.qty, 10);
						tons = add * this.state.qty / 1000;
					}
					if (add > this.state.max_qty1) {
						this.setState({
							min_qty: this.state.max_qty1,
							tons: this.state.max_qty1 * this.state.qty / 1000,
							qty_err_status: true,
							qty_err_msg: "* Maximum Quantity is " + this.state.max_qty1
						});
					} else {
						if (this.state.is_cart === 1) {
							this.setState({
								min_qty: add,
								tons: tons,
								addtocart_msg: 'UPDATE CART',
								qty_err_status: false,
								qty_err_msg: ''
							});
						} else {
							this.setState({
								min_qty: add,
								tons: tons,
								addtocart_msg: 'ADD TO CART',
								qty_err_status: false,
								qty_err_msg: ''
							});
						}
					}
				}
				//  GRAMS INCREMENT 
				else if (this.state.unit_name === "gm") {
						if (this.state.type === "Feed" && this.refs.input_minqty.value !== '') {
							add = parseInt(this.state.min_qty, 10) + parseInt(500 * 1000 / this.state.qty, 10);
							tons = add * this.state.qty / 1000 / 1000;
						} else if (this.state.type === "Feed" && this.refs.input_minqty.value === '') {
							add = parseInt(this.state.min_qty1, 10) + parseInt(500 * 1000 / this.state.qty, 10);
							tons = add * this.state.qty / 1000 / 1000;
						}
						if ((this.state.type === "Health Care" || this.state.type === "Hatchery Health Care") && this.refs.input_minqty.value !== '') {
							add = parseInt(this.state.min_qty, 10) + parseInt(1, 10);
							tons = add * this.state.qty / 1000 / 1000;
						} else if ((this.state.type === "Health Care" || this.state.type === "Hatchery Health Care") && this.refs.input_minqty.value === '') {
							add = parseInt(this.state.min_qty1, 10) + parseInt(1, 10);
							tons = add * this.state.qty / 1000 / 1000;
						}
						//  adding if not greater thn limit.
						if (add > this.state.max_qty1) {
							this.setState({
								min_qty: this.state.max_qty1,
								qty_err_status: true,
								qty_err_msg: "* Maximum Quantity is " + this.state.max_qty1
							});
						} else {
							if (this.state.is_cart === 1) {
								this.setState({
									min_qty: add,
									tons: tons,
									addtocart_msg: 'UPDATE CART',
									qty_err_status: false,
									qty_err_msg: ''
								});
							} else {
								this.setState({
									min_qty: add,
									tons: tons,
									addtocart_msg: 'ADD TO CART',
									qty_err_status: false,
									qty_err_msg: ''
								});
							}
						}
					}
					// LTR's
					else if (this.state.unit_name === "ltr") {
							if (this.state.type === "Feed" && this.refs.input_minqty.value !== '') {
								add = parseInt(this.state.min_qty, 10) + parseInt(500 / this.state.qty, 10);
							} else if (this.state.type === "Feed" && this.refs.input_minqty.value === '') {
								add = parseInt(this.state.min_qty1, 10) + parseInt(500 / this.state.qty, 10);
							}
	
							if ((this.state.type === "Health Care" || this.state.type === "Hatchery Health Care") && this.refs.input_minqty.value !== '') {
								add = parseInt(this.state.min_qty, 10) + parseInt(1, 10);
							} else if ((this.state.type === "Health Care" || this.state.type === "Hatchery Health Care") && this.refs.input_minqty.value === '') {
								add = parseInt(this.state.min_qty1, 10) + parseInt(1, 10);
							}
							if (add > this.state.max_qty1) {
								this.setState({
									min_qty: this.state.max_qty1,
									qty_err_status: true,
									qty_err_msg: "* Maximum Quantity is " + this.state.max_qty1
								});
							} else {
								if (this.state.is_cart === 1) {
									this.setState({
										min_qty: add,
										addtocart_msg: 'UPDATE CART',
										qty_err_status: false,
										qty_err_msg: ''
									});
								} else {
									this.setState({
										min_qty: add,
										addtocart_msg: 'ADD TO CART',
										qty_err_status: false,
										qty_err_msg: ''
									});
								}
							}
						} else if (this.state.unit_name === "nos") {
							if (this.refs.input_minqty.value !== '') {
								add = parseInt(this.state.min_qty, 10) + 1;
							} else {
								add = parseInt(this.state.min_qty1, 10);
							}
							if (add > this.state.max_qty1) {
								this.setState({
									min_qty: this.state.max_qty1,
									qty_err_status: true,
									qty_err_msg: "* Maximum Quantity is " + this.state.max_qty1
								});
							} else {
								if (this.state.is_cart === 1) {
									this.setState({
										min_qty: add,
										addtocart_msg: 'UPDATE CART',
										qty_err_status: false,
										qty_err_msg: ''
									});
								} else {
									this.setState({
										min_qty: add,
										addtocart_msg: 'ADD TO CART',
										qty_err_status: false,
										qty_err_msg: ''
									});
								}
							}
						} else {
	
							if (this.refs.input_minqty.value !== '') {
								add = parseInt(this.state.min_qty, 10) + 1;
							} else {
								add = parseInt(this.state.min_qty1, 10);
							}
							if (add > this.state.max_qty1) {
								this.setState({
									min_qty: this.state.max_qty1,
									qty_err_status: true,
									qty_err_msg: "* Maximum Quantity is " + this.state.max_qty1
								});
							} else {
								if (this.state.is_cart === 1) {
									this.setState({
										min_qty: add,
										addtocart_msg: 'UPDATE CART',
										qty_err_status: false,
										qty_err_msg: ''
									});
								} else {
									this.setState({
										min_qty: add,
										addtocart_msg: 'ADD TO CART',
										qty_err_status: false,
										qty_err_msg: ''
									});
								}
							}
						}
			}
		}, {
			key: 'decrementMinQty',
			value: function decrementMinQty() {
				var minquantity = '';
				var removedquantity = '';
				var total = '';
				setTimeout(function () {
					(0, _jquery2.default)('.plus_btn img').attr('src', __webpack_require__(46));
					if (parseInt(this.refs.input_minqty.value) - 1 <= parseInt(this.state.min_qty1)) {
						(0, _jquery2.default)('.minus_btn img').attr('src', __webpack_require__(45));
					}
				}.bind(this), 100);
				if (this.state.unit_name === "") {
					minquantity = parseInt(this.state.min_qty, 10);
				} else if (parseInt(this.state.min_qty, 10) <= parseInt(this.state.min_qty1, 10)) {
					minquantity = parseInt(this.state.min_qty1, 10);
					removedquantity = parseInt(500 / minquantity, 10);
					total = parseInt(minquantity, 10);
				} else if (this.state.unit_name === "kg" && this.state.type === "Feed") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(500 / this.state.qty, 10);
					// total = parseInt(minquantity - removedquantity,10)
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(500 / this.state.qty, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(500 / this.state.qty, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "kg" && this.state.type === "Health Care") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(1,10);
					// total=parseInt(minquantity - removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "kg" && this.state.type === "Hatchery Health Care") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(1,10);
					// total=parseInt(minquantity - removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "gm" && this.state.type === "Feed") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(500 * 1000 / this.state.qty,10);
					// total=parseInt(minquantity - removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(500 * 1000 / this.state.qty, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(500 * 1000 / this.state.qty, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "gm" && this.state.type === "Health Care") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(1,10);
					// total=parseInt(minquantity - removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "gm" && this.state.type === "Hatchery Health Care") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(1,10);
					// total=parseInt(minquantity - removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "ltr" && this.state.type === "Feed") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(500 / this.state.qty,10);
					// total=parseInt(minquantity - removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(500 / this.state.qty, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(500 / this.state.qty, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "ltr" && this.state.type === "Health Care") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(1,10);
					// total=parseInt(minquantity - removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "ltr" && this.state.type === "Hatchery Health Care") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(1,10);
					// total=parseInt(minquantity-removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else if (this.state.unit_name === "nos") {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(1,10);
					// total=parseInt(minquantity-removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				} else {
					// minquantity=parseInt(this.state.min_qty,10);
					// removedquantity=parseInt(1,10);
					// total=parseInt(minquantity-removedquantity,10);
					if (this.state.min_qty === '' || this.state.min_qty === 'NaN') {
						minquantity = parseInt(this.state.min_qty1, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					} else {
						minquantity = parseInt(this.state.min_qty, 10);
						removedquantity = parseInt(1, 10);
						if (parseInt(minquantity - removedquantity, 10) < parseInt(this.state.min_qty1, 10) || parseInt(minquantity - removedquantity, 10) === 'NaN') {
							this.setState({
								qty_err_status: true,
								qty_err_msg: '* Minimum Quantity is ' + this.state.min_qty1
							});
							total = this.state.min_qty1;
						} else {
							total = parseInt(minquantity - removedquantity, 10);
						}
					}
				}
	
				if (this.state.is_cart === 1 && this.state.unit_name !== "nos") {
					this.setState({
						min_qty: parseInt(total, 10),
						tons: total * this.state.qty / 1000,
						addtocart_msg: 'UPDATE CART'
						// addtocart_status:false,
					});
				} else if (this.state.is_cart === 0 && this.state.unit_name === "kg") {
					this.setState({
						min_qty: parseInt(total, 10),
						tons: total * this.state.qty / 1000,
						addtocart_msg: 'ADD TO CART'
						// addtocart_status:false,
					});
				} else if (this.state.is_cart === 0 && this.state.unit_name === "gm") {
					this.setState({
						min_qty: parseInt(total, 10),
						tons: total * this.state.qty / 1000 / 1000,
						addtocart_msg: 'ADD TO CART'
						// addtocart_status:false,
					});
				} else if (this.state.is_cart === 1 && this.state.unit_name === "nos") {
					this.setState({
						min_qty: parseInt(total, 10),
						addtocart_msg: 'UPDATE CART'
						// addtocart_status:false,
					});
				} else if (this.state.is_cart === 0 && this.state.unit_name === "nos") {
					this.setState({
						min_qty: parseInt(total, 10),
						// tons: total * this.state.qty / 1000,
						addtocart_msg: 'ADD TO CART'
					});
				} else {
					if (this.state.is_cart === 0) {
						this.setState({
							min_qty: parseInt(total, 10),
							// tons: total * this.state.qty / 1000,
							addtocart_msg: 'ADD TO CART'
						});
					}
					if (this.state.is_cart === 1) {
						this.setState({
							min_qty: parseInt(total, 10),
							addtocart_msg: 'UPDATE CART'
						});
					}
				}
			}
		}, {
			key: 'getDeviceId',
			value: function getDeviceId() {
				if (localStorage.user_id) {
					var user_id = localStorage.user_id;
				} else {
					user_id = 0;
				}
				var data1 = { from: 'mobile_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
	
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getDeviceId',
					dataType: 'json',
					data: { req: data2 },
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'removeCartItems',
			value: function removeCartItems() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token'), deal_id: this.state.dealid, deal_type: '1', quantity: this.refs.input_minqty.value, pl_size: 0, salinity: 0, pickup_date: 0, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'replaceCart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success" && data.cart_flag === 1) {
							this.setState({
								addtocart_msg: 'GO TO CART',
								clearcart_status: false
								// addtocart_status:true,
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'placeOrderModal',
			value: function placeOrderModal() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (this.state.addtocart_msg === "GO TO CART") {
					_reactRouter.browserHistory.push('/mycart');
				}
				if (!localStorage.user_id && !localStorage.token) {
					var quantity = '';
					if (this.refs.input_minqty.value < parseInt(this.state.min_qty1, 10) || this.refs.input_minqty.value === "NaN") {
						this.setState({
							qty_err_status: true,
							qty_err_msg: "* Minimum Quantity is " + this.state.min_qty1
						});
						quantity = this.state.min_qty1;
					} else if (this.refs.input_minqty.value > parseInt(this.state.max_qty1, 10)) {
						this.setState({
							qty_err_status: true,
							qty_err_msg: "* Maximum Quantity is " + this.state.max_qty1
						});
						quantity = this.state.max_qty1;
					} else {
						if (this.props.params.Bname) {
							localStorage.setItem('m_r_p_dt', '/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Bname + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.DealId);
						} else {
							localStorage.setItem('m_r_p_dt', '/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.DealId);
						}
						localStorage.setItem('mob_addtocart', '1');
						localStorage.setItem('mob_addtocart_qty', this.state.min_qty);
						_reactRouter.browserHistory.push('/login');
					}
				} else {
					if (this.state.addtocart_msg === "ADD TO CART" || this.state.addtocart_msg === "UPDATE CART") {
	
						var quantity = '';
						if (this.refs.input_minqty.value < parseInt(this.state.min_qty1, 10) || this.refs.input_minqty.value === "NaN") {
							this.setState({
								qty_err_status: true,
								qty_err_msg: "* Minimum Quantity is " + this.state.min_qty1
							});
							quantity = this.state.min_qty1;
						} else {
							this.setState({
								rotateClass: true
							});
							if (localStorage.source) {
								var source = localStorage.getItem('source');
							} else {
								source = '';
							}
							if (localStorage.campaign) {
								var campaign = localStorage.getItem('campaign');
							} else {
								campaign = '';
							}
							if (localStorage.url_id) {
								var url_id = localStorage.getItem('url_id');
							} else {
								url_id = '';
							}
							quantity = this.refs.input_minqty.value;
							var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token'), deal_id: this.state.dealid, deal_type: 1, quantity: quantity, pl_size: 0, salinity: 0, pickup_date: 0, source: source, campaign: campaign, url_id: url_id };
							var data2 = JSON.stringify(data1);
							_jquery2.default.ajax({
								method: 'post',
								dataType: 'json',
								url: baseUrl + 'addToCart',
								data: { req: data2 },
								success: function (data) {
									if (data.status === "success" && data.message === "Added to cart") {
										this.setState({
											addtocart_msg: 'GO TO CART',
											is_cart: data.cart_flag
										});
										localStorage.removeItem('mob_addtocart');
										localStorage.removeItem('mob_addtocart_qty');
									}
									if (data.status === "success" && data.message === "Cart Updated") {
										this.setState({
											addtocart_msg: 'GO TO CART',
											is_cart: data.cart_flag
										});
										localStorage.removeItem('mob_addtocart');
										localStorage.removeItem('mob_addtocart_qty');
									}
									if (data.status === "error" && data.cart_flag === 0) {
										this.setState({
											clearcart_status: true
										});
										localStorage.removeItem('mob_addtocart');
										localStorage.removeItem('mob_addtocart_qty');
									}
									if (data.status === "error" && data.message === "Product already added to the cart" && data.cart_flag === 1) {
										this.setState({
											cart_added_status: true,
											addtocart_msg: 'GO TO CART',
											// addtocart_status:true,
											is_cart: data.cart_flag
										});
										localStorage.removeItem('mob_addtocart');
										localStorage.removeItem('mob_addtocart_qty');
									}
								}.bind(this),
								error: function error(err) {}
							});
						}
					}
				}
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					showModal: false,
					reqbestPrice: false,
					clearcart_status: false,
					cart_added_status: false,
					req_confirm_modal: false,
					ad_assist_modal: false,
					ad_asst_confirm_modal: false
				});
			}
			// scroll()
			// {
			// 	var lastScroll = 0;
			// 	var scrollUpStart = 0;
			// 	$(window).on('scroll',function()
			// 	{
			// 		var scroll = $(window).scrollTop();
			// 		if(scroll === 0)
			// 		{
			// 			$(".page_hdr").addClass("dtl_pg_hdr");
			// 		}
			// 		else if(lastScroll > scroll)
			// 		{
			// 			if(scrollUpStart < scroll)
			// 			{
			// 				scrollUpStart = scroll;
			// 			}
			// 			if(scrollUpStart - scroll >= 200)
			// 			{
			// 				$(".page_hdr").addClass("dtl_pg_hdr");
			// 			}
			// 		}
			// 		else
			// 		{
			// 			scrollUpStart = 0;
			// 			$(".page_hdr").removeClass("dtl_pg_hdr");
			// 		}
			// 		lastScroll = scroll;
			// 	});
			// }
	
		}, {
			key: 'ShareFunc',
			value: function ShareFunc(evnt) {
				var _this2 = this;
	
				var data1 = { from: 'mobile_web', type: 1, did: evnt };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'createTinyurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							msg: data.msg,
							shareUrl: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {}
				});
				this.setState({ open: !this.state.open });
				setTimeout(function () {
					_this2.setState({ open: false });
				}, 10000);
			}
		}, {
			key: 'getswipeDescription',
			value: function getswipeDescription(pid, cid) {
				var currentState = this.state.isToggle;
	
				this.props.getProductDesc(pid, cid);
				this.setState({
					swipe_attr_status: cid,
					check_swipe_id: cid
				});
			}
		}, {
			key: 'updateMinQty',
			value: function updateMinQty(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						min_qty: x,
						tons: x * this.state.qty / 1000
					});
				}
				if (x > parseInt(this.state.max_qty1, 10)) {
					this.setState({
						min_qty: this.state.max_qty1,
						tons: this.state.max_qty1 * this.state.qty / 1000
					});
				}
			}
		}, {
			key: 'addToWishlistOnload',
			value: function addToWishlistOnload() {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('addtowishlist_onload', '1');
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					this.setState({
						page_loading: true
					});
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.token, type: 1, did: this.props.params.DealId, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'addToWishlist',
						success: function (data) {
							if (data.status === 'success' && data.message === 'Added to wish list') {
								this.setState({
									wishLst_flag: 1,
									page_loading: false
								});
								localStorage.removeItem('addtowishlist_onload');
							}
							if (data.status === 'error' && data.message === "Token mismatch") {
								this.setState({
									page_loading: false
								});
								this.tokenCheck();
								localStorage.removeItem('addtowishlist_onload');
							}
						}.bind(this),
						error: function (err) {
							this.setState({
								page_loading: false
							});
							localStorage.removeItem('addtowishlist_onload');
						}.bind(this)
					});
				}
			}
		}, {
			key: 'addToWishlist',
			value: function addToWishlist() {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('addtowishlist_onload', '1');
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					// this.setState({
					// 	page_loading:true,
					// });
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.token, type: 1, did: this.state.pro_deal_details.id, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'addToWishlist',
						success: function (data) {
							if (data.status === 'success' && data.message === 'Added to wish list') {
								this.setState({
									wishLst_flag: 1,
									page_loading: false
								});
								localStorage.removeItem('addtowishlist_onload');
							}
							if (data.status === 'error' && data.message === "Token mismatch") {
								this.setState({
									page_loading: false
								});
								this.tokenCheck();
								localStorage.removeItem('addtowishlist_onload');
							}
						}.bind(this),
						error: function error(err) {
							this.setState({
								page_loading: false
							});
						}
					});
				}
			}
		}, {
			key: 'videoplayer',
			value: function videoplayer(url, id) {
				// var url = url.split("=").pop();
				// $('.slide-id-'+id).html('<div class="iframe-container"><div><iframe src="https://www.youtube.com/embed/'+url+'" width="560" height="315" frameborder="0" allowfullscreen></iframe></div></div>');
				var url = url.split("=").pop();
				window.open("http://www.youtube.com/embed/" + url);
			}
		}, {
			key: 'chatnow',
			value: function chatnow() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
	
				if (!localStorage.user_id && !localStorage.token) {
					if (this.props.params.Bname) {
						localStorage.setItem('m_r_p_dt', '/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Bname + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.DealId);
					} else {
						localStorage.setItem('m_r_p_dt', '/pdetails/' + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.Title + "/" + this.props.params.Pid + "/" + this.props.params.DealId);
					}
					localStorage.setItem('mob_addtocart', '1');
					localStorage.setItem('mob_addtocart_qty', this.state.min_qty);
					_reactRouter.browserHistory.push('/login');
				} else {
					location.href = this.state.wb_url;
				}
			}
		}, {
			key: 'toggleDisclaimer',
			value: function toggleDisclaimer() {
				this.setState({ visibility: !this.state.visibility });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var that = this;
				// $(window).on('popstate', function(event) {
				// 	that.close();
				// 	console.log(that);
				// });		
				(0, _jquery2.default)('.min_qty_btn input').unbind("keyup").keyup(function (e) {
	
					if (parseInt((0, _jquery2.default)('.min_qty_btn input').val()) + 1 <= parseInt(that.state.min_qty1)) {
						(0, _jquery2.default)('.minus_btn img').attr('src', __webpack_require__(45));
						(0, _jquery2.default)('.plus_btn img').attr('src', __webpack_require__(46));
					}
					if (e.keyCode == 8) {
						if (parseInt((0, _jquery2.default)('.min_qty_btn input').val()) + 1 <= parseInt(that.state.min_qty1)) {
							console.log("Key background");
							//$('.minus_btn img').attr('src',require('./../../../assets/images/minus_orange_fade.png'));
							(0, _jquery2.default)('.plus_btn img').attr('src', __webpack_require__(46));
						}
					}
	
					if (parseInt((0, _jquery2.default)('.min_qty_btn input').val()) - 1 >= parseInt(that.state.min_qty1)) {
						(0, _jquery2.default)('.minus_btn img').attr('src', __webpack_require__(75));
					}
	
					if (parseInt((0, _jquery2.default)('.min_qty_btn input').val()) >= parseInt(that.state.max_qty1)) {
						(0, _jquery2.default)('.plus_btn img').attr('src', __webpack_require__(110));
						(0, _jquery2.default)('.minus_btn img').attr('src', __webpack_require__(75));
					}
	
					if (parseInt((0, _jquery2.default)('.min_qty_btn input').val()) < parseInt(that.state.max_qty1)) {
						(0, _jquery2.default)('.plus_btn img').attr('src', __webpack_require__(46));
					}
				});
				(0, _jquery2.default)('.min_qty_btn input').keyup(function (e) {
					if (e.keyCode == 8) {
						(0, _jquery2.default)('.minus_btn img').attr('src', __webpack_require__(45));
						(0, _jquery2.default)('.plus_btn img').attr('src', __webpack_require__(46));
					}
				});
	
				(0, _jquery2.default)(document).off('change', '#ad-sel-question');
				(0, _jquery2.default)(document).on('change', '#ad-sel-question', function () {
					(0, _jquery2.default)('#ad-sel-question').css("color", "#666");
					(0, _jquery2.default)('#ad-sel-question option').css("color", "#666");
				});
	
				(0, _jquery2.default)('.tab_txt').unbind("click").click(function () {
					(0, _jquery2.default)('.tab_txt').css("color", "#333");
					(0, _jquery2.default)(this).css("color", "#ff742a");
				});
	
				var carousel_params = '';
				var img_array = _jquery2.default.makeArray(this.state.imgs);
				if (img_array.length > 1) {
					carousel_params = {
						pagination: {
							el: '.swiper-pagination',
							clickable: true,
							dynamicBullets: false
						}
					};
				} else {
					carousel_params = {
						paginationClickable: true,
						slidesPerView: 1,
						spaceBetween: 0
					};
				}
	
				var self = this;
				var product_imgs = img_array.map(function (image, index) {
					if (image.url) {
						return _react2.default.createElement(
							'div',
							{ style: { 'maxWidth': '100%' }, className: 'slide-id-' + index },
							_react2.default.createElement(
								'div',
								{ onClick: function onClick() {
										self.videoplayer(image.url, index);
									}, style: { height: '355px' } },
								_react2.default.createElement(
									'i',
									null,
									'\xA0'
								),
								_react2.default.createElement(
									'table',
									{ id: 'wrapper' },
									_react2.default.createElement(
										'tr',
										null,
										_react2.default.createElement(
											'td',
											null,
											_react2.default.createElement('img', { itemProp: 'image', src: baseAssets + 'images/product_imgs/' + image.img }),
											_react2.default.createElement(
												'div',
												{ className: 'mob_play_icon' },
												_react2.default.createElement(
													'span',
													null,
													_react2.default.createElement('img', { src: baseAssets + 'images/play_icon.png', alt: ' ' })
												)
											)
										)
									)
								),
								_react2.default.createElement('img', { src: baseAssets + 'images/play_icon.png', alt: ' ' })
							)
						);
					} else {
						return _react2.default.createElement(
							'div',
							{ style: { 'maxWidth': '100%' } },
							_react2.default.createElement('img', { itemProp: 'image', src: baseAssets + 'images/product_imgs/' + image.img, alt: ' ', height: '355px', className: 'img-item-' + (index % 2 ? 'even' : 'odd') })
						);
						{/*return (<div className="iframe-container"><div style={{height:'355px'}}><iframe src="https://www.youtube.com/embed/QH2-TGUlwu4" width="560" height="315" frameborder="0"></iframe></div></div>);*/}
					}
				});
				var swipe_product_attributes = this.state.swipe_product_attributes.map(function (product, index) {
					return _react2.default.createElement(Details, { key: product.c_id, data: product });
				});
				var shareUrl = this.state.shareUrl;
				var title = "Hey Click here " + shareUrl + " to check " + this.state.pro_details.title + " from AquaDeals.";
				var description = shareUrl;
				var views_cnt = this.state.pro_deal_details.views_count >= 1 ? _react2.default.createElement(
					'span',
					null,
					_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/views.png', width: '17px', alt: ' ', role: 'presentation' }),
					' ',
					this.state.pro_deal_details.views_count
				) : '';
				// var rec_cnt=this.state.offer.recommended >=1 ? <span className="recommended_img"><img src={baseAssets+'icons/web_icons/recommended1.png'} alt=" "/>{this.state.offer.recommended}</span> : '';
				var recommendation = this.state.recommended >= 1 ? _react2.default.createElement(
					'span',
					null,
					_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/recommended1.png', alt: ' ', width: '17px' }),
					this.state.recommended
				) : '';
				var getcoupons = '';
				if (this.state.coupons.length > 0) {
					getcoupons = "coupons";
					var descriptionTop = _react2.default.createElement(
						_reactBootstrap.Popover,
						{ className: 'in', id: 'popover-positioned-top' },
						this.state.coupon_first.description
					);
					var couponsList = _react2.default.createElement(
						_reactBootstrap.Popover,
						{ id: 'popover-positioned-top1' },
						this.state.cpns_list.replace(/,\s*$/, "")
					);
					if (this.state.coupons.length === 1) {
						getcoupons = _react2.default.createElement(
							'div',
							{ className: 'row ', style: { paddingTop: '10px', paddingBottom: '10px', backgroundColor: '#fff!important' } },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-6 col-md-6 col-xs-offset-3 col-md-offset-3' },
								_react2.default.createElement(
									'div',
									{ className: 'mob_new_coupon_blk' },
									_react2.default.createElement(
										'i',
										{ className: 'coupon_left_img' },
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_left.png', alt: ' ' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'coupon_text' },
										this.state.coupon_first.coupon_code
									),
									_react2.default.createElement(
										_reactBootstrap.OverlayTrigger,
										{ trigger: 'focus', placement: 'top', overlay: descriptionTop },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ className: 'coupon_info_img' },
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_info.png', alt: ' ' })
										)
									)
								)
							)
						);
					} else {
						getcoupons = _react2.default.createElement(
							'div',
							{ className: 'row ', style: { paddingTop: '10px', paddingBottom: '10px', backgroundColor: '#fff!important' } },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-6 col-xs-6 col-sm-6 col-xs-offset' },
								_react2.default.createElement(
									'div',
									{ className: 'mob_new_coupon_blk' },
									_react2.default.createElement(
										'i',
										{ className: 'coupon_left_img' },
										_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_left.png', alt: ' ' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'coupon_text' },
										this.state.coupon_first.coupon_code
									),
									_react2.default.createElement(
										_reactBootstrap.OverlayTrigger,
										{ trigger: 'focus', placement: 'top', overlay: descriptionTop },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ className: 'coupon_info_img' },
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/coupon_info.png', alt: ' ' })
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-6 col-xs-6 col-sm-6' },
								_react2.default.createElement(
									_reactBootstrap.OverlayTrigger,
									{ trigger: 'focus', placement: 'top', overlay: couponsList },
									_react2.default.createElement(
										_reactBootstrap.Button,
										{ className: 'applied_coupons' },
										'Applied coupons'
									)
								)
							)
						);
					}
				} else {
					getcoupons = '';
				}
				var ad_assist_data = _react2.default.createElement(
					_reactBootstrap.Popover,
					{ className: 'in', id: 'popover-positioned-top2' },
					_react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: this.state.ad_grnt_str } })
				);
	
				var ad_assist_icon = this.state.ad_guarantee === 1 && this.state.ad_guarantee_icon ? _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{ trigger: 'focus', placement: 'top', overlay: ad_assist_data },
					_react2.default.createElement(
						_reactBootstrap.Button,
						{ className: 'ad_guarantee_icon' },
						_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/' + this.state.ad_guarantee_icon, alt: ' ' })
					)
				) : '';
	
				var caa_icon = this.state.caa_approved_flag === 1 ? _react2.default.createElement(
					'span',
					{ className: 'caa_icon' },
					_react2.default.createElement('img', { src: this.state.caa_icon, alt: ' ' })
				) : '';
	
				// const tabs_params = {
				//   paginationClickable: true,
				//   spaceBetween: 10,
				//   slidesPerView: 2
				// }
				var deals_params = {
					paginationClickable: true,
					spaceBetween: 10,
					slidesPerView: 3
				};
				var z = this.state.swipe_attributes_titles.map(function (name, index) {
					var _this3 = this;
	
					return _react2.default.createElement(
						'div',
						{ className: this.state.swipe_attr_status === name.cid && this.state.isToggle ? "swipe_attr_title_blk swipe_title_active" : "swipe_attr_title_blk" },
						_react2.default.createElement(
							'div',
							{ style: { background: '#fff', borderRadius: '13px', padding: '8px 2px', fontSize: '12px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', cursor: 'pointer' }, onClick: function onClick() {
									_this3.getswipeDescription(_this3.props.params.Pid, name.cid);
								} },
							_react2.default.createElement(
								'a',
								{ title: name.title, className: 'product_att_titles' },
								name.title
							)
						),
						' ',
						this.state.swipe_attr_status === name.cid && this.state.isToggle ? _react2.default.createElement(
							'div',
							{ className: 'arrow_indi1' },
							_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/triangle_up.png', alt: ' ', width: '20px' })
						) : ''
					);
				}.bind(this));
	
				var z2 = this.state.swipe_attributes_titles.map(function (name, index) {
					var _this4 = this;
	
					return _react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'tab_txt', onClick: function onClick() {
									_this4.getswipeDescription(_this4.props.params.Pid, name.cid);
								} },
							name.title
						),
						this.state.swipe_attr_status === name.cid && this.state.isToggle ? _react2.default.createElement(
							'div',
							{ className: 'arrow_indi1' },
							_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/triangle_up.png', alt: ' ', width: '20px' })
						) : _react2.default.createElement(
							'div',
							{ className: 'arrow_indihide' },
							_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/triangle_up.png', alt: ' ', width: '20px' })
						)
					);
				}.bind(this));
	
				var params = {
					paginationClickable: true,
					spaceBetween: 20,
					slidesPerView: 2.3
				};
	
				var similar_brand_deals = this.state.similar_brand_deals.map(function (data, index) {
					return _react2.default.createElement(
						'div',
						{ className: data.title === "View More" ? "swipe_dtls_content1" : "similar_deals_item" },
						data.promo_ribbion ? _react2.default.createElement(
							'i',
							{ className: 'ribbon_img' },
							_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + data.promo_ribbion, alt: '' })
						) : '',
						data.title === "View More" ? _react2.default.createElement(
							_reactRouter.Link,
							{ to: "/pdeals/" + data.url_dtype_name + '/' + data.url_cat_name + '/' + this.state.category_id + '/Pcategory/' + data.dtype },
							data.image === '' ? '' : _react2.default.createElement('img', { className: 'sw_dtls_img', src: baseAssets + 'images/product_imgs/' + data.image, alt: ' ' }),
							data.title ? _react2.default.createElement(
								'h5',
								{ className: 'm_dtls_name organic_dtls_name view_more_title' },
								data.title
							) : _react2.default.createElement(
								'h5',
								null,
								'\xA0'
							),
							data.brand_name ? _react2.default.createElement(
								'h6',
								{ className: 'sw_brand_name' },
								data.brand_name
							) : _react2.default.createElement(
								'h6',
								null,
								'\xA0'
							),
							data.mrp ? _react2.default.createElement(
								'p',
								{ className: 'sw_dtls_price' },
								'MRP \u20B9 ',
								data.mrp
							) : _react2.default.createElement(
								'p',
								null,
								'\xA0'
							)
						) : _react2.default.createElement(
							'a',
							{ href: '/pdetails/' + data.url_dtype_name + '/' + data.url_cat_name + '/' + data.url_brand_name + '/' + data.url_product_name + '/' + data.pid + '/' + data.deal_id },
							data.image === '' ? '' : _react2.default.createElement('img', { className: 'sw_dtls_img', src: baseAssets + 'images/product_imgs/' + data.image, alt: ' ' }),
							data.title ? _react2.default.createElement(
								'h5',
								{ className: 'm_dtls_name organic_dtls_name view_more_title' },
								data.title
							) : _react2.default.createElement(
								'h5',
								null,
								'\xA0'
							),
							data.brand_name ? _react2.default.createElement(
								'h6',
								{ className: 'sw_brand_name' },
								data.brand_name
							) : _react2.default.createElement(
								'h6',
								null,
								'\xA0'
							),
							data.mrp ? _react2.default.createElement(
								'p',
								{ className: 'sw_dtls_price' },
								'MRP \u20B9 ',
								data.mrp
							) : _react2.default.createElement(
								'p',
								null,
								'\xA0'
							)
						)
					);
				}.bind(this));
	
				var similar_category_deals = this.state.similar_category_deals.map(function (data, index) {
					return _react2.default.createElement(
						'div',
						{ className: data.title === "View More" ? "swipe_dtls_content1" : "similar_deals_item" },
						data.promo_ribbion ? _react2.default.createElement(
							'i',
							{ className: 'ribbon_img' },
							_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + data.promo_ribbion, alt: '' })
						) : '',
						data.title === "View More" ? _react2.default.createElement(
							'a',
							{ href: "/pdeals/" + data.url_dtype_name + '/' + data.url_cat_name + '/' + this.state.category_id + '/Pcategory/' + data.dtype },
							data.image === '' ? '' : _react2.default.createElement('img', { className: 'sw_dtls_img', src: baseAssets + 'images/product_imgs/' + data.image, alt: ' ' }),
							data.title ? _react2.default.createElement(
								'h5',
								{ className: 'm_dtls_name organic_dtls_name view_more_title' },
								data.title
							) : _react2.default.createElement(
								'h5',
								null,
								'\xA0'
							),
							data.brand_name ? _react2.default.createElement(
								'h6',
								{ className: 'sw_brand_name' },
								data.brand_name
							) : _react2.default.createElement(
								'h6',
								null,
								'\xA0'
							),
							data.mrp ? _react2.default.createElement(
								'p',
								{ className: 'sw_dtls_price' },
								'MRP \u20B9 ',
								data.mrp
							) : _react2.default.createElement(
								'p',
								null,
								'\xA0'
							)
						) : _react2.default.createElement(
							'a',
							{ href: '/pdetails/' + data.url_dtype_name + '/' + data.url_cat_name + '/' + data.url_brand_name + '/' + data.url_product_name + '/' + data.pid + '/' + data.deal_id },
							data.image === '' ? '' : _react2.default.createElement('img', { className: 'sw_dtls_img', src: baseAssets + 'images/product_imgs/' + data.image, alt: ' ' }),
							data.title ? _react2.default.createElement(
								'h5',
								{ className: 'm_dtls_name organic_dtls_name view_more_title' },
								data.title
							) : _react2.default.createElement(
								'h5',
								null,
								'\xA0'
							),
							data.brand_name ? _react2.default.createElement(
								'h6',
								{ className: 'sw_brand_name' },
								data.brand_name
							) : _react2.default.createElement(
								'h6',
								null,
								'\xA0'
							),
							data.mrp ? _react2.default.createElement(
								'p',
								{ className: 'sw_dtls_price' },
								'MRP \u20B9 ',
								data.mrp
							) : _react2.default.createElement(
								'p',
								null,
								'\xA0'
							)
						)
					);
				}.bind(this));
	
				var similar_stage_deals = this.state.similar_stage_deals.map(function (data, index) {
					return _react2.default.createElement(
						'div',
						{ className: data.title === "View More" ? "swipe_dtls_content1" : "similar_deals_item" },
						data.promo_ribbion ? _react2.default.createElement(
							'i',
							{ className: 'ribbon_img' },
							_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + data.promo_ribbion, alt: '' })
						) : '',
						data.title === "View More" ? _react2.default.createElement(
							_reactRouter.Link,
							{ to: "/pdeals/" + data.url_dtype_name + '/' + data.url_cat_name + '/' + this.state.category_id + '/Pcategory/' + data.dtype },
							data.image === '' ? '' : _react2.default.createElement('img', { className: 'sw_dtls_img', src: baseAssets + 'images/product_imgs/' + data.image, alt: ' ' }),
							data.title ? _react2.default.createElement(
								'h5',
								{ className: 'm_dtls_name organic_dtls_name view_more_title' },
								data.title
							) : _react2.default.createElement(
								'h5',
								null,
								'\xA0'
							),
							data.brand_name ? _react2.default.createElement(
								'h6',
								{ className: 'sw_brand_name' },
								data.brand_name
							) : _react2.default.createElement(
								'h6',
								null,
								'\xA0'
							),
							data.mrp ? _react2.default.createElement(
								'p',
								{ className: 'sw_dtls_price' },
								'MRP \u20B9 ',
								data.mrp
							) : _react2.default.createElement(
								'p',
								null,
								'\xA0'
							)
						) : _react2.default.createElement(
							'a',
							{ href: '/pdetails/' + data.url_dtype_name + '/' + data.url_cat_name + '/' + data.url_brand_name + '/' + data.url_product_name + '/' + data.pid + '/' + data.deal_id },
							data.image === '' ? '' : _react2.default.createElement('img', { className: 'sw_dtls_img', src: baseAssets + 'images/product_imgs/' + data.image, alt: ' ' }),
							data.title ? _react2.default.createElement(
								'h5',
								{ className: 'm_dtls_name organic_dtls_name view_more_title' },
								data.title
							) : _react2.default.createElement(
								'h5',
								null,
								'\xA0'
							),
							data.brand_name ? _react2.default.createElement(
								'h6',
								{ className: 'sw_brand_name' },
								data.brand_name
							) : _react2.default.createElement(
								'h6',
								null,
								'\xA0'
							),
							data.mrp ? _react2.default.createElement(
								'p',
								{ className: 'sw_dtls_price' },
								'MRP \u20B9 ',
								data.mrp
							) : _react2.default.createElement(
								'p',
								null,
								'\xA0'
							)
						)
					);
				}.bind(this));
	
				// errors of the req form 
				(0, _jquery2.default)('#req_quantity').keyup(function () {
					(0, _jquery2.default)('#req_quantity_err').text('');
				});
				(0, _jquery2.default)('#req_state').keyup(function () {
					(0, _jquery2.default)('#req_state_err').text('');
				});
				(0, _jquery2.default)('#req_city').keyup(function () {
					(0, _jquery2.default)('#req_city_err').text('');
				});
				(0, _jquery2.default)('#req_doorno').keyup(function () {
					(0, _jquery2.default)('#req_doorno_err').text('');
				});
				(0, _jquery2.default)('#req_pincode').keyup(function () {
					(0, _jquery2.default)('#req_pincode_err').text('');
				});
	
				var wishLst_flag = '';
				if (this.state.wishLst_flag === 1) {
					wishLst_flag = _react2.default.createElement(
						'div',
						{ className: 'goto_wish_blk' },
						_react2.default.createElement(
							'div',
							{ className: 'col-md-6 col-sm-6 col-xs-6 first_blk' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/wishlist' },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/wish_list_filled.png', alt: '', width: '16px', style: { marginRight: '5px' } })
								),
								' Go to wishlist'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-md-6 col-sm-6 col-xs-6 second_blk' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ className: 'share_list1', onClick: function onClick() {
										_this5.ShareFunc(_this5.state.dealid);
									} },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'mob-assets/share.png', alt: 'share', width: '19px' })
								),
								_react2.default.createElement(
									'span',
									null,
									'Share'
								)
							),
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									_reactBootstrap.Panel,
									{ className: 'pro_full_panel1', collapsible: true, expanded: this.state.open },
									_react2.default.createElement(
										FacebookShareButton,
										{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
										_react2.default.createElement(FacebookIcon, { size: 32, round: true })
									),
									_react2.default.createElement(
										TwitterShareButton,
										{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
										_react2.default.createElement(TwitterIcon, { size: 32, round: true })
									),
									_react2.default.createElement(
										GooglePlusShareButton,
										{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
										_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
									)
								)
							)
						)
					);
				} else {
					wishLst_flag = _react2.default.createElement(
						'div',
						{ className: 'addto_wish_blk' },
						_react2.default.createElement(
							'div',
							{ className: 'col-md-6 col-sm-6 col-xs-6 first_blk' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ onClick: function onClick() {
										_this5.addToWishlist();
									} },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/wish_list_unfilled.png', alt: '', width: '12px' })
								),
								' Add to wishlist'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-md-6 col-sm-6 col-xs-6 second_blk' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ className: 'share_list1', onClick: function onClick() {
										_this5.ShareFunc(_this5.state.dealid);
									} },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'mob-assets/share.png', alt: 'share', width: '19px' })
								),
								_react2.default.createElement(
									'span',
									null,
									'Share'
								)
							),
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									_reactBootstrap.Panel,
									{ className: 'pro_full_panel1', collapsible: true, expanded: this.state.open },
									_react2.default.createElement(
										FacebookShareButton,
										{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
										_react2.default.createElement(FacebookIcon, { size: 32, round: true })
									),
									_react2.default.createElement(
										TwitterShareButton,
										{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
										_react2.default.createElement(TwitterIcon, { size: 32, round: true })
									),
									_react2.default.createElement(
										GooglePlusShareButton,
										{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
										_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
									)
								)
							)
						)
					);
				}
				var likes_btn = this.state.brand_like_status === '1' ? _react2.default.createElement(
					'span',
					{ className: 'pro_brand_dtls_likes', onClick: function onClick() {
							_this5.likeBrand(0);
						} },
					_react2.default.createElement('i', { className: "glyph_heart_active glyphicon glyphicon-heart" }),
					parseInt(this.state.brand_likes_count, 10) === 1 ? this.state.brand_likes_count + ' Like' : this.state.brand_likes_count + ' Likes'
				) : _react2.default.createElement(
					'span',
					{ className: 'pro_brand_dtls_likes', onClick: function onClick() {
							_this5.likeBrand(1);
						} },
					_react2.default.createElement('i', { className: "glyph_heart glyphicon glyphicon-heart" }),
					parseInt(this.state.brand_likes_count, 10) === 1 ? this.state.brand_likes_count + ' Like' : this.state.brand_likes_count + ' Likes'
				);
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals' },
					this.state.loading && !this.state.page_error_status ? _react2.default.createElement(
						'div',
						{ className: 'pro_full_details_page', itemScope: 'itemScope', itemType: 'http://schema.org/Product' },
						_react2.default.createElement(
							'div',
							{ className: 'page_hdr dtl_pg_hdr' },
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ onClick: function onClick() {
												_reactRouter.browserHistory.goBack();
											} },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: ' ' })
										)
									),
									this.state.pro_details.brand_name
								),
								_react2.default.createElement(
									'a',
									{ href: '/', className: 'home_newicon' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
								)
							)
						),
						_react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'div',
								{ className: 'row lst_img', style: { position: 'relative', height: '360px' } },
								caa_icon,
								_react2.default.createElement(
									'section',
									{ id: 'mob_pro_imgs' },
									_react2.default.createElement(
										_reactIdSwiper2.default,
										carousel_params,
										product_imgs
									)
								),
								this.state.page_loading ? _react2.default.createElement(
									'i',
									{ className: 'mob_loading' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/mob_loading.gif', alt: 'Loading' })
								) : '',
								_react2.default.createElement(
									'div',
									{ className: 'view_rec_blk' },
									views_cnt,
									'\xA0',
									recommendation
								)
							)
						),
						_react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'div',
								{ className: 'row full_deals_name deal_name' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-12 col-sm-12 col-xs-12' },
									_react2.default.createElement(
										'div',
										{ style: { backgroundColor: '#fff' } },
										this.state.pro_details.title ? _react2.default.createElement(
											'h4',
											{ itemProp: 'name' },
											this.state.pro_details.title,
											' ',
											this.state.pro_details.unit_pack
										) : '',
										this.state.pro_details.brand_name ? _react2.default.createElement(
											'h5',
											{ itemProp: 'brand' },
											_react2.default.createElement(
												'span',
												{ className: 'mob_brand_flag_img' },
												_react2.default.createElement('img', { src: baseAssets + 'icons/' + this.state.pro_details.brand_flag, role: 'presentation', alt: ' ' })
											),
											this.state.pro_details.brand_name
										) : '',
										this.state.pro_deal_details.mrp ? _react2.default.createElement(
											'h4',
											{ itemProp: 'offers', itemScope: true, itemType: 'http://schema.org/Offer', className: 'deal_mrp' },
											_react2.default.createElement('meta', { itemProp: 'priceCurrency', content: 'INR' }),
											'MRP ',
											_react2.default.createElement('span', null),
											_react2.default.createElement(
												'span',
												{ style: { color: '#333' } },
												'\u20B9'
											),
											' ',
											_react2.default.createElement(
												'span',
												{ itemProp: 'price' },
												this.state.pro_deal_details.mrp
											)
										) : '',
										this.state.show_order_count === 1 ? _react2.default.createElement(
											'p',
											null,
											_react2.default.createElement(
												'span',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/hot_sale.png', alt: '', width: '16px' })
											),
											this.state.order_count
										) : '',
										ad_assist_icon
									)
								)
							)
						),
						_react2.default.createElement('div', { className: 'clr' }),
						_react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							wishLst_flag
						),
						_react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h4',
								{ className: 'pro_header_h4' },
								'Discount & Offers'
							),
							_react2.default.createElement(
								'div',
								{ className: 'row deal_name' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-12 col-sm-12 col-xs-12' },
									_react2.default.createElement(
										'div',
										{ style: { backgroundColor: '#fff' } },
										this.state.offer_details.aqua_cash_title ? _react2.default.createElement(
											'h5',
											{ className: 'book_aquacash' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/nav_aquacash.png', alt: ' ', width: '20px' })
											),
											this.state.offer_details.aqua_cash_title
										) : '',
										this.state.offer_details.full_aquacash_back_title ? _react2.default.createElement(
											'h5',
											{ className: 'cashback' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/newcashback.png', width: '18px', alt: ' ' })
											),
											this.state.offer_details.full_aquacash_back_title
										) : '',
										this.state.offer_details.pur_ern_ofr_desc ? _react2.default.createElement(
											'h5',
											{ className: 'book_aquacash' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/nav_aquacash.png', alt: ' ', width: '18px' })
											),
											this.state.offer_details.pur_ern_ofr_desc
										) : '',
										parseInt(this.state.offer_details.emi_opt_sts) === 1 ? _react2.default.createElement(
											'h5',
											{ className: 'mob_emi' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/emi.png', alt: ' ', width: '20px' })
											),
											this.state.offer_details.emi_opt_desc
										) : ''
									)
								)
							)
						),
						this.state.show_about_brand_flag ? _react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'div',
								{ className: 'pro_abt_brand_blk' },
								_react2.default.createElement(
									'h4',
									{ className: 'pro_header_h4' },
									'About the brand'
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-12 col-sm-12 col-xs-12', style: { padding: '0px 0px 10px 0px!important' } },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-3 col-sm-3 col-xs-3', style: { padding: '0px 5px 0px 0px!important' } },
										_react2.default.createElement(
											_reactRouter.Link,
											{ className: 'pro_abt_link', to: this.state.pro_details ? '/' + this.state.pro_details.url_brand_name + '/brand-details/' + this.state.offer.bid : '' },
											_react2.default.createElement(
												'i',
												null,
												_react2.default.createElement('img', { src: this.state.pro_details ? baseAssets + 'images/brand_icons/' + this.state.pro_details.brand_logo : '', alt: ' ' })
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-md-9 col-sm-9 col-xs-9', style: { padding: '15px 0px 0px 0px!important' } },
										_react2.default.createElement(
											_reactRouter.Link,
											{ className: 'pro_abt_link', to: this.state.pro_details ? '/' + this.state.pro_details.url_brand_name + '/brand-details/' + this.state.offer.bid : '' },
											_react2.default.createElement(
												'h5',
												{ className: 'pro_abt_brand_title' },
												this.state.pro_details ? this.state.pro_details.brand_name : ''
											),
											_react2.default.createElement(
												'p',
												{ className: 'pro_abt_brand_desc' },
												this.state.pro_details ? this.state.pro_details.brand_desc : ''
											)
										),
										likes_btn
									)
								)
							)
						) : '',
						this.state.coupons.length > 0 ? _react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h4',
								{ className: 'pro_header_h4' },
								'Coupons'
							),
							getcoupons
						) : '',
						_react2.default.createElement(
							'section',
							{ className: 'container-fluid pro_block_header1' },
							_react2.default.createElement(
								'h4',
								{ className: 'pro_header_h4' },
								'Select Quantity'
							),
							_react2.default.createElement(
								'div',
								{ className: 'row qty_selectblk' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-12 col-sm-12 col-xs-12' },
									this.state.unit_name === "kg" || this.state.unit_name === "gm" ? _react2.default.createElement(
										'div',
										{ className: 'qty_section' },
										_react2.default.createElement(
											'button',
											{ className: 'minus_btn', onClick: function onClick() {
													_this5.decrementMinQty();
												} },
											_react2.default.createElement('img', { src: __webpack_require__(45), alt: ' ' })
										),
										_react2.default.createElement(
											'span',
											{ className: 'min_qty_btn' },
											_react2.default.createElement('input', { type: 'text', placeholder: this.state.min_qty1, value: this.state.min_qty, ref: 'input_minqty', onChange: this.updateMinQty })
										),
										_react2.default.createElement(
											'button',
											{ className: 'plus_btn', onClick: function onClick() {
													_this5.incrementMinQty();
												} },
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/plus.png', alt: ' ' })
										),
										_react2.default.createElement(
											'button',
											{ className: 'equal_btn' },
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/equalto.png', alt: ' ' }),
											' '
										),
										_react2.default.createElement(
											'span',
											{ className: 'qty_value' },
											_react2.default.createElement(
												'span',
												{ className: 'qty_mainvalue' },
												this.state.tons
											),
											_react2.default.createElement('br', null),
											_react2.default.createElement(
												'span',
												{ className: 'qty_unitname' },
												'Tons'
											)
										),
										_react2.default.createElement(
											'i',
											{ className: 'truck_img_blk' },
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/truck.png', alt: ' ', width: '80px' })
										),
										this.state.qty_err_status ? _react2.default.createElement(
											'p',
											{ className: 'err_quantity' },
											this.state.qty_err_msg
										) : ''
									) : _react2.default.createElement(
										'div',
										{ className: 'qty_section', style: { textAlign: 'center' } },
										_react2.default.createElement(
											'button',
											{ className: 'minus_btn', onClick: function onClick() {
													_this5.decrementMinQty();
												} },
											_react2.default.createElement('img', { src: __webpack_require__(45), alt: ' ' })
										),
										_react2.default.createElement(
											'span',
											{ className: 'min_qty_btn' },
											_react2.default.createElement('input', { type: 'text', placeholder: this.state.min_qty1, value: this.state.min_qty, ref: 'input_minqty', onChange: this.updateMinQty })
										),
										_react2.default.createElement(
											'button',
											{ className: 'plus_btn', onClick: function onClick() {
													_this5.incrementMinQty();
												} },
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/plus.png', alt: ' ' })
										),
										this.state.qty_err_status ? _react2.default.createElement(
											'p',
											{ className: 'web_err_quantity' },
											this.state.qty_err_msg
										) : ''
									),
									_react2.default.createElement(
										'div',
										{ className: 'mob_prev_order_text' },
										this.state.previous_order === '' ? '' : this.state.previous_order
									)
								)
							)
						),
						_react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h4',
								{ className: 'pro_header_h4' },
								'More Options'
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-6 col-xs-6 col-sm-6 col-xs-offset', style: { textAlign: 'center', paddingTop: '15px', paddingBottom: '15px', cursor: 'pointer' }, onClick: function onClick() {
										_this5.checkBestPrice();
									} },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/get_best_price.png', alt: ' ', width: '40px' })
								),
								_react2.default.createElement(
									'span',
									{ style: { display: 'block', fontSize: '11px', paddingTop: '3px' } },
									'GET BEST PRICE'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-6 col-xs-6 col-sm-6', style: { textAlign: 'center', paddingTop: '15px', paddingBottom: '15px', cursor: 'pointer' }, onClick: function onClick() {
										_this5.getAdAssistModal();
									} },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/ad_assist_icon_5.png', alt: ' ', width: '40px' })
								),
								_react2.default.createElement(
									'span',
									{ style: { display: 'block', fontSize: '11px', paddingTop: '3px' } },
									'AD ASSIST'
								)
							)
						),
						this.state.free_ship_flag === 1 ? _react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h4',
								{ className: 'pro_header_h4' },
								'Free Shipment'
							),
							_react2.default.createElement(
								'div',
								{ className: 'row mob_pinblk' },
								this.state.free_ship_flag === 1 ? _react2.default.createElement(
									'div',
									{ className: 'col-md-12 col-sm-12 col-xs-12' },
									_react2.default.createElement(
										'div',
										{ className: 'mob_pin_inputblk' },
										_react2.default.createElement('input', { type: 'text', placeholder: 'Pincode', value: this.state.user_zipcode === '0' ? '' : this.state.user_zipcode, maxLength: 6, ref: 'pincode', onChange: function onChange() {
												_this5.pincodeChange();
											} }),
										_react2.default.createElement(
											'a',
											{ className: 'mob_pin_btn', onClick: function onClick() {
													_this5.checkPincode();
												} },
											'Check'
										)
									),
									this.state.err_pincode ? _react2.default.createElement(
										'span',
										{ className: 'err_pincode' },
										this.state.err_pincode_msg
									) : '',
									_react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/shipping_van.png', alt: ' ' })
										),
										_react2.default.createElement(
											'span',
											null,
											this.state.free_ship_msg
										)
									)
								) : ''
							)
						) : '',
						this.state.product_tabs_avail ? _react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h4',
								{ className: 'pro_header_h4' },
								'Details'
							),
							_react2.default.createElement(
								'div',
								{ className: 'row', style: { backgroundColor: '#f2f2f2' } },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-12 col-sm-12 col-xs-12', style: { marginTop: '5px' } },
									_react2.default.createElement(
										'div',
										{ className: 'desc_swipeblock' },
										_react2.default.createElement(
											'ul',
											{ className: 'tabs_btns' },
											z2
										),
										this.state.isToggle && this.state.swipe_desc_info ? _react2.default.createElement(
											'div',
											{ style: { marginTop: '-30px' } },
											_react2.default.createElement(
												'div',
												{ className: 'row description_blk' },
												this.state.swipe_desc_info ? _react2.default.createElement(
													'section',
													{ className: 'mob_pro_desc' },
													_react2.default.createElement('div', { dangerouslySetInnerHTML: {
															__html: this.state.swipe_desc_info
														} })
												) : ''
											)
										) : '',
										this.state.isToggle && swipe_product_attributes.length > 0 ? _react2.default.createElement(
											'div',
											{ className: 'row' },
											_react2.default.createElement(
												'div',
												{ className: 'col-md-12 col-xs-12 col-sm-12 description_cntnt' },
												_react2.default.createElement(
													'table',
													null,
													swipe_product_attributes
												)
											)
										) : ''
									)
								)
							)
						) : '',
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid', style: { backgroundColor: '#f1f2f2', padding: '1px 0px 0px 0px!important' } },
							this.state.brand_sim_flag === 1 ? _react2.default.createElement(
								'div',
								{ className: 'similar_tab_item similar_tab_over_text', onClick: function onClick() {
										_this5.getSimilarBrandDeals();
									} },
								_react2.default.createElement(
									'i',
									{ className: 'similar_tab_item_float' },
									_react2.default.createElement('img', { src: __webpack_require__(259), alt: '...', width: '25' })
								),
								_react2.default.createElement(
									'span',
									{ className: 'over_text' },
									'More deals from ' + this.state.pro_details.brand_name
								),
								' ',
								this.state.similar_brand_deals_status ? _react2.default.createElement(
									'i',
									{ className: 'similar_arrow_icon' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/up_black.png', alt: '', width: '25px' })
								) : _react2.default.createElement(
									'i',
									{ className: 'similar_arrow_icon' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/down_black.png', alt: '', width: '25px' })
								)
							) : '',
							this.state.similar_brand_deals_status ? _react2.default.createElement(
								'div',
								{ className: 'similar_deals_blk' },
								_react2.default.createElement(
									_reactIdSwiper2.default,
									_extends({}, deals_params, { key: similar_brand_deals.length }),
									similar_brand_deals
								)
							) : '',
							this.state.cat_sim_flag === 1 ? _react2.default.createElement(
								'div',
								{ className: 'similar_tab_item similar_tab_over_text', onClick: function onClick() {
										_this5.getSimilarCatDeals();
									} },
								_react2.default.createElement(
									'i',
									{ className: 'similar_tab_item_float' },
									_react2.default.createElement('img', { src: __webpack_require__(260), alt: '...', width: '25' })
								),
								_react2.default.createElement(
									'span',
									{ className: 'over_text' },
									'More deals in ' + this.state.pro_details.category
								),
								' ',
								this.state.similar_category_deals_status ? _react2.default.createElement(
									'i',
									{ className: 'similar_arrow_icon' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/up_black.png', alt: '', width: '25px' })
								) : _react2.default.createElement(
									'i',
									{ className: 'similar_arrow_icon' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/down_black.png', alt: '', width: '25px' })
								)
							) : '',
							this.state.similar_category_deals_status ? _react2.default.createElement(
								'div',
								{ className: 'similar_deals_blk' },
								_react2.default.createElement(
									_reactIdSwiper2.default,
									_extends({}, deals_params, { key: similar_category_deals.length }),
									similar_category_deals
								)
							) : '',
							this.state.stage_sim_flag === 1 ? _react2.default.createElement(
								'div',
								{ className: 'similar_tab_item similar_tab_over_text', onClick: function onClick() {
										_this5.getSimilarStageDeals();
									} },
								_react2.default.createElement(
									'i',
									{ className: 'similar_tab_item_float' },
									_react2.default.createElement('img', { src: __webpack_require__(261), alt: '...', width: '25' })
								),
								_react2.default.createElement(
									'span',
									{ className: 'over_text' },
									'View Similar Stage'
								),
								' ',
								this.state.similar_stage_deals_status ? _react2.default.createElement(
									'i',
									{ className: 'similar_arrow_icon' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/up_black.png', alt: '', width: '25px' })
								) : _react2.default.createElement(
									'i',
									{ className: 'similar_arrow_icon' },
									_react2.default.createElement('img', { src: baseAssets + "images/web_imgs/down_black.png", alt: '', width: '25px' })
								)
							) : '',
							this.state.similar_stage_deals_status ? _react2.default.createElement(
								'div',
								{ className: 'similar_deals_blk' },
								_react2.default.createElement(
									_reactIdSwiper2.default,
									_extends({}, deals_params, { key: similar_stage_deals.length }),
									similar_stage_deals
								)
							) : ''
						),
						this.state.disclaimer_flag ? _react2.default.createElement(
							'div',
							{ className: 'view_disclaimer_details' },
							_react2.default.createElement(
								'span',
								{ id: 'disclaimer_toggle_txt' },
								_react2.default.createElement(
									'a',
									{ onClick: function onClick() {
											_this5.toggleDisclaimer();
										} },
									this.state.visibility ? "Hide Disclaimer" : "View Disclaimer"
								)
							),
							this.state.visibility ? _react2.default.createElement('span', { id: 'mob_disclaimer_txt', dangerouslySetInnerHTML: { __html: this.state.disclaimer_txt } }) : ''
						) : '',
						_react2.default.createElement(
							'section',
							{ className: 'botm_btns container-fluid', style: { paddingBottom: '5px' } },
							_react2.default.createElement(
								'ul',
								null,
								this.state.zendesk_flag == 1 ? _react2.default.createElement(
									'li',
									{ className: 'col-md-6 col-xs-6 col-sm-6 mob_get_best_price_btn wb_btn', style: { cursor: 'pointer' }, onClick: function onClick() {
											_this5.chatnow();
										} },
									_react2.default.createElement(
										_reactRouter.Link,
										null,
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/wb_icon.png', alt: ' ' })
										),
										_react2.default.createElement(
											'span',
											{ style: { color: '#00B646' } },
											'CHAT NOW'
										)
									)
								) : _react2.default.createElement(
									'li',
									{ className: 'col-md-6 col-xs-6 col-sm-6 mob_get_best_price_btn', style: { cursor: 'pointer' } },
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: '/customer_care' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/icons/enquiry_now.png', alt: ' ' })
										),
										'ENQUIRE NOW'
									)
								),
								_react2.default.createElement(
									'li',
									{ className: this.state.rotateClass ? "col-md-6 col-xs-6 col-sm-6 mob_rotate_true" : "col-md-6 col-xs-6 col-sm-6 mob_rotate_false", onClick: function onClick() {
											_this5.placeOrderModal();
										}, style: { cursor: 'pointer' } },
									_react2.default.createElement(
										_reactRouter.Link,
										null,
										this.state.addtocart_msg
									)
								)
							)
						)
					) : _react2.default.createElement(
						'div',
						null,
						this.state.page_error_status ? _react2.default.createElement(_NotFound2.default, null) : _react2.default.createElement(
							'div',
							{ className: 'mob_loading' },
							_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/mob_loading.gif', alt: 'AquaDeals' })
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.clearcart_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#333' } },
								'You can\'t have multiple seller items in the cart. Empty existing cart & add this item ',
								this.state.pro_details.title,
								'?'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'NO'
							),
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: function onClick() {
											_this5.removeCartItems();
										} },
									'YES'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.cart_added_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#666' } },
								'Product already added to the cart!'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'Close'
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'mob_reqbestprice', show: this.state.reqbestPrice, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'section',
								{ className: 'bst_header_block', style: { textAlign: 'center' } },
								_react2.default.createElement(
									'h4',
									{ className: 'req_title' },
									'REQUEST FOR BEST PRICE'
								),
								_react2.default.createElement(
									'span',
									{ onClick: this.close },
									_react2.default.createElement(_reactWebVectorIcons2.default, {
										name: 'close',
										font: 'SimpleLineIcons',
										color: '#333',
										size: 16,
										style: { position: 'absolute', right: '10px', top: '8px', cursor: 'pointer' }
									})
								),
								_react2.default.createElement('img', { src: __webpack_require__(251), width: '80', alt: '' }),
								_react2.default.createElement(
									'p',
									{ className: 'req_desc' },
									_react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.state.best_price_txt } })
								)
							),
							_react2.default.createElement(
								'form',
								{ className: 'req_best_price_form', onSubmit: this.reqBestPriceSubmit },
								_react2.default.createElement('input', { type: 'text', maxLength: 10, id: 'req_quantity', ref: 'req_quantity', value: this.state.req_quantity, onChange: this.req_quantityChange, placeholder: 'Enter Quantity' }),
								_react2.default.createElement('span', { className: 'req_err', id: 'req_quantity_err' }),
								_react2.default.createElement('input', { type: 'text', ref: 'req_state', id: 'req_state', value: this.state.req_state, onChange: this.req_stateChange, placeholder: 'Enter State' }),
								_react2.default.createElement('span', { className: 'req_err', id: 'req_state_err' }),
								_react2.default.createElement('input', { type: 'text', maxLength: 6, ref: 'req_pincode', id: 'req_pincode', value: this.state.req_pincode, onChange: this.req_pincodeChange, placeholder: 'Pincode' }),
								_react2.default.createElement('span', { className: 'req_err', id: 'req_pincode_err' }),
								_react2.default.createElement(
									'div',
									{ className: 'req_footer' },
									_react2.default.createElement(
										'button',
										{ type: 'submit' },
										'SUBMIT'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'mob_reqbestprice_confm', show: this.state.req_confirm_modal, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							this.state.req_confirm_message,
							_react2.default.createElement(
								'a',
								{ onClick: this.close, className: 'req_conf_ok_btn' },
								'OK'
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'ad_asst_modalbox', show: this.state.ad_assist_modal, onHide: this.close, id: 'ad_assist_home' },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'section',
								{ id: 'assets_cnt_block' },
								_react2.default.createElement(
									'span',
									{ onClick: this.close },
									_react2.default.createElement(_reactWebVectorIcons2.default, {
										name: 'close',
										font: 'SimpleLineIcons',
										color: '#fff',
										size: 16,
										style: { position: 'absolute', right: '10px', top: '8px', cursor: 'pointer' }
									})
								),
								_react2.default.createElement('img', { src: __webpack_require__(106), alt: '' }),
								_react2.default.createElement(
									'p',
									null,
									'Please submit the details, one of our experts will respond shortly.'
								),
								_react2.default.createElement(
									'section',
									{ className: 'ad_prd_blocks' },
									_react2.default.createElement(
										'p',
										null,
										_react2.default.createElement(
											'span',
											{ className: 'orng_clr' },
											'Brand: '
										),
										this.state.pro_details.brand_name ? this.state.pro_details.brand_name : ''
									),
									_react2.default.createElement(
										'p',
										null,
										_react2.default.createElement(
											'span',
											{ className: 'orng_clr' },
											'Product: '
										),
										' ',
										this.state.pro_details.title ? this.state.pro_details.title : ''
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'aqua-txt-block' },
									_react2.default.createElement(
										'select',
										{ id: 'ad-sel-question' },
										this.state.queries.map(function (option) {
											return _react2.default.createElement(
												'option',
												{ key: option.id, value: option.id },
												option.question
											);
										})
									),
									_react2.default.createElement(
										'h6',
										null,
										'Best time to contact:  ',
										this.state.time_err_status ? _react2.default.createElement(
											'span',
											{ style: { color: 'red', fontSize: '10px' } },
											this.state.time_err_msg
										) : ''
									),
									_react2.default.createElement(
										'form',
										{ onSubmit: this.submitAdAssistData },
										_react2.default.createElement(
											'div',
											{ className: 'ad_asst_time_blk' },
											_react2.default.createElement(
												'span',
												{ className: this.state.ad_asst_time === 1 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time", onClick: function onClick() {
														_this5.setAdTime(1);
													} },
												'9am - 12pm'
											),
											_react2.default.createElement(
												'span',
												{ className: this.state.ad_asst_time === 2 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time", onClick: function onClick() {
														_this5.setAdTime(2);
													} },
												'12pm - 3pm'
											),
											_react2.default.createElement(
												'span',
												{ className: this.state.ad_asst_time === 3 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time", onClick: function onClick() {
														_this5.setAdTime(3);
													} },
												'3pm - 5pm'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'ad_asst_submit_blk' },
											_react2.default.createElement(
												'button',
												{ type: 'submit' },
												'SCHEDULE CALL'
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'mob_reqbestprice_confm', show: this.state.ad_asst_confirm_modal, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							this.state.ad_asst_confirm_message,
							_react2.default.createElement(
								'a',
								{ onClick: this.close, className: 'req_conf_ok_btn' },
								'OK'
							)
						)
					)
				);
			}
		}]);
	
		return ProductFullDetails;
	}(_react.Component);
	
	var Details = function (_Component2) {
		_inherits(Details, _Component2);
	
		function Details() {
			_classCallCheck(this, Details);
	
			return _possibleConstructorReturn(this, (Details.__proto__ || Object.getPrototypeOf(Details)).apply(this, arguments));
		}
	
		_createClass(Details, [{
			key: 'render',
			value: function render() {
				var mydata = this.props.data;
				return _react2.default.createElement(
					'tr',
					null,
					mydata.value !== '--' ? _react2.default.createElement(
						'td',
						null,
						mydata.name
					) : '',
					mydata.value !== '--' ? _react2.default.createElement(
						'td',
						{ className: 'desc_right' },
						mydata.value
					) : ''
				);
			}
		}]);
	
		return Details;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			product_tabs: state.posts.product_tabs,
			product_desc: state.posts.product_desc
		};
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(ProductFullDetails);

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactShare = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var SubDeals = function (_Component) {
		_inherits(SubDeals, _Component);
	
		function SubDeals(props) {
			_classCallCheck(this, SubDeals);
	
			var _this = _possibleConstructorReturn(this, (SubDeals.__proto__ || Object.getPrototypeOf(SubDeals)).call(this, props));
	
			_this.state = {
				// tid : this.props.params.Tid,
				// type: this.props.params.Type,
				// dtype: this.props.params.DType,
				pdeals: [],
				totdata: '',
				pid: _this.props.params.Pid,
				sort: '1',
				img_price: 'price.png',
				img_data: 'Price',
				open: false,
				seo_desc: '',
				cart_count: 0,
				loading_gif: false,
				mob_loading: false
			};
			_this.getSort = _this.getSort.bind(_this);
			_this.getDeviceId = _this.getDeviceId.bind(_this);
			_this.getCartCount = _this.getCartCount.bind(_this);
			_this.getNearBy = _this.getNearBy.bind(_this);
	
			return _this;
		}
	
		_createClass(SubDeals, [{
			key: 'getSort',
			value: function getSort() {
				this.setState({
					loading_gif: true
				});
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var data1 = { from: 'mobile_web', uid: uid, sort: this.state.sort, pid: this.state.pid };
				var data2 = JSON.stringify(data1);
				// alert("Sort function");
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getNewsearch',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (this.state.sort === 1) {
							var ss = 2;
							var img_price = 'down.png';
							var img_data = 'High - Low';
						} else {
							ss = 1;
							img_price = 'up.png';
							img_data = 'Low - High';
						}
						this.setState({
							sort: ss,
							img_price: img_price,
							img_data: img_data
						});
						this.setState({
							pdeals: data.products,
							totdata: data,
							loading_gif: false
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'getNearBy',
			value: function getNearBy() {
				this.setState({
					loading_gif: true
				});
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var data1 = { from: 'mobile_web', id: uid, token: localStorage.token, lat: localStorage.getItem('latitude'), long: localStorage.getItem('longitude'), pid: this.state.pid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getNewsearch',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							pdeals: data.products,
							totdata: data,
							loading_gif: false
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Location Error: "+ err);
					}
				});
			}
		}, {
			key: 'getDeviceId',
			value: function getDeviceId() {
				if (localStorage.user_id) {
					var user_id = localStorage.user_id;
				} else {
					user_id = 0;
				}
				var data1 = { from: 'mobile_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getDeviceId',
					dataType: 'json',
					data: { req: data2 },
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'getCartCount',
			value: function getCartCount() {
				if (localStorage.user_id) {
					var user_id = localStorage.user_id;
				} else {
					user_id = 0;
				}
				var data1 = { from: 'mobile_web', id: user_id, token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						console.log(data);
						this.setState({
							cart_count: data.cart_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				localStorage.removeItem('m_r_p_deals');
				this.setState({
					mob_loading: true
				});
				if (this.props.params.BrandName && this.props.params.CatName && this.props.params.ProName && this.props.params.Pid && !this.props.params.DType) {
					localStorage.setItem('subdeals', '/subdeals/' + this.props.params.BrandName + '/' + this.props.params.CatName + '/' + this.props.params.ProName + '/' + this.props.params.Pid);
				} else if (this.props.params.BrandName && this.props.params.CatName && this.props.params.DType && this.props.params.ProName && this.props.params.Pid) {
					localStorage.setItem('subdeals', '/subdeals/' + this.props.params.BrandName + '/' + this.props.params.CatName + '/' + this.props.params.DType + '/' + this.props.params.ProName + '/' + this.props.params.Pid);
				}
	
				if (screen.width >= 800 && this.props.params.BrandName && this.props.params.CatName && this.props.params.ProName && this.props.params.DType && this.props.params.Pid) {
					window.location.href = "/web/subdeals/" + this.props.params.BrandName + "/" + this.props.params.CatName + "/" + this.props.params.DType + "/" + this.props.params.ProName + "/" + this.props.params.Pid;
				}
				if (localStorage.user_id && localStorage.token) {
					this.getCartCount();
				}
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				this.getDeviceId();
				var data1 = { from: 'mobile_web', uid: uid, pid: this.state.pid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getNewsearch',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							pdeals: data.products,
							totdata: data,
							mob_loading: false
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var products = this.state.pdeals.map(function (product, index) {
					return _react2.default.createElement(ProductsList, { key: index, data: product, onUpdate: function onUpdate() {
							return _this2.getCartCount();
						} });
				});
				document.title = this.state.totdata.product_name + " - Products | AquaDeals ";
				document.getElementsByTagName("META")[2].content = "Browse best deals from " + this.state.totdata.product_name + " in AquaDeals.Contact customer care for any queries on these Aqua products and order online";
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals subdeals_page' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ onClick: function onClick() {
											_reactRouter.browserHistory.goBack();
										} },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
									)
								),
								' ',
								this.state.totdata.product_name,
								' '
							),
							_react2.default.createElement(
								'a',
								{ href: '/', className: 'home_logo1' },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
							),
							_react2.default.createElement(
								'a',
								{ className: 'mob_cart_btn', href: '/mycart' },
								_react2.default.createElement('img', { alt: '', src: baseAssets + 'icons/web_icons/cart_icon.png' }),
								this.state.cart_count > 0 ? _react2.default.createElement(
									'span',
									{ className: this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count" },
									this.state.cart_count
								) : ''
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'pag_cntnt' },
						'\xA0'
					),
					this.state.mob_loading ? _react2.default.createElement(
						'div',
						{ className: 'mob_loading' },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/mob_loading.gif', alt: 'Loading' })
					) : '',
					this.state.loading_gif ? _react2.default.createElement(
						'i',
						{ className: 'loading_gif' },
						_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
					) : '',
					_react2.default.createElement(
						'section',
						{ className: 'subdeals_cnt' },
						products,
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'seed_sort dsl_srt new_dsl' },
						_react2.default.createElement(
							'ul',
							null,
							_react2.default.createElement(
								'li',
								{ style: { cursor: 'pointer' }, className: 'col-md-12 col-xs-12 col-sm-12' },
								_react2.default.createElement(
									'a',
									{ onClick: this.getSort },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + this.state.img_price, alt: 'sort' }),
									_react2.default.createElement(
										'span',
										null,
										this.state.img_data
									)
								)
							)
						)
					)
				);
			}
		}]);
	
		return SubDeals;
	}(_react.Component);
	
	exports.default = SubDeals;
	
	var ProductsList = function (_Component2) {
		_inherits(ProductsList, _Component2);
	
		function ProductsList(props) {
			_classCallCheck(this, ProductsList);
	
			var _this3 = _possibleConstructorReturn(this, (ProductsList.__proto__ || Object.getPrototypeOf(ProductsList)).call(this, props));
	
			_this3.state = {
				open: false,
				msg: '',
				shareUrl: '',
				cart_count: '',
				clearcart_status: false,
				already_added_status: false
			};
			_this3.shareFunc = _this3.ShareFunc.bind(_this3);
			_this3.addToCart = _this3.addToCart.bind(_this3);
			_this3.updateCartCount = _this3.updateCartCount.bind(_this3);
			_this3.close = _this3.close.bind(_this3);
			_this3.replaceCartItems = _this3.replaceCartItems.bind(_this3);
			_this3.addToQuickCart = _this3.addToQuickCart.bind(_this3);
			_this3.addToQuickCart_Onload = _this3.addToQuickCart_Onload.bind(_this3);
			return _this3;
		}
	
		_createClass(ProductsList, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				if (localStorage.user_id && localStorage.token && localStorage.quickbuy_onload) {
					this.addToQuickCart_Onload();
					localStorage.removeItem('quickbuy_onload');
					localStorage.removeItem('quickbuy_deal_id');
				}
			}
		}, {
			key: 'ShareFunc',
			value: function ShareFunc(evnt) {
				var _this4 = this;
	
				var data1 = { from: 'mobile_web', type: 1, did: evnt };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'createTinyurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						// console.log(data);
						this.setState({
							msg: data.msg,
							shareUrl: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
				// ReactGA.event({
				//   category: 'Feed Deals List',
				//   action: 'Clicked Share Button',
				// });
				this.setState({
					open: !this.state.open
				});
				setTimeout(function () {
					_this4.setState({ open: false });
				}, 5000);
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					clearcart_status: false,
					already_added_status: false
				});
			}
		}, {
			key: 'updateCartCount',
			value: function updateCartCount() {
				this.props.onUpdate();
			}
		}, {
			key: 'addToCart',
			value: function addToCart(deal_id) {
				if (!localStorage.user_id && !localStorage.token) {
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.user_id) {
						var user_id = localStorage.user_id;
					} else {
						user_id = 0;
					}
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', id: user_id, token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'post',
						dataType: 'json',
						url: baseUrl + 'quickBuy',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.updateCartCount();
								_reactRouter.browserHistory.push('/mycart');
							} else if (data.status === "error" && data.cart_flag === 0) {
								this.setState({
									clearcart_status: true
								});
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
							} else if (data.status === "error" && data.message === "Token mismatch") {
								localStorage.removeItem('token');
								localStorage.removeItem('user_id');
								_reactRouter.browserHistory.push('/login');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'addToQuickCart',
			value: function addToQuickCart(deal_id) {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('quickbuy_onload', '1');
					localStorage.setItem('quickbuy_deal_id', deal_id);
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.user_id) {
						var user_id = localStorage.user_id;
					} else {
						user_id = 0;
					}
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', id: user_id, token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'post',
						dataType: 'json',
						url: baseUrl + 'addToQCart',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.updateCartCount();
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
								_reactRouter.browserHistory.push('/quickcart');
							} else if (data.status === "error" && data.cart_flag === 0) {
								this.setState({
									clearcart_status: true
								});
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'addToQuickCart_Onload',
			value: function addToQuickCart_Onload() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (localStorage.quickbuy_deal_id) {
					var deal_id = localStorage.quickbuy_deal_id;
				} else {
					deal_id = 0;
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('quickbuy_onload', '1');
					localStorage.setItem('quickbuy_deal_id', deal_id);
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.user_id;
					} else {
						uid = 0;
					}
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'post',
						dataType: 'json',
						url: baseUrl + 'addToQCart',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.updateCartCount();
								_reactRouter.browserHistory.push('/quickcart');
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							} else if (data.status === "error" && data.cart_flag === 0) {
								this.setState({
									clearcart_status: true
								});
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							}
							localStorage.removeItem('quickbuy_onload');
							localStorage.removeItem('quickbuy_deal_id');
						}.bind(this),
						error: function error(err) {}
					});
				}
				localStorage.removeItem('quickbuy_onload');
				localStorage.removeItem('quickbuy_deal_id');
			}
		}, {
			key: 'replaceCartItems',
			value: function replaceCartItems(deal_id, quantity) {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (localStorage.user_id) {
					var user_id = localStorage.user_id;
				} else {
					user_id = 0;
				}
				var data1 = { from: 'mobile_web', id: user_id, token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1, quantity: quantity, pl_size: 0, salinity: 0, pickup_date: 0, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'replaceCart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								clearcart_status: false
							});
							_reactRouter.browserHistory.push('/mycart');
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var mydata = this.props.data;
				// var shareUrl = "https://aqua.deals/pdetails/"+mydata.url_dtype_name+"/"+mydata.url_cat_name+"/"+mydata.url_product_name+"/"+mydata.pro_id+"/"+mydata.id;
				// var title = "AquaDeals";
				var shareUrl = this.state.shareUrl;
				var title = "Hey! Click here " + shareUrl + " to check " + mydata.title + " from AquaDeals.";
				// var description= shareUrl;    
				return _react2.default.createElement(
					'div',
					{ className: 'list_card' },
					mydata.promo_ribbion ? _react2.default.createElement(
						'i',
						{ className: 'ribbon_img' },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + mydata.promo_ribbion, alt: '' })
					) : '',
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: "/pdetails/" + mydata.url_dtype_name + "/" + mydata.url_cat_name + "/" + mydata.url_brand_name + "/" + mydata.url_product_name + "/" + mydata.pro_id + "/" + mydata.id },
						_react2.default.createElement(
							'div',
							{ className: 'list_img' },
							_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/' + mydata.image, alt: 'AquaDeals', role: 'presentation' })
						),
						mydata.ad_guarantee_flag === '1' ? _react2.default.createElement(
							'span',
							{ className: 'pdeals_adguarantee' },
							_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: ' ' })
						) : '',
						_react2.default.createElement(
							'div',
							{ className: 'list_txt' },
							mydata.brand_name ? _react2.default.createElement(
								'h4',
								null,
								mydata.brand_name
							) : '',
							mydata.title ? _react2.default.createElement(
								'h5',
								null,
								mydata.title
							) : '',
							mydata.pricediff === "" ? _react2.default.createElement(
								'h3',
								null,
								'MRP \u20B9 ',
								mydata.mrp
							) : '',
							mydata.pricediff ? _react2.default.createElement(
								'h3',
								null,
								'aquacash discount \u20B9 ',
								mydata.pricediff
							) : '',
							mydata.over_rate >= 1 ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'str_blk' },
									_react2.default.createElement('i', { className: 'glyphicon glyphicon-star glyphicon_sub_star' }),
									mydata.over_rate,
									' '
								),
								mydata.deal_views > 0 ? _react2.default.createElement(
									'div',
									{ className: 'views_eye' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/views.png', width: '17px', role: 'presentation' }),
									' ',
									mydata.deal_views,
									' ',
									mydata.deal_views > 1 ? ' Views' : ' View'
								) : ''
							) : _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'str_blk' },
									_react2.default.createElement('i', { className: 'glyphicon glyphicon-star no_star' })
								),
								mydata.deal_views > 0 ? _react2.default.createElement(
									'div',
									{ className: 'views_eye' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/views.png', width: '17px', role: 'presentation' }),
									' ',
									mydata.deal_views,
									' ',
									mydata.deal_views > 1 ? ' Views' : ' View'
								) : ''
							)
						)
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ className: 'share_list', onClick: function onClick() {
								_this5.ShareFunc(mydata.id);
							} },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/share1.png', alt: 'share' })
					),
					_react2.default.createElement(
						'a',
						{ className: 'quick_buy_img', onClick: function onClick() {
								return _this5.addToQuickCart(mydata.id);
							} },
						_react2.default.createElement('img', { src: __webpack_require__(256), alt: ' ', width: '40' })
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_reactBootstrap.Panel,
							{ className: 'share_panel', collapsible: true, expanded: this.state.open },
							_react2.default.createElement(
								FacebookShareButton,
								{ url: shareUrl, quote: title, className: 'test_share' },
								_react2.default.createElement(FacebookIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								TwitterShareButton,
								{ url: shareUrl, quote: title, className: 'test_share' },
								_react2.default.createElement(TwitterIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								GooglePlusShareButton,
								{ url: shareUrl, className: 'test_share' },
								_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.clearcart_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#333' } },
								'You can\'t have multiple seller items in the cart. Empty existing cart & add this item ',
								mydata.title,
								'?'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'NO'
							),
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: function onClick() {
											_this5.replaceCartItems(mydata.id, mydata.min_qty);
										} },
									'YES'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.already_added_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#333' } },
								'Product already added to the cart'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'OK'
							)
						)
					)
				);
			}
		}]);
	
		return ProductsList;
	}(_react.Component);

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var My_Order_aborted = function (_Component) {
		_inherits(My_Order_aborted, _Component);
	
		function My_Order_aborted(props) {
			_classCallCheck(this, My_Order_aborted);
	
			var _this = _possibleConstructorReturn(this, (My_Order_aborted.__proto__ || Object.getPrototypeOf(My_Order_aborted)).call(this, props));
	
			_this.state = {
				status_title: 'Something went wrong'
			};
			return _this;
		}
	
		_createClass(My_Order_aborted, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					window.location.href = "/web/order_status/" + this.props.params.Type;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var status_title = 'Something went wrong';
				if (localStorage.pay_page) {
					var pay_page = localStorage.getItem('pay_page');
				} else {
					pay_page = '/';
				}
				if (this.props.params.Type === 'aborted') {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Transaction Aborted'
						),
						_react2.default.createElement(
							'a',
							{ className: 'mob_link_btn', href: pay_page },
							'Try Again'
						)
					);
				} else if (this.props.params.Type === 'failure') {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Transaction Failed'
						),
						_react2.default.createElement(
							'a',
							{ className: 'mob_link_btn', href: pay_page },
							'Try Again'
						)
					);
				} else if (this.props.params.Type === 'invalid') {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Invalid Transaction'
						),
						_react2.default.createElement(
							'a',
							{ className: 'mob_link_btn', href: pay_page },
							'Try Again'
						)
					);
				} else if (this.props.params.Type === 'serverDown') {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Server Down'
						),
						_react2.default.createElement(
							'a',
							{ className: 'mob_link_btn', href: pay_page },
							'Try Again'
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals my_order_aborted_page' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: '/myorders' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
									)
								),
								'Confirmation'
							),
							_react2.default.createElement(
								'a',
								{ href: '/', title: 'Home', className: 'home_logo1' },
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/home1.png', alt: 'Home' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'pag_cntnt' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'abort_content' },
						status_title ? status_title : _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'h4',
								null,
								'Something went wrong !'
							),
							_react2.default.createElement(
								'a',
								{ className: 'mob_link_btn', href: pay_page },
								'Try Again'
							)
						)
					)
				);
			}
		}]);
	
		return My_Order_aborted;
	}(_react.Component);
	
	exports.default = My_Order_aborted;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactStars = __webpack_require__(33);
	
	var _reactStars2 = _interopRequireDefault(_reactStars);
	
	var _custom_functions = __webpack_require__(69);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import StarRating from 'react-bootstrap-star-rating';
	
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets//';
	
	var My_Orders = function (_Component) {
		_inherits(My_Orders, _Component);
	
		function My_Orders(props) {
			_classCallCheck(this, My_Orders);
	
			var _this = _possibleConstructorReturn(this, (My_Orders.__proto__ || Object.getPrototypeOf(My_Orders)).call(this, props));
	
			_this.state = {
				cart_count: 0,
				activeTab: 1,
				bookings: [],
				cancel_bookings: [],
				bookings_count: '',
				cancel_count: 0,
				orders_list_status: false,
				book_type: '',
				// payment variables starts here
				pre_payment_id: '',
				order_id: '',
				paid_amt: '',
				username: '',
				address: '',
				city: '',
				state: '',
				pincode: '',
				mobile: '',
				email: '',
				cancel_modal_status: false,
				cancel_reasons: [],
				edit_input_status: false,
				edit_input: '',
				bid: '',
				booking_type: '',
				selected_reason: '',
				cancel_success_status: false,
				cancel_success_msg: '',
				test_orders: [],
				gateway_mode: '',
				pageId: '.mob_myorders_page'
			};
			_this.getCartCount = _this.getCartCount.bind(_this);
			_this.handleTabsSelect = _this.handleTabsSelect.bind(_this);
			_this.getOrdersList = _this.getOrdersList.bind(_this);
			_this.repeatOrder = _this.repeatOrder.bind(_this);
			_this.getBookingsFilterbyType = _this.getBookingsFilterbyType.bind(_this);
			_this.getBookingsFilterbyStatus = _this.getBookingsFilterbyStatus.bind(_this);
			_this.payNow = _this.payNow.bind(_this);
			_this.ccAvenue = _this.ccAvenue.bind(_this);
			_this.getCancelDetails = _this.getCancelDetails.bind(_this);
			_this.handleCancel_Submit = _this.handleCancel_Submit.bind(_this);
			_this.openCancelModal = _this.openCancelModal.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.selectedReason = _this.selectedReason.bind(_this);
			_this.update_other_reason = _this.update_other_reason.bind(_this);
	
			_this.ratingChanged = _this.ratingChanged.bind(_this);
			_this.openRatingsPage = _this.openRatingsPage.bind(_this);
	
			_this.getCancelBookingsFilter = _this.getCancelBookingsFilter.bind(_this);
			return _this;
		}
	
		_createClass(My_Orders, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					window.location.href = "/web/myorders";
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('myorders', '/myorders');
					_reactRouter.browserHistory.push('/login');
				}
				if (localStorage.user_id && localStorage.token) {
					this.getCartCount();
					this.getOrdersList();
				}
				localStorage.removeItem('book_date');
				localStorage.removeItem('seller');
				localStorage.removeItem('vid');
				localStorage.removeItem('order_details');
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					cancel_modal_status: false,
					cancel_success_status: false
				});
			}
		}, {
			key: 'openRatingsPage',
			value: function openRatingsPage(bid, booking_type, give_rate, seller, book_date, vid, product_id) {
				// Seed -> booking_type = 0;
				// Product -> booking_type = 1;
				localStorage.setItem('book_date', book_date);
				localStorage.setItem('seller', seller);
				localStorage.setItem('vid', vid);
				localStorage.setItem('product_id', product_id);
	
				if (booking_type === 1 && give_rate === 'no') {
					_reactRouter.browserHistory.push('/viewrating/product/' + bid);
				} else if (booking_type === 0 && give_rate === 'no') {
					_reactRouter.browserHistory.push('/viewrating/' + bid);
				} else if (booking_type === 1 && give_rate === 'yes') {
					_reactRouter.browserHistory.push('/giverating/product/' + bid);
				} else if (booking_type === 0 && give_rate === 'yes') {
					_reactRouter.browserHistory.push('/giverating/' + bid);
				}
			}
		}, {
			key: 'getBookingsFilterbyStatus',
			value: function getBookingsFilterbyStatus(status) {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, status: status, type: '' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getBookings',
					success: function (data) {
						this.setState({
							bookings: data.bookings,
							cancel_bookings: data.cancel_bookings,
							bookings_count: data.bookings_count,
							cancel_count: data.cancel_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getBookingsFilterbyType',
			value: function getBookingsFilterbyType(type) {
				var type = type.toString();
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, status: '', type: type };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getBookings',
					success: function (data) {
						this.setState({
							bookings: data.bookings,
							cancel_bookings: data.cancel_bookings,
							bookings_count: data.bookings_count,
							cancel_count: data.cancel_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getCancelBookingsFilter',
			value: function getCancelBookingsFilter(type) {
				var type = type.toString();
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, status: '', type: type };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getBookings',
					success: function (data) {
						this.setState({
							bookings: data.bookings,
							cancel_bookings: data.cancel_bookings,
							bookings_count: data.bookings_count,
							cancel_count: data.cancel_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'repeatOrder',
			value: function repeatOrder(booking_id) {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, booking_id: booking_id, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'recap_cart',
					success: function success(data) {
						if (data.status === "success") {
							_reactRouter.browserHistory.push('/mycart');
							// this.getOrdersList();
						}
					},
					error: function error(err) {}
				});
			}
		}, {
			key: 'update_other_reason',
			value: function update_other_reason(event) {
				this.setState({
					edit_input: event.target.value
				});
			}
		}, {
			key: 'getCartCount',
			value: function getCartCount() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							cart_count: data.cart_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'handleTabsSelect',
			value: function handleTabsSelect(key) {
				this.setState({
					activeTab: key
				});
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var that = this;
				setTimeout(function () {
					that.enableOrdersList();
				}, 3000);
			}
		}, {
			key: 'enableOrdersList',
			value: function enableOrdersList() {
				// this.getCart();
				this.setState({
					orders_list_status: true
				});
			}
		}, {
			key: 'getOrdersList',
			value: function getOrdersList() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, status: '', type: '' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getBookings',
					success: function (data) {
						this.setState({
							bookings: data.bookings,
							cancel_bookings: data.cancel_bookings,
							bookings_count: data.bookings_count,
							cancel_count: data.cancel_count,
							gateway_mode: data.gateway_mode
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'ccAvenue',
			value: function ccAvenue() {
				var basePayUrl = 'https://aqua.deals/paymentGateWay/paymentRequestHandler.php';
				// var basePayUrl='http://203.193.173.125/paymentGateWay/paymentRequestHandler.php';
	
				var username = this.state.username;
				var address = this.state.address;
				var city = this.state.city;
				var state = this.state.state;
				var pincode = this.state.pincode;
				var mobile = this.state.mobile;
				var email = this.state.email;
				var rem_amt = 'rem_amt';
				var deal_type = this.state.book_type;
	
				var data1 = { access_code: 'AVIJ67DJ41BD20JIDB', merchant_id: '103328', order_id: this.state.order_id, merchant_param1: this.state.pre_payment_id, merchant_param2: deal_type, merchant_param3: rem_amt, merchant_param4: 'mobile_web', amount: this.state.paid_amt, currency: 'INR', cancel_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', redirect_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', billing_name: username, billing_address: address, billing_city: city, billing_state: state, billing_zip: pincode, billing_tel: mobile, billing_country: 'India', billing_email: email };
				// var data1={access_code:'AVJZ66DG16BM17ZJMB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:rem_amt,merchant_param4:'mobile_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',redirect_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
	
				_jquery2.default.ajax({
					method: 'POST',
					data: data1,
					url: basePayUrl,
					success: function success(data) {
						(0, _jquery2.default)('.mob_myorders_page').html(data);
					},
					error: function error(err) {}
				});
			}
		}, {
			key: 'payNow',
			value: function payNow(book_id, paid_amt, pay_type, book_type, u_name, u_address, u_phone, u_zip, u_city, u_state, u_email) {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, book_id: book_id, paid_amt: paid_amt, pay_type: pay_type, book_type: book_type, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'rem_amt_temp_process',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								pre_payment_id: data.pre_payment_id,
								order_id: data.order_id,
								paid_amt: data.paid_amt,
								book_type: book_type,
	
								username: u_name,
								address: u_address,
								city: u_city,
								state: u_state,
								pincode: u_zip,
								mobile: u_phone,
								email: u_email
							});
						}
						var payment_params = { from: 'desktop_web',
							uid: localStorage.getItem('user_id'),
							pre_payment_id: data.pre_payment_id,
							order_id: data.order_id,
							deal_type: this.state.book_type,
							cart_ids: '',
							paid_amt: data.paid_amt,
							username: this.state.username,
							address: this.state.address,
							city: this.state.city,
							state: this.state.state,
							pincode: this.state.pincode,
							mobile: this.state.mobile,
							country: 'India',
							email: this.state.email,
							cart_add_id: 'rem_amt',
							pageId: this.state.pageId,
							rzp_key: this.props.rzp_keys.key_id };
						if (this.state.gateway_mode == 2) {
							(0, _custom_functions.razorpayForm)(payment_params);
						} else {
							(0, _custom_functions.ccAvenue)(payment_params);
						}
	
						//this.ccAvenue();
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
	
				});
			}
		}, {
			key: 'getCancelDetails',
			value: function getCancelDetails() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token };
				var data2 = JSON.stringify(data1);
	
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'cancel_reasons',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								cancel_reasons: data.reasons
							});
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'handleCancel_Submit',
			value: function handleCancel_Submit(event) {
				event.preventDefault();
				var bid = this.state.bid;
				var booking_type = this.state.booking_type;
				var selected_reason = this.state.selected_reason;
				if (this.state.selected_reason === 9) {
					selected_reason = this.state.edit_input;
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				if (booking_type === 1) {
					var action_url = 'product_booking_cancel';
					var data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, reason: selected_reason, book_id: bid, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
				} else {
					action_url = 'booking_cancel';
					data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, book_id: bid, reason: selected_reason, source: source, campaign: campaign, url_id: url_id };
					data2 = JSON.stringify(data1);
				}
	
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + action_url,
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								cancel_modal_status: false,
								cancel_success_status: true,
								cancel_success_msg: data.message
							});
							// alert(data.message);
							// window.location.reload();
							this.getOrdersList();
						} else {
							this.setState({
								cancel_modal_status: false,
								cancel_success_status: true,
								cancel_success_msg: data.message
							});
							this.getOrdersList();
							// alert(data.message);
							// window.location.reload();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'openCancelModal',
			value: function openCancelModal(bid, booking_type) {
				this.setState({
					cancel_modal_status: true,
					bid: bid,
					booking_type: booking_type
				});
			}
		}, {
			key: 'selectedReason',
			value: function selectedReason(id, flag) {
				if (flag === '1') {
					this.setState({
						edit_input_status: true,
						selected_reason: id
					});
				} else {
					this.setState({
						edit_input_status: false,
						selected_reason: id
					});
				}
			}
		}, {
			key: 'ratingChanged',
			value: function ratingChanged(newRating) {
				console.log(newRating);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				document.title = "My Orders | AquaDeals";
				// $(window).scrollTop(0);
				(0, _jquery2.default)('body').css('background', '#f1f1f2');
				var orders_tabs = '';
				if (this.state.bookings_count === 0) {
					var bookings = _react2.default.createElement(
						'div',
						{ className: 'no_ordrs_blk', style: { marginTop: '150px', textAlign: 'center' } },
						_react2.default.createElement(
							'p',
							null,
							'No orders were made'
						),
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: '/' },
							'EXPLORE BEST DEALS'
						)
					);
				} else {
					bookings = this.state.bookings.map(function (order, index) {
						var _this2 = this;
	
						var status = '';
						var rating = '';
						var repeat = '';
						// paynow and cacel blk start here
						var paynow_cancel = '';
						if (order.rem_amt_flag === '1' || order.rem_amt_flag === '2') {
							paynow_cancel = '';
						} else if (order.rem_amt_flag === '0' && order.cancel_flag === 1) {
							var pay_type = 1;
	
							var u_name = order.shipping_details ? order.shipping_details.name : '';
							var u_address = order.shipping_details ? order.shipping_details.address : '';
							var u_phone = order.shipping_details ? order.shipping_details.phone : '';
							var u_zip = order.shipping_details ? order.shipping_details.zip : '';
							var u_city = order.shipping_details ? order.shipping_details.city : '';
							var u_state = order.shipping_details ? order.shipping_details.state : '';
							//var u_default_flag = order.shipping_details ? order.shipping_details.default_flag : '';
							//var u_behalf_of = order.shipping_details ? order.shipping_details.behalf_of : '';
							//var u_status = order.shipping_details ? order.shipping_details.status : '';
							var u_email = order.shipping_details ? order.shipping_details.email : '';
	
							paynow_cancel = _react2.default.createElement(
								'div',
								{ className: 'pay_cancel_blk' },
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'span',
										{ onClick: function onClick() {
												_this2.payNow(order.booking_id, order.order_amount, pay_type, order.booking_type, u_name, u_address, u_phone, u_zip, u_city, u_state, u_email);
											} },
										'PAY NOW '
									),
									_react2.default.createElement(
										'span',
										{ style: { float: 'right', cursor: 'pointer' }, onClick: function onClick() {
												_this2.openCancelModal(order.bid, order.booking_type);
											} },
										'CANCEL'
									)
								)
							);
						} else if (order.rem_amt_flag === '0' && order.cancel_flag === 0) {
							pay_type = 1;
							u_name = order.shipping_details ? order.shipping_details.name : '';
							u_address = order.shipping_details ? order.shipping_details.address : '';
							u_phone = order.shipping_details ? order.shipping_details.phone : '';
							u_zip = order.shipping_details ? order.shipping_details.zip : '';
							u_city = order.shipping_details ? order.shipping_details.city : '';
							u_state = order.shipping_details ? order.shipping_details.state : '';
							//u_default_flag = order.shipping_details ? order.shipping_details.default_flag : '';
							//u_behalf_of = order.shipping_details ? order.shipping_details.behalf_of : '';
							//u_status = order.shipping_details ? order.shipping_details.status : '';
							u_email = order.shipping_details ? order.shipping_details.email : '';
							paynow_cancel = _react2.default.createElement(
								'div',
								{ className: 'pay_blk', style: { marginTop: '10px', paddingTop: '5px', borderTop: '1px solid #f1f1f2' } },
								_react2.default.createElement(
									'p',
									{ onClick: function onClick() {
											_this2.payNow(order.booking_id, order.order_amount, order.status, order.booking_type, u_name, u_address, u_phone, u_zip, u_city, u_state, u_email);
										} },
									_react2.default.createElement(
										'span',
										null,
										'PAY NOW'
									)
								)
							);
						}
						// paynow and cacel blk ENDS here
						// cancel blk starts here
						var cancel = '';
						if (order.rem_amt_flag === '1' && order.cancel_flag === 1) {
							cancel = _react2.default.createElement(
								'div',
								{ className: 'cancel_blk', onClick: function onClick() {
										_this2.openCancelModal(order.bid, order.booking_type);
									}, style: { textAlign: 'center', color: '#ff742a', cursor: 'pointer' } },
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'span',
										null,
										'CANCEL'
									)
								)
							);
						}
						// cancel blk ends here
						// rating status with rating and repeat status
						if (order.status === '2' && order.rate === 1) {
							var give_rate = 'no';
							rating = _react2.default.createElement(
								'div',
								{ className: 'order_rate_blk' },
								_react2.default.createElement(
									'p',
									null,
									'View Rating'
								),
								_react2.default.createElement(
									'div',
									{ className: 'rate_blk', onClick: function onClick() {
											_this2.openRatingsPage(order.bid, order.booking_type, give_rate, order.seller, order.book_date, order.vid, order.product_id);
										} },
									_react2.default.createElement(_reactStars2.default, {
										count: 5,
										onChange: this.ratingChanged,
										className: 'rate_blk_item',
										size: 50,
										value: order.rating,
										edit: false,
										color1: '#F3F3F3',
										color2: '#FABB9A' })
								)
							);
						} else {
							rating = '';
						}
						if (order.status === '6' && order.rate === 1) {
							give_rate = 'yes';
							rating = _react2.default.createElement(
								'div',
								{ className: 'order_rate_blk' },
								_react2.default.createElement(
									'p',
									{ className: 'rate_desc' },
									'Rate the order based on your experience'
								),
								_react2.default.createElement(
									'div',
									{ className: 'rate_blk', onClick: function onClick() {
											_this2.openRatingsPage(order.bid, order.booking_type, give_rate, order.seller, order.book_date, order.vid, order.product_id);
										} },
									_react2.default.createElement(_reactStars2.default, {
										count: 5,
										onChange: this.ratingChanged,
										className: 'rate_blk_item',
										size: 50,
										value: order.rating,
										edit: false,
										color1: '#F3F3F3',
										color2: '#FABB9A' })
								)
							);
							repeat = _react2.default.createElement(
								'div',
								{ style: { textAlign: 'center', color: '#ff742a', cursor: 'pointer', marginTop: '10px' }, onClick: function onClick() {
										_this2.repeatOrder(order.booking_id);
									} },
								'REPEAT'
							);
						}
	
						if (order.status === '2' && order.rate === 2) {
							repeat = _react2.default.createElement(
								'div',
								{ style: { textAlign: 'center', color: '#ff742a', cursor: 'pointer', marginTop: '10px' }, onClick: function onClick() {
										_this2.repeatOrder(order.booking_id);
									} },
								'REPEAT'
							);
							give_rate = 'no';
							rating = _react2.default.createElement(
								'div',
								{ className: 'order_rate_blk' },
								_react2.default.createElement(
									'p',
									null,
									'View Rating'
								),
								_react2.default.createElement(
									'div',
									{ className: 'rate_blk', onClick: function onClick() {
											_this2.openRatingsPage(order.bid, order.booking_type, give_rate, order.seller, order.book_date, order.vid, order.product_id);
										} },
									_react2.default.createElement(_reactStars2.default, {
										count: 5,
										onChange: this.ratingChanged,
										className: 'rate_blk_item',
										size: 50,
										edit: false,
										color1: '#F3F3F3',
										value: order.rating,
										color2: '#FABB9A' })
								)
							);
							// set rating
						}
						if (order.status === '6' && order.rate === 2) {
							give_rate = 'no';
							rating = _react2.default.createElement(
								'div',
								{ className: 'order_rate_blk' },
								_react2.default.createElement(
									'p',
									null,
									'View Rating'
								),
								_react2.default.createElement(
									'div',
									{ className: 'rate_blk', onClick: function onClick() {
											_this2.openRatingsPage(order.bid, order.booking_type, give_rate, order.seller, order.book_date, order.vid, order.product_id);
										} },
									_react2.default.createElement(_reactStars2.default, {
										className: 'rate_blk_item',
										count: 5,
										onChange: this.ratingChanged,
										size: 50,
										edit: false,
										color1: '#F3F3F3',
										value: order.rating,
										color2: '#FABB9A' })
								)
							);
							//set Rating;
							repeat = _react2.default.createElement(
								'div',
								{ style: { textAlign: 'center', color: '#ff742a', cursor: 'pointer', marginTop: '10px' }, onClick: function onClick() {
										_this2.repeatOrder(order.booking_id);
									} },
								'REPEAT'
							);
						}
	
						// order status like placed,shipping,delivered starts here
						if (order.status === '0' || order.status === '4' || order.status === '7') {
							status = 'Placed';
						} else if (order.status === '1') {
							status = 'Processing';
						} else if (order.status === '3') {
							status = 'Cancelled';
						} else if (order.status === '5') {
							status = 'Shipping';
						} else if (order.status === '6') {
							status = 'Delivered';
						}
						// order status like placed,shipping,delivered ends here
						return _react2.default.createElement(
							'div',
							{ className: 'order_item' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/order_details/' + order.booking_type + '/' + order.bid, className: 'my_order_link' },
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'span',
										null,
										'Order No ',
										order.booking_id
									),
									_react2.default.createElement(
										'span',
										{ className: 'ordr_right' },
										'\u20B9',
										order.order_amount_online
									)
								),
								_react2.default.createElement(
									'p',
									{ className: 'order_status' },
									_react2.default.createElement(
										'span',
										{ style: { color: '#666' } },
										order.book_date
									),
									_react2.default.createElement(
										'span',
										{ className: 'ordr_right ordr_status' },
										status
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'order_list_items' },
									order.items.length > 0 ? order.items.map(function (item, index) {
										return _react2.default.createElement(
											'div',
											{ className: 'col-xs-12 col-md-12 order_subitems' },
											_react2.default.createElement(
												'div',
												{ className: 'col-xs-3 col-md-3', style: { padding: '0px' } },
												_react2.default.createElement(
													'i',
													{ className: 'order_icon' },
													_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/' + item.image, alt: '' })
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-xs-9 col-md-9', style: { padding: '0px' } },
												_react2.default.createElement(
													'p',
													null,
													item.title
												),
												_react2.default.createElement(
													'p',
													{ className: 'order_qty' },
													'Quantity ',
													item.quantity
												)
											)
										);
									}) : ''
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-12' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/product_imgs/' + order.progress_bar, alt: '' })
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'order_rating_blk' },
								rating
							),
							_react2.default.createElement(
								'div',
								{ className: 'order_actions_blk' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-12 col-sm-12 col-xs-12' },
									paynow_cancel,
									cancel,
									repeat
								)
							)
						);
					}.bind(this));
				}
				if (this.state.cancel_count === 0) {
					var cancel_bookings = _react2.default.createElement(
						'div',
						{ className: 'no_ordrs_blk', style: { marginTop: '150px', textAlign: 'center' } },
						_react2.default.createElement(
							'p',
							null,
							'No Orders were made'
						),
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: '/' },
							'EXPLORE BEST DEALS'
						)
					);
				} else {
					cancel_bookings = this.state.cancel_bookings.map(function (order, index) {
						var status = '';
						if (order.status === '3') {
							status = 'Cancelled';
						}
						return _react2.default.createElement(
							'div',
							{ className: 'order_item' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/order_details/' + order.booking_type + '/' + order.bid, className: 'my_order_link' },
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'span',
										null,
										'Order No ',
										order.booking_id
									),
									_react2.default.createElement(
										'span',
										{ className: 'ordr_right' },
										'\u20B9',
										order.order_amount
									)
								),
								_react2.default.createElement(
									'p',
									{ className: 'order_status' },
									_react2.default.createElement(
										'span',
										{ style: { color: '#666' } },
										order.book_date
									),
									_react2.default.createElement(
										'span',
										{ className: 'ordr_right', style: { color: 'red' } },
										status
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'order_list_items' },
									order.items.length > 0 ? order.items.map(function (item, index) {
										return _react2.default.createElement(
											'div',
											{ className: 'col-xs-12 col-md-12 order_subitems' },
											_react2.default.createElement(
												'div',
												{ className: 'col-xs-3 col-md-3', style: { padding: '0px' } },
												_react2.default.createElement(
													'i',
													{ className: 'order_icon' },
													_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/' + item.image, alt: '' })
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-xs-9 col-md-9', style: { padding: '0px' } },
												_react2.default.createElement(
													'p',
													null,
													item.title
												),
												_react2.default.createElement(
													'p',
													{ className: 'order_qty' },
													'Quantity ',
													item.quantity
												)
											)
										);
									}) : ''
								)
							)
						);
					});
				}
	
				orders_tabs = _react2.default.createElement(
					_reactBootstrap.Tabs,
					{ activeKey: this.state.activeTab, tabWidth: 2, className: 'my_ordr_tabs', id: 'my_orders_tabs', onSelect: this.handleTabsSelect },
					_react2.default.createElement(
						_reactBootstrap.Tab,
						{ eventKey: 1, tabClassName: 'mob_orders_tab', title: "MY ORDERS : " + this.state.bookings_count },
						_react2.default.createElement(
							'div',
							null,
							bookings
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Tab,
						{ eventKey: 2, tabClassName: 'mob_orders_tab', title: "CANCELLED : " + this.state.cancel_count },
						_react2.default.createElement(
							'div',
							null,
							cancel_bookings
						)
					)
				);
	
				var cancel_reasons = this.state.cancel_reasons.map(function (data, index) {
					var _this3 = this;
	
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement('input', { type: 'radio', id: data.id, name: 'reason', className: 'cancel_radio', onClick: function onClick() {
								_this3.selectedReason(data.id, data.flag);
							} }),
						_react2.default.createElement(
							'span',
							null,
							data.reason
						),
						data.flag === '1' ? _react2.default.createElement(
							'div',
							{ className: 'other_reason_blk' },
							this.state.edit_input_status ? _react2.default.createElement('input', { type: 'text', name: 'other_reason', ref: 'other_reason', id: 'other_reason', placeholder: 'Enter any reason', value: this.state.edit_input, onChange: this.update_other_reason }) : ''
						) : ''
					);
				}.bind(this));
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals mob_myorders_page' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: '/' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png', width: '16px', alt: '' })
									)
								),
								'My Orders'
							),
							_react2.default.createElement(
								'a',
								{ href: '/', title: 'Home', className: 'home_logo1' },
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/home1.png', alt: 'Home' })
							),
							_react2.default.createElement(
								'a',
								{ className: 'mob_cart_btn', href: '/mycart' },
								_react2.default.createElement('img', { alt: '', src: 'https://aquadeals.in/admin/assets/icons/web_icons/cart_icon.png' }),
								this.state.cart_count > 0 ? _react2.default.createElement(
									'span',
									{ className: this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count" },
									this.state.cart_count
								) : ''
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'pag_cntnt3' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'orders_content' },
						orders_tabs
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ onEntered: function onEntered() {
								_this4.getCancelDetails();
							}, className: '', show: this.state.cancel_modal_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ className: 'modal_offer_header', closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ className: 'm_title', style: { textAlign: 'center', color: '#fff' } },
								'Order Cancellation'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'p',
									null,
									'Do you want to cancel this Order?'
								),
								_react2.default.createElement(
									'form',
									{ className: 'cancel_reasons_form', onSubmit: this.handleCancel_Submit },
									_react2.default.createElement(
										'div',
										{ className: '' },
										cancel_reasons
									),
									_react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'div',
											{ className: 'modal-footer' },
											_react2.default.createElement(
												'a',
												{ className: 'cancel_no_btn', onClick: this.close },
												'No'
											),
											_react2.default.createElement(
												'button',
												{ type: 'submit', className: 'cancel_yes_btn' },
												'Yes'
											)
										)
									)
								)
							)
						)
					),
					this.state.activeTab === 1 ? _react2.default.createElement(
						'section',
						{ className: 'seed_sort dsl_srt' },
						_react2.default.createElement(
							'ul',
							null,
							_react2.default.createElement(
								'li',
								{ className: 'col-md-6 col-xs-6 col-sm-6 ' },
								_react2.default.createElement(
									_reactBootstrap.ButtonToolbar,
									null,
									_react2.default.createElement(
										_reactBootstrap.DropdownButton,
										{ className: 'order_filter_1', noCaret: true, title: 'By Order Status', dropup: true },
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ header: true },
											'By Order Status'
										),
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ className: 'seed_list1', onClick: function onClick() {
													return _this4.getBookingsFilterbyStatus('');
												} },
											'All'
										),
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ className: 'seed_list1', eventKey: 0, onClick: function onClick() {
													return _this4.getBookingsFilterbyStatus(0);
												} },
											'Placed'
										),
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ className: 'seed_list1', eventKey: 5, onClick: function onClick() {
													return _this4.getBookingsFilterbyStatus(5);
												} },
											'Shipping'
										),
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ className: 'seed_list1', eventKey: 6, onClick: function onClick() {
													return _this4.getBookingsFilterbyStatus(6);
												} },
											'Delivered'
										)
									)
								)
							),
							_react2.default.createElement(
								'li',
								{ className: 'col-md-6 col-xs-6 col-sm-6 coast_list1' },
								_react2.default.createElement(
									_reactBootstrap.ButtonToolbar,
									null,
									_react2.default.createElement(
										_reactBootstrap.DropdownButton,
										{ className: 'order_filter_2', noCaret: true, onClick: this.getBrands, title: 'By Type', dropup: true },
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ header: true },
											'By Type '
										),
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ className: 'seed_list1', eventKey: '', onClick: function onClick() {
													return _this4.getBookingsFilterbyType('');
												} },
											'All'
										),
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ className: 'seed_list1', eventKey: 0, onClick: function onClick() {
													return _this4.getBookingsFilterbyType(0);
												} },
											'Seed'
										),
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ className: 'seed_list1', eventKey: 1, onClick: function onClick() {
													return _this4.getBookingsFilterbyType(1);
												} },
											'Product'
										)
									)
								)
							)
						)
					) : _react2.default.createElement(
						'section',
						{ className: 'seed_sort dsl_srt' },
						_react2.default.createElement(
							'ul',
							null,
							_react2.default.createElement(
								'li',
								{ className: 'col-md-12 col-xs-12 col-sm-12 coast_list1' },
								_react2.default.createElement(
									_reactBootstrap.ButtonToolbar,
									null,
									_react2.default.createElement(
										_reactBootstrap.DropdownButton,
										{ className: 'order_filter_2', noCaret: true, onClick: this.getBrands, title: 'By Type', dropup: true },
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ header: true },
											'By Type '
										),
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ className: 'seed_list1', eventKey: '', onClick: function onClick() {
													return _this4.getCancelBookingsFilter('');
												} },
											'ALL'
										),
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ className: 'seed_list1', eventKey: 0, onClick: function onClick() {
													return _this4.getCancelBookingsFilter(0);
												} },
											'Seed'
										),
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ className: 'seed_list1', eventKey: 1, onClick: function onClick() {
													return _this4.getCancelBookingsFilter(1);
												} },
											'Product'
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'showModal', show: this.state.cancel_success_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#666', textAlign: 'center' } },
								this.state.cancel_success_msg
							)
						)
					)
				);
			}
		}]);
	
		return My_Orders;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			rzp_keys: state.posts.rzp_keys
		};
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(My_Orders);

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _NotFound = __webpack_require__(84);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _custom_functions = __webpack_require__(69);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets//';
	
	var Order_Details = function (_Component) {
		_inherits(Order_Details, _Component);
	
		function Order_Details(props) {
			_classCallCheck(this, Order_Details);
	
			var _this = _possibleConstructorReturn(this, (Order_Details.__proto__ || Object.getPrototypeOf(Order_Details)).call(this, props));
	
			_this.state = {};
			_this.state = {
				total_data: [],
				details: [],
				shipping_address: [],
	
				items: [],
				aqua_cash: '',
				aqua_cash1: '',
				coupons_amt: '',
				coupons_amt1: '',
				seller_discount: '',
				seller_discount1: '',
				promo_manf_value: '',
				promo_manf_value1: '',
				promo_hatch_value: '',
				promo_hatch_value1: '',
				applied_coupons: [],
				applied_coupons1: '',
				payment_details: [],
				payment_log: [],
				shipment_log: [],
				ship_dlvr_blck: [],
				details_status: false,
				page_error_status: false,
				page_loading: false,
	
				pay_now_btn: '',
				other_amount_btn: '',
				famount_pay_manufacturer: '',
	
				other_amount_btn_status: false,
				err_qty_status: false,
				err_qty_msg: '',
				min_val: '',
				max_val: '',
				book_id: '',
				applied_cpns_amt: '',
				confirm_modal: false,
				famount_pay_hatchery: '',
	
				edit_input_status: false,
				edit_input: '',
				cancel_modal_status: false,
				cancel_reasons: [],
				selected_reason: '',
	
				rate_flag: '',
				shipping_details: '',
				confirm_btn_show: '',
				transport_mode: '',
	
				cancel_time: '',
				cancel_reason: '',
				cancel_by: '',
	
				cancel_success_status: false,
				cancel_success_msg: '',
	
				// shipping payment start 
				ship_cc_pay: '',
				ship_pre_payment_id: '',
				ship_order_id: '',
				ship_paid_amt: '',
				ship_book_type: '',
	
				ship_username: '',
				ship_address: '',
				ship_city: '',
				ship_state: '',
				ship_pincode: '',
				ship_mobile: '',
				ship_email: '',
				// shipping payment ends 
				pageId: '.mob_order_details_page'
	
			};
			_this.getOrderDetails = _this.getOrderDetails.bind(_this);
			_this.enableOtherAmount = _this.enableOtherAmount.bind(_this);
			_this.validateOtherAmount = _this.validateOtherAmount.bind(_this);
			_this.payNow = _this.payNow.bind(_this);
			_this.ccAvenue = _this.ccAvenue.bind(_this);
			_this.payOtherAmount = _this.payOtherAmount.bind(_this);
			_this.close = _this.close.bind(_this);
	
			_this.openCancelModal = _this.openCancelModal.bind(_this);
			_this.getCancelDetails = _this.getCancelDetails.bind(_this);
			_this.handleCancel_Submit = _this.handleCancel_Submit.bind(_this);
			_this.selectedReason = _this.selectedReason.bind(_this);
			_this.update_other_reason = _this.update_other_reason.bind(_this);
			_this.shippingPayNow = _this.shippingPayNow.bind(_this);
			_this.shipping_ccAvenue = _this.shipping_ccAvenue.bind(_this);
			return _this;
		}
	
		_createClass(Order_Details, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.props.get_rzp_keys("mobile_web");
				if (screen.width >= 800) {
					window.location.href = "/web/order_details/" + this.props.params.OrderType + '/' + this.props.params.Oid;
				}
				if (!localStorage.user_id /*&& !localStorage.token*/) {
						localStorage.setItem('order_details', '/order_details/' + this.props.params.OrderType + '/' + this.props.params.Oid);
						_reactRouter.browserHistory.push('/login');
					} else {
					this.getOrderDetails();
				}
	
				localStorage.removeItem('myorders');
			}
		}, {
			key: 'shippingPayNow',
			value: function shippingPayNow() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, bid: this.props.params.Oid, type: this.props.params.OrderType, details_flag: 1, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'ship_payment_temp_process',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								ship_pre_payment_id: data.pre_payment_id,
								ship_order_id: data.order_id,
								ship_paid_amt: data.paid_amt,
								ship_book_type: data.book_type,
	
								ship_username: data.shipaddress[0].name,
								ship_address: data.shipaddress[0].address,
								ship_city: data.shipaddress[0].city,
								ship_state: data.shipaddress[0].state,
								ship_pincode: data.shipaddress[0].zip,
								ship_mobile: data.shipaddress[0].phone,
								ship_email: data.shipaddress[0].email
							});
							//this.shipping_ccAvenue();
	
							var payment_params = { from: 'desktop_web',
								uid: localStorage.getItem('user_id'),
								pre_payment_id: data.pre_payment_id,
								order_id: data.order_id,
								deal_type: this.state.ship_book_type,
								cart_ids: data.cart_ids,
								paid_amt: data.paid_amt,
								username: this.state.ship_username,
								address: this.state.ship_address,
								city: this.state.ship_city,
								state: this.state.ship_state,
								pincode: this.state.ship_pincode,
								mobile: this.state.ship_mobile,
								country: 'India',
								email: this.state.ship_email,
								cart_add_id: 'shipping_amt',
								pageId: this.state.pageId,
								rzp_key: this.props.rzp_keys.key_id };
							if (this.state.gateway_mode == 2) {
								(0, _custom_functions.razorpayForm)(payment_params);
								this.setState({
									page_loading: false
								});
							} else {
								(0, _custom_functions.ccAvenue)(payment_params);
							}
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
	
				});
			}
		}, {
			key: 'shipping_ccAvenue',
			value: function shipping_ccAvenue() {
				var username = this.state.ship_username;
				var address = this.state.ship_address;
				var city = this.state.ship_city;
				var state = this.state.ship_state;
				var pincode = this.state.ship_pincode;
				var mobile = this.state.ship_mobile;
				var email = this.state.ship_email;
				var shipping_amt = 'shipping_amt';
				var deal_type = this.state.ship_book_type;
	
				var basePayUrl = 'https://aqua.deals/paymentGateWay/paymentRequestHandler.php';
				// var basePayUrl='http://203.193.173.125/paymentGateWay/paymentRequestHandler.php';
	
				var data1 = { access_code: 'AVIJ67DJ41BD20JIDB', merchant_id: '103328', order_id: this.state.ship_order_id, merchant_param1: this.state.pre_payment_id, merchant_param2: deal_type, merchant_param3: shipping_amt, merchant_param4: 'mobile_web', amount: this.state.ship_paid_amt, currency: 'INR', cancel_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', redirect_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', billing_name: username, billing_address: address, billing_city: city, billing_state: state, billing_zip: pincode, billing_tel: mobile, billing_country: 'India', billing_email: email };
				// var data1={access_code:'AVJZ66DG16BM17ZJMB',merchant_id:'103328',order_id:this.state.ship_order_id,merchant_param1:this.state.ship_pre_payment_id,merchant_param2:deal_type,merchant_param3:shipping_amt,merchant_param4:'mobile_web',amount:this.state.ship_paid_amt,currency:'INR',cancel_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',redirect_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
				_jquery2.default.ajax({
					method: 'POST',
					data: data1,
					url: basePayUrl,
					success: function success(data) {
						(0, _jquery2.default)('.mob_order_details_page').html(data);
					},
					error: function error(err) {}
				});
			}
		}, {
			key: 'openCancelModal',
			value: function openCancelModal(bid, booking_type) {
				this.setState({
					cancel_modal_status: true
				});
			}
		}, {
			key: 'getCancelDetails',
			value: function getCancelDetails() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token };
				var data2 = JSON.stringify(data1);
	
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'cancel_reasons',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								cancel_reasons: data.reasons
							});
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var that = this;
				setTimeout(function () {
					that.enableDetails();
				}, 3000);
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					confirm_modal: false,
					cancel_modal_status: false,
					cancel_success_status: false
				});
			}
		}, {
			key: 'enableDetails',
			value: function enableDetails() {
				this.setState({
					details_status: true
				});
			}
		}, {
			key: 'getOrderDetails',
			value: function getOrderDetails() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, bid: this.props.params.Oid, order_type: this.props.params.OrderType, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				var order_type = this.props.params.OrderType;
	
				this.setState({
					page_loading: true
				});
	
				if (order_type === '0') {
					var call_fn = 'Booking_details';
				} else if (order_type === '1') {
					call_fn = 'pro_booking_details';
				} else {
					call_fn = 'pro_booking_details';
				}
	
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + call_fn,
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								page_loading: false,
								total_data: data,
								details: data.details,
								shipping_address: data.shipping_address,
								items: data.items,
								applied_coupons: data.applied_coupons,
								payment_details: data.payment_details,
								ship_dlvr_blck: data.ship_dlvr_blck,
								aqua_cash: data.aqua_cash,
								aqua_cash1: data.aqua_cash1,
								seller_discount: data.seller_discount,
								seller_discount1: data.seller_discount1,
								promo_hatch_value: data.promo_hatch_value,
								promo_hatch_value1: data.promo_hatch_value1,
								promo_manf_value: data.promo_manf_value,
								promo_manf_value1: data.promo_manf_value1,
								coupons_amt: data.coupons_amt,
								coupons_amt1: data.coupons_amt1,
								payment_log: data.payment_log,
								shipment_log: data.shipment_log,
								applied_cpns_amt: data.details.applied_cpns_amt,
								pay_now_btn: data.pay_now_btn,
								other_amount_btn: data.other_amount_btn,
								famount_pay_manufacturer: data.famount_pay_manufacturer,
								famount_pay_hatchery: data.famount_pay_hatchery,
								min_val: data.min_val,
								max_val: data.max_val,
								book_id: data.details.booking_id,
	
								pre_payment_id: '',
								order_id: '',
								paid_amt: '',
								rate_flag: data.rate_flag,
								shipping_details: data.shipping_details,
								confirm_btn_show: data.confirm_btn_show,
								transport_mode: data.transport_mode,
	
								cancel_time: data.cancel_time,
								cancel_reason: data.cancel_reason,
								cancel_by: data.cancel_by,
								ship_cc_pay: data.ship_cc_pay,
								gateway_mode: data.gateway_mode
							});
						} else {
							this.setState({
								page_error_status: true
							});
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'enableOtherAmount',
			value: function enableOtherAmount() {
				this.setState({
					other_amount_btn_status: true
				});
			}
		}, {
			key: 'validateOtherAmount',
			value: function validateOtherAmount() {
				this.setState({
					err_qty_status: false,
					err_qty_msg: ''
				});
				//var x='';
				if (parseInt(this.refs.ref_other_amt.value, 10) < parseInt(this.state.min_val, 10)) {
					//x='Minimum Quantity is '+this.state.min_val;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Minimum amount is ' + this.state.min_val
					});
				}
				if (parseInt(this.refs.ref_other_amt.value, 10) > parseInt(this.state.max_val, 10)) {
					// alert('Maximum Quantity is '+this.state.max_qty);
					//x='Maximum Quantity is '+this.state.max_val;
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Maximum amount is ' + this.state.max_val
					});
				}
				var check = /[^0-9]/gi;
				if (check.test(this.refs.ref_other_amt.value)) {
					//x='* Invalid Amount';	
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Invalid Amount'
					});
				}
	
				//if(x==='')
				//{
				//alert('testing');
				//this.other_amount_cartCalculations(4,this.refs.ref_other_amt.value);	
				//}
			}
		}, {
			key: 'payNow',
			value: function payNow() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				if (this.props.params.OrderType === '1') {
					var paid_amt = this.state.famount_pay_manufacturer;
				} else if (this.props.params.OrderType === '0') {
					paid_amt = this.state.famount_pay_hatchery;
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var pay_type = '1';
				var book_id = this.state.book_id;
				var book_type = this.props.params.OrderType;
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, book_id: book_id, paid_amt: paid_amt, pay_type: pay_type, book_type: book_type, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'rem_amt_temp_process',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								pre_payment_id: data.pre_payment_id,
								order_id: data.order_id,
								paid_amt: data.paid_amt
							});
						}
						//this.ccAvenue();
						var payment_params = { from: 'mobile_web',
							uid: localStorage.getItem('user_id'),
							pre_payment_id: data.pre_payment_id,
							order_id: data.order_id,
							deal_type: this.props.params.OrderType,
							cart_ids: data.cart_ids,
							paid_amt: data.paid_amt,
							username: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].name : '',
							address: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].address : '',
							city: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].city : '',
							state: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].state : '',
							pincode: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].zip : '',
							mobile: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].mobile : '',
							country: 'India',
							email: '',
							cart_add_id: 'rem_amt',
							pageId: this.state.pageId,
							rzp_key: this.props.rzp_keys.key_id };
	
						if (this.state.gateway_mode == 2) {
							(0, _custom_functions.razorpayForm)(payment_params);
							this.setState({
								page_loading: false
							});
						} else {
							(0, _custom_functions.ccAvenue)(payment_params);
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'payOtherAmount',
			value: function payOtherAmount() {
				var x = '';
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (this.refs.ref_other_amt.value === '') {
					x = '* Enter Amount';
					this.setState({
						err_qty_status: true,
						err_qty_msg: '* Enter Amount'
					});
				}
				if (parseInt(this.refs.ref_other_amt.value, 10) === parseInt(this.state.max_val, 10)) {
					this.setState({
						confirm_modal: true
					});
				} else {
					if (parseInt(this.refs.ref_other_amt.value, 10) < parseInt(this.state.min_val, 10)) {
						x = 'Minimum Quantity is ' + this.state.min_val;
						this.setState({
							err_qty_status: true,
							err_qty_msg: '* Minimum amount is ' + this.state.min_val
						});
					}
					if (parseInt(this.refs.ref_other_amt.value, 10) > parseInt(this.state.max_val, 10)) {
						x = 'Maximum Quantity is ' + this.state.max_val;
						this.setState({
							err_qty_status: true,
							err_qty_msg: '* Maximum amount is ' + this.state.max_val
						});
					}
					var check = /[^0-9]/gi;
					if (check.test(this.refs.ref_other_amt.value)) {
						x = '* Invalid Amount';
						this.setState({
							err_qty_status: true,
							err_qty_msg: '* Invalid Amount'
						});
					}
					if (x === '') {
						var baseUrl = 'https://aquadeals.in/admin/web3/user/';
						var paid_amt = this.refs.ref_other_amt.value;
						var pay_type = '2';
						var book_id = this.state.book_id;
						var book_type = this.props.params.OrderType;
						var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, book_id: book_id, paid_amt: paid_amt, pay_type: pay_type, book_type: book_type, source: source, campaign: campaign, url_id: url_id };
						var data2 = JSON.stringify(data1);
						_jquery2.default.ajax({
							method: 'POST',
							dataType: 'json',
							url: baseUrl + 'rem_amt_temp_process',
							data: { req: data2 },
							success: function (data) {
								if (data.status === 'success') {
									this.setState({
										pre_payment_id: data.pre_payment_id,
										order_id: data.order_id,
										paid_amt: data.paid_amt
									});
								}
								var payment_params = { from: 'mobile_web',
									uid: localStorage.getItem('user_id'),
									pre_payment_id: data.pre_payment_id,
									order_id: data.order_id,
									deal_type: this.props.params.OrderType,
									cart_ids: data.cart_ids,
									paid_amt: data.paid_amt,
									username: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].name : '',
									address: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].address : '',
									city: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].city : '',
									state: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].state : '',
									pincode: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].zip : '',
									mobile: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].mobile : '',
									country: 'India',
									email: '',
									cart_add_id: 'rem_amt',
									pageId: this.state.pageId,
									rzp_key: this.props.rzp_keys.key_id };
	
								if (this.state.gateway_mode == 2) {
									(0, _custom_functions.razorpayForm)(payment_params);
									this.setState({
										page_loading: false
									});
								} else {
									(0, _custom_functions.ccAvenue)(payment_params);
								}
								//this.ccAvenue();
							}.bind(this),
							error: function error(err) {
								console.log(err);
							}
						});
					}
				}
			}
		}, {
			key: 'ccAvenue',
			value: function ccAvenue() {
				var username = this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].name : '';
				var address = this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].address : '';
				var city = this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].city : '';
				var state = this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].state : '';
				var pincode = this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].zip : '';
				var mobile = this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].mobile : '';
				var email = '';
				var rem_amt = 'rem_amt';
				var deal_type = this.props.params.OrderType;
	
				var basePayUrl = 'https://aqua.deals/paymentGateWay/paymentRequestHandler.php';
				// var basePayUrl='http://203.193.173.125/paymentGateWay/paymentRequestHandler.php';
	
				var data1 = { access_code: 'AVIJ67DJ41BD20JIDB', merchant_id: '103328', order_id: this.state.order_id, merchant_param1: this.state.pre_payment_id, merchant_param2: deal_type, merchant_param3: rem_amt, merchant_param4: 'mobile_web', amount: this.state.paid_amt, currency: 'INR', cancel_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', redirect_url: 'https://aqua.deals/paymentGateWay/paymentResponseHandler.php', billing_name: username, billing_address: address, billing_city: city, billing_state: state, billing_zip: pincode, billing_tel: mobile, billing_country: 'India', billing_email: email };
				// var data1={access_code:'AVJZ66DG16BM17ZJMB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:rem_amt,merchant_param4:'mobile_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',redirect_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
				_jquery2.default.ajax({
					method: 'POST',
					data: data1,
					url: basePayUrl,
					success: function success(data) {
						(0, _jquery2.default)('.mob_order_details_page').html(data);
					},
					error: function error(err) {}
				});
			}
		}, {
			key: 'selectedReason',
			value: function selectedReason(id, flag) {
				if (flag === '1') {
					this.setState({
						edit_input_status: true,
						selected_reason: id
					});
				} else {
					this.setState({
						edit_input_status: false,
						selected_reason: id
					});
				}
			}
		}, {
			key: 'update_other_reason',
			value: function update_other_reason(event) {
				this.setState({
					edit_input: event.target.value
				});
			}
		}, {
			key: 'handleCancel_Submit',
			value: function handleCancel_Submit(event) {
				event.preventDefault();
				var bid = this.props.params.Oid;
				var booking_type = this.props.params.OrderType;
				var selected_reason = this.state.selected_reason;
				if (this.state.selected_reason === 9) {
					selected_reason = this.state.edit_input;
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				if (booking_type === '1') {
					var action_url = 'product_booking_cancel';
					var data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, reason: selected_reason, book_id: bid, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
				} else {
					action_url = 'booking_cancel';
					data1 = { from: 'mobile_web', uid: localStorage.user_id, token: localStorage.token, book_id: bid, reason: selected_reason, source: source, campaign: campaign, url_id: url_id };
					data2 = JSON.stringify(data1);
				}
	
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + action_url,
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								cancel_modal_status: false,
								cancel_success_status: true,
								cancel_success_msg: data.message
							});
							// alert(data.message);
							// window.location.reload();
							this.getOrderDetails();
						} else {
							this.setState({
								cancel_modal_status: false,
								cancel_success_status: true,
								cancel_success_msg: data.message
							});
							this.getOrderDetails();
							// alert(data.message);
							// window.location.reload();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				document.title = this.state.details.booking_id ? "Order " + this.state.details.booking_id + " Details" : "Order Details | AquaDeals";
				// $(window).scrollTop(0);
				(0, _jquery2.default)('body').css('background-color', '#fff');
				var status = '';
				if (this.state.details.status === '0' || this.state.details.status === '4' || this.state.details.status === '7') {
					status = 'Order Placed';
				} else if (this.state.details.status === '1') {
					status = 'Processing';
				} else if (this.state.details.status === '3') {
					status = 'Cancelled';
				} else if (this.state.details.status === '5') {
					status = 'Shipping';
				} else if (this.state.details.status === '6') {
					status = 'Delivered';
				}
				var order_items = '';
				if (this.state.items.length > 0) {
					if (this.props.params.OrderType === '1') {
						order_items = this.state.items.map(function (order, index) {
							return _react2.default.createElement(
								'div',
								{ className: '' },
								_react2.default.createElement(
									'div',
									{ className: 'order_list_items' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-12 col-md-12 order_subitems' },
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-3 col-md-3', style: { padding: '0px' } },
											_react2.default.createElement(
												'i',
												{ className: 'order_icon' },
												_react2.default.createElement('img', { src: order.image, alt: '' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-9 col-md-9', style: { padding: '0px' } },
											_react2.default.createElement(
												'p',
												null,
												order.title
											),
											_react2.default.createElement(
												'p',
												null,
												_react2.default.createElement(
													'span',
													{ style: { fontSize: '10px', color: '#999' } },
													order.brand
												),
												_react2.default.createElement(
													'span',
													{ style: { float: 'right' } },
													'\u20B9 ',
													order.total_amount
												)
											),
											_react2.default.createElement(
												'p',
												null,
												'Price \u20B9 ',
												order.mrp,
												' ',
												_react2.default.createElement(
													'span',
													null,
													'Quantity ',
													order.quantity,
													' '
												),
												' '
											)
										)
									)
								)
							);
						});
					} else {
						order_items = this.state.items.map(function (order, index) {
							return _react2.default.createElement(
								'div',
								{ className: '' },
								_react2.default.createElement(
									'div',
									{ className: 'order_list_items' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-12 col-md-12 order_subitems' },
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-2 col-md-2', style: { padding: '0px' } },
											_react2.default.createElement(
												'i',
												{ className: 'seed_order_icon' },
												_react2.default.createElement('img', { src: order.image, alt: '' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-10 col-md-10', style: { padding: '0px' } },
											_react2.default.createElement(
												'p',
												{ style: { color: '#333' } },
												order.specie
											),
											_react2.default.createElement(
												'p',
												null,
												_react2.default.createElement(
													'span',
													{ style: { float: 'right' } },
													'\u20B9 ',
													order.total_amount
												)
											),
											_react2.default.createElement(
												'p',
												{ style: { color: '#999' } },
												_react2.default.createElement(
													'span',
													null,
													'Plsize'
												),
												'\xA0',
												_react2.default.createElement(
													'span',
													null,
													order.plsize
												),
												'\xA0',
												_react2.default.createElement(
													'span',
													null,
													'Salinity'
												),
												'\xA0',
												_react2.default.createElement(
													'span',
													null,
													order.salinity
												)
											),
											_react2.default.createElement(
												'p',
												null,
												'Price \u20B9 ',
												order.mrp,
												' ',
												_react2.default.createElement(
													'span',
													null,
													'Quantity ',
													order.quantity
												)
											)
										)
									)
								)
							);
						});
					}
				}
	
				var payment_log = this.state.payment_log.map(function (data, index) {
					return _react2.default.createElement(
						'div',
						{ className: 'ordr_dtls_5' },
						_react2.default.createElement(
							'p',
							null,
							data.msg
						)
					);
				});
				var shipment_log = this.state.shipment_log.map(function (data, index) {
					return _react2.default.createElement(
						'div',
						{ className: 'ordr_dtls_5' },
						_react2.default.createElement(
							'p',
							null,
							data.msg
						)
					);
				});
				var pay_remaining_amount = '';
				if (this.state.pay_now_btn === 'yes') {
					pay_remaining_amount = _react2.default.createElement(
						'div',
						{ className: 'pay_now_btn', onClick: function onClick() {
								_this2.payNow();
							} },
						_react2.default.createElement(
							'a',
							null,
							'Pay \u20B9 ',
							this.state.famount_pay_manufacturer,
							' ',
							this.state.famount_pay_hatchery,
							' Online ',
							_react2.default.createElement(
								'i',
								{ className: 'fwd_img' },
								_react2.default.createElement('img', { alt: '', src: 'https://aquadeals.in/admin/assets/images/fwd_org.png', width: '15px' })
							)
						)
					);
				} else {
					pay_remaining_amount = '';
				}
	
				var other_amount_btn = '';
				if (this.state.other_amount_btn === 'yes') {
					other_amount_btn = _react2.default.createElement(
						'div',
						{ className: 'other_amount_btn' },
						_react2.default.createElement(
							'a',
							{ onClick: function onClick() {
									_this2.enableOtherAmount();
								} },
							'Pay Other Amount ',
							_react2.default.createElement(
								'i',
								{ className: 'fwd_img', style: { marginLeft: '11px' } },
								_react2.default.createElement('img', { alt: '', src: 'https://aquadeals.in/admin/assets/images/fwd_org.png', width: '15px' })
							)
						),
						this.state.other_amount_btn_status ? _react2.default.createElement(
							'span',
							{ className: 'ordr_dtls_6' },
							_react2.default.createElement('input', { onChange: function onChange() {
									return _this2.validateOtherAmount();
								}, ref: 'ref_other_amt', id: 'ref_other_amt', type: 'text', placeholder: 'Enter Amount' }),
							this.state.err_qty_status ? _react2.default.createElement(
								'span',
								{ className: 'error_other_amt' },
								this.state.err_qty_msg
							) : ''
						) : '',
						this.state.other_amount_btn_status ? _react2.default.createElement(
							'a',
							{ className: 'pay_other_btn', onClick: function onClick() {
									_this2.payOtherAmount();
								} },
							'PAY'
						) : ''
					);
				} else {
					other_amount_btn = '';
				}
				var cancel_reasons = this.state.cancel_reasons.map(function (data, index) {
					var _this3 = this;
	
					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement('input', { type: 'radio', id: data.id, name: 'reason', className: 'cancel_radio', onClick: function onClick() {
								_this3.selectedReason(data.id, data.flag);
							} }),
						_react2.default.createElement(
							'span',
							null,
							data.reason
						),
						data.flag === '1' ? _react2.default.createElement(
							'div',
							{ className: 'other_reason_blk' },
							this.state.edit_input_status ? _react2.default.createElement('input', { type: 'text', name: 'other_reason', ref: 'other_reason', id: 'other_reason', placeholder: 'Enter any reason', value: this.state.edit_input, onChange: this.update_other_reason }) : ''
						) : ''
					);
				}.bind(this));
	
				var cancel_btn_status = this.state.details.status ? this.state.details.status : '';
				var cancel_btn = '';
				if (cancel_btn_status) {
					if (cancel_btn_status === "0" || cancel_btn_status === "4" || cancel_btn_status === "7") {
						cancel_btn = _react2.default.createElement(
							'div',
							{ className: 'ordr_ftr_blk', onClick: function onClick() {
									_this2.openCancelModal();
								} },
							_react2.default.createElement(
								'a',
								{ className: 'ordr_cncl_btn' },
								'CANCEL ORDER'
							)
						);
					} else {
						cancel_btn = '';
					}
				}
	
				var transport_info = '';
				if (this.state.details.driver_name !== '' && this.state.details.mobile !== '') {
	
					transport_info = _react2.default.createElement(
						'div',
						{ className: 'transport_info_blk' },
						_react2.default.createElement(
							'h5',
							null,
							'Transport Info'
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									null,
									this.state.transport_mode === '0' ? 'Driver Name' : 'Transport Area',
									' : '
								),
								' ',
								this.state.details ? this.state.details.driver_name : ''
							),
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'span',
									null,
									this.state.transport_mode === '0' ? 'Vehicle No' : 'Transport Name',
									' : '
								),
								this.state.details ? this.state.details.vehicle_no : ''
							),
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'a',
									{ href: this.state.details ? 'tel:+' + this.state.details.driver_mobile : '' },
									this.state.details ? this.state.details.driver_mobile : ''
								)
							),
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'a',
									{ href: this.state.details ? 'tel+' + this.state.details.alternate_number_driver : '' },
									this.state.details ? this.state.details.alternate_number_driver : ''
								)
							)
						)
					);
					// }
					// else
					// {
					// 	transport_info =<div><div className="clr">&nbsp;</div><div className="clr">&nbsp;</div><div className="clr">&nbsp;</div></div>;
					// }
				} else {
					// transport_info = <div><div className="clr">&nbsp;</div><div className="clr">&nbsp;</div><div className="clr">&nbsp;</div></div>;
					transport_info = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						)
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals mob_order_details_page' },
					this.state.page_error_status ? _react2.default.createElement(_NotFound2.default, null) : _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'page_hdr' },
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: '/myorders' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
										)
									),
									'Order ',
									this.state.details.booking_id,
									' Details '
								),
								_react2.default.createElement(
									'a',
									{ href: '/', title: 'Home', className: 'home_logo1' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/home1.png', alt: 'Home' })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'pag_cntnt3' },
							'\xA0'
						),
						!this.state.page_loading ? _react2.default.createElement(
							'div',
							{ className: 'ordr_details_content' },
							_react2.default.createElement(
								'section',
								{ className: 'ordr_dtls_1' },
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'p',
										null,
										_react2.default.createElement(
											'span',
											null,
											this.state.details.booking_id
										),
										_react2.default.createElement(
											'span',
											{ className: 'right_side' },
											'\u20B9 ',
											this.state.details.total_discount
										)
									),
									_react2.default.createElement(
										'p',
										null,
										_react2.default.createElement(
											'span',
											{ style: { fontSize: '10px' } },
											this.state.details.book_date
										),
										_react2.default.createElement(
											'span',
											{ className: 'order_details_status' },
											status
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'ordr_dtls_2' },
								this.state.items.length > 1 ? _react2.default.createElement(
									'p',
									null,
									'You have ',
									this.state.items.length,
									' items in your order'
								) : _react2.default.createElement(
									'p',
									null,
									'You have ',
									this.state.items.length,
									' item in your order'
								),
								order_items,
								this.state.total_data.progress_bar != "" ? _react2.default.createElement(
									'div',
									{ className: 'col-md-12 col-sm-12 col-xs-12' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/product_imgs/' + this.state.total_data.progress_bar, alt: '' })
									)
								) : ''
							),
							_react2.default.createElement(
								'div',
								{ className: '', style: { marginTop: '10px' } },
								_react2.default.createElement(
									'h5',
									{ className: 'ordr_header' },
									'ORDER SUMMARY'
								),
								_react2.default.createElement(
									'div',
									{ className: 'ordr_dtls_3' },
									_react2.default.createElement(
										'table',
										{ className: 'table cart_table' },
										_react2.default.createElement(
											'tr',
											{ className: 'cart_tr_total' },
											_react2.default.createElement(
												'td',
												null,
												'Order Total'
											),
											_react2.default.createElement(
												'td',
												null,
												'\u20B9 ',
												this.state.details.total_amount
											)
										),
										this.state.aqua_cash1 && parseInt(this.state.aqua_cash1, 10) > 0 ? _react2.default.createElement(
											'tr',
											{ className: 'cart_tr' },
											_react2.default.createElement(
												'td',
												null,
												'Aquacash Discount'
											),
											_react2.default.createElement(
												'td',
												null,
												'(-) \u20B9 ',
												this.state.aqua_cash
											)
										) : '',
										this.state.coupons_amt1 && parseInt(this.state.coupons_amt1, 10) > 0 ? _react2.default.createElement(
											'tr',
											{ className: 'cart_tr' },
											_react2.default.createElement(
												'td',
												null,
												'Applicable Coupons'
											),
											_react2.default.createElement(
												'td',
												null,
												'(-) \u20B9 ',
												this.state.coupons_amt
											)
										) : '',
										this.state.seller_discount1 && parseInt(this.state.seller_discount1, 10) > 0 ? _react2.default.createElement(
											'tr',
											{ className: 'cart_tr' },
											_react2.default.createElement(
												'td',
												null,
												'Seller Discount'
											),
											_react2.default.createElement(
												'td',
												null,
												'(-) \u20B9 ',
												this.state.seller_discount
											)
										) : '',
										this.state.promo_manf_value1 && parseInt(this.state.promo_manf_value1, 10) > 0 ? _react2.default.createElement(
											'tr',
											{ className: 'cart_tr' },
											_react2.default.createElement(
												'td',
												null,
												'Promo Discount'
											),
											_react2.default.createElement(
												'td',
												null,
												'(-) \u20B9 ',
												this.state.promo_manf_value
											)
										) : '',
										this.state.promo_hatch_value1 && this.state.promo_hatch_value1 > 0 ? _react2.default.createElement(
											'tr',
											{ className: 'cart_tr' },
											_react2.default.createElement(
												'td',
												null,
												'Promo Discount'
											),
											_react2.default.createElement(
												'td',
												null,
												'(-) \u20B9 ',
												this.state.promo_hatch_value
											)
										) : '',
										_react2.default.createElement(
											'tr',
											{ className: 'cart_tr_grandtotal' },
											_react2.default.createElement(
												'td',
												null,
												'\xA0'
											),
											_react2.default.createElement(
												'td',
												null,
												'Total \xA0 \xA0 \u20B9 ',
												this.state.details.total_discount
											)
										)
									)
								)
							),
							this.state.payment_details.length > 0 ? _react2.default.createElement(
								'div',
								{ style: { marginTop: '10px' } },
								_react2.default.createElement(
									'h5',
									{ className: 'ordr_header' },
									'PAYMENT DETAILS'
								),
								this.state.payment_details.map(function (item, index) {
									return _react2.default.createElement(
										'h5',
										{ className: 'ordr_dtls_4' },
										_react2.default.createElement(
											'span',
											null,
											item.title
										),
										_react2.default.createElement(
											'span',
											{ style: { float: 'right' } },
											'\u20B9 ',
											item.value
										)
									);
								})
							) : '',
							payment_log.length > 0 ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'h5',
									{ className: 'ordr_header' },
									'PAYMENT HISTORY'
								),
								payment_log
							) : '',
							pay_remaining_amount ? _react2.default.createElement(
								'div',
								{ className: 'payment_options' },
								pay_remaining_amount
							) : '',
							other_amount_btn ? other_amount_btn : '',
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'h5',
									{ className: 'ordr_header' },
									'SHIPPING AND DELIVERY'
								),
								_react2.default.createElement(
									'div',
									null,
									this.state.ship_dlvr_blck.map(function (data, index) {
										var _this4 = this;
	
										return _react2.default.createElement(
											'div',
											{ className: 'ship_del_blk' },
											_react2.default.createElement(
												'h5',
												null,
												_react2.default.createElement(
													'span',
													null,
													data.shipment_charge ? 'Shipping Charge' : ''
												),
												this.state.ship_cc_pay === 1 ? _react2.default.createElement(
													'span',
													{ className: 'ship_pay_now_btn', onClick: function onClick() {
															_this4.shippingPayNow();
														} },
													data.shipment_charge ? data.shipment_charge : ''
												) : _react2.default.createElement(
													'span',
													{ className: 'right_side' },
													data.shipment_charge ? data.shipment_charge : ''
												)
											),
											_react2.default.createElement(
												'h5',
												null,
												_react2.default.createElement(
													'span',
													null,
													data.deliver_date ? 'Delivery Date' : ''
												),
												_react2.default.createElement(
													'span',
													{ className: 'right_side' },
													data.deliver_date ? data.deliver_date : ''
												)
											)
										);
									}.bind(this))
								)
							),
							shipment_log.length > 0 ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'h5',
									{ className: 'ordr_header' },
									'SHIPPING PAYMENT HISTORY'
								),
								shipment_log
							) : '',
							_react2.default.createElement(
								'div',
								{ className: 'ship_adrs_blk' },
								_react2.default.createElement(
									'h5',
									{ className: 'ordr_header' },
									'SHIPPING ADDRESS'
								),
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'p',
										null,
										this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].name : ''
									),
									_react2.default.createElement(
										'p',
										null,
										this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].address : ''
									),
									_react2.default.createElement(
										'p',
										null,
										this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].city : '',
										' , ',
										this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].state : ''
									),
									_react2.default.createElement(
										'p',
										null,
										this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].zip : ''
									),
									_react2.default.createElement(
										'p',
										{ style: { color: '#ff742a' } },
										_react2.default.createElement(
											'a',
											{ href: this.state.total_data.shipping_address ? 'tel:+' + this.state.total_data.shipping_address[0].mobile : '' },
											this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].mobile : ''
										)
									)
								)
							),
							transport_info,
							this.state.cancel_by !== '' ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'h5',
									{ className: 'ordr_header' },
									'CANCELLATION DETAILS'
								),
								_react2.default.createElement(
									'div',
									{ style: { padding: '10px' } },
									this.state.cancel_by ? _react2.default.createElement(
										'p',
										null,
										_react2.default.createElement(
											'span',
											null,
											'Cancelled by '
										),
										_react2.default.createElement(
											'span',
											{ style: { float: 'right' } },
											this.state.cancel_by
										)
									) : '',
									this.state.cancel_time ? _react2.default.createElement(
										'p',
										null,
										_react2.default.createElement(
											'span',
											null,
											'Date & Time '
										),
										_react2.default.createElement(
											'span',
											{ style: { float: 'right' } },
											this.state.cancel_time
										)
									) : '',
									this.state.cancel_reason ? _react2.default.createElement(
										'p',
										null,
										_react2.default.createElement(
											'span',
											null,
											'Reason'
										),
										_react2.default.createElement(
											'span',
											{ style: { float: 'right' } },
											this.state.cancel_reason
										)
									) : ''
								)
							) : '',
							_react2.default.createElement(
								_reactBootstrap.Modal,
								{ className: 'order_confirm_modal', show: this.state.confirm_modal, onHide: this.close },
								_react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
								_react2.default.createElement(
									_reactBootstrap.Modal.Body,
									null,
									_react2.default.createElement(
										'h4',
										{ className: 'order_confirm_title' },
										'Are You Sure?'
									),
									_react2.default.createElement(
										'p',
										null,
										'You are paying full amount !'
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal.Footer,
									{ className: 'modal_footer' },
									_react2.default.createElement(
										'a',
										{ onClick: function onClick() {
												_this2.payNow();
											} },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ style: { background: '#ff742a none repeat scroll 0 0', color: '#fff' } },
											'Yes, I will pay'
										)
									)
								)
							),
							this.state.details.status === '2' || this.state.details.status === '6' ? _react2.default.createElement(
								'div',
								{ className: 'ordr_ftr_blk' },
								this.state.rate_flag === 2 ? _react2.default.createElement(
									_reactRouter.Link,
									{ className: 'ordr_view_rate_btn', to: this.props.params.OrderType === '1' ? '/rate/product/' + this.props.params.Oid : '/rate/' + this.props.params.Oid },
									'View Rating'
								) : '',
								this.state.rate_flag === 1 ? _react2.default.createElement(
									_reactRouter.Link,
									{ className: 'ordr_give_rate_btn', to: this.props.params.OrderType === '1' ? '/giverating/product/' + this.props.params.Oid : '/giverating/' + this.props.params.Oid },
									'Give Rating'
								) : ''
							) : '',
							cancel_btn,
							_react2.default.createElement(
								_reactBootstrap.Modal,
								{ onEntered: function onEntered() {
										_this2.getCancelDetails();
									}, className: '', show: this.state.cancel_modal_status, onHide: this.close },
								_react2.default.createElement(
									_reactBootstrap.Modal.Header,
									{ className: 'modal_offer_header', closeButton: true },
									_react2.default.createElement(
										_reactBootstrap.Modal.Title,
										{ className: 'm_title', style: { textAlign: 'center', color: '#fff' } },
										'Order Cancellation'
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal.Body,
									null,
									_react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(
											'p',
											null,
											'Do you want to cancel this Order?'
										),
										_react2.default.createElement(
											'form',
											{ className: 'cancel_reasons_form', onSubmit: this.handleCancel_Submit },
											_react2.default.createElement(
												'div',
												{ className: '' },
												cancel_reasons
											),
											_react2.default.createElement(
												'div',
												null,
												_react2.default.createElement(
													'div',
													{ className: 'modal-footer' },
													_react2.default.createElement(
														'a',
														{ className: 'cancel_no_btn', onClick: this.close },
														'No'
													),
													_react2.default.createElement(
														'button',
														{ type: 'submit', className: 'cancel_yes_btn' },
														'Yes'
													)
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal,
								{ className: 'showModal', show: this.state.cancel_success_status, onHide: this.close },
								_react2.default.createElement(
									_reactBootstrap.Modal.Body,
									null,
									_react2.default.createElement(
										'h4',
										{ style: { fontSize: '14px', color: '#666', textAlign: 'center' } },
										this.state.cancel_success_msg
									)
								)
							)
						) : _react2.default.createElement(
							'div',
							{ className: 'page_loading' },
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/loading_more.gif', alt: 'Loading' })
						)
					)
				);
			}
		}]);
	
		return Order_Details;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			rzp_keys: state.posts.rzp_keys
		};
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Order_Details);

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _custom_functions = __webpack_require__(69);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRedux = __webpack_require__(15);
	
	var _actions = __webpack_require__(22);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// /shipping_payment/:Type/:Book_Id/:Uid
	
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Shipping_Payment = function (_Component) {
		_inherits(Shipping_Payment, _Component);
	
		function Shipping_Payment(props) {
			_classCallCheck(this, Shipping_Payment);
	
			var _this = _possibleConstructorReturn(this, (Shipping_Payment.__proto__ || Object.getPrototypeOf(Shipping_Payment)).call(this, props));
	
			_this.state = {
				pre_payment_id: '',
				order_id: '',
				paid_amt: '',
				book_type: '',
	
				shipaddress: [],
				username: '',
				address: '',
				city: '',
				state: '',
				pincode: '',
				mobile: '',
				email: '',
	
				payment_details: '',
				pros: [],
				shipment_details: '',
				deal_type: '',
				booking_data: [],
				tot_data: [],
				billing_status: false,
				page_error_status: false,
				pageId: '.shipping_payment_page'
			};
			_this.getShippingDetails = _this.getShippingDetails.bind(_this);
			_this.enableBillingDetails = _this.enableBillingDetails.bind(_this);
			return _this;
		}
	
		_createClass(Shipping_Payment, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					window.location.href = '/web/shipping_payment/' + this.props.params.Type + '/' + this.props.params.Book_Id + '/' + this.props.params.Uid;
					// window.location.href='http://203.193.173.125/web/shipping_payment/'+this.props.params.Type+'/'+this.props.params.Book_Id+'/'+this.props.params.Uid;
				}
				if (!localStorage.token && !localStorage.user_id) {
					localStorage.setItem('shipping', '/shipping_payment/' + this.props.params.Type + '/' + this.props.params.Book_Id + '/' + this.props.params.Uid);
					_reactRouter.browserHistory.push('/login');
				} else {
					this.getShippingDetails();
				}
			}
		}, {
			key: 'enableBillingDetails',
			value: function enableBillingDetails() {
				this.setState({
					billing_status: true
				});
			}
		}, {
			key: 'getShippingDetails',
			value: function getShippingDetails() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: uid, token: localStorage.token, bid: this.props.params.Book_Id, type: this.props.params.Type, pid: this.props.params.Uid, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'get_shipment_stat',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								payment_details: data.payment_details,
								pros: data.pros,
								shipment_details: data.shipment_details,
								deal_type: data.deal_type,
								booking_data: data.booking_data,
								tot_data: data
							});
						} else if (data.status === 'error' && data.message === 'You are not authorized') {
							this.setState({
								page_error_status: true
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				var that = this;
				setTimeout(function () {
					that.enableBillingDetails();
				}, 3000);
			}
			// payNow(book_id,paid_amt,pay_type,book_type,u_name,u_address,u_phone,u_zip,u_city,u_state,u_email)
	
		}, {
			key: 'payNow',
			value: function payNow() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, bid: this.props.params.Book_Id, type: this.props.params.Type, pid: this.props.params.Uid, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'ship_payment_temp_process',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								pre_payment_id: data.pre_payment_id,
								order_id: data.order_id,
								paid_amt: data.paid_amt,
								book_type: data.book_type,
	
								username: data.shipaddress[0].name,
								address: data.shipaddress[0].address,
								city: data.shipaddress[0].city,
								state: data.shipaddress[0].state,
								pincode: data.shipaddress[0].zip,
								mobile: data.shipaddress[0].phone,
								email: data.shipaddress[0].email,
								gateway_mode: data.gateway_mode
	
							});
							var payment_params = { from: 'mobile_web',
								uid: localStorage.getItem('user_id'),
								pre_payment_id: this.state.pre_payment_id,
								order_id: this.state.order_id,
								deal_type: this.state.book_type,
								cart_ids: '',
								paid_amt: this.state.paid_amt,
								username: this.state.username,
								address: this.state.address,
								city: this.state.city,
								state: this.state.state,
								pincode: this.state.pincode,
								mobile: this.state.mobile,
								country: 'India',
								email: this.state.email,
								cart_add_id: 'shipping_amt',
								pageId: this.state.pageId,
								rzp_key: this.props.rzp_keys.key_id };
							if (this.state.gateway_mode == 2) {
								(0, _custom_functions.razorpayForm)(payment_params);
								this.setState({
									page_loading: false
								});
							} else {
								(0, _custom_functions.ccAvenue)(payment_params);
							}
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
	
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				document.title = "Shipping Payment | AquaDeals";
				if (this.state.pros.length > 0) {
					if (this.state.deal_type === '1') {
						var products = this.state.pros.map(function (order, index) {
							return _react2.default.createElement(
								'div',
								{ className: '' },
								_react2.default.createElement(
									'div',
									{ className: 'order_list_items' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-12 col-md-12 order_subitems' },
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-3 col-md-3', style: { padding: '0px' } },
											_react2.default.createElement(
												'i',
												{ className: 'order_icon' },
												_react2.default.createElement('img', { src: order.image, alt: '' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-9 col-md-9', style: { padding: '0px' } },
											order.title ? _react2.default.createElement(
												'p',
												null,
												order.title
											) : _react2.default.createElement(
												'p',
												null,
												'\xA0'
											),
											order.brand || order.total_amount ? _react2.default.createElement(
												'p',
												null,
												_react2.default.createElement(
													'span',
													{ style: { fontSize: '10px', color: '#999' } },
													order.brand
												),
												_react2.default.createElement(
													'span',
													{ style: { float: 'right' } },
													'\u20B9 ',
													order.total_amount
												)
											) : _react2.default.createElement(
												'p',
												null,
												'\xA0'
											),
											_react2.default.createElement(
												'p',
												null,
												'Price \u20B9 ',
												order.mrp,
												' ',
												_react2.default.createElement(
													'span',
													null,
													'Quantity ',
													order.quantity,
													' '
												),
												' '
											)
										)
									)
								)
							);
						});
					} else {
						products = this.state.pros.map(function (order, index) {
							return _react2.default.createElement(
								'div',
								{ className: '' },
								_react2.default.createElement(
									'div',
									{ className: 'order_list_items' },
									_react2.default.createElement(
										'div',
										{ className: 'col-xs-12 col-md-12 order_subitems' },
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-2 col-md-2', style: { padding: '0px' } },
											_react2.default.createElement(
												'i',
												{ className: 'seed_order_icon' },
												_react2.default.createElement('img', { src: order.image, alt: '' })
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-xs-10 col-md-10', style: { padding: '0px' } },
											order.specie ? _react2.default.createElement(
												'p',
												{ style: { color: '#333' } },
												order.specie
											) : _react2.default.createElement(
												'p',
												null,
												'\xA0'
											),
											order.total_amount ? _react2.default.createElement(
												'p',
												null,
												_react2.default.createElement(
													'span',
													{ style: { float: 'right' } },
													'\u20B9 ',
													order.total_amount
												)
											) : _react2.default.createElement(
												'p',
												null,
												'\xA0'
											),
											_react2.default.createElement(
												'p',
												{ style: { color: '#999' } },
												_react2.default.createElement(
													'span',
													null,
													'Plsize'
												),
												'\xA0',
												_react2.default.createElement(
													'span',
													null,
													order.plsize
												),
												'\xA0',
												_react2.default.createElement(
													'span',
													null,
													'Salinity'
												),
												'\xA0',
												_react2.default.createElement(
													'span',
													null,
													order.salinity
												)
											),
											_react2.default.createElement(
												'p',
												null,
												'Price \u20B9 ',
												order.mrp,
												' ',
												_react2.default.createElement(
													'span',
													null,
													'Quantity ',
													order.quantity
												)
											)
										)
									)
								)
							);
						});
					}
				}
	
				// if(this.state.shipment_details.length > 0)
				// {
				// 	var shipment_details=<div style={{marginTop:'10px'}}>
				// 						<h5 className="ordr_header">SHIPPING DETAILS</h5>
				// 						{this.state.shipment_details.map(function(item,index){
				// 							return(
				// 								<h5 className="ordr_dtls_4"><span>{item.title}</span><span style={{float:'right'}}>&#8377; {item.value}</span></h5>
				// 								);
				// 							})}
				// 					</div>;
				// }
				// else
				// {
				// 	shipment_details='';
				// }
	
				var status = '';
				if (this.state.tot_data) {
					if (this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].status === '0' || this.state.tot_data.booking_data[0] === '4' || this.state.tot_data.booking_data[0].status === '7' : '') {
						status = 'Order Placed';
					} else if (this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].status === '1' : '') {
						status = 'Processing';
					} else if (this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].status === '3' : '') {
						status = 'Cancelled';
					} else if (this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].status === '5' : '') {
						status = 'Shipping';
					} else if (this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].status === '6' : '') {
						status = 'Delivered';
					}
				}
	
				var b_id = this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].booking_id : '';
				var total_discount = this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].total_discount : '';
				var book_date = this.state.tot_data.booking_data ? this.state.tot_data.booking_data[0].created_on : '';
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals shipping_payment_page' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: '/' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
									)
								),
								'Shipping Payment'
							),
							_react2.default.createElement(
								'a',
								{ href: '/', title: 'Home', className: 'home_logo1' },
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/home1.png', alt: 'Home' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'pag_cntnt' },
						'\xA0'
					),
					this.state.page_error_status ? _react2.default.createElement(
						'div',
						{ className: 'ship_error_block' },
						_react2.default.createElement(
							'h4',
							null,
							'You are not authorized'
						),
						_react2.default.createElement(
							'a',
							{ href: '/' },
							'Explore Deals'
						)
					) : _react2.default.createElement(
						'div',
						{ className: 'ship_dtls_cnt_blk' },
						_react2.default.createElement(
							'section',
							{ className: 'ordr_dtls_1' },
							this.state.booking_data ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'span',
										null,
										b_id
									),
									_react2.default.createElement(
										'span',
										{ className: 'right_side' },
										'\u20B9 ',
										total_discount
									)
								),
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'span',
										{ style: { fontSize: '10px' } },
										book_date
									),
									_react2.default.createElement(
										'span',
										{ className: 'order_details_status' },
										status
									)
								)
							) : ''
						),
						_react2.default.createElement(
							'div',
							{ className: 'ship_dtls_pro_blk' },
							this.state.pros.length > 1 ? _react2.default.createElement(
								'p',
								{ style: { paddingLeft: '10px', marginTop: '5px' } },
								'You have ',
								this.state.pros.length,
								' items in your order'
							) : _react2.default.createElement(
								'p',
								{ style: { paddingLeft: '10px', marginTop: '5px' } },
								'You have ',
								this.state.pros.length,
								' item in your order'
							),
							products,
							this.state.tot_data.progress_bar != "" ? _react2.default.createElement(
								'div',
								{ className: 'col-md-12 col-sm-12 col-xs-12' },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/product_imgs/' + this.state.tot_data.progress_bar, alt: '' })
								)
							) : ''
						),
						_react2.default.createElement(
							'div',
							{ className: '', style: { marginTop: '10px' } },
							_react2.default.createElement(
								'h5',
								{ className: 'ordr_header' },
								'ORDER SUMMARY'
							),
							this.state.billing_status ? _react2.default.createElement(
								'div',
								{ className: 'ordr_dtls_3' },
								_react2.default.createElement(
									'table',
									{ className: 'table cart_table' },
									_react2.default.createElement(
										'tr',
										{ className: 'cart_tr_total' },
										_react2.default.createElement(
											'td',
											null,
											'Order Total'
										),
										_react2.default.createElement(
											'td',
											null,
											'\u20B9 ',
											this.state.tot_data.total_amount
										)
									),
									this.state.tot_data.aqua_cash1 && parseInt(this.state.tot_data.aqua_cash1, 10) > 0 ? _react2.default.createElement(
										'tr',
										{ className: 'cart_tr' },
										_react2.default.createElement(
											'td',
											null,
											'Aquacash Discount'
										),
										_react2.default.createElement(
											'td',
											null,
											'(-) \u20B9 ',
											this.state.tot_data.aqua_cash
										)
									) : '',
									this.state.tot_data.coupons_amt1 && parseInt(this.state.tot_data.coupons_amt1, 10) > 0 ? _react2.default.createElement(
										'tr',
										{ className: 'cart_tr' },
										_react2.default.createElement(
											'td',
											null,
											'Applicable Coupons'
										),
										_react2.default.createElement(
											'td',
											null,
											'(-) \u20B9 ',
											this.state.tot_data.coupons_amt
										)
									) : '',
									this.state.tot_data.seller_discount1 && parseInt(this.state.tot_data.seller_discount1, 10) > 0 ? _react2.default.createElement(
										'tr',
										{ className: 'cart_tr' },
										_react2.default.createElement(
											'td',
											null,
											'Seller Discount'
										),
										_react2.default.createElement(
											'td',
											null,
											'(-) \u20B9 ',
											this.state.tot_data.seller_discount
										)
									) : '',
									this.state.tot_data.promo_manf_value1 && parseInt(this.state.tot_data.promo_manf_value1, 10) > 0 ? _react2.default.createElement(
										'tr',
										{ className: 'cart_tr' },
										_react2.default.createElement(
											'td',
											null,
											'Promo Discount'
										),
										_react2.default.createElement(
											'td',
											null,
											'(-) \u20B9 ',
											this.state.tot_data.promo_manf_value
										)
									) : '',
									this.state.tot_data.promo_hatch_value1 && parseInt(this.state.tot_data.promo_hatch_value1, 10) > 0 ? _react2.default.createElement(
										'tr',
										{ className: 'cart_tr' },
										_react2.default.createElement(
											'td',
											null,
											'Promo Discount'
										),
										_react2.default.createElement(
											'td',
											null,
											'(-) \u20B9 ',
											this.state.tot_data.promo_hatch_value
										)
									) : '',
									_react2.default.createElement(
										'tr',
										{ className: 'cart_tr_grandtotal' },
										_react2.default.createElement(
											'td',
											null,
											'\xA0'
										),
										_react2.default.createElement(
											'td',
											null,
											'Total \xA0 \xA0 \u20B9 ',
											this.state.tot_data.total_discount
										)
									),
									this.state.tot_data.ship_value1 && parseInt(this.state.tot_data.ship_value1, 10) > 0 ? _react2.default.createElement(
										'tr',
										{ className: 'ship_grandtotal' },
										_react2.default.createElement(
											'td',
											null,
											'You need to pay shipping charges'
										),
										_react2.default.createElement(
											'td',
											null,
											'(+) \u20B9 ',
											this.state.tot_data.ship_value
										)
									) : ''
								)
							) : _react2.default.createElement(
								'div',
								{ className: 'price_loading' },
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/loading_more.gif', alt: 'Loading' })
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'ship_pay_blk' },
							_react2.default.createElement(
								'a',
								{ className: 'ship_pay_btn', onClick: function onClick() {
										_this2.payNow();
									} },
								'PAY NOW'
							)
						)
					)
				);
			}
		}]);
	
		return Shipping_Payment;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			rzp_keys: state.posts.rzp_keys
		};
	}
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(Shipping_Payment);

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Shipping_Status = function (_Component) {
		_inherits(Shipping_Status, _Component);
	
		function Shipping_Status() {
			_classCallCheck(this, Shipping_Status);
	
			return _possibleConstructorReturn(this, (Shipping_Status.__proto__ || Object.getPrototypeOf(Shipping_Status)).apply(this, arguments));
		}
	
		_createClass(Shipping_Status, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					window.location.href = "/web/payment_status/" + this.props.params.Status;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = "Payment Status | AquaDeals";
				var status_title = _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'h4',
						null,
						'Something went wrong !'
					)
				);
				if (this.props.params.Status === 'aborted') {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Transaction Aborted'
						),
						_react2.default.createElement(
							'a',
							{ href: '/', className: 'expl_btn' },
							'Explore Deals'
						)
					);
				} else if (this.props.params.Status === 'success') {
					if (this.props.params.OrderType && this.props.params.Oid) {
						status_title = _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'i',
								null,
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/conformed.png', width: '70px', alt: '' })
							),
							_react2.default.createElement(
								'h5',
								{ style: { marginTop: '10px', marginBottom: '30px' } },
								'Shipping Payment Completed Successfully'
							),
							_react2.default.createElement(
								'a',
								{ href: '/order_details/' + this.props.params.OrderType + '/' + this.props.params.Oid },
								'View Order Details'
							)
						);
					} else {
						status_title = _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'i',
								null,
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/conformed.png', width: '70px', alt: '' })
							),
							_react2.default.createElement(
								'h5',
								{ style: { marginTop: '10px' } },
								'Shipping Payment Completed Successfully'
							)
						);
					}
				} else if (this.props.params.Status === 'failure') {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Transaction Failed'
						),
						_react2.default.createElement(
							'a',
							{ href: '/', className: 'expl_btn' },
							'Explore Deals'
						)
					);
				} else if (this.props.params.Status === 'invalid') {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Invalid Transaction'
						),
						_react2.default.createElement(
							'a',
							{ href: '/', className: 'expl_btn' },
							'Explore Deals'
						)
					);
				} else if (this.props.params.Status === 'serverDown') {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Server Down'
						),
						_react2.default.createElement(
							'a',
							{ href: '/', className: 'expl_btn' },
							'Explore Deals'
						)
					);
				} else {
					status_title = _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h4',
							null,
							'Something went wrong !'
						),
						_react2.default.createElement(
							'a',
							{ href: '/', className: 'expl_btn' },
							'Explore Deals'
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals shipping_status_page' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: '/' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
									)
								),
								'Confirmation'
							),
							_react2.default.createElement(
								'a',
								{ href: '/', title: 'Home', className: 'home_logo1' },
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/home1.png', alt: 'Home' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'pag_cntnt' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'abort_content' },
						status_title ? status_title : _react2.default.createElement(
							'h4',
							null,
							'Something went wrong'
						)
					)
				);
			}
		}]);
	
		return Shipping_Status;
	}(_react.Component);
	
	exports.default = Shipping_Status;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _reactSwipe = __webpack_require__(125);
	
	var _reactSwipe2 = _interopRequireDefault(_reactSwipe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var PromotionsNew = function (_Component) {
		_inherits(PromotionsNew, _Component);
	
		function PromotionsNew(props) {
			_classCallCheck(this, PromotionsNew);
	
			var _this = _possibleConstructorReturn(this, (PromotionsNew.__proto__ || Object.getPrototypeOf(PromotionsNew)).call(this, props));
	
			_this.state = {
				tot_data: [],
				product_offers: [],
				seed_offers: [],
				offers: [],
				is_loading: false
			};
			_this.getOffers = _this.getOffers.bind(_this);
			return _this;
		}
	
		_createClass(PromotionsNew, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.getOffers();
			}
		}, {
			key: 'getOffers',
			value: function getOffers() {
				var data1 = { from: 'mobile_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getOffers',
					success: function (data) {
						if (data.status === 'available') {
							this.setState({
								tot_data: data,
								product_offers: data.product_offers,
								seed_offers: data.seed_offers,
								offers: data.offers,
								is_loading: true
							});
							setTimeout(function () {
								(0, _jquery2.default)('.promo_truck_img').show();
							}, 100);
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var params = {
					paginationClickable: true,
					spaceBetween: 0,
					slidesPerView: 1,
					// autoplay:3000,
					// autoplayDisableOnInteraction:false,
					// loop:true
					parallax: true,
					parallaxEl: {
						el: '.parallax-bg',
						value: '-23%'
					}
				};
	
				var product_offers = this.state.product_offers.map(function (product, index) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ className: "new_promo_item promo_road_img2", to: "/pdetails/" + product.url_dtype_name + "/" + product.url_cat_name + "/" + product.url_brand_name + "/" + product.url_product_name + "/" + product.product_id + "/" + product.deal_id },
						_react2.default.createElement(
							'div',
							{ className: 'promo_swipe_img' },
							_react2.default.createElement(
								'div',
								{ className: 'raod_img' },
								' ',
								_react2.default.createElement('img', { className: 'img', src: 'https://aquadeals.in/admin/assets/images/web_imgs/road_0.png', alt: '', title: '' }),
								_react2.default.createElement(
									'span',
									{ className: 'promo_swipe_img_item' },
									_react2.default.createElement('img', { src: product.img === '' ? baseAssets + 'icons/web_icons/offer-icon.png' : product.img, alt: '' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'btm_swp' },
								product.title ? _react2.default.createElement(
									'h5',
									{ className: 'promo_gen_title' },
									product.title
								) : _react2.default.createElement(
									'h5',
									{ className: 'promo_gen_title' },
									'\xA0'
								),
								product.desc ? _react2.default.createElement(
									'h6',
									{ className: 'gen_desc' },
									product.desc
								) : _react2.default.createElement(
									'h6',
									{ className: 'gen_desc' },
									'\xA0'
								)
							)
						)
					);
				});
				var seed_offers = this.state.seed_offers.map(function (seed, index) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ className: "new_promo_item promo_road_img2", to: "/sdetails/" + seed.url_title + "/" + seed.deal_id },
						_react2.default.createElement(
							'div',
							{ className: 'promo_swipe_img' },
							_react2.default.createElement(
								'div',
								{ className: 'raod_img' },
								' ',
								_react2.default.createElement('img', { className: 'img', src: 'https://aquadeals.in/admin/assets/images/web_imgs/road_0.png', alt: '', title: '' }),
								_react2.default.createElement(
									'span',
									{ className: 'promo_swipe_img_item' },
									_react2.default.createElement('img', { src: seed.img === '' ? baseAssets + 'icons/web_icons/offer-icon.png' : seed.img, alt: '' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'btm_swp' },
								seed.title ? _react2.default.createElement(
									'h5',
									{ className: 'promo_gen_title' },
									seed.title
								) : _react2.default.createElement(
									'h5',
									{ className: 'promo_gen_title' },
									'\xA0'
								),
								seed.desc ? _react2.default.createElement(
									'h6',
									{ className: 'gen_desc' },
									seed.desc
								) : _react2.default.createElement(
									'h6',
									{ className: 'gen_desc' },
									'\xA0'
								)
							)
						)
					);
				});
				var offers = this.state.offers.map(function (offer, index) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ className: "new_promo_item promo_road_img2 promo_road_img_" + index, to: '/offer/' + offer.id + "/details" },
						_react2.default.createElement(
							'div',
							{ className: 'promo_swipe_img' },
							_react2.default.createElement(
								'div',
								{ className: 'raod_img' },
								' ',
								_react2.default.createElement('img', { className: 'img', src: 'https://aquadeals.in/admin/assets/images/web_imgs/road_0.png', alt: '', title: '' }),
								_react2.default.createElement(
									'span',
									{ className: 'promo_swipe_img_item' },
									_react2.default.createElement('img', { src: offer.img === '' ? baseAssets + 'icons/web_icons/offer-icon.png' : offer.img, alt: '' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'btm_swp' },
								offer.title ? _react2.default.createElement(
									'h5',
									{ className: 'promo_gen_title' },
									offer.title
								) : _react2.default.createElement(
									'h5',
									{ className: 'promo_gen_title' },
									'\xA0'
								),
								offer.desc ? _react2.default.createElement(
									'h6',
									{ className: 'gen_desc' },
									offer.desc
								) : _react2.default.createElement(
									'h6',
									{ className: 'gen_desc' },
									'\xA0'
								)
							)
						)
					);
				});
				(0, _jquery2.default)('body').css('background-color', '#fff');
				return _react2.default.createElement(
					'div',
					null,
					this.state.is_loading ? _react2.default.createElement(
						'div',
						{ className: 'promotional_blk container-fluid', style: { textAlign: 'center' } },
						_react2.default.createElement(
							'div',
							{ style: { marginBottom: '15px' } },
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									'div',
									{ className: 'truck_img' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/promotions_truck.png', alt: '', title: '' }),
									' '
								),
								_react2.default.createElement(
									_reactSwipe2.default,
									{ ref: 'reactSwipe', className: 'carousel item', swipeOptions: {
											continuous: true,
											disableScroll: product_offers.length + seed_offers.length + offers.length === 1 ? true : false,
											stopPropagation: false,
											callback: function callback(index, elem) {},
											transitionEnd: function transitionEnd(index, elem) {}
										}, key: product_offers.length + seed_offers.length + offers.length },
									product_offers,
									seed_offers,
									offers
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row promo_titles_blk' },
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-6 col-md-6 col-sm-6 col-xs-6' },
									_react2.default.createElement(
										'h5',
										{ className: 'promotions_title' },
										this.state.offers.length > 0 ? 'AD OFFERS' : 'PROMOTIONS'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-lg-6 col-md-6 col-sm-6 col-xs-6 promotions_viewall_title' },
									_react2.default.createElement(
										'a',
										{ className: 'promo_view_all', href: this.state.offers.length > 0 ? "/offerszone" : "/promotional_offers" },
										'VIEW ALL'
									)
								)
							)
						)
					) : ""
				);
			}
		}]);
	
		return PromotionsNew;
	}(_react.Component);
	
	exports.default = PromotionsNew;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactRedux = __webpack_require__(15);
	
	var _redux = __webpack_require__(100);
	
	var _actions = __webpack_require__(22);
	
	var _reactWebVectorIcons = __webpack_require__(29);
	
	var _reactWebVectorIcons2 = _interopRequireDefault(_reactWebVectorIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var Recommended = function (_Component) {
		_inherits(Recommended, _Component);
	
		function Recommended(props) {
			_classCallCheck(this, Recommended);
	
			var _this = _possibleConstructorReturn(this, (Recommended.__proto__ || Object.getPrototypeOf(Recommended)).call(this, props));
	
			_this.state = {}, _this.state = {
				tot_data: [],
				product_offers: [],
				seed_offers: [],
				offers: [],
				recent: [],
				suggetions: [],
				pro_recommended: [],
				ad_assist_modal: false,
				ad_asst_confirm_modal: false,
				assist_data: [],
				queries: []
			};
			_this.getOffers = _this.getOffers.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.submitAdAssistData = _this.submitAdAssistData.bind(_this);
			return _this;
		}
	
		_createClass(Recommended, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.getOffers();
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.props.recommendedforyou();
				if (this.props.recommended.suggetions) {
					this.setState({
						suggetions: this.props.recommended.suggetions
					});
				}
			}
		}, {
			key: 'getOffers',
			value: function getOffers() {
				var data1 = { from: 'mobile_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'getOffers',
					success: function (data) {
						if (data.status === 'available') {
							this.setState({
								tot_data: data,
								product_offers: data.product_offers,
								seed_offers: data.seed_offers,
								offers: data.offers
							});
							setTimeout(function () {
								(0, _jquery2.default)('.promo_truck_img').show();
							}, 100);
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getAdAssistModal',
			value: function getAdAssistModal() {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('adassist_status', '1');
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', id: uid, pid: '', token: localStorage.getItem('token'), source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'checkaskExpert',
						success: function (data) {
							if (data.status === 'success' && data.proceed === 1) {
								this.setState({
									ad_assist_modal: !this.state.ad_assist_modal,
									assist_data: data,
									queries: data.queries
								});
								localStorage.removeItem('adassist_status');
							}
							if (data.status === 'success' && data.proceed === 0) {
								this.setState({
									ad_asst_confirm_modal: true,
									ad_asst_confirm_message: data.msg
								});
								localStorage.removeItem('adassist_status');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					ad_assist_modal: false,
					ad_asst_confirm_modal: false
				});
			}
		}, {
			key: 'setAdTime',
			value: function setAdTime(val) {
				this.setState({
					ad_asst_time: val,
					time_err_status: false,
					time_err_msg: ''
				});
			}
		}, {
			key: 'submitAdAssistData',
			value: function submitAdAssistData(event) {
				event.preventDefault();
				var error_flag = false;
				var q_id = (0, _jquery2.default)('#ad-sel-question').val();
				if (q_id == 1) {
					(0, _jquery2.default)('#ad-sel-question').css("color", "red");
					(0, _jquery2.default)('#ad-sel-question option').css("color", "#666");
					error_flag = true;
				} else {
					(0, _jquery2.default)('#ad-sel-question').css("color", "#666");
					(0, _jquery2.default)('#ad-sel-question option').css("color", "#666");
					error_flag = false;
				}
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var ad_time = this.state.ad_asst_time ? this.state.ad_asst_time : '0';
				if (ad_time == '0') {
					console.log("dv;slfjlkfr");
					error_flag = true;
					this.setState({
						time_err_status: true,
						time_err_msg: '* Required'
					});
				}
				console.log(error_flag);
				if (!error_flag) {
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.token, pid: '', time: ad_time, desc: '', source: source, campaign: campaign, url_id: url_id, selectedQue: q_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'askExpert',
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									ad_assist_modal: false,
									ad_asst_confirm_message: data.message,
									ad_asst_confirm_modal: true
								});
							} else {
								this.setState({
									ad_assist_modal: false
									// ad_asst_confirm_message:data.message,
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				(0, _jquery2.default)(document).off('change', '#ad-sel-question');
				(0, _jquery2.default)(document).on('change', '#ad-sel-question', function () {
					(0, _jquery2.default)('#ad-sel-question').css("color", "#666");
					(0, _jquery2.default)('#ad-sel-question option').css("color", "#666");
				});
	
				var params = {
					paginationClickable: true,
					spaceBetween: 10,
					slidesPerView: 1.8,
					parallax: true,
					parallaxEl: {
						el: '.parallax-bg',
						value: '-23%'
					},
					observer: true,
					rebuildOnUpdate: true
					// centeredSlides: true,
				};
				var recommended = this.props.recommended.suggetions;
				if (this.props.recommended.suggetions) {
	
					var pro_recommended = recommended.map(function (product, index) {
						return _react2.default.createElement(
							_reactRouter.Link,
							{ className: 'mob_rec_item', href: product.redirect_url },
							_react2.default.createElement(
								'div',
								{ className: 'mob_rec_product_ofer_icon' },
								_react2.default.createElement('img', { src: product.logo, alt: '' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'mob_rec_product_cntnt' },
								product.product ? _react2.default.createElement(
									'h5',
									{ className: 'mob_rec_product_title' },
									product.product
								) : _react2.default.createElement(
									'h5',
									null,
									'\xA0'
								),
								product.mrp ? _react2.default.createElement(
									'h6',
									{ className: 'mob_rec_product_desc' },
									'MRP \u20B9',
									product.mrp
								) : _react2.default.createElement(
									'h6',
									null,
									'\xA0'
								)
							)
						);
					});
				}
	
				var product_offers = this.state.product_offers.map(function (product, index) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ className: "new_promo_item promo_road_img2", to: "/pdetails/" + product.url_dtype_name + "/" + product.url_cat_name + "/" + product.url_brand_name + "/" + product.url_product_name + "/" + product.product_id + "/" + product.deal_id },
						_react2.default.createElement(
							'div',
							{ className: 'promo_swipe_img' },
							_react2.default.createElement(
								'div',
								{ className: 'raod_img' },
								' ',
								_react2.default.createElement('img', { className: 'img', src: 'https://aquadeals.in/admin/assets/images/web_imgs/road_0.png', alt: '', title: '' }),
								_react2.default.createElement(
									'span',
									{ className: 'promo_swipe_img_item' },
									_react2.default.createElement('img', { src: product.img === '' ? baseAssets + 'icons/web_icons/offer-icon.png' : product.img, alt: '' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'btm_swp' },
								product.title ? _react2.default.createElement(
									'h5',
									{ className: 'promo_gen_title' },
									product.title
								) : _react2.default.createElement(
									'h5',
									{ className: 'promo_gen_title' },
									'\xA0'
								),
								product.desc ? _react2.default.createElement(
									'h6',
									{ className: 'gen_desc' },
									product.desc
								) : _react2.default.createElement(
									'h6',
									{ className: 'gen_desc' },
									'\xA0'
								)
							)
						)
					);
				});
				var seed_offers = this.state.seed_offers.map(function (seed, index) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ className: "new_promo_item promo_road_img2", to: "/sdetails/" + seed.url_title + "/" + seed.deal_id },
						_react2.default.createElement(
							'div',
							{ className: 'promo_swipe_img' },
							_react2.default.createElement(
								'div',
								{ className: 'raod_img' },
								' ',
								_react2.default.createElement('img', { className: 'img', src: 'https://aquadeals.in/admin/assets/images/web_imgs/road_0.png', alt: '', title: '' }),
								_react2.default.createElement(
									'span',
									{ className: 'promo_swipe_img_item' },
									_react2.default.createElement('img', { src: seed.img === '' ? baseAssets + 'icons/web_icons/offer-icon.png' : seed.img, alt: '' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'btm_swp' },
								seed.title ? _react2.default.createElement(
									'h5',
									{ className: 'promo_gen_title' },
									seed.title
								) : _react2.default.createElement(
									'h5',
									{ className: 'promo_gen_title' },
									'\xA0'
								),
								seed.desc ? _react2.default.createElement(
									'h6',
									{ className: 'gen_desc' },
									seed.desc
								) : _react2.default.createElement(
									'h6',
									{ className: 'gen_desc' },
									'\xA0'
								)
							)
						)
					);
				});
				var offers = this.state.offers.map(function (offer, index) {
					return _react2.default.createElement(
						_reactRouter.Link,
						{ className: "new_promo_item promo_road_img2 promo_road_img_" + index, to: '/offer/' + offer.id + "/details" },
						_react2.default.createElement(
							'div',
							{ className: 'promo_swipe_img' },
							_react2.default.createElement(
								'div',
								{ className: 'raod_img' },
								' ',
								_react2.default.createElement('img', { className: 'img', src: 'https://aquadeals.in/admin/assets/images/web_imgs/road_0.png', alt: '', title: '' }),
								_react2.default.createElement(
									'span',
									{ className: 'promo_swipe_img_item' },
									_react2.default.createElement('img', { src: offer.img === '' ? baseAssets + 'icons/web_icons/offer-icon.png' : offer.img, alt: '' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'btm_swp' },
								offer.title ? _react2.default.createElement(
									'h5',
									{ className: 'promo_gen_title' },
									offer.title
								) : _react2.default.createElement(
									'h5',
									{ className: 'promo_gen_title' },
									'\xA0'
								),
								offer.desc ? _react2.default.createElement(
									'h6',
									{ className: 'gen_desc' },
									offer.desc
								) : _react2.default.createElement(
									'h6',
									{ className: 'gen_desc' },
									'\xA0'
								)
							)
						)
					);
				});
				(0, _jquery2.default)('body').css('background-color', '#fff');
	
				return _react2.default.createElement(
					'div',
					null,
					this.props.recommended.ad_assist_flag == 1 && this.props.isLoading ? _react2.default.createElement(
						'div',
						{ style: { backgroundColor: '#fff', marginTop: '10px', marginBottom: '10px', paddingTop: '10px', paddingBottom: '10px' }, className: 'mob_rec_block' },
						_react2.default.createElement(
							'h4',
							{ className: 'stores_title' },
							'AD ASSIST'
						),
						_react2.default.createElement('img', { src: baseAssets + "/icons/" + this.props.recommended.ad_assist_banner, alt: '', onClick: function onClick() {
								_this2.getAdAssistModal();
							} })
					) : '',
					this.props.recommended.suggetions != '' && this.props.isLoading ? _react2.default.createElement(
						'div',
						{ style: { backgroundColor: '#fff', marginTop: '10px', marginBottom: '10px', paddingTop: '10px', paddingBottom: '10px' }, className: 'mob_rec_block' },
						_react2.default.createElement(
							'h4',
							{ className: 'stores_title' },
							'RECOMMENDED FOR YOU'
						),
						_react2.default.createElement(
							_reactIdSwiper2.default,
							_extends({}, params, { key: this.state.suggetions }),
							pro_recommended
						)
					) : '',
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'ad_asst_modalbox', show: this.state.ad_assist_modal, onHide: this.close, id: 'ad_assist_home' },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'section',
								{ id: 'assets_cnt_block' },
								_react2.default.createElement(
									'span',
									{ onClick: this.close },
									_react2.default.createElement(_reactWebVectorIcons2.default, {
										name: 'close',
										font: 'SimpleLineIcons',
										color: '#fff',
										size: 16,
										style: { position: 'absolute', right: '10px', top: '8px' }
									})
								),
								_react2.default.createElement('img', { src: __webpack_require__(106), alt: '' }),
								_react2.default.createElement(
									'p',
									null,
									'Please submit the details, one of our experts will respond shortly.'
								),
								_react2.default.createElement(
									'div',
									{ className: 'aqua-txt-block' },
									_react2.default.createElement(
										'select',
										{ id: 'ad-sel-question' },
										this.state.queries.map(function (option) {
											return _react2.default.createElement(
												'option',
												{ key: option.id, value: option.id },
												option.question
											);
										})
									),
									_react2.default.createElement(
										'h6',
										null,
										'Best time to contact:  ',
										this.state.time_err_status ? _react2.default.createElement(
											'span',
											{ style: { color: 'red', fontSize: '10px' } },
											this.state.time_err_msg
										) : ''
									),
									_react2.default.createElement(
										'form',
										{ onSubmit: this.submitAdAssistData },
										_react2.default.createElement(
											'div',
											{ className: 'ad_asst_time_blk' },
											_react2.default.createElement(
												'span',
												{ className: this.state.ad_asst_time === 1 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time", onClick: function onClick() {
														_this2.setAdTime(1);
													} },
												'9am - 12pm'
											),
											_react2.default.createElement(
												'span',
												{ className: this.state.ad_asst_time === 2 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time", onClick: function onClick() {
														_this2.setAdTime(2);
													} },
												'12pm - 3pm'
											),
											_react2.default.createElement(
												'span',
												{ className: this.state.ad_asst_time === 3 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time", onClick: function onClick() {
														_this2.setAdTime(3);
													} },
												'3pm - 5pm'
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'ad_asst_submit_blk' },
											_react2.default.createElement(
												'button',
												{ type: 'submit' },
												'SCHEDULE CALL'
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'mob_reqbestprice', show: this.state.ad_asst_confirm_modal, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							this.state.ad_asst_confirm_message,
							_react2.default.createElement(
								'a',
								{ onClick: this.close, className: 'req_conf_ok_btn' },
								'OK'
							)
						)
					)
				);
			}
		}]);
	
		return Recommended;
	}(_react.Component);
	
	function mapStateToProps(state) {
		return {
			recommended: state.posts.recommended,
			isLoading: state.posts.isLoading
		};
	}
	
	function mapDispatchToProps(dispatch) {
		return {
			recommendedforyou: (0, _redux.bindActionCreators)(_actions.recommendedforyou, dispatch)
		};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Recommended);

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Product = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactShare = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var NaupliiDeals = function (_Component) {
		_inherits(NaupliiDeals, _Component);
	
		function NaupliiDeals(props) {
			_classCallCheck(this, NaupliiDeals);
	
			var _this = _possibleConstructorReturn(this, (NaupliiDeals.__proto__ || Object.getPrototypeOf(NaupliiDeals)).call(this, props));
	
			_this.state = {
				seedsList: [],
				offer: {},
				sort_status: true,
				sort: '1',
				img_price: 'price.png',
				coasts: [],
				coast: '0',
				nodata: false,
				img_data: 'Price',
				open: false,
				latitude: '',
				longitude: '',
				seed_type: _this.props.params.Stype,
				shareUrl: '',
				loading: false,
				web_title: '',
				web_desc: '',
				seo_title: '',
				seo_desc: '',
				cart_count: 0,
				seed_filters: [],
				sort_title: 'Sort By',
				sort_coast_title: 'Coasts',
				loading_gif: false
			};
			_this.getDeviceId = _this.getDeviceId.bind(_this);
			_this.getCartCount = _this.getCartCount.bind(_this);
	
			_this.getNearBy = _this.getNearBy.bind(_this);
			_this.getSort = _this.getSort.bind(_this);
			_this.getCoasts = _this.getCoasts.bind(_this);
			_this.getSelectedCoast = _this.getSelectedCoast.bind(_this);
			_this.getSeedFilters = _this.getSeedFilters.bind(_this);
			return _this;
		}
	
		_createClass(NaupliiDeals, [{
			key: 'getNearBy',
			value: function getNearBy() {
				this.setState({
					loading_gif: true
				});
				var data1 = { from: 'mobile_web', lat: this.state.latitude, long: this.state.longitude, sort: this.state.sort, species: '0', deal_type: '8' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdeals',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.data.length === 0) {
							this.setState({
								nodata: true,
								loading_gif: false
							});
						} else {
							this.setState({
								nodata: false,
								seedsList: data.data,
								offer: data,
								web_title: data.title,
								web_desc: data.desc,
								loading_gif: false
							});
	
							// document.title =this.state.web_title +  " - Deals | AquaDeals ";
							// document.title ="Nauplii - Deals | AquaDeals ";
							// document.getElementsByTagName("META")[2].content=this.state.seo_desc;
						}
					}.bind(this),
					error: function error(err) {
						// console.log("Location Error: "+ err);
					}
				});
			}
		}, {
			key: 'getCoasts',
			value: function getCoasts() {
				var data1 = { from: 'mobile_web', species: '0', deal_type: '8' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'coasts',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							coasts: data.coasts
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'getCartCount',
			value: function getCartCount() {
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						console.log(data);
						this.setState({
							cart_count: data.cart_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getDeviceId',
			value: function getDeviceId() {
				if (localStorage.user_id) {
					var user_id = localStorage.user_id;
				} else {
					user_id = 0;
				}
				var data1 = { from: 'mobile_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getDeviceId',
					dataType: 'json',
					data: { req: data2 },
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					window.location.href = "/web/nauplii/nauplii/8";
				}
				this.getDeviceId();
				if (localStorage.user_id && localStorage.token) {
					this.getCartCount();
				}
				this.getSeedFilters();
				this.getCoasts();
				var data1 = { from: 'mobile_web', sort: '1', coast: '0', species: '0', deal_type: '8' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdeals',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							seedsList: data.data,
							offer: data,
							web_title: data.title,
							web_desc: data.desc,
							loading: true,
							seo_title: 'Nauplii deals from Hatcheries | AquaDeals',
							seo_desc: 'Browse quality Nauplii deals from CAA approved Hatcheries, shop online and avail free shipment.'
						});
						// document.title =this.state.web_title+  " - Deals | AquaDeals | "+this.state.seo_desc;
						document.title = this.state.seo_title;
						document.getElementsByTagName("META")[2].content = this.state.seo_desc;
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'getSort',
			value: function getSort(id, type) {
				this.setState({
					loading_gif: true
				});
				localStorage.setItem('sort', this.state.sort);
				var data1 = { from: 'mobile_web', sort: this.state.sort, coast: this.state.coast, species: '0', deal_type: '8' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdeals',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (this.state.sort === 1) {
							var ss = 2;
							var img_price = 'down.png';
							var img_data = 'High - Low';
						} else {
							ss = 1;
							img_price = 'up.png';
							img_data = 'Low - High';
						}
						this.setState({
							sort: ss,
							img_price: img_price,
							img_data: img_data,
							seedsList: data.data,
							offer: data,
							sort_title: type,
							loading_gif: false
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'getSelectedCoast',
			value: function getSelectedCoast(c, type) {
				this.setState({
					loading_gif: true
				});
				if (this.state.sort === 1) {
					this.setState({
						sort: '2'
					});
				} else {
					this.setState({
						sort: '1'
					});
				}
				this.setState({
					coast: c
				});
				var data1 = { from: 'mobile_web', coast: c, sort: localStorage.sort, species: '0', deal_type: '8' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdeals',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.data.length === 0) {
							this.setState({
								nodata: true,
								loading_gif: false
							});
						} else {
							this.setState({
								nodata: false
							});
						}
						this.setState({
							seedsList: data.data,
							offer: data,
							sort_coast_title: type,
							loading_gif: false
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'getSeedFilters',
			value: function getSeedFilters() {
				var data1 = { from: 'mobile_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'seedFilters',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							seed_filters: data.sort
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var products = this.state.seedsList.map(function (product, index) {
					return _react2.default.createElement(Product, { key: product.deals_data.id, data: product, onUpdate: function onUpdate() {
							return _this2.getCartCount();
						} });
				});
	
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals' },
					this.state.loading ? _react2.default.createElement(
						'div',
						{ className: 'seed_list_page mob_seedlist_page' },
						_react2.default.createElement(
							'div',
							{ className: 'page_hdr' },
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: "/" },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
										)
									),
									' Nauplii'
								),
								_react2.default.createElement(
									'a',
									{ href: '/', className: 'home_logo1' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
								),
								_react2.default.createElement(
									'a',
									{ className: 'mob_cart_btn', href: '/mycart' },
									_react2.default.createElement('img', { alt: '', src: baseAssets + 'icons/web_icons/cart_icon.png' }),
									this.state.cart_count > 0 ? _react2.default.createElement(
										'span',
										{ className: this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count" },
										this.state.cart_count
									) : ''
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'pag_cntnt' },
							'\xA0'
						),
						this.state.loading_gif ? _react2.default.createElement(
							'i',
							{ className: 'loading_gif' },
							_react2.default.createElement('img', { src: baseAssets + 'images/loading_more.gif', alt: 'Loading' })
						) : '',
						_react2.default.createElement(
							'section',
							{ className: '' },
							this.state.nodata ? _react2.default.createElement(
								'div',
								{ className: 'no_data' },
								_react2.default.createElement(
									'h3',
									null,
									'No Deals Available'
								),
								_react2.default.createElement(
									'p',
									null,
									'Need something here? ',
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: "/customer_care" },
										'CONTACT US'
									),
									' Now !'
								)
							) : products.length > 0 ? products : _react2.default.createElement(
								'div',
								{ className: 'no_data' },
								_react2.default.createElement(
									'h3',
									null,
									'No Deals Available'
								),
								_react2.default.createElement(
									'p',
									null,
									'Need something here? ',
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: '/customer_care' },
										'CONTACT US'
									),
									' Now !'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							)
						),
						_react2.default.createElement(
							'section',
							{ className: 'seed_sort' },
							_react2.default.createElement(
								'ul',
								null,
								_react2.default.createElement(
									'li',
									{ className: 'col-md-4 col-xs-4 col-sm-4 coast_list ', style: { cursor: 'pointer' } },
									_react2.default.createElement(
										_reactBootstrap.ButtonToolbar,
										null,
										_react2.default.createElement(
											_reactBootstrap.DropdownButton,
											{ className: 'test_filter_4', noCaret: true, title: this.state.sort_title, dropup: true },
											_react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ header: true },
												'Sort By'
											),
											this.state.seed_filters.map(function (seed, index) {
												return _react2.default.createElement(
													_reactBootstrap.MenuItem,
													{ className: 'seed_list', eventKey: seed.id, onClick: function onClick() {
															return _this2.getSort(seed.id, seed.type);
														} },
													seed.type
												);
											})
										)
									)
								),
								_react2.default.createElement(
									'li',
									{ className: 'col-md-4 col-xs-4 col-sm-4', style: { cursor: 'pointer' } },
									_react2.default.createElement(
										'a',
										{ onClick: this.getNearBy, title: '' },
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/nearby.png', alt: 'nearby', style: { marginTop: '4px' } }),
										' ',
										_react2.default.createElement(
											'span',
											null,
											'Nearby'
										)
									)
								),
								_react2.default.createElement(
									'li',
									{ className: 'col-md-4 col-xs-4 col-sm-4 coast_list ', style: { cursor: 'pointer' } },
									_react2.default.createElement(
										_reactBootstrap.ButtonToolbar,
										null,
										_react2.default.createElement(
											_reactBootstrap.DropdownButton,
											{ className: 'filter_coast', noCaret: true, title: this.state.sort_coast_title, dropup: true },
											_react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ header: true },
												'Coasts : ',
												this.state.coasts.length,
												' '
											),
											this.state.coasts.map(function (coast, index) {
												return _react2.default.createElement(
													_reactBootstrap.MenuItem,
													{ className: 'seed_list', eventKey: coast.id, onClick: function onClick() {
															return _this2.getSelectedCoast(coast.id, coast.coast);
														} },
													coast.coast
												);
											})
										)
									)
								)
							)
						)
					) : _react2.default.createElement(
						'div',
						{ className: 'loading_sym' },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/loading.gif', alt: 'Loading', role: 'presentation' }),
						' '
					)
				);
			}
		}]);
	
		return NaupliiDeals;
	}(_react.Component);
	
	exports.default = NaupliiDeals;
	
	var Product = exports.Product = function (_Component2) {
		_inherits(Product, _Component2);
	
		function Product() {
			_classCallCheck(this, Product);
	
			var _this3 = _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).call(this));
	
			_this3.state = {
				open: false,
				shareUrl: '',
				msg: '',
				cart_count: '',
				clearcart_status: false,
				already_added_status: false
			};
			_this3.ShareFunc = _this3.ShareFunc.bind(_this3);
			_this3.addToCart = _this3.addToCart.bind(_this3);
			_this3.updateCartCount = _this3.updateCartCount.bind(_this3);
			_this3.close = _this3.close.bind(_this3);
			_this3.replaceCartItems = _this3.replaceCartItems.bind(_this3);
			_this3.addToQuickCart = _this3.addToQuickCart.bind(_this3);
	
			return _this3;
		}
	
		_createClass(Product, [{
			key: 'ShareFunc',
			value: function ShareFunc(evnt) {
				var _this4 = this;
	
				var data1 = { from: 'mobile_web', type: 0, did: evnt };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'createTinyurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							msg: data.msg,
							shareUrl: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
				this.setState({
					open: !this.state.open
				});
				setTimeout(function () {
					_this4.setState({ open: false });
				}, 5000);
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					clearcart_status: false,
					already_added_status: false
				});
			}
		}, {
			key: 'replaceCartItems',
			value: function replaceCartItems(deal_id, quantity) {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 0, quantity: quantity, pl_size: 0, salinity: 0, pickup_date: 0, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'replaceCart',
					data: { req: data2 },
					success: function (data) {
						console.log(data);
						if (data.status === "success") {
							this.setState({
								clearcart_status: false
							});
							_reactRouter.browserHistory.push('/mycart');
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'updateCartCount',
			value: function updateCartCount() {
				this.props.onUpdate();
			}
		}, {
			key: 'addToCart',
			value: function addToCart(deal_id) {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('nauplii', '/nauplii');
					_reactRouter.browserHistory.push('/login');
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 0, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'quickBuy',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success") {
							this.updateCartCount();
							_reactRouter.browserHistory.push('/mycart');
						} else if (data.status === "error" && data.cart_flag === 0) {
							this.setState({
								clearcart_status: true
							});
						} else if (data.status === "error" && data.message === "Product already added to the cart") {
							this.setState({
								already_added_status: true
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'addToQuickCart',
			value: function addToQuickCart(deal_id) {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('nauplii', '/nauplii');
					_reactRouter.browserHistory.push('/login');
				} else {
					var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 0, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'post',
						dataType: 'json',
						url: baseUrl + 'addToQCart',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.updateCartCount();
								_reactRouter.browserHistory.push('/quickcart');
							} else if (data.status === "error" && data.cart_flag === 0) {
								this.setState({
									clearcart_status: true
								});
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var mydata = this.props.data;
				// var shareUrl = 'http://203.193.173.125:3003/seed_details/'+mydata.deals_data.id;
				var shareUrl = this.state.shareUrl;
				var title = "Hey Click here " + shareUrl + " to check " + mydata.deals_data.sname + " from AquaDeals.";
				var description = shareUrl;
				// var title = this.state.msg;
				var no_data = '';
				if (mydata.length === 0) {
					no_data = _react2.default.createElement(
						'div',
						{ className: 'no_data' },
						_react2.default.createElement(
							'h3',
							null,
							'No Deals Available'
						),
						_react2.default.createElement(
							'p',
							null,
							'Need something here? ',
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: "/customer_care" },
								'CONTACT US'
							),
							' Now !'
						)
					);
				} else {
					no_data = "";
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'list_card seedlist_card' },
					no_data,
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: "/sdetails/" + mydata.deals_data.sname + "/" + mydata.deals_data.id },
						_react2.default.createElement(
							'div',
							{ className: 'list_img' },
							_react2.default.createElement('img', { src: baseAssets + 'images/seller_imgs/thumbnails/' + mydata.deals_data.image, alt: 'AquaDeals', role: 'presentation' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'list_txt' },
							_react2.default.createElement(
								'h4',
								{ style: { color: '#333' } },
								mydata.deals_data.sname
							),
							mydata.deals_data.discount_price > 0 ? _react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									'span',
									{ style: { color: '#333' } },
									'\u20B9 '
								),
								mydata.offer,
								' off on 1M'
							) : '',
							mydata.deals_data.price ? _react2.default.createElement(
								'p',
								null,
								_react2.default.createElement('span', null),
								_react2.default.createElement(
									'span',
									{ style: { color: '#333' } },
									'\u20B9 '
								),
								_react2.default.createElement(
									'span',
									{ style: { color: '#666' } },
									mydata.deals_data.price
								)
							) : '',
							mydata.deals_data.rate >= 1 ? _react2.default.createElement(
								'h6',
								null,
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/star_filled.png', width: '16px', role: 'presentation' })
								),
								mydata.deals_data.rate
							) : _react2.default.createElement(
								'h6',
								null,
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/star_gray.png', width: '16px', role: 'presentation' })
								)
							)
						)
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ className: 'share_list', onClick: function onClick() {
								_this5.ShareFunc(mydata.deals_data.id);
							} },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/share1.png', alt: 'share' })
					),
					mydata.view_status > 0 ? _react2.default.createElement(
						'h6',
						{ className: 'views_eye' },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', width: '17px', role: 'presentation' }),
						' ',
						mydata.view_status,
						' ',
						mydata.view_status > 1 ? 'Views' : 'View'
					) : '',
					_react2.default.createElement(
						'a',
						{ className: 'seed_quick_buy_img', onClick: function onClick() {
								return _this5.addToQuickCart(mydata.deals_data.id);
							} },
						_react2.default.createElement('img', { src: baseAssets + "images/icons/quick_buy.png", alt: ' ', width: '50px' })
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_reactBootstrap.Panel,
							{ className: 'share_panel', collapsible: true, expanded: this.state.open },
							_react2.default.createElement(
								FacebookShareButton,
								{ url: shareUrl, quote: title, className: 'test_share' },
								_react2.default.createElement(FacebookIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								TwitterShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share' },
								_react2.default.createElement(TwitterIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								GooglePlusShareButton,
								{ url: shareUrl, quote: title, descirption: description, className: 'test_share' },
								_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.clearcart_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#333' } },
								'You can\'t have multiple seller items in the cart. Empty existing cart & add this item ',
								mydata.deals_data.sname,
								'?'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'NO'
							),
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: function onClick() {
											_this5.replaceCartItems(mydata.deals_data.id, mydata.deals_data.min_allowed_qty);
										} },
									'YES'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.already_added_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#333' } },
								'Product already added to the cart'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'OK'
							)
						)
					)
				);
			}
		}]);
	
		return Product;
	}(_react.Component);

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ProductDetails = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactSwipe = __webpack_require__(125);
	
	var _reactSwipe2 = _interopRequireDefault(_reactSwipe);
	
	var _NotFound = __webpack_require__(84);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactShare = __webpack_require__(18);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Geosuggest from 'react-geosuggest';
	
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var SeedDetails = function (_Component) {
		_inherits(SeedDetails, _Component);
	
		function SeedDetails(props) {
			_classCallCheck(this, SeedDetails);
	
			var _this = _possibleConstructorReturn(this, (SeedDetails.__proto__ || Object.getPrototypeOf(SeedDetails)).call(this, props));
	
			_this.state = {
				id: _this.props.params.Id,
				seedDetails: [],
				deal_options: '',
				details: '',
				offers_details: '',
				test: [],
				s: [],
				hatchary_details: [],
				rate: '',
				res_img: '',
				seller_id: '',
				deal_id: '',
				open: false,
				showModal: false,
				loading: false,
				reqbestPrice: false,
				sname: '',
				session: localStorage.getItem('token'),
				data_status: false,
				coupons: [],
				views_count: '',
				recomends: '',
				seo_title: '',
				seo_desc: '',
				coupon_first: [],
				cpns_list: '',
	
				min_allowed_qty: '',
				min_allowed_qty1: '',
				available_qty: '',
				plsize: 0,
				plsizes: [],
				salinities: [],
				millions: '',
				min_allowed_qty_status: false,
				salinity: 0,
				seeddates: '',
				start_date: '',
				end_date: '',
				addtocart_msg: '',
				is_cart: 0,
				clearcart_status: false,
				addtocart_status: false,
				updatecart_status: false,
				sp_name: '',
				active_date: '',
				date_status: false,
				err_date: '',
				err_date_status: false,
	
				free_ship_msg: '',
				user_zipcode: '',
				free_shipment: '',
	
				err_pincode: false,
				err_pincode_msg: '',
	
				product_existed: false,
				emi_opt_desc: '',
				emi_opt_sts: 0,
	
				err_qty_status: false, //checking the status of quantity 
				err_qty_status_1: false, // checking the if the qty is high and setting it to max
				err_qty_msg: '',
	
				req_confirm_modal: false,
				req_confirm_message: '',
				req_pincode: '',
				req_quantity: '',
				req_state: '',
				req_city: '',
				req_doorno: '',
				wishLst_flag: '',
				page_loading: false,
				shareUrl: '',
				cart_date: '',
				cart_date_active: '',
				cart_qty: '',
				cart_salinity: 0,
				cart_pl_size: 0,
				date_flag: false
			};
			_this.scroll = _this.scroll.bind(_this);
			_this.modalOpen = _this.modalOpen.bind(_this);
			_this.close = _this.close.bind(_this);
			localStorage.setItem('seed_id', _this.props.params.Id);
			_this.getDeviceId = _this.getDeviceId.bind(_this);
	
			_this.decrementMinQty = _this.decrementMinQty.bind(_this);
			_this.updateMinQty = _this.updateMinQty.bind(_this);
			_this.incrementMinQty = _this.incrementMinQty.bind(_this);
			_this.plsizeChange = _this.plsizeChange.bind(_this);
			_this.salinityChange = _this.salinityChange.bind(_this);
			_this.DealPlSalinity = _this.DealPlSalinity.bind(_this);
			_this.getDates = _this.getDates.bind(_this);
			_this.placeOrderModal = _this.placeOrderModal.bind(_this);
			_this.removeCartItems = _this.removeCartItems.bind(_this);
			_this.changeDate = _this.changeDate.bind(_this);
	
			_this.checkPincode = _this.checkPincode.bind(_this);
			_this.pincodeChange = _this.pincodeChange.bind(_this);
	
			_this.req_pincodeChange = _this.req_pincodeChange.bind(_this);
			_this.req_quantityChange = _this.req_quantityChange.bind(_this);
			_this.req_stateChange = _this.req_stateChange.bind(_this);
			_this.req_cityChange = _this.req_cityChange.bind(_this);
			_this.req_doornoChange = _this.req_doornoChange.bind(_this);
			_this.reqBestPriceSubmit = _this.reqBestPriceSubmit.bind(_this);
			_this.checkBestPrice = _this.checkBestPrice.bind(_this);
			_this.addToWishlist = _this.addToWishlist.bind(_this);
			_this.ShareFunc = _this.ShareFunc.bind(_this);
			_this.addToWishlistOnload = _this.addToWishlistOnload.bind(_this);
	
			// this.onSuggestSelect=this.onSuggestSelect.bind(this);
			_this.addtocartOnload = _this.addtocartOnload.bind(_this);
			_this.checkBestPriceOnload = _this.checkBestPriceOnload.bind(_this);
			return _this;
		}
		// onSuggestSelect(e)
		// {
		// 	this.setState({
		//       req_city: e.label,
		//     });
		// }
	
	
		_createClass(SeedDetails, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					window.location.href = "/web/sdetails/" + this.props.params.BrandName + "/" + this.props.params.Id;
				}
				this.DealPlSalinity();
				localStorage.setItem('m_r_s_dt', '/sdetails/' + this.props.params.BrandName + "/" + this.props.params.Id);
				localStorage.removeItem('m_r_p_dt');
				this.scroll();
				this.getDeviceId();
				// if(!localStorage.token && !localStorage.user_id)
				// {
				// 	localStorage.setItem('m_r_s_dt','/sdetails/'+this.props.params.BrandName+"/"+this.props.params.Id)
				// 	browserHistory.push('/login');
				// }
				// else
				// {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
	
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: this.props.params.Id, uid: uid, token: localStorage.token, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdealsdetails',
					dataType: 'json',
					data: { req: data2 },
					success: function (response) {
						if (response.status === "error") {
							this.setState({
								data_status: true
							});
							window.location.href = response.redirect;
						}
						if (response.message === "Token mismatch") {
							localStorage.removeItem('token');
							localStorage.removeItem('user_id');
							_reactRouter.browserHistory.push('/login');
						}
						var s = _jquery2.default.makeArray(response.offers_details);
						var h = _jquery2.default.makeArray(response.hatchary_details);
						var d_opt = _jquery2.default.makeArray(response.deal_options);
						this.setState({
							loading: true,
							seller_id: response.data[0]['deals_data']['seller_id'],
							deal_id: response.data[0]['deals_data']['id'],
							sp_name: response.data[0]['deals_data']['sname'],
							seedDetails: response.data,
							details: response,
							test: s[0],
							views_count: response.views_count,
							recomends: response.recomends,
							t: response.data[0],
							hatchary_details: h[0],
							coupon_first: response.coupons[0],
							rate: response.data[0]['deals_data']['rate'],
							res_img: response.imgs,
							coupons: response.coupons,
							cpns_list: response.cpns_list,
	
							min_allowed_qty: response.data[0]['deals_data']['min_allowed_qty'],
							min_allowed_qty1: response.data[0]['deals_data']['min_allowed_qty'],
							available_qty: response.data[0]['deals_data']['available_qty'],
							millions: parseFloat(response.data[0]['deals_data']['min_allowed_qty']) / 1000000,
							start_date: response.start_date,
							end_date: response.end_date,
							is_cart: response.is_cart,
							free_ship_msg: response.free_ship_msg,
							user_zipcode: response.user_zipcode,
							free_shipment: response.free_shipment,
	
							emi_opt_desc: response.emi_opt_desc,
							emi_opt_sts: response.emi_opt_sts,
							seo_title: h[0]['org_name'] + ' Aqua Seed Deals',
							seo_desc: 'Buy quality ' + response.data[0]['deals_data']['sname'] + ' Aquaculture seed from CAA approved ' + h[0]['org_name'] + ' and avail free shipment',
							wishLst_flag: response.wishLst_flag,
							cart_date: response.cart_date,
							cart_salinity: response.cart_salinity,
							cart_pl_size: response.cart_pl_size
						});
	
						if (response.cart_qty !== 0) {
							this.setState({
								min_allowed_qty: response.cart_qty
							});
						}
						if (response.cart_date !== '') {
							this.setState({
								date_flag: true
								// active_date:response.cart_date,
							});
						}
						if (response.cart_pl_size !== 0) {
							this.setState({
								plsize: response.cart_pl_size
							});
						}
						if (response.cart_salinity !== 0) {
							this.setState({
								salinity: response.cart_salinity
							});
						}
						if (response.data[0]['deals_data']['sname'] === null) {
							this.setState({
								seo_desc: 'Buy quality ' + response.data[0]['deals_data']['oname'] + ' Aquaculture seed from CAA approved ' + h[0]['org_name'] + ' and avail free shipment'
							});
						}
						if (d_opt.length > 0) {
							this.setState({
								deal_options: d_opt[0]
							});
						}
						if (response.is_cart === 1) {
							this.setState({
								addtocart_msg: 'GO TO CART',
								is_cart: response.is_cart
							});
						} else {
							this.setState({
								addtocart_msg: 'ADD TO CART',
								is_cart: response.is_cart
							});
						}
						document.title = this.state.seo_title;
						document.getElementsByTagName("META")[2].content = this.state.seo_desc;
						this.getDates();
	
						if (localStorage.user_id && localStorage.token && localStorage.mob_seedaddtocart) {
							this.addtocartOnload();
						}
						if (localStorage.user_id && localStorage.token && localStorage.mob_seed_checkbestprice) {
							this.checkBestPriceOnload();
						}
						if (localStorage.user_id && localStorage.token && localStorage.addtowishlist_onload) {
							this.addToWishlistOnload();
						}
					}.bind(this),
					error: function error(err) {}
				});
				// }
			}
		}, {
			key: 'ShareFunc',
			value: function ShareFunc(evnt) {
				var _this2 = this;
	
				var data1 = { from: 'mobile_web', type: 0, did: evnt };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'createTinyurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							msg: data.msg,
							shareUrl: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
				this.setState({
					open: !this.state.open
				});
				setTimeout(function () {
					_this2.setState({ open: false });
				}, 10000);
			}
		}, {
			key: 'reqBestPriceSubmit',
			value: function reqBestPriceSubmit(event) {
				event.preventDefault();
				var quantity = this.refs.req_quantity.value;
				var state = this.refs.req_state.value;
				var city = this.refs.req_city.value;
				var doorno = this.refs.req_doorno.value;
				var pincode = this.refs.req_pincode.value;
	
				var flag = 0;
				var namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
	
				if (quantity === '' && quantity.length < 1) {
					(0, _jquery2.default)('#req_quantity_err').text('* enter quantity');
					flag = 1;
				}
				if (state === '' && !namePattern.test(state) && state.length < 2) {
					(0, _jquery2.default)('#req_state_err').text('* enter state');
					flag = 1;
				}
				if (state !== '' && state.length < 2 && !namePattern.test(state)) {
					(0, _jquery2.default)('#req_state_err').text('* enter valid state');
					flag = 1;
				}
				if (city === '' && !namePattern.test(city)) {
					(0, _jquery2.default)('#req_city_err').text('* enter city');
					flag = 1;
				}
				if (city !== '' && city.length < 3) {
					(0, _jquery2.default)('#req_city_err').text('* enter city');
					flag = 1;
				}
				if (doorno === '' && doorno.length <= 1) {
					(0, _jquery2.default)('#req_doorno_err').text('* enter address');
					flag = 1;
				}
				if (doorno !== '' && doorno.length <= 1) {
					(0, _jquery2.default)('#req_doorno_err').text('* enter address');
					flag = 1;
				}
				if (pincode === '' && pincode.length < 6) {
					(0, _jquery2.default)('#req_pincode_err').text('* enter valid pincode');
					flag = 1;
				}
				if (pincode !== '' && pincode.length < 6) {
					(0, _jquery2.default)('#req_pincode_err').text('* enter valid pincode');
					flag = 1;
				}
				if (quantity !== '' && quantity < parseInt(this.state.min_allowed_qty1, 10)) {
					(0, _jquery2.default)('#req_quantity_err').text('* minimum quantity is ' + this.state.min_allowed_qty1);
					flag = 1;
				}
				if (quantity > parseInt(this.state.available_qty, 10)) {
					(0, _jquery2.default)('#req_quantity_err').text('* maximum quantity is ' + this.state.available_qty);
					flag = 1;
				}
	
				if (flag === 0) {
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					// saveBestpriceLead(id,did,dtype,req_qty,address,req_loc,city(selected text value),state(selected text value))
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.token, did: this.props.params.Id, dtype: '0', req_qty: this.state.req_quantity, state: this.state.req_state, city: this.state.req_city, address: this.state.req_doorno, req_loc: this.state.req_pincode, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'saveBestpriceLead',
						success: function (data) {
							if (data.status === 'success') {
								this.setState({
									reqbestPrice: false,
									req_confirm_modal: true,
									req_confirm_message: data.message
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'req_quantityChange',
			value: function req_quantityChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						req_quantity: x
					});
				}
			}
		}, {
			key: 'req_doornoChange',
			value: function req_doornoChange(event) {
				this.setState({
					req_doorno: event.target.value
				});
			}
		}, {
			key: 'req_cityChange',
			value: function req_cityChange(event) {
				// this.setState({
				// 	req_city:event.target.value,
				// });
				var x = event.target.value;
				var namePattern = /^[a-z A-Z]+$/;
				if (!namePattern.test(event.target.value) && x !== '') {
					x = event.target.value.replace(namePattern, "");
				} else {
					this.setState({
						req_city: event.target.value
					});
				}
			}
		}, {
			key: 'req_stateChange',
			value: function req_stateChange(event) {
				var x = event.target.value;
				var namePattern = /^[a-z A-Z]+$/;
				if (!namePattern.test(event.target.value) && x !== '') {
					x = event.target.value.replace(namePattern, "");
				} else {
					this.setState({
						req_state: event.target.value
					});
				}
			}
		}, {
			key: 'req_pincodeChange',
			value: function req_pincodeChange(event) {
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						req_pincode: x
					});
				}
			}
		}, {
			key: 'checkBestPriceOnload',
			value: function checkBestPriceOnload() {
				if (!localStorage.user_id && !localStorage.token) {
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
	
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					var baseUrl = 'https://aquadeals.in/admin/web3/user/';
					var data1 = { from: 'mobile_web', did: this.props.params.Id, id: uid, dtype: 0, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'checkBestPriceLead',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success' && data.proceed === 1) {
								this.setState({
									reqbestPrice: true
								});
								localStorage.removeItem('mob_seed_checkbestprice');
							} else if (data.status === 'success' && data.proceed === 0) {
								// alert(data.msg);
								this.setState({
									req_confirm_modal: true,
									req_confirm_message: data.msg
								});
								localStorage.removeItem('mob_seed_checkbestprice');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'checkBestPrice',
			value: function checkBestPrice() {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('mob_seed_checkbestprice', '1');
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.getItem('user_id');
					} else {
						uid = 0;
					}
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
	
					var data1 = { from: 'mobile_web', did: this.props.params.Id, id: uid, dtype: 0, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						url: baseUrl + 'checkBestPriceLead',
						data: { req: data2 },
						success: function (data) {
							if (data.status === 'success' && data.proceed === 1) {
								this.setState({
									reqbestPrice: true
								});
								localStorage.removeItem('mob_seed_checkbestprice');
							} else if (data.status === 'success' && data.proceed === 0) {
								// alert(data.msg);
								this.setState({
									req_confirm_modal: true,
									req_confirm_message: data.msg
								});
								localStorage.removeItem('mob_seed_checkbestprice');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'checkPincode',
			value: function checkPincode() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (this.refs.pincode.value.length === 6) {
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.token, type: 0, did: this.props.params.Id, zip: this.refs.pincode.value, device_id: localStorage.getItem('push_device_id'), source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						url: baseUrl + 'checkFreeshipment',
						dataType: 'json',
						data: { req: data2 },
						success: function (data) {
							this.setState({
								free_ship_msg: data.msg
							});
						}.bind(this),
						error: function error(err) {}
					});
				} else {
					this.setState({
						err_pincode: true,
						// err_pincode_msg:'* Invalid pincode',
						free_ship_msg: 'Invalid Pincode'
					});
				}
			}
		}, {
			key: 'pincodeChange',
			value: function pincodeChange() {
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(this.refs.pincode.value)) {
					var x = this.refs.pincode.value.replace(invalidChars, "");
				} else {
					this.setState({
						err_pincode: true
					});
				}
				this.setState({
					user_zipcode: x,
					err_pincode: false
				});
			}
		}, {
			key: 'placeOrderModal',
			value: function placeOrderModal() {
				if (this.state.addtocart_msg === "GO TO CART") {
					_reactRouter.browserHistory.push('/mycart');
				}
				if (!localStorage.user_id && !localStorage.token) {
					if (this.state.date_flag === true) {
						this.setState({
							err_date: '',
							err_date_status: false
						});
						localStorage.setItem('mob_seedaddtocart', '1');
						localStorage.setItem('mob_seed_addtocart_qty', this.state.min_allowed_qty);
						localStorage.setItem('mob_seed_addtocart_pick_date', this.state.active_date);
						localStorage.setItem('mob_seed_addtocart_salinity', this.state.salinity);
						localStorage.setItem('mob_seed_addtocart_plsize', this.state.plsize);
						_reactRouter.browserHistory.push('/login');
					} else {
						this.setState({
							err_date: '* Please Select Pickup Date',
							err_date_status: true
						});
						alert('* Please Select Pickup Date');
					}
				} else {
					if (this.state.date_flag === true) {
						this.setState({
							err_date: '',
							err_date_status: false
						});
					} else {
						this.setState({
							err_date: '* Please Select Pickup Date',
							err_date_status: true
						});
						alert('* Please Select Pickup Date');
					}
					if (this.state.date_flag === true) {
						if (this.state.addtocart_msg === "ADD TO CART" || this.state.addtocart_msg === "UPDATE CART") {
							var quantity = '';
	
							if (this.refs.input_minqty.value < parseInt(this.state.min_allowed_qty1, 10) || this.refs.input_minqty.value === "NaN") {
								this.setState({
									err_qty_status_1: true,
									err_qty_msg: "* Minimum Quantity is " + this.state.min_allowed_qty1,
									min_allowed_qty: this.state.min_allowed_qty1,
									millions: parseInt(this.state.min_allowed_qty1, 10) / 1000000
								});
								quantity = this.state.min_allowed_qty1;
							} else if (this.refs.input_minqty.value === '') {
								this.setState({
									min_allowed_qty: this.state.available_qty,
									millions: parseInt(this.state.available_qty, 10) / 1000000,
									err_qty_status_1: true,
									err_qty_msg: "* Minimum Quantity is " + this.state.min_allowed_qty1
								});
							} else if (this.refs.input_minqty.value > parseInt(this.state.available_qty, 10)) {
								this.setState({
									min_allowed_qty: this.state.available_qty,
									millions: parseInt(this.state.available_qty, 10) / 1000000,
									err_qty_status_1: true,
									err_qty_msg: '* Maximum quantity is ' + this.state.available_qty
								});
							} else {
								this.setState({
									err_qty_status_1: false,
									err_qty_msg: ''
								});
								quantity = this.refs.input_minqty.value;
							}
							if (this.refs.input_minqty.value >= this.state.min_allowed_qty1 && this.refs.input_minqty.value !== "NaN") {
								if (this.state.plsize === 0) {
									var seed_plsize = 'PLSIZE';
								} else {
									seed_plsize = this.state.plsize;
								}
								if (this.state.salinity === 0) {
									var seed_salinity = 'SALINITY';
								} else {
									seed_salinity = this.state.salinity;
								}
								if (localStorage.user_id) {
									var uid = localStorage.getItem('user_id');
								} else {
									uid = 0;
								}
								if (this.state.active_date === '') {
									var pickup_date = this.state.cart_date_active;
								} else {
									pickup_date = this.state.active_date;
								}
	
								if (localStorage.source) {
									var source = localStorage.getItem('source');
								} else {
									source = '';
								}
								if (localStorage.campaign) {
									var campaign = localStorage.getItem('campaign');
								} else {
									campaign = '';
								}
								if (localStorage.url_id) {
									var url_id = localStorage.getItem('url_id');
								} else {
									url_id = '';
								}
								var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token'), deal_id: this.props.params.Id, deal_type: 0, quantity: quantity, pl_size: seed_plsize, salinity: seed_salinity, pickup_date: pickup_date, source: source, campaign: campaign, url_id: url_id };
								var data2 = JSON.stringify(data1);
								_jquery2.default.ajax({
									method: 'post',
									dataType: 'json',
									url: baseUrl + 'addToCart',
									data: { req: data2 },
									success: function (data) {
										if (data.status === "success" && data.message === "Added to cart") {
											this.setState({
												addtocart_msg: 'GO TO CART',
												addtocart_status: true,
												is_cart: 1
											});
											localStorage.removeItem('mob_seedaddtocart');
											localStorage.removeItem('mob_seed_addtocart_qty');
											localStorage.removeItem('mob_seed_addtocart_pick_date');
											localStorage.removeItem('mob_seed_addtocart_salinity');
											localStorage.removeItem('mob_seed_addtocart_plsize');
										}
										if (data.status === "success" && data.message === "Cart Updated") {
											this.setState({
												updatecart_status: true,
												addtocart_msg: 'GO TO CART',
												is_cart: 1
											});
											localStorage.removeItem('mob_seedaddtocart');
											localStorage.removeItem('mob_seed_addtocart_qty');
											localStorage.removeItem('mob_seed_addtocart_pick_date');
											localStorage.removeItem('mob_seed_addtocart_salinity');
											localStorage.removeItem('mob_seed_addtocart_plsize');
										}
										if (data.status === "error" && data.cart_flag === 0) {
											this.setState({
												clearcart_status: true
											});
											localStorage.removeItem('mob_seedaddtocart');
											localStorage.removeItem('mob_seed_addtocart_qty');
											localStorage.removeItem('mob_seed_addtocart_pick_date');
											localStorage.removeItem('mob_seed_addtocart_salinity');
											localStorage.removeItem('mob_seed_addtocart_plsize');
										}
	
										if (data.status === "error" && data.message === "Product already added to the cart" && data.cart_flag === 1) {
											this.setState({
												addtocart_msg: 'GO TO CART',
												addtocart_status: true,
												is_cart: data.cart_flag,
												product_existed: true
											});
											localStorage.removeItem('mob_seedaddtocart');
											localStorage.removeItem('mob_seed_addtocart_qty');
											localStorage.removeItem('mob_seed_addtocart_pick_date');
											localStorage.removeItem('mob_seed_addtocart_salinity');
											localStorage.removeItem('mob_seed_addtocart_plsize');
										}
									}.bind(this),
									error: function error(err) {
										localStorage.removeItem('mob_seedaddtocart');
										localStorage.removeItem('mob_seed_addtocart_qty');
										localStorage.removeItem('mob_seed_addtocart_pick_date');
										localStorage.removeItem('mob_seed_addtocart_salinity');
										localStorage.removeItem('mob_seed_addtocart_plsize');
									}
								});
							}
						}
					}
				}
			}
		}, {
			key: 'addtocartOnload',
			value: function addtocartOnload() {
				if (this.state.addtocart_msg === "GO TO CART") {
					_reactRouter.browserHistory.push('/mycart');
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('mob_seedaddtocart', '1');
					localStorage.setItem('mob_seed_addtocart_qty', this.state.min_allowed_qty);
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.mob_seed_addtocart_pick_date) {
						// if(this.state.addtocart_msg ==="Add to Cart" || this.state.addtocart_msg ==="Update Cart")
						//{
						var quantity = '';
						if (localStorage.mob_seed_addtocart_qty) {
							quantity = localStorage.getItem('mob_seed_addtocart_qty');
						} else {
							quantity = '';
						}
						if (quantity < parseInt(this.state.min_allowed_qty1, 10) || quantity === "NaN") {
							this.setState({
								err_qty_status_1: true,
								err_qty_msg: "* Minimum Quantity is " + this.state.min_allowed_qty1,
								min_allowed_qty: this.state.min_allowed_qty1,
								millions: parseInt(this.state.min_allowed_qty1, 10) / 1000000
							});
							quantity = this.state.min_allowed_qty1;
						} else if (quantity === '') {
							this.setState({
								min_allowed_qty: this.state.available_qty,
								millions: parseInt(this.state.available_qty, 10) / 1000000,
								err_qty_status_1: true,
								err_qty_msg: "* Minimum Quantity is " + this.state.min_allowed_qty1
							});
						} else if (quantity > parseInt(this.state.available_qty, 10)) {
							this.setState({
								min_allowed_qty: this.state.available_qty,
								millions: parseInt(this.state.available_qty, 10) / 1000000,
								err_qty_status_1: true,
								err_qty_msg: '* Maximum quantity is ' + this.state.available_qty
							});
						} else {
							this.setState({
								err_qty_status_1: false,
								err_qty_msg: ''
							});
							quantity = localStorage.getItem('mob_seed_addtocart_qty');
						}
						if (quantity >= this.state.min_allowed_qty1 && quantity !== "NaN") {
	
							if (localStorage.mob_seed_addtocart_plsize && localStorage.mob_seed_addtocart_plsize !== '0') {
								var seed_plsize = localStorage.getItem('mob_seed_addtocart_plsize');
							} else {
								seed_plsize = 'PLSIZE';
							}
							if (localStorage.mob_seed_addtocart_salinity && localStorage.mob_seed_addtocart_salinity !== '0') {
								var seed_salinity = localStorage.getItem('mob_seed_addtocart_salinity');
							} else {
								seed_salinity = 'SALINITY';
							}
							if (localStorage.mob_seed_addtocart_pick_date) {
								var pickup_date = localStorage.getItem('mob_seed_addtocart_pick_date');
							} else {
								pickup_date = '';
							}
							if (localStorage.user_id) {
								var uid = localStorage.getItem('user_id');
							} else {
								uid = 0;
							}
							if (localStorage.source) {
								var source = localStorage.getItem('source');
							} else {
								source = '';
							}
							if (localStorage.campaign) {
								var campaign = localStorage.getItem('campaign');
							} else {
								campaign = '';
							}
							if (localStorage.url_id) {
								var url_id = localStorage.getItem('url_id');
							} else {
								url_id = '';
							}
							var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token'), deal_id: this.props.params.Id, deal_type: 0, quantity: quantity, pl_size: seed_plsize, salinity: seed_salinity, pickup_date: pickup_date, source: source, campaign: campaign, url_id: url_id };
							var data2 = JSON.stringify(data1);
							_jquery2.default.ajax({
								method: 'post',
								dataType: 'json',
								url: baseUrl + 'addToCart',
								data: { req: data2 },
								success: function (data) {
									if (data.status === "success" && data.message === "Added to cart") {
										this.setState({
											addtocart_msg: 'Go to Cart',
											addtocart_status: true,
											is_cart: 1
										});
										localStorage.removeItem('mob_seedaddtocart');
										localStorage.removeItem('mob_seed_addtocart_qty');
										localStorage.removeItem('mob_seed_addtocart_pick_date');
										localStorage.removeItem('mob_seed_addtocart_salinity');
										localStorage.removeItem('mob_seed_addtocart_plsize');
									}
									if (data.status === "success" && data.message === "Cart Updated") {
										this.setState({
											updatecart_status: true,
											addtocart_msg: 'Go to Cart',
											is_cart: 1
										});
										localStorage.removeItem('mob_seedaddtocart');
										localStorage.removeItem('mob_seed_addtocart_qty');
										localStorage.removeItem('mob_seed_addtocart_pick_date');
										localStorage.removeItem('mob_seed_addtocart_salinity');
										localStorage.removeItem('mob_seed_addtocart_plsize');
									}
									if (data.status === "error" && data.cart_flag === 0) {
										this.setState({
											clearcart_status: true
										});
										localStorage.removeItem('mob_seedaddtocart');
										localStorage.removeItem('mob_seed_addtocart_qty');
										localStorage.removeItem('mob_seed_addtocart_pick_date');
										localStorage.removeItem('mob_seed_addtocart_salinity');
										localStorage.removeItem('mob_seed_addtocart_plsize');
									}
	
									if (data.status === "error" && data.message === "Product already added to the cart" && data.cart_flag === 1) {
										this.setState({
											addtocart_msg: 'Go to Cart',
											addtocart_status: true,
											is_cart: data.cart_flag,
											product_existed: true
										});
										localStorage.removeItem('mob_seedaddtocart');
										localStorage.removeItem('mob_seed_addtocart_qty');
										localStorage.removeItem('mob_seed_addtocart_pick_date');
										localStorage.removeItem('mob_seed_addtocart_salinity');
										localStorage.removeItem('mob_seed_addtocart_plsize');
									}
								}.bind(this),
								error: function error(err) {
									localStorage.removeItem('mob_seedaddtocart');
									localStorage.removeItem('mob_seed_addtocart_qty');
									localStorage.removeItem('mob_seed_addtocart_pick_date');
									localStorage.removeItem('mob_seed_addtocart_salinity');
									localStorage.removeItem('mob_seed_addtocart_plsize');
								}
							});
						}
						//}
					}
				}
			}
		}, {
			key: 'removeCartItems',
			value: function removeCartItems() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
	
				if (this.state.active_date === '') {
					var pickup_date = this.state.cart_date_active;
				} else {
					pickup_date = this.state.active_date;
				}
				var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token'), deal_id: this.props.params.Id, deal_type: 0, quantity: this.refs.input_minqty.value, pl_size: this.state.plsize, salinity: this.state.salinity, pickup_date: pickup_date, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'replaceCart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success" && data.cart_flag === 1) {
							this.setState({
								addtocart_msg: 'GO TO CART',
								clearcart_status: false,
								addtocart_status: true
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'DealPlSalinity',
			value: function DealPlSalinity() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var data1 = { from: 'mobile_web', deal_id: this.props.params.Id, id: uid, token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'DealPlSalinity',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "ok") {
							this.setState({
								plsizes: data.plsizes,
								salinities: data.salinities
							});
						}
						if (data.status === "error" && data.message === "Token mismatch") {
							localStorage.removeItem('user_id');
							localStorage.removeItem('token');
							window.location.reload();
						}
					}.bind(this),
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}, {
			key: 'salinityChange',
			value: function salinityChange() {
				this.setState({
					salinity: this.refs.select_salinity.value
				});
				if (this.state.is_cart === 1) {
					this.setState({
						addtocart_msg: 'UPDATE CART'
					});
				}
			}
		}, {
			key: 'plsizeChange',
			value: function plsizeChange() {
				this.setState({
					plsize: this.refs.select_plsize.value
				});
				if (this.state.is_cart === 1) {
					this.setState({
						addtocart_msg: 'UPDATE CART'
					});
				}
			}
		}, {
			key: 'decrementMinQty',
			value: function decrementMinQty() {
				if (this.state.min_allowed_qty !== this.state.min_allowed_qty1 && this.state.min_allowed_qty > this.state.min_allowed_qty1) {
					var cal = parseInt(this.state.min_allowed_qty, 10) - 100000;
					this.setState({
						min_allowed_qty: parseInt(this.state.min_allowed_qty, 10) - 100000,
						min_allowed_qty_status: false,
						millions: cal / 1000000,
						err_qty_status_1: false,
						err_qty_msg: ''
					});
				} else {
					this.setState({
						min_allowed_qty: parseInt(this.state.min_allowed_qty1, 10),
						millions: parseInt(this.state.min_allowed_qty1, 10) / 1000000,
						err_qty_status_1: true,
						err_qty_msg: '* Minimum quantity is ' + this.state.min_allowed_qty1
					});
				}
				if (this.state.is_cart === 1) {
					this.setState({
						addtocart_msg: 'UPDATE CART'
					});
				}
			}
		}, {
			key: 'updateMinQty',
			value: function updateMinQty(event) {
				this.setState({
					err_qty_status_1: false,
					err_qty_msg: ''
				});
				var x = event.target.value;
				var invalidChars = /[^0-9]/gi;
				if (invalidChars.test(event.target.value)) {
					x = event.target.value.replace(invalidChars, "");
				} else {
					this.setState({
						min_allowed_qty: x,
						millions: parseInt(x, 10) / 1000000
					});
				}
				if (this.refs.input_minqty.value > parseInt(this.state.available_qty, 10)) {
					this.setState({
						min_allowed_qty: this.state.available_qty,
						millions: parseInt(this.state.available_qty, 10) / 1000000,
						err_qty_status_1: true,
						err_qty_msg: '* Maximum quantity is ' + this.state.available_qty
					});
				} else if (this.refs.input_minqty.value === "") {
					this.setState({
						min_allowed_qty: '',
						err_qty_status_1: true,
						err_qty_msg: '* Minimum quantity is ' + this.state.min_allowed_qty1,
						millions: 0
					});
				}
			}
		}, {
			key: 'incrementMinQty',
			value: function incrementMinQty() {
				var cal = parseInt(this.state.min_allowed_qty, 10) + 100000;
				if (cal <= this.state.available_qty) {
					this.setState({
						min_allowed_qty: parseInt(this.state.min_allowed_qty, 10) + 100000,
						millions: cal / 1000000,
						err_qty_status_1: false,
						err_qty_msg: ''
					});
				} else if (this.refs.input_minqty.value === '') {
					this.setState({
						min_allowed_qty: this.state.min_allowed_qty1,
						millions: parseInt(this.state.min_allowed_qty1, 10) / 1000000,
						err_qty_status_1: true,
						err_qty_msg: '* Minimum quantity is ' + this.state.min_allowed_qty1
					});
				} else {
					this.setState({
						min_allowed_qty: parseInt(this.state.available_qty, 10),
						millions: parseInt(this.state.available_qty, 10) / 1000000,
						min_allowed_qty_status: true,
						err_qty_status_1: true,
						err_qty_msg: '* Maximum quantity is ' + this.state.available_qty
					});
				}
				if (this.state.is_cart === 1) {
					this.setState({
						addtocart_msg: 'UPDATE CART'
					});
				}
			}
		}, {
			key: 'modalOpen',
			value: function modalOpen() {
				this.setState({
					showModal: true
				});
			}
		}, {
			key: 'closeModal',
			value: function closeModal() {
				this.setState({
					showModal: false,
					reqbestPrice: false,
					product_existed: false
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					showModal: false,
					reqbestPrice: false,
					clearcart_status: false,
					product_existed: false,
					req_confirm_modal: false
				});
			}
		}, {
			key: 'getDeviceId',
			value: function getDeviceId() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'mobile_web', id: uid, device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getDeviceId',
					dataType: 'json',
					data: { req: data2 },
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'scroll',
			value: function scroll() {
				var lastScroll = 0;
				var scrollUpStart = 0;
				(0, _jquery2.default)(window).on('scroll', function () {
					var scroll = (0, _jquery2.default)(window).scrollTop();
					if (scroll === 0) {
						(0, _jquery2.default)(".page_hdr").addClass("dtl_pg_hdr");
					} else if (lastScroll > scroll) {
						if (scrollUpStart < scroll) {
							scrollUpStart = scroll;
						}
						if (scrollUpStart - scroll >= 200) {
							(0, _jquery2.default)(".page_hdr").addClass("dtl_pg_hdr");
						}
					} else {
						scrollUpStart = 0;
						(0, _jquery2.default)(".page_hdr").removeClass("dtl_pg_hdr");
					}
					lastScroll = scroll;
				});
			}
		}, {
			key: 'changeDate',
			value: function changeDate(dt) {
				this.setState({
					active_date: dt,
					date_flag: true,
					err_date_status: false,
					cart_date_active: dt
				});
				if (this.state.is_cart === 1) {
					this.setState({
						addtocart_msg: 'UPDATE CART'
					});
				}
			}
		}, {
			key: 'getDates',
			value: function getDates() {
				var day = 1000 * 60 * 60 * 24;
				var d1 = Date.parse(this.state.start_date);
				var d2 = Date.parse(this.state.end_date);
				var d3 = Date.parse(this.state.cart_date);
				var date1 = new Date(d1);
				var date2 = new Date(d2);
				var date3 = new Date(d3);
				var diff = (date2.getTime() - date1.getTime()) / day;
				var dates = [];
				var months = new Array(12);
				months[0] = "Jan";
				months[1] = "Feb";
				months[2] = "Mar";
				months[3] = "Apr";
				months[4] = "May";
				months[5] = "Jun";
				months[6] = "Jul";
				months[7] = "Aug";
				months[8] = "Sep";
				months[9] = "Oct";
				months[10] = "Nov";
				months[11] = "Dec";
				for (var i = 0; i <= diff; i++) {
					var xx = date1.getTime() + day * i;
					var yy = new Date(xx);
					var monthName = months[yy.getMonth()];
					var tt = yy.getDate() + " " + monthName + " " + yy.getFullYear();
					dates[i + 1] = tt;
				}
				if (this.state.cart_date !== '') {
					var a = date3.getTime();
					var b = new Date(a);
					monthName = months[b.getMonth()];
					var c = b.getDate() + " " + monthName + " " + b.getFullYear();
					this.setState({
						cart_date_active: c
					});
				}
				this.setState({
					seeddates: dates
				});
			}
		}, {
			key: 'addToWishlistOnload',
			value: function addToWishlistOnload() {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('addtowishlist_onload', '1');
					_reactRouter.browserHistory.push('/login');
				} else {
					this.setState({
						page_loading: true
					});
					if (localStorage.user_id) {
						var uid = localStorage.user_id;
					} else {
						uid = 0;
					}
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.token, type: 0, did: this.props.params.Id, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'addToWishlist',
						success: function (data) {
							if (data.status === 'success' && data.message === 'Added to wish list') {
								this.setState({
									wishLst_flag: 1,
									page_loading: false
								});
								localStorage.removeItem('addtowishlist_onload');
							} else {
								this.setState({
									page_loading: false
								});
								localStorage.removeItem('addtowishlist_onload');
							}
						}.bind(this),
						error: function error(err) {
							this.setState({
								page_loading: false
							});
						}
					});
				}
			}
		}, {
			key: 'addToWishlist',
			value: function addToWishlist() {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('addtowishlist_onload', '1');
					_reactRouter.browserHistory.push('/login');
				} else {
					this.setState({
						page_loading: true
					});
					if (localStorage.user_id) {
						var uid = localStorage.user_id;
					} else {
						uid = 0;
					}
					if (localStorage.source) {
						var source = localStorage.getItem('source');
					} else {
						source = '';
					}
					if (localStorage.campaign) {
						var campaign = localStorage.getItem('campaign');
					} else {
						campaign = '';
					}
					if (localStorage.url_id) {
						var url_id = localStorage.getItem('url_id');
					} else {
						url_id = '';
					}
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.token, type: 0, did: this.props.params.Id, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + 'addToWishlist',
						success: function (data) {
							if (data.status === 'success' && data.message === 'Added to wish list') {
								this.setState({
									wishLst_flag: 1,
									page_loading: false
								});
								localStorage.removeItem('addtowishlist_onload');
							} else {
								this.setState({
									page_loading: false
								});
								localStorage.removeItem('addtowishlist_onload');
							}
						}.bind(this),
						error: function error(err) {
							this.setState({
								page_loading: false
							});
						}
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var params = {
					paginationClickable: true,
					spaceBetween: 5,
					slidesPerView: 6
				};
				var shareUrl = this.state.shareUrl;
				var title = "Hey Click here " + shareUrl + " to check " + this.state.sp_name + " from AquaDeals.";
				var description = shareUrl;
				var x = _jquery2.default.makeArray(this.state.seeddates);
				var seeddates = x.map(function (dt, index) {
					var _this3 = this;
	
					return _react2.default.createElement(
						'div',
						{ className: this.state.active_date === dt || this.state.cart_date_active === dt ? "seed_dateblk seed_dateblk_active" : "seed_dateblk", key: index, onClick: function onClick() {
								_this3.changeDate(dt);
							} },
						_react2.default.createElement(
							'div',
							{ className: 'seed_date' },
							dt
						)
					);
				}.bind(this));
				var img_array = _jquery2.default.makeArray(this.state.res_img);
				var product_imgs = img_array.map(function (image, index) {
					return _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/seller_imgs/thumbnails/' + image.img, alt: ' ', height: '355px' });
				});
				var views_cnt = this.state.details.views_count >= 1 ? _react2.default.createElement(
					'span',
					null,
					_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/views.png', width: '20px', role: 'presentation' }),
					' ',
					this.state.details.views_count
				) : '';
				var rec_cnt = this.state.details.recomends >= 1 ? _react2.default.createElement(
					'span',
					{ className: 'recommended_img' },
					_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/recommended1.png', width: '16px', role: 'presentation' }),
					' \xA0',
					this.state.details.recomends
				) : '';
				var details = this.state.seedDetails.map(function (details, index) {
					return _react2.default.createElement(ProductDetails, { key: details.deals_data.id, data: details, views_cnt: views_cnt, rec_cnt: rec_cnt });
				});
				// var shipment= this.state.details.free_shipment === '0' ? '' : <h5><i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/shipping_van.png'} alt=" " width="20px"  /></i>{this.state.details.shipping_desc}</h5>;
				// var credit = this.state.details.credit_facility === '0' ? '' : <h5><i><img src={'https://aquadeals.in/admin/assets/images/web_imgs/credit_ava.png'} alt=" " /></i>{this.state.details.credit_title} </h5>;
				var recommendation = this.state.recomends >= 1 ? _react2.default.createElement(
					'span',
					null,
					_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/recommended1.png', alt: ' ', style: { width: '16px', position: 'relative', top: '-1px' } }),
					' ',
					this.state.recomends
				) : '';
				var getcoupons = '';
				if (this.state.coupons.length > 0) {
					getcoupons = "coupons";
					var descriptionTop = _react2.default.createElement(
						_reactBootstrap.Popover,
						{ className: 'in', id: 'popover-positioned-top' },
						this.state.coupon_first.description
					);
					var couponsList = _react2.default.createElement(
						_reactBootstrap.Popover,
						{ id: 'popover-positioned-top1' },
						this.state.cpns_list.replace(/,\s*$/, "")
					);
					if (this.state.coupons.length === 1) {
						getcoupons = _react2.default.createElement(
							'div',
							{ className: 'row', style: { paddingTop: '10px', paddingBottom: '10px' } },
							_react2.default.createElement(
								'div',
								{ className: 'col-xs-6 col-md-6 col-xs-offset-3 col-md-offset-3' },
								_react2.default.createElement(
									'div',
									{ className: 'mob_new_coupon_blk' },
									_react2.default.createElement(
										'i',
										{ className: 'coupon_left_img' },
										_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/coupon_left.png', alt: ' ' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'coupon_text' },
										this.state.coupon_first.coupon_code
									),
									_react2.default.createElement(
										_reactBootstrap.OverlayTrigger,
										{ trigger: 'focus', placement: 'top', overlay: descriptionTop },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ className: 'coupon_info_img' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/coupon_info.png', alt: ' ' })
										)
									)
								)
							)
						);
					} else {
						getcoupons = _react2.default.createElement(
							'div',
							{ className: 'row', style: { paddingTop: '10px', paddingBottom: '10px' } },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-6 col-xs-6 col-sm-6 col-xs-offset' },
								_react2.default.createElement(
									'div',
									{ className: 'mob_new_coupon_blk' },
									_react2.default.createElement(
										'i',
										{ className: 'coupon_left_img' },
										_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/coupon_left.png', alt: ' ' })
									),
									_react2.default.createElement(
										'div',
										{ className: 'coupon_text' },
										this.state.coupon_first.coupon_code
									),
									_react2.default.createElement(
										_reactBootstrap.OverlayTrigger,
										{ trigger: 'focus', placement: 'top', overlay: descriptionTop },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ className: 'coupon_info_img' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/coupon_info.png', alt: ' ' })
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-6 col-xs-6 col-sm-6' },
								_react2.default.createElement(
									_reactBootstrap.OverlayTrigger,
									{ trigger: 'focus', placement: 'top', overlay: couponsList },
									_react2.default.createElement(
										_reactBootstrap.Button,
										{ className: 'applied_coupons' },
										'Applied coupons'
									)
								)
							)
						);
					}
				} else {
					getcoupons = '';
				}
				var plsizes = this.state.plsizes.map(function (pl, index) {
					return _react2.default.createElement(
						'option',
						{ key: pl, value: pl },
						pl
					);
				});
				var salinities = this.state.salinities.map(function (sal, index) {
					return _react2.default.createElement(
						'option',
						{ key: sal, value: sal },
						sal
					);
				});
	
				// errors of the req form 
				(0, _jquery2.default)('#req_quantity').keyup(function () {
					(0, _jquery2.default)('#req_quantity_err').text('');
				});
				(0, _jquery2.default)('#req_state').keyup(function () {
					(0, _jquery2.default)('#req_state_err').text('');
				});
				(0, _jquery2.default)('#req_city').keyup(function () {
					(0, _jquery2.default)('#req_city_err').text('');
				});
				(0, _jquery2.default)('#req_doorno').keyup(function () {
					(0, _jquery2.default)('#req_doorno_err').text('');
				});
				(0, _jquery2.default)('#req_pincode').keyup(function () {
					(0, _jquery2.default)('#req_pincode_err').text('');
				});
	
				var wishLst_flag = '';
				if (this.state.wishLst_flag === 1) {
					wishLst_flag = _react2.default.createElement(
						'div',
						{ className: 'goto_wish_blk' },
						_react2.default.createElement(
							'div',
							{ className: 'col-md-6 col-sm-6 col-xs-6 first_blk' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: '/wishlist' },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/wish_list_filled.png', alt: '', width: '12px' })
								),
								' Go to wishlist'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-md-6 col-sm-6 col-xs-6 second_blk' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ className: 'share_list1', onClick: function onClick() {
										_this4.ShareFunc(_this4.state.seedid);
									} },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/share1.png', alt: 'share', width: '19px' })
								),
								' Share'
							),
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									_reactBootstrap.Panel,
									{ className: 'seed_full_panel1', collapsible: true, expanded: this.state.open },
									_react2.default.createElement(
										FacebookShareButton,
										{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
										_react2.default.createElement(FacebookIcon, { size: 32, round: true })
									),
									_react2.default.createElement(
										TwitterShareButton,
										{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
										_react2.default.createElement(TwitterIcon, { size: 32, round: true })
									),
									_react2.default.createElement(
										GooglePlusShareButton,
										{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
										_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
									)
								)
							)
						)
					);
				} else {
					wishLst_flag = _react2.default.createElement(
						'div',
						{ className: 'addto_wish_blk' },
						_react2.default.createElement(
							'div',
							{ className: 'col-md-6 col-sm-6 col-xs-6 first_blk' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ onClick: function onClick() {
										_this4.addToWishlist();
									} },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/wish_list_unfilled.png', alt: '', width: '12px' })
								),
								' Add to wishlist'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-md-6 col-sm-6 col-xs-6 second_blk' },
							_react2.default.createElement(
								_reactRouter.Link,
								{ className: 'share_list1', onClick: function onClick() {
										_this4.ShareFunc(_this4.state.seedid);
									} },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/share1.png', alt: 'share', width: '19px' })
								),
								' Share'
							),
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									_reactBootstrap.Panel,
									{ className: 'seed_full_panel1', collapsible: true, expanded: this.state.open },
									_react2.default.createElement(
										FacebookShareButton,
										{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
										_react2.default.createElement(FacebookIcon, { size: 32, round: true })
									),
									_react2.default.createElement(
										TwitterShareButton,
										{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
										_react2.default.createElement(TwitterIcon, { size: 32, round: true })
									),
									_react2.default.createElement(
										GooglePlusShareButton,
										{ url: shareUrl, quote: title, description: description, className: 'test_share1' },
										_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
									)
								)
							)
						)
					);
				}
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals seed_full_details_page' },
					this.state.loading && !this.state.data_status ? _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: 'page_hdr dtl_pg_hdr' },
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ onClick: function onClick() {
												_reactRouter.browserHistory.goBack();
											} },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
										)
									),
									this.state.hatchary_details.org_name
								),
								_react2.default.createElement(
									'a',
									{ href: '/', className: 'home_newicon' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/home1.png', alt: 'Home' })
								)
							)
						),
						_react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'div',
								{ className: 'row lst_img', style: { position: 'relative' } },
								_react2.default.createElement(
									_reactSwipe2.default,
									{ ref: 'reactSwipe', className: 'carousel item', swipeOptions: {
											continuous: true,
											disableScroll: false,
											stopPropagation: false,
											callback: function callback(index, elem) {},
											transitionEnd: function transitionEnd(index, elem) {}
										}, key: product_imgs.length },
									product_imgs
								),
								_react2.default.createElement(
									'div',
									{ className: 'seed_view_rec_blk' },
									views_cnt,
									' \xA0 \xA0 ',
									recommendation
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row deal_name' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-12 col-sm-12 col-xs-12' },
									details
								)
							),
							_react2.default.createElement(
								'section',
								{ className: 'row deal_name' },
								wishLst_flag
							),
							_react2.default.createElement(
								'div',
								{ className: 'row deal_name' },
								_react2.default.createElement(
									'div',
									{ className: 'block_header' },
									_react2.default.createElement(
										'h4',
										{ className: 'mob_seed_h4' },
										'Discount & Offers'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'seed_full_cash_block col-md-12' },
									this.state.test.aqua_cash_title ? _react2.default.createElement(
										'h5',
										{ className: 'book_aquacash', style: { clear: 'both' } },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/nav_aquacash.png', alt: ' ', width: '15px' })
										),
										this.state.test.aqua_cash_title
									) : '',
									this.state.test.full_aquacash_back_title ? _react2.default.createElement(
										'h5',
										{ className: 'cashback', style: { color: '#666' } },
										_react2.default.createElement(
											'i',
											{ style: { display: 'block', float: 'left', paddingRight: '0px!important', marginRight: '4px' } },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/newcashback.png', alt: ' ', width: '18px' })
										),
										this.state.test.full_aquacash_back_title
									) : '',
									this.state.test.pur_ern_ofr_desc ? _react2.default.createElement(
										'h5',
										{ style: { color: '#666', fontSize: '11px', marginBottom: '15px' } },
										_react2.default.createElement(
											'i',
											{ style: { display: 'block', float: 'left', marginRight: '10px' } },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/nav_aquacash.png', alt: ' ', width: '15px' })
										),
										this.state.test.pur_ern_ofr_desc
									) : '',
									this.state.emi_opt_sts === 1 ? _react2.default.createElement(
										'h5',
										{ style: { color: '#666', fontSize: '11px', marginBottom: '15px' } },
										_react2.default.createElement(
											'i',
											{ style: { display: 'block', float: 'left', marginRight: 10 + 'px' } },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/emi.png', alt: ' ', width: '15px' })
										),
										this.state.emi_opt_desc
									) : ''
								)
							),
							_react2.default.createElement('div', { className: 'clr' })
						),
						this.state.coupons.length > 0 ? _react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'block_header' },
									_react2.default.createElement(
										'h4',
										{ className: 'mob_seed_h4 ' },
										'Coupons '
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-12' },
									this.state.coupons.length > 0 ? _react2.default.createElement(
										'div',
										{ className: '', style: { backgroundColor: '#fff' } },
										getcoupons
									) : ''
								)
							)
						) : '',
						_react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'block_header' },
									_react2.default.createElement(
										'h4',
										{ className: 'mob_seed_h4' },
										'Select Quantity'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-12', style: { backgroundColor: '#fff!important' } },
									_react2.default.createElement(
										'div',
										{ className: 'qty_section', style: { position: 'relative', textAlign: 'center' } },
										_react2.default.createElement(
											'button',
											{ className: 'minus_btn', onClick: function onClick() {
													_this4.decrementMinQty();
												} },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/minus_orange.png', alt: ' ' })
										),
										_react2.default.createElement(
											'span',
											{ className: 'min_qty_btn' },
											_react2.default.createElement('input', { type: 'text', placeholder: this.state.min_allowed_qty1, value: this.state.min_allowed_qty, ref: 'input_minqty', onChange: this.updateMinQty })
										),
										_react2.default.createElement(
											'button',
											{ className: 'plus_btn', onClick: function onClick() {
													_this4.incrementMinQty();
												} },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/plus.png', alt: ' ' })
										),
										_react2.default.createElement(
											'button',
											{ className: 'equal_btn' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/equalto.png', alt: '' }),
											' '
										),
										_react2.default.createElement(
											'span',
											{ className: 'seed_qty_value' },
											_react2.default.createElement(
												'span',
												{ className: 'qty_mainvalue' },
												this.state.millions
											),
											_react2.default.createElement('br', null),
											_react2.default.createElement(
												'span',
												{ className: 'qty_unitname' },
												'Millions'
											)
										),
										_react2.default.createElement(
											'i',
											{ className: 'millions_img' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/box_seed_quantity.png', alt: '', width: '80px' })
										),
										this.state.err_qty_status_1 ? _react2.default.createElement(
											'p',
											{ className: 'err_seedlimit' },
											this.state.err_qty_msg
										) : ''
									)
								)
							)
						),
						_react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'block_header' },
									_react2.default.createElement(
										'h4',
										{ className: 'mob_seed_h4' },
										'Select PL Size & Salinity'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-12', style: { backgroundColor: '#fff', paddingTop: '10px', paddingBottom: '15px', overflow: 'hidden' } },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-6 col-sm-6 col-xs-6', style: { padding: '0px' } },
										_react2.default.createElement(
											'select',
											{ value: this.state.plsize, onChange: function onChange() {
													_this4.plsizeChange();
												}, className: 'form-control select_plsize', ref: 'select_plsize' },
											_react2.default.createElement(
												'option',
												{ key: '0', value: '0', selected: parseInt(this.state.cart_pl_size, 10) === 0 ? 'selected' : '' },
												'PL Size'
											),
											plsizes
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-md-6 col-sm-6 col-xs-6', style: { paddingRight: '0px' } },
										_react2.default.createElement(
											'select',
											{ value: this.state.salinity, onChange: function onChange() {
													_this4.salinityChange();
												}, ref: 'select_salinity', className: 'form-control select_salinity' },
											_react2.default.createElement(
												'option',
												{ key: '0', value: '0', selected: true },
												'Salinity'
											),
											salinities
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'block_header' },
									_react2.default.createElement(
										'h4',
										{ className: 'mob_seed_h4' },
										'Select Date'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'mob_select_date', style: { position: 'relative' } },
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/mob-assets/back_orange.png', alt: '', className: 'left_arrow_date' }),
								_react2.default.createElement(
									_reactIdSwiper2.default,
									_extends({}, params, { key: seeddates.length }),
									seeddates
								),
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/mob-assets/forward_orange.png', alt: '', className: 'right_arrow_date' }),
								this.state.err_date_status ? _react2.default.createElement(
									'p',
									{ className: 'err_dateselect' },
									this.state.err_date
								) : ''
							)
						),
						this.state.free_shipment === '1' ? _react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'block_header' },
									_react2.default.createElement(
										'h4',
										{ className: 'mob_seed_h4' },
										'Free Shipment'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row mob_pinblk' },
								this.state.free_shipment === '1' ? _react2.default.createElement(
									'div',
									{ className: 'col-md-12 col-sm-12 col-xs-12' },
									_react2.default.createElement(
										'div',
										{ className: 'mob_pin_inputblk' },
										_react2.default.createElement('input', { type: 'text', placeholder: 'Pincode', value: this.state.user_zipcode === '0' ? '' : this.state.user_zipcode, maxLength: 6, ref: 'pincode', onChange: function onChange() {
												_this4.pincodeChange();
											} }),
										_react2.default.createElement(
											'a',
											{ className: 'mob_pin_btn', onClick: function onClick() {
													_this4.checkPincode();
												} },
											'Check'
										)
									),
									this.state.err_pincode ? _react2.default.createElement(
										'p',
										{ className: 'err_pincode' },
										this.state.err_pincode_msg
									) : '',
									_react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/shipping_van.png', alt: '' })
										),
										_react2.default.createElement(
											'span',
											null,
											this.state.free_ship_msg
										)
									)
								) : ''
							)
						) : '',
						this.state.deal_options.length > 0 || this.state.hatchary_details.caa === "Yes" ? _react2.default.createElement(
							'div',
							{ className: 'block_header' },
							_react2.default.createElement(
								'h4',
								{ className: 'mob_seed_h4' },
								'Key Features'
							)
						) : '',
						this.state.deal_options && this.state.hatchary_details.caa === "Yes" ? _react2.default.createElement(
							'div',
							{ className: 'row key_featurs' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12 col-sm-12 col-xs-12' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6' },
									this.state.hatchary_details.caa === "Yes" ? _react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											'span',
											null,
											'CAA Approved'
										),
										' '
									) : ''
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6', style: { padding: '0px' } },
									this.state.hatchary_details.caa === "Yes" ? _react2.default.createElement(
										'h5',
										{ className: 'caa_approved' },
										'Yes, Vallid till ',
										this.state.hatchary_details.caa_date
									) : ''
								)
							)
						) : '',
						this.state.deal_options.length > 0 ? _react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'div',
								{ className: 'row key_featurs' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6' },
									this.state.hatchary_details.caa === "Yes" ? _react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											'span',
											null,
											'CAA Approved'
										),
										' '
									) : ''
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6' },
									this.state.hatchary_details.caa === "Yes" ? _react2.default.createElement(
										'h5',
										null,
										'Yes, Vallid till ',
										this.state.hatchary_details.caa_date
									) : ''
								),
								_react2.default.createElement('div', { className: 'clr' }),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6' },
									this.state.deal_options.brod_name !== "0" ? _react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											'span',
											null,
											'Brood Stock Source'
										)
									) : ''
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6' },
									this.state.deal_options.brod_name !== "0" ? _react2.default.createElement(
										'h5',
										{ className: 'mob_feature_desc' },
										_react2.default.createElement(
											'span',
											null,
											this.state.deal_options.brod_name
										)
									) : ''
								),
								_react2.default.createElement('div', { className: 'clr' }),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6' },
									this.state.deal_options.nauplii !== "0" ? _react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											'span',
											null,
											'Nauplii'
										)
									) : ''
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6' },
									this.state.deal_options.nauplii !== "0" ? _react2.default.createElement(
										'h5',
										{ className: 'mob_feature_desc' },
										_react2.default.createElement(
											'span',
											null,
											this.state.deal_options.nauplii
										)
									) : ''
								),
								_react2.default.createElement('div', { className: 'clr' }),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6' },
									this.state.deal_options.feed_sub !== "0" ? _react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											'span',
											null,
											'Feed'
										)
									) : ''
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6' },
									this.state.deal_options.feed_sub !== "0" ? _react2.default.createElement(
										'h5',
										{ className: 'mob_feature_desc' },
										_react2.default.createElement(
											'span',
											null,
											this.state.deal_options.feed_sub
										)
									) : ''
								),
								_react2.default.createElement('div', { className: 'clr' }),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6' },
									this.state.deal_options.cultrDays_days !== "0" ? _react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											'span',
											null,
											'Cultured Days'
										)
									) : ''
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6' },
									this.state.deal_options.cultrDays_days !== "0" ? _react2.default.createElement(
										'h5',
										{ className: 'mob_feature_desc' },
										_react2.default.createElement(
											'span',
											null,
											this.state.deal_options.cultrDays_days
										)
									) : ''
								),
								_react2.default.createElement('div', { className: 'clr' }),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6' },
									this.state.deal_options.pkg_size !== "0" ? _react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											'span',
											null,
											'Minimum Packing Size'
										)
									) : ''
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6' },
									this.state.deal_options.pkg_size !== "0" ? _react2.default.createElement(
										'h5',
										{ className: 'mob_feature_desc' },
										_react2.default.createElement(
											'span',
											null,
											this.state.deal_options.pkg_size
										)
									) : ''
								),
								_react2.default.createElement('div', { className: 'clr' }),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6' },
									this.state.deal_options.daign_name !== "0" ? _react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											'span',
											null,
											'Diagnosis'
										)
									) : ''
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6' },
									this.state.deal_options.daign_name !== "0" ? _react2.default.createElement(
										'h5',
										{ className: 'mob_feature_desc' },
										_react2.default.createElement(
											'span',
											null,
											this.state.deal_options.daign_name
										)
									) : ''
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6' },
									this.state.deal_options.pcr_tests !== "0" ? _react2.default.createElement(
										'h5',
										null,
										_react2.default.createElement(
											'span',
											null,
											'PCR Tests'
										)
									) : ''
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-xs-6 col-sm-6' },
									this.state.deal_options.pcr_tests !== "0" ? _react2.default.createElement(
										'h5',
										{ className: 'mob_feature_desc' },
										_react2.default.createElement(
											'span',
											null,
											this.state.deal_options.pcr_tests
										)
									) : ''
								)
							)
						) : '',
						_react2.default.createElement(
							'section',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'block_header' },
									_react2.default.createElement(
										'h4',
										{ className: 'mob_seed_h4' },
										'More about the Seller'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row key_featurs' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-12' },
									_react2.default.createElement(
										'div',
										{ className: 'row' },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-10 col-xs-10 col-sm-10' },
											this.state.hatchary_details.org_name ? _react2.default.createElement(
												'h5',
												null,
												_react2.default.createElement(
													'i',
													null,
													_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/home.png', alt: 'aqua' })
												),
												this.state.hatchary_details.org_name
											) : '',
											this.state.hatchary_details.coast ? _react2.default.createElement(
												'h5',
												null,
												_react2.default.createElement(
													'i',
													{ style: { marginTop: '1px' } },
													_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/hat_loc.png', alt: 'aqua' })
												),
												this.state.hatchary_details.coast
											) : ''
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-xs-2 col-sm-2' },
											this.state.rate >= 1 ? _react2.default.createElement(
												'div',
												{ className: 'seler_rating' },
												this.state.rate
											) : ''
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'section',
							{ className: 'botm_btns container-fluid' },
							_react2.default.createElement(
								'ul',
								null,
								_react2.default.createElement(
									'li',
									{ className: 'col-md-6 col-xs-6 col-sm-6 mob_req_btn', onClick: function onClick() {
											_this4.checkBestPrice();
										} },
									_react2.default.createElement(
										_reactRouter.Link,
										{ title: '' },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/get_best_price.png', alt: ' ' })
										),
										'GET BEST PRICE'
									),
									' '
								),
								_react2.default.createElement(
									'li',
									{ className: 'col-md-6 col-xs-6 col-sm-6 mob_addto_cart_btn', onClick: function onClick() {
											_this4.placeOrderModal();
										} },
									_react2.default.createElement(
										_reactRouter.Link,
										null,
										this.state.addtocart_msg
									)
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal,
								{ className: 'showModal', show: this.state.showModal, onHide: this.close },
								_react2.default.createElement(
									_reactBootstrap.Modal.Header,
									{ closeButton: true },
									_react2.default.createElement(
										_reactBootstrap.Modal.Title,
										{ style: { fontSize: '16px', color: '#333' } },
										'AquaDeals'
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal.Body,
									null,
									_react2.default.createElement(
										'h4',
										{ style: { fontSize: '14px', color: '#666' } },
										'You need to install Android mobile app to prebook seed.'
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal.Footer,
									{ className: 'modal_footer' },
									_react2.default.createElement(
										_reactBootstrap.Button,
										{ style: { background: '#fff none repeat scroll 0 0', color: '#ff742a' }, onClick: this.close },
										'Close'
									),
									_react2.default.createElement(
										'a',
										{ href: 'https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en', target: '_blank', title: '' },
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ style: { background: '#ff742a none repeat scroll 0 0', color: '#fff' } },
											'OK'
										)
									)
								)
							)
						)
					) : _react2.default.createElement(
						'div',
						null,
						this.state.data_status ? _react2.default.createElement(_NotFound2.default, null) : _react2.default.createElement(
							'div',
							{ className: 'mob_loading' },
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/mob_loading.gif', alt: 'Loading', role: 'presentation' })
						),
						' '
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.clearcart_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#333' } },
								'You can\'t have multiple seller items in the cart. Empty existing cart & add this item ',
								this.state.sp_name,
								'?'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'NO'
							),
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: function onClick() {
											_this4.removeCartItems();
										} },
									'YES'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.product_existed, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'AquaDeals'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#666' } },
								'Product already added to the cart'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'Close'
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'mob_reqbestprice', show: this.state.reqbestPrice, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ className: 'req_title' },
								'REQUEST FOR BEST PRICE'
							),
							_react2.default.createElement(
								'p',
								{ className: 'req_desc' },
								'For bulk order requirements please fill up the form we will get back with in 48hrs time.'
							),
							_react2.default.createElement(
								'form',
								{ className: 'req_best_price_form', onSubmit: this.reqBestPriceSubmit },
								_react2.default.createElement('input', { type: 'text', maxLength: 10, id: 'req_quantity', ref: 'req_quantity', value: this.state.req_quantity, onChange: this.req_quantityChange, placeholder: 'Enter Quantity' }),
								_react2.default.createElement('span', { className: 'req_err', id: 'req_quantity_err' }),
								_react2.default.createElement('input', { type: 'text', ref: 'req_state', id: 'req_state', value: this.state.req_state, onChange: this.req_stateChange, placeholder: 'Enter State' }),
								_react2.default.createElement('span', { className: 'req_err', id: 'req_state_err' }),
								_react2.default.createElement('input', { type: 'text', ref: 'req_city', id: 'req_city', value: this.state.req_city, onChange: this.req_cityChange, placeholder: 'Enter City / Town' }),
								_react2.default.createElement('span', { className: 'req_err', id: 'req_city_err' }),
								_react2.default.createElement('input', { type: 'text', ref: 'req_doorno', id: 'req_doorno', value: this.state.req_doorno, onChange: this.req_doornoChange, placeholder: 'Door No / Landmark' }),
								_react2.default.createElement('span', { className: 'req_err', id: 'req_doorno_err' }),
								_react2.default.createElement('input', { type: 'text', maxLength: 6, ref: 'req_pincode', id: 'req_pincode', value: this.state.req_pincode, onChange: this.req_pincodeChange, placeholder: 'Pincode' }),
								_react2.default.createElement('span', { className: 'req_err', id: 'req_pincode_err' }),
								_react2.default.createElement(
									'div',
									{ className: 'req_footer' },
									_react2.default.createElement(
										'a',
										{ onClick: this.close },
										'CANCEL'
									),
									_react2.default.createElement(
										'button',
										{ type: 'submit' },
										'SEND'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'mob_reqbestprice', show: this.state.req_confirm_modal, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							this.state.req_confirm_message,
							_react2.default.createElement(
								'a',
								{ onClick: this.close, className: 'req_conf_ok_btn' },
								'OK'
							)
						)
					)
				);
			}
		}]);
	
		return SeedDetails;
	}(_react.Component);
	
	exports.default = SeedDetails;
	
	var ProductDetails = exports.ProductDetails = function (_Component2) {
		_inherits(ProductDetails, _Component2);
	
		function ProductDetails() {
			_classCallCheck(this, ProductDetails);
	
			var _this5 = _possibleConstructorReturn(this, (ProductDetails.__proto__ || Object.getPrototypeOf(ProductDetails)).call(this));
	
			_this5.state = {
				seedid: localStorage.getItem('seed_id')
			};
	
			return _this5;
		}
	
		_createClass(ProductDetails, [{
			key: 'render',
			value: function render() {
				var mydetails = this.props.data;
				return _react2.default.createElement(
					'div',
					null,
					mydetails.deals_data.oname ? _react2.default.createElement(
						'h4',
						{ style: { color: '#666', paddingTop: '5px', fontWeight: 'bold' } },
						mydetails.deals_data.oname
					) : '',
					mydetails.deals_data.sname ? _react2.default.createElement(
						'h5',
						null,
						mydetails.deals_data.sname
					) : '',
					mydetails.deals_data.price ? _react2.default.createElement(
						'p',
						{ style: { fontWeight: 'bold' } },
						'MRP ',
						_react2.default.createElement('span', null),
						_react2.default.createElement(
							'span',
							{ style: { color: '#333' } },
							'\u20B9 '
						),
						_react2.default.createElement(
							'span',
							{ style: { color: '#666' } },
							mydetails.deals_data.price
						)
					) : ''
				);
			}
		}]);
	
		return ProductDetails;
	}(_react.Component);

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Product = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactShare = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var SeedsCat = function (_Component) {
		_inherits(SeedsCat, _Component);
	
		function SeedsCat(props) {
			_classCallCheck(this, SeedsCat);
	
			var _this = _possibleConstructorReturn(this, (SeedsCat.__proto__ || Object.getPrototypeOf(SeedsCat)).call(this, props));
	
			_this.state = {
				seedsList: [],
				offer: {},
				sort_status: true,
				sort: '1',
				img_price: 'price.png',
				coasts: [],
				coast: '0',
				nodata: false,
				img_data: 'Price',
				open: false,
				latitude: '',
				longitude: '',
				seed_type: _this.props.params.Stype,
				shareUrl: '',
				loading: false,
				web_title: '',
				web_desc: '',
				seo_title: '',
				seo_desc: '',
				cart_count: 0
			};
			_this.showPosition = _this.showPosition.bind(_this);
			_this.showError = _this.showError.bind(_this);
			_this.getNearBy = _this.getNearBy.bind(_this);
			_this.getSort = _this.getSort.bind(_this);
			_this.getCoasts = _this.getCoasts.bind(_this);
			_this.getSelectedCoast = _this.getSelectedCoast.bind(_this);
			_this.getDeviceId = _this.getDeviceId.bind(_this);
			_this.getCartCount = _this.getCartCount.bind(_this);
			return _this;
		}
	
		_createClass(SeedsCat, [{
			key: 'getCartCount',
			value: function getCartCount() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							cart_count: data.cart_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'showPosition',
			value: function showPosition(position) {
				this.setState({
					latitude: position.coords.latitude,
					longitude: position.coords.longitude
				});
			}
		}, {
			key: 'getDeviceId',
			value: function getDeviceId() {
				if (localStorage.user_id) {
					var user_id = localStorage.user_id;
				} else {
					user_id = 0;
				}
				var data1 = { from: 'mobile_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getDeviceId',
					dataType: 'json',
					data: { req: data2 },
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'showError',
			value: function showError(error) {
				switch (error.code) {
					case error.PERMISSION_DENIED:
						// console.log("User denied the request for Geolocation.");
						break;
					case error.POSITION_UNAVAILABLE:
						// console.log("Location information is unavailable.");
						break;
					case error.TIMEOUT:
						// console.log("The request to get user location timed out.");
						break;
					case error.UNKNOWN_ERROR:
						// console.log("An unknown error occurred.");
						break;
					default:
						console.log('');
						break;
				}
			}
		}, {
			key: 'getNearBy',
			value: function getNearBy() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', lat: this.state.latitude, long: this.state.longitude, coast: this.state.coast, sort: this.state.sort, species: this.state.seed_type };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdeals',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.data.length === 0) {
							this.setState({
								nodata: true
							});
						} else {
							this.setState({
								nodata: false,
								seedsList: data.data,
								offer: data
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getCoasts',
			value: function getCoasts() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'coasts',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							coasts: data.coasts
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					window.location.href = "/web/seed/" + this.props.params.Name + "/" + this.props.params.Stype;
				}
	
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
				} else {
					alert("GeoLocation is not supported by the browser");
				}
				if (localStorage.user_id && localStorage.token) {
					this.getCartCount();
				}
				this.getDeviceId();
				this.getCoasts();
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', species: this.state.seed_type };
				var data2 = JSON.stringify(data1);
	
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdeals',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							seedsList: data.data,
							offer: data,
							loading: true,
							web_title: data.title,
							seo_title: data.title + ' Aqua seed deals from Hatcheries',
							seo_desc: 'Browse quality ' + data.title + ' seed deals from CAA approved Hatcheries, shop online and avail free shipment.',
							web_desc: data.desc
						});
						document.title = this.state.web_title + "";
						document.getElementsByTagName("META")[2].content = this.state.seo_desc;
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSort',
			value: function getSort() {
				localStorage.setItem('sort', this.state.sort);
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', sort: this.state.sort, species: this.state.seed_type, coast: this.state.coast };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdeals',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (this.state.sort === 1) {
							var ss = 2;
							var img_price = 'down.png';
							var img_data = 'High - Low';
						} else {
							ss = 1;
							img_price = 'up.png';
							img_data = 'Low - High';
						}
						this.setState({
							sort: ss,
							img_price: img_price,
							img_data: img_data
						});
						this.setState({
							seedsList: data.data,
							offer: data,
							web_title: data.title,
							web_desc: data.desc
						});
						// document.title =this.state.web_title+ "- Seed | AquaDeals | "+this.state.seo_desc;
						document.title = this.state.web_title + "- Seed | AquaDeals";
						document.getElementsByTagName("META")[2].content = this.state.seo_desc;
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSelectedCoast',
			value: function getSelectedCoast(c) {
				this.setState({
					coast: c
				});
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', coast: c, species: this.state.seed_type, sort: localStorage.sort };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdeals',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.data.length === 0) {
							this.setState({
								nodata: true
							});
						} else {
							this.setState({
								nodata: false
							});
						}
						this.setState({
							seedsList: data.data,
							offer: data,
							web_title: data.title,
							web_desc: data.desc
						});
						document.title = this.state.web_title + "- Seed | AquaDeals ";
						document.getElementsByTagName("META")[2].content = this.state.seo_desc;
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var products = this.state.seedsList.map(function (product, index) {
					return _react2.default.createElement(Product, { key: product.deals_data.id, data: product });
				});
				var getTitle = this.state.seed_type === '1' ? 'Vannamei' : 'Tiger';
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals seed_list_cat_page' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: '/' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
									)
								),
								getTitle
							),
							_react2.default.createElement(
								'a',
								{ href: '/', className: 'home_logo1' },
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/home1.png', alt: 'Home' })
							),
							_react2.default.createElement(
								'a',
								{ className: 'mob_cart_btn', href: '/mycart' },
								_react2.default.createElement('img', { alt: '', src: 'https://aquadeals.in/admin/assets/icons/web_icons/cart_icon.png' }),
								this.state.cart_count > 0 ? _react2.default.createElement(
									'span',
									{ className: this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count" },
									this.state.cart_count
								) : ''
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'pag_cntnt' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'container-fluid' },
						this.state.nodata ? _react2.default.createElement(
							'div',
							{ className: 'no_data' },
							_react2.default.createElement(
								'h3',
								null,
								'No Deals Available'
							),
							_react2.default.createElement(
								'p',
								null,
								'Need something here? ',
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: '/customer_care' },
									'CONTACT US'
								),
								' now !'
							)
						) : products.length > 0 ? products : _react2.default.createElement(
							'div',
							{ className: 'no_data' },
							_react2.default.createElement(
								'h3',
								null,
								'No Deals Available'
							),
							_react2.default.createElement(
								'p',
								null,
								'Need something here? ',
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: '/customer_care' },
									'CONTACT US'
								),
								' now !'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'seed_sort' },
						_react2.default.createElement(
							'ul',
							null,
							_react2.default.createElement(
								'li',
								{ className: 'col-md-4 col-xs-4 col-sm-4' },
								_react2.default.createElement(
									'a',
									{ onClick: this.getSort, title: '' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/' + this.state.img_price, alt: 'sort' }),
									_react2.default.createElement(
										'span',
										null,
										this.state.img_data
									)
								)
							),
							_react2.default.createElement(
								'li',
								{ className: 'col-md-4 col-xs-4 col-sm-4 coast_list ' },
								_react2.default.createElement(
									_reactBootstrap.ButtonToolbar,
									null,
									_react2.default.createElement(
										_reactBootstrap.DropdownButton,
										{ className: 'test_filter', noCaret: true, title: 'Coasts', dropup: true },
										this.state.coasts.map(function (coast, index) {
											return _react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ eventKey: coast.id, onClick: function onClick() {
														return _this2.getSelectedCoast(coast.id);
													} },
												coast.coast
											);
										})
									)
								)
							),
							_react2.default.createElement(
								'li',
								{ className: 'col-md-4 col-xs-4 col-sm-4' },
								_react2.default.createElement(
									'a',
									{ onClick: this.getNearBy, title: '' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/nearby.png', alt: 'nearby' }),
									' ',
									_react2.default.createElement(
										'span',
										null,
										'Nearby'
									),
									' '
								)
							)
						)
					)
				);
			}
		}]);
	
		return SeedsCat;
	}(_react.Component);
	
	exports.default = SeedsCat;
	
	var Product = exports.Product = function (_Component2) {
		_inherits(Product, _Component2);
	
		function Product() {
			_classCallCheck(this, Product);
	
			var _this3 = _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).call(this));
	
			_this3.state = {
				open: false
			};
			_this3.ShareFunc = _this3.ShareFunc.bind(_this3);
			return _this3;
		}
	
		_createClass(Product, [{
			key: 'ShareFunc',
			value: function ShareFunc(evnt) {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', type: 0, did: evnt };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'createTinyurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							msg: data.msg,
							shareUrl: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {}
				});
				this.setState({ open: !this.state.open });
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var mydata = this.props.data;
				var shareUrl = this.state.shareUrl;
				var title = "Hey Click here " + shareUrl + " to check " + mydata.deals_data.sname + " from AquaDeals.";
				var description = shareUrl;
				return _react2.default.createElement(
					'div',
					{ className: 'list_card' },
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: "/sdetails/" + mydata.deals_data.sname + "/" + mydata.deals_data.id },
						_react2.default.createElement(
							'div',
							{ className: 'list_img' },
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/seller_imgs/thumbnails/' + mydata.deals_data.image, alt: 'AquaDeals', role: 'presentation' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'list_txt' },
							mydata.deals_data.sname ? _react2.default.createElement(
								'h4',
								{ style: { color: '#111' } },
								mydata.deals_data.sname
							) : '',
							mydata.deals_data.discount_price > 0 ? _react2.default.createElement(
								'h5',
								null,
								'\u20B9 ',
								mydata.offer,
								' off on 1M'
							) : '',
							mydata.deals_data.price ? _react2.default.createElement(
								'p',
								null,
								_react2.default.createElement('span', null),
								_react2.default.createElement(
									'span',
									{ style: { color: '#111' } },
									'\u20B9'
								),
								_react2.default.createElement(
									'span',
									{ style: { color: '#111' } },
									mydata.deals_data.price
								)
							) : '',
							mydata.deals_data.rate >= 1 ? _react2.default.createElement(
								'h6',
								null,
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/star_filled.png', width: '16px', role: 'presentation' })
								),
								' ',
								mydata.deals_data.rate,
								' '
							) : _react2.default.createElement(
								'h6',
								null,
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/star_gray.png', width: '16px', role: 'presentation' })
								)
							)
						)
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ className: 'share_list', onClick: function onClick() {
								_this4.ShareFunc(mydata.deals_data.id);
							} },
						_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/share1.png', alt: 'share' })
					),
					mydata.view_status > 0 ? _react2.default.createElement(
						'h6',
						{ className: 'views_eye' },
						_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/eye.png', width: '17px', role: 'presentation' }),
						' ',
						mydata.view_status,
						' ',
						mydata.view_status > 1 ? 'Views' : 'View'
					) : '',
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_reactBootstrap.Panel,
							{ className: 'share_panel', collapsible: true, expanded: this.state.open },
							_react2.default.createElement(
								FacebookShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share' },
								_react2.default.createElement(FacebookIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								TwitterShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share' },
								_react2.default.createElement(TwitterIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								GooglePlusShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share' },
								_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
							)
						)
					)
				);
			}
		}]);
	
		return Product;
	}(_react.Component);

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Product = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactShare = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var SeedsList = function (_Component) {
		_inherits(SeedsList, _Component);
	
		function SeedsList(props) {
			_classCallCheck(this, SeedsList);
	
			var _this = _possibleConstructorReturn(this, (SeedsList.__proto__ || Object.getPrototypeOf(SeedsList)).call(this, props));
	
			_this.state = {
				seedsList: [],
				offer: {},
				sort_status: true,
				sort: '0',
				img_price: 'price.png',
				coasts: [],
				seed_filters: [],
				sort_title: 'Sort By',
				coast: '0',
				nodata: false,
				img_data: 'Price',
				open: false,
				latitude: '',
				longitude: '',
				loading: false,
				web_title: '',
				web_desc: '',
				seo_title: '',
				seo_desc: '',
	
				cart_count: 0,
				sort_coast_title: 'Coasts',
				loading_gif: false
			};
			_this.showPosition = _this.showPosition.bind(_this);
			_this.showError = _this.showError.bind(_this);
			_this.getNearBy = _this.getNearBy.bind(_this);
			_this.getSort = _this.getSort.bind(_this);
			_this.getCoasts = _this.getCoasts.bind(_this);
			_this.getSelectedCoast = _this.getSelectedCoast.bind(_this);
			_this.getDeviceId = _this.getDeviceId.bind(_this);
			_this.getCartCount = _this.getCartCount.bind(_this);
			_this.getSeedFilters = _this.getSeedFilters.bind(_this);
			return _this;
		}
	
		_createClass(SeedsList, [{
			key: 'getCartCount',
			value: function getCartCount() {
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							cart_count: data.cart_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSeedFilters',
			value: function getSeedFilters() {
				var data1 = { from: 'mobile_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'seedFilters',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							seed_filters: data.sort
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'showPosition',
			value: function showPosition(position) {
				localStorage.setItem('lat', position.coords.latitude);
				localStorage.setItem('long', position.coords.longitude);
				this.setState({
					latitude: position.coords.latitude,
					longitude: position.coords.longitude
				}.bind(this));
			}
		}, {
			key: 'showError',
			value: function showError(error) {
				switch (error.code) {
					case error.PERMISSION_DENIED:
						console.log("User denied the request for Geolocation.");
						break;
					case error.POSITION_UNAVAILABLE:
						console.log("Location information is unavailable.");
						break;
					case error.TIMEOUT:
						console.log("The request to get user location timed out.");
						break;
					case error.UNKNOWN_ERROR:
						console.log("An unknown error occurred.");
						break;
					default:
						break;
				}
			}
		}, {
			key: 'getDeviceId',
			value: function getDeviceId() {
				if (localStorage.user_id) {
					var user_id = localStorage.user_id;
				} else {
					user_id = 0;
				}
				var data1 = { from: 'mobile_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getDeviceId',
					dataType: 'json',
					data: { req: data2 },
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'getNearBy',
			value: function getNearBy() {
				this.setState({
					loading_gif: true
				});
				var data1 = { from: 'mobile_web', lat: this.state.latitude, long: this.state.longitude, sort: this.state.sort };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdeals',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.data.length === 0) {
							this.setState({
								nodata: true,
								loading_gif: false
							});
						} else {
							this.setState({
								nodata: false,
								seedsList: data.data,
								offer: data,
								web_title: data.title,
								web_desc: data.desc,
								loading_gif: false
							});
							// document.title =this.state.web_title +  " - Deals | AquaDeals | "+this.state.seo_desc;
							document.title = this.state.web_title + " - Deals | AquaDeals ";
							document.getElementsByTagName("META")[2].content = this.state.seo_desc;
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getCoasts',
			value: function getCoasts() {
				var data1 = { from: 'mobile_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'coasts',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							coasts: data.coasts
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					window.location.href = "/web/seed";
				}
				localStorage.removeItem('m_r_s_dt');
				/*if(navigator.geolocation)
	   {
	   	navigator.geolocation.getCurrentPosition(this.showPosition,this.showError);
	   }
	   */
				this.getSeedFilters();
				this.getCoasts();
				this.getDeviceId();
				if (localStorage.user_id && localStorage.token) {
					this.getCartCount();
				}
				var data1 = { from: 'mobile_web', sort: '0', coast: '0' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdeals',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							seedsList: data.data,
							offer: data,
							web_title: data.title,
							web_desc: data.desc,
							loading: true,
							seo_title: "Vannamei,Tiger seed deals from Hatcheries",
							seo_desc: 'Browse quality Vannamei,Tiger seed deals from CAA approved Hatcheries, shop online and avail free shipment.'
						});
						// document.title =this.state.web_title+  " - Deals | AquaDeals | "+this.state.seo_desc;
						document.title = this.state.seo_title;
						document.getElementsByTagName("META")[2].content = this.state.seo_desc;
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'getSort',
			value: function getSort(id, type) {
				this.setState({
					loading_gif: true
				});
				localStorage.setItem('sort', this.state.sort);
				var data1 = { from: 'mobile_web', sort: id, coast: this.state.coast };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdeals',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (this.state.sort === 1) {
							var ss = 2;
							var img_price = 'down.png';
							var img_data = 'High - Low';
						} else {
							ss = 1;
							img_price = 'up.png';
							img_data = 'Low - High';
						}
						this.setState({
							sort: ss,
							img_price: img_price,
							img_data: img_data,
							seedsList: data.data,
							offer: data,
							sort_title: type,
							loading_gif: false
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'getSelectedCoast',
			value: function getSelectedCoast(c, type) {
				if (this.state.sort === 1) {
					this.setState({
						sort: '2',
						loading_gif: true
					});
				} else {
					this.setState({
						sort: '1',
						loading_gif: true
					});
				}
				this.setState({
					coast: c,
					loading_gif: true
				});
				var data1 = { from: 'mobile_web', coast: c, sort: localStorage.sort };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getdeals',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.data.length === 0) {
							this.setState({
								nodata: true,
								loading_gif: false
							});
						} else {
							this.setState({
								nodata: false,
								loading_gif: false
							});
						}
						this.setState({
							seedsList: data.data,
							offer: data,
							sort_coast_title: type,
							loading_gif: false
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var products = this.state.seedsList.map(function (product, index) {
					return _react2.default.createElement(Product, { key: product.deals_data.id, data: product, onUpdate: function onUpdate() {
							return _this2.getCartCount();
						} });
				});
				// var coasts = this.state.coasts.map((coast,index) => (<Coasts key={coast.id} data={coast} getSelectedCoast={this.getSelectedCoast} />));
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals' },
					this.state.loading ? _react2.default.createElement(
						'div',
						{ className: 'seed_list_page mob_seedlist_page' },
						_react2.default.createElement(
							'div',
							{ className: 'page_hdr' },
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: "/" },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
										)
									),
									' Seed'
								),
								_react2.default.createElement(
									'a',
									{ href: '/', className: 'home_logo1' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/home1.png', alt: 'Home' })
								),
								_react2.default.createElement(
									'a',
									{ className: 'mob_cart_btn', href: '/mycart' },
									_react2.default.createElement('img', { alt: '', src: baseAssets + 'icons/web_icons/cart_icon.png' }),
									this.state.cart_count > 0 ? _react2.default.createElement(
										'span',
										{ className: this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count" },
										this.state.cart_count
									) : ''
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'pag_cntnt' },
							'\xA0'
						),
						this.state.loading_gif ? _react2.default.createElement(
							'i',
							{ className: 'mob_loading' },
							_react2.default.createElement('img', { src: baseAssets + 'images/mob_loading.gif', alt: 'Loading' })
						) : '',
						_react2.default.createElement(
							'section',
							{ className: '' },
							this.state.nodata ? _react2.default.createElement(
								'div',
								{ className: 'no_data' },
								_react2.default.createElement(
									'h3',
									null,
									'No Deals Available'
								),
								_react2.default.createElement(
									'p',
									null,
									'Need something here? ',
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: "/customer_care" },
										'CONTACT US'
									),
									' Now !'
								)
							) : products.length > 0 ? products : _react2.default.createElement(
								'div',
								{ className: 'no_data' },
								_react2.default.createElement(
									'h3',
									null,
									'No Deals Available'
								),
								_react2.default.createElement(
									'p',
									null,
									'Need something here? ',
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: '/customer_care' },
										'CONTACT US'
									),
									' Now !'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							),
							_react2.default.createElement(
								'div',
								{ className: 'clr' },
								'\xA0'
							)
						),
						_react2.default.createElement(
							'section',
							{ className: 'seed_sort dsl_srt' },
							_react2.default.createElement(
								'ul',
								null,
								_react2.default.createElement(
									'li',
									{ className: 'col-md-6 col-xs-6 col-sm-6 coast_list ', style: { cursor: 'pointer' } },
									_react2.default.createElement(
										_reactBootstrap.ButtonToolbar,
										null,
										_react2.default.createElement(
											_reactBootstrap.DropdownButton,
											{ className: 'test_filter_4', noCaret: true, title: this.state.sort_title, dropup: true },
											_react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ header: true },
												'Sort By'
											),
											this.state.seed_filters.map(function (seed, index) {
												return _react2.default.createElement(
													_reactBootstrap.MenuItem,
													{ className: 'seed_list', eventKey: seed.id, onClick: function onClick() {
															return _this2.getSort(seed.id, seed.type);
														} },
													seed.type
												);
											})
										)
									)
								),
								_react2.default.createElement(
									'li',
									{ className: 'col-md-6 col-xs-6 col-sm-6 coast_list ', style: { cursor: 'pointer' } },
									_react2.default.createElement(
										_reactBootstrap.ButtonToolbar,
										null,
										_react2.default.createElement(
											_reactBootstrap.DropdownButton,
											{ className: 'test_filter', noCaret: true, title: this.state.sort_coast_title, dropup: true },
											_react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ header: true },
												'Coasts : ',
												this.state.coasts.length,
												' '
											),
											this.state.coasts.map(function (coast, index) {
												return _react2.default.createElement(
													_reactBootstrap.MenuItem,
													{ className: 'seed_list', eventKey: coast.id, onClick: function onClick() {
															return _this2.getSelectedCoast(coast.id, coast.coast);
														} },
													coast.coast
												);
											})
										)
									)
								)
							)
						)
					) : _react2.default.createElement(
						'div',
						{ className: 'mob_loading' },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/mob_loading.gif', alt: 'Loading', role: 'presentation' }),
						' '
					)
				);
			}
		}]);
	
		return SeedsList;
	}(_react.Component);
	
	exports.default = SeedsList;
	
	var Product = exports.Product = function (_Component2) {
		_inherits(Product, _Component2);
	
		function Product(props) {
			_classCallCheck(this, Product);
	
			var _this3 = _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).call(this, props));
	
			_this3.state = {
				open: false,
				shareUrl: '',
				msg: '',
				cart_count: '',
				clearcart_status: false,
				already_added_status: false
			};
			_this3.ShareFunc = _this3.ShareFunc.bind(_this3);
			_this3.addToCart = _this3.addToCart.bind(_this3);
			_this3.updateCartCount = _this3.updateCartCount.bind(_this3);
			_this3.close = _this3.close.bind(_this3);
			_this3.replaceCartItems = _this3.replaceCartItems.bind(_this3);
			_this3.addToQuickCart = _this3.addToQuickCart.bind(_this3);
			_this3.addToQuickCart_Onload = _this3.addToQuickCart_Onload.bind(_this3);
			return _this3;
		}
	
		_createClass(Product, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (localStorage.user_id && localStorage.token && localStorage.quickbuy_onload) {
					this.addToQuickCart_Onload();
					localStorage.removeItem('quickbuy_onload');
					localStorage.removeItem('quickbuy_deal_id');
				}
			}
		}, {
			key: 'ShareFunc',
			value: function ShareFunc(evnt) {
				var _this4 = this;
	
				var data1 = { from: 'mobile_web', type: 0, did: evnt };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'createTinyurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							msg: data.msg,
							shareUrl: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
				this.setState({
					open: !this.state.open
				});
				setTimeout(function () {
					_this4.setState({ open: false });
				}, 5000);
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					clearcart_status: false,
					already_added_status: false
				});
			}
		}, {
			key: 'replaceCartItems',
			value: function replaceCartItems(deal_id, quantity) {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 0, quantity: quantity, pl_size: 0, salinity: 0, pickup_date: 0, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'replaceCart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								clearcart_status: false
							});
							_reactRouter.browserHistory.push('/mycart');
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'updateCartCount',
			value: function updateCartCount() {
				this.props.onUpdate();
			}
		}, {
			key: 'addToQuickCart',
			value: function addToQuickCart(deal_id) {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('seed', '/seed');
					localStorage.setItem('quickbuy_onload', '1');
					localStorage.setItem('quickbuy_deal_id', deal_id);
					_reactRouter.browserHistory.push('/login');
				} else {
					var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 0, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'post',
						dataType: 'json',
						url: baseUrl + 'addToQCart',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.updateCartCount();
								_reactRouter.browserHistory.push('/quickcart');
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							} else if (data.status === "error" && data.cart_flag === 0) {
								this.setState({
									clearcart_status: true
								});
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							}
							localStorage.removeItem('quickbuy_onload');
							localStorage.removeItem('quickbuy_deal_id');
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'addToQuickCart_Onload',
			value: function addToQuickCart_Onload() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('seed', '/seed');
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.user_id;
					} else {
						uid = 0;
					}
					if (localStorage.quickbuy_deal_id) {
						var deal_id = localStorage.quickbuy_deal_id;
					} else {
						deal_id = 0;
					}
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 0, source: source, campaign: campaign, url_id: url_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'post',
						dataType: 'json',
						url: baseUrl + 'addToQCart',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.updateCartCount();
								_reactRouter.browserHistory.push('/quickcart');
								localStorage.removeItem('quickbuy_deal_id');
								localStorage.removeItem('quickbuy_onload');
							} else if (data.status === "error" && data.cart_flag === 0) {
								this.setState({
									clearcart_status: true
								});
								localStorage.removeItem('quickbuy_deal_id');
								localStorage.removeItem('quickbuy_onload');
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
								localStorage.removeItem('quickbuy_deal_id');
								localStorage.removeItem('quickbuy_onload');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'addToCart',
			value: function addToCart(deal_id) {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('seed', '/seed');
					_reactRouter.browserHistory.push('/login');
				}
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 0, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'quickBuy',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success") {
							this.updateCartCount();
							_reactRouter.browserHistory.push('/mycart');
						} else if (data.status === "error" && data.cart_flag === 0) {
							this.setState({
								clearcart_status: true
							});
						} else if (data.status === "error" && data.message === "Product already added to the cart") {
							this.setState({
								already_added_status: true
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var mydata = this.props.data;
				var shareUrl = this.state.shareUrl;
				var title = "Hey Click here " + shareUrl + " to check " + mydata.deals_data.sname + " from AquaDeals.";
				var description = shareUrl;
				var no_data = '';
				if (mydata.length === 0) {
					no_data = _react2.default.createElement(
						'div',
						{ className: 'no_data' },
						_react2.default.createElement(
							'h3',
							null,
							'No Deals Available'
						),
						_react2.default.createElement(
							'p',
							null,
							'Need something here? ',
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: "/customer_care" },
								'CONTACT US'
							),
							' Now !'
						)
					);
				} else {
					no_data = "";
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'list_card seedlist_card' },
					no_data,
					mydata.promo_ribbion ? _react2.default.createElement(
						'i',
						{ className: 'ribbon_img' },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + mydata.promo_ribbion, alt: '' })
					) : '',
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: "/sdetails/" + mydata.deals_data.sname + "/" + mydata.deals_data.id },
						_react2.default.createElement(
							'div',
							{ className: 'list_img' },
							_react2.default.createElement('img', { src: baseAssets + 'images/seller_imgs/thumbnails/' + mydata.deals_data.image, alt: ' ', role: 'presentation' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'list_txt' },
							_react2.default.createElement(
								'h4',
								{ style: { color: '#333' } },
								mydata.deals_data.sname
							),
							_react2.default.createElement(
								'h5',
								null,
								mydata.deals_data.oname
							),
							mydata.deals_data.price ? _react2.default.createElement(
								'p',
								null,
								_react2.default.createElement('span', null),
								_react2.default.createElement(
									'span',
									{ style: { color: '#333' } },
									'\u20B9 '
								),
								_react2.default.createElement(
									'span',
									{ style: { color: '#666' } },
									mydata.deals_data.price
								)
							) : '',
							mydata.offer > 0 ? _react2.default.createElement(
								'h5',
								{ className: 'seed_price' },
								_react2.default.createElement(
									'span',
									null,
									'\u20B9 '
								),
								mydata.offer,
								' off on 1M'
							) : '',
							mydata.deals_data.discount_price > 0 ? _react2.default.createElement(
								'h5',
								{ className: 'seed_price' },
								_react2.default.createElement(
									'span',
									null,
									'\u20B9 '
								),
								mydata.offer,
								' off on 1M'
							) : '',
							mydata.deals_data.rate >= 1 ? _react2.default.createElement(
								'h6',
								null,
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/star_filled.png', width: '16px', role: 'presentation' })
								),
								mydata.deals_data.rate
							) : _react2.default.createElement(
								'h6',
								null,
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/star_gray.png', width: '16px', role: 'presentation' })
								)
							)
						)
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ className: 'share_list', onClick: function onClick() {
								_this5.ShareFunc(mydata.deals_data.id);
							} },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/share1.png', alt: 'share' })
					),
					mydata.view_status > 0 ? _react2.default.createElement(
						'h6',
						{ className: 'views_eye' },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/views.png', width: '17px', role: 'presentation' }),
						' ',
						mydata.view_status,
						' ',
						mydata.view_status > 1 ? 'Views' : 'View'
					) : '',
					_react2.default.createElement(
						'a',
						{ className: 'seed_quick_buy_img', onClick: function onClick() {
								return _this5.addToQuickCart(mydata.deals_data.id);
							} },
						_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/icons/quick_buy.png', alt: ' ', width: '50px' })
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_reactBootstrap.Panel,
							{ className: 'share_panel', collapsible: true, expanded: this.state.open },
							_react2.default.createElement(
								FacebookShareButton,
								{ url: shareUrl, quote: title, className: 'test_share' },
								_react2.default.createElement(FacebookIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								TwitterShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share' },
								_react2.default.createElement(TwitterIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								GooglePlusShareButton,
								{ url: shareUrl, quote: title, descirption: description, className: 'test_share' },
								_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.clearcart_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#333' } },
								'You can\'t have multiple seller items in the cart. Empty existing cart & add this item ',
								mydata.deals_data.sname,
								'?'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'NO'
							),
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: function onClick() {
											_this5.replaceCartItems(mydata.deals_data.id, mydata.deals_data.min_allowed_qty);
										} },
									'YES'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.already_added_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#333' } },
								'Product already added to the cart'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'OK'
							)
						)
					)
				);
			}
		}]);
	
		return Product;
	}(_react.Component);

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SmartCart = function (_Component) {
		_inherits(SmartCart, _Component);
	
		function SmartCart(props) {
			_classCallCheck(this, SmartCart);
	
			var _this = _possibleConstructorReturn(this, (SmartCart.__proto__ || Object.getPrototypeOf(SmartCart)).call(this, props));
	
			_this.state = {
				cartcount: '',
				page_loading: false,
				smart_filters: [],
				smart_deals: [],
				active_filter: 0,
	
				//  add to cart values
				replace_did: '',
				replace_deal_type: '',
				replace_qty: '',
				replace_pl_size: '',
				replace_salinity: '',
				replace_pickup_date: '',
				replace_id: '',
				replace_product_name: '',
	
				cart_status: false,
				cart_status_msg: '',
				clearcart_status: false,
				cart_added_status: false
				// cart values ends here
			};
			_this.getSmartFilters = _this.getSmartFilters.bind(_this);
			_this.getSmartDeals = _this.getSmartDeals.bind(_this);
			_this.getSmartDealsByType = _this.getSmartDealsByType.bind(_this);
			_this.addToCart = _this.addToCart.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.replaceCartItems = _this.replaceCartItems.bind(_this);
			_this.getCartCount = _this.getCartCount.bind(_this);
			_this.tokenCheck = _this.tokenCheck.bind(_this);
			return _this;
		}
	
		_createClass(SmartCart, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (!localStorage.token && !localStorage.user_id) {
					localStorage.setItem('smartcart', '/smartcart');
					_reactRouter.browserHistory.push('/login');
				} else {
					this.getCartCount();
					this.getSmartFilters();
					this.getSmartDeals();
				}
			}
		}, {
			key: 'tokenCheck',
			value: function tokenCheck() {
				localStorage.removeItem('user_id');
				localStorage.removeItem('token');
				window.location.reload();
			}
		}, {
			key: 'getSmartFilters',
			value: function getSmartFilters() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'smart_list_filters',
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								smart_filters: data.filters
							});
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSmartDeals',
			value: function getSmartDeals() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, dtype: 0 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'smart_list',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								smart_deals: data.data
							});
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.tokenCheck();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSmartDealsByType',
			value: function getSmartDealsByType(dtype) {
				this.setState({
					active_filter: dtype
				});
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, dtype: dtype };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'smart_list',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								smart_deals: data.data
							});
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
			// data.did,data.dtype,data.qty,data.pl,data.salinity,data.pickup_date,data.id,data.product_name
	
		}, {
			key: 'addToCart',
			value: function addToCart(did, deal_type, qty, pl, salinity, pickup_date, id, product_name) {
				this.setState({
					replace_did: did,
					replace_deal_type: deal_type,
					replace_qty: qty,
					replace_pl_size: pl,
					replace_salinity: salinity,
					replace_pickup_date: pickup_date,
					replace_id: id,
					replace_product_name: product_name
				});
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, deal_id: did, deal_type: deal_type, quantity: qty, pl_size: pl, salinity: salinity, pickup_date: pickup_date };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'addToCart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success" && data.message === "Added to cart") {
							// this.setState({
							// 	cart_status:true,
							// 	cart_status_msg:data.message,
							// });
							_reactRouter.browserHistory.push('/mycart');
						}
						if (data.status === "success" && data.message === "Cart Updated") {
							this.setState({
								cart_status: true,
								cart_status_msg: data.message
							});
						}
						if (data.status === "error" && data.cart_flag === 0) {
							this.setState({
								clearcart_status: true
							});
						}
						if (data.status === "error" && data.message === "Product already added to the cart" && data.cart_flag === 1) {
							this.setState({
								cart_added_status: true
							});
						}
						this.getCartCount();
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'replaceCartItems',
			value: function replaceCartItems() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: this.state.replace_did, deal_type: this.state.replace_deal_type, quantity: this.state.replace_qty, pl_size: this.state.replace_pl, salinity: this.state.replace_salinity, pickup_date: this.state.replace_pickup_date };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'replaceCart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success" && data.cart_flag === 1) {
							// this.setState({
							// 	clearcart_status:false,
							// 	cart_status:true,
							// 	cart_status_msg:data.message,
							// });
							_reactRouter.browserHistory.push('/mycart');
						} else {
							this.getCartCount();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					cart_status: false,
					clearcart_status: false,
					cart_added_status: false
				});
			}
		}, {
			key: 'getCartCount',
			value: function getCartCount() {
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								cartcount: data.cart_count
							});
						} else if (data.status === 'error' && data.message === 'Token mismatch') {
							localStorage.clear();
							window.location.reload();
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				document.title = "Smart Cart | AquaDeals";
				var smart_filters = this.state.smart_filters.map(function (data, index) {
					var _this2 = this;
	
					return _react2.default.createElement(
						'a',
						{ className: this.state.active_filter === data.id ? "smt_fltr_item smt_fltr_item_active" : "smt_fltr_item", onClick: function onClick() {
								_this2.getSmartDealsByType(data.id);
							} },
						data.name,
						this.state.active_filter === data.id ? _react2.default.createElement(
							'i',
							{ className: 'smt_arrow' },
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/triangle_up.png', alt: ' ', style: { width: '20px', height: '18px' } })
						) : ''
					);
				}.bind(this));
				var smart_deals = this.state.smart_deals.map(function (data, index) {
					var _this3 = this;
	
					return _react2.default.createElement(
						'div',
						{ className: 'col-lg-6 col-md-6 col-sm-6 col-xs-6 smt_dtls_item' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: data.type === 0 ? "/sdetails/" + data.sname + "/" + data.did : "/pdetails/" + data.url_dtype_name + "/" + data.url_cat_name + "/" + data.url_brand_name + "/" + data.url_product_name + "/" + data.pid + "/" + data.id },
							_react2.default.createElement(
								'div',
								{ className: 'smt_img_blk' },
								_react2.default.createElement(
									'i',
									null,
									_react2.default.createElement('img', { src: data.img, alt: '' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'smt_data_blk' },
								data.product_name ? _react2.default.createElement(
									'h5',
									{ className: 'smt_pro_name' },
									data.product_name
								) : _react2.default.createElement(
									'h5',
									{ className: 'smt_pro_name' },
									'\xA0'
								),
								data.brand_name ? _react2.default.createElement(
									'h6',
									{ className: 'smt_pro_brand' },
									data.brand_name
								) : _react2.default.createElement(
									'h6',
									{ className: 'smt_pro_brand' },
									'\xA0'
								),
								data.mrp ? _react2.default.createElement(
									'p',
									{ className: 'smt_pro_price' },
									'MRP : \u20B9 ',
									data.mrp
								) : _react2.default.createElement(
									'p',
									{ className: 'smt_pro_price' },
									'\xA0'
								),
								data.date ? _react2.default.createElement(
									'p',
									{ className: 'smt_pro_date' },
									'Date : ',
									data.date
								) : _react2.default.createElement(
									'p',
									null,
									'\xA0'
								)
							)
						),
						data.cart_flag === 1 ? _react2.default.createElement(
							'div',
							{ className: 'smt_add_blk' },
							_react2.default.createElement(
								'a',
								{ className: 'smt_add_cart_btn', href: '/mycart' },
								'GO TO CART'
							)
						) : _react2.default.createElement(
							'div',
							{ className: 'smt_add_blk' },
							_react2.default.createElement(
								'a',
								{ className: 'smt_add_cart_btn', onClick: function onClick() {
										_this3.addToCart(data.did, data.type, data.qty, data.pl, data.salinity, data.pickup_date, data.id, data.product_name);
									} },
								'ADD TO CART'
							)
						)
					);
				}.bind(this));
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals mob_smartcart' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						this.state.cartcount !== 0 ? _react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: '/' },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { className: 'cross_icon', src: 'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png', width: '14px', alt: '' })
									)
								),
								' SMART CART'
							),
							_react2.default.createElement(
								'a',
								{ href: '/', className: 'home_newicon' },
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/home1.png', alt: 'Home' })
							),
							_react2.default.createElement(
								'a',
								{ className: 'mob_smart_cart_btn', href: '/mycart' },
								_react2.default.createElement('img', { alt: '', src: 'https://aquadeals.in/admin/assets/icons/web_icons/cart_icon.png' }),
								this.state.cartcount > 0 ? _react2.default.createElement(
									'span',
									{ className: "mob_cart_count1" },
									this.state.cart_count > 9 ? _react2.default.createElement(
										'span',
										null,
										this.state.cartcount
									) : _react2.default.createElement(
										'span',
										null,
										'\xA0',
										this.state.cartcount,
										'\xA0'
									)
								) : ''
							)
						) : _react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ onClick: function onClick() {
											_reactRouter.browserHistory.goBack();
										} },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png', width: '16px', alt: '' })
									)
								),
								' Smart Cart'
							),
							_react2.default.createElement(
								'a',
								{ href: '/', className: 'home_logo_cart' },
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/home1.png', alt: 'Home' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					smart_filters.length > 0 ? _react2.default.createElement(
						'div',
						{ className: '' },
						this.state.page_loading ? _react2.default.createElement(
							'div',
							{ className: 'checkout_loading' },
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/loading_more.gif', alt: 'Loading' })
						) : _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'smt_fltrs_blk' },
								_react2.default.createElement(
									'div',
									null,
									smart_filters
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'smt_deals_blk' },
								smart_deals.length > 0 ? smart_deals : _react2.default.createElement(
									'div',
									{ className: 'no_data' },
									'No Previous Orders Found'
								)
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal,
							{ className: 'm_pro_full_dtls_modal', show: this.state.cart_status, onHide: this.close },
							_react2.default.createElement(
								_reactBootstrap.Modal.Header,
								{ closeButton: true },
								_react2.default.createElement(
									_reactBootstrap.Modal.Title,
									{ style: { fontSize: '16px', color: '#333' } },
									'Alert'
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal.Body,
								null,
								_react2.default.createElement(
									'h4',
									{ style: { fontSize: '14px', color: '#666' } },
									this.state.cart_status_msg
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal.Footer,
								{ className: 'modal_footer' },
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
									'Close'
								)
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal,
							{ className: 'm_pro_full_dtls_modal', show: this.state.clearcart_status, onHide: this.close },
							_react2.default.createElement(
								_reactBootstrap.Modal.Header,
								{ closeButton: true },
								_react2.default.createElement(
									_reactBootstrap.Modal.Title,
									{ style: { fontSize: '16px', color: '#333' } },
									'Alert'
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal.Body,
								null,
								_react2.default.createElement(
									'h4',
									{ style: { fontSize: '14px', color: '#333' } },
									'You can\'t have multiple seller items in the cart. Empty existing cart & add this item ',
									this.state.replace_pro_title,
									'?'
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal.Footer,
								{ className: 'modal_footer' },
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
									'NO'
								),
								_react2.default.createElement(
									'a',
									null,
									_react2.default.createElement(
										_reactBootstrap.Button,
										{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: function onClick() {
												_this4.replaceCartItems();
											} },
										'YES'
									)
								)
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal,
							{ className: 'm_pro_full_dtls_modal', show: this.state.cart_added_status, onHide: this.close },
							_react2.default.createElement(
								_reactBootstrap.Modal.Header,
								{ closeButton: true },
								_react2.default.createElement(
									_reactBootstrap.Modal.Title,
									{ style: { fontSize: '16px', color: '#333' } },
									'Alert'
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal.Body,
								null,
								_react2.default.createElement(
									'h4',
									{ style: { fontSize: '14px', color: '#666' } },
									'Product already added to the cart!'
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal.Footer,
								{ className: 'modal_footer' },
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
									'Close'
								)
							)
						)
					) : _react2.default.createElement(
						'div',
						{ className: 'no_data' },
						'No Previous Orders Found'
					)
				);
			}
		}]);
	
		return SmartCart;
	}(_react.Component);
	
	exports.default = SmartCart;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var ADStores = function (_Component) {
		_inherits(ADStores, _Component);
	
		function ADStores(props) {
			_classCallCheck(this, ADStores);
	
			var _this = _possibleConstructorReturn(this, (ADStores.__proto__ || Object.getPrototypeOf(ADStores)).call(this, props));
	
			_this.state = {
				deal_offers: [],
				deal_details: [],
				arrowImage: '',
				dealoffer_name: '',
				bgImage: '',
				deal_bg_img: '',
				url_name: '',
				isToggle: false,
				check_swipe_id: '',
				is_loaded: false
			};
			_this.getblockDetails = _this.getblockDetails.bind(_this);
			return _this;
		}
	
		_createClass(ADStores, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				var data1 = { from: 'mobile_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					url: baseUrl + 'getdealOffers',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							deal_offers: data.deal_offers,
							is_loaded: true
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getblockDetails',
			value: function getblockDetails(block_id) {
				var currentState = this.state.isToggle;
				this.setState({
					arrowImage: block_id
				});
				if (block_id !== this.state.check_swipe_id) {
					this.setState({ isToggle: true });
					var data1 = { from: 'mobile_web', id: block_id };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'POST',
						url: baseUrl + 'getOfferDeals',
						dataType: 'json',
						data: { req: data2 },
						success: function (data) {
							this.setState({
								deal_details: data.deal_blocks,
								deal_bg_img: baseAssets + 'images/' + data.blck_img,
								dealoffer_name: data.arrayname,
								url_name: data.url_name,
								check_swipe_id: block_id
							});
						}.bind(this),
						error: function error(err) {}
					});
				} else {
					this.setState({ isToggle: !currentState });
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var params = {
					paginationClickable: true,
					spaceBetween: 10,
					slidesPerView: 3,
					parallax: true,
					parallaxEl: '.parallax-bg'
					// parallaxEl: {
					//   el: '.parallax-bg',
					//   value: '-23%'
					// },
				};
				var mob_swipe_blocks = this.state.deal_offers.map(function (block, index) {
					var _this2 = this;
	
					return _react2.default.createElement(
						'div',
						{ className: 'swipe_blocks_list', onClick: function onClick() {
								_this2.getblockDetails(block.id);
							} },
						block.img === '' ? '' : _react2.default.createElement('img', { className: 'store_pic', src: 'https://aquadeals.in/admin/assets/images/' + block.img, alt: ' ' }),
						_react2.default.createElement(
							'p',
							{ className: 'block_name' },
							block.type
						),
						this.state.isToggle ? _react2.default.createElement(
							'p',
							{ className: 'block_arrow' },
							this.state.arrowImage === block.id ? _react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/' + block.arrow_img, alt: ' ' }) : ''
						) : ''
					);
				}.bind(this));
	
				var swipe_all = '';
	
				if (this.state.deal_details.length > 0) {
					swipe_all = this.state.deal_details.map(function (block, index) {
						return _react2.default.createElement(
							'div',
							{ className: block.pro_title === "View More" ? "swipe_dtls_content1" : 'swipe_dtls_content' },
							this.state.dealoffer_name === "Imported" ? _react2.default.createElement(
								_reactRouter.Link,
								{ to: '/pdeals/' + block.url_dtype + '/' + block.url_name + '/' + block.id + '/' + block.type + '/' + block.pro_id },
								block.image === '' ? '' : _react2.default.createElement('img', { className: 'sw_dtls_img', src: 'https://aquadeals.in/admin/assets/images/' + block.image, alt: ' ' }),
								block.pro_title ? _react2.default.createElement(
									'h5',
									{ className: 'm_dtls_name import_dtls_name' },
									block.pro_title
								) : _react2.default.createElement(
									'h5',
									{ className: 'm_dtls_name import_dtls_name' },
									'\xA0'
								),
								block.brand_name ? _react2.default.createElement(
									'h6',
									{ className: 'sw_brand_name' },
									block.brand_name
								) : _react2.default.createElement(
									'h6',
									{ className: 'sw_brand_name' },
									'\xA0'
								),
								block.mrp ? _react2.default.createElement(
									'p',
									{ className: 'sw_dtls_price' },
									'MRP \u20B9 ',
									block.mrp
								) : _react2.default.createElement(
									'p',
									{ className: 'sw_dtls_price' },
									'\xA0'
								)
							) : _react2.default.createElement(
								'div',
								null,
								block.promo_ribbion ? _react2.default.createElement(
									'i',
									{ className: 'ribbon_img' },
									_react2.default.createElement('img', { alt: '', src: 'https://aquadeals.in/admin/assets/images/web_imgs/' + block.promo_ribbion })
								) : '',
								block.pro_title === "View More" ? _react2.default.createElement(
									_reactRouter.Link,
									{ to: '/stores/' + block.url_name + '/' + block.id },
									block.image === '' ? '' : _react2.default.createElement('img', { className: 'sw_dtls_img', src: 'https://aquadeals.in/admin/assets/images/' + block.image, alt: ' ' }),
									_react2.default.createElement(
										'h5',
										{ className: 'm_dtls_name organic_dtls_name' },
										block.pro_title
									)
								) : _react2.default.createElement(
									_reactRouter.Link,
									{ to: '/pdetails/' + block.url_dtype_name + '/' + block.url_cat_name + '/' + block.url_brand_name + '/' + block.url_product_name + '/' + block.pro_id + '/' + block.id },
									block.image === '' ? '' : _react2.default.createElement('img', { className: 'sw_dtls_img', src: 'https://aquadeals.in/admin/assets/images/' + block.image, alt: ' ' }),
									block.pro_title ? _react2.default.createElement(
										'h5',
										{ className: 'm_dtls_name organic_dtls_name' },
										block.pro_title
									) : _react2.default.createElement(
										'h5',
										{ className: 'm_dtls_name organic_dtls_name' },
										'\xA0'
									),
									block.brand_name ? _react2.default.createElement(
										'h6',
										{ className: 'sw_brand_name' },
										block.brand_name
									) : _react2.default.createElement(
										'h6',
										{ className: 'sw_brand_name' },
										'\xA0'
									),
									block.mrp ? _react2.default.createElement(
										'p',
										{ className: 'sw_dtls_price' },
										'MRP \u20B9 ',
										block.mrp
									) : _react2.default.createElement(
										'p',
										{ className: 'sw_dtls_price' },
										'\xA0'
									)
								)
							)
						);
					}.bind(this));
				}
				return _react2.default.createElement(
					'div',
					null,
					this.state.is_loaded ? _react2.default.createElement(
						'div',
						{ style: { backgroundColor: '#fff', marginTop: '10px', marginBottom: '10px', paddingTop: '10px', paddingBottom: '10px' } },
						_react2.default.createElement(
							'h4',
							{ className: 'stores_title' },
							'AD STORES'
						),
						_react2.default.createElement(
							_reactIdSwiper2.default,
							_extends({}, params, { key: mob_swipe_blocks.length }),
							mob_swipe_blocks
						),
						this.state.isToggle ? _react2.default.createElement(
							'div',
							null,
							swipe_all.length >= 2 ? _react2.default.createElement(
								'div',
								{ className: 'swipe_imp_bg', style: { backgroundSize: 'cover!important', background: 'url(' + this.state.deal_bg_img + ') no-repeat' } },
								this.state.isToggle ? _react2.default.createElement(
									_reactIdSwiper2.default,
									_extends({}, params, { key: swipe_all.length }),
									swipe_all
								) : ''
							) : ''
						) : ''
					) : ''
				);
			}
		}]);
	
		return ADStores;
	}(_react.Component);
	
	exports.default = ADStores;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactIdSwiper = __webpack_require__(19);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _reactRouter = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var BrandStores = function (_Component) {
		_inherits(BrandStores, _Component);
	
		function BrandStores(props) {
			_classCallCheck(this, BrandStores);
	
			var _this = _possibleConstructorReturn(this, (BrandStores.__proto__ || Object.getPrototypeOf(BrandStores)).call(this, props));
	
			_this.state = {
				deal_offers: [],
				is_loaded: false
			};
			_this.getStoreBrands = _this.getStoreBrands.bind(_this);
			return _this;
		}
	
		_createClass(BrandStores, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				this.getStoreBrands();
			}
		}, {
			key: 'getStoreBrands',
			value: function getStoreBrands() {
				var data1 = { from: 'mobile_web' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'brand_store',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							deal_offers: data.deal_offers,
							is_loaded: true
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var params = {
					paginationClickable: true,
					spaceBetween: 10,
					slidesPerView: 'auto',
					preloadImages: true,
					calculateHeight: true
				};
				var mob_brand_blocks = this.state.deal_offers.map(function (block, index) {
					var red_url = '/';
					return _react2.default.createElement(
						_reactRouter.Link,
						{ to: block.redirect_url, className: 'swipe_blocks_list' },
						block.img === '' ? '' : _react2.default.createElement(
							'div',
							{ className: 'center-cropped', style: { 'backgroundImage': 'url("' + baseAssets + 'images/' + block.img + '")', 'background-size': '310px 200px' } },
							_react2.default.createElement('img', { className: 'store_brand_pic', src: baseAssets + 'images/' + block.img, alt: ' ' })
						)
					);
				});
				return _react2.default.createElement(
					'div',
					null,
					this.state.is_loaded ? _react2.default.createElement(
						'div',
						{ className: 'brand_stores_blk' },
						mob_brand_blocks.length > 0 ? _react2.default.createElement(
							'h4',
							{ className: 'stores_title' },
							'BRAND STORES'
						) : '',
						_react2.default.createElement(
							_reactIdSwiper2.default,
							_extends({}, params, { key: mob_brand_blocks.length }),
							mob_brand_blocks
						)
					) : ''
				);
			}
		}]);
	
		return BrandStores;
	}(_react.Component);
	
	exports.default = BrandStores;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactShare = __webpack_require__(18);
	
	var _reactInfiniteScrollComponent = __webpack_require__(57);
	
	var _reactInfiniteScrollComponent2 = _interopRequireDefault(_reactInfiniteScrollComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	// path: /pdeals/:Type/:Tid
	
	var PartnerDeals = function (_Component) {
		_inherits(PartnerDeals, _Component);
	
		function PartnerDeals(props) {
			_classCallCheck(this, PartnerDeals);
	
			var _this = _possibleConstructorReturn(this, (PartnerDeals.__proto__ || Object.getPrototypeOf(PartnerDeals)).call(this, props));
	
			_this.state = {
				tid: _this.props.params.Tid,
				type: _this.props.params.Type,
				dtype: _this.props.params.DType,
				pdeals: [],
				totdata: '',
				prevPath: '',
				brands: [],
				categories: [],
				brands_status: false,
				cat_status: false,
				cat_sort_status: false,
				nodata: false,
				open: false,
				web_title: '',
				web_desc: '',
				loadmore_number: 2,
				loadmore_status: 0,
				set_type: '',
				next_page: '',
				sort_list: [],
	
				cart_count: 0,
				sort_title: 'Sort By',
				seo_title: '',
				seo_desc: '',
				loading_gif: false,
				loading_more_status: false,
				deal_type_status: false,
				deal_types: [],
				mob_loading: false,
				page_name: ''
			};
			_this.getBrands = _this.getBrands.bind(_this);
			_this.getSelectedBrand = _this.getSelectedBrand.bind(_this);
			_this.getDeviceId = _this.getDeviceId.bind(_this);
			_this.getSelectedCategorySort = _this.getSelectedCategorySort.bind(_this);
			_this.getCartCount = _this.getCartCount.bind(_this);
			_this.fetchData = _this.fetchData.bind(_this);
			_this.refresh = _this.refresh.bind(_this);
			_this.getSelectedDType = _this.getSelectedDType.bind(_this);
	
			_this.getPartnerDeals = _this.getPartnerDeals.bind(_this);
			// this.getCategories=this.getCategories.bind(this);
			return _this;
		}
	
		_createClass(PartnerDeals, [{
			key: 'refresh',
			value: function refresh() {
				console.log("");
			}
		}, {
			key: 'fetchData',
			value: function fetchData() {
				// this.state.next_page, this.state.set_type,this.props.params.Tid,this.props.params.DType
				var num = this.state.next_page;
				var type = this.state.set_type;
				if (this.props.params.Dtype) {
					var dtype = this.props.params.DType;
				} else {
					dtype = 0;
				}
				// var dtype=this.props.params.DType;
				var tid = this.props.params.Tid;
	
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				this.setState({
					// loading_gif:true,
					loading_more_status: true
				});
	
				var getfunc = "";
				var data1 = "";
				var data2 = "";
				type = this.props.params.Type;
				if (type === "all") {
					data1 = { from: 'mobile_web', uid: uid, page: num, type: dtype, limit: 20 };
					data2 = JSON.stringify(data1);
					getfunc = "getPoductDeals";
				} else if (type === "Pcategory") {
					data1 = { from: 'mobile_web', uid: uid, page: num, dtype: dtype, type: type, tid: tid, limit: 20 };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				} else if (type === "brand") {
					data1 = { from: 'mobile_web', uid: uid, page: num, dtype: dtype, type: type, tid: tid, limit: 20 };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				} else if (type === "partner") {
					data1 = { from: 'mobile_web', uid: uid, page: num, dtype: 0, type: type, tid: tid, limit: 20 };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				}
				if (this.state.loadmore_status === 1) {
					this.setState({
						// loading_gif:true,
						loadmore_status: true
					});
					_jquery2.default.ajax({
						method: 'POST',
						dataType: 'json',
						data: { req: data2 },
						url: baseUrl + getfunc,
						success: function (data) {
							if (data.products) {
								if (data.load_more === 1) {
									this.setState({
										pdeals: this.state.pdeals.concat(data.products),
										offer: data,
										todata: data,
										loadmore_status: data.load_more,
										set_type: data.set_type,
										next_page: data.next_page,
										loading_gif: false,
										loading_more_status: false
									});
								} else {
									this.setState({
										set_type: data.set_type,
										next_page: data.next_page,
										loadmore_status: data.load_more,
										loading_gif: false,
										loading_more_status: false
									});
								}
							} else {
								if (data.load_more === 1) {
									this.setState({
										pdeals: this.state.pdeals.concat(data.result),
										// feedsList: this.state.feedsList.concat(data.result),
										set_type: data.set_type,
										next_page: data.next_page,
										loadmore_status: data.load_more,
										loading_gif: false,
										loading_more_status: false
									});
								} else {
									this.setState({
										set_type: data.set_type,
										next_page: data.next_page,
										loadmore_status: data.load_more,
										loading_gif: false,
										loading_more_status: false
									});
								}
							}
						}.bind(this),
						error: function error(err) {
							this.setState({
								loading_gif: false,
								loading_more_status: false
							});
						}
					});
				} else {
					this.setState({
						loading_more_status: false
					});
				}
			}
		}, {
			key: 'getCartCount',
			value: function getCartCount() {
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							cart_count: data.cart_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getDeviceId',
			value: function getDeviceId() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var data1 = { from: 'mobile_web', id: uid, device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getDeviceId',
					dataType: 'json',
					data: { req: data2 },
					success: function success(data) {},
					error: function error(err) {}
				});
			}
		}, {
			key: 'getBrands',
			value: function getBrands() {
				if (this.props.params.DType) {
					var dtype = this.props.params.DType;
				} else {
					dtype = 0;
				}
				var data1 = { from: 'mobile_web', type: this.state.type, tid: this.state.tid, dtype: dtype };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'filterBrandCat',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.brands_lst.length > 0) {
							this.setState({
								brands_status: true
							});
						}
						if (data.cat_lst.length > 0) {
							this.setState({
								cat_status: true
							});
						}
						if (data.deal_types.length > 0) {
							this.setState({
								deal_type_status: true
							});
						}
						this.setState({
							brands: data.brands_lst,
							categories: data.cat_lst,
							sort_list: data.sort,
							deal_types: data.deal_types
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSelectedBrand',
			value: function getSelectedBrand(b) {
				this.setState({
					loading_gif: true
				});
				localStorage.setItem('brand', b);
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (this.state.type === "offers") {
					var data1 = { from: "mobile_web", "tid": "", "type": "combo", "cat_id": "cat_id", "uid": uid, "deal_offer_type": "3", "bid": b, "lat1": "", "long1": "", "sort": localStorage.getItem('cat_sort') };
				} else {
					data1 = { from: 'mobile_web', uid: uid, type: this.state.type, tid: this.state.tid, dtype: this.state.dtype, bid: b };
				}
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true,
								loading_gif: false
							});
						} else {
							this.setState({
								nodata: false,
								loading_gif: false
							});
						}
						this.setState({
							pdeals: data.result,
							totdata: data,
							loadmore_status: data.load_more,
							set_type: data.set_type,
							next_page: data.next_page
						});
						if (data.status === 'error') {
							localStorage.removeItem('cat_id');
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSelectedCategory',
			value: function getSelectedCategory(c) {
				this.setState({
					loading_gif: true
				});
				localStorage.setItem('cat_id', c);
				localStorage.removeItem('brand');
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var data1 = { from: 'mobile_web', uid: uid, type: this.state.type, tid: this.state.tid, dtype: this.state.dtype, cat_id: c };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true,
								loading_gif: false
							});
						} else {
							this.setState({
								nodata: false,
								loading_gif: false
							});
						}
						this.setState({
							pdeals: data.result,
							totdata: data,
							loadmore_status: data.load_more,
							set_type: data.set_type,
							next_page: data.next_page
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSelectedCategorySort',
			value: function getSelectedCategorySort(c, name) {
				this.setState({
					loading_gif: true
				});
				// localStorage.removeItem('brand');
				var catId = 0;
				localStorage.setItem('cat_sort', c);
	
				if (localStorage.cat_id) {
					catId = localStorage.getItem('cat_id');
				} else {
					catId = 0;
				}
				this.setState({
					sort_title: name
				});
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (this.state.type === 'offers') {
					var data1 = { from: "mobile_web", "tid": "", "type": "", "uid": uid, "deal_offer_type": "3", "bid": localStorage.getItem('brand'), "lat1": "", "long1": "", "sort": c };
				} else {
					data1 = { from: 'mobile_web', uid: uid, type: this.state.type, tid: this.state.tid, dtype: this.state.dtype, cat_id: catId, sort: c };
				}
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true,
								loading_gif: false
							});
						} else {
							this.setState({
								nodata: false,
								loading_gif: false
							});
						}
						this.setState({
							pdeals: data.result,
							totdata: data,
							loadmore_status: data.load_more,
							set_type: data.set_type,
							next_page: data.next_page
						});
						localStorage.removeItem('cat_sort');
						localStorage.removeItem('cat_id');
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSelectedBrandSort',
			value: function getSelectedBrandSort(b, name) {
				this.setState({
					loading_gif: true
				});
				// localStorage.removeItem('brand');
				var bid = 0;
				localStorage.setItem('bid_sort', b);
				if (localStorage.brand) {
					bid = localStorage.getItem('brand');
				} else {
					bid = 0;
				}
				this.setState({
					sort_title: name
				});
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (this.state.type === 'offers') {
					var data1 = { from: "mobile_web", "tid": "", "type": "", "uid": uid, "deal_offer_type": "3", "bid": localStorage.getItem('brand'), "lat1": "", "long1": "", "sort": b };
				} else {
					data1 = { from: 'mobile_web', uid: uid, type: this.state.type, tid: this.state.tid, dtype: this.state.dtype, bid: bid, sort: b };
				}
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true,
								loading_gif: false
							});
						} else {
							this.setState({
								nodata: false,
								loading_gif: false
							});
						}
						this.setState({
							pdeals: data.result,
							totdata: data,
							loadmore_status: data.load_more,
							set_type: data.set_type,
							next_page: data.next_page
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSelectedDType',
			value: function getSelectedDType(dtype) {
				this.setState({
					loading_gif: true
				});
				// localStorage.removeItem('brand');
				// var catId=0;
	
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				if (this.state.type === 'offers') {
					var data1 = { from: "mobile_web", "tid": "", "type": "", "uid": uid, "deal_offer_type": "3", "bid": localStorage.getItem('brand'), "lat1": "", "long1": "", "sort": '' };
				} else {
					data1 = { from: 'mobile_web', uid: uid, type: this.state.type, tid: this.state.tid, dtype: dtype, sort: '' };
				}
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true,
								loading_gif: false
							});
						} else {
							this.setState({
								nodata: false,
								loading_gif: false
							});
						}
						this.setState({
							pdeals: data.result,
							totdata: data,
							loadmore_status: data.load_more,
							set_type: data.set_type,
							next_page: data.next_page
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				localStorage.setItem('m_r_p_deals', '/pdeals/' + this.props.params.Type + '/' + this.props.params.Tid);
				// if(screen.width >= 800)
				// {
				//   window.location.href="/web/pdeals/"+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Tid+"/"+this.props.params.Type+"/"+this.props.params.DType;
				// }
				// if(this.props.params.BrandName && this.props.params.CatName && this.props.params.Tid && this.props.params.Type && this.props.params.DType)
				// {
				//   	localStorage.setItem('m_r_p_deals',"/pdeals/"+this.props.params.BrandName+"/"+this.props.params.CatName +"/"+this.props.params.Tid+"/"+this.props.params.Type+"/"+this.props.params.DType)	
				// }
				// else
				// {
				// 		localStorage.removeItem('m_r_p_deals');	
				// }
	
				if (localStorage.user_id && localStorage.token) {
					this.getCartCount();
				}
	
				this.getDeviceId();
				localStorage.removeItem('m_r_e_coupon_dt');
				localStorage.removeItem('m_r_s_dt');
				localStorage.removeItem('m_r_p_dt');
				localStorage.removeItem('m_r_e_s_dt');
				localStorage.removeItem('m_r_e_p_dt');
				localStorage.removeItem('w_r_p_deals');
				localStorage.removeItem('w_r_s_deals');
				localStorage.removeItem('m_r_s_deals');
				localStorage.removeItem('subdeals');
				//localStorage.removeItem('m_r_p_deals');
				localStorage.removeItem('bid');
				localStorage.removeItem('cat_sort');
				localStorage.removeItem('url');
				this.getBrands();
	
				// var data1= '';
				// var data2= '';
				//  	var get_function= '';
				//  	var uid =0;
				// if(localStorage.user_id)
				// {
				//    uid=localStorage.getItem('user_id')
				// }
				// else
				// {
				//    uid=0;
				// }
				this.getPartnerDeals();
			}
		}, {
			key: 'getPartnerDeals',
			value: function getPartnerDeals() {
				if (this.props.params.Type) {
					var type = this.props.params.Type;
				} else {
					type = 'type';
				}
				if (this.props.params.Tid) {
					var tid = this.props.params.Tid;
				} else {
					tid = 0;
				}
				this.setState({
					mob_loading: true
				});
				var data1 = { from: 'mobile_web', type: type, tid: tid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true,
								mob_loading: false
							});
						} else {
							this.setState({
								nodata: false,
								mob_loading: false
							});
						}
						this.setState({
							pdeals: data.result,
							totdata: data,
							loadmore_status: data.load_more,
							set_type: data.set_type,
							next_page: data.next_page,
							seo_desc: '',
							mob_loading: false,
							page_name: data.cat_name
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				(0, _jquery2.default)('body').css('background', '#fff');
				document.title = this.state.page_name ? 'Shop the best deals from ' + this.state.page_name + ' | AquaDeals' : 'Shop the best deals from AquaDeals';
				var products = this.state.pdeals.map(function (product, index) {
					return _react2.default.createElement(ProductsList, { key: product.pid, data: product, onUpdate: function onUpdate() {
							return _this2.getCartCount();
						} });
				});
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals pdeals_page mob_pdeals_page' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ onClick: function onClick() {
											_reactRouter.browserHistory.goBack();
										} },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
									)
								),
								this.state.totdata.cat_name ? this.state.totdata.cat_name : ''
							),
							_react2.default.createElement(
								'a',
								{ href: '/', title: 'Home', className: 'home_logo1' },
								_react2.default.createElement('img', { src: baseAssets + 'icons/web_icons/home1.png', alt: 'Home' })
							),
							_react2.default.createElement(
								'a',
								{ className: 'mob_cart_btn', href: '/mycart' },
								_react2.default.createElement('img', { alt: '', src: baseAssets + 'icons/web_icons/cart_icon.png' }),
								this.state.cart_count > 0 ? _react2.default.createElement(
									'span',
									{ className: this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count" },
									this.state.cart_count
								) : ''
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'pag_cntnt' },
						'\xA0'
					),
					this.state.mob_loading ? _react2.default.createElement(
						'i',
						{ className: 'mob_loading' },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/mob_loading.gif', alt: 'Loading' })
					) : '',
					_react2.default.createElement(
						'section',
						{ className: '' },
						this.state.nodata ? _react2.default.createElement(
							'div',
							{ className: 'no_data' },
							_react2.default.createElement(
								'h3',
								null,
								'No Deals Available'
							),
							_react2.default.createElement(
								'p',
								null,
								'Need something here? ',
								_react2.default.createElement(
									_reactRouter.Link,
									{ to: "/customer_care" },
									'CONTACT US'
								),
								' now !'
							)
						) : '',
						_react2.default.createElement(
							_reactInfiniteScrollComponent2.default,
							{
								pullDownToRefresh: true,
								pullDownToRefreshContent: _react2.default.createElement(
									'h3',
									{ style: { textAlign: 'center' } },
									'\u2193'
								),
								releaseToRefreshContent: _react2.default.createElement(
									'h3',
									{ style: { textAlign: 'center' } },
									'\u2191'
								),
								refreshFunction: this.refresh,
								next: this.fetchData,
								hasMore: true,
								scrollThreshold: 0.8,
								loader: _react2.default.createElement('h4', null),
								endMessage: _react2.default.createElement(
									'p',
									{ style: { textAlign: 'center' } },
									_react2.default.createElement('b', null)
								) },
							products
						),
						this.state.loading_more_status ? _react2.default.createElement(
							'div',
							{ className: 'loading_more_sym' },
							_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/mob_loading.gif', alt: 'Loading' })
						) : ''
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'seed_sort dsl_srt' },
						_react2.default.createElement(
							'ul',
							null,
							this.state.cat_status ? _react2.default.createElement(
								'li',
								{ className: 'col-md-6 col-xs-6 col-sm-6 ' },
								_react2.default.createElement(
									_reactBootstrap.ButtonToolbar,
									null,
									_react2.default.createElement(
										_reactBootstrap.DropdownButton,
										{ className: 'test_filter_4', noCaret: true, onClick: this.getSorts, title: this.state.sort_title, dropup: true },
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ header: true },
											'Sort By'
										),
										this.state.sort_list.map(function (cat, index) {
											return _react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ className: 'seed_list1', eventKey: cat.id, onClick: function onClick() {
														return _this2.getSelectedCategorySort(cat.id, cat.name);
													} },
												cat.name
											);
										})
									)
								)
							) : _react2.default.createElement(
								'li',
								{ className: 'col-md-6 col-xs-6 col-sm-6 ' },
								_react2.default.createElement(
									_reactBootstrap.ButtonToolbar,
									null,
									_react2.default.createElement(
										_reactBootstrap.DropdownButton,
										{ className: 'test_filter_4', noCaret: true, onClick: this.getSorts, title: this.state.sort_title, dropup: true },
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ header: true },
											'Sort By'
										),
										this.state.sort_list.map(function (cat, index) {
											return _react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ className: 'seed_list1', eventKey: cat.id, onClick: function onClick() {
														return _this2.getSelectedBrandSort(cat.id, cat.name);
													} },
												cat.name
											);
										})
									)
								)
							),
							this.state.brands_status ? _react2.default.createElement(
								'li',
								{ className: 'col-md-6 col-xs-6 col-sm-6 coast_list1' },
								_react2.default.createElement(
									_reactBootstrap.ButtonToolbar,
									null,
									_react2.default.createElement(
										_reactBootstrap.DropdownButton,
										{ className: 'test_filter_1', noCaret: true, onClick: this.getBrands, title: 'By Brand', dropup: true },
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ header: true },
											'By Brand (',
											this.state.brands.length,
											')'
										),
										this.state.brands.map(function (brand, index) {
											return _react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ eventKey: brand.id, className: 'seed_list1', onClick: function onClick() {
														return _this2.getSelectedBrand(brand.id);
													} },
												brand.name
											);
										})
									)
								)
							) : '',
							this.state.cat_status ? _react2.default.createElement(
								'li',
								{ className: 'col-md-6 col-xs-6 col-sm-6 coast_list2' },
								_react2.default.createElement(
									_reactBootstrap.ButtonToolbar,
									null,
									_react2.default.createElement(
										_reactBootstrap.DropdownButton,
										{ className: 'test_filter_2', noCaret: true, onClick: this.getCoasts, title: 'By Category', dropup: true },
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ header: true },
											'By Category '
										),
										this.state.categories.map(function (cat, index) {
											return _react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ className: 'seed_list1', eventKey: cat.id, onClick: function onClick() {
														return _this2.getSelectedCategory(cat.id);
													} },
												cat.name
											);
										})
									)
								)
							) : '',
							this.state.deal_type_status ? _react2.default.createElement(
								'li',
								{ className: 'col-md-6 col-xs-6 col-sm-6 coast_list2' },
								_react2.default.createElement(
									_reactBootstrap.ButtonToolbar,
									null,
									_react2.default.createElement(
										_reactBootstrap.DropdownButton,
										{ className: 'test_filter_2', noCaret: true, onClick: this.getCoasts, title: 'By Type', dropup: true },
										_react2.default.createElement(
											_reactBootstrap.MenuItem,
											{ header: true },
											'By Type '
										),
										this.state.deal_types.map(function (cat, index) {
											return _react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ className: 'seed_list1', eventKey: cat.id, onClick: function onClick() {
														return _this2.getSelectedDType(cat.id);
													} },
												cat.name
											);
										})
									)
								)
							) : ''
						)
					)
				);
			}
		}]);
	
		return PartnerDeals;
	}(_react.Component);
	
	exports.default = PartnerDeals;
	
	var ProductsList = function (_Component2) {
		_inherits(ProductsList, _Component2);
	
		function ProductsList(props) {
			_classCallCheck(this, ProductsList);
	
			var _this3 = _possibleConstructorReturn(this, (ProductsList.__proto__ || Object.getPrototypeOf(ProductsList)).call(this, props));
	
			_this3.state = {
				open: false,
				msg: '',
				shareUrl: '',
				cart_count: '',
				clearcart_status: false,
				already_added_status: false
			};
			_this3.ShareFunc = _this3.ShareFunc.bind(_this3);
			_this3.addToCart = _this3.addToCart.bind(_this3);
			_this3.updateCartCount = _this3.updateCartCount.bind(_this3);
			_this3.close = _this3.close.bind(_this3);
			_this3.replaceCartItems = _this3.replaceCartItems.bind(_this3);
			_this3.addToQuickCart = _this3.addToQuickCart.bind(_this3);
			return _this3;
		}
	
		_createClass(ProductsList, [{
			key: 'replaceCartItems',
			value: function replaceCartItems(deal_id, quantity) {
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1, quantity: quantity, pl_size: 0, salinity: 0, pickup_date: 0 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'replaceCart',
					data: { req: data2 },
					success: function (data) {
						console.log(data);
						if (data.status === "success") {
							this.setState({
								clearcart_status: false
							});
							_reactRouter.browserHistory.push('/mycart');
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					clearcart_status: false,
					already_added_status: false
				});
			}
		}, {
			key: 'updateCartCount',
			value: function updateCartCount() {
				this.props.onUpdate();
			}
		}, {
			key: 'ShareFunc',
			value: function ShareFunc(evnt) {
				var _this4 = this;
	
				var data1 = { from: 'mobile_web', type: 1, did: evnt };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'createTinyurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							msg: data.msg,
							shareUrl: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {}
				});
				this.setState({
					open: !this.state.open
				});
				setTimeout(function () {
					_this4.setState({ open: false });
				}, 5000);
			}
		}, {
			key: 'addToQuickCart',
			value: function addToQuickCart(deal_id) {
				if (!localStorage.user_id && !localStorage.token) {
					_reactRouter.browserHistory.push('/login');
				} else {
					var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1 };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'post',
						dataType: 'json',
						url: baseUrl + 'addToQCart',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.updateCartCount();
								_reactRouter.browserHistory.push('/quickcart');
							} else if (data.status === "error" && data.cart_flag === 0) {
								this.setState({
									clearcart_status: true
								});
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'addToCart',
			value: function addToCart(deal_id) {
				if (!localStorage.user_id && !localStorage.token) {
					_reactRouter.browserHistory.push('/login');
				} else {
					var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1 };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'post',
						dataType: 'json',
						url: baseUrl + 'quickBuy',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.updateCartCount();
								_reactRouter.browserHistory.push('/mycart');
							} else if (data.status === "error" && data.cart_flag === 0) {
								this.setState({
									clearcart_status: true
								});
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
							} else if (data.status === "error" && data.message === "Token mismatch") {
								localStorage.removeItem('token');
								localStorage.removeItem('user_id');
								_reactRouter.browserHistory.push('/login');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var mydata = this.props.data;
				var shareUrl = this.state.shareUrl;
				var title = "Hey Click here " + shareUrl + " to check " + mydata.title + " from AquaDeals.";
				var description = shareUrl;
				return _react2.default.createElement(
					'div',
					{ className: "list_card" },
					mydata.promo_ribbion ? _react2.default.createElement(
						'i',
						{ className: 'ribbon_img' },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/' + mydata.promo_ribbion, alt: '' })
					) : '',
					mydata.dealcount >= 2 ? _react2.default.createElement(
						_reactRouter.Link,
						{ to: "/subdeals/" + mydata.url_dtype_name + "/" + mydata.url_cat_name + "/" + mydata.dtype + "/" + mydata.url_brand_name + "/" + mydata.pid },
						_react2.default.createElement(
							'div',
							{ className: 'list_img' },
							_react2.default.createElement('img', { src: mydata.image === null ? baseAssets + 'images/product_imgs/noimage1.jpg' : baseAssets + 'images/product_imgs/' + mydata.image, alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'list_txt' },
							_react2.default.createElement(
								'h4',
								null,
								mydata.title,
								' ',
								mydata.quantity
							),
							mydata.brand_name ? _react2.default.createElement(
								'h5',
								null,
								mydata.brand_name
							) : '',
							mydata.dealcount >= 2 ? _react2.default.createElement(
								'h3',
								null,
								mydata.dealcount,
								' deals available'
							) : '',
							mydata.over_rate >= 1 ? _react2.default.createElement(
								'h6',
								null,
								_react2.default.createElement(
									'i',
									{ className: 'm_star_rate' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/star_filled.png', width: '16px', role: 'presentation' })
								),
								mydata.over_rate
							) : _react2.default.createElement(
								'h6',
								null,
								_react2.default.createElement(
									'i',
									{ className: 'm_nostar_rate' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/star_gray.png', width: '17px', role: 'presentation' })
								)
							)
						)
					) : _react2.default.createElement(
						_reactRouter.Link,
						{ to: "/pdetails/" + mydata.url_dtype_name + "/" + mydata.url_cat_name + "/" + mydata.url_brand_name + "/" + mydata.url_product_name + "/" + mydata.pid + "/" + mydata.deal_id },
						_react2.default.createElement(
							'div',
							{ className: 'list_img' },
							_react2.default.createElement('img', { src: mydata.image === null ? baseAssets + 'images/product_imgs/noimage1.jpg' : baseAssets + 'images/product_imgs/' + mydata.image, alt: ' ' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'list_txt' },
							_react2.default.createElement(
								'h4',
								null,
								mydata.title,
								' ',
								mydata.quantity
							),
							mydata.brand_name ? _react2.default.createElement(
								'h5',
								null,
								mydata.brand_name
							) : '',
							mydata.pricediff === "" ? _react2.default.createElement(
								'h3',
								null,
								'MRP \u20B9 ',
								mydata.mrp
							) : '',
							mydata.dealcount >= 2 ? _react2.default.createElement(
								'h3',
								null,
								mydata.dealcount,
								' deals available'
							) : '',
							mydata.pricediff ? _react2.default.createElement(
								'h3',
								null,
								'aquacash discount \u20B9 ',
								mydata.pricediff
							) : '',
							mydata.over_rate >= 1 ? _react2.default.createElement(
								'h6',
								null,
								_react2.default.createElement(
									'i',
									{ className: 'm_star_rate' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/star_filled.png', width: '16px', role: 'presentation' })
								),
								mydata.over_rate
							) : _react2.default.createElement(
								'h6',
								null,
								_react2.default.createElement(
									'i',
									{ className: 'm_nostar_rate' },
									_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/star_gray.png', width: '17px', role: 'presentation' })
								)
							)
						)
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ className: 'share_list', onClick: function onClick() {
								_this5.ShareFunc(mydata.deal_id);
							} },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/share1.png', alt: 'share' })
					),
					mydata.count > 0 ? _react2.default.createElement(
						'h6',
						{ className: 'views_eye' },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/eye.png', width: '17px', role: 'presentation' }),
						' ',
						mydata.count,
						' ',
						mydata.count > 1 ? 'Views' : 'View'
					) : '',
					mydata.dealcount >= 2 ? '' : _react2.default.createElement(
						'a',
						{ className: 'quick_buy_img', onClick: function onClick() {
								return _this5.addToQuickCart(mydata.deal_id);
							} },
						_react2.default.createElement('img', { src: baseAssets + "images/icons/quick_buy.png", alt: ' ', width: '50px' })
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_reactBootstrap.Panel,
							{ className: 'share_panel', collapsible: true, expanded: this.state.open },
							_react2.default.createElement(
								FacebookShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share' },
								_react2.default.createElement(FacebookIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								TwitterShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share' },
								_react2.default.createElement(TwitterIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								GooglePlusShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share' },
								_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.clearcart_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#333' } },
								'You can\'t have multiple seller items in the cart. Empty existing cart & add this item ',
								mydata.title,
								'?'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'NO'
							),
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: function onClick() {
											_this5.replaceCartItems(mydata.deal_id, mydata.min_qty);
										} },
									'YES'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.already_added_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#333' } },
								'Product already added to the cart'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'OK'
							)
						)
					)
				);
			}
		}]);
	
		return ProductsList;
	}(_react.Component);

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Product = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactInfiniteScrollComponent = __webpack_require__(57);
	
	var _reactInfiniteScrollComponent2 = _interopRequireDefault(_reactInfiniteScrollComponent);
	
	var _reactShare = __webpack_require__(18);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
	    GooglePlusShareButton = _reactShare.ShareButtons.GooglePlusShareButton,
	    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;
	
	var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
	var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
	var GooglePlusIcon = (0, _reactShare.generateShareIcon)('google');
	
	
	//  path : /stores/:StoreType/:ID
	//  	 : /stores/:StoreType
	//		 : /ad-banners/:StoreType
	
	var baseUrl = 'https://aquadeals.in/admin/web3/user/';
	var baseAssets = 'https://aquadeals.in/admin/assets/';
	
	var StoreDeals = function (_Component) {
		_inherits(StoreDeals, _Component);
	
		function StoreDeals(props) {
			_classCallCheck(this, StoreDeals);
	
			var _this = _possibleConstructorReturn(this, (StoreDeals.__proto__ || Object.getPrototypeOf(StoreDeals)).call(this, props));
	
			_this.state = {
				store_deals: [],
				loading_more_status: false,
	
				brands: [],
				sort_list: [],
				feedcat: [],
				nodata: false,
				open: false,
				types: [],
				title: '',
				desc: '',
				tid: _this.props.params.Tid,
				type: _this.props.params.Type,
				dtype: _this.props.params.DType,
				htype: _this.props.params.DType,
				data_type: _this.props.params.DType,
				bread: '',
				activeMenu: '',
				selected: '',
				loading: false,
				lod: false,
				loadmore_number: 2,
				loadmore_status: 0,
				set_type: '',
				next_page: '',
				seo_desc: '',
				loading_gif: false,
	
				brands_status: false,
				cat_status: false,
				sort_status: false,
				deal_type_status: false,
				deal_types: [],
				ad_guarantee_flag: 0
			};
			_this.getCartCount = _this.getCartCount.bind(_this);
			_this.getBrands = _this.getBrands.bind(_this);
			_this.getSelectedBrand = _this.getSelectedBrand.bind(_this);
			_this.getSelectedCategorySort = _this.getSelectedCategorySort.bind(_this);
			_this.refresh = _this.refresh.bind(_this);
			_this.fetchData = _this.fetchData.bind(_this);
			_this.getSelectedDType = _this.getSelectedDType.bind(_this);
			return _this;
		}
	
		_createClass(StoreDeals, [{
			key: 'refresh',
			value: function refresh() {
				console.log("");
			}
		}, {
			key: 'fetchData',
			value: function fetchData() {
				this.setState({
					loading_more_status: true
				});
				var num = this.state.next_page;
				var dtype = this.props.params.DType;
				// var type=this.state.set_type;
				var tid = this.props.params.Tid;
	
				var getfunc = "";
				var data1 = "";
				var data2 = "";
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var type = 'store';
				if (this.props.params.StoreType === 'caa-approved') {
					type = this.props.params.StoreType;
				} else if (this.props.params.StoreType === 'ad-guarantee') {
					type = this.props.params.StoreType;
				} else if (this.props.params.StoreType === 'ad-assist') {
					type = this.props.params.StoreType;
				}
	
				if (type === "all") {
					data1 = { from: 'mobile_web', page: num, type: dtype, limit: 20 };
					data2 = JSON.stringify(data1);
					getfunc = "getPoductDeals";
				}
				if (type === "Pcategory") {
					data1 = { from: 'mobile_web', uid: uid, page: num, dtype: dtype, type: type, tid: tid, limit: 20 };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				}
				if (type === "brand") {
					data1 = { from: 'mobile_web', uid: uid, page: num, dtype: dtype, type: type, tid: tid, limit: 20 };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				} else {
					data1 = { from: 'mobile_web', uid: uid, page: num, dtype: dtype, type: type, tid: this.props.params.ID, limit: 20 };
					data2 = JSON.stringify(data1);
					getfunc = "getProductbycat_brand";
				}
	
				var products = "";
				if (this.state.loadmore_status === 1) {
					_jquery2.default.ajax({
						method: 'POST',
						url: baseUrl + getfunc,
						dataType: 'json',
						data: { req: data2 },
						success: function (data) {
							if (data.load_more === 1) {
								this.setState({
									store_deals: this.state.store_deals.concat(data.result),
									title: data.cat_name,
									desc: data.cat_desc,
									selected: data.cat_name,
									loadmore_status: data.load_more,
									set_type: data.set_type,
									next_page: data.next_page,
	
									loading_gif: false,
									loading_more_status: false
								});
							} else {
								this.setState({
									set_type: data.set_type,
									next_page: data.next_page,
									loadmore_status: data.load_more,
									loading_gif: false,
									loading_more_status: false
								});
							}
							// this.setState({
							// 	  loading:true,
							//     loading_more_status:false,
							//     title:data.cat_name,
							//     desc:data.cat_desc,
							//     selected  : data.cat_name,
							//     loadmore_status:data.load_more,
							//     set_type: data.set_type,
							//     next_page:data.next_page,
							// });
							// this.setState({ 
							//     store_deals:this.state.store_deals.concat(data.result),
							// });
						}.bind(this),
						error: function error(err) {}
					});
				} else {
					this.setState({
						loading_more_status: false
					});
				}
			}
		}, {
			key: 'getSelectedBrand',
			value: function getSelectedBrand(b) {
				this.setState({
					loading_gif: true
				});
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var type = 'store';
				if (this.props.params.StoreType === 'caa-approved') {
					type = this.props.params.StoreType;
				} else if (this.props.params.StoreType === 'ad-guarantee') {
					type = this.props.params.StoreType;
				} else if (this.props.params.StoreType === 'ad-assist') {
					type = this.props.params.StoreType;
				}
	
				localStorage.setItem('brand', b);
				localStorage.removeItem('cat');
				var data1 = { from: 'mobile_web', uid: uid, type: type, tid: this.props.params.ID, dtype: '', bid: b };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true
							});
						} else {
							this.setState({
								nodata: false
							});
						}
						this.setState({
							store_deals: data.result,
							totdata: data,
							loadmore_status: data.load_more,
							set_type: data.set_type,
							next_page: data.next_page,
							loading_gif: false
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getSelectedCategorySort',
			value: function getSelectedCategorySort(c) {
				this.setState({
					loading_gif: true
				});
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				var type = 'store';
				if (this.props.params.StoreType === 'caa-approved') {
					type = this.props.params.StoreType;
				} else if (this.props.params.StoreType === 'ad-guarantee') {
					type = this.props.params.StoreType;
				} else if (this.props.params.StoreType === 'ad-assist') {
					type = this.props.params.StoreType;
				}
				var data1 = { from: 'mobile_web', uid: uid, tid: this.props.params.ID, type: type, dtype: '', bid: localStorage.brand, sort: c, limit: 10 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true
							});
						} else {
							this.setState({
								nodata: false
							});
						}
						this.setState({
							store_deals: data.result,
							totdata: data,
							loadmore_status: data.load_more,
							set_type: data.set_type,
							next_page: data.next_page,
							loading_gif: false
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.scrollTo(0, 0);
				if (screen.width >= 800) {
					if (this.props.params.ID) {
						window.location.href = "/web/stores/" + this.props.params.StoreType + '/' + this.props.params.ID;
					}
					// else
					// {
					// 	window.location.href="/web/stores/"+this.props.params.StoreType;
					// }
				}
				var loc = window.location;
				var str = location.pathname;
	
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('m_r_p_deals', str);
				}
				if (localStorage.token && localStorage.user_id) {
					this.getCartCount();
				}
				var uid = 0;
				if (localStorage.user_id) {
					uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				this.getBrands();
	
				var type = 'store';
				if (this.props.params.StoreType === 'caa-approved') {
					type = this.props.params.StoreType;
				} else if (this.props.params.StoreType === 'ad-guarantee') {
					type = this.props.params.StoreType;
				} else if (this.props.params.StoreType === 'ad-assist') {
					type = this.props.params.StoreType;
				}
				var data1 = { from: 'mobile_web', uid: uid, tid: this.props.params.ID, type: type, dtype: '', bid: '', sort: '', limit: 20 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true
							});
						} else {
							this.setState({
								nodata: false
							});
						}
						if (data.status === "success") {
							this.setState({
								store_deals: data.result,
	
								page_name: data.cat_name,
								loading: true,
								title: data.product_name,
								desc: 'The best offers of AquaDeals',
								selected: data.cat_name,
								loadmore_status: data.load_more,
								set_type: data.set_type,
								next_page: data.next_page
							});
						}
	
						// document.title =this.state.web_title+  " - Deals | AquaDeals ";
						// document.getElementsByTagName("META")[2].content=this.state.seo_desc;
					}.bind(this),
					error: function error(err) {
						// console.log("Error"+err);
					}
				});
			}
		}, {
			key: 'getSelectedDType',
			value: function getSelectedDType(dtype) {
				this.setState({
					loading_gif: true
				});
				if (localStorage.user_id) {
					var uid = localStorage.getItem('user_id');
				} else {
					uid = 0;
				}
				// if(this.state.type === 'offers')
				// {
				// 	var data1={from:"mobile_web","tid":"","type":"","uid":uid,"deal_offer_type":"3","bid":localStorage.getItem('brand'),"lat1":"","long1":"","sort":''}
				// }
				// else
				// {
				// 	 data1={from: 'mobile_web',uid:uid,type:this.state.type,tid: this.state.tid,dtype:dtype,sort:''};
				// }
				var type = 'store';
	
				if (this.props.params.StoreType === 'caa-approved') {
					type = this.props.params.StoreType;
				} else if (this.props.params.StoreType === 'ad-guarantee') {
					type = this.props.params.StoreType;
				} else if (this.props.params.StoreType === 'ad-assist') {
					type = this.props.params.StoreType;
				}
				var data1 = { from: 'mobile_web', uid: uid, type: type, tid: this.props.params.ID, dtype: dtype, sort: '' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getProductbycat_brand',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.result.length === 0) {
							this.setState({
								nodata: true,
								loading_gif: false
							});
						} else {
							this.setState({
								nodata: false,
								loading_gif: false
							});
						}
						this.setState({
							pdeals: data.result,
							totdata: data,
							loadmore_status: data.load_more,
							set_type: data.set_type,
							next_page: data.next_page
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getBrands',
			value: function getBrands() {
				if (localStorage.user_id) {
					var uid = localStorage.user_id;
				} else {
					uid = 0;
				}
				var type = 'store';
				if (this.props.params.StoreType === 'caa-approved') {
					//type=this.props.params.StoreType;
					type = 'store';
				} else if (this.props.params.StoreType === 'ad-guarantee') {
					type = 'store';
				} else if (this.props.params.StoreType === 'ad-assist') {
					type = this.props.params.StoreType;
				}
	
				var data1 = { from: 'mobile_web', type: type, tid: this.props.params.ID, dtype: '', uid: uid };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'filterBrandCat',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						if (data.brands_lst.length > 0) {
							this.setState({
								brands_status: true
							});
						}
						if (data.cat_lst.length > 0) {
							this.setState({
								cat_status: true
							});
						}
						if (data.sort.length > 0) {
							this.setState({
								sort_status: true
							});
						}
						if (data.deal_types.length > 0) {
							this.setState({
								deal_type_status: true
							});
						}
						this.setState({
							brands: data.brands_lst,
							categories: data.cat_lst,
							sort_list: data.sort,
							deal_types: data.deal_types
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'getCartCount',
			value: function getCartCount() {
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token') };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'cart_count',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							cart_count: data.cart_count
						});
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				document.title = this.state.page_name ? this.state.page_name + " Store | AquaDeals" : "AquaDeals Stores | AquaDeals";
				var storedeals = this.state.store_deals.map(function (deal, index) {
					return _react2.default.createElement(Product, { key: index, data: deal, onUpdate: function onUpdate() {
							return _this2.getCartCount();
						} });
				});
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals' },
					this.state.loading ? _react2.default.createElement(
						'div',
						{ className: 'mob_storedeals' },
						_react2.default.createElement(
							'div',
							{ className: 'page_hdr' },
							_react2.default.createElement(
								'div',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'h5',
									null,
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: "/" },
										_react2.default.createElement(
											'i',
											null,
											_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/back_arrow.png', width: '18px', alt: '' })
										)
									),
									this.state.page_name
								),
								_react2.default.createElement(
									'a',
									{ href: '/', className: 'home_logo1' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/home1.png', alt: 'Home' })
								),
								_react2.default.createElement(
									'a',
									{ className: 'mob_cart_btn', href: '/mycart' },
									_react2.default.createElement('img', { alt: '', src: 'https://aquadeals.in/admin/assets/icons/web_icons/cart_icon.png' }),
									this.state.cart_count > 0 ? _react2.default.createElement(
										'span',
										{ className: this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count" },
										this.state.cart_count
									) : ''
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'pag_cntnt' },
							'\xA0'
						),
						this.state.loading_gif ? _react2.default.createElement(
							'i',
							{ className: 'mob_loading' },
							_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/mob_loading.gif', alt: 'Loading' })
						) : '',
						_react2.default.createElement(
							'section',
							{ className: '' },
							this.state.nodata ? _react2.default.createElement(
								'div',
								{ className: 'no_data' },
								_react2.default.createElement(
									'h3',
									null,
									'No Deals Available'
								),
								_react2.default.createElement(
									'p',
									null,
									'Need something here? ',
									_react2.default.createElement(
										_reactRouter.Link,
										{ to: "/customer_care" },
										'CONTACT US'
									),
									' now !'
								)
							) : '',
							_react2.default.createElement(
								_reactInfiniteScrollComponent2.default,
								{
									pullDownToRefresh: true,
									pullDownToRefreshContent: _react2.default.createElement(
										'h3',
										{ style: { textAlign: 'center' } },
										'\u2193'
									),
									releaseToRefreshContent: _react2.default.createElement(
										'h3',
										{ style: { textAlign: 'center' } },
										'\u2191'
									),
									refreshFunction: this.refresh,
									next: this.fetchData,
									hasMore: true,
									scrollThreshold: 0.5,
									loader: _react2.default.createElement('h4', null),
									endMessage: _react2.default.createElement(
										'p',
										{ style: { textAlign: 'center' } },
										_react2.default.createElement('b', null)
									) },
								storedeals
							),
							this.state.loading_more_status ? _react2.default.createElement(
								'div',
								{ className: 'loading_more_sym' },
								_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/mob_loading.gif', alt: 'Loading' })
							) : ''
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'section',
							{ className: 'seed_sort dsl_srt' },
							_react2.default.createElement(
								'ul',
								null,
								this.state.sort_status && !this.state.cat_status && !this.state.brands_status ? _react2.default.createElement(
									'li',
									{ className: 'col-md-12 col-xs-12 col-sm-12 ' },
									_react2.default.createElement(
										_reactBootstrap.ButtonToolbar,
										null,
										_react2.default.createElement(
											_reactBootstrap.DropdownButton,
											{ className: 'test_filter_4', noCaret: true, onClick: this.getSorts, title: 'Sort By', dropup: true },
											_react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ header: true },
												'Sort By'
											),
											this.state.sort_list.map(function (cat, index) {
												return _react2.default.createElement(
													_reactBootstrap.MenuItem,
													{ className: 'seed_list1', eventKey: cat.id, onClick: function onClick() {
															return _this2.getSelectedCategorySort(cat.id);
														} },
													cat.name
												);
											})
										)
									)
								) : ' ',
								this.state.sort_status && (this.state.cat_status || this.state.brands_status) ? _react2.default.createElement(
									'li',
									{ className: 'col-md-6 col-xs-6 col-sm-6 ' },
									_react2.default.createElement(
										_reactBootstrap.ButtonToolbar,
										null,
										_react2.default.createElement(
											_reactBootstrap.DropdownButton,
											{ className: 'test_filter_4', noCaret: true, onClick: this.getSorts, title: 'Sort By', dropup: true },
											_react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ header: true },
												'Sort By'
											),
											this.state.sort_list.map(function (cat, index) {
												return _react2.default.createElement(
													_reactBootstrap.MenuItem,
													{ className: 'seed_list1', eventKey: cat.id, onClick: function onClick() {
															return _this2.getSelectedCategorySort(cat.id);
														} },
													cat.name
												);
											})
										)
									)
								) : '',
								this.state.cat_status ? _react2.default.createElement(
									'li',
									{ className: 'col-md-6 col-xs-6 col-sm-6 coast_list2' },
									_react2.default.createElement(
										_reactBootstrap.ButtonToolbar,
										null,
										_react2.default.createElement(
											_reactBootstrap.DropdownButton,
											{ className: 'test_filter_2', noCaret: true, onClick: this.getCoasts, title: 'By Category', dropup: true },
											_react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ header: true },
												'By Category'
											),
											this.state.categories.map(function (cat, index) {
												return _react2.default.createElement(
													_reactBootstrap.MenuItem,
													{ className: 'seed_list1', eventKey: cat.id, onClick: function onClick() {
															return _this2.getSelectedCategory(cat.id);
														} },
													cat.name
												);
											})
										)
									)
								) : '',
								this.state.brands_status ? _react2.default.createElement(
									'li',
									{ className: 'col-md-6 col-xs-6 col-sm-6 coast_list1' },
									_react2.default.createElement(
										_reactBootstrap.ButtonToolbar,
										null,
										_react2.default.createElement(
											_reactBootstrap.DropdownButton,
											{ className: 'test_filter_1', noCaret: true, onClick: this.getBrands, title: 'By Brand', dropup: true },
											_react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ header: true },
												'By Brand (',
												this.state.brands.length,
												')'
											),
											this.state.brands.map(function (brand, index) {
												return _react2.default.createElement(
													_reactBootstrap.MenuItem,
													{ eventKey: brand.id, className: 'seed_list1', onClick: function onClick() {
															return _this2.getSelectedBrand(brand.id);
														} },
													brand.name
												);
											})
										)
									)
								) : '',
								this.state.deal_type_status ? _react2.default.createElement(
									'li',
									{ className: 'col-md-6 col-xs-6 col-sm-6 coast_list2' },
									_react2.default.createElement(
										_reactBootstrap.ButtonToolbar,
										null,
										_react2.default.createElement(
											_reactBootstrap.DropdownButton,
											{ className: 'test_filter_2', noCaret: true, onClick: this.getCoasts, title: 'By Type', dropup: true },
											_react2.default.createElement(
												_reactBootstrap.MenuItem,
												{ header: true },
												'By Type '
											),
											this.state.deal_types.map(function (cat, index) {
												return _react2.default.createElement(
													_reactBootstrap.MenuItem,
													{ className: 'seed_list1', eventKey: cat.id, onClick: function onClick() {
															return _this2.getSelectedDType(cat.id);
														} },
													cat.name
												);
											})
										)
									)
								) : ''
							)
						)
					) : _react2.default.createElement(
						'div',
						{ className: 'mob_loading' },
						_react2.default.createElement('img', { src: baseAssets + 'images/web_imgs/mob_loading.gif', alt: 'Loading', role: 'presentation' }),
						' '
					)
				);
			}
		}]);
	
		return StoreDeals;
	}(_react.Component);
	
	exports.default = StoreDeals;
	
	var Product = exports.Product = function (_Component2) {
		_inherits(Product, _Component2);
	
		function Product(props) {
			_classCallCheck(this, Product);
	
			var _this3 = _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).call(this, props));
	
			_this3.state = {
				open: false,
				msg: '',
				shareUrl: '',
				cart_count: '',
				clearcart_status: false,
				already_added_status: false
			};
			_this3.ShareFunc = _this3.ShareFunc.bind(_this3);
			_this3.addToCart = _this3.addToCart.bind(_this3);
			_this3.updateCartCount = _this3.updateCartCount.bind(_this3);
			_this3.close = _this3.close.bind(_this3);
			_this3.replaceCartItems = _this3.replaceCartItems.bind(_this3);
			_this3.addToQuickCart = _this3.addToQuickCart.bind(_this3);
			_this3.addToQuickCart_Onload = _this3.addToQuickCart_Onload.bind(_this3);
			return _this3;
		}
	
		_createClass(Product, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (localStorage.user_id && localStorage.token && localStorage.quickbuy_onload) {
					this.addToQuickCart_Onload();
					localStorage.removeItem('quickbuy_onload');
					localStorage.removeItem('quickbuy_deal_id');
				}
			}
		}, {
			key: 'ShareFunc',
			value: function ShareFunc(evnt) {
				var _this4 = this;
	
				var data1 = { from: 'mobile_web', type: 1, did: evnt };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'createTinyurl',
					dataType: 'json',
					data: { req: data2 },
					success: function (data) {
						this.setState({
							msg: data.msg,
							shareUrl: data.tinyurl
						});
					}.bind(this),
					error: function error(err) {}
				});
				this.setState({
					open: !this.state.open
				});
				setTimeout(function () {
					_this4.setState({ open: false });
				}, 5000);
			}
		}, {
			key: 'replaceCartItems',
			value: function replaceCartItems(deal_id, quantity) {
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1, quantity: quantity, pl_size: 0, salinity: 0, pickup_date: 0 };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'replaceCart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success") {
							this.setState({
								clearcart_status: false
							});
							_reactRouter.browserHistory.push('/mycart');
						}
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					clearcart_status: false,
					already_added_status: false
				});
			}
		}, {
			key: 'addToCart',
			value: function addToCart(deal_id) {
				if (!localStorage.user_id && !localStorage.token) {
					_reactRouter.browserHistory.push('/login');
				} else {
					var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1 };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'post',
						dataType: 'json',
						url: baseUrl + 'quickBuy',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.updateCartCount();
								_reactRouter.browserHistory.push('/mycart');
							} else if (data.status === "error" && data.cart_flag === 0) {
								this.setState({
									clearcart_status: true
								});
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'addToQuickCart_Onload',
			value: function addToQuickCart_Onload() {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('stores_quick_buy', '1');
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.user_id;
					} else {
						uid = 0;
					}
					if (localStorage.quickbuy_deal_id) {
						var deal_id = localStorage.quickbuy_deal_id;
					} else {
						deal_id = 0;
					}
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1 };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'post',
						dataType: 'json',
						url: baseUrl + 'addToQCart',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.updateCartCount();
								_reactRouter.browserHistory.push('/quickcart');
							} else if (data.status === "error" && data.cart_flag === 0) {
								this.setState({
									clearcart_status: true
								});
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'addToQuickCart',
			value: function addToQuickCart(deal_id) {
				if (!localStorage.user_id && !localStorage.token) {
					localStorage.setItem('stores_quick_buy', '1');
					localStorage.setItem('quickbuy_onload', '1');
					localStorage.setItem('quickbuy_deal_id', deal_id);
					_reactRouter.browserHistory.push('/login');
				} else {
					if (localStorage.user_id) {
						var uid = localStorage.user_id;
					} else {
						uid = 0;
					}
					var data1 = { from: 'mobile_web', id: uid, token: localStorage.getItem('token'), deal_id: deal_id, deal_type: 1 };
					var data2 = JSON.stringify(data1);
					_jquery2.default.ajax({
						method: 'post',
						dataType: 'json',
						url: baseUrl + 'addToQCart',
						data: { req: data2 },
						success: function (data) {
							if (data.status === "success") {
								this.updateCartCount();
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
								_reactRouter.browserHistory.push('/quickcart');
							} else if (data.status === "error" && data.cart_flag === 0) {
								this.setState({
									clearcart_status: true
								});
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							} else if (data.status === "error" && data.message === "Product already added to the cart") {
								this.setState({
									already_added_status: true
								});
								localStorage.removeItem('quickbuy_onload');
								localStorage.removeItem('quickbuy_deal_id');
							}
						}.bind(this),
						error: function error(err) {}
					});
				}
			}
		}, {
			key: 'updateCartCount',
			value: function updateCartCount() {
				this.props.onUpdate();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var mydata = this.props.data;
				var shareUrl = this.state.shareUrl;
				var title = "Hey Click here " + shareUrl + " to check " + mydata.title + " from AquaDeals.";
				var description = shareUrl;
				return _react2.default.createElement(
					'div',
					{ className: 'list_card' },
					mydata.promo_ribbion ? _react2.default.createElement(
						'i',
						{ className: 'ribbon_img' },
						_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/' + mydata.promo_ribbion, alt: '' })
					) : '',
					mydata.dealcount >= 2 ? _react2.default.createElement(
						_reactRouter.Link,
						{ to: '/subdeals/' + mydata.url_dtype_name + '/' + mydata.url_cat_name + '/' + mydata.dtype + '/' + mydata.url_brand_name + '/' + mydata.pid },
						_react2.default.createElement(
							'div',
							{ className: 'list_img' },
							_react2.default.createElement('img', { src: mydata.image === null ? 'https://aquadeals.in/admin/assets/images/product_imgs/noimage1.jpg' : 'https://aquadeals.in/admin/assets/images/product_imgs/thumbnails/' + mydata.image, alt: ' ' })
						),
						mydata.ad_guarantee_flag === '1' ? _react2.default.createElement(
							'span',
							{ className: 'pdeals_adguarantee' },
							_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: ' ' })
						) : '',
						_react2.default.createElement(
							'div',
							{ className: 'list_txt' },
							_react2.default.createElement(
								'h4',
								null,
								mydata.title,
								' ',
								mydata.quantity
							),
							mydata.brand_name ? _react2.default.createElement(
								'h5',
								null,
								mydata.brand_name
							) : '',
							mydata.dealcount >= 2 ? _react2.default.createElement(
								'h3',
								null,
								mydata.dealcount,
								' deals available'
							) : '',
							mydata.over_rate >= 1 ? _react2.default.createElement(
								'h6',
								null,
								_react2.default.createElement(
									'i',
									{ className: 'm_star_rate' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/star_filled.png', width: '16px', role: 'presentation' })
								),
								mydata.over_rate
							) : _react2.default.createElement(
								'h6',
								null,
								_react2.default.createElement(
									'i',
									{ className: 'm_nostar_rate' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/star_gray.png', width: '17px', role: 'presentation' })
								)
							)
						)
					) : _react2.default.createElement(
						_reactRouter.Link,
						{ to: "/pdetails/" + mydata.url_dtype_name + "/" + mydata.url_cat_name + "/" + mydata.url_brand_name + "/" + mydata.url_product_name + "/" + mydata.pid + "/" + mydata.deal_id },
						_react2.default.createElement(
							'div',
							{ className: 'list_img' },
							_react2.default.createElement('img', { src: mydata.image === null ? 'https://aquadeals.in/admin/assets/images/product_imgs/noimage1.jpg' : 'https://aquadeals.in/admin/assets/images/product_imgs/thumbnails/' + mydata.image, alt: ' ' })
						),
						mydata.ad_guarantee_flag === '1' ? _react2.default.createElement(
							'span',
							{ className: 'pdeals_adguarantee' },
							_react2.default.createElement('img', { src: baseAssets + 'images/product_imgs/ad_guarantee.png', alt: ' ' })
						) : '',
						_react2.default.createElement(
							'div',
							{ className: 'list_txt' },
							_react2.default.createElement(
								'h4',
								null,
								mydata.title,
								' ',
								mydata.quantity
							),
							mydata.brand_name ? _react2.default.createElement(
								'h5',
								null,
								mydata.brand_name
							) : '',
							mydata.pricediff === "" ? _react2.default.createElement(
								'h3',
								null,
								'MRP \u20B9 ',
								mydata.mrp
							) : '',
							mydata.pricediff ? _react2.default.createElement(
								'h3',
								null,
								'aquacash discount \u20B9 ',
								mydata.pricediff
							) : '',
							mydata.over_rate >= 1 ? _react2.default.createElement(
								'h6',
								null,
								_react2.default.createElement(
									'i',
									{ className: 'm_star_rate' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/star_filled.png', width: '16px', role: 'presentation' })
								),
								mydata.over_rate
							) : _react2.default.createElement(
								'h6',
								null,
								_react2.default.createElement(
									'i',
									{ className: 'm_nostar_rate' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/star_gray.png', width: '17px', role: 'presentation' })
								)
							)
						)
					),
					mydata.dealcount <= 1 ? _react2.default.createElement(
						_reactRouter.Link,
						{ className: 'share_list', onClick: function onClick() {
								_this5.ShareFunc(mydata.deal_id);
							} },
						_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/share1.png', alt: 'share' })
					) : '',
					mydata.dealcount >= 2 ? '' : mydata.count >= 2 ? _react2.default.createElement(
						'h6',
						{ className: "views_eye" },
						_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/web_imgs/eye.png', width: '17px', role: 'presentation' }),
						' ',
						mydata.count,
						' ',
						mydata.count > 1 ? 'Views' : 'View'
					) : '',
					mydata.dealcount >= 2 ? '' : _react2.default.createElement(
						'a',
						{ className: 'quick_buy_img', onClick: function onClick() {
								return _this5.addToQuickCart(mydata.deal_id);
							} },
						_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/icons/quick_buy.png', alt: ' ', width: '50px' })
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_reactBootstrap.Panel,
							{ className: 'share_panel', collapsible: true, expanded: this.state.open },
							_react2.default.createElement(
								FacebookShareButton,
								{ url: shareUrl, quote: title, className: 'test_share' },
								_react2.default.createElement(FacebookIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								TwitterShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share' },
								_react2.default.createElement(TwitterIcon, { size: 32, round: true })
							),
							_react2.default.createElement(
								GooglePlusShareButton,
								{ url: shareUrl, quote: title, description: description, className: 'test_share' },
								_react2.default.createElement(GooglePlusIcon, { size: 32, round: true })
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.clearcart_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#333' } },
								'You can\'t have multiple seller items in the cart. Empty existing cart & add this item ',
								mydata.title,
								'?'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'NO'
							),
							_react2.default.createElement(
								'a',
								null,
								_react2.default.createElement(
									_reactBootstrap.Button,
									{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: function onClick() {
											_this5.replaceCartItems(mydata.deal_id, mydata.min_qty);
										} },
									'YES'
								)
							)
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal,
						{ className: 'm_pro_full_dtls_modal', show: this.state.already_added_status, onHide: this.close },
						_react2.default.createElement(
							_reactBootstrap.Modal.Header,
							{ closeButton: true },
							_react2.default.createElement(
								_reactBootstrap.Modal.Title,
								{ style: { fontSize: '16px', color: '#333' } },
								'Alert'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Body,
							null,
							_react2.default.createElement(
								'h4',
								{ style: { fontSize: '14px', color: '#333' } },
								'Product already added to the cart'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Modal.Footer,
							{ className: 'modal_footer' },
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ style: { background: 'none', border: 'none', color: '#ff742a' }, onClick: this.close },
								'OK'
							)
						)
					)
				);
			}
		}]);
	
		return Product;
	}(_react.Component);

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _reactWebVectorIcons = __webpack_require__(29);
	
	var _reactWebVectorIcons2 = _interopRequireDefault(_reactWebVectorIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WishList = function (_Component) {
		_inherits(WishList, _Component);
	
		function WishList(props) {
			_classCallCheck(this, WishList);
	
			var _this = _possibleConstructorReturn(this, (WishList.__proto__ || Object.getPrototypeOf(WishList)).call(this, props));
	
			_this.state = {
				cartcount: '',
				page_loading: false,
				wish_deals: [],
				cart_status: false,
				cart_status_msg: '',
				cart_added_status: false,
				clearcart_status: false,
	
				replace_deal_id: '',
				replace_deal_type: '',
				replace_qty: '',
				replace_pl_size: '',
				replace_salinity: '',
				replace_pickup_date: '',
				replace_id: '',
				replace_pro_title: '',
				emptyCartConfirm: false,
				cart_flag: ''
	
			};
			_this.getDeals = _this.getDeals.bind(_this);
			_this.addToCart = _this.addToCart.bind(_this);
			_this.close = _this.close.bind(_this);
			_this.replaceCartItems = _this.replaceCartItems.bind(_this);
			_this.emptyCartConfirm = _this.emptyCartConfirm.bind(_this);
			_this.emptyWishList = _this.emptyWishList.bind(_this);
			_this.deleteSingleItem = _this.deleteSingleItem.bind(_this);
			_this.tokenCheck = _this.tokenCheck.bind(_this);
			return _this;
		}
	
		_createClass(WishList, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (!localStorage.token && !localStorage.user_id) {
					localStorage.setItem('wishlist', '/wishlist');
					_reactRouter.browserHistory.push('/login');
				} else {
					this.getDeals();
				}
			}
		}, {
			key: 'deleteSingleItem',
			value: function deleteSingleItem(id) {
				this.setState({
					page_loading: true
				});
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: id, token: localStorage.token, uid: localStorage.user_id, source: source, campain: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'rmvFrmWshlst',
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								page_loading: false
							});
							this.getDeals();
						}
						if (data.status === 'error' && data.message === 'Token mismatch') {
							this.tokenCheck();
						}
						// else
						// {
						// 	this.setState({
						// 		page_loading:false,
						// 	});
						// }
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'tokenCheck',
			value: function tokenCheck() {
				localStorage.removeItem('user_id');
				localStorage.removeItem('token');
				window.location.reload();
			}
		}, {
			key: 'getDeals',
			value: function getDeals() {
				this.setState({
					page_loading: true
				});
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'Wishlist',
					data: { req: data2 },
					success: function (data) {
						if (data.status === 'success') {
							this.setState({
								page_loading: false,
								wish_deals: data.lst_items,
								cartcount: data.count
							});
						} else if (data.status === 'error' && data.message === "Token mismatch") {
							this.tokenCheck();
						} else {
							this.setState({
								page_loading: false
							});
						}
					}.bind(this),
					error: function error(err) {
						this.setState({
							page_loading: false
						});
					}
				});
			}
		}, {
			key: 'addToCart',
			value: function addToCart(deal_id, deal_type, qty, pl_size, salinity, pickup_date, id, pro_title) {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				this.setState({
					replace_deal_id: deal_id,
					replace_deal_type: deal_type,
					replace_qty: qty,
					replace_pl_size: pl_size,
					replace_salinity: salinity,
					replace_pickup_date: pickup_date,
					replace_id: id,
					replace_pro_title: pro_title, source: source, campaign: campaign, url_id: url_id
				});
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, deal_id: deal_id, deal_type: deal_type, quantity: qty, pl_size: pl_size, salinity: salinity, pickup_date: pickup_date, wishLst_id: id, wishLst_flag: '1' };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					url: baseUrl + 'addToCart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success" && data.message === "Added to cart") {
							this.setState({
								cart_status: true,
								cart_status_msg: data.message
							});
							this.getDeals();
						}
						if (data.status === "success" && data.message === "Cart Updated") {
							this.setState({
								cart_status: true,
								cart_status_msg: data.message
							});
						}
						if (data.status === "error" && data.cart_flag === 0) {
							this.setState({
								clearcart_status: true
							});
						}
						if (data.status === "error" && data.message === "Product already added to the cart" && data.cart_flag === 1) {
							this.setState({
								cart_added_status: true
							});
						}
						this.getDeals();
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'close',
			value: function close() {
				this.setState({
					cart_status: false,
					clearcart_status: false,
					cart_added_status: false,
					emptyCartConfirm: false
				});
			}
		}, {
			key: 'replaceCartItems',
			value: function replaceCartItems() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.getItem('user_id'), token: localStorage.getItem('token'), deal_id: this.state.replace_deal_id, deal_type: this.state.replace_deal_type, quantity: this.state.replace_qty, pl_size: this.state.replace_pl_size, salinity: this.state.replace_salinity, pickup_date: this.state.replace_pickup_date, source: source, campaign: campaign, url_id: url_id, wishLst_flag: '1', wishLst_id: this.state.replace_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'post',
					dataType: 'json',
					url: baseUrl + 'replaceCart',
					data: { req: data2 },
					success: function (data) {
						if (data.status === "success" && data.cart_flag === 1) {
							this.setState({
								clearcart_status: false,
								cart_status: true,
								cart_status_msg: data.message
							});
						}
						this.getDeals();
					}.bind(this),
					error: function error(err) {
						// console.log(err)
					}
				});
			}
		}, {
			key: 'emptyCartConfirm',
			value: function emptyCartConfirm() {
	
				this.setState({
					emptyCartConfirm: true
				});
			}
		}, {
			key: 'emptyWishList',
			value: function emptyWishList() {
				if (localStorage.source) {
					var source = localStorage.getItem('source');
				} else {
					source = '';
				}
				if (localStorage.campaign) {
					var campaign = localStorage.getItem('campaign');
				} else {
					campaign = '';
				}
				if (localStorage.url_id) {
					var url_id = localStorage.getItem('url_id');
				} else {
					url_id = '';
				}
				this.setState({
					emptyCartConfirm: false
				});
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				var data1 = { from: 'mobile_web', id: localStorage.user_id, token: localStorage.token, source: source, campaign: campaign, url_id: url_id };
				var data2 = JSON.stringify(data1);
				_jquery2.default.ajax({
					method: 'POST',
					dataType: 'json',
					data: { req: data2 },
					url: baseUrl + 'clearWishlist',
					success: function (data) {
						if (data.status === 'success') {}
						this.getDeals();
					}.bind(this),
					error: function error(err) {}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				document.title = "WishList | AquaDeals";
				var wishdeals_list = this.state.wish_deals.map(function (data, index) {
					var _this2 = this;
	
					return _react2.default.createElement(
						'div',
						{ className: 'col-md-6 col-sm-6 col-xs-5 mob_wish_deal_blks' },
						_react2.default.createElement(
							'span',
							{ onClick: function onClick() {
									_this2.deleteSingleItem(data.id);
								} },
							_react2.default.createElement(_reactWebVectorIcons2.default, {
								name: 'close',
								font: 'SimpleLineIcons',
								color: '#bbb',
								size: 16,
								style: { position: 'absolute', right: '10px', top: '8px', cursor: 'pointer' }
							})
						),
						_react2.default.createElement(
							_reactRouter.Link,
							{ style: { textDecoration: 'none', color: '#333' }, to: data.type === 0 ? "/sdetails/" + data.sname + "/" + data.deal_id : "/pdetails/" + data.url_dtype_name + "/" + data.url_cat_name + "/" + data.url_brand_name + "/" + data.url_product_name + "/" + data.pid + "/" + data.deal_id },
							_react2.default.createElement(
								'div',
								{ style: { paddingLeft: '10px', paddingRight: '10px' } },
								data.type === 0 ? _react2.default.createElement('img', { src: data.img !== null && data.img !== '' ? data.img : 'https://aquadeals.in/admin/assets/icons/web_icons/noImage.png', alt: '' }) : _react2.default.createElement('img', { src: data.img !== null && data.img !== '' ? data.img : 'https://aquadeals.in/admin/assets/icons/web_icons/noImage.png', alt: '' })
							),
							data.pro_name ? _react2.default.createElement(
								'h5',
								{ className: 'mob_wish_title' },
								data.pro_name
							) : _react2.default.createElement(
								'h5',
								{ className: 'mob_wish_title' },
								'\xA0'
							),
							data.brand !== null && data.brand !== "" ? _react2.default.createElement(
								'h6',
								{ className: 'mob_wish_brand' },
								data.brand
							) : _react2.default.createElement(
								'h6',
								{ className: 'mob_wish_brand' },
								'\xA0'
							),
							data.mrp ? _react2.default.createElement(
								'h6',
								{ className: 'mob_wish_mrp' },
								'MRP : \u20B9 ',
								data.mrp,
								' '
							) : _react2.default.createElement(
								'h6',
								{ className: 'mob_wish_mrp' },
								'\xA0'
							)
						),
						data.cart_flag === 1 ? _react2.default.createElement(
							'div',
							{ className: 'mob_wish_add_blk' },
							_react2.default.createElement(
								'a',
								{ className: 'mob_wish_add_cart_btn', href: '/mycart' },
								'GO TO CART'
							)
						) : _react2.default.createElement(
							'div',
							{ className: 'mob_wish_add_blk' },
							_react2.default.createElement(
								'a',
								{ className: 'mob_wish_add_cart_btn', onClick: function onClick() {
										_this2.addToCart(data.deal_id, data.type, data.qty, data.pl_size, data.salinity, data.pickup_date, data.id, data.pro_name);
									} },
								'ADD TO CART'
							)
						)
					);
				}.bind(this));
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals mob_wishlist' },
					_react2.default.createElement(
						'div',
						{ className: 'page_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'container-fluid' },
							_react2.default.createElement(
								'h5',
								null,
								_react2.default.createElement(
									_reactRouter.Link,
									{ onClick: function onClick() {
											_reactRouter.browserHistory.goBack();
										} },
									_react2.default.createElement(
										'i',
										null,
										_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png', className: 'cross_icon', width: '14px', alt: '' })
									)
								),
								_react2.default.createElement(
									'span',
									{ className: 'header_text' },
									'WishList'
								)
							),
							_react2.default.createElement(
								'a',
								{ href: '/', className: 'home_newicon' },
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/home1.png', alt: 'Home' })
							),
							_react2.default.createElement(
								'a',
								{ className: 'cart_emptybtn', onClick: function onClick() {
										_this3.emptyCartConfirm();
									} },
								_react2.default.createElement('img', { alt: '', src: 'https://aquadeals.in/admin/assets/icons/web_icons/del_bin3.png' })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					this.state.cartcount !== 0 ? _react2.default.createElement(
						'div',
						{ style: { marginBottom: '30px' } },
						this.state.page_loading ? _react2.default.createElement(
							'div',
							{ className: 'checkout_loading' },
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/loading_more.gif', alt: 'Loading' })
						) : _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'section',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'div',
									{ className: 'row', style: { backgroundColor: '#f2f2f2', paddingTop: '10px', paddingBottom: '10px' } },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-6 col-sm-6 col-xs-6' },
										this.state.cartcount > 1 ? 'Items : ' + this.state.cartcount : 'Item : ' + this.state.cartcount,
										' '
									)
								)
							),
							_react2.default.createElement(
								'section',
								{ className: 'container-fluid' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									wishdeals_list
								)
							),
							this.state.page_loading ? _react2.default.createElement(
								'i',
								{ className: 'pro_load_img' },
								_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/images/loading_more.gif', alt: 'Loading' })
							) : '',
							_react2.default.createElement(
								_reactBootstrap.Modal,
								{ className: 'wish_modals', show: this.state.cart_status, onHide: this.close },
								_react2.default.createElement(
									_reactBootstrap.Modal.Header,
									{ closeButton: true },
									_react2.default.createElement(
										_reactBootstrap.Modal.Title,
										{ className: 'wish_modal_title' },
										'Alert'
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal.Body,
									null,
									_react2.default.createElement(
										'h4',
										{ className: 'wish_modal_h4' },
										this.state.cart_status_msg
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal.Footer,
									{ className: 'modal_footer' },
									_react2.default.createElement(
										_reactBootstrap.Button,
										{ onClick: this.close },
										'Close'
									)
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal,
								{ className: 'wish_modals', show: this.state.clearcart_status, onHide: this.close },
								_react2.default.createElement(
									_reactBootstrap.Modal.Header,
									{ closeButton: true },
									_react2.default.createElement(
										_reactBootstrap.Modal.Title,
										{ className: 'wish_modal_title' },
										'Alert'
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal.Body,
									null,
									_react2.default.createElement(
										'h4',
										{ className: 'wish_modal_h4' },
										'You can\'t have multiple seller items in the cart. Empty existing cart & add this item ',
										this.state.replace_pro_title,
										'?'
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal.Footer,
									{ className: 'modal_footer' },
									_react2.default.createElement(
										_reactBootstrap.Button,
										{ onClick: this.close },
										'NO'
									),
									_react2.default.createElement(
										'a',
										null,
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ onClick: function onClick() {
													_this3.replaceCartItems();
												} },
											'YES'
										)
									)
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal,
								{ className: 'wish_modals', show: this.state.cart_added_status, onHide: this.close },
								_react2.default.createElement(
									_reactBootstrap.Modal.Header,
									{ closeButton: true },
									_react2.default.createElement(
										_reactBootstrap.Modal.Title,
										{ className: 'wish_modal_title' },
										'Alert'
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal.Body,
									null,
									_react2.default.createElement(
										'h4',
										{ className: 'wish_modal_h4' },
										'Product already added to the cart!'
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal.Footer,
									{ className: 'modal_footer' },
									_react2.default.createElement(
										_reactBootstrap.Button,
										{ onClick: this.close },
										'Close'
									)
								)
							),
							_react2.default.createElement(
								_reactBootstrap.Modal,
								{ className: 'wish_modals', show: this.state.emptyCartConfirm, onHide: this.close },
								_react2.default.createElement(
									_reactBootstrap.Modal.Body,
									null,
									_react2.default.createElement(
										'h5',
										null,
										'Do you want to remove all items? '
									)
								),
								_react2.default.createElement(
									_reactBootstrap.Modal.Footer,
									{ className: 'mob_cart_confirm' },
									_react2.default.createElement(
										_reactBootstrap.Button,
										{ className: '', onClick: this.close },
										'NO'
									),
									_react2.default.createElement(
										'a',
										null,
										_react2.default.createElement(
											_reactBootstrap.Button,
											{ onClick: function onClick() {
													_this3.emptyWishList();
												} },
											'YES'
										)
									)
								)
							)
						)
					) : _react2.default.createElement(
						'div',
						{ className: 'wishlist_emtpy' },
						_react2.default.createElement(
							'i',
							null,
							_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/empty_cartbg.png', alt: '...' })
						),
						_react2.default.createElement(
							'h4',
							{ style: { marginBottom: '25px', marginTop: '10px' } },
							'Your Wishlist is Empty'
						),
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: "/", className: 'wish_shopbtn' },
							'SHOP NOW'
						)
					)
				);
			}
		}]);
	
		return WishList;
	}(_react.Component);
	
	exports.default = WishList;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(2);
	
	var _Header = __webpack_require__(139);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(138);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Home = function (_Component) {
		_inherits(Home, _Component);
	
		function Home(props) {
			_classCallCheck(this, Home);
	
			var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));
	
			_this.getDeviceId = _this.getDeviceId.bind(_this);
			return _this;
		}
	
		_createClass(Home, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (screen.width >= 800) {
					window.location.href = "/web/aboutus";
				}
				this.getDeviceId();
			}
		}, {
			key: 'getDeviceId',
			value: function getDeviceId() {
				if (localStorage.user_id) {
					var user_id = localStorage.user_id;
				} else {
					user_id = 0;
				}
				var data1 = { from: 'mobile_web', id: user_id, device_id: localStorage.getItem('push_device_id') };
				var data2 = JSON.stringify(data1);
				var baseUrl = 'https://aquadeals.in/admin/web3/user/';
				_jquery2.default.ajax({
					method: 'POST',
					url: baseUrl + 'getDeviceId',
					dataType: 'json',
					data: { req: data2 },
					success: function success(data) {
						// console.log(data);    
					},
					error: function error(err) {
						// console.log(err);
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				document.title = "AquaDeals - Online AquaCulture MarketPlace  Find best deals on Seed, Feed, Health Care, Machinery & Farm Equipments, Products, Ropes & Nets Paddle Wheels and More | AquaDeals";
				document.getElementsByTagName("META")[2].content = "It is a place for deals related to Aqua culture";
				return _react2.default.createElement(
					'div',
					{ className: 'mob_deals' },
					_react2.default.createElement(_Header2.default, null),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'clr' },
						'\xA0'
					),
					_react2.default.createElement(
						'section',
						{ className: 'indx_hdr' },
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'container tp_block' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-5 col-md-offset-1 col-sm-6' },
									_react2.default.createElement(
										'h2',
										null,
										'Welcome to Aquadeals'
									),
									_react2.default.createElement(
										'p',
										null,
										'For fast and safe orders  of Seed, Feed, Health Care, Machinery & Farm Equipment  experience the AquaDeals app on your Android phone and order on the GO! We are sure you will find the best deals every time. Invite your Contacts and get AquaCash. Refer your friends to download the AquaDeals app, sign up using your referral code and earn Rs. 2000 AquaCash. Your friend gets Rs. 2000 AquaCash. And there\u2019s more.'
									),
									_react2.default.createElement(
										'ul',
										{ className: 'top_btns_blk' },
										_react2.default.createElement(
											'li',
											null,
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: '/', className: 'top_btns' },
												'Explore AquaDeals'
											)
										),
										_react2.default.createElement(
											'li',
											null,
											_react2.default.createElement(
												_reactRouter.Link,
												{ to: "/enquire_now/partner/support/sid/did", className: 'top_btns' },
												'Join as Partner'
											)
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-6 col-sm-6' },
									_react2.default.createElement(
										'div',
										{ className: 'top_rgt_mble' },
										_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/mobile.png', alt: 'Aqua' })
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'features_blk' },
						_react2.default.createElement('div', { className: 'topright' }),
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ className: 'features_cntnt' },
								_react2.default.createElement(
									'div',
									{ className: 'row' },
									_react2.default.createElement(
										'div',
										{ className: 'col-md-8' },
										_react2.default.createElement(
											'div',
											{ className: 'row features_blk_cntnt' },
											_react2.default.createElement(
												'div',
												{ className: 'col-md-5' },
												_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/deals.png', alt: 'Deal' }),
												_react2.default.createElement(
													'h4',
													null,
													'D',
													_react2.default.createElement(
														'span',
														null,
														'eal'
													),
													's'
												),
												_react2.default.createElement(
													'p',
													null,
													'Search several deals on Seed, Feed, Health Care, Machinery & Farm Equipment etc right from your mobile.'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-5' },
												_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/bookings.png', alt: 'Orders' }),
												_react2.default.createElement(
													'h4',
													null,
													'ORDERS'
												),
												_react2.default.createElement(
													'p',
													null,
													'Save finding, meeting and negotiating time. Now, find & order your deal in 3 simple steps wherever you are'
												)
											)
										),
										_react2.default.createElement(
											'div',
											{ className: 'row features_blk_cntnt' },
											_react2.default.createElement(
												'div',
												{ className: 'col-md-5' },
												_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/offers.png', alt: 'Offers' }),
												_react2.default.createElement(
													'h4',
													null,
													'Spec',
													_react2.default.createElement(
														'span',
														null,
														'ial Off'
													),
													'ers'
												),
												_react2.default.createElement(
													'p',
													null,
													'Celebrate the best of offers that you can ever get for your aqua business. Profit, Share, WalletUp!'
												)
											),
											_react2.default.createElement(
												'div',
												{ className: 'col-md-5' },
												_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/refer.png', alt: 'Refer' }),
												_react2.default.createElement(
													'h4',
													null,
													'Ref',
													_react2.default.createElement(
														'span',
														null,
														'er & Ea'
													),
													'rn'
												),
												_react2.default.createElement(
													'p',
													null,
													'Fill your wallet with the magical AquaCash by just sharing with your friends across the world on how you got better business with AD. Bestow Smiles!'
												)
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'col-md-4' },
										_react2.default.createElement(
											'h2',
											null,
											'Feat',
											_react2.default.createElement(
												'span',
												null,
												'ures'
											)
										),
										_react2.default.createElement(
											'h6',
											null,
											'For fast and safe orders of Seed, Feed, Health Care, Machinery & Farm Equipment experience the AquaDeals app on your Android phone and order on the GO! We are sure you will find the best deals every time. Invite your Contacts and get AquaCash.'
										)
									)
								)
							)
						),
						_react2.default.createElement('div', { className: 'bottomleft' })
					),
					_react2.default.createElement(
						'section',
						{ className: 'aquacash_blk' },
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-7' },
									_react2.default.createElement(
										'div',
										{ className: 'aquacash_mble' },
										_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/aquacash.png', alt: 'Aqua' })
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-4' },
									_react2.default.createElement(
										'h4',
										null,
										'AquaCash'
									),
									_react2.default.createElement(
										'p',
										null,
										'We respect your time and so reveal you from the fuss of banking everytime. Virtual money makes your life easy!'
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						' ',
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						' ',
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						),
						_react2.default.createElement(
							'div',
							{ className: 'clr' },
							'\xA0'
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'status_blk' },
						_react2.default.createElement('div', { className: 'topright' }),
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								'ul',
								{ className: 'status_div' },
								_react2.default.createElement(
									'li',
									{ className: 'col-md-4 col-sm-4 col-xs-4' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/users.png', alt: 'users' }),
									_react2.default.createElement(
										'h4',
										null,
										'20,000+'
									),
									_react2.default.createElement(
										'p',
										null,
										'Users'
									)
								),
								_react2.default.createElement(
									'li',
									{ className: 'col-md-4 col-sm-4 col-xs-4' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/partners.png', alt: 'Partners' }),
									_react2.default.createElement(
										'h4',
										null,
										'210'
									),
									_react2.default.createElement(
										'p',
										null,
										'Partners'
									)
								),
								_react2.default.createElement(
									'li',
									{ className: 'col-md-4 col-sm-4 col-xs-4' },
									_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/hatchery.png', alt: 'Hatcheries' }),
									_react2.default.createElement(
										'h4',
										null,
										'463'
									),
									_react2.default.createElement(
										'p',
										null,
										'Hatcheries'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'section',
						{ className: 'brands_blk thumbnail' },
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								'div',
								{ id: 'carousel-example-generic', className: 'carousel slide', 'data-ride': 'carousel' },
								_react2.default.createElement(
									'div',
									{ className: 'carousel-inner', role: 'listbox' },
									_react2.default.createElement(
										'div',
										{ className: 'item active' },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_1.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_2.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_3.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_4.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3 hidden-sm hidden-xs' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_5.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3 hidden-sm hidden-xs' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_6.jpg', alt: '...' })
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'item' },
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_7.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_8.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_9.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_10.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3 hidden-sm hidden-xs' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_1.jpg', alt: '...' })
										),
										_react2.default.createElement(
											'div',
											{ className: 'col-md-2 col-sm-3 col-xs-3 hidden-sm hidden-xs' },
											_react2.default.createElement('img', { src: 'https://aquadeals.in/admin/assets/icons/web_icons/brand_2.jpg', alt: '...' })
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(_Footer2.default, null)
				);
			}
		}]);
	
		return Home;
	}(_react.Component);
	
	exports.default = Home;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(15);
	
	var _redux = __webpack_require__(100);
	
	var _reactRouter = __webpack_require__(2);
	
	var _reduxThunk = __webpack_require__(969);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(556);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reactGa = __webpack_require__(802);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _App = __webpack_require__(490);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Home = __webpack_require__(553);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _login = __webpack_require__(497);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _Registration = __webpack_require__(493);
	
	var _Registration2 = _interopRequireDefault(_Registration);
	
	var _Otpverify = __webpack_require__(492);
	
	var _Otpverify2 = _interopRequireDefault(_Otpverify);
	
	var _verifyOtp = __webpack_require__(502);
	
	var _verifyOtp2 = _interopRequireDefault(_verifyOtp);
	
	var _reset = __webpack_require__(501);
	
	var _reset2 = _interopRequireDefault(_reset);
	
	var _ab_login = __webpack_require__(495);
	
	var _ab_login2 = _interopRequireDefault(_ab_login);
	
	var _Signup = __webpack_require__(494);
	
	var _Signup2 = _interopRequireDefault(_Signup);
	
	var _profile = __webpack_require__(500);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _SeedsList = __webpack_require__(546);
	
	var _SeedsList2 = _interopRequireDefault(_SeedsList);
	
	var _SeedsCat = __webpack_require__(545);
	
	var _SeedsCat2 = _interopRequireDefault(_SeedsCat);
	
	var _SeedDetails = __webpack_require__(544);
	
	var _SeedDetails2 = _interopRequireDefault(_SeedDetails);
	
	var _Browse_feed_deals = __webpack_require__(531);
	
	var _Browse_feed_deals2 = _interopRequireDefault(_Browse_feed_deals);
	
	var _subdeals = __webpack_require__(535);
	
	var _subdeals2 = _interopRequireDefault(_subdeals);
	
	var _product_full_details = __webpack_require__(534);
	
	var _product_full_details2 = _interopRequireDefault(_product_full_details);
	
	var _pdeals = __webpack_require__(533);
	
	var _pdeals2 = _interopRequireDefault(_pdeals);
	
	var _offers_details = __webpack_require__(532);
	
	var _offers_details2 = _interopRequireDefault(_offers_details);
	
	var _Search = __webpack_require__(521);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Enquire_now = __webpack_require__(520);
	
	var _Enquire_now2 = _interopRequireDefault(_Enquire_now);
	
	var _EnquireNow_Partner = __webpack_require__(519);
	
	var _EnquireNow_Partner2 = _interopRequireDefault(_EnquireNow_Partner);
	
	var _Customer_care = __webpack_require__(518);
	
	var _Customer_care2 = _interopRequireDefault(_Customer_care);
	
	var _customer_care_seller = __webpack_require__(526);
	
	var _customer_care_seller2 = _interopRequireDefault(_customer_care_seller);
	
	var _NotFound = __webpack_require__(84);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _coupon_details = __webpack_require__(530);
	
	var _coupon_details2 = _interopRequireDefault(_coupon_details);
	
	var _promo_offerszone = __webpack_require__(529);
	
	var _promo_offerszone2 = _interopRequireDefault(_promo_offerszone);
	
	var _promo_offers_fulldetails = __webpack_require__(528);
	
	var _promo_offers_fulldetails2 = _interopRequireDefault(_promo_offers_fulldetails);
	
	var _change_number = __webpack_require__(496);
	
	var _change_number2 = _interopRequireDefault(_change_number);
	
	var _ChangeVerifyOtp = __webpack_require__(491);
	
	var _ChangeVerifyOtp2 = _interopRequireDefault(_ChangeVerifyOtp);
	
	var _NaupliiDeals = __webpack_require__(543);
	
	var _NaupliiDeals2 = _interopRequireDefault(_NaupliiDeals);
	
	var _MyCart = __webpack_require__(509);
	
	var _MyCart2 = _interopRequireDefault(_MyCart);
	
	var _mob_num = __webpack_require__(498);
	
	var _mob_num2 = _interopRequireDefault(_mob_num);
	
	var _mob_verify_otp = __webpack_require__(499);
	
	var _mob_verify_otp2 = _interopRequireDefault(_mob_verify_otp);
	
	var _AllPromoOffers = __webpack_require__(515);
	
	var _AllPromoOffers2 = _interopRequireDefault(_AllPromoOffers);
	
	var _store_deals = __webpack_require__(551);
	
	var _store_deals2 = _interopRequireDefault(_store_deals);
	
	var _Share_Earn = __webpack_require__(522);
	
	var _Share_Earn2 = _interopRequireDefault(_Share_Earn);
	
	var _My_Aquacash = __webpack_require__(504);
	
	var _My_Aquacash2 = _interopRequireDefault(_My_Aquacash);
	
	var _Checkout = __webpack_require__(508);
	
	var _Checkout2 = _interopRequireDefault(_Checkout);
	
	var _My_Orders = __webpack_require__(537);
	
	var _My_Orders2 = _interopRequireDefault(_My_Orders);
	
	var _Order_Details = __webpack_require__(538);
	
	var _Order_Details2 = _interopRequireDefault(_Order_Details);
	
	var _Order_response = __webpack_require__(511);
	
	var _Order_response2 = _interopRequireDefault(_Order_response);
	
	var _Order_aborted = __webpack_require__(510);
	
	var _Order_aborted2 = _interopRequireDefault(_Order_aborted);
	
	var _My_Order_aborted = __webpack_require__(536);
	
	var _My_Order_aborted2 = _interopRequireDefault(_My_Order_aborted);
	
	var _Notifications = __webpack_require__(505);
	
	var _Notifications2 = _interopRequireDefault(_Notifications);
	
	var _View_Rating = __webpack_require__(506);
	
	var _View_Rating2 = _interopRequireDefault(_View_Rating);
	
	var _GiveRatings = __webpack_require__(503);
	
	var _GiveRatings2 = _interopRequireDefault(_GiveRatings);
	
	var _downloads = __webpack_require__(527);
	
	var _downloads2 = _interopRequireDefault(_downloads);
	
	var _QuickCart = __webpack_require__(512);
	
	var _QuickCart2 = _interopRequireDefault(_QuickCart);
	
	var _Shipping_Payment = __webpack_require__(539);
	
	var _Shipping_Payment2 = _interopRequireDefault(_Shipping_Payment);
	
	var _Shipping_Status = __webpack_require__(540);
	
	var _Shipping_Status2 = _interopRequireDefault(_Shipping_Status);
	
	var _Quick_Checkout = __webpack_require__(513);
	
	var _Quick_Checkout2 = _interopRequireDefault(_Quick_Checkout);
	
	var _WishList = __webpack_require__(552);
	
	var _WishList2 = _interopRequireDefault(_WishList);
	
	var _SmartCart = __webpack_require__(547);
	
	var _SmartCart2 = _interopRequireDefault(_SmartCart);
	
	var _About_Brand = __webpack_require__(507);
	
	var _About_Brand2 = _interopRequireDefault(_About_Brand);
	
	var _PartnerDeals = __webpack_require__(550);
	
	var _PartnerDeals2 = _interopRequireDefault(_PartnerDeals);
	
	var _Advertise = __webpack_require__(514);
	
	var _Advertise2 = _interopRequireDefault(_Advertise);
	
	var _SiteMap = __webpack_require__(523);
	
	var _SiteMap2 = _interopRequireDefault(_SiteMap);
	
	var _CheckoutFlow = __webpack_require__(517);
	
	var _CheckoutFlow2 = _interopRequireDefault(_CheckoutFlow);
	
	__webpack_require__(626);
	
	__webpack_require__(631);
	
	__webpack_require__(627);
	
	__webpack_require__(630);
	
	__webpack_require__(628);
	
	__webpack_require__(629);
	
	__webpack_require__(646);
	
	__webpack_require__(620);
	
	__webpack_require__(243);
	
	__webpack_require__(244);
	
	__webpack_require__(621);
	
	__webpack_require__(622);
	
	__webpack_require__(623);
	
	__webpack_require__(624);
	
	var _Web_IndexHome = __webpack_require__(469);
	
	var _Web_IndexHome2 = _interopRequireDefault(_Web_IndexHome);
	
	var _Web_SeedsList = __webpack_require__(480);
	
	var _Web_SeedsList2 = _interopRequireDefault(_Web_SeedsList);
	
	var _Web_Seed_Details = __webpack_require__(479);
	
	var _Web_Seed_Details2 = _interopRequireDefault(_Web_Seed_Details);
	
	var _Web_pdeals = __webpack_require__(466);
	
	var _Web_pdeals2 = _interopRequireDefault(_Web_pdeals);
	
	var _Web_product_full_details = __webpack_require__(467);
	
	var _Web_product_full_details2 = _interopRequireDefault(_Web_product_full_details);
	
	var _Web_subdeals = __webpack_require__(468);
	
	var _Web_subdeals2 = _interopRequireDefault(_Web_subdeals);
	
	var _Web_App = __webpack_require__(420);
	
	var _Web_App2 = _interopRequireDefault(_Web_App);
	
	var _Web_enquire_now = __webpack_require__(461);
	
	var _Web_enquire_now2 = _interopRequireDefault(_Web_enquire_now);
	
	var _Web_customer_care = __webpack_require__(458);
	
	var _Web_customer_care2 = _interopRequireDefault(_Web_customer_care);
	
	var _Web_customer_care_seller = __webpack_require__(459);
	
	var _Web_customer_care_seller2 = _interopRequireDefault(_Web_customer_care_seller);
	
	var _Web_Registration = __webpack_require__(430);
	
	var _Web_Registration2 = _interopRequireDefault(_Web_Registration);
	
	var _Web_login = __webpack_require__(434);
	
	var _Web_login2 = _interopRequireDefault(_Web_login);
	
	var _Web_forgot = __webpack_require__(433);
	
	var _Web_forgot2 = _interopRequireDefault(_Web_forgot);
	
	var _Web_ab_login = __webpack_require__(432);
	
	var _Web_ab_login2 = _interopRequireDefault(_Web_ab_login);
	
	var _Web_verifyOtp = __webpack_require__(438);
	
	var _Web_verifyOtp2 = _interopRequireDefault(_Web_verifyOtp);
	
	var _Web_Signup = __webpack_require__(431);
	
	var _Web_Signup2 = _interopRequireDefault(_Web_Signup);
	
	var _Web_reset = __webpack_require__(437);
	
	var _Web_reset2 = _interopRequireDefault(_Web_reset);
	
	var _Web_coupon_details = __webpack_require__(464);
	
	var _Web_coupon_details2 = _interopRequireDefault(_Web_coupon_details);
	
	var _Web_Profile = __webpack_require__(425);
	
	var _Web_Profile2 = _interopRequireDefault(_Web_Profile);
	
	var _Web_Otpverify = __webpack_require__(429);
	
	var _Web_Otpverify2 = _interopRequireDefault(_Web_Otpverify);
	
	var _Web_mob_num = __webpack_require__(435);
	
	var _Web_mob_num2 = _interopRequireDefault(_Web_mob_num);
	
	var _Web_mob_verify_otp = __webpack_require__(436);
	
	var _Web_mob_verify_otp2 = _interopRequireDefault(_Web_mob_verify_otp);
	
	var _Web_EnquireNow_Partner = __webpack_require__(453);
	
	var _Web_EnquireNow_Partner2 = _interopRequireDefault(_Web_EnquireNow_Partner);
	
	var _Web_OffersDetails = __webpack_require__(465);
	
	var _Web_OffersDetails2 = _interopRequireDefault(_Web_OffersDetails);
	
	var _Web_promo_offerszone = __webpack_require__(462);
	
	var _Web_promo_offerszone2 = _interopRequireDefault(_Web_promo_offerszone);
	
	var _Web_MyCart = __webpack_require__(441);
	
	var _Web_MyCart2 = _interopRequireDefault(_Web_MyCart);
	
	var _Web_NaupliiDeals = __webpack_require__(478);
	
	var _Web_NaupliiDeals2 = _interopRequireDefault(_Web_NaupliiDeals);
	
	var _Web_DealBlocks = __webpack_require__(452);
	
	var _Web_DealBlocks2 = _interopRequireDefault(_Web_DealBlocks);
	
	var _Web_AllPromoOffers = __webpack_require__(451);
	
	var _Web_AllPromoOffers2 = _interopRequireDefault(_Web_AllPromoOffers);
	
	var _Web_Checkout = __webpack_require__(440);
	
	var _Web_Checkout2 = _interopRequireDefault(_Web_Checkout);
	
	var _Web_Order_aborted = __webpack_require__(442);
	
	var _Web_Order_aborted2 = _interopRequireDefault(_Web_Order_aborted);
	
	var _Web_Order_response = __webpack_require__(443);
	
	var _Web_Order_response2 = _interopRequireDefault(_Web_Order_response);
	
	var _Web_downloads = __webpack_require__(460);
	
	var _Web_downloads2 = _interopRequireDefault(_Web_downloads);
	
	var _Web_Shipping_Payment = __webpack_require__(473);
	
	var _Web_Shipping_Payment2 = _interopRequireDefault(_Web_Shipping_Payment);
	
	var _Web_Shipping_Status = __webpack_require__(474);
	
	var _Web_Shipping_Status2 = _interopRequireDefault(_Web_Shipping_Status);
	
	var _Web_Order_Details = __webpack_require__(472);
	
	var _Web_Order_Details2 = _interopRequireDefault(_Web_Order_Details);
	
	var _Web_View_Rating = __webpack_require__(426);
	
	var _Web_View_Rating2 = _interopRequireDefault(_Web_View_Rating);
	
	var _Web_GiveRatings = __webpack_require__(422);
	
	var _Web_GiveRatings2 = _interopRequireDefault(_Web_GiveRatings);
	
	var _Web_My_Orders = __webpack_require__(471);
	
	var _Web_My_Orders2 = _interopRequireDefault(_Web_My_Orders);
	
	var _Web_My_Order_aborted = __webpack_require__(470);
	
	var _Web_My_Order_aborted2 = _interopRequireDefault(_Web_My_Order_aborted);
	
	var _Web_QuickCart = __webpack_require__(476);
	
	var _Web_QuickCart2 = _interopRequireDefault(_Web_QuickCart);
	
	var _Web_Quick_Checkout = __webpack_require__(477);
	
	var _Web_Quick_Checkout2 = _interopRequireDefault(_Web_Quick_Checkout);
	
	var _Web_Store_Deals = __webpack_require__(486);
	
	var _Web_Store_Deals2 = _interopRequireDefault(_Web_Store_Deals);
	
	var _Web_Change_Number = __webpack_require__(428);
	
	var _Web_Change_Number2 = _interopRequireDefault(_Web_Change_Number);
	
	var _Web_ChangeVerifyOtp = __webpack_require__(427);
	
	var _Web_ChangeVerifyOtp2 = _interopRequireDefault(_Web_ChangeVerifyOtp);
	
	var _Web_Share_Earn = __webpack_require__(455);
	
	var _Web_Share_Earn2 = _interopRequireDefault(_Web_Share_Earn);
	
	var _Web_My_Aquacash = __webpack_require__(423);
	
	var _Web_My_Aquacash2 = _interopRequireDefault(_Web_My_Aquacash);
	
	var _Web_Notifications = __webpack_require__(424);
	
	var _Web_Notifications2 = _interopRequireDefault(_Web_Notifications);
	
	var _Web_Promo_Offers_Fulldetails = __webpack_require__(454);
	
	var _Web_Promo_Offers_Fulldetails2 = _interopRequireDefault(_Web_Promo_Offers_Fulldetails);
	
	var _WebPromotions = __webpack_require__(220);
	
	var _WebPromotions2 = _interopRequireDefault(_WebPromotions);
	
	var _Web_SmartCart = __webpack_require__(482);
	
	var _Web_SmartCart2 = _interopRequireDefault(_Web_SmartCart);
	
	var _Web_WishList = __webpack_require__(488);
	
	var _Web_WishList2 = _interopRequireDefault(_Web_WishList);
	
	var _Web_About_Brand = __webpack_require__(439);
	
	var _Web_About_Brand2 = _interopRequireDefault(_Web_About_Brand);
	
	var _Web_Partner_Deals = __webpack_require__(485);
	
	var _Web_Partner_Deals2 = _interopRequireDefault(_Web_Partner_Deals);
	
	var _Web_Advertise = __webpack_require__(450);
	
	var _Web_Advertise2 = _interopRequireDefault(_Web_Advertise);
	
	var _Web_Site_Map = __webpack_require__(457);
	
	var _Web_Site_Map2 = _interopRequireDefault(_Web_Site_Map);
	
	var _Web_Site_CheckoutFlow = __webpack_require__(456);
	
	var _Web_Site_CheckoutFlow2 = _interopRequireDefault(_Web_Site_CheckoutFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// My GA ID:: UA-91206053-1
	_reactGa2.default.initialize('UA-87061138-3');
	
	var createStoreWithMiddleware = (0, _redux.applyMiddleware)(_reduxThunk2.default)(_redux.createStore);
	var store = createStoreWithMiddleware(_reducers2.default);
	
	// Desktop WEB IMPORTS STARTS HERE
	
	// import './Desktop/assets/css/icons-style.css';
	
	function logPageView() {
		_reactGa2.default.set({ page: window.location.pathname });
		_reactGa2.default.pageview(window.location.pathname);
	
		var loc = window.location;
		location.path = '' + loc.search;
		var str = location.path;
		var str_href = '' + loc.href;
		// var pageUrl='${loc.base}';
		var baseUrl = 'https://aquadeals.in/admin/web3/user/';
		var ref_url = document.referrer;
		if (str !== '' || ref_url !== '') {
			localStorage.setItem('tot_url', loc);
			// document.cookie="tot_url="+loc;
			// document.cookie="camp="+str;
			localStorage.setItem('camp', str);
			var fromName = '';
			if (localStorage.user_id) {
				var uid = localStorage.getItem('user_id');
			} else {
				uid = 0;
			}
			if (screen.width < 800) {
				fromName = 'mobile_web';
			} else {
				fromName = 'desktop_web';
			}
			var data1 = { from: fromName, url: str_href, uid: uid, ref_url: ref_url };
			var data2 = JSON.stringify(data1);
			_jquery2.default.ajax({
				method: 'POST',
				dataType: 'json',
				data: { req: data2 },
				url: baseUrl + 'split_url',
				success: function success(data) {
					if (data.status === 'success') {
						localStorage.setItem('source', data.source);
						localStorage.setItem('campaign', data.campaign);
						localStorage.setItem('url_id', data.url_id);
					}
				},
				error: function error(err) {}
			});
		}
	}
	
	_reactDom2.default.render(_react2.default.createElement(
		_reactRedux.Provider,
		{ store: store },
		_react2.default.createElement(
			_reactRouter.Router,
			{ history: _reactRouter.browserHistory, onUpdate: logPageView },
			_react2.default.createElement(_reactRouter.Route, { path: '/', component: _App2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/aboutus', component: _Home2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/home', component: _App2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/account(/:redirectPath)', component: _login2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/login(/:redirectPath)', component: _Registration2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/verify', component: _verifyOtp2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/Otpverify', component: _Otpverify2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/reset', component: _reset2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/signup', component: _Signup2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/profile', component: _profile2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/seed', component: _SeedsList2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/seed/:Name/:Stype', component: _SeedsCat2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/sdetails/:BrandName/:Id', component: _SeedDetails2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/ab_login', component: _ab_login2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/subdeals/:BrandName/:CatName/:ProName/:Pid', component: _subdeals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/subdeals/:Pid', component: _subdeals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/subdeals/:BrandName/:CatName/:DType/:ProName/:Pid', component: _subdeals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/subdeals/:BrandName/:CatName/:ProName/:Pid/type/:DType', component: _subdeals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/pdeals/:BrandName/all/:Type', component: _Browse_feed_deals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/pdeals/:BrandName/:CatName/:Tid/:Type/:DType(/:Dids)', component: _pdeals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/pdeals/:Type/:CatName/:Tid', component: _pdeals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/pdeals/:Type/:Tid', component: _PartnerDeals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/offers/deals/:Tid/:Type/:DType', component: _offers_details2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/pdetails/:Pid/:DealId', component: _product_full_details2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/pdetails/:BrandName/:CatName/:Title/:Pid/:DealId', component: _product_full_details2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/pdetails/:BrandName/:CatName/:Bname/:Title/:Pid/:DealId', component: _product_full_details2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/Search', component: _Search2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/enquire_now/partner/support/:Sid/:Did', component: _EnquireNow_Partner2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/enquire_now/:Ltype/:Sid/:Did', component: _Enquire_now2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/nauplii', component: _NaupliiDeals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/customer_care', component: _Customer_care2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/customer_care_seller', component: _customer_care_seller2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/coupon/details/:Cid', component: _coupon_details2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/offerszone', component: _promo_offerszone2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/offer/:Oid/details', component: _promo_offers_fulldetails2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/change_number', component: _change_number2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/verify_otp', component: _ChangeVerifyOtp2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/mobile', component: _mob_num2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/mobile/verify_otp', component: _mob_verify_otp2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/promotional_offers', component: _AllPromoOffers2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/mycart', component: _MyCart2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/stores/:StoreType/:ID', component: _store_deals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/stores/:StoreType', component: _store_deals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/ad-banners/:StoreType', component: _store_deals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/myaquacash', component: _My_Aquacash2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/checkout', component: _Checkout2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/share_earn', component: _Share_Earn2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/myorders', component: _My_Orders2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/order_details/:OrderType/:Oid', component: _Order_Details2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/status/:book_id/:type/:Uid', component: _Order_response2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/status/:Type', component: _Order_aborted2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/order_status/:Type', component: _My_Order_aborted2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/notifications', component: _Notifications2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/viewrating/:Bid', component: _View_Rating2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/viewrating/:Product/:Bid', component: _View_Rating2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/giverating/:Bid', component: _GiveRatings2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/giverating/:Product/:Bid', component: _GiveRatings2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/downloads', component: _downloads2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/quickcart', component: _QuickCart2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/shipping_payment/:Type/:Book_Id/:Uid', component: _Shipping_Payment2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/payment_status/:Status', component: _Shipping_Status2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/payment_status/:OrderType/:Oid/:Status', component: _Shipping_Status2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/quick_checkout', component: _Quick_Checkout2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/wishlist', component: _WishList2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/smartcart', component: _SmartCart2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/:Bname/brand-details/:DType/:Bid', component: _About_Brand2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/:Bname/brand-details/:Bid', component: _About_Brand2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/advertise-with-us', component: _Advertise2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/site-map', component: _SiteMap2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/checkout-flow', component: _CheckoutFlow2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web', component: _Web_App2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/home', component: _Web_App2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/aboutus', component: _Web_IndexHome2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/seed', component: _Web_SeedsList2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/seed/:Name/:Dtype', component: _Web_SeedsList2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: 'web/nauplii/:Name/:Stype', component: _Web_NaupliiDeals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/sdetails/:BrandName/:Sid', component: _Web_Seed_Details2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/pdeals/brands/:BrandName/:Bid', component: _Web_pdeals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/pdeals/:BrandName/:Type/:DType', component: _Web_pdeals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/pdeals/:BrandName/:CatName/:Tid/:Type/:DType(/:Dids)', component: _Web_pdeals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/pdetails/:BrandName/:CatName/:Title/:Pid/:Did', component: _Web_product_full_details2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/pdetails/:BrandName/:CatName/:Bname/:Title/:Pid/:Did', component: _Web_product_full_details2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/subdeals/:BrandName/:CatName/:ProName/:Pid', component: _Web_subdeals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/subdeals/:BrandName/:CatName/:ProName/:Pid/type/:DType', component: _Web_subdeals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/subdeals/:BrandName/:CatName/:DType/:ProName/:Pid', component: _Web_subdeals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/subdeals/:BrandName/:Pid/:DType', component: _Web_subdeals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/enquire_now/partner/support/:Sid/:Did', component: _Web_EnquireNow_Partner2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/enquire/:Ltype/:Sid/:Did', component: _Web_enquire_now2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/customer_care', component: _Web_customer_care2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/customer_care_seller', component: _Web_customer_care_seller2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/login(/:redirectPath)', component: _Web_Registration2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/account', component: _Web_login2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/forgot', component: _Web_forgot2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/verify', component: _Web_verifyOtp2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/signup', component: _Web_Signup2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/reset', component: _Web_reset2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/ab_login', component: _Web_ab_login2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/otpverify', component: _Web_Otpverify2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/coupon/details/:Cid', component: _Web_coupon_details2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/profile', component: _Web_Profile2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/mobile', component: _Web_mob_num2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/mobile/verify_otp', component: _Web_mob_verify_otp2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/offers/deals/:Tid/:Type/:DType', component: _Web_OffersDetails2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/offerszone', component: _Web_promo_offerszone2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/mycart', component: _Web_MyCart2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/blocks', component: _Web_DealBlocks2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/promotional_offers', component: _Web_AllPromoOffers2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/checkout', component: _Web_Checkout2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/status/:Type', component: _Web_Order_aborted2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/status/:book_id/:type/:Uid', component: _Web_Order_response2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/downloads', component: _Web_downloads2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/shipping_payment/:Type/:Book_Id/:Uid', component: _Web_Shipping_Payment2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/payment_status/:Status', component: _Web_Shipping_Status2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/payment_status/:OrderType/:Oid/:Status', component: _Web_Shipping_Status2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/order_details/:OrderType/:Oid', component: _Web_Order_Details2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/viewrating/:Bid', component: _Web_View_Rating2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/viewrating/:Product/:Bid', component: _Web_View_Rating2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/giverating/:Bid', component: _Web_GiveRatings2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/giverating/:Product/:Bid', component: _Web_GiveRatings2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/myorders', component: _Web_My_Orders2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/order_status/:Type', component: _Web_My_Order_aborted2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/quickcart', component: _Web_QuickCart2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/quick_checkout', component: _Web_Quick_Checkout2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/stores/:StoreType/:ID', component: _Web_Store_Deals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/stores/:StoreType', component: _Web_Store_Deals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/ad-banners/:StoreType', component: _Web_Store_Deals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/change_number', component: _Web_Change_Number2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/verify_otp', component: _Web_ChangeVerifyOtp2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/share_earn', component: _Web_Share_Earn2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/myaquacash', component: _Web_My_Aquacash2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/notifications', component: _Web_Notifications2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/offer/:Oid/details', component: _Web_Promo_Offers_Fulldetails2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/promotions', component: _WebPromotions2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/smartcart', component: _Web_SmartCart2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/wishlist', component: _Web_WishList2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/:Bname/brand-details/:DType/:Bid', component: _Web_About_Brand2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/:Bname/brand-details/:Bid', component: _Web_About_Brand2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/pdeals/:Type/:Tid', component: _Web_Partner_Deals2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/advertise-with-us', component: _Web_Advertise2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/site-map', component: _Web_Site_Map2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '/web/checkout-flow', component: _Web_Site_CheckoutFlow2.default }),
			_react2.default.createElement(_reactRouter.Route, { path: '*', component: _NotFound2.default })
		)
	), document.getElementById('root'));

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _types.AUTH_USER:
	            return _extends({}, state, { authenticated: false, formdata: action.payload.data });
	        case _types.LOGOUT_USER:
	            return _extends({}, state, { authenticated: false });
	
	        case _types.AUTH_ERROR:
	            return _extends({}, state, { error: action.payload });
	        default:
	            return state;
	
	    }
	};
	
	var _types = __webpack_require__(137);
	
	// import jwtDecode from 'jwt-decode';
	// const token = localStorage.getItem('token');
	var INITIAL_STATE = { formdata: [] };

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	var _redux = __webpack_require__(100);
	
	var _reduxForm = __webpack_require__(36);
	
	var _auth_reducer = __webpack_require__(555);
	
	var _auth_reducer2 = _interopRequireDefault(_auth_reducer);
	
	var _post_reducer = __webpack_require__(557);
	
	var _post_reducer2 = _interopRequireDefault(_post_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootReducer = (0, _redux.combineReducers)({
	   form: _reduxForm.reducer,
	   auth: _auth_reducer2.default,
	   posts: _post_reducer2.default
	});
	exports.default = rootReducer;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _types.POST_SHOW:
	      return _extends({}, state, { post: action.payload.data });
	    case _types.FETCH_POST:
	      return _extends({}, state, { all: action.payload.data });
	    case _types.FETCH_ADS:
	      return _extends({}, state, { ads: action.payload.data.imgs });
	    case _types.FETCH_PROMO_ADS:
	      return _extends({}, state, { offers: action.payload.data.offers, product_offers: action.payload.data.product_offers, seed_offers: action.payload.data.seed_offers, promo_ads: action.payload.data });
	    case _types.FETCH_SEARCH:
	      return _extends({}, state, { search: action.payload.data, brands: action.payload.data.brands, products: action.payload.data.products, categories: action.payload.data.categories, isLoading: true });
	    case _types.FETCH_TRENDS:
	      return _extends({}, state, { trendings: action.payload.data.data, popular_brands: action.payload.data.data2, recent_search: action.payload.data.data1, isLoading: true });
	    case _types.FETCH_LEADS:
	      return _extends({}, state, { leads: action.payload.data, lead_status: action.payload.data.status });
	    case _types.EDIT_POST:
	      return _extends({}, state, { edit: action.payload.data });
	    case _types.MYCART_PLACEORDER:
	      return _extends({}, state, { mycart_order_status: action.payload.data.status, total_cart_data: action.payload });
	    case _types.UPDATE_POST:
	      return _extends({}, state, { update: action.payload.data });
	    case _types.FETCH_RZP_KEYS:
	      return _extends({}, state, { rzp_keys: action.payload.data });
	    case _types.FETCH_RECENT:
	      return _extends({}, state, { recommended: action.payload.data, isLoading: true });
	    case _types.FETCH_PRODUCT_TABS:
	      return _extends({}, state, { product_tabs: action.payload.data });
	    case _types.FETCH_PRODUCT_DESC:
	      return _extends({}, state, { product_desc: action.payload.data });
	    case _types.FETCH_USER_ADDR:
	      return _extends({}, state, { user_address: action.payload.data });
	    case _types.CLEAR_STATE:
	      return _extends({}, state = INITIAL_STATE);
	    default:
	      return state;
	  }
	};
	
	var _types = __webpack_require__(137);
	
	var INITIAL_STATE = { all: [], post: null, ads: [], offers: [], product_offers: [], seed_offers: [], promo_ads: [], search: [], brands: [], products: [], categories: [], trendings: [], leads: [], popular_brands: [], recent_search: [], lead_status: '', mycart_order_status: '', total_cart_data: [], rzp_keys: [], recommended: [], product_tabs: [], product_desc: [], user_address: [], isLoading: false };

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(565), __esModule: true };

/***/ },
/* 559 */
[993, 566],
/* 560 */
[994, 567],
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(568), __esModule: true };

/***/ },
/* 562 */
[996, 571],
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(572), __esModule: true };

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(573), __esModule: true };

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(37);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(591);
	module.exports = __webpack_require__(37).Object.assign;


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(592);
	var $Object = __webpack_require__(37).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(593);
	var $Object = __webpack_require__(37).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(594);
	module.exports = __webpack_require__(37).Object.getPrototypeOf;


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(595);
	module.exports = __webpack_require__(37).Object.keys;


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(596);
	module.exports = __webpack_require__(37).Object.setPrototypeOf;


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(599);
	__webpack_require__(597);
	__webpack_require__(600);
	__webpack_require__(601);
	module.exports = __webpack_require__(37).Symbol;


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(598);
	__webpack_require__(602);
	module.exports = __webpack_require__(154).f('iterator');


/***/ },
/* 574 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 575 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(73);
	var toLength = __webpack_require__(589);
	var toAbsoluteIndex = __webpack_require__(588);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(86);
	var gOPS = __webpack_require__(147);
	var pIE = __webpack_require__(102);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(52).document;
	module.exports = document && document.documentElement;


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(228);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(146);
	var descriptor = __webpack_require__(103);
	var setToStringTag = __webpack_require__(148);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(71)(IteratorPrototype, __webpack_require__(74)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 581 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(104)('meta');
	var isObject = __webpack_require__(72);
	var has = __webpack_require__(61);
	var setDesc = __webpack_require__(62).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(70)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(51);
	var getKeys = __webpack_require__(86);
	var gOPS = __webpack_require__(147);
	var pIE = __webpack_require__(102);
	var toObject = __webpack_require__(87);
	var IObject = __webpack_require__(232);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(70)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(62);
	var anObject = __webpack_require__(85);
	var getKeys = __webpack_require__(86);
	
	module.exports = __webpack_require__(51) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(73);
	var gOPN = __webpack_require__(235).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(72);
	var anObject = __webpack_require__(85);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(229)(Function.call, __webpack_require__(234).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(151);
	var defined = __webpack_require__(143);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(151);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(151);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(575);
	var step = __webpack_require__(581);
	var Iterators = __webpack_require__(145);
	var toIObject = __webpack_require__(73);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(233)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(60);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(583) });


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(60);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(146) });


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(60);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(51), 'Object', { defineProperty: __webpack_require__(62).f });


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(87);
	var $getPrototypeOf = __webpack_require__(236);
	
	__webpack_require__(238)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(87);
	var $keys = __webpack_require__(86);
	
	__webpack_require__(238)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(60);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(586).set });


/***/ },
/* 597 */
/***/ function(module, exports) {



/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(587)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(233)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(52);
	var has = __webpack_require__(61);
	var DESCRIPTORS = __webpack_require__(51);
	var $export = __webpack_require__(60);
	var redefine = __webpack_require__(239);
	var META = __webpack_require__(582).KEY;
	var $fails = __webpack_require__(70);
	var shared = __webpack_require__(150);
	var setToStringTag = __webpack_require__(148);
	var uid = __webpack_require__(104);
	var wks = __webpack_require__(74);
	var wksExt = __webpack_require__(154);
	var wksDefine = __webpack_require__(153);
	var enumKeys = __webpack_require__(577);
	var isArray = __webpack_require__(579);
	var anObject = __webpack_require__(85);
	var isObject = __webpack_require__(72);
	var toObject = __webpack_require__(87);
	var toIObject = __webpack_require__(73);
	var toPrimitive = __webpack_require__(152);
	var createDesc = __webpack_require__(103);
	var _create = __webpack_require__(146);
	var gOPNExt = __webpack_require__(585);
	var $GOPD = __webpack_require__(234);
	var $GOPS = __webpack_require__(147);
	var $DP = __webpack_require__(62);
	var $keys = __webpack_require__(86);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(235).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(102).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(101)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(71)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(153)('asyncIterator');


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(153)('observable');


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(590);
	var global = __webpack_require__(52);
	var hide = __webpack_require__(71);
	var Iterators = __webpack_require__(145);
	var TO_STRING_TAG = __webpack_require__(74)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(604);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = process.env.DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(173)))

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(707);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(241);
	
	exports.__esModule = true;
	
	/**
	 * document.activeElement
	 */
	exports['default'] = activeElement;
	
	var _ownerDocument = __webpack_require__(240);
	
	var _ownerDocument2 = babelHelpers.interopRequireDefault(_ownerDocument);
	
	function activeElement() {
	  var doc = arguments[0] === undefined ? document : arguments[0];
	
	  try {
	    return doc.activeElement;
	  } catch (e) {}
	}
	
	module.exports = exports['default'];

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hasClass = __webpack_require__(607);
	
	module.exports = function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!hasClass(element)) element.className = element.className + ' ' + className;
	};

/***/ },
/* 607 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (' ' + element.className + ' ').indexOf(' ' + className + ' ') !== -1;
	};

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var contains = __webpack_require__(156),
	    qsa = __webpack_require__(612);
	
	module.exports = function (selector, handler) {
	  return function (e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = qsa(top, selector);
	
	    if (matches.some(function (match) {
	      return contains(match, target);
	    })) handler.call(this, e);
	  };
	};

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var on = __webpack_require__(611),
	    off = __webpack_require__(610),
	    filter = __webpack_require__(608);
	
	module.exports = { on: on, off: off, filter: filter };

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(89);
	var off = function off() {};
	
	if (canUseDOM) {
	
	  off = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = off;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(89);
	var on = function on() {};
	
	if (canUseDOM) {
	  on = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = on;

/***/ },
/* 612 */
/***/ function(module, exports) {

	'use strict';
	//     Zepto.js
	//     (c) 2010-2015 Thomas Fuchs
	//     Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/,
	    toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	module.exports = function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	};

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(241);
	
	var _utilCamelizeStyle = __webpack_require__(242);
	
	var _utilCamelizeStyle2 = babelHelpers.interopRequireDefault(_utilCamelizeStyle);
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	module.exports = function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : { //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	
	      prop = (0, _utilCamelizeStyle2['default'])(prop);
	
	      if (prop == 'float') prop = 'styleFloat';
	
	      var current = node.currentStyle[prop] || null;
	
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left;
	
	        // Put in the new values to get a computed value out
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px';
	
	        // Revert the changed values
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	};

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var camelize = __webpack_require__(242),
	    hyphenate = __webpack_require__(618),
	    _getComputedStyle = __webpack_require__(613),
	    removeStyle = __webpack_require__(615);
	
	var has = Object.prototype.hasOwnProperty;
	
	module.exports = function style(node, property, value) {
	  var css = '',
	      props = property;
	
	  if (typeof property === 'string') {
	
	    if (value === undefined) return node.style[camelize(property)] || _getComputedStyle(node).getPropertyValue(hyphenate(property));else (props = {})[property] = value;
	  }
	
	  for (var key in props) if (has.call(props, key)) {
	    !props[key] && props[key] !== 0 ? removeStyle(node, hyphenate(key)) : css += hyphenate(key) + ':' + props[key] + ';';
	  }
	
	  node.style.cssText += ';' + css;
	};

/***/ },
/* 615 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	};

/***/ },
/* 616 */
/***/ function(module, exports) {

	"use strict";
	
	var rHyphen = /-(.)/g;
	
	module.exports = function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	};

/***/ },
/* 617 */
/***/ function(module, exports) {

	'use strict';
	
	var rUpper = /([A-Z])/g;
	
	module.exports = function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	};

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	
	"use strict";
	
	var hyphenate = __webpack_require__(617);
	var msPattern = /^ms-/;
	
	module.exports = function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, "-ms-");
	};

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var canUseDOM = __webpack_require__(89);
	
	var size;
	
	module.exports = function (recalc) {
	  if (!size || recalc) {
	    if (canUseDOM) {
	      var scrollDiv = document.createElement('div');
	
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	};

/***/ },
/* 620 */
243,
/* 621 */
243,
/* 622 */
243,
/* 623 */
243,
/* 624 */
243,
/* 625 */
243,
/* 626 */
243,
/* 627 */
243,
/* 628 */
243,
/* 629 */
243,
/* 630 */
243,
/* 631 */
243,
/* 632 */
243,
/* 633 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelize
	 * @typechecks
	 */
	
	"use strict";
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelizeStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(633);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createArrayFromMixed
	 * @typechecks
	 */
	
	'use strict';
	
	var toArray = __webpack_require__(644);
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return(
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createNodesFromMarkup
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var createArrayFromMixed = __webpack_require__(635);
	var getMarkupWrap = __webpack_require__(249);
	var invariant = __webpack_require__(14);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : undefined;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : undefined;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = createArrayFromMixed(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 637 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUnboundedScrollPosition
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 638 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenate
	 * @typechecks
	 */
	
	'use strict';
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenateStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(638);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 640 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isNode
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	'use strict';
	
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isNode = __webpack_require__(640);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 642 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule mapObject
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 643 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule memoizeStringOnly
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 *
	 * @param {function} callback
	 * @return {function}
	 */
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule toArray
	 * @typechecks
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
	  // old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : undefined;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : undefined;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : undefined;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	module.exports = toArray;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/check_out.4dc19fcd.png";

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/digital.1e670d88.ttf";

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/check_out_mob.7d5f4739.png";

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mob_loading.870750ac.gif";

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/nav_aboutus.c36f0d4d.png";

/***/ },
/* 650 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = __webpack_require__(264);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(158);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ },
/* 653 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(76);
	
	var _PathUtils = __webpack_require__(63);
	
	var _ExecutionEnvironment = __webpack_require__(112);
	
	var _DOMUtils = __webpack_require__(160);
	
	var _DOMStateStorage = __webpack_require__(265);
	
	var _createDOMHistory = __webpack_require__(266);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(76);
	
	var _PathUtils = __webpack_require__(63);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(63);
	
	var _Actions = __webpack_require__(76);
	
	var _createHistory = __webpack_require__(268);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(811);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 658 */
/***/ function(module, exports) {

	/**
	 * SVG elements are case-sensitive.
	 *
	 * @see {@link https://developer.mozilla.org/docs/Web/SVG/Element#SVG_elements_A_to_Z}
	 */
	var CASE_SENSITIVE_TAG_NAMES = [
	  'animateMotion',
	  'animateTransform',
	  'clipPath',
	  'feBlend',
	  'feColorMatrix',
	  'feComponentTransfer',
	  'feComposite',
	  'feConvolveMatrix',
	  'feDiffuseLighting',
	  'feDisplacementMap',
	  'feDropShadow',
	  'feFlood',
	  'feFuncA',
	  'feFuncB',
	  'feFuncG',
	  'feFuncR',
	  'feGaussainBlur',
	  'feImage',
	  'feMerge',
	  'feMergeNode',
	  'feMorphology',
	  'feOffset',
	  'fePointLight',
	  'feSpecularLighting',
	  'feSpotLight',
	  'feTile',
	  'feTurbulence',
	  'foreignObject',
	  'linearGradient',
	  'radialGradient',
	  'textPath'
	];
	
	module.exports = {
	  CASE_SENSITIVE_TAG_NAMES: CASE_SENSITIVE_TAG_NAMES
	};


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	var utilities = __webpack_require__(270);
	
	// constants
	var HTML = 'html';
	var HEAD = 'head';
	var BODY = 'body';
	var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
	var HEAD_TAG_REGEX = /<head.*>/i;
	var BODY_TAG_REGEX = /<body.*>/i;
	// http://www.w3.org/TR/html/syntax.html#void-elements
	var VOID_ELEMENTS_REGEX = /<(area|base|br|col|embed|hr|img|input|keygen|link|menuitem|meta|param|source|track|wbr)(.*?)\/?>/gi;
	
	// detect IE browser
	var isIE9 = utilities.isIE(9);
	var isIE = isIE9 || utilities.isIE();
	
	/**
	 * DOMParser (performance: slow).
	 *
	 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
	 */
	var parseFromString;
	
	if (typeof window.DOMParser === 'function') {
	  var domParser = new window.DOMParser();
	
	  // IE9 does not support 'text/html' MIME type
	  // https://msdn.microsoft.com/en-us/library/ff975278(v=vs.85).aspx
	  var mimeType = isIE9 ? 'text/xml' : 'text/html';
	
	  /**
	   * Creates an HTML document using `DOMParser.parseFromString`.
	   *
	   * @param  {string} html      - The HTML string.
	   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
	   * @return {HTMLDocument}
	   */
	  parseFromString = function domStringParser(html, tagName) {
	    if (tagName) {
	      html = '<' + tagName + '>' + html + '</' + tagName + '>';
	    }
	
	    // because IE9 only supports MIME type 'text/xml', void elements need to be self-closed
	    if (isIE9) {
	      html = html.replace(VOID_ELEMENTS_REGEX, '<$1$2$3/>');
	    }
	
	    return domParser.parseFromString(html, mimeType);
	  };
	}
	
	/**
	 * DOMImplementation (performance: fair).
	 *
	 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
	 */
	var parseFromDocument;
	
	if (typeof document.implementation === 'object') {
	  // title parameter is required in IE
	  // https://msdn.microsoft.com/en-us/library/ff975457(v=vs.85).aspx
	  var doc = document.implementation.createHTMLDocument(
	    isIE ? 'HTML_DOM_PARSER_TITLE' : undefined
	  );
	
	  /**
	   * Use HTML document created by `document.implementation.createHTMLDocument`.
	   *
	   * @param  {string} html      - The HTML string.
	   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
	   * @return {HTMLDocument}
	   */
	  parseFromDocument = function createHTMLDocument(html, tagName) {
	    if (tagName) {
	      doc.documentElement.getElementsByTagName(tagName)[0].innerHTML = html;
	      return doc;
	    }
	
	    try {
	      doc.documentElement.innerHTML = html;
	      return doc;
	      // fallback when certain elements in `documentElement` are read-only (IE9)
	    } catch (err) {
	      if (parseFromString) {
	        return parseFromString(html);
	      }
	    }
	  };
	}
	
	/**
	 * Template (performance: fast).
	 *
	 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
	 */
	var parseFromTemplate;
	var template = document.createElement('template');
	
	if (template.content) {
	  /**
	   * Uses a template element (content fragment) to parse HTML.
	   *
	   * @param  {string} html - The HTML string.
	   * @return {NodeList}
	   */
	  parseFromTemplate = function templateParser(html) {
	    template.innerHTML = html;
	    return template.content.childNodes;
	  };
	}
	
	// fallback document parser
	var parseWithFallback = parseFromDocument || parseFromString;
	
	/**
	 * Parses HTML string to DOM nodes.
	 *
	 * @param  {string} html - The HTML string.
	 * @return {NodeList|Array}
	 */
	function domparser(html) {
	  var firstTagName;
	  var match = html.match(FIRST_TAG_REGEX);
	
	  if (match && match[1]) {
	    firstTagName = match[1].toLowerCase();
	  }
	
	  var doc;
	  var element;
	  var elements;
	
	  switch (firstTagName) {
	    case HTML:
	      if (parseFromString) {
	        doc = parseFromString(html);
	
	        // the created document may come with filler head/body elements,
	        // so make sure to remove them if they don't actually exist
	        if (!HEAD_TAG_REGEX.test(html)) {
	          element = doc.getElementsByTagName(HEAD)[0];
	          if (element) {
	            element.parentNode.removeChild(element);
	          }
	        }
	
	        if (!BODY_TAG_REGEX.test(html)) {
	          element = doc.getElementsByTagName(BODY)[0];
	          if (element) {
	            element.parentNode.removeChild(element);
	          }
	        }
	
	        return doc.getElementsByTagName(HTML);
	      }
	      break;
	
	    case HEAD:
	    case BODY:
	      if (parseWithFallback) {
	        elements = parseWithFallback(html).getElementsByTagName(firstTagName);
	
	        // account for possibility of sibling
	        if (BODY_TAG_REGEX.test(html) && HEAD_TAG_REGEX.test(html)) {
	          return elements[0].parentNode.childNodes;
	        }
	
	        return elements;
	      }
	      break;
	
	    // low-level tag or text
	    default:
	      if (parseFromTemplate) {
	        return parseFromTemplate(html);
	      }
	
	      if (parseWithFallback) {
	        return parseWithFallback(html, BODY).getElementsByTagName(BODY)[0]
	          .childNodes;
	      }
	
	      break;
	  }
	
	  return [];
	}
	
	module.exports = domparser;


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	var domparser = __webpack_require__(659);
	var utilities = __webpack_require__(270);
	
	var formatDOM = utilities.formatDOM;
	var isIE9 = utilities.isIE(9);
	
	var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>
	
	/**
	 * Parses HTML and reformats DOM nodes output.
	 *
	 * @param  {String} html - The HTML string.
	 * @return {Array}       - The formatted DOM nodes.
	 */
	function parseDOM(html) {
	  if (typeof html !== 'string') {
	    throw new TypeError('First argument must be a string');
	  }
	
	  if (!html) {
	    return [];
	  }
	
	  // match directive
	  var match = html.match(DIRECTIVE_REGEX);
	  var directive;
	
	  if (match && match[1]) {
	    directive = match[1];
	
	    // remove directive in IE9 because DOMParser uses
	    // MIME type 'text/xml' instead of 'text/html'
	    if (isIE9) {
	      html = html.replace(match[0], '');
	    }
	  }
	
	  return formatDOM(domparser(html), null, directive);
	}
	
	module.exports = parseDOM;


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	var reactProperty = __webpack_require__(841);
	var styleToObject = __webpack_require__(984);
	var utilities = __webpack_require__(271);
	
	var camelCase = utilities.camelCase;
	
	var htmlProperties = reactProperty.html;
	var svgProperties = reactProperty.svg;
	var isCustomAttribute = reactProperty.isCustomAttribute;
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Converts HTML/SVG DOM attributes to React props.
	 *
	 * @param  {Object} [attributes={}] - The HTML/SVG DOM attributes.
	 * @return {Object}                 - The React props.
	 */
	function attributesToProps(attributes) {
	  attributes = attributes || {};
	
	  var attributeName;
	  var attributeNameLowerCased;
	  var attributeValue;
	  var property;
	  var props = {};
	
	  for (attributeName in attributes) {
	    attributeValue = attributes[attributeName];
	
	    // ARIA (aria-*) or custom data (data-*) attribute
	    if (isCustomAttribute(attributeName)) {
	      props[attributeName] = attributeValue;
	      continue;
	    }
	
	    // convert HTML attribute to React prop
	    attributeNameLowerCased = attributeName.toLowerCase();
	    if (hasOwnProperty.call(htmlProperties, attributeNameLowerCased)) {
	      property = htmlProperties[attributeNameLowerCased];
	      props[property.propertyName] =
	        property.hasBooleanValue ||
	        (property.hasOverloadedBooleanValue && !attributeValue)
	          ? true
	          : attributeValue;
	      continue;
	    }
	
	    // convert SVG attribute to React prop
	    if (hasOwnProperty.call(svgProperties, attributeName)) {
	      property = svgProperties[attributeName];
	      props[property.propertyName] = attributeValue;
	      continue;
	    }
	
	    // preserve custom attribute if React >=16
	    if (utilities.PRESERVE_CUSTOM_ATTRIBUTES) {
	      props[attributeName] = attributeValue;
	    }
	  }
	
	  // convert inline style to object
	  if (attributes.style != null) {
	    props.style = cssToJs(attributes.style);
	  }
	
	  return props;
	}
	
	/**
	 * Converts CSS style string to JS style object.
	 *
	 * @param  {String} style - The CSS style.
	 * @return {Object}       - The JS style object.
	 */
	function cssToJs(style) {
	  if (typeof style !== 'string') {
	    throw new TypeError('First argument must be a string.');
	  }
	
	  var styleObj = {};
	
	  styleToObject(style, function(property, value) {
	    // skip if it's a comment node
	    if (property && value) {
	      styleObj[camelCase(property)] = value;
	    }
	  });
	
	  return styleObj;
	}
	
	module.exports = attributesToProps;


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var attributesToProps = __webpack_require__(661);
	var utilities = __webpack_require__(271);
	
	var cloneElement = React.cloneElement;
	var createElement = React.createElement;
	var isValidElement = React.isValidElement;
	
	/**
	 * Converts DOM nodes to React elements.
	 *
	 * @param  {Array}    nodes             - The DOM nodes.
	 * @param  {Object}   [options]         - The additional options.
	 * @param  {Function} [options.replace] - The replace method.
	 * @return {ReactElement|Array}
	 */
	function domToReact(nodes, options) {
	  options = options || {};
	  var result = [];
	  var node;
	  var hasReplace = typeof options.replace === 'function';
	  var replaceElement;
	  var props;
	  var children;
	
	  for (var i = 0, len = nodes.length; i < len; i++) {
	    node = nodes[i];
	
	    // replace with custom React element (if present)
	    if (hasReplace) {
	      replaceElement = options.replace(node);
	
	      if (isValidElement(replaceElement)) {
	        // specify a "key" prop if element has siblings
	        // https://fb.me/react-warning-keys
	        if (len > 1) {
	          replaceElement = cloneElement(replaceElement, {
	            key: replaceElement.key || i
	          });
	        }
	        result.push(replaceElement);
	        continue;
	      }
	    }
	
	    if (node.type === 'text') {
	      result.push(node.data);
	      continue;
	    }
	
	    props = node.attribs;
	    if (!shouldPassAttributesUnaltered(node)) {
	      // update values
	      props = attributesToProps(node.attribs);
	    }
	
	    children = null;
	
	    // node type for <script> is "script"
	    // node type for <style> is "style"
	    if (node.type === 'script' || node.type === 'style') {
	      // prevent text in <script> or <style> from being escaped
	      // https://facebook.github.io/react/tips/dangerously-set-inner-html.html
	      if (node.children[0]) {
	        props.dangerouslySetInnerHTML = {
	          __html: node.children[0].data
	        };
	      }
	    } else if (node.type === 'tag') {
	      // setting textarea value in children is an antipattern in React
	      // https://reactjs.org/docs/forms.html#the-textarea-tag
	      if (node.name === 'textarea' && node.children[0]) {
	        props.defaultValue = node.children[0].data;
	
	        // continue recursion of creating React elements (if applicable)
	      } else if (node.children && node.children.length) {
	        children = domToReact(node.children, options);
	      }
	
	      // skip all other cases (e.g., comment)
	    } else {
	      continue;
	    }
	
	    // specify a "key" prop if element has siblings
	    // https://fb.me/react-warning-keys
	    if (len > 1) {
	      props.key = i;
	    }
	
	    result.push(createElement(node.name, props, children));
	  }
	
	  return result.length === 1 ? result[0] : result;
	}
	
	function shouldPassAttributesUnaltered(node) {
	  return (
	    utilities.PRESERVE_CUSTOM_ATTRIBUTES &&
	    node.type === 'tag' &&
	    utilities.isCustomComponent(node.name, node.attribs)
	  );
	}
	
	module.exports = domToReact;


/***/ },
/* 663 */
/***/ function(module, exports) {

	// http://www.w3.org/TR/CSS21/grammar.html
	// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
	var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
	
	var NEWLINE_REGEX = /\n/g;
	var WHITESPACE_REGEX = /^\s*/;
	
	// declaration
	var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
	var COLON_REGEX = /^:\s*/;
	var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
	var SEMICOLON_REGEX = /^[;\s]*/;
	
	// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
	var TRIM_REGEX = /^\s+|\s+$/g;
	
	// strings
	var NEWLINE = '\n';
	var FORWARD_SLASH = '/';
	var ASTERISK = '*';
	var EMPTY_STRING = '';
	
	// types
	var TYPE_COMMENT = 'comment';
	var TYPE_DECLARATION = 'declaration';
	
	/**
	 * @param {String} style
	 * @param {Object} [options]
	 * @return {Object[]}
	 * @throws {TypeError}
	 * @throws {Error}
	 */
	module.exports = function(style, options) {
	  if (typeof style !== 'string') {
	    throw new TypeError('First argument must be a string');
	  }
	
	  if (!style) return [];
	
	  options = options || {};
	
	  /**
	   * Positional.
	   */
	  var lineno = 1;
	  var column = 1;
	
	  /**
	   * Update lineno and column based on `str`.
	   *
	   * @param {String} str
	   */
	  function updatePosition(str) {
	    var lines = str.match(NEWLINE_REGEX);
	    if (lines) lineno += lines.length;
	    var i = str.lastIndexOf(NEWLINE);
	    column = ~i ? str.length - i : column + str.length;
	  }
	
	  /**
	   * Mark position and patch `node.position`.
	   *
	   * @return {Function}
	   */
	  function position() {
	    var start = { line: lineno, column: column };
	    return function(node) {
	      node.position = new Position(start);
	      whitespace();
	      return node;
	    };
	  }
	
	  /**
	   * Store position information for a node.
	   *
	   * @constructor
	   * @property {Object} start
	   * @property {Object} end
	   * @property {undefined|String} source
	   */
	  function Position(start) {
	    this.start = start;
	    this.end = { line: lineno, column: column };
	    this.source = options.source;
	  }
	
	  /**
	   * Non-enumerable source string.
	   */
	  Position.prototype.content = style;
	
	  var errorsList = [];
	
	  /**
	   * Error `msg`.
	   *
	   * @param {String} msg
	   * @throws {Error}
	   */
	  function error(msg) {
	    var err = new Error(
	      options.source + ':' + lineno + ':' + column + ': ' + msg
	    );
	    err.reason = msg;
	    err.filename = options.source;
	    err.line = lineno;
	    err.column = column;
	    err.source = style;
	
	    if (options.silent) {
	      errorsList.push(err);
	    } else {
	      throw err;
	    }
	  }
	
	  /**
	   * Match `re` and return captures.
	   *
	   * @param {RegExp} re
	   * @return {undefined|Array}
	   */
	  function match(re) {
	    var m = re.exec(style);
	    if (!m) return;
	    var str = m[0];
	    updatePosition(str);
	    style = style.slice(str.length);
	    return m;
	  }
	
	  /**
	   * Parse whitespace.
	   */
	  function whitespace() {
	    match(WHITESPACE_REGEX);
	  }
	
	  /**
	   * Parse comments.
	   *
	   * @param {Object[]} [rules]
	   * @return {Object[]}
	   */
	  function comments(rules) {
	    var c;
	    rules = rules || [];
	    while ((c = comment())) {
	      if (c !== false) {
	        rules.push(c);
	      }
	    }
	    return rules;
	  }
	
	  /**
	   * Parse comment.
	   *
	   * @return {Object}
	   * @throws {Error}
	   */
	  function comment() {
	    var pos = position();
	    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;
	
	    var i = 2;
	    while (
	      EMPTY_STRING != style.charAt(i) &&
	      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
	    ) {
	      ++i;
	    }
	    i += 2;
	
	    if (EMPTY_STRING === style.charAt(i - 1)) {
	      return error('End of comment missing');
	    }
	
	    var str = style.slice(2, i - 2);
	    column += 2;
	    updatePosition(str);
	    style = style.slice(i);
	    column += 2;
	
	    return pos({
	      type: TYPE_COMMENT,
	      comment: str
	    });
	  }
	
	  /**
	   * Parse declaration.
	   *
	   * @return {Object}
	   * @throws {Error}
	   */
	  function declaration() {
	    var pos = position();
	
	    // prop
	    var prop = match(PROPERTY_REGEX);
	    if (!prop) return;
	    comment();
	
	    // :
	    if (!match(COLON_REGEX)) return error("property missing ':'");
	
	    // val
	    var val = match(VALUE_REGEX);
	
	    var ret = pos({
	      type: TYPE_DECLARATION,
	      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
	      value: val
	        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
	        : EMPTY_STRING
	    });
	
	    // ;
	    match(SEMICOLON_REGEX);
	
	    return ret;
	  }
	
	  /**
	   * Parse declarations.
	   *
	   * @return {Object[]}
	   */
	  function declarations() {
	    var decls = [];
	
	    comments(decls);
	
	    // declarations
	    var decl;
	    while ((decl = declaration())) {
	      if (decl !== false) {
	        decls.push(decl);
	        comments(decls);
	      }
	    }
	
	    return decls;
	  }
	
	  whitespace();
	  return declarations();
	};
	
	/**
	 * Trim `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function trim(str) {
	  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
	}


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasToStringTag = __webpack_require__(159)();
	var callBound = __webpack_require__(227);
	
	var $toString = callBound('Object.prototype.toString');
	
	var isStandardArguments = function isArguments(value) {
		if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
			return false;
		}
		return $toString(value) === '[object Arguments]';
	};
	
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			$toString(value) !== '[object Array]' &&
			$toString(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateGetDayCall(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = __webpack_require__(159)();
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) {
			return false;
		}
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(227);
	var hasToStringTag = __webpack_require__(159)();
	var has;
	var $exec;
	var isRegexMarker;
	var badStringifier;
	
	if (hasToStringTag) {
		has = callBound('Object.prototype.hasOwnProperty');
		$exec = callBound('RegExp.prototype.exec');
		isRegexMarker = {};
	
		var throwRegexMarker = function () {
			throw isRegexMarker;
		};
		badStringifier = {
			toString: throwRegexMarker,
			valueOf: throwRegexMarker
		};
	
		if (typeof Symbol.toPrimitive === 'symbol') {
			badStringifier[Symbol.toPrimitive] = throwRegexMarker;
		}
	}
	
	var $toString = callBound('Object.prototype.toString');
	var gOPD = Object.getOwnPropertyDescriptor;
	var regexClass = '[object RegExp]';
	
	module.exports = hasToStringTag
		// eslint-disable-next-line consistent-return
		? function isRegex(value) {
			if (!value || typeof value !== 'object') {
				return false;
			}
	
			var descriptor = gOPD(value, 'lastIndex');
			var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
			if (!hasLastIndexDataProperty) {
				return false;
			}
	
			try {
				$exec(value, badStringifier);
			} catch (e) {
				return e === isRegexMarker;
			}
		}
		: function isRegex(value) {
			// In older browsers, typeof regex incorrectly returns 'function'
			if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
				return false;
			}
	
			return $toString(value) === regexClass;
		};


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var debug = __webpack_require__(603)('jsonp');
	
	/**
	 * Module exports.
	 */
	
	module.exports = jsonp;
	
	/**
	 * Callback index.
	 */
	
	var count = 0;
	
	/**
	 * Noop function.
	 */
	
	function noop(){}
	
	/**
	 * JSONP handler
	 *
	 * Options:
	 *  - param {String} qs parameter (`callback`)
	 *  - prefix {String} qs parameter (`__jp`)
	 *  - name {String} qs parameter (`prefix` + incr)
	 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
	 *
	 * @param {String} url
	 * @param {Object|Function} optional options / callback
	 * @param {Function} optional callback
	 */
	
	function jsonp(url, opts, fn){
	  if ('function' == typeof opts) {
	    fn = opts;
	    opts = {};
	  }
	  if (!opts) opts = {};
	
	  var prefix = opts.prefix || '__jp';
	
	  // use the callback name that was passed if one was provided.
	  // otherwise generate a unique name by incrementing our counter.
	  var id = opts.name || (prefix + (count++));
	
	  var param = opts.param || 'callback';
	  var timeout = null != opts.timeout ? opts.timeout : 60000;
	  var enc = encodeURIComponent;
	  var target = document.getElementsByTagName('script')[0] || document.head;
	  var script;
	  var timer;
	
	
	  if (timeout) {
	    timer = setTimeout(function(){
	      cleanup();
	      if (fn) fn(new Error('Timeout'));
	    }, timeout);
	  }
	
	  function cleanup(){
	    if (script.parentNode) script.parentNode.removeChild(script);
	    window[id] = noop;
	    if (timer) clearTimeout(timer);
	  }
	
	  function cancel(){
	    if (window[id]) {
	      cleanup();
	    }
	  }
	
	  window[id] = function(data){
	    debug('jsonp got', data);
	    cleanup();
	    if (fn) fn(null, data);
	  };
	
	  // add qs component
	  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
	  url = url.replace('?&', '?');
	
	  debug('jsonp req "%s"', url);
	
	  // create script
	  script = document.createElement('script');
	  script.src = url;
	  target.parentNode.insertBefore(script, target);
	
	  return cancel;
	}


/***/ },
/* 668 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(677),
	    createFind = __webpack_require__(695);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias detect
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.result(_.find(users, function(chr) {
	 *   return chr.age < 40;
	 * }), 'user');
	 * // => 'barney'
	 *
	 * // using the `_.matches` callback shorthand
	 * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	 * // => 'pebbles'
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.result(_.find(users, 'active', false), 'user');
	 * // => 'fred'
	 *
	 * // using the `_.property` callback shorthand
	 * _.result(_.find(users, 'active'), 'user');
	 * // => 'barney'
	 */
	var find = createFind(baseEach);
	
	module.exports = find;


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var cachePush = __webpack_require__(691),
	    getNative = __webpack_require__(114);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 *
	 * Creates a cache object to store unique values.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var length = values ? values.length : 0;
	
	  this.data = { 'hash': nativeCreate(null), 'set': new Set };
	  while (length--) {
	    this.push(values[length]);
	  }
	}
	
	// Add functions to the `Set` cache.
	SetCache.prototype.push = cachePush;
	
	module.exports = SetCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 671 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 672 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 673 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 674 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(685),
	    baseMatchesProperty = __webpack_require__(686),
	    bindCallback = __webpack_require__(165),
	    identity = __webpack_require__(287),
	    property = __webpack_require__(705);
	
	/**
	 * The base implementation of `_.callback` which supports specifying the
	 * number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function baseCallback(func, thisArg, argCount) {
	  var type = typeof func;
	  if (type == 'function') {
	    return thisArg === undefined
	      ? func
	      : bindCallback(func, thisArg, argCount);
	  }
	  if (func == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return baseMatches(func);
	  }
	  return thisArg === undefined
	    ? property(func)
	    : baseMatchesProperty(func, thisArg);
	}
	
	module.exports = baseCallback;


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(682),
	    cacheIndexOf = __webpack_require__(690),
	    createCache = __webpack_require__(694);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.difference` which accepts a single array
	 * of values to exclude.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values) {
	  var length = array ? array.length : 0,
	      result = [];
	
	  if (!length) {
	    return result;
	  }
	  var index = -1,
	      indexOf = baseIndexOf,
	      isCommon = true,
	      cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	      valuesLength = values.length;
	
	  if (cache) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	    values = cache;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index];
	
	    if (isCommon && value === value) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === value) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (indexOf(values, value, 0) < 0) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(681),
	    createBaseEach = __webpack_require__(692);
	
	/**
	 * The base implementation of `_.forEach` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 678 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	 * without support for callback shorthands and `this` binding, which iterates
	 * over `collection` using the provided `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @param {boolean} [retKey] Specify returning the key of the found element
	 *  instead of the element itself.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFind(collection, predicate, eachFunc, retKey) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = retKey ? key : value;
	      return false;
	    }
	  });
	  return result;
	}
	
	module.exports = baseFind;


/***/ },
/* 679 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for callback shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromRight) {
	  var length = array.length,
	      index = fromRight ? length : -1;
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(274),
	    keysIn = __webpack_require__(170);
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	module.exports = baseForIn;


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(274),
	    keys = __webpack_require__(169);
	
	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(700);
	
	/**
	 * The base implementation of `_.indexOf` without support for binary searches.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	var equalArrays = __webpack_require__(696),
	    equalByTag = __webpack_require__(697),
	    equalObjects = __webpack_require__(698),
	    isArray = __webpack_require__(54),
	    isHostObject = __webpack_require__(279),
	    isTypedArray = __webpack_require__(703);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = objToString.call(object);
	    if (objTag == argsTag) {
	      objTag = objectTag;
	    } else if (objTag != objectTag) {
	      objIsArr = isTypedArray(object);
	    }
	  }
	  if (!othIsArr) {
	    othTag = objToString.call(other);
	    if (othTag == argsTag) {
	      othTag = objectTag;
	    } else if (othTag != objectTag) {
	      othIsArr = isTypedArray(other);
	    }
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !(objIsArr || objIsObj)) {
	    return equalByTag(object, other, objTag);
	  }
	  if (!isLoose) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  // For more information on detecting circular references see https://es5.github.io/#JO.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == object) {
	      return stackB[length] == other;
	    }
	  }
	  // Add `object` and `other` to the stack of traversed objects.
	  stackA.push(object);
	  stackB.push(other);
	
	  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	  stackA.pop();
	  stackB.pop();
	
	  return result;
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(276),
	    toObject = __webpack_require__(43);
	
	/**
	 * The base implementation of `_.isMatch` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} matchData The propery names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = toObject(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(684),
	    getMatchData = __webpack_require__(699),
	    toObject = __webpack_require__(43);
	
	/**
	 * The base implementation of `_.matches` which does not clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    var key = matchData[0][0],
	        value = matchData[0][1];
	
	    return function(object) {
	      if (object == null) {
	        return false;
	      }
	      object = toObject(object);
	      return object[key] === value && (value !== undefined || (key in object));
	    };
	  }
	  return function(object) {
	    return baseIsMatch(object, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(275),
	    baseIsEqual = __webpack_require__(276),
	    baseSlice = __webpack_require__(688),
	    isArray = __webpack_require__(54),
	    isKey = __webpack_require__(281),
	    isStrictComparable = __webpack_require__(282),
	    last = __webpack_require__(668),
	    toObject = __webpack_require__(43),
	    toPath = __webpack_require__(285);
	
	/**
	 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to compare.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  var isArr = isArray(path),
	      isCommon = isKey(path) && isStrictComparable(srcValue),
	      pathKey = (path + '');
	
	  path = toPath(path);
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    var key = pathKey;
	    object = toObject(object);
	    if ((isArr || !isCommon) && !(key in object)) {
	      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	      if (object == null) {
	        return false;
	      }
	      key = last(path);
	      object = toObject(object);
	    }
	    return object[key] === srcValue
	      ? (srcValue !== undefined || (key in object))
	      : baseIsEqual(srcValue, object[key], undefined, true);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(275),
	    toPath = __webpack_require__(285);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function basePropertyDeep(path) {
	  var pathKey = (path + '');
	  path = toPath(path);
	  return function(object) {
	    return baseGet(object, path, pathKey);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 688 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  start = start == null ? 0 : (+start || 0);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (end === undefined || end > length) ? length : (+end || 0);
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 689 */
/***/ function(module, exports) {

	/**
	 * Converts `value` to a string if it's not one. An empty string is returned
	 * for `null` or `undefined` values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  return value == null ? '' : (value + '');
	}
	
	module.exports = baseToString;


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(55);
	
	/**
	 * Checks if `value` is in `cache` mimicking the return signature of
	 * `_.indexOf` by returning `0` if the value is found, else `-1`.
	 *
	 * @private
	 * @param {Object} cache The cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `0` if `value` is found, else `-1`.
	 */
	function cacheIndexOf(cache, value) {
	  var data = cache.data,
	      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	  return result ? 0 : -1;
	}
	
	module.exports = cacheIndexOf;


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(55);
	
	/**
	 * Adds `value` to the cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var data = this.data;
	  if (typeof value == 'string' || isObject(value)) {
	    data.set.add(value);
	  } else {
	    data.hash[value] = true;
	  }
	}
	
	module.exports = cachePush;


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(278),
	    isLength = __webpack_require__(77),
	    toObject = __webpack_require__(43);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    var length = collection ? getLength(collection) : 0;
	    if (!isLength(length)) {
	      return eachFunc(collection, iteratee);
	    }
	    var index = fromRight ? length : -1,
	        iterable = toObject(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(43);
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var SetCache = __webpack_require__(670),
	    getNative = __webpack_require__(114);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a `Set` cache object to optimize linear searches of large arrays.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	 */
	function createCache(values) {
	  return (nativeCreate && Set) ? new SetCache(values) : null;
	}
	
	module.exports = createCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(675),
	    baseFind = __webpack_require__(678),
	    baseFindIndex = __webpack_require__(679),
	    isArray = __webpack_require__(54);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(eachFunc, fromRight) {
	  return function(collection, predicate, thisArg) {
	    predicate = baseCallback(predicate, thisArg, 3);
	    if (isArray(collection)) {
	      var index = baseFindIndex(collection, predicate, fromRight);
	      return index > -1 ? collection[index] : undefined;
	    }
	    return baseFind(collection, predicate, eachFunc);
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(674);
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing arrays.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var index = -1,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	    return false;
	  }
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index],
	        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	    if (result !== undefined) {
	      if (result) {
	        continue;
	      }
	      return false;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (isLoose) {
	      if (!arraySome(other, function(othValue) {
	            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	          })) {
	        return false;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalArrays;


/***/ },
/* 697 */
/***/ function(module, exports) {

	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag) {
	  switch (tag) {
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object)
	        ? other != +other
	        : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(169);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isLoose) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  var skipCtor = isLoose;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key],
	        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	      return false;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (!skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalObjects;


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(282),
	    pairs = __webpack_require__(704);
	
	/**
	 * Gets the propery names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = pairs(object),
	      length = result.length;
	
	  while (length--) {
	    result[length][2] = isStrictComparable(result[length][1]);
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 700 */
/***/ function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 0 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(167),
	    isArray = __webpack_require__(54),
	    isIndex = __webpack_require__(280),
	    isLength = __webpack_require__(77),
	    isString = __webpack_require__(168),
	    keysIn = __webpack_require__(170);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object) || isString(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = shimKeys;


/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(286),
	    isHostObject = __webpack_require__(279),
	    isObjectLike = __webpack_require__(64);
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
	}
	
	module.exports = isNative;


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(77),
	    isObjectLike = __webpack_require__(64);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(169),
	    toObject = __webpack_require__(43);
	
	/**
	 * Creates a two dimensional array of the key-value pairs for `object`,
	 * e.g. `[[key1, value1], [key2, value2]]`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * _.pairs({ 'barney': 36, 'fred': 40 });
	 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	 */
	function pairs(object) {
	  object = toObject(object);
	
	  var index = -1,
	      props = keys(object),
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    var key = props[index];
	    result[index] = [key, object[key]];
	  }
	  return result;
	}
	
	module.exports = pairs;


/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(277),
	    basePropertyDeep = __webpack_require__(687),
	    isKey = __webpack_require__(281);
	
	/**
	 * Creates a function that returns the property value at `path` on a
	 * given object.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': { 'c': 2 } } },
	 *   { 'a': { 'b': { 'c': 1 } } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b.c'));
	 * // => [2, 1]
	 *
	 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 706 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 707 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ },
/* 708 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(88);
	var callBind = __webpack_require__(142);
	
	var implementation = __webpack_require__(288);
	var getPolyfill = __webpack_require__(289);
	var shim = __webpack_require__(710);
	
	var polyfill = callBind(getPolyfill(), Object);
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(289);
	var define = __webpack_require__(88);
	
	module.exports = function shimObjectIs() {
		var polyfill = getPolyfill();
		define(Object, { is: polyfill }, {
			is: function testObjectIs() {
				return Object.is !== polyfill;
			}
		});
		return polyfill;
	};


/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(291); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(292);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(292);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(715);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 715 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(983);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 717 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ },
/* 718 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelGroup = __webpack_require__(311);
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	var Accordion = _react2['default'].createClass({
	  displayName: 'Accordion',
	
	  render: function render() {
	    return _react2['default'].createElement(
	      _PanelGroup2['default'],
	      _extends({}, this.props, { accordion: true }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Accordion;
	module.exports = exports['default'];

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibDeprecated = __webpack_require__(121);
	
	var _reactPropTypesLibDeprecated2 = _interopRequireDefault(_reactPropTypesLibDeprecated);
	
	var _styleMaps = __webpack_require__(27);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var Alert = _react2['default'].createClass({
	  displayName: 'Alert',
	
	  propTypes: {
	    onDismiss: _react2['default'].PropTypes.func,
	    /**
	     * @private
	     */
	    dismissAfter: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.number, 'No longer supported.'),
	    closeLabel: _react2['default'].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      closeLabel: 'Close Alert'
	    };
	  },
	
	  renderDismissButton: function renderDismissButton() {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: this.props.onDismiss,
	        'aria-hidden': 'true',
	        tabIndex: '-1'
	      },
	      _react2['default'].createElement(
	        'span',
	        null,
	        '×'
	      )
	    );
	  },
	
	  renderSrOnlyDismissButton: function renderSrOnlyDismissButton() {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close sr-only',
	        onClick: this.props.onDismiss
	      },
	      this.props.closeLabel
	    );
	  },
	
	  render: function render() {
	    var classes = _utilsBootstrapUtils.getClassSet(this.props);
	    var isDismissable = !!this.props.onDismiss;
	
	    classes[_utilsBootstrapUtils.prefix(this.props, 'dismissable')] = isDismissable;
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        role: 'alert',
	        className: _classnames2['default'](this.props.className, classes)
	      }),
	      isDismissable ? this.renderDismissButton() : null,
	      this.props.children,
	      isDismissable ? this.renderSrOnlyDismissButton() : null
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    if (this.props.dismissAfter && this.props.onDismiss) {
	      this.dismissTimer = setTimeout(this.props.onDismiss, this.props.dismissAfter);
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.dismissTimer);
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsStyles(_styleMaps.State.values(), _styleMaps.State.INFO, _utilsBootstrapUtils.bsClass('alert', Alert));
	module.exports = exports['default'];

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _utilsValidComponentChildren = __webpack_require__(28);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var Badge = _react2['default'].createClass({
	  displayName: 'Badge',
	
	  propTypes: {
	    pullRight: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      pullRight: false,
	      bsClass: 'badge'
	    };
	  },
	
	  hasContent: function hasContent() {
	    var children = this.props.children;
	
	    return _utilsValidComponentChildren2['default'].count(children) > 0 || _react2['default'].Children.count(children) > 1 || typeof children === 'string' || typeof children === 'number';
	  },
	
	  render: function render() {
	    var _classes;
	
	    var classes = (_classes = {
	      'pull-right': this.props.pullRight
	    }, _classes[_utilsBootstrapUtils.prefix(this.props)] = this.hasContent(), _classes);
	    return _react2['default'].createElement(
	      'span',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, classes)
	      }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Badge;
	module.exports = exports['default'];

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsValidComponentChildren = __webpack_require__(28);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _BreadcrumbItem = __webpack_require__(294);
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	var Breadcrumb = _react2['default'].createClass({
	  displayName: 'Breadcrumb',
	
	  propTypes: {
	    /**
	     * bootstrap className
	     * @private
	     */
	    bsClass: _react2['default'].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'breadcrumb'
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    return _react2['default'].createElement(
	      'ol',
	      _extends({}, props, {
	        role: 'navigation',
	        'aria-label': 'breadcrumbs',
	        className: _classnames2['default'](className, this.props.bsClass) }),
	      _utilsValidComponentChildren2['default'].map(this.props.children, this.renderBreadcrumbItem)
	    );
	  },
	
	  renderBreadcrumbItem: function renderBreadcrumbItem(child, index) {
	    return _react.cloneElement(child, { key: child.key || index });
	  }
	});
	
	Breadcrumb.Item = _BreadcrumbItem2['default'];
	
	exports['default'] = Breadcrumb;
	module.exports = exports['default'];

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(65);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FormGroup = __webpack_require__(176);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _InputBase2 = __webpack_require__(177);
	
	var _InputBase3 = _interopRequireDefault(_InputBase2);
	
	var _utilsChildrenValueInputValidation = __webpack_require__(180);
	
	var _utilsChildrenValueInputValidation2 = _interopRequireDefault(_utilsChildrenValueInputValidation);
	
	var _utilsDeprecationWarning = __webpack_require__(91);
	
	var _utilsDeprecationWarning2 = _interopRequireDefault(_utilsDeprecationWarning);
	
	var ButtonInput = (function (_InputBase) {
	  _inherits(ButtonInput, _InputBase);
	
	  function ButtonInput() {
	    _classCallCheck(this, ButtonInput);
	
	    _InputBase.apply(this, arguments);
	  }
	
	  ButtonInput.prototype.renderFormGroup = function renderFormGroup(children) {
	    var _props = this.props;
	    var bsStyle = _props.bsStyle;
	    var value = _props.value;
	
	    var other = _objectWithoutProperties(_props, ['bsStyle', 'value']);
	
	    return _react2['default'].createElement(
	      _FormGroup2['default'],
	      other,
	      children
	    );
	  };
	
	  ButtonInput.prototype.renderInput = function renderInput() {
	    var _props2 = this.props;
	    var children = _props2.children;
	    var value = _props2.value;
	
	    var other = _objectWithoutProperties(_props2, ['children', 'value']);
	
	    var val = children ? children : value;
	    return _react2['default'].createElement(_Button2['default'], _extends({}, other, { componentClass: 'input', ref: 'input', key: 'input', value: val }));
	  };
	
	  return ButtonInput;
	})(_InputBase3['default']);
	
	ButtonInput.types = _Button2['default'].types;
	
	ButtonInput.defaultProps = {
	  type: 'button'
	};
	
	ButtonInput.propTypes = {
	  type: _react2['default'].PropTypes.oneOf(ButtonInput.types),
	  bsStyle: function bsStyle() {
	    // defer to Button propTypes of bsStyle
	    return null;
	  },
	  children: _utilsChildrenValueInputValidation2['default'],
	  value: _utilsChildrenValueInputValidation2['default']
	};
	
	exports['default'] = _utilsDeprecationWarning2['default'].wrapper(ButtonInput, '`<ButtonInput>`', '`<Button>` directly');
	module.exports = exports['default'];

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _Button = __webpack_require__(65);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var ButtonToolbar = _react2['default'].createClass({
	  displayName: 'ButtonToolbar',
	
	  propTypes: {
	    bsSize: _Button2['default'].propTypes.bsSize
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'btn-toolbar'
	    };
	  },
	
	  render: function render() {
	    var classes = _utilsBootstrapUtils.getClassSet(this.props);
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        role: 'toolbar',
	        className: _classnames2['default'](this.props.className, classes)
	      }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = ButtonToolbar;
	module.exports = exports['default'];

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _Object$assign = __webpack_require__(92)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _utilsValidComponentChildren = __webpack_require__(28);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _CarouselCaption = __webpack_require__(726);
	
	var _CarouselCaption2 = _interopRequireDefault(_CarouselCaption);
	
	var _CarouselItem = __webpack_require__(296);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _Glyphicon = __webpack_require__(118);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var Carousel = _react2['default'].createClass({
	  displayName: 'Carousel',
	
	  propTypes: {
	    slide: _react2['default'].PropTypes.bool,
	    indicators: _react2['default'].PropTypes.bool,
	    interval: _react2['default'].PropTypes.number,
	    controls: _react2['default'].PropTypes.bool,
	    pauseOnHover: _react2['default'].PropTypes.bool,
	    wrap: _react2['default'].PropTypes.bool,
	    /**
	     * Callback fired when the active item changes.
	     *
	     * ```js
	     * (eventKey: any) => any | (eventKey: any, event: Object) => any
	     * ```
	     *
	     * If this callback takes two or more arguments, the second argument will
	     * be a persisted event object with `direction` set to the direction of the
	     * transition.
	     */
	    onSelect: _react2['default'].PropTypes.func,
	    onSlideEnd: _react2['default'].PropTypes.func,
	    activeIndex: _react2['default'].PropTypes.number,
	    defaultActiveIndex: _react2['default'].PropTypes.number,
	    direction: _react2['default'].PropTypes.oneOf(['prev', 'next']),
	    prevIcon: _react2['default'].PropTypes.node,
	    nextIcon: _react2['default'].PropTypes.node
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'carousel',
	      slide: true,
	      interval: 5000,
	      pauseOnHover: true,
	      wrap: true,
	      indicators: true,
	      controls: true,
	      prevIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-left' }),
	      nextIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-right' })
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      activeIndex: this.props.defaultActiveIndex == null ? 0 : this.props.defaultActiveIndex,
	      previousActiveIndex: null,
	      direction: null
	    };
	  },
	
	  getDirection: function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.waitForNext();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.timeout);
	  },
	
	  next: function next(e) {
	    if (e) {
	      e.preventDefault();
	    }
	
	    var index = this.getActiveIndex() + 1;
	    var count = _utilsValidComponentChildren2['default'].count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.handleSelect(index, e, 'next');
	  },
	
	  prev: function prev(e) {
	    if (e) {
	      e.preventDefault();
	    }
	
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _utilsValidComponentChildren2['default'].count(this.props.children) - 1;
	    }
	
	    this.handleSelect(index, e, 'prev');
	  },
	
	  pause: function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  },
	
	  play: function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  },
	
	  waitForNext: function waitForNext() {
	    if (!this.isPaused && this.props.slide && this.props.interval && this.props.activeIndex == null) {
	      this.timeout = setTimeout(this.next, this.props.interval);
	    }
	  },
	
	  handleMouseOver: function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	
	  handleMouseOut: function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  },
	
	  render: function render() {
	    var _classes;
	
	    var classes = (_classes = {}, _classes[_utilsBootstrapUtils.prefix(this.props)] = true, _classes.slide = this.props.slide, _classes);
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      }),
	      this.props.indicators ? this.renderIndicators() : null,
	      _react2['default'].createElement(
	        'div',
	        {
	          ref: 'inner',
	          className: _utilsBootstrapUtils.prefix(this.props, 'inner')
	        },
	        _utilsValidComponentChildren2['default'].map(this.props.children, this.renderItem)
	      ),
	      this.props.controls ? this.renderControls() : null
	    );
	  },
	
	  renderPrev: function renderPrev() {
	    var classes = 'left ' + _utilsBootstrapUtils.prefix(this.props, 'control');
	
	    return _react2['default'].createElement(
	      'a',
	      { className: classes, href: '#prev', key: 0, onClick: this.prev },
	      this.props.prevIcon
	    );
	  },
	
	  renderNext: function renderNext() {
	    var classes = 'right ' + _utilsBootstrapUtils.prefix(this.props, 'control');
	
	    return _react2['default'].createElement(
	      'a',
	      { className: classes, href: '#next', key: 1, onClick: this.next },
	      this.props.nextIcon
	    );
	  },
	
	  renderControls: function renderControls() {
	    if (!this.props.wrap) {
	      var activeIndex = this.getActiveIndex();
	      var count = _utilsValidComponentChildren2['default'].count(this.props.children);
	
	      return [activeIndex !== 0 ? this.renderPrev() : null, activeIndex !== count - 1 ? this.renderNext() : null];
	    }
	
	    return [this.renderPrev(), this.renderNext()];
	  },
	
	  renderIndicator: function renderIndicator(child, index) {
	    var _this = this;
	
	    var className = index === this.getActiveIndex() ? 'active' : null;
	
	    return _react2['default'].createElement('li', {
	      key: index,
	      className: className,
	      onClick: function (e) {
	        return _this.handleSelect(index, e, null);
	      } });
	  },
	
	  renderIndicators: function renderIndicators() {
	    var _this2 = this;
	
	    var indicators = [];
	    _utilsValidComponentChildren2['default'].forEach(this.props.children, function (child, index) {
	      indicators.push(_this2.renderIndicator(child, index),
	
	      // Force whitespace between indicator elements, bootstrap
	      // requires this for correct spacing of elements.
	      ' ');
	    }, this);
	
	    return _react2['default'].createElement(
	      'ol',
	      { className: _utilsBootstrapUtils.prefix(this.props, 'indicators') },
	      indicators
	    );
	  },
	
	  getActiveIndex: function getActiveIndex() {
	    return this.props.activeIndex != null ? this.props.activeIndex : this.state.activeIndex;
	  },
	
	  handleItemAnimateOutEnd: function handleItemAnimateOutEnd() {
	    var _this3 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this3.waitForNext();
	
	      if (_this3.props.onSlideEnd) {
	        _this3.props.onSlideEnd();
	      }
	    });
	  },
	
	  renderItem: function renderItem(child, index) {
	    var activeIndex = this.getActiveIndex();
	    var isActive = index === activeIndex;
	    var isPreviousActive = this.state.previousActiveIndex != null && this.state.previousActiveIndex === index && this.props.slide;
	
	    return _react.cloneElement(child, {
	      active: isActive,
	      ref: child.ref,
	      key: child.key ? child.key : index,
	      index: index,
	      animateOut: isPreviousActive,
	      animateIn: isActive && this.state.previousActiveIndex != null && this.props.slide,
	      direction: this.state.direction,
	      onAnimateOutEnd: isPreviousActive ? this.handleItemAnimateOutEnd : null
	    });
	  },
	
	  handleSelect: function handleSelect(index, e, direction) {
	    clearTimeout(this.timeout);
	
	    if (this.isMounted()) {
	      var previousActiveIndex = this.getActiveIndex();
	      direction = direction || this.getDirection(previousActiveIndex, index);
	
	      var onSelect = this.props.onSelect;
	
	      if (onSelect) {
	        if (onSelect.length > 1) {
	          // React SyntheticEvents are pooled, so we need to remove this event
	          // from the pool to add a custom property. To avoid unnecessarily
	          // removing objects from the pool, only do this when the listener
	          // actually wants the event.
	          e.persist();
	          e.direction = direction;
	
	          onSelect(index, e);
	        } else {
	          onSelect(index);
	        }
	      }
	
	      if (this.props.activeIndex == null && index !== previousActiveIndex) {
	        if (this.state.previousActiveIndex != null) {
	          // If currently animating don't activate the new index.
	          // TODO: look into queuing this canceled call and
	          // animating after the current animation has ended.
	          return;
	        }
	
	        this.setState({
	          activeIndex: index,
	          previousActiveIndex: previousActiveIndex,
	          direction: direction
	        });
	      }
	    }
	  }
	});
	
	Carousel = _Object$assign(Carousel, { Caption: _CarouselCaption2['default'], Item: _CarouselItem2['default'] });
	
	exports['default'] = Carousel;
	module.exports = exports['default'];

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var CarouselCaption = _react2['default'].createClass({
	  displayName: 'Carousel.Caption',
	  propTypes: {
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div'
	    };
	  },
	
	  render: function render() {
	    var ComponentClass = this.props.componentClass;
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'carousel-caption') }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = CarouselCaption;
	module.exports = exports['default'];

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var propTypes = {
	  inline: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error']),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Checkbox inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Checkbox = (function (_React$Component) {
	  _inherits(Checkbox, _React$Component);
	
	  function Checkbox() {
	    _classCallCheck(this, Checkbox);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Checkbox.prototype.render = function render() {
	    var _props = this.props;
	    var inline = _props.inline;
	    var disabled = _props.disabled;
	    var validationState = _props.validationState;
	    var inputRef = _props.inputRef;
	    var className = _props.className;
	    var style = _props.style;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    delete props.bsClass;
	
	    var input = _react2['default'].createElement('input', _extends({}, props, {
	      ref: inputRef,
	      type: 'checkbox',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes;
	
	      var _classes2 = (_classes = {}, _classes[_utilsBootstrapUtils.prefix(this.props, 'inline')] = true, _classes.disabled = disabled, _classes);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? _warning2['default'](!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : undefined;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: _classnames2['default'](className, _classes2), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = _extends({}, _utilsBootstrapUtils.getClassSet(this.props), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: _classnames2['default'](className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Checkbox;
	})(_react2['default'].Component);
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	
	exports['default'] = _utilsBootstrapUtils.bsClass('checkbox', Checkbox);
	module.exports = exports['default'];

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _Object$keys = __webpack_require__(56)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styleMaps = __webpack_require__(27);
	
	var _styleMaps2 = _interopRequireDefault(_styleMaps);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var Clearfix = _react2['default'].createClass({
	  displayName: 'Clearfix',
	
	  propTypes: {
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default'],
	    /**
	     * Apply clearfix
	     *
	     * on Extra small devices Phones
	     *
	     * adds class `visible-xs-block`
	     */
	    visibleXsBlock: _react2['default'].PropTypes.bool,
	    /**
	     * Apply clearfix
	     *
	     * on Small devices Tablets
	     *
	     * adds class `visible-sm-block`
	     */
	    visibleSmBlock: _react2['default'].PropTypes.bool,
	    /**
	     * Apply clearfix
	     *
	     * on Medium devices Desktops
	     *
	     * adds class `visible-md-block`
	     */
	    visibleMdBlock: _react2['default'].PropTypes.bool,
	    /**
	     * Apply clearfix
	     *
	     * on Large devices Desktops
	     *
	     * adds class `visible-lg-block`
	     */
	    visibleLgBlock: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div'
	    };
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var ComponentClass = this.props.componentClass;
	
	    var classes = {};
	
	    _Object$keys(_styleMaps2['default'].SIZES).forEach(function (key) {
	      var size = _styleMaps2['default'].SIZES[key];
	
	      classes['visible-' + size + '-block'] = _this.props['visible' + size.charAt(0).toUpperCase() + size.slice(1) + 'Block'];
	    }, this);
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'clearfix', classes) }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Clearfix;
	module.exports = exports['default'];

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var propTypes = {
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  htmlFor: _react2['default'].PropTypes.string,
	  srOnly: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  srOnly: false
	};
	
	var contextTypes = {
	  $bs_formGroup: _react2['default'].PropTypes.object
	};
	
	var ControlLabel = (function (_React$Component) {
	  _inherits(ControlLabel, _React$Component);
	
	  function ControlLabel() {
	    _classCallCheck(this, ControlLabel);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ControlLabel.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props;
	    var _props$htmlFor = _props.htmlFor;
	    var htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor;
	    var srOnly = _props.srOnly;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['htmlFor', 'srOnly', 'className']);
	
	     false ? _warning2['default'](controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : undefined;
	
	    delete props.bsClass;
	
	    var classes = _extends({}, _utilsBootstrapUtils.getClassSet(this.props), {
	      'sr-only': srOnly
	    });
	
	    return _react2['default'].createElement('label', _extends({}, props, {
	      htmlFor: htmlFor,
	      className: _classnames2['default'](className, classes)
	    }));
	  };
	
	  return ControlLabel;
	})(_react2['default'].Component);
	
	ControlLabel.propTypes = propTypes;
	ControlLabel.defaultProps = defaultProps;
	ControlLabel.contextTypes = contextTypes;
	
	exports['default'] = _utilsBootstrapUtils.bsClass('control-label', ControlLabel);
	module.exports = exports['default'];

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _Object$keys = __webpack_require__(56)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dropdown = __webpack_require__(116);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _lodashCompatObjectOmit = __webpack_require__(171);
	
	var _lodashCompatObjectOmit2 = _interopRequireDefault(_lodashCompatObjectOmit);
	
	var _lodashCompatObjectPick = __webpack_require__(115);
	
	var _lodashCompatObjectPick2 = _interopRequireDefault(_lodashCompatObjectPick);
	
	var _Button = __webpack_require__(65);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var DropdownButton = (function (_React$Component) {
	  _inherits(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    _classCallCheck(this, DropdownButton);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  DropdownButton.prototype.render = function render() {
	    var _props = this.props;
	    var bsStyle = _props.bsStyle;
	    var bsSize = _props.bsSize;
	    var disabled = _props.disabled;
	    var _props2 = this.props;
	    var title = _props2.title;
	    var children = _props2.children;
	
	    var props = _objectWithoutProperties(_props2, ['title', 'children']);
	
	    var dropdownProps = _lodashCompatObjectPick2['default'](props, _Object$keys(_Dropdown2['default'].ControlledComponent.propTypes));
	    var toggleProps = _lodashCompatObjectOmit2['default'](props, _Object$keys(_Dropdown2['default'].ControlledComponent.propTypes));
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      _extends({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        _extends({}, toggleProps, {
	          disabled: disabled
	        }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return DropdownButton;
	})(_react2['default'].Component);
	
	DropdownButton.propTypes = _extends({
	  disabled: _react2['default'].PropTypes.bool,
	  bsStyle: _Button2['default'].propTypes.bsStyle,
	  bsSize: _Button2['default'].propTypes.bsSize,
	
	  /**
	   * When used with the `title` prop, the noCaret option will not render a caret icon, in the toggle element.
	   */
	  noCaret: _react2['default'].PropTypes.bool,
	  title: _react2['default'].PropTypes.node.isRequired
	
	}, _Dropdown2['default'].propTypes);
	
	DropdownButton.defaultProps = {
	  disabled: false,
	  pullRight: false,
	  dropup: false,
	  navItem: false,
	  noCaret: false
	};
	
	exports['default'] = DropdownButton;
	module.exports = exports['default'];

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(164);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _utilsCreateChainedFunction = __webpack_require__(32);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var _utilsValidComponentChildren = __webpack_require__(28);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _reactOverlaysLibRootCloseWrapper = __webpack_require__(325);
	
	var _reactOverlaysLibRootCloseWrapper2 = _interopRequireDefault(_reactOverlaysLibRootCloseWrapper);
	
	var DropdownMenu = (function (_React$Component) {
	  _inherits(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    _classCallCheck(this, DropdownMenu);
	
	    _React$Component.call(this, props);
	
	    this.focusNext = this.focusNext.bind(this);
	    this.focusPrevious = this.focusPrevious.bind(this);
	    this.getFocusableMenuItems = this.getFocusableMenuItems.bind(this);
	    this.getItemsAndActiveIndex = this.getItemsAndActiveIndex.bind(this);
	
	    this.handleKeyDown = this.handleKeyDown.bind(this);
	  }
	
	  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.props.onClose(event);
	        break;
	      default:
	    }
	  };
	
	  DropdownMenu.prototype.focusNext = function focusNext() {
	    var _getItemsAndActiveIndex = this.getItemsAndActiveIndex();
	
	    var items = _getItemsAndActiveIndex.items;
	    var activeItemIndex = _getItemsAndActiveIndex.activeItemIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    if (activeItemIndex === items.length - 1) {
	      items[0].focus();
	      return;
	    }
	
	    items[activeItemIndex + 1].focus();
	  };
	
	  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
	    var _getItemsAndActiveIndex2 = this.getItemsAndActiveIndex();
	
	    var items = _getItemsAndActiveIndex2.items;
	    var activeItemIndex = _getItemsAndActiveIndex2.activeItemIndex;
	
	    if (activeItemIndex === 0) {
	      items[items.length - 1].focus();
	      return;
	    }
	
	    items[activeItemIndex - 1].focus();
	  };
	
	  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeElement = document.activeElement;
	    var activeItemIndex = items.indexOf(activeElement);
	
	    return { items: items, activeItemIndex: activeItemIndex };
	  };
	
	  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
	    var menuNode = _reactDom2['default'].findDOMNode(this);
	
	    if (menuNode === undefined) {
	      return [];
	    }
	
	    return [].slice.call(menuNode.querySelectorAll('[tabIndex="-1"]'), 0);
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var _classes,
	        _this = this;
	
	    var _props = this.props;
	    var children = _props.children;
	    var onSelect = _props.onSelect;
	    var pullRight = _props.pullRight;
	    var className = _props.className;
	    var labelledBy = _props.labelledBy;
	    var open = _props.open;
	    var onClose = _props.onClose;
	
	    var props = _objectWithoutProperties(_props, ['children', 'onSelect', 'pullRight', 'className', 'labelledBy', 'open', 'onClose']);
	
	    var items = _utilsValidComponentChildren2['default'].map(children, function (child) {
	      var childProps = child.props || {};
	
	      return _react2['default'].cloneElement(child, {
	        onKeyDown: _utilsCreateChainedFunction2['default'](childProps.onKeyDown, _this.handleKeyDown),
	        onSelect: _utilsCreateChainedFunction2['default'](childProps.onSelect, onSelect)
	      }, childProps.children);
	    });
	
	    var classes = (_classes = {}, _classes[_utilsBootstrapUtils.prefix(this.props, 'menu')] = true, _classes[_utilsBootstrapUtils.prefix(this.props, 'menu-right')] = pullRight, _classes);
	
	    var list = _react2['default'].createElement(
	      'ul',
	      _extends({
	        className: _classnames2['default'](className, classes),
	        role: 'menu',
	        'aria-labelledby': labelledBy
	      }, props),
	      items
	    );
	
	    if (open) {
	      list = _react2['default'].createElement(
	        _reactOverlaysLibRootCloseWrapper2['default'],
	        { noWrap: true, onRootClose: onClose },
	        list
	      );
	    }
	
	    return list;
	  };
	
	  return DropdownMenu;
	})(_react2['default'].Component);
	
	DropdownMenu.defaultProps = {
	  bsRole: 'menu',
	  bsClass: 'dropdown',
	  pullRight: false
	};
	
	DropdownMenu.propTypes = {
	  open: _react2['default'].PropTypes.bool,
	  pullRight: _react2['default'].PropTypes.bool,
	  onClose: _react2['default'].PropTypes.func,
	  labelledBy: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	  onSelect: _react2['default'].PropTypes.func
	};
	
	exports['default'] = DropdownMenu;
	module.exports = exports['default'];

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var propTypes = {
	  horizontal: _react2['default'].PropTypes.bool,
	  inline: _react2['default'].PropTypes.bool,
	  componentClass: _reactPropTypesLibElementType2['default']
	};
	
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form = (function (_React$Component) {
	  _inherits(Form, _React$Component);
	
	  function Form() {
	    _classCallCheck(this, Form);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Form.prototype.render = function render() {
	    var _props = this.props;
	    var horizontal = _props.horizontal;
	    var inline = _props.inline;
	    var Component = _props.componentClass;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['horizontal', 'inline', 'componentClass', 'className']);
	
	    delete props.bsClass;
	
	    var classes = [];
	    if (horizontal) {
	      classes.push(_utilsBootstrapUtils.prefix(this.props, 'horizontal'));
	    }
	    if (inline) {
	      classes.push(_utilsBootstrapUtils.prefix(this.props, 'inline'));
	    }
	
	    return _react2['default'].createElement(Component, _extends({}, props, { className: _classnames2['default'](className, classes) }));
	  };
	
	  return Form;
	})(_react2['default'].Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	exports['default'] = _utilsBootstrapUtils.bsClass('form', Form);
	module.exports = exports['default'];

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _FormControlFeedback = __webpack_require__(734);
	
	var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);
	
	var _FormControlStatic = __webpack_require__(735);
	
	var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);
	
	var propTypes = {
	  componentClass: _reactPropTypesLibElementType2['default'],
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _react2['default'].PropTypes.string,
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  componentClass: 'input'
	};
	
	var contextTypes = {
	  $bs_formGroup: _react2['default'].PropTypes.object
	};
	
	var FormControl = (function (_React$Component) {
	  _inherits(FormControl, _React$Component);
	
	  function FormControl() {
	    _classCallCheck(this, FormControl);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  FormControl.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props;
	    var Component = _props.componentClass;
	    var type = _props.type;
	    var _props$id = _props.id;
	    var id = _props$id === undefined ? controlId : _props$id;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['componentClass', 'type', 'id', 'className']);
	
	     false ? _warning2['default'](controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : undefined;
	
	    delete props.bsClass;
	
	    // input[type="file"] should not have .form-control.
	    var classes = undefined;
	    if (type !== 'file') {
	      classes = _utilsBootstrapUtils.getClassSet(this.props);
	    }
	
	    return _react2['default'].createElement(Component, _extends({}, props, {
	      type: type,
	      id: id,
	      className: _classnames2['default'](className, classes)
	    }));
	  };
	
	  return FormControl;
	})(_react2['default'].Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	
	FormControl.Feedback = _FormControlFeedback2['default'];
	FormControl.Static = _FormControlStatic2['default'];
	
	exports['default'] = _utilsBootstrapUtils.bsClass('form-control', FormControl);
	module.exports = exports['default'];

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _Glyphicon = __webpack_require__(118);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	
	var contextTypes = {
	  $bs_formGroup: _react2['default'].PropTypes.object
	};
	
	var FormControlFeedback = (function (_React$Component) {
	  _inherits(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    _classCallCheck(this, FormControlFeedback);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	      case 'warning':
	        return 'warning-sign';
	      case 'error':
	        return 'remove';
	      default:
	        return null;
	    }
	  };
	
	  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, props) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	    if (!glyph) {
	      return null;
	    }
	
	    return _react2['default'].createElement(_Glyphicon2['default'], _extends({}, props, {
	      glyph: glyph,
	      className: _classnames2['default'](className, classes)
	    }));
	  };
	
	  FormControlFeedback.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['className', 'children']);
	
	    delete props.bsClass;
	
	    var classes = _utilsBootstrapUtils.getClassSet(this.props);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, props);
	    }
	
	    var child = _react2['default'].Children.only(children);
	    return _react2['default'].cloneElement(child, _extends({}, props, {
	      className: _classnames2['default'](child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	})(_react2['default'].Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	exports['default'] = _utilsBootstrapUtils.bsClass('form-control-feedback', FormControlFeedback);
	module.exports = exports['default'];

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var propTypes = {
	  componentClass: _reactPropTypesLibElementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic = (function (_React$Component) {
	  _inherits(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    _classCallCheck(this, FormControlStatic);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  FormControlStatic.prototype.render = function render() {
	    var _props = this.props;
	    var Component = _props.componentClass;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['componentClass', 'className']);
	
	    delete props.bsClass;
	
	    var classes = _utilsBootstrapUtils.getClassSet(this.props);
	
	    return _react2['default'].createElement(Component, _extends({}, props, { className: _classnames2['default'](className, classes) }));
	  };
	
	  return FormControlStatic;
	})(_react2['default'].Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	exports['default'] = _utilsBootstrapUtils.bsClass('form-control-static', FormControlStatic);
	module.exports = exports['default'];

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _InputBase2 = __webpack_require__(177);
	
	var _InputBase3 = _interopRequireDefault(_InputBase2);
	
	var _utilsChildrenValueInputValidation = __webpack_require__(180);
	
	var _utilsChildrenValueInputValidation2 = _interopRequireDefault(_utilsChildrenValueInputValidation);
	
	var _utilsDeprecationWarning = __webpack_require__(91);
	
	var _utilsDeprecationWarning2 = _interopRequireDefault(_utilsDeprecationWarning);
	
	var Static = (function (_InputBase) {
	  _inherits(Static, _InputBase);
	
	  function Static() {
	    _classCallCheck(this, Static);
	
	    _InputBase.apply(this, arguments);
	  }
	
	  Static.prototype.getValue = function getValue() {
	    var _props = this.props;
	    var children = _props.children;
	    var value = _props.value;
	
	    return children ? children : value;
	  };
	
	  Static.prototype.renderInput = function renderInput() {
	    var _props2 = this.props;
	    var ComponentClass = _props2.componentClass;
	
	    var props = _objectWithoutProperties(_props2, ['componentClass']);
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, props, { className: _classnames2['default'](props.className, 'form-control-static'), ref: 'input', key: 'input' }),
	      this.getValue()
	    );
	  };
	
	  return Static;
	})(_InputBase3['default']);
	
	Static.propTypes = {
	  value: _utilsChildrenValueInputValidation2['default'],
	  /**
	   * You can override the default 'p' with a custom element
	   */
	  componentClass: _reactPropTypesLibElementType2['default'],
	  children: _utilsChildrenValueInputValidation2['default']
	};
	
	Static.defaultProps = {
	  componentClass: 'p'
	};
	
	exports['default'] = _utilsDeprecationWarning2['default'].wrapper(Static, '`<FormControls.Static>`', '`<FormControl.Static>`');
	module.exports = exports['default'];

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var HelpBlock = (function (_React$Component) {
	  _inherits(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    _classCallCheck(this, HelpBlock);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  HelpBlock.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    delete props.bsClass;
	
	    var classes = _utilsBootstrapUtils.getClassSet(this.props);
	
	    return _react2['default'].createElement('span', _extends({}, props, { className: _classnames2['default'](className, classes) }));
	  };
	
	  return HelpBlock;
	})(_react2['default'].Component);
	
	exports['default'] = _utilsBootstrapUtils.bsClass('help-block', HelpBlock);
	module.exports = exports['default'];

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Image = _react2['default'].createClass({
	  displayName: 'Image',
	
	  propTypes: {
	
	    /**
	     * Sets image as responsive image
	     */
	    responsive: _react2['default'].PropTypes.bool,
	
	    /**
	     * Sets image shape as rounded
	     */
	    rounded: _react2['default'].PropTypes.bool,
	
	    /**
	     * Sets image shape as circle
	     */
	    circle: _react2['default'].PropTypes.bool,
	
	    /**
	     * Sets image shape as thumbnail
	     */
	    thumbnail: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      responsive: false,
	      rounded: false,
	      circle: false,
	      thumbnail: false
	    };
	  },
	
	  render: function render() {
	    var classes = {
	      'img-responsive': this.props.responsive,
	      'img-rounded': this.props.rounded,
	      'img-circle': this.props.circle,
	      'img-thumbnail': this.props.thumbnail
	    };
	
	    return _react2['default'].createElement('img', _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }));
	  }
	});
	
	exports['default'] = Image;
	module.exports = exports['default'];

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	var _interopRequireWildcard = __webpack_require__(181)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormControls = __webpack_require__(299);
	
	var FormControls = _interopRequireWildcard(_FormControls);
	
	var _InputBase2 = __webpack_require__(177);
	
	var _InputBase3 = _interopRequireDefault(_InputBase2);
	
	var _utilsDeprecationWarning = __webpack_require__(91);
	
	var _utilsDeprecationWarning2 = _interopRequireDefault(_utilsDeprecationWarning);
	
	var Input = (function (_InputBase) {
	  _inherits(Input, _InputBase);
	
	  function Input() {
	    _classCallCheck(this, Input);
	
	    _InputBase.apply(this, arguments);
	  }
	
	  Input.prototype.render = function render() {
	    if (this.props.type === 'static') {
	      _utilsDeprecationWarning2['default']('Input type=static', 'FormControls.Static');
	      return _react2['default'].createElement(FormControls.Static, this.props);
	    }
	
	    return _InputBase.prototype.render.call(this);
	  };
	
	  return Input;
	})(_InputBase3['default']);
	
	Input.propTypes = {
	  type: _react2['default'].PropTypes.string
	};
	
	exports['default'] = _utilsDeprecationWarning2['default'].wrapper(Input, '`<Input>`', '`<FormControl>`, `<Checkbox>`, or `<Radio>`, with `<FormGroup>` and/or ' + '`<InputGroup>` as needed');
	module.exports = exports['default'];

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styleMaps = __webpack_require__(27);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _InputGroupAddon = __webpack_require__(741);
	
	var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);
	
	var _InputGroupButton = __webpack_require__(742);
	
	var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);
	
	var InputGroup = (function (_React$Component) {
	  _inherits(InputGroup, _React$Component);
	
	  function InputGroup() {
	    _classCallCheck(this, InputGroup);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  InputGroup.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    delete props.bsClass;
	    delete props.bsSize;
	
	    var classes = _utilsBootstrapUtils.getClassSet(this.props);
	
	    return _react2['default'].createElement('span', _extends({}, props, { className: _classnames2['default'](className, classes) }));
	  };
	
	  return InputGroup;
	})(_react2['default'].Component);
	
	InputGroup.Addon = _InputGroupAddon2['default'];
	InputGroup.Button = _InputGroupButton2['default'];
	
	exports['default'] = _utilsBootstrapUtils.bsClass('input-group', _utilsBootstrapUtils.bsSizes([_styleMaps.Sizes.LARGE, _styleMaps.Sizes.SMALL], InputGroup));
	module.exports = exports['default'];

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var InputGroupAddon = (function (_React$Component) {
	  _inherits(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    _classCallCheck(this, InputGroupAddon);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  InputGroupAddon.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    delete props.bsClass;
	
	    var classes = _utilsBootstrapUtils.getClassSet(this.props);
	
	    return _react2['default'].createElement('span', _extends({}, props, { className: _classnames2['default'](className, classes) }));
	  };
	
	  return InputGroupAddon;
	})(_react2['default'].Component);
	
	exports['default'] = _utilsBootstrapUtils.bsClass('input-group-addon', InputGroupAddon);
	module.exports = exports['default'];

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var InputGroupButton = (function (_React$Component) {
	  _inherits(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    _classCallCheck(this, InputGroupButton);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  InputGroupButton.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    delete props.bsClass;
	
	    var classes = _utilsBootstrapUtils.getClassSet(this.props);
	
	    return _react2['default'].createElement('span', _extends({}, props, { className: _classnames2['default'](className, classes) }));
	  };
	
	  return InputGroupButton;
	})(_react2['default'].Component);
	
	exports['default'] = _utilsBootstrapUtils.bsClass('input-group-btn', InputGroupButton);
	module.exports = exports['default'];

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var Jumbotron = _react2['default'].createClass({
	  displayName: 'Jumbotron',
	
	  propTypes: {
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return { componentClass: 'div' };
	  },
	
	  render: function render() {
	    var ComponentClass = this.props.componentClass;
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'jumbotron') }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Jumbotron;
	module.exports = exports['default'];

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styleMaps = __webpack_require__(27);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var Label = (function (_React$Component) {
	  _inherits(Label, _React$Component);
	
	  function Label() {
	    _classCallCheck(this, _Label);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Label.prototype.render = function render() {
	    var classes = _utilsBootstrapUtils.getClassSet(this.props);
	
	    return _react2['default'].createElement(
	      'span',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, classes)
	      }),
	      this.props.children
	    );
	  };
	
	  var _Label = Label;
	  Label = _utilsBootstrapUtils.bsStyles(_styleMaps.State.values().concat(_styleMaps.DEFAULT, _styleMaps.PRIMARY), _styleMaps.DEFAULT)(Label) || Label;
	  Label = _utilsBootstrapUtils.bsClass('label')(Label) || Label;
	  return Label;
	})(_react2['default'].Component);
	
	exports['default'] = Label;
	module.exports = exports['default'];

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ListGroupItem = __webpack_require__(302);
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsValidComponentChildren = __webpack_require__(28);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var ListGroup = (function (_React$Component) {
	  _inherits(ListGroup, _React$Component);
	
	  function ListGroup() {
	    _classCallCheck(this, ListGroup);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ListGroup.prototype.render = function render() {
	    var _this = this;
	
	    var items = _utilsValidComponentChildren2['default'].map(this.props.children, function (item, index) {
	      return _react.cloneElement(item, { key: item.key ? item.key : index });
	    });
	
	    if (this.areCustomChildren(items)) {
	      var Component = this.props.componentClass;
	      return _react2['default'].createElement(
	        Component,
	        _extends({}, this.props, {
	          className: _classnames2['default'](this.props.className, 'list-group') }),
	        items
	      );
	    }
	
	    var shouldRenderDiv = false;
	
	    if (!this.props.children) {
	      shouldRenderDiv = true;
	    } else {
	      _utilsValidComponentChildren2['default'].forEach(this.props.children, function (child) {
	        if (_this.isAnchorOrButton(child.props)) {
	          shouldRenderDiv = true;
	        }
	      });
	    }
	
	    return shouldRenderDiv ? this.renderDiv(items) : this.renderUL(items);
	  };
	
	  ListGroup.prototype.isAnchorOrButton = function isAnchorOrButton(props) {
	    return props.href || props.onClick;
	  };
	
	  ListGroup.prototype.areCustomChildren = function areCustomChildren(children) {
	    var customChildren = false;
	
	    _utilsValidComponentChildren2['default'].forEach(children, function (child) {
	      if (child.type !== _ListGroupItem2['default']) {
	        customChildren = true;
	      }
	    }, this);
	
	    return customChildren;
	  };
	
	  ListGroup.prototype.renderUL = function renderUL(items) {
	    var listItems = _utilsValidComponentChildren2['default'].map(items, function (item) {
	      return _react.cloneElement(item, { listItem: true });
	    });
	
	    return _react2['default'].createElement(
	      'ul',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, 'list-group') }),
	      listItems
	    );
	  };
	
	  ListGroup.prototype.renderDiv = function renderDiv(items) {
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, 'list-group') }),
	      items
	    );
	  };
	
	  return ListGroup;
	})(_react2['default'].Component);
	
	ListGroup.defaultProps = {
	  componentClass: 'div'
	};
	
	ListGroup.propTypes = {
	  className: _react2['default'].PropTypes.string,
	  /**
	   * The element for ListGroup if children are
	   * user-defined custom components.
	   * @type {("ul"|"div")}
	   */
	  componentClass: _react2['default'].PropTypes.oneOf(['ul', 'div']),
	  id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])
	};
	
	exports['default'] = ListGroup;
	module.exports = exports['default'];

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _Object$assign = __webpack_require__(92)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _MediaHeading = __webpack_require__(748);
	
	var _MediaHeading2 = _interopRequireDefault(_MediaHeading);
	
	var _MediaBody = __webpack_require__(747);
	
	var _MediaBody2 = _interopRequireDefault(_MediaBody);
	
	var _MediaLeft = __webpack_require__(749);
	
	var _MediaLeft2 = _interopRequireDefault(_MediaLeft);
	
	var _MediaRight = __webpack_require__(752);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	var _MediaList = __webpack_require__(750);
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	var _MediaListItem = __webpack_require__(751);
	
	var _MediaListItem2 = _interopRequireDefault(_MediaListItem);
	
	var Media = _react2['default'].createClass({
	  displayName: 'Media',
	  propTypes: {
	    /**
	     * You can use a custom element for the media container
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div'
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var ComponentClass = _props.componentClass;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['componentClass', 'className']);
	
	    return _react2['default'].createElement(ComponentClass, _extends({}, props, { className: _classnames2['default'](className, 'media') }));
	  }
	});
	
	Media = _Object$assign(Media, { Heading: _MediaHeading2['default'], Body: _MediaBody2['default'], Left: _MediaLeft2['default'], Right: _MediaRight2['default'], List: _MediaList2['default'], ListItem: _MediaListItem2['default'] });
	
	exports['default'] = Media;
	module.exports = exports['default'];

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var MediaBody = _react2['default'].createClass({
	  displayName: 'Media.Body',
	  propTypes: {
	    /**
	     * You can use a custom element for the media body
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div'
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var ComponentClass = _props.componentClass;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['componentClass', 'className']);
	
	    return _react2['default'].createElement(ComponentClass, _extends({}, props, { className: _classnames2['default'](className, 'media-body') }));
	  }
	});
	
	exports['default'] = MediaBody;
	module.exports = exports['default'];

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var MediaHeading = _react2['default'].createClass({
	  displayName: 'Media.Heading',
	  propTypes: {
	    /**
	     * You can use a custom element for the media heading
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'h4'
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var ComponentClass = _props.componentClass;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['componentClass', 'className']);
	
	    return _react2['default'].createElement(ComponentClass, _extends({}, props, { className: _classnames2['default'](className, 'media-heading') }));
	  }
	});
	
	exports['default'] = MediaHeading;
	module.exports = exports['default'];

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var MediaLeft = _react2['default'].createClass({
	  displayName: 'Media.Left',
	  propTypes: {
	    /**
	     * Align the media to the top, middle or bottom
	     * of the media object
	     */
	    align: _react2['default'].PropTypes.oneOf(['top', 'middle', 'bottom'])
	  },
	
	  render: function render() {
	    var _classNames;
	
	    var _props = this.props;
	    var align = _props.align;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['align', 'className']);
	
	    var classes = _classnames2['default'](className, 'media-left', (_classNames = {}, _classNames['media-' + align] = Boolean(align), _classNames));
	
	    // Only add the media-alignment class if align is passed in props
	    return _react2['default'].createElement('div', _extends({}, props, { className: classes }));
	  }
	});
	
	exports['default'] = MediaLeft;
	module.exports = exports['default'];

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var MediaList = _react2['default'].createClass({
	  displayName: 'Media.List',
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    return _react2['default'].createElement('ul', _extends({}, props, { className: _classnames2['default'](className, 'media-list') }));
	  }
	});
	
	exports['default'] = MediaList;
	module.exports = exports['default'];

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var MediaListItem = _react2['default'].createClass({
	  displayName: 'Media.ListItem',
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    return _react2['default'].createElement('li', _extends({}, props, { className: _classnames2['default'](className, 'media') }));
	  }
	});
	
	exports['default'] = MediaListItem;
	module.exports = exports['default'];

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var MediaRight = _react2['default'].createClass({
	  displayName: 'Media.Right',
	  propTypes: {
	    /**
	     * Align the media to the top, middle or bottom
	     * of the media object
	     */
	    align: _react2['default'].PropTypes.oneOf(['top', 'middle', 'bottom'])
	  },
	
	  render: function render() {
	    var _classNames;
	
	    var _props = this.props;
	    var align = _props.align;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['align', 'className']);
	
	    var classes = _classnames2['default'](className, 'media-right', (_classNames = {}, _classNames['media-' + align] = Boolean(align), _classNames));
	
	    // Only add the media-alignment class if align is passed in props
	    return _react2['default'].createElement('div', _extends({}, props, { className: classes }));
	  }
	});
	
	exports['default'] = MediaRight;
	module.exports = exports['default'];

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibAll = __webpack_require__(120);
	
	var _reactPropTypesLibAll2 = _interopRequireDefault(_reactPropTypesLibAll);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _utilsCreateChainedFunction = __webpack_require__(32);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var _SafeAnchor = __webpack_require__(47);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var MenuItem = (function (_React$Component) {
	  _inherits(MenuItem, _React$Component);
	
	  function MenuItem(props) {
	    _classCallCheck(this, MenuItem);
	
	    _React$Component.call(this, props);
	
	    this.handleClick = this.handleClick.bind(this);
	  }
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    if (!this.props.href || this.props.disabled) {
	      event.preventDefault();
	    }
	
	    if (this.props.disabled) {
	      return;
	    }
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, event);
	    }
	  };
	
	  MenuItem.prototype.render = function render() {
	    if (this.props.divider) {
	      return _react2['default'].createElement('li', {
	        role: 'separator',
	        className: _classnames2['default']('divider', this.props.className),
	        style: this.props.style
	      });
	    }
	
	    if (this.props.header) {
	      var headerClass = _utilsBootstrapUtils.prefix(this.props, 'header');
	
	      return _react2['default'].createElement(
	        'li',
	        {
	          role: 'heading',
	          className: _classnames2['default'](headerClass, this.props.className),
	          style: this.props.style
	        },
	        this.props.children
	      );
	    }
	
	    var _props = this.props;
	    var className = _props.className;
	    var style = _props.style;
	    var onClick = _props.onClick;
	
	    var props = _objectWithoutProperties(_props, ['className', 'style', 'onClick']);
	
	    delete props.onSelect;
	
	    var classes = {
	      disabled: this.props.disabled,
	      active: this.props.active
	    };
	
	    return _react2['default'].createElement(
	      'li',
	      { role: 'presentation',
	        className: _classnames2['default'](className, classes),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], _extends({}, props, {
	        role: 'menuitem',
	        tabIndex: '-1',
	        onClick: _utilsCreateChainedFunction2['default'](onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return MenuItem;
	})(_react2['default'].Component);
	
	MenuItem.propTypes = {
	
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _react2['default'].PropTypes.bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _react2['default'].PropTypes.bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: _reactPropTypesLibAll2['default'](_react2['default'].PropTypes.bool, function (props) {
	    if (props.divider && props.children) {
	      return new Error('Children will not be rendered for dividers');
	    }
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _react2['default'].PropTypes.any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _react2['default'].PropTypes.bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _react2['default'].PropTypes.string,
	
	  /**
	   * HTML `target` attribute corresponding to `a.target`.
	   */
	  target: _react2['default'].PropTypes.string,
	
	  /**
	   * HTML `title` attribute corresponding to `a.title`.
	   */
	  title: _react2['default'].PropTypes.string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _react2['default'].PropTypes.func,
	
	  onKeyDown: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * HTML `id` attribute.
	   */
	  id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])
	};
	
	MenuItem.defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	exports['default'] = _utilsBootstrapUtils.bsClass('dropdown', MenuItem);
	module.exports = exports['default'];

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _Object$keys = __webpack_require__(56)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _domHelpersEvents = __webpack_require__(609);
	
	var _domHelpersEvents2 = _interopRequireDefault(_domHelpersEvents);
	
	var _domHelpersOwnerDocument = __webpack_require__(240);
	
	var _domHelpersOwnerDocument2 = _interopRequireDefault(_domHelpersOwnerDocument);
	
	var _domHelpersUtilInDOM = __webpack_require__(89);
	
	var _domHelpersUtilInDOM2 = _interopRequireDefault(_domHelpersUtilInDOM);
	
	var _domHelpersUtilScrollbarSize = __webpack_require__(619);
	
	var _domHelpersUtilScrollbarSize2 = _interopRequireDefault(_domHelpersUtilScrollbarSize);
	
	var _lodashCompatObjectPick = __webpack_require__(115);
	
	var _lodashCompatObjectPick2 = _interopRequireDefault(_lodashCompatObjectPick);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactOverlaysLibModal = __webpack_require__(817);
	
	var _reactOverlaysLibModal2 = _interopRequireDefault(_reactOverlaysLibModal);
	
	var _reactOverlaysLibUtilsIsOverflowing = __webpack_require__(328);
	
	var _reactOverlaysLibUtilsIsOverflowing2 = _interopRequireDefault(_reactOverlaysLibUtilsIsOverflowing);
	
	var _reactPropTypesLibDeprecated = __webpack_require__(121);
	
	var _reactPropTypesLibDeprecated2 = _interopRequireDefault(_reactPropTypesLibDeprecated);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _styleMaps = __webpack_require__(27);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _Fade = __webpack_require__(117);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalDialog = __webpack_require__(755);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalBody = __webpack_require__(303);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalHeader = __webpack_require__(305);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(306);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _ModalFooter = __webpack_require__(304);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	/* eslint-disable react/prop-types */
	var Modal = _react2['default'].createClass({
	  displayName: 'Modal',
	
	  propTypes: _extends({}, _reactOverlaysLibModal2['default'].propTypes, _ModalDialog2['default'].propTypes, {
	
	    /**
	     * Include a backdrop component. Specify 'static' for a backdrop that doesn't trigger an "onHide" when clicked.
	     */
	    backdrop: _react2['default'].PropTypes.oneOf(['static', true, false]),
	
	    /**
	     * Close the modal when escape key is pressed
	     */
	    keyboard: _react2['default'].PropTypes.bool,
	
	    /**
	     * Open and close the Modal with a slide and fade animation.
	     */
	    animation: _react2['default'].PropTypes.bool,
	
	    /**
	     * A Component type that provides the modal content Markup. This is a useful prop when you want to use your own
	     * styles and markup to create a custom modal component.
	     */
	    dialogComponentClass: _reactPropTypesLibElementType2['default'],
	
	    /**
	     * @private
	     */
	    dialogComponent: _reactPropTypesLibDeprecated2['default'](_reactPropTypesLibElementType2['default'], 'Use `dialogComponentClass`.'),
	
	    /**
	     * When `true` The modal will automatically shift focus to itself when it opens, and replace it to the last focused element when it closes.
	     * Generally this should never be set to false as it makes the Modal less accessible to assistive technologies, like screen-readers.
	     */
	    autoFocus: _react2['default'].PropTypes.bool,
	
	    /**
	     * When `true` The modal will prevent focus from leaving the Modal while open.
	     * Consider leaving the default value here, as it is necessary to make the Modal work well with assistive technologies,
	     * such as screen readers.
	     */
	    enforceFocus: _react2['default'].PropTypes.bool,
	
	    /**
	     * Hide this from automatic props documentation generation.
	     * @private
	     */
	    bsStyle: _react2['default'].PropTypes.string,
	
	    /**
	     * When `true` The modal will show itself.
	     */
	    show: _react2['default'].PropTypes.bool,
	
	    /**
	     * A callback fired when the header closeButton or non-static backdrop is
	     * clicked. Required if either are specified.
	     */
	    onHide: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired before the Modal transitions in
	     */
	    onEnter: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition in
	     */
	    onEntering: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning in
	     */
	    onEntered: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired right before the Modal transitions out
	     */
	    onExit: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition out
	     */
	    onExiting: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning out
	     */
	    onExited: _react2['default'].PropTypes.func
	  }),
	
	  childContextTypes: {
	    '$bs_onModalHide': _react2['default'].PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return _extends({}, _reactOverlaysLibModal2['default'].defaultProps, {
	      bsClass: 'modal',
	      animation: true,
	      dialogComponentClass: _ModalDialog2['default']
	    });
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      modalStyles: {}
	    };
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      $bs_onModalHide: this.props.onHide
	    };
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    _domHelpersEvents2['default'].off(window, 'resize', this.handleWindowResize);
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var className = _props.className;
	    var children = _props.children;
	    var dialogClassName = _props.dialogClassName;
	    var animation = _props.animation;
	
	    var props = _objectWithoutProperties(_props, ['className', 'children', 'dialogClassName', 'animation']);
	
	    var modalStyles = this.state.modalStyles;
	
	    var inClass = { 'in': props.show && !animation };
	    var Dialog = props.dialogComponent || props.dialogComponentClass;
	
	    var parentProps = _lodashCompatObjectPick2['default'](props, _Object$keys(_reactOverlaysLibModal2['default'].propTypes).concat(['onExit', 'onExiting', 'onEnter', 'onEntered']) // the rest are fired in _onHide() and _onShow()
	    );
	
	    var modal = _react2['default'].createElement(
	      Dialog,
	      _extends({
	        key: 'modal',
	        ref: function (ref) {
	          return _this._modal = ref;
	        }
	      }, props, {
	        style: modalStyles,
	        className: _classnames2['default'](className, inClass),
	        dialogClassName: dialogClassName,
	        onClick: props.backdrop === true ? this.handleDialogClick : null
	      }),
	      this.props.children
	    );
	
	    return _react2['default'].createElement(
	      _reactOverlaysLibModal2['default'],
	      _extends({}, parentProps, {
	        show: props.show,
	        ref: function (ref) {
	          _this._wrapper = ref && ref.refs.modal;
	          _this._backdrop = ref && ref.refs.backdrop;
	        },
	        onEntering: this._onShow,
	        onExited: this._onHide,
	        backdropClassName: _classnames2['default'](_utilsBootstrapUtils.prefix(props, 'backdrop'), inClass),
	        containerClassName: _utilsBootstrapUtils.prefix(props, 'open'),
	        transition: animation ? _Fade2['default'] : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      modal
	    );
	  },
	
	  _onShow: function _onShow() {
	    _domHelpersEvents2['default'].on(window, 'resize', this.handleWindowResize);
	
	    this.setState(this._getStyles());
	
	    if (this.props.onEntering) {
	      var _props2;
	
	      (_props2 = this.props).onEntering.apply(_props2, arguments);
	    }
	  },
	
	  _onHide: function _onHide() {
	    _domHelpersEvents2['default'].off(window, 'resize', this.handleWindowResize);
	
	    if (this.props.onExited) {
	      var _props3;
	
	      (_props3 = this.props).onExited.apply(_props3, arguments);
	    }
	  },
	
	  handleDialogClick: function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  },
	
	  handleWindowResize: function handleWindowResize() {
	    this.setState(this._getStyles());
	  },
	
	  _getStyles: function _getStyles() {
	    if (!_domHelpersUtilInDOM2['default']) {
	      return {};
	    }
	
	    var node = _reactDom2['default'].findDOMNode(this._modal);
	    var doc = _domHelpersOwnerDocument2['default'](node);
	
	    var scrollHt = node.scrollHeight;
	    var bodyIsOverflowing = _reactOverlaysLibUtilsIsOverflowing2['default'](_reactDom2['default'].findDOMNode(this.props.container || doc.body));
	    var modalIsOverflowing = scrollHt > doc.documentElement.clientHeight;
	
	    return {
	      modalStyles: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? _domHelpersUtilScrollbarSize2['default']() : void 0,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? _domHelpersUtilScrollbarSize2['default']() : void 0
	      }
	    };
	  }
	});
	
	Modal.Body = _ModalBody2['default'];
	Modal.Header = _ModalHeader2['default'];
	Modal.Title = _ModalTitle2['default'];
	Modal.Footer = _ModalFooter2['default'];
	
	Modal.Dialog = _ModalDialog2['default'];
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports['default'] = _utilsBootstrapUtils.bsSizes([_styleMaps.Sizes.LARGE, _styleMaps.Sizes.SMALL], _utilsBootstrapUtils.bsClass('modal', Modal));
	module.exports = exports['default'];

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styleMaps = __webpack_require__(27);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	/* eslint-disable react/prop-types */
	var ModalDialog = _react2['default'].createClass({
	  displayName: 'ModalDialog',
	
	  propTypes: {
	    /**
	     * A css class to apply to the Modal dialog DOM node.
	     */
	    dialogClassName: _react2['default'].PropTypes.string
	  },
	
	  render: function render() {
	    var modalStyle = _extends({
	      display: 'block'
	    }, this.props.style);
	    var bsClassPrefix = _utilsBootstrapUtils.prefix(this.props);
	    var dialogClasses = _utilsBootstrapUtils.getClassSet(this.props);
	
	    delete dialogClasses[bsClassPrefix];
	    dialogClasses[_utilsBootstrapUtils.prefix(this.props, 'dialog')] = true;
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        title: null,
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: _classnames2['default'](this.props.className, bsClassPrefix)
	      }),
	      _react2['default'].createElement(
	        'div',
	        { className: _classnames2['default'](this.props.dialogClassName, dialogClasses) },
	        _react2['default'].createElement(
	          'div',
	          { className: _utilsBootstrapUtils.prefix(this.props, 'content'), role: 'document' },
	          this.props.children
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsSizes([_styleMaps.Sizes.LARGE, _styleMaps.Sizes.SMALL], _utilsBootstrapUtils.bsClass('modal', ModalDialog));
	module.exports = exports['default'];

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dropdown = __webpack_require__(116);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var NavDropdown = (function (_React$Component) {
	  _inherits(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    _classCallCheck(this, NavDropdown);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  NavDropdown.prototype.render = function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var title = _props.title;
	    var noCaret = _props.noCaret;
	
	    var props = _objectWithoutProperties(_props, ['children', 'title', 'noCaret']);
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      _extends({}, props, { componentClass: 'li' }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        {
	          useAnchor: true,
	          disabled: props.disabled,
	          noCaret: noCaret
	        },
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return NavDropdown;
	})(_react2['default'].Component);
	
	NavDropdown.propTypes = _extends({
	  noCaret: _react2['default'].PropTypes.bool,
	  title: _react2['default'].PropTypes.node.isRequired
	}, _Dropdown2['default'].propTypes);
	
	exports['default'] = NavDropdown;
	module.exports = exports['default'];

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _uncontrollable = __webpack_require__(135);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _styleMaps = __webpack_require__(27);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _Grid = __webpack_require__(300);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _NavbarBrand = __webpack_require__(309);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _NavbarCollapse = __webpack_require__(758);
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	var _NavbarHeader = __webpack_require__(759);
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	var _NavbarToggle = __webpack_require__(760);
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	var Navbar = _react2['default'].createClass({
	  displayName: 'Navbar',
	
	  propTypes: {
	    /**
	     * Create a fixed navbar along the top of the screen, that scrolls with the page
	     */
	    fixedTop: _react2['default'].PropTypes.bool,
	    /**
	     * Create a fixed navbar along the bottom of the screen, that scrolls with the page
	     */
	    fixedBottom: _react2['default'].PropTypes.bool,
	    /**
	     * Create a full-width navbar that scrolls away with the page
	     */
	    staticTop: _react2['default'].PropTypes.bool,
	    /**
	     * An alternative dark visual style for the Navbar
	     */
	    inverse: _react2['default'].PropTypes.bool,
	    /**
	     * Allow the Navbar to fluidly adjust to the page or container width, instead of at the
	     * predefined screen breakpoints
	     */
	    fluid: _react2['default'].PropTypes.bool,
	
	    /**
	     * Set a custom element for this component.
	     */
	    componentClass: _reactPropTypesLibElementType2['default'],
	    /**
	     * A callback fired when the `<Navbar>` body collapses or expands.
	     * Fired when a `<Navbar.Toggle>` is clicked and called with the new `navExpanded` boolean value.
	     *
	     * @controllable navExpanded
	     */
	    onToggle: _react2['default'].PropTypes.func,
	
	    /**
	     * Explicitly set the visiblity of the navbar body
	     *
	     * @controllable onToggle
	     */
	    expanded: _react2['default'].PropTypes.bool
	
	  },
	
	  childContextTypes: {
	    $bs_navbar: _react.PropTypes.bool,
	    $bs_navbar_bsClass: _react.PropTypes.string,
	    $bs_navbar_onToggle: _react.PropTypes.func,
	    $bs_navbar_expanded: _react.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'nav',
	      fixedTop: false,
	      fixedBottom: false,
	      staticTop: false,
	      inverse: false,
	      fluid: false
	    };
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      $bs_navbar: true,
	      $bs_navbar_bsClass: this.props.bsClass,
	      $bs_navbar_onToggle: this.handleToggle,
	      $bs_navbar_expanded: this.props.expanded
	    };
	  },
	
	  handleToggle: function handleToggle() {
	    this.props.onToggle(!this.props.expanded);
	  },
	
	  isNavExpanded: function isNavExpanded() {
	    return !!this.props.expanded;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var fixedTop = _props.fixedTop;
	    var fixedBottom = _props.fixedBottom;
	    var staticTop = _props.staticTop;
	    var inverse = _props.inverse;
	    var ComponentClass = _props.componentClass;
	    var fluid = _props.fluid;
	    var className = _props.className;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'componentClass', 'fluid', 'className', 'children']);
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	    if (props.role === undefined && ComponentClass !== 'nav') {
	      props.role = 'navigation';
	    }
	
	    if (inverse) {
	      props.bsStyle = _styleMaps.INVERSE;
	    }
	
	    var classes = _utilsBootstrapUtils.getClassSet(props);
	
	    classes[_utilsBootstrapUtils.prefix(this.props, 'fixed-top')] = fixedTop;
	    classes[_utilsBootstrapUtils.prefix(this.props, 'fixed-bottom')] = fixedBottom;
	    classes[_utilsBootstrapUtils.prefix(this.props, 'static-top')] = staticTop;
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, props, { className: _classnames2['default'](className, classes) }),
	      _react2['default'].createElement(
	        _Grid2['default'],
	        { fluid: fluid },
	        children
	      )
	    );
	  }
	});
	
	var NAVBAR_STATES = [_styleMaps.DEFAULT, _styleMaps.INVERSE];
	
	Navbar = _utilsBootstrapUtils.bsStyles(NAVBAR_STATES, _styleMaps.DEFAULT, _utilsBootstrapUtils.bsClass('navbar', _uncontrollable2['default'](Navbar, { expanded: 'onToggle' })));
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var wrapper = function wrapper(_ref, _ref2) {
	    var Tag = _ref.componentClass;
	    var className = _ref.className;
	
	    var props = _objectWithoutProperties(_ref, ['componentClass', 'className']);
	
	    var _classNames;
	
	    var _ref2$$bs_navbar_bsClass = _ref2.$bs_navbar_bsClass;
	    var bsClass = _ref2$$bs_navbar_bsClass === undefined ? 'navbar' : _ref2$$bs_navbar_bsClass;
	    return _react2['default'].createElement(Tag, _extends({}, props, {
	      className: _classnames2['default'](className, _utilsBootstrapUtils.prefix({ bsClass: bsClass }, suffix), (_classNames = {}, _classNames[_utilsBootstrapUtils.prefix({ bsClass: bsClass }, 'right')] = props.pullRight, _classNames[_utilsBootstrapUtils.prefix({ bsClass: bsClass }, 'left')] = props.pullLeft, _classNames))
	    }));
	  };
	
	  wrapper.displayName = displayName;
	
	  wrapper.propTypes = {
	    componentClass: _reactPropTypesLibElementType2['default'],
	    pullRight: _react2['default'].PropTypes.bool,
	    pullLeft: _react2['default'].PropTypes.bool
	  };
	  wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	
	  wrapper.contextTypes = {
	    $bs_navbar_bsClass: _react.PropTypes.string
	  };
	
	  return wrapper;
	}
	
	Navbar.Brand = _NavbarBrand2['default'];
	Navbar.Header = _NavbarHeader2['default'];
	Navbar.Toggle = _NavbarToggle2['default'];
	Navbar.Collapse = _NavbarCollapse2['default'];
	
	Navbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	Navbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	Navbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');
	
	exports['default'] = Navbar;
	module.exports = exports['default'];

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _Collapse = __webpack_require__(175);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var NavbarCollapse = _react2['default'].createClass({
	  displayName: 'NavbarCollapse',
	
	  contextTypes: {
	    $bs_navbar_bsClass: _react.PropTypes.string,
	    $bs_navbar_expanded: _react.PropTypes.bool
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['children']);
	
	    var _context = this.context;
	    var _context$$bs_navbar_bsClass = _context.$bs_navbar_bsClass;
	    var bsClass = _context$$bs_navbar_bsClass === undefined ? 'navbar' : _context$$bs_navbar_bsClass;
	    var expanded = _context.$bs_navbar_expanded;
	
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      _extends({ 'in': expanded }, props),
	      _react2['default'].createElement(
	        'div',
	        { className: _utilsBootstrapUtils.prefix({ bsClass: bsClass }, 'collapse') },
	        children
	      )
	    );
	  }
	});
	
	exports['default'] = NavbarCollapse;
	module.exports = exports['default'];

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var NavbarHeader = _react2['default'].createClass({
	  displayName: 'NavbarHeader',
	
	  contextTypes: {
	    $bs_navbar_bsClass: _react.PropTypes.string
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    var _context$$bs_navbar_bsClass = this.context.$bs_navbar_bsClass;
	    var bsClass = _context$$bs_navbar_bsClass === undefined ? 'navbar' : _context$$bs_navbar_bsClass;
	
	    var headerClasses = _utilsBootstrapUtils.prefix({ bsClass: bsClass }, 'header');
	
	    return _react2['default'].createElement('div', _extends({}, props, { className: _classnames2['default'](className, headerClasses) }));
	  }
	});
	
	exports['default'] = NavbarHeader;
	module.exports = exports['default'];

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _utilsCreateChainedFunction = __webpack_require__(32);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var NavbarToggle = _react2['default'].createClass({
	  displayName: 'NavbarToggle',
	
	  propTypes: {
	    onClick: _react2['default'].PropTypes.func,
	    /**
	     * The toggle content, if left empty it will render the default toggle (seen above).
	     */
	    children: _react.PropTypes.node
	  },
	
	  contextTypes: {
	    $bs_navbar_bsClass: _react.PropTypes.string,
	    $bs_navbar_onToggle: _react.PropTypes.func,
	    $bs_navbar_expanded: _react.PropTypes.bool
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var onClick = _props.onClick;
	    var className = _props.className;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['onClick', 'className', 'children']);
	
	    var _context = this.context;
	    var _context$$bs_navbar_bsClass = _context.$bs_navbar_bsClass;
	    var bsClass = _context$$bs_navbar_bsClass === undefined ? 'navbar' : _context$$bs_navbar_bsClass;
	    var onToggle = _context.$bs_navbar_onToggle;
	    var expanded = _context.$bs_navbar_expanded;
	
	    var buttonProps = _extends({
	      type: 'button'
	    }, props, {
	      onClick: _utilsCreateChainedFunction2['default'](onClick, onToggle),
	      className: _classnames2['default'](className, _utilsBootstrapUtils.prefix({ bsClass: bsClass }, 'toggle'), !expanded && 'collapsed')
	    });
	
	    if (children) {
	      return _react2['default'].createElement(
	        'button',
	        buttonProps,
	        children
	      );
	    }
	
	    return _react2['default'].createElement(
	      'button',
	      buttonProps,
	      _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        'Toggle navigation'
	      ),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' })
	    );
	  }
	});
	
	exports['default'] = NavbarToggle;
	module.exports = exports['default'];

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable react/prop-types */
	
	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _Object$keys = __webpack_require__(56)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _domHelpersQueryContains = __webpack_require__(156);
	
	var _domHelpersQueryContains2 = _interopRequireDefault(_domHelpersQueryContains);
	
	var _lodashCompatObjectPick = __webpack_require__(115);
	
	var _lodashCompatObjectPick2 = _interopRequireDefault(_lodashCompatObjectPick);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__(310);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _utilsCreateChainedFunction = __webpack_require__(32);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var OverlayTrigger = _react2['default'].createClass({
	  displayName: 'OverlayTrigger',
	
	  propTypes: _extends({}, _Overlay2['default'].propTypes, {
	
	    /**
	    * Specify which action or actions trigger Overlay visibility
	    */
	    trigger: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.oneOf(['click', 'hover', 'focus']), _react2['default'].PropTypes.arrayOf(_react2['default'].PropTypes.oneOf(['click', 'hover', 'focus']))]),
	
	    /**
	     * A millisecond delay amount to show and hide the Overlay once triggered
	     */
	    delay: _react2['default'].PropTypes.number,
	    /**
	     * A millisecond delay amount before showing the Overlay once triggered.
	     */
	    delayShow: _react2['default'].PropTypes.number,
	    /**
	     * A millisecond delay amount before hiding the Overlay once triggered.
	     */
	    delayHide: _react2['default'].PropTypes.number,
	
	    /**
	     * The initial visibility state of the Overlay, for more nuanced visibility control consider
	     * using the Overlay component directly.
	     */
	    defaultOverlayShown: _react2['default'].PropTypes.bool,
	
	    /**
	     * An element or text to overlay next to the target.
	     */
	    overlay: _react2['default'].PropTypes.node.isRequired,
	
	    /**
	     * @private
	     */
	    onBlur: _react2['default'].PropTypes.func,
	    /**
	     * @private
	     */
	    onClick: _react2['default'].PropTypes.func,
	    /**
	     * @private
	     */
	    onFocus: _react2['default'].PropTypes.func,
	    /**
	     * @private
	     */
	    onMouseEnter: _react2['default'].PropTypes.func,
	    /**
	     * @private
	     */
	    onMouseLeave: _react2['default'].PropTypes.func,
	
	    // override specific overlay props
	    /**
	     * @private
	     */
	    target: function target() {},
	    /**
	    * @private
	    */
	    onHide: function onHide() {},
	    /**
	     * @private
	     */
	    show: function show() {}
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultOverlayShown: false,
	      trigger: ['hover', 'focus']
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isOverlayShown: this.props.defaultOverlayShown
	    };
	  },
	
	  show: function show() {
	    this.setState({
	      isOverlayShown: true
	    });
	  },
	
	  hide: function hide() {
	    this.setState({
	      isOverlayShown: false
	    });
	  },
	
	  toggle: function toggle() {
	    if (this.state.isOverlayShown) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.handleMouseOver = this.handleMouseOverOut.bind(null, this.handleDelayedShow);
	    this.handleMouseOut = this.handleMouseOverOut.bind(null, this.handleDelayedHide);
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  },
	
	  renderOverlay: function renderOverlay() {
	    _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    _reactDom2['default'].unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    if (this._mountNode) {
	      this.renderOverlay();
	    }
	  },
	
	  getOverlayTarget: function getOverlayTarget() {
	    return _reactDom2['default'].findDOMNode(this);
	  },
	
	  getOverlay: function getOverlay() {
	    var overlayProps = _extends({}, _lodashCompatObjectPick2['default'](this.props, _Object$keys(_Overlay2['default'].propTypes)), {
	      show: this.state.isOverlayShown,
	      onHide: this.hide,
	      target: this.getOverlayTarget,
	      onExit: this.props.onExit,
	      onExiting: this.props.onExiting,
	      onExited: this.props.onExited,
	      onEnter: this.props.onEnter,
	      onEntering: this.props.onEntering,
	      onEntered: this.props.onEntered
	    });
	
	    var overlay = _react.cloneElement(this.props.overlay, {
	      placement: overlayProps.placement,
	      container: overlayProps.container
	    });
	
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      overlayProps,
	      overlay
	    );
	  },
	
	  render: function render() {
	    var trigger = _react2['default'].Children.only(this.props.children);
	    var triggerProps = trigger.props;
	
	    var props = {
	      'aria-describedby': this.props.overlay.props.id
	    };
	
	    // create in render otherwise owner is lost...
	    this._overlay = this.getOverlay();
	
	    props.onClick = _utilsCreateChainedFunction2['default'](triggerProps.onClick, this.props.onClick);
	
	    if (isOneOf('click', this.props.trigger)) {
	      props.onClick = _utilsCreateChainedFunction2['default'](this.toggle, props.onClick);
	    }
	
	    if (isOneOf('hover', this.props.trigger)) {
	       false ? _warning2['default'](!(this.props.trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the visibilty of the overlay to just mouse users. ' + 'Consider also including the `"focus"` trigger so that touch and keyboard only users can see the overlay as well.') : undefined;
	
	      props.onMouseOver = _utilsCreateChainedFunction2['default'](this.handleMouseOver, this.props.onMouseOver, triggerProps.onMouseOver);
	      props.onMouseOut = _utilsCreateChainedFunction2['default'](this.handleMouseOut, this.props.onMouseOut, triggerProps.onMouseOut);
	    }
	
	    if (isOneOf('focus', this.props.trigger)) {
	      props.onFocus = _utilsCreateChainedFunction2['default'](this.handleDelayedShow, this.props.onFocus, triggerProps.onFocus);
	      props.onBlur = _utilsCreateChainedFunction2['default'](this.handleDelayedHide, this.props.onBlur, triggerProps.onBlur);
	    }
	
	    return _react.cloneElement(trigger, props);
	  },
	
	  handleDelayedShow: function handleDelayedShow() {
	    var _this = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.isOverlayShown || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this._hoverShowDelay = null;
	      _this.show();
	    }, delay);
	  },
	
	  handleDelayedHide: function handleDelayedHide() {
	    var _this2 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.isOverlayShown || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this2._hoverHideDelay = null;
	      _this2.hide();
	    }, delay);
	  },
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker moving
	  // from one child element to another.
	  handleMouseOverOut: function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if (!related || related !== target && !_domHelpersQueryContains2['default'](target, related)) {
	      handler(e);
	    }
	  }
	
	});
	
	exports['default'] = OverlayTrigger;
	module.exports = exports['default'];

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var PageHeader = _react2['default'].createClass({
	  displayName: 'PageHeader',
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'page-header') }),
	      _react2['default'].createElement(
	        'h1',
	        null,
	        this.props.children
	      )
	    );
	  }
	});
	
	exports['default'] = PageHeader;
	module.exports = exports['default'];

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SafeAnchor = __webpack_require__(47);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _utilsCreateChainedFunction = __webpack_require__(32);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var PageItem = _react2['default'].createClass({
	  displayName: 'PageItem',
	
	  propTypes: {
	    disabled: _react2['default'].PropTypes.bool,
	    previous: _react2['default'].PropTypes.bool,
	    next: _react2['default'].PropTypes.bool,
	    onClick: _react2['default'].PropTypes.func,
	    onSelect: _react2['default'].PropTypes.func,
	    eventKey: _react2['default'].PropTypes.any
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disabled: false,
	      previous: false,
	      next: false
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var disabled = _props.disabled;
	    var previous = _props.previous;
	    var next = _props.next;
	    var onClick = _props.onClick;
	    var className = _props.className;
	    var style = _props.style;
	
	    var props = _objectWithoutProperties(_props, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: _classnames2['default'](className, { disabled: disabled, previous: previous, next: next }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], _extends({}, props, {
	        disabled: disabled,
	        onClick: _utilsCreateChainedFunction2['default'](onClick, this.handleSelect)
	      }))
	    );
	  },
	
	  handleSelect: function handleSelect(e) {
	    if (this.props.onSelect || this.props.disabled) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, e);
	      }
	    }
	  }
	});
	
	exports['default'] = PageItem;
	module.exports = exports['default'];

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsValidComponentChildren = __webpack_require__(28);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _utilsCreateChainedFunction = __webpack_require__(32);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var Pager = _react2['default'].createClass({
	  displayName: 'Pager',
	
	  propTypes: {
	    onSelect: _react2['default'].PropTypes.func
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'ul',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, 'pager') }),
	      _utilsValidComponentChildren2['default'].map(this.props.children, this.renderPageItem)
	    );
	  },
	
	  renderPageItem: function renderPageItem(child, index) {
	    return _react.cloneElement(child, {
	      onSelect: _utilsCreateChainedFunction2['default'](child.props.onSelect, this.props.onSelect),
	      key: child.key ? child.key : index
	    });
	  }
	});
	
	exports['default'] = Pager;
	module.exports = exports['default'];

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _PaginationButton = __webpack_require__(766);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _SafeAnchor = __webpack_require__(47);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var Pagination = _react2['default'].createClass({
	  displayName: 'Pagination',
	
	  propTypes: {
	    activePage: _react2['default'].PropTypes.number,
	    items: _react2['default'].PropTypes.number,
	    maxButtons: _react2['default'].PropTypes.number,
	    /**
	     * When `true`, will display the first and the last button page
	     */
	    boundaryLinks: _react2['default'].PropTypes.bool,
	    /**
	     * When `true`, will display the default node value ('&hellip;').
	     * Otherwise, will display provided node (when specified).
	     */
	    ellipsis: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	    /**
	     * When `true`, will display the default node value ('&laquo;').
	     * Otherwise, will display provided node (when specified).
	     */
	    first: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	    /**
	     * When `true`, will display the default node value ('&raquo;').
	     * Otherwise, will display provided node (when specified).
	     */
	    last: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	    /**
	     * When `true`, will display the default node value ('&lsaquo;').
	     * Otherwise, will display provided node (when specified).
	     */
	    prev: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	    /**
	     * When `true`, will display the default node value ('&rsaquo;').
	     * Otherwise, will display provided node (when specified).
	     */
	    next: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	    onSelect: _react2['default'].PropTypes.func,
	    /**
	     * You can use a custom element for the buttons
	     */
	    buttonComponentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      activePage: 1,
	      items: 1,
	      maxButtons: 0,
	      first: false,
	      last: false,
	      prev: false,
	      next: false,
	      ellipsis: true,
	      boundaryLinks: false,
	      buttonComponentClass: _SafeAnchor2['default'],
	      bsClass: 'pagination'
	    };
	  },
	
	  renderPageButtons: function renderPageButtons() {
	    var pageButtons = [];
	    var startPage = undefined,
	        endPage = undefined,
	        hasHiddenPagesAfter = undefined;
	    var _props = this.props;
	    var maxButtons = _props.maxButtons;
	    var activePage = _props.activePage;
	    var items = _props.items;
	    var onSelect = _props.onSelect;
	    var ellipsis = _props.ellipsis;
	    var buttonComponentClass = _props.buttonComponentClass;
	    var boundaryLinks = _props.boundaryLinks;
	
	    if (maxButtons) {
	      var hiddenPagesBefore = activePage - parseInt(maxButtons / 2, 10);
	      startPage = hiddenPagesBefore > 1 ? hiddenPagesBefore : 1;
	      hasHiddenPagesAfter = startPage + maxButtons <= items;
	
	      if (!hasHiddenPagesAfter) {
	        endPage = items;
	        startPage = items - maxButtons + 1;
	        if (startPage < 1) {
	          startPage = 1;
	        }
	      } else {
	        endPage = startPage + maxButtons - 1;
	      }
	    } else {
	      startPage = 1;
	      endPage = items;
	    }
	
	    for (var pagenumber = startPage; pagenumber <= endPage; pagenumber++) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: pagenumber,
	          eventKey: pagenumber,
	          active: pagenumber === activePage,
	          onSelect: onSelect,
	          buttonComponentClass: buttonComponentClass
	        },
	        pagenumber
	      ));
	    }
	
	    if (boundaryLinks && ellipsis && startPage !== 1) {
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: 'ellipsisFirst',
	          disabled: true,
	          buttonComponentClass: buttonComponentClass
	        },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'More' },
	          this.props.ellipsis === true ? '…' : this.props.ellipsis
	        )
	      ));
	
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: 1,
	          eventKey: 1,
	          active: false,
	          onSelect: onSelect,
	          buttonComponentClass: buttonComponentClass
	        },
	        '1'
	      ));
	    }
	
	    if (maxButtons && hasHiddenPagesAfter && ellipsis) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: 'ellipsis',
	          disabled: true,
	          buttonComponentClass: buttonComponentClass
	        },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'More' },
	          this.props.ellipsis === true ? '…' : this.props.ellipsis
	        )
	      ));
	
	      if (boundaryLinks && endPage !== items) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          {
	            key: items,
	            eventKey: items,
	            active: false,
	            onSelect: onSelect,
	            buttonComponentClass: buttonComponentClass
	          },
	          items
	        ));
	      }
	    }
	
	    return pageButtons;
	  },
	
	  renderPrev: function renderPrev() {
	    if (!this.props.prev) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _PaginationButton2['default'],
	      {
	        key: 'prev',
	        eventKey: this.props.activePage - 1,
	        disabled: this.props.activePage === 1,
	        onSelect: this.props.onSelect,
	        buttonComponentClass: this.props.buttonComponentClass
	      },
	      _react2['default'].createElement(
	        'span',
	        { 'aria-label': 'Previous' },
	        this.props.prev === true ? '‹' : this.props.prev
	      )
	    );
	  },
	
	  renderNext: function renderNext() {
	    if (!this.props.next) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _PaginationButton2['default'],
	      {
	        key: 'next',
	        eventKey: this.props.activePage + 1,
	        disabled: this.props.activePage >= this.props.items,
	        onSelect: this.props.onSelect,
	        buttonComponentClass: this.props.buttonComponentClass
	      },
	      _react2['default'].createElement(
	        'span',
	        { 'aria-label': 'Next' },
	        this.props.next === true ? '›' : this.props.next
	      )
	    );
	  },
	
	  renderFirst: function renderFirst() {
	    if (!this.props.first) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _PaginationButton2['default'],
	      {
	        key: 'first',
	        eventKey: 1,
	        disabled: this.props.activePage === 1,
	        onSelect: this.props.onSelect,
	        buttonComponentClass: this.props.buttonComponentClass
	      },
	      _react2['default'].createElement(
	        'span',
	        { 'aria-label': 'First' },
	        this.props.first === true ? '«' : this.props.first
	      )
	    );
	  },
	
	  renderLast: function renderLast() {
	    if (!this.props.last) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _PaginationButton2['default'],
	      {
	        key: 'last',
	        eventKey: this.props.items,
	        disabled: this.props.activePage >= this.props.items,
	        onSelect: this.props.onSelect,
	        buttonComponentClass: this.props.buttonComponentClass
	      },
	      _react2['default'].createElement(
	        'span',
	        { 'aria-label': 'Last' },
	        this.props.last === true ? '»' : this.props.last
	      )
	    );
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'ul',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils.getClassSet(this.props))
	      }),
	      this.renderFirst(),
	      this.renderPrev(),
	      this.renderPageButtons(),
	      this.renderNext(),
	      this.renderLast()
	    );
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsClass('pagination', Pagination);
	module.exports = exports['default'];

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _utilsCreateChainedFunction = __webpack_require__(32);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var PaginationButton = _react2['default'].createClass({
	  displayName: 'PaginationButton',
	
	  propTypes: {
	    className: _react2['default'].PropTypes.string,
	    eventKey: _react2['default'].PropTypes.any,
	    onSelect: _react2['default'].PropTypes.func,
	    disabled: _react2['default'].PropTypes.bool,
	    active: _react2['default'].PropTypes.bool,
	    onClick: _react2['default'].PropTypes.func,
	    /**
	     * You can use a custom element for this component
	     */
	    buttonComponentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      active: false,
	      disabled: false
	    };
	  },
	
	  handleClick: function handleClick(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, event);
	    }
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var active = _props.active;
	    var disabled = _props.disabled;
	    var onClick = _props.onClick;
	    var ButtonComponentClass = _props.buttonComponentClass;
	    var className = _props.className;
	    var style = _props.style;
	
	    var props = _objectWithoutProperties(_props, ['active', 'disabled', 'onClick', 'buttonComponentClass', 'className', 'style']);
	
	    delete props.onSelect;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: _classnames2['default'](className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(ButtonComponentClass, _extends({}, props, {
	        disabled: disabled,
	        onClick: _utilsCreateChainedFunction2['default'](onClick, this.handleClick)
	      }))
	    );
	  }
	});
	
	exports['default'] = PaginationButton;
	module.exports = exports['default'];

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styleMaps = __webpack_require__(27);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _Collapse = __webpack_require__(175);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var Panel = _react2['default'].createClass({
	  displayName: 'Panel',
	
	  propTypes: {
	    collapsible: _react2['default'].PropTypes.bool,
	    onSelect: _react2['default'].PropTypes.func,
	    header: _react2['default'].PropTypes.node,
	    id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	    footer: _react2['default'].PropTypes.node,
	    defaultExpanded: _react2['default'].PropTypes.bool,
	    expanded: _react2['default'].PropTypes.bool,
	    eventKey: _react2['default'].PropTypes.any,
	    headerRole: _react2['default'].PropTypes.string,
	    panelRole: _react2['default'].PropTypes.string,
	
	    onEnter: _Collapse2['default'].propTypes.onEnter,
	    onEntering: _Collapse2['default'].propTypes.onEntering,
	    onEntered: _Collapse2['default'].propTypes.onEntered,
	    onExit: _Collapse2['default'].propTypes.onExit,
	    onExiting: _Collapse2['default'].propTypes.onExiting,
	    onExited: _Collapse2['default'].propTypes.onExited
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultExpanded: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      expanded: this.props.defaultExpanded
	    };
	  },
	
	  handleSelect: function handleSelect(e) {
	    e.persist();
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.handleToggle();
	    }
	  },
	
	  handleToggle: function handleToggle() {
	    this.setState({ expanded: !this.state.expanded });
	  },
	
	  isExpanded: function isExpanded() {
	    return this.props.expanded != null ? this.props.expanded : this.state.expanded;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var headerRole = _props.headerRole;
	    var panelRole = _props.panelRole;
	
	    var props = _objectWithoutProperties(_props, ['headerRole', 'panelRole']);
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils.getClassSet(this.props)),
	        id: this.props.collapsible ? null : this.props.id, onSelect: null
	      }),
	      this.renderHeading(headerRole),
	      this.props.collapsible ? this.renderCollapsibleBody(panelRole) : this.renderBody(),
	      this.renderFooter()
	    );
	  },
	
	  renderCollapsibleBody: function renderCollapsibleBody(panelRole) {
	    var collapseProps = {
	      onEnter: this.props.onEnter,
	      onEntering: this.props.onEntering,
	      onEntered: this.props.onEntered,
	      onExit: this.props.onExit,
	      onExiting: this.props.onExiting,
	      onExited: this.props.onExited,
	      'in': this.isExpanded()
	    };
	    var props = {
	      className: _utilsBootstrapUtils.prefix(this.props, 'collapse'),
	      id: this.props.id,
	      ref: 'panel',
	      'aria-hidden': !this.isExpanded()
	    };
	    if (panelRole) {
	      props.role = panelRole;
	    }
	
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      collapseProps,
	      _react2['default'].createElement(
	        'div',
	        props,
	        this.renderBody()
	      )
	    );
	  },
	
	  renderBody: function renderBody() {
	    var _this = this;
	
	    var allChildren = this.props.children;
	    var bodyElements = [];
	    var panelBodyChildren = [];
	    var bodyClass = _utilsBootstrapUtils.prefix(this.props, 'body');
	
	    function getProps() {
	      return { key: bodyElements.length };
	    }
	
	    function addPanelChild(child) {
	      bodyElements.push(_react.cloneElement(child, getProps()));
	    }
	
	    function addPanelBody(children) {
	      bodyElements.push(_react2['default'].createElement(
	        'div',
	        _extends({ className: bodyClass }, getProps()),
	        children
	      ));
	    }
	
	    function maybeRenderPanelBody() {
	      if (panelBodyChildren.length === 0) {
	        return;
	      }
	
	      addPanelBody(panelBodyChildren);
	      panelBodyChildren = [];
	    }
	
	    // Handle edge cases where we should not iterate through children.
	    if (!Array.isArray(allChildren) || allChildren.length === 0) {
	      if (this.shouldRenderFill(allChildren)) {
	        addPanelChild(allChildren);
	      } else {
	        addPanelBody(allChildren);
	      }
	    } else {
	      allChildren.forEach(function (child) {
	        if (_this.shouldRenderFill(child)) {
	          maybeRenderPanelBody();
	
	          // Separately add the filled element.
	          addPanelChild(child);
	        } else {
	          panelBodyChildren.push(child);
	        }
	      });
	
	      maybeRenderPanelBody();
	    }
	
	    return bodyElements;
	  },
	
	  shouldRenderFill: function shouldRenderFill(child) {
	    return _react2['default'].isValidElement(child) && child.props.fill != null;
	  },
	
	  renderHeading: function renderHeading(headerRole) {
	    var header = this.props.header;
	
	    if (!header) {
	      return null;
	    }
	
	    if (!_react2['default'].isValidElement(header) || Array.isArray(header)) {
	      header = this.props.collapsible ? this.renderCollapsibleTitle(header, headerRole) : header;
	    } else {
	      var className = _classnames2['default'](_utilsBootstrapUtils.prefix(this.props, 'title'), header.props.className);
	
	      if (this.props.collapsible) {
	        header = _react.cloneElement(header, {
	          className: className,
	          children: this.renderAnchor(header.props.children, headerRole)
	        });
	      } else {
	        header = _react.cloneElement(header, { className: className });
	      }
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: _utilsBootstrapUtils.prefix(this.props, 'heading') },
	      header
	    );
	  },
	
	  renderAnchor: function renderAnchor(header, headerRole) {
	    return _react2['default'].createElement(
	      'a',
	      {
	        href: '#' + (this.props.id || ''),
	        'aria-controls': this.props.collapsible ? this.props.id : null,
	        className: this.isExpanded() ? null : 'collapsed',
	        'aria-expanded': this.isExpanded(),
	        'aria-selected': this.isExpanded(),
	        onClick: this.handleSelect,
	        role: headerRole
	      },
	      header
	    );
	  },
	
	  renderCollapsibleTitle: function renderCollapsibleTitle(header, headerRole) {
	    return _react2['default'].createElement(
	      'h4',
	      { className: _utilsBootstrapUtils.prefix(this.props, 'title'), role: 'presentation' },
	      this.renderAnchor(header, headerRole)
	    );
	  },
	
	  renderFooter: function renderFooter() {
	    if (!this.props.footer) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: _utilsBootstrapUtils.prefix(this.props, 'footer') },
	      this.props.footer
	    );
	  }
	});
	
	var PANEL_STATES = _styleMaps.State.values().concat(_styleMaps.DEFAULT, _styleMaps.PRIMARY);
	
	exports['default'] = _utilsBootstrapUtils.bsStyles(PANEL_STATES, _styleMaps.DEFAULT, _utilsBootstrapUtils.bsClass('panel', Panel));
	module.exports = exports['default'];

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibIsRequiredForA11y = __webpack_require__(122);
	
	var _reactPropTypesLibIsRequiredForA11y2 = _interopRequireDefault(_reactPropTypesLibIsRequiredForA11y);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var Popover = _react2['default'].createClass({
	  displayName: 'Popover',
	
	  propTypes: {
	
	    /**
	     * An html id attribute, necessary for accessibility
	     * @type {string}
	     * @required
	     */
	    id: _reactPropTypesLibIsRequiredForA11y2['default'](_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	    /**
	     * Sets the direction the Popover is positioned towards.
	     */
	    placement: _react2['default'].PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	    /**
	     * The "left" position value for the Popover.
	     */
	    positionLeft: _react2['default'].PropTypes.number,
	    /**
	     * The "top" position value for the Popover.
	     */
	    positionTop: _react2['default'].PropTypes.number,
	    /**
	     * The "left" position value for the Popover arrow.
	     */
	    arrowOffsetLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	    /**
	     * The "top" position value for the Popover arrow.
	     */
	    arrowOffsetTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	    /**
	     * Title text
	     */
	    title: _react2['default'].PropTypes.node
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      placement: 'right',
	      bsClass: 'popover'
	    };
	  },
	
	  render: function render() {
	    var _classes;
	
	    var classes = (_classes = {}, _classes[_utilsBootstrapUtils.prefix(this.props)] = true, _classes[this.props.placement] = true, _classes);
	
	    var style = _extends({
	      left: this.props.positionLeft,
	      top: this.props.positionTop,
	      display: 'block'
	    }, this.props.style);
	
	    // eslint-disable-line react/prop-types
	    var arrowStyle = {
	      left: this.props.arrowOffsetLeft,
	      top: this.props.arrowOffsetTop
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({
	        role: 'tooltip'
	      }, this.props, {
	        className: _classnames2['default'](this.props.className, classes),
	        style: style,
	        title: null
	      }),
	      _react2['default'].createElement('div', { className: 'arrow', style: arrowStyle }),
	      this.props.title ? this.renderTitle() : null,
	      _react2['default'].createElement(
	        'div',
	        { className: _utilsBootstrapUtils.prefix(this.props, 'content') },
	        this.props.children
	      )
	    );
	  },
	
	  renderTitle: function renderTitle() {
	    return _react2['default'].createElement(
	      'h3',
	      { className: _utilsBootstrapUtils.prefix(this.props, 'title') },
	      this.props.title
	    );
	  }
	});
	
	exports['default'] = Popover;
	module.exports = exports['default'];
	// we don't want to expose the `style` property

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styleMaps = __webpack_require__(27);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _utilsDeprecationWarning = __webpack_require__(91);
	
	var _utilsDeprecationWarning2 = _interopRequireDefault(_utilsDeprecationWarning);
	
	var _utilsValidComponentChildren = __webpack_require__(28);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _Interpolate = __webpack_require__(301);
	
	var _Interpolate2 = _interopRequireDefault(_Interpolate);
	
	/**
	 * Custom propTypes checker
	 */
	function onlyProgressBar(props, propName, componentName) {
	  if (props[propName]) {
	    var _ret = (function () {
	      var error = undefined,
	          childIdentifier = undefined;
	
	      _react2['default'].Children.forEach(props[propName], function (child) {
	        if (child.type !== ProgressBar) {
	          //eslint-disable-line
	          childIdentifier = child.type.displayName ? child.type.displayName : child.type;
	          error = new Error('Children of ' + componentName + ' can contain only ProgressBar components. Found ' + childIdentifier);
	        }
	      });
	
	      return {
	        v: error
	      };
	    })();
	
	    if (typeof _ret === 'object') return _ret.v;
	  }
	}
	
	var ProgressBar = (function (_React$Component) {
	  _inherits(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    _classCallCheck(this, ProgressBar);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ProgressBar.prototype.getPercentage = function getPercentage(now, min, max) {
	    var roundPrecision = 1000;
	    return Math.round((now - min) / (max - min) * 100 * roundPrecision) / roundPrecision;
	  };
	
	  ProgressBar.prototype.render = function render() {
	    if (this.props.isChild) {
	      return this.renderProgressBar();
	    }
	
	    var content = undefined;
	
	    if (this.props.children) {
	      content = _utilsValidComponentChildren2['default'].map(this.props.children, this.renderChildBar);
	    } else {
	      content = this.renderProgressBar();
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, 'progress'),
	        min: null,
	        max: null,
	        label: null,
	        'aria-valuetext': null
	      }),
	      content
	    );
	  };
	
	  ProgressBar.prototype.renderChildBar = function renderChildBar(child, index) {
	    return _react.cloneElement(child, {
	      isChild: true,
	      key: child.key ? child.key : index
	    });
	  };
	
	  ProgressBar.prototype.renderProgressBar = function renderProgressBar() {
	    var _classNames;
	
	    var _props = this.props;
	    var className = _props.className;
	    var label = _props.label;
	    var now = _props.now;
	    var min = _props.min;
	    var max = _props.max;
	    var style = _props.style;
	
	    var props = _objectWithoutProperties(_props, ['className', 'label', 'now', 'min', 'max', 'style']);
	
	    var percentage = this.getPercentage(now, min, max);
	
	    if (typeof label === 'string') {
	      label = this.renderLabel(percentage);
	    }
	
	    if (this.props.srOnly) {
	      label = _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      );
	    }
	
	    var classes = _classnames2['default'](className, _utilsBootstrapUtils.getClassSet(this.props), (_classNames = {
	      active: this.props.active
	    }, _classNames[_utilsBootstrapUtils.prefix(this.props, 'striped')] = this.props.active || this.props.striped, _classNames));
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, props, {
	        className: classes,
	        role: 'progressbar',
	        style: _extends({ width: percentage + '%' }, style),
	        'aria-valuenow': this.props.now,
	        'aria-valuemin': this.props.min,
	        'aria-valuemax': this.props.max
	      }),
	      label
	    );
	  };
	
	  ProgressBar.prototype.renderLabel = function renderLabel(percentage) {
	    var _props2 = this.props;
	    var interpolateClass = _props2.interpolateClass;
	    var now = _props2.now;
	    var min = _props2.min;
	    var max = _props2.max;
	    var bsStyle = _props2.bsStyle;
	    var label = _props2.label;
	
	    var InterpolateClass = interpolateClass || _Interpolate2['default'];
	
	    var REGEXP = InterpolateClass.REGEXP;
	
	    if (REGEXP && REGEXP.exec(label)) {
	      _utilsDeprecationWarning2['default']('String interpolation in <ProgressBar label>', 'ES2015 template strings or other patterns');
	    }
	
	    return _react2['default'].createElement(
	      InterpolateClass,
	      {
	        now: now,
	        min: min,
	        max: max,
	        percent: percentage,
	        bsStyle: bsStyle
	      },
	      label
	    );
	  };
	
	  return ProgressBar;
	})(_react2['default'].Component);
	
	ProgressBar.propTypes = {
	  min: _react.PropTypes.number,
	  now: _react.PropTypes.number,
	  max: _react.PropTypes.number,
	  label: _react.PropTypes.node,
	  srOnly: _react.PropTypes.bool,
	  striped: _react.PropTypes.bool,
	  active: _react.PropTypes.bool,
	  children: onlyProgressBar,
	  className: _react2['default'].PropTypes.string,
	  interpolateClass: _react.PropTypes.node,
	  /**
	   * @private
	   */
	  isChild: _react.PropTypes.bool
	};
	
	ProgressBar.defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	exports['default'] = _utilsBootstrapUtils.bsStyles(_styleMaps.State.values(), _utilsBootstrapUtils.bsClass('progress-bar', ProgressBar));
	module.exports = exports['default'];

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var propTypes = {
	  inline: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error']),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Radio inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Radio = (function (_React$Component) {
	  _inherits(Radio, _React$Component);
	
	  function Radio() {
	    _classCallCheck(this, Radio);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Radio.prototype.render = function render() {
	    var _props = this.props;
	    var inline = _props.inline;
	    var disabled = _props.disabled;
	    var validationState = _props.validationState;
	    var inputRef = _props.inputRef;
	    var className = _props.className;
	    var style = _props.style;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    delete props.bsClass;
	
	    var input = _react2['default'].createElement('input', _extends({}, props, {
	      ref: inputRef,
	      type: 'radio',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes;
	
	      var _classes2 = (_classes = {}, _classes[_utilsBootstrapUtils.prefix(this.props, 'inline')] = true, _classes.disabled = disabled, _classes);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? _warning2['default'](!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : undefined;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: _classnames2['default'](className, _classes2), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = _extends({}, _utilsBootstrapUtils.getClassSet(this.props), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: _classnames2['default'](className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Radio;
	})(_react2['default'].Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	
	exports['default'] = _utilsBootstrapUtils.bsClass('radio', Radio);
	module.exports = exports['default'];

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var ResponsiveEmbed = (function (_React$Component) {
	  _inherits(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    _classCallCheck(this, ResponsiveEmbed);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ResponsiveEmbed.prototype.render = function render() {
	    var _props = this.props;
	    var bsClass = _props.bsClass;
	    var className = _props.className;
	    var a16by9 = _props.a16by9;
	    var a4by3 = _props.a4by3;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['bsClass', 'className', 'a16by9', 'a4by3', 'children']);
	
	     false ? _warning2['default'](!(!a16by9 && !a4by3), '`a16by9` or `a4by3` attribute must be set.') : undefined;
	     false ? _warning2['default'](!(a16by9 && a4by3), 'Either `a16by9` or `a4by3` attribute can be set. Not both.') : undefined;
	
	    var aspectRatio = {
	      'embed-responsive-16by9': a16by9,
	      'embed-responsive-4by3': a4by3
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      { className: _classnames2['default'](bsClass, aspectRatio) },
	      _react.cloneElement(children, _extends({}, props, {
	        className: _classnames2['default'](className, 'embed-responsive-item')
	      }))
	    );
	  };
	
	  return ResponsiveEmbed;
	})(_react2['default'].Component);
	
	ResponsiveEmbed.defaultProps = {
	  bsClass: 'embed-responsive',
	  a16by9: false,
	  a4by3: false
	};
	
	ResponsiveEmbed.propTypes = {
	  /**
	   * bootstrap className
	   * @private
	   */
	  bsClass: _react.PropTypes.string,
	  /**
	   * This component accepts only one child element
	   */
	  children: _react.PropTypes.element.isRequired,
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _react.PropTypes.bool,
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _react.PropTypes.bool
	};
	
	exports['default'] = ResponsiveEmbed;
	module.exports = exports['default'];

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibElementType = __webpack_require__(20);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var Row = _react2['default'].createClass({
	  displayName: 'Row',
	
	  propTypes: {
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div'
	    };
	  },
	
	  render: function render() {
	    var ComponentClass = this.props.componentClass;
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'row') }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Row;
	module.exports = exports['default'];

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _Object$keys = __webpack_require__(56)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(65);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__(116);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__(774);
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _lodashCompatObjectOmit = __webpack_require__(171);
	
	var _lodashCompatObjectOmit2 = _interopRequireDefault(_lodashCompatObjectOmit);
	
	var _lodashCompatObjectPick = __webpack_require__(115);
	
	var _lodashCompatObjectPick2 = _interopRequireDefault(_lodashCompatObjectPick);
	
	var SplitButton = (function (_React$Component) {
	  _inherits(SplitButton, _React$Component);
	
	  function SplitButton() {
	    _classCallCheck(this, SplitButton);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  SplitButton.prototype.render = function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var title = _props.title;
	    var onClick = _props.onClick;
	    var target = _props.target;
	    var href = _props.href;
	    var toggleLabel = _props.toggleLabel;
	    var bsSize = _props.bsSize;
	    var bsStyle = _props.bsStyle;
	
	    var props = _objectWithoutProperties(_props, ['children', 'title', 'onClick', 'target', 'href', 'toggleLabel', 'bsSize', 'bsStyle']);
	
	    var disabled = props.disabled;
	
	    var dropdownProps = _lodashCompatObjectPick2['default'](props, _Object$keys(_Dropdown2['default'].ControlledComponent.propTypes));
	    var buttonProps = _lodashCompatObjectOmit2['default'](props, _Object$keys(_Dropdown2['default'].ControlledComponent.propTypes));
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      dropdownProps,
	      _react2['default'].createElement(
	        _Button2['default'],
	        _extends({}, buttonProps, {
	          onClick: onClick,
	          bsStyle: bsStyle,
	          bsSize: bsSize,
	          disabled: disabled,
	          target: target,
	          href: href
	        }),
	        title
	      ),
	      _react2['default'].createElement(_SplitToggle2['default'], {
	        'aria-label': toggleLabel || title,
	        bsStyle: bsStyle,
	        bsSize: bsSize,
	        disabled: disabled
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return SplitButton;
	})(_react2['default'].Component);
	
	SplitButton.propTypes = _extends({}, _Dropdown2['default'].propTypes, {
	  bsStyle: _Button2['default'].propTypes.bsStyle,
	
	  /**
	   * @private
	   */
	  onClick: function onClick() {},
	  target: _react2['default'].PropTypes.string,
	  href: _react2['default'].PropTypes.string,
	  /**
	   * The content of the split button.
	   */
	  title: _react2['default'].PropTypes.node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _react2['default'].PropTypes.string
	});
	
	SplitButton.defaultProps = {
	  disabled: false,
	  dropup: false,
	  pullRight: false
	};
	
	SplitButton.Toggle = _SplitToggle2['default'];
	
	exports['default'] = SplitButton;
	module.exports = exports['default'];

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownToggle = __webpack_require__(298);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var SplitToggle = (function (_React$Component) {
	  _inherits(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    _classCallCheck(this, SplitToggle);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  SplitToggle.prototype.render = function render() {
	    return _react2['default'].createElement(_DropdownToggle2['default'], _extends({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	})(_react2['default'].Component);
	
	exports['default'] = SplitToggle;
	
	SplitToggle.defaultProps = _DropdownToggle2['default'].defaultProps;
	module.exports = exports['default'];

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabPane = __webpack_require__(312);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	var _TabContainer = __webpack_require__(178);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(179);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var Tab = (function (_React$Component) {
	  _inherits(Tab, _React$Component);
	
	  function Tab() {
	    _classCallCheck(this, Tab);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Tab.prototype.render = function render() {
	    var _props = this.props;
	    var title = _props.title;
	    var disabled = _props.disabled;
	    var tabClassName = _props.tabClassName;
	
	    var props = _objectWithoutProperties(_props, ['title', 'disabled', 'tabClassName']);
	
	    return _react2['default'].createElement(_TabPane2['default'], props);
	  };
	
	  return Tab;
	})(_react2['default'].Component);
	
	Tab.propTypes = _extends({}, _TabPane2['default'].propTypes, {
	
	  disabled: _react2['default'].PropTypes.bool,
	
	  title: _react2['default'].PropTypes.node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _react2['default'].PropTypes.string
	});
	
	Tab.Container = _TabContainer2['default'];
	Tab.Content = _TabContent2['default'];
	Tab.Pane = _TabPane2['default'];
	
	exports['default'] = Tab;
	module.exports = exports['default'];

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Table = _react2['default'].createClass({
	  displayName: 'Table',
	
	  propTypes: {
	    striped: _react2['default'].PropTypes.bool,
	    bordered: _react2['default'].PropTypes.bool,
	    condensed: _react2['default'].PropTypes.bool,
	    hover: _react2['default'].PropTypes.bool,
	    responsive: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bordered: false,
	      condensed: false,
	      hover: false,
	      responsive: false,
	      striped: false
	    };
	  },
	
	  render: function render() {
	    var classes = {
	      'table': true,
	      'table-striped': this.props.striped,
	      'table-bordered': this.props.bordered,
	      'table-condensed': this.props.condensed,
	      'table-hover': this.props.hover
	    };
	    var table = _react2['default'].createElement(
	      'table',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	
	    return this.props.responsive ? _react2['default'].createElement(
	      'div',
	      { className: 'table-responsive' },
	      table
	    ) : table;
	  }
	});
	
	exports['default'] = Table;
	module.exports = exports['default'];

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _objectWithoutProperties = __webpack_require__(11)['default'];
	
	var _Object$keys = __webpack_require__(56)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _uncontrollable = __webpack_require__(135);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Col = __webpack_require__(297);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _Nav = __webpack_require__(307);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(308);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _styleMaps = __webpack_require__(27);
	
	var _styleMaps2 = _interopRequireDefault(_styleMaps);
	
	var _reactPropTypesLibIsRequiredForA11y = __webpack_require__(122);
	
	var _reactPropTypesLibIsRequiredForA11y2 = _interopRequireDefault(_reactPropTypesLibIsRequiredForA11y);
	
	var _utilsDeprecationWarning = __webpack_require__(91);
	
	var _utilsDeprecationWarning2 = _interopRequireDefault(_utilsDeprecationWarning);
	
	var _utilsValidComponentChildren = __webpack_require__(28);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _TabContainer = __webpack_require__(178);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(179);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var TabContainer = _TabContainer2['default'].ControlledComponent;
	
	function getDefaultActiveKeyFromChildren(children) {
	  var defaultActiveKey = undefined;
	  _utilsValidComponentChildren2['default'].forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	  return defaultActiveKey;
	}
	
	var Tabs = _react2['default'].createClass({
	  displayName: 'Tabs',
	
	  propTypes: {
	
	    /**
	     * Mark the Tab with a matching `eventKey` as active.
	     *
	     * @controllable onSelect
	     */
	    activeKey: _react2['default'].PropTypes.any,
	
	    /**
	     * Navigation style for tabs
	     *
	     * If not specified, it will be treated as `'tabs'` when vertically
	     * positioned and `'pills'` when horizontally positioned.
	     */
	    bsStyle: _react2['default'].PropTypes.oneOf(['tabs', 'pills']),
	
	    animation: _react2['default'].PropTypes.bool,
	
	    id: _reactPropTypesLibIsRequiredForA11y2['default'](_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	    /**
	     * Callback fired when a Tab is selected.
	     *
	     * ```js
	     * function (
	     * 	Any eventKey,
	     * 	SyntheticEvent event?
	     * )
	     * ```
	     *
	     * @controllable activeKey
	     */
	    onSelect: _react2['default'].PropTypes.func,
	
	    /**
	     * Unmount tabs (remove it from the DOM) when it is no longer visible
	     */
	    unmountOnExit: _react2['default'].PropTypes.bool,
	
	    /**
	     * @deprecated Use TabContainer to create differently shaped tab layouts.
	     */
	    position: _react2['default'].PropTypes.oneOf(['top', 'left', 'right']),
	
	    /**
	     * Number of grid columns for the tabs if horizontally positioned
	     *
	     * This accepts either a single width or a mapping of size to width.
	     *
	     * @deprecated Use TabContainer to create differently shaped tab layouts.
	     */
	    tabWidth: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.object]),
	    /**
	     * Number of grid columns for the panes if horizontally positioned
	     *
	     * This accepts either a single width or a mapping of size to width. If not
	     * specified, it will be treated as `styleMaps.GRID_COLUMNS` minus
	     * `tabWidth`.
	     *
	     * @deprecated Use TabContainer to create differently shaped tab layouts.
	     */
	    paneWidth: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.object]),
	    /**
	     * Render without clearfix if horizontally positioned
	     *
	     * @deprecated Use TabContainer to create differently shaped tab layouts.
	     */
	    standalone: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'tab',
	      animation: true,
	      tabWidth: 2,
	      position: 'top',
	      standalone: false,
	      unmountOnExit: false
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var id = _props.id;
	    var className = _props.className;
	    var style = _props.style;
	    var position = _props.position;
	    var bsStyle = _props.bsStyle;
	    var tabWidth = _props.tabWidth;
	    var paneWidth = _props.paneWidth;
	    var standalone = _props.standalone;
	    var children = _props.children;
	    var onSelect = _props.onSelect;
	    var activeKey = _props.activeKey;
	
	    var props = _objectWithoutProperties(_props, ['id', 'className', 'style', 'position', 'bsStyle', 'tabWidth', 'paneWidth', 'standalone', 'children', 'onSelect', 'activeKey']);
	
	    activeKey = this.getActiveKey();
	
	    var isHorizontal = position === 'left' || position === 'right';
	
	    if (bsStyle == null) {
	      bsStyle = isHorizontal ? 'pills' : 'tabs';
	    }
	
	    var containerProps = { id: id, className: className, style: style, activeKey: activeKey, onSelect: onSelect };
	
	    var tabsProps = _extends({}, props, {
	      bsStyle: bsStyle,
	      bsClass: undefined,
	      stacked: isHorizontal,
	      ref: 'tabs',
	      role: 'tablist'
	    });
	
	    var childTabs = _utilsValidComponentChildren2['default'].map(children, this.renderTab);
	
	    var panesProps = {
	      ref: 'panes',
	      animation: props.animation,
	      unmountOnExit: props.unmountOnExit
	    };
	
	    var childPanes = children;
	
	    if (isHorizontal) {
	      _utilsDeprecationWarning2['default']({
	        message: 'Horizontal Tabs (position "left" or "right") are deprecated in favor ' + 'of the more flexible TabContainer component.'
	      });
	
	      if (!standalone) {
	        containerProps.className = _classnames2['default'](containerProps.className, 'clearfix');
	      }
	
	      var _getColProps = this.getColProps({ tabWidth: tabWidth, paneWidth: paneWidth });
	
	      var tabsColProps = _getColProps.tabsColProps;
	      var panesColProps = _getColProps.panesColProps;
	
	      var tabs = _react2['default'].createElement(
	        _Col2['default'],
	        _extends({ componentClass: _Nav2['default'] }, tabsProps, tabsColProps),
	        childTabs
	      );
	      var panes = _react2['default'].createElement(
	        _Col2['default'],
	        _extends({ componentClass: _TabContent2['default'] }, panesProps, panesColProps),
	        childPanes
	      );
	
	      if (position === 'left') {
	        return _react2['default'].createElement(
	          TabContainer,
	          containerProps,
	          _react2['default'].createElement(
	            'div',
	            null,
	            tabs,
	            panes
	          )
	        );
	      }
	
	      return _react2['default'].createElement(
	        TabContainer,
	        containerProps,
	        _react2['default'].createElement(
	          'div',
	          null,
	          panes,
	          tabs
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      TabContainer,
	      containerProps,
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _Nav2['default'],
	          tabsProps,
	          childTabs
	        ),
	        _react2['default'].createElement(
	          _TabContent2['default'],
	          panesProps,
	          childPanes
	        )
	      )
	    );
	  },
	
	  getActiveKey: function getActiveKey() {
	    var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	    var activeKey = props.activeKey;
	    var children = props.children;
	
	    return activeKey === undefined ? getDefaultActiveKeyFromChildren(children) : activeKey;
	  },
	
	  renderPane: function renderPane(child, index) {
	    return _react.cloneElement(child, {
	      key: child.key ? child.key : index
	    });
	  },
	
	  renderTab: function renderTab(child) {
	    if (child.props.title == null) {
	      return null;
	    }
	
	    var _child$props = child.props;
	    var eventKey = _child$props.eventKey;
	    var title = _child$props.title;
	    var disabled = _child$props.disabled;
	    var tabClassName = _child$props.tabClassName;
	
	    return _react2['default'].createElement(
	      _NavItem2['default'],
	      {
	        eventKey: eventKey,
	        disabled: disabled,
	        className: tabClassName
	      },
	      title
	    );
	  },
	
	  getColProps: function getColProps(_ref) {
	    var tabWidth = _ref.tabWidth;
	    var paneWidth = _ref.paneWidth;
	
	    var tabsColProps = undefined;
	    if (tabWidth instanceof Object) {
	      tabsColProps = tabWidth;
	    } else {
	      tabsColProps = { xs: tabWidth };
	    }
	
	    var panesColProps = undefined;
	    if (paneWidth == null) {
	      panesColProps = {};
	      _Object$keys(tabsColProps).forEach(function (size) {
	        panesColProps[size] = _styleMaps2['default'].GRID_COLUMNS - tabsColProps[size];
	      });
	    } else if (paneWidth instanceof Object) {
	      panesColProps = paneWidth;
	    } else {
	      panesColProps = { xs: paneWidth };
	    }
	
	    return { tabsColProps: tabsColProps, panesColProps: panesColProps };
	  }
	
	});
	
	exports['default'] = _uncontrollable2['default'](Tabs, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var _SafeAnchor = __webpack_require__(47);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var Thumbnail = _react2['default'].createClass({
	  displayName: 'Thumbnail',
	
	  propTypes: {
	    alt: _react2['default'].PropTypes.string,
	    href: _react2['default'].PropTypes.string,
	    src: _react2['default'].PropTypes.string
	  },
	
	  render: function render() {
	    var classes = _utilsBootstrapUtils.getClassSet(this.props);
	
	    if (this.props.href) {
	      return _react2['default'].createElement(
	        _SafeAnchor2['default'],
	        _extends({}, this.props, { href: this.props.href, className: _classnames2['default'](this.props.className, classes) }),
	        _react2['default'].createElement('img', { src: this.props.src, alt: this.props.alt })
	      );
	    }
	
	    if (this.props.children) {
	      return _react2['default'].createElement(
	        'div',
	        _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	        _react2['default'].createElement('img', { src: this.props.src, alt: this.props.alt }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'caption' },
	          this.props.children
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      _react2['default'].createElement('img', { src: this.props.src, alt: this.props.alt })
	    );
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsClass('thumbnail', Thumbnail);
	module.exports = exports['default'];

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibIsRequiredForA11y = __webpack_require__(122);
	
	var _reactPropTypesLibIsRequiredForA11y2 = _interopRequireDefault(_reactPropTypesLibIsRequiredForA11y);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var Tooltip = _react2['default'].createClass({
	  displayName: 'Tooltip',
	
	  propTypes: {
	    /**
	     * An html id attribute, necessary for accessibility
	     * @type {string}
	     * @required
	     */
	    id: _reactPropTypesLibIsRequiredForA11y2['default'](_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	    /**
	     * Sets the direction the Tooltip is positioned towards.
	     */
	    placement: _react2['default'].PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	    /**
	     * The "left" position value for the Tooltip.
	     */
	    positionLeft: _react2['default'].PropTypes.number,
	    /**
	     * The "top" position value for the Tooltip.
	     */
	    positionTop: _react2['default'].PropTypes.number,
	    /**
	     * The "left" position value for the Tooltip arrow.
	     */
	    arrowOffsetLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	    /**
	     * The "top" position value for the Tooltip arrow.
	     */
	    arrowOffsetTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	    /**
	     * Title text
	     */
	    title: _react2['default'].PropTypes.node
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'tooltip',
	      placement: 'right'
	    };
	  },
	
	  render: function render() {
	    var _classes;
	
	    var classes = (_classes = {}, _classes[_utilsBootstrapUtils.prefix(this.props)] = true, _classes[this.props.placement] = true, _classes);
	
	    var style = _extends({
	      left: this.props.positionLeft,
	      top: this.props.positionTop
	    }, this.props.style);
	
	    var arrowStyle = {
	      left: this.props.arrowOffsetLeft,
	      top: this.props.arrowOffsetTop
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({
	        role: 'tooltip'
	      }, this.props, {
	        className: _classnames2['default'](this.props.className, classes),
	        style: style
	      }),
	      _react2['default'].createElement('div', { className: _utilsBootstrapUtils.prefix(this.props, 'arrow'), style: arrowStyle }),
	      _react2['default'].createElement(
	        'div',
	        { className: _utilsBootstrapUtils.prefix(this.props, 'inner') },
	        this.props.children
	      )
	    );
	  }
	});
	
	exports['default'] = Tooltip;
	module.exports = exports['default'];

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(13)['default'];
	
	var _classCallCheck = __webpack_require__(12)['default'];
	
	var _extends = __webpack_require__(5)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styleMaps = __webpack_require__(27);
	
	var _utilsBootstrapUtils = __webpack_require__(10);
	
	var Well = (function (_React$Component) {
	  _inherits(Well, _React$Component);
	
	  function Well() {
	    _classCallCheck(this, _Well);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Well.prototype.render = function render() {
	    var classes = _utilsBootstrapUtils.getClassSet(this.props);
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	  };
	
	  var _Well = Well;
	  Well = _utilsBootstrapUtils.bsSizes([_styleMaps.Sizes.LARGE, _styleMaps.Sizes.SMALL])(Well) || Well;
	  Well = _utilsBootstrapUtils.bsClass('well')(Well) || Well;
	  return Well;
	})(_react2['default'].Component);
	
	exports['default'] = Well;
	module.exports = exports['default'];

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _reactPropTypesLibCommon = __webpack_require__(188);
	
	var _childrenToArray = __webpack_require__(783);
	
	var _childrenToArray2 = _interopRequireDefault(_childrenToArray);
	
	exports['default'] = {
	
	  requiredRoles: function requiredRoles() {
	    for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
	      roles[_key] = arguments[_key];
	    }
	
	    return _reactPropTypesLibCommon.createChainableTypeChecker(function requiredRolesValidator(props, propName, component) {
	      var missing = undefined;
	      var children = _childrenToArray2['default'](props.children);
	
	      var inRole = function inRole(role, child) {
	        return role === child.props.bsRole;
	      };
	
	      roles.every(function (role) {
	        if (!children.some(function (child) {
	          return inRole(role, child);
	        })) {
	          missing = role;
	          return false;
	        }
	        return true;
	      });
	
	      if (missing) {
	        return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + missing + '. ' + (component + ' must have at least one child of each of the following bsRoles: ' + roles.join(', ')));
	      }
	    });
	  },
	
	  exclusiveRoles: function exclusiveRoles() {
	    for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      roles[_key2] = arguments[_key2];
	    }
	
	    return _reactPropTypesLibCommon.createChainableTypeChecker(function exclusiveRolesValidator(props, propName, component) {
	      var children = _childrenToArray2['default'](props.children);
	      var duplicate = undefined;
	
	      roles.every(function (role) {
	        var childrenWithRole = children.filter(function (child) {
	          return child.props.bsRole === role;
	        });
	
	        if (childrenWithRole.length > 1) {
	          duplicate = role;
	          return false;
	        }
	        return true;
	      });
	
	      if (duplicate) {
	        return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + duplicate + '. ' + ('Only one child each allowed with the following bsRoles: ' + roles.join(', ')));
	      }
	    });
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 782 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = ReactTransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	exports['default'] = childrenAsArray;
	
	var _ValidComponentChildren = __webpack_require__(28);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function childrenAsArray(children) {
	  var result = [];
	
	  if (children === undefined) {
	    return result;
	  }
	
	  _ValidComponentChildren2['default'].forEach(children, function (child) {
	    result.push(child);
	  });
	
	  return result;
	}
	
	module.exports = exports['default'];

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = __webpack_require__(181)['default'];
	
	var _interopRequireDefault = __webpack_require__(4)['default'];
	
	exports.__esModule = true;
	
	var _bootstrapUtils2 = __webpack_require__(10);
	
	var _bootstrapUtils = _interopRequireWildcard(_bootstrapUtils2);
	
	exports.bootstrapUtils = _bootstrapUtils;
	
	var _childrenValueInputValidation2 = __webpack_require__(180);
	
	var _childrenValueInputValidation3 = _interopRequireDefault(_childrenValueInputValidation2);
	
	exports.childrenValueInputValidation = _childrenValueInputValidation3['default'];
	
	var _createChainedFunction2 = __webpack_require__(32);
	
	var _createChainedFunction3 = _interopRequireDefault(_createChainedFunction2);
	
	exports.createChainedFunction = _createChainedFunction3['default'];
	
	var _ValidComponentChildren2 = __webpack_require__(28);
	
	var _ValidComponentChildren3 = _interopRequireDefault(_ValidComponentChildren2);
	
	exports.ValidComponentChildren = _ValidComponentChildren3['default'];

/***/ },
/* 785 */
[996, 789],
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(799);
	module.exports = __webpack_require__(93).Object.assign;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(183);
	module.exports = function create(P, D){
	  return $.create(P, D);
	};

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(800);
	module.exports = __webpack_require__(93).Object.keys;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(801);
	module.exports = __webpack_require__(93).Object.setPrototypeOf;

/***/ },
/* 790 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(317);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 792 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 793 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 794 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(792);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.1 Object.assign(target, source, ...)
	var $        = __webpack_require__(183)
	  , toObject = __webpack_require__(318)
	  , IObject  = __webpack_require__(795);
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = __webpack_require__(316)(function(){
	  var a = Object.assign
	    , A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , $$    = arguments
	    , $$len = $$.length
	    , index = 1
	    , getKeys    = $.getKeys
	    , getSymbols = $.getSymbols
	    , isEnum     = $.isEnum;
	  while($$len > index){
	    var S      = IObject($$[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  }
	  return T;
	} : Object.assign;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(182)
	  , core    = __webpack_require__(93)
	  , fails   = __webpack_require__(316);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var getDesc  = __webpack_require__(183).getDesc
	  , isObject = __webpack_require__(317)
	  , anObject = __webpack_require__(791);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(315)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(182);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(796)});

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(318);
	
	__webpack_require__(797)('keys', function($keys){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(182);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(798).set});

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(38));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__13__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 10);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = warn;
	
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = trim;
	
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	function trim(s) {
	  return s.replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	exports["default"] = exports.testModeAPI = exports.plugin = void 0;
	
	var _format2 = _interopRequireDefault(__webpack_require__(3));
	
	var _removeLeadingSlash = _interopRequireDefault(__webpack_require__(6));
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	var _loadGA = _interopRequireDefault(__webpack_require__(7));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	var _log = _interopRequireDefault(__webpack_require__(8));
	
	var _testModeAPI = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';
	
	var _debug = false;
	var _titleCase = true;
	var _testMode = false;
	var _alwaysSendToDefaultTracker = true;
	
	var internalGa = function internalGa() {
	  var _window;
	
	  if (_testMode) return _testModeAPI["default"].ga.apply(_testModeAPI["default"], arguments);
	  if (_isNotBrowser) return false;
	  if (!window.ga) return (0, _warn["default"])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
	  return (_window = window).ga.apply(_window, arguments);
	};
	
	function _format(s) {
	  return (0, _format2["default"])(s, _titleCase);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn["default"])('ga command must be a string');
	      return;
	    }
	
	    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);
	
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn["default"])('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	
	    if (options.useExistingGa) {
	      return;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function initialize(configsOrTrackingId, options) {
	  if (options && options.testMode === true) {
	    _testMode = true;
	  } else {
	    if (_isNotBrowser) {
	      return false;
	    }
	
	    if (!options || options.standardImplementation !== true) (0, _loadGA["default"])(options);
	  }
	
	  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
	
	  if (Array.isArray(configsOrTrackingId)) {
	    configsOrTrackingId.forEach(function (config) {
	      if (_typeof(config) !== 'object') {
	        (0, _warn["default"])('All configs must be an object');
	        return;
	      }
	
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configsOrTrackingId, options);
	  }
	
	  return true;
	}
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	
	
	function ga() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(void 0, args);
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'arguments\');');
	      (0, _log["default"])("with arguments: ".concat(JSON.stringify(args)));
	    }
	  }
	
	  return window.ga;
	}
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn["default"])('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if (_typeof(fieldsObject) !== 'object') {
	    (0, _warn["default"])('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn["default"])('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log["default"])('called ga(\'set\', fieldsObject);');
	    (0, _log["default"])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
	  }
	}
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	
	  if (_debug) {
	    (0, _log["default"])('called ga(\'send\', fieldObject);');
	    (0, _log["default"])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
	    (0, _log["default"])("with trackers: ".concat(JSON.stringify(trackerNames)));
	  }
	}
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 * @param {String} title - (optional) the page title e. g. 'My Website'
	 */
	
	
	function pageview(rawPath, trackerNames, title) {
	  if (!rawPath) {
	    (0, _warn["default"])('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim["default"])(rawPath);
	
	  if (path === '') {
	    (0, _warn["default"])('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  var extraFields = {};
	
	  if (title) {
	    extraFields.title = title;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', _objectSpread({
	      hitType: 'pageview',
	      page: path
	    }, extraFields));
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'send\', \'pageview\', path);');
	      var extraLog = '';
	
	      if (title) {
	        extraLog = " and title: ".concat(title);
	      }
	
	      (0, _log["default"])("with path: ".concat(path).concat(extraLog));
	    }
	  }
	}
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn["default"])('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash["default"])((0, _trim["default"])(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn["default"])('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = "/modal/".concat(modalName);
	
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log["default"])('called ga(\'send\', \'pageview\', path);');
	      (0, _log["default"])("with path: ".concat(path));
	    }
	  }
	}
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || !value || typeof value !== 'number') {
	      (0, _warn["default"])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param args.transport {string} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn["default"])('args.category AND args.action are required in event()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    }; // Optional Fields
	
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn["default"])('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn["default"])('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn["default"])('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn["default"])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    }); // Send to GA
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    }; // Optional Fields
	
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn["default"])('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    } // Send to GA
	
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   * @param trackerName {String} optional e.g 'trackerName'
	   */
	  require: function require(rawName, options, trackerName) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn["default"])('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim["default"])(rawName);
	
	      if (name === '') {
	        (0, _warn["default"])('`name` cannot be an empty string in .require()');
	        return;
	      }
	
	      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields
	
	      if (options) {
	        if (_typeof(options) !== 'object') {
	          (0, _warn["default"])('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn["default"])('Empty `options` given to .require()');
	        }
	
	        ga(requireString, name, options);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
	        }
	      } else {
	        ga(requireString, name);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "');"));
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload;
	    var actionType;
	
	    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
	      payload = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      actionType = arguments.length <= 2 ? undefined : arguments[2];
	      payload = arguments.length <= 3 ? undefined : arguments[3];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn["default"])('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn["default"])('Expected `action` arg to be a String.');
	      } else {
	        var command = "".concat(pluginName, ":").concat(action);
	        payload = payload || null;
	
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
	          }
	        } else if (payload) {
	          ga(command, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("with payload: ".concat(JSON.stringify(payload)));
	          }
	        } else {
	          ga(command);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	          }
	        }
	      }
	    }
	  }
	};
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	
	exports.plugin = plugin;
	
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn["default"])('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn["default"])('args.label is required in outboundLink()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	    var safetyCallbackCalled = false;
	
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	      hitCallback();
	    }; // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	    // register safety net timeout:
	
	
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA
	
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	var testModeAPI = _testModeAPI["default"];
	exports.testModeAPI = testModeAPI;
	var _default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  testModeAPI: _testModeAPI["default"]
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = format;
	
	var _mightBeEmail = _interopRequireDefault(__webpack_require__(4));
	
	var _toTitleCase = _interopRequireDefault(__webpack_require__(5));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function format(s, titleCase) {
	  if ((0, _mightBeEmail["default"])(s)) {
	    (0, _warn["default"])('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  if (titleCase) {
	    return (0, _toTitleCase["default"])(s);
	  }
	
	  return s;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = mightBeEmail;
	
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return typeof s === 'string' && s.indexOf('@') !== -1;
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = toTitleCase;
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * To Title Case 2.1 - http://individed.com/code/to-title-case/
	 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	 * https://github.com/gouch/to-title-case
	 */
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
	
	function toTitleCase(string) {
	  return (0, _trim["default"])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = removeLeadingSlash;
	
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	
	function _default(options) {
	  var gaAddress = 'https://www.google-analytics.com/analytics.js';
	
	  if (options && options.gaAddress) {
	    gaAddress = options.gaAddress;
	  } else if (options && options.debug) {
	    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
	  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	
	  /* eslint-disable */
	
	
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', gaAddress, 'ga');
	  /* eslint-enable */
	
	}
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = log;
	
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.gaCalls = void 0;
	var gaCalls = [];
	exports.gaCalls = gaCalls;
	var _default = {
	  calls: gaCalls,
	  ga: function ga() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    gaCalls.push([].concat(args));
	  },
	  resetCalls: function resetCalls() {
	    gaCalls.length = 0;
	  }
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.OutboundLink = exports.testModeAPI = exports.outboundLink = exports.plugin = exports.exception = exports.event = exports.timing = exports.modalview = exports.pageview = exports.send = exports.set = exports.ga = exports.initialize = void 0;
	
	var _OutboundLink = _interopRequireDefault(__webpack_require__(11));
	
	var Defaults = _interopRequireWildcard(__webpack_require__(2));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialize = Defaults.initialize;
	exports.initialize = initialize;
	var ga = Defaults.ga;
	exports.ga = ga;
	var set = Defaults.set;
	exports.set = set;
	var send = Defaults.send;
	exports.send = send;
	var pageview = Defaults.pageview;
	exports.pageview = pageview;
	var modalview = Defaults.modalview;
	exports.modalview = modalview;
	var timing = Defaults.timing;
	exports.timing = timing;
	var event = Defaults.event;
	exports.event = event;
	var exception = Defaults.exception;
	exports.exception = exception;
	var plugin = Defaults.plugin;
	exports.plugin = plugin;
	var outboundLink = Defaults.outboundLink;
	exports.outboundLink = outboundLink;
	var testModeAPI = Defaults.testModeAPI;
	exports.testModeAPI = testModeAPI;
	_OutboundLink["default"].origTrackLink = _OutboundLink["default"].trackLink;
	_OutboundLink["default"].trackLink = Defaults.outboundLink;
	var OutboundLink = _OutboundLink["default"];
	exports.OutboundLink = OutboundLink;
	
	var _default = _objectSpread({}, Defaults, {
	  OutboundLink: OutboundLink
	});
	
	exports["default"] = _default;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(12));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  function OutboundLink() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick,
	          trackerNames = _this$props.trackerNames;
	      var eventMeta = {
	        label: eventLabel
	      };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        }, trackerNames);
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(OutboundLink, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          href = _this$props2.to,
	          oldProps = _objectWithoutProperties(_this$props2, ["to"]);
	
	      var props = _objectSpread({}, oldProps, {
	        href: href,
	        onClick: this.handleClick
	      });
	
	      if (this.props.target === NEWTAB) {
	        props.rel = 'noopener noreferrer';
	      }
	
	      delete props.eventLabel;
	      delete props.trackerNames;
	      return _react["default"].createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	exports["default"] = OutboundLink;
	
	_defineProperty(OutboundLink, "trackLink", function () {
	  (0, _warn["default"])('ga tracking not enabled');
	});
	
	_defineProperty(OutboundLink, "propTypes", {
	  eventLabel: _propTypes["default"].string.isRequired,
	  target: _propTypes["default"].string,
	  to: _propTypes["default"].string,
	  onClick: _propTypes["default"].func,
	  trackerNames: _propTypes["default"].arrayOf(_propTypes["default"].string)
	});
	
	_defineProperty(OutboundLink, "defaultProps", {
	  target: null,
	  to: null,
	  onClick: null,
	  trackerNames: null
	});
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__12__;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__13__;
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 803 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* istanbul ignore next */
	/**
	 * Default values
	 */
	exports.default = {
	  fixtures: [],
	  initialValue: '',
	  placeholder: 'Search places',
	  disabled: false,
	  className: '',
	  inputClassName: '',
	  location: null,
	  radius: null,
	  bounds: null,
	  country: null,
	  types: null,
	  queryDelay: 250,
	  googleMaps: null,
	  onActivateSuggest: function onActivateSuggest() {},
	  onSuggestSelect: function onSuggestSelect() {},
	  onSuggestNoResults: function onSuggestNoResults() {},
	  onFocus: function onFocus() {},
	  onBlur: function onBlur() {},
	  onChange: function onChange() {},
	  skipSuggest: function skipSuggest() {},
	  getSuggestLabel: function getSuggestLabel(suggest) {
	    return suggest.description;
	  },
	  autoActivateFirstSuggest: false,
	  style: {
	    'input': {},
	    'suggests': {},
	    'suggestItem': {}
	  },
	  ignoreTab: false
	};

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(174);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _filterInputAttributes = __webpack_require__(321);
	
	var _filterInputAttributes2 = _interopRequireDefault(_filterInputAttributes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line no-unused-vars
	
	
	/**
	 * The input field
	 * @param {Object} props The component's props
	 * @return {JSX} The icon component.
	 */
	var Input = function (_React$Component) {
	  _inherits(Input, _React$Component);
	
	  function Input() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Input);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function () {
	      _this.props.onChange(_this.refs.input.value);
	    }, _this.onFocus = function () {
	      _this.props.onFocus();
	    }, _this.onBlur = function () {
	      _this.props.onBlur();
	    }, _this.onInputKeyDown = function (event) {
	      switch (event.which) {
	        case 40:
	          // DOWN
	          event.preventDefault();
	          _this.props.onNext();
	          break;
	        case 38:
	          // UP
	          event.preventDefault();
	          _this.props.onPrev();
	          break;
	        case 13:
	          // ENTER
	          if (_this.props.ignoreEnter) {
	            event.preventDefault();
	          }
	
	          _this.props.onSelect();
	          break;
	        case 9:
	          // TAB
	          if (!_this.props.ignoreTab) {
	            _this.props.onSelect();
	          }
	          break;
	        case 27:
	          // ESC
	          _this.props.onEscape();
	          break;
	        /* istanbul ignore next */
	        default:
	          break;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Input, [{
	    key: 'shouldComponentUpdate',
	
	    /**
	     * Whether or not the component should update
	     * @param {Object} nextProps The new properties
	     * @param {Object} nextState The new state
	     * @return {Boolean} Update or not?
	     */
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	
	    /**
	     * When the input got changed
	     */
	
	
	    /**
	     * When the input got focused
	     */
	
	
	    /**
	     * When the input loses focus
	     */
	
	
	    /**
	     * When a key gets pressed in the input
	     * @param  {Event} event The keypress event
	     */
	
	  }, {
	    key: 'focus',
	
	
	    /**
	     * Focus the input
	     */
	    value: function focus() {
	      this.refs.input.focus();
	    }
	
	    /**
	     * Render the view
	     * @return {Function} The React element to render
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var attributes = (0, _filterInputAttributes2.default)(this.props),
	          classes = (0, _classnames2.default)('geosuggest__input', this.props.className);
	
	      return _react2.default.createElement('input', _extends({ className: classes,
	        ref: 'input',
	        type: 'text',
	        autoComplete: 'off'
	      }, attributes, {
	        value: this.props.value,
	        style: this.props.style,
	        onKeyDown: this.onInputKeyDown,
	        onChange: this.onChange,
	        onFocus: this.onFocus,
	        onBlur: this.onBlur }));
	    }
	  }]);
	
	  return Input;
	}(_react2.default.Component);
	
	/**
	 * Default values for the properties
	 * @type {Object}
	 */
	
	
	Input.defaultProps = {
	  className: '',
	  value: '',
	  ignoreTab: false
	};
	
	exports.default = Input;

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Default values
	 */
	exports.default = {
	  fixtures: _react2.default.PropTypes.array,
	  initialValue: _react2.default.PropTypes.string,
	  placeholder: _react2.default.PropTypes.string,
	  disabled: _react2.default.PropTypes.bool,
	  className: _react2.default.PropTypes.string,
	  inputClassName: _react2.default.PropTypes.string,
	  location: _react2.default.PropTypes.object,
	  radius: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]),
	  bounds: _react2.default.PropTypes.object,
	  country: _react2.default.PropTypes.string,
	  types: _react2.default.PropTypes.array,
	  queryDelay: _react2.default.PropTypes.number,
	  googleMaps: _react2.default.PropTypes.object,
	  onSuggestSelect: _react2.default.PropTypes.func,
	  onFocus: _react2.default.PropTypes.func,
	  onBlur: _react2.default.PropTypes.func,
	  onChange: _react2.default.PropTypes.func,
	  skipSuggest: _react2.default.PropTypes.func,
	  getSuggestLabel: _react2.default.PropTypes.func,
	  autoActivateFirstSuggest: _react2.default.PropTypes.bool,
	  style: _react2.default.PropTypes.shape({
	    input: _react2.default.PropTypes.object,
	    suggests: _react2.default.PropTypes.object,
	    suggestItem: _react2.default.PropTypes.object
	  }),
	  ignoreTab: _react2.default.PropTypes.bool
	};

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(174);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A single Geosuggest item in the list
	 * @param {Object} props The component's props
	 * @return {JSX} The icon component.
	 */
	var SuggestItem = function (_React$Component) {
	  _inherits(SuggestItem, _React$Component);
	
	  function SuggestItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SuggestItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SuggestItem.__proto__ || Object.getPrototypeOf(SuggestItem)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (event) {
	      event.preventDefault();
	      _this.props.onSelect(_this.props.suggest);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SuggestItem, [{
	    key: 'shouldComponentUpdate',
	
	    /**
	     * Whether or not the component should update
	     * @param {Object} nextProps The new properties
	     * @param {Object} nextState The new state
	     * @return {Boolean} Update or not?
	     */
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	
	    /**
	     * When the suggest item got clicked
	     * @param {Event} event The click event
	     */
	
	  }, {
	    key: 'render',
	
	
	    /**
	     * Render the view
	     * @return {Function} The React element to render
	     */
	    value: function render() {
	      var classes = (0, _classnames2.default)('geosuggest-item', this.props.className, { 'geosuggest-item--active': this.props.isActive });
	
	      return _react2.default.createElement(
	        'li',
	        { className: classes,
	          style: this.props.style,
	          onMouseDown: this.props.onMouseDown,
	          onMouseOut: this.props.onMouseOut,
	          onClick: this.onClick },
	        this.props.suggest.label
	      );
	    }
	  }]);
	
	  return SuggestItem;
	}(_react2.default.Component);
	
	/**
	 * Default values for the properties
	 * @type {Object}
	 */
	
	
	exports.default = SuggestItem;
	SuggestItem.defaultProps = {
	  isActive: false,
	  className: '',
	  suggest: {}
	};

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(174);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _suggestItem = __webpack_require__(806);
	
	var _suggestItem2 = _interopRequireDefault(_suggestItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line no-unused-vars
	
	
	/**
	 * The list with suggestions. Either from an API or provided as fixture
	 * @param {Object} props The component's props
	 * @return {JSX} The icon component.
	 */
	var SuggestList = function (_React$Component) {
	  _inherits(SuggestList, _React$Component);
	
	  function SuggestList() {
	    _classCallCheck(this, SuggestList);
	
	    return _possibleConstructorReturn(this, (SuggestList.__proto__ || Object.getPrototypeOf(SuggestList)).apply(this, arguments));
	  }
	
	  _createClass(SuggestList, [{
	    key: 'shouldComponentUpdate',
	
	    /**
	     * Whether or not the component should update
	     * @param {Object} nextProps The new properties
	     * @param {Object} nextState The new state
	     * @return {Boolean} Update or not?
	     */
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	
	    /**
	     * Whether or not it is hidden
	     * @return {Boolean} Hidden or not?
	     */
	
	  }, {
	    key: 'isHidden',
	    value: function isHidden() {
	      return this.props.isHidden || this.props.suggests.length === 0;
	    }
	
	    /**
	     * There are new properties available for the list
	     * @param {Object} nextProps The new properties
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.suggests !== this.props.suggests) {
	        if (nextProps.suggests.length === 0) {
	          this.props.onSuggestNoResults();
	        }
	      }
	    }
	
	    /**
	     * Render the view
	     * @return {Function} The React element to render
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var classes = (0, _classnames2.default)('geosuggest__suggests', { 'geosuggest__suggests--hidden': this.isHidden() });
	
	      return _react2.default.createElement(
	        'ul',
	        { className: classes, style: this.props.style },
	        this.props.suggests.map(function (suggest) {
	          var isActive = _this2.props.activeSuggest && suggest.placeId === _this2.props.activeSuggest.placeId;
	
	          return _react2.default.createElement(_suggestItem2.default, { key: suggest.placeId,
	            className: suggest.className,
	            suggest: suggest,
	            style: _this2.props.suggestItemStyle,
	            isActive: isActive,
	            onMouseDown: _this2.props.onSuggestMouseDown,
	            onMouseOut: _this2.props.onSuggestMouseOut,
	            onSelect: _this2.props.onSuggestSelect });
	        })
	      );
	    }
	  }]);
	
	  return SuggestList;
	}(_react2.default.Component);
	
	/**
	 * Default values for the properties
	 * @type {Object}
	 */
	
	
	exports.default = SuggestList;
	SuggestList.defaultProps = {
	  isHidden: true,
	  suggests: []
	};

/***/ },
/* 808 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cn = void 0;
	
	var cn = function cn(className) {
	  return typeof className === 'string' ? className.split('.').join(' ').trim() : '';
	};
	
	exports.cn = cn;

/***/ },
/* 809 */
404,
/* 810 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(810);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _deepEqual = __webpack_require__(155);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	function intersects(array1, array2) {
	  return !!(array1 && array2 && array1.some(function (item) {
	    return ~array2.indexOf(item);
	  }));
	}
	
	var LazyCache = (function () {
	  function LazyCache(component, calculators) {
	    var _this = this;
	
	    _classCallCheck(this, LazyCache);
	
	    this.component = component;
	    this.allProps = [];
	    this.cache = Object.keys(calculators).reduce(function (accumulator, key) {
	      var _extends2;
	
	      var calculator = calculators[key];
	      var fn = calculator.fn;
	      var paramNames = calculator.params;
	      paramNames.forEach(function (param) {
	        if (! ~_this.allProps.indexOf(param)) {
	          _this.allProps.push(param);
	        }
	      });
	      return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = {
	        value: undefined,
	        props: paramNames,
	        fn: fn
	      }, _extends2));
	    }, {});
	  }
	
	  LazyCache.prototype.get = function get(key) {
	    var component = this.component;
	    var _cache$key = this.cache[key];
	    var value = _cache$key.value;
	    var fn = _cache$key.fn;
	    var props = _cache$key.props;
	
	    if (value !== undefined) {
	      return value;
	    }
	    var params = props.map(function (prop) {
	      return component.props[prop];
	    });
	    var result = fn.apply(undefined, params);
	    this.cache[key].value = result;
	    return result;
	  };
	
	  LazyCache.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var component = this.component;
	
	    var diffProps = [];
	    this.allProps.forEach(function (prop) {
	      if (!_deepEqual2['default'](component.props[prop], nextProps[prop])) {
	        diffProps.push(prop);
	      }
	    });
	    if (diffProps.length) {
	      Object.keys(this.cache).forEach(function (key) {
	        if (intersects(diffProps, _this2.cache[key].props)) {
	          delete _this2.cache[key].value; // uncache value
	        }
	      });
	    }
	  };
	
	  return LazyCache;
	})();
	
	exports['default'] = LazyCache;
	module.exports = exports['default'];

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(812);


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OffCanvas = function OffCanvas(_ref) {
	  var _ref$width = _ref.width;
	  var width = _ref$width === undefined ? 250 : _ref$width;
	  var _ref$transitionDurati = _ref.transitionDuration;
	  var transitionDuration = _ref$transitionDurati === undefined ? 250 : _ref$transitionDurati;
	  var _ref$isMenuOpened = _ref.isMenuOpened;
	  var isMenuOpened = _ref$isMenuOpened === undefined ? false : _ref$isMenuOpened;
	  var _ref$position = _ref.position;
	  var position = _ref$position === undefined ? "left" : _ref$position;
	  var children = _ref.children;
	
	
	  // transfer the <OffCanvas /> props to the children
	  var transferProps = function transferProps(element) {
	    return _react2.default.cloneElement(element, { width: width, transitionDuration: transitionDuration, isMenuOpened: isMenuOpened, position: position });
	  };
	
	  // transfer the props from OffCanvas to the child
	  var offCanvasChildren = _react2.default.Children.map(children, transferProps);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    offCanvasChildren
	  );
	};
	
	exports.default = OffCanvas;

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OffCanvasBody = function OffCanvasBody(_ref) {
	  var _ref$width = _ref.width;
	  var width = _ref$width === undefined ? 250 : _ref$width;
	  var _ref$transitionDurati = _ref.transitionDuration;
	  var transitionDuration = _ref$transitionDurati === undefined ? 250 : _ref$transitionDurati;
	  var _ref$isMenuOpened = _ref.isMenuOpened;
	  var isMenuOpened = _ref$isMenuOpened === undefined ? false : _ref$isMenuOpened;
	  var _ref$position = _ref.position;
	  var position = _ref$position === undefined ? "left" : _ref$position;
	  var children = _ref.children;
	  var className = _ref.className;
	  var style = _ref.style;
	
	
	  // closed state style
	  var translateX = position === 'left' ? 0 : 0;
	  var closedStyle = {
	    transitionDuration: transitionDuration + 'ms',
	    transform: 'translate(' + translateX + 'px, 0px)',
	    backfaceVisibility: 'hidden'
	  };
	
	  // open state style
	  var translateOpenX = position === 'left' ? width : -1 * width;
	  var openStyle = {
	    transform: 'translate(' + translateOpenX + 'px, 0px)'
	  };
	
	  // create current state styles
	  var currStyle = Object.assign({}, closedStyle);
	  if (isMenuOpened) {
	    currStyle = Object.assign({}, currStyle, openStyle);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: _extends({}, currStyle, style), className: className },
	    children
	  );
	};
	
	OffCanvasBody.propTypes = {
	  width: _react.PropTypes.number,
	  transitionDuration: _react.PropTypes.number,
	  isMenuOpened: _react.PropTypes.bool,
	  position: _react.PropTypes.oneOf(["left", "right"]),
	  style: _react.PropTypes.object
	};
	
	exports.default = OffCanvasBody;

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OffCanvasMenu = function OffCanvasMenu(_ref) {
	  var _ref$width = _ref.width;
	  var width = _ref$width === undefined ? 250 : _ref$width;
	  var _ref$transitionDurati = _ref.transitionDuration;
	  var transitionDuration = _ref$transitionDurati === undefined ? 250 : _ref$transitionDurati;
	  var _ref$isMenuOpened = _ref.isMenuOpened;
	  var isMenuOpened = _ref$isMenuOpened === undefined ? false : _ref$isMenuOpened;
	  var _ref$position = _ref.position;
	  var position = _ref$position === undefined ? "left" : _ref$position;
	  var children = _ref.children;
	  var className = _ref.className;
	  var style = _ref.style;
	
	
	  // closed state style
	  var left = position === 'left' ? -1 * width + 'px' : 'auto';
	  var right = position === 'left' ? 'auto' : -1 * width + 'px';
	  var translateX = position === 'left' ? -1 * width : 0;
	  var closedStyle = {
	    width: width + 'px',
	    position: 'fixed',
	    top: '0px',
	    left: left,
	    right: right,
	    transform: 'translate(' + translateX + 'px, 0px)',
	    transitionDuration: transitionDuration + 'ms',
	    backfaceVisibility: 'hidden'
	  };
	
	  // open state style
	  var translateOpenX = position === 'left' ? width : -1 * width;
	  var openStyle = {
	    transform: 'translate(' + translateOpenX + 'px, 0px)'
	  };
	
	  // create current state styles
	  var currStyle = Object.assign({}, closedStyle);
	  if (isMenuOpened) {
	    currStyle = Object.assign({}, currStyle, openStyle);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: _extends({}, currStyle, style), className: className },
	    children
	  );
	};
	
	OffCanvasMenu.propTypes = {
	  width: _react.PropTypes.number,
	  transitionDuration: _react.PropTypes.number,
	  isMenuOpened: _react.PropTypes.bool,
	  position: _react.PropTypes.oneOf(["left", "right"]),
	  style: _react.PropTypes.object
	};
	
	exports.default = OffCanvasMenu;

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*eslint-disable react/prop-types */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(839);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _componentOrElement = __webpack_require__(187);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _elementType = __webpack_require__(335);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Portal = __webpack_require__(324);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ModalManager = __webpack_require__(818);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _ownerDocument = __webpack_require__(94);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _addEventListener = __webpack_require__(327);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(821);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _inDOM = __webpack_require__(78);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _activeElement = __webpack_require__(824);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(185);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _getContainer = __webpack_require__(184);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	var Modal = _react2.default.createClass({
	  displayName: 'Modal',
	
	
	  propTypes: _extends({}, _Portal2.default.propTypes, {
	
	    /**
	     * Set the visibility of the Modal
	     */
	    show: _react2.default.PropTypes.bool,
	
	    /**
	     * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	     *
	     * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	     * page content can be placed behind a virtual backdrop as well as a visual one.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	    /**
	     * A callback fired when the Modal is opening.
	     */
	    onShow: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	     *
	     * The `onHide` callback only signals intent from the Modal,
	     * you must actually set the `show` prop to `false` for the Modal to close.
	     */
	    onHide: _react2.default.PropTypes.func,
	
	    /**
	     * Include a backdrop component.
	     */
	    backdrop: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.oneOf(['static'])]),
	
	    /**
	     * A function that returns a backdrop component. Useful for custom
	     * backdrop rendering.
	     *
	     * ```js
	     *  renderBackdrop={props => <MyBackdrop {...props} />}
	     * ```
	     */
	    renderBackdrop: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	     */
	    onEscapeKeyUp: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the backdrop, if specified, is clicked.
	     */
	    onBackdropClick: _react2.default.PropTypes.func,
	
	    /**
	     * A style object for the backdrop component.
	     */
	    backdropStyle: _react2.default.PropTypes.object,
	
	    /**
	     * A css class or classes for the backdrop component.
	     */
	    backdropClassName: _react2.default.PropTypes.string,
	
	    /**
	     * A css class or set of classes applied to the modal container when the modal is open,
	     * and removed when it is closed.
	     */
	    containerClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Close the modal when escape key is pressed
	     */
	    keyboard: _react2.default.PropTypes.bool,
	
	    /**
	     * A `<Transition/>` component to use for the dialog and backdrop components.
	     */
	    transition: _elementType2.default,
	
	    /**
	     * The `timeout` of the dialog transition if specified. This number is used to ensure that
	     * transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    dialogTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * The `timeout` of the backdrop transition if specified. This number is used to
	     * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    backdropTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * When `true` The modal will automatically shift focus to itself when it opens, and
	     * replace it to the last focused element when it closes. This also
	     * works correctly with any Modal children that have the `autoFocus` prop.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    autoFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will prevent focus from leaving the Modal while open.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    enforceFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will restore focus to previously focused element once
	     * modal is hidden
	     */
	    restoreFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * Callback fired before the Modal transitions in
	     */
	    onEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition in
	     */
	    onEntering: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning in
	     */
	    onEntered: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired right before the Modal transitions out
	     */
	    onExit: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition out
	     */
	    onExiting: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning out
	     */
	    onExited: _react2.default.PropTypes.func,
	
	    /**
	     * A ModalManager instance used to track and manage the state of open
	     * Modals. Useful when customizing how modals interact within a container
	     */
	    manager: _react2.default.PropTypes.object.isRequired
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    var noop = function noop() {};
	
	    return {
	      show: false,
	      backdrop: true,
	      keyboard: true,
	      autoFocus: true,
	      enforceFocus: true,
	      restoreFocus: true,
	      onHide: noop,
	      manager: modalManager,
	      renderBackdrop: function renderBackdrop(props) {
	        return _react2.default.createElement('div', props);
	      }
	    };
	  },
	  omitProps: function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  },
	  getInitialState: function getInitialState() {
	    return { exited: !this.props.show };
	  },
	  render: function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: 'modal',
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        dialog
	      )
	    );
	  },
	  renderBackdrop: function renderBackdrop() {
	    var _this = this;
	
	    var _props2 = this.props,
	        backdropStyle = _props2.backdropStyle,
	        backdropClassName = _props2.backdropClassName,
	        renderBackdrop = _props2.renderBackdrop,
	        Transition = _props2.transition,
	        backdropTransitionTimeout = _props2.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this.backdrop = ref;
	    };
	
	    var backdrop = _react2.default.createElement('div', {
	      ref: backdropRef,
	      style: this.props.backdropStyle,
	      className: this.props.backdropClassName,
	      onClick: this.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': this.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        renderBackdrop({
	          ref: backdropRef,
	          style: backdropStyle,
	          className: backdropClassName,
	          onClick: this.handleBackdropClick
	        })
	      );
	    }
	
	    return backdrop;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.show) {
	      this.onShow();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var _props3 = this.props,
	        show = _props3.show,
	        transition = _props3.transition;
	
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  },
	  onShow: function onShow() {
	    var doc = (0, _ownerDocument2.default)(this);
	    var container = (0, _getContainer2.default)(this.props.container, doc.body);
	
	    this.props.manager.add(this, container, this.props.containerClassName);
	
	    this._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleDocumentKeyUp);
	
	    this._onFocusinListener = (0, _addFocusListener2.default)(this.enforceFocus);
	
	    this.focus();
	
	    if (this.props.onShow) {
	      this.props.onShow();
	    }
	  },
	  onHide: function onHide() {
	    this.props.manager.remove(this);
	
	    this._onDocumentKeyupListener.remove();
	
	    this._onFocusinListener.remove();
	
	    if (this.props.restoreFocus) {
	      this.restoreLastFocus();
	    }
	  },
	  setMountNode: function setMountNode(ref) {
	    this.mountNode = ref ? ref.getMountNode() : ref;
	  },
	  handleHidden: function handleHidden() {
	    this.setState({ exited: true });
	    this.onHide();
	
	    if (this.props.onExited) {
	      var _props4;
	
	      (_props4 = this.props).onExited.apply(_props4, arguments);
	    }
	  },
	  handleBackdropClick: function handleBackdropClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (this.props.onBackdropClick) {
	      this.props.onBackdropClick(e);
	    }
	
	    if (this.props.backdrop === true) {
	      this.props.onHide();
	    }
	  },
	  handleDocumentKeyUp: function handleDocumentKeyUp(e) {
	    if (this.props.keyboard && e.keyCode === 27 && this.isTopModal()) {
	      if (this.props.onEscapeKeyUp) {
	        this.props.onEscapeKeyUp(e);
	      }
	      this.props.onHide();
	    }
	  },
	  checkForFocus: function checkForFocus() {
	    if (_inDOM2.default) {
	      this.lastFocus = (0, _activeElement2.default)();
	    }
	  },
	  focus: function focus() {
	    var autoFocus = this.props.autoFocus;
	    var modalContent = this.getDialogElement();
	    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var focusInModal = current && (0, _contains2.default)(modalContent, current);
	
	    if (modalContent && autoFocus && !focusInModal) {
	      this.lastFocus = current;
	
	      if (!modalContent.hasAttribute('tabIndex')) {
	        modalContent.setAttribute('tabIndex', -1);
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
	      }
	
	      modalContent.focus();
	    }
	  },
	  restoreLastFocus: function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  },
	  enforceFocus: function enforceFocus() {
	    var enforceFocus = this.props.enforceFocus;
	
	
	    if (!enforceFocus || !this.isMounted() || !this.isTopModal()) {
	      return;
	    }
	
	    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var modal = this.getDialogElement();
	
	    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
	      modal.focus();
	    }
	  },
	
	
	  //instead of a ref, which might conflict with one the parent applied.
	  getDialogElement: function getDialogElement() {
	    var node = this.refs.modal;
	    return node && node.lastChild;
	  },
	  isTopModal: function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  }
	});
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__(186);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _class = __webpack_require__(826);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _scrollbarSize = __webpack_require__(838);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(328);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(823);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function () {
	  function ModalManager() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	        hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	        _ref2$handleContainer = _ref2.handleContainerOverflow,
	        handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	    _classCallCheck(this, ModalManager);
	
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.handleContainerOverflow = handleContainerOverflow;
	    this.modals = [];
	    this.containers = [];
	    this.data = [];
	  }
	
	  _createClass(ModalManager, [{
	    key: 'add',
	    value: function add(modal, container, className) {
	      var modalIdx = this.modals.indexOf(modal);
	      var containerIdx = this.containers.indexOf(container);
	
	      if (modalIdx !== -1) {
	        return modalIdx;
	      }
	
	      modalIdx = this.modals.length;
	      this.modals.push(modal);
	
	      if (this.hideSiblingNodes) {
	        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	      }
	
	      if (containerIdx !== -1) {
	        this.data[containerIdx].modals.push(modal);
	        return modalIdx;
	      }
	
	      var data = {
	        modals: [modal],
	        //right now only the first modal of a container will have its classes applied
	        classes: className ? className.split(/\s+/) : [],
	
	        overflowing: (0, _isOverflowing2.default)(container)
	      };
	
	      if (this.handleContainerOverflow) {
	        setContainerStyle(data, container);
	      }
	
	      data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	      this.containers.push(container);
	      this.data.push(data);
	
	      return modalIdx;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(modal) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx === -1) {
	        return;
	      }
	
	      var containerIdx = findContainer(this.data, modal);
	      var data = this.data[containerIdx];
	      var container = this.containers[containerIdx];
	
	      data.modals.splice(data.modals.indexOf(modal), 1);
	
	      this.modals.splice(modalIdx, 1);
	
	      // if that was the last modal in a container,
	      // clean up the container
	      if (data.modals.length === 0) {
	        data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	        if (this.handleContainerOverflow) {
	          removeContainerStyle(data, container);
	        }
	
	        if (this.hideSiblingNodes) {
	          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	        }
	        this.containers.splice(containerIdx, 1);
	        this.data.splice(containerIdx, 1);
	      } else if (this.hideSiblingNodes) {
	        //otherwise make sure the next top modal is visible to a SR
	        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	      }
	    }
	  }, {
	    key: 'isTopModal',
	    value: function isTopModal(modal) {
	      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	
	  return ModalManager;
	}();
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(324);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(820);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(325);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _elementType = __webpack_require__(335);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props, context));
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.show) {
	        this.setState({ exited: false });
	      } else if (!nextProps.transition) {
	        // Otherwise let handleHidden take care of marking exited.
	        this.setState({ exited: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          container = _props.container,
	          containerPadding = _props.containerPadding,
	          target = _props.target,
	          placement = _props.placement,
	          shouldUpdatePosition = _props.shouldUpdatePosition,
	          rootClose = _props.rootClose,
	          children = _props.children,
	          Transition = _props.transition,
	          props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	      // Don't un-render the overlay while it's transitioning out.
	
	
	      var mountOverlay = props.show || Transition && !this.state.exited;
	      if (!mountOverlay) {
	        // Don't bother showing anything if we don't have to.
	        return null;
	      }
	
	      var child = children;
	
	      // Position is be inner-most because it adds inline styles into the child,
	      // which the other wrappers don't forward correctly.
	      child = _react2.default.createElement(
	        _Position2.default,
	        { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	        child
	      );
	
	      if (Transition) {
	        var onExit = props.onExit,
	            onExiting = props.onExiting,
	            onEnter = props.onEnter,
	            onEntering = props.onEntering,
	            onEntered = props.onEntered;
	
	        // This animates the child node by injecting props, so it must precede
	        // anything that adds a wrapping div.
	
	        child = _react2.default.createElement(
	          Transition,
	          {
	            'in': props.show,
	            transitionAppear: true,
	            onExit: onExit,
	            onExiting: onExiting,
	            onExited: this.onHiddenListener,
	            onEnter: onEnter,
	            onEntering: onEntering,
	            onEntered: onEntered
	          },
	          child
	        );
	      }
	
	      // This goes after everything else because it adds a wrapping div.
	      if (rootClose) {
	        child = _react2.default.createElement(
	          _RootCloseWrapper2.default,
	          { onRootClose: props.onHide },
	          child
	        );
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { container: container },
	        child
	      );
	    }
	  }, {
	    key: 'handleHidden',
	    value: function handleHidden() {
	      this.setState({ exited: true });
	
	      if (this.props.onExited) {
	        var _props2;
	
	        (_props2 = this.props).onExited.apply(_props2, arguments);
	      }
	    }
	  }]);
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2.default.PropTypes.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _react2.default.PropTypes.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _react2.default.PropTypes.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2.default.PropTypes.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(187);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _calculatePosition = __webpack_require__(822);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(184);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(94);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props, context));
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  _createClass(Position, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updatePosition(this.getTarget());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this._needsFlush = true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this._needsFlush) {
	        this._needsFlush = false;
	        this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['children', 'className']);
	
	      var _state = this.state,
	          positionLeft = _state.positionLeft,
	          positionTop = _state.positionTop,
	          arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	      // These should not be forwarded to the child.
	
	
	      delete props.target;
	      delete props.container;
	      delete props.containerPadding;
	      delete props.shouldUpdatePosition;
	
	      var child = _react2.default.Children.only(children);
	      return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	        // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	        // and `props.style`.
	        positionLeft: positionLeft,
	        positionTop: positionTop,
	        className: (0, _classnames2.default)(className, child.props.className),
	        style: _extends({}, child.props.style, {
	          left: positionLeft,
	          top: positionTop
	        })
	      }));
	    }
	  }, {
	    key: 'getTarget',
	    value: function getTarget() {
	      var target = this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    }
	  }, {
	    key: 'maybeUpdatePosition',
	    value: function maybeUpdatePosition(placementChanged) {
	      var target = this.getTarget();
	
	      if (!this.props.shouldUpdatePosition && target === this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      this.updatePosition(target);
	    }
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition(target) {
	      this._lastTarget = target;
	
	      if (!target) {
	        this.setState({
	          positionLeft: 0,
	          positionTop: 0,
	          arrowOffsetLeft: null,
	          arrowOffsetTop: null
	        });
	
	        return;
	      }
	
	      var overlay = _reactDom2.default.findDOMNode(this);
	      var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	      this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	    }
	  }]);
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _react2.default.PropTypes.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _react2.default.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _react2.default.PropTypes.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ },
/* 821 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(331);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(830);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(332);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(94);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ },
/* 823 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(95));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(329));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(825));
	
	exports.addClass = _addClass.default;
	
	var _removeClass = _interopRequireDefault(__webpack_require__(827));
	
	exports.removeClass = _removeClass.default;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(329));
	
	exports.hasClass = _hasClass.default;
	var _default = {
	  addClass: _addClass.default,
	  removeClass: _removeClass.default,
	  hasClass: _hasClass.default
	};
	exports.default = _default;

/***/ },
/* 827 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(78));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = offsetParent;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(95));
	
	var _style = _interopRequireDefault(__webpack_require__(186));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.exports = exports["default"];

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = position;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(400));
	
	var _offset = _interopRequireDefault(__webpack_require__(331));
	
	var _offsetParent = _interopRequireDefault(__webpack_require__(829));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(332));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(831));
	
	var _style = _interopRequireDefault(__webpack_require__(186));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = {
	    top: 0,
	    left: 0
	  },
	      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	
	  if ((0, _style.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent.default)(node);
	    offset = (0, _offset.default)(node);
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
	    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
	  } // Subtract parent offsets and node margins
	
	
	  return (0, _extends2.default)({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(119));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(334));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 833 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ },
/* 834 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ },
/* 835 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 836 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(836));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(25);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(78));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ },
/* 839 */
24,
/* 840 */
/***/ function(module, exports) {

	/**
	 * Checks if only one of the listed properties is in use. An error is given
	 * if multiple have a value
	 *
	 * @param props
	 * @param propName
	 * @param componentName
	 * @returns {Error|undefined}
	 */
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createSinglePropFromChecker;
	
	function createSinglePropFromChecker() {
	  for (var _len = arguments.length, arrOfProps = Array(_len), _key = 0; _key < _len; _key++) {
	    arrOfProps[_key] = arguments[_key];
	  }
	
	  function validate(props, propName) {
	    var usedPropCount = arrOfProps.map(function (listedProp) {
	      return props[listedProp];
	    }).reduce(function (acc, curr) {
	      return acc + (curr !== undefined ? 1 : 0);
	    }, 0);
	
	    if (usedPropCount > 1) {
	      var first = arrOfProps[0];
	      var others = arrOfProps.slice(1);
	
	      var message = others.join(', ') + ' and ' + first;
	      return new Error('Invalid prop \'' + propName + '\', only one of the following ' + ('may be provided: ' + message));
	    }
	  }
	  return validate;
	}
	
	module.exports = exports['default'];

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	var HTMLDOMPropertyConfig = __webpack_require__(842);
	var SVGDOMPropertyConfig = __webpack_require__(843);
	var injection = __webpack_require__(844);
	
	var MUST_USE_PROPERTY = injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	/**
	 * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/DOMProperty.js#L14-L16
	 *
	 * @param  {Number}  value
	 * @param  {Number}  bitmask
	 * @return {Boolean}
	 */
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	/**
	 * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/DOMProperty.js#L57
	 *
	 * @param {Object}  domPropertyConfig - HTMLDOMPropertyConfig or SVGDOMPropertyConfig
	 * @param {Object}  config            - The object to be mutated
	 * @param {Boolean} isSVG             - Whether the injected config is HTML or SVG (it assumes the default is HTML)
	 */
	function injectDOMPropertyConfig(domPropertyConfig, config, isSVG) {
	  var Properties = domPropertyConfig.Properties;
	  var DOMAttributeNames = domPropertyConfig.DOMAttributeNames;
	  var attributeName;
	  var propertyName;
	  var propConfig;
	
	  for (propertyName in Properties) {
	    attributeName =
	      DOMAttributeNames[propertyName] ||
	      (isSVG ? propertyName : propertyName.toLowerCase());
	    propConfig = Properties[propertyName];
	
	    config[attributeName] = {
	      attributeName: attributeName,
	      propertyName: propertyName,
	      mustUseProperty: checkMask(propConfig, MUST_USE_PROPERTY),
	      hasBooleanValue: checkMask(propConfig, HAS_BOOLEAN_VALUE),
	      hasNumericValue: checkMask(propConfig, HAS_NUMERIC_VALUE),
	      hasPositiveNumericValue: checkMask(
	        propConfig,
	        HAS_POSITIVE_NUMERIC_VALUE
	      ),
	      hasOverloadedBooleanValue: checkMask(
	        propConfig,
	        HAS_OVERLOADED_BOOLEAN_VALUE
	      )
	    };
	  }
	}
	
	/**
	 * HTML properties config.
	 *
	 * @type {Object}
	 */
	var html = {};
	injectDOMPropertyConfig(HTMLDOMPropertyConfig, html);
	
	/**
	 * SVG properties config.
	 *
	 * @type {Object}
	 */
	var svg = {};
	injectDOMPropertyConfig(SVGDOMPropertyConfig, svg, true);
	
	/**
	 * HTML and SVG properties config.
	 *
	 * @type {Object}
	 */
	var properties = {};
	injectDOMPropertyConfig(HTMLDOMPropertyConfig, properties);
	injectDOMPropertyConfig(SVGDOMPropertyConfig, properties, true);
	
	var ATTRIBUTE_NAME_START_CHAR =
	  ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	var ATTRIBUTE_NAME_CHAR =
	  ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
	
	module.exports = {
	  html: html,
	  svg: svg,
	  properties: properties,
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   *
	   * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25
	   *
	   * @param {String}
	   * @return {Boolean}
	   */
	  isCustomAttribute: RegExp.prototype.test.bind(
	    new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$')
	  )
	};


/***/ },
/* 842 */
/***/ function(module, exports) {

	module.exports = {
	  Properties: {
	    autoFocus: 4,
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: 4,
	    allowTransparency: 0,
	    alt: 0,
	    as: 0,
	    async: 4,
	    autoComplete: 0,
	    autoPlay: 4,
	    capture: 4,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: 5,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: 24,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: 4,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0,
	    dateTime: 0,
	    default: 4,
	    defer: 4,
	    dir: 0,
	    disabled: 4,
	    download: 32,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: 4,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: 4,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: 4,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    multiple: 5,
	    muted: 5,
	    name: 0,
	    nonce: 0,
	    noValidate: 4,
	    open: 4,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: 4,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: 4,
	    referrerPolicy: 0,
	    rel: 0,
	    required: 4,
	    reversed: 4,
	    role: 0,
	    rows: 24,
	    rowSpan: 8,
	    sandbox: 0,
	    scope: 0,
	    scoped: 4,
	    scrolling: 0,
	    seamless: 4,
	    selected: 5,
	    shape: 0,
	    size: 24,
	    sizes: 0,
	    span: 24,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: 8,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    property: 0,
	    resource: 0,
	    typeof: 0,
	    vocab: 0,
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    autoSave: 0,
	    color: 0,
	    itemProp: 0,
	    itemScope: 4,
	    itemType: 0,
	    itemID: 0,
	    itemRef: 0,
	    results: 0,
	    security: 0,
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  }
	};


/***/ },
/* 843 */
/***/ function(module, exports) {

	module.exports = {
	  Properties: {
	    accentHeight: 0,
	    accumulate: 0,
	    additive: 0,
	    alignmentBaseline: 0,
	    allowReorder: 0,
	    alphabetic: 0,
	    amplitude: 0,
	    arabicForm: 0,
	    ascent: 0,
	    attributeName: 0,
	    attributeType: 0,
	    autoReverse: 0,
	    azimuth: 0,
	    baseFrequency: 0,
	    baseProfile: 0,
	    baselineShift: 0,
	    bbox: 0,
	    begin: 0,
	    bias: 0,
	    by: 0,
	    calcMode: 0,
	    capHeight: 0,
	    clip: 0,
	    clipPath: 0,
	    clipRule: 0,
	    clipPathUnits: 0,
	    colorInterpolation: 0,
	    colorInterpolationFilters: 0,
	    colorProfile: 0,
	    colorRendering: 0,
	    contentScriptType: 0,
	    contentStyleType: 0,
	    cursor: 0,
	    cx: 0,
	    cy: 0,
	    d: 0,
	    decelerate: 0,
	    descent: 0,
	    diffuseConstant: 0,
	    direction: 0,
	    display: 0,
	    divisor: 0,
	    dominantBaseline: 0,
	    dur: 0,
	    dx: 0,
	    dy: 0,
	    edgeMode: 0,
	    elevation: 0,
	    enableBackground: 0,
	    end: 0,
	    exponent: 0,
	    externalResourcesRequired: 0,
	    fill: 0,
	    fillOpacity: 0,
	    fillRule: 0,
	    filter: 0,
	    filterRes: 0,
	    filterUnits: 0,
	    floodColor: 0,
	    floodOpacity: 0,
	    focusable: 0,
	    fontFamily: 0,
	    fontSize: 0,
	    fontSizeAdjust: 0,
	    fontStretch: 0,
	    fontStyle: 0,
	    fontVariant: 0,
	    fontWeight: 0,
	    format: 0,
	    from: 0,
	    fx: 0,
	    fy: 0,
	    g1: 0,
	    g2: 0,
	    glyphName: 0,
	    glyphOrientationHorizontal: 0,
	    glyphOrientationVertical: 0,
	    glyphRef: 0,
	    gradientTransform: 0,
	    gradientUnits: 0,
	    hanging: 0,
	    horizAdvX: 0,
	    horizOriginX: 0,
	    ideographic: 0,
	    imageRendering: 0,
	    in: 0,
	    in2: 0,
	    intercept: 0,
	    k: 0,
	    k1: 0,
	    k2: 0,
	    k3: 0,
	    k4: 0,
	    kernelMatrix: 0,
	    kernelUnitLength: 0,
	    kerning: 0,
	    keyPoints: 0,
	    keySplines: 0,
	    keyTimes: 0,
	    lengthAdjust: 0,
	    letterSpacing: 0,
	    lightingColor: 0,
	    limitingConeAngle: 0,
	    local: 0,
	    markerEnd: 0,
	    markerMid: 0,
	    markerStart: 0,
	    markerHeight: 0,
	    markerUnits: 0,
	    markerWidth: 0,
	    mask: 0,
	    maskContentUnits: 0,
	    maskUnits: 0,
	    mathematical: 0,
	    mode: 0,
	    numOctaves: 0,
	    offset: 0,
	    opacity: 0,
	    operator: 0,
	    order: 0,
	    orient: 0,
	    orientation: 0,
	    origin: 0,
	    overflow: 0,
	    overlinePosition: 0,
	    overlineThickness: 0,
	    paintOrder: 0,
	    panose1: 0,
	    pathLength: 0,
	    patternContentUnits: 0,
	    patternTransform: 0,
	    patternUnits: 0,
	    pointerEvents: 0,
	    points: 0,
	    pointsAtX: 0,
	    pointsAtY: 0,
	    pointsAtZ: 0,
	    preserveAlpha: 0,
	    preserveAspectRatio: 0,
	    primitiveUnits: 0,
	    r: 0,
	    radius: 0,
	    refX: 0,
	    refY: 0,
	    renderingIntent: 0,
	    repeatCount: 0,
	    repeatDur: 0,
	    requiredExtensions: 0,
	    requiredFeatures: 0,
	    restart: 0,
	    result: 0,
	    rotate: 0,
	    rx: 0,
	    ry: 0,
	    scale: 0,
	    seed: 0,
	    shapeRendering: 0,
	    slope: 0,
	    spacing: 0,
	    specularConstant: 0,
	    specularExponent: 0,
	    speed: 0,
	    spreadMethod: 0,
	    startOffset: 0,
	    stdDeviation: 0,
	    stemh: 0,
	    stemv: 0,
	    stitchTiles: 0,
	    stopColor: 0,
	    stopOpacity: 0,
	    strikethroughPosition: 0,
	    strikethroughThickness: 0,
	    string: 0,
	    stroke: 0,
	    strokeDasharray: 0,
	    strokeDashoffset: 0,
	    strokeLinecap: 0,
	    strokeLinejoin: 0,
	    strokeMiterlimit: 0,
	    strokeOpacity: 0,
	    strokeWidth: 0,
	    surfaceScale: 0,
	    systemLanguage: 0,
	    tableValues: 0,
	    targetX: 0,
	    targetY: 0,
	    textAnchor: 0,
	    textDecoration: 0,
	    textRendering: 0,
	    textLength: 0,
	    to: 0,
	    transform: 0,
	    u1: 0,
	    u2: 0,
	    underlinePosition: 0,
	    underlineThickness: 0,
	    unicode: 0,
	    unicodeBidi: 0,
	    unicodeRange: 0,
	    unitsPerEm: 0,
	    vAlphabetic: 0,
	    vHanging: 0,
	    vIdeographic: 0,
	    vMathematical: 0,
	    values: 0,
	    vectorEffect: 0,
	    version: 0,
	    vertAdvY: 0,
	    vertOriginX: 0,
	    vertOriginY: 0,
	    viewBox: 0,
	    viewTarget: 0,
	    visibility: 0,
	    widths: 0,
	    wordSpacing: 0,
	    writingMode: 0,
	    x: 0,
	    xHeight: 0,
	    x1: 0,
	    x2: 0,
	    xChannelSelector: 0,
	    xlinkActuate: 0,
	    xlinkArcrole: 0,
	    xlinkHref: 0,
	    xlinkRole: 0,
	    xlinkShow: 0,
	    xlinkTitle: 0,
	    xlinkType: 0,
	    xmlBase: 0,
	    xmlns: 0,
	    xmlnsXlink: 0,
	    xmlLang: 0,
	    xmlSpace: 0,
	    y: 0,
	    y1: 0,
	    y2: 0,
	    yChannelSelector: 0,
	    z: 0,
	    zoomAndPan: 0
	  },
	  DOMAttributeNames: {
	    accentHeight: 'accent-height',
	    alignmentBaseline: 'alignment-baseline',
	    arabicForm: 'arabic-form',
	    baselineShift: 'baseline-shift',
	    capHeight: 'cap-height',
	    clipPath: 'clip-path',
	    clipRule: 'clip-rule',
	    colorInterpolation: 'color-interpolation',
	    colorInterpolationFilters: 'color-interpolation-filters',
	    colorProfile: 'color-profile',
	    colorRendering: 'color-rendering',
	    dominantBaseline: 'dominant-baseline',
	    enableBackground: 'enable-background',
	    fillOpacity: 'fill-opacity',
	    fillRule: 'fill-rule',
	    floodColor: 'flood-color',
	    floodOpacity: 'flood-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    fontSizeAdjust: 'font-size-adjust',
	    fontStretch: 'font-stretch',
	    fontStyle: 'font-style',
	    fontVariant: 'font-variant',
	    fontWeight: 'font-weight',
	    glyphName: 'glyph-name',
	    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	    glyphOrientationVertical: 'glyph-orientation-vertical',
	    horizAdvX: 'horiz-adv-x',
	    horizOriginX: 'horiz-origin-x',
	    imageRendering: 'image-rendering',
	    letterSpacing: 'letter-spacing',
	    lightingColor: 'lighting-color',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    overlinePosition: 'overline-position',
	    overlineThickness: 'overline-thickness',
	    paintOrder: 'paint-order',
	    panose1: 'panose-1',
	    pointerEvents: 'pointer-events',
	    renderingIntent: 'rendering-intent',
	    shapeRendering: 'shape-rendering',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strikethroughPosition: 'strikethrough-position',
	    strikethroughThickness: 'strikethrough-thickness',
	    strokeDasharray: 'stroke-dasharray',
	    strokeDashoffset: 'stroke-dashoffset',
	    strokeLinecap: 'stroke-linecap',
	    strokeLinejoin: 'stroke-linejoin',
	    strokeMiterlimit: 'stroke-miterlimit',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    textDecoration: 'text-decoration',
	    textRendering: 'text-rendering',
	    underlinePosition: 'underline-position',
	    underlineThickness: 'underline-thickness',
	    unicodeBidi: 'unicode-bidi',
	    unicodeRange: 'unicode-range',
	    unitsPerEm: 'units-per-em',
	    vAlphabetic: 'v-alphabetic',
	    vHanging: 'v-hanging',
	    vIdeographic: 'v-ideographic',
	    vMathematical: 'v-mathematical',
	    vectorEffect: 'vector-effect',
	    vertAdvY: 'vert-adv-y',
	    vertOriginX: 'vert-origin-x',
	    vertOriginY: 'vert-origin-y',
	    wordSpacing: 'word-spacing',
	    writingMode: 'writing-mode',
	    xHeight: 'x-height',
	    xlinkActuate: 'xlink:actuate',
	    xlinkArcrole: 'xlink:arcrole',
	    xlinkHref: 'xlink:href',
	    xlinkRole: 'xlink:role',
	    xlinkShow: 'xlink:show',
	    xlinkTitle: 'xlink:title',
	    xlinkType: 'xlink:type',
	    xmlBase: 'xml:base',
	    xmlnsXlink: 'xmlns:xlink',
	    xmlLang: 'xml:lang',
	    xmlSpace: 'xml:space'
	  }
	};


/***/ },
/* 844 */
/***/ function(module, exports) {

	module.exports = {
	  MUST_USE_PROPERTY: 1,
	  HAS_BOOLEAN_VALUE: 4,
	  HAS_NUMERIC_VALUE: 8,
	  HAS_POSITIVE_NUMERIC_VALUE: 24,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 32
	};


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(38);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(337);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(338);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(337);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(847);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(848);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(338);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(857);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(657);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 847 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(100);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 849 */
[998, 339, 852, 853],
/* 850 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 851 */
[999, 854],
/* 852 */
[1000, 339],
/* 853 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 854 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 855 */
[1001, 850],
/* 856 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 857 */
[1002, 849, 851, 856],
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(26);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(340);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(26);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(341);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(26);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(58);
	
	var _InternalPropTypes = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(26);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(58);
	
	var _InternalPropTypes = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(26);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(267);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(113);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(191);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(66);
	
	var _RouterContext = __webpack_require__(123);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(58);
	
	var _RouterUtils = __webpack_require__(342);
	
	var _routerWarning = __webpack_require__(26);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(123);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(26);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(189);
	
	var _routerWarning = __webpack_require__(26);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(123);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(26);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(654);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(344);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(79);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(189);
	
	var _makeStateWithLocation = __webpack_require__(345);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(79);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(267);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(344);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(79);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(76);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(343);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(191);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(58);
	
	var _RouterUtils = __webpack_require__(342);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(189);
	
	var _makeStateWithLocation = __webpack_require__(345);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(79);
	
	var _routerWarning = __webpack_require__(26);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(113);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(191);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(26);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(879);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 879 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 880 */
24,
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(140);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.generateIcon = generateIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(38);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _icons = __webpack_require__(882);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function generateIcon(network) {
	  if (!_icons2.default[network.toLowerCase()]) {
	    throw new Error('invalid network name for a social icon');
	  }
	
	  var iconConfig = _icons2.default[network.toLowerCase()];
	
	  var Icon = function Icon(props) {
	    var className = props.className,
	        iconBgStyle = props.iconBgStyle,
	        logoFillColor = props.logoFillColor,
	        round = props.round,
	        size = props.size;
	
	
	    var baseStyle = {
	      width: size,
	      height: size
	    };
	
	    var classes = 'social-icon social-icon--' + network + ' ' + className;
	
	    var finalIconBgStyle = (0, _extends3.default)({}, iconBgStyle);
	
	    return _react2.default.createElement(
	      'div',
	      { style: baseStyle },
	      _react2.default.createElement(
	        'svg',
	        {
	          viewBox: '0 0 64 64',
	          width: size,
	          height: size,
	          className: classes },
	        _react2.default.createElement(
	          'g',
	          null,
	          !round ? _react2.default.createElement('rect', {
	            width: '64',
	            height: '64',
	            fill: iconConfig.color,
	            style: finalIconBgStyle }) : _react2.default.createElement('circle', {
	            cx: '32',
	            cy: '32',
	            r: '31',
	            fill: iconConfig.color,
	            style: finalIconBgStyle })
	        ),
	        _react2.default.createElement(
	          'g',
	          null,
	          _react2.default.createElement('path', { d: iconConfig.icon, fill: logoFillColor })
	        )
	      )
	    );
	  };
	
	  Icon.propTypes = {
	    className: _propTypes2.default.string,
	    iconBgStyle: _propTypes2.default.object,
	    logoFillColor: _propTypes2.default.string,
	    round: _propTypes2.default.bool,
	    size: _propTypes2.default.number
	  };
	
	  Icon.defaultProps = {
	    className: '',
	    logoFillColor: 'white',
	    size: 64
	  };
	
	  return Icon;
	}

/***/ },
/* 882 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable max-len */
	exports.default = {
	  facebook: {
	    icon: 'M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z',
	    mask: 'M0,0v64h64V0H0z M39.6,22l-2.8,0c-2.2,0-2.6,1.1-2.6,2.6V28h5.3l-0.7,5.3h-4.6V47h-5.5V33.3H24V28h4.6V24 c0-4.6,2.8-7,6.9-7c2,0,3.6,0.1,4.1,0.2V22z',
	    color: '#3b5998'
	  },
	  google: {
	    icon: 'M25.3,30.1v3.8h6.3c-0.3,1.6-1.9,4.8-6.3,4.8c-3.8,0-6.9-3.1-6.9-7s3.1-7,6.9-7c2.2,0,3.6,0.9,4.4,1.7l3-2.9c-1.9-1.8-4.4-2.9-7.4-2.9c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.4,0,10.7-4.5,10.7-10.9c0-0.7-0.1-1.3-0.2-1.8H25.3L25.3,30.1z M49.8,28.9h-3.2v-3.2h-3.2v3.2h-3.2v3.2h3.2v3.2h3.2v-3.2h3.2',
	    mask: 'M0,0v64h64V0H0z M31.3,19.1c0.3,0.3,0.6,0.7,0.9,1.2c0.3,0.4,0.5,0.9,0.7,1.5c0.2,0.6,0.3,1.3,0.3,2.1 c0,1.4-0.3,2.6-0.9,3.4c-0.3,0.4-0.6,0.8-0.9,1.2c-0.4,0.4-0.8,0.7-1.2,1.1c-0.2,0.2-0.5,0.5-0.7,0.8c-0.2,0.3-0.4,0.7-0.4,1.1 c0,0.4,0.1,0.8,0.4,1c0.2,0.3,0.4,0.5,0.6,0.7l1.4,1.1c0.8,0.7,1.6,1.5,2.2,2.3c0.6,0.8,0.9,2,0.9,3.3c0,1.9-0.9,3.7-2.6,5.2 c-1.8,1.6-4.3,2.4-7.7,2.4c-2.8,0-4.9-0.6-6.3-1.8c-1.4-1.1-2.1-2.4-2.1-3.9c0-0.7,0.2-1.6,0.7-2.5c0.4-0.9,1.2-1.7,2.4-2.4 c1.3-0.7,2.7-1.2,4.1-1.5c1.4-0.2,2.6-0.3,3.5-0.4c-0.3-0.4-0.5-0.8-0.8-1.2c-0.3-0.4-0.4-0.9-0.4-1.5c0-0.4,0-0.6,0.2-0.9 c0.1-0.2,0.2-0.5,0.2-0.7c-0.5,0.1-0.9,0.1-1.3,0.1c-2.1,0-3.8-0.7-4.9-2c-1.2-1.2-1.8-2.7-1.8-4.3c0-2,0.8-3.8,2.5-5.4 c1.1-0.9,2.3-1.6,3.5-1.8c1.2-0.2,2.3-0.4,3.4-0.4h8L33,18.4h-2.5C30.7,18.6,31,18.8,31.3,19.1z M48,32h-4.3v4.2h-2.5V32H37v-2.5 h4.2v-4.3h2.5v4.3H48V32z M27.1,19.1c-0.6-0.5-1.4-0.7-2.2-0.7c-1.1,0-2,0.5-2.7,1.3c-0.6,0.9-0.9,1.9-0.9,3c0,1.5,0.4,3,1.3,4.5 c0.4,0.7,0.9,1.4,1.6,1.9c0.6,0.5,1.4,0.8,2.2,0.8c1.1,0,1.9-0.4,2.6-1.1c0.3-0.5,0.6-1,0.7-1.6c0.1-0.5,0.1-1,0.1-1.4 c0-1.6-0.4-3.2-1.2-4.8C28.2,20.2,27.7,19.5,27.1,19.1z M26.9,36.2c-0.2,0-0.7,0-1.6,0.1c-0.8,0.1-1.7,0.3-2.5,0.6 c-0.2,0.1-0.5,0.2-0.9,0.4c-0.4,0.2-0.7,0.4-1.1,0.7c-0.4,0.3-0.7,0.7-0.9,1.2c-0.3,0.5-0.4,1.1-0.4,1.8c0,1.4,0.6,2.6,1.9,3.5 c1.2,0.9,2.9,1.4,5,1.4c1.9,0,3.3-0.4,4.3-1.3c1-0.8,1.5-1.8,1.5-3.1c0-1-0.3-1.9-1-2.7c-0.7-0.7-1.8-1.6-3.3-2.6 C27.5,36.2,27.2,36.2,26.9,36.2z',
	    color: '#dd4b39'
	  },
	  linkedin: {
	    icon: 'M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z',
	    mask: 'M0,0v64h64V0H0z M25.8,44h-5.4V26.6h5.4V44z M23.1,24.3c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1 c1.7,0,3.1,1.4,3.1,3.1C26.2,22.9,24.8,24.3,23.1,24.3z M46,44h-5.4v-8.4c0-2,0-4.6-2.8-4.6c-2.8,0-3.2,2.2-3.2,4.5V44h-5.4V26.6 h5.2V29h0.1c0.7-1.4,2.5-2.8,5.1-2.8c5.5,0,6.5,3.6,6.5,8.3V44z',
	    color: '#007fb1'
	  },
	  email: {
	    icon: 'M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z',
	    mask: 'M41.1,25H22.9l9.1,7.1L41.1,25z M44,26.6l-12,9.3l-12-9.3V39h24V26.6z M0,0v64h64V0H0z M47,42H17V22h30V42z',
	    color: '#7f7f7f'
	  },
	  twitter: {
	    icon: 'M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z',
	    mask: 'M0,0v64h64V0H0z M44.7,25.5c0,0.3,0,0.6,0,0.8C44.7,35,38.1,45,26.1,45c-3.7,0-7.2-1.1-10.1-2.9 c0.5,0.1,1,0.1,1.6,0.1c3.1,0,5.9-1,8.2-2.8c-2.9-0.1-5.3-2-6.1-4.6c0.4,0.1,0.8,0.1,1.2,0.1c0.6,0,1.2-0.1,1.7-0.2 c-3-0.6-5.3-3.3-5.3-6.4c0,0,0-0.1,0-0.1c0.9,0.5,1.9,0.8,3,0.8c-1.8-1.2-2.9-3.2-2.9-5.5c0-1.2,0.3-2.3,0.9-3.3 c3.2,4,8.1,6.6,13.5,6.9c-0.1-0.5-0.2-1-0.2-1.5c0-3.6,2.9-6.6,6.6-6.6c1.9,0,3.6,0.8,4.8,2.1c1.5-0.3,2.9-0.8,4.2-1.6 c-0.5,1.5-1.5,2.8-2.9,3.6c1.3-0.2,2.6-0.5,3.8-1C47.1,23.4,46,24.5,44.7,25.5z',
	    color: '#00aced'
	  },
	  pinterest: {
	    icon: 'M32,16c-8.8,0-16,7.2-16,16c0,6.6,3.9,12.2,9.6,14.7c0-1.1,0-2.5,0.3-3.7 c0.3-1.3,2.1-8.7,2.1-8.7s-0.5-1-0.5-2.5c0-2.4,1.4-4.1,3.1-4.1c1.5,0,2.2,1.1,2.2,2.4c0,1.5-0.9,3.7-1.4,5.7 c-0.4,1.7,0.9,3.1,2.5,3.1c3,0,5.1-3.9,5.1-8.5c0-3.5-2.4-6.1-6.7-6.1c-4.9,0-7.9,3.6-7.9,7.7c0,1.4,0.4,2.4,1.1,3.1 c0.3,0.3,0.3,0.5,0.2,0.9c-0.1,0.3-0.3,1-0.3,1.3c-0.1,0.4-0.4,0.6-0.8,0.4c-2.2-0.9-3.3-3.4-3.3-6.1c0-4.5,3.8-10,11.4-10 c6.1,0,10.1,4.4,10.1,9.2c0,6.3-3.5,11-8.6,11c-1.7,0-3.4-0.9-3.9-2c0,0-0.9,3.7-1.1,4.4c-0.3,1.2-1,2.5-1.6,3.4 c1.4,0.4,3,0.7,4.5,0.7c8.8,0,16-7.2,16-16C48,23.2,40.8,16,32,16z',
	    mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
	    color: '#cb2128'
	  },
	  vk: {
	    icon: 'M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
	    mask: 'M0,0v64h64V0H0z M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
	    color: '#45668e'
	  },
	  ok: {
	    icon: 'M39,30c-1,0-3,2-7,2s-6-2-7-2c-1.1,0-2,0.9-2,2c0,1,0.6,1.5,1,1.7c1.2,0.7,5,2.3,5,2.3l-4.3,5.4   c0,0-0.8,0.9-0.8,1.6c0,1.1,0.9,2,2,2c1,0,1.5-0.7,1.5-0.7S32,39,32,39c0,0,4.5,5.3,4.5,5.3S37,45,38,45c1.1,0,2-0.9,2-2   c0-0.6-0.8-1.6-0.8-1.6L35,36c0,0,3.8-1.6,5-2.3c0.4-0.3,1-0.7,1-1.7C41,30.9,40.1,30,39,30z M32,15c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S35.9,15,32,15z M32,25.5   c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C35.5,23.9,33.9,22.5,35,22.5z ',
	    mask: 'M45,1H5C2.8,1,1,2.8,1,5v40c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4V5C49,2.8,47.2,1,45,1z',
	    color: '#f2720c'
	  },
	  telegram: {
	    icon: 'm45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957',
	    mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
	    color: '#37aee2'
	  },
	  whatsapp: {
	    icon: 'm42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915',
	    mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
	    color: '#2cb742'
	  },
	  reddit: {
	    icon: 'm 52.8165,31.942362 c 0,-2.4803 -2.0264,-4.4965 -4.5169,-4.4965 -1.2155,0 -2.3171,0.4862 -3.128,1.2682 -3.077,-2.0247 -7.2403,-3.3133 -11.8507,-3.4782 l 2.5211,-7.9373 6.8272,1.5997 -0.0102,0.0986 c 0,2.0281 1.6575,3.6771 3.6958,3.6771 2.0366,0 3.6924,-1.649 3.6924,-3.6771 0,-2.0281 -1.6575,-3.6788 -3.6924,-3.6788 -1.564,0 -2.8968,0.9758 -3.4357,2.3443 l -7.3593,-1.7255 c -0.3213,-0.0782 -0.6477,0.1071 -0.748,0.4233 L 32,25.212062 c -4.8246,0.0578 -9.1953,1.3566 -12.41,3.4425 -0.8058,-0.7446 -1.8751,-1.2104 -3.0583,-1.2104 -2.4905,0 -4.5152,2.0179 -4.5152,4.4982 0,1.649 0.9061,3.0787 2.2389,3.8607 -0.0884,0.4794 -0.1462,0.9639 -0.1462,1.4569 0,6.6487 8.1736,12.0581 18.2223,12.0581 10.0487,0 18.224,-5.4094 18.224,-12.0581 0,-0.4658 -0.0493,-0.9248 -0.1275,-1.377 1.4144,-0.7599 2.3885,-2.2304 2.3885,-3.9406 z m -29.2808,3.0872 c 0,-1.4756 1.207,-2.6775 2.6894,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 -1.4824,0 -2.6894,-1.2002 -2.6894,-2.6758 z m 15.4037,7.9373 c -1.3549,1.3481 -3.4816,2.0043 -6.5008,2.0043 l -0.0221,-0.0051 -0.0221,0.0051 c -3.0209,0 -5.1476,-0.6562 -6.5008,-2.0043 -0.2465,-0.2448 -0.2465,-0.6443 0,-0.8891 0.2465,-0.2465 0.6477,-0.2465 0.8942,0 1.105,1.0999 2.9393,1.6337 5.6066,1.6337 l 0.0221,0.0051 0.0221,-0.0051 c 2.6673,0 4.5016,-0.5355 5.6066,-1.6354 0.2465,-0.2465 0.6477,-0.2448 0.8942,0 0.2465,0.2465 0.2465,0.6443 0,0.8908 z m -0.3213,-5.2615 c -1.4824,0 -2.6877,-1.2002 -2.6877,-2.6758 0,-1.4756 1.2053,-2.6775 2.6877,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 z',
	    color: '#5f99cf'
	  },
	  tumblr: {
	    icon: 'M39.2,41c-0.6,0.3-1.6,0.5-2.4,0.5c-2.4,0.1-2.9-1.7-2.9-3v-9.3h6v-4.5h-6V17c0,0-4.3,0-4.4,0 c-0.1,0-0.2,0.1-0.2,0.2c-0.3,2.3-1.4,6.4-5.9,8.1v3.9h3V39c0,3.4,2.5,8.1,9,8c2.2,0,4.7-1,5.2-1.8L39.2,41z',
	    mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
	    color: '#2c4762'
	  },
	  livejournal: {
	    icon: 'M18.3407821,28.1764706 L21.9441341,31.789916 L33.0055865,42.882353 C33.0055865,42.882353 33.0893855,42.9663866 33.0893855,42.9663866 L46.6648046,47 C46.6648046,47 46.6648046,47 46.7486034,47 C46.8324022,47 46.8324022,47 46.9162012,46.9159664 C47,46.8319327 47,46.8319327 47,46.7478991 L42.9776536,33.1344537 C42.9776536,33.1344537 42.9776536,33.1344537 42.8938548,33.0504202 L31.1620111,21.3697479 L31.1620111,21.3697479 L28.1452514,18.2605042 C27.3072626,17.4201681 26.5530726,17 25.7150838,17 C24.2905028,17 23.0335195,18.3445378 21.5251397,19.8571429 C21.273743,20.1092437 20.9385475,20.4453781 20.6871508,20.697479 C20.3519553,21.0336134 20.1005586,21.2857143 19.849162,21.5378151 C18.3407821,22.9663866 17.0837989,24.2268908 17,25.7394958 C17.0837989,26.4957983 17.5027933,27.3361345 18.3407821,28.1764706 Z M39.9012319,39.6134454 C39.7336341,39.4453781 39.4822374,37.6806724 40.2364275,36.8403362 C40.9906174,36.0840337 41.6610084,36 42.1638017,36 C42.3313995,36 42.4989973,36 42.5827961,36 L44.8453659,43.5630253 L43.5883828,44.8235295 L36.0464833,42.5546218 C35.9626843,42.2184874 35.8788855,41.2100841 36.8844722,40.2016807 C37.2196676,39.8655463 37.8900587,39.6134454 38.5604498,39.6134454 C39.147042,39.6134454 39.5660364,39.7815126 39.5660364,39.7815126 C39.6498353,39.8655463 39.8174331,39.8655463 39.8174331,39.7815126 C39.9850307,39.7815126 39.9850307,39.697479 39.9012319,39.6134454 Z',
	    mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
	    color: '#21A5D8'
	  },
	  mailru: {
	    icon: 'M39.7107745,17 C41.6619755,17 43.3204965,18.732852 43.3204965,21.0072202 C43.3204965,23.2815885 41.7595357,25.0144404 39.7107745,25.0144404 C37.7595732,25.0144404 36.1010522,23.2815885 36.1010522,21.0072202 C36.1010522,18.732852 37.7595732,17 39.7107745,17 Z M24.3938451,17 C26.3450463,17 28.0035672,18.732852 28.0035672,21.0072202 C28.0035672,23.2815885 26.4426063,25.0144404 24.3938451,25.0144404 C22.4426439,25.0144404 20.7841229,23.2815885 20.7841229,21.0072202 C20.7841229,18.732852 22.4426439,17 24.3938451,17 Z M51.9057817,43.4259928 C51.7106617,44.0758123 51.4179815,44.6173285 50.9301812,44.9422383 C50.637501,45.1588448 50.2472607,45.267148 49.8570205,45.267148 C49.07654,45.267148 48.3936197,44.833935 48.0033795,44.0758123 L46.2472985,40.7184115 L45.759498,41.2599278 C42.5400162,44.9422383 37.466893,47 32.0035297,47 C26.5401664,47 21.5646034,44.9422383 18.2475614,41.2599278 L17.7597611,40.7184115 L16.00368,44.0758123 C15.6134398,44.833935 14.9305194,45.267148 14.1500389,45.267148 C13.7597986,45.267148 13.3695584,45.1588448 13.0768782,44.9422383 C12.0037176,44.2924187 11.7110374,42.7761733 12.2963978,41.5848375 L16.7841605,33.0288807 C17.1744007,32.270758 17.8573211,31.8375453 18.6378016,31.8375453 C19.0280418,31.8375453 19.4182821,31.9458485 19.7109623,32.1624548 C20.7841229,32.8122743 21.0768031,34.3285197 20.4914427,35.5198555 L20.1012025,36.2779783 L20.2963226,36.602888 C22.4426439,39.9602888 27.0279667,42.234657 31.9059697,42.234657 C36.7839727,42.234657 41.3692955,40.068592 43.5156167,36.602888 L43.7107367,36.2779783 L43.3204965,35.6281587 C43.0278165,35.0866425 42.9302562,34.436823 43.1253765,33.7870035 C43.3204965,33.137184 43.6131767,32.5956678 44.100977,32.270758 C44.3936572,32.0541515 44.7838975,31.9458485 45.1741377,31.9458485 C45.9546182,31.9458485 46.6375385,32.3790613 47.0277787,33.137184 L51.5155415,41.6931408 C52.003342,42.234657 52.100902,42.8844765 51.9057817,43.4259928 Z',
	    mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
	    color: '#168DE2'
	  }
	};
	/* eslint-enable max-len */

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MailruShareButton = exports.LivejournalShareButton = exports.TumblrShareButton = exports.RedditShareButton = exports.OKShareButton = exports.VKShareButton = exports.PinterestShareButton = exports.LinkedinShareButton = exports.GooglePlusShareButton = exports.EmailShareButton = exports.WhatsappShareButton = exports.TelegramShareButton = exports.TwitterShareButton = exports.FacebookShareButton = undefined;
	
	var _extends2 = __webpack_require__(140);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(221);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(223);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(224);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(226);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(225);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _keys = __webpack_require__(222);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(38);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _socialMediaShareLinks = __webpack_require__(348);
	
	var links = _interopRequireWildcard(_socialMediaShareLinks);
	
	var _utils = __webpack_require__(192);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedNetworks = (0, _keys2.default)(links); /* eslint-disable react/no-multi-comp */
	
	var ShareButton = function (_Component) {
	  (0, _inherits3.default)(ShareButton, _Component);
	
	  function ShareButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ShareButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ShareButton.__proto__ || (0, _getPrototypeOf2.default)(ShareButton)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (e) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onClick = _this$props.onClick,
	          openWindow = _this$props.openWindow;
	
	
	      if (disabled) {
	        return;
	      }
	
	      e.preventDefault();
	
	      var link = _this.link();
	
	      if (openWindow) {
	        _this.openWindow(link);
	      }
	
	      if (onClick) {
	        onClick(link);
	      }
	    }, _this.onKeyPress = function (e) {
	      if (e.key === 'Enter' || e.key === 13) {
	        _this.onClick(e);
	      }
	    }, _this.openWindow = function (link) {
	      var _this$props2 = _this.props,
	          beforeOnClick = _this$props2.beforeOnClick,
	          onShareWindowClose = _this$props2.onShareWindowClose,
	          windowWidth = _this$props2.windowWidth,
	          windowHeight = _this$props2.windowHeight;
	
	
	      var windowOptions = {
	        height: windowHeight,
	        width: windowWidth
	      };
	
	      var windowOpenBound = function windowOpenBound() {
	        return (0, _utils.windowOpen)(link, windowOptions, onShareWindowClose);
	      };
	
	      if (beforeOnClick) {
	        var returnVal = beforeOnClick();
	
	        if ((0, _utils.isPromise)(returnVal)) {
	          returnVal.then(windowOpenBound);
	        } else {
	          windowOpenBound();
	        }
	      } else {
	        windowOpenBound();
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ShareButton, [{
	    key: 'link',
	    value: function link() {
	      var _props = this.props,
	          url = _props.url,
	          opts = _props.opts,
	          network = _props.network;
	
	      return links[network](url, opts);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          additionalProps = _props2.additionalProps,
	          children = _props2.children,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          disabledStyle = _props2.disabledStyle,
	          network = _props2.network,
	          role = _props2.role,
	          style = _props2.style,
	          tabIndex = _props2.tabIndex;
	
	
	      var classes = (0, _classnames2.default)('SocialMediaShareButton', 'SocialMediaShareButton--' + network, {
	        'SocialMediaShareButton--disabled': !!disabled,
	        disabled: !!disabled
	      }, className);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, additionalProps, {
	          role: role,
	          tabIndex: tabIndex,
	          onClick: this.onClick,
	          onKeyPress: this.onKeyPress,
	          className: classes,
	          style: (0, _extends3.default)({}, style, disabled ? disabledStyle : {}) }),
	        children
	      );
	    }
	  }]);
	  return ShareButton;
	}(_react.Component);
	
	/* HOC to ease migration from v1 to v2.
	 * To-be-removed in v2.
	 */
	
	
	ShareButton.propTypes = {
	  additionalProps: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  disabledStyle: _propTypes2.default.object,
	  network: _propTypes2.default.oneOf(supportedNetworks),
	  onClick: _propTypes2.default.func,
	  opts: _propTypes2.default.object,
	  openWindow: _propTypes2.default.bool,
	  url: _propTypes2.default.string.isRequired,
	  role: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  windowWidth: _propTypes2.default.number,
	  windowHeight: _propTypes2.default.number,
	  beforeOnClick: _propTypes2.default.func,
	  onShareWindowClose: _propTypes2.default.func,
	  tabIndex: _propTypes2.default.string
	};
	ShareButton.defaultProps = {
	  disabledStyle: {
	    opacity: 0.6
	  },
	  openWindow: true,
	  role: 'button',
	  tabIndex: '0'
	};
	exports.default = ShareButton;
	function createShareButton(network) {
	  var optsMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	    return {};
	  };
	  var propTypes = arguments[2];
	  var defaultProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var CreatedButton = function CreatedButton(props) {
	    return _react2.default.createElement(ShareButton, (0, _extends3.default)({}, props, {
	      network: network,
	      opts: optsMap(props) }));
	  };
	
	  CreatedButton.propTypes = propTypes;
	  CreatedButton.defaultProps = defaultProps;
	
	  return CreatedButton;
	}
	
	var FacebookShareButton = exports.FacebookShareButton = createShareButton('facebook', function (props) {
	  /* eslint-disable no-console */
	  if (props.picture) {
	    console.warn('FacebookShareButton warning: picture is a deprecated prop.');
	  }
	
	  if (props.title) {
	    console.warn('FacebookShareButton warning: title is a deprecated prop. Use "quote" instead.');
	  }
	
	  if (props.description) {
	    console.warn('FacebookShareButton warning: description is a deprecated prop.\n      Use "quote" instead.');
	  }
	  /* eslint-enable no-console */
	
	  return {
	    quote: props.quote,
	    hashtag: props.hashtag
	  };
	}, {
	  quote: _propTypes2.default.string,
	  hashtag: _propTypes2.default.string
	}, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	var TwitterShareButton = exports.TwitterShareButton = createShareButton('twitter', function (props) {
	  return {
	    hashtags: props.hashtags,
	    title: props.title,
	    via: props.via
	  };
	}, {
	  hashtags: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  title: _propTypes2.default.string,
	  via: _propTypes2.default.string
	}, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	var TelegramShareButton = exports.TelegramShareButton = createShareButton('telegram', function (props) {
	  return {
	    title: props.title,
	    via: props.via
	  };
	}, {
	  title: _propTypes2.default.string,
	  via: _propTypes2.default.string
	}, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	var WhatsappShareButton = exports.WhatsappShareButton = createShareButton('whatsapp', function (props) {
	  return {
	    title: props.title,
	    separator: props.separator
	  };
	}, {
	  title: _propTypes2.default.string,
	  separator: _propTypes2.default.string
	}, {
	  separator: ' ',
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	var EmailShareButton = exports.EmailShareButton = createShareButton('email', function (props) {
	  return {
	    subject: props.subject,
	    body: props.body
	  };
	}, {
	  subject: _propTypes2.default.string,
	  body: _propTypes2.default.string
	}, {
	  openWindow: false,
	  onClick: function onClick(link) {
	    window.location.href = link;
	  }
	});
	
	var GooglePlusShareButton = exports.GooglePlusShareButton = createShareButton('googlePlus', undefined, undefined, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	var LinkedinShareButton = exports.LinkedinShareButton = createShareButton('linkedin', function (props) {
	  return {
	    title: props.title,
	    description: props.description
	  };
	}, {
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string
	}, {
	  windowWidth: 750,
	  windowHeight: 600
	});
	
	var PinterestShareButton = exports.PinterestShareButton = createShareButton('pinterest', function (props) {
	  return {
	    media: props.media,
	    description: props.description
	  };
	}, {
	  media: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string
	}, {
	  windowWidth: 1000,
	  windowHeight: 730
	});
	
	var VKShareButton = exports.VKShareButton = createShareButton('vk', function (props) {
	  return {
	    title: props.title,
	    description: props.description,
	    image: props.image
	  };
	}, {
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  image: _propTypes2.default.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	var OKShareButton = exports.OKShareButton = createShareButton('ok', function (props) {
	  return {
	    title: props.title,
	    description: props.description,
	    image: props.image
	  };
	}, {
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  image: _propTypes2.default.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	var RedditShareButton = exports.RedditShareButton = createShareButton('reddit', function (props) {
	  return {
	    title: props.title
	  };
	}, {
	  title: _propTypes2.default.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	var TumblrShareButton = exports.TumblrShareButton = createShareButton('tumblr', function (props) {
	  return {
	    title: props.title,
	    tags: props.tags.join(','),
	    caption: props.caption,
	    posttype: props.posttype
	  };
	}, {
	  title: _propTypes2.default.string,
	  caption: _propTypes2.default.string,
	  posttype: _propTypes2.default.string,
	  tags: _propTypes2.default.arrayOf(_propTypes2.default.string)
	}, {
	  tags: [],
	  posttype: 'link',
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	var LivejournalShareButton = exports.LivejournalShareButton = createShareButton('livejournal', function (props) {
	  return {
	    title: props.title,
	    description: props.description
	  };
	}, {
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	var MailruShareButton = exports.MailruShareButton = createShareButton('mailru', function (props) {
	  return {
	    title: props.title,
	    description: props.description,
	    image: props.image
	  };
	}, {
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  image: _propTypes2.default.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TwitterShareCount = exports.TumblrShareCount = exports.RedditShareCount = exports.OKShareCount = exports.VKShareCount = exports.PinterestShareCount = exports.GooglePlusShareCount = exports.LinkedinShareCount = exports.FacebookShareCount = undefined;
	
	var _extends2 = __webpack_require__(140);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(221);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(223);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(224);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(226);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(225);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(38);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shareCountGetters = __webpack_require__(347);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/no-multi-comp */
	var SocialMediaShareCount = function (_Component) {
	  (0, _inherits3.default)(SocialMediaShareCount, _Component);
	
	  function SocialMediaShareCount(props) {
	    (0, _classCallCheck3.default)(this, SocialMediaShareCount);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SocialMediaShareCount.__proto__ || (0, _getPrototypeOf2.default)(SocialMediaShareCount)).call(this, props));
	
	    _this._isMounted = false;
	    _this.state = { count: 0 };
	    return _this;
	  }
	
	  (0, _createClass3.default)(SocialMediaShareCount, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._isMounted = true;
	      this.updateCount(this.props.url);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.url !== this.props.url) {
	        this.updateCount(nextProps.url);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	    }
	  }, {
	    key: 'updateCount',
	    value: function updateCount(url) {
	      var _this2 = this;
	
	      if (this.props.getCount) {
	        this.setState({
	          isLoading: true
	        });
	
	        this.props.getCount(url, function (count) {
	          if (_this2._isMounted) {
	            _this2.setState({
	              count: count,
	              isLoading: false
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          count = _state.count,
	          isLoading = _state.isLoading;
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('SocialMediaShareCount', className) },
	        !isLoading && children(count || 0)
	      );
	    }
	  }]);
	  return SocialMediaShareCount;
	}(_react.Component);
	
	SocialMediaShareCount.propTypes = {
	  children: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  getCount: _propTypes2.default.func,
	  url: _propTypes2.default.string.isRequired
	};
	
	SocialMediaShareCount.defaultProps = {
	  children: function children(shareCount) {
	    return shareCount;
	  }
	};
	
	function shareCountFactory(getCount) {
	  return function (props) {
	    return _react2.default.createElement(SocialMediaShareCount, (0, _extends3.default)({ getCount: getCount }, props));
	  };
	}
	
	var FacebookShareCount = exports.FacebookShareCount = shareCountFactory(_shareCountGetters.getFacebookShareCount);
	var LinkedinShareCount = exports.LinkedinShareCount = shareCountFactory(_shareCountGetters.getLinkedinShareCount);
	var GooglePlusShareCount = exports.GooglePlusShareCount = shareCountFactory(_shareCountGetters.getGooglePlusShareCount);
	var PinterestShareCount = exports.PinterestShareCount = shareCountFactory(_shareCountGetters.getPinterestShareCount);
	var VKShareCount = exports.VKShareCount = shareCountFactory(_shareCountGetters.getVKShareCount);
	var OKShareCount = exports.OKShareCount = shareCountFactory(_shareCountGetters.getOKShareCount);
	var RedditShareCount = exports.RedditShareCount = shareCountFactory(_shareCountGetters.getRedditShareCount);
	var TumblrShareCount = exports.TumblrShareCount = shareCountFactory(_shareCountGetters.getTumblrShareCount);
	var TwitterShareCount = exports.TwitterShareCount = function TwitterShareCount() {
	  throw new Error('TwitterShareCount was removed in version 1.3.0 because' + 'the Twitter API was shut down and there is no replacement. Please ' + 'remove it from your code.');
	};

/***/ },
/* 885 */
404,
/* 886 */
404,
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(886),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(887);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(34);
	
	var findDOMNode = __webpack_require__(201);
	var focusNode = __webpack_require__(247);
	
	var Mixin = {
	  componentDidMount: function () {
	    if (this.props.autoFocus) {
	      focusNode(findDOMNode(this));
	    }
	  }
	};
	
	var AutoFocusUtils = {
	  Mixin: Mixin,
	
	  focusDOMComponent: function () {
	    focusNode(ReactMount.getNode(this._rootNodeID));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015 Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(48);
	var EventPropagators = __webpack_require__(97);
	var ExecutionEnvironment = __webpack_require__(30);
	var FallbackCompositionState = __webpack_require__(898);
	var SyntheticCompositionEvent = __webpack_require__(928);
	var SyntheticInputEvent = __webpack_require__(931);
	
	var keyOf = __webpack_require__(53);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(349);
	var ExecutionEnvironment = __webpack_require__(30);
	var ReactPerf = __webpack_require__(40);
	
	var camelizeStyleName = __webpack_require__(634);
	var dangerousStyleValue = __webpack_require__(936);
	var hyphenateStyleName = __webpack_require__(639);
	var memoizeStringOnly = __webpack_require__(643);
	var warning = __webpack_require__(16);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	
	  var warnHyphenatedStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?', name, camelizeStyleName(name)) : undefined;
	  };
	
	  var warnBadVendoredStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1)) : undefined;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon. ' + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, '')) : undefined;
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   */
	  var warnValidStyle = function (name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   */
	  setValueForStyles: function (node, styles) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName]);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
	      if (styleName === 'float') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(CSSPropertyOperations, 'CSSPropertyOperations', {
	  setValueForStyles: 'setValueForStyles'
	});
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(48);
	var EventPluginHub = __webpack_require__(96);
	var EventPropagators = __webpack_require__(97);
	var ExecutionEnvironment = __webpack_require__(30);
	var ReactUpdates = __webpack_require__(41);
	var SyntheticEvent = __webpack_require__(68);
	
	var getEventTarget = __webpack_require__(204);
	var isEventSupported = __webpack_require__(207);
	var isTextInputElement = __webpack_require__(376);
	var keyOf = __webpack_require__(53);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementID = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementID, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementID = null;
	}
	
	function getTargetIDForChangeEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return topLevelTargetID;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For old IE.) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For old IE.) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For old IE.) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementID = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For old IE.) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetIDForInputEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return topLevelTargetID;
	  }
	}
	
	// For IE8 and IE9.
	function handleEventsForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetIDForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementID;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetIDForClickEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return topLevelTargetID;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	
	    var getTargetIDFunc, handleEventFunc;
	    if (shouldUseChangeEvent(topLevelTarget)) {
	      if (doesChangeEventBubble) {
	        getTargetIDFunc = getTargetIDForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(topLevelTarget)) {
	      if (isInputEventSupported) {
	        getTargetIDFunc = getTargetIDForInputEvent;
	      } else {
	        getTargetIDFunc = getTargetIDForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(topLevelTarget)) {
	      getTargetIDFunc = getTargetIDForClickEvent;
	    }
	
	    if (getTargetIDFunc) {
	      var targetID = getTargetIDFunc(topLevelType, topLevelTarget, topLevelTargetID);
	      if (targetID) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, targetID, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, topLevelTarget, topLevelTargetID);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 893 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ClientReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var nextReactRootIndex = 0;
	
	var ClientReactRootIndex = {
	  createReactRootIndex: function () {
	    return nextReactRootIndex++;
	  }
	};
	
	module.exports = ClientReactRootIndex;

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var createNodesFromMarkup = __webpack_require__(636);
	var emptyFunction = __webpack_require__(42);
	var getMarkupWrap = __webpack_require__(249);
	var invariant = __webpack_require__(14);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function (markupList) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : undefined;
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      !markupList[i] ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : undefined;
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
	          // This index will be parsed back out below.
	          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          !!resultList.hasOwnProperty(resultIndex) ?  false ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : undefined;
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	        } else if (false) {
	          console.error('Danger: Discarding unexpected node:', renderNode);
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    !(resultListAssignmentCount === resultList.length) ?  false ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : undefined;
	
	    !(resultList.length === markupList.length) ?  false ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : undefined;
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : undefined;
	    !(oldChild.tagName.toLowerCase() !== 'html') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : undefined;
	
	    var newChild;
	    if (typeof markup === 'string') {
	      newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	    } else {
	      newChild = markup;
	    }
	    oldChild.parentNode.replaceChild(newChild, oldChild);
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(53);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(48);
	var EventPropagators = __webpack_require__(97);
	var SyntheticMouseEvent = __webpack_require__(129);
	
	var ReactMount = __webpack_require__(34);
	var keyOf = __webpack_require__(53);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	var getFirstReactDOM = ReactMount.getFirstReactDOM;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var extractedEvents = [null, null];
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (topLevelTarget.window === topLevelTarget) {
	      // `topLevelTarget` is probably a window object.
	      win = topLevelTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = topLevelTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    var fromID = '';
	    var toID = '';
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = topLevelTarget;
	      fromID = topLevelTargetID;
	      to = getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement);
	      if (to) {
	        toID = ReactMount.getID(to);
	      } else {
	        to = win;
	      }
	      to = to || win;
	    } else {
	      from = win;
	      to = topLevelTarget;
	      toID = topLevelTargetID;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, fromID, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = from;
	    leave.relatedTarget = to;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, toID, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = to;
	    enter.relatedTarget = from;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);
	
	    extractedEvents[0] = leave;
	    extractedEvents[1] = enter;
	
	    return extractedEvents;
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(48);
	var ReactErrorUtils = __webpack_require__(364);
	
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(16);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `Mount`: [required] Module that can convert between React dom IDs and
	 *   actual node references.
	 */
	var injection = {
	  Mount: null,
	  injectMount: function (InjectedMount) {
	    injection.Mount = InjectedMount;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(InjectedMount && InjectedMount.getNode && InjectedMount.getID, 'EventPluginUtils.injection.injectMount(...): Injected Mount ' + 'module is missing getNode or getID.') : undefined;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchIDs = event._dispatchIDs;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var idsIsArr = Array.isArray(dispatchIDs);
	    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(idsIsArr === listenersIsArr && IDsLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : undefined;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {string} domID DOM id to pass to the callback.
	 */
	function executeDispatch(event, simulated, listener, domID) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = injection.Mount.getNode(domID);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event, domID);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event, domID);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchIDs[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchIDs);
	  }
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchIDs[i])) {
	        return dispatchIDs[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchIDs)) {
	      return dispatchIDs;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchIDs = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchID = event._dispatchIDs;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : undefined;
	  var res = dispatchListener ? dispatchListener(event, dispatchID) : null;
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getNode: function (id) {
	    return injection.Mount.getNode(id);
	  },
	  getID: function (node) {
	    return injection.Mount.getID(node);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(59);
	
	var assign = __webpack_require__(17);
	var getTextContentAccessor = __webpack_require__(375);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(80);
	var ExecutionEnvironment = __webpack_require__(30);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var hasSVG;
	if (ExecutionEnvironment.canUseDOM) {
	  var implementation = document.implementation;
	  hasSVG = implementation && implementation.hasFeature && implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
	}
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(/^(data|aria)-[a-z_][a-z\d_.\-]*$/),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: null,
	    acceptCharset: null,
	    accessKey: null,
	    action: null,
	    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    allowTransparency: MUST_USE_ATTRIBUTE,
	    alt: null,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: null,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    cellPadding: null,
	    cellSpacing: null,
	    charSet: MUST_USE_ATTRIBUTE,
	    challenge: MUST_USE_ATTRIBUTE,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    classID: MUST_USE_ATTRIBUTE,
	    // To set className on SVG elements, it's necessary to use .setAttribute;
	    // this works on HTML elements too in all browsers except IE8. Conveniently,
	    // IE8 doesn't support SVG and so we can simply use the attribute in
	    // browsers that support SVG and the property in browsers that don't,
	    // regardless of whether the element is HTML or SVG.
	    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
	    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: null,
	    content: null,
	    contentEditable: null,
	    contextMenu: MUST_USE_ATTRIBUTE,
	    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    coords: null,
	    crossOrigin: null,
	    data: null, // For `<object />` acts as `src`.
	    dateTime: MUST_USE_ATTRIBUTE,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: null,
	    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: null,
	    encType: null,
	    form: MUST_USE_ATTRIBUTE,
	    formAction: MUST_USE_ATTRIBUTE,
	    formEncType: MUST_USE_ATTRIBUTE,
	    formMethod: MUST_USE_ATTRIBUTE,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: MUST_USE_ATTRIBUTE,
	    frameBorder: MUST_USE_ATTRIBUTE,
	    headers: null,
	    height: MUST_USE_ATTRIBUTE,
	    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    high: null,
	    href: null,
	    hrefLang: null,
	    htmlFor: null,
	    httpEquiv: null,
	    icon: null,
	    id: MUST_USE_PROPERTY,
	    inputMode: MUST_USE_ATTRIBUTE,
	    integrity: null,
	    is: MUST_USE_ATTRIBUTE,
	    keyParams: MUST_USE_ATTRIBUTE,
	    keyType: MUST_USE_ATTRIBUTE,
	    kind: null,
	    label: null,
	    lang: null,
	    list: MUST_USE_ATTRIBUTE,
	    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    low: null,
	    manifest: MUST_USE_ATTRIBUTE,
	    marginHeight: null,
	    marginWidth: null,
	    max: null,
	    maxLength: MUST_USE_ATTRIBUTE,
	    media: MUST_USE_ATTRIBUTE,
	    mediaGroup: null,
	    method: null,
	    min: null,
	    minLength: MUST_USE_ATTRIBUTE,
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: null,
	    nonce: MUST_USE_ATTRIBUTE,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: null,
	    pattern: null,
	    placeholder: null,
	    poster: null,
	    preload: null,
	    radioGroup: null,
	    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    rel: null,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: MUST_USE_ATTRIBUTE,
	    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: null,
	    sandbox: null,
	    scope: null,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: null,
	    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: null,
	    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: MUST_USE_ATTRIBUTE,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: null,
	    src: null,
	    srcDoc: MUST_USE_PROPERTY,
	    srcLang: null,
	    srcSet: MUST_USE_ATTRIBUTE,
	    start: HAS_NUMERIC_VALUE,
	    step: null,
	    style: null,
	    summary: null,
	    tabIndex: null,
	    target: null,
	    title: null,
	    type: null,
	    useMap: null,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: MUST_USE_ATTRIBUTE,
	    wmode: MUST_USE_ATTRIBUTE,
	    wrap: null,
	
	    /**
	     * RDFa Properties
	     */
	    about: MUST_USE_ATTRIBUTE,
	    datatype: MUST_USE_ATTRIBUTE,
	    inlist: MUST_USE_ATTRIBUTE,
	    prefix: MUST_USE_ATTRIBUTE,
	    // property is also supported for OpenGraph in meta tags.
	    property: MUST_USE_ATTRIBUTE,
	    resource: MUST_USE_ATTRIBUTE,
	    'typeof': MUST_USE_ATTRIBUTE,
	    vocab: MUST_USE_ATTRIBUTE,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: MUST_USE_ATTRIBUTE,
	    autoCorrect: MUST_USE_ATTRIBUTE,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: null,
	    // color is for Safari mask-icon link
	    color: null,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: MUST_USE_ATTRIBUTE,
	    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    itemType: MUST_USE_ATTRIBUTE,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: MUST_USE_ATTRIBUTE,
	    itemRef: MUST_USE_ATTRIBUTE,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: null,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: MUST_USE_ATTRIBUTE,
	    // IE-only attribute that controls focus behavior
	    unselectable: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {
	    autoComplete: 'autocomplete',
	    autoFocus: 'autofocus',
	    autoPlay: 'autoplay',
	    autoSave: 'autosave',
	    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
	    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
	    encType: 'encoding',
	    hrefLang: 'hreflang',
	    radioGroup: 'radiogroup',
	    spellCheck: 'spellcheck',
	    srcDoc: 'srcdoc',
	    srcSet: 'srcset'
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(355);
	var ReactDOMServer = __webpack_require__(910);
	var ReactIsomorphic = __webpack_require__(915);
	
	var assign = __webpack_require__(17);
	var deprecated = __webpack_require__(937);
	
	// `version` will be added here by ReactIsomorphic.
	var React = {};
	
	assign(React, ReactIsomorphic);
	
	assign(React, {
	  // ReactDOM
	  findDOMNode: deprecated('findDOMNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.findDOMNode),
	  render: deprecated('render', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.render),
	  unmountComponentAtNode: deprecated('unmountComponentAtNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.unmountComponentAtNode),
	
	  // ReactDOMServer
	  renderToString: deprecated('renderToString', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToString),
	  renderToStaticMarkup: deprecated('renderToStaticMarkup', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToStaticMarkup)
	});
	
	React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOM;
	React.__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOMServer;
	
	module.exports = React;

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserComponentMixin
	 */
	
	'use strict';
	
	var ReactInstanceMap = __webpack_require__(98);
	
	var findDOMNode = __webpack_require__(201);
	var warning = __webpack_require__(16);
	
	var didWarnKey = '_getDOMNodeDidWarn';
	
	var ReactBrowserComponentMixin = {
	  /**
	   * Returns the DOM node rendered by this component.
	   *
	   * @return {DOMElement} The root node of this component.
	   * @final
	   * @protected
	   */
	  getDOMNode: function () {
	     false ? warning(this.constructor[didWarnKey], '%s.getDOMNode(...) is deprecated. Please use ' + 'ReactDOM.findDOMNode(instance) instead.', ReactInstanceMap.get(this).getName() || this.tagName || 'Unknown') : undefined;
	    this.constructor[didWarnKey] = true;
	    return findDOMNode(this);
	  }
	};
	
	module.exports = ReactBrowserComponentMixin;

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(67);
	
	var instantiateReactComponent = __webpack_require__(206);
	var shouldUpdateReactComponent = __webpack_require__(209);
	var traverseAllChildren = __webpack_require__(210);
	var warning = __webpack_require__(16);
	
	function instantiateChild(childInstances, child, name) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, null);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, transaction, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return null;
	    }
	    var name;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      var prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          ReactReconciler.unmountComponent(prevChild, name);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, null);
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        ReactReconciler.unmountComponent(prevChildren[name]);
	      }
	    }
	    return nextChildren;
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(197);
	var ReactCurrentOwner = __webpack_require__(49);
	var ReactElement = __webpack_require__(35);
	var ReactInstanceMap = __webpack_require__(98);
	var ReactPerf = __webpack_require__(40);
	var ReactPropTypeLocations = __webpack_require__(128);
	var ReactPropTypeLocationNames = __webpack_require__(127);
	var ReactReconciler = __webpack_require__(67);
	var ReactUpdateQueue = __webpack_require__(199);
	
	var assign = __webpack_require__(17);
	var emptyObject = __webpack_require__(90);
	var invariant = __webpack_require__(14);
	var shouldUpdateReactComponent = __webpack_require__(209);
	var warning = __webpack_require__(16);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  return Component(this.props, this.context, this.updater);
	};
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	
	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedComponent = null;
	
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._rootNodeID = rootID;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    // Initialize the public class
	    var inst;
	    var renderedElement;
	
	    // This is a way to detect if Component is a stateless arrow function
	    // component, which is not newable. It might not be 100% reliable but is
	    // something we can do until we start detecting that Component extends
	    // React.Component. We already assume that typeof Component === 'function'.
	    var canInstantiate = ('prototype' in Component);
	
	    if (canInstantiate) {
	      if (false) {
	        ReactCurrentOwner.current = this;
	        try {
	          inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	        } finally {
	          ReactCurrentOwner.current = null;
	        }
	      } else {
	        inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	      }
	    }
	
	    if (!canInstantiate || inst === null || inst === false || ReactElement.isValidElement(inst)) {
	      renderedElement = inst;
	      inst = new StatelessComponent(Component);
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`, returned ' + 'null/false from a stateless component, or tried to render an ' + 'element whose type is a function that isn\'t a React component.', Component.displayName || Component.name || 'Component') : undefined;
	      } else {
	        // We support ES6 inheriting from React.Component, the module pattern,
	        // and stateless components, but not ES6 classes that don't extend
	        process.env.NODE_ENV !== 'production' ? warning(Component.prototype && Component.prototype.isReactComponent || !canInstantiate || !(inst instanceof Component), '%s(...): React component classes must extend React.Component.', Component.displayName || Component.name || 'Component') : undefined;
	      }
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = ReactUpdateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : undefined;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    if (inst.componentWillMount) {
	      inst.componentWillMount();
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    this._renderedComponent = this._instantiateReactComponent(renderedElement);
	
	    var markup = ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, this._processChildContext(context));
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }
	
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function () {
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount) {
	      inst.componentWillUnmount();
	    }
	
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    this._renderedComponent = null;
	    this._instance = null;
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var maskedContext = null;
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	      if (false) {
	        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : undefined;
	      }
	      return assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function (newProps) {
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.propTypes) {
	        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function (propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	          error = propTypes[propName](props, propName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // top-level render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	             false ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : undefined;
	          } else {
	             false ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : undefined;
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement || this._currentElement, transaction, this._context);
	    }
	
	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	
	    var nextContext = this._context === nextUnmaskedContext ? inst.context : this._processContext(nextUnmaskedContext);
	    var nextProps;
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement === nextParentElement) {
	      // Skip checking prop types again -- we don't read inst.props to avoid
	      // warning for DOM component props in this upgrade
	      nextProps = nextParentElement.props;
	    } else {
	      nextProps = this._processProps(nextParentElement.props);
	      // An update here will schedule an update but immediately set
	      // _pendingStateQueue which will ensure that any state updates gets
	      // immediately reconciled instead of waiting for the next batch.
	
	      if (inst.componentWillReceiveProps) {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	
	    var shouldUpdate = this._pendingForceUpdate || !inst.shouldComponentUpdate || inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(typeof shouldUpdate !== 'undefined', '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : undefined;
	    }
	
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      // These two IDs are actually the same! But nothing should rely on that.
	      var thisID = this._rootNodeID;
	      var prevComponentID = prevComponentInstance._rootNodeID;
	      ReactReconciler.unmountComponent(prevComponentInstance);
	
	      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
	      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, thisID, transaction, this._processChildContext(context));
	      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  _replaceNodeWithMarkupByID: function (prevComponentID, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (typeof renderedComponent === 'undefined' && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactCurrentOwner.current = null;
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid ReactComponent must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : undefined;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : undefined;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (inst instanceof StatelessComponent) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	ReactPerf.measureMethods(ReactCompositeComponentMixin, 'ReactCompositeComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent',
	  _renderValidatedComponent: '_renderValidatedComponent'
	});
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 904 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var mouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getNativeProps: function (inst, props, context) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var nativeProps = {};
	    for (var key in props) {
	      if (props.hasOwnProperty(key) && !mouseListenerNames[key]) {
	        nativeProps[key] = props[key];
	      }
	    }
	
	    return nativeProps;
	  }
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 * @typechecks static-only
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var AutoFocusUtils = __webpack_require__(889);
	var CSSPropertyOperations = __webpack_require__(891);
	var DOMProperty = __webpack_require__(80);
	var DOMPropertyOperations = __webpack_require__(194);
	var EventConstants = __webpack_require__(48);
	var ReactBrowserEventEmitter = __webpack_require__(126);
	var ReactComponentBrowserEnvironment = __webpack_require__(196);
	var ReactDOMButton = __webpack_require__(904);
	var ReactDOMInput = __webpack_require__(907);
	var ReactDOMOption = __webpack_require__(908);
	var ReactDOMSelect = __webpack_require__(357);
	var ReactDOMTextarea = __webpack_require__(911);
	var ReactMount = __webpack_require__(34);
	var ReactMultiChild = __webpack_require__(916);
	var ReactPerf = __webpack_require__(40);
	var ReactUpdateQueue = __webpack_require__(199);
	
	var assign = __webpack_require__(17);
	var canDefineProperty = __webpack_require__(131);
	var escapeTextContentForBrowser = __webpack_require__(132);
	var invariant = __webpack_require__(14);
	var isEventSupported = __webpack_require__(207);
	var keyOf = __webpack_require__(53);
	var setInnerHTML = __webpack_require__(133);
	var setTextContent = __webpack_require__(208);
	var shallowEqual = __webpack_require__(250);
	var validateDOMNesting = __webpack_require__(211);
	var warning = __webpack_require__(16);
	
	var deleteListener = ReactBrowserEventEmitter.deleteListener;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var CHILDREN = keyOf({ children: null });
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	
	var ELEMENT_NODE_TYPE = 1;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	var legacyPropsDescriptor;
	if (false) {
	  legacyPropsDescriptor = {
	    props: {
	      enumerable: false,
	      get: function () {
	        var component = this._reactInternalComponent;
	        process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .props of a DOM node; instead, ' + 'recreate the props as `render` did originally or read the DOM ' + 'properties/attributes directly from this node (e.g., ' + 'this.refs.box.className).%s', getDeclarationErrorAddendum(component)) : undefined;
	        return component._currentElement.props;
	      }
	    }
	  };
	}
	
	function legacyGetDOMNode() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .getDOMNode() of a DOM node; ' + 'instead, use the node directly.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return this;
	}
	
	function legacyIsMounted() {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .isMounted() of a DOM node.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return !!component;
	}
	
	function legacySetStateEtc() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setState(), .replaceState(), or ' + '.forceUpdate() of a DOM node. This is a no-op.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	}
	
	function legacySetProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueSetPropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function legacyReplaceProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .replaceProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueReplacePropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined becauses undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : undefined;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (false) {
	    if (voidElementTags[component._tag]) {
	      process.env.NODE_ENV !== 'production' ? warning(props.children == null && props.dangerouslySetInnerHTML == null, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : undefined;
	    }
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : undefined;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : undefined;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : undefined;
	    process.env.NODE_ENV !== 'production' ? warning(!props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : undefined;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : undefined;
	}
	
	function enqueuePutListener(id, registrationName, listener, transaction) {
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : undefined;
	  }
	  var container = ReactMount.findReactContainerForID(id);
	  if (container) {
	    var doc = container.nodeType === ELEMENT_NODE_TYPE ? container.ownerDocument : container;
	    listenTo(registrationName, doc);
	  }
	  transaction.getReactMountReady().enqueue(putListener, {
	    id: id,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  ReactBrowserEventEmitter.putListener(listenerToPut.id, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : invariant(false) : undefined;
	  var node = ReactMount.getNode(inst._rootNodeID);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : undefined;
	
	  switch (inst._tag) {
	    case 'iframe':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	  }
	}
	
	function mountReadyInputWrapper() {
	  ReactDOMInput.mountReadyWrapper(this);
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special cased tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = ({}).hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : undefined;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function processChildContextDev(context, inst) {
	  // Pass down our tag name to child components for validation purposes
	  context = assign({}, context);
	  var info = context[validateDOMNesting.ancestorInfoContextKey];
	  context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(info, inst._tag, inst);
	  return context;
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(tag) {
	  validateDangerousTag(tag);
	  this._tag = tag.toLowerCase();
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._rootNodeID = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._nodeWithLegacyProperties = null;
	  if (false) {
	    this._unprocessedContextDev = null;
	    this._processedContextDev = null;
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  construct: function (element) {
	    this._currentElement = element;
	  },
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {string} rootID The root DOM ID for this node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._rootNodeID = rootID;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getNativeProps(this, props, context);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, context);
	        props = ReactDOMInput.getNativeProps(this, props, context);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, context);
	        props = ReactDOMOption.getNativeProps(this, props, context);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, context);
	        props = ReactDOMSelect.getNativeProps(this, props, context);
	        context = ReactDOMSelect.processChildContext(this, props, context);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, context);
	        props = ReactDOMTextarea.getNativeProps(this, props, context);
	        break;
	    }
	
	    assertValidProps(this, props);
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting(this._tag, this, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    if (false) {
	      this._unprocessedContextDev = context;
	      this._processedContextDev = processChildContextDev(context, this);
	      context = this._processedContextDev;
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement(this._currentElement.type);
	      DOMPropertyOperations.setAttributeForID(el, this._rootNodeID);
	      // Populate node cache
	      ReactMount.getID(el);
	      this._updateDOMProperties({}, props, transaction, el);
	      this._createInitialChildren(transaction, props, context, el);
	      mountImage = el;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(mountReadyInputWrapper, this);
	      // falls through
	      case 'button':
	      case 'select':
	      case 'textarea':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this._rootNodeID, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (propKey !== CHILDREN) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
	    return ret + ' ' + markupForID;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, el) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        setInnerHTML(el, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        setTextContent(el, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          el.appendChild(mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
	        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
	        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
	        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
	        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
	        break;
	    }
	
	    if (false) {
	      // If the context is reference-equal to the old one, pass down the same
	      // processed object so the update bailout in ReactReconciler behaves
	      // correctly (and identically in dev and prod). See #5005.
	      if (this._unprocessedContextDev !== context) {
	        this._unprocessedContextDev = context;
	        this._processedContextDev = processChildContextDev(context, this);
	      }
	      context = this._processedContextDev;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction, null);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (!canDefineProperty && this._nodeWithLegacyProperties) {
	      this._nodeWithLegacyProperties.props = nextProps;
	    }
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction, node) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey)) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        DOMPropertyOperations.deleteValueForProperty(node, propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps[propKey];
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this._rootNodeID, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        if (propKey === CHILDREN) {
	          nextProp = null;
	        }
	        DOMPropertyOperations.setValueForAttribute(node, propKey, nextProp);
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertantly setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      if (!node) {
	        node = ReactMount.getNode(this._rootNodeID);
	      }
	      CSSPropertyOperations.setValueForStyles(node, styleUpdates);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function () {
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	        ReactDOMInput.unmountWrapper(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : undefined;
	        break;
	    }
	
	    this.unmountChildren();
	    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._wrapperState = null;
	    if (this._nodeWithLegacyProperties) {
	      var node = this._nodeWithLegacyProperties;
	      node._reactInternalComponent = null;
	      this._nodeWithLegacyProperties = null;
	    }
	  },
	
	  getPublicInstance: function () {
	    if (!this._nodeWithLegacyProperties) {
	      var node = ReactMount.getNode(this._rootNodeID);
	
	      node._reactInternalComponent = this;
	      node.getDOMNode = legacyGetDOMNode;
	      node.isMounted = legacyIsMounted;
	      node.setState = legacySetStateEtc;
	      node.replaceState = legacySetStateEtc;
	      node.forceUpdate = legacySetStateEtc;
	      node.setProps = legacySetProps;
	      node.replaceProps = legacyReplaceProps;
	
	      if (false) {
	        if (canDefineProperty) {
	          Object.defineProperties(node, legacyPropsDescriptor);
	        } else {
	          // updateComponent will update this property on subsequent renders
	          node.props = this._currentElement.props;
	        }
	      } else {
	        // updateComponent will update this property on subsequent renders
	        node.props = this._currentElement.props;
	      }
	
	      this._nodeWithLegacyProperties = node;
	    }
	    return this._nodeWithLegacyProperties;
	  }
	
	};
	
	ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent'
	});
	
	assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(35);
	var ReactElementValidator = __webpack_require__(361);
	
	var mapObject = __webpack_require__(642);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(198);
	var LinkedValueUtils = __webpack_require__(195);
	var ReactMount = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(41);
	
	var assign = __webpack_require__(17);
	var invariant = __webpack_require__(14);
	
	var instancesByReactID = {};
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getNativeProps: function (inst, props, context) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var nativeProps = assign({}, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  mountReadyWrapper: function (inst) {
	    // Can't be in mountWrapper or else server rendering leaks.
	    instancesByReactID[inst._rootNodeID] = inst;
	  },
	
	  unmountWrapper: function (inst) {
	    delete instancesByReactID[inst._rootNodeID];
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'checked', checked || false);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactMount.getNode(this._rootNodeID);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React with non-React.
	      var otherID = ReactMount.getID(otherNode);
	      !otherID ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : undefined;
	      var otherInstance = instancesByReactID[otherID];
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Unknown radio button ID %s.', otherID) : invariant(false) : undefined;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(352);
	var ReactDOMSelect = __webpack_require__(357);
	
	var assign = __webpack_require__(17);
	var warning = __webpack_require__(16);
	
	var valueContextKey = ReactDOMSelect.valueContextKey;
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, context) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : undefined;
	    }
	
	    // Look up whether this option is 'selected' via context
	    var selectValue = context[valueContextKey];
	
	    // If context key is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === '' + props.value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === '' + props.value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  getNativeProps: function (inst, props, context) {
	    var nativeProps = assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      nativeProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = '';
	
	    // Flatten children and warn if they aren't strings or numbers;
	    // invalid types are ignored.
	    ReactChildren.forEach(props.children, function (child) {
	      if (child == null) {
	        return;
	      }
	      if (typeof child === 'string' || typeof child === 'number') {
	        content += child;
	      } else {
	         false ? warning(false, 'Only strings and numbers are supported as <option> children.') : undefined;
	      }
	    });
	
	    if (content) {
	      nativeProps.children = content;
	    }
	
	    return nativeProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var getNodeForCharacterOffset = __webpack_require__(940);
	var getTextContentAccessor = __webpack_require__(375);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (typeof offsets.end === 'undefined') {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = typeof offsets.end === 'undefined' ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMServer
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(360);
	var ReactServerRendering = __webpack_require__(921);
	var ReactVersion = __webpack_require__(200);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(195);
	var ReactDOMIDOperations = __webpack_require__(198);
	var ReactUpdates = __webpack_require__(41);
	
	var assign = __webpack_require__(17);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(16);
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getNativeProps: function (inst, props, context) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : undefined;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    var nativeProps = assign({}, props, {
	      defaultValue: undefined,
	      value: undefined,
	      children: inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = props.children;
	    if (children != null) {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : undefined;
	      }
	      !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : undefined;
	      if (Array.isArray(children)) {
	        !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : undefined;
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(props);
	
	    inst._wrapperState = {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue),
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(96);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {object} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native environment event.
	   */
	  handleTopLevel: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventListener = __webpack_require__(245);
	var ExecutionEnvironment = __webpack_require__(30);
	var PooledClass = __webpack_require__(59);
	var ReactInstanceHandles = __webpack_require__(81);
	var ReactMount = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(41);
	
	var assign = __webpack_require__(17);
	var getEventTarget = __webpack_require__(204);
	var getUnboundedScrollPosition = __webpack_require__(637);
	
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * Finds the parent React component of `node`.
	 *
	 * @param {*} node
	 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
	 *                           is not nested.
	 */
	function findParent(node) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  var nodeID = ReactMount.getID(node);
	  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	  var container = ReactMount.findReactContainerForID(rootID);
	  var parent = ReactMount.getFirstReactDOM(container);
	  return parent;
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  // TODO: Re-enable event.path handling
	  //
	  // if (bookKeeping.nativeEvent.path && bookKeeping.nativeEvent.path.length > 1) {
	  //   // New browsers have a path attribute on native events
	  //   handleTopLevelWithPath(bookKeeping);
	  // } else {
	  //   // Legacy browsers don't have a path attribute on native events
	  //   handleTopLevelWithoutPath(bookKeeping);
	  // }
	
	  void handleTopLevelWithPath; // temporarily unused
	  handleTopLevelWithoutPath(bookKeeping);
	}
	
	// Legacy browsers don't have a path attribute on native events
	function handleTopLevelWithoutPath(bookKeeping) {
	  var topLevelTarget = ReactMount.getFirstReactDOM(getEventTarget(bookKeeping.nativeEvent)) || window;
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = topLevelTarget;
	  while (ancestor) {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = findParent(ancestor);
	  }
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    topLevelTarget = bookKeeping.ancestors[i];
	    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, topLevelTarget, topLevelTargetID, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	// New browsers have a path attribute on native events
	function handleTopLevelWithPath(bookKeeping) {
	  var path = bookKeeping.nativeEvent.path;
	  var currentNativeTarget = path[0];
	  var eventsFired = 0;
	  for (var i = 0; i < path.length; i++) {
	    var currentPathElement = path[i];
	    if (currentPathElement.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE) {
	      currentNativeTarget = path[i + 1];
	    }
	    // TODO: slow
	    var reactParent = ReactMount.getFirstReactDOM(currentPathElement);
	    if (reactParent === currentPathElement) {
	      var currentPathElementID = ReactMount.getID(currentPathElement);
	      var newRootID = ReactInstanceHandles.getReactRootIDFromNodeID(currentPathElementID);
	      bookKeeping.ancestors.push(currentPathElement);
	
	      var topLevelTargetID = ReactMount.getID(currentPathElement) || '';
	      eventsFired++;
	      ReactEventListener._handleTopLevel(bookKeeping.topLevelType, currentPathElement, topLevelTargetID, bookKeeping.nativeEvent, currentNativeTarget);
	
	      // Jump to the root of this React render tree
	      while (currentPathElementID !== newRootID) {
	        i++;
	        currentPathElement = path[i];
	        currentPathElementID = ReactMount.getID(currentPathElement);
	      }
	    }
	  }
	  if (eventsFired === 0) {
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, window, '', bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(80);
	var EventPluginHub = __webpack_require__(96);
	var ReactComponentEnvironment = __webpack_require__(197);
	var ReactClass = __webpack_require__(353);
	var ReactEmptyComponent = __webpack_require__(362);
	var ReactBrowserEventEmitter = __webpack_require__(126);
	var ReactNativeComponent = __webpack_require__(368);
	var ReactPerf = __webpack_require__(40);
	var ReactRootIndex = __webpack_require__(371);
	var ReactUpdates = __webpack_require__(41);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  RootIndex: ReactRootIndex.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactIsomorphic
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(352);
	var ReactComponent = __webpack_require__(354);
	var ReactClass = __webpack_require__(353);
	var ReactDOMFactories = __webpack_require__(906);
	var ReactElement = __webpack_require__(35);
	var ReactElementValidator = __webpack_require__(361);
	var ReactPropTypes = __webpack_require__(370);
	var ReactVersion = __webpack_require__(200);
	
	var assign = __webpack_require__(17);
	var onlyChild = __webpack_require__(941);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Hook for JSX spread, don't use this for anything else.
	  __spread: assign
	};
	
	module.exports = React;

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(197);
	var ReactMultiChildUpdateTypes = __webpack_require__(367);
	
	var ReactCurrentOwner = __webpack_require__(49);
	var ReactReconciler = __webpack_require__(67);
	var ReactChildReconciler = __webpack_require__(902);
	
	var flattenChildren = __webpack_require__(938);
	
	/**
	 * Updating children of a component may trigger recursive updates. The depth is
	 * used to batch recursive updates to render markup more efficiently.
	 *
	 * @type {number}
	 * @private
	 */
	var updateDepth = 0;
	
	/**
	 * Queue of update configuration objects.
	 *
	 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
	 *
	 * @type {array<object>}
	 * @private
	 */
	var updateQueue = [];
	
	/**
	 * Queue of markup to be rendered.
	 *
	 * @type {array<string>}
	 * @private
	 */
	var markupQueue = [];
	
	/**
	 * Enqueues markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function enqueueInsertMarkup(parentID, markup, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    markupIndex: markupQueue.push(markup) - 1,
	    content: null,
	    fromIndex: null,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues moving an existing element to another index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function enqueueMove(parentID, fromIndex, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues removing an element at an index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function enqueueRemove(parentID, fromIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the markup of a node.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function enqueueSetMarkup(parentID, markup) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    markupIndex: null,
	    content: markup,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the text content.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function enqueueTextContent(parentID, textContent) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    markupIndex: null,
	    content: textContent,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue() {
	  if (updateQueue.length) {
	    ReactComponentEnvironment.processChildrenUpdates(updateQueue, markupQueue);
	    clearQueue();
	  }
	}
	
	/**
	 * Clears any enqueued updates.
	 *
	 * @private
	 */
	function clearQueue() {
	  updateQueue.length = 0;
	  markupQueue.length = 0;
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	          var rootID = this._rootNodeID + name;
	          var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        // TODO: The setTextContent operation should be enough
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChild(prevChildren[name]);
	          }
	        }
	        // Set new text content.
	        this.setTextContent(nextContent);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChildByName(prevChildren[name], name);
	          }
	        }
	        this.setMarkup(nextMarkup);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        this._updateChildren(nextNestedChildrenElements, transaction, context);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, transaction, context);
	      this._renderedChildren = nextChildren;
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          this.moveChild(prevChild, nextIndex, lastIndex);
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            this._unmountChild(prevChild);
	          }
	          // The child must be instantiated before it's mounted.
	          this._mountChildByNameAtIndex(nextChild, name, nextIndex, transaction, context);
	        }
	        nextIndex++;
	      }
	      // Remove children that are no longer present.
	      for (name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	          this._unmountChild(prevChildren[name]);
	        }
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted.
	     *
	     * @internal
	     */
	    unmountChildren: function () {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, mountImage) {
	      enqueueInsertMarkup(this._rootNodeID, mountImage, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child) {
	      enqueueRemove(this._rootNodeID, child._mountIndex);
	    },
	
	    /**
	     * Sets this text content string.
	     *
	     * @param {string} textContent Text content to set.
	     * @protected
	     */
	    setTextContent: function (textContent) {
	      enqueueTextContent(this._rootNodeID, textContent);
	    },
	
	    /**
	     * Sets this markup string.
	     *
	     * @param {string} markup Markup to set.
	     * @protected
	     */
	    setMarkup: function (markup) {
	      enqueueSetMarkup(this._rootNodeID, markup);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildByNameAtIndex: function (child, name, index, transaction, context) {
	      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	      var rootID = this._rootNodeID + name;
	      var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	      child._mountIndex = index;
	      this.createChild(child, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child) {
	      this.removeChild(child);
	      child._mountIndex = null;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    // Check that `component` is still the current ref because we do not want to
	    // detach the ref if another component stole it.
	    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(193);
	var PooledClass = __webpack_require__(59);
	var ReactBrowserEventEmitter = __webpack_require__(126);
	var ReactDOMFeatureFlags = __webpack_require__(356);
	var ReactInputSelection = __webpack_require__(365);
	var Transaction = __webpack_require__(130);
	
	var assign = __webpack_require__(17);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(forceHTML) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = !forceHTML && ReactDOMFeatureFlags.useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(917);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 920 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerBatchingStrategy
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactServerRendering
	 */
	'use strict';
	
	var ReactDefaultBatchingStrategy = __webpack_require__(359);
	var ReactElement = __webpack_require__(35);
	var ReactInstanceHandles = __webpack_require__(81);
	var ReactMarkupChecksum = __webpack_require__(366);
	var ReactServerBatchingStrategy = __webpack_require__(920);
	var ReactServerRenderingTransaction = __webpack_require__(922);
	var ReactUpdates = __webpack_require__(41);
	
	var emptyObject = __webpack_require__(90);
	var instantiateReactComponent = __webpack_require__(206);
	var invariant = __webpack_require__(14);
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToString(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(false);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      var markup = componentInstance.mountComponent(id, transaction, emptyObject);
	      return ReactMarkupChecksum.addChecksumToMarkup(markup);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup, without the extra React ID and checksum
	 * (for generating static pages)
	 */
	function renderToStaticMarkup(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(true);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      return componentInstance.mountComponent(id, transaction, emptyObject);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 * @typechecks
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(59);
	var CallbackQueue = __webpack_require__(193);
	var Transaction = __webpack_require__(130);
	
	var assign = __webpack_require__(17);
	var emptyFunction = __webpack_require__(42);
	
	/**
	 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
	 * during the performing of the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  close: emptyFunction
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [ON_DOM_READY_QUEUEING];
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = false;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(80);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {
	    clipPath: MUST_USE_ATTRIBUTE,
	    cx: MUST_USE_ATTRIBUTE,
	    cy: MUST_USE_ATTRIBUTE,
	    d: MUST_USE_ATTRIBUTE,
	    dx: MUST_USE_ATTRIBUTE,
	    dy: MUST_USE_ATTRIBUTE,
	    fill: MUST_USE_ATTRIBUTE,
	    fillOpacity: MUST_USE_ATTRIBUTE,
	    fontFamily: MUST_USE_ATTRIBUTE,
	    fontSize: MUST_USE_ATTRIBUTE,
	    fx: MUST_USE_ATTRIBUTE,
	    fy: MUST_USE_ATTRIBUTE,
	    gradientTransform: MUST_USE_ATTRIBUTE,
	    gradientUnits: MUST_USE_ATTRIBUTE,
	    markerEnd: MUST_USE_ATTRIBUTE,
	    markerMid: MUST_USE_ATTRIBUTE,
	    markerStart: MUST_USE_ATTRIBUTE,
	    offset: MUST_USE_ATTRIBUTE,
	    opacity: MUST_USE_ATTRIBUTE,
	    patternContentUnits: MUST_USE_ATTRIBUTE,
	    patternUnits: MUST_USE_ATTRIBUTE,
	    points: MUST_USE_ATTRIBUTE,
	    preserveAspectRatio: MUST_USE_ATTRIBUTE,
	    r: MUST_USE_ATTRIBUTE,
	    rx: MUST_USE_ATTRIBUTE,
	    ry: MUST_USE_ATTRIBUTE,
	    spreadMethod: MUST_USE_ATTRIBUTE,
	    stopColor: MUST_USE_ATTRIBUTE,
	    stopOpacity: MUST_USE_ATTRIBUTE,
	    stroke: MUST_USE_ATTRIBUTE,
	    strokeDasharray: MUST_USE_ATTRIBUTE,
	    strokeLinecap: MUST_USE_ATTRIBUTE,
	    strokeOpacity: MUST_USE_ATTRIBUTE,
	    strokeWidth: MUST_USE_ATTRIBUTE,
	    textAnchor: MUST_USE_ATTRIBUTE,
	    transform: MUST_USE_ATTRIBUTE,
	    version: MUST_USE_ATTRIBUTE,
	    viewBox: MUST_USE_ATTRIBUTE,
	    x1: MUST_USE_ATTRIBUTE,
	    x2: MUST_USE_ATTRIBUTE,
	    x: MUST_USE_ATTRIBUTE,
	    xlinkActuate: MUST_USE_ATTRIBUTE,
	    xlinkArcrole: MUST_USE_ATTRIBUTE,
	    xlinkHref: MUST_USE_ATTRIBUTE,
	    xlinkRole: MUST_USE_ATTRIBUTE,
	    xlinkShow: MUST_USE_ATTRIBUTE,
	    xlinkTitle: MUST_USE_ATTRIBUTE,
	    xlinkType: MUST_USE_ATTRIBUTE,
	    xmlBase: MUST_USE_ATTRIBUTE,
	    xmlLang: MUST_USE_ATTRIBUTE,
	    xmlSpace: MUST_USE_ATTRIBUTE,
	    y1: MUST_USE_ATTRIBUTE,
	    y2: MUST_USE_ATTRIBUTE,
	    y: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {
	    clipPath: 'clip-path',
	    fillOpacity: 'fill-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    patternContentUnits: 'patternContentUnits',
	    patternUnits: 'patternUnits',
	    preserveAspectRatio: 'preserveAspectRatio',
	    spreadMethod: 'spreadMethod',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strokeDasharray: 'stroke-dasharray',
	    strokeLinecap: 'stroke-linecap',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    viewBox: 'viewBox',
	    xlinkActuate: 'xlink:actuate',
	    xlinkArcrole: 'xlink:arcrole',
	    xlinkHref: 'xlink:href',
	    xlinkRole: 'xlink:role',
	    xlinkShow: 'xlink:show',
	    xlinkTitle: 'xlink:title',
	    xlinkType: 'xlink:type',
	    xmlBase: 'xml:base',
	    xmlLang: 'xml:lang',
	    xmlSpace: 'xml:space'
	  }
	};
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(48);
	var EventPropagators = __webpack_require__(97);
	var ExecutionEnvironment = __webpack_require__(30);
	var ReactInputSelection = __webpack_require__(365);
	var SyntheticEvent = __webpack_require__(68);
	
	var getActiveElement = __webpack_require__(248);
	var isTextInputElement = __webpack_require__(376);
	var keyOf = __webpack_require__(53);
	var shallowEqual = __webpack_require__(250);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementID = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementID, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(topLevelTarget) || topLevelTarget.contentEditable === 'true') {
	          activeElement = topLevelTarget;
	          activeElementID = topLevelTargetID;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementID = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 925 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ServerReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Size of the reactRoot ID space. We generate random numbers for React root
	 * IDs and if there's a collision the events and DOM update system will
	 * get confused. In the future we need a way to generate GUIDs but for
	 * now this will work on a smaller scale.
	 */
	var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);
	
	var ServerReactRootIndex = {
	  createReactRootIndex: function () {
	    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
	  }
	};
	
	module.exports = ServerReactRootIndex;

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(48);
	var EventListener = __webpack_require__(245);
	var EventPropagators = __webpack_require__(97);
	var ReactMount = __webpack_require__(34);
	var SyntheticClipboardEvent = __webpack_require__(927);
	var SyntheticEvent = __webpack_require__(68);
	var SyntheticFocusEvent = __webpack_require__(930);
	var SyntheticKeyboardEvent = __webpack_require__(932);
	var SyntheticMouseEvent = __webpack_require__(129);
	var SyntheticDragEvent = __webpack_require__(929);
	var SyntheticTouchEvent = __webpack_require__(933);
	var SyntheticUIEvent = __webpack_require__(99);
	var SyntheticWheelEvent = __webpack_require__(934);
	
	var emptyFunction = __webpack_require__(42);
	var getEventCharCode = __webpack_require__(202);
	var invariant = __webpack_require__(14);
	var keyOf = __webpack_require__(53);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // FireFox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : undefined;
	    var event = EventConstructor.getPooled(dispatchConfig, topLevelTargetID, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var node = ReactMount.getNode(id);
	      if (!onClickListeners[id]) {
	        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (id, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      onClickListeners[id].remove();
	      delete onClickListeners[id];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(68);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(68);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(129);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(99);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(68);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(99);
	
	var getEventCharCode = __webpack_require__(202);
	var getEventKey = __webpack_require__(939);
	var getEventModifierState = __webpack_require__(203);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(99);
	
	var getEventModifierState = __webpack_require__(203);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(129);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 935 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    for (; i < Math.min(i + 4096, m); i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(349);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule deprecated
	 */
	
	'use strict';
	
	var assign = __webpack_require__(17);
	var warning = __webpack_require__(16);
	
	/**
	 * This will log a single deprecation notice per function and forward the call
	 * on to the new API.
	 *
	 * @param {string} fnName The name of the function
	 * @param {string} newModule The module that fn will exist in
	 * @param {string} newPackage The module that fn will exist in
	 * @param {*} ctx The context this forwarded call should run in
	 * @param {function} fn The function to forward on to
	 * @return {function} The function that will warn once and then call fn
	 */
	function deprecated(fnName, newModule, newPackage, ctx, fn) {
	  var warned = false;
	  if (false) {
	    var newFn = function () {
	      process.env.NODE_ENV !== 'production' ? warning(warned,
	      // Require examples in this string must be split to prevent React's
	      // build tools from mistaking them for real requires.
	      // Otherwise the build tools will attempt to build a '%s' module.
	      'React.%s is deprecated. Please use %s.%s from require' + '(\'%s\') ' + 'instead.', fnName, newModule, fnName, newPackage) : undefined;
	      warned = true;
	      return fn.apply(ctx, arguments);
	    };
	    // We need to make sure all properties of the original fn are copied over.
	    // In particular, this is needed to support PropTypes
	    return assign(newFn, fn);
	  }
	
	  return fn;
	}
	
	module.exports = deprecated;

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var traverseAllChildren = __webpack_require__(210);
	var warning = __webpack_require__(16);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = result[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.exports = flattenChildren;

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(202);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 940 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(35);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : undefined;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(132);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(34);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(163);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _isValid = __webpack_require__(134);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	  if (!(0, _isPromise2.default)(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (!(0, _isValid2.default)(errors)) {
	        stop(errors);
	        return Promise.reject();
	      } else if (rejected) {
	        stop();
	        throw new Error('Asynchronous validation promise was rejected without errors.');
	      }
	      stop();
	      return Promise.resolve();
	    };
	  };
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	
	exports.default = asyncValidation;

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createAll;
	
	var _reducer = __webpack_require__(214);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _createReduxForm = __webpack_require__(948);
	
	var _createReduxForm2 = _interopRequireDefault(_createReduxForm);
	
	var _mapValues = __webpack_require__(213);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _bindActionData = __webpack_require__(378);
	
	var _bindActionData2 = _interopRequireDefault(_bindActionData);
	
	var _actions = __webpack_require__(377);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _actionTypes = __webpack_require__(212);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _createPropTypes = __webpack_require__(947);
	
	var _createPropTypes2 = _interopRequireDefault(_createPropTypes);
	
	var _getValuesFromState = __webpack_require__(386);
	
	var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// bind form as first parameter of action creators
	var boundActions = _extends({}, (0, _mapValues2.default)(_extends({}, actions, {
	  autofillWithKey: function autofillWithKey(key) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _bindActionData2.default)(actions.autofill, { key: key }).apply(undefined, args);
	  },
	  changeWithKey: function changeWithKey(key) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    return (0, _bindActionData2.default)(actions.change, { key: key }).apply(undefined, args);
	  },
	  initializeWithKey: function initializeWithKey(key) {
	    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      args[_key3 - 1] = arguments[_key3];
	    }
	
	    return (0, _bindActionData2.default)(actions.initialize, { key: key }).apply(undefined, args);
	  },
	  reset: function reset(key) {
	    return (0, _bindActionData2.default)(actions.reset, { key: key })();
	  },
	  touchWithKey: function touchWithKey(key) {
	    for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	      args[_key4 - 1] = arguments[_key4];
	    }
	
	    return (0, _bindActionData2.default)(actions.touch, { key: key }).apply(undefined, args);
	  },
	  untouchWithKey: function untouchWithKey(key) {
	    for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	      args[_key5 - 1] = arguments[_key5];
	    }
	
	    return (0, _bindActionData2.default)(actions.untouch, { key: key }).apply(undefined, args);
	  },
	  destroy: function destroy(key) {
	    return (0, _bindActionData2.default)(actions.destroy, { key: key })();
	  }
	}), function (action) {
	  return function (form) {
	    for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	      args[_key6 - 1] = arguments[_key6];
	    }
	
	    return (0, _bindActionData2.default)(action, { form: form }).apply(undefined, args);
	  };
	}));
	
	var addArrayValue = boundActions.addArrayValue;
	var autofill = boundActions.autofill;
	var autofillWithKey = boundActions.autofillWithKey;
	var blur = boundActions.blur;
	var change = boundActions.change;
	var changeWithKey = boundActions.changeWithKey;
	var destroy = boundActions.destroy;
	var focus = boundActions.focus;
	var initialize = boundActions.initialize;
	var initializeWithKey = boundActions.initializeWithKey;
	var removeArrayValue = boundActions.removeArrayValue;
	var reset = boundActions.reset;
	var startAsyncValidation = boundActions.startAsyncValidation;
	var startSubmit = boundActions.startSubmit;
	var stopAsyncValidation = boundActions.stopAsyncValidation;
	var stopSubmit = boundActions.stopSubmit;
	var submitFailed = boundActions.submitFailed;
	var swapArrayValues = boundActions.swapArrayValues;
	var touch = boundActions.touch;
	var touchWithKey = boundActions.touchWithKey;
	var untouch = boundActions.untouch;
	var untouchWithKey = boundActions.untouchWithKey;
	
	function createAll(isReactNative, React, connect) {
	  return {
	    actionTypes: actionTypes,
	    addArrayValue: addArrayValue,
	    autofill: autofill,
	    autofillWithKey: autofillWithKey,
	    blur: blur,
	    change: change,
	    changeWithKey: changeWithKey,
	    destroy: destroy,
	    focus: focus,
	    getValues: _getValuesFromState2.default,
	    initialize: initialize,
	    initializeWithKey: initializeWithKey,
	    propTypes: (0, _createPropTypes2.default)(),
	    reduxForm: (0, _createReduxForm2.default)(isReactNative, React, connect),
	    reducer: _reducer2.default,
	    removeArrayValue: removeArrayValue,
	    reset: reset,
	    startAsyncValidation: startAsyncValidation,
	    startSubmit: startSubmit,
	    stopAsyncValidation: stopAsyncValidation,
	    stopSubmit: stopSubmit,
	    submitFailed: submitFailed,
	    swapArrayValues: swapArrayValues,
	    touch: touch,
	    touchWithKey: touchWithKey,
	    untouch: untouch,
	    untouchWithKey: untouchWithKey
	  };
	}

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(38);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actions = __webpack_require__(377);
	
	var importedActions = _interopRequireWildcard(_actions);
	
	var _getDisplayName = __webpack_require__(384);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _reducer = __webpack_require__(214);
	
	var _deepEqual = __webpack_require__(155);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _bindActionData = __webpack_require__(378);
	
	var _bindActionData2 = _interopRequireDefault(_bindActionData);
	
	var _getValues = __webpack_require__(385);
	
	var _getValues2 = _interopRequireDefault(_getValues);
	
	var _isValid = __webpack_require__(134);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _readFields = __webpack_require__(960);
	
	var _readFields2 = _interopRequireDefault(_readFields);
	
	var _handleSubmit2 = __webpack_require__(955);
	
	var _handleSubmit3 = _interopRequireDefault(_handleSubmit2);
	
	var _asyncValidation = __webpack_require__(944);
	
	var _asyncValidation2 = _interopRequireDefault(_asyncValidation);
	
	var _silenceEvents = __webpack_require__(954);
	
	var _silenceEvents2 = _interopRequireDefault(_silenceEvents);
	
	var _silenceEvent = __webpack_require__(383);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	var _wrapMapDispatchToProps = __webpack_require__(966);
	
	var _wrapMapDispatchToProps2 = _interopRequireDefault(_wrapMapDispatchToProps);
	
	var _wrapMapStateToProps = __webpack_require__(967);
	
	var _wrapMapStateToProps2 = _interopRequireDefault(_wrapMapStateToProps);
	
	var _createInitialState = __webpack_require__(379);
	
	var _createInitialState2 = _interopRequireDefault(_createInitialState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Creates a HOC that knows how to create redux-connected sub-components.
	 */
	var createHigherOrderComponent = function createHigherOrderComponent(config, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	  var Component = React.Component;
	
	  return function (reduxMountPoint, formName, formKey, getFormState) {
	    var _ref = options || {},
	        _ref$withRef = _ref.withRef,
	        withRef = _ref$withRef === undefined ? false : _ref$withRef;
	
	    var ReduxForm = function (_Component) {
	      _inherits(ReduxForm, _Component);
	
	      function ReduxForm(props) {
	        _classCallCheck(this, ReduxForm);
	
	        // bind functions
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.asyncValidate = _this.asyncValidate.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        var _this$props = _this.props,
	            initialValues = _this$props.initialValues,
	            submitPassback = _this$props.submitPassback;
	        // Check if form state was initialized, if not, initialize it.
	
	        var form = (0, _deepEqual2.default)(props.form, _reducer.initialState) ? (0, _createInitialState2.default)(initialValues, config.fields, {}, true, false) : props.form;
	        _this.fields = (0, _readFields2.default)(_extends({}, props, { form: form }), {}, {}, _this.asyncValidate, isReactNative);
	        submitPassback(function () {
	          return _this.handleSubmit();
	        }); // wrapped in function to disallow params
	        return _this;
	      }
	
	      ReduxForm.prototype.componentWillMount = function componentWillMount() {
	        var _props = this.props,
	            fields = _props.fields,
	            form = _props.form,
	            initialize = _props.initialize,
	            initialValues = _props.initialValues;
	
	        if (initialValues && !form._initialized) {
	          initialize(initialValues, fields);
	        }
	      };
	
	      ReduxForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!(0, _deepEqual2.default)(this.props.fields, nextProps.fields) || !(0, _deepEqual2.default)(this.props.form, nextProps.form, { strict: true })) {
	          this.fields = (0, _readFields2.default)(nextProps, this.props, this.fields, this.asyncValidate, isReactNative);
	        }
	        if (!(0, _deepEqual2.default)(this.props.initialValues, nextProps.initialValues)) {
	          this.props.initialize(nextProps.initialValues, nextProps.fields, this.props.overwriteOnInitialValuesChange || !this.props.form._initialized);
	        }
	      };
	
	      ReduxForm.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (config.destroyOnUnmount) {
	          this.props.destroy();
	        }
	      };
	
	      ReduxForm.prototype.asyncValidate = function asyncValidate(name, value) {
	        var _this2 = this;
	
	        var _props2 = this.props,
	            alwaysAsyncValidate = _props2.alwaysAsyncValidate,
	            asyncValidate = _props2.asyncValidate,
	            dispatch = _props2.dispatch,
	            fields = _props2.fields,
	            form = _props2.form,
	            startAsyncValidation = _props2.startAsyncValidation,
	            stopAsyncValidation = _props2.stopAsyncValidation,
	            validate = _props2.validate;
	
	        var isSubmitting = !name;
	        if (asyncValidate) {
	          var values = (0, _getValues2.default)(fields, form);
	          if (name) {
	            values[name] = value;
	          }
	          var syncErrors = validate(values, this.props);
	          var allPristine = this.fields._meta.allPristine;
	
	          var initialized = form._initialized;
	
	          // if blur validating, only run async validate if sync validation passes
	          // and submitting (not blur validation) or form is dirty or form was never initialized
	          // unless alwaysAsyncValidate is true
	          var syncValidationPasses = isSubmitting || (0, _isValid2.default)(syncErrors[name]);
	          if (alwaysAsyncValidate || syncValidationPasses && (isSubmitting || !allPristine || !initialized)) {
	            return (0, _asyncValidation2.default)(function () {
	              return asyncValidate(values, dispatch, _this2.props);
	            }, startAsyncValidation, stopAsyncValidation, name);
	          }
	        }
	      };
	
	      ReduxForm.prototype.handleSubmit = function handleSubmit(submitOrEvent) {
	        var _this3 = this;
	
	        var _props3 = this.props,
	            onSubmit = _props3.onSubmit,
	            fields = _props3.fields,
	            form = _props3.form;
	
	        var check = function check(submit) {
	          if (!submit || typeof submit !== 'function') {
	            throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	          }
	          return submit;
	        };
	        return !submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent) ?
	        // submitOrEvent is an event: fire submit
	        (0, _handleSubmit3.default)(check(onSubmit), (0, _getValues2.default)(fields, form), this.props, this.asyncValidate) :
	        // submitOrEvent is the submit function: return deferred submit thunk
	        (0, _silenceEvents2.default)(function () {
	          return (0, _handleSubmit3.default)(check(submitOrEvent), (0, _getValues2.default)(fields, form), _this3.props, _this3.asyncValidate);
	        });
	      };
	
	      ReduxForm.prototype.render = function render() {
	        var _this4 = this,
	            _ref2;
	
	        var allFields = this.fields;
	
	        var _props4 = this.props,
	            addArrayValue = _props4.addArrayValue,
	            asyncBlurFields = _props4.asyncBlurFields,
	            autofill = _props4.autofill,
	            blur = _props4.blur,
	            change = _props4.change,
	            destroy = _props4.destroy,
	            focus = _props4.focus,
	            fields = _props4.fields,
	            form = _props4.form,
	            initialValues = _props4.initialValues,
	            initialize = _props4.initialize,
	            onSubmit = _props4.onSubmit,
	            propNamespace = _props4.propNamespace,
	            reset = _props4.reset,
	            removeArrayValue = _props4.removeArrayValue,
	            returnRejectedSubmitPromise = _props4.returnRejectedSubmitPromise,
	            startAsyncValidation = _props4.startAsyncValidation,
	            startSubmit = _props4.startSubmit,
	            stopAsyncValidation = _props4.stopAsyncValidation,
	            stopSubmit = _props4.stopSubmit,
	            submitFailed = _props4.submitFailed,
	            swapArrayValues = _props4.swapArrayValues,
	            touch = _props4.touch,
	            untouch = _props4.untouch,
	            validate = _props4.validate,
	            passableProps = _objectWithoutProperties(_props4, ['addArrayValue', 'asyncBlurFields', 'autofill', 'blur', 'change', 'destroy', 'focus', 'fields', 'form', 'initialValues', 'initialize', 'onSubmit', 'propNamespace', 'reset', 'removeArrayValue', 'returnRejectedSubmitPromise', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitFailed', 'swapArrayValues', 'touch', 'untouch', 'validate']); // eslint-disable-line no-redeclare
	
	
	        var _allFields$_meta = allFields._meta,
	            allPristine = _allFields$_meta.allPristine,
	            allValid = _allFields$_meta.allValid,
	            errors = _allFields$_meta.errors,
	            formError = _allFields$_meta.formError,
	            values = _allFields$_meta.values;
	
	
	        var props = {
	          // State:
	          active: form._active,
	          asyncValidating: form._asyncValidating,
	          dirty: !allPristine,
	          error: formError,
	          errors: errors,
	          fields: allFields,
	          formKey: formKey,
	          invalid: !allValid,
	          pristine: allPristine,
	          submitting: form._submitting,
	          submitFailed: form._submitFailed,
	          valid: allValid,
	          values: values,
	
	          // Actions:
	          asyncValidate: (0, _silenceEvents2.default)(function () {
	            return _this4.asyncValidate();
	          }),
	          // ^ doesn't just pass this.asyncValidate to disallow values passing
	          destroyForm: (0, _silenceEvents2.default)(destroy),
	          handleSubmit: this.handleSubmit,
	          initializeForm: (0, _silenceEvents2.default)(function (initValues) {
	            return initialize(initValues, fields);
	          }),
	          resetForm: (0, _silenceEvents2.default)(reset),
	          touch: (0, _silenceEvents2.default)(function () {
	            return touch.apply(undefined, arguments);
	          }),
	          touchAll: (0, _silenceEvents2.default)(function () {
	            return touch.apply(undefined, fields);
	          }),
	          untouch: (0, _silenceEvents2.default)(function () {
	            return untouch.apply(undefined, arguments);
	          }),
	          untouchAll: (0, _silenceEvents2.default)(function () {
	            return untouch.apply(undefined, fields);
	          })
	        };
	        var passedProps = propNamespace ? (_ref2 = {}, _ref2[propNamespace] = props, _ref2) : props;
	        if (withRef) {
	          return React.createElement(WrappedComponent, _extends({}, _extends({}, passableProps, passedProps), { ref: 'wrappedInstance' }));
	        }
	        return React.createElement(WrappedComponent, _extends({}, passableProps, passedProps));
	      };
	
	      return ReduxForm;
	    }(Component);
	
	    ReduxForm.displayName = 'ReduxForm(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	    ReduxForm.WrappedComponent = WrappedComponent;
	    ReduxForm.propTypes = {
	      // props:
	      alwaysAsyncValidate: _propTypes2.default.bool,
	      asyncBlurFields: _propTypes2.default.arrayOf(_propTypes2.default.string),
	      asyncValidate: _propTypes2.default.func,
	      dispatch: _propTypes2.default.func.isRequired,
	      fields: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	      form: _propTypes2.default.object,
	      initialValues: _propTypes2.default.any,
	      onSubmit: _propTypes2.default.func,
	      onSubmitSuccess: _propTypes2.default.func,
	      onSubmitFail: _propTypes2.default.func,
	      overwriteOnInitialValuesChange: _propTypes2.default.bool.isRequired,
	      propNamespace: _propTypes2.default.string,
	      readonly: _propTypes2.default.bool,
	      returnRejectedSubmitPromise: _propTypes2.default.bool,
	      submitPassback: _propTypes2.default.func.isRequired,
	      validate: _propTypes2.default.func,
	
	      // actions:
	      addArrayValue: _propTypes2.default.func.isRequired,
	      autofill: _propTypes2.default.func.isRequired,
	      blur: _propTypes2.default.func.isRequired,
	      change: _propTypes2.default.func.isRequired,
	      destroy: _propTypes2.default.func.isRequired,
	      focus: _propTypes2.default.func.isRequired,
	      initialize: _propTypes2.default.func.isRequired,
	      removeArrayValue: _propTypes2.default.func.isRequired,
	      reset: _propTypes2.default.func.isRequired,
	      startAsyncValidation: _propTypes2.default.func.isRequired,
	      startSubmit: _propTypes2.default.func.isRequired,
	      stopAsyncValidation: _propTypes2.default.func.isRequired,
	      stopSubmit: _propTypes2.default.func.isRequired,
	      submitFailed: _propTypes2.default.func.isRequired,
	      swapArrayValues: _propTypes2.default.func.isRequired,
	      touch: _propTypes2.default.func.isRequired,
	      untouch: _propTypes2.default.func.isRequired
	    };
	    ReduxForm.defaultProps = {
	      asyncBlurFields: [],
	      form: _reducer.initialState,
	      readonly: false,
	      returnRejectedSubmitPromise: false,
	      validate: function validate() {
	        return {};
	      }
	    };
	
	    // bind touch flags to blur and change
	    var unboundActions = _extends({}, importedActions, {
	      blur: (0, _bindActionData2.default)(importedActions.blur, {
	        touch: !!config.touchOnBlur
	      }),
	      change: (0, _bindActionData2.default)(importedActions.change, {
	        touch: !!config.touchOnChange
	      })
	    });
	
	    // make redux connector with or without form key
	    var decorate = formKey !== undefined && formKey !== null ? connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
	      var formState = getFormState(state, reduxMountPoint);
	      if (!formState) {
	        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
	      }
	      return formState && formState[formName] && formState[formName][formKey];
	    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, {
	      form: formName,
	      key: formKey
	    })), mergeProps, options) : connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
	      var formState = getFormState(state, reduxMountPoint);
	      if (!formState) {
	        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
	      }
	      return formState && formState[formName];
	    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, { form: formName })), mergeProps, options);
	
	    return decorate(ReduxForm);
	  };
	};
	
	exports.default = createHigherOrderComponent;

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(38);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createPropTypes = function createPropTypes() {
	  return {
	    // State:
	    active: _propTypes2.default.string, // currently active field
	    asyncValidating: _propTypes2.default.bool.isRequired, // true if async validation is running
	    autofilled: _propTypes2.default.bool, // true if set programmatically by autofill
	    dirty: _propTypes2.default.bool.isRequired, // true if any values are different from initialValues
	    error: _propTypes2.default.any, // form-wide error from '_error' key in validation result
	    errors: _propTypes2.default.object, // a map of errors corresponding to structure of form data (result of validation)
	    fields: _propTypes2.default.object.isRequired, // the map of fields
	    formKey: _propTypes2.default.any, // the form key if one was provided (used when doing multirecord forms)
	    invalid: _propTypes2.default.bool.isRequired, // true if there are any validation errors
	    pristine: _propTypes2.default.bool.isRequired, // true if the values are the same as initialValues
	    submitting: _propTypes2.default.bool.isRequired, // true if the form is in the process of being submitted
	    submitFailed: _propTypes2.default.bool.isRequired, // true if the form was submitted and failed for any reason
	    valid: _propTypes2.default.bool.isRequired, // true if there are no validation errors
	    values: _propTypes2.default.object.isRequired, // the values of the form as they will be submitted
	
	    // Actions:
	    asyncValidate: _propTypes2.default.func.isRequired, // function to trigger async validation
	    destroyForm: _propTypes2.default.func.isRequired, // action to destroy the form's data in Redux
	    handleSubmit: _propTypes2.default.func.isRequired, // function to submit the form
	    initializeForm: _propTypes2.default.func.isRequired, // action to initialize form data
	    resetForm: _propTypes2.default.func.isRequired, // action to reset the form data to previously initialized values
	    touch: _propTypes2.default.func.isRequired, // action to mark fields as touched
	    touchAll: _propTypes2.default.func.isRequired, // action to mark ALL fields as touched
	    untouch: _propTypes2.default.func.isRequired, // action to mark fields as untouched
	    untouchAll: _propTypes2.default.func.isRequired // action to mark ALL fields as untouched
	  };
	};
	
	exports.default = createPropTypes;

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createReduxFormConnector = __webpack_require__(949);
	
	var _createReduxFormConnector2 = _interopRequireDefault(_createReduxFormConnector);
	
	var _hoistNonReactStatics = __webpack_require__(968);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	var createReduxForm = function createReduxForm(isReactNative, React, connect) {
	  var Component = React.Component;
	
	  var reduxFormConnector = (0, _createReduxFormConnector2.default)(isReactNative, React, connect);
	  return function (config, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	    return function (WrappedComponent) {
	      var ReduxFormConnector = reduxFormConnector(WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options);
	
	      var _ref = options || {},
	          _ref$withRef = _ref.withRef,
	          withRef = _ref$withRef === undefined ? false : _ref$withRef;
	
	      var configWithDefaults = _extends({
	        overwriteOnInitialValuesChange: true,
	        touchOnBlur: true,
	        touchOnChange: false,
	        destroyOnUnmount: true
	      }, config);
	
	      var ConnectedForm = function (_Component) {
	        _inherits(ConnectedForm, _Component);
	
	        function ConnectedForm(props) {
	          _classCallCheck(this, ConnectedForm);
	
	          var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	          _this.handleSubmitPassback = _this.handleSubmitPassback.bind(_this);
	          return _this;
	        }
	
	        ConnectedForm.prototype.getWrappedInstance = function getWrappedInstance() {
	          (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	          return this.refs.wrappedInstance.refs.wrappedInstance.getWrappedInstance().refs.wrappedInstance;
	        };
	
	        ConnectedForm.prototype.handleSubmitPassback = function handleSubmitPassback(submit) {
	          this.submit = submit;
	        };
	
	        ConnectedForm.prototype.render = function render() {
	          if (withRef) {
	            return React.createElement(ReduxFormConnector, _extends({}, configWithDefaults, this.props, {
	              ref: 'wrappedInstance',
	              submitPassback: this.handleSubmitPassback }));
	          }
	          return React.createElement(ReduxFormConnector, _extends({}, configWithDefaults, this.props, {
	            submitPassback: this.handleSubmitPassback }));
	        };
	
	        return ConnectedForm;
	      }(Component);
	
	      return (0, _hoistNonReactStatics2.default)(ConnectedForm, WrappedComponent);
	    };
	  };
	};
	
	exports.default = createReduxForm;

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(38);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _noGetters = __webpack_require__(813);
	
	var _noGetters2 = _interopRequireDefault(_noGetters);
	
	var _getDisplayName = __webpack_require__(384);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _createHigherOrderComponent = __webpack_require__(946);
	
	var _createHigherOrderComponent2 = _interopRequireDefault(_createHigherOrderComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component tracks props that affect how the form is mounted to the store. Normally these should not change,
	 * but if they do, the connected components below it need to be redefined.
	 */
	var createReduxFormConnector = function createReduxFormConnector(isReactNative, React, connect) {
	  return function (WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	    var Component = React.Component;
	
	    var _ref = options || {},
	        _ref$withRef = _ref.withRef,
	        withRef = _ref$withRef === undefined ? false : _ref$withRef;
	
	    var ReduxFormConnector = function (_Component) {
	      _inherits(ReduxFormConnector, _Component);
	
	      function ReduxFormConnector(props) {
	        _classCallCheck(this, ReduxFormConnector);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.cache = new _noGetters2.default(_this, {
	          ReduxForm: {
	            params: [
	            // props that effect how redux-form connects to the redux store
	            'reduxMountPoint', 'form', 'formKey', 'getFormState'],
	            fn: (0, _createHigherOrderComponent2.default)(props, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options)
	          }
	        });
	        return _this;
	      }
	
	      ReduxFormConnector.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.cache.componentWillReceiveProps(nextProps);
	      };
	
	      ReduxFormConnector.prototype.render = function render() {
	        var ReduxForm = this.cache.get('ReduxForm');
	        // remove some redux-form config-only props
	
	        var _props = this.props,
	            reduxMountPoint = _props.reduxMountPoint,
	            destroyOnUnmount = _props.destroyOnUnmount,
	            form = _props.form,
	            getFormState = _props.getFormState,
	            touchOnBlur = _props.touchOnBlur,
	            touchOnChange = _props.touchOnChange,
	            passableProps = _objectWithoutProperties(_props, ['reduxMountPoint', 'destroyOnUnmount', 'form', 'getFormState', 'touchOnBlur', 'touchOnChange']); // eslint-disable-line no-redeclare
	
	
	        if (withRef) {
	          return React.createElement(ReduxForm, _extends({}, passableProps, { ref: 'wrappedInstance' }));
	        }
	        return React.createElement(ReduxForm, passableProps);
	      };
	
	      return ReduxFormConnector;
	    }(Component);
	
	    ReduxFormConnector.displayName = 'ReduxFormConnector(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	    ReduxFormConnector.WrappedComponent = WrappedComponent;
	    ReduxFormConnector.propTypes = {
	      destroyOnUnmount: _propTypes2.default.bool,
	      reduxMountPoint: _propTypes2.default.string,
	      form: _propTypes2.default.string.isRequired,
	      formKey: _propTypes2.default.string,
	      getFormState: _propTypes2.default.func,
	      touchOnBlur: _propTypes2.default.bool,
	      touchOnChange: _propTypes2.default.bool
	    };
	    ReduxFormConnector.defaultProps = {
	      reduxMountPoint: 'form',
	      getFormState: function getFormState(state, reduxMountPoint) {
	        return state[reduxMountPoint];
	      }
	    };
	    return ReduxFormConnector;
	  };
	};
	
	exports.default = createReduxFormConnector;

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getValue = __webpack_require__(381);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnBlur = function createOnBlur(name, blur, isReactNative, afterBlur) {
	  return function (event) {
	    var value = (0, _getValue2.default)(event, isReactNative);
	    blur(name, value);
	    if (afterBlur) {
	      afterBlur(name, value);
	    }
	  };
	};
	exports.default = createOnBlur;

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getValue = __webpack_require__(381);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnChange = function createOnChange(name, change, isReactNative) {
	  return function (event) {
	    return change(name, (0, _getValue2.default)(event, isReactNative));
	  };
	};
	exports.default = createOnChange;

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createOnDragStart = __webpack_require__(380);
	
	var createOnDrop = function createOnDrop(name, change) {
	  return function (event) {
	    change(name, event.dataTransfer.getData(_createOnDragStart.dataKey));
	  };
	};
	exports.default = createOnDrop;

/***/ },
/* 953 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var createOnFocus = function createOnFocus(name, focus) {
	  return function () {
	    return focus(name);
	  };
	};
	exports.default = createOnFocus;

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _silenceEvent = __webpack_require__(383);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
	  };
	};
	
	exports.default = silenceEvents;

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(163);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _isValid = __webpack_require__(134);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleSubmit = function handleSubmit(submit, values, props, asyncValidate) {
	  var dispatch = props.dispatch,
	      fields = props.fields,
	      onSubmitSuccess = props.onSubmitSuccess,
	      onSubmitFail = props.onSubmitFail,
	      startSubmit = props.startSubmit,
	      stopSubmit = props.stopSubmit,
	      submitFailed = props.submitFailed,
	      returnRejectedSubmitPromise = props.returnRejectedSubmitPromise,
	      touch = props.touch,
	      validate = props.validate;
	
	  var syncErrors = validate(values, props);
	  touch.apply(undefined, fields); // touch all fields
	  if ((0, _isValid2.default)(syncErrors)) {
	    var doSubmit = function doSubmit() {
	      var result = submit(values, dispatch, props);
	      if ((0, _isPromise2.default)(result)) {
	        startSubmit();
	        return result.then(function (submitResult) {
	          stopSubmit();
	          if (onSubmitSuccess) {
	            onSubmitSuccess(submitResult);
	          }
	          return submitResult;
	        }, function (submitError) {
	          stopSubmit(submitError);
	          if (onSubmitFail) {
	            onSubmitFail(submitError);
	          }
	          if (returnRejectedSubmitPromise) {
	            return Promise.reject(submitError);
	          }
	        });
	      }
	      if (onSubmitSuccess) {
	        onSubmitSuccess(result);
	      }
	      return result;
	    };
	    var asyncValidateResult = asyncValidate();
	    return (0, _isPromise2.default)(asyncValidateResult) ?
	    // asyncValidateResult will be rejected if async validation failed
	    asyncValidateResult.then(doSubmit, function () {
	      submitFailed();
	      if (onSubmitFail) {
	        onSubmitFail();
	      }
	      return returnRejectedSubmitPromise ? Promise.reject() : Promise.resolve();
	    }) : doSubmit(); // no async validation, so submit
	  }
	  submitFailed();
	
	  if (onSubmitFail) {
	    onSubmitFail(syncErrors);
	  }
	
	  if (returnRejectedSubmitPromise) {
	    return Promise.reject(syncErrors);
	  }
	};
	
	exports.default = handleSubmit;

/***/ },
/* 956 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (value) {
	  var getType = {};
	  return value && getType.toString.call(value) === '[object Function]';
	};

/***/ },
/* 957 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isPristine;
	function isPristine(initial, data) {
	  if (initial === data) {
	    return true;
	  }
	  if (typeof initial === 'boolean' || typeof data === 'boolean') {
	    return initial === data;
	  } else if (initial instanceof Date && data instanceof Date) {
	    return initial.getTime() === data.getTime();
	  } else if (initial && typeof initial === 'object') {
	    if (!data || typeof data !== 'object') {
	      return false;
	    }
	    var initialKeys = Object.keys(initial);
	    var dataKeys = Object.keys(data);
	    if (initialKeys.length !== dataKeys.length) {
	      return false;
	    }
	    for (var index = 0; index < dataKeys.length; index++) {
	      var key = dataKeys[index];
	      if (!isPristine(initial[key], data[key])) {
	        return false;
	      }
	    }
	  } else if (initial || data) {
	    // allow '' to equate to undefined or null
	    return initial === data;
	  } else if (initial === null && data === 0 || initial === 0 && data === null) {
	    return false;
	  }
	  return true;
	}

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = normalizeFields;
	
	var _fieldValue = __webpack_require__(82);
	
	function extractKey(field) {
	  var dotIndex = field.indexOf('.');
	  var openIndex = field.indexOf('[');
	  var closeIndex = field.indexOf(']');
	
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	
	  var isArray = openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex);
	  var key = void 0;
	  var nestedPath = void 0;
	
	  if (isArray) {
	    key = field.substring(0, openIndex);
	    nestedPath = field.substring(closeIndex + 1);
	
	    if (nestedPath[0] === '.') {
	      nestedPath = nestedPath.substring(1);
	    }
	  } else if (dotIndex > 0) {
	    key = field.substring(0, dotIndex);
	    nestedPath = field.substring(dotIndex + 1);
	  } else {
	    key = field;
	  }
	
	  return { isArray: isArray, key: key, nestedPath: nestedPath };
	}
	
	function normalizeField(field, fullFieldPath, state, previousState, values, previousValues, normalizers) {
	  if (field.isArray) {
	    if (field.nestedPath) {
	      var array = state && state[field.key] || [];
	      var previousArray = previousState && previousState[field.key] || [];
	      var nestedField = extractKey(field.nestedPath);
	
	      return array.map(function (nestedState, i) {
	        nestedState[nestedField.key] = normalizeField(nestedField, fullFieldPath, nestedState, previousArray[i], values, previousValues, normalizers);
	
	        return nestedState;
	      });
	    }
	
	    var _normalizer = normalizers[fullFieldPath];
	
	    var result = _normalizer(state && state[field.key], previousState && previousState[field.key], values, previousValues);
	    return field.isArray ? result && result.map(_fieldValue.makeFieldValue) : result;
	  } else if (field.nestedPath) {
	    var nestedState = state && state[field.key] || {};
	    var _nestedField = extractKey(field.nestedPath);
	
	    nestedState[_nestedField.key] = normalizeField(_nestedField, fullFieldPath, nestedState, previousState && previousState[field.key], values, previousValues, normalizers);
	
	    return nestedState;
	  }
	
	  var finalField = state && Object.assign({}, state[field.key] || {});
	  var normalizer = normalizers[fullFieldPath];
	
	  finalField.value = normalizer(finalField.value, previousState && previousState[field.key] && previousState[field.key].value, values, previousValues);
	
	  return (0, _fieldValue.makeFieldValue)(finalField);
	}
	
	function normalizeFields(normalizers, state, previousState, values, previousValues) {
	  var newState = Object.keys(normalizers).reduce(function (accumulator, field) {
	    var extracted = extractKey(field);
	
	    accumulator[extracted.key] = normalizeField(extracted, field, state, previousState, values, previousValues, normalizers);
	
	    return accumulator;
	  }, {});
	
	  return _extends({}, state, newState);
	}

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createOnBlur = __webpack_require__(950);
	
	var _createOnBlur2 = _interopRequireDefault(_createOnBlur);
	
	var _createOnChange = __webpack_require__(951);
	
	var _createOnChange2 = _interopRequireDefault(_createOnChange);
	
	var _createOnDragStart = __webpack_require__(380);
	
	var _createOnDragStart2 = _interopRequireDefault(_createOnDragStart);
	
	var _createOnDrop = __webpack_require__(952);
	
	var _createOnDrop2 = _interopRequireDefault(_createOnDrop);
	
	var _createOnFocus = __webpack_require__(953);
	
	var _createOnFocus2 = _interopRequireDefault(_createOnFocus);
	
	var _silencePromise = __webpack_require__(964);
	
	var _silencePromise2 = _interopRequireDefault(_silencePromise);
	
	var _read = __webpack_require__(390);
	
	var _read2 = _interopRequireDefault(_read);
	
	var _updateField = __webpack_require__(965);
	
	var _updateField2 = _interopRequireDefault(_updateField);
	
	var _isChecked = __webpack_require__(389);
	
	var _isChecked2 = _interopRequireDefault(_isChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getSuffix(input, closeIndex) {
	  var suffix = input.substring(closeIndex + 1);
	  if (suffix[0] === '.') {
	    suffix = suffix.substring(1);
	  }
	  return suffix;
	}
	
	var getNextKey = function getNextKey(path) {
	  var dotIndex = path.indexOf('.');
	  var openIndex = path.indexOf('[');
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    return path.substring(0, openIndex);
	  }
	  return dotIndex > 0 ? path.substring(0, dotIndex) : path;
	};
	
	var shouldAsyncValidate = function shouldAsyncValidate(name, asyncBlurFields) {
	  return (
	    // remove array indices
	    ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'))
	  );
	};
	
	var readField = function readField(state, fieldName) {
	  var pathToHere = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var fields = arguments[3];
	  var syncErrors = arguments[4];
	  var asyncValidate = arguments[5];
	  var isReactNative = arguments[6];
	  var props = arguments[7];
	  var callback = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : function () {
	    return null;
	  };
	  var prefix = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
	  var asyncBlurFields = props.asyncBlurFields,
	      autofill = props.autofill,
	      blur = props.blur,
	      change = props.change,
	      focus = props.focus,
	      form = props.form,
	      initialValues = props.initialValues,
	      readonly = props.readonly,
	      addArrayValue = props.addArrayValue,
	      removeArrayValue = props.removeArrayValue,
	      swapArrayValues = props.swapArrayValues;
	
	  var dotIndex = fieldName.indexOf('.');
	  var openIndex = fieldName.indexOf('[');
	  var closeIndex = fieldName.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    // array field
	    var key = fieldName.substring(0, openIndex);
	    var rest = getSuffix(fieldName, closeIndex);
	    var stateArray = state && state[key] || [];
	    var fullPrefix = prefix + fieldName.substring(0, closeIndex + 1);
	    var subfields = props.fields.reduce(function (accumulator, field) {
	      if (field.indexOf(fullPrefix) === 0) {
	        accumulator.push(field);
	      }
	      return accumulator;
	    }, []).map(function (field) {
	      return getSuffix(field, prefix.length + closeIndex);
	    });
	    var addMethods = function addMethods(dest) {
	      Object.defineProperty(dest, 'addField', {
	        value: function value(_value, index) {
	          return addArrayValue(pathToHere + key, _value, index, subfields);
	        }
	      });
	      Object.defineProperty(dest, 'removeField', {
	        value: function value(index) {
	          return removeArrayValue(pathToHere + key, index);
	        }
	      });
	      Object.defineProperty(dest, 'swapFields', {
	        value: function value(indexA, indexB) {
	          return swapArrayValues(pathToHere + key, indexA, indexB);
	        }
	      });
	      return dest;
	    };
	    if (!fields[key] || fields[key].length !== stateArray.length) {
	      fields[key] = fields[key] ? [].concat(fields[key]) : [];
	      addMethods(fields[key]);
	    }
	    var fieldArray = fields[key];
	    var changed = false;
	    stateArray.forEach(function (fieldState, index) {
	      if (rest && !fieldArray[index]) {
	        fieldArray[index] = {};
	        changed = true;
	      }
	      var dest = rest ? fieldArray[index] : {};
	      var nextPath = '' + pathToHere + key + '[' + index + ']' + (rest ? '.' : '');
	      var nextPrefix = '' + prefix + key + '[]' + (rest ? '.' : '');
	
	      var result = readField(fieldState, rest, nextPath, dest, syncErrors, asyncValidate, isReactNative, props, callback, nextPrefix);
	      if (fieldArray[index] !== result) {
	        if (rest) {
	          // if something's after [] in field name, the array item is an object field
	          // we need it to compare !== to the original (so react re-renders appropriately)
	          result = _extends({}, dest);
	        }
	        fieldArray[index] = result;
	        changed = true;
	      }
	    });
	    if (fieldArray.length > stateArray.length) {
	      // remove extra items that aren't in state array
	      fieldArray.splice(stateArray.length, fieldArray.length - stateArray.length);
	    }
	    if (changed) {
	      fieldArray = addMethods([].concat(fieldArray));
	    }
	    fields[key] = fieldArray;
	    return fieldArray;
	  }
	  if (dotIndex > 0) {
	    // subobject field
	    var _key = fieldName.substring(0, dotIndex);
	    var _rest = fieldName.substring(dotIndex + 1);
	    var subobject = fields[_key] || {};
	    var nextPath = pathToHere + _key + '.';
	    var nextKey = getNextKey(_rest);
	    var nextPrefix = prefix + _key + '.';
	    var previous = subobject[nextKey];
	    var result = readField(state[_key] || {}, _rest, nextPath, subobject, syncErrors, asyncValidate, isReactNative, props, callback, nextPrefix);
	    if (result !== previous) {
	      var _extends2;
	
	      subobject = _extends({}, subobject, (_extends2 = {}, _extends2[nextKey] = result, _extends2));
	    }
	    fields[_key] = subobject;
	    return subobject;
	  }
	  var name = pathToHere + fieldName;
	  var field = fields[fieldName] || {};
	  if (field.name !== name) {
	    var onChange = (0, _createOnChange2.default)(name, change, isReactNative);
	    var initialFormValue = (0, _read2.default)(name + '.initial', form);
	    var initialValue = initialFormValue || (0, _read2.default)(name, initialValues);
	    initialValue = initialValue === undefined ? '' : initialValue;
	    field.name = name;
	    field.checked = (0, _isChecked2.default)(initialValue);
	    field.value = initialValue;
	    field.initialValue = initialValue;
	    if (!readonly) {
	      field.autofill = function (value) {
	        return autofill(name, value);
	      };
	      field.onBlur = (0, _createOnBlur2.default)(name, blur, isReactNative, shouldAsyncValidate(name, asyncBlurFields) && function (blurName, blurValue) {
	        return (0, _silencePromise2.default)(asyncValidate(blurName, blurValue));
	      });
	      field.onChange = onChange;
	      field.onDragStart = (0, _createOnDragStart2.default)(name, function () {
	        return field.value;
	      });
	      field.onDrop = (0, _createOnDrop2.default)(name, change);
	      field.onFocus = (0, _createOnFocus2.default)(name, focus);
	      field.onUpdate = onChange; // alias to support belle. https://github.com/nikgraf/belle/issues/58
	    }
	    field.valid = true;
	    field.invalid = false;
	    Object.defineProperty(field, '_isField', { value: true });
	  }
	
	  var fieldState = (fieldName ? state[fieldName] : state) || {};
	  var syncError = (0, _read2.default)(name, syncErrors);
	  var updated = (0, _updateField2.default)(field, fieldState, name === form._active, syncError);
	  if (fieldName || fields[fieldName] !== updated) {
	    fields[fieldName] = updated;
	  }
	  callback(updated);
	  return updated;
	};
	
	exports.default = readField;

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _readField = __webpack_require__(959);
	
	var _readField2 = _interopRequireDefault(_readField);
	
	var _write = __webpack_require__(391);
	
	var _write2 = _interopRequireDefault(_write);
	
	var _getValues = __webpack_require__(385);
	
	var _getValues2 = _interopRequireDefault(_getValues);
	
	var _removeField = __webpack_require__(961);
	
	var _removeField2 = _interopRequireDefault(_removeField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Reads props and generates (or updates) field structure
	 */
	var readFields = function readFields(props, previousProps, myFields, asyncValidate, isReactNative) {
	  var fields = props.fields,
	      form = props.form,
	      validate = props.validate;
	
	  var previousFields = previousProps.fields;
	  var values = (0, _getValues2.default)(fields, form);
	  var syncErrors = validate(values, props) || {};
	  var errors = {};
	  var formError = syncErrors._error || form._error;
	  var allValid = !formError;
	  var allPristine = true;
	  var tally = function tally(field) {
	    if (field.error) {
	      errors = (0, _write2.default)(field.name, field.error, errors);
	      allValid = false;
	    }
	    if (field.dirty) {
	      allPristine = false;
	    }
	  };
	  var fieldObjects = previousFields ? previousFields.reduce(function (accumulator, previousField) {
	    return ~fields.indexOf(previousField) ? accumulator : (0, _removeField2.default)(accumulator, previousField);
	  }, _extends({}, myFields)) : _extends({}, myFields);
	  fields.forEach(function (name) {
	    (0, _readField2.default)(form, name, undefined, fieldObjects, syncErrors, asyncValidate, isReactNative, props, tally);
	  });
	  Object.defineProperty(fieldObjects, '_meta', {
	    value: {
	      allPristine: allPristine,
	      allValid: allValid,
	      values: values,
	      errors: errors,
	      formError: formError
	    }
	  });
	  return fieldObjects;
	};
	exports.default = readFields;

/***/ },
/* 961 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var without = function without(object, key) {
	  var copy = _extends({}, object);
	  delete copy[key];
	  return copy;
	};
	
	var removeField = function removeField(fields, path) {
	  var dotIndex = path.indexOf('.');
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    // array field
	    var key = path.substring(0, openIndex);
	    if (!Array.isArray(fields[key])) {
	      return without(fields, key);
	    }
	    var rest = path.substring(closeIndex + 1);
	    if (rest[0] === '.') {
	      rest = rest.substring(1);
	    }
	    if (rest) {
	      var _extends2;
	
	      var copy = [];
	      fields[key].forEach(function (item, index) {
	        var result = removeField(item, rest);
	        if (Object.keys(result).length) {
	          copy[index] = result;
	        }
	      });
	      return copy.length ? _extends({}, fields, (_extends2 = {}, _extends2[key] = copy, _extends2)) : without(fields, key);
	    }
	    return without(fields, key);
	  }
	  if (dotIndex > 0) {
	    var _extends3;
	
	    // subobject field
	    var _key = path.substring(0, dotIndex);
	    var _rest = path.substring(dotIndex + 1);
	    if (!fields[_key]) {
	      return fields;
	    }
	    var result = removeField(fields[_key], _rest);
	    return Object.keys(result).length ? _extends({}, fields, (_extends3 = {}, _extends3[_key] = removeField(fields[_key], _rest), _extends3)) : without(fields, _key);
	  }
	  return without(fields, path);
	};
	
	exports.default = removeField;

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _fieldValue = __webpack_require__(82);
	
	var reset = function reset(value) {
	  return (0, _fieldValue.makeFieldValue)(value === undefined || value && value.initial === undefined ? {} : { initial: value.initial, value: value.initial });
	};
	
	/**
	 * Sets the initial values into the state and returns a new copy of the state
	 */
	var resetState = function resetState(values) {
	  return values ? Object.keys(values).reduce(function (accumulator, key) {
	    var value = values[key];
	    if (Array.isArray(value)) {
	      accumulator[key] = value.map(function (item) {
	        return (0, _fieldValue.isFieldValue)(item) ? reset(item) : resetState(item);
	      });
	    } else if (value) {
	      if ((0, _fieldValue.isFieldValue)(value)) {
	        accumulator[key] = reset(value);
	      } else if (typeof value === 'object' && value !== null) {
	        accumulator[key] = resetState(value);
	      } else {
	        accumulator[key] = value;
	      }
	    }
	    return accumulator;
	  }, {}) : values;
	};
	
	exports.default = resetState;

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fieldValue = __webpack_require__(82);
	
	var isMetaKey = function isMetaKey(key) {
	  return key[0] === '_';
	};
	
	/**
	 * Sets an error on a field deep in the tree, returning a new copy of the state
	 */
	var setErrors = function setErrors(state, errors, destKey) {
	  var clear = function clear() {
	    if (Array.isArray(state)) {
	      return state.map(function (stateItem, index) {
	        return setErrors(stateItem, errors && errors[index], destKey);
	      });
	    }
	    if (state && typeof state === 'object') {
	      var result = Object.keys(state).reduce(function (accumulator, key) {
	        var _extends2;
	
	        return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends2 = {}, _extends2[key] = setErrors(state[key], errors && errors[key], destKey), _extends2));
	      }, state);
	      if ((0, _fieldValue.isFieldValue)(state)) {
	        (0, _fieldValue.makeFieldValue)(result);
	      }
	      return result;
	    }
	    return (0, _fieldValue.makeFieldValue)(state);
	  };
	  if (typeof File !== 'undefined' && state instanceof File) {
	    return state;
	  }
	  if (!errors) {
	    if (!state) {
	      return state;
	    }
	    if (state[destKey]) {
	      var copy = _extends({}, state);
	      delete copy[destKey];
	      return (0, _fieldValue.makeFieldValue)(copy);
	    }
	    return clear();
	  }
	  if (typeof errors === 'string') {
	    var _extends3;
	
	    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends3 = {}, _extends3[destKey] = errors, _extends3)));
	  }
	  if (Array.isArray(errors)) {
	    if (!state || Array.isArray(state)) {
	      var _copy = (state || []).map(function (stateItem, index) {
	        return setErrors(stateItem, errors[index], destKey);
	      });
	      errors.forEach(function (errorItem, index) {
	        return _copy[index] = setErrors(_copy[index], errorItem, destKey);
	      });
	      return _copy;
	    }
	    return setErrors(state, errors[0], destKey); // use first error
	  }
	  if ((0, _fieldValue.isFieldValue)(state)) {
	    var _extends4;
	
	    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends4 = {}, _extends4[destKey] = errors, _extends4)));
	  }
	  var errorKeys = Object.keys(errors);
	  if (!errorKeys.length && !state) {
	    return state;
	  }
	  return errorKeys.reduce(function (accumulator, key) {
	    var _extends5;
	
	    return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends5 = {}, _extends5[key] = setErrors(state && state[key], errors[key], destKey), _extends5));
	  }, clear() || {});
	};
	
	exports.default = setErrors;

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(163);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noop = function noop() {
	  return undefined;
	};
	
	var silencePromise = function silencePromise(promise) {
	  return (0, _isPromise2.default)(promise) ? promise.then(noop, noop) : promise;
	};
	
	exports.default = silencePromise;

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isPristine = __webpack_require__(957);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	var _isValid = __webpack_require__(134);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _isChecked = __webpack_require__(389);
	
	var _isChecked2 = _interopRequireDefault(_isChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Updates a field object from the store values
	 */
	var updateField = function updateField(field, formField, active, syncError) {
	  var diff = {};
	  var formFieldValue = formField.value === undefined ? '' : formField.value;
	
	  // update field value
	  if (field.value !== formFieldValue) {
	    diff.value = formFieldValue;
	    diff.checked = (0, _isChecked2.default)(formFieldValue);
	  }
	
	  // update dirty/pristine
	  var pristine = (0, _isPristine2.default)(formFieldValue, formField.initial);
	  if (field.pristine !== pristine) {
	    diff.dirty = !pristine;
	    diff.pristine = pristine;
	  }
	
	  // update field error
	  var error = syncError || formField.submitError || formField.asyncError;
	  if (error !== field.error) {
	    diff.error = error;
	  }
	  var valid = (0, _isValid2.default)(error);
	  if (field.valid !== valid) {
	    diff.invalid = !valid;
	    diff.valid = valid;
	  }
	
	  if (active !== field.active) {
	    diff.active = active;
	  }
	  var touched = !!formField.touched;
	  if (touched !== field.touched) {
	    diff.touched = touched;
	  }
	  var visited = !!formField.visited;
	  if (visited !== field.visited) {
	    diff.visited = visited;
	  }
	  var autofilled = !!formField.autofilled;
	  if (autofilled !== field.autofilled) {
	    diff.autofilled = autofilled;
	  }
	
	  if ('initial' in formField && formField.initial !== field.initialValue) {
	    field.initialValue = formField.initial;
	  }
	
	  return Object.keys(diff).length ? _extends({}, field, diff) : field;
	};
	exports.default = updateField;

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(100);
	
	var _helpers = __webpack_require__(387);
	
	var wrapMapDispatchToProps = function wrapMapDispatchToProps(mapDispatchToProps, actionCreators) {
	  if (mapDispatchToProps) {
	    if (typeof mapDispatchToProps === 'function') {
	      if ((0, _helpers.getDependsOnOwnProps)(mapDispatchToProps)) {
	        return function (dispatch, ownProps) {
	          return _extends({
	            dispatch: dispatch
	          }, mapDispatchToProps(dispatch, ownProps), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	        };
	      }
	      return function (dispatch) {
	        return _extends({
	          dispatch: dispatch
	        }, mapDispatchToProps(dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	      };
	    }
	    return function (dispatch) {
	      return _extends({
	        dispatch: dispatch
	      }, (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	    };
	  }
	  return function (dispatch) {
	    return _extends({
	      dispatch: dispatch
	    }, (0, _redux.bindActionCreators)(actionCreators, dispatch));
	  };
	};
	
	exports.default = wrapMapDispatchToProps;

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _helpers = __webpack_require__(387);
	
	var wrapMapStateToProps = function wrapMapStateToProps(mapStateToProps, getForm) {
	  if (mapStateToProps) {
	    if (typeof mapStateToProps !== 'function') {
	      throw new Error('mapStateToProps must be a function');
	    }
	    if ((0, _helpers.getDependsOnOwnProps)(mapStateToProps)) {
	      return function (state, ownProps) {
	        return _extends({}, mapStateToProps(state, ownProps), {
	          form: getForm(state)
	        });
	      };
	    }
	    return function (state) {
	      return _extends({}, mapStateToProps(state), {
	        form: getForm(state)
	      });
	    };
	  }
	  return function (state) {
	    return {
	      form: getForm(state)
	    };
	  };
	};
	
	exports.default = wrapMapStateToProps;

/***/ },
/* 968 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 969 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/** A function that accepts a potential "extra argument" value to be injected later,
	 * and returns an instance of the thunk middleware that uses that value
	 */
	function createThunkMiddleware(extraArgument) {
	  // Standard Redux middleware definition pattern:
	  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
	  var middleware = function middleware(_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
	        // If this "action" is really a function, call it and return the result.
	        if (typeof action === 'function') {
	          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
	          return action(dispatch, getState, extraArgument);
	        } // Otherwise, pass the action down the middleware chain as usual
	
	
	        return next(action);
	      };
	    };
	  };
	
	  return middleware;
	}
	
	var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
	// with whatever "extra arg" they want to inject into their thunks
	
	thunk.withExtraArgument = createThunkMiddleware;
	var _default = thunk;
	exports.default = _default;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(392);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 971 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(393);
	
	var _isPlainObject = __webpack_require__(396);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(394);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 973 */
[998, 395, 976, 977],
/* 974 */
850,
/* 975 */
[999, 978],
/* 976 */
[1000, 395],
/* 977 */
853,
/* 978 */
854,
/* 979 */
[1001, 974],
/* 980 */
856,
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(88);
	var callBind = __webpack_require__(142);
	
	var implementation = __webpack_require__(397);
	var getPolyfill = __webpack_require__(398);
	var shim = __webpack_require__(982);
	
	var flagsBound = callBind(implementation);
	
	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = flagsBound;


/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(88).supportsDescriptors;
	var getPolyfill = __webpack_require__(398);
	var gOPD = Object.getOwnPropertyDescriptor;
	var defineProperty = Object.defineProperty;
	var TypeErr = TypeError;
	var getProto = Object.getPrototypeOf;
	var regex = /a/;
	
	module.exports = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};


/***/ },
/* 983 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(663);
	
	/**
	 * Parses inline style to object.
	 *
	 * @example
	 * // returns { 'line-height': '42' }
	 * StyleToObject('line-height: 42;');
	 *
	 * @param  {String}      style      - The inline style.
	 * @param  {Function}    [iterator] - The iterator function.
	 * @return {null|Object}
	 */
	function StyleToObject(style, iterator) {
	  var output = null;
	  if (!style || typeof style !== 'string') {
	    return output;
	  }
	
	  var declaration;
	  var declarations = parse(style);
	  var hasIterator = typeof iterator === 'function';
	  var property;
	  var value;
	
	  for (var i = 0, len = declarations.length; i < len; i++) {
	    declaration = declarations[i];
	    property = declaration.property;
	    value = declaration.value;
	
	    if (hasIterator) {
	      iterator(property, value, declaration);
	    } else if (value) {
	      output || (output = {});
	      output[property] = value;
	    }
	  }
	
	  return output;
	}
	
	module.exports = StyleToObject;


/***/ },
/* 985 */
/***/ function(module, exports) {

	/*
	 * Swipe 2.0.0
	 * Brad Birdsall
	 * https://github.com/thebird/Swipe
	 * Copyright 2013-2015, MIT License
	 *
	 */
	
	(function(root, factory) {
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = factory();
	  } else {
	    root.Swipe = factory();
	  }
	})(this, function() {
	  'use strict';
	
	  return function Swipe(container, options) {
	    // utilities
	    var noop = function() {}; // simple no operation function
	    var offloadFn = function(fn) {
	      setTimeout(fn || noop, 0);
	    }; // offload a functions execution
	
	    // check browser capabilities
	    var browser = {
	      addEventListener: !!window.addEventListener,
	      touch:
	        'ontouchstart' in window ||
	        (window.DocumentTouch && document instanceof window.DocumentTouch),
	      transitions: (function(temp) {
	        var props = [
	          'transitionProperty',
	          'WebkitTransition',
	          'MozTransition',
	          'OTransition',
	          'msTransition'
	        ];
	        for (var i in props)
	          if (temp.style[props[i]] !== undefined) return true;
	        return false;
	      })(document.createElement('swipe'))
	    };
	
	    // quit if no root element
	    if (!container) return;
	    var element = container.children[0];
	    var slides, slidePos, width, length;
	    options = options || {};
	    var index = parseInt(options.startSlide, 10) || 0;
	    var speed = options.speed || 300;
	    var widthOfSiblingSlidePreview =
	      parseInt(options.widthOfSiblingSlidePreview, 10) || 0;
	    var continuous = (options.continuous =
	      options.continuous !== undefined ? options.continuous : true);
	
	    function setup() {
	      // cache slides
	      slides = element.children;
	      length = slides.length;
	
	      // set continuous to false if only one slide
	      continuous = slides.length < 2 ? false : options.continuous;
	
	      // create an array to store current positions of each slide
	      slidePos = new Array(slides.length);
	
	      // determine width of each slide
	      width =
	        Math.round(
	          container.getBoundingClientRect().width || container.offsetWidth
	        ) -
	        widthOfSiblingSlidePreview * 2;
	
	      element.style.width = slides.length * width + 'px';
	
	      // stack elements
	      var pos = slides.length;
	      while (pos--) {
	        var slide = slides[pos];
	
	        slide.style.width = width + 'px';
	        slide.setAttribute('data-index', pos);
	
	        if (browser.transitions) {
	          slide.style.left = pos * -width + widthOfSiblingSlidePreview + 'px';
	          move(pos, index > pos ? -width : index < pos ? width : 0, 0);
	        }
	      }
	
	      // reposition elements before and after index
	      if (continuous && browser.transitions) {
	        move(circle(index - 1), -width, 0);
	        move(circle(index + 1), width, 0);
	      }
	
	      if (!browser.transitions)
	        element.style.left = index * -width + widthOfSiblingSlidePreview + 'px';
	
	      container.style.visibility = 'visible';
	    }
	
	    function prev() {
	      if (continuous) slide(index - 1);
	      else if (index) slide(index - 1);
	    }
	
	    function next() {
	      if (continuous) slide(index + 1);
	      else if (index < slides.length - 1) slide(index + 1);
	    }
	
	    function circle(index) {
	      // a simple positive modulo using slides.length
	      return (slides.length + (index % slides.length)) % slides.length;
	    }
	
	    function slide(to, slideSpeed) {
	      // do nothing if already on requested slide
	      if (index == to) return;
	
	      if (browser.transitions) {
	        var direction = Math.abs(index - to) / (index - to); // 1: backward, -1: forward
	
	        // get the actual position of the slide
	        if (continuous) {
	          var natural_direction = direction;
	          direction = -slidePos[circle(to)] / width;
	
	          // if going forward but to < index, use to = slides.length + to
	          // if going backward but to > index, use to = -slides.length + to
	          if (direction !== natural_direction)
	            to = -direction * slides.length + to;
	        }
	
	        var diff = Math.abs(index - to) - 1;
	
	        // move all the slides between index and to in the right direction
	        while (diff--)
	          move(
	            circle((to > index ? to : index) - diff - 1),
	            width * direction,
	            0
	          );
	
	        to = circle(to);
	
	        move(index, width * direction, slideSpeed || speed);
	        move(to, 0, slideSpeed || speed);
	
	        if (continuous) move(circle(to - direction), -(width * direction), 0); // we need to get the next in place
	      } else {
	        to = circle(to);
	        animate(index * -width, to * -width, slideSpeed || speed);
	        //no fallback for a circular continuous if the browser does not accept transitions
	      }
	
	      index = to;
	      offloadFn(options.callback && options.callback(index, slides[index]));
	    }
	
	    function move(index, dist, speed) {
	      translate(index, dist, speed);
	      slidePos[index] = dist;
	    }
	
	    function translate(index, dist, speed) {
	      var slide = slides[index];
	      var style = slide && slide.style;
	
	      if (!style) return;
	
	      style.webkitTransitionDuration = style.MozTransitionDuration = style.msTransitionDuration = style.OTransitionDuration = style.transitionDuration =
	        speed + 'ms';
	
	      style.webkitTransform = 'translate(' + dist + 'px,0)' + 'translateZ(0)';
	      style.msTransform = style.MozTransform = style.OTransform =
	        'translateX(' + dist + 'px)';
	    }
	
	    function animate(from, to, speed) {
	      // if not an animation, just reposition
	      if (!speed) {
	        element.style.left = to + 'px';
	        return;
	      }
	
	      var start = +new Date();
	
	      var timer = setInterval(function() {
	        var timeElap = +new Date() - start;
	
	        if (timeElap > speed) {
	          element.style.left = to + 'px';
	
	          if (delay) begin();
	
	          options.transitionEnd &&
	            options.transitionEnd.call(event, index, slides[index]);
	
	          clearInterval(timer);
	          return;
	        }
	
	        element.style.left =
	          (to - from) * (Math.floor((timeElap / speed) * 100) / 100) +
	          from +
	          'px';
	      }, 4);
	    }
	
	    // setup auto slideshow
	    var delay = options.auto || 0;
	    var interval;
	
	    function begin() {
	      clearTimeout(interval);
	      interval = setTimeout(next, delay);
	    }
	
	    function stop() {
	      delay = 0;
	      clearTimeout(interval);
	    }
	
	    // setup initial vars
	    var start = {};
	    var delta = {};
	    var isScrolling;
	
	    // setup event capturing
	    var events = {
	      handleEvent: function(event) {
	        switch (event.type) {
	          case 'touchstart':
	            this.start(event);
	            break;
	          case 'touchmove':
	            this.move(event);
	            break;
	          case 'touchend':
	            offloadFn(this.end(event));
	            break;
	          case 'webkitTransitionEnd':
	          case 'msTransitionEnd':
	          case 'oTransitionEnd':
	          case 'otransitionend':
	          case 'transitionend':
	            offloadFn(this.transitionEnd(event));
	            break;
	          case 'resize':
	            offloadFn(setup);
	            break;
	        }
	
	        if (options.stopPropagation) event.stopPropagation();
	      },
	      start: function(event) {
	        var touches = event.touches[0];
	
	        // measure start values
	        start = {
	          // get initial touch coords
	          x: touches.pageX,
	          y: touches.pageY,
	
	          // store time to determine touch duration
	          time: +new Date()
	        };
	
	        // used for testing first move event
	        isScrolling = undefined;
	
	        // reset delta and end measurements
	        delta = {};
	
	        // attach touchmove and touchend listeners
	        element.addEventListener('touchmove', this, false);
	        element.addEventListener('touchend', this, false);
	      },
	      move: function(event) {
	        // ensure swiping with one touch and not pinching
	        if (event.touches.length > 1 || (event.scale && event.scale !== 1))
	          return;
	
	        if (options.disableScroll) return;
	
	        var touches = event.touches[0];
	
	        // measure change in x and y
	        delta = {
	          x: touches.pageX - start.x,
	          y: touches.pageY - start.y
	        };
	
	        // determine if scrolling test has run - one time test
	        if (typeof isScrolling == 'undefined') {
	          isScrolling = !!(
	            isScrolling || Math.abs(delta.x) < Math.abs(delta.y)
	          );
	        }
	
	        // if user is not trying to scroll vertically
	        if (!isScrolling) {
	          // prevent native scrolling
	          event.preventDefault();
	
	          // stop slideshow
	          stop();
	
	          // increase resistance if first or last slide
	          if (continuous) {
	            // we don't add resistance at the end
	
	            translate(
	              circle(index - 1),
	              delta.x + slidePos[circle(index - 1)],
	              0
	            );
	            translate(index, delta.x + slidePos[index], 0);
	            translate(
	              circle(index + 1),
	              delta.x + slidePos[circle(index + 1)],
	              0
	            );
	          } else {
	            delta.x =
	              delta.x /
	              ((!index && delta.x > 0) || // if first slide and sliding left
	              (index == slides.length - 1 && // or if last slide and sliding right
	                delta.x < 0) // and if sliding at all
	                ? Math.abs(delta.x) / width + 1 // determine resistance level
	                : 1); // no resistance if false
	
	            // translate 1:1
	            translate(index - 1, delta.x + slidePos[index - 1], 0);
	            translate(index, delta.x + slidePos[index], 0);
	            translate(index + 1, delta.x + slidePos[index + 1], 0);
	          }
	          options.swiping && options.swiping(-delta.x / width);
	        }
	      },
	      end: function(event) {
	        // measure duration
	        var duration = +new Date() - start.time;
	
	        // determine if slide attempt triggers next/prev slide
	        var isValidSlide =
	          (Number(duration) < 250 && // if slide duration is less than 250ms
	            Math.abs(delta.x) > 20) || // and if slide amt is greater than 20px
	          Math.abs(delta.x) > width / 2; // or if slide amt is greater than half the width
	
	        // determine if slide attempt is past start and end
	        var isPastBounds =
	          (!index && delta.x > 0) || // if first slide and slide amt is greater than 0
	          (index == slides.length - 1 && delta.x < 0); // or if last slide and slide amt is less than 0
	
	        if (continuous) isPastBounds = false;
	
	        // determine direction of swipe (true:right, false:left)
	        var direction = delta.x < 0;
	
	        // if not scrolling vertically
	        if (!isScrolling) {
	          if (isValidSlide && !isPastBounds) {
	            if (direction) {
	              if (continuous) {
	                // we need to get the next in this direction in place
	
	                move(circle(index - 1), -width, 0);
	                move(circle(index + 2), width, 0);
	              } else {
	                move(index - 1, -width, 0);
	              }
	
	              move(index, slidePos[index] - width, speed);
	              move(
	                circle(index + 1),
	                slidePos[circle(index + 1)] - width,
	                speed
	              );
	              index = circle(index + 1);
	            } else {
	              if (continuous) {
	                // we need to get the next in this direction in place
	
	                move(circle(index + 1), width, 0);
	                move(circle(index - 2), -width, 0);
	              } else {
	                move(index + 1, width, 0);
	              }
	
	              move(index, slidePos[index] + width, speed);
	              move(
	                circle(index - 1),
	                slidePos[circle(index - 1)] + width,
	                speed
	              );
	              index = circle(index - 1);
	            }
	
	            options.callback && options.callback(index, slides[index]);
	          } else {
	            if (continuous) {
	              move(circle(index - 1), -width, speed);
	              move(index, 0, speed);
	              move(circle(index + 1), width, speed);
	            } else {
	              move(index - 1, -width, speed);
	              move(index, 0, speed);
	              move(index + 1, width, speed);
	            }
	          }
	        }
	
	        // kill touchmove and touchend event listeners until touchstart called again
	        element.removeEventListener('touchmove', events, false);
	        element.removeEventListener('touchend', events, false);
	        element.removeEventListener('touchforcechange', function() {}, false);
	      },
	      transitionEnd: function(event) {
	        if (parseInt(event.target.getAttribute('data-index'), 10) == index) {
	          if (delay) begin();
	
	          options.transitionEnd &&
	            options.transitionEnd.call(event, index, slides[index]);
	        }
	      }
	    };
	
	    // trigger setup
	    setup();
	
	    // start auto slideshow if applicable
	    if (delay) begin();
	
	    // add event listeners
	    if (browser.addEventListener) {
	      // set touchstart event on element
	      if (browser.touch) {
	        element.addEventListener('touchstart', events, false);
	        element.addEventListener('touchforcechange', function() {}, false);
	      }
	
	      if (browser.transitions) {
	        element.addEventListener('webkitTransitionEnd', events, false);
	        element.addEventListener('msTransitionEnd', events, false);
	        element.addEventListener('oTransitionEnd', events, false);
	        element.addEventListener('otransitionend', events, false);
	        element.addEventListener('transitionend', events, false);
	      }
	
	      // set resize event on window
	      window.addEventListener('resize', events, false);
	    } else {
	      window.onresize = function() {
	        setup();
	      }; // to play nice with old IE
	    }
	
	    // expose the Swipe API
	    return {
	      setup: function() {
	        setup();
	      },
	      slide: function(to, speed) {
	        // cancel slideshow
	        stop();
	
	        slide(to, speed);
	      },
	      prev: function() {
	        // cancel slideshow
	        stop();
	
	        prev();
	      },
	      next: function() {
	        // cancel slideshow
	        stop();
	
	        next();
	      },
	      stop: function() {
	        // cancel slideshow
	        stop();
	      },
	      getPos: function() {
	        // return current index position
	        return index;
	      },
	      getNumSlides: function() {
	        // return total number of slides
	        return length;
	      },
	      kill: function() {
	        // cancel slideshow
	        stop();
	
	        // reset element
	        element.style.width = '';
	        element.style.left = '';
	
	        // reset slides
	        var pos = slides.length;
	        while (pos--) {
	          var slide = slides[pos];
	          slide.style.width = '';
	          slide.style.left = '';
	
	          if (browser.transitions) translate(pos, 0, 0);
	        }
	
	        // removed event listeners
	        if (browser.addEventListener) {
	          // remove current event listeners
	          element.removeEventListener('touchstart', events, false);
	          element.removeEventListener('webkitTransitionEnd', events, false);
	          element.removeEventListener('msTransitionEnd', events, false);
	          element.removeEventListener('oTransitionEnd', events, false);
	          element.removeEventListener('otransitionend', events, false);
	          element.removeEventListener('transitionend', events, false);
	          window.removeEventListener('resize', events, false);
	        } else {
	          window.onresize = null;
	        }
	      }
	    };
	  };
	});


/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Swiper 4.5.1
	 * Most modern mobile touch slider and framework with hardware accelerated transitions
	 * http://www.idangero.us/swiper/
	 *
	 * Copyright 2014-2019 Vladimir Kharlampidi
	 *
	 * Released under the MIT License
	 *
	 * Released on: September 13, 2019
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = global || self, global.Swiper = factory());
	}(this, function () { 'use strict';
	
	  /**
	   * SSR Window 1.0.1
	   * Better handling for window object in SSR environment
	   * https://github.com/nolimits4web/ssr-window
	   *
	   * Copyright 2018, Vladimir Kharlampidi
	   *
	   * Licensed under MIT
	   *
	   * Released on: July 18, 2018
	   */
	  var doc = (typeof document === 'undefined') ? {
	    body: {},
	    addEventListener: function addEventListener() {},
	    removeEventListener: function removeEventListener() {},
	    activeElement: {
	      blur: function blur() {},
	      nodeName: '',
	    },
	    querySelector: function querySelector() {
	      return null;
	    },
	    querySelectorAll: function querySelectorAll() {
	      return [];
	    },
	    getElementById: function getElementById() {
	      return null;
	    },
	    createEvent: function createEvent() {
	      return {
	        initEvent: function initEvent() {},
	      };
	    },
	    createElement: function createElement() {
	      return {
	        children: [],
	        childNodes: [],
	        style: {},
	        setAttribute: function setAttribute() {},
	        getElementsByTagName: function getElementsByTagName() {
	          return [];
	        },
	      };
	    },
	    location: { hash: '' },
	  } : document; // eslint-disable-line
	
	  var win = (typeof window === 'undefined') ? {
	    document: doc,
	    navigator: {
	      userAgent: '',
	    },
	    location: {},
	    history: {},
	    CustomEvent: function CustomEvent() {
	      return this;
	    },
	    addEventListener: function addEventListener() {},
	    removeEventListener: function removeEventListener() {},
	    getComputedStyle: function getComputedStyle() {
	      return {
	        getPropertyValue: function getPropertyValue() {
	          return '';
	        },
	      };
	    },
	    Image: function Image() {},
	    Date: function Date() {},
	    screen: {},
	    setTimeout: function setTimeout() {},
	    clearTimeout: function clearTimeout() {},
	  } : window; // eslint-disable-line
	
	  /**
	   * Dom7 2.1.3
	   * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
	   * http://framework7.io/docs/dom.html
	   *
	   * Copyright 2019, Vladimir Kharlampidi
	   * The iDangero.us
	   * http://www.idangero.us/
	   *
	   * Licensed under MIT
	   *
	   * Released on: February 11, 2019
	   */
	
	  var Dom7 = function Dom7(arr) {
	    var self = this;
	    // Create array-like object
	    for (var i = 0; i < arr.length; i += 1) {
	      self[i] = arr[i];
	    }
	    self.length = arr.length;
	    // Return collection with methods
	    return this;
	  };
	
	  function $(selector, context) {
	    var arr = [];
	    var i = 0;
	    if (selector && !context) {
	      if (selector instanceof Dom7) {
	        return selector;
	      }
	    }
	    if (selector) {
	        // String
	      if (typeof selector === 'string') {
	        var els;
	        var tempParent;
	        var html = selector.trim();
	        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
	          var toCreate = 'div';
	          if (html.indexOf('<li') === 0) { toCreate = 'ul'; }
	          if (html.indexOf('<tr') === 0) { toCreate = 'tbody'; }
	          if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) { toCreate = 'tr'; }
	          if (html.indexOf('<tbody') === 0) { toCreate = 'table'; }
	          if (html.indexOf('<option') === 0) { toCreate = 'select'; }
	          tempParent = doc.createElement(toCreate);
	          tempParent.innerHTML = html;
	          for (i = 0; i < tempParent.childNodes.length; i += 1) {
	            arr.push(tempParent.childNodes[i]);
	          }
	        } else {
	          if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
	            // Pure ID selector
	            els = [doc.getElementById(selector.trim().split('#')[1])];
	          } else {
	            // Other selectors
	            els = (context || doc).querySelectorAll(selector.trim());
	          }
	          for (i = 0; i < els.length; i += 1) {
	            if (els[i]) { arr.push(els[i]); }
	          }
	        }
	      } else if (selector.nodeType || selector === win || selector === doc) {
	        // Node/element
	        arr.push(selector);
	      } else if (selector.length > 0 && selector[0].nodeType) {
	        // Array of elements or instance of Dom
	        for (i = 0; i < selector.length; i += 1) {
	          arr.push(selector[i]);
	        }
	      }
	    }
	    return new Dom7(arr);
	  }
	
	  $.fn = Dom7.prototype;
	  $.Class = Dom7;
	  $.Dom7 = Dom7;
	
	  function unique(arr) {
	    var uniqueArray = [];
	    for (var i = 0; i < arr.length; i += 1) {
	      if (uniqueArray.indexOf(arr[i]) === -1) { uniqueArray.push(arr[i]); }
	    }
	    return uniqueArray;
	  }
	
	  // Classes and attributes
	  function addClass(className) {
	    if (typeof className === 'undefined') {
	      return this;
	    }
	    var classes = className.split(' ');
	    for (var i = 0; i < classes.length; i += 1) {
	      for (var j = 0; j < this.length; j += 1) {
	        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.add(classes[i]); }
	      }
	    }
	    return this;
	  }
	  function removeClass(className) {
	    var classes = className.split(' ');
	    for (var i = 0; i < classes.length; i += 1) {
	      for (var j = 0; j < this.length; j += 1) {
	        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.remove(classes[i]); }
	      }
	    }
	    return this;
	  }
	  function hasClass(className) {
	    if (!this[0]) { return false; }
	    return this[0].classList.contains(className);
	  }
	  function toggleClass(className) {
	    var classes = className.split(' ');
	    for (var i = 0; i < classes.length; i += 1) {
	      for (var j = 0; j < this.length; j += 1) {
	        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.toggle(classes[i]); }
	      }
	    }
	    return this;
	  }
	  function attr(attrs, value) {
	    var arguments$1 = arguments;
	
	    if (arguments.length === 1 && typeof attrs === 'string') {
	      // Get attr
	      if (this[0]) { return this[0].getAttribute(attrs); }
	      return undefined;
	    }
	
	    // Set attrs
	    for (var i = 0; i < this.length; i += 1) {
	      if (arguments$1.length === 2) {
	        // String
	        this[i].setAttribute(attrs, value);
	      } else {
	        // Object
	        // eslint-disable-next-line
	        for (var attrName in attrs) {
	          this[i][attrName] = attrs[attrName];
	          this[i].setAttribute(attrName, attrs[attrName]);
	        }
	      }
	    }
	    return this;
	  }
	  // eslint-disable-next-line
	  function removeAttr(attr) {
	    for (var i = 0; i < this.length; i += 1) {
	      this[i].removeAttribute(attr);
	    }
	    return this;
	  }
	  function data(key, value) {
	    var el;
	    if (typeof value === 'undefined') {
	      el = this[0];
	      // Get value
	      if (el) {
	        if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
	          return el.dom7ElementDataStorage[key];
	        }
	
	        var dataKey = el.getAttribute(("data-" + key));
	        if (dataKey) {
	          return dataKey;
	        }
	        return undefined;
	      }
	      return undefined;
	    }
	
	    // Set value
	    for (var i = 0; i < this.length; i += 1) {
	      el = this[i];
	      if (!el.dom7ElementDataStorage) { el.dom7ElementDataStorage = {}; }
	      el.dom7ElementDataStorage[key] = value;
	    }
	    return this;
	  }
	  // Transforms
	  // eslint-disable-next-line
	  function transform(transform) {
	    for (var i = 0; i < this.length; i += 1) {
	      var elStyle = this[i].style;
	      elStyle.webkitTransform = transform;
	      elStyle.transform = transform;
	    }
	    return this;
	  }
	  function transition(duration) {
	    if (typeof duration !== 'string') {
	      duration = duration + "ms"; // eslint-disable-line
	    }
	    for (var i = 0; i < this.length; i += 1) {
	      var elStyle = this[i].style;
	      elStyle.webkitTransitionDuration = duration;
	      elStyle.transitionDuration = duration;
	    }
	    return this;
	  }
	  // Events
	  function on() {
	    var assign;
	
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	    var eventType = args[0];
	    var targetSelector = args[1];
	    var listener = args[2];
	    var capture = args[3];
	    if (typeof args[1] === 'function') {
	      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
	      targetSelector = undefined;
	    }
	    if (!capture) { capture = false; }
	
	    function handleLiveEvent(e) {
	      var target = e.target;
	      if (!target) { return; }
	      var eventData = e.target.dom7EventData || [];
	      if (eventData.indexOf(e) < 0) {
	        eventData.unshift(e);
	      }
	      if ($(target).is(targetSelector)) { listener.apply(target, eventData); }
	      else {
	        var parents = $(target).parents(); // eslint-disable-line
	        for (var k = 0; k < parents.length; k += 1) {
	          if ($(parents[k]).is(targetSelector)) { listener.apply(parents[k], eventData); }
	        }
	      }
	    }
	    function handleEvent(e) {
	      var eventData = e && e.target ? e.target.dom7EventData || [] : [];
	      if (eventData.indexOf(e) < 0) {
	        eventData.unshift(e);
	      }
	      listener.apply(this, eventData);
	    }
	    var events = eventType.split(' ');
	    var j;
	    for (var i = 0; i < this.length; i += 1) {
	      var el = this[i];
	      if (!targetSelector) {
	        for (j = 0; j < events.length; j += 1) {
	          var event = events[j];
	          if (!el.dom7Listeners) { el.dom7Listeners = {}; }
	          if (!el.dom7Listeners[event]) { el.dom7Listeners[event] = []; }
	          el.dom7Listeners[event].push({
	            listener: listener,
	            proxyListener: handleEvent,
	          });
	          el.addEventListener(event, handleEvent, capture);
	        }
	      } else {
	        // Live events
	        for (j = 0; j < events.length; j += 1) {
	          var event$1 = events[j];
	          if (!el.dom7LiveListeners) { el.dom7LiveListeners = {}; }
	          if (!el.dom7LiveListeners[event$1]) { el.dom7LiveListeners[event$1] = []; }
	          el.dom7LiveListeners[event$1].push({
	            listener: listener,
	            proxyListener: handleLiveEvent,
	          });
	          el.addEventListener(event$1, handleLiveEvent, capture);
	        }
	      }
	    }
	    return this;
	  }
	  function off() {
	    var assign;
	
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	    var eventType = args[0];
	    var targetSelector = args[1];
	    var listener = args[2];
	    var capture = args[3];
	    if (typeof args[1] === 'function') {
	      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
	      targetSelector = undefined;
	    }
	    if (!capture) { capture = false; }
	
	    var events = eventType.split(' ');
	    for (var i = 0; i < events.length; i += 1) {
	      var event = events[i];
	      for (var j = 0; j < this.length; j += 1) {
	        var el = this[j];
	        var handlers = (void 0);
	        if (!targetSelector && el.dom7Listeners) {
	          handlers = el.dom7Listeners[event];
	        } else if (targetSelector && el.dom7LiveListeners) {
	          handlers = el.dom7LiveListeners[event];
	        }
	        if (handlers && handlers.length) {
	          for (var k = handlers.length - 1; k >= 0; k -= 1) {
	            var handler = handlers[k];
	            if (listener && handler.listener === listener) {
	              el.removeEventListener(event, handler.proxyListener, capture);
	              handlers.splice(k, 1);
	            } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
	              el.removeEventListener(event, handler.proxyListener, capture);
	              handlers.splice(k, 1);
	            } else if (!listener) {
	              el.removeEventListener(event, handler.proxyListener, capture);
	              handlers.splice(k, 1);
	            }
	          }
	        }
	      }
	    }
	    return this;
	  }
	  function trigger() {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    var events = args[0].split(' ');
	    var eventData = args[1];
	    for (var i = 0; i < events.length; i += 1) {
	      var event = events[i];
	      for (var j = 0; j < this.length; j += 1) {
	        var el = this[j];
	        var evt = (void 0);
	        try {
	          evt = new win.CustomEvent(event, {
	            detail: eventData,
	            bubbles: true,
	            cancelable: true,
	          });
	        } catch (e) {
	          evt = doc.createEvent('Event');
	          evt.initEvent(event, true, true);
	          evt.detail = eventData;
	        }
	        // eslint-disable-next-line
	        el.dom7EventData = args.filter(function (data, dataIndex) { return dataIndex > 0; });
	        el.dispatchEvent(evt);
	        el.dom7EventData = [];
	        delete el.dom7EventData;
	      }
	    }
	    return this;
	  }
	  function transitionEnd(callback) {
	    var events = ['webkitTransitionEnd', 'transitionend'];
	    var dom = this;
	    var i;
	    function fireCallBack(e) {
	      /* jshint validthis:true */
	      if (e.target !== this) { return; }
	      callback.call(this, e);
	      for (i = 0; i < events.length; i += 1) {
	        dom.off(events[i], fireCallBack);
	      }
	    }
	    if (callback) {
	      for (i = 0; i < events.length; i += 1) {
	        dom.on(events[i], fireCallBack);
	      }
	    }
	    return this;
	  }
	  function outerWidth(includeMargins) {
	    if (this.length > 0) {
	      if (includeMargins) {
	        // eslint-disable-next-line
	        var styles = this.styles();
	        return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
	      }
	      return this[0].offsetWidth;
	    }
	    return null;
	  }
	  function outerHeight(includeMargins) {
	    if (this.length > 0) {
	      if (includeMargins) {
	        // eslint-disable-next-line
	        var styles = this.styles();
	        return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
	      }
	      return this[0].offsetHeight;
	    }
	    return null;
	  }
	  function offset() {
	    if (this.length > 0) {
	      var el = this[0];
	      var box = el.getBoundingClientRect();
	      var body = doc.body;
	      var clientTop = el.clientTop || body.clientTop || 0;
	      var clientLeft = el.clientLeft || body.clientLeft || 0;
	      var scrollTop = el === win ? win.scrollY : el.scrollTop;
	      var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
	      return {
	        top: (box.top + scrollTop) - clientTop,
	        left: (box.left + scrollLeft) - clientLeft,
	      };
	    }
	
	    return null;
	  }
	  function styles() {
	    if (this[0]) { return win.getComputedStyle(this[0], null); }
	    return {};
	  }
	  function css(props, value) {
	    var i;
	    if (arguments.length === 1) {
	      if (typeof props === 'string') {
	        if (this[0]) { return win.getComputedStyle(this[0], null).getPropertyValue(props); }
	      } else {
	        for (i = 0; i < this.length; i += 1) {
	          // eslint-disable-next-line
	          for (var prop in props) {
	            this[i].style[prop] = props[prop];
	          }
	        }
	        return this;
	      }
	    }
	    if (arguments.length === 2 && typeof props === 'string') {
	      for (i = 0; i < this.length; i += 1) {
	        this[i].style[props] = value;
	      }
	      return this;
	    }
	    return this;
	  }
	  // Iterate over the collection passing elements to `callback`
	  function each(callback) {
	    // Don't bother continuing without a callback
	    if (!callback) { return this; }
	    // Iterate over the current collection
	    for (var i = 0; i < this.length; i += 1) {
	      // If the callback returns false
	      if (callback.call(this[i], i, this[i]) === false) {
	        // End the loop early
	        return this;
	      }
	    }
	    // Return `this` to allow chained DOM operations
	    return this;
	  }
	  // eslint-disable-next-line
	  function html(html) {
	    if (typeof html === 'undefined') {
	      return this[0] ? this[0].innerHTML : undefined;
	    }
	
	    for (var i = 0; i < this.length; i += 1) {
	      this[i].innerHTML = html;
	    }
	    return this;
	  }
	  // eslint-disable-next-line
	  function text(text) {
	    if (typeof text === 'undefined') {
	      if (this[0]) {
	        return this[0].textContent.trim();
	      }
	      return null;
	    }
	
	    for (var i = 0; i < this.length; i += 1) {
	      this[i].textContent = text;
	    }
	    return this;
	  }
	  function is(selector) {
	    var el = this[0];
	    var compareWith;
	    var i;
	    if (!el || typeof selector === 'undefined') { return false; }
	    if (typeof selector === 'string') {
	      if (el.matches) { return el.matches(selector); }
	      else if (el.webkitMatchesSelector) { return el.webkitMatchesSelector(selector); }
	      else if (el.msMatchesSelector) { return el.msMatchesSelector(selector); }
	
	      compareWith = $(selector);
	      for (i = 0; i < compareWith.length; i += 1) {
	        if (compareWith[i] === el) { return true; }
	      }
	      return false;
	    } else if (selector === doc) { return el === doc; }
	    else if (selector === win) { return el === win; }
	
	    if (selector.nodeType || selector instanceof Dom7) {
	      compareWith = selector.nodeType ? [selector] : selector;
	      for (i = 0; i < compareWith.length; i += 1) {
	        if (compareWith[i] === el) { return true; }
	      }
	      return false;
	    }
	    return false;
	  }
	  function index() {
	    var child = this[0];
	    var i;
	    if (child) {
	      i = 0;
	      // eslint-disable-next-line
	      while ((child = child.previousSibling) !== null) {
	        if (child.nodeType === 1) { i += 1; }
	      }
	      return i;
	    }
	    return undefined;
	  }
	  // eslint-disable-next-line
	  function eq(index) {
	    if (typeof index === 'undefined') { return this; }
	    var length = this.length;
	    var returnIndex;
	    if (index > length - 1) {
	      return new Dom7([]);
	    }
	    if (index < 0) {
	      returnIndex = length + index;
	      if (returnIndex < 0) { return new Dom7([]); }
	      return new Dom7([this[returnIndex]]);
	    }
	    return new Dom7([this[index]]);
	  }
	  function append() {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    var newChild;
	
	    for (var k = 0; k < args.length; k += 1) {
	      newChild = args[k];
	      for (var i = 0; i < this.length; i += 1) {
	        if (typeof newChild === 'string') {
	          var tempDiv = doc.createElement('div');
	          tempDiv.innerHTML = newChild;
	          while (tempDiv.firstChild) {
	            this[i].appendChild(tempDiv.firstChild);
	          }
	        } else if (newChild instanceof Dom7) {
	          for (var j = 0; j < newChild.length; j += 1) {
	            this[i].appendChild(newChild[j]);
	          }
	        } else {
	          this[i].appendChild(newChild);
	        }
	      }
	    }
	
	    return this;
	  }
	  function prepend(newChild) {
	    var i;
	    var j;
	    for (i = 0; i < this.length; i += 1) {
	      if (typeof newChild === 'string') {
	        var tempDiv = doc.createElement('div');
	        tempDiv.innerHTML = newChild;
	        for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
	          this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
	        }
	      } else if (newChild instanceof Dom7) {
	        for (j = 0; j < newChild.length; j += 1) {
	          this[i].insertBefore(newChild[j], this[i].childNodes[0]);
	        }
	      } else {
	        this[i].insertBefore(newChild, this[i].childNodes[0]);
	      }
	    }
	    return this;
	  }
	  function next(selector) {
	    if (this.length > 0) {
	      if (selector) {
	        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
	          return new Dom7([this[0].nextElementSibling]);
	        }
	        return new Dom7([]);
	      }
	
	      if (this[0].nextElementSibling) { return new Dom7([this[0].nextElementSibling]); }
	      return new Dom7([]);
	    }
	    return new Dom7([]);
	  }
	  function nextAll(selector) {
	    var nextEls = [];
	    var el = this[0];
	    if (!el) { return new Dom7([]); }
	    while (el.nextElementSibling) {
	      var next = el.nextElementSibling; // eslint-disable-line
	      if (selector) {
	        if ($(next).is(selector)) { nextEls.push(next); }
	      } else { nextEls.push(next); }
	      el = next;
	    }
	    return new Dom7(nextEls);
	  }
	  function prev(selector) {
	    if (this.length > 0) {
	      var el = this[0];
	      if (selector) {
	        if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
	          return new Dom7([el.previousElementSibling]);
	        }
	        return new Dom7([]);
	      }
	
	      if (el.previousElementSibling) { return new Dom7([el.previousElementSibling]); }
	      return new Dom7([]);
	    }
	    return new Dom7([]);
	  }
	  function prevAll(selector) {
	    var prevEls = [];
	    var el = this[0];
	    if (!el) { return new Dom7([]); }
	    while (el.previousElementSibling) {
	      var prev = el.previousElementSibling; // eslint-disable-line
	      if (selector) {
	        if ($(prev).is(selector)) { prevEls.push(prev); }
	      } else { prevEls.push(prev); }
	      el = prev;
	    }
	    return new Dom7(prevEls);
	  }
	  function parent(selector) {
	    var parents = []; // eslint-disable-line
	    for (var i = 0; i < this.length; i += 1) {
	      if (this[i].parentNode !== null) {
	        if (selector) {
	          if ($(this[i].parentNode).is(selector)) { parents.push(this[i].parentNode); }
	        } else {
	          parents.push(this[i].parentNode);
	        }
	      }
	    }
	    return $(unique(parents));
	  }
	  function parents(selector) {
	    var parents = []; // eslint-disable-line
	    for (var i = 0; i < this.length; i += 1) {
	      var parent = this[i].parentNode; // eslint-disable-line
	      while (parent) {
	        if (selector) {
	          if ($(parent).is(selector)) { parents.push(parent); }
	        } else {
	          parents.push(parent);
	        }
	        parent = parent.parentNode;
	      }
	    }
	    return $(unique(parents));
	  }
	  function closest(selector) {
	    var closest = this; // eslint-disable-line
	    if (typeof selector === 'undefined') {
	      return new Dom7([]);
	    }
	    if (!closest.is(selector)) {
	      closest = closest.parents(selector).eq(0);
	    }
	    return closest;
	  }
	  function find(selector) {
	    var foundElements = [];
	    for (var i = 0; i < this.length; i += 1) {
	      var found = this[i].querySelectorAll(selector);
	      for (var j = 0; j < found.length; j += 1) {
	        foundElements.push(found[j]);
	      }
	    }
	    return new Dom7(foundElements);
	  }
	  function children(selector) {
	    var children = []; // eslint-disable-line
	    for (var i = 0; i < this.length; i += 1) {
	      var childNodes = this[i].childNodes;
	
	      for (var j = 0; j < childNodes.length; j += 1) {
	        if (!selector) {
	          if (childNodes[j].nodeType === 1) { children.push(childNodes[j]); }
	        } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
	          children.push(childNodes[j]);
	        }
	      }
	    }
	    return new Dom7(unique(children));
	  }
	  function remove() {
	    for (var i = 0; i < this.length; i += 1) {
	      if (this[i].parentNode) { this[i].parentNode.removeChild(this[i]); }
	    }
	    return this;
	  }
	  function add() {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    var dom = this;
	    var i;
	    var j;
	    for (i = 0; i < args.length; i += 1) {
	      var toAdd = $(args[i]);
	      for (j = 0; j < toAdd.length; j += 1) {
	        dom[dom.length] = toAdd[j];
	        dom.length += 1;
	      }
	    }
	    return dom;
	  }
	
	  var Methods = {
	    addClass: addClass,
	    removeClass: removeClass,
	    hasClass: hasClass,
	    toggleClass: toggleClass,
	    attr: attr,
	    removeAttr: removeAttr,
	    data: data,
	    transform: transform,
	    transition: transition,
	    on: on,
	    off: off,
	    trigger: trigger,
	    transitionEnd: transitionEnd,
	    outerWidth: outerWidth,
	    outerHeight: outerHeight,
	    offset: offset,
	    css: css,
	    each: each,
	    html: html,
	    text: text,
	    is: is,
	    index: index,
	    eq: eq,
	    append: append,
	    prepend: prepend,
	    next: next,
	    nextAll: nextAll,
	    prev: prev,
	    prevAll: prevAll,
	    parent: parent,
	    parents: parents,
	    closest: closest,
	    find: find,
	    children: children,
	    remove: remove,
	    add: add,
	    styles: styles,
	  };
	
	  Object.keys(Methods).forEach(function (methodName) {
	    $.fn[methodName] = $.fn[methodName] || Methods[methodName];
	  });
	
	  var Utils = {
	    deleteProps: function deleteProps(obj) {
	      var object = obj;
	      Object.keys(object).forEach(function (key) {
	        try {
	          object[key] = null;
	        } catch (e) {
	          // no getter for object
	        }
	        try {
	          delete object[key];
	        } catch (e) {
	          // something got wrong
	        }
	      });
	    },
	    nextTick: function nextTick(callback, delay) {
	      if ( delay === void 0 ) delay = 0;
	
	      return setTimeout(callback, delay);
	    },
	    now: function now() {
	      return Date.now();
	    },
	    getTranslate: function getTranslate(el, axis) {
	      if ( axis === void 0 ) axis = 'x';
	
	      var matrix;
	      var curTransform;
	      var transformMatrix;
	
	      var curStyle = win.getComputedStyle(el, null);
	
	      if (win.WebKitCSSMatrix) {
	        curTransform = curStyle.transform || curStyle.webkitTransform;
	        if (curTransform.split(',').length > 6) {
	          curTransform = curTransform.split(', ').map(function (a) { return a.replace(',', '.'); }).join(', ');
	        }
	        // Some old versions of Webkit choke when 'none' is passed; pass
	        // empty string instead in this case
	        transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	      } else {
	        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	        matrix = transformMatrix.toString().split(',');
	      }
	
	      if (axis === 'x') {
	        // Latest Chrome and webkits Fix
	        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m41; }
	        // Crazy IE10 Matrix
	        else if (matrix.length === 16) { curTransform = parseFloat(matrix[12]); }
	        // Normal Browsers
	        else { curTransform = parseFloat(matrix[4]); }
	      }
	      if (axis === 'y') {
	        // Latest Chrome and webkits Fix
	        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m42; }
	        // Crazy IE10 Matrix
	        else if (matrix.length === 16) { curTransform = parseFloat(matrix[13]); }
	        // Normal Browsers
	        else { curTransform = parseFloat(matrix[5]); }
	      }
	      return curTransform || 0;
	    },
	    parseUrlQuery: function parseUrlQuery(url) {
	      var query = {};
	      var urlToParse = url || win.location.href;
	      var i;
	      var params;
	      var param;
	      var length;
	      if (typeof urlToParse === 'string' && urlToParse.length) {
	        urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
	        params = urlToParse.split('&').filter(function (paramsPart) { return paramsPart !== ''; });
	        length = params.length;
	
	        for (i = 0; i < length; i += 1) {
	          param = params[i].replace(/#\S+/g, '').split('=');
	          query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
	        }
	      }
	      return query;
	    },
	    isObject: function isObject(o) {
	      return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
	    },
	    extend: function extend() {
	      var args = [], len$1 = arguments.length;
	      while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];
	
	      var to = Object(args[0]);
	      for (var i = 1; i < args.length; i += 1) {
	        var nextSource = args[i];
	        if (nextSource !== undefined && nextSource !== null) {
	          var keysArray = Object.keys(Object(nextSource));
	          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
	            var nextKey = keysArray[nextIndex];
	            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	            if (desc !== undefined && desc.enumerable) {
	              if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
	                Utils.extend(to[nextKey], nextSource[nextKey]);
	              } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
	                to[nextKey] = {};
	                Utils.extend(to[nextKey], nextSource[nextKey]);
	              } else {
	                to[nextKey] = nextSource[nextKey];
	              }
	            }
	          }
	        }
	      }
	      return to;
	    },
	  };
	
	  var Support = (function Support() {
	    var testDiv = doc.createElement('div');
	    return {
	      touch: (win.Modernizr && win.Modernizr.touch === true) || (function checkTouch() {
	        return !!((win.navigator.maxTouchPoints > 0) || ('ontouchstart' in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch));
	      }()),
	
	      pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent || ('maxTouchPoints' in win.navigator && win.navigator.maxTouchPoints > 0)),
	      prefixedPointerEvents: !!win.navigator.msPointerEnabled,
	
	      transition: (function checkTransition() {
	        var style = testDiv.style;
	        return ('transition' in style || 'webkitTransition' in style || 'MozTransition' in style);
	      }()),
	      transforms3d: (win.Modernizr && win.Modernizr.csstransforms3d === true) || (function checkTransforms3d() {
	        var style = testDiv.style;
	        return ('webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style);
	      }()),
	
	      flexbox: (function checkFlexbox() {
	        var style = testDiv.style;
	        var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
	        for (var i = 0; i < styles.length; i += 1) {
	          if (styles[i] in style) { return true; }
	        }
	        return false;
	      }()),
	
	      observer: (function checkObserver() {
	        return ('MutationObserver' in win || 'WebkitMutationObserver' in win);
	      }()),
	
	      passiveListener: (function checkPassiveListener() {
	        var supportsPassive = false;
	        try {
	          var opts = Object.defineProperty({}, 'passive', {
	            // eslint-disable-next-line
	            get: function get() {
	              supportsPassive = true;
	            },
	          });
	          win.addEventListener('testPassiveListener', null, opts);
	        } catch (e) {
	          // No support
	        }
	        return supportsPassive;
	      }()),
	
	      gestures: (function checkGestures() {
	        return 'ongesturestart' in win;
	      }()),
	    };
	  }());
	
	  var Browser = (function Browser() {
	    function isSafari() {
	      var ua = win.navigator.userAgent.toLowerCase();
	      return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
	    }
	    return {
	      isIE: !!win.navigator.userAgent.match(/Trident/g) || !!win.navigator.userAgent.match(/MSIE/g),
	      isEdge: !!win.navigator.userAgent.match(/Edge/g),
	      isSafari: isSafari(),
	      isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
	    };
	  }());
	
	  var SwiperClass = function SwiperClass(params) {
	    if ( params === void 0 ) params = {};
	
	    var self = this;
	    self.params = params;
	
	    // Events
	    self.eventsListeners = {};
	
	    if (self.params && self.params.on) {
	      Object.keys(self.params.on).forEach(function (eventName) {
	        self.on(eventName, self.params.on[eventName]);
	      });
	    }
	  };
	
	  var staticAccessors = { components: { configurable: true } };
	
	  SwiperClass.prototype.on = function on (events, handler, priority) {
	    var self = this;
	    if (typeof handler !== 'function') { return self; }
	    var method = priority ? 'unshift' : 'push';
	    events.split(' ').forEach(function (event) {
	      if (!self.eventsListeners[event]) { self.eventsListeners[event] = []; }
	      self.eventsListeners[event][method](handler);
	    });
	    return self;
	  };
	
	  SwiperClass.prototype.once = function once (events, handler, priority) {
	    var self = this;
	    if (typeof handler !== 'function') { return self; }
	    function onceHandler() {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	      handler.apply(self, args);
	      self.off(events, onceHandler);
	      if (onceHandler.f7proxy) {
	        delete onceHandler.f7proxy;
	      }
	    }
	    onceHandler.f7proxy = handler;
	    return self.on(events, onceHandler, priority);
	  };
	
	  SwiperClass.prototype.off = function off (events, handler) {
	    var self = this;
	    if (!self.eventsListeners) { return self; }
	    events.split(' ').forEach(function (event) {
	      if (typeof handler === 'undefined') {
	        self.eventsListeners[event] = [];
	      } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
	        self.eventsListeners[event].forEach(function (eventHandler, index) {
	          if (eventHandler === handler || (eventHandler.f7proxy && eventHandler.f7proxy === handler)) {
	            self.eventsListeners[event].splice(index, 1);
	          }
	        });
	      }
	    });
	    return self;
	  };
	
	  SwiperClass.prototype.emit = function emit () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	    var self = this;
	    if (!self.eventsListeners) { return self; }
	    var events;
	    var data;
	    var context;
	    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
	      events = args[0];
	      data = args.slice(1, args.length);
	      context = self;
	    } else {
	      events = args[0].events;
	      data = args[0].data;
	      context = args[0].context || self;
	    }
	    var eventsArray = Array.isArray(events) ? events : events.split(' ');
	    eventsArray.forEach(function (event) {
	      if (self.eventsListeners && self.eventsListeners[event]) {
	        var handlers = [];
	        self.eventsListeners[event].forEach(function (eventHandler) {
	          handlers.push(eventHandler);
	        });
	        handlers.forEach(function (eventHandler) {
	          eventHandler.apply(context, data);
	        });
	      }
	    });
	    return self;
	  };
	
	  SwiperClass.prototype.useModulesParams = function useModulesParams (instanceParams) {
	    var instance = this;
	    if (!instance.modules) { return; }
	    Object.keys(instance.modules).forEach(function (moduleName) {
	      var module = instance.modules[moduleName];
	      // Extend params
	      if (module.params) {
	        Utils.extend(instanceParams, module.params);
	      }
	    });
	  };
	
	  SwiperClass.prototype.useModules = function useModules (modulesParams) {
	      if ( modulesParams === void 0 ) modulesParams = {};
	
	    var instance = this;
	    if (!instance.modules) { return; }
	    Object.keys(instance.modules).forEach(function (moduleName) {
	      var module = instance.modules[moduleName];
	      var moduleParams = modulesParams[moduleName] || {};
	      // Extend instance methods and props
	      if (module.instance) {
	        Object.keys(module.instance).forEach(function (modulePropName) {
	          var moduleProp = module.instance[modulePropName];
	          if (typeof moduleProp === 'function') {
	            instance[modulePropName] = moduleProp.bind(instance);
	          } else {
	            instance[modulePropName] = moduleProp;
	          }
	        });
	      }
	      // Add event listeners
	      if (module.on && instance.on) {
	        Object.keys(module.on).forEach(function (moduleEventName) {
	          instance.on(moduleEventName, module.on[moduleEventName]);
	        });
	      }
	
	      // Module create callback
	      if (module.create) {
	        module.create.bind(instance)(moduleParams);
	      }
	    });
	  };
	
	  staticAccessors.components.set = function (components) {
	    var Class = this;
	    if (!Class.use) { return; }
	    Class.use(components);
	  };
	
	  SwiperClass.installModule = function installModule (module) {
	      var params = [], len = arguments.length - 1;
	      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];
	
	    var Class = this;
	    if (!Class.prototype.modules) { Class.prototype.modules = {}; }
	    var name = module.name || (((Object.keys(Class.prototype.modules).length) + "_" + (Utils.now())));
	    Class.prototype.modules[name] = module;
	    // Prototype
	    if (module.proto) {
	      Object.keys(module.proto).forEach(function (key) {
	        Class.prototype[key] = module.proto[key];
	      });
	    }
	    // Class
	    if (module.static) {
	      Object.keys(module.static).forEach(function (key) {
	        Class[key] = module.static[key];
	      });
	    }
	    // Callback
	    if (module.install) {
	      module.install.apply(Class, params);
	    }
	    return Class;
	  };
	
	  SwiperClass.use = function use (module) {
	      var params = [], len = arguments.length - 1;
	      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];
	
	    var Class = this;
	    if (Array.isArray(module)) {
	      module.forEach(function (m) { return Class.installModule(m); });
	      return Class;
	    }
	    return Class.installModule.apply(Class, [ module ].concat( params ));
	  };
	
	  Object.defineProperties( SwiperClass, staticAccessors );
	
	  function updateSize () {
	    var swiper = this;
	    var width;
	    var height;
	    var $el = swiper.$el;
	    if (typeof swiper.params.width !== 'undefined') {
	      width = swiper.params.width;
	    } else {
	      width = $el[0].clientWidth;
	    }
	    if (typeof swiper.params.height !== 'undefined') {
	      height = swiper.params.height;
	    } else {
	      height = $el[0].clientHeight;
	    }
	    if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
	      return;
	    }
	
	    // Subtract paddings
	    width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
	    height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);
	
	    Utils.extend(swiper, {
	      width: width,
	      height: height,
	      size: swiper.isHorizontal() ? width : height,
	    });
	  }
	
	  function updateSlides () {
	    var swiper = this;
	    var params = swiper.params;
	
	    var $wrapperEl = swiper.$wrapperEl;
	    var swiperSize = swiper.size;
	    var rtl = swiper.rtlTranslate;
	    var wrongRTL = swiper.wrongRTL;
	    var isVirtual = swiper.virtual && params.virtual.enabled;
	    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
	    var slides = $wrapperEl.children(("." + (swiper.params.slideClass)));
	    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
	    var snapGrid = [];
	    var slidesGrid = [];
	    var slidesSizesGrid = [];
	
	    var offsetBefore = params.slidesOffsetBefore;
	    if (typeof offsetBefore === 'function') {
	      offsetBefore = params.slidesOffsetBefore.call(swiper);
	    }
	
	    var offsetAfter = params.slidesOffsetAfter;
	    if (typeof offsetAfter === 'function') {
	      offsetAfter = params.slidesOffsetAfter.call(swiper);
	    }
	
	    var previousSnapGridLength = swiper.snapGrid.length;
	    var previousSlidesGridLength = swiper.snapGrid.length;
	
	    var spaceBetween = params.spaceBetween;
	    var slidePosition = -offsetBefore;
	    var prevSlideSize = 0;
	    var index = 0;
	    if (typeof swiperSize === 'undefined') {
	      return;
	    }
	    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
	      spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
	    }
	
	    swiper.virtualSize = -spaceBetween;
	
	    // reset margins
	    if (rtl) { slides.css({ marginLeft: '', marginTop: '' }); }
	    else { slides.css({ marginRight: '', marginBottom: '' }); }
	
	    var slidesNumberEvenToRows;
	    if (params.slidesPerColumn > 1) {
	      if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
	        slidesNumberEvenToRows = slidesLength;
	      } else {
	        slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
	      }
	      if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
	        slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
	      }
	    }
	
	    // Calc slides
	    var slideSize;
	    var slidesPerColumn = params.slidesPerColumn;
	    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
	    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
	    for (var i = 0; i < slidesLength; i += 1) {
	      slideSize = 0;
	      var slide = slides.eq(i);
	      if (params.slidesPerColumn > 1) {
	        // Set slides order
	        var newSlideOrderIndex = (void 0);
	        var column = (void 0);
	        var row = (void 0);
	        if (
	          (params.slidesPerColumnFill === 'column')
	          || (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1)
	        ) {
	          if (params.slidesPerColumnFill === 'column') {
	            column = Math.floor(i / slidesPerColumn);
	            row = i - (column * slidesPerColumn);
	            if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
	              row += 1;
	              if (row >= slidesPerColumn) {
	                row = 0;
	                column += 1;
	              }
	            }
	          } else {
	            var groupIndex = Math.floor(i / params.slidesPerGroup);
	            row = Math.floor(i / params.slidesPerView) - groupIndex * params.slidesPerColumn;
	            column = i - row * params.slidesPerView - groupIndex * params.slidesPerView;
	          }
	          newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
	          slide
	            .css({
	              '-webkit-box-ordinal-group': newSlideOrderIndex,
	              '-moz-box-ordinal-group': newSlideOrderIndex,
	              '-ms-flex-order': newSlideOrderIndex,
	              '-webkit-order': newSlideOrderIndex,
	              order: newSlideOrderIndex,
	            });
	        } else {
	          row = Math.floor(i / slidesPerRow);
	          column = i - (row * slidesPerRow);
	        }
	        slide
	          .css(
	            ("margin-" + (swiper.isHorizontal() ? 'top' : 'left')),
	            (row !== 0 && params.spaceBetween) && (((params.spaceBetween) + "px"))
	          )
	          .attr('data-swiper-column', column)
	          .attr('data-swiper-row', row);
	      }
	      if (slide.css('display') === 'none') { continue; } // eslint-disable-line
	
	      if (params.slidesPerView === 'auto') {
	        var slideStyles = win.getComputedStyle(slide[0], null);
	        var currentTransform = slide[0].style.transform;
	        var currentWebKitTransform = slide[0].style.webkitTransform;
	        if (currentTransform) {
	          slide[0].style.transform = 'none';
	        }
	        if (currentWebKitTransform) {
	          slide[0].style.webkitTransform = 'none';
	        }
	        if (params.roundLengths) {
	          slideSize = swiper.isHorizontal()
	            ? slide.outerWidth(true)
	            : slide.outerHeight(true);
	        } else {
	          // eslint-disable-next-line
	          if (swiper.isHorizontal()) {
	            var width = parseFloat(slideStyles.getPropertyValue('width'));
	            var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
	            var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
	            var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
	            var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
	            var boxSizing = slideStyles.getPropertyValue('box-sizing');
	            if (boxSizing && boxSizing === 'border-box' && !Browser.isIE) {
	              slideSize = width + marginLeft + marginRight;
	            } else {
	              slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
	            }
	          } else {
	            var height = parseFloat(slideStyles.getPropertyValue('height'));
	            var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
	            var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
	            var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
	            var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
	            var boxSizing$1 = slideStyles.getPropertyValue('box-sizing');
	            if (boxSizing$1 && boxSizing$1 === 'border-box' && !Browser.isIE) {
	              slideSize = height + marginTop + marginBottom;
	            } else {
	              slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
	            }
	          }
	        }
	        if (currentTransform) {
	          slide[0].style.transform = currentTransform;
	        }
	        if (currentWebKitTransform) {
	          slide[0].style.webkitTransform = currentWebKitTransform;
	        }
	        if (params.roundLengths) { slideSize = Math.floor(slideSize); }
	      } else {
	        slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
	        if (params.roundLengths) { slideSize = Math.floor(slideSize); }
	
	        if (slides[i]) {
	          if (swiper.isHorizontal()) {
	            slides[i].style.width = slideSize + "px";
	          } else {
	            slides[i].style.height = slideSize + "px";
	          }
	        }
	      }
	      if (slides[i]) {
	        slides[i].swiperSlideSize = slideSize;
	      }
	      slidesSizesGrid.push(slideSize);
	
	
	      if (params.centeredSlides) {
	        slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
	        if (prevSlideSize === 0 && i !== 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
	        if (i === 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
	        if (Math.abs(slidePosition) < 1 / 1000) { slidePosition = 0; }
	        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
	        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
	        slidesGrid.push(slidePosition);
	      } else {
	        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
	        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
	        slidesGrid.push(slidePosition);
	        slidePosition = slidePosition + slideSize + spaceBetween;
	      }
	
	      swiper.virtualSize += slideSize + spaceBetween;
	
	      prevSlideSize = slideSize;
	
	      index += 1;
	    }
	    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
	    var newSlidesGrid;
	
	    if (
	      rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
	      $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") });
	    }
	    if (!Support.flexbox || params.setWrapperSize) {
	      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	    }
	
	    if (params.slidesPerColumn > 1) {
	      swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
	      swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
	      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	      if (params.centeredSlides) {
	        newSlidesGrid = [];
	        for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
	          var slidesGridItem = snapGrid[i$1];
	          if (params.roundLengths) { slidesGridItem = Math.floor(slidesGridItem); }
	          if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) { newSlidesGrid.push(slidesGridItem); }
	        }
	        snapGrid = newSlidesGrid;
	      }
	    }
	
	    // Remove last grid elements depending on width
	    if (!params.centeredSlides) {
	      newSlidesGrid = [];
	      for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
	        var slidesGridItem$1 = snapGrid[i$2];
	        if (params.roundLengths) { slidesGridItem$1 = Math.floor(slidesGridItem$1); }
	        if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
	          newSlidesGrid.push(slidesGridItem$1);
	        }
	      }
	      snapGrid = newSlidesGrid;
	      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
	        snapGrid.push(swiper.virtualSize - swiperSize);
	      }
	    }
	    if (snapGrid.length === 0) { snapGrid = [0]; }
	
	    if (params.spaceBetween !== 0) {
	      if (swiper.isHorizontal()) {
	        if (rtl) { slides.css({ marginLeft: (spaceBetween + "px") }); }
	        else { slides.css({ marginRight: (spaceBetween + "px") }); }
	      } else { slides.css({ marginBottom: (spaceBetween + "px") }); }
	    }
	
	    if (params.centerInsufficientSlides) {
	      var allSlidesSize = 0;
	      slidesSizesGrid.forEach(function (slideSizeValue) {
	        allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
	      });
	      allSlidesSize -= params.spaceBetween;
	      if (allSlidesSize < swiperSize) {
	        var allSlidesOffset = (swiperSize - allSlidesSize) / 2;
	        snapGrid.forEach(function (snap, snapIndex) {
	          snapGrid[snapIndex] = snap - allSlidesOffset;
	        });
	        slidesGrid.forEach(function (snap, snapIndex) {
	          slidesGrid[snapIndex] = snap + allSlidesOffset;
	        });
	      }
	    }
	
	    Utils.extend(swiper, {
	      slides: slides,
	      snapGrid: snapGrid,
	      slidesGrid: slidesGrid,
	      slidesSizesGrid: slidesSizesGrid,
	    });
	
	    if (slidesLength !== previousSlidesLength) {
	      swiper.emit('slidesLengthChange');
	    }
	    if (snapGrid.length !== previousSnapGridLength) {
	      if (swiper.params.watchOverflow) { swiper.checkOverflow(); }
	      swiper.emit('snapGridLengthChange');
	    }
	    if (slidesGrid.length !== previousSlidesGridLength) {
	      swiper.emit('slidesGridLengthChange');
	    }
	
	    if (params.watchSlidesProgress || params.watchSlidesVisibility) {
	      swiper.updateSlidesOffset();
	    }
	  }
	
	  function updateAutoHeight (speed) {
	    var swiper = this;
	    var activeSlides = [];
	    var newHeight = 0;
	    var i;
	    if (typeof speed === 'number') {
	      swiper.setTransition(speed);
	    } else if (speed === true) {
	      swiper.setTransition(swiper.params.speed);
	    }
	    // Find slides currently in view
	    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
	      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
	        var index = swiper.activeIndex + i;
	        if (index > swiper.slides.length) { break; }
	        activeSlides.push(swiper.slides.eq(index)[0]);
	      }
	    } else {
	      activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
	    }
	
	    // Find new height from highest slide in view
	    for (i = 0; i < activeSlides.length; i += 1) {
	      if (typeof activeSlides[i] !== 'undefined') {
	        var height = activeSlides[i].offsetHeight;
	        newHeight = height > newHeight ? height : newHeight;
	      }
	    }
	
	    // Update Height
	    if (newHeight) { swiper.$wrapperEl.css('height', (newHeight + "px")); }
	  }
	
	  function updateSlidesOffset () {
	    var swiper = this;
	    var slides = swiper.slides;
	    for (var i = 0; i < slides.length; i += 1) {
	      slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
	    }
	  }
	
	  function updateSlidesProgress (translate) {
	    if ( translate === void 0 ) translate = (this && this.translate) || 0;
	
	    var swiper = this;
	    var params = swiper.params;
	
	    var slides = swiper.slides;
	    var rtl = swiper.rtlTranslate;
	
	    if (slides.length === 0) { return; }
	    if (typeof slides[0].swiperSlideOffset === 'undefined') { swiper.updateSlidesOffset(); }
	
	    var offsetCenter = -translate;
	    if (rtl) { offsetCenter = translate; }
	
	    // Visible Slides
	    slides.removeClass(params.slideVisibleClass);
	
	    swiper.visibleSlidesIndexes = [];
	    swiper.visibleSlides = [];
	
	    for (var i = 0; i < slides.length; i += 1) {
	      var slide = slides[i];
	      var slideProgress = (
	        (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
	      ) / (slide.swiperSlideSize + params.spaceBetween);
	      if (params.watchSlidesVisibility) {
	        var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
	        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
	        var isVisible = (slideBefore >= 0 && slideBefore < swiper.size - 1)
	                  || (slideAfter > 1 && slideAfter <= swiper.size)
	                  || (slideBefore <= 0 && slideAfter >= swiper.size);
	        if (isVisible) {
	          swiper.visibleSlides.push(slide);
	          swiper.visibleSlidesIndexes.push(i);
	          slides.eq(i).addClass(params.slideVisibleClass);
	        }
	      }
	      slide.progress = rtl ? -slideProgress : slideProgress;
	    }
	    swiper.visibleSlides = $(swiper.visibleSlides);
	  }
	
	  function updateProgress (translate) {
	    if ( translate === void 0 ) translate = (this && this.translate) || 0;
	
	    var swiper = this;
	    var params = swiper.params;
	
	    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	    var progress = swiper.progress;
	    var isBeginning = swiper.isBeginning;
	    var isEnd = swiper.isEnd;
	    var wasBeginning = isBeginning;
	    var wasEnd = isEnd;
	    if (translatesDiff === 0) {
	      progress = 0;
	      isBeginning = true;
	      isEnd = true;
	    } else {
	      progress = (translate - swiper.minTranslate()) / (translatesDiff);
	      isBeginning = progress <= 0;
	      isEnd = progress >= 1;
	    }
	    Utils.extend(swiper, {
	      progress: progress,
	      isBeginning: isBeginning,
	      isEnd: isEnd,
	    });
	
	    if (params.watchSlidesProgress || params.watchSlidesVisibility) { swiper.updateSlidesProgress(translate); }
	
	    if (isBeginning && !wasBeginning) {
	      swiper.emit('reachBeginning toEdge');
	    }
	    if (isEnd && !wasEnd) {
	      swiper.emit('reachEnd toEdge');
	    }
	    if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
	      swiper.emit('fromEdge');
	    }
	
	    swiper.emit('progress', progress);
	  }
	
	  function updateSlidesClasses () {
	    var swiper = this;
	
	    var slides = swiper.slides;
	    var params = swiper.params;
	    var $wrapperEl = swiper.$wrapperEl;
	    var activeIndex = swiper.activeIndex;
	    var realIndex = swiper.realIndex;
	    var isVirtual = swiper.virtual && params.virtual.enabled;
	
	    slides.removeClass(((params.slideActiveClass) + " " + (params.slideNextClass) + " " + (params.slidePrevClass) + " " + (params.slideDuplicateActiveClass) + " " + (params.slideDuplicateNextClass) + " " + (params.slideDuplicatePrevClass)));
	
	    var activeSlide;
	    if (isVirtual) {
	      activeSlide = swiper.$wrapperEl.find(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + activeIndex + "\"]"));
	    } else {
	      activeSlide = slides.eq(activeIndex);
	    }
	
	    // Active classes
	    activeSlide.addClass(params.slideActiveClass);
	
	    if (params.loop) {
	      // Duplicate to all looped slides
	      if (activeSlide.hasClass(params.slideDuplicateClass)) {
	        $wrapperEl
	          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + realIndex + "\"]"))
	          .addClass(params.slideDuplicateActiveClass);
	      } else {
	        $wrapperEl
	          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]"))
	          .addClass(params.slideDuplicateActiveClass);
	      }
	    }
	    // Next Slide
	    var nextSlide = activeSlide.nextAll(("." + (params.slideClass))).eq(0).addClass(params.slideNextClass);
	    if (params.loop && nextSlide.length === 0) {
	      nextSlide = slides.eq(0);
	      nextSlide.addClass(params.slideNextClass);
	    }
	    // Prev Slide
	    var prevSlide = activeSlide.prevAll(("." + (params.slideClass))).eq(0).addClass(params.slidePrevClass);
	    if (params.loop && prevSlide.length === 0) {
	      prevSlide = slides.eq(-1);
	      prevSlide.addClass(params.slidePrevClass);
	    }
	    if (params.loop) {
	      // Duplicate to all looped slides
	      if (nextSlide.hasClass(params.slideDuplicateClass)) {
	        $wrapperEl
	          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
	          .addClass(params.slideDuplicateNextClass);
	      } else {
	        $wrapperEl
	          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
	          .addClass(params.slideDuplicateNextClass);
	      }
	      if (prevSlide.hasClass(params.slideDuplicateClass)) {
	        $wrapperEl
	          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
	          .addClass(params.slideDuplicatePrevClass);
	      } else {
	        $wrapperEl
	          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
	          .addClass(params.slideDuplicatePrevClass);
	      }
	    }
	  }
	
	  function updateActiveIndex (newActiveIndex) {
	    var swiper = this;
	    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	    var slidesGrid = swiper.slidesGrid;
	    var snapGrid = swiper.snapGrid;
	    var params = swiper.params;
	    var previousIndex = swiper.activeIndex;
	    var previousRealIndex = swiper.realIndex;
	    var previousSnapIndex = swiper.snapIndex;
	    var activeIndex = newActiveIndex;
	    var snapIndex;
	    if (typeof activeIndex === 'undefined') {
	      for (var i = 0; i < slidesGrid.length; i += 1) {
	        if (typeof slidesGrid[i + 1] !== 'undefined') {
	          if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
	            activeIndex = i;
	          } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
	            activeIndex = i + 1;
	          }
	        } else if (translate >= slidesGrid[i]) {
	          activeIndex = i;
	        }
	      }
	      // Normalize slideIndex
	      if (params.normalizeSlideIndex) {
	        if (activeIndex < 0 || typeof activeIndex === 'undefined') { activeIndex = 0; }
	      }
	    }
	    if (snapGrid.indexOf(translate) >= 0) {
	      snapIndex = snapGrid.indexOf(translate);
	    } else {
	      snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
	    }
	    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
	    if (activeIndex === previousIndex) {
	      if (snapIndex !== previousSnapIndex) {
	        swiper.snapIndex = snapIndex;
	        swiper.emit('snapIndexChange');
	      }
	      return;
	    }
	
	    // Get real index
	    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
	
	    Utils.extend(swiper, {
	      snapIndex: snapIndex,
	      realIndex: realIndex,
	      previousIndex: previousIndex,
	      activeIndex: activeIndex,
	    });
	    swiper.emit('activeIndexChange');
	    swiper.emit('snapIndexChange');
	    if (previousRealIndex !== realIndex) {
	      swiper.emit('realIndexChange');
	    }
	    if (swiper.initialized || swiper.runCallbacksOnInit) {
	      swiper.emit('slideChange');
	    }
	  }
	
	  function updateClickedSlide (e) {
	    var swiper = this;
	    var params = swiper.params;
	    var slide = $(e.target).closest(("." + (params.slideClass)))[0];
	    var slideFound = false;
	    if (slide) {
	      for (var i = 0; i < swiper.slides.length; i += 1) {
	        if (swiper.slides[i] === slide) { slideFound = true; }
	      }
	    }
	
	    if (slide && slideFound) {
	      swiper.clickedSlide = slide;
	      if (swiper.virtual && swiper.params.virtual.enabled) {
	        swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
	      } else {
	        swiper.clickedIndex = $(slide).index();
	      }
	    } else {
	      swiper.clickedSlide = undefined;
	      swiper.clickedIndex = undefined;
	      return;
	    }
	    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
	      swiper.slideToClickedSlide();
	    }
	  }
	
	  var update = {
	    updateSize: updateSize,
	    updateSlides: updateSlides,
	    updateAutoHeight: updateAutoHeight,
	    updateSlidesOffset: updateSlidesOffset,
	    updateSlidesProgress: updateSlidesProgress,
	    updateProgress: updateProgress,
	    updateSlidesClasses: updateSlidesClasses,
	    updateActiveIndex: updateActiveIndex,
	    updateClickedSlide: updateClickedSlide,
	  };
	
	  function getTranslate (axis) {
	    if ( axis === void 0 ) axis = this.isHorizontal() ? 'x' : 'y';
	
	    var swiper = this;
	
	    var params = swiper.params;
	    var rtl = swiper.rtlTranslate;
	    var translate = swiper.translate;
	    var $wrapperEl = swiper.$wrapperEl;
	
	    if (params.virtualTranslate) {
	      return rtl ? -translate : translate;
	    }
	
	    var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
	    if (rtl) { currentTranslate = -currentTranslate; }
	
	    return currentTranslate || 0;
	  }
	
	  function setTranslate (translate, byController) {
	    var swiper = this;
	    var rtl = swiper.rtlTranslate;
	    var params = swiper.params;
	    var $wrapperEl = swiper.$wrapperEl;
	    var progress = swiper.progress;
	    var x = 0;
	    var y = 0;
	    var z = 0;
	
	    if (swiper.isHorizontal()) {
	      x = rtl ? -translate : translate;
	    } else {
	      y = translate;
	    }
	
	    if (params.roundLengths) {
	      x = Math.floor(x);
	      y = Math.floor(y);
	    }
	
	    if (!params.virtualTranslate) {
	      if (Support.transforms3d) { $wrapperEl.transform(("translate3d(" + x + "px, " + y + "px, " + z + "px)")); }
	      else { $wrapperEl.transform(("translate(" + x + "px, " + y + "px)")); }
	    }
	    swiper.previousTranslate = swiper.translate;
	    swiper.translate = swiper.isHorizontal() ? x : y;
	
	    // Check if we need to update progress
	    var newProgress;
	    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	    if (translatesDiff === 0) {
	      newProgress = 0;
	    } else {
	      newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
	    }
	    if (newProgress !== progress) {
	      swiper.updateProgress(translate);
	    }
	
	    swiper.emit('setTranslate', swiper.translate, byController);
	  }
	
	  function minTranslate () {
	    return (-this.snapGrid[0]);
	  }
	
	  function maxTranslate () {
	    return (-this.snapGrid[this.snapGrid.length - 1]);
	  }
	
	  var translate = {
	    getTranslate: getTranslate,
	    setTranslate: setTranslate,
	    minTranslate: minTranslate,
	    maxTranslate: maxTranslate,
	  };
	
	  function setTransition (duration, byController) {
	    var swiper = this;
	
	    swiper.$wrapperEl.transition(duration);
	
	    swiper.emit('setTransition', duration, byController);
	  }
	
	  function transitionStart (runCallbacks, direction) {
	    if ( runCallbacks === void 0 ) runCallbacks = true;
	
	    var swiper = this;
	    var activeIndex = swiper.activeIndex;
	    var params = swiper.params;
	    var previousIndex = swiper.previousIndex;
	    if (params.autoHeight) {
	      swiper.updateAutoHeight();
	    }
	
	    var dir = direction;
	    if (!dir) {
	      if (activeIndex > previousIndex) { dir = 'next'; }
	      else if (activeIndex < previousIndex) { dir = 'prev'; }
	      else { dir = 'reset'; }
	    }
	
	    swiper.emit('transitionStart');
	
	    if (runCallbacks && activeIndex !== previousIndex) {
	      if (dir === 'reset') {
	        swiper.emit('slideResetTransitionStart');
	        return;
	      }
	      swiper.emit('slideChangeTransitionStart');
	      if (dir === 'next') {
	        swiper.emit('slideNextTransitionStart');
	      } else {
	        swiper.emit('slidePrevTransitionStart');
	      }
	    }
	  }
	
	  function transitionEnd$1 (runCallbacks, direction) {
	    if ( runCallbacks === void 0 ) runCallbacks = true;
	
	    var swiper = this;
	    var activeIndex = swiper.activeIndex;
	    var previousIndex = swiper.previousIndex;
	    swiper.animating = false;
	    swiper.setTransition(0);
	
	    var dir = direction;
	    if (!dir) {
	      if (activeIndex > previousIndex) { dir = 'next'; }
	      else if (activeIndex < previousIndex) { dir = 'prev'; }
	      else { dir = 'reset'; }
	    }
	
	    swiper.emit('transitionEnd');
	
	    if (runCallbacks && activeIndex !== previousIndex) {
	      if (dir === 'reset') {
	        swiper.emit('slideResetTransitionEnd');
	        return;
	      }
	      swiper.emit('slideChangeTransitionEnd');
	      if (dir === 'next') {
	        swiper.emit('slideNextTransitionEnd');
	      } else {
	        swiper.emit('slidePrevTransitionEnd');
	      }
	    }
	  }
	
	  var transition$1 = {
	    setTransition: setTransition,
	    transitionStart: transitionStart,
	    transitionEnd: transitionEnd$1,
	  };
	
	  function slideTo (index, speed, runCallbacks, internal) {
	    if ( index === void 0 ) index = 0;
	    if ( speed === void 0 ) speed = this.params.speed;
	    if ( runCallbacks === void 0 ) runCallbacks = true;
	
	    var swiper = this;
	    var slideIndex = index;
	    if (slideIndex < 0) { slideIndex = 0; }
	
	    var params = swiper.params;
	    var snapGrid = swiper.snapGrid;
	    var slidesGrid = swiper.slidesGrid;
	    var previousIndex = swiper.previousIndex;
	    var activeIndex = swiper.activeIndex;
	    var rtl = swiper.rtlTranslate;
	    if (swiper.animating && params.preventInteractionOnTransition) {
	      return false;
	    }
	
	    var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
	    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
	
	    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
	      swiper.emit('beforeSlideChangeStart');
	    }
	
	    var translate = -snapGrid[snapIndex];
	
	    // Update progress
	    swiper.updateProgress(translate);
	
	    // Normalize slideIndex
	    if (params.normalizeSlideIndex) {
	      for (var i = 0; i < slidesGrid.length; i += 1) {
	        if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
	          slideIndex = i;
	        }
	      }
	    }
	    // Directions locks
	    if (swiper.initialized && slideIndex !== activeIndex) {
	      if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
	        return false;
	      }
	      if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
	        if ((activeIndex || 0) !== slideIndex) { return false; }
	      }
	    }
	
	    var direction;
	    if (slideIndex > activeIndex) { direction = 'next'; }
	    else if (slideIndex < activeIndex) { direction = 'prev'; }
	    else { direction = 'reset'; }
	
	
	    // Update Index
	    if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
	      swiper.updateActiveIndex(slideIndex);
	      // Update Height
	      if (params.autoHeight) {
	        swiper.updateAutoHeight();
	      }
	      swiper.updateSlidesClasses();
	      if (params.effect !== 'slide') {
	        swiper.setTranslate(translate);
	      }
	      if (direction !== 'reset') {
	        swiper.transitionStart(runCallbacks, direction);
	        swiper.transitionEnd(runCallbacks, direction);
	      }
	      return false;
	    }
	
	    if (speed === 0 || !Support.transition) {
	      swiper.setTransition(0);
	      swiper.setTranslate(translate);
	      swiper.updateActiveIndex(slideIndex);
	      swiper.updateSlidesClasses();
	      swiper.emit('beforeTransitionStart', speed, internal);
	      swiper.transitionStart(runCallbacks, direction);
	      swiper.transitionEnd(runCallbacks, direction);
	    } else {
	      swiper.setTransition(speed);
	      swiper.setTranslate(translate);
	      swiper.updateActiveIndex(slideIndex);
	      swiper.updateSlidesClasses();
	      swiper.emit('beforeTransitionStart', speed, internal);
	      swiper.transitionStart(runCallbacks, direction);
	      if (!swiper.animating) {
	        swiper.animating = true;
	        if (!swiper.onSlideToWrapperTransitionEnd) {
	          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
	            if (!swiper || swiper.destroyed) { return; }
	            if (e.target !== this) { return; }
	            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	            swiper.onSlideToWrapperTransitionEnd = null;
	            delete swiper.onSlideToWrapperTransitionEnd;
	            swiper.transitionEnd(runCallbacks, direction);
	          };
	        }
	        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	      }
	    }
	
	    return true;
	  }
	
	  function slideToLoop (index, speed, runCallbacks, internal) {
	    if ( index === void 0 ) index = 0;
	    if ( speed === void 0 ) speed = this.params.speed;
	    if ( runCallbacks === void 0 ) runCallbacks = true;
	
	    var swiper = this;
	    var newIndex = index;
	    if (swiper.params.loop) {
	      newIndex += swiper.loopedSlides;
	    }
	
	    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
	  }
	
	  /* eslint no-unused-vars: "off" */
	  function slideNext (speed, runCallbacks, internal) {
	    if ( speed === void 0 ) speed = this.params.speed;
	    if ( runCallbacks === void 0 ) runCallbacks = true;
	
	    var swiper = this;
	    var params = swiper.params;
	    var animating = swiper.animating;
	    if (params.loop) {
	      if (animating) { return false; }
	      swiper.loopFix();
	      // eslint-disable-next-line
	      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	      return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
	    }
	    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
	  }
	
	  /* eslint no-unused-vars: "off" */
	  function slidePrev (speed, runCallbacks, internal) {
	    if ( speed === void 0 ) speed = this.params.speed;
	    if ( runCallbacks === void 0 ) runCallbacks = true;
	
	    var swiper = this;
	    var params = swiper.params;
	    var animating = swiper.animating;
	    var snapGrid = swiper.snapGrid;
	    var slidesGrid = swiper.slidesGrid;
	    var rtlTranslate = swiper.rtlTranslate;
	
	    if (params.loop) {
	      if (animating) { return false; }
	      swiper.loopFix();
	      // eslint-disable-next-line
	      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	    }
	    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
	    function normalize(val) {
	      if (val < 0) { return -Math.floor(Math.abs(val)); }
	      return Math.floor(val);
	    }
	    var normalizedTranslate = normalize(translate);
	    var normalizedSnapGrid = snapGrid.map(function (val) { return normalize(val); });
	    var normalizedSlidesGrid = slidesGrid.map(function (val) { return normalize(val); });
	
	    var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
	    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
	    var prevIndex;
	    if (typeof prevSnap !== 'undefined') {
	      prevIndex = slidesGrid.indexOf(prevSnap);
	      if (prevIndex < 0) { prevIndex = swiper.activeIndex - 1; }
	    }
	    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
	  }
	
	  /* eslint no-unused-vars: "off" */
	  function slideReset (speed, runCallbacks, internal) {
	    if ( speed === void 0 ) speed = this.params.speed;
	    if ( runCallbacks === void 0 ) runCallbacks = true;
	
	    var swiper = this;
	    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
	  }
	
	  /* eslint no-unused-vars: "off" */
	  function slideToClosest (speed, runCallbacks, internal) {
	    if ( speed === void 0 ) speed = this.params.speed;
	    if ( runCallbacks === void 0 ) runCallbacks = true;
	
	    var swiper = this;
	    var index = swiper.activeIndex;
	    var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);
	
	    if (snapIndex < swiper.snapGrid.length - 1) {
	      var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	
	      var currentSnap = swiper.snapGrid[snapIndex];
	      var nextSnap = swiper.snapGrid[snapIndex + 1];
	
	      if ((translate - currentSnap) > (nextSnap - currentSnap) / 2) {
	        index = swiper.params.slidesPerGroup;
	      }
	    }
	
	    return swiper.slideTo(index, speed, runCallbacks, internal);
	  }
	
	  function slideToClickedSlide () {
	    var swiper = this;
	    var params = swiper.params;
	    var $wrapperEl = swiper.$wrapperEl;
	
	    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
	    var slideToIndex = swiper.clickedIndex;
	    var realIndex;
	    if (params.loop) {
	      if (swiper.animating) { return; }
	      realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
	      if (params.centeredSlides) {
	        if (
	          (slideToIndex < swiper.loopedSlides - (slidesPerView / 2))
	          || (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
	        ) {
	          swiper.loopFix();
	          slideToIndex = $wrapperEl
	            .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
	            .eq(0)
	            .index();
	
	          Utils.nextTick(function () {
	            swiper.slideTo(slideToIndex);
	          });
	        } else {
	          swiper.slideTo(slideToIndex);
	        }
	      } else if (slideToIndex > swiper.slides.length - slidesPerView) {
	        swiper.loopFix();
	        slideToIndex = $wrapperEl
	          .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
	          .eq(0)
	          .index();
	
	        Utils.nextTick(function () {
	          swiper.slideTo(slideToIndex);
	        });
	      } else {
	        swiper.slideTo(slideToIndex);
	      }
	    } else {
	      swiper.slideTo(slideToIndex);
	    }
	  }
	
	  var slide = {
	    slideTo: slideTo,
	    slideToLoop: slideToLoop,
	    slideNext: slideNext,
	    slidePrev: slidePrev,
	    slideReset: slideReset,
	    slideToClosest: slideToClosest,
	    slideToClickedSlide: slideToClickedSlide,
	  };
	
	  function loopCreate () {
	    var swiper = this;
	    var params = swiper.params;
	    var $wrapperEl = swiper.$wrapperEl;
	    // Remove duplicated slides
	    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();
	
	    var slides = $wrapperEl.children(("." + (params.slideClass)));
	
	    if (params.loopFillGroupWithBlank) {
	      var blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
	      if (blankSlidesNum !== params.slidesPerGroup) {
	        for (var i = 0; i < blankSlidesNum; i += 1) {
	          var blankNode = $(doc.createElement('div')).addClass(((params.slideClass) + " " + (params.slideBlankClass)));
	          $wrapperEl.append(blankNode);
	        }
	        slides = $wrapperEl.children(("." + (params.slideClass)));
	      }
	    }
	
	    if (params.slidesPerView === 'auto' && !params.loopedSlides) { params.loopedSlides = slides.length; }
	
	    swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
	    swiper.loopedSlides += params.loopAdditionalSlides;
	    if (swiper.loopedSlides > slides.length) {
	      swiper.loopedSlides = slides.length;
	    }
	
	    var prependSlides = [];
	    var appendSlides = [];
	    slides.each(function (index, el) {
	      var slide = $(el);
	      if (index < swiper.loopedSlides) { appendSlides.push(el); }
	      if (index < slides.length && index >= slides.length - swiper.loopedSlides) { prependSlides.push(el); }
	      slide.attr('data-swiper-slide-index', index);
	    });
	    for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
	      $wrapperEl.append($(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
	    }
	    for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
	      $wrapperEl.prepend($(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
	    }
	  }
	
	  function loopFix () {
	    var swiper = this;
	    var params = swiper.params;
	    var activeIndex = swiper.activeIndex;
	    var slides = swiper.slides;
	    var loopedSlides = swiper.loopedSlides;
	    var allowSlidePrev = swiper.allowSlidePrev;
	    var allowSlideNext = swiper.allowSlideNext;
	    var snapGrid = swiper.snapGrid;
	    var rtl = swiper.rtlTranslate;
	    var newIndex;
	    swiper.allowSlidePrev = true;
	    swiper.allowSlideNext = true;
	
	    var snapTranslate = -snapGrid[activeIndex];
	    var diff = snapTranslate - swiper.getTranslate();
	
	
	    // Fix For Negative Oversliding
	    if (activeIndex < loopedSlides) {
	      newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
	      newIndex += loopedSlides;
	      var slideChanged = swiper.slideTo(newIndex, 0, false, true);
	      if (slideChanged && diff !== 0) {
	        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	      }
	    } else if ((params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2) || (activeIndex >= slides.length - loopedSlides)) {
	      // Fix For Positive Oversliding
	      newIndex = -slides.length + activeIndex + loopedSlides;
	      newIndex += loopedSlides;
	      var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);
	      if (slideChanged$1 && diff !== 0) {
	        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	      }
	    }
	    swiper.allowSlidePrev = allowSlidePrev;
	    swiper.allowSlideNext = allowSlideNext;
	  }
	
	  function loopDestroy () {
	    var swiper = this;
	    var $wrapperEl = swiper.$wrapperEl;
	    var params = swiper.params;
	    var slides = swiper.slides;
	    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + ",." + (params.slideClass) + "." + (params.slideBlankClass))).remove();
	    slides.removeAttr('data-swiper-slide-index');
	  }
	
	  var loop = {
	    loopCreate: loopCreate,
	    loopFix: loopFix,
	    loopDestroy: loopDestroy,
	  };
	
	  function setGrabCursor (moving) {
	    var swiper = this;
	    if (Support.touch || !swiper.params.simulateTouch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
	    var el = swiper.el;
	    el.style.cursor = 'move';
	    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
	    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
	    el.style.cursor = moving ? 'grabbing' : 'grab';
	  }
	
	  function unsetGrabCursor () {
	    var swiper = this;
	    if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
	    swiper.el.style.cursor = '';
	  }
	
	  var grabCursor = {
	    setGrabCursor: setGrabCursor,
	    unsetGrabCursor: unsetGrabCursor,
	  };
	
	  function appendSlide (slides) {
	    var swiper = this;
	    var $wrapperEl = swiper.$wrapperEl;
	    var params = swiper.params;
	    if (params.loop) {
	      swiper.loopDestroy();
	    }
	    if (typeof slides === 'object' && 'length' in slides) {
	      for (var i = 0; i < slides.length; i += 1) {
	        if (slides[i]) { $wrapperEl.append(slides[i]); }
	      }
	    } else {
	      $wrapperEl.append(slides);
	    }
	    if (params.loop) {
	      swiper.loopCreate();
	    }
	    if (!(params.observer && Support.observer)) {
	      swiper.update();
	    }
	  }
	
	  function prependSlide (slides) {
	    var swiper = this;
	    var params = swiper.params;
	    var $wrapperEl = swiper.$wrapperEl;
	    var activeIndex = swiper.activeIndex;
	
	    if (params.loop) {
	      swiper.loopDestroy();
	    }
	    var newActiveIndex = activeIndex + 1;
	    if (typeof slides === 'object' && 'length' in slides) {
	      for (var i = 0; i < slides.length; i += 1) {
	        if (slides[i]) { $wrapperEl.prepend(slides[i]); }
	      }
	      newActiveIndex = activeIndex + slides.length;
	    } else {
	      $wrapperEl.prepend(slides);
	    }
	    if (params.loop) {
	      swiper.loopCreate();
	    }
	    if (!(params.observer && Support.observer)) {
	      swiper.update();
	    }
	    swiper.slideTo(newActiveIndex, 0, false);
	  }
	
	  function addSlide (index, slides) {
	    var swiper = this;
	    var $wrapperEl = swiper.$wrapperEl;
	    var params = swiper.params;
	    var activeIndex = swiper.activeIndex;
	    var activeIndexBuffer = activeIndex;
	    if (params.loop) {
	      activeIndexBuffer -= swiper.loopedSlides;
	      swiper.loopDestroy();
	      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
	    }
	    var baseLength = swiper.slides.length;
	    if (index <= 0) {
	      swiper.prependSlide(slides);
	      return;
	    }
	    if (index >= baseLength) {
	      swiper.appendSlide(slides);
	      return;
	    }
	    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
	
	    var slidesBuffer = [];
	    for (var i = baseLength - 1; i >= index; i -= 1) {
	      var currentSlide = swiper.slides.eq(i);
	      currentSlide.remove();
	      slidesBuffer.unshift(currentSlide);
	    }
	
	    if (typeof slides === 'object' && 'length' in slides) {
	      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
	        if (slides[i$1]) { $wrapperEl.append(slides[i$1]); }
	      }
	      newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
	    } else {
	      $wrapperEl.append(slides);
	    }
	
	    for (var i$2 = 0; i$2 < slidesBuffer.length; i$2 += 1) {
	      $wrapperEl.append(slidesBuffer[i$2]);
	    }
	
	    if (params.loop) {
	      swiper.loopCreate();
	    }
	    if (!(params.observer && Support.observer)) {
	      swiper.update();
	    }
	    if (params.loop) {
	      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	    } else {
	      swiper.slideTo(newActiveIndex, 0, false);
	    }
	  }
	
	  function removeSlide (slidesIndexes) {
	    var swiper = this;
	    var params = swiper.params;
	    var $wrapperEl = swiper.$wrapperEl;
	    var activeIndex = swiper.activeIndex;
	
	    var activeIndexBuffer = activeIndex;
	    if (params.loop) {
	      activeIndexBuffer -= swiper.loopedSlides;
	      swiper.loopDestroy();
	      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
	    }
	    var newActiveIndex = activeIndexBuffer;
	    var indexToRemove;
	
	    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
	      for (var i = 0; i < slidesIndexes.length; i += 1) {
	        indexToRemove = slidesIndexes[i];
	        if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
	        if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
	      }
	      newActiveIndex = Math.max(newActiveIndex, 0);
	    } else {
	      indexToRemove = slidesIndexes;
	      if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
	      if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
	      newActiveIndex = Math.max(newActiveIndex, 0);
	    }
	
	    if (params.loop) {
	      swiper.loopCreate();
	    }
	
	    if (!(params.observer && Support.observer)) {
	      swiper.update();
	    }
	    if (params.loop) {
	      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	    } else {
	      swiper.slideTo(newActiveIndex, 0, false);
	    }
	  }
	
	  function removeAllSlides () {
	    var swiper = this;
	
	    var slidesIndexes = [];
	    for (var i = 0; i < swiper.slides.length; i += 1) {
	      slidesIndexes.push(i);
	    }
	    swiper.removeSlide(slidesIndexes);
	  }
	
	  var manipulation = {
	    appendSlide: appendSlide,
	    prependSlide: prependSlide,
	    addSlide: addSlide,
	    removeSlide: removeSlide,
	    removeAllSlides: removeAllSlides,
	  };
	
	  var Device = (function Device() {
	    var ua = win.navigator.userAgent;
	
	    var device = {
	      ios: false,
	      android: false,
	      androidChrome: false,
	      desktop: false,
	      windows: false,
	      iphone: false,
	      ipod: false,
	      ipad: false,
	      cordova: win.cordova || win.phonegap,
	      phonegap: win.cordova || win.phonegap,
	    };
	
	    var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
	    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
	    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	
	
	    // Windows
	    if (windows) {
	      device.os = 'windows';
	      device.osVersion = windows[2];
	      device.windows = true;
	    }
	    // Android
	    if (android && !windows) {
	      device.os = 'android';
	      device.osVersion = android[2];
	      device.android = true;
	      device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
	    }
	    if (ipad || iphone || ipod) {
	      device.os = 'ios';
	      device.ios = true;
	    }
	    // iOS
	    if (iphone && !ipod) {
	      device.osVersion = iphone[2].replace(/_/g, '.');
	      device.iphone = true;
	    }
	    if (ipad) {
	      device.osVersion = ipad[2].replace(/_/g, '.');
	      device.ipad = true;
	    }
	    if (ipod) {
	      device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
	      device.iphone = true;
	    }
	    // iOS 8+ changed UA
	    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
	      if (device.osVersion.split('.')[0] === '10') {
	        device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
	      }
	    }
	
	    // Desktop
	    device.desktop = !(device.os || device.android || device.webView);
	
	    // Webview
	    device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);
	
	    // Minimal UI
	    if (device.os && device.os === 'ios') {
	      var osVersionArr = device.osVersion.split('.');
	      var metaViewport = doc.querySelector('meta[name="viewport"]');
	      device.minimalUi = !device.webView
	        && (ipod || iphone)
	        && (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7)
	        && metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
	    }
	
	    // Pixel Ratio
	    device.pixelRatio = win.devicePixelRatio || 1;
	
	    // Export object
	    return device;
	  }());
	
	  function onTouchStart (event) {
	    var swiper = this;
	    var data = swiper.touchEventsData;
	    var params = swiper.params;
	    var touches = swiper.touches;
	    if (swiper.animating && params.preventInteractionOnTransition) {
	      return;
	    }
	    var e = event;
	    if (e.originalEvent) { e = e.originalEvent; }
	    data.isTouchEvent = e.type === 'touchstart';
	    if (!data.isTouchEvent && 'which' in e && e.which === 3) { return; }
	    if (!data.isTouchEvent && 'button' in e && e.button > 0) { return; }
	    if (data.isTouched && data.isMoved) { return; }
	    if (params.noSwiping && $(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : ("." + (params.noSwipingClass)))[0]) {
	      swiper.allowClick = true;
	      return;
	    }
	    if (params.swipeHandler) {
	      if (!$(e).closest(params.swipeHandler)[0]) { return; }
	    }
	
	    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	    var startX = touches.currentX;
	    var startY = touches.currentY;
	
	    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore
	
	    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
	    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
	    if (
	      edgeSwipeDetection
	      && ((startX <= edgeSwipeThreshold)
	      || (startX >= win.screen.width - edgeSwipeThreshold))
	    ) {
	      return;
	    }
	
	    Utils.extend(data, {
	      isTouched: true,
	      isMoved: false,
	      allowTouchCallbacks: true,
	      isScrolling: undefined,
	      startMoving: undefined,
	    });
	
	    touches.startX = startX;
	    touches.startY = startY;
	    data.touchStartTime = Utils.now();
	    swiper.allowClick = true;
	    swiper.updateSize();
	    swiper.swipeDirection = undefined;
	    if (params.threshold > 0) { data.allowThresholdMove = false; }
	    if (e.type !== 'touchstart') {
	      var preventDefault = true;
	      if ($(e.target).is(data.formElements)) { preventDefault = false; }
	      if (
	        doc.activeElement
	        && $(doc.activeElement).is(data.formElements)
	        && doc.activeElement !== e.target
	      ) {
	        doc.activeElement.blur();
	      }
	
	      var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
	      if (params.touchStartForcePreventDefault || shouldPreventDefault) {
	        e.preventDefault();
	      }
	    }
	    swiper.emit('touchStart', e);
	  }
	
	  function onTouchMove (event) {
	    var swiper = this;
	    var data = swiper.touchEventsData;
	    var params = swiper.params;
	    var touches = swiper.touches;
	    var rtl = swiper.rtlTranslate;
	    var e = event;
	    if (e.originalEvent) { e = e.originalEvent; }
	    if (!data.isTouched) {
	      if (data.startMoving && data.isScrolling) {
	        swiper.emit('touchMoveOpposite', e);
	      }
	      return;
	    }
	    if (data.isTouchEvent && e.type === 'mousemove') { return; }
	    var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	    var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	    if (e.preventedByNestedSwiper) {
	      touches.startX = pageX;
	      touches.startY = pageY;
	      return;
	    }
	    if (!swiper.allowTouchMove) {
	      // isMoved = true;
	      swiper.allowClick = false;
	      if (data.isTouched) {
	        Utils.extend(touches, {
	          startX: pageX,
	          startY: pageY,
	          currentX: pageX,
	          currentY: pageY,
	        });
	        data.touchStartTime = Utils.now();
	      }
	      return;
	    }
	    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
	      if (swiper.isVertical()) {
	        // Vertical
	        if (
	          (pageY < touches.startY && swiper.translate <= swiper.maxTranslate())
	          || (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
	        ) {
	          data.isTouched = false;
	          data.isMoved = false;
	          return;
	        }
	      } else if (
	        (pageX < touches.startX && swiper.translate <= swiper.maxTranslate())
	        || (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
	      ) {
	        return;
	      }
	    }
	    if (data.isTouchEvent && doc.activeElement) {
	      if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
	        data.isMoved = true;
	        swiper.allowClick = false;
	        return;
	      }
	    }
	    if (data.allowTouchCallbacks) {
	      swiper.emit('touchMove', e);
	    }
	    if (e.targetTouches && e.targetTouches.length > 1) { return; }
	
	    touches.currentX = pageX;
	    touches.currentY = pageY;
	
	    var diffX = touches.currentX - touches.startX;
	    var diffY = touches.currentY - touches.startY;
	    if (swiper.params.threshold && Math.sqrt((Math.pow( diffX, 2 )) + (Math.pow( diffY, 2 ))) < swiper.params.threshold) { return; }
	
	    if (typeof data.isScrolling === 'undefined') {
	      var touchAngle;
	      if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
	        data.isScrolling = false;
	      } else {
	        // eslint-disable-next-line
	        if ((diffX * diffX) + (diffY * diffY) >= 25) {
	          touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
	          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
	        }
	      }
	    }
	    if (data.isScrolling) {
	      swiper.emit('touchMoveOpposite', e);
	    }
	    if (typeof data.startMoving === 'undefined') {
	      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
	        data.startMoving = true;
	      }
	    }
	    if (data.isScrolling) {
	      data.isTouched = false;
	      return;
	    }
	    if (!data.startMoving) {
	      return;
	    }
	    swiper.allowClick = false;
	    e.preventDefault();
	    if (params.touchMoveStopPropagation && !params.nested) {
	      e.stopPropagation();
	    }
	
	    if (!data.isMoved) {
	      if (params.loop) {
	        swiper.loopFix();
	      }
	      data.startTranslate = swiper.getTranslate();
	      swiper.setTransition(0);
	      if (swiper.animating) {
	        swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
	      }
	      data.allowMomentumBounce = false;
	      // Grab Cursor
	      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	        swiper.setGrabCursor(true);
	      }
	      swiper.emit('sliderFirstMove', e);
	    }
	    swiper.emit('sliderMove', e);
	    data.isMoved = true;
	
	    var diff = swiper.isHorizontal() ? diffX : diffY;
	    touches.diff = diff;
	
	    diff *= params.touchRatio;
	    if (rtl) { diff = -diff; }
	
	    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
	    data.currentTranslate = diff + data.startTranslate;
	
	    var disableParentSwiper = true;
	    var resistanceRatio = params.resistanceRatio;
	    if (params.touchReleaseOnEdges) {
	      resistanceRatio = 0;
	    }
	    if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
	      disableParentSwiper = false;
	      if (params.resistance) { data.currentTranslate = (swiper.minTranslate() - 1) + (Math.pow( (-swiper.minTranslate() + data.startTranslate + diff), resistanceRatio )); }
	    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
	      disableParentSwiper = false;
	      if (params.resistance) { data.currentTranslate = (swiper.maxTranslate() + 1) - (Math.pow( (swiper.maxTranslate() - data.startTranslate - diff), resistanceRatio )); }
	    }
	
	    if (disableParentSwiper) {
	      e.preventedByNestedSwiper = true;
	    }
	
	    // Directions locks
	    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
	      data.currentTranslate = data.startTranslate;
	    }
	    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
	      data.currentTranslate = data.startTranslate;
	    }
	
	
	    // Threshold
	    if (params.threshold > 0) {
	      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
	        if (!data.allowThresholdMove) {
	          data.allowThresholdMove = true;
	          touches.startX = touches.currentX;
	          touches.startY = touches.currentY;
	          data.currentTranslate = data.startTranslate;
	          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
	          return;
	        }
	      } else {
	        data.currentTranslate = data.startTranslate;
	        return;
	      }
	    }
	
	    if (!params.followFinger) { return; }
	
	    // Update active index in free mode
	    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }
	    if (params.freeMode) {
	      // Velocity
	      if (data.velocities.length === 0) {
	        data.velocities.push({
	          position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
	          time: data.touchStartTime,
	        });
	      }
	      data.velocities.push({
	        position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
	        time: Utils.now(),
	      });
	    }
	    // Update progress
	    swiper.updateProgress(data.currentTranslate);
	    // Update translate
	    swiper.setTranslate(data.currentTranslate);
	  }
	
	  function onTouchEnd (event) {
	    var swiper = this;
	    var data = swiper.touchEventsData;
	
	    var params = swiper.params;
	    var touches = swiper.touches;
	    var rtl = swiper.rtlTranslate;
	    var $wrapperEl = swiper.$wrapperEl;
	    var slidesGrid = swiper.slidesGrid;
	    var snapGrid = swiper.snapGrid;
	    var e = event;
	    if (e.originalEvent) { e = e.originalEvent; }
	    if (data.allowTouchCallbacks) {
	      swiper.emit('touchEnd', e);
	    }
	    data.allowTouchCallbacks = false;
	    if (!data.isTouched) {
	      if (data.isMoved && params.grabCursor) {
	        swiper.setGrabCursor(false);
	      }
	      data.isMoved = false;
	      data.startMoving = false;
	      return;
	    }
	    // Return Grab Cursor
	    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	      swiper.setGrabCursor(false);
	    }
	
	    // Time diff
	    var touchEndTime = Utils.now();
	    var timeDiff = touchEndTime - data.touchStartTime;
	
	    // Tap, doubleTap, Click
	    if (swiper.allowClick) {
	      swiper.updateClickedSlide(e);
	      swiper.emit('tap', e);
	      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) > 300) {
	        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
	        data.clickTimeout = Utils.nextTick(function () {
	          if (!swiper || swiper.destroyed) { return; }
	          swiper.emit('click', e);
	        }, 300);
	      }
	      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
	        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
	        swiper.emit('doubleTap', e);
	      }
	    }
	
	    data.lastClickTime = Utils.now();
	    Utils.nextTick(function () {
	      if (!swiper.destroyed) { swiper.allowClick = true; }
	    });
	
	    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
	      data.isTouched = false;
	      data.isMoved = false;
	      data.startMoving = false;
	      return;
	    }
	    data.isTouched = false;
	    data.isMoved = false;
	    data.startMoving = false;
	
	    var currentPos;
	    if (params.followFinger) {
	      currentPos = rtl ? swiper.translate : -swiper.translate;
	    } else {
	      currentPos = -data.currentTranslate;
	    }
	
	    if (params.freeMode) {
	      if (currentPos < -swiper.minTranslate()) {
	        swiper.slideTo(swiper.activeIndex);
	        return;
	      }
	      if (currentPos > -swiper.maxTranslate()) {
	        if (swiper.slides.length < snapGrid.length) {
	          swiper.slideTo(snapGrid.length - 1);
	        } else {
	          swiper.slideTo(swiper.slides.length - 1);
	        }
	        return;
	      }
	
	      if (params.freeModeMomentum) {
	        if (data.velocities.length > 1) {
	          var lastMoveEvent = data.velocities.pop();
	          var velocityEvent = data.velocities.pop();
	
	          var distance = lastMoveEvent.position - velocityEvent.position;
	          var time = lastMoveEvent.time - velocityEvent.time;
	          swiper.velocity = distance / time;
	          swiper.velocity /= 2;
	          if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
	            swiper.velocity = 0;
	          }
	          // this implies that the user stopped moving a finger then released.
	          // There would be no events with distance zero, so the last event is stale.
	          if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
	            swiper.velocity = 0;
	          }
	        } else {
	          swiper.velocity = 0;
	        }
	        swiper.velocity *= params.freeModeMomentumVelocityRatio;
	
	        data.velocities.length = 0;
	        var momentumDuration = 1000 * params.freeModeMomentumRatio;
	        var momentumDistance = swiper.velocity * momentumDuration;
	
	        var newPosition = swiper.translate + momentumDistance;
	        if (rtl) { newPosition = -newPosition; }
	
	        var doBounce = false;
	        var afterBouncePosition;
	        var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
	        var needsLoopFix;
	        if (newPosition < swiper.maxTranslate()) {
	          if (params.freeModeMomentumBounce) {
	            if (newPosition + swiper.maxTranslate() < -bounceAmount) {
	              newPosition = swiper.maxTranslate() - bounceAmount;
	            }
	            afterBouncePosition = swiper.maxTranslate();
	            doBounce = true;
	            data.allowMomentumBounce = true;
	          } else {
	            newPosition = swiper.maxTranslate();
	          }
	          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
	        } else if (newPosition > swiper.minTranslate()) {
	          if (params.freeModeMomentumBounce) {
	            if (newPosition - swiper.minTranslate() > bounceAmount) {
	              newPosition = swiper.minTranslate() + bounceAmount;
	            }
	            afterBouncePosition = swiper.minTranslate();
	            doBounce = true;
	            data.allowMomentumBounce = true;
	          } else {
	            newPosition = swiper.minTranslate();
	          }
	          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
	        } else if (params.freeModeSticky) {
	          var nextSlide;
	          for (var j = 0; j < snapGrid.length; j += 1) {
	            if (snapGrid[j] > -newPosition) {
	              nextSlide = j;
	              break;
	            }
	          }
	
	          if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
	            newPosition = snapGrid[nextSlide];
	          } else {
	            newPosition = snapGrid[nextSlide - 1];
	          }
	          newPosition = -newPosition;
	        }
	        if (needsLoopFix) {
	          swiper.once('transitionEnd', function () {
	            swiper.loopFix();
	          });
	        }
	        // Fix duration
	        if (swiper.velocity !== 0) {
	          if (rtl) {
	            momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
	          } else {
	            momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
	          }
	        } else if (params.freeModeSticky) {
	          swiper.slideToClosest();
	          return;
	        }
	
	        if (params.freeModeMomentumBounce && doBounce) {
	          swiper.updateProgress(afterBouncePosition);
	          swiper.setTransition(momentumDuration);
	          swiper.setTranslate(newPosition);
	          swiper.transitionStart(true, swiper.swipeDirection);
	          swiper.animating = true;
	          $wrapperEl.transitionEnd(function () {
	            if (!swiper || swiper.destroyed || !data.allowMomentumBounce) { return; }
	            swiper.emit('momentumBounce');
	
	            swiper.setTransition(params.speed);
	            swiper.setTranslate(afterBouncePosition);
	            $wrapperEl.transitionEnd(function () {
	              if (!swiper || swiper.destroyed) { return; }
	              swiper.transitionEnd();
	            });
	          });
	        } else if (swiper.velocity) {
	          swiper.updateProgress(newPosition);
	          swiper.setTransition(momentumDuration);
	          swiper.setTranslate(newPosition);
	          swiper.transitionStart(true, swiper.swipeDirection);
	          if (!swiper.animating) {
	            swiper.animating = true;
	            $wrapperEl.transitionEnd(function () {
	              if (!swiper || swiper.destroyed) { return; }
	              swiper.transitionEnd();
	            });
	          }
	        } else {
	          swiper.updateProgress(newPosition);
	        }
	
	        swiper.updateActiveIndex();
	        swiper.updateSlidesClasses();
	      } else if (params.freeModeSticky) {
	        swiper.slideToClosest();
	        return;
	      }
	
	      if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
	        swiper.updateProgress();
	        swiper.updateActiveIndex();
	        swiper.updateSlidesClasses();
	      }
	      return;
	    }
	
	    // Find current slide
	    var stopIndex = 0;
	    var groupSize = swiper.slidesSizesGrid[0];
	    for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
	      if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
	        if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
	          stopIndex = i;
	          groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
	        }
	      } else if (currentPos >= slidesGrid[i]) {
	        stopIndex = i;
	        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
	      }
	    }
	
	    // Find current slide size
	    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
	
	    if (timeDiff > params.longSwipesMs) {
	      // Long touches
	      if (!params.longSwipes) {
	        swiper.slideTo(swiper.activeIndex);
	        return;
	      }
	      if (swiper.swipeDirection === 'next') {
	        if (ratio >= params.longSwipesRatio) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
	        else { swiper.slideTo(stopIndex); }
	      }
	      if (swiper.swipeDirection === 'prev') {
	        if (ratio > (1 - params.longSwipesRatio)) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
	        else { swiper.slideTo(stopIndex); }
	      }
	    } else {
	      // Short swipes
	      if (!params.shortSwipes) {
	        swiper.slideTo(swiper.activeIndex);
	        return;
	      }
	      if (swiper.swipeDirection === 'next') {
	        swiper.slideTo(stopIndex + params.slidesPerGroup);
	      }
	      if (swiper.swipeDirection === 'prev') {
	        swiper.slideTo(stopIndex);
	      }
	    }
	  }
	
	  function onResize () {
	    var swiper = this;
	
	    var params = swiper.params;
	    var el = swiper.el;
	
	    if (el && el.offsetWidth === 0) { return; }
	
	    // Breakpoints
	    if (params.breakpoints) {
	      swiper.setBreakpoint();
	    }
	
	    // Save locks
	    var allowSlideNext = swiper.allowSlideNext;
	    var allowSlidePrev = swiper.allowSlidePrev;
	    var snapGrid = swiper.snapGrid;
	
	    // Disable locks on resize
	    swiper.allowSlideNext = true;
	    swiper.allowSlidePrev = true;
	
	    swiper.updateSize();
	    swiper.updateSlides();
	
	    if (params.freeMode) {
	      var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
	      swiper.setTranslate(newTranslate);
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	
	      if (params.autoHeight) {
	        swiper.updateAutoHeight();
	      }
	    } else {
	      swiper.updateSlidesClasses();
	      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
	        swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	      } else {
	        swiper.slideTo(swiper.activeIndex, 0, false, true);
	      }
	    }
	    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
	      swiper.autoplay.run();
	    }
	    // Return locks after resize
	    swiper.allowSlidePrev = allowSlidePrev;
	    swiper.allowSlideNext = allowSlideNext;
	
	    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
	      swiper.checkOverflow();
	    }
	  }
	
	  function onClick (e) {
	    var swiper = this;
	    if (!swiper.allowClick) {
	      if (swiper.params.preventClicks) { e.preventDefault(); }
	      if (swiper.params.preventClicksPropagation && swiper.animating) {
	        e.stopPropagation();
	        e.stopImmediatePropagation();
	      }
	    }
	  }
	
	  function attachEvents() {
	    var swiper = this;
	    var params = swiper.params;
	    var touchEvents = swiper.touchEvents;
	    var el = swiper.el;
	    var wrapperEl = swiper.wrapperEl;
	
	    {
	      swiper.onTouchStart = onTouchStart.bind(swiper);
	      swiper.onTouchMove = onTouchMove.bind(swiper);
	      swiper.onTouchEnd = onTouchEnd.bind(swiper);
	    }
	
	    swiper.onClick = onClick.bind(swiper);
	
	    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
	    var capture = !!params.nested;
	
	    // Touch Events
	    {
	      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
	        target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
	        doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
	        doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
	      } else {
	        if (Support.touch) {
	          var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	          target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	          target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
	          target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
	        }
	        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
	          target.addEventListener('mousedown', swiper.onTouchStart, false);
	          doc.addEventListener('mousemove', swiper.onTouchMove, capture);
	          doc.addEventListener('mouseup', swiper.onTouchEnd, false);
	        }
	      }
	      // Prevent Links Clicks
	      if (params.preventClicks || params.preventClicksPropagation) {
	        target.addEventListener('click', swiper.onClick, true);
	      }
	    }
	
	    // Resize handler
	    swiper.on((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize, true);
	  }
	
	  function detachEvents() {
	    var swiper = this;
	
	    var params = swiper.params;
	    var touchEvents = swiper.touchEvents;
	    var el = swiper.el;
	    var wrapperEl = swiper.wrapperEl;
	
	    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
	    var capture = !!params.nested;
	
	    // Touch Events
	    {
	      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
	        target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
	        doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	        doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
	      } else {
	        if (Support.touch) {
	          var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	          target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	          target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	          target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
	        }
	        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
	          target.removeEventListener('mousedown', swiper.onTouchStart, false);
	          doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
	          doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
	        }
	      }
	      // Prevent Links Clicks
	      if (params.preventClicks || params.preventClicksPropagation) {
	        target.removeEventListener('click', swiper.onClick, true);
	      }
	    }
	
	    // Resize handler
	    swiper.off((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize);
	  }
	
	  var events = {
	    attachEvents: attachEvents,
	    detachEvents: detachEvents,
	  };
	
	  function setBreakpoint () {
	    var swiper = this;
	    var activeIndex = swiper.activeIndex;
	    var initialized = swiper.initialized;
	    var loopedSlides = swiper.loopedSlides; if ( loopedSlides === void 0 ) loopedSlides = 0;
	    var params = swiper.params;
	    var breakpoints = params.breakpoints;
	    if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) { return; }
	
	    // Set breakpoint for window width and update parameters
	    var breakpoint = swiper.getBreakpoint(breakpoints);
	
	    if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
	      var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
	      if (breakpointOnlyParams) {
	        ['slidesPerView', 'spaceBetween', 'slidesPerGroup'].forEach(function (param) {
	          var paramValue = breakpointOnlyParams[param];
	          if (typeof paramValue === 'undefined') { return; }
	          if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
	            breakpointOnlyParams[param] = 'auto';
	          } else if (param === 'slidesPerView') {
	            breakpointOnlyParams[param] = parseFloat(paramValue);
	          } else {
	            breakpointOnlyParams[param] = parseInt(paramValue, 10);
	          }
	        });
	      }
	
	      var breakpointParams = breakpointOnlyParams || swiper.originalParams;
	      var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
	      var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
	
	      if (directionChanged && initialized) {
	        swiper.changeDirection();
	      }
	
	      Utils.extend(swiper.params, breakpointParams);
	
	      Utils.extend(swiper, {
	        allowTouchMove: swiper.params.allowTouchMove,
	        allowSlideNext: swiper.params.allowSlideNext,
	        allowSlidePrev: swiper.params.allowSlidePrev,
	      });
	
	      swiper.currentBreakpoint = breakpoint;
	
	      if (needsReLoop && initialized) {
	        swiper.loopDestroy();
	        swiper.loopCreate();
	        swiper.updateSlides();
	        swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
	      }
	
	      swiper.emit('breakpoint', breakpointParams);
	    }
	  }
	
	  function getBreakpoint (breakpoints) {
	    var swiper = this;
	    // Get breakpoint for window width
	    if (!breakpoints) { return undefined; }
	    var breakpoint = false;
	    var points = [];
	    Object.keys(breakpoints).forEach(function (point) {
	      points.push(point);
	    });
	    points.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
	    for (var i = 0; i < points.length; i += 1) {
	      var point = points[i];
	      if (swiper.params.breakpointsInverse) {
	        if (point <= win.innerWidth) {
	          breakpoint = point;
	        }
	      } else if (point >= win.innerWidth && !breakpoint) {
	        breakpoint = point;
	      }
	    }
	    return breakpoint || 'max';
	  }
	
	  var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };
	
	  function addClasses () {
	    var swiper = this;
	    var classNames = swiper.classNames;
	    var params = swiper.params;
	    var rtl = swiper.rtl;
	    var $el = swiper.$el;
	    var suffixes = [];
	
	    suffixes.push('initialized');
	    suffixes.push(params.direction);
	
	    if (params.freeMode) {
	      suffixes.push('free-mode');
	    }
	    if (!Support.flexbox) {
	      suffixes.push('no-flexbox');
	    }
	    if (params.autoHeight) {
	      suffixes.push('autoheight');
	    }
	    if (rtl) {
	      suffixes.push('rtl');
	    }
	    if (params.slidesPerColumn > 1) {
	      suffixes.push('multirow');
	    }
	    if (Device.android) {
	      suffixes.push('android');
	    }
	    if (Device.ios) {
	      suffixes.push('ios');
	    }
	    // WP8 Touch Events Fix
	    if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
	      suffixes.push(("wp8-" + (params.direction)));
	    }
	
	    suffixes.forEach(function (suffix) {
	      classNames.push(params.containerModifierClass + suffix);
	    });
	
	    $el.addClass(classNames.join(' '));
	  }
	
	  function removeClasses () {
	    var swiper = this;
	    var $el = swiper.$el;
	    var classNames = swiper.classNames;
	
	    $el.removeClass(classNames.join(' '));
	  }
	
	  var classes = { addClasses: addClasses, removeClasses: removeClasses };
	
	  function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
	    var image;
	    function onReady() {
	      if (callback) { callback(); }
	    }
	    if (!imageEl.complete || !checkForComplete) {
	      if (src) {
	        image = new win.Image();
	        image.onload = onReady;
	        image.onerror = onReady;
	        if (sizes) {
	          image.sizes = sizes;
	        }
	        if (srcset) {
	          image.srcset = srcset;
	        }
	        if (src) {
	          image.src = src;
	        }
	      } else {
	        onReady();
	      }
	    } else {
	      // image already loaded...
	      onReady();
	    }
	  }
	
	  function preloadImages () {
	    var swiper = this;
	    swiper.imagesToLoad = swiper.$el.find('img');
	    function onReady() {
	      if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) { return; }
	      if (swiper.imagesLoaded !== undefined) { swiper.imagesLoaded += 1; }
	      if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
	        if (swiper.params.updateOnImagesReady) { swiper.update(); }
	        swiper.emit('imagesReady');
	      }
	    }
	    for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
	      var imageEl = swiper.imagesToLoad[i];
	      swiper.loadImage(
	        imageEl,
	        imageEl.currentSrc || imageEl.getAttribute('src'),
	        imageEl.srcset || imageEl.getAttribute('srcset'),
	        imageEl.sizes || imageEl.getAttribute('sizes'),
	        true,
	        onReady
	      );
	    }
	  }
	
	  var images = {
	    loadImage: loadImage,
	    preloadImages: preloadImages,
	  };
	
	  function checkOverflow() {
	    var swiper = this;
	    var wasLocked = swiper.isLocked;
	
	    swiper.isLocked = swiper.snapGrid.length === 1;
	    swiper.allowSlideNext = !swiper.isLocked;
	    swiper.allowSlidePrev = !swiper.isLocked;
	
	    // events
	    if (wasLocked !== swiper.isLocked) { swiper.emit(swiper.isLocked ? 'lock' : 'unlock'); }
	
	    if (wasLocked && wasLocked !== swiper.isLocked) {
	      swiper.isEnd = false;
	      swiper.navigation.update();
	    }
	  }
	
	  var checkOverflow$1 = { checkOverflow: checkOverflow };
	
	  var defaults = {
	    init: true,
	    direction: 'horizontal',
	    touchEventsTarget: 'container',
	    initialSlide: 0,
	    speed: 300,
	    //
	    preventInteractionOnTransition: false,
	
	    // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
	    edgeSwipeDetection: false,
	    edgeSwipeThreshold: 20,
	
	    // Free mode
	    freeMode: false,
	    freeModeMomentum: true,
	    freeModeMomentumRatio: 1,
	    freeModeMomentumBounce: true,
	    freeModeMomentumBounceRatio: 1,
	    freeModeMomentumVelocityRatio: 1,
	    freeModeSticky: false,
	    freeModeMinimumVelocity: 0.02,
	
	    // Autoheight
	    autoHeight: false,
	
	    // Set wrapper width
	    setWrapperSize: false,
	
	    // Virtual Translate
	    virtualTranslate: false,
	
	    // Effects
	    effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
	
	    // Breakpoints
	    breakpoints: undefined,
	    breakpointsInverse: false,
	
	    // Slides grid
	    spaceBetween: 0,
	    slidesPerView: 1,
	    slidesPerColumn: 1,
	    slidesPerColumnFill: 'column',
	    slidesPerGroup: 1,
	    centeredSlides: false,
	    slidesOffsetBefore: 0, // in px
	    slidesOffsetAfter: 0, // in px
	    normalizeSlideIndex: true,
	    centerInsufficientSlides: false,
	
	    // Disable swiper and hide navigation when container not overflow
	    watchOverflow: false,
	
	    // Round length
	    roundLengths: false,
	
	    // Touches
	    touchRatio: 1,
	    touchAngle: 45,
	    simulateTouch: true,
	    shortSwipes: true,
	    longSwipes: true,
	    longSwipesRatio: 0.5,
	    longSwipesMs: 300,
	    followFinger: true,
	    allowTouchMove: true,
	    threshold: 0,
	    touchMoveStopPropagation: true,
	    touchStartPreventDefault: true,
	    touchStartForcePreventDefault: false,
	    touchReleaseOnEdges: false,
	
	    // Unique Navigation Elements
	    uniqueNavElements: true,
	
	    // Resistance
	    resistance: true,
	    resistanceRatio: 0.85,
	
	    // Progress
	    watchSlidesProgress: false,
	    watchSlidesVisibility: false,
	
	    // Cursor
	    grabCursor: false,
	
	    // Clicks
	    preventClicks: true,
	    preventClicksPropagation: true,
	    slideToClickedSlide: false,
	
	    // Images
	    preloadImages: true,
	    updateOnImagesReady: true,
	
	    // loop
	    loop: false,
	    loopAdditionalSlides: 0,
	    loopedSlides: null,
	    loopFillGroupWithBlank: false,
	
	    // Swiping/no swiping
	    allowSlidePrev: true,
	    allowSlideNext: true,
	    swipeHandler: null, // '.swipe-handler',
	    noSwiping: true,
	    noSwipingClass: 'swiper-no-swiping',
	    noSwipingSelector: null,
	
	    // Passive Listeners
	    passiveListeners: true,
	
	    // NS
	    containerModifierClass: 'swiper-container-', // NEW
	    slideClass: 'swiper-slide',
	    slideBlankClass: 'swiper-slide-invisible-blank',
	    slideActiveClass: 'swiper-slide-active',
	    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
	    slideVisibleClass: 'swiper-slide-visible',
	    slideDuplicateClass: 'swiper-slide-duplicate',
	    slideNextClass: 'swiper-slide-next',
	    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
	    slidePrevClass: 'swiper-slide-prev',
	    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
	    wrapperClass: 'swiper-wrapper',
	
	    // Callbacks
	    runCallbacksOnInit: true,
	  };
	
	  /* eslint no-param-reassign: "off" */
	
	  var prototypes = {
	    update: update,
	    translate: translate,
	    transition: transition$1,
	    slide: slide,
	    loop: loop,
	    grabCursor: grabCursor,
	    manipulation: manipulation,
	    events: events,
	    breakpoints: breakpoints,
	    checkOverflow: checkOverflow$1,
	    classes: classes,
	    images: images,
	  };
	
	  var extendedDefaults = {};
	
	  var Swiper = /*@__PURE__*/(function (SwiperClass) {
	    function Swiper() {
	      var assign;
	
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	      var el;
	      var params;
	      if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
	        params = args[0];
	      } else {
	        (assign = args, el = assign[0], params = assign[1]);
	      }
	      if (!params) { params = {}; }
	
	      params = Utils.extend({}, params);
	      if (el && !params.el) { params.el = el; }
	
	      SwiperClass.call(this, params);
	
	      Object.keys(prototypes).forEach(function (prototypeGroup) {
	        Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
	          if (!Swiper.prototype[protoMethod]) {
	            Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
	          }
	        });
	      });
	
	      // Swiper Instance
	      var swiper = this;
	      if (typeof swiper.modules === 'undefined') {
	        swiper.modules = {};
	      }
	      Object.keys(swiper.modules).forEach(function (moduleName) {
	        var module = swiper.modules[moduleName];
	        if (module.params) {
	          var moduleParamName = Object.keys(module.params)[0];
	          var moduleParams = module.params[moduleParamName];
	          if (typeof moduleParams !== 'object' || moduleParams === null) { return; }
	          if (!(moduleParamName in params && 'enabled' in moduleParams)) { return; }
	          if (params[moduleParamName] === true) {
	            params[moduleParamName] = { enabled: true };
	          }
	          if (
	            typeof params[moduleParamName] === 'object'
	            && !('enabled' in params[moduleParamName])
	          ) {
	            params[moduleParamName].enabled = true;
	          }
	          if (!params[moduleParamName]) { params[moduleParamName] = { enabled: false }; }
	        }
	      });
	
	      // Extend defaults with modules params
	      var swiperParams = Utils.extend({}, defaults);
	      swiper.useModulesParams(swiperParams);
	
	      // Extend defaults with passed params
	      swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
	      swiper.originalParams = Utils.extend({}, swiper.params);
	      swiper.passedParams = Utils.extend({}, params);
	
	      // Save Dom lib
	      swiper.$ = $;
	
	      // Find el
	      var $el = $(swiper.params.el);
	      el = $el[0];
	
	      if (!el) {
	        return undefined;
	      }
	
	      if ($el.length > 1) {
	        var swipers = [];
	        $el.each(function (index, containerEl) {
	          var newParams = Utils.extend({}, params, { el: containerEl });
	          swipers.push(new Swiper(newParams));
	        });
	        return swipers;
	      }
	
	      el.swiper = swiper;
	      $el.data('swiper', swiper);
	
	      // Find Wrapper
	      var $wrapperEl = $el.children(("." + (swiper.params.wrapperClass)));
	
	      // Extend Swiper
	      Utils.extend(swiper, {
	        $el: $el,
	        el: el,
	        $wrapperEl: $wrapperEl,
	        wrapperEl: $wrapperEl[0],
	
	        // Classes
	        classNames: [],
	
	        // Slides
	        slides: $(),
	        slidesGrid: [],
	        snapGrid: [],
	        slidesSizesGrid: [],
	
	        // isDirection
	        isHorizontal: function isHorizontal() {
	          return swiper.params.direction === 'horizontal';
	        },
	        isVertical: function isVertical() {
	          return swiper.params.direction === 'vertical';
	        },
	        // RTL
	        rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
	        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
	        wrongRTL: $wrapperEl.css('display') === '-webkit-box',
	
	        // Indexes
	        activeIndex: 0,
	        realIndex: 0,
	
	        //
	        isBeginning: true,
	        isEnd: false,
	
	        // Props
	        translate: 0,
	        previousTranslate: 0,
	        progress: 0,
	        velocity: 0,
	        animating: false,
	
	        // Locks
	        allowSlideNext: swiper.params.allowSlideNext,
	        allowSlidePrev: swiper.params.allowSlidePrev,
	
	        // Touch Events
	        touchEvents: (function touchEvents() {
	          var touch = ['touchstart', 'touchmove', 'touchend'];
	          var desktop = ['mousedown', 'mousemove', 'mouseup'];
	          if (Support.pointerEvents) {
	            desktop = ['pointerdown', 'pointermove', 'pointerup'];
	          } else if (Support.prefixedPointerEvents) {
	            desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
	          }
	          swiper.touchEventsTouch = {
	            start: touch[0],
	            move: touch[1],
	            end: touch[2],
	          };
	          swiper.touchEventsDesktop = {
	            start: desktop[0],
	            move: desktop[1],
	            end: desktop[2],
	          };
	          return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
	        }()),
	        touchEventsData: {
	          isTouched: undefined,
	          isMoved: undefined,
	          allowTouchCallbacks: undefined,
	          touchStartTime: undefined,
	          isScrolling: undefined,
	          currentTranslate: undefined,
	          startTranslate: undefined,
	          allowThresholdMove: undefined,
	          // Form elements to match
	          formElements: 'input, select, option, textarea, button, video',
	          // Last click time
	          lastClickTime: Utils.now(),
	          clickTimeout: undefined,
	          // Velocities
	          velocities: [],
	          allowMomentumBounce: undefined,
	          isTouchEvent: undefined,
	          startMoving: undefined,
	        },
	
	        // Clicks
	        allowClick: true,
	
	        // Touches
	        allowTouchMove: swiper.params.allowTouchMove,
	
	        touches: {
	          startX: 0,
	          startY: 0,
	          currentX: 0,
	          currentY: 0,
	          diff: 0,
	        },
	
	        // Images
	        imagesToLoad: [],
	        imagesLoaded: 0,
	
	      });
	
	      // Install Modules
	      swiper.useModules();
	
	      // Init
	      if (swiper.params.init) {
	        swiper.init();
	      }
	
	      // Return app instance
	      return swiper;
	    }
	
	    if ( SwiperClass ) Swiper.__proto__ = SwiperClass;
	    Swiper.prototype = Object.create( SwiperClass && SwiperClass.prototype );
	    Swiper.prototype.constructor = Swiper;
	
	    var staticAccessors = { extendedDefaults: { configurable: true },defaults: { configurable: true },Class: { configurable: true },$: { configurable: true } };
	
	    Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic () {
	      var swiper = this;
	      var params = swiper.params;
	      var slides = swiper.slides;
	      var slidesGrid = swiper.slidesGrid;
	      var swiperSize = swiper.size;
	      var activeIndex = swiper.activeIndex;
	      var spv = 1;
	      if (params.centeredSlides) {
	        var slideSize = slides[activeIndex].swiperSlideSize;
	        var breakLoop;
	        for (var i = activeIndex + 1; i < slides.length; i += 1) {
	          if (slides[i] && !breakLoop) {
	            slideSize += slides[i].swiperSlideSize;
	            spv += 1;
	            if (slideSize > swiperSize) { breakLoop = true; }
	          }
	        }
	        for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
	          if (slides[i$1] && !breakLoop) {
	            slideSize += slides[i$1].swiperSlideSize;
	            spv += 1;
	            if (slideSize > swiperSize) { breakLoop = true; }
	          }
	        }
	      } else {
	        for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
	          if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
	            spv += 1;
	          }
	        }
	      }
	      return spv;
	    };
	
	    Swiper.prototype.update = function update () {
	      var swiper = this;
	      if (!swiper || swiper.destroyed) { return; }
	      var snapGrid = swiper.snapGrid;
	      var params = swiper.params;
	      // Breakpoints
	      if (params.breakpoints) {
	        swiper.setBreakpoint();
	      }
	      swiper.updateSize();
	      swiper.updateSlides();
	      swiper.updateProgress();
	      swiper.updateSlidesClasses();
	
	      function setTranslate() {
	        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
	        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
	        swiper.setTranslate(newTranslate);
	        swiper.updateActiveIndex();
	        swiper.updateSlidesClasses();
	      }
	      var translated;
	      if (swiper.params.freeMode) {
	        setTranslate();
	        if (swiper.params.autoHeight) {
	          swiper.updateAutoHeight();
	        }
	      } else {
	        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
	          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	        } else {
	          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
	        }
	        if (!translated) {
	          setTranslate();
	        }
	      }
	      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
	        swiper.checkOverflow();
	      }
	      swiper.emit('update');
	    };
	
	    Swiper.prototype.changeDirection = function changeDirection (newDirection, needUpdate) {
	      if ( needUpdate === void 0 ) needUpdate = true;
	
	      var swiper = this;
	      var currentDirection = swiper.params.direction;
	      if (!newDirection) {
	        // eslint-disable-next-line
	        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
	      }
	      if ((newDirection === currentDirection) || (newDirection !== 'horizontal' && newDirection !== 'vertical')) {
	        return swiper;
	      }
	
	      swiper.$el
	        .removeClass(("" + (swiper.params.containerModifierClass) + currentDirection + " wp8-" + currentDirection))
	        .addClass(("" + (swiper.params.containerModifierClass) + newDirection));
	
	      if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
	        swiper.$el.addClass(((swiper.params.containerModifierClass) + "wp8-" + newDirection));
	      }
	
	      swiper.params.direction = newDirection;
	
	      swiper.slides.each(function (slideIndex, slideEl) {
	        if (newDirection === 'vertical') {
	          slideEl.style.width = '';
	        } else {
	          slideEl.style.height = '';
	        }
	      });
	
	      swiper.emit('changeDirection');
	      if (needUpdate) { swiper.update(); }
	
	      return swiper;
	    };
	
	    Swiper.prototype.init = function init () {
	      var swiper = this;
	      if (swiper.initialized) { return; }
	
	      swiper.emit('beforeInit');
	
	      // Set breakpoint
	      if (swiper.params.breakpoints) {
	        swiper.setBreakpoint();
	      }
	
	      // Add Classes
	      swiper.addClasses();
	
	      // Create loop
	      if (swiper.params.loop) {
	        swiper.loopCreate();
	      }
	
	      // Update size
	      swiper.updateSize();
	
	      // Update slides
	      swiper.updateSlides();
	
	      if (swiper.params.watchOverflow) {
	        swiper.checkOverflow();
	      }
	
	      // Set Grab Cursor
	      if (swiper.params.grabCursor) {
	        swiper.setGrabCursor();
	      }
	
	      if (swiper.params.preloadImages) {
	        swiper.preloadImages();
	      }
	
	      // Slide To Initial Slide
	      if (swiper.params.loop) {
	        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
	      } else {
	        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
	      }
	
	      // Attach events
	      swiper.attachEvents();
	
	      // Init Flag
	      swiper.initialized = true;
	
	      // Emit
	      swiper.emit('init');
	    };
	
	    Swiper.prototype.destroy = function destroy (deleteInstance, cleanStyles) {
	      if ( deleteInstance === void 0 ) deleteInstance = true;
	      if ( cleanStyles === void 0 ) cleanStyles = true;
	
	      var swiper = this;
	      var params = swiper.params;
	      var $el = swiper.$el;
	      var $wrapperEl = swiper.$wrapperEl;
	      var slides = swiper.slides;
	
	      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
	        return null;
	      }
	
	      swiper.emit('beforeDestroy');
	
	      // Init Flag
	      swiper.initialized = false;
	
	      // Detach events
	      swiper.detachEvents();
	
	      // Destroy loop
	      if (params.loop) {
	        swiper.loopDestroy();
	      }
	
	      // Cleanup styles
	      if (cleanStyles) {
	        swiper.removeClasses();
	        $el.removeAttr('style');
	        $wrapperEl.removeAttr('style');
	        if (slides && slides.length) {
	          slides
	            .removeClass([
	              params.slideVisibleClass,
	              params.slideActiveClass,
	              params.slideNextClass,
	              params.slidePrevClass ].join(' '))
	            .removeAttr('style')
	            .removeAttr('data-swiper-slide-index')
	            .removeAttr('data-swiper-column')
	            .removeAttr('data-swiper-row');
	        }
	      }
	
	      swiper.emit('destroy');
	
	      // Detach emitter events
	      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
	        swiper.off(eventName);
	      });
	
	      if (deleteInstance !== false) {
	        swiper.$el[0].swiper = null;
	        swiper.$el.data('swiper', null);
	        Utils.deleteProps(swiper);
	      }
	      swiper.destroyed = true;
	
	      return null;
	    };
	
	    Swiper.extendDefaults = function extendDefaults (newDefaults) {
	      Utils.extend(extendedDefaults, newDefaults);
	    };
	
	    staticAccessors.extendedDefaults.get = function () {
	      return extendedDefaults;
	    };
	
	    staticAccessors.defaults.get = function () {
	      return defaults;
	    };
	
	    staticAccessors.Class.get = function () {
	      return SwiperClass;
	    };
	
	    staticAccessors.$.get = function () {
	      return $;
	    };
	
	    Object.defineProperties( Swiper, staticAccessors );
	
	    return Swiper;
	  }(SwiperClass));
	
	  var Device$1 = {
	    name: 'device',
	    proto: {
	      device: Device,
	    },
	    static: {
	      device: Device,
	    },
	  };
	
	  var Support$1 = {
	    name: 'support',
	    proto: {
	      support: Support,
	    },
	    static: {
	      support: Support,
	    },
	  };
	
	  var Browser$1 = {
	    name: 'browser',
	    proto: {
	      browser: Browser,
	    },
	    static: {
	      browser: Browser,
	    },
	  };
	
	  var Resize = {
	    name: 'resize',
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        resize: {
	          resizeHandler: function resizeHandler() {
	            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
	            swiper.emit('beforeResize');
	            swiper.emit('resize');
	          },
	          orientationChangeHandler: function orientationChangeHandler() {
	            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
	            swiper.emit('orientationchange');
	          },
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        // Emit resize
	        win.addEventListener('resize', swiper.resize.resizeHandler);
	
	        // Emit orientationchange
	        win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        win.removeEventListener('resize', swiper.resize.resizeHandler);
	        win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	      },
	    },
	  };
	
	  var Observer = {
	    func: win.MutationObserver || win.WebkitMutationObserver,
	    attach: function attach(target, options) {
	      if ( options === void 0 ) options = {};
	
	      var swiper = this;
	
	      var ObserverFunc = Observer.func;
	      var observer = new ObserverFunc(function (mutations) {
	        // The observerUpdate event should only be triggered
	        // once despite the number of mutations.  Additional
	        // triggers are redundant and are very costly
	        if (mutations.length === 1) {
	          swiper.emit('observerUpdate', mutations[0]);
	          return;
	        }
	        var observerUpdate = function observerUpdate() {
	          swiper.emit('observerUpdate', mutations[0]);
	        };
	
	        if (win.requestAnimationFrame) {
	          win.requestAnimationFrame(observerUpdate);
	        } else {
	          win.setTimeout(observerUpdate, 0);
	        }
	      });
	
	      observer.observe(target, {
	        attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
	        childList: typeof options.childList === 'undefined' ? true : options.childList,
	        characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
	      });
	
	      swiper.observer.observers.push(observer);
	    },
	    init: function init() {
	      var swiper = this;
	      if (!Support.observer || !swiper.params.observer) { return; }
	      if (swiper.params.observeParents) {
	        var containerParents = swiper.$el.parents();
	        for (var i = 0; i < containerParents.length; i += 1) {
	          swiper.observer.attach(containerParents[i]);
	        }
	      }
	      // Observe container
	      swiper.observer.attach(swiper.$el[0], { childList: swiper.params.observeSlideChildren });
	
	      // Observe wrapper
	      swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.observer.observers.forEach(function (observer) {
	        observer.disconnect();
	      });
	      swiper.observer.observers = [];
	    },
	  };
	
	  var Observer$1 = {
	    name: 'observer',
	    params: {
	      observer: false,
	      observeParents: false,
	      observeSlideChildren: false,
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        observer: {
	          init: Observer.init.bind(swiper),
	          attach: Observer.attach.bind(swiper),
	          destroy: Observer.destroy.bind(swiper),
	          observers: [],
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        swiper.observer.init();
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        swiper.observer.destroy();
	      },
	    },
	  };
	
	  var Virtual = {
	    update: function update(force) {
	      var swiper = this;
	      var ref = swiper.params;
	      var slidesPerView = ref.slidesPerView;
	      var slidesPerGroup = ref.slidesPerGroup;
	      var centeredSlides = ref.centeredSlides;
	      var ref$1 = swiper.params.virtual;
	      var addSlidesBefore = ref$1.addSlidesBefore;
	      var addSlidesAfter = ref$1.addSlidesAfter;
	      var ref$2 = swiper.virtual;
	      var previousFrom = ref$2.from;
	      var previousTo = ref$2.to;
	      var slides = ref$2.slides;
	      var previousSlidesGrid = ref$2.slidesGrid;
	      var renderSlide = ref$2.renderSlide;
	      var previousOffset = ref$2.offset;
	      swiper.updateActiveIndex();
	      var activeIndex = swiper.activeIndex || 0;
	
	      var offsetProp;
	      if (swiper.rtlTranslate) { offsetProp = 'right'; }
	      else { offsetProp = swiper.isHorizontal() ? 'left' : 'top'; }
	
	      var slidesAfter;
	      var slidesBefore;
	      if (centeredSlides) {
	        slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
	        slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
	      } else {
	        slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
	        slidesBefore = slidesPerGroup + addSlidesAfter;
	      }
	      var from = Math.max((activeIndex || 0) - slidesBefore, 0);
	      var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
	      var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
	
	      Utils.extend(swiper.virtual, {
	        from: from,
	        to: to,
	        offset: offset,
	        slidesGrid: swiper.slidesGrid,
	      });
	
	      function onRendered() {
	        swiper.updateSlides();
	        swiper.updateProgress();
	        swiper.updateSlidesClasses();
	        if (swiper.lazy && swiper.params.lazy.enabled) {
	          swiper.lazy.load();
	        }
	      }
	
	      if (previousFrom === from && previousTo === to && !force) {
	        if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
	          swiper.slides.css(offsetProp, (offset + "px"));
	        }
	        swiper.updateProgress();
	        return;
	      }
	      if (swiper.params.virtual.renderExternal) {
	        swiper.params.virtual.renderExternal.call(swiper, {
	          offset: offset,
	          from: from,
	          to: to,
	          slides: (function getSlides() {
	            var slidesToRender = [];
	            for (var i = from; i <= to; i += 1) {
	              slidesToRender.push(slides[i]);
	            }
	            return slidesToRender;
	          }()),
	        });
	        onRendered();
	        return;
	      }
	      var prependIndexes = [];
	      var appendIndexes = [];
	      if (force) {
	        swiper.$wrapperEl.find(("." + (swiper.params.slideClass))).remove();
	      } else {
	        for (var i = previousFrom; i <= previousTo; i += 1) {
	          if (i < from || i > to) {
	            swiper.$wrapperEl.find(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + i + "\"]")).remove();
	          }
	        }
	      }
	      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
	        if (i$1 >= from && i$1 <= to) {
	          if (typeof previousTo === 'undefined' || force) {
	            appendIndexes.push(i$1);
	          } else {
	            if (i$1 > previousTo) { appendIndexes.push(i$1); }
	            if (i$1 < previousFrom) { prependIndexes.push(i$1); }
	          }
	        }
	      }
	      appendIndexes.forEach(function (index) {
	        swiper.$wrapperEl.append(renderSlide(slides[index], index));
	      });
	      prependIndexes.sort(function (a, b) { return b - a; }).forEach(function (index) {
	        swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
	      });
	      swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, (offset + "px"));
	      onRendered();
	    },
	    renderSlide: function renderSlide(slide, index) {
	      var swiper = this;
	      var params = swiper.params.virtual;
	      if (params.cache && swiper.virtual.cache[index]) {
	        return swiper.virtual.cache[index];
	      }
	      var $slideEl = params.renderSlide
	        ? $(params.renderSlide.call(swiper, slide, index))
	        : $(("<div class=\"" + (swiper.params.slideClass) + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>"));
	      if (!$slideEl.attr('data-swiper-slide-index')) { $slideEl.attr('data-swiper-slide-index', index); }
	      if (params.cache) { swiper.virtual.cache[index] = $slideEl; }
	      return $slideEl;
	    },
	    appendSlide: function appendSlide(slides) {
	      var swiper = this;
	      if (typeof slides === 'object' && 'length' in slides) {
	        for (var i = 0; i < slides.length; i += 1) {
	          if (slides[i]) { swiper.virtual.slides.push(slides[i]); }
	        }
	      } else {
	        swiper.virtual.slides.push(slides);
	      }
	      swiper.virtual.update(true);
	    },
	    prependSlide: function prependSlide(slides) {
	      var swiper = this;
	      var activeIndex = swiper.activeIndex;
	      var newActiveIndex = activeIndex + 1;
	      var numberOfNewSlides = 1;
	
	      if (Array.isArray(slides)) {
	        for (var i = 0; i < slides.length; i += 1) {
	          if (slides[i]) { swiper.virtual.slides.unshift(slides[i]); }
	        }
	        newActiveIndex = activeIndex + slides.length;
	        numberOfNewSlides = slides.length;
	      } else {
	        swiper.virtual.slides.unshift(slides);
	      }
	      if (swiper.params.virtual.cache) {
	        var cache = swiper.virtual.cache;
	        var newCache = {};
	        Object.keys(cache).forEach(function (cachedIndex) {
	          newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cache[cachedIndex];
	        });
	        swiper.virtual.cache = newCache;
	      }
	      swiper.virtual.update(true);
	      swiper.slideTo(newActiveIndex, 0);
	    },
	    removeSlide: function removeSlide(slidesIndexes) {
	      var swiper = this;
	      if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) { return; }
	      var activeIndex = swiper.activeIndex;
	      if (Array.isArray(slidesIndexes)) {
	        for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
	          swiper.virtual.slides.splice(slidesIndexes[i], 1);
	          if (swiper.params.virtual.cache) {
	            delete swiper.virtual.cache[slidesIndexes[i]];
	          }
	          if (slidesIndexes[i] < activeIndex) { activeIndex -= 1; }
	          activeIndex = Math.max(activeIndex, 0);
	        }
	      } else {
	        swiper.virtual.slides.splice(slidesIndexes, 1);
	        if (swiper.params.virtual.cache) {
	          delete swiper.virtual.cache[slidesIndexes];
	        }
	        if (slidesIndexes < activeIndex) { activeIndex -= 1; }
	        activeIndex = Math.max(activeIndex, 0);
	      }
	      swiper.virtual.update(true);
	      swiper.slideTo(activeIndex, 0);
	    },
	    removeAllSlides: function removeAllSlides() {
	      var swiper = this;
	      swiper.virtual.slides = [];
	      if (swiper.params.virtual.cache) {
	        swiper.virtual.cache = {};
	      }
	      swiper.virtual.update(true);
	      swiper.slideTo(0, 0);
	    },
	  };
	
	  var Virtual$1 = {
	    name: 'virtual',
	    params: {
	      virtual: {
	        enabled: false,
	        slides: [],
	        cache: true,
	        renderSlide: null,
	        renderExternal: null,
	        addSlidesBefore: 0,
	        addSlidesAfter: 0,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        virtual: {
	          update: Virtual.update.bind(swiper),
	          appendSlide: Virtual.appendSlide.bind(swiper),
	          prependSlide: Virtual.prependSlide.bind(swiper),
	          removeSlide: Virtual.removeSlide.bind(swiper),
	          removeAllSlides: Virtual.removeAllSlides.bind(swiper),
	          renderSlide: Virtual.renderSlide.bind(swiper),
	          slides: swiper.params.virtual.slides,
	          cache: {},
	        },
	      });
	    },
	    on: {
	      beforeInit: function beforeInit() {
	        var swiper = this;
	        if (!swiper.params.virtual.enabled) { return; }
	        swiper.classNames.push(((swiper.params.containerModifierClass) + "virtual"));
	        var overwriteParams = {
	          watchSlidesProgress: true,
	        };
	        Utils.extend(swiper.params, overwriteParams);
	        Utils.extend(swiper.originalParams, overwriteParams);
	
	        if (!swiper.params.initialSlide) {
	          swiper.virtual.update();
	        }
	      },
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        if (!swiper.params.virtual.enabled) { return; }
	        swiper.virtual.update();
	      },
	    },
	  };
	
	  var Keyboard = {
	    handle: function handle(event) {
	      var swiper = this;
	      var rtl = swiper.rtlTranslate;
	      var e = event;
	      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
	      var kc = e.keyCode || e.charCode;
	      // Directions locks
	      if (!swiper.allowSlideNext && ((swiper.isHorizontal() && kc === 39) || (swiper.isVertical() && kc === 40) || kc === 34)) {
	        return false;
	      }
	      if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && kc === 37) || (swiper.isVertical() && kc === 38) || kc === 33)) {
	        return false;
	      }
	      if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
	        return undefined;
	      }
	      if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
	        return undefined;
	      }
	      if (swiper.params.keyboard.onlyInViewport && (kc === 33 || kc === 34 || kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
	        var inView = false;
	        // Check that swiper should be inside of visible area of window
	        if (swiper.$el.parents(("." + (swiper.params.slideClass))).length > 0 && swiper.$el.parents(("." + (swiper.params.slideActiveClass))).length === 0) {
	          return undefined;
	        }
	        var windowWidth = win.innerWidth;
	        var windowHeight = win.innerHeight;
	        var swiperOffset = swiper.$el.offset();
	        if (rtl) { swiperOffset.left -= swiper.$el[0].scrollLeft; }
	        var swiperCoord = [
	          [swiperOffset.left, swiperOffset.top],
	          [swiperOffset.left + swiper.width, swiperOffset.top],
	          [swiperOffset.left, swiperOffset.top + swiper.height],
	          [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height] ];
	        for (var i = 0; i < swiperCoord.length; i += 1) {
	          var point = swiperCoord[i];
	          if (
	            point[0] >= 0 && point[0] <= windowWidth
	            && point[1] >= 0 && point[1] <= windowHeight
	          ) {
	            inView = true;
	          }
	        }
	        if (!inView) { return undefined; }
	      }
	      if (swiper.isHorizontal()) {
	        if (kc === 33 || kc === 34 || kc === 37 || kc === 39) {
	          if (e.preventDefault) { e.preventDefault(); }
	          else { e.returnValue = false; }
	        }
	        if (((kc === 34 || kc === 39) && !rtl) || ((kc === 33 || kc === 37) && rtl)) { swiper.slideNext(); }
	        if (((kc === 33 || kc === 37) && !rtl) || ((kc === 34 || kc === 39) && rtl)) { swiper.slidePrev(); }
	      } else {
	        if (kc === 33 || kc === 34 || kc === 38 || kc === 40) {
	          if (e.preventDefault) { e.preventDefault(); }
	          else { e.returnValue = false; }
	        }
	        if (kc === 34 || kc === 40) { swiper.slideNext(); }
	        if (kc === 33 || kc === 38) { swiper.slidePrev(); }
	      }
	      swiper.emit('keyPress', kc);
	      return undefined;
	    },
	    enable: function enable() {
	      var swiper = this;
	      if (swiper.keyboard.enabled) { return; }
	      $(doc).on('keydown', swiper.keyboard.handle);
	      swiper.keyboard.enabled = true;
	    },
	    disable: function disable() {
	      var swiper = this;
	      if (!swiper.keyboard.enabled) { return; }
	      $(doc).off('keydown', swiper.keyboard.handle);
	      swiper.keyboard.enabled = false;
	    },
	  };
	
	  var Keyboard$1 = {
	    name: 'keyboard',
	    params: {
	      keyboard: {
	        enabled: false,
	        onlyInViewport: true,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        keyboard: {
	          enabled: false,
	          enable: Keyboard.enable.bind(swiper),
	          disable: Keyboard.disable.bind(swiper),
	          handle: Keyboard.handle.bind(swiper),
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        if (swiper.params.keyboard.enabled) {
	          swiper.keyboard.enable();
	        }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        if (swiper.keyboard.enabled) {
	          swiper.keyboard.disable();
	        }
	      },
	    },
	  };
	
	  function isEventSupported() {
	    var eventName = 'onwheel';
	    var isSupported = eventName in doc;
	
	    if (!isSupported) {
	      var element = doc.createElement('div');
	      element.setAttribute(eventName, 'return;');
	      isSupported = typeof element[eventName] === 'function';
	    }
	
	    if (!isSupported
	      && doc.implementation
	      && doc.implementation.hasFeature
	      // always returns true in newer browsers as per the standard.
	      // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	      && doc.implementation.hasFeature('', '') !== true
	    ) {
	      // This is the only way to test support for the `wheel` event in IE9+.
	      isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
	    }
	
	    return isSupported;
	  }
	  var Mousewheel = {
	    lastScrollTime: Utils.now(),
	    event: (function getEvent() {
	      if (win.navigator.userAgent.indexOf('firefox') > -1) { return 'DOMMouseScroll'; }
	      return isEventSupported() ? 'wheel' : 'mousewheel';
	    }()),
	    normalize: function normalize(e) {
	      // Reasonable defaults
	      var PIXEL_STEP = 10;
	      var LINE_HEIGHT = 40;
	      var PAGE_HEIGHT = 800;
	
	      var sX = 0;
	      var sY = 0; // spinX, spinY
	      var pX = 0;
	      var pY = 0; // pixelX, pixelY
	
	      // Legacy
	      if ('detail' in e) {
	        sY = e.detail;
	      }
	      if ('wheelDelta' in e) {
	        sY = -e.wheelDelta / 120;
	      }
	      if ('wheelDeltaY' in e) {
	        sY = -e.wheelDeltaY / 120;
	      }
	      if ('wheelDeltaX' in e) {
	        sX = -e.wheelDeltaX / 120;
	      }
	
	      // side scrolling on FF with DOMMouseScroll
	      if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
	        sX = sY;
	        sY = 0;
	      }
	
	      pX = sX * PIXEL_STEP;
	      pY = sY * PIXEL_STEP;
	
	      if ('deltaY' in e) {
	        pY = e.deltaY;
	      }
	      if ('deltaX' in e) {
	        pX = e.deltaX;
	      }
	
	      if ((pX || pY) && e.deltaMode) {
	        if (e.deltaMode === 1) { // delta in LINE units
	          pX *= LINE_HEIGHT;
	          pY *= LINE_HEIGHT;
	        } else { // delta in PAGE units
	          pX *= PAGE_HEIGHT;
	          pY *= PAGE_HEIGHT;
	        }
	      }
	
	      // Fall-back if spin cannot be determined
	      if (pX && !sX) {
	        sX = (pX < 1) ? -1 : 1;
	      }
	      if (pY && !sY) {
	        sY = (pY < 1) ? -1 : 1;
	      }
	
	      return {
	        spinX: sX,
	        spinY: sY,
	        pixelX: pX,
	        pixelY: pY,
	      };
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      var swiper = this;
	      swiper.mouseEntered = true;
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      var swiper = this;
	      swiper.mouseEntered = false;
	    },
	    handle: function handle(event) {
	      var e = event;
	      var swiper = this;
	      var params = swiper.params.mousewheel;
	
	      if (!swiper.mouseEntered && !params.releaseOnEdges) { return true; }
	
	      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
	      var delta = 0;
	      var rtlFactor = swiper.rtlTranslate ? -1 : 1;
	
	      var data = Mousewheel.normalize(e);
	
	      if (params.forceToAxis) {
	        if (swiper.isHorizontal()) {
	          if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) { delta = data.pixelX * rtlFactor; }
	          else { return true; }
	        } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = data.pixelY; }
	        else { return true; }
	      } else {
	        delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
	      }
	
	      if (delta === 0) { return true; }
	
	      if (params.invert) { delta = -delta; }
	
	      if (!swiper.params.freeMode) {
	        if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
	          if (delta < 0) {
	            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
	              swiper.slideNext();
	              swiper.emit('scroll', e);
	            } else if (params.releaseOnEdges) { return true; }
	          } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
	            swiper.slidePrev();
	            swiper.emit('scroll', e);
	          } else if (params.releaseOnEdges) { return true; }
	        }
	        swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
	      } else {
	        // Freemode or scrollContainer:
	        if (swiper.params.loop) {
	          swiper.loopFix();
	        }
	        var position = swiper.getTranslate() + (delta * params.sensitivity);
	        var wasBeginning = swiper.isBeginning;
	        var wasEnd = swiper.isEnd;
	
	        if (position >= swiper.minTranslate()) { position = swiper.minTranslate(); }
	        if (position <= swiper.maxTranslate()) { position = swiper.maxTranslate(); }
	
	        swiper.setTransition(0);
	        swiper.setTranslate(position);
	        swiper.updateProgress();
	        swiper.updateActiveIndex();
	        swiper.updateSlidesClasses();
	
	        if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
	          swiper.updateSlidesClasses();
	        }
	
	        if (swiper.params.freeModeSticky) {
	          clearTimeout(swiper.mousewheel.timeout);
	          swiper.mousewheel.timeout = Utils.nextTick(function () {
	            swiper.slideToClosest();
	          }, 300);
	        }
	        // Emit event
	        swiper.emit('scroll', e);
	
	        // Stop autoplay
	        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) { swiper.autoplay.stop(); }
	        // Return page scroll on edge positions
	        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) { return true; }
	      }
	
	      if (e.preventDefault) { e.preventDefault(); }
	      else { e.returnValue = false; }
	      return false;
	    },
	    enable: function enable() {
	      var swiper = this;
	      if (!Mousewheel.event) { return false; }
	      if (swiper.mousewheel.enabled) { return false; }
	      var target = swiper.$el;
	      if (swiper.params.mousewheel.eventsTarged !== 'container') {
	        target = $(swiper.params.mousewheel.eventsTarged);
	      }
	      target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
	      target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
	      target.on(Mousewheel.event, swiper.mousewheel.handle);
	      swiper.mousewheel.enabled = true;
	      return true;
	    },
	    disable: function disable() {
	      var swiper = this;
	      if (!Mousewheel.event) { return false; }
	      if (!swiper.mousewheel.enabled) { return false; }
	      var target = swiper.$el;
	      if (swiper.params.mousewheel.eventsTarged !== 'container') {
	        target = $(swiper.params.mousewheel.eventsTarged);
	      }
	      target.off(Mousewheel.event, swiper.mousewheel.handle);
	      swiper.mousewheel.enabled = false;
	      return true;
	    },
	  };
	
	  var Mousewheel$1 = {
	    name: 'mousewheel',
	    params: {
	      mousewheel: {
	        enabled: false,
	        releaseOnEdges: false,
	        invert: false,
	        forceToAxis: false,
	        sensitivity: 1,
	        eventsTarged: 'container',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        mousewheel: {
	          enabled: false,
	          enable: Mousewheel.enable.bind(swiper),
	          disable: Mousewheel.disable.bind(swiper),
	          handle: Mousewheel.handle.bind(swiper),
	          handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
	          handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
	          lastScrollTime: Utils.now(),
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        if (swiper.params.mousewheel.enabled) { swiper.mousewheel.enable(); }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        if (swiper.mousewheel.enabled) { swiper.mousewheel.disable(); }
	      },
	    },
	  };
	
	  var Navigation = {
	    update: function update() {
	      // Update Navigation Buttons
	      var swiper = this;
	      var params = swiper.params.navigation;
	
	      if (swiper.params.loop) { return; }
	      var ref = swiper.navigation;
	      var $nextEl = ref.$nextEl;
	      var $prevEl = ref.$prevEl;
	
	      if ($prevEl && $prevEl.length > 0) {
	        if (swiper.isBeginning) {
	          $prevEl.addClass(params.disabledClass);
	        } else {
	          $prevEl.removeClass(params.disabledClass);
	        }
	        $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	      }
	      if ($nextEl && $nextEl.length > 0) {
	        if (swiper.isEnd) {
	          $nextEl.addClass(params.disabledClass);
	        } else {
	          $nextEl.removeClass(params.disabledClass);
	        }
	        $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	      }
	    },
	    onPrevClick: function onPrevClick(e) {
	      var swiper = this;
	      e.preventDefault();
	      if (swiper.isBeginning && !swiper.params.loop) { return; }
	      swiper.slidePrev();
	    },
	    onNextClick: function onNextClick(e) {
	      var swiper = this;
	      e.preventDefault();
	      if (swiper.isEnd && !swiper.params.loop) { return; }
	      swiper.slideNext();
	    },
	    init: function init() {
	      var swiper = this;
	      var params = swiper.params.navigation;
	      if (!(params.nextEl || params.prevEl)) { return; }
	
	      var $nextEl;
	      var $prevEl;
	      if (params.nextEl) {
	        $nextEl = $(params.nextEl);
	        if (
	          swiper.params.uniqueNavElements
	          && typeof params.nextEl === 'string'
	          && $nextEl.length > 1
	          && swiper.$el.find(params.nextEl).length === 1
	        ) {
	          $nextEl = swiper.$el.find(params.nextEl);
	        }
	      }
	      if (params.prevEl) {
	        $prevEl = $(params.prevEl);
	        if (
	          swiper.params.uniqueNavElements
	          && typeof params.prevEl === 'string'
	          && $prevEl.length > 1
	          && swiper.$el.find(params.prevEl).length === 1
	        ) {
	          $prevEl = swiper.$el.find(params.prevEl);
	        }
	      }
	
	      if ($nextEl && $nextEl.length > 0) {
	        $nextEl.on('click', swiper.navigation.onNextClick);
	      }
	      if ($prevEl && $prevEl.length > 0) {
	        $prevEl.on('click', swiper.navigation.onPrevClick);
	      }
	
	      Utils.extend(swiper.navigation, {
	        $nextEl: $nextEl,
	        nextEl: $nextEl && $nextEl[0],
	        $prevEl: $prevEl,
	        prevEl: $prevEl && $prevEl[0],
	      });
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      var ref = swiper.navigation;
	      var $nextEl = ref.$nextEl;
	      var $prevEl = ref.$prevEl;
	      if ($nextEl && $nextEl.length) {
	        $nextEl.off('click', swiper.navigation.onNextClick);
	        $nextEl.removeClass(swiper.params.navigation.disabledClass);
	      }
	      if ($prevEl && $prevEl.length) {
	        $prevEl.off('click', swiper.navigation.onPrevClick);
	        $prevEl.removeClass(swiper.params.navigation.disabledClass);
	      }
	    },
	  };
	
	  var Navigation$1 = {
	    name: 'navigation',
	    params: {
	      navigation: {
	        nextEl: null,
	        prevEl: null,
	
	        hideOnClick: false,
	        disabledClass: 'swiper-button-disabled',
	        hiddenClass: 'swiper-button-hidden',
	        lockClass: 'swiper-button-lock',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        navigation: {
	          init: Navigation.init.bind(swiper),
	          update: Navigation.update.bind(swiper),
	          destroy: Navigation.destroy.bind(swiper),
	          onNextClick: Navigation.onNextClick.bind(swiper),
	          onPrevClick: Navigation.onPrevClick.bind(swiper),
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        swiper.navigation.init();
	        swiper.navigation.update();
	      },
	      toEdge: function toEdge() {
	        var swiper = this;
	        swiper.navigation.update();
	      },
	      fromEdge: function fromEdge() {
	        var swiper = this;
	        swiper.navigation.update();
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        swiper.navigation.destroy();
	      },
	      click: function click(e) {
	        var swiper = this;
	        var ref = swiper.navigation;
	        var $nextEl = ref.$nextEl;
	        var $prevEl = ref.$prevEl;
	        if (
	          swiper.params.navigation.hideOnClick
	          && !$(e.target).is($prevEl)
	          && !$(e.target).is($nextEl)
	        ) {
	          var isHidden;
	          if ($nextEl) {
	            isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
	          } else if ($prevEl) {
	            isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
	          }
	          if (isHidden === true) {
	            swiper.emit('navigationShow', swiper);
	          } else {
	            swiper.emit('navigationHide', swiper);
	          }
	          if ($nextEl) {
	            $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
	          }
	          if ($prevEl) {
	            $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
	          }
	        }
	      },
	    },
	  };
	
	  var Pagination = {
	    update: function update() {
	      // Render || Update Pagination bullets/items
	      var swiper = this;
	      var rtl = swiper.rtl;
	      var params = swiper.params.pagination;
	      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	      var $el = swiper.pagination.$el;
	      // Current/Total
	      var current;
	      var total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	      if (swiper.params.loop) {
	        current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
	        if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
	          current -= (slidesLength - (swiper.loopedSlides * 2));
	        }
	        if (current > total - 1) { current -= total; }
	        if (current < 0 && swiper.params.paginationType !== 'bullets') { current = total + current; }
	      } else if (typeof swiper.snapIndex !== 'undefined') {
	        current = swiper.snapIndex;
	      } else {
	        current = swiper.activeIndex || 0;
	      }
	      // Types
	      if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
	        var bullets = swiper.pagination.bullets;
	        var firstIndex;
	        var lastIndex;
	        var midIndex;
	        if (params.dynamicBullets) {
	          swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
	          $el.css(swiper.isHorizontal() ? 'width' : 'height', ((swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)) + "px"));
	          if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
	            swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
	            if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
	              swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
	            } else if (swiper.pagination.dynamicBulletIndex < 0) {
	              swiper.pagination.dynamicBulletIndex = 0;
	            }
	          }
	          firstIndex = current - swiper.pagination.dynamicBulletIndex;
	          lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
	          midIndex = (lastIndex + firstIndex) / 2;
	        }
	        bullets.removeClass(((params.bulletActiveClass) + " " + (params.bulletActiveClass) + "-next " + (params.bulletActiveClass) + "-next-next " + (params.bulletActiveClass) + "-prev " + (params.bulletActiveClass) + "-prev-prev " + (params.bulletActiveClass) + "-main"));
	        if ($el.length > 1) {
	          bullets.each(function (index, bullet) {
	            var $bullet = $(bullet);
	            var bulletIndex = $bullet.index();
	            if (bulletIndex === current) {
	              $bullet.addClass(params.bulletActiveClass);
	            }
	            if (params.dynamicBullets) {
	              if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
	                $bullet.addClass(((params.bulletActiveClass) + "-main"));
	              }
	              if (bulletIndex === firstIndex) {
	                $bullet
	                  .prev()
	                  .addClass(((params.bulletActiveClass) + "-prev"))
	                  .prev()
	                  .addClass(((params.bulletActiveClass) + "-prev-prev"));
	              }
	              if (bulletIndex === lastIndex) {
	                $bullet
	                  .next()
	                  .addClass(((params.bulletActiveClass) + "-next"))
	                  .next()
	                  .addClass(((params.bulletActiveClass) + "-next-next"));
	              }
	            }
	          });
	        } else {
	          var $bullet = bullets.eq(current);
	          $bullet.addClass(params.bulletActiveClass);
	          if (params.dynamicBullets) {
	            var $firstDisplayedBullet = bullets.eq(firstIndex);
	            var $lastDisplayedBullet = bullets.eq(lastIndex);
	            for (var i = firstIndex; i <= lastIndex; i += 1) {
	              bullets.eq(i).addClass(((params.bulletActiveClass) + "-main"));
	            }
	            $firstDisplayedBullet
	              .prev()
	              .addClass(((params.bulletActiveClass) + "-prev"))
	              .prev()
	              .addClass(((params.bulletActiveClass) + "-prev-prev"));
	            $lastDisplayedBullet
	              .next()
	              .addClass(((params.bulletActiveClass) + "-next"))
	              .next()
	              .addClass(((params.bulletActiveClass) + "-next-next"));
	          }
	        }
	        if (params.dynamicBullets) {
	          var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
	          var bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
	          var offsetProp = rtl ? 'right' : 'left';
	          bullets.css(swiper.isHorizontal() ? offsetProp : 'top', (bulletsOffset + "px"));
	        }
	      }
	      if (params.type === 'fraction') {
	        $el.find(("." + (params.currentClass))).text(params.formatFractionCurrent(current + 1));
	        $el.find(("." + (params.totalClass))).text(params.formatFractionTotal(total));
	      }
	      if (params.type === 'progressbar') {
	        var progressbarDirection;
	        if (params.progressbarOpposite) {
	          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
	        } else {
	          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
	        }
	        var scale = (current + 1) / total;
	        var scaleX = 1;
	        var scaleY = 1;
	        if (progressbarDirection === 'horizontal') {
	          scaleX = scale;
	        } else {
	          scaleY = scale;
	        }
	        $el.find(("." + (params.progressbarFillClass))).transform(("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")")).transition(swiper.params.speed);
	      }
	      if (params.type === 'custom' && params.renderCustom) {
	        $el.html(params.renderCustom(swiper, current + 1, total));
	        swiper.emit('paginationRender', swiper, $el[0]);
	      } else {
	        swiper.emit('paginationUpdate', swiper, $el[0]);
	      }
	      $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	    },
	    render: function render() {
	      // Render Container
	      var swiper = this;
	      var params = swiper.params.pagination;
	      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	
	      var $el = swiper.pagination.$el;
	      var paginationHTML = '';
	      if (params.type === 'bullets') {
	        var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	        for (var i = 0; i < numberOfBullets; i += 1) {
	          if (params.renderBullet) {
	            paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
	          } else {
	            paginationHTML += "<" + (params.bulletElement) + " class=\"" + (params.bulletClass) + "\"></" + (params.bulletElement) + ">";
	          }
	        }
	        $el.html(paginationHTML);
	        swiper.pagination.bullets = $el.find(("." + (params.bulletClass)));
	      }
	      if (params.type === 'fraction') {
	        if (params.renderFraction) {
	          paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
	        } else {
	          paginationHTML = "<span class=\"" + (params.currentClass) + "\"></span>"
	          + ' / '
	          + "<span class=\"" + (params.totalClass) + "\"></span>";
	        }
	        $el.html(paginationHTML);
	      }
	      if (params.type === 'progressbar') {
	        if (params.renderProgressbar) {
	          paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
	        } else {
	          paginationHTML = "<span class=\"" + (params.progressbarFillClass) + "\"></span>";
	        }
	        $el.html(paginationHTML);
	      }
	      if (params.type !== 'custom') {
	        swiper.emit('paginationRender', swiper.pagination.$el[0]);
	      }
	    },
	    init: function init() {
	      var swiper = this;
	      var params = swiper.params.pagination;
	      if (!params.el) { return; }
	
	      var $el = $(params.el);
	      if ($el.length === 0) { return; }
	
	      if (
	        swiper.params.uniqueNavElements
	        && typeof params.el === 'string'
	        && $el.length > 1
	        && swiper.$el.find(params.el).length === 1
	      ) {
	        $el = swiper.$el.find(params.el);
	      }
	
	      if (params.type === 'bullets' && params.clickable) {
	        $el.addClass(params.clickableClass);
	      }
	
	      $el.addClass(params.modifierClass + params.type);
	
	      if (params.type === 'bullets' && params.dynamicBullets) {
	        $el.addClass(("" + (params.modifierClass) + (params.type) + "-dynamic"));
	        swiper.pagination.dynamicBulletIndex = 0;
	        if (params.dynamicMainBullets < 1) {
	          params.dynamicMainBullets = 1;
	        }
	      }
	      if (params.type === 'progressbar' && params.progressbarOpposite) {
	        $el.addClass(params.progressbarOppositeClass);
	      }
	
	      if (params.clickable) {
	        $el.on('click', ("." + (params.bulletClass)), function onClick(e) {
	          e.preventDefault();
	          var index = $(this).index() * swiper.params.slidesPerGroup;
	          if (swiper.params.loop) { index += swiper.loopedSlides; }
	          swiper.slideTo(index);
	        });
	      }
	
	      Utils.extend(swiper.pagination, {
	        $el: $el,
	        el: $el[0],
	      });
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      var params = swiper.params.pagination;
	      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	      var $el = swiper.pagination.$el;
	
	      $el.removeClass(params.hiddenClass);
	      $el.removeClass(params.modifierClass + params.type);
	      if (swiper.pagination.bullets) { swiper.pagination.bullets.removeClass(params.bulletActiveClass); }
	      if (params.clickable) {
	        $el.off('click', ("." + (params.bulletClass)));
	      }
	    },
	  };
	
	  var Pagination$1 = {
	    name: 'pagination',
	    params: {
	      pagination: {
	        el: null,
	        bulletElement: 'span',
	        clickable: false,
	        hideOnClick: false,
	        renderBullet: null,
	        renderProgressbar: null,
	        renderFraction: null,
	        renderCustom: null,
	        progressbarOpposite: false,
	        type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
	        dynamicBullets: false,
	        dynamicMainBullets: 1,
	        formatFractionCurrent: function (number) { return number; },
	        formatFractionTotal: function (number) { return number; },
	        bulletClass: 'swiper-pagination-bullet',
	        bulletActiveClass: 'swiper-pagination-bullet-active',
	        modifierClass: 'swiper-pagination-', // NEW
	        currentClass: 'swiper-pagination-current',
	        totalClass: 'swiper-pagination-total',
	        hiddenClass: 'swiper-pagination-hidden',
	        progressbarFillClass: 'swiper-pagination-progressbar-fill',
	        progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
	        clickableClass: 'swiper-pagination-clickable', // NEW
	        lockClass: 'swiper-pagination-lock',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        pagination: {
	          init: Pagination.init.bind(swiper),
	          render: Pagination.render.bind(swiper),
	          update: Pagination.update.bind(swiper),
	          destroy: Pagination.destroy.bind(swiper),
	          dynamicBulletIndex: 0,
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        swiper.pagination.init();
	        swiper.pagination.render();
	        swiper.pagination.update();
	      },
	      activeIndexChange: function activeIndexChange() {
	        var swiper = this;
	        if (swiper.params.loop) {
	          swiper.pagination.update();
	        } else if (typeof swiper.snapIndex === 'undefined') {
	          swiper.pagination.update();
	        }
	      },
	      snapIndexChange: function snapIndexChange() {
	        var swiper = this;
	        if (!swiper.params.loop) {
	          swiper.pagination.update();
	        }
	      },
	      slidesLengthChange: function slidesLengthChange() {
	        var swiper = this;
	        if (swiper.params.loop) {
	          swiper.pagination.render();
	          swiper.pagination.update();
	        }
	      },
	      snapGridLengthChange: function snapGridLengthChange() {
	        var swiper = this;
	        if (!swiper.params.loop) {
	          swiper.pagination.render();
	          swiper.pagination.update();
	        }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        swiper.pagination.destroy();
	      },
	      click: function click(e) {
	        var swiper = this;
	        if (
	          swiper.params.pagination.el
	          && swiper.params.pagination.hideOnClick
	          && swiper.pagination.$el.length > 0
	          && !$(e.target).hasClass(swiper.params.pagination.bulletClass)
	        ) {
	          var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
	          if (isHidden === true) {
	            swiper.emit('paginationShow', swiper);
	          } else {
	            swiper.emit('paginationHide', swiper);
	          }
	          swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
	        }
	      },
	    },
	  };
	
	  var Scrollbar = {
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
	      var scrollbar = swiper.scrollbar;
	      var rtl = swiper.rtlTranslate;
	      var progress = swiper.progress;
	      var dragSize = scrollbar.dragSize;
	      var trackSize = scrollbar.trackSize;
	      var $dragEl = scrollbar.$dragEl;
	      var $el = scrollbar.$el;
	      var params = swiper.params.scrollbar;
	
	      var newSize = dragSize;
	      var newPos = (trackSize - dragSize) * progress;
	      if (rtl) {
	        newPos = -newPos;
	        if (newPos > 0) {
	          newSize = dragSize - newPos;
	          newPos = 0;
	        } else if (-newPos + dragSize > trackSize) {
	          newSize = trackSize + newPos;
	        }
	      } else if (newPos < 0) {
	        newSize = dragSize + newPos;
	        newPos = 0;
	      } else if (newPos + dragSize > trackSize) {
	        newSize = trackSize - newPos;
	      }
	      if (swiper.isHorizontal()) {
	        if (Support.transforms3d) {
	          $dragEl.transform(("translate3d(" + newPos + "px, 0, 0)"));
	        } else {
	          $dragEl.transform(("translateX(" + newPos + "px)"));
	        }
	        $dragEl[0].style.width = newSize + "px";
	      } else {
	        if (Support.transforms3d) {
	          $dragEl.transform(("translate3d(0px, " + newPos + "px, 0)"));
	        } else {
	          $dragEl.transform(("translateY(" + newPos + "px)"));
	        }
	        $dragEl[0].style.height = newSize + "px";
	      }
	      if (params.hide) {
	        clearTimeout(swiper.scrollbar.timeout);
	        $el[0].style.opacity = 1;
	        swiper.scrollbar.timeout = setTimeout(function () {
	          $el[0].style.opacity = 0;
	          $el.transition(400);
	        }, 1000);
	      }
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
	      swiper.scrollbar.$dragEl.transition(duration);
	    },
	    updateSize: function updateSize() {
	      var swiper = this;
	      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
	
	      var scrollbar = swiper.scrollbar;
	      var $dragEl = scrollbar.$dragEl;
	      var $el = scrollbar.$el;
	
	      $dragEl[0].style.width = '';
	      $dragEl[0].style.height = '';
	      var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
	
	      var divider = swiper.size / swiper.virtualSize;
	      var moveDivider = divider * (trackSize / swiper.size);
	      var dragSize;
	      if (swiper.params.scrollbar.dragSize === 'auto') {
	        dragSize = trackSize * divider;
	      } else {
	        dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
	      }
	
	      if (swiper.isHorizontal()) {
	        $dragEl[0].style.width = dragSize + "px";
	      } else {
	        $dragEl[0].style.height = dragSize + "px";
	      }
	
	      if (divider >= 1) {
	        $el[0].style.display = 'none';
	      } else {
	        $el[0].style.display = '';
	      }
	      if (swiper.params.scrollbar.hide) {
	        $el[0].style.opacity = 0;
	      }
	      Utils.extend(scrollbar, {
	        trackSize: trackSize,
	        divider: divider,
	        moveDivider: moveDivider,
	        dragSize: dragSize,
	      });
	      scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
	    },
	    getPointerPosition: function getPointerPosition(e) {
	      var swiper = this;
	      if (swiper.isHorizontal()) {
	        return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX);
	      }
	      return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY);
	    },
	    setDragPosition: function setDragPosition(e) {
	      var swiper = this;
	      var scrollbar = swiper.scrollbar;
	      var rtl = swiper.rtlTranslate;
	      var $el = scrollbar.$el;
	      var dragSize = scrollbar.dragSize;
	      var trackSize = scrollbar.trackSize;
	      var dragStartPos = scrollbar.dragStartPos;
	
	      var positionRatio;
	      positionRatio = ((scrollbar.getPointerPosition(e)) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top']
	        - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
	      positionRatio = Math.max(Math.min(positionRatio, 1), 0);
	      if (rtl) {
	        positionRatio = 1 - positionRatio;
	      }
	
	      var position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);
	
	      swiper.updateProgress(position);
	      swiper.setTranslate(position);
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    },
	    onDragStart: function onDragStart(e) {
	      var swiper = this;
	      var params = swiper.params.scrollbar;
	      var scrollbar = swiper.scrollbar;
	      var $wrapperEl = swiper.$wrapperEl;
	      var $el = scrollbar.$el;
	      var $dragEl = scrollbar.$dragEl;
	      swiper.scrollbar.isTouched = true;
	      swiper.scrollbar.dragStartPos = (e.target === $dragEl[0] || e.target === $dragEl)
	        ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
	      e.preventDefault();
	      e.stopPropagation();
	
	      $wrapperEl.transition(100);
	      $dragEl.transition(100);
	      scrollbar.setDragPosition(e);
	
	      clearTimeout(swiper.scrollbar.dragTimeout);
	
	      $el.transition(0);
	      if (params.hide) {
	        $el.css('opacity', 1);
	      }
	      swiper.emit('scrollbarDragStart', e);
	    },
	    onDragMove: function onDragMove(e) {
	      var swiper = this;
	      var scrollbar = swiper.scrollbar;
	      var $wrapperEl = swiper.$wrapperEl;
	      var $el = scrollbar.$el;
	      var $dragEl = scrollbar.$dragEl;
	
	      if (!swiper.scrollbar.isTouched) { return; }
	      if (e.preventDefault) { e.preventDefault(); }
	      else { e.returnValue = false; }
	      scrollbar.setDragPosition(e);
	      $wrapperEl.transition(0);
	      $el.transition(0);
	      $dragEl.transition(0);
	      swiper.emit('scrollbarDragMove', e);
	    },
	    onDragEnd: function onDragEnd(e) {
	      var swiper = this;
	
	      var params = swiper.params.scrollbar;
	      var scrollbar = swiper.scrollbar;
	      var $el = scrollbar.$el;
	
	      if (!swiper.scrollbar.isTouched) { return; }
	      swiper.scrollbar.isTouched = false;
	      if (params.hide) {
	        clearTimeout(swiper.scrollbar.dragTimeout);
	        swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
	          $el.css('opacity', 0);
	          $el.transition(400);
	        }, 1000);
	      }
	      swiper.emit('scrollbarDragEnd', e);
	      if (params.snapOnRelease) {
	        swiper.slideToClosest();
	      }
	    },
	    enableDraggable: function enableDraggable() {
	      var swiper = this;
	      if (!swiper.params.scrollbar.el) { return; }
	      var scrollbar = swiper.scrollbar;
	      var touchEventsTouch = swiper.touchEventsTouch;
	      var touchEventsDesktop = swiper.touchEventsDesktop;
	      var params = swiper.params;
	      var $el = scrollbar.$el;
	      var target = $el[0];
	      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
	      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	      if (!Support.touch) {
	        target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
	        doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
	        doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
	      } else {
	        target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
	        target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
	        target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
	      }
	    },
	    disableDraggable: function disableDraggable() {
	      var swiper = this;
	      if (!swiper.params.scrollbar.el) { return; }
	      var scrollbar = swiper.scrollbar;
	      var touchEventsTouch = swiper.touchEventsTouch;
	      var touchEventsDesktop = swiper.touchEventsDesktop;
	      var params = swiper.params;
	      var $el = scrollbar.$el;
	      var target = $el[0];
	      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
	      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	      if (!Support.touch) {
	        target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
	        doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
	        doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
	      } else {
	        target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
	        target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
	        target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
	      }
	    },
	    init: function init() {
	      var swiper = this;
	      if (!swiper.params.scrollbar.el) { return; }
	      var scrollbar = swiper.scrollbar;
	      var $swiperEl = swiper.$el;
	      var params = swiper.params.scrollbar;
	
	      var $el = $(params.el);
	      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
	        $el = $swiperEl.find(params.el);
	      }
	
	      var $dragEl = $el.find(("." + (swiper.params.scrollbar.dragClass)));
	      if ($dragEl.length === 0) {
	        $dragEl = $(("<div class=\"" + (swiper.params.scrollbar.dragClass) + "\"></div>"));
	        $el.append($dragEl);
	      }
	
	      Utils.extend(scrollbar, {
	        $el: $el,
	        el: $el[0],
	        $dragEl: $dragEl,
	        dragEl: $dragEl[0],
	      });
	
	      if (params.draggable) {
	        scrollbar.enableDraggable();
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.scrollbar.disableDraggable();
	    },
	  };
	
	  var Scrollbar$1 = {
	    name: 'scrollbar',
	    params: {
	      scrollbar: {
	        el: null,
	        dragSize: 'auto',
	        hide: false,
	        draggable: false,
	        snapOnRelease: true,
	        lockClass: 'swiper-scrollbar-lock',
	        dragClass: 'swiper-scrollbar-drag',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        scrollbar: {
	          init: Scrollbar.init.bind(swiper),
	          destroy: Scrollbar.destroy.bind(swiper),
	          updateSize: Scrollbar.updateSize.bind(swiper),
	          setTranslate: Scrollbar.setTranslate.bind(swiper),
	          setTransition: Scrollbar.setTransition.bind(swiper),
	          enableDraggable: Scrollbar.enableDraggable.bind(swiper),
	          disableDraggable: Scrollbar.disableDraggable.bind(swiper),
	          setDragPosition: Scrollbar.setDragPosition.bind(swiper),
	          getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
	          onDragStart: Scrollbar.onDragStart.bind(swiper),
	          onDragMove: Scrollbar.onDragMove.bind(swiper),
	          onDragEnd: Scrollbar.onDragEnd.bind(swiper),
	          isTouched: false,
	          timeout: null,
	          dragTimeout: null,
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        swiper.scrollbar.init();
	        swiper.scrollbar.updateSize();
	        swiper.scrollbar.setTranslate();
	      },
	      update: function update() {
	        var swiper = this;
	        swiper.scrollbar.updateSize();
	      },
	      resize: function resize() {
	        var swiper = this;
	        swiper.scrollbar.updateSize();
	      },
	      observerUpdate: function observerUpdate() {
	        var swiper = this;
	        swiper.scrollbar.updateSize();
	      },
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        swiper.scrollbar.setTranslate();
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        swiper.scrollbar.setTransition(duration);
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        swiper.scrollbar.destroy();
	      },
	    },
	  };
	
	  var Parallax = {
	    setTransform: function setTransform(el, progress) {
	      var swiper = this;
	      var rtl = swiper.rtl;
	
	      var $el = $(el);
	      var rtlFactor = rtl ? -1 : 1;
	
	      var p = $el.attr('data-swiper-parallax') || '0';
	      var x = $el.attr('data-swiper-parallax-x');
	      var y = $el.attr('data-swiper-parallax-y');
	      var scale = $el.attr('data-swiper-parallax-scale');
	      var opacity = $el.attr('data-swiper-parallax-opacity');
	
	      if (x || y) {
	        x = x || '0';
	        y = y || '0';
	      } else if (swiper.isHorizontal()) {
	        x = p;
	        y = '0';
	      } else {
	        y = p;
	        x = '0';
	      }
	
	      if ((x).indexOf('%') >= 0) {
	        x = (parseInt(x, 10) * progress * rtlFactor) + "%";
	      } else {
	        x = (x * progress * rtlFactor) + "px";
	      }
	      if ((y).indexOf('%') >= 0) {
	        y = (parseInt(y, 10) * progress) + "%";
	      } else {
	        y = (y * progress) + "px";
	      }
	
	      if (typeof opacity !== 'undefined' && opacity !== null) {
	        var currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
	        $el[0].style.opacity = currentOpacity;
	      }
	      if (typeof scale === 'undefined' || scale === null) {
	        $el.transform(("translate3d(" + x + ", " + y + ", 0px)"));
	      } else {
	        var currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
	        $el.transform(("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")"));
	      }
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      var $el = swiper.$el;
	      var slides = swiper.slides;
	      var progress = swiper.progress;
	      var snapGrid = swiper.snapGrid;
	      $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
	        .each(function (index, el) {
	          swiper.parallax.setTransform(el, progress);
	        });
	      slides.each(function (slideIndex, slideEl) {
	        var slideProgress = slideEl.progress;
	        if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
	          slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
	        }
	        slideProgress = Math.min(Math.max(slideProgress, -1), 1);
	        $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
	          .each(function (index, el) {
	            swiper.parallax.setTransform(el, slideProgress);
	          });
	      });
	    },
	    setTransition: function setTransition(duration) {
	      if ( duration === void 0 ) duration = this.params.speed;
	
	      var swiper = this;
	      var $el = swiper.$el;
	      $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
	        .each(function (index, parallaxEl) {
	          var $parallaxEl = $(parallaxEl);
	          var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
	          if (duration === 0) { parallaxDuration = 0; }
	          $parallaxEl.transition(parallaxDuration);
	        });
	    },
	  };
	
	  var Parallax$1 = {
	    name: 'parallax',
	    params: {
	      parallax: {
	        enabled: false,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        parallax: {
	          setTransform: Parallax.setTransform.bind(swiper),
	          setTranslate: Parallax.setTranslate.bind(swiper),
	          setTransition: Parallax.setTransition.bind(swiper),
	        },
	      });
	    },
	    on: {
	      beforeInit: function beforeInit() {
	        var swiper = this;
	        if (!swiper.params.parallax.enabled) { return; }
	        swiper.params.watchSlidesProgress = true;
	        swiper.originalParams.watchSlidesProgress = true;
	      },
	      init: function init() {
	        var swiper = this;
	        if (!swiper.params.parallax.enabled) { return; }
	        swiper.parallax.setTranslate();
	      },
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        if (!swiper.params.parallax.enabled) { return; }
	        swiper.parallax.setTranslate();
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        if (!swiper.params.parallax.enabled) { return; }
	        swiper.parallax.setTransition(duration);
	      },
	    },
	  };
	
	  var Zoom = {
	    // Calc Scale From Multi-touches
	    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
	      if (e.targetTouches.length < 2) { return 1; }
	      var x1 = e.targetTouches[0].pageX;
	      var y1 = e.targetTouches[0].pageY;
	      var x2 = e.targetTouches[1].pageX;
	      var y2 = e.targetTouches[1].pageY;
	      var distance = Math.sqrt((Math.pow( (x2 - x1), 2 )) + (Math.pow( (y2 - y1), 2 )));
	      return distance;
	    },
	    // Events
	    onGestureStart: function onGestureStart(e) {
	      var swiper = this;
	      var params = swiper.params.zoom;
	      var zoom = swiper.zoom;
	      var gesture = zoom.gesture;
	      zoom.fakeGestureTouched = false;
	      zoom.fakeGestureMoved = false;
	      if (!Support.gestures) {
	        if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
	          return;
	        }
	        zoom.fakeGestureTouched = true;
	        gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
	      }
	      if (!gesture.$slideEl || !gesture.$slideEl.length) {
	        gesture.$slideEl = $(e.target).closest('.swiper-slide');
	        if (gesture.$slideEl.length === 0) { gesture.$slideEl = swiper.slides.eq(swiper.activeIndex); }
	        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
	        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	        gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	        if (gesture.$imageWrapEl.length === 0) {
	          gesture.$imageEl = undefined;
	          return;
	        }
	      }
	      gesture.$imageEl.transition(0);
	      swiper.zoom.isScaling = true;
	    },
	    onGestureChange: function onGestureChange(e) {
	      var swiper = this;
	      var params = swiper.params.zoom;
	      var zoom = swiper.zoom;
	      var gesture = zoom.gesture;
	      if (!Support.gestures) {
	        if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
	          return;
	        }
	        zoom.fakeGestureMoved = true;
	        gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
	      }
	      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	      if (Support.gestures) {
	        zoom.scale = e.scale * zoom.currentScale;
	      } else {
	        zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
	      }
	      if (zoom.scale > gesture.maxRatio) {
	        zoom.scale = (gesture.maxRatio - 1) + (Math.pow( ((zoom.scale - gesture.maxRatio) + 1), 0.5 ));
	      }
	      if (zoom.scale < params.minRatio) {
	        zoom.scale = (params.minRatio + 1) - (Math.pow( ((params.minRatio - zoom.scale) + 1), 0.5 ));
	      }
	      gesture.$imageEl.transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	    },
	    onGestureEnd: function onGestureEnd(e) {
	      var swiper = this;
	      var params = swiper.params.zoom;
	      var zoom = swiper.zoom;
	      var gesture = zoom.gesture;
	      if (!Support.gestures) {
	        if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
	          return;
	        }
	        if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
	          return;
	        }
	        zoom.fakeGestureTouched = false;
	        zoom.fakeGestureMoved = false;
	      }
	      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	      zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
	      gesture.$imageEl.transition(swiper.params.speed).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	      zoom.currentScale = zoom.scale;
	      zoom.isScaling = false;
	      if (zoom.scale === 1) { gesture.$slideEl = undefined; }
	    },
	    onTouchStart: function onTouchStart(e) {
	      var swiper = this;
	      var zoom = swiper.zoom;
	      var gesture = zoom.gesture;
	      var image = zoom.image;
	      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	      if (image.isTouched) { return; }
	      if (Device.android) { e.preventDefault(); }
	      image.isTouched = true;
	      image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	      image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	    },
	    onTouchMove: function onTouchMove(e) {
	      var swiper = this;
	      var zoom = swiper.zoom;
	      var gesture = zoom.gesture;
	      var image = zoom.image;
	      var velocity = zoom.velocity;
	      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	      swiper.allowClick = false;
	      if (!image.isTouched || !gesture.$slideEl) { return; }
	
	      if (!image.isMoved) {
	        image.width = gesture.$imageEl[0].offsetWidth;
	        image.height = gesture.$imageEl[0].offsetHeight;
	        image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
	        image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
	        gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
	        gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
	        gesture.$imageWrapEl.transition(0);
	        if (swiper.rtl) {
	          image.startX = -image.startX;
	          image.startY = -image.startY;
	        }
	      }
	      // Define if we need image drag
	      var scaledWidth = image.width * zoom.scale;
	      var scaledHeight = image.height * zoom.scale;
	
	      if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) { return; }
	
	      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
	      image.maxX = -image.minX;
	      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
	      image.maxY = -image.minY;
	
	      image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	      image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	
	      if (!image.isMoved && !zoom.isScaling) {
	        if (
	          swiper.isHorizontal()
	          && (
	            (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x)
	            || (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
	          )
	        ) {
	          image.isTouched = false;
	          return;
	        } if (
	          !swiper.isHorizontal()
	          && (
	            (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y)
	            || (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
	          )
	        ) {
	          image.isTouched = false;
	          return;
	        }
	      }
	      e.preventDefault();
	      e.stopPropagation();
	
	      image.isMoved = true;
	      image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
	      image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;
	
	      if (image.currentX < image.minX) {
	        image.currentX = (image.minX + 1) - (Math.pow( ((image.minX - image.currentX) + 1), 0.8 ));
	      }
	      if (image.currentX > image.maxX) {
	        image.currentX = (image.maxX - 1) + (Math.pow( ((image.currentX - image.maxX) + 1), 0.8 ));
	      }
	
	      if (image.currentY < image.minY) {
	        image.currentY = (image.minY + 1) - (Math.pow( ((image.minY - image.currentY) + 1), 0.8 ));
	      }
	      if (image.currentY > image.maxY) {
	        image.currentY = (image.maxY - 1) + (Math.pow( ((image.currentY - image.maxY) + 1), 0.8 ));
	      }
	
	      // Velocity
	      if (!velocity.prevPositionX) { velocity.prevPositionX = image.touchesCurrent.x; }
	      if (!velocity.prevPositionY) { velocity.prevPositionY = image.touchesCurrent.y; }
	      if (!velocity.prevTime) { velocity.prevTime = Date.now(); }
	      velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
	      velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
	      if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) { velocity.x = 0; }
	      if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) { velocity.y = 0; }
	      velocity.prevPositionX = image.touchesCurrent.x;
	      velocity.prevPositionY = image.touchesCurrent.y;
	      velocity.prevTime = Date.now();
	
	      gesture.$imageWrapEl.transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
	    },
	    onTouchEnd: function onTouchEnd() {
	      var swiper = this;
	      var zoom = swiper.zoom;
	      var gesture = zoom.gesture;
	      var image = zoom.image;
	      var velocity = zoom.velocity;
	      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	      if (!image.isTouched || !image.isMoved) {
	        image.isTouched = false;
	        image.isMoved = false;
	        return;
	      }
	      image.isTouched = false;
	      image.isMoved = false;
	      var momentumDurationX = 300;
	      var momentumDurationY = 300;
	      var momentumDistanceX = velocity.x * momentumDurationX;
	      var newPositionX = image.currentX + momentumDistanceX;
	      var momentumDistanceY = velocity.y * momentumDurationY;
	      var newPositionY = image.currentY + momentumDistanceY;
	
	      // Fix duration
	      if (velocity.x !== 0) { momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x); }
	      if (velocity.y !== 0) { momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y); }
	      var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
	
	      image.currentX = newPositionX;
	      image.currentY = newPositionY;
	
	      // Define if we need image drag
	      var scaledWidth = image.width * zoom.scale;
	      var scaledHeight = image.height * zoom.scale;
	      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
	      image.maxX = -image.minX;
	      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
	      image.maxY = -image.minY;
	      image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
	      image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
	
	      gesture.$imageWrapEl.transition(momentumDuration).transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
	    },
	    onTransitionEnd: function onTransitionEnd() {
	      var swiper = this;
	      var zoom = swiper.zoom;
	      var gesture = zoom.gesture;
	      if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
	        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
	        gesture.$imageWrapEl.transform('translate3d(0,0,0)');
	
	        zoom.scale = 1;
	        zoom.currentScale = 1;
	
	        gesture.$slideEl = undefined;
	        gesture.$imageEl = undefined;
	        gesture.$imageWrapEl = undefined;
	      }
	    },
	    // Toggle Zoom
	    toggle: function toggle(e) {
	      var swiper = this;
	      var zoom = swiper.zoom;
	
	      if (zoom.scale && zoom.scale !== 1) {
	        // Zoom Out
	        zoom.out();
	      } else {
	        // Zoom In
	        zoom.in(e);
	      }
	    },
	    in: function in$1(e) {
	      var swiper = this;
	
	      var zoom = swiper.zoom;
	      var params = swiper.params.zoom;
	      var gesture = zoom.gesture;
	      var image = zoom.image;
	
	      if (!gesture.$slideEl) {
	        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
	        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
	        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	      }
	      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	
	      gesture.$slideEl.addClass(("" + (params.zoomedSlideClass)));
	
	      var touchX;
	      var touchY;
	      var offsetX;
	      var offsetY;
	      var diffX;
	      var diffY;
	      var translateX;
	      var translateY;
	      var imageWidth;
	      var imageHeight;
	      var scaledWidth;
	      var scaledHeight;
	      var translateMinX;
	      var translateMinY;
	      var translateMaxX;
	      var translateMaxY;
	      var slideWidth;
	      var slideHeight;
	
	      if (typeof image.touchesStart.x === 'undefined' && e) {
	        touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
	        touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
	      } else {
	        touchX = image.touchesStart.x;
	        touchY = image.touchesStart.y;
	      }
	
	      zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	      zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	      if (e) {
	        slideWidth = gesture.$slideEl[0].offsetWidth;
	        slideHeight = gesture.$slideEl[0].offsetHeight;
	        offsetX = gesture.$slideEl.offset().left;
	        offsetY = gesture.$slideEl.offset().top;
	        diffX = (offsetX + (slideWidth / 2)) - touchX;
	        diffY = (offsetY + (slideHeight / 2)) - touchY;
	
	        imageWidth = gesture.$imageEl[0].offsetWidth;
	        imageHeight = gesture.$imageEl[0].offsetHeight;
	        scaledWidth = imageWidth * zoom.scale;
	        scaledHeight = imageHeight * zoom.scale;
	
	        translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
	        translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
	        translateMaxX = -translateMinX;
	        translateMaxY = -translateMinY;
	
	        translateX = diffX * zoom.scale;
	        translateY = diffY * zoom.scale;
	
	        if (translateX < translateMinX) {
	          translateX = translateMinX;
	        }
	        if (translateX > translateMaxX) {
	          translateX = translateMaxX;
	        }
	
	        if (translateY < translateMinY) {
	          translateY = translateMinY;
	        }
	        if (translateY > translateMaxY) {
	          translateY = translateMaxY;
	        }
	      } else {
	        translateX = 0;
	        translateY = 0;
	      }
	      gesture.$imageWrapEl.transition(300).transform(("translate3d(" + translateX + "px, " + translateY + "px,0)"));
	      gesture.$imageEl.transition(300).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	    },
	    out: function out() {
	      var swiper = this;
	
	      var zoom = swiper.zoom;
	      var params = swiper.params.zoom;
	      var gesture = zoom.gesture;
	
	      if (!gesture.$slideEl) {
	        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
	        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
	        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	      }
	      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	
	      zoom.scale = 1;
	      zoom.currentScale = 1;
	      gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
	      gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
	      gesture.$slideEl.removeClass(("" + (params.zoomedSlideClass)));
	      gesture.$slideEl = undefined;
	    },
	    // Attach/Detach Events
	    enable: function enable() {
	      var swiper = this;
	      var zoom = swiper.zoom;
	      if (zoom.enabled) { return; }
	      zoom.enabled = true;
	
	      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
	
	      // Scale image
	      if (Support.gestures) {
	        swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
	        swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
	        swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
	      } else if (swiper.touchEvents.start === 'touchstart') {
	        swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
	        swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
	        swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
	      }
	
	      // Move image
	      swiper.$wrapperEl.on(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
	    },
	    disable: function disable() {
	      var swiper = this;
	      var zoom = swiper.zoom;
	      if (!zoom.enabled) { return; }
	
	      swiper.zoom.enabled = false;
	
	      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
	
	      // Scale image
	      if (Support.gestures) {
	        swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
	        swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
	        swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
	      } else if (swiper.touchEvents.start === 'touchstart') {
	        swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
	        swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
	        swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
	      }
	
	      // Move image
	      swiper.$wrapperEl.off(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
	    },
	  };
	
	  var Zoom$1 = {
	    name: 'zoom',
	    params: {
	      zoom: {
	        enabled: false,
	        maxRatio: 3,
	        minRatio: 1,
	        toggle: true,
	        containerClass: 'swiper-zoom-container',
	        zoomedSlideClass: 'swiper-slide-zoomed',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      var zoom = {
	        enabled: false,
	        scale: 1,
	        currentScale: 1,
	        isScaling: false,
	        gesture: {
	          $slideEl: undefined,
	          slideWidth: undefined,
	          slideHeight: undefined,
	          $imageEl: undefined,
	          $imageWrapEl: undefined,
	          maxRatio: 3,
	        },
	        image: {
	          isTouched: undefined,
	          isMoved: undefined,
	          currentX: undefined,
	          currentY: undefined,
	          minX: undefined,
	          minY: undefined,
	          maxX: undefined,
	          maxY: undefined,
	          width: undefined,
	          height: undefined,
	          startX: undefined,
	          startY: undefined,
	          touchesStart: {},
	          touchesCurrent: {},
	        },
	        velocity: {
	          x: undefined,
	          y: undefined,
	          prevPositionX: undefined,
	          prevPositionY: undefined,
	          prevTime: undefined,
	        },
	      };
	
	      ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach(function (methodName) {
	        zoom[methodName] = Zoom[methodName].bind(swiper);
	      });
	      Utils.extend(swiper, {
	        zoom: zoom,
	      });
	
	      var scale = 1;
	      Object.defineProperty(swiper.zoom, 'scale', {
	        get: function get() {
	          return scale;
	        },
	        set: function set(value) {
	          if (scale !== value) {
	            var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
	            var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
	            swiper.emit('zoomChange', value, imageEl, slideEl);
	          }
	          scale = value;
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        if (swiper.params.zoom.enabled) {
	          swiper.zoom.enable();
	        }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        swiper.zoom.disable();
	      },
	      touchStart: function touchStart(e) {
	        var swiper = this;
	        if (!swiper.zoom.enabled) { return; }
	        swiper.zoom.onTouchStart(e);
	      },
	      touchEnd: function touchEnd(e) {
	        var swiper = this;
	        if (!swiper.zoom.enabled) { return; }
	        swiper.zoom.onTouchEnd(e);
	      },
	      doubleTap: function doubleTap(e) {
	        var swiper = this;
	        if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
	          swiper.zoom.toggle(e);
	        }
	      },
	      transitionEnd: function transitionEnd() {
	        var swiper = this;
	        if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
	          swiper.zoom.onTransitionEnd();
	        }
	      },
	    },
	  };
	
	  var Lazy = {
	    loadInSlide: function loadInSlide(index, loadInDuplicate) {
	      if ( loadInDuplicate === void 0 ) loadInDuplicate = true;
	
	      var swiper = this;
	      var params = swiper.params.lazy;
	      if (typeof index === 'undefined') { return; }
	      if (swiper.slides.length === 0) { return; }
	      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	
	      var $slideEl = isVirtual
	        ? swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]"))
	        : swiper.slides.eq(index);
	
	      var $images = $slideEl.find(("." + (params.elementClass) + ":not(." + (params.loadedClass) + "):not(." + (params.loadingClass) + ")"));
	      if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
	        $images = $images.add($slideEl[0]);
	      }
	      if ($images.length === 0) { return; }
	
	      $images.each(function (imageIndex, imageEl) {
	        var $imageEl = $(imageEl);
	        $imageEl.addClass(params.loadingClass);
	
	        var background = $imageEl.attr('data-background');
	        var src = $imageEl.attr('data-src');
	        var srcset = $imageEl.attr('data-srcset');
	        var sizes = $imageEl.attr('data-sizes');
	
	        swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, function () {
	          if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) { return; }
	          if (background) {
	            $imageEl.css('background-image', ("url(\"" + background + "\")"));
	            $imageEl.removeAttr('data-background');
	          } else {
	            if (srcset) {
	              $imageEl.attr('srcset', srcset);
	              $imageEl.removeAttr('data-srcset');
	            }
	            if (sizes) {
	              $imageEl.attr('sizes', sizes);
	              $imageEl.removeAttr('data-sizes');
	            }
	            if (src) {
	              $imageEl.attr('src', src);
	              $imageEl.removeAttr('data-src');
	            }
	          }
	
	          $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
	          $slideEl.find(("." + (params.preloaderClass))).remove();
	          if (swiper.params.loop && loadInDuplicate) {
	            var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
	            if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
	              var originalSlide = swiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + (swiper.params.slideDuplicateClass) + ")"));
	              swiper.lazy.loadInSlide(originalSlide.index(), false);
	            } else {
	              var duplicatedSlide = swiper.$wrapperEl.children(("." + (swiper.params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]"));
	              swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
	            }
	          }
	          swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
	        });
	
	        swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
	      });
	    },
	    load: function load() {
	      var swiper = this;
	      var $wrapperEl = swiper.$wrapperEl;
	      var swiperParams = swiper.params;
	      var slides = swiper.slides;
	      var activeIndex = swiper.activeIndex;
	      var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
	      var params = swiperParams.lazy;
	
	      var slidesPerView = swiperParams.slidesPerView;
	      if (slidesPerView === 'auto') {
	        slidesPerView = 0;
	      }
	
	      function slideExist(index) {
	        if (isVirtual) {
	          if ($wrapperEl.children(("." + (swiperParams.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]")).length) {
	            return true;
	          }
	        } else if (slides[index]) { return true; }
	        return false;
	      }
	      function slideIndex(slideEl) {
	        if (isVirtual) {
	          return $(slideEl).attr('data-swiper-slide-index');
	        }
	        return $(slideEl).index();
	      }
	
	      if (!swiper.lazy.initialImageLoaded) { swiper.lazy.initialImageLoaded = true; }
	      if (swiper.params.watchSlidesVisibility) {
	        $wrapperEl.children(("." + (swiperParams.slideVisibleClass))).each(function (elIndex, slideEl) {
	          var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
	          swiper.lazy.loadInSlide(index);
	        });
	      } else if (slidesPerView > 1) {
	        for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
	          if (slideExist(i)) { swiper.lazy.loadInSlide(i); }
	        }
	      } else {
	        swiper.lazy.loadInSlide(activeIndex);
	      }
	      if (params.loadPrevNext) {
	        if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
	          var amount = params.loadPrevNextAmount;
	          var spv = slidesPerView;
	          var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
	          var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
	          // Next Slides
	          for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
	            if (slideExist(i$1)) { swiper.lazy.loadInSlide(i$1); }
	          }
	          // Prev Slides
	          for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
	            if (slideExist(i$2)) { swiper.lazy.loadInSlide(i$2); }
	          }
	        } else {
	          var nextSlide = $wrapperEl.children(("." + (swiperParams.slideNextClass)));
	          if (nextSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(nextSlide)); }
	
	          var prevSlide = $wrapperEl.children(("." + (swiperParams.slidePrevClass)));
	          if (prevSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(prevSlide)); }
	        }
	      }
	    },
	  };
	
	  var Lazy$1 = {
	    name: 'lazy',
	    params: {
	      lazy: {
	        enabled: false,
	        loadPrevNext: false,
	        loadPrevNextAmount: 1,
	        loadOnTransitionStart: false,
	
	        elementClass: 'swiper-lazy',
	        loadingClass: 'swiper-lazy-loading',
	        loadedClass: 'swiper-lazy-loaded',
	        preloaderClass: 'swiper-lazy-preloader',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        lazy: {
	          initialImageLoaded: false,
	          load: Lazy.load.bind(swiper),
	          loadInSlide: Lazy.loadInSlide.bind(swiper),
	        },
	      });
	    },
	    on: {
	      beforeInit: function beforeInit() {
	        var swiper = this;
	        if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
	          swiper.params.preloadImages = false;
	        }
	      },
	      init: function init() {
	        var swiper = this;
	        if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
	          swiper.lazy.load();
	        }
	      },
	      scroll: function scroll() {
	        var swiper = this;
	        if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
	          swiper.lazy.load();
	        }
	      },
	      resize: function resize() {
	        var swiper = this;
	        if (swiper.params.lazy.enabled) {
	          swiper.lazy.load();
	        }
	      },
	      scrollbarDragMove: function scrollbarDragMove() {
	        var swiper = this;
	        if (swiper.params.lazy.enabled) {
	          swiper.lazy.load();
	        }
	      },
	      transitionStart: function transitionStart() {
	        var swiper = this;
	        if (swiper.params.lazy.enabled) {
	          if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
	            swiper.lazy.load();
	          }
	        }
	      },
	      transitionEnd: function transitionEnd() {
	        var swiper = this;
	        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
	          swiper.lazy.load();
	        }
	      },
	    },
	  };
	
	  /* eslint no-bitwise: ["error", { "allow": [">>"] }] */
	
	  var Controller = {
	    LinearSpline: function LinearSpline(x, y) {
	      var binarySearch = (function search() {
	        var maxIndex;
	        var minIndex;
	        var guess;
	        return function (array, val) {
	          minIndex = -1;
	          maxIndex = array.length;
	          while (maxIndex - minIndex > 1) {
	            guess = maxIndex + minIndex >> 1;
	            if (array[guess] <= val) {
	              minIndex = guess;
	            } else {
	              maxIndex = guess;
	            }
	          }
	          return maxIndex;
	        };
	      }());
	      this.x = x;
	      this.y = y;
	      this.lastIndex = x.length - 1;
	      // Given an x value (x2), return the expected y2 value:
	      // (x1,y1) is the known point before given value,
	      // (x3,y3) is the known point after given value.
	      var i1;
	      var i3;
	
	      this.interpolate = function interpolate(x2) {
	        if (!x2) { return 0; }
	
	        // Get the indexes of x1 and x3 (the array indexes before and after given x2):
	        i3 = binarySearch(this.x, x2);
	        i1 = i3 - 1;
	
	        // We have our indexes i1 & i3, so we can calculate already:
	        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
	        return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
	      };
	      return this;
	    },
	    // xxx: for now i will just save one spline function to to
	    getInterpolateFunction: function getInterpolateFunction(c) {
	      var swiper = this;
	      if (!swiper.controller.spline) {
	        swiper.controller.spline = swiper.params.loop
	          ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid)
	          : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
	      }
	    },
	    setTranslate: function setTranslate(setTranslate$1, byController) {
	      var swiper = this;
	      var controlled = swiper.controller.control;
	      var multiplier;
	      var controlledTranslate;
	      function setControlledTranslate(c) {
	        // this will create an Interpolate function based on the snapGrids
	        // x is the Grid of the scrolled scroller and y will be the controlled scroller
	        // it makes sense to create this only once and recall it for the interpolation
	        // the function does a lot of value caching for performance
	        var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
	        if (swiper.params.controller.by === 'slide') {
	          swiper.controller.getInterpolateFunction(c);
	          // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
	          // but it did not work out
	          controlledTranslate = -swiper.controller.spline.interpolate(-translate);
	        }
	
	        if (!controlledTranslate || swiper.params.controller.by === 'container') {
	          multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
	          controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
	        }
	
	        if (swiper.params.controller.inverse) {
	          controlledTranslate = c.maxTranslate() - controlledTranslate;
	        }
	        c.updateProgress(controlledTranslate);
	        c.setTranslate(controlledTranslate, swiper);
	        c.updateActiveIndex();
	        c.updateSlidesClasses();
	      }
	      if (Array.isArray(controlled)) {
	        for (var i = 0; i < controlled.length; i += 1) {
	          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	            setControlledTranslate(controlled[i]);
	          }
	        }
	      } else if (controlled instanceof Swiper && byController !== controlled) {
	        setControlledTranslate(controlled);
	      }
	    },
	    setTransition: function setTransition(duration, byController) {
	      var swiper = this;
	      var controlled = swiper.controller.control;
	      var i;
	      function setControlledTransition(c) {
	        c.setTransition(duration, swiper);
	        if (duration !== 0) {
	          c.transitionStart();
	          if (c.params.autoHeight) {
	            Utils.nextTick(function () {
	              c.updateAutoHeight();
	            });
	          }
	          c.$wrapperEl.transitionEnd(function () {
	            if (!controlled) { return; }
	            if (c.params.loop && swiper.params.controller.by === 'slide') {
	              c.loopFix();
	            }
	            c.transitionEnd();
	          });
	        }
	      }
	      if (Array.isArray(controlled)) {
	        for (i = 0; i < controlled.length; i += 1) {
	          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	            setControlledTransition(controlled[i]);
	          }
	        }
	      } else if (controlled instanceof Swiper && byController !== controlled) {
	        setControlledTransition(controlled);
	      }
	    },
	  };
	  var Controller$1 = {
	    name: 'controller',
	    params: {
	      controller: {
	        control: undefined,
	        inverse: false,
	        by: 'slide', // or 'container'
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        controller: {
	          control: swiper.params.controller.control,
	          getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
	          setTranslate: Controller.setTranslate.bind(swiper),
	          setTransition: Controller.setTransition.bind(swiper),
	        },
	      });
	    },
	    on: {
	      update: function update() {
	        var swiper = this;
	        if (!swiper.controller.control) { return; }
	        if (swiper.controller.spline) {
	          swiper.controller.spline = undefined;
	          delete swiper.controller.spline;
	        }
	      },
	      resize: function resize() {
	        var swiper = this;
	        if (!swiper.controller.control) { return; }
	        if (swiper.controller.spline) {
	          swiper.controller.spline = undefined;
	          delete swiper.controller.spline;
	        }
	      },
	      observerUpdate: function observerUpdate() {
	        var swiper = this;
	        if (!swiper.controller.control) { return; }
	        if (swiper.controller.spline) {
	          swiper.controller.spline = undefined;
	          delete swiper.controller.spline;
	        }
	      },
	      setTranslate: function setTranslate(translate, byController) {
	        var swiper = this;
	        if (!swiper.controller.control) { return; }
	        swiper.controller.setTranslate(translate, byController);
	      },
	      setTransition: function setTransition(duration, byController) {
	        var swiper = this;
	        if (!swiper.controller.control) { return; }
	        swiper.controller.setTransition(duration, byController);
	      },
	    },
	  };
	
	  var a11y = {
	    makeElFocusable: function makeElFocusable($el) {
	      $el.attr('tabIndex', '0');
	      return $el;
	    },
	    addElRole: function addElRole($el, role) {
	      $el.attr('role', role);
	      return $el;
	    },
	    addElLabel: function addElLabel($el, label) {
	      $el.attr('aria-label', label);
	      return $el;
	    },
	    disableEl: function disableEl($el) {
	      $el.attr('aria-disabled', true);
	      return $el;
	    },
	    enableEl: function enableEl($el) {
	      $el.attr('aria-disabled', false);
	      return $el;
	    },
	    onEnterKey: function onEnterKey(e) {
	      var swiper = this;
	      var params = swiper.params.a11y;
	      if (e.keyCode !== 13) { return; }
	      var $targetEl = $(e.target);
	      if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
	        if (!(swiper.isEnd && !swiper.params.loop)) {
	          swiper.slideNext();
	        }
	        if (swiper.isEnd) {
	          swiper.a11y.notify(params.lastSlideMessage);
	        } else {
	          swiper.a11y.notify(params.nextSlideMessage);
	        }
	      }
	      if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
	        if (!(swiper.isBeginning && !swiper.params.loop)) {
	          swiper.slidePrev();
	        }
	        if (swiper.isBeginning) {
	          swiper.a11y.notify(params.firstSlideMessage);
	        } else {
	          swiper.a11y.notify(params.prevSlideMessage);
	        }
	      }
	      if (swiper.pagination && $targetEl.is(("." + (swiper.params.pagination.bulletClass)))) {
	        $targetEl[0].click();
	      }
	    },
	    notify: function notify(message) {
	      var swiper = this;
	      var notification = swiper.a11y.liveRegion;
	      if (notification.length === 0) { return; }
	      notification.html('');
	      notification.html(message);
	    },
	    updateNavigation: function updateNavigation() {
	      var swiper = this;
	
	      if (swiper.params.loop) { return; }
	      var ref = swiper.navigation;
	      var $nextEl = ref.$nextEl;
	      var $prevEl = ref.$prevEl;
	
	      if ($prevEl && $prevEl.length > 0) {
	        if (swiper.isBeginning) {
	          swiper.a11y.disableEl($prevEl);
	        } else {
	          swiper.a11y.enableEl($prevEl);
	        }
	      }
	      if ($nextEl && $nextEl.length > 0) {
	        if (swiper.isEnd) {
	          swiper.a11y.disableEl($nextEl);
	        } else {
	          swiper.a11y.enableEl($nextEl);
	        }
	      }
	    },
	    updatePagination: function updatePagination() {
	      var swiper = this;
	      var params = swiper.params.a11y;
	      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	        swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
	          var $bulletEl = $(bulletEl);
	          swiper.a11y.makeElFocusable($bulletEl);
	          swiper.a11y.addElRole($bulletEl, 'button');
	          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
	        });
	      }
	    },
	    init: function init() {
	      var swiper = this;
	
	      swiper.$el.append(swiper.a11y.liveRegion);
	
	      // Navigation
	      var params = swiper.params.a11y;
	      var $nextEl;
	      var $prevEl;
	      if (swiper.navigation && swiper.navigation.$nextEl) {
	        $nextEl = swiper.navigation.$nextEl;
	      }
	      if (swiper.navigation && swiper.navigation.$prevEl) {
	        $prevEl = swiper.navigation.$prevEl;
	      }
	      if ($nextEl) {
	        swiper.a11y.makeElFocusable($nextEl);
	        swiper.a11y.addElRole($nextEl, 'button');
	        swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
	        $nextEl.on('keydown', swiper.a11y.onEnterKey);
	      }
	      if ($prevEl) {
	        swiper.a11y.makeElFocusable($prevEl);
	        swiper.a11y.addElRole($prevEl, 'button');
	        swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
	        $prevEl.on('keydown', swiper.a11y.onEnterKey);
	      }
	
	      // Pagination
	      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	        swiper.pagination.$el.on('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) { swiper.a11y.liveRegion.remove(); }
	
	      var $nextEl;
	      var $prevEl;
	      if (swiper.navigation && swiper.navigation.$nextEl) {
	        $nextEl = swiper.navigation.$nextEl;
	      }
	      if (swiper.navigation && swiper.navigation.$prevEl) {
	        $prevEl = swiper.navigation.$prevEl;
	      }
	      if ($nextEl) {
	        $nextEl.off('keydown', swiper.a11y.onEnterKey);
	      }
	      if ($prevEl) {
	        $prevEl.off('keydown', swiper.a11y.onEnterKey);
	      }
	
	      // Pagination
	      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	        swiper.pagination.$el.off('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
	      }
	    },
	  };
	  var A11y = {
	    name: 'a11y',
	    params: {
	      a11y: {
	        enabled: true,
	        notificationClass: 'swiper-notification',
	        prevSlideMessage: 'Previous slide',
	        nextSlideMessage: 'Next slide',
	        firstSlideMessage: 'This is the first slide',
	        lastSlideMessage: 'This is the last slide',
	        paginationBulletMessage: 'Go to slide {{index}}',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        a11y: {
	          liveRegion: $(("<span class=\"" + (swiper.params.a11y.notificationClass) + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")),
	        },
	      });
	      Object.keys(a11y).forEach(function (methodName) {
	        swiper.a11y[methodName] = a11y[methodName].bind(swiper);
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        if (!swiper.params.a11y.enabled) { return; }
	        swiper.a11y.init();
	        swiper.a11y.updateNavigation();
	      },
	      toEdge: function toEdge() {
	        var swiper = this;
	        if (!swiper.params.a11y.enabled) { return; }
	        swiper.a11y.updateNavigation();
	      },
	      fromEdge: function fromEdge() {
	        var swiper = this;
	        if (!swiper.params.a11y.enabled) { return; }
	        swiper.a11y.updateNavigation();
	      },
	      paginationUpdate: function paginationUpdate() {
	        var swiper = this;
	        if (!swiper.params.a11y.enabled) { return; }
	        swiper.a11y.updatePagination();
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        if (!swiper.params.a11y.enabled) { return; }
	        swiper.a11y.destroy();
	      },
	    },
	  };
	
	  var History = {
	    init: function init() {
	      var swiper = this;
	      if (!swiper.params.history) { return; }
	      if (!win.history || !win.history.pushState) {
	        swiper.params.history.enabled = false;
	        swiper.params.hashNavigation.enabled = true;
	        return;
	      }
	      var history = swiper.history;
	      history.initialized = true;
	      history.paths = History.getPathValues();
	      if (!history.paths.key && !history.paths.value) { return; }
	      history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
	      if (!swiper.params.history.replaceState) {
	        win.addEventListener('popstate', swiper.history.setHistoryPopState);
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (!swiper.params.history.replaceState) {
	        win.removeEventListener('popstate', swiper.history.setHistoryPopState);
	      }
	    },
	    setHistoryPopState: function setHistoryPopState() {
	      var swiper = this;
	      swiper.history.paths = History.getPathValues();
	      swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
	    },
	    getPathValues: function getPathValues() {
	      var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) { return part !== ''; });
	      var total = pathArray.length;
	      var key = pathArray[total - 2];
	      var value = pathArray[total - 1];
	      return { key: key, value: value };
	    },
	    setHistory: function setHistory(key, index) {
	      var swiper = this;
	      if (!swiper.history.initialized || !swiper.params.history.enabled) { return; }
	      var slide = swiper.slides.eq(index);
	      var value = History.slugify(slide.attr('data-history'));
	      if (!win.location.pathname.includes(key)) {
	        value = key + "/" + value;
	      }
	      var currentState = win.history.state;
	      if (currentState && currentState.value === value) {
	        return;
	      }
	      if (swiper.params.history.replaceState) {
	        win.history.replaceState({ value: value }, null, value);
	      } else {
	        win.history.pushState({ value: value }, null, value);
	      }
	    },
	    slugify: function slugify(text) {
	      return text.toString()
	        .replace(/\s+/g, '-')
	        .replace(/[^\w-]+/g, '')
	        .replace(/--+/g, '-')
	        .replace(/^-+/, '')
	        .replace(/-+$/, '');
	    },
	    scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
	      var swiper = this;
	      if (value) {
	        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
	          var slide = swiper.slides.eq(i);
	          var slideHistory = History.slugify(slide.attr('data-history'));
	          if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
	            var index = slide.index();
	            swiper.slideTo(index, speed, runCallbacks);
	          }
	        }
	      } else {
	        swiper.slideTo(0, speed, runCallbacks);
	      }
	    },
	  };
	
	  var History$1 = {
	    name: 'history',
	    params: {
	      history: {
	        enabled: false,
	        replaceState: false,
	        key: 'slides',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        history: {
	          init: History.init.bind(swiper),
	          setHistory: History.setHistory.bind(swiper),
	          setHistoryPopState: History.setHistoryPopState.bind(swiper),
	          scrollToSlide: History.scrollToSlide.bind(swiper),
	          destroy: History.destroy.bind(swiper),
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        if (swiper.params.history.enabled) {
	          swiper.history.init();
	        }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        if (swiper.params.history.enabled) {
	          swiper.history.destroy();
	        }
	      },
	      transitionEnd: function transitionEnd() {
	        var swiper = this;
	        if (swiper.history.initialized) {
	          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
	        }
	      },
	    },
	  };
	
	  var HashNavigation = {
	    onHashCange: function onHashCange() {
	      var swiper = this;
	      var newHash = doc.location.hash.replace('#', '');
	      var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
	      if (newHash !== activeSlideHash) {
	        var newIndex = swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-hash=\"" + newHash + "\"]")).index();
	        if (typeof newIndex === 'undefined') { return; }
	        swiper.slideTo(newIndex);
	      }
	    },
	    setHash: function setHash() {
	      var swiper = this;
	      if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) { return; }
	      if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
	        win.history.replaceState(null, null, (("#" + (swiper.slides.eq(swiper.activeIndex).attr('data-hash'))) || ''));
	      } else {
	        var slide = swiper.slides.eq(swiper.activeIndex);
	        var hash = slide.attr('data-hash') || slide.attr('data-history');
	        doc.location.hash = hash || '';
	      }
	    },
	    init: function init() {
	      var swiper = this;
	      if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) { return; }
	      swiper.hashNavigation.initialized = true;
	      var hash = doc.location.hash.replace('#', '');
	      if (hash) {
	        var speed = 0;
	        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
	          var slide = swiper.slides.eq(i);
	          var slideHash = slide.attr('data-hash') || slide.attr('data-history');
	          if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
	            var index = slide.index();
	            swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
	          }
	        }
	      }
	      if (swiper.params.hashNavigation.watchState) {
	        $(win).on('hashchange', swiper.hashNavigation.onHashCange);
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (swiper.params.hashNavigation.watchState) {
	        $(win).off('hashchange', swiper.hashNavigation.onHashCange);
	      }
	    },
	  };
	  var HashNavigation$1 = {
	    name: 'hash-navigation',
	    params: {
	      hashNavigation: {
	        enabled: false,
	        replaceState: false,
	        watchState: false,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        hashNavigation: {
	          initialized: false,
	          init: HashNavigation.init.bind(swiper),
	          destroy: HashNavigation.destroy.bind(swiper),
	          setHash: HashNavigation.setHash.bind(swiper),
	          onHashCange: HashNavigation.onHashCange.bind(swiper),
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        if (swiper.params.hashNavigation.enabled) {
	          swiper.hashNavigation.init();
	        }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        if (swiper.params.hashNavigation.enabled) {
	          swiper.hashNavigation.destroy();
	        }
	      },
	      transitionEnd: function transitionEnd() {
	        var swiper = this;
	        if (swiper.hashNavigation.initialized) {
	          swiper.hashNavigation.setHash();
	        }
	      },
	    },
	  };
	
	  /* eslint no-underscore-dangle: "off" */
	
	  var Autoplay = {
	    run: function run() {
	      var swiper = this;
	      var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
	      var delay = swiper.params.autoplay.delay;
	      if ($activeSlideEl.attr('data-swiper-autoplay')) {
	        delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
	      }
	      clearTimeout(swiper.autoplay.timeout);
	      swiper.autoplay.timeout = Utils.nextTick(function () {
	        if (swiper.params.autoplay.reverseDirection) {
	          if (swiper.params.loop) {
	            swiper.loopFix();
	            swiper.slidePrev(swiper.params.speed, true, true);
	            swiper.emit('autoplay');
	          } else if (!swiper.isBeginning) {
	            swiper.slidePrev(swiper.params.speed, true, true);
	            swiper.emit('autoplay');
	          } else if (!swiper.params.autoplay.stopOnLastSlide) {
	            swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
	            swiper.emit('autoplay');
	          } else {
	            swiper.autoplay.stop();
	          }
	        } else if (swiper.params.loop) {
	          swiper.loopFix();
	          swiper.slideNext(swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else if (!swiper.isEnd) {
	          swiper.slideNext(swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else if (!swiper.params.autoplay.stopOnLastSlide) {
	          swiper.slideTo(0, swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else {
	          swiper.autoplay.stop();
	        }
	      }, delay);
	    },
	    start: function start() {
	      var swiper = this;
	      if (typeof swiper.autoplay.timeout !== 'undefined') { return false; }
	      if (swiper.autoplay.running) { return false; }
	      swiper.autoplay.running = true;
	      swiper.emit('autoplayStart');
	      swiper.autoplay.run();
	      return true;
	    },
	    stop: function stop() {
	      var swiper = this;
	      if (!swiper.autoplay.running) { return false; }
	      if (typeof swiper.autoplay.timeout === 'undefined') { return false; }
	
	      if (swiper.autoplay.timeout) {
	        clearTimeout(swiper.autoplay.timeout);
	        swiper.autoplay.timeout = undefined;
	      }
	      swiper.autoplay.running = false;
	      swiper.emit('autoplayStop');
	      return true;
	    },
	    pause: function pause(speed) {
	      var swiper = this;
	      if (!swiper.autoplay.running) { return; }
	      if (swiper.autoplay.paused) { return; }
	      if (swiper.autoplay.timeout) { clearTimeout(swiper.autoplay.timeout); }
	      swiper.autoplay.paused = true;
	      if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
	        swiper.autoplay.paused = false;
	        swiper.autoplay.run();
	      } else {
	        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
	        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
	      }
	    },
	  };
	
	  var Autoplay$1 = {
	    name: 'autoplay',
	    params: {
	      autoplay: {
	        enabled: false,
	        delay: 3000,
	        waitForTransition: true,
	        disableOnInteraction: true,
	        stopOnLastSlide: false,
	        reverseDirection: false,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        autoplay: {
	          running: false,
	          paused: false,
	          run: Autoplay.run.bind(swiper),
	          start: Autoplay.start.bind(swiper),
	          stop: Autoplay.stop.bind(swiper),
	          pause: Autoplay.pause.bind(swiper),
	          onTransitionEnd: function onTransitionEnd(e) {
	            if (!swiper || swiper.destroyed || !swiper.$wrapperEl) { return; }
	            if (e.target !== this) { return; }
	            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
	            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
	            swiper.autoplay.paused = false;
	            if (!swiper.autoplay.running) {
	              swiper.autoplay.stop();
	            } else {
	              swiper.autoplay.run();
	            }
	          },
	        },
	      });
	    },
	    on: {
	      init: function init() {
	        var swiper = this;
	        if (swiper.params.autoplay.enabled) {
	          swiper.autoplay.start();
	        }
	      },
	      beforeTransitionStart: function beforeTransitionStart(speed, internal) {
	        var swiper = this;
	        if (swiper.autoplay.running) {
	          if (internal || !swiper.params.autoplay.disableOnInteraction) {
	            swiper.autoplay.pause(speed);
	          } else {
	            swiper.autoplay.stop();
	          }
	        }
	      },
	      sliderFirstMove: function sliderFirstMove() {
	        var swiper = this;
	        if (swiper.autoplay.running) {
	          if (swiper.params.autoplay.disableOnInteraction) {
	            swiper.autoplay.stop();
	          } else {
	            swiper.autoplay.pause();
	          }
	        }
	      },
	      destroy: function destroy() {
	        var swiper = this;
	        if (swiper.autoplay.running) {
	          swiper.autoplay.stop();
	        }
	      },
	    },
	  };
	
	  var Fade = {
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      var slides = swiper.slides;
	      for (var i = 0; i < slides.length; i += 1) {
	        var $slideEl = swiper.slides.eq(i);
	        var offset = $slideEl[0].swiperSlideOffset;
	        var tx = -offset;
	        if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
	        var ty = 0;
	        if (!swiper.isHorizontal()) {
	          ty = tx;
	          tx = 0;
	        }
	        var slideOpacity = swiper.params.fadeEffect.crossFade
	          ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
	          : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
	        $slideEl
	          .css({
	            opacity: slideOpacity,
	          })
	          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px)"));
	      }
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      var slides = swiper.slides;
	      var $wrapperEl = swiper.$wrapperEl;
	      slides.transition(duration);
	      if (swiper.params.virtualTranslate && duration !== 0) {
	        var eventTriggered = false;
	        slides.transitionEnd(function () {
	          if (eventTriggered) { return; }
	          if (!swiper || swiper.destroyed) { return; }
	          eventTriggered = true;
	          swiper.animating = false;
	          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
	          for (var i = 0; i < triggerEvents.length; i += 1) {
	            $wrapperEl.trigger(triggerEvents[i]);
	          }
	        });
	      }
	    },
	  };
	
	  var EffectFade = {
	    name: 'effect-fade',
	    params: {
	      fadeEffect: {
	        crossFade: false,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        fadeEffect: {
	          setTranslate: Fade.setTranslate.bind(swiper),
	          setTransition: Fade.setTransition.bind(swiper),
	        },
	      });
	    },
	    on: {
	      beforeInit: function beforeInit() {
	        var swiper = this;
	        if (swiper.params.effect !== 'fade') { return; }
	        swiper.classNames.push(((swiper.params.containerModifierClass) + "fade"));
	        var overwriteParams = {
	          slidesPerView: 1,
	          slidesPerColumn: 1,
	          slidesPerGroup: 1,
	          watchSlidesProgress: true,
	          spaceBetween: 0,
	          virtualTranslate: true,
	        };
	        Utils.extend(swiper.params, overwriteParams);
	        Utils.extend(swiper.originalParams, overwriteParams);
	      },
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        if (swiper.params.effect !== 'fade') { return; }
	        swiper.fadeEffect.setTranslate();
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        if (swiper.params.effect !== 'fade') { return; }
	        swiper.fadeEffect.setTransition(duration);
	      },
	    },
	  };
	
	  var Cube = {
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      var $el = swiper.$el;
	      var $wrapperEl = swiper.$wrapperEl;
	      var slides = swiper.slides;
	      var swiperWidth = swiper.width;
	      var swiperHeight = swiper.height;
	      var rtl = swiper.rtlTranslate;
	      var swiperSize = swiper.size;
	      var params = swiper.params.cubeEffect;
	      var isHorizontal = swiper.isHorizontal();
	      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	      var wrapperRotate = 0;
	      var $cubeShadowEl;
	      if (params.shadow) {
	        if (isHorizontal) {
	          $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
	          if ($cubeShadowEl.length === 0) {
	            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
	            $wrapperEl.append($cubeShadowEl);
	          }
	          $cubeShadowEl.css({ height: (swiperWidth + "px") });
	        } else {
	          $cubeShadowEl = $el.find('.swiper-cube-shadow');
	          if ($cubeShadowEl.length === 0) {
	            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
	            $el.append($cubeShadowEl);
	          }
	        }
	      }
	      for (var i = 0; i < slides.length; i += 1) {
	        var $slideEl = slides.eq(i);
	        var slideIndex = i;
	        if (isVirtual) {
	          slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
	        }
	        var slideAngle = slideIndex * 90;
	        var round = Math.floor(slideAngle / 360);
	        if (rtl) {
	          slideAngle = -slideAngle;
	          round = Math.floor(-slideAngle / 360);
	        }
	        var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
	        var tx = 0;
	        var ty = 0;
	        var tz = 0;
	        if (slideIndex % 4 === 0) {
	          tx = -round * 4 * swiperSize;
	          tz = 0;
	        } else if ((slideIndex - 1) % 4 === 0) {
	          tx = 0;
	          tz = -round * 4 * swiperSize;
	        } else if ((slideIndex - 2) % 4 === 0) {
	          tx = swiperSize + (round * 4 * swiperSize);
	          tz = swiperSize;
	        } else if ((slideIndex - 3) % 4 === 0) {
	          tx = -swiperSize;
	          tz = (3 * swiperSize) + (swiperSize * 4 * round);
	        }
	        if (rtl) {
	          tx = -tx;
	        }
	
	        if (!isHorizontal) {
	          ty = tx;
	          tx = 0;
	        }
	
	        var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
	        if (progress <= 1 && progress > -1) {
	          wrapperRotate = (slideIndex * 90) + (progress * 90);
	          if (rtl) { wrapperRotate = (-slideIndex * 90) - (progress * 90); }
	        }
	        $slideEl.transform(transform);
	        if (params.slideShadows) {
	          // Set shadows
	          var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	          var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	          if (shadowBefore.length === 0) {
	            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
	            $slideEl.append(shadowBefore);
	          }
	          if (shadowAfter.length === 0) {
	            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
	            $slideEl.append(shadowAfter);
	          }
	          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
	          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
	        }
	      }
	      $wrapperEl.css({
	        '-webkit-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	        '-moz-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	        '-ms-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	        'transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	      });
	
	      if (params.shadow) {
	        if (isHorizontal) {
	          $cubeShadowEl.transform(("translate3d(0px, " + ((swiperWidth / 2) + params.shadowOffset) + "px, " + (-swiperWidth / 2) + "px) rotateX(90deg) rotateZ(0deg) scale(" + (params.shadowScale) + ")"));
	        } else {
	          var shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
	          var multiplier = 1.5 - (
	            (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2)
	            + (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
	          );
	          var scale1 = params.shadowScale;
	          var scale2 = params.shadowScale / multiplier;
	          var offset = params.shadowOffset;
	          $cubeShadowEl.transform(("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + ((swiperHeight / 2) + offset) + "px, " + (-swiperHeight / 2 / scale2) + "px) rotateX(-90deg)"));
	        }
	      }
	      var zFactor = (Browser.isSafari || Browser.isUiWebView) ? (-swiperSize / 2) : 0;
	      $wrapperEl
	        .transform(("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)"));
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      var $el = swiper.$el;
	      var slides = swiper.slides;
	      slides
	        .transition(duration)
	        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	        .transition(duration);
	      if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
	        $el.find('.swiper-cube-shadow').transition(duration);
	      }
	    },
	  };
	
	  var EffectCube = {
	    name: 'effect-cube',
	    params: {
	      cubeEffect: {
	        slideShadows: true,
	        shadow: true,
	        shadowOffset: 20,
	        shadowScale: 0.94,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        cubeEffect: {
	          setTranslate: Cube.setTranslate.bind(swiper),
	          setTransition: Cube.setTransition.bind(swiper),
	        },
	      });
	    },
	    on: {
	      beforeInit: function beforeInit() {
	        var swiper = this;
	        if (swiper.params.effect !== 'cube') { return; }
	        swiper.classNames.push(((swiper.params.containerModifierClass) + "cube"));
	        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
	        var overwriteParams = {
	          slidesPerView: 1,
	          slidesPerColumn: 1,
	          slidesPerGroup: 1,
	          watchSlidesProgress: true,
	          resistanceRatio: 0,
	          spaceBetween: 0,
	          centeredSlides: false,
	          virtualTranslate: true,
	        };
	        Utils.extend(swiper.params, overwriteParams);
	        Utils.extend(swiper.originalParams, overwriteParams);
	      },
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        if (swiper.params.effect !== 'cube') { return; }
	        swiper.cubeEffect.setTranslate();
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        if (swiper.params.effect !== 'cube') { return; }
	        swiper.cubeEffect.setTransition(duration);
	      },
	    },
	  };
	
	  var Flip = {
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      var slides = swiper.slides;
	      var rtl = swiper.rtlTranslate;
	      for (var i = 0; i < slides.length; i += 1) {
	        var $slideEl = slides.eq(i);
	        var progress = $slideEl[0].progress;
	        if (swiper.params.flipEffect.limitRotation) {
	          progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
	        }
	        var offset = $slideEl[0].swiperSlideOffset;
	        var rotate = -180 * progress;
	        var rotateY = rotate;
	        var rotateX = 0;
	        var tx = -offset;
	        var ty = 0;
	        if (!swiper.isHorizontal()) {
	          ty = tx;
	          tx = 0;
	          rotateX = -rotateY;
	          rotateY = 0;
	        } else if (rtl) {
	          rotateY = -rotateY;
	        }
	
	        $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
	
	        if (swiper.params.flipEffect.slideShadows) {
	          // Set shadows
	          var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	          var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	          if (shadowBefore.length === 0) {
	            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>"));
	            $slideEl.append(shadowBefore);
	          }
	          if (shadowAfter.length === 0) {
	            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>"));
	            $slideEl.append(shadowAfter);
	          }
	          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
	          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
	        }
	        $slideEl
	          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)"));
	      }
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      var slides = swiper.slides;
	      var activeIndex = swiper.activeIndex;
	      var $wrapperEl = swiper.$wrapperEl;
	      slides
	        .transition(duration)
	        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	        .transition(duration);
	      if (swiper.params.virtualTranslate && duration !== 0) {
	        var eventTriggered = false;
	        // eslint-disable-next-line
	        slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
	          if (eventTriggered) { return; }
	          if (!swiper || swiper.destroyed) { return; }
	          // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
	          eventTriggered = true;
	          swiper.animating = false;
	          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
	          for (var i = 0; i < triggerEvents.length; i += 1) {
	            $wrapperEl.trigger(triggerEvents[i]);
	          }
	        });
	      }
	    },
	  };
	
	  var EffectFlip = {
	    name: 'effect-flip',
	    params: {
	      flipEffect: {
	        slideShadows: true,
	        limitRotation: true,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        flipEffect: {
	          setTranslate: Flip.setTranslate.bind(swiper),
	          setTransition: Flip.setTransition.bind(swiper),
	        },
	      });
	    },
	    on: {
	      beforeInit: function beforeInit() {
	        var swiper = this;
	        if (swiper.params.effect !== 'flip') { return; }
	        swiper.classNames.push(((swiper.params.containerModifierClass) + "flip"));
	        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
	        var overwriteParams = {
	          slidesPerView: 1,
	          slidesPerColumn: 1,
	          slidesPerGroup: 1,
	          watchSlidesProgress: true,
	          spaceBetween: 0,
	          virtualTranslate: true,
	        };
	        Utils.extend(swiper.params, overwriteParams);
	        Utils.extend(swiper.originalParams, overwriteParams);
	      },
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        if (swiper.params.effect !== 'flip') { return; }
	        swiper.flipEffect.setTranslate();
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        if (swiper.params.effect !== 'flip') { return; }
	        swiper.flipEffect.setTransition(duration);
	      },
	    },
	  };
	
	  var Coverflow = {
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      var swiperWidth = swiper.width;
	      var swiperHeight = swiper.height;
	      var slides = swiper.slides;
	      var $wrapperEl = swiper.$wrapperEl;
	      var slidesSizesGrid = swiper.slidesSizesGrid;
	      var params = swiper.params.coverflowEffect;
	      var isHorizontal = swiper.isHorizontal();
	      var transform = swiper.translate;
	      var center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
	      var rotate = isHorizontal ? params.rotate : -params.rotate;
	      var translate = params.depth;
	      // Each slide offset from center
	      for (var i = 0, length = slides.length; i < length; i += 1) {
	        var $slideEl = slides.eq(i);
	        var slideSize = slidesSizesGrid[i];
	        var slideOffset = $slideEl[0].swiperSlideOffset;
	        var offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;
	
	        var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
	        var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
	        // var rotateZ = 0
	        var translateZ = -translate * Math.abs(offsetMultiplier);
	
	        var translateY = isHorizontal ? 0 : params.stretch * (offsetMultiplier);
	        var translateX = isHorizontal ? params.stretch * (offsetMultiplier) : 0;
	
	        // Fix for ultra small values
	        if (Math.abs(translateX) < 0.001) { translateX = 0; }
	        if (Math.abs(translateY) < 0.001) { translateY = 0; }
	        if (Math.abs(translateZ) < 0.001) { translateZ = 0; }
	        if (Math.abs(rotateY) < 0.001) { rotateY = 0; }
	        if (Math.abs(rotateX) < 0.001) { rotateX = 0; }
	
	        var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";
	
	        $slideEl.transform(slideTransform);
	        $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
	        if (params.slideShadows) {
	          // Set shadows
	          var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	          var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	          if ($shadowBeforeEl.length === 0) {
	            $shadowBeforeEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
	            $slideEl.append($shadowBeforeEl);
	          }
	          if ($shadowAfterEl.length === 0) {
	            $shadowAfterEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
	            $slideEl.append($shadowAfterEl);
	          }
	          if ($shadowBeforeEl.length) { $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0; }
	          if ($shadowAfterEl.length) { $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0; }
	        }
	      }
	
	      // Set correct perspective for IE10
	      if (Support.pointerEvents || Support.prefixedPointerEvents) {
	        var ws = $wrapperEl[0].style;
	        ws.perspectiveOrigin = center + "px 50%";
	      }
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      swiper.slides
	        .transition(duration)
	        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	        .transition(duration);
	    },
	  };
	
	  var EffectCoverflow = {
	    name: 'effect-coverflow',
	    params: {
	      coverflowEffect: {
	        rotate: 50,
	        stretch: 0,
	        depth: 100,
	        modifier: 1,
	        slideShadows: true,
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        coverflowEffect: {
	          setTranslate: Coverflow.setTranslate.bind(swiper),
	          setTransition: Coverflow.setTransition.bind(swiper),
	        },
	      });
	    },
	    on: {
	      beforeInit: function beforeInit() {
	        var swiper = this;
	        if (swiper.params.effect !== 'coverflow') { return; }
	
	        swiper.classNames.push(((swiper.params.containerModifierClass) + "coverflow"));
	        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
	
	        swiper.params.watchSlidesProgress = true;
	        swiper.originalParams.watchSlidesProgress = true;
	      },
	      setTranslate: function setTranslate() {
	        var swiper = this;
	        if (swiper.params.effect !== 'coverflow') { return; }
	        swiper.coverflowEffect.setTranslate();
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        if (swiper.params.effect !== 'coverflow') { return; }
	        swiper.coverflowEffect.setTransition(duration);
	      },
	    },
	  };
	
	  var Thumbs = {
	    init: function init() {
	      var swiper = this;
	      var ref = swiper.params;
	      var thumbsParams = ref.thumbs;
	      var SwiperClass = swiper.constructor;
	      if (thumbsParams.swiper instanceof SwiperClass) {
	        swiper.thumbs.swiper = thumbsParams.swiper;
	        Utils.extend(swiper.thumbs.swiper.originalParams, {
	          watchSlidesProgress: true,
	          slideToClickedSlide: false,
	        });
	        Utils.extend(swiper.thumbs.swiper.params, {
	          watchSlidesProgress: true,
	          slideToClickedSlide: false,
	        });
	      } else if (Utils.isObject(thumbsParams.swiper)) {
	        swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
	          watchSlidesVisibility: true,
	          watchSlidesProgress: true,
	          slideToClickedSlide: false,
	        }));
	        swiper.thumbs.swiperCreated = true;
	      }
	      swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
	      swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
	    },
	    onThumbClick: function onThumbClick() {
	      var swiper = this;
	      var thumbsSwiper = swiper.thumbs.swiper;
	      if (!thumbsSwiper) { return; }
	      var clickedIndex = thumbsSwiper.clickedIndex;
	      var clickedSlide = thumbsSwiper.clickedSlide;
	      if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) { return; }
	      if (typeof clickedIndex === 'undefined' || clickedIndex === null) { return; }
	      var slideToIndex;
	      if (thumbsSwiper.params.loop) {
	        slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
	      } else {
	        slideToIndex = clickedIndex;
	      }
	      if (swiper.params.loop) {
	        var currentIndex = swiper.activeIndex;
	        if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
	          swiper.loopFix();
	          // eslint-disable-next-line
	          swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	          currentIndex = swiper.activeIndex;
	        }
	        var prevIndex = swiper.slides.eq(currentIndex).prevAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
	        var nextIndex = swiper.slides.eq(currentIndex).nextAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
	        if (typeof prevIndex === 'undefined') { slideToIndex = nextIndex; }
	        else if (typeof nextIndex === 'undefined') { slideToIndex = prevIndex; }
	        else if (nextIndex - currentIndex < currentIndex - prevIndex) { slideToIndex = nextIndex; }
	        else { slideToIndex = prevIndex; }
	      }
	      swiper.slideTo(slideToIndex);
	    },
	    update: function update(initial) {
	      var swiper = this;
	      var thumbsSwiper = swiper.thumbs.swiper;
	      if (!thumbsSwiper) { return; }
	
	      var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto'
	        ? thumbsSwiper.slidesPerViewDynamic()
	        : thumbsSwiper.params.slidesPerView;
	
	      if (swiper.realIndex !== thumbsSwiper.realIndex) {
	        var currentThumbsIndex = thumbsSwiper.activeIndex;
	        var newThumbsIndex;
	        if (thumbsSwiper.params.loop) {
	          if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
	            thumbsSwiper.loopFix();
	            // eslint-disable-next-line
	            thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
	            currentThumbsIndex = thumbsSwiper.activeIndex;
	          }
	          // Find actual thumbs index to slide to
	          var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
	          var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
	          if (typeof prevThumbsIndex === 'undefined') { newThumbsIndex = nextThumbsIndex; }
	          else if (typeof nextThumbsIndex === 'undefined') { newThumbsIndex = prevThumbsIndex; }
	          else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = currentThumbsIndex; }
	          else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = nextThumbsIndex; }
	          else { newThumbsIndex = prevThumbsIndex; }
	        } else {
	          newThumbsIndex = swiper.realIndex;
	        }
	        if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
	          if (thumbsSwiper.params.centeredSlides) {
	            if (newThumbsIndex > currentThumbsIndex) {
	              newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
	            } else {
	              newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
	            }
	          } else if (newThumbsIndex > currentThumbsIndex) {
	            newThumbsIndex = newThumbsIndex - slidesPerView + 1;
	          }
	          thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
	        }
	      }
	
	      // Activate thumbs
	      var thumbsToActivate = 1;
	      var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
	
	      if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
	        thumbsToActivate = swiper.params.slidesPerView;
	      }
	
	      thumbsSwiper.slides.removeClass(thumbActiveClass);
	      if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual) {
	        for (var i = 0; i < thumbsToActivate; i += 1) {
	          thumbsSwiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]")).addClass(thumbActiveClass);
	        }
	      } else {
	        for (var i$1 = 0; i$1 < thumbsToActivate; i$1 += 1) {
	          thumbsSwiper.slides.eq(swiper.realIndex + i$1).addClass(thumbActiveClass);
	        }
	      }
	    },
	  };
	  var Thumbs$1 = {
	    name: 'thumbs',
	    params: {
	      thumbs: {
	        swiper: null,
	        slideThumbActiveClass: 'swiper-slide-thumb-active',
	        thumbsContainerClass: 'swiper-container-thumbs',
	      },
	    },
	    create: function create() {
	      var swiper = this;
	      Utils.extend(swiper, {
	        thumbs: {
	          swiper: null,
	          init: Thumbs.init.bind(swiper),
	          update: Thumbs.update.bind(swiper),
	          onThumbClick: Thumbs.onThumbClick.bind(swiper),
	        },
	      });
	    },
	    on: {
	      beforeInit: function beforeInit() {
	        var swiper = this;
	        var ref = swiper.params;
	        var thumbs = ref.thumbs;
	        if (!thumbs || !thumbs.swiper) { return; }
	        swiper.thumbs.init();
	        swiper.thumbs.update(true);
	      },
	      slideChange: function slideChange() {
	        var swiper = this;
	        if (!swiper.thumbs.swiper) { return; }
	        swiper.thumbs.update();
	      },
	      update: function update() {
	        var swiper = this;
	        if (!swiper.thumbs.swiper) { return; }
	        swiper.thumbs.update();
	      },
	      resize: function resize() {
	        var swiper = this;
	        if (!swiper.thumbs.swiper) { return; }
	        swiper.thumbs.update();
	      },
	      observerUpdate: function observerUpdate() {
	        var swiper = this;
	        if (!swiper.thumbs.swiper) { return; }
	        swiper.thumbs.update();
	      },
	      setTransition: function setTransition(duration) {
	        var swiper = this;
	        var thumbsSwiper = swiper.thumbs.swiper;
	        if (!thumbsSwiper) { return; }
	        thumbsSwiper.setTransition(duration);
	      },
	      beforeDestroy: function beforeDestroy() {
	        var swiper = this;
	        var thumbsSwiper = swiper.thumbs.swiper;
	        if (!thumbsSwiper) { return; }
	        if (swiper.thumbs.swiperCreated && thumbsSwiper) {
	          thumbsSwiper.destroy();
	        }
	      },
	    },
	  };
	
	  // Swiper Class
	
	  var components = [
	    Device$1,
	    Support$1,
	    Browser$1,
	    Resize,
	    Observer$1,
	    Virtual$1,
	    Keyboard$1,
	    Mousewheel$1,
	    Navigation$1,
	    Pagination$1,
	    Scrollbar$1,
	    Parallax$1,
	    Zoom$1,
	    Lazy$1,
	    Controller$1,
	    A11y,
	    History$1,
	    HashNavigation$1,
	    Autoplay$1,
	    EffectFade,
	    EffectCube,
	    EffectFlip,
	    EffectCoverflow,
	    Thumbs$1
	  ];
	
	  if (typeof Swiper.use === 'undefined') {
	    Swiper.use = Swiper.Class.use;
	    Swiper.installModule = Swiper.Class.installModule;
	  }
	
	  Swiper.use(components);
	
	  return Swiper;
	
	}));


/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(988);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(991)(module)))

/***/ },
/* 988 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(990);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function createUncontrollable(mixins, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var methods = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        propTypes;
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'becasue they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = _react2.default.createClass(_extends({
	
	      displayName: 'Uncontrolled(' + displayName + ')',
	
	      mixins: mixins,
	
	      propTypes: propTypes
	
	    }, methods, {
	      componentWillMount: function componentWillMount() {
	        var props = this.props,
	            keys = Object.keys(controlledValues);
	
	        this._values = utils.transform(keys, function (values, key) {
	          values[key] = props[utils.defaultKey(key)];
	        }, {});
	      },
	
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var _this = this;
	
	        var props = this.props,
	            keys = Object.keys(controlledValues);
	
	        keys.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      },
	      render: function render() {
	        var _this2 = this;
	
	        var newProps = {};
	        var _props = this.props;
	        var valueLink = _props.valueLink;
	        var checkedLink = _props.checkedLink;
	
	        var props = _objectWithoutProperties(_props, ['valueLink', 'checkedLink']);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this2.props[propName];
	
	          if (linkPropName && !isProp(_this2.props, propName) && isProp(_this2.props, linkPropName)) {
	            prop = _this2.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this2._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this2, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      }
	    }));
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	        args[_key - 2] = arguments[_key];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.customPropType = customPropType;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.isReactComponent = isReactComponent;
	exports.has = has;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(23);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function customPropType(handler, propType, name) {
	
	  return function (props, propName) {
	
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	
	      return propType && propType(props, propName, name);
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      var type = basePropTypes[prop];
	
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = customPropType(handler, type, displayName);
	
	      if (type !== undefined) obj[defaultKey(prop)] = type;
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}

/***/ },
/* 991 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 992 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = { "default": __webpack_require__(__webpack_module_template_argument_0__), __esModule: true };

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = { "default": __webpack_require__(__webpack_module_template_argument_0__), __esModule: true };

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = { "default": __webpack_require__(__webpack_module_template_argument_0__), __esModule: true };

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = { "default": __webpack_require__(__webpack_module_template_argument_0__), __esModule: true };

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    getRawTag = __webpack_require__(__webpack_module_template_argument_1__),
	    objectToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var overArg = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    getPrototype = __webpack_require__(__webpack_module_template_argument_1__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** static/js/main.26a1f388.js
 **/